
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("h1Y8a", function(module, exports) {
/**
 * @generated SignedSource<<8d05da60a2bb614ae09e8c369c9ba741>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0b5629b07134c74a$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "kind": "ScalarField",
            "name": "data"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "FullPageEditorComponentReadFragment",
        "selections": [
            {
                "concreteType": "Macro",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "macroId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "contentId"
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "mode",
                                "value": "EDITOR"
                            }
                        ],
                        "concreteType": "RenderedMacro",
                        "kind": "LinkedField",
                        "name": "renderedMacro",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroRenderedRepresentation"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroBodyStorage"
                            },
                            {
                                "concreteType": "WebResourceDependenciesV2",
                                "kind": "LinkedField",
                                "name": "webResource",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "contexts"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "keys"
                                    },
                                    {
                                        "concreteType": "SuperBatchWebResourcesV2",
                                        "kind": "LinkedField",
                                        "name": "superbatch",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "metatags"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "WebResourceTagsV2",
                                        "kind": "LinkedField",
                                        "name": "tags",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    },
                                    {
                                        "concreteType": "WebResourceUrisV2",
                                        "kind": "LinkedField",
                                        "name": "uris",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "concreteType": "EmbeddedMediaTokenV2",
                                "kind": "LinkedField",
                                "name": "mediaToken",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "renderedMacro(mode:\"EDITOR\")"
                    }
                ]
            },
            {
                "concreteType": "PageInfoV2",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "endCursor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                    }
                ]
            }
        ],
        "type": "MacroConnection"
    };
}();
$0b5629b07134c74a$var$node.hash = "9c9352ccf1b8c8a448af05f4d82f86d8";
var $0b5629b07134c74a$export$2e2bcd8739ae039 = $0b5629b07134c74a$var$node;



var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $2XqLN = parcelRequire("2XqLN");


var $a4TK8 = parcelRequire("a4TK8");


var $ibzAc = parcelRequire("ibzAc");


var $2v1PW = parcelRequire("2v1PW");


var $inPa6 = parcelRequire("inPa6");


var $eiA8Z = parcelRequire("eiA8Z");


var $6qdjm = parcelRequire("6qdjm");


var $bre0g = parcelRequire("bre0g");


var $iu6m9 = parcelRequire("iu6m9");


var $f8eu7 = parcelRequire("f8eu7");

var $l1vR8 = parcelRequire("l1vR8");

var $drwOC = parcelRequire("drwOC");

var $1RH0O = parcelRequire("1RH0O");


var $lxDfD = parcelRequire("lxDfD");


var $fbPMY = parcelRequire("fbPMY");


var $4tOXV = parcelRequire("4tOXV");


var $6KwrO = parcelRequire("6KwrO");


var $3mVfX = parcelRequire("3mVfX");


var $5fMeR = parcelRequire("5fMeR");




var $dLc9m = parcelRequire("dLc9m");




var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $8SCD6 = parcelRequire("8SCD6");


var $fIKxq = parcelRequire("fIKxq");


var $5vi32 = parcelRequire("5vi32");


var $9wGTI = parcelRequire("9wGTI");


var $iNYtG = parcelRequire("iNYtG");


var $euL71 = parcelRequire("euL71");


var $bQm3c = parcelRequire("bQm3c");

function $9747c27e818a1963$export$a9e17b56b1093c49() {
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPaidEdition = edition !== (0, $euL71.ConfluenceEdition).FREE;
    // Must be paid edition
    if (!isPaidEdition) return false;
    return true;
}



var $6mKj3 = parcelRequire("6mKj3");


var $aWwYt = parcelRequire("aWwYt");


var $2JYae = parcelRequire("2JYae");


var $8i27m = parcelRequire("8i27m");


var $gGHFp = parcelRequire("gGHFp");


var $lfmjq = parcelRequire("lfmjq");


var $hd53J = parcelRequire("hd53J");


var $NYiei = parcelRequire("NYiei");


var $4L9ve = parcelRequire("4L9ve");


var $8S5Nq = parcelRequire("8S5Nq");


var $iz4WO = parcelRequire("iz4WO");


var $jOYfu = parcelRequire("jOYfu");


var $jXhAV = parcelRequire("jXhAV");


var $fSC8h = parcelRequire("fSC8h");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $3d5UI = parcelRequire("3d5UI");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $iWI3x = parcelRequire("iWI3x");


var $bRTjQ = parcelRequire("bRTjQ");


var $foQ4a = parcelRequire("foQ4a");





var $7mpOv = parcelRequire("7mpOv");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $iwNka = parcelRequire("iwNka");


var $7aRa9 = parcelRequire("7aRa9");


var $inDu6 = parcelRequire("inDu6");


var $jSnXV = parcelRequire("jSnXV");








var $hYoU4 = parcelRequire("hYoU4");

const $f9dc71ade1ee2d5f$export$9745d8c24b40881d = /*#__PURE__*/ (0, $42omo.createContext)({
    isSaving: false,
    savedTime: new Date()
});
const $f9dc71ade1ee2d5f$export$df7407750199bb6d = /*#__PURE__*/ (0, $42omo.createContext)({
    triggerSaveIndicator: ()=>{}
});
const $f9dc71ade1ee2d5f$var$DEBOUNCE_SAVE_PERIOD = 1200;
const $f9dc71ade1ee2d5f$var$COMMIT_STATUS_DEBOUNCE = 500;
const $f9dc71ade1ee2d5f$var$NCS_POLLING_INTERVAL = 500;
const $f9dc71ade1ee2d5f$export$b5e4a2fe6178c584 = ({ editorApi: editorApi, children: children })=>{
    const [isSaving, setIsSaving] = (0, $42omo.useState)(false);
    const [savedTime, setSavedTime] = (0, $42omo.useState)(new Date());
    const saveAttemptCallbackId = (0, $42omo.useRef)(0);
    const saveCompleteCallbackId = (0, $42omo.useRef)(0);
    const pollIntervalId = (0, $42omo.useRef)(0);
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const previousBodyChangeTimeRef = (0, $42omo.useRef)(undefined);
    // These window functions are used here as performance efficient callback throttlers
    // requestIdleCallback is not supported by all browsers, hence fallback to requestAnimationFrame
    const throttledCallback = window.requestIdleCallback || window.requestAnimationFrame;
    const cancelThrottle = (0, $42omo.useCallback)((id)=>{
        if (throttledCallback === window.requestIdleCallback) window.cancelIdleCallback(id);
        else window.cancelAnimationFrame(id);
    }, [
        throttledCallback
    ]);
    const onSaveSuccess = (0, $42omo.useCallback)(()=>{
        if (saveCompleteCallbackId.current) cancelThrottle(saveCompleteCallbackId.current);
        const id = throttledCallback(()=>{
            setSavedTime(new Date());
            setIsSaving(false);
            clearInterval(pollIntervalId.current);
            pollIntervalId.current = 0;
            saveCompleteCallbackId.current = 0;
        });
        saveCompleteCallbackId.current = id;
    }, [
        cancelThrottle,
        throttledCallback
    ]);
    const pollForStepsSaved = (0, $42omo.useCallback)(()=>{
        if (!collabEditProvider) return;
        const unconfirmedSteps = collabEditProvider.getUnconfirmedSteps();
        if (!unconfirmedSteps || unconfirmedSteps.length === 0) onSaveSuccess();
    }, [
        collabEditProvider,
        onSaveSuccess
    ]);
    const onSaveAttempt = (0, $42omo.useCallback)(()=>{
        if (saveAttemptCallbackId.current) cancelThrottle(saveAttemptCallbackId.current);
        if (pollIntervalId.current) clearInterval(pollIntervalId.current);
        const attemptId = throttledCallback(()=>{
            setIsSaving(true);
            saveAttemptCallbackId.current = 0;
            const id = setInterval(pollForStepsSaved, $f9dc71ade1ee2d5f$var$NCS_POLLING_INTERVAL);
            pollIntervalId.current = id;
        });
        saveAttemptCallbackId.current = attemptId;
    }, [
        throttledCallback,
        cancelThrottle,
        pollForStepsSaved
    ]);
    // Update polling interval callback with new poll() whenever it updates
    // Because setInterval callback does not track state changes (i.e. isSaving)
    (0, $42omo.useEffect)(()=>{
        if (pollIntervalId.current) {
            clearInterval(pollIntervalId.current);
            pollIntervalId.current = setInterval(pollForStepsSaved, $f9dc71ade1ee2d5f$var$NCS_POLLING_INTERVAL);
        }
    }, [
        pollForStepsSaved
    ]);
    const debouncedOnChange = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(onSaveAttempt, $f9dc71ade1ee2d5f$var$COMMIT_STATUS_DEBOUNCE, {
            leading: true,
            trailing: false
        }), [
        onSaveAttempt
    ]);
    (0, $6qdjm.usePluginStateEffect)(editorApi, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        const lastChangeTime = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        if (!collabEditState?.initialised || !lastChangeTime) return;
        if (lastChangeTime !== previousBodyChangeTimeRef.current) {
            previousBodyChangeTimeRef.current = lastChangeTime;
            debouncedOnChange();
        }
    });
    // Cancel any awaiting callbacks on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (pollIntervalId.current) clearInterval(pollIntervalId.current);
            if (saveAttemptCallbackId.current) cancelThrottle(saveAttemptCallbackId.current);
            if (saveCompleteCallbackId.current) cancelThrottle(saveCompleteCallbackId.current);
        };
    // eslint-disable-next-line
    }, []);
    // display save indicator with auto resolve to saved, for changes outside document body
    const triggerSaving = (0, $42omo.useCallback)(()=>{
        let autoSuccessTimeoutId;
        if (!isSaving) {
            if (saveAttemptCallbackId.current) cancelThrottle(saveAttemptCallbackId.current);
            const attemptId = throttledCallback(()=>{
                setIsSaving(true);
                saveAttemptCallbackId.current = 0;
                autoSuccessTimeoutId = setTimeout(onSaveSuccess, $f9dc71ade1ee2d5f$var$DEBOUNCE_SAVE_PERIOD);
            });
            saveAttemptCallbackId.current = attemptId;
        }
        return ()=>{
            if (autoSuccessTimeoutId) clearTimeout(autoSuccessTimeoutId);
        };
    }, [
        isSaving,
        throttledCallback,
        cancelThrottle,
        onSaveSuccess
    ]);
    const saveIndicatorContextValue = (0, $42omo.useMemo)(()=>({
            isSaving: isSaving,
            savedTime: savedTime
        }), [
        isSaving,
        savedTime
    ]);
    const saveIndicatorTriggerContextValue = (0, $42omo.useMemo)(()=>({
            triggerSaveIndicator: triggerSaving
        }), [
        triggerSaving
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f9dc71ade1ee2d5f$export$9745d8c24b40881d.Provider, {
        value: saveIndicatorContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f9dc71ade1ee2d5f$export$df7407750199bb6d.Provider, {
        value: saveIndicatorTriggerContextValue
    }, children));
};



var $8cjD5 = parcelRequire("8cjD5");


var $2xS8W = parcelRequire("2xS8W");


var $70pcM = parcelRequire("70pcM");


var $cEgMD = parcelRequire("cEgMD");


var $85rxh = parcelRequire("85rxh");


var $fjhaB = parcelRequire("fjhaB");


var $9EvUR = parcelRequire("9EvUR");


var $98Cy1 = parcelRequire("98Cy1");





var $kyKWe = parcelRequire("kyKWe");







const $30f609f1a737209e$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        // Only re-run if value is updated
        ref.current = value;
    }, [
        value
    ]);
    // Return previous value (happens before the update in useEffect)
    return ref.current;
};


const $b332f5d2fa8005d6$var$getDisabledReason = ({ shouldShowNewContentHistory: shouldShowNewContentHistory, shouldRenderPreview: shouldRenderPreview, isTitleFocused: isTitleFocused, collabEditError: collabEditError, collabLimitReached: collabLimitReached, heartbeatError: heartbeatError, saveDraftError: saveDraftError })=>{
    if (shouldRenderPreview) return 'should-render-preview';
    else if (shouldShowNewContentHistory) return 'show-new-content-history';
    else if (isTitleFocused) return 'title-focused';
    else if (collabLimitReached) return 'collab-limit-reached';
    else if (collabEditError) return collabEditError.code;
    else if (heartbeatError) return heartbeatError.reason;
    else if (saveDraftError) return `Draft sync returned status ${saveDraftError?.statusCode}`;
    return '';
};
const $b332f5d2fa8005d6$export$d2b5179b7b1bfa0e = ({ contentId: contentId, disabled: disabled, shouldRenderPreview: shouldRenderPreview, shouldShowNewContentHistory: shouldShowNewContentHistory, isTitleFocused: isTitleFocused, collabEditError: collabEditError, collabLimitReached: collabLimitReached, heartbeatError: heartbeatError, saveDraftError: saveDraftError })=>{
    // Navigator.onLine: https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/onLine
    // Document.visibilityState: https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilityState
    const onLine = navigator.onLine;
    const visibilityState = document.visibilityState;
    const disabledReason = $b332f5d2fa8005d6$var$getDisabledReason({
        shouldRenderPreview: shouldRenderPreview,
        shouldShowNewContentHistory: shouldShowNewContentHistory,
        isTitleFocused: isTitleFocused,
        collabEditError: collabEditError,
        collabLimitReached: collabLimitReached,
        heartbeatError: heartbeatError,
        saveDraftError: saveDraftError
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const prevDisabled = (0, $30f609f1a737209e$export$5cae361ad82dce8b)(disabled);
    // Ref to keep track of enabled/disabled transition start/end and duration
    const enabledTransitionStart = (0, $42omo.useRef)();
    const disabledTransitionStart = (0, $42omo.useRef)();
    const disabledTransitionId = (0, $42omo.useRef)();
    const sinceDisabled = ()=>{
        return !disabled && typeof disabledTransitionStart.current === 'number' ? performance.now() - disabledTransitionStart.current : undefined;
    };
    const sinceEnabled = ()=>{
        return disabled && typeof enabledTransitionStart.current === 'number' ? performance.now() - enabledTransitionStart.current : undefined;
    };
    const disabledChanged = typeof disabled === 'boolean' && typeof prevDisabled === 'boolean' && disabled !== prevDisabled;
    (0, $42omo.useEffect)(()=>{
        if (disabledChanged) {
            // fire analytics event
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    actionSubject: 'editor',
                    action: disabled ? 'disabled' : 'enabled',
                    source: 'editorComponent',
                    attributes: {
                        contentId: contentId,
                        transitionId: disabledTransitionId.current,
                        visibilityState: visibilityState,
                        onLine: onLine,
                        disabledReason: disabledReason,
                        disabledDuration: sinceDisabled(),
                        enabledDuration: sinceEnabled()
                    }
                }
            }).fire();
            // transition from enabled -> disabled
            if (!prevDisabled && disabled) {
                disabledTransitionStart.current = performance.now();
                enabledTransitionStart.current = undefined;
            // transition from disabled -> enabled
            } else {
                disabledTransitionId.current = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
                enabledTransitionStart.current = performance.now();
                disabledTransitionStart.current = undefined;
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        disabledChanged,
        disabled
    ]);
};



var $l3Dp5 = parcelRequire("l3Dp5");


var $e9owJ = parcelRequire("e9owJ");


var $7BsWq = parcelRequire("7BsWq");


var $1NbQn = parcelRequire("1NbQn");




const $0642f0591024f070$export$f31ae08e8dcbd049 = (0, $2XqLN.default)(()=>{
    return {
        allowMatchCase: true
    };
});



var $fBnV3 = parcelRequire("fBnV3");

/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");





var $jxs8y = parcelRequire("jxs8y");

var $xQxzY = parcelRequire("xQxzY");





var $7W8i8 = parcelRequire("7W8i8");


var $dPJCf = parcelRequire("dPJCf");





var $3jwuS = parcelRequire("3jwuS");


var $7ZQNA = parcelRequire("7ZQNA");




const $9a6aed826f4ffb4d$var$logger = (0, $7W8i8.getLogger)('native-collab');
const $9a6aed826f4ffb4d$var$parseMonolithContent = (data, editorActions)=>{
    const content = data?.content?.nodes?.[0];
    const contentBody = content?.body?.atlas_doc_format?.value;
    const contentTitle = content?.title;
    let contentAppearance = null;
    try {
        const appearance = content?.appearanceDraft?.nodes?.[0]?.value;
        if (appearance) contentAppearance = JSON.parse(appearance);
    } catch (e) {
        $9a6aed826f4ffb4d$var$logger.error`Error parsing content appearance: ${e}`;
    }
    // at this point since we are getting data after the editor has mounted we need to
    // set the content in the editor through editorActions
    if (contentBody && editorActions) editorActions.replaceDocument(contentBody);
    return {
        draftBody: contentBody ?? null,
        draftTitle: contentTitle ?? null,
        draftAppearance: contentAppearance
    };
};
const $9a6aed826f4ffb4d$var$parseCollabDraftBody = (draftData, appearanceData)=>{
    const draft = draftData?.collabDraft;
    const appearanceContent = appearanceData?.content?.nodes?.[0];
    const draftAppearance = appearanceContent?.appearanceDraft?.nodes?.[0]?.value;
    return {
        draftBody: draft?.document ?? null,
        draftTitle: draft?.metadata?.title ?? null,
        draftAppearance: draftAppearance ? JSON.parse(draftAppearance) : null
    };
};
const $9a6aed826f4ffb4d$export$48c0f85d55b51110 = ({ contentId: contentId, draftShareId: draftShareId, collabEditInitialized: collabEditInitialized, editorActions: editorActions, isUnrecoverableCollabEditError: isUnrecoverableCollabEditError })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const transitionId = (0, $dPJCf.useTransitionId)();
    const isInitialLoad = !transitionId;
    const shouldPreloadForSSR = isInitialLoad;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const bodyPreloadingEnabled = (0, $9wGTI.fg)('confluence_preload_draft_content_in_next_editor') || shouldPreloadForSSR || isLivePage;
    const draftLoadTime = (0, $42omo.useRef)(null);
    const getMonolithContentTimeout = (0, $42omo.useRef)(null);
    let initialDraft = {
        draftBody: null,
        draftTitle: null,
        draftAppearance: null
    };
    const [getMonolithContent, { data: monolithDraftData, loading: monolithContentLoading, error: monolithContentError }] = (0, $jxs8y.useLazyQuery)((0, $eSUdr.default)`query useInjectDraftContentConfluenceDraftQuery($contentId:ID!$status:[String]!){content(id:$contentId status:$status){nodes{appearanceDraft:properties(key:"content-appearance-draft"){nodes{id key value version{number}}}id type status title body{atlas_doc_format{value}}}}}`, {
        variables: {
            contentId: contentId,
            status: [
                'draft',
                'current'
            ]
        }
    });
    const hasConfluenceDraftQueryLoaded = !monolithContentLoading && !monolithContentError && !!monolithDraftData;
    const { data: collabDraftData, loading: collabDraftLoading, error: collabDraftError } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $7ZQNA.CollabDraftQuery), {
        fetchPolicy: 'cache-first',
        variables: {
            id: contentId,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined,
            hydrateAdf: true
        },
        skip: !bodyPreloadingEnabled
    });
    const { data: appearanceData, loading: appearanceLoading, error: appearanceError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useInjectDraftContentgetDraftContentAppearancePropertyQuery($contentId:ID$status:[String]){content(id:$contentId status:$status){nodes{id appearanceDraft:properties(key:"content-appearance-draft"){nodes{id key value version{number}}}}}}`, {
        fetchPolicy: 'cache-first',
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        skip: !bodyPreloadingEnabled
    });
    const hasCollabDraftQueryLoaded = !collabDraftLoading && !!collabDraftData?.collabDraft && !!appearanceData && !appearanceLoading;
    initialDraft = (0, $42omo.useMemo)(()=>{
        return hasConfluenceDraftQueryLoaded ? $9a6aed826f4ffb4d$var$parseMonolithContent(monolithDraftData, editorActions) : $9a6aed826f4ffb4d$var$parseCollabDraftBody(collabDraftData, appearanceData);
    }, [
        collabDraftData,
        appearanceData,
        monolithDraftData,
        hasConfluenceDraftQueryLoaded,
        editorActions
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isUnrecoverableCollabEditError) {
            if (getMonolithContentTimeout.current) clearTimeout(getMonolithContentTimeout.current);
            getMonolithContent();
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'monolithFallback',
                    actionSubject: 'nativeEditor',
                    source: 'confluenceFrontend',
                    objectId: contentId,
                    attributes: {
                        timeout: 0
                    }
                }
            }).fire();
        }
    }, [
        isUnrecoverableCollabEditError,
        getMonolithContentTimeout,
        getMonolithContent,
        createAnalyticsEvent,
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!getMonolithContentTimeout.current && !hasCollabDraftQueryLoaded) getMonolithContentTimeout.current = window.setTimeout(()=>{
            getMonolithContent();
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'monolithFallback',
                    actionSubject: 'nativeEditor',
                    source: 'confluenceFrontend',
                    objectId: contentId,
                    attributes: {
                        timeout: (0, $6mKj3.expVal)('confluence_editor_monolith_fallback_timer', 'value', 10000)
                    }
                }
            }).fire();
        }, (0, $6mKj3.expVal)('confluence_editor_monolith_fallback_timer', 'value', 10000));
    }, [
        hasCollabDraftQueryLoaded,
        getMonolithContentTimeout,
        getMonolithContent,
        createAnalyticsEvent,
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (getMonolithContentTimeout.current && (hasCollabDraftQueryLoaded || collabEditInitialized)) {
            clearTimeout(getMonolithContentTimeout.current);
            getMonolithContentTimeout.current = null;
        }
    }, [
        getMonolithContentTimeout,
        hasCollabDraftQueryLoaded,
        collabEditInitialized
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (getMonolithContentTimeout.current) clearTimeout(getMonolithContentTimeout.current);
        };
    }, [
        getMonolithContentTimeout
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!bodyPreloadingEnabled) return;
        if (!collabDraftError && hasCollabDraftQueryLoaded && !appearanceError) {
            draftLoadTime.current = performance.now();
            $9a6aed826f4ffb4d$var$logger.debug`Draft content retrieved from CollabDraftQuery at ${performance.now() / 1000}`;
        }
    }, [
        hasCollabDraftQueryLoaded,
        collabDraftError,
        appearanceError,
        bodyPreloadingEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (collabEditInitialized && !!draftLoadTime.current) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'editorContentVisibleDisabledTime',
                actionSubject: 'nativeEditor',
                source: 'confluenceFrontend',
                objectId: contentId,
                attributes: {
                    timeDiff: performance.now() - draftLoadTime.current
                }
            }
        }).fire();
    // don't depend on createAnalyticsEvent to avoid unnecessary re-triggers of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditInitialized,
        contentId
    ]);
    return initialDraft;
};



var $bjxK7 = parcelRequire("bjxK7");


var $9Eka4 = parcelRequire("9Eka4");


var $hfIjM = parcelRequire("hfIjM");








var $hp2SH = parcelRequire("hp2SH");


var $ge2sX = parcelRequire("ge2sX");




const $2c4c7052e9c1b92a$export$7f4d6e84af98b77e = (0, $eSUdr.default)`query GetContentAgeQuery($contentId:ID!){content(id:$contentId status:["current" "draft"]){nodes{id history{createdDate}version{when}}}}`;


const $6fc6623dec610eba$export$ea50f0fba62a9f14 = async (createAnalyticsEvent, { contentId: contentId, collabService: collabService })=>{
    if (!createAnalyticsEvent || !contentId) return;
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const result = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $2c4c7052e9c1b92a$export$7f4d6e84af98b77e),
            variables: {
                contentId: contentId
            },
            fetchPolicy: 'cache-first'
        });
        let utcCreatedDate = result.data?.content?.nodes?.[0]?.history?.createdDate;
        let isUnpublishedDraft = false;
        if (!utcCreatedDate) {
            if (!!result.data?.content?.nodes?.[0]?.version?.when) {
                // unpublished draft, so use draft creation date
                utcCreatedDate = result.data?.content?.nodes?.[0]?.version?.when;
                isUnpublishedDraft = true;
            } else return;
        }
        const { shard: shard, edition: edition } = await (0, $ge2sX.getSessionData)();
        // get created and current date in UTC ms time
        const createdDate = new Date(utcCreatedDate).getTime();
        const currentDate = Date.now();
        // number of days between this (latest) edit and page creation
        const daysSinceCreated = Math.floor((currentDate - createdDate) / 86400000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                actionSubject: 'editor',
                action: 'trackPageLifetime',
                source: 'editorComponent',
                attributes: {
                    contentId: contentId,
                    daysSinceCreated: daysSinceCreated,
                    collabService: collabService,
                    isUnpublishedDraft: isUnpublishedDraft,
                    shard: shard,
                    edition: edition
                }
            }
        }).fire();
    } catch (e) {
        return;
    }
};
const $6fc6623dec610eba$export$f46ffb959d708168 = ({ contentId: contentId, collabService: collabService })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        $6fc6623dec610eba$export$ea50f0fba62a9f14(createAnalyticsEvent, {
            contentId: contentId,
            collabService: collabService
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
};



var $3W9OD = parcelRequire("3W9OD");


var $beK3g = parcelRequire("beK3g");


var $foVrt = parcelRequire("foVrt");


var $f6GmT = parcelRequire("f6GmT");







const $349687d7e88d726e$export$f95232bf2d33b362 = ()=>{
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const aiProviders = (0, $42omo.useRef)({});
    const onAIProviderChanged = (0, $42omo.useCallback)((source, provider)=>{
        if (!collabEditConnected || !collabEditProvider) return;
        let agentId = provider?.agent?.id;
        const agentIdPrefix = 'agent:';
        const action = agentId ? 'add' : 'remove';
        // Fetch the previously enabled provider's ID as it isn't provided
        // when unsetting the selected provider
        if (aiProviders.current[source]) agentId = aiProviders.current[source];
        aiProviders.current[source] = provider?.agent?.id;
        if (agentId) {
            const providerId = `${agentIdPrefix}${agentId}`;
            collabEditProvider.sendMessage({
                type: 'ai-provider:change',
                action: action,
                providerId: providerId
            });
        }
        collabEditProvider.setAIProviderActiveIds(Object.values(aiProviders.current).filter((id)=>!!id).map((id)=>`${agentIdPrefix}${id}`));
    }, [
        collabEditConnected,
        collabEditProvider
    ]);
    return {
        onAIProviderChanged: onAIProviderChanged
    };
};





const $92561710d62f83c7$export$4e0e446ffa50ddc0 = ()=>{
    const [isActive, setIsActive] = (0, $42omo.useState)(document.visibilityState === 'visible');
    const delay = 2000; // 2 seconds delay
    (0, $42omo.useEffect)(()=>{
        let timer;
        const handleVisibilityChange = ()=>{
            clearTimeout(timer);
            if (document.visibilityState === 'visible') timer = setTimeout(()=>{
                setIsActive(true);
            }, delay);
            else setIsActive(false);
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            clearTimeout(timer);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    return isActive;
};



var $9ovft = parcelRequire("9ovft");

/**
 * @graphql cc
 */ 



var $1KmJq = parcelRequire("1KmJq");

















var $4VJDS = parcelRequire("4VJDS");








var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");





var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $bMmYR = parcelRequire("bMmYR");


var $b4kc6 = parcelRequire("b4kc6");


var $9F9dn = parcelRequire("9F9dn");

const $a59bf23b6ef769dd$var$UNKNOWN_ERROR_STR = 'Unknown Error from useEditorDraftSyncAction Mutation';
const $a59bf23b6ef769dd$var$DRAFT_SYNC_DEBOUNCE_TIME = 2500;
const $a59bf23b6ef769dd$var$parseSyncStatus = (syncStatus)=>{
    // syncStatus is expected to follow this pattern: pending-{stepVersionNumber} | synced-{stepVersionNumber}
    if (typeof syncStatus !== 'string') return undefined;
    const parsed = syncStatus.split('-');
    return {
        status: parsed[0],
        version: Number(parsed[1])
    };
};
const $a59bf23b6ef769dd$export$7a6d63ee0185f0fd = ({ contentId: contentId, editorPresetAPI: editorPresetAPI, editorActions: editorActions, isFirstParticipant: isFirstParticipant, onDraftSyncSuccess: onDraftSyncSuccess, flags: flags })=>{
    const intl = (0, $8C5kA.default)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ collabEditProvider: collabEditProvider, collabEditInitialized: collabEditInitialized }, { setIsDraftSyncPending: setIsDraftSyncPending }] = (0, $hYoU4.useNativeCollabState)();
    const draftSyncDebounceMaxWait = (0, $4VJDS.default).getNumber('draft_sync_debounce_max_wait', 0);
    const [draftSyncActionError, setDraftSyncActionError] = (0, $42omo.useState)(null);
    const previousLocalChangeTimeRef = (0, $42omo.useRef)(undefined);
    const previousOfflineStatusRef = (0, $42omo.useRef)(false);
    const submitErrorToMonitoringSystem = (0, $42omo.useCallback)((error)=>{
        (0, $fJlJm.setContentErrorAttributes)(error, {
            objectId: contentId
        });
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
    }, [
        contentId
    ]);
    const [editorDraftSyncActionMutation] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useEditorDraftSyncActionEditorDraftSyncActionMutation($input:EditorDraftSyncInput!){editorDraftSyncAction(input:$input){success errors{message extensions{errorType statusCode}}}}`);
    const executeDraftSyncActionMutation = (0, $42omo.useCallback)(async ()=>{
        const currentStep = collabEditProvider?.getCurrentPmVersion();
        // Fallback adf should only be sent by a single user to avoid conflict errors on the BE
        const latestAdf = isFirstParticipant ? await editorActions.getValue() : null;
        const { data: data } = await editorDraftSyncActionMutation({
            variables: {
                input: {
                    contentId: contentId,
                    ncsStepVersion: currentStep,
                    doSetRelations: true,
                    // Collaborator relation is an entity on the backend used to indicate if a user made changes to that version
                    latestAdf: latestAdf && JSON.stringify(latestAdf)
                }
            }
        });
        return data;
    }, [
        contentId,
        editorDraftSyncActionMutation,
        collabEditProvider,
        editorActions,
        isFirstParticipant
    ]);
    const saveDraft = (0, $42omo.useCallback)(async ()=>{
        setIsDraftSyncPending(true);
        try {
            const data = await (0, $bMmYR.retry)(executeDraftSyncActionMutation, {
                maxAttempts: 2,
                timeout: 2000
            });
            const result = data?.editorDraftSyncAction;
            if (result?.success) {
                // After draft is saved, save source sync blocks and reference synced blocks on the document
                if ((0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true)) {
                    const flushSyncBlockSuccess = await editorPresetAPI?.syncedBlock?.actions.flushBodiedSyncBlocks();
                    if (flags && !flushSyncBlockSuccess) (0, $b4kc6.showFlushSyncBlockErrorFlag)(flags, intl, editorPresetAPI?.syncedBlock?.actions.flushBodiedSyncBlocks);
                    await editorPresetAPI?.syncedBlock?.actions.flushSyncedBlocks();
                }
                setDraftSyncActionError(null);
                setIsDraftSyncPending(false);
                onDraftSyncSuccess?.();
                return;
            }
            if (result?.errors?.length && result?.errors?.length > 0) {
                result.errors.forEach((error)=>{
                    if (error.message && error.extensions && error.extensions[0]?.statusCode) setDraftSyncActionError(new (0, $9F9dn.DraftSyncResponseError)(error.message, error.extensions[0].statusCode));
                    else setDraftSyncActionError(new (0, $9F9dn.DraftSyncResponseError)(error?.message || $a59bf23b6ef769dd$var$UNKNOWN_ERROR_STR, undefined));
                    submitErrorToMonitoringSystem(error);
                });
                return;
            }
        } catch (error) {
            setDraftSyncActionError(new (0, $9F9dn.DraftSyncResponseError)(error?.message || $a59bf23b6ef769dd$var$UNKNOWN_ERROR_STR, Number((0, $aMcHK.getStatusCode)(error))));
            submitErrorToMonitoringSystem(error);
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        editorPresetAPI?.syncedBlock?.actions,
        submitErrorToMonitoringSystem,
        setIsDraftSyncPending,
        executeDraftSyncActionMutation,
        onDraftSyncSuccess,
        flags,
        intl
    ]);
    const onUpdate = (0, $42omo.useCallback)(()=>{
        if (!isLivePage || !collabEditProvider || !collabEditInitialized) return;
        const metadata = collabEditProvider.getMetadata();
        const collabSyncStatus = $a59bf23b6ef769dd$var$parseSyncStatus(metadata['syncStatus']);
        if (collabSyncStatus) {
            const currentStatus = collabSyncStatus['status'];
            if (currentStatus === 'synced') // BE is not currently saving, so send request
            saveDraft();
            if (currentStatus === 'pending') // implies BE is already saving, so we don't send a new request
            return;
        } else // collabSyncStatus is set by the BE as a result of draft sync. If it doesn't exist, BE needs to save and set it.
        saveDraft();
    }, [
        isLivePage,
        collabEditProvider,
        collabEditInitialized,
        saveDraft
    ]);
    const debouncedOnUpdate = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(onUpdate, $a59bf23b6ef769dd$var$DRAFT_SYNC_DEBOUNCE_TIME, {
            trailing: true,
            ...draftSyncDebounceMaxWait > 0 && {
                maxWait: draftSyncDebounceMaxWait
            }
        }), [
        onUpdate,
        draftSyncDebounceMaxWait
    ]);
    const triggerUpdate = (0, $42omo.useCallback)(()=>{
        if (isLivePage) debouncedOnUpdate();
    }, [
        debouncedOnUpdate,
        isLivePage
    ]);
    const cancelUpdate = (0, $42omo.useCallback)(()=>debouncedOnUpdate.cancel(), [
        debouncedOnUpdate
    ]);
    const flushUpdate = (0, $42omo.useCallback)(()=>{
        debouncedOnUpdate.flush();
    }, [
        debouncedOnUpdate
    ]);
    const handlePluginStateEffect = (0, $42omo.useCallback)(({ collabEditState: collabEditState, connectivityState: connectivityState })=>{
        if (!isLivePage) return;
        if (connectivityState?.mode === 'offline') {
            previousOfflineStatusRef.current = true;
            return;
        } else if (connectivityState?.mode === 'online') {
            // reset any draft sync errors upon coming back online
            if (previousOfflineStatusRef.current === true) setDraftSyncActionError(null);
            previousOfflineStatusRef.current = false;
        }
        if (!collabEditState?.initialised?.lastLocalOrganicBodyChangeAt || collabEditState?.initialised?.lastLocalOrganicBodyChangeAt === previousLocalChangeTimeRef.current) // Implies no user changes have been made
        return;
        previousLocalChangeTimeRef.current = collabEditState.initialised.lastLocalOrganicBodyChangeAt;
        triggerUpdate();
    }, [
        isLivePage,
        triggerUpdate
    ]);
    (0, $6qdjm.usePluginStateEffect)(editorPresetAPI, [
        'collabEdit',
        'connectivity'
    ], handlePluginStateEffect);
    (0, $42omo.useEffect)(()=>{
        if (!isLivePage || !collabEditProvider || !collabEditInitialized) return;
        window.addEventListener('beforeunload', flushUpdate);
        return ()=>{
            window.removeEventListener('beforeunload', flushUpdate);
        };
    }, [
        collabEditInitialized,
        collabEditProvider,
        isLivePage,
        flushUpdate
    ]);
    return {
        triggerUpdate: triggerUpdate,
        cancelUpdate: cancelUpdate,
        flushUpdate: flushUpdate,
        draftSyncActionError: draftSyncActionError
    };
};





const $83a5ab04c7ded94b$export$f6774c6023dca75e = (fetchNativeCollab)=>{
    const hasPreloadedResult = (0, $42omo.useRef)(false);
    // Fetch native collab data into cache
    const preloadNativeCollabRefetch = (0, $42omo.useCallback)(async ()=>{
        try {
            const data = await fetchNativeCollab(false);
            hasPreloadedResult.current = true;
            return data;
        } catch (error) {
            hasPreloadedResult.current = false;
            throw error;
        }
    }, [
        fetchNativeCollab
    ]);
    const refetchNativeCollab = (0, $42omo.useCallback)(async (shouldCheckCache)=>{
        // Use cache if preloaded, otherwise use the provided value
        const checkCache = hasPreloadedResult.current || !!shouldCheckCache;
        try {
            return await fetchNativeCollab(checkCache);
        } catch (error) {
            hasPreloadedResult.current = false;
            throw error;
        }
    }, [
        fetchNativeCollab
    ]);
    return {
        refetchNativeCollab: refetchNativeCollab,
        preloadNativeCollabRefetch: preloadNativeCollabRefetch
    };
};



var $btQhd = parcelRequire("btQhd");


var $8uySb = parcelRequire("8uySb");


var $lmEhP = parcelRequire("lmEhP");


var $cvzKy = parcelRequire("cvzKy");


var $2dIEg = parcelRequire("2dIEg");


var $i8Ylv = parcelRequire("i8Ylv");





var $QU6QS = parcelRequire("QU6QS");


var $cQJcI = parcelRequire("cQJcI");


var $202oG = parcelRequire("202oG");




// find editor node dom with localId
const $6424f127b1220946$var$getLocalIdSelector = (localId)=>{
    // Check if the element with data-local-id exists
    if (document.querySelector(`[data-local-id="${localId}"]`)) return document.querySelector(`[data-local-id="${localId}"]`);
    // special case for tables, decision lists, and task lists which already have localId
    if (document.querySelector(`[data-table-local-id="${localId}"]`)) return document.querySelector(`[data-table-local-id="${localId}"]`);
    if (document.querySelector(`[data-decision-list-local-id="${localId}"]`)) return document.querySelector(`[data-decision-list-local-id="${localId}"]`);
    if (document.querySelector(`[data-task-list-local-id="${localId}"]`)) return document.querySelector(`[data-task-list-local-id="${localId}"]`);
    // special case for extension, smart cards and media
    if (document.querySelector(`[localid="${localId}"]`)) return document.querySelector(`[localid="${localId}"]`);
    return null;
};
const $6424f127b1220946$export$3873199fd2fe1b43 = (hasProseMirrorRendered, blockLinkHashPrefix = (0, $cQJcI.DEFAULT_BLOCK_LINK_HASH_PREFIX))=>{
    const { hash: hash } = (0, $QU6QS.useLocation)();
    (0, $42omo.useEffect)(()=>{
        if (!hasProseMirrorRendered || !hash) return;
        if ((0, $6mKj3.expValEquals)('platform_editor_block_menu', 'isEnabled', true)) {
            const blockId = (0, $cQJcI.extractBlockIdFromLinkHash)(hash, blockLinkHashPrefix);
            if (blockId) {
                const localIdSelector = $6424f127b1220946$var$getLocalIdSelector(blockId);
                localIdSelector?.scrollIntoView();
                return;
            }
        }
        const id = hash.slice(1);
        const element = document.getElementById(id);
        // Indicates anchor
        if (element) element.scrollIntoView();
        const headingIdToElement = (0, $202oG.getHeadingIdsToElements)();
        const scrollContainer = document.getElementsByClassName('fabric-editor-popup-scroll-parent')?.[0];
        // The top of the heading element
        const headingTop = headingIdToElement.get(id)?.getBoundingClientRect()?.top;
        // The top of the scroll container
        const scrollContainerTop = scrollContainer?.getBoundingClientRect()?.top;
        // The current scroll position
        const offset = scrollContainer?.scrollTop;
        if (headingTop === undefined || scrollContainerTop === undefined || offset === undefined) return;
        // Subtract the scroll container position from the heading position to get the scroll distance
        // and add the offset to account for current scroll position
        const scrollToY = headingTop - scrollContainerTop + offset;
        scrollContainer?.scrollTo({
            left: 0,
            top: scrollToY,
            behavior: 'smooth'
        });
    }, [
        hash,
        blockLinkHashPrefix,
        hasProseMirrorRendered
    ]);
};



var $cHANb = parcelRequire("cHANb");


var $3plmx = parcelRequire("3plmx");


var $3IZob = parcelRequire("3IZob");


var $awIbt = parcelRequire("awIbt");


var $dWbBL = parcelRequire("dWbBL");


var $dE9mB = parcelRequire("dE9mB");


var $2KWDO = parcelRequire("2KWDO");


var $bAGpj = parcelRequire("bAGpj");


var $5IgBW = parcelRequire("5IgBW");

/**
 * @graphql cc
 */ 









var $kDIns = parcelRequire("kDIns");


var $aHcFH = parcelRequire("aHcFH");


var $i49vP = parcelRequire("i49vP");




/**
 * @generated SignedSource<<e99e5f77398de72ed1eaf920aeb05693>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $2640c2b6e1124b9f$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["FOOTER"] = "FOOTER";
    CommentType["INLINE"] = "INLINE";
    CommentType["RESOLVED"] = "RESOLVED";
    CommentType["UNRESOLVED"] = "UNRESOLVED";
    return CommentType;
}({});
var $2640c2b6e1124b9f$export$950556173b6cbecb = /*#__PURE__*/ function(Depth) {
    Depth["ALL"] = "ALL";
    Depth["ROOT"] = "ROOT";
    return Depth;
}({});
var $2640c2b6e1124b9f$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});


const $362e915d9e4c68ec$var$useCommentRefetchInlineCommentTopLevelMarkerRefsQuery = (0, $eSUdr.default)`query useCommentRefetchInlineCommentTopLevelMarkerRefsQuery($pageId:ID!$contentStatus:[GraphQLContentStatus]$depth:Depth$type:[CommentType]){comments(pageId:$pageId contentStatus:$contentStatus depth:$depth type:$type){nodes{id parentId location{type ...on InlineComment{inlineMarkerRef}}}}}`;
const $362e915d9e4c68ec$export$fa2f3483b0f3a070 = (annotations, adfAnnotations)=>{
    if (!adfAnnotations) return [];
    return annotations.filter((annotation)=>{
        return adfAnnotations.hasOwnProperty(annotation);
    });
};
const $362e915d9e4c68ec$export$309cbc11a2b3a570 = ({ isDocumentActive: isDocumentActive, contentId: contentId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment, handleGqlError: handleGqlError, previousAnnotations: previousAnnotations, updateUnreadCommentsOnFirstRender: updateUnreadCommentsOnFirstRender, updateUnreadComments: updateUnreadComments, adfAnnotations: adfAnnotations })=>{
    const { refetch: refetch } = (0, $xQxzY.useQuery)($362e915d9e4c68ec$var$useCommentRefetchInlineCommentTopLevelMarkerRefsQuery, {
        variables: {
            pageId: contentId,
            contentStatus: [
                (0, $2640c2b6e1124b9f$export$b634e5de755b7d35).DRAFT,
                (0, $2640c2b6e1124b9f$export$b634e5de755b7d35).CURRENT
            ]
        },
        skip: true,
        onError: handleGqlError,
        fetchPolicy: 'network-only'
    });
    // Track previous isDocumentActive state to detect when document becomes active
    const prevIsDocumentActive = (0, $42omo.useRef)(isDocumentActive);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_remove_comment_refetch')) // Feature gate on comment refetch is disabled, subscriptions will handle updates to the annotations
        // See handleOnPublicationEvent in next/packages/comments-pubsub/src/hooks/useEditorInlineCommentsPubSub.ts
        // The useCommentRefetch hook will be removed.
        return;
        // Only trigger refetch when document becomes active (user comes back to page)
        if (isDocumentActive && !prevIsDocumentActive.current) refetch({
            pageId: contentId,
            contentStatus: [
                (0, $2640c2b6e1124b9f$export$b634e5de755b7d35).DRAFT,
                (0, $2640c2b6e1124b9f$export$b634e5de755b7d35).CURRENT
            ],
            depth: (0, $2640c2b6e1124b9f$export$950556173b6cbecb).ROOT,
            type: [
                (0, $2640c2b6e1124b9f$export$ffa1150e6a48f9cd).UNRESOLVED
            ]
        }).then((response)=>{
            const updatedAnnotationsFromQuery = (0, $i49vP.updateCommentHighlightsInEditor)({
                data: response.data,
                previousAnnotations: previousAnnotations
            });
            // organizes the annotations for navigation to work
            if (updatedAnnotationsFromQuery.length) {
                // filter out annotations from the response that are not in the annotation state
                // the query may return dangling annotations that are not in the ADF
                const updatedAnnotationsWithAdf = (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux') ? $362e915d9e4c68ec$export$fa2f3483b0f3a070(updatedAnnotationsFromQuery, adfAnnotations) : updatedAnnotationsFromQuery;
                // annotations is a sorted list of marker refs in the ADF
                (0, $kDIns.getEditorResolvedState)({
                    annotations: (0, $aHcFH.getSortedMarkerRefs)(updatedAnnotationsWithAdf, 'edit'),
                    pageId: contentId,
                    triggerAnalyticsEvent: triggerAnalyticsEvent,
                    updateUnresolvedInlineComment: updateUnresolvedInlineComment
                });
                if (!(0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) {
                    updateUnreadCommentsOnFirstRender(true);
                    updateUnreadComments(true);
                }
            }
        }).catch((error)=>{
            handleGqlError(error);
        });
        // Update the ref with current state
        prevIsDocumentActive.current = isDocumentActive;
    // we only want to update the comment highlights when the user comes back to the page
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDocumentActive,
        adfAnnotations
    ]);
};



var $aUU0C = parcelRequire("aUU0C");


var $k8e76 = parcelRequire("k8e76");


var $WheoQ = parcelRequire("WheoQ");


var $fHAwL = parcelRequire("fHAwL");


var $OCz5m = parcelRequire("OCz5m");


var $aPQsP = parcelRequire("aPQsP");


var $bcv7k = parcelRequire("bcv7k");


var $32x2E = parcelRequire("32x2E");


var $brsfB = parcelRequire("brsfB");


var $hdxAi = parcelRequire("hdxAi");











var $a3fRD = parcelRequire("a3fRD");





var $b4wUN = parcelRequire("b4wUN");


var $esRft = parcelRequire("esRft");


var $b3j2Y = parcelRequire("b3j2Y");











var $a7SsH = parcelRequire("a7SsH");

/**
 * @graphql cc
 */ 






















const $a429a791ecef3570$var$useUsersContentPermissionsContentPermissionsQuery = (0, $eSUdr.default)`query useUsersContentPermissionsContentPermissionsQuery($accountIds:[String]!$contentId:ID!){contentPermissions(contentId:$contentId){contentAccess subjectsWithEffectiveContentPermissions{nodes{id displayName user{profilePicture{path}}}}}usersWithContentRestrictions(accountIds:$accountIds contentId:$contentId){hasSpaceViewPermission restrictingContent{id hasRestrictions}accountId displayName profilePicture{path}}}`;
const $a429a791ecef3570$var$useUsersContentPermissionsNewUserHasRestrictionsQuery = (0, $eSUdr.default)`query useUsersContentPermissionsNewUserHasRestrictionsQuery($cloudId:ID!$accountIds:[String]!$resourceId:ID!$resourceType:String!$permission:String!){confluence_usersHavePermission(cloudId:$cloudId principalIds:$accountIds resourceId:$resourceId resourceType:$resourceType permission:$permission){usersHavePermissionList{principalId hasPermission}}confluenceUsers(accountIds:$accountIds){nodes{displayName profilePicture{path}...on KnownUser{accountId}}}}`;
const $a429a791ecef3570$var$useUsersContentPermissionsUpdateContentPermissionsMutation = (0, $eSUdr.default)`mutation useUsersContentPermissionsUpdateContentPermissionsMutation($contentId:ID!$input:[UpdateContentPermissionsInput]!){updateContentPermissions(contentId:$contentId input:$input){status}}`;
const $a429a791ecef3570$export$d525ee52d361179f = async ({ accountIds: accountIds, contentId: contentId, cloudId: cloudId, setAddedMentions: setAddedMentions, setAddedTasks: setAddedTasks })=>{
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: data } = await (0, $hp2SH.getApolloClient)().query({
            query: $a429a791ecef3570$var$useUsersContentPermissionsNewUserHasRestrictionsQuery,
            variables: {
                cloudId: cloudId,
                accountIds: accountIds,
                resourceId: contentId,
                resourceType: 'PAGE',
                permission: 'VIEW'
            },
            fetchPolicy: 'network-only' // we'll need to check user's permissions everytime to correctly display the correct flag contents in case the user's permission changed
        });
        const usersWithViewPermissions = new Set(data?.confluence_usersHavePermission?.usersHavePermissionList?.filter((user)=>user?.hasPermission).map((user)=>user?.principalId));
        return data?.confluenceUsers?.nodes?.reduce((acc, user)=>{
            if (usersWithViewPermissions.has(user?.accountId)) acc.push({
                id: user?.accountId,
                hasViewRestrictions: false,
                displayName: user?.displayName,
                userPhoto: user?.profilePicture?.path
            });
            return acc;
        }, []);
    } catch (error) {
        //reset state so query won't keep erroring out on same data
        setAddedMentions([]);
        setAddedTasks([]);
        return [];
    }
};
const $a429a791ecef3570$export$a5b8a857cb669f1f = ({ contentId: contentId, isUpdatedMentionsInLivePagesEnabled: isUpdatedMentionsInLivePagesEnabled, isLivePage: isLivePage, currentUserId: currentUserId, mentionsToDisplay: mentionsToDisplay, source: source })=>{
    //TODO: save the permissions of users in a separate state if it's already available, so that we don't have to query forit again
    const mentionedUserIds = (0, $42omo.useMemo)(()=>{
        const allUniqueMentionedUserIds = new Set(mentionsToDisplay.map((mention)=>mention.id));
        return Array.from(allUniqueMentionedUserIds);
    }, [
        mentionsToDisplay
    ]);
    const [unrestrictedUsers, setUnrestrictedUsers] = (0, $42omo.useState)([]);
    const [isUnrestrictedUsersLoading, setIsUnrestrictedUsersLoading] = (0, $42omo.useState)(false);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { setAddedMentions: setAddedMentions, setAddedTasks: setAddedTasks, addUnrestrictedMentions: addUnrestrictedMentions, addParentSpaceRestrictedMentions: addParentSpaceRestrictedMentions, addPageRestrictedMentions: addPageRestrictedMentions, addParentSpaceRestrictedTasks: addParentSpaceRestrictedTasks, addPageRestrictedTasks: addPageRestrictedTasks, addUnrestrictedTasks: addUnrestrictedTasks } = (0, $hdxAi.useMentionsNotificationsActions)();
    //useLazyQuery is being used here because skip was not being respected in useQuery. Known issue in react-apollo: https://github.com/apollographql/react-apollo/issues/3492
    const [getContentPermissions, { data: updatedContentPermissionsData, error: updatedUsersContentPermissionsError, loading: updatedUsersContentPermissionsLoading }] = (0, $jxs8y.useLazyQuery)($a429a791ecef3570$var$useUsersContentPermissionsContentPermissionsQuery, {
        variables: {
            contentId: contentId,
            accountIds: mentionedUserIds
        },
        fetchPolicy: 'network-only',
        // we'll need to check user's permissions everytime to correctly display the correct flag contents in case the user's permission changed
        onError: ()=>{
            //reset state so query won't keep erroring out on same data
            setAddedMentions([]);
            setAddedTasks([]);
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (isUpdatedMentionsInLivePagesEnabled && mentionedUserIds.length) getContentPermissions({
            variables: {
                contentId: contentId,
                accountIds: mentionedUserIds
            }
        });
    }, [
        contentId,
        isUpdatedMentionsInLivePagesEnabled,
        mentionedUserIds,
        getContentPermissions
    ]);
    (0, $42omo.useEffect)(()=>{
        const fetchUnrestrictedUsers = async ()=>{
            if (isUpdatedMentionsInLivePagesEnabled && mentionedUserIds.length) {
                setIsUnrestrictedUsersLoading(true);
                try {
                    const usersWithViewPermissions = await $a429a791ecef3570$export$d525ee52d361179f({
                        accountIds: mentionedUserIds,
                        contentId: contentId,
                        cloudId: cloudId,
                        setAddedMentions: setAddedMentions,
                        setAddedTasks: setAddedTasks
                    });
                    setUnrestrictedUsers(usersWithViewPermissions);
                } finally{
                    setIsUnrestrictedUsersLoading(false);
                }
            }
        };
        fetchUnrestrictedUsers();
    }, [
        contentId,
        isUpdatedMentionsInLivePagesEnabled,
        mentionedUserIds,
        cloudId,
        setAddedMentions,
        setAddedTasks
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [updateUsersContentPermissionMutation] = (0, $1KmJq.useMutation)($a429a791ecef3570$var$useUsersContentPermissionsUpdateContentPermissionsMutation, {
        onCompleted: ()=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    actionSubject: 'updateContentPermissions',
                    action: 'succeeded',
                    source: source,
                    attributes: {
                        contentId: contentId,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        },
        onError: (error)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    actionSubject: 'updateContentPermissions',
                    action: 'failed',
                    source: source,
                    attributes: {
                        contentId: contentId,
                        error: error.message,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        }
    });
    const mentionsWithSpaceRestrictions = [];
    const usersWithSpaceRestrictionsIds = new Set();
    const mentionsWithParentPageRestrictions = [];
    const usersWithParentPageRestrictionsIds = new Set();
    const usersWithSpaceOrParentRestrictionsIds = new Set();
    const usersWithCurrentPageRestrictionsIds = new Set();
    const usersWithUnrestrictedPageAccessIds = new Set();
    const accountIdToDisplayNameMap = new Map();
    (0, $42omo.useEffect)(()=>{
        if (Boolean(updatedContentPermissionsData && mentionsToDisplay?.length && !isUnrestrictedUsersLoading)) {
            const { contentPermissions: contentPermissions, usersWithContentRestrictions: contentRestrictions } = updatedContentPermissionsData;
            if (contentPermissions?.contentAccess === 'EVERYONE_NO_ACCESS') {
                contentPermissions?.subjectsWithEffectiveContentPermissions?.nodes?.forEach((user)=>{
                    if (user?.id === currentUserId || !user?.id) return;
                    usersWithUnrestrictedPageAccessIds.add(user.id);
                    accountIdToDisplayNameMap.set(user.id, {
                        displayName: user.displayName,
                        userPhoto: user?.user?.profilePicture?.path
                    });
                });
                unrestrictedUsers.forEach((user)=>{
                    usersWithUnrestrictedPageAccessIds.add(user.id);
                    accountIdToDisplayNameMap.set(user.id, {
                        displayName: user.displayName ?? '',
                        userPhoto: user.userPhoto ?? ''
                    });
                });
            }
            contentRestrictions?.forEach((user)=>{
                if (!user?.accountId) return;
                accountIdToDisplayNameMap.set(user.accountId, {
                    displayName: user.displayName,
                    userPhoto: user?.profilePicture?.path
                });
                if (!user.hasSpaceViewPermission) {
                    //has space level restriction
                    usersWithSpaceRestrictionsIds.add(user.accountId);
                    usersWithSpaceOrParentRestrictionsIds.add(user.accountId);
                } else if (user.restrictingContent?.hasRestrictions) {
                    //has parent page level restriction
                    usersWithParentPageRestrictionsIds.add(user.accountId);
                    usersWithSpaceOrParentRestrictionsIds.add(user.accountId);
                } else if (contentPermissions?.contentAccess === 'EVERYONE_NO_ACCESS') //might have page level restriction
                {
                    if (!usersWithUnrestrictedPageAccessIds.has(user.accountId)) usersWithCurrentPageRestrictionsIds.add(user.accountId);
                }
            });
            mentionsToDisplay.forEach((mention)=>{
                const mentionToAdd = {
                    ...mention,
                    displayName: accountIdToDisplayNameMap.get(mention.id)?.displayName ?? '',
                    userPhoto: accountIdToDisplayNameMap.get(mention.id)?.userPhoto ?? ''
                };
                if (mention?.taskLocalId) {
                    //Buckets added task mentions into different permission groups
                    if (usersWithSpaceRestrictionsIds.has(mention.id)) //Users who dont have access to the page due to space restrictions
                    addParentSpaceRestrictedTasks([
                        mentionToAdd
                    ]);
                    else if (usersWithParentPageRestrictionsIds.has(mention.id)) //Users who don't have access to the page due to parent page restrictions
                    addParentSpaceRestrictedTasks([
                        mentionToAdd
                    ]);
                    else if (usersWithCurrentPageRestrictionsIds.has(mention.id)) //Users who don't have access to the page due to current page restrictions
                    addPageRestrictedTasks([
                        mentionToAdd
                    ]);
                    else //Users who have access to the page
                    addUnrestrictedTasks([
                        mentionToAdd
                    ]);
                } else {
                    //Buckets added general mentions into different permission groups
                    if (usersWithSpaceRestrictionsIds.has(mention.id)) {
                        //Users who dont have access to the page due to space restrictions
                        mentionsWithSpaceRestrictions.push(mentionToAdd);
                        addParentSpaceRestrictedMentions([
                            mentionToAdd
                        ]);
                    } else if (usersWithParentPageRestrictionsIds.has(mention.id)) {
                        //Users who don't have access to the page due to parent page restrictions
                        mentionsWithParentPageRestrictions.push(mentionToAdd);
                        addParentSpaceRestrictedMentions([
                            mentionToAdd
                        ]);
                    } else if (usersWithCurrentPageRestrictionsIds.has(mention.id)) //Users who don't have access to the page due to current page restrictions
                    addPageRestrictedMentions([
                        mentionToAdd
                    ]);
                    else //Users who have access to the page
                    addUnrestrictedMentions([
                        mentionToAdd
                    ]);
                }
            });
            setAddedMentions([]);
            setAddedTasks([]);
            setUnrestrictedUsers([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        updatedContentPermissionsData,
        isUnrestrictedUsersLoading,
        unrestrictedUsers
    ]);
    return {
        updatedUsersContentPermissionsError: updatedUsersContentPermissionsError,
        updatedUsersContentPermissionsLoading: updatedUsersContentPermissionsLoading,
        updateUsersContentPermissionMutation: updateUsersContentPermissionMutation
    };
};


/**
 * @graphql cc
 */ 











const $05c7f8c23696cebd$var$useMentionNotificationMutationCreateContentMentionNotificationActionMutation = (0, $eSUdr.default)`mutation useMentionNotificationMutationCreateContentMentionNotificationActionMutation($contentId:ID!$mentions:[ContentMention]!){createContentMentionNotificationAction(input:{contentId:$contentId mentions:$mentions}){contentId success errors{message}}}`;
const $05c7f8c23696cebd$export$82f89b951e37c769 = ({ contentId: contentId, setError: setError, showDontNotifyFailedFlag: showDontNotifyFailedFlag })=>{
    const [createContentMentionNotificationAction, { error: contentMentionNotificationError }] = (0, $1KmJq.useMutation)($05c7f8c23696cebd$var$useMentionNotificationMutationCreateContentMentionNotificationActionMutation);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendMentionNotification = (0, $42omo.useCallback)(({ mentions: mentions })=>{
        const fireAnalyticsEvent = (action)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'mentionsNotifications',
                    action: action,
                    actionSubject: 'mentionInputMutation',
                    attributes: {
                        mentions: mentions.map((mention)=>({
                                mentionedUserId: mention.mentionedUserAccountId,
                                mentionId: mention.mentionLocalId
                            })),
                        contentId: contentId
                    }
                }
            }).fire();
        };
        // NCS draft syncs need to happen prior to mutation in order for
        // email content to show up. A 15 second buffer after user closes
        // the flag notification will give draft syncs a chance to happen.
        setTimeout(()=>{
            // tells backend to send notificiation for the list of mention IDs
            createContentMentionNotificationAction({
                variables: {
                    contentId: contentId,
                    mentions: mentions
                }
            }).then(()=>{
                fireAnalyticsEvent('succeeded');
            }).catch(()=>{
                //TODO: create new error flag that handles multiple names
                fireAnalyticsEvent('failed');
            });
        }, 15000);
    }, [
        contentId,
        createAnalyticsEvent,
        createContentMentionNotificationAction
    ]);
    const sendCancelMentionNotification = (0, $42omo.useCallback)(({ mentions: mentions })=>{
        createContentMentionNotificationAction({
            variables: {
                contentId: contentId,
                mentions: mentions
            }
        }).catch((error)=>{
            setError(error);
            showDontNotifyFailedFlag();
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentId,
        createContentMentionNotificationAction
    ]);
    return {
        sendMentionNotification: sendMentionNotification,
        sendCancelMentionNotification: sendCancelMentionNotification,
        contentMentionNotificationError: contentMentionNotificationError
    };
};


/**
 * @graphql cc
 */ 














const $204e1c50e8dfb669$var$useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation = (0, $eSUdr.default)`mutation useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation($contentId:ID!$tasks:[IndividualInlineTaskNotificationInput]!){createInlineTaskNotification(input:{contentId:$contentId tasks:$tasks}){contentId success errors{message}}}`;
const $204e1c50e8dfb669$export$bb50e46e1081bc7f = ({ contentId: contentId, setError: setError, showDontNotifyFailedFlag: showDontNotifyFailedFlag })=>{
    const [createInlineTaskNotificationMutation, { error: createTaskNotificationError }] = (0, $1KmJq.useMutation)($204e1c50e8dfb669$var$useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendCreateInlineTaskNotifications = (0, $42omo.useCallback)(({ tasks: tasks })=>{
        const fireAnalyticsEvent = (action)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'mentionsNotifications',
                    action: action,
                    actionSubject: 'createInlineTaskMention',
                    attributes: {
                        contentId: contentId,
                        mentions: tasks?.map((task)=>({
                                taskId: task.taskId,
                                mentionId: task.recipientMentionLocalId,
                                mentionedUserId: task.recipientAccountId
                            }))
                    }
                }
            }).fire();
        };
        const taskItemsToNotify = (0, $9wGTI.fg)('confluence_frontend_task_mentions_id') ? tasks?.map((task)=>({
                ...task,
                taskId: '0'
            })) : tasks;
        // NCS draft syncs need to happen prior to mutation in order for
        // email content to show up. A 15 second buffer after user closes
        // the flag notification will give draft syncs a chance to happen.
        setTimeout(()=>{
            createInlineTaskNotificationMutation({
                variables: {
                    contentId: contentId,
                    tasks: taskItemsToNotify
                }
            }).then(()=>{
                fireAnalyticsEvent('succeeded');
            }).catch((error)=>{
                fireAnalyticsEvent('failed');
                setError(error);
            });
        }, 15000);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentId,
        createAnalyticsEvent,
        createInlineTaskNotificationMutation
    ]);
    const cancelInlineTaskNotifications = (0, $42omo.useCallback)(({ tasks: tasks })=>{
        const taskItemsToNotify = (0, $9wGTI.fg)('confluence_frontend_task_mentions_id') ? tasks?.map((task)=>({
                ...task,
                taskId: '0'
            })) : tasks;
        createInlineTaskNotificationMutation({
            variables: {
                contentId: contentId,
                tasks: taskItemsToNotify
            }
        }).catch(()=>{
            showDontNotifyFailedFlag();
        });
    }, [
        contentId,
        createInlineTaskNotificationMutation,
        showDontNotifyFailedFlag
    ]);
    return {
        sendCreateInlineTaskNotifications: sendCreateInlineTaskNotifications,
        cancelInlineTaskNotifications: cancelInlineTaskNotifications,
        createTaskNotificationError: createTaskNotificationError
    };
};


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $55e2d13107c6bf2d$export$4fd34ed002cf6bfb = /*#__PURE__*/ function(ContentRole) {
    ContentRole["DEFAULT"] = "DEFAULT";
    ContentRole["EDITOR"] = "EDITOR";
    ContentRole["VIEWER"] = "VIEWER";
    return ContentRole;
}({});
var $55e2d13107c6bf2d$export$aa5f3445d469c06b = /*#__PURE__*/ function(ConfluencePrincipalType) {
    ConfluencePrincipalType["GROUP"] = "GROUP";
    ConfluencePrincipalType["USER"] = "USER";
    return ConfluencePrincipalType;
}({});


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $1acca270709c231c$export$ab5aad00225c5662 = /*#__PURE__*/ function(Operation) {
    Operation["ASSIGNED"] = "ASSIGNED";
    Operation["COMPLETE"] = "COMPLETE";
    Operation["DELETED"] = "DELETED";
    Operation["IN_COMPLETE"] = "IN_COMPLETE";
    Operation["REWORDED"] = "REWORDED";
    Operation["UNASSIGNED"] = "UNASSIGNED";
    return Operation;
}({});



var $cgtv4 = parcelRequire("cgtv4");

const $7af36150ec4f5d3b$export$b059320aeb0e91e6 = (0, $cgtv4.defineMessages)({
    mentionFlagTitle: {
        id: "mentions-notifications.mention.flag.title",
        defaultMessage: "{displayName} will be notified"
    },
    mentionFlagTitleTwoMentions: {
        id: "mentions-notifications.mention.flag.title.two.mentions",
        defaultMessage: "{displayName} and {somebodyElse} will be notified"
    },
    mentionFlagTitleMultipleMentions: {
        id: "mentions-notifications.mention.flag.title.multiple.mentions",
        defaultMessage: "{displayName}, {somebodyElse}, and {numOthers, plural, one {# other} other {# others}} will be notified"
    },
    mentionFlagDescription: {
        id: "mentions-notifications.mention.flag.description",
        defaultMessage: "We\u2019ll let them know you mentioned them."
    },
    taskMentionFlagTitle: {
        id: "mentions-notifications.task.mention.flag.title",
        defaultMessage: "We\u2019ll notify {displayName}"
    },
    taskMentionFlagDescription: {
        id: "mentions-notifications.task.mention.flag.description",
        defaultMessage: "We\u2019ll let them know you assigned them a task."
    },
    mentionFlagFailedTitle: {
        id: "mentions-notifications.mention.flag.failed.title",
        defaultMessage: "We weren\u2019t able to notify {displayName}"
    },
    mentionFlagFailedTitleWithoutDisplayName: {
        id: "mentions-notifications.mention.flag.failed.generic.title",
        defaultMessage: "We weren\u2019t able to notify the user"
    },
    mentionFlagFailedDescription: {
        id: "mentions-notifications.mention.flag.failed.description",
        defaultMessage: "In order to notify them, you\u2019ll need to @ mention them again."
    },
    mentionFlagDoNotNotifyButton: {
        id: "mentions-notifications.mention.flag.do.not.notify.button",
        defaultMessage: "Don\u2019t notify"
    },
    mentionFlagAcknowledgeButton: {
        id: "mentions-notifications.mention.flag.acknowledge.button",
        defaultMessage: "OK"
    },
    mentionFlagNoPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.permissions.title",
        defaultMessage: "Share with {displayName}?"
    },
    mentionFlagTwoNoPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.permissions.two.mentions.title",
        defaultMessage: "Share with {displayName} and {somebodyElse}?"
    },
    mentionFlagMultipleNoPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.permissions.multiple.mentions.title",
        defaultMessage: "Share with {displayName}, {somebodyElse}, and {numOthers, plural, one {# other} other {# others}}"
    },
    mentionFlagNoSpaceOrParentPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.space.parent.permissions.title",
        defaultMessage: "{displayName} won\u2019t be notified"
    },
    mentionFlagTwoNoSpaceOrParentPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.space.parent.permissions.two.mentions.title",
        defaultMessage: "{displayName} and {somebodyElse} won\u2019t be notified"
    },
    mentionFlagMultipleNoSpaceOrParentPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.space.parent.permissions.multiple.mentions.title",
        defaultMessage: "{displayName}, {somebodyElse}, and {numOthers, plural, one {# other} other {# others}} won\u2019t be notified"
    },
    taskMentionFlagNoPermissionsTitle: {
        id: "mentions-notifications.task.mention.flag.no.permissions.title",
        defaultMessage: "Share with {displayName}?"
    },
    mentionFlagNoSpaceOrParentPermissionsDescription: {
        id: "mentions-notifications.mention.flag.no.space.parent.permissions.description",
        defaultMessage: "They need space or parent access, so we can\u2019t let them know you mentioned them."
    },
    mentionFlagNoPermissionsDescription: {
        id: "mentions-notifications.mention.flag.no.permissions.description",
        defaultMessage: "They don\u2019t have access to this content, so we can\u2019t let them know you mentioned them."
    },
    taskMentionFlagNoPermissionsDescription: {
        id: "mentions-notifications.task.mention.flag.no.permissions.description",
        defaultMessage: "They don\u2019t have access to this content, so we can\u2019t assign them a task or notify them."
    },
    mentionFlagNoPermissionsParentRestrictionsDescription: {
        id: "mentions-notifications.mention.flag.no.permissions.parent.restrictions.description",
        defaultMessage: "They don\u2019t have access to a parent item, so we can\u2019t let them know you mentioned them."
    },
    taskMentionFlagNoPermissionsParentRestrictionsDescription: {
        id: "mentions-notifications.task.mention.flag.no.permissions.parent.restrictions.description",
        defaultMessage: "They don\u2019t have access to a parent item, so we can\u2019t assign them a task or notify them."
    },
    mentionFlagNoPermissionsSpaceRestrictionsDescription: {
        id: "mentions-notifications.mention.flag.no.permissions.space.restrictions.description",
        defaultMessage: "They don\u2019t have access to the space, so we can\u2019t let them know you mentioned them."
    },
    taskMentionFlagNoPermissionsSpaceRestrictionsDescription: {
        id: "mentions-notifications.task.mention.flag.no.permissions.space.restrictions.description",
        defaultMessage: "They don\u2019t have access to the space, so we can\u2019t assign them a task or notify them."
    },
    taskMentionFlagNoPermissionsParentSpaceRestrictionsDescription: {
        id: "mentions-notifications.task.mention.flag.no.permissions.parent.space.restrictions.description",
        defaultMessage: "They don\u2019t have access to a parent item or space, so we can\u2019t assign them this task or notify them."
    },
    mentionFlagShareNowButton: {
        id: "mentions-notifications.mention.flag.share.now.button",
        defaultMessage: "Share now"
    },
    mentionFlagDontShareButton: {
        id: "mentions-notifications.mention.flag.dont.share.button",
        defaultMessage: "Don\u2019t share"
    },
    mentionFlagShareFailedTitle: {
        id: "mentions-notifications.mention.flag.share.failed.title",
        defaultMessage: "We weren\u2019t able to share this content with {displayName}"
    },
    mentionFlagShareFailedDescription: {
        id: "mentions-notifications.mention.flag.share.failed.description",
        defaultMessage: "Please try again later."
    },
    deletedMentionFlagTitle: {
        id: "mentions-notifications.mention.flag.deleted.title",
        defaultMessage: "You just removed an @ mention"
    },
    deletedMentionFlagDescription: {
        id: "mentions-notifications.mention.flag.deleted.description",
        defaultMessage: "{name} won\u2019t be notified anymore"
    },
    deletedMentionFlagConfirmation: {
        id: "mentions-notifications.mention.flag.deleted.confirmation",
        defaultMessage: "Got it"
    },
    dontNotifyFailureTitle: {
        id: "mentions-notifications.mention.flag.do.not.notify.failure.title",
        defaultMessage: "Something went wrong"
    },
    dontNotifyFailureDescription: {
        id: "mentions-notifications.mention.flag.do.not.notify.failure.description",
        defaultMessage: "Due to an error, we weren\u2019t able to cancel this notification."
    }
});






var $cAdj8 = parcelRequire("cAdj8");

const $4363b504cf9a037b$export$d8cade7866e82605 = ()=>{
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)();
    const canEditPageRestrictions = (0, $42omo.useMemo)(()=>{
        if (pageInfo) {
            const pageType = pageInfo.type ?? '';
            const operations = pageInfo.operations || [];
            const userCanEditRestrictions = operations.some((o)=>o?.operation === 'restrict_content' && o?.targetType === pageType);
            return userCanEditRestrictions;
        }
        return false;
    }, [
        pageInfo
    ]);
    return canEditPageRestrictions;
};





const $2b2a9498abd1ee19$export$406377d40397a2f7 = (startTime)=>{
    const endTime = Date.now();
    let elapsedTimeInSeconds = 0;
    if (startTime.current !== null) elapsedTimeInSeconds = (endTime - startTime.current) / 1000; // Convert to seconds
    return elapsedTimeInSeconds;
};


const $36be47a9ed41f8db$var$getDisplayNames = (mentions)=>{
    const displayNames = new Set(mentions.map((mention)=>mention.displayName));
    const iterator = displayNames.values();
    const displayName = iterator.next().value ?? '';
    const somebodyElse = iterator.next().value ?? '';
    return {
        displayNames: displayNames,
        displayName: displayName,
        somebodyElse: somebodyElse
    };
};
const $36be47a9ed41f8db$export$fdb0a5f78dc34be6 = ({ flags: flags, contentId: contentId, isLivePage: isLivePage, isMentionsNotificationsEnabled: isMentionsNotificationsEnabled, editorActions: editorActions })=>{
    const [{ addedMentions: addedMentions, deletedMentions: deletedMentions, addedTasks: addedTasks, unrestrictedMentions: unrestrictedMentions, parentSpaceRestrictedMentions: parentSpaceRestrictedMentions, pageRestrictedMentions: pageRestrictedMentions, unrestrictedTasks: unrestrictedTasks, pageRestrictedTasks: pageRestrictedTasks, parentSpaceRestrictedTasks: parentSpaceRestrictedTasks, deletedTasks: deletedTasks, mentionsAdded: mentionsAdded, tasksAdded: tasksAdded }, { setAddedMentions: setAddedMentions, setDeletedMentions: setDeletedMentions, setUnrestrictedMentions: setUnrestrictedMentions, setParentSpaceRestrictedMentions: setParentSpaceRestrictedMentions, setPageRestrictedMentions: setPageRestrictedMentions, setUnrestrictedTasks: setUnrestrictedTasks, setPageRestrictedTasks: setPageRestrictedTasks, setParentSpaceRestrictedTasks: setParentSpaceRestrictedTasks, setDeletedTasks: setDeletedTasks, setMentionsAdded: setMentionsAdded, setTasksAdded: setTasksAdded }] = (0, $hdxAi.useMentionsNotifications)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    //General Mention Flag IDs
    const [currentAddedMentionFlagId, setCurrentAddedMentionFlagId] = (0, $42omo.useState)('');
    const [currentSpaceOrParentRestrictionMentionFlagId, setCurrentSpaceOrParentRestrictionMentionFlagId] = (0, $42omo.useState)('');
    const [currentPageRestrictionMentionFlagId, setCurrentPageRestrictionMentionFlagId] = (0, $42omo.useState)('');
    //Task Mentions Flag IDs
    const [currentAddedTaskFlagId, setCurrentAddedTaskFlagId] = (0, $42omo.useState)('');
    const [currentPageRestrictionTaskFlagId, setCurrentPageRestrictionTaskFlagId] = (0, $42omo.useState)('');
    const [currentSpaceOrParentRestrictionTaskFlagId, setCurrentSpaceOrParentRestrictionTaskFlagId] = (0, $42omo.useState)('');
    //General Mention Timeouts
    const addedUnrestrictedMentionFlagTimeout = (0, $42omo.useRef)();
    const pageRestrictedMentionFlagTimeout = (0, $42omo.useRef)();
    const spaceParentRestrictedMentionFlagTimeout = (0, $42omo.useRef)();
    //Task Mention Timeouts
    const addedUnrestrictedTaskFlagTimeout = (0, $42omo.useRef)();
    const pageRestrictedTaskFlagTimeout = (0, $42omo.useRef)();
    const spaceParentRestrictedTaskFlagTimeout = (0, $42omo.useRef)();
    const [error, setError] = (0, $42omo.useState)(null);
    const mentionsToDisplay = (0, $42omo.useMemo)(()=>[
            ...addedMentions,
            ...addedTasks
        ], [
        addedMentions,
        addedTasks
    ]);
    const { updatedUsersContentPermissionsError: updatedUsersContentPermissionsError, updatedUsersContentPermissionsLoading: updatedUsersContentPermissionsLoading, updateUsersContentPermissionMutation: updateUsersContentPermissionMutation } = (0, $a429a791ecef3570$export$a5b8a857cb669f1f)({
        contentId: contentId,
        isUpdatedMentionsInLivePagesEnabled: isMentionsNotificationsEnabled,
        isLivePage: isLivePage,
        currentUserId: currentUserId,
        mentionsToDisplay: mentionsToDisplay,
        source: 'mentionNoAccessFlag'
    });
    const canEditPageRestrictions = (0, $4363b504cf9a037b$export$d8cade7866e82605)();
    (0, $42omo.useEffect)(()=>{
        const getDuplicateMentions = async (mentions)=>{
            const duplicateMentions = new Set();
            if (mentions.length > 0) {
                const mentionCounts = new Map();
                const editorContent = await editorActions?.getValue();
                editorContent?.content?.forEach((node)=>{
                    node?.content?.forEach((content)=>{
                        if (content.type === 'mention') {
                            if (mentionCounts.has(content.attrs.id)) mentionCounts.set(content.attrs.id, mentionCounts.get(content.attrs.id) + 1);
                            else mentionCounts.set(content.attrs.id, 1);
                        }
                    });
                });
                mentions.forEach((mention)=>{
                    if (mentionCounts.get(mention.id) > 1) duplicateMentions.add(mention.id);
                });
            }
            return duplicateMentions;
        };
        getDuplicateMentions(mentionsToDisplay).then((duplicateMentions)=>{
            if (duplicateMentions.size > 0) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'mentionsNotifications',
                    action: 'created',
                    actionSubject: 'mention',
                    attributes: {
                        isDuplicate: true
                    }
                }
            }).fire();
        }).catch((e)=>{
            setError(e);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mentionsToDisplay
    ]);
    const mentionsFlagStartTime = (0, $42omo.useRef)(null);
    const tasksFlagStartTime = (0, $42omo.useRef)(null);
    // `showCustomFlag` for confirmation flags without CTA
    const showCustomFlag = (0, $42omo.useCallback)(({ title: title, description: description, userPhoto: userPhoto, autoDismiss: autoDismiss = true, id: id, handleOnClose: handleOnClose })=>{
        flags.showCustomFlag({
            id: id ?? undefined,
            title: title,
            description: description,
            isAutoDismiss: autoDismiss,
            customIcon: userPhoto ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                src: userPhoto,
                label: "mention"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b4wUN))), {
                spacing: "spacious",
                label: "mention"
            }),
            onClose: handleOnClose
        });
    }, [
        flags
    ]);
    const showDontNotifyFailedFlag = (0, $42omo.useCallback)(()=>{
        flags.showCustomFlag({
            title: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).dontNotifyFailureTitle),
            description: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).dontNotifyFailureDescription),
            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                spacing: "spacious",
                label: "error"
            }),
            isAutoDismiss: true
        });
    }, [
        flags,
        formatMessage
    ]);
    const { sendMentionNotification: sendMentionNotification, sendCancelMentionNotification: sendCancelMentionNotification, contentMentionNotificationError: contentMentionNotificationError } = (0, $05c7f8c23696cebd$export$82f89b951e37c769)({
        contentId: contentId,
        setError: setError,
        showDontNotifyFailedFlag: showDontNotifyFailedFlag
    });
    const { sendCreateInlineTaskNotifications: sendCreateInlineTaskNotifications, cancelInlineTaskNotifications: cancelInlineTaskNotifications, createTaskNotificationError: createTaskNotificationError } = (0, $204e1c50e8dfb669$export$bb50e46e1081bc7f)({
        contentId: contentId,
        setError: setError,
        showDontNotifyFailedFlag: showDontNotifyFailedFlag
    });
    // `showCustomFlagWithAction` for:
    // - unrestricted users with "do not notify" CTA
    // - share now for restricted users
    // - deleted mention flag
    const showCustomFlagWithActions = (0, $42omo.useCallback)(({ title: title, description: description, userPhoto: userPhoto, actions: actions, handleOnClose: handleOnClose, autoDismiss: autoDismiss = true, id: id })=>{
        flags.showCustomFlag({
            title: title,
            description: description,
            isAutoDismiss: autoDismiss,
            customIcon: userPhoto ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                src: userPhoto,
                label: "mention"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b4wUN))), {
                spacing: "spacious",
                label: "mention"
            }),
            onClose: handleOnClose && handleOnClose,
            actions: actions,
            id: id ?? undefined
        });
    }, [
        flags
    ]);
    const displayNoPermissionsFlag = (0, $42omo.useCallback)(({ displayNames: displayNames, flagFields: flagFields, displayName: displayName, somebodyElse: somebodyElse, flagId: flagId, restrictedLevel: restrictedLevel = 'page', hasAction: hasAction = false, userPhoto: userPhoto })=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'triggered',
                actionSubject: 'mentionNoAccessFlag',
                source: 'page',
                attributes: {
                    restrictedLevel: restrictedLevel,
                    isLivePage: isLivePage
                }
            }
        }).fire();
        const hasPageRestrictionsAndCanEdit = restrictedLevel === 'page' && canEditPageRestrictions;
        const showFlagFn = hasAction ? showCustomFlagWithActions : showCustomFlag;
        if (displayNames.size === 1) showFlagFn({
            ...flagFields,
            title: hasPageRestrictionsAndCanEdit ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagNoPermissionsTitle, {
                displayName: displayName
            }) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagNoSpaceOrParentPermissionsTitle, {
                displayName: displayName
            }),
            id: flagId,
            userPhoto: userPhoto
        });
        else if (displayNames.size === 2) showFlagFn({
            ...flagFields,
            title: hasPageRestrictionsAndCanEdit ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagTwoNoPermissionsTitle, {
                displayName: displayName,
                somebodyElse: somebodyElse
            }) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagTwoNoSpaceOrParentPermissionsTitle, {
                displayName: displayName,
                somebodyElse: somebodyElse
            }),
            id: flagId
        });
        else //3 or more mentioned users
        showFlagFn({
            ...flagFields,
            title: hasPageRestrictionsAndCanEdit ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagMultipleNoPermissionsTitle, {
                displayName: displayName,
                somebodyElse: somebodyElse,
                numOthers: displayNames.size - 2
            }) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagMultipleNoSpaceOrParentPermissionsTitle, {
                displayName: displayName,
                somebodyElse: somebodyElse,
                numOthers: displayNames.size - 2
            }),
            id: flagId
        });
    }, [
        createAnalyticsEvent,
        formatMessage,
        showCustomFlag,
        showCustomFlagWithActions,
        isLivePage,
        canEditPageRestrictions
    ]);
    const getNotificationPayload = (notifyAction, mentions, type)=>{
        const mentionsWithNotificationAction = [];
        const tasksWithNotificationAction = [];
        mentions.forEach((mention)=>{
            if (type === 'standard') mentionsWithNotificationAction.push({
                mentionedUserAccountId: mention.id,
                mentionLocalId: mention.localId,
                notificationAction: notifyAction
            });
            else if (type === 'task') tasksWithNotificationAction.push({
                notificationAction: notifyAction,
                operation: (0, $1acca270709c231c$export$ab5aad00225c5662).ASSIGNED,
                recipientAccountId: mention.id,
                recipientMentionLocalId: mention.localId,
                taskId: mention.taskLocalId ?? ''
            });
        });
        return {
            mentionsWithNotificationAction: mentionsWithNotificationAction,
            tasksWithNotificationAction: tasksWithNotificationAction
        };
    };
    const sendNotificationFn = (mentions, type, closeFlagFn)=>{
        const { mentionsWithNotificationAction: mentionsWithNotificationAction, tasksWithNotificationAction: tasksWithNotificationAction } = getNotificationPayload((0, $a7SsH.NotificationAction).NOTIFY, mentions, type);
        if (type === 'standard') sendMentionNotification({
            mentions: mentionsWithNotificationAction
        });
        else if (type === 'task') sendCreateInlineTaskNotifications({
            tasks: tasksWithNotificationAction
        });
        closeFlagFn?.();
    };
    const showUnrestrictedPageAccessFlag = (0, $42omo.useCallback)(({ type: type, mentions: mentions, userPhoto: userPhoto })=>{
        const analyticsPayload = mentions.map((mention)=>{
            if (type === 'standard') return {
                mentionedUserId: mention.id,
                mentionId: mention.localId
            };
            else if (type === 'task') return {
                taskId: mention.taskLocalId,
                mentionId: mention.localId,
                mentionedUserId: mention.id
            };
        });
        let addedMentionFlagId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        const handleFlag = (currentFlagId, setCurrentFlagId, flagStartTime)=>{
            if (currentFlagId) addedMentionFlagId = currentFlagId;
            else {
                setCurrentFlagId(addedMentionFlagId);
                flagStartTime.current = Date.now();
            }
        };
        if (type === 'standard') handleFlag(currentAddedMentionFlagId, setCurrentAddedMentionFlagId, mentionsFlagStartTime);
        else if (type === 'task') handleFlag(currentAddedTaskFlagId, setCurrentAddedTaskFlagId, tasksFlagStartTime);
        const { displayNames: displayNames, displayName: displayName, somebodyElse: somebodyElse } = $36be47a9ed41f8db$var$getDisplayNames(mentions);
        const closeFlag = ()=>{
            flags.hideFlag(addedMentionFlagId);
            if (type === 'standard') {
                setCurrentAddedMentionFlagId('');
                setUnrestrictedMentions([]);
                mentionsFlagStartTime.current = null;
            } else if (type === 'task') {
                setCurrentAddedTaskFlagId('');
                setUnrestrictedTasks([]);
                tasksFlagStartTime.current = null;
            }
        };
        const sendDontNotifyFn = ()=>{
            const { mentionsWithNotificationAction: mentionsWithNotificationAction, tasksWithNotificationAction: tasksWithNotificationAction } = getNotificationPayload((0, $a7SsH.NotificationAction).DONT_NOTIFY, mentions, type);
            if (type === 'standard') {
                sendCancelMentionNotification({
                    mentions: mentionsWithNotificationAction
                });
                clearTimeout(addedUnrestrictedMentionFlagTimeout.current);
            } else if (type === 'task') {
                cancelInlineTaskNotifications({
                    tasks: tasksWithNotificationAction
                });
                clearTimeout(addedUnrestrictedTaskFlagTimeout.current);
            }
        };
        const handleClose = ()=>{
            //when "X" is clicked, or user acknowledges the flag
            const elapsedTimeInSeconds = type === 'standard' ? (0, $2b2a9498abd1ee19$export$406377d40397a2f7)(mentionsFlagStartTime) : (0, $2b2a9498abd1ee19$export$406377d40397a2f7)(tasksFlagStartTime);
            closeFlag();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: 'mentionsNotifications',
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: type === 'standard' ? 'dismissMentionsNotifications' : 'dismissTaskMentionsNotifications',
                    attributes: {
                        contentId: contentId,
                        elapsedTimeInSeconds: elapsedTimeInSeconds,
                        mentions: analyticsPayload
                    }
                }
            }).fire();
        };
        //When there is a flag currently open when a new mention is added, we want to reset the timer for the flag to be open, i.e. persist the flag to be open for another 8 seconds
        if (type === 'standard') {
            clearTimeout(addedUnrestrictedMentionFlagTimeout.current);
            addedUnrestrictedMentionFlagTimeout.current = setTimeout(()=>{
                sendNotificationFn(mentions, type, closeFlag);
            }, 8000);
        } else if (type === 'task') {
            clearTimeout(addedUnrestrictedTaskFlagTimeout.current);
            addedUnrestrictedTaskFlagTimeout.current = setTimeout(()=>{
                sendNotificationFn(mentions, type, closeFlag);
            }, 8000);
        }
        const sharedFlagFields = {
            description: type === 'standard' ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagDescription) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).taskMentionFlagDescription),
            actions: [
                {
                    content: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagAcknowledgeButton),
                    onClick: handleClose
                },
                {
                    content: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagDoNotNotifyButton),
                    onClick: ()=>{
                        //On clicking "don't notify"
                        const elapsedTimeInSeconds = type === 'standard' ? (0, $2b2a9498abd1ee19$export$406377d40397a2f7)(mentionsFlagStartTime) : (0, $2b2a9498abd1ee19$export$406377d40397a2f7)(tasksFlagStartTime);
                        sendDontNotifyFn();
                        closeFlag();
                        createAnalyticsEvent({
                            type: 'sendUIEvent',
                            data: {
                                source: 'mentionsNotifications',
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: type === 'standard' ? 'doNotNotify' : 'doNotAssign',
                                attributes: {
                                    contentId: contentId,
                                    mentions: analyticsPayload,
                                    elapsedTimeInSeconds: elapsedTimeInSeconds
                                }
                            }
                        }).fire();
                    }
                }
            ],
            handleOnClose: handleClose,
            autoDismiss: false
        };
        if (displayNames.size === 1) showCustomFlagWithActions({
            ...sharedFlagFields,
            title: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagTitle, {
                displayName: displayName
            }),
            id: addedMentionFlagId,
            userPhoto: userPhoto
        });
        else if (displayNames.size === 2) showCustomFlagWithActions({
            ...sharedFlagFields,
            title: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagTitleTwoMentions, {
                displayName: displayName,
                somebodyElse: somebodyElse
            }),
            id: addedMentionFlagId
        });
        else //3 or more mentioned users
        showCustomFlagWithActions({
            ...sharedFlagFields,
            title: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagTitleMultipleMentions, {
                displayName: displayName,
                somebodyElse: somebodyElse,
                numOthers: displayNames.size - 2
            }),
            id: addedMentionFlagId
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentId,
        createAnalyticsEvent,
        currentAddedMentionFlagId,
        flags,
        formatMessage,
        sendCancelMentionNotification,
        sendMentionNotification,
        setUnrestrictedMentions,
        showCustomFlagWithActions,
        currentAddedTaskFlagId,
        sendCreateInlineTaskNotifications,
        setUnrestrictedTasks,
        cancelInlineTaskNotifications,
        mentionsFlagStartTime,
        tasksFlagStartTime
    ]);
    const showPageRestrictionsFlag = (0, $42omo.useCallback)(({ type: type, mentions: mentions })=>{
        let addedMentionFlagId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        //If a flag ID is already in local state, that means the respective flag is currently open. If not, we generate a uuid to set on the flag which is about to be opened. Having a uuid on the flag allows us to update the content without closing the flag
        if (type === 'standard' && currentPageRestrictionMentionFlagId) addedMentionFlagId = currentPageRestrictionMentionFlagId;
        else if (type === 'task' && currentPageRestrictionTaskFlagId) addedMentionFlagId = currentPageRestrictionTaskFlagId;
        if (type === 'standard' && !currentPageRestrictionMentionFlagId) setCurrentPageRestrictionMentionFlagId(addedMentionFlagId);
        if (type === 'task' && !currentPageRestrictionTaskFlagId) setCurrentPageRestrictionTaskFlagId(addedMentionFlagId);
        const { displayNames: displayNames, displayName: displayName, somebodyElse: somebodyElse } = $36be47a9ed41f8db$var$getDisplayNames(mentions);
        const closeFlag = ()=>{
            flags.hideFlag(addedMentionFlagId);
            if (type === 'standard') {
                clearTimeout(pageRestrictedMentionFlagTimeout.current);
                setCurrentPageRestrictionMentionFlagId('');
                setPageRestrictedMentions([]);
            } else if (type === 'task') {
                clearTimeout(pageRestrictedTaskFlagTimeout.current);
                setCurrentPageRestrictionTaskFlagId('');
                setPageRestrictedTasks([]);
            }
        };
        //When there is a flag currently open when a new mention is added, we want to reset the timer for the flag to be open, i.e. persist the flag to be open for another 8 seconds
        if (type === 'standard') {
            clearTimeout(pageRestrictedMentionFlagTimeout.current);
            pageRestrictedMentionFlagTimeout.current = setTimeout(()=>{
                closeFlag();
            }, 8000);
        } else if (type === 'task') {
            clearTimeout(pageRestrictedTaskFlagTimeout.current);
            pageRestrictedTaskFlagTimeout.current = setTimeout(()=>{
                closeFlag();
            }, 8000);
        }
        const flagActions = [
            {
                content: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagShareNowButton),
                onClick: ()=>{
                    //On clicking "share now" - Update page permissions
                    closeFlag();
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: 'mentionNoAccessFlag',
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'shareNowButton',
                            attributes: {
                                mentionType: type,
                                isLivePage: isLivePage
                            }
                        }
                    }).fire();
                    updateUsersContentPermissionMutation({
                        variables: {
                            contentId: contentId,
                            input: mentions?.map((user)=>({
                                    contentRole: (0, $55e2d13107c6bf2d$export$4fd34ed002cf6bfb).VIEWER,
                                    principalId: user.id,
                                    confluencePrincipalType: (0, $55e2d13107c6bf2d$export$aa5f3445d469c06b).USER
                                }))
                        }
                    }).then(()=>{
                        // Only send immediate notification for Live Pages
                        if (isLivePage) sendNotificationFn(mentions, type, closeFlag);
                    }).catch((e)=>{
                        setError(e);
                        showCustomFlag({
                            title: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagShareFailedTitle),
                            description: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagShareFailedDescription)
                        });
                    });
                }
            },
            {
                content: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagDontShareButton),
                onClick: ()=>{
                    closeFlag();
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: 'mentionNoAccessFlag',
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'dontShareButton',
                            attributes: {
                                mentionType: type,
                                isLivePage: isLivePage
                            }
                        }
                    }).fire();
                }
            }
        ];
        const sharedFlagFields = {
            description: type === 'standard' ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagNoPermissionsDescription) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).taskMentionFlagNoPermissionsDescription),
            actions: canEditPageRestrictions ? flagActions : undefined,
            handleOnClose: ()=>{
                closeFlag();
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'mentionNoAccessFlag',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'dismissButton',
                        attributes: {
                            mentionType: type,
                            restrictedLevel: 'page',
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
            },
            autoDismiss: false
        };
        displayNoPermissionsFlag({
            displayNames: displayNames,
            flagFields: {
                ...sharedFlagFields,
                title: ''
            },
            displayName: displayName,
            somebodyElse: somebodyElse,
            flagId: addedMentionFlagId,
            restrictedLevel: 'page',
            hasAction: true,
            userPhoto: mentions[0]?.userPhoto
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        canEditPageRestrictions,
        contentId,
        createAnalyticsEvent,
        currentPageRestrictionMentionFlagId,
        currentPageRestrictionTaskFlagId,
        displayNoPermissionsFlag,
        flags,
        formatMessage,
        setPageRestrictedMentions,
        setPageRestrictedTasks,
        showCustomFlag,
        updateUsersContentPermissionMutation
    ]);
    const showParentSpaceRestrictedFlag = (0, $42omo.useCallback)(({ type: type, mentions: mentions })=>{
        let addedMentionFlagId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        //If a flag ID is already in local state, that means the respective flag is currently open. If not, we generate a uuid to set on the flag which is about to be opened. Having a uuid on the flag allows us to update the content without closing the flag
        if (type === 'standard' && currentSpaceOrParentRestrictionMentionFlagId) addedMentionFlagId = currentSpaceOrParentRestrictionMentionFlagId;
        else if (type === 'task' && currentSpaceOrParentRestrictionTaskFlagId) addedMentionFlagId = currentSpaceOrParentRestrictionTaskFlagId;
        if (type === 'standard' && !currentSpaceOrParentRestrictionMentionFlagId) setCurrentSpaceOrParentRestrictionMentionFlagId(addedMentionFlagId);
        if (type === 'task' && !currentSpaceOrParentRestrictionTaskFlagId) setCurrentSpaceOrParentRestrictionTaskFlagId(addedMentionFlagId);
        const { displayNames: displayNames, displayName: displayName, somebodyElse: somebodyElse } = $36be47a9ed41f8db$var$getDisplayNames(mentions);
        const closeFlag = ()=>{
            flags.hideFlag(addedMentionFlagId);
            if (type === 'standard') {
                clearTimeout(spaceParentRestrictedMentionFlagTimeout.current);
                setCurrentSpaceOrParentRestrictionMentionFlagId('');
                setParentSpaceRestrictedMentions([]);
            } else if (type === 'task') {
                clearTimeout(spaceParentRestrictedTaskFlagTimeout.current);
                setCurrentSpaceOrParentRestrictionTaskFlagId('');
                setParentSpaceRestrictedTasks([]);
            }
        };
        //When there is a flag currently open when a new mention is added, we want to reset the timer for the flag to be open, i.e. persist the flag to be open for another 8 seconds
        if (type === 'standard') {
            clearTimeout(spaceParentRestrictedMentionFlagTimeout.current);
            spaceParentRestrictedMentionFlagTimeout.current = setTimeout(()=>{
                closeFlag();
            }, 8000);
        } else if (type === 'task') {
            clearTimeout(spaceParentRestrictedTaskFlagTimeout.current);
            spaceParentRestrictedTaskFlagTimeout.current = setTimeout(()=>{
                closeFlag();
            }, 8000);
        }
        const sharedFlagFields = {
            description: type === 'standard' ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagNoSpaceOrParentPermissionsDescription) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).taskMentionFlagNoPermissionsParentSpaceRestrictionsDescription),
            handleOnClose: ()=>{
                closeFlag();
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'mentionNoAccessFlag',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'dismissButton',
                        attributes: {
                            mentionType: type,
                            restrictedLevel: 'parent',
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
            },
            autoDismiss: false
        };
        displayNoPermissionsFlag({
            displayNames: displayNames,
            flagFields: {
                ...sharedFlagFields,
                title: '',
                actionContent: '',
                actionOnClick: ()=>{}
            },
            displayName: displayName,
            somebodyElse: somebodyElse,
            restrictedLevel: 'parent',
            flagId: addedMentionFlagId,
            userPhoto: mentions[0]?.userPhoto
        });
    }, [
        createAnalyticsEvent,
        currentSpaceOrParentRestrictionMentionFlagId,
        currentSpaceOrParentRestrictionTaskFlagId,
        formatMessage,
        displayNoPermissionsFlag,
        flags,
        setParentSpaceRestrictedMentions,
        setParentSpaceRestrictedTasks,
        isLivePage
    ]);
    (0, $42omo.useEffect)(()=>{
        //Handling deleted mentions
        if (deletedMentions.length > 0) {
            //Handles updating content of current open mention flags
            const deletedMentionsLocalIds = new Set(deletedMentions.map((mention)=>mention.localId));
            //Filter out deleted mentions from current open general mention flag
            const remainingUnrestrictedStandardMentions = unrestrictedMentions.filter((unrestrictedMention)=>!deletedMentionsLocalIds.has(unrestrictedMention.localId));
            const remainingParentSpaceRestrictedStandardMentions = parentSpaceRestrictedMentions.filter((parentSpaceRestrictedMention)=>!deletedMentionsLocalIds.has(parentSpaceRestrictedMention.localId));
            const remainingPageRestrictedStandardMentions = pageRestrictedMentions.filter((pageRestrictedMention)=>!deletedMentionsLocalIds.has(pageRestrictedMention.localId));
            //Close general mention flag if none remain
            if (remainingUnrestrictedStandardMentions?.length === 0) {
                clearTimeout(addedUnrestrictedMentionFlagTimeout.current);
                flags.hideFlag(currentAddedMentionFlagId);
                setCurrentAddedMentionFlagId('');
            }
            if (remainingParentSpaceRestrictedStandardMentions?.length === 0) {
                clearTimeout(spaceParentRestrictedMentionFlagTimeout.current);
                flags.hideFlag(currentSpaceOrParentRestrictionMentionFlagId);
                setCurrentSpaceOrParentRestrictionMentionFlagId('');
            }
            if (remainingPageRestrictedStandardMentions?.length === 0) {
                clearTimeout(pageRestrictedMentionFlagTimeout.current);
                flags.hideFlag(currentPageRestrictionMentionFlagId);
                setCurrentPageRestrictionMentionFlagId('');
            }
            setUnrestrictedMentions(remainingUnrestrictedStandardMentions);
            setParentSpaceRestrictedMentions(remainingParentSpaceRestrictedStandardMentions);
            setPageRestrictedMentions(remainingPageRestrictedStandardMentions);
            setDeletedMentions([]);
        }
        if (deletedTasks.length > 0) {
            //Handles updating content of current open task flags
            const deletedTasksLocalIds = new Set(deletedTasks.map((mention)=>mention.localId));
            //Filter out deleted mentions from current open task mention flag
            const remainingUnrestrictedTasks = unrestrictedTasks.filter((unrestrictedTask)=>!deletedTasksLocalIds.has(unrestrictedTask.localId));
            const remainingParentSpaceRestrictedTasks = parentSpaceRestrictedTasks.filter((parentSpaceRestrictedTask)=>!deletedTasksLocalIds.has(parentSpaceRestrictedTask.localId));
            const remainingPageRestrictedTasks = pageRestrictedTasks.filter((pageRestrictedTask)=>!deletedTasksLocalIds.has(pageRestrictedTask.localId));
            //Close task mention flag if none remain
            if (remainingUnrestrictedTasks?.length === 0) {
                clearTimeout(addedUnrestrictedTaskFlagTimeout.current);
                flags.hideFlag(currentAddedTaskFlagId);
                setCurrentAddedTaskFlagId('');
            }
            if (remainingParentSpaceRestrictedTasks?.length === 0) {
                clearTimeout(spaceParentRestrictedTaskFlagTimeout.current);
                flags.hideFlag(currentSpaceOrParentRestrictionTaskFlagId);
                setCurrentSpaceOrParentRestrictionTaskFlagId('');
            }
            if (remainingPageRestrictedTasks?.length === 0) {
                clearTimeout(pageRestrictedTaskFlagTimeout.current);
                flags.hideFlag(currentPageRestrictionTaskFlagId);
                setCurrentPageRestrictionTaskFlagId('');
            }
            setUnrestrictedTasks(remainingUnrestrictedTasks);
            setParentSpaceRestrictedTasks(remainingParentSpaceRestrictedTasks);
            setPageRestrictedTasks(remainingPageRestrictedTasks);
            setDeletedTasks([]);
        }
    //leaving addedMentions out of the dependency array otherwise the deleted flag will be displayed twice
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        setDeletedMentions,
        flags,
        showCustomFlagWithActions,
        formatMessage,
        setAddedMentions,
        deletedMentions,
        setDeletedTasks,
        deletedTasks
    ]);
    const checkPastedMentions = (mentions)=>{
        return mentions.some((mention)=>mention.method === 'pasted');
    };
    (0, $42omo.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && unrestrictedMentions?.length) {
            if (isLivePage) {
                if (checkPastedMentions(unrestrictedMentions)) // When mention is pasted, show flag
                showUnrestrictedPageAccessFlag({
                    type: 'standard',
                    mentions: unrestrictedMentions,
                    userPhoto: unrestrictedMentions[0]?.userPhoto
                });
                else {
                    // When mention is typed, only send notification
                    sendNotificationFn(unrestrictedMentions, 'standard');
                    setUnrestrictedMentions([]);
                }
            } else setUnrestrictedMentions([]);
        }
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        unrestrictedMentions,
        updatedUsersContentPermissionsLoading,
        isLivePage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && unrestrictedTasks?.length) {
            if (isLivePage) {
                if (checkPastedMentions(unrestrictedTasks)) // When mention is pasted, show flag
                showUnrestrictedPageAccessFlag({
                    type: 'task',
                    mentions: unrestrictedTasks,
                    userPhoto: unrestrictedTasks[0]?.userPhoto
                });
                else {
                    // When mention is typed, only send notification
                    sendNotificationFn(unrestrictedTasks, 'task');
                    setUnrestrictedTasks([]);
                }
            } else setUnrestrictedTasks([]);
        }
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        unrestrictedTasks,
        updatedUsersContentPermissionsLoading,
        isLivePage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && parentSpaceRestrictedMentions?.length) showParentSpaceRestrictedFlag({
            type: 'standard',
            mentions: parentSpaceRestrictedMentions
        });
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        flags,
        parentSpaceRestrictedMentions,
        updatedUsersContentPermissionsLoading
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && parentSpaceRestrictedTasks?.length) showParentSpaceRestrictedFlag({
            type: 'task',
            mentions: parentSpaceRestrictedTasks
        });
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        flags,
        parentSpaceRestrictedTasks,
        updatedUsersContentPermissionsLoading
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && pageRestrictedMentions?.length) showPageRestrictionsFlag({
            type: 'standard',
            mentions: pageRestrictedMentions
        });
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        canEditPageRestrictions,
        flags,
        pageRestrictedMentions,
        updatedUsersContentPermissionsLoading
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && pageRestrictedTasks?.length) showPageRestrictionsFlag({
            type: 'task',
            mentions: pageRestrictedTasks
        });
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        canEditPageRestrictions,
        flags,
        pageRestrictedTasks,
        updatedUsersContentPermissionsLoading
    ]);
    (0, $42omo.useEffect)(()=>{
        if (mentionsAdded.currentUser.length > 0) {
            if (isLivePage) {
                const { mentionsWithNotificationAction: mentionsWithNotificationAction } = getNotificationPayload((0, $a7SsH.NotificationAction).DONT_NOTIFY, mentionsAdded.currentUser, 'standard');
                sendCancelMentionNotification({
                    mentions: mentionsWithNotificationAction
                });
            }
            setMentionsAdded({
                currentUser: []
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mentionsAdded.currentUser
    ]);
    (0, $42omo.useEffect)(()=>{
        if (tasksAdded.currentUser.length > 0) {
            if (isLivePage) {
                const { tasksWithNotificationAction: tasksWithNotificationAction } = getNotificationPayload((0, $a7SsH.NotificationAction).DONT_NOTIFY, tasksAdded.currentUser, 'task');
                cancelInlineTaskNotifications({
                    tasks: tasksWithNotificationAction
                });
            }
            setTasksAdded({
                currentUser: []
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tasksAdded.currentUser
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), createTaskNotificationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: createTaskNotificationError
    }), contentMentionNotificationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentMentionNotificationError
    }), updatedUsersContentPermissionsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: updatedUsersContentPermissionsError
    }));
};
const $36be47a9ed41f8db$export$6124ca97c5c9fe4d = ({ children: children, flags: flags, contentId: contentId, isLivePage: isLivePage, isMentionsNotificationsEnabled: isMentionsNotificationsEnabled, editorActions: editorActions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36be47a9ed41f8db$export$fdb0a5f78dc34be6, {
        flags: flags,
        contentId: contentId,
        isLivePage: isLivePage,
        isMentionsNotificationsEnabled: isMentionsNotificationsEnabled,
        editorActions: editorActions
    })), children);
};



var $hwk5r = parcelRequire("hwk5r");

parcelRequire("kGaEh");
var $lWVgZ = parcelRequire("lWVgZ");
var $kGaEh = parcelRequire("kGaEh");


var $2HGN8 = parcelRequire("2HGN8");


var $c4PY4 = parcelRequire("c4PY4");


var $e8Lxy = parcelRequire("e8Lxy");


var $hMRhJ = parcelRequire("hMRhJ");


var $gKaeO = parcelRequire("gKaeO");


var $fE1Ao = parcelRequire("fE1Ao");


var $a1uFh = parcelRequire("a1uFh");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");





var $lEVfb = parcelRequire("lEVfb");





var $3wSkK = parcelRequire("3wSkK");

/* EditorConnectionBannerOfflineMode.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gmMgo = parcelRequire("gmMgo");




var $b3YrF = parcelRequire("b3YrF");


var $bQ6eU = parcelRequire("bQ6eU");


var $fVUfS = parcelRequire("fVUfS");





var $aJv6Q = parcelRequire("aJv6Q");


var $bT0se = parcelRequire("bT0se");


var $g01A4 = parcelRequire("g01A4");











var $18HQ4 = parcelRequire("18HQ4");

/* CreateOfflineCopy.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove entire file when platform_editor_offline_editing_web_ga_fixes is cleaned up
// This component is only used in the old conflict message (with saveCopy parameter)




var $T1bCI = parcelRequire("T1bCI");











var $h9yJL = parcelRequire("h9yJL");





var $7xVCs = parcelRequire("7xVCs");




const $129ea4f2daae19f3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    errorFlagTitle: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.error-flag.title.non-final",
        defaultMessage: "We failed to create a copy"
    },
    errorFlagDescription: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.error-flag.description.non-final",
        defaultMessage: "Check your network connection or try again."
    },
    copyCreatedFlagTitle: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.copy-created-flag.title.non-final",
        defaultMessage: "Copy created"
    },
    copyCreatedFlagDescription: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.copy-created-flag.description.non-final",
        defaultMessage: "We copied your offline edits into a new page. All changes were saved."
    },
    copyCreatedFlagViewPage: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.copy-created-flag.view-page-link.non-final",
        defaultMessage: "View page"
    },
    createCopyFlagTitle: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.title.non-final",
        defaultMessage: "Issue syncing offline edits"
    },
    createCopyFlagDescription: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.description.non-final",
        defaultMessage: "We found conflicting edits when syncing to the cloud. View merged edits here or create a copy of your offline changes."
    },
    createCopyFlagCreateAction: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.create-action.non-final",
        defaultMessage: "Create copy"
    },
    createCopyFlagNoAction: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.no-action.non-final",
        defaultMessage: "I don\u2019t need a copy"
    }
});



var $f7B1p = parcelRequire("f7B1p");

const $0045511f0064ab73$export$eea1b38e4aaafc7d = (spaceId, contentId, adf, isLivePage = false)=>{
    return (0, $f7B1p.cfetch)('/wiki/api/v2/pages', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            spaceId: spaceId,
            parentId: contentId,
            status: 'draft',
            body: {
                representation: 'atlas_doc_format',
                value: JSON.stringify(adf)
            },
            ...isLivePage && {
                subtype: 'live'
            }
        })
    });
};


const $f917592567f31a69$var$styles = {
    saveCopyLink: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c81o8v _4bfu1r31 _1hms8stv _ajmmnqa1 _bfhk1j28 _k48pmoej _syaz1rpy _irr319yr"
};
const $f917592567f31a69$export$3e0f67bf0e97b95a = (0, $7aRa9.withFlags)(({ flags: flags, chunks: chunks, api: api, contentId: contentId, spaceId: spaceId, setIsLoading: setIsLoading, isLivePage: isLivePage = false })=>{
    const isCreatingPage = (0, $42omo.useRef)(false);
    const offlineDoc = (0, $b3YrF.useSharedPluginStateSelector)(api, 'collabEdit.lastReconnectionConflictMetadata')?.offlineDoc;
    const [shouldUpdatePageTree, setShouldUpdatePageTree] = (0, $42omo.useState)(false);
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        testId: "offline-conflict-create-page-copy",
        onClick: async ()=>{
            if (isCreatingPage.current || !offlineDoc || !spaceId) return;
            isCreatingPage.current = true;
            setIsLoading(true);
            try {
                const response = await (0, $0045511f0064ab73$export$eea1b38e4aaafc7d)(spaceId, contentId, new (0, $h9yJL.JSONTransformer)().encode(offlineDoc), isLivePage);
                if (!response.ok) {
                    flags.showFlag($f917592567f31a69$var$createErrorFlag(intl));
                    return;
                }
                setShouldUpdatePageTree(true);
                flags.hideFlag('editor_reconnection_conflict');
                const data = await response.json();
                flags.showFlag($f917592567f31a69$var$createCopySuccessFlag(`${data._links.base}${data._links.edituiv2}`, intl));
            } catch (e) {
                flags.showFlag($f917592567f31a69$var$createErrorFlag(intl));
            } finally{
                isCreatingPage.current = false;
                setIsLoading(false);
            }
        },
        xcss: $f917592567f31a69$var$styles.saveCopyLink
    }, chunks), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $7xVCs.PageTreeStateUpdater)
        ]
    }, (pageStateUpdater)=>{
        // Make sure we only push the update once
        if (shouldUpdatePageTree && contentId) {
            // Requests that we fetch the page tree with the newly restored page.
            pageStateUpdater.setForceFetchPageId(contentId);
            setShouldUpdatePageTree(false);
        }
        return null;
    }));
});
const $f917592567f31a69$var$createErrorFlag = (intl)=>({
        id: 'editor-reconnection-conflict-copy-failed',
        type: 'error',
        title: intl.formatMessage((0, $129ea4f2daae19f3$export$defe85febe8b728c).errorFlagTitle),
        description: intl.formatMessage((0, $129ea4f2daae19f3$export$defe85febe8b728c).errorFlagDescription),
        close: 'auto'
    });
const $f917592567f31a69$var$createCopySuccessFlag = (href, intl)=>({
        id: 'editor-reconnection-conflict-copy-created',
        type: 'success',
        title: intl.formatMessage((0, $129ea4f2daae19f3$export$defe85febe8b728c).copyCreatedFlagTitle),
        description: intl.formatMessage((0, $129ea4f2daae19f3$export$defe85febe8b728c).copyCreatedFlagDescription),
        close: 'auto',
        actions: [
            {
                content: intl.formatMessage((0, $129ea4f2daae19f3$export$defe85febe8b728c).copyCreatedFlagViewPage),
                href: href
            }
        ]
    });



var $kVuKK = parcelRequire("kVuKK");




function $8f9742f0ad2c6b9c$export$22acf644c7b26688(initialValue, risingEdgeDelay, fallingEdgeDelay) {
    const [value, setValue] = (0, $42omo.useState)(initialValue);
    const risingEdgeTimeout = (0, $42omo.useRef)(null);
    const fallingEdgeTimeout = (0, $42omo.useRef)(null);
    const updateValue = (0, $42omo.useCallback)((newValue)=>{
        if (newValue === true) {
            // Clear any pending falling edge timeout
            if (fallingEdgeTimeout.current !== null) {
                clearTimeout(fallingEdgeTimeout.current);
                fallingEdgeTimeout.current = null;
            }
            // If there is a rising edge pending already, or the value is already true, do nothing
            if (risingEdgeTimeout.current !== null || value === true) return;
            // If there is no delay, update the value immediately
            if (risingEdgeDelay === 0) setValue(true);
            else // Otherwise set a new rising edge timeout
            risingEdgeTimeout.current = window.setTimeout(()=>{
                risingEdgeTimeout.current = null;
                setValue(true);
            }, risingEdgeDelay);
        } else {
            // Clear any pending rising edge timeout
            if (risingEdgeTimeout.current !== null) {
                clearTimeout(risingEdgeTimeout.current);
                risingEdgeTimeout.current = null;
            }
            // If there is a falling edge pending already, or the value is already false, do nothing
            if (fallingEdgeTimeout.current !== null || value === false) return;
            // If there is no delay, update the value immediately
            if (fallingEdgeDelay === 0) setValue(false);
            else // Otherwise set a new falling edge timeout
            fallingEdgeTimeout.current = window.setTimeout(()=>{
                fallingEdgeTimeout.current = null;
                setValue(false);
            }, fallingEdgeDelay);
        }
    }, [
        fallingEdgeDelay,
        risingEdgeDelay,
        value
    ]);
    return [
        value,
        updateValue
    ];
}
function $8f9742f0ad2c6b9c$export$c40112cb03d4ce32(value, risingEdgeDelay, fallingEdgeDelay) {
    const [delayedValue, setDelayedValue] = $8f9742f0ad2c6b9c$export$22acf644c7b26688(value, risingEdgeDelay, fallingEdgeDelay);
    (0, $42omo.useEffect)(()=>{
        setDelayedValue(value);
    }, [
        value,
        setDelayedValue
    ]);
    return delayedValue;
}


const $ceee0e5a959b634f$var$AnimatedEllipsis = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.EllipsisContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.AnimatedDot), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.AnimatedDot), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.AnimatedDot), null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ceee0e5a959b634f$export$884d2f68355ca9c8 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { toolbarHidden: toolbarHidden, show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_v564gu18 _1e0c11p5 _kqswstnw _1bsb1osq _1bah1h6o _4cvr1h6o _y3gn1h6o _1ltvze3t _ca0q12x7 _n3td12x7 _bfhkysee _8hrzjp4b _1pby1nn1",
            __cmplp.toolbarHidden ? "_154iidpf" : "_154i1ady",
            __cmplp.show ? "_t9ecp8ia" : "_t9ecdgp5",
            __cmplp.toolbarHidden ? "_1911idpf" : "_19111ady",
            __cmplp.className
        ])
    });
});
const $ceee0e5a959b634f$export$31ea92f3997410dd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81o8v _1reo15vq _18m915vq _ect41kw7 _k48pmoej _syaz1rpy _o5724jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ceee0e5a959b634f$export$bb5d4b172e6970cd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ceee0e5a959b634f$var$FadingSpanInternal, {
        "aria-hidden": !props?.show,
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $ceee0e5a959b634f$var$FadingSpanInternal = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _v564ayzn _nd5l1ekt _1e0c1txw _4cvr1h6o _1bah1h6o _18u0u2gc _2hwxu2gc",
            __cmplp.show ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $ceee0e5a959b634f$var$backgroundColor = {
    online: "_v564glyw _bfhk1y9u _t9ecp8ia",
    offline: "_bfhkysee",
    conflicts: "_bfhkysee"
};
const $ceee0e5a959b634f$var$styles = {
    conflictLink: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c81o8v _bfhk1j28 _k48pmoej _syaz1rpy _1doce4h9 _1o3i1b2s _1il9gq9o _irr319yr",
    learnMoreLink: "_syaz1rpy _10531rpy",
    placeholder: "_1bsbdlk8"
};
const $ceee0e5a959b634f$var$isMessageDescriptor = (msg)=>{
    return !!msg && typeof msg === 'object' && msg.id !== undefined && msg.defaultMessage !== undefined;
}; /**
    * Custom hook to manage the state of banner variants and provide a consistent interface for their usage.
    * @param variant - The variant definition to use. This should ideally be a constant defined outside of the component to prevent re-renders.
    * @param props - The props to pass to the variant condition function. This should be treated as a dependency array, and values should be kept in the same order.
    * @returns The current state of the banner variant.
    *
    * @privateRemarks
    *
    * Within this hook, the react-hooks/exhaustive-deps rule is disabled in a few places.
    * This is because we track the dependencies provided by the props argument as their values instead of the overall reference.
    * This is done to prevent the need to memoize the props object without causing unnecessary re-renders.
    * By directly depending on the values in this array, we can ensure that the hook will only re-run when the values change, not the array itself.
    *
    * This does however have the caveat that we lose static analysis of the dependencies, so extra care should be taken when working in this function.
    */ 
function $ceee0e5a959b634f$export$dd92d6ba26bc2ad5(variant, props, triggerAnalyticsEvent) {
    const { condition: conditionFn, onConditionChange: onConditionChange, onVisibilityChange: onVisibilityChange, message: message } = variant;
    const [condition, setCondition] = (0, $42omo.useState)(conditionFn(...props));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const lastConditionChange = (0, $42omo.useRef)(performance.now());
    const lastVisibilityChange = (0, $42omo.useRef)(performance.now());
    const fireConditionChange = (0, $42omo.useCallback)((newConditionValue)=>{
        if (onConditionChange) {
            const timing = {
                startTime: lastConditionChange.current,
                endTime: performance.now(),
                duration: performance.now() - lastConditionChange.current
            };
            lastConditionChange.current = performance.now();
            onConditionChange(newConditionValue, timing, triggerAnalyticsEvent, ...props);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- Refer to private remarks in the function description
    [
        onConditionChange,
        triggerAnalyticsEvent,
        ...props
    ]);
    (0, $42omo.useEffect)(()=>{
        const newConditionValue = conditionFn(...props);
        if (condition !== newConditionValue) {
            setCondition(newConditionValue);
            fireConditionChange(newConditionValue);
        } // eslint-disable-next-line react-hooks/exhaustive-deps -- Refer to private remarks in the function description
    }, [
        conditionFn,
        onConditionChange,
        condition,
        triggerAnalyticsEvent,
        ...props
    ]); // Fire condition change event on the first render to maintain consistency with previous behaviour for analytics
    const hasExecutedFirstRender = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!hasExecutedFirstRender.current) {
            hasExecutedFirstRender.current = true;
            fireConditionChange(condition);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- Refer to private remarks in the function description
    [
        fireConditionChange,
        condition
    ]);
    const wrappedOnVisibilityChange = (0, $42omo.useCallback)((visibilityValue)=>{
        if (onVisibilityChange) {
            const timing = {
                startTime: lastVisibilityChange.current,
                endTime: performance.now(),
                duration: performance.now() - lastVisibilityChange.current
            };
            lastVisibilityChange.current = performance.now();
            onVisibilityChange(visibilityValue, timing, triggerAnalyticsEvent, ...props);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- Refer to private remarks in the function description
    [
        onVisibilityChange,
        triggerAnalyticsEvent,
        ...props
    ]);
    const messageValue = (0, $42omo.useMemo)(()=>{
        if (typeof message === 'function') return message(...props);
        else if ($ceee0e5a959b634f$var$isMessageDescriptor(message)) return formatMessage(message);
        return null; // eslint-disable-next-line react-hooks/exhaustive-deps -- Refer to private remarks in the function description
    }, [
        message,
        ...props
    ]);
    return {
        id: variant.id,
        condition: condition,
        message: messageValue,
        wrapperStyleKey: variant.wrapperStyleKey,
        onVisibilityChange: wrappedOnVisibilityChange
    };
}
const $ceee0e5a959b634f$export$6484431ecffbb42d = {
    id: 'back-online-banner',
    condition: (isBackOnline)=>isBackOnline,
    message: (0, $kVuKK.i18n).editorEnabledOfflineMode,
    wrapperStyleKey: 'online'
};
const $ceee0e5a959b634f$export$fdc43f78fadf92e6 = {
    id: 'offline-disabled-banner',
    condition: (isOfflineStorageUnavailable)=>isOfflineStorageUnavailable,
    message: (0, $kVuKK.i18n).editorDisabled,
    wrapperStyleKey: 'offline'
};
const $ceee0e5a959b634f$export$e3d57ca72010d8b5 = {
    id: 'offline-banner',
    condition: (isOffline)=>isOffline,
    message: (0, $kVuKK.i18n).editorDisabledOfflineMode,
    wrapperStyleKey: 'offline',
    onConditionChange: (newCondition, _timing, triggerAnalyticsEvent, _isOffline, offlineData, editorType, restrictionUpdate)=>{
        if (newCondition) {
            // Save browser network status and document visibility state when the user goes offline
            offlineData.current.browserNetworkStatus = navigator.onLine;
            offlineData.current.documentVisibilityState = document.visibilityState; // Fire analytics event when the offline banner is now active (though it may not be visible yet)
            triggerAnalyticsEvent('offline.banner.show.indicator', {
                editorType: editorType,
                restrictionUpdate: restrictionUpdate
            });
        }
    },
    onVisibilityChange: (isVisible, timing, triggerAnalyticsEvent, _isOffline, onlineData, editorType, _restrictionUpdate)=>{
        if (!isVisible) // Fire analytics event when the offline banner has been displayed
        triggerAnalyticsEvent('offline.banner.displayed', {
            browserNetworkStatus: onlineData.current.browserNetworkStatus,
            editorType: editorType,
            documentVisibilityState: onlineData.current.documentVisibilityState,
            duration: timing.duration
        });
    }
};
const $ceee0e5a959b634f$export$5b93469ec56d27bf = {
    id: 'connection-timeout-banner',
    condition: (connectionTimedOut)=>connectionTimedOut,
    message: (0, $kVuKK.i18n).collabEditConnectionTimeout,
    wrapperStyleKey: 'offline',
    onConditionChange: (newCondition, _timing, triggerAnalyticsEvent, _connectionTimedOut, offlineData, { contentId: contentId, contentType: contentType })=>{
        if (newCondition) {
            // Save browser network status and document visibility state when the user goes offline
            offlineData.current.browserNetworkStatus = navigator.onLine;
            offlineData.current.documentVisibilityState = document.visibilityState; // Fire analytics event when the connection timeout banner is now active (though it may not be visible yet)
            triggerAnalyticsEvent('collab.edit.connection.timeout.show.indicator', {
                contentId: contentId,
                contentType: contentType
            });
        }
    },
    onVisibilityChange: (isVisible, timing, triggerAnalyticsEvent, _connectionTimedOut, offlineData, { editorType: editorType })=>{
        if (!isVisible) // Fire analytics event when the connection timeout banner has been displayed
        triggerAnalyticsEvent('connection.timeout.banner.displayed', {
            browserNetworkStatus: offlineData.current.browserNetworkStatus,
            editorType: editorType,
            documentVisibilityState: offlineData.current.documentVisibilityState,
            duration: timing.duration
        });
    }
};
const $ceee0e5a959b634f$export$865dd254943cb7d0 = {
    id: 'restriction-update-banner',
    condition: (restrictionUpdate, willEditorDisable)=>restrictionUpdate && willEditorDisable,
    message: (0, $kVuKK.i18n).editorDisabledDueToPermissionChange,
    wrapperStyleKey: 'offline'
};
const $ceee0e5a959b634f$export$d8b1b94ede519079 = {
    id: 'conflict-banner',
    condition: (conflicts)=>conflicts !== undefined && (conflicts.deleted.length > 0 || conflicts.inserted.length > 0),
    wrapperStyleKey: 'conflicts',
    message: (conflicts, formatMessage, fullPageEditorPresetAPI, contentId, spaceId, setIsLoading, isLivePage)=>{
        const messageKey = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? (0, $kVuKK.i18n).editorSyncFailedDueToConflictsUpdated : (0, $kVuKK.i18n).editorSyncFailedDueToConflicts;
        const conflictCount = conflicts !== undefined ? conflicts.deleted.length + conflicts.inserted.length : 0;
        let saveCopy;
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) saveCopy = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f917592567f31a69$export$3e0f67bf0e97b95a), {
                api: fullPageEditorPresetAPI,
                chunks: chunks,
                contentId: contentId,
                spaceId: spaceId,
                setIsLoading: setIsLoading,
                isLivePage: isLivePage
            });
        return formatMessage(messageKey, {
            conflictIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bQ6eU))), {
                label: "",
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }),
            conflictLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                    onClick: ()=>{
                        if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) fullPageEditorPresetAPI?.core?.actions.execute(fullPageEditorPresetAPI?.conflictResolutionUI?.commands.startResolvingConflicts);
                        else fullPageEditorPresetAPI?.core?.actions.execute(fullPageEditorPresetAPI?.conflictResolutionUI?.commands.navigateToFirstConflict);
                    },
                    xcss: $ceee0e5a959b634f$var$styles.conflictLink,
                    testId: "offline-conflict-navigate-to-first-conflict"
                }, chunks),
            saveCopy: saveCopy,
            conflictCount: conflictCount
        });
    }
};
const $ceee0e5a959b634f$export$989f13cb92705548 = {
    id: 'resyncing-editor-disabled-banner',
    condition: (resyncingEditorDisabled)=>resyncingEditorDisabled,
    message: (0, $kVuKK.i18n).resyncingEditorDisabled,
    wrapperStyleKey: 'offline'
};
const $ceee0e5a959b634f$var$EditorConnectionBannerComponent = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})((0, $gmMgo.default)(({ editorType: editorType, contentType: contentType, contentId: contentId, spaceId: spaceId, triggerAnalyticsEvent: triggerAnalyticsEvent, collabEditState: collabEditState, willEditorDisable: willEditorDisable = false, fullPageEditorPresetAPI: fullPageEditorPresetAPI, intl: { formatMessage: formatMessage }, isLivePage: isLivePage, isEditorToolbarHidden: isEditorToolbarHidden })=>{
    const [isFirstRender, setIsFirstRender] = (0, $42omo.useState)(true); // Timeout values for showing and hiding the banners
    const SHOW_TIMEOUT = 3000;
    const HIDE_TIMEOUT = 3000; // Track conflict state
    const conflicts = (0, $b3YrF.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'conflictResolutionUI.conflicts');
    const isOfflineStorageDisabled = Boolean((0, $b3YrF.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'editorOfflineStorage.disabled'));
    const offlineStorageIsInactiveSyncing = (0, $b3YrF.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'editorOfflineStorage.inactiveSyncing') ?? false; // Track if the user is online
    const hasInternet = (0, $8f9742f0ad2c6b9c$export$c40112cb03d4ce32)(isFirstRender ? true : !(collabEditState.collabEditInternetLost && willEditorDisable), SHOW_TIMEOUT, HIDE_TIMEOUT);
    const connectionTimedOut = (0, $8f9742f0ad2c6b9c$export$c40112cb03d4ce32)(isFirstRender ? false : collabEditState.collabEditConnectionTimedOut && willEditorDisable, SHOW_TIMEOUT, HIDE_TIMEOUT);
    const isOfflineStorageUnavailable = (0, $8f9742f0ad2c6b9c$export$c40112cb03d4ce32)(isFirstRender ? false : isOfflineStorageDisabled && !willEditorDisable && collabEditState.collabEditInternetLost, 0, 0);
    const isOnline = !isOfflineStorageDisabled ? hasInternet && !connectionTimedOut : !collabEditState.collabEditInternetLost && !connectionTimedOut; // Track when the user goes back online
    const [isBackOnline, setIsBackOnline] = (0, $42omo.useState)(false);
    const lastOnlineState = (0, $42omo.useRef)(isOnline);
    const backOnlineBannerTimeout = (0, $42omo.useRef)(null);
    const SHOW_BACK_ONLINE_TIMEOUT = 3000; // Show the back online banner for 3 seconds
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false); // Track restriction updates (permission changes)
    const [restrictionUpdate, setRestrictionUpdate] = (0, $8f9742f0ad2c6b9c$export$22acf644c7b26688)(false, 0, // Restriction updates should be shown immediately
    HIDE_TIMEOUT);
    const onRestrictionUpdatedEvent = (0, $42omo.useCallback)(()=>{
        triggerAnalyticsEvent('offline.banner.restriction.updated', {
            editorType: editorType,
            restrictionUpdate: restrictionUpdate
        });
        if (editorType === 'classic') setRestrictionUpdate(true);
    }, [
        editorType,
        restrictionUpdate,
        setRestrictionUpdate,
        triggerAnalyticsEvent
    ]);
    const onRestrictionUpdatedPubSubEvent = (0, $42omo.useCallback)(()=>{
        if (![
            'DUAL',
            'GRAPHQL'
        ].includes((0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', '')) || !(0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false)) onRestrictionUpdatedEvent();
    }, [
        onRestrictionUpdatedEvent
    ]); // Listen for restriction update events (permission changes)
    (0, $bT0se.usePubSubEvent)({
        contentId: contentId,
        contentType: contentType,
        eventName: `restrictionUpdated:${contentType}`,
        onEvent: onRestrictionUpdatedPubSubEvent,
        skip: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false) && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') && (0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', '') === 'GRAPHQL'
    });
    (0, $g01A4.useContentRestrictionSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        callback: onRestrictionUpdatedEvent,
        subscriberId: 'EditorConnectionBannerOfflineModeSubscription'
    }); // Reset restriction update when editor reconnects so the default message is shown next time the editor goes offline
    (0, $42omo.useEffect)(()=>{
        if (!willEditorDisable) setRestrictionUpdate(false);
    }, [
        setRestrictionUpdate,
        willEditorDisable
    ]);
    (0, $42omo.useEffect)(()=>{
        // If the user has gone back online after being offline, show the banner for a short time
        if (!lastOnlineState.current && isOnline) {
            setIsBackOnline(true); // Clear any existing timeout to avoid hiding the banner too early
            if (backOnlineBannerTimeout.current) clearTimeout(backOnlineBannerTimeout.current);
            backOnlineBannerTimeout.current = window.setTimeout(()=>{
                setIsBackOnline(false);
                backOnlineBannerTimeout.current = null;
            }, SHOW_BACK_ONLINE_TIMEOUT);
        } else if (lastOnlineState.current && !isOnline) {
            setIsBackOnline(false); // Strictly speaking this isn't necessary, the callback now has no effect, but I figure it's good to clean the timeout up anyway
            if (backOnlineBannerTimeout.current) clearTimeout(backOnlineBannerTimeout.current);
        }
        lastOnlineState.current = isOnline;
    }, [
        isOnline,
        setIsBackOnline
    ]); // Create the banner variant states and manage their visibility
    const backOnlineBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$6484431ecffbb42d, [
        isBackOnline
    ], triggerAnalyticsEvent);
    const offlineData = (0, $42omo.useRef)({
        browserNetworkStatus: true,
        documentVisibilityState: ''
    });
    const offlineBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$e3d57ca72010d8b5, [
        !hasInternet,
        offlineData,
        editorType,
        restrictionUpdate
    ], triggerAnalyticsEvent); // Use a memoized editor info object to avoid unnecessary re-renders
    const editorInfo = (0, $42omo.useMemo)(()=>({
            contentId: contentId,
            contentType: contentType,
            editorType: editorType
        }), [
        contentId,
        contentType,
        editorType
    ]);
    const connectionTimeoutBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$5b93469ec56d27bf, [
        connectionTimedOut,
        offlineData,
        editorInfo
    ], triggerAnalyticsEvent);
    const restrictionUpdateBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$865dd254943cb7d0, [
        restrictionUpdate,
        willEditorDisable
    ], triggerAnalyticsEvent);
    const disabledOfflineBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$fdc43f78fadf92e6, [
        isOfflineStorageUnavailable
    ], triggerAnalyticsEvent);
    const conflictBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$d8b1b94ede519079, [
        conflicts,
        formatMessage,
        fullPageEditorPresetAPI,
        contentId,
        spaceId,
        setIsLoading,
        isLivePage
    ], triggerAnalyticsEvent);
    const resyncingEditorDisabledBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$989f13cb92705548, [
        offlineStorageIsInactiveSyncing
    ], triggerAnalyticsEvent); // Banner list is ordered by priority, so the first valid banner will be shown
    const banners = [
        conflictBanner,
        disabledOfflineBanner,
        resyncingEditorDisabledBanner,
        backOnlineBanner,
        restrictionUpdateBanner,
        offlineBanner,
        connectionTimeoutBanner
    ]; // Track the most recent banner to detect changes in visibility (separately from tracking if each banner's condition has changed)
    const lastBanner = (0, $42omo.useRef)(undefined);
    const currentBanner = banners.find((banner)=>banner.condition);
    if (currentBanner?.id !== lastBanner.current) {
        // Fire a visibility change event for the banner that was previously visible
        if (lastBanner.current !== undefined) {
            // We can assume that the last ID is in the list of banners, as the banner list is constant, so we'll mark the result type as non-null
            const lastBannerInstance = banners.find((banner)=>banner.id === lastBanner.current);
            if (lastBannerInstance.onVisibilityChange !== undefined) lastBannerInstance.onVisibilityChange(false);
        } // Fire a visibility change event for the banner that is now visible (if any)
        if (currentBanner?.onVisibilityChange !== undefined) currentBanner.onVisibilityChange(true);
        lastBanner.current = currentBanner?.id;
    }
    (0, $42omo.useEffect)(()=>{
        if (isFirstRender) setIsFirstRender(false);
    }, [
        isFirstRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ceee0e5a959b634f$export$26d1be1a3667a472, {
        isLoading: isLoading,
        currentBanner: currentBanner,
        isEditorToolbarHidden: isEditorToolbarHidden
    });
}));
const $ceee0e5a959b634f$export$26d1be1a3667a472 = ({ currentBanner: currentBanner, isLoading: isLoading, isEditorToolbarHidden: isEditorToolbarHidden })=>{
    // Get the message to display in the banner (if any) and format it if necessary
    const CurrentMessage = (0, $42omo.useMemo)(()=>currentBanner?.message, [
        currentBanner
    ]);
    const LoadingIndicator = (0, $42omo.useMemo)(()=>{
        if (currentBanner?.wrapperStyleKey !== 'conflicts') return null;
         // Show loading ellipsis for conflicts only for now
        // Show a placeholder when not loading to avoid layout shift
        return isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ceee0e5a959b634f$var$AnimatedEllipsis, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            className: (0, $gMc0m.default)([
                $ceee0e5a959b634f$var$styles.placeholder
            ])
        });
    }, [
        isLoading,
        currentBanner
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ceee0e5a959b634f$export$884d2f68355ca9c8, {
        "data-testid": "status-indicator",
        show: currentBanner !== undefined,
        toolbarHidden: isEditorToolbarHidden,
        className: (0, $gMc0m.default)([
            currentBanner?.wrapperStyleKey === 'online' && $ceee0e5a959b634f$var$backgroundColor['online'],
            currentBanner?.wrapperStyleKey === 'offline' && $ceee0e5a959b634f$var$backgroundColor['offline'],
            currentBanner?.wrapperStyleKey === 'conflicts' && $ceee0e5a959b634f$var$backgroundColor['conflicts']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ceee0e5a959b634f$export$bb5d4b172e6970cd, {
        "data-testid": "status-indicator-text",
        role: "alert",
        show: currentBanner !== undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ceee0e5a959b634f$export$31ea92f3997410dd, {
        "data-testid": "status-text"
    }, CurrentMessage), LoadingIndicator));
};
const $ceee0e5a959b634f$export$2d7f5da98593df5c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($ceee0e5a959b634f$var$EditorConnectionBannerComponent);


const $5b566a57f88868ac$export$6d9f0d80d291faa5 = ({ triggerAnalyticsEvent: triggerAnalyticsEvent, collabEditInternetLost: collabEditInternetLost, collabEditConnectionTimedOut: collabEditConnectionTimedOut, willEditorDisable: willEditorDisable, contentType: contentType, contentId: contentId, spaceId: spaceId, fullPageEditorPresetAPI: fullPageEditorPresetAPI, collabEditState: collabEditState, isDesktop: isDesktop, isLivePage: isLivePage, isViewMode: isViewMode })=>{
    const isEditorToolbarDockedAtTop = (0, $lEVfb.useIsEditorToolbarDockedAtTop)({
        defaultDockedAtTop: !isLivePage
    });
    const isEditorToolbarHidden = isViewMode || !isEditorToolbarDockedAtTop;
    if (isDesktop || (0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ceee0e5a959b634f$export$2d7f5da98593df5c), {
        editorType: "next",
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        collabEditState: collabEditState,
        willEditorDisable: willEditorDisable,
        contentType: contentType,
        contentId: contentId,
        spaceId: spaceId,
        fullPageEditorPresetAPI: fullPageEditorPresetAPI,
        isEditorToolbarHidden: isEditorToolbarHidden
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3wSkK.EditorConnectionBanner), {
        editorType: "next",
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        collabEditInternetLost: collabEditInternetLost,
        collabEditConnectionTimedOut: collabEditConnectionTimedOut,
        willEditorDisable: willEditorDisable,
        contentType: contentType,
        contentId: contentId,
        isEditorToolbarHidden: isEditorToolbarHidden
    });
};









var $4tuiZ = parcelRequire("4tuiZ");

const $8458479082092807$export$d89be7c77f7ffd93 = (isLivePage, contentId)=>{
    const { setWasTransitionedFromEditor: setWasTransitionedFromEditor, hideNewContentHistory: hideNewContentHistory } = (0, $4tuiZ.useNewContentHistoryActions)();
    (0, $42omo.useEffect)(()=>{
        if (isLivePage && (0, $6mKj3.expVal)('confluence_content_history_updates', 'isEnabled', false)) setWasTransitionedFromEditor(true);
    }, [
        isLivePage,
        setWasTransitionedFromEditor,
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        // Reset states on editor unmount - not checking expVal here since it doesn't really matter and we just resetting to default
        return ()=>{
            hideNewContentHistory();
            setWasTransitionedFromEditor(false);
        };
    }, [
        setWasTransitionedFromEditor,
        hideNewContentHistory,
        contentId
    ]);
};





var $gGwl1 = parcelRequire("gGwl1");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");





var $6LguK = parcelRequire("6LguK");


var $e6u60 = parcelRequire("e6u60");

const $6eee7623ad82c8da$export$386b0ae74d3f86a0 = (triggerAnalyticsEvent)=>{
    // log time of keypress
    const now = performance?.now();
    // grab the array of fmp & tti metrics
    const fmpMetrics = performance?.getEntriesByName('browser-metric:fmp');
    const ttiMetrics = performance?.getEntriesByName('browser-metric:tti');
    // grab the most recently added fmp & tti metrics
    const fmpEnd = fmpMetrics[fmpMetrics.length - 1]?.startTime + fmpMetrics[fmpMetrics.length - 1]?.duration;
    const ttiEnd = ttiMetrics[ttiMetrics.length - 1]?.startTime + ttiMetrics[ttiMetrics.length - 1]?.duration;
    // if now (keypress time), fmp, and tti all exist, fire the measure time to edit analytics event
    if (now && fmpEnd && ttiEnd) triggerAnalyticsEvent('measure.time.to.edit', {
        keypressTime: now,
        fmpTimeToEdit: now - fmpEnd,
        ttiTimeToEdit: now - ttiEnd,
        fmpEnd: fmpEnd,
        ttiEnd: ttiEnd
    });
};









var $j8hiR = parcelRequire("j8hiR");


var $9137z = parcelRequire("9137z");

const $455b0e3615badc4d$export$257c6c9e28c0ad4b = (collabEditProvider)=>{
    const handleConnecting = ()=>{
        // tracking time between when provider is created in the FE and when channel initialization starts
        (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_PRE_CONNECTED);
        // tracking time between when provider's channel is initialized and when connected event is fired
        (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_CONNECTED);
    };
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        // @ts-ignore
        collabEditProvider.on('connecting', handleConnecting);
        return ()=>{
            // @ts-ignore
            collabEditProvider.off('connecting', handleConnecting);
        };
    }, [
        collabEditProvider
    ]);
};



var $gkIgp = parcelRequire("gkIgp");


var $S6mif = parcelRequire("S6mif");


var $kXAjP = parcelRequire("kXAjP");
var $39X8O = parcelRequire("39X8O");


var $6dTPw = parcelRequire("6dTPw");





var $jmjWc = parcelRequire("jmjWc");


const $5fed17fe09649c6f$export$be5a95ae7f8387c0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "k58TW",
    name: "MarketplaceAppsContainer",
    loader: async ()=>(await (parcelRequire("aG1TG"))).MarketplaceAppsContainer
});


const $f9a65503f42ecec3$export$bc75c05af9bceb4a = ({ searchTerm: searchTerm, mode: mode })=>{
    if (!searchTerm) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5fed17fe09649c6f$export$be5a95ae7f8387c0), {
        searchTerm: searchTerm,
        mode: mode
    });
};



var $4ri4I = parcelRequire("4ri4I");





const $11b8024921ea2f1a$export$a1cd66d9f8e156b1 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "gzpgy",
    name: "ConditionalPublish",
    loader: async ()=>(await (parcelRequire("c0BUW"))).ConditionalPublish
});






var $gTyTP = parcelRequire("gTyTP");


var $cmBjr = parcelRequire("cmBjr");


var $kXsBa = parcelRequire("kXsBa");


var $1B6Lx = parcelRequire("1B6Lx");


var $3o3i5 = parcelRequire("3o3i5");


var $kSPGK = parcelRequire("kSPGK");








var $bAIqi = parcelRequire("bAIqi");





const $ee7c889194e6f932$export$c43bb192f22b2458 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8Gtxn",
    name: "LazyEditorContextCustomSitesConfigPanel",
    loader: async ()=>(await (parcelRequire("bMmhd"))).EditorContextCustomSitesConfigPanel
});


const $f04c510354797dd3$export$7a4297a73e39e6ad = /*#__PURE__*/ (0, $42omo.memo)(({ localId: localId, closeSelf: closeSelf, editorApi: editorApi, contentId: contentId, upsellModalSource: upsellModalSource, setUpsellModalSource: setUpsellModalSource })=>{
    if (upsellModalSource) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bAIqi.ExtensionInsertUpsellLoader), {
        setUpsellModalSource: setUpsellModalSource,
        feature: upsellModalSource
    });
    if (localId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ee7c889194e6f932$export$c43bb192f22b2458), {
        localId: localId,
        closeSelf: closeSelf,
        editorApi: editorApi,
        contentId: contentId
    });
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));





var $ks2lK = parcelRequire("ks2lK");





var $kcoxM = parcelRequire("kcoxM");


var $5Ac5G = parcelRequire("5Ac5G");


var $4cOi8 = parcelRequire("4cOi8");

var $cNwLI = parcelRequire("cNwLI");


var $lf1vG = parcelRequire("lf1vG");


var $cVaAA = parcelRequire("cVaAA");


var $bl1ay = parcelRequire("bl1ay");

const $b5ea4fb4260f4ec5$var$ALLOWED_EXTENSIONS = [
    (0, $cNwLI.SPOTLIGHT_EXTENSION_TYPE),
    (0, $5Ac5G.carouselExtensionType),
    (0, $kcoxM.CARDS_EXTENSION_TYPE),
    (0, $cVaAA.LINKS_MENU_EXTENSION_TYPE),
    (0, $cNwLI.SECTION_EXTENSION_TYPE),
    (0, $bl1ay.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE),
    (0, $lf1vG.SEARCH_EXTENSION_TYPE)
];
const $b5ea4fb4260f4ec5$export$bdd538c0d43098c3 = (editorActions)=>{
    const [activeNodeLocalId, setActiveNodeLocalId] = (0, $42omo.useState)(null);
    // when upsellModalSource is undefined, we use it to close the upsell modal in ModalUpsellWrapper.
    const [upsellModalSource, setUpsellModalSource] = (0, $42omo.useState)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const openConfigPanel = (0, $42omo.useCallback)((localId)=>{
        if (!localId) return;
        const { attrs: attrs, type: type } = editorActions?.getNodeByLocalId(localId)?.toJSON() || {};
        const { extensionType: extensionType, extensionKey: extensionKey } = attrs || {};
        const editorView = editorActions._privateGetEditorView();
        const selection = editorView?.state?.selection;
        if (selection instanceof (0, $ks2lK.NodeSelection)) {
            if ($b5ea4fb4260f4ec5$var$ALLOWED_EXTENSIONS.includes(extensionType)) setActiveNodeLocalId(localId);
        } else {
            if (type !== 'multiBodiedExtension' || !editorView?.state) return;
            // Handle MultiBodiedExtension config panel
            let multiBodiedExtensionPosition = editorView.state.selection.from;
            editorView.state.tr.doc.descendants((node, pos)=>{
                if (node.attrs?.localId === localId) {
                    multiBodiedExtensionPosition = pos;
                    return;
                }
            });
            editorView.dispatch(editorView.state.tr?.setSelection?.((0, $ks2lK.NodeSelection).create(editorView.state.tr.doc, multiBodiedExtensionPosition)));
            if ($b5ea4fb4260f4ec5$var$ALLOWED_EXTENSIONS.includes(extensionType)) setActiveNodeLocalId(localId);
        }
        if (!!extensionKey && !!extensionType) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editExtension',
                source: `${extensionKey}ExtensionConfig`,
                attributes: {
                    extensionType: extensionType
                }
            }
        }).fire();
    }, [
        setActiveNodeLocalId,
        createAnalyticsEvent,
        editorActions
    ]);
    const closeConfigPanel = (0, $42omo.useCallback)(()=>{
        const selectedNode = editorActions.getSelectedNode()?.toJSON();
        if (activeNodeLocalId && selectedNode?.attrs?.localId === activeNodeLocalId && selectedNode?.attrs?.extensionType === (0, $kcoxM.CARDS_EXTENSION_TYPE)) {
            const parameters = selectedNode.attrs.parameters || {};
            if (parameters.renderVariant === (0, $4cOi8.RenderVariant).MANUAL) {
                delete parameters.filters;
                delete parameters.cardCount;
            }
            if (parameters.renderVariant === (0, $4cOi8.RenderVariant).DYNAMIC) parameters.cards = [];
            editorActions.replaceSelection({
                ...selectedNode,
                attrs: {
                    ...selectedNode.attrs,
                    parameters: {
                        ...parameters
                    }
                }
            }, true);
        }
        setActiveNodeLocalId(null);
    }, [
        activeNodeLocalId,
        editorActions,
        setActiveNodeLocalId
    ]);
    return (0, $42omo.useMemo)(()=>({
            activeNodeLocalId: activeNodeLocalId,
            openConfigPanel: openConfigPanel,
            closeConfigPanel: closeConfigPanel,
            upsellModalSource: upsellModalSource,
            setUpsellModalSource: setUpsellModalSource
        }), [
        activeNodeLocalId,
        openConfigPanel,
        closeConfigPanel,
        upsellModalSource,
        setUpsellModalSource
    ]);
};



var $cQhbe = parcelRequire("cQhbe");


var $sLZsl = parcelRequire("sLZsl");










var $j1Ss3 = parcelRequire("j1Ss3");


var $dWCFT = parcelRequire("dWCFT");


var $3Vbz9 = parcelRequire("3Vbz9");


var $duCvb = parcelRequire("duCvb");





var $i9VoI = parcelRequire("i9VoI");




const $97a8d2d7e4b91567$export$eda8293dfd8214f4 = (0, $eSUdr.default)`query ContentSchedulePublishQuery($contentId:ID!$status:[String]){content(id:$contentId status:$status){nodes{id schedulePublishDate}}}`;


const $f9205d97e0969451$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    rescheduleUpdateWithSpaceName: {
        id: "editor-schedule-publish.success.reschedule.update.with.space.name",
        defaultMessage: "{pageTitle} has been rescheduled to update on {date} at {time} in the {spaceName} space"
    },
    rescheduleUpdate: {
        id: "editor-schedule-publish.success.reschedule.update",
        defaultMessage: "{pageTitle} has been rescheduled to update on {date} at {time}"
    },
    reschedulePublishWithSpaceName: {
        id: "editor-schedule-publish.success.reschedule.publish.with.space.name",
        defaultMessage: "{pageTitle} has been rescheduled to publish on {date} at {time} in the {spaceName} space"
    },
    reschedulePublish: {
        id: "editor-schedule-publish.success.reschedule.publish",
        defaultMessage: "{pageTitle} has been rescheduled to publish on {date} at {time}"
    },
    scheduleUpdateWithSpaceName: {
        id: "editor-schedule-publish.success.schedule.update.message.with.space.name",
        defaultMessage: "{pageTitle} will be updated on {date} at {time} in the {spaceName} space"
    },
    scheduleUpdate: {
        id: "editor-schedule-publish.success.schedule.update.message",
        defaultMessage: "{pageTitle} will be updated on {date} at {time}"
    },
    schedulePublishWithSpaceName: {
        id: "editor-schedule-publish.success.schedule.publish.message.with.space.name",
        defaultMessage: "{pageTitle} will be published on {date} at {time} in the {spaceName} space"
    },
    schedulePublish: {
        id: "editor-schedule-publish.success.schedule.publish.message",
        defaultMessage: "{pageTitle} will be published on {date} at {time}"
    },
    scheduleUpdateTitle: {
        id: "editor-schedule-publish.success.schedule.update.title",
        defaultMessage: "Update scheduled"
    },
    schedulePublishTitle: {
        id: "editor-schedule-publish.success.schedule.publish.title",
        defaultMessage: "Publish scheduled"
    }
});
const $f9205d97e0969451$export$206997a838ea4b9d = ({ contentId: contentId, contentType: contentType, title: title, isUnpublishedDraft: isUnpublishedDraft, flags: flags, isSchedulePublishEnabled: // TODO MODES-3970 isSchedulePublishEnabled should be removed when when its consumer(FullPageEditorComponent) doesn't have to support the use case of schedule publish being disabled.
// This is set to true when on a live page. Live pages currently use FullPageEditorComponent and do not support scheduling publishes.
isSchedulePublishEnabled = true })=>{
    const [currentlyScheduledPublishDate, setCurrentlyScheduledPublishDate] = (0, $42omo.useState)(null);
    const [spaceName] = (0, $42omo.useState)();
    const intl = (0, $8C5kA.default)();
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [getContent, { data: contentData }] = (0, $j1Ss3.useLazyQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $97a8d2d7e4b91567$export$eda8293dfd8214f4), {
        fetchPolicy: 'network-only'
    });
    /**
   * Store refs to state values used in handleSchedulePublish, because putting them
   * directly into the callback causes the memoized function to be recreated several
   * times rapidly, resulting in issues with PubSub subscribe/unsubscribing properly
   */ const flagDataRef = (0, $42omo.useRef)({
        spaceName: spaceName,
        title: title,
        isUnpublishedDraft: isUnpublishedDraft,
        currentlyScheduledPublishDate: currentlyScheduledPublishDate
    });
    /**
   * Returns the object received by intl.formatMessage for the schedule publish success flag's content
   */ const getFlagMessage = (0, $42omo.useCallback)(()=>{
        const updating = !flagDataRef.current.isUnpublishedDraft;
        if (flagDataRef.current.currentlyScheduledPublishDate) {
            // Rescheduling
            if (updating) {
                if (flagDataRef.current.spaceName) return $f9205d97e0969451$export$a7357cdd1f0b0168.rescheduleUpdateWithSpaceName;
                return $f9205d97e0969451$export$a7357cdd1f0b0168.rescheduleUpdate;
            } else {
                // Publishing
                if (flagDataRef.current.spaceName) return $f9205d97e0969451$export$a7357cdd1f0b0168.reschedulePublishWithSpaceName;
                return $f9205d97e0969451$export$a7357cdd1f0b0168.reschedulePublish;
            }
        } else // Scheduling (for first time)
        if (updating) {
            if (flagDataRef.current.spaceName) return $f9205d97e0969451$export$a7357cdd1f0b0168.scheduleUpdateWithSpaceName;
            return $f9205d97e0969451$export$a7357cdd1f0b0168.scheduleUpdate;
        } else {
            // Publishing
            if (flagDataRef.current.spaceName) return $f9205d97e0969451$export$a7357cdd1f0b0168.schedulePublishWithSpaceName;
            return $f9205d97e0969451$export$a7357cdd1f0b0168.schedulePublish;
        }
    }, []);
    const handleSchedulePublish = (0, $42omo.useCallback)((_delta, response)=>{
        const { eventType: eventType, publishTime: publishTime } = response?.schedulePublished || {};
        const { accountId: accountId } = response;
        if (!isSchedulePublishEnabled) return;
        switch(eventType){
            case 'scheduled':
                const scheduledPublishDate = new Date(publishTime);
                const monthDayRegex = /[^,]*$/g; // selects everything after comma ","
                const updating = !flagDataRef.current.isUnpublishedDraft;
                flags.showFlag({
                    type: 'success-circle',
                    close: 'auto',
                    title: intl.formatMessage(updating ? $f9205d97e0969451$export$a7357cdd1f0b0168.scheduleUpdateTitle : $f9205d97e0969451$export$a7357cdd1f0b0168.schedulePublishTitle),
                    description: intl.formatMessage(getFlagMessage(), {
                        pageTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, flagDataRef.current.title),
                        date: (0, $dWCFT.default)(scheduledPublishDate, 'PP').replace(monthDayRegex, ''),
                        time: (0, $3Vbz9.format)(scheduledPublishDate, 'h:mm aaaa z'),
                        spaceName: flagDataRef.current.spaceName
                    })
                }).finally(()=>{
                    setCurrentlyScheduledPublishDate(scheduledPublishDate);
                });
                break;
            case 'unscheduled':
                setCurrentlyScheduledPublishDate(null);
                break;
            case 'published':
                (0, $ge2sX.getSessionData)().then(({ userId: userId })=>{
                    if (accountId === userId) (0, $duCvb.showPublishSuccessFlags)({
                        isFirstTimePublish: isUnpublishedDraft,
                        shouldTimeout: false,
                        spaceName: flagDataRef.current.spaceName,
                        flags: flags,
                        title: flagDataRef.current.title,
                        intl: intl
                    });
                });
        }
    }, [
        getFlagMessage,
        isUnpublishedDraft,
        intl,
        flags,
        isSchedulePublishEnabled
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        subscriberId: 'useSchedulePublishFlagsWatcher',
        delta: 'schedulePublished',
        onDataReceived: handleSchedulePublish
    });
    (0, $42omo.useEffect)(()=>{
        if (!isSchedulePublishEnabled) return;
        const params = {
            contentId: contentId,
            status: [
                isUnpublishedDraft ? 'draft' : 'current'
            ]
        };
        getContent({
            variables: params
        });
    }, [
        getContent,
        contentId,
        isUnpublishedDraft,
        isSchedulePublishEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isSchedulePublishEnabled) return;
        const contentSchedulePublishDate = contentData?.content?.nodes[0]?.schedulePublishDate;
        const date = contentSchedulePublishDate ? new Date(contentSchedulePublishDate) : null;
        setCurrentlyScheduledPublishDate(date);
    // The spaceName used to be set here, but it was sometimes invalid.
    // Please re-add calling `setSpaceName` here after GENI-2960 is completed.
    }, [
        contentData,
        isSchedulePublishEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        flagDataRef.current = {
            spaceName: spaceName,
            title: title,
            isUnpublishedDraft: isUnpublishedDraft,
            currentlyScheduledPublishDate: currentlyScheduledPublishDate
        };
    }, [
        spaceName,
        title,
        isUnpublishedDraft,
        currentlyScheduledPublishDate
    ]);
};











const $6b433f129bb94645$var$PrimaryToolbarContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $6b433f129bb94645$var$memoizeDeepEq = (0, $2XqLN.default)((obj)=>obj, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
function $6b433f129bb94645$export$5acade271146d69c({ children: children, value: value }) {
    const memoizedValue = $6b433f129bb94645$var$memoizeDeepEq(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b433f129bb94645$var$PrimaryToolbarContext.Provider, {
        value: memoizedValue
    }, children);
}
function $6b433f129bb94645$export$87f05b83083ffee2() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($6b433f129bb94645$var$PrimaryToolbarContext);
    if (!context) throw new Error('usePrimaryToolbarContext must be used within a PrimaryToolbarContextProvider');
    return context;
}


/**
 * @generated SignedSource<<c91db97b01af29eb573742abc8e1dce6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ab1e224d72963101$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "EditorPrimaryToolbarComponentsGetDraftParentFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "__typename"
            }
        ],
        "type": "Content"
    };
}();
$ab1e224d72963101$var$node.hash = "8d1e74aac7d44af0e715791d1017e102";
var $ab1e224d72963101$export$2e2bcd8739ae039 = $ab1e224d72963101$var$node;









var $gabmL = parcelRequire("gabmL");





var $1Vx7O = parcelRequire("1Vx7O");


var $1ch0f = parcelRequire("1ch0f");


var $2unW6 = parcelRequire("2unW6");


var $6yCgm = parcelRequire("6yCgm");

parcelRequire("aYZaZ");
var $iQb1R = parcelRequire("iQb1R");
var $aYZaZ = parcelRequire("aYZaZ");





var $6tSjb = parcelRequire("6tSjb");


const $088b8a15e556cc8e$export$ad9980f718bbeeb6 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "TEbaC",
    name: "LivePagesEllipsisDropdownComponent",
    loader: async ()=>(await (parcelRequire("4LVRL"))).LivePagesEllipsisDropdownComponent,
    loading: (0, $6tSjb.EllipsisPlaceholder)
});





















var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");


var $ecUYt = parcelRequire("ecUYt");


var $jacyh = parcelRequire("jacyh");


var $5rEAe = parcelRequire("5rEAe");


var $3mmDo = parcelRequire("3mmDo");


var $lHzSp = parcelRequire("lHzSp");


var $atF9V = parcelRequire("atF9V");


var $fFmJj = parcelRequire("fFmJj");

const $02a52aafb1fafdd7$var$EditorPrimaryToolbarComponentsFunction = ({ forceDisabled: forceDisabled, userOffline: userOffline, collabLimitReached: collabLimitReached, contentId: contentId, contentType: contentType, isContentCreationPanelOpen: isContentCreationPanelOpen, isUnpublishedDraft: isUnpublishedDraft, onClickPublish: onClickPublish, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, onPreviewClicked: onPreviewClicked, saveDraft: saveDraft, spaceKey: spaceKey, title: title, showRevertDialog: showRevertDialog, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, isPublishingContent: isPublishingContent, editorActions: editorActions, isSingleUserSession: isSingleUserSession, navigateOnClose: navigateOnClose, triggerAnalyticsEvent: triggerAnalyticsEvent, shouldRenderPreview: shouldRenderPreview, shouldShowRecentSpotlight: shouldShowRecentSpotlight, flags: flags, viewMode: viewMode, pageTreeStateUpdater: pageTreeStateUpdater, hasEditPermission: hasEditPermission, ellipsisEditorActions: ellipsisEditorActions, allowInlineComments: allowInlineComments = true, allowPageComments: allowPageComments = true })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $ab1e224d72963101$export$2e2bcd8739ae039)
    });
    const { emojiCoverPictureAndContentStateSubscription: emojiCoverPictureAndContentStateSubscription, hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, hasContentState: hasContentState } = (0, $lHzSp.useEmojiTitleCoverPictureAndContentState)();
    const { hasRestrictionsSubscription: hasRestrictionsSubscription, hasRestrictions: hasRestrictions } = (0, $atF9V.useRestrictions)();
    const publicLinkData = (0, $gabmL.usePublicLinkPageDataProvider)({
        pageId: contentId,
        fetchPolicy: 'cache-and-network'
    });
    const hasLabels = (0, $2unW6.useLabels)(contentId);
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    const shouldDisableActions = isPublishingContent || userOffline || !!forceDisabled;
    const areMainButtonsDisabled = shouldDisableActions || publicLinkData.isLoading;
    const isPublishDisabledForPublishModal = shouldDisableActions || Boolean(collabLimitReached);
    const hasTitle = Boolean(title);
    const hasBody = !editorActions.isDocumentEmpty();
    const { forceRefetchBlogTree: forceRefetchBlogTree } = (0, $jacyh.useBlogTreeActions)();
    const willDeleteBlankDraftOnClose = (0, $3mmDo.useWillDeleteBlankDraftOnClose)({
        isUnpublishedDraft: isUnpublishedDraft,
        isSingleUserSession: isSingleUserSession,
        hasTitle: hasTitle,
        hasBody: hasBody,
        hasEmoji: hasEmoji,
        hasCoverPicture: hasCoverPicture,
        hasContentState: hasContentState,
        hasRestrictions: hasRestrictions,
        hasLabels: hasLabels
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    // Data is not used so we don't worry about errors here
    (0, $42omo.useEffect)(()=>{
        for (const error of publicLinkData.errors)(0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        publicLinkData.errors
    ]);
    const publishButtonDisabledReason = (0, $1Vx7O.getPublishButtonDisabledReason)({
        title: title,
        isPublishingContent: isPublishingContent,
        userOffline: userOffline,
        forceDisabled: forceDisabled
    });
    const onClose = async ()=>{
        if (contentType === 'page') (0, $lXYVJ.setViewTransitionSource)((0, $1C3B1.EDITOR_CLOSE_BUTTON_CLICK));
        if (shouldShowRecentSpotlight) setOnboardingState({
            key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).RECENT_SPOTLIGHT_OPEN,
            value: 'true'
        });
        if (willDeleteBlankDraftOnClose) {
            triggerAnalyticsEvent('close', {
                discarded: true
            });
            (0, $1ch0f.deleteDraft)({
                contentId: contentId,
                deleteOnlyIfBlank: true
            }).then(async ({ data: data })=>{
                if (contentType === 'blogpost') // refreshes blog tree on discard close of blog draft
                forceRefetchBlogTree();
                triggerAnalyticsEvent('draftDiscarded', {
                    wasDeleted: !!data?.deleteContent?.wasDeleted
                });
                const parentId = await (0, $5rEAe.getParentOfDraft)(contentId, readFragmentInterop);
                if (parentId) pageTreeStateUpdater.setForceFetchPageId(parentId);
                else createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'notFound',
                        actionSubject: 'discardedDraftParent',
                        objectType: contentType,
                        objectId: contentId
                    }
                }).fire();
            });
            navigateOnClose({
                isDiscarding: true
            });
        } else {
            triggerAnalyticsEvent('close');
            saveDraft({
                isOnClose: true
            }).then(()=>navigateOnClose());
        }
    };
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const allowedEllipsisButtons = !isCompanyHub ? [
        (0, $iQb1R.Buttons).PUBLISH_WITHOUT_NOTIFY,
        (0, $iQb1R.Buttons).DELETE_DRAFT,
        (0, $iQb1R.Buttons).EDIT_LABELS,
        (0, $iQb1R.Buttons).MOVE_PAGE,
        (0, $iQb1R.Buttons).PREVIEW,
        (0, $iQb1R.Buttons).RESOLVED_COMMENTS,
        (0, $iQb1R.Buttons).TEMPLATE_BROWSER,
        (0, $iQb1R.Buttons).VIEW_CHANGES,
        (0, $iQb1R.Buttons).SWITCH_TO_LIVE_EDIT,
        (0, $iQb1R.Buttons).CLASSIFY_CONTENT
    ] : [
        (0, $iQb1R.Buttons).DELETE_DRAFT,
        (0, $iQb1R.Buttons).PREVIEW,
        (0, $iQb1R.Buttons).RESOLVED_COMMENTS,
        (0, $iQb1R.Buttons).VIEW_CHANGES
    ];
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEmbedded = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showEllipsisDropdown = !isEmbedded;
    const ellipsisDropdownProps = {
        contentId: contentId,
        contentType: contentType,
        isDisabled: areMainButtonsDisabled || userOffline || collabLimitReached,
        isUnpublishedDraft: isUnpublishedDraft,
        isShowingLabelsDialog: false,
        onPreviewClicked: onPreviewClicked,
        onClickPublish: onClickPublish,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        saveDraft: saveDraft,
        tooltipDisabledState: publishButtonDisabledReason,
        spaceKey: spaceKey,
        isContentCreationPanelShown: isContentCreationPanelOpen,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        showRevertDialog: showRevertDialog,
        allowedEllipsisButtons: allowedEllipsisButtons,
        hasEditPermission: hasEditPermission,
        editorActions: ellipsisEditorActions
    };
    // allowCopyLink and allowRestrictions are contingent on if user is not in Company hub space
    // Only inline comments button is whitelisted for Company hub editors to remain consistent with whitelisted actions in the EllipsisDropdown
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, emojiCoverPictureAndContentStateSubscription, hasRestrictionsSubscription, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6yCgm.MainButtons), {
        allowWebItems: true,
        allowCopyLink: !isCompanyHub && !isEmbedded,
        allowInlineComments: allowInlineComments,
        allowPageComments: allowPageComments,
        allowRestrictions: !isCompanyHub && !isEmbedded,
        allowStar: isLivePage && !isEmbedded,
        allowWatch: isLivePage && !isEmbedded,
        areMainButtonsDisabled: areMainButtonsDisabled,
        contentId: contentId,
        contentType: contentType,
        isPublishDisabled: !title || !title?.trim() || areMainButtonsDisabled || collabLimitReached || !collabEditConnected,
        isCloseButtonDisabled: shouldDisableActions,
        isPublishDisabledForPublishModal: isPublishDisabledForPublishModal,
        isUnpublishedDraft: isUnpublishedDraft,
        discardOnCloseEnabled: willDeleteBlankDraftOnClose,
        onClose: onClose,
        onClickPreview: onPreviewClicked,
        onClickPublish: onClickPublish,
        publishButtonDisabledReason: publishButtonDisabledReason,
        isPublishingContent: isPublishingContent,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        shouldRenderPreview: shouldRenderPreview,
        flags: flags,
        saveDraft: saveDraft,
        title: title,
        subsequentNode: showEllipsisDropdown && (isLivePage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $088b8a15e556cc8e$export$ad9980f718bbeeb6), {
            contentId: contentId,
            spaceKey: spaceKey,
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
            onClickPublish: onClickPublish,
            saveDraft: saveDraft,
            isViewMode: viewMode && !hasEditPermission,
            onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
            isDisabled: areMainButtonsDisabled || userOffline || collabLimitReached
        }) : //@ts-ignore
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aYZaZ.EllipsisDropdownComponent), ellipsisDropdownProps)),
        spaceKey: spaceKey,
        editorActions: editorActions,
        viewMode: viewMode
    }));
};
const $02a52aafb1fafdd7$export$170e4ca3217957a2 = (0, $ecUYt.withPageTreeStateUpdater)($02a52aafb1fafdd7$var$EditorPrimaryToolbarComponentsFunction);











const $82bb8752b1a17b39$export$3bc2a95151a4db09 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $82bb8752b1a17b39$var$memoizeDeepEq = (0, $2XqLN.default)((obj)=>obj, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
function $82bb8752b1a17b39$export$f7b2b60e23c443f6({ children: children, value: value }) {
    const memoizedValue = $82bb8752b1a17b39$var$memoizeDeepEq(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($82bb8752b1a17b39$export$3bc2a95151a4db09.Provider, {
        value: memoizedValue
    }, children);
}
function $82bb8752b1a17b39$export$69a815b52f63537() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($82bb8752b1a17b39$export$3bc2a95151a4db09);
    if (!context) throw new Error('useContentComponentsContext must be used within a ContentComponentsContextProvider');
    return context;
}


/* EditorActionBar.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $bWLcG = parcelRequire("bWLcG");


var $cgsIj = parcelRequire("cgsIj");

















var $ktUCG = parcelRequire("ktUCG");


var $i5zxs = parcelRequire("i5zxs");











var $ebrpi = parcelRequire("ebrpi");


var $3gadb = parcelRequire("3gadb");








var $cF2C3 = parcelRequire("cF2C3");

const $878360c0a07026f6$var$i18n = (0, $cgtv4.defineMessages)({
    savingMessage: {
        id: "save-indicator.saving",
        defaultMessage: "Saving"
    },
    allChangesSavedMessage: {
        id: "save-indicator.all.changes.saved",
        defaultMessage: "Saved"
    },
    savedTooltipMessage: {
        id: "save-indicator.all.changes.saved.tooltip",
        defaultMessage: "Every change is saved. The last change was {time}."
    },
    errorTooltipMessage: {
        id: "save-indicator.error.tooltip",
        defaultMessage: "We couldn\u2019t save the latest changes. The last save was {time}."
    }
});
const $878360c0a07026f6$var$saveIndicatorStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    cursor: 'default',
    marginLeft: 'space.050',
    marginRight: 'space.050',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $878360c0a07026f6$var$saveIndicatorTextStyles = (0, $ecnYn.xcss)({
    minWidth: '44px'
});
const $878360c0a07026f6$var$STATUSES = {
    DISABLED: 'disabled',
    ERROR: 'error',
    SAVING: 'saving',
    SAVED: 'saved'
};
const $878360c0a07026f6$export$944e361a93f068b6 = ({ editorActions: editorActions, saveError: saveError, title: title, hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, selectingEmojiTitle: selectingEmojiTitle, selectingCoverPicture: selectingCoverPicture, formatMessage: formatMessage })=>{
    const { isSaving: isSaving, savedTime: savedTime } = (0, $42omo.useContext)((0, $f9dc71ade1ee2d5f$export$9745d8c24b40881d));
    const [status, setStatus] = (0, $42omo.useState)(null);
    const [tooltip, setTooltip] = (0, $42omo.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasSentFeatureExposed = (0, $42omo.useRef)(false);
    const sendFeatureExposed = (0, $42omo.useCallback)(()=>{
        if (!hasSentFeatureExposed.current) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: 'feature',
                    action: 'exposed',
                    source: 'SaveIndicatorTooltip'
                }
            }).fire();
            hasSentFeatureExposed.current = true;
        }
    }, [
        createAnalyticsEvent
    ]);
    // Update save indicator text
    (0, $42omo.useEffect)(()=>{
        if (editorActions?.isDocumentEmpty() && !title && !hasEmoji && !hasCoverPicture) setStatus($878360c0a07026f6$var$STATUSES.DISABLED);
        else if (saveError) setStatus($878360c0a07026f6$var$STATUSES.ERROR);
        else if (isSaving || selectingEmojiTitle || selectingCoverPicture) setStatus($878360c0a07026f6$var$STATUSES.SAVING);
        else setStatus($878360c0a07026f6$var$STATUSES.SAVED);
    }, [
        title,
        hasEmoji,
        hasCoverPicture,
        editorActions,
        saveError,
        isSaving,
        selectingEmojiTitle,
        selectingCoverPicture,
        setStatus
    ]);
    // Update tooltip with last saved timestamp
    const refreshTooltip = (0, $42omo.useCallback)(()=>{
        if (status === $878360c0a07026f6$var$STATUSES.SAVING) setTooltip('');
        else if (status === $878360c0a07026f6$var$STATUSES.ERROR) {
            sendFeatureExposed();
            setTooltip(formatMessage($878360c0a07026f6$var$i18n.errorTooltipMessage, {
                time: (0, $cF2C3.timeFormatter)(savedTime, formatMessage)
            }));
        } else {
            sendFeatureExposed();
            setTooltip(formatMessage($878360c0a07026f6$var$i18n.savedTooltipMessage, {
                time: (0, $cF2C3.timeFormatter)(savedTime, formatMessage)
            }));
        }
    }, [
        status,
        setTooltip,
        sendFeatureExposed,
        formatMessage,
        savedTime
    ]);
    // Responsive save indicator, show icon instead of strings when viewport is small
    const getResponsiveSaveIndicator = (0, $42omo.useCallback)(()=>{
        if (status === $878360c0a07026f6$var$STATUSES.ERROR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
            spacing: "spacious",
            label: "error"
        });
        else if (status === $878360c0a07026f6$var$STATUSES.SAVING) return formatMessage($878360c0a07026f6$var$i18n.savingMessage);
        else if (status === $878360c0a07026f6$var$STATUSES.SAVED) return formatMessage($878360c0a07026f6$var$i18n.allChangesSavedMessage);
    }, [
        status,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        onShow: refreshTooltip,
        content: tooltip,
        testId: "save-indicator-tooltip",
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "save-indicator",
        "aria-label": tooltip,
        tabIndex: 0,
        role: "button",
        paddingInline: "space.050",
        xcss: [
            $878360c0a07026f6$var$saveIndicatorStyles,
            (status === $878360c0a07026f6$var$STATUSES.SAVING || status === $878360c0a07026f6$var$STATUSES.SAVED) && $878360c0a07026f6$var$saveIndicatorTextStyles
        ]
    }, getResponsiveSaveIndicator()));
};


const $785e82a3520d8bdd$var$SaveIndicatorWrapper = ({ editorActions: editorActions, saveError: saveError, title: title })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $ktUCG.EmojiTitleStateContainer),
            (0, $i5zxs.CoverPictureStateContainer)
        ]
    }, (emojiTitleState, coverPictureState)=>{
        const selectingEmojiTitle = emojiTitleState.state.isUpdatingEmoji;
        const selectingCoverPicture = coverPictureState.state.isUploadingPicture || coverPictureState.state.isRemovingPicture || coverPictureState.state.isRepositioningPicture;
        const hasEmoji = !!emojiTitleState.state.selectedEmoji;
        const hasCoverPicture = coverPictureState.state.hasCoverPicture;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $878360c0a07026f6$export$944e361a93f068b6), {
            editorActions: editorActions,
            saveError: saveError,
            title: title,
            hasEmoji: hasEmoji,
            hasCoverPicture: hasCoverPicture,
            selectingEmojiTitle: selectingEmojiTitle,
            selectingCoverPicture: selectingCoverPicture,
            formatMessage: formatMessage
        });
    });
};
const $785e82a3520d8bdd$export$7ceebdb305e167df = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_MODES
})($785e82a3520d8bdd$var$SaveIndicatorWrapper);



var $40pD8 = parcelRequire("40pD8");

parcelRequire("Q2uE4");
var $knzfV = parcelRequire("knzfV");




const $29f7b817e5a3be3c$export$c206229737fbecf5 = (props)=>{
    const { contentClassificationMetadata: contentClassificationMetadata } = props;
    const { hasNoClassification: hasNoClassification, contentLevelLoading: contentLevelLoading } = contentClassificationMetadata;
    const classificationEnabledFinalEvaluation = contentClassificationMetadata?.featureEnabled ?? false;
    return (0, $42omo.useMemo)(()=>{
        if (!classificationEnabledFinalEvaluation) return false;
        if (hasNoClassification) return false;
        if (contentLevelLoading) return false;
        return true;
    }, [
        contentLevelLoading,
        hasNoClassification,
        classificationEnabledFinalEvaluation
    ]);
};


/* EditorClassificationTagWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 









const $ae28c0eef32d4b04$export$1ea7d51d1b0f817f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Y65XF",
    name: "EditorClassificationTagWrapper",
    loader: async ()=>(await (parcelRequire("g5ZRs"))).EditorClassificationTagWrapper,
    loading: (props)=>{
        const { shouldRenderPlaceholder: shouldRenderPlaceholder } = props;
        if (!shouldRenderPlaceholder) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
                ...__cmplp,
                style: __cmpls,
                ref: __cmplr,
                className: (0, $gMc0m.default)([
                    "_4t3i1ou6",
                    __cmplp.className
                ])
            });
        }), {}, '');
    }
});












var $9YwaJ = parcelRequire("9YwaJ");




const $c564822da305b5a7$var$i18n = (0, $cgtv4.defineMessages)({
    requestToEdit: {
        defaultMessage: "Request to edit",
        id: "no-permission.request.to.edit.button.placeholder.label"
    }
});
const $c564822da305b5a7$var$RequestToEditPlaceholder = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
        isDisabled: true
    }, intl.formatMessage($c564822da305b5a7$var$i18n.requestToEdit));
};

const $c564822da305b5a7$export$8d3bd7292e9c1665 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nHgfY",
    name: "RequestToEditLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("d6K5N"))).RequestToEdit,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c564822da305b5a7$var$RequestToEditPlaceholder, null)
});



var $5mJom = parcelRequire("5mJom");


var $26Yfd = parcelRequire("26Yfd");

// Update EDITOR_ACTION_BAR_HEIGHT in EditorDisplayWrapper and EditorHelpCenterComponent and EditorDraftBannerStyles
const $127f29c854fd1c7d$var$editorActionBarWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    position: 'relative',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    justifyContent: 'space-between',
    borderBottomColor: 'color.border',
    borderBottomStyle: 'solid',
    borderBottomWidth: 'border.width',
    minHeight: '36px',
    // editor inline coment sidebar has a zIndex of 501, and editor toolbar has a zIndex of 510, set a slighly higher zIndex would fix overlap issue with popups from inline comments and invite to share popup.
    zIndex: 'flag',
    backgroundColor: 'elevation.surface',
    paddingLeft: 'space.150',
    maxHeight: 'unset',
    alignItems: 'center',
    gap: 'space.025'
});
const $127f29c854fd1c7d$var$hiddenStyles = (0, $ecnYn.xcss)({
    display: 'none'
});
const $127f29c854fd1c7d$var$overflowStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden'
});
const $127f29c854fd1c7d$var$breadcrumbsAndClassificationTagWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    flex: '0 1 auto',
    overflow: 'hidden',
    justifyContent: 'start',
    minWidth: 'fit-content',
    gap: 'space.050',
    [(0, $bWLcG.media).above.xs]: {
        minWidth: '96px'
    }
});
const $127f29c854fd1c7d$var$componentsWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    minWidth: 'fit-content',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexBasis: 'unset',
    marginLeft: 'auto'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $127f29c854fd1c7d$var$VerticalSeparator = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s81cy0 _1kl71uh4 _1e0c1o8l _1bsbt94y _4t3i7vkz",
            __cmplp.className
        ])
    });
});
const $127f29c854fd1c7d$var$ButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2hwx12x7",
            __cmplp.className
        ])
    });
});
const $127f29c854fd1c7d$var$EditorActionBar = ({ spaceKey: spaceKey, editorActions: editorActions, collabEditState: collabEditState, title: title, forceDisabled: forceDisabled, userOffline: userOffline, contentId: contentId, contentType: contentType, isContentCreationPanelOpen: isContentCreationPanelOpen, isUnpublishedDraft: isUnpublishedDraft, onClickPublish: onClickPublish, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, onPreviewClicked: onPreviewClicked, saveDraft: saveDraft, collabLimitReached: collabLimitReached, showRevertDialog: showRevertDialog, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, isPublishingContent: isPublishingContent, isSingleUserSession: isSingleUserSession, navigateOnClose: navigateOnClose, triggerAnalyticsEvent: triggerAnalyticsEvent, shouldRenderPreview: shouldRenderPreview, shouldShowRecentSpotlight: shouldShowRecentSpotlight, checkIfConditionPreventingPublish: checkIfConditionPreventingPublish, flags: flags, hasEditPermission: hasEditPermission, editorDisabled: editorDisabled, isTitleFocused: isTitleFocused, viewMode: viewMode, contentClassificationMetadata: contentClassificationMetadata, isLivePage: isLivePage, requestToEditContent: requestToEditContent, hasRequestedEditPermission: hasRequestedEditPermission, ellipsisEditorActions: ellipsisEditorActions })=>{
    const isDataClassificationEnabledForOrg = contentClassificationMetadata?.featureEnabled ?? false;
    const classificationProps = {
        isDataClassificationEnabledForOrg: isDataClassificationEnabledForOrg,
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType,
        contentClassificationMetadata: contentClassificationMetadata,
        hasEditPermission: hasEditPermission,
        isLivePage: isLivePage,
        userOffline: userOffline
    };
    const shouldRenderClassificationPlaceholder = (0, $29f7b817e5a3be3c$export$c206229737fbecf5)(classificationProps);
    const isCollabNetworkUnreachable = (editorDisabled || collabLimitReached) && !isTitleFocused && !userOffline;
    const hideSaveIndicator = viewMode || isCollabNetworkUnreachable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $127f29c854fd1c7d$var$editorActionBarWrapperStyles,
            shouldRenderPreview && $127f29c854fd1c7d$var$hiddenStyles
        ],
        testId: "editor-action-bar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40pD8.ClassificationModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $knzfV.ClassificationEditModal), {
        contentId: contentId,
        spaceKey: spaceKey,
        contentClassificationMetadata: contentClassificationMetadata
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $127f29c854fd1c7d$var$breadcrumbsAndClassificationTagWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $127f29c854fd1c7d$var$overflowStyles,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgsIj.Breadcrumbs), {
        contentId: contentId,
        spaceKey: spaceKey,
        contentTitle: title ?? undefined,
        testId: "editor-breadcrumbs-container"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ae28c0eef32d4b04$export$1ea7d51d1b0f817f), {
        ...classificationProps,
        shouldRenderPlaceholder: shouldRenderClassificationPlaceholder
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $127f29c854fd1c7d$var$componentsWrapperStyles
    }, !hideSaveIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $785e82a3520d8bdd$export$7ceebdb305e167df), {
        editorActions: editorActions,
        saveError: !!collabEditState.collabEditError || userOffline,
        title: title
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5mJom.ContentHeaderPresenceLoader), {
        contentId: contentId,
        contentType: contentType,
        isViewMode: viewMode,
        analyticSource: "editPageScreen"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($127f29c854fd1c7d$var$VerticalSeparator, null), !hasEditPermission && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($127f29c854fd1c7d$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c564822da305b5a7$export$8d3bd7292e9c1665), {
        contentId: contentId,
        requestToEditContent: requestToEditContent,
        hasRequestedEditPermission: hasRequestedEditPermission
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $02a52aafb1fafdd7$export$170e4ca3217957a2), {
        forceDisabled: forceDisabled,
        userOffline: userOffline,
        contentId: contentId,
        contentType: contentType,
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        isUnpublishedDraft: isUnpublishedDraft,
        onClickPublish: onClickPublish,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        onPreviewClicked: onPreviewClicked,
        saveDraft: saveDraft,
        spaceKey: spaceKey,
        title: title,
        collabLimitReached: collabLimitReached,
        showRevertDialog: showRevertDialog,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        isPublishingContent: isPublishingContent,
        editorActions: editorActions,
        isSingleUserSession: isSingleUserSession,
        navigateOnClose: navigateOnClose,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        shouldRenderPreview: shouldRenderPreview,
        shouldShowRecentSpotlight: shouldShowRecentSpotlight,
        checkIfConditionPreventingPublish: checkIfConditionPreventingPublish,
        flags: flags,
        viewMode: viewMode,
        hasEditPermission: hasEditPermission,
        ellipsisEditorActions: ellipsisEditorActions
    }))));
};
const $127f29c854fd1c7d$var$MemoEditorActionBar = /*#__PURE__*/ (0, $42omo.memo)($127f29c854fd1c7d$var$EditorActionBar);
const $127f29c854fd1c7d$export$97f4d50961f98e6a = (props)=>{
    const showRevertDialog = (0, $26Yfd.useStableCallback)(props.showRevertDialog);
    const onClickPublish = (0, $26Yfd.useStableCallback)(props.onClickPublish);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($127f29c854fd1c7d$var$MemoEditorActionBar, {
        ...props,
        showRevertDialog: showRevertDialog,
        onClickPublish: onClickPublish
    });
};



var $fwwrH = parcelRequire("fwwrH");


var $b8Qzg = parcelRequire("b8Qzg");


var $7QM6o = parcelRequire("7QM6o");





const $98d4df931c17ad78$export$d11bc9a2de7fd8e3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9jK-r",
    name: "BlankPageQuickActions",
    loader: async ()=>(await (parcelRequire("3pvXE"))).BlankPageQuickActions
});






var $hV9Q1 = parcelRequire("hV9Q1");


var $bUiJC = parcelRequire("bUiJC");


var $ixblh = parcelRequire("ixblh");


var $c06us = parcelRequire("c06us");

const $ccf3ae46461db7a4$export$5690797982203811 = ({ spaceKey: spaceKey })=>{
    const [previewHovered, setPreviewHovered] = (0, $42omo.useState)(false);
    const { templates: templates, templateIndex: templateIndex, buttonHovered: buttonHovered } = (0, $c06us.useBlankPageQuickActionsContext)();
    const shouldShowTemplatePreview = buttonHovered || previewHovered;
    const { width: width } = (0, $bUiJC.useEditorWidthObserver)({});
    (0, $42omo.useEffect)(()=>{
        // we need to preload the TemplatePreview
        // component or the rendering will flicker between
        // skeleton & loaded states
        (0, $hV9Q1.TemplatePreview).preload();
    }, []);
    return shouldShowTemplatePreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ixblh.BlankPageQuickActionsTemplatePreviewWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ixblh.BlankPageQuickActionsTemplatePreviewContainer), {
        editorWidth: width,
        shouldShowTemplatePreview: shouldShowTemplatePreview,
        onMouseEnter: ()=>{
            setPreviewHovered(true);
        },
        onMouseLeave: ()=>{
            setPreviewHovered(false);
        },
        "data-testid": "bpqa-full-size-template-preview-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hV9Q1.TemplatePreview), {
        spaceKey: spaceKey,
        templates: templates.map((template)=>({
                name: template.name ?? null,
                contentBlueprintId: template.contentBlueprintId ?? null,
                templateId: template.templateId ?? null,
                blueprintModuleCompleteKey: template.blueprintModuleCompleteKey ?? null,
                itemModuleCompleteKey: template.itemModuleCompleteKey ?? null,
                iconURL: template.iconURL ?? null,
                darkModeIconURL: template.darkModeIconURL,
                styleClass: template.styleClass ?? null
            })),
        currentTemplateIndex: templateIndex,
        numPreviewsToFetchAtOnce: 3
    }))) : null;
};





const $382552a311f1e790$export$fa234c370103664 = ({ collabEditInitialized: collabEditInitialized, contentType: contentType, isEditorEmpty: isEditorEmpty, viewMode: viewMode })=>{
    return contentType === 'page' && !viewMode && collabEditInitialized && isEditorEmpty;
};



var $lG7DR = parcelRequire("lG7DR");


var $bFMG7 = parcelRequire("bFMG7");


var $l2hqi = parcelRequire("l2hqi");


var $liGyh = parcelRequire("liGyh");


var $6tkbf = parcelRequire("6tkbf");








var $cb6fO = parcelRequire("cb6fO");


var $1NBp8 = parcelRequire("1NBp8");







const $5c5c39eb3a311fda$export$5972bbfae42d8829 = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType, title: title, createdDate: createdDate, isUnpublishedDraft: isUnpublishedDraft })=>{
    const titleRef = (0, $42omo.useRef)(title);
    const createdDateRef = (0, $42omo.useRef)(createdDate);
    (0, $42omo.useEffect)(()=>{
        titleRef.current = title;
    }, [
        title
    ]);
    (0, $42omo.useEffect)(()=>{
        createdDateRef.current = createdDate;
    }, [
        createdDate
    ]);
    const getHeadingLinkPath = (0, $42omo.useCallback)(()=>{
        const isUnpublishedPage = contentType === 'page' && isUnpublishedDraft;
        const isUnpublishedBlog = contentType === 'blogpost' && isUnpublishedDraft;
        const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        if (isUnpublishedPage) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: 'pages'
        });
        if (isUnpublishedBlog) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: 'blog'
        });
        if (contentType === 'blogpost' && !createdDateRef.current) return (0, $1NBp8.VIEW_BLOG).toUrl({
            contentId: contentId,
            spaceKey: spaceKey,
            slug: (0, $cb6fO.generateSlug)(titleRef.current)
        });
        if (isCompanyHub && (0, $6mKj3.expVal)('company-hub-edit-heading-anchor-link-create', 'isEnabled', false)) return (0, $1NBp8.COMPANY_HUB).toUrl();
        return (0, $cb6fO.buildContentPath)(spaceKey, contentId, contentType, createdDateRef.current ?? '', (0, $cb6fO.generateSlug)(titleRef.current));
    }, [
        contentId,
        spaceKey,
        contentType,
        isUnpublishedDraft
    ]);
    return {
        getHeadingLinkPath: getHeadingLinkPath
    };
};



var $7f6xB = parcelRequire("7f6xB");


var $fMO7O = parcelRequire("fMO7O");


var $6gbpH = parcelRequire("6gbpH");


var $iKSlH = parcelRequire("iKSlH");







var $1l6y9 = parcelRequire("1l6y9");




var $ewVsQ = parcelRequire("ewVsQ");





const $2442a59098041fb3$export$3633514513e9b8b3 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "5W2r2",
    name: "ConfluenceRecapModalLoadable",
    loader: async ()=>(await (parcelRequire("a3Xby"))).ConfluenceRecapModalErrorBoundary
});



var $kRAnY = parcelRequire("kRAnY");


var $kDhla = parcelRequire("kDhla");

/* PageFooterComments.tsx generated by @compiled/babel-plugin v0.36.1 */ 





parcelRequire("b1pD4");
var $3ACqI = parcelRequire("3ACqI");


var $jTxSS = parcelRequire("jTxSS");





var $l5y3Y = parcelRequire("l5y3Y");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $04e9M = parcelRequire("04e9M");





var $2i3To = parcelRequire("2i3To");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");











var $398ES = parcelRequire("398ES");





var $deTj5 = parcelRequire("deTj5");


var $7zgzO = parcelRequire("7zgzO");


var $hrEV9 = parcelRequire("hrEV9");








var $ftXPY = parcelRequire("ftXPY");







'use no memo';
const $fdbc46c13e75ea1d$var$loadingPageCommentWrapperStyles = null;
const $fdbc46c13e75ea1d$var$pageCommentWrapperStyles = null;
const $fdbc46c13e75ea1d$var$pageCommentStyle = null;
const $fdbc46c13e75ea1d$var$pageCommentWiderStyles = null;
const $fdbc46c13e75ea1d$var$pageCommentAbsoluteWrapperStyles = null;
const $fdbc46c13e75ea1d$var$PageCommentAbsoluteWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testId": "page-comment-absolute-wrapper",
        className: (0, $gMc0m.default)([
            "_kqswstnw _1ltvidpf _1bsbkest"
        ])
    }, children);
const $fdbc46c13e75ea1d$var$sendKeyboardShortcutAnalytics = ({ source: source, shortcut: shortcut })=>{
    let pageMode;
    if (source === (0, $cD1qu.PageMode).VIEW) pageMode = 'viewPage';
    else if (source === (0, $cD1qu.PageMode).LIVE) pageMode = 'livePages';
    (0, $04e9M.getAnalyticsWebClient)().then((analyticsClient)=>{
        analyticsClient.sendUIEvent({
            source: pageMode,
            action: 'pressed',
            actionSubject: 'keyboardShortcut',
            actionSubjectId: 'createComment',
            attributes: {
                key: shortcut
            }
        });
    });
}; /**
    * @deprecated This component is deprecated and will be removed in a future version.
    * It is used to render legacy page comments but is no longer needed as part of modernization.
    */ 
const $fdbc46c13e75ea1d$var$LazyLoadablePageComments = ({ children: children, shouldLazyLoad: shouldLazyLoad, renderPlaceholder: renderPlaceholder, loadPageCommentsCallback: loadPageCommentsCallback, isCommentsReady: isCommentsReady })=>{
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const wrapperRef = (0, $42omo.useRef)(null);
    const observerRef = (0, $42omo.useRef)(null);
    const [commentSectionTop, setCommentSectionTop] = (0, $42omo.useState)(undefined); // load comments immediately if not lazy load, otherwise wait until it is in the viewport
    const [loadPageComments, setLoadPageComments] = (0, $42omo.useState)(!shouldLazyLoad);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    (0, $42omo.useEffect)(()=>{
        const editorTextArea = document.getElementById('ak-editor-textarea');
        if (editorTextArea) {
            // Create a ResizeObserver to watch for size changes
            const resizeObserver = new ResizeObserver((entries)=>{
                if ((0, $9wGTI.fg)('confluence_footer_comment_styling_change')) {
                    const newTop = (0, $aHcFH.getCommentPositionTopOfSectionEditor)(entries); // Warning temporary to unblock modernisation release (see COMMENTS-3668)
                    (0, $jTxSS.flushSync)(()=>{
                        newTop && setCommentSectionTop(newTop);
                    });
                }
            }); // Start observing the editorTextArea and documentContent for size changes
            resizeObserver.observe(editorTextArea); // Cleanup function to disconnect the observer on unmount
            return ()=>resizeObserver.disconnect();
        }
    }, []);
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line no-restricted-syntax
        observerRef.current = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) {
                // show page comments when the wrapper is in viewport
                setLoadPageComments(true);
                observerRef.current?.disconnect();
            }
        }); // Remove the observer as soon as the component is unmounted
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (wrapperRef.current && !loadPageComments) // attach intersection observer after content is ready
        observerRef.current?.observe(wrapperRef.current);
    }, [
        loadPageComments
    ]);
    (0, $42omo.useEffect)(()=>{
        if (loadPageComments) loadPageCommentsCallback?.();
    }, [
        loadPageComments,
        loadPageCommentsCallback
    ]); // render placeholder only in SSR
    const shouldRenderPageComments = loadPageComments;
    const PositioningWrapper = (0, $9wGTI.fg)('confluence_frontend_general_comments_styles') ? $fdbc46c13e75ea1d$var$PageCommentAbsoluteWrapper : (0, $42omo.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, (0, $9wGTI.fg)('confluence_frontend_general_comments_styles') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: wrapperRef,
        className: (0, $gMc0m.default)([
            !isCommentsReady && "_1yt4pxbi _1e0c1txw _1bsb1wug _1bah1h6o _n3tdv47k _kqswstnw _94n5idpf _1pbyjwwv"
        ])
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PositioningWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testId": "page-comment-wrapper",
        ...(0, $9wGTI.fg)('confluence_frontend_general_comments_styles') ? {} : {
            ref: wrapperRef
        },
        style: {
            visibility: isCommentsReady ? 'visible' : 'hidden',
            top: isCommentsReady ? commentSectionTop : undefined
        },
        className: (0, $gMc0m.default)([
            (0, $9wGTI.fg)('confluence_frontend_general_comments_styles') && "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1w8u _p12f2q5v _1ul9e0nm",
            isCommentsReady ? "_kqswh2mm _1pbyjwwv _1e0c1txw _1bah1h6o" : "_1yt4pxbi _1e0c1txw _1bsb1wug _1bah1h6o _n3tdv47k _kqswstnw _94n5idpf _1pbyjwwv"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
        listener: (e)=>{
            e.preventDefault();
            if (document.querySelector('[data-testid="editor-floating-toolbar"]')) return;
            if (!isCommentsReady) {
                setQueryParams({
                    showCommentArea: 'true'
                }); //This will scroll to and load the page comments section if its not available (e.g. on long pages)
                wrapperRef.current?.scrollIntoView && wrapperRef.current?.scrollIntoView({
                    block: 'end',
                    behavior: 'smooth'
                });
            } else window.dispatchEvent(new Event('openPageCommentEditor'));
            $fdbc46c13e75ea1d$var$sendKeyboardShortcutAnalytics({
                source: pageMode,
                shortcut: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR)
            });
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _19pkn7od _2hwxn7od _otyrn7od _18u0n7od _11rm1hrf _1bsb1osq _2lx21bp4 _1e0c1txw _1bah1yb4 _4cvr1y6m _p12fn7od _1ul9118a"
        ])
    }, shouldRenderPageComments ? children : renderPlaceholder?.()))));
};
const $fdbc46c13e75ea1d$var$PageFooterCommentsComponent = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, loadingPriority: loadingPriority })=>{
    /* Preload CommentsSectionQuery - We preload CommentsSectionQuery as part of next/packages/query-preloaders/src/index.ts,
     but its bestEffort Preloading - meaning if it exceeds the threshold it wont wait for query to finish
     Adding preloading here as well to ensure data is ready once user scrolls*/ const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const { error: error } = (0, $xQxzY.useQuery)(isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery), {
        variables: {
            contentId: contentId,
            offset: '',
            first: (0, $2i3To.DEFAULT_LIMIT)
        },
        fetchPolicy: 'cache-and-network',
        skip: !contentId
    }); /*  Marking all graphql errors here as handled since we are only preloading query. The CommentsSectionFabric component
         where the query data is used has exhaustive error handling*/ 
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { focusedCommentId: focusedCommentId, replyToComment: replyToComment, showCommentArea: showCommentArea, editComment: editComment, commentId: commentId } = getQueryParams(); /* check for query params - If anyone of these are true just load Page comments */ 
    const isFocusedComment = Boolean(focusedCommentId || replyToComment || showCommentArea || editComment === 'true' && commentId);
    const [isCommentsReady, setIsCommentsReady] = (0, $42omo.useState)(false);
    const startExperienceTracker = (0, $42omo.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
            attributes: {
                isConditionalRenderingOn: true,
                isFocusedComment: isFocusedComment,
                editor: 'FABRIC',
                contentId: contentId
            }
        });
    }, [
        experienceTracker,
        isFocusedComment,
        contentId
    ]); // Display comment Placeholder
    const renderCommentPlaceholder = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deTj5.CommentPlaceholder), {
            showPlaceholder: true
        });
    };
    const windowHeight = window.innerHeight;
    const editorProseMirrorHeight = document.querySelector('.ak-editor-content-area .ProseMirror')?.scrollHeight || 0;
    const contentHeight = editorProseMirrorHeight / windowHeight; // The placeholder isn't in view if the content takes up more than 30% and less than 2% of the screen
    const shouldRenderPlaceholder = contentHeight < 0.3 && contentHeight > 0.02;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fdbc46c13e75ea1d$var$LazyLoadablePageComments, {
        shouldLazyLoad: !isFocusedComment,
        renderPlaceholder: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        shouldRenderPlaceholder ? renderCommentPlaceholder : undefined,
        loadPageCommentsCallback: startExperienceTracker,
        isCommentsReady: isCommentsReady
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, // Important! Here, the renderCommentPlaceholder() must match the renderPlaceholder
    // in LazyLoadPageComments to ensure the initial hydration matches the SSR render result
    !isCommentsReady && !isLivePage && renderCommentPlaceholder(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hrEV9.CommentsSectionLoader), {
        contentId: contentId,
        classicComments: (0, $3ACqI.CommentsSectionLoader),
        handlePageCommentsRender: ()=>setIsCommentsReady(true),
        loadingPriority: loadingPriority || (0, $398ES.LoadingPriority).PAINT
    })));
});
const $fdbc46c13e75ea1d$export$f9d737bcf2a1ec12 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COLLABORATION
})($fdbc46c13e75ea1d$var$PageFooterCommentsComponent);






const $4f7d3262c48387ee$export$c0bc8bbccc993b75 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "tsrw0",
    name: "PublishModalKeyboardShortcuts",
    loader: async ()=>{
        return (await (parcelRequire("6XpHo"))).PublishModalKeyboardShortcuts;
    }
});






const $73d7c23c9a6a572e$export$b112826b6cf719c1 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "XmBDy",
    name: "PublishModalMountPoint",
    loader: async ()=>{
        return (await (parcelRequire("5D6c6"))).PublishModalMountPoint;
    }
});



var $1N2OF = parcelRequire("1N2OF");


var $6pob4 = parcelRequire("6pob4");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");





var $fT4aa = parcelRequire("fT4aa");


var $jFkNO = parcelRequire("jFkNO");


var $cZa7r = parcelRequire("cZa7r");





var $bK3oZ = parcelRequire("bK3oZ");

/* ImproveWritingFlag.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $eXmBZ = parcelRequire("eXmBZ");





var $dpPtd = parcelRequire("dpPtd");




const $f886df47871fea69$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    title: {
        id: "experiment-improve-writing-on-paste.improve-writing-flag.title",
        defaultMessage: "Use AI by highlighting text"
    },
    description: {
        id: "experiment-improve-writing-on-paste.improve-writing-flag.description",
        defaultMessage: "Edit with AI by highlighting text on the page and selecting Improve writing."
    }
});
const $f886df47871fea69$export$ec786ad9cda0533d = ({ editorAPI: editorAPI })=>{
    const [flagShownFirstPaste, setFlagShownFirstPaste] = (0, $42omo.useState)(false);
    const [flagShownSecondPaste, setFlagShownSecondPaste] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const [promptAction, setPromptAction] = (0, $42omo.useState)(null); // Listen to the AI prompt action plugin state
    // `aiPromptActionCompleted` is part of AIPlugin EditorPluginAISharedState
    const { actionSource: actionSource, actionType: actionType, prompt: prompt } = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPI, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>{
        return {
            actionSource: aiExperienceState?.aiPromptActionCompleted?.actionSource,
            actionType: aiExperienceState?.aiPromptActionCompleted?.actionType,
            prompt: aiExperienceState?.aiPromptActionCompleted?.prompt
        };
    });
    // Update state when plugin state changes to display flag
    (0, $42omo.useEffect)(()=>{
        if (actionType && prompt === 'improve-writing') setPromptAction({
            actionSource: actionSource,
            actionType: actionType,
            prompt: prompt
        });
    }, [
        actionSource,
        actionType,
        prompt
    ]);
    if (promptAction && (!flagShownFirstPaste || !flagShownSecondPaste && promptAction.actionType === 'second-paste')) {
        if (promptAction.actionType === 'second-paste') setFlagShownSecondPaste(true);
         // edge case: first paste occurs without a flag trigger (ex: navigate away before finishing experience)
        //   -> second paste causes infinite display of first paste flag
        // to prevent this, we always setFlagShownFirstPaste -> true
        setFlagShownFirstPaste(true);
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                action: 'viewed',
                name: 'improveWritingFlag',
                attributes: {
                    actionSource: promptAction?.actionSource,
                    actionType: promptAction?.actionType,
                    prompt: promptAction?.prompt,
                    source: 'improveWritingOnPaste'
                }
            }
        }).fire();
        showFlag({
            id: 'improve-writing-flag',
            title: $f886df47871fea69$export$a7357cdd1f0b0168.title.defaultMessage,
            description: $f886df47871fea69$export$a7357cdd1f0b0168.description.defaultMessage,
            appearance: 'normal',
            icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                label: "Info",
                color: "var(--ds-icon-information, #357DE8)"
            }),
            onDismissed: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'improveWritingFlag',
                        source: 'improveWritingOnPaste',
                        attributes: {
                            actionSource: promptAction?.actionSource,
                            actionType: promptAction?.actionType,
                            prompt: promptAction?.prompt,
                            buttonType: 'dismissButton'
                        }
                    }
                }).fire();
            }
        });
    }
    return null;
};
const $f886df47871fea69$export$29f4298e129f4360 = ({ editorAPI: editorAPI })=>{
    return /*#__PURE__*/ $42omo.createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ $42omo.createElement($f886df47871fea69$export$ec786ad9cda0533d, {
        editorAPI: editorAPI
    }));
};



var $essql = parcelRequire("essql");


var $7oCdN = parcelRequire("7oCdN");


var $88Nzy = parcelRequire("88Nzy");


var $dA1Sn = parcelRequire("dA1Sn");


var $8HrX3 = parcelRequire("8HrX3");





var $fWGpT = parcelRequire("fWGpT");


var $5Za2S = parcelRequire("5Za2S");


var $j7xMJ = parcelRequire("j7xMJ");


var $cLo2u = parcelRequire("cLo2u");


var $39rFu = parcelRequire("39rFu");


var $2VZOl = parcelRequire("2VZOl");





var $8KbKw = parcelRequire("8KbKw");

var $1sAC2 = parcelRequire("1sAC2");


var $9sGCn = parcelRequire("9sGCn");


var $ek3aD = parcelRequire("ek3aD");











var $iUV81 = parcelRequire("iUV81");


var $7PuC4 = parcelRequire("7PuC4");






















var $2ZJmt = parcelRequire("2ZJmt");





var $9ohnn = parcelRequire("9ohnn");


var $16o3K = parcelRequire("16o3K");





var $dTb09 = parcelRequire("dTb09");







const $c907e804706c3ad7$export$34125ddc34657a7f = (0, $dTb09.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('platform_editor_ai_aifc_streaming'), (api)=>{
    const aiIsStreaming = (0, $b3YrF.useSharedPluginStateSelector)(api, 'aiExperience.isStreaming', {
        disabled: !api
    }) ?? false;
    return {
        aiIsStreaming: aiIsStreaming
    };
}, (_api)=>{
    return {
        aiIsStreaming: false
    };
});


const $f8ea506e3a40865e$var$i18n = (0, $cgtv4.defineMessages)({
    lockoutMessage: {
        id: "full-page-editor.navigation-lockout-message",
        defaultMessage: "Changes made just now may not be saved."
    }
});
const $f8ea506e3a40865e$var$DEBOUNCE_TIMEOUT = 1000;
const $f8ea506e3a40865e$export$d85ed874af6294e9 = ({ contentId: contentId, isPublishingContent: isPublishingContent, isFirstParticipant: isFirstParticipant, editorPresetAPI: editorPresetAPI })=>{
    const [unsavedChanges, setUnsavedChanges] = (0, $42omo.useState)(false);
    const [{ isDraftSyncPending: isDraftSyncPending }] = (0, $hYoU4.useNativeCollabDraftSync)();
    const [{ collabEditProvider: collabEditProvider, collabEditInitialized: collabEditInitialized }] = (0, $hYoU4.useNativeCollabState)();
    const { hasEditorContentChangedByAnyUser: hasEditorContentChangedByAnyUser } = (0, $16o3K.useHasEditorContentChanged)({
        editorPresetAPI: editorPresetAPI
    });
    const { isCollabProviderConnected: isCollabProviderConnected } = (0, $9ohnn.useConnected)(collabEditProvider, contentId);
    /**
   * - Draft sync is handled by first participant, so leaving should not be prevented for subsequent participants
   * - Publishing is an exception because it handles syncing on its own before transition
   * - The editor content has to have changed for unsaved changes to exist
   */ const isExceptionConditionMet = !isFirstParticipant || isPublishingContent || !hasEditorContentChangedByAnyUser;
    const checkCollabProviderSteps = (0, $42omo.useCallback)(({ status: status })=>{
        if (!collabEditProvider || !collabEditInitialized) {
            setUnsavedChanges(false);
            return;
        }
        if (status === 'attempt' || status === 'success') {
            const unconfirmedSteps = collabEditProvider.getUnconfirmedSteps();
            setUnsavedChanges(!!(unconfirmedSteps && unconfirmedSteps.length > 0));
        } else // implies status === "failure"
        setUnsavedChanges(true);
    }, [
        collabEditProvider,
        collabEditInitialized
    ]);
    const debouncedCheckCollabProviderSteps = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(checkCollabProviderSteps, $f8ea506e3a40865e$var$DEBOUNCE_TIMEOUT), [
        checkCollabProviderSteps
    ]);
    // Collab provider commit listener
    (0, $42omo.useEffect)(()=>{
        if (isExceptionConditionMet || !collabEditProvider || !collabEditInitialized) {
            setUnsavedChanges(false);
            return;
        }
        collabEditProvider.on('commit-status', debouncedCheckCollabProviderSteps);
        return ()=>{
            collabEditProvider.off('commit-status', debouncedCheckCollabProviderSteps);
        };
    }, [
        collabEditProvider,
        collabEditInitialized,
        isExceptionConditionMet,
        debouncedCheckCollabProviderSteps
    ]);
    const [hasOfflineConflicts, setHasOfflineConflicts] = (0, $42omo.useState)(false);
    (0, $6qdjm.usePluginStateEffect)(editorPresetAPI, [
        'collabEdit',
        'connectivity',
        'conflictResolutionUI'
    ], ({ collabEditState: collabEditState, connectivityState: connectivityState, conflictResolutionUIState: conflictResolutionUIState })=>{
        if (!isCollabProviderConnected && !!collabEditState?.initialised?.lastLocalOrganicBodyChangeAt) setUnsavedChanges(!!collabEditProvider?.getUnconfirmedSteps()?.length);
        if (connectivityState?.mode === 'offline') setUnsavedChanges(!!collabEditProvider?.getUnconfirmedSteps()?.length);
        if ((0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)) {
            const hasConflicts = conflictResolutionUIState?.conflicts && (conflictResolutionUIState?.conflicts.inserted?.length > 0 || conflictResolutionUIState?.conflicts.deleted?.length > 0);
            if (hasConflicts) setHasOfflineConflicts(true);
            else if (hasOfflineConflicts && !hasConflicts) setHasOfflineConflicts(false);
        }
    });
    const { aiIsStreaming: aiIsStreaming } = (0, $c907e804706c3ad7$export$34125ddc34657a7f)(editorPresetAPI);
    /*
   * unsavedChanges is an internal state controlled by listening to collab provider commmit events while isDraftSyncPending is a separate state controlled by draft sync hooks
   */ const shouldRenderLockout = unsavedChanges || isDraftSyncPending;
    return !isExceptionConditionMet && shouldRenderLockout || hasOfflineConflicts || aiIsStreaming;
};
const $f8ea506e3a40865e$export$28f25e906763db1e = ({ contentId: contentId, isPublishingContent: isPublishingContent, isFirstParticipant: isFirstParticipant, editorPresetAPI: editorPresetAPI })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // TODO do we want this in the hook or in this component?
    (0, $42omo.useEffect)(()=>{
        const deferIdle = (cb)=>{
            if ('requestIdleCallback' in window) requestIdleCallback(cb, {
                timeout: 5000
            });
            else requestAnimationFrame(cb);
        };
        // force load of NavigationLockout on idle so it's available if the
        // connection goes offline
        deferIdle(()=>{
            (0, $2ZJmt.NavigationLockout).preload();
        });
    }, []);
    const hasUnsavedChanges = $f8ea506e3a40865e$export$d85ed874af6294e9({
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        isFirstParticipant: isFirstParticipant,
        editorPresetAPI: editorPresetAPI
    });
    const isSeamlessTransition = (transitionCallbackIds)=>{
        return (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') ? transitionCallbackIds.includes('live_doc_preloading_transition_callback_id') : false;
    };
    /**
   * We do not want to trigger the lockout if the upcoming location is the same route with the same contentId
   * If the above conditions are true, the user is still editing the page, but the url has changed
   * Which implies the user is not exiting the editor, so we shouldn't block navigation.
   */ const isSameRoute = (currentRoute, nextRoute)=>{
        const contentIdMatch = 'contentId' in nextRoute.params && nextRoute.params['contentId'] === contentId;
        const routeNameMatch = currentRoute.name === nextRoute.name;
        return contentIdMatch && routeNameMatch;
    };
    const isSafeTransition = ({ currentRoute: currentRoute, nextRoute: nextRoute, transitionCallbackIds: transitionCallbackIds })=>{
        return isSameRoute(currentRoute, nextRoute) || transitionCallbackIds && transitionCallbackIds.length > 0 && isSeamlessTransition(transitionCallbackIds);
    };
    return hasUnsavedChanges ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZJmt.NavigationLockout), {
        message: intl.formatMessage($f8ea506e3a40865e$var$i18n.lockoutMessage),
        isSafeTransition: isSafeTransition,
        onActivate: (message, currentRoute, nextRoute)=>{
            // message===true tells react-router not to block the transition.
            // We only want to fire an event when a transition was blocked, so we make sure message !== true
            if (message !== true) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: 'navigationLockoutPrompt',
                    action: 'shown',
                    source: 'NavigationLockout',
                    attributes: {
                        nextRoute: nextRoute?.name ?? '',
                        currentRoute: currentRoute?.name ?? '',
                        contentId: contentId
                    }
                }
            }).fire();
        }
    }) : null;
};


const $d2e739e403a90913$export$1da4922e40f79365 = ({ contentId: contentId, collabEditProvider: collabEditProvider, isPublishingContent: isPublishingContent, isFirstParticipant: isFirstParticipant, editorPresetAPI: editorPresetAPI, isLivePage: isLivePage, hasEditPermission: hasEditPermission, isFastLoadedLiveDoc: isFastLoadedLiveDoc })=>{
    const hasUnsavedChanges = (0, $f8ea506e3a40865e$export$d85ed874af6294e9)({
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        isFirstParticipant: isFirstParticipant,
        editorPresetAPI: editorPresetAPI
    });
    // Create a promise that resolves when we're no longer waiting for unsaved changes. The latest promise will always be used by the transition callback when it's invoked, to ensure we don't transition until there are no unsaved changes.
    const isWaitingForUnsavedChangesPromiseResolveRef = (0, $42omo.useRef)(null);
    const isWaitingForUnsavedChangesPromiseRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        // Resolve the promise once hasUnsavedChanges is false if it didn't immediately resolve
        if (!hasUnsavedChanges && isWaitingForUnsavedChangesPromiseResolveRef.current) {
            isWaitingForUnsavedChangesPromiseResolveRef.current();
            isWaitingForUnsavedChangesPromiseResolveRef.current = null;
        }
    }, [
        hasUnsavedChanges
    ]);
    if (!isWaitingForUnsavedChangesPromiseRef.current) isWaitingForUnsavedChangesPromiseRef.current = new Promise((resolve)=>{
        if (!hasUnsavedChanges) resolve();
        else isWaitingForUnsavedChangesPromiseResolveRef.current = resolve;
    });
    const { client: fetchUsersClient } = (0, $j7xMJ.useFetchUsersClient)();
    const { setCollabEditProvider: setCollabEditProvider, setHasInitialDraft: setHasInitialDraft, resetNativeCollabState: resetNativeCollabState } = (0, $hYoU4.useNativeCollabActions)();
    const { nativeEditorComponentsPreloader: nativeEditorComponentsPreloader } = (0, $39rFu.useEditPageLoadingActions)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const [{ presenceId: presenceId }] = (0, $2VZOl.useNativeCollabPresenceState)();
    const presenceIdRef = (0, $42omo.useRef)(presenceId);
    presenceIdRef.current = presenceId;
    const [isTransitionPreloading, setIsTransitionPreloading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!isLivePage || !(0, $9wGTI.fg)('confluence_frontend_transition_preloading_system')) return;
        (0, $ek3aD.getGlobalTransitionPreloader)().registerTransitionCallback({
            id: 'live_doc_preloading_transition_callback_id',
            callback: ({ match: match })=>new Promise(async (resolve)=>{
                    setIsTransitionPreloading(true);
                    try {
                        if (match?.params?.contentId) {
                            // TODO When updating this preloading callback to run on non-livedoc routes as we transition into a live doc:
                            //      Also preload the live doc components. Reference how LivePagePreloader.tsx does this
                            // We destroy collab provider as early as possible to reduce the risk of rare race conditions where
                            //    we end up on a different page than expected after awaiting below promises, and then problematically destroy collab edit provider
                            if (collabEditProvider) {
                                collabEditProvider?.destroy?.();
                                // Clear the memoized function. If the user goes back to editing the same page,
                                // then we don't run into problem trying to talk to the old (destroyed) collab provider.
                                if ((0, $fWGpT.getCollabEditProvider)?.cache?.clear) (0, $fWGpT.getCollabEditProvider).cache.clear();
                            }
                            resetNativeCollabState();
                            (0, $1sAC2.nativeCollabPermissionsTokenState).clearPermissionsTokenState(contentId);
                            const preloadLivePageRoutePromise = (0, $iUV81.preloadLivePageRoute)(match, match.url);
                            await Promise.all([
                                preloadLivePageRoutePromise,
                                nativeEditorComponentsPreloader()
                            ]);
                            // Ensure we're not waiting for unsaved changes before unblocking transition
                            if (isWaitingForUnsavedChangesPromiseRef.current) await isWaitingForUnsavedChangesPromiseRef.current;
                        }
                    } catch (err) {
                        (0, $7W8i8.getLogger)('useLiveDocTransitionCallback').error`Error preloading live doc: ${err}`;
                    }
                    setIsTransitionPreloading(false);
                    resolve();
                }),
            onlyCalledIfFunc: ({ match: match })=>{
                // Don't seamlessly transition if the current live doc is not fast loaded, as non-fast-loaded -> fast-loaded live docs
                //   trigger a remount that breaks NCS on seamless transition
                if (match?.params?.contentId && isFastLoadedLiveDoc) {
                    const { subType: subType } = (0, $9sGCn.getCachedPageData)(match.params.contentId);
                    if (subType === 'live') return true;
                }
                return false;
            },
            onPerformanceMetricStart: ({ match: match })=>{
                if (match?.params?.contentId) (0, $7PuC4.startLivePageLoadMetrics)({
                    userId: userId ?? undefined
                });
            },
            onRouteContinueCallback: ({ match: match })=>new Promise(async (resolve)=>{
                    const nextContentId = match?.params?.contentId;
                    const { subType: subType } = (0, $9sGCn.getCachedPageData)(nextContentId);
                    if (subType !== 'live') return;
                    const draft = await (0, $5Za2S.getDraft)(nextContentId); // This is performant as it's already cached because our callback promise retrieved CollabDraftQuery in `preloadLivePageRoute`
                    const ncsProvider = (0, $fWGpT.getCollabEditProvider)({
                        contentId: nextContentId,
                        cloudId: cloudId,
                        contentType: 'page',
                        permissionTokenRefresh: (0, $8KbKw.fetchCollabPermissionToken)(nextContentId, undefined),
                        initialDraft: draft,
                        isLivePage: true,
                        presenceId: presenceIdRef.current,
                        presenceActivity: hasEditPermission ? 'editor' : 'viewer',
                        userId: userId,
                        fetchUsersClient: fetchUsersClient
                    });
                    setCollabEditProvider(ncsProvider);
                    // @ts-ignore
                    const hasInitialDraft = Boolean(ncsProvider?.initialDraft);
                    setHasInitialDraft(hasInitialDraft);
                    resolve();
                })
        });
    }, [
        contentId,
        isLivePage,
        collabEditProvider,
        setCollabEditProvider,
        setHasInitialDraft,
        cloudId,
        nativeEditorComponentsPreloader,
        spaceKey,
        userId,
        hasEditPermission,
        presenceIdRef,
        fetchUsersClient,
        resetNativeCollabState,
        isFastLoadedLiveDoc
    ]);
    return {
        isTransitionPreloading: isTransitionPreloading
    };
};






var $fthpM = parcelRequire("fthpM");








var $1JdaQ = parcelRequire("1JdaQ");


var $7541v = parcelRequire("7541v");









var $9uAPw = parcelRequire("9uAPw");




const $04e4e4b928c4520b$export$9ac42f814ec8d6c6 = ({ mentionChanges: mentionChanges, deletedMentions: deletedMentions, addedMentions: addedMentions, setDeletedMentions: setDeletedMentions, setAddedMentions: setAddedMentions, userId: userId, unrestrictedMentions: unrestrictedMentions, parentSpaceRestrictedMentions: parentSpaceRestrictedMentions, pageRestrictedMentions: pageRestrictedMentions, unrestrictedTasks: unrestrictedTasks, addedTasks: addedTasks, deletedTasks: deletedTasks, setAddedTasks: setAddedTasks, setDeletedTasks: setDeletedTasks, pageRestrictedTasks: pageRestrictedTasks, parentSpaceRestrictedTasks: parentSpaceRestrictedTasks, setMentionsAdded: setMentionsAdded, setTasksAdded: setTasksAdded })=>{
    // Process added mentions first
    const addedMentionsExcludingCurrentUser = [];
    const addedTasksExcludingCurrentUser = [];
    const currentUserAddedMentions = []; // user mentioned themselves
    const currentUserAddedTasks = [];
    mentionChanges.forEach((mentionChange)=>{
        // we add user mentioning themselves so that we let backend know not to notify them
        if (mentionChange.id === userId) {
            if (mentionChange.type === 'added') {
                if (mentionChange?.taskLocalId) currentUserAddedTasks.push(mentionChange);
                else currentUserAddedMentions.push(mentionChange);
            }
        } else if (mentionChange.type === 'added') {
            if (mentionChange?.taskLocalId) addedTasksExcludingCurrentUser.push(mentionChange);
            else addedMentionsExcludingCurrentUser.push(mentionChange);
        }
    });
    if (currentUserAddedMentions.length > 0) setMentionsAdded({
        currentUser: currentUserAddedMentions
    });
    if (currentUserAddedTasks.length > 0) setTasksAdded({
        currentUser: currentUserAddedTasks
    });
    const currentAndNewAddedMentions = [
        ...addedMentions,
        ...addedMentionsExcludingCurrentUser
    ];
    const currentAndNewAddedTasks = [
        ...addedTasks,
        ...addedTasksExcludingCurrentUser
    ];
    if (addedMentionsExcludingCurrentUser.length > 0) setAddedMentions(currentAndNewAddedMentions);
    if (addedTasksExcludingCurrentUser.length > 0) setAddedTasks(currentAndNewAddedTasks);
    const currentAddedMentionsLocalIds = new Set([
        ...unrestrictedMentions.map((mention)=>mention.localId),
        ...parentSpaceRestrictedMentions.map((mention)=>mention.localId),
        ...pageRestrictedMentions.map((mention)=>mention.localId)
    ]);
    const currentAddedTasksLocalIds = new Set([
        ...unrestrictedTasks.map((mention)=>mention.localId),
        ...parentSpaceRestrictedTasks.map((mention)=>mention.localId),
        ...pageRestrictedTasks.map((mention)=>mention.localId)
    ]);
    // Process deleted mentions next, but only if they exist in the added mentions
    const validDeletedMentions = [];
    const validDeletedTasks = [];
    mentionChanges.forEach((mentionChange)=>{
        if (mentionChange.id !== userId) {
            if (mentionChange.type === 'deleted') {
                if (currentAddedMentionsLocalIds.has(mentionChange.localId)) validDeletedMentions.push(mentionChange);
                else if (currentAddedTasksLocalIds.has(mentionChange.localId)) validDeletedTasks.push(mentionChange);
            }
        }
    });
    if (validDeletedMentions.length > 0) setDeletedMentions([
        ...deletedMentions,
        ...validDeletedMentions
    ]);
    if (validDeletedTasks.length > 0) setDeletedTasks([
        ...deletedTasks,
        ...validDeletedTasks
    ]);
};









var $9Zt9E = parcelRequire("9Zt9E");


var $3GtBN = parcelRequire("3GtBN");


var $ijGoX = parcelRequire("ijGoX");


var $bDgLc = parcelRequire("bDgLc");








var $yuV6Z = parcelRequire("yuV6Z");










function $78d13d0c9995dbf8$export$7274b8e5fdf0c8bf() {
    const { userId: userId, cloudId: cloudId, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    // We need a special emoji parameters that supports SSR load optimization here.
    const emojiResourceParams = (0, $42omo.useMemo)(()=>{
        return (0, $yuV6Z.createEmojiProviderParameters)({
            cloudId: cloudId,
            userId: userId,
            isLicensed: isLicensed,
            isLoggedIn: isLoggedIn
        });
    }, [
        cloudId,
        userId,
        isLicensed,
        isLoggedIn
    ]);
    if (!(0, $6mKj3.expVal)('platform_editor_emoji_otp', 'isEnabled', false)) return undefined;
    const emojiNodeDataProvider = (0, $32x2E.getEmojiNodeDataProvider)((0, $ibzAc.default), {
        ...emojiResourceParams,
        allowAnonymousAccess: true
    });
    if (emojiNodeDataProvider) {
        const ssrProvidersData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
        const ssrData = ssrProvidersData['emojiNodeDataProvider'];
        emojiNodeDataProvider.setSSRData(ssrData);
    }
    return emojiNodeDataProvider;
}






var $8L9Ex = parcelRequire("8L9Ex");







/* useEditorToolbarExtensions.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $jdPfT = parcelRequire("jdPfT");


var $gj7hi = parcelRequire("gj7hi");


var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");


var $9fBoq = parcelRequire("9fBoq");


var $eSLr0 = parcelRequire("eSLr0");


var $6ld6a = parcelRequire("6ld6a");


var $2Awp2 = parcelRequire("2Awp2");

/* ForgeEditorAction.tsx generated by @compiled/babel-plugin v0.36.1 */ 























var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");





var $ep3mz = parcelRequire("ep3mz");


var $6uUjl = parcelRequire("6uUjl");


var $lsxnT = parcelRequire("lsxnT");










// I'm optimizing for single byline as most instances have an average of 2 - 3 apps in the byline and shouldn't be multiline
const $b54e9ea534ca36ea$var$PAGE_PADDING_TOP = 135; // Rough estimate for cover picture avg height - doesn't need to be exact since the popup will float in editor
const $b54e9ea534ca36ea$var$COVER_PICTURE_PADDING_TOP = 275;
const $b54e9ea534ca36ea$var$popupWrapperStyle = (0, $ecnYn.xcss)({
    padding: 'space.250',
    maxWidth: '500px',
    maxHeight: '500px'
});
const $b54e9ea534ca36ea$var$triggerStyles = null;
const $b54e9ea534ca36ea$export$8b1e2d0f3ad73269 = ({ contentId: contentId, forgeExtension: forgeExtension, onClose: onClose, selection: selection })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleInitialRender = ()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'editorActionsToolbarMenu',
                action: 'shown',
                actionSubject: 'forgeApp',
                actionSubjectId: 'editorActionsMenuForgeApp',
                attributes: {
                    contentId: contentId,
                    isLivePage: isLivePage,
                    appInfo: {
                        id: forgeExtension?.id,
                        appId: forgeExtension?.appId,
                        key: forgeExtension?.key,
                        appVersion: forgeExtension?.appVersion,
                        appOwner: forgeExtension?.appOwner
                    }
                }
            }
        }).fire();
    };
    // Bridge needs to be memoised here.
    // Otherwise the useMemo hook in NativeUIRenderer will trigger an infinite rerender loop on ContextMenuForgeApp when using the Frame component.
    const memoedBridge = (0, $42omo.useMemo)(()=>({
            onClose: onClose,
            ...(0, $9wGTI.fg)('forge-ui-fix-bridge-close-method') ? {
                close: onClose
            } : {}
        }), [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $i5zxs.CoverPictureStateContainer)
        ]
    }, (coverPictureState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $b54e9ea534ca36ea$var$popupWrapperStyle,
                    testId: "forge-editor-popup-content"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                    attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContextMenuForgeApp), {
                    app: forgeExtension,
                    extensionData: {
                        type: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
                        selectedText: selection.text,
                        content: {
                            id: contentId || '',
                            type: (0, $hIaUw.getContentType)(routeName),
                            subtype: isLivePage ? 'live' : null
                        },
                        space: {
                            key: spaceKey,
                            id: spaceId
                        }
                    },
                    onInitialRender: handleInitialRender,
                    onTearDown: onClose,
                    bridge: memoedBridge
                }))),
            trigger: ({ ref: ref })=>{
                // Adjust left position based on if side nav is open or not - it will push the content too left if we don't check
                const sideNavWidth = document.getElementById('side-navigation')?.offsetWidth || 0;
                const leftCoords = selection.coords.left - sideNavWidth; // Adjust top position based on if cover picture is present or not - it will be too high otherwise
                const topCoords = coverPictureState.state.hasCoverPicture ? selection.coords.top + $b54e9ea534ca36ea$var$COVER_PICTURE_PADDING_TOP - $b54e9ea534ca36ea$var$PAGE_PADDING_TOP : selection.coords.top - $b54e9ea534ca36ea$var$PAGE_PADDING_TOP;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                    "data-testid": "forge-editor-action-selection",
                    ref: ref,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic positioning based on selection coordinates
                        top: topCoords,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic positioning based on selection coordinates
                        left: leftCoords,
                        width: selection.coords.right - selection.coords.left,
                        height: selection.coords.bottom - selection.coords.top
                    },
                    className: (0, $gMc0m.default)([
                        "_kqswstnw _lcxvglyw"
                    ])
                });
            },
            isOpen: true,
            placement: "bottom"
        }));
};


const $263e225aef982cc6$var$iconImageStyle = null; // Need this to satisfy the toolbar extension API which expects a label prop type
const $263e225aef982cc6$var$ImageIcon = ({ label: label, src: src })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: src,
        alt: label,
        className: (0, $gMc0m.default)([
            "_4t3i1tcg _1bsb1tcg"
        ])
    }));
const $263e225aef982cc6$export$a3c406cbb96a0e18 = (contentId)=>{
    // Need ref since these are fetched and updated asynchronously so the API uses a ref to track this
    const extensionsRef = (0, $42omo.useRef)([]); // Forge items
    const { extensions: extensions } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU)
    });
    // Connect items
    const { webItems: webItems } = (0, $6ld6a.useWebItemLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ACTION_PANEL)
    });
    const filteredWebItems = webItems.filter((item)=>!(0, $2Awp2.DROPDOWN_EXCLUDED_ITEMS).includes(item.completeKey || ''));
    const connectItems = filteredWebItems.map((item)=>({
            label: item?.label,
            icon: item?.icon?.path ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($263e225aef982cc6$var$ImageIcon, {
                    label: item?.label || '',
                    src: item?.icon?.path
                }) : (0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))),
            onClick: ()=>{
                if (item?.url) window.open(item.url, '_blank');
            }
        }));
    const forgeItems = extensions.map((extension)=>({
            label: (0, $9fBoq.extensionTitle)(extension),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))),
            contentComponent: ({ selection: selection, closeExtension: closeExtension })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b54e9ea534ca36ea$export$8b1e2d0f3ad73269), {
                    key: extension.key,
                    contentId: contentId,
                    forgeExtension: extension,
                    onClose: closeExtension,
                    selection: selection
                });
            }
        }));
    extensionsRef.current = [
        ...connectItems,
        ...forgeItems
    ];
    return [
        {
            key: 'external-extensions',
            source: 'external',
            inlineToolbar: {
                getMenuItems: ()=>{
                    return [
                        ...extensionsRef.current
                    ];
                }
            }
        }
    ];
};









var $2qVkt = parcelRequire("2qVkt");


var $cHaKZ = parcelRequire("cHaKZ");





var $1mDVg = parcelRequire("1mDVg");

parcelRequire("aiS08");
var $1L1jV = parcelRequire("1L1jV");










const $304811a46258dbff$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    singleCreateWorkItemName: {
        id: "jira-work-create-extension.single-create-work-item.name",
        defaultMessage: "Create Jira work item"
    },
    bulkCreateWorkItemName: {
        id: "jira-work-create-extension.bulk-create-work-item.name",
        defaultMessage: "Create Jira work items"
    }
});



var $eqKgz = parcelRequire("eqKgz");





var $aUTn5 = parcelRequire("aUTn5");


var $3TWPv = parcelRequire("3TWPv");


var $1Q0l6 = parcelRequire("1Q0l6");

parcelRequire("aiS08");



var $UNr39 = parcelRequire("UNr39");




const $2317020506cf48db$export$a25c0fd63a5cc834 = (activeSelection)=>{
    if (!activeSelection) return '';
    const docFragment = activeSelection.getRangeAt(0).cloneContents();
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(docFragment);
    return tempDiv.innerHTML;
};
const $2317020506cf48db$export$233a92718b28d19e = 254;
const $2317020506cf48db$export$2878cc467c8be8fe = (text, maxLength)=>{
    const horizontalEllipsis = "\u2026";
    if (text.length <= maxLength) return [
        text,
        ''
    ];
    // Calculate the length of the first part without including the ellipsis
    const firstPartLength = maxLength - horizontalEllipsis.length;
    // Split the text into two parts
    const firstPart = text.substring(0, firstPartLength);
    const firstPartWithHorizontalEllipis = firstPart + horizontalEllipsis;
    return [
        firstPartWithHorizontalEllipis,
        text
    ];
};
const $2317020506cf48db$export$5645fd1d37220db2 = (activeSelection)=>{
    const selectionString = activeSelection?.toString() || '';
    const htmlString = $2317020506cf48db$export$a25c0fd63a5cc834(activeSelection);
    const [summary] = $2317020506cf48db$export$2878cc467c8be8fe(selectionString, $2317020506cf48db$export$233a92718b28d19e);
    /*
	 The regex matches one or more occurrences of any line break (\r, \n) or tab (\t)
	 and replaces them all with a single space. (We only consider whitespace characters because
	 these are the only ones that ultimately stick when parsing the summary.)
  */ const summaryWithoutFormatting = summary.replace(/[\r\n\t]+/g, ' ');
    // Convert the full HTML content to ADF for the description
    const descriptionAdf = (0, $eqKgz.htmlToADF)(htmlString);
    return [
        summaryWithoutFormatting,
        descriptionAdf
    ];
};


const $7a3ce11c17355349$var$createSingleJiraWorkItemHandleCommon = ({ actions: actions, activeSelection: activeSelection, contentId: contentId, contentType: contentType, container: container, lastModified: lastModified, pageMode: pageMode })=>{
    const highlightedText = (0, $eqKgz.htmlToADF)((0, $2317020506cf48db$export$a25c0fd63a5cc834)(activeSelection));
    const insertStorageFragmentRequestPayload = (0, $1Q0l6.constructInsertStorageFragmentRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), (0, $1Q0l6.getValidRange)(activeSelection?.getRangeAt(0)), container, lastModified);
    const [summaryWithoutFormatting, descriptionAdf] = (0, $2317020506cf48db$export$5645fd1d37220db2)(activeSelection);
    actions.setSummary(summaryWithoutFormatting);
    actions.setDescriptionAdf(descriptionAdf);
    actions.setContentId(contentId);
    contentType && actions.setContentType(contentType);
    actions.setHighlightedText(highlightedText);
    actions.setInsertStorageFragmentRequestPayload(insertStorageFragmentRequestPayload);
    actions.setPageMode(pageMode);
};
const $7a3ce11c17355349$export$5e8df502ba998c83 = ({ rightSidebarContext: rightSidebarContext, actions: actions, activeSelection: activeSelection, contentId: contentId, contentType: contentType, container: container, lastModified: lastModified, pageMode: pageMode })=>{
    if ((0, $9wGTI.fg)('confluence_editor_single_work_create_improvements')) {
        (0, $3TWPv.openSingleIssueSidePanelWithSelection)({
            actions: actions,
            rightSidebarContext: rightSidebarContext,
            activeSelection: activeSelection,
            contentId: contentId,
            contentType: contentType,
            container: container,
            lastModified: lastModified,
            pageMode: pageMode,
            convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
        });
        return;
    }
    $7a3ce11c17355349$var$createSingleJiraWorkItemHandleCommon({
        actions: actions,
        activeSelection: activeSelection,
        contentId: contentId,
        contentType: contentType,
        container: container,
        lastModified: lastModified,
        pageMode: pageMode
    });
    rightSidebarContext.open((0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID), (0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_WIDTH));
};
const $7a3ce11c17355349$export$494c35a67fd7a49e = ({ rightSidebarContext: rightSidebarContext, actions: actions, editorAPI: editorAPI })=>{
    if (editorAPI !== null && editorAPI !== undefined) actions.setEditorAPI(editorAPI);
    rightSidebarContext.open((0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID), (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
};


const $afe78874648e993b$export$d1fccc80d4f8b453 = ({ activeSelection: activeSelection, container: // completeKey, prop that will be used later in later work item creation modes added
container, contentId: contentId, contentType: contentType, lastModified: lastModified, rightSidebarContext: rightSidebarContext, actions: actions, pageMode: pageMode })=>{
    // switch here eventually for different jira work item create modes
    if (contentId) (0, $7a3ce11c17355349$export$5e8df502ba998c83)({
        actions: actions,
        rightSidebarContext: rightSidebarContext,
        activeSelection: activeSelection,
        container: container,
        contentId: contentId,
        contentType: contentType,
        lastModified: lastModified,
        pageMode: pageMode
    });
};


const $dc24c60db4dc9ba4$var$WorkItemCreationType = {
    SINGLE_WORK_ITEM: 'SINGLE_ISSUE',
    MULTIPLE_WORK_ITEM: 'MULTIPLE_ISSUE',
    AI_WORK_ITEM: 'AI_ISSUE'
};
const $dc24c60db4dc9ba4$export$d32eae3898223fdf = ({ rightSidebarContextRef: rightSidebarContextRef, pageModeRef: pageModeRef, hasEditPermissionRef: hasEditPermissionRef })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireCreateWorkItemButtonClickedAnalytics = (0, $42omo.useCallback)((workItemCreationType, isCreatedFromTable)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'jiraIssueLink',
                type: 'ui',
                attributes: {
                    issueCreationType: workItemCreationType,
                    // Set to false because a dropdown or flyout is not implemented at this entry point.
                    // TODO: Update this value if a dropdown or flyout is added in the future.
                    isDropdownItem: false,
                    isCreatedFromTable: isCreatedFromTable,
                    pageMode: pageModeRef.current,
                    hasEditPermission: hasEditPermissionRef.current
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        pageModeRef,
        hasEditPermissionRef
    ]);
    const handleSingleCreateClick = (0, $42omo.useCallback)(async ()=>{
        actions.setHasEditPermission(hasEditPermissionRef.current);
        const activeSelection = window.getSelection();
        const container = document.querySelector('div#ak-editor-textarea');
        fireCreateWorkItemButtonClickedAnalytics($dc24c60db4dc9ba4$var$WorkItemCreationType.SINGLE_WORK_ITEM, // Set to false because bulk creation from the table is not yet available at this entry point.
        // TODO: Update this value if bulk creation functionality is added in the future.
        false);
        (0, $afe78874648e993b$export$d1fccc80d4f8b453)({
            activeSelection: activeSelection,
            container: container,
            contentId: contentId,
            contentType: contentType,
            rightSidebarContext: rightSidebarContextRef?.current,
            actions: actions,
            pageMode: pageModeRef.current
        });
    }, [
        fireCreateWorkItemButtonClickedAnalytics,
        contentId,
        contentType,
        rightSidebarContextRef,
        actions,
        pageModeRef,
        hasEditPermissionRef
    ]);
    return {
        name: formatMessage((0, $304811a46258dbff$export$defe85febe8b728c).singleCreateWorkItemName),
        icon: (0, $9wGTI.fg)('platform_editor_toolbar_aifc_patch_8') ? (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))) : (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        onClick: ()=>{
            handleSingleCreateClick();
        },
        isDisabled: ()=>{
            const currentSidebar = rightSidebarContextRef?.current?.getCurrent();
            return currentSidebar?.panelId === (0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID);
        }
    };
};












var $7ZcJJ = parcelRequire("7ZcJJ");










parcelRequire("aiS08");












var $2ViZo = parcelRequire("2ViZo");


var $hq2Sz = parcelRequire("hq2Sz");


var $cSSgB = parcelRequire("cSSgB");




const $a8cc1d5c0eec455b$export$ccdc6b8dc23bf978 = (editorAPI)=>{
    if (!editorAPI?.selectionExtension?.actions?.getSelectionAdf) return false;
    const selectionResult = editorAPI.selectionExtension.actions.getSelectionAdf();
    // Determine if multiple table rows are selected
    return selectionResult?.selectedNodeAdf?.type === 'table' && !!selectionResult?.selectionRanges && selectionResult.selectionRanges.length > 1;
};


const $8055735e114abbc3$var$WorkItemCreationType = {
    SINGLE_WORK_ITEM: 'SINGLE_ISSUE',
    MULTIPLE_WORK_ITEM: 'MULTIPLE_ISSUE',
    AI_WORK_ITEM: 'AI_ISSUE'
};
const $8055735e114abbc3$export$f0c80e15dd78dd09 = ({ rightSidebarContextRef: rightSidebarContextRef, pageModeRef: pageModeRef, hasEditPermissionRef: hasEditPermissionRef, editorAPIRef: editorAPIRef })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const actions = (0, $1mDVg.useIssueCreateSidePanelActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsCreatedFromActionItems = (0, $hq2Sz.useSetIsCreatedFromActionItems)();
    const lastModified = (0, $hq2Sz.useGetContentLastModifiedTimestamp)();
    const setSelectedTableAdf = (0, $hq2Sz.useSetSelectedTableAdf)();
    const fireCreateWorkItemButtonClickedAnalytics = (0, $42omo.useCallback)((workItemCreationType, isCreatedFromTable, isCreatedFromActionItems)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'jiraIssueLink',
                type: 'ui',
                attributes: {
                    issueCreationType: workItemCreationType,
                    isDropdownItem: false,
                    isCreatedFromTable: isCreatedFromTable,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    pageMode: pageModeRef.current,
                    hasEditPermission: hasEditPermissionRef.current
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        pageModeRef,
        hasEditPermissionRef
    ]);
    const initializeCreateState = (0, $42omo.useCallback)(()=>{
        actions.setHasEditPermission(hasEditPermissionRef.current);
        const activeSelection = window.getSelection();
        const container = document.querySelector('div#ak-editor-textarea');
        return {
            activeSelection: activeSelection,
            container: container
        };
    }, [
        actions,
        hasEditPermissionRef
    ]);
    const handleSingleCreateClick = (0, $42omo.useCallback)(async ()=>{
        const { activeSelection: activeSelection, container: container } = initializeCreateState();
        const isActionItemSelection = (0, $cSSgB.getClosestActionListFromSelection)(activeSelection);
        fireCreateWorkItemButtonClickedAnalytics($8055735e114abbc3$var$WorkItemCreationType.SINGLE_WORK_ITEM, false, !!isActionItemSelection);
        (0, $afe78874648e993b$export$d1fccc80d4f8b453)({
            activeSelection: activeSelection,
            container: container,
            contentId: contentId,
            contentType: contentType,
            rightSidebarContext: rightSidebarContextRef?.current,
            actions: actions,
            pageMode: pageModeRef.current
        });
    }, [
        initializeCreateState,
        contentId,
        actions,
        pageModeRef,
        rightSidebarContextRef,
        fireCreateWorkItemButtonClickedAnalytics,
        contentType
    ]);
    const handleBulkCreateClick = (0, $42omo.useCallback)(async ()=>{
        const { activeSelection: activeSelection, container: container } = initializeCreateState();
        if (!contentId) //We'd always expect a contentId to be returned from the page context.
        //In the unexpected case where it is not, the button press will be a no-op and the user can try clicking again,
        //upon which the contentId should hopefully be populated.
        return;
        const result = (0, $2ViZo.prepareBulkCreateFromSelection)({
            actions: actions,
            activeSelection: activeSelection,
            contentId: contentId,
            container: container,
            lastModified: lastModified,
            pageMode: pageModeRef.current,
            hasEditPermission: hasEditPermissionRef.current,
            setIsCreatedFromTable: setIsCreatedFromTable,
            setIsCreatedFromActionItems: setIsCreatedFromActionItems,
            convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
        });
        if (result === (0, $2ViZo.BulkSelectionResult).Table) {
            const selectionResult = editorAPIRef.current?.selectionExtension?.actions?.getSelectionAdf?.();
            setSelectedTableAdf(selectionResult?.selectedNodeAdf ?? undefined);
        }
        if (result === (0, $2ViZo.BulkSelectionResult).None) {
            //In the unexpected case where the selection cannot be prepared for bulk create, we fall back to the single create experience
            handleSingleCreateClick();
            return;
        }
        fireCreateWorkItemButtonClickedAnalytics($8055735e114abbc3$var$WorkItemCreationType.MULTIPLE_WORK_ITEM, result === (0, $2ViZo.BulkSelectionResult).Table, result === (0, $2ViZo.BulkSelectionResult).ActionItems);
        (0, $7a3ce11c17355349$export$494c35a67fd7a49e)({
            rightSidebarContext: rightSidebarContextRef?.current,
            actions: actions,
            editorAPI: editorAPIRef.current
        });
    }, [
        initializeCreateState,
        actions,
        contentId,
        lastModified,
        pageModeRef,
        hasEditPermissionRef,
        rightSidebarContextRef,
        setIsCreatedFromTable,
        setIsCreatedFromActionItems,
        setSelectedTableAdf,
        editorAPIRef,
        handleSingleCreateClick,
        fireCreateWorkItemButtonClickedAnalytics
    ]);
    if (!(0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false)) return [];
    const toolbarConfiguration = {
        getMenuItems: ()=>{
            const currentSidebar = rightSidebarContextRef?.current?.getCurrent();
            const isDisabled = currentSidebar?.panelId === (0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID) || currentSidebar?.panelId === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
            return (0, $a8cc1d5c0eec455b$export$ccdc6b8dc23bf978)(editorAPIRef?.current) ? [
                {
                    label: formatMessage((0, $304811a46258dbff$export$defe85febe8b728c).bulkCreateWorkItemName),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))),
                    onClick: ()=>{
                        handleBulkCreateClick();
                    },
                    isDisabled: isDisabled
                }
            ] : [
                {
                    label: formatMessage((0, $304811a46258dbff$export$defe85febe8b728c).singleCreateWorkItemName),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
                    onClick: ()=>{
                        handleSingleCreateClick();
                    },
                    isDisabled: isDisabled
                }
            ];
        }
    };
    return [
        {
            key: 'jira-work-create',
            source: 'first-party',
            inlineToolbar: toolbarConfiguration
        }
    ];
};









var $g5gZt = parcelRequire("g5gZt");


var $4Hqhn = parcelRequire("4Hqhn");


var $cnH0s = parcelRequire("cnH0s");


var $1pnTI = parcelRequire("1pnTI");


var $8rBRl = parcelRequire("8rBRl");

const $432d11428ba55738$export$e42a32d48694fecd = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { handleCreateNoteClick: handleCreateNoteClick, handleAddToNoteClick: handleAddToNoteClick } = (0, $1pnTI.useContextualNoteCreation)({
        source: 'useNoteSelectionExtension'
    });
    const { notesList: notesList } = (0, $8rBRl.useContextualNotesList)();
    const notesListRef = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        notesListRef.current = notesList;
    }, [
        notesList
    ]);
    const toolbarConfiguration = {
        getToolbarItem: ()=>({
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4Hqhn))),
                tooltip: formatMessage((0, $cnH0s.sharedI18n).addToNote)
            }),
        getMenuItems: ()=>{
            return [
                ...notesListRef.current.map((note)=>({
                        ...note,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4Hqhn))),
                        onClick: ()=>handleAddToNoteClick(note.ari)
                    })),
                {
                    label: formatMessage((0, $cnH0s.sharedI18n).createNote),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
                    onClick: handleCreateNoteClick
                }
            ];
        }
    };
    const noteSelectionExtension = {
        key: 'note-contextual-create',
        source: 'first-party',
        inlineToolbar: toolbarConfiguration
    };
    return {
        extensionList: [
            noteSelectionExtension
        ]
    };
};












var $isFEX = parcelRequire("isFEX");


var $3fxwO = parcelRequire("3fxwO");


var $8aF6s = parcelRequire("8aF6s");





var $jh7y0 = parcelRequire("jh7y0");

/* CreateSnippetModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $ccHMk = parcelRequire("ccHMk");


var $hkl5F = parcelRequire("hkl5F");

var $fzqvY = parcelRequire("fzqvY");

var $fb3kw = parcelRequire("fb3kw");

var $dn4ZF = parcelRequire("dn4ZF");


var $7hXDW = parcelRequire("7hXDW");


var $8TTLA = parcelRequire("8TTLA");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $804cB = parcelRequire("804cB");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $4noo5 = parcelRequire("4noo5");


var $9EtP6 = parcelRequire("9EtP6");


var $hEeUR = parcelRequire("hEeUR");

















var $3e10B = parcelRequire("3e10B");


var $e9jnk = parcelRequire("e9jnk");

const $d03297280e9e3f82$export$d3a1558cac2e6533 = (onCreate)=>{
    const [error, setError] = (0, $42omo.useState)(null);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const create = (0, $42omo.useCallback)(async (name, body)=>{
        const params = {
            name: name,
            body: body,
            bodyFormat: (0, $e9jnk.SnippetBodyFormat).ADF,
            product: (0, $e9jnk.SnippetProduct).CONFLUENCE
        };
        try {
            setLoading(true);
            const newSnippet = await (0, $3e10B.createSnippet)(params);
            onCreate(newSnippet.name, newSnippet.description);
            return newSnippet;
        } catch (thrownError) {
            setError(thrownError);
        } finally{
            setLoading(false);
        }
        return null;
    }, [
        onCreate,
        setError,
        setLoading
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!loading && error) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
    }, [
        error,
        loading
    ]);
    return {
        create: create,
        error: error,
        loading: loading
    };
};


var $e0d6fa0d5e247589$export$186f79148af906ca = /*#__PURE__*/ function(CreateSnippetModalEvents) {
    CreateSnippetModalEvents["CANCELLED"] = "createSnippetModalCancelled";
    CreateSnippetModalEvents["CLOSED"] = "createSnippetModalClosed";
    CreateSnippetModalEvents["CREATED"] = "createSnippetModalCreated";
    return CreateSnippetModalEvents;
}({});
const $e0d6fa0d5e247589$export$93264818345214c8 = 60;
const $e0d6fa0d5e247589$export$4e4fc3c1312865b2 = 120;
const $e0d6fa0d5e247589$var$styles = {
    headerContainer: "_1yt41ejb _1e0c1txw _4cvr1y6m _1bah1yb4 _2lx2vrvc",
    headerText: "_zulp1b66 _1e0c1txw _4cvr1y6m _2lx21bp4",
    bodyContainer: "_zulp1ejb _1e0c1txw _2lx21bp4 _4t3i1osq",
    contentContainer: "_19itno8c _2rko1mok _1e0c1txw _2lx21bp4 _16jlkb7n _c71l5x59 _a5o91bu2",
    adfContainer: "_1reo1wug _18m91wug _1yt41ejb _4t3i1osq"
};
const $e0d6fa0d5e247589$var$CreateSnippetModalHeader = ({ onClose: onClose })=>{
    const { titleId: titleId } = (0, $804cB.useModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0d6fa0d5e247589$var$styles.headerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0d6fa0d5e247589$var$styles.headerText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "medium",
        id: titleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $jh7y0.messages).createTemplateModalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "medium",
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $jh7y0.messages).createTemplateModalDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: onClose
    }));
};
const $e0d6fa0d5e247589$export$3336f6e2bcd88a3e = ({ adf: adf, onClose: onClose, onCreate: onCreate })=>{
    const [adfError, setADFError] = (0, $42omo.useState)(null);
    const { create: create } = (0, $d03297280e9e3f82$export$d3a1558cac2e6533)(onCreate);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const intl = (0, $8C5kA.default)();
    const fireCreateSnippetModalAnalytics = (0, $42omo.useCallback)((event)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceCreateSnippetModal',
                action: 'closed',
                actionSubject: 'button',
                actionSubjectId: 'createSnippet',
                type: 'ui',
                attributes: {
                    event: event
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const exitModal = (0, $42omo.useCallback)((event)=>{
        fireCreateSnippetModalAnalytics(event);
        onClose();
    }, [
        fireCreateSnippetModalAnalytics,
        onClose
    ]);
    const submit = (0, $42omo.useCallback)(async (values)=>{
        await create(values.snippetName, adf);
        fireCreateSnippetModalAnalytics("createSnippetModalCreated");
        onClose();
    }, [
        fireCreateSnippetModalAnalytics,
        onClose,
        adf,
        create
    ]);
    const handleADFError = (0, $42omo.useCallback)((error)=>{
        setADFError(error);
    }, [
        setADFError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        height: "750px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: (values)=>submit(values)
    }, ({ getState: getState, formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e0d6fa0d5e247589$var$CreateSnippetModalHeader, {
            onClose: ()=>exitModal("createSnippetModalClosed")
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e0d6fa0d5e247589$var$styles.bodyContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "snippetName",
            label: intl.formatMessage((0, $jh7y0.messages).createTemplateModalNameLabel),
            defaultValue: "",
            helperMessage: intl.formatMessage((0, $jh7y0.messages).createTemplateModalNameHelper),
            component: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
                    ...fieldProps,
                    maxLength: $e0d6fa0d5e247589$export$93264818345214c8,
                    placeholder: intl.formatMessage((0, $jh7y0.messages).createTemplateModalNamePlaceholder)
                }),
            validate: (value)=>!!value ? undefined : intl.formatMessage((0, $jh7y0.messages).createTemplateModalNameError),
            isRequired: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hkl5F.default), {
            name: "snippetDescription",
            label: intl.formatMessage((0, $jh7y0.messages).createTemplateModalDescriptionLabel),
            maxCharacters: $e0d6fa0d5e247589$export$4e4fc3c1312865b2
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
                ...fieldProps,
                placeholder: intl.formatMessage((0, $jh7y0.messages).createTemplateModalDescriptionPlaceholder)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e0d6fa0d5e247589$var$styles.contentContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e0d6fa0d5e247589$var$styles.adfContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEeUR.ADFRenderer), {
            document: adf,
            appearance: "comment",
            allowPlaceholderText: true,
            onError: handleADFError
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dn4ZF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            onClick: ()=>exitModal("createSnippetModalCancelled")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $jh7y0.messages).createTemplateModalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            type: "submit",
            appearance: "primary",
            isDisabled: !getState().dirty || getState().hasValidationErrors || !!adfError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $jh7y0.messages).createTemplateModalCreateButton)))))));
};









var $5SAOw = parcelRequire("5SAOw");





var $4MPLO = parcelRequire("4MPLO");

const $dc8a26cf89389c81$export$a72e587fbb595114 = ({ snippet: snippet, editorAPIRef: editorAPIRef })=>{
    if (!editorAPIRef?.current) return;
    const editorApi = editorAPIRef.current;
    const addQuickInsertItem = editorApi?.quickInsert?.commands?.addQuickInsertItem;
    if (addQuickInsertItem === undefined) return;
    editorApi.core?.actions.execute(addQuickInsertItem((intl)=>[
            $dc8a26cf89389c81$var$createSnippetQuickInsertItem({
                snippet: snippet,
                intl: intl
            })
        ]));
};
const $dc8a26cf89389c81$var$createSnippetQuickInsertItem = ({ snippet: snippet, intl: intl })=>{
    return {
        key: `snippet-${snippet.snippetId}`,
        title: snippet.name,
        description: (0, $4MPLO.createSnippetDescription)(snippet.createdBy, intl),
        keywords: (0, $4MPLO.extractSnippetKeywords)(snippet.name, intl),
        isDisabledOffline: true,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                label: "Snippet"
            }),
        action: (insert, state)=>{
            const body = snippet.body;
            if (!body) return false;
            if (Array.isArray(body)) {
                const fragment = (0, $5SAOw.Fragment).fromJSON(state.schema, body);
                return insert(fragment);
            }
            return insert(body);
        }
    };
};


const $265fec22bc2b6d8c$export$96bc1bdad3daccdf = ({ editorAPIRef: editorAPIRef })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const fireCreateSnippetButtonClickedAnalytics = (0, $42omo.useCallback)((selectionLength)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createSnippet',
                type: 'ui',
                attributes: {
                    selectionLength: selectionLength
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleCreateSnippet = (0, $42omo.useCallback)(()=>{
        if (!editorAPIRef?.current) return;
        const actions = editorAPIRef?.current?.selectionExtension?.actions;
        const document = actions?.getDocumentFromSelection();
        const docAdf = document?.selectedNodeAdf;
        // getDocumentFromSelection will always return adf of type 'doc', so strip this doc wrapper for the saved content;
        const adfContent = docAdf?.content?.filter((content)=>content !== undefined);
        if (!adfContent || adfContent.length === 0) return;
        const onSnippetCreate = (snippetName, snippetDescription)=>{
            // In the future, we will use the response from the create endpoint most likely.
            // When that is implemented this will be removed
            const testSnippet = {
                ari: (0, $3fxwO.BlocksSnippetAri).create({
                    siteId: 'test-site-id',
                    workspaceId: 'test-workspace',
                    snippetId: '5c03eba4-7886-7f32-a0e3-af11d571f573'
                }),
                name: snippetName,
                description: snippetDescription,
                body: adfContent.length === 1 ? adfContent[0] : adfContent,
                bodyFormat: (0, $e9jnk.SnippetBodyFormat).ADF,
                createdAt: new Date(),
                createdBy: {
                    accountId: 'atlassian',
                    displayName: 'Atlassian'
                },
                isFavorite: 0,
                product: (0, $e9jnk.SnippetProduct).CONFLUENCE,
                snippetId: 'test-id',
                status: (0, $e9jnk.SnippetStatus).ACTIVE,
                updatedAt: new Date()
            };
            (0, $dc8a26cf89389c81$export$a72e587fbb595114)({
                snippet: testSnippet,
                editorAPIRef: editorAPIRef
            });
        };
        fireCreateSnippetButtonClickedAnalytics(JSON.stringify(adfContent)?.length);
        showModal((0, $e0d6fa0d5e247589$export$3336f6e2bcd88a3e), {
            adf: docAdf,
            onCreate: onSnippetCreate
        });
    }, [
        editorAPIRef,
        fireCreateSnippetButtonClickedAnalytics,
        showModal
    ]);
    if (!(0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false)) return [];
    const toolbarConfiguration = {
        getMenuItems: ()=>{
            return [
                {
                    label: formatMessage((0, $jh7y0.messages).createTemplate),
                    lozenge: {
                        label: formatMessage((0, $jh7y0.messages).createTemplateLozenge)
                    },
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($isFEX))),
                    onClick: ()=>{
                        handleCreateSnippet();
                    }
                }
            ];
        }
    };
    return [
        {
            key: 'create-snippet',
            source: 'first-party',
            inlineToolbar: toolbarConfiguration
        }
    ];
};








/* useTrelloInboxSelectionExtension.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $lAFHW = parcelRequire("lAFHW");





var $lpGuF = parcelRequire("lpGuF");




const $e9e6a29a0deabfc6$export$1a972864ed9252e6 = (0, $cgtv4.defineMessages)({
    successTitle: {
        id: "highlight-actions.trello.create.success",
        defaultMessage: "Trello card created"
    },
    errorTitle: {
        id: "highlight-actions.trello.create.error",
        defaultMessage: "Couldn't create Trello card. Try again later."
    },
    openCard: {
        id: "highlight-actions.trello.openCard",
        defaultMessage: "Open card"
    }
});


const $32f76a2196ddc2ab$var$messages = (0, $cgtv4.defineMessages)({
    menuItemLabel: {
        id: "editor-features.trello-inbox.create-card",
        defaultMessage: "Send to your Trello Inbox"
    }
});
const $32f76a2196ddc2ab$var$iconWrapperStyles = null;
const $32f76a2196ddc2ab$var$handleCreateTrelloCard = async (contentId, flags, formatMessage)=>{
    if (!flags) return;
    try {
        const selection = window.getSelection();
        if (!selection || selection.rangeCount === 0) return;
        const selectedText = selection.toString().trim();
        if (!selectedText) return;
        const result = await (0, $lpGuF.createTrelloCardHandle)({
            text: selectedText,
            contentId: contentId
        });
        if (result?.cardUrl) {
            const titleNode = /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, formatMessage((0, $e9e6a29a0deabfc6$export$1a972864ed9252e6).successTitle));
            flags.showFlag({
                id: `trello-inbox-create-success-${Date.now()}`,
                title: titleNode,
                appearance: 'success',
                actions: [
                    {
                        content: formatMessage((0, $e9e6a29a0deabfc6$export$1a972864ed9252e6).openCard),
                        href: result.cardUrl,
                        target: '_blank'
                    }
                ]
            });
        } else flags.showFlag({
            id: `trello-inbox-create-error-${Date.now()}`,
            title: formatMessage((0, $e9e6a29a0deabfc6$export$1a972864ed9252e6).errorTitle),
            appearance: 'error'
        });
    } catch  {
        flags.showFlag({
            id: `trello-inbox-create-error-${Date.now()}`,
            title: formatMessage((0, $e9e6a29a0deabfc6$export$1a972864ed9252e6).errorTitle),
            appearance: 'error'
        });
    }
};
const $32f76a2196ddc2ab$export$b4751a4560935df = (contentId, _editorAPIRef, flags)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return {
        key: 'trello-inbox',
        source: 'first-party',
        inlineToolbar: {
            getMenuItems: ()=>{
                const label = formatMessage($32f76a2196ddc2ab$var$messages.menuItemLabel);
                const icon = ()=>/*#__PURE__*/ $42omo.createElement("span", {
                        className: (0, $gMc0m.default)([
                            "_1e0c116y _4cvr1h6o _1bah1h6o _4t3ipxbi _1bsbpxbi _1752pxbi _w8l5pxbi"
                        ])
                    }, /*#__PURE__*/ $42omo.createElement((0, $lAFHW.TrelloIcon), {
                        label: label,
                        appearance: "neutral",
                        size: "small"
                    }));
                return [
                    {
                        label: label,
                        icon: icon,
                        onClick: ()=>$32f76a2196ddc2ab$var$handleCreateTrelloCard(contentId || '', flags, formatMessage)
                    }
                ];
            }
        }
    };
};


const $0826d4545dd61f1d$export$69326c9b91111e89 = ({ isSidePanelOpenRef: isSidePanelOpenRef, rightSidebarContextRef: rightSidebarContextRef, pageModeRef: pageModeRef, hasEditPermissionRef: hasEditPermissionRef, contentId: contentId, editorAPIRef: editorAPIRef, flags: flags })=>{
    const createSnippetExtension = (0, $265fec22bc2b6d8c$export$96bc1bdad3daccdf)({
        editorAPIRef: editorAPIRef
    });
    const jiraWorkCreateSelectionExtension = (0, $dc24c60db4dc9ba4$export$d32eae3898223fdf)({
        isSidePanelOpenRef: isSidePanelOpenRef,
        rightSidebarContextRef: rightSidebarContextRef,
        pageModeRef: pageModeRef,
        hasEditPermissionRef: hasEditPermissionRef
    });
    const jiraWorkCreateExtensionV2 = (0, $8055735e114abbc3$export$f0c80e15dd78dd09)({
        isSidePanelOpenRef: isSidePanelOpenRef,
        rightSidebarContextRef: rightSidebarContextRef,
        pageModeRef: pageModeRef,
        hasEditPermissionRef: hasEditPermissionRef,
        editorAPIRef: editorAPIRef
    });
    const useConditionalNoteSelectionExtension = (0, $dTb09.conditionalHooksFactory)(// NEXT PR: switch this to use the feature gate for notes rollout
    ()=>(0, $6mKj3.expVal)('cc_notes', 'isEnabled', false), (0, $432d11428ba55738$export$e42a32d48694fecd), ()=>({
            extensionList: []
        }));
    // Connect and Forge 2P extensions
    const useExternalExtensionsWithContentId = ()=>(0, $263e225aef982cc6$export$a3c406cbb96a0e18)(contentId);
    const useConditionalExternalExtensions = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expVal)('confluence_enable_2p_toolbar_apps', 'isEnabled', false), useExternalExtensionsWithContentId, ()=>[]);
    const { extensionList: noteExtensionList } = useConditionalNoteSelectionExtension();
    const externalExtensions = useConditionalExternalExtensions();
    const trelloExtension = (0, $32f76a2196ddc2ab$export$b4751a4560935df)(contentId, editorAPIRef, flags);
    const jiraWorkCreateExtensionList = (0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false) ? jiraWorkCreateExtensionV2 : [];
    const extensionList = [
        ...createSnippetExtension,
        ...noteExtensionList,
        ...externalExtensions,
        ...jiraWorkCreateExtensionList,
        ...flags && (0, $9wGTI.fg)('quick_capture_trello_inbox') ? [
            trelloExtension
        ] : []
    ];
    return {
        extensions: (0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false) ? {} : {
            firstParty: [
                jiraWorkCreateSelectionExtension
            ]
        },
        extensionList: extensionList
    };
};






var $ai7NK = parcelRequire("ai7NK");




const $9d48445854f70eb8$export$8b02a744327cd19 = (viewMode, isLivePage, hasEditPermission)=>{
    if (isLivePage) {
        if (viewMode === 'edit' && hasEditPermission) return (0, $1mDVg.PageMode).LIVE_EDIT;
        return (0, $1mDVg.PageMode).LIVE_VIEW;
    }
    if (viewMode === 'edit' && hasEditPermission) return (0, $1mDVg.PageMode).EDIT;
    return (0, $1mDVg.PageMode).VIEW;
};



var $jln20 = parcelRequire("jln20");


var $9aXRY = parcelRequire("9aXRY");


var $a37Yb = parcelRequire("a37Yb");


var $jO6sX = parcelRequire("jO6sX");










var $8TW6I = parcelRequire("8TW6I");


var $2RJaj = parcelRequire("2RJaj");


var $2pBiX = parcelRequire("2pBiX");


var $4R3wx = parcelRequire("4R3wx");


var $hMfsx = parcelRequire("hMfsx");


var $8Q0mA = parcelRequire("8Q0mA");


var $6T0Pj = parcelRequire("6T0Pj");


var $5i3ci = parcelRequire("5i3ci");










const $6c1b58cebd0e5cea$var$ENTRYPOINT_ID = 'loom-confluence-page-editor-toolbar';
const $6c1b58cebd0e5cea$var$SOURCE_COMPONENT = 'loomConfluencePageEditorToolbar';
const $6c1b58cebd0e5cea$var$SOURCE_CONTEXT = 'confluencePageEditorToolbarRecordAVideo';
const $6c1b58cebd0e5cea$var$i18n = (0, $cgtv4.defineMessages)({
    crossSellPopupCardDescription: {
        id: "editor-presets.full-page-editor.crossSellPopupCardDescription",
        defaultMessage: "Save time and engage your team with a video walkthrough of this page."
    },
    crossSellPopupCardTitle: {
        id: "editor-presets.full-page-editor.crossSellPopupCardTitle",
        defaultMessage: "Share your work with a video"
    }
});
const $6c1b58cebd0e5cea$var$EditorLoomButtonComponent = ({ buttonComponent: ButtonComponent, editorAPIRef: editorAPIRef, flags: flags })=>{
    const isNewToolbarEnabled = ((0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expVal)('platform_editor_toolbar_aifc_confluence', 'isEnabled', false)) && (0, $6mKj3.expVal)('platform_editor_toolbar_migrate_loom', 'isEnabled', false);
    const intl = (0, $8C5kA.default)();
    const { entryPointVariant: entryPointVariant, error: error, loading: loading } = (0, $4R3wx.useLoomEntryPointVariant)();
    const loomEntryPointErrorCallback = (0, $2pBiX.useLoomEntryPointErrorCallback)({
        flags: flags
    });
    if (entryPointVariant === 'BETA' || isNewToolbarEnabled && entryPointVariant === 'CO_USE') // Fall back to the plugin's default behavior when in a recorder-eligible state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, null);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, {
        onClickBeforeInit: loomEntryPointErrorCallback
    });
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, {
        isDisabled: true
    });
    if (entryPointVariant === 'CROSS_FLOW') {
        if (isNewToolbarEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMfsx.CrossFlowMenuItem), {
            buttonComponent: ButtonComponent,
            sourceActionSubjectId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
            entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID,
            sourceComponent: $6c1b58cebd0e5cea$var$SOURCE_COMPONENT,
            sourceContext: $6c1b58cebd0e5cea$var$SOURCE_CONTEXT
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T0Pj.LoomCrossFlowPopupCard), {
            description: intl.formatMessage($6c1b58cebd0e5cea$var$i18n.crossSellPopupCardDescription),
            entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID,
            placement: "bottom-end",
            // Render in a Portal to isolate from conflicts caused by editor-based CSS + keyboard & focus behavior
            shouldRenderToParent: false,
            sourceActionSubjectId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
            sourceComponent: $6c1b58cebd0e5cea$var$SOURCE_COMPONENT,
            sourceContext: $6c1b58cebd0e5cea$var$SOURCE_CONTEXT,
            title: intl.formatMessage($6c1b58cebd0e5cea$var$i18n.crossSellPopupCardTitle),
            trigger: ({ isSelected: isSelected, onClick: onClick, ...otherTriggerProps })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, {
                    onClickBeforeInit: onClick,
                    selected: isSelected,
                    ...otherTriggerProps
                }));
            }
        });
    }
    if (entryPointVariant === 'CROSS_JOIN') {
        if (isNewToolbarEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMfsx.CrossJoinMenuItem), {
            buttonComponent: ButtonComponent,
            sourceActionSubjectId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
            entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID,
            flags: (0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? flags : undefined
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Q0mA.LoomCrossJoinPopupCard), {
            description: intl.formatMessage($6c1b58cebd0e5cea$var$i18n.crossSellPopupCardDescription),
            entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID,
            placement: "bottom-end",
            // Render in a Portal to isolate from conflicts caused by editor-based CSS + keyboard & focus behavior
            shouldRenderToParent: false,
            sourceActionSubjectId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
            title: intl.formatMessage($6c1b58cebd0e5cea$var$i18n.crossSellPopupCardTitle),
            triggerLink: (href, { onClick: onClick, ...otherTriggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, {
                    ...otherTriggerProps,
                    href: href,
                    onClickBeforeInit: onClick,
                    rel: "noreferrer",
                    target: "_blank"
                })),
            flags: (0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? flags : undefined
        });
    }
    if (entryPointVariant === 'CO_USE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2RJaj.EditorToolbarLoomButtonSpotlight), {
        editorAPIRef: editorAPIRef,
        spotlightPlacement: "bottom right",
        nudgeSource: "fullPageEditorToolbar",
        epMessage: "cc-loom-onboarding-spotlight-editor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, null));
    return null;
};
const $6c1b58cebd0e5cea$export$6aeb215a2a3b0ff0 = (0, $7aRa9.withFlags)($6c1b58cebd0e5cea$var$EditorLoomButtonComponent);



var $diJQD = parcelRequire("diJQD");

function $9661ce7f5a08c58b$export$2272e89b7d3ccec0(props) {
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar, hideObjectSidebarByPanelId: hideObjectSidebarByPanelId } = (0, $aWwYt.useObjectSidebarActions)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isDesktop: isDesktop } = (0, $2JYae.useIsDesktop)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const [{ deletedMentions: deletedMentions, addedMentions: addedMentions, unrestrictedMentions: unrestrictedMentions, parentSpaceRestrictedMentions: parentSpaceRestrictedMentions, pageRestrictedMentions: pageRestrictedMentions, unrestrictedTasks: unrestrictedTasks, addedTasks: addedTasks, deletedTasks: deletedTasks, pageRestrictedTasks: pageRestrictedTasks, parentSpaceRestrictedTasks: parentSpaceRestrictedTasks }, { setDeletedMentions: setDeletedMentions, setAddedMentions: setAddedMentions, setAddedTasks: setAddedTasks, setDeletedTasks: setDeletedTasks, setMentionsAdded: setMentionsAdded, setTasksAdded: setTasksAdded }] = (0, $hdxAi.useMentionsNotifications)();
    const [mentionChanges, setMentionChanges] = (0, $42omo.useState)([]);
    const previousEditorProps = (0, $7541v.default)(props);
    const isClassicMentionsNotificationsEnrolled = (0, $9747c27e818a1963$export$a9e17b56b1093c49)();
    const isLivePageRef = (0, $42omo.useRef)(isLivePage);
    isLivePageRef.current = isLivePage;
    const getCurrentIsLivePage = (0, $42omo.useCallback)(()=>{
        return isLivePageRef.current;
    }, []);
    const { confluenceEditorPreferencesProvider: confluenceEditorPreferencesProvider, editorPreferencesProvider: editorPreferencesProvider } = (0, $jO6sX.useEditorPreferencesProvider)({
        getCurrentIsLivePage: getCurrentIsLivePage
    });
    const isSidePanelOpen = (0, $ai7NK.useIsSidePanelOpen)();
    const isSidePanelOpenRef = (0, $42omo.useRef)(isSidePanelOpen);
    isSidePanelOpenRef.current = isSidePanelOpen;
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const rightSidebarContextRef = (0, $42omo.useRef)(rightSidebarContext);
    rightSidebarContextRef.current = rightSidebarContext;
    const hasEditPermission = props.hasEditPermission || false;
    const hasEditPermissionRef = (0, $42omo.useRef)(hasEditPermission);
    hasEditPermissionRef.current = hasEditPermission;
    const pageMode = (0, $9d48445854f70eb8$export$8b02a744327cd19)(props.viewMode, props.__livePage, props.hasEditPermission);
    const pageModeRef = (0, $42omo.useRef)(pageMode);
    pageModeRef.current = pageMode;
    (0, $42omo.useEffect)(()=>{
        const isMentionNotificationsEnabled = isLivePage || !isLivePage && isClassicMentionsNotificationsEnrolled;
        if (mentionChanges.length && isMentionNotificationsEnabled) {
            (0, $04e4e4b928c4520b$export$9ac42f814ec8d6c6)({
                mentionChanges: mentionChanges,
                deletedMentions: deletedMentions,
                addedMentions: addedMentions,
                setDeletedMentions: setDeletedMentions,
                setAddedMentions: setAddedMentions,
                userId: userId,
                unrestrictedMentions: unrestrictedMentions,
                parentSpaceRestrictedMentions: parentSpaceRestrictedMentions,
                pageRestrictedMentions: pageRestrictedMentions,
                unrestrictedTasks: unrestrictedTasks,
                addedTasks: addedTasks,
                deletedTasks: deletedTasks,
                setAddedTasks: setAddedTasks,
                setDeletedTasks: setDeletedTasks,
                pageRestrictedTasks: pageRestrictedTasks,
                parentSpaceRestrictedTasks: parentSpaceRestrictedTasks,
                setMentionsAdded: setMentionsAdded,
                setTasksAdded: setTasksAdded
            });
            setMentionChanges([]);
        }
    // We only need to trigger the handler function when mentionChanges gets updated
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mentionChanges
    ]);
    const editorAPIRef = (0, $42omo.useRef)(null);
    const { isPluginEnabled: isLoomPluginEnabled, pluginOptions: loomPluginOptions } = (0, $9Zt9E.useLoomPluginOptions)({
        EditorButtonComponent: (0, $6c1b58cebd0e5cea$export$6aeb215a2a3b0ff0),
        editorAPIRef: editorAPIRef,
        // [ED-27497] IMPORTANT: If you change the code below, please also update the
        // platform/packages/editor/editor-presets-confluence/src/presets/full-page/loomPluginOptions.ts
        ...(0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? {
            editorShouldShowToolbarLoomButton: false
        } : {}
    });
    const { pluginOptions: trackChangesPluginOptions } = (0, $a37Yb.useTrackChangesPlugin)({
        editorAPIRef: editorAPIRef
    });
    const { config: editorEngagementPlatformPluginConfig } = (0, $ijGoX.useEditorEngagementPlatform)();
    const editorPluginAIDefinitionsEnabled = (0, $bDgLc.useEditorPluginAIDefinitionsEnabled)();
    const editorPluginAIDefinitionsConfig = (0, $bDgLc.useEditorPluginAIDefinitionsConfig)();
    const editorPluginAIProactiveEnabled = (0, $8L9Ex.useEditorPluginAIProactiveEnabled)({
        aiGlobalOptInStatus: props.aiGlobalOptIn.status
    });
    const editorPluginAIProactiveConfig = (0, $8L9Ex.useEditorPluginAIProactiveConfig)({
        aiGlobalOptIn: props.aiGlobalOptIn,
        editorPluginAIFeedbackHandlers: props.editorPluginAIFeedbackHandlers
    });
    const selectionExtensionPluginOptions = (0, $0826d4545dd61f1d$export$69326c9b91111e89)({
        isSidePanelOpenRef: isSidePanelOpenRef,
        rightSidebarContextRef: rightSidebarContextRef,
        pageModeRef: pageModeRef,
        hasEditPermissionRef: hasEditPermissionRef,
        contentId: props.contentId,
        editorAPIRef: editorAPIRef,
        flags: props.flags
    });
    const limitedModePluginOptions = {
        contentId: props.contentId,
        showFlag: props.flags.showFlag
    };
    const { isEligibleCreateNewWhiteboard: isEligibleCreateNewWhiteboard } = (0, $9aXRY.useIsEligibleCreateNewWhiteboard)();
    const intl = (0, $8C5kA.default)();
    const emojiNodeDataProvider = (0, $78d13d0c9995dbf8$export$7274b8e5fdf0c8bf)();
    const presetFunction = (0, $42omo.useCallback)(()=>{
        const { __livePage: __livePage, __rendererExtensionOptions: __rendererExtensionOptions, allowFindReplace: allowFindReplace, annotationProviders: annotationProviders, appearance: appearance, autoformattingProvider: autoformattingProvider, editorPluginAIOptions: editorPluginAIOptions, collabEdit: collabEdit, contextIdentifierProvider: contextIdentifierProvider, elementBrowser: elementBrowser, emojiProvider: emojiProvider, extensionHandlers: extensionHandlers, getExtensionHeight: getExtensionHeight, getHeadingLinkPath: getHeadingLinkPath, hasRequestedEditPermission: hasRequestedEditPermission, isAIEnabledForContent: isAIEnabledForContent, linking: linking, media: media, mention: mention, mentionProvider: mentionProvider, quickInsert: quickInsert, referentialityContext: referentialityContext, requestToEditContent: requestToEditContent, taskDecisionProvider: taskDecisionProvider, viewMode: viewMode, disabled: disabled, blockLinkHashPrefix: blockLinkHashPrefix, showDiffPluginParams: showDiffPluginParams, syncedBlockProvider: syncedBlockProvider, disableFloatingToolbar: disableFloatingToolbar, disableToolbar: disableToolbar, contentId: contentId, spaceKey: spaceKey } = props;
        // IMPORTANT: Don't add spread operator (`...props`) here because it will make impossible to
        //            understand which props are used in the preset.
        const presetOptions = {
            __livePage: __livePage,
            __rendererExtensionOptions: __rendererExtensionOptions,
            allowFindReplace: allowFindReplace,
            annotationProviders: annotationProviders,
            appearance: appearance,
            autoformattingProvider: autoformattingProvider,
            collabEdit: collabEdit,
            contextIdentifierProvider: contextIdentifierProvider,
            contextPanelOptions: {
                objectSideBar: {
                    showPanel: showObjectSidebar,
                    closePanel: hideObjectSidebar,
                    closePanelById: hideObjectSidebarByPanelId
                }
            },
            contentId: contentId,
            spaceKey: spaceKey,
            editorEngagementPlatformPluginConfig: editorEngagementPlatformPluginConfig,
            editorPluginAIDefinitionsConfig: editorPluginAIDefinitionsConfig,
            editorPluginAIDefinitionsEnabled: editorPluginAIDefinitionsEnabled,
            editorPluginAIOptions: editorPluginAIOptions,
            editorPluginAIProactiveConfig: editorPluginAIProactiveConfig,
            editorPluginAIProactiveEnabled: editorPluginAIProactiveEnabled,
            elementBrowser: elementBrowser,
            emojiProvider: emojiProvider,
            emojiNodeDataProvider: emojiNodeDataProvider,
            extensionHandlers: extensionHandlers,
            flags: props.flags,
            getExtensionHeight: getExtensionHeight,
            getHeadingLinkPath: getHeadingLinkPath,
            handleMentionsChanged: (changes)=>{
                if (changes.length) setMentionChanges(changes);
            },
            hasEditPermission: props.hasEditPermission,
            hasRequestedEditPermission: hasRequestedEditPermission,
            intl: intl,
            isAIEnabledForContent: isAIEnabledForContent,
            isCompanyHub: props.isCompanyHub || false,
            isDesktop: isDesktop,
            isEligibleCreateNewWhiteboard: isEligibleCreateNewWhiteboard,
            isLoomPluginEnabled: isLoomPluginEnabled,
            limitedModePluginOptions: limitedModePluginOptions,
            linking: linking,
            loomPluginOptions: loomPluginOptions,
            media: media,
            mention: mention,
            mentionProvider: mentionProvider,
            prevAppearance: previousEditorProps?.appearance,
            quickInsert: quickInsert,
            referentialityContext: referentialityContext,
            requestToEditContent: requestToEditContent,
            selectionExtensionPluginOptions: selectionExtensionPluginOptions,
            taskDecisionProvider: taskDecisionProvider,
            userPreferencesProvider: confluenceEditorPreferencesProvider,
            userPreferencesProviderNext: editorPreferencesProvider,
            viewMode: viewMode,
            contextualFormattingEnabled: props.contextualFormattingEnabled,
            disabled: disabled,
            blockLinkHashPrefix: blockLinkHashPrefix,
            showDiffPluginParams: showDiffPluginParams,
            syncedBlockProvider: syncedBlockProvider,
            disableFloatingToolbar: disableFloatingToolbar,
            disableToolbar: disableToolbar,
            trackChangesPluginOptions: trackChangesPluginOptions
        };
        return (0, $diJQD.createFullPageEditorPreset)(presetOptions);
    // The dependency array should mirror the dependencies we pass to usePreset.
    // Refactor this to only use one usePreset when cleaning up confluence_frontend_transition_preloading_system FG
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.appearance,
        props.contentId
    ]);
    const { preset: presetStandard, editorApi: editorApiStandard } = (0, $1JdaQ.usePreset)(presetFunction, [
        // WARNING: Adding this dependency array causes the editor plugins to all recreate
        // This can be very expensive. Be very careful adding to this, avoid if possible!
        // Generally we can update props via their plugin APIs (see `placeholder` as an example)
        // update preset based on props change, originally from packages/editor/editor-core/src/create-editor/preset-utils.ts
        // persistScrollGutter not used, allowUndoRedoButtons and sanitizePrivateContent always true
        props.appearance
    ]);
    const { preset: presetSmootherTransitionsFG, editorApi: editorApiSmootherTransitionsFG } = (0, $1JdaQ.usePreset)(presetFunction, [
        props.appearance,
        props.contentId
    ]);
    const isPresetRerunningOnTransition = (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') && isLivePage;
    const editorApi = isPresetRerunningOnTransition ? editorApiSmootherTransitionsFG : editorApiStandard;
    const preset = isPresetRerunningOnTransition ? presetSmootherTransitionsFG : presetStandard;
    (0, $42omo.useEffect)(()=>{
        editorApi?.core?.actions.execute(editorApi?.placeholder?.commands.setPlaceholder(props.placeholder ?? ''));
    }, [
        editorApi,
        props.placeholder
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_transition_preloading_system')) editorApi?.media?.actions.setProvider(props.media?.provider);
    }, [
        editorApi,
        props.media?.provider
    ]);
    const { setEditorAPI: setEditorAPI } = props;
    (0, $42omo.useEffect)(()=>{
        if (!setEditorAPI) return;
        editorAPIRef.current = editorApi;
        setEditorAPI(editorApi);
    }, [
        editorApi,
        setEditorAPI
    ]);
    (0, $42omo.useEffect)(()=>{
        if (props.viewMode === undefined) return;
        editorApi?.core?.actions?.execute(editorApi?.editorViewMode?.commands?.updateViewMode(props.viewMode));
    }, [
        props.viewMode,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        editorApi?.core?.actions?.execute(editorApi?.taskDecision?.commands?.updateEditPermission(props.hasEditPermission));
    }, [
        props.hasEditPermission,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        editorApi?.core?.actions?.execute(editorApi?.taskDecision?.commands?.updateHasRequestedEditPermission(props.hasRequestedEditPermission || false));
    }, [
        props.hasRequestedEditPermission,
        editorApi
    ]);
    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled, enablementSource: enablementSource } = editorPluginAIDefinitionsConfig;
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_ai_access_policy')) return;
        editorApi?.core?.actions?.execute(editorApi?.aiDefinitions?.commands?.updateState({
            enabled: enabled,
            autoHighlightEnabled: autoHighlightEnabled,
            enablementSource: enablementSource
        }));
    }, [
        editorApi,
        enabled,
        autoHighlightEnabled,
        enablementSource
    ]);
    const { openLoomRecorder: openLoomRecorder } = (0, $9uAPw.useLoomRecorderEntryPoint)({
        flags: props.flags,
        entryPointLocation: 'editor-toolbar',
        resetInsertFunctionOnUnmount: true
    });
    const loomProviderConfig = (0, $42omo.useMemo)(()=>({
            openLoomRecorder: openLoomRecorder
        }), [
        openLoomRecorder
    ]);
    (0, $3GtBN.useInitializeLoomPlugin)({
        loomPlugin: editorApi?.loom,
        providerConfig: loomProviderConfig
    });
    return preset;
}








const $639a5b7d5146574b$var$hydrationContainerStyles = {
    height: '100%'
};
function $639a5b7d5146574b$export$3b07c6dfbdf7e5bd({ ...props }) {
    const fullPagePreset = (0, $9661ce7f5a08c58b$export$2272e89b7d3ccec0)({
        appearance: props.appearance,
        featureFlags: props.featureFlags,
        onSave: props.onSave,
        linking: props.linking,
        contextIdentifierProvider: props.contextIdentifierProvider,
        media: props.media,
        placeholder: props.placeholder,
        collabEdit: props.collabEdit,
        primaryToolbarComponents: props.primaryToolbarComponents,
        waitForMediaUpload: props.waitForMediaUpload,
        mention: props.mention,
        allowFindReplace: props.allowFindReplace,
        allowExtension: props.allowExtension,
        extensionHandlers: props.extensionHandlers,
        referentialityContext: props.referentialityContext,
        emojiProvider: props.emojiProvider,
        mentionProvider: props.mentionProvider,
        annotationProviders: props.annotationProviders,
        autoformattingProvider: props.autoformattingProvider,
        taskDecisionProvider: props.taskDecisionProvider,
        editorPluginAIOptions: props.editorPluginAIOptions,
        aiGlobalOptIn: props.aiGlobalOptIn,
        editorPluginAIFeedbackHandlers: props.editorPluginAIFeedbackHandlers,
        elementBrowser: props.elementBrowser,
        setEditorAPI: props.setEditorAPI,
        viewMode: props.viewMode,
        hasEditPermission: props.hasEditPermission,
        requestToEditContent: props.requestToEditContent,
        hasRequestedEditPermission: props.hasRequestedEditPermission,
        getHeadingLinkPath: props.getHeadingLinkPath,
        __rendererExtensionOptions: props.__rendererExtensionOptions,
        __livePage: props.__livePage,
        flags: props.flags,
        quickInsert: props.quickInsert,
        contextPanelOptions: props.contextPanelOptions,
        spaceId: props.spaceId,
        spaceKey: props.spaceKey,
        contentId: props.contentId,
        isAIEnabledForContent: props.isAIEnabledForContent,
        getExtensionHeight: props.getExtensionHeight,
        collabEditProvider: props.collabEditProvider,
        disabled: props.disabled,
        contextualFormattingEnabled: !!props.showEmbeddedModernHeader,
        isCompanyHub: props.isCompanyHub,
        syncedBlockProvider: props.syncedBlockProvider
    });
    const editorProps = {
        preset: fullPagePreset,
        defaultValue: props.defaultValue,
        disabled: props.disabled,
        // Providers
        mentionProvider: props.mentionProvider,
        contextIdentifierProvider: props.contextIdentifierProvider,
        searchProvider: props.searchProvider,
        activityProvider: props.activityProvider,
        annotationProviders: props.annotationProviders,
        collabEditProvider: props.collabEditProvider,
        collabEdit: props.collabEdit,
        extensionProviders: props.extensionProviders,
        // Other props
        shouldFocus: props.shouldFocus,
        quickInsert: props.quickInsert,
        secondaryToolbarComponents: props.secondaryToolbarComponents,
        featureFlags: props.featureFlags,
        primaryToolbarComponents: props.primaryToolbarComponents,
        contextPanel: props.contextPanel,
        contentComponents: props.contentComponents,
        primaryToolbarIconBefore: props.primaryToolbarIconBefore,
        sanitizePrivateContent: props.sanitizePrivateContent,
        __livePage: props.__livePage,
        // Callbacks
        // @ts-expect-error - We don't allow `EditorView` to be passed in the new API
        onChange: props.onChange,
        onEditorReady: props.onEditorReady,
        appearance: props.appearance,
        contentMode: props.contentMode,
        getExtensionHeight: props.getExtensionHeight
    };
    if ((0, $6mKj3.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fthpM.FullPageEditor), editorProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
        name: "full-page-editor",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $639a5b7d5146574b$var$hydrationContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fthpM.FullPageEditor), editorProps));
}






var $cauOq = parcelRequire("cauOq");

var $7WFax = parcelRequire("7WFax");


var $hQDqA = parcelRequire("hQDqA");








var $i4dNk = parcelRequire("i4dNk");

const $022566d7a48da434$export$4d07d1c131526670 = ({ contentId: contentId, version: version, spaceKey: spaceKey, editorApi: editorApi, isContentCreationPanelOpen: isContentCreationPanelOpen, isShowingOfflineBanner: isShowingOfflineBanner, editorActions: editorActions, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, handleTitleChange: handleTitleChange })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isInCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { areBannersHidden: areBannersHidden } = (0, $i4dNk.useCfind4473CreationFocusedNav)(); // simplify the nav for D0 experience
    /**
	 * Editor Help Center conflicts with the OnboardingEditorBanner and should be suppressed when the banner is shown
	 * The banner has queries that need to fully resolve before the banner knows if it should render itself
	 * To prevent the help center from flashing on the screen, we hide it until the banner queries and logic are complete
	 *
	 * Since we don't render the OnboardingEditorBanner on live pages, loaded state should always be true for live pages to render the Help Manager.
	 */ const [isOnboardingBannerDataLoaded, setIsOnboardingBannerDataLoaded] = (0, $42omo.useState)(isLivePage);
    const [isHelpMenuOpen, setIsHelpMenuOpen] = (0, $42omo.useState)(false);
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const openHelpDialog = ()=>{
        editorApi?.helpDialog?.actions.openHelp();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !areBannersHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7WFax.HelpWidget), {
        contentId: contentId,
        openHelpDialog: openHelpDialog,
        isNCSEditor: true,
        isCompanyHub: isCompanyHub,
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        isOpen: isHelpMenuOpen,
        setIsOpen: setIsHelpMenuOpen
    }), isOnboardingBannerDataLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cauOq.EditorHelpCenter), {
        contentId: contentId,
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        isCompanyHub: isCompanyHub,
        setIsOpen: setIsHelpMenuOpen
    }), !isLivePage && !isInCompanyHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hQDqA.OnboardingEditorBanner), {
        contentId: contentId,
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        isShowingOfflineBanner: isShowingOfflineBanner,
        version: version,
        spaceKey: spaceKey,
        editorActions: editorActions,
        setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        handleTitleChange: handleTitleChange
    })) : null);
};


const $9b9cd112fc8297b9$export$2319941692274211 = 'editor.content.placeholder.11';
const $9b9cd112fc8297b9$export$f7109619a5e9e0d6 = 'next-FullPageEditorComponent';
const $9b9cd112fc8297b9$export$b7b0d81eceb7980e = 'editor.content.placeholder.easy.mentions';
const $9b9cd112fc8297b9$export$a86989c71e454d74 = 'Type / for all elements or @ to mention someone.';
const $9b9cd112fc8297b9$export$7f03b831e2e40b16 = 'editor.content.placeholder.ai';
const $9b9cd112fc8297b9$export$b24394dc8739ac79 = 'editor.content.placeholder.controls';
const $9b9cd112fc8297b9$export$6a44b93c4f739392 = "Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone (we\u2019ll let them know).";
const $9b9cd112fc8297b9$export$e57dbc13424cb25a = 'Select + or type / to insert elements';


/* eslint-disable check-file/filename-blocklist */ 


const $48dba10f6de5f65d$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    placeholderBracketHint: {
        id: "full-page-editor.place.holder.bracket.hint",
        defaultMessage: "Any element can be quickly inserted by typing /"
    },
    blogpostPermissionsNotice: {
        id: "full-page-editor.permissions.blogpost-access",
        defaultMessage: "Default access to this blog is now in effect."
    },
    editorEmptyDocumentPlaceholder: {
        id: "full-page-editor.content.placeholder.empty.doc",
        defaultMessage: "Type / to insert elements"
    },
    editorEmptyDocumentPlaceholderAI: {
        id: "full-page-editor.content.placeholder.empty.doc.ai",
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "Use {key}+' to ask AI, or type / to insert elements"
    },
    editorEmptyDocumentSpaceShortcutPlaceholder: {
        id: "full-page-editor.content.placeholder.space-shortcut",
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "Press space to Ask Rovo or / to insert elements"
    },
    commentLinkNotFoundFlagTitle: {
        id: "full-page-editor.comment-link-not-found.flag.title",
        defaultMessage: "This comment is not available"
    },
    commentLinkNotFoundFlagDescription: {
        id: "full-page-editor.comment-link-not-found.flag.description",
        defaultMessage: "It may be deleted."
    },
    commentRemovedByRovoTitle: {
        id: "full-page-editor.rovo.removed.flag.title",
        defaultMessage: "Comments deleted"
    },
    commentRemovedByRovoDescription: {
        id: "full-page-editor.rovo.removed.flag.description",
        defaultMessage: "One or more comments were deleted in your latest edit with Rovo."
    },
    commentRemovedByRovoViewCommentCTA: {
        id: "full-page-editor.rovo.removed.flag.cta.view-comment",
        defaultMessage: "Go to comment"
    }
});











var $9VJDA = parcelRequire("9VJDA");





var $j0gZR = parcelRequire("j0gZR");




const $8dcb77f48242281e$var$i18n = (0, $cgtv4.defineMessages)({
    fallbackFlagTitle: {
        id: "full-page-editor.unsupported-macro.fallback-flag.title",
        defaultMessage: "This element may require you to publish"
    },
    fallbackFlagDescription: {
        id: "full-page-editor.unsupported-macro.fallback-flag.description",
        defaultMessage: "To fully display and use this element, publish your page via the <menuIcon></menuIcon> menu on the toolbar."
    },
    fallbackFlagLivePageDescription: {
        id: "full-page-editor.unsupported-macro.fallback-flag.live-page.description",
        defaultMessage: "The results of this element aren\u2019t visible when editing a live doc. Convert this doc to a page and publish it via the <menuIcon></menuIcon> menu to display it fully."
    },
    fallbackFlagLearnMoreAction: {
        id: "full-page-editor.unsupported-macro.fallback-flag.action",
        defaultMessage: "Learn more about this EAP"
    }
});
const $8dcb77f48242281e$export$210750141a74fdf7 = (flags, isLivePage)=>{
    const intl = (0, $8C5kA.default)();
    const macroFallbackUiAllowlist = (0, $42omo.useMemo)(()=>{
        const allowlist = (0, $4VJDS.default).getStringList('confluence_frontend_macro_fallback_ui_allowlist', []);
        return allowlist.map((m)=>m.trim().toLowerCase());
    }, []);
    const showMacroFallbackFlag = (0, $42omo.useCallback)(async ({ macro: macro, isBodiedExtension: isBodiedExtension })=>{
        if (!macroFallbackUiAllowlist || !macro || !isLivePage || macroFallbackUiAllowlist[0] === 'allow_all') return;
        const macroKey = macro.toLowerCase();
        const is2PNonBodied = !(0, $j0gZR.is1PMacro)(macroKey) && !isBodiedExtension;
        if (is2PNonBodied || isBodiedExtension) return;
        // If macro is in the allowlist don't show the warning
        if (macroFallbackUiAllowlist.includes(macroKey)) return;
        await flags.showFlag({
            type: 'warning',
            close: 'auto',
            title: intl.formatMessage($8dcb77f48242281e$var$i18n.fallbackFlagTitle),
            description: intl.formatMessage(isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? $8dcb77f48242281e$var$i18n.fallbackFlagLivePageDescription : $8dcb77f48242281e$var$i18n.fallbackFlagDescription, {
                menuIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                        label: "Icon for publish menu"
                    })
            }),
            messageType: 'transactional',
            messageId: 'editor-macro-fallback-flag'
        });
    }, [
        flags,
        macroFallbackUiAllowlist,
        intl,
        isLivePage
    ]);
    return {
        showMacroFallbackFlag: showMacroFallbackFlag
    };
};



var $eLnQS = parcelRequire("eLnQS");









var $7vJCW = parcelRequire("7vJCW");


var $5RPbY = parcelRequire("5RPbY");





var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");








var $ausiN = parcelRequire("ausiN");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1a6ac472bb8e7312$var$EICByLinePlaceholder = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4t3ixy5q",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3ixy5q",
            __cmplp.className
        ])
    });
});
const $1a6ac472bb8e7312$export$3e11d22d8f198f93 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { isLivePage: isLivePage } = t0;
    if (isLivePage) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ausiN.LivePagesByLinePlaceholderComponent), null);
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    } else {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1a6ac472bb8e7312$var$EICByLinePlaceholder, {
                "data-testid": "editor-in-context-by-line-placeholder"
            }, "\xa0");
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
} : ({ isLivePage: isLivePage })=>{
    if (isLivePage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ausiN.LivePagesByLinePlaceholderComponent), null);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1a6ac472bb8e7312$var$EICByLinePlaceholder, {
        "data-testid": "editor-in-context-by-line-placeholder"
    }, "\xa0");
};



const $b9ff99b32dac7da1$export$a5fad03eb2e226dc = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cpz9T",
    name: "EditorByLineArea",
    loader: async ()=>(await (parcelRequire("abFjU"))).EditorByLineArea,
    loading: (0, $1a6ac472bb8e7312$export$3e11d22d8f198f93)
});



var $9iTNj = parcelRequire("9iTNj");




var $38qvz = parcelRequire("38qvz");








var $bMPhU = parcelRequire("bMPhU");




const $08a4a4f0ffa330f8$export$4907a23e9e92d796 = ({ contentId: contentId, cloudId: cloudId, linkCreation: linkCreation, focusEditor: focusEditor, onFocusChanged: onFocusChanged, debounceOnChange: debounceOnChange, userOffline: userOffline, templateSuggestionsRef: templateSuggestionsRef, templateButtonRef: templateButtonRef, viewMode: viewMode, contentClassificationMetadata: contentClassificationMetadata, version: version, isEditorEmpty: isEditorEmpty, editorApi: editorApi, editorSessionId: editorSessionId, isSeamlessTransitionInProgress: isSeamlessTransitionInProgress = false, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    const { collabEditState: collabEditState, contentType: contentType, shouldRenderPreview: shouldRenderPreview, isPublishingContent: isPublishingContent, isUnpublishedDraft: isUnpublishedDraft, spaceKey: spaceKey } = (0, $6b433f129bb94645$export$87f05b83083ffee2)();
    const { contentComponentsTitle: contentComponentsTitle, contentComponentsDisabled: contentComponentsDisabled, handleTitleChange: handleTitleChange, breadcrumbsClickHandler: breadcrumbsClickHandler } = (0, $82bb8752b1a17b39$export$69a815b52f63537)();
    const { isKnowledgeBaseSpace: isKnowledgeBaseSpace } = (0, $38qvz.useSpaceType)({
        spaceKey: spaceKey
    });
    const homepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const isSpaceOverview = homepageId === contentId;
    const transitionId = (0, $dPJCf.useTransitionId)();
    const isInitialLoad = !transitionId;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const ssrOrInitial = isInitialLoad && window.__SSR_RENDERED__;
    // For Live Pages, title component doesn't send metadata to NCS via client websocket message broadcast, hence is not dependent on collab being connected
    const disableTitleAsNotConnected = contentComponentsDisabled || !isLivePage && !collabEditConnected;
    const isTitleDisabled = !ssrOrInitial && (disableTitleAsNotConnected || linkCreation);
    const [isTitleGenerating, setIsTitleGenerating] = (0, $42omo.useState)(false);
    const handleTitleGeneratingChange = (0, $42omo.useCallback)((isGenerating)=>{
        setIsTitleGenerating(isGenerating);
    }, []);
    const EditorAppearanceButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RPbY.EditorAppearanceButtonNext), {
        contentId: contentId,
        disabled: contentComponentsDisabled || !collabEditConnected,
        isStatusDisconnected: collabEditState.collabEditInternetLost
    });
    const breadcrumbsComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7vJCW.EditorBreadcrumbs), {
        key: "breadcrumbs-line",
        contentId: contentId,
        contentType: contentType,
        EditContentAppearanceButton: EditorAppearanceButton,
        breadcrumbsClickHandler: breadcrumbsClickHandler,
        isPublishingContent: isPublishingContent,
        userOffline: userOffline,
        collabEditInitialized: collabEditState.collabEditInitialized,
        moveLocationConfig: {
            spaceKey: spaceKey,
            isUnpublishedDraft: isUnpublishedDraft
        },
        isKnowledgeBaseSpace: isKnowledgeBaseSpace
    });
    const shouldShowLivePagesByLine = isEmbeddedConfluence ? hasByLineContributors || hasByLineExtensions || hasReactions : true;
    const livePagesByLineComponent = shouldShowLivePagesByLine ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b9ff99b32dac7da1$export$a5fad03eb2e226dc), {
        contentId: contentId,
        contentType: contentType,
        isPublishingContent: isPublishingContent,
        userOffline: userOffline,
        editorAppearanceButton: EditorAppearanceButton,
        isLivePage: isLivePage,
        isKnowledgeBaseSpace: isKnowledgeBaseSpace,
        viewMode: viewMode,
        editorApi: editorApi,
        isUnpublishedDraft: isUnpublishedDraft,
        isSpaceOverview: isSpaceOverview,
        hasByLineContributors: hasByLineContributors,
        hasByLineExtensions: hasByLineExtensions,
        hasReactions: hasReactions
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9iTNj.TitleAreaContentComponents), {
        key: "title-area-content-components",
        title: contentComponentsTitle,
        breadcrumbsComponent: breadcrumbsComponent,
        contentId: contentId,
        cloudId: cloudId,
        isDisabled: isTitleDisabled,
        onChange: handleTitleChange,
        focusEditor: focusEditor,
        onFocusChanged: onFocusChanged,
        debounceOnChange: debounceOnChange,
        contentType: contentType,
        userOffline: userOffline,
        isInPreview: shouldRenderPreview,
        isPublishingContent: isPublishingContent,
        isUnpublishedDraft: isUnpublishedDraft,
        templateSuggestionsRef: templateSuggestionsRef,
        templateButtonRef: templateButtonRef,
        contentTopperComponent: livePagesByLineComponent,
        linkCreation: linkCreation,
        viewMode: viewMode,
        contentClassificationMetadata: contentClassificationMetadata,
        version: version,
        isEditorEmpty: isEditorEmpty,
        contentComponentsDisabled: contentComponentsDisabled,
        isStatusDisconnected: collabEditState.collabEditInternetLost,
        editorApi: editorApi,
        editorSessionId: editorSessionId,
        isSeamlessTransitionInProgress: isSeamlessTransitionInProgress,
        isTitleGenerating: isTitleGenerating,
        onTitleGeneratingChange: handleTitleGeneratingChange
    });
};












var $ikPi2 = parcelRequire("ikPi2");




const $57b1365ec21ea4d6$export$12026d53c57123e6 = (editorPresetAPI)=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ collabEditInitialized: collabEditInitialized }] = (0, $hYoU4.useNativeCollabState)();
    // FIXME: https://product-fabric.atlassian.net/browse/ED-25722
    const [loomInsertUrlState, loomInsertUrlActions] = (0, $ikPi2.useLoomInsertUrlState)();
    (0, $42omo.useEffect)(()=>{
        try {
            /**
			 * Insert Loom video at the top of the editor.
			 * Ensure the collab service plugin and editorPresetAPI have been initialized
			 * and the Loom video is present, to prevent premature Loom video insertion.
			 * After insertion, delete the Loom video to ensure no more insertions occur.
			 */ if (collabEditInitialized && editorPresetAPI && loomInsertUrlState.fullPageEditorLoomUrl) {
                editorPresetAPI?.loom?.actions.insertLoom({
                    sharedUrl: loomInsertUrlState.fullPageEditorLoomUrl.sharedUrl,
                    title: loomInsertUrlState.fullPageEditorLoomUrl.title || ''
                }, 'start');
                loomInsertUrlActions.updateFullPageEditorLoomUrl(undefined);
                experienceTracker.succeed({
                    name: (0, $irVI7.LOOM_PAGE_HEADER_CONTENT_INSERTION),
                    attributes: {
                        inserted: true
                    }
                });
            }
        } catch (error) {
            loomInsertUrlActions.updateFullPageEditorLoomUrl(undefined);
            experienceTracker.fail({
                name: (0, $irVI7.LOOM_PAGE_HEADER_CONTENT_INSERTION),
                error: error
            });
        }
    }, [
        collabEditInitialized,
        editorPresetAPI,
        experienceTracker,
        loomInsertUrlActions,
        loomInsertUrlState.fullPageEditorLoomUrl
    ]);
};























const $df142c0f7d22fd62$export$f08b3cfa3cbddb9c = ({ contentId: contentId })=>{
    const wasStartedRef = (0, $42omo.useRef)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { livePageReleasePhase: livePageReleasePhase } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    return (0, $42omo.useCallback)(()=>{
        if (!wasStartedRef.current && isLivePage) {
            experienceTracker.start({
                name: (0, $irVI7.EDIT_PAGE_EXPERIENCE),
                attributes: {
                    contentId: contentId,
                    isLivePage: isLivePage,
                    livePageReleasePhase: livePageReleasePhase
                }
            });
            wasStartedRef.current = true;
        }
    }, [
        wasStartedRef,
        experienceTracker,
        isLivePage,
        contentId,
        livePageReleasePhase
    ]);
};





function $b3e3043e802ac415$export$befb12a9d0ae7ad9({ editorApi: editorApi, contentId: contentId }) {
    const startLivePageEditExperience = (0, $df142c0f7d22fd62$export$f08b3cfa3cbddb9c)({
        contentId: contentId
    });
    const { hasEditorContentChangedByLocalUserExcludingComments: hasEditorContentChangedByLocalUserExcludingComments } = (0, $16o3K.useHasEditorContentChanged)({
        editorPresetAPI: editorApi
    });
    const { setEditorApi: setEditorApi } = (0, $kDhla.useFullPageEditorApiActions)();
    (0, $42omo.useEffect)(()=>{
        if (editorApi) // FIXME: https://product-fabric.atlassian.net/browse/ED-25722
        // @ts-expect-error
        setEditorApi(editorApi);
    }, [
        editorApi,
        setEditorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (editorApi && hasEditorContentChangedByLocalUserExcludingComments) startLivePageEditExperience();
    }, [
        editorApi,
        startLivePageEditExperience,
        hasEditorContentChangedByLocalUserExcludingComments
    ]);
}














const $aa4689242ad06a0b$export$dc599391a17e1b5b = ({ disabled: disabled, collabEditInternetLost: collabEditInternetLost, internetDisconnected: internetDisconnected, api: api })=>{
    const { isDesktop: isDesktop } = (0, $2JYae.useIsDesktop)();
    const isOfflineStorageDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'editorOfflineStorage.disabled', {
        disabled: !(isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false))
    }) ?? false;
    const inactiveSyncing = (0, $b3YrF.useSharedPluginStateSelector)(api, 'editorOfflineStorage.inactiveSyncing', {
        disabled: !(isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false))
    }) ?? false;
    return (0, $42omo.useMemo)(()=>{
        if (isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)) {
            if (inactiveSyncing) return true;
            if (isOfflineStorageDisabled) return disabled;
            return disabled && !(collabEditInternetLost || internetDisconnected);
        }
        return disabled;
    }, [
        isDesktop,
        collabEditInternetLost,
        internetDisconnected,
        disabled,
        isOfflineStorageDisabled,
        inactiveSyncing
    ]);
};





const $e5418cfc53a98775$export$c0a34c12e787105e = ({ collabEditInternetLost: collabEditInternetLost, internetDisconnected: internetDisconnected, editorFullPagePresetAPI: editorFullPagePresetAPI })=>{
    (0, $42omo.useEffect)(()=>{
        const isDisconnected = collabEditInternetLost || internetDisconnected;
        if (isDisconnected) editorFullPagePresetAPI?.core.actions.execute(editorFullPagePresetAPI?.connectivity?.commands.setMode('offline'));
        else editorFullPagePresetAPI?.core.actions.execute(editorFullPagePresetAPI?.connectivity?.commands.setMode('online'));
    }, [
        collabEditInternetLost,
        internetDisconnected,
        editorFullPagePresetAPI
    ]);
};








const $767f50cadbc92220$export$4da6e3f66c58b328 = (editorFullPagePresetAPI)=>{
    const historyCanUndo = (0, $b3YrF.useSharedPluginStateSelector)(editorFullPagePresetAPI, 'history.canUndo');
    const historyCanRedo = (0, $b3YrF.useSharedPluginStateSelector)(editorFullPagePresetAPI, 'history.canRedo');
    const canUndo = editorFullPagePresetAPI?.undoRedoPlugin?.actions.undo && historyCanUndo || false;
    const canRedo = editorFullPagePresetAPI?.undoRedoPlugin?.actions.redo && historyCanRedo || false;
    const undo = (0, $42omo.useCallback)(()=>{
        if (!editorFullPagePresetAPI?.undoRedoPlugin?.actions) return false;
        return editorFullPagePresetAPI.undoRedoPlugin.actions.undo();
    }, [
        editorFullPagePresetAPI
    ]);
    const redo = (0, $42omo.useCallback)(()=>{
        if (!editorFullPagePresetAPI?.undoRedoPlugin?.actions) return false;
        return editorFullPagePresetAPI.undoRedoPlugin.actions.redo();
    }, [
        editorFullPagePresetAPI
    ]);
    const activateFindReplace = (0, $42omo.useCallback)(()=>{
        if (!editorFullPagePresetAPI?.findReplace?.actions) return false;
        return editorFullPagePresetAPI.findReplace.actions.activateFindReplace();
    }, [
        editorFullPagePresetAPI
    ]);
    return {
        canUndo: canUndo,
        canRedo: canRedo,
        undo: undo,
        redo: redo,
        activateFindReplace: activateFindReplace
    };
};


/**
 * @graphql cc
 */ 









var $9FoVw = parcelRequire("9FoVw");



















/**
 * @generated SignedSource<<e9a86803f0639bc2dab372633167789e>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $69af2cdb1717ff4e$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});


function $39cea118bb4c75f1$export$1a19d181d558cc48({ commentId: commentId, contentId: contentId, annotationState: annotationState, handleGqlError: handleGqlError }) {
    // this is for focused comment
    const { data: data } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useFocusedCommentInlineCommentMarkerRefQuery($commentId:ID!$pageId:ID!$contentStatus:[GraphQLContentStatus]){comments(commentId:$commentId pageId:$pageId contentStatus:$contentStatus){nodes{id location{type ...on InlineComment{inlineMarkerRef inlineResolveProperties{resolved}}}parentId}}}`, {
        variables: {
            commentId: commentId || '',
            pageId: contentId,
            contentStatus: [
                (0, $69af2cdb1717ff4e$export$b634e5de755b7d35).DRAFT,
                (0, $69af2cdb1717ff4e$export$b634e5de755b7d35).CURRENT
            ]
        },
        skip: !commentId,
        onError: handleGqlError,
        fetchPolicy: 'cache-first'
    });
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentContainerToFocus: setCommentContainerToFocus } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const hasOpenedFocusedComment = (0, $42omo.useRef)(false);
    const [{ shouldUpdateUnreadCommentsOnFirstRender: shouldUpdateUnreadCommentsOnFirstRender }] = (0, $fHAwL.useUnreadComments)();
    // Reset hasOpenedFocusedComment when commentId changes
    (0, $42omo.useEffect)(()=>{
        if (hasOpenedFocusedComment.current && (0, $9wGTI.fg)('confluence_comment_notification_deeplink')) hasOpenedFocusedComment.current = false;
    }, [
        commentId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (hasOpenedFocusedComment.current) return;
        const focusedComment = data?.comments?.nodes?.[0] ?? null;
        if (commentId && focusedComment && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') || !shouldUpdateUnreadCommentsOnFirstRender)) {
            const markerRef = focusedComment.location.inlineMarkerRef ?? '';
            const isResolved = Boolean(focusedComment.location.inlineResolveProperties?.resolved);
            if (isResolved && (0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                if (markerRef) {
                    setCurrentlySelectedThreadKey(markerRef);
                    setCommentContainerToFocus(commentId); // we'll be using this to scroll to it using data-comment-id
                    hasOpenedFocusedComment.current = true;
                }
            } else if (// dangling comment
            markerRef && annotationState?.annotationsLoaded && !(markerRef in annotationState.annotations) && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) {
                setCurrentlySelectedThreadKey(markerRef);
                setCommentContainerToFocus(commentId); // we'll be using this to scroll to it using data-comment-id
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                });
                hasOpenedFocusedComment.current = true; // to prevent focused comment from being opened again. We may need a better way to handle this
            } else {
                const commentElement = document.getElementById(markerRef);
                if (commentElement && markerRef !== '') {
                    // Use new unified navigation when feature flag is enabled
                    if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) {
                        const success = (0, $9FoVw.handleDeepLinkNavigation)({
                            scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                            context: (0, $9FoVw.NavigationContext).EDITOR,
                            block: 'center',
                            inline: 'nearest',
                            markElement: commentElement,
                            commentId: commentId
                        });
                        if (success) hasOpenedFocusedComment.current = true;
                    } else if ((0, $9wGTI.fg)('confluence-fe-comments-deep-link-behavior')) {
                        const existingComment = document.querySelector(`[data-comment-id="${commentId}"]`);
                        if (existingComment) {
                            const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
                            const allRepliesVisible = !showMoreButton;
                            if (allRepliesVisible) existingComment.scrollIntoView({
                                behavior: 'instant',
                                block: 'center'
                            });
                            else (0, $i49vP.openInlineCommentInEditor)({
                                targetElement: commentElement,
                                targetElementID: markerRef
                            });
                        } else // Watch for comment to be rendered using common utility
                        (0, $aHcFH.watchForCommentRepliesAndScroll)({
                            targetCommentId: commentId,
                            onScrollReady: (commentElementToScroll)=>{
                                commentElementToScroll.scrollIntoView({
                                    behavior: 'instant',
                                    block: 'center'
                                });
                            },
                            onFallback: ()=>{
                                (0, $i49vP.openInlineCommentInEditor)({
                                    targetElement: commentElement,
                                    targetElementID: markerRef
                                });
                            }
                        });
                    }
                    !(0, $9wGTI.fg)('confluence_comments_unified_navigation') && (0, $i49vP.openInlineCommentInEditor)({
                        targetElement: commentElement,
                        targetElementID: markerRef,
                        shouldScroll: false
                    });
                    hasOpenedFocusedComment.current = true;
                }
            }
        }
        return ()=>{
            if ((0, $9wGTI.fg)('confluence_comment_notification_deeplink')) hasOpenedFocusedComment.current = false;
        };
    }, [
        commentId,
        data,
        annotationState?.annotations,
        annotationState?.annotationsLoaded,
        shouldUpdateUnreadCommentsOnFirstRender,
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        setCommentContainerToFocus
    ]);
}





/* EditorControlsBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 













var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $5nBzc = parcelRequire("5nBzc");


var $2Nwuj = parcelRequire("2Nwuj");


var $fpGTa = parcelRequire("fpGTa");



var $bUlM5 = parcelRequire("bUlM5");

var $cwkWT = parcelRequire("cwkWT");

var $5dK2X = parcelRequire("5dK2X");







var $luv00 = parcelRequire("luv00");


var $j5cB3 = parcelRequire("j5cB3");


var $dcvq8 = parcelRequire("dcvq8");


var $lx6jn = parcelRequire("lx6jn");










const $3faf0024169aae07$var$BannerImageLight = ({ title: title, titleId: titleId, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "56px",
        viewBox: "0 0 477 81",
        fill: "none",
        "aria-labelledby": titleId,
        ...props
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#EED7FC",
        d: "M-68.35-87.55c.706 3.65 1.105 7.55 1.162 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.55 38.086-.142.036-.292.079-.434.114-.613.157-1.226.307-1.853.45-.192.042-.392.092-.584.135-.769.164-1.546.32-2.337.463a68.966 68.966 0 0 1-8.422.949c-.969.05-1.945.085-2.935.1a74.01 74.01 0 0 1-5.059-.115c-.427-.021-.855-.042-1.282-.07a71.101 71.101 0 0 1-5.508-.607 56.036 56.036 0 0 1-2.23-.385 15.078 15.078 0 0 1-.549-.114 66.927 66.927 0 0 1-1.717-.364 11.145 11.145 0 0 1-.47-.114 41.712 41.712 0 0 1-1.91-.492c-.057-.014-.114-.028-.164-.042-12.141-3.366-21.823-10.374-27.88-20.67-4.125 6.98-9.953 12.47-17.114 16.32l.406.15a50.29 50.29 0 0 1-2.323 1.198c-.149-.05-.306-.107-.456-.157l-.52.243c.193.07.335.135.414.178-.008 0-.015.007-.029.014l-.463-.157a53.928 53.928 0 0 1-8.322 2.966c-.142.036-.292.079-.435.114a70.62 70.62 0 0 1-1.852.45c-.193.042-.392.092-.584.135-.77.164-1.547.32-2.337.463a68.969 68.969 0 0 1-8.422.948c-.969.05-1.945.086-2.936.1a73.98 73.98 0 0 1-5.058-.114 76.37 76.37 0 0 1-1.311-.071 70.424 70.424 0 0 1-5.48-.606c-.256-.036-.505-.086-.755-.128l.107.356a62.432 62.432 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a64.599 64.599 0 0 1-1.132-.25 10.069 10.069 0 0 1-.471-.114 41.67 41.67 0 0 1-1.909-.492c-.057-.014-.114-.028-.164-.043-13.096-3.607-23.32-11.457-29.241-23.092v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138.285-1.497.613-2.945.983-4.363a61.02 61.02 0 0 1 2.679-8.007 56.391 56.391 0 0 1 1.482-3.23l.129-.249c.064-.121.128-.236.192-.364.335-.649.67-1.305 1.026-1.932a50.705 50.705 0 0 1 12.262-14.452 54.475 54.475 0 0 1 5.052-3.629 59.73 59.73 0 0 1 6.484-3.55 58.52 58.52 0 0 1 2.472-1.112 71.218 71.218 0 0 1 8.564-2.988c.114-.035.235-.057.349-.092l.727-.193c.228-.057.449-.121.677-.178.406-.107.805-.221 1.211-.314 6.961-1.69 14.215-2.495 22.323-2.495 1.161 0 2.308.014 3.455.05.342.007.677.028 1.019.042 1.112.043 2.223.1 3.321.179 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542v-.007c.178.057.356.107.534.157h-.014c.092-.029.185-.057.285-.079l.256.086c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.12 7.593 6.385 2.816 12.028 6.431 16.816 10.958 10.26 9.796 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.579c5.45-6.83 8.208-17.639 8.393-33.075l40.391-.114v.007h.221c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.414-17.703 8.607-33.346h.491v-.007l40.392-.114c.278 15.764 3.078 26.693 8.678 33.46h63.904c-6.897-11.893-11.863-24.505-11.863-36.069 0-2.346.086-4.663.25-6.959.498-6.873 2.073-12.997 4.496-18.38.313-.699.641-1.376.983-2.046.1-.2.206-.399.306-.599.185-.349.378-.699.57-1.041 6.562-11.771 17.428-19.485 29.647-23.121a56.626 56.626 0 0 1 3.912-1.006 59.845 59.845 0 0 1 11.151-1.397c.427-.014.862-.036 1.289-.036v-.043c.086 0 .164.022.25.022.085 0 .163-.022.249-.022v.043c.292 0 .584.022.869.029a59.49 59.49 0 0 1 11.792 1.461 54.24 54.24 0 0 1 1.532.364c.199.05.392.107.591.164 1.069.285 2.124.599 3.171.941 6.192 2.046 11.998 5.155 17.022 9.333a46.662 46.662 0 0 1 7.003 7.222c5.722 7.315 9.548 16.683 10.382 28.126.163 2.296.249 4.62.249 6.959 0 2.203-.185 4.442-.52 6.709-.036.242-.079.485-.121.72-.036.235-.079.463-.121.699-.079.449-.164.891-.257 1.34-1.788 8.791-5.8 17.888-10.851 26.601H425v-292.23c-3.142 2.788-6.548 5.234-10.175 7.372-19.173 11.294-44.36 14.01-67.787 14.01h-65.001c-14.592 0-24.646 6.039-24.646 21.646 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a224.095 224.095 0 0 1-.492-11.885 325.16 325.16 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.022-.342.036-.506.028-.392.05-.784.078-1.17.107-1.44.242-2.851.406-4.241.727-6.267 1.988-12.078 3.791-17.418a69.698 69.698 0 0 1 2.707-6.852c.25-.549.513-1.09.777-1.625a60.153 60.153 0 0 1 2.558-4.67 54.424 54.424 0 0 1 1.902-2.938 57.44 57.44 0 0 1 4.254-5.454c.157-.178.328-.356.484-.534.221-.25.449-.5.677-.742a57.671 57.671 0 0 1 7.759-6.901c9.377-6.945 21.261-11.486 35.554-13.518 4.289-.606 8.785-.991 13.502-1.14 1.575-.05 3.171-.08 4.788-.08h74.442c1.211 0 2.38-.035 3.527-.1l.648-.042c13.039-.87 21.881-6.01 25.771-16.961.043-.122.093-.243.136-.364.164-.478.32-.97.463-1.476.035-.114.064-.235.092-.349.307-1.098.563-2.246.777-3.451H101.425c-4.51 20.719-12.005 37.659-23.056 50.635a292.48 292.48 0 0 1 21.24 2.467l-9.59 63.396C43.434-8.347 21.482 3.46 16.687 35.151l-61.952-9.383c4.018-26.55 12.155-47.74 25.372-63.261a292.481 292.481 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.826c10.502 6.531 17.79 16.976 20.498 30.936l-.021-.007Zm171.407 305.704c-1.61.264-3.299.406-5.059.414a32.17 32.17 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.37 29.37 0 0 1-.456-5.126c0-1.839.143-3.572.435-5.197 1.717-9.647 8.422-15.628 17.862-17.233a32.23 32.23 0 0 1 5.266-.442c1.76 0 3.448.129 5.059.385 9.447 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.366.456 5.198 0 1.811-.143 3.522-.421 5.133-1.703 9.689-8.421 15.7-17.876 17.261l.007-.007Zm121.524-17.546c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.059.413-1.831 0-3.591-.135-5.265-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.37 29.37 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32.112 32.112 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30.17 30.17 0 0 1-.42 5.133l.007-.007Zm20.748-40.953c.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563v64.58c-23.278 6.488-68.5.286-68.5.286v-.008ZM362.065 16.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.581c-23.277 6.488-68.499.285-68.499.285.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563Zm-401.572 98.154c.498-9.982 2.707-18.416 6.198-25.517 7.646-15.55 21.668-24.533 38.825-28.24 8.172-1.769 17.035-2.36 26.255-1.897 8.244.413 16.174 1.725 23.498 3.964l.022-.078h.014a57.887 57.887 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221a46.87 46.87 0 0 1 1.226-2.296c7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.564.926-.163 1.859-.313 2.807-.456 6.27-.92 12.846-1.198 19.565-.855 6.213.313 12.213 1.098 17.898 2.352 1.233.271 2.459.57 3.663.892l.733.192c.086.022.179.043.271.072.114.028.228.056.342.092.755.214 1.504.45 2.252.678.256.078.52.15.776.235 7.667 2.48 14.557 6.01 20.356 10.659a52.094 52.094 0 0 1 3.078 2.673 48.977 48.977 0 0 1 3.67 3.836c.292.342.577.691.862 1.04.192.236.378.478.57.714.556.713 1.09 1.44 1.61 2.181a49.36 49.36 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412c-2.429-4.906-3.691-12.185-4.346-18.744-3.719.264-7.545.321-11.429.192-.691-.021-1.382-.043-2.073-.071h-.071l-.684-.043c-.185-.007-.364-.021-.549-.035-7.787-.478-15.283-1.754-22.237-3.872-.955 3.28-2.137 6.353-3.541 9.197-7.695 15.621-21.852 24.626-38.86 28.319-7.923 1.718-16.444 2.31-25.215 1.868-4.631-.235-9.142-.72-13.495-1.476-1.304 6.46-3.292 13.575-6.199 18.209l-36.871-9.154s7.053-11.151 8.143-24.519c-5.856-5.219-10.445-11.7-13.373-19.571-2.73-7.336-4.062-15.827-3.57-25.666l-.021.007Zm-79.829 28.19 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.272-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.585-.727.213-1.461.406-2.202.563-.242-.207-.484-.414-.719-.621-5.045.97-10.46.628-16.01-1.019a45.598 45.598 0 0 1-6.926-2.695 46.789 46.789 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668l-.235-.043-.121-.021a29.164 29.164 0 0 1-1.347-2.51c.086.014.171.029.257.05-1.96-3.836-3.021-8.028-3.093-12.491-4.075-.307-7.98-.592-11.528-.82l.449-.228c-.969.107-1.852.121-2.707.1-.072.313-.136.62-.221.934a22.197 22.197 0 0 1-1.411 3.721 22.65 22.65 0 0 1-1.995 3.38c-4.389 6.081-11.001 7.964-18.005 5.889a24.096 24.096 0 0 1-3.605-1.405 24.154 24.154 0 0 1-3.477-2.039c-5.978-4.22-8.621-10.544-6.626-17.738a22.485 22.485 0 0 1 1.396-3.672 22.022 22.022 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.875 1.24.364 2.501.841 3.755 1.454a24.473 24.473 0 0 1 3.342 1.947c5.03 3.522 7.687 8.57 7.21 14.395 1.845.163 3.171.313 3.171.313l5.4.05s2.722.079 4.938.057a34.23 34.23 0 0 1 1.161-6.438c.642-2.31 1.532-4.663 2.679-7.051a43.12 43.12 0 0 1 3.898-6.58c5.885-8.107 13.822-12.3 22.664-12.77.492-8.17.948-16.398 2.231-22.059.748 2.638.071-6.46.591-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.122-35.584 35.568-5.126 5.122 35.584-20.206 2.909c-.549 6.901-1.225 13.51-1.468 14.23-.064-.12.121-.706-.292-.734-.085 1.034-.071 2.125-.15 3.223.649-.286.321-1.64.528-1.74.071 4.1-.584 12.42-1.233 17.018 3.043.086 6.177.585 9.355 1.512a47.373 47.373 0 0 1 7.218 2.787 45.491 45.491 0 0 1 6.419 3.744c3.912 2.737 7.076 5.946 9.398 9.546.164-.107.335-.214.499-.32a5.88 5.88 0 0 0-.392.491.854.854 0 0 1 .079.136c1.218-.685 8.949-7.593 9.796-7.743-.035.057-.292.47-.334.542 1.018-.371 2.999-2.802 3.726-2.396.185-.128.506-.392.919-.748-3.049-3.865-4.104-8.691-2.636-13.989a22.577 22.577 0 0 1 1.396-3.672 22.022 22.022 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.462 24.462 0 0 1 3.342 1.946c5.978 4.185 8.628 10.517 6.612 17.753a22.221 22.221 0 0 1-1.41 3.722 22.698 22.698 0 0 1-1.996 3.38c-4.389 6.08-11 7.963-18.005 5.888a24.072 24.072 0 0 1-3.605-1.404 24.246 24.246 0 0 1-3.477-2.04 20.03 20.03 0 0 1-2.971-2.552 1165.843 1165.843 0 0 1-14.272 10.623 29.08 29.08 0 0 1 1.397 2.902c.114.264.228.528.335.791v.03c2.166 5.738 2.451 12.198.534 19.085-.648 2.339-1.553 4.72-2.714 7.144-.015.029-.036.064-.05.093.149.092.299.178.449.271-.05.107-.093.213-.143.313a46.63 46.63 0 0 1-1.054 2.047c-.157-.093-.321-.186-.478-.286a42.937 42.937 0 0 1-1.966 3.187c3.021 1.512 7.303 4.107 9.497 5.725-.335-.071-1.083-.37-1.859-.834l-.143.214c1.824 1.012 3.249 2.995 5.422 3.151 0 0-2.109-1.561-2.486-2.003l.028-.014-.014-.043c4.261 2.189 9.17 5.183 13.416 7.65l17.97-14.224 22.294 28.198-28.18 22.309-22.294-28.198v.021Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M197.242 10.71a493.5 493.5 0 0 1-.064-1.547v-.17a227.753 227.753 0 0 1-.1-3.416c0-.121 0-.242-.007-.37l-.022-1.32c0-.2 0-.399-.007-.599 0-.399-.007-.798-.014-1.204V-.333c0-.92.014-1.826.036-2.731a40.67 40.67 0 0 1-4.696 1.362c-2.75.599-5.643 1.005-8.678 1.247l.37-.228h.015c-1.119-.007-2.323.136-1.846.285h-.249c1.347 1.348 2.273 2.282 2.608 2.688-.264-.228-2.316-1.989-2.644-2.267 2.038 2.239 6.391 6.324 10.488 9.91 1.66 1.469 3.278 2.86 4.653 4.043h.321a311.046 311.046 0 0 1-.164-3.202v-.07.006ZM178.96-.348c-7.944-.014-15.689-1.098-23.256-2.445a667.71 667.71 0 0 1-.107-1.448c.535 7.793 1.354 13.497 1.981 18.217h36.658c-.634-.55-1.275-1.098-1.902-1.655A311.884 311.884 0 0 1 178.96-.348Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#EED7FC",
        d: "M181.946.023c.327.278 2.379 2.039 2.643 2.267-.342-.406-1.268-1.333-2.608-2.688h.25c-.478-.15.726-.292 1.845-.285h-.014l-.371.228c3.036-.242 5.921-.649 8.678-1.247a40.672 40.672 0 0 0 4.696-1.362c.021-.877.05-1.74.085-2.602l-.484.192c-.477.185-.976.32-1.454.478-.962.335-1.952.57-2.921.805-3.911.927-7.788 1.29-11.329 1.412-.434.014-.869.029-1.296.036a421.776 421.776 0 0 1-6.726-6.916c-5.601-5.882-12.163-13.425-17.435-21.11-.029.37-.064.74-.093 1.118-.028.386-.05.785-.078 1.17.242.335.47.656.684.94.954 1.327 1.703 2.368 2.315 3.138-.755-.656-1.831-1.932-3.028-3.572 0 .071-.007.135-.014.207 4.489 6.43 9.783 12.783 15.582 19.014a409.898 409.898 0 0 0 5.757 6.01c-1.859-.02-3.583-.092-5.144-.156-5.336-.456-10.638-1.234-15.917-2.182.021.285.035.563.057.841.035.492.071.97.107 1.448 7.567 1.34 15.311 2.424 23.256 2.445a312.468 312.468 0 0 0 13.373 12.67c.627.556 1.269 1.105 1.903 1.654h2.857c-1.375-1.191-2.993-2.574-4.653-4.043-4.104-3.586-8.45-7.671-10.488-9.91h-.035Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M197.05 3.887c0 .45.015.884.022 1.32l-.022-1.32Zm.028 1.69c.029 1.176.057 2.31.1 3.415-.043-1.098-.071-2.239-.1-3.415Zm-.05-3.494c0 .407.007.806.014 1.205 0-.399-.007-.798-.014-1.205ZM372.866-38.79c-19.173 11.293-44.36 14.009-67.787 14.009h-65.002c-.912 0-1.802.021-2.679.071-13.124.72-21.966 6.945-21.966 21.575 0 4.534 1.005 11.578 1.503 17.11h-19.522a321.858 321.858 0 0 1-.164-3.2c.05 1.104.1 2.167.164 3.2.513 8.934 1.439 15.265 2.123 20.42h59.359c-.499-5.54-1.504-12.584-1.504-17.111 0-15.607 10.061-21.646 24.646-21.646h65.001c23.42 0 48.607-2.716 67.787-14.01A64.662 64.662 0 0 0 425-25.744v-92.749h-20.435v16.634c0 32.86-12.989 52.046-31.692 63.068h-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#EED7FC",
        d: "M383.126-107.549c0 9.411-1.909 16.491-5.557 21.582-3.086 4.306-7.425 7.193-12.904 8.855-.178.056-.37.1-.556.156-.826.236-1.667.45-2.543.635a48.078 48.078 0 0 1-6.876.884c-.605.036-1.225.064-1.852.078-.627.022-1.261.029-1.91.029h-74.599c-1.567 0-3.106.028-4.631.078-1.574.05-3.121.129-4.645.228-.763.05-1.518.107-2.266.172-.399.035-.798.07-1.197.114-.342.035-.691.064-1.04.1-.043 0-.079.007-.121.014l-.357.042-.791.086c-1.04.121-2.073.25-3.092.392a95.256 95.256 0 0 0-6.619 1.162 87.502 87.502 0 0 0-3.256.742 86.423 86.423 0 0 0-7.317 2.146c-4.204 1.44-8.116 3.18-11.728 5.204a63.718 63.718 0 0 0-5.201 3.244 58.442 58.442 0 0 0-2.815 2.082 36.5 36.5 0 0 0-.805.656 60.45 60.45 0 0 0-2.173 1.861c-4.631 4.178-8.522 9.048-11.657 14.609-.106.185-.206.378-.313.57-.093.171-.192.342-.285.513-.257.47-.506.956-.748 1.433-3.064 6.068-5.294 12.884-6.655 20.434a94.997 94.997 0 0 0-.527 3.294 105.5 105.5 0 0 0-.962 10.509c-.036.863-.064 1.725-.086 2.602a117.4 117.4 0 0 0-.035 2.73v2.418c0 .406.007.805.014 1.205 0 .2 0 .399.007.599 0 .449.014.884.022 1.319a242.213 242.213 0 0 0 .106 3.786v.17l.065 1.548v.071c.049 1.105.099 2.167.163 3.201h19.523c-.499-5.54-1.503-12.584-1.503-17.11 0-14.63 8.842-20.855 21.966-21.575.876-.05 1.767-.072 2.679-.072h65.001c23.42 0 48.607-2.716 67.788-14.01 18.703-11.015 31.692-30.2 31.692-63.068v-16.662h-21.432v10.944h.028Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M78.347-67.858C58.354-44.373 26.719-33.878-19.921-37.5a90.81 90.81 0 0 1 1.895-2.153 93.243 93.243 0 0 0-1.902 2.153C-33.145-21.98-41.282-.79-45.3 25.76l61.952 9.384C21.447 3.459 43.399-8.354 89.982-2.002l9.59-63.396c-7.403-1.12-14.478-1.94-21.24-2.467a220.48 220.48 0 0 0-4.167-.286c1.375.086 2.764.179 4.168.286l.014.007Zm215.217 83.666s.499 65.85 0 65.422c0 0 15.127 2.074 32.384 2.573v-3.437l-.043-9.646v-.02c0-.52 0-1.04-.007-1.554v-5.27c-.057-9.504-.107-16.584-.107-16.584.677.236 1.354.457 2.03.67l.485.15a67.963 67.963 0 0 0 2.202.65 90.53 90.53 0 0 0 1.909.505c.157.043.314.079.47.121.677.172 1.361.329 2.038.485.093.022.178.036.271.057a82.64 82.64 0 0 0 2.28.471c.691.135 1.375.257 2.066.378.1.014.2.035.299.05a94.24 94.24 0 0 0 1.896.3c.106.013.213.035.32.05.698.099 1.397.192 2.102.284.093.014.192.022.285.036.67.078 1.332.157 1.995.22.057 0 .114.015.171.022.713.072 1.432.136 2.138.193.078 0 .163.014.242.021 1.446.114 2.878.2 4.303.264h.164c1.454.057 2.886.093 4.304.1h.064c1.446.007 2.871 0 4.275-.043V16.371s-36.908 10.43-68.5-.563h-.036Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M348.713 51.934c.078 0 .164.014.242.021-.078 0-.164-.014-.242-.021Zm-22.757 31.869c.05 15.1.029 29.104-.199 28.911 0 0 45.222 6.203 68.5-.285v-64.58s-14.03 3.964-32.184 4.427v28.668c-9.811 2.738-23.527 3.216-36.11 2.852l-.007.007Zm-.199-36.518s.057 7.08.107 16.584c-.057-9.504-.107-16.584-.107-16.584Zm11.264 3.037c.135.029.27.058.413.079a7.366 7.366 0 0 0-.413-.079Zm9.375 1.398c.057 0 .114.014.171.021-.057 0-.114-.014-.171-.021Zm-14.021-2.453c.157.043.313.079.47.121-.157-.035-.313-.078-.47-.12Zm-2.08-.556c.057.014.114.029.178.05-.057-.014-.114-.028-.178-.05Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#EED7FC",
        d: "M357.727 52.319c-1.418-.007-2.85-.043-4.304-.1h-.164c-1.425-.057-2.857-.15-4.303-.264-.079 0-.164-.014-.242-.021-.713-.057-1.425-.121-2.138-.193-.057 0-.114-.014-.171-.021-.663-.071-1.332-.143-1.995-.221-.093-.014-.192-.021-.285-.036a74.149 74.149 0 0 1-2.102-.285c-.107-.014-.214-.035-.32-.05a86.6 86.6 0 0 1-1.896-.3c-.099-.014-.199-.035-.299-.05a99.632 99.632 0 0 1-2.066-.377 6.563 6.563 0 0 0-.413-.078 78.608 78.608 0 0 1-1.867-.393c-.093-.02-.178-.035-.271-.057a70.267 70.267 0 0 1-2.508-.606c-.634-.164-1.275-.328-1.909-.506-.057-.014-.114-.028-.179-.05-.676-.192-1.346-.392-2.023-.599l-.485-.15a68.617 68.617 0 0 1-2.03-.67s.057 7.087.107 16.584v5.269c0 .513 0 1.034.007 1.554v.022l.043 9.646v3.436c12.582.364 26.298-.12 36.109-2.852V52.283c-1.404.036-2.829.05-4.275.043h-.064l.043-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M66.278 67.07c-2.536-4.534-4.945-9.097-7.317-13.66-.036.078-.079.15-.121.22-1.397 2.824-2.58 5.868-3.534 9.134.463.142.919.285 1.375.427a73.413 73.413 0 0 1 9.604 3.872l-.007.007Zm93.473 9.204c-2.807 4.264-5.978 8.185-9.362 11.757-3.356 3.586-7.09 6.802-11.023 9.461.022-.021.464-.4.962-.82.25-.214.499-.42.677-.592a27.2 27.2 0 0 0 .314-.292 59.792 59.792 0 0 1-4.788 3.365c.171.378.342.763.506 1.141a65.376 65.376 0 0 0 2.565 4.734c3.683 6.082 8.407 11.172 13.594 14.901a43.937 43.937 0 0 0 3.584 2.317c.228-.035.463-.071.691-.1.812-.121 1.589-.235 2.344-.349.499-.071.984-.15 1.447-.214.27-.043.527-.078.783-.114.399-.791.77-1.604 1.162-2.396 1.047-2.074 1.874-4.249 2.786-6.388.427-1.076.805-2.181 1.211-3.265l.598-1.633c.193-.549.357-1.105.535-1.654l1.054-3.315.919-3.351.456-1.675.399-1.69.791-3.373.677-3.393.335-1.697.285-1.704c.192-1.134.378-2.274.57-3.408.157-1.14.314-2.274.47-3.415l.235-1.704.186-1.711c.128-1.14.249-2.275.377-3.408.798-9.098 1.361-18.188.813-27.022 0-.042-.008-.085-.008-.128a48.965 48.965 0 0 0-3.669-3.836 40.232 40.232 0 0 1-.556 5.968c-1.938 10.701-6.284 20.512-11.906 29.025l-.014-.022Zm-58.638-49.066c.342-.663.513-.962.484-.97-.021-.006-.242.279-.591.835-.342.563-.87 1.369-1.46 2.424-1.226 2.096-2.808 5.169-4.425 8.905-1.61 3.743-3.2 8.178-4.568 12.926-2.743 9.51-4.374 20.276-5.272 28.953a439.59 439.59 0 0 1-.171 1.697c3.042 3.872 5.536 8.263 7.374 13.204.4 1.077.77 2.182 1.112 3.308.035.029.071.05.1.079.812.584 1.631 1.183 2.515 1.704.434.263.855.556 1.31.798.45.243.906.478 1.361.72.45.257.92.464 1.397.663l1.418.614 1.468.499.733.249.749.186 1.503.37h.007c0-1.091 0-2.189.043-3.287.335-11.15 2.786-22.322 6.868-32.853 4.083-10.545 9.776-20.448 16.431-29.51a165.508 165.508 0 0 1 5.187-6.651c1.809-2.168 3.74-4.285 5.942-6.16l.128-.107c-5.693-1.262-11.685-2.046-17.898-2.353-6.719-.335-13.295-.064-19.565.855a84.868 84.868 0 0 0-3.798 5.975c.706-1.419 1.276-2.403 1.618-3.066v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M176.851 52.989c-.05 5.255-.428 10.901-.884 16.427-.869 11.072-2.75 21.574-3.747 27.834.513-2.26 1.054-4.549 1.475-6.895.484-2.331.84-4.712 1.246-7.115.699-4.813 1.333-9.732 1.71-14.73.392-4.998.727-10.06.77-15.136.028-2.16-.014-4.328-.107-6.488-.185-.242-.378-.478-.57-.713.1 2.167.135 4.449.107 6.823v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M178.738 61.324c-.826 16.583-3.37 33.288-8.528 47.832a111.022 111.022 0 0 1-4.96 11.828l2.679-.399a37.628 37.628 0 0 0-.427 1.961c-.036.178-.064.356-.1.527a42.736 42.736 0 0 0-.249 1.612c-.014.121-.036.242-.05.37-.057.485-.1.97-.142 1.455a44.29 44.29 0 0 0 2.422.599c-2.636-.271-2.337-.129-.342.285.05.007.107.021.157.028 5.272-4.327 9.661-9.71 12.882-16.284 3.448-7.022 5.629-15.343 6.12-25.174.499-9.982-.848-18.594-3.612-26.01a49.36 49.36 0 0 0-5.665-10.886c.114 4.085.022 8.185-.185 12.263v-.007Zm-16.75 10.786a37.13 37.13 0 0 0 1.617-3.13c-1.689 2.19-5.472 9.34-1.617 3.13ZM86.99 59.598c.192-.97.491-2.21.883-3.8.499-2.281 1.653-6.032 2.807-9.333 1.155-3.308 2.26-6.188 2.202-6.958-1.097 2.873-2.7 6.987-3.883 10.873-1.204 3.878-2.002 7.507-2.01 9.225v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M69.933 69.016c5.038 2.91 9.505 6.46 13.267 10.688l.043-.4c1.104-9.667 2.771-18.936 5.215-27.427 2.409-8.499 5.658-16.177 9.355-22.715a86.122 86.122 0 0 1 2.672-4.406 72.13 72.13 0 0 0-2.843.563c-16.017 3.486-29.511 11.714-37.463 25.795 2.658 5.07 5.337 10.117 8.144 15.093.527.942 1.076 1.868 1.618 2.802l-.008.007Zm61.14 17.233c.755 3.885 1.866 7.785 3.355 11.521.157-.085.307-.178.464-.264-1.219-3.065-2.501-7.436-3.285-11.763-.898-4.55-1.211-8.998-1.817-11.643.15 3.9.506 8.014 1.283 12.156v-.007Zm14.178-58.706.05-.057c.163-.157.313-.306.456-.442a5.425 5.425 0 0 1-.342-.093 12.67 12.67 0 0 0-.35.414l.179.178h.007ZM129.042 66.6c-.064.37-.135.463-.164.826-.035.528.164 1.355.221 1.804 0-.314.078-1.02.107-1.625.028-.6.057-1.098-.157-1.006h-.007Zm2.308-6.246c-.342 1.29-.862 3.187-1.125 5.183-.357 1.99-.414 4.064-.407 5.618l.25.05.192-3.28c.029-.784.157-1.554.221-2.131.071-.578.128-.963.15-.97l-.05-.035c.1-.079.306-.065.299-.528.663-3.33 1.019-4.934 1.09-5.397.064-.464-.256.192-.62 1.476v.014ZM110.367 78.57l.2.228c1.332-4.898 3.177-9.91 5.108-14.387l-.178-.221c-1.995 4.605-3.769 9.39-5.13 14.38Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M145.885 29.953c-2.472 2.816-4.56 6.039-6.369 9.44-3.577 6.837-6.171 14.33-7.439 22.023-.142.963-.342 1.918-.435 2.888l-.313 2.901c-.114 1.94-.278 3.872-.242 5.804-.05 1.932.107 3.85.199 5.76.221 1.904.378 3.8.741 5.662.271 1.875.763 3.7 1.183 5.518.541 1.79 1.026 3.586 1.71 5.297.207.62.449 1.227.698 1.826.15-.093.307-.186.456-.279 2.302-1.397 4.054-2.723 5.273-3.621.591-.47 1.054-.842 1.368-1.091.313-.25.47-.385.47-.385 1.974-1.676 3.798-3.53 5.572-5.433 1.788-1.89 3.434-3.907 5.03-5.953 1.589-2.054 3.049-4.2 4.453-6.388 1.361-2.21 2.651-4.456 3.805-6.78 0 0 .214-.4.563-1.148.349-.742.876-1.804 1.432-3.145a73.816 73.816 0 0 0 3.641-10.616c1.111-4.178 1.845-8.798 1.532-12.926-.015-.235-.05-.463-.072-.698-5.799-4.656-12.696-8.178-20.356-10.66-.256-.085-.52-.156-.776-.235a36.996 36.996 0 0 0-2.124 2.232v.007Zm-25.656 23.913c-1.832 3.244-3.164 6.132-2.843 6.203l.114-.236c1.503-2.866 2.743-5.104 3.968-7.329 1.247-2.21 2.494-4.413 4.204-7.072l-.178-.193c-1.126 1.804-3.463 5.376-5.273 8.634l.008-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M137.314 33.418a141.537 141.537 0 0 0-7.353 9.468c-4.695 6.61-8.949 13.825-12.404 21.596-3.456 7.771-6.099 16.106-7.539 24.804a90.711 90.711 0 0 0-1.232 15.457c.135.007.271.014.406.029l1.532.092c.513.007 1.019-.028 1.524-.035.506-.029 1.012 0 1.518-.093 1.005-.136 1.995-.214 2.985-.435 6.384-1.184 12.028-3.479 16.367-5.803-.52-1.227-.962-2.496-1.433-3.758-.313-.827-.527-1.69-.79-2.538-.25-.856-.528-1.697-.706-2.574l-.598-2.602c-.186-.87-.307-1.754-.456-2.624-.335-1.74-.442-3.508-.642-5.24-.213-3.48-.299-6.902-.021-10.16.435-6.523 1.746-12.355 3.199-16.854-.399 1.84-1.596 6.374-2.28 11.592l.242.122c.763-6.025 2.63-12.07 5.002-17.739 2.394-5.675 5.23-11.015 8.408-15.8 0 0-.62.735-1.504 1.926a56.993 56.993 0 0 0-3.092 4.663c-1.076 1.81-2.145 3.736-2.928 5.447-.414.848-.784 1.618-1.105 2.267l-.691 1.569v-.079l-.085.15c1.539-4.021 3.398-8.078 5.835-11.957 1.617-2.595 3.498-5.111 5.686-7.407-.242-.064-.485-.129-.734-.193-2.586 1.818-4.909 4.171-7.104 6.73l-.007-.02ZM62.78 58.436c.74 1.355 2.43 4.164 3.028 4.791-.72-1.647-4.774-8.384-3.028-4.79Zm106.789-9.539c.285-1.255.492-2.802.627-3.594.086-1.554.021-2.139-.043-2.103-.078.036-.149.692-.292 1.611-.235 1.84-.812 4.727-1.019 5.946.136.35.449-.606.727-1.86Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#EED7FC",
        d: "M69.933 69.016a567.385 567.385 0 0 1-1.617-2.802c-2.808-4.976-5.487-10.03-8.144-15.093-.42.749-.834 1.512-1.226 2.296 2.373 4.563 4.788 9.126 7.318 13.66a64.022 64.022 0 0 1 3.662 1.947l.007-.008Zm-4.118-5.796c-.606-.627-2.294-3.436-3.028-4.791-1.746-3.593 2.315 3.137 3.028 4.791Zm109.268 9.047c-.128 1.134-.249 2.275-.377 3.409l-.185 1.71-.236 1.705-.47 3.415c-.192 1.133-.377 2.267-.57 3.408l-.285 1.704-.335 1.697-.677 3.393-.79 3.373-.399 1.69-.456 1.675-.92 3.351-1.054 3.315c-.178.549-.342 1.112-.534 1.654l-.599 1.633c-.406 1.09-.784 2.188-1.211 3.265-.912 2.139-1.739 4.313-2.786 6.388-.392.799-.762 1.604-1.161 2.396.285-.043.555-.086.826-.122.349-.663.72-1.361 1.097-2.117.414-1.005.613-.934.784-1.098.029-.093.021-.135-.021-.078 0 0 .035-.057.085-.15.05-.1.121-.243.214-.421.164-.37.392-.905.663-1.54.527-1.283 1.303-2.959 1.909-4.727 1.347-3.479 2.394-7.136 2.515-7.4l.214.171c-.52 1.775-1.083 3.857-1.91 5.996-.399 1.069-.783 2.189-1.246 3.287-.478 1.09-.955 2.196-1.433 3.294-.456 1.105-1.033 2.153-1.546 3.186-.263.507-.513 1.013-.769 1.512.37-.057.719-.107 1.054-.157.129-.257.257-.513.378-.77l.142.292-.213.428c.156-.021.299-.043.449-.064a109.76 109.76 0 0 0 4.959-11.828c5.158-14.544 7.702-31.25 8.528-47.833.2-4.078.299-8.177.185-12.263a45.124 45.124 0 0 0-1.61-2.181c.093 2.16.136 4.327.107 6.488-.043 5.083-.37 10.145-.769 15.136-.385 4.998-1.012 9.917-1.71 14.73-.399 2.395-.763 4.784-1.247 7.115-.421 2.346-.969 4.634-1.475 6.894.997-6.26 2.878-16.768 3.748-27.834.463-5.525.833-11.172.883-16.426.029-2.375 0-4.663-.107-6.823-.285-.35-.57-.7-.862-1.041 0 .042.007.085.007.128.549 8.834-.014 17.917-.812 27.021l.028.014Zm-6.462 40.311c-.292.813-.442.999-.812 1.804-.299.157.164-.919.62-2.274.484-1.34 1.097-2.902 1.332-3.608-.285 1.02-.72 2.916-1.147 4.078h.007Zm-33.937-80.515c-1.803 2.168-3.505 4.392-5.187 6.652-6.662 9.07-12.347 18.965-16.43 29.51-4.083 10.53-6.534 21.703-6.869 32.853a83.783 83.783 0 0 0-.042 3.287h-.008l-1.503-.371-.748-.185-.734-.25-1.468-.499-1.418-.613a12.374 12.374 0 0 1-1.396-.663l-1.36-.72c-.45-.242-.877-.535-1.312-.798-.876-.514-1.696-1.113-2.515-1.704-.036-.029-.071-.05-.1-.079.357 1.17.67 2.367.955 3.593 1.41.899 2.85 1.704 4.31 2.403 2.373 1.148 4.86 1.882 7.332 2.374.285 9.183 1.988 18.217 5.294 26.594 1.112 2.702 2.508 5.34 4.232 7.735.186.015.364.029.549.036a37.958 37.958 0 0 1-1.382-2.06c-2.622-4.357-4.111-8.941-5.023-12.313l-.599-2.303c-.171-.684-.285-1.283-.399-1.775l-.335-1.533c.428 1.64.841 3.287 1.361 4.926a60.26 60.26 0 0 0 1.66 4.913c1.24 3.251 2.8 6.466 4.881 9.382.192.271.392.535.598.799.691.035 1.383.05 2.074.071-.064-.078-.136-.143-.193-.221-2.835-3.458-4.788-7.614-6.227-11.914a78.003 78.003 0 0 1-3.071-13.239c-.42-2.916-.655-5.839-.762-8.755.399.028.791.057 1.183.078.313.014.627.05.94.043l.933-.029c.62-.028 1.247-.014 1.86-.078 2.494-.25 4.817-.72 7.161-1.312 2.337-.599 4.638-1.383 6.932-2.303a53.42 53.42 0 0 0 6.228-3.001c-.15-.336-.314-.656-.456-.991a19.15 19.15 0 0 1-.506-1.134c-4.339 2.324-9.99 4.62-16.366 5.803-.991.221-1.981.3-2.986.435-.499.086-1.004.064-1.517.093-.506.007-1.019.05-1.525.036l-1.532-.093c-.135-.007-.271-.021-.406-.029a90.711 90.711 0 0 1 1.232-15.457c1.433-8.698 4.083-17.032 7.539-24.804 3.455-7.77 7.709-14.986 12.404-21.595a141.92 141.92 0 0 1 7.353-9.468c2.188-2.56 4.518-4.905 7.104-6.73a94.78 94.78 0 0 0-3.662-.892l-.128.107c-2.209 1.875-4.133 4-5.943 6.16l-.007.029Zm-32.141 72.274c-.37-.114-.577-.214-.705-.314-.257-.207-.235-.371-.677-.72.72.392 3.527 1.304 2.878 1.29l.236.1c-.827-.064-1.354-.249-1.732-.349v-.007Zm4.347 8.683c-.264-1.803-.321-3.222-.378-4.192-.007-.977.021-1.518.078-1.583.114-.128.235 1.64.527 5.576l.022.178-.249.014v.007Zm3.676-34.222-.2-.228c1.361-4.99 3.135-9.775 5.13-14.38l.179.22c-1.931 4.478-3.777 9.49-5.109 14.388Zm10.908-26.301c-1.225 2.224-2.465 4.463-3.968 7.33l-.114.235c-.314-.072 1.012-2.96 2.843-6.203 1.809-3.251 4.146-6.83 5.272-8.634l.178.192c-1.71 2.66-2.957 4.863-4.203 7.073l-.008.007Zm46.206-.257a74.31 74.31 0 0 1-3.641 10.616c-.563 1.34-1.083 2.403-1.432 3.145a21.583 21.583 0 0 1-.563 1.147c-1.154 2.318-2.451 4.57-3.804 6.78-1.404 2.182-2.865 4.328-4.454 6.389-1.596 2.046-3.249 4.057-5.03 5.953-1.774 1.904-3.598 3.757-5.572 5.433 0 0-.156.142-.47.385-.313.25-.776.613-1.368 1.09-1.218.906-2.964 2.225-5.272 3.623-.15.092-.307.185-.456.278.292.706.605 1.397.912 2.089a59.741 59.741 0 0 0 4.788-3.366s-.136.122-.314.293c-.178.17-.434.378-.677.591-.491.421-.94.799-.962.82 3.933-2.659 7.674-5.874 11.023-9.46a84.977 84.977 0 0 0 9.362-11.757c5.622-8.513 9.975-18.316 11.906-29.025a38.45 38.45 0 0 0 .556-5.968 55.617 55.617 0 0 0-3.078-2.673c.021.235.057.463.071.699.313 4.128-.42 8.748-1.532 12.925l.007-.007Zm-5.693 19.87c-3.854 6.21-.064-.94 1.618-3.13a38.878 38.878 0 0 1-1.618 3.13Zm8.173-28.91c.057-.036.128.542.042 2.103-.135.792-.349 2.346-.627 3.594-.277 1.254-.584 2.21-.726 1.86.206-1.226.783-4.106 1.019-5.946.142-.92.213-1.575.292-1.611Zm-81.703 8.677c-2.443 8.491-4.11 17.76-5.215 27.428l-.043.399c.656.741 1.29 1.497 1.903 2.281.057-.556.114-1.12.17-1.697.898-8.676 2.53-19.45 5.273-28.953 1.368-4.748 2.95-9.183 4.567-12.926 1.618-3.736 3.2-6.809 4.425-8.905.591-1.062 1.118-1.868 1.46-2.424.35-.563.57-.841.592-.834.028.007-.143.306-.485.97-.342.662-.912 1.646-1.617 3.065a86.22 86.22 0 0 1 3.798-5.974c-.941.135-1.874.285-2.808.456a86.09 86.09 0 0 0-2.672 4.406c-3.697 6.538-6.946 14.216-9.355 22.715l.007-.007Zm2.224-5.412c-1.155 3.309-2.309 7.052-2.808 9.333-.392 1.59-.69 2.83-.883 3.8.007-1.718.812-5.347 2.009-9.225 1.183-3.886 2.786-7.993 3.883-10.873.057.763-1.054 3.65-2.202 6.958v.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#EED7FC",
        d: "m133.631 46.251.093-.15v.08c.164-.364.399-.906.691-1.57.313-.648.691-1.418 1.104-2.267.784-1.704 1.853-3.636 2.929-5.447a56.7 56.7 0 0 1 3.092-4.662c.883-1.191 1.503-1.925 1.503-1.925-3.177 4.784-6.013 10.124-8.407 15.799-2.373 5.668-4.24 11.714-5.002 17.738l-.242-.12c.684-5.22 1.881-9.754 2.28-11.594-1.454 4.5-2.758 10.331-3.199 16.855-.278 3.258-.193 6.68.021 10.16.2 1.732.306 3.493.641 5.24.157.87.271 1.754.456 2.623l.599 2.603c.178.87.456 1.718.705 2.574.264.848.478 1.71.791 2.538.47 1.262.912 2.53 1.432 3.757.164.378.328.763.506 1.134.15.335.306.663.456.991a42.843 42.843 0 0 0 1.824 3.614 54.512 54.512 0 0 0 2.608 4.221c1.824 2.667 3.79 5.055 5.771 7.087a47.549 47.549 0 0 0 5.828 5.069c-.128-.228-1.389-1.112-2.622-2.21-.634-.535-1.225-1.148-1.731-1.69-.485-.563-.855-1.069-.99-1.426 2.764 2.895 5.928 5.369 9.184 7.387.969-.143 1.916-.286 2.835-.421a40.901 40.901 0 0 1-3.583-2.317c-5.187-3.729-9.911-8.819-13.595-14.901a61.437 61.437 0 0 1-2.565-4.734 55.475 55.475 0 0 0-.506-1.14c-.306-.692-.62-1.384-.912-2.09a27.164 27.164 0 0 1-.698-1.825c-.684-1.711-1.169-3.508-1.71-5.297-.42-1.826-.912-3.644-1.183-5.519-.363-1.86-.527-3.764-.741-5.66-.092-1.911-.249-3.83-.199-5.761-.043-1.933.128-3.865.242-5.804l.313-2.902c.093-.97.293-1.925.435-2.887 1.268-7.693 3.855-15.186 7.439-22.023 1.809-3.401 3.897-6.624 6.369-9.44a36.996 36.996 0 0 1 2.124-2.232 76.062 76.062 0 0 0-2.252-.677c-.142.135-.285.285-.456.442l-.05.057-.178-.178c.121-.15.235-.285.349-.414-.085-.021-.178-.043-.271-.071-2.187 2.296-4.068 4.813-5.685 7.408-2.437 3.885-4.297 7.935-5.836 11.956l-.007.021Zm-4.424 21.36c-.029.6-.107 1.305-.107 1.626-.057-.449-.25-1.283-.221-1.803.028-.364.1-.457.164-.828.221-.092.185.407.156 1.006h.008Zm10.466 41.973c-.399-.349-.791-.92-1.161-1.512-.356-.598-.67-1.219-.955-1.654.164-.092.834.799 1.418 1.647.584.849 1.054 1.669.698 1.519Zm-8.065-23.849c.783 4.328 2.066 8.698 3.284 11.764.064.164.129.335.193.492.242.52.498 1.055.755 1.59 1.247 2.567 2.679 5.205 4.275 7.693.955 1.504 1.988 2.93 3.007 4.271 1.047 1.319 2.08 2.566 3.113 3.643.357.392.756.784 1.176 1.183.413.414.855.827 1.339 1.248-5.279-4.057-10.217-10.402-13.444-17.724-.207-.47-.407-.941-.599-1.419-.1-.235-.192-.478-.285-.713-1.489-3.729-2.601-7.636-3.356-11.522-.776-4.142-1.133-8.256-1.282-12.156.598 2.646.912 7.095 1.817 11.643l.007.007Zm.363-26.857c-.071.463-.42 2.068-1.09 5.397.007.464-.2.442-.299.528l.05.035s-.079.385-.15.97c-.057.577-.192 1.347-.221 2.132-.093 1.561-.185 3.158-.192 3.28l-.25-.05c-.007-1.555.05-3.637.406-5.619.264-1.996.784-3.9 1.126-5.183.364-1.283.684-1.94.62-1.476v-.014Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M-22.564 159.762c0-.078.014-.156.022-.235a42.24 42.24 0 0 0 .092-1.654c0-.121.014-.235.014-.356.022-.656.022-1.312.008-1.975 0-.122-.008-.25-.015-.371a31.618 31.618 0 0 0-.085-1.633l-.043-.542a31.502 31.502 0 0 0-.228-1.989l7.959 2.025c1.225.314 2.536.642 3.911.991.549.143 1.105.278 1.675.421.57.142 1.14.285 1.71.435 1.154.292 2.322.584 3.491.877 1.168.292 2.337.591 3.491.876.577.143 1.147.286 1.71.428 2.537.635 4.93 1.234 6.983 1.733.228.057.449.114.67.164.876.214 1.674.406 2.38.577.527.129 1.011.243 1.424.342.42.1.777.179 1.069.243.584.128.898.185.883.157v.071c0 .043-.007.1-.014.171v.029c0 .071-.014.164-.021.263 0 .029 0 .05-.007.079-.007.107-.022.221-.036.349 0 .029 0 .057-.007.086-.014.142-.028.299-.05.47v.022c-.021.178-.036.363-.064.57 0 .029 0 .05-.007.071-.022.193-.043.407-.071.621 0 .05-.015.092-.015.142-.028.221-.05.449-.078.685 0 .05-.014.1-.021.149-.029.243-.065.492-.093.756l-.021.178a86.63 86.63 0 0 0-.107.842.35.35 0 0 1-.015.085c-.035.293-.078.592-.12.899 0 .035-.015.078-.015.114-.043.313-.093.627-.135.955-.007.064-.022.128-.029.193l-.15.969c-.014.079-.02.15-.035.228-.05.335-.107.67-.164 1.02-.014.071-.021.142-.036.214-.056.356-.12.72-.185 1.083-.007.05-.021.1-.028.15a59.38 59.38 0 0 1-.2 1.112c0 .036-.014.065-.021.1-.071.385-.143.777-.221 1.177-.014.064-.021.128-.036.192l-.17.856c4.353.755 8.87 1.24 13.494 1.475 8.77.443 17.293-.149 25.215-1.867 17.008-3.686 31.165-12.691 38.86-28.319 1.404-2.845 2.58-5.911 3.541-9.198.328-1.133.627-2.302.905-3.493a63.012 63.012 0 0 1-.912 3.508 51.202 51.202 0 0 1-1.425-.449 70.453 70.453 0 0 1-8.927-3.558c-.47-.228-.94-.464-1.411-.699a58.693 58.693 0 0 1-9.141-5.746 78.108 78.108 0 0 1-1.198-.949 50.902 50.902 0 0 1-5.507-5.211 44.277 44.277 0 0 1-1.974-2.317 49.002 49.002 0 0 1-4.318-6.367 47.006 47.006 0 0 1-1.46-2.781 51.454 51.454 0 0 1-.67-1.44 55.956 55.956 0 0 1-1.225-2.987 56.355 56.355 0 0 1-1.789-5.718 60.546 60.546 0 0 1-1.439-7.786 70.579 70.579 0 0 1-.463-6.759c-.036-1.754 0-3.55.085-5.39.3-5.982 1.219-11.4 2.658-16.312-7.332-2.239-15.255-3.55-23.498-3.964-9.22-.464-18.084.128-26.256 1.896-17.157 3.708-31.179 12.698-38.824 28.24-3.491 7.102-5.7 15.529-6.199 25.518-.491 9.838.84 18.33 3.57 25.666 2.928 7.871 7.517 14.352 13.373 19.571l-.014.021Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#EED7FC",
        d: "M52.612 79.148a76.4 76.4 0 0 0-.086 5.39c.043 2.331.2 4.584.463 6.758a59.35 59.35 0 0 0 1.44 7.786 55.746 55.746 0 0 0 1.788 5.718 48.21 48.21 0 0 0 1.225 2.987 48.458 48.458 0 0 0 2.13 4.221 48.245 48.245 0 0 0 4.318 6.367 51.701 51.701 0 0 0 1.974 2.317 51.018 51.018 0 0 0 6.705 6.16c2.821 2.174 5.878 4.085 9.141 5.746.463.236.933.471 1.41.699 2.844 1.369 5.83 2.545 8.928 3.558.47.157.948.299 1.425.449.335-1.141.635-2.31.912-3.508.05-.214.1-.435.143-.656.192-.884.37-1.782.534-2.695.072-.392.136-.784.2-1.183a64.732 64.732 0 0 0 .513-3.929c.035-.342.064-.698.092-1.041.079-.912.15-1.832.2-2.773 0-.093.014-.185.021-.278v-.064c.357-7.03-.213-13.383-1.546-19.115a60.208 60.208 0 0 0-.955-3.593 52.976 52.976 0 0 0-1.111-3.308 48.869 48.869 0 0 0-9.277-15.486c-3.762-4.228-8.23-7.778-13.267-10.687a61.548 61.548 0 0 0-3.662-1.947 70.724 70.724 0 0 0-9.604-3.87c-.456-.15-.912-.293-1.375-.429h-.015l-.021.079c-1.44 4.912-2.358 10.33-2.658 16.312l.015.015Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#c)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M58.287-54H477.02v400.9H58.287z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "#F0F1F2",
        clipPath: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M101 31h342v8H101zM91 51h352v8H91zm0 21h161v8H91z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#e)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 313.252,
        height: 18.265,
        x: 40,
        y: 23.171,
        fill: "#fff",
        rx: 2.74
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "#505258",
        fillRule: "evenodd",
        clipPath: "url(#g)",
        clipRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.537 28.762a.792.792 0 0 0-.809.001.824.824 0 0 0-.403.715v1.095l1.337.79c.329.194.53.552.53.94v2.825a1.1 1.1 0 0 1-.062.366l1.795-1.062a.83.83 0 0 0 .404-.717v-2.824a.833.833 0 0 0-.404-.717l-2.388-1.412Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.94 35.13a.824.824 0 0 1-.404.715h.001a.792.792 0 0 1-.809.002l-2.387-1.413a.833.833 0 0 1-.405-.717v-2.825a.83.83 0 0 1 .404-.716l1.795-1.062c-.04.116-.062.24-.062.366v2.825c0 .388.201.745.53.939l1.337.791v1.094Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.537 28.762a.792.792 0 0 0-.809.001.824.824 0 0 0-.403.715v1.095l1.337.79c.329.194.53.552.53.94v2.825a1.1 1.1 0 0 1-.062.366l1.795-1.062a.83.83 0 0 0 .404-.717v-2.824a.833.833 0 0 0-.404-.717l-2.388-1.412Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.94 35.13a.824.824 0 0 1-.404.715h.001a.792.792 0 0 1-.809.002l-2.387-1.413a.833.833 0 0 1-.405-.717v-2.825a.83.83 0 0 1 .404-.716l1.795-1.062c-.04.116-.062.24-.062.366v2.825c0 .388.201.745.53.939l1.337.791v1.094Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#B3B9C4",
        d: "M55.525 29.792h21.919v5.023H55.525z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M82.924 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        d: "M89.545 31.961h2.969v-2.853h.684V35.5h-.684v-2.853h-2.97V35.5h-.684v-6.392h.685v2.853Zm5.465.721c.213 0 .399.031.555.093a.822.822 0 0 1 .363.259c.085.11.128.239.128.388v.004a.559.559 0 0 1-.278.496.809.809 0 0 1-.27.108v.014a.837.837 0 0 1 .481.189.53.53 0 0 1 .177.417v.003a.741.741 0 0 1-.14.452.882.882 0 0 1-.396.294 1.672 1.672 0 0 1-.614.101 1.44 1.44 0 0 1-.577-.107.935.935 0 0 1-.391-.303.877.877 0 0 1-.165-.463l-.002-.024h.748l.003.022a.27.27 0 0 0 .06.135c.032.04.075.073.13.097a.483.483 0 0 0 .192.035.45.45 0 0 0 .19-.037.3.3 0 0 0 .122-.104.278.278 0 0 0 .043-.152v-.003a.233.233 0 0 0-.107-.208.56.56 0 0 0-.312-.072h-.275V33.8h.275c.082 0 .151-.01.208-.031a.289.289 0 0 0 .13-.09.231.231 0 0 0 .046-.144v-.003a.25.25 0 0 0-.152-.242.389.389 0 0 0-.172-.036c-.07 0-.13.013-.182.037a.286.286 0 0 0-.12.102.325.325 0 0 0-.054.151l-.002.017h-.707l.002-.027a.858.858 0 0 1 .153-.452.879.879 0 0 1 .366-.294 1.31 1.31 0 0 1 .544-.106Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "m99.834 31.377 1.812 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M109.865 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#44546F",
        strokeLinejoin: "round",
        strokeWidth: 1.027,
        d: "M119.797 32.304c.788 0 1.427-.553 1.427-1.341 0-.789-.639-1.342-1.427-1.342h-2.112v2.683m2.112 0h.457c.788 0 1.427.553 1.427 1.341 0 .788-.639 1.342-1.427 1.342h-2.569v-2.683m2.112 0h-2.112"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M133.154 29.108h2.968v.684h-1.1l-1.205 5.023h1.163v.685h-2.968v-.684h1.1l1.206-5.024h-1.164v-.684Zm8.233 2.269 1.813 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M151.419 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#44546F",
        strokeLinejoin: "round",
        strokeWidth: 0.685,
        d: "M159.067 33.674v-.171l.586-1.541m3.296 1.712v-.171l-.583-1.541m0 0-1.121-2.969h-.465l-1.127 2.969m2.713 0h-2.713"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#44546F",
        strokeWidth: 1.37,
        d: "M164.662 35.272h-7.307"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "m168.329 31.377 1.812 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.485-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#44546F",
        strokeLinejoin: "round",
        strokeWidth: 0.685,
        d: "m183.269 31.048-.57 1.598.285.286m.285-1.884 2.829-1.975a.286.286 0 0 1 .366.032l.575.575a.285.285 0 0 1 .032.366l-1.975 2.829m-1.827-1.827 1.827 1.827m0 0-1.598.57-.286-.285m-.228-.228-.514.514.229.228.513-.514m-.228-.228.228.228"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#172B4D",
        strokeWidth: 1.37,
        d: "M188.407 35.272h-7.306"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "m192.074 31.377 1.812 1.813 1.813-1.813.484.484-2.054 2.055a.343.343 0 0 1-.485 0l-2.055-2.055.485-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M202.105 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M214.891 30.25h-6.392v-.686h6.392v.685Zm0 2.397h-6.392v-.685h6.392v.685Zm-3.196 2.397h-3.196v-.685h3.196v.685Zm7.32-3.667 1.813 1.813 1.812-1.813.485.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Zm14.142-1.47a.57.57 0 1 1 1.141-.001.57.57 0 0 1-1.141 0Zm6.393.342h-4.567v-.685h4.567v.685Zm-6.393 2.055a.57.57 0 1 1 1.141 0 .57.57 0 0 1-1.141 0Zm6.393.342h-4.567v-.684h4.567v.684Zm-6.393 2.055a.57.57 0 1 1 1.14 0 .57.57 0 0 1-1.14 0Zm6.393.343h-4.567v-.685h4.567v.685Zm4.123-3.667 1.813 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M253.705 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M263.396 29.664a1.795 1.795 0 1 1 2.539 2.54l-1.028 1.027-.484-.484 1.027-1.028a1.11 1.11 0 1 0-1.57-1.57l-1.028 1.027-.484-.484 1.028-1.028Zm1.397 1.626-2.511 2.512-.485-.484 2.512-2.512.484.484Zm-4.137 1.114 1.027-1.027.485.484-1.028 1.028a1.11 1.11 0 1 0 1.571 1.57l1.027-1.027.484.484-1.027 1.027a1.795 1.795 0 1 1-2.539-2.539Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M272.427 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M278.364 30.078c0-.662.536-1.199 1.198-1.199h4.909a1.2 1.2 0 0 1 1.199 1.199v3.767a1.2 1.2 0 0 1-1.199 1.199h-4.076l-1.519.868a.343.343 0 0 1-.512-.297v-5.537Zm1.198-.514a.514.514 0 0 0-.513.514v4.946l1.165-.665h4.257c.284 0 .514-.23.514-.514v-3.767a.514.514 0 0 0-.514-.514h-4.909Zm4.282 2.055h-3.654v-.685h3.654v.685Zm-1.37 1.37h-2.284v-.685h2.284v.685Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#B3B9C4",
        d: "M288.41 29.793h21.919v5.023H288.41z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M315.808 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M321.744 32.304a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Zm2.968 0a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Zm2.968 0a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M334.529 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        d: "M342.91 28.65a.628.628 0 0 0-.579.872l.041.08.377.628v1.587a2.22 2.22 0 0 0-.541.279c-.419.297-.829.823-.829 1.692 0 .19.153.343.342.343h2.055v1.826h.685V34.13h2.055a.343.343 0 0 0 .343-.342c0-.869-.411-1.395-.83-1.692a2.25 2.25 0 0 0-.54-.28V30.23l.376-.628a.628.628 0 0 0-.538-.951h-2.417Zm1.942 1.309a.34.34 0 0 0-.048.176v1.94c0 .168.121.311.286.339h.004l.03.007a1.552 1.552 0 0 1 .509.234c.211.15.428.39.508.79h-4.045c.08-.4.297-.64.508-.79a1.556 1.556 0 0 1 .51-.234l.03-.007h.003a.342.342 0 0 0 .287-.338v-1.941a.342.342 0 0 0-.049-.176l-.374-.623h2.215l-.374.623Z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#292A2E",
        d: "M143.186 68.735c.141 0 .586 3.665.305 5.157.482.302.897 1.064.875 1.858 2.034 1.56.772-2.411.352-3.645-.342.828-.07-1.266-.333-1.589.016.178-.352-3.375-1.016-2.393-.085-.11-.354.712-.185.61l.002.002Zm-7.937 3.73c.135.784-.204 1.446-.751 2.075.334 2.71 2.44-1.575 2.936-2.62 0 0 .912-1.817.922-1.593.352-.138 2.323-2.659 1.016-2.603-.373.393-.718 1.363-1.123 1.35-.904.194-1.934 2.682-2.999 3.395l-.001-.004Zm-6.428-7.115c-.435 1.7 2.805.443 4.076.388 0 0 1.318.014 1.68-.215-.191-.002 4.487-.226 2.034-1.145-.066.023-1.686.097-1.686.097-2.117-.528-4.351.11-6.106.877l.002-.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#0C66E4",
        fillOpacity: 0.14,
        d: "M314 47.745H147.042v14.637H314z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M137.436 45h17.153v18.297h-17.153z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#h)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M149.798 43.71a6.006 6.006 0 0 0-3.969 1.339 6.026 6.026 0 0 0-3.968-1.338h-1.143v3.43h1.143c1.613 0 2.116.801 2.287 1.144v4.506h-1.143v3.43h1.143v3.431c-.148.343-.651 1.143-2.287 1.143h-1.143v3.431h1.143a6.026 6.026 0 0 0 3.968-1.338 5.965 5.965 0 0 0 3.969 1.338h1.143v-3.43h-1.143c-1.613 0-2.116-.8-2.288-1.144v-3.43h1.213V52.79h-1.144v-4.506c.149-.343.652-1.143 2.287-1.143h1.144V43.71h-1.212Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#000",
        d: "M149.798 45.998v-1.143a4.574 4.574 0 0 0-3.969 1.875 4.574 4.574 0 0 0-3.968-1.875v1.143a3.213 3.213 0 0 1 3.431 2.104v5.832h-1.144v1.144h1.144v4.757a3.234 3.234 0 0 1-3.431 2.104v1.144a4.635 4.635 0 0 0 3.968-1.864 4.636 4.636 0 0 0 3.969 1.864v-1.144a3.225 3.225 0 0 1-3.362-2.104v-4.769h1.143v-1.143h-1.143v-5.81a3.211 3.211 0 0 1 3.362-2.115Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M0 0h477v81H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M-259-118.5h684v385h-684z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "c"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 419.213,
        height: 220.555,
        x: 58.287,
        y: -54,
        fill: "#fff",
        rx: 5.243
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "d"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M31.03-25.464a3.932 3.932 0 0 1 3.932-3.932h487.581v374.861H31.03V-25.464Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "f"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 313.252,
        height: 18.265,
        x: 40,
        y: 23.171,
        fill: "#fff",
        rx: 2.74
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M45.48 28.65h7.306v7.307H45.48z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "e",
        width: 324.211,
        height: 29.225,
        x: 34.52,
        y: 21.345,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 3.653
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 2.74
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.15 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13247_133684"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 0.228
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "effect1_dropShadow_13247_133684",
        result: "effect2_dropShadow_13247_133684"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_13247_133684",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "h",
        width: 14.866,
        height: 25.095,
        x: 138.431,
        y: 42.565,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 1.144
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 1.144
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13247_133684"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_13247_133684",
        result: "shape"
    }))));
};
const $3faf0024169aae07$var$BannerImageDark = ({ title: title, titleId: titleId, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "56px",
        viewBox: "0 0 477 81",
        fill: "none",
        "aria-labelledby": titleId,
        ...props
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "c",
        width: 686,
        height: 389,
        x: -260,
        y: -119.5,
        fill: "#000",
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M-260-119.5h686v389h-686z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M294.605 266.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56.055 56.055 0 0 1 3.912-1.005 59.762 59.762 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.249.022.086 0 .164-.022.25-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462.513.114 1.026.235 1.532.364.199.05.392.107.591.164 1.069.285 2.123.598 3.171.941 6.191 2.046 11.998 5.154 17.021 9.332a46.673 46.673 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-25.743c-3.142 2.787-6.548 5.233-10.175 7.371-19.173 11.294-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.039-24.646 21.646 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223.037 223.037 0 0 1-.492-11.885 238.289 238.289 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968a137.79 137.79 0 0 1 11.699-.478h74.442a62.92 62.92 0 0 0 3.527-.1l.648-.042c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.135-.364.164-.485.321-.977.464-1.476.035-.114.057-.228.092-.342a38.98 38.98 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-2.002C43.427-8.354 21.475 3.452 16.68 35.144l-61.952-9.383C-41.253-.79-33.116-21.98-19.9-37.5a292.483 292.483 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.791 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.293.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135-.769.164-1.546.32-2.337.463-3.014.535-6.156.856-9.398.984a59 59 0 0 1-1.952.064 80.363 80.363 0 0 1-4.56-.085c-.598-.029-1.19-.05-1.781-.093a71.106 71.106 0 0 1-5.508-.606 56.036 56.036 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a66.504 66.504 0 0 1-1.717-.363c-.156-.036-.313-.072-.47-.114a41.541 41.541 0 0 1-1.909-.492 5.423 5.423 0 0 1-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178-.007 0-.015.007-.029.014-.149-.05-.313-.107-.47-.157a54.023 54.023 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135-.769.164-1.546.32-2.336.463-3.014.535-6.157.856-9.398.984-.649.029-1.297.058-1.953.065a76.937 76.937 0 0 1-6.056-.157 68.182 68.182 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62.105 62.105 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53.066 53.066 0 0 1-1.132-.25 11.189 11.189 0 0 1-.471-.114 41.67 41.67 0 0 1-1.909-.492c-.057-.014-.114-.028-.164-.042-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a63.596 63.596 0 0 1 .983-4.363 61.02 61.02 0 0 1 2.679-8.007 56.391 56.391 0 0 1 1.482-3.23l.129-.249c.064-.121.128-.235.192-.357.335-.648.67-1.304 1.026-1.932a50.705 50.705 0 0 1 12.262-14.452 54.475 54.475 0 0 1 5.052-3.629 57.83 57.83 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a58.52 58.52 0 0 1 2.472-1.112 71.392 71.392 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542.178.043.356.093.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.693 8.678 33.46h63.905l-.015.035Zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.588 45.588 0 0 1-6.925-2.695 46.678 46.678 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.079-.014-.15-.029-.228-.036a3.667 3.667 0 0 1-.121-.021 29.164 29.164 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.836-3.021-8.028-3.093-12.491-4.075-.306-7.98-.592-11.528-.82l.449-.228c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.293 22.293 0 0 1-1.411 3.722 22.724 22.724 0 0 1-1.995 3.379c-4.389 6.082-11.001 7.964-18.005 5.889a23.988 23.988 0 0 1-3.605-1.405 24.154 24.154 0 0 1-3.477-2.039c-5.978-4.22-8.622-10.544-6.627-17.738a22.488 22.488 0 0 1 1.397-3.672 22.02 22.02 0 0 1 2.023-3.422c4.389-6.046 10.973-7.914 17.984-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34.154 34.154 0 0 1 1.161-6.438c.641-2.31 1.532-4.662 2.679-7.05a43.121 43.121 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.018 3.042.086 6.177.585 9.355 1.512a47.373 47.373 0 0 1 7.218 2.788 45.558 45.558 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a5.465 5.465 0 0 0-.392.491c.028.043.057.086.078.136 1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.485 22.485 0 0 1 1.396-3.671 22.022 22.022 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.467 24.467 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22.22 22.22 0 0 1-1.411 3.722 22.707 22.707 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24.082 24.082 0 0 1-3.605-1.404 24.192 24.192 0 0 1-3.477-2.04 19.98 19.98 0 0 1-2.971-2.552 1165.843 1165.843 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901.114.264.228.528.335.792v.028c2.166 5.74 2.451 12.199.534 19.086-.648 2.339-1.553 4.72-2.715 7.144-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45.036 45.036 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a42.943 42.943 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198.014.014Zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11.001 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286v-.008ZM362.058 16.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.581c-23.277 6.488-68.499.285-68.499.285.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563ZM103.05 218.154a32.17 32.17 0 0 1-5.059.414 32.17 32.17 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.36 29.36 0 0 1-.456-5.126c0-1.839.143-3.572.435-5.197 1.717-9.647 8.422-15.628 17.862-17.233a32.228 32.228 0 0 1 5.266-.442c1.76 0 3.448.129 5.058.385 9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198 0 1.811-.143 3.522-.421 5.133-1.703 9.689-8.422 15.7-17.876 17.261l.007-.007Zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.072l-.684-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.476-1.304 6.46-3.292 13.575-6.199 18.21l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.035-2.36 26.255-1.897 8.244.413 16.174 1.725 23.498 3.964l.022-.078h.014a57.883 57.883 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221.392-.785.798-1.548 1.226-2.296 7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.564.926-.164 1.859-.313 2.807-.456 6.27-.92 12.846-1.198 19.565-.855 6.213.313 12.213 1.098 17.898 2.352 1.233.271 2.459.57 3.663.892l.733.192c.086.021.179.043.271.071.114.029.228.058.342.093.755.214 1.504.45 2.252.678.256.078.52.15.776.235 7.667 2.48 14.557 6.01 20.356 10.659a52.13 52.13 0 0 1 3.078 2.673 48.996 48.996 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714a53.34 53.34 0 0 1 1.61 2.181 49.357 49.357 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412-.021.007Zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.059.413-1.831 0-3.591-.135-5.265-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.37 29.37 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32.112 32.112 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30.17 30.17 0 0 1-.42 5.133l.007-.007Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245D",
        d: "M294.605 266.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56.055 56.055 0 0 1 3.912-1.005 59.762 59.762 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.249.022.086 0 .164-.022.25-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462.513.114 1.026.235 1.532.364.199.05.392.107.591.164 1.069.285 2.123.598 3.171.941 6.191 2.046 11.998 5.154 17.021 9.332a46.673 46.673 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-25.743c-3.142 2.787-6.548 5.233-10.175 7.371-19.173 11.294-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.039-24.646 21.646 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223.037 223.037 0 0 1-.492-11.885 238.289 238.289 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968a137.79 137.79 0 0 1 11.699-.478h74.442a62.92 62.92 0 0 0 3.527-.1l.648-.042c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.135-.364.164-.485.321-.977.464-1.476.035-.114.057-.228.092-.342a38.98 38.98 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-2.002C43.427-8.354 21.475 3.452 16.68 35.144l-61.952-9.383C-41.253-.79-33.116-21.98-19.9-37.5a292.483 292.483 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.791 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.293.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135-.769.164-1.546.32-2.337.463-3.014.535-6.156.856-9.398.984a59 59 0 0 1-1.952.064 80.363 80.363 0 0 1-4.56-.085c-.598-.029-1.19-.05-1.781-.093a71.106 71.106 0 0 1-5.508-.606 56.036 56.036 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a66.504 66.504 0 0 1-1.717-.363c-.156-.036-.313-.072-.47-.114a41.541 41.541 0 0 1-1.909-.492 5.423 5.423 0 0 1-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178-.007 0-.015.007-.029.014-.149-.05-.313-.107-.47-.157a54.023 54.023 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135-.769.164-1.546.32-2.336.463-3.014.535-6.157.856-9.398.984-.649.029-1.297.058-1.953.065a76.937 76.937 0 0 1-6.056-.157 68.182 68.182 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62.105 62.105 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53.066 53.066 0 0 1-1.132-.25 11.189 11.189 0 0 1-.471-.114 41.67 41.67 0 0 1-1.909-.492c-.057-.014-.114-.028-.164-.042-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a63.596 63.596 0 0 1 .983-4.363 61.02 61.02 0 0 1 2.679-8.007 56.391 56.391 0 0 1 1.482-3.23l.129-.249c.064-.121.128-.235.192-.357.335-.648.67-1.304 1.026-1.932a50.705 50.705 0 0 1 12.262-14.452 54.475 54.475 0 0 1 5.052-3.629 57.83 57.83 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a58.52 58.52 0 0 1 2.472-1.112 71.392 71.392 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542.178.043.356.093.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.693 8.678 33.46h63.905l-.015.035Zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.588 45.588 0 0 1-6.925-2.695 46.678 46.678 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.079-.014-.15-.029-.228-.036a3.667 3.667 0 0 1-.121-.021 29.164 29.164 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.836-3.021-8.028-3.093-12.491-4.075-.306-7.98-.592-11.528-.82l.449-.228c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.293 22.293 0 0 1-1.411 3.722 22.724 22.724 0 0 1-1.995 3.379c-4.389 6.082-11.001 7.964-18.005 5.889a23.988 23.988 0 0 1-3.605-1.405 24.154 24.154 0 0 1-3.477-2.039c-5.978-4.22-8.622-10.544-6.627-17.738a22.488 22.488 0 0 1 1.397-3.672 22.02 22.02 0 0 1 2.023-3.422c4.389-6.046 10.973-7.914 17.984-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34.154 34.154 0 0 1 1.161-6.438c.641-2.31 1.532-4.662 2.679-7.05a43.121 43.121 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.018 3.042.086 6.177.585 9.355 1.512a47.373 47.373 0 0 1 7.218 2.788 45.558 45.558 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a5.465 5.465 0 0 0-.392.491c.028.043.057.086.078.136 1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.485 22.485 0 0 1 1.396-3.671 22.022 22.022 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.467 24.467 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22.22 22.22 0 0 1-1.411 3.722 22.707 22.707 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24.082 24.082 0 0 1-3.605-1.404 24.192 24.192 0 0 1-3.477-2.04 19.98 19.98 0 0 1-2.971-2.552 1165.843 1165.843 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901.114.264.228.528.335.792v.028c2.166 5.74 2.451 12.199.534 19.086-.648 2.339-1.553 4.72-2.715 7.144-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45.036 45.036 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a42.943 42.943 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198.014.014Zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11.001 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286v-.008ZM362.058 16.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.581c-23.277 6.488-68.499.285-68.499.285.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563ZM103.05 218.154a32.17 32.17 0 0 1-5.059.414 32.17 32.17 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.36 29.36 0 0 1-.456-5.126c0-1.839.143-3.572.435-5.197 1.717-9.647 8.422-15.628 17.862-17.233a32.228 32.228 0 0 1 5.266-.442c1.76 0 3.448.129 5.058.385 9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198 0 1.811-.143 3.522-.421 5.133-1.703 9.689-8.422 15.7-17.876 17.261l.007-.007Zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.072l-.684-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.476-1.304 6.46-3.292 13.575-6.199 18.21l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.035-2.36 26.255-1.897 8.244.413 16.174 1.725 23.498 3.964l.022-.078h.014a57.883 57.883 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221.392-.785.798-1.548 1.226-2.296 7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.564.926-.164 1.859-.313 2.807-.456 6.27-.92 12.846-1.198 19.565-.855 6.213.313 12.213 1.098 17.898 2.352 1.233.271 2.459.57 3.663.892l.733.192c.086.021.179.043.271.071.114.029.228.058.342.093.755.214 1.504.45 2.252.678.256.078.52.15.776.235 7.667 2.48 14.557 6.01 20.356 10.659a52.13 52.13 0 0 1 3.078 2.673 48.996 48.996 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714a53.34 53.34 0 0 1 1.61 2.181 49.357 49.357 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412-.021.007Zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.059.413-1.831 0-3.591-.135-5.265-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.37 29.37 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32.112 32.112 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30.17 30.17 0 0 1-.42 5.133l.007-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#48245D",
        strokeWidth: 2,
        d: "M294.605 266.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56.055 56.055 0 0 1 3.912-1.005 59.762 59.762 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.249.022.086 0 .164-.022.25-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462.513.114 1.026.235 1.532.364.199.05.392.107.591.164 1.069.285 2.123.598 3.171.941 6.191 2.046 11.998 5.154 17.021 9.332a46.673 46.673 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-25.743c-3.142 2.787-6.548 5.233-10.175 7.371-19.173 11.294-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.039-24.646 21.646 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223.037 223.037 0 0 1-.492-11.885 238.289 238.289 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968a137.79 137.79 0 0 1 11.699-.478h74.442a62.92 62.92 0 0 0 3.527-.1l.648-.042c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.135-.364.164-.485.321-.977.464-1.476.035-.114.057-.228.092-.342a38.98 38.98 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-2.002C43.427-8.354 21.475 3.452 16.68 35.144l-61.952-9.383C-41.253-.79-33.116-21.98-19.9-37.5a292.483 292.483 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.791 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.293.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135-.769.164-1.546.32-2.337.463-3.014.535-6.156.856-9.398.984a59 59 0 0 1-1.952.064 80.363 80.363 0 0 1-4.56-.085c-.598-.029-1.19-.05-1.781-.093a71.106 71.106 0 0 1-5.508-.606 56.036 56.036 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a66.504 66.504 0 0 1-1.717-.363c-.156-.036-.313-.072-.47-.114a41.541 41.541 0 0 1-1.909-.492 5.423 5.423 0 0 1-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178-.007 0-.015.007-.029.014-.149-.05-.313-.107-.47-.157a54.023 54.023 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135-.769.164-1.546.32-2.336.463-3.014.535-6.157.856-9.398.984-.649.029-1.297.058-1.953.065a76.937 76.937 0 0 1-6.056-.157 68.182 68.182 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62.105 62.105 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53.066 53.066 0 0 1-1.132-.25 11.189 11.189 0 0 1-.471-.114 41.67 41.67 0 0 1-1.909-.492c-.057-.014-.114-.028-.164-.042-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a63.596 63.596 0 0 1 .983-4.363 61.02 61.02 0 0 1 2.679-8.007 56.391 56.391 0 0 1 1.482-3.23l.129-.249c.064-.121.128-.235.192-.357.335-.648.67-1.304 1.026-1.932a50.705 50.705 0 0 1 12.262-14.452 54.475 54.475 0 0 1 5.052-3.629 57.83 57.83 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a58.52 58.52 0 0 1 2.472-1.112 71.392 71.392 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542.178.043.356.093.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.693 8.678 33.46h63.905l-.015.035Zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.588 45.588 0 0 1-6.925-2.695 46.678 46.678 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.079-.014-.15-.029-.228-.036a3.667 3.667 0 0 1-.121-.021 29.164 29.164 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.836-3.021-8.028-3.093-12.491-4.075-.306-7.98-.592-11.528-.82l.449-.228c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.293 22.293 0 0 1-1.411 3.722 22.724 22.724 0 0 1-1.995 3.379c-4.389 6.082-11.001 7.964-18.005 5.889a23.988 23.988 0 0 1-3.605-1.405 24.154 24.154 0 0 1-3.477-2.039c-5.978-4.22-8.622-10.544-6.627-17.738a22.488 22.488 0 0 1 1.397-3.672 22.02 22.02 0 0 1 2.023-3.422c4.389-6.046 10.973-7.914 17.984-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34.154 34.154 0 0 1 1.161-6.438c.641-2.31 1.532-4.662 2.679-7.05a43.121 43.121 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.018 3.042.086 6.177.585 9.355 1.512a47.373 47.373 0 0 1 7.218 2.788 45.558 45.558 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a5.465 5.465 0 0 0-.392.491c.028.043.057.086.078.136 1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.485 22.485 0 0 1 1.396-3.671 22.022 22.022 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.467 24.467 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22.22 22.22 0 0 1-1.411 3.722 22.707 22.707 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24.082 24.082 0 0 1-3.605-1.404 24.192 24.192 0 0 1-3.477-2.04 19.98 19.98 0 0 1-2.971-2.552 1165.843 1165.843 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901.114.264.228.528.335.792v.028c2.166 5.74 2.451 12.199.534 19.086-.648 2.339-1.553 4.72-2.715 7.144-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45.036 45.036 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a42.943 42.943 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198.014.014Zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11.001 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286v-.008ZM362.058 16.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.581c-23.277 6.488-68.499.285-68.499.285.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563ZM103.05 218.154a32.17 32.17 0 0 1-5.059.414 32.17 32.17 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.36 29.36 0 0 1-.456-5.126c0-1.839.143-3.572.435-5.197 1.717-9.647 8.422-15.628 17.862-17.233a32.228 32.228 0 0 1 5.266-.442c1.76 0 3.448.129 5.058.385 9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198 0 1.811-.143 3.522-.421 5.133-1.703 9.689-8.422 15.7-17.876 17.261l.007-.007Zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.072l-.684-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.476-1.304 6.46-3.292 13.575-6.199 18.21l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.035-2.36 26.255-1.897 8.244.413 16.174 1.725 23.498 3.964l.022-.078h.014a57.883 57.883 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221.392-.785.798-1.548 1.226-2.296 7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.564.926-.164 1.859-.313 2.807-.456 6.27-.92 12.846-1.198 19.565-.855 6.213.313 12.213 1.098 17.898 2.352 1.233.271 2.459.57 3.663.892l.733.192c.086.021.179.043.271.071.114.029.228.058.342.093.755.214 1.504.45 2.252.678.256.078.52.15.776.235 7.667 2.48 14.557 6.01 20.356 10.659a52.13 52.13 0 0 1 3.078 2.673 48.996 48.996 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714a53.34 53.34 0 0 1 1.61 2.181 49.357 49.357 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412-.021.007Zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.059.413-1.831 0-3.591-.135-5.265-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.37 29.37 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32.112 32.112 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30.17 30.17 0 0 1-.42 5.133l.007-.007Z",
        mask: "url(#c)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M178.953-.348c-7.944-.014-15.689-1.098-23.256-2.445l-.107-1.448c.535 7.793 1.354 13.497 1.981 18.217h36.658c-.634-.55-1.275-1.098-1.902-1.655A311.884 311.884 0 0 1 178.953-.348Zm18.289 11.129v-.07c-.022-.507-.043-1.027-.064-1.548v-.171a227.748 227.748 0 0 1-.1-3.415c0-.121 0-.242-.007-.37l-.022-1.32c0-.2 0-.4-.007-.599 0-.399-.007-.798-.014-1.205V-.333c0-.92.014-1.826.036-2.731a40.672 40.672 0 0 1-4.696 1.362c-2.75.598-5.643 1.005-8.678 1.247l.37-.228h.015c-1.119-.007-2.323.136-1.846.285h-.249c1.347 1.348 2.273 2.282 2.608 2.688-.264-.228-2.316-1.989-2.644-2.267 2.038 2.239 6.391 6.324 10.488 9.91 1.66 1.469 3.278 2.86 4.653 4.043h.321a311.19 311.19 0 0 1-.164-3.202v.008Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245D",
        d: "M181.937.023c.328.278 2.38 2.039 2.644 2.267-.342-.406-1.269-1.333-2.608-2.688h.249c-.477-.15.727-.292 1.846-.285h-.015l-.37.228c3.035-.242 5.921-.649 8.678-1.247a40.67 40.67 0 0 0 4.696-1.362c.021-.877.049-1.74.085-2.602l-.484.192c-.478.185-.969.32-1.454.478-.962.335-1.952.57-2.921.805-3.912.927-7.788 1.29-11.329 1.412-.435.014-.869.029-1.297.036a430.203 430.203 0 0 1-6.726-6.916c-5.6-5.882-12.162-13.425-17.435-21.11-.028.37-.064.74-.092 1.118-.029.386-.05.785-.079 1.17.243.335.471.656.684.94.955 1.327 1.703 2.368 2.316 3.138-.755-.656-1.831-1.932-3.028-3.572 0 .071-.007.135-.014.207 4.488 6.43 9.782 12.783 15.582 19.014a409.898 409.898 0 0 0 5.757 6.01c-1.86-.02-3.584-.092-5.144-.156-5.337-.456-10.638-1.234-15.917-2.182.021.285.035.563.057.841.035.492.071.97.106 1.448 7.567 1.34 15.312 2.424 23.256 2.445a311.916 311.916 0 0 0 13.374 12.67c.627.556 1.268 1.105 1.902 1.654h2.858c-1.376-1.191-2.993-2.574-4.653-4.043-4.104-3.586-8.45-7.671-10.488-9.91h-.036Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M197.171 8.985c-.022-.556-.036-1.112-.057-1.69l-.043-1.725c.028 1.176.057 2.31.1 3.415Zm-.15-6.902c0 .407.007.806.014 1.205 0-.399-.007-.798-.014-1.204ZM372.866-38.79c-19.173 11.293-44.36 14.009-67.787 14.009h-65.001c-8.208 0-14.977 1.91-19.338 6.36-.484.491-.94 1.02-1.36 1.575-.214.278-.414.563-.613.863-2.152 3.244-3.342 7.479-3.342 12.847 0 4.25.884 10.702 1.404 16.056.035.357.071.706.1 1.056h-19.523a321.835 321.835 0 0 1-.164-3.202c.05 1.106.1 2.168.164 3.202.513 8.933 1.439 15.264 2.123 20.419h59.359c-.499-5.54-1.504-12.584-1.504-17.111 0-15.607 10.061-21.646 24.646-21.646h65.001c23.42 0 48.607-2.716 67.787-14.01a64.67 64.67 0 0 0 10.175-7.372v-92.749h-20.435v16.634c0 32.86-12.989 52.046-31.692 63.068ZM197.043 3.887c0 .45.014.884.021 1.32l-.021-1.32Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245D",
        d: "M383.126-107.549c0 8.691-1.632 15.386-4.752 20.37-1.561 2.488-3.492 4.555-5.786 6.216a23.495 23.495 0 0 1-3.705 2.203c-1.482.72-3.078 1.305-4.781 1.79-.869.25-1.767.47-2.693.663-3.178.649-6.676.963-10.481.963h-74.599c-.755 0-1.51 0-2.251.021-3.62.057-7.111.25-10.488.57-.385.036-.777.072-1.154.114l-.357.043-.79.086c-3.235.37-6.363.855-9.363 1.469-4.068.834-7.923 1.889-11.556 3.172-.513.178-1.019.37-1.525.556-.1.036-.207.079-.307.114-.306.114-.605.243-.912.364-6.483 2.567-12.219 5.889-17.178 9.939a60.552 60.552 0 0 0-2.173 1.86c-4.631 4.178-8.522 9.048-11.657 14.61-.106.184-.206.377-.313.57-.093.17-.192.342-.285.513-.257.47-.506.955-.748 1.433-3.064 6.067-5.294 12.883-6.655 20.433a94.92 94.92 0 0 0-.527 3.294c-.029.214-.064.42-.093.628a107.939 107.939 0 0 0-.869 9.874 156.42 156.42 0 0 0-.086 2.603c-.021.905-.035 1.81-.035 2.73V2.07c0 .406.007.806.014 1.205 0 .2 0 .4.007.599 0 .45.014.884.022 1.319a1907.277 1907.277 0 0 0 .049 2.096c.015.57.036 1.134.057 1.69v.17l.065 1.548v.071c.049 1.105.099 2.168.163 3.202h19.523c-.029-.35-.064-.7-.1-1.056-.52-5.354-1.403-11.814-1.403-16.056 0-5.361 1.189-9.596 3.341-12.847.193-.293.399-.585.613-.863a15.88 15.88 0 0 1 1.361-1.576c4.353-4.449 11.129-6.36 19.337-6.36h65.001c23.42 0 48.607-2.716 67.788-14.009 18.703-11.015 31.692-30.201 31.692-63.069v-16.626h-21.432v10.944h.021Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        stroke: "#35243F",
        d: "M78.564-67.346c6.518.516 13.329 1.303 20.446 2.368L89.568-2.562C66.492-5.657 49.39-4.285 37.425 1.862 25.46 8.01 18.722 18.886 16.243 34.575l-60.965-9.233c4.02-26.155 12.06-47.013 25.019-62.325 46.462 3.56 78.159-6.886 98.267-30.363Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M293.564 15.808s.499 65.85 0 65.422c0 0 15.127 2.074 32.384 2.573-.05-15.749-.171-32.675-.193-35.94v-.57a75.38 75.38 0 0 0 2.515.82 66.27 66.27 0 0 0 2.202.648c.634.178 1.268.35 1.909.506.157.043.314.079.471.122.677.17 1.361.328 2.037.484.093.022.179.036.271.058.627.135 1.247.27 1.874.392.135.028.271.057.406.078.691.135 1.382.257 2.066.378.1.014.2.036.3.05.634.107 1.268.207 1.895.3.107.014.214.035.321.05.698.099 1.403.192 2.101.284.093.015.193.022.285.036.67.078 1.333.157 1.995.221.057 0 .114.014.171.021.713.072 1.433.136 2.138.193.078 0 .164.014.242.021 1.447.114 2.879.2 4.304.264h.164c1.453.057 2.885.093 4.303.1h.064c1.447.007 2.872 0 4.275-.043V16.371s-36.907 10.431-68.5-.563Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M348.705 51.934c.078 0 .164.014.242.021-.078 0-.164-.014-.242-.021Zm-11.691-1.612c.135.029.27.058.406.079a8.538 8.538 0 0 0-.406-.079Zm-4.646-1.055c.157.043.314.079.47.121a11.683 11.683 0 0 1-.47-.12Zm-4.588-1.304c.164.05.328.1.485.15-.164-.05-.328-.1-.485-.15Zm2.507.748c.057.014.114.029.178.05-.057-.014-.114-.028-.178-.05Zm16.109 3.009c.057 0 .114.014.171.021-.057 0-.114-.014-.171-.021Zm-20.448 32.083c.049 15.1.028 29.104-.2 28.911 0 0 45.222 6.203 68.5-.285v-64.58s-14.029 3.964-32.184 4.427v28.668c-9.811 2.738-23.527 3.216-36.109 2.852l-.007.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245D",
        d: "M357.718 52.319c-1.418-.007-2.85-.043-4.304-.1h-.163a111.47 111.47 0 0 1-4.304-.264c-.078 0-.164-.014-.242-.021-.713-.057-1.425-.121-2.138-.193-.057 0-.114-.014-.171-.021a196.13 196.13 0 0 1-1.995-.221c-.092-.014-.192-.021-.285-.036a74.149 74.149 0 0 1-2.102-.285c-.106-.014-.213-.035-.32-.05a87.475 87.475 0 0 1-1.895-.3c-.1-.014-.2-.035-.3-.05a95.943 95.943 0 0 1-2.472-.455c-.627-.122-1.247-.257-1.874-.393-.093-.02-.178-.035-.271-.057a69.432 69.432 0 0 1-2.508-.606c-.634-.164-1.275-.328-1.909-.506-.057-.014-.114-.028-.178-.05-.677-.192-1.347-.392-2.024-.599-.164-.05-.328-.1-.484-.15a75.03 75.03 0 0 1-2.031-.67v.571c.021 3.265.143 20.198.192 35.94 12.583.364 26.299-.12 36.11-2.852V52.283c-1.404.036-2.829.05-4.275.043h-.064l.007-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M86.99 59.598c.192-.97.491-2.21.883-3.8.499-2.281 1.653-6.032 2.807-9.333 1.155-3.308 2.26-6.188 2.202-6.958-1.097 2.873-2.7 6.987-3.883 10.873-1.204 3.878-2.002 7.507-2.01 9.225v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M69.927 69.016c5.037 2.91 9.504 6.46 13.266 10.688l.043-.4c1.104-9.667 2.772-18.936 5.215-27.427 2.409-8.499 5.658-16.177 9.356-22.715a86.304 86.304 0 0 1 2.671-4.406c-.954.17-1.902.356-2.842.563-16.017 3.486-29.512 11.714-37.464 25.795 2.658 5.069 5.337 10.117 8.144 15.093.528.941 1.076 1.868 1.618 2.802l-.007.007Zm61.146 17.233c.755 3.885 1.866 7.785 3.355 11.521.157-.085.307-.178.464-.264-1.219-3.065-2.501-7.436-3.285-11.764-.898-4.548-1.211-8.997-1.817-11.642.15 3.9.506 8.013 1.283 12.156v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M137.307 33.418a141.891 141.891 0 0 0-7.353 9.468c-4.695 6.61-8.949 13.825-12.404 21.596-3.456 7.771-6.099 16.106-7.538 24.804a90.61 90.61 0 0 0-1.233 15.457c.135.007.271.014.406.028l1.532.093c.513.007 1.019-.028 1.525-.036.506-.028 1.011 0 1.51-.092 1.005-.136 1.995-.214 2.986-.435 6.384-1.184 12.027-3.479 16.366-5.804-.52-1.226-.962-2.495-1.432-3.757-.314-.827-.528-1.69-.791-2.538-.25-.856-.528-1.697-.706-2.574l-.598-2.602c-.185-.87-.307-1.754-.456-2.624-.335-1.74-.442-3.508-.641-5.24-.214-3.48-.3-6.902-.022-10.16.435-6.523 1.746-12.356 3.199-16.854-.399 1.84-1.596 6.373-2.28 11.592l.243.122c.762-6.025 2.629-12.07 5.001-17.739 2.394-5.675 5.23-11.015 8.408-15.8 0 0-.62.735-1.504 1.926a56.993 56.993 0 0 0-3.092 4.663c-1.076 1.81-2.144 3.736-2.928 5.447-.413.848-.791 1.618-1.105 2.267l-.691 1.568v-.078l-.085.15c1.539-4.021 3.398-8.078 5.835-11.957 1.618-2.595 3.499-5.112 5.686-7.407a69.887 69.887 0 0 0-.734-.193c-2.586 1.818-4.909 4.17-7.104 6.73v-.02Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M131.343 60.354c-.342 1.29-.862 3.187-1.126 5.183-.356 1.99-.413 4.064-.406 5.618l.249.05.193-3.28c.028-.784.157-1.554.221-2.131.071-.578.128-.963.149-.97l-.05-.035c.1-.079.307-.065.3-.528.662-3.33 1.019-4.934 1.09-5.397.064-.464-.257.192-.62 1.476v.014ZM66.27 67.07c-2.537-4.534-4.945-9.097-7.317-13.66a2.11 2.11 0 0 1-.122.22c-1.396 2.824-2.572 5.868-3.534 9.134.464.142.92.285 1.376.427a73.399 73.399 0 0 1 9.604 3.872l-.007.007Zm-3.49-8.634c.74 1.355 2.43 4.164 3.028 4.791-.72-1.647-4.774-8.384-3.028-4.79Zm54.72 1.397c1.503-2.866 2.743-5.105 3.969-7.329 1.246-2.21 2.493-4.413 4.203-7.072l-.178-.193c-1.126 1.804-3.463 5.376-5.272 8.634-1.831 3.244-3.164 6.132-2.843 6.203l.114-.236.007-.007Zm-1.825 4.577-.178-.22c-1.995 4.605-3.769 9.39-5.13 14.38l.2.228c1.332-4.898 3.177-9.91 5.108-14.387Zm29.569-36.867.05-.057c.164-.157.313-.306.456-.442a5.425 5.425 0 0 1-.342-.093c-.114.129-.228.264-.349.414l.178.178h.007Zm31.607 25.446c-.05 5.255-.428 10.901-.884 16.427-.869 11.072-2.75 21.574-3.747 27.834.513-2.26 1.054-4.549 1.475-6.895.484-2.331.847-4.712 1.246-7.115.699-4.813 1.333-9.732 1.71-14.73.392-4.998.727-10.06.77-15.136.028-2.16-.014-4.328-.107-6.488-.185-.242-.378-.478-.57-.713.1 2.167.135 4.449.107 6.823v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M178.738 61.324c-.826 16.583-3.37 33.288-8.528 47.832a111.022 111.022 0 0 1-4.96 11.828l2.679-.399a37.628 37.628 0 0 0-.427 1.961c-.036.178-.064.356-.1.527a45.054 45.054 0 0 0-.249 1.612c-.014.121-.036.242-.05.363-.057.485-.1.97-.142 1.455.812.221 1.617.427 2.422.598-2.636-.27-2.337-.128-.342.286.05.007.107.021.157.028 5.272-4.327 9.661-9.71 12.882-16.284 3.448-7.023 5.629-15.343 6.12-25.175.499-9.981-.848-18.594-3.612-26.009a49.36 49.36 0 0 0-5.665-10.887c.114 4.086.022 8.185-.185 12.264Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M159.743 76.274c-2.807 4.264-5.978 8.185-9.362 11.757-3.356 3.586-7.09 6.802-11.023 9.461.022-.021.463-.4.962-.82.249-.214.499-.42.677-.592.185-.17.306-.285.313-.292a59.435 59.435 0 0 1-4.788 3.365c.171.378.342.763.506 1.141a65.376 65.376 0 0 0 2.565 4.734c3.684 6.082 8.408 11.172 13.595 14.901a43.595 43.595 0 0 0 3.584 2.317c.228-.035.463-.071.691-.1.812-.121 1.589-.235 2.344-.349.499-.071.983-.15 1.446-.214.271-.043.528-.078.784-.114.399-.791.77-1.604 1.161-2.396 1.048-2.074 1.874-4.249 2.786-6.388.428-1.076.805-2.181 1.212-3.265l.598-1.633c.192-.549.356-1.105.534-1.654l1.055-3.315.919-3.351.456-1.675.399-1.69.791-3.373.677-3.393.335-1.697.285-1.704c.192-1.134.377-2.274.57-3.408l.47-3.415.235-1.704.185-1.711c.129-1.14.25-2.275.378-3.408.798-9.098 1.361-18.188.812-27.022 0-.042-.007-.085-.007-.128a49.15 49.15 0 0 0-3.669-3.836c-.022 2.025-.235 4.022-.556 5.968-1.938 10.701-6.284 20.512-11.906 29.025l-.014-.022ZM129.035 66.6c-.064.37-.135.463-.164.826-.035.528.164 1.355.221 1.804 0-.314.079-1.02.107-1.625.029-.6.057-1.098-.157-1.006h-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M161.988 72.11a37.13 37.13 0 0 0 1.617-3.13c-1.689 2.19-5.472 9.34-1.617 3.13Zm-16.109-42.157c-2.473 2.816-4.56 6.039-6.37 9.44-3.577 6.837-6.17 14.33-7.439 22.023-.142.963-.342 1.918-.434 2.888l-.314 2.901c-.114 1.94-.278 3.872-.242 5.804-.05 1.932.107 3.85.199 5.76.221 1.904.378 3.8.741 5.662.271 1.875.763 3.7 1.183 5.518.535 1.79 1.026 3.586 1.71 5.297.207.62.449 1.227.698 1.826.15-.093.307-.186.456-.279 2.302-1.397 4.055-2.723 5.273-3.621.591-.47 1.054-.842 1.368-1.091.313-.25.47-.385.47-.385 1.974-1.676 3.798-3.53 5.572-5.433 1.788-1.89 3.434-3.907 5.03-5.953 1.589-2.054 3.05-4.2 4.453-6.388 1.361-2.21 2.651-4.456 3.805-6.78 0 0 .214-.4.563-1.148.349-.742.876-1.804 1.432-3.145a73.816 73.816 0 0 0 3.641-10.616c1.111-4.178 1.845-8.798 1.532-12.926-.014-.235-.05-.463-.071-.698-5.8-4.656-12.697-8.178-20.357-10.66-.256-.085-.52-.156-.776-.235a36.67 36.67 0 0 0-2.123 2.232v.007Zm23.683 18.944c.285-1.255.492-2.802.627-3.594.086-1.554.022-2.139-.043-2.103-.078.036-.149.692-.292 1.611-.235 1.84-.812 4.727-1.019 5.946.136.35.449-.606.72-1.86h.007Zm-68.458-21.689c.342-.663.513-.962.485-.97-.022-.007-.242.279-.592.835-.342.563-.869 1.369-1.46 2.424-1.226 2.096-2.807 5.169-4.425 8.905-1.61 3.743-3.199 8.177-4.567 12.926-2.743 9.51-4.375 20.276-5.272 28.953-.057.578-.114 1.14-.171 1.697 3.042 3.871 5.536 8.263 7.374 13.204a57.52 57.52 0 0 1 1.111 3.308c.036.029.072.05.1.079.812.584 1.632 1.183 2.515 1.704.435.263.855.556 1.311.798.45.243.905.478 1.361.72.45.257.92.464 1.397.663l1.418.613 1.467.499.734.25.748.185 1.504.371h.007c0-1.091 0-2.189.043-3.287.334-11.15 2.785-22.322 6.868-32.853 4.083-10.545 9.776-20.448 16.43-29.51 1.682-2.26 3.385-4.477 5.187-6.651 1.81-2.168 3.741-4.285 5.943-6.16l.128-.107c-5.693-1.262-11.685-2.047-17.898-2.353-6.719-.335-13.295-.064-19.565.855a84.573 84.573 0 0 0-3.798 5.975c.705-1.419 1.275-2.403 1.617-3.066v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245D",
        d: "M175.076 72.267c-.128 1.134-.249 2.275-.377 3.409l-.186 1.71-.235 1.705c-.157 1.133-.313 2.274-.47 3.415-.185 1.133-.378 2.267-.57 3.408l-.285 1.704-.335 1.697-.677 3.393-.791 3.373-.399 1.69-.456 1.675-.919 3.351-1.054 3.315c-.178.549-.342 1.112-.535 1.654l-.598 1.633c-.406 1.09-.784 2.188-1.211 3.265-.912 2.139-1.739 4.313-2.786 6.388-.392.799-.763 1.604-1.162 2.396.285-.043.556-.086.827-.122.349-.663.719-1.361 1.097-2.117.413-1.005.613-.934.784-1.098.028-.093.021-.135-.022-.078 0 0 .036-.057.086-.15.05-.1.121-.243.214-.421.164-.37.392-.905.662-1.54.528-1.283 1.304-2.959 1.91-4.727 1.346-3.479 2.394-7.136 2.515-7.4l.214.171c-.52 1.775-1.083 3.857-1.91 5.996-.399 1.069-.784 2.189-1.247 3.287-.477 1.09-.954 2.196-1.432 3.294-.456 1.105-1.033 2.153-1.546 3.186-.264.507-.513 1.013-.769 1.512.37-.057.719-.107 1.054-.157.128-.257.257-.513.378-.77l.142.292-.214.428c.157-.021.3-.043.449-.064a109.559 109.559 0 0 0 4.959-11.828c5.159-14.544 7.702-31.25 8.529-47.833.199-4.078.299-8.177.185-12.263a45.124 45.124 0 0 0-1.61-2.181c.093 2.16.135 4.327.107 6.488-.043 5.083-.371 10.145-.77 15.136-.384 4.998-1.011 9.917-1.71 14.73-.399 2.395-.762 4.784-1.247 7.115-.42 2.346-.969 4.634-1.474 6.894.997-6.26 2.878-16.768 3.747-27.834.463-5.525.834-11.172.884-16.426a118.14 118.14 0 0 0-.107-6.823c-.285-.35-.57-.7-.862-1.041 0 .042.007.085.007.128.549 8.834-.014 17.917-.812 27.021l.028.014Zm-6.462 40.311c-.292.813-.442.999-.812 1.804-.3.157.163-.919.627-2.274.484-1.34 1.097-2.902 1.332-3.608-.285 1.02-.72 2.916-1.147 4.078Zm-.941-60.338a74.31 74.31 0 0 1-3.641 10.616c-.562 1.34-1.083 2.403-1.432 3.145-.342.741-.563 1.147-.563 1.147-1.154 2.318-2.451 4.57-3.804 6.78-1.404 2.182-2.865 4.328-4.453 6.389-1.596 2.046-3.249 4.057-5.031 5.953-1.774 1.904-3.598 3.757-5.571 5.433 0 0-.157.142-.471.385-.313.25-.776.613-1.368 1.09-1.218.906-2.964 2.225-5.272 3.623-.15.092-.307.185-.456.278.292.706.605 1.397.912 2.089a59.741 59.741 0 0 0 4.788-3.366s-.136.122-.314.293c-.178.17-.434.378-.677.591-.491.421-.933.799-.961.82 3.933-2.659 7.673-5.874 11.022-9.46a84.976 84.976 0 0 0 9.362-11.757c5.622-8.513 9.975-18.316 11.906-29.025a38.45 38.45 0 0 0 .556-5.968 55.617 55.617 0 0 0-3.078-2.673c.021.235.057.463.071.699.314 4.128-.42 8.748-1.532 12.925l.007-.007Zm-5.685 19.87c-3.855 6.21-.065-.94 1.617-3.13a38.858 38.858 0 0 1-1.617 3.13Zm8.165-28.91c.057-.036.128.542.043 2.103-.136.792-.35 2.346-.627 3.594-.278 1.254-.585 2.21-.72 1.86.207-1.226.784-4.106 1.019-5.946.142-.92.214-1.575.292-1.611h-.007ZM88.45 51.877c-2.444 8.491-4.111 17.76-5.215 27.428l-.043.399a48.92 48.92 0 0 1 1.902 2.281c.057-.556.114-1.12.171-1.697.898-8.676 2.53-19.45 5.273-28.953 1.368-4.748 2.95-9.183 4.567-12.926 1.617-3.736 3.199-6.809 4.424-8.905.592-1.062 1.119-1.868 1.461-2.424.349-.563.57-.841.592-.834.028.007-.143.306-.485.97-.342.662-.912 1.646-1.617 3.065a86.36 86.36 0 0 1 3.797-5.974 74.35 74.35 0 0 0-2.807.456 85.949 85.949 0 0 0-2.672 4.406c-3.698 6.538-6.947 14.216-9.355 22.715l.007-.007Zm2.23-5.412c-1.154 3.309-2.308 7.052-2.807 9.333-.392 1.59-.691 2.83-.883 3.8.007-1.718.812-5.347 2.009-9.225 1.183-3.886 2.786-7.993 3.883-10.873.057.763-1.055 3.65-2.202 6.958v.007Zm21.988 82.747a78.014 78.014 0 0 1-3.071-13.24 82.354 82.354 0 0 1-.762-8.755c.399.029.79.057 1.182.078.314.015.627.05.941.043l.933-.028c.62-.029 1.247-.015 1.86-.079 2.494-.249 4.816-.72 7.161-1.312 2.337-.598 4.638-1.383 6.932-2.302a53.578 53.578 0 0 0 6.227-3.002c-.149-.335-.313-.656-.456-.991-.178-.37-.349-.749-.506-1.134-4.339 2.325-9.989 4.62-16.366 5.804-.99.221-1.98.299-2.985.435-.499.085-1.005.064-1.511.092-.505.008-1.018.05-1.524.036l-1.532-.093c-.136-.007-.271-.021-.406-.028a90.712 90.712 0 0 1 1.232-15.457c1.432-8.698 4.083-17.033 7.539-24.804 3.455-7.771 7.709-14.987 12.404-21.596a141.563 141.563 0 0 1 7.353-9.468c2.188-2.56 4.517-4.905 7.104-6.73a94.78 94.78 0 0 0-3.662-.891c-.043.035-.086.07-.129.107-2.208 1.875-4.132 4-5.942 6.16-1.803 2.167-3.505 4.391-5.187 6.651-6.662 9.07-12.348 18.965-16.43 29.51-4.083 10.53-6.534 21.703-6.869 32.853a83.783 83.783 0 0 0-.042 3.287h-.008l-1.503-.371-.748-.185-.734-.25-1.468-.499-1.418-.613a12.374 12.374 0 0 1-1.396-.663l-1.36-.72c-.45-.242-.877-.535-1.312-.798-.876-.514-1.696-1.113-2.515-1.704-.036-.029-.071-.05-.1-.079.357 1.17.67 2.367.955 3.593 1.41.899 2.85 1.704 4.31 2.403 2.373 1.148 4.86 1.882 7.332 2.374.285 9.183 1.988 18.217 5.294 26.594 1.112 2.702 2.508 5.34 4.232 7.735.186.015.364.029.549.036a37.958 37.958 0 0 1-1.382-2.06c-2.622-4.357-4.111-8.941-5.023-12.313l-.599-2.303c-.171-.685-.285-1.283-.399-1.775l-.335-1.533c.428 1.64.841 3.287 1.361 4.926a60.26 60.26 0 0 0 1.66 4.913c1.24 3.251 2.8 6.466 4.881 9.382.192.271.392.535.598.799.691.035 1.383.05 2.074.071-.064-.078-.136-.143-.193-.221-2.835-3.458-4.788-7.614-6.227-11.914l-.014.029Zm7.559-75.346c1.81-3.251 4.147-6.83 5.273-8.634l.178.193c-1.71 2.659-2.957 4.862-4.204 7.072-1.225 2.225-2.465 4.463-3.968 7.33l-.114.235c-.314-.072 1.011-2.96 2.843-6.203l-.008.007Zm-4.738 10.324.178.22c-1.93 4.478-3.776 9.49-5.108 14.388l-.2-.228c1.361-4.99 3.135-9.774 5.13-14.38Zm-12.953 40.147c-.37-.114-.577-.214-.705-.314-.257-.207-.235-.371-.677-.72.719.392 3.527 1.305 2.878 1.29l.235.1c-.826-.064-1.353-.249-1.731-.349v-.007Zm4.346 8.684c-.263-1.804-.32-3.223-.377-4.193-.007-.976.021-1.518.078-1.582.114-.129.235 1.639.527 5.575l.022.178-.25.014v.008ZM69.926 69.016a562.81 562.81 0 0 1-1.617-2.802c-2.807-4.976-5.486-10.031-8.144-15.093a53.76 53.76 0 0 0-1.225 2.296c2.372 4.563 4.787 9.126 7.317 13.66a63.866 63.866 0 0 1 3.662 1.947l.007-.008Zm-4.118-5.796c-.606-.627-2.294-3.437-3.028-4.791-1.746-3.593 2.315 3.137 3.028 4.791Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245D",
        d: "m133.622 46.251.093-.15v.08c.164-.364.399-.906.691-1.57.314-.648.691-1.418 1.105-2.267.783-1.704 1.852-3.636 2.928-5.447a56.958 56.958 0 0 1 3.092-4.662c.884-1.191 1.504-1.925 1.504-1.925-3.178 4.784-6.014 10.124-8.408 15.799-2.373 5.668-4.239 11.714-5.002 17.738l-.242-.12c.684-5.22 1.881-9.754 2.28-11.594-1.453 4.5-2.757 10.331-3.199 16.855-.278 3.258-.192 6.68.021 10.16.2 1.732.307 3.493.642 5.24.156.87.27 1.754.456 2.623l.598 2.603c.178.87.456 1.718.705 2.574.264.848.478 1.71.791 2.538.471 1.262.912 2.53 1.432 3.757.164.378.328.763.506 1.134.15.335.307.663.456.991a43.144 43.144 0 0 0 1.824 3.614 54.821 54.821 0 0 0 2.608 4.221 53.39 53.39 0 0 0 5.771 7.087 47.479 47.479 0 0 0 5.829 5.069c-.129-.228-1.39-1.112-2.622-2.21-.635-.535-1.226-1.148-1.732-1.69-.484-.563-.855-1.069-.99-1.426 2.764 2.895 5.928 5.369 9.184 7.387.969-.143 1.917-.286 2.836-.421a40.767 40.767 0 0 1-3.584-2.317c-5.187-3.729-9.911-8.819-13.595-14.901a61.437 61.437 0 0 1-2.565-4.734 55.475 55.475 0 0 0-.506-1.14c-.306-.692-.619-1.384-.912-2.09a27.164 27.164 0 0 1-.698-1.825c-.684-1.711-1.168-3.508-1.71-5.297-.42-1.826-.912-3.644-1.183-5.519-.363-1.86-.527-3.764-.741-5.66-.092-1.911-.249-3.83-.199-5.761-.043-1.933.128-3.865.242-5.804l.314-2.902c.092-.97.299-1.925.434-2.887 1.269-7.693 3.855-15.186 7.439-22.023 1.81-3.401 3.897-6.624 6.37-9.44a36.67 36.67 0 0 1 2.123-2.232 74.296 74.296 0 0 0-2.252-.677 13.84 13.84 0 0 1-.456.442l-.05.057-.178-.178c.121-.15.235-.285.349-.414-.085-.021-.178-.043-.27-.071-2.181 2.296-4.069 4.813-5.686 7.408-2.437 3.885-4.296 7.935-5.835 11.956l-.008.021Zm-4.424 21.36c-.029.6-.107 1.305-.107 1.626-.057-.449-.249-1.283-.221-1.803.029-.364.1-.457.164-.828.221-.092.185.407.157 1.006h.007Zm10.466 41.973c-.399-.349-.79-.92-1.161-1.512-.356-.598-.67-1.219-.955-1.654.164-.092.834.799 1.418 1.647.584.849 1.055 1.669.698 1.519Zm-8.065-23.849c.784 4.328 2.066 8.698 3.285 11.764.064.164.128.335.192.492.242.52.499 1.055.755 1.59 1.247 2.567 2.679 5.205 4.275 7.693.955 1.504 1.988 2.93 3.007 4.271 1.047 1.319 2.08 2.566 3.114 3.643.356.392.755.784 1.175 1.183.413.414.855.827 1.34 1.248-5.28-4.057-10.218-10.402-13.445-17.724a50.49 50.49 0 0 1-.599-1.419c-.099-.235-.192-.478-.285-.713-1.489-3.729-2.6-7.636-3.356-11.522-.776-4.142-1.132-8.256-1.282-12.156.598 2.646.912 7.095 1.817 11.643l.007.007Zm.363-26.857c-.071.463-.42 2.068-1.09 5.397.007.464-.199.442-.299.528l.05.035s-.079.385-.15.97c-.057.577-.192 1.347-.221 2.132l-.192 3.28-.249-.05c-.008-1.555.049-3.637.406-5.619.263-1.996.783-3.9 1.125-5.183.364-1.283.684-1.94.62-1.476v-.014Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M93.459 137.325a45.18 45.18 0 0 1-1.425-.449 72.597 72.597 0 0 1-6.042-2.253 62.083 62.083 0 0 1-2.886-1.304 69.158 69.158 0 0 1-2.793-1.426c-10.523-5.704-18.824-14.11-23.52-25.574-.206-.499-.398-1.006-.59-1.512a56.423 56.423 0 0 1-2.473-8.748 60.143 60.143 0 0 1-.755-4.763c-.456-3.807-.592-7.85-.378-12.156.3-5.981 1.218-11.4 2.658-16.312-7.332-2.239-15.255-3.55-23.499-3.964-9.22-.464-18.083.128-26.255 1.896C-11.656 64.468-25.68 73.458-33.323 89c-3.492 7.102-5.7 15.529-6.2 25.518-.49 9.839.842 18.33 3.57 25.666 2.929 7.871 7.517 14.352 13.374 19.571 0-.078.014-.157.021-.235.043-.549.072-1.098.093-1.654 0-.121.014-.235.014-.357.022-.656.022-1.311.008-1.975 0-.121-.008-.249-.015-.37a31.844 31.844 0 0 0-.085-1.633l-.043-.542a31.428 31.428 0 0 0-.228-1.989s37.542 9.575 37.356 9.276v.071c0 .043-.007.1-.014.171v.029c0 .071-.014.164-.021.263 0 .029 0 .05-.007.079-.008.107-.022.221-.036.349 0 .029 0 .057-.007.086-.014.142-.029.299-.05.47v.029c-.021.171-.036.356-.057.556 0 .028 0 .057-.007.085-.021.2-.043.407-.071.628 0 .043-.008.085-.015.135-.028.221-.05.449-.078.685 0 .057-.014.107-.021.164-.029.242-.064.499-.093.755 0 .05-.014.1-.021.157-.036.278-.072.556-.114.849a.637.637 0 0 1-.015.114c-.035.285-.078.577-.12.877 0 .043-.015.078-.015.121-.043.314-.093.627-.135.955-.008.065-.022.129-.029.193-.05.321-.1.649-.15.984-.014.071-.02.142-.035.214-.05.335-.107.677-.164 1.026a1.84 1.84 0 0 1-.036.193c-.057.363-.12.727-.185 1.098-.007.05-.021.107-.028.157-.065.363-.129.734-.2 1.105 0 .035-.014.071-.021.1-.072.392-.15.784-.221 1.183-.014.057-.021.121-.036.178l-.17.863c4.353.756 8.87 1.241 13.494 1.476 8.77.442 17.292-.15 25.215-1.868 17.008-3.686 31.165-12.691 38.86-28.319 1.404-2.845 2.58-5.911 3.541-9.197.328-1.134.627-2.303.905-3.494a62.925 62.925 0 0 1-.912 3.508l-.014.021Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245D",
        d: "M52.605 79.147c-.214 4.307-.078 8.35.378 12.157a60.226 60.226 0 0 0 .755 4.763 56.211 56.211 0 0 0 2.472 8.747c.193.514.385 1.013.591 1.512 4.696 11.464 12.996 19.87 23.52 25.574A65.93 65.93 0 0 0 86 134.63a75.19 75.19 0 0 0 6.042 2.253c.47.157.947.3 1.425.449.335-1.14.634-2.31.912-3.507.05-.214.1-.435.142-.656a72.775 72.775 0 0 0 .734-3.886 64.059 64.059 0 0 0 .513-3.928c.036-.35.064-.699.1-1.056.078-.905.15-1.818.2-2.752 0-.099.014-.199.02-.306v-.057c.357-7.03-.213-13.382-1.545-19.115a60.129 60.129 0 0 0-.955-3.593 52.91 52.91 0 0 0-1.112-3.308c-1.838-4.941-4.332-9.326-7.374-13.204a48.92 48.92 0 0 0-1.902-2.282c-3.762-4.228-8.23-7.778-13.267-10.687a61.698 61.698 0 0 0-3.662-1.947 70.724 70.724 0 0 0-9.605-3.87c-.456-.15-.912-.293-1.375-.429h-.014c-.007.029-.014.05-.022.079-1.439 4.912-2.358 10.33-2.657 16.312l.007.007Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1D2125",
        d: "M58.287-54H477.02v400.9H58.287z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "#303134",
        clipPath: "url(#e)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M101 31h342v8H101zM91 51h352v8H91zm0 21h161v8H91z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#g)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 313.252,
        height: 18.265,
        x: 40,
        y: 23.171,
        fill: "#22272B",
        rx: 2.74
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "#505258",
        fillRule: "evenodd",
        clipPath: "url(#h)",
        clipRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.537 28.762a.792.792 0 0 0-.809.001.824.824 0 0 0-.403.715v1.095l1.337.79c.329.194.53.552.53.94v2.825a1.1 1.1 0 0 1-.062.366l1.795-1.062a.83.83 0 0 0 .404-.717v-2.824a.833.833 0 0 0-.404-.717l-2.388-1.412Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.94 35.13a.824.824 0 0 1-.404.715h.001a.792.792 0 0 1-.809.002l-2.387-1.413a.833.833 0 0 1-.405-.717v-2.825a.83.83 0 0 1 .404-.716l1.795-1.062c-.04.116-.062.24-.062.366v2.825c0 .388.201.745.53.939l1.337.791v1.094Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.537 28.762a.792.792 0 0 0-.809.001.824.824 0 0 0-.403.715v1.095l1.337.79c.329.194.53.552.53.94v2.825a1.1 1.1 0 0 1-.062.366l1.795-1.062a.83.83 0 0 0 .404-.717v-2.824a.833.833 0 0 0-.404-.717l-2.388-1.412Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.94 35.13a.824.824 0 0 1-.404.715h.001a.792.792 0 0 1-.809.002l-2.387-1.413a.833.833 0 0 1-.405-.717v-2.825a.83.83 0 0 1 .404-.716l1.795-1.062c-.04.116-.062.24-.062.366v2.825c0 .388.201.745.53.939l1.337.791v1.094Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#454F59",
        d: "M55.525 29.792h21.919v5.023H55.525z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M82.924 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        d: "M89.545 31.961h2.969v-2.853h.684V35.5h-.684v-2.853h-2.97V35.5h-.684v-6.392h.685v2.853Zm5.465.721c.213 0 .399.031.555.093a.822.822 0 0 1 .363.259c.085.11.128.239.128.388v.004a.559.559 0 0 1-.278.496.809.809 0 0 1-.27.108v.014a.837.837 0 0 1 .481.189.53.53 0 0 1 .177.417v.003a.741.741 0 0 1-.14.452.882.882 0 0 1-.396.294 1.672 1.672 0 0 1-.614.101 1.44 1.44 0 0 1-.577-.107.935.935 0 0 1-.391-.303.877.877 0 0 1-.165-.463l-.002-.024h.748l.003.022a.27.27 0 0 0 .06.135c.032.04.075.073.13.097a.483.483 0 0 0 .192.035.45.45 0 0 0 .19-.037.3.3 0 0 0 .122-.104.278.278 0 0 0 .043-.152v-.003a.233.233 0 0 0-.107-.208.56.56 0 0 0-.312-.072h-.275V33.8h.275c.082 0 .151-.01.208-.031a.289.289 0 0 0 .13-.09.231.231 0 0 0 .046-.144v-.003a.25.25 0 0 0-.152-.242.389.389 0 0 0-.172-.036c-.07 0-.13.013-.182.037a.286.286 0 0 0-.12.102.325.325 0 0 0-.054.151l-.002.017h-.707l.002-.027a.858.858 0 0 1 .153-.452.879.879 0 0 1 .366-.294 1.31 1.31 0 0 1 .544-.106Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "m99.834 31.377 1.812 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M109.865 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#9FADBC",
        strokeLinejoin: "round",
        strokeWidth: 1.027,
        d: "M119.797 32.304c.788 0 1.427-.553 1.427-1.341 0-.789-.639-1.342-1.427-1.342h-2.112v2.683m2.112 0h.457c.788 0 1.427.553 1.427 1.341 0 .788-.639 1.342-1.427 1.342h-2.569v-2.683m2.112 0h-2.112"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "M133.154 29.108h2.968v.684h-1.1l-1.205 5.023h1.163v.685h-2.968v-.684h1.1l1.206-5.024h-1.164v-.684Zm8.233 2.269 1.813 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M151.419 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#9FADBC",
        strokeLinejoin: "round",
        strokeWidth: 0.685,
        d: "M159.067 33.674v-.171l.586-1.541m3.296 1.712v-.171l-.583-1.541m0 0-1.121-2.969h-.465l-1.127 2.969m2.713 0h-2.713"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#9FADBC",
        strokeWidth: 1.37,
        d: "M164.662 35.272h-7.307"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "m168.329 31.377 1.812 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.485-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#9FADBC",
        strokeLinejoin: "round",
        strokeWidth: 0.685,
        d: "m183.269 31.048-.57 1.598.285.286m.285-1.884 2.829-1.975a.286.286 0 0 1 .366.032l.575.575a.285.285 0 0 1 .032.366l-1.975 2.829m-1.827-1.827 1.827 1.827m0 0-1.598.57-.286-.285m-.228-.228-.514.514.229.228.513-.514m-.228-.228.228.228"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#B6C2CF",
        strokeWidth: 1.37,
        d: "M188.407 35.272h-7.306"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "m192.074 31.377 1.812 1.813 1.813-1.813.484.484-2.054 2.055a.343.343 0 0 1-.485 0l-2.055-2.055.485-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M202.105 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "M214.891 30.25h-6.392v-.686h6.392v.685Zm0 2.397h-6.392v-.685h6.392v.685Zm-3.196 2.397h-3.196v-.685h3.196v.685Zm7.32-3.667 1.813 1.813 1.812-1.813.485.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Zm14.142-1.47a.57.57 0 1 1 1.141-.001.57.57 0 0 1-1.141 0Zm6.393.342h-4.567v-.685h4.567v.685Zm-6.393 2.055a.57.57 0 1 1 1.141 0 .57.57 0 0 1-1.141 0Zm6.393.342h-4.567v-.684h4.567v.684Zm-6.393 2.055a.57.57 0 1 1 1.14 0 .57.57 0 0 1-1.14 0Zm6.393.343h-4.567v-.685h4.567v.685Zm4.123-3.667 1.813 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M253.705 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "M263.395 29.664a1.795 1.795 0 1 1 2.539 2.54l-1.028 1.027-.484-.484 1.027-1.028a1.11 1.11 0 1 0-1.57-1.57l-1.027 1.027-.485-.484 1.028-1.028Zm1.397 1.626-2.511 2.512-.485-.484 2.512-2.512.484.484Zm-4.137 1.114 1.027-1.027.485.484-1.028 1.028a1.11 1.11 0 1 0 1.571 1.57l1.027-1.027.484.484-1.027 1.027a1.795 1.795 0 1 1-2.539-2.539Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M272.427 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "M278.364 30.078c0-.662.536-1.199 1.198-1.199h4.909a1.2 1.2 0 0 1 1.199 1.199v3.767a1.2 1.2 0 0 1-1.199 1.199h-4.076l-1.519.868a.343.343 0 0 1-.512-.297v-5.537Zm1.198-.514a.514.514 0 0 0-.513.514v4.946l1.165-.665h4.257c.284 0 .514-.23.514-.514v-3.767a.514.514 0 0 0-.514-.514h-4.909Zm4.282 2.055h-3.654v-.685h3.654v.685Zm-1.37 1.37h-2.284v-.685h2.284v.685Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#454F59",
        d: "M288.41 29.793h21.919v5.023H288.41z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M315.808 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "M321.744 32.304a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Zm2.968 0a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Zm2.968 0a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M334.529 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        d: "M342.91 28.65a.628.628 0 0 0-.579.872l.041.08.377.628v1.587a2.22 2.22 0 0 0-.541.279c-.419.297-.829.823-.829 1.692 0 .19.153.343.342.343h2.055v1.826h.685V34.13h2.055a.343.343 0 0 0 .343-.342c0-.869-.411-1.395-.83-1.692a2.25 2.25 0 0 0-.54-.28V30.23l.376-.628a.628.628 0 0 0-.538-.951h-2.417Zm1.942 1.309a.34.34 0 0 0-.048.176v1.94c0 .168.121.311.286.339h.004l.03.007a1.552 1.552 0 0 1 .509.234c.211.15.428.39.508.79h-4.045c.08-.4.297-.64.508-.79a1.556 1.556 0 0 1 .51-.234l.03-.007h.003a.342.342 0 0 0 .287-.338v-1.941a.342.342 0 0 0-.049-.176l-.374-.623h2.215l-.374.623Z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#CECFD2",
        d: "M143.186 68.735c.141 0 .586 3.665.305 5.157.482.302.897 1.064.875 1.858 2.034 1.56.772-2.411.352-3.645-.342.828-.07-1.266-.333-1.589.016.178-.352-3.375-1.016-2.393-.085-.11-.354.712-.185.61l.002.002Zm-7.937 3.73c.135.784-.204 1.446-.751 2.075.334 2.71 2.44-1.575 2.936-2.62 0 0 .912-1.817.922-1.593.352-.138 2.323-2.659 1.016-2.603-.373.393-.718 1.363-1.123 1.35-.904.194-1.934 2.682-2.999 3.395l-.001-.004Zm-6.428-7.115c-.435 1.7 2.805.443 4.076.388 0 0 1.318.014 1.68-.215-.191-.002 4.487-.226 2.034-1.145-.066.023-1.686.097-1.686.097-2.117-.528-4.351.11-6.106.877l.002-.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#669DF1",
        fillOpacity: 0.14,
        d: "M314 47.745H147.042v14.637H314z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M137.436 45h17.153v18.297h-17.153z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#i)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1F1F21",
        d: "M149.798 43.71a6.006 6.006 0 0 0-3.969 1.339 6.026 6.026 0 0 0-3.968-1.338h-1.143v3.43h1.143c1.613 0 2.116.801 2.287 1.144v4.506h-1.143v3.43h1.143v3.431c-.148.343-.651 1.143-2.287 1.143h-1.143v3.431h1.143a6.026 6.026 0 0 0 3.968-1.338 5.965 5.965 0 0 0 3.969 1.338h1.143v-3.43h-1.143c-1.613 0-2.116-.8-2.288-1.144v-3.43h1.213V52.79h-1.144v-4.506c.149-.343.652-1.143 2.287-1.143h1.144V43.71h-1.212Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#CECFD2",
        d: "M149.798 45.998v-1.143a4.574 4.574 0 0 0-3.969 1.875 4.574 4.574 0 0 0-3.968-1.875v1.143a3.213 3.213 0 0 1 3.431 2.104v5.832h-1.144v1.144h1.144v4.757a3.234 3.234 0 0 1-3.431 2.104v1.144a4.635 4.635 0 0 0 3.968-1.864 4.636 4.636 0 0 0 3.969 1.864v-1.144a3.225 3.225 0 0 1-3.362-2.104v-4.769h1.143v-1.143h-1.143v-5.81a3.211 3.211 0 0 1 3.362-2.115Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M0 0h477v81H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M-259-118.5h684v385h-684z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "d"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 419.213,
        height: 220.555,
        x: 58.287,
        y: -54,
        fill: "#fff",
        rx: 5.243
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "e"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M31.03-25.464a3.932 3.932 0 0 1 3.932-3.932h487.581v374.861H31.03V-25.464Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 313.252,
        height: 18.265,
        x: 40,
        y: 23.171,
        fill: "#fff",
        rx: 2.74
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "h"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M45.48 28.65h7.306v7.307H45.48z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "f",
        width: 324.211,
        height: 29.225,
        x: 34.52,
        y: 21.345,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 3.653
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 2.74
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.36 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13247_134475"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 0.228
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "effect1_dropShadow_13247_134475",
        result: "effect2_dropShadow_13247_134475"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_13247_134475",
        result: "shape"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feMorphology", {
        in: "SourceAlpha",
        radius: 0.457,
        result: "effect3_innerShadow_13247_134475"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feComposite", {
        in2: "hardAlpha",
        k2: -1,
        k3: 1,
        operator: "arithmetic"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.737255 0 0 0 0 0.839216 0 0 0 0 0.941176 0 0 0 0.12 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "shape",
        result: "effect3_innerShadow_13247_134475"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "i",
        width: 14.866,
        height: 25.095,
        x: 138.431,
        y: 42.565,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 1.144
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 1.144
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13247_134475"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_13247_134475",
        result: "shape"
    }))));
const $3faf0024169aae07$var$NewToolbarBannerImageLight = ({ title: title, titleId: titleId, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "56px",
        viewBox: "0 0 477 56",
        fill: "none",
        "aria-labelledby": titleId,
        ...props
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#eed7fc",
        d: "M-68.35-100.55c.706 3.65 1.105 7.55 1.162 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.55 38.086-.142.036-.292.079-.434.114-.613.157-1.226.307-1.853.45-.192.042-.392.092-.584.135q-1.152.247-2.337.463a69 69 0 0 1-8.422.949q-1.452.076-2.935.1a74 74 0 0 1-5.059-.115q-.641-.03-1.282-.07a71 71 0 0 1-5.508-.607 56 56 0 0 1-2.23-.385 15 15 0 0 1-.549-.114 67 67 0 0 1-1.717-.364 11 11 0 0 1-.47-.114 42 42 0 0 1-1.91-.492q-.087-.021-.164-.042c-12.141-3.366-21.823-10.374-27.88-20.67-4.125 6.98-9.953 12.47-17.114 16.32l.406.15a50.29 50.29 0 0 1-2.323 1.198c-.149-.05-.306-.107-.456-.157l-.52.243c.193.07.335.135.414.178-.008 0-.015.007-.029.014l-.463-.157a54 54 0 0 1-8.322 2.966c-.143.036-.292.079-.435.114a70.62 70.62 0 0 1-1.852.45c-.193.042-.392.092-.584.135q-1.154.247-2.337.463a69 69 0 0 1-8.422.948q-1.452.077-2.936.1a74 74 0 0 1-5.058-.114 76 76 0 0 1-1.311-.071 70 70 0 0 1-5.48-.606c-.256-.036-.505-.086-.755-.128l.107.356a62 62 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a65 65 0 0 1-1.132-.25q-.235-.051-.471-.114a42 42 0 0 1-1.909-.492q-.087-.021-.164-.042c-13.096-3.608-23.32-11.458-29.241-23.093v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138.285-1.497.613-2.945.984-4.363a61 61 0 0 1 2.678-8.007 56 56 0 0 1 1.483-3.23c.042-.085.085-.164.128-.249.064-.121.128-.236.192-.364.335-.649.67-1.305 1.026-1.932a50.7 50.7 0 0 1 12.262-14.452 55 55 0 0 1 5.052-3.629 60 60 0 0 1 6.484-3.55 59 59 0 0 1 2.472-1.112 71 71 0 0 1 8.564-2.988c.114-.035.235-.057.349-.092l.727-.193c.228-.057.449-.121.677-.178.406-.107.805-.221 1.211-.314 6.961-1.69 14.215-2.495 22.323-2.495 1.161 0 2.308.014 3.455.05.342.007.677.028 1.019.042 1.112.043 2.223.1 3.321.179 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542v-.007q.267.084.534.157h-.014q.137-.045.285-.079l.256.086c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.12 7.593 6.385 2.816 12.028 6.431 16.816 10.958 10.26 9.796 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.579c5.45-6.83 8.208-17.639 8.393-33.075l40.391-.114v.007h.221c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.414-17.703 8.607-33.346h.491v-.007l40.392-.114c.278 15.764 3.078 26.694 8.678 33.46h63.904c-6.897-11.893-11.863-24.505-11.863-36.069 0-2.346.086-4.663.25-6.959.498-6.873 2.073-12.997 4.496-18.38.313-.699.641-1.376.983-2.046.1-.2.207-.399.306-.599.185-.349.378-.699.57-1.041 6.562-11.771 17.428-19.485 29.647-23.121a57 57 0 0 1 3.912-1.006 60 60 0 0 1 11.151-1.397c.427-.014.862-.036 1.289-.036v-.043c.086 0 .164.022.25.022s.163-.022.249-.022v.043c.292 0 .584.022.869.029a59.5 59.5 0 0 1 11.792 1.461 54 54 0 0 1 1.532.364c.199.05.392.107.591.164q1.602.428 3.171.941c6.192 2.046 11.998 5.155 17.022 9.333a46.7 46.7 0 0 1 7.003 7.222c5.722 7.315 9.548 16.683 10.382 28.126.164 2.296.249 4.62.249 6.959 0 2.203-.185 4.442-.52 6.709-.036.242-.078.485-.121.72-.036.235-.079.463-.121.699-.079.449-.164.891-.257 1.34-1.788 8.791-5.8 17.888-10.851 26.601H425v-292.23c-3.142 2.788-6.548 5.234-10.175 7.372-19.173 11.294-44.36 14.01-67.787 14.01h-65.001c-14.592 0-24.646 6.04-24.646 21.646 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.216a224 224 0 0 1-.492-11.886 325 325 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.022-.342.036-.506.028-.392.05-.784.078-1.17q.16-2.158.406-4.241c.727-6.267 1.988-12.078 3.791-17.418a70 70 0 0 1 2.707-6.852c.25-.549.513-1.09.777-1.625a60 60 0 0 1 2.558-4.67 54 54 0 0 1 1.902-2.937q.492-.715 1.005-1.42a57 57 0 0 1 3.249-4.035c.157-.178.328-.356.484-.534q.333-.377.677-.742a57.7 57.7 0 0 1 7.759-6.901c9.377-6.945 21.261-11.486 35.554-13.518a125 125 0 0 1 13.502-1.141q2.362-.076 4.788-.078h74.442c1.211 0 2.38-.036 3.527-.1l.648-.043c13.039-.87 21.881-6.01 25.771-16.961.043-.122.093-.243.136-.364q.247-.717.463-1.476c.036-.114.064-.235.093-.349a37 37 0 0 0 .776-3.451H101.425c-4.51 20.719-12.005 37.659-23.056 50.635a293 293 0 0 1 21.24 2.467l-9.59 63.396C43.434-21.347 21.482-9.54 16.687 22.151l-61.952-9.383c4.018-26.55 12.155-47.74 25.372-63.261a293 293 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.826c10.502 6.531 17.79 16.976 20.498 30.936zm171.407 305.704c-1.61.264-3.299.406-5.059.414a32 32 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.4 29.4 0 0 1-.456-5.126q-.001-2.759.435-5.197c1.717-9.647 8.422-15.628 17.862-17.233a32 32 0 0 1 5.266-.442q2.641 0 5.059.385c9.447 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.366.456 5.198 0 1.811-.143 3.522-.421 5.133-1.703 9.689-8.421 15.7-17.876 17.261zm121.524-17.546c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.058.413-1.832 0-3.592-.135-5.266-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.4 29.4 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32 32 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30 30 0 0 1-.42 5.133zm20.748-40.953c.499.421 0-65.421 0-65.421 31.592 11 68.5.563 68.5.563v64.58c-23.278 6.488-68.5.286-68.5.286zM362.065 3.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.58c-23.277 6.489-68.499.286-68.499.286.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563m-401.572 98.154c.498-9.982 2.707-18.416 6.198-25.517 7.646-15.55 21.668-24.533 38.825-28.24 8.172-1.769 17.036-2.36 26.255-1.897 8.244.413 16.174 1.725 23.499 3.964.007-.029.014-.05.02-.078h.015a58 58 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221q.586-1.176 1.226-2.296c7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.563.926-.165 1.859-.314 2.807-.457 6.27-.92 12.847-1.197 19.565-.855 6.213.313 12.213 1.098 17.898 2.353 1.233.27 2.458.57 3.663.89.242.065.491.129.733.193.086.022.179.043.271.072.114.028.228.056.342.092.755.214 1.504.45 2.252.677.256.079.52.15.776.236 7.667 2.48 14.557 6.01 20.356 10.659a52 52 0 0 1 3.078 2.673 49 49 0 0 1 3.67 3.836q.436.515.862 1.04c.192.236.378.478.57.714q.832 1.07 1.61 2.181a49.4 49.4 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412c-2.429-4.906-3.691-12.185-4.346-18.744-3.719.264-7.545.321-11.429.192q-1.037-.03-2.073-.071h-.071l-.684-.043c-.185-.007-.364-.021-.549-.035-7.787-.478-15.283-1.754-22.237-3.872-.955 3.28-2.137 6.353-3.541 9.197-7.695 15.621-21.852 24.626-38.86 28.319-7.923 1.718-16.444 2.31-25.215 1.868-4.631-.235-9.141-.72-13.495-1.476-1.304 6.46-3.292 13.575-6.199 18.209l-36.871-9.154s7.053-11.151 8.143-24.519c-5.856-5.219-10.445-11.7-13.373-19.571-2.73-7.336-4.062-15.827-3.57-25.666zm-79.829 28.19 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.272-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.585-.727.213-1.461.406-2.202.563q-.365-.31-.719-.621c-5.045.97-10.46.628-16.01-1.019a45.6 45.6 0 0 1-6.926-2.695 47 47 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668l-.235-.043-.121-.021a29 29 0 0 1-1.347-2.51q.128.02.257.05c-1.96-3.836-3.021-8.028-3.092-12.491-4.076-.307-7.98-.592-11.529-.82l.449-.228a20 20 0 0 1-2.707.1c-.072.313-.136.62-.221.934a22 22 0 0 1-1.411 3.721 22.7 22.7 0 0 1-1.995 3.38c-4.389 6.081-11.001 7.964-18.005 5.889a24 24 0 0 1-3.605-1.405 24 24 0 0 1-3.477-2.039c-5.978-4.22-8.621-10.544-6.626-17.738a22.5 22.5 0 0 1 1.396-3.672 22 22 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.875 1.24.364 2.501.841 3.755 1.454a24.5 24.5 0 0 1 3.342 1.947c5.03 3.522 7.687 8.57 7.21 14.395 1.845.163 3.171.313 3.171.313l5.4.05s2.722.079 4.938.057a34.2 34.2 0 0 1 1.161-6.438c.642-2.31 1.532-4.663 2.679-7.051a43 43 0 0 1 3.898-6.58c5.885-8.107 13.822-12.3 22.664-12.77.492-8.17.948-16.398 2.231-22.059.748 2.638.071-6.46.591-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.122-35.584 35.568-5.126 5.123 35.584-20.207 2.909c-.549 6.901-1.225 13.51-1.468 14.23-.064-.12.121-.706-.292-.734-.085 1.034-.071 2.125-.15 3.223.649-.286.321-1.64.528-1.74.071 4.1-.585 12.42-1.233 17.018 3.043.086 6.177.585 9.355 1.512a47.4 47.4 0 0 1 7.218 2.787 45.5 45.5 0 0 1 6.419 3.743c3.912 2.738 7.076 5.947 9.398 9.547.164-.107.335-.214.499-.32a6 6 0 0 0-.392.491 1 1 0 0 1 .079.136c1.218-.685 8.949-7.593 9.796-7.743-.035.057-.292.47-.334.542 1.019-.371 2.999-2.802 3.726-2.396.185-.128.506-.392.919-.748-3.049-3.865-4.104-8.691-2.636-13.989a22.6 22.6 0 0 1 1.396-3.672 22 22 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.4 24.4 0 0 1 3.342 1.946c5.978 4.185 8.628 10.517 6.612 17.753a22 22 0 0 1-1.41 3.722 22.7 22.7 0 0 1-1.996 3.38c-4.389 6.08-11 7.963-18.005 5.888a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04 20 20 0 0 1-2.971-2.552 1166 1166 0 0 1-14.272 10.623 29.08 29.08 0 0 1 1.397 2.902q.173.396.335.791v.03c2.166 5.738 2.451 12.198.534 19.085q-.972 3.508-2.714 7.144c-.015.029-.036.064-.05.093.149.092.299.178.449.271-.05.107-.093.213-.143.313a47 47 0 0 1-1.054 2.047c-.157-.093-.321-.186-.478-.286a43 43 0 0 1-1.966 3.187c3.021 1.512 7.303 4.107 9.497 5.725-.335-.071-1.083-.37-1.859-.834l-.143.214c1.824 1.012 3.249 2.995 5.422 3.151 0 0-2.109-1.561-2.486-2.003l.028-.014-.014-.043c4.261 2.189 9.17 5.183 13.416 7.65l17.97-14.224 22.294 28.198-28.18 22.309-22.294-28.198z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M197.242-2.29a493.5 493.5 0 0 1-.064-1.547v-.17a228 228 0 0 1-.1-3.416q.002-.18-.007-.37l-.022-1.32q.002-.3-.007-.599-.002-.597-.014-1.205v-2.416c0-.92.014-1.826.036-2.731a41 41 0 0 1-4.696 1.362c-2.75.598-5.643 1.005-8.678 1.247l.37-.228h.015c-1.119-.007-2.323.136-1.846.285h-.249c1.347 1.348 2.273 2.282 2.608 2.688-.264-.228-2.316-1.989-2.644-2.267 2.038 2.239 6.391 6.324 10.488 9.91 1.66 1.469 3.278 2.86 4.653 4.043h.321a311 311 0 0 1-.164-3.202v-.07zM178.96-13.348c-7.945-.014-15.69-1.098-23.256-2.445-.036-.478-.072-.956-.107-1.448.534 7.793 1.353 13.497 1.98 18.217h36.659c-.635-.55-1.276-1.098-1.903-1.654a311 311 0 0 1-13.373-12.67"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#eed7fc",
        d: "M181.946-12.977c.327.278 2.379 2.039 2.643 2.267-.342-.406-1.268-1.333-2.608-2.688h.25c-.478-.15.726-.292 1.845-.285h-.014l-.371.228c3.036-.242 5.921-.649 8.678-1.247a41 41 0 0 0 4.696-1.362c.021-.877.05-1.74.085-2.602l-.484.192c-.477.185-.976.32-1.454.478-.962.335-1.952.57-2.921.805-3.911.927-7.788 1.29-11.329 1.412a80 80 0 0 1-1.296.036 422 422 0 0 1-6.726-6.916c-5.601-5.882-12.163-13.425-17.435-21.11-.029.37-.064.74-.093 1.118-.028.386-.05.785-.078 1.17.242.335.47.656.684.94.954 1.327 1.703 2.368 2.315 3.138-.755-.656-1.831-1.932-3.028-3.572 0 .071-.007.135-.014.207 4.489 6.43 9.783 12.783 15.582 19.014a410 410 0 0 0 5.757 6.01c-1.859-.02-3.583-.092-5.144-.156-5.336-.457-10.638-1.234-15.917-2.182.021.285.035.563.057.841.035.492.071.97.107 1.448 7.567 1.34 15.311 2.424 23.256 2.445a312 312 0 0 0 13.373 12.67c.627.556 1.269 1.105 1.903 1.654h2.857c-1.375-1.191-2.993-2.574-4.653-4.043-4.104-3.586-8.45-7.671-10.488-9.91z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M372.866-51.79c-19.173 11.293-44.36 14.009-67.787 14.009h-65.002c-.912 0-1.802.021-2.679.071-13.124.72-21.966 6.945-21.966 21.575 0 4.534 1.005 11.578 1.503 17.11h-19.522a322 322 0 0 1-.164-3.2c.05 1.105.1 2.167.164 3.2.513 8.934 1.439 15.265 2.123 20.42h59.359c-.499-5.54-1.504-12.584-1.504-17.111 0-15.607 10.061-21.646 24.646-21.646h65.001c23.42 0 48.607-2.716 67.787-14.01A64.7 64.7 0 0 0 425-38.742v-92.75h-20.435v16.634c0 32.86-12.989 52.046-31.692 63.068z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#eed7fc",
        d: "M383.126-120.549c0 9.411-1.909 16.491-5.557 21.582-3.086 4.306-7.425 7.193-12.904 8.855-.178.056-.37.1-.556.156-.826.236-1.667.45-2.543.635q-.075.009-.15.028a48 48 0 0 1-6.726.856q-.91.055-1.852.078-.939.031-1.91.029h-74.599c-1.567 0-3.106.028-4.631.078-1.574.05-3.121.129-4.645.228q-1.144.075-2.266.172c-.399.035-.798.07-1.197.114-.342.035-.691.064-1.04.1-.043 0-.079.007-.121.014l-.357.042-.791.086q-1.562.18-3.092.392a95 95 0 0 0-6.619 1.162 88 88 0 0 0-3.256.742 86 86 0 0 0-7.317 2.146c-4.204 1.44-8.116 3.18-11.728 5.204a64 64 0 0 0-5.201 3.244 58 58 0 0 0-2.815 2.082q-.408.323-.805.656a61 61 0 0 0-2.173 1.861c-4.631 4.178-8.522 9.048-11.657 14.609-.106.185-.206.378-.313.57-.093.171-.192.342-.285.513-.257.47-.506.956-.748 1.433-3.064 6.068-5.294 12.884-6.655 20.434a95 95 0 0 0-.527 3.294 106 106 0 0 0-.962 10.509c-.036.863-.064 1.725-.086 2.602a117.4 117.4 0 0 0-.035 2.73v2.418q.002.608.014 1.205-.002.3.007.599c0 .449.014.884.022 1.319a242.218 242.218 0 0 0 .106 3.786v.17l.065 1.548v.071c.049 1.105.099 2.167.163 3.201h19.523c-.499-5.54-1.503-12.584-1.503-17.11 0-14.63 8.842-20.855 21.966-21.575q1.313-.074 2.679-.072h65.001c23.42 0 48.607-2.716 67.788-14.01 18.703-11.015 31.692-30.2 31.692-63.068v-16.662h-21.432v10.944z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M78.348-80.858C58.355-57.373 26.72-46.878-19.922-50.5a91 91 0 0 1 1.896-2.153 93 93 0 0 0-1.903 2.153C-33.144-34.98-41.28-13.79-45.3 12.76l61.952 9.384C21.447-9.541 43.4-21.354 89.982-15.003l9.59-63.396c-7.402-1.12-14.477-1.94-21.239-2.467a221 221 0 0 0-4.168-.286q2.063.127 4.168.286zM293.564 2.808s.499 65.85 0 65.421c0 0 15.127 2.075 32.384 2.574v-3.437l-.043-9.646v-.02q.002-.782-.007-1.554v-5.27c-.057-9.503-.107-16.583-.107-16.583q1.016.352 2.03.67l.485.15a67.963 67.963 0 0 0 2.202.65 90.53 90.53 0 0 0 1.909.505c.157.043.314.079.47.121.677.172 1.361.329 2.038.485.093.022.178.036.271.057a82.64 82.64 0 0 0 2.28.471c.691.135 1.375.257 2.066.378.1.014.2.035.299.05a94 94 0 0 0 1.896.3c.106.013.213.035.32.05q1.046.147 2.102.284c.093.014.192.022.285.036.67.078 1.332.157 1.995.22.057 0 .114.015.171.022.713.072 1.432.136 2.138.193.078 0 .163.014.242.021q2.167.17 4.303.264h.164q2.179.087 4.304.1h.064c1.446.007 2.871 0 4.275-.043V3.371s-36.908 10.43-68.5-.563z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M348.713 38.934c.078 0 .164.014.242.021-.078 0-.164-.014-.242-.021m-22.757 31.869c.05 15.1.029 29.103-.199 28.91 0 0 45.222 6.204 68.5-.284v-64.58s-14.03 3.964-32.184 4.427v28.668c-9.811 2.738-23.527 3.216-36.11 2.852zm-.199-36.518s.057 7.08.107 16.584c-.057-9.504-.107-16.584-.107-16.584m11.264 3.038c.135.028.27.057.413.078a7.366 7.366 0 0 0-.413-.079m9.375 1.398c.057 0 .114.014.171.021-.057 0-.114-.014-.171-.021m-14.021-2.453c.157.043.313.079.47.121-.157-.035-.313-.078-.47-.12m-2.08-.557q.084.02.178.05a2 2 0 0 1-.178-.05"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#eed7fc",
        d: "M357.727 39.319q-2.125-.012-4.304-.1h-.164c-1.425-.057-2.857-.15-4.303-.264-.079 0-.164-.014-.242-.021q-1.069-.085-2.138-.193c-.057 0-.114-.014-.171-.021-.663-.071-1.332-.143-1.995-.221-.093-.014-.192-.022-.285-.036a75 75 0 0 1-2.102-.285c-.107-.014-.214-.036-.32-.05a86 86 0 0 1-1.896-.3c-.099-.014-.199-.035-.299-.05a99.632 99.632 0 0 1-2.479-.456 70.958 70.958 0 0 1-1.867-.392c-.093-.021-.178-.035-.271-.057a70 70 0 0 1-2.038-.484q-.234-.056-.47-.122c-.634-.164-1.275-.328-1.909-.506a110.499 110.499 0 0 1-2.202-.649l-.485-.15a69 69 0 0 1-2.03-.67s.057 7.087.107 16.584v5.269q-.002.771.007 1.554v.021l.043 9.647v3.436c12.582.364 26.298-.121 36.109-2.852V39.283q-2.106.054-4.275.043h-.064z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M66.278 54.07c-2.536-4.535-4.945-9.097-7.317-13.66q-.056.116-.121.22c-1.397 2.824-2.58 5.868-3.534 9.134q.693.214 1.375.427a73.4 73.4 0 0 1 9.604 3.872zm93.473 9.204c-2.808 4.264-5.978 8.185-9.363 11.757-3.355 3.586-7.089 6.802-11.022 9.461.021-.021.463-.4.962-.82.249-.214.499-.42.677-.591l.313-.293a59 59 0 0 1-4.788 3.365c.171.378.342.763.506 1.141a65 65 0 0 0 2.565 4.734c3.684 6.082 8.408 11.172 13.595 14.901a43 43 0 0 0 3.584 2.317c.228-.035.463-.071.691-.1.812-.121 1.589-.235 2.344-.349.499-.071.983-.15 1.446-.214.271-.043.527-.078.784-.114.399-.791.769-1.604 1.161-2.395 1.048-2.075 1.874-4.25 2.786-6.389.428-1.076.805-2.181 1.211-3.265l.599-1.633c.192-.549.356-1.105.534-1.654l1.055-3.315.919-3.351.456-1.675.399-1.69.791-3.372.677-3.394.335-1.697.285-1.704c.192-1.134.377-2.274.569-3.408l.471-3.415.235-1.704.185-1.711c.128-1.14.25-2.275.378-3.408.798-9.098 1.361-18.188.812-27.021 0-.043-.007-.086-.007-.129a49 49 0 0 0-3.669-3.836 40.4 40.4 0 0 1-.556 5.968c-1.938 10.702-6.284 20.512-11.906 29.025zm-58.639-49.066c.342-.663.513-.962.485-.97-.022-.006-.243.279-.592.835-.342.563-.869 1.369-1.46 2.424-1.226 2.096-2.808 5.169-4.425 8.905-1.61 3.743-3.2 8.178-4.567 12.926-2.743 9.51-4.375 20.277-5.273 28.953l-.17 1.697c3.042 3.872 5.535 8.263 7.374 13.204q.599 1.617 1.111 3.308c.036.029.072.05.1.079.812.584 1.632 1.183 2.515 1.704.435.264.855.556 1.311.798.449.243.905.478 1.361.72.449.257.92.464 1.397.663l1.417.614 1.468.499.734.25.748.184 1.503.371h.008c0-1.09 0-2.189.042-3.287.335-11.15 2.786-22.322 6.869-32.853 4.083-10.545 9.775-20.448 16.43-29.51a167 167 0 0 1 5.187-6.651c1.81-2.168 3.741-4.285 5.942-6.16l.129-.107c-5.693-1.262-11.685-2.046-17.898-2.353-6.719-.335-13.296-.064-19.566.855a85 85 0 0 0-3.797 5.975c.705-1.419 1.275-2.403 1.617-3.066z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M176.851 39.989c-.05 5.255-.428 10.901-.884 16.427-.869 11.072-2.75 21.574-3.747 27.834.513-2.26 1.054-4.549 1.475-6.895.484-2.331.84-4.712 1.246-7.115.699-4.812 1.333-9.732 1.71-14.73.392-4.998.727-10.06.77-15.136.028-2.16-.014-4.328-.107-6.488-.185-.242-.378-.478-.57-.713.1 2.167.135 4.449.107 6.823z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M178.739 48.324c-.827 16.583-3.371 33.288-8.529 47.832a111 111 0 0 1-4.959 11.828l2.679-.399a38 38 0 0 0-.428 1.961c-.035.178-.064.356-.099.527a43 43 0 0 0-.25 1.612c-.014.121-.035.242-.05.37-.057.485-.099.97-.142 1.455a44 44 0 0 0 2.422.599c-2.636-.271-2.337-.129-.342.285.05.007.107.021.157.028 5.273-4.327 9.662-9.71 12.882-16.284 3.449-7.022 5.629-15.343 6.121-25.175.498-9.981-.848-18.594-3.613-26.008a49.4 49.4 0 0 0-5.664-10.887c.114 4.085.021 8.185-.185 12.263zM161.988 59.11a37.13 37.13 0 0 0 1.617-3.13c-1.689 2.19-5.472 9.34-1.617 3.13M86.99 46.598c.192-.97.49-2.21.883-3.8.498-2.281 1.653-6.032 2.807-9.333 1.154-3.308 2.259-6.188 2.202-6.958-1.098 2.873-2.7 6.987-3.883 10.872-1.205 3.879-2.003 7.508-2.01 9.226z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M69.933 56.016c5.037 2.91 9.505 6.46 13.267 10.688l.042-.4c1.105-9.667 2.772-18.936 5.216-27.427 2.408-8.499 5.657-16.177 9.355-22.715a86 86 0 0 1 2.672-4.406q-1.433.254-2.843.563C81.625 15.805 68.13 24.033 60.179 38.114c2.657 5.07 5.336 10.117 8.144 15.093.527.941 1.076 1.868 1.617 2.802zm75.318-41.473.05-.057q.243-.237.456-.442a6 6 0 0 1-.342-.092q-.169.19-.35.413l.179.178zM129.042 53.6c-.064.37-.135.463-.164.826-.035.528.164 1.355.221 1.804 0-.313.078-1.02.107-1.625.028-.6.057-1.098-.157-1.005zm2.308-6.246c-.342 1.29-.862 3.187-1.126 5.183-.356 1.99-.413 4.064-.406 5.618l.249.05.193-3.28c.028-.784.156-1.554.221-2.131.071-.578.128-.963.149-.97l-.05-.035c.1-.079.307-.065.3-.528.662-3.33 1.018-4.934 1.09-5.397.064-.464-.257.192-.62 1.476zM110.367 65.57l.2.228c1.332-4.898 3.177-9.91 5.108-14.387l-.178-.221c-1.995 4.605-3.769 9.39-5.13 14.38m35.518-48.617c-2.472 2.816-4.56 6.039-6.369 9.44-3.577 6.837-6.171 14.33-7.439 22.023-.142.963-.342 1.918-.435 2.888l-.313 2.901c-.114 1.94-.278 3.872-.242 5.804-.05 1.932.107 3.85.199 5.76.221 1.904.378 3.8.741 5.662.271 1.875.763 3.7 1.183 5.518.541 1.79 1.026 3.586 1.71 5.297.207.62.449 1.227.698 1.826.15-.093.307-.186.456-.279 2.302-1.397 4.054-2.723 5.273-3.621.591-.471 1.054-.842 1.368-1.091.313-.25.47-.385.47-.385 1.974-1.676 3.798-3.53 5.572-5.433 1.788-1.89 3.434-3.907 5.03-5.953 1.589-2.054 3.049-4.2 4.453-6.388 1.361-2.21 2.651-4.456 3.805-6.78 0 0 .214-.4.563-1.149.349-.741.876-1.803 1.432-3.144a74 74 0 0 0 3.641-10.616c1.111-4.178 1.845-8.798 1.532-12.926-.015-.235-.05-.463-.072-.698-5.799-4.656-12.696-8.178-20.356-10.66-.256-.085-.52-.156-.776-.235a37 37 0 0 0-2.124 2.232zm-25.656 23.913c-1.832 3.244-3.164 6.132-2.843 6.203l.114-.236c1.503-2.866 2.743-5.104 3.968-7.329 1.247-2.21 2.494-4.413 4.204-7.072l-.178-.193c-1.126 1.804-3.463 5.376-5.273 8.634z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M137.314 20.418a141 141 0 0 0-7.353 9.468c-4.696 6.61-8.949 13.825-12.405 21.596s-6.099 16.106-7.538 24.804a90.7 90.7 0 0 0-1.233 15.457c.136.007.271.014.406.029l1.532.092c.513.007 1.019-.028 1.525-.035.506-.029 1.012 0 1.518-.093 1.004-.136 1.995-.214 2.985-.435 6.384-1.183 12.027-3.48 16.366-5.803-.52-1.227-.962-2.496-1.432-3.758-.313-.827-.527-1.69-.791-2.538-.249-.856-.527-1.697-.705-2.574l-.599-2.602c-.185-.87-.306-1.754-.456-2.624-.335-1.74-.442-3.508-.641-5.24-.214-3.48-.299-6.902-.021-10.16.434-6.523 1.745-12.355 3.199-16.854-.399 1.84-1.596 6.374-2.28 11.592l.242.122c.762-6.025 2.629-12.07 5.002-17.739 2.394-5.675 5.23-11.015 8.407-15.8 0 0-.62.735-1.503 1.926a57 57 0 0 0-3.092 4.663c-1.076 1.81-2.145 3.736-2.929 5.447-.413.848-.784 1.618-1.104 2.267l-.691 1.568v-.078l-.086.15c1.539-4.021 3.399-8.078 5.836-11.957 1.617-2.595 3.498-5.111 5.685-7.407l-.733-.193c-2.587 1.818-4.91 4.171-7.104 6.73zM62.78 45.436c.741 1.355 2.43 4.164 3.028 4.791-.72-1.647-4.773-8.384-3.028-4.79m106.79-9.54c.285-1.255.491-2.802.627-3.594.085-1.554.021-2.139-.043-2.103-.079.036-.15.692-.292 1.611-.235 1.84-.813 4.727-1.019 5.946.135.35.449-.606.727-1.86"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#eed7fc",
        d: "M69.933 56.016a567 567 0 0 1-1.617-2.801c-2.808-4.977-5.487-10.032-8.144-15.094-.42.749-.834 1.511-1.226 2.296 2.373 4.563 4.788 9.126 7.318 13.66a64 64 0 0 1 3.662 1.947zm-4.118-5.796c-.606-.627-2.294-3.437-3.028-4.791-1.746-3.593 2.315 3.137 3.028 4.791m109.268 9.048c-.128 1.133-.249 2.274-.378 3.407l-.185 1.712-.235 1.704c-.157 1.133-.313 2.274-.47 3.415-.193 1.133-.378 2.267-.57 3.408l-.285 1.704-.335 1.696-.677 3.394-.791 3.372-.399 1.69-.456 1.676-.919 3.35-1.055 3.316c-.178.549-.342 1.112-.534 1.654l-.598 1.633c-.407 1.09-.784 2.188-1.212 3.265-.912 2.139-1.738 4.313-2.786 6.388-.391.799-.762 1.604-1.161 2.396.285-.043.556-.086.827-.122.349-.663.719-1.361 1.097-2.117.413-1.005.613-.934.784-1.098.028-.093.021-.135-.022-.078 0 0 .036-.057.086-.15q.075-.152.213-.421c.164-.371.392-.905.663-1.54.527-1.283 1.304-2.959 1.91-4.727 1.346-3.479 2.394-7.136 2.515-7.4l.213.17c-.52 1.776-1.083 3.858-1.909 5.997-.399 1.07-.784 2.189-1.247 3.287-.477 1.09-.955 2.195-1.432 3.293-.456 1.106-1.033 2.154-1.546 3.187-.264.507-.513 1.013-.77 1.512.371-.057.72-.107 1.055-.157q.194-.385.377-.77l.143.292-.214.428c.157-.021.299-.043.449-.064a110 110 0 0 0 4.959-11.828c5.159-14.544 7.702-31.25 8.529-47.833.199-4.078.299-8.177.185-12.263a45 45 0 0 0-1.61-2.181c.092 2.16.135 4.327.107 6.488-.043 5.083-.371 10.145-.77 15.136-.385 4.998-1.012 9.917-1.71 14.73-.399 2.395-.762 4.784-1.247 7.115-.42 2.346-.969 4.634-1.475 6.894.998-6.26 2.879-16.769 3.748-27.834.463-5.525.834-11.172.884-16.426.028-2.375 0-4.663-.107-6.824q-.426-.525-.862-1.04c0 .042.007.085.007.128.548 8.834-.015 17.917-.813 27.021zm-6.462 40.31c-.293.813-.442.999-.813 1.804-.299.157.164-.92.62-2.274.485-1.34 1.098-2.902 1.333-3.608-.285 1.02-.72 2.916-1.148 4.078zm-33.936-80.514c-1.803 2.167-3.506 4.391-5.187 6.651-6.662 9.07-12.348 18.965-16.431 29.51-4.082 10.53-6.533 21.703-6.868 32.853a84 84 0 0 0-.043 3.287h-.007l-1.503-.37-.749-.186-.733-.25-1.468-.499-1.418-.613c-.477-.2-.948-.406-1.397-.663l-1.36-.72c-.45-.242-.877-.535-1.311-.798-.877-.514-1.696-1.113-2.515-1.704-.036-.029-.072-.05-.1-.079.356 1.17.67 2.367.954 3.593a40.651 40.651 0 0 0 4.311 2.403c2.373 1.148 4.859 1.882 7.332 2.374.285 9.183 1.988 18.217 5.294 26.594 1.111 2.702 2.508 5.34 4.232 7.735.185.015.363.029.548.036a39 39 0 0 1-1.382-2.06c-2.622-4.357-4.111-8.941-5.023-12.313l-.598-2.303c-.171-.684-.285-1.283-.399-1.775l-.335-1.533c.427 1.64.84 3.287 1.361 4.926a60 60 0 0 0 1.66 4.913c1.239 3.251 2.8 6.466 4.88 9.382q.289.405.599.799c.691.035 1.382.05 2.073.071-.064-.078-.135-.143-.192-.221-2.836-3.458-4.788-7.614-6.227-11.914a78 78 0 0 1-3.071-13.239c-.421-2.916-.656-5.84-.763-8.755.399.028.791.057 1.183.078.314.014.627.05.941.043l.933-.029c.62-.028 1.247-.014 1.86-.078 2.493-.25 4.816-.72 7.16-1.312 2.337-.599 4.639-1.383 6.933-2.303a53.5 53.5 0 0 0 6.227-3.001c-.15-.336-.313-.656-.456-.991q-.269-.557-.506-1.134c-4.339 2.324-9.989 4.62-16.366 5.803-.99.221-1.981.3-2.985.435-.499.086-1.005.065-1.518.093-.506.007-1.019.05-1.525.036l-1.532-.093c-.135-.007-.27-.021-.406-.028a90.7 90.7 0 0 1 1.233-15.458c1.432-8.698 4.083-17.032 7.538-24.804 3.456-7.77 7.709-14.986 12.405-21.595a141 141 0 0 1 7.353-9.468c2.187-2.56 4.517-4.905 7.103-6.73a94 94 0 0 0-3.662-.892l-.128.107c-2.209 1.875-4.133 4-5.942 6.16zm-32.141 72.273c-.371-.115-.577-.214-.706-.314-.256-.207-.235-.37-.677-.72.72.392 3.527 1.305 2.879 1.29l.235.1c-.826-.064-1.354-.25-1.731-.35zm4.346 8.683c-.264-1.803-.321-3.222-.378-4.192-.007-.977.022-1.518.079-1.582.114-.129.235 1.64.527 5.575l.021.178-.249.014zm3.676-34.222-.199-.228c1.361-4.99 3.135-9.775 5.13-14.38l.178.22c-1.931 4.478-3.776 9.49-5.109 14.388m10.909-26.301c-1.226 2.224-2.465 4.463-3.969 7.33l-.114.235c-.313-.072 1.012-2.96 2.843-6.203 1.81-3.251 4.147-6.83 5.273-8.634l.178.192c-1.71 2.66-2.957 4.863-4.204 7.073zm46.206-.257a74.4 74.4 0 0 1-3.641 10.616c-.563 1.34-1.083 2.403-1.432 3.145a22 22 0 0 1-.563 1.148c-1.154 2.317-2.451 4.57-3.805 6.78-1.404 2.181-2.864 4.327-4.453 6.388-1.596 2.046-3.249 4.057-5.03 5.953-1.774 1.904-3.598 3.757-5.572 5.433 0 0-.157.142-.47.385-.314.25-.777.613-1.368 1.09-1.219.906-2.964 2.225-5.273 3.623-.149.092-.306.185-.456.278.292.706.606 1.397.912 2.089a60 60 0 0 0 4.788-3.366s-.135.122-.313.293-.435.378-.677.591c-.492.421-.941.799-.962.82 3.933-2.659 7.674-5.874 11.022-9.46a85 85 0 0 0 9.363-11.757c5.621-8.513 9.975-18.316 11.905-29.025.328-1.947.535-3.943.556-5.968a55 55 0 0 0-3.078-2.673c.022.235.057.463.071.698.314 4.129-.42 8.749-1.531 12.927zm-5.693 19.87c-3.855 6.21-.064-.94 1.617-3.13a39 39 0 0 1-1.617 3.13m8.172-28.91c.057-.036.128.542.043 2.103-.135.792-.349 2.346-.627 3.594-.278 1.254-.584 2.21-.727 1.86.207-1.226.784-4.106 1.019-5.946.143-.92.214-1.575.292-1.611m-81.702 8.677c-2.444 8.491-4.112 17.76-5.216 27.428l-.043.399c.656.741 1.29 1.497 1.903 2.281q.086-.833.17-1.697c.898-8.676 2.53-19.45 5.273-28.953 1.368-4.748 2.95-9.183 4.567-12.926 1.618-3.736 3.2-6.809 4.425-8.905.591-1.062 1.118-1.868 1.46-2.424.35-.563.57-.841.592-.834.028.007-.143.306-.485.97s-.912 1.646-1.617 3.065a86 86 0 0 1 3.798-5.974c-.941.135-1.874.285-2.808.456a86 86 0 0 0-2.672 4.406c-3.697 6.538-6.946 14.216-9.355 22.715zm2.222-5.412c-1.154 3.309-2.308 7.052-2.807 9.333-.392 1.59-.69 2.83-.883 3.8.007-1.718.812-5.347 2.009-9.225 1.183-3.886 2.786-7.993 3.883-10.873.057.763-1.054 3.65-2.202 6.958z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#eed7fc",
        d: "m133.631 33.252.093-.15v.078c.164-.363.399-.905.691-1.568.313-.65.691-1.42 1.104-2.268.784-1.704 1.853-3.636 2.929-5.447a57 57 0 0 1 3.092-4.662c.883-1.191 1.503-1.925 1.503-1.925-3.177 4.784-6.013 10.124-8.407 15.799-2.373 5.668-4.24 11.714-5.002 17.738l-.242-.12c.684-5.22 1.881-9.754 2.28-11.594-1.454 4.5-2.758 10.331-3.199 16.855-.278 3.258-.193 6.68.021 10.16.2 1.732.306 3.493.641 5.24.157.87.271 1.754.456 2.624l.599 2.602c.178.87.456 1.718.705 2.574.264.848.478 1.71.791 2.538.47 1.262.912 2.53 1.432 3.757.164.378.328.763.506 1.134.15.335.306.663.456.99a43 43 0 0 0 1.824 3.615 55 55 0 0 0 2.608 4.221c1.824 2.667 3.79 5.055 5.771 7.087a47.6 47.6 0 0 0 5.828 5.069c-.128-.228-1.389-1.112-2.622-2.21-.634-.535-1.225-1.148-1.731-1.69-.485-.563-.855-1.069-.99-1.426 2.764 2.895 5.928 5.369 9.184 7.387l2.835-.421a41 41 0 0 1-3.583-2.317c-5.187-3.729-9.911-8.82-13.595-14.901a61 61 0 0 1-2.565-4.734q-.248-.576-.506-1.14c-.306-.692-.62-1.384-.912-2.09a27 27 0 0 1-.698-1.825c-.684-1.711-1.169-3.508-1.71-5.297-.42-1.826-.912-3.644-1.183-5.519-.363-1.86-.527-3.764-.741-5.66-.092-1.911-.249-3.83-.199-5.761-.043-1.932.128-3.864.242-5.804l.313-2.902c.093-.97.293-1.925.435-2.887 1.268-7.693 3.855-15.186 7.439-22.024 1.809-3.4 3.897-6.623 6.369-9.44a37 37 0 0 1 2.124-2.23 76 76 0 0 0-2.252-.678c-.142.136-.285.285-.456.442l-.05.057-.178-.178c.121-.15.235-.285.349-.414-.085-.021-.178-.042-.271-.071-2.187 2.296-4.068 4.813-5.685 7.408-2.437 3.885-4.297 7.935-5.836 11.956zm-4.424 21.36c-.029.599-.107 1.305-.107 1.625-.057-.449-.25-1.283-.221-1.803.028-.364.1-.457.164-.827.221-.093.185.406.156 1.005zm10.466 41.972c-.399-.35-.791-.92-1.161-1.511-.356-.6-.67-1.22-.955-1.655.164-.092.834.799 1.418 1.647.584.849 1.054 1.669.698 1.519m-8.065-23.849c.783 4.328 2.066 8.698 3.284 11.764.064.164.129.335.193.492.242.52.498 1.055.755 1.59 1.247 2.567 2.679 5.205 4.275 7.693.955 1.504 1.988 2.93 3.007 4.27 1.047 1.32 2.08 2.567 3.113 3.644.357.392.756.784 1.176 1.183.413.414.855.827 1.339 1.248-5.279-4.057-10.217-10.402-13.444-17.724q-.31-.703-.599-1.419c-.1-.235-.192-.478-.285-.713-1.489-3.729-2.601-7.636-3.356-11.521-.776-4.143-1.133-8.257-1.282-12.156.598 2.645.912 7.094 1.817 11.642zm.363-26.857c-.071.464-.42 2.068-1.09 5.397.007.464-.2.442-.299.528l.05.035s-.079.385-.15.97c-.057.578-.192 1.348-.221 2.132-.093 1.561-.185 3.158-.192 3.28l-.25-.05c-.007-1.555.05-3.637.406-5.619.264-1.996.784-3.9 1.126-5.183.364-1.283.684-1.94.62-1.476z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M-22.563 146.762c0-.078.014-.157.021-.235a42 42 0 0 0 .093-1.654c0-.121.014-.235.014-.356q.03-.982.007-1.975c0-.122-.007-.25-.014-.371a32 32 0 0 0-.086-1.633l-.042-.542a32 32 0 0 0-.228-1.989l7.958 2.025c1.226.314 2.537.642 3.912.991.549.143 1.104.278 1.674.421q.855.212 1.71.435c1.154.292 2.323.584 3.491.876s2.337.592 3.492.877q.865.215 1.71.428c2.536.635 4.93 1.234 6.982 1.733q.341.087.67.164c.876.214 1.674.406 2.38.577.527.129 1.011.243 1.425.342q.63.149 1.068.243c.585.128.898.185.884.157v.071q-.002.065-.014.171v.029c0 .071-.015.164-.022.263 0 .029 0 .05-.007.079q-.012.159-.035.349.002.043-.008.086-.019.213-.05.47v.022c-.02.178-.035.363-.064.57 0 .029 0 .05-.007.071-.021.193-.042.407-.07.621 0 .05-.015.092-.015.142-.029.221-.05.449-.079.685 0 .05-.014.099-.02.149-.03.243-.065.492-.094.756l-.02.178q-.055.404-.108.842a.4.4 0 0 1-.014.085q-.055.439-.121.899c0 .035-.014.078-.014.114-.043.313-.093.627-.136.955-.007.064-.021.128-.028.192l-.15.97c-.014.079-.021.15-.036.228-.05.335-.106.67-.163 1.02-.015.071-.022.142-.036.214-.057.356-.121.72-.185 1.083-.007.05-.022.1-.029.15a59 59 0 0 1-.2 1.112c0 .036-.014.064-.02.1-.072.385-.143.777-.222 1.177-.014.064-.02.128-.035.192l-.171.856c4.353.755 8.87 1.24 13.495 1.475 8.77.442 17.292-.149 25.215-1.868 17.007-3.686 31.165-12.69 38.86-28.318 1.403-2.845 2.579-5.911 3.54-9.198a63.012 63.012 0 0 1-.007.015 48 48 0 0 1-1.424-.45 70 70 0 0 1-8.928-3.557c-.47-.228-.94-.464-1.41-.699a58.7 58.7 0 0 1-9.142-5.746 78 78 0 0 1-1.197-.949 51 51 0 0 1-5.508-5.211 44 44 0 0 1-1.973-2.318 49 49 0 0 1-4.318-6.366 47 47 0 0 1-1.46-2.78 49.41 49.41 0 0 1-.67-1.441 56 56 0 0 1-1.226-2.987 56 56 0 0 1-1.788-5.718 61 61 0 0 1-1.44-7.786 71 71 0 0 1-.463-6.759c-.035-1.754 0-3.55.086-5.39.3-5.982 1.218-11.4 2.657-16.312-7.331-2.24-15.254-3.55-23.498-3.964-9.22-.464-18.083.128-26.255 1.896-17.157 3.707-31.18 12.698-38.825 28.24-3.49 7.102-5.7 15.529-6.198 25.517-.492 9.839.84 18.331 3.57 25.667 2.928 7.871 7.516 14.352 13.373 19.571z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#eed7fc",
        d: "M52.612 66.148a76 76 0 0 0-.085 5.39c.042 2.331.2 4.584.463 6.758a59 59 0 0 0 1.439 7.786 56 56 0 0 0 1.788 5.718c.378 1.02.791 2.018 1.226 2.987a48.81 48.81 0 0 0 2.13 4.22 48 48 0 0 0 4.318 6.368 52 52 0 0 0 1.974 2.317 50.993 50.993 0 0 0 6.705 6.16c2.82 2.174 5.877 4.085 9.14 5.746q.696.355 1.411.699c2.843 1.369 5.829 2.545 8.928 3.558.47.157.948.299 1.425.449.335-1.141.634-2.31.912-3.508q.077-.323.142-.656.288-1.326.535-2.695c.071-.392.135-.784.2-1.183q.115-.73.22-1.469c.114-.806.207-1.626.292-2.46.036-.342.064-.698.093-1.041.078-.912.15-1.832.2-2.773 0-.093.014-.185.02-.278v-.064c.357-7.03-.213-13.383-1.545-19.115a60 60 0 0 0-.955-3.593 53 53 0 0 0-1.112-3.308A48.869 48.869 0 0 0 83.2 66.675c-3.761-4.228-8.229-7.778-13.266-10.687a62 62 0 0 0-3.662-1.947 71 71 0 0 0-9.605-3.87q-.682-.225-1.375-.429h-.014c-.007.029-.014.05-.022.079-1.439 4.912-2.358 10.33-2.657 16.312z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M58.287-67h418.734v400.9H58.287z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "#f0f1f2",
        clipPath: "url(#c)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M101 18h342v8H101zM91 38h352v8H91z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 299.5,
        height: 18,
        x: 40,
        y: 10.171,
        fill: "#fff",
        rx: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#e)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#bf63f3",
        d: "M47.69 16.256a.68.68 0 0 1 .669.006l1.625.938.385.222a.68.68 0 0 1 .34.588v2.32a.677.677 0 0 1-.34.588l-1.51.872a1 1 0 0 0 .052-.3v-2.32a.89.89 0 0 0-.447-.771l-.279-.161-.847-.489v-.898a.68.68 0 0 1 .34-.587z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#bf63f3",
        d: "m47.178 16.553-1.51.871a.68.68 0 0 0-.34.589v2.319c0 .242.13.467.34.589l.358.206 1.652.953a.682.682 0 0 0 1.02-.588v-.899l-.874-.504-.252-.145a.89.89 0 0 1-.446-.772v-2.319a.9.9 0 0 1 .052-.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1868db",
        fillRule: "evenodd",
        d: "m47.824 20.09-1.798 1.037-.358-.206a.68.68 0 0 1-.34-.589v-2.32c0-.243.129-.467.34-.588l1.51-.872-.01.029a.9.9 0 0 0-.042.272v2.32c0 .318.17.612.446.77z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#bf63f3",
        fillRule: "evenodd",
        d: "m48.185 18.238-.847-.489v-.898a.68.68 0 0 1 .34-.587l.012-.008a.68.68 0 0 1 .669.006l1.625.938z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fca700",
        fillRule: "evenodd",
        d: "m50.369 17.422-.385-.222-1.799 1.038.28.16a.89.89 0 0 1 .446.772v2.32a.9.9 0 0 1-.053.3l1.511-.872a.68.68 0 0 0 .34-.588v-2.32a.68.68 0 0 0-.34-.588",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#82b536",
        fillRule: "evenodd",
        d: "m47.824 20.09-1.798 1.037 1.652.953a.682.682 0 0 0 1.02-.588v-.899z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 31,
        height: 5,
        x: 54,
        y: 16.671,
        fill: "#dddee1",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#6b6e76",
        d: "m94.337 18.617-1.687 1.688a.21.21 0 0 1-.282.014l-.016-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M106.501 16.398a.75.75 0 0 1 1.061 0l.462.462a.75.75 0 0 1 0 1.06l-3.037 3.037a.75.75 0 0 1-.383.205l-1.268.254a.282.282 0 0 1-.331-.331l.254-1.267a.75.75 0 0 1 .205-.384zm.663.397a.187.187 0 0 0-.265 0l-.36.36.727.728.36-.36a.186.186 0 0 0 0-.266zm-.296 1.486-.727-.728-2.279 2.28a.2.2 0 0 0-.052.095l-.17.854.853-.171a.2.2 0 0 0 .096-.051zm.555 1.45a.282.282 0 0 1 .529 0l.231.633.632.23a.281.281 0 0 1 0 .53l-.632.23-.231.632a.282.282 0 0 1-.529 0l-.23-.632-.633-.23a.281.281 0 0 1 0-.53l.633-.23z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 38.5,
        height: 5,
        x: 112,
        y: 16.671,
        fill: "#dddee1",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#0b1228",
        fillOpacity: 0.06,
        d: "M156.5 10.171h.5v18h-.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M166.805 17.109H165v-.563h4.125v.563h-1.758v4.687h-.562zm2.695 1.5v-.938h.562v.938H171v.562h-.938v1.875c0 .104.084.188.188.188h.75v.562h-.75a.75.75 0 0 1-.75-.75v-1.875h-.75v-.562z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M181.125 16.968c0-.233.189-.422.422-.422h1.734c.845 0 1.594.61 1.594 1.524 0 .367-.121.685-.321.934.414.261.696.708.696 1.269 0 .914-.749 1.523-1.594 1.523h-2.109a.42.42 0 0 1-.422-.422zm2.156 1.781c.45 0 .75-.299.75-.68 0-.38-.3-.679-.75-.679h-1.312v1.36zm-1.312.844h1.687c.45 0 .75.3.75.68s-.3.68-.75.68h-1.687z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#6b6e76",
        d: "m196.837 18.617-1.687 1.688a.21.21 0 0 1-.283.014l-.015-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#g)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M206.188 17.765a.562.562 0 1 1 1.124-.001.562.562 0 0 1-1.124.001m0 2.813a.562.562 0 1 1 1.124-.002.562.562 0 0 1-1.124.002M212 18.046h-3.75v-.562H212zm0 2.813h-3.75v-.563H212z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#6b6e76",
        d: "m222.837 18.617-1.687 1.688a.21.21 0 0 1-.283.014l-.015-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M238.625 17.484h-5.25v-.563h5.25zm0 1.968h-5.25v-.562h5.25zM236 21.423h-2.625v-.563H236z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 10.135,
        height: 10.135,
        x: 246.932,
        y: 14.104,
        stroke: "#0b1228",
        strokeOpacity: 0.14,
        strokeWidth: 0.365,
        rx: 2.068
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#505258",
        strokeLinejoin: "round",
        strokeWidth: 0.637,
        d: "M249.938 21.609v-.179l.609-1.605m3.433 1.784v-.179l-.606-1.605m0 0-1.169-3.091h-.484l-1.174 3.091m2.827 0h-2.827"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M268.082 17.004a1.475 1.475 0 0 1 2.086 2.085l-.844.844-.398-.398.844-.844a.912.912 0 0 0-1.29-1.29l-.844.844-.397-.398zm1.148 1.335-2.062 2.062-.398-.397 2.062-2.063zm-3.398.915.844-.844.398.398-.844.843a.912.912 0 0 0 1.29 1.29l.844-.844.397.398-.843.844a1.475 1.475 0 0 1-2.086-2.085M280 17.343c0-.544.441-.984.984-.984h4.032c.543 0 .984.44.984.984v3.094a.985.985 0 0 1-.984.984h-3.348l-1.247.713a.282.282 0 0 1-.421-.244zm.984-.422a.42.42 0 0 0-.422.422v4.062l.957-.546h3.497a.42.42 0 0 0 .422-.422v-3.094a.42.42 0 0 0-.422-.422zm3.516 1.688h-3v-.563h3zm-1.125 1.125H281.5v-.563h1.875z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 29.5,
        height: 5,
        x: 289,
        y: 16.671,
        fill: "#dddee1",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M327.5 19.171a.562.562 0 1 1 1.125 0 .562.562 0 0 1-1.125 0m2.438 0a.562.562 0 1 1 1.124-.001.562.562 0 0 1-1.124.001m2.437 0a.563.563 0 1 1 1.125 0 .563.563 0 0 1-1.125 0",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#0c66e4",
        fillOpacity: 0.14,
        d: "M314 34.745H147.042v14.637H314z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M137.436 32h17.153v18.297h-17.153z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#h)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M149.798 30.711a6 6 0 0 0-3.969 1.338 6.03 6.03 0 0 0-3.968-1.338h-1.143v3.43h1.143c1.613 0 2.116.801 2.287 1.144v4.506h-1.143v3.43h1.143v3.431c-.148.343-.651 1.144-2.287 1.144h-1.143v3.43h1.143a6.03 6.03 0 0 0 3.968-1.338 5.97 5.97 0 0 0 3.969 1.338h1.143v-3.43h-1.143c-1.613 0-2.116-.8-2.288-1.144v-3.43h1.213V39.79h-1.144v-4.506c.149-.343.652-1.143 2.287-1.143h1.144V30.71z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#000",
        d: "M149.798 32.998v-1.143a4.57 4.57 0 0 0-3.969 1.875 4.57 4.57 0 0 0-3.968-1.875v1.143a3.21 3.21 0 0 1 3.431 2.104v5.832h-1.144v1.144h1.144v4.757a3.234 3.234 0 0 1-3.431 2.104v1.144a4.64 4.64 0 0 0 3.968-1.864 4.64 4.64 0 0 0 3.969 1.864v-1.144a3.225 3.225 0 0 1-3.362-2.104v-4.769h1.143v-1.143h-1.143v-5.81a3.21 3.21 0 0 1 3.362-2.115"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M-259-131.5h684v385h-684z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 419.213,
        height: 220.555,
        x: 58.287,
        y: -67,
        fill: "#fff",
        rx: 5.243
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "c"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M31.03-38.464a3.93 3.93 0 0 1 3.932-3.932h487.582v374.861H31.03z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "e"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 57,
        height: 14,
        x: 42,
        y: 12.171,
        fill: "#fff",
        rx: 2
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "f"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M177 14.171a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-20a2 2 0 0 1-2-2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M203 14.171a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-20a2 2 0 0 1-2-2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "d",
        width: 311.5,
        height: 30,
        x: 34,
        y: 8.171,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.15 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13945_18711"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 0.25
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "effect1_dropShadow_13945_18711",
        result: "effect2_dropShadow_13945_18711"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_13945_18711",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "h",
        width: 14.292,
        height: 24.521,
        x: 138.718,
        y: 29.708,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13945_18711"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_13945_18711",
        result: "shape"
    }))));
const $3faf0024169aae07$var$NewToolbarBannerImageDark = ({ title: title, titleId: titleId, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "56px",
        viewBox: "0 0 477 56",
        fill: "none",
        "aria-labelledby": titleId,
        ...props
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "b",
        width: 686,
        height: 389,
        x: -260,
        y: -132.5,
        fill: "#000",
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M-260-132.5h686v389h-686z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M294.605 253.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56 56 0 0 1 3.912-1.005 59.8 59.8 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.25.022s.163-.022.249-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462q.771.17 1.532.364c.199.05.392.107.591.164q1.602.427 3.171.941c6.191 2.046 11.998 5.154 17.021 9.332a46.7 46.7 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-38.743c-3.142 2.787-6.548 5.233-10.175 7.372-19.173 11.293-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.038-24.646 21.645 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223 223 0 0 1-.492-11.885 247 247 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968 3.754-.321 7.652-.477 11.699-.477h74.442c1.211 0 2.379-.036 3.527-.1l.648-.043c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.136-.364q.246-.728.463-1.476c.035-.114.057-.228.092-.342a39 39 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-15.001c-46.583-6.352-68.535 5.454-73.33 37.146l-61.952-9.383C-41.253-13.79-33.116-34.98-19.9-50.5a293 293 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.792 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.292.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135q-1.152.247-2.337.463c-3.014.535-6.156.856-9.398.984-.648.029-1.296.057-1.952.065a80 80 0 0 1-4.56-.086c-.598-.029-1.19-.05-1.781-.093a71 71 0 0 1-5.508-.606 56 56 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a67 67 0 0 1-1.717-.363q-.234-.053-.47-.114a42 42 0 0 1-1.909-.492l-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178q-.01.002-.029.014c-.149-.05-.313-.107-.47-.157a54 54 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135q-1.152.247-2.337.463c-3.013.535-6.156.856-9.397.984-.649.029-1.297.058-1.953.065a77 77 0 0 1-6.056-.157 68 68 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62 62 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53 53 0 0 1-1.132-.25 11 11 0 0 1-.471-.114 42 42 0 0 1-1.909-.491l-.164-.043c-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a64 64 0 0 1 .984-4.363 61 61 0 0 1 2.678-8.007 56 56 0 0 1 1.483-3.23c.042-.085.085-.164.128-.249l.192-.357c.335-.648.67-1.304 1.026-1.932a50.7 50.7 0 0 1 12.262-14.452 55 55 0 0 1 5.052-3.629 58 58 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a59 59 0 0 1 2.472-1.112 71 71 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542q.267.064.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.694 8.678 33.459h63.905zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.6 45.6 0 0 1-6.925-2.695 46.7 46.7 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.078-.014-.15-.029-.228-.036l-.121-.021a29 29 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.835-3.021-8.028-3.093-12.49-4.075-.308-7.98-.593-11.528-.82l.449-.229c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.3 22.3 0 0 1-1.411 3.721 22.7 22.7 0 0 1-1.995 3.38c-4.389 6.082-11.001 7.964-18.005 5.889a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04c-5.978-4.22-8.622-10.544-6.627-17.738a22.5 22.5 0 0 1 1.397-3.672 22 22 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34 34 0 0 1 1.161-6.438q.96-3.467 2.679-7.05a43 43 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.019 3.042.085 6.177.584 9.355 1.51a47.4 47.4 0 0 1 7.218 2.789 45.6 45.6 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a6 6 0 0 0-.392.491 1 1 0 0 1 .078.136c1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.5 22.5 0 0 1 1.396-3.671 22 22 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.5 24.5 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22 22 0 0 1-1.411 3.722 22.7 22.7 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04 20 20 0 0 1-2.971-2.552 1166 1166 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901q.173.396.335.792v.028c2.166 5.74 2.451 12.199.534 19.086q-.972 3.508-2.715 7.144c-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45 45 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a43 43 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286zM362.058 3.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.58c-23.277 6.489-68.499.286-68.499.286.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563M103.05 205.154a32 32 0 0 1-5.059.414 32 32 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.4 29.4 0 0 1-.456-5.126q-.001-2.759.435-5.197c1.717-9.647 8.422-15.628 17.862-17.233a32 32 0 0 1 5.266-.442q2.641 0 5.058.385c9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198q-.002 2.716-.421 5.133c-1.703 9.689-8.422 15.7-17.876 17.261zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.071l-.685-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.475-1.304 6.459-3.292 13.574-6.199 18.209l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.036-2.36 26.255-1.897 8.244.413 16.174 1.725 23.499 3.964.007-.029.014-.05.02-.078h.015a58 58 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221a47 47 0 0 1 1.226-2.296c7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.563.926-.165 1.859-.314 2.807-.457 6.27-.92 12.847-1.197 19.565-.855 6.213.313 12.213 1.098 17.898 2.352a86 86 0 0 1 3.663.892l.733.192c.086.022.179.043.271.071.114.029.228.057.342.093.755.214 1.504.45 2.252.677.256.079.52.15.776.236 7.667 2.48 14.557 6.01 20.356 10.659a52 52 0 0 1 3.078 2.673 49 49 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714q.832 1.07 1.61 2.181a49.4 49.4 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.058.413-1.832 0-3.592-.135-5.266-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.4 29.4 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32 32 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30 30 0 0 1-.42 5.133z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245d",
        d: "M294.605 253.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56 56 0 0 1 3.912-1.005 59.8 59.8 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.25.022s.163-.022.249-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462q.771.17 1.532.364c.199.05.392.107.591.164q1.602.427 3.171.941c6.191 2.046 11.998 5.154 17.021 9.332a46.7 46.7 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-38.743c-3.142 2.787-6.548 5.233-10.175 7.372-19.173 11.293-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.038-24.646 21.645 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223 223 0 0 1-.492-11.885 247 247 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968 3.754-.321 7.652-.477 11.699-.477h74.442c1.211 0 2.379-.036 3.527-.1l.648-.043c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.136-.364q.246-.728.463-1.476c.035-.114.057-.228.092-.342a39 39 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-15.001c-46.583-6.352-68.535 5.454-73.33 37.146l-61.952-9.383C-41.253-13.79-33.116-34.98-19.9-50.5a293 293 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.792 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.292.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135q-1.152.247-2.337.463c-3.014.535-6.156.856-9.398.984-.648.029-1.296.057-1.952.065a80 80 0 0 1-4.56-.086c-.598-.029-1.19-.05-1.781-.093a71 71 0 0 1-5.508-.606 56 56 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a67 67 0 0 1-1.717-.363q-.234-.053-.47-.114a42 42 0 0 1-1.909-.492l-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178q-.01.002-.029.014c-.149-.05-.313-.107-.47-.157a54 54 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135q-1.152.247-2.337.463c-3.013.535-6.156.856-9.397.984-.649.029-1.297.058-1.953.065a77 77 0 0 1-6.056-.157 68 68 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62 62 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53 53 0 0 1-1.132-.25 11 11 0 0 1-.471-.114 42 42 0 0 1-1.909-.491l-.164-.043c-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a64 64 0 0 1 .984-4.363 61 61 0 0 1 2.678-8.007 56 56 0 0 1 1.483-3.23c.042-.085.085-.164.128-.249l.192-.357c.335-.648.67-1.304 1.026-1.932a50.7 50.7 0 0 1 12.262-14.452 55 55 0 0 1 5.052-3.629 58 58 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a59 59 0 0 1 2.472-1.112 71 71 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542q.267.064.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.694 8.678 33.459h63.905zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.6 45.6 0 0 1-6.925-2.695 46.7 46.7 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.078-.014-.15-.029-.228-.036l-.121-.021a29 29 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.835-3.021-8.028-3.093-12.49-4.075-.308-7.98-.593-11.528-.82l.449-.229c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.3 22.3 0 0 1-1.411 3.721 22.7 22.7 0 0 1-1.995 3.38c-4.389 6.082-11.001 7.964-18.005 5.889a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04c-5.978-4.22-8.622-10.544-6.627-17.738a22.5 22.5 0 0 1 1.397-3.672 22 22 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34 34 0 0 1 1.161-6.438q.96-3.467 2.679-7.05a43 43 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.019 3.042.085 6.177.584 9.355 1.51a47.4 47.4 0 0 1 7.218 2.789 45.6 45.6 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a6 6 0 0 0-.392.491 1 1 0 0 1 .078.136c1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.5 22.5 0 0 1 1.396-3.671 22 22 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.5 24.5 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22 22 0 0 1-1.411 3.722 22.7 22.7 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04 20 20 0 0 1-2.971-2.552 1166 1166 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901q.173.396.335.792v.028c2.166 5.74 2.451 12.199.534 19.086q-.972 3.508-2.715 7.144c-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45 45 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a43 43 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286zM362.058 3.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.58c-23.277 6.489-68.499.286-68.499.286.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563M103.05 205.154a32 32 0 0 1-5.059.414 32 32 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.4 29.4 0 0 1-.456-5.126q-.001-2.759.435-5.197c1.717-9.647 8.422-15.628 17.862-17.233a32 32 0 0 1 5.266-.442q2.641 0 5.058.385c9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198q-.002 2.716-.421 5.133c-1.703 9.689-8.422 15.7-17.876 17.261zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.071l-.685-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.475-1.304 6.459-3.292 13.574-6.199 18.209l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.036-2.36 26.255-1.897 8.244.413 16.174 1.725 23.499 3.964.007-.029.014-.05.02-.078h.015a58 58 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221a47 47 0 0 1 1.226-2.296c7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.563.926-.165 1.859-.314 2.807-.457 6.27-.92 12.847-1.197 19.565-.855 6.213.313 12.213 1.098 17.898 2.352a86 86 0 0 1 3.663.892l.733.192c.086.022.179.043.271.071.114.029.228.057.342.093.755.214 1.504.45 2.252.677.256.079.52.15.776.236 7.667 2.48 14.557 6.01 20.356 10.659a52 52 0 0 1 3.078 2.673 49 49 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714q.832 1.07 1.61 2.181a49.4 49.4 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.058.413-1.832 0-3.592-.135-5.266-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.4 29.4 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32 32 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30 30 0 0 1-.42 5.133z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#48245d",
        strokeWidth: 2,
        d: "M294.605 253.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56 56 0 0 1 3.912-1.005 59.8 59.8 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.25.022s.163-.022.249-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462q.771.17 1.532.364c.199.05.392.107.591.164q1.602.427 3.171.941c6.191 2.046 11.998 5.154 17.021 9.332a46.7 46.7 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-38.743c-3.142 2.787-6.548 5.233-10.175 7.372-19.173 11.293-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.038-24.646 21.645 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223 223 0 0 1-.492-11.885 247 247 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968 3.754-.321 7.652-.477 11.699-.477h74.442c1.211 0 2.379-.036 3.527-.1l.648-.043c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.136-.364q.246-.728.463-1.476c.035-.114.057-.228.092-.342a39 39 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-15.001c-46.583-6.352-68.535 5.454-73.33 37.146l-61.952-9.383C-41.253-13.79-33.116-34.98-19.9-50.5a293 293 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.792 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.292.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135q-1.152.247-2.337.463c-3.014.535-6.156.856-9.398.984-.648.029-1.296.057-1.952.065a80 80 0 0 1-4.56-.086c-.598-.029-1.19-.05-1.781-.093a71 71 0 0 1-5.508-.606 56 56 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a67 67 0 0 1-1.717-.363q-.234-.053-.47-.114a42 42 0 0 1-1.909-.492l-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178q-.01.002-.029.014c-.149-.05-.313-.107-.47-.157a54 54 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135q-1.152.247-2.337.463c-3.013.535-6.156.856-9.397.984-.649.029-1.297.058-1.953.065a77 77 0 0 1-6.056-.157 68 68 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62 62 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53 53 0 0 1-1.132-.25 11 11 0 0 1-.471-.114 42 42 0 0 1-1.909-.491l-.164-.043c-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a64 64 0 0 1 .984-4.363 61 61 0 0 1 2.678-8.007 56 56 0 0 1 1.483-3.23c.042-.085.085-.164.128-.249l.192-.357c.335-.648.67-1.304 1.026-1.932a50.7 50.7 0 0 1 12.262-14.452 55 55 0 0 1 5.052-3.629 58 58 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a59 59 0 0 1 2.472-1.112 71 71 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542q.267.064.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.694 8.678 33.459h63.905zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.6 45.6 0 0 1-6.925-2.695 46.7 46.7 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.078-.014-.15-.029-.228-.036l-.121-.021a29 29 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.835-3.021-8.028-3.093-12.49-4.075-.308-7.98-.593-11.528-.82l.449-.229c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.3 22.3 0 0 1-1.411 3.721 22.7 22.7 0 0 1-1.995 3.38c-4.389 6.082-11.001 7.964-18.005 5.889a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04c-5.978-4.22-8.622-10.544-6.627-17.738a22.5 22.5 0 0 1 1.397-3.672 22 22 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34 34 0 0 1 1.161-6.438q.96-3.467 2.679-7.05a43 43 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.019 3.042.085 6.177.584 9.355 1.51a47.4 47.4 0 0 1 7.218 2.789 45.6 45.6 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a6 6 0 0 0-.392.491 1 1 0 0 1 .078.136c1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.5 22.5 0 0 1 1.396-3.671 22 22 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.5 24.5 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22 22 0 0 1-1.411 3.722 22.7 22.7 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04 20 20 0 0 1-2.971-2.552 1166 1166 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901q.173.396.335.792v.028c2.166 5.74 2.451 12.199.534 19.086q-.972 3.508-2.715 7.144c-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45 45 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a43 43 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286zM362.058 3.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.58c-23.277 6.489-68.499.286-68.499.286.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563ZM103.05 205.154a32 32 0 0 1-5.059.414 32 32 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.4 29.4 0 0 1-.456-5.126q-.001-2.759.435-5.197c1.717-9.647 8.422-15.628 17.862-17.233a32 32 0 0 1 5.266-.442q2.641 0 5.058.385c9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198q-.002 2.716-.421 5.133c-1.703 9.689-8.422 15.7-17.876 17.261zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.071l-.685-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.475-1.304 6.459-3.292 13.574-6.199 18.209l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.036-2.36 26.255-1.897 8.244.413 16.174 1.725 23.499 3.964.007-.029.014-.05.02-.078h.015a58 58 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221a47 47 0 0 1 1.226-2.296c7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.563.926-.165 1.859-.314 2.807-.457 6.27-.92 12.847-1.197 19.565-.855 6.213.313 12.213 1.098 17.898 2.352a86 86 0 0 1 3.663.892l.733.192c.086.022.179.043.271.071.114.029.228.057.342.093.755.214 1.504.45 2.252.677.256.079.52.15.776.236 7.667 2.48 14.557 6.01 20.356 10.659a52 52 0 0 1 3.078 2.673 49 49 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714q.832 1.07 1.61 2.181a49.4 49.4 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.058.413-1.832 0-3.592-.135-5.266-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.4 29.4 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32 32 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30 30 0 0 1-.42 5.133z",
        mask: "url(#b)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M178.953-13.348c-7.945-.014-15.69-1.098-23.256-2.445-.036-.478-.072-.956-.107-1.448.534 7.793 1.354 13.497 1.981 18.217h36.658c-.634-.55-1.276-1.098-1.903-1.654a312 312 0 0 1-13.373-12.67m18.289 11.13v-.072a493.5 493.5 0 0 1-.064-1.547v-.171a228 228 0 0 1-.1-3.415q.002-.18-.007-.37l-.022-1.32q.002-.3-.007-.599c0-.399-.007-.798-.014-1.205v-2.416c0-.92.014-1.826.036-2.731a41 41 0 0 1-4.696 1.362c-2.75.598-5.643 1.005-8.678 1.247l.37-.228h.015c-1.119-.007-2.323.136-1.846.285h-.249c1.347 1.348 2.273 2.282 2.608 2.688-.264-.228-2.316-1.989-2.644-2.267 2.038 2.239 6.391 6.324 10.488 9.91 1.66 1.469 3.278 2.86 4.653 4.043h.321a311 311 0 0 1-.164-3.202z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245d",
        d: "M181.937-12.977c.328.278 2.38 2.039 2.643 2.267-.342-.406-1.268-1.333-2.608-2.688h.25c-.478-.15.727-.292 1.845-.285h-.014l-.371.228c3.036-.242 5.921-.649 8.679-1.247a41 41 0 0 0 4.695-1.362c.021-.877.05-1.74.086-2.602l-.485.192c-.477.185-.969.32-1.453.478-.962.335-1.953.57-2.922.805-3.911.927-7.787 1.29-11.328 1.412-.435.014-.87.028-1.297.036a426 426 0 0 1-6.726-6.916c-5.6-5.882-12.163-13.425-17.435-21.11-.029.37-.064.74-.093 1.118-.028.386-.05.785-.078 1.17.242.335.47.656.684.94.955 1.327 1.703 2.368 2.316 3.138-.756-.656-1.832-1.932-3.029-3.572 0 .071-.007.135-.014.207 4.489 6.43 9.783 12.783 15.583 19.014a405 405 0 0 0 5.757 6.01c-1.86-.02-3.584-.092-5.145-.156-5.336-.457-10.637-1.234-15.917-2.182.021.285.036.563.057.841l.107 1.448c7.567 1.34 15.312 2.424 23.256 2.445a312 312 0 0 0 13.374 12.67c.627.556 1.268 1.105 1.902 1.654h2.857c-1.375-1.191-2.992-2.574-4.653-4.043-4.104-3.586-8.45-7.671-10.488-9.91z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M372.866-51.79c-19.173 11.293-44.36 14.009-67.787 14.009h-65.001c-8.208 0-14.977 1.91-19.338 6.36-.484.492-.94 1.02-1.36 1.575a15 15 0 0 0-.613.863c-2.152 3.244-3.342 7.479-3.342 12.848 0 4.249.884 10.701 1.404 16.055.035.357.071.706.1 1.056h-19.523a322 322 0 0 1-.164-3.202c.05 1.106.1 2.168.164 3.202.513 8.933 1.439 15.264 2.123 20.419h59.359c-.499-5.54-1.504-12.584-1.504-17.111 0-15.607 10.061-21.646 24.646-21.646h65.001c23.42 0 48.607-2.716 67.787-14.01a64.7 64.7 0 0 0 10.175-7.371v-92.75h-20.435v16.634c0 32.86-12.989 52.046-31.692 63.068"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245d",
        d: "M383.126-120.549c0 8.691-1.632 15.386-4.752 20.369-1.561 2.489-3.492 4.556-5.786 6.218a23.62 23.62 0 0 1-3.705 2.203c-1.482.72-3.078 1.304-4.781 1.79q-1.304.374-2.693.662c-3.178.649-6.676.963-10.481.963h-74.599c-.755 0-1.51 0-2.251.021-3.62.057-7.111.25-10.488.57-.385.036-.777.072-1.154.115l-.357.042-.79.086c-3.235.37-6.363.855-9.363 1.469-4.068.834-7.923 1.889-11.556 3.172-.513.178-1.019.371-1.525.556-.1.036-.207.079-.307.114-.306.114-.605.243-.912.364-6.483 2.567-12.219 5.89-17.178 9.939a61 61 0 0 0-2.173 1.86c-4.631 4.179-8.522 9.048-11.657 14.61-.106.184-.206.377-.313.57-.093.17-.192.342-.285.513-.257.47-.506.955-.748 1.433-3.064 6.067-5.294 12.883-6.655 20.433a95 95 0 0 0-.527 3.294c-.029.214-.064.421-.093.628a108 108 0 0 0-.869 9.874 156.42 156.42 0 0 0-.086 2.603c-.021.905-.035 1.81-.035 2.73v2.417c0 .407.007.806.014 1.205q-.002.3.007.599c0 .45.014.884.022 1.319a1907.277 1907.277 0 0 0 .049 2.096q.024.856.057 1.69v.17l.065 1.548v.071c.049 1.105.099 2.168.163 3.202h19.523q-.045-.523-.1-1.056c-.52-5.354-1.403-11.813-1.403-16.056 0-5.361 1.189-9.596 3.341-12.847.193-.293.399-.585.613-.863a15.77 15.77 0 0 1 1.361-1.575c4.353-4.45 11.129-6.36 19.337-6.36h65.001c23.42 0 48.607-2.717 67.788-14.01 18.703-11.015 31.692-30.201 31.692-63.069v-16.626h-21.432v10.944z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        stroke: "#35243f",
        d: "M78.564-80.346c6.518.516 13.329 1.303 20.446 2.368l-9.442 62.416c-23.076-3.095-40.179-1.723-52.143 4.424C25.46-4.99 18.722 5.886 16.243 21.575l-60.965-9.233c4.02-26.155 12.06-47.013 25.019-62.325 46.462 3.56 78.159-6.886 98.267-30.363Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M293.564 2.808s.499 65.85 0 65.421c0 0 15.127 2.075 32.384 2.574-.05-15.749-.171-32.675-.193-35.94v-.571a75 75 0 0 0 2.515.82 66 66 0 0 0 2.202.65c.634.177 1.268.349 1.909.505.157.043.314.079.471.122.677.17 1.361.328 2.037.484.093.022.179.036.271.058.627.135 1.247.27 1.874.392.135.028.271.057.406.078.691.135 1.382.257 2.066.378.1.014.2.035.3.05q.953.16 1.895.3c.107.014.214.035.321.05.698.099 1.403.192 2.101.284.093.015.193.022.285.036.67.078 1.333.157 1.995.221.057 0 .114.014.171.021.713.072 1.433.136 2.138.193.078 0 .164.014.242.021 1.447.114 2.879.2 4.304.264h.164q2.178.088 4.303.1h.064c1.447.007 2.872 0 4.275-.043V3.371s-36.907 10.43-68.5-.563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M348.705 38.934c.078 0 .164.014.242.021-.078 0-.164-.014-.242-.021m-11.691-1.611c.135.028.27.057.406.078q-.204-.045-.406-.079m-4.646-1.055c.157.043.314.079.47.121a12 12 0 0 1-.47-.12m-4.588-1.305q.248.075.485.15-.248-.075-.485-.15m2.507.748q.084.02.178.05a2 2 0 0 1-.178-.05m16.109 3.009c.057 0 .114.014.171.021-.057 0-.114-.014-.171-.021m-20.448 32.083c.049 15.1.028 29.103-.2 28.91 0 0 45.222 6.204 68.5-.284v-64.58s-14.029 3.964-32.184 4.427v28.668c-9.811 2.738-23.527 3.216-36.109 2.852z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245d",
        d: "M357.718 39.319c-1.418-.007-2.85-.043-4.304-.1h-.163a111.47 111.47 0 0 1-4.304-.264c-.078 0-.164-.014-.242-.021q-1.069-.085-2.138-.193c-.057 0-.114-.014-.171-.021a196.13 196.13 0 0 1-1.995-.221c-.092-.014-.192-.022-.285-.036a75 75 0 0 1-2.102-.285c-.106-.014-.213-.036-.32-.05a87 87 0 0 1-1.895-.3c-.1-.014-.2-.035-.3-.05a96 96 0 0 1-2.472-.456c-.627-.12-1.247-.256-1.874-.392-.093-.021-.178-.035-.271-.057a69 69 0 0 1-2.037-.484q-.236-.056-.471-.122c-.634-.164-1.275-.328-1.909-.506a108.306 108.306 0 0 1-2.202-.649c-.164-.05-.328-.1-.484-.15a75 75 0 0 1-2.031-.67v.571c.021 3.265.143 20.198.192 35.94 12.583.364 26.299-.121 36.11-2.852V39.283q-2.106.054-4.275.043h-.064z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M86.99 46.598c.192-.97.49-2.21.883-3.8.498-2.281 1.653-6.032 2.807-9.333 1.154-3.308 2.259-6.188 2.202-6.958-1.098 2.873-2.7 6.987-3.883 10.873-1.205 3.878-2.003 7.507-2.01 9.225z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M69.926 56.016c5.037 2.91 9.505 6.46 13.267 10.688q.02-.205.043-.4c1.104-9.667 2.771-18.936 5.215-27.427 2.408-8.499 5.657-16.177 9.355-22.715a86 86 0 0 1 2.672-4.406q-1.432.254-2.843.563c-16.017 3.486-29.512 11.714-37.463 25.795 2.658 5.069 5.337 10.117 8.144 15.093.527.941 1.076 1.868 1.617 2.802zm67.381-35.598a141 141 0 0 0-7.353 9.468c-4.695 6.61-8.949 13.825-12.405 21.596s-6.099 16.106-7.538 24.804a90.7 90.7 0 0 0-1.233 15.457q.204.009.407.028l1.531.093c.513.007 1.019-.028 1.525-.035.506-.03 1.012 0 1.511-.093 1.004-.136 1.995-.214 2.985-.435 6.384-1.184 12.027-3.48 16.366-5.804-.52-1.226-.962-2.495-1.432-3.757-.313-.827-.527-1.69-.791-2.538-.249-.856-.527-1.697-.705-2.574l-.599-2.602c-.185-.87-.306-1.754-.456-2.624-.335-1.74-.441-3.508-.641-5.24-.214-3.48-.299-6.902-.021-10.16.434-6.524 1.745-12.356 3.199-16.854-.399 1.84-1.596 6.374-2.28 11.592l.242.122c.762-6.025 2.629-12.07 5.002-17.739 2.394-5.675 5.23-11.015 8.407-15.8 0 0-.62.735-1.503 1.926a57 57 0 0 0-3.092 4.663c-1.076 1.81-2.145 3.736-2.929 5.447-.413.848-.791 1.618-1.104 2.267l-.691 1.568v-.078l-.086.15c1.539-4.021 3.399-8.078 5.836-11.957 1.617-2.595 3.498-5.112 5.685-7.407l-.733-.193c-2.587 1.818-4.91 4.17-7.104 6.73z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M131.343 47.354c-.342 1.29-.862 3.187-1.126 5.183-.356 1.99-.413 4.064-.406 5.618l.249.05.193-3.28c.028-.784.157-1.554.221-2.131.071-.578.128-.963.149-.97l-.05-.035c.1-.079.307-.065.3-.528.662-3.33 1.019-4.934 1.09-5.397.064-.464-.257.192-.62 1.476zM66.27 54.07c-2.536-4.534-4.944-9.097-7.317-13.66q-.055.116-.121.22c-1.397 2.824-2.572 5.868-3.534 9.134q.693.213 1.375.428a73.4 73.4 0 0 1 9.605 3.871zm-3.49-8.634c.741 1.355 2.43 4.164 3.028 4.791-.72-1.647-4.773-8.384-3.028-4.79m54.72 1.396c1.503-2.866 2.743-5.105 3.969-7.329 1.246-2.21 2.493-4.413 4.203-7.072l-.178-.193c-1.126 1.804-3.463 5.376-5.272 8.634-1.831 3.244-3.164 6.132-2.843 6.203l.114-.236zm-1.825 4.577-.178-.22c-1.995 4.605-3.769 9.39-5.13 14.38l.2.228c1.332-4.898 3.177-9.91 5.108-14.387m29.569-36.868.05-.057c.164-.157.313-.306.456-.442a6 6 0 0 1-.342-.092q-.17.19-.349.413l.178.178zm31.607 25.446c-.05 5.255-.428 10.901-.884 16.427-.869 11.072-2.75 21.574-3.747 27.834.513-2.26 1.054-4.549 1.475-6.895.484-2.331.847-4.712 1.246-7.115.699-4.812 1.333-9.732 1.71-14.73.392-4.998.727-10.06.77-15.136.028-2.16-.014-4.328-.107-6.488-.185-.242-.378-.478-.57-.713.1 2.167.135 4.449.107 6.823z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M178.739 48.324c-.827 16.583-3.371 33.288-8.529 47.832a111 111 0 0 1-4.959 11.828l2.679-.399a38 38 0 0 0-.428 1.961c-.035.178-.064.356-.099.527a45 45 0 0 0-.25 1.612c-.014.121-.035.242-.05.363-.057.485-.099.97-.142 1.455.812.221 1.617.427 2.422.598-2.636-.27-2.337-.128-.342.286.05.007.107.021.157.028 5.273-4.327 9.662-9.71 12.882-16.284 3.449-7.023 5.629-15.343 6.121-25.175.498-9.981-.848-18.594-3.613-26.009a49.4 49.4 0 0 0-5.664-10.887c.114 4.086.021 8.185-.185 12.264"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M159.743 63.274c-2.807 4.264-5.978 8.185-9.362 11.757-3.356 3.586-7.09 6.802-11.023 9.461.022-.021.463-.4.962-.82.249-.214.499-.42.677-.592.185-.17.306-.285.313-.292a59 59 0 0 1-4.788 3.365c.171.378.342.763.506 1.141a65 65 0 0 0 2.565 4.734c3.684 6.082 8.408 11.172 13.595 14.901a44 44 0 0 0 3.584 2.317c.228-.035.463-.071.691-.1.812-.121 1.589-.235 2.344-.349.499-.071.983-.15 1.446-.214.271-.043.528-.078.784-.114.399-.791.77-1.604 1.161-2.396 1.048-2.074 1.874-4.249 2.786-6.388.428-1.076.805-2.181 1.212-3.265l.598-1.633c.192-.549.356-1.105.534-1.654l1.055-3.315.919-3.351.456-1.675.399-1.69.791-3.373.677-3.393.335-1.697.285-1.704c.192-1.134.377-2.274.57-3.408l.47-3.415.235-1.704.185-1.711c.129-1.14.25-2.275.378-3.408.798-9.098 1.361-18.188.812-27.022 0-.042-.007-.085-.007-.128a49 49 0 0 0-3.669-3.836c-.022 2.025-.235 4.022-.556 5.968-1.938 10.701-6.284 20.512-11.906 29.025zM129.035 53.6c-.064.37-.135.463-.164.826-.035.528.164 1.355.221 1.804 0-.313.079-1.02.107-1.625.029-.6.057-1.098-.157-1.006z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M161.988 59.11a37.13 37.13 0 0 0 1.617-3.13c-1.689 2.19-5.472 9.34-1.617 3.13m-16.109-42.157c-2.473 2.816-4.56 6.039-6.37 9.44-3.577 6.837-6.17 14.33-7.439 22.023-.142.963-.342 1.918-.434 2.888l-.314 2.901c-.114 1.94-.278 3.872-.242 5.804-.05 1.932.107 3.85.199 5.76.221 1.904.378 3.8.741 5.662.271 1.875.763 3.7 1.183 5.518.535 1.79 1.026 3.586 1.71 5.297.207.62.449 1.227.698 1.826.15-.093.307-.186.456-.279 2.302-1.397 4.055-2.723 5.273-3.621.591-.471 1.054-.842 1.368-1.091.313-.25.47-.385.47-.385 1.974-1.676 3.798-3.53 5.572-5.433 1.788-1.89 3.434-3.907 5.03-5.953 1.589-2.054 3.05-4.2 4.453-6.388 1.361-2.21 2.651-4.456 3.805-6.78 0 0 .214-.4.563-1.149.349-.741.876-1.803 1.432-3.144a74 74 0 0 0 3.641-10.616c1.111-4.178 1.845-8.798 1.532-12.926-.014-.235-.05-.463-.071-.698-5.8-4.656-12.697-8.178-20.357-10.66-.256-.085-.52-.156-.776-.235a37 37 0 0 0-2.123 2.232zm23.683 18.944c.285-1.255.491-2.802.627-3.594.085-1.554.021-2.139-.043-2.103-.078.036-.15.692-.292 1.611-.235 1.84-.812 4.727-1.019 5.946.135.35.449-.606.72-1.86zm-68.458-21.689c.342-.663.513-.962.485-.97-.022-.007-.242.279-.592.835-.342.563-.869 1.369-1.46 2.424-1.226 2.096-2.807 5.169-4.425 8.905-1.61 3.743-3.199 8.177-4.567 12.926-2.743 9.51-4.375 20.276-5.272 28.953-.057.578-.114 1.14-.171 1.697 3.042 3.871 5.536 8.263 7.374 13.204q.599 1.617 1.111 3.308c.036.029.072.05.1.079.812.584 1.632 1.183 2.515 1.704.435.263.855.556 1.311.798.45.243.905.478 1.361.72.45.257.92.464 1.397.663l1.418.614 1.467.499.734.25.748.184 1.504.371h.007c0-1.09 0-2.189.043-3.287.334-11.15 2.785-22.322 6.868-32.853 4.083-10.545 9.776-20.448 16.43-29.51 1.682-2.26 3.385-4.477 5.187-6.651 1.81-2.168 3.741-4.285 5.943-6.16l.128-.107c-5.693-1.262-11.685-2.046-17.898-2.353-6.719-.335-13.295-.064-19.565.855a85 85 0 0 0-3.798 5.975c.705-1.419 1.275-2.403 1.617-3.066z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245d",
        d: "M175.076 59.268c-.128 1.133-.249 2.274-.377 3.407l-.186 1.712-.235 1.704c-.157 1.133-.313 2.274-.47 3.415-.185 1.133-.378 2.267-.57 3.408l-.285 1.704-.335 1.696-.677 3.394-.791 3.372-.399 1.69-.456 1.676-.919 3.35-1.054 3.316c-.178.549-.342 1.112-.535 1.654l-.598 1.633c-.406 1.09-.784 2.188-1.211 3.265-.912 2.139-1.739 4.313-2.786 6.388-.392.799-.763 1.604-1.162 2.396.285-.043.556-.086.827-.122.349-.663.719-1.361 1.097-2.117.413-1.005.613-.934.784-1.098.028-.093.021-.135-.022-.078 0 0 .036-.057.086-.15q.075-.152.214-.421c.164-.371.392-.905.662-1.54.528-1.283 1.304-2.959 1.91-4.727 1.346-3.479 2.394-7.136 2.515-7.4l.214.17c-.52 1.776-1.083 3.858-1.91 5.997-.399 1.07-.784 2.189-1.247 3.287-.477 1.09-.954 2.195-1.432 3.293-.456 1.106-1.033 2.154-1.546 3.187-.264.507-.513 1.013-.769 1.512q.553-.084 1.054-.157c.128-.257.257-.513.378-.77l.142.292-.214.428c.157-.021.3-.043.449-.064a110 110 0 0 0 4.959-11.828c5.159-14.544 7.702-31.25 8.529-47.833.199-4.078.299-8.177.185-12.263a45 45 0 0 0-1.61-2.181c.093 2.16.135 4.327.107 6.488-.043 5.083-.371 10.145-.77 15.136-.384 4.998-1.011 9.917-1.71 14.73-.399 2.395-.762 4.784-1.247 7.115-.42 2.346-.969 4.634-1.474 6.894.997-6.26 2.878-16.769 3.747-27.834.463-5.525.834-11.172.884-16.426.028-2.375-.007-4.663-.107-6.824q-.426-.525-.862-1.04c0 .042.007.085.007.128.549 8.834-.014 17.917-.812 27.021zm-6.462 40.31c-.292.813-.442.999-.812 1.804-.3.157.163-.92.627-2.274.484-1.34 1.097-2.902 1.332-3.608-.285 1.02-.72 2.916-1.147 4.078m-.94-60.338a74.4 74.4 0 0 1-3.641 10.616c-.563 1.34-1.083 2.403-1.432 3.145-.342.741-.563 1.148-.563 1.148-1.154 2.317-2.451 4.57-3.805 6.78-1.403 2.182-2.864 4.328-4.453 6.388-1.596 2.046-3.249 4.057-5.03 5.953-1.774 1.904-3.598 3.758-5.572 5.433 0 0-.157.142-.47.385-.314.25-.777.613-1.368 1.09-1.219.906-2.964 2.225-5.273 3.623-.149.092-.306.185-.456.278.292.706.606 1.397.912 2.089a59 59 0 0 0 4.788-3.366s-.135.122-.313.293-.435.378-.677.592c-.492.42-.933.798-.962.82 3.933-2.66 7.674-5.875 11.022-9.461a85 85 0 0 0 9.363-11.757c5.621-8.513 9.975-18.316 11.906-29.025.327-1.946.534-3.943.555-5.968a55 55 0 0 0-3.078-2.673c.022.235.057.463.072.699.313 4.128-.421 8.748-1.532 12.926zm-5.686 19.87c-3.855 6.21-.064-.94 1.617-3.13a39 39 0 0 1-1.617 3.13m8.165-28.91c.057-.036.129.542.043 2.103-.135.792-.349 2.346-.627 3.594-.278 1.255-.584 2.21-.72 1.86.207-1.226.784-4.106 1.019-5.946.143-.92.214-1.575.292-1.61zM88.45 38.877c-2.443 8.491-4.11 17.76-5.215 27.428q-.02.204-.043.399a49 49 0 0 1 1.903 2.281q.086-.833.17-1.697c.898-8.676 2.53-19.45 5.273-28.953 1.368-4.748 2.95-9.183 4.567-12.926 1.618-3.736 3.2-6.809 4.425-8.905.591-1.062 1.119-1.868 1.461-2.424.349-.563.57-.841.591-.834.028.007-.143.306-.485.97s-.911 1.646-1.617 3.065a87 87 0 0 1 3.798-5.974c-.941.135-1.874.285-2.808.456a86 86 0 0 0-2.671 4.406c-3.698 6.538-6.947 14.216-9.356 22.715zm2.23-5.412c-1.154 3.309-2.308 7.052-2.806 9.333-.392 1.59-.692 2.83-.884 3.8.007-1.718.812-5.347 2.01-9.225 1.182-3.886 2.785-7.993 3.882-10.873.057.763-1.054 3.65-2.201 6.958zm21.988 82.747a78 78 0 0 1-3.071-13.24c-.42-2.916-.655-5.839-.762-8.755q.597.045 1.183.079c.313.014.627.05.94.042l.934-.028c.62-.029 1.247-.014 1.859-.079 2.494-.25 4.817-.72 7.161-1.311 2.337-.6 4.638-1.384 6.933-2.303a54 54 0 0 0 6.227-3.002c-.15-.335-.314-.656-.456-.991q-.269-.556-.506-1.134c-4.339 2.325-9.989 4.62-16.366 5.804-.991.22-1.981.3-2.986.435-.498.085-1.004.064-1.51.093-.506.007-1.019.05-1.525.035l-1.532-.093c-.135-.007-.27-.02-.406-.028a90.7 90.7 0 0 1 1.233-15.457c1.432-8.698 4.082-17.033 7.538-24.804s7.709-14.987 12.405-21.596a141 141 0 0 1 7.353-9.468c2.187-2.56 4.517-4.905 7.103-6.73a94 94 0 0 0-3.662-.891l-.128.107c-2.209 1.875-4.133 4-5.942 6.16-1.803 2.167-3.506 4.391-5.187 6.651-6.662 9.07-12.348 18.965-16.431 29.51-4.082 10.53-6.533 21.703-6.868 32.853a84 84 0 0 0-.043 3.287h-.007l-1.503-.37-.749-.186-.733-.25-1.468-.499-1.418-.613c-.477-.2-.948-.406-1.397-.663l-1.36-.72c-.45-.242-.877-.535-1.311-.799-.877-.513-1.696-1.112-2.515-1.703-.036-.029-.072-.05-.1-.079.356 1.17.67 2.367.954 3.594a41 41 0 0 0 4.311 2.402c2.373 1.148 4.859 1.882 7.332 2.374.285 9.183 1.988 18.216 5.294 26.594 1.111 2.702 2.508 5.34 4.232 7.735.185.015.363.029.548.036a39 39 0 0 1-1.382-2.06c-2.622-4.357-4.111-8.941-5.023-12.313l-.598-2.303c-.171-.685-.285-1.283-.399-1.775l-.335-1.533c.427 1.64.84 3.287 1.361 4.926a60 60 0 0 0 1.66 4.913c1.239 3.251 2.8 6.466 4.88 9.382q.289.405.599.799c.691.035 1.382.05 2.073.071-.064-.078-.135-.143-.192-.221-2.836-3.458-4.788-7.614-6.227-11.914zm7.56-75.346c1.81-3.251 4.147-6.83 5.272-8.634l.179.193c-1.71 2.659-2.957 4.862-4.204 7.072-1.226 2.225-2.465 4.463-3.969 7.33l-.114.235c-.313-.072 1.012-2.96 2.843-6.203zM115.49 51.19l.178.22c-1.931 4.478-3.776 9.49-5.109 14.388l-.199-.228c1.361-4.99 3.135-9.774 5.13-14.38m-12.953 40.147c-.371-.114-.578-.214-.706-.314-.256-.207-.235-.37-.677-.72.72.392 3.527 1.305 2.879 1.29l.235.1c-.827-.064-1.354-.25-1.731-.35zm4.346 8.684c-.264-1.804-.321-3.223-.378-4.193-.007-.976.022-1.518.079-1.582.114-.129.235 1.64.527 5.575l.021.178-.249.014zM69.926 56.016a563 563 0 0 1-1.617-2.802c-2.807-4.976-5.486-10.031-8.144-15.093a54 54 0 0 0-1.225 2.296c2.372 4.563 4.787 9.126 7.317 13.66a64 64 0 0 1 3.662 1.947zm-4.118-5.796c-.606-.627-2.294-3.437-3.028-4.791-1.746-3.593 2.315 3.137 3.028 4.791"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245d",
        d: "m133.622 33.251.093-.15v.08c.164-.364.399-.906.691-1.57.314-.648.691-1.418 1.105-2.267.783-1.704 1.852-3.636 2.928-5.447a57 57 0 0 1 3.092-4.662c.884-1.191 1.504-1.925 1.504-1.925-3.178 4.784-6.014 10.124-8.408 15.799-2.373 5.668-4.239 11.714-5.002 17.738l-.242-.12c.684-5.22 1.881-9.754 2.28-11.594-1.453 4.5-2.757 10.331-3.199 16.855-.278 3.258-.192 6.68.021 10.16.2 1.732.307 3.493.642 5.24.156.87.27 1.754.456 2.623l.598 2.603c.178.87.456 1.718.705 2.574.264.848.478 1.71.791 2.538.471 1.262.912 2.53 1.432 3.757.164.378.328.763.506 1.134.15.335.307.663.456.99a43 43 0 0 0 1.824 3.615 55 55 0 0 0 2.608 4.221 53.39 53.39 0 0 0 5.771 7.087 47.5 47.5 0 0 0 5.829 5.069c-.129-.228-1.39-1.112-2.622-2.21-.635-.535-1.226-1.148-1.732-1.69-.484-.563-.855-1.069-.99-1.426 2.764 2.895 5.928 5.369 9.184 7.387.969-.143 1.917-.286 2.836-.421a41 41 0 0 1-3.584-2.317c-5.187-3.729-9.911-8.82-13.595-14.901a62 62 0 0 1-2.565-4.734 56 56 0 0 0-.506-1.14c-.306-.692-.619-1.384-.912-2.09a27 27 0 0 1-.698-1.825c-.684-1.711-1.168-3.508-1.71-5.297-.42-1.826-.912-3.644-1.183-5.519-.363-1.86-.527-3.764-.741-5.66-.092-1.911-.249-3.83-.199-5.761-.043-1.932.128-3.865.242-5.804l.314-2.902c.092-.97.299-1.925.434-2.887 1.269-7.693 3.855-15.186 7.439-22.024 1.81-3.4 3.897-6.623 6.37-9.44a37 37 0 0 1 2.123-2.23 74 74 0 0 0-2.252-.678 14 14 0 0 1-.456.442l-.05.057-.178-.178c.121-.15.235-.285.349-.414-.085-.021-.178-.042-.27-.071-2.181 2.296-4.069 4.813-5.686 7.408-2.437 3.885-4.296 7.935-5.835 11.956zm-4.424 21.36c-.029.6-.107 1.306-.107 1.626-.057-.449-.249-1.283-.221-1.803.029-.364.1-.457.164-.828.221-.092.185.407.157 1.006zm10.466 41.973c-.399-.35-.79-.92-1.161-1.511-.356-.6-.67-1.22-.955-1.655.164-.092.834.799 1.418 1.647.584.849 1.055 1.669.698 1.519m-8.065-23.849c.784 4.328 2.066 8.698 3.285 11.764.064.164.128.335.192.492.242.52.499 1.055.755 1.59 1.247 2.567 2.679 5.205 4.275 7.693.955 1.504 1.988 2.93 3.007 4.27 1.047 1.32 2.08 2.567 3.114 3.644.356.392.755.784 1.175 1.183.413.414.855.827 1.34 1.248-5.28-4.057-10.218-10.402-13.445-17.724a51 51 0 0 1-.599-1.419c-.099-.235-.192-.478-.285-.713-1.489-3.729-2.6-7.636-3.356-11.522-.776-4.142-1.132-8.256-1.282-12.155.598 2.645.912 7.094 1.817 11.642zm.363-26.857c-.071.463-.42 2.068-1.09 5.397.007.464-.199.442-.299.528l.05.035s-.079.385-.15.97c-.057.578-.192 1.348-.221 2.132l-.192 3.28-.249-.05c-.008-1.555.049-3.637.406-5.619.263-1.996.783-3.9 1.125-5.183.364-1.283.684-1.94.62-1.476z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M93.46 124.325a45 45 0 0 1-1.426-.449 73 73 0 0 1-6.042-2.253 62 62 0 0 1-2.885-1.304 69 69 0 0 1-2.793-1.426c-10.524-5.704-18.824-14.11-23.52-25.574-.206-.5-.399-1.006-.591-1.512a56.4 56.4 0 0 1-2.473-8.748 60 60 0 0 1-.755-4.763c-.456-3.807-.591-7.85-.378-12.156.3-5.981 1.219-11.4 2.658-16.312-7.332-2.239-15.254-3.55-23.498-3.964-9.22-.464-18.083.128-26.256 1.896C-11.656 51.468-25.678 60.458-33.323 76c-3.491 7.102-5.7 15.53-6.199 25.518-.491 9.839.841 18.33 3.57 25.666 2.928 7.871 7.517 14.352 13.374 19.571 0-.078.014-.157.021-.235.043-.549.071-1.098.093-1.654 0-.121.014-.235.014-.357.021-.656.021-1.311.007-1.975 0-.121-.007-.249-.014-.37a32 32 0 0 0-.086-1.633l-.043-.542a32 32 0 0 0-.228-1.989s37.542 9.575 37.357 9.276v.071q-.002.065-.014.171v.029c0 .071-.015.164-.022.263 0 .029 0 .05-.007.079q-.012.159-.036.349.002.043-.007.086-.019.213-.05.47v.029c-.02.171-.035.356-.056.556q.002.042-.008.085-.03.298-.07.628c0 .043-.008.085-.015.135-.029.221-.05.449-.078.685 0 .057-.015.107-.022.164-.028.242-.064.499-.092.755 0 .05-.015.1-.022.157-.036.278-.071.556-.114.849a1 1 0 0 1-.014.114c-.036.285-.079.577-.121.877 0 .043-.014.078-.014.121-.043.314-.093.627-.136.955-.007.065-.021.129-.028.193q-.075.482-.15.984c-.014.071-.021.142-.036.214q-.076.502-.163 1.026a2 2 0 0 1-.036.193q-.087.543-.185 1.098c-.008.05-.022.107-.029.157q-.094.546-.2 1.105c0 .035-.014.071-.02.1-.072.392-.15.784-.222 1.183-.014.057-.021.121-.035.178l-.171.863c4.353.756 8.87 1.241 13.495 1.476 8.77.442 17.292-.15 25.215-1.868 17.007-3.686 31.165-12.691 38.86-28.319 1.403-2.845 2.579-5.911 3.54-9.197a62.925 62.925 0 0 1-.007.014z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245d",
        d: "M52.605 66.148c-.214 4.306-.078 8.348.378 12.156a60.226 60.226 0 0 0 .755 4.763 56 56 0 0 0 2.472 8.747c.193.514.385 1.013.591 1.512 4.696 11.464 12.996 19.87 23.52 25.574.912.499 1.846.969 2.793 1.426q1.422.684 2.886 1.304a75 75 0 0 0 6.042 2.253c.47.157.947.3 1.425.449.335-1.14.634-2.31.912-3.507q.077-.323.142-.656a73 73 0 0 0 .734-3.886q.117-.728.221-1.476c.114-.805.207-1.618.292-2.452.036-.35.064-.699.1-1.056.078-.905.15-1.818.2-2.752 0-.099.014-.199.02-.306v-.057c.357-7.03-.213-13.382-1.545-19.115a60 60 0 0 0-.955-3.593 53 53 0 0 0-1.112-3.308c-1.838-4.941-4.332-9.326-7.374-13.204a49 49 0 0 0-1.902-2.282c-3.762-4.228-8.23-7.778-13.267-10.687a62 62 0 0 0-3.662-1.947 71 71 0 0 0-9.605-3.87q-.682-.225-1.375-.429h-.014c-.007.029-.014.05-.022.079-1.439 4.912-2.358 10.33-2.657 16.312z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#c)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1d2125",
        d: "M58.287-67h418.734v400.9H58.287z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "#303134",
        clipPath: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M101 18h342v8H101zM91 38h352v8H91z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#e)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 299.5,
        height: 18,
        x: 40,
        y: 9.271,
        fill: "#2b2c2f",
        rx: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#bf63f3",
        d: "M47.69 15.356a.68.68 0 0 1 .669.006l1.625.937.385.223a.68.68 0 0 1 .34.588v2.32a.677.677 0 0 1-.34.588l-1.51.872.009-.028a.9.9 0 0 0 .043-.273V18.27a.89.89 0 0 0-.447-.771l-.279-.161-.847-.489v-.898a.68.68 0 0 1 .34-.587z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#bf63f3",
        d: "m47.178 15.652-1.51.872a.68.68 0 0 0-.34.589v2.319c0 .242.13.467.34.589l.358.206 1.652.953a.682.682 0 0 0 1.02-.588v-.899l-.874-.504-.252-.145a.89.89 0 0 1-.446-.772v-2.319a.9.9 0 0 1 .052-.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1868db",
        fillRule: "evenodd",
        d: "m47.824 19.19-1.798 1.037-.358-.206a.68.68 0 0 1-.34-.589v-2.32c0-.243.129-.467.34-.588l1.51-.872-.01.029a.9.9 0 0 0-.042.272v2.32c0 .318.17.612.446.77z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#bf63f3",
        fillRule: "evenodd",
        d: "m48.185 17.338-.847-.489v-.898a.68.68 0 0 1 .34-.587l.012-.008a.68.68 0 0 1 .669.006l1.625.937z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fca700",
        fillRule: "evenodd",
        d: "m50.369 16.522-.385-.223-1.799 1.039.28.16a.89.89 0 0 1 .446.772v2.32a.9.9 0 0 1-.053.3l1.511-.872a.68.68 0 0 0 .34-.588v-2.32a.68.68 0 0 0-.34-.588",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#82b536",
        fillRule: "evenodd",
        d: "m47.824 19.19-1.798 1.037 1.652.953a.682.682 0 0 0 1.02-.588v-.899z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 31,
        height: 5,
        x: 54,
        y: 15.771,
        fill: "#3d3f43",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#96999e",
        d: "m94.337 17.717-1.687 1.688a.21.21 0 0 1-.282.014l-.016-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M106.501 15.498a.75.75 0 0 1 1.061 0l.462.462a.75.75 0 0 1 0 1.06l-3.037 3.037a.75.75 0 0 1-.383.205l-1.268.254a.282.282 0 0 1-.331-.331l.254-1.267a.75.75 0 0 1 .205-.383zm.663.397a.187.187 0 0 0-.265 0l-.36.36.727.728.36-.36a.186.186 0 0 0 0-.266zm-.296 1.486-.727-.728-2.279 2.28a.2.2 0 0 0-.052.095l-.17.854.853-.171a.2.2 0 0 0 .096-.051zm.555 1.45a.282.282 0 0 1 .529 0l.231.633.632.23a.281.281 0 0 1 0 .53l-.632.23-.231.632a.282.282 0 0 1-.529 0l-.23-.632-.633-.23a.281.281 0 0 1 0-.53l.633-.23z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 38.5,
        height: 5,
        x: 112,
        y: 15.771,
        fill: "#3d3f43",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#0b1228",
        fillOpacity: 0.06,
        d: "M156.5 9.271h.5v18h-.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M166.805 16.209H165v-.563h4.125v.563h-1.758v4.687h-.562zm2.695 1.5v-.938h.562v.938H171v.562h-.938v1.875c0 .104.084.188.188.188h.75v.562h-.75a.75.75 0 0 1-.75-.75v-1.875h-.75v-.562z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#g)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M181.125 16.068c0-.233.189-.422.422-.422h1.734c.845 0 1.594.61 1.594 1.524 0 .367-.121.685-.321.934.414.261.696.708.696 1.269 0 .914-.749 1.523-1.594 1.523h-2.109a.42.42 0 0 1-.422-.422zm2.156 1.781c.45 0 .75-.299.75-.68 0-.38-.3-.679-.75-.679h-1.312v1.36zm-1.312.844h1.687c.45 0 .75.3.75.68s-.3.68-.75.68h-1.687z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#96999e",
        d: "m196.837 17.717-1.687 1.688a.21.21 0 0 1-.283.014l-.015-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#h)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M206.188 16.865a.562.562 0 1 1 1.124-.001.562.562 0 0 1-1.124.001m0 2.813a.562.562 0 1 1 1.124-.002.562.562 0 0 1-1.124.002M212 17.146h-3.75v-.562H212zm0 2.813h-3.75v-.563H212z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#96999e",
        d: "m222.837 17.717-1.687 1.688a.21.21 0 0 1-.283.014l-.015-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M238.625 16.584h-5.25v-.563h5.25zm0 1.968h-5.25v-.562h5.25zM236 20.522h-2.625v-.563H236z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 10.135,
        height: 10.135,
        x: 246.932,
        y: 13.204,
        stroke: "#e3e4f2",
        strokeOpacity: 0.12,
        strokeWidth: 0.365,
        rx: 2.068
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#a9abaf",
        strokeLinejoin: "round",
        strokeWidth: 0.637,
        d: "M249.938 20.709v-.179l.609-1.605m3.433 1.784v-.179l-.606-1.605m0 0-1.169-3.091h-.484l-1.174 3.091m2.827 0h-2.827"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M268.082 16.104a1.475 1.475 0 0 1 2.086 2.085l-.844.844-.398-.398.844-.844a.912.912 0 0 0-1.29-1.29l-.844.844-.397-.398zm1.148 1.335-2.062 2.062-.398-.397 2.062-2.063zm-3.398.915.844-.844.398.398-.844.843a.912.912 0 0 0 1.29 1.29l.844-.844.397.398-.843.844a1.475 1.475 0 0 1-2.086-2.085M280 16.443c0-.544.441-.984.984-.984h4.032c.543 0 .984.44.984.984v3.094a.984.984 0 0 1-.984.984h-3.348l-1.247.713a.282.282 0 0 1-.421-.244zm.984-.422a.42.42 0 0 0-.422.422v4.062l.957-.546h3.497a.42.42 0 0 0 .422-.422v-3.094a.42.42 0 0 0-.422-.422zm3.516 1.688h-3v-.563h3zm-1.125 1.125H281.5v-.563h1.875z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 29.5,
        height: 5,
        x: 289,
        y: 15.771,
        fill: "#3d3f43",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M327.5 18.271a.563.563 0 1 1 1.125 0 .563.563 0 0 1-1.125 0m2.438 0a.562.562 0 1 1 1.124-.001.562.562 0 0 1-1.124.001m2.437 0a.563.563 0 1 1 1.125 0 .563.563 0 0 1-1.125 0",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#669df1",
        fillOpacity: 0.14,
        d: "M314 34.745H147.042v14.637H314z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M137.436 32h17.153v18.297h-17.153z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#i)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1f1f21",
        d: "M149.798 30.711a6 6 0 0 0-3.969 1.338 6.03 6.03 0 0 0-3.968-1.338h-1.143v3.43h1.143c1.613 0 2.116.801 2.287 1.144v4.506h-1.143v3.43h1.143v3.431c-.148.343-.651 1.144-2.287 1.144h-1.143v3.43h1.143a6.03 6.03 0 0 0 3.968-1.338 5.97 5.97 0 0 0 3.969 1.338h1.143v-3.43h-1.143c-1.613 0-2.116-.8-2.288-1.144v-3.43h1.213V39.79h-1.144v-4.506c.149-.343.652-1.143 2.287-1.143h1.144V30.71z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#cecfd2",
        d: "M149.798 32.998v-1.143a4.57 4.57 0 0 0-3.969 1.875 4.57 4.57 0 0 0-3.968-1.875v1.143a3.21 3.21 0 0 1 3.431 2.104v5.832h-1.144v1.144h1.144v4.757a3.234 3.234 0 0 1-3.431 2.104v1.144a4.64 4.64 0 0 0 3.968-1.864 4.64 4.64 0 0 0 3.969 1.864v-1.144a3.225 3.225 0 0 1-3.362-2.104v-4.769h1.143v-1.143h-1.143v-5.81a3.21 3.21 0 0 1 3.362-2.115"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M-259-131.5h684v385h-684z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "c"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 419.213,
        height: 220.555,
        x: 58.287,
        y: -67,
        fill: "#fff",
        rx: 5.243
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "d"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M31.03-38.464a3.93 3.93 0 0 1 3.932-3.932h487.582v374.861H31.03z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "f"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 57,
        height: 14,
        x: 42,
        y: 11.271,
        fill: "#fff",
        rx: 2
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M177 13.271a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-20a2 2 0 0 1-2-2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "h"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M203 13.271a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-20a2 2 0 0 1-2-2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "e",
        width: 311.5,
        height: 30,
        x: 34,
        y: 7.271,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.15 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13945_18829"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 0.25
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "effect1_dropShadow_13945_18829",
        result: "effect2_dropShadow_13945_18829"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_13945_18829",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "i",
        width: 14.292,
        height: 24.521,
        x: 138.718,
        y: 29.708,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13945_18829"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_13945_18829",
        result: "shape"
    }))));
const $3faf0024169aae07$export$6196548d78d8d0b4 = /*#__PURE__*/ (0, $42omo.memo)($3faf0024169aae07$var$BannerImageLight);
const $3faf0024169aae07$export$b164ab6127963004 = /*#__PURE__*/ (0, $42omo.memo)($3faf0024169aae07$var$BannerImageDark);
const $3faf0024169aae07$export$79b5c2b53f30d5cc = /*#__PURE__*/ (0, $42omo.memo)($3faf0024169aae07$var$NewToolbarBannerImageLight);
const $3faf0024169aae07$export$c074d09e35c0419e = /*#__PURE__*/ (0, $42omo.memo)($3faf0024169aae07$var$NewToolbarBannerImageDark);


const $17ecc52f8acaba5c$var$layoutArea = 'editor-controls-changeboarding-layout-area';
const $17ecc52f8acaba5c$var$feedbackBannerStyles = (0, $ecnYn.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    color: 'color.text.subtle',
    padding: 'space.150',
    backgroundColor: 'color.background.accent.purple.subtlest',
    alignItems: 'center',
    justifyItems: 'end'
});
const $17ecc52f8acaba5c$var$breakpointContainerQuery = `@container ${$17ecc52f8acaba5c$var$layoutArea} (min-width: 67.5rem)`;
const $17ecc52f8acaba5c$var$shortChangeBoardingImageAddStyles = null;
const $17ecc52f8acaba5c$var$feedbackBannerNewPinningStyles = (0, $ecnYn.xcss)({
    containerType: 'inline-size',
    containerName: $17ecc52f8acaba5c$var$layoutArea,
    padding: 'space.0'
});
const $17ecc52f8acaba5c$var$feedbackBannerLayerStyles = (0, $ecnYn.xcss)({
    zIndex: 'modal'
});
const $17ecc52f8acaba5c$var$feedbackBannerMessageStyles = (0, $ecnYn.xcss)({
    gridArea: 'message',
    textAlign: 'center',
    display: 'inline-block',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'space.100',
    wordBreak: 'break-word'
});
const $17ecc52f8acaba5c$var$shortFeedbackBannerMessagePinningStyles = null;
const $17ecc52f8acaba5c$var$closeButtonStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifySelf: 'end',
    gridArea: 'close',
    paddingRight: 'space.150'
});
const $17ecc52f8acaba5c$var$i18n = (0, $cgtv4.defineMessages)({
    bannerClose: {
        id: "editor-action-bar.editor-controls-onboarding.close",
        defaultMessage: "Close"
    },
    lozengeMessage: {
        id: "editor-action-bar.editor-controls-onboarding.lozenge",
        defaultMessage: "New"
    },
    collectorCommunityGroup: {
        id: "editor-action-bar.feedback-collector.community-group",
        defaultMessage: "Community group"
    },
    imageAltText: {
        id: "editor-action-bar.editor-controls-onboarding.image-alt-text",
        defaultMessage: "New formatting toolbar button"
    },
    bannerMessageForPinningTopToolbarShort: {
        id: "editor-action-bar.editor-controls-onboarding.message-pinning-inline-toolbar-short",
        defaultMessage: "Try the <link>inline toolbar</link>. Unpin it. Select text to edit."
    },
    bannerMessageForPinningInlineToolbarShort: {
        id: "editor-action-bar.editor-controls-onboarding.message-pinning-top-toolbar-short",
        defaultMessage: "<link>Inline toolbar</link>. Select text to edit. Or pin back to the top."
    },
    shareYourFeedbackShort: {
        id: "editor-action-bar.editor-controls-onboarding.share-your-feedback-short",
        defaultMessage: "<feedback>Feedback</feedback>"
    }
});
const $17ecc52f8acaba5c$export$1666b5647a488a02 = 'https://support.atlassian.com/confluence-cloud/docs/how-to-use-the-new-toolbar-and-insert-elements/';
const $17ecc52f8acaba5c$export$101e4e78d861fa81 = 'https://community.atlassian.com/forums/Confluence-articles/Live-Docs-Beta-update-Control-where-the-edit-tool-bar-lives/ba-p/3005144#M13863';
const $17ecc52f8acaba5c$var$getShortPinningBannerMessage = (bannerType)=>{
    if (bannerType === 'toolbar-inline') return $17ecc52f8acaba5c$var$i18n.bannerMessageForPinningInlineToolbarShort;
    return $17ecc52f8acaba5c$var$i18n.bannerMessageForPinningTopToolbarShort;
};
const $17ecc52f8acaba5c$var$BannerStyleWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_nd5l13um _1yt4utpp _1e0c116y _4cvr1h6o _1bah1h6o _1nmz1hna _1n261g80 _12qsutpp _o5amu2gc"
        ])
    }, children);
const $17ecc52f8acaba5c$var$BannerImageStyleWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_nd5l1sq2 _10fpv2br _1e0cglyw _17vm11p5"
        ])
    }, children);
const $17ecc52f8acaba5c$export$e465eaad07815d4e = ({ onDismiss: onDismiss, triggerAnalyticsEvent: triggerAnalyticsEvent, isLivePage: isLivePage, isEmbeddedConfluence: isEmbeddedConfluence, bannerType: bannerType })=>{
    const isDarkMode = (0, $j5cB3.useIsDarkMode)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [showFeedbackCollector, setShowFeedbackCollector] = (0, $42omo.useState)(false);
    const { areBannersHidden: areBannersHidden } = (0, $i4dNk.useCfind4473CreationFocusedNav)(); // simplify the nav for D0 experience
    (0, $42omo.useEffect)(()=>{
        if (triggerAnalyticsEvent) triggerAnalyticsEvent('controls.banner.displayed', {
            isLivePage: isLivePage
        });
    }, [
        triggerAnalyticsEvent,
        isLivePage
    ]);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const handleOnClickClose = ()=>{
        if (triggerAnalyticsEvent) triggerAnalyticsEvent('controls.banner.dismissed', {
            isLivePage: isLivePage
        });
        onDismiss();
    };
    const handleOnClickFeedbackButton = ()=>{
        setShowFeedbackCollector(true);
    };
    const handleSubmitFeedback = ()=>{
        handleOnClickClose();
        setShowFeedbackCollector(false);
    };
    if (isEmbeddedConfluence) return null;
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true);
    const NewToolbarBannerImage = isDarkMode ? (0, $3faf0024169aae07$export$c074d09e35c0419e) : (0, $3faf0024169aae07$export$79b5c2b53f30d5cc);
    const ChangeBoardingImage = isDarkMode ? (0, $3faf0024169aae07$export$b164ab6127963004) : (0, $3faf0024169aae07$export$6196548d78d8d0b4);
    const BannerImage = isNewToolbarEnabled ? NewToolbarBannerImage : ChangeBoardingImage;
    if (areBannersHidden) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "editor-controls-onboarding-banner",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cwkWT.default), {
        templateAreas: [
            'image message close'
        ],
        templateColumns: "minmax(max-content, 1fr) auto 1fr",
        xcss: [
            $17ecc52f8acaba5c$var$feedbackBannerStyles,
            $17ecc52f8acaba5c$var$feedbackBannerLayerStyles,
            $17ecc52f8acaba5c$var$feedbackBannerNewPinningStyles
        ],
        testId: "editor-controls-onboarding-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($17ecc52f8acaba5c$var$BannerImageStyleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BannerImage, {
        title: formatMessage($17ecc52f8acaba5c$var$i18n.imageAltText),
        titleId: `onboarding-banner-image-${isDarkMode ? 'dark' : 'light'}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($17ecc52f8acaba5c$var$BannerStyleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $17ecc52f8acaba5c$var$feedbackBannerMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: "new",
        isBold: true
    }, formatMessage($17ecc52f8acaba5c$var$i18n.lozengeMessage)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$17ecc52f8acaba5c$var$getShortPinningBannerMessage(bannerType),
        values: {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
                    href: $17ecc52f8acaba5c$export$1666b5647a488a02,
                    target: "_blank"
                }, chunks),
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                    weight: "bold"
                }, chunks)
        }
    }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$17ecc52f8acaba5c$var$i18n.shareYourFeedbackShort,
        values: {
            feedback: (chunks)=>// eslint-disable-next-line @atlassian/a11y/anchor-is-valid
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: "#",
                    onClick: handleOnClickFeedbackButton
                }, chunks)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $17ecc52f8acaba5c$var$closeButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage($17ecc52f8acaba5c$var$i18n.bannerClose),
        onClick: handleOnClickClose
    }))), showFeedbackCollector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcvq8.LazyGlobalFeedbackCollector), {
        onClose: ()=>setShowFeedbackCollector(false),
        onCloseComplete: ()=>{},
        onSubmit: handleSubmitFeedback,
        feedbackSource: (0, $lx6jn.FeedbackSource).EDITOR_CONTROLS,
        additionalFields: {
            source: 'editor-controls-feedback-banner'
        }
    }));
};












var $lmtWR = parcelRequire("lmtWR");

const $3b7f1197d4985005$export$e3fd0f06dd598301 = (isLivePage)=>{
    const isEditorToolbarDockedAtTop = (0, $lEVfb.useIsEditorToolbarDockedAtTop)({
        defaultDockedAtTop: !isLivePage
    });
    const bannerType = (0, $lmtWR.getBannerType)(isEditorToolbarDockedAtTop);
    const [isControlsBannerDismissed, setIsControlsBannerDismissed] = (0, $42omo.useState)(()=>(0, $lmtWR.isBannerDismissedInLocalStorage)(bannerType));
    (0, $42omo.useEffect)(()=>{
        setIsControlsBannerDismissed((0, $lmtWR.isBannerDismissedInLocalStorage)(bannerType));
    }, [
        bannerType
    ]);
    const onDismiss = (0, $42omo.useCallback)(()=>{
        setIsControlsBannerDismissed(true);
        (0, $lmtWR.persistBannerDismissalNewPinning)(bannerType);
    }, [
        bannerType
    ]);
    return {
        isControlsBannerDismissed: isControlsBannerDismissed,
        onDismiss: onDismiss,
        bannerType: bannerType
    };
};



var $1wNUR = parcelRequire("1wNUR");





var $4Dj8n = parcelRequire("4Dj8n");

const $642dd5941c63cbaa$export$4a2ff2a211b229b0 = /*#__PURE__*/ (0, $42omo.memo)(({ isLivePage: isLivePage, isEmbeddedConfluence: isEmbeddedConfluence, viewMode: viewMode, spaceKey: spaceKey, triggerAnalyticsEvent: triggerAnalyticsEvent, contentId: contentId, version: version, isShowingOfflineBanner: isShowingOfflineBanner })=>{
    const { isControlsBannerDismissed: isControlsBannerDismissed, onDismiss: onDismiss, bannerType: bannerType } = (0, $3b7f1197d4985005$export$e3fd0f06dd598301)(isLivePage);
    const { isVisible: isOnboardingEditorDraftBannerVisible } = (0, $1wNUR.useOnboardingBannerLogic)({
        contentId: contentId,
        version: version,
        isShowingOfflineBanner: isShowingOfflineBanner,
        spaceKey: spaceKey,
        setIsOnboardingBannerDataLoaded: ()=>{}
    });
    const shouldShowControlsBanner = !viewMode && !isControlsBannerDismissed && spaceKey !== 'XFLOW' && !isOnboardingEditorDraftBannerVisible && !(0, $9wGTI.fg)('platform_editor_control_remove_banner'); // remove change boarding banner for all customers. Remove the EditorControlsBanner completely when cleaning up the flag.
    if (shouldShowControlsBanner) {
        if ((0, $9wGTI.fg)('cc_activation_hide_changeboarding_for_new_users')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Dj8n.ExcludeNewConfluenceActiveUser), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $17ecc52f8acaba5c$export$e465eaad07815d4e), {
            onDismiss: onDismiss,
            triggerAnalyticsEvent: triggerAnalyticsEvent,
            isLivePage: isLivePage,
            isEmbeddedConfluence: isEmbeddedConfluence,
            bannerType: bannerType
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $17ecc52f8acaba5c$export$e465eaad07815d4e), {
            onDismiss: onDismiss,
            triggerAnalyticsEvent: triggerAnalyticsEvent,
            isLivePage: isLivePage,
            isEmbeddedConfluence: isEmbeddedConfluence,
            bannerType: bannerType
        });
    }
    if (spaceKey !== 'XFLOW' && !isLivePage && (0, $9wGTI.fg)('aifc_create_enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwwrH.SmartCreateFeedbackBannerLoader), {
        contentType: "page"
    });
});






var $fFa3V = parcelRequire("fFa3V");




const $7aceeeaf0148bdde$export$166cbf4b2438db83 = (isLivePage)=>{
    (0, $42omo.useEffect)(()=>{
        if (isLivePage || (0, $6mKj3.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) {
            const mainContent = document.getElementById('AkMainContent');
            // If the main content area is not found, or it already has a tabIndex set,
            // don't mess with tabIndex at all.
            if (!mainContent || mainContent.hasAttribute('tabIndex')) return;
            // Two-stage hydration previously masked a React execution order bug by causing this to be rendered and fired
            //  before the title component was mounted. With two-stage hydration removed, we now need to ensure that
            //  we correctly handle focus. React will fire the title component's useEffect before this one as it is on
            //  a child component of the editor. Therefore, we check here if the title is focused already, and if so,
            //  we do not steal focus away.
            if (document.activeElement?.getAttribute?.('name') === 'livepages-title' && (0, $6mKj3.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true)) return;
            mainContent.setAttribute('tabIndex', '-1');
            const unbind = (0, $fFa3V.bind)(mainContent, {
                type: 'blur',
                listener: ()=>{
                    mainContent.removeAttribute('tabIndex');
                    unbind();
                }
            });
            mainContent.focus();
            return unbind;
        }
    }, [
        isLivePage
    ]);
};









var $lrMxq = parcelRequire("lrMxq");





function $1e65a39b95334039$export$7d2a7d16db4db259({ editorApi: editorApi, editorActionsProps: editorActionsProps, hasAiButton: hasAiButton, hasAudioButton: hasAudioButton, contentId: contentId, spaceKey: spaceKey, contentType: contentType, contentTitle: contentTitle, isUnpublishedDraft: isUnpublishedDraft }) {
    const isShowDiffSelected = (0, $b3YrF.useSharedPluginStateSelector)(editorApi, 'trackChanges.isDisplayingChanges', {
        disabled: !(0, $9wGTI.fg)('platform_editor_ai_aifc_streaming')
    }) ?? false;
    const isShowDiffAvailable = (0, $b3YrF.useSharedPluginStateSelector)(editorApi, 'trackChanges.isShowDiffAvailable', {
        disabled: !(0, $9wGTI.fg)('platform_editor_ai_aifc_streaming')
    }) ?? false;
    const onShowDiff = (0, $42omo.useCallback)(()=>{
        const wasShowDiffSelected = isShowDiffSelected;
        const result = editorApi?.core.actions.execute(editorApi?.trackChanges?.commands.toggleChanges);
        // On de-selection - focus back on the editor
        if (result && wasShowDiffSelected) editorApi?.core.actions.focus();
    }, [
        editorApi,
        isShowDiffSelected
    ]);
    const { aiIsStreaming: aiIsStreaming } = (0, $c907e804706c3ad7$export$34125ddc34657a7f)(editorApi);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lrMxq.ObjectSidebarControl), {
        key: "object-sidebar-control",
        hasCommentsButton: true,
        hasDetailsButton: true,
        hasLoomButton: true,
        hasUndoRedoButton: true,
        undoRedoButtonActions: editorActionsProps,
        hasAiButton: hasAiButton,
        hasAudioButton: hasAudioButton,
        showDiffButtonActions: {
            isShowDiffEnabled: isShowDiffAvailable ?? false,
            onShowDiff: onShowDiff,
            isShowDiffSelected: isShowDiffSelected
        },
        aiIsStreaming: aiIsStreaming,
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType,
        contentTitle: contentTitle,
        isUnpublishedDraft: isUnpublishedDraft
    });
}






var $8Psje = parcelRequire("8Psje");


var $wtSEP = parcelRequire("wtSEP");




const $ea0f0e1bfeeed9fe$export$72f7c3354b160bdb = (Component)=>{
    return (props)=>{
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $9wGTI.fg)('aifc_create_enabled') && (0, $8Psje.isRovoSystemSpaceKey)(props.spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props);
    };
};


const $b56facd6a98e9621$var$ConditionalTwoStageHydration = ({ children: children })=>{
    if ((0, $6mKj3.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
        name: "full-page-editor-contentcomponents-after"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $b56facd6a98e9621$var$FullPageEditorWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19121cl4",
            __cmplp.className
        ])
    });
}); // IMPORTANT: If you change the code below, please also update the
const $b56facd6a98e9621$var$CARD_OPTIONS = {
    allowDatasource: true
};
const $b56facd6a98e9621$var$useLinkCreationQueryParam = (0, $dPJCf.createSingleQueryParamHook)('linkCreation');
const $b56facd6a98e9621$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $b56facd6a98e9621$var$useFocusedMentionIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedMentionId');
const $b56facd6a98e9621$var$useReplyToCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment'); // Content components are displayed below the editor tool bar
const $b56facd6a98e9621$var$_getContentComponents = (0, $2XqLN.default)(({ contentId: contentId, cloudId: cloudId, debounceTitleChangeUpdates: debounceTitleChangeUpdates, focusEditor: focusEditor, onFocusChanged: onFocusChanged, userOffline: userOffline, linkCreation: linkCreation, editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers, isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEnabledForContent: isAIEnabledForContent, hideSpinner: hideSpinner, templateSuggestionsRef: templateSuggestionsRef, templateButtonRef: templateButtonRef, viewMode: viewMode, contentClassificationMetadata: contentClassificationMetadata, spaceKey: spaceKey, isUnpublishedDraft: isUnpublishedDraft, showBlankPageQuickActions: showBlankPageQuickActions, isLivePage: isLivePage, version: version, isEditorEmpty: isEditorEmpty, shouldRenderPreview: shouldRenderPreview, shouldShowNewContentHistory: shouldShowNewContentHistory, isEditorAnnotationProviderManagersEnabled: isEditorAnnotationProviderManagersEnabled, editorApi: editorApi, contentType: contentType, editorActions: editorActions, disabled: disabled, isTitleFocused: isTitleFocused, appearance: appearance, title: title, onTitleChange: onTitleChange, cancelDebouncedSaveDraft: cancelDebouncedSaveDraft, showSpinner: showSpinner, loadingPriority: loadingPriority, isRovoButtonEnabled: isRovoButtonEnabled, editorSessionId: editorSessionId, editorActionsProps: editorActionsProps, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions, hasPageComments: hasPageComments, isEmbeddedConfluence: isEmbeddedConfluence, isTemplateBrowserEnabled: isTemplateBrowserEnabled, isSeamlessTransitionInProgress: isSeamlessTransitionInProgress = false })=>{
    const titleAreaContentComponents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8SCD6.ReactionsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $08a4a4f0ffa330f8$export$4907a23e9e92d796), {
        isEditorEmpty: isEditorEmpty,
        contentId: contentId,
        cloudId: cloudId,
        focusEditor: focusEditor,
        onFocusChanged: onFocusChanged,
        debounceOnChange: debounceTitleChangeUpdates,
        userOffline: userOffline,
        templateSuggestionsRef: templateSuggestionsRef,
        templateButtonRef: templateButtonRef,
        linkCreation: linkCreation,
        hideSpinner: hideSpinner,
        viewMode: viewMode,
        contentClassificationMetadata: contentClassificationMetadata,
        version: version,
        editorApi: editorApi,
        editorSessionId: editorSessionId,
        isSeamlessTransitionInProgress: isSeamlessTransitionInProgress,
        hasByLineContributors: hasByLineContributors,
        hasByLineExtensions: hasByLineExtensions,
        hasReactions: hasReactions
    }));
    let blankPageQuickActionsTemplatePreview;
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey); // show BPQA full size template preview when we
    // are not previewing the editor, BPQA should show and it's either
    // an unpublished draft or a live page
    const shouldShowFullPageTemplatePreview = !shouldShowNewContentHistory && !shouldRenderPreview && showBlankPageQuickActions && (isUnpublishedDraft || isLivePage);
    if (shouldShowFullPageTemplatePreview) blankPageQuickActionsTemplatePreview = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccf3ae46461db7a4$export$5690797982203811), {
        spaceKey: spaceKey
    });
    const isEmbeddedTemplateBrowserEnabled = isEmbeddedConfluence ? isTemplateBrowserEnabled : true;
    const shouldRenderBPQA = isEmbeddedTemplateBrowserEnabled && !shouldShowNewContentHistory && !shouldRenderPreview && showBlankPageQuickActions && !isCompanyHub;
    const shouldRenderPageFooterComments = isEmbeddedConfluence ? hasPageComments : true; // confluence_footer_comment_styling_change controls pinning the footer to the bottom on small live pages (see ObjectCommentContainer)
    // However, this can only happen on first paint in SPA (useEffect + the DOM aren't available in SSR), so the SSR'd version doesn't match the SPA version
    // Until we have a styling only fix, we should prevent rendering this in SSR (but keep preloading, etc to improve TTVC)
    const shouldRenderObjectCommentWrapper = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    true;
    return {
        before: [
            !isCompanyHub && titleAreaContentComponents,
            isAdminHubAIEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2dIEg.EditorPluginAIWithFeedback), {
                key: "editor-ai-feedback-collector",
                editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers
            }),
            isEditorAnnotationProviderManagersEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5IgBW.EditorAnnotationProviderComponents), {
                key: "editorAnnotationProviderComponents"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fbPMY.EditorForgeExtensionConfigHelperRenderer), {
                key: "editorForgeExtensionConfigHelperRenderer"
            }),
            !isCompanyHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e65a39b95334039$export$7d2a7d16db4db259), {
                editorActionsProps: editorActionsProps,
                hasAiButton: isLivePage || isRovoButtonEnabled,
                hasAudioButton: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                isAIEnabledForContent && (0, $9wGTI.fg)('cc_ai_audio_in_live_docs_object_sidebar'),
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: contentType,
                contentTitle: title,
                editorApi: editorApi,
                isUnpublishedDraft: isUnpublishedDraft
            }),
            shouldRenderBPQA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $98d4df931c17ad78$export$d11bc9a2de7fd8e3), {
                editorActions: editorActions,
                disabled: disabled,
                isTitleFocused: isTitleFocused,
                focusEditor: focusEditor,
                appearance: appearance,
                spaceKey: spaceKey,
                isUnpublishedDraft: isUnpublishedDraft,
                title: title,
                onTitleChange: onTitleChange,
                contentId: contentId,
                cancelDebouncedSaveDraft: cancelDebouncedSaveDraft,
                showSpinner: showSpinner,
                hideSpinner: hideSpinner,
                isAIEnabled: isAdminHubAIEnabled,
                editorPresetAPI: editorApi
            })
        ],
        after: [
            blankPageQuickActionsTemplatePreview,
            shouldRenderPageFooterComments && !shouldRenderBPQA && isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56facd6a98e9621$var$ConditionalTwoStageHydration, null, contentType === 'page' && (0, $6mKj3.expValEquals)('confluence_ai_related_content_for_live_pages', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lxDfD.default), {
                name: "end-of-page-recommendation-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fIKxq.EndOfPageRecommendationLoader), {
                entityType: contentType,
                entityId: contentId,
                spaceKey: spaceKey ?? '',
                pageWidthType: `"max-width"`,
                isLivePage: isLivePage
            })), !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lxDfD.default), {
                name: "editor-footer-comments"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdbc46c13e75ea1d$export$f9d737bcf2a1ec12), {
                key: contentId,
                contentId: contentId,
                loadingPriority: loadingPriority
            })), shouldRenderObjectCommentWrapper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lxDfD.default), {
                name: "editor-footer-comments"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $70pcM.ObjectCommentWrapper), {
                showGeneralComment: true,
                showLabels: true,
                loadingPriority: loadingPriority,
                key: `ObjectCommentWrapper-${contentId}`,
                hasReactions: hasReactions,
                editorIsUserOffline: userOffline
            })), (0, $9wGTI.fg)('confluence_comment_sticky_footer_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2xS8W.StickyDraftCommentContainer), null)))
        ]
    };
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $b56facd6a98e9621$var$_getContextPanelComponent = (0, $2XqLN.default)(()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2KWDO.EditorContextPanelView), null);
});
const $b56facd6a98e9621$var$_getEditorContextConnectionsPanel = (0, $2XqLN.default)(({ referentialityContext: referentialityContext, connectionsPanelActiveNodeLocalId: connectionsPanelActiveNodeLocalId, setConnectionsPanelActiveNodeLocalId: setConnectionsPanelActiveNodeLocalId, closeConnectionsPanel: closeConnectionsPanel })=>{
    if (connectionsPanelActiveNodeLocalId && referentialityContext?.api) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXAjP.EditorContextConnectionsPanel), {
        api: referentialityContext.api,
        activeNodeLocalId: connectionsPanelActiveNodeLocalId,
        setActiveNodeLocalId: setConnectionsPanelActiveNodeLocalId,
        closeConnectionsPanel: closeConnectionsPanel
    });
    return null;
});
const $b56facd6a98e9621$var$_getEditorContextSmartButtonConfigPanel = (0, $2XqLN.default)(({ smartButtonActiveNodeLocalId: smartButtonActiveNodeLocalId, closeSmartButtonConfigPanel: closeSmartButtonConfigPanel, fullPageEditorPresetAPI: fullPageEditorPresetAPI })=>{
    if (smartButtonActiveNodeLocalId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8S5Nq.SmartButtonConfigPanel), {
        localId: smartButtonActiveNodeLocalId,
        closeSelf: closeSmartButtonConfigPanel,
        editorApi: fullPageEditorPresetAPI
    });
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/placeholderPluginOptions/placeholderPluginOptions.ts
const $b56facd6a98e9621$var$_getPlaceholderText = (0, $2XqLN.default)((placeholderTextParam)=>{
    const isAIEnabledForContent = placeholderTextParam.isAIEnabledForContent;
    if (isAIEnabledForContent && (0, $9wGTI.fg)('platform_editor_ai_aifc_streaming')) return (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).editorEmptyDocumentSpaceShortcutPlaceholder;
    if (isAIEnabledForContent && (0, $iu6m9.editorExperiment)('platform_editor_ai_quickstart_command', true)) return (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).editorEmptyDocumentPlaceholderAI;
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).editorEmptyDocumentPlaceholder;
    const key = `${isAIEnabledForContent ? 'AI' : 'noAI'}`;
    const placeholders = {
        AI: {
            //  Placeholder text when AI is enabled
            id: (0, $9b9cd112fc8297b9$export$7f03b831e2e40b16),
            defaultMessage: (0, $9b9cd112fc8297b9$export$6a44b93c4f739392)
        },
        noAI: {
            //  Placeholder text when AI is not enabled
            id: (0, $9b9cd112fc8297b9$export$b7b0d81eceb7980e),
            defaultMessage: (0, $9b9cd112fc8297b9$export$a86989c71e454d74)
        }
    };
    return placeholders[key];
});
const $b56facd6a98e9621$var$withEditorContext = (component)=>(0, $3plmx.withSmartCardProviderContext)((0, $gKaeO.withRevertContext)((0, $6LguK.withEditorModalContext)(component)));
const $b56facd6a98e9621$var$getContentAppearance = (0, $2XqLN.default)((appearance, draftAppearance)=>{
    // if the appearance is default value (version 0), reference the draftAppearance if it exists; otherwise, use appearance
    const contentAppearance = appearance.version === 0 && draftAppearance ? draftAppearance : appearance.appearance;
    return (0, $c4PY4.getContentAppearanceForAtlaskit)(contentAppearance);
}); // If updating please update in DiffEditor.tsx as well

const $b56facd6a98e9621$var$_createLCMExtensionProvider = async (outerEditorView, outerEditorApi, propOverrides)=>{
    const { createManifest: createManifest } = await (parcelRequire("fh45B"));
    return new (0, $bre0g.default)([
        createManifest(outerEditorView, outerEditorApi, propOverrides)
    ]);
};
const $b56facd6a98e9621$var$FullPageEditorComponentImpl = (props)=>{
    const { contentId: // Props from Loader
    contentId, spaceKey: spaceKey, collabEditProvider: collabEditProvider, collabEdit: collabEdit, collabEditState: collabEditState, heartbeatData: heartbeatData, contentType: contentType, disabled: disabled, setForceDisabled: setForceDisabled, internetDisconnected: internetDisconnected, forceDisabled: forceDisabled, draftShareId: draftShareId, refetchNativeCollab: refetchNativeCollab, isFirstParticipant: isFirstParticipant, isSingleUserSession: isSingleUserSession, isUnpublishedDraft: isUnpublishedDraft, onTitleChange: onTitleChange, title: title, version: version, viewMode: viewMode, onPublishUpdateTitleInPageTree: onPublishUpdateTitleInPageTree, optimisticDeleteItemInTree: optimisticDeleteItemInTree, customPerfData: customPerfData, editorActions: // Props from editor-core
    editorActions, extensionContextProvider: // Context Provider for macro
    extensionContextProvider, flags: flags, dialogs: dialogs, handleDocChange: handleDocChange, hasEditPermission: /**
     * defaults to true
     * used by live pages as live pages render editor on view only mode
     */ hasEditPermission = true, createdDate: createdDate, onDraftSyncSuccess: onDraftSyncSuccess, loadingPriority: loadingPriority, isFastLoadedLiveDoc: isFastLoadedLiveDoc, hasByLineContributors: hasByLineContributors = true, hasByLineExtensions: hasByLineExtensions = true, hasReactions: hasReactions = true, hasPageComments: hasPageComments = true, hasInlineComments: hasInlineComments = true } = props;
    const [{ fullPageEditorPresetAPI: fullPageEditorPresetAPI }, { setEditorApi: setEditorApi, resetEditorApi: resetEditorApi }] = (0, $kDhla.useFullPageEditorApi)(); // Ensures editorApi sweet state is cleared on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            resetEditorApi();
        };
    }, [
        resetEditorApi
    ]); // Recommended way of accessing collabEditProvider without promise wrapper.
    const [{ collabEditProvider: extractedCollabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { triggerAnalyticsEvent: triggerAnalyticsEvent } = (0, $e9owJ.useEditorAnalyticsEvent)({
        contentId: contentId,
        contentType: contentType,
        subject: 'editPage',
        source: (0, $9b9cd112fc8297b9$export$f7109619a5e9e0d6),
        version: version,
        collabService: 'ncs'
    });
    const { requestToEditContent: requestToEditContent, hasRequestedEditPermission: hasRequestedEditPermission } = (0, $ewVsQ.useRequestToEditContent)({
        contentId: contentId,
        flags: flags,
        triggerAnalyticsEvent: triggerAnalyticsEvent
    });
    const isClassicMentionsNotificationsEnrolled = (0, $9747c27e818a1963$export$a9e17b56b1093c49)();
    const { setEditorAnnotations: setEditorAnnotations } = (0, $aUU0C.useEditorAnnotationsActions)();
    const isDocumentActive = (0, $92561710d62f83c7$export$4e0e446ffa50ddc0)();
    const { isSmartButtonAllowed: isSmartButtonAllowed } = (0, $iz4WO.useSmartButtonPremiumGate)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $0b5629b07134c74a$export$2e2bcd8739ae039)
    });
    const { updateTitle: updateContentTypesTitle } = (0, $kXsBa.useContentTypesTitleUpdate)(contentId, title || '');
    const { collabEditInitialized: collabEditInitialized, collabEditError: collabEditError, collabEditInternetLost: collabEditInternetLost, collabEditConnectionTimedOut: collabEditConnectionTimedOut } = collabEditState;
    const intl = (0, $8C5kA.default)();
    const { cloudId: cloudId, userId: userId, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, edition: edition, orgId: orgId, environment: environment } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const linkCreation = $b56facd6a98e9621$var$useLinkCreationQueryParam();
    const focusedCommentId = $b56facd6a98e9621$var$useFocusedCommentIdQueryParam();
    const replyToCommentId = $b56facd6a98e9621$var$useReplyToCommentIdQueryParam();
    const focusedMentionId = $b56facd6a98e9621$var$useFocusedMentionIdQueryParam();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { triggerSaveIndicator: triggerSaveIndicator } = (0, $42omo.useContext)((0, $f9dc71ade1ee2d5f$export$df7407750199bb6d));
    const isEditorEmpty = (0, $eiA8Z.useSharedPluginStateWithSelector)(fullPageEditorPresetAPI, // @ts-ignore @ts-expect-error
    [
        'empty'
    ], // @ts-ignore @ts-expect-error
    (states)=>!!states?.emptyState?.editorIsEmpty) ?? editorActions?.isDocumentEmpty();
    const showBlankPageQuickActions = (0, $382552a311f1e790$export$fa234c370103664)({
        contentType: contentType,
        collabEditInitialized: collabEditInitialized,
        isEditorEmpty: isEditorEmpty,
        viewMode: viewMode
    });
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const templateSuggestionsRef = (0, $42omo.useRef)(null);
    const templateButtonRef = (0, $42omo.useRef)(null);
    const [{ editSource: editSource }] = (0, $4ri4I.useEditSource)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isRovoButtonEnabled = (0, $fT4aa.useAIRovoButtonEnablement)();
    const handleGqlError = (0, $42omo.useCallback)((error, isCommentNotFound = false)=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            error: error,
            attributes: {
                mode: isLivePage ? (0, $l2hqi.InlineCommentMode).LIVE : (0, $l2hqi.InlineCommentMode).EDIT,
                stopPoint: 'full-page-editor/FullPageEditorComponent',
                commentNotFound: isCommentNotFound
            }
        });
    }, [
        experienceTracker,
        isLivePage
    ]); // Note that this will detect missing inline and footer comments because the query will
    // find either type of comment - so if the comment doesn't exist, we will get the "not
    // found" error
    const handleUseFocusedCommentGQLError = (0, $42omo.useCallback)((error)=>{
        const isCommentNotFound = error ? (0, $6tkbf.isCommentNotFoundError)(error.message) : false;
        if (flags && isCommentNotFound) {
            const commentId = focusedCommentId || replyToCommentId;
            const FULLPAGEEDITOR_COMMMENT_LINK_NOT_FOUND_FLAG_ID = `fullpageeditor-comment-link-not-found-${commentId}`;
            flags.showWarningFlag({
                id: FULLPAGEEDITOR_COMMMENT_LINK_NOT_FOUND_FLAG_ID,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).commentLinkNotFoundFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).commentLinkNotFoundFlagDescription)
            });
        }
        handleGqlError(error, isCommentNotFound);
    }, [
        flags,
        focusedCommentId,
        handleGqlError,
        replyToCommentId
    ]);
    (0, $iwNka.useExposeGoogleMeetScreenShare)(); // === Editor State ===
    const [shouldRenderPreview, setShouldRenderPreview] = (0, $42omo.useState)(false);
    const [previewAsBlog, setPreviewAsBlog] = (0, $42omo.useState)(false);
    const [stagedContentId, setStagedContentId] = (0, $42omo.useState)();
    const [stagedSpaceKey, setStagedSpaceKey] = (0, $42omo.useState)();
    const [proseMirrorRenderedData, setProseMirrorRenderedData] = (0, $42omo.useState)(null);
    const [checkIfConditionPreventingPublish, setCheckIfConditionPreventingPublish] = (0, $42omo.useState)();
    const assignConditionalFunction = (0, $42omo.useCallback)((conditionalFunction)=>setCheckIfConditionPreventingPublish(()=>conditionalFunction), []);
    const { updateUnresolvedInlineComment: updateUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)(); // importing the comments data states here as a temporary workaround to fix circular dependency, we need these states to handle dangling and unread from unread-comments package
    // unread-comments package is using comments-data package so we can't import comments-data into unread-comments package
    const [{ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: commentsDataMap }, { setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, clearCommentsData: clearCommentsData, addNewCommentThreads: addNewCommentThreads }] = (0, $8i27m.useCommentsData)();
    const { clearProcessedData: clearProcessedData } = (0, $4L9ve.useProcessedCommentsDataActions)();
    const { clearMentionsFlags: clearMentionsFlags } = (0, $hdxAi.useMentionsNotificationsActions)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap, setCurrentView: setCurrentView } = (0, $3mVfX.useCommentsPanelActions)();
    const { updateUnreadComments: updateUnreadComments, updateUnreadCommentsOnFirstRender: updateUnreadCommentsOnFirstRender } = (0, $fHAwL.useUnreadCommentsActions)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { shouldShowNewContentHistory: shouldShowNewContentHistory } = (0, $4tuiZ.useNewContentHistoryState)();
    (0, $8458479082092807$export$d89be7c77f7ffd93)(isLivePage, contentId);
    (0, $6424f127b1220946$export$3873199fd2fe1b43)(proseMirrorRenderedData !== null);
    const handleCollabError = (0, $fBnV3.useHandleCollabError)(flags);
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)), !(0, $9wGTI.fg)('cc_onboarding_experience') || version !== 1); // when a user is eligible for contextual invite nudge, tag them before they publish
    (0, $lG7DR.useContextualInviteNudge)();
    const { editorOnboardingEligiblity: editorOnboardingEligiblity, recentSpotlightCompleted: recentSpotlightCompleted } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const shouldShowRecentSpotlight = !onboardingStateLoading && editorOnboardingEligiblity && !recentSpotlightCompleted; // Makes sure recentSpotlightCompleted is not undefined
    const { onEditorReady: onEditorReady, startingLinks: startingLinks } = (0, $1l6y9.useInviteFromLinkExperimentEditor)(); // === Editor common functionalities and providers ===
    const { collabLimitReached: collabLimitReached, heartbeatError: heartbeatError, stopHeartbeatCallback: stopHeartbeatCallback, editorSessionId: editorSessionId } = heartbeatData; // Preloading native collab data for faster refetch when publishing
    const { refetchNativeCollab: refetchNativeCollabWithPreloading, preloadNativeCollabRefetch: preloadNativeCollabRefetch } = (0, $83a5ab04c7ded94b$export$f6774c6023dca75e)(refetchNativeCollab); // Edit page draft syncing
    const { cancelDebouncedSaveDraft: cancelDebouncedSaveDraft, triggerSaveDraft: triggerSaveDraft, navigateOnClose: navigateOnClose, onPublish: onPublish, isPublishingContent: isPublishingContent, saveDraft: saveDraft, saveDraftError: saveDraftError } = (0, $l3Dp5.useDraftSyncAndPublish)({
        contentId: contentId,
        contentType: contentType,
        refetchNativeCollab: (0, $6mKj3.expValEquals)('confluence_publish_ivc_native_collab_query', 'isEnabled', true) ? refetchNativeCollabWithPreloading : refetchNativeCollab,
        isFirstParticipant: isFirstParticipant,
        isUnpublishedDraft: isUnpublishedDraft,
        spaceKey: spaceKey,
        title: title,
        version: version,
        onCollabError: handleCollabError,
        editorActions: editorActions,
        checkIfConditionPreventingPublish: checkIfConditionPreventingPublish,
        flags: flags,
        dialogs: dialogs,
        editorPresetAPI: fullPageEditorPresetAPI,
        editorSessionId: editorSessionId,
        onPublishUpdateTitleInPageTree: onPublishUpdateTitleInPageTree,
        optimisticDeleteItemInTree: optimisticDeleteItemInTree,
        startingLinks: startingLinks
    }); // Live doc draft syncing
    const { draftSyncActionError: draftSyncActionError } = (0, $a59bf23b6ef769dd$export$7a6d63ee0185f0fd)({
        contentId: contentId,
        editorPresetAPI: fullPageEditorPresetAPI,
        editorActions: editorActions,
        onDraftSyncSuccess: onDraftSyncSuccess,
        isFirstParticipant: isFirstParticipant,
        flags: flags
    });
    const hasUnsavedChanges = (0, $f8ea506e3a40865e$export$d85ed874af6294e9)({
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        isFirstParticipant: isFirstParticipant,
        editorPresetAPI: fullPageEditorPresetAPI
    });
    const printLockout = (0, $88Nzy.usePrintIntercept)({
        enabled: (0, $6mKj3.expValEquals)('afm-enable-command-p-reroute', 'isEnabled', true),
        shouldBlockPrint: ()=>hasUnsavedChanges
    });
    (0, $7oCdN.usePrintCoverInjector)((0, $6mKj3.expValEquals)('afm-enable-command-p-reroute', 'isEnabled', true), intl);
    const { isTransitionPreloading: isLiveDocSeamlessTransitionPreloading } = (0, $d2e739e403a90913$export$1da4922e40f79365)({
        contentId: contentId,
        collabEditProvider: extractedCollabEditProvider,
        isPublishingContent: isPublishingContent,
        isFirstParticipant: isFirstParticipant,
        editorPresetAPI: fullPageEditorPresetAPI,
        isLivePage: isLivePage,
        hasEditPermission: hasEditPermission,
        isFastLoadedLiveDoc: isFastLoadedLiveDoc
    });
    const [isLiveDocSeamlessTransitioning, setIsLiveDocSeamlessTransitioning] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (isLivePage) {
            if (!isLiveDocSeamlessTransitioning && isLiveDocSeamlessTransitionPreloading) setIsLiveDocSeamlessTransitioning(true);
            else if (isLiveDocSeamlessTransitioning && !disabled && !isLiveDocSeamlessTransitionPreloading) setIsLiveDocSeamlessTransitioning(false);
        } else if (isLiveDocSeamlessTransitioning) setIsLiveDocSeamlessTransitioning(false);
    }, [
        contentId,
        disabled,
        isLiveDocSeamlessTransitionPreloading,
        isLivePage,
        isLiveDocSeamlessTransitioning
    ]);
    const [isAutoConverted] = (0, $sLZsl.useAutoConvertState)();
    const { draftTitle: draftTitle, draftBody: draftBody, draftAppearance: draftAppearance } = (0, $9a6aed826f4ffb4d$export$48c0f85d55b51110)({
        contentId: contentId,
        draftShareId: draftShareId,
        collabEditInitialized: collabEditInitialized,
        editorActions: editorActions,
        isUnrecoverableCollabEditError: !!collabEditError && (0, $S6mif.isUnrecoverableError)(collabEditError)
    });
    const { connectionsPanelActiveNodeLocalId: connectionsPanelActiveNodeLocalId, setConnectionsPanelActiveNodeLocalId: setConnectionsPanelActiveNodeLocalId, openConnectionsPanel: openConnectionsPanel, closeConnectionsPanel: closeConnectionsPanel } = (0, $39X8O.useConnectionsPanel)();
    const { activeNodeLocalId: activeNodeLocalId, openConfigPanel: openConfigPanel, closeConfigPanel: closeConfigPanel, upsellModalSource: upsellModalSource, setUpsellModalSource: setUpsellModalSource } = (0, $b5ea4fb4260f4ec5$export$bdd538c0d43098c3)(editorActions);
    const { smartButtonActiveNodeLocalId: smartButtonActiveNodeLocalId, openSmartButtonConfigPanel: openSmartButtonConfigPanel, closeSmartButtonConfigPanel: closeSmartButtonConfigPanel } = (0, $jOYfu.useSmartButtonConfigPanel)();
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const { optInStatus: optInStatus, triggerOptInFlow: triggerOptInFlow, AIOptInModal: AIOptInModal } = (0, $i8Ylv.useEditorAIOptIn)({
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        isAIEnabledForContent: isAIEnabledForContent,
        edition: edition,
        orgId: orgId,
        environment: environment
    });
    const aiGlobalOptIn = (0, $42omo.useMemo)(()=>({
            status: optInStatus,
            triggerOptInFlow: triggerOptInFlow
        }), [
        optInStatus,
        triggerOptInFlow
    ]);
    const { editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers } = (0, $f6GmT.useEditorPluginAIFeedbackHandlers)();
    const { onAIProviderChanged: onAIProviderChanged } = (0, $349687d7e88d726e$export$f95232bf2d33b362)();
    const getChannelVariables = (0, $85rxh.useGetChannelVariables)(cloudId, userId || 'anonymous', orgId);
    const mediaOptions = (0, $bjxK7.useMediaOptions)({
        contentId: contentId,
        contentType: contentType,
        flags: flags,
        viewMode: viewMode,
        editorAPI: fullPageEditorPresetAPI ?? undefined
    });
    const handleFeedbackClicked = (0, $42omo.useCallback)((props)=>{
        editorPluginAIFeedbackHandlers.current.handleFeedbackClicked(props);
    }, [
        editorPluginAIFeedbackHandlers
    ]);
    const handleReviewStateEntered = (0, $42omo.useCallback)(()=>{
        editorPluginAIFeedbackHandlers.current.handleReviewStateEntered();
    }, [
        editorPluginAIFeedbackHandlers
    ]);
    const handleExperienceEnded = (0, $42omo.useCallback)(()=>{
        editorPluginAIFeedbackHandlers.current.handleExperienceEnded();
    }, [
        editorPluginAIFeedbackHandlers
    ]);
    const editorPluginAIProviders = (0, $42omo.useMemo)(()=>({
            mediaProvider: mediaOptions.provider
        }), [
        mediaOptions.provider
    ]);
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const handleAnnotationsRemovedByAI = (0, $26Yfd.useStableCallback)((ids)=>{
        if (!ids?.length) return;
        if (ids.length) flags?.showInfoFlag({
            id: ids[0],
            title: intl.formatMessage((0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).commentRemovedByRovoTitle, {
                count: ids.length
            }),
            description: intl.formatMessage((0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).commentRemovedByRovoDescription, {
                count: ids.length
            }),
            isAutoDismiss: true,
            actions: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? [
                {
                    content: intl.formatMessage((0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).commentRemovedByRovoViewCommentCTA, {
                        count: ids.length
                    }),
                    onClick: ()=>{
                        const openWithView = (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux') ? (0, $3mVfX.ViewValues).DELETED_CONTENT : (0, $3mVfX.ViewValues).OPEN;
                        if (!isCommentsPanelShown) showCommentsPanel({
                            openWithView: openWithView
                        });
                        else setCurrentView(openWithView);
                         // If multiple comments were removed then we will only scroll to the first in the list of comments
                        setTimeout(()=>{
                            scrollCommentsPanelToThread({
                                annotationId: ids[0],
                                scrollOnLoad: true,
                                isCommentThreadDangling: true
                            });
                        }, 1000);
                        flags.hideFlag(flags.state.flags[0]?.id);
                    }
                }
            ] : []
        });
    });
    const editorPluginAIOptions = (0, $foVrt.useEditorPluginAIOptions)({
        aiGlobalOptIn: aiGlobalOptIn,
        appearance: 'full-page',
        onFeedbackClicked: handleFeedbackClicked,
        onReviewStateEntered: handleReviewStateEntered,
        onExperienceComplete: handleExperienceEnded,
        onAIProviderChanged: onAIProviderChanged,
        getChannelVariables: getChannelVariables,
        providers: editorPluginAIProviders,
        contentId: contentId,
        onAnnotationsRemoved: handleAnnotationsRemovedByAI,
        usePlatformPrompt: (0, $9wGTI.fg)('platform_editor_ai_aifc_streaming')
    });
    (0, $6fc6623dec610eba$export$f46ffb959d708168)({
        contentId: contentId,
        collabService: 'ncs'
    });
    const { isTitleFocused: isTitleFocused, shouldFocusEditor: shouldFocusEditor, debounceTitleChangeUpdates: debounceTitleChangeUpdates, focusEditor: focusEditor, onFocusChanged: onFocusChanged } = (0, $1NbQn.useEditorTitleFocus)({
        contentType: contentType,
        editorActions: editorActions,
        isUnpublishedDraft: isUnpublishedDraft
    }); // Editor Disabled Analytics
    (0, $b332f5d2fa8005d6$export$d2b5179b7b1bfa0e)({
        contentId: contentId,
        disabled: isTitleFocused || disabled,
        shouldRenderPreview: shouldRenderPreview,
        shouldShowNewContentHistory: shouldShowNewContentHistory,
        isTitleFocused: isTitleFocused,
        collabEditError: collabEditError,
        collabLimitReached: collabLimitReached,
        heartbeatError: heartbeatError
    });
    const updateUnresolvedInlineCommentFn = (0, $WheoQ.useUpdateAnnotations)([
        updateUnresolvedInlineComment,
        setOrderedActiveAnnotationIdList
    ]);
    const annotationProviderOptions = (0, $bAGpj.useEditorAnnotationProviderOptions)({
        pageId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        editorActions: editorActions,
        updateUnresolvedInlineComment: (0, $9wGTI.fg)('confluence-frontend-comments-panel') ? updateUnresolvedInlineCommentFn : updateUnresolvedInlineComment
    });
    const activityProvider = (0, $fjhaB.useActivityProvider)();
    const mentionProvider = (0, $hfIjM.useMentionProvider)(spaceId, undefined, focusedMentionId);
    const profilecardProvider = (0, $brsfB.useProfilecardProvider)({
        push: push,
        cloudId: cloudId,
        featureFlags: featureFlags,
        userId: userId
    });
    const mentionProps = (0, $42omo.useMemo)(()=>{
        return {
            profilecardProvider: profilecardProvider
        };
    }, [
        profilecardProvider
    ]);
    const searchProvider = (0, $3W9OD.useSearchProvider)();
    const findReplaceOptions = (0, $0642f0591024f070$export$f31ae08e8dcbd049)();
    const taskDecisionProvider = (0, $bcv7k.getTaskDecisionProvider)();
    const autoformattingProvider = (0, $9EvUR.useAutoformattingProvider)({
        contentId: contentId,
        spaceKey: spaceKey,
        source: (0, $9b9cd112fc8297b9$export$f7109619a5e9e0d6)
    });
    const emojiProvider = (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId || undefined,
        allowAnonymousAccess: true
    });
    const contextIdentifierProvider = (0, $98Cy1.useContextIdentifierProvider)(spaceId, contentId);
    const { fetchProvider: fetchProvider, writeProvider: writeProvider } = (0, $drwOC.useMemoizedContentAPIProviders)(cloudId);
    const confluencePageAri = (0, $f8eu7.getConfluencePageAri)(contentId ?? '', cloudId, contentType === 'page' ? 'page' : 'blogpost');
    const confluencePageId = confluencePageAri.match(/ari:cloud:confluence:[^:]+:(page|blogpost)\/(.+)$/)?.[2] ?? '';
    const { fetchProvider: blockServiceFetchProvider, writeProvider: blockServiceWriteProvider } = (0, $l1vR8.useMemoizedBlockServiceAPIProviders)(confluencePageAri, 'confluence-page', confluencePageId);
    const syncedBlockProvider = (0, $1RH0O.useMemoizedSyncedBlockProvider)((0, $9wGTI.fg)('platform_synced_blocks_block_service_provider') ? blockServiceFetchProvider : fetchProvider, (0, $9wGTI.fg)('platform_synced_blocks_block_service_provider') ? blockServiceWriteProvider : writeProvider, confluencePageAri, {
        parentDataProviders: {
            mentionProvider: mentionProvider,
            profilecardProvider: mentionProps?.profilecardProvider,
            taskDecisionProvider: taskDecisionProvider
        },
        providerCreator: (0, $9Eka4.getSyncedBlockNestedRendererProviderCreator)(cloudId, userId)
    });
    const { showMacroFallbackFlag: showMacroFallbackFlag } = (0, $8dcb77f48242281e$export$210750141a74fdf7)(flags, isLivePage);
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)(); // Extension V2 API props
    const { extensionOptions: extensionOptions, rendererExtensionOptions: rendererExtensionOptions } = (0, $aPQsP.useExtensionOptions)({
        contentId: contentId,
        contentType: contentType,
        editorActions: editorActions,
        mentionProvider: mentionProvider,
        spaceKey: spaceKey,
        spaceId: spaceId,
        extensionContextProvider: extensionContextProvider,
        openConnectionsPanel: openConnectionsPanel,
        openConfigPanel: openConfigPanel,
        openSmartButtonConfigPanel: openSmartButtonConfigPanel,
        onCompleteCallback: showMacroFallbackFlag,
        isLivePage: isLivePage,
        allowCreateDatabaseExtension: true,
        allowDatabaseQuickInsert: true,
        allowCreateWhiteboardExtension: true,
        flags: flags,
        aiOptInStatus: optInStatus,
        editorAPI: fullPageEditorPresetAPI ?? undefined,
        setUpsellModalSource: setUpsellModalSource,
        isFullPageEditor: true,
        allowCompanyHubExclusiveExtensions: isCompanyHub,
        isLivePagesFeatureEnabled: isLivePagesFeatureEnabled,
        allowLegacyMacros: true,
        isCollabEditForLiveUpdatesEnabled: true
    });
    (0, $essql.useUnreadCommentsSetup)({
        pageId: contentId,
        pageContentTypeProps: {
            pageMode: 'edit',
            orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
            commentsDataMap: commentsDataMap,
            addNewCommentThreads: addNewCommentThreads
        }
    });
    const { mode: editorContentMode } = (0, $gGHFp.useEditorContentModeValue)({
        contentId: contentId
    });
    const extensionProvidersWithLCM = (0, $42omo.useMemo)(()=>{
        const outerEditorView = editorActions._privateGetEditorView();
        const LCMExtension = $b56facd6a98e9621$var$_createLCMExtensionProvider(outerEditorView, fullPageEditorPresetAPI, {
            contentMode: editorContentMode
        });
        return [
            ...extensionOptions.extensionProviders,
            LCMExtension
        ];
    }, [
        editorActions,
        fullPageEditorPresetAPI,
        extensionOptions.extensionProviders,
        editorContentMode
    ]);
    const { showRevertDialog: showRevertDialog } = (0, $gKaeO.useEditorRevertDialogContext)();
    const { showSpinner: showSpinner, hideSpinner: hideSpinner, shouldShowSpinner: shouldShowSpinner } = (0, $beK3g.useSpinner)();
    const editorAnnotationsRef = (0, $42omo.useRef)([]);
    const annotationStateRef = (0, $42omo.useRef)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    (0, $6qdjm.usePluginStateEffect)(fullPageEditorPresetAPI, [
        'annotation'
    ], ({ annotationState: annotationState })=>{
        const annotations = annotationState?.annotations;
        const { selectedAnnotations: selectedAnnotations, mouseData: mouseData } = annotationState || {};
        annotationStateRef.current = annotationState;
        const handleCommentQueryParams = ()=>{
            if (selectedAnnotations && selectedAnnotations.length > 0 && mouseData?.isSelecting && (focusedCommentId || replyToCommentId)) removeCommentQueryParams();
        };
        const setAnnotations = ()=>{
            const editorAnnotationsToSet = annotations ? Object.keys(annotations) : [];
            if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) setEditorAnnotations((0, $aHcFH.getSortedMarkerRefs)(editorAnnotationsToSet, 'edit'), contentId);
            else setEditorAnnotations((0, $aHcFH.getSortedMarkerRefs)(editorAnnotationsToSet, 'edit'));
            editorAnnotationsRef.current = editorAnnotationsToSet;
            const activeEditorAnnotationsToSet = annotations ? Object.keys(annotations).filter((key)=>annotations[key] === false) : [];
            setOrderedActiveAnnotationIdList((0, $aHcFH.getSortedMarkerRefs)(activeEditorAnnotationsToSet, 'edit'));
        };
        handleCommentQueryParams();
        setAnnotations();
    });
    (0, $39cea118bb4c75f1$export$1a19d181d558cc48)({
        commentId: focusedCommentId || replyToCommentId,
        contentId: contentId,
        handleGqlError: handleUseFocusedCommentGQLError,
        annotationState: annotationStateRef.current
    });
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { setStoredCommentData: setStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true
        }
    });
    (0, $9ovft.useEditorInlineCommentsPubSub)({
        contentId: contentId,
        contentType: contentType,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        updateUnresolvedInlineComment: (0, $9wGTI.fg)('confluence-frontend-comments-panel') ? updateUnresolvedInlineCommentFn : updateUnresolvedInlineComment,
        isDocumentActive: isDocumentActive,
        storedCommentData: storedCommentData,
        setStoredCommentData: setStoredCommentData,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    });
    const { retrieveEditorTitleAndContent: retrieveEditorTitleAndContent } = (0, $iWI3x.useRetrieveEditorTitleAndContent)({
        onCollabError: handleCollabError,
        editorActions: editorActions
    });
    (0, $362e915d9e4c68ec$export$309cbc11a2b3a570)({
        isDocumentActive: isDocumentActive,
        previousAnnotations: editorAnnotationsRef.current,
        contentId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        updateUnresolvedInlineComment: (0, $9wGTI.fg)('confluence-frontend-comments-panel') ? updateUnresolvedInlineCommentFn : updateUnresolvedInlineComment,
        handleGqlError: handleGqlError,
        updateUnreadComments: updateUnreadComments,
        updateUnreadCommentsOnFirstRender: updateUnreadCommentsOnFirstRender,
        adfAnnotations: annotationStateRef.current?.annotations
    }); // TODO: add missing configs/providers (possibly not all):
    // presenceProvider
    // legacyImageUploadProvider
    // placeholderBracketHint
    // allowAnalyticsGASV3
    // onDestroy
    const wrapperProps = {
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS,
        collabEditState: collabEditState,
        contentId: contentId,
        forceDisableEditor: setForceDisabled,
        isUnpublishedDraft: isUnpublishedDraft,
        contentType: contentType,
        editorActions: editorActions,
        heartbeatError: heartbeatError,
        saveDraftError: isLivePage ? draftSyncActionError : saveDraftError,
        stopHeartbeatCallback: stopHeartbeatCallback,
        isLivePage: isLivePage,
        editorDisabled: disabled
    };
    const performanceTrackingOptions = undefined;
    const editorFeatureFlags = (0, $7BsWq.useEditorFeatureFlags)();
    const editorExperiments = (0, $eLnQS.useEditorFullPageExperiments)();
    (0, $455b0e3615badc4d$export$257c6c9e28c0ad4b)(extractedCollabEditProvider); // Fetch content's classification data
    const contentClassificationMetadata = (0, $bFMG7.useContentClassification)({
        contentId: contentId,
        spaceKeyOverride: spaceKey,
        contentStatusContext: isLivePage ? 'current-and-draft' : 'draft-only'
    });
    (0, $42omo.useEffect)(()=>{
        if (collabEditInitialized && !disabled) (0, $e6u60.scrollToLastViewedPosition)(contentId);
    }, [
        collabEditInitialized,
        disabled,
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        // DTR-1401-CFE
        // HOT-103036
        // If a blogpost is selected from in-editor templates panel, any preset restrictions are lost.
        // This lets the user know to update their blog restrictions.
        const showBlogpostAccessFlag = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).BLOGPOST_PERMISSIONS_NOTICE);
        if (flags && showBlogpostAccessFlag === 'true') {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).blogpostPermissionsNotice)
            });
            (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).BLOGPOST_PERMISSIONS_NOTICE);
        }
    }, [
        flags
    ]);
    (0, $42omo.useEffect)(()=>{
        document.addEventListener('keydown', ()=>(0, $6eee7623ad82c8da$export$386b0ae74d3f86a0)(triggerAnalyticsEvent), {
            once: true
        });
    }, [
        triggerAnalyticsEvent
    ]); // Close the object sidebar when navigating to a new page
    (0, $42omo.useEffect)(()=>{
        hideObjectSidebar();
    }, [
        contentId,
        hideObjectSidebar
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                resetInitialDataLoadedMap();
                clearCommentsData();
            }
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) clearProcessedData();
            clearMentionsFlags();
            setActiveHighlight(null);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]); // Focus the main content area for live pages Full Page Editor mount.
    (0, $7aceeeaf0148bdde$export$166cbf4b2438db83)(isLivePage);
    const onProseMirrorRendered = (proseMirrorRenderedAttributes)=>{
        proseMirrorRenderedAttributes = proseMirrorRenderedAttributes || {}; // "distortedDuration" gets a true value if page was loaded in the background
        // in a non-visible tab which can lead to inaccurate duration numbers,
        // this can help us to capture only legitimate durations in our metric dashboards.
        // See https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/editor/editor-common/src/utils/performance/measure-render.ts
        const { proseMirrorRenderedFMP: proseMirrorRenderedFMP, proseMirrorRenderedTimestamp: proseMirrorRenderedTimestamp, startTime: startTime, duration: duration, nodes: nodes, nodeSize: nodeSize, nodeSizeBucket: nodeSizeBucket, totalNodes: totalNodes, nodesInViewport: nodesInViewport, distortedDuration: distortedDuration } = proseMirrorRenderedAttributes;
        setProseMirrorRenderedData({
            proseMirrorRenderedFMP: proseMirrorRenderedFMP,
            proseMirrorRenderedTimestamp: proseMirrorRenderedTimestamp,
            startTime: startTime,
            duration: duration,
            nodes: nodes,
            nodesInViewport: nodesInViewport,
            distortedDuration: distortedDuration
        });
        if ((0, $6mKj3.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).endHeavyTask('PageLoad');
        if ((0, $6mKj3.expValEquals)('cc_editor_insm_doc_size_stats', 'isEnabled', true)) (0, $2v1PW.insm).session?.addProperties({
            'initial:totalNodes': totalNodes,
            'initial:nodeSize': nodeSize,
            'initial:nodes': nodes,
            'initial:nodesInViewport': nodesInViewport,
            'initial:renderDuration': duration,
            'initial:nodeSizeBucket': nodeSizeBucket
        });
    };
    (0, $42omo.useEffect)(()=>{
        (0, $3d5UI.waitForGlobal)({
            listener: 'FullPageEditorComponent',
            globalProperty: 'AJS.bind'
        }, ()=>{
            window.AJS.bind('createGASv3Event', (_, data)=>{
                createAnalyticsEvent(data).fire();
            });
        });
        return ()=>{
            (0, $3d5UI.waitForGlobal)({
                listener: 'FullPageEditorComponent',
                globalProperty: 'AJS.unbind'
            }, ()=>{
                window.AJS.unbind('createGASv3Event');
            });
        };
    }, [
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        isAutoConverted && (0, $cQhbe.sendEditorConversionAnalyticsPageEvent)(createAnalyticsEvent, {
            pageAction: (0, $cQhbe.AutoConvertEvent).EDITED,
            source: 'FullPageEditorComponent-Next'
        }, (0, $cQhbe.AutoConvertActionSubject).AUTO_CONVERSION);
    }, [
        isAutoConverted,
        createAnalyticsEvent
    ]);
    const { setOptimisticTitle: setOptimisticTitle, optimisticTitle: optimisticTitle } = (0, $kSPGK.useOptimisticTitleChange)(contentId, title);
    const updateTimestampCache = (0, $1B6Lx.useUpdateLastEditedTimestampVersionCache)();
    const userOffline = collabEditInternetLost || collabEditConnectionTimedOut;
    const handleTitleChange = (0, $26Yfd.useStableCallback)((newTitle)=>{
        if (isLivePage) {
            /*
      	Live pages immediately persist title changes to the backend and change the page title in the UI,
      	unlike regular pages where changing the title only alters the draft version of the page and
      	it is not fully persisted until the user saves the draft.
      	*/ updateContentTypesTitle(newTitle);
            return;
        }
        setOptimisticTitle(newTitle);
        triggerSaveIndicator();
        onTitleChange(newTitle);
        triggerSaveDraft(); // Update timestamp cache so that Last Edited in object header responsively updates
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) updateTimestampCache({
            contentId: contentId
        });
    });
    (0, $b3e3043e802ac415$export$befb12a9d0ae7ad9)({
        editorApi: fullPageEditorPresetAPI || undefined,
        contentId: contentId
    });
    const { openPublishModal: openPublishModal } = (0, $6pob4.usePublishModalMountActions)();
    const validatePageAndOpenModal = (0, $1N2OF.usePrePublishTitleValidation)({
        contentId: contentId,
        contentType: contentType,
        isUnpublishedDraft: isUnpublishedDraft,
        flags: flags,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        onBeforeValidation: (0, $42omo.useCallback)(()=>{
            saveDraft?.();
        }, [
            saveDraft
        ]),
        onValidationSuccess: openPublishModal,
        analyticsSource: 'LivePagesDetailsPanel',
        optimisticTitle: optimisticTitle
    });
    (0, $cHANb.useEditorAIReplacingTitle)(isAIEnabledForContent, handleTitleChange);
    const handleBreadcrumbsClick = (0, $42omo.useCallback)((destinationUrl)=>{
        // https://product-fabric.atlassian.net/browse/CEMS-2479
        // sync draft and content title with NCS
        // when user click on breadcrumbs to exit the editor
        // so title is up-to-date in page tree
        return new Promise((resolve)=>{
            saveDraft({
                isOnClose: true
            }).then(()=>{
                push(destinationUrl);
                resolve();
            });
        });
    }, [
        push,
        saveDraft
    ]); // [ED-27497] IMPORTANT: This has been moved to the below function. If you add anything here, also add it to the new function.
    // `quickInsertPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/quickInsertPluginOptions.ts'.
    const elementBrowser = (0, $42omo.useMemo)(()=>({
            showModal: true,
            replacePlusMenu: true,
            emptyStateHandler: (0, $f9a65503f42ecec3$export$bc75c05af9bceb4a)
        }), []); // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    const fullPageEditorFeatureFlags = (0, $42omo.useMemo)(()=>({
            ...editorFeatureFlags,
            ...editorExperiments,
            'basic-text-transformations': // utilise this flag as part of eligibility check to avoid passing AI enablement status as editor prop
            aiGlobalOptIn.status === 'disabled'
        }), [
        editorFeatureFlags,
        editorExperiments,
        aiGlobalOptIn.status
    ]);
    const onPreviewClicked = (0, $42omo.useCallback)((requestingPreviewAsBlog, stagedMoveParams)=>{
        setPreviewAsBlog(requestingPreviewAsBlog === true);
        setShouldRenderPreview(true);
        setStagedContentId(stagedMoveParams?.newParentPageId);
        setStagedSpaceKey(stagedMoveParams?.newSpaceKey);
    }, [
        setPreviewAsBlog,
        setShouldRenderPreview,
        setStagedContentId,
        setStagedSpaceKey
    ]);
    const onHoverPublish = (0, $42omo.useCallback)(()=>{
        if (preloadNativeCollabRefetch && (0, $6mKj3.expValEquals)('confluence_publish_ivc_native_collab_query', 'isEnabled', true)) preloadNativeCollabRefetch();
    }, [
        preloadNativeCollabRefetch
    ]);
    const onClickPublish = (0, $26Yfd.useStableCallback)(onPublish);
    const navigateOnCloseStable = (0, $26Yfd.useStableCallback)(navigateOnClose);
    (0, $f9205d97e0969451$export$206997a838ea4b9d)({
        contentId: contentId,
        contentType: contentType,
        isUnpublishedDraft: isUnpublishedDraft,
        title: title ?? draftTitle,
        flags: flags,
        isSchedulePublishEnabled: !isLivePage
    }); // Insert Loom video at top of editor page if a Loom url exists
    (0, $57b1365ec21ea4d6$export$12026d53c57123e6)(fullPageEditorPresetAPI);
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const { getHeadingLinkPath: getHeadingLinkPath } = (0, $5c5c39eb3a311fda$export$5972bbfae42d8829)({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType,
        title: title,
        createdDate: createdDate,
        isUnpublishedDraft: isUnpublishedDraft
    });
    const editorDisabled = (0, $aa4689242ad06a0b$export$dc599391a17e1b5b)({
        disabled: disabled,
        collabEditInternetLost: collabEditInternetLost,
        internetDisconnected: internetDisconnected,
        api: fullPageEditorPresetAPI
    });
    (0, $e5418cfc53a98775$export$c0a34c12e787105e)({
        collabEditInternetLost: collabEditInternetLost,
        internetDisconnected: internetDisconnected,
        editorFullPagePresetAPI: fullPageEditorPresetAPI
    });
    const extensionRendererViewOptions = (0, $kRAnY.useExtensionRendererViewOptions)({
        getExtensionHandlers: rendererExtensionOptions?.getExtensionHandlers,
        isLivePage: isLivePage,
        contentId: contentId,
        spaceKey: spaceKey
    });
    const getExtensionHeight = (0, $jFkNO.useExtensionNodeParams)();
    const { isDesktop: isDesktop } = (0, $2JYae.useIsDesktop)();
    const finalExtensionProviders = extensionProvidersWithLCM;
    const ssrExtensionHandlers = (0, $OCz5m.useEditorSSRExtensionHandlers)(contentId, spaceKey, finalExtensionProviders);
    const FullPageEditorComponentWrapper = isCompanyHub ? (0, $6gbpH.HubEditorWrapper) : $b56facd6a98e9621$var$FullPageEditorWrapper;
    const { canUndo: canUndo, canRedo: canRedo, undo: undo, redo: redo, activateFindReplace: activateFindReplace } = (0, $767f50cadbc92220$export$4da6e3f66c58b328)(fullPageEditorPresetAPI);
    const editorActionsProps = (0, $9wGTI.fg)('platform_editor_ai_aifc_streaming') || (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? {
        canUndo: canUndo,
        canRedo: canRedo,
        undo: undo,
        redo: redo,
        activateFindReplace: activateFindReplace
    } : undefined;
    const allowInlineComments = isEmbeddedConfluence ? hasInlineComments : true;
    const allowPageComments = isEmbeddedConfluence ? hasPageComments : true;
    const { isTemplateBrowserEnabled: isTemplateBrowserEnabled } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    const { hasModernHeader: hasModernHeader, hideHelpButton: hideHelpButton } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const showEmbeddedModernHeader = isEmbeddedConfluence ? hasModernHeader : !isEmbeddedConfluence;
    const showHelpWidget = isEmbeddedConfluence ? !hideHelpButton : true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lxDfD.default), {
        name: "full-page-editor-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f9dc71ade1ee2d5f$export$b5e4a2fe6178c584), {
        editorApi: fullPageEditorPresetAPI
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dE9mB.EditorContextPanelContextProvider), {
        editorAPI: fullPageEditorPresetAPI
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40pD8.ClassificationModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dWbBL.EditorContextContentCreationPanelWrapper), {
        cancelDebouncedSaveDraft: cancelDebouncedSaveDraft,
        collabEditInitialized: collabEditInitialized,
        contentId: contentId,
        contentType: contentType,
        draftShareId: draftShareId,
        editorActions: editorActions,
        hideSpinner: hideSpinner,
        isUnpublishedDraft: isUnpublishedDraft,
        renderPanel: !shouldRenderPreview || !shouldShowNewContentHistory,
        showSpinner: showSpinner,
        title: title
    }, ({ isContentCreationPanelOpen: isContentCreationPanelOpen, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, beforeUpdateRequest: beforeUpdateRequest, postUpdateRequest: postUpdateRequest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2HGN8.ContentAppearanceContextProvider), {
            contentId: contentId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2HGN8.ContentAppearanceContextConsumer), null, ({ contentAppearance: contentAppearance })=>{
            let appearance = $b56facd6a98e9621$var$getContentAppearance(contentAppearance, draftAppearance);
            if (isCompanyHub) // Company Hub editors no longer have the option of changing page width,
            // as content topper is removed. For users who had previously set Company
            // Hub page to 'full-width' and can no longer change it back, we force it to
            // 'full-page' to fix unexpected layout issues and allow editors to
            // set the width on individual extension instances.
            appearance = 'full-page';
            const referentialityContext = (0, $6dTPw.getReferentialityContext)(createAnalyticsEvent, contentId, appearance, ssrExtensionHandlers, extensionRendererViewOptions, getExtensionHeight); // IMPORTANT: If you change the code below, please also update the
            // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/placeholderPluginOptions/placeholderPluginOptions.ts
            const placeholderText = !viewMode && $b56facd6a98e9621$var$_getPlaceholderText({
                featureFlags: featureFlags,
                isAIEnabledForContent: isAIEnabledForContent
            });
            const metaKey = (0, $4tOXV.isMac)() ? "\u2318" : 'Ctrl';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FullPageEditorComponentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c06us.BlankPageQuickActionsProvider), {
                spaceKey: spaceKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f6xB.HeadingLinksStyleWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $btQhd.EditorWrapper), wrapperProps, isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $73d7c23c9a6a572e$export$b112826b6cf719c1), {
                onClickPublish: onClickPublish,
                onClickPreview: onPreviewClicked,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                publishButtonDisabled: false,
                title: title ?? draftTitle,
                userViewingPreview: false,
                isUnpublishedDraft: false,
                contentType: contentType,
                shouldShowWorldIcon: false,
                shouldShowFooterButtons: false,
                isConvertToPageDialog: true,
                onHoverPublish: onHoverPublish
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4f7d3262c48387ee$export$c0bc8bbccc993b75), {
                contentId: contentId,
                contentType: contentType,
                isUnpublishedDraft: isUnpublishedDraft,
                hasEditPermission: hasEditPermission,
                flags: flags,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                saveDraft: saveDraft
            })), !shouldShowNewContentHistory && ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $642dd5941c63cbaa$export$4a2ff2a211b229b0), {
                isLivePage: isLivePage,
                isEmbeddedConfluence: isEmbeddedConfluence,
                viewMode: viewMode,
                spaceKey: spaceKey,
                editorFullPagePresetAPI: fullPageEditorPresetAPI,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                contentId: contentId,
                version: version,
                isShowingOfflineBanner: collabEditInternetLost
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !isLivePage && (0, $9wGTI.fg)('aifc_create_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwwrH.SmartCreateFeedbackBannerLoader), {
                contentType: "page"
            }))), showEmbeddedModernHeader && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3o3i5.EditorObjectHeaderContextProvider), {
                value: {
                    saveDraft: saveDraft,
                    navigateOnClose: navigateOnClose,
                    triggerAnalyticsEvent: triggerAnalyticsEvent,
                    version: version,
                    editorActions: editorActions,
                    title: title,
                    onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
                    isContentCreationPanelOpen: isContentCreationPanelOpen,
                    retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                    showRevertDialog: showRevertDialog,
                    onPreviewClicked: onPreviewClicked,
                    hasEditPermission: hasEditPermission,
                    isPublishingContent: isPublishingContent,
                    userOffline: userOffline,
                    forceDisabled: forceDisabled,
                    editorTitle: title ?? draftTitle,
                    collabLimitReached: collabLimitReached,
                    collabEditConnected: collabEditConnected,
                    onClickPublish: onClickPublish,
                    shouldRenderPreview: shouldRenderPreview,
                    shouldShowNewContentHistory: shouldShowNewContentHistory,
                    isUnpublishedDraft: isUnpublishedDraft,
                    validatePageAndOpenModal: validatePageAndOpenModal,
                    ...editorActionsProps,
                    viewMode: viewMode,
                    onHoverPublish: onHoverPublish
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
                name: (0, $irVI7.OBJECT_HEADER_EXPERIENCE)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8Qzg.ContentTypesHeader), {
                contentId: contentId
            }), isLivePage && (0, $9wGTI.fg)('aifc_create_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwwrH.SmartCreateFeedbackBannerLoader), {
                contentType: "page"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $127f29c854fd1c7d$export$97f4d50961f98e6a), {
                spaceKey: spaceKey,
                editorActions: editorActions,
                collabEditState: collabEditState,
                title: title ?? draftTitle,
                forceDisabled: forceDisabled,
                userOffline: userOffline,
                contentId: contentId,
                contentType: contentType,
                isContentCreationPanelOpen: isContentCreationPanelOpen,
                isUnpublishedDraft: isUnpublishedDraft,
                onClickPublish: onClickPublish,
                onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
                onPreviewClicked: onPreviewClicked,
                saveDraft: saveDraft,
                collabLimitReached: collabLimitReached,
                showRevertDialog: showRevertDialog,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                isPublishingContent: isPublishingContent,
                isSingleUserSession: isSingleUserSession,
                navigateOnClose: navigateOnCloseStable,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                shouldRenderPreview: shouldRenderPreview || shouldShowNewContentHistory,
                shouldShowRecentSpotlight: shouldShowRecentSpotlight,
                checkIfConditionPreventingPublish: checkIfConditionPreventingPublish,
                flags: flags,
                createAnalyticsEvent: createAnalyticsEvent,
                hasEditPermission: hasEditPermission,
                editorDisabled: disabled,
                isTitleFocused: isTitleFocused,
                viewMode: viewMode,
                contentClassificationMetadata: contentClassificationMetadata,
                isLivePage: isLivePage,
                requestToEditContent: requestToEditContent,
                hasRequestedEditPermission: hasRequestedEditPermission,
                ellipsisEditorActions: editorActionsProps
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8uySb.EditorDisplayWrapper), {
                "data-testid": "full-page-editor-style" //TODO: Control isHidden prop
                ,
                isHidden: shouldRenderPreview || shouldShowNewContentHistory,
                isEditorActionBarRendered: true,
                isToolbarAifcEnabled: (0, $9wGTI.fg)('platform_editor_ai_aifc_streaming')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5b566a57f88868ac$export$6d9f0d80d291faa5), {
                editorType: "next",
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                collabEditState: collabEditState,
                collabEditInternetLost: collabEditInternetLost,
                collabEditConnectionTimedOut: collabEditConnectionTimedOut,
                willEditorDisable: !editorDisabled,
                contentType: contentType,
                contentId: contentId,
                spaceId: spaceId,
                fullPageEditorPresetAPI: fullPageEditorPresetAPI,
                isViewMode: viewMode || false,
                isLivePage: isLivePage,
                isDesktop: isDesktop
            }), showHelpWidget && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $022566d7a48da434$export$4d07d1c131526670), {
                contentId: contentId,
                isContentCreationPanelOpen: isContentCreationPanelOpen,
                onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
                editorActions: editorActions,
                isShowingOfflineBanner: collabEditInternetLost,
                version: version,
                spaceKey: spaceKey,
                editorApi: fullPageEditorPresetAPI,
                handleTitleChange: handleTitleChange
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2442a59098041fb3$export$3633514513e9b8b3), {
                isUnpublishedDraft: isUnpublishedDraft,
                onClickPublish: ()=>onPublish({
                        suppressNotifyWatchers: false
                    })()
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8cjD5.PageLoadMark), {
                name: "onBeforeEditor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
                contentId: contentId,
                mode: (0, $5kjCz.EDITOR),
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
            }), (0, $9wGTI.fg)('confluence_footer_comment_styling_change') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iNYtG.PageCommentsPubSubHandler), {
                contentId: contentId,
                contentType: contentType
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bRTjQ.EditorAnalyticsListener), {
                contentId: contentId,
                contentType: contentType,
                source: "pageAndBlogEditor" // TODO: add isTemplateEditorCheck
                ,
                collabService: (0, $gkIgp.CollabServiceProperty).NCS,
                onProseMirrorRendered: onProseMirrorRendered,
                isGuest: isExternalCollaborator
            }, // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            proseMirrorRenderedData && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hd53J.CommentsDataBackgroundLoader), {
                contentId: contentId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6b433f129bb94645$export$5acade271146d69c), {
                value: {
                    forceDisabled: forceDisabled,
                    userOffline: userOffline,
                    collabLimitReached: collabLimitReached,
                    contentId: contentId,
                    contentType: contentType,
                    isContentCreationPanelOpen: isContentCreationPanelOpen,
                    isUnpublishedDraft: isUnpublishedDraft,
                    onClickPublish: onClickPublish,
                    onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
                    onPreviewClicked: onPreviewClicked,
                    saveDraft: saveDraft,
                    spaceKey: spaceKey,
                    showRevertDialog: showRevertDialog,
                    retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                    isPublishingContent: isPublishingContent,
                    isSingleUserSession: isSingleUserSession,
                    triggerAnalyticsEvent: triggerAnalyticsEvent,
                    navigateOnClose: navigateOnCloseStable,
                    title: title,
                    editorActions: editorActions,
                    disabled: disabled || collabLimitReached,
                    isTitleFocused: isTitleFocused,
                    collabEditState: collabEditState,
                    shouldRenderPreview: shouldRenderPreview,
                    shouldShowNewContentHistory: shouldShowNewContentHistory,
                    shouldShowRecentSpotlight: shouldShowRecentSpotlight,
                    flags: flags,
                    createAnalyticsEvent: createAnalyticsEvent,
                    hasEditPermission: hasEditPermission,
                    ellipsisEditorActions: editorActionsProps
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82bb8752b1a17b39$export$f7b2b60e23c443f6), {
                value: {
                    contentComponentsTitle: title ?? draftTitle,
                    contentComponentsDisabled: disabled || collabLimitReached || !collabEditInitialized,
                    handleTitleChange: handleTitleChange,
                    breadcrumbsClickHandler: handleBreadcrumbsClick,
                    beforeUpdateRequest: beforeUpdateRequest,
                    postUpdateRequest: postUpdateRequest
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKSlH.MultiMacroQueryContainer), {
                contentId: contentId,
                featureFlags: featureFlags,
                readFragmentInterop: readFragmentInterop,
                contentRendererMode: (0, $5kjCz.EDITOR)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $36be47a9ed41f8db$export$6124ca97c5c9fe4d), {
                contentId: contentId,
                flags: flags,
                isLivePage: isLivePage,
                isMentionsNotificationsEnabled: isLivePage || isClassicMentionsNotificationsEnrolled,
                editorActions: editorActions
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9jl6v.InlineCommentsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNzRA.ObjectCommentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fMO7O.GuestMentionsNotificationsWrapper), {
                dialogs: dialogs,
                flags: flags
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lmEhP.EditorLinkingFeatures), {
                options: $b56facd6a98e9621$var$CARD_OPTIONS,
                viewMode: viewMode,
                isLivePage: isLivePage
            }, (editorLinkingProps)=>{
                // TODO: fix me. ignored to get an unrelated refactor in: React Hooks must be called in a React function component or a custom React Hook function
                /* eslint-disable react-hooks/rules-of-hooks */ const mainButtonsContext = (0, $6b433f129bb94645$export$87f05b83083ffee2)(); /* eslint-enable react-hooks/rules-of-hooks */ 
                const primaryToolBarComponent = !showEmbeddedModernHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $02a52aafb1fafdd7$export$170e4ca3217957a2), {
                    ...mainButtonsContext,
                    allowInlineComments: allowInlineComments,
                    allowPageComments: allowPageComments
                }) : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jXhAV.QuickReload), {
                    contentId: contentId,
                    contentType: contentType,
                    // package on what a more correct lastPollTime value would be.
                    lastPollTime: Date.now(),
                    pageMode: isLivePage ? (0, $fSC8h.PageMode).LIVE : (0, $fSC8h.PageMode).EDITOR
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                    attribution: (0, $3IBnw.Attribution).EDITOR_CORE
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $639a5b7d5146574b$export$3b07c6dfbdf7e5bd), {
                    setEditorAPI: setEditorApi,
                    // ComposableEditor
                    referentialityContext: referentialityContext,
                    editorPluginAIOptions: editorPluginAIOptions,
                    aiGlobalOptIn: aiGlobalOptIn,
                    editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers,
                    ...extensionOptions,
                    extensionProviders: extensionProvidersWithLCM,
                    getExtensionHeight: getExtensionHeight,
                    allowConfluenceInlineComment: allowInlineComments,
                    allowFindReplace: !collabEditInternetLost && findReplaceOptions,
                    defaultValue: draftBody ?? undefined,
                    elementBrowser: elementBrowser,
                    media: mediaOptions,
                    mention: mentionProps,
                    placeholder: placeholderText && intl.formatMessage(placeholderText, {
                        key: metaKey
                    }),
                    waitForMediaUpload: true,
                    __rendererExtensionOptions: extensionRendererViewOptions,
                    appearance: appearance ?? 'full-page',
                    contentMode: (0, $6mKj3.expValEquals)('cc_editor_ai_content_mode', 'forceAll', true) ? 'compact' : editorContentMode,
                    disabled: isTitleFocused || editorDisabled || collabLimitReached,
                    onChange: handleDocChange,
                    shouldFocus: !!title && shouldFocusEditor,
                    onEditorReady: onEditorReady,
                    activityProvider: activityProvider,
                    annotationProviders: allowInlineComments ? annotationProviderOptions : undefined,
                    autoformattingProvider: autoformattingProvider,
                    collabEditProvider: collabEditProvider,
                    collabEdit: collabEdit,
                    contextIdentifierProvider: contextIdentifierProvider,
                    emojiProvider: emojiProvider,
                    mentionProvider: mentionProvider,
                    searchProvider: searchProvider,
                    taskDecisionProvider: taskDecisionProvider,
                    syncedBlockProvider: syncedBlockProvider,
                    contentComponents: $b56facd6a98e9621$var$_getContentComponents({
                        contentId: contentId,
                        debounceTitleChangeUpdates: debounceTitleChangeUpdates,
                        focusEditor: focusEditor,
                        onFocusChanged: onFocusChanged,
                        userOffline: userOffline,
                        linkCreation: linkCreation === 'true',
                        editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers,
                        isAdminHubAIEnabled: isAdminHubAIEnabled,
                        isAIEnabledForContent: isAIEnabledForContent,
                        hideSpinner: hideSpinner,
                        templateSuggestionsRef: templateSuggestionsRef,
                        templateButtonRef: templateButtonRef,
                        editorActions: editorActions,
                        isTitleFocused: isTitleFocused,
                        disabled: disabled,
                        viewMode: viewMode,
                        contentClassificationMetadata: contentClassificationMetadata,
                        appearance: appearance,
                        spaceKey: spaceKey,
                        title: title,
                        cancelDebouncedSaveDraft: cancelDebouncedSaveDraft,
                        showSpinner: showSpinner,
                        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
                        isUnpublishedDraft: isUnpublishedDraft,
                        featureFlags: featureFlags,
                        fullPageEditorPresetAPI: fullPageEditorPresetAPI,
                        showBlankPageQuickActions: showBlankPageQuickActions,
                        isLivePage: isLivePage,
                        version: version,
                        isEditorEmpty: isEditorEmpty,
                        shouldRenderPreview: shouldRenderPreview,
                        shouldShowNewContentHistory: shouldShowNewContentHistory,
                        isEditorAnnotationProviderManagersEnabled: (0, $9wGTI.fg)('confluence_frontend_editor_annotation_manager'),
                        editorApi: fullPageEditorPresetAPI,
                        contentType: contentType,
                        onTitleChange: onTitleChange,
                        loadingPriority: loadingPriority,
                        isRovoButtonEnabled: isRovoButtonEnabled,
                        editorSessionId: editorSessionId,
                        editorActionsProps: editorActionsProps,
                        isSeamlessTransitionInProgress: (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') && isLiveDocSeamlessTransitioning,
                        hasByLineContributors: hasByLineContributors,
                        hasByLineExtensions: hasByLineExtensions,
                        hasReactions: hasReactions,
                        hasPageComments: hasPageComments,
                        isEmbeddedConfluence: isEmbeddedConfluence,
                        isTemplateBrowserEnabled: isTemplateBrowserEnabled
                    }),
                    contextPanel: $b56facd6a98e9621$var$_getContextPanelComponent(),
                    featureFlags: fullPageEditorFeatureFlags,
                    performanceTracking: performanceTrackingOptions,
                    ...editorLinkingProps,
                    viewMode: viewMode ? 'view' : 'edit',
                    __livePage: isLivePage,
                    flags: flags,
                    primaryToolbarComponents: primaryToolBarComponent,
                    hasEditPermission: hasEditPermission,
                    requestToEditContent: requestToEditContent,
                    hasRequestedEditPermission: hasRequestedEditPermission,
                    getHeadingLinkPath: getHeadingLinkPath,
                    contentId: contentId,
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    isAIEnabledForContent: isAIEnabledForContent,
                    showEmbeddedModernHeader: showEmbeddedModernHeader,
                    isCompanyHub: isCompanyHub
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dLc9m.EditorCommentShortcutListener), {
                    contentId: contentId,
                    viewMode: viewMode,
                    editorApi: fullPageEditorPresetAPI
                }), proseMirrorRenderedData !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8HrX3.TaskScrollComponent), null));
            }))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $beK3g.Spinner), {
                shouldShowSpinner: shouldShowSpinner || // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') && isLiveDocSeamlessTransitioning,
                isOverlayTransparent: !shouldShowSpinner && (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') && isLiveDocSeamlessTransitioning
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AIOptInModal, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fE1Ao.EditorRevertDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                isUnpublishedDraft: isUnpublishedDraft,
                cancelDebouncedSaveDraft: cancelDebouncedSaveDraft
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a1uFh.OnboardingEditorModalPrompt), {
                onTitleChange: onTitleChange,
                handlePublish: ()=>onPublish({
                        suppressNotifyWatchers: false
                    })()
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $11b8024921ea2f1a$export$a1cd66d9f8e156b1), {
                contentId: contentId,
                spaceKey: spaceKey,
                setCheckIfConditionPreventingPublish: assignConditionalFunction
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cvzKy.PageLoadWrapper), {
                disabled: disabled,
                contentId: contentId,
                isCreate: isUnpublishedDraft,
                proseMirrorRenderedData: proseMirrorRenderedData,
                editSource: editSource,
                extractedCollabEditProvider: extractedCollabEditProvider,
                isLivePage: isLivePage,
                customPerfData: customPerfData,
                draftBody: draftBody
            }), shouldShowNewContentHistory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gGwl1.NewContentHistory), {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: contentType
            }) : null, shouldRenderPreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
                value: rendererExtensionOptions
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kGaEh.PreviewPageComponent), {
                contentId: contentId,
                spaceKey: spaceKey,
                stagedContentId: stagedContentId,
                stagedSpaceKey: stagedSpaceKey,
                contentType: contentType,
                contentAppearance: contentAppearance,
                title: title,
                editorActions: editorActions,
                showTemplateVariablesInPreview: true,
                changeEditorMode: ()=>setShouldRenderPreview(false),
                Renderer: (0, $e8Lxy.PageContentRenderer),
                isPageContentRenderer: true,
                editorType: (0, $lWVgZ.EditorTypes).NCS,
                previewAsBlog: previewAsBlog,
                contentClassificationMetadata: contentClassificationMetadata
            })) : null, contentType === 'page' && isLivePagesFeatureEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cmBjr.ConvertToLivePageFlag), null), (0, $6mKj3.expVal)('confluence_modernized_move_dialog', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lfmjq.MovePageSuccessFlag), null), !isEmbeddedConfluence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bK3oZ.RovoBridgeCommandListener), {
                contentId: contentId,
                contentLocation: "global",
                editorAPI: fullPageEditorPresetAPI,
                setEditorDisabled: setForceDisabled,
                mediaProvider: mediaOptions?.provider
            })), fullPageEditorPresetAPI && (0, $9wGTI.fg)('cc_improve_writing_on_paste_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f886df47871fea69$export$29f4298e129f4360), {
                editorAPI: fullPageEditorPresetAPI
            })), $b56facd6a98e9621$var$_getEditorContextConnectionsPanel({
                referentialityContext: referentialityContext,
                connectionsPanelActiveNodeLocalId: connectionsPanelActiveNodeLocalId,
                setConnectionsPanelActiveNodeLocalId: setConnectionsPanelActiveNodeLocalId,
                closeConnectionsPanel: closeConnectionsPanel
            }), // This FF controls if the right rail config panel is available in when editing a page
            isSmartButtonAllowed ? $b56facd6a98e9621$var$_getEditorContextSmartButtonConfigPanel({
                smartButtonActiveNodeLocalId: smartButtonActiveNodeLocalId,
                closeSmartButtonConfigPanel: closeSmartButtonConfigPanel,
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f04c510354797dd3$export$7a4297a73e39e6ad), {
                localId: activeNodeLocalId || '',
                closeSelf: closeConfigPanel,
                editorApi: fullPageEditorPresetAPI || undefined,
                contentId: contentId,
                upsellModalSource: upsellModalSource,
                setUpsellModalSource: setUpsellModalSource
            })));
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hwk5r.DocumentEditPageTitle), {
        contentType: contentType,
        isCreatingNew: isUnpublishedDraft,
        spaceKey: spaceKey,
        title: title,
        isLivePage: isLivePage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8ea506e3a40865e$export$28f25e906763db1e), {
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        isFirstParticipant: isFirstParticipant,
        editorPresetAPI: fullPageEditorPresetAPI
    }), printLockout);
};
const $b56facd6a98e9621$export$63318eb7b01b69fa = (0, $ea0f0e1bfeeed9fe$export$72f7c3354b160bdb)((0, $3IZob.withDocChangeContext)($b56facd6a98e9621$var$withEditorContext((0, $awIbt.withEditorActions)((0, $7aRa9.withFlags)((0, $inDu6.withDialogs)($b56facd6a98e9621$var$FullPageEditorComponentImpl))))));
module.exports["FullPageEditorComponent"] = $b56facd6a98e9621$export$63318eb7b01b69fa;

});

parcelRegister("bre0g", function(module, exports) {

var $2cmfr = parcelRequire("2cmfr");

class $1d9210071da756d7$export$2e2bcd8739ae039 {
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            const nodes = manifest?.modules?.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                preloadCalls.push(node?.preloadRender?.());
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    getPreloadedExtension(type, key) {
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = manifests.find((manifest)=>manifest.type === type && manifest.key === key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $2cmfr.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsPromise = void 0;
        this.manifestsCache = [];
        this.autoConvertHandlers = void 0;
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
}
module.exports["default"] = $1d9210071da756d7$export$2e2bcd8739ae039;

});

parcelRegister("4tOXV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");


var $1Whri = parcelRequire("1Whri");


var $fZAJP = parcelRequire("fZAJP");

const $05ef07480c610d29$export$9ac100e40613ea10 = ()=>{
    let userAgent = '';
    if (window.__SSR_USER_AGENT__) userAgent = window.__SSR_USER_AGENT__;
    else userAgent = window?.navigator?.userAgent;
    return userAgent.indexOf('Mac') > -1;
};
const $05ef07480c610d29$var$styles = {
    flexCenter: "_1rjcv77o _1e0c1txw _4cvr1h6o",
    base: "_2rko12b0 _1rjcv77o _18zru2gc _1e0c1o8l _18u0v77o _2hwxv77o",
    contentBefore: "_18u01b66 _2hwxze3t",
    darkBackground: "_bfhk18j9",
    lightBackground: "_bfhkysee"
};
const $05ef07480c610d29$var$i18n = (0, $cgtv4.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutShift: {
        id: "shortcuts.shift",
        defaultMessage: "Shift"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutCtrl: {
        id: "shortcuts.ctrl",
        defaultMessage: "Ctrl"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutCommandWin: {
        id: "shortcuts.cmd.win",
        defaultMessage: "Ctrl"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutCommandMac: {
        id: "shortcuts.cmd.mac",
        defaultMessage: "Cmd"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutOptionMac: {
        id: "shortcuts.opt.mac",
        defaultMessage: "Opt"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutOptionWin: {
        id: "shortcuts.opt.win",
        defaultMessage: "Alt"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutPlus: {
        id: "shortcuts.plus",
        defaultMessage: "+"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutMinus: {
        id: "shortcuts.minus",
        defaultMessage: "-"
    },
    keyboardShortcutEnter: {
        id: "shortcuts.enter",
        defaultMessage: "Enter"
    },
    keyboardShortcutMeta: {
        id: "shortcuts.meta",
        defaultMessage: "Meta"
    }
});
const $05ef07480c610d29$var$processKey = (key, formatMessage)=>{
    const mac = $05ef07480c610d29$export$9ac100e40613ea10();
    const lowerCaseKey = key.toLowerCase();
    switch(lowerCaseKey){
        case 'shift':
            return '\u21E7';
        // ⇧
        case 'cmd':
        case 'mod':
            return mac ? '\u2318' // ⌘
             : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCommandWin);
        case 'ctrl':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCtrl);
        case 'opt':
        case 'option':
            return mac ? formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionMac) : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionWin);
        case 'enter':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutEnter);
        case 'meta':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutMeta);
        case 'uparrow':
            return '\u2191';
        // ↑
        case 'downarrow':
            return '\u2193';
        // ↓
        case 'leftarrow':
            return '\u2190';
        // ←
        case 'rightarrow':
            return '\u2192';
        // →
        case 'plus':
            return '+';
        case 'minus':
            return '-';
        default:
            return key;
    }
};
const $05ef07480c610d29$var$getShortcutStrings = (accelerator, formatMessage)=>{
    const shortcutKeys = accelerator.includes(' ') ? accelerator.split(' ') : accelerator.split('+');
    return shortcutKeys.map((key)=>{
        const processedKey = $05ef07480c610d29$var$processKey(key, formatMessage);
        if (processedKey.length === 1) return processedKey.toUpperCase();
        else return processedKey;
    });
};
const $05ef07480c610d29$export$7571b974b8c6ca70 = (accelerator, formatMessage)=>{
    return $05ef07480c610d29$var$getShortcutStrings(accelerator, formatMessage).join(' ');
};
const $05ef07480c610d29$export$7005a48098466b5d = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { shortcut: shortcut, contentBefore: contentBefore, isEditorShortcut: isEditorShortcut, isTooltip: t1 } = t0;
    const isTooltip = t1 === undefined ? false : t1;
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $8C5kA.default)();
    let T0;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[0] !== areKeyboardShortcutsEnabled || $[1] !== contentBefore || $[2] !== intl.formatMessage || $[3] !== isEditorShortcut || $[4] !== isTooltip || $[5] !== shortcut) {
        const shortcutStrings = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        const shouldRenderShortcutSegment = areKeyboardShortcutsEnabled || isEditorShortcut;
        T0 = (0, $gdv5Z.default);
        t2 = "span";
        t3 = $05ef07480c610d29$var$styles.flexCenter;
        t4 = contentBefore;
        t5 = shouldRenderShortcutSegment && shortcutStrings.map((shortcutSegment, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                as: "span",
                key: `${shortcutSegment}-${index}`,
                xcss: (0, $1Whri.cx)($05ef07480c610d29$var$styles.base, Boolean(contentBefore) && $05ef07480c610d29$var$styles.contentBefore, isTooltip ? $05ef07480c610d29$var$styles.darkBackground : $05ef07480c610d29$var$styles.lightBackground)
            }, shortcutSegment));
        $[0] = areKeyboardShortcutsEnabled;
        $[1] = contentBefore;
        $[2] = intl.formatMessage;
        $[3] = isEditorShortcut;
        $[4] = isTooltip;
        $[5] = shortcut;
        $[6] = T0;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else {
        T0 = $[6];
        t2 = $[7];
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
    }
    let t6;
    if ($[11] !== T0 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            as: t2,
            xcss: t3
        }, t4, t5);
        $[11] = T0;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ shortcut: shortcut, contentBefore: contentBefore, isEditorShortcut: isEditorShortcut, isTooltip: isTooltip = false })=>{
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $8C5kA.default)();
    const shortcutStrings = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
    const shouldRenderShortcutSegment = areKeyboardShortcutsEnabled || isEditorShortcut; // This is going to be rendered in a <span> so no <div> should be used here.
    // Otherwise it will break HTML structure causing SSR hydration mismatch.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $05ef07480c610d29$var$styles.flexCenter
    }, contentBefore, shouldRenderShortcutSegment && shortcutStrings.map((shortcutSegment, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            key: `${shortcutSegment}-${index}`,
            xcss: (0, $1Whri.cx)($05ef07480c610d29$var$styles.base, Boolean(contentBefore) && $05ef07480c610d29$var$styles.contentBefore, isTooltip ? $05ef07480c610d29$var$styles.darkBackground : $05ef07480c610d29$var$styles.lightBackground)
        }, shortcutSegment)));
}; /**
    * Converts shortcut strings like "ctrl+[" to an array of strings like ["Ctrl", "["].
    *
    * This is used for mapping the shortcut constants in `confluence-shortcuts.ts` to the
    * format expected by the ADS Tooltip `shortcut` prop.
    *
    * It checks if keyboard shortcuts are enabled and returns undefined if they are not.
    *
    * @example
    * ```
    * const shortcut = useShortcutStrings({ shortcut: 'ctrl+[' });
    * <Tooltip content="My tooltip" shortcut={shortcut} />
    * ```
    */ 
const $05ef07480c610d29$export$e84ae736f9706c5d = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { shortcut: shortcut, isEditorShortcut: t1 } = t0;
    const isEditorShortcut = t1 === undefined ? false : t1;
    const intl = (0, $8C5kA.default)();
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    if (!shortcut) return;
    let t2;
    if ($[0] !== intl.formatMessage || $[1] !== shortcut) {
        t2 = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        $[0] = intl.formatMessage;
        $[1] = shortcut;
        $[2] = t2;
    } else t2 = $[2];
    const shortcutStrings = t2;
    const shouldDisplayShortcut = areKeyboardShortcutsEnabled || isEditorShortcut;
    if (!shouldDisplayShortcut) return;
    return shortcutStrings;
} : ({ shortcut: shortcut, isEditorShortcut: isEditorShortcut = false })=>{
    const intl = (0, $8C5kA.default)();
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    if (!shortcut) return undefined;
    const shortcutStrings = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage); // Editor shortcuts are always enabled
    const shouldDisplayShortcut = areKeyboardShortcutsEnabled || isEditorShortcut;
    if (!shouldDisplayShortcut) return undefined;
    return shortcutStrings;
};
module.exports["isMac"] = $05ef07480c610d29$export$9ac100e40613ea10;
module.exports["getShortcutString"] = $05ef07480c610d29$export$7571b974b8c6ca70;
module.exports["ShortcutVisualizer"] = $05ef07480c610d29$export$7005a48098466b5d;
module.exports["useShortcutStrings"] = $05ef07480c610d29$export$e84ae736f9706c5d;

});

parcelRegister("fZAJP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3y1ko = parcelRequire("3y1ko");

let $640354b193201be7$var$inflightPromise = null;
const $640354b193201be7$var$updaters = new Set();
const $640354b193201be7$export$130f87a5d53e682d = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(6);
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const [enabled, setEnabled] = (0, $42omo.useState)(window.__SHORTCUT_ENABLED__ ?? false);
    let t0;
    let t1;
    if ($[0] !== isLicensed || $[1] !== isLoggedIn) {
        t0 = ()=>{
            if (typeof window.__SHORTCUT_ENABLED__ !== "boolean") {
                if (!$640354b193201be7$var$inflightPromise) $640354b193201be7$var$inflightPromise = isLoggedIn && isLicensed ? (0, $3y1ko.fetchShortcutEnabledState)() : Promise.resolve(false);
                $640354b193201be7$var$inflightPromise.then(setEnabled);
            }
            $640354b193201be7$var$updaters.add(setEnabled);
            return ()=>{
                $640354b193201be7$var$updaters.delete(setEnabled);
            };
        };
        t1 = [
            isLoggedIn,
            isLicensed
        ];
        $[0] = isLicensed;
        $[1] = isLoggedIn;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
    const notify = $640354b193201be7$var$_temp;
    const t2 = Boolean(enabled);
    let t3;
    if ($[4] !== t2) {
        t3 = [
            t2,
            notify
        ];
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ()=>{
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const [enabled, setEnabled] = (0, $42omo.useState)(window.__SHORTCUT_ENABLED__ ?? false);
    (0, $42omo.useEffect)(()=>{
        if (typeof window.__SHORTCUT_ENABLED__ !== 'boolean') {
            if (!$640354b193201be7$var$inflightPromise) $640354b193201be7$var$inflightPromise = // preloadShortcutEnabledState will set window.__SHORTCUT_ENABLED__
            isLoggedIn && isLicensed ? (0, $3y1ko.fetchShortcutEnabledState)() : Promise.resolve(false);
            $640354b193201be7$var$inflightPromise.then(setEnabled);
        }
        $640354b193201be7$var$updaters.add(setEnabled);
        return ()=>{
            $640354b193201be7$var$updaters.delete(setEnabled);
        };
    }, [
        isLoggedIn,
        isLicensed
    ]);
    const notify = (0, $42omo.useCallback)(async (enabled_0)=>{
        try {
            const res = await (0, $f7B1p.cfetch)('/wiki/rest/confluenceshortcuts/latest/enabled', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    enabled: enabled_0
                })
            });
            if (res.ok) {
                const newEnabled = await res.text() === 'true';
                // Any newly created hook instance will get the updated value
                window.__SHORTCUT_ENABLED__ = newEnabled;
                // Notify all the existing hooks on the page that we have updated the value
                $640354b193201be7$var$updaters.forEach((updater)=>updater(newEnabled));
            }
        } catch (e) {
            (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error updating keyboard shortcuts enabled state: ${e.message}`), {
                attribution: (0, $3IBnw.Attribution).BACKBONE
            });
        }
    }, []);
    return [
        Boolean(enabled),
        notify
    ];
};
async function $640354b193201be7$var$_temp(enabled_0) {
    try {
        const res = await (0, $f7B1p.cfetch)("/wiki/rest/confluenceshortcuts/latest/enabled", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                enabled: enabled_0
            })
        });
        if (res.ok) {
            const newEnabled = await res.text() === "true";
            window.__SHORTCUT_ENABLED__ = newEnabled;
            $640354b193201be7$var$updaters.forEach((updater)=>updater(newEnabled));
        }
    } catch (t0) {
        const e = t0;
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error updating keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
}
module.exports["useKeyboardShortcutsEnabled"] = $640354b193201be7$export$130f87a5d53e682d;

});

parcelRegister("3y1ko", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $xwvlW = parcelRequire("xwvlW");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $f7B1p = parcelRequire("f7B1p");

async function $4c06255176f911bc$export$632d1cf1f5c6210f() {
    let enabled = false;
    try {
        const res = await (async ()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult = await (0, $f7B1p.cfetch)('/wiki/rest/confluenceshortcuts/latest/enabled');
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            return _asyncResult;
        })();
        if (res.ok) enabled = await (async ()=>{
            const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult2 = await res.text();
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
            return _asyncResult2;
        })() === 'true';
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error fetching keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
    return window.__SHORTCUT_ENABLED__ = enabled;
}
async function $4c06255176f911bc$export$abcdd924245fc03a() {
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    if (isLoggedIn && isLicensed) return await (async ()=>{
        const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult3 = await $4c06255176f911bc$export$632d1cf1f5c6210f();
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
        return _asyncResult3;
    })();
    return false;
}
module.exports["fetchShortcutEnabledState"] = $4c06255176f911bc$export$632d1cf1f5c6210f;
module.exports["preloadShortcutEnabledState"] = $4c06255176f911bc$export$abcdd924245fc03a;

});

parcelRegister("6KwrO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $i6UMJ = parcelRequire("i6UMJ");


var $3mVfX = parcelRequire("3mVfX");


var $7B9wr = parcelRequire("7B9wr");

const $2060138590e26f29$var$commentsPanelListContainerId = 'comments-panel-list-container';
const $2060138590e26f29$var$getCommentThreadContainerId = (annotationId)=>`comment-thread-${annotationId}-container`;
const $2060138590e26f29$export$88e1787f42a1426e = ()=>{
    const { currentView: currentView } = (0, $3mVfX.useCommentsPanelState)();
    const { setCurrentView: setCurrentView } = (0, $3mVfX.useCommentsPanelActions)();
    const isNewDanglingCommentExperienceEnabled = (0, $7B9wr.useIsNewDanglingCommentExperienceEnabled)();
    const scrollCommentsPanelToThread = (0, $42omo.useCallback)(({ annotationId: annotationId, isCommentThreadResolved: isCommentThreadResolved, isCommentThreadDangling: isCommentThreadDangling, commentType: commentType, scrollToEnd: scrollToEnd = false, hasKeyPressed: hasKeyPressed = false, annotationClicked: annotationClicked = false, scrollOnLoad: scrollOnLoad = false, commentContainerToFocus: commentContainerToFocus })=>{
        if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) return;
        if (!isCommentThreadResolved) {
            if (annotationClicked) {
                // Take the user to the open view if they click on an annotation
                // and they are on resolved or unread view
                if (isCommentThreadDangling && isNewDanglingCommentExperienceEnabled) setCurrentView((0, $3mVfX.ViewValues).DELETED_CONTENT);
                else {
                    if (currentView === (0, $3mVfX.ViewValues).UNREAD && (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
                    else setCurrentView((0, $3mVfX.ViewValues).OPEN);
                }
            }
        }
        const commentThreadContainerId = $2060138590e26f29$var$getCommentThreadContainerId(annotationId);
        const scrollToThread = ()=>{
            (0, $i6UMJ.scrollCommentsPanel)({
                containerId: $2060138590e26f29$var$commentsPanelListContainerId,
                commentMarkerRef: commentThreadContainerId,
                commentContainerToFocus: commentContainerToFocus,
                commentType: commentType,
                scrollToEnd: scrollToEnd,
                hasKeyPressed: hasKeyPressed,
                annotationClicked: annotationClicked,
                scrollOnLoad: scrollOnLoad
            });
        };
        // If comment thread container exists and view is not being updated, scroll immediately
        const container = document.getElementById(commentThreadContainerId);
        if (container && currentView !== undefined) {
            scrollToThread();
            return;
        }
        // Set up observer to watch for comment thread container creation
        const observer = new MutationObserver((_mutations, obs)=>{
            // observe the comment thread container
            const containerUpdated = document.getElementById(commentThreadContainerId);
            if (containerUpdated) {
                obs.disconnect();
                scrollToThread();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                'id'
            ]
        });
        // Return cleanup function to ensure observer is disconnected
        return ()=>{
            observer.disconnect();
        };
    }, [
        currentView,
        setCurrentView,
        isNewDanglingCommentExperienceEnabled
    ]);
    return (0, $42omo.useMemo)(()=>({
            scrollCommentsPanelToThread: scrollCommentsPanelToThread
        }), [
        scrollCommentsPanelToThread
    ]);
};
module.exports["useCommentsPanelScroll"] = $2060138590e26f29$export$88e1787f42a1426e;

});

parcelRegister("i6UMJ", function(module, exports) {

var $422HI = parcelRequire("422HI");


var $7Oxky = parcelRequire("7Oxky");


var $8i27m = parcelRequire("8i27m");


var $6faGq = parcelRequire("6faGq");


var $9wGTI = parcelRequire("9wGTI");


var $3mVfX = parcelRequire("3mVfX");


var $9wEpK = parcelRequire("9wEpK");

const $6ed006a18ff2d87d$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS = 8;
const $6ed006a18ff2d87d$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW = 60;
const $6ed006a18ff2d87d$var$getTotalOffsetAboveCommentsPanelThreads = (generalCommentsHeaderHeight)=>{
    let objectSidebarPanelHeader = document.querySelector("[data-testid='object-sidebar-panel-header']");
    let additionalOffset = 0;
    if (!objectSidebarPanelHeader) {
        objectSidebarPanelHeader = document.querySelector("[data-testid='scrolled-object-sidebar-panel-header']");
        additionalOffset = $6ed006a18ff2d87d$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS;
    }
    const objectSidebarPanelHeaderHeight = objectSidebarPanelHeader?.getBoundingClientRect().height ?? 0;
    const objectHeaderHeight = document.querySelector("[data-testid='object-header-container']")?.getBoundingClientRect().height ?? 0;
    const topNavContainerHeight = document.querySelector("[data-testid='grid-topNav']")?.getBoundingClientRect().height ?? 0;
    const bannerContainerHeight = document.querySelector("[data-testid='banner-container']")?.getBoundingClientRect().height ?? 0;
    const editorControlsOnboardingBannerHeight = document.querySelector("[data-testid='editor-controls-onboarding-banner']")?.getBoundingClientRect().height ?? 0;
    const announcementBannerHeight = document.querySelector("[id='AkBanner']")?.getBoundingClientRect().height ?? 0;
    return objectSidebarPanelHeaderHeight + objectHeaderHeight + topNavContainerHeight + bannerContainerHeight + additionalOffset + generalCommentsHeaderHeight + editorControlsOnboardingBannerHeight + announcementBannerHeight;
};
const $6ed006a18ff2d87d$export$4d211f4974dcf196 = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === (0, $8i27m.CommentType).GENERAL ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const totalPaddingAboveCommentThreadView = $6ed006a18ff2d87d$var$getTotalOffsetAboveCommentsPanelThreads(generalCommentsHeaderHeight);
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    const viewportTop = totalPaddingAboveCommentThreadView;
    const viewportBottom = window.innerHeight - objectSidebarPanelFooterHeight;
    const commentTopInView = commentThreadRect.top >= viewportTop;
    const commentBottomInView = commentThreadRect.bottom <= viewportBottom;
    if (commentTopInView && commentBottomInView) // Comment is 100% in view
    return false;
    else if (!commentTopInView && commentBottomInView) // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
    else if (commentTopInView && !commentBottomInView) {
        // Comment is <100% in view and the hidden part is the bottom of the comment
        const hiddenBottomHeight = commentThreadRect.bottom - viewportBottom;
        if (hiddenBottomHeight <= $6ed006a18ff2d87d$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW) // The hidden part is <= 60 pixels
        return false;
        else // The hidden part is > 60 pixels
        return true;
    } else // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
};
const $6ed006a18ff2d87d$export$9c5b7a3c864ae31b = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === (0, $8i27m.CommentType).GENERAL ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    return(// Element is partially out of view below the comments panel viewport
    commentThreadRect.bottom + generalCommentsHeaderHeight > window.innerHeight - objectSidebarPanelFooterHeight);
};
var $6ed006a18ff2d87d$export$50c823aead020a09 = /*#__PURE__*/ function(LocationValue) {
    LocationValue["PANEL"] = "panel";
    LocationValue["FOOTER"] = "footer";
    LocationValue["STANDALONE"] = "standalone";
    return LocationValue;
}({});
/**
 * Watches for a specific comment container to appear in the DOM and scrolls to it when found
 * Only active when confluence-fe-comments-deep-link-behavior feature gate is enabled
 */ const $6ed006a18ff2d87d$var$watchForCommentContainerAndScroll = (commentContainerToFocus)=>{
    if (!(0, $9wGTI.fg)('confluence-fe-comments-deep-link-behavior')) return ()=>{}; // Return empty cleanup function if feature gate is disabled
    let isDisconnected = false;
    let commentFound = false;
    // Find the most specific container to observe
    const commentsPanelListContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    const targetContainer = commentsPanelListContainer || document.body;
    const observer = new MutationObserver(()=>{
        if (isDisconnected || commentFound) return;
        // Look for the comment element directly
        const commentElement = targetContainer.querySelector(`[data-comment-id="${commentContainerToFocus}"]`);
        if (commentElement) {
            commentFound = true;
            commentElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
            isDisconnected = true;
            observer.disconnect();
        }
    });
    // Start observing only the specific container
    observer.observe(targetContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
            'data-comment-id'
        ]
    });
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
        }
    };
};
const $6ed006a18ff2d87d$export$85b827bda656b8e1 = ({ containerId: containerId, commentMarkerRef: commentMarkerRef, commentType: commentType, scrollToEnd: scrollToEnd, hasKeyPressed: hasKeyPressed, annotationClicked: annotationClicked, scrollOnLoad: scrollOnLoad, commentContainerToFocus: commentContainerToFocus })=>{
    if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) return;
    const container = document.querySelector(`[data-testid='${containerId}']`);
    if (container) {
        const element = document.querySelector(`[data-testid='${commentMarkerRef}']`);
        if (commentContainerToFocus) {
            $6ed006a18ff2d87d$var$watchForCommentContainerAndScroll(commentContainerToFocus);
            return;
        }
        if (element) {
            const activeElement = document.activeElement;
            const isReplyButton = activeElement?.getAttribute('data-testid') === 'comment-reply-button';
            if (isReplyButton) {
                const replyContainer = document.querySelector('[data-testid=comments-panel-new-reply-container]');
                replyContainer?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center'
                });
                return;
            }
            // If triggered by keyboard navigation or focus or if annotationClicked is true or triggered by a focused loading
            if (hasKeyPressed || annotationClicked || scrollOnLoad) {
                if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    if (scrollToEnd && $6ed006a18ff2d87d$export$9c5b7a3c864ae31b(element, commentType) || $6ed006a18ff2d87d$export$4d211f4974dcf196(element, commentType)) element.scrollIntoView({
                        behavior: 'smooth',
                        block: scrollToEnd ? 'end' : 'start'
                    });
                } else element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                return;
            }
        }
    }
};
const $6ed006a18ff2d87d$export$68e3ad656cdca3ec = (orderedActiveAnnotationIdList)=>{
    return orderedActiveAnnotationIdList.slice(0, Math.min(orderedActiveAnnotationIdList.length, (0, $7Oxky.COMMENT_BATCH_SIZE))).filter((item)=>!item.isLoaded) // only get the ones that are not loaded yet
    .map((item)=>item.threadKey);
};
const $6ed006a18ff2d87d$var$getDanglingComments = ({ commentsDataMap: commentsDataMap, annotationsSet: annotationsSet, openCommentThreads: openCommentThreads })=>{
    // Add dangling comments and handle real-time changes
    for(const threadKey in commentsDataMap.inline){
        const commentThread = commentsDataMap.inline[threadKey];
        const isDanglingComment = commentThread?.location?.inlineResolveProperties?.isDangling;
        if (commentThread?.isOpen) {
            // if the comment is already dangling, we want to add it to the list
            if (isDanglingComment) {
                const markerRef = commentThread?.location?.inlineMarkerRef;
                // comment is no longer dangling if it has a marker ref and is in the annotations set
                if (markerRef && annotationsSet && annotationsSet.has(markerRef)) {
                    const updatedCommentThread = {
                        ...commentThread,
                        location: {
                            ...commentThread.location,
                            inlineResolveProperties: {
                                ...commentThread.location.inlineResolveProperties,
                                isDangling: false
                            }
                        }
                    };
                    openCommentThreads.push(updatedCommentThread);
                } else openCommentThreads.push(commentThread);
                continue;
            }
            // check for real time dangling comments
            const markerRef = commentThread?.location?.inlineMarkerRef;
            // comment is dangling if it has a marker ref and is not in the annotations set
            // deleted and resolved comments are not in commentsDataMap so we know it's only dangling scenario
            // we do this here so the view will update immediately, but the actual mutation is handled in useDanglingOperations
            if (markerRef && annotationsSet && !annotationsSet.has(markerRef)) {
                const updatedCommentThread = {
                    ...commentThread,
                    location: {
                        ...commentThread.location,
                        inlineResolveProperties: {
                            ...commentThread.location.inlineResolveProperties,
                            isDangling: true
                        }
                    }
                };
                openCommentThreads.push(updatedCommentThread);
            }
        }
    }
};
const $6ed006a18ff2d87d$export$aa9a5ed6405f18d6 = ({ commentsDataMap: commentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, removedThreadsMap: removedThreadsMap, showInlineComments: showInlineComments, showGeneralComments: showGeneralComments, location: location = "panel" })=>{
    const openCommentThreads = [];
    const annotationsSet = new Set(orderedActiveAnnotationIdList.map((item)=>item.threadKey));
    // inline comments
    if (showInlineComments && location === "panel") {
        const removedAnnotationIds = new Set(Object.values(removedThreadsMap.inline));
        const filteredActiveAnnotationIds = orderedActiveAnnotationIdList.filter((item)=>!removedAnnotationIds.has(item.threadKey));
        const totalAnnotationsCount = filteredActiveAnnotationIds.length + Object.keys(removedThreadsMap).length;
        let activeIndex = 0; // Track position in filteredActiveAnnotationIds
        for(let i = 0; i < totalAnnotationsCount; i++){
            let threadKey = '';
            if (removedThreadsMap.inline.hasOwnProperty(i)) {
                threadKey = removedThreadsMap.inline[i];
                const commentThread = commentsDataMap.inline[threadKey];
                if (commentThread) openCommentThreads.push(commentThread);
            } else if (activeIndex < filteredActiveAnnotationIds.length) {
                threadKey = filteredActiveAnnotationIds[activeIndex].threadKey;
                const commentThread = commentsDataMap.inline[threadKey];
                // dangling comments had a marker ref and will be inside commentsDataMap, so we want to ignore these first
                const isDanglingComment = commentThread?.location?.inlineResolveProperties?.isDangling && (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
                // Don't add if it's dangling or might become dangling (has marker ref but not in annotations set)
                const markerRef = commentThread?.location?.inlineMarkerRef;
                const mightBecomeDangling = markerRef && annotationsSet && !annotationsSet.has(markerRef);
                if (commentThread?.isOpen && !isDanglingComment && !mightBecomeDangling) openCommentThreads.push(commentThread);
                activeIndex++;
            }
        }
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) $6ed006a18ff2d87d$var$getDanglingComments({
            commentsDataMap: commentsDataMap,
            openCommentThreads: openCommentThreads,
            annotationsSet: annotationsSet
        });
    }
    // general comments
    if (showGeneralComments || location === "footer") {
        // We can just push these in the order we have them because we have no concept of "active"
        const generalComments = Object.values(commentsDataMap.general).filter((generalComment)=>{
            return generalComment.isOpen || generalComment.wasRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT;
        });
        openCommentThreads.push(...generalComments);
    }
    return openCommentThreads;
};
const $6ed006a18ff2d87d$export$85db2a7195bf7 = ({ numUnreadComments: numUnreadComments, commentsDataMap: commentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, removedThreadsMap: removedThreadsMap, showInlineComments: showInlineComments, showGeneralComments: showGeneralComments, location: location = "panel" })=>{
    const unreadCommentThreads = [];
    if ((Object.keys(commentsDataMap.inline).length > 0 || Object.keys(commentsDataMap.general).length > 0) && (numUnreadComments > 0 || Object.keys(removedThreadsMap.inline).length > 0)) {
        // inline comments
        if (showInlineComments && location === "panel") {
            const removedAnnotationIds = new Set(Object.values(removedThreadsMap.inline));
            const filteredActiveAnnotationIds = orderedActiveAnnotationIdList.filter((item)=>!removedAnnotationIds.has(item.threadKey));
            const totalAnnotationsCount = filteredActiveAnnotationIds.length + Object.keys(removedThreadsMap.inline).length;
            let activeIndex = 0; // Track position in filteredActiveAnnotationIds
            for(let i = 0; i < totalAnnotationsCount; i++){
                let threadKey = '';
                if (removedThreadsMap.inline.hasOwnProperty(i)) {
                    threadKey = removedThreadsMap.inline[i];
                    const commentThread = commentsDataMap.inline[threadKey];
                    if (commentThread?.isOpen && (commentThread?.isUnread || commentThread?.replies?.some((reply)=>reply.isUnread))) unreadCommentThreads.push(commentThread);
                } else if (activeIndex < filteredActiveAnnotationIds.length) {
                    threadKey = filteredActiveAnnotationIds[activeIndex].threadKey;
                    const commentThread = commentsDataMap.inline[threadKey];
                    if (commentThread?.isOpen && (commentThread?.isUnread || commentThread?.replies?.some((reply)=>reply.isUnread))) unreadCommentThreads.push(commentThread);
                    activeIndex++;
                }
            }
        }
        // general comments
        if (showGeneralComments) {
            // We can just push these in the order we have them because we have no concept of "active"
            const generalComments = Object.values(commentsDataMap.general).filter((generalComment)=>{
                return (generalComment.isOpen || generalComment.wasRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT) && (generalComment.isUnread || generalComment.replies.some((reply)=>reply.isUnread));
            });
            unreadCommentThreads.push(...generalComments);
        }
    }
    return unreadCommentThreads;
};
const $6ed006a18ff2d87d$export$4fc364cd63a9b204 = ({ commentsDataMap: commentsDataMap, showInlineComments: showInlineComments, showGeneralComments: showGeneralComments, location: location = "panel" })=>{
    const resolvedCommentThreads = [];
    // inline comments
    if (showInlineComments && location === "panel") for(const key in commentsDataMap.inline){
        const comment = commentsDataMap.inline[key];
        if (comment.isOpen === false) resolvedCommentThreads.push(comment);
    }
    // general comments
    if (showGeneralComments) for(const key in commentsDataMap.general){
        const comment = commentsDataMap.general[key];
        if (comment.isOpen === false) resolvedCommentThreads.push(comment);
    }
    return resolvedCommentThreads;
};
const $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime = (comment)=>{
    const commentLocation = comment.location;
    const resolvedTime = commentLocation?.inlineResolveProperties?.resolvedTime || commentLocation?.commentResolveProperties?.resolvedTime; // from the BE, this is for both reopened and resolved time, in milliseconds
    return resolvedTime || (0, $6faGq.getValidDate)(comment.createdAtNonLocalized).getTime(); // getTime() returns milliseconds
};
const $6ed006a18ff2d87d$export$d2935240a910e26e = (currentSort, commentThreads)=>{
    if (currentSort === (0, $3mVfX.SortValues).MOST_RECENT) return [
        ...commentThreads
    ].sort((a, b)=>$6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(b) - $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(a));
    return commentThreads;
};
const $6ed006a18ff2d87d$export$47f9a121266175f = (annotations)=>annotations.map((annotation)=>annotation.threadKey);
const $6ed006a18ff2d87d$export$7119b2a60583b6dc = (marks = [])=>marks.map((mark)=>mark.attrs.id);
const $6ed006a18ff2d87d$export$b02d74cde949c060 = (commentA, commentB)=>(0, $6faGq.getValidDate)(commentA?.createdAtNonLocalized).getTime() - (0, $6faGq.getValidDate)(commentB?.createdAtNonLocalized).getTime();
const $6ed006a18ff2d87d$export$5425fcea1abfd6f7 = (error)=>{
    if (!error) // if falsy, consider it as NOT containing non-reactionsSummary errors
    return true;
    else if (error instanceof (0, $422HI.ApolloErrorInterop) || error instanceof (0, $9wEpK.ApolloError)) {
        // TODO we will need to migrate to ApolloRelayInterops to get proper error type of ApolloErrorInterop instead of ApolloError
        // after migration, we can remove the instanceof ApolloError check here
        const hasOtherGqlErrors = error.graphQLErrors?.filter((e)=>!e.path?.includes('reactionsSummary'))?.length > 0;
        return !hasOtherGqlErrors && !error.networkError;
    } else // if truthy but not an ApolloErrorInterop, consider it as containing non-reactionsSummary errors
    return false;
};
module.exports["LocationValue"] = $6ed006a18ff2d87d$export$50c823aead020a09;
module.exports["scrollCommentsPanel"] = $6ed006a18ff2d87d$export$85b827bda656b8e1;
module.exports["getAnnotationsToLoad"] = $6ed006a18ff2d87d$export$68e3ad656cdca3ec;
module.exports["getOpenCommentThreads"] = $6ed006a18ff2d87d$export$aa9a5ed6405f18d6;
module.exports["getUnreadCommentThreads"] = $6ed006a18ff2d87d$export$85db2a7195bf7;
module.exports["getResolvedCommentThreads"] = $6ed006a18ff2d87d$export$4fc364cd63a9b204;
module.exports["getSortedCommentThreads"] = $6ed006a18ff2d87d$export$d2935240a910e26e;
module.exports["getAnnotationThreadKeys"] = $6ed006a18ff2d87d$export$47f9a121266175f;
module.exports["getMarkIds"] = $6ed006a18ff2d87d$export$7119b2a60583b6dc;
module.exports["getCommentsSortedOldestToNewest"] = $6ed006a18ff2d87d$export$b02d74cde949c060;
module.exports["onlyHasReactionsSummaryErrors"] = $6ed006a18ff2d87d$export$5425fcea1abfd6f7;

});

parcelRegister("7Oxky", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7Sm4c = parcelRequire("7Sm4c");


var $fHAwL = parcelRequire("fHAwL");


var $aUU0C = parcelRequire("aUU0C");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $8i27m = parcelRequire("8i27m");


var $3ZsvI = parcelRequire("3ZsvI");

const $9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery = (0, $eSUdr.default)`query useActiveInlineCommentsQueryActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!$pageId:ID!$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList pageId:$pageId contentStatus:$contentStatus){nodes{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}createdAt{value}createdAtNonLocalized replies{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}`;
const $9d95853344936385$export$e8d93aa39e79e9aa = 1000; // setting to 1000 for now until we implement infinite scroll for the comments panel
const $9d95853344936385$export$6ddede7674b6d70f = ({ pageId: pageId, markerRefList: markerRefList, skip: skip = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [{ commentsDataMap: commentsDataMap }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap }] = (0, $8i27m.useCommentsData)();
    const [{ readCommentsListState: readCommentsListState }] = (0, $fHAwL.useUnreadComments)();
    const [{ annotations: annotations }] = (0, $aUU0C.useEditorAnnotations)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    // Determine if the query should be skipped
    const skipQuery = !pageId || markerRefList.length === 0 || skip;
    const annotationsInEditorDoc = (0, $42omo.useMemo)(()=>{
        return new Set(annotations);
    }, [
        annotations
    ]);
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0;
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery, {
        variables: {
            pageId: pageId,
            inlineMarkerRefList: markerRefList,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ]
        },
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: skipQuery ? 'cache-only' : 'cache-and-network',
        // We want to utilize the cache as much as possible, but keep the list up to date if it changes
        skip: skipQuery,
        onCompleted: (result)=>{
            (0, $3ZsvI.updateCommentsDataState)({
                data: result,
                readCommentsListState: readCommentsListState,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                annotationsInEditorDoc: annotationsInEditorDoc,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: true
            });
            setLoading(false);
        },
        onError: (err)=>{
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (err.message.search(/reactions/i) !== -1 || err.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(err);
            setLoading(false);
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    return {
        loading: !skipQuery ? loading : false,
        data: // If we skip the query make sure loading is false
        data,
        error: error,
        refetch: refetch
    };
};
module.exports["COMMENT_BATCH_SIZE"] = $9d95853344936385$export$e8d93aa39e79e9aa;
module.exports["useActiveInlineCommentsQuery"] = $9d95853344936385$export$6ddede7674b6d70f;

});

parcelRegister("fHAwL", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $7fff4328005dca96$var$initialState = {
    unreadCommentsListState: [],
    readCommentsListState: new Set(),
    shouldUpdateUnreadComments: false,
    shouldUpdateUnreadCommentsOnFirstRender: true,
    threadKeyToCommentIdMap: {},
    allComments: [],
    isUnreadQueryLoading: false,
    // this is the for updated unread comment list experience
    unreadCommentIDSet: new Set(),
    shouldClearVisibleThreads: false
};
const $7fff4328005dca96$var$actions = {
    updateUnreadCommentsListState: (transform)=>({ setState: setState, getState: getState })=>{
            const { unreadCommentsListState: unreadCommentsListState, threadKeyToCommentIdMap: threadKeyToCommentIdMap } = getState();
            setState({
                unreadCommentsListState: transform(unreadCommentsListState, threadKeyToCommentIdMap)
            });
        },
    updateReadCommentsListState: (transform)=>({ setState: setState, getState: getState })=>{
            const { readCommentsListState: readCommentsListState } = getState();
            setState({
                readCommentsListState: transform(readCommentsListState)
            });
        },
    updateUnreadComments: (shouldUpdateUnreadComments)=>({ setState: setState })=>{
            setState({
                shouldUpdateUnreadComments: shouldUpdateUnreadComments
            });
        },
    updateUnreadCommentsOnFirstRender: (shouldUpdateUnreadCommentsOnFirstRender)=>({ setState: setState })=>{
            setState({
                shouldUpdateUnreadCommentsOnFirstRender: shouldUpdateUnreadCommentsOnFirstRender
            });
        },
    updateThreadKeyToCommentIdMap: (transform)=>({ setState: setState, getState: getState })=>{
            const { threadKeyToCommentIdMap: threadKeyToCommentIdMap } = getState();
            setState({
                threadKeyToCommentIdMap: transform(threadKeyToCommentIdMap)
            });
        },
    updateAllComments: (allComments)=>({ setState: setState })=>{
            setState({
                allComments: allComments
            });
        },
    setIsUnreadQueryLoading: (loading)=>({ setState: setState })=>{
            setState({
                isUnreadQueryLoading: loading
            });
        },
    updateUnreadCommentIDSet: (unreadCommentIDSet, operation = 'initialize')=>({ setState: setState, getState: getState })=>{
            const { unreadCommentIDSet: existingSet } = getState();
            switch(operation){
                case 'initialize':
                    setState({
                        unreadCommentIDSet: unreadCommentIDSet
                    });
                    break;
                case 'add':
                    setState({
                        unreadCommentIDSet: new Set([
                            ...existingSet,
                            ...unreadCommentIDSet
                        ])
                    });
                    break;
                case 'remove':
                    const newSet = new Set(existingSet);
                    unreadCommentIDSet.forEach((id)=>newSet.delete(id));
                    setState({
                        unreadCommentIDSet: newSet
                    });
                    break;
                case 'removeAll':
                    setState({
                        unreadCommentIDSet: new Set()
                    });
                    break;
            }
        },
    setShouldClearVisibleThreads: (shouldClearVisibleThreads)=>({ setState: setState })=>{
            setState({
                shouldClearVisibleThreads: shouldClearVisibleThreads
            });
        }
};
const $7fff4328005dca96$var$UnreadCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $7fff4328005dca96$var$initialState,
    actions: $7fff4328005dca96$var$actions,
    name: 'UnreadCommentsStore'
});
const $7fff4328005dca96$export$df6365a5248dcd96 = (0, $9zUhf.createHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$b7fe87478f70c759 = (0, $9zUhf.createActionsHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$fdd0a0c032c12265 = (0, $9zUhf.createStateHook)($7fff4328005dca96$var$UnreadCommentsStore);
module.exports["useUnreadComments"] = $7fff4328005dca96$export$df6365a5248dcd96;
module.exports["useUnreadCommentsActions"] = $7fff4328005dca96$export$b7fe87478f70c759;
module.exports["useUnreadCommentsState"] = $7fff4328005dca96$export$fdd0a0c032c12265;

});

parcelRegister("aUU0C", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $6b57ff110c624a89$var$initialState = {
    annotations: []
};
const $6b57ff110c624a89$var$actions = {
    setEditorAnnotations: (newAnnotations, pageId)=>({ getState: getState, setState: setState })=>{
            const { annotations: annotations } = getState();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(newAnnotations, annotations)) setState({
                annotations: newAnnotations,
                pageId: pageId
            });
        }
};
const $6b57ff110c624a89$var$EditorAnnotationsStore = (0, $1P1Tu.createStore)({
    initialState: $6b57ff110c624a89$var$initialState,
    actions: $6b57ff110c624a89$var$actions,
    name: 'EditorAnnotationsStore'
});
const $6b57ff110c624a89$export$af3b3e68acbfeb43 = (0, $9zUhf.createHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
const $6b57ff110c624a89$export$72e98d7f4c892f01 = (0, $9zUhf.createActionsHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
module.exports["useEditorAnnotations"] = $6b57ff110c624a89$export$af3b3e68acbfeb43;
module.exports["useEditorAnnotationsActions"] = $6b57ff110c624a89$export$72e98d7f4c892f01;

});

parcelRegister("aSsfA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
} : ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("de2j9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
} : ()=>(0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("8i27m", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $a4TK8 = parcelRequire("a4TK8");


var $9rE3H = parcelRequire("9rE3H");


var $f5Wgm = parcelRequire("f5Wgm");


var $eg9xl = parcelRequire("eg9xl");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $3ZsvI = parcelRequire("3ZsvI");

const $33a0cfbfba499043$var$logger = (0, $7W8i8.getLogger)('comments-data');
var $33a0cfbfba499043$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
var $33a0cfbfba499043$export$e539ce02135a18ae = /*#__PURE__*/ function(UnreadAction) {
    UnreadAction[UnreadAction["READ"] = 0] = "READ";
    UnreadAction[UnreadAction["UNREAD"] = 1] = "UNREAD";
    return UnreadAction;
}({});
var $33a0cfbfba499043$export$74159dff405238c0 = /*#__PURE__*/ function(CommentActionType) {
    CommentActionType["CREATE_COMMENT"] = "created";
    CommentActionType["DELETE_COMMENT"] = "deleted";
    CommentActionType["RESOLVE_COMMENT_THREAD"] = "resolved";
    CommentActionType["REOPEN_COMMENT_THREAD"] = "reopened";
    CommentActionType["REATTACH_COMMENT"] = "reattach";
    return CommentActionType;
}({});
var $33a0cfbfba499043$export$2021eb0669e47276 = /*#__PURE__*/ function(FooterCommentsLoadingStateType) {
    FooterCommentsLoadingStateType["NOT_LOADED"] = "not_loaded";
    FooterCommentsLoadingStateType["PRELOADING"] = "preloading";
    FooterCommentsLoadingStateType["PARTIALLY_LOADED"] = "partially_loaded";
    FooterCommentsLoadingStateType["FULLY_LOADED"] = "fully_loaded";
    return FooterCommentsLoadingStateType;
}({});
const $33a0cfbfba499043$export$53ac33307b5acee9 = ()=>({
        orderedActiveAnnotationIdList: [],
        commentsDataMap: {
            inline: {},
            general: {}
        },
        removedThreadsMap: {
            inline: {},
            general: {}
        },
        commentThreadsRemovedByOtherUsers: {},
        hasNestedComments: false,
        cacheUpdateFailed: false,
        footerCommentsLoadingState: "not_loaded"
    });
const $33a0cfbfba499043$export$e324594224ef24da = {
    setCommentsDataMap: (newCommentsDataMap)=>({ getState: getState, setState: setState })=>{
            const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = getState();
            const parentCommentThreadKeys = new Set(Object.keys(newCommentsDataMap.inline));
            // Update the loaded status of annotations based on newCommentsDataMap
            const updatedAnnotationList = orderedActiveAnnotationIdList.map((annotation)=>({
                    ...annotation,
                    isLoaded: parentCommentThreadKeys.has(annotation.threadKey)
                }));
            const hasNestedComments = (0, $3ZsvI.parseHasNestedComments)(newCommentsDataMap);
            setState({
                commentsDataMap: newCommentsDataMap,
                orderedActiveAnnotationIdList: updatedAnnotationList,
                hasNestedComments: hasNestedComments
            });
        },
    setOrderedActiveAnnotationIdList: (newCommentsList)=>({ getState: getState, setState: setState })=>{
            const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = getState();
            if (!newCommentsList || newCommentsList.length === 0) {
                // Only update state if the current list is not already empty
                if (orderedActiveAnnotationIdList.length > 0) setState({
                    orderedActiveAnnotationIdList: []
                });
                return;
            }
            // Create a map of existing annotationId to their isLoaded states for quick lookup
            const existingAnnotationsMap = new Map(orderedActiveAnnotationIdList.map(({ threadKey: threadKey, isLoaded: isLoaded })=>[
                    threadKey,
                    isLoaded
                ]));
            // Use a Set to ensure unique annotation IDs
            const uniqueCommentsSet = new Set(newCommentsList);
            // Map the unique comments set to the new state, preserving isLoaded where possible
            const updatedAnnotationList = Array.from(uniqueCommentsSet).map((threadKey)=>({
                    threadKey: threadKey,
                    isLoaded: existingAnnotationsMap.get(threadKey) ?? false
                }));
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(orderedActiveAnnotationIdList, updatedAnnotationList)) setState({
                orderedActiveAnnotationIdList: updatedAnnotationList
            });
        },
    updateReactionsSummary: (emojiId, actionType, commentId, commentType, readReactionsSummaryFragment, writeReactionsSummaryFragment, pageId, threadKey, cache)=>({ setState: setState, getState: getState })=>{
            const updateReactionsForComment = (comment, emojiId, actionType)=>{
                const { reactionsSummary: reactionsSummary } = comment;
                if (!reactionsSummary) return;
                const reactionsAri = reactionsSummary?.ari || '';
                const reactionsContainerAri = reactionsSummary?.containerAri || '';
                const reactionsNodes = reactionsSummary?.reactionsSummaryForEmoji || [];
                const updatedReactionsNodes = [
                    ...reactionsNodes
                ];
                const updatedReactionsSummary = {
                    ...reactionsSummary
                };
                if (actionType === 'add') {
                    const reaction = updatedReactionsNodes.find((item)=>item?.emojiId === emojiId);
                    // If the reaction exists and the user has not reacted, add the user and increment the count
                    if (reaction && !reaction.reacted) {
                        reaction.count++;
                        reaction.reacted = true;
                    } else if (!reaction) // If the reaction does not exist, create a new reaction
                    updatedReactionsNodes.push({
                        emojiId: emojiId,
                        count: 1,
                        reacted: true,
                        id: `${reactionsContainerAri}|${reactionsAri}|${emojiId}`
                    });
                } else if (actionType === 'delete') {
                    const reactionIdx = updatedReactionsNodes.findIndex((item)=>item?.emojiId === emojiId);
                    // If the reaction exists, update its attributes
                    if (reactionIdx !== -1) {
                        const reaction = updatedReactionsNodes[reactionIdx];
                        // If the reaction exists and the user has reacted, remove the user and decrement the count
                        if (reaction && reaction.reacted) {
                            reaction.count--;
                            reaction.reacted = false;
                        }
                        // If the reaction exists and has no reactions, remove the reaction
                        if (reaction && reaction.count <= 0) updatedReactionsNodes.splice(reactionIdx, 1);
                    }
                }
                updatedReactionsSummary.reactionsSummaryForEmoji = updatedReactionsNodes;
                updatedReactionsSummary.reactionsCount = updatedReactionsNodes.reduce((total, reaction)=>total + (reaction?.count || 0), 0);
                comment.reactionsSummary = updatedReactionsSummary;
            };
            try {
                if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) {
                    const reactionsSummaryId = `$Comment:${commentId}.reactionsSummary(${JSON.stringify({
                        childType: 'comment',
                        contentType: 'page',
                        pageId: pageId
                    })})`;
                    const reactionsSummary = readReactionsSummaryFragment({
                        id: reactionsSummaryId
                    });
                    if (reactionsSummary) {
                        const commentReactionsSummary = {
                            ...reactionsSummary
                        };
                        updateReactionsForComment(commentReactionsSummary, emojiId, actionType);
                        writeReactionsSummaryFragment({
                            fragmentId: reactionsSummaryId,
                            data: commentReactionsSummary
                        });
                    }
                    const repliesReactionsSummaryId = `$Comment:${commentId}.replies.reactionsSummary(${JSON.stringify({
                        childType: 'comment',
                        contentType: 'page',
                        pageId: pageId
                    })})`;
                    const repliesReactionsSummary = readReactionsSummaryFragment({
                        id: repliesReactionsSummaryId
                    });
                    if (repliesReactionsSummary) {
                        const updatedRepliesReactionsSummary = {
                            reactionsSummary: repliesReactionsSummary
                        };
                        updateReactionsForComment(repliesReactionsSummary, emojiId, actionType);
                        writeReactionsSummaryFragment({
                            fragmentId: repliesReactionsSummaryId,
                            data: updatedRepliesReactionsSummary
                        });
                    }
                } else {
                    const queryVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                        pageId: pageId,
                        type: commentType === "general" ? (0, $f5Wgm.CommentType).FOOTER : undefined
                    });
                    // Update the comments panel cache
                    const cacheResult = cache?.readQuery({
                        query: (0, $eg9xl.ActiveCommentsQuery),
                        variables: queryVariables
                    });
                    if (cacheResult) {
                        const updatedCacheResult = {
                            ...cacheResult
                        };
                        const commentNodes = updatedCacheResult.comments?.nodes || [];
                        const comment = commentNodes.find((node)=>commentType === "general" ? node?.id === threadKey : node?.location?.inlineMarkerRef === threadKey);
                        let reply;
                        if (comment) {
                            // If the comment IDs don't match, this is a reply, find it and use that
                            if (comment.id !== commentId) {
                                reply = comment.replies.find((r)=>r.id === commentId);
                                // If we don't find the reply after that, just return
                                if (!reply) return;
                            }
                            updateReactionsForComment(reply || comment, emojiId, actionType);
                            cache?.writeQuery({
                                query: (0, $eg9xl.ActiveCommentsQuery),
                                variables: queryVariables,
                                data: updatedCacheResult
                            });
                        }
                    }
                }
            } catch (err) {
                $33a0cfbfba499043$var$logger.error`An error occurred when updating comments panel cache - ${err}`;
            }
            // Update the comment datasource
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedMap = {
                ...commentsDataMap
            };
            if (!threadKey) return;
            const comment = updatedMap[commentType][threadKey];
            let reply;
            // If the comment doesn't exist in the map, just return
            if (!comment) return;
            // If the comment IDs don't match, this is a reply, find it and use that
            if (comment.id !== commentId) {
                reply = comment.replies.find((r)=>r.id === commentId);
                // If we don't find the reply after that, just return
                if (!reply) return;
            }
            updateReactionsForComment(reply || comment, emojiId, actionType);
            setState({
                commentsDataMap: updatedMap
            });
        },
    updateUnreadStatus: (commentUnreadUpdateMap, action)=>({ setState: setState, getState: getState })=>{
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedMap = {
                ...commentsDataMap
            };
            const updateUnreadFn = (commentType)=>([threadKey, commentIdsToMark])=>{
                    const commentData = updatedMap[commentType][threadKey];
                    if (commentData) {
                        const isParentCommentUnread = commentIdsToMark.has(commentData.id);
                        updatedMap[commentType][threadKey] = {
                            ...commentData,
                            isUnread: isParentCommentUnread ? action === 1 : commentData.isUnread,
                            replies: commentData.replies?.map((reply)=>{
                                // Update the reply's unread status if its ID is included in commentIdsToMark
                                if (commentIdsToMark.has(reply.id)) return {
                                    ...reply,
                                    isUnread: action === 1
                                };
                                return reply;
                            }),
                            wasRemovedByAnotherUser: false
                        };
                    }
                };
            // For each threadKey and their comment IDs, update the unread status in the inline commentsDataMap
            Object.entries(commentUnreadUpdateMap.inline).forEach(updateUnreadFn("inline"));
            // For each threadKey and their comment IDs, update the unread status in the general commentsDataMap
            Object.entries(commentUnreadUpdateMap.general).forEach(updateUnreadFn("general"));
            setState({
                commentsDataMap: updatedMap
            });
        },
    addNewCommentThreads: (newCommentThreads)=>({ setState: setState, getState: getState })=>{
            const { commentsDataMap: commentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, hasNestedComments: hasNestedComments } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            // Add the comment threads for inline
            for(const threadKey in newCommentThreads.inline){
                const newCommentThread = newCommentThreads.inline[threadKey];
                updatedCommentsDataMap.inline[threadKey] = newCommentThread;
            }
            // Add the comment threads for general
            for(const threadKey in newCommentThreads.general){
                const newCommentThread = newCommentThreads.general[threadKey];
                updatedCommentsDataMap.general[threadKey] = newCommentThread;
            }
            // Update the loaded status of annotations
            const updatedAnnotationList = orderedActiveAnnotationIdList.map((annotation)=>({
                    ...annotation,
                    isLoaded: Object.keys(newCommentThreads).includes(annotation.threadKey) ? true : annotation.isLoaded
                }));
            // No need to reparse if we've already found a case
            const newHasNestedComments = hasNestedComments || (0, $3ZsvI.parseHasNestedComments)(updatedCommentsDataMap);
            setState({
                commentsDataMap: updatedCommentsDataMap,
                orderedActiveAnnotationIdList: updatedAnnotationList,
                hasNestedComments: newHasNestedComments
            });
        },
    addReplyToCommentThread: (threadKey, reply, commentType)=>({ setState: setState, getState: getState })=>{
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            const parentCommentThread = updatedCommentsDataMap[commentType][threadKey];
            if (parentCommentThread) {
                // Ensure replies array exists
                const existingReplies = parentCommentThread.replies || [];
                // due to the nature of how we are sending multiple pubsub events are being sent for comment creation, we have to check for a duplicate before adding a reply
                const replyExists = existingReplies.some((existingReply)=>existingReply.id === reply.id);
                if (!replyExists) {
                    const updatedReplies = [
                        ...existingReplies,
                        reply
                    ];
                    const updatedParentCommentThread = {
                        ...parentCommentThread,
                        replies: updatedReplies
                    };
                    updatedCommentsDataMap[commentType][threadKey] = updatedParentCommentThread;
                    setState({
                        commentsDataMap: updatedCommentsDataMap
                    });
                }
            }
        },
    getCurrentCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setFooterCommentsLoadingState: (footerCommentsLoadingState)=>({ setState: setState })=>{
            setState({
                footerCommentsLoadingState: footerCommentsLoadingState
            });
        },
    updateCommentBody: (commentId, threadKey, newBodyValue, commentType, displayName = null)=>({ setState: setState, getState: getState })=>{
            // Find the comment in the map
            const { commentsDataMap: commentsDataMap } = getState();
            // Make a copy of the map so if looks like a new object in shallow comparisons and also
            // avoids mutating the original map
            const updatedMap = {
                ...commentsDataMap
            };
            // The "parentComment" is either the comment itself (if a top-level comment) or the parent of
            // the reply thread
            const parentComment = updatedMap[commentType][threadKey];
            if (parentComment) {
                // If the modified comment is a top-level comment, update the body value
                if (parentComment.id === commentId) {
                    // Make a copy of the comment and update the body value, then put it back into the map
                    const updatedComment = {
                        ...parentComment,
                        body: {
                            value: newBodyValue
                        },
                        version: {
                            ...parentComment.version,
                            by: {
                                ...parentComment.version?.by,
                                displayName: displayName
                            },
                            number: (parentComment.version?.number ?? 0) + 1,
                            when: new Date().toISOString()
                        }
                    };
                    updatedMap[commentType][threadKey] = updatedComment;
                    setState({
                        commentsDataMap: updatedMap
                    });
                } else // Else we didn't find the comment at the top-level, check the replies
                for(let replyIndex = 0; replyIndex < parentComment.replies.length; replyIndex++){
                    const reply = parentComment.replies[replyIndex];
                    if (reply.id === commentId) {
                        // Make a copy of the comment and update the reply's body value, then put it back into the map
                        const updatedReply = {
                            ...reply,
                            body: {
                                value: newBodyValue
                            },
                            version: {
                                ...reply.version,
                                by: {
                                    ...reply.version?.by,
                                    displayName: displayName
                                },
                                number: (reply.version?.number ?? 0) + 1,
                                when: new Date().toISOString()
                            }
                        };
                        // (A reminder that ... does a shallow copy, so we need to copy the replies array as well)
                        const updatedComment = {
                            ...parentComment,
                            replies: [
                                ...parentComment.replies
                            ]
                        };
                        updatedComment.replies[replyIndex] = updatedReply;
                        updatedMap[commentType][threadKey] = updatedComment;
                        setState({
                            commentsDataMap: updatedMap
                        });
                        break;
                    }
                }
            }
        },
    // keep track of removed annotations as well as update removed comments with wasRemovedByAnotherUser
    updateRemovedCommentIdsMap: ({ threadKey: threadKey, commentId: commentId, commentActionType: commentActionType, isReply: isReply, commentType: commentType, resolvedProperties: resolvedProperties })=>({ setState: setState, getState: getState })=>{
            const { commentThreadsRemovedByOtherUsers: commentThreadsRemovedByOtherUsers } = getState();
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                const { commentsDataMap: commentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, removedThreadsMap: removedThreadsMap } = getState();
                const updatedCommentsDataMap = {
                    ...commentsDataMap
                };
                const commentThread = updatedCommentsDataMap[commentType][threadKey];
                if (commentThread) {
                    if (isReply) {
                        const updatedCommentThreadReplies = commentThread.replies.map((r)=>{
                            if (r.id === commentId) return {
                                ...r,
                                wasRemovedByAnotherUser: commentActionType
                            };
                            return r;
                        });
                        updatedCommentsDataMap[commentType][threadKey] = {
                            ...commentThread,
                            replies: updatedCommentThreadReplies
                        };
                    } else if (resolvedProperties) {
                        if ((commentType === "inline" || !(0, $9wGTI.fg)('confluence_gen_comments_resolve_pubsub')) && resolvedProperties.inlineResolveProperties) updatedCommentsDataMap[commentType][threadKey] = {
                            ...commentThread,
                            location: {
                                type: 'INLINE',
                                inlineMarkerRef: threadKey,
                                inlineResolveProperties: resolvedProperties.inlineResolveProperties,
                                inlineText: resolvedProperties.inlineText || ''
                            },
                            isOpen: false,
                            wasRemovedByAnotherUser: commentActionType
                        };
                        else updatedCommentsDataMap[commentType][threadKey] = {
                            ...commentThread,
                            location: {
                                commentResolveProperties: {
                                    resolved: resolvedProperties.resolved || false,
                                    resolvedFriendlyDate: resolvedProperties.resolvedFriendlyDate || '',
                                    resolvedTime: resolvedProperties.resolvedTime || 0,
                                    resolvedUser: resolvedProperties.resolvedUser || ''
                                },
                                type: 'GENERAL'
                            },
                            isOpen: false,
                            wasRemovedByAnotherUser: commentActionType
                        };
                    } else updatedCommentsDataMap[commentType][threadKey] = {
                        ...commentThread,
                        isOpen: false,
                        wasRemovedByAnotherUser: commentActionType
                    };
                    if (commentActionType === "resolved") // mark those comments in the thread as read
                    updatedCommentsDataMap[commentType][threadKey] = {
                        ...updatedCommentsDataMap[commentType][threadKey],
                        isUnread: false,
                        replies: commentThread.replies.map((r)=>{
                            return {
                                ...r,
                                isUnread: false
                            };
                        })
                    };
                    const updatedRemovedThreadsMap = {
                        ...removedThreadsMap
                    };
                    let threadKeyId = -1;
                    if (commentType === "inline") {
                        // since orderedActiveAnnotationIdList will not include previously removed annotations, we need to add in annotations in removedThreadsMap
                        // so that we can correctly find the index of the removed annotation
                        const inlineThreadKeyList = [
                            ...orderedActiveAnnotationIdList.map((a)=>a.threadKey)
                        ];
                        Object.entries(updatedRemovedThreadsMap.inline).forEach(([index, key])=>{
                            const position = parseInt(index, 10); // Ensure the index is treated as a number
                            inlineThreadKeyList.splice(position, 0, key);
                        });
                        threadKeyId = inlineThreadKeyList.findIndex((key)=>key === threadKey);
                    } else {
                        // General comments are ordered correctly in the map by timestamp
                        const orderedGeneralThreadKeyList = Object.keys(commentsDataMap.general);
                        threadKeyId = orderedGeneralThreadKeyList.findIndex((key)=>key === threadKey);
                    }
                    if (threadKeyId !== -1) updatedRemovedThreadsMap[commentType][threadKeyId] = threadKey;
                    setState({
                        commentsDataMap: updatedCommentsDataMap,
                        removedThreadsMap: updatedRemovedThreadsMap
                    });
                }
            }
            // Update commentThreadsRemovedByOtherUsers map
            const updatedRemovedComments = {
                ...commentThreadsRemovedByOtherUsers
            };
            updatedRemovedComments[commentId] = commentActionType;
            // Internally, this will be batched with the other state updates when cc_comments_new_comments_data_manager is disabled
            setState({
                commentThreadsRemovedByOtherUsers: updatedRemovedComments
            });
        },
    handleRemovingComments: ({ threadKey: threadKey, commentId: commentId, action: action, commentType: commentType })=>({ setState: setState, getState: getState })=>{
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            const parentCommentThread = updatedCommentsDataMap[commentType][threadKey];
            if (parentCommentThread) {
                if (action === "resolved" && parentCommentThread.id === commentId) {
                    // If the action is to resolve the thread and the commentId matches the parent, remove the thread
                    delete updatedCommentsDataMap[commentType][threadKey];
                    setState({
                        commentsDataMap: updatedCommentsDataMap
                    });
                } else if (action === "deleted") {
                    // If the action is to delete a reply, filter out the reply with the specified commentId
                    const updatedReplies = parentCommentThread.replies.filter((reply)=>reply.id !== commentId);
                    updatedCommentsDataMap[commentType][threadKey] = {
                        ...parentCommentThread,
                        replies: updatedReplies
                    };
                    // Update the parent comment thread with the filtered replies
                    setState({
                        commentsDataMap: updatedCommentsDataMap
                    });
                }
            }
        },
    resolveParentComment: ({ threadKey: threadKey, commentType: commentType })=>({ setState: setState, getState: getState })=>{
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            const parentCommentThread = updatedCommentsDataMap[commentType][threadKey];
            if (parentCommentThread) {
                parentCommentThread.isOpen = false;
                setState({
                    commentsDataMap: updatedCommentsDataMap
                });
            }
        },
    reopenParentComment: ({ threadKey: threadKey, commentType: commentType })=>({ setState: setState, getState: getState })=>{
            const { commentsDataMap: commentsDataMap, commentThreadsRemovedByOtherUsers: commentThreadsRemovedByOtherUsers } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            const parentCommentThread = updatedCommentsDataMap[commentType][threadKey];
            if (parentCommentThread) {
                parentCommentThread.isOpen = true;
                // Remove from commentThreadsRemovedByOtherUsers when reopened
                const updatedRemovedComments = {
                    ...commentThreadsRemovedByOtherUsers
                };
                delete updatedRemovedComments[parentCommentThread.id];
                setState({
                    commentsDataMap: updatedCommentsDataMap,
                    commentThreadsRemovedByOtherUsers: updatedRemovedComments
                });
            }
        },
    deleteParentComment: ({ threadKey: threadKey, commentType: commentType })=>({ setState: setState, getState: getState })=>{
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            const parentCommentThread = updatedCommentsDataMap[commentType][threadKey];
            if (parentCommentThread) {
                delete updatedCommentsDataMap[commentType][threadKey];
                setState({
                    commentsDataMap: updatedCommentsDataMap
                });
            }
        },
    clearRemovedComments: ()=>({ getState: getState, setState: setState })=>{
            const { commentsDataMap: commentsDataMap } = getState();
            const commentsDataMapCopy = {
                ...commentsDataMap
            };
            // Filter out deleted / resolved comments for the legacy comments data map
            const updatedInlineCommentsDataMap = Object.fromEntries(Object.entries(commentsDataMapCopy.inline).filter(([_, commentData])=>!commentData.wasRemovedByAnotherUser).map(([key, commentData])=>[
                    key,
                    {
                        ...commentData,
                        replies: (commentData.replies || []).filter((reply)=>!reply.wasRemovedByAnotherUser)
                    }
                ]));
            const updatedGeneralCommentsDataMap = Object.fromEntries(Object.entries(commentsDataMapCopy.general).filter(([_, commentData])=>!commentData.wasRemovedByAnotherUser).map(([key, commentData])=>[
                    key,
                    {
                        ...commentData,
                        replies: (commentData.replies || []).filter((reply)=>!reply.wasRemovedByAnotherUser)
                    }
                ]));
            setState({
                removedThreadsMap: {
                    inline: {},
                    general: {}
                },
                commentThreadsRemovedByOtherUsers: {},
                commentsDataMap: {
                    inline: updatedInlineCommentsDataMap,
                    general: updatedGeneralCommentsDataMap
                }
            });
        },
    clearCommentsData: ()=>({ setState: setState })=>{
            setState($33a0cfbfba499043$export$53ac33307b5acee9());
        },
    setCacheUpdateFailed: (failed)=>({ setState: setState })=>{
            setState({
                cacheUpdateFailed: failed
            });
        }
};
const $33a0cfbfba499043$export$13b7c646235a7fd4 = (0, $1P1Tu.createStore)({
    initialState: $33a0cfbfba499043$export$53ac33307b5acee9(),
    actions: $33a0cfbfba499043$export$e324594224ef24da,
    name: 'CommentsDataStore'
});
const $33a0cfbfba499043$export$80f09eb388fa70f9 = (0, $9zUhf.createHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
const $33a0cfbfba499043$export$b5e3986841a4e13f = (0, $9zUhf.createActionsHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
const $33a0cfbfba499043$export$c14a8182bd597724 = (0, $9zUhf.createStateHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
module.exports["CommentType"] = $33a0cfbfba499043$export$ffa1150e6a48f9cd;
module.exports["UnreadAction"] = $33a0cfbfba499043$export$e539ce02135a18ae;
module.exports["CommentActionType"] = $33a0cfbfba499043$export$74159dff405238c0;
module.exports["FooterCommentsLoadingStateType"] = $33a0cfbfba499043$export$2021eb0669e47276;
module.exports["useCommentsData"] = $33a0cfbfba499043$export$80f09eb388fa70f9;
module.exports["useCommentsDataActions"] = $33a0cfbfba499043$export$b5e3986841a4e13f;
module.exports["useCommentsDataState"] = $33a0cfbfba499043$export$c14a8182bd597724;

});

parcelRegister("9rE3H", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $f5Wgm = parcelRequire("f5Wgm");

const $5b808dc3cc2fdcb5$export$3816ffab97d6707 = 3;
const $5b808dc3cc2fdcb5$export$210268213d223b14 = 0;
const $5b808dc3cc2fdcb5$export$c2458e66b06ab105 = -1; // We can't do cache.evict based on apollo version, so use -1 as a flag
const $5b808dc3cc2fdcb5$export$8b7f986ffbf7a476 = 2000;
const $5b808dc3cc2fdcb5$export$5d8fdefd80b8eaa1 = 1000;
const $5b808dc3cc2fdcb5$export$ed108990552755bd = 250;
const $5b808dc3cc2fdcb5$export$37f798be419840d9 = (contentId, isArchived)=>{
    return {
        pageId: contentId,
        contentStatus: [
            isArchived ? 'ARCHIVED' : 'CURRENT',
            'DRAFT'
        ],
        type: [
            (0, $f5Wgm.CommentType).FOOTER
        ],
        first: (0, $9wGTI.fg)('confluence_frontend_always_ssr_footer_comments') ? $5b808dc3cc2fdcb5$export$3816ffab97d6707 : $5b808dc3cc2fdcb5$export$210268213d223b14
    };
};
const $5b808dc3cc2fdcb5$export$aebda4267d7ff0ef = ({ pageId: pageId, type: type, isArchived: isArchived = false })=>{
    let firstCount = $5b808dc3cc2fdcb5$export$ed108990552755bd;
    if ((0, $9wGTI.fg)('confluence_frontend_comments_1k_batch_size')) firstCount = $5b808dc3cc2fdcb5$export$5d8fdefd80b8eaa1;
    // This feature gate should override the one above
    if ((0, $9wGTI.fg)('confluence_frontend_always_ssr_footer_comments')) firstCount = $5b808dc3cc2fdcb5$export$8b7f986ffbf7a476;
    return {
        pageId: pageId,
        contentStatus: [
            isArchived ? 'ARCHIVED' : 'CURRENT',
            'DRAFT'
        ],
        first: firstCount,
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        ...(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && type && {
            type: [
                type
            ]
        }
    };
};
module.exports["ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG"] = $5b808dc3cc2fdcb5$export$c2458e66b06ab105;
module.exports["buildConsistentActiveCommentsQueryPreloadVariables"] = $5b808dc3cc2fdcb5$export$37f798be419840d9;
module.exports["buildConsistentActiveCommentsQueryVariables"] = $5b808dc3cc2fdcb5$export$aebda4267d7ff0ef;

});

parcelRegister("f5Wgm", function(module, exports) {
/**
 * @generated SignedSource<<51774defd383cfbd4d4fa005398e207b>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $533e03080cab577e$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["FOOTER"] = "FOOTER";
    CommentType["INLINE"] = "INLINE";
    CommentType["RESOLVED"] = "RESOLVED";
    CommentType["UNRESOLVED"] = "UNRESOLVED";
    return CommentType;
}({});
var $533e03080cab577e$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
var $533e03080cab577e$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["CommentType"] = $533e03080cab577e$export$ffa1150e6a48f9cd;

});

parcelRegister("eg9xl", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $2f8045f4499bf3be$export$a7a48376ff44e870 = (0, $eSUdr.default)`query ActiveCommentsQuery($pageId:ID!$contentStatus:[GraphQLContentStatus]$type:[CommentType]$first:Long)@allowHigherTimeout{comments(pageId:$pageId contentStatus:$contentStatus depth:ROOT confluenceCommentFilter:{commentState:UNRESOLVED commentType:$type}singleThreaded:true type:$type first:$first){nodes{id author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}replies{id author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}totalCount}}`;
module.exports["ActiveCommentsQuery"] = $2f8045f4499bf3be$export$a7a48376ff44e870;

});

parcelRegister("3ZsvI", function(module, exports) {

var $2GXr2 = parcelRequire("2GXr2");


var $cD1qu = parcelRequire("cD1qu");


var $9wGTI = parcelRequire("9wGTI");


var $8i27m = parcelRequire("8i27m");

const $d2d2318c0a6737a0$export$c616a7cf09d59df6 = ({ comment: comment, readCommentsListState: readCommentsListState, currentUserId: currentUserId, annotationsInEditorDoc: annotationsInEditorDoc, pageMode: pageMode, isOpen: isOpen, type: type })=>{
    const isUnread = Boolean(// NOTE: we no longer use this isUnread field when fg('confluence_frontend_unread_comments_fixes') is enabled
    (0, $2GXr2.isValidUnreadComment)({
        comment: comment,
        viewedComments: readCommentsListState,
        userId: currentUserId,
        annotationsInEditorDoc: annotationsInEditorDoc,
        pageMode: pageMode
    }));
    return {
        ...comment,
        isUnread: isUnread,
        wasRemovedByAnotherUser: false,
        isOpen: isOpen,
        type: type,
        replies: comment.replies?.map((reply)=>{
            if (!reply.reactionsSummary) reply.reactionsSummary = null;
            const isReplyUnread = Boolean(// NOTE: we no longer use this isUnread field when fg('confluence_frontend_unread_comments_fixes') is enabled
            (0, $2GXr2.isValidUnreadComment)({
                comment: reply,
                viewedComments: readCommentsListState,
                userId: currentUserId,
                annotationsInEditorDoc: annotationsInEditorDoc,
                pageMode: pageMode
            }));
            return {
                ...reply,
                type: type,
                isUnread: isReplyUnread,
                wasRemovedByAnotherUser: false
            };
        })
    };
};
const $d2d2318c0a6737a0$export$e8d1c15bdf6a3ce8 = ({ data: data, readCommentsListState: readCommentsListState, annotationsInEditorDoc: annotationsInEditorDoc, pageMode: pageMode, currentUserId: currentUserId, updateData: updateData, isOpen: isOpen = true })=>{
    const inlineCommentThreadsToAdd = {};
    const generalCommentThreadsToAdd = {};
    const loadFooterComments = (0, $9wGTI.fg)('confluence_comment_footercomments_editpage') ? pageMode !== (0, $cD1qu.PageMode).EDIT : true;
    data?.comments?.nodes?.forEach((comment)=>{
        // We only want top level comments
        if (comment && !comment.parentId) {
            if (!comment.reactionsSummary) comment.reactionsSummary = null;
            if (comment.contentStatus === (0, $cD1qu.ContentStatus).DRAFT && pageMode === (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
            const commentType = comment.location.type;
            if (commentType === 'INLINE') {
                const threadKey = comment.location.inlineMarkerRef;
                if (threadKey) inlineCommentThreadsToAdd[threadKey] = $d2d2318c0a6737a0$export$c616a7cf09d59df6({
                    comment: comment,
                    readCommentsListState: readCommentsListState,
                    currentUserId: currentUserId,
                    annotationsInEditorDoc: annotationsInEditorDoc,
                    pageMode: pageMode,
                    isOpen: isOpen,
                    type: (0, $8i27m.CommentType).INLINE
                });
            } else if (commentType === 'FOOTER' && loadFooterComments) {
                const threadKey = comment.id;
                generalCommentThreadsToAdd[threadKey] = $d2d2318c0a6737a0$export$c616a7cf09d59df6({
                    comment: comment,
                    readCommentsListState: readCommentsListState,
                    currentUserId: currentUserId,
                    pageMode: pageMode,
                    isOpen: isOpen,
                    type: (0, $8i27m.CommentType).GENERAL
                });
            }
        }
    });
    updateData({
        inline: inlineCommentThreadsToAdd,
        general: generalCommentThreadsToAdd
    });
};
const $d2d2318c0a6737a0$export$6036c2c532b2fa41 = (commentsDataMap)=>{
    try {
        const allGeneralComments = Object.values(commentsDataMap.general);
        // To see if there are nested comments, we need to check whether there are any replies whose parentID is not equal to the parent Comment's ID
        // This is because commentsDataMap.general is a flat map of parent comment --> everything below it
        // But each comment has it's own parent id which may be different from it's top level parent
        return allGeneralComments.some((comment)=>{
            return comment?.replies?.some((reply)=>reply.parentId !== comment.id);
        });
    } catch  {
        // Default to false if somehow something goes wrong
        return false;
    }
};
const $d2d2318c0a6737a0$export$f60efc56f0412906 = (activeCommentsQueryResult, updateFn)=>{
    // This should only ever be called with data - however if it isn't we should update state to NOT_LOADED
    if (activeCommentsQueryResult?.comments?.totalCount === undefined) {
        updateFn((0, $8i27m.FooterCommentsLoadingStateType).NOT_LOADED);
        return;
    }
    const loadedCommentCount = activeCommentsQueryResult?.comments?.nodes?.reduce((acc, comment)=>{
        return acc + (comment?.replies?.length || 0) + 1; // return parent + reply count
    }, 0) ?? 0;
    // The BE sometimes will give us mismatched numbers for complex nested scenarios, as long as > 0 call it good
    // With the FG off this prevents rendering, so add a special case
    // With the FG on it renders properly, but load experience may fail to close
    // This case is super rare (should be <<1% of pages), but if it significantly affects metrics will need another special case
    const allLoaded = loadedCommentCount === activeCommentsQueryResult?.comments?.totalCount || !(0, $9wGTI.fg)('confluence_frontend_always_ssr_footer_comments') && loadedCommentCount > 0;
    if (allLoaded) updateFn((0, $8i27m.FooterCommentsLoadingStateType).FULLY_LOADED);
    else if ((0, $9wGTI.fg)('confluence_frontend_always_ssr_footer_comments')) // partial load is only possible under this flag
    updateFn((0, $8i27m.FooterCommentsLoadingStateType).PARTIALLY_LOADED);
    else // If not partial or full, most be not loaded
    updateFn((0, $8i27m.FooterCommentsLoadingStateType).NOT_LOADED);
};
const $d2d2318c0a6737a0$export$74e9552da989b708 = (commentsDataMap, commentId)=>{
    // Check if our ID is one of the parent comments, if so return the parent comment
    const findParent = Object.values(commentsDataMap.general).find((comment)=>comment.id === commentId || comment.replies?.some((reply)=>reply.id === commentId));
    if (!findParent) return null;
    if (findParent?.id === commentId) return findParent;
    else return findParent.replies?.find((reply)=>reply.id === commentId);
};
const $d2d2318c0a6737a0$export$92c95f9748a31706 = (commentsDataMap, commentId)=>{
    return Object.values(commentsDataMap.general).find((comment)=>comment.id === commentId || comment.replies?.some((reply)=>reply.id === commentId));
};
module.exports["normalizeCommentData"] = $d2d2318c0a6737a0$export$c616a7cf09d59df6;
module.exports["updateCommentsDataState"] = $d2d2318c0a6737a0$export$e8d1c15bdf6a3ce8;
module.exports["parseHasNestedComments"] = $d2d2318c0a6737a0$export$6036c2c532b2fa41;
module.exports["updateFooterCommentsLoadingState"] = $d2d2318c0a6737a0$export$f60efc56f0412906;

});

parcelRegister("2GXr2", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $kaMMU = parcelRequire("kaMMU");

var $b5cd25b4c801c790$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
const $b5cd25b4c801c790$export$22ce26f7ba09f326 = ({ comment: comment, viewedComments: viewedComments, userId: userId, annotationsInEditorDoc: annotationsInEditorDoc, pageMode: pageMode = 'view' })=>{
    const isUnread = !viewedComments.has(comment.id);
    const commentLocation = comment?.location;
    const isUnresolved = !commentLocation?.inlineResolveProperties?.resolved;
    const isNotOwnComment = 'accountId' in comment.author && comment.author?.accountId !== userId;
    const createdLast30Days = new Date(comment.createdAt?.value) > new Date(Date.now() - 2592000000);
    const markerRefExists = commentLocation?.inlineMarkerRef;
    const isAnnotationInDoc = pageMode === 'edit' ? markerRefExists && annotationsInEditorDoc?.has(markerRefExists) : true;
    const isGeneralComment = comment?.location.type === 'FOOTER';
    return isUnread && isUnresolved && isNotOwnComment && createdLast30Days && (isGeneralComment || markerRefExists && isAnnotationInDoc);
};
const $b5cd25b4c801c790$export$db3977bdc028a0eb = async ({ allComments: allComments, updateUnreadCommentsListState: updateUnreadCommentsListState, userId: userId, pageId: pageId, updateReadCommentsListState: updateReadCommentsListState, updateThreadKeyToCommentIdMap: updateThreadKeyToCommentIdMap, resetStates: resetStates, pageMode: pageMode = 'view', annotationsInEditorDoc: annotationsInEditorDoc })=>{
    const hasUnresolvedComments = allComments && allComments.some((comment)=>!comment?.location?.inlineResolveProperties?.resolved);
    if (hasUnresolvedComments && pageId) try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const data = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $kaMMU.ContentAnalyticsViewedComments),
            variables: {
                contentId: pageId
            },
            fetchPolicy: 'network-only'
        });
        const viewedComments = new Set(data?.data?.contentAnalyticsViewedComments?.commentIds);
        updateReadCommentsListState(()=>viewedComments);
        const unreadComments = [];
        const threadKeyMap = {};
        allComments.forEach((comment)=>{
            if (!comment) return;
            const commentType = comment.location.type === 'INLINE' ? "inline" : "general";
            const threadKey = commentType === "inline" ? comment.location?.inlineMarkerRef : comment.id;
            if (userId && threadKey) {
                if ($b5cd25b4c801c790$export$22ce26f7ba09f326({
                    comment: comment,
                    viewedComments: viewedComments,
                    userId: userId,
                    annotationsInEditorDoc: annotationsInEditorDoc,
                    pageMode: pageMode
                })) unreadComments.push({
                    id: comment.id,
                    threadKey: threadKey ?? '',
                    commentType: commentType
                });
                if (comment.replies) comment.replies.forEach((reply)=>{
                    if (reply) {
                        if ($b5cd25b4c801c790$export$22ce26f7ba09f326({
                            comment: reply,
                            viewedComments: viewedComments,
                            userId: userId,
                            annotationsInEditorDoc: annotationsInEditorDoc,
                            pageMode: pageMode
                        })) unreadComments.push({
                            id: reply.id,
                            threadKey: threadKey ?? '',
                            commentType: commentType
                        });
                        if (!threadKeyMap[threadKey]) threadKeyMap[threadKey] = new Set([
                            reply.id
                        ]);
                        else if (threadKeyMap[threadKey]) threadKeyMap[threadKey].add(reply.id);
                    }
                });
            }
        });
        updateThreadKeyToCommentIdMap((prevState)=>{
            const mergedThreadKeyMap = {
                ...prevState
            };
            Object.keys(threadKeyMap).forEach((key)=>{
                if (!mergedThreadKeyMap[key]) mergedThreadKeyMap[key] = threadKeyMap[key];
                else mergedThreadKeyMap[key] = new Set([
                    ...mergedThreadKeyMap[key],
                    ...threadKeyMap[key]
                ]);
            });
            return mergedThreadKeyMap;
        });
        updateUnreadCommentsListState(()=>unreadComments);
        // Once we are done updating the unread list, need to reset the states.
        resetStates();
    } catch  {
        // We don't want to show any unread count in the comment button if there's an error
        resetStates();
    }
};
module.exports["isValidUnreadComment"] = $b5cd25b4c801c790$export$22ce26f7ba09f326;
module.exports["createUnreadCommentList"] = $b5cd25b4c801c790$export$db3977bdc028a0eb;

});

parcelRegister("kaMMU", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $4e57d0e413ebf71f$export$c9ba123bc30c20b6 = (0, $eSUdr.default)`query ContentAnalyticsViewedComments($contentId:ID!){contentAnalyticsViewedComments(contentId:$contentId){commentIds}}`;
module.exports["ContentAnalyticsViewedComments"] = $4e57d0e413ebf71f$export$c9ba123bc30c20b6;

});

parcelRegister("6faGq", function(module, exports) {

var $3ejfs = parcelRequire("3ejfs");


var $3iaSn = parcelRequire("3iaSn");

const $fd14f0f09d6b2a27$export$48c62524de3612b3 = (dateString)=>{
    if (!dateString) return new Date(0); // Return earliest possible date if missing
    // Ensure UTC timezone. Some createdAt values are missing the UTC timezone identifier, and some have it
    const normalizedDate = dateString.endsWith('Z') ? dateString : `${dateString}Z`;
    // Try to parse the date, return earliest date if invalid
    const parsed = new Date(normalizedDate);
    return isNaN(parsed.getTime()) ? new Date(0) : parsed;
};

const $fd14f0f09d6b2a27$export$63880caa66d80fb9 = ({ intl: intl, dateString: dateString, commentStatus: commentStatus = (0, $3iaSn.CommentStatus).OPEN, resolveProperties: resolveProperties, isReply: isReply = false })=>{
    if (!dateString) return '';
    // Get formatted timestamp
    let timestamp;
    try {
        const { formatTimeAgo: formatTimeAgo } = (parcelRequire("1JmNR"));
        timestamp = formatTimeAgo(intl, $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString));
    } catch (error) {
        // Fallback to a simple date format if formatTimeAgo is not available
        const date = $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString);
        timestamp = date.toLocaleDateString(intl.locale);
    }
    // For replies, just return the timestamp without comment status
    if (isReply) return timestamp;
    // Format based on comment status
    switch(commentStatus){
        case (0, $3iaSn.CommentStatus).RESOLVED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                friendlyDate: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).REOPENED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
                createdAtNonLocalized: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).OPEN:
        default:
            return intl.formatMessage((0, $3ejfs.commentsi18n).createdTimestamp, {
                timestamp: timestamp
            });
    }
};
module.exports["getValidDate"] = $fd14f0f09d6b2a27$export$48c62524de3612b3;
module.exports["formatTimestampForAriaLabel"] = $fd14f0f09d6b2a27$export$63880caa66d80fb9;

});

parcelRegister("3ejfs", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $d1e9edb9f1563526$export$454b2229580969d0 = (0, $cgtv4.defineMessages)({
    resolvedByInfoText: {
        id: "comments-util.resolved.by.info.text",
        defaultMessage: "Resolved by {username} {friendlyDate}"
    },
    reopenedByTooltipTextCommentsPanel: {
        id: "comments-util.reopened.by.tooltip.text.comments.panel",
        defaultMessage: "Added {createdAtNonLocalized}, reopened by {username}"
    },
    createdTimestamp: {
        id: "comments-util.timestamp.created",
        defaultMessage: "created {timestamp}"
    },
    resolvedDateInfoText: {
        id: "comments-util.resolved.date.info.text",
        defaultMessage: "Resolved {friendlyDate}"
    },
    reopenedDateInfoText: {
        id: "comments-util.reopened.date.info.text",
        defaultMessage: "Reopened {friendlyDate}"
    },
    generalCommentTooltip: {
        id: "comments-util.view.tooltip.general.comment",
        defaultMessage: "General comment"
    },
    anonymous: {
        id: "comments-util.display.name.anonymous",
        defaultMessage: "Anonymous"
    },
    editedBy: {
        id: "comments-util.edited.by",
        defaultMessage: "Edited by {username} {at}"
    },
    edited: {
        id: "comments-util.edited",
        defaultMessage: "Edited"
    },
    resolvedByTooltipTextCommentsPanel: {
        id: "comments-util.resolved.by.tooltip.text.comments.panel",
        defaultMessage: "By {username}"
    }
});
module.exports["commentsi18n"] = $d1e9edb9f1563526$export$454b2229580969d0;

});

parcelRegister("3iaSn", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $c6395b80aeb36ecd$export$4f1057b172870e9c = /*#__PURE__*/ function(CommentStatus) {
    CommentStatus["OPEN"] = "OPEN";
    CommentStatus["RESOLVED"] = "RESOLVED";
    CommentStatus["REOPENED"] = "REOPENED";
    return CommentStatus;
}({});
const $c6395b80aeb36ecd$export$eac30d30628b994a = ({ resolveProperties: resolveProperties })=>{
    return (0, $42omo.useMemo)(()=>{
        // If no resolve properties, the comment is open
        if (!resolveProperties) return "OPEN";
        // If resolved is false, the comment is reopened
        if (!resolveProperties.resolved) return "REOPENED";
        return "RESOLVED";
    }, [
        resolveProperties
    ]);
};
module.exports["CommentStatus"] = $c6395b80aeb36ecd$export$4f1057b172870e9c;
module.exports["useGetCommentStatus"] = $c6395b80aeb36ecd$export$eac30d30628b994a;

});

parcelRegister("1JmNR", function(module, exports) {
$parcel$export(module.exports, "formatTimeAgo", () => (parcelRequire("1YXTQ")).formatTimeAgo);
$parcel$export(module.exports, "TimeAgo", () => (parcelRequire("1YXTQ")).TimeAgo);
$parcel$export(module.exports, "StaticTimeAgo", () => (parcelRequire("1YXTQ")).StaticTimeAgo);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $1YXTQ = parcelRequire("1YXTQ");


});

parcelRegister("3mVfX", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        commentsMarkedAsRead: {
            inline: {},
            general: {}
        },
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType)=>({ setState: setState })=>{
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType
            });
        },
    setCommentsInThreadToBeMarkedAsRead: ({ threadKey: threadKey, commentIds: commentIds, commentType: commentType })=>({ setState: setState, getState: getState })=>{
            const { commentsMarkedAsRead: commentsMarkedAsRead } = getState();
            if (threadKey && commentIds) {
                // Add the new comment IDs to the existing set for the specific parent
                const updatedCommentIds = {
                    ...commentsMarkedAsRead
                };
                const existingIdsSet = updatedCommentIds[commentType][threadKey] || new Set();
                commentIds.forEach((id)=>existingIdsSet.add(id));
                // Update the map with the new set of IDs
                updatedCommentIds[commentType][threadKey] = existingIdsSet;
                setState({
                    commentsMarkedAsRead: updatedCommentIds
                });
            }
        },
    setCommentsToBeMarkedAsRead: (commentsMarkedAsRead)=>({ setState: setState })=>{
            setState({
                commentsMarkedAsRead: commentsMarkedAsRead
            });
        },
    clearCommentsMarkedAsRead: ()=>({ setState: setState })=>{
            setState({
                commentsMarkedAsRead: {
                    inline: {},
                    general: {}
                }
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $1P1Tu.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $9zUhf.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $9zUhf.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $9zUhf.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("7B9wr", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $1ggpj = parcelRequire("1ggpj");

const $e0dcf0245d0f4db8$export$8ee67841592dfd9f = ()=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    return contentType !== (0, $1ggpj.ContentType).DATABASE && contentType !== (0, $1ggpj.ContentType).WHITEBOARD && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux');
};
module.exports["useIsNewDanglingCommentExperienceEnabled"] = $e0dcf0245d0f4db8$export$8ee67841592dfd9f;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE
};
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("5fMeR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $21K7m = parcelRequire("21K7m");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2eC70 = parcelRequire("2eC70");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $9buj5 = parcelRequire("9buj5");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("31cJ9"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("67Tpc"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("468Lh"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("6zTnr"))).CommentsPanelWrapper
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    }
});
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const { handleMarkCommentsAsRead: handleMarkCommentsAsRead } = (0, $9buj5.useUnreadPanelComments)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const [shouldClearUnreads, setShouldClearUnreads] = (0, $42omo.useState)(false);
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $42omo.useRef)(hasContentChanged);
    (0, $42omo.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    // Required to invoke handleMarkCommentsAsRead and if any commentsMarkedAsRead
    // then we will call the MarkCommentsReadMutation Mutation
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        if (shouldClearUnreads) handleMarkCommentsAsRead();
        return ()=>{
            setShouldClearUnreads(false);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldClearUnreads,
        setShouldClearUnreads
    ]);
    const onPanelCloseFunction = ()=>{
        setCurrentView(undefined);
        setShouldClearUnreads(true);
        // Unselect active annotations on the page
        if (pageMode === (0, $cD1qu.PageMode).VIEW) {
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            setViewProps(null);
        } else {
            eventEmitter.emit('setselectedannotation', '');
            setEditorViewProps(null);
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        if ((0, $6mKj3.expValEquals)('confluence_comments_5766_bugfix', 'isEnabled', true)) setReplyToCommentId();
    };
    const onPanelCloseCallback = (0, $42omo.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        setShouldClearUnreads,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId
    ]);
    const onPanelClose = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? onPanelCloseCallback : onPanelCloseFunction;
    const canClosePanel = (0, $42omo.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                openWithView: openWithView,
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = (0, $9wGTI.fg)('confluence_comment_footercomments_editpage') ? pageMode !== (0, $cD1qu.PageMode).EDIT : true;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon : undefined,
                headerLabel: $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? $3b7f940e5fdc8097$var$CommentsPanelFilterMenu : undefined
            },
            BodyComponent: ()=>$3b7f940e5fdc8097$var$CommentsPanelWrapper({
                    openWithView: openWithView
                }),
            FooterComponent: canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            }
        }, 'push');
    };
    const showCommentsPanelHandler = (0, $42omo.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isSpaceOverviewPage,
        isWhiteboardView,
        onPanelClose,
        pageMode,
        showObjectSidebar
    ]);
    const showCommentsPanel = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? showCommentsPanelHandler : showCommentsPanelFunction;
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("7aw3q", function(module, exports) {

var $1iSzD = parcelRequire("1iSzD");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("9bL1w", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $9VQUw.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    if (isTemplateBrowserEnabled) allowedEllipsisButtons.push("template-browser");
    const isSpacePickerDisabled = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'] ?? false;
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: isTemplateBrowserEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        loomExternalOpenRoute: loomExternalOpenRoute
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("hpNab", function(module, exports) {

var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");

var $cfa17a27dec34885$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $cfa17a27dec34885$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        'template-browser',
        'inline-comments',
        'disable-publish-close-buttons',
        'loom-external-open'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$var$pageAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$blogPostAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$whiteboardAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard
};
const $cfa17a27dec34885$var$contentTypeAllowedFeatures = {
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $cfa17a27dec34885$var$pageAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $cfa17a27dec34885$var$blogPostAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $cfa17a27dec34885$var$whiteboardAllowedFeatures
};
const $cfa17a27dec34885$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$cfa17a27dec34885$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $cfa17a27dec34885$export$3207c60940c4a9b0;

});

parcelRegister("9tQM5", function(module, exports) {
var $5b5865fbd831eb6d$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $5b5865fbd831eb6d$export$942a5fac9b8c9dc2;

});

parcelRegister("kFwgS", function(module, exports) {
var $b38de1a13d5a6bb8$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $b38de1a13d5a6bb8$export$816ef638e478449a;

});

parcelRegister("9VQUw", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

const $4ea72974304e25a5$export$1acbaeb6a9a6bc40 = (0, $hpNab.ALLOWED_FEATURES).view;
const $4ea72974304e25a5$export$2c7469b01e61fde2 = (0, $hpNab.ALLOWED_FEATURES).edit;
const $4ea72974304e25a5$export$72afc086e90eb0bf = (0, $hpNab.ALLOWED_FEATURES).whiteboard;
module.exports["VIEW_PAGE_FEATURES"] = $4ea72974304e25a5$export$1acbaeb6a9a6bc40;
module.exports["EDIT_PAGE_FEATURES"] = $4ea72974304e25a5$export$2c7469b01e61fde2;
module.exports["WHITEBOARD_FEATURES"] = $4ea72974304e25a5$export$72afc086e90eb0bf;

});

parcelRegister("gyiJY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iV5Ic = parcelRequire("iV5Ic");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

const $b2e9e223d7519ab7$var$QUERY_NAME = 'initialAllowedFeatures';
var $b2e9e223d7519ab7$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $b2e9e223d7519ab7$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $42omo.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $b2e9e223d7519ab7$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $42omo.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    // Ensure the return type matches UseAllowedFeaturesType<T>
    if (!allowedFeatures && initialAllowedFeatures !== undefined) return initialAllowedFeatures;
    return allowedFeatures;
}
module.exports["useAllowedFeatures"] = $b2e9e223d7519ab7$export$745a9b66a8f1814a;

});

parcelRegister("cxu5H", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $gyiJY = parcelRequire("gyiJY");

const { view: $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
const $9b72a1c744147957$export$f9f73b7eca94463f = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)();
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-share" out of allowedViewPageFeatures,
	 * so that the Share button won't be disable when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-share',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ];
    const allowedViewPageFeatures = allowedFeatures === 'all' ? (0, $9VQUw.VIEW_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const showShare = !(allowedViewPageFeatures?.includes('disable-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-share'));
    return {
        showShare: showShare,
        hasByLineContributors: allowedViewPageFeatures?.includes('byline-contributors') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-contributors'),
        hasByLineExtensions: allowedViewPageFeatures?.includes('byline-extensions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-extensions'),
        hasPageReactions: allowedViewPageFeatures?.includes('page-reactions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-reactions'),
        hasStickyHeader: allowedViewPageFeatures?.includes('sticky-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('sticky-header'),
        showEdit: allowedViewPageFeatures?.includes('edit') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('edit'),
        showDelete: allowedViewPageFeatures?.includes('delete') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('delete'),
        hasComments: allowedViewPageFeatures?.includes('page-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-comments'),
        hasInlineCommentsAndHighlightActions: allowedViewPageFeatures?.includes('inline-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('inline-comments'),
        includeNonLicensedUsersToShare: showShare && (allowedViewPageFeatures?.includes('non-licensed-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('non-licensed-share')),
        hasModernHeader: allowedViewPageFeatures?.includes('modern-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('modern-header'),
        hideHelpButton: allowedViewPageFeatures?.includes('disable-help-button') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-help-button'),
        hideTitleToolbar: allowedViewPageFeatures?.includes('disable-title-toolbar') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-title-toolbar'),
        loomExternalOpenRoute: allowedViewPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route
    };
};
module.exports["useEmbeddedViewPageFeatures"] = $9b72a1c744147957$export$f9f73b7eca94463f;

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            setState({
                panelWidth: Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97) + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $42omo.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("4BDAe", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $bbe4d3361c67916e$var$noop = (props)=>{};
const $bbe4d3361c67916e$export$5f5debba1692bf40 = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) return {
        open: $bbe4d3361c67916e$var$noop,
        close: $bbe4d3361c67916e$var$noop,
        setPanelWidth: $bbe4d3361c67916e$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bbe4d3361c67916e$export$5f5debba1692bf40;

});

parcelRegister("fN3iy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7FN4e = parcelRequire("7FN4e");


var $D92g9 = parcelRequire("D92g9");

const $1ec08acbc7c3653d$var$noop = (props)=>{};
const $1ec08acbc7c3653d$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $1ec08acbc7c3653d$var$noop,
    onClose: $1ec08acbc7c3653d$var$noop
};
const $1ec08acbc7c3653d$export$f473d225913e225d = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $1ec08acbc7c3653d$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $1ec08acbc7c3653d$var$noop,
                onClose: $1ec08acbc7c3653d$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
				When opening a new preview panel, if the current panel is of the same type we don't
				want to close the panel, but rather swap out the content. If the panel types don't match
				we close the current panel and open the new one.
				ex: A Goals panel is already open, and user tries to open a different Goals panel.
				Parent Products must pass their preview panel close functions to the Preview Panel provider
				via the `onPreviewPanelClose` prop.
			*/ if (state.panel && !(0, $D92g9.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $1ec08acbc7c3653d$var$initialState.onOpen,
                onClose: params.onClose || $1ec08acbc7c3653d$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $1ec08acbc7c3653d$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)();
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, {
        ...$1ec08acbc7c3653d$var$initialState,
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $42omo.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $42omo.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $42omo.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $42omo.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
const $1ec08acbc7c3653d$export$609db4be92d0fad8 = ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $1ec08acbc7c3653d$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $1ec08acbc7c3653d$export$609db4be92d0fad8;

});

parcelRegister("7FN4e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $awbqn = parcelRequire("awbqn");

const $426c7353872dcab1$export$82b270f291af5a5 = ()=>{
    const [defaultWidth, setDefaultWidth] = (0, $42omo.useState)((0, $awbqn.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $42omo.useState)(defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $42omo.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $42omo.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $42omo.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $42omo.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $42omo.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $awbqn.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $426c7353872dcab1$export$82b270f291af5a5;

});

parcelRegister("awbqn", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");

const $9ee4137247832c84$var$getExperimentValue = (0, $c6GJD.default).getExperimentValue;
const $9ee4137247832c84$var$EXPERIMENT = 'platform_global_preview_panels_default_width';
const $9ee4137247832c84$export$c82b124a4ae0f274 = 'isEnabled';
const $9ee4137247832c84$export$56368731b0f4a091 = 'minimumWidth';
const $9ee4137247832c84$export$97a0618f336c05be = 'ratio';
const $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH = 400;
const $9ee4137247832c84$var$PANEL_MAX_WIDTH = 1000;
const $9ee4137247832c84$var$FALLBACK_RATIO = 0.25;
const $9ee4137247832c84$export$29ceecbfeef33bfc = ()=>{
    if (!$9ee4137247832c84$var$getExperimentValue($9ee4137247832c84$var$EXPERIMENT, $9ee4137247832c84$export$c82b124a4ae0f274, false)) return $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    const windowWidth = window.innerWidth;
    const minWidthForWiderPanel = $9ee4137247832c84$var$getExperimentValue($9ee4137247832c84$var$EXPERIMENT, $9ee4137247832c84$export$56368731b0f4a091, Number.MAX_VALUE);
    let width = $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth > minWidthForWiderPanel) {
        const panelWidthToWindowWidthRatio = $9ee4137247832c84$var$getExperimentValue($9ee4137247832c84$var$EXPERIMENT, $9ee4137247832c84$export$97a0618f336c05be, $9ee4137247832c84$var$FALLBACK_RATIO);
        const proposedPanelWidth = Math.round(windowWidth * panelWidthToWindowWidthRatio);
        width = proposedPanelWidth < $9ee4137247832c84$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $9ee4137247832c84$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $9ee4137247832c84$export$29ceecbfeef33bfc;

});

parcelRegister("D92g9", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");

const $101bde26e7a6d36a$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $k4HRJ.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $k4HRJ.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $101bde26e7a6d36a$export$eb89e687f2b278d7;

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    return PanelName;
}({});
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;

});

parcelRegister("gczDe", function(module, exports) {

var $cVw8q = parcelRequire("cVw8q");

let $d31fe98ca852fa54$var$rendererEmitter = undefined;
const $d31fe98ca852fa54$export$894d051c63add88c = ()=>{
    if (!$d31fe98ca852fa54$var$rendererEmitter) $d31fe98ca852fa54$var$rendererEmitter = new (0, $cVw8q.AnnotationUpdateEmitter)();
    return $d31fe98ca852fa54$var$rendererEmitter;
};
module.exports["getRendererAnnotationEventEmitter"] = $d31fe98ca852fa54$export$894d051c63add88c;

});

parcelRegister("cVw8q", function(module, exports) {

var $5rDjV = parcelRequire("5rDjV");


var $fdq1c = parcelRequire("fdq1c");

class $088b66af3518f6bb$export$7cc60aa9ef845515 extends (0, $5rDjV.EventEmitter) {
    on(event, listener) {
        return super.on(event, listener);
    }
    off(event, listener) {
        return super.removeListener(event, listener);
    }
}
function $088b66af3518f6bb$export$3238f27f6e07aed2() {
    return new (0, $fdq1c.SharedAnnotationManager)();
}
module.exports["AnnotationUpdateEmitter"] = $088b66af3518f6bb$export$7cc60aa9ef845515;
module.exports["createAnnotationManager"] = $088b66af3518f6bb$export$3238f27f6e07aed2;

});

parcelRegister("fdq1c", function(module, exports) {

var $5rDjV = parcelRequire("5rDjV");

class $629fc281f4644e5a$export$c7aecf09b7cf478f {
    setPreemptiveGate(handler) {
        this.preemptiveGate = handler;
        return this;
    }
    checkPreemptiveGate() {
        if (this.activePreemptiveGate) // If the preemptive gate check already in flight then just return the promise
        // and don't call the preemptive gate again.
        // This is to prevent multiple calls to the preemptive gate creating multiple
        // promises that will resolve at different times.
        return Promise.resolve(this.activePreemptiveGate);
        const gate = this.activePreemptiveGate = this.preemptiveGate().then((result)=>{
            this.activePreemptiveGate = undefined;
            return result;
        });
        return gate;
    }
    onDraftAnnotationStarted(handler) {
        this.emitter.on('draftAnnotationStarted', handler);
        return this;
    }
    offDraftAnnotationStarted(handler) {
        this.emitter.off('draftAnnotationStarted', handler);
        return this;
    }
    onAnnotationSelectionChange(handler) {
        this.emitter.on('annotationSelectionChanged', handler);
        return this;
    }
    offAnnotationSelectionChange(handler) {
        this.emitter.off('annotationSelectionChanged', handler);
        return this;
    }
    emit(event) {
        this.emitter.emit(event.name, event.data);
        return this;
    }
    hook(method, handler) {
        this.hooks.set(method, handler);
        return this;
    }
    unhook(method, handler) {
        if (!this.hooks.has(method) || this.hooks.get(method) !== handler) return this;
        this.hooks.delete(method);
        return this;
    }
    allowAnnotation() {
        const fn = this.hooks.get('allowAnnotation');
        if (!fn) return false;
        try {
            return fn();
        } catch (error) {
            return false;
        }
    }
    startDraft() {
        const fn = this.hooks.get('startDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch (error) {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearDraft() {
        const fn = this.hooks.get('clearDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch (error) {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    applyDraft(id) {
        const fn = this.hooks.get('applyDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id);
        } catch (error) {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    getDraft() {
        const fn = this.hooks.get('getDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch (error) {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    setIsAnnotationSelected(id, isSelected) {
        const fn = this.hooks.get('setIsAnnotationSelected');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            // NOTE: The hook needs to manage the firing the annotationSelectionChanged event when a change is made. This is
            // because the hook is responsible for the state of the selection. The manager is not responsible for the state of
            // the selection.
            return fn(id, isSelected);
        } catch (error) {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    setIsAnnotationHovered(id, isHovered) {
        const fn = this.hooks.get('setIsAnnotationHovered');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id, isHovered);
        } catch (error) {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearAnnotation(id) {
        const fn = this.hooks.get('clearAnnotation');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id);
        } catch (error) {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    constructor(){
        /**
     * This is the event emitter that is used to emit events from the manager. It is used to communicate with
     * other parts of the application.
     */ this.emitter = new (0, $5rDjV.EventEmitter)();
        /**
     * This is the map of hooks that can be added to the manager. Hooks are a 1:1 mapping of methods that can be
     * called on the manager. They are used to extend the functionality of the manager.
     */ this.hooks = new Map();
        this.preemptiveGate = ()=>Promise.resolve(true);
        this.activePreemptiveGate = undefined;
    }
}
module.exports["SharedAnnotationManager"] = $629fc281f4644e5a$export$c7aecf09b7cf478f;

});

parcelRegister("gfqXk", function(module, exports) {

var $cVw8q = parcelRequire("cVw8q");

let $d97010bba34874b5$var$editorEmitter = undefined;
const $d97010bba34874b5$export$60921b94e11f8e19 = ()=>{
    if (!$d97010bba34874b5$var$editorEmitter) $d97010bba34874b5$var$editorEmitter = new (0, $cVw8q.AnnotationUpdateEmitter)();
    return $d97010bba34874b5$var$editorEmitter;
};
module.exports["getEditorAnnotationEventEmitter"] = $d97010bba34874b5$export$60921b94e11f8e19;

});

parcelRegister("htsj6", function(module, exports) {

var $2PDpU = parcelRequire("2PDpU");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");


var $ep3mz = parcelRequire("ep3mz");


var $9wGTI = parcelRequire("9wGTI");

const $feac3235d890b171$export$50af12b79850199d = (props = {})=>{
    if ((0, $9wGTI.fg)('stop_watching_more_queries')) // No refresh function if FG is on
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $feac3235d890b171$export$689c7050603c5c14(props, false);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    return $feac3235d890b171$export$689c7050603c5c14(props, true);
};
const $feac3235d890b171$export$689c7050603c5c14 = ({ skip: skip = false } = {}, returnRefreshFunction = true)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const query = (0, $2PDpU.default);
    const options = {
        skip: skip || !contentId,
        variables: {
            contentId: contentId ?? ''
        }
    };
    let result;
    if (returnRefreshFunction) // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jMyy4.useQueryInterop)(query, options);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(query, options);
    const { data: data, loading: loading, error: error } = result;
    const contentNode = data?.content?.nodes?.[0];
    return {
        contentStatus: contentNode?.status,
        loading: loading,
        error: error,
        refetch: result.refetch,
        type: contentNode?.type
    };
};
module.exports["useContentStatus"] = $feac3235d890b171$export$50af12b79850199d;
module.exports["useContentStatusWithRefetch"] = $feac3235d890b171$export$689c7050603c5c14;

});

parcelRegister("2PDpU", function(module, exports) {
/**
 * @generated SignedSource<<2907f65b81f9f12ac8d707a3a8f4b524>>
 * @relayHash 11ef6cf70fe5a26f89cf732fe25cb27f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5
const $ac2eaa9e4c9bbbba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft",
                        "archived"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "11ef6cf70fe5a26f89cf732fe25cb27f",
            "id": "3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5",
            "metadata": {},
            "name": "useContentStatusContentStatusQuery",
            "operationKind": "query",
            "text": "query useContentStatusContentStatusQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\",\"archived\"]){nodes{id,status,type}}}"
        }
    };
}();
$ac2eaa9e4c9bbbba$var$node.hash = "42fd7c46b2fddcc220c48467ae805b6e";
var $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039 = $ac2eaa9e4c9bbbba$var$node;
module.exports["default"] = $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039;

});

parcelRegister("cZa7r", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $42omo = parcelRequire("42omo");


var $cVw8q = parcelRequire("cVw8q");


var $21K7m = parcelRequire("21K7m");


var $afGoD = parcelRequire("afGoD");


var $9QIM2 = parcelRequire("9QIM2");


var $gczDe = parcelRequire("gczDe");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $cUycv = parcelRequire("cUycv");


var $8WQTF = parcelRequire("8WQTF");

const $d99a6317060f344e$export$39085f26fb4d6afa = /*#__PURE__*/ (0, $42omo.createContext)({
    selectionProps: null,
    hoverProps: null,
    viewProps: null,
    editorCreateProps: null,
    editorViewProps: null,
    showCreateComponent: false,
    showHighlightActions: false,
    selectionOptions: undefined,
    stepGenerationError: false,
    newlyCreatedAnnotationId: undefined,
    isOffline: false,
    storedCommentData: null
});
$d99a6317060f344e$export$39085f26fb4d6afa.displayName = 'AnnotationsContext';
const $d99a6317060f344e$export$57d1b2fe9544d93c = /*#__PURE__*/ (0, $42omo.createContext)(false);
$d99a6317060f344e$export$57d1b2fe9544d93c.displayName = 'AnnotationsOfflineContext';
const $d99a6317060f344e$var$ConditionalAnnotationsOfflineContextProvider = ({ children: children, value: value })=>{
    if ((0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$57d1b2fe9544d93c.Provider, {
        value: value
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $d99a6317060f344e$export$6e641cb791644965 = /*#__PURE__*/ (0, $42omo.createContext)({
    setSelectionProps: ()=>{},
    setHoverProps: ()=>{},
    setViewProps: ()=>{},
    setEditorCreateProps: ()=>{},
    setEditorViewProps: ()=>{},
    setShowCreateComponent: ()=>{},
    setShowHighlightActions: ()=>{},
    setSelectionOptions: ()=>{},
    setStepGenerationError: ()=>{},
    setSelectionOptionsForCreateEditor: ()=>{},
    setNewlyCreatedAnnotationId: ()=>{},
    handleSaveSuccess: ()=>{},
    handleClose: ()=>{},
    setIsOffline: ()=>{},
    setStoredCommentData: ()=>{},
    clearStoredCommentData: ()=>{}
});
$d99a6317060f344e$export$6e641cb791644965.displayName = 'AnnotationDispatchContext';
const $d99a6317060f344e$export$567c82ef93e7d5a1 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
$d99a6317060f344e$export$567c82ef93e7d5a1.displayName = 'AnnotationManagerContext';
const $d99a6317060f344e$export$22e6290b4a8e41d3 = ({ children: children })=>{
    const [selectionProps, setSelectionProps] = (0, $42omo.useState)(null);
    const [hoverProps, setHoverProps] = (0, $42omo.useState)(null);
    const [viewProps, setViewProps] = (0, $42omo.useState)(null);
    const [editorCreateProps, setEditorCreateProps] = (0, $42omo.useState)(null);
    const [editorViewProps, setEditorViewProps] = (0, $42omo.useState)(null);
    const [showCreateComponent, setShowCreateComponent] = (0, $42omo.useState)(false);
    const [showHighlightActions, setShowHighlightActions] = (0, $42omo.useState)(false);
    const [selectionOptions, setSelectionOptions] = (0, $42omo.useState)();
    const [stepGenerationError, setStepGenerationError] = (0, $42omo.useState)(false);
    const [newlyCreatedAnnotationId, setNewlyCreatedAnnotationId] = (0, $42omo.useState)();
    const [prevContentId, setPrevContentId] = (0, $42omo.useState)(null);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const annotationManager = (0, $42omo.useMemo)(()=>(0, $9wGTI.fg)('platform_editor_comments_api_manager') ? (0, $cVw8q.createAnnotationManager)() : undefined, []);
    // This is effectively used with editorCreateProps and editorViewProps but we're tracking it independently as it doesn't really tie into the same lifecycle events
    const [isOffline, setIsOffline] = (0, $42omo.useState)(false);
    // Stored comment data for direct data flow
    const [storedCommentData, setStoredCommentData] = (0, $42omo.useState)(null);
    // Get rendererActions for renderer mode (always call hook, but only use when feature gate is enabled)
    const rendererActionsHook = (0, $8WQTF.useRendererActions)();
    const rendererActions = rendererActionsHook?.rendererActions;
    (0, $42omo.useEffect)(()=>{
        const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
        function handleAnnotationFocus({ annotationId: annotationId }) {
            // The fact annotations is an array here is meaningless at this time - Confluence
            // always picks the top annotation
            const focusedAnnotation = annotationId;
            if (!focusedAnnotation) {
                // If there is no running experience -- then this is a noop.
                (0, $4EKKB.selectInlineComment).debug('Renderer emitted event indicating no focused annotation.');
                return;
            }
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.complete({
                pageClass: pageClass,
                entryPoint: 'unknown:RendererFocus',
                annotationId: focusedAnnotation
            });
        }
        // Fired when an annotation is focused (ie. comment navigation, comment click)
        emitter.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        return ()=>{
            emitter.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        };
    }, [
        pageClass
    ]);
    const resetProviderState = (0, $42omo.useCallback)(()=>{
        setSelectionProps(null);
        setHoverProps(null);
        setViewProps(null);
        setEditorCreateProps(null);
        setEditorViewProps(null);
        setShowCreateComponent(false);
        setShowHighlightActions(false);
        setSelectionOptions(undefined);
        setStepGenerationError(false);
        setNewlyCreatedAnnotationId(undefined);
        setStoredCommentData(null);
    }, []);
    // When the content ID changes, reset the provider state
    (0, $42omo.useEffect)(()=>{
        if (!contentId) return;
        if (prevContentId && contentId !== prevContentId) resetProviderState();
        setPrevContentId(contentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        setShowCreateComponent(false);
        setStepGenerationError(false);
        setSelectionOptions(undefined);
        if (annotationManager) annotationManager.clearDraft();
        else selectionProps && selectionProps.onClose();
        setSelectionProps(null);
    }, [
        setShowCreateComponent,
        setStepGenerationError,
        setSelectionOptions,
        selectionProps,
        annotationManager
    ]);
    /*
	 * NOTE: This function will not be calling setShowCreateComponent because it's
	 *       consumers will not be refreshing themselves with new selectionOptions.
	 *       It will now be the responsibility of the consumers of this function to call
	 *       setShowCreateComponent(true). See SelectionComponent.tsx (~line 132)
	 */ const setSelectionOptionsForCreateEditor = (0, $42omo.useCallback)(({ experienceAttributes: experienceAttributes } = {})=>{
        setShowCreateComponent(false); // Hide an existing create component if it exists
        const annotationId = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
        // to exclude "not-page-or-doc" from pageClass to make typecheck happy
        const pageClassAttr = pageClass === 'renderer' ? 'renderer' : 'editor';
        (0, $3YBks.createInlineCommentCompoundExperience).start({
            attributes: {
                pageClass: (0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage') ? pageClassAttr : 'renderer',
                commentType: 'inline',
                annotationId: annotationId,
                ...experienceAttributes ?? {}
            }
        });
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.start();
        let result = undefined;
        if (annotationManager) {
            const startDraftResult = annotationManager.startDraft();
            if (startDraftResult.success) result = startDraftResult.actionResult;
        } else {
            if (!selectionProps) {
                // selectionProps is not defined. This may occur if a comment sidebar box was just closed, which
                // unsets selectionProps. In this case, we treat this as no-op, and unselect any annotation.
                (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                // We soft-fail create-inline-comment/init experience here to track how often this occurs.
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Attempted to create inline comment when no selection was present'));
                return;
            }
            result = selectionProps.applyDraftMode({
                annotationId: annotationId,
                keepNativeSelection: false
            });
        }
        const ancestorNodeTypes = result?.ancestorNodeTypes ?? [];
        const alphabeticalAncestorNodeTypes = [
            ...ancestorNodeTypes
        ].sort();
        (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: result?.inlineNodeTypes ?? [],
            ancestorNodeTypes: ancestorNodeTypes,
            alphabeticalAncestorNodeTypes: alphabeticalAncestorNodeTypes,
            // @ts-ignore
            initialPosition: [
                result?.step?.from,
                result?.step?.to
            ]
        });
        if (result) {
            setSelectionOptions({
                step: result.step,
                inlineNodeTypes: result.inlineNodeTypes,
                originalSelection: result.originalSelection,
                numMatches: result.numMatches,
                matchIndex: result.matchIndex,
                createdFrom: (0, $afGoD.CommentCreationLocation).RENDERER,
                pos: result.pos,
                targetNodeType: result.targetNodeType
            });
            // Tell the renderer to close any currently-open comments
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            setShowHighlightActions(false);
        } else {
            setStepGenerationError(true);
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Failed to generate step'));
        }
    }, [
        selectionProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setStepGenerationError,
        annotationManager,
        pageClass
    ]);
    const handleSaveSuccess = (0, $42omo.useCallback)((annotationId, commentData)=>{
        setStepGenerationError(false);
        // Set stored comment data for direct data flow when experiment is enabled
        if (commentData) setStoredCommentData(commentData);
        let result = false;
        if (annotationManager) {
            const result = annotationManager.applyDraft(annotationId);
            if (result.success && !!result.actionResult?.doc) {
                selectionProps.updateDocument && selectionProps.updateDocument(result.actionResult.doc);
                setNewlyCreatedAnnotationId(annotationId);
            } else throw new Error('Error ocurred when applying the step to the active document');
        } else // Renderer mode: Try using rendererActions.applyAnnotation() first (similar to editor's annotationManager.applyDraft())
        // This provides more reliable annotation application, matching the editor implementation
        if (rendererActions && selectionOptions?.step && (0, $9wGTI.fg)('confluence_frontend_comment_highlight_apply_fixes')) {
            const step = selectionOptions.step;
            // Extract position from step - use pos if available, otherwise use from/to
            const position = selectionOptions.pos ? {
                to: selectionOptions.pos,
                from: selectionOptions.pos
            } : {
                to: step.to,
                from: step.from
            };
            const annotationResult = rendererActions.applyAnnotation(position, {
                annotationId: annotationId,
                annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
            });
            if (annotationResult && annotationResult.doc) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                if (!storedCommentData) selectionProps.removeDraftMode();
                selectionProps.updateDocument && selectionProps.updateDocument(annotationResult.doc);
                setTimeout(()=>{
                    // Tell the renderer to set the new comment to active
                    if (emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                        annotationIds: [
                            annotationId
                        ],
                        eventTarget: document.getElementById(annotationId)
                    })) {
                        emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                            annotationId: annotationId
                        });
                        setNewlyCreatedAnnotationId(annotationId);
                    }
                // We need the timeout to give the document the chance to make the marks properly
                }, 250);
            } else throw new Error('Error ocurred when applying the step to the active document');
        } else {
            // Fallback to original onCreate method
            // Since we generated the uuid ourselves, we need to replace the document generated with
            // the annotationId that we received from the backend so things line up correctly
            result = selectionProps.onCreate(annotationId);
            if (result) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                if (!storedCommentData) selectionProps.removeDraftMode();
                selectionProps.updateDocument && selectionProps.updateDocument(result.doc);
                setTimeout(()=>{
                    // Tell the renderer to set the new comment to active
                    if (emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                        annotationIds: [
                            annotationId
                        ],
                        // eventTarget: wrapperDOM,
                        eventTarget: document.getElementById(annotationId)
                    })) {
                        emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                            annotationId: annotationId
                        });
                        setNewlyCreatedAnnotationId(annotationId);
                    }
                // We need the timeout to give the document the chance to make the marks properly
                }, 250);
            } else throw new Error('Error ocurred when applying the step to the active document');
        }
    }, [
        annotationManager,
        setStepGenerationError,
        setNewlyCreatedAnnotationId,
        selectionProps,
        setStoredCommentData,
        storedCommentData,
        rendererActions,
        selectionOptions
    ]);
    const providerValue = (0, $42omo.useMemo)(()=>({
            selectionProps: selectionProps,
            hoverProps: hoverProps,
            viewProps: viewProps,
            editorCreateProps: editorCreateProps,
            editorViewProps: editorViewProps,
            showCreateComponent: showCreateComponent,
            showHighlightActions: showHighlightActions,
            selectionOptions: selectionOptions,
            stepGenerationError: stepGenerationError,
            newlyCreatedAnnotationId: newlyCreatedAnnotationId,
            isOffline: isOffline,
            storedCommentData: storedCommentData
        }), [
        selectionProps,
        hoverProps,
        viewProps,
        editorCreateProps,
        editorViewProps,
        showCreateComponent,
        showHighlightActions,
        selectionOptions,
        stepGenerationError,
        newlyCreatedAnnotationId,
        isOffline,
        storedCommentData
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setSelectionProps: setSelectionProps,
            setHoverProps: setHoverProps,
            setViewProps: setViewProps,
            setEditorCreateProps: setEditorCreateProps,
            setEditorViewProps: setEditorViewProps,
            setShowCreateComponent: setShowCreateComponent,
            setShowHighlightActions: setShowHighlightActions,
            setSelectionOptions: setSelectionOptions,
            setStepGenerationError: setStepGenerationError,
            setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor,
            setNewlyCreatedAnnotationId: setNewlyCreatedAnnotationId,
            handleSaveSuccess: handleSaveSuccess,
            handleClose: handleClose,
            setIsOffline: setIsOffline,
            // Stored comment data management functions
            setStoredCommentData: (commentData)=>setStoredCommentData(commentData ?? null),
            clearStoredCommentData: ()=>setStoredCommentData(null)
        }), [
        setSelectionProps,
        setHoverProps,
        setViewProps,
        setEditorCreateProps,
        setEditorViewProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setSelectionOptions,
        setStepGenerationError,
        setSelectionOptionsForCreateEditor,
        setNewlyCreatedAnnotationId,
        handleSaveSuccess,
        handleClose,
        setIsOffline,
        // Stored comment data management functions
        setStoredCommentData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$567c82ef93e7d5a1.Provider, {
        value: annotationManager
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$39085f26fb4d6afa.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$6e641cb791644965.Provider, {
        value: dispatchProviderValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$var$ConditionalAnnotationsOfflineContextProvider, {
        value: isOffline
    }, children))));
};
const $d99a6317060f344e$export$ede9be424e8ef89a = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$39085f26fb4d6afa);
};
const $d99a6317060f344e$export$3be336e5c3e78567 = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$6e641cb791644965);
};
const $d99a6317060f344e$export$3998d49469d13f97 = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$567c82ef93e7d5a1);
};
const $d99a6317060f344e$export$3757730e05e42ee2 = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$57d1b2fe9544d93c);
};
module.exports["AnnotationsProvider"] = $d99a6317060f344e$export$22e6290b4a8e41d3;
module.exports["useAnnotations"] = $d99a6317060f344e$export$ede9be424e8ef89a;
module.exports["useAnnotationsDispatch"] = $d99a6317060f344e$export$3be336e5c3e78567;
module.exports["useAnnotationManager"] = $d99a6317060f344e$export$3998d49469d13f97;
module.exports["useAnnotationsIsOffline"] = $d99a6317060f344e$export$3757730e05e42ee2;

});

parcelRegister("afGoD", function(module, exports) {
/**
 * @generated SignedSource<<71be4194137313c8ff0872a3df259dda>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $f8b43d46712cd783$export$cdccd0683766be81 = /*#__PURE__*/ function(CommentCreationLocation) {
    CommentCreationLocation["DATABASE"] = "DATABASE";
    CommentCreationLocation["EDITOR"] = "EDITOR";
    CommentCreationLocation["LIVE"] = "LIVE";
    CommentCreationLocation["RENDERER"] = "RENDERER";
    CommentCreationLocation["WHITEBOARD"] = "WHITEBOARD";
    return CommentCreationLocation;
}({});
var $f8b43d46712cd783$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $f8b43d46712cd783$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $f8b43d46712cd783$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["CommentCreationLocation"] = $f8b43d46712cd783$export$cdccd0683766be81;

});

parcelRegister("9QIM2", function(module, exports) {

var $de2j9 = parcelRequire("de2j9");


var $3jwuS = parcelRequire("3jwuS");


var $dPJCf = parcelRequire("dPJCf");


var $9wGTI = parcelRequire("9wGTI");


var $gEtAQ = parcelRequire("gEtAQ");

function $06d23c10422abe2f$export$d9ae12e82c9f2aba() {
    // Note -- this hook does not inform the consumer if they are on a live doc page which
    // is using the editor.
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    // useRouteName use RoutesContext which is more reliable than reading window.location.pathname directly.
    const routeName = (0, $dPJCf.useRouteName)({
        selector: (name)=>name
    });
    const isTinyMCEPage = $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage();
    if (isTinyMCEPage) // TinyMCE pages are not considered editor pages or docs in the context of this hook
    return 'not-page-or-doc';
    if (isEditorPage) return 'editor';
    if (isCurrentPageLive) return 'editor';
    if ((0, $9wGTI.fg)('confluence_frontend_fix_page_class_route_detection')) {
        // Pass routeName to isDatabase/isWhiteboard - they will use it when feature gate is enabled
        if ((0, $gEtAQ.isDatabase)(routeName) || (0, $gEtAQ.isWhiteboard)(routeName)) return 'not-page-or-doc';
    } else {
        // Legacy behavior: use window.location.pathname (can have race conditions during SPA transitions)
        if ((0, $gEtAQ.isDatabase)() || (0, $gEtAQ.isWhiteboard)()) return 'not-page-or-doc';
    }
    return 'renderer';
}
function $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage() {
    const possibleTinyMCESelectors = [
        `[data-testid="TinyMCERendererTestId"]`,
        '.tinymce-editor'
    ];
    // This check is only relevant in the context of comment experiences
    // and so if we are in an environment without a document -- we
    // can safely treat it as not a tinymce page.
    if (typeof document === 'undefined') return false;
    const isTinyMCEPage = possibleTinyMCESelectors.some((selector)=>document.querySelector(selector) !== null);
    return isTinyMCEPage;
}
module.exports["usePageClass"] = $06d23c10422abe2f$export$d9ae12e82c9f2aba;

});

parcelRegister("gEtAQ", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null && (0, $9wGTI.fg)('confluence_frontend_fix_page_class_route_detection')) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null && (0, $9wGTI.fg)('confluence_frontend_fix_page_class_route_detection')) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("4EKKB", function(module, exports) {

var $gykrH = parcelRequire("gykrH");


var $irVI7 = parcelRequire("irVI7");


var $aJPUt = parcelRequire("aJPUt");


var $fGzMp = parcelRequire("fGzMp");


var $8Ss4E = parcelRequire("8Ss4E");

let $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
function $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug(experienceName, experienceStage) {
    function createInlineCommentExperienceDebug({ error: error, createAnalyticsEvent: createAnalyticsEvent, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `Legacy select debug message: ${error.message || String(error)}`,
            attributes: {
                ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
                ...extraAttributes,
                experienceStage: experienceStage
            }
        });
        return;
    }
    return createInlineCommentExperienceDebug;
}
var $d671aa981fcb4da6$var$ExperienceType = /*#__PURE__*/ function(ExperienceType) {
    ExperienceType["DOCUMENT"] = "document";
    ExperienceType["DOCUMENT_WITH_PANEL"] = "documentWithPanel";
    ExperienceType["PANEL"] = "panel";
    return ExperienceType;
}($d671aa981fcb4da6$var$ExperienceType || {});
function $d671aa981fcb4da6$var$getExperienceType(entryPoint, sidebarOpenAtStart) {
    switch(entryPoint){
        case 'create-comment':
        case 'comment-navigation':
        case 'unknown:InlineComment':
            return "document";
        case 'annotation-change':
        case 'keyboard-navigation':
        case 'unknown:RendererFocus':
            return sidebarOpenAtStart ? "documentWithPanel" : "document";
        case 'sidebar':
        case 'unknown:CommentsPanelList':
            return "panel";
        default:
            return "document";
    }
}
const $d671aa981fcb4da6$export$e2b3aff7888f2745 = {
    _start: (startAttributes, _options)=>{
        if (startAttributes.pageClass === 'not-page-or-doc') return;
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceState = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
        const runningExperienceAttributes = experienceState?.attributes;
        if (!experienceState?.hasStopped && runningExperienceAttributes?.annotationId !== undefined && runningExperienceAttributes?.annotationId === startAttributes.annotationId) {
            // If there is an existing (unstopped) experience
            // - and that experience has an annotationId
            //   - keyboard and comment navigation will start experiences without an annotationId -- and these should be restarted on an new start
            // - and that annotationId matches the one in the startAttributes
            // we assume the experience is still active, and don't start a new one.
            // the reason we can hit this is because the selectInlineCommentCompoundExperience._start is called when there is a "select inline comment"
            // signal, and individual signals fire in different orders (sometimes they are the first signal, sometimes they are later).
            // However -- if the second signal has a clearer entry point
            // we update the entry point attribute of the existing experience.
            if (runningExperienceAttributes?.entryPoint?.startsWith('unknown') && !startAttributes.entryPoint.startsWith('unknown')) {
                $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                    entryPoint: startAttributes.entryPoint
                });
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `After starting from ${runningExperienceAttributes.entryPoint}, received signal from ${startAttributes.entryPoint}`
                });
            }
            return;
        }
        if (// When the side bar is open, and the user selects a comment using the keyboard,
        // the keyboard navigation triggers a select annotation first (without an annotationId),
        // followed by the show comment start or select annotation complete (with an annotationId.
        startAttributes.entryPoint === 'unknown:CommentsPanelList' && runningExperienceAttributes?.entryPoint === 'keyboard-navigation' && runningExperienceAttributes?.annotationId === undefined) {
            $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                annotationId: startAttributes.annotationId
            });
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `After starting from ${runningExperienceAttributes.entryPoint}, received signal from ${startAttributes.entryPoint} with annotationId ${startAttributes.annotationId}`
            });
            return;
        }
        // First prepare the new attributes without modifying the global state
        // This ensures that any abort of current experiences will use their original attributes
        const newAttributes = {
            pageClass: startAttributes.pageClass,
            commentType: startAttributes.commentType,
            annotationId: 'annotationId' in startAttributes ? startAttributes.annotationId : undefined,
            entryPoint: startAttributes.entryPoint,
            version: 'single-experience'
        };
        // We check if there is a dom element with a testId of "object-sidebar-panel-body" and if so mark the
        // experience as being during a sidebar open experience.
        newAttributes.sidebarOpenAtStart = document.querySelector('[data-testid="object-sidebar-panel-body"]') !== null;
        newAttributes.experienceType = $d671aa981fcb4da6$var$getExperienceType(startAttributes.entryPoint, newAttributes.sidebarOpenAtStart);
        // If the create inline comment experience is running, we want to link the two experiences
        const createInlineCommentExperienceState = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        if (createInlineCommentExperienceState && !createInlineCommentExperienceState.hasStopped) newAttributes.linkedCompoundTaskId = createInlineCommentExperienceState.attributes?.compoundTaskId;
        // Adds a debug point to the last running experience (debug points are only added if there is a running experience)
        // Note:
        // A new experience is followed after this is fired -- so this should always be the last debug point (as the new experience will trigger a fail or abort).
        // In the case there is no running experience, the experience tracker will discard the debugPoint.
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `Restarted from ${startAttributes.entryPoint} with annotationId: ${startAttributes.annotationId} (sidebarOpenAtStart: ${newAttributes.sidebarOpenAtStart})`
        });
        // Start press trace if no trace is currently active
        (0, $8Ss4E.startUFOPressTrace)((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
        // Then start a new compound experience with the new attributes
        // This will abort any running experiences with the same name, but they'll keep their original attributes
        experienceTracker.start({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: newAttributes,
            // If the annotation is not selected and comment shown to the user within 12 seconds -- we assume there has been a failure to select the inline comment
            timeout: (0, $aJPUt.ExperienceTimeout).SELECT_INLINE_COMMMENT,
            collect: (events)=>{
                const isThisCommentBeingResolved = (event)=>{
                    return event.name === (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE) && event.action === 'taskStart' && (0, $gykrH.hasAttribute)(event, 'annotationId', $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId);
                };
                events.forEach((event)=>{
                    if (isThisCommentBeingResolved(event)) $d671aa981fcb4da6$export$e2b3aff7888f2745.abort({
                        abortReason: 'Comment being resolved'
                    });
                });
            }
        });
        if (startAttributes.annotationId === undefined) experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `selectInlineCommentCompoundExperience._start started from ${startAttributes.entryPoint} with unknown annotationId`
        });
        else experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `selectInlineCommentCompoundExperience._start started from ${startAttributes.entryPoint} with annotationId ${startAttributes.annotationId}`
        });
        // Now it's safe to update the global state since any aborts have already happened
        // We reset experience state if we are starting a new experience
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = newAttributes;
        // By the time we get a task fail (particularly for timeout aborts) -- the contentId may have changed
        const originalContentId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.attributes?.contentId;
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.originalContentId = originalContentId;
        experienceTracker.updateAttributes({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                originalContentId: originalContentId
            }
        });
    },
    debugPoint: (message, attributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: message,
            attributes: attributes
        });
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            message: message,
            attributes: attributes
        });
    },
    addCommonAttributes: (additionalCommonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {
            ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
            ...additionalCommonAttributes
        };
        experienceTracker.updateAttributes({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: additionalCommonAttributes
        });
    },
    abort: ({ abortReason: abortReason })=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.abort({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            reason: abortReason,
            checkForTimeout: true
        });
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
    },
    selectAnnotation: {
        debug: $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE), 'selectAnnotation'),
        /**
     * This is currently used to start from
     * - annotationId unknown
     *   - comment navigation
     *   - keyboard navigation
     * - annotationId known
     *   - create comment
     *   - comment sidebar comment selection
     *
     * These should be separate signals once the multi experience is deprecated.
     */ start: (startAttributes)=>{
            function isUnknownAnnotationId(startAttributes) {
                return startAttributes.entryPoint === 'keyboard-navigation' || startAttributes.entryPoint === 'comment-navigation';
            }
            if (isUnknownAnnotationId(startAttributes)) {
                $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes, {
                    annotationUnknown: true
                });
                return;
            }
            $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
        },
        abort: ({ abortReason: abortReason })=>{
            $d671aa981fcb4da6$export$e2b3aff7888f2745.abort({
                abortReason: // @ts-ignore the abort reasons have mismatch due to type from the old multi experience. and once that is removed we can remove this cast
                abortReason
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        /**
     * Note -- the selectAnnotation does not trigger a completion of the selectInlineComment experience.
     * Instead -- the selectInlineComment experience is completed when the showComment experience completes
     * (which looks for the selected annotation as part of its completion logic).
     *
     * With the single experience -- this is less a complete and rather just an indirect signal that a selection has been made (in case it's not detected by the showComment experience).
     * When the multi selectInlineCommentCompoundExperience is deprecated, this can be renamed to indicate it's a "annotationSelection" signal rather than a "completed" signal.
     */ complete: (startAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            const experienceState = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
            // There can be cases where no start has been called for the select experience.
            // - When a product consumer of the editor setselectedannotation api calls the select experience
            //   and has not been instrumented.
            // - When the annotation selection is via editor logic (ie. editor selection being moved onto
            //   an annotation).
            if (experienceState === null) {
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: 'selectAnnotation completed from no experience - no explicit start point',
                    attributes: startAttributes
                });
                $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
            }
        }
    },
    showComment: {
        debug: $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE), 'showComment'),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        },
        start: (startAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: 'showComment start triggered',
                attributes: startAttributes
            });
        },
        abort: ({ abortReason: abortReason })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                reason: abortReason
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        fail: (error, extraAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: error,
                attributes: {
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
                    ...extraAttributes
                }
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        complete: (completedFrom)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: completedFrom,
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        standaloneSidebarComplete: (commentUIVerticalDistanceFromAnnotation)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `standaloneSidebarComplete triggered`
            });
            if (commentUIVerticalDistanceFromAnnotation > 40) experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `Comment UI is misaligned by >40px pixels`,
                attributes: {
                    misalignedBy: commentUIVerticalDistanceFromAnnotation
                }
            });
            if (typeof $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId !== 'string') {
                experienceTracker.fail({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('selectInlineCommentCompoundExperience.standaloneSidebarComplete called when no annotationId was known'),
                    attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                });
                return;
            }
            if (!$d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused($d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId)) experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: new Error(`selectInlineCommentCompoundExperience.standaloneSidebarComplete ended without a focused and in viewport annotation.`),
                attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
            });
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: 'Standalone sidebar inline comment selection completed',
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
        },
        sidePanelComplete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `sidePanelComplete triggered`
            });
            if (typeof $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId !== 'string') {
                experienceTracker.fail({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('selectInlineCommentCompoundExperience.sidePanelComplete called when no annotationId was known'),
                    attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                });
                return;
            }
            if (!$d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused($d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId)) experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: new Error('selectInlineCommentCompoundExperience.sidePanelComplete did not result in a visible and focused annotation'),
                attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
            });
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: 'Side Panel inline comment selection completed',
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
        }
    }
};
/**
 *
 * Checks if there is an annotation currently visible in the document.
 *
 * The comment UI is currently opinionated about the comment UI being attached to the first instance of the focused annotation element.
 *
 * So we can safely skip checking if the initial focused annotation is not visible
 *
 * Note: this method causes reflow, and should not be used in performance sensitive code.
 *
 */ function $d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused(annotationId) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    const possibleFocusedAnnotationElements = document.querySelectorAll(// This will match the annotation id in either the Editor or Renderer
    `[data-id="${annotationId}"][data-mark-annotation-type="inlineComment"][data-has-focus="true"],
		[data-id="${annotationId}"][data-mark-annotation-type="inlineComment"] .ak-editor-annotation-focus`);
    if (possibleFocusedAnnotationElements.length === 0) {
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `No annotation element found`
        });
        return false;
    }
    /**
   * Annotations can have multiple elements in the dom, with each of the elements having the focus state set to true.
   * Ie. Comments spanning multiple lines will have multiple elements with the focus state set to true.
   *
   * In addition to this -- sometimes there will be "hidden" focused annotation elements where the dom is duplicated
   * such as for annotations on table header cells in the renderer.
   *
   * If the first element is not visible due to being hidden, we continue checking until we reach a visible element, and then check whether it is in the viewport.
   *
   */ for(let i = 0; i < possibleFocusedAnnotationElements.length; i++){
        const element = possibleFocusedAnnotationElements[i];
        if (element instanceof HTMLElement) {
            if (!element.checkVisibility()) {
                // Skip to the next element if the current one is not visible
                // This can happen in scenarios where the dom is duplicated, such as for annotations on table header cells in the renderer.
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `Annotation element had a hidden focused element, skipping to next element`
                });
                continue;
            }
            const rect = element.getBoundingClientRect();
            const isVisible = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
            // This is the first visible element -- which should be focused and
            // in the viewport
            if (isVisible) return true;
            else {
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `Annotation element found - but not in viewport`
                });
                return false;
            }
        }
    }
    return false;
}
const $d671aa981fcb4da6$export$b65d55854b7eb069 = {
    debug: $d671aa981fcb4da6$export$e2b3aff7888f2745.debugPoint
};
module.exports["selectInlineCommentCompoundExperience"] = $d671aa981fcb4da6$export$e2b3aff7888f2745;
module.exports["selectInlineComment"] = $d671aa981fcb4da6$export$b65d55854b7eb069;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 25000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("8Ss4E", function(module, exports) {

var $5qzNs = parcelRequire("5qzNs");


var $kyKWe = parcelRequire("kyKWe");


var $lMdlY = parcelRequire("lMdlY");


var $4TXTZ = parcelRequire("4TXTZ");


var $1iSzD = parcelRequire("1iSzD");


var $hukUK = parcelRequire("hukUK");


var $c3Qwv = parcelRequire("c3Qwv");


var $1NBp8 = parcelRequire("1NBp8");


var $cEgMD = parcelRequire("cEgMD");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $gykrH = parcelRequire("gykrH");


var $aJPUt = parcelRequire("aJPUt");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");


var $7v9li = parcelRequire("7v9li");


var $949zl = parcelRequire("949zl");


var $h10mo = parcelRequire("h10mo");

const $8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences = [
    (0, $irVI7.NOT_FOUND_EXPERIENCE),
    (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE),
    (0, $irVI7.RESTRICTED_SPACE_EXPERIENCE),
    (0, $irVI7.RESTRICTED_SPACE_FOR_GUEST_EXPERIENCE)
];
const $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound = (0, $1A7bE.collectAny)($8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences);
const $8c50530bac3b9ba1$var$stopOnConnectAddon = (0, $1A7bE.collectAny)([
    (0, $irVI7.CONNECT_ADDON_EXPERIENCE)
]);
/**
 * Stores the new experiences started due to SPA transition
 */ const $8c50530bac3b9ba1$var$namesStartedInPreviousRoute = [];
/**
 *  Specifies routes that signify completion for each experience.
 *  Used with experienceTracker's collect function to monitor progress of experiences.
 *  For example, 'create page' experience is considered complete when it leads to 'edit page'.
 */ const $8c50530bac3b9ba1$var$redirectRoutesForExperiences = {
    [(0, $irVI7.CREATE_PAGE_EXPERIENCE)]: [
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name,
        (0, $1NBp8.VIEW_PAGE).name // CREATE_PAGE_EXPERIENCE -> VIEW_PAGE means a live page was created
    ],
    [(0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE)]: [
        (0, $1NBp8.WHITEBOARD_BOARD).name
    ],
    [(0, $irVI7.CREATE_DATABASE_EXPERIENCE)]: [
        (0, $1NBp8.DATABASE_VIEW).name
    ],
    [(0, $irVI7.CREATE_EMBED_EXPERIENCE)]: [
        (0, $1NBp8.EMBED_VIEW).name
    ]
};
const $8c50530bac3b9ba1$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE = [
    (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE)
];
const $8c50530bac3b9ba1$export$4b786e0ae0cc0857 = {
    [(0, $1NBp8.SPACE_OVERVIEW).name]: 'space',
    [(0, $1NBp8.COMPANY_HUB).name]: 'space',
    [(0, $1NBp8.EDIT_PAGE_EMBED).name]: 'page',
    [(0, $1NBp8.EDIT_PAGE_V2).name]: 'page',
    [(0, $1NBp8.EDIT_BLOG_V2).name]: 'blog',
    [(0, $1NBp8.VIEW_PAGE).name]: 'page',
    [(0, $1NBp8.VIEW_BLOG).name]: 'blog',
    [(0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name]: 'blog'
};
const $8c50530bac3b9ba1$export$5396770e9da36673 = (routeName)=>{
    switch(routeName){
        case (0, $1NBp8.EDIT_BLOG).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.CREATE_PAGE).name:
            return 'TINY';
        default:
            return 'FABRIC';
    }
};
function $8c50530bac3b9ba1$export$cac1117e2433d80e(match, transitionId, sessionData) {
    if (!match) return;
    const tracker = (0, $fGzMp.getExperienceTracker)();
    // Moves current route data to previous route data to ensure `getExperienceTracker.ts getPreviousRouteExperienceData()` works correctly
    (0, $fGzMp.captureRouteChange)(match.name);
    // Live page's edit-page and session experience starts after the route has finished loading and unsubscribed from the tracker, so it's not in the `startExperienceForRoute` function's namesStartedInPreviousRoute array. We will handle finishing it separately in `finishLivePageExperiences`.
    // It's important that `finishLivePageExperiences` is invoked before we attempt to succeed EDIT_PAGE_EXPERIENCE below, as `finishLivePageExperiences` is responsible for succeeding EDIT_PAGE_EXPERIENCE on live pages while setting the experience attribute `isLivePage
    $8c50530bac3b9ba1$var$finishLivePageExperiences();
    $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.forEach((name)=>{
        const allowedRoutes = $8c50530bac3b9ba1$var$redirectRoutesForExperiences[name];
        // For create content routes, we do not want to abort if it is routing to correct page.
        // But, if it is a create experience and routing to a page is is not supposed to be going to,
        // we can assume something is wrong and we abort it.
        if (allowedRoutes && allowedRoutes.includes(match.name)) return;
        if (// If we were on edit-page or view-page/session experience and leave to another route, we should succeed that experience, not abort it.
        name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) && (0, $7v9li.hasHealthyRunningEditPageExperience)() || name === (0, $irVI7.COMPANY_HUB_EDITOR_EXPERIENCE) && (0, $7v9li.hasHealthyRunningCompanyHubEditExperience)() || name === (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE) && (0, $949zl.hasHealthyRunningViewPageExperience)()) {
            tracker.succeed({
                name: name
            });
            return;
        }
        // For all other situations, we still abort.
        tracker.abort({
            name: name,
            reason: 'Aborted due to SPA started a new experience'
        });
    });
    $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.length = 0;
    const unsubscribe = tracker.subscribe((e)=>{
        if (e.action === 'taskStart') $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.push(e.name);
    });
    if ((0, $9wGTI.fg)('confluence_frontend_abort_exp_on_route_change')) $8c50530bac3b9ba1$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE.forEach((name)=>{
        $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.push(name);
    });
    switch(match.name){
        case (0, $1NBp8.COMPANY_HUB_EDIT).name:
            $8c50530bac3b9ba1$var$startCompanyHubEditor(transitionId, sessionData);
            break;
        case (0, $1NBp8.EDIT_PAGE_EMBED).name:
        case (0, $1NBp8.EDIT_PAGE_V2).name:
        case (0, $1NBp8.EDIT_BLOG_V2).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.EDIT_BLOG).name:
        case (0, $1NBp8.CREATE_PAGE).name:
        case (0, $1NBp8.HUB_EDIT).name:
            $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData);
            break;
        case (0, $1NBp8.VIEW_PAGE).name:
        case (0, $1NBp8.VIEW_BLOG).name:
        case (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name:
            $8c50530bac3b9ba1$var$startViewContent(match.params.contentId, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData);
            break;
        case (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name:
            $8c50530bac3b9ba1$var$startEditPageSmartCreate(match);
            break;
        case (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).name:
            $8c50530bac3b9ba1$var$startViewPublicLinkGlobalSettings(match.query.tab, match.query.space, transitionId);
            break;
        case (0, $1NBp8.EXTERNAL_SHARE).name:
            $8c50530bac3b9ba1$var$startViewPublicLinkSharedPage(match.params.id, transitionId);
            break;
        case (0, $1NBp8.SPACE_OVERVIEW).name:
            $8c50530bac3b9ba1$var$startViewContent(match.params.spaceKey, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: match.params.spaceKey,
                isLandingPage: match.search === '?mode=global'
            });
            break;
        case (0, $1NBp8.COMPANY_HUB).name:
            const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)(sessionData) || '';
            $8c50530bac3b9ba1$var$startViewContent(spaceKey, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: spaceKey
            });
            break;
        case (0, $1NBp8.HOME).name:
            (0, $h10mo.startHome)();
            break;
        case (0, $1NBp8.EDIT_TEMPLATE_SPACE).name:
        case (0, $1NBp8.EDIT_TEMPLATE).name:
            $8c50530bac3b9ba1$var$startTemplateEditPage(match.params.contentId, transitionId);
            break;
        case (0, $1NBp8.CREATE_TEMPLATE_SPACE).name:
        case (0, $1NBp8.CREATE_TEMPLATE).name:
            $8c50530bac3b9ba1$var$startTemplateEditPage(/* id */ undefined, transitionId);
            break;
        case (0, $1NBp8.ADVANCED_SEARCH).name:
            $8c50530bac3b9ba1$var$startAdvancedSearch(match);
            break;
        case (0, $1NBp8.SPACE_ARCHIVED_PAGES).name:
            $8c50530bac3b9ba1$var$startArchivedPagesList();
            break;
        case (0, $1NBp8.SPACE_BULK_TOOLS).name:
            $8c50530bac3b9ba1$var$startContentManager();
            break;
        case (0, $1NBp8.SPACE_DIRECTORY).name:
            $8c50530bac3b9ba1$var$startSpaceDirectory();
            break;
        case (0, $1NBp8.TEMPLATE_GALLERY).name:
            $8c50530bac3b9ba1$var$startTemplateGallery();
            break;
        case (0, $1NBp8.SPACE_PAGES).name:
            $8c50530bac3b9ba1$var$startSpacePages();
            break;
        case (0, $1NBp8.WHITEBOARD_BOARD).name:
            $8c50530bac3b9ba1$var$startWhiteboardBoard(match);
            break;
        case (0, $1NBp8.DATABASE_VIEW).name:
            $8c50530bac3b9ba1$var$startDatabaseView(match.params.contentId);
            break;
        case (0, $1NBp8.EMBED_VIEW).name:
            $8c50530bac3b9ba1$var$startEmbedPageView(match.params.contentId);
            break;
        case (0, $1NBp8.FOLDER_VIEW).name:
            $8c50530bac3b9ba1$var$startFolderView(match.params.contentId);
            break;
        case (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name:
            //Adding the other space perms uplift tabs at a later date.
            if (match.params.tab === 'public-links') $8c50530bac3b9ba1$var$startViewPublicLinksSpaceSettings();
            break;
        case (0, $1NBp8.ADMIN_ANNOUNCEMENT_BANNER_RENDERER).name:
            $8c50530bac3b9ba1$var$startViewAdminAnnouncementBannerSettings();
            break;
        case (0, $1NBp8.SPACE_MANAGER).name:
            $8c50530bac3b9ba1$var$startSpaceManager();
            break;
        case (0, $1NBp8.ADMIN_COMPANY_HOME_BUILDER).name:
        case (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name:
            $8c50530bac3b9ba1$var$startCompanyHomeBuilderLoad();
            break;
    }
    const startCreateOperations = ()=>{
        const subType = typeof match?.query?.subType === 'string' ? match.query.subType : null;
        if (match.name === (0, $1NBp8.CREATE_CONTENT).name) $8c50530bac3b9ba1$var$startCreateContent(match, sessionData, subType);
        else if (match.query.createDialog) {
            $8c50530bac3b9ba1$var$startCreatePage(String(transitionId), transitionId, subType);
            (0, $7v9li.startCreateAndEditPage)();
        }
    };
    startCreateOperations();
    unsubscribe();
}
function $8c50530bac3b9ba1$var$startCreatePage(id, transitionId, subType) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    experienceTracker.start({
        name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
        id: id,
        attributes: {
            isLivePage: subType?.toLowerCase() === 'live'
        },
        startTime: transitionId === 0 ? 0 : undefined,
        collect (events, experience) {
            experience.stopOn(events.find((event)=>event.action === 'taskFail' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_LOAD_DIALOG_EXPERIENCE), (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
            experience.stopOn(events.find((event)=>event.action === 'taskSuccess' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
            experience.stopOn(events.find((event)=>event.action === 'taskAbort' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
        }
    });
    experienceTracker.start({
        name: (0, $irVI7.CREATE_PAGE_LOAD_DIALOG_EXPERIENCE),
        id: id,
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_DIALOG_LOAD
    });
}
function $8c50530bac3b9ba1$export$b9a409823a06b924(experienceName) {
    const activeTrace = (0, $lMdlY.getActiveTrace)();
    if (!activeTrace) (0, $4TXTZ.default)(experienceName.replace(/\//g, '-'));
}
function $8c50530bac3b9ba1$export$478e84e2cc5ff22d(compoundExperience, editorLoadExperience, editorPublishExperience) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const compoundExperienceAttributes = {
        ...compoundExperience.attributes,
        compoundTaskId: compoundTaskId
    };
    experienceTracker.start({
        ...compoundExperience,
        id: compoundTaskId,
        attributes: compoundExperienceAttributes,
        collect: (events, experience)=>{
            experience.stopOn(events.find(({ action: action, name: name })=>action === 'taskFail' && name === editorLoadExperience.name));
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskSuccess' || action === 'taskFail') && name === editorPublishExperience.name));
            if (compoundExperience.collect) compoundExperience.collect(events, experience);
        }
    });
    experienceTracker.start({
        ...editorLoadExperience,
        id: editorLoadExperience.id || compoundExperience.id,
        timeout: editorLoadExperience.timeout || (0, $aJPUt.ExperienceTimeout).EDITOR_LOAD,
        attributes: compoundExperienceAttributes,
        collect: editorLoadExperience.collect
    });
}
function $8c50530bac3b9ba1$export$7df6656d8508e8da(subExperience) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    // Initialize attributes from the original subExperience
    const attributes = {
        ...subExperience.attributes
    };
    // Extract the compound experience name from the sub-experience name if it follows
    // the naming convention "<compound_experience_name>/<sub_experience>"
    const subExperienceName = subExperience.name;
    const nameParts = subExperienceName.split('/');
    // Only attempt to get compound experience if the name includes a separator
    if (nameParts.length > 1) {
        const compoundExperienceName = nameParts[0];
        const compoundExperienceState = experienceTracker.getExperienceState(compoundExperienceName);
        // If compound experience exists, inherit its compoundTaskId
        if (compoundExperienceState) // Link the compound experience's compoundTaskId if available
        {
            if (compoundExperienceState.attributes?.compoundTaskId) attributes.compoundTaskId = compoundExperienceState.attributes.compoundTaskId;
        }
    }
    // Start the sub-experience with the attributes (original or enhanced with compoundTaskId)
    experienceTracker.start({
        ...subExperience,
        attributes: attributes
    });
}
const $8c50530bac3b9ba1$var$stopOnCloseForEditPage = (events, experience, loadExperienceName, closeExperienceName)=>{
    const loadStopExperience = events.find((event)=>event.name === loadExperienceName && (0, $gykrH.isStop)(event));
    const closeStopExperience = events.find((event)=>event.name === closeExperienceName && (0, $gykrH.isStop)(event));
    if (!closeStopExperience) return;
    // prettier-ignore
    if ((!loadStopExperience || loadStopExperience.action !== "taskSuccess") && closeStopExperience.action === "taskSuccess") // loading incomplete or failed, therefore editing session was broken and close doesn't indicate a success
    experience.abort({
        reason: "Editor closed before load completed",
        attributes: {
            loadExperienceState: loadStopExperience?.action ?? "incomplete"
        }
    });
    else experience.stopOn(closeStopExperience);
};
function $8c50530bac3b9ba1$var$startEditPageSmartCreate(match) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE),
        id: match.params.contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT,
        collect: (events, experience)=>{
            const hasNoPermissionOrNotFoundEvent = events.find((event)=>(0, $gykrH.isStop)(event) && (0, $gykrH.hasName)(event, ...$8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences));
            if (hasNoPermissionOrNotFoundEvent) experience.fail({
                error: new Error(`${hasNoPermissionOrNotFoundEvent.name} experience resulted in ${hasNoPermissionOrNotFoundEvent.action} - unexpected for the smart create editor`)
            });
        }
    });
}
function $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData) {
    const isLegacyEditor = $8c50530bac3b9ba1$export$5396770e9da36673(match?.name ?? '') === 'TINY';
    let editPageExperienceName = (0, $irVI7.EDIT_PAGE_EXPERIENCE);
    if (match.name === (0, $1NBp8.EDIT_PAGE_EMBED).name) editPageExperienceName = (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE);
    else if (isLegacyEditor) editPageExperienceName = (0, $irVI7.EDIT_LEGACY_PAGE_EXPERIENCE);
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: editPageExperienceName,
        id: match.params.contentId,
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: $8c50530bac3b9ba1$export$5396770e9da36673(match.name),
            contentType: $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name],
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: match?.name === (0, $1NBp8.COMPANY_HUB_EDIT).name || match?.name === (0, $1NBp8.HUB_EDIT).name,
            contentId: match.params.contentId
        },
        // override with full-page-editor specific stop/collect behaviour
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            const loadExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_LOAD_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE);
            const closeExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE);
            $8c50530bac3b9ba1$var$stopOnCloseForEditPage(events, experience, loadExperienceName, closeExperienceName);
        }
    }, /* editorLoadExperience */ {
        name: isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_LOAD_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            const closeExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE);
            const closeExperience = events.find((event)=>(0, $gykrH.isStop)(event) && event.name === closeExperienceName);
            if (closeExperience) experience.abort({
                reason: 'Editor closed before load completed',
                attributes: {
                    closeExperienceState: closeExperience?.action ?? 'incomplete'
                }
            });
        }
    }, /* editorPublishExperience */ {
        name: isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_PUBLISH_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startCompanyHubEditor(transitionId, sessionData) {
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $irVI7.COMPANY_HUB_EDITOR_EXPERIENCE),
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: 'FABRIC',
            contentType: 'space',
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: true
        },
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            $8c50530bac3b9ba1$var$stopOnCloseForEditPage(events, experience, (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE), (0, $irVI7.COMPANY_HUB_EDITOR_CLOSE_EXPERIENCE));
        }
    }, /* editorLoadExperience */ {
        name: (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE),
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        }
    }, /* editorPublishExperience */ {
        name: (0, $irVI7.FRONT_COVER_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startViewContent(id, transitionId, contentType, query, sessionData, attributes) {
    // WS-3261 - We need to track if the view is coming from an external source (email notification, Slack, etc.)
    const isFromExternal = Boolean(query && query.atlOrigin);
    // Track APDEX part of the content (title and content itself)
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_CONTENT_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD,
        attributes: {
            contentType: contentType,
            isFromExternal: isFromExternal,
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            ...attributes
        },
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            $8c50530bac3b9ba1$var$stopOnConnectAddon(events, experience);
        }
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinkGlobalSettings(tab, space, transitionId) {
    if (tab === 'public-links' && !space) (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINK_SITE_SETTINGS_EXPERIENCE),
        id: 'public-links',
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinksSpaceSettings() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINKS_SPACE_SETTINGS_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinkSharedPage(id, transitionId) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINK_SHARED_PAGE_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startTemplateEditPage(id, transitionId) {
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        collect: (events, experience)=>{
            experience.stopOn(events.find((event)=>(0, $gykrH.isStop)(event) && event.name === (0, $irVI7.TEMPLATE_EDIT_PAGE_CLOSE_EXPERIENCE)));
        }
    }, /* editorLoadExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).TEMPLATE_EDITOR_LOAD
    }, /* editorPublishExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startAdvancedSearch(match) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
        id: (0, $hukUK.objectHash)((0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))(match.query, [
            'search_id'
        ]))
    });
}
function $8c50530bac3b9ba1$var$startArchivedPagesList() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_ARCHIVED_PAGES_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startContentManager() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CONTENT_MANAGER_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startSpaceDirectory() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_DIRECTORY_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).SPACE_DIRECTORY
    });
}
function $8c50530bac3b9ba1$var$startTemplateGallery() {
    const TemplateGallerySubExperiences = [
        (0, $irVI7.TEMPLATE_GALLERY_CATEGORIES_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_SPACE_SELECTOR_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_CARDS_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_TEMPLATE_DETAIL_EXPERIENCE)
    ];
    const collectTemplateGalleryLoadExperiences = (events, experience)=>{
        (0, $1A7bE.collectAll)(TemplateGallerySubExperiences)(events, experience);
    };
    const stopOnRestrictedPage = (0, $1A7bE.collectAll)([
        (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE)
    ]);
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.TEMPLATE_GALLERY_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT,
        collect: (events, experience)=>{
            collectTemplateGalleryLoadExperiences(events, experience);
            stopOnRestrictedPage(events, experience);
        }
    });
}
function $8c50530bac3b9ba1$var$startSpacePages() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_PAGES_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startCreateContent(match, sessionData, subType) {
    const queryParams = match.query;
    const isPersonalSpace = queryParams.spaceKey?.[0] !== undefined ? (queryParams.spaceKey[0] === '~').toString() : 'unknown';
    const flow = (0, $c3Qwv.getSingleParam)(queryParams, 'source') || 'createContentRoute';
    if (match.params.contentType === 'whiteboard') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const whiteboardExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.WHITEBOARD_EXPERIENCE));
            if (whiteboardExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'database') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const databaseExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.DATABASE_EXPERIENCE));
            if (databaseExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'smartLinkEmbed') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_EMBED_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const smartLinkEmbedExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.EMBED_EXPERIENCE));
            if (smartLinkEmbedExperienceStart) experience.succeed();
        }
    });
    else if ([
        'page',
        'blog'
    ].includes(match.params.contentType)) (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            contentType: match.params.contentType,
            flow: flow,
            isCreateContentRoute: true,
            isPersonalSpace: isPersonalSpace,
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isLivePage: subType?.toLowerCase() === 'live'
        },
        collect: (events, experience)=>{
            const editPageStarted = events.find((event)=>event.action === 'taskStart' && (event.name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) || event.name === (0, $irVI7.EDIT_LEGACY_PAGE_EXPERIENCE)));
            if (editPageStarted) experience.succeed();
        }
    });
}
function $8c50530bac3b9ba1$var$startWhiteboardBoard(match) {
    const embeddedWhiteboardSubExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE)
    ];
    const whiteboardSubExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE),
        (0, $irVI7.VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_WATCH_EXPERIENCE)
    ];
    const objectHeaderWhiteboardSubExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const subExperiences = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? objectHeaderWhiteboardSubExperiences : whiteboardSubExperiences;
    const isEmbedded = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const contentId = match.params.contentId;
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.WHITEBOARD_EXPERIENCE), isEmbedded ? embeddedWhiteboardSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startDatabaseView(contentId) {
    const databaseSubExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE),
        (0, $irVI7.VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE)
    ];
    const objectHeaderDatabaseSubExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const subExperiences = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? objectHeaderDatabaseSubExperiences : databaseSubExperiences;
    const embeddedDatabaseSubExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE)
    ];
    const isEmbedded = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.DATABASE_EXPERIENCE), isEmbedded ? embeddedDatabaseSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, mainExperience, subExperiences) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: mainExperience,
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(subExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    subExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startEmbedPageView(contentId) {
    const embedPageSubExperiences = [
        (0, $irVI7.EMBED_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE),
        (0, $irVI7.VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE)
    ];
    const objectHeaderEmbedSubExperiences = [
        (0, $irVI7.EMBED_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const subExperiences = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? objectHeaderEmbedSubExperiences : embedPageSubExperiences;
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.EMBED_EXPERIENCE),
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(subExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    embedPageSubExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startFolderView(contentId) {
    const folderSubExperiences = [
        (0, $irVI7.FOLDER_CONTENT_EXPERIENCE)
    ];
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.FOLDER_EXPERIENCE),
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(folderSubExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    folderSubExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startViewAdminAnnouncementBannerSettings() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.ADMIN_ANNOUNCEMENT_BANNER_SETTINGS_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$startSpaceManager() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_MANAGER_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$startCompanyHomeBuilderLoad() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.COMPANY_HOME_BUILDER_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$finishLivePageExperiences() {
    const tracker = (0, $fGzMp.getExperienceTracker)();
    const livePageExperiencesToSucceed = [
        (0, $irVI7.EDIT_PAGE_EXPERIENCE),
        (0, $irVI7.LIVE_PAGE_SESSION_EXPERIENCE)
    ];
    livePageExperiencesToSucceed.forEach((experience)=>{
        const experienceState = tracker.getExperienceState(experience);
        // We want to identify if it's actively running, and if so, succeed it. This aligns with how we succeed non-live-page experiences on transition.
        // We validate the `isLivePage` attribute is `true` before succeeding, to avoid undesirably succeeding edit-page here when it's not a live page
        if (experienceState && !experienceState?.hasStopped && experienceState?.attributes?.isLivePage) tracker.succeed({
            name: experience
        });
    });
}
module.exports["routeNameToContentTypeMap"] = $8c50530bac3b9ba1$export$4b786e0ae0cc0857;
module.exports["startExperienceForRoute"] = $8c50530bac3b9ba1$export$cac1117e2433d80e;
module.exports["startUFOPressTrace"] = $8c50530bac3b9ba1$export$b9a409823a06b924;
module.exports["startEditorExperiences"] = $8c50530bac3b9ba1$export$478e84e2cc5ff22d;
module.exports["startEditorSubExperience"] = $8c50530bac3b9ba1$export$7df6656d8508e8da;

});

parcelRegister("5qzNs", function(module, exports) {

var $5ukOg = parcelRequire("5ukOg");


var $ipwYn = parcelRequire("ipwYn");


var $5kt6R = parcelRequire("5kt6R");


var $f2rYC = parcelRequire("f2rYC");


var $gR42R = parcelRequire("gR42R");


var $5baaE = parcelRequire("5baaE");


var $5Nw7l = parcelRequire("5Nw7l");


var $jHiyU = parcelRequire("jHiyU");

/** Used to compose bitmasks for cloning. */ var $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG = 1, $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG = 2, $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3f3b25eb0c07a9d2$var$omit = $5Nw7l(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $5ukOg(paths, function(path) {
        path = $f2rYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $gR42R(object, $jHiyU(object), result);
    if (isDeep) result = $ipwYn(result, $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG | $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG | $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG, $5baaE);
    var length = paths.length;
    while(length--)$5kt6R(result, paths[length]);
    return result;
});
module.exports = $3f3b25eb0c07a9d2$var$omit;

});

parcelRegister("ipwYn", function(module, exports) {

var $en5bh = parcelRequire("en5bh");


var $hLryH = parcelRequire("hLryH");


var $jykdj = parcelRequire("jykdj");


var $3g4Fn = parcelRequire("3g4Fn");


var $juOMD = parcelRequire("juOMD");


var $dYI4C = parcelRequire("dYI4C");


var $irmBX = parcelRequire("irmBX");


var $3qHtb = parcelRequire("3qHtb");


var $80RNM = parcelRequire("80RNM");


var $d5B92 = parcelRequire("d5B92");


var $jHiyU = parcelRequire("jHiyU");


var $1WABR = parcelRequire("1WABR");


var $1Z3rm = parcelRequire("1Z3rm");


var $ka5vO = parcelRequire("ka5vO");


var $8LtzT = parcelRequire("8LtzT");


var $fZxmY = parcelRequire("fZxmY");


var $cSA01 = parcelRequire("cSA01");


var $83PD5 = parcelRequire("83PD5");


var $lc9ud = parcelRequire("lc9ud");


var $6b9OI = parcelRequire("6b9OI");


var $d6TaN = parcelRequire("d6TaN");


var $jVTxf = parcelRequire("jVTxf");

/** Used to compose bitmasks for cloning. */ var $d674238523d4f2bb$var$CLONE_DEEP_FLAG = 1, $d674238523d4f2bb$var$CLONE_FLAT_FLAG = 2, $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $d674238523d4f2bb$var$argsTag = '[object Arguments]', $d674238523d4f2bb$var$arrayTag = '[object Array]', $d674238523d4f2bb$var$boolTag = '[object Boolean]', $d674238523d4f2bb$var$dateTag = '[object Date]', $d674238523d4f2bb$var$errorTag = '[object Error]', $d674238523d4f2bb$var$funcTag = '[object Function]', $d674238523d4f2bb$var$genTag = '[object GeneratorFunction]', $d674238523d4f2bb$var$mapTag = '[object Map]', $d674238523d4f2bb$var$numberTag = '[object Number]', $d674238523d4f2bb$var$objectTag = '[object Object]', $d674238523d4f2bb$var$regexpTag = '[object RegExp]', $d674238523d4f2bb$var$setTag = '[object Set]', $d674238523d4f2bb$var$stringTag = '[object String]', $d674238523d4f2bb$var$symbolTag = '[object Symbol]', $d674238523d4f2bb$var$weakMapTag = '[object WeakMap]';
var $d674238523d4f2bb$var$arrayBufferTag = '[object ArrayBuffer]', $d674238523d4f2bb$var$dataViewTag = '[object DataView]', $d674238523d4f2bb$var$float32Tag = '[object Float32Array]', $d674238523d4f2bb$var$float64Tag = '[object Float64Array]', $d674238523d4f2bb$var$int8Tag = '[object Int8Array]', $d674238523d4f2bb$var$int16Tag = '[object Int16Array]', $d674238523d4f2bb$var$int32Tag = '[object Int32Array]', $d674238523d4f2bb$var$uint8Tag = '[object Uint8Array]', $d674238523d4f2bb$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d674238523d4f2bb$var$uint16Tag = '[object Uint16Array]', $d674238523d4f2bb$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $d674238523d4f2bb$var$cloneableTags = {};
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$argsTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayBufferTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dataViewTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$boolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dateTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float64Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$mapTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$numberTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$objectTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$regexpTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$setTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$stringTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$symbolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8ClampedTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint32Tag] = true;
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$errorTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$funcTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $d674238523d4f2bb$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $d674238523d4f2bb$var$CLONE_DEEP_FLAG, isFlat = bitmask & $d674238523d4f2bb$var$CLONE_FLAT_FLAG, isFull = bitmask & $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lc9ud(value)) return value;
    var isArr = $fZxmY(value);
    if (isArr) {
        result = $1Z3rm(value);
        if (!isDeep) return $irmBX(value, result);
    } else {
        var tag = $1WABR(value), isFunc = tag == $d674238523d4f2bb$var$funcTag || tag == $d674238523d4f2bb$var$genTag;
        if ($cSA01(value)) return $dYI4C(value, isDeep);
        if (tag == $d674238523d4f2bb$var$objectTag || tag == $d674238523d4f2bb$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $8LtzT(value);
            if (!isDeep) return isFlat ? $80RNM(value, $juOMD(result, value)) : $3qHtb(value, $3g4Fn(result, value));
        } else {
            if (!$d674238523d4f2bb$var$cloneableTags[tag]) return object ? value : {};
            result = $ka5vO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $en5bh);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($6b9OI(value)) value.forEach(function(subValue) {
        result.add($d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($83PD5(value)) value.forEach(function(subValue, key) {
        result.set(key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $jHiyU : $d5B92 : isFlat ? $jVTxf : $d6TaN;
    var props = isArr ? undefined : keysFunc(value);
    $hLryH(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $jykdj(result, key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $d674238523d4f2bb$var$baseClone;

});

parcelRegister("hLryH", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $ceec3402dc147ea9$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $ceec3402dc147ea9$var$arrayEach;

});

parcelRegister("3g4Fn", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $25f67c63e240b594$var$baseAssign(object, source) {
    return object && $gR42R(source, $d6TaN(source), object);
}
module.exports = $25f67c63e240b594$var$baseAssign;

});

parcelRegister("juOMD", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jVTxf = parcelRequire("jVTxf");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $e318362ea5151771$var$baseAssignIn(object, source) {
    return object && $gR42R(source, $jVTxf(source), object);
}
module.exports = $e318362ea5151771$var$baseAssignIn;

});

parcelRegister("3qHtb", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jcne3 = parcelRequire("jcne3");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $27f584f8141687cb$var$copySymbols(source, object) {
    return $gR42R(source, $jcne3(source), object);
}
module.exports = $27f584f8141687cb$var$copySymbols;

});

parcelRegister("80RNM", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $75Obx = parcelRequire("75Obx");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $5d580ec319704467$var$copySymbolsIn(source, object) {
    return $gR42R(source, $75Obx(source), object);
}
module.exports = $5d580ec319704467$var$copySymbolsIn;

});

parcelRegister("1Z3rm", function(module, exports) {
/** Used for built-in method references. */ var $171e28212cd49be3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $171e28212cd49be3$var$hasOwnProperty = $171e28212cd49be3$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $171e28212cd49be3$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $171e28212cd49be3$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $171e28212cd49be3$var$initCloneArray;

});

parcelRegister("ka5vO", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");


var $43GUE = parcelRequire("43GUE");


var $62nGv = parcelRequire("62nGv");


var $eBmVy = parcelRequire("eBmVy");


var $jDkcM = parcelRequire("jDkcM");

/** `Object#toString` result references. */ var $ead9046a77579327$var$boolTag = '[object Boolean]', $ead9046a77579327$var$dateTag = '[object Date]', $ead9046a77579327$var$mapTag = '[object Map]', $ead9046a77579327$var$numberTag = '[object Number]', $ead9046a77579327$var$regexpTag = '[object RegExp]', $ead9046a77579327$var$setTag = '[object Set]', $ead9046a77579327$var$stringTag = '[object String]', $ead9046a77579327$var$symbolTag = '[object Symbol]';
var $ead9046a77579327$var$arrayBufferTag = '[object ArrayBuffer]', $ead9046a77579327$var$dataViewTag = '[object DataView]', $ead9046a77579327$var$float32Tag = '[object Float32Array]', $ead9046a77579327$var$float64Tag = '[object Float64Array]', $ead9046a77579327$var$int8Tag = '[object Int8Array]', $ead9046a77579327$var$int16Tag = '[object Int16Array]', $ead9046a77579327$var$int32Tag = '[object Int32Array]', $ead9046a77579327$var$uint8Tag = '[object Uint8Array]', $ead9046a77579327$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ead9046a77579327$var$uint16Tag = '[object Uint16Array]', $ead9046a77579327$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ead9046a77579327$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $ead9046a77579327$var$arrayBufferTag:
            return $jZrbP(object);
        case $ead9046a77579327$var$boolTag:
        case $ead9046a77579327$var$dateTag:
            return new Ctor(+object);
        case $ead9046a77579327$var$dataViewTag:
            return $43GUE(object, isDeep);
        case $ead9046a77579327$var$float32Tag:
        case $ead9046a77579327$var$float64Tag:
        case $ead9046a77579327$var$int8Tag:
        case $ead9046a77579327$var$int16Tag:
        case $ead9046a77579327$var$int32Tag:
        case $ead9046a77579327$var$uint8Tag:
        case $ead9046a77579327$var$uint8ClampedTag:
        case $ead9046a77579327$var$uint16Tag:
        case $ead9046a77579327$var$uint32Tag:
            return $jDkcM(object, isDeep);
        case $ead9046a77579327$var$mapTag:
            return new Ctor;
        case $ead9046a77579327$var$numberTag:
        case $ead9046a77579327$var$stringTag:
            return new Ctor(object);
        case $ead9046a77579327$var$regexpTag:
            return $62nGv(object);
        case $ead9046a77579327$var$setTag:
            return new Ctor;
        case $ead9046a77579327$var$symbolTag:
            return $eBmVy(object);
    }
}
module.exports = $ead9046a77579327$var$initCloneByTag;

});

parcelRegister("43GUE", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $2f48bad00268e015$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jZrbP(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $2f48bad00268e015$var$cloneDataView;

});

parcelRegister("62nGv", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $46554d38b2abfa6c$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $46554d38b2abfa6c$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $46554d38b2abfa6c$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $46554d38b2abfa6c$var$cloneRegExp;

});

parcelRegister("eBmVy", function(module, exports) {

var $agzqu = parcelRequire("agzqu");

/** Used to convert symbols to primitives and strings. */ var $aa164e47d9e5bdc6$var$symbolProto = $agzqu ? $agzqu.prototype : undefined, $aa164e47d9e5bdc6$var$symbolValueOf = $aa164e47d9e5bdc6$var$symbolProto ? $aa164e47d9e5bdc6$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $aa164e47d9e5bdc6$var$cloneSymbol(symbol) {
    return $aa164e47d9e5bdc6$var$symbolValueOf ? Object($aa164e47d9e5bdc6$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $aa164e47d9e5bdc6$var$cloneSymbol;

});

parcelRegister("83PD5", function(module, exports) {

var $3Ap6k = parcelRequire("3Ap6k");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $5de6a718766ecdb3$var$nodeIsMap = $cl53l && $cl53l.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $5de6a718766ecdb3$var$isMap = $5de6a718766ecdb3$var$nodeIsMap ? $dFnBO($5de6a718766ecdb3$var$nodeIsMap) : $3Ap6k;
module.exports = $5de6a718766ecdb3$var$isMap;

});

parcelRegister("3Ap6k", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $29c8346be35e214d$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $29c8346be35e214d$var$baseIsMap(value) {
    return $6eZU2(value) && $1WABR(value) == $29c8346be35e214d$var$mapTag;
}
module.exports = $29c8346be35e214d$var$baseIsMap;

});

parcelRegister("6b9OI", function(module, exports) {

var $sQE8x = parcelRequire("sQE8x");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $47fb629c5fa31bac$var$nodeIsSet = $cl53l && $cl53l.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $47fb629c5fa31bac$var$isSet = $47fb629c5fa31bac$var$nodeIsSet ? $dFnBO($47fb629c5fa31bac$var$nodeIsSet) : $sQE8x;
module.exports = $47fb629c5fa31bac$var$isSet;

});

parcelRegister("sQE8x", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $056b741c66fd28fb$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $056b741c66fd28fb$var$baseIsSet(value) {
    return $6eZU2(value) && $1WABR(value) == $056b741c66fd28fb$var$setTag;
}
module.exports = $056b741c66fd28fb$var$baseIsSet;

});

parcelRegister("5kt6R", function(module, exports) {

var $f2rYC = parcelRequire("f2rYC");


var $apAFY = parcelRequire("apAFY");


var $9rfkh = parcelRequire("9rfkh");


var $w287Y = parcelRequire("w287Y");

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3e1566926de40aab$var$baseUnset(object, path) {
    path = $f2rYC(path, object);
    object = $9rfkh(object, path);
    return object == null || delete object[$w287Y($apAFY(path))];
}
module.exports = $3e1566926de40aab$var$baseUnset;

});

parcelRegister("9rfkh", function(module, exports) {

var $aT80v = parcelRequire("aT80v");


var $3BqCC = parcelRequire("3BqCC");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $6df28623e183fd76$var$parent(object, path) {
    return path.length < 2 ? object : $aT80v(object, $3BqCC(path, 0, -1));
}
module.exports = $6df28623e183fd76$var$parent;

});

parcelRegister("5baaE", function(module, exports) {

var $gTZCn = parcelRequire("gTZCn");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $3c55de8c787dd7a6$var$customOmitClone(value) {
    return $gTZCn(value) ? undefined : value;
}
module.exports = $3c55de8c787dd7a6$var$customOmitClone;

});

parcelRegister("5Nw7l", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $438a713c021efc47$var$flatRest(func) {
    return $gnVVm($iK2Oc(func, undefined, $5qOzM), func + '');
}
module.exports = $438a713c021efc47$var$flatRest;

});

parcelRegister("5qOzM", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f469ccb29f16086$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8jC8i(array, 1) : [];
}
module.exports = $3f469ccb29f16086$var$flatten;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("hukUK", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $1AV5C = parcelRequire("1AV5C");

let $ad68a267ac2e31a8$var$SESSION_SALT;
const $ad68a267ac2e31a8$export$237ebf1f4974c28e = ()=>{
    $ad68a267ac2e31a8$var$SESSION_SALT = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
};
const $ad68a267ac2e31a8$var$toStringArray = (arr)=>`[${arr.map((item)=>$ad68a267ac2e31a8$var$toString(item)).join(',')}]`;
const $ad68a267ac2e31a8$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $ad68a267ac2e31a8$var$toStringArray(o);
    if (typeof o == 'object') return $ad68a267ac2e31a8$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $ad68a267ac2e31a8$export$66b1d6a1029e925d = (o)=>{
    if (!$ad68a267ac2e31a8$var$SESSION_SALT) $ad68a267ac2e31a8$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$ad68a267ac2e31a8$var$toString(value)}`).join()},${$ad68a267ac2e31a8$var$SESSION_SALT}`;
    return (0, $1AV5C.hashData)(strToHash);
};
module.exports["objectHash"] = $ad68a267ac2e31a8$export$66b1d6a1029e925d;

});

parcelRegister("1A7bE", function(module, exports) {

var $gykrH = parcelRequire("gykrH");

const $812facbbd37978f7$export$feb7963ae429f97f = (experienceNames)=>{
    const experienceNameSet = new Set(experienceNames);
    return (events, experience)=>{
        // Fail as soon as any sub-experience is failed or aborted
        experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')), {
            incompleteSubExperiences: [
                ...experienceNameSet
            ].join(', ')
        });
        // If there's a success remove the experience from the set
        // of experiences we're waiting for.
        events.forEach((event)=>{
            if ((0, $gykrH.isStop)(event)) experienceNameSet.delete(event.name);
        });
        // Experience is considered complete if all sub-experiences
        // are complete.
        if (experienceNameSet.size === 0) experience.succeed();
    };
};
const $812facbbd37978f7$export$79dbdd3e43727beb = (experienceNames)=>(events, experience)=>experience.stopOn(events.find((event)=>(0, $gykrH.isStop)(event) && (0, $gykrH.hasName)(event, ...experienceNames)));
module.exports["collectAll"] = $812facbbd37978f7$export$feb7963ae429f97f;
module.exports["collectAny"] = $812facbbd37978f7$export$79dbdd3e43727beb;

});

parcelRegister("h10mo", function(module, exports) {

var $1dnxO = parcelRequire("1dnxO");


var $irVI7 = parcelRequire("irVI7");


var $gykrH = parcelRequire("gykrH");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");

const $49be9d39a158f0e7$var$homeSubExperiences = [
    (0, $irVI7.HOME_OVERVIEW_EXPERIENCE),
    (0, $irVI7.HOME_RECENT_EXPERIENCE),
    (0, $irVI7.HOME_STARRED_EXPERIENCE),
    (0, $irVI7.HOME_WATCHING_EXPERIENCE),
    (0, $irVI7.HOME_DRAFTS_EXPERIENCE)
];
function $49be9d39a158f0e7$var$collectHomeNav3(events, experience) {
    const homeExperiences = new Set($49be9d39a158f0e7$var$homeSubExperiences);
    // stop as soon as any sub-experience is failed or aborted
    experience.stopOn(events.find((event)=>(event.action === 'taskFail' || event.action === 'taskAbort') && (homeExperiences.has(event.name) || event.name === (0, $irVI7.HOME_SPACES_EXPERIENCE))));
    // if any of the view experiences succeed AND the spaces experience succeeds, the root home experience should succeed
    let viewExperienceDidSucceed = false;
    let spacesExperienceDidSucceed = false;
    events.forEach((event)=>{
        if ((0, $gykrH.isStop)(event)) {
            if (homeExperiences.has(event.name)) viewExperienceDidSucceed = true;
            if (event.name === (0, $irVI7.HOME_SPACES_EXPERIENCE) && event.action === 'taskSuccess') spacesExperienceDidSucceed = true;
        }
    });
    if (viewExperienceDidSucceed && spacesExperienceDidSucceed) experience.succeed();
}
function $49be9d39a158f0e7$export$4278268ff5675d74() {
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.HOME_EXPERIENCE),
        collect: isNav4Enabled ? (0, $1A7bE.collectAny)($49be9d39a158f0e7$var$homeSubExperiences) : $49be9d39a158f0e7$var$collectHomeNav3
    });
}
module.exports["startHome"] = $49be9d39a158f0e7$export$4278268ff5675d74;

});

parcelRegister("3YBks", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");

let $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
let $3ac00da98b683ca3$var$runningExperiences = [];
// Note: The soft failure is set on the first soft failure not updated following
let $3ac00da98b683ca3$var$softFailure = undefined;
let $3ac00da98b683ca3$var$publishFailed = false;
let $3ac00da98b683ca3$var$publishSuccessCount = 0;
function $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug(experienceName) {
    function createInlineCommentExperienceDebug({ error: error, createAnalyticsEvent: createAnalyticsEvent, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceAttributes = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'error',
                actionSubject: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
                source: experienceName,
                attributes: {
                    ...experienceAttributes,
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
                    ...extraAttributes,
                    error: error.message || String(error),
                    stack: error.stack
                }
            }
        }).fire();
    }
    return createInlineCommentExperienceDebug;
}
const $3ac00da98b683ca3$export$90894e50be2305e9 = {
    start: function createInlineCommentCompoundExperience({ attributes: attributes }) {
        // reset common experience state when starting a new parent experience
        $3ac00da98b683ca3$var$runningExperiences = [
            (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)
        ];
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
        $3ac00da98b683ca3$var$softFailure = undefined;
        $3ac00da98b683ca3$var$publishFailed = false;
        $3ac00da98b683ca3$var$publishSuccessCount = 0;
        const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.start({
            name: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
            id: compoundTaskId,
            attributes: {
                ...attributes,
                compoundTaskId: compoundTaskId
            },
            collect: (events, experience)=>{
                (0, $1A7bE.collectAll)([
                    (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                    (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
                ])(events, experience);
            }
        });
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            compoundTaskId: compoundTaskId,
            annotationId: attributes.annotationId,
            pageClass: attributes.pageClass,
            entryPoint: attributes.entryPoint
        };
    },
    debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)),
    addCommonAttributes: (commonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
            ...commonAttributes
        };
        for (const runningExperience of $3ac00da98b683ca3$var$runningExperiences)experienceTracker.updateAttributes({
            name: runningExperience,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    attachCommonAttributes: (experienceName)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.updateAttributes({
            name: experienceName,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    initExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                timeout: 5000,
                attributes: {
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
                }
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
        },
        fail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                error: error
            });
        },
        softFail: (error)=>{
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'init'
            };
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        abort: ({ abortReason: abortReason })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                reason: abortReason
            });
        },
        /**
     * This completes the init experience and starts the draft to publish experience.
     */ complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    draftToPublishExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
        },
        publishFailed: (error)=>{
            $3ac00da98b683ca3$var$publishFailed = true;
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'publish-failed'
            };
        },
        publishSucceeded: ()=>{
            $3ac00da98b683ca3$var$publishSuccessCount += 1;
        },
        abort: ({ abortReason: abortReason })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: abortReason
            });
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        stopOnError: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.stopOnError({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        dismissed: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$publishSuccessCount > 0) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish success')
            });
            else if ($3ac00da98b683ca3$var$publishFailed) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish attempt')
            });
            else experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: 'Draft comment dismissed'
            });
        },
        softFail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'multiple-saves-without-error'
            };
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    attachCommentExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                // If the view comment does not load in 6 seconds, it's
                // an indicator something has gone wrong.
                timeout: 6000,
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    }
};
module.exports["createInlineCommentCompoundExperience"] = $3ac00da98b683ca3$export$90894e50be2305e9;

});

parcelRegister("8WQTF", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $4677820b18a14e4d$export$66feffbad722f9d4 = /*#__PURE__*/ (0, $42omo.createContext)({
    rendererActions: null,
    pageId: undefined,
    pageAdf: undefined
});
$4677820b18a14e4d$export$66feffbad722f9d4.displayName = 'RendererActionsContext';
const $4677820b18a14e4d$export$c7c5640cf8aff722 = /*#__PURE__*/ (0, $42omo.createContext)({
    setRendererActions: ()=>{},
    setPageAdf: ()=>{}
});
$4677820b18a14e4d$export$c7c5640cf8aff722.displayName = 'RendererActionsDispatchContext';
const $4677820b18a14e4d$export$a41bfe8d4028fb59 = ({ children: children })=>{
    const [rendererActions, setRendererActions] = (0, $42omo.useState)(null);
    const [pageId, setPageId] = (0, $42omo.useState)(undefined);
    const [pageAdf, setPageAdf] = (0, $42omo.useState)(undefined);
    const providerValue = (0, $42omo.useMemo)(()=>({
            rendererActions: rendererActions,
            pageId: pageId,
            pageAdf: pageAdf
        }), [
        rendererActions,
        pageId,
        pageAdf
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setRendererActions: (actions, newPageId)=>{
                setRendererActions(actions);
                setPageId(newPageId);
            },
            setPageAdf: (newPageAdf)=>{
                setPageAdf(newPageAdf);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4677820b18a14e4d$export$66feffbad722f9d4.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4677820b18a14e4d$export$c7c5640cf8aff722.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $4677820b18a14e4d$export$55249bdd00e8a5d6 = ()=>{
    return (0, $42omo.useContext)($4677820b18a14e4d$export$66feffbad722f9d4);
};
const $4677820b18a14e4d$export$6e9863dfedeaae60 = ()=>{
    return (0, $42omo.useContext)($4677820b18a14e4d$export$c7c5640cf8aff722);
};
module.exports["RendererActionsProvider"] = $4677820b18a14e4d$export$a41bfe8d4028fb59;
module.exports["useRendererActions"] = $4677820b18a14e4d$export$55249bdd00e8a5d6;
module.exports["useRendererActionsDispatch"] = $4677820b18a14e4d$export$6e9863dfedeaae60;

});

parcelRegister("dANtQ", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");

const $be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery = (0, $eSUdr.default)`query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId:ID!){content(id:$contentId status:["draft" "current"]){nodes{id type operations{operation targetType}}}}`;
const $be6154107952d370$export$4cae5d8963399c48 = (contentId, cacheOnly = false)=>{
    const { data: data, loading: loading, error: error, refetch: refetch, networkStatus: networkStatus } = (0, $xQxzY.useQuery)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        variables: {
            contentId: contentId
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: cacheOnly ? 'cache-only' : 'cache-and-network',
        skip: !contentId
    });
    const contentNode = data?.content?.nodes?.[0];
    const operations = contentNode?.operations ?? [];
    const createPermission = operations.some((operationResults)=>operationResults?.operation === 'create' && operationResults?.targetType === 'comment');
    return {
        canAddComments: createPermission,
        loading: loading,
        contentQueryError: error,
        refetch: refetch,
        networkStatus: networkStatus
    };
};
module.exports["useAddCommentPermissionCheck"] = $be6154107952d370$export$4cae5d8963399c48;

});

parcelRegister("2eC70", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $54a9888a279e8118$export$eb5d3a5abb22f159 = ()=>{
    return {
        newDataManagerEnabled: (0, $6mKj3.UNSAFE_expValNoExposure)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    };
};
module.exports["getCommentsDataManagerExperimentAttributes"] = $54a9888a279e8118$export$eb5d3a5abb22f159;

});

parcelRegister("cMvMc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f2899d935411e961$export$fb31a121515f224d = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "_Vqh0",
    name: "CommentWarningDialog",
    loader: async ()=>(await (parcelRequire("8FCWK"))).CommentWarningDialog
});
module.exports["CommentWarningDialog"] = $f2899d935411e961$export$fb31a121515f224d;

});

parcelRegister("8FCWK", function(module, exports) {

let $65005d03f1075b43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $65005d03f1075b43$var$load("hhss7"),
    $65005d03f1075b43$var$load("cqNU4")
]).then(()=>parcelRequire('9c4UU'));

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("bSvtO", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $45ca38ec521afdf7$var$initialState = {
    hasContentChanged: false,
    isCommentContentReady: false
};
const $45ca38ec521afdf7$export$53ac33307b5acee9 = ()=>({
        hasContentChanged: false,
        isCommentContentReady: false
    });
const $45ca38ec521afdf7$export$e324594224ef24da = {
    onChange: (hasChanges)=>({ setState: setState })=>{
            setState({
                hasContentChanged: hasChanges
            });
        },
    resetContentChanged: ()=>({ setState: setState })=>{
            setState({
                hasContentChanged: false
            });
        },
    onCommentContentReady: ()=>({ setState: setState })=>{
            setState({
                isCommentContentReady: true
            });
        }
};
const $45ca38ec521afdf7$var$CommentsContentStore = (0, $1P1Tu.createStore)({
    initialState: $45ca38ec521afdf7$var$initialState,
    actions: $45ca38ec521afdf7$export$e324594224ef24da,
    name: 'CommentsContentStore'
});
const $45ca38ec521afdf7$export$ef1bfc0b6758ca67 = (0, $9zUhf.createHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$e2038e591f93e866 = (0, $9zUhf.createActionsHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$1756d05b0495e6b = (0, $9zUhf.createStateHook)($45ca38ec521afdf7$var$CommentsContentStore);
module.exports["useCommentsContentActions"] = $45ca38ec521afdf7$export$e2038e591f93e866;
module.exports["useCommentsContentState"] = $45ca38ec521afdf7$export$1756d05b0495e6b;

});

parcelRegister("9buj5", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");


var $8i27m = parcelRequire("8i27m");


var $fHAwL = parcelRequire("fHAwL");


var $3mVfX = parcelRequire("3mVfX");


var $9wGTI = parcelRequire("9wGTI");

const $02faaefae22f6672$var$useUnreadPanelCommentsMarkInlineCommentsReadMutation = (0, $eSUdr.default)`mutation useUnreadPanelCommentsMarkInlineCommentsReadMutation($commentIds:[ID!]!){markCommentsAsRead(input:{commentIds:$commentIds}){success errors}}`;
const $02faaefae22f6672$export$b2c07ec1a20446f7 = ()=>{
    const [{ commentsMarkedAsRead: commentsMarkedAsRead }, { clearCommentsMarkedAsRead: clearCommentsMarkedAsRead }] = (0, $3mVfX.useCommentsPanel)();
    const { updateUnreadStatus: updateUnreadStatus } = (0, $8i27m.useCommentsDataActions)();
    const [{ readCommentsListState: readCommentsListState, unreadCommentsListState: unreadCommentsListState }, { updateReadCommentsListState: updateReadCommentsListState, updateUnreadCommentsListState: updateUnreadCommentsListState }] = (0, $fHAwL.useUnreadComments)();
    // TODO: handle error
    const [markInlineCommentsRead] = (0, $1KmJq.useMutation)($02faaefae22f6672$var$useUnreadPanelCommentsMarkInlineCommentsReadMutation);
    // call the mutation to mark the list of comment IDs as read
    const handleMarkCommentsAsRead = (0, $42omo.useCallback)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        if (Object.keys(commentsMarkedAsRead.inline).length > 0 || Object.keys(commentsMarkedAsRead.general).length > 0) {
            const inlineCommentIdsToMarkAsRead = Object.values(commentsMarkedAsRead.inline).reduce((acc, set)=>{
                acc.push(...set);
                return acc;
            }, []);
            const generalCommentIdsToMarkAsRead = Object.values(commentsMarkedAsRead.general).reduce((acc, set)=>{
                acc.push(...set);
                return acc;
            }, []);
            const commentIdsToMarkAsRead = [
                ...inlineCommentIdsToMarkAsRead,
                ...generalCommentIdsToMarkAsRead
            ];
            if (!commentIdsToMarkAsRead?.length) return;
            markInlineCommentsRead({
                variables: {
                    commentIds: commentIdsToMarkAsRead
                }
            });
            // update our data store to indicate these comments are now read
            updateUnreadStatus(commentsMarkedAsRead, (0, $8i27m.UnreadAction).READ);
            // reset our list of comments to mark as read
            clearCommentsMarkedAsRead();
            // update existing unread and read data stores
            const commentIdsToMarkAsReadSet = new Set(commentIdsToMarkAsRead);
            const filteredUnreadComments = unreadCommentsListState.filter((unreadComment)=>!commentIdsToMarkAsReadSet.has(unreadComment.id));
            updateUnreadCommentsListState(()=>filteredUnreadComments);
            const newReadCommentsListState = new Set([
                ...readCommentsListState,
                ...commentIdsToMarkAsRead
            ]);
            updateReadCommentsListState(()=>newReadCommentsListState);
        }
    }, [
        markInlineCommentsRead,
        clearCommentsMarkedAsRead,
        commentsMarkedAsRead,
        updateUnreadStatus,
        readCommentsListState,
        unreadCommentsListState,
        updateReadCommentsListState,
        updateUnreadCommentsListState
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        const handleBeforeUnload = ()=>{
            // Mark comments as read if the user closes the window
            handleMarkCommentsAsRead();
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            // Mark comments as read when the component unmounts
            handleMarkCommentsAsRead();
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, $42omo.useMemo)(()=>({
            handleMarkCommentsAsRead: handleMarkCommentsAsRead
        }), [
        handleMarkCommentsAsRead
    ]);
};
module.exports["useUnreadPanelComments"] = $02faaefae22f6672$export$b2c07ec1a20446f7;

});

parcelRegister("31cJ9", function(module, exports) {

let $232b566f32005450$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $232b566f32005450$var$load("jxz2q"),
    $232b566f32005450$var$load("9jS5g"),
    $232b566f32005450$var$load("f1NVy"),
    $232b566f32005450$var$load("kHOMt"),
    $232b566f32005450$var$load("laMwR"),
    $232b566f32005450$var$load("aZinD"),
    $232b566f32005450$var$load("1QdXB"),
    $232b566f32005450$var$load("goLL0"),
    $232b566f32005450$var$load("9Z7qK"),
    $232b566f32005450$var$load("duPDN"),
    $232b566f32005450$var$load("afXyT"),
    $232b566f32005450$var$load("coJiW"),
    $232b566f32005450$var$load("1Jgsw"),
    $232b566f32005450$var$load("cPWI2"),
    $232b566f32005450$var$load("lkOIY"),
    $232b566f32005450$var$load("dh8Yu"),
    $232b566f32005450$var$load("fxPKA"),
    $232b566f32005450$var$load("4eboO"),
    $232b566f32005450$var$load("8YSo7"),
    $232b566f32005450$var$load("6FuHS"),
    $232b566f32005450$var$load("eyaRC"),
    $232b566f32005450$var$load("9ijrN"),
    $232b566f32005450$var$load("Wowvf"),
    $232b566f32005450$var$load("cyGuT"),
    $232b566f32005450$var$load("lrvSS"),
    $232b566f32005450$var$load("axHWl"),
    $232b566f32005450$var$load("8FbYE"),
    $232b566f32005450$var$load("dUevD"),
    $232b566f32005450$var$load("fZt2F"),
    $232b566f32005450$var$load("7u4WP"),
    $232b566f32005450$var$load("8Gekp"),
    $232b566f32005450$var$load("7e13v"),
    $232b566f32005450$var$load("let0D"),
    $232b566f32005450$var$load("aqr2D"),
    $232b566f32005450$var$load("6vyHt"),
    $232b566f32005450$var$load("6M36W"),
    $232b566f32005450$var$load("ioQAS"),
    $232b566f32005450$var$load("kUbUu"),
    $232b566f32005450$var$load("4Lgj0"),
    $232b566f32005450$var$load("kSJiq"),
    $232b566f32005450$var$load("5QKVr"),
    $232b566f32005450$var$load("bxFZs"),
    $232b566f32005450$var$load("gYeBT"),
    $232b566f32005450$var$load("9AHrA"),
    $232b566f32005450$var$load("gLGsg"),
    $232b566f32005450$var$load("eHDb1"),
    $232b566f32005450$var$load("2zUEf"),
    $232b566f32005450$var$load("iZU4p"),
    $232b566f32005450$var$load("kCMj8"),
    $232b566f32005450$var$load("5tz7G"),
    $232b566f32005450$var$load("6wr18"),
    $232b566f32005450$var$load("jwWp5"),
    $232b566f32005450$var$load("hhss7"),
    $232b566f32005450$var$load("7EorR"),
    $232b566f32005450$var$load("awqCy"),
    $232b566f32005450$var$load("ffEVr"),
    $232b566f32005450$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("67Tpc", function(module, exports) {

let $475e5fe958ff349f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $475e5fe958ff349f$var$load("jxz2q"),
    $475e5fe958ff349f$var$load("9jS5g"),
    $475e5fe958ff349f$var$load("f1NVy"),
    $475e5fe958ff349f$var$load("kHOMt"),
    $475e5fe958ff349f$var$load("laMwR"),
    $475e5fe958ff349f$var$load("aZinD"),
    $475e5fe958ff349f$var$load("1QdXB"),
    $475e5fe958ff349f$var$load("goLL0"),
    $475e5fe958ff349f$var$load("9Z7qK"),
    $475e5fe958ff349f$var$load("duPDN"),
    $475e5fe958ff349f$var$load("afXyT"),
    $475e5fe958ff349f$var$load("coJiW"),
    $475e5fe958ff349f$var$load("1Jgsw"),
    $475e5fe958ff349f$var$load("cPWI2"),
    $475e5fe958ff349f$var$load("lkOIY"),
    $475e5fe958ff349f$var$load("dh8Yu"),
    $475e5fe958ff349f$var$load("fxPKA"),
    $475e5fe958ff349f$var$load("4eboO"),
    $475e5fe958ff349f$var$load("8YSo7"),
    $475e5fe958ff349f$var$load("6FuHS"),
    $475e5fe958ff349f$var$load("eyaRC"),
    $475e5fe958ff349f$var$load("9ijrN"),
    $475e5fe958ff349f$var$load("Wowvf"),
    $475e5fe958ff349f$var$load("cyGuT"),
    $475e5fe958ff349f$var$load("lrvSS"),
    $475e5fe958ff349f$var$load("axHWl"),
    $475e5fe958ff349f$var$load("8FbYE"),
    $475e5fe958ff349f$var$load("dUevD"),
    $475e5fe958ff349f$var$load("fZt2F"),
    $475e5fe958ff349f$var$load("7u4WP"),
    $475e5fe958ff349f$var$load("8Gekp"),
    $475e5fe958ff349f$var$load("7e13v"),
    $475e5fe958ff349f$var$load("let0D"),
    $475e5fe958ff349f$var$load("aqr2D"),
    $475e5fe958ff349f$var$load("6vyHt"),
    $475e5fe958ff349f$var$load("6M36W"),
    $475e5fe958ff349f$var$load("ioQAS"),
    $475e5fe958ff349f$var$load("kUbUu"),
    $475e5fe958ff349f$var$load("4Lgj0"),
    $475e5fe958ff349f$var$load("kSJiq"),
    $475e5fe958ff349f$var$load("5QKVr"),
    $475e5fe958ff349f$var$load("bxFZs"),
    $475e5fe958ff349f$var$load("gYeBT"),
    $475e5fe958ff349f$var$load("9AHrA"),
    $475e5fe958ff349f$var$load("gLGsg"),
    $475e5fe958ff349f$var$load("eHDb1"),
    $475e5fe958ff349f$var$load("2zUEf"),
    $475e5fe958ff349f$var$load("iZU4p"),
    $475e5fe958ff349f$var$load("kCMj8"),
    $475e5fe958ff349f$var$load("5tz7G"),
    $475e5fe958ff349f$var$load("6wr18"),
    $475e5fe958ff349f$var$load("jwWp5"),
    $475e5fe958ff349f$var$load("hhss7"),
    $475e5fe958ff349f$var$load("7EorR"),
    $475e5fe958ff349f$var$load("awqCy"),
    $475e5fe958ff349f$var$load("ffEVr"),
    $475e5fe958ff349f$var$load("bZz7X")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("468Lh", function(module, exports) {

let $2fbe84d57611bf8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2fbe84d57611bf8a$var$load("jxz2q"),
    $2fbe84d57611bf8a$var$load("9jS5g"),
    $2fbe84d57611bf8a$var$load("f1NVy"),
    $2fbe84d57611bf8a$var$load("kHOMt"),
    $2fbe84d57611bf8a$var$load("laMwR"),
    $2fbe84d57611bf8a$var$load("aZinD"),
    $2fbe84d57611bf8a$var$load("1QdXB"),
    $2fbe84d57611bf8a$var$load("goLL0"),
    $2fbe84d57611bf8a$var$load("9Z7qK"),
    $2fbe84d57611bf8a$var$load("duPDN"),
    $2fbe84d57611bf8a$var$load("afXyT"),
    $2fbe84d57611bf8a$var$load("coJiW"),
    $2fbe84d57611bf8a$var$load("1Jgsw"),
    $2fbe84d57611bf8a$var$load("cPWI2"),
    $2fbe84d57611bf8a$var$load("lkOIY"),
    $2fbe84d57611bf8a$var$load("dh8Yu"),
    $2fbe84d57611bf8a$var$load("fxPKA"),
    $2fbe84d57611bf8a$var$load("4eboO"),
    $2fbe84d57611bf8a$var$load("8YSo7"),
    $2fbe84d57611bf8a$var$load("6FuHS"),
    $2fbe84d57611bf8a$var$load("eyaRC"),
    $2fbe84d57611bf8a$var$load("9ijrN"),
    $2fbe84d57611bf8a$var$load("Wowvf"),
    $2fbe84d57611bf8a$var$load("cyGuT"),
    $2fbe84d57611bf8a$var$load("lrvSS"),
    $2fbe84d57611bf8a$var$load("axHWl"),
    $2fbe84d57611bf8a$var$load("8FbYE"),
    $2fbe84d57611bf8a$var$load("dUevD"),
    $2fbe84d57611bf8a$var$load("fZt2F"),
    $2fbe84d57611bf8a$var$load("7u4WP"),
    $2fbe84d57611bf8a$var$load("8Gekp"),
    $2fbe84d57611bf8a$var$load("7e13v"),
    $2fbe84d57611bf8a$var$load("let0D"),
    $2fbe84d57611bf8a$var$load("aqr2D"),
    $2fbe84d57611bf8a$var$load("6vyHt"),
    $2fbe84d57611bf8a$var$load("6M36W"),
    $2fbe84d57611bf8a$var$load("ioQAS"),
    $2fbe84d57611bf8a$var$load("kUbUu"),
    $2fbe84d57611bf8a$var$load("4Lgj0"),
    $2fbe84d57611bf8a$var$load("kSJiq"),
    $2fbe84d57611bf8a$var$load("5QKVr"),
    $2fbe84d57611bf8a$var$load("bxFZs"),
    $2fbe84d57611bf8a$var$load("gYeBT"),
    $2fbe84d57611bf8a$var$load("9AHrA"),
    $2fbe84d57611bf8a$var$load("gLGsg"),
    $2fbe84d57611bf8a$var$load("eHDb1"),
    $2fbe84d57611bf8a$var$load("2zUEf"),
    $2fbe84d57611bf8a$var$load("iZU4p"),
    $2fbe84d57611bf8a$var$load("kCMj8"),
    $2fbe84d57611bf8a$var$load("5tz7G"),
    $2fbe84d57611bf8a$var$load("6wr18"),
    $2fbe84d57611bf8a$var$load("jwWp5"),
    $2fbe84d57611bf8a$var$load("hhss7"),
    $2fbe84d57611bf8a$var$load("7EorR"),
    $2fbe84d57611bf8a$var$load("awqCy"),
    $2fbe84d57611bf8a$var$load("ffEVr"),
    $2fbe84d57611bf8a$var$load("bZz7X")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("6zTnr", function(module, exports) {

let $4ca0f7b250cca4fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4ca0f7b250cca4fc$var$load("jxz2q"),
    $4ca0f7b250cca4fc$var$load("9jS5g"),
    $4ca0f7b250cca4fc$var$load("f1NVy"),
    $4ca0f7b250cca4fc$var$load("kHOMt"),
    $4ca0f7b250cca4fc$var$load("laMwR"),
    $4ca0f7b250cca4fc$var$load("aZinD"),
    $4ca0f7b250cca4fc$var$load("1QdXB"),
    $4ca0f7b250cca4fc$var$load("goLL0"),
    $4ca0f7b250cca4fc$var$load("9Z7qK"),
    $4ca0f7b250cca4fc$var$load("duPDN"),
    $4ca0f7b250cca4fc$var$load("afXyT"),
    $4ca0f7b250cca4fc$var$load("coJiW"),
    $4ca0f7b250cca4fc$var$load("1Jgsw"),
    $4ca0f7b250cca4fc$var$load("cPWI2"),
    $4ca0f7b250cca4fc$var$load("lkOIY"),
    $4ca0f7b250cca4fc$var$load("dh8Yu"),
    $4ca0f7b250cca4fc$var$load("fxPKA"),
    $4ca0f7b250cca4fc$var$load("4eboO"),
    $4ca0f7b250cca4fc$var$load("8YSo7"),
    $4ca0f7b250cca4fc$var$load("6FuHS"),
    $4ca0f7b250cca4fc$var$load("eyaRC"),
    $4ca0f7b250cca4fc$var$load("9ijrN"),
    $4ca0f7b250cca4fc$var$load("Wowvf"),
    $4ca0f7b250cca4fc$var$load("cyGuT"),
    $4ca0f7b250cca4fc$var$load("lrvSS"),
    $4ca0f7b250cca4fc$var$load("axHWl"),
    $4ca0f7b250cca4fc$var$load("8FbYE"),
    $4ca0f7b250cca4fc$var$load("dUevD"),
    $4ca0f7b250cca4fc$var$load("fZt2F"),
    $4ca0f7b250cca4fc$var$load("7u4WP"),
    $4ca0f7b250cca4fc$var$load("8Gekp"),
    $4ca0f7b250cca4fc$var$load("7e13v"),
    $4ca0f7b250cca4fc$var$load("let0D"),
    $4ca0f7b250cca4fc$var$load("aqr2D"),
    $4ca0f7b250cca4fc$var$load("6vyHt"),
    $4ca0f7b250cca4fc$var$load("6M36W"),
    $4ca0f7b250cca4fc$var$load("ioQAS"),
    $4ca0f7b250cca4fc$var$load("kUbUu"),
    $4ca0f7b250cca4fc$var$load("4Lgj0"),
    $4ca0f7b250cca4fc$var$load("kSJiq"),
    $4ca0f7b250cca4fc$var$load("5QKVr"),
    $4ca0f7b250cca4fc$var$load("bxFZs"),
    $4ca0f7b250cca4fc$var$load("gYeBT"),
    $4ca0f7b250cca4fc$var$load("9AHrA"),
    $4ca0f7b250cca4fc$var$load("gLGsg"),
    $4ca0f7b250cca4fc$var$load("eHDb1"),
    $4ca0f7b250cca4fc$var$load("2zUEf"),
    $4ca0f7b250cca4fc$var$load("iZU4p"),
    $4ca0f7b250cca4fc$var$load("kCMj8"),
    $4ca0f7b250cca4fc$var$load("5tz7G"),
    $4ca0f7b250cca4fc$var$load("6wr18"),
    $4ca0f7b250cca4fc$var$load("jwWp5"),
    $4ca0f7b250cca4fc$var$load("hhss7"),
    $4ca0f7b250cca4fc$var$load("7EorR"),
    $4ca0f7b250cca4fc$var$load("awqCy"),
    $4ca0f7b250cca4fc$var$load("ffEVr"),
    $4ca0f7b250cca4fc$var$load("bZz7X")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("inDu6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $kRW4Y = parcelRequire("kRW4Y");

function $34458177b4f70747$export$69f1ef99d32d73a0(InnerComponent) {
    var _WithDialogs;
    return _WithDialogs = class WithDialogs extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $kRW4Y.DialogsStateContainer)
                ]
            }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    dialogs: dialogs
                }));
        }
    }, _WithDialogs.displayName = `withDialogs(${InnerComponent.displayName || InnerComponent.name})`, _WithDialogs;
}
module.exports["withDialogs"] = $34458177b4f70747$export$69f1ef99d32d73a0;

});

parcelRegister("kRW4Y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $T1bCI.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("9FoVw", function(module, exports) {
/**
 * @fileoverview Unified comment navigation utilities for scrolling to different comment types
 * and handling various navigation scenarios across editor and renderer contexts.
 */ 
var $21K7m = parcelRequire("21K7m");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $f5Wgm = parcelRequire("f5Wgm");


var $i49vP = parcelRequire("i49vP");


var $aHcFH = parcelRequire("aHcFH");

var $0343eaf78527fd4c$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["NEXT"] = "next";
    ShortcutType["PREVIOUS"] = "previous";
    ShortcutType["UNREAD"] = "unread";
    return ShortcutType;
}({});
var $0343eaf78527fd4c$var$CommentType = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}($0343eaf78527fd4c$var$CommentType || {});
var $0343eaf78527fd4c$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    return ViewValues;
}({});
// Navigation types based on comment scrolling architecture
var $0343eaf78527fd4c$var$NavigationType = /*#__PURE__*/ function(NavigationType) {
    NavigationType["INLINE_ANNOTATION"] = "inline_annotation";
    NavigationType["COMMENTS_PANEL"] = "comments_panel";
    NavigationType["FOOTER_COMMENTS"] = "footer_comments";
    NavigationType["DEEP_LINK"] = "deep_link";
    NavigationType["KEYBOARD_SHORTCUT"] = "keyboard_shortcut";
    NavigationType["INLINE_HEADER_ARROWS"] = "inline_header_arrows";
    return NavigationType;
}($0343eaf78527fd4c$var$NavigationType || {});
var $0343eaf78527fd4c$export$e6e360ac7d345e5 = /*#__PURE__*/ function(ScrollBehavior) {
    ScrollBehavior["INSTANT"] = "instant";
    ScrollBehavior["SMOOTH"] = "smooth";
    return ScrollBehavior;
}({});
var $0343eaf78527fd4c$export$3044ab7fdabeaee6 = /*#__PURE__*/ function(NavigationContext) {
    NavigationContext["EDITOR"] = "editor";
    NavigationContext["RENDERER"] = "renderer";
    NavigationContext["PANEL"] = "panel";
    NavigationContext["REPLY"] = "reply";
    return NavigationContext;
}({});
const $0343eaf78527fd4c$export$9f32f1ed184088e0 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, inline: inline, markElement: markElement, annotationId: annotationId } = options;
    if (!markElement) return false;
    // Handle different contexts
    switch(context){
        case "editor":
            // Check if element needs to be expanded in editor
            (0, $i49vP.checkElementExpandInEditor)(markElement);
            // Emit the setselectedannotation event
            const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
            editorEmitter.emit('setselectedannotation', markElement.id);
            // Scroll to the element in editor
            (0, $i49vP.scrollToElementInEditor)({
                targetElement: markElement,
                viewingRoomOffset: -100
            });
            return true;
        case "renderer":
            // Renderer-specific logic with improved focus management
            const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
            if (focusedMarkerRef?.id !== markElement.id) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: markElement.id
                });
                // Check if element needs to be expanded
                (0, $aHcFH.checkElementExpand)(markElement, true);
            }
            // Scroll to the annotation mark
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        case "panel":
            // For panel context, ensure annotation is visible and highlighted
            if (annotationId) {
                // Emit events to ensure the annotation is properly focused
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: annotationId
                });
            }
            // Scroll the annotation into view
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        default:
            return false;
    }
};
/**
 * Wait for the comments panel to be rendered in the DOM
 * Returns a Promise that resolves when the panel is available or times out after 5 seconds
 */ const $0343eaf78527fd4c$var$waitForCommentsPanel = ()=>{
    const commentsPanelListContainerId = 'comments-panel-list-container';
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            const panel = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
            if (panel) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Start observing the document body for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 5000); // 5 second timeout
    });
};
/**
 * Wait for the comments panel view/filter to change to the specified view
 * Returns a Promise that resolves when the view change is complete or times out after 3 seconds
 */ const $0343eaf78527fd4c$var$waitForViewChange = (expectedView)=>{
    return new Promise((resolve)=>{
        // Check if the view has already changed by checking the data-current-view attribute on the container
        const checkView = ()=>{
            const container = document.querySelector('[data-testid="comments-panel-list-container"]');
            if (container && container.getAttribute('data-current-view') === expectedView) return true;
        };
        if (checkView()) {
            resolve(true);
            return;
        }
        // Observe document body for both container creation and attribute changes
        // This handles cases where the container gets unmounted/remounted
        const observer = new MutationObserver(()=>{
            if (checkView()) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Observe the entire document body to catch:
        // 1. Container being created/removed
        // 2. Attribute changes on the container when it exists
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                'data-current-view'
            ]
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 3000); // 3 second timeout
    });
};
/**
 * Check if an element is already fully visible within the panel
 * Avoids unnecessary scrolling if the element is already in view
 */ const $0343eaf78527fd4c$var$isElementFullyVisible = (element)=>{
    const elementRect = element.getBoundingClientRect();
    const panelContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    const panelRect = panelContainer?.getBoundingClientRect();
    if (!panelRect) return false;
    return elementRect.top >= panelRect.top && elementRect.bottom <= panelRect.bottom;
};
/**
 * Determine the optimal scroll position based on context and comment type
 * Considers whether to scroll to start, center, or end based on various factors
 */ const $0343eaf78527fd4c$var$determineScrollPosition = (element, block, scrollToEnd, commentType)=>{
    let scrollBlock = block;
    if (scrollToEnd) {
        // Check if the comment thread reply is out of view
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === (0, $f5Wgm.CommentType).INLINE ? "inline" : "general";
        const isOutOfView = (0, $aHcFH.isCommentThreadReplyOutOfView)(element, commentTypeEnum);
        if (isOutOfView) scrollBlock = 'end';
    } else {
        // Check if we should scroll to top
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === (0, $f5Wgm.CommentType).INLINE ? "inline" : "general";
        const shouldScrollToTop = (0, $aHcFH.shouldScrollCommentThreadToTop)(element, commentTypeEnum);
        if (shouldScrollToTop) scrollBlock = 'start';
    }
    return scrollBlock;
};
/**
 * Perform the actual scrolling operation with optimized behavior
 * Handles different scroll scenarios based on user interaction context
 */ const $0343eaf78527fd4c$var$performScrollToElement = (element, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType)=>{
    // Skip scrolling if element is already fully visible
    if ($0343eaf78527fd4c$var$isElementFullyVisible(element)) return;
    // Determine scroll behavior based on trigger type
    if (hasKeyPressed || annotationClicked || scrollOnLoad) {
        const scrollBlock = $0343eaf78527fd4c$var$determineScrollPosition(element, block, scrollToEnd, commentType);
        element.scrollIntoView({
            behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
            block: scrollBlock
        });
    } else // Default scroll behavior
    element.scrollIntoView({
        behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
        block: block
    });
};
const $0343eaf78527fd4c$export$390f6df30bfcd812 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, commentId: commentId, annotationId: annotationId, commentType: commentType, scrollToEnd: scrollToEnd = false, hasKeyPressed: hasKeyPressed = false, annotationClicked: annotationClicked = false, scrollOnLoad: scrollOnLoad = false } = options;
    // Only handle panel context navigation
    if (context !== "panel") return false;
    // Define panel container and thread selectors
    const commentsPanelListContainerId = 'comments-panel-list-container';
    // annotationId is used for DOM selectors, commentId is the actual comment identifier
    const commentThreadContainerId = `comment-thread-${annotationId}-container`;
    // Check if panel is available, wait if not
    const panelContainer = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
    if (!panelContainer) // Panel is not rendered yet, wait for it to appear
    return $0343eaf78527fd4c$var$waitForCommentsPanel().then((panelAvailable)=>{
        if (panelAvailable) // Recursively call the function now that panel is available
        return $0343eaf78527fd4c$export$390f6df30bfcd812(options);
        return false;
    });
    // Look for the specific comment thread container
    const commentThreadElement = document.querySelector(`[data-testid='${commentThreadContainerId}']`);
    // If comment thread exists, scroll immediately
    if (commentThreadElement) {
        $0343eaf78527fd4c$var$performScrollToElement(commentThreadElement, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType);
        return true;
    }
    // Use optimized observer to watch for comment thread container creation
    commentId && (0, $aHcFH.watchForCommentContainerAndScroll)(commentId);
    return true;
};
const $0343eaf78527fd4c$export$dcd3c0d6a66d0412 = async (options)=>{
    const { expectedView: expectedView, commentId: commentId, annotationId: annotationId, ...navigationOptions } = options;
    // Only wait for view change for panel context
    if (navigationOptions.context === "panel" && expectedView) await $0343eaf78527fd4c$var$waitForViewChange(expectedView);
    // Then perform the navigation - pass both commentId and annotationId
    return $0343eaf78527fd4c$export$390f6df30bfcd812({
        ...navigationOptions,
        commentId: commentId,
        annotationId: annotationId
    });
};
const $0343eaf78527fd4c$export$34fd7e98d0739b5c = (options)=>{
    const { block: block, inline: inline, commentId: commentId, scrollBehavior: scrollBehavior, navigationContext: navigationContext } = options;
    let containerId;
    if (!commentId) return false;
    // Check if comment already exists in DOM
    // Determine container ID based on navigation context:
    // - PANEL: uses comment-thread container
    // - REPLY: uses data-comment-id attribute selector
    // - Default (footer): uses footer-comment-thread container
    if (navigationContext === "panel") containerId = `comment-thread-${commentId}-container`;
    else if (navigationContext === "reply") containerId = `[data-comment-id="${commentId}"]`;
    else containerId = `footer-comment-thread-${commentId}-container`;
    // Use querySelector for REPLY context (attribute selector), getElementById for others (ID)
    const existingComment = navigationContext === "reply" ? document.querySelector(containerId) : document.getElementById(containerId);
    if (existingComment) {
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        return true;
    } else {
        // Comment not yet rendered, use DOM resolver to watch for it
        (0, $aHcFH.watchForCommentRepliesAndScroll)({
            targetCommentId: commentId,
            onScrollReady: (commentElement)=>{
                // Find the container element by ID or selector based on navigation context
                const containerElement = navigationContext === "reply" ? document.querySelector(containerId) : document.getElementById(containerId);
                const elementToScroll = containerElement || commentElement;
                elementToScroll.scrollIntoView({
                    behavior: scrollBehavior,
                    block: block,
                    inline: inline
                });
            },
            containerId: containerId
        });
        return true;
    }
};
const $0343eaf78527fd4c$export$ea1c337d9000e2 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, commentId: commentId, markElement: markElement, context: context } = options;
    if (!commentId || !markElement) return false;
    // Check if comment already exists in DOM
    const existingComment = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (existingComment) {
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        return true;
    } else {
        // we need to click on the annotation in the editor if the comment is not yet rendered
        if (context === "editor" && markElement) (0, $i49vP.openInlineCommentInEditor)({
            targetElement: markElement,
            targetElementID: markElement.id,
            shouldScroll: false
        });
        // Comment not yet rendered, use DOM resolver to watch for it
        (0, $aHcFH.watchForCommentRepliesAndScroll)({
            targetCommentId: commentId,
            onScrollReady: (commentElement)=>{
                commentElement.scrollIntoView({
                    behavior: scrollBehavior,
                    block: block,
                    inline: inline
                });
            },
            markElement: markElement
        });
        return true;
    }
    return false;
};
const $0343eaf78527fd4c$export$807107038899c351 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, annotationId: annotationId, commentId: commentId, commentType: commentType, isCommentsPanelOpen: isCommentsPanelOpen, hasKeyPressed: hasKeyPressed = true, scrollToEnd: scrollToEnd = false, context: context, shortcutType: shortcutType, isResolved: isResolved } = options;
    // Get the mark element for both inline navigation and annotation events
    const markElement = document.getElementById(annotationId);
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (commentType === (0, $f5Wgm.CommentType).FOOTER) $0343eaf78527fd4c$export$34fd7e98d0739b5c({
        scrollBehavior: scrollBehavior,
        block: block,
        inline: inline || 'center',
        commentId: annotationId
    });
    // If comments panel is open, use panel navigation
    if (isCommentsPanelOpen) {
        // For inline comments, also call handleInlineAnnotationNavigation to ensure proper inline comment behavior
        if (commentType === (0, $f5Wgm.CommentType).INLINE && !isResolved) $0343eaf78527fd4c$export$9f32f1ed184088e0({
            scrollBehavior: scrollBehavior,
            context: context || "panel",
            block: block,
            inline: inline || 'center',
            markElement: markElement,
            annotationId: annotationId
        });
        // This ensure the ViewComponent useEffect is not triggered
        if (markElement && !isResolved) {
            // Emit annotation events for panel navigation
            if (context === "editor") {
                const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
                editorEmitter.emit('setselectedannotation', annotationId);
            } else if (context === "renderer") {
                const rendererEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                rendererEmitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: null
                });
            }
        }
        // Use the existing panel navigation logic
        const result = $0343eaf78527fd4c$export$390f6df30bfcd812({
            scrollBehavior: scrollBehavior,
            context: "panel",
            block: block,
            inline: inline,
            annotationId: annotationId,
            commentType: commentType,
            hasKeyPressed: hasKeyPressed,
            scrollToEnd: scrollToEnd
        });
        if (result instanceof Promise) // For async panel navigation, return true immediately
        // The actual navigation will happen asynchronously
        return true;
        return result;
    }
    if (!markElement) return false;
    // For unread navigation, scroll to the comment element with data-comment-id instead of markElement
    if (shortcutType === "unread" && commentElement) commentElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    else // For standalone navigation, we don't emit events - just scroll to the element
    markElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    return true;
};
const $0343eaf78527fd4c$export$36dad1a923539611 = (options)=>{
    const { previousMarkerRef: previousMarkerRef, nextMarkerRef: nextMarkerRef, context: context } = options;
    // Get the next comment element
    const nextMarkElement = document.getElementById(nextMarkerRef);
    if (!nextMarkElement) return false;
    // Get the previous and next comment elements
    const previousCommentElement = document.getElementById(previousMarkerRef);
    const nextCommentElement = document.getElementById(nextMarkerRef);
    if (previousCommentElement && nextCommentElement) {
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between current and previous comment positions
                const currentRect = nextCommentElement.getBoundingClientRect();
                const previousRect = previousCommentElement.getBoundingClientRect();
                const differenceOffset = currentRect.top - previousRect.top;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment
        (0, $aHcFH.scrollToComment)(nextCommentElement, previousCommentElement, true, false);
    }
    return true;
};
module.exports["ShortcutType"] = $0343eaf78527fd4c$export$99058db374262376;
module.exports["ScrollBehavior"] = $0343eaf78527fd4c$export$e6e360ac7d345e5;
module.exports["NavigationContext"] = $0343eaf78527fd4c$export$3044ab7fdabeaee6;
module.exports["handleInlineAnnotationNavigation"] = $0343eaf78527fd4c$export$9f32f1ed184088e0;
module.exports["handleCommentsPanelNavigation"] = $0343eaf78527fd4c$export$390f6df30bfcd812;
module.exports["handleCommentsPanelNavigationWithViewChange"] = $0343eaf78527fd4c$export$dcd3c0d6a66d0412;
module.exports["handleFooterCommentsNavigation"] = $0343eaf78527fd4c$export$34fd7e98d0739b5c;
module.exports["handleDeepLinkNavigation"] = $0343eaf78527fd4c$export$ea1c337d9000e2;
module.exports["handleKeyboardShortcutNavigation"] = $0343eaf78527fd4c$export$807107038899c351;
module.exports["handleInlineHeaderArrowsNavigation"] = $0343eaf78527fd4c$export$36dad1a923539611;

});

parcelRegister("i49vP", function(module, exports) {

var $gfqXk = parcelRequire("gfqXk");


var $4EKKB = parcelRequire("4EKKB");


var $aHcFH = parcelRequire("aHcFH");

const $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage = (element)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    while(nodeToMeasure && !nodeToMeasure.classList.contains('fabric-editor-popup-scroll-parent')){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    return elementOffsetTop;
};
const $36cd0189b09a46b6$export$cc3d34287540b287 = (element)=>{
    const expandSelectors = [
        '.ak-editor-expand'
    ];
    const getExpandButton = (node)=>{
        if (node.classList.contains('ak-editor-expand')) {
            const button = node.querySelector('.ak-editor-expand__icon-container');
            return button;
        }
        return null;
    };
    const isExpanded = (button)=>{
        const expandContainer = button.closest('.ak-editor-expand');
        return expandContainer?.classList.contains('ak-editor-expand__expanded') || false;
    };
    const onExpand = ()=>{
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            isInExpand: true
        });
    };
    (0, $aHcFH.checkElementExpandMultiLevelCommon)(element, {
        isEditor: true,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded,
        onExpand: onExpand
    });
};
const $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8 = (element)=>{
    $36cd0189b09a46b6$export$cc3d34287540b287(element);
};
const $36cd0189b09a46b6$export$2163ce5a75e4a465 = ({ targetElement: targetElement, targetElementID: targetElementID, shouldScroll: shouldScroll = true })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8(targetElement);
    emitter.emit('setselectedannotation', targetElementID);
    window.getSelection()?.setPosition(targetElement);
    shouldScroll && $36cd0189b09a46b6$export$4ee22c4fac4681d8({
        targetElement: targetElement,
        viewingRoomOffset: -100
    });
};
const $36cd0189b09a46b6$export$4ee22c4fac4681d8 = ({ targetElement: targetElement, viewingRoomOffset: viewingRoomOffset = 0 })=>{
    const editorScrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
    if (editorScrollableContainer) editorScrollableContainer.scrollTo(0, $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage(targetElement) + viewingRoomOffset // add viewing room
    );
};
const $36cd0189b09a46b6$export$443ba0c8d1b21569 = ({ data: data, previousAnnotations: previousAnnotations })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const topLevelCommentMarkerRefs = data?.comments?.nodes?.map((node)=>(node?.location).inlineMarkerRef);
    if (topLevelCommentMarkerRefs && topLevelCommentMarkerRefs.length > 0) {
        const newAnnotationsSet = new Set(topLevelCommentMarkerRefs);
        const removedMarkerRefs = [];
        previousAnnotations.forEach((item)=>{
            if (!newAnnotationsSet.has(item)) removedMarkerRefs.push(item);
        });
        let updatedAnnotations = [
            ...previousAnnotations
        ];
        const addedMarkerRefs = [];
        newAnnotationsSet.forEach((item)=>{
            if (!previousAnnotations.includes(item)) addedMarkerRefs.push(item);
        });
        for (const markerRef of addedMarkerRefs){
            emitter.emit('create', markerRef);
            updatedAnnotations.push(markerRef);
        }
        for (const markerRef of removedMarkerRefs){
            emitter.emit('resolve', markerRef);
            updatedAnnotations = updatedAnnotations.filter((annotation)=>annotation !== markerRef);
        }
        return updatedAnnotations;
    }
    return [];
};
module.exports["checkElementExpandInEditor"] = $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8;
module.exports["openInlineCommentInEditor"] = $36cd0189b09a46b6$export$2163ce5a75e4a465;
module.exports["scrollToElementInEditor"] = $36cd0189b09a46b6$export$4ee22c4fac4681d8;
module.exports["updateCommentHighlightsInEditor"] = $36cd0189b09a46b6$export$443ba0c8d1b21569;

});

parcelRegister("aHcFH", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $1dnxO = parcelRequire("1dnxO");


var $cD1qu = parcelRequire("cD1qu");


var $i49vP = parcelRequire("i49vP");

const $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7 = 'inline-create-comment-selection';
const $a78c261c3211f7d6$export$b803c692fbaaa5a4 = 'inline-highlight';
const $a78c261c3211f7d6$export$fb3d0eebfe85522a = 'active-highlight';
const $a78c261c3211f7d6$export$b899b07e3f725968 = ()=>{
    const commentData = {
        commentIndex: undefined,
        totalComments: undefined
    };
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) {
        commentData['commentIndex'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['position']);
        commentData['totalComments'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['totalComments']);
    }
    return commentData;
};
const $a78c261c3211f7d6$export$1f7acceb752add79 = (pageMode)=>{
    const marks = Array.from(document.querySelectorAll($a78c261c3211f7d6$export$8c7b048437c01388(pageMode))).map((node)=>{
        if (pageMode === 'edit') return node.id;
        else return $a78c261c3211f7d6$export$8f4213b45c05ab5d(node);
    });
    /* In case of overlapping comments there will be multiple tags with the same markerRefs. We need to remove
  duplicates in that case so we can navigate between comments correctly */ return new Set(marks);
};
const $a78c261c3211f7d6$export$9b48c18cc387f791 = (markerRefList, pageMode = 'view')=>{
    const distinctMarks = [
        ...$a78c261c3211f7d6$export$1f7acceb752add79(pageMode)
    ];
    return distinctMarks.filter((mark)=>mark && markerRefList.includes(mark));
};
const $a78c261c3211f7d6$export$8c7b048437c01388 = (pageMode = 'view')=>{
    if (pageMode === 'edit') return "[annotationtype='inlineComment']";
    else return '[data-mark-annotation-type="inlineComment"], .inline-comment-marker';
};
const $a78c261c3211f7d6$export$f7ceeb7ba8156450 = ()=>{
    const activeHighlights = document.querySelectorAll(`.${$a78c261c3211f7d6$export$fb3d0eebfe85522a}`);
    activeHighlights.forEach((activeHighlight)=>{
        activeHighlight.classList.remove($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    });
};
const $a78c261c3211f7d6$var$getNextTextNodeOld = (node, boundingParentNode)=>{
    let currentNode = node;
    let nextTextNode = currentNode?.nextSibling;
    // If the node has no next sibling, grab it's parent's next sibling until we find a node
    while(!nextTextNode){
        nextTextNode = currentNode?.parentElement?.nextSibling;
        if (nextTextNode) {
            // WS-2551 - If the bounding parent exists and we're out of bounds of it, we're done looking
            if (boundingParentNode && !boundingParentNode.contains(nextTextNode)) {
                nextTextNode = null;
                break;
            }
            // If we've landed on a text node, then break out
            if (nextTextNode.nodeType === Node.TEXT_NODE) break;
            // If the node exists and it's a hard break (<br />), we do one of two things:
            //   1. If it has a bounding parent, break out because the <br /> signifies the end of the selection
            //   2. If not, then move to the next sibling because we don't count hard breaks in selections
            if (nextTextNode?.tagName === 'BR') {
                if (boundingParentNode) break;
                else nextTextNode = nextTextNode.nextSibling;
            }
        } else // If the text node we tried to access is null, we need to jump up a generation
        currentNode = currentNode?.parentNode;
    }
    // Search for the first text node in the next node
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE)nextTextNode = nextTextNode.firstChild;
    return nextTextNode;
};
const $a78c261c3211f7d6$export$3e98291f1f032a77 = (currentNode, boundingNode, isInlineMark)=>{
    let nextTextNode = isInlineMark ? currentNode : currentNode?.nextSibling;
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE){
        // If the text node is the bounding node, return that node
        if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return nextTextNode;
        // Check if the node is a hard break (<br />) or an element with role="presentation" we do one of two things:
        if (nextTextNode?.tagName === 'BR') {
            // If it has a bounding parent, break out because the <br /> signifies the end of the selection
            if (boundingNode) return nextTextNode;
            // If not, then move to the next sibling because we don't count hard breaks in selections
            nextTextNode = nextTextNode.nextSibling;
        } else if (nextTextNode?.attributes?.getNamedItem('role')?.value === 'presentation') // If the element has role="presentation", move to the parent element's sibling because this current node does not contain a text node
        nextTextNode = nextTextNode.parentNode?.nextSibling;
        else if ($a78c261c3211f7d6$var$isEmojiNode(nextTextNode)) {
            // If we encounter an emoji and it's also the bounding node, return nothing
            if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return null;
            // Otherwise, just return the node after it and keep going
            nextTextNode = nextTextNode.nextSibling;
        } else // Otherwise, search for the first text node in the next node
        nextTextNode = nextTextNode.firstChild;
    }
    // If we've found the text node, return that node
    if (nextTextNode?.nodeType === Node.TEXT_NODE) return nextTextNode;
    // If the text node we tried to access is null, we need to jump up a generation
    if (!nextTextNode) return $a78c261c3211f7d6$export$3e98291f1f032a77(currentNode?.parentNode, boundingNode);
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // WS-2551 - Triple clicks are the only thing that can cause the endContainer to be a non-text node
    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    if (!startContainer.isSameNode(endContainer)) {
        let boundingParentNode;
        // Push the starting node into a range
        const startingRange = new Range();
        startingRange.setStart(startContainer, startOffset);
        startingRange.setEnd(startContainer, startContainer.length);
        rangesToHighlight.push(startingRange);
        // WS-2551 - In the case of a triple click, we only want to contain our selection to the
        // first non-comment parent wrapping the starting container to ensure we don't over select
        if (isTripleClick) {
            boundingParentNode = startContainer.parentNode;
            while(!boundingParentNode || boundingParentNode.nodeType === Node.TEXT_NODE || $a78c261c3211f7d6$export$8f4213b45c05ab5d(boundingParentNode) !== null)boundingParentNode = boundingParentNode?.parentNode;
        } else {
            // Push the ending node into a range only if it's not a triple click
            const endingRange = new Range();
            endingRange.setStart(endContainer, 0);
            endingRange.setEnd(endContainer, endOffset);
            rangesToHighlight.push(endingRange);
        }
        // Iterate through all the inner nodes and extract the text ranges
        let node = $a78c261c3211f7d6$var$getNextTextNodeOld(startContainer, boundingParentNode);
        while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
            if (node.length) {
                const range = new Range();
                range.selectNodeContents(node);
                rangesToHighlight.push(range);
            }
            node = $a78c261c3211f7d6$var$getNextTextNodeOld(node, boundingParentNode);
        }
    } else // If they are the same container it's much simpler and we can just use the range
    rangesToHighlight.push(selectedRange);
    return rangesToHighlight;
};
const $a78c261c3211f7d6$var$isEmojiNode = (node)=>{
    if (!node) return false;
    const attributes = node?.attributes;
    const classList = node?.classList;
    return attributes && attributes.getNamedItem('data-emoji-id') || classList && classList.contains('emoji-common-node');
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRanges = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // The endContainer is a non-text node when the user either:
    // 1. Triple clicks a node
    // 2. Highlights a header
    // 3. The highlight goes to the next node but does not actually highlight anything (offset === 0)
    const isNonTextNodeEndContainer = endContainer.nodeType !== Node.TEXT_NODE;
    // If highlight is just one node (i.e. same containers), it's much simpler and we can just use the range
    if (startContainer.isSameNode(endContainer)) {
        rangesToHighlight.push(selectedRange);
        return rangesToHighlight;
    }
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    let boundingNode;
    // Push the starting node into a range
    const startingRange = new Range();
    startingRange.setStart(startContainer, startOffset);
    startingRange.setEnd(startContainer, startContainer.length);
    rangesToHighlight.push(startingRange);
    // In the case of a non-text node endContainer, we want to set a bounding node to the endContainer so we know
    // to stop traversing the DOM when hidding that bounding node
    if (isNonTextNodeEndContainer) {
        // If the end container is non-text and an emoji, we need to jump up a level or else it is
        // going to be bound to a node that we will never be able to check and thus never exit
        if ($a78c261c3211f7d6$var$isEmojiNode(endContainer)) boundingNode = endContainer.parentNode;
        else boundingNode = endContainer;
    } else {
        // Push the ending node into a range
        const endingRange = new Range();
        endingRange.setStart(endContainer, 0);
        endingRange.setEnd(endContainer, endOffset);
        rangesToHighlight.push(endingRange);
    }
    // Get the first "inner" node between the start and end containers
    let node = $a78c261c3211f7d6$export$3e98291f1f032a77(startContainer, boundingNode);
    // Iterate through all the inner nodes and extract the text ranges
    while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
        if (node.length) {
            const range = new Range();
            range.selectNodeContents(node);
            rangesToHighlight.push(range);
        }
        node = $a78c261c3211f7d6$export$3e98291f1f032a77(node, boundingNode);
    }
    return rangesToHighlight;
};
const $a78c261c3211f7d6$export$739c145b6a07c076 = (isFabricPage, isCreateDialogOpen = false, markerRef = '')=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    let markOffsetTop = 0;
    // Measure the offset of the highlight from the renderer wrapper
    // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    if (markerRef) {
        const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(highlight);
    } else {
        const selection = window.getSelection();
        // If there is a user selection, we need to create a new temp "highlight" for this
        // new selection as it is removed when the temp "highlight" is created
        const isNewSelection = selection && selection.type == 'Range' && !isCreateDialogOpen;
        if (isNewSelection) {
            // Reset any existing DOM selections
            $a78c261c3211f7d6$export$743373b19993e2b0();
            // Mark the selection in the DOM temporarily
            $a78c261c3211f7d6$export$4147ba71ff179432(false);
        }
        const createCommentHighlight = document.querySelector(`.${highlightClass}`);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(createCommentHighlight);
    }
    // On a fabric page, the highlight is positioned relative to the renderer
    // wrapper. To correctly position the sidebar we need to measure the offset
    // of the renderer wrapper and the offset of the highlight from the wrapper
    if (isFabricPage) {
        const rendererWrapper = document.querySelector('#content .ak-renderer-wrapper');
        if (rendererWrapper) markOffsetTop += rendererWrapper.offsetTop;
    } else {
        // In tiny, we need to remove the title and author info offset to position it correctly
        const pageMetadata = document.querySelector('#content-body .page-metadata-modification-info');
        if (pageMetadata) markOffsetTop -= pageMetadata.offsetTop - pageMetadata.offsetHeight;
    }
    return markOffsetTop;
};
const $a78c261c3211f7d6$export$4147ba71ff179432 = (useNewHighlightLogic)=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    const selection = window.getSelection();
    if (!selection || selection.type !== 'Range') // Throw error?
    return;
    // Extract the range
    const selectedRange = selection.getRangeAt(0);
    // Get an array of the ranges to make highlights
    const rangesToHighlight = useNewHighlightLogic ? $a78c261c3211f7d6$var$extractTextNodesIntoRanges(selectedRange) : $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld(selectedRange);
    rangesToHighlight.forEach((range)=>{
        // Create a new wrapper element with the correct class
        const highlightWrapper = document.createElement('span');
        highlightWrapper.classList.add(highlightClass);
        // Extract the contents of the range and add it to the new wrapper
        highlightWrapper.appendChild(range.extractContents());
        // Re-insert the wrapper back into the range
        range.insertNode(highlightWrapper);
    });
    // Clear the selection
    selection.removeAllRanges();
};
const $a78c261c3211f7d6$var$unwrapTextNodes = (wrappedNodes)=>{
    while(wrappedNodes.length){
        const node = wrappedNodes.shift();
        if (!node) return;
        const { parentNode: parentNode } = node;
        // Extract the text contents of the selection node out of the temp wrapper
        while(node.firstChild)parentNode?.insertBefore(node.firstChild, node);
        // After the text has been extracted, delete the wrapper
        parentNode?.removeChild(node);
        // Normalize the parent to fix any text node fragmentation
        parentNode?.normalize();
    }
};
const $a78c261c3211f7d6$export$743373b19993e2b0 = ()=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    // Grab all the newly created selection nodes
    const tempSelectionNodes = Array.from(document.querySelectorAll(`.${highlightClass}`));
    $a78c261c3211f7d6$var$unwrapTextNodes(tempSelectionNodes);
};
const $a78c261c3211f7d6$export$a160a5110cbadcb8 = (isFabricPage, markerRef, isActive = true)=>{
    const createCommentSelectionNodes = document.querySelectorAll(`.${$a78c261c3211f7d6$export$d2bdbdaa2c26e7f7}`);
    const ref = markerRef || '';
    // If we find selection nodes in the DOM, we need to add some attributes to them,
    // based on the page type, so they behave correctly when the user clicks a highlight
    if (createCommentSelectionNodes.length) createCommentSelectionNodes.forEach((selectionNode)=>{
        if (isFabricPage) {
            selectionNode.setAttribute($a78c261c3211f7d6$export$98471574bfa5228e, ref);
            selectionNode.setAttribute('data-mark-annotation-type', 'inlineComment');
        } else {
            selectionNode.setAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832, ref);
            selectionNode.classList.add('inline-comment-marker');
        }
        const classesToAdd = [
            $a78c261c3211f7d6$export$b803c692fbaaa5a4
        ];
        if (isActive) classesToAdd.push($a78c261c3211f7d6$export$fb3d0eebfe85522a);
        // Add the classes needed
        selectionNode.classList.add(...classesToAdd);
        // Finally, remove the selection class to make it a full mark
        selectionNode.classList.remove($a78c261c3211f7d6$export$d2bdbdaa2c26e7f7);
    });
};
const $a78c261c3211f7d6$var$setHighlightsAsActive = (highlightElement, skipClassCheck = false)=>{
    if (skipClassCheck || highlightElement.classList.contains($a78c261c3211f7d6$export$b803c692fbaaa5a4)) highlightElement.classList.add($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    // We need to set all the children of this highlight to active as well
    const { children: children } = highlightElement;
    for(let i = 0; i < children.length; ++i)$a78c261c3211f7d6$var$setHighlightsAsActive(children[i], skipClassCheck);
};
const $a78c261c3211f7d6$export$fd55463aeed84830 = (markerRef, skipClassCheck = false)=>{
    const highlightMarks = $a78c261c3211f7d6$export$6dfccc77fe608546(markerRef) || [];
    highlightMarks.forEach((highlight)=>$a78c261c3211f7d6$var$setHighlightsAsActive(highlight, skipClassCheck));
};
const $a78c261c3211f7d6$export$280edc47a64130be = (markerRef)=>{
    const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef || '');
    return Boolean(highlight && highlight.classList.contains($a78c261c3211f7d6$export$fb3d0eebfe85522a));
};
const $a78c261c3211f7d6$export$a26c4eafef12029f = (markerRef)=>{
    const highlightMarksToRemove = Array.from($a78c261c3211f7d6$export$6dfccc77fe608546(markerRef));
    $a78c261c3211f7d6$var$unwrapTextNodes(highlightMarksToRemove);
    $a78c261c3211f7d6$export$f7ceeb7ba8156450();
};
const $a78c261c3211f7d6$export$a0939f064b367798 = ()=>{
    const highlightedAnnotations = Array.from(document.querySelectorAll('.ak-editor-annotation-blur, .ak-editor-annotation-focus'));
    const highlightedAnnotationIds = highlightedAnnotations.map((annotation)=>annotation?.closest('.annotationView-content-wrap')?.id).filter((id)=>Boolean(id));
    return new Set(highlightedAnnotationIds);
};
const $a78c261c3211f7d6$export$98471574bfa5228e = 'data-id';
const $a78c261c3211f7d6$export$90ee95b6cd79c832 = 'data-ref';
const $a78c261c3211f7d6$var$hasAdfContent = (input)=>{
    const content = input && input.content;
    return content && content.some($a78c261c3211f7d6$var$validateContent);
};
// Check to make sure if we have item.type as paragraph content is not empty (user did not type anything)
// or user has put in blank spaces(empty string) and clicked save
// Any type other than paragraph is valid (e.g:- when user inserts divider, status etc without content)
const $a78c261c3211f7d6$var$validateContent = (item)=>item.type !== 'paragraph' || $a78c261c3211f7d6$var$validateParagraph(item);
const $a78c261c3211f7d6$var$validateParagraph = (item)=>{
    if (item.content) return item.content.some($a78c261c3211f7d6$var$isParagraphNotEmpty);
    return false;
};
const $a78c261c3211f7d6$var$isParagraphNotEmpty = (item)=>item.type !== 'text' || item.text.trim() !== '';
const $a78c261c3211f7d6$export$915f03d46d87bfd4 = (adf)=>!adf || !$a78c261c3211f7d6$var$hasAdfContent(adf);
const $a78c261c3211f7d6$export$d204c0ea9b3f0d7d = (isFabricPage)=>isFabricPage ? $a78c261c3211f7d6$export$98471574bfa5228e : $a78c261c3211f7d6$export$90ee95b6cd79c832;
const $a78c261c3211f7d6$export$8f4213b45c05ab5d = (element)=>{
    let markerRef = null;
    if (element) {
        markerRef = element.getAttribute($a78c261c3211f7d6$export$98471574bfa5228e);
        if (!markerRef) markerRef = element.getAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832);
    }
    return markerRef;
};
const $a78c261c3211f7d6$export$21445ab787d3b446 = (markerRef, additionalQueryScope = '')=>{
    if (!markerRef) return null;
    // We need to allow for additional query scope to be added to specify particular markerRef comments
    return document.querySelector(`${additionalQueryScope} [${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], ${additionalQueryScope} [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$export$6dfccc77fe608546 = (markerRef)=>{
    return document.querySelectorAll(`[${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$export$6d23af9d8c2844b1 = [
    'enter',
    'escape'
];
const $a78c261c3211f7d6$var$getDimensions = ()=>{
    try {
        return {
            currentWindowHeight: window.innerHeight || (window.top?.innerHeight ?? 0),
            currentPageOffset: window.scrollY || (window.top?.scrollY ?? 0)
        };
    } catch  {
        // Catch cross origin iframe error https://hello.atlassian.net/browse/CBT-907
        return {
            currentWindowHeight: 0,
            currentPageOffset: 0
        };
    }
};
const $a78c261c3211f7d6$var$getDimensionsForNav4 = ()=>{
    try {
        const nav4ScrollParent = document.getElementById('AkMainContent');
        const currentPageOffset = !!nav4ScrollParent ? nav4ScrollParent.scrollTop : window.scrollY || (window.top?.scrollY ?? 0);
        return {
            currentWindowHeight: window.innerHeight || (window.top?.innerHeight ?? 0),
            currentPageOffset: currentPageOffset
        };
    } catch  {
        // Catch cross origin iframe error https://hello.atlassian.net/browse/CBT-907
        return {
            currentWindowHeight: 0,
            currentPageOffset: 0
        };
    }
};
const $a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET = 350;
const $a78c261c3211f7d6$export$858fd2398afb28e4 = (commentElement, useInstantScroll = false, isAbove = false)=>{
    if (!commentElement) return;
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = $a78c261c3211f7d6$var$getDimensions();
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    // If the position of the comment box is more than halfway down the screen, reposition it to the center
    if (offset <= currentPageOffset || offset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = currentWindowHeight / 5;
        window.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$b451b837f5309ae9 = ({ commentId: commentId, targetCommentId: targetCommentId, isEditor: isEditor, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (commentId !== targetCommentId) return;
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (isEditor && commentElement) (0, $i49vP.scrollToElementInEditor)({
        targetElement: commentElement,
        viewingRoomOffset: viewingRoomOffset
    });
    else $a78c261c3211f7d6$export$fc9b5eebad60b835({
        element: commentElement,
        viewingRoomOffset: viewingRoomOffset,
        useInstantScroll: useInstantScroll
    });
};
const $a78c261c3211f7d6$export$e5d4e097ce63febc = ({ commentElement: commentElement, scrollRootElement: scrollRootElement, currentPageOffset: currentPageOffset, currentWindowHeight: currentWindowHeight, isAbove: isAbove, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll })=>{
    if (!commentElement) return;
    // We may be in an iframe so use window.top
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    const rendererOffset = document.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
    // If the position of the highlight is more than halfway down the screen, reposition it to the center
    if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
        scrollRootElement.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$82eb6662255613e = ({ commentElement: commentElement, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll = false, isAbove: isAbove = false, commentThreadContainerId: commentThreadContainerId, isCommentsPanel: isCommentsPanel })=>{
    if (!commentElement) return;
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const nodeToConsider = $a78c261c3211f7d6$export$ee0755cb593feed6(commentElement) || commentElement;
    const targetCommentHighlight = nodeToConsider.getBoundingClientRect();
    const { scrollRootElement: scrollRootElement, getDimensions: getDimensions } = $a78c261c3211f7d6$var$getScrollRootContext(isNav4Enabled);
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = getDimensions();
    const behavior = useInstantScroll ? 'instant' : 'smooth';
    if (isCommentsPanel) {
        const element = document.querySelector(`[data-testid='${commentThreadContainerId}']`);
        const commentThreadParentElement = element.getBoundingClientRect().top;
        const commentThreadSelector = document.querySelector(`[data-testid='comments-panel-list-container']`);
        const inlineCommentPosition = element?.getBoundingClientRect();
        const documentContent = document.getElementById('content');
        const documentContentTopPosition = documentContent?.getBoundingClientRect().top;
        const commentAboveViewport = inlineCommentPosition && documentContentTopPosition && Math.floor(inlineCommentPosition.top) < Math.floor(documentContentTopPosition);
        const commentBelowViewport = inlineCommentPosition && inlineCommentPosition.top + 200 > window.innerHeight;
        const commentHighlightAboveViewPort = Math.floor(targetCommentHighlight.bottom) < currentPageOffset;
        const commentHighlightBelowViewPort = targetCommentHighlight.top + 200 > window.innerHeight;
        /**
     * Determine which panel or section needs to be scrolled:
     * the content area or the comments panel.
     * We need to find out if the highlight or panel is above or below the viewport.
     * This will help us decide which one to scroll.
     */ if (commentHighlightAboveViewPort || commentHighlightBelowViewPort) // if the comment highlight is above or below viewport use content area to scroll;
        scrollRootElement.scrollBy({
            top: window.innerHeight - commentThreadParentElement - (window.innerHeight - targetCommentHighlight.top),
            behavior: behavior
        });
        else if (commentThreadSelector && (commentAboveViewport || commentBelowViewport || window.innerHeight - commentThreadParentElement - (window.innerHeight - targetCommentHighlight.top) < 0)) // if the comment thread is above or below viewport or
        // there is difference in top of comment thread and highlight if completely visible in the viewport
        //  use commentThreadSelector as an element to scroll ;
        commentThreadSelector.scrollBy({
            top: window.innerHeight - targetCommentHighlight.top - (window.innerHeight - commentThreadParentElement),
            behavior: behavior
        });
        else scrollRootElement.scrollBy({
            top: targetCommentHighlight.top - commentThreadParentElement,
            behavior: behavior
        });
    } else {
        // We may be in an iframe so use window.top
        const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
        const rendererOffset = document.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
        // If the position of the highlight is more than halfway down the screen, reposition it to the center
        if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
            const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
            scrollRootElement.scrollTo({
                top: offset - windowOffset,
                behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
            });
        }
    //If comment is in expand, open respective expand
    }
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$export$c7436bd0a15f3e7e = ({ commentElement: commentElement, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll = false, isAbove: isAbove = false, commentThreadAnnotationId: commentThreadAnnotationId, isCommentsPanel: isCommentsPanel, scrollCommentsPanelToThread: scrollCommentsPanelToThread, shouldScrollCommentsPanel: shouldScrollCommentsPanel = false })=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        const commentThreadContainerId = `comment-thread-${commentThreadAnnotationId}-container`;
        $a78c261c3211f7d6$export$82eb6662255613e({
            commentElement: commentElement,
            isFabricPage: isFabricPage,
            useInstantScroll: useInstantScroll,
            isAbove: isAbove,
            commentThreadContainerId: commentThreadContainerId,
            isCommentsPanel: isCommentsPanel
        });
        return;
    }
    if (!commentElement) return;
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const nodeToConsider = $a78c261c3211f7d6$export$ee0755cb593feed6(commentElement) || commentElement;
    const targetCommentHighlight = nodeToConsider.getBoundingClientRect();
    const { scrollRootElement: scrollRootElement, getDimensions: getDimensionsFromScrollRootContext } = $a78c261c3211f7d6$var$getScrollRootContext(isNav4Enabled);
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = getDimensionsFromScrollRootContext();
    if (isCommentsPanel) {
        const commentHighlightAboveViewPort = Math.floor(targetCommentHighlight.bottom) < currentPageOffset;
        const commentHighlightBelowViewPort = targetCommentHighlight.top + 200 > window.innerHeight;
        // Scroll the highlight into view in the main content body
        if (commentHighlightAboveViewPort || commentHighlightBelowViewPort) $a78c261c3211f7d6$export$e5d4e097ce63febc({
            commentElement: commentElement,
            scrollRootElement: scrollRootElement,
            currentPageOffset: currentPageOffset,
            currentWindowHeight: currentWindowHeight,
            isAbove: isAbove,
            isFabricPage: !!isFabricPage,
            useInstantScroll: useInstantScroll
        });
        // Scroll the comment thread into view in the comments panel if triggered by a KB shortcut
        if (commentThreadAnnotationId && scrollCommentsPanelToThread && shouldScrollCommentsPanel && !(0, $9wGTI.fg)('confluence_comments_unified_navigation')) scrollCommentsPanelToThread({
            annotationId: commentThreadAnnotationId
        });
    } else $a78c261c3211f7d6$export$e5d4e097ce63febc({
        commentElement: commentElement,
        scrollRootElement: scrollRootElement,
        currentPageOffset: currentPageOffset,
        currentWindowHeight: currentWindowHeight,
        isAbove: isAbove,
        isFabricPage: !!isFabricPage,
        useInstantScroll: useInstantScroll
    });
    //If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$export$66b4d1e3b6633573 = (target, scrollContainer)=>{
    const rect = target.getBoundingClientRect();
    const parentRect = scrollContainer.getBoundingClientRect();
    let moveY = 0;
    // The distance (in pixels) between the target and the end of the visible viewport at which point,
    // when scrolling the target into view, scrolling takes place.
    const SCROLL_THRESHOLD = 60;
    // The extra space (in pixels) that is left above or below the target when it is scrolled into view.
    const SCROLL_MARGIN = 120;
    // Note: visible area of the container refers to parentRect.top/bottom +/- SCROLL_THRESHOLD
    if (rect.top < parentRect.top + SCROLL_THRESHOLD) // If the target is above the top of the visible area of the container, moveY should be negative to bring target down into view
    moveY = -(parentRect.top - rect.top + SCROLL_MARGIN);
    else if (rect.bottom > parentRect.bottom - SCROLL_THRESHOLD) // If the target's bottom is below the bottom of the visible area of the container, move Y should be positive to bring target up into view
    moveY = rect.bottom - parentRect.bottom + SCROLL_MARGIN;
    if (moveY) scrollContainer.scrollTop += moveY;
};
const $a78c261c3211f7d6$export$fb40c5e75b82df8 = (isEditor, isViewCommentMode)=>{
    if (isEditor && isViewCommentMode) return 'editor-comments-sidebar';
    else if (isEditor && !isViewCommentMode) return 'editor-create-sidebar';
    else if (!isEditor && isViewCommentMode) return 'renderer-comments-sidebar';
    else return 'renderer-create-sidebar';
};
const $a78c261c3211f7d6$export$db9eae89818590a4 = (commentElement, previousCommentElement, isFabricPage, isEditor)=>{
    if (!commentElement) return;
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext(isNav4Enabled);
    // if current open comment is out of viewport, we need to scroll so that the next comment is in viewport
    const sidebarId = $a78c261c3211f7d6$export$fb40c5e75b82df8(isEditor, true); // Hard-coding isViewCommentMode to true because navigation only exists in the view scenario
    const inlineCommentSidebar = document.getElementById(sidebarId);
    const inlineCommentPosition = inlineCommentSidebar?.getBoundingClientRect();
    const documentContent = document.getElementById('content');
    const documentContentTopPosition = documentContent?.getBoundingClientRect().top;
    const commentAboveViewport = inlineCommentPosition && documentContentTopPosition && inlineCommentPosition.top < documentContentTopPosition + scrollRootOffset;
    const commentBelowViewport = inlineCommentPosition && inlineCommentPosition.top + 200 > window.innerHeight;
    if (commentAboveViewport || commentBelowViewport) {
        $a78c261c3211f7d6$export$c7436bd0a15f3e7e({
            commentElement: commentElement,
            isFabricPage: isFabricPage
        });
        return;
    }
    const previousOffset = previousCommentElement ? $a78c261c3211f7d6$export$331805bfbe18b1c0(previousCommentElement) : 0;
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement);
    const differenceOffset = offset - previousOffset;
    scrollRootElement.scrollBy({
        top: differenceOffset,
        behavior: 'smooth' // navigation uses a smooth scroll
    });
    // If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$var$adjustNodeForStickyHeader = (stickyHeaderElement)=>{
    let adjustedElement = stickyHeaderElement;
    const markerRef = $a78c261c3211f7d6$export$8f4213b45c05ab5d(adjustedElement);
    // If this is exists it's a commited comment, look for its counterpart in the real table
    // TODO: Support new highlights when we allow it
    if (markerRef) // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    adjustedElement = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef, '.pm-table-wrapper');
    return adjustedElement;
};
const $a78c261c3211f7d6$export$ee0755cb593feed6 = (element)=>{
    let nodeToReturn = element;
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToReturn && nodeToReturn.closest && nodeToReturn.closest('.pm-table-sticky-wrapper')) nodeToReturn = $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToReturn);
    if (nodeToReturn) {
        // WS-2718 - If a comment is in an extension macro
        const extensionParent = nodeToReturn.closest('.ak-renderer-extension');
        if (extensionParent) nodeToReturn = extensionParent;
    }
    return nodeToReturn;
};
const $a78c261c3211f7d6$export$331805bfbe18b1c0 = (element, relativeToElement, isRendererAnnotationProviderEnabled)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('.pm-table-sticky-wrapper')) // The RAP annotation draft mark is applied to the both pm-table-sticky-wrapper as well as the pm-table-wrapper.
    // Need to check only pm-table-wrapper annotation draft mark for the RAP enabled
    nodeToMeasure = isRendererAnnotationProviderEnabled ? document.querySelector(`.pm-table-wrapper [data-annotation-draft-mark="true"]`) : $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToMeasure);
    // Iterate through the offset parents until we are back to the ak-renderer-wrapper to get the
    // proper offset Fabric Pages wrap the content in a .ak-renderer-wrapper element, but Tiny
    // pages do not have anything like that, but will return null when we get to <body>
    while(nodeToMeasure && !nodeToMeasure.classList.contains('ak-renderer-wrapper') && nodeToMeasure !== relativeToElement){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    // WS-2718 - If a comment is in an extension macro, we need to add its container offset as well
    if (nodeToMeasure) {
        const extensionParent = nodeToMeasure.closest('.ak-renderer-extension');
        if (extensionParent) elementOffsetTop += extensionParent.offsetTop;
    }
    return elementOffsetTop;
};
const $a78c261c3211f7d6$export$d0d02dc9adb82d62 = (element, isFabricPage)=>{
    //get the child of element passed in
    const expandElement = element?.hasChildNodes() ? element?.firstChild : element;
    //check if element is expand button and return element if so
    if (isFabricPage) {
        if (expandElement?.tagName?.toLowerCase() === 'button') return expandElement;
    } else if (expandElement?.classList?.contains('expand-control')) return expandElement?.firstChild; //it's one child down for tiny pages
    return null;
};
const $a78c261c3211f7d6$export$1a2319f5c2109ee1 = (element, options)=>{
    const { expandSelectors: expandSelectors, getExpandButton: getExpandButton, isExpanded: isExpanded, onExpand: onExpand } = options;
    const nodeToCheck = element;
    // Check if comment is in any expand
    const isInExpand = expandSelectors.some((selector)=>nodeToCheck?.closest?.(selector));
    if (!isInExpand) return;
    // Find all expand buttons that need to be opened, starting from the innermost
    const expandButtonsToOpen = [];
    let currentNode = nodeToCheck;
    while(currentNode){
        // Check if current node has an expand button
        const expandButton = getExpandButton(currentNode);
        if (expandButton) // Check if this expand is already opened
        {
            if (!isExpanded(expandButton)) expandButtonsToOpen.push(expandButton);
        }
        currentNode = currentNode?.parentElement;
    }
    // Open all expand buttons from innermost to outermost
    const buttonsToClick = [
        ...expandButtonsToOpen
    ].reverse();
    buttonsToClick.forEach((expandButton)=>{
        if (onExpand) onExpand(expandButton);
        expandButton.click();
    });
};
const $a78c261c3211f7d6$export$d2685a53bf6957f4 = (element, isFabricPage)=>{
    const expandElementClassname = isFabricPage ? '.expand-content-wrapper' : '.expand-content';
    const nestedExpandElementClassname = '.nestedExpand-content-wrapper';
    const expandSelectors = [
        expandElementClassname,
        nestedExpandElementClassname
    ];
    const getExpandButton = (node)=>$a78c261c3211f7d6$export$d0d02dc9adb82d62(node, isFabricPage);
    const isExpanded = (button)=>{
        return isFabricPage ? button.getAttribute('aria-expanded') === 'true' : button.className.includes('expanded');
    };
    $a78c261c3211f7d6$export$1a2319f5c2109ee1(element, {
        isFabricPage: isFabricPage,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded
    });
};
const $a78c261c3211f7d6$export$876171b9c9b54aab = (element, isFabricPage)=>{
    $a78c261c3211f7d6$export$d2685a53bf6957f4(element, isFabricPage);
};
const $a78c261c3211f7d6$export$187f977414e8342c = (action, index, markerRefList)=>{
    if (markerRefList.length === 0 || index === undefined || index === -1) return;
    let commentIndex = -1;
    //Navigate to first inline comment if we're on the last comment and the user clicks next,
    // or to the last comment if we're on the first comment and the user clicks previous
    if (action === 'next') commentIndex = index === markerRefList.length - 1 ? 0 : index + 1;
    else if (action === 'previous') commentIndex = index === 0 ? markerRefList.length - 1 : index - 1;
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$883ebc059dd86e88 = (index, markerRefList, unreadMarkerRefList)=>{
    if (index === undefined || markerRefList.length === 0 || index === -1 || !unreadMarkerRefList || unreadMarkerRefList.length === 0) return;
    let commentIndex = !(0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes') ? index : index % markerRefList.length; // Handle case where index is beyond array length
    const refListLength = markerRefList.length;
    let iterations = 0;
    while(markerRefList[commentIndex] !== undefined && !unreadMarkerRefList.includes(markerRefList[commentIndex]) && iterations < refListLength){
        commentIndex = (commentIndex + 1) % markerRefList.length;
        iterations++;
    }
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$b401b3c3a0774fd7 = ()=>navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $a78c261c3211f7d6$export$bec1a1359bf081c5 = ()=>window.clipboardData && typeof window.clipboardData.setData === 'function';
const $a78c261c3211f7d6$export$dcc703cd1f894b4c = (textToCopy)=>new Promise((resolve, reject)=>{
        if ($a78c261c3211f7d6$export$bec1a1359bf081c5()) {
            window.clipboardData.setData('text', textToCopy);
            resolve();
        } else reject('IE clipboard api is not supported');
    });
const $a78c261c3211f7d6$export$2cdf1b96a9f86d16 = async (text)=>{
    if ($a78c261c3211f7d6$export$b401b3c3a0774fd7()) await navigator.clipboard.writeText(text);
};
const $a78c261c3211f7d6$export$d26ca9d0d4cbdbe9 = (text, ref)=>new Promise((res, rej)=>{
        if (!ref) {
            rej();
            return;
        }
        const textarea = document.createElement('textarea');
        textarea.readOnly = true;
        textarea.defaultValue = text;
        ref.appendChild(textarea);
        textarea.select();
        const wasCopied = document.execCommand('copy');
        ref.removeChild(textarea);
        wasCopied ? res() : rej();
    });
const $a78c261c3211f7d6$export$ab567600730c0b3b = (annotationElement, scrollParentSelector)=>{
    const scrollParent = document.querySelector(scrollParentSelector);
    return $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement, scrollParent);
};
const $a78c261c3211f7d6$export$3cdeee3ea1732782 = (annotationElement, scrollParentSelector, isView)=>{
    let offset = 0;
    if (annotationElement) {
        // If the annotation is the wrapperDOM, we actually need #content to be the scrollParent
        const scrollParent = document.querySelector('div#content[data-inline-comments-target="true"]');
        if (scrollParent) {
            let annotationOffset;
            if (isView) annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement);
            else {
                // If the annotation is the wrapperDOM, we need to find the actual highlight instead
                const actualHiglightElement = scrollParent.querySelector(scrollParentSelector);
                annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(actualHiglightElement, undefined, true);
            }
            offset = annotationOffset + scrollParent.offsetTop;
        }
    }
    return offset;
};
const $a78c261c3211f7d6$export$9f8164812b21bc7a = (entries)=>{
    const windowHeight = window.innerHeight;
    if ((0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true) || (0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
        if (!(0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
            // When fg is ON, we would have verified that there's no
            // endOfPageRecommendations before adding this ResizeObserver.
            // So no need to check it here.
            const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
            if (endOfPageRecommendations) return 0;
        }
        const editorTextArea = document.getElementById('ak-editor-textarea');
        const editorBottom = editorTextArea?.getBoundingClientRect().bottom;
        if (editorBottom && windowHeight) {
            // The minimum spacing between bottom of editor content and top of footer is 120px
            const minimumSpacing = 120;
            // - There's an existing fixed 24px margin below editor content.
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px to make it visually distinct
            //   when a short LiveDoc has some vs zero existing footer comment.
            const editorBottomMargin = 24;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
            const currentScroll = editorScrollParent?.scrollTop ?? 0;
            const editorBottomUnscrolled = editorBottom + currentScroll;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - editorBottomUnscrolled;
            return Math.max(verticalDistanceFromWindowBottomUnscrolled - editorBottomMargin - addFooterCommentHeight - extraFooterCommentHeightToShow, minimumSpacing);
        }
    } else {
        // The calculation is
        // 15px of marginTop on the comment container
        // 2px full-page-editor-style bottom which above the viewport
        // 1px border which is cumulates to 120px
        const thresholdTop = 102;
        const editorEntry = entries.find((entry)=>entry.target.id === 'ak-editor-textarea');
        const editorBottom = editorEntry?.target.getBoundingClientRect().bottom;
        const editorContentHeight = document.querySelector(`.ak-editor-content-area .ProseMirror`)?.getBoundingClientRect().height;
        const documentContentBottom = document.querySelector(`[data-testid='full-page-editor-style']`)?.getBoundingClientRect().bottom;
        if (editorContentHeight) {
            // If the document content is larger than the window height, just set it to a static 120 to keep the proper spacing
            if (editorContentHeight > windowHeight) return 120;
            if (documentContentBottom && editorBottom) {
                const verticalDistance = documentContentBottom - editorBottom;
                if (verticalDistance >= thresholdTop && editorContentHeight <= windowHeight) return verticalDistance - thresholdTop;
                else if (verticalDistance <= thresholdTop) return thresholdTop;
            }
        }
    }
};
const $a78c261c3211f7d6$export$e3a17b46d43aa5f6 = ()=>{
    // This is deprecated, and will be replaced by a new approach that works in SSR.
    let newTop = 0;
    const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
    const legacyLabels = document.querySelector('[data-vc="view-page-labels-container"]');
    // no extra spacing if the page shows end-of-page recommendations or legacy labels
    if (!endOfPageRecommendations && !legacyLabels) {
        const rendererContent = document.getElementById('main-content');
        const rendererContentBottom = rendererContent?.getBoundingClientRect()?.bottom ?? 0;
        if (rendererContentBottom) {
            // - There's an existing fixed 80px margin below Page content (See
            //   next/packages/view-page-common/src/ViewPageContent.tsx).
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px (matching Editor version ^)
            //   to make it visually distinct when a short Page has some vs zero
            //   existing footer comment.
            const contentBottomMargin = 80;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            // Find the current scroll offset on the Page.
            // This is similar to implementation in getDimensionsForNav4(),
            // but when the window is very narrow, nav4ScrollParent.scrollTop
            // can be 0 (nav4ScrollParent element itself exists on page) while
            // window.scrollY is positive.
            // So this is a more robust implementation. Will explore whether
            // getDimensionsForNav4() can be updated to use this implementation
            // in a separate PR.
            const nav4ScrollParent = document.getElementById('AkMainContent');
            const currentPageOffset = (nav4ScrollParent?.scrollTop ?? 0) + (window.scrollY ?? window.top?.scrollY ?? 0);
            const rendererContentBottomUnscrolled = rendererContentBottom + currentPageOffset;
            const windowHeight = window.innerHeight;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - rendererContentBottomUnscrolled - contentBottomMargin;
            newTop = Math.max(verticalDistanceFromWindowBottomUnscrolled - addFooterCommentHeight - extraFooterCommentHeightToShow, 0);
        }
    }
    return newTop;
};
const $a78c261c3211f7d6$export$fc9b5eebad60b835 = ({ element: element, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (!element) return;
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const { useNav4ScrollRoot: useNav4ScrollRoot, scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext(isNav4Enabled);
    const elementRect = element.getBoundingClientRect();
    const elementTopViewport = elementRect.top;
    const scrollRootTopViewport = useNav4ScrollRoot ? scrollRootElement.getBoundingClientRect().top : 0;
    const elementTopFromScrollRoot = elementTopViewport - scrollRootTopViewport;
    const targetScrollPosition = elementTopFromScrollRoot + scrollRootOffset + viewingRoomOffset;
    scrollRootElement.scrollTo({
        top: targetScrollPosition,
        behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
    });
    // open expand if the element is inside an expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(element, true);
};
const $a78c261c3211f7d6$export$b3ba907d5759e257 = (commentId)=>{
    let isDisconnected = false;
    let commentFound = false;
    // Find the most specific container to observe
    const commentsPanelListContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    const targetContainer = commentsPanelListContainer || document.body;
    const observer = new MutationObserver(()=>{
        if (isDisconnected || commentFound) return;
        // Look for the comment element directly
        const commentElement = targetContainer.querySelector(`[data-comment-id="${commentId}"]`);
        if (commentElement) {
            commentFound = true;
            commentElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
            isDisconnected = true;
            observer.disconnect();
        }
    });
    // Start observing only the specific container
    observer.observe(targetContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
            'data-comment-id'
        ]
    });
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
        }
    };
};
const $a78c261c3211f7d6$export$b1b7c9bcc75c855d = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId })=>{
    if ((0, $6mKj3.expValEquals)('confluence_comments_use_new_observer', 'isEnabled', true)) return $a78c261c3211f7d6$export$4d09fb2a10e54800({
        targetCommentId: targetCommentId,
        onScrollReady: onScrollReady,
        onFallback: onFallback,
        timeoutMs: timeoutMs,
        markElement: markElement,
        containerId: containerId
    });
    let commentFound = false;
    let isDisconnected = false;
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                for (const addedNode of Array.from(mutation.addedNodes))if (addedNode.nodeType === Node.ELEMENT_NODE) {
                    const element = addedNode;
                    // Check if this element or any of its descendants has the specific data-comment-id
                    const containerElement = containerId ? document.getElementById(containerId) : null;
                    const commentElement = containerElement || element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
                    if (commentElement) {
                        commentFound = true;
                        // Early return if the comment is in the container element
                        if (containerElement) {
                            onScrollReady(containerElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        }
                        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                        // Check the initial state of the show more button
                        const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
                        if (!showMoreButton) {
                            onScrollReady(commentElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        } else // Trigger click on the show more button to expand all replies
                        showMoreButton.click();
                        break;
                    }
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
            const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Find the comment element by ID or data-comment-id attribute
 */ const $a78c261c3211f7d6$var$findCommentElement = (targetCommentId, containerId, isFooterCommentInPanel)=>{
    // If isFooterCommentInPanel is true, use comment-thread-${targetCommentId}-container
    if (isFooterCommentInPanel) {
        const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
        if (panelContainer) return panelContainer;
    }
    // Try container element first if containerId is provided
    if (containerId) {
        const container = document.getElementById(containerId);
        if (container) return container;
    }
    // Fall back to finding by data-comment-id
    return document.querySelector(`[data-comment-id="${targetCommentId}"]`);
};
const $a78c261c3211f7d6$export$5eaef9e6a0975768 = (commentElement, targetCommentId)=>{
    if (!commentElement) return null;
    // 1. Check within commentElement (descendants)
    const buttonInComment = commentElement.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInComment) return buttonInComment;
    // 2. Check in parent element (siblings)
    const parentElement = commentElement.parentElement;
    const buttonInParent = parentElement?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInParent) return buttonInParent;
    // 3. Check in replies container (specific to this comment thread)
    const repliesContainer = document.querySelector(`[data-testid="comment-thread-${targetCommentId}-replies"]`);
    const buttonInReplies = repliesContainer?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInReplies) return buttonInReplies;
    return null;
};
/**
 * Handle the comment element being found
 * Checks for show more button and either scrolls immediately or clicks to expand
 */ const $a78c261c3211f7d6$var$handleCommentFound = (commentElement, targetCommentId, containerId, markElement, onScrollReady)=>{
    // If container element exists and we're using it, scroll immediately
    if (containerId && commentElement.id === containerId) {
        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    }
    // Expand mark element if needed
    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
    // Check for show more button
    const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
    if (!showMoreButton) {
        // No show more button, scroll immediately
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    } else {
        // Show more button exists, click it to expand replies
        showMoreButton.click();
        return false; // Keep watching for button to disappear
    }
};
/**
 * Check if comment element exists in newly added nodes
 */ const $a78c261c3211f7d6$var$checkAddedNodes = (addedNodes, targetCommentId, containerId, isFooterCommentInPanel, onCommentFound)=>{
    for (const addedNode of Array.from(addedNodes)){
        if (addedNode.nodeType !== Node.ELEMENT_NODE) continue;
        const element = addedNode;
        // Check if this element or its descendants contains the comment
        let commentElement = null;
        // First check for container element
        if (containerId) {
            const container = document.getElementById(containerId);
            if (container) commentElement = container;
        }
        // If not found, check for comment by data-comment-id
        if (!commentElement) commentElement = element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
        // If isFooterCommentInPanel, also check for panel container
        if (!commentElement && isFooterCommentInPanel) {
            const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
            if (panelContainer) commentElement = panelContainer;
        }
        if (commentElement) {
            const shouldDisconnect = onCommentFound(commentElement);
            if (shouldDisconnect) return true; // Indicates we should stop processing
        }
    }
    return false;
};
const $a78c261c3211f7d6$export$4d09fb2a10e54800 = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId, isFooterCommentInPanel: isFooterCommentInPanel = false })=>{
    let commentFound = false;
    let isDisconnected = false;
    const handleCommentFoundWrapper = (commentElement)=>{
        commentFound = true;
        return $a78c261c3211f7d6$var$handleCommentFound(commentElement, targetCommentId, containerId, markElement, onScrollReady);
    };
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                const shouldStop = $a78c261c3211f7d6$var$checkAddedNodes(mutation.addedNodes, targetCommentId, containerId, isFooterCommentInPanel, handleCommentFoundWrapper);
                if (shouldStop) {
                    isDisconnected = true;
                    observer.disconnect();
                    return;
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
            const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
            // If comment exists and show more button is gone, we're ready to scroll
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Returns the HTMLElement or window that should be used as the scroll root. By default, this is the window.
 * For Nav 4, this is the div with id=AkMainContent, if the id exists in the DOM
 *
 * @param isNav4Enabled - boolean
 */ function $a78c261c3211f7d6$var$getScrollRootContext(isNav4Enabled = false) {
    const nav4ScrollRootElement = document.getElementById('AkMainContent');
    const useNav4ScrollRoot = isNav4Enabled && !!nav4ScrollRootElement;
    const scrollRootElement = useNav4ScrollRoot ? nav4ScrollRootElement : window;
    const scrollRootOffset = useNav4ScrollRoot ? nav4ScrollRootElement.scrollTop : window.scrollY;
    return {
        useNav4ScrollRoot: useNav4ScrollRoot,
        scrollRootElement: scrollRootElement,
        scrollRootOffset: scrollRootOffset,
        getDimensions: isNav4Enabled ? $a78c261c3211f7d6$var$getDimensionsForNav4 : $a78c261c3211f7d6$var$getDimensions
    };
}
// Constants for comment thread visibility
const $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS = 8;
const $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW = 60;
const $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads = (generalCommentsHeaderHeight)=>{
    let objectSidebarPanelHeader = document.querySelector("[data-testid='object-sidebar-panel-header']");
    let additionalOffset = 0;
    if (!objectSidebarPanelHeader) {
        objectSidebarPanelHeader = document.querySelector("[data-testid='scrolled-object-sidebar-panel-header']");
        additionalOffset = $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS;
    }
    const objectSidebarPanelHeaderHeight = objectSidebarPanelHeader?.getBoundingClientRect().height ?? 0;
    const objectHeaderHeight = document.querySelector("[data-testid='object-header-container']")?.getBoundingClientRect().height ?? 0;
    const topNavContainerHeight = document.querySelector("[data-testid='grid-topNav']")?.getBoundingClientRect().height ?? 0;
    const bannerContainerHeight = document.querySelector("[data-testid='banner-container']")?.getBoundingClientRect().height ?? 0;
    const editorControlsOnboardingBannerHeight = document.querySelector("[data-testid='editor-controls-onboarding-banner']")?.getBoundingClientRect().height ?? 0;
    const announcementBannerHeight = document.querySelector("[id='AkBanner']")?.getBoundingClientRect().height ?? 0;
    return objectSidebarPanelHeaderHeight + objectHeaderHeight + topNavContainerHeight + bannerContainerHeight + additionalOffset + generalCommentsHeaderHeight + editorControlsOnboardingBannerHeight + announcementBannerHeight;
};
const $a78c261c3211f7d6$export$4d211f4974dcf196 = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const totalPaddingAboveCommentThreadView = $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads(generalCommentsHeaderHeight);
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    const viewportTop = totalPaddingAboveCommentThreadView;
    const viewportBottom = window.innerHeight - objectSidebarPanelFooterHeight;
    const commentTopInView = commentThreadRect.top >= viewportTop;
    const commentBottomInView = commentThreadRect.bottom <= viewportBottom;
    if (commentTopInView && commentBottomInView) // Comment is 100% in view
    return false;
    else if (!commentTopInView && commentBottomInView) // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
    else if (commentTopInView && !commentBottomInView) {
        // Comment is <100% in view and the hidden part is the bottom of the comment
        const hiddenBottomHeight = commentThreadRect.bottom - viewportBottom;
        if (hiddenBottomHeight <= $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW) // The hidden part is <= 60 pixels
        return false;
        else // The hidden part is > 60 pixels
        return true;
    } else // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
};
const $a78c261c3211f7d6$export$9c5b7a3c864ae31b = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    return(// Element is partially out of view below the comments panel viewport
    commentThreadRect.bottom + generalCommentsHeaderHeight > window.innerHeight - objectSidebarPanelFooterHeight);
};
const $a78c261c3211f7d6$export$e3c287b6d80b16ce = ({ pageMode: pageMode, pageWidthType: pageWidthType, hasEndOfPageRecommendations: hasEndOfPageRecommendations })=>{
    const endOfPageRecommendationsMaxWidth = '1000px';
    if (pageMode === (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) {
        // pageWidthType is a string like '"default"' / '"full-width"' in renderer mode, and is undefined in live doc mode
        const isDefaultWidth = pageWidthType && JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT;
        if (hasEndOfPageRecommendations) // when end-of-page recommendations is present, always match its width (see EndOfPageRecContainer.tsx)
        return {
            width: isDefaultWidth ? '87.5%' : '100%',
            maxWidth: endOfPageRecommendationsMaxWidth
        };
        else return {
            width: '100%',
            maxWidth: isDefaultWidth ? '760px' : '1800px' // if not defaultWidth, use full page width
        };
    }
    if (pageMode !== (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width_ld') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) return {
        width: '100%',
        maxWidth: hasEndOfPageRecommendations && (0, $6mKj3.expValEquals)('confluence_ai_related_content_for_live_pages', 'isEnabled', true) ? endOfPageRecommendationsMaxWidth : '100%'
    };
    // Base case: when the fg for the current pageMode isn't ON, i.e. either of:
    // - pageMode === PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // - pageMode !== PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width_ld') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // This block can be removed entirely once both fgs are rolled out.
    let maxWidth = '100%';
    if (pageWidthType) maxWidth = JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT ? '1000px' : 'unset';
    return {
        width: '100%',
        maxWidth: maxWidth
    };
};
module.exports["CREATE_COMMENT_SELECTION_CLASS"] = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
module.exports["HIGHLIGHT_CLASS"] = $a78c261c3211f7d6$export$b803c692fbaaa5a4;
module.exports["ACTIVE_CLASS"] = $a78c261c3211f7d6$export$fb3d0eebfe85522a;
module.exports["getCommentIndexAndCount"] = $a78c261c3211f7d6$export$b899b07e3f725968;
module.exports["getInlineMarkSelector"] = $a78c261c3211f7d6$export$8c7b048437c01388;
module.exports["getMarkerRef"] = $a78c261c3211f7d6$export$8f4213b45c05ab5d;
module.exports["getSortedMarkerRefs"] = $a78c261c3211f7d6$export$9b48c18cc387f791;
module.exports["clearActiveHighlight"] = $a78c261c3211f7d6$export$f7ceeb7ba8156450;
module.exports["getNextTextNode"] = $a78c261c3211f7d6$export$3e98291f1f032a77;
module.exports["getHighlightOffset"] = $a78c261c3211f7d6$export$739c145b6a07c076;
module.exports["getHighlightFromMarkerRef"] = $a78c261c3211f7d6$export$21445ab787d3b446;
module.exports["calculateElementOffset"] = $a78c261c3211f7d6$export$331805bfbe18b1c0;
module.exports["resetTemporaryDOMHighlight"] = $a78c261c3211f7d6$export$743373b19993e2b0;
module.exports["convertDOMHighlightToMark"] = $a78c261c3211f7d6$export$a160a5110cbadcb8;
module.exports["setCommentAsActive"] = $a78c261c3211f7d6$export$fd55463aeed84830;
module.exports["removeMarkInDOM"] = $a78c261c3211f7d6$export$a26c4eafef12029f;
module.exports["isEmptyAdf"] = $a78c261c3211f7d6$export$915f03d46d87bfd4;
module.exports["keyPropagationList"] = $a78c261c3211f7d6$export$6d23af9d8c2844b1;
module.exports["scrollPageCommentIntoView"] = $a78c261c3211f7d6$export$858fd2398afb28e4;
module.exports["handleScrollToElement"] = $a78c261c3211f7d6$export$b451b837f5309ae9;
module.exports["scrollToElementWithViewingRoom"] = $a78c261c3211f7d6$export$fc9b5eebad60b835;
module.exports["checkElementExpand"] = $a78c261c3211f7d6$export$876171b9c9b54aab;
module.exports["scrollCommentIntoView"] = $a78c261c3211f7d6$export$c7436bd0a15f3e7e;
module.exports["getSidebarId"] = $a78c261c3211f7d6$export$fb40c5e75b82df8;
module.exports["scrollToComment"] = $a78c261c3211f7d6$export$db9eae89818590a4;
module.exports["checkElementExpandMultiLevelCommon"] = $a78c261c3211f7d6$export$1a2319f5c2109ee1;
module.exports["getNextMarkerRef"] = $a78c261c3211f7d6$export$187f977414e8342c;
module.exports["getNextUnreadThreadKey"] = $a78c261c3211f7d6$export$883ebc059dd86e88;
module.exports["isClipboardApiSupported"] = $a78c261c3211f7d6$export$b401b3c3a0774fd7;
module.exports["isIEClipboardApiSupported"] = $a78c261c3211f7d6$export$bec1a1359bf081c5;
module.exports["copyToClipboardIE"] = $a78c261c3211f7d6$export$dcc703cd1f894b4c;
module.exports["copyToClipboard"] = $a78c261c3211f7d6$export$2cdf1b96a9f86d16;
module.exports["legacyCopyToClipboard"] = $a78c261c3211f7d6$export$d26ca9d0d4cbdbe9;
module.exports["calculateEditorOffsetFromParent"] = $a78c261c3211f7d6$export$ab567600730c0b3b;
module.exports["calculateRendererOffsetFromParent"] = $a78c261c3211f7d6$export$3cdeee3ea1732782;
module.exports["getCommentPositionTopOfSectionEditor"] = $a78c261c3211f7d6$export$9f8164812b21bc7a;
module.exports["getCommentPositionTopOfSectionRenderer"] = $a78c261c3211f7d6$export$e3a17b46d43aa5f6;
module.exports["watchForCommentContainerAndScroll"] = $a78c261c3211f7d6$export$b3ba907d5759e257;
module.exports["watchForCommentRepliesAndScroll"] = $a78c261c3211f7d6$export$b1b7c9bcc75c855d;
module.exports["shouldScrollCommentThreadToTop"] = $a78c261c3211f7d6$export$4d211f4974dcf196;
module.exports["isCommentThreadReplyOutOfView"] = $a78c261c3211f7d6$export$9c5b7a3c864ae31b;
module.exports["getWidthAndMaxWidth"] = $a78c261c3211f7d6$export$e3c287b6d80b16ce;

});

parcelRegister("fNzRA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $en1dX = parcelRequire("en1dX");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

var $7b4a2f6cc35c72e1$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $7b4a2f6cc35c72e1$export$8a175172a11240d4 = /*#__PURE__*/ (0, $42omo.createContext)({
    expandCommentContainer: ()=>{},
    closeCommentContainer: ()=>{},
    setWrapperWidth: ()=>{},
    setIsObjectCommentWrapperVisible: ()=>{},
    setFooterEditorEntry: ()=>{}
});
$7b4a2f6cc35c72e1$export$8a175172a11240d4.displayName = 'ObjectCommentDispatchContext';
const $7b4a2f6cc35c72e1$export$358734f355c08965 = /*#__PURE__*/ (0, $42omo.createContext)({
    expanded: false,
    footerEditorEntry: undefined,
    width: undefined,
    isObjectCommentWrapperVisible: false
});
$7b4a2f6cc35c72e1$export$358734f355c08965.displayName = 'ObjectCommentContext';
const $7b4a2f6cc35c72e1$export$d248a0e4aca56201 = ({ children: children })=>{
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $42omo.useState)(undefined);
    const [width, setWidth] = (0, $42omo.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $42omo.useState)(false);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const providerValue = (0, $42omo.useMemo)(()=>({
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        }), [
        expanded,
        footerEditorEntry,
        width,
        isObjectCommentWrapperVisible
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            expandCommentContainer: (props)=>{
                const { entryPoint: entryPoint } = props ?? {};
                if (entryPoint && (0, $9wGTI.fg)('confluence_fe_add_page_comment_exp_coverage')) (0, $8Ss4E.startEditorExperiences)({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    attributes: {
                        editor: 'FABRIC',
                        isSingleExperience: true,
                        edition: edition,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        entryPoint: entryPoint
                    }
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
                });
                setExpanded(true);
            },
            closeCommentContainer: ()=>{
                setFooterEditorEntry(undefined);
                setExpanded(false);
            },
            setWrapperWidth: (width)=>{
                setWidth(width ? `${width}px` : '100%');
            },
            setIsObjectCommentWrapperVisible: (visible)=>{
                setIsObjectCommentWrapperVisible(visible);
            },
            setFooterEditorEntry: (footerEditorEntry)=>{
                setFooterEditorEntry(footerEditorEntry);
            }
        }), [
        setExpanded,
        setFooterEditorEntry,
        setWidth,
        setIsObjectCommentWrapperVisible,
        edition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $7b4a2f6cc35c72e1$export$da430766ddf17a6b = ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
};
const $7b4a2f6cc35c72e1$export$8ba3235fe153fa01 = ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
};
module.exports["AddFooterCommentMode"] = $7b4a2f6cc35c72e1$export$94f8d08c2312472b;
module.exports["ObjectCommentProvider"] = $7b4a2f6cc35c72e1$export$d248a0e4aca56201;
module.exports["useObjectCommentContext"] = $7b4a2f6cc35c72e1$export$da430766ddf17a6b;
module.exports["useObjectCommentDispatchContext"] = $7b4a2f6cc35c72e1$export$8ba3235fe153fa01;

});

parcelRegister("en1dX", function(module, exports) {
var $88e03e673e36ecc4$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["COMMENTS_PANEL"] = "commentsPanel";
    AnalyticsSource["STANDALONE"] = "standalone";
    AnalyticsSource["PAGE_FOOTER"] = "pageFooter";
    return AnalyticsSource;
}({});
var $88e03e673e36ecc4$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["REOPEN_COMMENT"] = "reopenComment";
    return ActionName;
}({});
var $88e03e673e36ecc4$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    CommentType["PAGE"] = "page";
    return CommentType;
}({});
module.exports["AnalyticsSource"] = $88e03e673e36ecc4$export$6890652a1aff7d1c;
module.exports["ActionName"] = $88e03e673e36ecc4$export$9c95d6e1614bad84;
module.exports["CommentType"] = $88e03e673e36ecc4$export$ffa1150e6a48f9cd;

});

parcelRegister("k8e76", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");


var $hE1Uz = parcelRequire("hE1Uz");

const $221ff47547c5dafc$var$initialState = {
    unresolvedInlineComments: []
};
const $221ff47547c5dafc$var$actions = {
    updateUnresolvedInlineComment: (unresolvedInlineComments)=>({ setState: setState })=>{
            setState({
                unresolvedInlineComments: unresolvedInlineComments
            });
        },
    addUnresolvedInlineComment: (unresolvedAnnotationId, pageModes)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            setState({
                unresolvedInlineComments: (0, $hE1Uz.findUnresolvedCommentIndex)(unresolvedAnnotationId, unresolvedInlineComments, pageModes)
            });
        },
    removeUnresolvedInlineComment: (unresolvedAnnotationId)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            const updatedUnresolvedInlineComments = [
                ...unresolvedInlineComments
            ];
            const unresolvedAnnotationIdx = updatedUnresolvedInlineComments.indexOf(unresolvedAnnotationId);
            // Remove the passed in comment if it exists and reset the state
            if (unresolvedAnnotationIdx > -1) {
                updatedUnresolvedInlineComments.splice(unresolvedAnnotationIdx, 1);
                setState({
                    unresolvedInlineComments: updatedUnresolvedInlineComments
                });
            }
        }
};
const $221ff47547c5dafc$var$InlineCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $221ff47547c5dafc$var$initialState,
    actions: $221ff47547c5dafc$var$actions,
    name: 'InlineCommentsStore'
});
const $221ff47547c5dafc$export$2d5fb1576e30b55e = (0, $9zUhf.createHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$84bffd53ee003f3d = (0, $9zUhf.createActionsHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$f4e420e107a562b0 = (0, $9zUhf.createStateHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$d9930cd528b1e4f5 = (0, $j1v0l.createSubscriber)($221ff47547c5dafc$var$InlineCommentsStore);
module.exports["useInlineComments"] = $221ff47547c5dafc$export$2d5fb1576e30b55e;
module.exports["useInlineCommentsActions"] = $221ff47547c5dafc$export$84bffd53ee003f3d;
module.exports["useInlineCommentsState"] = $221ff47547c5dafc$export$f4e420e107a562b0;

});

parcelRegister("hE1Uz", function(module, exports) {
var $8288f6cefaa5e2cf$var$PageMode = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}($8288f6cefaa5e2cf$var$PageMode || {});
const $8288f6cefaa5e2cf$export$556f3f3c22ea5327 = (unresolvedAnnotationId, unresolvedInlineComments, pageMode)=>{
    const isFullPageEditor = pageMode === "live" || pageMode === "edit";
    let activeAnnotationMarks;
    if (isFullPageEditor) {
        // In the full-page editor mode, collect parent spans with unique IDs for annotation boundaries
        const parentSpansSet = new Set();
        const annotations = document.querySelectorAll('.ak-editor-annotation-focus, .ak-editor-annotation-blur');
        annotations.forEach((element)=>{
            const parentSpan = element.closest('span[id]');
            if (parentSpan) parentSpansSet.add(parentSpan);
        });
        activeAnnotationMarks = Array.from(parentSpansSet);
    } else // For renderer or view mode, collect marks with active annotation state
    activeAnnotationMarks = Array.from(document.querySelectorAll("mark[data-mark-annotation-state='active']"));
    // Attempt to find the index of the new unresolved annotation by matching its element
    const newlyUnresolvedAnnotation = document.getElementById(unresolvedAnnotationId);
    const allUnresolvedAnnotations = Array.from(activeAnnotationMarks);
    const matchedIndex = newlyUnresolvedAnnotation ? allUnresolvedAnnotations.indexOf(newlyUnresolvedAnnotation) : -1;
    // Construct the new array with unresolved comments
    const newUnresolvedInlineComments = [
        ...unresolvedInlineComments
    ];
    if (matchedIndex !== -1) newUnresolvedInlineComments.splice(matchedIndex, 0, unresolvedAnnotationId);
    else newUnresolvedInlineComments.push(unresolvedAnnotationId);
    return newUnresolvedInlineComments;
};
module.exports["findUnresolvedCommentIndex"] = $8288f6cefaa5e2cf$export$556f3f3c22ea5327;

});

parcelRegister("9jl6v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ag6aQ = parcelRequire("ag6aQ");


var $aHcFH = parcelRequire("aHcFH");


var $9FoVw = parcelRequire("9FoVw");


var $i49vP = parcelRequire("i49vP");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $9wGTI = parcelRequire("9wGTI");

const $427c50c01d3953e2$export$87eb11c3f8007b3b = /*#__PURE__*/ (0, $42omo.createContext)({
    createComment: ()=>{},
    clearCreateHighlight: ()=>{},
    onHighlightClick: ()=>{},
    toggleSidebar: ()=>{},
    setResolvedComment: ()=>{},
    setActiveHighlight: ()=>{},
    navigateToInlineComment: ()=>{}
});
$427c50c01d3953e2$export$87eb11c3f8007b3b.displayName = 'InlineCommentsDispatchContext';
const $427c50c01d3953e2$export$e6352a1cdc05c52c = /*#__PURE__*/ (0, $42omo.createContext)({
    newCommentHighlight: undefined,
    highlightOrigin: 'userHighlight',
    activeHighlight: null,
    firstHighlightClicked: false,
    shouldDisplaySidebar: false,
    resolvedComment: null
});
$427c50c01d3953e2$export$e6352a1cdc05c52c.displayName = 'InlineCommentsContext';
const $427c50c01d3953e2$export$f54686667fb05777 = ({ children: children })=>{
    const [newCommentHighlight, setNewCommentHighlight] = (0, $42omo.useState)();
    const [highlightOrigin, setHighlightOrigin] = (0, $42omo.useState)('userHighlight');
    /**
	 * We eventually want this value to be the official state for loading/displaying
	 * the UI for inline comments. InlineCommentSidebar and some child components have created
	 * stateful logic (active highlight, isSidebarShown, etc) that assumes
	 * the code is always loaded which we will eventually adjust.
	 */ const [shouldDisplaySidebar, setShouldDisplaySidebar] = (0, $42omo.useState)(false);
    const firstHighlightClicked = (0, $42omo.useRef)(false);
    const [activeHighlight, setActiveHighlight] = (0, $42omo.useState)(null);
    const [resolvedComment, setResolvedComment] = (0, $42omo.useState)(null);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const providerValue = (0, $42omo.useMemo)(()=>({
            newCommentHighlight: newCommentHighlight,
            highlightOrigin: highlightOrigin,
            activeHighlight: activeHighlight,
            resolvedComment: resolvedComment,
            firstHighlightClicked: firstHighlightClicked.current,
            shouldDisplaySidebar: shouldDisplaySidebar
        }), [
        activeHighlight,
        highlightOrigin,
        newCommentHighlight,
        resolvedComment,
        shouldDisplaySidebar,
        firstHighlightClicked
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            createComment: (newHighlight, origin = 'userHighlight')=>{
                /**
				 * Creating a comment is one of the three user explicit scenarios
				 * where we want to load inline comments code.
				 */ setShouldDisplaySidebar(true);
                setNewCommentHighlight(newHighlight);
                setHighlightOrigin(origin);
                if (resolvedComment) setResolvedComment(null);
            },
            clearCreateHighlight: ()=>setNewCommentHighlight(undefined),
            onHighlightClick: (markerRef)=>{
                if (!firstHighlightClicked.current) firstHighlightClicked.current = true;
                /**
				 * Clicking on a highlight is one of the three user explicit scenarios
				 * where we want to load inline comments code.
				 */ if (markerRef) setShouldDisplaySidebar(true);
                else setShouldDisplaySidebar(false);
                setActiveHighlight(markerRef);
            },
            setResolvedComment: setResolvedComment,
            toggleSidebar: (shouldDisplay)=>setShouldDisplaySidebar(shouldDisplay),
            setActiveHighlight: setActiveHighlight,
            navigateToInlineComment: ({ action: action, triggeredByKeyboardShortcut: triggeredByKeyboardShortcut, currentCommentIndex: currentCommentIndex, onNavigationClick: onNavigationClick, isEditor: isEditor, removeCommentQueryParams: removeCommentQueryParams, unresolvedInlineComments: unresolvedInlineComments, createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isNavigateToNextUnread: isNavigateToNextUnread, unreadInlineComments: unreadInlineComments = [], unreadGeneralComments: unreadGeneralComments = [], getCommentIndex: getCommentIndex, footerComments: footerComments = [], scrollToFooterComment: scrollToFooterComment, commentsDataMap: commentsDataMap })=>{
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    navigationAction: action
                });
                const couldBeNavigatingToFooterComment = triggeredByKeyboardShortcut && footerComments?.length > 0 && (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
                if (unresolvedInlineComments?.length < 2 && !couldBeNavigatingToFooterComment) {
                    (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                        abortReason: 'Comment navigation when only one comment'
                    });
                    if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'Comment navigation when only one comment',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: 'comment-context/InlineCommentsContext'
                        }
                    });
                    return;
                }
                // Clear the focusedCommentId queryParams so that reply does not opens up if any...
                removeCommentQueryParams();
                const combinedInlineFooterComments = [
                    ...unresolvedInlineComments,
                    ...footerComments
                ];
                let nextThreadKey = '';
                let currentThreadKey = '';
                if (triggeredByKeyboardShortcut && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    if (isNavigateToNextUnread) {
                        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) {
                            // Add 1 to currentCommentIndex to move to the next comment, otherwise it gets stuck on the current comment
                            const nextIndex = currentCommentIndex + 1;
                            nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(nextIndex, combinedInlineFooterComments, [
                                ...unreadInlineComments,
                                ...unreadGeneralComments
                            ]) ?? '';
                        } else // Legacy behavior when feature flag is disabled
                        nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(currentCommentIndex, combinedInlineFooterComments, [
                            ...unreadInlineComments,
                            ...unreadGeneralComments
                        ]) ?? '';
                    } else nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, combinedInlineFooterComments) ?? '';
                    currentThreadKey = combinedInlineFooterComments[currentCommentIndex];
                } else {
                    nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, unresolvedInlineComments) ?? '';
                    currentThreadKey = unresolvedInlineComments[currentCommentIndex];
                }
                if (!nextThreadKey) {
                    (0, $4EKKB.selectInlineComment).debug(`Couldn't find next annotation to select in document`);
                    return;
                }
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    annotationId: nextThreadKey
                });
                if (triggeredByKeyboardShortcut && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    if (footerComments.includes(nextThreadKey) && scrollToFooterComment && commentsDataMap?.general?.[nextThreadKey]) {
                        setActiveHighlight(null);
                        scrollToFooterComment(nextThreadKey);
                        (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                            abortReason: 'Navigating to general comment'
                        });
                        return;
                    }
                }
                const nextCommentElement = document.getElementById(nextThreadKey) || ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? document.getElementById(`footer-comment-thread-${nextThreadKey}-container`) : null);
                const previousCommentElement = document.getElementById(currentThreadKey) || ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? document.getElementById(`footer-comment-thread-${currentThreadKey}-container`) : null);
                if (nextCommentElement) (0, $i49vP.checkElementExpandInEditor)(nextCommentElement);
                else (0, $4EKKB.selectInlineComment).debug('No annotation found in doc to check if in expand');
                onNavigationClick(nextThreadKey);
                const nextCommentIndex = getCommentIndex(nextThreadKey);
                let heightOfMediaCommentSelectedPlaceholder = 0;
                if ((0, $9wGTI.fg)('confluence_frontend_new_comments_scrolling')) {
                    const isCurrentCommentContentMediaComment = previousCommentElement?.closest('.media-single-node');
                    const isNavigatingToLastCommentFromPreviousAction = action === 'previous' && nextCommentIndex === unresolvedInlineComments.length - 1;
                    const isNavigatingToFirstCommentFromNextAction = action === 'next' && nextCommentIndex === 0;
                    if (isCurrentCommentContentMediaComment && (action === 'next' || isNavigatingToLastCommentFromPreviousAction || isNavigatingToFirstCommentFromNextAction)) {
                        // if the media comment placeholder is visible, it pushes the contents of the page down, which affects navigating to the prev and next comment
                        // this means we'll need to scroll a bit less so that the cursor is still over the navigation arrow icon
                        const mediaCommentSelectedPlaceholder = document.querySelector('[data-id="caption-placeholder"]');
                        heightOfMediaCommentSelectedPlaceholder = mediaCommentSelectedPlaceholder ? mediaCommentSelectedPlaceholder.offsetHeight : 0;
                    }
                }
                const previousOffset = previousCommentElement ? (0, $aHcFH.calculateElementOffset)(previousCommentElement) : 0;
                const offset = (0, $aHcFH.calculateElementOffset)(nextCommentElement);
                const scrollableContainerSelector = isEditor ? '.fabric-editor-popup-scroll-parent' : '#content-body';
                const scrollableContainer = document.querySelector(scrollableContainerSelector);
                const differenceOffset = offset - previousOffset - heightOfMediaCommentSelectedPlaceholder;
                const enableOnArrowNavigation = (0, $9wGTI.fg)('confluence_comments_disable_scroll') ? !triggeredByKeyboardShortcut : true;
                // Feature gate: Use unified navigation or legacy scrolling
                if (enableOnArrowNavigation) {
                    if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) // Use unified navigation
                    (0, $9FoVw.handleInlineHeaderArrowsNavigation)({
                        previousMarkerRef: currentThreadKey,
                        nextMarkerRef: nextThreadKey,
                        context: isEditor ? (0, $9FoVw.NavigationContext).EDITOR : (0, $9FoVw.NavigationContext).RENDERER
                    });
                    else {
                        // Use legacy scrolling (scrollBy + scrollToComment)
                        scrollableContainer?.scrollBy(0, differenceOffset);
                        (0, $aHcFH.scrollToComment)(nextCommentElement, previousCommentElement, true, Boolean(isEditor));
                    }
                }
                if (nextCommentElement) {
                    // As we navigate inline comments with arrow icons, we want to update the cursor location to where the open inline comment is
                    // unless it is a media node in which case, we want our selection to be the media node element.
                    const media = nextCommentElement.querySelector(`.${(0, $ag6aQ.ClassNames).MEDIA_CONTAINER}`);
                    if (media) {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'block',
                            blockType: 'media'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(media);
                    } else {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'inline'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(nextCommentElement);
                    }
                }
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'navigate',
                        actionSubjectId: 'inlineCommentArrowsNavigate',
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            action: action
                        },
                        objectType: 'inlineComment',
                        objectId: contentId,
                        source: isEditor ? 'editPageScreen' : 'renderPageScreen'
                    }
                }).fire();
            }
        }), [
        resolvedComment,
        firstHighlightClicked,
        setShouldDisplaySidebar,
        setHighlightOrigin,
        setResolvedComment,
        setActiveHighlight,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($427c50c01d3953e2$export$e6352a1cdc05c52c.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($427c50c01d3953e2$export$87eb11c3f8007b3b.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $427c50c01d3953e2$export$89bc450b4e1563a9 = ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
};
const $427c50c01d3953e2$export$43e36990fc9d516b = ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
};
module.exports["InlineCommentsProvider"] = $427c50c01d3953e2$export$f54686667fb05777;
module.exports["useInlineCommentsContext"] = $427c50c01d3953e2$export$89bc450b4e1563a9;
module.exports["useInlineCommentsDispatchContext"] = $427c50c01d3953e2$export$43e36990fc9d516b;

});

parcelRegister("dkkKv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fHAwL = parcelRequire("fHAwL");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $aqBZ0 = parcelRequire("aqBZ0");


var $aUU0C = parcelRequire("aUU0C");


var $9rE3H = parcelRequire("9rE3H");


var $eg9xl = parcelRequire("eg9xl");


var $8i27m = parcelRequire("8i27m");


var $3ZsvI = parcelRequire("3ZsvI");

const $7c240d799ee287c0$export$1369688a638bab5e = ({ pageId: pageId, skip: skip = false, type: type, onCompletedFn: onCompletedFn, returnNativeLoading: returnNativeLoading = false, useStableCommentsDataUpdates: useStableCommentsDataUpdates = false, fetchPolicy: fetchPolicy, isPreload: isPreload = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [{ commentsDataMap: commentsDataMap, cacheUpdateFailed: cacheUpdateFailed }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap, setFooterCommentsLoadingState: setFooterCommentsLoadingState }] = (0, $8i27m.useCommentsData)();
    const [{ readCommentsListState: readCommentsListState }] = (0, $fHAwL.useUnreadComments)();
    const [{ annotations: annotations }] = (0, $aUU0C.useEditorAnnotations)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const annotationsInEditorDoc = (0, $42omo.useMemo)(()=>{
        return new Set(annotations);
    }, [
        annotations
    ]);
    // Determine if the query should be skipped
    const skipQuery = !pageId || skip;
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0 || Object.keys(commentsDataMap.general).length > 0;
    // Check if the page is archived
    const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
    // Using preload variables isn't 100% necessary since we write to the full cache,
    // but should be more stable in the event the full cache update fails
    const queryVariables = isPreload ? (0, $9rE3H.buildConsistentActiveCommentsQueryPreloadVariables)(pageId, isArchived) : (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
        pageId: pageId,
        type: type,
        isArchived: isArchived
    });
    const cacheUpdateFailedFetchPolicy = cacheUpdateFailed && (0, $9wGTI.fg)('confluence_comment_donot_use_cache') ? 'network-only' : undefined;
    const defaultFetchPolicy = skipQuery || isPreload ? 'cache-only' : 'cache-and-network'; // TODO: Cache and network probably not perfect, used to ensure consistency on the panel
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $eg9xl.ActiveCommentsQuery), {
        variables: queryVariables,
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: fetchPolicy || cacheUpdateFailedFetchPolicy || defaultFetchPolicy,
        skip: skipQuery,
        onCompleted: (result)=>{
            // onCompleted doesn't fire as expected after multiple cache reads
            if (!useStableCommentsDataUpdates && result) {
                (0, $3ZsvI.updateCommentsDataState)({
                    data: result,
                    readCommentsListState: readCommentsListState,
                    updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                    annotationsInEditorDoc: annotationsInEditorDoc,
                    pageMode: pageMode,
                    currentUserId: currentUserId ?? '',
                    isOpen: true
                });
                if (!skipQuery) // Don't update loading state if the query is skipped
                // onCompleted will still get called in some circumstances with skip = true
                (0, $3ZsvI.updateFooterCommentsLoadingState)(data, setFooterCommentsLoadingState);
            }
            setLoading(false);
            if (result) onCompletedFn && onCompletedFn();
        },
        onError: undefined,
        errorPolicy: 'all'
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (error.message.search(/reactions/i) !== -1 || error.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
            setLoading(false);
        }
    }, [
        error
    ]);
    (0, $42omo.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    let returnLoading = queryLoading;
    // If we're not returning the native loading out of apollo, update returnLoading to our tracked version
    if (!returnNativeLoading) returnLoading = !skipQuery ? loading : false;
    // We set totalCount to ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG when preload is loading
    // We should respect this regardless of context, since the query really is loading behind the scenes
    const isPreloadLoading = data?.comments?.totalCount === (0, $9rE3H.ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG);
    returnLoading = isPreloadLoading || returnLoading;
    (0, $42omo.useEffect)(()=>{
        // onCompleted gets fired on the first cache-read only, which as you can imagine causes a lot of race conditions during transition
        // This is the recommended way to deal with complex scenarios involving cache + network reads
        // onCompleted will also fire incorrectly for concurrent calls on the same page, since it has an outdated copy of hasAlreadyFetchedInitialData telescoped in before some calls complete
        if (!skipQuery && isPreloadLoading) // Mark this as preloading to prevent race conditions where loading is not yet set in caller
        setFooterCommentsLoadingState((0, $8i27m.FooterCommentsLoadingStateType).PRELOADING);
        if (useStableCommentsDataUpdates && !isPreloadLoading && !skipQuery && data) {
            // Preload updates data, which we don't want
            (0, $3ZsvI.updateCommentsDataState)({
                data: data,
                readCommentsListState: readCommentsListState,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                annotationsInEditorDoc: annotationsInEditorDoc,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: true
            });
            // Don't update loading state if the query is skipped
            (0, $3ZsvI.updateFooterCommentsLoadingState)(data, setFooterCommentsLoadingState);
        }
    }, [
        data,
        useStableCommentsDataUpdates,
        hasAlreadyFetchedInitialData,
        addNewCommentThreads,
        setCommentsDataMap,
        annotationsInEditorDoc,
        pageMode,
        currentUserId,
        readCommentsListState,
        skipQuery,
        type,
        setFooterCommentsLoadingState,
        isPreloadLoading
    ]);
    return {
        loading: returnLoading,
        data: data,
        error: error,
        refetch: refetch
    };
};
module.exports["useActiveCommentsQuery"] = $7c240d799ee287c0$export$1369688a638bab5e;

});

parcelRegister("aqBZ0", function(module, exports) {
const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;

});

parcelRegister("4L9ve", function(module, exports) {
/**
 * Sweet state store for processed comments data.
 * This store should ONLY be updated by CommentsDataBackgroundLoader.
 * All other consumers should use the state/actions hooks to read data.
 */ 
var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4HDYO = parcelRequire("4HDYO");

const $20eb19f7ec5706e8$export$53ac33307b5acee9 = ()=>({
        allComments: [],
        allFilteredComments: [],
        openInlineComments: [],
        openFooterComments: [],
        resolvedComments: [],
        openComments: [],
        commentsDataMap: {
            inline: {},
            general: {}
        },
        flatCommentsMap: {},
        flatMarkerRefMap: {},
        hasNestedComments: false,
        isDataProcessed: false,
        commentCount: 0,
        hasAnyComments: false,
        error: undefined,
        refetch: undefined
    });
const $20eb19f7ec5706e8$export$e324594224ef24da = {
    /**
	 * Updates all processed comments data.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 * Note: refetch is set separately via setRefetch, so it's not included here.
	 */ setProcessedData: (data)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...data,
                error: undefined,
                // Keep existing refetch if it exists, don't overwrite it
                refetch: currentState.refetch
            });
        },
    /**
	 * Sets an error state for processed comments data.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setError: (error)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                error: error,
                isDataProcessed: true
            });
        },
    /**
	 * Sets the refetch function from useAllCommentsData.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setRefetch: (refetch)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                refetch: refetch
            });
        },
    /**
	 * Clears all processed comments data and resets to initial state.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ clearProcessedData: ()=>({ setState: setState })=>{
            setState($20eb19f7ec5706e8$export$53ac33307b5acee9());
        }
};
const $20eb19f7ec5706e8$export$4be6ac988c62a591 = (0, $1P1Tu.createStore)({
    initialState: $20eb19f7ec5706e8$export$53ac33307b5acee9(),
    actions: $20eb19f7ec5706e8$export$e324594224ef24da,
    name: 'ProcessedCommentsDataStore'
});
const $20eb19f7ec5706e8$export$421cff7071854c91 = (0, $9zUhf.createHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$2919c8d01260d4fe = (0, $9zUhf.createActionsHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$93d43ef0fc9d136b = (0, $9zUhf.createStateHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
// Non-React utility for accessing store outside of React components
const $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance = (0, $4HDYO.defaultRegistry).getStore($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$db6951977b558d4d = ()=>{
    return $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance.storeState.getState();
};
module.exports["useProcessedCommentsDataActions"] = $20eb19f7ec5706e8$export$2919c8d01260d4fe;
module.exports["useProcessedCommentsDataState"] = $20eb19f7ec5706e8$export$93d43ef0fc9d136b;
module.exports["getProcessedCommentsDataState"] = $20eb19f7ec5706e8$export$db6951977b558d4d;

});

parcelRegister("cgy29", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aWwYt = parcelRequire("aWwYt");


var $cMvMc = parcelRequire("cMvMc");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $brNvA = parcelRequire("brNvA");


var $cZa7r = parcelRequire("cZa7r");


var $4DJgG = parcelRequire("4DJgG");

const $dacb5f0322f4a333$export$5ae138a5a05281f1 = ({ contentId: contentId, isFabric: isFabric, sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics })=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor } = (0, $cZa7r.useAnnotationsDispatch)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach } = (0, $brNvA.useReattachComment)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const content = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        content.current = document.querySelector('div#content');
    }, []);
    const createReactInlineCommentHighlight = ({ experienceAttributes: experienceAttributes } = {})=>{
        if (isObjectSidebarShown) hideObjectSidebar();
        if (isFabric) setSelectionOptionsForCreateEditor({
            experienceAttributes: experienceAttributes
        });
        else if (content.current) createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach
        }));
    };
    const handleCommentButtonClick = ({ dialogs: dialogs, shortcut: shortcut, experienceAttributes: experienceAttributes })=>{
        if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>createReactInlineCommentHighlight({
                    experienceAttributes: experienceAttributes
                })
        });
        else createReactInlineCommentHighlight({
            experienceAttributes: experienceAttributes
        });
        if (shortcut) sendKeyboardShortcutAnalytics(shortcut);
    };
    return {
        handleCommentButtonClick: handleCommentButtonClick
    };
};
module.exports["useCreateCommentAction"] = $dacb5f0322f4a333$export$5ae138a5a05281f1;

});

parcelRegister("brNvA", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $2c05d1bead0fe3b6$export$fb4e7a383f5cb089 = /*#__PURE__*/ (0, $42omo.createContext)({
    commentToReattach: null,
    reattachHighlight: null,
    isInReattachMode: ()=>false
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentContext';
const $2c05d1bead0fe3b6$export$29a077948aa018ea = /*#__PURE__*/ (0, $42omo.createContext)({
    setCommentToReattach: ()=>{},
    setReattachHighlight: ()=>{},
    clearReattachMode: ()=>{}
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentDispatchContext';
const $2c05d1bead0fe3b6$export$eeb6c3345224df9d = ({ children: children })=>{
    const [commentToReattach, setCommentToReattach] = (0, $42omo.useState)(null);
    const [reattachHighlight, setReattachHighlight] = (0, $42omo.useState)(null);
    const providerValue = (0, $42omo.useMemo)(()=>({
            commentToReattach: commentToReattach,
            reattachHighlight: reattachHighlight,
            isInReattachMode: ()=>Boolean(commentToReattach)
        }), [
        commentToReattach,
        reattachHighlight
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setCommentToReattach: setCommentToReattach,
            setReattachHighlight: (highlight)=>{
                setReattachHighlight(highlight?.numMatches !== 0 ? highlight : null);
            },
            clearReattachMode: ()=>{
                setCommentToReattach(null);
                setReattachHighlight(null);
            }
        }), [
        setCommentToReattach,
        setReattachHighlight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c05d1bead0fe3b6$export$fb4e7a383f5cb089.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c05d1bead0fe3b6$export$29a077948aa018ea.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $2c05d1bead0fe3b6$export$d801c7a3a205f98e = ()=>{
    return (0, $42omo.useContext)($2c05d1bead0fe3b6$export$fb4e7a383f5cb089);
};
const $2c05d1bead0fe3b6$export$344893016ba0bdd4 = ()=>{
    return (0, $42omo.useContext)($2c05d1bead0fe3b6$export$29a077948aa018ea);
};
module.exports["ReattachCommentContext"] = $2c05d1bead0fe3b6$export$fb4e7a383f5cb089;
module.exports["ReattachCommentProvider"] = $2c05d1bead0fe3b6$export$eeb6c3345224df9d;
module.exports["useReattachComment"] = $2c05d1bead0fe3b6$export$d801c7a3a205f98e;
module.exports["useReattachCommentDispatch"] = $2c05d1bead0fe3b6$export$344893016ba0bdd4;

});

parcelRegister("4DJgG", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $7W8i8 = parcelRequire("7W8i8");


var $9wGTI = parcelRequire("9wGTI");


var $aUTn5 = parcelRequire("aUTn5");

const $917b9bb03b3149d5$var$logger = (0, $7W8i8.getLogger)('inline-comment');
const $917b9bb03b3149d5$export$dbde27c406dff8e8 = ({ content: content, contentId: contentId, commentToReattach: commentToReattach, actions: actions })=>{
    let selectionObj = {
        numMatches: 0,
        matchIndex: -1,
        selectedText: '',
        timestamp: 0
    };
    const selection = window.getSelection();
    // TODO: Clean up as a part of https://product-fabric.atlassian.net/browse/COMMENTS-5258
    if ((!selection || selection.rangeCount === 0) && (0, $9wGTI.fg)('confluece_fe_comments_no_selection')) {
        $917b9bb03b3149d5$var$logger.debug`No text selected. Creating inline comment at cursor position.`;
        return selectionObj;
    }
    if (selection) {
        // TODO clean up after above FG is removed
        const range = selection.getRangeAt(0);
        const legacySelection = (0, $aUTn5.convertSelectionToLegacyFormat)(content.current, range, contentId);
        const { searchText: { numMatches: numMatches, index: matchIndex, selectedText: selectedText } } = legacySelection;
        selectionObj = {
            numMatches: numMatches,
            matchIndex: matchIndex,
            selectedText: selectedText,
            timestamp: Date.now()
        };
        /**
		 * We generate the annotation step for the upcoming new collab service
		 * to consume. This means we will eventually started sending markerRef
		 * ids from the FE.
		 */ try {
            const markerRef = commentToReattach ? commentToReattach.inlineMarkerRef : (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
            if (actions) {
                const proseMirrorStep = actions.annotate(range, markerRef, 'inlineComment');
                const { step: { from: from, to: to, mark: mark } } = proseMirrorStep;
                selectionObj['step'] = {
                    from: from,
                    to: to,
                    mark: {
                        type: 'annotation',
                        attrs: {
                            key: mark.attrs?.annotationType,
                            value: mark.attrs?.id
                        }
                    }
                };
            }
        } catch (e) {
            $917b9bb03b3149d5$var$logger.error`An error occurred when generating a step - ${e}`;
        }
    }
    return selectionObj;
};
module.exports["getLegacyConvertedSelectionObj"] = $917b9bb03b3149d5$export$dbde27c406dff8e8;

});

parcelRegister("liGyh", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $6tkbf = parcelRequire("6tkbf");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $lb2Lp = parcelRequire("lb2Lp");


var $kgNLQ = parcelRequire("kgNLQ");


var $aSsfA = parcelRequire("aSsfA");


var $1rdvc = parcelRequire("1rdvc");

const $ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery = (0, $eSUdr.default)`query useCommentQueryParamsCommentLocationQuery($commentId:ID$contentStatus:[GraphQLContentStatus]){comments(commentId:$commentId contentStatus:$contentStatus){nodes{container{id}location{type}}}}`;
const $ba57c93125c5375a$var$logger = (0, $7W8i8.getLogger)('comment-query-params');
const $ba57c93125c5375a$export$63c5e37b7c8d14d1 = ({ location: location, queryArchivedContent: queryArchivedContent = false } = {})=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [pageId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { focusedCommentId: focusedCommentId, editComment: editComment, commentId: commentId, replyToComment: replyToComment, showCommentArea: showCommentArea, shouldMention: shouldMention, unreadCommentMark: unreadCommentMark } = getQueryParams();
    const targetCommentId = focusedCommentId || replyToComment || editComment && commentId;
    const shouldSkipQuery = !targetCommentId || !location;
    // NEW FLOW: Use useCommentById when experiment is enabled
    const { comment: comment, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: targetCommentId || '',
        contentId: pageId || '',
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: shouldSkipQuery || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
        }
    });
    // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
    const { data: legacyData, error: legacyError } = (0, $xQxzY.useQuery)($ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery, {
        variables: {
            commentId: targetCommentId,
            contentStatus: [
                queryArchivedContent ? (0, $1rdvc.GraphQLContentStatus).ARCHIVED : (0, $1rdvc.GraphQLContentStatus).DRAFT,
                (0, $1rdvc.GraphQLContentStatus).CURRENT
            ]
        },
        skip: shouldSkipQuery || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    if (legacyError) $ba57c93125c5375a$var$logger.error`Error: Unable to query comment location for ${commentId}`;
    // Determine error state - use new flow error or old flow error
    const error = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? commentError : legacyError;
    // Note that this will detect missing inline and footer comments because the query will find
    // either type of comment - so if the comment doesn't exist, we will get the "not found" error
    // In the new flow, useCommentById returns an error when the comment isn't found after loading completes
    const isCommentNotFound = error ? (0, $6tkbf.isCommentNotFoundError)(error.message || String(error)) : false;
    let focusedId;
    let editCommentId;
    let replyToCommentId;
    // Extract location and container ID from either new or old flow
    const commentLocation = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? comment?.location?.type : legacyData?.comments?.nodes?.[0]?.location?.type;
    // Extract container ID from either new or old flow
    let commentContainerId;
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
        if (comment && 'container' in comment) // Comment replies coming from the new manager don't have a container
        commentContainerId = comment.container?.id;
        else commentContainerId = undefined;
    } else commentContainerId = legacyData?.comments?.nodes?.[0]?.container?.id;
    // Only return comment IDs for relevant location; If no location is given, return them all
    const shouldReturnIds = (!location || location === commentLocation) && (pageId === commentContainerId || commentContainerId === undefined && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false));
    if (shouldReturnIds) {
        /* A focused comment query param just uses "focusedCommentId={COMMENT_ID}" */ focusedId = focusedCommentId ? focusedCommentId : undefined;
        /* An edit comment query param uses a combination of "editComment=true&commentId={COMMENT_ID}" */ editCommentId = editComment && editComment === 'true' && commentId ? commentId : undefined;
        /* A reply to comment query param just uses "replyToComment={COMMENT_ID}" */ replyToCommentId = replyToComment ? replyToComment : undefined;
    }
    /* PAGE COMMENTS ONLY: A new comment uses the "showCommentArea=true" query param */ const shouldOpenNewCommentEditor = showCommentArea === 'true';
    /* A mention comment uses the "shouldMention=true" query param */ const shouldMentionInNewCommentEditor = shouldMention === 'true' && replyToCommentId !== undefined;
    const removeCommentQueryParamsFunction = ()=>{
        let commentTypeKey = '', commentIdKey = '', commentMentionKey = '';
        if (focusedId) commentTypeKey = 'focusedCommentId';
        else if (shouldMentionInNewCommentEditor) {
            commentTypeKey = 'replyToComment';
            commentMentionKey = 'shouldMention';
        } else if (replyToCommentId) commentTypeKey = 'replyToComment';
        else if (editCommentId) {
            commentTypeKey = 'editComment';
            commentIdKey = 'commentId';
        } else if (shouldOpenNewCommentEditor) commentTypeKey = 'showCommentArea';
        if (commentTypeKey || commentIdKey || commentMentionKey || unreadCommentMark) {
            const params = getQueryParams();
            setQueryParams({
                ...params,
                [commentTypeKey]: undefined,
                [commentIdKey]: undefined,
                [commentMentionKey]: undefined,
                unreadCommentMark: undefined
            });
        }
    };
    const removeCommentQueryParamsCallback = (0, $42omo.useCallback)(removeCommentQueryParamsFunction, [
        getQueryParams,
        setQueryParams,
        unreadCommentMark,
        editCommentId,
        replyToCommentId,
        shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor,
        focusedId
    ]);
    const removeCommentQueryParams = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? removeCommentQueryParamsCallback : removeCommentQueryParamsFunction;
    const setFocusedCommentQueryParam = (commentId)=>{
        const params = getQueryParams();
        setQueryParams({
            ...params,
            focusedCommentId: commentId
        });
    };
    return {
        focusedCommentId: focusedId,
        editCommentId: editCommentId,
        replyToCommentId: replyToCommentId,
        shouldOpenNewCommentEditor: shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor: shouldMentionInNewCommentEditor,
        unreadCommentMark: unreadCommentMark,
        removeCommentQueryParams: removeCommentQueryParams,
        setFocusedCommentQueryParam: setFocusedCommentQueryParam,
        isCommentNotFound: isCommentNotFound
    };
};
const $ba57c93125c5375a$export$b073d30d47d4035b = ({ queryArchivedContent: queryArchivedContent = false } = {})=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'INLINE',
        queryArchivedContent: queryArchivedContent
    });
const $ba57c93125c5375a$export$97d0ff531551284c = ()=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'FOOTER'
    });
module.exports["useInlineCommentQueryParams"] = $ba57c93125c5375a$export$b073d30d47d4035b;

});

parcelRegister("6tkbf", function(module, exports) {

var $lb2Lp = parcelRequire("lb2Lp");

const $6b00aa328c211ce7$export$9f99b736afd21d01 = (errorMessage)=>{
    if (errorMessage) {
        // Check if the full error message matches the string thrown from useCommentById
        if (errorMessage === (0, $lb2Lp.USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE)) return true;
        // Also check the reason message (extracted from backend error format)
        const reasonStartIdx = errorMessage.lastIndexOf(':') + 1;
        const reasonMessage = errorMessage.substring(reasonStartIdx, errorMessage.length).trim();
        // If this string is ever updated on the BE and you need to change it - make sure to also update USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE for consistency
        const backendReasonMessage = 'No comment found for the given id';
        return reasonMessage === backendReasonMessage;
    }
    return false;
};
module.exports["isCommentNotFoundError"] = $6b00aa328c211ce7$export$9f99b736afd21d01;

});

parcelRegister("lb2Lp", function(module, exports) {

var $dc3kb = parcelRequire("dc3kb");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");

// The `useCommentById` hook efficiently fetches a single comment by ID with a simple strategy:
// First, it checks the cache for the allCommentsDataQuery using useAllCommentsData with cache-only
// policy. If the comment is found in the cache and data is processed, it uses that data. Otherwise,
// it makes a separate query for just the specific comment. This ensures quick access to individual
// comments without unnecessary network requests when data is already cached. The hook also provides
// loading states, error handling, and comprehensive type safety.
// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this hook - or at least the part that executes the query into the
// useAllCommentsData.ts file.
const $f4841d4502be35b2$var$commentByIdQuery = (0, $dc3kb.default);
const $f4841d4502be35b2$export$4bf99575c214d4b = 'Comment not found: No comment found for the given id';
const $f4841d4502be35b2$export$1f091977fe1929e2 = 'useCommentById requires either commentId or markerRef and contentId to be provided';
const $f4841d4502be35b2$export$778dda4ccca7793f = ({ commentId: commentId, markerRef: markerRef, contentId: contentId, contentStatus: contentStatus = [
    'CURRENT'
], options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onError: onError, skip: explicitlySkipped = false } = options;
    // Skip queries if experiment is disabled or explicitly skipped through options
    const skip = explicitlySkipped || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // Validate that at least one identifier is provided (only if not skipping)
    const validationError = (0, $42omo.useMemo)(()=>!skip && (!contentId || !commentId && !markerRef) ? new Error($f4841d4502be35b2$export$1f091977fe1929e2) : undefined, [
        skip,
        commentId,
        markerRef,
        contentId
    ]);
    const skipQueries = skip || !!validationError;
    // Skip the individual comment query if we have cached data from the full query, it's been processed, and we're not asking for fresh BE data
    const shouldSkipOneCommentQuery = skipQueries || fetchPolicy !== 'network-only' && processedCommentsData.isDataProcessed;
    // Always query with all 4 content statuses to guarantee cache hits on preloaded data
    // We'll filter the result client-side based on the passed-in contentStatus
    const oneCommentData = (0, $jMyy4.useQueryInterop)($f4841d4502be35b2$var$commentByIdQuery, {
        variables: {
            pageId: contentId ?? '',
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        skip: shouldSkipOneCommentQuery,
        onError: (error)=>{
            // Handle specific GraphQL errors gracefully
            // WS-3494 - If the error isn't related to reactionsSummary returning null, just mark it handled
            // COMMENTS-188 - Or if the error isn't related to cc-pages not being reachable just mark it handled
            if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
        }
    });
    // Look for the comment using the flat map for O(1) lookup, or fall back to searching arrays
    const finalComment = (0, $42omo.useMemo)(()=>{
        if (validationError) return undefined;
        // If data is processed, try to find in the flat maps (fastest - O(1))
        if (processedCommentsData.isDataProcessed) {
            if (commentId) {
                const cachedComment = processedCommentsData.flatCommentsMap?.[commentId];
                if (cachedComment) return cachedComment;
            } else if (markerRef) {
                const cachedCommentByMarkerRef = processedCommentsData.flatMarkerRefMap?.[markerRef];
                if (cachedCommentByMarkerRef) return cachedCommentByMarkerRef;
            }
        }
        // Fall back to searching in oneCommentData if available
        if (oneCommentData.data?.comments?.nodes) {
            // Filter out any null nodes - can't just use .filter because TS complains about type
            // mismatch.  Fortunately, this query should only have one comment node anyway.
            const commentData = oneCommentData.data.comments.nodes.map((node)=>node).filter((node)=>node);
            if (!commentData) return undefined;
            // Search in retrieved comments and their replies
            return (0, $kgNLQ.findAndFilterComment)(commentData, commentId, markerRef, contentStatus);
        }
        return undefined;
    }, [
        validationError,
        commentId,
        processedCommentsData.flatCommentsMap,
        processedCommentsData.flatMarkerRefMap,
        processedCommentsData.isDataProcessed,
        oneCommentData.data?.comments?.nodes,
        markerRef,
        contentStatus
    ]);
    // Create an error if we have the full response but can't find the comment
    // 99% of the time this error will be thrown when cachedUseAllCommentsData is populated, but the comment isn't available
    // useCommentByIdQuery **should** throw a similar error if the comment isn't found from the BE,
    // but keep the check here in case the BE changes, or our comment is in another status & is filtered out
    const commentNotFoundError = (0, $42omo.useMemo)(()=>{
        // Only create error if:
        // 1. We're not loading anymore (have full response)
        // 2. We have data (either from processedCommentsData or oneCommentData)
        // 3. We searched for the comment but didn't find it
        // 4. There's no existing error
        if (!skipQueries && processedCommentsData.isDataProcessed && !oneCommentData.loading && !processedCommentsData.error && !oneCommentData.error && finalComment === undefined) return new Error($f4841d4502be35b2$export$4bf99575c214d4b);
        return undefined;
    }, [
        skipQueries,
        processedCommentsData.isDataProcessed,
        processedCommentsData.error,
        oneCommentData.loading,
        oneCommentData.error,
        finalComment
    ]);
    return {
        loading: !processedCommentsData.isDataProcessed && oneCommentData.loading,
        // (Only loading state if both are loading)
        error: validationError || processedCommentsData.error || oneCommentData.error || commentNotFoundError,
        comment: finalComment
    };
};
const $f4841d4502be35b2$export$77a85b13740d9b96 = async ({ commentId: commentId, markerRef: markerRef, contentId: contentId, fetchPolicy: fetchPolicy = 'network-only' })=>{
    if (!contentId || !commentId && !markerRef) return Promise.resolve(null);
    const response = await (0, $c0rhi.queryInterop)({
        query: $f4841d4502be35b2$var$commentByIdQuery,
        variables: {
            pageId: contentId,
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            // Query for all content statuses - don't filter by contentStatus
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy
    });
    const nodes = response?.data?.comments?.nodes;
    if (!nodes || nodes.length === 0) return null;
    // Filter out nulls and convert readonly array to mutable array
    const comments = nodes.filter((node)=>node !== null);
    return (0, $kgNLQ.findAndFilterComment)(comments, commentId, markerRef, (0, $NYiei.allContentStatuses));
};
module.exports["USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE"] = $f4841d4502be35b2$export$4bf99575c214d4b;
module.exports["useCommentById"] = $f4841d4502be35b2$export$778dda4ccca7793f;
module.exports["fetchCommentById"] = $f4841d4502be35b2$export$77a85b13740d9b96;

});

parcelRegister("dc3kb", function(module, exports) {
/**
 * @generated SignedSource<<5436b93d76e4ad3ca1b847dd48c8568a>>
 * @relayHash 80f6dc5113d6aef8927adf669909b48e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a7e41ef969ee551d0afd8d103f23ec6991292b83b77931c1782403014e46ce8b
const $09771c757ee62765$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRef"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v12 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v15 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v17 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v22 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = {
        "kind": "ScalarField",
        "name": "when"
    }, v28 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Variable",
                    "name": "inlineMarkerRef",
                    "variableName": "inlineMarkerRef"
                },
                v4 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        },
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCommentByIdQuery",
            "selections": v28 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCommentByIdQuery",
            "selections": v28 /*: any*/ 
        },
        "params": {
            "cacheID": "80f6dc5113d6aef8927adf669909b48e",
            "id": "a7e41ef969ee551d0afd8d103f23ec6991292b83b77931c1782403014e46ce8b",
            "metadata": {},
            "name": "useCommentByIdQuery",
            "operationKind": "query",
            "text": "query useCommentByIdQuery($pageId:ID!,$commentId:ID,$inlineMarkerRef:String,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,commentId:$commentId,inlineMarkerRef:$inlineMarkerRef){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}}"
        }
    };
}();
$09771c757ee62765$var$node.hash = "ed7145a8b5d08f815e716de36a4b73ca";
var $09771c757ee62765$export$2e2bcd8739ae039 = $09771c757ee62765$var$node;
module.exports["default"] = $09771c757ee62765$export$2e2bcd8739ae039;

});

parcelRegister("c0rhi", function(module, exports) {

var $kczYx = parcelRequire("kczYx");


var $86okN = parcelRequire("86okN");


var $1RY07 = parcelRequire("1RY07");

function $ca39dfd4a17910a6$export$c53086aa5c7d04b4(params) {
    return $ca39dfd4a17910a6$var$queryInteropApollo(params);
}
function $ca39dfd4a17910a6$var$queryInteropRelay(params) {
    const relayFetchPolicy = $ca39dfd4a17910a6$var$mapFetchPolicyForQuery(params.fetchPolicy);
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: ()=>(0, $kczYx.fetchQuery)(window.GLOBAL_RELAY_ENV, params.query, params.variables ?? {}, {
                fetchPolicy: relayFetchPolicy
            }).toPromise(),
        convertToApolloError: $ca39dfd4a17910a6$export$657ce0d4a1b8cb1a
    });
}
function $ca39dfd4a17910a6$var$queryInteropApollo({ query: query, ...rest }) {
    return window['GLOBAL_APOLLO_CLIENT'].query({
        ...rest,
        query: (0, $86okN.toDocumentNode)(query)
    });
}
// Relay:  https://relay.dev/docs/guided-tour/reusing-cached-data/fetch-policies/
// Apollo: https://www.apollographql.com/docs/react/data/queries#supported-fetch-policies
function $ca39dfd4a17910a6$var$mapFetchPolicyForQuery(fetchPolicy) {
    switch(fetchPolicy){
        case 'no-cache':
        case 'network-only':
            return 'network-only';
        case 'cache-first':
        case 'cache-only':
        default:
            return 'store-or-network';
    }
}
function $ca39dfd4a17910a6$export$657ce0d4a1b8cb1a(error) {
    // TODO: Implement proper error conversion
    return error;
}
module.exports["queryInterop"] = $ca39dfd4a17910a6$export$c53086aa5c7d04b4;

});

parcelRegister("1RY07", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");

async function $32cd044d306ca797$export$642c5b07a008cc22({ fetchData: fetchData, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none', skip: skip = false, onCompleted: onCompleted, onError: onError, getCachedData: getCachedData, setCachedData: setCachedData, convertToApolloError: convertToApolloError }) {
    if (skip) return {
        data: undefined,
        errors: []
    };
    // cache-first / store-or-network: return cached data if it exists or fetch from network
    if ((fetchPolicy === 'cache-first' || fetchPolicy === 'store-or-network') && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                errors: []
            };
        }
    }
    // cache-and-network: return cached data immediately, fetch in background
    if (fetchPolicy === 'cache-and-network' && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            fetchData().catch(()=>{});
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                errors: []
            };
        }
    }
    // network-only or cache miss: fetch from network
    try {
        const data = await fetchData();
        if (fetchPolicy !== 'no-cache' && setCachedData) await setCachedData(data);
        onCompleted?.(data);
        return {
            data: data,
            errors: []
        };
    } catch (error) {
        const apolloError = await Promise.resolve(convertToApolloError(error));
        if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
            (0, $7Sm4c.processError)(e);
        });
        onError?.(apolloError);
        if (errorPolicy === 'all') return {
            data: undefined,
            errors: apolloError.graphQLErrors || []
        };
        // errorPolicy === 'none': throw the error
        throw apolloError;
    }
}
module.exports["apolloCompatibleQuery"] = $32cd044d306ca797$export$642c5b07a008cc22;

});

parcelRegister("NYiei", function(module, exports) {

var $1Pttz = parcelRequire("1Pttz");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $7Sm4c = parcelRequire("7Sm4c");


var $6mKj3 = parcelRequire("6mKj3");


var $kgNLQ = parcelRequire("kgNLQ");

const $bd3b81debc212a33$export$ef1591875b2a95ef = 1500;
const $bd3b81debc212a33$export$a1c5d5765ca44631 = [
    'DRAFT',
    'CURRENT',
    'ARCHIVED',
    'DELETED'
];
const $bd3b81debc212a33$export$a5752cd8da7feaeb = (0, $1Pttz.default);
const $bd3b81debc212a33$export$66fa4e722aa8c832 = (contentId)=>({
        pageId: contentId,
        contentStatus: $bd3b81debc212a33$export$a1c5d5765ca44631,
        first: $bd3b81debc212a33$export$ef1591875b2a95ef
    });
const $bd3b81debc212a33$var$addCommentRootToCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount })=>{
    // Add the newly added comment to the end of the root comments list
    const updatedRootComments = [
        ...cachedRootComments,
        newComment
    ];
    // Increment total count. Note that we can only add individual comments without any replies, but
    // let's be safe and adjust for any replies in case this ever changes
    const updatedTotalCount = totalCount + repliesCount + 1;
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$addCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to add the reply from the top-level parent's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE). So to add a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array with the new reply added, as the original is readonly
        const updatedReplies = [
            ...parentComment.replies || [],
            newComment
        ];
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
        // Increment total count. We can only add individual comments without any replies, but let's be
        // safe and adjust for any replies in case this ever changes
        updatedTotalCount += 1 + repliesCount;
    } else // Parent comment not found
    error = Error(`Cannot add reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$addCommentToCache = ({ cachedRootComments: cachedRootComments, newComment: newComment, totalCount: totalCount })=>{
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = newComment?.parentId;
    const repliesCount = newComment?.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$addCommentRootToCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$addCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$var$deleteRootCommentInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount })=>{
    let updatedTotalCount = totalCount;
    // Remove the newly resolved comment from the list if we can find it
    // Create a copy of the root comment array without the deleted reply, as the original is readonly
    const updatedRootComments = cachedRootComments.filter((comment)=>comment?.id !== commentId);
    // Decrement total count - currently we can't delete a reply that has any comments, but
    // let's be safe and adjust for any replies in case this ever changes
    updatedTotalCount -= 1 + repliesCount;
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$deleteCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to remove the reply from the top-level comment's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE).  So to remove a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array without the deleted reply, as the original
        // is readonly
        const updatedReplies = (parentComment.replies || []).filter((reply)=>reply?.id !== commentId);
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
        // Decrement total count. Currently we can't delete a reply that has any comments. Also
        // since we can’t have spread fragments in Relay-friendly queries yet, the current
        // CommentReply type doesn't have a `replies` field. And the backend, sends the nested
        // replies to us in a flat list with the correct parentIDs so the FE must manually nest
        // them. But let's adjust the count for replies just in case this ever changes.
        updatedTotalCount -= 1 + repliesCount;
    } else // Parent comment not found
    error = Error(`Cannot delete reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$removeCommentFromCache = ({ cachedRootComments: cachedRootComments, commentId: commentId, totalCount: totalCount })=>{
    // Find the comment to delete to determine if it's a root comment or a reply
    const commentToDelete = (0, $kgNLQ.findCommentInData)(cachedRootComments, commentId);
    if (!commentToDelete) return {
        updatedRootComments: [],
        updatedTotalCount: 0,
        error: new Error(`Cannot delete comment in cache: comment with ID ${commentId} not found`)
    };
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = commentToDelete.parentId;
    const repliesCount = commentToDelete.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$deleteRootCommentInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$deleteCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$export$19f817fe57f17368 = ({ contentId: contentId, options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onCompleted: onCompleted, onError: onError } = options;
    const handleQueryError = (0, $42omo.useCallback)((error)=>{
        // Handle specific GraphQL errors gracefully
        // WS-3494 - If the error isn't related to reactionsSummary returning null, just mark it handled
        // COMMENTS-188 - Or if the error isn't related to cc-pages not being reachable just mark it handled
        if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        onError?.(error);
    }, [
        onError
    ]);
    // Skip query if experiment is disabled, no content ID, or explicitly skipped
    const shouldSkip = !contentId || !!options.skip || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    const queryResponse = (0, $jMyy4.useQueryInterop)($bd3b81debc212a33$export$a5752cd8da7feaeb, {
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId ?? ''),
        skip: shouldSkip,
        context: {
            single: true
        },
        fetchPolicy: // We auto-batch queries that fire within 10ms of eachother. Since this query is slow, this unbatches it to avoid slowing down everything else
        fetchPolicy,
        onCompleted: (data)=>{
            onCompleted?.(data);
        },
        onError: handleQueryError
    });
    // Refetch function with error handling
    const refetch = (0, $42omo.useCallback)(async ()=>{
        try {
            return await queryResponse.refetch();
        } catch (error) {
            handleQueryError(error);
        }
    }, [
        queryResponse,
        handleQueryError
    ]);
    const addCommentInCache = (0, $42omo.useCallback)(({ newComment: newComment, onError: onError })=>{
        // If the new comment is a root comment, we need to add it to the root comments list and
        // update the main query's cache and totalCount. If it's a reply, we need to add it to its
        // parent comments's replies list in the cache - but we still  update the whole main query
        // (vs. just update the parent comment itself via a fragment update) because we need to
        // update the main query's totalCount in the cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            const dataProxy = (0, $l1uFv.readQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId)
            });
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy?.comments?.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$addCommentToCache({
                cachedRootComments: cachedRootComments,
                newComment: newComment,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                }
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when adding new comment to cache with ID ${newComment?.id}: ${err}`));
        }
    }, [
        contentId
    ]);
    const deleteCommentInCache = (0, $42omo.useCallback)(({ commentId: commentId, onError: onError })=>{
        // First, we try to find the comment to determine if it's a root comment or a reply.  If it's a
        // root comment, we need to remove it from the root comments list and update the main query's
        // cache and totalCount. If it's a reply, we need to update its parent comments's replies list
        // in the cache - but we still  update the whole main query (vs. just update the parent comment
        // itself via a fragment update) because we need to update the main query's totalCount in the
        // cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            const dataProxy = (0, $l1uFv.readQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId)
            });
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy?.comments?.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$removeCommentFromCache({
                cachedRootComments: cachedRootComments,
                commentId: commentId,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                }
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when deleting cached comment with ID ${commentId}: ${err}`));
        }
    }, [
        contentId
    ]);
    return {
        loading: queryResponse.loading,
        error: queryResponse.error,
        refetch: refetch,
        data: queryResponse.data,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    };
};
module.exports["MAX_COMMENTS_TO_RETURN"] = $bd3b81debc212a33$export$ef1591875b2a95ef;
module.exports["allContentStatuses"] = $bd3b81debc212a33$export$a1c5d5765ca44631;
module.exports["useAllCommentsData"] = $bd3b81debc212a33$export$19f817fe57f17368;

});

parcelRegister("1Pttz", function(module, exports) {
/**
 * @generated SignedSource<<ffe25591c3e17983b11fcfcb1d4214ba>>
 * @relayHash 9e9dce87233142bdde0be6a1e1389db3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca81297f1557d2f17e9e2311bb04d63937ce1bd7af490b89946ebdfc85fc61e9
const $e5d3dc3314ebdbc2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v11 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v13 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v14 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v11 /*: any*/ 
    }, v15 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v21 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v23 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v24 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "number"
    }, v26 = {
        "kind": "ScalarField",
        "name": "when"
    }, v27 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v21 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useAllCommentsDataQuery",
            "selections": v27 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useAllCommentsDataQuery",
            "selections": v27 /*: any*/ 
        },
        "params": {
            "cacheID": "9e9dce87233142bdde0be6a1e1389db3",
            "id": "ca81297f1557d2f17e9e2311bb04d63937ce1bd7af490b89946ebdfc85fc61e9",
            "metadata": {},
            "name": "useAllCommentsDataQuery",
            "operationKind": "query",
            "text": "query useAllCommentsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long!){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$e5d3dc3314ebdbc2$var$node.hash = "f3f3f95ad61519f75dd5ba8d0cde2302";
var $e5d3dc3314ebdbc2$export$2e2bcd8739ae039 = $e5d3dc3314ebdbc2$var$node;
module.exports["default"] = $e5d3dc3314ebdbc2$export$2e2bcd8739ae039;

});

parcelRegister("l1uFv", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("fEmGS", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    return $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data, variables: variables } = params;
    if (!data) return;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, root, queryFields, data, variables || {});
    });
}
function $f0827a369f0dafa9$var$writeQueryFields(storeProxy, record, fields, data, variables) {
    if (!record || !data) return;
    for (const field of fields){
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldData = data[linkedField.name];
            if (fieldData !== undefined) {
                if (Array.isArray(fieldData)) {
                    const linkedRecords = fieldData.map((item)=>{
                        if (item && typeof item === 'object') {
                            const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                            const existingRecord = record.getLinkedRecord(fieldKey);
                            if (existingRecord && linkedField.selections) {
                                $f0827a369f0dafa9$var$writeQueryFields(storeProxy, existingRecord, linkedField.selections, item, variables);
                                return existingRecord;
                            }
                        }
                        return null;
                    }).filter((rec)=>rec !== null);
                    if (linkedRecords.length > 0) {
                        const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                        record.setLinkedRecords(linkedRecords, fieldKey);
                    }
                } else if (fieldData && typeof fieldData === 'object') {
                    const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                    const linkedRecord = record.getLinkedRecord(fieldKey);
                    // If no linked record exists but we have data with an ID, we can try to get the existing record,
                    // or create a new record based on __typename. However, this shouldn't be a common use-case across the codebase,
                    // so we'll skip these code paths for now
                    if (linkedRecord && linkedField.selections) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, linkedRecord, linkedField.selections, fieldData, variables);
                }
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            if (data[scalarField.name] !== undefined) record.setValue(data[scalarField.name], scalarField.name);
        }
    }
}
function $f0827a369f0dafa9$var$getFieldKey(field, variables) {
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments
    const args = field.args.map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("kgNLQ", function(module, exports) {

var $cD1qu = parcelRequire("cD1qu");


var $jbF1h = parcelRequire("jbF1h");

var $344a24116515d334$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
const $344a24116515d334$export$c6a7031105fdebc = (commentData, commentId)=>{
    // Search in retreived comments and their replies
    for (const comment of commentData){
        // Check if this is the comment we're looking for
        if (comment?.id === commentId) return comment;
        // Check if it's in the replies
        if (comment?.replies) {
            const foundReply = comment.replies.find((reply)=>reply?.id === commentId);
            if (foundReply) return foundReply;
        }
    }
    // else comment not found
    return undefined;
};
const $344a24116515d334$export$fb9051669482cbe0 = (condition, trueFn, falseFn)=>condition ? trueFn : falseFn;
const $344a24116515d334$export$6ba3a6375d12d24f = (commentData, replyParentId)=>{
    // Search through each root level comment's replies
    for (const comment of commentData){
        // Return this comment if it is the parent of the reply, else check if this comment has replies
        // and if any of them have the matching parentId
        if (comment?.id === replyParentId || comment?.replies.find((reply)=>reply?.id === replyParentId)) return comment;
    }
    // else comment not found
    return undefined;
};
const $344a24116515d334$export$3e4a472ec0de2dc6 = (commentData, markerRef)=>{
    // Search in retrieved comments and their replies
    for (const comment of commentData){
        // Check if this comment's marker ref matches
        const location = comment?.location;
        if (location?.inlineMarkerRef === markerRef) return comment;
    }
    return undefined;
};
const $344a24116515d334$export$499492f953d5abba = (comments, commentId, markerRef, contentStatus)=>{
    if (comments.length === 0) return undefined;
    let foundComment;
    if (commentId) foundComment = $344a24116515d334$export$c6a7031105fdebc(comments, commentId);
    else if (markerRef) foundComment = $344a24116515d334$export$3e4a472ec0de2dc6(comments, markerRef);
    if (!foundComment) return undefined;
    // Filter by contentStatus before returning
    const matchesContentStatusFilter = (comment)=>{
        if (!comment || !comment.contentStatus) return false;
        // Convert comment's contentStatus to uppercase to match GraphQLContentStatus format
        const commentStatus = comment.contentStatus.toUpperCase();
        return contentStatus.includes(commentStatus);
    };
    if (matchesContentStatusFilter(foundComment)) return foundComment;
    return undefined;
};
const $344a24116515d334$export$4d95f4b945556294 = (comment, mutationResult)=>{
    const resolveInlineComment = mutationResult?.data?.resolveInlineComment;
    const mutationStatus = resolveInlineComment?.status ?? false;
    const resolveProperties = resolveInlineComment?.resolveProperties ?? undefined;
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: mutationStatus,
        resolveProperties: resolveProperties
    });
};
const $344a24116515d334$export$d81a62b32f0e420f = (comment, mutationResult)=>{
    const commentResolutionStates = mutationResult?.data?.confluence_resolveComments?.commentResolutionStates;
    if ((commentResolutionStates?.length ?? 0) > 1) throw new Error('resolveCommentInCacheCallback() only supports one comment resolution state per mutation call');
    const firstResolutionState = commentResolutionStates?.[0] ?? undefined;
    const mutationStatus = firstResolutionState?.status ?? false;
    const partialResolveProperties = firstResolutionState?.resolveProperties ?? undefined;
    // We need to ensure that resolveProperties contains all non-optional properties so we can safely
    // spread it into the comment location resolve properties, so choose defaults for any missing
    // ones.  This is needed because some of the mutations don't request all the properties in their
    // responses.
    const resolveProperties = partialResolveProperties ? {
        resolved: true,
        isDangling: false,
        // These are nullable in the schema, but included to make Typescript happy
        resolvedUser: undefined,
        resolvedFriendlyDate: undefined,
        resolvedTime: undefined,
        // Add any non-null/undefined properties from the mutation result
        ...partialResolveProperties
    } : undefined;
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: mutationStatus,
        resolveProperties: resolveProperties
    });
};
const $344a24116515d334$export$aa65246494e3c3e0 = (comment, mutationResult)=>{
    // (The property is called "commentResolutionStates" but there is only one item per mutation call)
    const commentResolutionStates = mutationResult?.data?.confluence_reopenComment?.commentResolutionStates;
    if (commentResolutionStates) {
        const mutationStatus = commentResolutionStates.status ?? false;
        const partialResolveProperties = commentResolutionStates.resolveProperties ?? undefined;
        // We need to ensure that resolveProperties contains all non-optional properties so we can safely
        // spread it into the comment location resolve properties, so choose defaults for any missing
        // ones. This is needed because some of the mutations don't request all the properties - or even
        // the commentResolutionStates property at all in their responses.
        const resolveProperties = {
            resolved: false,
            isDangling: false,
            // These are nullable in the schema, but included to make Typescript happy
            resolvedUser: undefined,
            resolvedFriendlyDate: undefined,
            resolvedTime: undefined,
            // Add any non-null/undefined properties from the mutation result
            ...partialResolveProperties
        };
        return (0, $jbF1h.resolveCommentInCache)({
            comment: comment,
            mutationStatus: mutationStatus,
            resolveProperties: resolveProperties
        });
    }
    // Else commentResolutionStates wasn't returned - assume failure to reopen
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: false,
        resolveProperties: undefined
    });
};
const $344a24116515d334$export$e237bdee87974d46 = (pageMode)=>{
    // On view pages, exclude draft comments
    if (pageMode === (0, $cD1qu.PageMode).VIEW) return [
        'CURRENT',
        'ARCHIVED'
    ];
    // On edit and live pages, include all statuses
    return [
        'CURRENT',
        'ARCHIVED',
        'DRAFT'
    ];
};
const $344a24116515d334$export$70df9f207ee9869d = (comment)=>{
    const location = comment?.location;
    if (location) {
        if ('inlineResolveProperties' in location) return location.inlineResolveProperties?.resolved ?? false;
        else if ('commentResolveProperties' in location) return location.commentResolveProperties?.resolved ?? false;
    }
    return false;
};
const $344a24116515d334$export$6036c2c532b2fa41 = (commentsDataMap)=>{
    try {
        const allGeneralComments = Object.values(commentsDataMap.general);
        // To see if there are nested comments, we need to check whether there are any replies whose parentID is not equal to the parent Comment's ID
        // This is because commentsDataMap.general is a flat map of parent comment --> everything below it
        // But each comment has it's own parent id which may be different from it's top level parent
        return allGeneralComments.some((comment)=>{
            return comment?.replies?.some((reply)=>reply && reply.parentId !== comment.id);
        });
    } catch  {
        // Default to false if somehow something goes wrong
        return false;
    }
};
const $344a24116515d334$export$2fa0b601110c277b = (comments, contentStatusFilters)=>{
    const allFilteredComments = [];
    const openComments = [];
    const openInlineComments = [];
    const openFooterComments = [];
    const resolvedComments = [];
    // Transform array-based data to map structure for legacy compatibility
    const commentsDataMap = {
        inline: {},
        general: {}
    };
    // Build flat map of all comments (including replies) for O(1) lookup by commentId
    const flatCommentsMap = {};
    // Build flat map of inline comments keyed by markerRef for O(1) lookup
    const flatMarkerRefMap = {};
    for (const comment of comments)// Filter by content status, which is a string literal type (that is, a set of allowed
    // strings), so be cautious if the definitions or schema change
    if (comment && contentStatusFilters.includes(comment.contentStatus?.toUpperCase())) {
        allFilteredComments.push(comment);
        // Add comment to flat map by commentId
        if (comment?.id) flatCommentsMap[comment.id] = comment;
        // Add inline parent comment to flatMarkerRefMap by markerRef (only parent comments, not replies)
        if (comment?.location?.type === 'INLINE' && !comment?.parentId) {
            const location = comment.location;
            if (location?.inlineMarkerRef) flatMarkerRefMap[location.inlineMarkerRef] = comment;
        }
        // Add all replies to flat map
        if (comment?.replies) {
            for (const reply of comment.replies)if (reply?.id) flatCommentsMap[reply.id] = reply;
        }
        const isOpen = !$344a24116515d334$export$70df9f207ee9869d(comment);
        const commentType = comment.location?.type === 'INLINE' ? "inline" : "general";
        const commentWithProperties = {
            ...comment,
            type: commentType,
            isOpen: isOpen,
            isUnread: false,
            wasRemovedByAnotherUser: false,
            replies: comment.replies?.filter((reply)=>reply !== null && reply !== undefined).map((reply)=>({
                    ...reply,
                    isUnread: false,
                    wasRemovedByAnotherUser: false
                }))
        };
        if (isOpen) {
            openComments.push(comment);
            if (comment?.location?.type === 'INLINE') openInlineComments.push(comment);
            else if (comment?.location?.type === 'FOOTER') openFooterComments.push(comment);
        // else unknown or missing location type, do nothing
        } else resolvedComments.push(comment);
        if (comment.location?.type === 'INLINE') {
            const threadKey = 'inlineMarkerRef' in comment.location ? comment.location.inlineMarkerRef || comment.id : comment.id;
            commentsDataMap.inline[threadKey] = commentWithProperties;
        } else if (comment.location?.type === 'FOOTER') commentsDataMap.general[comment.id] = commentWithProperties;
    }
    const hasNestedComments = $344a24116515d334$export$6036c2c532b2fa41(commentsDataMap);
    const commentCount = allFilteredComments.length;
    const hasAnyComments = commentCount > 0;
    return {
        allFilteredComments: allFilteredComments,
        openComments: openComments,
        openInlineComments: openInlineComments,
        openFooterComments: openFooterComments,
        resolvedComments: resolvedComments,
        commentsDataMap: commentsDataMap,
        flatCommentsMap: flatCommentsMap,
        flatMarkerRefMap: flatMarkerRefMap,
        hasNestedComments: hasNestedComments,
        commentCount: commentCount,
        hasAnyComments: hasAnyComments
    };
};
module.exports["findCommentInData"] = $344a24116515d334$export$c6a7031105fdebc;
module.exports["selectUpdateFunction"] = $344a24116515d334$export$fb9051669482cbe0;
module.exports["findRootCommentForReply"] = $344a24116515d334$export$6ba3a6375d12d24f;
module.exports["findAndFilterComment"] = $344a24116515d334$export$499492f953d5abba;
module.exports["resolveInlineCommentInCacheCallback"] = $344a24116515d334$export$4d95f4b945556294;
module.exports["resolveCommentInCacheCallback"] = $344a24116515d334$export$d81a62b32f0e420f;
module.exports["reopenCommentInCacheCallback"] = $344a24116515d334$export$aa65246494e3c3e0;
module.exports["buildDefaultCommentsContentStatusFilters"] = $344a24116515d334$export$e237bdee87974d46;
module.exports["categorizeComments"] = $344a24116515d334$export$2fa0b601110c277b;

});

parcelRegister("jbF1h", function(module, exports) {

var $6nYhN = parcelRequire("6nYhN");


var $42omo = parcelRequire("42omo");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");

// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/useCommentById.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this function - or at least the cache updating parts for the function
// - into the useAllCommentsData.ts file.
const $bd790562493588ff$var$updateCommentInCacheFragment = (0, $6nYhN.default);
const $bd790562493588ff$export$8ce65958c48a9ac3 = ()=>{
    const readFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $bd790562493588ff$var$updateCommentInCacheFragment
    });
    const writeFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: $bd790562493588ff$var$updateCommentInCacheFragment
    });
    /**
   * Function to update a comment in the Apollo cache.
   * @param mutationResult - The result of the mutation that triggered the cache update
   * @param commentId - ID of the comment to update
   * @param updateCallback - Callback function that receives the current comment data
   *                         and returns the updated comment data
   * @param onError - Optional error callback to handle errors during the update process
   */ const updateCommentInCache = (0, $42omo.useCallback)(({ mutationResult: mutationResult, commentId: commentId, updateCallback: updateCallback, onError: onError })=>{
        if (!commentId) {
            onError?.(new Error('Cannot update comment in cache: comment ID is missing'));
            return;
        }
        try {
            // The fragment ID format for Apollo cache
            const fragmentId = `Comment:${commentId}`;
            // Read the current comment from cache
            const cachedComment = readFragment({
                id: fragmentId
            });
            if (!cachedComment) {
                // (There is a slight chance the comment is not in cache - but the mutation that calls
                // this function would have to completed successfully to call us, so presumably the
                // comment existed then. Thus the only legit reason for it to be missing from the cache
                // now is if another user deleted the comment in between the mutation and this cache
                // update call. That is unlikely, so let's log this as an error and return. If in
                // the future we find the legit use case is happening more often, we can change to a
                // warning instead.)
                onError?.(new Error(`Cannot update comment in cache: comment with ID ${commentId} not found in cache`));
                return;
            }
            // Apply the update callback on a copy of the cached comment
            // (Note that the updateCallback should return a new object, not mutate the original - so
            //  make copies of any nested objects you need to change also)
            const updatedComment = updateCallback({
                ...cachedComment
            }, mutationResult);
            // Write the updated comment back to cache
            writeFragment({
                fragmentId: fragmentId,
                data: updatedComment
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when updating cached comment data: ${err}`));
            return;
        }
    }, [
        readFragment,
        writeFragment
    ]);
    return {
        updateCommentInCache: updateCommentInCache
    };
};
const $bd790562493588ff$export$9e04af313e7174f4 = ({ comment: comment, mutationStatus: mutationStatus, resolveProperties: resolveProperties })=>{
    if (!mutationStatus || !resolveProperties) // Mutation result is missing or incomplete - so just return the comment unchanged
    return comment;
    // Extract isDangling separately since it is handled differently, and exclude __typename since we
    // don't need it and Typescript would complain about it being included in the spread below.
    const { __typename: __typename, isDangling: isDangling, ...otherResolveProperties } = resolveProperties;
    // Mark the comment as resolved in the cache, but how to do that depends on the comment type
    const location = comment.location;
    const newLocation = {
        ...location,
        ...'commentResolveProperties' in location ? {
            commentResolveProperties: {
                ...location.commentResolveProperties,
                ...otherResolveProperties
            }
        } : {},
        ...'inlineResolveProperties' in location ? {
            inlineResolveProperties: {
                ...location.inlineResolveProperties,
                ...otherResolveProperties,
                isDangling: isDangling
            }
        } : {}
    };
    return {
        ...comment,
        location: newLocation
    };
};
const $bd790562493588ff$export$df3d27666bd765d5 = (comment, mutationResult)=>{
    const newBodyValue = mutationResult?.data?.updateComment.body?.value;
    const updatedBody = {
        ...comment.body,
        // Remember that an empty string is a valid body value, so only skip updating if newBodyValue
        // is null or undefined
        ...newBodyValue || newBodyValue === '' ? {
            value: newBodyValue
        } : {}
    };
    const newVersion = mutationResult?.data?.updateComment.version;
    const newDisplayName = newVersion?.by?.displayName;
    // If the existing comment's version doesn't have a "by" field, we don't want to add just part
    // of it - so set it to undefined so it won't be included in the updated comment. This probably
    // won't actually ever happen, but it makes Typescript happy just in case.
    const updatedBy = comment.version?.by ? {
        ...{
            ...comment.version?.by
        },
        ...newDisplayName ? {
            displayName: newDisplayName
        } : {}
    } : undefined;
    const updatedVersion = {
        ...comment.version,
        ...newVersion?.number ? {
            number: newVersion.number
        } : {},
        ...newVersion?.when ? {
            when: newVersion.when
        } : {},
        ...updatedBy ? {
            by: {
                ...updatedBy
            }
        } : {}
    };
    return {
        ...comment,
        body: updatedBody,
        version: {
            ...updatedVersion
        }
    };
};
module.exports["useUpdateCommentInCache"] = $bd790562493588ff$export$8ce65958c48a9ac3;
module.exports["resolveCommentInCache"] = $bd790562493588ff$export$9e04af313e7174f4;
module.exports["updateCommentBodyInCacheCallback"] = $bd790562493588ff$export$df3d27666bd765d5;

});

parcelRegister("6nYhN", function(module, exports) {
/**
 * @generated SignedSource<<8cee7c13c115a0ca5c80cee14f8fd725>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1d633d5b65e9f4e8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v7 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v9 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v10 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v11 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v12 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v5 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v19 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "number"
    }, v21 = {
        "kind": "ScalarField",
        "name": "when"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useUpdateCommentInCacheFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    v4 /*: any*/ ,
                    v5 /*: any*/ ,
                    v6 /*: any*/ 
                ]
            },
            v8 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ ,
            {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v6 /*: any*/ ,
                            v4 /*: any*/ 
                        ]
                    },
                    v8 /*: any*/ ,
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ ,
                    v19 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "by",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ 
                                ]
                            },
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v5 /*: any*/ ,
                            v2 /*: any*/ ,
                            v6 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "friendlyWhen"
                    },
                    v20 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            }
        ],
        "type": "Comment"
    };
}();
$1d633d5b65e9f4e8$var$node.hash = "b050d36387ca001aa3988c3e0f6d32bb";
var $1d633d5b65e9f4e8$export$2e2bcd8739ae039 = $1d633d5b65e9f4e8$var$node;
module.exports["default"] = $1d633d5b65e9f4e8$export$2e2bcd8739ae039;

});

parcelRegister("1rdvc", function(module, exports) {
/**
 * @generated SignedSource<<5ee01bec8d3f6c744747b059c459e176>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $39a1d37ae379d69e$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["GraphQLContentStatus"] = $39a1d37ae379d69e$export$b634e5de755b7d35;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("9Q4ck"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("9Q4ck", function(module, exports) {

let $729c39fbd06cc51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $729c39fbd06cc51d$var$load("fZt2F"),
    $729c39fbd06cc51d$var$load("hhss7"),
    $729c39fbd06cc51d$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;

});

parcelRegister("izhdc", function(module, exports) {

var $8i27m = parcelRequire("8i27m");

const $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b = (currentlyRenderedThreads, unresolvedInlineComments)=>{
    // Grab everything on the screen as a set for quick access
    const allRenderedInlineCommentIds = new Set(unresolvedInlineComments);
    // Grab all of the refs for inline comments that are available on the panel
    const panelCommentRefs = currentlyRenderedThreads.map((comment)=>{
        if (comment.type === 'INLINE') {
            if ('inlineMarkerRef' in comment && comment.inlineMarkerRef) return {
                ref: comment.inlineMarkerRef,
                type: (0, $8i27m.CommentType).INLINE
            };
            else return {
                ref: '',
                type: (0, $8i27m.CommentType).INLINE
            };
        } else return {
            ref: comment.id,
            type: (0, $8i27m.CommentType).GENERAL
        };
    }).filter((comment)=>{
        return comment.ref !== '';
    });
    // Grab the refs that we can navigate too (aka the ones rendered on the page, so open (i.e. not resolved) comments)
    const navigableInlineCommentRefs = new Set(panelCommentRefs.map((comment)=>{
        if (comment.type === (0, $8i27m.CommentType).INLINE) return allRenderedInlineCommentIds.has(comment.ref) ? comment.ref : '';
        else return comment.ref;
    }));
    return {
        panelCommentRefs: panelCommentRefs,
        navigableInlineCommentRefs: navigableInlineCommentRefs
    };
};
const $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29 = (action, panelCommentRefs, currentlySelectedThreadKey)=>{
    let nextIndex = panelCommentRefs.findIndex((comment)=>{
        return comment.ref === currentlySelectedThreadKey;
    });
    if (nextIndex === -1) nextIndex = 0;
    else if (action === 'next') nextIndex = (nextIndex + 1) % panelCommentRefs.length;
    else nextIndex = (nextIndex - 1 + panelCommentRefs.length) % panelCommentRefs.length;
    return panelCommentRefs[nextIndex];
};
const $fd72c77cd5bf52d0$export$46b037fca0ede95d = (action, currentIndex, totalComments, footerCommentsLoadingState)=>{
    const isAtBeginning = currentIndex === 0;
    const isAtEnd = currentIndex === totalComments - 1;
    if (footerCommentsLoadingState === (0, $8i27m.FooterCommentsLoadingStateType).NOT_LOADED) {
        if (isAtEnd && action === 'next' || isAtBeginning && action === 'previous') return true;
    } else if (footerCommentsLoadingState === (0, $8i27m.FooterCommentsLoadingStateType).PARTIALLY_LOADED) {
        if (isAtBeginning && action === 'previous') return true;
    }
    return false;
};
module.exports["parsePanelAndInlineRefs"] = $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b;
module.exports["getNextRef"] = $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29;
module.exports["isNavigatingToPotentiallyUnloadedFooterComment"] = $fd72c77cd5bf52d0$export$46b037fca0ede95d;

});

parcelRegister("gSkOQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6lAIr = parcelRequire("6lAIr");


var $i6UMJ = parcelRequire("i6UMJ");


var $9wGTI = parcelRequire("9wGTI");


var $8i27m = parcelRequire("8i27m");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");

const $89de80864b4e19fe$export$618f651f678380bf = ()=>{
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap, removedThreadsMap: removedThreadsMap } = (0, $8i27m.useCommentsDataState)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    return (0, $42omo.useMemo)(()=>{
        const footerCommentThreads = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $6lAIr.getVisibleCommentThreads)({
            commentsDataMap: commentsDataMap,
            includeGeneralComments: true,
            includeInlineComments: false,
            orderedAnnotationIds: (0, $i6UMJ.getAnnotationThreadKeys)(orderedActiveAnnotationIdList)
        }) : (0, $i6UMJ.getOpenCommentThreads)({
            commentsDataMap: commentsDataMap,
            showInlineComments: false,
            showGeneralComments: true,
            location: (0, $i6UMJ.LocationValue).FOOTER,
            orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
            removedThreadsMap: removedThreadsMap
        });
        const footerCommentIds = footerCommentThreads.map((thread)=>thread.id);
        return {
            footerCommentIds: footerCommentIds,
            footerCommentThreads: footerCommentThreads
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotationIdList,
        removedThreadsMap
    ]);
};
module.exports["useFooterComments"] = $89de80864b4e19fe$export$618f651f678380bf;

});

parcelRegister("6lAIr", function(module, exports) {

var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $i6UMJ = parcelRequire("i6UMJ");


var $3mVfX = parcelRequire("3mVfX");

const $475d5d8641a18b80$var$isParentCommentOpen = (commentData)=>commentData.isOpen;
const $475d5d8641a18b80$var$wasCommentRemovedByAnotherUser = (comment)=>Boolean(comment.wasRemovedByAnotherUser);
const $475d5d8641a18b80$var$wasCommentDeletedByAnotherUser = (comment)=>comment.wasRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT;
const $475d5d8641a18b80$var$isInlineLocation = (location)=>'inlineMarkerRef' in location;
const $475d5d8641a18b80$var$isParentComment = (comment)=>'isOpen' in comment;
const $475d5d8641a18b80$var$getVisibleGeneralComments = ({ isCommentValid: isCommentValid, comments: comments })=>Object.values(comments).reduce((acc, comment)=>{
        if (isCommentValid(comment)) acc.push({
            ...comment,
            replies: comment.replies.filter(isCommentValid)
        });
        return acc;
    }, []);
const $475d5d8641a18b80$var$getNextInlineResolveProperties = (inlineResolveProperties, isDangling)=>{
    if (!inlineResolveProperties) return {};
    return {
        inlineResolveProperties: {
            ...inlineResolveProperties,
            isDangling: isDangling
        }
    };
};
const $475d5d8641a18b80$var$updateCommentLocation = (comment, isDangling)=>{
    const commentLocation = comment.location;
    if (!$475d5d8641a18b80$var$isInlineLocation(commentLocation)) return commentLocation;
    return {
        ...commentLocation,
        ...$475d5d8641a18b80$var$getNextInlineResolveProperties(commentLocation.inlineResolveProperties, isDangling)
    };
};
const $475d5d8641a18b80$var$getNextComment = (comment, isDangling, isNewDanglingCommentExperienceEnabled)=>{
    const { isUnread: isUnread, replies: replies, ...rest } = comment;
    const shouldMarkDanglingCommentsAndTheirRepliesAsRead = isDangling && isNewDanglingCommentExperienceEnabled;
    const updatedReplies = shouldMarkDanglingCommentsAndTheirRepliesAsRead ? replies.map((reply)=>({
            ...reply,
            isUnread: false
        })) : replies;
    return {
        ...rest,
        isUnread: shouldMarkDanglingCommentsAndTheirRepliesAsRead ? false : isUnread,
        replies: updatedReplies,
        location: $475d5d8641a18b80$var$updateCommentLocation(comment, isDangling)
    };
};
const $475d5d8641a18b80$var$getVisibleInlineComments = (isCommentValid, comments, orderedAnnotationIds, isNewDanglingCommentExperienceEnabled)=>{
    const activeMarkerRefs = new Set(orderedAnnotationIds);
    const nonDangling = [];
    const dangling = [];
    const validComments = Object.values(comments).reduce((acc, comment)=>{
        if (isCommentValid(comment)) acc.push({
            ...comment,
            replies: comment.replies.filter(isCommentValid)
        });
        return acc;
    }, []);
    for (const comment of validComments){
        const commentLocation = comment.location;
        const inlineMarkerRef = $475d5d8641a18b80$var$isInlineLocation(commentLocation) ? commentLocation.inlineMarkerRef : null;
        const isDangling = !inlineMarkerRef || !activeMarkerRefs.has(inlineMarkerRef);
        const updatedComment = $475d5d8641a18b80$var$getNextComment(comment, isDangling, isNewDanglingCommentExperienceEnabled);
        if (isDangling) dangling.push(updatedComment);
        else nonDangling.push(updatedComment);
    }
    return [
        nonDangling,
        dangling
    ];
};
const $475d5d8641a18b80$export$70df9f207ee9869d = (comment)=>{
    if ($475d5d8641a18b80$var$wasCommentDeletedByAnotherUser(comment)) return false;
    return $475d5d8641a18b80$var$isParentComment(comment) ? !$475d5d8641a18b80$var$isParentCommentOpen(comment) : true;
};
const $475d5d8641a18b80$export$28d3eb19856355d7 = (comment)=>{
    if ($475d5d8641a18b80$var$wasCommentRemovedByAnotherUser(comment)) return false;
    return $475d5d8641a18b80$var$isParentComment(comment) ? $475d5d8641a18b80$var$isParentCommentOpen(comment) : true;
};
const $475d5d8641a18b80$var$sortInlineCommentsByOrderedActiveAnnotationIdList = (comments, orderedAnnotationIds)=>{
    const commentsByMarkerRef = new Map(comments.map((comment)=>{
        const commentLocation = comment.location;
        const inlineMarkerRef = $475d5d8641a18b80$var$isInlineLocation(commentLocation) ? commentLocation.inlineMarkerRef : null;
        return [
            inlineMarkerRef,
            comment
        ];
    }));
    return orderedAnnotationIds.map((id)=>commentsByMarkerRef.get(id)).filter((comment)=>comment !== undefined);
};
const $475d5d8641a18b80$var$getVisibleInlineThreadsForView = (currentView, sortedNonDanglingComments, danglingComments)=>{
    switch(currentView){
        case (0, $3mVfX.ViewValues).OPEN:
        case (0, $3mVfX.ViewValues).UNREAD:
            return sortedNonDanglingComments;
        case (0, $3mVfX.ViewValues).DELETED_CONTENT:
            return danglingComments;
        default:
            return [
                ...sortedNonDanglingComments,
                ...danglingComments
            ];
    }
};
const $475d5d8641a18b80$var$getVisibleInlineThreads = ({ isCommentValid: isCommentValid, commentsDataMap: commentsDataMap, orderedAnnotationIds: orderedAnnotationIds, currentView: currentView, isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled })=>{
    const [nonDanglingComments, danglingComments] = $475d5d8641a18b80$var$getVisibleInlineComments(isCommentValid, commentsDataMap.inline, orderedAnnotationIds, isNewDanglingCommentExperienceEnabled);
    const sortedNonDanglingComments = $475d5d8641a18b80$var$sortInlineCommentsByOrderedActiveAnnotationIdList(nonDanglingComments, orderedAnnotationIds);
    const visibleInlineThreadsForView = isNewDanglingCommentExperienceEnabled ? $475d5d8641a18b80$var$getVisibleInlineThreadsForView(currentView, sortedNonDanglingComments, danglingComments) : [
        ...sortedNonDanglingComments,
        ...danglingComments
    ];
    return (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? visibleInlineThreadsForView : sortedNonDanglingComments;
};
const $475d5d8641a18b80$var$getIsCommentValid = ({ currentView: currentView })=>{
    switch(currentView){
        case (0, $3mVfX.ViewValues).RESOLVED:
            return $475d5d8641a18b80$export$70df9f207ee9869d;
        default:
            return $475d5d8641a18b80$export$28d3eb19856355d7;
    }
};
const $475d5d8641a18b80$export$cbe812921774e978 = ({ commentsDataMap: commentsDataMap, orderedAnnotationIds: orderedAnnotationIds, includeInlineComments: includeInlineComments, includeGeneralComments: includeGeneralComments, currentView: currentView = (0, $3mVfX.ViewValues).OPEN, isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled = (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux'), isCommentValid: providedIsCommentValid })=>{
    const threads = [];
    const isCommentValid = providedIsCommentValid ?? $475d5d8641a18b80$var$getIsCommentValid({
        currentView: currentView
    });
    if (includeInlineComments) {
        const inlineThreads = $475d5d8641a18b80$var$getVisibleInlineThreads({
            isCommentValid: isCommentValid,
            commentsDataMap: commentsDataMap,
            orderedAnnotationIds: orderedAnnotationIds,
            currentView: currentView,
            isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled
        });
        threads.push(...inlineThreads);
    }
    if (includeGeneralComments) {
        const generalThreads = $475d5d8641a18b80$var$getVisibleGeneralComments({
            isCommentValid: isCommentValid,
            comments: commentsDataMap.general
        }).sort((0, $i6UMJ.getCommentsSortedOldestToNewest));
        threads.push(...generalThreads);
    }
    return threads;
};
module.exports["getVisibleCommentThreads"] = $475d5d8641a18b80$export$cbe812921774e978;

});

parcelRegister("8SCD6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $l5y3Y = parcelRequire("l5y3Y");

const $6881c6359fe8b822$export$4da9db299e81cd38 = /*#__PURE__*/ (0, $42omo.createContext)({
    isReactionsEnabled: false
});
$6881c6359fe8b822$export$4da9db299e81cd38.displayName = 'ReactionsContext';
const $6881c6359fe8b822$export$2157a4212fd7f5b1 = ({ contentId: contentId, children: children })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const reactionsContextValue = (0, $42omo.useMemo)(()=>({
            isReactionsEnabled: isReactionsEnabled
        }), [
        isReactionsEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
        value: reactionsContextValue
    }, children);
};
module.exports["ReactionsContext"] = $6881c6359fe8b822$export$4da9db299e81cd38;
module.exports["ReactionsProvider"] = $6881c6359fe8b822$export$2157a4212fd7f5b1;

});

parcelRegister("l5y3Y", function(module, exports) {

var $xQxzY = parcelRequire("xQxzY");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $8pvtc = parcelRequire("8pvtc");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $8pvtc.WebPanelLocationQuery), baseOptions) : (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $8pvtc.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first'
    });
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("8pvtc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $ac1e927e530cb686$export$d97dfe528d83a912 = (0, $eSUdr.default)`query WebPanelLocationQuery($location:String$contentId:ID$spaceKey:String){webPanels(location:$location contentId:$contentId key:$spaceKey){moduleKey completeKey html location label weight name}}`;
module.exports["WebPanelLocationQuery"] = $ac1e927e530cb686$export$d97dfe528d83a912;

});

parcelRegister("5vi32", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    return (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("gGHFp", function(module, exports) {

var $joyRP = parcelRequire("joyRP");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $9wGTI = parcelRequire("9wGTI");


var $flWvL = parcelRequire("flWvL");

const $fc42d4eabc71418e$var$UseEditorContentModeValueQuery = (0, $joyRP.default);
function $fc42d4eabc71418e$export$6bb080aad8c6a96a({ contentId: contentId, isArchived: isArchived }) {
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isDraft = !isLivePage && Boolean(isEditorPage) && (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp');
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($fc42d4eabc71418e$var$UseEditorContentModeValueQuery, {
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: 'cache-and-network',
        skip: !(0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || !contentId // avoid starting network flow
    });
    let serverModeRaw;
    if ((0, $9wGTI.fg)('platform_editor_content_mode_button_mvp')) {
        const contentProps = data?.content?.nodes?.[0]?.contentProperties;
        if (isDraft) serverModeRaw = contentProps?.draft?.contentMode;
        else serverModeRaw = contentProps?.latest?.contentMode;
    } else serverModeRaw = undefined;
    const mode = (0, $flWvL.serverToUiContentMode)(serverModeRaw);
    return (0, $42omo.useMemo)(()=>({
            mode: mode,
            isLoading: (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') ? Boolean(loading) : false,
            error: (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') ? error ?? null : null
        }), [
        mode,
        loading,
        error
    ]);
}
module.exports["useEditorContentModeValue"] = $fc42d4eabc71418e$export$6bb080aad8c6a96a;

});

parcelRegister("joyRP", function(module, exports) {
/**
 * @generated SignedSource<<7d4381122b7da51c5a57a4c67758f949>>
 * @relayHash ff452defe6c30c6aef6cb69359d0b5a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad
const $fd020ad5a5ea36ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "PublishedContentProperties",
                                            "kind": "LinkedField",
                                            "name": "latest",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "DraftContentProperties",
                                            "kind": "LinkedField",
                                            "name": "draft",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ff452defe6c30c6aef6cb69359d0b5a9",
            "id": "34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad",
            "metadata": {},
            "name": "useEditorContentModeValueQuery",
            "operationKind": "query",
            "text": "query useEditorContentModeValueQuery($contentId:ID!,$isDraft:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,contentProperties{latest@skip(if:$isDraft){contentMode},draft@include(if:$isDraft){contentMode}}}}}"
        }
    };
}();
$fd020ad5a5ea36ff$var$node.hash = "51a479801516afe1b59a1bbcd1c3f7d5";
var $fd020ad5a5ea36ff$export$2e2bcd8739ae039 = $fd020ad5a5ea36ff$var$node;
module.exports["default"] = $fd020ad5a5ea36ff$export$2e2bcd8739ae039;

});

parcelRegister("flWvL", function(module, exports) {
const $601c87545eb15d39$export$7744ef788ce8060b = (server)=>{
    if (typeof server === 'string') {
        const v = server.toLowerCase();
        if (v === 'compact') return 'compact';
    }
    return 'standard';
};
const $601c87545eb15d39$export$c21c52065fb17015 = (ui)=>ui === 'compact' ? 'COMPACT' : 'STANDARD';
const $601c87545eb15d39$export$9b5b746082006bde = (m)=>m === 'compact' ? 'standard' : 'compact';
const $601c87545eb15d39$export$bc47da214dd10736 = (opts)=>{
    if (opts.isLivePage) return 'CURRENT';
    if (opts.isEditorPage) return 'DRAFT';
    return 'CURRENT';
};
const $601c87545eb15d39$export$7052ab1304ba8160 = (isDraft, isArchived)=>{
    return isArchived ? 'archived' : isDraft ? 'draft' : 'current';
};
module.exports["serverToUiContentMode"] = $601c87545eb15d39$export$7744ef788ce8060b;
module.exports["uiToServerContentMode"] = $601c87545eb15d39$export$c21c52065fb17015;
module.exports["flipContentMode"] = $601c87545eb15d39$export$9b5b746082006bde;
module.exports["resolveContentStatus"] = $601c87545eb15d39$export$bc47da214dd10736;
module.exports["queryStatusFor"] = $601c87545eb15d39$export$7052ab1304ba8160;

});

parcelRegister("lfmjq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $7aRa9 = parcelRequire("7aRa9");

const $0d3a7c976c53fe50$export$687b1508b29e79eb = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const moved = urlParams.get('moved');
        if (moved === 'success') {
            // Show the success flag
            flags.showSuccessFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $0d3a7c976c53fe50$var$i18n.movePageItemMovedTitle),
                isAutoDismiss: true
            });
            // Clean up URL parameters without causing a page reload
            urlParams.delete('moved');
            const newParams = urlParams.size > 0 ? `?${urlParams.toString()}` : '';
            const newUrl = `${window.location.pathname}${newParams}${window.location.hash}`;
            window.history.replaceState({}, '', newUrl);
        }
    }, [
        flags,
        intl
    ]);
    return null;
});
const $0d3a7c976c53fe50$var$i18n = (0, $cgtv4.defineMessages)({
    movePageItemMovedTitle: {
        id: "page-tree.move-page.flag.success",
        defaultMessage: "Item moved"
    }
});
module.exports["MovePageSuccessFlag"] = $0d3a7c976c53fe50$export$687b1508b29e79eb;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("hd53J", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $aSsfA = parcelRequire("aSsfA");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $2eC70 = parcelRequire("2eC70");


var $4L9ve = parcelRequire("4L9ve");

// Initiates the loading of all comment data for the specified page in the background
// This component is also responsible for processing the raw comments data and updating
// the ProcessedCommentsDataStore with categorized results using default contentStatus filters.
// Experience tracking constants
const $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE = 'comments-data-background-load';
const $52b7f7492d78c524$export$bdd232a9ca677e73 = ({ contentId: contentId })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { setProcessedData: setProcessedData, setError: setError, setRefetch: setRefetch } = (0, $4L9ve.useProcessedCommentsDataActions)();
    // Call the hook to load all comments - should only when content has settled and is ready so we
    // don't impact loading times
    // Always fetch with network-only to ensure we get fresh data
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: !contentId,
            fetchPolicy: 'network-only'
        }
    });
    // Set refetch function in store whenever it changes
    (0, $42omo.useEffect)(()=>{
        if (refetch) setRefetch(refetch);
    }, [
        refetch,
        setRefetch
    ]);
    // Process and update the ProcessedCommentsDataStore when data changes
    // This is the ONLY place where the processed data store should be updated
    (0, $42omo.useEffect)(()=>{
        // Don't process data while loading
        if (loading) return;
        if (error) {
            // Set error state in the store
            setError(error);
            return;
        }
        // Filter out null nodes and create array (empty array if no data)
        const allComments = (data?.comments?.nodes || []).filter((node)=>node !== null);
        // Categorize comments using default contentStatus filters
        const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
        const categorized = (0, $kgNLQ.categorizeComments)(allComments, contentStatusFilters);
        // Update the processed data store with categorized results
        // Note: refetch is set separately via setRefetch, so we don't include it here
        setProcessedData({
            allComments: allComments,
            ...categorized,
            isDataProcessed: true
        });
    }, [
        data,
        loading,
        error,
        pageMode,
        setProcessedData,
        setError
    ]);
    // Experience tracking: Handle success/failure when loading completes
    (0, $42omo.useEffect)(()=>{
        if (!contentId) return;
        // Only track completion if we're not still loading
        if (!loading) {
            if (error) // Experience failed due to error
            experienceTracker.fail({
                name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE,
                error: error
            });
            else // Experience succeeded - comments data loaded successfully
            experienceTracker.succeed({
                name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE
            });
        }
    }, [
        loading,
        error,
        contentId,
        experienceTracker
    ]);
    // This component only triggers the hook, doesn't render anything other than the ExperienceStart,
    // which handles being rendered multiple times with the same props gracefully
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE,
        attributes: {
            ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
            contentId: contentId
        }
    });
};
module.exports["CommentsDataBackgroundLoader"] = $52b7f7492d78c524$export$bdd232a9ca677e73;

});

parcelRegister("ln0hx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("8S5Nq", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $218fb6be7858ca8d$export$c96c4e8509a478b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "OOALz",
    name: "SmartButtonConfigPanel",
    loader: async ()=>(await (parcelRequire("4mS4G"))).SmartButtonConfigPanel
});
module.exports["SmartButtonConfigPanel"] = $218fb6be7858ca8d$export$c96c4e8509a478b;

});

parcelRegister("4mS4G", function(module, exports) {

let $32e329928923dc8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $32e329928923dc8a$var$load("8yTXr"),
    $32e329928923dc8a$var$load("drv5I"),
    $32e329928923dc8a$var$load("iQ0Jm"),
    $32e329928923dc8a$var$load("6wr18"),
    $32e329928923dc8a$var$load("gctwz"),
    $32e329928923dc8a$var$load("7f9Fz"),
    $32e329928923dc8a$var$load("ffEVr"),
    $32e329928923dc8a$var$load("lhkXg"),
    $32e329928923dc8a$var$load("h2QhJ"),
    $32e329928923dc8a$var$load("hjl2g")
]).then(()=>parcelRequire('cN6V7'));

});

parcelRegister("iz4WO", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $9wGTI = parcelRequire("9wGTI");

const $a33c6d5d862efa17$export$cb03d08131b95fd = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    return {
        isSmartButtonAllowed: isPremium || (0, $9wGTI.fg)('a4c_free_and_standard_editions')
    };
};
module.exports["useSmartButtonPremiumGate"] = $a33c6d5d862efa17$export$cb03d08131b95fd;

});

parcelRegister("jOYfu", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5aeb329f1887f8c3$export$f82678483d6187c3 = ()=>{
    const [smartButtonActiveNodeLocalId, setSmartButtonActiveNodeLocalId] = (0, $42omo.useState)(null);
    const openSmartButtonConfigPanel = (0, $42omo.useCallback)((localId)=>{
        setSmartButtonActiveNodeLocalId(localId);
    }, [
        setSmartButtonActiveNodeLocalId
    ]);
    const closeSmartButtonConfigPanel = (0, $42omo.useCallback)(()=>{
        setSmartButtonActiveNodeLocalId(null);
    }, [
        setSmartButtonActiveNodeLocalId
    ]);
    return (0, $42omo.useMemo)(()=>({
            smartButtonActiveNodeLocalId: smartButtonActiveNodeLocalId,
            openSmartButtonConfigPanel: openSmartButtonConfigPanel,
            closeSmartButtonConfigPanel: closeSmartButtonConfigPanel
        }), [
        smartButtonActiveNodeLocalId,
        openSmartButtonConfigPanel,
        closeSmartButtonConfigPanel
    ]);
};
module.exports["useSmartButtonConfigPanel"] = $5aeb329f1887f8c3$export$f82678483d6187c3;

});

parcelRegister("jXhAV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d2180b659da4cd23$export$cace184d1f5b9f1 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "QfGBR",
    name: "QuickReload",
    loader: async ()=>{
        const { QuickReload: QuickReload } = await (parcelRequire("9MGju"));
        return QuickReload;
    }
});
module.exports["QuickReload"] = $d2180b659da4cd23$export$cace184d1f5b9f1;

});

parcelRegister("9MGju", function(module, exports) {

let $71f96b4eeccceed7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $71f96b4eeccceed7$var$load("f1NVy"),
    $71f96b4eeccceed7$var$load("6wr18"),
    $71f96b4eeccceed7$var$load("fzXjm"),
    $71f96b4eeccceed7$var$load("2F69B"),
    $71f96b4eeccceed7$var$load("4t77a"),
    $71f96b4eeccceed7$var$load("gLGsg"),
    $71f96b4eeccceed7$var$load("fwmQF"),
    $71f96b4eeccceed7$var$load("ffEVr"),
    $71f96b4eeccceed7$var$load("7e13v"),
    $71f96b4eeccceed7$var$load("7XFs3")
]).then(()=>parcelRequire('1EPbu'));

});

parcelRegister("fSC8h", function(module, exports) {
var $aa49ff5a5783772f$export$c51d39001809fe3e = /*#__PURE__*/ function(PubSubState) {
    PubSubState[PubSubState["POLLING_ONLY"] = 0] = "POLLING_ONLY";
    PubSubState[PubSubState["PUBSUB_ONLY"] = 1] = "PUBSUB_ONLY";
    PubSubState[PubSubState["ACTIVE"] = 2] = "ACTIVE";
    PubSubState[PubSubState["TERMINATED"] = 3] = "TERMINATED";
    return PubSubState;
}({});
const $aa49ff5a5783772f$export$5a33be95ac52bdad = 2000;
var $aa49ff5a5783772f$export$8f29965b50c50222 = /*#__PURE__*/ function(PubSubFlagType) {
    PubSubFlagType[PubSubFlagType["COMMENT"] = 0] = "COMMENT";
    PubSubFlagType[PubSubFlagType["EDIT"] = 1] = "EDIT";
    return PubSubFlagType;
}({});
var $aa49ff5a5783772f$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode[PageMode["EDITOR"] = 0] = "EDITOR";
    PageMode[PageMode["LIVE"] = 1] = "LIVE";
    PageMode[PageMode["RENDERER"] = 2] = "RENDERER";
    return PageMode;
}({});
module.exports["PubSubState"] = $aa49ff5a5783772f$export$c51d39001809fe3e;
module.exports["INACTIVE_TAB_WAIT_INTERVAL"] = $aa49ff5a5783772f$export$5a33be95ac52bdad;
module.exports["PubSubFlagType"] = $aa49ff5a5783772f$export$8f29965b50c50222;
module.exports["PageMode"] = $aa49ff5a5783772f$export$6ea4b0c62affbe44;

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("iWI3x", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hYoU4 = parcelRequire("hYoU4");


var $4arST = parcelRequire("4arST");

const $6e8e2f3a6d87036a$export$9540a34fb4a0cc39 = {
    COLLAB_PROVIDER: 'RETRIEVE_EDITOR_TITLE_AND_CONTENT_ERROR_COLLAB_PROVIDER',
    ACK_STATE: 'RETRIEVE_EDITOR_TITLE_AND_CONTENT_ERROR_ACK_STATE'
};
const $6e8e2f3a6d87036a$export$502db6186656215e = ({ onCollabError: onCollabError, editorActions: editorActions })=>{
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const getCollabProviderState = (0, $4arST.useGetCollabProviderState)({
        editorActions: editorActions,
        collabEditProvider: collabEditProvider,
        reason: 'get-content'
    });
    const retrieveEditorTitleAndContent = (0, $42omo.useCallback)(()=>{
        return new Promise((resolve, reject)=>{
            if (!collabEditProvider) return reject($6e8e2f3a6d87036a$export$9540a34fb4a0cc39.COLLAB_PROVIDER);
            return Promise.resolve(getCollabProviderState(true)).then((ackState)=>{
                if (!ackState) return reject($6e8e2f3a6d87036a$export$9540a34fb4a0cc39.ACK_STATE);
                const { title: title, content: content, stepVersion: stepVersion } = ackState;
                return resolve({
                    title: title,
                    adf: content,
                    ncsStepVersion: stepVersion.toString()
                });
            }).catch((error)=>{
                onCollabError();
                reject(error);
            });
        });
    }, [
        onCollabError,
        getCollabProviderState,
        collabEditProvider
    ]);
    return {
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent
    };
};
module.exports["useRetrieveEditorTitleAndContent"] = $6e8e2f3a6d87036a$export$502db6186656215e;

});

parcelRegister("hYoU4", function(module, exports) {

var $3wgAM = parcelRequire("3wgAM");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $1P1Tu.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $FOT9i.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $9zUhf.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("3wgAM", function(module, exports) {

var $2LrJx = parcelRequire("2LrJx");


var $5Nw7l = parcelRequire("5Nw7l");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $29013b23581f9040$var$pick = $5Nw7l(function(object, paths) {
    return object == null ? {} : $2LrJx(object, paths);
});
module.exports = $29013b23581f9040$var$pick;

});

parcelRegister("2LrJx", function(module, exports) {

var $egNUN = parcelRequire("egNUN");


var $7U49l = parcelRequire("7U49l");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $20357bdd9d2fadfb$var$basePick(object, paths) {
    return $egNUN(object, paths, function(value, path) {
        return $7U49l(object, path);
    });
}
module.exports = $20357bdd9d2fadfb$var$basePick;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("7mpOv", function(module, exports) {

var $gejop = parcelRequire("gejop");


var $42omo = parcelRequire("42omo");


var $lzcvT = parcelRequire("lzcvT");


var $5spQU = parcelRequire("5spQU");


var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");

const $7ae32555811cd45f$var$UseIsAIEnabledForContentQuery = (0, $gejop.default);
const $7ae32555811cd45f$var$isAIReadAllowed = (operationsList)=>{
    if (operationsList) return operationsList.some((item)=>item?.operation === 'ai_read');
    else return false;
};
const $7ae32555811cd45f$export$cc5edac91cdebf9b = ({ contentId: contentId })=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabled;
    // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback.
    // This encodes environment composition (e.g., commercial-cloud: true, fedramp-moderate: false, isolated-commercial-cloud-ga: true).
    const isAIFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai') : !(0, $lzcvT.isFedRamp)();
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)($7ae32555811cd45f$var$UseIsAIEnabledForContentQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId || !isAIFeatureEnabled || !isAdminHubAIEnabled && !shouldShowRovo || !(0, $9wGTI.fg)('confluence_ai_access_policy')
    });
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    if (!(0, $9wGTI.fg)('confluence_ai_access_policy')) return {
        isAIEnabledForContent: isAdminHubAIEnabled,
        isRovoEnabledForContent: shouldShowRovo
    };
    const aiRead = $7ae32555811cd45f$var$isAIReadAllowed(data?.content?.nodes?.[0]?.operations);
    return {
        isAIEnabledForContent: aiRead && isAdminHubAIEnabled,
        isRovoEnabledForContent: aiRead && shouldShowRovo
    };
};
function $7ae32555811cd45f$export$fb975e2d7306f54a(WrappedComponent) {
    return function EnhancedComponent(props) {
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = $7ae32555811cd45f$export$cc5edac91cdebf9b({
            contentId: contentId ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
    };
}
module.exports["useIsAIEnabledForContent"] = $7ae32555811cd45f$export$cc5edac91cdebf9b;
module.exports["withIsAIEnabledForContent"] = $7ae32555811cd45f$export$fb975e2d7306f54a;

});

parcelRegister("gejop", function(module, exports) {
/**
 * @generated SignedSource<<dcc7465266fc46a48308c2a084af2ed9>>
 * @relayHash 3a27260e57e410ffecd4ba617c6d3637
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 31c4e4a3ba20d4a057426f91f20e95897295f9d91218d2d7ad20c63eb6d8908d
const $3cac748832e2023e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsAIEnabledForContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsAIEnabledForContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3a27260e57e410ffecd4ba617c6d3637",
            "id": "31c4e4a3ba20d4a057426f91f20e95897295f9d91218d2d7ad20c63eb6d8908d",
            "metadata": {},
            "name": "useIsAIEnabledForContentQuery",
            "operationKind": "query",
            "text": "query useIsAIEnabledForContentQuery($contentId:ID!){content(id:$contentId){nodes{id,operations{targetType,operation}}}}"
        }
    };
}();
$3cac748832e2023e$var$node.hash = "87034a7db072a7db419402593bcbd707";
var $3cac748832e2023e$export$2e2bcd8739ae039 = $3cac748832e2023e$var$node;
module.exports["default"] = $3cac748832e2023e$export$2e2bcd8739ae039;

});

parcelRegister("5spQU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $jYbwE = parcelRequire("jYbwE");

Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $jYbwE.isEnvironmentBlockEnabled;
    }
});



Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $jYbwE.isFeatureEnabled;
    }
});

});

parcelRegister("jYbwE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $5RB5d = parcelRequire("5RB5d");


var $bRppy = parcelRequire("bRppy");

/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @returns if the environment block is available in the current cloud environment
 */ function $e89c8fa7bf5c28ec$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $e89c8fa7bf5c28ec$var$getBoundaryKey();
    return (0, $bRppy.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $e89c8fa7bf5c28ec$var$isEnvironmentBlockEnabled;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @returns if the feature is available in the current cloud environment
 */ function $e89c8fa7bf5c28ec$var$isFeatureEnabled(environmentBlockName, featureName) {
    const boundaryKey = $e89c8fa7bf5c28ec$var$getBoundaryKey();
    return (0, $bRppy.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
}
module.exports.isFeatureEnabled = $e89c8fa7bf5c28ec$var$isFeatureEnabled;
function $e89c8fa7bf5c28ec$var$getBoundaryKey() {
    if ((0, $5RB5d.isFedrampModerate)()) return $bRppy.FED_MOD_KEY;
    if ((0, $5RB5d.isIsolatedCloud)()) return $bRppy.ISOLATED_CLOUD_COMMERCIAL_KEY;
    return $bRppy.COMMERCIAL_KEY;
}

});

parcelRegister("5RB5d", function(module, exports) {

var $9vFIg = parcelRequire("9vFIg");


var $iG8l7 = parcelRequire("iG8l7");

function $444eaaec2c4d71fe$export$9186ccba8effc5de() {
    const atlCtxCookieValues = (0, $iG8l7.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $9vFIg.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $444eaaec2c4d71fe$export$104cb891a6e90b3a() {
    const atlCtxCookieValues = (0, $iG8l7.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $9vFIg.FEDRAMP_MODERATE);
}
function $444eaaec2c4d71fe$export$80638ee198476daf() {
    const atlCtxCookieValues = (0, $iG8l7.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icDomain;
}
function $444eaaec2c4d71fe$export$839b022803d38d4d() {
    const atlCtxCookieValues = (0, $iG8l7.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}
module.exports["isIsolatedCloud"] = $444eaaec2c4d71fe$export$9186ccba8effc5de;
module.exports["isFedrampModerate"] = $444eaaec2c4d71fe$export$104cb891a6e90b3a;

});

parcelRegister("9vFIg", function(module, exports) {
const $6ec75da0edf32757$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $6ec75da0edf32757$export$f005e2e9f707cb5f = 'commercial';
const $6ec75da0edf32757$export$a739cd5aac835909 = 'staging';
const $6ec75da0edf32757$export$42dd0cdd351a4a9 = 'prod';
const $6ec75da0edf32757$export$404582bc18fe4d9e = 'dev';
const $6ec75da0edf32757$export$d8347b4aae768c2d = [
    $6ec75da0edf32757$export$f005e2e9f707cb5f
];
const $6ec75da0edf32757$export$b1b1ccc8f3e7f954 = [
    $6ec75da0edf32757$export$f005e2e9f707cb5f,
    $6ec75da0edf32757$export$ce553301d55c2fd8
];
const $6ec75da0edf32757$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $6ec75da0edf32757$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $6ec75da0edf32757$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
module.exports["FEDRAMP_MODERATE"] = $6ec75da0edf32757$export$ce553301d55c2fd8;
module.exports["ISOLATED_CLOUD_PERIMETERS"] = $6ec75da0edf32757$export$d8347b4aae768c2d;
module.exports["ATL_CTX_PERIMETER"] = $6ec75da0edf32757$export$87285944378c596;
module.exports["ATL_CTX_ISOLATION_CONTEXT_DOMAIN"] = $6ec75da0edf32757$export$715603e81922c3ec;
module.exports["ATL_CTX_ISOLATION_CONTEXT_ID"] = $6ec75da0edf32757$export$a0ffa0598c95dfb7;

});

parcelRegister("iG8l7", function(module, exports) {

var $9vFIg = parcelRequire("9vFIg");

/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $d9929e543e364378$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}
function $d9929e543e364378$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = $d9929e543e364378$var$getRawCookieValue((0, $9vFIg.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = $d9929e543e364378$var$getRawCookieValue((0, $9vFIg.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = $d9929e543e364378$var$getRawCookieValue((0, $9vFIg.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}
module.exports["parseAtlCtxCookies"] = $d9929e543e364378$export$3fa7b7af96286cc9;

});

parcelRegister("bRppy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $bW2zJ = parcelRequire("bW2zJ");

Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $bW2zJ.isEnvironmentBlockEnabledForBoundary;
    }
});



Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $bW2zJ.isFeatureEnabledForBoundary;
    }
});

var $dAnKm = parcelRequire("dAnKm");

Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $dAnKm.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $dAnKm.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $dAnKm.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});

});

parcelRegister("bW2zJ", function(module, exports) {
"use strict";
var $8b071be3717020b1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $8b071be3717020b1$var$sdk_data_json_1 = $8b071be3717020b1$var$__importDefault((parcelRequire("leq11")));
const $8b071be3717020b1$var$aemEnvironmentBlockData = $8b071be3717020b1$var$sdk_data_json_1.default;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $8b071be3717020b1$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $8b071be3717020b1$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $8b071be3717020b1$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $8b071be3717020b1$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($8b071be3717020b1$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $8b071be3717020b1$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        return environmentBlockData.features[featureName]?.compositions[boundaryKey] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $8b071be3717020b1$var$isFeatureEnabledForBoundary;
function $8b071be3717020b1$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    return $8b071be3717020b1$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName]?.compositions[boundaryKey] === true;
}

});

parcelRegister("leq11", function(module, exports) {
module.exports = JSON.parse("{\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"adminhub-access-requests\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-actor-profiles\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-add-product\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-admin-insights\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-api-token-controls\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-app-requests\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-app-updates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-audit-log\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-automatic-product-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-billing-console\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-brie\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-byok\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-content-scanning\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-custom-email-addresses\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-data-classifications\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-data-management\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-data-residency\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-discovered-apps\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-dlp-partner-integrations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-enforced-2-step-verification\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-enforced-data-security-policy-by-classification\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-experiment-controls\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-hippa-compliance\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-last-active-date\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-multiple-idps\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-org-deletion\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-product-recommendation\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-release-tracks\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-remediation-api\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-remediation-recommendations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-remediation-workflows\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-saml-sso\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-sandbox\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-self-service-product-acquisition\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-siem-integrations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-site-rename\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-third-party-contacts\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-url-subdomain-updates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-user-access-invites\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-user-access-settings\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-user-counts\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-user-impersonation\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-user-provisioning\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}}}},\"assets\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{\"assets-data-manager\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"assets-reports\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"atlassian-analytics\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"bitbucket\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{\"bitbucket-slack-app\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"pipelines\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"chat\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"compass\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":false,\"fedramp-moderate\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"ccma\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-ai\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-anonymous-access\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-company-hub\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-content-archiving\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-content-manager\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-databases\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-editing-experience\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-editor-offline-storage\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-employee-directory\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-loom-integration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-mission-control\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-mobile-app\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-page-analytics\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-presenter-mode\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-public-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-questions-native-experience\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-questions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-search\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-single-space-guests\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-slack-integration\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-smart-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-space-analytics\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-team-calendars\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-whiteboards\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"customer-service-management\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"focus\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"goals\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"guard-premium\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"guard-standard\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"home\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{\"home-status-backend\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"jira\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"jcma\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-audit-log\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-backlogs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-boards-and-views\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-calendar-view\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-components\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jira-forms\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-github-for-jira\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-github-workflows\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jira-in-product-help\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jira-insights\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-loom-banner\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jira-mobile-app\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jira-opsgenie\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jira-plans\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-project-archiving\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-project-templates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-releases\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-share\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-site-optimiser\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-slack\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-smart-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-team-managed-projects\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-workflow-configuration\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}}}},\"jira-align\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"jira-service-management-help-center\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-ai-ops\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-ai-services\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-approvals\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-automation-playbook\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-canned-responses\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-change-calendar\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-change-risk-assessment\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-chat-ops\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-chat\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-csat\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-developer-escalations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-email-requests\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-forms\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-help-center\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-incident-conference-calls\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-incident-management-integration\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-journey-builder\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-multi-language-support\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-queues\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-related-issues\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-reports-operations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-services\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-sla-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-templates-and-views\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"opsgenie\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}}}},\"loom\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"projects\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"rovo\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{\"rovo-ai-3p-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"rovo-ai-app-availability\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"rovo-ai-atlassian-intelligence-app-availability\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"rovo-ai-machine-learning\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"rovo-ai-natural-language-in-automation-rule-creation\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"rovo-ai-projects\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"rovo-ai-smart-features-based-on-machine-learning-tecton-ai\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"rovo-dev\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"statuspage\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"studio\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"talent\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"teams\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"trello\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"anti-abuse-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"application-tunnels\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"atlassian-visualization-platform-plato\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"collaboration-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"commerce-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"commerce-platform-self-serve\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"cross-product-search\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"customer-support-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"ecosystem-forge\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"ecosystem-oauth\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"forge-cli\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"forge-remote-capabilities\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"forge-system-apps\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"forge\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}}}},\"experience-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"growth-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"identity\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"identity-virality\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}}}},\"machine-learning-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"marketplace\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"marketplace-app-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}}}},\"migrations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"data-center-to-agc\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"migration-link-fixing\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}}}},\"migrations-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"post-office\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"product-integrations-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"reactions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"smartlinks\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"analytics-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"asset-readiness-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"atlassian-graphql-gateway\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"atlassian-platform-deployer\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"automation-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"automation-platform-actions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"automation-platform-branches\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"automation-platform-conditions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"automation-platform-templates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"automation-platform-triggers\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"aws-cloud-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"bifrost\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"build-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"cloud-security\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"compliance-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"consent-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"core-network-automation\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"cross-gateway\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-classification-governance-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-depot-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-exchange-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"aqui\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"data-management-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-movement-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-platform-services\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-telemetry-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"decisions-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"detection-and-response-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"edge\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"encryption-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"environment-management-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"eureka-streaming-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"flight-deck-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"golden-ami\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"infrastructure\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"internal-edge\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"job-execution-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"kitt-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"knowledge-graph\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"mail-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"media-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"networking\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"observability-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"pollinator\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"resiliency-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"security-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"service-to-service-fabric\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"socrates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"staff-authentication-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"streamhub\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"targeting-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"tdp-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"teamwork-graph-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"tenant-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"trusted-change-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"vdi\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"workplace-technology-solutions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}}}}");

});

parcelRegister("dAnKm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BOUNDARY_KEYS_LIST = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY
];

});

parcelRegister("iwNka", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7zgzO = parcelRequire("7zgzO");


var $fFk4O = parcelRequire("fFk4O");

const $54ae78ae571a596a$export$1a20dd7f74852e6b = ()=>{
    // Linter is forcing us to use getHref instead of window.location.href to retrieve href and it isn't the full href - it doesn't include origin
    const { getHref: getHref } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    (0, $42omo.useEffect)(()=>{
        // https://atlassian.slack.com/archives/C0131PNA4GL/p1723738281832269
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if ('setCaptureHandleConfig' in (navigator?.mediaDevices ?? {})) {
            const href = getHref();
            (0, $fFk4O.appendGoogleMeetScreenSharingScript)(href);
        }
    // Only execute on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
module.exports["useExposeGoogleMeetScreenShare"] = $54ae78ae571a596a$export$1a20dd7f74852e6b;

});

parcelRegister("fFk4O", function(module, exports) {

var $9ICY6 = parcelRequire("9ICY6");

const $1cd0e9177e768135$export$449f0d0bb2c2424b = 'https://www.gstatic.com/meetjs/addons/1.1.0/meet.addons.js';
const $1cd0e9177e768135$export$8ea5dba186347383 = (href)=>{
    // Create script
    const script = document.createElement('script');
    script.src = $1cd0e9177e768135$export$449f0d0bb2c2424b;
    script.async = true;
    // When script is done loading, run the Google Meet screenshare method
    script.onload = ()=>{
        (0, $9ICY6.exposeToMeetWhenScreensharing)(href);
    };
    // Add script to DOM
    document.head.appendChild(script);
};
module.exports["appendGoogleMeetScreenSharingScript"] = $1cd0e9177e768135$export$8ea5dba186347383;

});

parcelRegister("9ICY6", function(module, exports) {

var $hwNSM = parcelRequire("hwNSM");

var $f29836a0ec4c93d3$export$eab8e91f09e6d84a = /*#__PURE__*/ function(ProjectNumber) {
    ProjectNumber["staging"] = "1017113233545";
    ProjectNumber["production"] = "118174936708";
    return ProjectNumber;
}({});
var $f29836a0ec4c93d3$export$73691bb86ec75a9 = /*#__PURE__*/ function(Hostname) {
    Hostname["staging"] = "cc-embedded-pages-integ-ui.stg-east.frontend.public.atl-paas.net";
    Hostname["production"] = "cc-embedded-pages-integ.atlassian.com";
    return Hostname;
}({});
const $f29836a0ec4c93d3$export$8446085e93adc95b = (hostname, queryParams)=>`https://${hostname}/google-meet/page?${queryParams}`;
const $f29836a0ec4c93d3$export$7973aed45b22124c = (href)=>{
    const buildUrl = `${window.location.origin}${href}`;
    const parsedURL = (0, $hwNSM.parseUrl)(buildUrl) ?? {};
    return new URLSearchParams(parsedURL).toString();
};
const $f29836a0ec4c93d3$export$88041f03017aa037 = (href)=>{
    const currentEnv = "production";
    // Create the correct query params for the main stage url - based on confluence embedded page
    const queryParams = $f29836a0ec4c93d3$export$7973aed45b22124c(href);
    // Grab hardcoded hostname and project number based on current env
    const hostname = $f29836a0ec4c93d3$export$73691bb86ec75a9[currentEnv] ?? "cc-embedded-pages-integ-ui.stg-east.frontend.public.atl-paas.net";
    const cloudProjectNumber = $f29836a0ec4c93d3$export$eab8e91f09e6d84a[currentEnv] ?? "1017113233545";
    // Fire the Google add-on method to allow promotion and add-on use when screensharing
    // startActivityOnOpen needs to be set to true as long as we use mainstageUrl
    // See docs for additional info: https://developers.google.com/meet/add-ons/reference/websdk/screenshare_api.addonscreenshareinfo.startactivityonopen
    window?.meet?.addon?.screensharing?.exposeToMeetWhenScreensharing({
        cloudProjectNumber: cloudProjectNumber,
        startActivityOnOpen: true,
        mainStageUrl: $f29836a0ec4c93d3$export$8446085e93adc95b(hostname, queryParams)
    });
};
module.exports["exposeToMeetWhenScreensharing"] = $f29836a0ec4c93d3$export$88041f03017aa037;

});

parcelRegister("85rxh", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $bf7e99398a94595e$export$2cbe7bfb10d82597 = (cloudId, userId, orgId)=>{
    return (0, $42omo.useCallback)((purpose)=>{
        if (purpose === 'rovo-agent') return {
            contentURL: window.location.origin + window.location.pathname,
            cloudId: cloudId,
            userId: userId,
            orgId: orgId
        };
        return null;
    }, [
        cloudId,
        userId,
        orgId
    ]);
};
module.exports["useGetChannelVariables"] = $bf7e99398a94595e$export$2cbe7bfb10d82597;

});

parcelRegister("fjhaB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $7Ryt2 = parcelRequire("7Ryt2");

function $cb89921c47be68ab$export$78c2bbd50206cc7f() {
    const [activityProvider, setActivityProvider] = (0, $42omo.useState)(undefined);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    (0, $42omo.useEffect)(()=>{
        setActivityProvider((0, $7Ryt2.getActivityProvider)(cloudId));
    }, [
        cloudId
    ]);
    return activityProvider;
}
module.exports["useActivityProvider"] = $cb89921c47be68ab$export$78c2bbd50206cc7f;

});

parcelRegister("7Ryt2", function(module, exports) {

var $iooNr = parcelRequire("iooNr");

const $7a079a70f1242941$var$ACTIVITY_URL = '/gateway/api/graphql';
async function $7a079a70f1242941$export$a2b55b950e46bdd9(cloudId) {
    return Promise.resolve(new (0, $iooNr.default)($7a079a70f1242941$var$ACTIVITY_URL, cloudId));
}
module.exports["getActivityProvider"] = $7a079a70f1242941$export$a2b55b950e46bdd9;

});

parcelRegister("iooNr", function(module, exports) {

var $6hu6G = parcelRequire("6hu6G");


var $2S07V = parcelRequire("2S07V");

/**
 * Currently the underlying FE service can only retrieve the first page of results, which is limited at 100 results.
 * See ACT-3418 for upcoming fix.
 */ const $a08e15a2b85e2ea8$var$DEFAULT_ACTIVITY_COUNT = 100;
class $a08e15a2b85e2ea8$export$2e2bcd8739ae039 {
    async getRecentItems(limit = $a08e15a2b85e2ea8$var$DEFAULT_ACTIVITY_COUNT) {
        if (!this.recentPromise) this.recentPromise = this.client.fetchActivities([
            50
        ], {
            rootContainerIds: [
                this.cloudId
            ],
            limit: limit
        }, [
            'viewed'
        ]);
        try {
            const response = await this.recentPromise;
            return response.viewed.map((node)=>({
                    objectId: node.object.id,
                    name: node.object.name || '',
                    container: this.getContainerName(node.containers),
                    url: node.object.url,
                    iconUrl: node.object.icon?.type === 'EMOJI' && node.object.icon.fallback ? node.object.icon.fallback : node.object.icon?.value || '',
                    type: node.object.type,
                    viewedTimestamp: node.timestamp
                })).filter((item)=>Boolean(item.name));
        } catch (err) {
            throw new (0, $2S07V.ActivityError)(err.message, err.code);
        }
    }
    async searchRecent(query) {
        const items = await this.getRecentItems();
        return this.filterItems(items, query);
    }
    /**
   * It should return the closet container's name
   */ getContainerName(containers) {
        for(let i = containers.length - 1; i >= 0; --i){
            const containerName = containers[i].name;
            if (containerName) return containerName;
        }
        return '';
    }
    filterItems(items, searchTerm) {
        if (!searchTerm) return [];
        return items.filter((item)=>{
            return item.name?.toLowerCase()?.includes(searchTerm.toLowerCase());
        });
    }
    /**
   *
   * @param url
   * @param cloudId - this will be transformed into an ARI
   * @param options - @deprecated this is no longer used
   */ constructor(url, cloudId, options = {}){
        this.cloudId = void 0;
        this.client = void 0;
        this.recentPromise = void 0;
        this.cloudId = `ari:cloud:platform::site/${cloudId}`;
        this.client = (0, $6hu6G.createActivityClient)('v3', 'editor', undefined, url);
    }
}
module.exports["default"] = $a08e15a2b85e2ea8$export$2e2bcd8739ae039;

});

parcelRegister("6hu6G", function(module, exports) {

var $89ZxY = parcelRequire("89ZxY");


var $8AdqG = parcelRequire("8AdqG");

let $ab62de022060b56f$var$previousClientVersion;
const $ab62de022060b56f$export$224367b01f71f2aa = (version, product, logger, baseUrl, configFetch)=>{
    if ($ab62de022060b56f$var$previousClientVersion && $ab62de022060b56f$var$previousClientVersion !== version && logger?.captureWarning) logger.captureWarning(`ActivityClient version has changed, is this intentional?`);
    $ab62de022060b56f$var$previousClientVersion = version || 'v3';
    if (version === 'v2') return new (0, $89ZxY.ActivityClientV2)(product, baseUrl);
    return new (0, $8AdqG.ActivityClientV3)(product, baseUrl, logger, configFetch);
};
module.exports["createActivityClient"] = $ab62de022060b56f$export$224367b01f71f2aa;

});

parcelRegister("89ZxY", function(module, exports) {

var $1kGOm = parcelRequire("1kGOm");


var $aMbzE = parcelRequire("aMbzE");


var $9Zwww = parcelRequire("9Zwww");

class $d9872470f8564e9f$export$330ab0047f2fb745 extends (0, $aMbzE.ActivityClient) {
    constructor(_product, baseUrl){
        super('v2', _product, undefined, baseUrl);
        this.fetchActivities = async (retryMS, filters, activityQueries)=>{
            return (0, $1kGOm.fetchActivitiesWithExperience)((experience)=>(0, $9Zwww.fetchActivitiesV2)({
                    experience: experience,
                    product: this.product,
                    retryMS: retryMS,
                    filters: filters,
                    activityQueries: activityQueries,
                    baseUrl: this.baseUrl
                }), 'v2');
        };
        this.setProduct = (product)=>{
            this.product = product;
        };
    }
}
module.exports["ActivityClientV2"] = $d9872470f8564e9f$export$330ab0047f2fb745;

});

parcelRegister("1kGOm", function(module, exports) {

var $8vHBJ = parcelRequire("8vHBJ");


var $lsrrn = parcelRequire("lsrrn");


var $agkwD = parcelRequire("agkwD");

async function $32117be304c7c4e1$export$4a906f16800734f3(fetchActivities, clientVersion) {
    const experience = clientVersion === 'v2' ? (0, $agkwD.recentWorkClientExperienceV2)() : (0, $agkwD.recentWorkClientExperienceV3)();
    try {
        experience.start();
        experience.addMetadata({
            clientVersion: clientVersion,
            packageName: $lsrrn.packageName,
            packageVersion: $lsrrn.packageVersion
        });
        const data = await fetchActivities(experience);
        experience.success();
        return data;
    } catch (e) {
        experience.failure({
            metadata: {
                error: $32117be304c7c4e1$export$f33622abb5224195(e)
            }
        });
        throw e;
    }
}
const $32117be304c7c4e1$export$f33622abb5224195 = (e)=>{
    if (e instanceof (0, $8vHBJ.default)) return {
        ...e,
        xRequestId: e.xRequestId ?? undefined,
        cause: undefined
    };
    return e instanceof Error ? {
        ...e,
        cause: undefined
    } : 'unknown';
};
module.exports["fetchActivitiesWithExperience"] = $32117be304c7c4e1$export$4a906f16800734f3;

});

parcelRegister("8vHBJ", function(module, exports) {
class $2e5e077062c7732f$export$2e2bcd8739ae039 extends Error {
    constructor({ message: message, statusCode: statusCode, path: path, method: method, xRequestId: xRequestId, headers: headers }){
        super();
        this.message = void 0;
        this.method = void 0;
        this.path = void 0;
        this.statusCode = void 0;
        this.xRequestId = void 0;
        this.headers = void 0;
        this.name = 'HttpError';
        this.message = message;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        this.method = method;
        this.statusCode = statusCode;
        this.xRequestId = xRequestId;
        // @ts-ignore - Property 'entries' does not exist on type 'Headers'.
        // This was added when enrolling `@atlassian/recent-work-client` into JFE local consumption
        this.headers = Array.from(headers.entries()).map((value, key)=>`${key}:${value}`).sort().join(',');
    }
}
const $2e5e077062c7732f$export$97b788730ba59845 = (e)=>e instanceof $2e5e077062c7732f$export$2e2bcd8739ae039;
module.exports["default"] = $2e5e077062c7732f$export$2e2bcd8739ae039;

});

parcelRegister("lsrrn", function(module, exports) {
const $5fc4693544cc0e9d$export$9345d7360ffe0722 = "platform-pkg";
const $5fc4693544cc0e9d$export$91546b032799aa40 = "0.0.0-use.local";
module.exports["packageName"] = $5fc4693544cc0e9d$export$9345d7360ffe0722;
module.exports["packageVersion"] = $5fc4693544cc0e9d$export$91546b032799aa40;

});

parcelRegister("agkwD", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $a4fb49f1c23260ee$var$keyToTiming = (key)=>({
        key: key,
        startMark: `${key}_start`,
        endMark: `${key}_end`
    });
const $a4fb49f1c23260ee$var$timings = [
    'FetchedActivities',
    'TransformedActivityItems',
    'GeneratedQueryWithFilters'
].map($a4fb49f1c23260ee$var$keyToTiming);
const $a4fb49f1c23260ee$export$d7769758f5eaa63b = ()=>{
    return new (0, $5aVN7.UFOExperience)('client', {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $a4fb49f1c23260ee$var$timings
    });
};
const $a4fb49f1c23260ee$export$9e32a4ed888f4717 = ()=>new (0, $5aVN7.UFOExperience)('client-v3', {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $a4fb49f1c23260ee$var$timings
    });
module.exports["recentWorkClientExperienceV2"] = $a4fb49f1c23260ee$export$d7769758f5eaa63b;
module.exports["recentWorkClientExperienceV3"] = $a4fb49f1c23260ee$export$9e32a4ed888f4717;

});

parcelRegister("aMbzE", function(module, exports) {

var $lJ9dF = parcelRequire("lJ9dF");

class $cfb0c7d09d50e5a4$export$157740f5433f3dbe {
    constructor(clientVersion, product, headers, baseUrl){
        this.clientVersion = void 0;
        this.product = 'unknown';
        this.headers = void 0;
        this.baseUrl = (0, $lJ9dF.GRAPHQL_GATEWAY_PATH);
        this.fetchActivities = void 0;
        this.setProduct = void 0;
        if (product) this.product = product;
        this.clientVersion = clientVersion;
        this.headers = headers ?? {};
        if (baseUrl) this.baseUrl = baseUrl;
    }
}
module.exports["ActivityClient"] = $cfb0c7d09d50e5a4$export$157740f5433f3dbe;

});

parcelRegister("lJ9dF", function(module, exports) {
const $328c904cbc4ce376$export$851c5df667ca24c8 = '/gateway/api/graphql';
var $328c904cbc4ce376$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SMARTLINK_VIEWED"] = "sl-viewed";
    VIEWED_EVENT["SMARTLINK_CLICKED"] = "sl-clicked";
    return VIEWED_EVENT;
}({});
var $328c904cbc4ce376$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $328c904cbc4ce376$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["COMMENT"] = "COMMENT";
    ActivityObjectType["ISSUE"] = "ISSUE";
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["PROJECT"] = "PROJECT";
    ActivityObjectType["SITE"] = "SITE";
    ActivityObjectType["SPACE"] = "SPACE";
    ActivityObjectType["TASK"] = "TASK";
    // 3P Graph types below
    ActivityObjectType["DOCUMENT"] = "document";
    ActivityObjectType["REMOTE_LINK"] = "remote-link";
    return ActivityObjectType;
}({});
module.exports["GRAPHQL_GATEWAY_PATH"] = $328c904cbc4ce376$export$851c5df667ca24c8;
module.exports["VIEWED_EVENT"] = $328c904cbc4ce376$export$d245b105c09339d8;
module.exports["WORKED_EVENT"] = $328c904cbc4ce376$export$eb4e9f525aef1cc3;
module.exports["ActivityObjectType"] = $328c904cbc4ce376$export$d02a56686be43f69;

});

parcelRegister("9Zwww", function(module, exports) {

var $9M6Bq = parcelRequire("9M6Bq");


var $flhdq = parcelRequire("flhdq");


var $8ONYO = parcelRequire("8ONYO");


var $2w7rF = parcelRequire("2w7rF");

const $e96892609f021260$var$ACTIVITIES_LIMIT = 50;
// typescript guard for validating the activities connection type
const $e96892609f021260$var$isMyActivitiesConnection = (activities)=>{
    return activities.myActivities !== undefined;
};
const $e96892609f021260$var$V2_AVAILABLE_PRODUCTS = [
    'teamCentral',
    'editor',
    'people',
    'jira',
    'townsquare',
    'apOnboarding',
    'worklens',
    'confluence',
    'start'
];
const $e96892609f021260$export$750ec7816fdd2f9e = async ({ experience: experience, product: product, retryMS: retryMS, filters: filters = {}, activityQueries: activityQueries, baseUrl: baseUrl })=>{
    const { limit: // we want to default limit if not applied
    limit = $e96892609f021260$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    experience.mark('GeneratedQueryWithFilters_start');
    const { query: query, queryFilters: queryFilters } = (0, $8ONYO.generateActivityQueryWithFilters)(product, restFilters, activityQueries);
    experience.mark('GeneratedQueryWithFilters_end');
    // This is to make v2 forwards compatible. Defaulting to start as the product
    const operationProduct = $e96892609f021260$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
    experience.mark('FetchedActivities_start');
    let response;
    try {
        response = await (0, $flhdq.postResource)(baseUrl, {
            operationName: (0, $9M6Bq.getOperationName)(operationProduct),
            query: query,
            variables: {
                first: limit,
                filters: queryFilters
            }
        }, retryMS);
    } catch (error) {
        if (!error || error.statusCode !== 401 && error.message !== 'The operation was aborted.') throw error;
    }
    experience.mark('FetchedActivities_end');
    let workedOn = [], viewed = [], all = [];
    if (!response || !response.data?.activities) return {
        all: all,
        workedOn: workedOn,
        viewed: viewed
    };
    experience.mark('TransformedActivityItems_start');
    if ($e96892609f021260$var$isMyActivitiesConnection(response.data.activities)) {
        if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $2w7rF.transformActivitiesItems)('workedOn', response.data.activities.myActivities.workedOn);
        if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) viewed = (0, $2w7rF.transformActivitiesItems)('viewed', response.data.activities.myActivities.viewed);
        if (response.data.activities.myActivities.all && activityQueries.includes('all')) all = (0, $2w7rF.transformActivitiesItems)('all', response.data.activities.myActivities.all);
    } else {
        if (response.data.activities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $2w7rF.transformActivitiesItems)('workedOn', response.data.activities.workedOn);
        if (response.data.activities.all && activityQueries.includes('all')) all = (0, $2w7rF.transformActivitiesItems)('all', response.data.activities.all);
    }
    experience.mark('TransformedActivityItems_end');
    return {
        all: all,
        viewed: viewed,
        workedOn: workedOn
    };
};
module.exports["fetchActivitiesV2"] = $e96892609f021260$export$750ec7816fdd2f9e;

});

parcelRegister("9M6Bq", function(module, exports) {

var $5nZsM = parcelRequire("5nZsM");

const $6478cdf7ffdfed6b$export$ad1e21d37f385bcb = (product)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(product);
};
const $6478cdf7ffdfed6b$export$41bca9dc6871dd4e = (product)=>{
    return `${$6478cdf7ffdfed6b$export$ad1e21d37f385bcb(product)}_activity_recentWorkClient`;
};
module.exports["getOperationName"] = $6478cdf7ffdfed6b$export$41bca9dc6871dd4e;

});

parcelRegister("5nZsM", function(module, exports) {

var $iKCFj = parcelRequire("iKCFj");


var $2Ed9T = parcelRequire("2Ed9T");

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $3ebec708b133657c$var$camelCase = $2Ed9T(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $iKCFj(word) : word);
});
module.exports = $3ebec708b133657c$var$camelCase;

});

parcelRegister("iKCFj", function(module, exports) {

var $fPVB6 = parcelRequire("fPVB6");


var $12IaO = parcelRequire("12IaO");

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $da6a84003d7bc8a2$var$capitalize(string) {
    return $12IaO($fPVB6(string).toLowerCase());
}
module.exports = $da6a84003d7bc8a2$var$capitalize;

});

parcelRegister("2Ed9T", function(module, exports) {

var $52wl7 = parcelRequire("52wl7");


var $iOvMY = parcelRequire("iOvMY");


var $bT49y = parcelRequire("bT49y");

/** Used to compose unicode capture groups. */ var $1ed9863c2ebfed04$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $1ed9863c2ebfed04$var$reApos = RegExp($1ed9863c2ebfed04$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $1ed9863c2ebfed04$var$createCompounder(callback) {
    return function(string) {
        return $52wl7($bT49y($iOvMY(string).replace($1ed9863c2ebfed04$var$reApos, '')), callback, '');
    };
}
module.exports = $1ed9863c2ebfed04$var$createCompounder;

});

parcelRegister("52wl7", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $3ab639a44a152d0d$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $3ab639a44a152d0d$var$arrayReduce;

});

parcelRegister("iOvMY", function(module, exports) {

var $i2ByD = parcelRequire("i2ByD");


var $fPVB6 = parcelRequire("fPVB6");

/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $db258e1bec5616a7$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $db258e1bec5616a7$var$rsComboMarksRange = '\\u0300-\\u036f', $db258e1bec5616a7$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $db258e1bec5616a7$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $db258e1bec5616a7$var$rsComboRange = $db258e1bec5616a7$var$rsComboMarksRange + $db258e1bec5616a7$var$reComboHalfMarksRange + $db258e1bec5616a7$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $db258e1bec5616a7$var$rsCombo = '[' + $db258e1bec5616a7$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $db258e1bec5616a7$var$reComboMark = RegExp($db258e1bec5616a7$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $db258e1bec5616a7$var$deburr(string) {
    string = $fPVB6(string);
    return string && string.replace($db258e1bec5616a7$var$reLatin, $i2ByD).replace($db258e1bec5616a7$var$reComboMark, '');
}
module.exports = $db258e1bec5616a7$var$deburr;

});

parcelRegister("i2ByD", function(module, exports) {

var $jghHU = parcelRequire("jghHU");

/** Used to map Latin Unicode letters to basic Latin letters. */ var $d2258c0d042ca0c6$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $d2258c0d042ca0c6$var$deburrLetter = $jghHU($d2258c0d042ca0c6$var$deburredLetters);
module.exports = $d2258c0d042ca0c6$var$deburrLetter;

});

parcelRegister("jghHU", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $e05d3f3448b226c6$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $e05d3f3448b226c6$var$basePropertyOf;

});

parcelRegister("bT49y", function(module, exports) {

var $011qA = parcelRequire("011qA");


var $1Xhyy = parcelRequire("1Xhyy");


var $fPVB6 = parcelRequire("fPVB6");


var $heRFI = parcelRequire("heRFI");

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $8a780d7d3205113e$var$words(string, pattern, guard) {
    string = $fPVB6(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $1Xhyy(string) ? $heRFI(string) : $011qA(string);
    return string.match(pattern) || [];
}
module.exports = $8a780d7d3205113e$var$words;

});

parcelRegister("011qA", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $003133aba52e1295$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $003133aba52e1295$var$asciiWords(string) {
    return string.match($003133aba52e1295$var$reAsciiWord) || [];
}
module.exports = $003133aba52e1295$var$asciiWords;

});

parcelRegister("1Xhyy", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $16c8eb795c50bf79$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $16c8eb795c50bf79$var$hasUnicodeWord(string) {
    return $16c8eb795c50bf79$var$reHasUnicodeWord.test(string);
}
module.exports = $16c8eb795c50bf79$var$hasUnicodeWord;

});

parcelRegister("heRFI", function(module, exports) {
/** Used to compose unicode character classes. */ var $c8cd609b21904ab0$var$rsAstralRange = '\\ud800-\\udfff', $c8cd609b21904ab0$var$rsComboMarksRange = '\\u0300-\\u036f', $c8cd609b21904ab0$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $c8cd609b21904ab0$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $c8cd609b21904ab0$var$rsComboRange = $c8cd609b21904ab0$var$rsComboMarksRange + $c8cd609b21904ab0$var$reComboHalfMarksRange + $c8cd609b21904ab0$var$rsComboSymbolsRange, $c8cd609b21904ab0$var$rsDingbatRange = '\\u2700-\\u27bf', $c8cd609b21904ab0$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $c8cd609b21904ab0$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $c8cd609b21904ab0$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $c8cd609b21904ab0$var$rsPunctuationRange = '\\u2000-\\u206f', $c8cd609b21904ab0$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $c8cd609b21904ab0$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $c8cd609b21904ab0$var$rsVarRange = '\\ufe0e\\ufe0f', $c8cd609b21904ab0$var$rsBreakRange = $c8cd609b21904ab0$var$rsMathOpRange + $c8cd609b21904ab0$var$rsNonCharRange + $c8cd609b21904ab0$var$rsPunctuationRange + $c8cd609b21904ab0$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $c8cd609b21904ab0$var$rsApos = "['\u2019]", $c8cd609b21904ab0$var$rsBreak = '[' + $c8cd609b21904ab0$var$rsBreakRange + ']', $c8cd609b21904ab0$var$rsCombo = '[' + $c8cd609b21904ab0$var$rsComboRange + ']', $c8cd609b21904ab0$var$rsDigits = '\\d+', $c8cd609b21904ab0$var$rsDingbat = '[' + $c8cd609b21904ab0$var$rsDingbatRange + ']', $c8cd609b21904ab0$var$rsLower = '[' + $c8cd609b21904ab0$var$rsLowerRange + ']', $c8cd609b21904ab0$var$rsMisc = '[^' + $c8cd609b21904ab0$var$rsAstralRange + $c8cd609b21904ab0$var$rsBreakRange + $c8cd609b21904ab0$var$rsDigits + $c8cd609b21904ab0$var$rsDingbatRange + $c8cd609b21904ab0$var$rsLowerRange + $c8cd609b21904ab0$var$rsUpperRange + ']', $c8cd609b21904ab0$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $c8cd609b21904ab0$var$rsModifier = '(?:' + $c8cd609b21904ab0$var$rsCombo + '|' + $c8cd609b21904ab0$var$rsFitz + ')', $c8cd609b21904ab0$var$rsNonAstral = '[^' + $c8cd609b21904ab0$var$rsAstralRange + ']', $c8cd609b21904ab0$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $c8cd609b21904ab0$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $c8cd609b21904ab0$var$rsUpper = '[' + $c8cd609b21904ab0$var$rsUpperRange + ']', $c8cd609b21904ab0$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $c8cd609b21904ab0$var$rsMiscLower = '(?:' + $c8cd609b21904ab0$var$rsLower + '|' + $c8cd609b21904ab0$var$rsMisc + ')', $c8cd609b21904ab0$var$rsMiscUpper = '(?:' + $c8cd609b21904ab0$var$rsUpper + '|' + $c8cd609b21904ab0$var$rsMisc + ')', $c8cd609b21904ab0$var$rsOptContrLower = '(?:' + $c8cd609b21904ab0$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $c8cd609b21904ab0$var$rsOptContrUpper = '(?:' + $c8cd609b21904ab0$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $c8cd609b21904ab0$var$reOptMod = $c8cd609b21904ab0$var$rsModifier + '?', $c8cd609b21904ab0$var$rsOptVar = '[' + $c8cd609b21904ab0$var$rsVarRange + ']?', $c8cd609b21904ab0$var$rsOptJoin = '(?:' + $c8cd609b21904ab0$var$rsZWJ + '(?:' + [
    $c8cd609b21904ab0$var$rsNonAstral,
    $c8cd609b21904ab0$var$rsRegional,
    $c8cd609b21904ab0$var$rsSurrPair
].join('|') + ')' + $c8cd609b21904ab0$var$rsOptVar + $c8cd609b21904ab0$var$reOptMod + ')*', $c8cd609b21904ab0$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $c8cd609b21904ab0$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $c8cd609b21904ab0$var$rsSeq = $c8cd609b21904ab0$var$rsOptVar + $c8cd609b21904ab0$var$reOptMod + $c8cd609b21904ab0$var$rsOptJoin, $c8cd609b21904ab0$var$rsEmoji = '(?:' + [
    $c8cd609b21904ab0$var$rsDingbat,
    $c8cd609b21904ab0$var$rsRegional,
    $c8cd609b21904ab0$var$rsSurrPair
].join('|') + ')' + $c8cd609b21904ab0$var$rsSeq;
/** Used to match complex or compound words. */ var $c8cd609b21904ab0$var$reUnicodeWord = RegExp([
    $c8cd609b21904ab0$var$rsUpper + '?' + $c8cd609b21904ab0$var$rsLower + '+' + $c8cd609b21904ab0$var$rsOptContrLower + '(?=' + [
        $c8cd609b21904ab0$var$rsBreak,
        $c8cd609b21904ab0$var$rsUpper,
        '$'
    ].join('|') + ')',
    $c8cd609b21904ab0$var$rsMiscUpper + '+' + $c8cd609b21904ab0$var$rsOptContrUpper + '(?=' + [
        $c8cd609b21904ab0$var$rsBreak,
        $c8cd609b21904ab0$var$rsUpper + $c8cd609b21904ab0$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $c8cd609b21904ab0$var$rsUpper + '?' + $c8cd609b21904ab0$var$rsMiscLower + '+' + $c8cd609b21904ab0$var$rsOptContrLower,
    $c8cd609b21904ab0$var$rsUpper + '+' + $c8cd609b21904ab0$var$rsOptContrUpper,
    $c8cd609b21904ab0$var$rsOrdUpper,
    $c8cd609b21904ab0$var$rsOrdLower,
    $c8cd609b21904ab0$var$rsDigits,
    $c8cd609b21904ab0$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $c8cd609b21904ab0$var$unicodeWords(string) {
    return string.match($c8cd609b21904ab0$var$reUnicodeWord) || [];
}
module.exports = $c8cd609b21904ab0$var$unicodeWords;

});

parcelRegister("flhdq", function(module, exports) {
parcelRequire("jjbGD");
var $99X6x = parcelRequire("99X6x");
var $jjbGD = parcelRequire("jjbGD");


var $g6Nhv = parcelRequire("g6Nhv");


var $8vHBJ = parcelRequire("8vHBJ");

const $50a49ab2b7b0fd3b$var$fetchResource = async (path, method, options = {})=>{
    const url = (0, $g6Nhv.getFullUrl)(path);
    const response = await fetch(url, {
        credentials: 'include',
        method: method,
        ...options
    }).catch((error)=>{
        throw new (0, $99X6x.default)({
            error: error,
            path: path,
            method: method
        });
    });
    const statusCode = response.status;
    if (!response.ok) {
        statusCode;
        const text = $50a49ab2b7b0fd3b$var$scrubTimestampFromErrorBody(await response.text());
        const httpError = new (0, $8vHBJ.default)({
            message: text,
            method: method,
            path: path,
            statusCode: statusCode,
            xRequestId: response.headers.get('x-request-id'),
            headers: response.headers
        });
        throw httpError;
    }
    return response;
};
const $50a49ab2b7b0fd3b$var$makeJsonRquest = async (path, method, additionalFetchOptions = {})=>{
    const response = await $50a49ab2b7b0fd3b$var$fetchResource(path, method, additionalFetchOptions);
    const text = await response.text();
    // trying to parse empty response as JSON throws an error, but endpoints can return empty response in case of success
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return text ? JSON.parse(text) : {};
};
const $50a49ab2b7b0fd3b$export$2ff3e1f219ccfad6 = async (path, data, retryMS, extraHeaders)=>(0, $jjbGD.retryOnException)(()=>$50a49ab2b7b0fd3b$var$makeJsonRquest(path, 'POST', {
            body: JSON.stringify(data),
            headers: {
                'content-type': 'application/json',
                ...extraHeaders
            }
        }), {
        intervalsMS: retryMS ?? []
    });
// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function $50a49ab2b7b0fd3b$var$scrubTimestampFromErrorBody(text) {
    let json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}
module.exports["postResource"] = $50a49ab2b7b0fd3b$export$2ff3e1f219ccfad6;

});

parcelRegister("jjbGD", function(module, exports) {
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("99X6x")).default);

var $ugvwf = parcelRequire("ugvwf");


var $8r8H1 = parcelRequire("8r8H1");


var $99X6x = parcelRequire("99X6x");

const $e6bcc9a5af5d2f35$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $e6bcc9a5af5d2f35$var$NO_CALLS_ERROR = 'No calls made';
const $e6bcc9a5af5d2f35$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $8r8H1.NO_RETRIES), retryOn: retryOn = [
    (0, $99X6x.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($e6bcc9a5af5d2f35$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $e6bcc9a5af5d2f35$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $e6bcc9a5af5d2f35$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $ugvwf.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};
module.exports["retryOnException"] = $e6bcc9a5af5d2f35$export$1d94629c94e7a17f;

});

parcelRegister("ugvwf", function(module, exports) {
const $b720f8bd3e196adc$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $b720f8bd3e196adc$export$2e2bcd8739ae039 = $b720f8bd3e196adc$var$convertToError;
module.exports["default"] = $b720f8bd3e196adc$export$2e2bcd8739ae039;

});

parcelRegister("8r8H1", function(module, exports) {
const $3648e78e1eff0ebe$export$a0a1c8f90becc136 = [];
const $3648e78e1eff0ebe$export$972171517b12aa4 = [
    0,
    0
];
const $3648e78e1eff0ebe$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $3648e78e1eff0ebe$export$f6858378b665f957 = [
    100,
    500,
    1000
];
module.exports["NO_RETRIES"] = $3648e78e1eff0ebe$export$a0a1c8f90becc136;

});

parcelRegister("99X6x", function(module, exports) {
class $96df690c33121e3a$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.method = void 0;
        this.originalName = void 0;
        this.path = void 0;
        this.stack = void 0;
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}
module.exports["default"] = $96df690c33121e3a$export$2e2bcd8739ae039;

});

parcelRegister("g6Nhv", function(module, exports) {
const $ed7d1e76b1f471ae$var$urlRegex = new RegExp(/^https?:\/\//);
function $ed7d1e76b1f471ae$export$2414511207262909(path, // Add this param so we can test this function better
hostConfig = {
    host: window.location.hostname,
    port: window.location.port
}) {
    // always return a just the URL if one is provided
    if ($ed7d1e76b1f471ae$var$urlRegex.test(path)) return path;
    return hostConfig.host === 'localhost' ? `http://${hostConfig.host}:${hostConfig.port}${path}` : path;
}
module.exports["getFullUrl"] = $ed7d1e76b1f471ae$export$2414511207262909;

});

parcelRegister("8ONYO", function(module, exports) {

var $9M6Bq = parcelRequire("9M6Bq");


var $tyUdU = parcelRequire("tyUdU");

const $5e56b4855b8ddd4f$var$ACTIVITIES = `
  nodes {
    id
    timestamp
    object {
      id
      name
      cloudId
      localResourceId
      product
      type
      url
      iconUrl
      containers {
        name
      }
      contributors {
        profile {
          accountId
          name
          picture
        }
      }
      events {
        eventType
      }
      extension {
        ... on ActivitiesJiraIssue {
          issueKey
        }
      }
    }
  }
`;
const $5e56b4855b8ddd4f$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filters: $filters) {
     ${$5e56b4855b8ddd4f$var$ACTIVITIES}
   }
`;
const $5e56b4855b8ddd4f$var$VIEWED__QUERY = `
   viewed(first: $first, filters: $filters) {
     ${$5e56b4855b8ddd4f$var$ACTIVITIES}
   }
`;
const $5e56b4855b8ddd4f$var$ALL__QUERY = `
    all(first: $first, filters: $filters) {
      ${$5e56b4855b8ddd4f$var$ACTIVITIES}
    }
`;
const $5e56b4855b8ddd4f$var$activityQueryMap = new Map([
    [
        'workedOn',
        $5e56b4855b8ddd4f$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $5e56b4855b8ddd4f$var$VIEWED__QUERY
    ],
    [
        'all',
        $5e56b4855b8ddd4f$var$ALL__QUERY
    ]
]);
const $5e56b4855b8ddd4f$var$getMyActivitiesQuery = (queries)=>`
      myActivities {
        ${queries.join('\n')}
      }
`;
const $5e56b4855b8ddd4f$var$getActivitiesQuery = (product, content)=>`
    query ${(0, $9M6Bq.getOperationName)(product)}($first: Int, $filters: [ActivitiesFilter!]) {
      activities {
        ${content}
      }
    }
`;
const $5e56b4855b8ddd4f$export$855cd08371c65b8c = (product, filters, activityQueries)=>{
    /**
	 * If we are filtering by `accountIds` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $5e56b4855b8ddd4f$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$5e56b4855b8ddd4f$var$activityQueryMap.get(query)).join('\n')),
            queryFilters: (0, $tyUdU.ACTIVITY_FILTER_COLLECTION).v2.get('activities')(filters)
        };
    } else return {
        query: $5e56b4855b8ddd4f$var$getActivitiesQuery(product, $5e56b4855b8ddd4f$var$getMyActivitiesQuery(activityQueries.map((query)=>$5e56b4855b8ddd4f$var$activityQueryMap.get(query)))),
        queryFilters: (0, $tyUdU.ACTIVITY_FILTER_COLLECTION).v2.get('myActivity')(filters)
    };
};
module.exports["generateActivityQueryWithFilters"] = $5e56b4855b8ddd4f$export$855cd08371c65b8c;

});

parcelRegister("tyUdU", function(module, exports) {

var $jcjam = parcelRequire("jcjam");


var $bOQQO = parcelRequire("bOQQO");

const $3ce1f7f21e6b0975$export$5201d39848130041 = {
    v2: (0, $jcjam.ACTIVITY_FILTER_V2_MAP),
    v3: (0, $bOQQO.ACTIVITY_FILTER_V3_MAP)
};
module.exports["ACTIVITY_FILTER_COLLECTION"] = $3ce1f7f21e6b0975$export$5201d39848130041;

});

parcelRegister("jcjam", function(module, exports) {

var $g1YDs = parcelRequire("g1YDs");


var $f8Fj5 = parcelRequire("f8Fj5");

const $a229434d184cb046$export$1dca7bc1ec360897 = new Map([
    [
        'myActivity',
        (0, $f8Fj5.default)
    ],
    [
        'activities',
        (0, $g1YDs.default)
    ]
]);
module.exports["ACTIVITY_FILTER_V2_MAP"] = $a229434d184cb046$export$1dca7bc1ec360897;

});

parcelRegister("g1YDs", function(module, exports) {

var $2dGYV = parcelRequire("2dGYV");

/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */ const $aa3e39d5302b5352$var$generateV2ActivitiesFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $2dGYV.generateActivityFiltersV2)(restFilters);
};
var $aa3e39d5302b5352$export$2e2bcd8739ae039 = $aa3e39d5302b5352$var$generateV2ActivitiesFilters;
module.exports["default"] = $aa3e39d5302b5352$export$2e2bcd8739ae039;

});

parcelRegister("2dGYV", function(module, exports) {

var $cfWcp = parcelRequire("cfWcp");

// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $91acf2a102fe0c9f$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $91acf2a102fe0c9f$var$KEYS_TO_TRANSFROM = new Map([
    [
        'actors',
        'accountIds'
    ]
]);
const $91acf2a102fe0c9f$export$ebef9c1f1e15c057 = (filters = {})=>(0, $cfWcp.generateActivityFilters)(filters, (originalkey, originalFilter)=>{
        const filter = Array.isArray(originalFilter) && $91acf2a102fe0c9f$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map((f)=>f.toUpperCase()) : originalFilter;
        const key = $91acf2a102fe0c9f$var$KEYS_TO_TRANSFROM.has(originalkey) ? $91acf2a102fe0c9f$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
        return {
            [key]: filter
        };
    });
module.exports["generateActivityFiltersV2"] = $91acf2a102fe0c9f$export$ebef9c1f1e15c057;

});

parcelRegister("cfWcp", function(module, exports) {
const $b77a537090dafa9a$export$23c75313f46dd54e = (filters = {}, transform, rootLevelFilters)=>{
    return Object.entries(filters).reduce((acc, [key, filter])=>{
        const entry = transform ? transform(key, filter) : {
            [key]: filter
        };
        return rootLevelFilters?.includes(key) ? {
            ...acc,
            ...entry
        } : {
            ...acc,
            arguments: {
                ...acc.arguments,
                ...entry
            }
        };
    }, {
        type: 'AND',
        arguments: {}
    });
};
module.exports["generateActivityFilters"] = $b77a537090dafa9a$export$23c75313f46dd54e;

});

parcelRegister("f8Fj5", function(module, exports) {

var $2dGYV = parcelRequire("2dGYV");

/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */ const $0a24d92d27935207$var$generateV2MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $2dGYV.generateActivityFiltersV2)(restFilters);
};
var $0a24d92d27935207$export$2e2bcd8739ae039 = $0a24d92d27935207$var$generateV2MyActivityFilters;
module.exports["default"] = $0a24d92d27935207$export$2e2bcd8739ae039;

});

parcelRegister("bOQQO", function(module, exports) {

var $dQITg = parcelRequire("dQITg");


var $jBMZs = parcelRequire("jBMZs");

const $68c8b19d94c6d0af$export$9a1782843b6e99d2 = new Map([
    [
        'myActivity',
        (0, $jBMZs.default)
    ],
    [
        'activities',
        (0, $dQITg.default)
    ]
]);
module.exports["ACTIVITY_FILTER_V3_MAP"] = $68c8b19d94c6d0af$export$9a1782843b6e99d2;

});

parcelRegister("dQITg", function(module, exports) {

var $cYpDV = parcelRequire("cYpDV");

/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */ const $c500a5dd90aab1cd$var$generateV3ActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, ...restFilters } = filters;
    return (0, $cYpDV.generateActivityFiltersV3)(restFilters);
};
var $c500a5dd90aab1cd$export$2e2bcd8739ae039 = $c500a5dd90aab1cd$var$generateV3ActivityFilters;
module.exports["default"] = $c500a5dd90aab1cd$export$2e2bcd8739ae039;

});

parcelRegister("cYpDV", function(module, exports) {

var $cfWcp = parcelRequire("cfWcp");

// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $a9947c270139ebd0$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $a9947c270139ebd0$var$ROOT_LEVEL_FILTERS = [
    'actors',
    'rootContainerIds'
];
const $a9947c270139ebd0$export$e73fe7ded3fe2664 = (filters = {})=>(0, $cfWcp.generateActivityFilters)(filters, (key, filter)=>Array.isArray(filter) && $a9947c270139ebd0$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? {
            [key]: filter.map((f)=>f.toLowerCase())
        } : {
            [key]: filter
        }, $a9947c270139ebd0$var$ROOT_LEVEL_FILTERS);
module.exports["generateActivityFiltersV3"] = $a9947c270139ebd0$export$e73fe7ded3fe2664;

});

parcelRegister("jBMZs", function(module, exports) {

var $cYpDV = parcelRequire("cYpDV");

/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */ const $233cbacaae2fcf7a$var$generateV3MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, ...restFilters } = filters;
    return (0, $cYpDV.generateActivityFiltersV3)(restFilters);
};
var $233cbacaae2fcf7a$export$2e2bcd8739ae039 = $233cbacaae2fcf7a$var$generateV3MyActivityFilters;
module.exports["default"] = $233cbacaae2fcf7a$export$2e2bcd8739ae039;

});

parcelRegister("2w7rF", function(module, exports) {
const $75279b3aeb424623$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
function $75279b3aeb424623$export$306a8b649360ca6f(query, activities = {}) {
    if (!activities || !activities.nodes) return [];
    return activities.nodes.map((item)=>{
        const { object: object, timestamp: timestamp } = item;
        const { cloudId: cloudId, events: events, extension: extension, iconUrl: iconUrl, id: id, localResourceId: localResourceId, name: name, product: product, url: url, type: type } = object;
        // V2 returns eventType captilised, V3 returns lowercase
        const eventType = events[0].eventType.toLowerCase();
        const issueKey = extension && extension.issueKey;
        let containers = [];
        if (issueKey) containers.push({
            name: issueKey
        });
        if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
        containers = containers.filter((container)=>!!container.name);
        return {
            query: query,
            containers: containers,
            contributors: (object.contributors || []).reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []),
            eventType: eventType,
            object: {
                rootContainerIdentifier: {
                    id: cloudId,
                    type: 'SITE',
                    ari: `${$75279b3aeb424623$var$SITE_ARI_PREFIX}${cloudId}`
                },
                deduplicateId: id,
                icon: {
                    type: 'URL',
                    value: iconUrl
                },
                id: id,
                localResourceId: localResourceId,
                name: name,
                product: product,
                subProduct: null,
                type: type,
                url: url
            },
            timestamp: timestamp
        };
    });
}
module.exports["transformActivitiesItems"] = $75279b3aeb424623$export$306a8b649360ca6f;

});

parcelRegister("8AdqG", function(module, exports) {

var $jjbGD = parcelRequire("jjbGD");


var $dh538 = parcelRequire("dh538");


var $lJ9dF = parcelRequire("lJ9dF");


var $lsrrn = parcelRequire("lsrrn");


var $1kGOm = parcelRequire("1kGOm");


var $flhdq = parcelRequire("flhdq");


var $8slu7 = parcelRequire("8slu7");


var $1HpcN = parcelRequire("1HpcN");


var $fX414 = parcelRequire("fX414");


var $a3sLS = parcelRequire("a3sLS");


var $l4NdO = parcelRequire("l4NdO");


var $h4NLj = parcelRequire("h4NLj");


var $aMbzE = parcelRequire("aMbzE");


var $dB4CM = parcelRequire("dB4CM");


var $9t27K = parcelRequire("9t27K");


var $2OHoP = parcelRequire("2OHoP");

const $0954b34b93e72b05$var$CONFLUENCE_COMMENT_TYPENAMES = [
    'ConfluenceComment',
    'ConfluenceFooterComment',
    'ConfluenceInlineComment'
];
const $0954b34b93e72b05$var$IGNORED_HTTP_ERRORS = new Map([
    // ignore all 401 errors
    [
        401,
        [
            /.*/
        ]
    ],
    [
        403,
        [
            /Invalid CORS request/
        ]
    ]
]);
const $0954b34b93e72b05$var$IGNORED_ERROR_MESSAGES = [
    'The operation was aborted.'
];
const $0954b34b93e72b05$var$DEFAULT_TAGS = {
    source: (0, $lsrrn.packageName),
    sourcePackageVersion: (0, $lsrrn.packageVersion)
};
class $0954b34b93e72b05$export$3c3c237c92ca1fb9 extends (0, $aMbzE.ActivityClient) {
    constructor(_product, baseUrl, logger, configFetch){
        super('v3', _product, {
            'X-ExperimentalApi': 'ActivityV3Api'
        }, baseUrl);
        this.hydratorConfigClient = void 0;
        this.clientHandlers = void 0;
        this.setProduct = (product)=>{
            this.product = product;
        };
        this.captureException = (error, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureException(error, {
                ...$0954b34b93e72b05$var$DEFAULT_TAGS,
                ...tags
            });
        };
        this.captureWarning = (message, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureWarning(message, {
                ...$0954b34b93e72b05$var$DEFAULT_TAGS,
                ...tags
            });
        };
        this.fetchHydratorConfig = async ()=>await this.hydratorConfigClient.fetchConfig();
        this.handleGraphQLErrors = (errors)=>{
            const invalidFragments = [];
            if (Array.isArray(errors)) {
                for (const err of errors){
                    this.captureException(new (0, $1HpcN.GraphQLJSError)(err));
                    const invalidFragment = (0, $dB4CM.default)(err);
                    if (invalidFragment) invalidFragments.push(invalidFragment);
                }
                return invalidFragments;
            }
            return [];
        };
        this.fetchActivitiesV3 = async (experience, retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            let { fragments: fragments, hydrators: hydrators } = await this.fetchHydratorConfig();
            experience.mark('GeneratedQueryWithFilters_start');
            let response;
            try {
                response = await (0, $jjbGD.retryOnException)(async ()=>{
                    const request = (0, $9t27K.generateGraphQLRequest)(this.product, filters, activityQueries, fragments);
                    experience.mark('GeneratedQueryWithFilters_end');
                    experience.mark('FetchedActivities_start');
                    experience.addMetadata({
                        filters: (0, $2OHoP.filtersToMetadata)(filters)
                    });
                    const res = await (0, $flhdq.postResource)(this.baseUrl, request, retryMS, {
                        ...this.headers
                    });
                    experience.mark('FetchedActivities_end');
                    const invalidFragments = this.handleGraphQLErrors(res?.errors);
                    if (invalidFragments.length > 0) {
                        fragments = (0, $2OHoP.filterInvalidFragments)(invalidFragments, fragments);
                        throw new (0, $8slu7.GraphQLFragmentError)(`Missing fragments: [${invalidFragments.toString()}]`);
                    }
                    return res;
                }, {
                    intervalsMS: [
                        0,
                        0,
                        0
                    ],
                    retryOn: (err)=>[
                            (0, $8slu7.GraphQLFragmentError)
                        ].some((retriableErr)=>err instanceof retriableErr),
                    captureException: this.captureException
                });
            } catch (error) {
                if (!error || !$0954b34b93e72b05$var$IGNORED_HTTP_ERRORS.get(error.statusCode)?.some((regExp)=>regExp.test(error.message)) && !$0954b34b93e72b05$var$IGNORED_ERROR_MESSAGES.includes(error.message)) throw error;
            }
            if ((0, $2OHoP.isEmptyActivitiesWithErrorsResponse)(response)) throw new (0, $fX414.GraphQLNoResultsError)(response.errors);
            if (!response || !response.data?.activity) return {
                workedOn: [],
                viewed: [],
                all: []
            };
            experience.mark('TransformedActivityItems_start');
            const workedOn = $0954b34b93e72b05$var$transformActivityItem('workedOn', (0, $2OHoP.activityRoot)(response.data.activity)?.workedOn?.edges || [], hydrators, this.captureException);
            // We don't need the activity root function here as viewed only exists on myActivity
            const viewed = $0954b34b93e72b05$var$transformActivityItem('viewed', response.data.activity?.myActivity?.viewed?.edges || [], hydrators, this.captureException);
            const all = $0954b34b93e72b05$var$transformActivityItem('all', (0, $2OHoP.activityRoot)(response.data.activity)?.all?.edges || [], hydrators, this.captureException);
            experience.mark('TransformedActivityItems_end');
            const activities = {
                viewed: viewed,
                workedOn: workedOn,
                all: all
            };
            return deduplicateActivities ? (0, $2OHoP.rollupActivitiesData)(activities) : activities;
        };
        this.fetchActivities = async (retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            return (0, $1kGOm.fetchActivitiesWithExperience)((experience)=>this.fetchActivitiesV3(experience, retryMS, filters, activityQueries, deduplicateActivities), 'v3');
        };
        this.clientHandlers = logger;
        this.hydratorConfigClient = new (0, $h4NLj.default)({
            captureException: this.captureException,
            captureWarning: this.captureWarning
        }, _product, configFetch);
    }
}
const $0954b34b93e72b05$var$setIconHydration = (object, hydratedData)=>{
    const isLiveDoc = object.data.__typename === 'ConfluencePage' && (0, $l4NdO.hydratedValueToString)(hydratedData.subtype) === 'LIVE';
    if (isLiveDoc) return (0, $l4NdO.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks, 'confluenceLiveDocIcon');
    if (object.product === 'graph' && (0, $l4NdO.isThirdPartyARI)(object.id)) {
        const product = (0, $l4NdO.parseThirdPartyProduct)(object.id).split('.').at(1);
        return (0, $l4NdO.hydrate3pIcon)(product, hydratedData.icon, hydratedData.staticFallbacks);
    }
    return $0954b34b93e72b05$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, $l4NdO.hydrateConfluenceIcon)(object.data?.container?.__typename || object.data.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, $l4NdO.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks);
};
const $0954b34b93e72b05$var$setStatusHydration = (hydratedData)=>{
    const value = (0, $l4NdO.hydratedValueToString)(hydratedData.statusValue);
    const score = (0, $l4NdO.hydratedValueToString)(hydratedData.statusScore);
    const color = (0, $l4NdO.hydratedValueToString)(hydratedData.statusColor);
    return value || score || color ? {
        value: value,
        score: score,
        color: color
    } : undefined;
};
function $0954b34b93e72b05$var$transformActivityItem(query, activities, hydrators, captureException) {
    return activities.reduce((acc, item)=>{
        if (item && item.node && item.node.object && item.node.event) {
            const { object: object, event: event } = item.node;
            if (!object.product || !object.type) return acc;
            let product = object.product;
            if (object.product === 'graph' || object.id.startsWith('ari:cloud:graph::pull-request')) product = (0, $2OHoP.getThirdPartyGraphProvider)(object);
            const isSmartlinkViewedType = item.node.event.eventType === (0, $lJ9dF.VIEWED_EVENT).SMARTLINK_VIEWED;
            const isRemoteLinkGateDisabled = !(0, $dh538.fg)('recent_work_client_enable_graph_remote_links');
            const isSmartlinkViewedGateEnabled = (0, $dh538.fg)('platform_recent_work_enable_sl-viewed_results');
            const isExternalRemoteLink = item.node.object.data?.__typename === 'ExternalRemoteLink';
            if (isSmartlinkViewedType && !isSmartlinkViewedGateEnabled) // Don't return any `sl-viewed` event results
            return acc;
            if (isExternalRemoteLink && isRemoteLinkGateDisabled) // Don't return Remote Link result if not rolled out to product yet
            return acc;
            const containers = [];
            let c = object.contributors || [];
            const contributors = c.reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []);
            const hydratedData = (0, $a3sLS.hydratePolymorphicData)(hydrators, object.data, captureException);
            if (hydratedData) {
                if (hydratedData.key) containers.push({
                    name: (0, $l4NdO.hydratedValueToString)(hydratedData.key, ' ')
                });
                if (hydratedData.containers) containers.push({
                    name: (0, $l4NdO.hydratedValueToString)(hydratedData.containers, ' ')
                });
                const actor = event.actor ? {
                    name: event.actor.name,
                    picture: event.actor.picture,
                    accountId: event.actor.accountId
                } : undefined;
                // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
                const eventType = object.type === 'comment' && event.eventType === (0, $lJ9dF.WORKED_EVENT).CREATED ? (0, $lJ9dF.WORKED_EVENT).COMMENTED : event.eventType;
                acc.push({
                    actor: actor,
                    query: query,
                    containers: containers,
                    contributors: contributors,
                    eventType: eventType,
                    object: {
                        rootContainerIdentifier: (0, $2OHoP.parseRootContainerARI)(object.rootContainerId),
                        icon: $0954b34b93e72b05$var$setIconHydration(object, hydratedData),
                        id: object.id,
                        deduplicateId: (0, $l4NdO.hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                        localResourceId: (0, $l4NdO.hydratedValueToString)(hydratedData.localResourceId),
                        name: (0, $l4NdO.hydratedValueToString)(hydratedData.name, ' '),
                        product: product,
                        subProduct: object.subProduct,
                        type: object.type,
                        subtype: (0, $l4NdO.hydratedValueToString)(hydratedData.subtype) || object.data.subtype,
                        url: (0, $l4NdO.hydratedValueToString)(hydratedData.url),
                        objectTypeName: (0, $l4NdO.hydratedValueToString)(hydratedData.objectTypeName),
                        creator: (0, $l4NdO.hydratedValueToString)(hydratedData.creator),
                        providerId: (0, $l4NdO.hydratedValueToString)(hydratedData.providerId),
                        status: $0954b34b93e72b05$var$setStatusHydration(hydratedData)
                    },
                    timestamp: event.timestamp
                });
            }
        }
        return acc;
    }, []);
}
module.exports["ActivityClientV3"] = $0954b34b93e72b05$export$3c3c237c92ca1fb9;

});

parcelRegister("8slu7", function(module, exports) {
class $d9ab8e53f4fb0597$export$2d1b192199788179 extends Error {
    constructor(message){
        super(message);
        this.name = 'GraphQLFragmentError';
        this.message = message;
    }
}
module.exports["GraphQLFragmentError"] = $d9ab8e53f4fb0597$export$2d1b192199788179;

});

parcelRegister("1HpcN", function(module, exports) {
class $6d47e15a0e40ba32$export$8d4af49ee2a0fbe2 extends Error {
    constructor(graphQLError){
        super(graphQLError.message);
        this.error = void 0;
        this.name = 'GraphQLJSError';
        this.error = graphQLError;
        this.message = graphQLError.message;
    }
}
module.exports["GraphQLJSError"] = $6d47e15a0e40ba32$export$8d4af49ee2a0fbe2;

});

parcelRegister("fX414", function(module, exports) {
class $5d9f0e5a45afc0ec$export$3f19ff30d409b70 extends Error {
    constructor(graphQLErrors){
        super();
        this.errors = void 0;
        this.errorMessages = void 0;
        this.name = 'GraphQLNoResultsError';
        this.errors = graphQLErrors;
        this.message = 'GraphQL returned errors & no results';
        this.errorMessages = graphQLErrors.map((error)=>error.message);
    }
}
module.exports["GraphQLNoResultsError"] = $5d9f0e5a45afc0ec$export$3f19ff30d409b70;

});

parcelRegister("a3sLS", function(module, exports) {

var $kkhbp = parcelRequire("kkhbp");


var $2fnPs = parcelRequire("2fnPs");

const $24f658990005dffd$export$d658049bf1a63492 = (hydrators, data, captureException)=>{
    if (data) {
        if ('__typename' in data) {
            const hydrator = hydrators[data.__typename];
            if (hydrator) try {
                return $24f658990005dffd$var$hydrateData(data, hydrator);
            } catch (error) {
                captureException && captureException(new (0, $2fnPs.default)({
                    error: error,
                    message: `Hydrator failed for [${data.__typename}].`
                }));
            }
            else captureException && captureException(new (0, $2fnPs.default)({
                message: `Missing hydrator for [${data.__typename}].`
            }));
        } else captureException && captureException(new (0, $2fnPs.default)({
            message: `Missing [__typename] field from data.`
        }));
    }
    return null;
};
function $24f658990005dffd$var$getOrSearch(object, path) {
    if (!object) return object;
    if (path.includes(':')) {
        const [searchField, searchValue] = path.split(':');
        return $24f658990005dffd$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, ''));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($kkhbp)))(object, path);
}
function $24f658990005dffd$var$resolvePath(object, path) {
    // Split the path on each bracket
    const splitPath = path.split(/\(|\)./);
    // Traverse the split path as a tree, resolving as we go
    let current = object;
    for (const split of splitPath)current = $24f658990005dffd$var$getOrSearch(current, split);
    return current;
}
function $24f658990005dffd$var$findNodeByField(edges, fieldId, searchValue) {
    return edges.find((edge)=>(0, (/*@__PURE__*/$parcel$interopDefault($kkhbp)))(edge, fieldId) === searchValue);
}
function $24f658990005dffd$export$a5c4301012ad6f07(object, paths) {
    return paths.map((path)=>$24f658990005dffd$var$resolvePath(object, path));
}
const $24f658990005dffd$var$hydrateData = (data, hydrator)=>{
    const { hydratorPaths: hydratorPaths, staticFallbacks: staticFallbacks } = hydrator;
    return {
        staticFallbacks: staticFallbacks,
        ...Object.entries(hydratorPaths).reduce((acc, [key, dataValue])=>{
            const item = $24f658990005dffd$export$a5c4301012ad6f07(data, dataValue);
            if (item) acc[key] = item;
            else throw new Error(`Bad hydrator path: ${key}`);
            return acc;
        }, {})
    };
};
module.exports["hydratePolymorphicData"] = $24f658990005dffd$export$d658049bf1a63492;

});

parcelRegister("2fnPs", function(module, exports) {
class $88b1285615459d57$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, message: message }){
        super();
        this.originalName = void 0;
        this.originalMessage = void 0;
        this.stack = void 0;
        const err = error instanceof Error ? error : new Error();
        this.name = 'HydratorError';
        this.message = message;
        this.originalMessage = err.message;
        this.stack = err.stack;
        this.originalName = err.name;
    }
}
module.exports["default"] = $88b1285615459d57$export$2e2bcd8739ae039;

});

parcelRegister("l4NdO", function(module, exports) {
const $5fe052f51633fc0f$export$c5cea44a1f75b431 = (value, separator = '')=>{
    if (!value) return null;
    return Array.isArray(value) ? value.join(separator) : value;
};
function $5fe052f51633fc0f$var$isURL(icon) {
    return typeof icon === 'string';
}
function $5fe052f51633fc0f$var$isValidEmoji(icon) {
    return typeof icon === 'object' && icon.value !== undefined && !!icon.value;
}
const $5fe052f51633fc0f$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $5fe052f51633fc0f$export$4578ef3572b21f34 = (ari)=>{
    const result = $5fe052f51633fc0f$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$5fe052f51633fc0f$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner] = result;
    return resourceOwner;
};
const $5fe052f51633fc0f$export$fccbae65febb6fd4 = (ari)=>$5fe052f51633fc0f$var$thirdPartyRegex.test(ari);
const $5fe052f51633fc0f$export$c60ec7b3c8b44fe1 = (product, icons, fallbacks, fallbackKey = 'icon')=>{
    if (fallbacks?.[fallbackKey] && product) {
        const thirdPartyLogo = fallbacks['thirdPartyIconPath']?.replace('{replaceProductName}', product) ?? fallbacks[fallbackKey];
        return {
            type: 'URL',
            value: thirdPartyLogo,
            fallbackIcon: fallbacks[fallbackKey]
        };
    }
    return $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks);
};
const $5fe052f51633fc0f$export$86b9f44277b105a6 = (confluenceContainerType, icons, fallbacks)=>{
    switch(confluenceContainerType){
        case 'ConfluenceBlogPost':
            return $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks, 'confluenceBlogIcon') || $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks);
        case 'ConfluencePage':
            return $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks, 'confluencePageIcon') || $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks);
        default:
            return $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks);
    }
};
const $5fe052f51633fc0f$export$a328b2bb0d21d984 = (icons, fallbacks, fallbackKey = 'icon')=>{
    if (Array.isArray(icons) && icons.length > 0) {
        const emojiIcons = icons.filter($5fe052f51633fc0f$var$isValidEmoji);
        if (emojiIcons.length > 0) return {
            type: 'EMOJI',
            value: emojiIcons[0].value,
            fallback: fallbacks?.[fallbackKey]
        };
        const urlIcons = icons.filter($5fe052f51633fc0f$var$isURL);
        if (urlIcons.length > 0) {
            const hydratedIcons = $5fe052f51633fc0f$export$c5cea44a1f75b431(urlIcons);
            if (hydratedIcons !== null) return {
                type: 'URL',
                value: hydratedIcons
            };
        }
    }
    if (fallbacks?.[fallbackKey]) return {
        type: 'URL',
        value: fallbacks[fallbackKey]
    };
    return null;
};
module.exports["hydratedValueToString"] = $5fe052f51633fc0f$export$c5cea44a1f75b431;
module.exports["parseThirdPartyProduct"] = $5fe052f51633fc0f$export$4578ef3572b21f34;
module.exports["isThirdPartyARI"] = $5fe052f51633fc0f$export$fccbae65febb6fd4;
module.exports["hydrate3pIcon"] = $5fe052f51633fc0f$export$c60ec7b3c8b44fe1;
module.exports["hydrateIcon"] = $5fe052f51633fc0f$export$a328b2bb0d21d984;
module.exports["hydrateConfluenceIcon"] = $5fe052f51633fc0f$export$86b9f44277b105a6;

});

parcelRegister("h4NLj", function(module, exports) {

var $g58eM = parcelRequire("g58eM");


var $hwkRt = parcelRequire("hwkRt");

const $3f0e325881d700a2$var$RECENT_WORK_ARTIFACT = 'recent-work-service';
const $3f0e325881d700a2$var$FD_ENVIRONMENT = 'prod';
const $3f0e325881d700a2$export$c270c412a04ff3e6 = {
    name: $3f0e325881d700a2$var$RECENT_WORK_ARTIFACT,
    dimensions: {
        environmentType: $3f0e325881d700a2$var$FD_ENVIRONMENT
    }
};
class $3f0e325881d700a2$export$2e2bcd8739ae039 {
    async fetchArtifact() {
        if (this.artifactFetch) return 0, $hwkRt.default;
        // We're using the bundled artifact temporarily as FD caching is broken and does not expire for 365 days
        // https://atlassian.slack.com/archives/C01UV3QT21F/p1753393679628199
        return 0, $hwkRt.default;
    }
    constructor(handlers, product, artifactFetch){
        this.artifactFetch = artifactFetch;
        this.fetchConfig = async ()=>{
            const artifact = await this.fetchArtifact();
            const { queryFragments: fragments, hydrators: hydrators } = artifact;
            return {
                fragments: fragments,
                hydrators: hydrators
            };
        };
        new (0, $g58eM.default)(product || 'recent-work-client', {
            handlers: handlers
        }, [
            {
                name: 'recent-work-service',
                dimensions: {
                    environmentType: $3f0e325881d700a2$var$FD_ENVIRONMENT
                },
                value: (0, $hwkRt.default)
            }
        ]);
        this.artifactFetch = artifactFetch;
    }
}
module.exports["FD_CLIENT_FETCH_PROPS"] = $3f0e325881d700a2$export$c270c412a04ff3e6;
module.exports["default"] = $3f0e325881d700a2$export$2e2bcd8739ae039;

});

parcelRegister("g58eM", function(module, exports) {

var $iLaQ6 = parcelRequire("iLaQ6");


var $jjbGD = parcelRequire("jjbGD");


var $kt8c2 = parcelRequire("kt8c2");


var $6yH3R = parcelRequire("6yH3R");

var $jmRYU = parcelRequire("jmRYU");


var $h2xad = parcelRequire("h2xad");


var $kvSko = parcelRequire("kvSko");


var $5Wn20 = parcelRequire("5Wn20");

function $bb5380b95425c19e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bb5380b95425c19e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bb5380b95425c19e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iLaQ6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bb5380b95425c19e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $bb5380b95425c19e$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $bb5380b95425c19e$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $bb5380b95425c19e$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $jjbGD.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $6yH3R.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $h2xad.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$bb5380b95425c19e$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = Math.random() < 0.001 ? (0, $5Wn20.flightDeckClientExperience)() : new (0, $jmRYU.MockExperience)();
        experience.start();
        try {
            const artifactWithKey = $bb5380b95425c19e$var$_objectSpread($bb5380b95425c19e$var$_objectSpread({}, artifact), {}, {
                key: (0, $kvSko.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $5Wn20.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $iLaQ6.default)(this, "fallbackArtifactMap", new Map());
        (0, $iLaQ6.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $kt8c2.default)($bb5380b95425c19e$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $kvSko.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
}
module.exports["default"] = $bb5380b95425c19e$export$2e2bcd8739ae039;

});

parcelRegister("kt8c2", function(module, exports) {

var $9Bict = parcelRequire("9Bict");

const $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $f62061dbe92ec1bb$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $9Bict.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["default"] = $f62061dbe92ec1bb$export$2e2bcd8739ae039;

});

parcelRegister("9Bict", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $21987ac45ee5412e$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $21987ac45ee5412e$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$21987ac45ee5412e$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $21987ac45ee5412e$export$efebfe7859cae3c7;

});

parcelRegister("6yH3R", function(module, exports) {

var $eoZW1 = parcelRequire("eoZW1");


var $4Nb0k = parcelRequire("4Nb0k");


var $gnjN9 = parcelRequire("gnjN9");


var $exN00 = parcelRequire("exN00");


var $5F2TE = parcelRequire("5F2TE");


var $jmRYU = parcelRequire("jmRYU");


var $1uJFJ = parcelRequire("1uJFJ");

/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $4c6752261483d0e7$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $4c6752261483d0e7$var$defaultPerimeter = "commercial";
async function $4c6752261483d0e7$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter, _dim$impactLevel;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $4c6752261483d0e7$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $4c6752261483d0e7$var$defaultPerimeter;
    // Needed for backwards compatibility with Flight Deck core, reference perimeter
    const impactLevel = (_dim$impactLevel = dim.impactLevel) !== null && _dim$impactLevel !== void 0 ? _dim$impactLevel : perimeter;
    const environment = $4c6752261483d0e7$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $eoZW1.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        impactLevel: impactLevel,
        environment: environment,
        locale: locale
    };
    const client = await $4c6752261483d0e7$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $4c6752261483d0e7$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $4c6752261483d0e7$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $4c6752261483d0e7$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $4c6752261483d0e7$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $4c6752261483d0e7$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $jmRYU.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $jmRYU.getVersionMetadataFetchExperience)();
    return new (0, $5F2TE.ConfigClient)(new (0, $gnjN9.BifrostDataSource)(new (0, $exN00.BifrostHttpClientImpl)(env, perimeter), (0, $4Nb0k.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $4c6752261483d0e7$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}
module.exports["fetchFlightDeckConfiguration"] = $4c6752261483d0e7$export$6026918e023c9101;

});

parcelRegister("eoZW1", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $639791195d5194df$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $639791195d5194df$export$2e2bcd8739ae039 = $639791195d5194df$export$852ff24d0930c62f;
module.exports["default"] = $639791195d5194df$export$2e2bcd8739ae039;

});

parcelRegister("4Nb0k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $1l7nm = parcelRequire("1l7nm");

Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $1l7nm.Either;
    }
});

var $dQfUU = parcelRequire("dQfUU");

Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $dQfUU.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $dQfUU.tryGetArtifactData;
    }
});

var $56c1N = parcelRequire("56c1N");

Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $56c1N.parseArtifactManifest;
    }
});

var $4rmqH = parcelRequire("4rmqH");

Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $4rmqH.parseVersionMetadata;
    }
});

var $ejfcn = parcelRequire("ejfcn");

Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $ejfcn.checkManifest;
    }
});

var $ecQWM = parcelRequire("ecQWM");

Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $ecQWM.ConfigRegistryDataSource;
    }
});

var $keTF5 = parcelRequire("keTF5");

Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $keTF5.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $keTF5.Versions;
    }
});

});

parcelRegister("1l7nm", function(module, exports) {
"use strict";
var $0f9d7946bab332da$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $0f9d7946bab332da$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $0f9d7946bab332da$var$Right(value);
    };
    Either.left = function(error) {
        return new $0f9d7946bab332da$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $0f9d7946bab332da$var$Either;
var $0f9d7946bab332da$var$Right = /** @class */ function(_super) {
    $0f9d7946bab332da$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $0f9d7946bab332da$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $0f9d7946bab332da$var$Either.right(this.right);
    };
    return Right;
}($0f9d7946bab332da$var$Either);
var $0f9d7946bab332da$var$Left = /** @class */ function(_super) {
    $0f9d7946bab332da$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $0f9d7946bab332da$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $0f9d7946bab332da$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $0f9d7946bab332da$var$Either.left(f(this.left));
    };
    return Left;
}($0f9d7946bab332da$var$Either);

});

parcelRegister("dQfUU", function(module, exports) {
"use strict";
var $0299bfe91f926726$var$__assign = module.exports && module.exports.__assign || function() {
    $0299bfe91f926726$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0299bfe91f926726$var$__assign.apply(this, arguments);
};
var $0299bfe91f926726$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0299bfe91f926726$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $0299bfe91f926726$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $0299bfe91f926726$var$tryGetArtifactData;

var $e1gYo = parcelRequire("e1gYo");


var $4Nb0k = parcelRequire("4Nb0k");


var $gtZqo = parcelRequire("gtZqo");


var $9kSKy = parcelRequire("9kSKy");


var $4245y = parcelRequire("4245y");

function $0299bfe91f926726$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $0299bfe91f926726$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $0299bfe91f926726$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $0299bfe91f926726$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $0299bfe91f926726$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $4Nb0k.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $gtZqo.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $0299bfe91f926726$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $9kSKy.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $0299bfe91f926726$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $0299bfe91f926726$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $0299bfe91f926726$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $e1gYo.interpolateTagScheme)(manifest.tagScheme, $0299bfe91f926726$var$__assign($0299bfe91f926726$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $0299bfe91f926726$var$__awaiter(_this, void 0, void 0, function() {
                                return $0299bfe91f926726$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $0299bfe91f926726$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $4245y.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $4245y.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $9kSKy.assertUnreachable)(artifact);
    }
}

});

parcelRegister("e1gYo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $a34e5329a6d15964$var$interpolateTagScheme;
module.exports.generateTagScheme = $a34e5329a6d15964$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $a34e5329a6d15964$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $a34e5329a6d15964$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $a34e5329a6d15964$var$getVersionMetadataTag;
const $a34e5329a6d15964$var$TAG_SCHEME_VERSION = 2;
function $a34e5329a6d15964$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($a34e5329a6d15964$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $a34e5329a6d15964$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $a34e5329a6d15964$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $a34e5329a6d15964$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $a34e5329a6d15964$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $a34e5329a6d15964$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $a34e5329a6d15964$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $a34e5329a6d15964$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("gtZqo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $bfff0076b2a38448$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $bfff0076b2a38448$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("9kSKy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $6cc0738327f40e2f$var$assertUnreachable;
function $6cc0738327f40e2f$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("4245y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $2efa854173b183a4$var$toJson;
module.exports.toPrettyJson = $2efa854173b183a4$var$toPrettyJson;
function $2efa854173b183a4$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $2efa854173b183a4$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("56c1N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $3b66d7c76b5a6f30$var$parseArtifactManifest;

var $7YiFT = parcelRequire("7YiFT");

function $3b66d7c76b5a6f30$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $7YiFT.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $7YiFT.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $3b66d7c76b5a6f30$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $7YiFT.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $3b66d7c76b5a6f30$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $3b66d7c76b5a6f30$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $7YiFT.parseUnknownObject)(dimensions);
    var supported = (0, $7YiFT.parseArray)(unparsedDimensions.supported).map($7YiFT.parseString);
    var fallback = (0, $7YiFT.parseUndefinedOr)($7YiFT.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $3b66d7c76b5a6f30$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $7YiFT.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $3b66d7c76b5a6f30$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $3b66d7c76b5a6f30$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $7YiFT.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $7YiFT.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $7YiFT.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $7YiFT.parseUndefinedOr)($7YiFT.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $3b66d7c76b5a6f30$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $3b66d7c76b5a6f30$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});

parcelRegister("7YiFT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $5cdc9f61297a7705$var$parseString;
module.exports.parseArray = $5cdc9f61297a7705$var$parseArray;
module.exports.parseBoolean = $5cdc9f61297a7705$var$parseBoolean;
module.exports.parseUnknownObject = $5cdc9f61297a7705$var$parseUnknownObject;
module.exports.parseUndefinedOr = $5cdc9f61297a7705$var$parseUndefinedOr;
function $5cdc9f61297a7705$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $5cdc9f61297a7705$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $5cdc9f61297a7705$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $5cdc9f61297a7705$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $5cdc9f61297a7705$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});

parcelRegister("4rmqH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $33bb15189e2a597d$var$parseVersionMetadata;

var $7YiFT = parcelRequire("7YiFT");

function $33bb15189e2a597d$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $7YiFT.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $7YiFT.parseString)(unknownObject.version);
    var publishTime = new Date((0, $7YiFT.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $7YiFT.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("ejfcn", function(module, exports) {
"use strict";
var $a6aea1303ef4c284$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $a6aea1303ef4c284$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $a6aea1303ef4c284$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $a6aea1303ef4c284$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("ecQWM", function(module, exports) {
"use strict";
var $a57b41e342284c93$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a57b41e342284c93$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $e1gYo = parcelRequire("e1gYo");


var $1l7nm = parcelRequire("1l7nm");


var $56c1N = parcelRequire("56c1N");


var $4rmqH = parcelRequire("4rmqH");

var $a57b41e342284c93$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $a57b41e342284c93$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $a57b41e342284c93$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $e1gYo.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($56c1N.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $1l7nm.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $a57b41e342284c93$var$__awaiter(this, void 0, void 0, function() {
            return $a57b41e342284c93$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $a57b41e342284c93$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $a57b41e342284c93$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $e1gYo.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $4rmqH.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $a57b41e342284c93$var$ConfigRegistryDataSource;

});

parcelRegister("keTF5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $ebc04ab7747b3e03$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $ebc04ab7747b3e03$var$BaseUrls;
var $ebc04ab7747b3e03$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $ebc04ab7747b3e03$var$Versions;

});

parcelRegister("gnjN9", function(module, exports) {

var $4Nb0k = parcelRequire("4Nb0k");


var $e1gYo = parcelRequire("e1gYo");

class $bebe258c209dced8$export$2cb8d79200775058 {
    async getLatestVersionMetadata() {
        const tag = (0, $e1gYo.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $4Nb0k.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $4Nb0k.parseVersionMetadata)(response);
                return (0, $4Nb0k.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $4Nb0k.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $e1gYo.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $4Nb0k.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $4Nb0k.parseArtifactManifest)(response);
                return (0, $4Nb0k.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $4Nb0k.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
}
module.exports["BifrostDataSource"] = $bebe258c209dced8$export$2cb8d79200775058;

});

parcelRegister("exN00", function(module, exports) {

var $4Nb0k = parcelRequire("4Nb0k");

function $a96a27f8779f7f59$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $a96a27f8779f7f59$export$45c6d12ca9c14f83 {
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $4Nb0k.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $4Nb0k.Either).right(json)));
            }).catch((error)=>resolve((0, $4Nb0k.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
    constructor(env, perimeter){
        this.baseUrl = $a96a27f8779f7f59$export$f654b28f82155665(env, perimeter);
    }
}
module.exports["BifrostHttpClientImpl"] = $a96a27f8779f7f59$export$45c6d12ca9c14f83;

});

parcelRegister("5F2TE", function(module, exports) {

var $iLaQ6 = parcelRequire("iLaQ6");


var $4Nb0k = parcelRequire("4Nb0k");


var $iLqQe = parcelRequire("iLqQe");

function $41f3074aaceffd34$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41f3074aaceffd34$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41f3074aaceffd34$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iLaQ6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41f3074aaceffd34$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $41f3074aaceffd34$export$8489e2f039bfcc4c {
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $41f3074aaceffd34$var$_objectSpread($41f3074aaceffd34$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $4Nb0k.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $4Nb0k.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $iLqQe.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
}
module.exports["ConfigClient"] = $41f3074aaceffd34$export$8489e2f039bfcc4c;

});

parcelRegister("iLqQe", function(module, exports) {
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $da916feb1601e8a8$export$1cc944571619e6e8 {
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
}
module.exports["ExperienceDataSourceWrapper"] = $da916feb1601e8a8$export$1cc944571619e6e8;

});

parcelRegister("jmRYU", function(module, exports) {
const $03a383e7109b9e96$var$SAMPLING_RATE = 10;
class $03a383e7109b9e96$var$UFOExperienceWrapper {
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
    constructor(experience){
        this.experience = experience;
    }
}
class $03a383e7109b9e96$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $03a383e7109b9e96$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $03a383e7109b9e96$var$SAMPLING_RATE) return new $03a383e7109b9e96$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("649YS"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $03a383e7109b9e96$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $03a383e7109b9e96$export$5e7536cf7bc56fee();
    }
}
const $03a383e7109b9e96$export$a3006f8f221c0a3b = ()=>$03a383e7109b9e96$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $03a383e7109b9e96$export$c3ac7702bfd47c1b = ()=>$03a383e7109b9e96$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});
module.exports["MockExperience"] = $03a383e7109b9e96$export$5e7536cf7bc56fee;
module.exports["getFlightDeckFetchExperience"] = $03a383e7109b9e96$export$a3006f8f221c0a3b;
module.exports["getVersionMetadataFetchExperience"] = $03a383e7109b9e96$export$c3ac7702bfd47c1b;

});

parcelRegister("649YS", function(module, exports) {

let $46aadbccc4f1e03a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $46aadbccc4f1e03a$var$load("h05Zl").then(()=>parcelRequire('1pDeP'));

});

parcelRegister("1uJFJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $Eff3A = parcelRequire("Eff3A");

Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $Eff3A.parseConfigWithTargeting;
    }
});

var $eqS6f = parcelRequire("eqS6f");

Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $eqS6f.TargetedConfig;
    }
});

});

parcelRegister("Eff3A", function(module, exports) {
"use strict";
var $078f8f416dfc8880$var$__assign = module.exports && module.exports.__assign || function() {
    $078f8f416dfc8880$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $078f8f416dfc8880$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $078f8f416dfc8880$var$parseConfigWithTargeting;

var $eqS6f = parcelRequire("eqS6f");

/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $078f8f416dfc8880$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $078f8f416dfc8880$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $eqS6f.TargetedConfig({
                defaultConfig: $078f8f416dfc8880$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $078f8f416dfc8880$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $eqS6f.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $078f8f416dfc8880$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $078f8f416dfc8880$var$__assign($078f8f416dfc8880$var$__assign({}, accObject), (_a = {}, _a[key] = $078f8f416dfc8880$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $078f8f416dfc8880$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $078f8f416dfc8880$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $078f8f416dfc8880$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $078f8f416dfc8880$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $078f8f416dfc8880$var$parseIdentifierList(target.orgIds),
            siteIds: $078f8f416dfc8880$var$parseIdentifierList(target.siteIds),
            userIds: $078f8f416dfc8880$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $078f8f416dfc8880$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});

parcelRegister("eqS6f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $a81d757bffb50f80$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
   * Determines whether to use the targeted configuration value or the default value
   * depending on whether the specified values match any of the target's rules.
   *
   * @param target the values to use to evaluate the config
   * @returns the {@link TargetingResult}, which would be the default value
   *     if the specified target did not match, or the targeted value if there
   *     was a match
   */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $a81d757bffb50f80$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $a81d757bffb50f80$var$TargetedConfig;
function $a81d757bffb50f80$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});

parcelRegister("h2xad", function(module, exports) {
class $c67c5938243bac5e$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
        this.perimeter = dimensions === null || dimensions === void 0 ? void 0 : dimensions.perimeter;
    }
}
const $c67c5938243bac5e$export$1d76d155060824c9 = (e)=>e instanceof $c67c5938243bac5e$export$2e2bcd8739ae039;
module.exports["default"] = $c67c5938243bac5e$export$2e2bcd8739ae039;

});

parcelRegister("kvSko", function(module, exports) {
const $eef0d84a095af3e3$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};
module.exports["artifactKey"] = $eef0d84a095af3e3$export$e3553dc63541d477;

});

parcelRegister("5Wn20", function(module, exports) {

var $iLaQ6 = parcelRequire("iLaQ6");


var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

function $45343c0ee8becd11$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $45343c0ee8becd11$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $45343c0ee8becd11$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iLaQ6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $45343c0ee8becd11$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $45343c0ee8becd11$export$1e3a41a51f6457c5 = ()=>new (0, $5aVN7.UFOExperience)("retrieve-artifact", {
        type: (0, $9NDUe.ExperienceTypes).Operation,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $45343c0ee8becd11$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $45343c0ee8becd11$var$_objectSpread($45343c0ee8becd11$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};
module.exports["flightDeckClientExperience"] = $45343c0ee8becd11$export$1e3a41a51f6457c5;
module.exports["exceptionToMetadata"] = $45343c0ee8becd11$export$f33622abb5224195;

});

parcelRegister("hwkRt", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fd3741f1fad91b0$export$2e2bcd8739ae039);
/* Fetch the latest artifact via: atlas fd get-artifact recent-work-service */ var $1fd3741f1fad91b0$export$2e2bcd8739ae039 = {
    localization: {
        eventTypes: {
            commented: {
                absolute: 'You commented on {absoluteTime}',
                relative: 'You commented {relativeTime}',
                standalone: 'You commented',
                multiAbsolute: 'Commented on {absoluteTime}',
                multiRelative: 'Commented {relativeTime}',
                multiStandalone: 'Commented'
            },
            created: {
                absolute: 'You created on {absoluteTime}',
                relative: 'You created {relativeTime}',
                standalone: 'You created',
                multiAbsolute: 'Created on {absoluteTime}',
                multiRelative: 'Created {relativeTime}',
                multiStandalone: 'Created'
            },
            edited: {
                absolute: 'You edited on {absoluteTime}',
                relative: 'You edited {relativeTime}',
                standalone: 'You edited',
                multiAbsolute: 'Edited on {absoluteTime}',
                multiRelative: 'Edited {relativeTime}',
                multiStandalone: 'Edited'
            },
            published: {
                absolute: 'You published on {absoluteTime}',
                relative: 'You published {relativeTime}',
                standalone: 'You published',
                multiAbsolute: 'Published on {absoluteTime}',
                multiRelative: 'Published {relativeTime}',
                multiStandalone: 'Published'
            },
            updated: {
                absolute: 'You updated on {absoluteTime}',
                relative: 'You updated {relativeTime}',
                standalone: 'You updated',
                multiAbsolute: 'Updated on {absoluteTime}',
                multiRelative: 'Updated {relativeTime}',
                multiStandalone: 'Updated'
            },
            viewed: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            'sl-viewed': {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            clicked: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            'sl-clicked': {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            }
        }
    },
    hydrators: {
        TownsquareGoal: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ],
                statusValue: [
                    'status.value'
                ],
                statusScore: [
                    'status.score'
                ]
            }
        },
        TownsquareProject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ],
                statusValue: [
                    'state.value'
                ]
            }
        },
        TownsquareComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'container.key'
                ],
                name: [
                    'container.name'
                ],
                url: [
                    'container.url'
                ],
                icon: [
                    'container.iconData'
                ],
                deduplicateId: [
                    'container.id'
                ]
            }
        },
        ConfluencePage: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'pageId'
                ],
                subtype: [
                    'subtype'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceLiveDocIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/live-doc.svg'
            }
        },
        ConfluenceBlogPost: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'blogPostId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg'
            }
        },
        ConfluenceWhiteboard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'whiteboardId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceDatabase: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'databaseId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/database.svg'
            }
        },
        ConfluenceEmbed: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'embedId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/embed.svg'
            }
        },
        ConfluenceComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceFooterComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceInlineComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        JiraIssue: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                objectTypeName: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'
                ],
                icon: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'key'
                ]
            }
        },
        JiraPlatformComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        JiraServiceManagementComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        TrelloBoard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'boardName'
                ],
                url: [
                    'boardUrl'
                ],
                containers: [
                    'workspace.displayName'
                ],
                deduplicateId: [
                    'objectId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/trello/board.svg'
            }
        },
        TrelloCard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'cardName'
                ],
                url: [
                    'cardUrl'
                ],
                containers: [
                    'list.name',
                    'list.board.name'
                ],
                deduplicateId: [
                    'objectId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/trello/card.svg'
            }
        },
        DevOpsDocument: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'webUrl'
                ],
                icon: [
                    'type.iconUrl'
                ]
            }
        },
        DevOpsPullRequestDetails: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                url: [
                    'url'
                ],
                containers: [
                    'repositoryName'
                ],
                key: [
                    'providerName'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/pull-request.svg'
            }
        },
        DevOpsDesign: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'webUrl'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/design.svg'
            }
        },
        ExternalDocument: {
            hydratorPaths: {
                id: [
                    'thirdPartyId'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                subtype: [
                    'type.category'
                ],
                key: [
                    'parent.displayName'
                ],
                containers: [
                    'createdBy.thirdPartyUser.name'
                ],
                creator: [
                    'createdBy.thirdPartyUser.name'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/document.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        ExternalRemoteLink: {
            hydratorPaths: {
                id: [
                    'thirdPartyId'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                subtype: [
                    'category'
                ],
                containers: [
                    'createdBy.thirdPartyUser.name'
                ],
                creator: [
                    'createdBy.thirdPartyUser.name'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/document.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        MercuryFocusArea: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                key: [
                    'focusAreaType.name'
                ],
                icon: [
                    'icon.url'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/mercury/focus-area.svg'
            }
        },
        MercuryPortfolio: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                key: [
                    'label'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/mercury/view.svg'
            }
        },
        CompassComponent: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'typeMetadata.iconUrl'
                ],
                key: [
                    'typeMetadata.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/compass/logo.svg'
            }
        },
        BitbucketPullRequest: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'pullRequestTitle'
                ],
                url: [
                    'href'
                ],
                key: [
                    'pullRequestTitle'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/bitbucket/logo.svg'
            }
        },
        LoomVideo: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'loomUrl'
                ],
                key: [
                    'owner.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/loom/logo.svg'
            }
        },
        AssetsObject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'label'
                ],
                key: [
                    'displayTypename'
                ],
                url: [
                    'links.web'
                ],
                icon: [
                    'avatar.url48'
                ],
                containers: [
                    'objectType.schema.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        },
        AssetsObjectType: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'assetsObjectTypeName'
                ],
                key: [
                    'displayTypename'
                ],
                url: [
                    'links.web'
                ],
                icon: [
                    'assetsObjectTypeIcon.url48'
                ],
                containers: [
                    'schema.assetsSchemaName'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        },
        AssetsSchema: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'assetsSchemaName'
                ],
                key: [
                    'displayTypename'
                ],
                url: [
                    'links.web'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        }
    },
    queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n    status {\n      value\n      score\n    }\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n    state {\n      value\n    }\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    subtype\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceWhiteboard on ConfluenceWhiteboard {\n    id\n    title\n    whiteboardId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceDatabase on ConfluenceDatabase {\n    id\n    title\n    databaseId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceEmbed on ConfluenceEmbed {\n    id\n    title\n    embedId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    name\n    avatar {\n      medium\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment trelloBoard on TrelloBoard {\n  id\n  objectId\n  boardName: name\n  boardUrl: url\n  workspace {\n    id\n    displayName\n  }\n}\n\n\nfragment trelloCard on TrelloCard {\n  id\n  objectId\n  cardName: name\n  cardUrl: url\n  list {\n    id\n    name\n    board @optIn(to: "TrelloListBoard") {\n      id\n      name\n    }\n  }\n}\n\n\n        fragment graphDevOpsDocument on DevOpsDocument {\n          id\n          displayName\n          webUrl: url\n          type {\n            iconUrl\n          }\n        }\n    \n\n        fragment graphExternalDocument on ExternalDocument {\n            id\n            type {\n                category\n            }\n            displayName\n            parent @optIn(to: "ExternalDataDepotQueryV2"){\n                ...on ExternalDocument {\n                    displayName\n                }\n            }\n            url\n            provider {\n                providerId\n            }\n            createdBy {\n                thirdPartyUser {\n                    name\n                }\n            }\n            thirdPartyId\n        }\n    \n\nfragment graphPullRequest on DevOpsPullRequestDetails {\n  id\n  title\n  url\n  repositoryName\n  providerName\n}\n\n\nfragment graphDesign on DevOpsDesign {\n  id\n  displayName\n  webUrl: url\n}\n\n\n        fragment graphExternalRemoteLink on ExternalRemoteLink {\n            id\n            displayName\n            category\n            createdBy {\n                thirdPartyUser {\n                    name\n                }\n            }\n            url\n            provider {\n                providerId\n            }\n            thirdPartyId\n        }\n    \n\n    fragment mercuryFocusArea on MercuryFocusArea {\n        id\n        name\n        url\n        focusAreaType {\n            name\n        }\n        icon {\n            url\n        }\n    }\n    \n\n    fragment mercuryPortfolio on MercuryPortfolio {\n        id\n        name\n        url\n        label\n    }\n    \n\nfragment compassComponent on CompassComponent {\n  id\n  name\n  url\n  typeMetadata {\n    iconUrl\n    name\n  }\n}\n\n\nfragment bitbucketPullRequest on BitbucketPullRequest {\n  id\n  pullRequestTitle: title\n  href\n  author {\n    picture\n  }\n}\n\n\nfragment loomVideo on LoomVideo {\n  id\n  name\n  loomUrl: url\n  owner {\n    name\n    picture\n  }\n}\n\n\n    fragment assetsObject on AssetsObject {\n      id\n      label\n      objectKey\n      links {\n        web\n      }\n      avatar {\n        url48\n      }\n      objectType {\n        name\n        schema {\n          name\n        }\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\n\n    fragment assetsObjectType on AssetsObjectType {\n      id\n      assetsObjectTypeName: name\n      links {\n        web\n      }\n      assetsObjectTypeIcon: icon {\n        url48\n      }\n      schema {\n        id\n        assetsSchemaName: name\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\n\n    fragment assetsSchema on AssetsSchema {\n      id\n      assetsSchemaKey: key\n      assetsSchemaName: name\n      links {\n        web\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceWhiteboard\n\t...confluenceDatabase\n\t...confluenceEmbed\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n\t...trelloBoard\n\t...trelloCard\n\t...graphDevOpsDocument\n\t...graphExternalDocument\n\t...graphPullRequest\n\t...graphDesign\n\t...graphExternalRemoteLink\n\t...mercuryFocusArea\n\t...mercuryPortfolio\n\t...compassComponent\n\t...bitbucketPullRequest\n\t...loomVideo\n\t...assetsObject\n\t...assetsObjectType\n\t...assetsSchema\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};

});

parcelRegister("dB4CM", function(module, exports) {

var $42tRz = parcelRequire("42tRz");

const $ed61875d80ed744a$var$errorHandlerMap = new Map([
    [
        'ValidationError',
        (0, $42tRz.default)
    ]
]);
const $ed61875d80ed744a$var$graphQLErrorHandler = (err)=>{
    const errorHandler = $ed61875d80ed744a$var$errorHandlerMap.get(err.extensions.classification);
    if (typeof errorHandler === 'function') return errorHandler(err);
    return null;
};
var $ed61875d80ed744a$export$2e2bcd8739ae039 = $ed61875d80ed744a$var$graphQLErrorHandler;
module.exports["default"] = $ed61875d80ed744a$export$2e2bcd8739ae039;

});

parcelRegister("42tRz", function(module, exports) {
/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */ const $67eeec4a0df79f16$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
const $67eeec4a0df79f16$var$validationErrorHandler = (graphQLError)=>{
    const invalidFragmentMatch = $67eeec4a0df79f16$var$captureRegex.exec(graphQLError.message);
    if (Array.isArray(invalidFragmentMatch)) {
        const invalidFragment = invalidFragmentMatch[1];
        if (invalidFragment) return invalidFragment;
    }
    return null;
};
var $67eeec4a0df79f16$export$2e2bcd8739ae039 = $67eeec4a0df79f16$var$validationErrorHandler;
module.exports["default"] = $67eeec4a0df79f16$export$2e2bcd8739ae039;

});

parcelRegister("9t27K", function(module, exports) {

var $9M6Bq = parcelRequire("9M6Bq");


var $tyUdU = parcelRequire("tyUdU");

const $54cb9195043b6c70$var$ACTIVITIES_LIMIT = 50;
const $54cb9195043b6c70$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $54cb9195043b6c70$var$VIEWED__QUERY = `
   viewed(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $54cb9195043b6c70$var$ALL__QUERY = `
    all(first: $first, filter: $filter) {
      ...activityItemConnection
    }
`;
const $54cb9195043b6c70$var$activityQueryMap = new Map([
    [
        'workedOn',
        $54cb9195043b6c70$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $54cb9195043b6c70$var$VIEWED__QUERY
    ],
    [
        'all',
        $54cb9195043b6c70$var$ALL__QUERY
    ]
]);
const $54cb9195043b6c70$var$getMyActivitiesQuery = (queries)=>`
      myActivity {
        ${queries.join('\n')}
      }
`;
const $54cb9195043b6c70$var$getActivitiesQuery = (product, content, fragments, activityFilterType = 'ActivityFilter')=>`
    query ${(0, $9M6Bq.getOperationName)(product)}($first: Int, $filter: ${activityFilterType}) {
      activity {
        ${content}
      }
    }
${fragments}
`;
const $54cb9195043b6c70$export$855cd08371c65b8c = (product, filters, activityQueries, fragments)=>{
    /**
	 * If we are filtering by `actors` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $54cb9195043b6c70$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$54cb9195043b6c70$var$activityQueryMap.get(query)).join('\n'), fragments, 'ActivityFilter'),
            queryFilters: (0, $tyUdU.ACTIVITY_FILTER_COLLECTION).v3.get('activities')(filters)
        };
    } else return {
        query: $54cb9195043b6c70$var$getActivitiesQuery(product, $54cb9195043b6c70$var$getMyActivitiesQuery(activityQueries.map((query)=>$54cb9195043b6c70$var$activityQueryMap.get(query))), fragments, 'MyActivityFilter'),
        queryFilters: (0, $tyUdU.ACTIVITY_FILTER_COLLECTION).v3.get('myActivity')(filters)
    };
};
const $54cb9195043b6c70$export$7489a6ef09862e48 = (product, filters, activityQueries, fragments)=>{
    const { limit: // we want to default limit if not applied
    limit = $54cb9195043b6c70$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    const { query: query, queryFilters: queryFilters } = $54cb9195043b6c70$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments);
    return {
        operationName: (0, $9M6Bq.getOperationName)(product),
        query: query,
        variables: {
            first: limit,
            filter: queryFilters
        }
    };
};
module.exports["generateGraphQLRequest"] = $54cb9195043b6c70$export$7489a6ef09862e48;

});

parcelRegister("2OHoP", function(module, exports) {

var $fBDYu = parcelRequire("fBDYu");

function $f8c057548f88677e$export$750d93207e30f59a(activitiesData) {
    const { all: all, viewed: viewed, workedOn: workedOn } = activitiesData;
    return {
        all: $f8c057548f88677e$var$rollUpActivityItems(all),
        viewed: $f8c057548f88677e$var$rollUpActivityItems(viewed),
        workedOn: $f8c057548f88677e$var$rollUpActivityItems(workedOn)
    };
}
function $f8c057548f88677e$var$rollUpActivityItems(activityItems) {
    // https://stackoverflow.com/a/49460534
    // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
    const latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce((acc, activityItem)=>{
        const deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
        const existingItem = acc[deduplicateId];
        if (existingItem) {
            const aggregatedItems = existingItem.aggregatedActivityItems || [];
            if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                activityItem.aggregatedActivityItems = [
                    ...aggregatedItems,
                    existingItem
                ];
                // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
                delete acc[deduplicateId];
                acc[deduplicateId] = activityItem;
            } else acc[deduplicateId].aggregatedActivityItems = [
                ...aggregatedItems,
                activityItem
            ];
        } else acc[deduplicateId] = activityItem;
        return acc;
    }, {});
    return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}
const $f8c057548f88677e$export$213ba2e9f2d143b9 = (key)=>{
    return new RegExp(`fragment ${$f8c057548f88677e$var$fragmentName(key)} on ${$f8c057548f88677e$var$fragmentType(key)} ({(.|\\n)+?(?=fragment))`, 'gm');
};
const $f8c057548f88677e$var$fragmentName = (key)=>key.charAt(0).toLowerCase() + key.slice(1);
const $f8c057548f88677e$var$fragmentType = (key)=>key.charAt(0).toUpperCase() + key.slice(1);
const $f8c057548f88677e$export$ea55e8e0446efa94 = (activity)=>{
    if (activity.myActivity) return activity.myActivity;
    return activity;
};
const $f8c057548f88677e$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
const $f8c057548f88677e$var$containerMapTypes = new Map([
    [
        $f8c057548f88677e$var$SITE_ARI_PREFIX,
        'SITE'
    ]
]);
function $f8c057548f88677e$export$788e6013936a6bb4(rootContainerARI) {
    // the "ID" portion of the ARI begins after the first '/'
    const ariSplitIndex = rootContainerARI.indexOf('/');
    return {
        ari: rootContainerARI,
        id: rootContainerARI.slice(ariSplitIndex + 1),
        type: $f8c057548f88677e$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
    };
}
function $f8c057548f88677e$export$e8f56bed6776c7ea(filters) {
    return {
        ...filters,
        // These have V high cardinality, so using a length
        actors: filters.actors?.length,
        containerIds: filters.containerIds?.length,
        // comma separated lists
        products: filters.products?.join(','),
        eventTypes: filters.eventTypes?.join(','),
        objectTypes: filters.objectTypes?.join(','),
        rootContainerIds: filters.rootContainerIds?.join(',')
    };
}
/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */ const $f8c057548f88677e$var$RESTRICTED_FRAGMENTS = [
    'activity',
    'all',
    'myActivity',
    'workedOn',
    'viewed',
    'activityItemConnection',
    'activityItemEdge'
];
function $f8c057548f88677e$export$e22863ec502608d2(invalidFragments, allFragments) {
    return invalidFragments.filter((fragment)=>!$f8c057548f88677e$var$RESTRICTED_FRAGMENTS.includes(fragment)).reduce((acc, invalidFragment)=>{
        return acc.replace(new RegExp(`...${invalidFragment}\n`, 'g'), '').replace($f8c057548f88677e$export$213ba2e9f2d143b9(invalidFragment), '');
    }, allFragments);
}
const $f8c057548f88677e$var$IGNORED_ERROR_CLASSIFICATIONS = [
    'IncorrectAuthException'
];
function $f8c057548f88677e$export$c939d6148e47244a(response) {
    if (!response?.data || !Array.isArray(response.errors)) return false;
    const filteredAggErrors = response.errors.filter((e)=>!e.extensions.classification || !$f8c057548f88677e$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification));
    return filteredAggErrors.length > 0 && $f8c057548f88677e$export$884573c560ed3600(response.data);
}
function $f8c057548f88677e$export$884573c560ed3600(queryData) {
    return !queryData.activity || $f8c057548f88677e$export$ea55e8e0446efa94(queryData.activity).all?.edges?.length === 0 && $f8c057548f88677e$export$ea55e8e0446efa94(queryData.activity).workedOn?.edges?.length === 0 && queryData.activity?.myActivity?.viewed?.edges?.length === 0;
}
function $f8c057548f88677e$export$618af76292d5645c(object) {
    const ari = object.id;
    let product = 'graph';
    if (ari.startsWith('ari:cloud:graph::pull-request') && object.data?.providerName) product = object.data?.providerName || 'graph';
    else if ((0, $fBDYu.isThirdPartyARI)(ari)) product = (0, $fBDYu.parseThirdPartyProduct)(ari).split('.')[1];
    return product.toLowerCase();
}
module.exports["rollupActivitiesData"] = $f8c057548f88677e$export$750d93207e30f59a;
module.exports["activityRoot"] = $f8c057548f88677e$export$ea55e8e0446efa94;
module.exports["parseRootContainerARI"] = $f8c057548f88677e$export$788e6013936a6bb4;
module.exports["filtersToMetadata"] = $f8c057548f88677e$export$e8f56bed6776c7ea;
module.exports["filterInvalidFragments"] = $f8c057548f88677e$export$e22863ec502608d2;
module.exports["isEmptyActivitiesWithErrorsResponse"] = $f8c057548f88677e$export$c939d6148e47244a;
module.exports["getThirdPartyGraphProvider"] = $f8c057548f88677e$export$618af76292d5645c;

});

parcelRegister("fBDYu", function(module, exports) {
const $3421cba56261eeed$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $3421cba56261eeed$export$4578ef3572b21f34 = (ari)=>{
    const result = $3421cba56261eeed$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$3421cba56261eeed$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner] = result;
    return resourceOwner;
};
const $3421cba56261eeed$export$fccbae65febb6fd4 = (ari)=>$3421cba56261eeed$var$thirdPartyRegex.test(ari);
module.exports["parseThirdPartyProduct"] = $3421cba56261eeed$export$4578ef3572b21f34;
module.exports["isThirdPartyARI"] = $3421cba56261eeed$export$fccbae65febb6fd4;

});

parcelRegister("2S07V", function(module, exports) {
class $73d177391dbdc800$export$16bbef74695765fd extends Error {
    constructor(message, status){
        super(message);
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        this.status = void 0;
        Object.setPrototypeOf(this, $73d177391dbdc800$export$16bbef74695765fd.prototype);
        this.status = status;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
module.exports["ActivityError"] = $73d177391dbdc800$export$16bbef74695765fd;

});

parcelRegister("9EvUR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $dJyLC = parcelRequire("dJyLC");

function $9c03756095734add$export$e412939fa65e9b05({ contentId: contentId, spaceKey: spaceKey, source: source }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return (0, $42omo.useMemo)(()=>Promise.resolve((0, $dJyLC.createConfluenceAutoformattingProvider)(spaceKey, contentId, createAnalyticsEvent, source)), [
        contentId,
        createAnalyticsEvent,
        spaceKey,
        source
    ]);
}
module.exports["useAutoformattingProvider"] = $9c03756095734add$export$e412939fa65e9b05;

});

parcelRegister("dJyLC", function(module, exports) {
const $80210b0d46d06b49$var$_isBlankOrEmpty = (str)=>!str || /^\s*$/.test(str);
const $80210b0d46d06b49$var$_sendAnalyticsEvent = (site, contentId, action, reason, createAnalyticsEvent, caller)=>{
    if (createAnalyticsEvent) createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'autoformat',
            actionSubjectId: 'undefinedLink autoformat',
            source: 'AutoformattingProvider',
            attributes: {
                site: site,
                contentId: contentId,
                reason: reason,
                caller: caller
            }
        }
    }).fire();
};
const $80210b0d46d06b49$export$79f57d12dd4f5b6b = (spaceKey, contentId, createAnalyticsEvent, caller)=>({
        '\\[(.*?)\\]\\(\\)': (match)=>{
            // If testing locally, you will need to set 'site' to an actual server such as "https://pug.jira-dev.com". Smart cards don't work with "localhost:8080".
            const site = location.origin;
            const title = match[1];
            if ($80210b0d46d06b49$var$_isBlankOrEmpty(title)) {
                $80210b0d46d06b49$var$_sendAnalyticsEvent(site, contentId, 'failed', 'empty title', createAnalyticsEvent, caller);
                return Promise.resolve({
                    type: ''
                });
            }
            if (!site || !spaceKey || !contentId) {
                $80210b0d46d06b49$var$_sendAnalyticsEvent(site, contentId, 'failed', 'missing site name, spaceKey or contentId', createAnalyticsEvent, caller);
                return Promise.resolve({
                    type: ''
                });
            }
            const encodedTitle = encodeURIComponent(title);
            const url = `${site}/wiki/pages/createpage.action?spaceKey=${spaceKey}&title=${encodedTitle}&linkCreation=true&fromPageId=${contentId}`;
            $80210b0d46d06b49$var$_sendAnalyticsEvent(site, contentId, 'success', 'autoformat succeeded', createAnalyticsEvent, caller);
            return Promise.resolve({
                type: 'inlineCard',
                attrs: {
                    url: url
                }
            });
        }
    });
const $80210b0d46d06b49$export$56f76dd14b7b11cc = (spaceKey, contentId, createAnalyticsEvent, caller)=>({
        getRules: ()=>Promise.resolve({
                ...$80210b0d46d06b49$export$79f57d12dd4f5b6b(spaceKey, contentId, createAnalyticsEvent, caller)
            })
    });
module.exports["createConfluenceAutoformattingProvider"] = $80210b0d46d06b49$export$56f76dd14b7b11cc;

});

parcelRegister("98Cy1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5UhfH = parcelRequire("5UhfH");

function $c1b5771e8fcb5e0a$export$de773409fd90c392(spaceId, objectId, product = 'confluence') {
    const [contextIdentProvider, setContextIdentProvider] = (0, $42omo.useState)(undefined);
    const spaceIdPromise = (0, $5UhfH.useSpaceIdPromise)(spaceId);
    (0, $42omo.useEffect)(()=>{
        setContextIdentProvider(spaceIdPromise.then((containerId)=>{
            return {
                containerId: containerId,
                objectId: objectId,
                product: product
            };
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        spaceId,
        objectId,
        product
    ]);
    return contextIdentProvider;
}
module.exports["useContextIdentifierProvider"] = $c1b5771e8fcb5e0a$export$de773409fd90c392;

});

parcelRegister("5UhfH", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $6f81802f32398f24$export$49fef1783eef7e2a(spaceId) {
    const resolveFnRef = (0, $42omo.useRef)(null);
    const spaceIdPromiseRef = (0, $42omo.useRef)(null);
    if (!spaceIdPromiseRef.current) spaceIdPromiseRef.current = new Promise((resolve)=>{
        resolveFnRef.current = resolve;
    });
    (0, $42omo.useEffect)(()=>{
        if (spaceId || spaceId === '') resolveFnRef.current(spaceId);
    }, [
        spaceId
    ]);
    return spaceIdPromiseRef.current;
}
module.exports["useSpaceIdPromise"] = $6f81802f32398f24$export$49fef1783eef7e2a;

});

parcelRegister("1NbQn", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $53f32890288a0cee$export$72a52078406bf49d({ isUnpublishedDraft: isUnpublishedDraft, contentType: contentType, editorActions: editorActions, editorType: editorType, initialShouldFocusEditor: initialShouldFocusEditor = true }) {
    // TODO: replace some of these arbitrary state values from graphQL query
    /**
	 * @todo CTE-268 typing in title is slow with in-editor templates (long term solution)
	 * For now, we are solving this by debouncing calls to the onTitleChange function inside EditorTitle
	 * Debouncing has some drawbacks for collaborators, so we only want this optimization when
	 * the template panel could be open
	 */ const debounceTitleChangeUpdates = isUnpublishedDraft && contentType === 'page';
    const isTemplateEditor = editorType === 'template';
    const [isTitleFocused, setIsTitleFocused] = (0, $42omo.useState)(null);
    const [shouldFocusEditor, setShouldFocusEditor] = (0, $42omo.useState)(initialShouldFocusEditor);
    // This function is only called when "tab" or "enter" is pressed when focused in the title
    const focusEditor = (0, $42omo.useCallback)(()=>{
        setIsTitleFocused(false);
        setShouldFocusEditor(true);
    }, []);
    const onFocusChanged = (0, $42omo.useCallback)((_isTitleFocused)=>{
        setIsTitleFocused(_isTitleFocused);
        // we disable editor when title is focused
        // re-enabling editor leads to force focus set on it
        // this leads to focus bugs when clicking on other inputs
        // so we explicitly disable editor focus here
        setShouldFocusEditor(false);
    }, []);
    (0, $42omo.useEffect)(()=>{
        // focus editor ONLY when forced to.
        // Losing title focus should NOT require forcing an editor focus
        // (in the case of backtabbing or clicking on a different button)
        // TODO: CTE-2423 remove editorType check once Confluence adopts editor version Rambo (with media focus bug fix)
        if (!isTitleFocused && shouldFocusEditor && !isTemplateEditor) editorActions.focus({
            scrollIntoView: false
        });
    }, [
        editorActions,
        isTitleFocused,
        shouldFocusEditor,
        isTemplateEditor
    ]);
    return (0, $42omo.useMemo)(()=>({
            isTitleFocused: isTitleFocused,
            shouldFocusEditor: shouldFocusEditor,
            debounceTitleChangeUpdates: debounceTitleChangeUpdates,
            focusEditor: focusEditor,
            onFocusChanged: onFocusChanged
        }), [
        isTitleFocused,
        shouldFocusEditor,
        debounceTitleChangeUpdates,
        focusEditor,
        onFocusChanged
    ]);
}
module.exports["useEditorTitleFocus"] = $53f32890288a0cee$export$72a52078406bf49d;

});

parcelRegister("fBnV3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");

const $189947004745ce10$export$d8065178219c808a = (flags)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return (0, $42omo.useCallback)(()=>{
        flags.showErrorFlag({
            title: formatMessage({
                id: "collab.status.error"
            }),
            description: formatMessage({
                id: "collab.status.tooltip.error"
            })
        });
    }, [
        flags,
        formatMessage
    ]);
};
module.exports["useHandleCollabError"] = $189947004745ce10$export$d8065178219c808a;

});

parcelRegister("7ZQNA", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $270318977b9095e1$export$89183b1b5e58f33c = (0, $eSUdr.default)`query CollabDraftQuery($id:ID!$draftShareId:String=""$hydrateAdf:Boolean){collabDraft(id:$id draftShareId:$draftShareId hydrateAdf:$hydrateAdf){document version metadata{title}}}`;
module.exports["CollabDraftQuery"] = $270318977b9095e1$export$89183b1b5e58f33c;

});

parcelRegister("bjxK7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $bQm3c = parcelRequire("bQm3c");


var $2vVvv = parcelRequire("2vVvv");


var $iP9x4 = parcelRequire("iP9x4");


var $4IoVL = parcelRequire("4IoVL");


var $gXrHX = parcelRequire("gXrHX");


var $cLo2u = parcelRequire("cLo2u");


var $e2Vf0 = parcelRequire("e2Vf0");

const $8ad336116c673b49$export$74fedad14355d824 = ({ contentId: contentId, contentType: contentType, editorAPI: editorAPI, flags: flags, viewMode: viewMode })=>{
    const intl = (0, $8C5kA.default)();
    const { featureFlags: featureFlags } = (0, $bQm3c.useSessionData)();
    const { isExternalShareRequest: isExternalShare } = (0, $42omo.useContext)((0, $gXrHX.ExternalShareContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const ssrMediaConfig = (0, $iP9x4.useMediaSSRModeAndAuthConfig)({
        contentId: contentId,
        spaceKey: spaceKey ?? undefined,
        isExternalShare: isExternalShare
    });
    const resolver = (0, $42omo.useRef)();
    // Keep most recent option values so dynamic provider getters don't close over stale ones
    const latestParamsRef = (0, $42omo.useRef)({
        contentId: contentId,
        spaceKey: spaceKey,
        isExternalShare: isExternalShare,
        contentType: contentType,
        viewMode: viewMode
    });
    latestParamsRef.current = {
        contentId: contentId,
        spaceKey: spaceKey,
        isExternalShare: isExternalShare,
        contentType: contentType,
        viewMode: viewMode
    };
    const showAttachmentLimitReachedFlag = (0, $42omo.useCallback)((data)=>{
        if (flags && data) flags.showErrorFlag((0, $2vVvv.getAttachmentSizeLimitErrorFlag)(data, intl)).then(()=>{
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'nextEditorAttachmentTooLargeFlag'
                }
            }).fire();
        });
        return !!data;
    }, [
        flags,
        intl,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!contentId) return;
        const createMediaProvider = ()=>{
            if (viewMode) return (0, $dh538.fg)('confluence_frontend_transition_preloading_system') ? (0, $4IoVL.createRendererMediaProviderDynamic)(()=>({
                    contentId: latestParamsRef.current.contentId,
                    spaceKey: latestParamsRef.current.spaceKey,
                    isExternalShare: latestParamsRef.current.isExternalShare
                })) : (0, $4IoVL.createRendererMediaProvider)({
                contentId: contentId,
                spaceKey: spaceKey,
                isExternalShare: isExternalShare
            });
            if (contentType) return (0, $dh538.fg)('confluence_frontend_transition_preloading_system') ? (0, $4IoVL.createEditorMediaProviderDynamic)(()=>({
                    contentId: latestParamsRef.current.contentId,
                    spaceKey: latestParamsRef.current.spaceKey,
                    contentType: latestParamsRef.current.contentType,
                    isExternalShare: latestParamsRef.current.isExternalShare,
                    // Passing undefined will allow us to use the default atlaskit size limit error behavior
                    onUploadRejection: flags ? showAttachmentLimitReachedFlag : undefined
                })) : (0, $4IoVL.createEditorMediaProvider)({
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: contentType,
                isExternalShare: isExternalShare,
                // Passing undefined will allow us to use the default atlaskit size limit error behavior
                onUploadRejection: flags ? showAttachmentLimitReachedFlag : undefined
            });
        };
        const mediaProvider = createMediaProvider();
        if (mediaProvider) {
            editorAPI?.media?.actions.setProvider(mediaProvider);
            if (resolver.current) resolver.current(mediaProvider);
        }
    }, [
        contentId,
        contentType,
        spaceKey,
        isExternalShare,
        viewMode,
        flags,
        showAttachmentLimitReachedFlag,
        featureFlags,
        editorAPI
    ]);
    const ssrMediaProvider = (0, $42omo.useMemo)(()=>{
        return undefined;
    }, [
        ssrMediaConfig
    ]);
    // IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/mediaPluginOptions/mediaPluginOptions.ts
    return (0, $42omo.useMemo)(()=>(0, $e2Vf0.getMediaOptions)({
            mediaProvider: new Promise((resolve)=>resolver.current = resolve),
            ssrMediaProvider: ssrMediaProvider,
            intl: intl,
            featureFlags: featureFlags
        }), [
        resolver,
        intl,
        featureFlags,
        ssrMediaProvider
    ]);
};
module.exports["useMediaOptions"] = $8ad336116c673b49$export$74fedad14355d824;

});

parcelRegister("2vVvv", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $57725dc45b51a081$var$attachmentSizeErrorFlagI18n = (0, $cgtv4.defineMessages)({
    errorTitle: {
        id: "fabric-media-support.attachment-size-limit-error.title",
        defaultMessage: "{fileName} is too large to upload"
    },
    errorDescription: {
        id: "fabric-media-support.attachment-size-limit-error.description",
        defaultMessage: "Attachments must be {size} or less."
    },
    learnMore: {
        id: "fabric-media-support.attachment-size-limit-error.learn-more",
        defaultMessage: "Learn more"
    }
});
const $57725dc45b51a081$var$sizeLimitLearnMoreLink = 'https://support.atlassian.com/confluence-cloud/docs/upload-a-file/';
const $57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n = (0, $cgtv4.defineMessages)({
    errorTitle: {
        id: "fabric-media-support.attachment-zero-byte-error.title",
        defaultMessage: "{fileName} is empty (zero bytes)"
    },
    errorDescription: {
        id: "fabric-media-support.attachment-zero-byte.description",
        defaultMessage: "Attachments must be at least 1 byte of size"
    }
});
const $57725dc45b51a081$export$f2d538a5633fea72 = (bytes, maxMagnitude)=>{
    if (bytes <= 0) return '0 bytes';
    const k = 1024;
    const decimals = 2;
    const units = [
        'bytes',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
    ];
    let maxIndex = units.length - 1;
    let exponent = Math.floor(Math.log(bytes) / Math.log(k));
    if (maxMagnitude && maxMagnitude < maxIndex) maxIndex = maxMagnitude;
    exponent = exponent > maxIndex ? maxIndex : exponent;
    return `${parseFloat((bytes / Math.pow(k, exponent)).toFixed(decimals))} ${units[exponent]}`;
};
const $57725dc45b51a081$export$1c61cf0ed486df46 = (data, intl)=>{
    if (data.reason === 'fileSizeLimitExceeded') return {
        title: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.errorTitle, {
            fileName: data.fileName
        }),
        description: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.errorDescription, {
            size: $57725dc45b51a081$export$f2d538a5633fea72(data.limit)
        }),
        actions: [
            {
                content: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.learnMore),
                onClick: ()=>{
                    window.open($57725dc45b51a081$var$sizeLimitLearnMoreLink, '_blank');
                }
            }
        ]
    };
    else return {
        title: intl.formatMessage($57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n.errorTitle, {
            fileName: data.fileName
        }),
        description: intl.formatMessage($57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n.errorDescription)
    };
};
module.exports["getAttachmentSizeLimitErrorFlag"] = $57725dc45b51a081$export$1c61cf0ed486df46;

});

parcelRegister("iP9x4", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $5yfLD = parcelRequire("5yfLD");


var $4h1jl = parcelRequire("4h1jl");


var $9wGTI = parcelRequire("9wGTI");


var $4IoVL = parcelRequire("4IoVL");

const $2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR = 'mediaProvider unavailable, must use initialAuth';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $2c59df77bd212c3d$var$isServerEnvironment = ()=>undefined;
const $2c59df77bd212c3d$var$isClientEnvironment = ()=>window.__SSR_RENDERED__;
const $2c59df77bd212c3d$var$getInitialAuth = (config)=>{
    const recordedAuth = (0, $4h1jl.mediaConfigRecorder)?.get();
    if (!recordedAuth) return undefined;
    return {
        ...recordedAuth,
        // If the mediaToken is provided in the config, use it.
        // This ensures the correct token is used in cases where the token differs from
        // the initial page, such as media included through an `include` macro.
        token: config?.mediaToken || recordedAuth.token
    };
};
const $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy = ()=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const shouldEnforceDataSecurityPolicy = (0, $4h1jl.mediaConfigEnforceDSPRecorder)?.get();
    return !!shouldEnforceDataSecurityPolicy;
};
const $2c59df77bd212c3d$var$getServerModeConfig = (config)=>({
        mode: 'server',
        config: {
            authProvider: ()=>Promise.reject(new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR)),
            initialAuth: $2c59df77bd212c3d$var$getInitialAuth(config),
            enforceDataSecurityPolicy: $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy()
        }
    });
const $2c59df77bd212c3d$var$createClientAuthProvider = ({ contentId: contentId, spaceKey: spaceKey, isExternalShare: isExternalShare, mediaToken: mediaToken })=>async (authContext)=>{
        if (!!contentId && !!spaceKey) {
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentId: contentId,
                spaceKey: spaceKey,
                isExternalShare: isExternalShare,
                mediaToken: mediaToken
            });
            return viewMediaClientConfig.authProvider(authContext);
        } else throw new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR);
    };
const $2c59df77bd212c3d$var$getClientModeConfig = (config)=>({
        mode: 'client',
        config: {
            authProvider: $2c59df77bd212c3d$var$createClientAuthProvider(config),
            initialAuth: window.__MEDIA_CONFIG__,
            enforceDataSecurityPolicy: window.__MEDIA_CONFIG_ENFORCE_DSP__
        }
    });
const $2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig = (config)=>{
    if ($2c59df77bd212c3d$var$isServerEnvironment()) return $2c59df77bd212c3d$var$getServerModeConfig(config);
    else if ($2c59df77bd212c3d$var$isClientEnvironment()) return $2c59df77bd212c3d$var$getClientModeConfig(config);
};
const $2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfigMemoized = (0, $2XqLN.default)($2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig, (0, (/*@__PURE__*/$parcel$interopDefault($5yfLD))));
const $2c59df77bd212c3d$export$45c8e19bd67cadee = (config)=>{
    return $2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfigMemoized(config);
};
module.exports["useMediaSSRModeAndAuthConfig"] = $2c59df77bd212c3d$export$45c8e19bd67cadee;

});

parcelRegister("5yfLD", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("4h1jl", function(module, exports) {

var $2BiLx = parcelRequire("2BiLx");

const $c75b7ce9b9db2aec$export$279f2f878f49d0df = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$e125b144e38aa5db = new (0, $2BiLx.ObjectRecorder)();
module.exports["mediaConfigRecorder"] = $c75b7ce9b9db2aec$export$279f2f878f49d0df;
module.exports["mediaConfigEnforceDSPRecorder"] = $c75b7ce9b9db2aec$export$e125b144e38aa5db;

});

parcelRegister("2BiLx", function(module, exports) {
class $53dcea44a491523c$export$e411414ea02dd271 {
    set(object) {
        this.object = object;
    }
    get() {
        return this.object;
    }
    constructor(){
        this.object = null;
    }
}
module.exports["ObjectRecorder"] = $53dcea44a491523c$export$e411414ea02dd271;

});

parcelRegister("4IoVL", function(module, exports) {

var $eGqQQ = parcelRequire("eGqQQ");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $kzNtP = parcelRequire("kzNtP");


var $c4QoG = parcelRequire("c4QoG");


var $kEk2z = parcelRequire("kEk2z");


var $kQiXs = parcelRequire("kQiXs");

const $17b0f8a5b73de479$var$DEFAULT_CONFIG = {
    clientId: '',
    fileStoreUrl: ''
};
const $17b0f8a5b73de479$var$cachedGetDownloadData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, isExternalShare: isExternalShare, shareToken: shareToken })=>{
    if (isExternalShare && shareToken && (0, $6mKj3.expValEquals)('add_anonid_in_media_token', 'cohort', 'test')) {
        const tokenResponse = await (0, $kEk2z.fetchExternalContentMediaSessionToken)(shareToken);
        const tokenData = tokenResponse?.data;
        return {
            token: tokenData?.externalContentMediaSession?.accessTokens?.readOnlyToken?.value || '',
            config: tokenData?.externalContentMediaSession?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
        };
    }
    // Fallback to existing logic for backward compatibility
    const response = await (isExternalShare ? (0, $kEk2z.fetchExternalShareMediaToken) : (0, $kEk2z.fetchMediaToken))(contentId);
    const data = response?.data;
    const externalData = data?.['singleContent'];
    const content = isExternalShare ? externalData : data?.['content']?.nodes?.[0];
    return {
        token: content?.body?.atlas_doc_format?.mediaToken?.token || '',
        config: data?.mediaConfiguration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$export$6176af039388fdbf = (dataGetter)=>async ()=>{
        const data = await dataGetter();
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$da46cefd33160c4d = (viewDataGetter, uploadDataGetter)=>async (params)=>{
        // Currently, supplying upload token only for file and collection update action.
        // If no params are provided, the view token is returned.
        const isUpdateAction = !!params?.access?.find(({ type: type, actions: actions })=>(type === 'file' || type == 'collection') && actions.includes('update'));
        const data = await (isUpdateAction ? uploadDataGetter() : viewDataGetter());
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$724cb324eb7535cd = async (contextId)=>{
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = (0, $c4QoG.getTemplateMediaContextValues)(contextId);
    // template media informtion is stored slightly different in the context
    // to be able to discern which call to make
    if (collectionId || templateId) return (0, $c4QoG.getTemplateMediaAuth)({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
    const response = await (0, $kEk2z.fetchMediaToken)(contextId);
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.mediaConfiguration || {};
    return {
        clientId: clientId,
        token: response?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token || '',
        baseUrl: fileStoreUrl || ''
    };
};
const $17b0f8a5b73de479$var$cachedGetUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = options.contentType === 'comment' && options.cloudId && (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? await (0, $kEk2z.getCommentUploadToken)(options.contentId, options.cloudId) : await (0, $kEk2z.getUploadToken)(options.contentId);
    const session = response?.data?.contentMediaSession;
    return {
        token: session?.token?.value || '',
        config: session?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG,
        collectionId: session?.collection || ''
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$var$getUploadCollectionId = async (options)=>{
    const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
    return uploadData.collectionId;
};
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter = (options)=>()=>$17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
const $17b0f8a5b73de479$var$getUploadMediaClientConfig = async (options)=>({
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
        useSha256ForUploads: true
    });
const $17b0f8a5b73de479$var$cachedGetExportDspData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, spaceKey: spaceKey })=>{
    const response = await (0, $kEk2z.getIsExportEnabledForContent)(contentId, spaceKey);
    const isExportAllowed = response?.data?.dataSecurityPolicy?.isActionEnabledForContent?.allowed;
    return {
        isExportAllowed: isExportAllowed,
        exp: Date.now() + 60000
    };
}, (json)=>json.exp);
const $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy = async (options)=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const { contentId: contentId, spaceKey: spaceKey, mediaDspContentId: mediaDspContentId } = options;
    if (!(0, $9wGTI.fg)('dlp_allow_content_dsp_check_without_space_details')) {
        // Note: If you can't provide spaceKey, you can't enable downloads in media viewer
        if (!spaceKey) return true;
    }
    try {
        const relevantContentId = mediaDspContentId || contentId;
        const response = await $17b0f8a5b73de479$var$cachedGetExportDspData.getValue({
            contentId: relevantContentId,
            spaceKey: spaceKey
        });
        const isExportAllowed = response?.isExportAllowed;
        return !isExportAllowed;
    } catch (e) {
        // Fails CLOSED
        return true;
    }
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetter = (options)=>async ()=>{
        // Only pass contentId, isExternalShare, and shareToken to the cacheWithExp function
        // to avoid unnecessary re-fetching of the token if other options differ
        const authQueryOptions = {
            contentId: options.contentId,
            isExternalShare: options.isExternalShare,
            shareToken: options.shareToken
        };
        let data = await $17b0f8a5b73de479$var$cachedGetDownloadData.getValue(authQueryOptions);
        if (options.mediaToken) data = {
            ...data,
            token: options.mediaToken
        };
        // For drafts mediaToken by default is null and created once any media added to them
        // So, once publishing draft that just got media but token was cached before as `null`
        // we need to re-fetch the token without the cache
        if (!data.token) data = await $17b0f8a5b73de479$var$cachedGetDownloadData.forceGetValue(authQueryOptions);
        return data;
    };
const $17b0f8a5b73de479$export$9891be2d4fea1436 = async (options)=>{
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd
    };
};
const $17b0f8a5b73de479$export$e43b4f8676d4deae = async (options)=>({
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd
    });
const $17b0f8a5b73de479$export$39c5d94533971b79 = async (options)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$9891be2d4fea1436(options)
    });
const $17b0f8a5b73de479$export$4887a1cde0f552dc = async (options)=>{
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(options);
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$9891be2d4fea1436(options),
        $17b0f8a5b73de479$var$getUploadMediaClientConfig(options),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$e43b4f8676d4deae(options) : undefined,
        $17b0f8a5b73de479$var$getUploadCollectionId(options)
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
    };
};
const $17b0f8a5b73de479$export$c64cc28e06e9eda = (pathname)=>{
    return !!(0, $1NBp8.PDF_EXPORT_PAGE).match(pathname);
};
let $17b0f8a5b73de479$var$previousAttachUploadedMediaListener;
const $17b0f8a5b73de479$var$registerGlobalFileAddedListener = (options)=>{
    if ($17b0f8a5b73de479$var$previousAttachUploadedMediaListener) (0, $eGqQQ.globalMediaEventEmitter).off('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
    $17b0f8a5b73de479$var$previousAttachUploadedMediaListener = (0, $kQiXs.attachUploadedMedia)(options);
    (0, $eGqQQ.globalMediaEventEmitter).on('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$export$af68076132bb2083 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd
    };
};
const $17b0f8a5b73de479$export$de798661504725b9 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd
    };
};
const $17b0f8a5b73de479$export$221251ab27f63f41 = async (getOptions)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$af68076132bb2083(getOptions)
    });
const $17b0f8a5b73de479$export$e6a9b44aa174a3d4 = async (getOptions)=>{
    // We deliberately do NOT register the global listener dynamically each token fetch.
    // Instead we register once per provider creation with the then-current options snapshot.
    // If you need the listener to react to changed options, recreate the provider instead.
    const initialOptions = getOptions();
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(initialOptions);
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$af68076132bb2083(()=>getOptions()),
        (async ()=>{
            const opts = getOptions();
            return $17b0f8a5b73de479$var$getUploadMediaClientConfig(opts);
        })(),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$de798661504725b9(()=>getOptions()) : undefined,
        (async ()=>{
            const opts = getOptions();
            return $17b0f8a5b73de479$var$getUploadCollectionId(opts);
        })()
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: initialOptions.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
    };
}; /**
 * Usage sketch (React):
 * const liveOptionsRef = useRef(currentOptions);
 * liveOptionsRef.current = currentOptions; // update on changes
 * const providerPromise = useMemo(() => createEditorMediaProviderDynamic(() => liveOptionsRef.current), []);
 * editorApi.media.actions.setProvider(providerPromise);
 */ 
module.exports["createAuthProvider"] = $17b0f8a5b73de479$export$6176af039388fdbf;
module.exports["getAuthFromContext"] = $17b0f8a5b73de479$export$724cb324eb7535cd;
module.exports["getViewMediaClientConfig"] = $17b0f8a5b73de479$export$9891be2d4fea1436;
module.exports["createRendererMediaProvider"] = $17b0f8a5b73de479$export$39c5d94533971b79;
module.exports["createEditorMediaProvider"] = $17b0f8a5b73de479$export$4887a1cde0f552dc;
module.exports["controlDataExportOnCertainFeatures"] = $17b0f8a5b73de479$export$c64cc28e06e9eda;
module.exports["createRendererMediaProviderDynamic"] = $17b0f8a5b73de479$export$221251ab27f63f41;
module.exports["createEditorMediaProviderDynamic"] = $17b0f8a5b73de479$export$e6a9b44aa174a3d4;

});

parcelRegister("kzNtP", function(module, exports) {

var $9ILXP = parcelRequire("9ILXP");


var $a4TK8 = parcelRequire("a4TK8");

const $852f3734fd3706d8$var$BUFFER_MS = 60000; // refresh token 60 seconds before it expires
const $852f3734fd3706d8$var$EMPTY = [
    -Infinity,
    null,
    null
];
function $852f3734fd3706d8$export$d18015d30d3c28a4(asyncFunction, tokenOrExpInMsAccessor, tokenExpBufferInMs = $852f3734fd3706d8$var$BUFFER_MS) {
    const cache = {};
    async function getValue(arg, force) {
        // It is ok to have clashing hash because we are going to check args anyway
        // Worse case is calling fn() more often than it should
        let hash = '';
        try {
            hash = JSON.stringify(arg);
        } catch  {}
        const [exp, lastArg, lastValue] = cache[hash] || $852f3734fd3706d8$var$EMPTY;
        if (force || exp <= Date.now() || !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(lastArg, arg)) {
            const value = await asyncFunction(arg);
            let tokenOrExp = null;
            try {
                tokenOrExp = tokenOrExpInMsAccessor(value);
            } catch (e) {}
            let exp = null;
            if (tokenOrExp) {
                if (!isNaN(tokenOrExp)) exp = Number(tokenOrExp);
                else if (typeof tokenOrExp === 'string') try {
                    exp = (0, $9ILXP.default)(tokenOrExp).exp * 1000 - tokenExpBufferInMs;
                } catch (e) {}
            }
            cache[hash] = exp === null ? $852f3734fd3706d8$var$EMPTY : [
                exp,
                arg,
                value
            ];
            return value;
        }
        return lastValue;
    }
    return {
        forceGetValue: (arg)=>{
            return getValue(arg, true);
        },
        getValue: (arg)=>{
            return getValue(arg, false);
        }
    };
}
module.exports["cacheWithExp"] = $852f3734fd3706d8$export$d18015d30d3c28a4;

});

parcelRegister("9ILXP", function(module, exports) {
function $713d6dc98197981e$var$e(e) {
    this.message = e;
}
$713d6dc98197981e$var$e.prototype = new Error, $713d6dc98197981e$var$e.prototype.name = "InvalidCharacterError";
var $713d6dc98197981e$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $713d6dc98197981e$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $713d6dc98197981e$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($713d6dc98197981e$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $713d6dc98197981e$var$r(t);
    }
}
function $713d6dc98197981e$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $713d6dc98197981e$var$o(e, r) {
    if ("string" != typeof e) throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($713d6dc98197981e$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$713d6dc98197981e$export$b9721ef022f71a68.prototype = new Error, $713d6dc98197981e$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $713d6dc98197981e$export$2e2bcd8739ae039 = $713d6dc98197981e$var$o;
module.exports["default"] = $713d6dc98197981e$export$2e2bcd8739ae039;

});

parcelRegister("c4QoG", function(module, exports) {

var $kzNtP = parcelRequire("kzNtP");


var $4IoVL = parcelRequire("4IoVL");


var $7EQEd = parcelRequire("7EQEd");

// blueprints/templates in uuid form are technically a new template
const $30f3da79b755ac50$var$isBlueprint = (templateId)=>!/^[0-9]+$/.test(templateId);
const $30f3da79b755ac50$var$isNewTemplate = (templateId)=>!templateId || templateId === '';
const $30f3da79b755ac50$var$shouldUseTemplateId = (templateIds)=>templateIds.length;
const $30f3da79b755ac50$var$formatTemplateId = (templateId, isFirstLoad, isUpload)=>{
    if ($30f3da79b755ac50$var$isNewTemplate(templateId) || $30f3da79b755ac50$var$isBlueprint(templateId) && isUpload || !isFirstLoad) return [];
    else return [
        templateId
    ];
};
const $30f3da79b755ac50$var$cachedGetTemplateUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateUploadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    const session = response?.data?.templateMediaSession;
    const collectionId = session?.collections?.[0]?.value || '';
    return {
        token: session?.uploadToken?.value || '',
        config: session?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        },
        collectionId: collectionId
    };
}, (json)=>json.token);
const $30f3da79b755ac50$var$cachedGetTemplateDownloadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    return {
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        config: response?.data?.templateMediaSession?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        }
    };
}, (json)=>json.token);
const $30f3da79b755ac50$export$ea5d75839efa2930 = async (editorOptions)=>{
    const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !editorOptions.collectionId, true);
    const uploadData = await $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
        ...editorOptions,
        templateIds: templateIds,
        collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : editorOptions.collectionId
    });
    return uploadData.collectionId;
};
const $30f3da79b755ac50$export$8867d7a854cea94a = (contextId)=>{
    let collectionId, templateId, spaceKey = null;
    try {
        ({ collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = JSON.parse(contextId));
    } catch (_) {}
    return {
        collectionId: collectionId,
        templateId: templateId,
        spaceKey: spaceKey
    };
};
const $30f3da79b755ac50$export$c52d46b5239d3052 = async ({ templateId: templateId, collectionId: collectionId, spaceKey: spaceKey })=>{
    // if given a templateId the source is the renderer, otherwise it's the editor
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        templateIds: templateId ? [
            templateId
        ] : [],
        collectionId: templateId ? null : collectionId,
        spaceKey: spaceKey
    });
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.templateMediaSession?.configuration || {};
    return {
        clientId: clientId,
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        baseUrl: fileStoreUrl
    };
};
const $30f3da79b755ac50$var$getAuthFromContext = async (contextId)=>{
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = $30f3da79b755ac50$export$8867d7a854cea94a(contextId);
    // templateID = null/undefined -> not template type
    // templateId = "" -> new template
    // templateId = "2394234324" -> user modified template
    // templateId = "23j4h-23jk4h-kj2h34-kj23h4" -> new template
    if (typeof collectionId !== 'string' && typeof templateId !== 'string') // copy source is page contentType
    return (0, $4IoVL.getAuthFromContext)(contextId);
    return $30f3da79b755ac50$export$c52d46b5239d3052({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
};
const $30f3da79b755ac50$export$e7a68a11bc740f17 = (options)=>{
    return {
        authProvider: (0, $4IoVL.createAuthProvider)(async ()=>$30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue(options)),
        getAuthFromContext: $30f3da79b755ac50$var$getAuthFromContext
    };
};
const $30f3da79b755ac50$export$4f3a63958bc8e871 = (options)=>{
    return Promise.resolve({
        viewMediaClientConfig: $30f3da79b755ac50$export$e7a68a11bc740f17(options)
    });
};
const $30f3da79b755ac50$export$582e7673a587f23a = async (options)=>{
    let isFirstDownload = true;
    let collectionId = options.collectionId;
    const getEditorViewTemplateMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(async ()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, isFirstDownload, false);
                isFirstDownload = false;
                return $30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                isFirstDownload = false;
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const getTemplateMediaUploadMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !collectionId, true);
                return $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const viewMediaClientConfig = getEditorViewTemplateMediaClientConfig(options);
    const uploadMediaClientConfig = getTemplateMediaUploadMediaClientConfig(options);
    const collection = await $30f3da79b755ac50$export$ea5d75839efa2930(options);
    collectionId = collection || null;
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig
    };
};
module.exports["getTemplateUploadCollectionId"] = $30f3da79b755ac50$export$ea5d75839efa2930;
module.exports["getTemplateMediaContextValues"] = $30f3da79b755ac50$export$8867d7a854cea94a;
module.exports["getTemplateMediaAuth"] = $30f3da79b755ac50$export$c52d46b5239d3052;
module.exports["createRendererTemplateMediaProvider"] = $30f3da79b755ac50$export$4f3a63958bc8e871;
module.exports["createTemplateEditorMediaProvider"] = $30f3da79b755ac50$export$582e7673a587f23a;

});

parcelRegister("7EQEd", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $luiqu = parcelRequire("luiqu");


var $enSbc = parcelRequire("enSbc");

const $bced78bb0973f66e$export$852d9acd488f2352 = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $luiqu.TemplateMediaSessionDownloadQuery),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'network-only'
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
const $bced78bb0973f66e$export$779a7b38112a4dbb = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $enSbc.TemplateMediaSessionUploadQuery),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'no-cache'
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["getTemplateDownloadToken"] = $bced78bb0973f66e$export$852d9acd488f2352;
module.exports["getTemplateUploadToken"] = $bced78bb0973f66e$export$779a7b38112a4dbb;

});

parcelRegister("luiqu", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $440c59eac2d55b68$export$73060cbb44bbb81a = (0, $eSUdr.default)`query TemplateMediaSessionDownloadQuery($spaceKey:String$templateIds:[String]!$collectionId:String){templateMediaSession(spaceKey:$spaceKey templateIds:$templateIds collectionId:$collectionId){collections{key value}configuration{fileStoreUrl clientId}downloadToken{value duration}}}`;
module.exports["TemplateMediaSessionDownloadQuery"] = $440c59eac2d55b68$export$73060cbb44bbb81a;

});

parcelRegister("enSbc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f50e5e4b8dc0ddde$export$44b2025315083eb = (0, $eSUdr.default)`query TemplateMediaSessionUploadQuery($spaceKey:String$templateIds:[String]!$collectionId:String){templateMediaSession(spaceKey:$spaceKey templateIds:$templateIds collectionId:$collectionId){collections{key value}configuration{fileStoreUrl clientId}uploadToken{value duration}}}`;
module.exports["TemplateMediaSessionUploadQuery"] = $f50e5e4b8dc0ddde$export$44b2025315083eb;

});

parcelRegister("kEk2z", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $9ILXP = parcelRequire("9ILXP");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $9wGTI = parcelRequire("9wGTI");


var $fOjen = parcelRequire("fOjen");


var $gVyaz = parcelRequire("gVyaz");


var $1qiwK = parcelRequire("1qiwK");


var $7tJer = parcelRequire("7tJer");


var $25RVt = parcelRequire("25RVt");


var $egLSs = parcelRequire("egLSs");


var $gB1dF = parcelRequire("gB1dF");

let $0f304931c974fcbd$var$isFirstLoad = true;
const $0f304931c974fcbd$export$f3bf3f7b03608218 = (requestBody)=>{
    if (requestBody.contentType === 'comment' && (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint')) // Hard disable drag-and-drop upload functionality for comments
    return;
    // Use regular mutation for normal uploads (file browser, copy-paste, etc.)
    return (0, $egLSs.experimentalFileUploadMutate)({
        variables: requestBody
    });
};
const $0f304931c974fcbd$export$2b7fb70f168591f8 = (contentId)=>(0, $hp2SH.getApolloClient)().query({
        query: (0, $1qiwK.MediaDownloadTokenQuery),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ],
            missingContentId: !contentId
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $0f304931c974fcbd$var$isFirstLoad ? 'cache-first' : 'network-only'
    }).then(/* onFulfilled */ (value)=>{
        $0f304931c974fcbd$var$isFirstLoad = false;
        try {
            $0f304931c974fcbd$var$throttleFetchMediaTokenErrors(contentId)(value?.errors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $0f304931c974fcbd$var$throttleFetchMediaTokenErrors(contentId)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
/**
 * `fetchMediaToken` is called repetitively to renew the token before it
 * expires. If an error condition arises (because of frontend or backend), the
 * same error(s) may be reported as unhandled to our analytics and monitoring at
 * a very high rate/volume. Such repetitive reporting fron one user in one tab
 * is noisy. `throttleFetchMediaTokenErrors` attempts to reduce the noise.
 */ const $0f304931c974fcbd$var$throttleFetchMediaTokenErrors = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((_cacheKey)=>{
    /**
	 * The errors that happened last time. The `GraphQLError` instances are big
	 * and are not trivial to compare so `prevErrors` caches partial info.
	 */ let prevErrors = undefined;
    return (graphQLErrors, networkError)=>{
        // Each of `graphQLErrors` and `networkError` are reported to analytics and
        // monitoring so type of `Error` does not matter to what follows and
        // `GraphQLError` is the most convenient TypeScript type to deal with.
        if (networkError) graphQLErrors = (graphQLErrors || []).concat(networkError);
        if (graphQLErrors) {
            /**
			 * The new/current errors which will become `prevErrors` at the end of
			 * this iteration.
			 */ const nextErrors = {};
            for (const graphQLError of graphQLErrors){
                // Extract the partial, easy-to-compare, cachable info from the big
                // `GraphQLError` instance:
                const message = graphQLError.message || String(graphQLError) || graphQLError.originalError?.message || String(graphQLError.originalError);
                const { path: path } = graphQLError;
                const key = Array.isArray(path) && path.join('.') || message;
                if (key) {
                    const value = (0, $aMcHK.getStatusCode)(graphQLError) || message;
                    if (value) {
                        nextErrors[key] = value;
                        // If a similar error happened in the previous iteration, do not
                        // report it to analytics and monitoring again:
                        if (prevErrors?.[key] === value) (0, $7Sm4c.markErrorAsHandled)(graphQLError);
                    }
                }
            }
            prevErrors = nextErrors;
        } else // If `MediaDownloadTokenQuery` succeeds, report subsequent/future errors
        // even if similar ones occurred and were reported before the current
        // success - there is a meaningful change in state and it may be useful in
        // debugging.
        prevErrors = undefined;
    };
});
const $0f304931c974fcbd$export$e5e77dc812ab6e52 = (contentId)=>(0, $hp2SH.getApolloClient)().query({
        query: (0, $gVyaz.ExternalShareMediaDownloadTokenQuery),
        variables: {
            contentId: contentId
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only'
    });
const $0f304931c974fcbd$export$db4c125247d46dd = (shareToken)=>(0, $hp2SH.getApolloClient)().query({
        query: (0, $gB1dF.ExternalContentMediaSessionQuery),
        variables: {
            shareToken: shareToken
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only'
    });
const $0f304931c974fcbd$export$2b96f2ad626f63d2 = (contentId)=>(0, $hp2SH.getApolloClient)().query({
        query: (0, $7tJer.MediaUploadTokenQuery),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'no-cache'
    });
const $0f304931c974fcbd$export$de87322aceb1e609 = async (contentId)=>{
    if (!(0, $9wGTI.fg)('confluence-media-upload-token-cache')) return $0f304931c974fcbd$export$2b96f2ad626f63d2(contentId);
    const client = (0, $hp2SH.getApolloClient)();
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: data } = await client.query({
            query: (0, $7tJer.MediaUploadTokenQuery),
            variables: {
                contentId: contentId
            },
            fetchPolicy: 'cache-first'
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $9ILXP.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return client.query({
        query: (0, $7tJer.MediaUploadTokenQuery),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only'
    });
};
const $0f304931c974fcbd$export$4205291ac54c446e = async (contentId, cloudId)=>{
    const client = (0, $hp2SH.getApolloClient)();
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: data } = await client.query({
            query: (0, $7tJer.CommentMediaUploadTokenQuery),
            variables: {
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'cache-first'
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $9ILXP.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return client.query({
        query: (0, $7tJer.CommentMediaUploadTokenQuery),
        variables: {
            cloudId: cloudId,
            contentId: contentId
        },
        fetchPolicy: 'network-only'
    });
};
const $0f304931c974fcbd$export$4777fc7c5d601381 = (contentId, spaceKey)=>{
    let variables = {
        action: (0, $fOjen.DataSecurityPolicyAction).PAGE_EXPORT,
        contentId: contentId,
        contentStatus: 'CURRENT',
        contentVersion: 1
    };
    if (spaceKey) variables = {
        ...variables,
        spaceKey: spaceKey
    };
    /* Note -> relay compatible query replacement available, in @confluence/data-security package.
	 * Leaving as is for now, to preserve consistent behavior w/ this direct getApolloClient() call
	 */ // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $25RVt.DSPIsActionEnabledForContentQuery),
        variables: variables,
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'cache-first'
    });
};
module.exports["setAttachment"] = $0f304931c974fcbd$export$f3bf3f7b03608218;
module.exports["fetchMediaToken"] = $0f304931c974fcbd$export$2b7fb70f168591f8;
module.exports["fetchExternalShareMediaToken"] = $0f304931c974fcbd$export$e5e77dc812ab6e52;
module.exports["fetchExternalContentMediaSessionToken"] = $0f304931c974fcbd$export$db4c125247d46dd;
module.exports["getUploadToken"] = $0f304931c974fcbd$export$de87322aceb1e609;
module.exports["getCommentUploadToken"] = $0f304931c974fcbd$export$4205291ac54c446e;
module.exports["getIsExportEnabledForContent"] = $0f304931c974fcbd$export$4777fc7c5d601381;

});

parcelRegister("fOjen", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $50a5089b6004564c$export$852364220ec700a8 = /*#__PURE__*/ function(DataSecurityPolicyAction) {
    DataSecurityPolicyAction["APP_ACCESS"] = "APP_ACCESS";
    DataSecurityPolicyAction["PAGE_EXPORT"] = "PAGE_EXPORT";
    DataSecurityPolicyAction["PUBLIC_LINKS"] = "PUBLIC_LINKS";
    return DataSecurityPolicyAction;
}({});
var $50a5089b6004564c$export$3c5b314640ce2287 = /*#__PURE__*/ function(DataSecurityPolicyDecidableContentStatus) {
    DataSecurityPolicyDecidableContentStatus["ARCHIVED"] = "ARCHIVED";
    DataSecurityPolicyDecidableContentStatus["CURRENT"] = "CURRENT";
    DataSecurityPolicyDecidableContentStatus["DRAFT"] = "DRAFT";
    return DataSecurityPolicyDecidableContentStatus;
}({});
module.exports["DataSecurityPolicyAction"] = $50a5089b6004564c$export$852364220ec700a8;

});

parcelRegister("gVyaz", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $c52c799589981459$export$89a863448acd97ea = (0, $eSUdr.default)`query ExternalShareMediaDownloadTokenQuery($contentId:ID!){singleContent(id:$contentId){id body{atlas_doc_format{mediaToken{token}}}}mediaConfiguration{clientId fileStoreUrl}}`;
module.exports["ExternalShareMediaDownloadTokenQuery"] = $c52c799589981459$export$89a863448acd97ea;

});

parcelRegister("1qiwK", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $9857557de8d9983c$export$6da16bc6e6dac136 = (0, $eSUdr.default)`query MediaDownloadTokenQuery($contentId:ID$status:[String]$missingContentId:Boolean=false){content(id:$contentId status:$status)@skip(if:$missingContentId){nodes{id body{atlas_doc_format{mediaToken{token}}}}}mediaConfiguration{clientId fileStoreUrl}}`;
module.exports["MediaDownloadTokenQuery"] = $9857557de8d9983c$export$6da16bc6e6dac136;

});

parcelRegister("7tJer", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $645f8a5252e0af3f$export$2b84bdb858844a5e = (0, $eSUdr.default)`query MediaUploadTokenQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value}configuration{clientId fileStoreUrl}collection}}`;
const $645f8a5252e0af3f$export$28c8b8565d1828fc = (0, $eSUdr.default)`query CommentMediaUploadTokenQuery($cloudId:ID!$contentId:ID!){contentMediaSession:confluence_commentMediaSession(cloudId:$cloudId contentId:$contentId){token{value}configuration{clientId fileStoreUrl}collection}}`;
module.exports["MediaUploadTokenQuery"] = $645f8a5252e0af3f$export$2b84bdb858844a5e;
module.exports["CommentMediaUploadTokenQuery"] = $645f8a5252e0af3f$export$28c8b8565d1828fc;

});

parcelRegister("25RVt", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $01cc250f38200635$export$ed16560030d1977a = (0, $eSUdr.default)`query DSPIsActionEnabledForContentQuery($action:DataSecurityPolicyAction!$contentId:ID!$contentStatus:DataSecurityPolicyDecidableContentStatus!$contentVersion:Int!$spaceKey:String){dataSecurityPolicy{isActionEnabledForContent(action:$action contentId:$contentId contentStatus:$contentStatus contentVersion:$contentVersion spaceKey:$spaceKey){action allowed}}}`;
module.exports["DSPIsActionEnabledForContentQuery"] = $01cc250f38200635$export$ed16560030d1977a;

});

parcelRegister("egLSs", function(module, exports) {

var $4GGNn = parcelRequire("4GGNn");


var $aBfpe = parcelRequire("aBfpe");

const $7fce44bdcdfe3fe8$export$1b01a64a392afa44 = ({ variables: variables })=>{
    return (0, $4GGNn.experimentalMutate)({
        url: `/wiki/rest/drag-and-drop/1/filestore/upload`,
        method: 'POST',
        body: JSON.stringify(variables),
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        parseResult: ()=>({
                experimentalFileUpload: true
            })
    });
};
module.exports["experimentalFileUploadMutate"] = $7fce44bdcdfe3fe8$export$1b01a64a392afa44;

});

parcelRegister("4GGNn", function(module, exports) {

var $GLgaM = parcelRequire("GLgaM");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError }) {
    const json = await (0, $GLgaM.fetchResponse)({
        url: url,
        method: method,
        body: body,
        headers: headers,
        credentials: credentials,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    }, variables);
    const data = await parseResult(json, variables);
    return {
        data: data
    };
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: headers,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("gB1dF", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $ce4bd6b1fab7850a$export$ba0c5347c62cd2c8 = (0, $eSUdr.default)`query ExternalContentMediaSessionQuery($shareToken:String!){externalContentMediaSession(shareToken:$shareToken){accessTokens{readOnlyToken{value}readWriteToken{value}}configuration{fileStoreUrl clientId}}}`;
module.exports["ExternalContentMediaSessionQuery"] = $ce4bd6b1fab7850a$export$ba0c5347c62cd2c8;

});

parcelRegister("kQiXs", function(module, exports) {

var $kEk2z = parcelRequire("kEk2z");

const $c59debd6932d7898$var$noop = ()=>{};
const $c59debd6932d7898$export$ad897c91dfb246e9 = (options)=>{
    if (options.contentId && options.contentType) return (file)=>{
        const { id: id, name: name, size: size, mimeType: mimeType } = file;
        const { contentId: contentId, contentType: contentType } = options;
        const requestBody = {
            size: size,
            contentType: contentType,
            mimeType: mimeType,
            fileName: name,
            pageId: contentId,
            fileStoreId: id,
            minorEdit: true,
            renderEditorHTML: false,
            collectionName: `contentId-${contentId}`,
            uploadSource: 'fabric-editor'
        };
        (0, $kEk2z.setAttachment)(requestBody);
    };
    else return $c59debd6932d7898$var$noop;
};
module.exports["attachUploadedMedia"] = $c59debd6932d7898$export$ad897c91dfb246e9;

});

parcelRegister("gXrHX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $42omo.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("e2Vf0", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");


var $2XqLN = parcelRequire("2XqLN");


var $kBU5m = parcelRequire("kBU5m");

const $ec33dccf9bb2dcb4$var$i18n = (0, $cgtv4.defineMessages)({
    invalidAltText: {
        id: "editor-features.alt-text.invalid",
        defaultMessage: "We aren\u2019t able to accept every possible character in Alt text. All Unicode letters and numbers are OK, but these are the only acceptable symbols: , ' . - _ ( )."
    }
});
const $ec33dccf9bb2dcb4$export$cbb71ca960bf2b80 = (0, $2XqLN.default)(({ mediaProvider: mediaProvider, ssrMediaProvider: ssrMediaProvider, intl: intl, featureFlags: featureFlags })=>{
    // IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/mediaPluginOptions/mediaPluginOptions.ts
    return {
        provider: mediaProvider,
        syncProvider: ssrMediaProvider,
        allowMediaSingle: true,
        allowResizing: true,
        allowResizingInTables: true,
        allowLinking: true,
        allowAltTextOnImages: true,
        allowCaptions: true,
        allowMediaInlineImages: true,
        allowPixelResizing: true,
        altTextValidator: (text)=>{
            const storageSupports = RegExp("^([\\p{L}\\p{N},'\\.\\s\\-_\\(\\)]|&amp;[0-9]{2};)*$", "u");
            if (!storageSupports.test(text)) return [
                intl.formatMessage($ec33dccf9bb2dcb4$var$i18n.invalidAltText)
            ];
            return [];
        },
        featureFlags: (0, $kBU5m.getMediaFeatureFlags)(featureFlags)
    };
});
module.exports["getMediaOptions"] = $ec33dccf9bb2dcb4$export$cbb71ca960bf2b80;

});

parcelRegister("kBU5m", function(module, exports) {
// featureFlags should come from getSessionData in @confluence/session-data
// IMPORTANT: If you change the code below, please also update the
// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/mediaPluginOptions/mediaPluginOptions.ts
function $d887a76516ca8f8c$export$88f94a4dc797781a(featureFlags) {
    return featureFlags ? {
        mediaInline: true
    } : {};
}
module.exports["getMediaFeatureFlags"] = $d887a76516ca8f8c$export$88f94a4dc797781a;

});

parcelRegister("hfIjM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $jubk3 = parcelRequire("jubk3");

var $fN9wG = parcelRequire("fN9wG");


var $hSHWm = parcelRequire("hSHWm");


var $5UhfH = parcelRequire("5UhfH");

function $cb04a18914327c7b$export$601d5e9e674a7c4a(spaceId, withAnalyticsEventProps, focusedMentionId) {
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { openCoreInvites: openCoreInvites, userRole: userRole } = (0, $42omo.useContext)((0, $hSHWm.CoreInvitesContext));
    const { isEligibleXProductUserInvite: isEligibleXProductUserInvite, onXProductUserInviteClick: onXProductUserInviteClick } = (0, $42omo.useContext)((0, $fN9wG.XProductUserInviteContext)); // check if user is eligible for XProductUserInvite
    const spaceIdPromise = (0, $5UhfH.useSpaceIdPromise)(spaceId);
    return (0, $42omo.useMemo)(()=>spaceIdPromise.then((spaceId)=>{
            return (0, $jubk3.createFabricMentionResource)(cloudId, spaceId, userId, withAnalyticsEventProps, openCoreInvites, userRole, focusedMentionId, isEligibleXProductUserInvite, onXProductUserInviteClick);
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        cloudId,
        userId,
        withAnalyticsEventProps,
        openCoreInvites,
        userRole,
        isEligibleXProductUserInvite,
        onXProductUserInviteClick
    ]);
}
module.exports["useMentionProvider"] = $cb04a18914327c7b$export$601d5e9e674a7c4a;

});

parcelRegister("jubk3", function(module, exports) {

var $kN1ON = parcelRequire("kN1ON");

var $ly0vw = parcelRequire("ly0vw");


var $7lu50 = parcelRequire("7lu50");


var $f7B1p = parcelRequire("f7B1p");


var $04e9M = parcelRequire("04e9M");


var $46J5o = parcelRequire("46J5o");


var $80Dol = parcelRequire("80Dol");


var $4ZRmn = parcelRequire("4ZRmn");

const $b08c9dc0f73ff25f$export$7758cc57d736bc3e = '/gateway/api/mentions';
const $b08c9dc0f73ff25f$export$bcbcd41d6c96b319 = '/gateway/api/teams/mentions';
const $b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL = '/gateway/api/v3/invitations/invite';
async function $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, focusedMentionId, isEligibleXProductUserInvite, onXProductUserInviteClick) {
    const userMentionConfig = {
        url: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        productId: 'micros-group/confluence',
        containerId: spaceId || undefined,
        shouldHighlightMention: (mention)=>mention.id === accountId,
        debounceTime: 150
    };
    const shouldEnableInvite = !!onInviteItemClick;
    if (shouldEnableInvite) {
        userMentionConfig.productName = 'Confluence';
        userMentionConfig.shouldEnableInvite = shouldEnableInvite;
        userMentionConfig.onInviteItemClick = onInviteItemClick;
        userMentionConfig.userRole = userRole;
    }
    userMentionConfig.inviteXProductUser = async (userId, mentionName)=>{
        let isSuccess = false;
        let client;
        try {
            if (accountId === userId || isEligibleXProductUserInvite && !await isEligibleXProductUserInvite()) return;
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const response = await (0, $f7B1p.cfetch)($b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    users: [
                        {
                            id: userId
                        }
                    ],
                    resources: [
                        `ari:cloud:confluence::site/${cloudId}`
                    ]
                })
            });
            if (!response.ok) throw new Error(`Network response error.  HTTP status: ${response.status}`);
            const data = await response.json();
            const inviteResponseObj = data[0];
            const product = Object.keys(inviteResponseObj?.results || {})[0];
            const invitationStatus = inviteResponseObj?.results?.[product];
            isSuccess = product?.includes('confluence') && invitationStatus === 'INVITED';
            await client.sendTrackEvent({
                source: 'editor',
                action: 'invited',
                actionSubject: 'xProductUser',
                attributes: {
                    invitationStatus: invitationStatus,
                    inviteeId: userId
                }
            });
        } catch (error) {
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserInvite',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack,
                    inviteeId: userId
                }
            });
            isSuccess = false;
        }
        onXProductUserInviteClick?.(mentionName, isSuccess);
    };
    const teamMentionConfig = {
        url: $b08c9dc0f73ff25f$export$bcbcd41d6c96b319,
        productId: 'micros-group/confluence',
        shouldHighlightMention: (mention)=>mention.id === accountId
    };
    const scrollToMention = ()=>{
        if (focusedMentionId) {
            const mentionElement = document.querySelector(`[data-local-id="${focusedMentionId}"]`);
            if (mentionElement) mentionElement.scrollIntoView({
                behavior: 'instant',
                inline: 'center',
                block: 'center'
            });
        }
    };
    userMentionConfig.mentionNameResolver = new (0, $kN1ON.DefaultMentionNameResolver)(new (0, $46J5o.MentionNameClient)(), withAnalyticsEventProps, scrollToMention);
    return $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite);
}
async function $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite) {
    let includeExternalCollaborators = false;
    const data = await (0, $4ZRmn.fetchMentionsProviderData)();
    // Entitlement check to determine if tenant is premium/enabled for Guests
    includeExternalCollaborators = (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(data) === true;
    return new (0, $80Dol.UserTeamMentionProvider)('/gateway/api/v1/recommendations', userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite);
}
async function $b08c9dc0f73ff25f$export$86c3c7f166be321d(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick) {
    if (!cloudId) throw new Error('MentionResource cannot be configured without a cloud id');
    const spaceId = mentionContext?.spaceId || undefined;
    const mentionResource = await $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, undefined, isEligibleXProductUserInvite, onXProductUserInviteClick);
    return {
        mentionResource: mentionResource,
        presenceResource: new (0, $ly0vw.default)({
            url: '/gateway/api/directory/graphql',
            cloudId: cloudId,
            productId: 'confluence'
        }),
        // Required for the TinyMCE mentions plugin, should be removed when TinyMCE is removed
        mentionServiceUrl: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        contextIdentifier: {
            containerId: spaceId || '',
            objectId: mentionContext?.contentId || '',
            childObjectId: mentionContext?.commentId || ''
        }
    };
}
module.exports["createFabricMentionResource"] = $b08c9dc0f73ff25f$export$395a616bfa7556a6;
module.exports["getMentionsConfig"] = $b08c9dc0f73ff25f$export$86c3c7f166be321d;

});

parcelRegister("kN1ON", function(module, exports) {

var $6mYMS = parcelRequire("6mYMS");


var $3jsXx = parcelRequire("3jsXx");

class $68b29c117af189b3$export$2ae0434dccdcb77e {
    lookupName(id) {
        const name = this.nameCache.get(id);
        if (name) {
            this.fireAnalytics(true, name);
            if (this.nameQueue.size === 0) this.scheduleOnAllResolved();
            return name;
        }
        return new Promise((resolve)=>{
            const processingItems = this.processingQueue.get(id);
            if (processingItems) this.processingQueue.set(id, [
                ...processingItems,
                resolve
            ]);
            const queuedItems = this.nameQueue.get(id) || [];
            this.nameQueue.set(id, [
                ...queuedItems,
                resolve
            ]);
            if (queuedItems.length === 0 && !processingItems) this.nameStartTime.set(id, Date.now());
            this.scheduleProcessQueue();
            if (this.isQueueAtLimit()) this.processQueue();
        });
    }
    cacheName(id, name) {
        this.nameCache.set(id, {
            id: id,
            name: name,
            status: (0, $6mYMS.MentionNameStatus).OK
        });
    }
    scheduleProcessQueue() {
        if (!this.debounce) this.debounce = window.setTimeout(this.processQueue, $68b29c117af189b3$export$2ae0434dccdcb77e.waitForBatch);
    }
    scheduleOnAllResolved() {
        if (this.debounceOnResolve) clearTimeout(this.debounceOnResolve);
        this.debounceOnResolve = window.setTimeout(()=>{
            if (this.isOnResolvedAllCalled) return;
            this.onResolvedAll();
            this.isOnResolvedAllCalled = true;
        }, $68b29c117af189b3$export$2ae0434dccdcb77e.waitForResolveAll);
    }
    isQueueAtLimit() {
        return this.nameQueue.size >= this.client.getLookupLimit();
    }
    splitQueueAtLimit() {
        const values = Array.from(this.nameQueue.entries());
        const splitPoint = this.client.getLookupLimit();
        return {
            queue: new Map(values.slice(0, splitPoint)),
            extraQueue: new Map(values.slice(splitPoint))
        };
    }
    resolveQueueItem(mentionDetail) {
        const { id: id } = mentionDetail;
        const resolvers = this.processingQueue.get(id);
        if (resolvers) {
            this.processingQueue.delete(id);
            this.nameCache.set(id, mentionDetail);
            resolvers.forEach((resolve)=>{
                try {
                    resolve(mentionDetail);
                } catch  {
                // ignore - exception in consumer
                }
            });
            this.fireAnalytics(false, mentionDetail);
        }
    }
    fireAnalytics(fromCache, mentionDetail) {
        const { id: id } = mentionDetail;
        const action = mentionDetail.status === (0, $6mYMS.MentionNameStatus).OK ? 'completed' : 'failed';
        const start = this.nameStartTime.get(id);
        const duration = start ? Date.now() - start : 0;
        this.nameStartTime.delete(id);
        this.fireHydrationEvent(action, id, fromCache, duration);
    }
    constructor(client, analyticsProps = {}, onResolvedAll = ()=>{}){
        // ms
        this.client = void 0;
        this.nameCache = new Map();
        this.nameQueue = new Map();
        this.nameStartTime = new Map();
        this.processingQueue = new Map();
        this.debounce = 0;
        this.debounceOnResolve = null;
        this.onResolvedAll = void 0;
        this.isOnResolvedAllCalled = false;
        this.fireHydrationEvent = void 0;
        this.processQueue = ()=>{
            clearTimeout(this.debounce);
            this.debounce = 0;
            const { queue: queue, extraQueue: extraQueue } = this.splitQueueAtLimit();
            this.nameQueue = extraQueue;
            this.processingQueue = $68b29c117af189b3$export$71ea0798a8cad7d8(this.processingQueue, queue);
            this.client.lookupMentionNames(Array.from(queue.keys())).then((response)=>{
                response.forEach((mentionDetail)=>{
                    const { id: id } = mentionDetail;
                    queue.delete(id);
                    this.resolveQueueItem(mentionDetail);
                });
                queue.forEach((_callback, id)=>{
                    // No response from client for these ids treat as unknown
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $6mYMS.MentionNameStatus).UNKNOWN
                    });
                });
            }).catch(()=>{
                // Service completely failed, reject all items in the queue
                queue.forEach((_callback, id)=>{
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $6mYMS.MentionNameStatus).SERVICE_ERROR
                    });
                });
            });
            // Make sure anything left in the queue gets processed.
            if (this.nameQueue.size > 0) this.scheduleProcessQueue();
            else this.scheduleOnAllResolved();
        };
        this.client = client;
        this.fireHydrationEvent = (0, $3jsXx.fireAnalyticsMentionHydrationEvent)(analyticsProps);
        // If provided, this will be called once all pending mentions in the queue are resolved.
        // A sample usage is scrolling to a mention on page load, after the mentions have loadad.
        this.onResolvedAll = onResolvedAll;
    }
}
/**
 * Merge the two queues making sure to merge callback arrays for items in queueB already in queueA.
 * This addresses [this ticket](https://product-fabric.atlassian.net/browse/QS-3789).
 */ $68b29c117af189b3$export$2ae0434dccdcb77e.waitForBatch = 100;
// ms
$68b29c117af189b3$export$2ae0434dccdcb77e.waitForResolveAll = 800;
function $68b29c117af189b3$export$71ea0798a8cad7d8(queueA, queueB) {
    const queueBeingMerged = new Map([
        ...queueA
    ]);
    // now add the items from the second queue that are not already in the
    //  merged queue being built
    [
        ...queueB
    ].forEach((item)=>{
        const [key, queueBCallbacks] = item;
        const itemAlreadyInMergedQueue = queueBeingMerged.has(key);
        if (!itemAlreadyInMergedQueue) queueBeingMerged.set(key, queueBCallbacks);
        else {
            // item already in merged queue, merge the callback arrays
            const queueACallbacks = queueBeingMerged.get(key) ?? [];
            const mergedCallbacks = new Set([
                ...queueBCallbacks,
                ...queueACallbacks
            ]);
            const deduplicatedCallbacks = Array.from(mergedCallbacks.values()); // prevents calling them twice
            queueBeingMerged.set(key, deduplicatedCallbacks);
        }
    });
    return queueBeingMerged;
}
module.exports["DefaultMentionNameResolver"] = $68b29c117af189b3$export$2ae0434dccdcb77e;

});

parcelRegister("6mYMS", function(module, exports) {
var $4e350b6bba0e5c59$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $4e350b6bba0e5c59$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $4e350b6bba0e5c59$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $4e350b6bba0e5c59$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $4e350b6bba0e5c59$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $4e350b6bba0e5c59$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $4e350b6bba0e5c59$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $4e350b6bba0e5c59$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $4e350b6bba0e5c59$export$81124e6148ca5db0[0];
}
function $4e350b6bba0e5c59$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[1];
}
function $4e350b6bba0e5c59$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[2];
}
function $4e350b6bba0e5c59$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[3];
}
function $4e350b6bba0e5c59$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $4e350b6bba0e5c59$export$4369c812aac99591 = (p)=>!!(p && p.then);
module.exports["MentionType"] = $4e350b6bba0e5c59$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $4e350b6bba0e5c59$export$81124e6148ca5db0;
module.exports["UserType"] = $4e350b6bba0e5c59$export$8436e53e45ffe15b;
module.exports["SliNames"] = $4e350b6bba0e5c59$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $4e350b6bba0e5c59$export$5c42d9dea6d035c1;
module.exports["Actions"] = $4e350b6bba0e5c59$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $4e350b6bba0e5c59$export$b8fa67dc54502853;
module.exports["isRestricted"] = $4e350b6bba0e5c59$export$dbaa15dc1820b89a;
module.exports["isSpecialMention"] = $4e350b6bba0e5c59$export$37b8dcac6198c514;
module.exports["isAppMention"] = $4e350b6bba0e5c59$export$eb590c844d13454c;
module.exports["isTeamMention"] = $4e350b6bba0e5c59$export$803b1379348dbfd5;
module.exports["isSpecialMentionText"] = $4e350b6bba0e5c59$export$d13d4f976b36a397;
module.exports["isPromise"] = $4e350b6bba0e5c59$export$4369c812aac99591;

});

parcelRegister("3jsXx", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");


var $ElsUb = parcelRequire("ElsUb");


var $6mYMS = parcelRequire("6mYMS");

const $43ca455672da960d$var$packageName = "platform-pkg";
const $43ca455672da960d$var$packageVersion = "0.0.0-use.local";
const $43ca455672da960d$export$245097525aef1262 = 'sli';
const $43ca455672da960d$export$c724588856bbfbcf = 'smart';
const $43ca455672da960d$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            attributes: {
                packageName: $43ca455672da960d$var$packageName,
                packageVersion: $43ca455672da960d$var$packageVersion,
                componentName: (0, $6mYMS.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $6mYMS.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        return event;
    };
const $43ca455672da960d$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $43ca455672da960d$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        attributes: {
            packageName: $43ca455672da960d$var$packageName,
            packageVersion: $43ca455672da960d$var$packageVersion,
            componentName: (0, $6mYMS.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $43ca455672da960d$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
// OLD Analytics
const $43ca455672da960d$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $43ca455672da960d$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$43ca455672da960d$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $6mYMS.isSpecialMentionText)(text)
        });
    };
module.exports["SLI_EVENT_TYPE"] = $43ca455672da960d$export$245097525aef1262;
module.exports["SMART_EVENT_TYPE"] = $43ca455672da960d$export$c724588856bbfbcf;
module.exports["fireAnalyticsMentionTypeaheadEvent"] = $43ca455672da960d$export$a823474ae5cb9e9c;
module.exports["fireAnalyticsMentionEvent"] = $43ca455672da960d$export$44902bc7b3f0b09f;
module.exports["fireSliAnalyticsEvent"] = $43ca455672da960d$export$c8b245b690e10169;
module.exports["fireAnalyticsMentionHydrationEvent"] = $43ca455672da960d$export$91b2fa6a0fe06408;

});

parcelRegister("ElsUb", function(module, exports) {
const $cc0765a5d08d319a$export$d821aa4c8afb384e = 'fabric-elements';
module.exports["ELEMENTS_CHANNEL"] = $cc0765a5d08d319a$export$d821aa4c8afb384e;

});

parcelRegister("ly0vw", function(module, exports) {

var $jaPjp = parcelRequire("jaPjp");


var $bqMS3 = parcelRequire("bqMS3");

class $c68c97e41ce8434f$var$CacheEntry {
    expired() {
        return Date.now() > this.expiry;
    }
    constructor(pres, timeout){
        this.presence = void 0;
        this.expiry = void 0;
        this.presence = pres;
        this.expiry = Date.now() + timeout;
    }
}
class $c68c97e41ce8434f$export$7b4524ed61cc8203 extends (0, $bqMS3.AbstractResource) {
    refreshPresence(userIds) {
        throw new Error(`not yet implemented.\nParams: userIds=${userIds}`);
    }
    notifyListeners(presences) {
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(presences);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $c68c97e41ce8434f$var$PresenceResource extends $c68c97e41ce8434f$export$7b4524ed61cc8203 {
    refreshPresence(userIds) {
        const cacheHits = this.presenceCache.getBulk(userIds);
        this.notifyListeners(cacheHits);
        const cacheMisses = this.presenceCache.getMissingUserIds(userIds);
        if (cacheMisses.length) this.retrievePresence(cacheMisses);
    }
    retrievePresence(userIds) {
        this.queryDirectoryForPresences(userIds).then((res)=>this.presenceParser.parse(res)).then((presences)=>{
            this.notifyListeners(presences);
            this.presenceCache.update(presences);
        });
    }
    queryDirectoryForPresences(userIds) {
        const query = {
            query: `query getPresenceForMentions($organizationId: String!, $userIds: [String!], $productId: String) {
                PresenceBulk(organizationId: $organizationId, product: $productId, userIds: $userIds) {
                  userId
                  state
                  stateMetadata
                }
              }`,
            variables: {
                organizationId: this.config.cloudId,
                userIds: userIds
            }
        };
        if (this.config.productId) query.variables['productId'] = this.config.productId;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(query)
        };
        return fetch(this.config.url, options).then((response)=>response.json());
    }
    static cleanUrl(url) {
        if (url.substr(-1) !== '/') url += '/';
        return url;
    }
    constructor(config){
        super();
        this.config = void 0;
        this.presenceCache = void 0;
        this.presenceParser = void 0;
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.cloudId) throw new Error('config.cloudId is a required parameter');
        this.config = config;
        this.config.url = $c68c97e41ce8434f$var$PresenceResource.cleanUrl(config.url);
        this.presenceCache = config.cache || new $c68c97e41ce8434f$export$f962b6f1aaaafaf5(config.cacheExpiry);
        this.presenceParser = config.parser || new $c68c97e41ce8434f$export$80bae4549cafd20d();
    }
}
class $c68c97e41ce8434f$export$f962b6f1aaaafaf5 {
    /**
   * Precondition: _delete is only called internally if userId exists in cache
   * Removes cache entry
   * @param userId
   */ _delete(userId) {
        delete this.cache[userId];
        this.size--;
    }
    /**
   * Checks a cache entry and calls delete if the info has expired
   * @param userId
   */ _deleteIfExpired(userId) {
        if (this.contains(userId) && this.cache[userId].expired()) this._delete(userId);
    }
    /**
   * Cleans expired entries from cache
   */ _removeExpired() {
        Object.keys(this.cache).forEach((id)=>{
            this._deleteIfExpired(id);
        });
    }
    /**
   * Checks if a user exists in the cache
   * @param userId
   */ contains(userId) {
        return this.cache.hasOwnProperty(userId);
    }
    /**
   * Retrieves a presence from the cache after checking for expired entries
   * @param userId - to index the cache
   * @returns Presence - the presence that matches the userId
   */ get(userId) {
        this._deleteIfExpired(userId);
        if (!this.contains(userId)) return {};
        return this.cache[userId].presence;
    }
    /**
   * Retrieve multiple presences at once from the cache
   * @param userIds - to index the cache
   * @returns PresenceMap - A map of userIds to cached Presences
   */ getBulk(userIds) {
        const presences = {};
        for (const userId of userIds)if (this.contains(userId)) presences[userId] = this.get(userId);
        return presences;
    }
    /**
   * For a given list of ids, returns a subset
   * of all the ids with missing cache entries.
   * @param userIds - to index the cache
   * @returns string[] - ids missing from the cache
   */ getMissingUserIds(userIds) {
        return userIds.filter((id)=>!this.contains(id));
    }
    /**
   * Precondition: presMap only contains ids of users not in cache
   *               expired users must first be removed then reinserted with updated presence
   * Updates the cache by adding the new Presence entries and setting the expiry time
   * @param presMap
   */ update(presMap) {
        if (this.size >= this.flushTrigger) this._removeExpired();
        Object.keys(presMap).forEach((userId)=>{
            this.cache[userId] = new $c68c97e41ce8434f$var$CacheEntry(presMap[userId], this.expiryInMillis);
            this.size++;
        });
    }
    constructor(cacheTimeout, cacheTrigger){
        this.cache = void 0;
        this.size = void 0;
        this.expiryInMillis = void 0;
        this.flushTrigger = void 0;
        this.expiryInMillis = cacheTimeout ? cacheTimeout : $c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultTimeout;
        this.flushTrigger = cacheTrigger ? cacheTrigger : $c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultFlushTrigger;
        this.cache = {};
        this.size = 0;
    }
}
$c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultTimeout = 20000;
$c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultFlushTrigger = 50;
class $c68c97e41ce8434f$export$80bae4549cafd20d {
    mapState(state) {
        if (state === 'unavailable') return 'offline';
        else if (state === 'available') return 'online';
        else return state;
    }
    parse(response) {
        const presences = {};
        if (response.hasOwnProperty('data') && response['data'].hasOwnProperty('PresenceBulk')) {
            const results = response['data'].PresenceBulk;
            // Store map of state and time indexed by userId.  Ignore null results.
            for (const user of results){
                if (user.userId && user.state) {
                    const state = $c68c97e41ce8434f$export$80bae4549cafd20d.extractState(user) || user.state;
                    presences[user.userId] = {
                        status: this.mapState(state)
                    };
                } else if (!user.hasOwnProperty('userId') || !user.hasOwnProperty('state')) // eslint-disable-next-line no-console
                console.error('Unexpected response from presence service contains keys: ' + Object.keys(user));
            }
        }
        return presences;
    }
    static extractState(presence) {
        if ($c68c97e41ce8434f$export$80bae4549cafd20d.isFocusState(presence)) return $c68c97e41ce8434f$export$80bae4549cafd20d.FOCUS_STATE;
        return presence.state;
    }
    /*
     This is a bit of an odd exception. In the case where a user is in "Focus Mode", their presence state
     is returned as 'busy' along with a `stateMetadata` object containing a `focus` field.
     In this case we ignore the value of the `state` field and treat the presence as a 'focus' state.
    */ static isFocusState(presence) {
        if (presence.stateMetadata) try {
            const metadata = JSON.parse(presence.stateMetadata);
            return metadata && !!metadata.focus;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`Failed to parse presence's stateMetadata for user with id ${presence.userId}: ${presence.stateMetadata}`);
            // eslint-disable-next-line no-console
            console.error(e);
        }
        return false;
    }
}
$c68c97e41ce8434f$export$80bae4549cafd20d.FOCUS_STATE = 'focus';
var $c68c97e41ce8434f$export$2e2bcd8739ae039 = $c68c97e41ce8434f$var$PresenceResource;
module.exports["default"] = $c68c97e41ce8434f$export$2e2bcd8739ae039;

});

parcelRegister("jaPjp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7f0f11694d4a0f0$export$2e2bcd8739ae039);
let $f7f0f11694d4a0f0$var$debugEnabled = false;
let $f7f0f11694d4a0f0$var$stacktracesEnabled = false;
function $f7f0f11694d4a0f0$export$748ada60eaf985cc(enable) {
    $f7f0f11694d4a0f0$var$debugEnabled = enable;
}
function $f7f0f11694d4a0f0$export$4f7017086af31c25(enable) {
    $f7f0f11694d4a0f0$var$stacktracesEnabled = enable;
}
function $f7f0f11694d4a0f0$export$2a858f450a2f66d() {
    if ($f7f0f11694d4a0f0$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $f7f0f11694d4a0f0$export$2e2bcd8739ae039(msg, ...args) {
    if ($f7f0f11694d4a0f0$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("bqMS3", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $6mYMS = parcelRequire("6mYMS");


var $jaPjp = parcelRequire("jaPjp");


var $3jsXx = parcelRequire("3jsXx");


var $jSnXV = parcelRequire("jSnXV");

const $298721003a2aaba7$var$MAX_QUERY_ITEMS = 100;
const $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS = 20;
const $298721003a2aaba7$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $298721003a2aaba7$export$4529f10aed0950d4 {
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
    constructor(){
        this.changeListeners = void 0;
        this.errListeners = void 0;
        this.infoListeners = void 0;
        this.allResultsListeners = void 0;
        this.analyticsListeners = void 0;
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
}
class $298721003a2aaba7$export$8576ba1ed2760927 extends $298721003a2aaba7$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $jaPjp.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $jaPjp.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $298721003a2aaba7$export$5a4331e3e1c43553 extends $298721003a2aaba7$export$8576ba1ed2760927 {
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $jaPjp.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $6mYMS.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $298721003a2aaba7$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
   * Clear a context object to generate query params by removing empty
   * strings, `undefined` and empty values.
   *
   * @param contextIdentifier the current context identifier
   * @returns a safe context for query encoding
   */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
   * Returns the initial mention display list before a search is performed for the specified
   * container.
   *
   * @param contextIdentifier
   * @returns Promise
   */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $298721003a2aaba7$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $6mYMS.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $6mYMS.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    constructor(config){
        super();
        this.config = void 0;
        this.lastReturnedSearch = void 0;
        this.activeSearches = void 0;
        this.productName = void 0;
        this.shouldEnableInvite = void 0;
        this.userRole = void 0;
        this.onInviteItemClick = void 0;
        this.inviteXProductUser = void 0;
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(this.filter, this.config.debounceTime);
    }
}
class $298721003a2aaba7$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.name = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.stack = void 0;
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $298721003a2aaba7$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $298721003a2aaba7$export$2e2bcd8739ae039 = $298721003a2aaba7$export$5a4331e3e1c43553;
module.exports["AbstractResource"] = $298721003a2aaba7$export$4529f10aed0950d4;
module.exports["AbstractMentionResource"] = $298721003a2aaba7$export$8576ba1ed2760927;
module.exports["isResolvingMentionProvider"] = $298721003a2aaba7$export$ae1fce5f69858ef3;
module.exports["default"] = $298721003a2aaba7$export$2e2bcd8739ae039;

});

parcelRegister("46J5o", function(module, exports) {

var $6mYMS = parcelRequire("6mYMS");


var $k1vn7 = parcelRequire("k1vn7");

class $71c2faaa98a432d0$export$82da878d725997a7 {
    getLookupLimit() {
        // HOT-108964 - sending too many mentions in the request header at once returns a 400
        // The API itself apparently has a hard limit of 90 (HOT-95106), but if we're not careful we can send too many
        // mentions and make the request header too large and the endpoint falls over
        return 0, $k1vn7.MENTIONS_LOOKUP_LIMIT;
    }
    async lookupMentionNames(ids) {
        // Allows to rely upon the preloaded mentions data when resolving mentions in the editor
        // both on the client and server side
        return (0, $k1vn7.preloadMentionsUsers)(ids).then((users)=>users.map((user)=>({
                    ...user,
                    status: (0, $6mYMS.MentionNameStatus).OK
                })));
    }
}
module.exports["MentionNameClient"] = $71c2faaa98a432d0$export$82da878d725997a7;

});

parcelRegister("k1vn7", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $eSUdr = parcelRequire("eSUdr");


var $dYU3e = parcelRequire("dYU3e");

const $ed0e2cb9f5186ade$var$ARI_PREFIX = 'ari:cloud:identity::user/';
const $ed0e2cb9f5186ade$export$7c5848ab9f90077b = 50;
const $ed0e2cb9f5186ade$var$getUserData = async (ids)=>{
    const { data: data } = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $dYU3e.queryAgg)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $eSUdr.default)`query preloadMentionsUsersUsersQuery($ids:[ID!]!){users(accountIds:$ids){id name}}`,
            variables: {
                ids: ids
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    return data?.users;
};
const $ed0e2cb9f5186ade$export$3adfff745266e959 = async (userIds)=>{
    const ids = userIds.map((id)=>`${$ed0e2cb9f5186ade$var$ARI_PREFIX}${id}`);
    const users = await (async ()=>{
        const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult2 = await $ed0e2cb9f5186ade$var$getUserData(ids);
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
        return _asyncResult2;
    })();
    return (users || []).map((user)=>({
            id: user?.id?.replace($ed0e2cb9f5186ade$var$ARI_PREFIX, ''),
            name: user?.name
        }));
};
module.exports["MENTIONS_LOOKUP_LIMIT"] = $ed0e2cb9f5186ade$export$7c5848ab9f90077b;
module.exports["preloadMentionsUsers"] = $ed0e2cb9f5186ade$export$3adfff745266e959;

});

parcelRegister("80Dol", function(module, exports) {

var $bqMS3 = parcelRequire("bqMS3");


var $3jsXx = parcelRequire("3jsXx");


var $6mYMS = parcelRequire("6mYMS");


var $f7B1p = parcelRequire("f7B1p");


var $ge2sX = parcelRequire("ge2sX");


var $9fywD = parcelRequire("9fywD");


var $04e9M = parcelRequire("04e9M");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $5CrKL = parcelRequire("5CrKL");


var $j5rtD = parcelRequire("j5rtD");

const $76cb501321125a14$var$INITIAL_STATE = 'initialState';
const $76cb501321125a14$var$SEARCH = 'searchUser';
const $76cb501321125a14$var$SUCCEEDED = 'succeeded';
const $76cb501321125a14$var$FAILED = 'failed';
const $76cb501321125a14$var$CONTEXT_TYPE = 'Mentions';
const $76cb501321125a14$var$MAX_RESULTS = 20;
// Use in memory cache only
const $76cb501321125a14$var$defaultCache = {
    getStoredValues: ()=>Promise.resolve(new Map()),
    setStoredValues: ()=>Promise.resolve()
};
class $76cb501321125a14$export$f500b4849378edff extends (0, $bqMS3.default) {
    /**
   * Overrides `remoteInitialState` from `MentionResource`
   * This is invoked for bootstrap/empty queries,
   */ async remoteInitialState(contextIdentifier) {
        try {
            const promise = await this.doSearch('', contextIdentifier);
            // Set initial cache
            if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) this.offlineCache?.set(this.userTeamEndpoint, promise);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    /**
   * Overrides `remoteSearch` from `MentionResource`
   * This is invoked for non-empty queries.
   */ async remoteSearch(query, contextIdentifier) {
        try {
            const promise = await this.doSearch(query, contextIdentifier);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    async getCachedValue(query) {
        const cachedValue = this.offlineCache?.get(this.userTeamEndpoint);
        if (!cachedValue) return undefined;
        if (query === '') return Promise.resolve(cachedValue);
        else {
            // If we're offline allow basic filtering of the cached results by name.
            if (window?.navigator.onLine === false) return Promise.resolve({
                query: query,
                mentions: cachedValue.mentions?.filter((v)=>v?.name?.toLowerCase().includes(query.toLowerCase()) || v?.mentionName?.toLowerCase().includes(query.toLowerCase()) || v?.nickname?.toLowerCase().includes(query.toLowerCase()))
            });
        }
    }
    async doSearch(query, contextIdentifier) {
        if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) {
            const cachedValue = await this.getCachedValue(query);
            // Use stale-while-revalidate - if the cached value exists use it first and
            // update the cache value in the background so that it's up to date when the
            // next call is made
            if (cachedValue) {
                if (query === '') this.doNetworkSearch(query, contextIdentifier).then((results)=>{
                    this.offlineCache?.set(this.userTeamEndpoint, results);
                }).catch(()=>{
                // Pass, it's okay if the cache doesn't update
                });
                return cachedValue;
            }
            return this.doNetworkSearch(query, contextIdentifier);
        } else return this.doNetworkSearch(query, contextIdentifier);
    }
    async doNetworkSearch(query, contextIdentifier) {
        (0, $5CrKL.MENTIONS_QUERY_METRIC).start();
        const response = await this.post(await this.cloudId(), await this.orgId(), query, contextIdentifier);
        if (!response.ok) {
            const errorBody = await response.json();
            (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
                customData: {
                    isExCoEnabled: this.includeExternalCollaborators,
                    success: false
                }
            });
            throw new Error(JSON.stringify(errorBody));
        }
        const body = await response.json();
        const mentions = body.recommendedUsers.map((recommended)=>{
            if (this.isUser(recommended)) return this.convertToUserMention(recommended);
            else this.isTeam(recommended);
            return this.convertToTeamMention(recommended);
        });
        let jiraMentions = [];
        if (mentions.length < $76cb501321125a14$var$MAX_RESULTS && this.isEligibleXProductUserInvite && await this.isEligibleXProductUserInvite()) try {
            const jiraResponse = await this.searchXproductUsers(await this.cloudId(), await this.orgId(), query, contextIdentifier);
            if (!jiraResponse.ok) {
                const errorBody = await jiraResponse.json();
                throw new Error(JSON.stringify(errorBody));
            }
            const jiraBody = await jiraResponse.json();
            // Remove objects from jiraMentions if an object with the same id is present in mentions
            const mentionIds = new Set(mentions.map((mention)=>mention.id));
            const recommendedJiraUsers = (jiraBody.recommendedUsers || []).filter((mention)=>!mentionIds.has(mention?.id)).slice(0, $76cb501321125a14$var$MAX_RESULTS - mentions.length);
            //only evaluate the experiment cohort if there are jira mentions to show
            if (recommendedJiraUsers.length > 0 && (0, $6mKj3.expValEquals)('cc_virality_x_product_user_invite', 'cohort', 'test')) jiraMentions = recommendedJiraUsers.map((recommended)=>{
                return {
                    ...this.convertToUserMention(recommended),
                    isXProductUser: true
                };
            });
        } catch (error) {
            const client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserSearch',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack
                }
            });
        }
        (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
            customData: {
                isExCoEnabled: this.includeExternalCollaborators,
                success: true
            }
        });
        return {
            query: query,
            mentions: [
                ...mentions,
                ...jiraMentions
            ]
        };
    }
    async cloudId() {
        const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
        return cloudId;
    }
    async orgId() {
        const { orgId: orgId } = await (0, $ge2sX.getSessionData)();
        return orgId;
    }
    async post(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: contextIdentifier && contextIdentifier.product || 'confluence',
                    // defaults to 'confluence' to work with old editor
                    siteId: cloudId,
                    containerId: contextIdentifier && contextIdentifier.containerId,
                    objectId: contextIdentifier && contextIdentifier.objectId,
                    childObjectId: contextIdentifier && contextIdentifier.childObjectId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {},
                    ...this.includeExternalCollaborators ? {
                        productAttributes: {
                            isEntitledConfluenceExternalCollaborator: true
                        }
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    ...this.includeExternalCollaborators ? {
                        productAccessPermissionIds: [
                            'write',
                            'external-collaborator-write'
                        ]
                    } : {}
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: true
            })
        });
    }
    async searchXproductUsers(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: 'jira',
                    // fetch only jira users
                    siteId: cloudId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    productAccessPermissionIds: [
                        'write'
                    ]
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: false // Do not include teams
            })
        });
    }
    isUser(recommended) {
        return recommended.entityType === 'USER';
    }
    convertToUserMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: recommended.userType,
            ...recommended?.attributes?.isConfluenceExternalCollaborator ? {
                lozenge: (0, $9fywD.ExternalUserLozengeProps)
            } : {}
        };
    }
    isTeam(recommended) {
        return recommended.entityType === 'TEAM';
    }
    convertToTeamMention(recommended) {
        const { teamLinkResolver: teamLinkResolver } = this.teamMentionConfig;
        let teamLink = '';
        const defaultTeamLink = `${window.location.origin}/people/team/${recommended.id}`;
        if (typeof teamLinkResolver === 'function') teamLink = teamLinkResolver(recommended.id);
        return {
            id: recommended.id,
            name: recommended.displayName,
            mentionName: recommended.displayName,
            avatarUrl: recommended.smallAvatarImageUrl,
            accessLevel: (0, $6mYMS.UserAccessLevel)[(0, $6mYMS.UserAccessLevel).CONTAINER],
            userType: (0, $6mYMS.UserType)[(0, $6mYMS.UserType).TEAM],
            context: {
                members: recommended.members,
                includesYou: recommended.includesYou,
                memberCount: recommended.memberCount,
                teamLink: teamLink || defaultTeamLink
            }
        };
    }
    constructor(userTeamEndpoint, userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite){
        super(userMentionConfig);
        this.userTeamEndpoint = void 0;
        this.teamMentionConfig = void 0;
        this.includeExternalCollaborators = void 0;
        this.offlineCache = void 0;
        this.isEligibleXProductUserInvite = void 0;
        this.teamMentionConfig = teamMentionConfig;
        this.userTeamEndpoint = userTeamEndpoint;
        this.includeExternalCollaborators = includeExternalCollaborators;
        this.isEligibleXProductUserInvite = isEligibleXProductUserInvite;
        const cache = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? $76cb501321125a14$var$defaultCache : undefined;
        this.offlineCache = (0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true) ? new (0, $j5rtD.OfflineCache)(cache) : undefined;
    }
}
module.exports["UserTeamMentionProvider"] = $76cb501321125a14$export$f500b4849378edff;

});

parcelRegister("9fywD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $43aed8c383cce8da$var$i18n = (0, $cgtv4.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("5CrKL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $41760797bb45431a$export$59eae628ebf25df4 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.MENTIONS_QUERY_CUSTOM_KEY)
});
module.exports["MENTIONS_QUERY_METRIC"] = $41760797bb45431a$export$59eae628ebf25df4;

});

parcelRegister("lSOAM", function(module, exports) {
$parcel$export(module.exports, "createPageLoadMetric", () => $2a47a9fc48674e91$export$c5aa7fcaede4a84d);
$parcel$export(module.exports, "createCustomMetric", () => $2a47a9fc48674e91$export$19ba7be4fcf34f3d);
$parcel$export(module.exports, "createInteractionMetric", () => $2a47a9fc48674e91$export$36d7a61d0660e29c);
$parcel$export(module.exports, "createPageSegmentLoadMetric", () => $2a47a9fc48674e91$export$34f706592a2f7442);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $3kTfj = parcelRequire("3kTfj");

var $kyiqo = parcelRequire("kyiqo");


var $64KID = parcelRequire("64KID");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const { pageLoad: $2a47a9fc48674e91$export$c5aa7fcaede4a84d, custom: $2a47a9fc48674e91$export$19ba7be4fcf34f3d, interaction: $2a47a9fc48674e91$export$36d7a61d0660e29c, pageSegmentLoad: $2a47a9fc48674e91$export$34f706592a2f7442, concurrent: $2a47a9fc48674e91$var$concurrent } = (0, $kyiqo.metrics);
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["isBMPageLoad"] = $2a47a9fc48674e91$export$9dede01b6f349441;
module.exports["hasBMPageLoadStarted"] = $2a47a9fc48674e91$export$cb339d0cd5cc821c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("kyiqo", function(module, exports) {

var $bCz2F = parcelRequire("bCz2F");


var $bs5rD = parcelRequire("bs5rD");

const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};
module.exports["metrics"] = $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54;

});

parcelRegister("bCz2F", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $bs5rD = parcelRequire("bs5rD");

const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $bbc3e125622b0c90$export$370df09ecc3de059;

});

parcelRegister("bs5rD", function(module, exports) {

var $iuio5 = parcelRequire("iuio5");


var $boXf9 = parcelRequire("boXf9");


var $giQku = parcelRequire("giQku");


var $j4jXg = parcelRequire("j4jXg");

const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $d0aae4122f29b5ae$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $d0aae4122f29b5ae$export$94114666844d5f66;
module.exports["interaction"] = $d0aae4122f29b5ae$export$92473e6020ad89b4;
module.exports["custom"] = $d0aae4122f29b5ae$export$4c00f665f0d4b443;

});

parcelRegister("iuio5", function(module, exports) {

var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $4k3LC = parcelRequire("4k3LC");

class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $6456fd2c244bded5$export$efdd3e096bc27746;

});

parcelRegister("boXf9", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $7RgFv = parcelRequire("7RgFv");


var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $j4jXg = parcelRequire("j4jXg");


var $3znwT = parcelRequire("3znwT");


var $69Zr8 = parcelRequire("69Zr8");


var $e9ZCR = parcelRequire("e9ZCR");

class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $b4ce8d24635e776a$export$3c51073271a9eac3;

});

parcelRegister("e9ZCR", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");

class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $fd3d2d441d340510$export$dc0d85d4d6503cd7;

});

parcelRegister("giQku", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");


var $iuio5 = parcelRequire("iuio5");


var $69Zr8 = parcelRequire("69Zr8");

class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $4f83d9bff0211700$export$24c8bfcd77494cc1;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$5e0f3443b5224f1d = 'ai-snippet-hover-card';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("j5rtD", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");

class $099b8337f3ad112c$export$8904fcd398c673fb {
    update() {
        this.storageManager.setStoredValues(this.map).catch(()=>{
        // Pass, it's okay if this fails
        });
    }
    destroy() {
        this.unloadCleanup();
    }
    get(key) {
        return this.map.get(key);
    }
    set(key, value) {
        this.map.set(key, value);
    }
    constructor(storageManager){
        this.map = new Map();
        this.storageManager = void 0;
        this.unloadCleanup = ()=>{};
        const cacheName = 'editor:offline-network-request-cache';
        this.storageManager = storageManager ?? new $099b8337f3ad112c$var$IndexedDBManager(cacheName);
        this.storageManager.getStoredValues()?.then((v)=>{
            this.map = v;
        }).catch(()=>{
        // If the offline cache is rejected, use the initial empty map
        });
        if (window !== undefined) this.unloadCleanup = (0, $fFa3V.bind)(window, {
            type: 'beforeunload',
            listener: ()=>{
                this.update();
            }
        });
    }
}
/** Storage manager using indexeddb */ class $099b8337f3ad112c$var$IndexedDBManager {
    openDatabase() {
        return new Promise((resolve, reject)=>{
            const request = indexedDB.open(this.cacheName, 2);
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                // Clear old results
                if (db.objectStoreNames.contains(this.objectStoreName)) db.deleteObjectStore(this.objectStoreName);
                db.createObjectStore(this.objectStoreName);
            };
            request.onsuccess = ()=>{
                resolve(request.result);
            };
            request.onerror = ()=>{
                reject(request.error);
            };
        });
    }
    // Retrieve a map of values for a store based on a set of keys
    async getAllStoredValues(store, keys) {
        const allValues = [];
        for (const key of keys){
            const valueRequest = store.get(key);
            allValues.push(new Promise((resolve, reject)=>{
                valueRequest.onsuccess = ()=>resolve([
                        key,
                        JSON.parse(valueRequest.result)
                    ]);
                valueRequest.onerror = ()=>reject(valueRequest.error);
            }));
        }
        return new Map(await Promise.all(allValues));
    }
    getStoredValues() {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readonly');
                const store = transaction.objectStore(this.objectStoreName);
                const request = store.getAllKeys();
                request.onsuccess = async ()=>{
                    const keys = request.result;
                    const resultMap = await this.getAllStoredValues(store, keys);
                    resolve(resultMap);
                };
                request.onerror = ()=>{
                    reject(request.error);
                };
            });
        }) ?? Promise.reject();
    }
    setStoredValues(values) {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readwrite');
                const store = transaction.objectStore(this.objectStoreName);
                transaction.oncomplete = ()=>resolve();
                transaction.onerror = ()=>reject(transaction.error);
                if (values.size === 0) return;
                // Clear the existing entries before setting new values
                store.clear().onsuccess = ()=>{
                    values.forEach((value, key)=>{
                        const serialisedValue = $099b8337f3ad112c$export$ad730aacbc246ec2(value);
                        if (serialisedValue !== null) store.put(serialisedValue, key);
                    });
                };
            });
        }) ?? Promise.reject();
    }
    constructor(cacheName){
        this.cacheName = cacheName;
        this.dbPromise = undefined;
        this.objectStoreName = 'cache';
        if (window?.indexedDB) this.dbPromise = this.openDatabase();
    }
}
function $099b8337f3ad112c$export$ad730aacbc246ec2(obj) {
    try {
        return JSON.stringify(obj, (_key, value)=>{
            if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean' && value !== null && value !== undefined && typeof value !== 'object' && !Array.isArray(value)) throw new Error('Non-serializable property found');
            return value;
        });
    } catch (error) {
        return null;
    }
}
module.exports["OfflineCache"] = $099b8337f3ad112c$export$8904fcd398c673fb;

});

parcelRegister("4ZRmn", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $egFdh = parcelRequire("egFdh");

const $2de55e06904eb9f2$export$5ced7267a5286f97 = async ()=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $egFdh.MentionsProviderQuery)
    }).then(({ data: data })=>{
        return data;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["fetchMentionsProviderData"] = $2de55e06904eb9f2$export$5ced7267a5286f97;

});

parcelRegister("egFdh", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $032347ca36d77113$export$a93100a78b528047 = (0, $eSUdr.default)`query MentionsProviderQuery{entitlements{externalCollaborator{isEntitled}}}`;
module.exports["MentionsProviderQuery"] = $032347ca36d77113$export$a93100a78b528047;

});

parcelRegister("fN9wG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $iXCQx = parcelRequire("iXCQx");


var $inPa6 = parcelRequire("inPa6");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $17wUi = parcelRequire("17wUi");


var $csz5R = parcelRequire("csz5R");


var $elPdM = parcelRequire("elPdM");

const $bd929afc952baa40$var$INVITE_CAPABILITIES_URL = '/gateway/api/v3/invitations/capabilities';
const $bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY = 'confluence_invite_capabilities_direct_invite_mode';
const $bd929afc952baa40$var$i18n = (0, $cgtv4.defineMessages)({
    inviteSuccessTitle: {
        id: "fabric-media-support.mentions-provider.x-product-user-invite.success.title",
        defaultMessage: "Successfully added"
    },
    inviteSuccessDescription: {
        id: "fabric-media-support.mentions-provider.x-product-user-invite.success.description",
        defaultMessage: "We sent an email to <b>{name}</b> confirming you added them to Confluence."
    }
});
const $bd929afc952baa40$export$3bdfaf8c811be72d = /*#__PURE__*/ (0, $42omo.createContext)({});
const $bd929afc952baa40$var$hasDirectInviteCapabilities = async (cloudId, createAnalyticsEvent)=>{
    try {
        const canUserAccessJira = await $bd929afc952baa40$var$hasJiraSoftwareAccess(cloudId);
        let directInviteMode;
        let invitePendingApprovalMode;
        if (canUserAccessJira) {
            //Call invite capabilities endpoint only if directInviteMode value is not available from local storage
            directInviteMode = (0, $17wUi.confluenceLocalStorageInstance).getItem($bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY);
            if (!directInviteMode) {
                const response = await (0, $f7B1p.cfetch)(`${$bd929afc952baa40$var$INVITE_CAPABILITIES_URL}?resource=ari:cloud:platform::site/${cloudId}`, {
                    method: 'GET',
                    headers: {
                        ACCEPT: 'application/json'
                    }
                });
                if (!response.ok) throw new Error(`Network response error.  HTTP status: ${response.status}`);
                const data = await response.json();
                for (const item of data)if (item?.resourceARI?.includes('confluence')) {
                    directInviteMode = item?.directInvite?.mode;
                    invitePendingApprovalMode = item?.invitePendingApproval?.mode;
                    break;
                }
                createAnalyticsEvent && createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: 'editor',
                        action: 'fetched',
                        actionSubject: 'inviteCapabilitiesForXProductUserInvite',
                        attributes: {
                            directInviteMode: directInviteMode,
                            invitePendingApprovalMode: invitePendingApprovalMode
                        }
                    }
                }).fire();
                if (!!directInviteMode) (0, $17wUi.confluenceLocalStorageInstance).setItem($bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY, directInviteMode, 86400);
            }
        }
        return directInviteMode === 'ANYONE';
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        createAnalyticsEvent && createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'editor',
                action: 'errored',
                actionSubject: 'inviteCapabilitiesForXProductUserInvite',
                attributes: {
                    errorMessage: errorMessage
                }
            }
        }).fire();
        return false;
    }
};
const $bd929afc952baa40$var$hasJiraSoftwareAccess = async (cloudId)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $csz5R.GetUserAccessQuery),
        variables: {
            resourceId: `ari:cloud:jira::site/${cloudId}`,
            permissionId: 'write'
        }
    }).then(({ data: data })=>{
        const hasJira = data?.confluence_tenantContext?.licensedProducts.some((product)=>product?.productKey?.toLowerCase().includes('jira-software') && product?.licenseStatus === (0, $elPdM.LicenseStatus).ACTIVE);
        return !!hasJira && data?.permitted;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return false;
    });
};
const $bd929afc952baa40$export$266d732058715003 = ({ children: children, flags: flags })=>{
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const promiseRef = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleXProductUserInvite = (0, $42omo.useCallback)(()=>{
        //check the eligibility criteria only once per SPA
        if (promiseRef.current) return promiseRef.current;
        promiseRef.current = (async ()=>{
            try {
                if (!(0, $9wGTI.fg)('cc_virality_x_product_user_invite_kill_switch') || !(accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS)) return false;
                return await $bd929afc952baa40$var$hasDirectInviteCapabilities(cloudId, createAnalyticsEvent);
            } catch (e) {
                return false;
            }
        })();
        return promiseRef.current;
    }, [
        accessStatus,
        cloudId,
        createAnalyticsEvent
    ]);
    const showSuccessFlag = (0, $42omo.useCallback)((name, isSuccess)=>{
        if (isSuccess) flags.showFlag({
            id: `x-product-user-invite-success`,
            title: formatMessage($bd929afc952baa40$var$i18n.inviteSuccessTitle),
            description: formatMessage($bd929afc952baa40$var$i18n.inviteSuccessDescription, {
                name: name,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                        weight: "bold"
                    }, chunks)
            }),
            type: 'success-circle'
        });
    }, [
        flags,
        formatMessage
    ]);
    const value = (0, $42omo.useMemo)(()=>({
            isEligibleXProductUserInvite: isEligibleXProductUserInvite,
            onXProductUserInviteClick: (name, isSuccess)=>{
                showSuccessFlag(name, isSuccess);
            }
        }), [
        isEligibleXProductUserInvite,
        showSuccessFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bd929afc952baa40$export$3bdfaf8c811be72d.Provider, {
        value: value
    }, children);
};
const $bd929afc952baa40$export$363c701b8b10381c = (0, $7aRa9.withFlags)($bd929afc952baa40$export$266d732058715003);
module.exports["XProductUserInviteContext"] = $bd929afc952baa40$export$3bdfaf8c811be72d;
module.exports["XProductUserInviteProvider"] = $bd929afc952baa40$export$363c701b8b10381c;

});

parcelRegister("csz5R", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $212cbe357c6b81cb$export$c97e544e33b94e50 = (0, $eSUdr.default)`query GetUserAccessQuery($resourceId:String!$permissionId:String!){confluence_tenantContext{licensedProducts{licenseStatus productKey}}permitted(resourceId:$resourceId permissionId:$permissionId)}`;
module.exports["GetUserAccessQuery"] = $212cbe357c6b81cb$export$c97e544e33b94e50;

});

parcelRegister("elPdM", function(module, exports) {
/**
 * @generated SignedSource<<a9e9815167cf406f3c6ef437385f5336>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $ad8e722f7df5268a$export$902181cb056f3d0b = /*#__PURE__*/ function(LicenseStatus) {
    LicenseStatus["ACTIVE"] = "ACTIVE";
    LicenseStatus["SUSPENDED"] = "SUSPENDED";
    LicenseStatus["UNLICENSED"] = "UNLICENSED";
    return LicenseStatus;
}({});
module.exports["LicenseStatus"] = $ad8e722f7df5268a$export$902181cb056f3d0b;

});

parcelRegister("3W9OD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7dyLS = parcelRequire("7dyLS");


var $2fkag = parcelRequire("2fkag");


var $bQm3c = parcelRequire("bQm3c");

function $267ba6a0568e3ab0$export$ffe8c124580b6e44() {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return (0, $42omo.useMemo)(()=>Promise.resolve((0, $2fkag.createSearchProvider)(cloudId, (0, $7dyLS.Scope).ConfluencePageBlog, undefined, undefined, true)), [
        cloudId
    ]);
}
module.exports["useSearchProvider"] = $267ba6a0568e3ab0$export$ffe8c124580b6e44;

});

parcelRegister("7dyLS", function(module, exports) {

var $lEY55 = parcelRequire("lEY55");


var $iUYhn = parcelRequire("iUYhn");


var $eFiFf = parcelRequire("eFiFf");


var $3YFt4 = parcelRequire("3YFt4");

var $ff4c1fab1412a389$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["townsquare"] = "TOWNSQUARE";
    Products["trello"] = "TRELLO";
    Products["bitbucket"] = "BITBUCKET";
    Products["other"] = "OTHER";
    return Products;
}({});
const $ff4c1fab1412a389$export$775b6bb06e53a214 = {
    ...(0, $lEY55.Scope),
    ...(0, $iUYhn.Scope),
    ...(0, $3YFt4.TownsquareScope),
    ...(0, $eFiFf.Scope)
};
module.exports["Scope"] = $ff4c1fab1412a389$export$775b6bb06e53a214;

});

parcelRegister("lEY55", function(module, exports) {
/**
 * Instead of enum types for ResultType, AnalyticsType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $31e4730094d25be0$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    Scope["ConfluencePageBlogWhiteboard"] = "confluence.page,blogpost,whiteboard";
    Scope["ConfluenceContentType"] = "confluence.page,blogpost,whiteboard,database,embed";
    return Scope;
}({});
const $31e4730094d25be0$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $31e4730094d25be0$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $31e4730094d25be0$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $31e4730094d25be0$export$7694915d49dbf79 = 'confluence_experiments.page,blogpost,whiteboard';
const $31e4730094d25be0$export$2d908678acc2f256 = 'confluence_experiments.page,blogpost,whiteboard,database,embed';
const $31e4730094d25be0$export$80a5be864676016b = 'confluence.space';
const $31e4730094d25be0$export$70542451ad6057d2 = 'urs.user-confluence';
const $31e4730094d25be0$export$6ec00f56b27cdc1d = 'generic-container-result';
const $31e4730094d25be0$export$ca1a50bc869949e = 'person-result';
const $31e4730094d25be0$export$a99961038e9d5471 = 'confluence-object-result';
const $31e4730094d25be0$export$18c69de2b4aa679c = 'recent-confluence';
const $31e4730094d25be0$export$dc31f0db54ab1a30 = 'result-confluence';
const $31e4730094d25be0$export$cb8b6c470492bee8 = 'recent-person';
const $31e4730094d25be0$export$ebb42dafe7a39a20 = 'result-person';
const $31e4730094d25be0$export$602b44a55c824e30 = 'advanced-search-confluence';
const $31e4730094d25be0$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $31e4730094d25be0$export$bbd1709e62826142 = 'confluence-page';
const $31e4730094d25be0$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $31e4730094d25be0$export$b441f0c13fd510b9 = 'confluence-attachment';
const $31e4730094d25be0$export$8ee8726ca4e2f8bd = 'confluence-space';
const $31e4730094d25be0$export$d0e824889e01c751 = 'person';
const $31e4730094d25be0$export$b0c74445b9c9b57 = 'confluence-app';
module.exports["Scope"] = $31e4730094d25be0$export$775b6bb06e53a214;

});

parcelRegister("iUYhn", function(module, exports) {
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $4cce666965dd4176$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $4cce666965dd4176$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $4cce666965dd4176$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $4cce666965dd4176$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $4cce666965dd4176$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});
module.exports["Scope"] = $4cce666965dd4176$export$775b6bb06e53a214;

});

parcelRegister("eFiFf", function(module, exports) {
var $e9e0239fba21ef53$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Loom"] = "loom.loom";
    return Scope;
}({});
module.exports["Scope"] = $e9e0239fba21ef53$export$775b6bb06e53a214;

});

parcelRegister("3YFt4", function(module, exports) {
var $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareQuestion"] = "townsquare.question";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});
 // End of copied code.
module.exports["TownsquareScope"] = $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa;

});

parcelRegister("2fkag", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dIeDA = parcelRequire("dIeDA");

const $f41289c0cfd3ba69$export$31a7d81156fc4fa1 = (cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri)=>{
    return new (0, $dIeDA.default)(cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri);
};
module.exports["createSearchProvider"] = $f41289c0cfd3ba69$export$31a7d81156fc4fa1;

});

parcelRegister("dIeDA", function(module, exports) {

var $3paC4 = parcelRequire("3paC4");

var $7dyLS = parcelRequire("7dyLS");


var $7MEO5 = parcelRequire("7MEO5");

const $2b54566fbe30c20f$var$ANALYTICS_IDENTIFIER = 'editor-quick-search';
class $2b54566fbe30c20f$export$2e2bcd8739ae039 {
    getAriString(opt) {
        try {
            return new (0, $7MEO5.ResourceIdentifier)(opt).toString();
        } catch (e) {
            return '';
        }
    }
    confluencePageBlogResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.title,
                // The `item.url` is only the relative path so we need to prefix the `item.baseUrl`
                url: item.baseUrl + item.url,
                container: item.container.title,
                contentType: this.mapToContentType(item.content && item.content.type),
                updatedTimestamp: item.lastModified,
                objectId: this.getAriString({
                    resourceOwner: 'confluence',
                    cloudId: this.cloudId,
                    resourceType: this.useConfluenceTypeInAri && item.content?.type || 'content',
                    resourceId: item.content && item.content.id
                })
            }));
    }
    jiraIssueResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.name,
                // The `item.url` here for Jira Issue is the absolute url
                url: item.url,
                container: item.attributes.container && item.attributes.container.title || '',
                contentType: this.mapToContentType(item.attributes['@type'], item.attributes.issueTypeName),
                updatedTimestamp: item.attributes.updated,
                objectId: this.getAriString({
                    resourceOwner: 'jira',
                    cloudId: this.cloudId,
                    resourceType: 'issue',
                    resourceId: item.id
                })
            }));
    }
    mapToContentType(type, subType) {
        switch(type){
            case 'issue':
                switch(subType){
                    case 'Bug':
                        return 'jira.issue.bug';
                    case 'Story':
                        return 'jira.issue.story';
                    case 'Task':
                        return 'jira.issue.task';
                    default:
                        return 'jira.issue';
                }
            case 'page':
                return 'confluence.page';
            case 'blogpost':
                return 'confluence.blogpost';
            default:
                return 'default';
        }
    }
    async quickSearch(query, limit) {
        const result = await this.client.search({
            query: query,
            scopes: [
                this.scope
            ],
            analytics: {
                identifier: this.analyticsIdentifier
            },
            resultLimit: limit
        });
        switch(this.scope){
            case (0, $7dyLS.Scope).ConfluencePageBlog:
                {
                    const scopeResult = result.response.retrieveScope(this.scope);
                    return this.confluencePageBlogResponseTransformer(scopeResult);
                }
            case (0, $7dyLS.Scope).JiraIssue:
                {
                    const scopeResult = result.response.retrieveScope(this.scope);
                    return this.jiraIssueResponseTransformer(scopeResult);
                }
            default:
                throw new Error(`Unsupported scope - ${this.scope}`);
        }
    }
    constructor(cloudId, scope, aggregatorUrl, analyticsIdentifier = $2b54566fbe30c20f$var$ANALYTICS_IDENTIFIER, useConfluenceTypeInAri = false){
        this.client = void 0;
        this.scope = void 0;
        this.cloudId = void 0;
        this.analyticsIdentifier = void 0;
        this.useConfluenceTypeInAri = void 0;
        switch(scope){
            case (0, $7dyLS.Scope).ConfluencePageBlog:
            case (0, $7dyLS.Scope).JiraIssue:
                break;
            default:
                throw new Error(`Unsupported scope - ${scope}`);
        }
        this.scope = scope;
        this.cloudId = cloudId;
        this.analyticsIdentifier = analyticsIdentifier;
        this.useConfluenceTypeInAri = useConfluenceTypeInAri;
        const config = {
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl
        };
        this.client = (0, $3paC4.createClient)(config);
    }
}
module.exports["default"] = $2b54566fbe30c20f$export$2e2bcd8739ae039;

});

parcelRegister("3paC4", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $jppmC = parcelRequire("jppmC");

const $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY = 3;
const $6b372c322d10f06f$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY);
};
class $6b372c322d10f06f$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $6b372c322d10f06f$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $jppmC.timed)(this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $6b372c322d10f06f$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $6b372c322d10f06f$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};
module.exports["createClient"] = $6b372c322d10f06f$export$5d730b7aed1a3eb0;

});

parcelRegister("jppmC", function(module, exports) {
const $e3bb250125deb745$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $e3bb250125deb745$export$d35186a762cd39c8;

});

parcelRegister("7MEO5", function(module, exports) {
"use strict";
var $5aacab81e886bd11$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $5aacab81e886bd11$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dxnq4 = parcelRequire("dxnq4");


$5aacab81e886bd11$var$__export((parcelRequire("3lrmR")));
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ var $5aacab81e886bd11$var$InvalidAriError = /** @class */ function(_super) {
    $5aacab81e886bd11$var$__extends(InvalidAriError, _super);
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ function InvalidAriError(ariString, description) {
        var _this = _super.call(this, "Invalid ari string: " + ariString + (description ? '. ' + description : '')) || this;
        _this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(_this, InvalidAriError.prototype);
        return _this;
    }
    /**
   * Construct an InvalidAriError given some constraint violations
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
   */ InvalidAriError.withConstraintViolations = function(ariString, violations) {
        return new InvalidAriError(ariString, violations.map(function(v) {
            return v.toString();
        }).join('\n'));
    };
    return InvalidAriError;
}(Error);
module.exports.InvalidAriError = $5aacab81e886bd11$var$InvalidAriError;
function $5aacab81e886bd11$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
var $5aacab81e886bd11$var$basicCharConstraint = $dxnq4.pattern(/^[a-z][a-z.-]*$/);
var $5aacab81e886bd11$var$resourceOwnerConstraints = [
    $dxnq4.lengthBetween(3, 255),
    $5aacab81e886bd11$var$basicCharConstraint
];
var $5aacab81e886bd11$var$resourceTypeConstraints = [
    $dxnq4.lengthBetween(3, 255),
    $5aacab81e886bd11$var$basicCharConstraint
];
var $5aacab81e886bd11$var$cloudIdConstraints = [
    $dxnq4.lengthBetween(36, 255)
];
var $5aacab81e886bd11$var$siteResourceType = 'site';
var $5aacab81e886bd11$var$resourceIdChars = /[\w-._~:@#]/.source;
var $5aacab81e886bd11$var$resourceIdConstraints = [
    $dxnq4.pattern(new RegExp("^" + $5aacab81e886bd11$var$resourceIdChars + "+(/" + $5aacab81e886bd11$var$resourceIdChars + "*)*(;v=" + $5aacab81e886bd11$var$resourceIdChars + "*)*$"))
]; /**
                                                                                                                                                          * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
                                                                                                                                                          * (like those for site wide ARIs) are upgraded to their latest form.
                                                                                                                                                          */ 
function $5aacab81e886bd11$var$upgrade(values) {
    var resourceId = values.resourceId, resourceOwner = values.resourceOwner, cloudId = values.cloudId; // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $5aacab81e886bd11$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
var $5aacab81e886bd11$var$ResourceIdentifier = /** @class */ function() {
    /**
   * Create a new Ari
   *
   * Only the resourceOwner is a required field, any other field can be omitted.
   * Older format types are converted on creation
   *
   * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
   * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
   * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
   * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
   *
   * @throws {InvalidAriError} if the provided segments fail to pass validation
   */ function ResourceIdentifier(values) {
        var _a = $5aacab81e886bd11$var$upgrade(values), resourceId = _a.resourceId, resourceOwner = _a.resourceOwner, resourceType = _a.resourceType, cloudId = _a.cloudId;
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    Object.defineProperty(ResourceIdentifier.prototype, "cloudId", {
        get: function() {
            if (this.resourceType === $5aacab81e886bd11$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
            return this.internalCloudId;
        },
        enumerable: true,
        configurable: true
    });
    /**
  * Parse a string as an Ari
  *
  * @param {string} ariString - the string to parse
  * @returns {Ari} the parsed ari
  * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
  */ ResourceIdentifier.parse = function(ariString) {
        if (!ariString) throw new $5aacab81e886bd11$var$InvalidAriError(ariString);
        var match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $5aacab81e886bd11$var$InvalidAriError(ariString);
        var terms = match.map(function(a) {
            return a && a.length > 0 ? a : undefined;
        });
        var resourceOwner = terms[1];
        if (!resourceOwner) throw new $5aacab81e886bd11$var$InvalidAriError(ariString);
        return new ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    };
    ResourceIdentifier.parseEncoded = function(encodedAriString) {
        return $5aacab81e886bd11$var$parse(decodeURIComponent(encodedAriString));
    }; /**
      * Converts this Ari to a string.
      */ 
    ResourceIdentifier.prototype.toString = function() {
        if (!this.ariString) {
            var resourceId = this.resourceType === $5aacab81e886bd11$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            var resourceType = this.resourceType || '';
            var sanitizedCloudId = this.resourceType === $5aacab81e886bd11$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = "ari:cloud:" + this.resourceOwner + ":" + sanitizedCloudId + ":" + resourceType + "/" + resourceId;
        }
        return this.ariString;
    }; /**
      * Converts this object to its json representation
      */ 
    ResourceIdentifier.prototype.toJSON = function() {
        return this.toString();
    }; /**
      * Checks if this context is the same as another context
      *
      * @param {Ari} other - the other parameter to match with
      * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
      */ 
    ResourceIdentifier.prototype.equals = function(other) {
        return other instanceof ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }; /**
      * This method checks if the current context contains the other context.
      *
      * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
      * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
      *
      * @param {Ari} other
      * @returns {boolean}
      */ 
    ResourceIdentifier.prototype.contains = function(other) {
        return this.matches(new ResourceIdentifier(other));
    }; /**
      * Checks if this context is the same as or contains the provided context.
      *
      * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
      *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
      *
      * e.g.
      * ```
      * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
      * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
      *
      * @param {Ari} other - the other parameter to match with
      * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
      */ 
    ResourceIdentifier.prototype.matches = function(other) {
        return $5aacab81e886bd11$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $5aacab81e886bd11$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $5aacab81e886bd11$var$siteResourceType && !!other.resourceType || $5aacab81e886bd11$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $5aacab81e886bd11$var$siteResourceType && !!other.resourceType || $5aacab81e886bd11$var$matchesSegment(this.resourceId, other.resourceId));
    };
    ResourceIdentifier.prototype.validateSiteWide = function() {
        var _a = this, resourceType = _a.resourceType, cloudId = _a.cloudId;
        if (resourceType === $5aacab81e886bd11$var$siteResourceType && !cloudId) return new $dxnq4.GeneralValidationError('site wide ARIs must have a cloudId');
    };
    ResourceIdentifier.prototype.validate = function() {
        var constraintViolations = [
            $dxnq4.validateField(this, 'resourceOwner', $5aacab81e886bd11$var$resourceOwnerConstraints),
            $dxnq4.validateField(this, 'resourceType', $5aacab81e886bd11$var$resourceTypeConstraints),
            $dxnq4.validateField(this, 'resourceId', $5aacab81e886bd11$var$resourceIdConstraints),
            $dxnq4.validateField(this, 'cloudId', $5aacab81e886bd11$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter(function(v) {
            return v;
        });
        if (constraintViolations.length > 0) throw $5aacab81e886bd11$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $5aacab81e886bd11$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    };
    ResourceIdentifier.prototype.urlEncode = function() {
        return encodeURIComponent(this.toString());
    };
    ResourceIdentifier.prototype.urlDecode = function() {
        return decodeURIComponent(this.toString());
    };
    return ResourceIdentifier;
}();
module.exports.ResourceIdentifier = $5aacab81e886bd11$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $5aacab81e886bd11$var$parse(ariString) {
    return $5aacab81e886bd11$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $5aacab81e886bd11$var$parse; /**
                        * Parse a URL encoded string as an Ari
                        *
                        * @param {string} encodedAriString - the string to parse
                        * @returns {Ari} the parsed ari
                        * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
                        */ 
function $5aacab81e886bd11$var$parseEncoded(encodedAriString) {
    return $5aacab81e886bd11$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $5aacab81e886bd11$var$parseEncoded;

});

parcelRegister("dxnq4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9db08607176ba86f$var$LengthConstraint = /** @class */ function() {
    function LengthConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    Object.defineProperty(LengthConstraint.prototype, "description", {
        get: function() {
            return "length must be between " + this.min + " and " + this.max;
        },
        enumerable: true,
        configurable: true
    });
    LengthConstraint.prototype.isValid = function(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    };
    return LengthConstraint;
}();
module.exports.LengthConstraint = $9db08607176ba86f$var$LengthConstraint;
var $9db08607176ba86f$var$RegexConstraint = /** @class */ function() {
    function RegexConstraint(regex) {
        this.regex = regex;
    }
    Object.defineProperty(RegexConstraint.prototype, "description", {
        get: function() {
            return "value must match regex " + this.regex.source;
        },
        enumerable: true,
        configurable: true
    });
    RegexConstraint.prototype.isValid = function(value) {
        return !value || this.regex.test(value);
    };
    return RegexConstraint;
}();
module.exports.RegexConstraint = $9db08607176ba86f$var$RegexConstraint;
var $9db08607176ba86f$var$GeneralValidationError = /** @class */ function() {
    function GeneralValidationError(error) {
        this.error = error;
    }
    GeneralValidationError.prototype.toString = function() {
        return this.error;
    };
    return GeneralValidationError;
}();
module.exports.GeneralValidationError = $9db08607176ba86f$var$GeneralValidationError;
var $9db08607176ba86f$var$ConstraintViolation = /** @class */ function() {
    function ConstraintViolation(fieldName, value, constraints) {
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    ConstraintViolation.prototype.toString = function() {
        var constraintSummary = this.constraints.map(function(c) {
            return "  - " + c.description;
        }).join('\n');
        return "'" + this.value + "' is not a valid value for " + this.fieldName + " as it violates the following constraints:\n" + constraintSummary;
    };
    return ConstraintViolation;
}();
module.exports.ConstraintViolation = $9db08607176ba86f$var$ConstraintViolation;
function $9db08607176ba86f$var$lengthBetween(min, max) {
    return new $9db08607176ba86f$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $9db08607176ba86f$var$lengthBetween;
function $9db08607176ba86f$var$pattern(regex) {
    return new $9db08607176ba86f$var$RegexConstraint(regex);
}
module.exports.pattern = $9db08607176ba86f$var$pattern;
function $9db08607176ba86f$var$validateField(object, fieldName, constraints) {
    var value = object[fieldName];
    var violatedConstraints = constraints.map(function(c) {
        return c.isValid(value) ? undefined : c;
    }).filter(function(c) {
        return c;
    });
    return violatedConstraints.length > 0 ? new $9db08607176ba86f$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $9db08607176ba86f$var$validateField;

});

parcelRegister("3lrmR", function(module, exports) {
"use strict";
var $26f88fee2c23b642$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3uwoy = parcelRequire("3uwoy");

var $26f88fee2c23b642$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($26f88fee2c23b642$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
var $26f88fee2c23b642$var$AppFamilyAriError = /** @class */ function(_super) {
    $26f88fee2c23b642$var$__extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error);
module.exports.AppFamilyAriError = $26f88fee2c23b642$var$AppFamilyAriError;
var $26f88fee2c23b642$var$NotAppFamilyAriError = /** @class */ function(_super) {
    $26f88fee2c23b642$var$__extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}($26f88fee2c23b642$var$AppFamilyAriError);
module.exports.NotAppFamilyAriError = $26f88fee2c23b642$var$NotAppFamilyAriError;
var $26f88fee2c23b642$var$NotExpectedAppFamilyAriTypeError = /** @class */ function(_super) {
    $26f88fee2c23b642$var$__extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}($26f88fee2c23b642$var$AppFamilyAriError);
module.exports.NotExpectedAppFamilyAriTypeError = $26f88fee2c23b642$var$NotExpectedAppFamilyAriTypeError; /**
                                                                              * throws NotAppFamilyAriError if not a valid app family ari
                                                                              */ 
function $26f88fee2c23b642$var$parseAppAri(ari) {
    return $3uwoy.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $26f88fee2c23b642$var$parseAppAri;
function $26f88fee2c23b642$var$createAppAri(json) {
    return new $3uwoy.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $26f88fee2c23b642$var$createAppAri;

});

parcelRegister("3uwoy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3lrmR = parcelRequire("3lrmR");


var $7MEO5 = parcelRequire("7MEO5");

var $28ad4d654e27c81d$var$versionPrefix = ';v=';
var $28ad4d654e27c81d$var$AppFamilyAriImpl = /** @class */ function() {
    function AppFamilyAriImpl(json) {
        this.json = json;
    }
    Object.defineProperty(AppFamilyAriImpl.prototype, "appId", {
        get: function() {
            return this.json.appId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "environmentId", {
        get: function() {
            return this.json.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "version", {
        get: function() {
            return this.json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionGroupId", {
        get: function() {
            return this.json.extensionGroupId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionKey", {
        get: function() {
            return this.json.extensionKey;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toJSON = function() {
        return this.json;
    };
    AppFamilyAriImpl.parse = function(ari) {
        var resourceOwner = ari.resourceOwner, resourceType = ari.resourceType, resourceId = ari.resourceId;
        if (resourceOwner !== $3lrmR.AppFamilyAri.resourceOwner) throw new $3lrmR.NotAppFamilyAriError(ari, "resourceOwner (" + resourceOwner + ") must be " + $3lrmR.AppFamilyAri.resourceOwner);
        if (!resourceType || $3lrmR.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $3lrmR.NotAppFamilyAriError(ari, "resourceType must be one of " + $3lrmR.AppFamilyAri.appFamilyResourceTypes);
        if (!resourceId) throw new $3lrmR.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        var versionIndex = resourceId.indexOf($28ad4d654e27c81d$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($28ad4d654e27c81d$var$versionPrefix) > versionIndex) throw new $3lrmR.NotAppFamilyAriError(ari, 'can only include one version suffix');
        var _a = resourceId.split($28ad4d654e27c81d$var$versionPrefix), mainResourceId = _a[0], version = _a[1];
        var segments = mainResourceId.split('/').map($28ad4d654e27c81d$var$stripToUndefined);
        if (segments.length > 4) throw new $3lrmR.NotAppFamilyAriError(ari, "no path segments can be added after extensionKey " + segments.slice(4));
        var _b = segments[0], appId = _b === void 0 ? undefined : _b, _c = segments[1], environmentId = _c === void 0 ? undefined : _c, _d = segments[2], providedExtensionGroupId = _d === void 0 ? undefined : _d, _e = segments[3], extensionKey = _e === void 0 ? undefined : _e;
        if (!appId) throw new $3lrmR.NotAppFamilyAriError(ari, 'appId must be included');
        var extensionGroupId = providedExtensionGroupId || (resourceType === $3lrmR.AppFamilyAri.extensionGroupResourceType || resourceType === $3lrmR.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $3lrmR.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId, extensionGroupId, extensionKey must all be provided for resourceType " + $3lrmR.AppFamilyAri.extensionResourceType);
        else if (resourceType === $3lrmR.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId, extensionGroupId must all be provided for resourceType " + $3lrmR.AppFamilyAri.extensionGroupResourceType);
        else if (resourceType === $3lrmR.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $3lrmR.AppFamilyAri.environmentResourceType);
        else if (resourceType === $3lrmR.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $3lrmR.AppFamilyAri.environmentResourceType);
        return new AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    };
    AppFamilyAriImpl.prototype.asAppAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppAri();
        }, 'app');
    };
    AppFamilyAriImpl.prototype.asAppEnvironmentAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppEnvironmentAri();
        }, 'environment');
    };
    AppFamilyAriImpl.prototype.asExtensionGroupAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionGroupAri();
        }, 'extension-group');
    };
    AppFamilyAriImpl.prototype.asExtensionAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionAri();
        }, 'extension');
    };
    AppFamilyAriImpl.prototype.isAppAri = function() {
        return !this.isAtLeastAppEnvironmentAri;
    };
    AppFamilyAriImpl.prototype.isAppEnvironmentAri = function() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    };
    AppFamilyAriImpl.prototype.isExtensionGroupAri = function() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    };
    AppFamilyAriImpl.prototype.isExtensionAri = function() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    };
    AppFamilyAriImpl.prototype.returnIf = function(check, type) {
        if (!check()) throw new $3lrmR.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    };
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastAppEnvironmentAri", {
        get: function() {
            return this.environmentId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastExtensionGroupAri", {
        get: function() {
            return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toAri = function() {
        var resourceOwner = $3lrmR.AppFamilyAri.resourceOwner;
        var _a = this.toJSON(), appId = _a.appId, environmentId = _a.environmentId, extensionGroupId = _a.extensionGroupId, extensionKey = _a.extensionKey, version = _a.version;
        function withVersion(segments) {
            var path = segments.join('/');
            if (!version) return path;
            else return "" + path + $28ad4d654e27c81d$var$versionPrefix + version;
        }
        if (this.isExtensionAri()) return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    };
    AppFamilyAriImpl.prototype.toString = function() {
        return this.toAri().toString();
    };
    return AppFamilyAriImpl;
}();
module.exports.AppFamilyAriImpl = $28ad4d654e27c81d$var$AppFamilyAriImpl;
function $28ad4d654e27c81d$var$stripToUndefined(str) {
    if (!str) return undefined;
    var trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});

parcelRegister("beK3g", function(module, exports) {
/* useSpinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $lOkIA = parcelRequire("lOkIA");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $510b459ad72a4bad$var$ReadOnlyOverlay = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71j9a _4t3i1osq _kqsw1n9t _1ltvidpf _154iidpf _1bsb1osq _1pby1ayy",
            __cmplp.className
        ])
    });
});
const $510b459ad72a4bad$var$TransparentReadOnlyOverlay = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_bfhk1j28 _80omv00u _4t3i1osq _kqswstnw _1ltvidpf _154iidpf _1bsb1osq _1pby1ayy",
            __cmplp.className
        ])
    });
});
const $510b459ad72a4bad$export$7f7cbe89f1eacd2 = ({ shouldShowSpinner: shouldShowSpinner, isOverlayTransparent: isOverlayTransparent = false })=>{
    if (!shouldShowSpinner) return null;
    if (isOverlayTransparent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($510b459ad72a4bad$var$TransparentReadOnlyOverlay, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lOkIA.CenteredSpinner), {
        size: "large"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($510b459ad72a4bad$var$ReadOnlyOverlay, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lOkIA.CenteredSpinner), {
        size: "medium"
    }));
};
const $510b459ad72a4bad$export$21495182eeff761c = ()=>{
    const [shouldShowSpinner, setShouldShowSpinner] = (0, $42omo.useState)(false);
    const showSpinner = (0, $42omo.useCallback)(()=>setShouldShowSpinner(true), []);
    const hideSpinner = (0, $42omo.useCallback)(()=>setShouldShowSpinner(false), []);
    return {
        showSpinner: showSpinner,
        hideSpinner: hideSpinner,
        shouldShowSpinner: shouldShowSpinner
    };
};
module.exports["Spinner"] = $510b459ad72a4bad$export$7f7cbe89f1eacd2;
module.exports["useSpinner"] = $510b459ad72a4bad$export$21495182eeff761c;

});

parcelRegister("lOkIA", function(module, exports) {
/* CenteredSpinner.js generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");

function $fe0e56b204487583$var$_defineProperty(e, r, t) {
    return (r = $fe0e56b204487583$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fe0e56b204487583$var$_toPropertyKey(t) {
    var i = $fe0e56b204487583$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fe0e56b204487583$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fe0e56b204487583$export$57732b6846a8df7c = {
    small: 12,
    medium: 26,
    large: 36
};
const $fe0e56b204487583$var$wrapperStyles = null;
const $fe0e56b204487583$var$spinnerStyles = null;
class $fe0e56b204487583$export$a2638930496865a0 extends (0, $42omo.PureComponent) {
    render() {
        const { style: style, size: size } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: style,
            "data-test-id": "wrapper-spinner",
            className: (0, $gMc0m.default)([
                "_1bsb1osq _4t3i1osq _kqswh2mm"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-test-id": "spinner",
            style: {
                marginLeft: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`,
                marginTop: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`
            },
            className: (0, $gMc0m.default)([
                "_kqswstnw _1ltv1ssb _154i1ssb _1pbyb4wl"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: $fe0e56b204487583$export$57732b6846a8df7c[size]
        })));
    }
}
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "displayName", 'CenteredSpinner');
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "propTypes", {
    /**
   * custom spinner style
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Size of spinner
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'small',
        'medium',
        'large'
    ])
});
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "defaultProps", {
    size: 'small'
});
module.exports["CenteredSpinner"] = $fe0e56b204487583$export$a2638930496865a0;

});

parcelRegister("9ovft", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jQ7BI = parcelRequire("jQ7BI");

const $b50d68d67cedaa55$export$7d464c122ca911c0 = ({ contentId: contentId, contentType: contentType, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment, isEnabled: isEnabled = true, isDocumentActive: isDocumentActive, storedCommentData: storedCommentData, setStoredCommentData: setStoredCommentData, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache })=>{
    const isRegistered = (0, $42omo.useRef)(false);
    const { register: register, unregister: unregister } = (0, $jQ7BI.useEditorInlineCommentsPubSub)({
        contentId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        updateUnresolvedInlineComment: updateUnresolvedInlineComment,
        contentType: contentType,
        storedCommentData: storedCommentData,
        setStoredCommentData: setStoredCommentData,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    });
    (0, $42omo.useEffect)(()=>{
        if (isEnabled && !isRegistered.current) {
            register();
            isRegistered.current = true;
            return ()=>{
                unregister();
                isRegistered.current = false;
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEnabled,
        register,
        unregister,
        isDocumentActive
    ]);
};
module.exports["useEditorInlineCommentsPubSub"] = $b50d68d67cedaa55$export$7d464c122ca911c0;

});

parcelRegister("jQ7BI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7S9uM = parcelRequire("7S9uM");


var $gRrX4 = parcelRequire("gRrX4");


var $gfqXk = parcelRequire("gfqXk");


var $kDIns = parcelRequire("kDIns");


var $aHcFH = parcelRequire("aHcFH");


var $cZa7r = parcelRequire("cZa7r");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $6UYek = parcelRequire("6UYek");


var $fHAwL = parcelRequire("fHAwL");


var $lb2Lp = parcelRequire("lb2Lp");


var $3BPrE = parcelRequire("3BPrE");


var $03oqz = parcelRequire("03oqz");

const $c13ad953d7aa53c9$export$7d464c122ca911c0 = ({ contentId: contentId, contentType: contentType, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment, storedCommentData: storedCommentData, setStoredCommentData: setStoredCommentData, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache })=>{
    const pubSubResourceType = contentType || 'page';
    const subscriptions = (0, $42omo.useRef)([]);
    const [{ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList }, { addReplyToCommentThread: addReplyToCommentThread, addNewCommentThreads: addNewCommentThreads, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, updateCommentBody: updateCommentBody, reopenParentComment: reopenParentComment }] = (0, $8i27m.useCommentsData)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const orderedActiveAnnotationIdListRef = (0, $42omo.useRef)(orderedActiveAnnotationIdList);
    const { editorViewProps: editorViewProps } = (0, $cZa7r.useAnnotations)();
    const { setContentId: setContentId, setContentType: setContentType, addSubscriber: addSubscriber, removeSubscriber: removeSubscriber } = (0, $6UYek.useSubscriptionsDispatchContext)() || {};
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { annotations: annotations = [] } = editorViewProps || {};
    const selectedAnnotationId = annotations[0]?.id;
    (0, $42omo.useEffect)(()=>{
        orderedActiveAnnotationIdListRef.current = orderedActiveAnnotationIdList;
    }, [
        orderedActiveAnnotationIdList
    ]);
    const handleOnPublicationEvent = (0, $42omo.useCallback)((event, markerRef)=>{
        const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
        emitter.emit(event, markerRef);
        const annotationIds = orderedActiveAnnotationIdListRef.current.map((annotation)=>annotation.threadKey);
        if (triggerAnalyticsEvent) // Updates ordered list of unresolved inline comments based on ADF to account for real-time changes (collaborative editing)
        (0, $kDIns.getEditorResolvedState)({
            // the annotations won't already include the pubsub marker ref
            annotations: (0, $aHcFH.getSortedMarkerRefs)([
                ...annotationIds,
                markerRef
            ], 'edit'),
            pageId: contentId,
            triggerAnalyticsEvent: triggerAnalyticsEvent,
            updateUnresolvedInlineComment: updateUnresolvedInlineComment
        });
    }, [
        contentId,
        triggerAnalyticsEvent,
        updateUnresolvedInlineComment
    ]);
    const onPublicationEvent = (0, $42omo.useCallback)(async (event, payload)=>{
        if (!event) return;
        let inlineCommentRequestBody;
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) inlineCommentRequestBody = payload?.[event];
        else inlineCommentRequestBody = payload.inlineCommentRequestBody;
        const { accountId: accountId } = payload || {};
        const { markerRef: markerRef, commentId: commentId, inlineCommentType: inlineCommentType } = inlineCommentRequestBody || {};
        // Don't do anything when the current user performs an action
        if (accountId === currentUserId) return;
        const isReply = inlineCommentType === 'REPLY';
        switch(event){
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUnresolved:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUnresolved:
                if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        await (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        });
                    } else // We load resolved + active separately, so unless the user has visited the resolved tab, the comment thread won't be in the state
                    // Hence the await here - as part of this function we update state
                    await (0, $03oqz.handleAddNewCommentThread)({
                        contentId: contentId,
                        markerRef: markerRef,
                        addNewCommentThreads: addNewCommentThreads
                    });
                    // Remove from commentThreadsRemovedByOtherUsers when reopened
                    if (markerRef && reopenParentComment && (0, $9wGTI.fg)('confluence_comments_reply_inline_reliability')) reopenParentComment({
                        threadKey: markerRef,
                        commentType: (0, $8i27m.CommentType).INLINE
                    });
                }
                // Call handleOnPublicationEvent after store updates are complete
                handleOnPublicationEvent('unresolve', markerRef);
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentResolved:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentResolved:
                handleOnPublicationEvent('resolve', markerRef);
                if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        });
                    }
                    const { inlineResolveProperties: inlineResolveProperties, inlineText: inlineText } = inlineCommentRequestBody;
                    if (inlineResolveProperties && (inlineText || (0, $9wGTI.fg)('confluence_comments_reply_inline_reliability'))) updateRemovedCommentIdsMap({
                        threadKey: markerRef,
                        commentId: commentId,
                        commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
                        isReply: isReply,
                        resolvedProperties: {
                            inlineResolveProperties: inlineResolveProperties,
                            inlineText: inlineText
                        },
                        commentType: (0, $8i27m.CommentType).INLINE
                    });
                    if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) {
                        const { replies: replies = [] } = inlineCommentRequestBody;
                        if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                            commentId,
                            ...replies
                        ]), 'remove');
                    }
                }
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentCreated:
            case (0, $3BPrE.InlineCommentSubscriptionEvents).EditorInlineCommentCreated:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentCreated:
            case (0, $3BPrE.InlineCommentPubSubEvents).EditorInlineCommentCreated:
                if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (addCommentInCache && commentId) {
                            const comment = await (0, $lb2Lp.fetchCommentById)({
                                commentId: commentId,
                                contentId: contentId,
                                fetchPolicy: 'network-only'
                            });
                            if (comment) addCommentInCache({
                                newComment: comment
                            });
                        }
                    } else if (isReply) await (0, $03oqz.handleAddedReplyInCommentThread)({
                        contentId: contentId,
                        markerRef: markerRef,
                        commentId: commentId,
                        addReplyToCommentThread: addReplyToCommentThread,
                        commentType: (0, $8i27m.CommentType).INLINE,
                        storedCommentData: storedCommentData,
                        setStoredCommentData: setStoredCommentData
                    });
                    else await (0, $03oqz.handleAddNewCommentThread)({
                        contentId: contentId,
                        markerRef: markerRef,
                        addNewCommentThreads: addNewCommentThreads
                    });
                    if (updateUnreadCommentIDSet && (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                } else if (isReply && markerRef === selectedAnnotationId) (0, $03oqz.refreshCommentThread)(contentId, markerRef);
                // Call handleOnPublicationEvent after store updates are complete
                handleOnPublicationEvent('create', markerRef);
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentDeleted:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentDeleted:
                // both a parent comment and reply can be deleted
                if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                    updateRemovedCommentIdsMap({
                        threadKey: markerRef,
                        commentId: commentId,
                        isReply: isReply,
                        commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                        commentType: (0, $8i27m.CommentType).INLINE
                    });
                    if (updateUnreadCommentIDSet && (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'remove');
                }
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                    if (deleteCommentInCache && commentId) deleteCommentInCache({
                        commentId: commentId
                    });
                }
                // Always handle annotation logic
                // We update useCommentsData state for the full panel, but the standalone comment doesn't look at it, so keep in sync via the API
                if (isReply && markerRef === selectedAnnotationId) (0, $03oqz.refreshCommentThread)(contentId, markerRef);
                if (!isReply && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) handleOnPublicationEvent('delete', markerRef);
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUpdated:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUpdated:
                if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        });
                    } else (0, $03oqz.handleEditedComment)({
                        contentId: contentId,
                        markerRef: markerRef,
                        commentId: commentId,
                        updateCommentBody: updateCommentBody
                    });
                } else if (markerRef === selectedAnnotationId) (0, $03oqz.refreshCommentThread)(contentId, markerRef);
                break;
            default:
                break;
        }
    }, [
        contentId,
        handleOnPublicationEvent,
        selectedAnnotationId,
        addNewCommentThreads,
        addReplyToCommentThread,
        updateRemovedCommentIdsMap,
        currentUserId,
        updateCommentBody,
        storedCommentData,
        setStoredCommentData,
        updateUnreadCommentIDSet,
        addCommentInCache,
        deleteCommentInCache,
        reopenParentComment
    ]);
    const register = (0, $42omo.useCallback)(()=>{
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
            if (!setContentType || !setContentId || !addSubscriber) return;
            setContentType(pubSubResourceType);
            setContentId(contentId);
            const subscribers = [
                {
                    subscriberId: 'useEditorInlineCommentsPubSubInlineCommentResolved',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'inlineCommentResolved'
                },
                {
                    subscriberId: 'useEditorInlineCommentsPubSubInlineCommentUnresolved',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'inlineCommentUnresolved'
                },
                {
                    subscriberId: 'useEditorInlineCommentsPubSubInlineCommentCreated',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'inlineCommentCreated'
                },
                {
                    subscriberId: 'useEditorInlineCommentsPubSubInlineCommentUpdated',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'inlineCommentUpdated'
                },
                {
                    subscriberId: 'useEditorInlineCommentsPubSubEditorInlineCommentCreated',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'editorInlineCommentCreated'
                }
            ];
            for (const subscriber of subscribers)subscriptions.current.push({
                subscriberId: addSubscriber(subscriber),
                delta: subscriber.delta
            });
            if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) subscriptions.current.push({
                delta: 'inlineCommentDeleted',
                subscriberId: addSubscriber({
                    subscriberId: 'useEditorInlineCommentsPubSubInlineCommentDeleted',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'inlineCommentDeleted'
                })
            });
        } else (0, $gRrX4.getPubSubClient)().then((client)=>{
            client.joinChannel(pubSubResourceType, contentId).finally(()=>{
                client.subscribe((0, $7S9uM.eventToAvi)('resolved:inline_comment'), onPublicationEvent);
                client.subscribe((0, $7S9uM.eventToAvi)('unresolved:inline_comment'), onPublicationEvent);
                client.subscribe((0, $7S9uM.eventToAvi)('created:inline_comment'), onPublicationEvent);
                client.subscribe((0, $7S9uM.eventToAvi)('created:editor_inline_comment'), onPublicationEvent);
                client.subscribe((0, $7S9uM.eventToAvi)('updated:inline_comment'), onPublicationEvent);
                if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) client.subscribe((0, $7S9uM.eventToAvi)('deleted:inline_comment'), onPublicationEvent);
            }).catch((error)=>{
                throw new Error(`PubSub Web Client joinChannel ${JSON.stringify(error)}`);
            });
        });
    }, [
        setContentType,
        pubSubResourceType,
        setContentId,
        contentId,
        onPublicationEvent,
        subscriptions,
        addSubscriber
    ]);
    const unregister = (0, $42omo.useCallback)(()=>{
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) for (const subscriber of subscriptions.current)removeSubscriber?.(subscriber);
        else (0, $gRrX4.getPubSubClient)().then((client)=>{
            client.leaveChannel(pubSubResourceType, contentId);
            client.unsubscribe((0, $7S9uM.eventToAvi)('resolved:inline_comment'), onPublicationEvent);
            client.unsubscribe((0, $7S9uM.eventToAvi)('unresolved:inline_comment'), onPublicationEvent);
            client.unsubscribe((0, $7S9uM.eventToAvi)('created:inline_comment'), onPublicationEvent);
            client.unsubscribe((0, $7S9uM.eventToAvi)('created:editor_inline_comment'), onPublicationEvent);
            client.unsubscribe((0, $7S9uM.eventToAvi)('updated:inline_comment'), onPublicationEvent);
            if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) client.unsubscribe((0, $7S9uM.eventToAvi)('deleted:inline_comment'), onPublicationEvent);
        });
    }, [
        contentId,
        onPublicationEvent,
        pubSubResourceType,
        removeSubscriber,
        subscriptions
    ]);
    return (0, $42omo.useMemo)(()=>({
            register: register,
            unregister: unregister,
            onPublicationEvent: onPublicationEvent
        }), [
        register,
        unregister,
        onPublicationEvent
    ]);
};
module.exports["useEditorInlineCommentsPubSub"] = $c13ad953d7aa53c9$export$7d464c122ca911c0;

});

parcelRegister("6UYek", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $7hXu9 = parcelRequire("7hXu9");


var $kyKWe = parcelRequire("kyKWe");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $gKr8t = parcelRequire("gKr8t");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $42omo.useState)(null);
    const [contentId, setContentId] = (0, $42omo.useState)(null);
    const [contentType, setContentType] = (0, $42omo.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $42omo.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $42omo.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = subscribers[delta].filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $42omo.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            if (subscribers.hasOwnProperty(delta)) (subscribers?.[delta]).forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { error: error } = (0, $7hXu9.useSubscription)((0, $eSUdr.default)`subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type id accountId __typename _deltas contentStateUpdated{key value version __typename}emojiTitleUpdated{key value version __typename}coverPictureUpdated{key value version __typename}pageTitlePropertyUpdated{key value version __typename}coverPictureDeleted{key __typename}emojiTitleDeleted{key __typename}contentStateDeleted{key __typename}coverPictureWidthUpdated{coverPictureWidth __typename}pageBlogified{spaceKey spaceName blogTitle converterDisplayName __typename}embedUpdated{product isBlankStateUpdate __typename}pageMigrated{fabricEligibility __typename}contentRestrictionUpdated{contentId __typename}pageMoved{oldSpaceKey newSpaceKey oldParentId oldPosition newSpaceAlias oldSpaceAlias __typename}pageUpdated{__typename trigger confVersion}contentUpdatedWithTemplate{spaceKey subtype __typename}inlineCommentCreated{commentId inlineCommentType adfBodyContent __typename markerRef}rendererInlineCommentCreated{__typename commentId adfBodyContent inlineCommentType markerRef publishVersionNumber step{from to pos mark{attrs{annotationType __typename}__typename}__typename}}editorInlineCommentCreated{adfBodyContent commentId inlineCommentType markerRef __typename}inlineCommentUpdated{commentId markerRef __typename}inlineCommentDeleted{commentId inlineCommentType markerRef __typename}inlineCommentResolved{commentId inlineResolveProperties{isDangling resolved resolvedByDangling resolvedFriendlyDate resolvedTime resolvedUser __typename}inlineText markerRef replies __typename}inlineCommentUnresolved{commentId markerRef __typename}inlineCommentReattached{commentId __typename markerRef publishVersionNumber step{from mark{attrs{__typename annotationType}__typename}__typename}}commentCreated{__typename adfBodyContent commentId pageCommentType}commentUpdated{__typename commentId}commentDeleted{__typename commentId}commentResolved{__typename adfBodyContent commentId pageCommentType replies}commentReopened{__typename commentId}schedulePublished{publishTime eventType confVersion __typename}contentAccessRequested{contentId __typename}}}`, {
        variables: {
            id: id,
            __extensions: extensions
        },
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(subscriptionData?.data?.confluence_onContentModified ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        client: (0, $gKr8t.getAGGClient)()
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || error?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = error?.errors?.[0]?.extensions?.statusCode;
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("3vc4U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $42omo.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $42omo.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $42omo.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $42omo.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || ''
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $42omo.useMemo)(()=>{
        const twentyFourHoursAgoInSecondsFallbackReplayCap = Math.floor((Date.now() - 86400000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < twentyFourHoursAgoInSecondsFallbackReplayCap) sequenceNumber = twentyFourHoursAgoInSecondsFallbackReplayCap;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("3BPrE", function(module, exports) {
var $e3661bd3089bf51c$export$7309710dd8a888d9 = /*#__PURE__*/ function(InlineCommentPubSubEvents) {
    InlineCommentPubSubEvents["InlineCommentCreated"] = "avi:confluence:created:inline_comment";
    InlineCommentPubSubEvents["RendererInlineCommentCreated"] = "avi:confluence:created:renderer_inline_comment";
    InlineCommentPubSubEvents["EditorInlineCommentCreated"] = "avi:confluence:created:editor_inline_comment";
    InlineCommentPubSubEvents["InlineCommentDeleted"] = "avi:confluence:deleted:inline_comment";
    InlineCommentPubSubEvents["InlineCommentResolved"] = "avi:confluence:resolved:inline_comment";
    InlineCommentPubSubEvents["InlineCommentUnresolved"] = "avi:confluence:unresolved:inline_comment";
    InlineCommentPubSubEvents["InlineCommentUpdated"] = "avi:confluence:updated:inline_comment";
    InlineCommentPubSubEvents["InlineCommentReattached"] = "avi:confluence:reattach:inline_comment";
    return InlineCommentPubSubEvents;
}({});
var $e3661bd3089bf51c$export$d05a35896d8f557d = /*#__PURE__*/ function(InlineCommentSubscriptionEvents) {
    InlineCommentSubscriptionEvents["InlineCommentCreated"] = "inlineCommentCreated";
    InlineCommentSubscriptionEvents["RendererInlineCommentCreated"] = "rendererInlineCommentCreated";
    InlineCommentSubscriptionEvents["EditorInlineCommentCreated"] = "editorInlineCommentCreated";
    InlineCommentSubscriptionEvents["InlineCommentDeleted"] = "inlineCommentDeleted";
    InlineCommentSubscriptionEvents["InlineCommentResolved"] = "inlineCommentResolved";
    InlineCommentSubscriptionEvents["InlineCommentUnresolved"] = "inlineCommentUnresolved";
    InlineCommentSubscriptionEvents["InlineCommentUpdated"] = "inlineCommentUpdated";
    InlineCommentSubscriptionEvents["InlineCommentReattached"] = "inlineCommentReattached";
    return InlineCommentSubscriptionEvents;
}({});
var $e3661bd3089bf51c$export$5d941a2346cc8f6a = /*#__PURE__*/ function(PagePubSubEvents) {
    PagePubSubEvents["PagePublished"] = "avi:confluence:publish:page";
    PagePubSubEvents["BlogPublished"] = "avi:confluence:publish:blogpost";
    return PagePubSubEvents;
}({});
var $e3661bd3089bf51c$export$15c104b3df413bde = /*#__PURE__*/ function(PageSubscriptionEvents) {
    PageSubscriptionEvents["PageUpdated"] = "pageUpdated";
    return PageSubscriptionEvents;
}({});
module.exports["InlineCommentPubSubEvents"] = $e3661bd3089bf51c$export$7309710dd8a888d9;
module.exports["InlineCommentSubscriptionEvents"] = $e3661bd3089bf51c$export$d05a35896d8f557d;
module.exports["PagePubSubEvents"] = $e3661bd3089bf51c$export$5d941a2346cc8f6a;
module.exports["PageSubscriptionEvents"] = $e3661bd3089bf51c$export$15c104b3df413bde;

});

parcelRegister("03oqz", function(module, exports) {

var $8i27m = parcelRequire("8i27m");


var $3B9cR = parcelRequire("3B9cR");


var $1C8XP = parcelRequire("1C8XP");


var $hp2SH = parcelRequire("hp2SH");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $895e8bda1c5e4d1e$export$15e2805385ec0eed = (contentId, markerRef)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $3B9cR.InlineCommentQuery),
        fetchPolicy: 'network-only',
        variables: {
            pageId: contentId,
            annotationId: markerRef,
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        }
    });
    else // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $1C8XP.ActiveInlineCommentsQuery),
        fetchPolicy: 'network-only',
        variables: {
            pageId: contentId,
            inlineMarkerRefList: [
                markerRef
            ],
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        }
    });
};
const $895e8bda1c5e4d1e$export$90e382997b4dc102 = async (contentId, markerRef)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const commentThreadDataResult = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $3B9cR.InlineCommentQuery),
            fetchPolicy: 'network-only',
            variables: {
                pageId: contentId,
                annotationId: markerRef,
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            }
        });
        return commentThreadDataResult.data;
    } else {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const commentThreadDataResult = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $1C8XP.ActiveInlineCommentsQuery),
            fetchPolicy: 'network-only',
            variables: {
                pageId: contentId,
                inlineMarkerRefList: [
                    markerRef
                ],
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            }
        });
        return commentThreadDataResult.data;
    }
};
const $895e8bda1c5e4d1e$export$e136ff0cd91112e0 = async ({ contentId: contentId, markerRef: markerRef, addNewCommentThreads: addNewCommentThreads })=>{
    const commentThreadDataResult = await $895e8bda1c5e4d1e$export$90e382997b4dc102(contentId ?? '', markerRef);
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment) addNewCommentThreads && addNewCommentThreads({
        inline: {
            [markerRef]: {
                ...comment,
                isUnread: true,
                isOpen: true,
                wasRemovedByAnotherUser: false,
                type: (0, $8i27m.CommentType).INLINE
            }
        },
        general: {}
    });
};
const $895e8bda1c5e4d1e$export$120fd6a8527dd6bd = async ({ contentId: contentId, markerRef: markerRef, commentId: commentId, addReplyToCommentThread: addReplyToCommentThread, commentType: commentType, storedCommentData: storedCommentData, setStoredCommentData: setStoredCommentData })=>{
    const commentThreadDataResult = await $895e8bda1c5e4d1e$export$90e382997b4dc102(contentId ?? '', markerRef);
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    const replies = comment?.replies;
    const reply = replies?.filter((r)=>r?.id === commentId)[0];
    if (reply) {
        // Update storedCommentData if it exists by adding the new reply
        if (storedCommentData && setStoredCommentData) {
            const updatedCommentData = {
                ...storedCommentData,
                replies: [
                    ...storedCommentData.replies || [],
                    reply
                ]
            };
            if ((0, $6mKj3.expValEquals)('confluence_frontend_replytoggler_fix', 'isEnabled', true)) // Only update if inlineMarkerRef matches between stored and fetched comment
            {
                if (storedCommentData.location?.inlineMarkerRef === comment?.location?.inlineMarkerRef) setStoredCommentData(updatedCommentData);
            } else // Original behavior - always update
            setStoredCommentData(updatedCommentData);
        }
        addReplyToCommentThread && addReplyToCommentThread(markerRef, {
            ...reply,
            isUnread: true
        }, commentType);
    }
};
const $895e8bda1c5e4d1e$export$7652b163bd2668c5 = async ({ contentId: contentId, markerRef: markerRef, commentId: commentId, updateCommentBody: updateCommentBody })=>{
    const commentThreadDataResult = await $895e8bda1c5e4d1e$export$90e382997b4dc102(contentId ?? '', markerRef);
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    const targetComment = comment?.id === commentId ? comment : comment?.replies?.find((r)=>r?.id === commentId);
    if (targetComment && updateCommentBody) updateCommentBody(commentId, markerRef, targetComment.body.value, (0, $8i27m.CommentType).INLINE, targetComment.version.by?.displayName);
};
module.exports["refreshCommentThread"] = $895e8bda1c5e4d1e$export$15e2805385ec0eed;
module.exports["handleAddNewCommentThread"] = $895e8bda1c5e4d1e$export$e136ff0cd91112e0;
module.exports["handleAddedReplyInCommentThread"] = $895e8bda1c5e4d1e$export$120fd6a8527dd6bd;
module.exports["handleEditedComment"] = $895e8bda1c5e4d1e$export$7652b163bd2668c5;

});

parcelRegister("3B9cR", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $7d2c123586cab1f2$export$5fa1043645dd2c26 = (0, $eSUdr.default)`query InlineCommentQuery($annotationId:String$pageId:ID!$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRef:$annotationId pageId:$pageId contentStatus:$contentStatus){nodes{replies{id parentId body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized links{webui editui}author{displayName permissionType profilePicture{path}...on KnownUser{accountId}}location{type}version{by{displayName}when number}permissions{isEditable isRemovable isResolvable}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){reactionsCount ari containerAri reactionsSummaryForEmoji{emojiId count reacted id}}}version{by{displayName}when number}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved resolvedTime resolvedUser}}}id body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized links{webui editui}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}permissions{isEditable isRemovable isResolvable}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){reactionsCount ari containerAri reactionsSummaryForEmoji{emojiId count reacted id}}}}}`;
module.exports["InlineCommentQuery"] = $7d2c123586cab1f2$export$5fa1043645dd2c26;

});

parcelRegister("bMmYR", function(module, exports) {
/**
 * Sleep an async context for timeoutMs milliseconds
 *
 * Note this does not block but instead sets a timeout
 *
 * @param timeoutMs The timeout in milliseconds
 * @returns {Promise} A promise that resolves after timeoutMs milliseconds
 */ const $e3747894d76f1f8c$var$sleep = (timeoutMs)=>new Promise((resolve)=>setTimeout(resolve, timeoutMs));
const $e3747894d76f1f8c$export$9369b12211e1fce4 = (action, { backOff: backOff = true, jitter: jitter = true, timeout: timeout = 2000, maxAttempts: maxAttempts = 3 } = {}, shouldRetry)=>{
    const recursiveRetry = async (attempt)=>{
        let nextTryIn = null;
        if (attempt < maxAttempts) {
            const jitterFactor = jitter ? 1 + Math.random() : 1;
            const backOffFactor = backOff ? Math.pow(2, attempt) : 1;
            nextTryIn = timeout * backOffFactor * jitterFactor;
        }
        try {
            return await action(attempt, nextTryIn);
        } catch (ex) {
            if (nextTryIn === null) throw ex;
            if (shouldRetry && !await shouldRetry(ex)) throw ex;
            await $e3747894d76f1f8c$var$sleep(nextTryIn);
            return await recursiveRetry(attempt + 1);
        }
    };
    return recursiveRetry(0);
};
module.exports["retry"] = $e3747894d76f1f8c$export$9369b12211e1fce4;

});

parcelRegister("btQhd", function(module, exports) {
/* EditorWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $T1bCI = parcelRequire("T1bCI");


var $a4TK8 = parcelRequire("a4TK8");


var $2XqLN = parcelRequire("2XqLN");


var $h3X17 = parcelRequire("h3X17");


var $inPa6 = parcelRequire("inPa6");


var $iRRvH = parcelRequire("iRRvH");


var $5vi32 = parcelRequire("5vi32");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $9wGTI = parcelRequire("9wGTI");


var $jxpvN = parcelRequire("jxpvN");


var $hrAmX = parcelRequire("hrAmX");


var $7aRa9 = parcelRequire("7aRa9");


var $6MSEP = parcelRequire("6MSEP");


var $dPJCf = parcelRequire("dPJCf");


var $6jB9o = parcelRequire("6jB9o");


var $1mHQU = parcelRequire("1mHQU");


var $5pjrL = parcelRequire("5pjrL");


var $601vk = parcelRequire("601vk");


var $wtSEP = parcelRequire("wtSEP");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $4PPzL = parcelRequire("4PPzL");


var $9Z1sw = parcelRequire("9Z1sw");


var $eSLr0 = parcelRequire("eSLr0");


var $sLZsl = parcelRequire("sLZsl");


var $8GzJ6 = parcelRequire("8GzJ6");


var $S6mif = parcelRequire("S6mif");


var $5MyXJ = parcelRequire("5MyXJ");


var $bQm3c = parcelRequire("bQm3c");


var $426PF = parcelRequire("426PF");


var $hp2SH = parcelRequire("hp2SH");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $iVU5h = parcelRequire("iVU5h");


var $iSXh4 = parcelRequire("iSXh4");


var $hNtOj = parcelRequire("hNtOj");


var $bUSKZ = parcelRequire("bUSKZ");


var $fBNZi = parcelRequire("fBNZi");


var $2tHI8 = parcelRequire("2tHI8");


var $4R7P9 = parcelRequire("4R7P9");


var $2ClJD = parcelRequire("2ClJD");

const $f5a9a69398726f05$var$HEARTBEAT_ERROR_FLAGS = [
    'tenant-unavailable',
    'unauthorised',
    'UNAUTHORIZED'
];
const $f5a9a69398726f05$var$EditorSuccessFlags = (0, $7aRa9.withFlags)((0, $601vk.EditorFlags)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5a9a69398726f05$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { bannerHeight: bannerHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kn4d69": (0, $7sObp.default)(__cmplp.bannerHeight, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq",
            __cmplp.bannerHeight > 0 ? "_4t3i2ld4" : "_4t3i1kxc",
            __cmplp.className
        ])
    });
});
const $f5a9a69398726f05$var$WithPanels = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _4t3i1osq _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $f5a9a69398726f05$var$PanelWrapper = ({ showPanel: showPanel, children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, children);
};
/* eslint-enable @typescript-eslint/no-unused-vars */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5a9a69398726f05$var$Panel = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $f5a9a69398726f05$var$PanelWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1o9zidpf _2lx21bp4",
            __cmplp?.showPanel ? "_1e0c1txw" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $f5a9a69398726f05$var$getFlagData = (0, $2XqLN.default)((flagData)=>flagData, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $f5a9a69398726f05$export$c0ee4c2a5005a714 = ({ attribution: attribution, forceDisableEditor: forceDisableEditor, collabEditState: collabEditState, contentType: contentType, contentId: contentId, children: children, isUnpublishedDraft: isUnpublishedDraft, editorActions: editorActions, heartbeatError: heartbeatError, stopHeartbeatCallback: stopHeartbeatCallback, saveDraftError: saveDraftError, isLivePage: isLivePage, editorDisabled: editorDisabled })=>{
    const { includeTopNav: includeTopNav } = (0, $42omo.useContext)((0, $jxpvN.BannerContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { collabEditInitialized: collabEditInitialized, collabEditError: collabEditError, collabRecoveryError: collabRecoveryError } = collabEditState;
    const [showCreateFromExtensionFlag, setShowCreateFromExtensionFlag] = (0, $42omo.useState)({
        showFlag: false,
        flagData: undefined
    });
    const [showRestoreSuccessFlag, setShowRestoreSuccessFlag] = (0, $42omo.useState)(false);
    const [blogifyConversionSuccess, setBlogifyConversionSuccess] = (0, $42omo.useState)({
        showFlag: false,
        flagData: undefined
    });
    const [heartbeatErrorFlag, setHeartbeatErrorFlag] = (0, $42omo.useState)({
        showFlag: false,
        heartbeatError: undefined
    });
    const [isAutoConverted] = (0, $sLZsl.useAutoConvertState)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    const previousHasSaveDraftError = (0, $42omo.useRef)(false);
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    // Analytics
    const migratedRecently = (0, $bUSKZ.useMigratedRecently)(contentId);
    // track publish experience in page migration
    // copied from ContentEditorBindingsComponent
    if (migratedRecently) experienceTracker.start({
        name: (0, $irVI7.MIGRATE_PAGE_PUBLISH_EXPERIENCE),
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH
    });
    // Show a draft create success flag if this draft was created from the create page extension
    (0, $42omo.useEffect)(()=>{
        // Ensure editor is ready
        if (collabEditInitialized && !editorDisabled) {
            const parentContentId = (0, $6jB9o.getParentContentId)();
            if (parentContentId) {
                // Get the parent page title & show a draft create success flag
                let flagTimeout;
                // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
                (0, $hp2SH.getApolloClient)().query({
                    query: (0, $426PF.PageTitleQuery),
                    variables: {
                        contentId: parentContentId
                    }
                }).then((result)=>{
                    const parentTitle = result.data?.singleContent?.title;
                    flagTimeout = setTimeout(()=>{
                        setShowCreateFromExtensionFlag({
                            showFlag: true,
                            flagData: {
                                parentTitle: parentTitle,
                                parentContentId: parentContentId
                            }
                        });
                    }, 1000);
                }).catch((e)=>{
                    if ((0, $1uFM6.isUnauthorizedError)(e) || (0, $95rLf.isExpectedApolloError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
                });
                return ()=>{
                    clearTimeout(flagTimeout);
                };
            }
        }
    }, [
        collabEditInitialized,
        editorDisabled
    ]);
    const showBlogifyConversionSuccessFlag = blogifyConversionSuccess.showFlag;
    const blogifyConversionSuccessFlagData = blogifyConversionSuccess.flagData;
    const handleRestore = (0, $42omo.useCallback)((_delta, response)=>{
        const { trigger: trigger } = response?.pageUpdated || {};
        const { accountId: accountId } = response || {};
        if (trigger === 'restore') // Show this flag only if the same user triggered the restore
        // Otherwise, useUpdateEvent handles when a different user restores
        return !showRestoreSuccessFlag && userId === accountId && setShowRestoreSuccessFlag(true);
        return false;
    }, [
        showRestoreSuccessFlag,
        userId
    ]);
    const onBlogifySubscriptionEvent = (0, $42omo.useCallback)((_eventName, response)=>{
        // force disable NCS editor whenever page is converted to blogpost
        forceDisableEditor && forceDisableEditor(true);
        !showBlogifyConversionSuccessFlag && response?.pageBlogified && setBlogifyConversionSuccess({
            showFlag: true,
            flagData: response?.pageBlogified
        });
    }, [
        forceDisableEditor,
        showBlogifyConversionSuccessFlag
    ]);
    /**
   * To ensure that the editor is the correct height and doesn't have double scrollbars,
   */ const panelHeight = (0, $2tHI8.useGeneralWebPanelHeight)();
    (0, $42omo.useEffect)(()=>{
        if (heartbeatError) {
            if (heartbeatError.reason === 'tenant-unavailable') forceDisableEditor(true);
            else if ((0, $5MyXJ.isPermissionError)(heartbeatError)) stopHeartbeatCallback();
            if (heartbeatErrorFlag.heartbeatError?.reason !== heartbeatError.reason) // Only update error flag data if error is different
            setHeartbeatErrorFlag({
                showFlag: $f5a9a69398726f05$var$HEARTBEAT_ERROR_FLAGS.includes(heartbeatError.reason),
                heartbeatError: heartbeatError
            });
        }
    // exclude heartbeatErrorFlag.heartbeatError?.reason from dep list to prevent firing twice in a row
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        heartbeatError,
        forceDisableEditor,
        stopHeartbeatCallback
    ]);
    const { isAMN: isAMN, isRecurringParent: isRecurringParent } = (0, $iSXh4.useAutomatedMeetingNotesPageProperties)(contentId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (!isLivePage && isAMN) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'editAMNPage',
                attributes: {
                    isRecurringParent: isRecurringParent,
                    referralSource: (0, $iVU5h.getAMNReferralSourceFromQueryParam)()
                }
            }
        }).fire();
    }, [
        contentId,
        isAMN,
        isRecurringParent,
        createAnalyticsEvent,
        isLivePage
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        subscriberId: 'EditorWrapperSubscriptionPageRestore',
        onDataReceived: handleRestore,
        delta: 'pageUpdated'
    });
    // GraphQL subscription for page blogified event
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        subscriberId: 'EditorWrapperSubscription',
        delta: 'pageBlogified',
        skip: // only listen for blogify events on pages
        contentType === 'blogpost',
        onDataReceived: onBlogifySubscriptionEvent
    });
    // Update the URL of the draft with new space key
    // 1. when another users move the page to different space
    // 2. when user returns to a bookmarked page which has since been moved
    (0, $fBNZi.useSpaceKeyWatcher)({
        contentType: contentType
    });
    (0, $42omo.useEffect)(()=>{
        // Disable editor when saveDraftError exists, re-enable when error is reset
        if (saveDraftError) {
            forceDisableEditor(true);
            previousHasSaveDraftError.current = true;
        }
        if (saveDraftError === null && previousHasSaveDraftError.current === true) {
            // saveDraftError gets set to null explicitely when reset
            forceDisableEditor(false);
            previousHasSaveDraftError.current = false;
        }
    }, [
        saveDraftError,
        forceDisableEditor
    ]);
    if (collabRecoveryError) {
        // Collab Reset mutation can return 403 or 404 directly from Confluence upon editor loading (i.e. perms/page deleted hasn't changed during editing session, so no flag)
        if (collabRecoveryError instanceof (0, $S6mif.CollabRecoveryErrorType) && collabRecoveryError.status === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6MSEP.RestrictedPage), {
            accessType: "edit",
            contentId: contentId
        });
        else if (collabRecoveryError instanceof (0, $S6mif.CollabRecoveryErrorType) && collabRecoveryError.status === 404) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null);
    }
    const isResourceDeletedOrArchived = collabEditError && 'reason' in collabEditError && collabEditError.reason === (0, $5pjrL.NATIVE_COLLAB_ERROR_REASONS).RESOURCE_DELETED;
    if (collabEditError?.status === 403) {
        // The collab service has emitted an error.
        // Cases for the 403:
        //  (1) on initial editor load when the collab provider is not initialized
        //  (2) user's permissions are revoked during the editing session.
        //  (3) page was deleted or archived: if this is the case, reason will be NATIVE_COLLAB_ERROR_REASONS.RESOURCE_DELETED
        // Most of the time when a 403 occurs, we want to kick the user out of the editor, and in the second case we want to show an error flag explaining that permissions have changed.
        // If we're on a live page and the page was deleted or archived, we don't want to show <NotFound /> nor kick the user out. Instead we expect the editor to be disabled and we'll show a flag. (This also helps resolve a race condition where <NotFound /> can be shown before the archiving user gets redirected.)
        if (!isLivePage || isLivePage && !isResourceDeletedOrArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, collabEditInitialized && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
            collabEditError: collabEditError
        }), isResourceDeletedOrArchived ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6MSEP.RestrictedPage), {
            accessType: "edit",
            contentId: contentId
        }));
        else if (isLivePage && isResourceDeletedOrArchived) // Stop the heartbeat callback to prevent it from kicking the user out of the editor. We want the user to stay in the editor with a flag visible, until they refresh (or if they're the archiver, are redirected).
        stopHeartbeatCallback();
    }
    const checkPermissionsErrorHandler = (0, $hNtOj.ssrPermissionsErrorHandler).getRestrictedRoute() === 'edit';
    if (!isTransition && checkPermissionsErrorHandler) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6MSEP.RestrictedPage), {
        accessType: "edit",
        contentId: contentId
    });
    if ((0, $5MyXJ.isPermissionError)(heartbeatError)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
        heartbeatError: heartbeatError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6MSEP.RestrictedPage), {
        accessType: "edit",
        contentId: contentId
    }));
    if (saveDraftError) {
        // For non 403 and non 404 saveDraft errors, we still want to render editor content, but in disabled state
        if (saveDraftError.statusCode === 403 || saveDraftError.statusCode === 404) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
            saveDraftError: saveDraftError
        }), saveDraftError.statusCode === 403 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6MSEP.RestrictedPage), {
            accessType: "edit",
            contentId: contentId
        }), saveDraftError.statusCode === 404 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null));
    }
    return(// TODO: display ADFParseError if passed in as a prop (from content reconciliation)
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        modal: true,
        attribution: attribution
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>// The wiki-content class name is required to avoid breaking macros that rely on DOM selectors
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$Wrapper // We want to set the banner height to 0 when in Embedded Confluence because banners are inserted in the
        , {
            // BannerContainer component, which is rendered in the PageLayout component, which is not rendered in Embedded Confluence.
            bannerHeight: isEmbeddedConfluence ? 0 : bannerState.getTotalHeight(includeTopNav) + panelHeight,
            "data-testid": "editor-wrapper",
            "data-fabric-mode": isUnpublishedDraft ? 'create' : 'edit',
            "data-content-subtype": isLivePage ? 'live' : undefined,
            className: "wiki-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$WithPanels, null, (0, $9wGTI.fg)('confluence_annotate_3p_web_panel') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
            name: "atl-general-web-panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$Panel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$Panel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first"
        })), children, !isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$Panel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
            location: (0, $eSLr0.ATL_EDITOR_SAVEBAR)
        }))), (0, $9wGTI.fg)('confluence_annotate_3p_web_panel_footer') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
            name: "atl-footer-web-panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$Panel, {
            showPanel: false,
            "data-testid": "atl-footer-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
            location: (0, $eSLr0.ATL_FOOTER)
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$Panel, {
            showPanel: false,
            "data-testid": "atl-footer-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
            location: (0, $eSLr0.ATL_FOOTER)
        })), heartbeatErrorFlag.showFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
            heartbeatError: heartbeatErrorFlag.heartbeatError
        }), collabEditError && (collabEditError.status === 500 || collabEditError.code === (0, $h3X17.PROVIDER_ERROR_CODE).LOCKED) && // unhandled error, no recovery steps at this point
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
            collabEditError: collabEditError
        }), collabRecoveryError && collabRecoveryError instanceof (0, $S6mif.CollabRecoveryErrorType) && collabRecoveryError.status === 500 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
            collabRecoveryError: collabRecoveryError
        }), isLivePage && collabEditError?.status === 403 && isResourceDeletedOrArchived && // If page is archived or deleted while on a live page, show a flag
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
            collabEditError: collabEditError
        }), showRestoreSuccessFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$EditorSuccessFlags, {
            flagData: $f5a9a69398726f05$var$getFlagData({
                [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).RESTORE_CONTENT_SUCCESS]: true
            }),
            contentId: contentId,
            contentType: contentType,
            isUnpublishedDraft: isUnpublishedDraft
        }), showBlogifyConversionSuccessFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$EditorSuccessFlags, {
            flagData: $f5a9a69398726f05$var$getFlagData({
                [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).BLOGIFY_BLOGPOST_SUCCESS]: true,
                ...blogifyConversionSuccessFlagData
            }),
            contentId: contentId,
            contentType: contentType,
            isUnpublishedDraft: isUnpublishedDraft
        }), showCreateFromExtensionFlag.showFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$EditorSuccessFlags, {
            flagData: $f5a9a69398726f05$var$getFlagData({
                [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CREATED_FROM_EXTENSION]: true,
                ...showCreateFromExtensionFlag.flagData
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4R7P9.MigrationSuccessFlag), {
            contentId: contentId
        }), editorActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ClJD.SameFileNameWarningFlag), {
            editorActions: editorActions,
            contentId: contentId
        }) : null, isAutoConverted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8GzJ6.EditorConversionModal), null) : null, saveDraftError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
            saveDraftError: saveDraftError
        })))));
};
module.exports["EditorWrapper"] = $f5a9a69398726f05$export$c0ee4c2a5005a714;

});

parcelRegister("jxpvN", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $205998aae8e9bd72$export$60bd66ed7962b851 = /*#__PURE__*/ (0, $42omo.createContext)({
    includeTopNav: true
});
$205998aae8e9bd72$export$60bd66ed7962b851.displayName = 'BannerContext';
module.exports["BannerContext"] = $205998aae8e9bd72$export$60bd66ed7962b851;

});

parcelRegister("hrAmX", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $1dnxO = parcelRequire("1dnxO");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.indexOf(inArray.filter((banner)=>banner.name === name)[0]);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $T1bCI.Container) {
    constructor(props = {}){
        super();
        this.topNavHeight = void 0;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray[index].height = height;
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        const navHeight = (0, $1dnxO.getIsNav4Enabled)() ? 48 : 56;
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.state.banners = props.initialState?.banners || [];
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("6MSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9387550ed869acb8$export$4242cfff65d64b16 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "M3-19",
    name: "RestrictedPage",
    loader: async ()=>(await (parcelRequire("6COeq"))).RestrictedPage
});
module.exports["RestrictedPage"] = $9387550ed869acb8$export$4242cfff65d64b16;

});

parcelRegister("6COeq", function(module, exports) {

let $4d2d41aa9940d898$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4d2d41aa9940d898$var$load("6wr18"),
    $4d2d41aa9940d898$var$load("2F69B"),
    $4d2d41aa9940d898$var$load("ffEVr"),
    $4d2d41aa9940d898$var$load("hhss7"),
    $4d2d41aa9940d898$var$load("kUiwW")
]).then(()=>parcelRequire('3kPYw'));

});

parcelRegister("6jB9o", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $9wGTI = parcelRequire("9wGTI");


var $1NBp8 = parcelRequire("1NBp8");


var $7PLO8 = parcelRequire("7PLO8");


var $1mHQU = parcelRequire("1mHQU");


var $4iY7F = parcelRequire("4iY7F");

const $c31ff9c3561eb614$var$i18n = {
    blogifySuccessTitle: {
        id: 'editor-flags.blogify.blogpost.success.title',
        defaultMessage: 'Page converted to a blog post',
        description: 'The title of the flag shown in the editor when someone convert a page to blogpost'
    },
    blogifySuccessMessage: {
        id: 'editor-flags.blogify.blogpost.success.message',
        defaultMessage: "{displayName} just converted this page to a <alink>blog post</alink>, which includes the changes you\u2019ve made so far.",
        description: 'The body of the flag shown in the editor when someone convert a page to blogpost'
    },
    restoreTitle: {
        id: 'editor-flags.restore-page.title',
        defaultMessage: 'Previous version restored',
        description: 'Title for flag that appears when another user restores a previous version of the page'
    },
    restoreMessage: {
        id: 'editor-flags.restore.page.success.message',
        defaultMessage: 'Recent changes may have been overwritten. Check the <alink>page history</alink> for details.',
        description: 'The body of the flag shown in the editor when someone revert the page/blogpost to previous version in page history'
    },
    extensionCreateTitle: {
        id: 'editor-flags.extension-create.title',
        defaultMessage: 'New draft created',
        description: 'Title for flag that appears when a draft is created by the /create Confluence page extension from another page'
    },
    extensionCreateMessage: {
        id: 'editor-flags.extension-create.message',
        defaultMessage: "There\u2019s now a link to this draft on <alink>{parentPage}</alink>. All of your changes have been saved.",
        description: 'The body of the flag shown in the editor when a draft is created by the /create Confluence page extension from another page'
    },
    extensionCreateParentPage: {
        id: 'editor-flags.extension-create.parent-page',
        defaultMessage: 'the previous page',
        description: 'Placeholder text for {parentPage} in `editor-flags.extension-create.message` when the parent page does not have a title'
    }
};
const $c31ff9c3561eb614$export$63605c1c0febbffe = (flags, formatMessage, { attributes: attributes, flagData: flagData }, createAnalyticsEvent)=>{
    const { contentType: contentType, spaceKey: spaceKey, contentId: contentId } = attributes;
    if (flagData) {
        if (flagData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).RESTORE_CONTENT_SUCCESS]) flags.showFlag({
            type: 'success-circle',
            title: formatMessage($c31ff9c3561eb614$var$i18n.restoreTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$c31ff9c3561eb614$var$i18n.restoreMessage,
                values: {
                    contentType: contentType,
                    alink: (0, $4iY7F.getPageHistoryLink)(attributes)
                }
            }),
            messageType: 'transactional',
            messageId: 'editor-flags-version-restore-success'
        });
        else if (flagData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).BLOGIFY_BLOGPOST_SUCCESS]) {
            const displayName = flagData?.converterDisplayName;
            flags.showFlag({
                type: 'success-circle',
                title: formatMessage($c31ff9c3561eb614$var$i18n.blogifySuccessTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$c31ff9c3561eb614$var$i18n.blogifySuccessMessage,
                    values: {
                        displayName: displayName || formatMessage({
                            id: "editor.page.moved.message.unknown.mover"
                        }),
                        alink: (...chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__page-experienc') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                                target: "_blank",
                                href: (0, $1NBp8.EDIT_BLOG_V2).toUrl({
                                    spaceKey: spaceKey,
                                    contentId: contentId,
                                    contentType: 'blog'
                                }, {
                                    query: {
                                        draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                                    }
                                })
                            }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                                target: "_blank",
                                href: (0, $1NBp8.EDIT_BLOG_V2).toUrl({
                                    spaceKey: spaceKey,
                                    contentId: contentId,
                                    contentType: 'blog'
                                }, {
                                    query: {
                                        draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                                    }
                                })
                            }, chunks)
                    }
                }),
                messageType: 'transactional',
                messageId: 'editor-flags-blogify-success'
            });
        } else if (flagData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CREATED_FROM_EXTENSION]) {
            const { parentContentId: parentContentId, parentTitle: parentTitle } = flagData;
            const parentUrl = (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                contentType: 'pages',
                spaceKey: spaceKey,
                contentId: parentContentId
            });
            const handleClick = (event)=>{
                event.preventDefault();
                // Open the parent page in the existing tab if it hasn't been closed
                const parentWin = window.open('', parentContentId);
                parentWin?.focus();
                // If tab was closed, navigate new tab to the parent page URL
                if (parentWin && !parentWin.location.host) // eslint-disable-next-line no-restricted-syntax
                parentWin.location.assign(parentUrl);
                if (createAnalyticsEvent) createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'parentPageLink',
                        actionSubjectId: 'inlineCreateOneStepExperiment',
                        source: 'SuccessFlag',
                        attributes: {
                            contentId: contentId,
                            contentType: contentType,
                            parentContentId: parentContentId
                        }
                    }
                }).fire();
            };
            flags.showFlag({
                type: 'success-circle',
                title: formatMessage($c31ff9c3561eb614$var$i18n.extensionCreateTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$c31ff9c3561eb614$var$i18n.extensionCreateMessage,
                    values: {
                        parentPage: !!parentTitle ? parentTitle : formatMessage($c31ff9c3561eb614$var$i18n.extensionCreateParentPage),
                        alink: (...chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__page-experienc') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                                href: parentUrl,
                                target: parentContentId,
                                onClick: handleClick
                            }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                                href: parentUrl,
                                target: parentContentId,
                                onClick: handleClick
                            }, chunks)
                    }
                }),
                messageType: 'transactional',
                messageId: 'editor-flags-create-from-extension-success'
            });
        }
    }
};
const $c31ff9c3561eb614$export$4db4941fd1416d17 = ()=>{
    // createdFrom parameter means draft was created by the create page extension from another page
    const urlParams = new URLSearchParams(window.location.search);
    const parentContentId = urlParams.get('createdFrom');
    if (parentContentId) {
        // Remove createdFrom param from url without reloading
        urlParams.delete('createdFrom');
        const newParams = urlParams.size > 0 ? `?${urlParams.toString()}` : '';
        window.history.pushState({}, '', `${window.location.pathname}${newParams}`);
        // Show flag if the parentContentId is a number
        // and this was an auto redirect from parent page, i.e. not copy/pasted url
        if (/^\d+$/.test(parentContentId) && !!document.referrer) return parentContentId;
    }
    return null;
};
module.exports["initializeSuccessFlag"] = $c31ff9c3561eb614$export$63605c1c0febbffe;
module.exports["getParentContentId"] = $c31ff9c3561eb614$export$4db4941fd1416d17;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    visitedLink: "_ect41gqc _10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: preventedClassName, // @ts-expect-error
style: preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)(appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    }) : /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("1mHQU", function(module, exports) {
const $bacd8f7695bdf465$export$c4d5263a0e2e072d = {
    DUPLICATE_TITLE: 'A page with this title already exists',
    DUPLICATE_TITLE_WITHIN_EDITOR: 'Give this page a unique title to move',
    DUPLICATE_EDIT_PAGE_BLOG_TITLE: 'Cannot convert draft, a blog with this title already exists',
    DUPLICATE_VIEW_PAGE_BLOG_TITLE: 'Cannot convert page, a blog with this title already exists',
    EMPTY_TITLE: 'empty-title',
    TITLE_REQUIRED: 'title-required',
    AI_GENERATED_TITLE: 'Review your AI-generated title',
    AI_GENERATED_TITLE_FROM_PASTE: 'AI generated title from paste',
    AI_GENERATED_TITLE_ERROR: "We couldn\u2019t generate a title for you",
    INVALID_PAGE_TITLE: 'You need to include the title to update a page.',
    // this error message is returned with status 400 in fabric editor when page with duplicate title is published
    DUPLICATE_TITLE_WITH_BAD_EXCEPTION: 'com.atlassian.confluence.api.service.exceptions.api.BadRequestException: A page with this title already exists',
    OTHER_PUBLISH: 'other-publish',
    OTHER_RESTORE: 'other-restore',
    CONTENT_RECONCILIATION: 'content-reconciliation',
    TITLE_TOO_LONG: 'Title cannot be longer than 255 characters.',
    MEDIA_FAILED: "Can't publish changes",
    SYNCHRONY_WAS_NOT_CONNECTED_ERROR: 'An unexpected error occurred after connecting to editing services.',
    SYNCHRONY_WAS_NOT_INITIALIZED_ERROR: 'An unexpected error occurred when connecting to editing services.',
    SYNCHRONY_ACK_MISSING_ERROR: 'An unexpected error occurred after requesting the final editor state.',
    FOUND_INVALID_TEMPLATE_VARIABLE: 'Found multiple variables with the same name but different types',
    DUPLICATE_TITLE_TEMPLATE: 'Template title already used, please use a different name.',
    TEMPLATE_CONTENT_PARSING_FAILURE: 'template-content-parsing-failure',
    SYNCHRONY_UNEXPECTED_ERROR: 'An unexpected error occurred while requesting the final editor state.',
    PUBLISH_TIME_TOO_LONG_ERROR: 'An error occurred and it took too long to publish the page.',
    SCHEDULE_PUBLISH_ERROR: 'An error occurred when scheduling the publish.',
    CANCEL_SCHEDULE_PUBLISH_ERROR: 'An error occured when cancelling the scheduled publish.',
    SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR: 'Add a title, and you can set a date and time for publishing.',
    REVERT_CONTENT_ERROR: 'An error occurred while trying to revert the page.',
    PARENT_NOT_PUBLISHED: 'com.atlassian.confluence.api.service.exceptions.api.BadRequestException: Could not publish draft. Parent page has not been published.',
    RESTORE_CONTENT_SUCCESS: 'Page/blogpost has been reverted to last version',
    BLOGIFY_BLOGPOST_SUCCESS: 'Page converted to a blog post',
    TEMPLATE_PUBLISH_TAKING_LONG: 'Bear with us, this is taking a moment.',
    COLLAB_INIT_TIMEOUT_TAKING_TOO_LONG: 'Collab init event is taking too long',
    ERROR_MESSAGE_WITH_BAD_EXCEPTION: 'com.atlassian.confluence.api.service.exceptions.api.BadRequestException:',
    CONFLICT_DRAFT_VERSIONING: 'Draft versioning is not supported.',
    COLLAB_STATUS_ERROR: "Can't save changes.",
    TEMPLATE_INVALID_SPACEKEY_ERROR: 'Invalid spaceKeys.',
    TEMPLATE_BLANK_TITLE_ERROR: 'Template title cannot be null or empty string',
    CREATED_FROM_EXTENSION: 'Draft created from create page extension'
};
module.exports["ALLOWED_FLAG_MESSAGES"] = $bacd8f7695bdf465$export$c4d5263a0e2e072d;

});

parcelRegister("4iY7F", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2Nwuj = parcelRequire("2Nwuj");


var $9wGTI = parcelRequire("9wGTI");


var $1NBp8 = parcelRequire("1NBp8");

const $35f324be8ccb2751$export$be60689b3b3efd2c = (attributes)=>{
    const { spaceKey: spaceKey, contentId: contentId, contentSlug: contentSlug } = attributes;
    return (...chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__page-experienc') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            target: "_blank",
            href: (0, $1NBp8.CONTENT_HISTORY).toUrl({
                spaceKey: spaceKey,
                contentId: contentId,
                contentSlug: contentSlug
            })
        }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            target: "_blank",
            href: (0, $1NBp8.CONTENT_HISTORY).toUrl({
                spaceKey: spaceKey,
                contentId: contentId,
                contentSlug: contentSlug
            })
        }, chunks);
};
module.exports["getPageHistoryLink"] = $35f324be8ccb2751$export$be60689b3b3efd2c;

});

parcelRegister("5pjrL", function(module, exports) {
/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $7aRa9 = parcelRequire("7aRa9");

var $1944a553ea5f1b71$export$b0df660525fc873b = /*#__PURE__*/ function(NATIVE_COLLAB_ERROR_REASONS) {
    // Native collab errors propagate from Confluence BE in S2S request to permission refresh and then to websocket via atlassian-frontend/src/packages/editor/collab-provider/src/error-code-mapper.ts
    NATIVE_COLLAB_ERROR_REASONS["RESOURCE_DELETED"] = "RESOURCE_DELETED";
    return NATIVE_COLLAB_ERROR_REASONS;
}({});
const $1944a553ea5f1b71$var$i18n = (0, $cgtv4.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    recoveryErrorTitle: {
        id: "editor-flags.error.recovery.title",
        defaultMessage: "Something went wrong while loading the editor"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    recoveryErrorBody: {
        id: "editor-flags.error.recovery.body",
        defaultMessage: "Your changes are safe. Please refresh and try again."
    },
    siteMaintenanceTitle: {
        id: "editor-flags.error.tenant.suspended.title",
        defaultMessage: "You can\u2019t edit this content right now"
    },
    siteMaintenanceDescription: {
        id: "editor-flags.error.tenant.suspended.description",
        defaultMessage: "Your Atlassian Cloud site is unavailable due to scheduled maintenance."
    },
    permissionRemovedTitle: {
        id: "fabric.editor.permission.removed.title",
        defaultMessage: "We can\u2019t show this content"
    },
    permissionRemovedDescription: {
        id: "fabric.editor.permission.removed.description",
        defaultMessage: "The permissions for this content were changed. Contact an admin for help."
    },
    pageRemovedTitle: {
        id: "fabric.editor.page.removed.title",
        defaultMessage: "This page was recently archived or deleted"
    },
    pageRemovedDescription: {
        id: "fabric.editor.page.removed.description",
        defaultMessage: "Please refresh now."
    },
    genericServerErrorTitle: {
        id: "error.server-error.title",
        defaultMessage: "Something went wrong"
    },
    genericServerErrorBody: {
        id: "error.server-error.body",
        defaultMessage: "Please try again later."
    }
});
/**
 * Currently collab service errors are handled based on error status code, in the future we may want finer granularity
 * and use the error message to provide further information in flag description. See also EditorWrapper.tsx & EditorFlags.tsx
 */ const $1944a553ea5f1b71$var$collabEditErrorFlagContent = (formatMessage, statusCode, reason)=>{
    switch(statusCode){
        case 403:
            if (reason === "RESOURCE_DELETED") return {
                title: formatMessage($1944a553ea5f1b71$var$i18n.pageRemovedTitle),
                description: formatMessage($1944a553ea5f1b71$var$i18n.pageRemovedDescription)
            };
            return {
                title: formatMessage($1944a553ea5f1b71$var$i18n.permissionRemovedTitle),
                description: formatMessage($1944a553ea5f1b71$var$i18n.permissionRemovedDescription)
            };
        case 423:
            // tenant suspended / maintenance
            return {
                title: formatMessage($1944a553ea5f1b71$var$i18n.siteMaintenanceTitle),
                description: formatMessage($1944a553ea5f1b71$var$i18n.siteMaintenanceDescription)
            };
        case 500:
            // Generic error for unrecoverable 500s from Collab Service...
            return {
                title: formatMessage($1944a553ea5f1b71$var$i18n.genericServerErrorTitle),
                description: formatMessage($1944a553ea5f1b71$var$i18n.genericServerErrorBody)
            };
        default:
            break;
    }
};
const $1944a553ea5f1b71$var$heartbeatErrorFlagContent = (formatMessage, reason)=>{
    switch(reason){
        case 'unauthorised':
        case 'UNAUTHORIZED':
            return {
                title: formatMessage($1944a553ea5f1b71$var$i18n.permissionRemovedTitle),
                description: formatMessage($1944a553ea5f1b71$var$i18n.permissionRemovedDescription)
            };
        case 'tenant-unavailable':
            return {
                title: formatMessage($1944a553ea5f1b71$var$i18n.siteMaintenanceTitle),
                description: formatMessage($1944a553ea5f1b71$var$i18n.siteMaintenanceDescription)
            };
        default:
            break;
    }
};
const $1944a553ea5f1b71$var$confluenceErrorFlagContent = (formatMessage, statusCode)=>{
    if (!statusCode) return {
        title: formatMessage($1944a553ea5f1b71$var$i18n.genericServerErrorTitle),
        description: formatMessage($1944a553ea5f1b71$var$i18n.genericServerErrorBody)
    };
    if (statusCode === 403) return {
        title: formatMessage($1944a553ea5f1b71$var$i18n.permissionRemovedTitle),
        description: formatMessage($1944a553ea5f1b71$var$i18n.permissionRemovedDescription)
    };
    else if (statusCode === 404) return {
        title: formatMessage($1944a553ea5f1b71$var$i18n.pageRemovedTitle),
        description: formatMessage($1944a553ea5f1b71$var$i18n.pageRemovedDescription)
    };
    else if (statusCode === 503) return {
        title: formatMessage($1944a553ea5f1b71$var$i18n.siteMaintenanceTitle),
        description: formatMessage($1944a553ea5f1b71$var$i18n.siteMaintenanceDescription)
    };
};
const $1944a553ea5f1b71$export$37cc9ec36ef290a5 = ({ flags: flags, collabEditError: collabEditError, collabRecoveryError: collabRecoveryError, heartbeatError: heartbeatError, saveDraftError: saveDraftError })=>{
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        if (collabEditError) {
            const flagContent = $1944a553ea5f1b71$var$collabEditErrorFlagContent(intl.formatMessage, 'status' in collabEditError ? collabEditError.status : undefined, 'reason' in collabEditError ? collabEditError.reason : undefined);
            if (flagContent) flags.showErrorFlag({
                ...flagContent
            });
        } // Don't depend on `flags` since its updates will cause infinite spam
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (collabRecoveryError) flags.showErrorFlag({
            title: intl.formatMessage($1944a553ea5f1b71$var$i18n.recoveryErrorTitle),
            description: intl.formatMessage($1944a553ea5f1b71$var$i18n.recoveryErrorBody)
        });
         // Don't depend on `flags` since its updates will cause infinite spam
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabRecoveryError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (heartbeatError) {
            const flagContent = $1944a553ea5f1b71$var$heartbeatErrorFlagContent(intl.formatMessage, 'reason' in heartbeatError ? heartbeatError.reason : undefined);
            if (flagContent) flags.showErrorFlag({
                ...flagContent
            });
        } // Don't depend on `flags` since its updates will cause infinite spam
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        heartbeatError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (saveDraftError) {
            const flagContent = $1944a553ea5f1b71$var$confluenceErrorFlagContent(intl.formatMessage, saveDraftError.statusCode);
            if (flagContent) flags.showErrorFlag({
                ...flagContent
            });
        } // You guessed it! .....Don't depend on `flags` since its updates will cause infinite spam
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        saveDraftError
    ]);
    // Cleanup on component unmount
    (0, $42omo.useEffect)(()=>()=>void flags.hideAllFlags(), [
        flags
    ]);
    return null;
};
const $1944a553ea5f1b71$export$23602cd239c801ed = (0, $7aRa9.withFlags)($1944a553ea5f1b71$export$37cc9ec36ef290a5);
module.exports["NATIVE_COLLAB_ERROR_REASONS"] = $1944a553ea5f1b71$export$b0df660525fc873b;
module.exports["NativeCollabErrorFlags"] = $1944a553ea5f1b71$export$23602cd239c801ed;

});

parcelRegister("601vk", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $gmMgo = parcelRequire("gmMgo");


var $kyKWe = parcelRequire("kyKWe");


var $inPa6 = parcelRequire("inPa6");


var $ep3mz = parcelRequire("ep3mz");


var $7aRa9 = parcelRequire("7aRa9");


var $b3j2Y = parcelRequire("b3j2Y");


var $3jwuS = parcelRequire("3jwuS");


var $03Xmw = parcelRequire("03Xmw");


var $fb79u = parcelRequire("fb79u");


var $6jB9o = parcelRequire("6jB9o");


var $1mHQU = parcelRequire("1mHQU");


var $cHfGW = parcelRequire("cHfGW");


var $gQojb = parcelRequire("gQojb");

const $5f7518f04afd0b6f$export$8f60114e4ef36b27 = (0, $gmMgo.default)(({ flags: flags, nextTryIn: nextTryIn, statusCode: statusCode, flagData: flagData, errorData: errorData, intl: { formatMessage: formatMessage }, lastPublisher: lastPublisher, parentPageId: parentPageId, collabService: collabService, isUnpublishedDraft: isUnpublishedDraft })=>{
    const [{ contentSlug: contentSlug, contentId: contentId, spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { triggerPageConflictAnalytics: triggerPageConflictAnalytics } = (0, $gQojb.usePageConflictAnalytics)({
        contentId: contentId,
        contentType: contentType,
        collabService: collabService,
        source: 'EditorFlags',
        actionSubjectId: 'editor.flag'
    });
    const userInfoQueryResult = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query EditorFlagsUserPersonalInformationQuery($accountId:ID!){user:confluence_atlassianUser(id:$accountId){id displayName}}`, {
        variables: {
            accountId: lastPublisher || ''
        },
        // only make this query if the lastPublisher is defined and it is a publish/restore flag
        skip: !lastPublisher || !errorData || !errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_PUBLISH] && !errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_RESTORE]
    });
    // only make this query if the parentPageId is NOT defined and we have an error where we want link to the parent page
    const ancestorQuerySkipped = Boolean(parentPageId) || !contentId || !errorData || !errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).PARENT_NOT_PUBLISHED];
    const ancestorQueryResult = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query EditorFlagsContentAncestorsQuery($contentId:ID!){content(id:$contentId status:["current" "draft"]){nodes{id ancestors{id}}}}`, {
        variables: {
            contentId: contentId
        },
        skip: ancestorQuerySkipped
    });
    const [actualParentPageId, setActualParentPageId] = (0, $42omo.useState)(parentPageId);
    (0, $42omo.useEffect)(()=>{
        // when done loading, set to the parentId that was found, or "" if not found
        if (!ancestorQuerySkipped && !ancestorQueryResult.loading) setActualParentPageId(ancestorQueryResult.data?.content?.nodes?.[0]?.ancestors?.slice(-1)[0]?.id || parentPageId || '');
    }, [
        parentPageId,
        ancestorQueryResult,
        ancestorQuerySkipped
    ]);
    // Cleanup on component unmount
    (0, $42omo.useEffect)(()=>()=>void flags.hideAllFlags(), [
        flags
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(errorData?.[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_PUBLISH] || errorData?.[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_RESTORE] || errorData?.[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).PARENT_NOT_PUBLISHED] && actualParentPageId === undefined) && !flagData) {
            const flagContent = (0, $cHfGW.buildEditorFlagMessage)({
                errorData: errorData,
                spaceKey: spaceKey,
                statusCode: statusCode,
                formatMessage: formatMessage,
                nextTryIn: nextTryIn,
                parentPageId: actualParentPageId,
                isUnpublishedDraft: isUnpublishedDraft,
                isLivePage: isLivePage
            });
            if (flagContent) {
                const flagId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
                flags.showErrorFlag({
                    id: flagId,
                    title: flagContent.title,
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $03Xmw.FlagDescription), {
                        flags: flags,
                        flagContent: flagContent,
                        flagId: flagId,
                        nextTryIn: nextTryIn
                    })
                });
                if (statusCode === 409) triggerPageConflictAnalytics(Object.keys(errorData ?? {}).filter((k)=>k.startsWith('com.atlassian.confluence.api.service.exceptions.ecosystem.ConflictException')), {});
            } else // If there is no errorData the value of flagProps is null
            // Clear the existing flags
            flags.hideAllFlags();
        }
    }, [
        isUnpublishedDraft,
        flags,
        flagData,
        nextTryIn,
        spaceKey,
        statusCode,
        errorData,
        lastPublisher,
        actualParentPageId,
        contentId,
        formatMessage,
        triggerPageConflictAnalytics,
        isLivePage
    ]);
    const showInfoFlag = (0, $42omo.useCallback)(()=>{
        const attributes = {
            contentType: contentType,
            spaceKey: spaceKey,
            contentId: contentId,
            contentSlug: contentSlug
        };
        return (0, $fb79u.initializeInfoFlag)(flags, formatMessage, attributes, isLivePage);
    }, // Subscribe returns a new flag object each rerender causing infinite rerendering when displaying a publish flag,
    // so we are excluding it from the dep array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        formatMessage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (errorData && (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_PUBLISH] || errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_RESTORE])) showInfoFlag()(userInfoQueryResult, {
            ...errorData
        });
    }, [
        userInfoQueryResult,
        errorData,
        showInfoFlag
    ]);
    const showSuccessFlag = (0, $42omo.useCallback)(()=>{
        const attributes = {
            contentType: contentType,
            spaceKey: spaceKey,
            contentId: contentId,
            contentSlug: contentSlug
        };
        (0, $6jB9o.initializeSuccessFlag)(flags, formatMessage, {
            attributes: attributes,
            flagData: flagData
        }, createAnalyticsEvent);
    // Subscribe returns a new flag object each rerender causing infinite re-rendering,
    // so we are excluding it from the dep array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formatMessage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (flagData) showSuccessFlag();
    }, [
        flagData,
        showSuccessFlag
    ]);
    return ancestorQueryResult?.error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: ancestorQueryResult.error
    }) : null;
});
const $5f7518f04afd0b6f$export$7220a8ff64533d72 = (0, $7aRa9.withFlags)($5f7518f04afd0b6f$export$8f60114e4ef36b27);
module.exports["EditorFlags"] = $5f7518f04afd0b6f$export$8f60114e4ef36b27;
module.exports["EditorErrorFlags"] = $5f7518f04afd0b6f$export$7220a8ff64533d72;

});

parcelRegister("03Xmw", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $7dc210c4acbee9cf$export$bc4f7e1226380dba = ({ flagContent: flagContent, nextTryIn: nextTryIn, flagId: flagId, flags: flags })=>{
    const [secondsLeft, setSecondsLeft] = (0, $42omo.useState)(nextTryIn ? Math.max(Math.round(nextTryIn / 1000), 0) : 0);
    const description = typeof flagContent.description === 'function' ? flagContent.description(secondsLeft) : flagContent.description;
    (0, $42omo.useEffect)(()=>{
        if (nextTryIn) {
            const flagInterval = setInterval(()=>setSecondsLeft((secondsLeft)=>secondsLeft - 1), 1000);
            return ()=>clearInterval(flagInterval);
        }
    }, [
        nextTryIn
    ]);
    // Clean the flag up if the flag is a count down flag
    // and the countdown reached its end
    if (nextTryIn && secondsLeft < 0) flags.hideFlag(flagId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "flag-description"
    }, description, flagContent.details && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "flag-details"
    }, flagContent.details));
};
module.exports["FlagDescription"] = $7dc210c4acbee9cf$export$bc4f7e1226380dba;

});

parcelRegister("fb79u", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1mHQU = parcelRequire("1mHQU");


var $4iY7F = parcelRequire("4iY7F");

const $e03997dfc3ec06ab$var$i18n = {
    publishTitle: {
        id: 'editor-flags.publish-page.title',
        defaultMessage: 'New version published',
        description: 'Title for flag that appears when a new version of the page is published'
    },
    publishMessage: {
        id: 'editor-flags.publish-page.known.user.message',
        defaultMessage: "{user} just published a new version of this page, which includes the changes you\u2019ve made so far",
        description: 'Message for flag that appears when a new version of the page is published'
    },
    restoreTitle: {
        id: 'editor-flags.restore-page.title',
        defaultMessage: 'Previous version restored',
        description: 'Title for flag that appears when another user restores a previous version of the page'
    },
    restoreOtherMessage: {
        id: 'editor-flags.restore-page.known.user.message',
        defaultMessage: '{user} just restored a prior version of this {contentType}. Recent changes may have been lost. Check the <alink>page history</alink> for details.',
        description: 'Message for flag that apprears when another user restores a previous version of the page'
    },
    unknownUser: {
        id: 'editor-flags.publish-page.known.user.name',
        defaultMessage: 'Another user',
        description: 'Alternate name when the user responsible for publish is not known'
    },
    anonymousUser: {
        id: 'editor-flags.publish-page.anonymous.user.name',
        defaultMessage: 'An anonymous user',
        description: 'Alternate name when anonymous user is responsible for publish'
    },
    reloadButton: {
        id: 'editor-flags.publish-page.actions.reload',
        description: 'Button label for button that causes a page reload',
        defaultMessage: 'Reload'
    }
};
const $e03997dfc3ec06ab$var$reloadPage = ()=>window.location.reload();
const $e03997dfc3ec06ab$var$displayLivePagePublishedFlag = (flags, formatMessage, user)=>{
    flags.showCustomFlag({
        title: formatMessage($e03997dfc3ec06ab$var$i18n.publishTitle),
        description: formatMessage($e03997dfc3ec06ab$var$i18n.publishMessage, {
            user: user
        }),
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    "data-testid": "quick-reload-reload-button"
                }, formatMessage($e03997dfc3ec06ab$var$i18n.reloadButton)),
                onClick: $e03997dfc3ec06ab$var$reloadPage
            }
        ]
    });
};
const $e03997dfc3ec06ab$var$getUserMessage = (formatMessage, queryResult)=>{
    let user;
    const displayName = queryResult?.data?.user?.displayName;
    /* There are 3 cases:
      1. error when making query : the other publisher is unknown and therefore default to "Another user"
      2. queryResult?.data?.user?.displayName is falsy but there is no error, the other publisher is anonymous user
      3. The other publisher is authenticated and there's no error in making query
     */ if (queryResult.error) // error when making query, publisher is unknown and therefore
    user = formatMessage($e03997dfc3ec06ab$var$i18n.unknownUser);
    else if (!displayName) // queryResult data is null, publisher is anonymous user
    user = formatMessage($e03997dfc3ec06ab$var$i18n.anonymousUser);
    else user = displayName;
    return user;
};
const $e03997dfc3ec06ab$var$handlePublishFlag = (flags, formatMessage, isLivePage, user)=>{
    if (isLivePage) $e03997dfc3ec06ab$var$displayLivePagePublishedFlag(flags, formatMessage, user);
    else flags.showInfoFlag({
        title: formatMessage($e03997dfc3ec06ab$var$i18n.publishTitle),
        description: formatMessage($e03997dfc3ec06ab$var$i18n.publishMessage, {
            user: user
        })
    });
};
const $e03997dfc3ec06ab$export$147dab68cb862647 = (flags, formatMessage, attributes, isLivePage = false)=>(queryResult, flagData)=>{
        if (!queryResult.loading) {
            const user = $e03997dfc3ec06ab$var$getUserMessage(formatMessage, queryResult);
            if (flagData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_PUBLISH]) {
                $e03997dfc3ec06ab$var$handlePublishFlag(flags, formatMessage, isLivePage, user);
                return;
            } else if (flagData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_RESTORE]) flags.showInfoFlag({
                title: formatMessage($e03997dfc3ec06ab$var$i18n.restoreTitle),
                description: formatMessage($e03997dfc3ec06ab$var$i18n.restoreOtherMessage, {
                    user: user,
                    alink: (0, $4iY7F.getPageHistoryLink)(attributes),
                    contentType: attributes.contentType ?? 'page'
                })
            });
        }
        return null;
    };
module.exports["initializeInfoFlag"] = $e03997dfc3ec06ab$export$147dab68cb862647;

});

parcelRegister("cHfGW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $iXCQx = parcelRequire("iXCQx");


var $jlIaF = parcelRequire("jlIaF");


var $9wGTI = parcelRequire("9wGTI");


var $jhwJP = parcelRequire("jhwJP");


var $1mHQU = parcelRequire("1mHQU");

// eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages
const $d33bb643a38eaa5e$var$i18nBase = (0, $cgtv4.defineMessages)({
    duplicatePageTitleHeader: {
        id: "editor-flags.save.page.exist.content.title",
        defaultMessage: "Give your page a unique name"
    },
    duplicateLivePageTitleHeader: {
        id: "editor-flags.save.live.page.exist.content.title",
        defaultMessage: "Give your doc a unique name"
    },
    duplicatePageTitleMessage: {
        id: "editor-flags.save.page.exist.message",
        defaultMessage: "Page names have to be unique within a space. Give your page a different name to publish it."
    },
    duplicateLivePageTitleMessage: {
        id: "editor-flags.save.live.page.exist.message",
        defaultMessage: "Live docs need unique names within a space. Give your doc a different name."
    },
    duplicateUpdatePageTitleMessage: {
        id: "editor-flags.save.update-page.exist.message",
        defaultMessage: "Page names have to be unique within a space. Give your page a different name to update it."
    },
    pageTitleInvalidTitleHeader: {
        id: "editor-flags.page.title.invalid.header",
        defaultMessage: "Invalid title - try again."
    },
    pageTitleUpdateInvalidTitleHeader: {
        id: "editor-flags.update-page.title.invalid.header",
        defaultMessage: "We can\u2019t update the page with that name."
    },
    pageTitleInvalidTitleMessage: {
        id: "editor-flags.page.title.invalid.message",
        defaultMessage: "Try another title, up to 255 characters."
    },
    pageTitleTooLongHeader: {
        id: "editor-flags.title.too.long.title",
        defaultMessage: "Your title is too long."
    },
    pageTitleTooLongMessage: {
        id: "editor-flags.title.too.long",
        defaultMessage: "The limit for titles is 255 characters."
    },
    duplicateTemplateTitleHeader: {
        id: "editor-flags.template.can.not.save.error.title.duplicate.title",
        defaultMessage: "A template with this name already exists"
    },
    duplicateTemplateTitleMessage: {
        id: "editor-flags.template.can.not.save.error.title.duplicate",
        defaultMessage: "Template names must be unique within a space. Give your template a different name to save it."
    },
    pageTooBigHeader: {
        id: "editor-flags.page.is.too.big.title",
        defaultMessage: "We can\u2019t save your content"
    },
    pageTooBigMessage: {
        id: "editor-flags.page.is.too.big",
        defaultMessage: "Pages larger than the 2MB limit are slow to load. Break your content into a couple pages and use the Include Page macro to display the content here."
    },
    templateTooBigHeader: {
        id: "editor-flags.template.is.too.big.title",
        defaultMessage: "We can\u2019t save your template"
    },
    templateTooBigMessage: {
        id: "editor-flags.template.is.too.big",
        defaultMessage: "Templates larger than the 2MB limit are slow to load. Break your content into a couple of templates."
    },
    connectionErrorHeader: {
        id: "editor-flags.offline.save.error.title",
        defaultMessage: "We\u2019re having trouble connecting right now"
    },
    connectionErrorMessage: {
        id: "editor-flags.offline.save.error",
        defaultMessage: "Give us a few seconds to reconnect, and you can resume your work."
    },
    templateConnectionParsingFailHeader: {
        id: "editor-flags.template.can.not.parse.content.title",
        defaultMessage: "We can\u2019t open this template"
    },
    templateConnectionParsingFailMessage: {
        id: "editor-flags.template.can.not.parse.content",
        defaultMessage: "This happens when a template contains broken or unsupported elements."
    },
    publishIsTakingTooLongHeader: {
        id: "editor-flags.error.delayed.publishing.title",
        defaultMessage: "We\u2019re having trouble publishing"
    },
    updateIsTakingTooLongHeader: {
        id: "editor-flags.error.delayed.updating.title",
        defaultMessage: "We\u2019re having trouble updating"
    },
    publishIsTakingTooLongMessage: {
        id: "editor-flags.error.delayed.publishing",
        defaultMessage: "We\u2019ll continue trying to publish. If it\u2019s taking too long, refresh the page and click {buttonText}."
    },
    updateIsTakingTooLongMessage: {
        id: "editor-flags.error.delayed.updating",
        defaultMessage: "We\u2019ll continue trying to update. If it\u2019s taking too long, refresh the page and click {buttonText}."
    },
    publishText: {
        id: "editor-flags.error.delayed.publishText",
        defaultMessage: "Publish"
    },
    updateText: {
        id: "editor-flags.error.delayed.updateText",
        defaultMessage: "Update"
    },
    schedulePublishErrorHeader: {
        id: "editor-flags.error.schedule.publish.title",
        defaultMessage: "We had an issue setting the schedule time"
    },
    schedulePublishErrorMessage: {
        id: "editor-flags.error.schedule.publish",
        defaultMessage: "Refresh the page and try again."
    },
    cancelScheduledPublishErrorHeader: {
        id: "editor-flags.error.cancel.scheduled.publish.title",
        defaultMessage: "We had an issue cancelling this scheduled publish"
    },
    cancelScheduledUpdateErrorHeader: {
        id: "editor-flags.error.cancel.scheduled.update.title",
        defaultMessage: "We had an issue cancelling this scheduled update"
    },
    cancelScheduledPublishErrorMessage: {
        id: "editor-flags.error.cancel.scheduled.publish",
        defaultMessage: "Refresh the page and try again."
    },
    schedulePublishNoHeaderErrorHeader: {
        id: "editor-flags.error.scheduled.publish.no-title-error.title",
        defaultMessage: "Your page needs a name"
    },
    schedulePublishNoHeaderErrorMessage: {
        id: "editor-flags.error.scheduled.publish.no-title-error",
        defaultMessage: "Add a title, and you can set a date and time for publishing."
    },
    scheduleUpdateNoHeaderErrorMessage: {
        id: "editor-flags.error.scheduled.update.no-title-error",
        defaultMessage: "Add a title, and you can set a date and time for updating."
    },
    defaultPublishErrorHeader: {
        id: "editor-flags.offline.save.error.generic.title",
        defaultMessage: "Your work is safe, but there\u2019s an issue"
    },
    defaultPublishErrorMessage: {
        id: "editor-flags.offline.save.error.generic",
        defaultMessage: "Refresh the page, and click Publish again."
    },
    defaultUpdateErrorMessage: {
        id: "editor-flags.offline.update.save.error.generic",
        defaultMessage: "Refresh the page, and click Update again."
    },
    defaultTemplateSaveErrorHeader: {
        id: "editor-flags.template.save.error.generic.title",
        defaultMessage: "There\u2019s an issue saving your template"
    },
    defaultTemplateSaveErrorMessage: {
        id: "editor-flags.template.save.error.generic.message",
        defaultMessage: "Try clicking Save again."
    },
    duplicateBlogTitleFromEditPageErrorHeader: {
        id: "editor-flags.error.edit-page.duplicate-blog-title-error.title",
        defaultMessage: "A blog with this name already exists"
    },
    duplicateBlogTitleFromEditPageErrorMessage: {
        id: "editor-flags.error.edit-page.duplicate-blog-title-error.message",
        defaultMessage: "Rename the page before publishing it as a blog."
    },
    duplicateUpdateBlogTitleFromEditPageErrorMessage: {
        id: "editor-flags.error.edit-page.update.duplicate-blog-title-error.message",
        defaultMessage: "Rename the page before updating it as a blog."
    },
    duplicateBlogTitleFromViewPageErrorHeader: {
        id: "editor-flags.error.view-page.duplicate-blog-title-error.title",
        defaultMessage: "A blog with this name already exists"
    },
    duplicateBlogTitleFromViewPageErrorMessage: {
        id: "editor-flags.error.view-page.duplicate-blog-title-error.message",
        defaultMessage: "Rename the page before converting it to a blog."
    },
    noAuthorizeMessage: {
        id: "editor-flags.error.no.authorize.message",
        defaultMessage: "Your session has expired. You\u2019ll need to log in again or switch to another account to keep working. {loginLink}"
    },
    loginLink: {
        id: "editor-flags.error.login.link",
        defaultMessage: "Log in or switch to another account"
    },
    noAccessMessage: {
        id: "editor-flags.error.no.access.message",
        defaultMessage: "Your session may have expired. You\u2019ll need to log in again or switch to another account to keep working. {loginLink}"
    },
    pageIsTrashedMessage: {
        id: "editor-flags.error.page.trashed.message",
        defaultMessage: "Copy your content, then add it to a new page or <link>restore this page from the trash</link> and try again."
    },
    livePageIsTrashedMessage: {
        id: "editor-flags.error.live.page.trashed.message",
        defaultMessage: "Copy your content, then add it to a new doc or <link>restore this doc from the trash</link> and try again."
    },
    pageIsTrashedMessageLink: {
        id: "editor-flags.error.page.trashed.message.link",
        defaultMessage: "Restore this content from the trash"
    },
    invalidTemplateVariableMessage: {
        id: "editor-flags.error.invalid.template.variable.message",
        defaultMessage: "Multiple template variables which have the same name \u201C{variableNames}\u201D but different parameters."
    },
    cantRevertPageTitle: {
        id: "editor.discard-to-published.error.title",
        defaultMessage: "Can\u2019t revert to last published version"
    },
    cantRevertPageMessage: {
        id: "editor.discard-to-published.error.message",
        defaultMessage: "We can\u2019t get the last published version of the page at the moment. Give it a few moments then try discarding the draft again."
    },
    parentNotPublishedHeader: {
        id: "editor-flags.error.edit-page.parent-not-published.title",
        defaultMessage: "This draft can\u2019t be published"
    },
    parentNotPublishedMessage: {
        id: "editor-flags.error.edit-page.parent-not-published.message",
        defaultMessage: "A published page can\u2019t exist under a page in the draft state. Publish the <link>parent page</link> first, then publish this page."
    },
    titleRequiredHeader: {
        id: "editor-flags.page.title.required.header",
        defaultMessage: "Title required"
    },
    titleRequiredMessage: {
        id: "editor-flags.page.title.required.message",
        defaultMessage: "Add a title before publishing."
    },
    titleRequiredUpdateMessage: {
        id: "editor-flags.update.page.title.required.update.message",
        defaultMessage: "Add a title before updating."
    },
    titleGeneratedAI: {
        id: "editor-flags.generate.ai.title",
        defaultMessage: "Review your AI-generated title"
    },
    titleGeneratedAIDescription: {
        id: "editor-flags.generate.ai.description",
        defaultMessage: "Rovo is generating a title for this page, as a title is required to publish. Select <bold>Accept</bold> to publish the page with this title or edit the title and publish manually. <Link>Content quality may vary.</Link>"
    },
    titleGeneratedFromPasteAI: {
        id: "editor-flags.generate.ai.from.paste.title",
        defaultMessage: "Rovo wrote a title for you"
    },
    titleGeneratedFromPasteAIDescription: {
        id: "editor-flags.generate.ai.from.paste.description",
        defaultMessage: "It\u2019s based on the text you pasted. <Link>Uses AI. Verify results.</Link>"
    },
    titleGeneratedAIError: {
        id: "editor-flags.generate.ai.error.title",
        defaultMessage: "We couldn\u2019t generate a title for you"
    },
    titleGeneratedAIErrorDescription: {
        id: "editor-flags.generate.ai.error.description",
        defaultMessage: "Rovo was unable to generate a title for you at this time. You can add a title and publish the page manually instead. <Link>Why did this happen?</Link>"
    },
    refreshPageConflictHeader: {
        id: "editor-flags.error.conflict.refresh-page.header",
        defaultMessage: "Refresh this page in order to publish"
    },
    refreshPageUpdateConflictHeader: {
        id: "editor-flags.error.update.conflict.refresh-page.header",
        defaultMessage: "Refresh in order to update"
    },
    refreshPageConflictMessage: {
        id: "editor-flags.error.conflict.refresh-page.message",
        defaultMessage: "This version has been updated by another user. Refresh the page in order to sync and publish your changes."
    },
    refreshUpdatePageConflictMessage: {
        id: "editor-flags.error.update.conflict.refresh-page.message",
        defaultMessage: "This version has been updated by another user. Refresh now in order to sync your changes."
    },
    draftConflictHeader: {
        id: "editor-flags.error.conflict.draft.header",
        defaultMessage: "Unable to publish draft"
    },
    draftConflictMessage: {
        id: "editor-flags.error.conflict.draft.message",
        defaultMessage: "Due to a server error, this draft can\u2019t be published. Copy and paste this content into a new draft in order to publish it."
    },
    duplicatePageNameWithinEditorErrorTitle: {
        id: "editor-flags.move-error.duplicate-page-name-within-editor.title",
        defaultMessage: "Give this page a unique title to move"
    },
    duplicateLivePageNameWithinEditorErrorTitle: {
        id: "editor-flags.move-error.duplicate-live-page-name-within-editor.title",
        defaultMessage: "Give this doc a unique title to move"
    },
    duplicatePageNameWithinEditorErrorDescription: {
        id: "editor-flags.move-error.duplicate-page-name-within-editor.description",
        defaultMessage: "To move this page to the {destinationSpace} space, give it a unique title and publish it first."
    },
    duplicateLivePageNameWithinEditorErrorDescription: {
        id: "editor-flags.move-error.duplicate-live-page-name-within-editor.description",
        defaultMessage: "To move this live doc to the {destinationSpace} space, give it a unique title."
    },
    duplicatePageNameWithinEditorUpdateErrorDescription: {
        id: "editor-flags.move-error.duplicate-page-name-within-editor.update.description",
        defaultMessage: "To move this page to the {destinationSpace} space, give it a unique title and update it first."
    },
    duplicateLivePageNameWithinEditorUpdateErrorDescription: {
        id: "editor-flags.move-error.duplicate-live-page-name-within-editor.update.description",
        defaultMessage: "To move this live doc to the {destinationSpace} space, give it a unique title and update it first."
    },
    collabStatusErrorTitle: {
        id: "editor-flags.collab-status-error.title",
        defaultMessage: "Can\u2019t save changes"
    },
    collabStatusErrorDescription: {
        id: "editor-flags.collab-status-error.description",
        defaultMessage: "Copy your work, then refresh, and we\u2019ll try to reconnect."
    },
    invalidSpaceKeyHeader: {
        id: "editor-flags.template.save.error.spacekey.invalid.header",
        defaultMessage: "There was an issue creating a template in this space"
    },
    invalidSpaceKeyMessage: {
        id: "editor-flags.template.save.error.spacekey.invalid.message",
        defaultMessage: "Check if the space exists and if you have admin permissions to create templates."
    },
    templateBlankTitleErrorHeader: {
        id: "editor-flags.template.can.not.save.error.title.blank.header",
        defaultMessage: "We can\u2019t save this template"
    },
    templateBlankTitleErrorMessage: {
        id: "editor-flags.template.can.not.save.error.title.blank.message",
        defaultMessage: "Templates can\u2019t have blank titles. Give your template a title to publish."
    }
});
const $d33bb643a38eaa5e$var$i18nLiveDocs = (0, $cgtv4.defineMessages)({
    pageTooBigMessage: {
        id: "editor-flags.page.is.too.big.livedocs",
        defaultMessage: "Content that is larger than the 2MB limit is slow to load. Break your content into a couple of pages or live docs and use the Include Page macro to display the content here."
    }
});
const $d33bb643a38eaa5e$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($d33bb643a38eaa5e$var$i18nBase, $d33bb643a38eaa5e$var$i18nLiveDocs);
const $d33bb643a38eaa5e$var$BOLD_BUTTON_TEXT = ({ isUnpublishedDraft: isUnpublishedDraft })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.publishText : $d33bb643a38eaa5e$var$i18n.updateText));
const $d33bb643a38eaa5e$var$LOGIN_LINK = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, (0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__page-experienc') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: "/login?application=confluence"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d33bb643a38eaa5e$var$i18n.loginLink)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: "/login?application=confluence"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d33bb643a38eaa5e$var$i18n.loginLink)));
const $d33bb643a38eaa5e$var$TRASH_LINK = ({ spaceKey: spaceKey, text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, (0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__page-experienc') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/viewtrash.action?key=${spaceKey}`,
        target: "_blank"
    }, text) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/viewtrash.action?key=${spaceKey}`,
        target: "_blank"
    }, text));
const $d33bb643a38eaa5e$var$PARENT_LINK = ({ parentPageId: parentPageId, text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, parentPageId ? (0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__page-experienc') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/resumedraft.action?draftId=${parentPageId}`,
        target: "_blank"
    }, text) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/resumedraft.action?draftId=${parentPageId}`,
        target: "_blank"
    }, text) : text);
const $d33bb643a38eaa5e$var$i18nInitializer = (formatMessage, isLivePage)=>({
        DUPLICATE_PAGE_TITLE: (isUnpublishedDraft)=>{
            const duplicatePageTitleMessage = isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? $d33bb643a38eaa5e$var$i18n.duplicateLivePageTitleMessage : $d33bb643a38eaa5e$var$i18n.duplicatePageTitleMessage;
            return {
                title: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? formatMessage($d33bb643a38eaa5e$var$i18n.duplicateLivePageTitleHeader) : formatMessage($d33bb643a38eaa5e$var$i18n.duplicatePageTitleHeader),
                description: formatMessage(isUnpublishedDraft ? duplicatePageTitleMessage : $d33bb643a38eaa5e$var$i18n.duplicateUpdatePageTitleMessage)
            };
        },
        TITLE_TOO_LONG: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.pageTitleTooLongHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.pageTitleTooLongMessage)
            }),
        DUPLICATE_TEMPLATE_TITLE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateTemplateTitleHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateTemplateTitleMessage)
            }),
        PARENT_NOT_PUBLISHED: (parentPageId)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.parentNotPublishedHeader),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$d33bb643a38eaa5e$var$i18n.parentNotPublishedMessage,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$PARENT_LINK, {
                                parentPageId: parentPageId,
                                text: chunks
                            })
                    }
                })
            }),
        NO_AUTHORIZE: ()=>({
                title: formatMessage({
                    id: "editor.offline.save.noauthorized.title"
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$d33bb643a38eaa5e$var$i18n.noAuthorizeMessage,
                    values: {
                        loginLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$LOGIN_LINK, null)
                    }
                })
            }),
        PAGE_CANNOT_BE_ACCESSED: ()=>({
                title: formatMessage({
                    id: "editor.page.can.not.be.accessed.title"
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$d33bb643a38eaa5e$var$i18n.noAccessMessage,
                    values: {
                        loginLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$LOGIN_LINK, null)
                    }
                })
            }),
        PAGE_CONFLICT_REFRESH: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.refreshPageConflictHeader : $d33bb643a38eaa5e$var$i18n.refreshPageUpdateConflictHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.refreshPageConflictMessage : $d33bb643a38eaa5e$var$i18n.refreshUpdatePageConflictMessage)
            }),
        PAGE_CONFLICT_DRAFT: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.draftConflictHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.draftConflictMessage)
            }),
        PAGE_TRASHED: (spaceKey)=>({
                title: formatMessage({
                    id: "editor.page.is.trashed.title"
                }),
                description: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$d33bb643a38eaa5e$var$i18n.livePageIsTrashedMessage,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$TRASH_LINK, {
                                spaceKey: spaceKey,
                                text: chunks
                            })
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$d33bb643a38eaa5e$var$i18n.pageIsTrashedMessage,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$TRASH_LINK, {
                                spaceKey: spaceKey,
                                text: chunks
                            })
                    }
                })
            }),
        PAGE_TOO_BIG: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.pageTooBigHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.pageTooBigMessage)
            }),
        TEMPLATE_TOO_BIG: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.templateTooBigHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.templateTooBigMessage)
            }),
        OFFLINE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.connectionErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.connectionErrorMessage)
            }),
        TEMPLATE_CONTENT_PARSING_FAILURE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.templateConnectionParsingFailHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.templateConnectionParsingFailMessage)
            }),
        EMPTY_TITLE: ()=>({
                title: formatMessage({
                    id: "editor.title.is.empty.title"
                }),
                description: formatMessage({
                    id: "editor.title.is.empty"
                })
            }),
        DUPLICATE_EDIT_PAGE_BLOG_TITLE: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromEditPageErrorHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromEditPageErrorMessage : $d33bb643a38eaa5e$var$i18n.duplicateUpdateBlogTitleFromEditPageErrorMessage)
            }),
        DUPLICATE_VIEW_PAGE_BLOG_TITLE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromViewPageErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromViewPageErrorMessage)
            }),
        MEDIA_FAILED: ()=>({
                title: formatMessage({
                    id: "editor.cant.publish.changes"
                }),
                description: formatMessage({
                    id: "editor.files.may.be.uploading"
                })
            }),
        INVALID_TEMPLATE_VARIABLE: (errorData)=>({
                title: formatMessage({
                    id: "fabric.template.can.not.save.error.title"
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$d33bb643a38eaa5e$var$i18n.invalidTemplateVariableMessage,
                    values: {
                        variableNames: errorData.i18nOptions.variableNames
                    }
                })
            }),
        DUPLICATE_PAGE_TITLE_WITHIN_EDITOR: (destinationSpace, isUnpublishedDraft)=>({
                title: formatMessage(isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? $d33bb643a38eaa5e$var$i18n.duplicateLivePageNameWithinEditorErrorTitle : $d33bb643a38eaa5e$var$i18n.duplicatePageNameWithinEditorErrorTitle),
                description: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.duplicateLivePageNameWithinEditorErrorDescription : $d33bb643a38eaa5e$var$i18n.duplicateLivePageNameWithinEditorUpdateErrorDescription,
                    values: {
                        destinationSpace: destinationSpace
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.duplicatePageNameWithinEditorErrorDescription : $d33bb643a38eaa5e$var$i18n.duplicatePageNameWithinEditorUpdateErrorDescription,
                    values: {
                        destinationSpace: destinationSpace
                    }
                })
            }),
        RECONCILIATION_ERROR: (errorData, nextTryIn)=>{
            const title = formatMessage({
                id: "editor.content.reconciliation.error.title"
            });
            if (nextTryIn != null) return {
                title: title,
                description: (secondsLeft)=>formatMessage({
                        id: "editor.content.reconciliation.error.retrying"
                    }, {
                        0: `${secondsLeft}`
                    })
            };
            const showStagingError = false;
            const messageEnv = showStagingError ? 'staging' : 'prod';
            const i18nDescriptionMessage = {
                id: `editor.content.reconciliation.error.fatal.${messageEnv}`
            };
            const description = formatMessage(i18nDescriptionMessage);
            const details = `${formatMessage({
                id: "editor.content.reconciliation.error.details"
            })} ${errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CONTENT_RECONCILIATION]}`;
            return {
                title: title,
                description: description,
                details: details
            };
        },
        PUBLISH_TIME_TOO_LONG_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.publishIsTakingTooLongHeader : $d33bb643a38eaa5e$var$i18n.updateIsTakingTooLongHeader),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.publishIsTakingTooLongMessage : $d33bb643a38eaa5e$var$i18n.updateIsTakingTooLongMessage,
                    values: {
                        buttonText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$BOLD_BUTTON_TEXT, {
                            isUnpublishedDraft: isUnpublishedDraft
                        })
                    }
                })
            }),
        SCHEDULE_PUBLISH_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.schedulePublishErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.schedulePublishErrorMessage)
            }),
        CANCEL_SCHEDULE_PUBLISH_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.cancelScheduledPublishErrorHeader : $d33bb643a38eaa5e$var$i18n.cancelScheduledUpdateErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.cancelScheduledPublishErrorMessage)
            }),
        SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.schedulePublishNoHeaderErrorHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.schedulePublishNoHeaderErrorMessage : $d33bb643a38eaa5e$var$i18n.scheduleUpdateNoHeaderErrorMessage)
            }),
        DEFAULT_PUBLISH_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.defaultPublishErrorHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.defaultPublishErrorMessage : $d33bb643a38eaa5e$var$i18n.defaultUpdateErrorMessage)
            }),
        DEFAULT_TEMPLATE_SAVE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.defaultTemplateSaveErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.defaultTemplateSaveErrorMessage)
            }),
        REVERT_CONTENT_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.cantRevertPageTitle),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.cantRevertPageMessage)
            }),
        PUBLISH_CONDITION_ERROR: (errorMsg)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.defaultPublishErrorHeader),
                description: errorMsg
            }),
        INVALID_PAGE_TITLE_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.pageTitleInvalidTitleHeader : $d33bb643a38eaa5e$var$i18n.pageTitleUpdateInvalidTitleHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.pageTitleInvalidTitleMessage)
            }),
        TITLE_REQUIRED: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleRequiredHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.titleRequiredMessage : $d33bb643a38eaa5e$var$i18n.titleRequiredUpdateMessage)
            }),
        AI_GENERATED_TITLE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAI),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAIDescription, {
                    Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                            target: "_blank",
                            href: "https://www.atlassian.com/trust/atlassian-intelligence",
                            appearance: "subtle"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("u", null, chunks)),
                    bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                            weight: "bold"
                        }, " ", chunks, " ")
                })
            }),
        AI_GENERATED_TITLE_FROM_PASTE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedFromPasteAI),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedFromPasteAIDescription, {
                    Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                            target: "_blank",
                            href: "https://www.atlassian.com/trust/atlassian-intelligence",
                            appearance: "subtle"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("u", null, chunks)),
                    bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                            weight: "bold"
                        }, " ", chunks, " ")
                })
            }),
        AI_GENERATED_TITLE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAIError),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAIErrorDescription, {
                    Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                            target: "_blank",
                            href: "https://support.atlassian.com/organization-administration/docs/troubleshoot-atlassian-intelligence/",
                            appearance: "subtle"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("u", null, chunks))
                })
            }),
        COLLAB_STATUS_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.collabStatusErrorTitle),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.collabStatusErrorDescription)
            }),
        INVALID_SPACEKEY_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.invalidSpaceKeyHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.invalidSpaceKeyMessage)
            }),
        TEMPLATE_BLANK_TITLE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.templateBlankTitleErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.templateBlankTitleErrorMessage)
            })
    });
const $d33bb643a38eaa5e$export$cda5b5526dda47f7 = ({ errorData: errorData, statusCode: statusCode, spaceKey: spaceKey, parentPageId: parentPageId, nextTryIn: nextTryIn, formatMessage: formatMessage, isTemplateEditor: isTemplateEditor = false, isUnpublishedDraft: isUnpublishedDraft = true, isLivePage: isLivePage = false })=>{
    if (!errorData || !Object.keys(errorData).length) return null;
    const i18nFormatter = $d33bb643a38eaa5e$var$i18nInitializer(formatMessage, isLivePage);
    // Http errors from the content api when publishing
    if (statusCode != null) switch(statusCode){
        case 400:
            if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE] || // have to check instead of doing errorData[ALLOWED_FLAG_MESSAGES.DUPLICATE_TITLE_WITH_BAD_EXCEPTION]
            // because BE message would sometimes have extra words at the end of A page with this title already exists
            // eg com.atlassian.confluence.api.service.exceptions.api.BadRequestException: A page with this title already exists:
            // A page already exists with the title <PAGE_TITLE> in the space with key <SPACE_KEY>
            Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_WITH_BAD_EXCEPTION) !== -1) return i18nFormatter.DUPLICATE_PAGE_TITLE(isUnpublishedDraft);
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).INVALID_PAGE_TITLE]) return i18nFormatter.INVALID_PAGE_TITLE_ERROR(isUnpublishedDraft);
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_TOO_LONG]) return i18nFormatter.TITLE_TOO_LONG();
            else if (Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_TEMPLATE) !== -1) return i18nFormatter.DUPLICATE_TEMPLATE_TITLE();
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).PARENT_NOT_PUBLISHED]) return i18nFormatter.PARENT_NOT_PUBLISHED(parentPageId);
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TEMPLATE_INVALID_SPACEKEY_ERROR]) return i18nFormatter.INVALID_SPACEKEY_ERROR();
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TEMPLATE_BLANK_TITLE_ERROR]) return i18nFormatter.TEMPLATE_BLANK_TITLE_ERROR();
            else if (// BadRequestException means something wrong with the request. BE throws this exception on request validation fail
            // This BadRequestException has a message attached to it and we should use it as default message if non of above conditions are met.
            // That's why make sure this "if" block should say at last.
            // We are adding this as part of our PublishCondition implementation. Please go through: https://hello.atlassian.net/wiki/spaces/CCECO/pages/1289257589/Custom+publishing+flow
            // For any further questions please contact ecosystem-ini team.
            Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).ERROR_MESSAGE_WITH_BAD_EXCEPTION) !== -1) {
                // positive look-behind "(?<=expression)" is not supported with str.match() so end up using below pattern.
                const patt = '[^com.atlassian.confluence.api.service.exceptions.api.BadRequestException:].*';
                const errorMsg = Object.keys(errorData)[0].match(patt);
                return i18nFormatter.PUBLISH_CONDITION_ERROR(errorMsg);
            }
            break;
        case 403:
            return i18nFormatter.NO_AUTHORIZE();
        case 404:
            return i18nFormatter.PAGE_CANNOT_BE_ACCESSED();
        case 409:
            if (Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).CONFLICT_DRAFT_VERSIONING) !== -1) return i18nFormatter.PAGE_CONFLICT_DRAFT();
            return i18nFormatter.PAGE_CONFLICT_REFRESH(isUnpublishedDraft);
        case 410:
            if (isTemplateEditor) return i18nFormatter.DEFAULT_TEMPLATE_SAVE_ERROR();
            return i18nFormatter.PAGE_TRASHED(spaceKey);
        case 413:
            return isTemplateEditor ? i18nFormatter.TEMPLATE_TOO_BIG() : i18nFormatter.PAGE_TOO_BIG();
        case 0:
        case 500:
        case 503:
            return i18nFormatter.OFFLINE_ERROR();
    }
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TEMPLATE_CONTENT_PARSING_FAILURE]) return i18nFormatter.TEMPLATE_CONTENT_PARSING_FAILURE();
    // editor errors triggered from within the fabric editor
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).EMPTY_TITLE]) return i18nFormatter.EMPTY_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_VIEW_PAGE_BLOG_TITLE]) return i18nFormatter.DUPLICATE_VIEW_PAGE_BLOG_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_WITHIN_EDITOR]) return i18nFormatter.DUPLICATE_PAGE_TITLE_WITHIN_EDITOR(errorData.destinationSpace, isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_EDIT_PAGE_BLOG_TITLE]) return i18nFormatter.DUPLICATE_EDIT_PAGE_BLOG_TITLE(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_TEMPLATE]) return i18nFormatter.DUPLICATE_TEMPLATE_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).MEDIA_FAILED]) return i18nFormatter.MEDIA_FAILED();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).FOUND_INVALID_TEMPLATE_VARIABLE]) return i18nFormatter.INVALID_TEMPLATE_VARIABLE(errorData);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CONTENT_RECONCILIATION]) return i18nFormatter.RECONCILIATION_ERROR(errorData, nextTryIn);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).PUBLISH_TIME_TOO_LONG_ERROR]) return i18nFormatter.PUBLISH_TIME_TOO_LONG_ERROR(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).SCHEDULE_PUBLISH_ERROR]) return i18nFormatter.SCHEDULE_PUBLISH_ERROR();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CANCEL_SCHEDULE_PUBLISH_ERROR]) return i18nFormatter.CANCEL_SCHEDULE_PUBLISH_ERROR(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR]) return i18nFormatter.SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).REVERT_CONTENT_ERROR]) return i18nFormatter.REVERT_CONTENT_ERROR();
    // UX https://product-fabric.atlassian.net/browse/CEMS-2468
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).COLLAB_INIT_TIMEOUT_TAKING_TOO_LONG]) return i18nFormatter.OFFLINE_ERROR();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_REQUIRED]) return i18nFormatter.TITLE_REQUIRED(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE]) return i18nFormatter.AI_GENERATED_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE_FROM_PASTE]) return i18nFormatter.AI_GENERATED_TITLE_FROM_PASTE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE_ERROR]) return i18nFormatter.AI_GENERATED_TITLE_ERROR();
    // Adding duplicate and invalid page errors outside of status code 400 for use with publish modal buttons (they do not send requests)
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE] || // have to check instead of doing errorData[ALLOWED_FLAG_MESSAGES.DUPLICATE_TITLE_WITH_BAD_EXCEPTION]
    // because BE message would sometimes have extra words at the end of A page with this title already exists
    // eg com.atlassian.confluence.api.service.exceptions.api.BadRequestException: A page with this title already exists:
    // A page already exists with the title <PAGE_TITLE> in the space with key <SPACE_KEY>
    Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_WITH_BAD_EXCEPTION) !== -1) return i18nFormatter.DUPLICATE_PAGE_TITLE(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).INVALID_PAGE_TITLE]) return i18nFormatter.INVALID_PAGE_TITLE_ERROR(isUnpublishedDraft);
    if (isTemplateEditor) return i18nFormatter.DEFAULT_TEMPLATE_SAVE_ERROR();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).COLLAB_STATUS_ERROR]) return i18nFormatter.COLLAB_STATUS_ERROR();
    return i18nFormatter.DEFAULT_PUBLISH_ERROR(isUnpublishedDraft);
};
module.exports["buildEditorFlagMessage"] = $d33bb643a38eaa5e$export$cda5b5526dda47f7;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("gQojb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $3dcbd344a2ba2fc1$export$593ae3df1272c4d1 = ({ source: source, actionSubjectId: actionSubjectId, contentId: contentId, contentType: contentType, collabService: collabService, version: version })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const triggerPageConflictAnalytics = (0, $42omo.useCallback)((errorMessage, extraData = {})=>{
        $3dcbd344a2ba2fc1$export$80e39f0a257b3d6c(source, actionSubjectId, {
            contentId: contentId,
            contentType: contentType,
            collabService: collabService,
            version: version,
            errorMessage: errorMessage,
            ...extraData
        }, createAnalyticsEvent);
    }, [
        createAnalyticsEvent,
        source,
        actionSubjectId,
        contentId,
        contentType,
        collabService,
        version
    ]);
    return {
        triggerPageConflictAnalytics: triggerPageConflictAnalytics
    };
};
const $3dcbd344a2ba2fc1$export$80e39f0a257b3d6c = (source, actionSubjectId, attributes, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            source: source,
            action: 'error',
            actionSubject: 'pageConflict',
            actionSubjectId: actionSubjectId,
            attributes: attributes
        }
    }).fire();
};
module.exports["usePageConflictAnalytics"] = $3dcbd344a2ba2fc1$export$593ae3df1272c4d1;

});

parcelRegister("wtSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $251dbde4d6244b59$export$271f9f08425019c7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pM5to",
    name: "NotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("9RII4"))).NotFound
});
module.exports["NotFound"] = $251dbde4d6244b59$export$271f9f08425019c7;

});

parcelRegister("9RII4", function(module, exports) {

let $72ebbeb6a57f7078$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $72ebbeb6a57f7078$var$load("iMSgb"),
    $72ebbeb6a57f7078$var$load("2F69B"),
    $72ebbeb6a57f7078$var$load("hhss7"),
    $72ebbeb6a57f7078$var$load("gEi5K")
]).then(()=>parcelRequire('3nvKi'));

});

parcelRegister("9Z1sw", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $iRRvH = parcelRequire("iRRvH");


var $bavCP = parcelRequire("bavCP");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $gTyTP = parcelRequire("gTyTP");


var $iqPSe = parcelRequire("iqPSe");


var $8pvtc = parcelRequire("8pvtc");

const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children, locationName: locationName, panels: panels } = t0;
    if (!(0, $9wGTI.fg)("confluence_annotate_3p_web_panel")) return children;
    const panelHasContent = panels?.length && panels.some($0aea74171df1eb15$var$_temp);
    if (!panelHasContent) return children;
    const t1 = `web-panel-${locationName}`;
    let t2;
    if ($[0] !== children || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
            name: t1
        }, children);
        $[0] = children;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children, locationName: locationName, panels: panels })=>{
    if (!(0, $9wGTI.fg)('confluence_annotate_3p_web_panel')) return children;
    // If all panels are empty, exclude it from UFOThirdPartySegment
    const panelHasContent = panels?.length && panels.some((panel)=>panel.html !== '');
    if (!panelHasContent) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
        name: `web-panel-${locationName}`
    }, children);
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $42omo.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $8pvtc.WebPanelLocationQuery),
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    }, ({ data: data, loading: loading, error: error })=>{
        // For transitions, loading and data is true
        if (loading && data) return null;
        if (!renderWhenLoading) {
            if (loading || error || !data) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        if (isLivePagesFeatureEnabled) panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    }));
};
function $0aea74171df1eb15$var$_temp(panel) {
    return panel.html !== "";
}
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("bavCP", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");

function $86f32d96feea2a1f$export$67f105fad14d18d({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
}
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("1eaCJ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

const $03574d8c2683228e$export$4962f3898bd5c829 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ExperienceSuccess(t0) {
    const $ = (0, $frIzR.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
} : function ExperienceSuccess({ name: name, attributes: attributes }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>experienceTracker.succeed({
            name: name,
            attributes: attributes
        }), [
        name,
        attributes,
        experienceTracker
    ]);
    return null;
};
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("3QyBm", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $4VJDS.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("iqPSe", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $brpfO = parcelRequire("brpfO");


var $6mKj3 = parcelRequire("6mKj3");


var $6UM2Q = parcelRequire("6UM2Q");


var $gIaMn = parcelRequire("gIaMn");


var $gEtAQ = parcelRequire("gEtAQ");

const $c50a10795e04dcb9$export$bbe14c99ac0820b3 = (0, $3u0dr.isReactCompilerActiveV1)() ? function WebPanel(t0) {
    const $ = (0, $frIzR.c)(18);
    const { html: html, panelId: panelId } = t0;
    const containerRef = (0, $42omo.useRef)(null);
    const [ssrSuccess, setSsrSuccess] = (0, $42omo.useState)(true);
    let t1;
    if ($[0] !== html) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /"moduleLocation"\s*:\s*"atl\.general"/;
            $[2] = t2;
        } else t2 = $[2];
        t1 = html.match(t2);
        $[0] = html;
        $[1] = t1;
    } else t1 = $[1];
    const moduleLocationMatch = t1;
    let t2;
    if ($[3] !== moduleLocationMatch) {
        t2 = Boolean(moduleLocationMatch) && (0, $gEtAQ.isSpaceOverview)();
        $[3] = moduleLocationMatch;
        $[4] = t2;
    } else t2 = $[4];
    const isMatchForActivatable = t2;
    let t3;
    if ($[5] !== isMatchForActivatable || $[6] !== ssrSuccess) {
        t3 = ()=>{
            const container = containerRef.current;
            if (!container) return;
            if (isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false)) {
                if (window?.__HYDRATABLE__) {
                    const scriptElement = container.querySelector("script.ap-iframe-body-script");
                    if (scriptElement) {
                        const scriptContent = scriptElement.textContent || "";
                        const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
                        if (match) {
                            const uniqueKey = match[1];
                            const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
                            if (iframe) return;
                        }
                    }
                }
                if (ssrSuccess) setSsrSuccess(false);
            }
            (0, $brpfO.evalLegacyConnectInlineScripts)(container, (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false));
        };
        $[5] = isMatchForActivatable;
        $[6] = ssrSuccess;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== html || $[9] !== isMatchForActivatable || $[10] !== panelId || $[11] !== ssrSuccess) {
        t4 = [
            html,
            panelId,
            ssrSuccess,
            isMatchForActivatable
        ];
        $[8] = html;
        $[9] = isMatchForActivatable;
        $[10] = panelId;
        $[11] = ssrSuccess;
        $[12] = t4;
    } else t4 = $[12];
    (0, $42omo.useLayoutEffect)(t3, t4);
    let t5;
    if ($[13] !== html || $[14] !== isMatchForActivatable || $[15] !== panelId || $[16] !== ssrSuccess) {
        t5 = isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: containerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UM2Q.ActivatableComponent), {
            id: panelId ?? "WebPanel",
            triggers: [
                {
                    type: (0, $gIaMn.ActivationTriggerType).SSR_ONLY
                }
            ],
            ssrSuccess: ssrSuccess,
            analyticsName: "WebPanel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: containerRef,
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
        $[13] = html;
        $[14] = isMatchForActivatable;
        $[15] = panelId;
        $[16] = ssrSuccess;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : function WebPanel({ html: html, panelId: panelId }) {
    const containerRef = (0, $42omo.useRef)(null);
    const [ssrSuccess, setSsrSuccess] = (0, $42omo.useState)(true);
    const moduleLocationMatch = html.match(/"moduleLocation"\s*:\s*"atl\.general"/);
    // Restrict to just atl-general for now
    const isMatchForActivatable = Boolean(moduleLocationMatch) && (0, $gEtAQ.isSpaceOverview)();
    (0, $42omo.useLayoutEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (isMatchForActivatable && (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)) {
            if (window?.__HYDRATABLE__) {
                const scriptElement = container.querySelector('script.ap-iframe-body-script');
                if (scriptElement) {
                    const scriptContent = scriptElement.textContent || '';
                    const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
                    if (match) {
                        const uniqueKey = match[1];
                        // Find iframe whose id contains the uniqueKey
                        const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
                        if (iframe) return;
                    }
                }
            }
            if (ssrSuccess) setSsrSuccess(false);
        }
        (0, $brpfO.evalLegacyConnectInlineScripts)(container, (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false));
    }, [
        html,
        panelId,
        ssrSuccess,
        isMatchForActivatable
    ]);
    return isMatchForActivatable && (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UM2Q.ActivatableComponent), {
        id: panelId ?? 'WebPanel',
        triggers: [
            {
                type: (0, $gIaMn.ActivationTriggerType).SSR_ONLY
            }
        ],
        ssrSuccess: ssrSuccess,
        analyticsName: "WebPanel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc-ignore-if-no-layout-shift": true,
        dangerouslySetInnerHTML: {
            __html: html
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: containerRef,
        "data-vc-ignore-if-no-layout-shift": true,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
};
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("6UM2Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9s45p = parcelRequire("9s45p");


var $75bK2 = parcelRequire("75bK2");


var $hRdzX = parcelRequire("hRdzX");

function $68e0b10beef6f399$export$1db2f2faaee8467f({ children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess }) {
    const gate = (0, $42omo.useMemo)(()=>(0, $9s45p.makeGate)(), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const renderChildren = (0, $42omo.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    const activateComponent = (0, $42omo.useCallback)((reason)=>{
        if (gate?.getStatus() === 'suspended') {
            onActivate?.(reason);
            if (analyticsName) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'activatableComponent',
                    action: 'activated',
                    actionSubject: 'activatableComponent',
                    attributes: {
                        analyticsName: analyticsName,
                        triggers: triggers,
                        boundaryId: id,
                        activationReason: reason
                    }
                }
            }).fire();
            gate.resolve();
        }
    }, [
        gate,
        id,
        onActivate,
        createAnalyticsEvent,
        analyticsName,
        triggers
    ]);
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)({
        triggers: triggers,
        gate: gate,
        activateComponent: activateComponent,
        boundaryId: id,
        analyticsName: analyticsName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: hostRefWithActivation,
        "data-hydration-shield": id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $75bK2.Boundary), {
        gate: gate,
        id: id,
        render: renderChildren,
        ssrSuccess: ssrSuccess,
        activateComponent: activateComponent,
        resolved: gate?.getStatus?.() === 'resolved',
        boundaryName: analyticsName || id,
        triggers: triggers
    }));
}
module.exports["ActivatableComponent"] = $68e0b10beef6f399$export$1db2f2faaee8467f;

});

parcelRegister("sLZsl", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9e73f43295b80088$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        isAutoConverted: false
    },
    actions: {
        setIsAutoConverted: (isAutoConverted)=>({ setState: setState })=>{
                setState({
                    isAutoConverted: isAutoConverted
                });
            }
    },
    name: 'isAutoConverted'
});
const $9e73f43295b80088$var$getAutoConvertState = (state)=>{
    return state.isAutoConverted;
};
const $9e73f43295b80088$export$dc84155a8aa7f285 = (0, $9zUhf.createHook)($9e73f43295b80088$var$Store, {
    selector: $9e73f43295b80088$var$getAutoConvertState
});
module.exports["useAutoConvertState"] = $9e73f43295b80088$export$dc84155a8aa7f285;

});

parcelRegister("8GzJ6", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0c186b876cfe191c$export$5960959cfc832bcd = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EcrVg",
    loader: async ()=>(await (parcelRequire("epT4q"))).EditorConversionModal,
    name: 'EditorConversionModal'
});
module.exports["EditorConversionModal"] = $0c186b876cfe191c$export$5960959cfc832bcd;

});

parcelRegister("epT4q", function(module, exports) {

let $a7ee1e55389677d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7ee1e55389677d9$var$load("dJjs8").then(()=>parcelRequire('8Ya0K'));

});

parcelRegister("S6mif", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h3X17 = parcelRequire("h3X17");


var $inPa6 = parcelRequire("inPa6");


var $422HI = parcelRequire("422HI");


var $bMmYR = parcelRequire("bMmYR");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $hBkCm = parcelRequire("hBkCm");


var $aMcHK = parcelRequire("aMcHK");


var $fJlJm = parcelRequire("fJlJm");


var $3jwuS = parcelRequire("3jwuS");


var $gTyTP = parcelRequire("gTyTP");

class $03a48f98bcaadc9f$export$26130dc3dd4c1286 extends Error {
    constructor(message, status, traceId){
        super(message), this.message = message, this.status = status, this.traceId = traceId;
        this.status = status;
        this.traceId = traceId;
    }
}
const $03a48f98bcaadc9f$var$isNotPermittedError = (error)=>{
    return error.code === (0, $h3X17.PROVIDER_ERROR_CODE).NO_PERMISSION_ERROR && 'EXPIRED_TOKEN' !== error.reason || error.code === (0, $h3X17.PROVIDER_ERROR_CODE).DOCUMENT_NOT_FOUND;
};
const $03a48f98bcaadc9f$export$fab3177d2bcbd98a = (error)=>{
    return !error.recoverable && (0, $h3X17.PROVIDER_ERROR_CODE).INTERNAL_SERVICE_ERROR !== error.code;
};
const $03a48f98bcaadc9f$var$getStatusCodeFromApolloError = (error)=>{
    return (0, $422HI.isApolloError)(error) && (0, $hBkCm.BadStatusError).isBadStatusError(error?.graphQLErrors?.[0]?.originalError) ? Number((0, $aMcHK.getStatusCodeError)(error.graphQLErrors[0].originalError)) : null;
};
const $03a48f98bcaadc9f$var$isTenantSuspendedError = (error)=>error.status === 423;
const $03a48f98bcaadc9f$export$5027865de34f9ec6 = (collabEditProvider, resetCollabService, contentId, contentType)=>{
    const [error, setError] = (0, $42omo.useState)(null);
    const [recoveryError, setRecoveryError] = (0, $42omo.useState)(null);
    const hasResetRef = (0, $42omo.useRef)({
        resetInProgress: false,
        resetCount: 0
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const currentEditorPageLoadExperienceName = isLivePage ? (0, $irVI7.VIEW_PAGE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE);
    const { livePageReleasePhase: livePageReleasePhase } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const stopExperienceOnRecoveryError = (0, $42omo.useCallback)((recoveryErrorForAnalytics)=>{
        if (!!recoveryErrorForAnalytics?.status && recoveryErrorForAnalytics?.status < 500) {
            experienceTracker.abort({
                name: currentEditorPageLoadExperienceName,
                reason: `Recovery failed with error status ${recoveryErrorForAnalytics.status}`,
                attributes: {
                    errorStatus: recoveryErrorForAnalytics?.status,
                    traceId: recoveryErrorForAnalytics?.traceId,
                    objectId: contentId,
                    objectType: contentType,
                    isLivePage: isLivePage,
                    ...isLivePage ? {
                        livePageReleasePhase: livePageReleasePhase
                    } : {}
                }
            });
            return;
        }
        experienceTracker.stopOnError({
            name: currentEditorPageLoadExperienceName,
            error: recoveryErrorForAnalytics,
            attributes: {
                ...recoveryErrorForAnalytics?.status ? {
                    errorStatus: recoveryErrorForAnalytics.status
                } : {},
                errorType: 'Recovery failed',
                traceId: recoveryErrorForAnalytics?.traceId,
                objectId: contentId,
                objectType: contentType,
                isLivePage: isLivePage,
                ...isLivePage ? {
                    livePageReleasePhase: livePageReleasePhase
                } : {}
            }
        });
    }, [
        contentId,
        contentType,
        experienceTracker,
        currentEditorPageLoadExperienceName,
        isLivePage,
        livePageReleasePhase
    ]);
    const setErrorAndDisconnect = (0, $42omo.useCallback)((newError)=>{
        if ($03a48f98bcaadc9f$var$isNotPermittedError(newError) || $03a48f98bcaadc9f$export$fab3177d2bcbd98a(newError) || $03a48f98bcaadc9f$var$isTenantSuspendedError(newError)) setError(newError);
        const experienceState = experienceTracker.getExperienceState(currentEditorPageLoadExperienceName);
        if (!experienceState || experienceState.hasStopped) {
            // initialisation completed but we received an error later
            if (!$03a48f98bcaadc9f$var$isNotPermittedError(newError)) {
                if ($03a48f98bcaadc9f$export$fab3177d2bcbd98a(newError)) experienceTracker.stopOnError({
                    name: (0, $irVI7.EDIT_PAGE_EXPERIENCE),
                    error: {
                        name: newError.code,
                        message: newError.message
                    },
                    attributes: {
                        errorStatus: newError.status,
                        objectId: contentId,
                        objectType: contentType,
                        isLivePage: isLivePage
                    }
                });
                else createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'error',
                        actionSubject: 'nativeEditor',
                        source: 'confluenceFrontend',
                        objectId: contentId,
                        objectType: contentType,
                        attributes: {
                            errorName: newError.code,
                            errorMessage: newError.message,
                            errorStatus: newError.status,
                            isRecoverable: true,
                            reason: 'reason' in newError ? newError.reason : 'unknown',
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
            }
            return;
        }
        if ($03a48f98bcaadc9f$var$isNotPermittedError(newError)) {
            // expected 403 for restricted page or deleted page
            // for deleted page, 403 is returned with reason "RESOURCE_DELETED"
            let newErrorReason;
            if ('reason' in newError) newErrorReason = newError.reason;
            collabEditProvider.disconnect();
            experienceTracker.abort({
                name: currentEditorPageLoadExperienceName,
                reason: newErrorReason ?? 'page restricted or deleted',
                attributes: {
                    errorStatus: newError.status,
                    errorName: newError.code,
                    errorMessage: newError.message,
                    objectId: contentId,
                    objectType: contentType,
                    isLivePage: isLivePage,
                    ...isLivePage ? {
                        livePageReleasePhase: livePageReleasePhase
                    } : {}
                }
            });
        } else if ($03a48f98bcaadc9f$export$fab3177d2bcbd98a(newError)) // unhandled/unexpected errors
        experienceTracker.stopOnError({
            name: currentEditorPageLoadExperienceName,
            error: {
                name: newError.code,
                message: newError.message
            },
            attributes: {
                errorStatus: newError.status,
                objectId: contentId,
                objectType: contentType,
                isLivePage: isLivePage,
                ...isLivePage ? {
                    livePageReleasePhase: livePageReleasePhase
                } : {}
            }
        });
    }, [
        collabEditProvider,
        experienceTracker,
        createAnalyticsEvent,
        contentId,
        contentType,
        currentEditorPageLoadExperienceName,
        isLivePage,
        livePageReleasePhase
    ]);
    const collabRecovery = (0, $42omo.useCallback)(async ()=>{
        if (hasResetRef.current.resetInProgress) return;
        else if (hasResetRef.current.resetCount > 0) {
            // recovery has already been attempted but we've received another 404d
            const error = new $03a48f98bcaadc9f$export$26130dc3dd4c1286(`Collab recovery unsuccessful`);
            setRecoveryError(error);
            stopExperienceOnRecoveryError(error);
            return;
        }
        hasResetRef.current = {
            resetInProgress: true,
            resetCount: hasResetRef.current.resetCount += 1
        };
        const shouldRetryPredicate = async (error)=>{
            const statusCode = $03a48f98bcaadc9f$var$getStatusCodeFromApolloError(error);
            return !!statusCode && statusCode >= 500;
        };
        try {
            await (0, $bMmYR.retry)(resetCollabService, {
                maxAttempts: 2,
                timeout: 2000
            }, shouldRetryPredicate); // kick off page recovery, with retry
            hasResetRef.current.resetInProgress = false;
        } catch (e) {
            // page recovery has failed, editor is empty... fatal error
            let recoveryError = e; // "public" error used by other components
            const statusCode = $03a48f98bcaadc9f$var$getStatusCodeFromApolloError(e);
            if (!!statusCode) recoveryError = new $03a48f98bcaadc9f$export$26130dc3dd4c1286(`Collab recovery responded with ${statusCode}`, statusCode, (0, $fJlJm.getTraceIdFromApolloError)(e) ?? undefined);
            setRecoveryError(recoveryError);
            stopExperienceOnRecoveryError(recoveryError);
            hasResetRef.current.resetInProgress = false;
        }
    }, [
        resetCollabService,
        stopExperienceOnRecoveryError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleError = (emittedError)=>{
            if (emittedError.status == 404) // 404 means that collab service doesn't have the document but Confluence does
            // try reset the document before displaying error (will be created in collab service if it doesn't exist). Currently only attempt reset once (no retry)
            collabRecovery();
            else setErrorAndDisconnect(emittedError);
        };
        collabEditProvider.on('error', handleError);
        return ()=>{
            collabEditProvider.off('error', handleError);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditProvider,
        resetCollabService
    ]);
    return {
        error: error,
        recoveryError: recoveryError
    };
};
module.exports["CollabRecoveryErrorType"] = $03a48f98bcaadc9f$export$26130dc3dd4c1286;
module.exports["isUnrecoverableError"] = $03a48f98bcaadc9f$export$fab3177d2bcbd98a;
module.exports["useError"] = $03a48f98bcaadc9f$export$5027865de34f9ec6;

});

parcelRegister("5MyXJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $3jwuS = parcelRequire("3jwuS");


var $4VJDS = parcelRequire("4VJDS");


var $9wGTI = parcelRequire("9wGTI");


var $8MyKT = parcelRequire("8MyKT");


var $jKP0k = parcelRequire("jKP0k");


var $loOZe = parcelRequire("loOZe");


var $9y3bP = parcelRequire("9y3bP");

/* Editor heartbeat set to tick every 60 seconds */ const $2350038afb2a4a3e$var$HEARTBEAT_TIMER_INTERVAL = 60000;
const $2350038afb2a4a3e$var$EDITOR_NCS_MAX_PARTICIPANTS = 'confluence_frontend_collab_ncs_max_participants';
const $2350038afb2a4a3e$var$LIVE_PAGES_LIMITS = 'confluence_frontend_collab_live_pages_limits';
const $2350038afb2a4a3e$var$COLLAB_SERVICE = 'ncs'; // this hook is only used for NCS editor
const $2350038afb2a4a3e$var$DEFAULT_MAX_EDIT_PARTICIPANTS = 12;
class $2350038afb2a4a3e$export$17a91496024ff2c1 extends Error {
    constructor(message, reason){
        super(message), this.message = message, this.reason = reason;
        this.reason = reason;
    }
}
const $2350038afb2a4a3e$export$e11674744930cd15 = (heartbeatError)=>{
    return heartbeatError?.reason === 'unauthorised' || heartbeatError?.reason === 'UNAUTHORIZED';
};
const $2350038afb2a4a3e$export$af429709ba6838d6 = ({ contentId: contentId, contentType: contentType, collabEditInitialized: collabEditInitialized, viewMode: viewMode })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const heartbeatTimerId = (0, $42omo.useRef)(null);
    const editorSessionIdRef = (0, $42omo.useRef)(null);
    const [subtypeMismatch, setSubtypeMismatch] = (0, $42omo.useState)(false);
    const [heartbeatSubtype, setHeartbeatSubtype] = (0, $42omo.useState)(undefined);
    // If view mode changes, trigger new heartbeat request with new "user type", before enforcing any limits or returning errors
    const prevViewModeRef = (0, $42omo.useRef)(viewMode !== undefined ? viewMode : null);
    const isResettingHeartbeat = (0, $42omo.useRef)(false);
    // keep track of list of users from heartbeat response, which are ordered by time that they joined the collaborative session
    const [orderedActiveUsers, setOrderedActiveUsers] = (0, $42omo.useState)(null);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // used for regular pages
    const [collabLimitReached, setCollabLimitReached] = (0, $42omo.useState)(false);
    // used for live pages
    const [liveEditLimitReached, setLiveEditLimitReached] = (0, $42omo.useState)(false);
    const [liveViewLimitReached, setLiveViewLimitReached] = (0, $42omo.useState)(false);
    const [heartbeatError, setHeartbeatError] = (0, $42omo.useState)();
    let maxEditParticipants = (0, $4VJDS.default).getNumber($2350038afb2a4a3e$var$EDITOR_NCS_MAX_PARTICIPANTS, $2350038afb2a4a3e$var$DEFAULT_MAX_EDIT_PARTICIPANTS);
    const livePagesLimitConfig = (0, $4VJDS.default).getString($2350038afb2a4a3e$var$LIVE_PAGES_LIMITS, '');
    const { viewLimit: livePageViewLimit, editLimit: livePageEditLimit } = (0, $42omo.useMemo)(()=>{
        const defaultLimits = {
            editLimit: $2350038afb2a4a3e$var$DEFAULT_MAX_EDIT_PARTICIPANTS,
            viewLimit: 100
        };
        if (typeof livePagesLimitConfig === 'string') try {
            const limitObject = JSON.parse(livePagesLimitConfig);
            if (!('viewLimit' in limitObject) || !('editLimit' in limitObject)) return defaultLimits;
            return limitObject;
        } catch  {
        // ignore and fallback to default
        }
        return defaultLimits;
    }, [
        livePagesLimitConfig
    ]);
    if (isLivePage) maxEditParticipants = livePageEditLimit;
    const [startHeartbeat] = (0, $loOZe.useExperimentalEditorStartHeartbeatMutation)({
        variables: {
            contentId: contentId,
            contentType: contentType,
            collabService: $2350038afb2a4a3e$var$COLLAB_SERVICE,
            heartbeatUserType: viewMode ? (0, $8MyKT.ExperimentalHeartbeatUserType).VIEW : (0, $8MyKT.ExperimentalHeartbeatUserType).EDIT
        }
    });
    const [stopHeartbeat] = (0, $9y3bP.useExperimentalEditorStopHeartbeatMutation)({
        variables: {
            contentId: contentId,
            contentType: contentType,
            heartbeatUserType: viewMode ? (0, $jKP0k.ExperimentalHeartbeatUserType).VIEW : (0, $jKP0k.ExperimentalHeartbeatUserType).EDIT
        }
    });
    const handleError = (0, $42omo.useCallback)((error, data)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'error',
                actionSubject: 'heartbeat',
                source: 'useEditorHeartbeat',
                objectId: contentId,
                objectType: contentType,
                attributes: {
                    error: {
                        reason: error instanceof $2350038afb2a4a3e$export$17a91496024ff2c1 ? error.reason : 'Error',
                        message: error.message
                    },
                    activeUsersSize: data?.experimentalEditorStartHeartbeat?.orderedUsers?.length
                }
            }
        }).fire();
        setHeartbeatError(error);
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const stopHeartbeatCallback = (0, $42omo.useCallback)(()=>{
        if (heartbeatTimerId?.current) clearInterval(heartbeatTimerId.current);
        stopHeartbeat().catch((error)=>{
            handleError(error);
        });
    }, [
        stopHeartbeat,
        handleError
    ]);
    const handleHeartbeatSubtypeMismatch = (0, $42omo.useCallback)((subtype)=>{
        setHeartbeatSubtype(subtype);
        // Detect if page type (live/classic page) differs between frontend and backend
        // This can happen when a page is converted but the user hasn't received the event
        // We disable the editor in NCS to prevent potential data loss in this state
        const hasSubtypeMismatch = isLivePage && subtype !== 'live' || // Live doc with a different subtype
        !isLivePage && subtype !== null; // Non-live doc with any subtype
        setSubtypeMismatch(hasSubtypeMismatch);
    }, [
        isLivePage,
        setHeartbeatSubtype,
        setSubtypeMismatch
    ]);
    const startHeartbeatCallback = (0, $42omo.useCallback)(()=>{
        startHeartbeat().then((result)=>{
            const { data: data } = result;
            if (isResettingHeartbeat.current) isResettingHeartbeat.current = false;
            if (!data || !data.experimentalEditorStartHeartbeat) {
                handleError(new $2350038afb2a4a3e$export$17a91496024ff2c1('Missing response data', !data ? 'No data' : 'No heartbeat data'));
                return;
            }
            const { error: error, message: message, orderedUsers: orderedUsers, editorSessionId: editorSessionId, subtype: subtype } = data.experimentalEditorStartHeartbeat;
            editorSessionIdRef.current = editorSessionId;
            if ((0, $9wGTI.fg)('confluence_ncs_disconnect_idle_tabs_pubsub')) handleHeartbeatSubtypeMismatch(subtype);
            if (error) {
                const heartbeatError = new $2350038afb2a4a3e$export$17a91496024ff2c1(message ?? 'Heartbeat failed', error);
                if (isLivePage && $2350038afb2a4a3e$export$e11674744930cd15(heartbeatError)) // heartbeat permission check is a redundant extra check on top of NCS permission enforcement
                // for live pages:
                //    there is a race condition where heartbeat is sent with outdated user type
                //    we ignore the permission error and re-send the heartbeat with the correct user type
                return;
                handleError(heartbeatError, data);
            }
            if (!!orderedUsers) setOrderedActiveUsers(orderedUsers);
        }).catch((error)=>{
            handleError(error);
        });
    }, [
        startHeartbeat,
        handleError,
        isLivePage,
        handleHeartbeatSubtypeMismatch
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!orderedActiveUsers || isResettingHeartbeat.current) return;
        const isCurrentUserOverLimit = ({ activeUsers: activeUsers, limit: limit })=>{
            // If there are less active users than the limit, the user is not over the limit
            if (activeUsers.length < limit) return false;
            const isUserAnActiveUser = userId ? activeUsers.slice(0, limit).includes(userId) : false;
            return(// heartbeat backend doesn't handle anonymous users, they will be locked out regardless of order that they joined (i.e. we just use activeUsers size number comparison for anonymous users)
            // otherwise, only the first N users should be able to continue editing
            !userId && activeUsers.length > limit || !!userId && !isUserAnActiveUser);
        };
        const editUsers = orderedActiveUsers.filter((user)=>user.heartbeatUserType === (0, $8MyKT.ExperimentalHeartbeatUserType).EDIT).map((user)=>user.accountId) ?? [];
        const isEditLimitExceeded = isCurrentUserOverLimit({
            activeUsers: editUsers,
            limit: maxEditParticipants
        });
        if (!isLivePage) {
            setCollabLimitReached(isEditLimitExceeded);
            return;
        }
        // include edit->view fallback users, based on queue order
        const allowedEditUsers = editUsers.slice(0, maxEditParticipants);
        const viewUsers = orderedActiveUsers.filter((user)=>!allowedEditUsers.includes(user.accountId)).map((user)=>user.accountId) ?? [];
        const isViewLimitExceeded = isCurrentUserOverLimit({
            activeUsers: viewUsers,
            limit: livePageViewLimit
        });
        if (isEditLimitExceeded && !(prevViewModeRef.current || isViewLimitExceeded)) setLiveEditLimitReached(true);
        else setLiveEditLimitReached(false);
        if (isViewLimitExceeded && (prevViewModeRef.current || isEditLimitExceeded)) setLiveViewLimitReached(true);
        else setLiveViewLimitReached(false);
    }, [
        orderedActiveUsers,
        maxEditParticipants,
        userId,
        isLivePage,
        livePageViewLimit
    ]);
    (0, $42omo.useEffect)(()=>{
        if (viewMode !== undefined && viewMode !== prevViewModeRef.current) {
            // view mode has changed, refetch heartbeat with new user type
            isResettingHeartbeat.current = true;
            startHeartbeatCallback();
            prevViewModeRef.current = viewMode;
        }
    }, [
        viewMode,
        startHeartbeatCallback
    ]);
    (0, $42omo.useEffect)(()=>{
        if (collabEditInitialized) {
            startHeartbeatCallback();
            heartbeatTimerId.current = setInterval(startHeartbeatCallback, $2350038afb2a4a3e$var$HEARTBEAT_TIMER_INTERVAL);
            return ()=>stopHeartbeatCallback();
        }
    // prevent re-triggering start/stop when heartbeat type changes (i.e. when mutation callback changes)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditInitialized,
        contentId,
        // only re-trigger heartbeat on specific mutation variables, not viewMode
        contentType
    ]);
    return {
        collabLimitReached: // regular edit pages
        collabLimitReached,
        liveEditLimitReached: // live pages specific
        liveEditLimitReached,
        liveViewLimitReached: liveViewLimitReached,
        heartbeatError: // shared data
        heartbeatError,
        stopHeartbeatCallback: stopHeartbeatCallback,
        editorSessionId: editorSessionIdRef.current,
        subtypeMismatch: subtypeMismatch,
        heartbeatSubtype: heartbeatSubtype
    };
};
module.exports["isPermissionError"] = $2350038afb2a4a3e$export$e11674744930cd15;
module.exports["useEditorHeartbeat"] = $2350038afb2a4a3e$export$af429709ba6838d6;

});

parcelRegister("8MyKT", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $d61f6181e4c7da5b$export$5d0e43ccb00ec46a = /*#__PURE__*/ function(ExperimentalHeartbeatUserType) {
    ExperimentalHeartbeatUserType["EDIT"] = "EDIT";
    ExperimentalHeartbeatUserType["VIEW"] = "VIEW";
    return ExperimentalHeartbeatUserType;
}({});
module.exports["ExperimentalHeartbeatUserType"] = $d61f6181e4c7da5b$export$5d0e43ccb00ec46a;

});

parcelRegister("jKP0k", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $89185ab988181834$export$5d0e43ccb00ec46a = /*#__PURE__*/ function(ExperimentalHeartbeatUserType) {
    ExperimentalHeartbeatUserType["EDIT"] = "EDIT";
    ExperimentalHeartbeatUserType["VIEW"] = "VIEW";
    return ExperimentalHeartbeatUserType;
}({});
module.exports["ExperimentalHeartbeatUserType"] = $89185ab988181834$export$5d0e43ccb00ec46a;

});

parcelRegister("loOZe", function(module, exports) {

var $9o40q = parcelRequire("9o40q");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

const $d7e083384eee425a$var$TENANT_SUSPENDED_RESPONSE = 'Site temporarily unavailable';
const $d7e083384eee425a$export$458b4e9b72fe370e = ({ variables: variables })=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: '/wiki/api/v2/editor/heartbeat/start',
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON,
            Accept: (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        body: ({ contentId: contentId, contentType: contentType, collabService: collabService, heartbeatUserType: heartbeatUserType })=>JSON.stringify({
                dataType: 'json',
                contentId: contentId,
                draftType: contentType ?? '',
                collabService: collabService,
                // confluence-frontend only sends heartbeat for Fabric editor, legacy editor heartbeat code is in confluence web resource.
                // heartbeat response is different for each editor version; only fabric heartbeat response in handled in this experimental mutation
                editorVersion: 'v2',
                heartbeatUserType: heartbeatUserType
            }),
        parseResponseOnError: async (fetchError)=>{
            // this catches unhandled server errors (e.g. internal server error)
            let error;
            let message;
            if (fetchError instanceof (0, $hBkCm.BadStatusError)) try {
                // try to parse original error message
                const errorMessageJson = await fetchError.response.json();
                if (errorMessageJson?.errorMessage === $d7e083384eee425a$var$TENANT_SUSPENDED_RESPONSE) {
                    // error from atlassian-proxy during region migration
                    error = 'tenant-unavailable';
                    message = 'Site temporarily unavailable';
                } else {
                    // Parse heartbeat REST error response
                    error = errorMessageJson?.errors[0].code;
                    message = errorMessageJson?.errors[0].title;
                }
            } catch  {
                error = fetchError.response.statusText;
                message = fetchError.message;
            }
            else {
                error = fetchError.name;
                message = fetchError.message;
            }
            return {
                orderedUsers: null,
                editorSessionId: null,
                error: error,
                message: message,
                subtype: null
            };
        },
        parseResult: ({ orderedUsers: orderedUsers, editorSessionId: editorSessionId, subtype: subtype, error: error, message: message })=>{
            return {
                experimentalEditorStartHeartbeat: {
                    orderedUsers: orderedUsers,
                    editorSessionId: editorSessionId,
                    error: error,
                    message: message,
                    subtype: subtype
                }
            };
        }
    });
};
module.exports["useExperimentalEditorStartHeartbeatMutation"] = $d7e083384eee425a$export$458b4e9b72fe370e;

});

parcelRegister("9o40q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5JnOJ = parcelRequire("5JnOJ");


var $6mKj3 = parcelRequire("6mKj3");


var $1GTIR = parcelRequire("1GTIR");


var $bjeS8 = parcelRequire("bjeS8");


var $hNILR = parcelRequire("hNILR");

function $ca37881e75cd694f$export$59b64e912820d0fb({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    if (!(0, $6mKj3.expValEquals)('cc_move_legacy-schema-bridge-code-into-interops', 'isEnabled', true)) // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return (0, $hNILR.useExperimentalMutationLegacy)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        maxRetries: maxRetries,
        variables: defaultVariables,
        update: update,
        optimisticResponse: optimisticResponse
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return $ca37881e75cd694f$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $ca37881e75cd694f$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: update, optimisticResponse: optimisticResponse }) {
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $5JnOJ.useApolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        update: update,
        optimisticResponse: optimisticResponse,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["useExperimentalMutation"] = $ca37881e75cd694f$export$59b64e912820d0fb;
module.exports["useExperimentalMutationBase"] = $ca37881e75cd694f$export$a2949d410ca8baf1;

});

parcelRegister("5JnOJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $7Sm4c = parcelRequire("7Sm4c");

function $0e0c7f21ad093cb8$export$36caaad0aa36f272({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse, convertToApolloError: convertToApolloError }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const apolloError = await Promise.resolve(convertToApolloError(error));
            if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
                (0, $7Sm4c.processError)(e);
            });
            onError?.(apolloError);
            const newResult = {
                data: undefined,
                loading: false,
                error: apolloError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw apolloError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useApolloCompatibleMutation"] = $0e0c7f21ad093cb8$export$36caaad0aa36f272;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("bjeS8", function(module, exports) {

var $aAxiE = parcelRequire("aAxiE");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $aAxiE.GraphQLError)(message, null, null, null, null, originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("hNILR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $hR9WV = parcelRequire("hR9WV");

function $fa6207d2b246a38d$export$9aaca330ad9c982e({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    return $fa6207d2b246a38d$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $fa6207d2b246a38d$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            const newResult = {
                data: undefined,
                loading: false,
                error: finalError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw finalError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useExperimentalMutationLegacy"] = $fa6207d2b246a38d$export$9aaca330ad9c982e;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("9y3bP", function(module, exports) {

var $aBfpe = parcelRequire("aBfpe");


var $9o40q = parcelRequire("9o40q");

const $bd279094f7d7a508$export$d3610256bfeae95f = ({ variables: variables })=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: '/wiki/api/v2/editor/heartbeat/stop',
        method: 'POST',
        variables: variables,
        headers: {
            Accept: (0, $aBfpe.MediaType).JSON,
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: ({ contentId: contentId, contentType: contentType, heartbeatUserType: heartbeatUserType })=>JSON.stringify({
                dataType: 'json',
                contentId: contentId,
                draftType: contentType ?? '',
                heartbeatUserType: heartbeatUserType
            }),
        parseResponseOnError: ()=>{
            return false;
        },
        parseResult: (response)=>{
            return {
                experimentalEditorStopHeartbeat: Boolean(response)
            };
        }
    });
};
module.exports["useExperimentalEditorStopHeartbeatMutation"] = $bd279094f7d7a508$export$d3610256bfeae95f;

});

parcelRegister("426PF", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f7eb9f600e97ba76$export$1c211db4e67cf500 = (0, $eSUdr.gql)`query PageTitleQuery($contentId:ID!){singleContent(id:$contentId){id title}}`;
module.exports["PageTitleQuery"] = $f7eb9f600e97ba76$export$1c211db4e67cf500;

});

parcelRegister("i9VoI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $42omo.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("iVU5h", function(module, exports) {
const $6269d9b82324487a$export$42ca032027818031 = ()=>{
    return new URLSearchParams(window.location.search).get('amn-referral-source') || '';
};
module.exports["getAMNReferralSourceFromQueryParam"] = $6269d9b82324487a$export$42ca032027818031;

});

parcelRegister("iSXh4", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $5ZqQS = parcelRequire("5ZqQS");

const $270f2eb7bad14df2$var$createAriId = (cloudId, pageId)=>`ari:cloud:confluence:${cloudId}:page/${pageId}`;
const $270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery = (0, $eSUdr.default)`query useAutomatedMeetingNotesPagePropertiesQuery($pageAri:ID!){page(id:$pageAri){properties(keys:["isAutomatedMeetingNotes" "meetingRecurrenceAri"]){nodes{key value}}subType}}`;
const $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey = 'isAutomatedMeetingNotes';
const $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey = 'meetingRecurrenceAri';
const $270f2eb7bad14df2$export$d2c3b4dbe2618d37 = (pageId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery, {
        variables: {
            pageAri: $270f2eb7bad14df2$var$createAriId(cloudId, pageId)
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error
    ]);
    return {
        isLoading: loading,
        ...$270f2eb7bad14df2$export$1607cf22d9dbad(data)
    };
};
const $270f2eb7bad14df2$export$1607cf22d9dbad = (data)=>{
    const pageProperties = data?.page?.properties?.nodes;
    const amnProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey);
    const recurrenceProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey);
    const isAMN = amnProperty?.value === 'true';
    const isRecurringParent = recurrenceProperty != undefined;
    const isLiveAMNPage = data?.page?.subType?.toLowerCase() === 'live' && isAMN;
    return {
        isAMN: isAMN,
        isRecurringParent: isRecurringParent,
        isLiveAMNPage: isLiveAMNPage
    };
};
module.exports["useAutomatedMeetingNotesPageProperties"] = $270f2eb7bad14df2$export$d2c3b4dbe2618d37;
module.exports["extractAmnPageProperties"] = $270f2eb7bad14df2$export$1607cf22d9dbad;

});

parcelRegister("hNtOj", function(module, exports) {

var $etu7G = parcelRequire("etu7G");

const $120c25b1424bdefe$export$c82fe4eede9104df = new (0, $etu7G.SSRPermissionsErrorHandler)();
module.exports["ssrPermissionsErrorHandler"] = $120c25b1424bdefe$export$c82fe4eede9104df;

});

parcelRegister("etu7G", function(module, exports) {
class $c6d83b8df27b1c26$export$e70f491dc46ba2ed {
    markSSRPreloadPermissionError(route, error) {
        this.hasSSRPreloadPermissionsErrorForRoute = route;
        if (error) this.errorType = error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
    }
    getRestrictedRoute() {
        return this.hasSSRPreloadPermissionsErrorForRoute || window.__SSR_RESTRICTED_PAGE__?.route || null;
    }
    getErrorType() {
        return this.errorType || window.__SSR_RESTRICTED_PAGE__?.errorType || null;
    }
    constructor(){
        this.hasSSRPreloadPermissionsErrorForRoute = void 0;
        this.errorType = void 0;
        this.hasSSRPreloadPermissionsErrorForRoute = null;
        this.errorType = null;
    }
}
module.exports["SSRPermissionsErrorHandler"] = $c6d83b8df27b1c26$export$e70f491dc46ba2ed;

});

parcelRegister("fBNZi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hp2SH = parcelRequire("hp2SH");


var $i9VoI = parcelRequire("i9VoI");


var $7zgzO = parcelRequire("7zgzO");


var $e9owJ = parcelRequire("e9owJ");


var $lIkCL = parcelRequire("lIkCL");

const $99aa1354571330dd$export$486cb94e63be330f = ({ contentType: contentType })=>{
    const { match: match, replace: replace, toUrl: toUrl } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { contentId: contentId, spaceKey: spaceKeyFromUrl } = match?.params ?? {};
    const { triggerAnalyticsEvent: triggerAnalyticsEvent } = (0, $e9owJ.useEditorAnalyticsEvent)({
        contentId: contentId,
        contentType: contentType,
        source: 'editPageScreen',
        subject: 'editor',
        collabService: 'ncs'
    });
    // Replaces the URL to match the given space key
    const changeUrl = (0, $42omo.useCallback)((spaceKey)=>{
        // Only changing the space key
        const params = {
            ...match?.params,
            query: match?.query,
            spaceKey: spaceKey
        };
        const url = toUrl(match?.name, params);
        if (url !== null) replace(url);
    }, [
        replace,
        toUrl,
        match
    ]);
    // Changes the URL if the new space key from the move event is different from the current
    const onMoveSubscriptionEvent = (0, $42omo.useCallback)((_eventName, response)=>{
        const newSpaceAlias = response?.pageMoved?.newSpaceAlias ?? null;
        if (newSpaceAlias !== null && newSpaceAlias?.toLowerCase() !== spaceKeyFromUrl?.toLowerCase()) changeUrl(newSpaceAlias);
        // Fire analytics to track when the page or blog was moved
        const eventName = contentType === 'page' ? 'pageMoved' : 'blogMoved';
        triggerAnalyticsEvent(eventName, {
            editorType: 'next',
            ...response
        });
    }, [
        changeUrl,
        contentType,
        spaceKeyFromUrl,
        triggerAnalyticsEvent
    ]);
    // Handles the case where the page is moved while the user is editing it
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        subscriberId: 'UseSpaceKeyWatcherSubscription',
        delta: 'pageMoved',
        onDataReceived: onMoveSubscriptionEvent
    });
    // Handles the case where the user returns to a bookmarked page which has since been moved
    (0, $42omo.useEffect)(()=>{
        const fetchSpaceKey = async ()=>{
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const { data: data } = await (0, $hp2SH.getApolloClient)().query({
                query: (0, $lIkCL.ContentSpaceKeyQuery),
                variables: {
                    contentId: contentId
                },
                fetchPolicy: 'network-only'
            });
            const contentSpaceKeyAsKey = data?.content?.nodes?.[0]?.space?.key ?? null;
            const contentSpaceAliasAsKey = data?.content?.nodes?.[0]?.space?.alias ?? null;
            const contentSpaceKey = contentSpaceAliasAsKey || contentSpaceKeyAsKey;
            if (contentSpaceKey !== null && contentSpaceKey !== spaceKeyFromUrl) changeUrl(contentSpaceKey);
        };
        if (contentId) fetchSpaceKey();
    }, [
        contentId,
        changeUrl,
        spaceKeyFromUrl
    ]);
};
module.exports["useSpaceKeyWatcher"] = $99aa1354571330dd$export$486cb94e63be330f;

});

parcelRegister("lIkCL", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $1d20d8840d947140$export$d8ddb957fd6cf218 = (0, $eSUdr.default)`query ContentSpaceKeyQuery($contentId:ID!){content(id:$contentId status:["current" "draft"]){nodes{id space{id key alias}}}}`;
module.exports["ContentSpaceKeyQuery"] = $1d20d8840d947140$export$d8ddb957fd6cf218;

});

parcelRegister("4R7P9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $7aRa9 = parcelRequire("7aRa9");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $4U6ec = parcelRequire("4U6ec");

const $9bece82eecc4ba59$var$i18n = (0, $cgtv4.defineMessages)({
    pageHasBeenConvertedTitle: {
        id: "editor-features.page-has-been-converted-title",
        defaultMessage: "Page has been converted"
    },
    pageHasBeenConvertedDescription: {
        id: "editor-features.page-has-been-converted-description",
        defaultMessage: "This page has been converted to the new editing experience"
    },
    pageHasBeenConvertedLearnMore: {
        id: "editor-features.page-has-been-converted-learn-more-link",
        defaultMessage: "Learn more"
    }
});
const $9bece82eecc4ba59$var$onClickLearnMore = ()=>{
    window.open((0, $4U6ec.learnMoreURL), '_blank');
};
const $9bece82eecc4ba59$var$MigrationSuccessFlagComponent = ({ contentId: contentId, flags: flags })=>{
    // We only want to show the flag once (we don't want to re-render and show the flag again)
    const didShowFlag = (0, $42omo.useRef)(false);
    // This key is set previously when a user manually converts a page (i.e. clicks "Convert page")
    const didManualConversionRecently = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).PAGE_JUST_CONVERTED) === contentId;
    // We want to clear the previously set key since we only want to show the flag when the user first lands in the Fabric editor
    const onClose = ()=>(0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).PAGE_JUST_CONVERTED);
    const shouldShowFlag = (0, $42omo.useMemo)(()=>didManualConversionRecently && !!flags, [
        didManualConversionRecently,
        flags
    ]);
    if (shouldShowFlag && !didShowFlag.current) {
        didShowFlag.current = true;
        flags.showInfoFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9bece82eecc4ba59$var$i18n.pageHasBeenConvertedTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9bece82eecc4ba59$var$i18n.pageHasBeenConvertedDescription),
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9bece82eecc4ba59$var$i18n.pageHasBeenConvertedLearnMore),
                    onClick: $9bece82eecc4ba59$var$onClickLearnMore
                }
            ],
            // Auto-dismiss the flag after 8 seconds (AtlasKit AutoDismissFlag default dismiss delay)
            isAutoDismiss: true,
            onClose: onClose
        });
    }
    return null;
};
const $9bece82eecc4ba59$export$bc6e366e749c654a = (0, $7aRa9.withFlags)($9bece82eecc4ba59$var$MigrationSuccessFlagComponent);
module.exports["MigrationSuccessFlag"] = $9bece82eecc4ba59$export$bc6e366e749c654a;

});

parcelRegister("4U6ec", function(module, exports) {
/**
 * @deprecated This should be removed once we migrate away from using Synchrony
 */ var $5137e303faa24d7f$export$9c28bc693ca74328 = /*#__PURE__*/ function(SYNC_STATUS_KEY) {
    SYNC_STATUS_KEY["CONNECTED"] = "connected";
    SYNC_STATUS_KEY["DISCONNECTED"] = "disconnected";
    SYNC_STATUS_KEY["ERROR"] = "error";
    SYNC_STATUS_KEY["COLLAB_LIMIT"] = "collab-limit";
    SYNC_STATUS_KEY["PERMISSION_CHANGED"] = "permission-changed";
    return SYNC_STATUS_KEY;
}({});
const $5137e303faa24d7f$export$40bf0201c34f0600 = 'l5albia6lf64r4n';
const $5137e303faa24d7f$export$92a4a783381b2c9 = 'confluence.fabric.page.optin.page.has.been.migrated';
const $5137e303faa24d7f$export$6a9702599c19f55f = 8000;
const $5137e303faa24d7f$export$11e4ffbb7072caae = 'https://support.atlassian.com/confluence-cloud/docs/convert-pages-to-the-new-editor/#Convertpagestotheneweditor-WhatACTUALLYhappenswhenyourcontentisconverted';
module.exports["DROPBOX_APP_KEY"] = $5137e303faa24d7f$export$40bf0201c34f0600;
module.exports["learnMoreURL"] = $5137e303faa24d7f$export$11e4ffbb7072caae;

});

parcelRegister("2ClJD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gmMgo = parcelRequire("gmMgo");


var $2Nwuj = parcelRequire("2Nwuj");


var $iXCQx = parcelRequire("iXCQx");


var $lcuos = parcelRequire("lcuos");


var $eGqQQ = parcelRequire("eGqQQ");


var $9wGTI = parcelRequire("9wGTI");


var $7aRa9 = parcelRequire("7aRa9");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $5ZqQS = parcelRequire("5ZqQS");


var $hOX68 = parcelRequire("hOX68");

const $3e63cfb29051b1a8$var$i18n = (0, $cgtv4.defineMessages)({
    sameFileNameTitle: {
        id: "editor-features.same.file.name.title",
        defaultMessage: "\u201C{file}\u201D already exists"
    },
    sameFileNameDescription: {
        id: "editor-features.same.file.name.description",
        defaultMessage: "The file you chose has the same name as an existing attachment, and the new one will replace the existing one."
    },
    sameFileNameLearnMore: {
        id: "editor-features.same.file.name.learn.more",
        defaultMessage: "Learn more about attachments."
    }
});
const $3e63cfb29051b1a8$var$ATTACHMENTS_LINK = 'https://support.atlassian.com/confluence-cloud/docs/manage-uploaded-files/';
const $3e63cfb29051b1a8$var$SameFileNameWarningFlagComponent = ({ editorActions: editorActions, flags: flags, contentId: contentId, intl: intl })=>{
    // [file id]: file name
    const attachmentsMapRef = (0, $42omo.useRef)({});
    /**
   * parses the editor adf to get media nodes
   * @returns mediaNodes[]
   */ const getMediaNodesFromAdf = (0, $42omo.useCallback)(async ()=>{
        const adf = await editorActions.getValue();
        const mediaNodes = (0, $lcuos.filter)(adf, (node)=>node.type === 'media' && !!node?.attrs?.['collection'] && node.attrs?.type !== 'external');
        return mediaNodes;
    }, [
        editorActions
    ]);
    /**
   * sets a map of attachments on the content
   */ const getAttachmentsMap = (0, $42omo.useCallback)(async ()=>{
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: data } = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $hOX68.ContentAttachmentsQuery),
            variables: {
                contentId: contentId,
                status: [
                    'current',
                    'draft'
                ]
            },
            fetchPolicy: 'network-only' // should get the latest ids
        }).catch((e)=>{
            if ((0, $1uFM6.isUnauthorizedError)(e) || (0, $6fil2.containsNetworkError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
            else (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            });
            return {
                data: null
            };
        });
        if (data === null) return;
        const attachmentsMap = data.content?.edges?.[0]?.node?.attachments?.nodes?.reduce((acc, curr)=>{
            const fileId = curr?.extensions?.find((i)=>i?.key === 'fileId')?.value;
            if (curr?.title && fileId) acc[fileId] = curr.title;
            return acc;
        }, {}) || {};
        Object.assign(attachmentsMapRef.current, attachmentsMap);
    }, [
        contentId
    ]);
    /**
   * @param filename
   */ const showSameFileNameFlag = (0, $42omo.useCallback)((filename)=>{
        flags.showWarningFlag({
            id: `file-with-same-name-${filename}`,
            title: intl.formatMessage($3e63cfb29051b1a8$var$i18n.sameFileNameTitle, {
                file: filename
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                as: "p"
            }, intl.formatMessage($3e63cfb29051b1a8$var$i18n.sameFileNameDescription), "\xa0", (0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__page-experienc') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                href: $3e63cfb29051b1a8$var$ATTACHMENTS_LINK,
                target: "_blank"
            }, intl.formatMessage($3e63cfb29051b1a8$var$i18n.sameFileNameLearnMore)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                href: $3e63cfb29051b1a8$var$ATTACHMENTS_LINK,
                target: "_blank"
            }, intl.formatMessage($3e63cfb29051b1a8$var$i18n.sameFileNameLearnMore)))
        });
    }, [
        flags,
        intl
    ]);
    /**
   * globalMediaEventEmitter callback, compares uploaded file name to file names on the editor
   * @param uploadedFileDetails parameter from globalMediaEventEmitter
   */ const checkForDuplicateFileNames = (0, $42omo.useCallback)(async (uploadedFileDetails)=>{
        const { name: uploadedFileName, id: uploadedFileId } = uploadedFileDetails;
        const mediaNodes = await getMediaNodesFromAdf();
        for (const mediaNode of mediaNodes){
            const mediaNodeFileId = mediaNode?.attrs?.id;
            // no id and do not check self
            if (!mediaNodeFileId || mediaNodeFileId === uploadedFileId) continue;
            if (attachmentsMapRef.current[mediaNodeFileId] === uploadedFileName) {
                showSameFileNameFlag(uploadedFileName);
                break;
            }
        }
        attachmentsMapRef.current[uploadedFileId] = uploadedFileName;
    }, [
        getMediaNodesFromAdf,
        showSameFileNameFlag
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $eGqQQ.globalMediaEventEmitter).on('file-added', checkForDuplicateFileNames);
        return ()=>{
            (0, $eGqQQ.globalMediaEventEmitter).off('file-added', checkForDuplicateFileNames);
        };
    }, [
        checkForDuplicateFileNames
    ]);
    (0, $42omo.useEffect)(()=>{
        getAttachmentsMap();
    }, [
        getAttachmentsMap
    ]);
    return null;
};
const $3e63cfb29051b1a8$export$cf6bace5e57a00db = (0, $7aRa9.withFlags)((0, $gmMgo.default)($3e63cfb29051b1a8$var$SameFileNameWarningFlagComponent));
module.exports["SameFileNameWarningFlag"] = $3e63cfb29051b1a8$export$cf6bace5e57a00db;

});

parcelRegister("lcuos", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $da92954c57c92ae9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $da92954c57c92ae9$export$3dea766d36a8935f;

});

parcelRegister("hOX68", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $2bc4ee56414e021f$export$d38c70a792a3108d = (0, $eSUdr.default)`query ContentAttachmentsQuery($contentId:ID!$status:[String]=["current"]){content(id:$contentId status:$status){edges{node{id attachments{nodes{id title extensions{key value}}}}}}}`;
module.exports["ContentAttachmentsQuery"] = $2bc4ee56414e021f$export$d38c70a792a3108d;

});

parcelRegister("8uySb", function(module, exports) {
/* EditorDisplayWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Component wrapping the editor to apply styling overrides
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a680464f54a8caa4$export$1a692c35a5e9cddf = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditorActionBarRendered: isEditorActionBarRendered, isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i1osq _kqswh2mm _19jk1jfw _kibh1jfw _bq9y1f4h _yovj1ejb _1dmjpxbi _1k07v47k _1iwipxbi _1jpz1b66",
            __cmplp.isEditorActionBarRendered && "_18m915vq",
            __cmplp?.isEditorActionBarRendered && !__cmplp?.isToolbarAifcEnabled ? "_1i191ejb" : "_1i19ze3t",
            __cmplp.isHidden ? "_1e0cglyw" : "_1e0cn7od",
            __cmplp.className
        ])
    });
});
module.exports["EditorDisplayWrapper"] = $a680464f54a8caa4$export$1a692c35a5e9cddf;

});

parcelRegister("lmEhP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jhcFr = parcelRequire("jhcFr");


var $bQm3c = parcelRequire("bQm3c");


var $vLw8x = parcelRequire("vLw8x");


var $7zgzO = parcelRequire("7zgzO");


var $etKOR = parcelRequire("etKOR");

const $87c86ebe3b41800e$export$78db118acf87bd21 = (options, viewMode, isChromelessEditor, isLivePage)=>{
    const config = (0, $etKOR.useLinkingOptions)(options, isChromelessEditor);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    // TODO MODES-4363 Once getSpaTransitionDetails & its consumers are refactored to not use RoutesContext, use RouteState instead of RoutesContext
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const productConfig = (0, $42omo.useMemo)(()=>({
            product: 'confluence',
            cloudId: cloudId
        }), [
        cloudId
    ]);
    /**
	 * Store live page state props in refs so the onClickCallback has a stable reference
	 * The onClickCallback passed to editor (and consumed within the useUniversalPreset hook)
	 * is not updated when the live page state changes.
	 */ const isLivePageRef = (0, $42omo.useRef)(isLivePage);
    const viewModeRef = (0, $42omo.useRef)(viewMode);
    (0, $42omo.useEffect)(()=>{
        isLivePageRef.current = isLivePage;
        viewModeRef.current = viewMode;
    }, [
        isLivePage,
        viewMode
    ]);
    /**
	 * By passing a callback we circumvent the default link click handling within platform
	 *
	 * We only want to allow smart links in live edit mode to navigte when this platform FF
	 * is enabled. The guarded behaviour can be instilled as the default on clean up (alongside
	 * removing the viewMode prop).
	 */ const onClickCallback = (0, $42omo.useCallback)(({ event: event, url: url })=>{
        if (viewModeRef.current && url) (0, $vLw8x.smartCardEventHandler)(routesContext, event, url);
    }, [
        routesContext
    ]);
    const linkPickerProps = (0, $jhcFr.useLinkPickerEditorProps)(undefined, productConfig);
    return (0, $42omo.useMemo)(()=>({
            linking: {
                ...config.linking,
                linkPicker: {
                    ...config.linking?.linkPicker,
                    ...linkPickerProps
                },
                smartLinks: {
                    ...config.linking?.smartLinks,
                    onClickCallback: onClickCallback
                }
            }
        }), [
        config,
        linkPickerProps,
        onClickCallback
    ]);
};
const $87c86ebe3b41800e$export$9b0cf83b2bedfd63 = ({ children: children, options: options, viewMode: viewMode = false, isChromelessEditor: isChromelessEditor = false, isLivePage: isLivePage = false })=>{
    const mergedProps = $87c86ebe3b41800e$export$78db118acf87bd21(options, viewMode, isChromelessEditor, isLivePage);
    return children(mergedProps);
};
module.exports["useLinkingFeatures"] = $87c86ebe3b41800e$export$78db118acf87bd21;
module.exports["EditorLinkingFeatures"] = $87c86ebe3b41800e$export$9b0cf83b2bedfd63;

});

parcelRegister("vLw8x", function(module, exports) {

var $6S5EB = parcelRequire("6S5EB");


var $dHSeC = parcelRequire("dHSeC");


var $icKZN = parcelRequire("icKZN");


var $jibmA = parcelRequire("jibmA");

const $fbd8de70e694fd11$export$71eec072841e6b90 = (routesContext, e, url)=>{
    const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
    if ((0, $jibmA.isExternalLink)(url)) {
        e.preventDefault();
        window.open(url, '_blank', 'noopener, noreferrer');
    } else if (details?.href && details.href === url) {
        e.preventDefault();
        routesContext.push(details.href, (0, $6S5EB.isExternalShareRequest)());
    } else $fbd8de70e694fd11$var$handleClick(e, url);
};
/**
 * Copied from @atlaskit/smart-card and
 * packages/media/smart-card/src/view/CardWithUrl/component.tsx to handle click
 * on a smart card with a URL because @atlaskit/smart-card expects
 * SmartCardEventClickHandler to handle the event fully, doesn't allow the
 * SmartCardEventClickHandler to fall back to the default @atlaskit/smart-card
 * click handler.
 */ const $fbd8de70e694fd11$var$handleClick = (e, url)=>{
    (0, $icKZN.isClickEventToOpenNewTab)(e, {
        shouldCheckIframe: true
    }) ? window.open(url, '_blank') : window.open(url, '_self');
};
module.exports["smartCardEventHandler"] = $fbd8de70e694fd11$export$71eec072841e6b90;

});

parcelRegister("6S5EB", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $d5074feaeb7f756a$export$50d92d69a5c05c70 = ()=>!!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
module.exports["isExternalShareRequest"] = $d5074feaeb7f756a$export$50d92d69a5c05c70;

});

parcelRegister("icKZN", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $76c86d96bcffdba9$export$4128d9964cdd56b5 = (event, options)=>{
    return event?.isDefaultPrevented() && (Boolean(options?.shouldCheckIframe) && $76c86d96bcffdba9$var$isIframe() || $76c86d96bcffdba9$var$isCtrlOrCommandClick(event) || $76c86d96bcffdba9$var$isMiddleClick(event));
};
const $76c86d96bcffdba9$var$isIframe = ()=>window.parent !== parent;
const $76c86d96bcffdba9$var$isMiddleClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return nativeEvent.button === 1;
};
const $76c86d96bcffdba9$var$isCtrlOrCommandClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return (0, $9wGTI.fg)('platform-smart-card-shift-key') ? nativeEvent.ctrlKey || nativeEvent.metaKey || nativeEvent.shiftKey : nativeEvent.ctrlKey || nativeEvent.metaKey;
};
module.exports["isClickEventToOpenNewTab"] = $76c86d96bcffdba9$export$4128d9964cdd56b5;

});

parcelRegister("jibmA", function(module, exports) {
/**
 * This is a temporary exception list which is used to determine if the link
 * is pointing to either Jira, a different instance or outside of Atlassian
 * entirely.
 */ const $005667118ff06aa5$export$b98882f166bb7ce2 = (url)=>{
    const windowHostname = window.location.hostname;
    // Only including support for certain Jira paths to minimise hardcoding
    const linkClickExceptionPaths = [
        '/browse',
        '/jira'
    ];
    let urlObject;
    try {
        urlObject = url && new URL(url);
    } catch  {}
    const { hostname: hostname, pathname: pathname } = urlObject || {};
    return hostname && windowHostname && hostname !== windowHostname || linkClickExceptionPaths.some((exceptionPath)=>pathname?.startsWith(exceptionPath));
};
module.exports["isExternalLink"] = $005667118ff06aa5$export$b98882f166bb7ce2;

});

parcelRegister("etKOR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kWKYj = parcelRequire("kWKYj");

const $5353808f826c81c2$export$535281304894bcdc = (cardOptions, isChromelessEditor = false)=>{
    const baseSmartLinks = (0, $kWKYj.useSmartCards)(isChromelessEditor);
    return (0, $42omo.useMemo)(()=>({
            linking: {
                smartLinks: {
                    ...baseSmartLinks,
                    ...cardOptions
                }
            }
        }), [
        baseSmartLinks,
        cardOptions
    ]);
};
module.exports["useLinkingOptions"] = $5353808f826c81c2$export$535281304894bcdc;

});

parcelRegister("kWKYj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ctpOV = parcelRequire("ctpOV");

const $11b3acfee7e9c227$export$5681a80d8b7b2bfb = (isChromelessEditor = false)=>{
    return (0, $42omo.useMemo)(()=>{
        return (0, $ctpOV.getSmartCardOptions)(isChromelessEditor);
    }, [
        isChromelessEditor
    ]);
};
module.exports["useSmartCards"] = $11b3acfee7e9c227$export$5681a80d8b7b2bfb;

});

parcelRegister("ctpOV", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $477dG = parcelRequire("477dG");


var $6mKj3 = parcelRequire("6mKj3");


var $iGhtC = parcelRequire("iGhtC");

const $97182487d32399bc$export$2a89c15ccab17d33 = (0, $2XqLN.default)((enableChromelessEditorCardProvider)=>{
    /**
   * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
   * (only supports Cloud single-issue URLs right now)
   */ const smartLinksBeforeMacros = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
    const cardProvider = enableChromelessEditorCardProvider ? new (0, $iGhtC.InlineCommentEditorCardProvider)(undefined, undefined, 'CONFLUENCE') : new (0, $477dG.EditorCardProvider)(undefined, undefined, 'CONFLUENCE');
    if ((0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'isEnabled', false)) {
        if (!enableChromelessEditorCardProvider) {
            const ssrProvidersData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
            const ssrData = ssrProvidersData[cardProvider.name];
            cardProvider.setSSRData(ssrData);
        }
    }
    // IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/pastePluginOptions.ts
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/cardPluginOptions.ts
    return {
        provider: Promise.resolve(cardProvider),
        resolveBeforeMacros: smartLinksBeforeMacros,
        allowBlockCards: true,
        allowEmbeds: true
    };
});
module.exports["getSmartCardOptions"] = $97182487d32399bc$export$2a89c15ccab17d33;

});

parcelRegister("477dG", function(module, exports) {
/* eslint-disable require-unicode-regexp,prefer-regex-literals */ 
var $79vw2 = parcelRequire("79vw2");


var $i0VEL = parcelRequire("i0VEL");


var $1oCLl = parcelRequire("1oCLl");


var $dDhJe = parcelRequire("dDhJe");

var $btw9C = parcelRequire("btw9C");


var $1bFdN = parcelRequire("1bFdN");


var $5nJCu = parcelRequire("5nJCu");


var $k00oi = parcelRequire("k00oi");


var $dh538 = parcelRequire("dh538");


var $lEzf1 = parcelRequire("lEzf1");

const $807e27f9bf9a8610$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $807e27f9bf9a8610$var$isJiraRoadmapOrTimeline = (url)=>url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/);
const $807e27f9bf9a8610$var$isPolarisView = (url)=>url.match(/^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/);
const $807e27f9bf9a8610$var$isJwmView = (url)=>url.match(/^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/);
const $807e27f9bf9a8610$var$isJiraList = (url)=>url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/);
const $807e27f9bf9a8610$var$isGiphyMedia = (url)=>url.match(/^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//);
const $807e27f9bf9a8610$var$isProformaView = (url)=>url.match(/^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/);
const $807e27f9bf9a8610$var$isConfluenceWhiteboard = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?"));
const $807e27f9bf9a8610$var$isConfluenceDatabase = (url)=>url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/);
const $807e27f9bf9a8610$var$isYoutubeVideo = (url)=>url.match(/^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/);
const $807e27f9bf9a8610$var$isLoomUrl = (url)=>{
    return url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})"));
};
const $807e27f9bf9a8610$var$isJiraDashboard = (url)=>{
    return url.match(/^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/);
};
const $807e27f9bf9a8610$var$isJiraBacklog = (url)=>{
    return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/);
};
const $807e27f9bf9a8610$var$isJiraBoard = (url)=>{
    return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/);
};
const $807e27f9bf9a8610$var$isJiraPlan = (url)=>{
    return(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)")) || url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)\\/scenarios\\/(?<resourceContext>\\d+)\\/(timeline|summary|calendar|program\\/\\d+|dependencies)\\/?")));
};
const $807e27f9bf9a8610$var$isJiraVersion = (url)=>{
    return url.match(/https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/);
};
const $807e27f9bf9a8610$var$isJiraForm = (url)=>{
    return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/);
};
const $807e27f9bf9a8610$var$isJiraSummary = (url)=>{
    return url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/);
};
const $807e27f9bf9a8610$var$isRovoAgentProfilePage = (url)=>{
    return url.match(/^https:\/\/.*?\/people\/agent\/.+$/);
};
const $807e27f9bf9a8610$var$isCustomer360LandingPage = (url)=>url.match(/^https:\/\/customer\.atlassian\.com\/.*$/);
const $807e27f9bf9a8610$var$isConfluenceTeamCalendars = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/(?<resourceContext>[^\\/]+)\\/calendars\\/(?<resourceId>[a-zA-Z0-9-]+)"));
const $807e27f9bf9a8610$var$isJiraIssueNavigator = (url)=>url.match(/^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/);
const $807e27f9bf9a8610$var$isAvpVisualizationView = (url)=>url.match(/^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/);
const $807e27f9bf9a8610$export$6a9668b99d8a1708 = (url)=>/\/browse\/((?:\w+)-(?:\d+))/i.test(url);
class $807e27f9bf9a8610$export$e4635c0135e1a519 extends (0, $i0VEL.NodeDataProvider) {
    nodeDataKey(node) {
        // We can use URL as a key here, because CardClient returns the same data for the same URL
        // regardless of the type of card (inline, block, embed).
        return node.attrs.url;
    }
    fetchNodesData(nodes) {
        const promises = nodes.map((node)=>{
            const url = node.attrs.url;
            return this.cardClient.fetchData(url);
        });
        return Promise.all(promises);
    }
    isNodeSupported(node) {
        return [
            'inlineCard',
            'blockCard',
            'embedCard'
        ].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async checkLinkResolved(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $btw9C.getStatus)(response) !== 'not_found') return true;
        } catch  {
            return false;
        }
    }
    async fetchDataForResource(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $btw9C.getStatus)(response) !== 'not_found') return response;
        } catch  {
            return undefined;
        }
    }
    extractAriFromData(responseData) {
        if (responseData.data && 'atlassian:ari' in responseData.data) return responseData.data['atlassian:ari'];
        return undefined;
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $lEzf1.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.checkLinkResolved(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = new RegExp(/^[a-zA-Z0-9]/).test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = new RegExp(/[a-zA-Z0-9]$/).test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    /**
   *
   * Decides whether the url passed in should be embedded by default
   *
   * protected so that subclasses can override this in order to custom handle links embedded by default
   *
   * @param url
   * @returns 'embed' for the card appearance to embed by default
   */ getHardCodedAppearance(url) {
        // Replace directly with isJiraPlan(url) on cleanup
        const isJiraPlanEvaluated = $807e27f9bf9a8610$var$isJiraPlan(url);
        const isJiraFormEvaluated = $807e27f9bf9a8610$var$isJiraForm(url);
        const isJiraSummaryEvaluated = $807e27f9bf9a8610$var$isJiraSummary(url);
        let isConfluenceTeamCalendarsEvaluated;
        if ((0, $dh538.fg)('tc_smart_link_embed_view')) isConfluenceTeamCalendarsEvaluated = $807e27f9bf9a8610$var$isConfluenceTeamCalendars(url);
        if ($807e27f9bf9a8610$var$isJiraRoadmapOrTimeline(url) || $807e27f9bf9a8610$var$isPolarisView(url) || $807e27f9bf9a8610$var$isJwmView(url) || $807e27f9bf9a8610$var$isJiraList(url) || $807e27f9bf9a8610$var$isGiphyMedia(url) || $807e27f9bf9a8610$var$isProformaView(url) || $807e27f9bf9a8610$var$isConfluenceWhiteboard(url) || $807e27f9bf9a8610$var$isConfluenceDatabase(url) || $807e27f9bf9a8610$var$isYoutubeVideo(url) || $807e27f9bf9a8610$var$isLoomUrl(url) || $807e27f9bf9a8610$var$isJiraDashboard(url) || $807e27f9bf9a8610$var$isJiraBacklog(url) || $807e27f9bf9a8610$var$isJiraBoard(url) || $807e27f9bf9a8610$var$isRovoAgentProfilePage(url) || $807e27f9bf9a8610$var$isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || $807e27f9bf9a8610$var$isCustomer360LandingPage(url) || isConfluenceTeamCalendarsEvaluated || $807e27f9bf9a8610$var$isJiraIssueNavigator(url) || $807e27f9bf9a8610$var$isAvpVisualizationView(url) && (0, $dh538.fg)('avp_unfurl_shared_charts_embed_by_default_2')) return 'embed';
    }
    async fetchData(url) {
        // it uses fetchNodesData internally and caches the result
        return (0, $1oCLl.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
        await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            type: 'inlineCard',
            attrs: {
                url: url
            }
        }) : await this.cardClient.fetchData(url);
    }
    /**
   * Make a /resolve call and find out if result has embed capability
   */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $btw9C.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $79vw2.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch  {
            return false;
        }
    }
    async getAuthStatusFromResolveResponse(url) {
        try {
            const { meta: { access: access, visibility: visibility } } = await this.fetchData(url);
            return {
                access: access,
                visibility: visibility
            };
        } catch  {
            return undefined;
        }
    }
    /**
   * Make a /resolve call and find out if result has datasource capability
   */ async getDatasourceFromResolveResponse(url) {
        try {
            const response = await this.fetchData(url);
            const datasources = response && response.datasources || [];
            if (datasources.length > 0) // For now we only have one datasource expected even though it is in an array.
            // When we have resources returning more than one we will have revisit this part.
            return datasources[0];
        } catch  {
            return undefined;
        }
    }
    /**
   * This is used to determine if the url is a local Jira url or a remote one.
   */ isLocalUrl(url) {
        return new URL(url).origin === this.baseUrl;
    }
    async resolve(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toSmartlinkAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if ((0, $dh538.fg)('issue-link-suggestions-in-comments')) {
                if ($807e27f9bf9a8610$export$6a9668b99d8a1708(url) && this.isLocalUrl(url)) {
                    const data = await this.fetchDataForResource(url);
                    if (data) {
                        const issueAri = this.extractAriFromData(data);
                        if (issueAri) this.onResolve?.(url, issueAri);
                    }
                }
            }
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            const isSupported = !!matchedProviderPattern || await this.checkLinkResolved(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                const isEmbedFriendlyLocationEvaluated = isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined;
                let preferredAppearance = shouldForceAppearance === undefined ? // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
                hardCodedAppearance || appearance : // User preferred appearance. It would be either one that has matching domain/path pattern OR
                // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
                isEmbedFriendlyLocationEvaluated && hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                const datasource = await this.getDatasourceFromResolveResponse(url);
                if (datasource) {
                    const { id: id, parameters: parameters } = datasource;
                    return this.transformer.toDatasourceAdf({
                        id: id,
                        parameters: parameters,
                        // in the future when we support multiple views, we will need to pass this in as a parameter
                        // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                        views: [
                            {
                                type: 'table'
                            }
                        ]
                    }, url);
                }
                if (isEmbedFriendlyLocationEvaluated && !userPreference && (0, $dh538.fg)('platform_sl_3p_unauth_paste_as_block_card_gate')) {
                    const authStatus = await this.getAuthStatusFromResolveResponse(url);
                    if (authStatus) {
                        const { access: access } = authStatus;
                        if (access === 'unauthorized') {
                            const isUnauthPasteAsBlockCardEnabled = !(0, $1oCLl.expValEquals)('platform_sl_3p_unauth_paste_as_block_card', 'cohort', 'control', 'control');
                            if (isUnauthPasteAsBlockCardEnabled) return this.transformer.toSmartlinkAdf(url, 'block');
                        }
                    }
                }
                return this.transformer.toSmartlinkAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
    constructor(envKey, baseUrlOverride, product, onResolve, customCardClient){
        super();
        this.name = void 0;
        this.baseUrl = void 0;
        this.resolverUrl = void 0;
        this.providersData = void 0;
        this.requestHeaders = void 0;
        this.transformer = void 0;
        this.providersLoader = void 0;
        this.cardClient = void 0;
        this.onResolve = void 0;
        this.name = 'editorCardProvider';
        this.baseUrl = baseUrlOverride || (0, $dDhJe.getBaseUrl)(envKey);
        this.resolverUrl = (0, $dDhJe.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $5nJCu.Transformer)();
        this.onResolve = onResolve;
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $807e27f9bf9a8610$var$BATCH_WAIT_TIME)
        });
        this.cardClient = customCardClient ?? new (0, $k00oi.default)(envKey, baseUrlOverride);
        if (!customCardClient && product) this.cardClient.setProduct(product);
    }
}
const $807e27f9bf9a8610$export$b7c3c9a99f7959f5 = new $807e27f9bf9a8610$export$e4635c0135e1a519();
module.exports["EditorCardProvider"] = $807e27f9bf9a8610$export$e4635c0135e1a519;
module.exports["editorCardProvider"] = $807e27f9bf9a8610$export$b7c3c9a99f7959f5;

});

parcelRegister("79vw2", function(module, exports) {

var $99WQy = parcelRequire("99WQy");

var $7MMjM = parcelRequire("7MMjM");

var $dsdUb = parcelRequire("dsdUb");

var $l6lJr = parcelRequire("l6lJr");

var $9WUug = parcelRequire("9WUug");

var $4sK6R = parcelRequire("4sK6R");

var $ccQw1 = parcelRequire("ccQw1");

var $hUifo = parcelRequire("hUifo");


var $9JHBV = parcelRequire("9JHBV");


var $lyclm = parcelRequire("lyclm");

const $56d3cb5a2f4b0466$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.displayName;
    return (0, $hUifo.extractTitle)(response?.data, removeTextHighlightingFromTitle);
};
const $56d3cb5a2f4b0466$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.url;
    return (0, $l6lJr.extractLink)(response?.data);
};
const $56d3cb5a2f4b0466$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.ari || (0, $lyclm.extractEntity)(response)?.thirdPartyAri;
    const data = response?.data;
    return (0, $99WQy.extractAri)(data);
};
const $56d3cb5a2f4b0466$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $lyclm.isEntityPresent)(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = (0, $lyclm.extractEntityEmbedUrl)(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return (0, $9JHBV.extractPreview)(response?.data, 'web', iframeUrlType);
};
const $56d3cb5a2f4b0466$export$ff753ed519e96e9e = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntityProvider)(response);
    return response?.data && (0, $ccQw1.extractProvider)(response?.data);
};
const $56d3cb5a2f4b0466$export$7a685df468cbf38f = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.createdAt;
    return response?.data && (0, $7MMjM.extractDateCreated)(response.data);
};
const $56d3cb5a2f4b0466$export$75047940e157fd1f = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.lastUpdatedAt;
    return response?.data && (0, $dsdUb.extractDateUpdated)(response.data);
};
const $56d3cb5a2f4b0466$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.createdBy?.displayName;
    const persons = (0, $9WUug.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $56d3cb5a2f4b0466$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) {
        const entity = (0, $lyclm.extractEntity)(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $9WUug.extractPersonCreatedBy)(response.data);
};
const $56d3cb5a2f4b0466$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.lastUpdatedBy?.displayName;
    const person = (0, $4sK6R.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
const $56d3cb5a2f4b0466$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) {
        const entity = (0, $lyclm.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};
module.exports["extractSmartLinkTitle"] = $56d3cb5a2f4b0466$export$3eda18658b66108;
module.exports["extractSmartLinkUrl"] = $56d3cb5a2f4b0466$export$7ba9b12c6a1b73de;
module.exports["extractSmartLinkAri"] = $56d3cb5a2f4b0466$export$16b02be3e2bb31ad;
module.exports["extractSmartLinkEmbed"] = $56d3cb5a2f4b0466$export$864b719baf5d744d;
module.exports["extractSmartLinkProvider"] = $56d3cb5a2f4b0466$export$ff753ed519e96e9e;
module.exports["extractSmartLinkCreatedOn"] = $56d3cb5a2f4b0466$export$7a685df468cbf38f;
module.exports["extractSmartLinkModifiedOn"] = $56d3cb5a2f4b0466$export$75047940e157fd1f;
module.exports["extractSmartLinkCreatedBy"] = $56d3cb5a2f4b0466$export$242875b46118beb2;
module.exports["extractSmartLinkAuthorGroup"] = $56d3cb5a2f4b0466$export$41fc716e1bc2dc90;
module.exports["extractSmartLinkModifiedBy"] = $56d3cb5a2f4b0466$export$7f099a839071a190;
module.exports["extractSmartLinkDownloadUrl"] = $56d3cb5a2f4b0466$export$96ed4c1b14ac210a;

});

parcelRegister("99WQy", function(module, exports) {
const $7b9cf113c389991e$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};
module.exports["extractAri"] = $7b9cf113c389991e$export$be18a6294fd426ec;

});

parcelRegister("7MMjM", function(module, exports) {
const $e4034aced29ead60$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};
module.exports["extractDateCreated"] = $e4034aced29ead60$export$e1226a5e0bbbf862;

});

parcelRegister("dsdUb", function(module, exports) {
const $d35ebe54446110dc$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
module.exports["extractDateUpdated"] = $d35ebe54446110dc$export$7fc2f5e6f9d22ae7;

});

parcelRegister("l6lJr", function(module, exports) {

var $kzBLz = parcelRequire("kzBLz");

const $d3adf1d8ff29df55$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $kzBLz.extractUrlFromLinkJsonLd)(url);
    }
    return undefined;
};
module.exports["extractLink"] = $d3adf1d8ff29df55$export$63f54cf4c5883620;

});

parcelRegister("kzBLz", function(module, exports) {
const $8554b737f5c5cb14$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $8554b737f5c5cb14$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};
module.exports["extractUrlFromLinkJsonLd"] = $8554b737f5c5cb14$export$396ba4ef2e37dc65;

});

parcelRegister("9WUug", function(module, exports) {

var $kzSaQ = parcelRequire("kzSaQ");

const $7710b1270e0d3189$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $kzSaQ.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $kzSaQ.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonCreatedBy"] = $7710b1270e0d3189$export$a66235cba0c9d11a;

});

parcelRegister("kzSaQ", function(module, exports) {

var $8hlRK = parcelRequire("8hlRK");

const $141d786062a33a3a$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $8hlRK.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};
module.exports["extractPersonFromJsonLd"] = $141d786062a33a3a$export$c471ae5fddcf1392;

});

parcelRegister("8hlRK", function(module, exports) {

var $kzBLz = parcelRequire("kzBLz");

const $15c3e8c19f3e9f93$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $kzBLz.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $kzBLz.extractUrlFromLinkJsonLd)(icon.url);
    }
    return undefined;
};
module.exports["extractUrlFromIconJsonLd"] = $15c3e8c19f3e9f93$export$67f3d92c824fd850;

});

parcelRegister("4sK6R", function(module, exports) {

var $kzSaQ = parcelRequire("kzSaQ");

const $120900a6e202ebd4$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $kzSaQ.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};
module.exports["extractPersonUpdatedBy"] = $120900a6e202ebd4$export$8a2d1ed7e6f336f0;

});

parcelRegister("ccQw1", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");





var $dh538 = parcelRequire("dh538");


var $3fvfu = parcelRequire("3fvfu");


var $8hlRK = parcelRequire("8hlRK");

var $kzBLz = parcelRequire("kzBLz");

const $56eab8749893649b$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $56eab8749893649b$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $56eab8749893649b$var$extractProviderImage(generator.image)
            };
        }
    }
    return undefined;
};
const $56eab8749893649b$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $3fvfu.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
        else if (id === (0, $3fvfu.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
    }
    if (icon) return (0, $8hlRK.extractUrlFromIconJsonLd)(icon);
    return undefined;
};
const $56eab8749893649b$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $kzBLz.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $kzBLz.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
const $56eab8749893649b$export$38df542ff03a4183 = (id)=>{
    return id === (0, $3fvfu.CONFLUENCE_GENERATOR_ID);
};
module.exports["extractProvider"] = $56eab8749893649b$export$a832871718466647;
module.exports["extractProviderIcon"] = $56eab8749893649b$export$6fb636a2ac885215;
module.exports["isConfluenceGenerator"] = $56eab8749893649b$export$38df542ff03a4183;

});

parcelRegister("3fvfu", function(module, exports) {
const $443f0fc151c7533d$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $443f0fc151c7533d$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $443f0fc151c7533d$export$84a73a0383f58180 = 'JiraTask';
const $443f0fc151c7533d$export$c6c83963a9378a67 = 'JiraSubTask';
const $443f0fc151c7533d$export$58af3c426c111a6d = 'JiraStory';
const $443f0fc151c7533d$export$ac9898a63417219e = 'JiraBug';
const $443f0fc151c7533d$export$54db5e3fb12e39cd = 'JiraEpic';
const $443f0fc151c7533d$export$2f54a5a217202c85 = 'JiraIncident';
const $443f0fc151c7533d$export$d097371052bfc411 = 'JiraServiceRequest';
const $443f0fc151c7533d$export$efd9452ad16c6676 = 'JiraChange';
const $443f0fc151c7533d$export$2e7e70abb5d81f67 = 'JiraProblem';
const $443f0fc151c7533d$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
module.exports["CONFLUENCE_GENERATOR_ID"] = $443f0fc151c7533d$export$cee224b5de4d6d66;
module.exports["JIRA_GENERATOR_ID"] = $443f0fc151c7533d$export$f654d825189934a7;

});

parcelRegister("hUifo", function(module, exports) {

var $2LN0V = parcelRequire("2LN0V");


var $aliCf = parcelRequire("aliCf");

const $ca558e6955be7d7f$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $2LN0V.extractContext)(jsonLd);
    const type = (0, $aliCf.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};
module.exports["extractTitle"] = $ca558e6955be7d7f$export$b05803156e5015b6;

});

parcelRegister("2LN0V", function(module, exports) {

var $aliCf = parcelRequire("aliCf");


var $8hlRK = parcelRequire("8hlRK");

const $1aa29b094fdafad8$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $8hlRK.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $aliCf.extractType)(context)
            };
        }
    }
    return undefined;
};
module.exports["extractContext"] = $1aa29b094fdafad8$export$efdbd45f3e77a161;

});

parcelRegister("aliCf", function(module, exports) {
const $b71c91ab48ca7fcb$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};
module.exports["extractType"] = $b71c91ab48ca7fcb$export$2e9ae379995d99e3;

});

parcelRegister("9JHBV", function(module, exports) {

var $lmIyd = parcelRequire("lmIyd");


var $kzBLz = parcelRequire("kzBLz");

const $619c28d037f806e9$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $lmIyd.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $kzBLz.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $kzBLz.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};
module.exports["extractPreview"] = $619c28d037f806e9$export$4b0d98b1b7f6d115;

});

parcelRegister("lmIyd", function(module, exports) {
const $0d1a0b98f1eafbac$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};
module.exports["extractPlatformIsSupported"] = $0d1a0b98f1eafbac$export$3e8ad908070b68b2;

});

parcelRegister("lyclm", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");





var $dh538 = parcelRequire("dh538");


var $3fvfu = parcelRequire("3fvfu");

const $fe608b0eca8c0821$export$8beff7405d020ddf = (response)=>response?.entityData;
const $fe608b0eca8c0821$export$c7168210b81d9383 = (response)=>Boolean($fe608b0eca8c0821$export$8beff7405d020ddf(response));
const $fe608b0eca8c0821$export$f97663ee76ac5b24 = (response)=>{
    const entity = $fe608b0eca8c0821$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $fe608b0eca8c0821$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $3fvfu.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        case 0, $3fvfu.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url
    };
};
const $fe608b0eca8c0821$export$19346520e937a99f = (response)=>{
    const entity = $fe608b0eca8c0821$export$8beff7405d020ddf(response);
    let url;
    if (entity) url = 'iconUrl' in entity && typeof entity?.iconUrl === 'string' ? entity.iconUrl : response?.meta.generator?.icon?.url;
    return {
        url: url,
        label: entity?.displayName
    };
};
module.exports["extractEntity"] = $fe608b0eca8c0821$export$8beff7405d020ddf;
module.exports["isEntityPresent"] = $fe608b0eca8c0821$export$c7168210b81d9383;
module.exports["extractEntityEmbedUrl"] = $fe608b0eca8c0821$export$f97663ee76ac5b24;
module.exports["extractEntityProvider"] = $fe608b0eca8c0821$export$ad879f2c9d5100a0;
module.exports["extractEntityIcon"] = $fe608b0eca8c0821$export$19346520e937a99f;

});

parcelRegister("i0VEL", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");

class $1946187bbb294084$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $eTj7Y.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) // Replace promise with the resolved data in the cache
                this.cache[dataKey] = {
                    source: 'network',
                    data: data
                };
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $1946187bbb294084$export$1185db7a00c13eed;

});

parcelRegister("dDhJe", function(module, exports) {
const $acfecaf0839e2c0b$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $acfecaf0839e2c0b$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $acfecaf0839e2c0b$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $acfecaf0839e2c0b$export$e2b040f052407032 = {
    dev: $acfecaf0839e2c0b$var$devBaseUrl,
    development: $acfecaf0839e2c0b$var$devBaseUrl,
    stg: $acfecaf0839e2c0b$var$stgBaseUrl,
    staging: $acfecaf0839e2c0b$var$stgBaseUrl,
    prd: $acfecaf0839e2c0b$var$prodBaseUrl,
    prod: $acfecaf0839e2c0b$var$prodBaseUrl,
    production: $acfecaf0839e2c0b$var$prodBaseUrl
};
const $acfecaf0839e2c0b$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? $acfecaf0839e2c0b$var$prodBaseUrl;
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $acfecaf0839e2c0b$export$e2b040f052407032 ? $acfecaf0839e2c0b$export$e2b040f052407032[envKey] : $acfecaf0839e2c0b$var$prodBaseUrl;
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $acfecaf0839e2c0b$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $acfecaf0839e2c0b$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $acfecaf0839e2c0b$export$2e2bcd8739ae039 = $acfecaf0839e2c0b$export$e2b040f052407032;
module.exports["getBaseUrl"] = $acfecaf0839e2c0b$export$f654b28f82155665;
module.exports["getResolverUrl"] = $acfecaf0839e2c0b$export$dc37652c1696f231;

});

parcelRegister("btw9C", function(module, exports) {
const $2b201a7ae9d0ebd0$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $2b201a7ae9d0ebd0$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $2b201a7ae9d0ebd0$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};
module.exports["getStatus"] = $2b201a7ae9d0ebd0$export$b70265791d2079d4;

});

parcelRegister("5nJCu", function(module, exports) {
class $b839f3682b6db3a9$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    buildDatasourceAdf(datasource, url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    }
    toSmartlinkAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
    toDatasourceAdf(datasource, url) {
        return this.buildDatasourceAdf(datasource, url);
    }
}
module.exports["Transformer"] = $b839f3682b6db3a9$export$f993aef960936087;

});

parcelRegister("k00oi", function(module, exports) {

var $1bFdN = parcelRequire("1bFdN");


var $1oCLl = parcelRequire("1oCLl");


var $Gi9G7 = parcelRequire("Gi9G7");


var $abpX2 = parcelRequire("abpX2");


var $jHnts = parcelRequire("jHnts");

var $dDhJe = parcelRequire("dDhJe");

var $btw9C = parcelRequire("btw9C");

var $gmi3X = parcelRequire("gmi3X");


var $97i3I = parcelRequire("97i3I");


var $9trs7 = parcelRequire("9trs7");


var $6a9Hv = parcelRequire("6a9Hv");


var $dh538 = parcelRequire("dh538");

const $542f7628c45b2158$var$MAX_BATCH_SIZE = 50;
const $542f7628c45b2158$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $542f7628c45b2158$var$URL_RESPONSE_CACHE_SIZE = 100;
const $542f7628c45b2158$export$d6a66073b5d79eb3 = new (0, $9trs7.LRUMap)($542f7628c45b2158$var$URL_RESPONSE_CACHE_SIZE);
class $542f7628c45b2158$export$2e2bcd8739ae039 {
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($abpX2)))({
            limit: 1,
            interval: $542f7628c45b2158$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $542f7628c45b2158$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($abpX2)))({
            limit: 1,
            interval: $542f7628c45b2158$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $542f7628c45b2158$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $542f7628c45b2158$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            if ((0, $dh538.fg)('platform_linking_force_no_cache_smart_card_client')) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined
                });
            } else responsePromise = loader.load(url);
            $542f7628c45b2158$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $542f7628c45b2158$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $97i3I.isSuccessfulResponse)(response) || (0, $btw9C.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $542f7628c45b2158$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $97i3I.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($Gi9G7)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $97i3I.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $97i3I.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($Gi9G7)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $97i3I.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $gmi3X.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $gmi3X.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $97i3I.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $gmi3X.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $gmi3X.NetworkError)) return new (0, $jHnts.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $jHnts.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $jHnts.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $jHnts.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $jHnts.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $jHnts.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
    constructor(envKey, baseUrlOverride){
        this.resolverUrl = void 0;
        this.envKey = void 0;
        this.baseUrlOverride = void 0;
        this.urlLoadersByDomain = void 0;
        this.loadersByDomain = void 0;
        this.retryConfig = void 0;
        this.resolvedCache = void 0;
        this.product = void 0;
        this.headers = void 0;
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...(0, $1oCLl.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $97i3I.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...(0, $1oCLl.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $97i3I.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>resource.resourceUrl);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $dDhJe.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
}
module.exports["default"] = $542f7628c45b2158$export$2e2bcd8739ae039;

});

parcelRegister("Gi9G7", function(module, exports) {
// Packages

var $bfRrZ = parcelRequire("bfRrZ");

function $07f201957e3f51a5$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $bfRrZ.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $07f201957e3f51a5$var$retry;

});

parcelRegister("bfRrZ", function(module, exports) {

module.exports = (parcelRequire("2CRnP"));

});

parcelRegister("2CRnP", function(module, exports) {

var $jWveU = parcelRequire("jWveU");

exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $jWveU(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});

parcelRegister("jWveU", function(module, exports) {
function $e84baaa017e10274$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $e84baaa017e10274$var$RetryOperation;
$e84baaa017e10274$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$e84baaa017e10274$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$e84baaa017e10274$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$e84baaa017e10274$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$e84baaa017e10274$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$e84baaa017e10274$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$e84baaa017e10274$var$RetryOperation.prototype.start = $e84baaa017e10274$var$RetryOperation.prototype.try;
$e84baaa017e10274$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$e84baaa017e10274$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$e84baaa017e10274$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});

parcelRegister("abpX2", function(module, exports) {
'use strict';
class $769f0fd050ef86b5$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $769f0fd050ef86b5$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $769f0fd050ef86b5$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $769f0fd050ef86b5$var$pThrottle;
module.exports.AbortError = $769f0fd050ef86b5$var$AbortError;

});

parcelRegister("jHnts", function(module, exports) {
class $65b10cace4bd92e7$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}
module.exports["APIError"] = $65b10cace4bd92e7$export$3e5b797e39668f84;

});

parcelRegister("gmi3X", function(module, exports) {
const $ffe0c3b764a3e96a$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $ffe0c3b764a3e96a$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $ffe0c3b764a3e96a$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $ffe0c3b764a3e96a$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $ffe0c3b764a3e96a$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["NetworkError"] = $ffe0c3b764a3e96a$export$bae979e68e4dc802;
module.exports["request"] = $ffe0c3b764a3e96a$export$b5fe3f66a567bec0;

});

parcelRegister("97i3I", function(module, exports) {
const $e30f485c735f2746$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $e30f485c735f2746$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};
module.exports["isSuccessfulResponse"] = $e30f485c735f2746$export$1b59fe731a28a49d;
module.exports["isErrorResponse"] = $e30f485c735f2746$export$bea7bee8a87e7c52;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("lEzf1", function(module, exports) {
const $73e1dba18235f000$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $73e1dba18235f000$export$bae979e68e4dc802 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(error){
        super(error);
    }
}
async function $73e1dba18235f000$export$b5fe3f66a567bec0(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, headers) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || $73e1dba18235f000$var$ALLOWED_RESPONSE_STATUS_CODES.includes(response.status)) return await response.json();
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $73e1dba18235f000$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["request"] = $73e1dba18235f000$export$b5fe3f66a567bec0;

});

parcelRegister("iGhtC", function(module, exports) {

var $477dG = parcelRequire("477dG");

const $6f3acea258be288a$var$isLoomUrl = (url)=>{
    return url.match(// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
    RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})"));
};
class $6f3acea258be288a$export$d4825e69ed899a33 extends (0, $477dG.EditorCardProvider) {
    getHardCodedAppearance(url) {
        if ($6f3acea258be288a$var$isLoomUrl(url)) return 'embed';
    }
}
module.exports["InlineCommentEditorCardProvider"] = $6f3acea258be288a$export$d4825e69ed899a33;

});

parcelRegister("cvzKy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $fwDOR = parcelRequire("fwDOR");


var $4icDV = parcelRequire("4icDV");

var $70LTe = parcelRequire("70LTe");


var $gzdsP = parcelRequire("gzdsP");


var $dPJCf = parcelRequire("dPJCf");


var $9eE57 = parcelRequire("9eE57");


var $6mKj3 = parcelRequire("6mKj3");


var $17wUi = parcelRequire("17wUi");


var $5q601 = parcelRequire("5q601");


var $3D6Pp = parcelRequire("3D6Pp");


var $b8XTE = parcelRequire("b8XTE");


var $7d2Nc = parcelRequire("7d2Nc");


var $ao6k0 = parcelRequire("ao6k0");


var $9137z = parcelRequire("9137z");


var $iFjdQ = parcelRequire("iFjdQ");


var $j8hiR = parcelRequire("j8hiR");


var $hYoU4 = parcelRequire("hYoU4");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $7r2px = parcelRequire("7r2px");


var $juCeZ = parcelRequire("juCeZ");


var $eSLr0 = parcelRequire("eSLr0");


var $9wGTI = parcelRequire("9wGTI");


var $koYWo = parcelRequire("koYWo");


var $3VbV8 = parcelRequire("3VbV8");


var $jG3mR = parcelRequire("jG3mR");


var $8Lceu = parcelRequire("8Lceu");

const $50ece43bf392701d$var$markFMPExperienceActionMeasures = (fmpTimestamp)=>{
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_INTENT_EDIT_FMP_ACTION), fmpTimestamp);
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_ROUTE_CHANGE_TO_FMP_ACTION), fmpTimestamp);
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EMBEDDED_EDIT_FMP_ACTION), fmpTimestamp);
};
const $50ece43bf392701d$var$markTTIExperienceActionMeasures = (ttiTimestamp)=>{
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_INTENT_EDIT_TTI_ACTION), ttiTimestamp);
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_ROUTE_CHANGE_TO_TTI_ACTION), ttiTimestamp);
    (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_INIT, ttiTimestamp);
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EMBEDDED_EDIT_TTI_ACTION), ttiTimestamp);
};
const $50ece43bf392701d$var$PageLoadWrapperComponent = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, proseMirrorRenderedData: proseMirrorRenderedData, disabled: disabled, isCreate: isCreate, editSource: editSource, embeddedConfluenceSource: embeddedConfluenceSource, isLivePage: isLivePage, customPerfData: customPerfData, draftBody: draftBody })=>{
    // When editor content is rendered on server, FMP should be reported as TTR on initial load,
    // as the moment when initial HTML is rendered, not when proseMirrorRenderedData is available.
    const isTransition = (0, $dPJCf.useIsTransition)();
    const initialFmpTimestamp = !isTransition && window.__SSR_RENDERED__ ? (0, $9eE57.getMark)('CFP-63.ssr-ttr') : undefined;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [renderPageLoadEnd, setRenderPageLoadEnd] = (0, $42omo.useState)(false);
    const [renderPageSegmentLoadEnd, setPageSegmentLoadEnd] = (0, $42omo.useState)(false);
    const [editorEnabledTimestamp, setEditorEnabledTimestamp] = (0, $42omo.useState)();
    const [fmpTimestamp, setFMPTimestamp] = (0, $42omo.useState)();
    const [isFirstLoadAfterTemplateCreation, setIsFirstLoadAfterTemplateCreation] = (0, $42omo.useState)();
    const [{ hasInitialDraft: hasInitialDraft }] = (0, $hYoU4.useNativeCollabState)();
    const sendMetrics = (0, $70LTe.useEmbeddedConfluenceEventMarkers)();
    const panelsModuleKeysAtlGeneral = (0, $juCeZ.useConnectAppsData)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    });
    const panelsModuleKeysAtlFooter = (0, $juCeZ.useConnectAppsData)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    });
    const contentExtensionMetrics = (0, $42omo.useMemo)(()=>{
        let metrics = customPerfData?.contentExtensionMetrics || {};
        if (draftBody && Object.keys(metrics).length === 0) metrics = (0, $7r2px.retrieveContentExtensionMetrics)(draftBody);
        return metrics;
    }, [
        draftBody,
        customPerfData?.contentExtensionMetrics
    ]);
    const smartlinksInitialState = !isTransition && window.__SSR_RENDERED__ && window['__SSR_SMARTLINKS__'];
    const preloadSmartlinksCount = (0, $42omo.useMemo)(()=>{
        if (!smartlinksInitialState) return 0;
        return Object.keys(smartlinksInitialState).length;
    }, [
        smartlinksInitialState
    ]);
    // When buffering is enabled, there are scenarios in which TTI can be marked prior to FMP.
    // In these cases, we wait until PM data becomes available and set TTI to be FMP.
    const markPageLoad = (fmpTimestamp, stopTime, isLivePage)=>{
        const ttiTimestamp = stopTime < fmpTimestamp ? fmpTimestamp : stopTime;
        $50ece43bf392701d$var$markTTIExperienceActionMeasures(ttiTimestamp);
        setEditorEnabledTimestamp(ttiTimestamp);
        setPageSegmentLoadEnd(true);
        if (!isLivePage) setRenderPageLoadEnd(true);
    };
    const pmRenderedTimestamp = proseMirrorRenderedData?.proseMirrorRenderedTimestamp;
    const documentStats = (0, $42omo.useMemo)(()=>(0, $8Lceu.getContentStats)(draftBody), [
        draftBody
    ]);
    const totalNodes = (0, $42omo.useMemo)(()=>{
        const allNodesCount = Object.values(documentStats);
        return allNodesCount.reduce((acc, nodeCnt)=>acc + nodeCnt, 0);
    }, [
        documentStats
    ]);
    // Check if this is the first load after creating a page from a template. We have experienced TTVC offenders through template-flows, so this is to identify those offenders.
    (0, $42omo.useEffect)(()=>{
        if ((0, $6mKj3.expValEquals)('platform_editor_template_creation_ufo_attribute', 'isEnabled', true)) {
            const contentIdSpecificKey = `page-created-from-template-${contentId}`;
            const templateCreatedTimestamp = (0, $17wUi.confluenceLocalStorageInstance).getItem(contentIdSpecificKey);
            if (templateCreatedTimestamp) {
                const timeSinceCreation = Date.now() - parseInt(templateCreatedTimestamp, 10);
                // Only consider it valid if it happened within the last 15 seconds. This is to avoid reading stale localStorage values.
                if (timeSinceCreation < 15000) setIsFirstLoadAfterTemplateCreation(true);
                else setIsFirstLoadAfterTemplateCreation(false);
                (0, $17wUi.confluenceLocalStorageInstance).removeItem(contentIdSpecificKey);
            } else setIsFirstLoadAfterTemplateCreation(false);
        }
    }, [
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        const renderContentTimestamp = pmRenderedTimestamp || initialFmpTimestamp;
        // mark FMP only once proseMirrorRenderedData has a defined value
        if (!fmpTimestamp && renderContentTimestamp) {
            setFMPTimestamp(renderContentTimestamp);
            $50ece43bf392701d$var$markFMPExperienceActionMeasures(renderContentTimestamp);
        }
        // Initially, when TTI is being marked for the first time, PM data either be defined or undefined
        if (typeof editorEnabledTimestamp === 'undefined' && !disabled) {
            const stopTime = performance.now();
            if (editSource === 'EmbeddedEditor') {
                const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
                const uniqueKey = observableObject?.object?.uniqueKey;
                sendMetrics({
                    timestamp: Date.now(),
                    ...uniqueKey && (0, $9wGTI.fg)('platform_deprecate_lp_cc_embed') ? {
                        customData: {
                            uniqueKey: uniqueKey
                        }
                    } : {}
                }, `${(0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $4icDV.EMBEDDED_EDITOR_TTI)}`);
            }
            // if PM data is already available, mark the TTI and page load end
            if (fmpTimestamp && !renderPageLoadEnd) markPageLoad(fmpTimestamp, stopTime, isLivePage);
            else {
                // if PM data is not yet available, save the TTI to be used later when FMP becomes defined
                $50ece43bf392701d$var$markTTIExperienceActionMeasures(stopTime);
                setEditorEnabledTimestamp(stopTime);
            }
            (0, $koYWo.sendEditorStartedPageEvent)(createAnalyticsEvent, {
                isCreate: isCreate
            });
        } else if (editorEnabledTimestamp) // once PM data is available, mark the TTI and page load end
        {
            if (fmpTimestamp && !renderPageLoadEnd) markPageLoad(fmpTimestamp, editorEnabledTimestamp, isLivePage);
        }
    }, [
        initialFmpTimestamp,
        pmRenderedTimestamp,
        editorEnabledTimestamp,
        fmpTimestamp,
        disabled,
        renderPageLoadEnd,
        createAnalyticsEvent,
        isCreate,
        isLivePage,
        customPerfData,
        editSource,
        sendMetrics
    ]);
    // PageSegmentLoadEnd & PageLoadEnd have common custom data. PageLoadEnd is only fired for non-live pages.
    const commonCustomData = {
        fabric: true,
        isLivePage: isLivePage,
        embeddedConfluenceSource: embeddedConfluenceSource,
        documentStats: documentStats,
        contentExtensionMetrics: contentExtensionMetrics,
        preloadSmartlinksCount: preloadSmartlinksCount,
        totalNodes: totalNodes,
        isFirstLoadAfterTemplateCreation: isFirstLoadAfterTemplateCreation
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "AwaitEditorSegment",
        hold: !renderPageSegmentLoadEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $3VbV8.EDITOR_METRIC)
    }), fmpTimestamp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3D6Pp.PageLoadMarkFMP), {
        timestamp: fmpTimestamp
    }), renderPageSegmentLoadEnd && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
        key: `end-segment-${contentId}`,
        metric: (0, $3VbV8.EDITOR_METRIC),
        stopTime: editorEnabledTimestamp,
        customData: {
            ...commonCustomData,
            ...customPerfData
        }
    }), renderPageLoadEnd && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ao6k0.PageLoadEnd), {
        key: `end-page-${contentId}`,
        metric: editSource === 'EmbeddedEditor' ? (0, $3VbV8.EMBEDDED_EDIT_PAGE_LOAD) : (0, $3VbV8.EDIT_PAGE_LOAD),
        stopTime: editorEnabledTimestamp,
        customData: {
            ...commonCustomData,
            contentId: contentId,
            isCreate: isCreate,
            collabService: 'ncs',
            experienceActionMeasures: (0, $iFjdQ.ExperienceActionMeasures).getMeasures(),
            collabEditProviderMeasures: (0, $9137z.CollabEditProviderMeasures).getMeasures(),
            editSource: editSource,
            proseMirrorRenderedData: proseMirrorRenderedData,
            hasInitialDraft: hasInitialDraft,
            browserExtensions: (0, $jG3mR.getBrowserExtensions)(),
            webPanelsAtlGeneral: panelsModuleKeysAtlGeneral,
            webPanelsAtlFooter: panelsModuleKeysAtlFooter
        }
    }));
});
const $50ece43bf392701d$export$cff79a690992c9f3 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($50ece43bf392701d$var$PageLoadWrapperComponent);
module.exports["PageLoadWrapper"] = $50ece43bf392701d$export$cff79a690992c9f3;

});

parcelRegister("4icDV", function(module, exports) {
const $2c9093170036a8a1$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $2c9093170036a8a1$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $2c9093170036a8a1$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $2c9093170036a8a1$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $2c9093170036a8a1$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $2c9093170036a8a1$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $2c9093170036a8a1$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $2c9093170036a8a1$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $2c9093170036a8a1$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $2c9093170036a8a1$export$73b982309451f084;

});

parcelRegister("70LTe", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $da99c994e33d3600$export$6654a9a4dc3a2802 = ()=>{
    return (0, $42omo.useCallback)((payload, type)=>{
        window.parent.postMessage({
            type: type,
            payload: payload
        }, '*');
    }, []);
};
module.exports["useEmbeddedConfluenceEventMarkers"] = $da99c994e33d3600$export$6654a9a4dc3a2802;

});

parcelRegister("5q601", function(module, exports) {
const $23ec6b91fddb9839$export$190611e0edbb22d5 = 'viewEditButtonClicked';
const $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e = 'editButtonClickedToEditRouteChange';
const $23ec6b91fddb9839$export$caabe0b707a0bfac = 'editRouteChangeToPageLoad';
const $23ec6b91fddb9839$export$a5b3479b02282e8c = 'tinySynchronyPluginsLoad';
const $23ec6b91fddb9839$export$1787f4f7916eb601 = 'tinySynchronyContentFetch';
const $23ec6b91fddb9839$export$99c2e20685f1cd4e = 'editIntentToEditPageTTI';
const $23ec6b91fddb9839$export$e04cfb21f00b2ad0 = 'editIntentToEditPageFMP';
const $23ec6b91fddb9839$export$1d8f87e0ed24898e = 'editEmbeddedPageTTI';
const $23ec6b91fddb9839$export$16bdef2ba2fa4a5 = 'editEmbeddedPageFMP';
const $23ec6b91fddb9839$export$4d09a02f749e3cc2 = 'routeChangeToEditorTTI';
const $23ec6b91fddb9839$export$c2bda34fe2c26f89 = 'tinySynchronyContentMetadaPreload';
module.exports["VIEW_EDIT_BUTTON_CLICKED_ACTION"] = $23ec6b91fddb9839$export$190611e0edbb22d5;
module.exports["EDIT_ROUTE_CHANGE_ACTION"] = $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e;
module.exports["EDIT_ROUTE_CHANGE_TO_FMP_ACTION"] = $23ec6b91fddb9839$export$caabe0b707a0bfac;
module.exports["TINY_SYNCHRONY_PLUGINS_LOAD_ACTION"] = $23ec6b91fddb9839$export$a5b3479b02282e8c;
module.exports["TINY_SYNCHRONY_CONTENT_FETCH_ACTION"] = $23ec6b91fddb9839$export$1787f4f7916eb601;
module.exports["EDIT_INTENT_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$99c2e20685f1cd4e;
module.exports["EDIT_INTENT_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$e04cfb21f00b2ad0;
module.exports["EMBEDDED_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$1d8f87e0ed24898e;
module.exports["EMBEDDED_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$16bdef2ba2fa4a5;
module.exports["EDIT_ROUTE_CHANGE_TO_TTI_ACTION"] = $23ec6b91fddb9839$export$4d09a02f749e3cc2;
module.exports["TINY_SYNCHRONY_CONTENT_METADATA_PRELOAD"] = $23ec6b91fddb9839$export$c2bda34fe2c26f89;

});

parcelRegister("3D6Pp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3kTfj = parcelRequire("3kTfj");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");

/**
 * This component allows to mark customized FMP metric on page-load event.
 */ const $9d1c13d4e17db9f2$var$PageLoadMarkFMPComponent = ({ timestamp: timestamp })=>{
    const pageLoadMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    (0, $42omo.useEffect)(()=>{
        if (typeof timestamp === 'number') pageLoadMetric.markFMP(timestamp);
        else {
            pageLoadMetric.markFMP();
            try {
                performance.mark('browser-metric.fmp');
                performance.measure('browser-metric:fmp', (0, $6VdZc.isInitial)() ? undefined : 'browser-metric.start', 'browser-metric.fmp');
            } catch (e) {
            // Suppress error when performance API failed.
            // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
            // That's why wrap with try catch statement.
            }
        }
    }, [
        timestamp,
        pageLoadMetric
    ]);
    return null;
};
const $9d1c13d4e17db9f2$export$107265ce1e467930 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($9d1c13d4e17db9f2$var$PageLoadMarkFMPComponent);
module.exports["PageLoadMarkFMP"] = $9d1c13d4e17db9f2$export$107265ce1e467930;

});

parcelRegister("b8XTE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $3kTfj = parcelRequire("3kTfj");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");

const $eb0c119b7155e6d7$var$noop = ()=>{};
const $eb0c119b7155e6d7$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $eb0c119b7155e6d7$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    // Use refs to avoid firing handlePageSegmentLoadMetricStop more than once despite changes to stopTime or customData
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handlePageSegmentLoadMetricStop = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            metric.stop({
                customData: {
                    ...finalCustomData,
                    previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                    previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                stopTime: stopTimeRef.current
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageSegmentLoadMetricStop, timing);
    return null;
}, /**
	 * Use lodash isEqual as comparator to avoid unnecessary re-renders
	 * i.e. when an object is defined directly within customData prop
	 * `<PageLoadSegmentEnd ... customData={{ data: 'example' }} />`
	 * (Export only for testing)
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $eb0c119b7155e6d7$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($eb0c119b7155e6d7$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $eb0c119b7155e6d7$export$a267cdf45880b07b;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
	 * This will perform the given action at a scheduled time after the
	 * component has painted.
	 *
	 * This is the default behavior.
	 */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
	 * This will perform the given action at the next animation frame (after the
	 * component has been painted).
	 */ ActionTiming["PAINT"] = "PAINT";
    /**
	 * This will perform the given action at the moment its render function
	 * fires.
	 *
	 * NOTE: This is called _within_ the render body, making it unpure. The
	 * component is memoized, so it will fire this only once for a given set
	 * of props. Be careful when using this, since it is unsafe.
	 */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["RECENT_DROPDOWN_ITEM_CLICK"] = $f3fed16e32582dfc$export$e20b00d7fdb37fd5;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("7d2Nc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3kTfj = parcelRequire("3kTfj");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");

const $c2bdb1677e0a2d6c$var$noop = ()=>{};
const $c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, onComplete: onComplete = $c2bdb1677e0a2d6c$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY, isCustomStart: isCustomStart = false })=>{
    const handlePageLoadMetricStart = (0, $42omo.useCallback)(()=>{
        if (metric) {
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${metric.key}`);
            if (isCustomStart) metric.start();
            else metric.startFromPageLoad();
            onComplete();
        }
    }, [
        metric,
        onComplete,
        isCustomStart
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageLoadMetricStart, timing);
    return null;
});
const $c2bdb1677e0a2d6c$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $c2bdb1677e0a2d6c$export$f11db193fdaffcc9;

});

parcelRegister("ao6k0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $kmyZQ = parcelRequire("kmyZQ");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");


var $6VdZc = parcelRequire("6VdZc");

var $7fw2E = parcelRequire("7fw2E");

const $3ef4c99d4b0f9884$var$PageLoadEndImpl = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime, onComplete: onComplete })=>{
    (0, $42omo.useEffect)(()=>{
        const stopArguments = {
            stopTime: typeof stopTime === 'number' ? stopTime : undefined,
            customData: {
                ...customData,
                previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            }
        };
        metric.stop(stopArguments);
        (0, $7fw2E.markBrowserMetricEnd)(metric);
        (0, $7sK8i.resumeLowPriorityEvents)();
        // trigger onComplete regardless of FF - PageLoadEnd can stop the progress bar temporarily,
        // as ProgressBarContainer returns early if the progress bar has already been stopped.
        onComplete();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData` or `stopTime`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onComplete,
        metric
    ]);
    return null;
});
const $3ef4c99d4b0f9884$var$PageLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, customData: customData, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__)) {
        const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
        const attribution = Boolean(window.__SSR_REACT_STREAMING__) ? 'streaming-hydration' : 'hydration';
        if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
            source: `PageLoadEnd - ${metric?.key}`,
            route: route,
            errorWithRoute: errorWithRoute,
            isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
        })).fire();
        else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
            attribution: attribution
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kmyZQ.ProgressBarContainer)
        ]
    }, (progressBar)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3ef4c99d4b0f9884$var$PageLoadEndImpl, {
            metric: metric,
            customData: customData,
            stopTime: stopTime,
            onComplete: progressBar.finish
        }));
});
const $3ef4c99d4b0f9884$export$570dec5b65c6715b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($3ef4c99d4b0f9884$var$PageLoadEndComponent);
module.exports["PageLoadEnd"] = $3ef4c99d4b0f9884$export$570dec5b65c6715b;

});

parcelRegister("dtDUi", function(module, exports) {

var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("7fw2E", function(module, exports) {

var $6VdZc = parcelRequire("6VdZc");

const $4bc3b2e76c18c48c$export$94f26401757ac8e7 = (metric)=>{
    let params;
    try {
        if ((0, $6VdZc.isInitial)()) {
            if (metric) {
                const data = metric.getData?.();
                const start = data?.start || 0;
                const stop = data?.stop || 0;
                params = [
                    {
                        duration: stop - start,
                        end: 'browser-metric.end'
                    }
                ];
            } else params = [
                undefined,
                'browser-metric.end'
            ];
        } else params = [
            'browser-metric.start',
            'browser-metric.end'
        ];
        performance.mark('browser-metric.end');
        performance.measure('browser-metric:tti', ...params);
    } catch (e) {
    // Suppress error when performance API failed.
    // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
    // That's why wrap with try catch statement.
    }
};
module.exports["markBrowserMetricEnd"] = $4bc3b2e76c18c48c$export$94f26401757ac8e7;

});

parcelRegister("9137z", function(module, exports) {

var $kGrzq = parcelRequire("kGrzq");

const $e77725a58fc80757$export$d93492bf620814be = new (0, $kGrzq.BaseMeasures)();
module.exports["CollabEditProviderMeasures"] = $e77725a58fc80757$export$d93492bf620814be;

});

parcelRegister("j8hiR", function(module, exports) {
var $fbca710eb28c4147$export$d0a57beabaefb993 = /*#__PURE__*/ function(COLLAB_EDIT_PROVIDER_MEASURES) {
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH"] = "collabEditProviderAnalyticsFetch";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CREATED"] = "collabEditProviderCreated";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_DISABLED"] = "collabEditProviderDisabled";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT"] = "collabEditProviderInitialized";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRE_CONNECTED"] = "collabEditProviderPreconnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CONNECTED"] = "collabEditProviderConnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT_DOC"] = "collabEditProviderInitDoc";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT"] = "collabEditProviderFetchNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT"] = "collabEditProviderPreloadNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT_TIMEOUT"] = "collabEditProviderPreloadNCSDraftTimeout";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_PERMS_TOKEN_FETCH"] = "collabEditProviderPermsTokenFetch";
    return COLLAB_EDIT_PROVIDER_MEASURES;
}({});
module.exports["COLLAB_EDIT_PROVIDER_MEASURES"] = $fbca710eb28c4147$export$d0a57beabaefb993;

});

parcelRegister("7r2px", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

const $0bdd6e0a6db7c960$var$logger = (0, $7W8i8.getLogger)('retrieveContentExtensionMetrics');
const $0bdd6e0a6db7c960$export$5da22daff5be7fe6 = (contentBody)=>{
    try {
        const contentExtensionMetrics = {
            contentExtensionCount: {
                connect: {},
                forge: {}
            },
            contentExtensionKeys: {
                connect: [],
                forge: []
            },
            hasExtensions: false
        };
        const document = JSON.parse(contentBody);
        document?.content?.forEach((node)=>{
            $0bdd6e0a6db7c960$export$bd4248834ea73a5(node, contentExtensionMetrics);
        });
        return contentExtensionMetrics;
    } catch  {
        $0bdd6e0a6db7c960$var$logger.error`Unable to parse ADF`;
        return {};
    }
};
const $0bdd6e0a6db7c960$export$bd4248834ea73a5 = (node, contentExtensionMetrics)=>{
    $0bdd6e0a6db7c960$var$retrieveContentExtensionCountFromNode(node, contentExtensionMetrics.contentExtensionCount);
    $0bdd6e0a6db7c960$var$retrieveContentExtensionKeysFromNode(node, contentExtensionMetrics.contentExtensionKeys);
    contentExtensionMetrics.hasExtensions = contentExtensionMetrics.contentExtensionKeys?.connect.length > 0 || contentExtensionMetrics.contentExtensionKeys?.forge.length > 0;
    return contentExtensionMetrics;
};
function $0bdd6e0a6db7c960$var$retrieveContentExtensionKeysFromNode({ attrs: attrs, type: type }, contentExtensionKeys) {
    if (attrs && type) {
        const { extensionType: extensionType, extensionKey: extensionKey } = attrs;
        // Forge extensions have extensionType of 'com.atlassian.ecosystem' whereas Connect extensions have 'com.atlassian.confluence.macro.core'.
        if (extensionType === 'com.atlassian.ecosystem' && extensionKey) contentExtensionKeys.forge.push(extensionKey);
        else if (extensionType === 'com.atlassian.confluence.macro.core' && extensionKey) contentExtensionKeys.connect.push(extensionKey);
        else return;
    }
}
function $0bdd6e0a6db7c960$var$retrieveContentExtensionCountFromNode({ attrs: attrs, type: type }, contentExtensionCount) {
    if (attrs && type) {
        const { extensionType: extensionType } = attrs;
        // Forge extensions have extensionType of 'com.atlassian.ecosystem' whereas Connect extensions have 'com.atlassian.confluence.macro.core'.
        let extensionsObj;
        if (extensionType === 'com.atlassian.ecosystem') extensionsObj = contentExtensionCount.forge;
        else if (extensionType === 'com.atlassian.confluence.macro.core') extensionsObj = contentExtensionCount.connect;
        else return;
        if (extensionsObj) extensionsObj[type] = (extensionsObj[type] || 0) + 1;
    }
}
module.exports["retrieveContentExtensionMetrics"] = $0bdd6e0a6db7c960$export$5da22daff5be7fe6;
module.exports["retrieveContentExtensionMetricsFromNode"] = $0bdd6e0a6db7c960$export$bd4248834ea73a5;

});

parcelRegister("juCeZ", function(module, exports) {

var $xQxzY = parcelRequire("xQxzY");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $8pvtc = parcelRequire("8pvtc");

const $816e839f3c4509f6$export$b3d89882591ee965 = ({ contentId: contentId, location: location })=>{
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: location
        }
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $8pvtc.WebPanelLocationQuery), baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $8pvtc.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first'
    });
    const panels = data?.webPanels || [];
    return panels.map((panel)=>panel?.moduleKey).join(',');
};
module.exports["useConnectAppsData"] = $816e839f3c4509f6$export$b3d89882591ee965;

});

parcelRegister("koYWo", function(module, exports) {

var $iFjdQ = parcelRequire("iFjdQ");


var $5q601 = parcelRequire("5q601");

const $b52d61085419c758$var$EDITOR_STARTED_MAX_MS = 15000;
const $b52d61085419c758$export$a8df9cafe21ac55e = (createAnalyticsEvent, analytics)=>{
    const { isCreate: isCreate } = analytics;
    const measures = (0, $iFjdQ.ExperienceActionMeasures).getMeasures();
    if (!measures.hasOwnProperty((0, $5q601.EDIT_ROUTE_CHANGE_TO_TTI_ACTION))) return;
    const timeToInitializeEditor = measures[0, $5q601.EDIT_ROUTE_CHANGE_TO_TTI_ACTION].duration;
    // Don't send event if editor took longer than 15 seconds to intialize or if page is being created
    if (timeToInitializeEditor > $b52d61085419c758$var$EDITOR_STARTED_MAX_MS || isCreate) return;
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'editorStarted',
            actionSubject: 'performanceTrigger',
            source: 'editPageScreen',
            attributes: {
                timeToInitializeEditor: timeToInitializeEditor
            }
        }
    }).fire();
};
module.exports["sendEditorStartedPageEvent"] = $b52d61085419c758$export$a8df9cafe21ac55e;

});

parcelRegister("3VbV8", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $1UCmC = parcelRequire("1UCmC");

var $jX1qB = parcelRequire("jX1qB");

var $fd6g2 = parcelRequire("fd6g2");

const $3fce579e2620525b$export$dfd790981c086398 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.FABRIC_PUBLISH_PAGE_KEY),
    histogram: {
        duration: '1000_2000_3000_4000_5000_6000_7000_8000_9000'
    }
});
const $3fce579e2620525b$export$5ac2615d36b4500c = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.EDIT_PAGE_LOAD_KEY),
    timings: [
        {
            key: 'onBeforeEditor',
            endMark: 'onBeforeEditor'
        },
        {
            key: 'editorRendered',
            startMark: 'onBeforeEditor'
        }
    ]
});
const $3fce579e2620525b$export$c5146b9e6a61ee5f = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.EDITOR_SEGMENT_KEY)
});
const $3fce579e2620525b$export$af294f5bd71dc2d = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.NCS_CONNECTED_FMP_KEY)
});
const $3fce579e2620525b$export$f9b776b1c66e5f0e = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.EMBEDDED_EDIT_PAGE_LOAD_KEY)
});
module.exports["FABRIC_PUBLISH_PAGE_METRIC"] = $3fce579e2620525b$export$dfd790981c086398;
module.exports["EDIT_PAGE_LOAD"] = $3fce579e2620525b$export$5ac2615d36b4500c;
module.exports["EDITOR_METRIC"] = $3fce579e2620525b$export$c5146b9e6a61ee5f;
module.exports["EMBEDDED_EDIT_PAGE_LOAD"] = $3fce579e2620525b$export$f9b776b1c66e5f0e;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["PUBLIC_LINKS_SPACE_SETTINGS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$4716363caa82a23b;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$fdd1a35fb559480a = 'recap-modal';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["RECAP_MODAL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$fdd1a35fb559480a;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;

});

parcelRegister("jG3mR", function(module, exports) {

var $1HVk8 = parcelRequire("1HVk8");

function $61eafb12aab3b3f9$export$4bc0e880260ffe3f() {
    return (0, $1HVk8.sniffUserBrowserExtensions)({
        extensions: [
            'grammarly'
        ]
    });
}
module.exports["getBrowserExtensions"] = $61eafb12aab3b3f9$export$4bc0e880260ffe3f;

});

parcelRegister("8Lceu", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");

const $049334d04d2ef297$var$extensionNodeSet = new Set([
    'extension',
    'inlineExtension',
    'bodiedExtension'
]);
const $049334d04d2ef297$export$81add81ff014aa45 = (draftBody)=>{
    if (!draftBody) return {};
    try {
        const doc = JSON.parse(draftBody);
        return (0, $1A9t2.reduce)(doc, (acc, node)=>{
            const key = $049334d04d2ef297$var$extensionNodeSet.has(node.type) ? `${node.type}:${node.attrs?.extensionKey}` : node.type;
            acc[key] = (acc[key] || 0) + 1;
            return acc;
        }, {});
    } catch (e) {
        return {};
    }
};
module.exports["getContentStats"] = $049334d04d2ef297$export$81add81ff014aa45;

});

parcelRegister("1A9t2", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $6d2a4e7dc7af02b0$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}
module.exports["reduce"] = $6d2a4e7dc7af02b0$export$533b26079ad0b4b;

});

parcelRegister("i8Ylv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $2Nwuj = parcelRequire("2Nwuj");


var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $5spQU = parcelRequire("5spQU");


var $lzcvT = parcelRequire("lzcvT");


var $9wGTI = parcelRequire("9wGTI");


var $5kEnh = parcelRequire("5kEnh");


var $42MJM = parcelRequire("42MJM");


var $48ubT = parcelRequire("48ubT");


var $euL71 = parcelRequire("euL71");


var $lsxnT = parcelRequire("lsxnT");


var $lbPWE = parcelRequire("lbPWE");


var $bdMSP = parcelRequire("bdMSP");


var $3GzdC = parcelRequire("3GzdC");


var $lwir9 = parcelRequire("lwir9");

const $618e6728be00f8eb$var$WAC_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $618e6728be00f8eb$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "editor-features.ai-optin-modal.title",
        defaultMessage: "Elevate your team\u2019s writing"
    },
    description: {
        id: "editor-features.ai-optin-modal.description",
        defaultMessage: "Help enhance your team\u2019s writing with Rovo. Let AI improve clarity, maintain a professional tone, or craft concise content."
    },
    readMoreText: {
        id: "editor-features.ai-optin-modal.learn-more.link.text",
        defaultMessage: "<a>Read about Rovo</a>"
    },
    adminTurnOnText: {
        id: "editor-features.ai-optin-modal.admin-turn-on-text",
        defaultMessage: "Turn on Rovo features for your users from Atlassian Administration."
    },
    closeCTAText: {
        id: "editor-features.ai-optin-modal.close-cta-text",
        defaultMessage: "Maybe later"
    },
    getStartCTAText: {
        id: "editor-features.ai-optin-modal.get-started-cta-text",
        defaultMessage: "Get started"
    },
    learnMoreText: {
        id: "editor-features.ai-optin-modal.learn-more-cta-text",
        defaultMessage: "Learn more"
    },
    upgradePlanText: {
        id: "editor-features.ai-optin-modal.upgrade-plan-text",
        defaultMessage: "To start using Rovo in your products, upgrade your plan."
    },
    upsellText: {
        id: "editor-features.ai-optin-modal.upsell-text",
        defaultMessage: "With Rovo (AI), your team can craft concise, clear, and professional content faster than ever."
    },
    freePlanText: {
        id: "editor-features.ai-optin-modal.free-plan-text",
        defaultMessage: "You\u2019re on the free plan."
    },
    standardPlanText: {
        id: "editor-features.ai-optin-modal.standard-plan-text",
        defaultMessage: "You\u2019re on the standard plan."
    }
});
const $618e6728be00f8eb$var$OptInModal = ({ onClose: onClose, edition: edition, isSiteAdmin: isSiteAdmin, orgId: orgId, environment: environment })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const adminLink = $618e6728be00f8eb$var$getOptInDeepLink(orgId, environment);
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { isEligible: isAiInEditorEligible, loading: isAiInEditorLoading, error: hasAiInEditorError, experienceUrl: aiInEditorExperienceUrl } = (0, $lbPWE.useIsEligibleForAiInEditor)();
    const { isABTreatment: isAiInEditorABTreatment } = (0, $bdMSP.useEnrolledAIInEditorModalsExperiment)({
        isEligible: isAiInEditorEligible && !isAiInEditorLoading && !hasAiInEditorError,
        touchpoint: 'ai-in-editor'
    });
    const onOptInReadMoreClick = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'editorAI',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editorAIOptInReadMoreLink',
                attributes: {
                    product: 'confluence',
                    isOrgAdmin: isSiteAdmin
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSiteAdmin
    ]);
    const showUpsell = edition !== (0, $euL71.ConfluenceEdition).PREMIUM;
    /**
   * HOT-116592 - https://atlassian.enterprise.slack.com/archives/C08MHDT1KLJ
   * This is used to track if the AIUpsell and / or AIOptIn components are rendered
   */ const onRender = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'editorAI',
                action: 'triggerOptInFlowModalRendered',
                actionSubject: 'editorAIOptInDialog',
                actionSubjectId: 'editorAIModalRendered',
                attributes: {
                    product: 'confluence',
                    isOrgAdmin: isSiteAdmin,
                    edition: edition,
                    env: environment,
                    upsell: showUpsell
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        showUpsell,
        edition,
        environment
    ]);
    if (isAiInEditorLoading) return null;
    if (!hasAiInEditorError && isAiInEditorABTreatment && aiInEditorExperienceUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3GzdC.ConfluenceAiInEditorModalWithErrorBoundaryLoadable), {
        experienceUrl: aiInEditorExperienceUrl,
        onClose: onClose,
        onRender: onRender
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: "fit-content",
        onClose: onClose,
        testId: showUpsell ? 'editor-ai-upsell-modal' : 'editor-ai-opt-in-modal',
        /**
   * HOT-116592 - https://atlassian.enterprise.slack.com/archives/C08MHDT1KLJ
   * Mark this modal as transactional as its a critical part of the ai upsell / opt in
   */ messageType: "transactional",
        messageId: "editor-ai-opt-in-modal"
    }, showUpsell ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42MJM.AIUpsell), {
        feature: "editorAI",
        title: formatMessage($618e6728be00f8eb$var$messages.title),
        body: `${formatMessage($618e6728be00f8eb$var$messages.upsellText)}
				<p></p>
				<p>${edition === (0, $euL71.ConfluenceEdition).FREE ? formatMessage($618e6728be00f8eb$var$messages.freePlanText) : formatMessage($618e6728be00f8eb$var$messages.standardPlanText)} ${formatMessage($618e6728be00f8eb$var$messages.upgradePlanText)}</p>`,
        image: {
            src: {
                default: (0, (/*@__PURE__*/$parcel$interopDefault($lwir9))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($lwir9)))
            },
            alt: 'editor-ai-opt-in-banner'
        },
        learnMoreLink: {
            message: formatMessage($618e6728be00f8eb$var$messages.learnMoreText),
            href: $618e6728be00f8eb$var$WAC_LINK
        },
        onRender: onRender
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5kEnh.default), {
        source: "editorAI",
        product: "confluence",
        isOrgAdmin: true,
        onAdminClose: onClose,
        // TODO: Update the attribute below so it is translated.
        // eslint-disable-next-line no-restricted-syntax
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($lwir9))),
            height: "96px",
            alt: "editor-ai-opt-in-banner"
        }),
        adminLink: adminLink,
        adminHeaderText: formatMessage($618e6728be00f8eb$var$messages.title),
        adminCloseCTAText: formatMessage($618e6728be00f8eb$var$messages.closeCTAText),
        adminCTAText: formatMessage($618e6728be00f8eb$var$messages.getStartCTAText),
        adminBodyText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($618e6728be00f8eb$var$messages.description), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$618e6728be00f8eb$var$messages.readMoreText,
            values: {
                a: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        href: $618e6728be00f8eb$var$WAC_LINK,
                        target: "_blank",
                        onClick: onOptInReadMoreClick,
                        rel: "noopener noreferrer"
                    }, s)
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($618e6728be00f8eb$var$messages.adminTurnOnText))),
        onRender: onRender
    }));
};
const $618e6728be00f8eb$var$getOptInDeepLink = (orgId, environment)=>{
    if (!orgId || !environment) return undefined;
    if (orgId) {
        if (environment === 'PRODUCTION') return `https://admin.atlassian.com/o/${orgId}/atlassian-intelligence`;
        else if (environment === 'STAGING') return `https://admin.stg.atlassian.com/o/${orgId}/atlassian-intelligence`;
    }
};
const $618e6728be00f8eb$var$getOptInStatus = (isAdminHubAIEnabled, isAIEnabledForContent, isSiteAdmin, edition)=>{
    const isAIFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai') : !(0, $lzcvT.isFedRamp)();
    if (!isAIFeatureEnabled) return 'disabled';
    if (!isAIEnabledForContent && isAdminHubAIEnabled) return 'disabled';
    if (isAdminHubAIEnabled) return 'enabled';
    if (edition === null) return 'disabled';
    if (isSiteAdmin) return 'disabled-opt-in';
    return 'disabled';
};
const $618e6728be00f8eb$var$defaultEmptyTrigger = ()=>{};
const $618e6728be00f8eb$var$defaultEmptyComponent = ()=>null;
const $618e6728be00f8eb$export$90c93708fff010b3 = ({ isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEnabledForContent: isAIEnabledForContent = true, edition: edition, orgId: orgId, environment: environment })=>{
    const isSiteAdmin = (0, $48ubT.useIsSiteAdmin)().isSiteAdmin;
    const optInStatus = $618e6728be00f8eb$var$getOptInStatus(isAdminHubAIEnabled, isAIEnabledForContent, isSiteAdmin, edition);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (optInStatus === 'disabled-opt-in') {
            const preloadImages = (paths)=>{
                paths.forEach((path)=>{
                    const img = new Image();
                    img.src = path;
                });
            };
            preloadImages([
                (0, (/*@__PURE__*/$parcel$interopDefault($lwir9)))
            ]);
        }
    }, [
        optInStatus
    ]);
    const [showOptInModal, setShowOptInModal] = (0, $42omo.useState)(false);
    const triggerOptInFlow = (0, $42omo.useCallback)(()=>{
        if (edition !== null) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'editorAI',
                action: 'triggerOptInFlow',
                actionSubject: 'editorAIOptInDialog',
                actionSubjectId: 'editorAIOptInTrigger',
                attributes: {
                    isOrgAdmin: isSiteAdmin,
                    optInType: edition === (0, $euL71.ConfluenceEdition).PREMIUM ? 'AIOptIn' : 'AIUpsell'
                }
            }
        }).fire();
        setShowOptInModal(true);
    }, [
        setShowOptInModal,
        createAnalyticsEvent,
        edition,
        isSiteAdmin
    ]);
    const AIOptInModal = (0, $42omo.useCallback)(()=>{
        const onCloseModal = ()=>setShowOptInModal(false);
        return showOptInModal && edition !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($618e6728be00f8eb$var$OptInModal, {
            onClose: onCloseModal,
            edition: edition,
            isSiteAdmin: isSiteAdmin,
            orgId: orgId,
            environment: environment
        }) : null;
    }, [
        showOptInModal,
        edition,
        isSiteAdmin,
        orgId,
        environment
    ]);
    if (optInStatus === 'disabled-opt-in') return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: AIOptInModal
    };
    return {
        optInStatus: optInStatus,
        triggerOptInFlow: $618e6728be00f8eb$var$defaultEmptyTrigger,
        AIOptInModal: $618e6728be00f8eb$var$defaultEmptyComponent
    };
};
const $618e6728be00f8eb$export$aa96168180a4e542 = (isAdminHubAIEnabled)=>{
    return isAdminHubAIEnabled ? 'enabled' : 'disabled';
};
module.exports["useEditorAIOptIn"] = $618e6728be00f8eb$export$90c93708fff010b3;

});

parcelRegister("5kEnh", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $3ouAo = parcelRequire("3ouAo");


var $gVzI4 = parcelRequire("gVzI4");


var $hA5CC = parcelRequire("hA5CC");


var $4LzvV = parcelRequire("4LzvV");

const $ad79fa1eeebb4272$var$VisibleTextOrgAdminStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $ad79fa1eeebb4272$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink, onRender: onRender })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const formatMessageValues = {
        a: (s)=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__confluence-ai') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                href: (0, $gVzI4.AI_LINK),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, $l998X.jsx)("a", {
                href: (0, $gVzI4.AI_LINK),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }),
        br: ()=>/*#__PURE__*/ (0, $l998X.jsx)("br", {})
    };
    const defaultHeader = formatMessage((0, $hA5CC.messages).aiOptInDialogHeaderText);
    const header = headerText ?? defaultHeader;
    const body = bodyText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogBodyText, formatMessageValues);
    const orgAdminBody = adminBodyText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogAdminBodyText, formatMessageValues);
    const orgAdminHeader = adminHeaderText ?? defaultHeader;
    (0, $42omo.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($3ouAo)))
        ]);
    }, []);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4LzvV.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $4LzvV.OptInContainer), {
            children: [
                image ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4LzvV.ImageWrapper), {
                    children: image
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $4LzvV.ImageWrapper), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3ouAo))),
                        height: "96px",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $4LzvV.ContentContainer), {
                    children: [
                        isOrgAdmin && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: $ad79fa1eeebb4272$var$VisibleTextOrgAdminStyles,
                            children: formatMessage((0, $hA5CC.messages).aiOptInAdminOnlyVisible)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $4LzvV.HeaderWrapper), {
                            children: isOrgAdmin ? orgAdminHeader : header
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $4LzvV.BodyWrapper), {
                            "data-testid": "dialog-body-text",
                            children: isOrgAdmin ? orgAdminBody : body
                        }),
                        isOrgAdmin && /*#__PURE__*/ (0, $l998X.jsxs)((0, $4LzvV.ButtonContainer), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                    appearance: "subtle",
                                    onClick: onCloseClicked,
                                    testId: "admin-close-button",
                                    children: adminCloseCTAText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogAdminMaybeLaterButtonText)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                                    appearance: "primary",
                                    onClick: onCTAClicked,
                                    href: adminLink ?? (0, $gVzI4.ADMIN_LINK),
                                    target: "_blank",
                                    testId: "admin-cta-button",
                                    children: adminCTAText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogAdminGetStartedButtonText)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $ad79fa1eeebb4272$export$2e2bcd8739ae039 = $ad79fa1eeebb4272$var$AiOptIn;
module.exports["default"] = $ad79fa1eeebb4272$export$2e2bcd8739ae039;

});

parcelRegister("3ouAo", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.cf053e66.svg", import.meta.url).toString();

});

parcelRegister("gVzI4", function(module, exports) {
const $30266e962d22c479$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $30266e962d22c479$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';
module.exports["AI_LINK"] = $30266e962d22c479$export$550fac1a4ec3d365;
module.exports["ADMIN_LINK"] = $30266e962d22c479$export$bae9a077d7ed5dfe;

});

parcelRegister("hA5CC", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $55820977c77a8e8c$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    /**
   * Messages for the AI Global Opt-in component
   */ aiOptInDialogHeaderText: {
        id: "ai-opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    aiOptInDialogBodyText: {
        id: "ai-opt-in.dialog.body.text",
        defaultMessage: "Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    aiOptInDialogLearnMoreLinkText: {
        id: "ai-opt-in.dialog.learn-more.link.text",
        defaultMessage: "Learn more about Atlassian Intelligence"
    },
    aiOptInDialogAdminBodyText: {
        id: "ai-opt-in.dialog.admin.body.text",
        defaultMessage: "Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    },
    aiOptInDialogAdminMaybeLaterButtonText: {
        id: "ai-opt-in.dialog.admin.maybe-later.button.text",
        defaultMessage: "Maybe later"
    },
    aiOptInDialogAdminGetStartedButtonText: {
        id: "ai-opt-in.dialog.admin.get-started.button.text",
        defaultMessage: "Get started"
    },
    aiOptInBannerBodyText: {
        id: "ai-opt-in.banner.body.text",
        defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it."
    },
    aiOptInBannerLearnMoreText: {
        id: "ai-opt-in.banner.learn.more.text",
        defaultMessage: "Learn more"
    },
    aiOptInAdminBannerBodyText: {
        id: "ai-opt-in.banner.admin.body.text",
        defaultMessage: "Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration."
    },
    aiOptInAdminOnlyVisible: {
        id: "ai-opt-in.admin.only.visible.text",
        defaultMessage: "This message is only visible to org admins."
    }
});
module.exports["messages"] = $55820977c77a8e8c$export$defe85febe8b728c;

});

parcelRegister("4LzvV", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");

const $3161983b4d5922a4$export$24c280970213bb11 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $7sObp.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko1qi0 _11q71lxv _16qs130s _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _kqswh2mm",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    });
});
const $3161983b4d5922a4$export$a0fab83bea8ccf2e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3161983b4d5922a4$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1cku _1e0c1txw _1biu1cku _1jpx1dfr _mezj1osq",
            __cmplp.className
        ])
    });
});
const $3161983b4d5922a4$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _2lx21bp4 _1wpz1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3161983b4d5922a4$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8nbxd",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3161983b4d5922a4$export$14966827497f4695 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c82smr",
            __cmplp.className
        ])
    });
});
const $3161983b4d5922a4$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _1bsb1osq _19pku2gc _1bahesu3",
            __cmplp.className
        ])
    });
});
module.exports["OptInBackgroundBorder"] = $3161983b4d5922a4$export$24c280970213bb11;
module.exports["OptInContainer"] = $3161983b4d5922a4$export$a0fab83bea8ccf2e;
module.exports["ImageWrapper"] = $3161983b4d5922a4$export$75f07c36086c2c81;
module.exports["ContentContainer"] = $3161983b4d5922a4$export$9d2b4227a95687cc;
module.exports["HeaderWrapper"] = $3161983b4d5922a4$export$960a49cc3d27a090;
module.exports["BodyWrapper"] = $3161983b4d5922a4$export$14966827497f4695;
module.exports["ButtonContainer"] = $3161983b4d5922a4$export$eddf54ea3db8d0f0;

});

parcelRegister("42MJM", function(module, exports) {
/* AIUpsell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cOrQJ = parcelRequire("cOrQJ");


var $inPa6 = parcelRequire("inPa6");


var $lHQAj = parcelRequire("lHQAj");


var $euL71 = parcelRequire("euL71");


var $cHKtk = parcelRequire("cHKtk");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20dc6939391e7f10$var$UpsellBackgroundBorder = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko1qi0 _1yt4v77o _11q7kwyp _16qs130s _1bsb1kdj _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $20dc6939391e7f10$var$UpsellContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20dc6939391e7f10$var$ImageWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1cku _4t3iys9h",
            __cmplp.className
        ])
    });
});
const $20dc6939391e7f10$var$ContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zbay22hw _155npxbi",
            __cmplp.className
        ])
    });
});
const $20dc6939391e7f10$export$38f23d3987aa9723 = ({ title: title, body: body, feature: feature, image: image, learnMoreLink: learnMoreLink, onRender: onRender })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showRequestUpgradeButton: showRequestUpgradeButton, showRequestUpgradeButtonAATest: showRequestUpgradeButtonAATest, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)(`${feature}UpsellScreen`);
    const learnMoreLinkMessageDescriptor = (0, $42omo.useMemo)(()=>{
        return showRequestUpgradeButton ? {
            id: 'change-edition.ai-upsell.learn-more.with-end-user-request-button',
            defaultMessage: 'Learn more',
            description: 'Learn more link label when end user request upgrade button is present'
        } : {
            id: 'change-edition.ai-upsell.learn-more',
            defaultMessage: learnMoreLink.message
        };
    }, [
        showRequestUpgradeButton,
        learnMoreLink.message
    ]);
    const bannerImage = colorMode === 'dark' ? image?.src.dark : image?.src.default;
    (0, $42omo.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    (0, $42omo.useEffect)(()=>{
        if (bannerImage) {
            const preloadImages = (paths)=>{
                paths.forEach((path)=>{
                    const img = new Image();
                    img.src = path;
                });
            };
            preloadImages([
                bannerImage
            ]);
        }
    }, [
        bannerImage
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiUpsellDialog',
                attributes: {
                    feature: feature
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        feature
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$UpsellBackgroundBorder, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$UpsellContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lHQAj.Card), {
        title: title,
        body: body,
        learnMoreLink: {
            ...learnMoreLink,
            messageDescriptor: learnMoreLinkMessageDescriptor,
            actionSubjectId: `${feature}LearnMore`
        },
        source: `${feature}UpsellScreen`,
        targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
        upgradeEditionActionSubjectId: `${feature}TryPremium`,
        isLoadingRequestUpgradeButton: loading,
        showRequestUpgradeButton: showRequestUpgradeButton,
        showRequestUpgradeButtonAATest: showRequestUpgradeButtonAATest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$ImageWrapper, {
        src: bannerImage
    })))));
};
module.exports["AIUpsell"] = $20dc6939391e7f10$export$38f23d3987aa9723;

});

parcelRegister("cOrQJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8z9j5 = parcelRequire("8z9j5");


var $60yhz = parcelRequire("60yhz");

/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $3ebd34920f1cc52c$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $42omo.useState)((0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        const observer = new (0, $60yhz.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $3ebd34920f1cc52c$export$2e2bcd8739ae039 = $3ebd34920f1cc52c$var$useThemeObserver;
module.exports["default"] = $3ebd34920f1cc52c$export$2e2bcd8739ae039;

});

parcelRegister("lHQAj", function(module, exports) {
/* Card.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("48ubT", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $w033M = parcelRequire("w033M");

const $cfdb58fabb92c022$export$f9f8a5cdb0c565ef = ()=>{
    const { data: data, error: error, loading: isAdminCheckLoading } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useIsSiteAdminUseIsSiteAdminQuery{isSiteAdmin}`);
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(data);
    return {
        isSiteAdmin: isSiteAdmin,
        isAdminCheckLoading: isAdminCheckLoading
    };
};
module.exports["useIsSiteAdmin"] = $cfdb58fabb92c022$export$f9f8a5cdb0c565ef;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cryCi = parcelRequire("cryCi");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    return ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("lbPWE", function(module, exports) {

var $3awkC = parcelRequire("3awkC");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");


var $jMyy4 = parcelRequire("jMyy4");


var $gKr8t = parcelRequire("gKr8t");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $gjUkr = parcelRequire("gjUkr");


var $inPa6 = parcelRequire("inPa6");

const $8cc93be0f89e75f1$export$cca3cdecfca1276f = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const skip = !isLoggedIn || !cloudId || edition !== (0, $euL71.ConfluenceEdition).FREE || !(0, $dh538.fg)('twcg-530_confluence_ai_in_editor_eot_gate');
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $3awkC.default), {
        variables: {
            cloudId: cloudId
        },
        skip: skip,
        fetchPolicy: 'cache-first',
        client: (0, $gKr8t.getAGGClient)(),
        onError: (error)=>{
            const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                product: (0, $gwZbZ.Product).CONFLUENCE,
                team: (0, $6o7wX.Team).GROWTH_LUNA,
                experimentMeta: {
                    experimentKey: 'twcg-530_confluence_ai_in_editor_eot'
                },
                errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
                errorMessage: error?.message,
                severity: (0, $gwZbZ.Severity).MEDIUM,
                source: 'useIsEligibleForAiInEditor',
                additionalAttributes: {
                    cloudId: cloudId
                }
            });
            createAnalyticsEvent(eventPayload).fire();
        }
    });
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const tenantContext = data?.tenantContexts?.[0];
    const entitlementInfo = tenantContext?.entitlementInfo;
    const entitlement = entitlementInfo?.entitlement;
    const experienceCapabilities = entitlement?.experienceCapabilities;
    const changeOfferingV2 = experienceCapabilities?.changeOfferingV2;
    const transactionAccount = entitlement?.transactionAccount;
    const hasCCPBillingSystem = data?.license?.billingSourceSystem === 'CCP';
    const canUpgradeToPremium = changeOfferingV2?.isAvailableToUser === true;
    const hasPaymentDetails = transactionAccount?.isBillToPresent === true;
    const experienceUrl = (0, $gjUkr.addAtlOriginToUrl)(changeOfferingV2?.experienceUrl || '');
    const isEligible = (0, $42omo.useMemo)(()=>{
        return isFreeEdition && isLoggedIn && Boolean(cloudId) && hasCCPBillingSystem && canUpgradeToPremium && !hasPaymentDetails;
    }, [
        isFreeEdition,
        isLoggedIn,
        cloudId,
        hasCCPBillingSystem,
        canUpgradeToPremium,
        hasPaymentDetails
    ]);
    return {
        isEligible: isEligible,
        edition: edition,
        canUpgrade: canUpgradeToPremium,
        loading: loading,
        error: error?.message || null,
        experienceUrl: experienceUrl
    };
};
module.exports["useIsEligibleForAiInEditor"] = $8cc93be0f89e75f1$export$cca3cdecfca1276f;

});

parcelRegister("3awkC", function(module, exports) {
/**
 * @generated SignedSource<<ecf601b77006ef5bb8b4a6882e2defae>>
 * @relayHash e20833603f55baf33c05d488de093039
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 051a217822c4ed932215d5dd2b311bc3f2cbc59380ffd0c24208e2de834610ee
const $d5e8f70541d1b89c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "concreteType": "License",
        "kind": "LinkedField",
        "name": "license",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "billingSourceSystem"
            }
        ]
    }, v2 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsEligibleForAiInEditorQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsEligibleForAiInEditorQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "e20833603f55baf33c05d488de093039",
            "id": "051a217822c4ed932215d5dd2b311bc3f2cbc59380ffd0c24208e2de834610ee",
            "metadata": {},
            "name": "useIsEligibleForAiInEditorQuery",
            "operationKind": "query",
            "text": "query useIsEligibleForAiInEditorQuery($cloudId:ID!){license{billingSourceSystem},tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,entitlement{__typename,transactionAccount{__typename,isBillToPresent,...on Node{__isNode:__typename,id}},experienceCapabilities{__typename,changeOfferingV2(offeringName:\"Premium\"){__typename,isAvailableToUser,experienceUrl}},id}}}}"
        }
    };
}();
$d5e8f70541d1b89c$var$node.hash = "0d75dc71c4b33da642ee318f10fa7971";
var $d5e8f70541d1b89c$export$2e2bcd8739ae039 = $d5e8f70541d1b89c$var$node;
module.exports["default"] = $d5e8f70541d1b89c$export$2e2bcd8739ae039;

});

parcelRegister("8hmrm", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $gvWCD = parcelRequire("gvWCD");


var $3HIy9 = parcelRequire("3HIy9");


var $39G0n = parcelRequire("39G0n");

const $31b517e9b4290477$export$8c06ae8e7f403dea = ({ product: product, team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, additionalAttributes: additionalAttributes = {} }, isActiveExperiment = true)=>{
    (0, $39G0n.validateExperimentName)(experimentMeta.experimentKey);
    const eventPayload = (0, $gvWCD.createEventPayload)({
        team: team,
        experimentMeta: experimentMeta,
        errorType: errorType,
        errorMessage: errorMessage,
        source: source,
        severity: severity,
        isActiveExperiment: isActiveExperiment,
        additionalAttributes: additionalAttributes,
        product: product
    });
    switch(product){
        case (0, $gwZbZ.Product).ADMIN_HUB:
            return {
                data: eventPayload
            };
        case (0, $gwZbZ.Product).JIRA:
            return {
                data: eventPayload,
                productSpecificRules: {
                    jira: {
                        createAnalyticsEventPayload: (0, $3HIy9.convertEventPayloadForJiraCreateAnalyticsEvent)({
                            data: eventPayload
                        }),
                        fireEventPayload: (0, $3HIy9.convertEventAttributesForJiraFireEvent)({
                            data: eventPayload
                        })
                    }
                }
            };
        case (0, $gwZbZ.Product).CONFLUENCE:
            return {
                type: (0, $gwZbZ.CONFLUENCE_OPERATIONAL_EVENT_TYPE),
                data: eventPayload
            };
        default:
            throw new Error(`Unsupported product: ${product}`);
    }
};
module.exports["createProductSpecificAnalyticsIntegrationPayload"] = $31b517e9b4290477$export$8c06ae8e7f403dea;

});

parcelRegister("gwZbZ", function(module, exports) {
const $64e202edaa8eb03b$export$ec4825154d679381 = 'error';
const $64e202edaa8eb03b$export$a924d1f92c0e2e78 = 'growth-experiment';
const $64e202edaa8eb03b$export$e5025d93161b0712 = 'sendOperationalEvent';
const $64e202edaa8eb03b$export$5c3e8a6b8e7ba45b = 'growth-error-analytics';
var $64e202edaa8eb03b$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["JIRA"] = "jira";
    Product["CONFLUENCE"] = "confluence";
    Product["ADMIN_HUB"] = "admin-hub";
    return Product;
}({});
var $64e202edaa8eb03b$export$dba1278861bf0dc1 = /*#__PURE__*/ function(ErrorType) {
    ErrorType["GRAPHQL"] = "graphql";
    ErrorType["REST"] = "rest";
    ErrorType["ERROR_BOUNDARY"] = "error-boundary";
    ErrorType["GENERIC"] = "generic";
    return ErrorType;
}({});
var $64e202edaa8eb03b$export$918a9776c0a3cf27 = /*#__PURE__*/ function(Severity) {
    Severity["LOW"] = "low";
    Severity["MEDIUM"] = "medium";
    Severity["HIGH"] = "high";
    return Severity;
}({});
const $64e202edaa8eb03b$export$a61493d7ab73936 = 'growth';
module.exports["ERROR_ACTION"] = $64e202edaa8eb03b$export$ec4825154d679381;
module.exports["ERROR_ACTION_SUBJECT"] = $64e202edaa8eb03b$export$a924d1f92c0e2e78;
module.exports["CONFLUENCE_OPERATIONAL_EVENT_TYPE"] = $64e202edaa8eb03b$export$e5025d93161b0712;
module.exports["Product"] = $64e202edaa8eb03b$export$264ad599d7cef668;
module.exports["ErrorType"] = $64e202edaa8eb03b$export$dba1278861bf0dc1;
module.exports["Severity"] = $64e202edaa8eb03b$export$918a9776c0a3cf27;
module.exports["EVENT_TAG_GROWTH"] = $64e202edaa8eb03b$export$a61493d7ab73936;

});

parcelRegister("gvWCD", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");

const $d2a9f5f63821177b$export$f2a94361d01a626c = ({ team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, isActiveExperiment: isActiveExperiment, product: product, additionalAttributes: additionalAttributes = {} })=>{
    const actionSubjectId = `${(0, $gwZbZ.ERROR_ACTION_SUBJECT)}-${experimentMeta.experimentKey}-${errorType}`;
    return {
        action: (0, $gwZbZ.ERROR_ACTION),
        actionSubject: (0, $gwZbZ.ERROR_ACTION_SUBJECT),
        actionSubjectId: actionSubjectId,
        source: experimentMeta.experimentKey,
        attributes: {
            errorType: errorType,
            team: team,
            experimentKey: experimentMeta.experimentKey,
            cohort: experimentMeta?.cohort,
            severity: severity,
            errorMessage: errorMessage,
            isActiveExperiment: isActiveExperiment,
            product: product,
            detailedSource: source,
            ...additionalAttributes
        },
        tags: [
            (0, $gwZbZ.EVENT_TAG_GROWTH)
        ]
    };
};
module.exports["createEventPayload"] = $d2a9f5f63821177b$export$f2a94361d01a626c;

});

parcelRegister("3HIy9", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $8hmrm = parcelRequire("8hmrm");

const $de70a0c4deb210a2$export$d5090ca98c07c12d = (payload)=>{
    const { data: data } = payload;
    return {
        action: data.action,
        actionSubject: data.actionSubject,
        source: data.source,
        actionSubjectId: data.actionSubjectId,
        tags: data.tags
    };
};
const $de70a0c4deb210a2$export$2144cc21b87dd554 = (payload)=>{
    const { data: data } = payload;
    const eventName = `${data.actionSubject} ${data.action}`;
    return {
        eventName: eventName,
        attributes: data.attributes
    };
};
const $de70a0c4deb210a2$export$f106561f47f05126 = (event)=>{
    const { payload: payload } = event;
    // Extract attributes from the event payload and create a formatted payload
    // specifically for Jira product integration
    const analyticsEventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
        product: (0, $gwZbZ.Product).JIRA,
        team: payload.attributes.team,
        experimentMeta: {
            experimentKey: payload.attributes.experimentKey,
            cohort: payload.attributes.cohort
        },
        errorType: payload.attributes.errorType,
        errorMessage: payload.attributes.errorMessage,
        source: payload.attributes.source,
        severity: payload.attributes.severity
    });
    // Return both payload formats needed for complete Jira analytics integration:
    // 1. createEventPayload: Used with Jira's createAnalyticsEvent
    // 2. fireEventPayload: Used with Jira's fireEvent
    return {
        createEventPayload: $de70a0c4deb210a2$export$d5090ca98c07c12d(analyticsEventPayload),
        fireEventPayload: $de70a0c4deb210a2$export$2144cc21b87dd554(analyticsEventPayload)
    };
};
module.exports["convertEventPayloadForJiraCreateAnalyticsEvent"] = $de70a0c4deb210a2$export$d5090ca98c07c12d;
module.exports["convertEventAttributesForJiraFireEvent"] = $de70a0c4deb210a2$export$2144cc21b87dd554;

});

parcelRegister("39G0n", function(module, exports) {
/**
 * Validates that an experiment name doesn't contain spaces.
 * Experiment names with spaces can cause issues in dashboards and analytics tracking.
 *
 * @param experimentName The experiment name to validate
 * @throws Error if experiment name contains spaces
 */ const $34ecc222054f7431$export$7fa6b5da621cbeb2 = (experimentName)=>{
    if (experimentName.includes(' ')) throw new Error(`Experiment name "${experimentName}" contains spaces. ` + 'Experiment names must not contain spaces to ensure proper tracking in dashboards. ' + 'Use camelCase or hyphens instead (e.g., "myExperiment" or "my-experiment").');
};
module.exports["validateExperimentName"] = $34ecc222054f7431$export$7fa6b5da621cbeb2;

});

parcelRegister("6o7wX", function(module, exports) {
/**
 * Enumeration of authorized teams for growth error analytics
 *
 * IMPORTANT: If your team wants to use growth-commons-error-analytics:
 * 1. Add your team name following the convention 'TEAM_NAME = team-name'
 * 2. Create a PR and request review from the #growth-luna channel
 * 3. Provide context about your team and use case in the PR description
 *
 * The growth-luna team reviews all additions to maintain analytics quality
 * and ensure proper integration with dashboards.
 *
 * @example
 * // Adding a new team:
 * // GROWTH_NEW_TEAM = 'growth-new-team', // requires approval
 */ var $7d6dde24ede24951$export$3e5d0af8e738b082 = /*#__PURE__*/ function(Team) {
    Team["GROWTH_LUNA"] = "growth-luna";
    return Team;
}({});
module.exports["Team"] = $7d6dde24ede24951$export$3e5d0af8e738b082;

});

parcelRegister("gjUkr", function(module, exports) {

var $6Co6F = parcelRequire("6Co6F");

const $10cc0a048087d5da$export$27aa48a6b5521530 = (url)=>{
    if (!url) return '';
    const origin = new (0, $6Co6F.default)({
        product: 'confluence'
    });
    return origin.addToUrl(url);
};
module.exports["addAtlOriginToUrl"] = $10cc0a048087d5da$export$27aa48a6b5521530;

});

parcelRegister("bdMSP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6mKj3 = parcelRequire("6mKj3");

const $81f1ccd13ae0eba6$export$c2005d7fb3853502 = ({ touchpoint: touchpoint, isEligible: isEligible, extraAnalyticsAttributes: extraAnalyticsAttributes = {} })=>{
    const memoizedAnalyticsAttributes = (0, $42omo.useMemo)(()=>extraAnalyticsAttributes, [
        extraAnalyticsAttributes
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasFiredEventsRef = (0, $42omo.useRef)({
        aa: new Set(),
        ab: new Set()
    });
    const experimentValues = (0, $42omo.useMemo)(()=>{
        if (!isEligible) return {
            isABTreatment: false
        };
        if ((0, $6mKj3.expVal)('twcg-530_confluence_ai_in_editor_eot', 'cohort', 'not-enrolled') !== 'not-enrolled') return {
            isABTreatment: (0, $6mKj3.expVal)('twcg-530_confluence_ai_in_editor_eot', 'cohort', 'not-enrolled') === 'treatment'
        };
        return {
            isABTreatment: false
        };
    }, [
        isEligible
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isEligible) return;
        if (!hasFiredEventsRef.current.aa.has(touchpoint) && (0, $6mKj3.expVal)('twcg-530_confluence_ai_in_editor_eot_aa', 'cohort', 'not-enrolled') !== 'not-enrolled') {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'exposed',
                    actionSubject: 'experiment',
                    actionSubjectId: `twcg-530_confluence_ai_in_editor_eot_aa-exposed`,
                    attributes: {
                        cohort: (0, $6mKj3.expVal)('twcg-530_confluence_ai_in_editor_eot_aa', 'cohort', 'not-enrolled'),
                        touchpoint: touchpoint,
                        ...memoizedAnalyticsAttributes
                    },
                    source: 'twcg-530_confluence_ai_in_editor_eot_aa'
                }
            }).fire();
            hasFiredEventsRef.current.aa.add(touchpoint);
        }
        if (!hasFiredEventsRef.current.ab.has(touchpoint) && (0, $6mKj3.expVal)('twcg-530_confluence_ai_in_editor_eot', 'cohort', 'not-enrolled') !== 'not-enrolled') {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'exposed',
                    actionSubject: 'experiment',
                    actionSubjectId: `twcg-530_confluence_ai_in_editor_eot-exposed`,
                    attributes: {
                        cohort: (0, $6mKj3.expVal)('twcg-530_confluence_ai_in_editor_eot', 'cohort', 'not-enrolled'),
                        touchpoint: touchpoint,
                        ...memoizedAnalyticsAttributes
                    },
                    source: 'twcg-530_confluence_ai_in_editor_eot'
                }
            }).fire();
            hasFiredEventsRef.current.ab.add(touchpoint);
        }
    }, [
        isEligible,
        touchpoint,
        memoizedAnalyticsAttributes,
        createAnalyticsEvent
    ]);
    return experimentValues;
};
module.exports["useEnrolledAIInEditorModalsExperiment"] = $81f1ccd13ae0eba6$export$c2005d7fb3853502;

});

parcelRegister("3GzdC", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c547a909ee5be0f8$export$91166c510522d36c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "jS4Zm",
    name: "ConfluenceAiInEditorModalWithErrorBoundaryLoadable",
    loader: async ()=>(await (parcelRequire("8VFEI"))).ConfluenceAiInEditorModalWithErrorBoundary
});
module.exports["ConfluenceAiInEditorModalWithErrorBoundaryLoadable"] = $c547a909ee5be0f8$export$91166c510522d36c;

});

parcelRegister("8VFEI", function(module, exports) {

let $6803f58f27c43f09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6803f58f27c43f09$var$load("kiGNy"),
    $6803f58f27c43f09$var$load("6wr18"),
    $6803f58f27c43f09$var$load("iAqyW"),
    $6803f58f27c43f09$var$load("ffEVr"),
    $6803f58f27c43f09$var$load("hhss7"),
    $6803f58f27c43f09$var$load("dHQ6a")
]).then(()=>parcelRequire('Mz1Cd'));

});

parcelRegister("lwir9", function(module, exports) {
module.exports = new URL("editor-ai-opt-in-banner.523b2454.svg", import.meta.url).toString();

});

parcelRegister("202oG", function(module, exports) {

var $h9yJL = parcelRequire("h9yJL");

function $2cfd9ea7d82f1add$export$dbad71934afee167(node, headingIds) {
    if (!node?.content?.length) return;
    // We are not use node.textContent here, because we would like to handle cases where
    // headings only contain inline blocks like emoji, status and date.
    const nodeContent = node.content.reduce((acc, currentNode)=>acc.concat($2cfd9ea7d82f1add$var$getText(currentNode) || ''), '').trim().replace(/\s/g, '-');
    if (!nodeContent) return;
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(nodeContent, headingIds);
}
const $2cfd9ea7d82f1add$var$getText = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : ''}]`;
};
function $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter = 0) {
    if (counter === 0 && !headingIds.has(baseId)) {
        headingIds.add(baseId);
        return baseId;
    } else if (counter !== 0) {
        const headingId = `${baseId}.${counter}`;
        if (!headingIds.has(headingId)) {
            headingIds.add(headingId);
            return headingId;
        }
    }
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter + 1);
}
const $2cfd9ea7d82f1add$var$HEADINGS = new Set([
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6'
]);
function* $2cfd9ea7d82f1add$var$getHeadingIds() {
    const editorElement = document.getElementById('ak-editor-textarea');
    const children = editorElement?.getElementsByTagName('*') ?? [];
    const headingIds = new Set();
    const editorTransformer = new (0, $h9yJL.JSONTransformer)();
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($2cfd9ea7d82f1add$var$HEADINGS.has(child.tagName)) {
            const pmNode = child.pmViewDesc?.node;
            if (!pmNode) continue;
            // Copied from TOC
            const adf = editorTransformer.encode(pmNode);
            let adfObject = adf;
            if (typeof adf === 'string') try {
                adfObject = JSON.parse(adf);
            } catch (err) {
            // Swallow the error as ADF format error handling is expected to be done earlier,
            // in the component that renders the entire content
            }
            const headingId = $2cfd9ea7d82f1add$export$dbad71934afee167(adfObject, headingIds);
            if (!headingId) continue;
            yield [
                headingId,
                child,
                pmNode
            ];
        }
    }
}
const $2cfd9ea7d82f1add$export$817005c72dc2688 = ()=>{
    const headingIdToElement = new Map();
    for (const [headingId, child, _] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        headingIdToElement.set(headingId, child);
        // A bit inefficient, but there's sometimes a discrepancy between the hashed ID and the generated ID. The least impactful solution is to just add both.
        headingIdToElement.set(encodeURIComponent(headingId), child);
    }
    return headingIdToElement;
};
const $2cfd9ea7d82f1add$export$e2a78e613c648859 = (node)=>{
    for (const [headingId, _, pmNode] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        if (node === pmNode) return headingId;
    }
    return undefined;
};
module.exports["getHeadingId"] = $2cfd9ea7d82f1add$export$dbad71934afee167;
module.exports["getHeadingIdsToElements"] = $2cfd9ea7d82f1add$export$817005c72dc2688;
module.exports["getHeadingIdForNode"] = $2cfd9ea7d82f1add$export$e2a78e613c648859;

});

parcelRegister("cHANb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jOIil = parcelRequire("jOIil");

const $9ab2866fb2a1e6e3$export$ff041132f32feaf3 = (enabled, handleNewTitle)=>{
    (0, $42omo.useEffect)(()=>{
        if (!enabled) return;
        const { unsubscribe: unsubscribe } = (0, $jOIil.eventHub).subscribe({
            event: 'replace title in confluence',
            callback: (data)=>{
                handleNewTitle(data.title);
            }
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        handleNewTitle,
        enabled
    ]);
};
module.exports["useEditorAIReplacingTitle"] = $9ab2866fb2a1e6e3$export$ff041132f32feaf3;

});

parcelRegister("jOIil", function(module, exports) {
class $3057f4cb0fd3db76$var$EventHub {
    /**
   * Subscribes to a specific Editor AI event, registering a callback function that will be invoked whenever the event is published.
   *
   * @param {object} params - The subscription parameters.
   * @param {T} params.event - The name of the event to subscribe to.
   * @param {(data: EventDataMap[T]) => void} params.callback - The callback function to invoke when the event is published.
   * It receives the event data as its parameter.
   * @returns {object} An object containing the `unsubscribe` method to remove the subscription when it's no longer needed.
   *
   * @example
   * // Subscribing to an event
   * const subscription = eventHub.subscribe({
   *   event: 'start prompt',
   *   callback: (data) => {
   *     console.log('Received start prompt event:', data);
   *   },
   * });
   *
   * // Later, to unsubscribe
   * subscription.unsubscribe();
   */ subscribe({ event: event, callback: callback }) {
        const callbacks = this.subscribers.get(event) || [];
        this.subscribers.set(event, [
            ...callbacks,
            callback
        ]);
        return {
            unsubscribe: ()=>{
                const callbacks = this.subscribers.get(event)?.filter((sub)=>sub !== callback) || [];
                if (callbacks.length > 0) this.subscribers.set(event, callbacks);
                else this.subscribers.delete(event);
            }
        };
    }
    /**
   * Publishes an Editor AI event to a target editor. (This will usually be an event like 'start prompt').
   *
   * @param {object} params - The event parameters.
   * @param {T} params.event - The name of the event to publish.
   * @param {ToEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
   * @returns {void}
   *
   * @example
   * // Publishing an event to the editor
   * eventHub.publishToEditor({
   *   event: 'start prompt',
   *   data: {
   *     prompt: 'issue reformatter',
   *     targetEditorId,
   *     analyticSourceId: 'jiraIssueReformatterExternalButton',
   *   },
   * });
   */ publishToEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    /**
   * Publishes an event originating from the editor, invoking all registered subscribers for that event.
   *
   * @param {object} params - The event parameters.
   * @param {T} params.event - The name of the event to publish.
   * @param {FromEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
   * @returns {void}
   *
   * @example
   * // Publishing an event from the editor
   * eventHub.publishFromEditor({
   *   event: 'replace title in confluence',
   *   data: {
   *     analyticSourceId: 'confluenceTitleToolbar',
   *     sourceEditorId,
   *     title: textContent,
   *   },
   * });
   */ publishFromEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.subscribers = new Map();
        this.subscribers = new Map();
    }
}
const $3057f4cb0fd3db76$export$e17a52e5da72c4cb = new $3057f4cb0fd3db76$var$EventHub();
module.exports["eventHub"] = $3057f4cb0fd3db76$export$e17a52e5da72c4cb;

});

parcelRegister("3plmx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $btw9C = parcelRequire("btw9C");


var $6mKj3 = parcelRequire("6mKj3");


var $kLzei = parcelRequire("kLzei");


var $bQm3c = parcelRequire("bQm3c");


var $lhTEt = parcelRequire("lhTEt");


var $i6Ps3 = parcelRequire("i6Ps3");


var $6M71K = parcelRequire("6M71K");

const $78db0f388b3bc59b$var$useInitialState = ()=>{
    return (0, $42omo.useMemo)(()=>{
        const ssrProvidersData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
        const ssrData = ssrProvidersData.editorCardProvider;
        if (!ssrData) return undefined;
        return Object.entries(ssrData).reduce((acc, [url, details])=>{
            acc[url] = {
                status: (0, $btw9C.getStatus)(details),
                details: details,
                metadataStatus: 'resolved'
            };
            return acc;
        }, {});
    }, []);
};
const $78db0f388b3bc59b$var$useStoreOptions = ()=>{
    const isPageSSR = (0, $i6Ps3.isPageSSRd)();
    const initialState = $78db0f388b3bc59b$var$useInitialState();
    const oldInitialState = window['__SSR_SMARTLINKS__'];
    const oldStoreOptions = (0, $lhTEt.useStoreOptions)(oldInitialState, isPageSSR);
    return (0, $42omo.useMemo)(()=>{
        if (initialState && (0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'isEnabled', false)) return {
            initialState: initialState
        };
        // Should be removed when the platform_editor_smart_card_otp experiment is rolled out
        return oldStoreOptions.storeOptions;
    }, [
        oldStoreOptions,
        initialState
    ]);
};
function $78db0f388b3bc59b$export$eaed11d22c122636(WrappedComponent) {
    return (props)=>{
        const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
        const storeOptions = $78db0f388b3bc59b$var$useStoreOptions();
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
            ...(0, $kLzei.getSmartCardRenderers)(),
            storeOptions: storeOptions,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }, content));
    };
}
module.exports["withSmartCardProviderContext"] = $78db0f388b3bc59b$export$eaed11d22c122636;

});

parcelRegister("3IZob", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $10e4e925e54c9160$var$DocChangeContext = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribeDocChange: ()=>{},
    unsubscribeDocChange: ()=>{}
});
const $10e4e925e54c9160$var$DocChangeContextProvider = ({ children: children })=>{
    const subscriptions = (0, $42omo.useRef)(new Set());
    const handleDocChange = (0, $42omo.useCallback)((editorView)=>{
        subscriptions.current.forEach((callback)=>{
            callback(editorView);
        });
    }, []);
    const subscribeDocChange = (0, $42omo.useCallback)((callback)=>{
        subscriptions.current.add(callback);
    }, []);
    const unsubscribeDocChange = (0, $42omo.useCallback)((callback)=>{
        subscriptions.current.delete(callback);
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            subscribeDocChange: subscribeDocChange,
            unsubscribeDocChange: unsubscribeDocChange
        }), [
        subscribeDocChange,
        unsubscribeDocChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10e4e925e54c9160$var$DocChangeContext.Provider, {
        value: value
    }, children({
        handleDocChange: handleDocChange
    }));
};
const $10e4e925e54c9160$export$82deeccbd0ef6b25 = ()=>(0, $42omo.useContext)($10e4e925e54c9160$var$DocChangeContext);
function $10e4e925e54c9160$export$9747c97496f7b432(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10e4e925e54c9160$var$DocChangeContextProvider, null, ({ handleDocChange: handleDocChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                ...props,
                handleDocChange: handleDocChange
            }));
}
module.exports["useDocChangeContext"] = $10e4e925e54c9160$export$82deeccbd0ef6b25;
module.exports["withDocChangeContext"] = $10e4e925e54c9160$export$9747c97496f7b432;

});

parcelRegister("awIbt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5AtW0 = parcelRequire("5AtW0");


var $auTg8 = parcelRequire("auTg8");

function $44be53440eeaa295$export$7deec7951f922f64(WrappedComponent) {
    function withEditorActions(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auTg8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5AtW0.default), {
            render: (editorActions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                    editorActions: editorActions,
                    ...props
                })
        }));
    }
    return withEditorActions;
}
module.exports["withEditorActions"] = $44be53440eeaa295$export$7deec7951f922f64;

});

parcelRegister("5AtW0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jZrBc = parcelRequire("jZrBc");

class $8777d177426e798b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8777d177426e798b$var$WithEditorActionsNew, this.props);
    }
    constructor(props){
        super(props);
    }
}
function $8777d177426e798b$var$WithEditorActionsNew(props) {
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $jZrBc.EditorContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8777d177426e798b$var$WithEditorActionsInner, {
        render: render,
        editorActions: context?.editorActions
    });
}
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $8777d177426e798b$var$WithEditorActionsInner extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        this.props.editorActions._privateSubscribe(()=>this.forceUpdate());
    }
    componentWillUnmount() {
        this.props.editorActions._privateUnsubscribe(()=>this.forceUpdate());
    }
    render() {
        return this.props.render(this.props.editorActions);
    }
}
module.exports["default"] = $8777d177426e798b$export$2e2bcd8739ae039;

});

parcelRegister("dWbBL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $8rj8Z = parcelRequire("8rj8Z");


var $5iPWm = parcelRequire("5iPWm");


var $3jwuS = parcelRequire("3jwuS");


var $i9VoI = parcelRequire("i9VoI");


var $ki0na = parcelRequire("ki0na");

const $bc4a316d21499c5a$var$renderContextPanelContentCreationPanel = (0, $2XqLN.default)(({ cancelDebouncedSaveDraft: // TODO: canPublish is used for isPanelDisabled, but and it includes a permission check in
// addition to collab init check which needs to be added for NativeCollab
// canPublish
cancelDebouncedSaveDraft, contentType: contentType, collabEditInitialized: collabEditInitialized, beforeUpdateRequest: beforeUpdateRequest, recoverAndRefreshEditorContent: recoverAndRefreshEditorContent, hideSpinner: hideSpinner, hasUserAddedContent: hasUserAddedContent, isUnpublishedDraft: isUnpublishedDraft, isContentCreationPanelOpen: isContentCreationPanelOpen, onClickCloseContentCreationPanel: onClickCloseContentCreationPanel, renderPanel: renderPanel, title: title, templateAllowList: templateAllowList, isImportDisabled: isImportDisabled, isAlwaysDiscardChanges: isAlwaysDiscardChanges, isSpacePickerDisabled: isSpacePickerDisabled, isLivePage: isLivePage })=>{
    const _renderPanel = renderPanel && (isUnpublishedDraft || isLivePage) && contentType === 'page';
    if (_renderPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5iPWm.EditorContextPanelContentCreationPanel), {
        hasUserAddedContent: hasUserAddedContent,
        isPanelDisabled: !collabEditInitialized,
        title: title,
        onContentUpdated: recoverAndRefreshEditorContent,
        beforeUpdateRequest: beforeUpdateRequest,
        beforeTemplateSelect: cancelDebouncedSaveDraft,
        isContentCreationPanelShown: isContentCreationPanelOpen,
        onClickCloseContentCreationPanel: onClickCloseContentCreationPanel,
        onError: hideSpinner,
        templateAllowList: templateAllowList,
        isImportDisabled: isImportDisabled,
        isAlwaysDiscardChanges: isAlwaysDiscardChanges,
        isSpacePickerDisabled: isSpacePickerDisabled
    });
    return null;
});
const $bc4a316d21499c5a$export$4b19e5011403af51 = ({ children: children, cancelDebouncedSaveDraft: cancelDebouncedSaveDraft, collabEditInitialized: collabEditInitialized, contentId: contentId, contentType: contentType, draftShareId: draftShareId, editorActions: editorActions, hideSpinner: hideSpinner, isUnpublishedDraft: isUnpublishedDraft, renderPanel: renderPanel, showSpinner: showSpinner, title: title, isEmbeddedEditor: isEmbeddedEditor, templateAllowList: templateAllowList, isSpacePickerDisabled: isSpacePickerDisabled })=>{
    const { beforeUpdateRequest: beforeUpdateRequest, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, onClickCloseContentCreationPanel: onClickCloseContentCreationPanel, postUpdateRequest: postUpdateRequest, hasUserAddedContent: hasUserAddedContent, isContentCreationPanelOpen: isContentCreationPanelOpen, onUpdatedWithTemplateSubscriptionEvent: onUpdatedWithTemplateSubscriptionEvent } = (0, $ki0na.useEditorContextPanel)({
        cancelDebouncedSaveDraft: cancelDebouncedSaveDraft,
        contentId: contentId,
        draftShareId: draftShareId,
        editorActions: editorActions,
        hideSpinner: hideSpinner,
        showSpinner: showSpinner,
        isUnpublishedDraft: isUnpublishedDraft,
        isEmbeddedEditor: isEmbeddedEditor
    });
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const pubSubResourceType = contentType || 'page';
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'EditorContextPanelPageUpdatedWithTemplateSubscription',
        contentId: contentId,
        delta: 'contentUpdatedWithTemplate',
        contentType: pubSubResourceType,
        onDataReceived: onUpdatedWithTemplateSubscriptionEvent
    });
    const recoverAndRefreshEditorContent = (0, $42omo.useCallback)(async ()=>{
        await (0, $8rj8Z.refetchEditorContent)(contentId);
        postUpdateRequest();
    }, [
        contentId,
        postUpdateRequest
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children({
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        beforeUpdateRequest: beforeUpdateRequest,
        postUpdateRequest: postUpdateRequest
    }), $bc4a316d21499c5a$var$renderContextPanelContentCreationPanel({
        cancelDebouncedSaveDraft: // canPublish,
        cancelDebouncedSaveDraft,
        collabEditInitialized: collabEditInitialized,
        contentType: contentType,
        beforeUpdateRequest: beforeUpdateRequest,
        recoverAndRefreshEditorContent: recoverAndRefreshEditorContent,
        hasUserAddedContent: hasUserAddedContent,
        isUnpublishedDraft: isUnpublishedDraft,
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        onClickCloseContentCreationPanel: onClickCloseContentCreationPanel,
        hideSpinner: hideSpinner,
        renderPanel: renderPanel,
        title: title,
        templateAllowList: templateAllowList,
        isImportDisabled: isEmbeddedEditor,
        isAlwaysDiscardChanges: isEmbeddedEditor,
        isSpacePickerDisabled: isSpacePickerDisabled,
        isLivePage: isLivePage
    }));
};
module.exports["EditorContextContentCreationPanelWrapper"] = $bc4a316d21499c5a$export$4b19e5011403af51;

});

parcelRegister("8rj8Z", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $l1kdf = parcelRequire("l1kdf");

const $87f902552c64bfd1$export$afadd31735d9bb64 = async (contentId)=>{
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        return await (0, $hp2SH.getApolloClient)().query({
            query: (0, $l1kdf.NativeCollabQuery),
            context: {
                single: true
            },
            fetchPolicy: 'network-only',
            variables: {
                contentId: contentId,
                status: [
                    'draft',
                    'current'
                ]
            }
        });
    } catch (error) {
    // NOTE: We intentionally swallow any possible error here as this query is only aimed
    // populate the cache with just published content. Should any error occur here after
    // successful publishing the page, the Apollo cache for the query will be invalidated
    // anyway and View Page will fetch the page and handle possible errors.
    }
};
module.exports["refetchEditorContent"] = $87f902552c64bfd1$export$afadd31735d9bb64;

});

parcelRegister("l1kdf", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $c2e596865d8e6fea$export$79b924d780de6f0d = (0, $eSUdr.default)`query NativeCollabQuery($contentId:ID$draftShareId:String$status:[String]){content(id:$contentId draftShareId:$draftShareId status:$status){nodes{id type status version{number ncsStepVersion by{type ...on KnownUser{accountId}}}history{createdBy{displayName}createdDate}space{id name homepageId}labels{nodes{id name}}subType}}}`;
module.exports["NativeCollabQuery"] = $c2e596865d8e6fea$export$79b924d780de6f0d;

});

parcelRegister("5iPWm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $aJPUt = parcelRequire("aJPUt");


var $7d2Nc = parcelRequire("7d2Nc");


var $ep3mz = parcelRequire("ep3mz");


var $9qW65 = parcelRequire("9qW65");


var $btbPP = parcelRequire("btbPP");


var $hZkjK = parcelRequire("hZkjK");


var $59T2o = parcelRequire("59T2o");


var $QcCxc = parcelRequire("QcCxc");

const $2f3d6b030a611bed$export$aaff6b6704dfdcef = /*#__PURE__*/ (0, $42omo.memo)(({ hasUserAddedContent: hasUserAddedContent, isPanelDisabled: isPanelDisabled, title: title, onContentUpdated: onContentUpdated, beforeTemplateSelect: beforeTemplateSelect, isContentCreationPanelShown: isContentCreationPanelShown, onClickCloseContentCreationPanel: onClickCloseContentCreationPanel, beforeUpdateRequest: beforeUpdateRequest, onError: onError, templateAllowList: templateAllowList, isImportDisabled: isImportDisabled, isAlwaysDiscardChanges: isAlwaysDiscardChanges, isSpacePickerDisabled: isSpacePickerDisabled })=>{
    const [currentSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    (0, $btbPP.usePanelOpenAnalyticsEvents)(isContentCreationPanelShown, contentId);
    const { abortTemplatePanelLoadExperiences: abortTemplatePanelLoadExperiences } = (0, $hZkjK.useLoadTemplatePanelExperienceTracker)();
    const subExperiences = (0, $42omo.useMemo)(()=>(0, $QcCxc.filterSubExperiences)(isSpacePickerDisabled), [
        isSpacePickerDisabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isContentCreationPanelShown) abortTemplatePanelLoadExperiences('closing template panel');
    }, [
        isContentCreationPanelShown,
        abortTemplatePanelLoadExperiences
    ]);
    if (isContentCreationPanelShown && currentSpaceKey && contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_EXPERIENCE),
        collect: (0, $QcCxc.collectLoadPanelExperiences)(subExperiences),
        timeout: (0, $aJPUt.ExperienceTimeout).IN_EDITOR_TEMPLATE_PANEL_LOAD
    }), subExperiences.map((name)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: name,
            key: name
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $9qW65.IN_EDITOR_TEMPLATES_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $59T2o.ContentCreationPanelTabs), {
        currentSpaceKey: currentSpaceKey,
        contentId: contentId,
        title: title,
        onContentUpdated: onContentUpdated,
        isPanelDisabled: isPanelDisabled,
        beforeTemplateSelect: beforeTemplateSelect,
        hasUserAddedContent: hasUserAddedContent,
        beforeUpdateRequest: beforeUpdateRequest,
        onError: onError,
        closeConfigPanel: onClickCloseContentCreationPanel,
        abortTemplatePanelLoadExperiences: abortTemplatePanelLoadExperiences,
        templateAllowList: templateAllowList,
        isImportDisabled: isImportDisabled,
        isAlwaysDiscardChanges: isAlwaysDiscardChanges,
        isSpacePickerDisabled: isSpacePickerDisabled
    }));
    return null;
});
module.exports["EditorContextPanelContentCreationPanel"] = $2f3d6b030a611bed$export$aaff6b6704dfdcef;

});

parcelRegister("9qW65", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $42c7f09509682fdc$export$de9c4920d9307bee = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.IN_EDITOR_TEMPLATES_SEGMENT_KEY)
});
module.exports["IN_EDITOR_TEMPLATES_METRIC"] = $42c7f09509682fdc$export$de9c4920d9307bee;

});

parcelRegister("btbPP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $f0ac822d8f33c68a$export$55a4b363793a10d0 = (isContentCreationPanelShown, contentId)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasScreenEventFired = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!hasScreenEventFired.current && isContentCreationPanelShown) {
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'templateDrawer',
                    objectId: contentId
                }
            }).fire();
            hasScreenEventFired.current = true;
        }
        // dont fire a close event until its been opened before
        if (hasScreenEventFired.current) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'templateDrawer',
                action: isContentCreationPanelShown ? 'opened' : 'closed',
                actionSubject: 'templateDrawer',
                objectId: contentId,
                actionSubjectId: isContentCreationPanelShown ? 'templateDrawerOpened' : 'templateDrawerClosed'
            }
        }).fire();
    }, [
        isContentCreationPanelShown,
        createAnalyticsEvent,
        contentId
    ]);
};
module.exports["usePanelOpenAnalyticsEvents"] = $f0ac822d8f33c68a$export$55a4b363793a10d0;

});

parcelRegister("hZkjK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");


var $QcCxc = parcelRequire("QcCxc");

const $3c4a4cbc3a864190$export$b6c47fafdd5a8f13 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        return experienceTracker.subscribe((0, $QcCxc.abortAllLoadPanelExperiencesOnEditPageEnded)(experienceTracker, (0, $QcCxc.loadPanelSubExperiences)));
    }, [
        experienceTracker
    ]);
    const abortExperiences = (0, $42omo.useCallback)((reason)=>{
        (0, $QcCxc.abortAllLoadPanelExperiences)(experienceTracker, (0, $QcCxc.loadPanelSubExperiences), reason);
    }, [
        experienceTracker
    ]);
    return {
        abortTemplatePanelLoadExperiences: abortExperiences
    };
};
module.exports["useLoadTemplatePanelExperienceTracker"] = $3c4a4cbc3a864190$export$b6c47fafdd5a8f13;

});

parcelRegister("QcCxc", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $gykrH = parcelRequire("gykrH");


var $1A7bE = parcelRequire("1A7bE");

const $97753ca4d20e5422$export$e27c5ac29356c803 = [
    (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_SPACE_SELECTOR_EXPERIENCE),
    (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_TEMPLATE_LIST_EXPERIENCE),
    (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE)
];
const $97753ca4d20e5422$export$5af17974359daea7 = (experienceTracker, subExperiences)=>(event)=>{
        const editPageExperienceEnded = event.name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) && (0, $gykrH.isStop)(event);
        if (editPageExperienceEnded) $97753ca4d20e5422$export$fbef40dd3c73dfed(experienceTracker, subExperiences, `${(0, $irVI7.EDIT_PAGE_EXPERIENCE)} experience ended`);
    };
const $97753ca4d20e5422$export$fbef40dd3c73dfed = (experienceTracker, subExperiences, reason)=>{
    const allLoadPanelExperiences = [
        (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_EXPERIENCE),
        ...subExperiences
    ];
    allLoadPanelExperiences.forEach((name)=>{
        experienceTracker.abort({
            name: name,
            reason: reason
        });
    });
};
const $97753ca4d20e5422$export$7bbca367109bb861 = (subExperiences)=>(events, experience)=>{
        (0, $1A7bE.collectAll)(subExperiences)(events, experience);
    };
const $97753ca4d20e5422$export$592985e5f8127ac4 = (isSpacePickerDisabled)=>{
    if (isSpacePickerDisabled) return $97753ca4d20e5422$export$e27c5ac29356c803.filter((subexperience)=>subexperience !== (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_SPACE_SELECTOR_EXPERIENCE));
    return $97753ca4d20e5422$export$e27c5ac29356c803;
};
module.exports["loadPanelSubExperiences"] = $97753ca4d20e5422$export$e27c5ac29356c803;
module.exports["abortAllLoadPanelExperiencesOnEditPageEnded"] = $97753ca4d20e5422$export$5af17974359daea7;
module.exports["abortAllLoadPanelExperiences"] = $97753ca4d20e5422$export$fbef40dd3c73dfed;
module.exports["collectLoadPanelExperiences"] = $97753ca4d20e5422$export$7bbca367109bb861;
module.exports["filterSubExperiences"] = $97753ca4d20e5422$export$592985e5f8127ac4;

});

parcelRegister("59T2o", function(module, exports) {
/* ContentCreationPanelTabs.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $xQxzY = parcelRequire("xQxzY");


var $4A7Gn = parcelRequire("4A7Gn");

var $gCbPZ = parcelRequire("gCbPZ");

var $0DTaW = parcelRequire("0DTaW");

var $k0WY4 = parcelRequire("k0WY4");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");


var $7zgzO = parcelRequire("7zgzO");


var $7pRMa = parcelRequire("7pRMa");


var $jVWe8 = parcelRequire("jVWe8");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $c5gk7 = parcelRequire("c5gk7");


var $lTuad = parcelRequire("lTuad");


var $23G6y = parcelRequire("23G6y");

const $a9fe7ee9063c2de8$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    templatesTabLabel: {
        id: "editor-context-panel-content-creation-panel.template-panel.tabs.templates.label",
        defaultMessage: "Templates"
    },
    importDocTabLabel: {
        id: "editor-context-panel-content-creation-panel.template-panel.tabs.import-doc.label",
        defaultMessage: "Import"
    },
    closeLabel: {
        id: "editor-context-panel-content-creation-panel.close-label",
        defaultMessage: "Close templates and import"
    }
});
const $a9fe7ee9063c2de8$var$CONTEXT_PANEL_TAB_TARGET = 'contextPanelTabTarget';
const $a9fe7ee9063c2de8$var$TEMPLATES_TAB_INDEX = 0;
const $a9fe7ee9063c2de8$var$IMPORT_TAB_INDEX = 1;
const $a9fe7ee9063c2de8$var$ContentWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_bfhkvuon _kqswh2mm _1tke1osq",
            __cmplp.disabled ? "_80om15jw" : "_80om73ad",
            __cmplp.className
        ])
    });
}); // header > body allows the sticky tabs to be on top of the tab body content as it scrolls
const $a9fe7ee9063c2de8$var$StickyTabsHeaderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q716j1 _kqsw1if8 _154imgjw _n3tdpxbi _1pbyowjs",
            __cmplp.className
        ])
    });
});
const $a9fe7ee9063c2de8$var$closeIconWrapperStyles = (0, $ecnYn.xcss)({
    height: '0px',
    position: 'absolute',
    right: '0',
    zIndex: 'dialog'
});
const $a9fe7ee9063c2de8$var$CustomTabPanel = ({ children: children })=>{
    const tabPanelAttributes = (0, $k0WY4.useTabPanel)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...tabPanelAttributes,
        style: {
            padding: `0 ${"var(--ds-space-050, 4px)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            zIndex: (0, $23G6y.layersNavigation)
        },
        tabIndex: -1
    }, children);
};
const $a9fe7ee9063c2de8$var$getParentPageId = (data)=>{
    const contentAncestors = data?.content?.nodes?.[0]?.ancestors ?? [];
    return contentAncestors.slice(-1)[0]?.id || '';
};
const $a9fe7ee9063c2de8$var$getInitialTabTarget = (queryParams, isImportDisabled)=>{
    const tabTarget = queryParams[$a9fe7ee9063c2de8$var$CONTEXT_PANEL_TAB_TARGET];
    if (tabTarget === 'import' && !isImportDisabled) return $a9fe7ee9063c2de8$var$IMPORT_TAB_INDEX;
    return $a9fe7ee9063c2de8$var$TEMPLATES_TAB_INDEX;
};
const $a9fe7ee9063c2de8$export$ea9a941ad7141159 = ({ currentSpaceKey: currentSpaceKey, contentId: contentId, title: title, onContentUpdated: onContentUpdated, isPanelDisabled: isPanelDisabled, beforeTemplateSelect: beforeTemplateSelect, hasUserAddedContent: hasUserAddedContent, beforeUpdateRequest: beforeUpdateRequest, onError: onError, closeConfigPanel: closeConfigPanel, abortTemplatePanelLoadExperiences: abortTemplatePanelLoadExperiences, templateAllowList: templateAllowList, isImportDisabled: isImportDisabled, isAlwaysDiscardChanges: isAlwaysDiscardChanges, isSpacePickerDisabled: isSpacePickerDisabled })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [selectedTab, setSelectedTab] = (0, $42omo.useState)($a9fe7ee9063c2de8$var$getInitialTabTarget(getQueryParams(), isImportDisabled));
    const { data: data, error: error, loading: loading } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query ContentCreationPanelTabsTemplatePanelContentQuery($contentId:ID!){content(id:$contentId status:["current" "draft"]){nodes{id ancestors{id title}}}}`, {
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only'
    });
    const parentPageId = $a9fe7ee9063c2de8$var$getParentPageId(data);
    const handleTabSelect = (0, $42omo.useCallback)((selectedIndex)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'editorRightRail',
                action: 'clicked',
                actionSubject: 'tab',
                actionSubjectId: selectedIndex === $a9fe7ee9063c2de8$var$IMPORT_TAB_INDEX ? 'importTab' : 'templatesTab'
            }
        }).fire();
        setSelectedTab(selectedIndex);
    }, [
        setSelectedTab,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (selectedTab !== $a9fe7ee9063c2de8$var$TEMPLATES_TAB_INDEX) abortTemplatePanelLoadExperiences('templates tab is not selected');
    }, [
        selectedTab,
        abortTemplatePanelLoadExperiences
    ]);
    (0, $42omo.useEffect)(()=>{
        setQueryParams({
            [$a9fe7ee9063c2de8$var$CONTEXT_PANEL_TAB_TARGET]: null
        }, true);
    }, [
        setQueryParams
    ]);
    if (loading) return null; // if this tabs array gets more complex, we will need to refactor the TEMPLATES_TAB_INDEX and CONTEXT_PANEL_TAB_TARGET concept into something that isnt hardcoded
    const tabs = [
        {
            label: $a9fe7ee9063c2de8$export$a7357cdd1f0b0168.templatesTabLabel,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7pRMa.TemplatePanel), {
                parentPageId: parentPageId,
                currentSpaceKey: currentSpaceKey,
                contentId: contentId,
                title: title,
                onContentUpdated: onContentUpdated,
                isPanelDisabled: isPanelDisabled,
                beforeTemplateSelect: beforeTemplateSelect,
                hasUserAddedContent: hasUserAddedContent,
                beforeUpdateRequest: beforeUpdateRequest,
                onError: onError,
                templateAllowList: templateAllowList,
                isAlwaysDiscardChanges: isAlwaysDiscardChanges,
                isSpacePickerDisabled: isSpacePickerDisabled
            })
        },
        ...!isImportDisabled ? [
            {
                label: $a9fe7ee9063c2de8$export$a7357cdd1f0b0168.importDocTabLabel,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jVWe8.SourcesList), {
                    hasUserAddedContent: hasUserAddedContent,
                    contentId: contentId,
                    parentPageId: parentPageId,
                    currentSpace: currentSpaceKey
                })
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lTuad.EditorContextPanelItem), {
        itemName: "template-panel",
        closeSelf: closeConfigPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    }, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_EXPERIENCE),
        error: error
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a9fe7ee9063c2de8$var$ContentWrapper, {
        disabled: isPanelDisabled,
        "data-testid": "content-creation-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4A7Gn.default), {
        onChange: handleTabSelect,
        selected: selectedTab,
        id: "editorContextPanelContentCreationTabs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a9fe7ee9063c2de8$var$StickyTabsHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a9fe7ee9063c2de8$var$closeIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5gk7.CloseButton), {
        onClose: closeConfigPanel,
        label: intl.formatMessage($a9fe7ee9063c2de8$export$a7357cdd1f0b0168.closeLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0DTaW.default), null, tabs.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gCbPZ.default), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), tab.label))))), tabs.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a9fe7ee9063c2de8$var$CustomTabPanel, {
            key: index
        }, tab.content))))));
};
module.exports["ContentCreationPanelTabs"] = $a9fe7ee9063c2de8$export$ea9a941ad7141159;

});

parcelRegister("gfIPU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

const $5675860ef242c9e4$export$eed1d73ebdd8c7ab = (0, $3u0dr.isReactCompilerActiveV1)() ? function ExperienceFailure(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
} : function ExperienceFailure({ name: name, error: error, attributes: attributes }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>experienceTracker.fail({
            name: name,
            error: error,
            attributes: attributes
        }), [
        experienceTracker,
        name,
        error,
        attributes
    ]);
    return null;
};
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("7pRMa", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $39d8ff3835a36bb3$export$67b0eaa8bfcb2d1f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Xum4K",
    name: "TemplatePanel",
    loader: async ()=>(await (parcelRequire("8IAGE"))).TemplatePanel
});
module.exports["TemplatePanel"] = $39d8ff3835a36bb3$export$67b0eaa8bfcb2d1f;

});

parcelRegister("8IAGE", function(module, exports) {

let $658ee408b2507f54$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $658ee408b2507f54$var$load("kFOec"),
    $658ee408b2507f54$var$load("9VvWo"),
    $658ee408b2507f54$var$load("6G4QQ")
]).then(()=>parcelRequire('dzOK8'));

});

parcelRegister("jVWe8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $063472e56b7451b3$export$b3ebd135320cfc = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "T0xtm",
    name: "SourcesList",
    loader: async ()=>(await (parcelRequire("f5Xhw"))).SourcesList
});
module.exports["SourcesList"] = $063472e56b7451b3$export$b3ebd135320cfc;

});

parcelRegister("f5Xhw", function(module, exports) {

let $afd54ebaa9839d36$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $afd54ebaa9839d36$var$load("52kTj").then(()=>parcelRequire('4eC1j'));

});

parcelRegister("c5gk7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $3gadb = parcelRequire("3gadb");

const $3611e64236f83f1d$var$i18n = (0, $cgtv4.defineMessages)({
    close: {
        id: "editor-context-panel.panel-close-button.close-label",
        defaultMessage: "Close configuration panel"
    }
});
const $3611e64236f83f1d$export$de65de8213222d10 = /*#__PURE__*/ (0, $42omo.memo)(({ appearance: appearance = 'subtle', onClose: onClose, label: label, isTooltipDisabled: isTooltipDisabled = true, testId: testId = 'panel-close-button', analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        hideTooltipOnClick: true,
        content: label || formatMessage($3611e64236f83f1d$var$i18n.close)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: onClose,
        appearance: appearance,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: label || formatMessage($3611e64236f83f1d$var$i18n.close),
        testId: testId,
        isTooltipDisabled: isTooltipDisabled,
        analyticsContext: analyticsContext
    }));
});
module.exports["CloseButton"] = $3611e64236f83f1d$export$de65de8213222d10;

});

parcelRegister("lTuad", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4oS56 = parcelRequire("4oS56");

const $cd929b75fafb645b$export$cea8cae1a6ef81f0 = /*#__PURE__*/ (0, $42omo.memo)(({ itemName: itemName, children: component, closeSelf: closeSelf, hasPadding: hasPadding = true, customWidth: customWidth })=>{
    const { setItem: setItem, removeItem: removeItem } = (0, $42omo.useContext)((0, $4oS56.EditorContextPanelContext));
    // remove the item on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            removeItem(itemName);
        };
    }, [
        itemName,
        removeItem
    ]);
    (0, $42omo.useEffect)(()=>{
        if (component) setItem({
            itemName: itemName,
            component: component,
            close: closeSelf,
            hasPadding: hasPadding,
            customWidth: customWidth
        });
        else removeItem(itemName);
    }, [
        component,
        itemName,
        setItem,
        removeItem,
        closeSelf,
        hasPadding,
        customWidth
    ]);
    return null;
});
module.exports["EditorContextPanelItem"] = $cd929b75fafb645b$export$cea8cae1a6ef81f0;

});

parcelRegister("4oS56", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $a02892cdeb8a3601$export$be6a93f320014444 = (0, $42omo.createContext)({
    item: null,
    setItem: ()=>{},
    removeItem: ()=>{},
    editorAPI: undefined
});
module.exports["EditorContextPanelContext"] = $a02892cdeb8a3601$export$be6a93f320014444;

});

parcelRegister("23G6y", function(module, exports) {
/**
 * Looking for gridSize? Use space tokens instead. If you need a token above 80px, or if you're setting width/height, just hardcode your value e.g. 240px.
 * Looking for borderRadius? Use a hardcoded 3px until tokens are available.
 */ // TODO(brizvash): move it to separate package or check is atlaskit will become compatible with compiled
const $81d67ebdabda9710$export$ddefa1de84eb00c6 = 400; // layers.layer()
const $81d67ebdabda9710$export$e2b78fc999d64ab4 = 300; // layers.dialog()
const $81d67ebdabda9710$export$ae37325b3735a1de = 200; // layers.navigation()
module.exports["layersNavigation"] = $81d67ebdabda9710$export$ae37325b3735a1de;

});

parcelRegister("ki0na", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $8rj8Z = parcelRequire("8rj8Z");


var $3IZob = parcelRequire("3IZob");


var $lJDEI = parcelRequire("lJDEI");

const $0c83309d3c4c183d$var$POST_BE_SYNCHRONOUS_REFRESH_EDITOR_TIMEOUT = 1500;
const $0c83309d3c4c183d$var$DELAY_INITIAL_CHECK_TIMEOUT = 4000;
const $0c83309d3c4c183d$var$isContentCreationPanelOpen = (getQueryParams)=>{
    return (0, $lJDEI.isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen)(getQueryParams);
};
const $0c83309d3c4c183d$export$d0c9d99895e9eacb = ({ cancelDebouncedSaveDraft: cancelDebouncedSaveDraft, contentId: contentId, draftShareId: draftShareId, editorActions: editorActions, hideSpinner: hideSpinner, showSpinner: showSpinner, isUnpublishedDraft: isUnpublishedDraft, isEmbeddedEditor: isEmbeddedEditor })=>{
    const { setQueryParams: setQueryParams, getQueryParams: getQueryParams, replace: replace } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const _skipLocalChangesCheck = (0, $42omo.useRef)((0, $lJDEI.getCreatedWithTemplateQueryParamValue)(getQueryParams));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [hasUserAddedContent, setHasUserAddedContent] = (0, $42omo.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange } = (0, $3IZob.useDocChangeContext)();
    (0, $42omo.useEffect)(()=>{
        setTimeout(()=>{
            _skipLocalChangesCheck.current = false;
        }, $0c83309d3c4c183d$var$DELAY_INITIAL_CHECK_TIMEOUT);
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    const onDocChange = (0, $42omo.useCallback)(()=>{
        const editorHasContent = !editorActions.isDocumentEmpty();
        const wasTemplatesPanelAutoClosed = (0, $lJDEI.getInEditorTemplatesPanelQueryParamValue)(getQueryParams) === (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED);
        if (isUnpublishedDraft && !editorHasContent && wasTemplatesPanelAutoClosed) (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_OPEN));
        if (!_skipLocalChangesCheck.current) {
            if ((0, $lJDEI.isInEditorTemplatesPanelQueryParamValueOpen)(getQueryParams) && editorHasContent) setQueryParams({
                [(0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME)]: (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED),
                [(0, $lJDEI.CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME)]: null
            }, true);
            setHasUserAddedContent(editorHasContent);
        }
    }, [
        editorActions,
        _skipLocalChangesCheck,
        getQueryParams,
        setQueryParams,
        isUnpublishedDraft
    ]);
    (0, $42omo.useEffect)(()=>{
        subscribeDocChange(onDocChange);
        return ()=>unsubscribeDocChange(onDocChange);
    }, [
        onDocChange
    ]);
    const onClickCloseContentCreationPanel = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'templateDrawer',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'templateDismissButton'
            }
        }).fire();
        (0, $lJDEI.removeInEditorTemplatesQueryParam)(setQueryParams);
    }, [
        setQueryParams,
        createAnalyticsEvent
    ]);
    const onClickOpenContentCreationPanel = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'dropdownMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'openTemplateBrowser'
            }
        }).fire();
        (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN));
    }, [
        setQueryParams,
        createAnalyticsEvent
    ]);
    const beforeUpdateRequest = (0, $42omo.useCallback)(()=>{
        showSpinner();
        cancelDebouncedSaveDraft();
        _skipLocalChangesCheck.current = true;
    }, [
        showSpinner,
        cancelDebouncedSaveDraft,
        _skipLocalChangesCheck
    ]);
    const postUpdateRequest = (0, $42omo.useCallback)(()=>{
        setHasUserAddedContent(false);
        (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_OPEN));
        setTimeout(()=>{
            _skipLocalChangesCheck.current = false;
            hideSpinner();
        }, $0c83309d3c4c183d$var$POST_BE_SYNCHRONOUS_REFRESH_EDITOR_TIMEOUT);
    }, [
        hideSpinner,
        _skipLocalChangesCheck,
        setQueryParams
    ]);
    const handleUpdatedWithTemplate = (0, $42omo.useCallback)(async (payload)=>{
        try {
            showSpinner();
            experienceTracker.start({
                name: (0, $irVI7.REFRESH_EDITOR_CONTENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
            });
            const { spaceKey: spaceKey, subType: subType } = payload;
            await (0, $8rj8Z.refetchEditorContent)(contentId);
            let route;
            let query = draftShareId ? {
                draftShareId: draftShareId
            } : {};
            if (isEmbeddedEditor) {
                route = (0, $1NBp8.EDIT_PAGE_EMBED);
                const params = getQueryParams();
                query = {
                    ...query,
                    ...params
                };
            } else if (subType === 'live') {
                route = (0, $1NBp8.VIEW_PAGE);
                // Since live page don't have the concept of drafts, draftShareId is not needed
                query = {};
            } else route = (0, $1NBp8.EDIT_PAGE_V2);
            replace(route.toUrl({
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: 'pages'
            }, {
                query: query
            }));
            experienceTracker.succeed({
                name: (0, $irVI7.REFRESH_EDITOR_CONTENT_EXPERIENCE)
            });
            experienceTracker.succeed({
                name: (0, $irVI7.IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR_EXPERIENCE)
            });
        } catch (error) {
            if (error instanceof Error) {
                experienceTracker.stopOnError({
                    name: (0, $irVI7.REFRESH_EDITOR_CONTENT_EXPERIENCE),
                    error: error
                });
                experienceTracker.stopOnError({
                    name: (0, $irVI7.IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR_EXPERIENCE),
                    error: error
                });
            }
        } finally{
            hideSpinner();
        }
    }, [
        contentId,
        cancelDebouncedSaveDraft,
        draftShareId,
        experienceTracker,
        showSpinner,
        hideSpinner,
        replace,
        isEmbeddedEditor,
        getQueryParams
    ]);
    const onUpdatedWithTemplateSubscriptionEvent = (0, $42omo.useCallback)(async (response)=>{
        cancelDebouncedSaveDraft();
        await handleUpdatedWithTemplate({
            spaceKey: response?.contentUpdatedWithTemplate?.spaceKey,
            subType: response?.contentUpdatedWithTemplate?.subtype
        });
    }, []);
    return {
        beforeUpdateRequest: beforeUpdateRequest,
        hasUserAddedContent: hasUserAddedContent,
        isContentCreationPanelOpen: $0c83309d3c4c183d$var$isContentCreationPanelOpen(getQueryParams),
        onDocChange: onDocChange,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        onClickCloseContentCreationPanel: onClickCloseContentCreationPanel,
        postUpdateRequest: postUpdateRequest,
        onUpdatedWithTemplateSubscriptionEvent: onUpdatedWithTemplateSubscriptionEvent
    };
};
module.exports["useEditorContextPanel"] = $0c83309d3c4c183d$export$d0c9d99895e9eacb;

});

parcelRegister("lJDEI", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $4a3de077c1d50444$export$339879d9e7e1b505 = 'inEditorTemplatesPanel';
const $4a3de077c1d50444$export$a957a3414f664a78 = 'open';
const $4a3de077c1d50444$export$5f52a3f66b36af8a = 'keep_open';
const $4a3de077c1d50444$export$3077ff8b594d6ef8 = 'auto_closed';
const $4a3de077c1d50444$export$e03fa63b521a0c2 = 'createdWithTemplate';
const $4a3de077c1d50444$export$5a50171a4c5c3a34 = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$e03fa63b521a0c2] === 'true';
};
const $4a3de077c1d50444$export$944cd488c360bc7a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$339879d9e7e1b505];
};
const $4a3de077c1d50444$export$e991edcb7a1d128f = (getQueryParams)=>{
    return $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams) === $4a3de077c1d50444$export$a957a3414f664a78;
};
const $4a3de077c1d50444$export$835e1f3b6fb2ce1a = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    return queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a;
};
const $4a3de077c1d50444$export$56073af4e8655248 = (setQueryParams)=>{
    setQueryParams({
        [$4a3de077c1d50444$export$339879d9e7e1b505]: null
    }, true);
};
const $4a3de077c1d50444$export$90fd502a25d2c01 = (setQueryParams, queryParamValue)=>{
    setQueryParams({
        [$4a3de077c1d50444$export$339879d9e7e1b505]: queryParamValue
    }, true);
};
const $4a3de077c1d50444$export$828af32839880b11 = (spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
    return (0, $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS).toUrl();
};
module.exports["IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$339879d9e7e1b505;
module.exports["IN_EDITOR_TEMPLATES_QUERY_OPEN"] = $4a3de077c1d50444$export$a957a3414f664a78;
module.exports["IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN"] = $4a3de077c1d50444$export$5f52a3f66b36af8a;
module.exports["IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED"] = $4a3de077c1d50444$export$3077ff8b594d6ef8;
module.exports["CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$e03fa63b521a0c2;
module.exports["getCreatedWithTemplateQueryParamValue"] = $4a3de077c1d50444$export$5a50171a4c5c3a34;
module.exports["getInEditorTemplatesPanelQueryParamValue"] = $4a3de077c1d50444$export$944cd488c360bc7a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpen"] = $4a3de077c1d50444$export$e991edcb7a1d128f;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen"] = $4a3de077c1d50444$export$835e1f3b6fb2ce1a;
module.exports["removeInEditorTemplatesQueryParam"] = $4a3de077c1d50444$export$56073af4e8655248;
module.exports["setInEditorTemplatesPanelQueryParam"] = $4a3de077c1d50444$export$90fd502a25d2c01;
module.exports["getTemplateListPage"] = $4a3de077c1d50444$export$828af32839880b11;

});

parcelRegister("dE9mB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4oS56 = parcelRequire("4oS56");

const $e37f3b5c00f62365$export$1eb912906fa8f246 = ({ children: children, editorAPI: editorAPI })=>{
    const [item, setItem] = (0, $42omo.useState)(null);
    const setNewItem = (0, $42omo.useCallback)((newItem)=>{
        setItem((prevItem)=>{
            if (prevItem && prevItem.itemName !== newItem.itemName) prevItem.close();
            return newItem;
        });
    }, []);
    const removeItem = (0, $42omo.useCallback)((itemName)=>{
        setItem((prevItem)=>prevItem?.itemName === itemName ? null : prevItem);
    }, []);
    const providerValue = (0, $42omo.useMemo)(()=>({
            item: item,
            setItem: setNewItem,
            removeItem: removeItem,
            editorAPI: editorAPI
        }), [
        item,
        removeItem,
        setNewItem,
        editorAPI
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4oS56.EditorContextPanelContext).Provider, {
        value: providerValue
    }, children);
};
module.exports["EditorContextPanelContextProvider"] = $e37f3b5c00f62365$export$1eb912906fa8f246;

});

parcelRegister("2KWDO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $auRzv = parcelRequire("auRzv");


var $aWwYt = parcelRequire("aWwYt");


var $fT4aa = parcelRequire("fT4aa");


var $9wGTI = parcelRequire("9wGTI");


var $6KaG6 = parcelRequire("6KaG6");


var $4oS56 = parcelRequire("4oS56");

const $954086d867f34b7e$export$863fb2cf408343cd = /*#__PURE__*/ (0, $42omo.memo)(()=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const isRovoButtonEnabled = (0, $fT4aa.useAIRovoButtonEnablement)();
    const panelWidth = (0, $aWwYt.usePanelWidth)();
    const panel = (0, $aWwYt.usePanel)();
    const { item: contextPanelItem, editorAPI: editorAPI } = (0, $42omo.useContext)((0, $4oS56.EditorContextPanelContext));
    // Previously, the pattern was to set state in EditorContextPanelContext in order to render components here.
    // Now, we render components directly in EditorContextPanelView to avoid bugs like https://hello.jira.atlassian.cloud/browse/DISCO-4183
    if (isObjectSidebarShown && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isRovoButtonEnabled)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auRzv.ContextPanel), {
        visible: true,
        editorAPI: editorAPI ?? undefined,
        hasPadding: false,
        customWidth: (panel?.id === 'proactive-ai-panel' || panel?.id.startsWith && panel?.id.startsWith('extensions-panel') || panel?.id === 'editor-element-insert-sidebar-panel') && (0, $9wGTI.fg)('platform_editor_ai_object_sidebar_injection') ? panelWidth || (0, $aWwYt.MIN_PANEL_WIDTH) : (0, $aWwYt.MIN_PANEL_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6KaG6.ObjectSidebarPanel), null));
    let component;
    let hasPadding;
    let customWidth;
    if (contextPanelItem) {
        component = contextPanelItem.component;
        hasPadding = contextPanelItem.hasPadding;
        customWidth = contextPanelItem.customWidth;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auRzv.ContextPanel), {
        visible: !!contextPanelItem,
        editorAPI: editorAPI ?? undefined,
        hasPadding: hasPadding,
        customWidth: customWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, component));
});
module.exports["EditorContextPanelView"] = $954086d867f34b7e$export$863fb2cf408343cd;

});

parcelRegister("fT4aa", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $lzcvT = parcelRequire("lzcvT");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

const $1cd4984a6a8003c6$export$dcc461521a57aee7 = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
    const isAIFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai') : !(0, $lzcvT.isFedRamp)();
    return isAIFeatureEnabled && isAdminHubAIEnabled && isRovoLLMEnabled;
};
module.exports["useAIRovoButtonEnablement"] = $1cd4984a6a8003c6$export$dcc461521a57aee7;

});

parcelRegister("6KaG6", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ce38ba3becf24406$export$877a45ed8043e865 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K9Gzp",
    name: "ObjectSidebarPanel",
    loader: async ()=>(await (parcelRequire("4Ppn3"))).ObjectSidebarPanelWrapper
});
module.exports["ObjectSidebarPanel"] = $ce38ba3becf24406$export$877a45ed8043e865;

});

parcelRegister("4Ppn3", function(module, exports) {

let $383f9af3792e0d6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $383f9af3792e0d6e$var$load("5tz7G"),
    $383f9af3792e0d6e$var$load("gr9Xf")
]).then(()=>parcelRequire('iFpSu'));

});

parcelRegister("bAGpj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dcoGt = parcelRequire("dcoGt");


var $cZa7r = parcelRequire("cZa7r");


var $9wGTI = parcelRequire("9wGTI");


var $dANtQ = parcelRequire("dANtQ");


var $ep3mz = parcelRequire("ep3mz");

const $16e040c4263f7228$export$665978abdb00663c = ({ pageId: pageId, editorActions: editorActions, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment })=>{
    const { setEditorCreateProps: setEditorCreateProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const annotationManager = (0, $cZa7r.useAnnotationManager)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(pageId);
    const canAddCommentsRef = (0, $42omo.useRef)(canAddComments);
    canAddCommentsRef.current = canAddComments;
    const getCanAddComments = (0, $42omo.useCallback)(()=>canAddCommentsRef.current, []);
    return (0, $42omo.useMemo)(()=>({
            inlineComment: (0, $dcoGt.getEditorInlineCommentOptions)({
                pageId: pageId,
                editorActions: editorActions,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                updateUnresolvedInlineComment: updateUnresolvedInlineComment,
                setEditorCreateProps: setEditorCreateProps,
                setEditorViewProps: setEditorViewProps,
                editorAnnotationProviderManagersEnabled: (0, $9wGTI.fg)('confluence_frontend_editor_annotation_manager'),
                getCanAddComments: getCanAddComments,
                contentType: contentType
            }),
            annotationManager: annotationManager
        }), [
        pageId,
        triggerAnalyticsEvent,
        editorActions,
        updateUnresolvedInlineComment,
        setEditorCreateProps,
        setEditorViewProps,
        annotationManager,
        contentType,
        getCanAddComments
    ]);
};
module.exports["useEditorAnnotationProviderOptions"] = $16e040c4263f7228$export$665978abdb00663c;

});

parcelRegister("dcoGt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hXzKU = parcelRequire("hXzKU");


var $jmjWc = parcelRequire("jmjWc");


var $gfqXk = parcelRequire("gfqXk");


var $kDIns = parcelRequire("kDIns");


var $gYgF0 = parcelRequire("gYgF0");


var $fS1ba = parcelRequire("fS1ba");


const $74da12b96ee2cb30$var$CreateComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lDg6H",
    name: "CreateComponent",
    loader: async ()=>(await Promise.resolve((parcelRequire("4tTm9")))).CreateComponent
});

const $74da12b96ee2cb30$var$ViewComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bZUjL",
    name: "ViewComponent",
    loader: async ()=>(await Promise.resolve((parcelRequire("3omFm")))).ViewComponent
});
const $74da12b96ee2cb30$var$ViewComponentMemoized = ({ pageId: pageId, editorActions: editorActions })=>/*#__PURE__*/ (0, $42omo.memo)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($74da12b96ee2cb30$var$ViewComponent, {
            pageId: pageId,
            editorActions: editorActions,
            ...props
        });
    });
const $74da12b96ee2cb30$var$CreateComponentMemoized = ({ pageId: pageId })=>/*#__PURE__*/ (0, $42omo.memo)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($74da12b96ee2cb30$var$CreateComponent, {
            pageId: pageId,
            ...props
        });
    });
const $74da12b96ee2cb30$export$e453b02e89d48d2b = ({ pageId: pageId, editorActions: editorActions, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment, editorAnnotationProviderManagersEnabled: editorAnnotationProviderManagersEnabled, getCanAddComments: getCanAddComments, contentType: contentType })=>{
    let updateSubscriber = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    if (!updateSubscriber?.off) updateSubscriber = null;
    return {
        viewComponent: editorAnnotationProviderManagersEnabled ? (0, $fS1ba.ViewManager)({
            pageId: pageId,
            editorActions: editorActions
        }) : $74da12b96ee2cb30$var$ViewComponentMemoized({
            pageId: pageId,
            editorActions: editorActions
        }),
        createComponent: editorAnnotationProviderManagersEnabled ? (0, $gYgF0.CreateManager)({
            pageId: pageId
        }) : $74da12b96ee2cb30$var$CreateComponentMemoized({
            pageId: pageId
        }),
        getState: (annotations)=>(0, $kDIns.getEditorResolvedState)({
                annotations: annotations,
                pageId: pageId,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                updateUnresolvedInlineComment: updateUnresolvedInlineComment
            }),
        updateSubscriber: updateSubscriber,
        disallowOnWhitespace: true,
        isToolbarAbove: true,
        supportedBlockNodes: [
            'media'
        ],
        onCommentButtonMount: ()=>(0, $hXzKU.LazyCommentEditor).preload(),
        getCanAddComments: getCanAddComments,
        contentType: contentType
    };
};
module.exports["getEditorInlineCommentOptions"] = $74da12b96ee2cb30$export$e453b02e89d48d2b;

});

parcelRegister("hXzKU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $jmjWc = parcelRequire("jmjWc");


var $6mKj3 = parcelRequire("6mKj3");


var $jnVM5 = parcelRequire("jnVM5");


const $7b7af88805418522$export$b355deaeb7ea7f7c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2kww5",
    name: "LazyCommentEditor",
    loader: async ()=>(await (parcelRequire("6CCXt"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium",
            interactionName: "comment-editor-loadable"
        })),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$301ffca6e2410600 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Pf9d2",
    name: "LazyInlineCommentEditor",
    loader: async ()=>(await (parcelRequire("6CCXt"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jnVM5.LazyCommentEditorPlaceholder), null),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$b728c0889ff2145f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DmrQC",
    name: "LazyCommentEditorWithoutSpinner",
    loader: async ()=>(await (parcelRequire("6CCXt"))).CommentEditor,
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});
module.exports["LazyCommentEditor"] = $7b7af88805418522$export$b355deaeb7ea7f7c;
module.exports["LazyInlineCommentEditor"] = $7b7af88805418522$export$301ffca6e2410600;
module.exports["LazyCommentEditorWithoutSpinner"] = $7b7af88805418522$export$b728c0889ff2145f;

});

parcelRegister("jnVM5", function(module, exports) {
/* LazyCommentEditorPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e8d5100a3bfca53$var$InputContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41b66 _19itia51 _2rkofajl _11c82smr _4t3i1ul9 _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $8e8d5100a3bfca53$export$b85a78dfaafd1a99 = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e8d5100a3bfca53$var$InputContainer, {
        disabled: true,
        placeholder: intl.formatMessage({
            id: "comment.reply.placeholder",
            defaultMessage: "Reply"
        })
    }));
};
module.exports["LazyCommentEditorPlaceholder"] = $8e8d5100a3bfca53$export$b85a78dfaafd1a99;

});

parcelRegister("6CCXt", function(module, exports) {

let $4d248301339d6cb6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4d248301339d6cb6$var$load("fm4rz"),
    $4d248301339d6cb6$var$load("39kma"),
    $4d248301339d6cb6$var$load("jwWp5"),
    $4d248301339d6cb6$var$load("6FuHS"),
    $4d248301339d6cb6$var$load("eyaRC"),
    $4d248301339d6cb6$var$load("aeEUI"),
    $4d248301339d6cb6$var$load("eHDb1"),
    $4d248301339d6cb6$var$load("2zUEf"),
    $4d248301339d6cb6$var$load("lrvSS"),
    $4d248301339d6cb6$var$load("axHWl"),
    $4d248301339d6cb6$var$load("fZt2F"),
    $4d248301339d6cb6$var$load("kCMj8"),
    $4d248301339d6cb6$var$load("e9JE4"),
    $4d248301339d6cb6$var$load("e4GNb"),
    $4d248301339d6cb6$var$load("5QKVr"),
    $4d248301339d6cb6$var$load("bxFZs"),
    $4d248301339d6cb6$var$load("2YffH"),
    $4d248301339d6cb6$var$load("tKhaz"),
    $4d248301339d6cb6$var$load("cPWI2"),
    $4d248301339d6cb6$var$load("i1fZC"),
    $4d248301339d6cb6$var$load("litDc"),
    $4d248301339d6cb6$var$load("9Uze4"),
    $4d248301339d6cb6$var$load("6rkrn"),
    $4d248301339d6cb6$var$load("fwZcf"),
    $4d248301339d6cb6$var$load("9A0ig"),
    $4d248301339d6cb6$var$load("dVAT5"),
    $4d248301339d6cb6$var$load("fIFgO"),
    $4d248301339d6cb6$var$load("86sUJ"),
    $4d248301339d6cb6$var$load("lkOIY"),
    $4d248301339d6cb6$var$load("dh8Yu"),
    $4d248301339d6cb6$var$load("fxPKA"),
    $4d248301339d6cb6$var$load("cu8No"),
    $4d248301339d6cb6$var$load("6sohm"),
    $4d248301339d6cb6$var$load("b5oVM"),
    $4d248301339d6cb6$var$load("9XYQ9"),
    $4d248301339d6cb6$var$load("8yTXr"),
    $4d248301339d6cb6$var$load("drv5I"),
    $4d248301339d6cb6$var$load("jp3gT"),
    $4d248301339d6cb6$var$load("5abXM"),
    $4d248301339d6cb6$var$load("k78EM"),
    $4d248301339d6cb6$var$load("5pvpJ"),
    $4d248301339d6cb6$var$load("hshEG"),
    $4d248301339d6cb6$var$load("5EQhG"),
    $4d248301339d6cb6$var$load("8fXIr"),
    $4d248301339d6cb6$var$load("dVkhd"),
    $4d248301339d6cb6$var$load("kjZZD"),
    $4d248301339d6cb6$var$load("ht5OT"),
    $4d248301339d6cb6$var$load("sj9Xz"),
    $4d248301339d6cb6$var$load("1qlDN"),
    $4d248301339d6cb6$var$load("1yVM6"),
    $4d248301339d6cb6$var$load("6wr18"),
    $4d248301339d6cb6$var$load("cyGuT"),
    $4d248301339d6cb6$var$load("hhss7"),
    $4d248301339d6cb6$var$load("8FbYE"),
    $4d248301339d6cb6$var$load("dUevD"),
    $4d248301339d6cb6$var$load("7u4WP"),
    $4d248301339d6cb6$var$load("Wowvf"),
    $4d248301339d6cb6$var$load("f1NVy"),
    $4d248301339d6cb6$var$load("let0D"),
    $4d248301339d6cb6$var$load("aqr2D"),
    $4d248301339d6cb6$var$load("ioQAS"),
    $4d248301339d6cb6$var$load("ffEVr"),
    $4d248301339d6cb6$var$load("kUbUu"),
    $4d248301339d6cb6$var$load("7EorR"),
    $4d248301339d6cb6$var$load("8Ovry")
]).then(()=>parcelRequire('3qEAL'));

});

parcelRegister("gYgF0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cZa7r = parcelRequire("cZa7r");


var $aWwYt = parcelRequire("aWwYt");


var $bSvtO = parcelRequire("bSvtO");


var $gfqXk = parcelRequire("gfqXk");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $9wGTI = parcelRequire("9wGTI");

const $a70e629208b21e04$export$3fa94ae7388781e0 = ({ pageId: pageId, onCreate: onCreate, onClose: onClose, dom: dom, textSelection: textSelection, inlineNodeTypes: inlineNodeTypes, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, isOffline: isOfflineFromProps, wasNewAnnotationSelected: wasNewAnnotationSelected })=>{
    const { editorViewProps: editorViewProps } = (0, $cZa7r.useAnnotations)();
    const { setEditorCreateProps: setEditorCreateProps, setEditorViewProps: setEditorViewProps, setIsOffline: setIsOffline, setStoredCommentData: setStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const editorAnnotationEventEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const annotationManager = (0, $cZa7r.useAnnotationManager)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isShowingComment = editorViewProps && editorViewProps.annotations.length > 0;
    const handleClose = (0, $42omo.useCallback)(()=>{
        if ((0, $9wGTI.fg)('platform_editor_comments_api_manager')) annotationManager?.clearDraft();
        else onClose && onClose();
        setEditorCreateProps(null);
    }, [
        onClose,
        setEditorCreateProps,
        annotationManager
    ]);
    const handleCreate = (0, $42omo.useCallback)((id, commentData)=>{
        if (commentData) setStoredCommentData(commentData);
        if ((0, $9wGTI.fg)('platform_editor_comments_api_manager')) return annotationManager?.applyDraft(id);
        else return onCreate && onCreate(id);
    }, [
        onCreate,
        annotationManager,
        setStoredCommentData
    ]);
    const closeObjectSidebar = (0, $42omo.useCallback)(()=>{
        if (isObjectSidebarShown) hideObjectSidebar();
    }, [
        isObjectSidebarShown,
        hideObjectSidebar
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_annotation_prompt_edit_discard')) {
            if (wasNewAnnotationSelected) {
                const onDiscardEdit = ()=>{
                    resetContentChanged();
                    handleClose();
                    setEditorViewProps(null);
                    closeObjectSidebar();
                };
                if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                    onConfirm: onDiscardEdit,
                    onCancel: ()=>{
                        editorAnnotationEventEmitter.emit('setselectedannotation', '');
                    }
                });
                else onDiscardEdit();
            }
        }
    }, [
        closeObjectSidebar,
        handleClose,
        hasContentChanged,
        wasNewAnnotationSelected,
        editorAnnotationEventEmitter,
        resetContentChanged,
        setEditorViewProps,
        showModal
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleSetEditorCreateProps = ()=>{
            setEditorViewProps(null);
            setEditorCreateProps({
                pageId: pageId,
                textSelection: textSelection,
                dom: dom,
                onCreate: handleCreate,
                onClose: handleClose,
                inlineNodeTypes: inlineNodeTypes,
                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
                closeObjectSidebar: closeObjectSidebar
            });
        };
        if (isShowingComment && hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                setEditorViewProps(null);
                handleSetEditorCreateProps();
                closeObjectSidebar();
            },
            onCancel: ()=>{
                // If the user cancels, then cancel out the highlight
                handleClose();
            }
        });
        else handleSetEditorCreateProps();
    // We only want to listen to changes that signifies a new comment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dom,
        textSelection
    ]);
    (0, $42omo.useEffect)(()=>{
        // This is effectively gated by the platform_editor_offline_editing_web experiment, via platform/packages/editor/editor-plugin-annotation/src/ui/InlineCommentView.tsx
        setIsOffline(isOfflineFromProps === true);
    }, [
        isOfflineFromProps,
        setIsOffline
    ]);
    return null;
};
const $a70e629208b21e04$export$a455823a9487ea0 = ({ pageId: pageId })=>/*#__PURE__*/ (0, $42omo.memo)((createComponentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a70e629208b21e04$export$3fa94ae7388781e0, {
            pageId: pageId,
            ...createComponentProps
        }));
module.exports["CreateManager"] = $a70e629208b21e04$export$a455823a9487ea0;

});

parcelRegister("fS1ba", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bSvtO = parcelRequire("bSvtO");


var $cZa7r = parcelRequire("cZa7r");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $gfqXk = parcelRequire("gfqXk");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $aJPUt = parcelRequire("aJPUt");


var $2eC70 = parcelRequire("2eC70");


var $9wGTI = parcelRequire("9wGTI");


var $5fMeR = parcelRequire("5fMeR");

const $9dbfd76fc543be2b$var$relativeFilePath = 'annotation-provider-inline-comments/editor/ViewManager';
const $9dbfd76fc543be2b$export$76599b5777b5fa44 = ({ pageId: pageId, editorActions: editorActions, newlySelectedAnnotationId: newlySelectedAnnotationId, annotations: annotations, annotationsList: annotationsList, getInlineNodeTypes: getInlineNodeTypes, onClose: onClose, onDelete: onDelete, onResolve: onResolve, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, isOffline: isOfflineFromProps })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { setEditorViewProps: setEditorViewProps, setIsOffline: setIsOffline, clearStoredCommentData: clearStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const { isCommentsPanelShown: isCommentsPanelShown } = (0, $5fMeR.useShowCommentsPanel)();
    // Clear stored comment data when annotation changes (before new component renders)
    (0, $42omo.useEffect)(()=>{
        if (storedCommentData) {
            const currentAnnotationId = annotations?.[0]?.id;
            const storedAnnotationId = storedCommentData?.location?.inlineMarkerRef;
            // Clear stored data if we're viewing a different annotation
            if (currentAnnotationId && storedAnnotationId && currentAnnotationId !== storedAnnotationId) clearStoredCommentData();
        }
    }, [
        annotations,
        storedCommentData,
        clearStoredCommentData
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        // NOTE: Any logic added to the handleClose function will need to be duplicated to EditorCommentShortcutListener.tsx. To revisit - create a shared function so the close inline comment logic can be reused
        // When closing the sidebar, return focus to the previously selected annotation element
        setTimeout(()=>{
            editorActions?.focus();
        }, 100);
        onClose && onClose();
        setEditorViewProps(null);
        if (storedCommentData) clearStoredCommentData();
        if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_editor')) experienceTracker.abort({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            reason: 'Inline comment was closed',
            checkForTimeout: true,
            publishDebugPoints: true,
            attributes: {
                stopPoint: $9dbfd76fc543be2b$var$relativeFilePath
            }
        });
    }, [
        editorActions,
        onClose,
        setEditorViewProps,
        experienceTracker,
        storedCommentData,
        clearStoredCommentData
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleSetEditorViewProps = ()=>{
            setEditorViewProps({
                pageId: pageId,
                editorActions: editorActions,
                annotations: annotations,
                annotationsList: annotationsList,
                getInlineNodeTypes: getInlineNodeTypes,
                onClose: handleClose,
                onDelete: onDelete,
                onResolve: onResolve,
                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar
            });
            // Only start the experience if the comments panel is closed to track the core view-inline-comment experience
            if (!isCommentsPanelShown && annotations[0]?.id && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_editor')) {
                const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE));
                /*
				 * Note: This logic runs after certain entrypoints start the view-inline-comment experience.
				 * We don't start a new experience if the annotation ID of the running experience is the same
				 * as the current annotation to avoid duplicating and aborting experiences.
				 */ if (experienceState === null || experienceState?.hasStopped || experienceState?.hasStopped === false && experienceState?.attributes?.annotationId !== annotations[0]?.id) experienceTracker.start({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                    attributes: {
                        ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                        annotationId: annotations[0]?.id,
                        entryPoint: $9dbfd76fc543be2b$var$relativeFilePath,
                        pageClass: 'editor'
                    }
                });
            }
            if (editorCreateProps) experienceTracker.succeed({
                name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE)
            });
        };
        // The annotation currently being shown
        const currentlyShownAnnotationId = editorViewProps && editorViewProps.annotations.length > 0 ? editorViewProps.annotations[0].id : undefined;
        // We only want to do anything if a new annotation has been clicked/selected
        if (newlySelectedAnnotationId !== currentlyShownAnnotationId) {
            // We only want to show the dialog if a new annotation has been selected AND content has changed
            // if a new annotation has not been selected, the onClose() function will handle the changed dialog
            // COMMENTS-3216 - With Concurrent Mode the rendering cycle is optimized to show things sooner
            //				   causing this component to mount before the state change for the comment content
            //				   is registered and thus causes the user to be prompted. We will never have a case
            //				   that currentlyShownAnnotationId is undefined AND there are changes, so this is safe
            if (hasContentChanged && currentlyShownAnnotationId !== undefined) {
                let abortedExperience = false;
                let abortedExperienceEntrypoint = '';
                if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_keyboard')) {
                    const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE));
                    /*
					 * If a keyboard shortcut or comment navigation is used to navigate when the content has changed,
					 * we abort and restart the experience on confirm because we can't predict if the user will
					 * confirm the navigation, or how long the user will take to confirm.
					 */ if (experienceState !== null && experienceState?.hasStopped === false && (experienceState?.attributes?.entryPoint === 'comments-shortcuts/EditorCommentShortcutListener' || experienceState?.attributes?.entryPoint === 'inline-comments-common/CommentNavigation')) {
                        abortedExperienceEntrypoint = experienceState?.attributes?.entryPoint;
                        experienceTracker.abort({
                            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                            reason: 'Comment warning dialog displayed',
                            checkForTimeout: true,
                            publishDebugPoints: true,
                            attributes: {
                                stopPoint: $9dbfd76fc543be2b$var$relativeFilePath
                            }
                        });
                        abortedExperience = true;
                    }
                }
                showModal((0, $cMvMc.CommentWarningDialog), {
                    onConfirm: ()=>{
                        if (abortedExperience) {
                            experienceTracker.start({
                                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                                attributes: {
                                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                                    annotationId: annotations.length && annotations[0].id,
                                    entryPoint: $9dbfd76fc543be2b$var$relativeFilePath,
                                    pageClass: 'editor'
                                }
                            });
                            (0, $4EKKB.selectInlineComment).debug(`Restarting experience after comment was discarded from comment warning dialog. Initial entrypoint: ${abortedExperienceEntrypoint}`);
                        }
                        // On confirm, activate the newly clicked one
                        if (annotations.length > 0) emitter.emit('setselectedannotation', annotations[0].id);
                        resetContentChanged();
                        handleSetEditorViewProps();
                    },
                    onCancel: ()=>{
                        // If we have a previously shown annotationId we want to keep it highlighted until the user makes their choice
                        if (currentlyShownAnnotationId) emitter.emit('setselectedannotation', currentlyShownAnnotationId);
                    }
                });
            } else handleSetEditorViewProps();
        }
    // We only want to listen to changes that signifies a new comment click
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        newlySelectedAnnotationId
    ]);
    (0, $42omo.useEffect)(()=>{
        // This is effectively gated by the platform_editor_offline_editing_web experiment, via platform/packages/editor/editor-plugin-annotation/src/ui/InlineCommentView.tsx
        setIsOffline(isOfflineFromProps === true);
    }, [
        isOfflineFromProps,
        setIsOffline
    ]);
    return null;
};
const $9dbfd76fc543be2b$export$e2fb22396d3bf4b8 = ({ pageId: pageId, editorActions: editorActions })=>/*#__PURE__*/ (0, $42omo.memo)((viewComponentProps)=>{
        // TODO: Handle multiple annotations
        const newlySelectedAnnotationId = viewComponentProps.annotations.length > 0 ? viewComponentProps.annotations[0].id : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9dbfd76fc543be2b$export$76599b5777b5fa44, {
            pageId: pageId,
            editorActions: editorActions,
            newlySelectedAnnotationId: newlySelectedAnnotationId,
            ...viewComponentProps
        });
    });
module.exports["ViewManager"] = $9dbfd76fc543be2b$export$e2fb22396d3bf4b8;

});

parcelRegister("5IgBW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cZa7r = parcelRequire("cZa7r");


var $4gEXU = parcelRequire("4gEXU");


var $4tTm9 = parcelRequire("4tTm9");


var $3omFm = parcelRequire("3omFm");

const $f7d023b2088a5828$export$a0008e78c876ccee = ()=>{
    const { editorCreateProps: editorCreateProps, editorViewProps: editorViewProps, isOffline: isOffline } = (0, $cZa7r.useAnnotations)();
    const { setEditorCreateProps: setEditorCreateProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const onConfirm = (0, $42omo.useCallback)(()=>{
        !!editorCreateProps && setEditorCreateProps(null);
        !!editorViewProps && setEditorViewProps(null);
    }, [
        editorCreateProps,
        setEditorCreateProps,
        editorViewProps,
        setEditorViewProps
    ]);
    (0, $4gEXU.usePreemptiveGate)({
        onConfirm: onConfirm
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, editorCreateProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tTm9.CreateComponent), {
        ...editorCreateProps,
        isOffline: isOffline
    }), editorViewProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3omFm.ViewComponent), {
        ...editorViewProps,
        isOffline: isOffline
    }));
};
module.exports["EditorAnnotationProviderComponents"] = $f7d023b2088a5828$export$a0008e78c876ccee;

});

parcelRegister("4gEXU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cZa7r = parcelRequire("cZa7r");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $bSvtO = parcelRequire("bSvtO");

function $4ccc472e1abe9fa4$export$b3246a2f66464d01({ onConfirm: onConfirm }) {
    const annotationManager = (0, $cZa7r.useAnnotationManager)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    // This hook enables the new preemptive gate for the editor comment API manager to catch the situation
    // where the user tries to start a draft while there is unsaved content in the editor.
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            if (hasContentChanged) annotationManager.setPreemptiveGate(()=>{
                return new Promise((resolve)=>{
                    showModal((0, $cMvMc.CommentWarningDialog), {
                        onConfirm: ()=>{
                            resetContentChanged();
                            onConfirm();
                            // Allow the draft to be started or the comment viewed.
                            resolve(true);
                        },
                        onCancel: ()=>{
                            // Cancel the start draft or view attempt.
                            resolve(false);
                        },
                        onClose: ()=>{
                            // Just in case the user closes the modal by some other means we need to ensure the
                            // promise is resolved. We do not want to leave the preemptive gate open.
                            resolve(false);
                        }
                    });
                });
            });
            else annotationManager?.setPreemptiveGate(()=>Promise.resolve(true));
            return ()=>{
                annotationManager?.setPreemptiveGate(()=>Promise.resolve(true));
            };
        }
    }, [
        hasContentChanged,
        annotationManager,
        showModal,
        resetContentChanged,
        onConfirm
    ]);
}
module.exports["usePreemptiveGate"] = $4ccc472e1abe9fa4$export$b3246a2f66464d01;

});

parcelRegister("3omFm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gfqXk = parcelRequire("gfqXk");


var $3jwuS = parcelRequire("3jwuS");


var $cZa7r = parcelRequire("cZa7r");


var $9wGTI = parcelRequire("9wGTI");


var $9FoVw = parcelRequire("9FoVw");


var $f5Wgm = parcelRequire("f5Wgm");


var $5fMeR = parcelRequire("5fMeR");


var $6KwrO = parcelRequire("6KwrO");


var $3mVfX = parcelRequire("3mVfX");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2UZkz = parcelRequire("2UZkz");

const $554aaf1aa11e07ba$export$aa84ce7cadd60676 = (nextMarkerRef)=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    emitter.emit('setselectedannotation', nextMarkerRef);
};
const $554aaf1aa11e07ba$export$f845437bf1d007fd = ({ annotations: clickedAnnotations, getInlineNodeTypes: getInlineNodeTypes, editorActions: editorActions, onClose: onClose, onDelete: onDelete, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar = false, isOffline: isOffline })=>{
    const { setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const supportedCommentActions = !isLivePage ? [
        'edit',
        'resolve'
    ] : [
        'edit',
        'resolve',
        'delete'
    ];
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCurrentView: setCurrentView } = (0, $3mVfX.useCommentsPanelActions)();
    const { currentView: currentView } = (0, $3mVfX.useCommentsPanelState)();
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const { isCommentsPanelShown: isCommentsPanelShown } = (0, $5fMeR.useShowCommentsPanel)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [isInlineCommentVisible, setIsInlineCommentVisible] = (0, $42omo.useState)(false);
    const inlineCommentRef = (0, $42omo.useCallback)((node)=>{
        if (node === null) setIsInlineCommentVisible(false);
        else setIsInlineCommentVisible(true);
    }, []);
    const handleResolve = ()=>{
        setEditorViewProps(null);
    };
    const handleDelete = (0, $42omo.useCallback)((id)=>{
        setEditorViewProps(null);
        onDelete && onDelete(id);
    }, [
        setEditorViewProps,
        onDelete
    ]);
    (0, $42omo.useEffect)(()=>{
        const annotationId = clickedAnnotations[0]?.id;
        if (!annotationId) return;
        const shouldScrollCommentsPanelToComment = isCommentsPanelShown && clickedAnnotations.length > 0;
        if (shouldScrollCommentsPanelToComment && (0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
            setCurrentlySelectedThreadKey(annotationId);
            let expectedView = undefined;
            if ((currentView === (0, $3mVfX.ViewValues).RESOLVED || currentView === (0, $3mVfX.ViewValues).DELETED_CONTENT) && (0, $9wGTI.fg)('confluence_comments_unified_navigation_viewchange')) {
                setCurrentView && setCurrentView((0, $3mVfX.ViewValues).OPEN);
                expectedView = (0, $3mVfX.ViewValues).OPEN;
            }
            if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                context: (0, $9FoVw.NavigationContext).PANEL,
                block: 'center',
                annotationId: annotationId,
                commentType: (0, $f5Wgm.CommentType).INLINE,
                annotationClicked: true,
                expectedView: expectedView
            });
            else scrollCommentsPanelToThread({
                annotationId: annotationId,
                annotationClicked: true
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clickedAnnotations[0]?.id
    ]);
    const handleNavigationClick = (nextMarkerRef)=>{
        if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_arrow_nav')) experienceTracker.updateAttributes({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                annotationId: nextMarkerRef
            }
        });
        $554aaf1aa11e07ba$export$aa84ce7cadd60676(nextMarkerRef);
    };
    const shouldRenderStandaloneInlineComment = clickedAnnotations.length > 0 && (!(0, $9wGTI.fg)('confluence-frontend-comments-panel') || !isCommentsPanelShown);
    return shouldRenderStandaloneInlineComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UZkz.InlineComment), {
        isEditor: true,
        annotation: clickedAnnotations[0],
        getInlineNodeTypes: getInlineNodeTypes,
        onClose: onClose,
        editorActions: editorActions,
        onNavigationClick: (nextMarkerRef)=>handleNavigationClick(nextMarkerRef),
        onResolve: handleResolve,
        onDelete: handleDelete,
        supportedTopLevelActions: supportedCommentActions,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        inlineCommentRef: inlineCommentRef,
        isInlineCommentVisible: isInlineCommentVisible,
        isOffline: isOffline,
        key: `inline-comment-${clickedAnnotations[0]?.id}`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
};
module.exports["editorHandleNavigationClick"] = $554aaf1aa11e07ba$export$aa84ce7cadd60676;
module.exports["ViewComponent"] = $554aaf1aa11e07ba$export$f845437bf1d007fd;

});

parcelRegister("WheoQ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b0ecc354fcdb9645$export$23b7aa19be1bc1ad = (callbacks)=>(0, $42omo.useCallback)((annotationsList)=>{
        callbacks.forEach((callback)=>callback(annotationsList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, callbacks);
module.exports["useUpdateAnnotations"] = $b0ecc354fcdb9645$export$23b7aa19be1bc1ad;

});

parcelRegister("aPQsP", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $2xIMp = parcelRequire("2xIMp");


var $inPa6 = parcelRequire("inPa6");


var $bre0g = parcelRequire("bre0g");


var $9ZD6n = parcelRequire("9ZD6n");


var $ke0mx = parcelRequire("ke0mx");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7PHx9 = parcelRequire("7PHx9");

var $1M1t5 = parcelRequire("1M1t5");


var $iz4WO = parcelRequire("iz4WO");


var $jRxDI = parcelRequire("jRxDI");


var $iONqR = parcelRequire("iONqR");


var $euL71 = parcelRequire("euL71");


var $6b7RE = parcelRequire("6b7RE");


var $gH8jv = parcelRequire("gH8jv");


var $2YtTU = parcelRequire("2YtTU");


var $4U6ec = parcelRequire("4U6ec");


var $3IZob = parcelRequire("3IZob");


var $giS6h = parcelRequire("giS6h");


var $fgd2r = parcelRequire("fgd2r");


var $1kHsc = parcelRequire("1kHsc");


var $aQw7y = parcelRequire("aQw7y");


var $bfil7 = parcelRequire("bfil7");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $1JyKZ = parcelRequire("1JyKZ");


var $cEgMD = parcelRequire("cEgMD");


var $lvKPs = parcelRequire("lvKPs");


var $aIqlA = parcelRequire("aIqlA");

const $f03f53a782506f81$var$noop = ()=>{};
const $f03f53a782506f81$var$_getClassicEditorProviders = (0, $2XqLN.default)(({ cloudId: cloudId, contentId: contentId, contentType: contentType, spaceKey: spaceKey, spaceId: spaceId, editorActions: editorActions, createAnalyticsEvent: createAnalyticsEvent, mentionProvider: mentionProvider, intlNext: intlNext, openMacroBrowserToEditExistingMacro: openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration, setActiveModal: setActiveModal, openConnectionsPanel: openConnectionsPanel, openConfigPanel: openConfigPanel, openSmartButtonConfigPanel: openSmartButtonConfigPanel, closeActiveModal: closeActiveModal, getMigrationExtensionManifest: getMigrationExtensionManifest, extensionContextProvider: extensionContextProvider, subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange, onCompleteCallback: onCompleteCallback, analyticsContext: analyticsContext, isLivePage: isLivePage, allowCreateDatabaseExtension: allowCreateDatabaseExtension, allowDatabaseQuickInsert: allowDatabaseQuickInsert, allowCreateWhiteboardExtension: allowCreateWhiteboardExtension, flags: flags, editorAPI: editorAPI, setUpsellModalSource: setUpsellModalSource, hideGlassPaneForForge: hideGlassPaneForForge, isFullPageEditor: isFullPageEditor, allowLegacyMacros: allowLegacyMacros, allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions, isLivePagesFeatureEnabled: isLivePagesFeatureEnabled, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isSmartButtonAllowed: isSmartButtonAllowed } = (0, $iz4WO.useSmartButtonPremiumGate)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const pageContext = {
        contentId: contentId,
        spaceKey: spaceKey,
        spaceId: spaceId,
        features: {
            configPanel: {
                enabled: true,
                optedOut: (0, $fgd2r.getOptedOutMacros)()
            },
            elementBrowser: true
        }
    };
    const extensionHandlers = (0, $lvKPs.getFullPageExtensionHandlers)({
        contentId: contentId,
        spaceKey: spaceKey,
        extensionContextProvider: extensionContextProvider,
        editorActions: editorActions,
        subscribeDocChange: subscribeDocChange,
        unsubscribeDocChange: unsubscribeDocChange,
        isLivePage: isLivePage,
        isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled
    });
    const macroConfig = {
        contentId: contentId,
        setActiveModal: setActiveModal,
        closeActiveModal: closeActiveModal
    };
    const hideCreateContentMacros = isCompanyHub && (0, $9wGTI.fg)('company-hub-hide-create-content-macros');
    const confluenceMacroExtensionProviderForEditor = (0, $bfil7.getConfluenceMacrosExtensionProviderForEditor)(pageContext, extensionHandlers, editorAPI ?? undefined, editorActions, macroConfig, getMigrationExtensionManifest || $f03f53a782506f81$var$noop, openMacroBrowserToEditExistingMacro || $f03f53a782506f81$var$noop, openMacroBrowserForInitialConfiguration || $f03f53a782506f81$var$noop, intlNext, createAnalyticsEvent, onCompleteCallback, isLivePage, flags, experienceTracker, contentType, allowCreateDatabaseExtension && !hideCreateContentMacros, allowDatabaseQuickInsert, allowCreateWhiteboardExtension && !hideCreateContentMacros, allowLegacyMacros, isLivePagesFeatureEnabled, isCompanyHub);
    const extensionProvidersList = [];
    extensionProvidersList.push(confluenceMacroExtensionProviderForEditor);
    const extensions = [];
    extensions.push((0, $9ZD6n.default)({
        appKey: (0, $4U6ec.DROPBOX_APP_KEY),
        canMountinIframe: false
    }));
    if (!hideCreateContentMacros) extensions.push((0, $ke0mx.manifest)({
        intl: intlNext,
        defaultCloudId: cloudId,
        defaultFormValues: {
            'confluence-page': {
                parentId: contentId,
                spaceId: spaceId
            }
        },
        analyticsContext: analyticsContext,
        pageContext: {
            isLivePage: isLivePage,
            isBlogpost: contentType === 'blogpost',
            isFullPageEditor: isFullPageEditor
        },
        location: 'confluence-page',
        allowConfluenceEditViewEmbed: true,
        flags: {
            showSuccess: ({ title: title, description: description, actions: actions })=>{
                flags?.showSuccessFlag({
                    title: title,
                    description: description,
                    actions: actions,
                    isAutoDismiss: true
                });
            },
            showFailure: ({ title: title, description: description, actions: actions })=>{
                flags?.showErrorFlag({
                    title: title,
                    description: description,
                    actions: actions,
                    isAutoDismiss: true
                });
            }
        }
    }));
    extensionProvidersList.push(new (0, $bre0g.default)(extensions));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const isAdmin = (0, $8Lx5S.useIsAdmin)();
    const showPremiumExtensions = isAdmin || isPremium;
    const premiumExtensions = showPremiumExtensions ? (0, $gH8jv.createPremiumExtensionManifests)({
        contentId: contentId,
        editorActions: editorActions,
        openConfigPanel: openConfigPanel,
        intl: intlNext,
        setUpsellModalSource: setUpsellModalSource,
        allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions
    }) : [];
    extensionProvidersList.push(new (0, $bre0g.default)(premiumExtensions));
    // Don't add the Smart Button extension if we're in the Company Hub,
    // the company-hub-migration-prevent-1p-macro experiment is enabled,
    // and the company-hub-prevent-1p-macro-via-tap-trait gate returns false.
    // company-hub-prevent-1p-macro-via-tap-trait is controlled by a tap trait that checks if a tenant's company hub
    // has been published with unsupported 1p macros in the last 4 months,
    // in which case we will allow them to insert Smart Button, an unsupported 1p macro.
    if (!isCompanyHub || !(0, $6mKj3.expVal)('company-hub-migration-prevent-1p-macro', 'isEnabled', false) || (0, $9wGTI.fg)('company-hub-prevent-1p-macro-via-tap-trait')) extensionProvidersList.push((0, $jRxDI.smartButtonExtensionProvider)({
        contentId: contentId,
        editorActions: editorActions,
        openSmartButtonConfigPanel: openSmartButtonConfigPanel,
        intl: intlNext,
        isSmartButtonAllowed: isSmartButtonAllowed,
        contentType: contentType
    }));
    extensionProvidersList.push((0, $6b7RE.projectLinkerExtensionProvider)({
        cloudId: cloudId,
        intl: intlNext,
        editorActions: editorActions,
        createAnalyticsEvent: createAnalyticsEvent
    }));
    extensionProvidersList.push((0, $7PHx9.connectChartExtensionProvider)(intlNext, editorActions, openConnectionsPanel, createAnalyticsEvent));
    extensionProvidersList.push((0, $1M1t5.referentialityExtensionProvider)({
        intl: intlNext,
        openConnectionsPanel: openConnectionsPanel,
        createAnalyticsEvent: createAnalyticsEvent
    }));
    if ((0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false)) extensionProvidersList.push((0, $iONqR.snippetExtensionProvider)(intlNext));
    extensionProvidersList.push((0, $aIqlA.getForgeExtensionHandler)({
        spaceKey: spaceKey,
        spaceId: spaceId,
        contentId: contentId,
        contentType: contentType,
        mentionProvider: mentionProvider,
        isEditing: true,
        connectExtensionProvider: confluenceMacroExtensionProviderForEditor,
        editorActions: editorActions,
        hideGlassPaneForForge: hideGlassPaneForForge,
        locale: intlNext.locale,
        isLivePage: !!isLivePage,
        editorAPI: editorAPI,
        useGetContextToken: $1JyKZ.useGetContextToken
    }));
    return extensionProvidersList;
});
const $f03f53a782506f81$var$_getExtensionRelatedProps = (0, $2XqLN.default)(({ cloudId: cloudId, contentId: contentId, contentType: contentType, editorActions: editorActions, createAnalyticsEvent: createAnalyticsEvent, mentionProvider: mentionProvider, spaceKey: spaceKey, spaceId: spaceId, openMacroBrowserToEditExistingMacro: // Props from ClassicEditorContext
openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration, setActiveModal: setActiveModal, openConnectionsPanel: openConnectionsPanel, openConfigPanel: openConfigPanel, openSmartButtonConfigPanel: openSmartButtonConfigPanel, closeActiveModal: closeActiveModal, getMigrationExtensionManifest: getMigrationExtensionManifest, extensionContextProvider: extensionContextProvider, intlNext: intlNext, featureFlagClient: featureFlagClient, subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange, onCompleteCallback: onCompleteCallback, analyticsContext: analyticsContext, isLivePage: isLivePage, allowCreateDatabaseExtension: allowCreateDatabaseExtension, allowDatabaseQuickInsert: allowDatabaseQuickInsert, allowCreateWhiteboardExtension: allowCreateWhiteboardExtension, flags: flags, aiOptInStatus: aiOptInStatus, editorAPI: editorAPI, setUpsellModalSource: setUpsellModalSource, hideGlassPaneForForge: hideGlassPaneForForge, isFullPageEditor: isFullPageEditor, allowLegacyMacros: allowLegacyMacros, allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions, isLivePagesFeatureEnabled: isLivePagesFeatureEnabled, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled })=>{
    const extensionProviders = $f03f53a782506f81$var$_getClassicEditorProviders({
        cloudId: cloudId,
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        spaceId: spaceId,
        editorActions: editorActions,
        createAnalyticsEvent: createAnalyticsEvent,
        mentionProvider: mentionProvider,
        intlNext: intlNext,
        featureFlagClient: featureFlagClient,
        openMacroBrowserToEditExistingMacro: openMacroBrowserToEditExistingMacro,
        openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration,
        setActiveModal: setActiveModal,
        openConnectionsPanel: openConnectionsPanel,
        openConfigPanel: openConfigPanel,
        openSmartButtonConfigPanel: openSmartButtonConfigPanel,
        closeActiveModal: closeActiveModal,
        getMigrationExtensionManifest: getMigrationExtensionManifest,
        extensionContextProvider: extensionContextProvider,
        subscribeDocChange: subscribeDocChange,
        unsubscribeDocChange: unsubscribeDocChange,
        onCompleteCallback: onCompleteCallback,
        analyticsContext: analyticsContext,
        isLivePage: isLivePage,
        allowCreateDatabaseExtension: allowCreateDatabaseExtension,
        allowDatabaseQuickInsert: allowDatabaseQuickInsert,
        allowCreateWhiteboardExtension: allowCreateWhiteboardExtension,
        flags: flags,
        aiOptInStatus: aiOptInStatus,
        editorAPI: editorAPI,
        setUpsellModalSource: setUpsellModalSource,
        hideGlassPaneForForge: hideGlassPaneForForge,
        isFullPageEditor: isFullPageEditor,
        allowLegacyMacros: allowLegacyMacros,
        allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions,
        isLivePagesFeatureEnabled: isLivePagesFeatureEnabled,
        isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled
    });
    const allowExtension = {
        allowBreakout: true,
        allowExtendFloatingToolbars: true
    };
    return {
        allowExtension: allowExtension,
        extensionProviders: extensionProviders
    };
});
const $f03f53a782506f81$export$d22e3badff9938a7 = ({ contentId: contentId, contentType: contentType, editorActions: editorActions, mentionProvider: mentionProvider, spaceKey: spaceKey, spaceId: spaceId, extensionContextProvider: extensionContextProvider, openConnectionsPanel: openConnectionsPanel, openConfigPanel: openConfigPanel, openSmartButtonConfigPanel: openSmartButtonConfigPanel, onCompleteCallback: onCompleteCallback, isLivePage: isLivePage, allowCreateDatabaseExtension: allowCreateDatabaseExtension, allowDatabaseQuickInsert: allowDatabaseQuickInsert, allowCreateWhiteboardExtension: allowCreateWhiteboardExtension, flags: flags, aiOptInStatus: aiOptInStatus, editorAPI: editorAPI, setUpsellModalSource: setUpsellModalSource, isFullPageEditor: isFullPageEditor = false, allowLegacyMacros: allowLegacyMacros = false, allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions = false, isLivePagesFeatureEnabled: isLivePagesFeatureEnabled, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled })=>{
    const { openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration, openMacroBrowserToEditExistingMacro: openMacroBrowserToEditExistingMacro, loadMacroBrowserResources: loadMacroBrowserResources, setActiveModal: setActiveModal, closeActiveModal: closeActiveModal, getMigrationExtensionManifest: getMigrationExtensionManifest, getExtensionHandlers: getExtensionHandlers, populateExtensionProviders: populateExtensionProviders } = (0, $42omo.useContext)((0, $giS6h.ClassicEditorContext));
    const { cloudId: cloudId, featureFlagClient: featureFlagClient } = (0, $bQm3c.useSessionData)();
    const shouldShowPremiumUpsell = (0, $2YtTU.usePremiumGate)();
    const intlNext = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // Trigger loading of macro browser resources
    (0, $42omo.useEffect)(()=>{
        if (loadMacroBrowserResources) loadMacroBrowserResources();
    }, [
        loadMacroBrowserResources
    ]);
    const { subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange } = (0, $3IZob.useDocChangeContext)();
    const analyticsContext = (0, $42omo.useContext)((0, $2xIMp.default));
    // TODO: Currently, Forge macros can only be non-bodied, but there's work
    // underway to allow for bodied macros. When that's complete, we'll need
    // to update this to be contingent on the macro type.
    const hideGlassPaneForForge = (0, $aQw7y.useShouldHideOverlay)('forge', false);
    const extensionOptions = (0, $42omo.useMemo)(()=>$f03f53a782506f81$var$_getExtensionRelatedProps({
            cloudId: cloudId,
            contentId: contentId,
            contentType: contentType,
            editorActions: editorActions,
            createAnalyticsEvent: createAnalyticsEvent,
            mentionProvider: mentionProvider,
            spaceKey: spaceKey,
            spaceId: spaceId,
            openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration,
            openMacroBrowserToEditExistingMacro: openMacroBrowserToEditExistingMacro,
            setActiveModal: setActiveModal,
            openConnectionsPanel: openConnectionsPanel,
            openConfigPanel: openConfigPanel,
            openSmartButtonConfigPanel: openSmartButtonConfigPanel,
            closeActiveModal: closeActiveModal,
            getMigrationExtensionManifest: getMigrationExtensionManifest,
            extensionContextProvider: extensionContextProvider,
            intlNext: intlNext,
            featureFlagClient: featureFlagClient,
            subscribeDocChange: subscribeDocChange,
            unsubscribeDocChange: unsubscribeDocChange,
            onCompleteCallback: onCompleteCallback,
            analyticsContext: analyticsContext,
            isLivePage: isLivePage,
            allowCreateDatabaseExtension: allowCreateDatabaseExtension,
            allowDatabaseQuickInsert: allowDatabaseQuickInsert,
            allowCreateWhiteboardExtension: allowCreateWhiteboardExtension,
            flags: flags,
            aiOptInStatus: aiOptInStatus,
            editorAPI: editorAPI,
            setUpsellModalSource: shouldShowPremiumUpsell ? setUpsellModalSource : undefined,
            hideGlassPaneForForge: hideGlassPaneForForge,
            isFullPageEditor: isFullPageEditor,
            allowLegacyMacros: allowLegacyMacros,
            allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions,
            isLivePagesFeatureEnabled: isLivePagesFeatureEnabled,
            isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentId,
        spaceKey,
        editorAPI,
        spaceId
    ]);
    return {
        extensionOptions: extensionOptions,
        rendererExtensionOptions: {
            getExtensionHandlers: getExtensionHandlers,
            populateExtensionProviders: populateExtensionProviders
        }
    };
};
module.exports["useExtensionOptions"] = $f03f53a782506f81$export$d22e3badff9938a7;

});

parcelRegister("9ZD6n", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $5x0y1 = parcelRequire("5x0y1");


var $kTtIX = parcelRequire("kTtIX");


var $dwj5l = parcelRequire("dwj5l");


async function $8264492e60b066c8$var$pickFromDropbox(appKey, canMountinIframe) {
    await (0, $kTtIX.default)(appKey);
    let popupMountPoint;
    // BC - as of 2020-01-21 this does not work, as no dropbox app we have is authorised
    // to iframe in the picker - we are currently waiting for permissions.
    // To test the picker, comment out the ReactDOM render call, and the `iframe` and `winowName` options
    if (canMountinIframe) {
        const Modal = await (parcelRequire("l4EvG"));
        // The decision has been made to simply append our modal to the body
        // Using the passed in popupMountPoint has the potential to cause
        // problems, and several users pass down document.body anyway
        //
        // We want to append it and attach it to a new div so we have complete control.
        popupMountPoint = document.getElementById((0, $dwj5l.POPUP_MOUNTPOINT));
        if (!popupMountPoint) {
            popupMountPoint = document.createElement('div');
            popupMountPoint.id = (0, $dwj5l.POPUP_MOUNTPOINT);
            document.body.appendChild(popupMountPoint);
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, $l998X.jsx)(Modal.default, {
            onClose: ()=>{}
        }), popupMountPoint);
    }
    let files;
    try {
        files = await new Promise((resolve, reject)=>{
            window.Dropbox.choose({
                iframe: canMountinIframe,
                windowName: canMountinIframe ? (0, $dwj5l.DROPBOX_IFRAME_NAME) : undefined,
                success: resolve,
                cancel: reject
            });
        });
    } catch (e) {
        if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(popupMountPoint);
        return;
    }
    let node;
    if (!files.length) {
        if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(popupMountPoint);
        return;
    }
    const newNodes = files.map((file)=>(0, $5x0y1.inlineCard)({
            url: file.link
        }));
    if (newNodes.length === 1) node = newNodes[0];
    else // NOTE: we are not currently passing in `multiselect`, so this is not a possible state,
    // but we likely want to allow multiselect in the future so doing some future-proofing
    node = {
        type: 'paragraph',
        content: newNodes
    };
    if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(popupMountPoint);
    return node;
}



const $8264492e60b066c8$var$manifestFunction = ({ appKey: appKey, canMountinIframe: canMountinIframe })=>({
        title: 'Dropbox',
        type: 'com.dropbox.fabric',
        key: 'dropbox',
        description: 'Embed Dropbox file to collaborate with your team',
        icons: {
            '16': ()=>(parcelRequire("oeyro")).then((mod)=>mod.default),
            '24': ()=>(parcelRequire("oeyro")).then((mod)=>mod.default),
            '48': ()=>(parcelRequire("oeyro")).then((mod)=>mod.default)
        },
        modules: {
            quickInsert: [
                {
                    key: 'item',
                    action: ()=>// eslint-disable-next-line no-async-promise-executor
                        new Promise(async (resolve, reject)=>{
                            try {
                                const newNode = await $8264492e60b066c8$var$pickFromDropbox(appKey, canMountinIframe);
                                if (!newNode) reject();
                                else resolve(newNode);
                            } catch (e) {
                                reject(e);
                            }
                        })
                }
            ]
        }
    });
var $8264492e60b066c8$export$2e2bcd8739ae039 = $8264492e60b066c8$var$manifestFunction;
module.exports["default"] = $8264492e60b066c8$export$2e2bcd8739ae039;

});

parcelRegister("5x0y1", function(module, exports) {
const $548cbc934d83dd4c$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });
module.exports["inlineCard"] = $548cbc934d83dd4c$export$cbf8224b64e0d942;

});

parcelRegister("kTtIX", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ba0b0705ccaf171$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line require-await

var $8ba0b0705ccaf171$export$2e2bcd8739ae039 = async (appKey)=>{
    if (!window.Dropbox) // The dropbox script is in no way typescript, and is not our code
    // It attached the `Dropbox` property to window.
    // @ts-ignore
    return (parcelRequire("6ENnI")).then(()=>{
        window.Dropbox.appKey = appKey;
    });
    else {
        window.Dropbox.appKey = appKey;
        return Promise.resolve();
    }
};

});

parcelRegister("6ENnI", function(module, exports) {

let $4d8cc89e711b5ba3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d8cc89e711b5ba3$var$load("9n0AM").then(()=>parcelRequire('12tqw'));

});

parcelRegister("dwj5l", function(module, exports) {
const $2db8f6b12db59ced$export$6a428e19cddf769b = 'twp-dropbox-popup-mount-point';
const $2db8f6b12db59ced$export$5719e9fb73d0a1be = 'twp-dropboxjs-iframe';
module.exports["POPUP_MOUNTPOINT"] = $2db8f6b12db59ced$export$6a428e19cddf769b;
module.exports["DROPBOX_IFRAME_NAME"] = $2db8f6b12db59ced$export$5719e9fb73d0a1be;

});

parcelRegister("l4EvG", function(module, exports) {

let $f579652900415be3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f579652900415be3$var$load("17JTB").then(()=>parcelRequire('3H9Ht'));

});

parcelRegister("oeyro", function(module, exports) {

let $048d8839b5559430$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $048d8839b5559430$var$load("cMAQT").then(()=>parcelRequire('fqMQg'));

});

parcelRegister("ke0mx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

parcelRequire("aqrhZ");
var $96msn = parcelRequire("96msn");
var $jyd5r = parcelRequire("jyd5r");


var $1e2E5 = parcelRequire("1e2E5");


var $jTxSS = parcelRequire("jTxSS");


var $bYRk6 = parcelRequire("bYRk6");


var $dh538 = parcelRequire("dh538");


var $d7ZU3 = parcelRequire("d7ZU3");


var $c6GJD = parcelRequire("c6GJD");


var $cYYWV = parcelRequire("cYYWV");


var $4XKEZ = parcelRequire("4XKEZ");


var $9pBtT = parcelRequire("9pBtT");

// as const so that values can be looked up for i18n in ./ui/messages/keywords
const $8b2ff5afb7b4d3e5$var$JIRA_KEYWORDS = [
    'create',
    'issue',
    'ticket',
    'raise',
    'new'
];
const $8b2ff5afb7b4d3e5$var$CONFLUENCE_KEYWORDS = [
    'create',
    'page',
    'new',
    'space',
    'publish'
];
// categories will put us into tabs in the quick insert browser (the plus menu)
const $8b2ff5afb7b4d3e5$var$JIRA_CATEGORIES = [
    'development',
    'external-content'
];
const $8b2ff5afb7b4d3e5$var$CONFLUENCE_CATEGORIES = [
    'confluence-content'
];



const $8b2ff5afb7b4d3e5$export$e538f94cc8cf4db8 = ({ intl: intl, intlLocale: intlLocale, defaultCloudId: defaultCloudId, analyticsContext: analyticsContext, location: location, gatewayBaseUrl: gatewayBaseUrl, flags: flags, defaultFormValues: defaultFormValues, pageContext: pageContext, allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed })=>{
    const formatMessage = (descriptor)=>{
        return intl?.formatMessage(descriptor) ?? descriptor.defaultMessage;
    };
    return {
        title: 'Link create editor extension',
        type: 'extension',
        key: 'com.atlassian.linking-platform.create',
        description: 'Configures quick insert commands for creating objects, like Jira issues and Confluence pages as links',
        icons: {
            '48': ()=>(parcelRequire("pKBxY")).then((mod)=>mod.default)
        },
        modules: {
            quickInsert: [
                {
                    key: 'linking-platform-create-jira-issue',
                    title: formatMessage((0, $dh538.fg)('jira-issue-terminology-update-m4') ? (0, $4XKEZ.jiraExtensionMessages).extensionTitleIssueTerminologyRefreshM4 : (0, $4XKEZ.jiraExtensionMessages).extensionTitle),
                    description: formatMessage((0, $dh538.fg)('jira-issue-terminology-update-m4') ? (0, $4XKEZ.jiraExtensionMessages).extensionDescriptionIssueTerminologyRefreshM4 : (0, $4XKEZ.jiraExtensionMessages).extensionDescription),
                    featured: true,
                    categories: $8b2ff5afb7b4d3e5$var$JIRA_CATEGORIES,
                    keywords: [
                        'jira',
                        ...$8b2ff5afb7b4d3e5$var$JIRA_KEYWORDS.map((keyword)=>formatMessage((0, $4XKEZ.keywords)[keyword]))
                    ],
                    icon: ()=>(parcelRequire("pKBxY")).then((mod)=>mod.default),
                    action: async ()=>$8b2ff5afb7b4d3e5$var$showCreateModal({
                            intl: intl,
                            intlLocale: intlLocale,
                            defaultCloudId: defaultCloudId,
                            analyticsContext: analyticsContext,
                            entityKey: 'jira-issue',
                            gatewayBaseUrl: gatewayBaseUrl,
                            location: location,
                            flags: flags,
                            defaultFormValues: defaultFormValues
                        })
                },
                {
                    key: 'linking-platform-create-confluence-page',
                    title: formatMessage((0, $4XKEZ.confluenceExtensionMessages).extensionTitle),
                    description: formatMessage((0, $4XKEZ.confluenceExtensionMessages).extensionDescription),
                    featured: true,
                    categories: $8b2ff5afb7b4d3e5$var$CONFLUENCE_CATEGORIES,
                    keywords: [
                        'confluence',
                        ...$8b2ff5afb7b4d3e5$var$CONFLUENCE_KEYWORDS.map((keyword)=>formatMessage((0, $4XKEZ.keywords)[keyword]))
                    ],
                    icon: ()=>(parcelRequire("jYvn2")).then((mod)=>mod.default),
                    action: async ()=>{
                        // Only do one step page creation if we are
                        // 1. in the full page editor
                        // 2. in a published page OR (on a live doc and enrolled in the experiment)
                        // 3. not in a blogpost
                        // 4. not using Safari
                        const shouldUseOneStepCreate = location === 'confluence-page' && pageContext?.isFullPageEditor && !pageContext?.isBlogpost && !(0, $d7ZU3.browser).safari;
                        if (shouldUseOneStepCreate) {
                            // Enable one step page creation on live pages if user is enrolled in the experiment
                            const isOneStepEnabledOnLivePage = pageContext?.isLivePage // Limit experiment exposure to users on a live page
                             ? (0, $c6GJD.default).getExperimentValue('confluence_live_docs_inline_create_page_one_step', 'isEnabled', false) : false;
                            if (!pageContext?.isLivePage || isOneStepEnabledOnLivePage) return $8b2ff5afb7b4d3e5$var$oneStepCreate({
                                intl: intl,
                                intlLocale: intlLocale,
                                defaultCloudId: defaultCloudId,
                                analyticsContext: analyticsContext,
                                gatewayBaseUrl: gatewayBaseUrl,
                                flags: flags,
                                defaultFormValues: defaultFormValues
                            });
                        }
                        return $8b2ff5afb7b4d3e5$var$showCreateModal({
                            intl: intl,
                            intlLocale: intlLocale,
                            defaultCloudId: defaultCloudId,
                            analyticsContext: analyticsContext,
                            entityKey: 'confluence-page',
                            gatewayBaseUrl: gatewayBaseUrl,
                            location: location,
                            flags: flags,
                            defaultFormValues: defaultFormValues,
                            allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed
                        });
                    }
                }
            ]
        }
    };
};
const $8b2ff5afb7b4d3e5$var$DEFAULT_LOCALE = 'en';
const $8b2ff5afb7b4d3e5$var$LINK_CREATE_REFERENCE_MOUNT_POINT_ID = 'link-create-mount-point';
const $8b2ff5afb7b4d3e5$var$getMountPoint = ()=>{
    let modalEl = document.getElementById(`${$8b2ff5afb7b4d3e5$var$LINK_CREATE_REFERENCE_MOUNT_POINT_ID}`);
    if (modalEl === null) {
        modalEl = document.createElement('div');
        modalEl.id = $8b2ff5afb7b4d3e5$var$LINK_CREATE_REFERENCE_MOUNT_POINT_ID;
        document.body.appendChild(modalEl);
    }
    return modalEl;
};
const $8b2ff5afb7b4d3e5$var$AnalyticsProviderWrapper = ({ children: children, value: value })=>{
    if (value === undefined) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cYYWV.LinkCreateModalProvider), {
        value: value,
        children: children
    });
};

const $8b2ff5afb7b4d3e5$var$LazyEditorExtensionLinkCreate = (0, $96msn.lazy)(()=>(parcelRequire("8aNIb")).then(({ EditorExtensionLinkCreate: EditorExtensionLinkCreate })=>({
            default: EditorExtensionLinkCreate
        })));

const $8b2ff5afb7b4d3e5$var$LazyOneStepLinkCreate = (0, $96msn.lazy)(()=>(parcelRequire("6Nkev")).then(({ OneStepLinkCreate: OneStepLinkCreate })=>({
            default: OneStepLinkCreate
        })));
/*
 * Rather than rendering a modal and requesting user input, this function
 * creates a new page and immediately inserts it without any user input.
 * The title is generated on the backend so the new page is just created
 * and inserted as a smartlink. This is part of the Confluence Inline Create
 * One Step experiment.
 */ const $8b2ff5afb7b4d3e5$var$oneStepCreate = ({ intl: intl, intlLocale: intlLocale, defaultCloudId: defaultCloudId, gatewayBaseUrl: gatewayBaseUrl, analyticsContext: analyticsContext, flags: flags, defaultFormValues: defaultFormValues })=>{
    return new Promise(async (res)=>{
        const mountPoint = $8b2ff5afb7b4d3e5$var$getMountPoint();
        const handleCreate = (payload)=>{
            res({
                type: 'inlineCard',
                attrs: {
                    url: payload.url
                }
            });
            // Open the draft in a new tab and show the success flag
            const parentId = defaultFormValues?.['confluence-page']?.parentId ?? '';
            window.name = parentId;
            // createdFrom param indicates to the new draft window to show a success flag on load
            const url = new URL(payload.linkToOpen ?? payload.url);
            url.searchParams.set('createdFrom', parentId);
            window.open(url, '_blank');
        };
        const handleComplete = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(mountPoint);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, $l998X.jsx)($8b2ff5afb7b4d3e5$var$AnalyticsProviderWrapper, {
            value: analyticsContext,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
                messages: intl?.messages ?? {},
                locale: intl?.locale ?? intlLocale ?? 'en',
                defaultLocale: $8b2ff5afb7b4d3e5$var$DEFAULT_LOCALE,
                onError: intl?.onError,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                    data: {
                        source: 'inlineCreateOneStep',
                        attributes: {
                            component: 'editorExtensionLinkCreate',
                            location: 'confluence-page',
                            triggeredFrom: 'quick-insert'
                        }
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9pBtT.ErrorBoundary), {
                        flags: flags,
                        onError: ()=>{
                            /**
             * If something goes wrong, resolve the promise to editor,
             * and unmount the component mountpoint
             */ res();
                            handleComplete();
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jyd5r.LazySuspense), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $l998X.jsx)($8b2ff5afb7b4d3e5$var$LazyOneStepLinkCreate, {
                                onCreate: handleCreate,
                                gatewayBaseUrl: gatewayBaseUrl,
                                defaultCloudId: defaultCloudId,
                                defaultFormValues: defaultFormValues
                            })
                        })
                    })
                })
            })
        }), mountPoint);
    });
};
const $8b2ff5afb7b4d3e5$var$showCreateModal = ({ intl: intl, intlLocale: intlLocale, defaultCloudId: defaultCloudId, entityKey: entityKey, gatewayBaseUrl: gatewayBaseUrl, location: location, analyticsContext: analyticsContext, flags: flags, defaultFormValues: defaultFormValues, allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed })=>new Promise(async (res)=>{
        const mountPoint = $8b2ff5afb7b4d3e5$var$getMountPoint();
        const handleCreate = (payload)=>{
            res({
                type: 'inlineCard',
                attrs: {
                    url: payload.url
                }
            });
        };
        const handleCancel = ()=>{
            res();
        };
        const handleCloseComplete = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(mountPoint);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, $l998X.jsx)($8b2ff5afb7b4d3e5$var$AnalyticsProviderWrapper, {
            value: analyticsContext,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
                messages: intl?.messages ?? {},
                locale: intl?.locale ?? intlLocale ?? 'en',
                defaultLocale: $8b2ff5afb7b4d3e5$var$DEFAULT_LOCALE,
                onError: intl?.onError,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                    data: {
                        attributes: {
                            component: 'editorExtensionLinkCreate',
                            location: location,
                            triggeredFrom: 'quick-insert'
                        }
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9pBtT.ErrorBoundary), {
                        flags: flags,
                        onError: ()=>{
                            /**
           * If something goes wrong, resolve the promise to editor,
           * and unmount the component mountpoint
           */ res();
                            handleCloseComplete();
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jyd5r.LazySuspense), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $l998X.jsx)($8b2ff5afb7b4d3e5$var$LazyEditorExtensionLinkCreate, {
                                defaultCloudId: defaultCloudId,
                                gatewayBaseUrl: gatewayBaseUrl,
                                defaultFormValues: defaultFormValues,
                                entityKey: entityKey,
                                onCreate: handleCreate,
                                onCancel: handleCancel,
                                onCloseComplete: handleCloseComplete,
                                flags: flags,
                                allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed
                            })
                        })
                    })
                })
            })
        }), mountPoint);
    });
module.exports["manifest"] = $8b2ff5afb7b4d3e5$export$e538f94cc8cf4db8;

});

parcelRegister("aqrhZ", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("96msn")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("96msn")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("96msn")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $lhchg = parcelRequire("lhchg");


var $96msn = parcelRequire("96msn");

parcelRequire("1BwGq");
var $jnAB4 = parcelRequire("jnAB4");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("eow39");
var $jyd5r = parcelRequire("jyd5r");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");


var $iYRNV = parcelRequire("iYRNV");


});

parcelRegister("8dgvm", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("dXZzO")).MODE);

var $dXZzO = parcelRequire("dXZzO");

const $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN = undefined;
const $5fac572772fbabda$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $5fac572772fbabda$var$DEFAULT_MODE = (0, $dXZzO.MODE).HYDRATE;
const $5fac572772fbabda$var$DEFAULT_RETRY = 2;
const $5fac572772fbabda$var$config = {
    crossOrigin: $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN,
    manifest: $5fac572772fbabda$var$DEFAULT_MANIFEST,
    mode: $5fac572772fbabda$var$DEFAULT_MODE,
    retry: $5fac572772fbabda$var$DEFAULT_RETRY
};
const $5fac572772fbabda$export$44487a86467333c3 = ()=>$5fac572772fbabda$var$config;
const $5fac572772fbabda$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $5fac572772fbabda$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN;
    $5fac572772fbabda$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $5fac572772fbabda$var$DEFAULT_MANIFEST;
    $5fac572772fbabda$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $5fac572772fbabda$var$DEFAULT_MODE;
    $5fac572772fbabda$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $5fac572772fbabda$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $5fac572772fbabda$export$44487a86467333c3;
module.exports["setConfig"] = $5fac572772fbabda$export$940a7873bb071df8;

});

parcelRegister("dXZzO", function(module, exports) {
const $a2b08cde192cf1ec$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $a2b08cde192cf1ec$export$e48589d9e4824227;

});

parcelRegister("lhchg", function(module, exports) {

var $89YVk = parcelRequire("89YVk");


var $8dgvm = parcelRequire("8dgvm");

parcelRequire("ecrVx");
var $4CMiD = parcelRequire("4CMiD");
var $6y0vU = parcelRequire("6y0vU");


var $27zaj = parcelRequire("27zaj");

const $f7d4b5876658b264$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $8dgvm.setConfig)(config);
        (0, $4CMiD.LISTENERS).length = 0;
        (0, $6y0vU.setCurrent)(0);
        if (!(0, $27zaj.isNodeEnvironment)()) (0, $89YVk.collect)();
    }
};

});

parcelRegister("89YVk", function(module, exports) {

var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");


var $8lfql = parcelRequire("8lfql");


var $3iPPT = parcelRequire("3iPPT");

const $5f0e6c234ea4c71a$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $8dgvm.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $dXZzO.MODE).RENDER ? (0, $8lfql.cloneElements)(markers[i], lazyBegin) : (0, $3iPPT.refElements)(markers[i], lazyBegin);
        if ((0, $euF6Z.COLLECTED).has(lazyBegin)) (0, $euF6Z.COLLECTED).get(lazyBegin).push(value);
        else (0, $euF6Z.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};
module.exports["collect"] = $5f0e6c234ea4c71a$export$bb44f104e3c54dae;

});

parcelRegister("euF6Z", function(module, exports) {
const $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $a8d3c1fdc5de2df2$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $a8d3c1fdc5de2df2$export$4831ef3968ea94ef;

});

parcelRegister("8lfql", function(module, exports) {
const $612c3fc5c2a28c4f$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};
module.exports["cloneElements"] = $612c3fc5c2a28c4f$export$c42217d53a7ebafb;

});

parcelRegister("3iPPT", function(module, exports) {
const $267b431587227d50$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};
module.exports["refElements"] = $267b431587227d50$export$c69443129766a7fc;

});

parcelRegister("ecrVx", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("6y0vU")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("6y0vU")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("4CMiD")).LISTENERS);

var $6y0vU = parcelRequire("6y0vU");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");


});

parcelRegister("6y0vU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $euF6Z = parcelRequire("euF6Z");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");

let $4c46510d73a23c1f$var$CURRENT_PHASE = (0, $euF6Z.PHASE).PAINT;
const $4c46510d73a23c1f$export$5f80f094fd31fffd = (phase)=>{
    $4c46510d73a23c1f$var$CURRENT_PHASE = phase;
    (0, $4CMiD.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $4c46510d73a23c1f$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: (0, $ilgZx.createSubscribe)((0, $4CMiD.LISTENERS)),
    currentValue: ()=>$4c46510d73a23c1f$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).PAINT)
    }
});
const $4c46510d73a23c1f$export$1dc361b277327f88 = ()=>{
    const v = (0, $42omo.useContext)($4c46510d73a23c1f$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $4c46510d73a23c1f$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $4c46510d73a23c1f$export$5a25eca35e5debcb;
module.exports["useLazyPhase"] = $4c46510d73a23c1f$export$1dc361b277327f88;

});

parcelRegister("4CMiD", function(module, exports) {
const $35e02d56e6163baa$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $35e02d56e6163baa$export$81b9c458a026d68f;

});

parcelRegister("ilgZx", function(module, exports) {
const $d5a75e5021e4308a$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $d5a75e5021e4308a$export$364097d812234b3f;

});

parcelRegister("27zaj", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("7zmsS")).default);

var $7zmsS = parcelRequire("7zmsS");

const $18b7834f7092bd86$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $18b7834f7092bd86$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $18b7834f7092bd86$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $18b7834f7092bd86$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $18b7834f7092bd86$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $18b7834f7092bd86$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $18b7834f7092bd86$export$283635c04a02cc36;
module.exports["attrToProp"] = $18b7834f7092bd86$export$62bf630d0de3d781;

});

parcelRegister("7zmsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $582d3a4d2ad75f69$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $582d3a4d2ad75f69$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("96msn", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");


var $27zaj = parcelRequire("27zaj");
var $7zmsS = parcelRequire("7zmsS");


var $k001K = parcelRequire("k001K");


var $1r9rN = parcelRequire("1r9rN");


var $2niqO = parcelRequire("2niqO");


var $aAlyb = parcelRequire("aAlyb");


var $1C3RC = parcelRequire("1C3RC");


var $1Bcgq = parcelRequire("1Bcgq");


var $fLvpO = parcelRequire("fLvpO");

function $6a061803acf54fcf$var$_extends() {
    $6a061803acf54fcf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a061803acf54fcf$var$_extends.apply(this, arguments);
}
function $6a061803acf54fcf$var$lazyProxy(_loader, { defer: defer = (0, $euF6Z.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $27zaj.isNodeEnvironment)();
    const dataLazyId = (0, $7zmsS.default)(moduleId);
    const LazyInternal = isServer ? (0, $2niqO.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $1r9rN.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $aAlyb.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $8dgvm.getConfig)();
                return (0, $1Bcgq.retry)(_loader, {
                    delay: (0, $k001K.RETRY_DELAY),
                    factor: (0, $k001K.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $27zaj.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $8dgvm.getConfig)();
        return (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $euF6Z.PHASE).PAINT ? (0, $k001K.PRIORITY).HIGH : (0, $k001K.PRIORITY).LOW;
        return (0, $1C3RC.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6a061803acf54fcf$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $euF6Z.PHASE).LAZY
    }
};
function $6a061803acf54fcf$export$c952e5f94576010e(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6a061803acf54fcf$export$291dd592399bdafa(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6a061803acf54fcf$export$488013bae63b21da(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6a061803acf54fcf$export$c952e5f94576010e;
module.exports["lazyAfterPaint"] = $6a061803acf54fcf$export$291dd592399bdafa;
module.exports["lazy"] = $6a061803acf54fcf$export$488013bae63b21da;

});

parcelRegister("aQIfl", function(module, exports) {
const $0209d2ec05e7d0da$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $0209d2ec05e7d0da$export$303f43e55cf1ef2f;

});

parcelRegister("k001K", function(module, exports) {
const $e8f3d428f2749473$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $e8f3d428f2749473$export$a339266ad71b2447 = 300;
const $e8f3d428f2749473$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $e8f3d428f2749473$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $e8f3d428f2749473$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $e8f3d428f2749473$export$ba64c908e55507fe;

});

parcelRegister("1r9rN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("1BwGq");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $k001K = parcelRequire("k001K");


var $fLvpO = parcelRequire("fLvpO");


var $8VyCG = parcelRequire("8VyCG");


var $femay = parcelRequire("femay");


var $1C3RC = parcelRequire("1C3RC");


var $iYRNV = parcelRequire("iYRNV");


var $36I1o = parcelRequire("36I1o");

function $10bfa415480e5081$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $42omo.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $42omo.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $42omo.useContext)((0, $iYRNV.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $fLvpO.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $36I1o.useSubscription)({
            context: (0, $9uVEz.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $euF6Z.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $36I1o.useSubscription)({
                context: (0, $6y0vU.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $42omo.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $1C3RC.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $k001K.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        (0, $42omo.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $euF6Z.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $8dgvm.getConfig)().mode === (0, $dXZzO.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8VyCG.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $femay.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ResolvedLazy, props);
    };
}
module.exports["createComponentClient"] = $10bfa415480e5081$export$6898b5504b58699a;

});

parcelRegister("1BwGq", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("9uVEz")).WaitContext);

var $9uVEz = parcelRequire("9uVEz");


var $jnAB4 = parcelRequire("jnAB4");


});

parcelRegister("9uVEz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jLShN = parcelRequire("jLShN");

const $6ea3a326e6c1ad89$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: ()=>(0, $jLShN.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $6ea3a326e6c1ad89$export$9ba3fe09d15de47b;

});

parcelRegister("jLShN", function(module, exports) {
const $e64c8432c5ffa90e$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $e64c8432c5ffa90e$export$276c7dbda7675aec;

});

parcelRegister("jnAB4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9uVEz = parcelRequire("9uVEz");

const $e1bc8db03d394dff$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $42omo.useContext)((0, $9uVEz.WaitContext));
    const value = (0, $42omo.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $42omo.useRef)(new Set());
    const api = (0, $42omo.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $42omo.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9uVEz.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("eow39", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("h5RZ7")).LazySuspenseContext);

var $jyd5r = parcelRequire("jyd5r");


var $h5RZ7 = parcelRequire("h5RZ7");


});

parcelRegister("jyd5r", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");


var $h5RZ7 = parcelRequire("h5RZ7");

class $e3bb580fd9a2f323$export$256c542058532d6f extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $27zaj.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $42omo.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $e3bb580fd9a2f323$export$256c542058532d6f;

});

parcelRegister("h5RZ7", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c71cc793aab4db4d$export$c33990e84065970c = /*#__PURE__*/ (0, $42omo.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $c71cc793aab4db4d$export$c33990e84065970c;

});

parcelRegister("fLvpO", function(module, exports) {
const $b7a39d38ff5e8305$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $b7a39d38ff5e8305$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$b7a39d38ff5e8305$export$6aa69c1258005366]: true
    });
    return error;
};
const $b7a39d38ff5e8305$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($b7a39d38ff5e8305$export$6aa69c1258005366);
module.exports["createLoaderError"] = $b7a39d38ff5e8305$export$c73a6a6f0bf7d425;

});

parcelRegister("8VyCG", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $67fe80fcd34326f0$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $67fe80fcd34326f0$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $42omo.useRef)(null);
    const { current: ssrDomNodes } = (0, $42omo.useRef)(content || []);
    (0, $42omo.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($67fe80fcd34326f0$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $67fe80fcd34326f0$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $67fe80fcd34326f0$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $67fe80fcd34326f0$export$d55db778a3e1446b;

});

parcelRegister("femay", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");

function $b1695c2d5acdcbdf$var$_extends() {
    $b1695c2d5acdcbdf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b1695c2d5acdcbdf$var$_extends.apply(this, arguments);
}
const $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $27zaj.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $42omo.createElement)((0, $42omo.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), $b1695c2d5acdcbdf$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};
module.exports["PlaceholderFallbackHydrate"] = $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4;

});

parcelRegister("1C3RC", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");


var $27zaj = parcelRequire("27zaj");


var $k001K = parcelRequire("k001K");


var $1J5yR = parcelRequire("1J5yR");


var $iYRNV = parcelRequire("iYRNV");

function $12cc564e7e862135$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $8dgvm.getConfig)();
    const assets = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $1J5yR.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $12cc564e7e862135$var$fakePromise = {
    then: ()=>$12cc564e7e862135$var$fakePromise,
    catch: ()=>$12cc564e7e862135$var$fakePromise,
    finally: ()=>$12cc564e7e862135$var$fakePromise
};
function $12cc564e7e862135$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $1J5yR.insertLinkTag)(href, rel));
        return $12cc564e7e862135$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $12cc564e7e862135$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $jLShN.noopCleanup;
}
function $12cc564e7e862135$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $27zaj.isNodeEnvironment)()) return 0, $jLShN.noopCleanup;
    (_GlobalReactLooselyLa = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $k001K.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $12cc564e7e862135$export$3af04dbcb01bad4d,
        $12cc564e7e862135$export$1046fd6a49d5e7a,
        $12cc564e7e862135$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $jLShN.noopCleanup;
}
module.exports["preloadAsset"] = $12cc564e7e862135$export$25bad4aa00c45355;

});

parcelRegister("1J5yR", function(module, exports) {

var $iYRNV = parcelRequire("iYRNV");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");

function $141e4ec3ad408220$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $jLShN.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $8dgvm.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $141e4ec3ad408220$export$6610512821c8a4ce;

});

parcelRegister("iYRNV", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dd1790f807a46380$export$e2d53c0cbedd2710 = {
    current: null
};
const $dd1790f807a46380$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $42omo.createContext)($dd1790f807a46380$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $dd1790f807a46380$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $dd1790f807a46380$export$8146ab57a3f7a7cb;

});

parcelRegister("36I1o", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $2434146821c65301$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $42omo.useContext)(context);
    (0, $42omo.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $2434146821c65301$export$368b4214baeb914c;

});

parcelRegister("2niqO", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $27zaj = parcelRequire("27zaj");


var $fLvpO = parcelRequire("fLvpO");

function $1bac06d947c9671a$var$load(moduleId, loader) {
    try {
        return (0, $27zaj.getExport)(loader());
    } catch (err) {
        throw (0, $fLvpO.createLoaderError)(err);
    }
}
function $1bac06d947c9671a$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $1bac06d947c9671a$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $8dgvm.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $euF6Z.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("link", {
                key: url,
                rel: defer === (0, $euF6Z.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
module.exports["createComponentServer"] = $1bac06d947c9671a$export$eb2e4b04351cdd9e;

});

parcelRegister("aAlyb", function(module, exports) {
const $7b4dfb9d7bf38586$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};
module.exports["createDeferred"] = $7b4dfb9d7bf38586$export$e673efccd97e4223;

});

parcelRegister("1Bcgq", function(module, exports) {
const $12a2c288067cec34$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $12a2c288067cec34$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $12a2c288067cec34$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $12a2c288067cec34$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $12a2c288067cec34$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $12a2c288067cec34$var$calculateDelay(context, policy);
        if (delay) await $12a2c288067cec34$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $12a2c288067cec34$export$9369b12211e1fce4;

});

parcelRegister("cYYWV", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $2xIMp = parcelRequire("2xIMp");

const $71e94db7c7ca5154$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
class $71e94db7c7ca5154$export$9e8ad10df3086be2 extends (0, $42omo.Component) {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2xIMp.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
    constructor(props){
        super(props);
        this.contextValue = void 0;
        this.getChildContext = ()=>{
            return this.contextValue;
        };
        const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext, getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers } = this.props.value;
        this.contextValue = {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }
}
$71e94db7c7ca5154$export$9e8ad10df3086be2.contextTypes = $71e94db7c7ca5154$var$ContextTypes;
$71e94db7c7ca5154$export$9e8ad10df3086be2.childContextTypes = $71e94db7c7ca5154$var$ContextTypes;
module.exports["LinkCreateModalProvider"] = $71e94db7c7ca5154$export$9e8ad10df3086be2;

});

parcelRegister("4XKEZ", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $822de4fa2e7d82c6$export$eebaaf2b24d91f63 = (0, $cgtv4.defineMessages)({
    create: {
        id: "editorExtensionLinkCreate.keyword.create",
        defaultMessage: "create"
    },
    issue: {
        id: "editorExtensionLinkCreate.keyword.issue",
        defaultMessage: "work item"
    },
    ticket: {
        id: "editorExtensionLinkCreate.keyword.ticket",
        defaultMessage: "ticket"
    },
    raise: {
        id: "editorExtensionLinkCreate.keyword.raise",
        defaultMessage: "raise"
    },
    new: {
        id: "editorExtensionLinkCreate.keyword.new",
        defaultMessage: "new"
    },
    space: {
        id: "editorExtensionLinkCreate.keyword.space",
        defaultMessage: "space"
    },
    publish: {
        id: "editorExtensionLinkCreate.keyword.publish",
        defaultMessage: "publish"
    },
    page: {
        id: "editorExtensionLinkCreate.keyword.page",
        defaultMessage: "page"
    }
});
const $822de4fa2e7d82c6$export$1578873c8519570a = (0, $cgtv4.defineMessages)({
    extensionTitle: {
        id: "editorExtensionLinkCreate.jiraIssue.quickInsert.title",
        defaultMessage: "Create Jira issue"
    },
    extensionTitleIssueTerminologyRefreshM4: {
        id: "editorExtensionLinkCreate.jiraIssue.quickInsert.title-issue-terminology-refresh-m4",
        defaultMessage: "Create Jira work item"
    },
    extensionDescription: {
        id: "editorExtensionLinkCreate.jiraIssue.quickInsert.description",
        defaultMessage: "Create an issue inline and insert the issue as a link"
    },
    extensionDescriptionIssueTerminologyRefreshM4: {
        id: "editorExtensionLinkCreate.jiraIssue.quickInsert.description-issue-terminology-refresh-m4",
        defaultMessage: "Create a work item inline and insert the work item as a link"
    }
});
const $822de4fa2e7d82c6$export$5d64ddc7566152fc = (0, $cgtv4.defineMessages)({
    extensionTitle: {
        id: "editorExtensionLinkCreate.confluencePage.quickInsert.title",
        defaultMessage: "Create Confluence page"
    },
    extensionDescription: {
        id: "editorExtensionLinkCreate.confluencePage.quickInsert.description",
        defaultMessage: "Create a new page and insert it as a link"
    }
});
const $822de4fa2e7d82c6$export$52fbd4579940dbd3 = (0, $cgtv4.defineMessages)({
    title: {
        id: "editorExtensionLinkCreate.jiraIssue.title",
        defaultMessage: "Create new issue"
    },
    titleIssueTerminologyRefreshM4: {
        id: "editorExtensionLinkCreate.jiraIssue.title-issue-terminology-refresh-m4",
        defaultMessage: "Create new work item"
    },
    successFlagTitle: {
        id: "editorExtensionLinkCreate.jiraIssue.successFlag.title",
        defaultMessage: "Issue created"
    },
    successFlagTitleIssueTerminologyRefreshM4: {
        id: "editorExtensionLinkCreate.jiraIssue.successFlag.title-issue-terminology-refresh-m4",
        defaultMessage: "Work item created"
    },
    successFlagDescription: {
        id: "editorExtensionLinkCreate.jiraIssue.successFlag.description",
        defaultMessage: "Your issue has been created"
    },
    successFlagDescriptionIssueTerminologyRefreshM4: {
        id: "editorExtensionLinkCreate.jiraIssue.successFlag.description-issue-terminology-refresh-m4",
        defaultMessage: "Your work item has been created"
    },
    successFlagActionOpen: {
        id: "editorExtensionLinkCreate.jiraIssue.successFlag.action.open",
        defaultMessage: "Open in Jira"
    }
});
const $822de4fa2e7d82c6$export$87a972c4338ba7c0 = (0, $cgtv4.defineMessages)({
    title: {
        id: "editorExtensionLinkCreate.confluencePage.title",
        defaultMessage: "Create new page"
    },
    newDraftTitle: {
        id: "editorExtensionLinkCreate.confluencePage.newDraftTitle",
        defaultMessage: "Untitled page"
    },
    successFlagTitle: {
        id: "editorExtensionLinkCreate.confluencePage.successFlag.title",
        defaultMessage: "Page created"
    },
    successFlagDescription: {
        id: "editorExtensionLinkCreate.confluencePage.successFlag.description",
        defaultMessage: "Your page has been created"
    },
    successFlagActionOpen: {
        id: "editorExtensionLinkCreate.confluencePage.successFlag.action.open",
        defaultMessage: "Open in Confluence"
    }
});
module.exports["keywords"] = $822de4fa2e7d82c6$export$eebaaf2b24d91f63;
module.exports["jiraExtensionMessages"] = $822de4fa2e7d82c6$export$1578873c8519570a;
module.exports["confluenceExtensionMessages"] = $822de4fa2e7d82c6$export$5d64ddc7566152fc;
module.exports["jiraIssueMessages"] = $822de4fa2e7d82c6$export$52fbd4579940dbd3;
module.exports["confluencePageMessages"] = $822de4fa2e7d82c6$export$87a972c4338ba7c0;

});

parcelRegister("9pBtT", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $hdKel = parcelRequire("hdKel");


var $ebpq7 = parcelRequire("ebpq7");


var $krp7k = parcelRequire("krp7k");


var $eZpnB = parcelRequire("eZpnB");

const $8d3a3fbbacd63515$var$NullFallback = ()=>null;
const $8d3a3fbbacd63515$var$getErrorType = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $8d3a3fbbacd63515$export$e926676385687eaf = ({ flags: flags, children: children, onError: onError })=>{
    const { fireEvent: fireEvent } = (0, $ebpq7.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $krp7k.BaseErrorBoundary), {
        errorComponent: /*#__PURE__*/ (0, $l998X.jsx)($8d3a3fbbacd63515$var$NullFallback, {}),
        onError: (error)=>{
            // Capture exception to Sentry
            if (error instanceof Error) (0, $hdKel.captureException)(error, 'editor-extension-link-create');
            flags?.showFailure?.({
                title: intl.formatMessage((0, $eZpnB.messages).title),
                description: intl.formatMessage((0, $eZpnB.messages).description)
            });
            fireEvent('operational.editorExtensionLinkCreateExperience.failed', {
                errorType: $8d3a3fbbacd63515$var$getErrorType(error)
            });
            onError?.();
        },
        children: children
    });
};
module.exports["ErrorBoundary"] = $8d3a3fbbacd63515$export$e926676385687eaf;

});

parcelRegister("hdKel", function(module, exports) {
const $98cbbeecc3c59dff$export$f5282963edea4a68 = async (_error, _packageName, _tags)=>{
    // Re-introduce in EDM-9682
    return;
};
module.exports["captureException"] = $98cbbeecc3c59dff$export$f5282963edea4a68;

});

parcelRegister("ebpq7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::ec329f21e6a5f943251e1d4a495988fb>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen editor-extension-link-create
 */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $gw7I8 = parcelRequire("gw7I8");


var $d5rV1 = parcelRequire("d5rV1");

const $76d4605a9bf2a846$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEvent = (0, $42omo.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $d5rV1.default)(...params));
        event.fire((0, $gw7I8.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $76d4605a9bf2a846$export$5bf35293e545f20c;

});

parcelRegister("gw7I8", function(module, exports) {
const $0e4ab8979da74ddc$export$3f072f06b90c3985 = 'media';
module.exports["EVENT_CHANNEL"] = $0e4ab8979da74ddc$export$3f072f06b90c3985;

});

parcelRegister("d5rV1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::34a5c56e53d2f2c68cac8363edc2b0d0>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen editor-extension-link-create
 */ const $06f66ac78f70af1b$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $06f66ac78f70af1b$export$2e2bcd8739ae039 = $06f66ac78f70af1b$var$createEventPayload;
module.exports["default"] = $06f66ac78f70af1b$export$2e2bcd8739ae039;

});

parcelRegister("krp7k", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $d96537c513bf058f$export$688779ac61ee945f extends (0, $42omo.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, errorComponent: errorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && errorComponent) return errorComponent;
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $d96537c513bf058f$export$688779ac61ee945f;

});

parcelRegister("eZpnB", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $6e0f7e34e90ca9be$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    title: {
        id: "editorExtensionLinkCreate.genericError.title",
        defaultMessage: "Something went wrong"
    },
    description: {
        id: "editorExtensionLinkCreate.genericError.description",
        defaultMessage: "Refresh the page and try again."
    }
});
module.exports["messages"] = $6e0f7e34e90ca9be$export$defe85febe8b728c;

});

parcelRegister("pKBxY", function(module, exports) {

let $04d67c9dc5f31a45$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $04d67c9dc5f31a45$var$load("6wr18"),
    $04d67c9dc5f31a45$var$load("ffEVr"),
    $04d67c9dc5f31a45$var$load("hXu5I")
]).then(()=>parcelRequire('hlE0H'));

});

parcelRegister("jYvn2", function(module, exports) {

let $e8abf46fd73e409c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e8abf46fd73e409c$var$load("8JZKd"),
    $e8abf46fd73e409c$var$load("7lyIx")
]).then(()=>parcelRequire('4XWss'));

});

parcelRegister("8aNIb", function(module, exports) {

let $5f35d197a56ed1b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5f35d197a56ed1b4$var$load("5EQhG"),
    $5f35d197a56ed1b4$var$load("6wr18"),
    $5f35d197a56ed1b4$var$load("ffEVr"),
    $5f35d197a56ed1b4$var$load("kjZZD"),
    $5f35d197a56ed1b4$var$load("a0oMZ")
]).then(()=>parcelRequire('BkPha'));

});

parcelRegister("6Nkev", function(module, exports) {

let $4f270384a97e916a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f270384a97e916a$var$load("ja1FH").then(()=>parcelRequire('cDh22'));

});

parcelRegister("7PHx9", function(module, exports) {

var $bre0g = parcelRequire("bre0g");


var $fPsyy = parcelRequire("fPsyy");


var $1M1t5 = parcelRequire("1M1t5");


var $872OF = parcelRequire("872OF");

const $d6233c6a28189b9d$export$7e6e8089e041148 = async (intl, editorActions, openConnectionsPanel, createAnalyticsEvent)=>{
    return new (0, $bre0g.default)([
        await (0, $fPsyy.createChartsExtension)({
            intl: intl,
            editorActions: editorActions,
            createAnalyticsEvent: createAnalyticsEvent,
            externalToolbarItems: openConnectionsPanel ? [
                (0, $1M1t5.getConnectionsToolbarItem)({
                    intl: intl,
                    openConnectionsPanel: openConnectionsPanel,
                    fireAnalytics: (adf)=>(0, $872OF.fireAnalyticsEventForConnectionsButton)(createAnalyticsEvent, adf)
                })
            ] : []
        })
    ]);
};
module.exports["connectChartExtensionProvider"] = $d6233c6a28189b9d$export$7e6e8089e041148;

});

parcelRegister("1M1t5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $bre0g = parcelRequire("bre0g");


var $7O0l1 = parcelRequire("7O0l1");


var $3IXUB = parcelRequire("3IXUB");


var $8pcS0 = parcelRequire("8pcS0");


var $872OF = parcelRequire("872OF");

const $8f8eb5112d081276$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    toolbarItemLabel: {
        id: "app-referentiality.provider.toolbar.item.label",
        defaultMessage: "Manage connected data"
    }
});
const $8f8eb5112d081276$export$1b65aa3790d4a1ee = ({ intl: intl, openConnectionsPanel: openConnectionsPanel, fireAnalytics: fireAnalytics })=>({
        key: 'connections',
        label: intl.formatMessage($8f8eb5112d081276$export$a7357cdd1f0b0168.toolbarItemLabel),
        display: 'icon',
        tooltip: intl.formatMessage($8f8eb5112d081276$export$a7357cdd1f0b0168.toolbarItemLabel),
        icon: ()=>{
            return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7O0l1))), {
                    spacing: "spacious",
                    label: intl.formatMessage($8f8eb5112d081276$export$a7357cdd1f0b0168.toolbarItemLabel)
                });
        },
        action: async (adf)=>{
            const localId = adf.attrs?.localId;
            if (localId) {
                openConnectionsPanel(localId);
                fireAnalytics(adf);
            }
        }
    });
const $8f8eb5112d081276$var$getTableContextualToolbar = ({ intl: intl, openConnectionsPanel: openConnectionsPanel, createAnalyticsEvent: createAnalyticsEvent })=>({
        context: {
            type: 'node',
            nodeType: 'table'
        },
        toolbarItems: [
            $8f8eb5112d081276$export$1b65aa3790d4a1ee({
                intl: intl,
                openConnectionsPanel: openConnectionsPanel,
                fireAnalytics: (adf)=>(0, $872OF.fireAnalyticsEventForConnectionsButton)(createAnalyticsEvent, adf)
            })
        ]
    });
const $8f8eb5112d081276$var$getConnectContextualToolbars = async ({ intl: intl, openConnectionsPanel: openConnectionsPanel, createAnalyticsEvent: createAnalyticsEvent })=>{
    const allMacros = await (0, $3IXUB.getMacroMetaData)();
    // All macros support referentiality
    const allMacrosWithRefDataSchema = allMacros.filter((macro)=>macro.pluginKey === 'com.atlassian.plugins.atlassian-connect-plugin' && (macro.refDataSchema?.inputType || macro.refDataSchema?.outputType));
    return allMacrosWithRefDataSchema.reduce((acc, macro)=>{
        const context = {
            type: 'extension',
            nodeType: 'extension',
            extensionKey: macro.macroName,
            extensionType: (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE
        };
        return [
            ...acc,
            {
                context: context,
                toolbarItems: [
                    $8f8eb5112d081276$export$1b65aa3790d4a1ee({
                        intl: intl,
                        openConnectionsPanel: openConnectionsPanel,
                        fireAnalytics: (adf)=>(0, $872OF.fireAnalyticsEventForConnectionsButton)(createAnalyticsEvent, adf)
                    })
                ]
            }
        ];
    }, []);
};

const $8f8eb5112d081276$export$43c4531a8498e016 = async ({ intl: intl, openConnectionsPanel: openConnectionsPanel = ()=>null, createAnalyticsEvent: createAnalyticsEvent })=>{
    return new (0, $bre0g.default)([
        {
            title: 'Referentiality',
            type: 'com.atlassian.confluence.referentiality',
            key: 'referentiality',
            icons: {
                '48': ()=>Promise.resolve((parcelRequire("jdPfT")))
            },
            modules: {
                contextualToolbars: [
                    $8f8eb5112d081276$var$getTableContextualToolbar({
                        intl: intl,
                        openConnectionsPanel: openConnectionsPanel,
                        createAnalyticsEvent: createAnalyticsEvent
                    }),
                    ...await $8f8eb5112d081276$var$getConnectContextualToolbars({
                        intl: intl,
                        openConnectionsPanel: openConnectionsPanel,
                        createAnalyticsEvent: createAnalyticsEvent
                    })
                ]
            }
        }
    ]);
};
module.exports["getConnectionsToolbarItem"] = $8f8eb5112d081276$export$1b65aa3790d4a1ee;
module.exports["referentialityExtensionProvider"] = $8f8eb5112d081276$export$43c4531a8498e016;

});

parcelRegister("3IXUB", function(module, exports) {

var $8eAX8 = parcelRequire("8eAX8");


var $6OgRG = parcelRequire("6OgRG");


var $l21Jh = parcelRequire("l21Jh");

const $a3d4cd842e4cfa1b$var$loadMacroMetadata = (0, $8eAX8.createMetadataLoader)();
function $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4(browserConfig) {
    return (0, $l21Jh.autoConvert)($a3d4cd842e4cfa1b$export$82582a527779c20, browserConfig);
}
const $a3d4cd842e4cfa1b$export$82582a527779c20 = async ()=>{
    const macros = await $a3d4cd842e4cfa1b$var$loadMacroMetadata();
    const isAllowed = (0, $6OgRG.isAllowedWithFeatureFlags)();
    return macros.filter((macroMetadata)=>{
        if (macroMetadata.hidden) return false;
        return isAllowed(macroMetadata);
    });
};
module.exports["getAutoConverter"] = $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4;
module.exports["getMacroMetaData"] = $a3d4cd842e4cfa1b$export$82582a527779c20;

});

parcelRegister("8eAX8", function(module, exports) {

var $k5ycH = parcelRequire("k5ycH");


var $cpjd2 = parcelRequire("cpjd2");


var $8n9tL = parcelRequire("8n9tL");


var $64KID = parcelRequire("64KID");


var $9wGTI = parcelRequire("9wGTI");


var $9fLxI = parcelRequire("9fLxI");

const $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES = [
    'wr!com.atlassian.confluence.plugins.confluence-view-file-macro:view-file-macro-resources'
];
const $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES = [
    'wr!confluence.web.resources:view-content',
    'wr!confluence.macros.advanced:get-more'
];
const $d0091e97ce884599$export$1d71148f13231a96 = ()=>[
        // transitional and implicit dependencies
        'wrc!com.atlassian.confluence.extra.team-calendars:amd',
        'wrc!com.atlassian.confluence.extra.team-calendars:user-timezone-setup',
        // editor context
        'wrc!com.atlassian.confluence.extra.team-calendars:calendar-init-editor',
        // macro-browser (not loaded by macro browser for some reason)
        'wrc!com.atlassian.confluence.extra.team-calendars:macro-browser-web-resources'
    ];
function $d0091e97ce884599$export$c3c980ae518bc695(webresources, macroRenderedOutputFromSSR, macroOutput, callback, scriptContainer, unavailableCallback) {
    let deps = [], jsTags;
    if (macroRenderedOutputFromSSR || macroOutput) deps = [
        ...$d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES
    ];
    else {
        if (!webresources) return Promise.resolve();
        jsTags = webresources?.tags?.js ?? null;
        const contexts = !jsTags || !scriptContainer ? webresources.contexts && webresources.contexts.map((context)=>`wrc!${context}`) || [] : [];
        const keys = !jsTags || !scriptContainer ? webresources.keys && webresources.keys.map((key)=>`wr!${key}`) || [] : [];
        deps = [
            ...$d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES,
            ...contexts,
            ...keys
        ];
        if ((0, $9wGTI.fg)('pgxp_connect_macro_inline_image_bugfix')) deps.push(...$d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES);
    }
    return new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)(deps, ()=>{
            // Callback
            if (callback) callback();
            if (scriptContainer && jsTags) (0, $k5ycH.loadResources)(scriptContainer, jsTags).then(resolve);
            else resolve();
        }, ()=>{
            // Unavailable Callback
            // eslint-disable-next-line no-console
            console.error(`Cannot loadMacroWebResources: ${deps}`);
            if (unavailableCallback) unavailableCallback();
        });
    });
}
function $d0091e97ce884599$export$a144665563142e() {
    let macrosMetadataCache = null;
    const macrosMetadataSpaceAwareCache = {};
    return async function metadataLoader() {
        const spaceKey = $d0091e97ce884599$var$getSpaceKey();
        if (spaceKey) {
            if (!macrosMetadataSpaceAwareCache[spaceKey]) macrosMetadataSpaceAwareCache[spaceKey] = $d0091e97ce884599$var$fetchMacroMetadata(spaceKey);
            return macrosMetadataSpaceAwareCache[spaceKey];
        }
        if (!macrosMetadataCache) macrosMetadataCache = $d0091e97ce884599$var$fetchMacroMetadata();
        return macrosMetadataCache;
    };
}
function $d0091e97ce884599$var$getSpaceKey() {
    const pageUrl = window.location.toString();
    const match = (0, $8n9tL.findAndMatchRoute)((0, $64KID.namedRoutes), pageUrl);
    // There's a race condition when the space key is not yet available in AJS upon
    // calling metadataLoader, therefore we fallback to the space key in the URL.
    return window.AJS?.Meta?.get('space-key') || match?.params?.spaceKey;
}
function $d0091e97ce884599$var$fetchMacroMetadata(spaceKey) {
    return (0, $9fLxI.getExtensionManifest)({
        spaceKey: spaceKey
    }).then((manifest)=>{
        const macros = manifest?.macros || [];
        return macros;
    });
}
module.exports["teamCalendarWRM"] = $d0091e97ce884599$export$1d71148f13231a96;
module.exports["loadMacroWebResources"] = $d0091e97ce884599$export$c3c980ae518bc695;
module.exports["createMetadataLoader"] = $d0091e97ce884599$export$a144665563142e;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$ed215fd77db898ec(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToScriptTags"] = $372ebd682f0fb003$export$ed215fd77db898ec;

});

parcelRegister("9fLxI", function(module, exports) {
async function $2552b7855153149c$export$573ee875a39e7e73({ spaceKey: spaceKey } = {
    spaceKey: undefined
}) {
    if (spaceKey) {
        var _window;
        const extensionManifestSpaceaware = (_window = window).__EXTENSION_MANIFEST_SPACEAWARE__ || (_window.__EXTENSION_MANIFEST_SPACEAWARE__ = {});
        if (!extensionManifestSpaceaware[spaceKey]) extensionManifestSpaceaware[spaceKey] = $2552b7855153149c$var$fetchExtensionManifests(spaceKey);
        return extensionManifestSpaceaware[spaceKey];
    }
    if (!window.__EXTENSION_MANIFEST__) window.__EXTENSION_MANIFEST__ = $2552b7855153149c$var$fetchExtensionManifests();
    return window.__EXTENSION_MANIFEST__;
}
function $2552b7855153149c$var$fetchExtensionManifests(spaceKey) {
    // eslint-disable-next-line check-credentials-option/has-credentials-option,no-restricted-syntax
    return fetch(`/wiki/plugins/macrobrowser/browse-macros.action?detailed=true&origin=extension-provider${spaceKey ? `&spaceKey=${spaceKey}` : ''}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json());
}
module.exports["getExtensionManifest"] = $2552b7855153149c$export$573ee875a39e7e73;

});

parcelRegister("6OgRG", function(module, exports) {
// This blocklist should reflect what is in https://pug.jira-dev.com/wiki/spaces/AEC/pages/3239608672/Macro+blocklist so if you want to add or remove something, please remember to update the page.
const $38fb99c52e3447fe$var$blocklist = {
    align: true,
    bgcolor: true,
    center: true,
    cheese: true,
    clickable: true,
    code: true,
    colgroup: true,
    column: true,
    'content-by-user': true,
    copyright: true,
    'create-space-button': true,
    div: true,
    expand: true,
    'fancy-bullets': true,
    'google-drive-docs': true,
    'google-drive-sheets': true,
    'google-drive-slides': true,
    favpages: true,
    'gadget-b7a6531b1c147f2e175f1209bed5c0ad': true,
    'gadget-01c2ed272e88f7333da124a03a481477': true,
    'gadget-d2450e06a9a285cf57eedb2d502d9d65b964eb847382938b6c57809bac2261bb': true,
    'global-reports': true,
    highlight: true,
    htmlcomment: true,
    im: true,
    img: true,
    info: true,
    junitreport: true,
    li: true,
    loremipsum: true,
    lozenge: true,
    multimedia: true,
    navmap: true,
    network: true,
    noformat: true,
    note: true,
    ol: true,
    OneDrive: true,
    p: true,
    panel: true,
    pre: true,
    'privacy-policy': true,
    'privacy-mark': true,
    'recently-used-labels': true,
    'reg-tm': true,
    rollover: true,
    roundrect: true,
    search: true,
    section: true,
    sm: true,
    'space-attachments': true,
    'space-details': true,
    span: true,
    status: true,
    strike: true,
    style: true,
    table: true,
    tbody: true,
    td: true,
    th: true,
    thead: true,
    tr: true,
    'trello-board': true,
    'trello-card': true,
    tip: true,
    tm: true,
    ul: true,
    warning: true
};
function $38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, blocklistOverrides = {}) {
    const key = macroMetadata.alternateId || (macroMetadata.id ? macroMetadata.id.replace('macro-', '') : macroMetadata.macroName);
    return blocklistOverrides.hasOwnProperty(key) ? blocklistOverrides[key] : Boolean($38fb99c52e3447fe$var$blocklist[key]);
}
function $38fb99c52e3447fe$export$1dba5c5d55fad37f() {
    const overrides = {};
    return (macroMetadata)=>!$38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, overrides);
}
async function $38fb99c52e3447fe$export$f38acf7431de7e2b(macroBrowser) {
    const originalList = [
        ...macroBrowser.metadataList
    ];
    // Currently no FF info is needed to create the blocklist but if it was, need to pass featureFlagClient to isAllowedWithFeatureFlags()
    const isAllowed = $38fb99c52e3447fe$export$1dba5c5d55fad37f();
    macroBrowser.metadataList = macroBrowser.metadataList.filter(isAllowed);
    /**
	 * Bring blocklisted items back so they show up elsewhere
	 */ return function restore() {
        macroBrowser.metadataList = originalList;
    };
}
module.exports["isAllowedWithFeatureFlags"] = $38fb99c52e3447fe$export$1dba5c5d55fad37f;
module.exports["applyBlocklist"] = $38fb99c52e3447fe$export$f38acf7431de7e2b;

});

parcelRegister("l21Jh", function(module, exports) {

var $3CRZ9 = parcelRequire("3CRZ9");


var $8PZXE = parcelRequire("8PZXE");

const $159df558ca333321$var$noop = ()=>null;
const $159df558ca333321$export$65b04260b3a15835 = async (loadMacroMetadata, browserConfig)=>{
    const { contentId: contentId } = browserConfig;
    if (!contentId) return $159df558ca333321$var$noop;
    const [jiraAutoConvert, connectAddonAutoConvert] = await Promise.all([
        (0, $3CRZ9.createJiraConverter)(contentId),
        (0, $8PZXE.createConnectAddonConverter)(loadMacroMetadata, contentId)
    ]);
    return (link)=>jiraAutoConvert(link) || connectAddonAutoConvert(link);
};
module.exports["autoConvert"] = $159df558ca333321$export$65b04260b3a15835;

});

parcelRegister("3CRZ9", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $6g1oe = parcelRequire("6g1oe");


var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

function $3fcae9e87e9104a7$var$convertLink(link, defaultJiraMacroAttributes) {
    const noop = ()=>{};
    const legacyHandler = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).require('confluence/jim/editor-plugins/jira-paste-link');
    // jira paste handler needs object in this format
    const uri = {
        source: link
    };
    const jimPasteHandlerResult = legacyHandler.pasteHandler(uri, null, noop);
    if (!jimPasteHandlerResult || !jimPasteHandlerResult.params) return null;
    /**
	 * use JSON.parse , JSON.stringify to deeply clone object, avoid any reference
	 */ const macroAttributes = JSON.parse(JSON.stringify(defaultJiraMacroAttributes));
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    macroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(jimPasteHandlerResult.params);
    return macroAttributes;
}
async function $3fcae9e87e9104a7$export$2264c7423a8e6d34(contentId) {
    const placeholderMacro = {
        macroDefinition: {
            name: 'jira'
        },
        contentId: contentId
    };
    // fetch ADF structure of JIM, and modify it to provide to editor later
    const jiraADFNode = await (0, $foRF9.fetchMacroAttributes)(placeholderMacro);
    return (link)=>$3fcae9e87e9104a7$var$convertLink(link, jiraADFNode);
}
module.exports["createJiraConverter"] = $3fcae9e87e9104a7$export$2264c7423a8e6d34;

});

parcelRegister("foRF9", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $aoRTi = parcelRequire("aoRTi");


var $8pcS0 = parcelRequire("8pcS0");


var $fgbpl = parcelRequire("fgbpl");


var $aMlgD = parcelRequire("aMlgD");


var $6mEZ3 = parcelRequire("6mEZ3");

const $5faed47790e8728c$var$isBlueprint = (contentId)=>!/^[0-9]+$/.test(contentId);
const $5faed47790e8728c$export$359c6f7177354dc2 = // eslint-disable-next-line graphql-relay-compat/no-experimental-directives, graphql-relay-compat/consistent-graphql-operation-naming -- Read https://go/connie-relay-migration-fyi
(0, $eSUdr.default)`query MacroPlaceholderADFQuery($contentId:ID!$macroDefinition:String!)@experimental{experimentalMacroPlaceholderADF(contentId:$contentId macroDefinition:$macroDefinition){json}}`;
const $5faed47790e8728c$export$74ec65bf601b5f8c = async (options)=>{
    const { macroDefinition: macroDefinition, contentId: contentId, selectedMacro: selectedMacro, intl: intl, isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = options;
    const experimentalMacroPlaceholderADFArgs = {
        variables: {
            contentId: $5faed47790e8728c$var$isBlueprint(contentId) ? '0' : contentId ?? '0',
            macroDefinition: JSON.stringify(macroDefinition)
        }
    };
    const results = await (0, $aoRTi.experimentalMacroPlaceholderADFQuery)(experimentalMacroPlaceholderADFArgs);
    let placeholderAdf;
    try {
        if (results?.data) placeholderAdf = JSON.parse(results?.data?.experimentalMacroPlaceholderADF?.json);
    } catch  {
        // eslint-disable-next-line no-console
        console.error('Error getting placeholder ADF');
    }
    const adf = {
        ...placeholderAdf
    };
    if ((0, $fgbpl.isBodiedExtension)(adf.type)) {
        if (selectedMacro) // Copy the macro contents into the adf node
        adf.content = selectedMacro.content;
        else if (!adf.content || adf.content.length === 0) {
            if (adf.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.EMPTY_ADF_CONTENT);
            if (adf.type === (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.MULTI_BODIED_INITIAL_CONTENT);
        }
    }
    const macroAttributes = (0, $6mEZ3.formatAsMacroAttributes)(adf);
    if (intl) {
        const macroTitleOverride = (0, $aMlgD.getMacroTitleOverride)(macroDefinition.name, intl, isLivePagesFeatureEnabled);
        if (macroTitleOverride && macroAttributes.attrs.parameters?.macroMetadata) macroAttributes.attrs.parameters.macroMetadata.title = macroTitleOverride;
    }
    return macroAttributes;
};
module.exports["fetchMacroAttributes"] = $5faed47790e8728c$export$74ec65bf601b5f8c;

});

parcelRegister("aoRTi", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

const $fef05c831d419c6c$export$145bdd0c11f23103 = async ({ variables: variables })=>{
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: '/wiki/rest/internal/1.0/macro/placeholder',
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: JSON.stringify({
            macro: JSON.parse(variables.macroDefinition),
            contentId: variables.contentId
        }),
        parseResponseOnError: (error)=>{
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) return {
                __badStatusError: true
            };
            throw error;
        },
        parseResult: (json)=>{
            if (json && typeof json === 'object' && '__badStatusError' in json) return {
                experimentalMacroPlaceholderADF: {
                    json: ''
                }
            };
            return {
                experimentalMacroPlaceholderADF: {
                    json: JSON.stringify(json)
                }
            };
        },
        variables: variables
    });
    return {
        data: result.data
    };
};
module.exports["experimentalMacroPlaceholderADFQuery"] = $fef05c831d419c6c$export$145bdd0c11f23103;

});

parcelRegister("iS5Ay", function(module, exports) {

var $4HDYO = parcelRequire("4HDYO");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("7ji4X", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $1P1Tu.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $9zUhf.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $9zUhf.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("8pcS0", function(module, exports) {
const $6863c3b6124eda1d$export$2400baf28368a887 = {
    TEMPLATE: 'com.atlassian.confluence.template',
    MACRO_CORE: 'com.atlassian.confluence.macro.core',
    MIGRATION: 'com.atlassian.confluence.migration',
    // used for all macros that use Extension API and require references to be rendered
    MACRO_WITH_REFERENCES: 'com.atlassian.confluence.macro.with.references'
};
const $6863c3b6124eda1d$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $6863c3b6124eda1d$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $6863c3b6124eda1d$export$84b772adeaf6b683 = 'extension';
const $6863c3b6124eda1d$export$5da07912b4c30471 = 'inlineExtension';
const $6863c3b6124eda1d$export$2af94dcd5e74e23b = 'bodiedExtension';
const $6863c3b6124eda1d$export$43b3eb119fc177ea = 'multiBodiedExtension';
const $6863c3b6124eda1d$export$6e997645168087e1 = [
    {
        content: [],
        type: 'paragraph'
    }
];
const $6863c3b6124eda1d$export$87be616c9ded92ee = [
    {
        type: 'extensionFrame',
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    }
];
const $6863c3b6124eda1d$export$f9804d409e73a2cd = {
    TEMPLATE: 'variable',
    INLINE_EXTERNAL_IMAGE: 'inline-external-image',
    INLINE_MEDIA_IMAGE: 'inline-media-image',
    PRIVACY_MARK: 'privacy-mark',
    ANCHOR: 'anchor',
    PANEL: 'panel',
    SECTION: 'section',
    CHEESE: 'cheese',
    COLUMN: 'column',
    CONTENT_BY_LABEL: 'contentbylabel',
    CONTENT_BY_USER: 'content-by-user',
    CREATE_SPACE_BUTTON: 'create-space-button',
    FAVORITE_PAGES: 'favpages',
    GLOBAL_REPORTS: 'global-reports',
    IM_PRESENCE: 'im',
    LOREMIPSUM: 'loremipsum',
    NAVIGATION_MAP: 'navmap',
    PAGE_TREE: 'pagetree',
    RECENTLY_UPDATED: 'recently-updated',
    RECENTLY_USED_LABELS: 'recently-used-labels',
    SEARCH: 'search',
    SPACE_DETAILS: 'space-details',
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__',
    REDACTED_MACRO_PLACEHOLDER: 'redactedMacroPlaceholder',
    TOC: 'toc',
    LIVE_SEARCH: 'livesearch',
    CREATE_FROM_TEMPLATE: 'create-from-template',
    CONFLUENCE_DATABASES: 'database-extension',
    DETAILS: 'details',
    DETAILS_SUMMARY: 'detailssummary',
    EXPAND: 'expand',
    EXCERPT: 'excerpt',
    EXCERPT_INCLUDE: 'excerpt-include',
    CHILDREN: 'children',
    PROFILE_PICTURE: 'profile-picture',
    PROFILE: 'profile',
    INCLUDE: 'include',
    LEGACY_CONTENT: 'legacy-content'
};
const $6863c3b6124eda1d$export$52ab8a936196819e = [
    'toc',
    'expand',
    'trello-board',
    'status',
    'jiraroadmap'
];
const $6863c3b6124eda1d$export$ab3b6d629a99a505 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TOC,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ANCHOR,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIVE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXPAND,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CREATE_FROM_TEMPLATE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.REDACTED_MACRO_PLACEHOLDER,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONFLUENCE_DATABASES,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE_PICTURE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE
];
const $6863c3b6124eda1d$export$77fa9372f916e938 = new Set([
    $6863c3b6124eda1d$export$84b772adeaf6b683,
    $6863c3b6124eda1d$export$5da07912b4c30471,
    $6863c3b6124eda1d$export$2af94dcd5e74e23b
]);
const $6863c3b6124eda1d$export$12c3fa6b8a339bbd = 255;
const $6863c3b6124eda1d$export$3b4caad8695d985a = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED
];
const $6863c3b6124eda1d$export$b700e56f703b191 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY
];
module.exports["EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2400baf28368a887;
module.exports["MIGRATION_EXTENSION_KEYS"] = $6863c3b6124eda1d$export$8e1715e14eb19dce;
module.exports["REGULAR_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$84b772adeaf6b683;
module.exports["INLINE_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$5da07912b4c30471;
module.exports["BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2af94dcd5e74e23b;
module.exports["MULTI_BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$43b3eb119fc177ea;
module.exports["EMPTY_ADF_CONTENT"] = $6863c3b6124eda1d$export$6e997645168087e1;
module.exports["MULTI_BODIED_INITIAL_CONTENT"] = $6863c3b6124eda1d$export$87be616c9ded92ee;
module.exports["EXTENSION_KEY"] = $6863c3b6124eda1d$export$f9804d409e73a2cd;
module.exports["allowedMacrosForInsertMenu"] = $6863c3b6124eda1d$export$52ab8a936196819e;
module.exports["serverRenderedExtensions"] = $6863c3b6124eda1d$export$ab3b6d629a99a505;
module.exports["supportedExtensions"] = $6863c3b6124eda1d$export$77fa9372f916e938;
module.exports["MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH"] = $6863c3b6124eda1d$export$12c3fa6b8a339bbd;
module.exports["MODERENIZED_MACRO_KEYS"] = $6863c3b6124eda1d$export$3b4caad8695d985a;
module.exports["MACROS_WITH_LIVE_DOC_REFERENCE"] = $6863c3b6124eda1d$export$b700e56f703b191;

});

parcelRegister("fgbpl", function(module, exports) {

var $8pcS0 = parcelRequire("8pcS0");

const $aba988feb2cb54c3$export$b05e83f63451e97 = (extensionType)=>{
    return [
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)
    ].indexOf(extensionType) >= 0;
};
module.exports["isBodiedExtension"] = $aba988feb2cb54c3$export$b05e83f63451e97;

});

parcelRegister("aMlgD", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");


var $8pcS0 = parcelRequire("8pcS0");

const $123431e233f03ed6$var$i18n = (0, $cgtv4.defineMessages)({
    anchorMacroTitle: {
        id: "fabric-extension-lib.anchor.title",
        defaultMessage: "Anchor link"
    },
    anchorMacroDescription: {
        id: "fabric-extension-lib.anchor.description",
        defaultMessage: "Create a link to anywhere"
    },
    childrenMacroTitle: {
        id: "fabric-extension-lib.children.live-docs.title",
        defaultMessage: "Child items (Child pages)"
    },
    childrenMacroDescription: {
        id: "fabric-extension-lib.children.live-docs.description",
        defaultMessage: "Display a custom list of content nested under a page or live doc."
    },
    detailsMacroTitle: {
        id: "fabric-extension-lib.details.live-docs.title",
        defaultMessage: "Content properties (Page properties)"
    },
    detailsMacroDescription: {
        id: "fabric-extension-lib.details.live-docs.description",
        defaultMessage: "Enter a table of summary information in this macro and display it on another page or live doc using a content properties report macro. You will need to add a label to this content and specify it in the report macro."
    },
    pageTreeMacroTitle: {
        id: "fabric-extension-lib.pagetree.live-docs.title",
        defaultMessage: "Content tree (Page tree)"
    },
    pageTreeMacroDescription: {
        id: "fabric-extension-lib.pagetree.live-docs.description",
        defaultMessage: "Display a full or partial content tree."
    },
    includeMacroTitle: {
        id: "fabric-extension-lib.include.live-docs.title",
        defaultMessage: "Include content (Include page)"
    },
    includeMacroDescription: {
        id: "fabric-extension-lib.include.live-docs.description",
        defaultMessage: "Display the full contents of a page or live doc."
    },
    detailsSummaryMacroTitle: {
        id: "fabric-extension-lib.details-summary.live-docs.title",
        defaultMessage: "Content properties report (Page properties report)"
    },
    detailsSummaryMacroDescription: {
        id: "fabric-extension-lib.details-summary.live-docs.description",
        defaultMessage: "Display a table of pages and live docs that contain a content properties macro and a specific label. The table includes a link to each item and the summary from the macro on that page or doc."
    }
});
const $123431e233f03ed6$export$f37635a5fac054ef = (extensionKey, intl, isLivePagesFeatureEnabled)=>{
    // Override new macro title for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroTitle);
    if (isLivePagesFeatureEnabled && (0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroTitle);
    }
    return null;
};
const $123431e233f03ed6$export$d82ae1b0fd434097 = (extensionKey, intl, isLivePagesFeatureEnabled)=>{
    // Override new macro title and description for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroDescription);
    // PGXT-7617 Update macro strings referencing page content types to also include live docs content types
    if (isLivePagesFeatureEnabled && (0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroDescription);
    }
    return null;
};
module.exports["getMacroTitleOverride"] = $123431e233f03ed6$export$f37635a5fac054ef;
module.exports["getMacroDescriptionOverride"] = $123431e233f03ed6$export$d82ae1b0fd434097;

});

parcelRegister("6mEZ3", function(module, exports) {

var $aMlgD = parcelRequire("aMlgD");


var $8pcS0 = parcelRequire("8pcS0");


var $juS6m = parcelRequire("juS6m");

function $b31b733ebe52245a$export$d80a64b0df71385c(params) {
    if (params.hasOwnProperty('')) return $b31b733ebe52245a$var$getParamValue(params['']) || '';
    return '';
}
function $b31b733ebe52245a$export$1d258479ae5735d7(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (value !== '') curr[key] = value;
        return curr;
    }, {});
}
function $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (key !== '' || value !== '') curr[key] = {
            value: value
        };
        return curr;
    }, {});
}
// does every key have a value key inside?
function $b31b733ebe52245a$var$getParamValue(macroParam) {
    if (macroParam?.hasOwnProperty('value')) return macroParam.value;
    return macroParam;
}
function $b31b733ebe52245a$export$a113856a79fa82ca(node) {
    const { type: type, content: content, attrs: attrs, fragmentLocalId: fragmentLocalId, ...rest } = node;
    // There is a discrepancy in docs and implementation of different parts of the code
    // https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/pull-requests/30727/overview?commentId=4917242
    const fieldWithMacroParameters = Boolean(attrs?.parameters) ? attrs : rest;
    const { macroParams: macroParams } = fieldWithMacroParameters?.parameters || {};
    const adf = {
        attrs: fieldWithMacroParameters,
        type: type
    };
    if (fragmentLocalId) adf.marks = [
        {
            attrs: {
                localId: fragmentLocalId,
                name: null
            },
            type: 'fragment'
        }
    ];
    // confluence needs to be updated to get rid of bodyType as per
    // https://product-fabric.atlassian.net/wiki/spaces/E/pages/252351342/Splitting+Extension+node+into+three+nodes
    // but for now, the beackend requires it to be sent
    adf.attrs.bodyType = 'none';
    if (type === 'bodiedExtension') {
        adf.content = content && content.length > 0 ? content : [];
        adf.attrs.bodyType = 'rich';
    }
    const keys = Object.keys(adf.attrs);
    keys.forEach((key)=>{
        if (adf.attrs[key] === undefined || adf.attrs[key] === null) delete adf.attrs[key];
    });
    adf.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return adf;
}
function $b31b733ebe52245a$export$f700a29bb3cb52bb(node) {
    const { attrs: attrs, content: content, type: type } = node;
    const { macroParams: macroParams } = attrs.parameters;
    // MacroAttributes and ADNode are pretty much the same type, but
    // MacroAttributes requires either "extension", "bodiedExtension", "multiBodiedExtension" or
    // "inlineExtension". This check is so we can pass the ADNode as a
    // MacroAttributes, but will default to "extension" if given an unexpected
    // value.
    let extensionType = (0, $8pcS0.REGULAR_EXTENSION_TYPE);
    if ([
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE),
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.INLINE_EXTENSION_TYPE)
    ].indexOf(type) >= 0) extensionType = type;
    const macroAttributes = {
        type: extensionType,
        attrs: attrs
    };
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    if (content) macroAttributes.content = content;
    macroAttributes.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return macroAttributes;
}
async function $b31b733ebe52245a$export$9ebfba63bbffe824(from, to, body, contentIdContext) {
    const queryData = await (0, $juS6m.experimentalContentBodyConvertQuery)(from, to, body, contentIdContext);
    return queryData.experimentalContentBodyConvert?.value;
}
async function $b31b733ebe52245a$export$4f223f6f161fb687(node, intl, isLivePagesFeatureEnabled) {
    const legacyMacro = await $b31b733ebe52245a$export$dc6dc202968f1e29(node);
    legacyMacro.title = node.attrs?.parameters?.macroMetadata?.title;
    if (intl) {
        const description = (0, $aMlgD.getMacroDescriptionOverride)(node.attrs.extensionKey, intl, isLivePagesFeatureEnabled);
        if (description) legacyMacro.description = description;
    }
    return legacyMacro;
}
async function $b31b733ebe52245a$export$dc6dc202968f1e29(node) {
    // just return the node if it's already in legacy format;
    if (node.hasOwnProperty('name') && !node.hasOwnProperty('attrs')) return Promise.resolve(node);
    const adNode = node;
    const { attrs: attrs } = adNode;
    const { extensionKey: extensionKey, parameters: parameters } = attrs || {
        extensionKey: null,
        parameters: {
            macroParams: {},
            macroMetadata: {
                schemaVersion: null
            }
        }
    };
    const { macroParams: macroParams, macroMetadata: macroMetadata } = parameters;
    const type = node.type;
    const name = extensionKey || '';
    const params = $b31b733ebe52245a$export$1d258479ae5735d7(macroParams || {});
    const defaultParameterValue = $b31b733ebe52245a$export$d80a64b0df71385c(macroParams || {});
    const schemaVersion = macroMetadata && macroMetadata.schemaVersion || '1';
    if (!adNode.content || adNode.content.length === 0) return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: ''
    };
    const responseBody = await $b31b733ebe52245a$export$9ebfba63bbffe824('atlas_doc_format', 'storage', JSON.stringify({
        type: 'doc',
        content: adNode.content,
        version: 1
    }));
    return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: responseBody || ''
    };
}
function $b31b733ebe52245a$export$9ca244251d53bbfc(node) {
    const parameters = {
        ...node?.parameters?.macroParams || {}
    };
    if (parameters.__bodyContent) delete parameters.__bodyContent;
    // CEMS-300: To provide a consistent parameter to macro vendors for
    // both the Tiny and Fabric editors, we unwrap the parameter values
    return JSON.stringify($b31b733ebe52245a$export$1d258479ae5735d7(parameters));
}
module.exports["getDefaultParamValue"] = $b31b733ebe52245a$export$d80a64b0df71385c;
module.exports["unwrapMacroParams"] = $b31b733ebe52245a$export$1d258479ae5735d7;
module.exports["wrapMacroParams"] = $b31b733ebe52245a$export$80a8efbe6e0eac1d;
module.exports["extensionToADF"] = $b31b733ebe52245a$export$a113856a79fa82ca;
module.exports["formatAsMacroAttributes"] = $b31b733ebe52245a$export$f700a29bb3cb52bb;
module.exports["convertBody"] = $b31b733ebe52245a$export$9ebfba63bbffe824;
module.exports["formatAsLegacyMacroWithOverrides"] = $b31b733ebe52245a$export$4f223f6f161fb687;
module.exports["getParametersString"] = $b31b733ebe52245a$export$9ca244251d53bbfc;

});

parcelRegister("juS6m", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");

const $3a3d352db800a7ae$export$4cf4dd4c5ab7075b = async (from, to, body, contentIdContext)=>{
    const variables = {
        from: from,
        to: to,
        body: body,
        contentIdContext: contentIdContext
    };
    const requestBody = {
        representation: from,
        value: body
    };
    const params = new URLSearchParams();
    if (contentIdContext) params.append('contentIdContext', contentIdContext);
    const queryString = params.toString();
    const queryParams = queryString ? `?${queryString}` : '';
    const url = `/wiki/rest/api/contentbody/convert/${to}${queryParams}`;
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: url,
        method: 'POST',
        body: JSON.stringify(requestBody),
        credentials: 'include',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnSuccess: async (response)=>{
            if (response.ok && response.status === 200) return response.json();
            throw response;
        },
        parseResponseOnError: (error)=>{
            throw new Error(`Conversion HTTP error, status = ${error.status}, message = "${error.statusText}"`);
        },
        parseResult: (response)=>({
                experimentalContentBodyConvert: {
                    value: response.value
                }
            }),
        variables: variables
    });
    return result.data;
};
module.exports["experimentalContentBodyConvertQuery"] = $3a3d352db800a7ae$export$4cf4dd4c5ab7075b;

});

parcelRegister("8PZXE", function(module, exports) {

var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

/*
This script adds autoconvert handlers to the confluence editor.

It executes on editor initialisation, registering the handlers defined in the original add-on descriptors of whatever
add-ons are installed. Each one is associated with a particular macro (although a macro can be associated with many
handlers.

On pattern match, the each handler will be asked if they match and will be processed by the first matching handler.
The macro object is then created, using the matched uri and the information already existing in the JS context, and
the macro is inserted into the editor.
*/ const $44631a970962135a$var$TRELLO_MACRO_NAME = 'trello-card';
const $44631a970962135a$var$escapePattern = (str)=>{
    return str.replace(/[\-\[\]\/\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
};
const $44631a970962135a$var$replaceAll = (find, replace, str)=>{
    return str.replace(new RegExp(find, 'g'), replace);
};
const $44631a970962135a$var$convertPatternToRegex = (pattern)=>{
    // Consolidate any double up wildcards
    while(pattern.indexOf('{}{}') !== -1)pattern = pattern.replace('{}{}', '{}');
    // build a regex from the defined autoconvert pattern
    pattern = $44631a970962135a$var$escapePattern(pattern);
    pattern = $44631a970962135a$var$replaceAll('{}', '[^/]*?', pattern);
    // eslint-disable-next-line prefer-template
    pattern = '^' + pattern + '$';
    return pattern;
};
const $44631a970962135a$var$isPatternSafe = (pattern)=>{
    const patternBlockList = [
        'http://',
        'https://',
        'http://{}',
        'https://{}',
        'http://{}.{}',
        'https://{}.{}',
        'http://{}.{}.{}',
        'https://{}.{}.{}'
    ];
    // check the url pattern is not banned
    return patternBlockList.every((bannedPattern)=>bannedPattern !== pattern);
};
const $44631a970962135a$var$hasAutoconvertData = (macro)=>{
    return macro.autoconvertData && macro.autoconvertData.urlParameter && macro.autoconvertData.patterns;
};
const $44631a970962135a$var$getADFNodeForMacros = async (macros, contentId)=>{
    const macroAttributesArray = await Promise.all(Array.from(macros).map((macroName)=>(0, $foRF9.fetchMacroAttributes)({
            macroDefinition: {
                name: macroName
            },
            contentId: contentId
        })));
    return macroAttributesArray.reduce((accu, macroAttributes)=>{
        accu[macroAttributes.attrs.extensionKey] = macroAttributes;
        return accu;
    }, {});
};
const $44631a970962135a$var$convertLink = (link, autoconvertDefs, macroAttributesMap)=>{
    const matchedAcd = autoconvertDefs.find((acd)=>{
        return !!link.match(acd.matcher);
    });
    if (matchedAcd) {
        const { macroName: macroName, urlParameter: urlParameter } = matchedAcd;
        const params = {};
        params[urlParameter] = link;
        const macroAttributes = macroAttributesMap[macroName];
        const convertedMacroAttributes = JSON.parse(JSON.stringify(macroAttributes));
        convertedMacroAttributes.attrs.text = `${urlParameter} = ${link}`;
        convertedMacroAttributes.attrs.extensionKey = macroName;
        if (!convertedMacroAttributes.attrs.parameters) convertedMacroAttributes.attrs.parameters = {};
        convertedMacroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(params);
        return convertedMacroAttributes;
    } else return null;
};
async function $44631a970962135a$export$13c25ccf87e8cca2(loadMacroMetadata, contentId) {
    const autoconvertDefs = [];
    const macros = await loadMacroMetadata();
    // this object contains name of macros which have correct autoconvertData
    const filteredMacros = new Set();
    macros.forEach((macro)=>{
        if (// Don't convert any new Trello links to Trello macro due to new Trello smart links
        !$44631a970962135a$var$hasAutoconvertData(macro) || macro.macroName === $44631a970962135a$var$TRELLO_MACRO_NAME) return;
        // only macro with autoconvertData can be converted
        macro.autoconvertData.patterns.forEach((pattern)=>{
            if ($44631a970962135a$var$isPatternSafe(pattern)) {
                const acd = {
                    macroName: macro.macroName,
                    urlParameter: macro.autoconvertData.urlParameter,
                    matcher: $44631a970962135a$var$convertPatternToRegex(pattern)
                };
                filteredMacros.add(acd.macroName);
                autoconvertDefs.push(acd);
            }
        });
    });
    const macroAttributes = await $44631a970962135a$var$getADFNodeForMacros(filteredMacros, contentId);
    return (link)=>$44631a970962135a$var$convertLink(link, autoconvertDefs, macroAttributes);
}
module.exports["createConnectAddonConverter"] = $44631a970962135a$export$13c25ccf87e8cca2;

});

parcelRegister("872OF", function(module, exports) {

var $9fBoq = parcelRequire("9fBoq");


var $8pcS0 = parcelRequire("8pcS0");

const $6089ca8d25fc98f0$var$fireAnalyticsEvent = (createAnalyticsEvent, sourceNode, targetAttributes)=>{
    if (!createAnalyticsEvent) return;
    const sourceAttributes = {
        sourceNodeType: sourceNode.type
    };
    // Source is Connect macro
    if (sourceNode.type === 'extension' && sourceNode.attrs?.extensionType === (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE) Object.assign(sourceAttributes, {
        sourceExtensionType: sourceNode.attrs?.extensionType,
        sourceExtensionKey: sourceNode.attrs?.extensionKey,
        sourceExtensionTitle: sourceNode.attrs?.parameters?.macroMetadata?.title,
        sourceExtensionParameters: sourceNode.attrs?.parameters
    });
    // Source is a Table
    if (sourceNode.type === 'table') Object.assign(sourceAttributes, {
        sourceExtensionType: 'table'
    });
    // Source is a Chart
    if (sourceNode.type === 'extension' && sourceNode.attrs?.extensionType === 'com.atlassian.chart') Object.assign(sourceAttributes, {
        sourceExtensionType: sourceNode.attrs?.extensionType,
        sourceExtensionKey: sourceNode.attrs?.extensionKey,
        sourceExtensionTitle: sourceNode.attrs?.parameters?.extensionTitle,
        sourceExtensionParameters: sourceNode.attrs?.parameters
    });
    const analyticsData = {
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createReference',
            source: 'editorFloatingToolbar',
            attributes: {
                ...sourceAttributes,
                ...targetAttributes
            }
        }
    };
    createAnalyticsEvent(analyticsData).fire();
};
const $6089ca8d25fc98f0$export$ab05b910337771f7 = (createAnalyticsEvent, sourceNode, targetMacro)=>{
    $6089ca8d25fc98f0$var$fireAnalyticsEvent(createAnalyticsEvent, sourceNode, {
        targetNodeType: 'extension',
        targetExtensionType: (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE,
        targetExtensionKey: targetMacro.macroName,
        targetExtensionTitle: targetMacro.title,
        targetMacro: targetMacro
    });
};
const $6089ca8d25fc98f0$export$6fc4be8bb74a5f0 = (createAnalyticsEvent, sourceNode, targetMacro)=>{
    $6089ca8d25fc98f0$var$fireAnalyticsEvent(createAnalyticsEvent, sourceNode, {
        targetNodeType: 'extension',
        targetExtensionType: 'com.atlassian.ecosystem',
        targetExtensionKey: targetMacro.id.replace('ari:cloud:ecosystem::extension/', ''),
        targetExtensionTitle: (0, $9fBoq.extensionTitle)(targetMacro),
        targetMacro: targetMacro
    });
};
const $6089ca8d25fc98f0$export$6546d4aebb1728df = (createAnalyticsEvent, node)=>{
    $6089ca8d25fc98f0$var$fireAnalyticsEvent(createAnalyticsEvent, node, {});
};
module.exports["fireAnalyticsEventForConnectionsButton"] = $6089ca8d25fc98f0$export$6546d4aebb1728df;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("jRxDI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $bre0g = parcelRequire("bre0g");


var $jmjWc = parcelRequire("jmjWc");


var $au7xi = parcelRequire("au7xi");


const $8c4ed19546fbbebf$var$SmartButtonExtension = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8Gy08",
    name: "SmartButtonExtension",
    loader: async ()=>(await (parcelRequire("9MR7j"))).SmartButtonExtension
});
const $8c4ed19546fbbebf$var$i18n = (0, $cgtv4.defineMessages)({
    extensionName: {
        id: "automation-extensions.smart-button.name",
        defaultMessage: "Smart Button"
    },
    extensionDescription: {
        id: "automation-extensions.smart-button.description",
        defaultMessage: "Enables users to create smart buttons to run automation rules"
    }
});

// "Manifest" of the extension
// Describes extension properties and how it hooks into other parts of editor
const $8c4ed19546fbbebf$var$getSmartButtonExtensionManifest = ({ contentId: contentId, editorActions: editorActions, openSmartButtonConfigPanel: openSmartButtonConfigPanel, isSmartButtonAllowed: isSmartButtonAllowed, intl: intl, contentType: contentType, isTemplateEditor: isTemplateEditor = false })=>({
        title: intl.formatMessage($8c4ed19546fbbebf$var$i18n.extensionName),
        type: (0, $au7xi.smartButtonExtensionType),
        key: 'smart-button',
        description: intl.formatMessage($8c4ed19546fbbebf$var$i18n.extensionDescription),
        icons: {
            // 48 is the pixel size of the icon
            '48': ()=>(parcelRequire("7yens")).then((mod)=>mod.AutomationIcon)
        },
        // automation icon to run rule from button toolbar can be added here - see code remove for A4C-2519
        modules: {
            // This governs the / menu and + menu insertion
            // We disable extension insertion from both menus by setting this as undefined
            quickInsert: isSmartButtonAllowed && contentType === 'page' ? [
                {
                    key: 'quick-insert',
                    keywords: [
                        'automation'
                    ],
                    action: ()=>Promise.resolve({
                            type: 'inlineExtension',
                            key: 'smart-button',
                            attrs: {
                                extensionType: (0, $au7xi.smartButtonExtensionType),
                                extensionKey: 'smart-button',
                                parameters: {
                                    extensionTitle: intl.formatMessage($8c4ed19546fbbebf$var$i18n.extensionName)
                                }
                            }
                        })
                }
            ] : undefined,
            // This is the actual node inserted into the content
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>({ node: node })=>{
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8c4ed19546fbbebf$var$SmartButtonExtension, {
                                extensionNode: node,
                                editorActions: editorActions,
                                openSmartButtonConfigPanel: openSmartButtonConfigPanel,
                                contentId: contentId,
                                contentType: contentType,
                                isTemplateEditor: isTemplateEditor
                            });
                        },
                    update: async ()=>{
                        const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                        const selectedLocalId = selectedNode?.attrs?.localId;
                        if (!!selectedLocalId && openSmartButtonConfigPanel) openSmartButtonConfigPanel(selectedLocalId);
                    }
                }
            }
        }
    });
const $8c4ed19546fbbebf$export$5d6127d5858c50c9 = async ({ contentId: contentId, editorActions: editorActions, openSmartButtonConfigPanel: openSmartButtonConfigPanel, isSmartButtonAllowed: isSmartButtonAllowed, intl: intl, contentType: contentType, isTemplateEditor: isTemplateEditor = false })=>new (0, $bre0g.default)([
        $8c4ed19546fbbebf$var$getSmartButtonExtensionManifest({
            contentId: contentId,
            editorActions: editorActions,
            openSmartButtonConfigPanel: openSmartButtonConfigPanel,
            isSmartButtonAllowed: isSmartButtonAllowed,
            intl: intl,
            contentType: contentType,
            isTemplateEditor: isTemplateEditor
        })
    ]);
module.exports["smartButtonExtensionProvider"] = $8c4ed19546fbbebf$export$5d6127d5858c50c9;

});

parcelRegister("9MR7j", function(module, exports) {

let $7201ccb0216488bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7201ccb0216488bc$var$load("6wr18"),
    $7201ccb0216488bc$var$load("gctwz"),
    $7201ccb0216488bc$var$load("7f9Fz"),
    $7201ccb0216488bc$var$load("lhkXg"),
    $7201ccb0216488bc$var$load("ffEVr"),
    $7201ccb0216488bc$var$load("fgNp8")
]).then(()=>parcelRequire('6ncRx'));

});

parcelRegister("7yens", function(module, exports) {

let $57f6dc6f33ede5cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $57f6dc6f33ede5cd$var$load("6wr18"),
    $57f6dc6f33ede5cd$var$load("ffEVr"),
    $57f6dc6f33ede5cd$var$load("djlDY")
]).then(()=>parcelRequire('iFAjt'));

});

parcelRegister("iONqR", function(module, exports) {

var $bre0g = parcelRequire("bre0g");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3e10B = parcelRequire("3e10B");


var $51WxS = parcelRequire("51WxS");

const $c614caf6b183de5b$export$e1aa62d66c6fe261 = async (intl)=>{
    try {
        const snippets = await (0, $3e10B.fetchSnippets)();
        if (!snippets || snippets.length === 0) return new (0, $bre0g.default)([]);
        const manifest = (0, $51WxS.snippetExtensionManifest)({
            snippets: snippets,
            intl: intl
        });
        return new (0, $bre0g.default)([
            manifest
        ]);
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        return new (0, $bre0g.default)([]);
    }
};
module.exports["snippetExtensionProvider"] = $c614caf6b183de5b$export$e1aa62d66c6fe261;

});

parcelRegister("3e10B", function(module, exports) {

var $3fxwO = parcelRequire("3fxwO");


var $f7B1p = parcelRequire("f7B1p");


var $ge2sX = parcelRequire("ge2sX");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $e9jnk = parcelRequire("e9jnk");


var $4MPLO = parcelRequire("4MPLO");

const $08eb629ddb2e8bad$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL = '/gateway/api/blocks/v1';
const $08eb629ddb2e8bad$var$SNIPPETS_PATH = '/snippets';
const $08eb629ddb2e8bad$var$PRODUCT_PATH = '/product/confluence';
class $08eb629ddb2e8bad$export$e48d728925b396bf extends Error {
    constructor(status){
        super(`Snippet error: ${status}`), this.status = status;
    }
}
const $08eb629ddb2e8bad$var$transformSnippets = async (snippets)=>{
    const { displayName: displayName } = await (0, $ge2sX.getSessionData)();
    return snippets.map((snippet)=>$08eb629ddb2e8bad$var$transformSnippetData(snippet, displayName));
};
const $08eb629ddb2e8bad$var$transformSnippetData = (snippet, displayName)=>{
    const createdBy = {
        accountId: snippet.createdBy,
        displayName: snippet.createdBy?.toLowerCase() === 'atlassian' ? 'Atlassian' : displayName || snippet.createdBy
    };
    return {
        ari: (0, $3fxwO.BlocksSnippetAri).parse(snippet.resourceId),
        snippetId: snippet.snippetId,
        name: snippet.name,
        description: snippet.description,
        bodyFormat: snippet.bodyFormat,
        body: (0, $4MPLO.parseSnippetContent)(snippet.body),
        product: snippet.product,
        isFavorite: snippet.isFavorite,
        status: snippet.status,
        createdBy: createdBy,
        createdAt: new Date(Number(snippet.createdAt)),
        updatedAt: new Date(Number(snippet.updatedAt))
    };
};
const $08eb629ddb2e8bad$export$424a614da735364c = async ()=>{
    const params = new URLSearchParams({
        format: (0, $e9jnk.SnippetBodyFormat).ADF
    });
    const response = await (0, $f7B1p.cfetch)(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH + $08eb629ddb2e8bad$var$PRODUCT_PATH}?${params.toString()}`, {
        method: 'GET',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
    });
    if (!response.ok) throw new $08eb629ddb2e8bad$export$e48d728925b396bf(response.status);
    const responseData = await response.json();
    if (!responseData.success) return [];
    // Success and error can both be present, so we need to log the error if it is present
    if (Array.isArray(responseData.error) && responseData.error.length > 0) responseData.error.forEach((error)=>{
        const errorToLog = new Error(`Error when fetching snippets: ${error?.message || JSON.stringify(error)}`);
        (0, $5ZqQS.getMonitoringClient)().submitError(errorToLog, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
    });
    return $08eb629ddb2e8bad$var$transformSnippets(responseData.success);
};
const $08eb629ddb2e8bad$export$f7bed3a90241a88a = async (params)=>{
    const response = await (0, $f7B1p.cfetch)(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}`, {
        method: 'POST',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS,
        body: JSON.stringify(params)
    });
    if (!response.ok) throw new $08eb629ddb2e8bad$export$e48d728925b396bf(response.status);
    return response.json();
};
module.exports["fetchSnippets"] = $08eb629ddb2e8bad$export$424a614da735364c;
module.exports["createSnippet"] = $08eb629ddb2e8bad$export$f7bed3a90241a88a;

});

parcelRegister("3fxwO", function(module, exports) {

var $l3omf = parcelRequire("l3omf");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/blocks/snippet/manifest.ts
var $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $l3omf.BlocksSnippetAriResourceOwner),
    resourceType: (0, $l3omf.BlocksSnippetAriResourceType),
    resourceIdSlug: "workspace/{workspaceId}/{snippetId}",
    resourceIdSegmentFormats: {
        workspaceId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        snippetId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-7][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/blocks/snippet/index.ts
var $25dcc7d0ac4036c1$export$7140b52dd9778730 = class _BlocksSnippetAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get workspaceId() {
        return this._workspaceId;
    }
    get snippetId() {
        return this._snippetId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts.qualifier,
            platformQualifier: $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts.resourceOwner,
            resourceType: $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts.resourceType,
            resourceId: `workspace/${opts.workspaceId}/${opts.snippetId}`,
            resourceIdSegmentValues: {
                workspaceId: opts.workspaceId,
                snippetId: opts.snippetId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts);
        return new _BlocksSnippetAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts);
        return new _BlocksSnippetAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            workspaceId: this.workspaceId,
            snippetId: this.snippetId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._workspaceId = opts.resourceIdSegmentValues.workspaceId, this._snippetId = opts.resourceIdSegmentValues.snippetId;
    }
};
module.exports["BlocksSnippetAri"] = $25dcc7d0ac4036c1$export$7140b52dd9778730;

});

parcelRegister("l3omf", function(module, exports) {
// src/blocks/snippet/types.ts
var $f53cc5c05a1e57d6$export$c5a78d3da90ef749 = "blocks", $f53cc5c05a1e57d6$export$38b3a184e1acf0da = "snippet";
module.exports["BlocksSnippetAriResourceOwner"] = $f53cc5c05a1e57d6$export$c5a78d3da90ef749;
module.exports["BlocksSnippetAriResourceType"] = $f53cc5c05a1e57d6$export$38b3a184e1acf0da;

});

parcelRegister("e9jnk", function(module, exports) {
var $9a53cc3a2d654f6a$export$e6769779009a1fa2 = /*#__PURE__*/ function(SnippetProduct) {
    // Only Confluence is allowed currently but more will be added:
    // 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
    SnippetProduct["CONFLUENCE"] = "CONFLUENCE";
    return SnippetProduct;
}({});
var $9a53cc3a2d654f6a$export$4b7b09c17f5ba341 = /*#__PURE__*/ function(SnippetBodyFormat) {
    // Only ADF is allowed currently but more will be added:
    // 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
    SnippetBodyFormat["ADF"] = "ADF";
    return SnippetBodyFormat;
}({});
var $9a53cc3a2d654f6a$export$9826bdf5a11e7016 = /*#__PURE__*/ function(SnippetStatus) {
    SnippetStatus["ACTIVE"] = "active";
    SnippetStatus["DELETED"] = "deleted";
    return SnippetStatus;
}({});
module.exports["SnippetProduct"] = $9a53cc3a2d654f6a$export$e6769779009a1fa2;
module.exports["SnippetBodyFormat"] = $9a53cc3a2d654f6a$export$4b7b09c17f5ba341;
module.exports["SnippetStatus"] = $9a53cc3a2d654f6a$export$9826bdf5a11e7016;

});

parcelRegister("4MPLO", function(module, exports) {

var $jh7y0 = parcelRequire("jh7y0");

function $ea21f85c6ae0b9ea$var$filterValidAdfNodes(nodes) {
    return nodes.filter((node)=>node !== undefined && node !== null);
}
const $ea21f85c6ae0b9ea$export$4cb5aec6fe7a20df = (content)=>{
    try {
        const parsedContent = JSON.parse(content);
        // Handle fragment (array of nodes without doc wrapper)
        if (Array.isArray(parsedContent)) return $ea21f85c6ae0b9ea$var$filterValidAdfNodes(parsedContent);
        // Handle single node or doc node
        const adfContent = parsedContent;
        if (adfContent.type === 'doc' && Array.isArray(adfContent.content)) return $ea21f85c6ae0b9ea$var$filterValidAdfNodes(adfContent.content);
        return adfContent;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error processing snippet ADF:', error);
        return undefined;
    }
};
const $ea21f85c6ae0b9ea$export$fefb8fa12cc0572f = (name, intl)=>{
    const nameKeywords = name.split(/\s+/).map((word)=>word.toLowerCase().trim()).filter((word)=>word.length > 0);
    const templateKeyword = intl.formatMessage((0, $jh7y0.messages).template).toLowerCase();
    const allKeywords = [
        ...nameKeywords,
        templateKeyword
    ];
    return Array.from(new Set(allKeywords));
};
const $ea21f85c6ae0b9ea$export$4a4fbbff52147a2b = (createdBy, intl)=>{
    const name = createdBy.displayName || createdBy.accountId;
    return intl.formatMessage((0, $jh7y0.messages).snippetBy, {
        name: name
    });
};
module.exports["parseSnippetContent"] = $ea21f85c6ae0b9ea$export$4cb5aec6fe7a20df;
module.exports["extractSnippetKeywords"] = $ea21f85c6ae0b9ea$export$fefb8fa12cc0572f;
module.exports["createSnippetDescription"] = $ea21f85c6ae0b9ea$export$4a4fbbff52147a2b;

});

parcelRegister("jh7y0", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $5dbf59ea4b5ad439$var$messagesBase = (0, $cgtv4.defineMessages)({
    createTemplate: {
        id: "snippets.createTemplate",
        defaultMessage: "Create template"
    },
    createTemplateLozenge: {
        id: "snippets.createTemplateLozenge",
        defaultMessage: "New"
    },
    createTemplateModalTitle: {
        id: "snippets.createTemplateModalTitle",
        defaultMessage: "Create template"
    },
    createTemplateModalDescription: {
        id: "snippets.createTemplateModalDescription",
        defaultMessage: "Save content and easily reuse it through / menu."
    },
    createTemplateModalNamePlaceholder: {
        id: "snippets.createTemplateModalNamePlaceholder",
        defaultMessage: "Enter template name"
    },
    createTemplateModalNameLabel: {
        id: "snippets.createTemplateModalNameLabel",
        defaultMessage: "Name"
    },
    createTemplateModalNameHelper: {
        id: "snippets.createTemplateModalNameHelper",
        defaultMessage: "Use a name to find your Block Template"
    },
    createTemplateModalNameError: {
        id: "snippets.createTemplateModalNameError",
        defaultMessage: "Name is required"
    },
    createTemplateModalDescriptionLabel: {
        id: "snippets.createTemplateModalDescriptionLabel",
        defaultMessage: "Description"
    },
    createTemplateModalDescriptionPlaceholder: {
        id: "snippets.createTemplateModalDescriptionPlaceholder",
        defaultMessage: "Enter template description"
    },
    createTemplateModalCancelButton: {
        id: "snippets.createTemplateModalCancelButton",
        defaultMessage: "Cancel"
    },
    createTemplateModalCreateButton: {
        id: "snippets.createTemplateModalCreateButton",
        defaultMessage: "Create"
    },
    snippetBy: {
        id: "snippets.quick-insert.by",
        defaultMessage: "by {name}"
    },
    template: {
        id: "snippets.quick-insert.template",
        defaultMessage: "template"
    }
});
const $5dbf59ea4b5ad439$export$defe85febe8b728c = $5dbf59ea4b5ad439$var$messagesBase;
module.exports["messages"] = $5dbf59ea4b5ad439$export$defe85febe8b728c;

});

parcelRegister("51WxS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jdPfT = parcelRequire("jdPfT");


var $jh7y0 = parcelRequire("jh7y0");


var $4MPLO = parcelRequire("4MPLO");


const $3f665bc0c658edea$export$bc0a2249d0f8fcd = ({ snippets: snippets, intl: intl })=>{
    const quickInsert = snippets.map((snippet)=>({
            key: `snippet-${snippet.snippetId}`,
            title: snippet.name,
            description: intl.formatMessage((0, $jh7y0.messages).snippetBy, {
                name: snippet.createdBy.displayName
            }),
            keywords: (0, $4MPLO.extractSnippetKeywords)(snippet.name, intl),
            icon: async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                        label: "Snippet"
                    }),
            action: async ()=>snippet.body
        }));
    return {
        title: 'Snippets',
        description: 'Insert saved snippets into your page',
        type: 'com.atlassian.confluence.macro.core',
        key: 'snippet-extension',
        icons: {
            // eslint-disable-next-line import/dynamic-import-chunkname
            '48': ()=>Promise.resolve((parcelRequire("jdPfT")))
        },
        modules: {
            quickInsert: quickInsert
        }
    };
};
module.exports["snippetExtensionManifest"] = $3f665bc0c658edea$export$bc0a2249d0f8fcd;

});

parcelRegister("6b7RE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $bre0g = parcelRequire("bre0g");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");

const $9e56fbf670b6dc1e$export$858ce1ee8936577f = async (args)=>new (0, $bre0g.default)([
        $9e56fbf670b6dc1e$var$getProjectLinkerExtensionManifest(args)
    ]);
const $9e56fbf670b6dc1e$var$getProjectLinkerExtensionManifest = ({ cloudId: cloudId, intl: intl, editorActions: editorActions, createAnalyticsEvent: createAnalyticsEvent })=>({
        title: intl.formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? $9e56fbf670b6dc1e$var$i18n.titleGalaxia : $9e56fbf670b6dc1e$var$i18n.title),
        type: 'com.atlassian.confluence.project-linker',
        key: 'project-linker',
        description: intl.formatMessage($9e56fbf670b6dc1e$var$i18n.description),
        icons: {
            '48': async ()=>({
                    default: ()=>null
                })
        },
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    render: async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9e56fbf670b6dc1e$var$ProjectLinkerLoader, {
                                cloudId: cloudId,
                                editorActions: editorActions,
                                createAnalyticsEvent: createAnalyticsEvent
                            }),
                    // @ts-expect-error This option is experimental and not reflected in the manifest type definition
                    __hideFrame: true
                }
            }
        }
    });

const $9e56fbf670b6dc1e$var$ProjectLinkerLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "mj056",
    name: "ProjectLinkerLoader",
    loader: async ()=>(await (parcelRequire("jjA8s"))).ProjectLinkerWrapper
});
const $9e56fbf670b6dc1e$var$i18n = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-space.project-linker.extension.title",
        defaultMessage: "Project linker"
    },
    titleGalaxia: {
        id: "create-space.project-linker.extension.title-galaxia",
        defaultMessage: "Space linker"
    },
    description: {
        id: "create-space.project-linker.extension.description",
        defaultMessage: "Provides a convenient way to link to projects on space overview"
    }
});
module.exports["projectLinkerExtensionProvider"] = $9e56fbf670b6dc1e$export$858ce1ee8936577f;

});

parcelRegister("jjA8s", function(module, exports) {

let $e0fbd26916fdaaa4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e0fbd26916fdaaa4$var$load("jg5LT"),
    $e0fbd26916fdaaa4$var$load("kjZZD"),
    $e0fbd26916fdaaa4$var$load("9XYQ9"),
    $e0fbd26916fdaaa4$var$load("iZU4p"),
    $e0fbd26916fdaaa4$var$load("6wr18"),
    $e0fbd26916fdaaa4$var$load("8JZKd"),
    $e0fbd26916fdaaa4$var$load("kTv6A"),
    $e0fbd26916fdaaa4$var$load("7EorR"),
    $e0fbd26916fdaaa4$var$load("kHOMt"),
    $e0fbd26916fdaaa4$var$load("hhss7"),
    $e0fbd26916fdaaa4$var$load("Wowvf"),
    $e0fbd26916fdaaa4$var$load("7e13v"),
    $e0fbd26916fdaaa4$var$load("aqr2D"),
    $e0fbd26916fdaaa4$var$load("ffEVr"),
    $e0fbd26916fdaaa4$var$load("c0JsV"),
    $e0fbd26916fdaaa4$var$load("8AwXG")
]).then(()=>parcelRequire('cIFHL'));

});

parcelRegister("fgd2r", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $ee57e9dbd4a15340$export$41ec0510c4ed436a = (flagName, defaultValue, map)=>(featureFlags)=>{
        const maybeValue = featureFlags[flagName];
        if (typeof maybeValue === 'string') try {
            const value = JSON.parse(maybeValue);
            return map ? map(value) : value;
        } catch (err) {
            return defaultValue;
        }
        return defaultValue;
    };
const $ee57e9dbd4a15340$export$395b7f16d1fbd63c = ()=>{
    const optedOutMacros = [
        'create-from-template',
        'auibutton',
        'cfm-progress-bar-hyperlink-step',
        'decisionreport',
        'viewpdf',
        'viewdoc',
        'viewxls',
        'viewppt',
        'cqlmacro1',
        'detailssummary',
        'contentbylabel'
    ];
    if (!(0, $9wGTI.fg)('confluence_frontend_blog_posts_macro_in_side_panel')) optedOutMacros.push('blog-posts');
    return optedOutMacros;
};
module.exports["getOptedOutMacros"] = $ee57e9dbd4a15340$export$395b7f16d1fbd63c;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("lvKPs", function(module, exports) {
/*
Not to be confused for comment-macro-extension-handler.tsx in the same package which is used specifically
for the comment editor. This MacroExtensionHandler file is used for creating extension handlers
for next/full-page-editor
*/ 
var $42omo = parcelRequire("42omo");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $8pcS0 = parcelRequire("8pcS0");


var $eS4Za = parcelRequire("eS4Za");


var $Qcu7n = parcelRequire("Qcu7n");


var $e8Lxy = parcelRequire("e8Lxy");


var $e1Stz = parcelRequire("e1Stz");


var $5a4cC = parcelRequire("5a4cC");


var $9m03g = parcelRequire("9m03g");


var $9JyIJ = parcelRequire("9JyIJ");


var $fuLIO = parcelRequire("fuLIO");


var $6aEhm = parcelRequire("6aEhm");


var $c8uPc = parcelRequire("c8uPc");


var $ahrsq = parcelRequire("ahrsq");


var $5h7sn = parcelRequire("5h7sn");


var $7NX4e = parcelRequire("7NX4e");


var $8jP8e = parcelRequire("8jP8e");


var $kvJ5e = parcelRequire("kvJ5e");

const $0e80447918933d7e$var$context = {
    insertCss: (styles)=>styles._insertCss()
};
const $0e80447918933d7e$export$ea8f3f4f30a7109d = ({ contentId: contentId, spaceKey: spaceKey, extensionContextProvider: extensionContextProvider, editorActions: editorActions, subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange, isLivePage: isLivePage, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled })=>{
    return {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE]: $0e80447918933d7e$export$9270a983db609799({
            contentId: contentId,
            spaceKey: spaceKey,
            extensionContextProvider: extensionContextProvider,
            editorActions: editorActions,
            subscribeDocChange: subscribeDocChange,
            unsubscribeDocChange: unsubscribeDocChange,
            isLivePage: isLivePage,
            isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled
        }),
        [(0, $8pcS0.EXTENSION_TYPE).MIGRATION]: (0, $5h7sn.getMigrationExtHandlerForEditor)({
            contentId: contentId,
            contextProviders: {}
        })
    };
};
const $0e80447918933d7e$export$9270a983db609799 = ({ contentId: contentId, spaceKey: spaceKey, extensionContextProvider: extensionContextProvider = {
    ClassicEditorContextProvider: ({ children: children, isWithinEditor: // @ts-ignore
    isWithinEditor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children)
}, editorActions: editorActions, subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange, isLivePage: isLivePage, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled })=>(0, $eS4Za.createMacroExtensionHandler)((extension, doc)=>{
        const resolvedExtensionKey = (0, $Qcu7n.resolveQuestionsMacroExtensionKey)(extension.extensionKey);
        const extensionKey = resolvedExtensionKey;
        // Update extension if key was resolved to a different value
        if (resolvedExtensionKey !== extension.extensionKey) extension = {
            ...extension,
            extensionKey: resolvedExtensionKey
        };
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        const { ClassicEditorContextProvider: ClassicEditorContextProvider } = extensionContextProvider;
        const macroDefaultProps = {
            node: extension,
            references: doc?.[0]?.references || [],
            contentId: contentId,
            spaceKey: spaceKey,
            mode: (0, $5kjCz.EDITOR),
            context: $0e80447918933d7e$var$context,
            extensionKey: extensionKey,
            attributes: attributes,
            multiBodiedExtensionActions: doc?.[0]?.actions
        };
        let implementation;
        const legacyMacroRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ClassicEditorContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps));
        switch(extensionKey){
            // blocklist - block extensions - we want to show the editor's placeholder frame, so return empty div
            case 'toc':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8jP8e.TableOfContentsLiveComponent), {
                    macroDefaultProps: macroDefaultProps,
                    editorActions: editorActions,
                    subscribeDocChange: subscribeDocChange,
                    unsubscribeDocChange: unsubscribeDocChange,
                    isCollabEditForLiveUpdatesEnabled: !!isCollabEditForLiveUpdatesEnabled
                });
                break;
            case 'create-from-template':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahrsq.CreateFromTemplate), macroDefaultProps);
                break;
            // blocklist - inline extensions - the editor doesn't render a placeholder frame, so we need to display something
            case 'pagetree':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c8uPc.DeadMacroRenderer), macroDefaultProps);
                break;
            case 'anchor':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6aEhm.AnchorMacroRenderer), macroDefaultProps);
                break;
            case 'excerpt-include':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ClassicEditorContextProvider, {
                    isWithinEditor: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7NX4e.ExcerptIncludeExtensionHandler), {
                    ...macroDefaultProps,
                    isLivePage: isLivePage,
                    Renderer: (0, $e8Lxy.PageContentRenderer)
                }));
                break;
            case 'detailssummary':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ClassicEditorContextProvider, {
                    isWithinEditor: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1Stz.PagePropertiesReportRenderer), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams,
                    openAnchorsInNewTab: true
                }));
                break;
            case 'profile-picture':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9m03g.ProfilePictureMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                });
                break;
            case 'profile':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5a4cC.UserProfileMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                });
                break;
            case 'include':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ClassicEditorContextProvider, {
                    isWithinEditor: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps));
                break;
            case 'livesearch':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJ5e.LiveSearchHandler), {
                    macroDefaultProps: macroDefaultProps
                });
                break;
            case 'questionslist-macro':
                implementation = legacyMacroRenderer;
                break;
            case 'questionslist-macro-native':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9JyIJ.GlobalQuestionsListMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                });
                break;
            // generic macro renderer
            default:
                implementation = legacyMacroRenderer;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: (0, $5kjCz.getExperienceName)((0, $5kjCz.EDITOR), extension),
            contentId: contentId,
            mode: (0, $5kjCz.EDITOR),
            extensionKey: extensionKey,
            attributes: attributes,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), implementation);
    });
module.exports["getFullPageExtensionHandlers"] = $0e80447918933d7e$export$ea8f3f4f30a7109d;

});

parcelRegister("5kjCz", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $2XqLN.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $42omo.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $42omo.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("6aEhm", function(module, exports) {
/* AnchorMacroRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1bY7o = parcelRequire("1bY7o");


var $9tVje = parcelRequire("9tVje");

const $0c2b5b61ad0a1759$var$i18n = (0, $cgtv4.defineMessages)({
    anchorMacroLabel: {
        id: "fabric-extension-handlers.inline-extension.valid-anchor-macro.icon.label",
        defaultMessage: "Anchor link"
    }
});
const $0c2b5b61ad0a1759$var$highlightAnimation = null;
const $0c2b5b61ad0a1759$var$animationStyles = null;
const $0c2b5b61ad0a1759$var$macroWrapperStyles = null;
const $0c2b5b61ad0a1759$export$16f5c11d6d7adab1 = (props)=>{
    const intl = (0, $8C5kA.default)();
    const [shouldPlayHighlightAnimation, setShouldPlayHighlightAnimation] = (0, $42omo.useState)(false);
    const [isMacroVisible, setIsMacroVisible] = (0, $42omo.useState)(false);
    const macroRef = (0, $42omo.useRef)(null);
    const anchorName = props?.node?.parameters?.macroParams[''].value;
    let anchorValid = true;
    if (!anchorName || anchorName.includes(' ')) anchorValid = false;
    if (anchorValid) try {
        decodeURIComponent(anchorName);
    } catch  {
        anchorValid = false;
    }
    (0, $42omo.useEffect)(()=>{
        setShouldPlayHighlightAnimation(anchorValid && window.location.hash === `#${anchorName}`);
        const handleOnHashChange = ()=>{
            setIsMacroVisible(false);
            setShouldPlayHighlightAnimation(anchorValid && window.location.hash === `#${anchorName}`);
        }; // There is a case where a url hash change occurs but does not reload the page.
        // To account for this, so we can still trigger the animation as expected when
        // the related anchor is scrolled to, we need to listen to the event.
        window.addEventListener('hashchange', handleOnHashChange);
        return ()=>{
            window.removeEventListener('hashchange', handleOnHashChange);
        };
    }, [
        anchorName,
        anchorValid,
        setShouldPlayHighlightAnimation
    ]);
    (0, $42omo.useEffect)(()=>{
        {
            /**
       * IntersectionObserver doesn't work for SSR pages.
       * Escaped using process.env.REACT_SSR above, per rule,
       * and silenced eslint warning safely below.
       */ // eslint-disable-next-line
            const observer = new IntersectionObserver(([entry])=>{
                if (!isMacroVisible) setIsMacroVisible(entry.isIntersecting);
            }, {
                threshold: 1.0
            });
            if (macroRef?.current) observer.observe(macroRef.current);
             // Remove the observer as soon as the component is unmounted
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        isMacroVisible,
        setIsMacroVisible,
        macroRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: macroRef,
        id: anchorValid ? anchorName : undefined,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko12b0 _1e0c1txw _1bah1h6o _4cvr1h6o _bfhki8nm _1bsb1tcg _4t3igktf _vchhusvi",
            shouldPlayHighlightAnimation && isMacroVisible && "",
            shouldPlayHighlightAnimation && isMacroVisible && "_y44vwhg8"
        ])
    }, anchorValid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        label: intl.formatMessage($0c2b5b61ad0a1759$var$i18n.anchorMacroLabel),
        color: "var(--ds-icon-subtle, #505258)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9tVje.AnchorMacroPlaceholder), null));
};
module.exports["AnchorMacroRenderer"] = $0c2b5b61ad0a1759$export$16f5c11d6d7adab1;

});

parcelRegister("ahrsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5kjCz = parcelRequire("5kjCz");


var $bX5uj = parcelRequire("bX5uj");


var $cYJC5 = parcelRequire("cYJC5");


var $bQm3c = parcelRequire("bQm3c");

const $78b48bb386aef67d$export$a6c71275c6598127 = ({ ...macroDefaultProps })=>{
    const { contentId: contentId, extensionKey: extensionKey, node: node, mode: mode } = macroDefaultProps;
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cYJC5.CreateFromTemplateLoader), {
        userId: userId || '',
        cloudId: cloudId,
        macroDefaultProps: macroDefaultProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: (0, $5kjCz.getExperienceName)(mode, node),
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }));
};
module.exports["CreateFromTemplate"] = $78b48bb386aef67d$export$a6c71275c6598127;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("8jP8e", function(module, exports) {
/* TableOfContentsLiveComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jSnXV = parcelRequire("jSnXV");


var $h9yJL = parcelRequire("h9yJL");


var $6qdjm = parcelRequire("6qdjm");


var $9hlns = parcelRequire("9hlns");


var $kDhla = parcelRequire("kDhla");


var $fDdWw = parcelRequire("fDdWw");


var $dwS6P = parcelRequire("dwS6P");


var $bQm3c = parcelRequire("bQm3c");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57df12aecf845afb$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ajq _bfhksm61",
            __cmplp.className
        ])
    });
});
const $57df12aecf845afb$var$Centered = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $57df12aecf845afb$export$7345e257c3f26650 = ({ macroDefaultProps: macroDefaultProps, editorActions: editorActions, subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled })=>{
    const [isInitialLoadComplete, setIsInitialLoadComplete] = (0, $42omo.useState)(false);
    const [adf, setAdf] = (0, $42omo.useState)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const debounceMs = 400;
    const previousRemoteChangeTimeRef = (0, $42omo.useRef)(undefined);
    const previousLocalChangeTimeRef = (0, $42omo.useRef)(undefined);
    const previousADF = (0, $42omo.useRef)();
    const updateAdf = (0, $42omo.useCallback)((editorView)=>{
        const doc = editorView?.state?.doc;
        if (doc) {
            const editorTransformer = new (0, $h9yJL.JSONTransformer)();
            const _adf = editorTransformer.encode(doc);
            if (isCollabEditForLiveUpdatesEnabled) {
                const shouldUpdateADF = previousADF.current ? !(0, $fDdWw.checkIsEqual)(previousADF.current, _adf) : true;
                previousADF.current = _adf;
                if (shouldUpdateADF) setAdf(_adf);
            } else setAdf(_adf);
        }
    }, [
        isCollabEditForLiveUpdatesEnabled
    ]);
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const debouncedUpdateADF = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            const editorView = editorActions._privateGetEditorView();
            updateAdf(editorView);
        }, debounceMs), [
        editorActions,
        updateAdf
    ]);
    (0, $6qdjm.usePluginStateEffect)(fullPageEditorPresetAPI, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        const lastRemoteChangeTime = collabEditState?.initialised?.lastRemoteOrganicBodyChangeAt;
        const lastLocalChangeTime = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        const hasRemoteChanged = lastRemoteChangeTime && lastRemoteChangeTime !== previousRemoteChangeTimeRef.current;
        const hasLocalChanged = lastLocalChangeTime && lastLocalChangeTime !== previousLocalChangeTimeRef.current;
        if (hasRemoteChanged || hasLocalChanged) {
            previousRemoteChangeTimeRef.current = lastRemoteChangeTime;
            previousLocalChangeTimeRef.current = lastLocalChangeTime;
            if (isCollabEditForLiveUpdatesEnabled) debouncedUpdateADF();
        }
    });
    (0, $42omo.useEffect)(()=>{
        const debouncedHandleDocChange = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(updateAdf, debounceMs);
        if (!isCollabEditForLiveUpdatesEnabled) subscribeDocChange(debouncedHandleDocChange);
        return ()=>{
            if (!isCollabEditForLiveUpdatesEnabled) unsubscribeDocChange(debouncedHandleDocChange);
        };
    }, [
        subscribeDocChange,
        unsubscribeDocChange,
        debounceMs,
        updateAdf,
        isCollabEditForLiveUpdatesEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        // Ideally we would rely on the doc change handler to populate the ADF
        // but the doc change handler is sometimes not called on initial load.
        const editorView = editorActions._privateGetEditorView();
        updateAdf(editorView);
        setIsInitialLoadComplete(true);
    }, [
        editorActions,
        updateAdf
    ]);
    if (!isInitialLoadComplete) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($57df12aecf845afb$var$Centered, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), null));
    else if (!adf) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($57df12aecf845afb$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dwS6P.TableOfContentsLoader), {
        isInEditMode: true,
        userId: userId ?? '',
        cloudId: cloudId ?? '',
        adf: adf,
        macroDefaultProps: macroDefaultProps
    }));
};
module.exports["TableOfContentsLiveComponent"] = $57df12aecf845afb$export$7345e257c3f26650;

});

parcelRegister("kDhla", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $1P1Tu.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $9zUhf.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $9zUhf.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $9zUhf.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("fDdWw", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $6jPem = parcelRequire("6jPem");

const $b1a5d5594ebd3d9f$export$b502f7a77e1faf1e = (prevADF, nextADF)=>{
    const prevHeadings = [];
    const nextHeadings = [];
    // Go through the ADF and push any headings
    // to a new array
    (0, $6jPem.traverse)(prevADF || {}, {
        heading: (node)=>{
            prevHeadings.push(node);
        }
    });
    (0, $6jPem.traverse)(nextADF || {}, {
        heading: (node)=>{
            nextHeadings.push(node);
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevHeadings, nextHeadings);
};
module.exports["checkIsEqual"] = $b1a5d5594ebd3d9f$export$b502f7a77e1faf1e;

});

parcelRegister("kvJ5e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $l7BGZ = parcelRequire("l7BGZ");


var $5kjCz = parcelRequire("5kjCz");


var $bX5uj = parcelRequire("bX5uj");


var $6mEZ3 = parcelRequire("6mEZ3");

const $638330f188c4cca8$export$e8ac5007ab7a695a = ({ macroDefaultProps: macroDefaultProps })=>{
    const { contentId: contentId, extensionKey: extensionKey, node: node, mode: mode } = macroDefaultProps;
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l7BGZ.LiveSearchLoader), {
        macroNode: (0, $6mEZ3.extensionToADF)(node)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: (0, $5kjCz.getExperienceName)(mode, node),
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }));
};
module.exports["LiveSearchHandler"] = $638330f188c4cca8$export$e8ac5007ab7a695a;

});

parcelRegister("bcv7k", function(module, exports) {
/**
 * We shouldn't really need this file, as the editor shouldn't require us to pass in
 * a task and decision provider. But for now it does. So this whole thing is a stub.
 */ 
var $2XqLN = parcelRequire("2XqLN");

class $eaaab3ad8fc788e2$var$Provider {
    notifyRecentUpdates(_updateContext) {}
    subscribe(_objectKey, _handler) {}
    toggleTask(objectKey, state) {
        if (this._toggleTaskCallback) this._toggleTaskCallback(objectKey, state);
        return Promise.resolve(state);
    }
    unsubscribe(_objectKey, _handler) {}
    unsubscribeRecentUpdates(_id) {}
    constructor(toggleTask){
        this._toggleTaskCallback = void 0;
        this._toggleTaskCallback = toggleTask;
    }
}
const $eaaab3ad8fc788e2$export$5405ecb032439dfe = (0, $2XqLN.default)(async (toggleTaskCallback)=>{
    return new $eaaab3ad8fc788e2$var$Provider(toggleTaskCallback);
});
module.exports["getTaskDecisionProvider"] = $eaaab3ad8fc788e2$export$5405ecb032439dfe;

});

parcelRegister("32x2E", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");

parcelRequire("8uNa8");
var $5B7Fh = parcelRequire("5B7Fh");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $5B7Fh.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("8uNa8", function(module, exports) {
$parcel$export(module.exports, "emojiPlugin", () => (parcelRequire("hcboS")).emojiPlugin);
$parcel$export(module.exports, "EmojiNodeDataProvider", () => (parcelRequire("5B7Fh")).EmojiNodeDataProvider);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5B7Fh = parcelRequire("5B7Fh");

var $hcboS = parcelRequire("hcboS");


});

parcelRegister("5B7Fh", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");


var $i0VEL = parcelRequire("i0VEL");

class $57ed069fa0b7e304$export$67106c51beb59865 extends (0, $i0VEL.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $eTj7Y.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $eTj7Y.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $fhsiz.defaultEmojiHeight),
                    width: (0, $fhsiz.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $57ed069fa0b7e304$export$67106c51beb59865;

});

parcelRegister("hcboS", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");


var $ahUGI = parcelRequire("ahUGI");

var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $1S4f7 = parcelRequire("1S4f7");


var $lOELb = parcelRequire("lOELb");


var $lNDSG = parcelRequire("lNDSG");


var $ks2lK = parcelRequire("ks2lK");


var $kVNt7 = parcelRequire("kVNt7");

var $lGf1F = parcelRequire("lGf1F");

var $injKz = parcelRequire("injKz");

var $aGYoD = parcelRequire("aGYoD");


var $1yB28 = parcelRequire("1yB28");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $kQc80 = parcelRequire("kQc80");


var $j0XxS = parcelRequire("j0XxS");


var $lhIns = parcelRequire("lhIns");


var $cKEEj = parcelRequire("cKEEj");


var $cTFYB = parcelRequire("cTFYB");


var $aFWfo = parcelRequire("aFWfo");

const $8d1c5078b4947753$export$144d1b98bacb98cc = (emoji, emojiProvider)=>({
        title: emoji.shortName || '',
        key: emoji.id || emoji.shortName,
        render ({ isSelected: isSelected, onClick: onClick, onHover: onHover }) {
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $kVNt7.default), {
                emoji: emoji,
                selected: isSelected,
                onMouseMove: onHover,
                onSelection: onClick,
                emojiProvider: emojiProvider
            });
        },
        emoji: emoji
    });
function $8d1c5078b4947753$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(emoji, emojiProvider) {
        // Check cache for hits
        const hit = seen.get(emoji.id || emoji.shortName);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(emoji, emojiProvider);
        seen.set(emoji.id || emoji.shortName, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $8d1c5078b4947753$var$memoizedToItem = $8d1c5078b4947753$export$fc10aeed3a532e2a($8d1c5078b4947753$export$144d1b98bacb98cc);
const $8d1c5078b4947753$var$defaultListLimit = 50;
const $8d1c5078b4947753$var$isFullShortName = (query)=>query && query.length > 1 && query.charAt(0) === ':' && query.charAt(query.length - 1) === ':';
const $8d1c5078b4947753$var$TRIGGER = ':';
function $8d1c5078b4947753$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
const $8d1c5078b4947753$export$d1221bd3f80501e0 = ({ config: options, api: api })=>{
    let previousEmojiProvider;
    const typeAhead = {
        id: (0, $lOELb.TypeAheadAvailableNodes).EMOJI,
        trigger: $8d1c5078b4947753$var$TRIGGER,
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(:)',
        headless: options ? options.headless : undefined,
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = $8d1c5078b4947753$var$getEmojiPluginState(editorState);
            const emojiProvider = pluginState.emojiProvider;
            if (!emojiProvider) return Promise.resolve([]);
            return new Promise((resolve)=>{
                const emojiProviderChangeHandler = {
                    result (emojiResult) {
                        if (!emojiResult || !emojiResult.emojis) resolve([]);
                        else {
                            const emojiItems = emojiResult.emojis.map((emoji)=>$8d1c5078b4947753$var$memoizedToItem.call(emoji, emojiProvider));
                            resolve(emojiItems);
                        }
                        emojiProvider.unsubscribe(emojiProviderChangeHandler);
                    }
                };
                emojiProvider.subscribe(emojiProviderChangeHandler);
                emojiProvider.filter($8d1c5078b4947753$var$TRIGGER.concat(query), {
                    limit: $8d1c5078b4947753$var$defaultListLimit,
                    skinTone: emojiProvider.getSelectedTone(),
                    sort: !query.length ? (0, $aGYoD.SearchSort).UsageFrequency : (0, $aGYoD.SearchSort).Default
                });
            });
        },
        forceSelect ({ query: query, items: items, editorState: editorState }) {
            const { asciiMap: asciiMap } = $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(editorState) || {};
            const normalizedQuery = $8d1c5078b4947753$var$TRIGGER.concat(query);
            // if the query has space at the end
            // check the ascii map for emojis
            if (!(options?.disableAutoformat && (0, $1oCLl.expValEquals)('platform_editor_plain_text_support', 'isEnabled', true)) && asciiMap && normalizedQuery.length >= 3 && normalizedQuery.endsWith(' ') && asciiMap.has(normalizedQuery.trim())) {
                const emoji = asciiMap.get(normalizedQuery.trim());
                return {
                    title: emoji?.name || '',
                    emoji: emoji
                };
            }
            const matchedItem = $8d1c5078b4947753$var$isFullShortName(normalizedQuery) ? items.find((item)=>item.title.toLowerCase() === normalizedQuery) : undefined;
            return matchedItem;
        },
        selectItem (state, item, insert, { mode: mode }) {
            const emojiPluginState = $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(state);
            if (emojiPluginState.emojiProvider && emojiPluginState.emojiProvider.recordSelection && item.emoji) emojiPluginState.emojiProvider.recordSelection(item.emoji).then((0, $injKz.recordSelectionSucceededSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            })).catch((0, $injKz.recordSelectionFailedSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            }));
            const fragment = (0, $kQc80.createEmojiFragment)(state.doc, state.selection.$head, item.emoji);
            const tr = insert(fragment);
            api?.analytics?.actions.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EMOJI,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).TYPEAHEAD
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    };
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { emoji: emojiNodeType } = schema.nodes;
        if (node.type === emojiNodeType) {
            const newText = node.attrs.text;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'emoji',
        nodes () {
            return [
                {
                    name: 'emoji',
                    node: (0, $j0XxS.emojiNodeSpec)()
                }
            ];
        },
        usePluginHook () {
            (0, $42omo.useEffect)(()=>{
                $8d1c5078b4947753$var$delayUntilIdle(()=>{
                    (0, $lGf1F.preloadEmojiPicker)();
                });
            }, []);
        },
        pmPlugins () {
            return [
                {
                    name: 'emoji',
                    plugin: (pmPluginFactoryParams)=>{
                        return $8d1c5078b4947753$var$createEmojiPlugin(pmPluginFactoryParams, options, api);
                    }
                },
                {
                    name: 'emojiAsciiInputRule',
                    plugin: ({ schema: schema })=>(0, $cTFYB.inputRulePlugin)(schema, api?.analytics?.actions, api, (0, $1oCLl.expValEquals)('platform_editor_plain_text_support', 'isEnabled', true) ? options?.disableAutoformat : undefined)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { emojiResourceConfig: emojiResourceConfig, asciiMap: asciiMap, emojiProvider: emojiProvider, inlineEmojiPopupOpen: inlineEmojiPopupOpen, emojiProviderPromise: emojiProviderPromise } = $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(editorState) ?? {};
            return {
                emojiResourceConfig: emojiResourceConfig,
                asciiMap: asciiMap,
                typeAheadHandler: typeAhead,
                emojiProvider: emojiProvider,
                emojiProviderPromise: emojiProviderPromise,
                inlineEmojiPopupOpen: inlineEmojiPopupOpen
            };
        },
        actions: {
            openTypeAhead: (0, $cKEEj.openTypeAhead)(typeAhead, api),
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousEmojiProvider === provider || options?.emojiProvider === providerPromise) return false;
                previousEmojiProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>$8d1c5078b4947753$var$setProviderTr(provider)(tr)) ?? false;
            }
        },
        commands: {
            insertEmoji: (0, $kQc80.insertEmoji)(api?.analytics?.actions)
        },
        contentComponent ({ editorView: editorView, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement }) {
            if (!api || (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control') || !editorView) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $aFWfo.InlineEmojiPopup), {
                api: api,
                editorView: editorView,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPoint,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'emoji',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).emoji),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).emojiDescription),
                        priority: 500,
                        keyshortcut: ':',
                        isDisabledOffline: false,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconEmoji), {}),
                        action (insert) {
                            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                                exposure: true
                            })) {
                                // Clear slash
                                let tr = insert('');
                                tr = (0, $cKEEj.setInlineEmojiPopupOpen)(true)(tr);
                                return tr;
                            }
                            const tr = insert(undefined);
                            api?.typeAhead?.actions.openAtTransaction({
                                triggerHandler: typeAhead,
                                inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                            })(tr);
                            return tr;
                        }
                    }
                ],
            typeAhead: typeAhead,
            floatingToolbar: (state, intl)=>{
                const isViewMode = ()=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode()) return undefined;
                const onClick = (stateFromClickEvent, dispatch)=>{
                    if (!api?.annotation) return true;
                    if (api?.analytics?.actions) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $d925B.ACTION).CLICKED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                        eventType: (0, $d925B.EVENT_TYPE).UI,
                        attributes: {
                            source: 'highlightActionsMenu',
                            pageMode: 'edit',
                            sourceNode: 'emoji'
                        }
                    });
                    const command = api.annotation?.actions?.setInlineCommentDraftState(true, (0, $d925B.INPUT_METHOD).TOOLBAR);
                    return command(stateFromClickEvent, dispatch);
                };
                return {
                    title: 'Emoji floating toolbar',
                    nodeType: [
                        state.schema.nodes.emoji
                    ],
                    onPositionCalculated: (0, $lNDSG.calculateToolbarPositionAboveSelection)('Emoji floating toolbar'),
                    items: (node)=>{
                        const annotationState = api?.annotation?.sharedState.currentState();
                        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationState?.annotations[mark.attrs.id] === false);
                        const showAnnotation = annotationState && annotationState.isVisible && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !activeCommentMark && isViewMode();
                        if (showAnnotation) return [
                            {
                                type: 'button',
                                showTitle: true,
                                testId: 'add-comment-emoji-button',
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
                                title: intl.formatMessage((0, $ahUGI.annotationMessages).createComment),
                                onClick: onClick,
                                tooltipContent: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
                                    description: intl.formatMessage((0, $ahUGI.annotationMessages).createComment)
                                }),
                                supportsViewMode: true
                            }
                        ];
                        return [];
                    }
                };
            }
        }
    };
};
/**
 * Actions
 */ const $8d1c5078b4947753$var$setAsciiMap = (asciiMap)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $cKEEj.setAsciiMap)(asciiMap)(state.tr);
            dispatch(tr);
        }
        return true;
    };
function $8d1c5078b4947753$export$ae9fa76f15c1e295(fn, limitTime, limitCount, onLimitReached) {
    let lastCallTime = 0;
    let callCount = 0;
    return function wrappedFn(...args) {
        const now = Date.now();
        if (now - lastCallTime < limitTime) {
            if (++callCount > limitCount) onLimitReached?.();
        } else {
            lastCallTime = now;
            callCount = 1;
        }
        return fn(...args);
    };
}
// At this stage console.error only
const $8d1c5078b4947753$var$logRateWarning = ()=>{};
const $8d1c5078b4947753$var$setProviderTr = $8d1c5078b4947753$export$ae9fa76f15c1e295((provider)=>(tr)=>(0, $cKEEj.setProvider)(provider)(tr), // If we change the emoji provider more than three times every 5 seconds we should warn.
// This seems like a really long time but the performance can be that laggy that we don't
// even get 3 events in 3 seconds and miss this indicator.
5000, 3, $8d1c5078b4947753$var$logRateWarning);
const $8d1c5078b4947753$var$setProvider = (provider)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = $8d1c5078b4947753$var$setProviderTr(provider)(state.tr);
            dispatch(tr);
        }
        return true;
    };
const $8d1c5078b4947753$export$e3ef5170578bd8ba = new (0, $ks2lK.PluginKey)('emojiPlugin');
function $8d1c5078b4947753$var$getEmojiPluginState(state) {
    return $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(state) || {};
}
function $8d1c5078b4947753$var$createEmojiPlugin(pmPluginFactoryParams, options, api) {
    return new (0, $1S4f7.SafePlugin)({
        key: $8d1c5078b4947753$export$e3ef5170578bd8ba,
        state: {
            init () {
                if (options?.emojiProvider && (0, $iu6m9.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)) return {
                    emojiProviderPromise: options.emojiProvider
                };
                return {};
            },
            apply (tr, pluginState) {
                const { action: action, params: params } = tr.getMeta($8d1c5078b4947753$export$e3ef5170578bd8ba) || {
                    action: null,
                    params: null
                };
                let newPluginState = pluginState;
                switch(action){
                    case (0, $cKEEj.ACTIONS).SET_PROVIDER:
                        newPluginState = {
                            ...pluginState,
                            emojiProvider: params.provider,
                            emojiProviderPromise: (0, $iu6m9.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true) ? Promise.resolve(params.provider) : undefined
                        };
                        pmPluginFactoryParams.dispatch($8d1c5078b4947753$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $cKEEj.ACTIONS).SET_ASCII_MAP:
                        newPluginState = {
                            ...pluginState,
                            asciiMap: params.asciiMap
                        };
                        pmPluginFactoryParams.dispatch($8d1c5078b4947753$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $cKEEj.ACTIONS).SET_INLINE_POPUP:
                        newPluginState = {
                            ...pluginState,
                            inlineEmojiPopupOpen: params.open
                        };
                        pmPluginFactoryParams.dispatch($8d1c5078b4947753$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                }
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                emoji: (node)=>{
                    return new (0, $lhIns.EmojiNodeView)(node, {
                        intl: pmPluginFactoryParams.getIntl(),
                        api: api,
                        emojiNodeDataProvider: options?.emojiNodeDataProvider
                    });
                }
            }
        },
        view (editorView) {
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'emojiProvider':
                        if (!providerPromise) return $8d1c5078b4947753$var$setProvider?.(undefined)?.(editorView.state, editorView.dispatch);
                        providerPromise.then((provider)=>{
                            $8d1c5078b4947753$var$setProvider?.(provider)?.(editorView.state, editorView.dispatch);
                            provider.getAsciiMap().then((asciiMap)=>{
                                $8d1c5078b4947753$var$setAsciiMap(asciiMap)(editorView.state, editorView.dispatch);
                            });
                        }).catch(()=>$8d1c5078b4947753$var$setProvider?.(undefined)?.(editorView.state, editorView.dispatch));
                        break;
                }
                return;
            };
            if (options?.emojiProvider) providerHandler('emojiProvider', options.emojiProvider);
            return {
                destroy () {
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('emojiProvider', providerHandler);
                }
            };
        }
    });
}
module.exports["emojiPlugin"] = $8d1c5078b4947753$export$d1221bd3f80501e0;
module.exports["emojiPluginKey"] = $8d1c5078b4947753$export$e3ef5170578bd8ba;

});

parcelRegister("kQc80", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $bYZ53 = parcelRequire("bYZ53");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");

const $86388d1937acfc41$export$c62c7770bca4be17 = (doc, pos, emoji)=>{
    const { id: id = '', fallback: fallback, shortName: shortName } = emoji;
    const annotationMarksForPos = (0, $bYZ53.getAnnotationMarksForPos)(pos);
    const emojiNode = doc.type.schema.nodes.emoji.createChecked({
        shortName: shortName,
        id: id,
        text: fallback || shortName
    }, null, annotationMarksForPos);
    const space = doc.type.schema.text(' ', annotationMarksForPos);
    return (0, $5SAOw.Fragment).fromArray([
        emojiNode,
        space
    ]);
};
const $86388d1937acfc41$export$8d5c072327044b6f = (editorAnalyticsAPI)=>(emojiId, inputMethod)=>{
        return ({ tr: tr })=>{
            const { doc: doc, selection: selection } = tr;
            const { emoji: emoji } = tr.doc.type.schema.nodes;
            if (emoji && emojiId) {
                const fragment = $86388d1937acfc41$export$c62c7770bca4be17(doc, selection.$head, emojiId);
                const newTr = (0, $8m4tT.safeInsert)(fragment)(tr);
                if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).INSERTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EMOJI,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })(newTr);
                newTr.setSelection((0, $ks2lK.Selection).near(newTr.doc.resolve(selection.$from.pos + fragment.size)));
                return newTr;
            }
            return null;
        };
    };
module.exports["createEmojiFragment"] = $86388d1937acfc41$export$c62c7770bca4be17;
module.exports["insertEmoji"] = $86388d1937acfc41$export$8d5c072327044b6f;

});

parcelRegister("j0XxS", function(module, exports) {

var $bIZRt = parcelRequire("bIZRt");


var $24P9d = parcelRequire("24P9d");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");

const $ef49a6b5d9cf65a1$var$isSSR = Boolean(undefined);
const $ef49a6b5d9cf65a1$export$d122e24cc43292f6 = ()=>{
    const emojiNode = (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $bIZRt.emojiWithLocalId) : (0, $bIZRt.emoji);
    if ($ef49a6b5d9cf65a1$var$isSSR) return emojiNode;
    return {
        ...emojiNode,
        toDOM: (node)=>$ef49a6b5d9cf65a1$export$9edeb07c311f4561(node)
    };
};
function $ef49a6b5d9cf65a1$export$9edeb07c311f4561(node) {
    // From packages/elements/emoji/src/components/common/EmojiPlaceholder.tsx
    const { shortName: shortName, id: id, text: text } = node.attrs;
    const isEmojiScalingEnabled = (0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true);
    const attrs = {
        'data-emoji-short-name': shortName,
        'data-emoji-id': id,
        'data-emoji-text': text,
        contenteditable: 'false',
        style: (0, $24P9d.convertToInlineCss)({
            content: "''",
            fill: "var(--ds-background-neutral, #0515240F)",
            ...isEmojiScalingEnabled ? {
                minWidth: '16.25px',
                minHeight: '16.25px'
            } : {
                minWidth: `20px`,
                width: `20px`,
                height: `20px`
            },
            position: 'relative',
            margin: '-1px 0',
            display: 'inline-block',
            background: "var(--ds-background-neutral, #0515240F)",
            borderRadius: "var(--ds-radius-small, 3px)",
            overflow: 'hidden',
            verticalAlign: 'middle',
            whiteSpace: 'nowrap',
            textAlign: 'center'
        }),
        'aria-busy': 'true',
        'aria-label': shortName,
        class: 'emoji-common-placeholder'
    };
    if ((0, $dh538.fg)('platform_editor_adf_with_localid')) attrs['data-local-id'] = node.attrs.localId;
    return [
        'span',
        attrs
    ];
}
module.exports["emojiNodeSpec"] = $ef49a6b5d9cf65a1$export$d122e24cc43292f6;
module.exports["emojiToDom"] = $ef49a6b5d9cf65a1$export$9edeb07c311f4561;

});

parcelRegister("lhIns", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");

var $98HrB = parcelRequire("98HrB");

var $ig7BH = parcelRequire("ig7BH");


var $hWRJP = parcelRequire("hWRJP");


var $5SAOw = parcelRequire("5SAOw");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $j0XxS = parcelRequire("j0XxS");

function $14dc3fa642295a9f$export$1d677781db73ff20(fallbackText) {
    // Regular expression to match a single emoji character
    const emojiRegex = // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    RegExp("^(\\p{Emoji_Presentation}|\\p{Extended_Pictographic}\\u{FE0F}?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?)+|\\p{Regional_Indicator}\\p{Regional_Indicator})$", "u");
    return emojiRegex.test(fallbackText);
}
class $14dc3fa642295a9f$export$cadc6675ce598ba8 {
    static logError(error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-emoji/EmojiNodeView'
        });
    }
    /** Type guard to check if a Node is an HTMLElement in a safe way. */ isHTMLElement(element) {
        if (element === null) return false;
        // In SSR `HTMLElement` is not defined, so we need to use duck typing here
        return 'innerHTML' in element && 'style' in element && 'classList' in element;
    }
    async updateDom(emojiProvider) {
        try {
            const { shortName: shortName, id: id, text: fallback } = this.node.attrs;
            const emojiDescription = await emojiProvider?.fetchByEmojiId({
                id: id,
                shortName: shortName,
                fallback: fallback
            }, true);
            if (!emojiDescription) {
                $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(new Error('Emoji description is not loaded'));
                this.renderFallback();
                return;
            }
            const emojiRepresentation = emojiDescription?.representation;
            if (!$14dc3fa642295a9f$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(new Error('Emoji representation is not supported'));
                this.renderFallback();
                return;
            }
            this.renderEmoji(emojiDescription, emojiRepresentation);
        } catch (error) {
            $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(error instanceof Error ? error : new Error('Unknown error on EmojiNodeView updateDom'));
            this.renderFallback();
        }
    }
    static isEmojiRepresentationSupported(representation) {
        return !!representation && ('sprite' in representation || 'imagePath' in representation || 'mediaPath' in representation);
    }
    // Pay attention, this method should be called only when the emoji provider returns
    // emoji data to prevent rendering empty emoji during loading.
    cleanUpAndRenderCommonAttributes() {
        // Clean up the DOM before rendering the new emoji
        if (this.domElement) {
            this.domElement.innerHTML = '';
            this.domElement.style.cssText = '';
            this.domElement.classList.remove((0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER);
            this.domElement.removeAttribute('aria-label'); // The label is set in the renderEmoji method
            this.domElement.removeAttribute('aria-busy');
        }
    }
    renderFallback() {
        this.renderingFallback = true;
        this.cleanUpAndRenderCommonAttributes();
        const fallbackElement = document.createElement('span');
        fallbackElement.innerText = this.node.attrs.text || this.node.attrs.shortName;
        fallbackElement.setAttribute('data-testid', `fallback-emoji-${this.node.attrs.shortName}`);
        fallbackElement.setAttribute('data-emoji-type', 'fallback');
        this.dom.appendChild(fallbackElement);
    }
    renderEmoji(description, representation) {
        this.renderingFallback = false;
        this.cleanUpAndRenderCommonAttributes();
        const emojiType = 'sprite' in representation ? 'sprite' : 'image';
        // Add wrapper for the emoji
        const containerElement = document.createElement('span');
        containerElement.setAttribute('role', 'img');
        containerElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_CONTAINER);
        containerElement.setAttribute('data-testid', `${emojiType}-emoji-${description.shortName}`);
        containerElement.setAttribute('data-emoji-type', emojiType);
        containerElement.setAttribute('aria-label', `${this.intl.formatMessage((0, $ig7BH.messages).emojiNodeLabel)} ${description.shortName}`);
        const emojiElement = 'sprite' in representation ? this.createSpriteEmojiElement(representation) : this.createImageEmojiElement(description, representation);
        containerElement.appendChild(emojiElement);
        this.dom.appendChild(containerElement);
    }
    createSpriteEmojiElement(representation) {
        const spriteElement = document.createElement('span');
        spriteElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE);
        const sprite = representation.sprite;
        const xPositionInPercent = 100 / (sprite.column - 1) * representation.xIndex;
        const yPositionInPercent = 100 / (sprite.row - 1) * representation.yIndex;
        spriteElement.style.backgroundImage = `url(${sprite.url})`;
        spriteElement.style.backgroundPosition = `${xPositionInPercent}% ${yPositionInPercent}%`;
        spriteElement.style.backgroundSize = `${sprite.column * 100}% ${sprite.row * 100}%`;
        spriteElement.style.minWidth = `${0, $fhsiz.defaultEmojiHeight}px`;
        spriteElement.style.minHeight = `${0, $fhsiz.defaultEmojiHeight}px`;
        if (!(0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) {
            spriteElement.style.width = `${0, $fhsiz.defaultEmojiHeight}px`;
            spriteElement.style.height = `${0, $fhsiz.defaultEmojiHeight}px`;
        }
        return spriteElement;
    }
    createImageEmojiElement(emojiDescription, representation) {
        const imageElement = document.createElement('img');
        imageElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE);
        imageElement.src = 'imagePath' in representation ? representation.imagePath : representation.mediaPath;
        imageElement.loading = 'lazy';
        imageElement.alt = emojiDescription.name || emojiDescription.shortName;
        if ((0, $1oCLl.expValEquals)('platform_editor_emoji_otp', 'isEnabled', true)) {
            imageElement.style.minWidth = `${0, $fhsiz.defaultEmojiHeight}px`;
            imageElement.style.objectFit = 'contain';
        }
        if (representation.width && representation.height) {
            imageElement.height = (0, $fhsiz.defaultEmojiHeight);
            if (!(0, $1oCLl.expValEquals)('platform_editor_emoji_otp', 'isEnabled', true)) // Because img.width is round to the nearest integer.
            imageElement.setAttribute('width', `${(0, $fhsiz.defaultEmojiHeight) / representation.height * representation.width}`);
        }
        imageElement.onerror = ()=>{
            if ((0, $1oCLl.expValEquals)('platform_editor_emoji_otp', 'isEnabled', true)) {
                this.renderFallback();
                return;
            }
            if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
                // If there's an error (ie. offline) render the ascii fallback if possible, otherwise
                // mark the node to refresh when returning online.
                // Create a check that confirms if this.node.attrs.text if an ascii emoji
                if ($14dc3fa642295a9f$export$1d677781db73ff20(this.node.attrs.text)) this.renderFallback();
                else this.renderingFallback = true;
            }
        };
        return imageElement;
    }
    /**
   * Prosemirror node view for rendering emoji nodes. This class is responsible for
   * rendering emoji nodes in the editor, handling updates, and managing fallback rendering.
   *
   * @param node - The ProseMirror node representing the emoji.
   * @param extraProps - An object containing additional parameters.
   * @param extraProps.intl - The internationalization object for formatting messages.
   * @param extraProps.api - The editor API for accessing shared state and connectivity features.
   * @param extraProps.emojiNodeDataProvider - (Optional) A provider for fetching emoji data.
   *
   * @example
   * const emojiNodeView = new EmojiNodeView(node, { intl, api, emojiNodeDataProvider });
   */ constructor(node, { intl: intl, api: api, emojiNodeDataProvider: emojiNodeDataProvider }){
        this.dom = void 0;
        this.domElement = void 0;
        this.node = void 0;
        this.intl = void 0;
        this.renderingFallback = false;
        this.destroy = ()=>{};
        this.node = node;
        this.intl = intl;
        const { dom: dom } = (0, $5SAOw.DOMSerializer).renderSpec(document, (0, $j0XxS.emojiToDom)(this.node));
        this.dom = dom;
        if ((0, $1oCLl.expValEquals)('platform_editor_emoji_otp', 'isEnabled', true)) this.domElement = this.isHTMLElement(dom) ? dom : undefined;
        else this.domElement = dom instanceof HTMLElement ? dom : undefined;
        if ((0, $1oCLl.expValEquals)('platform_editor_emoji_otp', 'isEnabled', true) && emojiNodeDataProvider) {
            let previousEmojiDescription;
            emojiNodeDataProvider.getData(node, (payload)=>{
                if (payload.error) {
                    $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(payload.error);
                    this.renderFallback();
                    return;
                }
                const optionalEmojiDescription = payload.data;
                if (!optionalEmojiDescription) {
                    this.renderFallback();
                    return;
                }
                const emojiRepresentation = optionalEmojiDescription?.representation;
                if (!$14dc3fa642295a9f$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                    this.renderFallback();
                    return;
                }
                if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(previousEmojiDescription, optionalEmojiDescription)) // Do not re-render if the emoji description is the same as before
                return;
                previousEmojiDescription = optionalEmojiDescription;
                this.renderEmoji(optionalEmojiDescription, emojiRepresentation);
            });
        } else {
            if ((0, $eTj7Y.isSSR)()) // The provider doesn't work in SSR, and we don't want to render fallback in SSR,
            // that's why we don't need to continue node rendering.
            // In SSR we want to show a placeholder, that `emojiToDom()` returns.
            return;
            // We use the `emojiProvider` from the shared state
            // because it supports the `emojiProvider` prop in the `ComposableEditor` options
            // as well as the `emojiProvider` in the `EmojiPlugin` options.
            const sharedState = api?.emoji?.sharedState;
            if (!sharedState) return;
            let emojiProvider = sharedState.currentState()?.emojiProvider;
            if (emojiProvider) this.updateDom(emojiProvider);
            const unsubscribe = sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if (emojiProvider === nextSharedState?.emojiProvider) // Do not update if the provider is the same
                return;
                emojiProvider = nextSharedState?.emojiProvider;
                this.updateDom(emojiProvider);
            });
            // Refresh emojis if we go back online
            const subscribeToConnection = api?.connectivity?.sharedState.onChange(({ prevSharedState: prevSharedState, nextSharedState: nextSharedState })=>{
                if (prevSharedState?.mode === 'offline' && nextSharedState?.mode === 'online' && this.renderingFallback && (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) this.updateDom(sharedState.currentState()?.emojiProvider);
            });
            this.destroy = ()=>{
                unsubscribe();
                subscribeToConnection?.();
            };
        }
    }
}
module.exports["EmojiNodeView"] = $14dc3fa642295a9f$export$cadc6675ce598ba8;

});

parcelRegister("ig7BH", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $2faac4f2f00836b4$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    emojiNodeLabel: {
        id: "fabric.emoji.label",
        defaultMessage: "Emoji"
    }
});
module.exports["messages"] = $2faac4f2f00836b4$export$defe85febe8b728c;

});

parcelRegister("cKEEj", function(module, exports) {

var $hcboS = parcelRequire("hcboS");

const $38eca9ebbfac95ba$export$92a1a3b7554e9387 = {
    SET_PROVIDER: 'SET_PROVIDER',
    SET_RESULTS: 'SET_RESULTS',
    SET_ASCII_MAP: 'SET_ASCII_MAP',
    SET_INLINE_POPUP: 'SET_INLINE_POPUP'
};
const $38eca9ebbfac95ba$export$5e8f481ab8296997 = (asciiMap)=>(tr)=>{
        return tr.setMeta((0, $hcboS.emojiPluginKey), {
            action: $38eca9ebbfac95ba$export$92a1a3b7554e9387.SET_ASCII_MAP,
            params: {
                asciiMap: asciiMap
            }
        });
    };
const $38eca9ebbfac95ba$export$adbec20dbbf15a6b = (typeaheadHandler, api)=>(inputMethod)=>{
        return Boolean(api?.typeAhead?.actions.open({
            triggerHandler: typeaheadHandler,
            inputMethod: inputMethod
        }));
    };
const $38eca9ebbfac95ba$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return tr.setMeta((0, $hcboS.emojiPluginKey), {
            action: $38eca9ebbfac95ba$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        });
    };
const $38eca9ebbfac95ba$export$f53f9c9a74ec859b = (open)=>(tr)=>tr.setMeta((0, $hcboS.emojiPluginKey), {
            action: $38eca9ebbfac95ba$export$92a1a3b7554e9387.SET_INLINE_POPUP,
            params: {
                open: open
            }
        });
module.exports["ACTIONS"] = $38eca9ebbfac95ba$export$92a1a3b7554e9387;
module.exports["setAsciiMap"] = $38eca9ebbfac95ba$export$5e8f481ab8296997;
module.exports["openTypeAhead"] = $38eca9ebbfac95ba$export$adbec20dbbf15a6b;
module.exports["setProvider"] = $38eca9ebbfac95ba$export$1572b3eade6662f9;
module.exports["setInlineEmojiPopupOpen"] = $38eca9ebbfac95ba$export$f53f9c9a74ec859b;

});

parcelRegister("cTFYB", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $1S4f7 = parcelRequire("1S4f7");


var $l03WE = parcelRequire("l03WE");


var $aIMBk = parcelRequire("aIMBk");

var $14sLv = parcelRequire("14sLv");


var $1oCLl = parcelRequire("1oCLl");

let $4f54215972d22941$var$matcher;
function $4f54215972d22941$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi, disableAutoformat) {
    if (disableAutoformat && (0, $1oCLl.expValEquals)('platform_editor_plain_text_support', 'isEnabled', true)) return;
    if (schema.nodes.emoji) {
        $4f54215972d22941$var$initMatcher(pluginInjectionApi);
        const asciiEmojiRule = (0, $l03WE.createRule)((0, $1oCLl.expValEquals)('platform_editor_wait_for_space_after_ascii_emoji', 'isEnabled', true) ? $4f54215972d22941$var$AsciiEmojiMatcher.REGEX_WITH_WHITESPACE : $4f54215972d22941$var$AsciiEmojiMatcher.REGEX_LEGACY, $4f54215972d22941$var$inputRuleHandler(editorAnalyticsAPI));
        return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('emoji', [
            asciiEmojiRule
        ]));
    }
    return;
}
function $4f54215972d22941$var$initMatcher(pluginInjectionApi) {
    pluginInjectionApi?.emoji.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
        const emojiProvider = nextSharedState?.emojiProvider;
        if (emojiProvider) emojiProvider.getAsciiMap().then((map)=>{
            $4f54215972d22941$var$matcher = new $4f54215972d22941$var$RecordingAsciiEmojiMatcher(emojiProvider, map);
        });
    });
}
const $4f54215972d22941$var$inputRuleHandler = (editorAnalyticsAPI)=>(state, matchParts, start, end)=>{
        if (!$4f54215972d22941$var$matcher) return null;
        const match = $4f54215972d22941$var$matcher.match(matchParts);
        if (match) {
            const transactionCreator = new $4f54215972d22941$var$AsciiEmojiTransactionCreator(state, match, start, end, editorAnalyticsAPI);
            return transactionCreator.create();
        }
        return null;
    };
const $4f54215972d22941$var$REGEX_LEADING_CAPTURE_INDEX = 1;
const $4f54215972d22941$var$REGEX_EMOJI_LEADING_PARENTHESES = 2;
const $4f54215972d22941$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX = 3;
const $4f54215972d22941$var$REGEX_TRAILING_CAPTURE_INDEX = 4;
const $4f54215972d22941$var$getLeadingString = (match, withParenthesis = true)=>match[$4f54215972d22941$var$REGEX_LEADING_CAPTURE_INDEX] + (withParenthesis ? match[$4f54215972d22941$var$REGEX_EMOJI_LEADING_PARENTHESES] : '');
const $4f54215972d22941$var$getLeadingStringWithoutParentheses = (match)=>$4f54215972d22941$var$getLeadingString(match, false);
const $4f54215972d22941$var$getAscii = (match, withParentheses = false)=>(withParentheses ? match[$4f54215972d22941$var$REGEX_EMOJI_LEADING_PARENTHESES] : '') + match[$4f54215972d22941$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX].trim();
const $4f54215972d22941$var$getAsciiWithParentheses = (matchParts)=>$4f54215972d22941$var$getAscii(matchParts, true);
const $4f54215972d22941$var$getTrailingString = (match)=>match[$4f54215972d22941$var$REGEX_TRAILING_CAPTURE_INDEX] || '';
class $4f54215972d22941$var$AsciiEmojiMatcher {
    match(matchParts) {
        return this.getAsciiEmojiMatch($4f54215972d22941$var$getLeadingStringWithoutParentheses(matchParts), $4f54215972d22941$var$getAsciiWithParentheses(matchParts), $4f54215972d22941$var$getTrailingString(matchParts)) || this.getAsciiEmojiMatch($4f54215972d22941$var$getLeadingString(matchParts), $4f54215972d22941$var$getAscii(matchParts), $4f54215972d22941$var$getTrailingString(matchParts));
    }
    getAsciiEmojiMatch(leading, ascii, trailing) {
        const emoji = this.asciiToEmojiMap.get(ascii);
        return emoji ? {
            emoji: emoji,
            leadingString: leading,
            trailingString: trailing
        } : undefined;
    }
    constructor(asciiToEmojiMap){
        this.asciiToEmojiMap = void 0;
        this.asciiToEmojiMap = asciiToEmojiMap;
    }
}
/**
 * A matcher that will record ascii matches as usages of the matched emoji.
 */ /**
 * This regex matches 2 scenarios:
 * 1. an emoticon starting with a colon character (e.g. :D => 😃)
 * 2. an emoticon not starting with a colon character (e.g. 8-D => 😎)
 *
 * Explanation (${leafNodeReplacementCharacter} is replaced with character \ufffc)
 *
 *  1st Capturing Group ((?:^|[\s\ufffc])(?:\(*?))
 *    Non-capturing group (?:^|[\s\ufffc])
 *      1st Alternative ^
 *        ^ asserts position at start of the string
 *      2nd Alternative [\s\ufffc]
 *        matches a single character present in [\s\ufffc]
 *    Non-capturing group (?:\(*?)
 *      matches the character ( literally between zero and unlimited times, as few times as possible, expanding as needed (lazy)
 *  2nd Capturing Group (\(?)
 *    matches a single ( if present
 *  3rd Capturing Group ([^:\s\ufffc\(]\S{1,3}|:\S{1,3}( ))
 *    1st Alternative [^:\s\ufffc\(]\S{1,3}
 *      matches a single character not present in [^:\s\ufffc\(] between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *    2nd Alternative :\S{1,3}( )
 *      : matches the character : literally
 *      \S{1,3} matches any non-whitespace character between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *  4th Capturing Group ( )
 *
 * See https://regex101.com/r/HRS9O2/4
 */ // New behavior: All emoticons require whitespace after them
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
$4f54215972d22941$var$AsciiEmojiMatcher.REGEX_WITH_WHITESPACE = new RegExp(`((?:^|[\\s${(0, $14sLv.leafNodeReplacementCharacter)}])(?:\\(*?))(\\(?)([^:\\s${(0, $14sLv.leafNodeReplacementCharacter)}\\(]\\S{1,3}|:\\S{1,3})([\\s\\t\\n])$`);
// Legacy behavior: Non-colon emoticons don't require whitespace
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
$4f54215972d22941$var$AsciiEmojiMatcher.REGEX_LEGACY = new RegExp(`((?:^|[\\s${(0, $14sLv.leafNodeReplacementCharacter)}])(?:\\(*?))(\\(?)([^:\\s${(0, $14sLv.leafNodeReplacementCharacter)}\\(]\\S{1,3}|:\\S{1,3}( ))$`);
class $4f54215972d22941$var$RecordingAsciiEmojiMatcher extends $4f54215972d22941$var$AsciiEmojiMatcher {
    match(matchParts) {
        const match = super.match(matchParts);
        if (match && this.emojiProvider.recordSelection) this.emojiProvider.recordSelection(match.emoji);
        return match;
    }
    constructor(emojiProvider, asciiToEmojiMap){
        super(asciiToEmojiMap);
        this.emojiProvider = void 0;
        this.emojiProvider = emojiProvider;
    }
}
class $4f54215972d22941$var$AsciiEmojiTransactionCreator {
    create() {
        const tr = this.state.tr.replaceWith(this.from, this.to, this.createNodes());
        this.editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EMOJI,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).ASCII
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    get from() {
        return this.start + this.match.leadingString.length;
    }
    get to() {
        return this.end;
    }
    createNodes() {
        const nodes = [
            this.createEmojiNode()
        ];
        if (this.trailingTextNodeRequired()) nodes.push(this.createTrailingTextNode());
        return nodes;
    }
    createEmojiNode() {
        const { emoji: emojiTypeNode } = this.state.schema.nodes;
        return emojiTypeNode.create(this.getEmojiNodeAttrs());
    }
    getEmojiNodeAttrs() {
        const emoji = this.match.emoji;
        return {
            id: emoji.id,
            shortName: emoji.shortName,
            text: emoji.fallback || emoji.shortName
        };
    }
    trailingTextNodeRequired() {
        return this.match.trailingString.length > 0;
    }
    createTrailingTextNode() {
        return this.state.schema.text(this.match.trailingString);
    }
    constructor(state, match, start, end, editorAnalyticsAPI){
        this.state = void 0;
        this.match = void 0;
        this.start = void 0;
        this.end = void 0;
        this.editorAnalyticsAPI = void 0;
        this.state = state;
        this.match = match;
        this.start = start;
        this.end = end;
        this.editorAnalyticsAPI = editorAnalyticsAPI;
    }
}
const $4f54215972d22941$var$plugins = (schema, providerFactory, featureFlags, editorAnalyticsAPI, pluginInjectionApi)=>{
    return [
        $4f54215972d22941$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi)
    ].filter((plugin)=>!!plugin);
};
var $4f54215972d22941$export$2e2bcd8739ae039 = $4f54215972d22941$var$plugins;
module.exports["inputRulePlugin"] = $4f54215972d22941$export$568a7ed6897c4817;

});

parcelRegister("aFWfo", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $d925B = parcelRequire("d925B");


var $kuh1P = parcelRequire("kuh1P");


var $1Oo9w = parcelRequire("1Oo9w");


var $jwWgu = parcelRequire("jwWgu");


var $efG2U = parcelRequire("efG2U");


var $b3YrF = parcelRequire("b3YrF");


var $aFUXX = parcelRequire("aFUXX");


var $fnia6 = parcelRequire("fnia6");


var $dh538 = parcelRequire("dh538");


var $cKEEj = parcelRequire("cKEEj");

const $5da86e14354f1f0f$var$PopupWithListeners = (0, $efG2U.default)((0, $jwWgu.default));
const $5da86e14354f1f0f$var$emojiPopupMessages = {
    emojiPickerAriaLabel: {
        id: 'fabric.emoji.picker.aria.label',
        defaultMessage: 'Emoji picker',
        description: 'Accessible label for the emoji picker popup'
    }
};
const $5da86e14354f1f0f$export$b7ec9ebb3bbf8534 = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, onClose: onClose })=>{
    const { emojiProvider: emojiProvider, inlineEmojiPopupOpen: isOpen } = (0, $1Oo9w.useSharedPluginState)(api, [
        'emoji'
    ])?.emojiState ?? {};
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        if (isOpen && (0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        isOpen,
        api
    ]);
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        onClose?.();
    }, [
        onClose,
        api
    ]);
    const focusEditor = (0, $42omo.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $42omo.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $d925B.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    if (!isOpen || !emojiProvider) return null;
    const domRef = (0, $kuh1P.getDomRefFromSelection)(editorView, (0, $d925B.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions);
    return /*#__PURE__*/ (0, $l998X.jsx)($5da86e14354f1f0f$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($5da86e14354f1f0f$var$emojiPopupMessages.emojiPickerAriaLabel),
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $efG2U.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fnia6.EmojiPicker), {
                    emojiProvider: Promise.resolve(emojiProvider),
                    onPickerRef: setOutsideClickTargetRef,
                    onSelection: handleSelection
                })
        })
    });
};
const $5da86e14354f1f0f$var$InlineEmojiPopupContent = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView })=>{
    const emojiProvider = (0, $b3YrF.useSharedPluginStateSelector)(api, 'emoji.emojiProvider');
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        api?.core.actions,
        api?.metrics?.commands
    ]);
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        editorView.dispatch((0, $cKEEj.setInlineEmojiPopupOpen)(false)(editorView.state.tr));
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
    }, [
        editorView,
        api.core.actions,
        api.metrics?.commands
    ]);
    const focusEditor = (0, $42omo.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $42omo.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $d925B.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    const domRef = (0, $42omo.useMemo)(()=>(0, $kuh1P.getDomRefFromSelection)(editorView, (0, $d925B.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions), [
        editorView,
        api?.analytics?.actions
    ]);
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($5da86e14354f1f0f$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($5da86e14354f1f0f$var$emojiPopupMessages.emojiPickerAriaLabel),
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $efG2U.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fnia6.EmojiPicker), {
                    emojiProvider: Promise.resolve(emojiProvider),
                    onPickerRef: setOutsideClickTargetRef,
                    onSelection: handleSelection
                })
        })
    });
};
const $5da86e14354f1f0f$export$295b54f3ba0abfa5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView })=>{
    const isOpen = (0, $b3YrF.useSharedPluginStateSelector)(api, 'emoji.inlineEmojiPopupOpen');
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($5da86e14354f1f0f$var$InlineEmojiPopupContent, {
        api: api,
        editorView: editorView,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement
    });
});
module.exports["InlineEmojiPopup"] = $5da86e14354f1f0f$export$295b54f3ba0abfa5;

});

parcelRegister("kuh1P", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $d925B = parcelRequire("d925B");

const $7e8a46109aa777b7$export$49d74ed2464a12b9 = (view, actionSubjectId, editorAnalyticsAPI)=>{
    try {
        const domRef = (0, $8m4tT.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
        if (domRef instanceof HTMLElement) {
            // If element is not a paragraph, we need to find the closest paragraph parent
            if (domRef.nodeName !== 'P') {
                const paragraphRef = domRef.closest('p');
                if (paragraphRef) return paragraphRef;
            }
            return domRef;
        } else throw new Error('Invalid DOM reference');
    } catch (error) {
        if (editorAnalyticsAPI) {
            const payload = {
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).PICKER,
                actionSubjectId: actionSubjectId,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: 'Error getting DOM reference from selection'
                }
            };
            editorAnalyticsAPI.fireAnalyticsEvent(payload);
        }
    }
};
module.exports["getDomRefFromSelection"] = $7e8a46109aa777b7$export$49d74ed2464a12b9;

});

parcelRegister("a7SsH", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $92a679059989a896$export$fb999f8a83c64817 = /*#__PURE__*/ function(NotificationAction) {
    NotificationAction["NOTIFY"] = "NOTIFY";
    NotificationAction["DONT_NOTIFY"] = "DONT_NOTIFY";
    return NotificationAction;
}({});
module.exports["NotificationAction"] = $92a679059989a896$export$fb999f8a83c64817;

});

parcelRegister("cAdj8", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $1uFM6 = parcelRequire("1uFM6");


var $flE5X = parcelRequire("flE5X");

const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $eSUdr.default)`query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId status:["current" "archived" "draft"]){nodes{id type status space{id}operations{operation targetType}version{number}}}}`;
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    status: '',
    space: {
        id: ''
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    });
    return (0, $42omo.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};
module.exports["usePageInfo"] = $a1394411ec7881e4$export$7b2dac1793a2824;

});

parcelRegister("kGaEh", function(module, exports) {
$parcel$export(module.exports, "EditorTypes", () => (parcelRequire("lWVgZ")).EditorTypes);
$parcel$export(module.exports, "PreviewPageComponent", () => $93081da57503141f$export$376eaf8a4000eb1e);
$parcel$export(module.exports, "PreviewWithRenderer", () => $93081da57503141f$export$702c4e944f9180d3);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");

parcelRequire("lWVgZ");


const $93081da57503141f$export$376eaf8a4000eb1e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uDcJD",
    name: "PreviewPageComponent",
    loader: async ()=>(await (parcelRequire("5rMDr"))).PreviewPageComponent
});

const $93081da57503141f$export$702c4e944f9180d3 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "UqJvA",
    name: "PreviewWithRenderer",
    loader: async ()=>// NOTE: placed into the same chunk as this component is used by Tiny editor and also used internally by PreviewPageComponent
        (await (parcelRequire("74UYY"))).PreviewWithRenderer
});

});

parcelRegister("5rMDr", function(module, exports) {

let $3f7533480cdf13d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f7533480cdf13d7$var$load("lnnYm"),
    $3f7533480cdf13d7$var$load("5odbj"),
    $3f7533480cdf13d7$var$load("2mt3f"),
    $3f7533480cdf13d7$var$load("lPQcc"),
    $3f7533480cdf13d7$var$load("6lM2n")
]).then(()=>parcelRequire('esDVy'));

});

parcelRegister("74UYY", function(module, exports) {

let $52751ba7797ac75d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $52751ba7797ac75d$var$load("lnnYm"),
    $52751ba7797ac75d$var$load("5odbj"),
    $52751ba7797ac75d$var$load("2mt3f"),
    $52751ba7797ac75d$var$load("lPQcc"),
    $52751ba7797ac75d$var$load("6lM2n")
]).then(()=>parcelRequire('cPug3'));

});

parcelRegister("lWVgZ", function(module, exports) {
var $65441210bfcb6bd9$export$bb6127f23acfd41c = /*#__PURE__*/ function(EditorTypes) {
    EditorTypes["NCS"] = "ncs";
    EditorTypes["SYNCHRONY"] = "synchrony";
    EditorTypes["TEMPLATE"] = "template";
    return EditorTypes;
}({});
module.exports["EditorTypes"] = $65441210bfcb6bd9$export$bb6127f23acfd41c;

});

parcelRegister("2HGN8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $hYoU4 = parcelRequire("hYoU4");


var $8VcPj = parcelRequire("8VcPj");


var $1d2ww = parcelRequire("1d2ww");

const $652df36b21c46ede$var$ContentAppearanceContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    contentAppearance: {
        appearance: (0, $1d2ww.ContentAppearanceType).DEFAULT,
        version: 0
    },
    setContentAppearance: ()=>{},
    contentAppearanceLoading: false
});
const $652df36b21c46ede$export$53c04435be7a0acf = ({ contentId: contentId, children: children })=>{
    const [contentAppearanceOverride, setContentAppearanceOverride] = (0, $42omo.useState)();
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    // Subscribe to metadata:changed events to update the content appearance for collaborators
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleMetadataChanged = (metadata)=>{
            const widthValue = metadata?.editorWidth?.value;
            const version = metadata?.editorWidth?.version;
            if (widthValue) setContentAppearanceOverride((currentAppearance)=>{
                if (!currentAppearance || version > currentAppearance.version) return {
                    appearance: widthValue,
                    version: version
                };
                else return currentAppearance;
            });
        };
        collabEditProvider.on('metadata:changed', handleMetadataChanged);
        return ()=>{
            collabEditProvider.off('metadata:changed', handleMetadataChanged);
        };
    }, [
        collabEditProvider
    ]);
    const draftAppearanceQuery = (0, $8VcPj.getContentAppearanceQuery)((0, $1d2ww.ContentAppearancePropertyKey).DRAFT);
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: initialContentAppearanceData, loading: initialContentAppearanceLoading } = (0, $j1Ss3.useQuery)(draftAppearanceQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        }
    });
    const context = (0, $42omo.useMemo)(()=>{
        const initialContentAppearance = (0, $8VcPj.getContentAppearanceFromQueryData)(initialContentAppearanceData, (0, $1d2ww.ContentAppearancePropertyKey).DRAFT);
        return {
            contentAppearance: contentAppearanceOverride || initialContentAppearance,
            setContentAppearance: setContentAppearanceOverride,
            contentAppearanceLoading: initialContentAppearanceLoading
        };
    }, [
        initialContentAppearanceData,
        initialContentAppearanceLoading,
        contentAppearanceOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($652df36b21c46ede$var$ContentAppearanceContext.Provider, {
        value: context
    }, children);
};
const $652df36b21c46ede$export$c3c73be39a08fc97 = ({ children: children })=>{
    const context = $652df36b21c46ede$export$4cedbdf2fdf3340d();
    return children(context);
};
const $652df36b21c46ede$export$4cedbdf2fdf3340d = ()=>{
    return (0, $42omo.useContext)($652df36b21c46ede$var$ContentAppearanceContext);
};
module.exports["ContentAppearanceContextProvider"] = $652df36b21c46ede$export$53c04435be7a0acf;
module.exports["ContentAppearanceContextConsumer"] = $652df36b21c46ede$export$c3c73be39a08fc97;
module.exports["useContentAppearance"] = $652df36b21c46ede$export$4cedbdf2fdf3340d;

});

parcelRegister("c4PY4", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $6mKj3 = parcelRequire("6mKj3");


var $1d2ww = parcelRequire("1d2ww");

const $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap = {
    [(0, $1d2ww.ContentAppearanceType).DEFAULT]: 'full-page',
    [(0, $1d2ww.ContentAppearanceType).FULL_WIDTH]: 'full-width',
    [(0, $1d2ww.ContentAppearanceType).MAX]: 'max'
};
const $e67a3bdaba93e18b$export$4ca444f48395eebe = (0, $2XqLN.default)((contentAppearance)=>{
    const appearanceForAtlaskit = $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[contentAppearance];
    // Fallback to 'full-width' if 'max' and experiment is off
    if (appearanceForAtlaskit === 'max' && !(0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) && !(0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) return 'full-width';
    if (appearanceForAtlaskit) return appearanceForAtlaskit;
    return $e67a3bdaba93e18b$export$e79a6aa49fcbdebe();
});
const $e67a3bdaba93e18b$export$e79a6aa49fcbdebe = ()=>{
    return $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[(0, $1d2ww.ContentAppearanceType).DEFAULT];
};
module.exports["getContentAppearanceForAtlaskit"] = $e67a3bdaba93e18b$export$4ca444f48395eebe;

});

parcelRegister("gKaeO", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $fdc21a809c69e224$var$EditorRevertDialogContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $fdc21a809c69e224$export$bb04726afe1ab08f = ({ children: children })=>{
    const [shouldShowRevertDialog, setShouldShowRevertDialog] = (0, $42omo.useState)(false);
    const [shouldShowRevertDialogDiff, setShouldShowRevertDialogDiff] = (0, $42omo.useState)(false);
    const hideRevertDialogDiff = (0, $42omo.useCallback)(()=>setShouldShowRevertDialogDiff(false), []);
    const showRevertDialogDiff = (0, $42omo.useCallback)(()=>setShouldShowRevertDialogDiff(true), []);
    const hideRevertDialog = (0, $42omo.useCallback)(()=>setShouldShowRevertDialog(false), []);
    const showRevertDialog = (0, $42omo.useCallback)(()=>{
        setShouldShowRevertDialog(true);
        setShouldShowRevertDialogDiff(false);
    }, []);
    const editorRevertDialogContextValue = (0, $42omo.useMemo)(()=>({
            shouldShowRevertDialog: shouldShowRevertDialog,
            shouldShowRevertDialogDiff: shouldShowRevertDialogDiff,
            hideRevertDialogDiff: hideRevertDialogDiff,
            showRevertDialogDiff: showRevertDialogDiff,
            hideRevertDialog: hideRevertDialog,
            showRevertDialog: showRevertDialog
        }), [
        shouldShowRevertDialog,
        shouldShowRevertDialogDiff,
        hideRevertDialogDiff,
        showRevertDialogDiff,
        hideRevertDialog,
        showRevertDialog
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fdc21a809c69e224$var$EditorRevertDialogContext.Provider, {
        value: editorRevertDialogContextValue
    }, children);
};
const $fdc21a809c69e224$export$6ff48c61ddbf94bf = ()=>{
    const context = (0, $42omo.useContext)($fdc21a809c69e224$var$EditorRevertDialogContext);
    if (context === undefined) throw new Error('EditorRevertDialogContext must be used within an EditorRevertDialogContextProvider');
    return context;
};
function $fdc21a809c69e224$export$bd3b9d76887afd3a(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fdc21a809c69e224$export$bb04726afe1ab08f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, props));
}
module.exports["EditorRevertDialogContextProvider"] = $fdc21a809c69e224$export$bb04726afe1ab08f;
module.exports["useEditorRevertDialogContext"] = $fdc21a809c69e224$export$6ff48c61ddbf94bf;
module.exports["withRevertContext"] = $fdc21a809c69e224$export$bd3b9d76887afd3a;

});

parcelRegister("fE1Ao", function(module, exports) {
/** @graphql cc */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $e9owJ = parcelRequire("e9owJ");


var $8G1o2 = parcelRequire("8G1o2");


var $dqLea = parcelRequire("dqLea");


var $l3Dp5 = parcelRequire("l3Dp5");


var $ge2sX = parcelRequire("ge2sX");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $4o1RV = parcelRequire("4o1RV");


var $jacyh = parcelRequire("jacyh");


var $jT0Cd = parcelRequire("jT0Cd");


var $3ejS6 = parcelRequire("3ejS6");


var $gKaeO = parcelRequire("gKaeO");


var $lRON8 = parcelRequire("lRON8");


var $1lZlH = parcelRequire("1lZlH");


var $4B8iP = parcelRequire("4B8iP");

const $5f783a6f76a26815$var$EditorRevertDialogContentQuery = (0, $eSUdr.default)`query EditorRevertDialogContentQuery($contentId:ID$status:[String]){content(id:$contentId status:$status){nodes{id type version{number}metadata{labels{id name}}links{webui context}}}}`;
const $5f783a6f76a26815$export$12786e122b13d0cd = (props)=>{
    const { contentId: contentId, isUnpublishedDraft: isUnpublishedDraft } = props;
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)($5f783a6f76a26815$var$EditorRevertDialogContentQuery, {
        variables: {
            contentId: contentId,
            status: [
                isUnpublishedDraft ? 'draft' : 'current'
            ]
        }
    });
    if (loading || error) return null;
    const content = (data?.content?.nodes ?? [])[0] ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5f783a6f76a26815$var$EditorRevertDialogContainer, {
        ...props,
        content: content
    });
};
const $5f783a6f76a26815$var$EditorRevertDialogContainer = (props)=>{
    const { relations: collaborators, loading: fetchingCollaboratorRelations, error: errorFetchingCollaborators } = (0, $3ejS6.useContentRelations)('collaborator', props.contentId, props.isUnpublishedDraft);
    const { relations: touched, loading: fetchingTouchedRelations, error: errorFetchingTouched } = (0, $3ejS6.useContentRelations)('touched', props.contentId, props.isUnpublishedDraft);
    const analyticsData = {
        blueprintType: (0, $1lZlH.getBlueprintType)(props.content),
        contentId: props.contentId,
        contentType: props.content?.type ?? '',
        spaceKey: props.spaceKey,
        version: props.content?.version?.number ?? undefined,
        source: 'next-EditorRevertDialogComponent',
        subject: 'revertOrDeleteDialog'
    };
    const { triggerAnalyticsEvent: triggerAnalyticsEvent } = (0, $e9owJ.useEditorAnalyticsEvent)(analyticsData);
    const { forceRefetchBlogTree: forceRefetchBlogTree } = (0, $jacyh.useBlogTreeActions)();
    const { matchSupportedRoute: matchSupportedRoute, push: push, replace: replace, match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const shouldPushInSelf = (path)=>{
        return !routePolicy || routePolicy.willPushInSelf(match?.name, match?.params.contentId, path, undefined);
    };
    const { shouldShowRevertDialog: shouldShowRevertDialog, shouldShowRevertDialogDiff: shouldShowRevertDialogDiff, hideRevertDialogDiff: hideRevertDialogDiff, showRevertDialogDiff: showRevertDialogDiff, hideRevertDialog: hideRevertDialog } = (0, $gKaeO.useEditorRevertDialogContext)();
    const mutationVars = {
        contentId: props.contentId
    };
    const onCompleted = (data)=>{
        if (data.experimentalRevertContent) {
            hideRevertDialog();
            const viewPagePath = (props.content?.links?.context ?? '') + (props.content?.links?.webui ?? '');
            props.cancelDebouncedSaveDraft?.();
            if (shouldPushInSelf(matchSupportedRoute(viewPagePath))) {
                if (viewPagePath !== '') push(viewPagePath);
            }
        }
    };
    const [revertContent] = (0, $4B8iP.useExperimentalRevertContentMutation)({
        onCompleted: onCompleted
    });
    const [deleteContent] = (0, $j1Ss3.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $lRON8.DeleteDraftMutationForRevertDialog), {
        variables: mutationVars,
        onCompleted: (data)=>{
            if (data.deleteContent.contentId) {
                const route = getAncestorRoute(props.spaceKey);
                hideRevertDialog();
                props.cancelDebouncedSaveDraft?.();
                if (shouldPushInSelf(route)) replace(route);
                if (props.content?.type === (0, $l3Dp5.ContentTypeType).BLOGPOST) // update blog tree after unpublished blog draft is deleted
                forceRefetchBlogTree();
            }
        }
    });
    const errorFetchingRelations = errorFetchingCollaborators !== undefined || errorFetchingTouched !== undefined;
    const breadcrumbs = (0, $8G1o2.useEditorBreadcrumbs)(props.contentId);
    const getAncestorRoute = (spaceKey)=>{
        // Gets the nearest ancestor in breadcrumbs. Use space index as fallback route in case of error or if page is a blog
        let url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        });
        if (props.content?.type === (0, $l3Dp5.ContentTypeType).PAGE && breadcrumbs) url = (0, $dqLea.getNearestVisibleAncestor)({
            breadcrumbs: breadcrumbs,
            fallbackUrl: url
        });
        return url;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ge2sX.SessionData), null, (sessionData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jT0Cd.EditorRevertDialogComponent), {
            content: props.content,
            contentId: props.contentId,
            isUnpublishedDraft: props.isUnpublishedDraft,
            triggerAnalyticsEvent: triggerAnalyticsEvent,
            collaboratorRelations: collaborators,
            touchedRelations: touched,
            fetchingCollaboratorRelations: fetchingCollaboratorRelations,
            fetchingTouchedRelations: fetchingTouchedRelations,
            shouldShowRevertDialog: shouldShowRevertDialog,
            shouldShowRevertDialogDiff: shouldShowRevertDialogDiff,
            hideRevertDialogDiff: hideRevertDialogDiff,
            showRevertDialogDiff: showRevertDialogDiff,
            hideRevertDialog: hideRevertDialog,
            errorFetchingRelations: errorFetchingRelations,
            revertContent: revertContent,
            deleteContent: deleteContent,
            currentAccountId: sessionData.userId,
            contentType: props.content?.type
        }));
};
module.exports["EditorRevertDialog"] = $5f783a6f76a26815$export$12786e122b13d0cd;

});

parcelRegister("8G1o2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $8WndG = parcelRequire("8WndG");


var $eitcW = parcelRequire("eitcW");

function $4afe25e74c0897d4$export$af6ae8f81a672789(contentId) {
    const queryArgs = {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    };
    const { data: data, error: error } = (0, $eitcW.useExperimentalEditorBreadcrumbsQuery)(queryArgs);
    const breadcrumbs = (0, $8WndG.handleEditorBreadcrumbsQueryResult)(data, error);
    const memoizedBreadcrumbs = (0, $42omo.useMemo)(()=>{
        return (0, $8WndG.handleEditorBreadcrumbsQueryResult)(data, error);
    }, [
        data,
        error
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? memoizedBreadcrumbs : breadcrumbs;
}
module.exports["useEditorBreadcrumbs"] = $4afe25e74c0897d4$export$af6ae8f81a672789;

});

parcelRegister("8WndG", function(module, exports) {

var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $6fil2 = parcelRequire("6fil2");

function $808c5ea5e28dcdc3$export$ba755fc0ebb98c2(data, error) {
    if (error) {
        if ((0, $6fil2.containsNetworkError)(error) || (0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
    }
    return data?.experimentalEditorBreadcrumbs?.breadcrumbs || [];
}
module.exports["handleEditorBreadcrumbsQueryResult"] = $808c5ea5e28dcdc3$export$ba755fc0ebb98c2;

});

parcelRegister("eitcW", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $aBfpe = parcelRequire("aBfpe");

const $5d9a3cd7c3da867c$export$dbbd3a7f70eb1e5d = ({ variables: variables, skip: skip, onError: onError })=>{
    const { contentId: contentId } = variables;
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/pages/breadcrumb.action?pageId=${contentId}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: (json, _variables)=>{
            if (!contentId) throw new Error('contentId is missing.');
            return {
                experimentalEditorBreadcrumbs: {
                    breadcrumbs: json?.breadcrumbs || null
                }
            };
        },
        skip: skip,
        variables: variables,
        onError: onError
    });
};
module.exports["useExperimentalEditorBreadcrumbsQuery"] = $5d9a3cd7c3da867c$export$dbbd3a7f70eb1e5d;

});

parcelRegister("dK51B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $42omo.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("fqCbQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $42omo.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $42omo.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("iXGsw", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $42omo.useRef)(null);
    const stopPolling = (0, $42omo.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $42omo.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $42omo.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $42omo.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("dqLea", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $af9bcbfa18f4b3b2$export$ebca4fecfc3d5dab = ({ breadcrumbs: breadcrumbs, fallbackUrl: fallbackUrl })=>{
    let url = fallbackUrl;
    // Loop through all breadcrumbs from bottom up and find the first view page url
    if (breadcrumbs) for(let index = breadcrumbs.length - 1; index >= 0; index--){
        const crumb = breadcrumbs[index];
        const ancestorUrl = crumb?.url;
        if (ancestorUrl && !(0, $1NBp8.RESUME_DRAFT_LEGACY).match(ancestorUrl)) {
            url = ancestorUrl;
            break;
        }
    }
    return url;
};
module.exports["getNearestVisibleAncestor"] = $af9bcbfa18f4b3b2$export$ebca4fecfc3d5dab;

});

parcelRegister("4o1RV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $iV5Ic = parcelRequire("iV5Ic");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

const $f3bd82ae210529c7$export$57395cb9dce31159 = (0, $3u0dr.isReactCompilerActiveV1)() ? function useNavigationPolicy() {
    const $ = (0, $frIzR.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function useNavigationPolicy() {
    const { navigationPolicy: navigationPolicy } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    return (0, $42omo.useMemo)(()=>({
            routePolicy: routePolicy,
            ...shimUrl
        }), [
        routePolicy,
        shimUrl
    ]);
};
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $iV5Ic = parcelRequire("iV5Ic");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $iV5Ic.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $42omo.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $42omo.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $2XqLN = parcelRequire("2XqLN");


var $42omo = parcelRequire("42omo");


var $7CLBv = parcelRequire("7CLBv");


var $dDZcC = parcelRequire("dDZcC");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
const $734ea8da77496ad5$export$8ed0b067e5cd675d = (0, $3u0dr.isReactCompilerActiveV1)() ? function useShimUrl(navigationPolicy) {
    const $ = (0, $frIzR.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
} : function useShimUrl(navigationPolicy) {
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    const shimUrl = (0, $42omo.useCallback)((urlToShim)=>{
        return $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    }, [
        shimTemplate,
        domainNamesToReplace,
        spaceKeyFilter
    ]);
    const shimAdfUrls = (0, $42omo.useCallback)((adf)=>{
        if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
        const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(adf);
        $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        return adfClone;
    }, [
        shimTemplate,
        domainNamesToReplace,
        spaceKeyFilter
    ]);
    const shimHtmlUrls = (0, $42omo.useCallback)((html)=>{
        if (!shimTemplate || !html) return html;
        // shimHtmlUrls is used on legacy macros, but some legacy macros return stringified ADFEntity
        // Check if the input is a JSON-stringified ADFEntity
        try {
            const parsedContent = JSON.parse(html);
            if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                // It's a valid ADF document - check if it needs nested table transformation
                if (html.includes('"extensionKey":"nested-table"')) {
                    const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                    return JSON.stringify(processedAdf);
                } else {
                    // ADF without nested tables - just delegate to shimAdfUrls and stringify the result
                    const shimmedAdf = shimAdfUrls(parsedContent);
                    return JSON.stringify(shimmedAdf);
                }
            }
        } catch  {
        // Not valid JSON, fall through to HTML processing
        }
        // Process as HTML string (for non-ADF content)
        try {
            return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, 'text/html'), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
        } catch  {
            return html;
        }
    }, [
        shimTemplate,
        domainNamesToReplace,
        spaceKeyFilter,
        shimAdfUrls
    ]);
    return (0, $42omo.useMemo)(()=>({
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        }), [
        shimUrl,
        shimAdfUrls,
        shimHtmlUrls
    ]);
};
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $2XqLN.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $2XqLN.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $dDZcC.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("7CLBv", function(module, exports) {

var $ipwYn = parcelRequire("ipwYn");

/** Used to compose bitmasks for cloning. */ var $58d10224aec51c86$var$CLONE_DEEP_FLAG = 1, $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $58d10224aec51c86$var$cloneDeep(value) {
    return $ipwYn(value, $58d10224aec51c86$var$CLONE_DEEP_FLAG | $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $58d10224aec51c86$var$cloneDeep;

});

parcelRegister("jacyh", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $d9bb792bb433dc50$var$initialState = {
    shouldForceRefetch: false
};
const $d9bb792bb433dc50$var$actions = {
    forceRefetchBlogTree: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                shouldForceRefetch: !currentState.shouldForceRefetch
            });
        }
};
const $d9bb792bb433dc50$var$BlogTreeStore = (0, $1P1Tu.createStore)({
    initialState: $d9bb792bb433dc50$var$initialState,
    actions: $d9bb792bb433dc50$var$actions
});
const $d9bb792bb433dc50$export$9638016a54f09a07 = (0, $9zUhf.createHook)($d9bb792bb433dc50$var$BlogTreeStore);
const $d9bb792bb433dc50$export$861bc4451e1cbefa = (0, $9zUhf.createActionsHook)($d9bb792bb433dc50$var$BlogTreeStore);
module.exports["useBlogTreeStore"] = $d9bb792bb433dc50$export$9638016a54f09a07;
module.exports["useBlogTreeActions"] = $d9bb792bb433dc50$export$861bc4451e1cbefa;

});

parcelRegister("jT0Cd", function(module, exports) {
/* eslint-disable react/no-this-in-sfc */ /* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage */ 
var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $6R5uz = parcelRequire("6R5uz");


var $eEA8O = parcelRequire("eEA8O");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $6xdDU = parcelRequire("6xdDU");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $9hlns = parcelRequire("9hlns");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $kj1gY = parcelRequire("kj1gY");


var $l3Dp5 = parcelRequire("l3Dp5");


var $1mHQU = parcelRequire("1mHQU");


var $601vk = parcelRequire("601vk");


var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $jpojX = parcelRequire("jpojX");


var $5IV6g = parcelRequire("5IV6g");

const $0abb7f37a4bc0936$var$JustifyShim = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", props);
const $0abb7f37a4bc0936$var$wrapperSpinnerStyles = (0, $ecnYn.xcss)({
    marginBlock: 'space.600',
    marginInline: 'auto',
    textAlign: 'center'
});
const $0abb7f37a4bc0936$var$WrapperSpinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
    xcss: $0abb7f37a4bc0936$var$wrapperSpinnerStyles
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), null));
const $0abb7f37a4bc0936$var$RevertExperienceTracker = ({ children: children, analyticsAttributes: analyticsAttributes })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { current: expTrackerConfig } = (0, $42omo.useRef)({
        name: (0, $irVI7.EDIT_PAGE_REVERT_DRAFT_EXPERIENCE),
        attributes: {
            ...analyticsAttributes,
            isCompanyHub: isCompanyHub
        }
    });
    (0, $42omo.useEffect)(()=>{
        experienceTracker.start(expTrackerConfig);
        return ()=>experienceTracker.abort({
                ...expTrackerConfig,
                reason: 'Modal closed'
            });
    }, [
        experienceTracker,
        expTrackerConfig
    ]);
    return children({
        experienceResolver: (prom)=>prom.then(()=>experienceTracker.succeed(expTrackerConfig)).catch((error)=>{
                experienceTracker.fail({
                    ...expTrackerConfig,
                    error: error
                });
                throw error;
            })
    });
};
const $0abb7f37a4bc0936$var$closeButtonStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.100'
});
const $0abb7f37a4bc0936$var$CloseButton = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "span",
        xcss: $0abb7f37a4bc0936$var$closeButtonStyles
    }, children);
const $0abb7f37a4bc0936$var$iconDiffNotShownStyles = (0, $ecnYn.xcss)({
    transform: 'rotate(0deg)',
    transition: '0.2s'
});
const $0abb7f37a4bc0936$var$iconDiffShownStyles = (0, $ecnYn.xcss)({
    transform: 'rotate(90deg)',
    transition: '0.2s'
});
const $0abb7f37a4bc0936$var$DiffExpandIcon = ({ isDiffShown: isDiffShown, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: isDiffShown ? $0abb7f37a4bc0936$var$iconDiffShownStyles : $0abb7f37a4bc0936$var$iconDiffNotShownStyles
    }, children);
};
class $0abb7f37a4bc0936$var$EditorRevertDialogComponentClass extends (0, $42omo.PureComponent) {
    render() {
        const { shouldShowRevertDialog: shouldShowRevertDialog, fetchingCollaboratorRelations: fetchingCollaboratorRelations, fetchingTouchedRelations: fetchingTouchedRelations, errorFetchingRelations: errorFetchingRelations, isUnpublishedDraft: isUnpublishedDraft } = this.props;
        if (!shouldShowRevertDialog) return null;
        if (errorFetchingRelations) {
            const errorData = {
                [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).REVERT_CONTENT_ERROR]: true,
                status: null
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $601vk.EditorErrorFlags), {
                errorData: errorData
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0abb7f37a4bc0936$var$RevertExperienceTracker, {
            analyticsAttributes: {
                isUnpublishedDraft: isUnpublishedDraft
            }
        }, ({ experienceResolver: experienceResolver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "editor-revert-modal-dialog"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
                onClose: this._handleRevertDialogDismissed
            }, this._renderHeader(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, fetchingCollaboratorRelations || fetchingTouchedRelations ? $0abb7f37a4bc0936$var$WrapperSpinner : this._renderChildren()), this._renderFooter({
                experienceResolver: experienceResolver
            })()))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            submitting: false
        };
        this._handleRevertDialogDismissed = ()=>this.props.hideRevertDialog();
        this._handleRevertDialogSubmitted = ({ experienceResolver: experienceResolver })=>async ()=>{
                this.setState({
                    submitting: true
                });
                const { isUnpublishedDraft: isUnpublishedDraft, deleteContent: deleteContent, revertContent: revertContent, contentId: contentId, triggerAnalyticsEvent: triggerAnalyticsEvent } = this.props;
                try {
                    if (isUnpublishedDraft) {
                        triggerAnalyticsEvent('deleteContent');
                        await experienceResolver(deleteContent(contentId));
                    } else {
                        triggerAnalyticsEvent('revertContent');
                        await experienceResolver(revertContent({
                            variables: {
                                contentId: contentId
                            }
                        }));
                    }
                } catch (_err) {
                // TODO show a helpful error message
                }
            };
        this._renderHeader = ()=>{
            const { isUnpublishedDraft: isUnpublishedDraft, contentType: contentType, intl: intl } = this.props;
            const headerContent = isUnpublishedDraft ? contentType === (0, $l3Dp5.ContentTypeType).PAGE ? intl.formatMessage({
                id: "editor.quit-dialog.title.page.delete"
            }) : intl.formatMessage({
                id: "editor.quit-dialog.title.blogpost.delete"
            }) : intl.formatMessage({
                id: "editor.quit-dialog.title.discard"
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jpojX.RevertModalHeader), null, headerContent);
        };
        this.renderWarningText = (contributorsList)=>{
            const { isUnpublishedDraft: isUnpublishedDraft, contentType: contentType } = this.props;
            const operationType = isUnpublishedDraft ? 'delete' : 'revert';
            const contributionType = contributorsList.length === 0 ? 'one' : 'many';
            const warningTextKey = (0, $5IV6g.WARN_TEXT)[operationType][contentType][contributionType];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: warningTextKey
            });
        };
        this._renderContributorsListSection = (contributorsList)=>{
            const { intl: intl } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jpojX.RevertContributorsList), null, contributorsList.map((contributor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jpojX.RevertContributorsListItem), {
                    key: contributor?.source?.accountId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jpojX.ContributorAvatar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jpojX.ContributorAvatarImg), {
                    src: contributor?.source?.profilePicture?.path,
                    alt: ""
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jpojX.ContributorDetail), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jpojX.ContributorDetailName), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, contributor?.source?.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jpojX.ContributorDetailLastModification), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, intl.formatMessage({
                    id: "editor.quit-dialog.last.edited"
                }), ' ', contributor?.relationData?.friendlyCreatedDate)))))));
        };
        this._calculateContributorsList = (collaboratorRelations, touchedRelations)=>{
            const { currentAccountId: currentAccountId } = this.props;
            const collaboratorAccountIds = collaboratorRelations.map((collaboratorRelation)=>collaboratorRelation?.source?.accountId);
            return touchedRelations.filter((touchedRelation)=>collaboratorAccountIds.indexOf(touchedRelation?.source?.accountId) > -1 && touchedRelation?.source?.accountId !== currentAccountId);
        };
        this._getDialogSubmitButtonText = ()=>{
            const { contentType: contentType, intl: intl } = this.props;
            const submitTextKeyMessage = {
                id: (0, $5IV6g.SUBMIT_TEXT)[this.getCurrentOperationType()][contentType]
            };
            return intl.formatMessage(submitTextKeyMessage);
        };
        this.getCurrentOperationType = ()=>this.props.isUnpublishedDraft ? 'delete' : 'revert';
        this._renderShowDiffToggle = (isDiffShown)=>{
            const { hideRevertDialogDiff: hideRevertDialogDiff, showRevertDialogDiff: showRevertDialogDiff } = this.props;
            // If the diff is currently shown, the toggle action will HIDE the diff. The toggle action should also show the contributors,
            // though this functionality is currently broken (see CFE-3296).
            // If the diff is not currently shown, the toggle action will SHOW the diff.
            const toggleAction = isDiffShown ? hideRevertDialogDiff : showRevertDialogDiff;
            const toggleActionTextId = isDiffShown ? 'editor.quit-dialog.link.hide.diff' : 'editor.quit-dialog.link.show.diff';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jpojX.RevertLinkActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "link",
                onClick: toggleAction,
                "aria-expanded": isDiffShown,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0abb7f37a4bc0936$var$DiffExpandIcon, {
                    isDiffShown: isDiffShown
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                    spacing: "spacious",
                    label: "Toggle diff",
                    size: "small"
                }))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: toggleActionTextId
            })));
        };
        this._renderChildren = ()=>{
            const { shouldShowRevertDialogDiff: shouldShowRevertDialogDiff, contentId: contentId, isUnpublishedDraft: isUnpublishedDraft, collaboratorRelations: collaboratorRelations, touchedRelations: touchedRelations } = this.props;
            const contributorsList = this._calculateContributorsList(collaboratorRelations, touchedRelations);
            const showDiffToggle = this._renderShowDiffToggle(shouldShowRevertDialogDiff);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, this.renderWarningText(contributorsList)), !isUnpublishedDraft && showDiffToggle, shouldShowRevertDialogDiff ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kj1gY.ChangesDiffLoader), {
                contentId: contentId
            }) : this._renderContributorsListSection(contributorsList));
        };
        this._renderFooter = ({ experienceResolver: experienceResolver })=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0abb7f37a4bc0936$var$JustifyShim, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                    "data-testid": "submit-button"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    isDisabled: this.state.submitting,
                    iconAfter: this.state.submitting ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), null) : undefined,
                    onClick: this._handleRevertDialogSubmitted({
                        experienceResolver: experienceResolver
                    }),
                    appearance: "primary"
                }, this._getDialogSubmitButtonText())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0abb7f37a4bc0936$var$CloseButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    isDisabled: this.state.submitting,
                    onClick: this._handleRevertDialogDismissed,
                    appearance: "subtle"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    id: "close.name"
                })))));
    }
}
$0abb7f37a4bc0936$var$EditorRevertDialogComponentClass.defaultProps = {
    contentType: (0, $l3Dp5.ContentTypeType).PAGE // Setting default value to help with the type error since contentType can be potentially null
};
const $0abb7f37a4bc0936$export$d21522f1fb83d2e9 = (0, $gmMgo.default)($0abb7f37a4bc0936$var$EditorRevertDialogComponentClass);
module.exports["EditorRevertDialogComponent"] = $0abb7f37a4bc0936$export$d21522f1fb83d2e9;

});

parcelRegister("kj1gY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $65a70e5bc153e910$export$3ecbd7f299e957b2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "20b9O",
    name: "ChangesDiffLoader",
    loader: async ()=>(await (parcelRequire("3JBBS"))).ChangesDiff
});
module.exports["ChangesDiffLoader"] = $65a70e5bc153e910$export$3ecbd7f299e957b2;

});

parcelRegister("3JBBS", function(module, exports) {

let $2b82bf9f6bb366aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2b82bf9f6bb366aa$var$load("8OiWl").then(()=>parcelRequire('fQeQL'));

});

parcelRegister("jpojX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $db051ff45b440e81$var$headerStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    fontWeight: 'font.weight.medium',
    padding: 'space.250'
});
const $db051ff45b440e81$export$54ae5c5dd05596de = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "h2",
        xcss: $db051ff45b440e81$var$headerStyles
    }, children);
const $db051ff45b440e81$var$contributorListStyles = (0, $ecnYn.xcss)({
    listStyle: 'none',
    paddingLeft: 'space.0',
    maxHeight: '160px',
    overflowY: 'auto'
});
const $db051ff45b440e81$export$fbf92180ee7fa390 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "ul",
        xcss: $db051ff45b440e81$var$contributorListStyles,
        testId: "editor-revert-dialog-contributors-list"
    }, children);
const $db051ff45b440e81$var$contributorListItemStyles = (0, $ecnYn.xcss)({
    float: 'left',
    width: '50%'
});
const $db051ff45b440e81$export$52d11275ec7751f6 = ({ key: key, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "li",
        xcss: $db051ff45b440e81$var$contributorListItemStyles,
        key: key
    }, children);
const $db051ff45b440e81$var$avatarStyles = (0, $ecnYn.xcss)({
    filter: 'grayscale(100%)',
    opacity: 0.7,
    display: 'table-cell',
    verticalAlign: 'middle',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.0',
    paddingRight: 'space.0'
});
const $db051ff45b440e81$export$5d6db156164366c9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $db051ff45b440e81$var$avatarStyles
    }, children);
const $db051ff45b440e81$var$avatarImgStyles = (0, $ecnYn.xcss)({
    height: 'size.300',
    borderRadius: 'radius.small'
});
const $db051ff45b440e81$export$62ca698686e2dcfb = ({ src: src, alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "img",
        xcss: $db051ff45b440e81$var$avatarImgStyles,
        src: src,
        alt: alt
    });
const $db051ff45b440e81$var$detailStyles = (0, $ecnYn.xcss)({
    display: 'table-cell',
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $db051ff45b440e81$export$e214e3696a2038d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $db051ff45b440e81$var$detailStyles
    }, children);
const $db051ff45b440e81$var$detailNameStyles = (0, $ecnYn.xcss)({
    fontWeight: 'font.weight.bold',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    display: 'block',
    width: '200px',
    overflow: 'hidden'
});
const $db051ff45b440e81$export$8017f73df02c60d6 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "p",
        xcss: $db051ff45b440e81$var$detailNameStyles
    }, children);
const $db051ff45b440e81$var$contributorDetailLastModificationStyles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    margin: 'space.0',
    font: 'font.body',
    verticalAlign: 'bottom',
    filter: 'grayscale(100%)',
    opacity: 0.6
});
const $db051ff45b440e81$export$b891b51eaabcd719 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "p",
        xcss: $db051ff45b440e81$var$contributorDetailLastModificationStyles
    }, children);
const $db051ff45b440e81$var$linkActionsStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100',
    marginLeft: 'space.0',
    marginRight: 'space.0'
});
const $db051ff45b440e81$export$73e5e09f3ced9be5 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $db051ff45b440e81$var$linkActionsStyles,
        testId: "editor-revert-dialog-link-actions"
    }, children);
module.exports["RevertModalHeader"] = $db051ff45b440e81$export$54ae5c5dd05596de;
module.exports["RevertContributorsList"] = $db051ff45b440e81$export$fbf92180ee7fa390;
module.exports["RevertContributorsListItem"] = $db051ff45b440e81$export$52d11275ec7751f6;
module.exports["ContributorAvatar"] = $db051ff45b440e81$export$5d6db156164366c9;
module.exports["ContributorAvatarImg"] = $db051ff45b440e81$export$62ca698686e2dcfb;
module.exports["ContributorDetail"] = $db051ff45b440e81$export$e214e3696a2038d;
module.exports["ContributorDetailName"] = $db051ff45b440e81$export$8017f73df02c60d6;
module.exports["ContributorDetailLastModification"] = $db051ff45b440e81$export$b891b51eaabcd719;
module.exports["RevertLinkActions"] = $db051ff45b440e81$export$73e5e09f3ced9be5;

});

parcelRegister("5IV6g", function(module, exports) {
const $99497d85d924fd35$export$dd897410adc66601 = {
    delete: {
        page: {
            one: 'editor.quit-dialog.delete.page.changes.by.one',
            many: 'editor.quit-dialog.delete.page.changes.by.many'
        },
        blogpost: {
            one: 'editor.quit-dialog.delete.blogpost.changes.by.one',
            many: 'editor.quit-dialog.delete.blogpost.changes.by.many'
        }
    },
    revert: {
        page: {
            one: 'editor.quit-dialog.revert.page.changes.by.one',
            many: 'editor.quit-dialog.revert.changes.by.many'
        },
        blogpost: {
            one: 'editor.quit-dialog.revert.blogpost.changes.by.one',
            many: 'editor.quit-dialog.revert.changes.by.many'
        }
    }
};
const $99497d85d924fd35$export$7fddb7b8aca8584f = {
    delete: {
        page: 'editor.quit-dialog.button.delete.page.exit',
        blogpost: 'editor.quit-dialog.button.delete.blog.exit'
    },
    revert: {
        page: 'editor.quit-dialog.button.revert.page.exit',
        blogpost: 'editor.quit-dialog.button.revert.blog.exit'
    }
};
module.exports["WARN_TEXT"] = $99497d85d924fd35$export$dd897410adc66601;
module.exports["SUBMIT_TEXT"] = $99497d85d924fd35$export$7fddb7b8aca8584f;

});

parcelRegister("3ejS6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $fUxWH = parcelRequire("fUxWH");

const $f7ea8bf18291e5f2$var$isKnownError = (error)=>{
    return error.graphQLErrors.some((e)=>e.message === 'User does not have permission to view the relationship' || e.message === 'Target entity does not exist');
};
const $f7ea8bf18291e5f2$export$d68df4b88ddb860f = (relationName, contentId, isUnpublishedDraft)=>{
    const variables = {
        relationName: relationName,
        sourceType: 'user',
        targetKey: contentId,
        targetStatus: 'draft'
    };
    const [getRelations, { data: data, loading: loading, error: error }] = (0, $fUxWH.useExperimentalRelationsForContentQuery)({
        variables: variables
    });
    (0, $42omo.useEffect)(()=>{
        // If we're reverting rather than deleting
        if (!isUnpublishedDraft) getRelations();
    }, [
        isUnpublishedDraft,
        getRelations
    ]);
    (0, $42omo.useEffect)(()=>{
        if (error && $f7ea8bf18291e5f2$var$isKnownError(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    return {
        relations: data?.experimentalRelationsForContent?.results ?? [],
        loading: loading,
        error: error
    };
};
module.exports["useContentRelations"] = $f7ea8bf18291e5f2$export$d68df4b88ddb860f;

});

parcelRegister("fUxWH", function(module, exports) {

var $eZLpN = parcelRequire("eZLpN");


var $aBfpe = parcelRequire("aBfpe");

const $595d7fd58c9684b8$export$6857b025f902bf11 = ({ variables: variables, onCompleted: onCompleted, onError: onError })=>{
    const { relationName: relationName, sourceType: sourceType, targetKey: targetKey, targetStatus: targetStatus } = variables;
    if (!relationName) throw new Error('relationName is missing');
    if (!sourceType) throw new Error('sourceType is missing');
    if (!targetKey) throw new Error('targetKey is missing');
    if (!targetStatus) throw new Error('targetStatus is missing');
    const parseResult = (response)=>{
        const mapSource = (source)=>{
            if (!source) return null;
            return {
                displayName: source.displayName ?? null,
                accountId: source.accountId ?? null,
                profilePicture: source.profilePicture?.path ? {
                    path: source.profilePicture.path
                } : null
            };
        };
        const mapRelationData = (relationData)=>{
            if (!relationData) return null;
            return {
                friendlyCreatedDate: relationData.friendlyCreatedDate ?? null
            };
        };
        return {
            experimentalRelationsForContent: {
                results: response.results.map((result)=>({
                        source: mapSource(result.source),
                        relationData: mapRelationData(result.relationData)
                    }))
            }
        };
    };
    return (0, $eZLpN.useExperimentalLazyQuery)({
        url: `/wiki/rest/api/relation/${relationName}/to/content/${targetKey}/from/${sourceType}/?targetStatus=${targetStatus}&expand=source,relationData`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: parseResult,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: (error)=>{
            // Check if it's a BadStatusError with response status
            if ('response' in error && error.response?.status) {
                const status = error.response.status;
                if (status === 403) return new Error('User does not have permission to view the relationship');
                else if (status === 404) return new Error('Target entity does not exist');
            }
            return new Error('Unknown error');
        }
    });
};
module.exports["useExperimentalRelationsForContentQuery"] = $595d7fd58c9684b8$export$6857b025f902bf11;

});

parcelRegister("lRON8", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $8c33294e3d69149a$export$c07c276728bebbbc = (0, $eSUdr.default)`mutation DeleteDraftMutationForRevertDialog($contentId:ID!){deleteContent(contentId:$contentId action:DELETE_DRAFT){contentId}}`;
module.exports["DeleteDraftMutationForRevertDialog"] = $8c33294e3d69149a$export$c07c276728bebbbc;

});

parcelRegister("1lZlH", function(module, exports) {

var $2NSIh = parcelRequire("2NSIh");

const $92e9616f723b6e02$export$5263310017cc26c7 = (content)=>{
    const labels = content?.metadata?.labels ?? [];
    const blueprintLabel = labels.find((item)=>{
        if (item?.name) return (0, $2NSIh.PREDEFINED_BLUEPRINT_TYPES)[item.name];
    });
    return blueprintLabel?.name ?? '';
};
module.exports["getBlueprintType"] = $92e9616f723b6e02$export$5263310017cc26c7;

});

parcelRegister("2NSIh", function(module, exports) {
const $359a22a23ec3fd20$export$8d89725053a04255 = {
    'meeting-notes': true,
    decisions: true,
    'kb-how-to-article': true,
    'file-list': true,
    retrospective: true,
    requirements: true,
    'shared-links': true,
    'kb-troubleshooting-article': true,
    'task-report': true,
    jirareport: true
};
module.exports["PREDEFINED_BLUEPRINT_TYPES"] = $359a22a23ec3fd20$export$8d89725053a04255;

});

parcelRegister("4B8iP", function(module, exports) {

var $aBfpe = parcelRequire("aBfpe");


var $b4EKK = parcelRequire("b4EKK");


var $9o40q = parcelRequire("9o40q");


var $hBkCm = parcelRequire("hBkCm");

const $b274159c92aeba75$export$b9d88f4afc1c4fa7 = ({ onCompleted: onCompleted } = {})=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: (variables)=>{
            if (!variables.contentId) throw new Error('contentId is missing');
            return `/wiki/rest/collab/1.0/content/${variables?.contentId}/changes/unpublished`;
        },
        method: 'DELETE',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: ()=>({
                experimentalRevertContent: true
            }),
        onCompleted: onCompleted,
        transformError: (error)=>{
            if (error instanceof (0, $hBkCm.BadStatusError)) return (0, $b4EKK.getErrorWithResponse)(new Error(`Failed to revert or delete draft: ${error}`), error?.response);
            return error;
        }
    });
};
module.exports["useExperimentalRevertContentMutation"] = $b274159c92aeba75$export$b9d88f4afc1c4fa7;

});

parcelRegister("b4EKK", function(module, exports) {
function $9a7b0181c65e47f8$export$d882ca6820b0f4f3(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    return error;
}
module.exports["getErrorWithResponse"] = $9a7b0181c65e47f8$export$d882ca6820b0f4f3;

});

parcelRegister("a1uFh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $4noo5 = parcelRequire("4noo5");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $8FvpY = parcelRequire("8FvpY");

var $6LguK = parcelRequire("6LguK");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");


var $lsxnT = parcelRequire("lsxnT");


var $8ul25 = parcelRequire("8ul25");


var $btgif = parcelRequire("btgif");

const $6e7c2a3fd79ba2ce$var$i18n = (0, $cgtv4.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    editorModalTitle: {
        id: "onboarding-editor.modal.title",
        defaultMessage: "This page needs a title"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    editorModalDescription: {
        id: "onboarding-editor.modal.description",
        defaultMessage: "Before you can publish this page, you\u2019ll need to give it a title."
    },
    editorModalPlaceholder: {
        id: "onboarding-editor.modal.placeholder",
        defaultMessage: "Enter title"
    },
    editorModalPublish: {
        id: "onboarding-editor.modal.button.publish",
        defaultMessage: "Publish"
    },
    editorModalClose: {
        id: "onboarding-editor.modal.button.close",
        defaultMessage: "Close"
    }
});
const $6e7c2a3fd79ba2ce$export$9265b150937a5ee1 = (props)=>{
    const { onTitleChange: onTitleChange, handlePublish: handlePublish } = props;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [title, setTitle] = (0, $42omo.useState)('');
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { modal: modal, hideEditorModal: hideEditorModal } = (0, $6LguK.useEditorModalContext)();
    const showModal = modal?.[(0, $8FvpY.ALLOWED_EDITOR_MODAL).ONBOARDING_EDITOR_MODAL] || false;
    const { fireEditorModalPromptClosed: fireEditorModalPromptClosed, fireEditorModalPromptPublished: fireEditorModalPromptPublished } = (0, $8ul25.useEditorOnboardingEvents)();
    const intl = (0, $8C5kA.default)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    (0, $42omo.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_EDITOR_PUBLISH_MODAL_PROMPT_EXPERIENCE),
            collect (events, experience) {
                // Fail or abort ONBOARDING_EDITOR_PUBLISH_MODAL_PROMPT_EXPERIENCE as soon as EDIT_PAGE_PUBLISH_EXPERIENCE fails or aborts:
                experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskFail' || action === 'taskAbort') && name === (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE)));
            }
        });
    }, [
        experienceTracker
    ]);
    const endExperienceTracker = ()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.ONBOARDING_EDITOR_PUBLISH_MODAL_PROMPT_EXPERIENCE)
        });
    };
    const onClose = ()=>{
        hideEditorModal((0, $8FvpY.ALLOWED_EDITOR_MODAL).ONBOARDING_EDITOR_MODAL);
        fireEditorModalPromptClosed();
        endExperienceTracker();
    };
    const onClickPublish = ()=>{
        // There needs to be a title before publishing is possible
        onTitleChange(title);
        return Promise.resolve(hideEditorModal((0, $8FvpY.ALLOWED_EDITOR_MODAL).ONBOARDING_EDITOR_MODAL)).then(()=>{
            handlePublish();
        }).then(()=>{
            // set hasUserPublished to true
            setOnboardingState({
                key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).HAS_USER_PUBLISHED,
                value: 'true'
            });
            fireEditorModalPromptPublished();
            endExperienceTracker();
        });
    };
    return showModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        key: "onboarding-editor-modal",
        onClose: onClose,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true,
        width: 480,
        messageType: "transactional",
        messageId: "onboarding-editor-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6e7c2a3fd79ba2ce$var$i18n.editorModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $btgif.ModalDescription), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6e7c2a3fd79ba2ce$var$i18n.editorModalDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
        testId: "editor-modal-prompt-textfield",
        autoFocus: true,
        onChange: (e)=>{
            setTitle(e.target.value);
        },
        placeholder: intl.formatMessage($6e7c2a3fd79ba2ce$var$i18n.editorModalPlaceholder)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: onClose,
        autoFocus: false,
        appearance: "subtle",
        testId: "editor-modal-prompt-close-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6e7c2a3fd79ba2ce$var$i18n.editorModalClose)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: onClickPublish,
        type: "submit",
        autoFocus: false,
        onSubmit: onClickPublish,
        isDisabled: title.length === 0,
        appearance: "primary",
        testId: "editor-modal-prompt-publish-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6e7c2a3fd79ba2ce$var$i18n.editorModalPublish)))) : null;
};
module.exports["OnboardingEditorModalPrompt"] = $6e7c2a3fd79ba2ce$export$9265b150937a5ee1;

});

parcelRegister("8FvpY", function(module, exports) {
const $1f6c26e8b75dac6d$export$66ebbe2730dd348f = {
    ONBOARDING_EDITOR_MODAL: 'onboarding-editor-modal'
};
module.exports["ALLOWED_EDITOR_MODAL"] = $1f6c26e8b75dac6d$export$66ebbe2730dd348f;

});

parcelRegister("6LguK", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $a5f0fa1f60ef7a3d$export$f094ef697e0046b5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    showEditorModal: ()=>{},
    hideEditorModal: ()=>{},
    modal: {}
});
const $a5f0fa1f60ef7a3d$export$43769d91a63d8617 = ({ children: children })=>{
    const [modal, setModal] = (0, $42omo.useState)({});
    const showEditorModal = (0, $42omo.useCallback)((modalName)=>{
        setModal({
            ...modal,
            [modalName]: true
        });
    }, [
        modal
    ]);
    const hideEditorModal = (0, $42omo.useCallback)((modalName)=>{
        setModal({
            ...modal,
            [modalName]: false
        });
    }, [
        modal
    ]);
    const editorModalContextValue = (0, $42omo.useMemo)(()=>({
            showEditorModal: showEditorModal,
            hideEditorModal: hideEditorModal,
            modal: modal
        }), [
        showEditorModal,
        hideEditorModal,
        modal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a5f0fa1f60ef7a3d$export$f094ef697e0046b5.Provider, {
        value: editorModalContextValue
    }, children);
};
function $a5f0fa1f60ef7a3d$export$25df5f37bf8e13e4(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a5f0fa1f60ef7a3d$export$43769d91a63d8617, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, props));
}
const $a5f0fa1f60ef7a3d$export$452d9698d6861523 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($a5f0fa1f60ef7a3d$export$f094ef697e0046b5);
module.exports["withEditorModalContext"] = $a5f0fa1f60ef7a3d$export$25df5f37bf8e13e4;
module.exports["useEditorModalContext"] = $a5f0fa1f60ef7a3d$export$452d9698d6861523;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("ivb8S", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7Sm4c = parcelRequire("7Sm4c");


var $9PBjm = parcelRequire("9PBjm");


var $8Lx5S = parcelRequire("8Lx5S");


var $6mKj3 = parcelRequire("6mKj3");


var $cbOce = parcelRequire("cbOce");


var $9xoMO = parcelRequire("9xoMO");


var $1cHqV = parcelRequire("1cHqV");


var $66UJS = parcelRequire("66UJS");

const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) onboardingState.forEach(({ key: key, value: value })=>{
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) return;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    });
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key value}}`, {
        update (cache, { data: data }) {
            const states = data.setOnboardingState;
            states.forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                cache.writeFragment({
                    id: `OnboardingState:${key}`,
                    fragment: (0, $eSUdr.default)`fragment myKey on OnboardingState{key value}`,
                    data: {
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }
                });
            });
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const setOnboardingState = (0, $42omo.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$660f2a41b807ece4 = (requestedKeys)=>{
    const variables = (0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false) ? {
        key: (0, $9xoMO.OnboardingKeysCombined)
    } : {
        key: requestedKeys
    };
    const data = (0, $9PBjm.getApolloCache)().readQuery({
        query: (0, $66UJS.getOnboardingStateGQL),
        variables: variables
    });
    if (!(0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false) || !data) return data;
    return (0, $1cHqV.filterOnboardingState)(data, requestedKeys);
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    // When enabled, always fetch ALL keys to ensure cache hits across different consumers.
    // This allows the preloaded data to be reused regardless of which subset of keys is requested.
    const queryVariables = (0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false) ? {
        key: (0, $9xoMO.OnboardingKeysCombined)
    } : {
        key: key
    };
    const { data: fullData, error: error, loading: loading, refetch: refetch } = (0, $j1Ss3.useQuery)((0, $6mKj3.expVal)('confluence_consolidate_onboarding_state_queries', 'isEnabled', false) ? // eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Preloaded GraphQL Operation
    (0, $eSUdr.default)`query GetOnboardingState($key:[String]){onboardingState(key:$key){key value}}` : (0, $eSUdr.default)`query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key value}}`, {
        variables: queryVariables,
        skip: skipQuery
    });
    // Filter the response to only include the keys that the consumer requested.
    // When the centralized experiment is enabled, we fetch all keys but only return
    // the ones the consumer requested.
    const data = (0, $42omo.useMemo)(()=>{
        if (!(0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false) || !fullData) return fullData;
        return (0, $1cHqV.filterOnboardingState)(fullData, key);
    }, [
        fullData,
        key
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["getOnboardingStateFromCache"] = $6fc4b7bb962289cc$export$660f2a41b807ece4;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("9PBjm", function(module, exports) {

var $eHj6r = parcelRequire("eHj6r");

function $ca1d37ec2e96c685$export$c25b3a02c2d5dc72() {
    return 0, $eHj6r.apolloCache;
}
module.exports["getApolloCache"] = $ca1d37ec2e96c685$export$c25b3a02c2d5dc72;

});

parcelRegister("cbOce", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("9xoMO", function(module, exports) {

var $dBcar = parcelRequire("dBcar");


var $gxTpP = parcelRequire("gxTpP");


var $5cryL = parcelRequire("5cryL");


var $da9fp = parcelRequire("da9fp");


var $lohHj = parcelRequire("lohHj");


var $b4VFP = parcelRequire("b4VFP");


var $d282Z = parcelRequire("d282Z");


var $d0hiC = parcelRequire("d0hiC");


var $9DBk6 = parcelRequire("9DBk6");


var $isKLx = parcelRequire("isKLx");


var $1gy7x = parcelRequire("1gy7x");


var $h86CY = parcelRequire("h86CY");


var $jbYIt = parcelRequire("jbYIt");


var $ccGoc = parcelRequire("ccGoc");


var $eoU1C = parcelRequire("eoU1C");


var $2wUAJ = parcelRequire("2wUAJ");


var $6eN5W = parcelRequire("6eN5W");


var $kNKrY = parcelRequire("kNKrY");


var $eAuT4 = parcelRequire("eAuT4");


var $lIcXr = parcelRequire("lIcXr");


var $bPDOf = parcelRequire("bPDOf");


var $eyUJP = parcelRequire("eyUJP");


var $9qLVv = parcelRequire("9qLVv");


var $eC276 = parcelRequire("eC276");


var $fsF73 = parcelRequire("fsF73");

const $af0fb818e1350632$export$1c433575c0d65d05 = [
    ...(0, $2wUAJ.StorageEnforcementOnboardingKeys),
    ...(0, $dBcar.OnboardingKeys),
    ...(0, $gxTpP.ContextualInviteNudgeOnboardingKeys),
    ...(0, $5cryL.EditorOnboardingKeys),
    ...(0, $d282Z.InsightsOnboardingKeys),
    ...(0, $isKLx.SpaceMissionControlOnboardingKeys),
    ...(0, $h86CY.PresenceAdminFeedbackSurveyOnboardingKeys),
    ...(0, $jbYIt.RoleBasedAccessControlOnboardingKeys),
    ...(0, $ccGoc.RovoVideoPlayerStateOnboardingKeys),
    ...(0, $eoU1C.ShareAndRestrictDialogOnboardingKeys),
    ...(0, $6eN5W.TrialComponentsOnboardingKeys),
    ...(0, $1gy7x.PersonalizedTemplatesOnboardingKeys),
    ...(0, $9DBk6.LiveDocsOnboardingKeys),
    ...(0, $b4VFP.HomeTakeoverOnboardingKeys),
    ...(0, $lohHj.FeedOnboardingKeys),
    ...(0, $da9fp.OptionalNthUserGuidedTourOnboardingKeys),
    ...(0, $d0hiC.LandInSpampleSpaceOnboardingKeys),
    ...(0, $kNKrY.CreateIntroFirstStepOnboardingStateKeys),
    ...(0, $eAuT4.NotesOnboardingSpotlightKeys),
    ...(0, $lIcXr.NewContentHistoryOnboardingStateKeys),
    ...(0, $bPDOf.AIFCOnboardingKeys),
    ...(0, $eyUJP.NthUserHomeOnboardingRevampKeys),
    ...(0, $9qLVv.RovoAwarenessOnboardingKeys),
    ...(0, $eC276.ExportJiraContextToPageTourKeys),
    ...(0, $fsF73.ConfluenceRecapOnboardingKeys)
];
module.exports["OnboardingKeysCombined"] = $af0fb818e1350632$export$1c433575c0d65d05;

});

parcelRegister("dBcar", function(module, exports) {
const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$a651929fa48b856 = 'nthUserOnboardingFlagViewed';
const $3c94963df51c0e13$export$26694bcd9ab12240 = 'nthUserOnboardingPageViewed';
const $3c94963df51c0e13$export$ff82dad92156967f = 'nthUserGSPagePath';
const $3c94963df51c0e13$export$a05aab42c7cc2cd2 = 'nthUserBannerDismissed';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$aae58c16337c3635 = {
    BULK_ACTIONS_CHANGEBOARDING_SPOTLIGHT_DISMISSED: 'content-tree-bulk-actions:isBulkActionsChangeboardingSpotlightDismissed'
};
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$cba7fd986c721ece = {
    HAS_DISMISSED_MODAL: 'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceIpmModal',
    HAS_DISMISSED_BANNER: 'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceBanner'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$cd598425c00dde23 = {
    HAS_AUTO_FOLLOWED_TEAMMATES: 'nth-user-auto-follow-teammates:hasAutoFollowedTeammates',
    AUTO_FOLLOW_BANNER_DISMISSED: 'nth-user-auto-follow-teammates:autoFollowBannerDismissed',
    AUTO_FOLLOW_BANNER_SHOWN_AT: 'nth-user-auto-follow-teammates:autoFollowBannerShownAt'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$d7fccce7dbca5a99 = 'revamped-bpqa:foundingAdminRevampedBpqaEligible';
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$f9ff90838813e652 = {
    FIRST_PASTE_VIEWED: 'improve-writing-on-paste:firstPasteViewed',
    SECOND_PASTE_VIEWED: 'improve-writing-on-paste:secondPasteViewed'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IMPROVED_GET_STARTED_NTH_USER_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$ff82dad92156967f}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`,
    NTH_USER_ONBOARDING_FLAG_VIEWED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$a651929fa48b856}`,
    NTH_USER_ONBOARDING_PAGE_VIEWED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$26694bcd9ab12240}`,
    NTH_USER_BANNER_DISMISSED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$a05aab42c7cc2cd2}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const { LEGACY_ONBOARDING_STATE: $3c94963df51c0e13$export$66aa87593037fd4a } = $3c94963df51c0e13$export$bfeb2da96277b623;
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    $3c94963df51c0e13$export$d7fccce7dbca5a99,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$cba7fd986c721ece),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$aae58c16337c3635),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$cd598425c00dde23),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$f9ff90838813e652),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3)
];
module.exports["PEOPLE"] = $3c94963df51c0e13$export$f35f2899eb1390e3;
module.exports["NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP"] = $3c94963df51c0e13$export$275d3dda87d2fa7a;
module.exports["NTH_USER_ONBOARDING_FLAG_VIEWED"] = $3c94963df51c0e13$export$a651929fa48b856;
module.exports["NTH_USER_ONBOARDING_PAGE_VIEWED"] = $3c94963df51c0e13$export$26694bcd9ab12240;
module.exports["IMPROVED_GET_STARTED_NTH_USER_PATH"] = $3c94963df51c0e13$export$ff82dad92156967f;
module.exports["HELP"] = $3c94963df51c0e13$export$da223e550b96c9d6;
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["IS_NAV_4_GLOBAL_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$b99b309b286adebc;
module.exports["IS_NAV_4_SPACE_TOUR_DISMISSED"] = $3c94963df51c0e13$export$20b0548cf5859d6;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CONTENT_TREE_BULK_ACTIONS"] = $3c94963df51c0e13$export$aae58c16337c3635;
module.exports["MODERNIZE_CONFLUENCE_IPM_MODAL"] = $3c94963df51c0e13$export$cba7fd986c721ece;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["PROMPT_DATABASE_COMPETITOR_LINK"] = $3c94963df51c0e13$export$5b471e2344a37be7;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["NTH_USER_AUTO_FOLLOW_TEAMMATES"] = $3c94963df51c0e13$export$cd598425c00dde23;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["FOUNDING_ADMIN_REVAMPED_BPQA_ELIGIBLE"] = $3c94963df51c0e13$export$d7fccce7dbca5a99;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["IMPROVE_WRITING_ON_PASTE"] = $3c94963df51c0e13$export$f9ff90838813e652;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("gxTpP", function(module, exports) {
const $62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab = {
    EXPERIMENT_ELIGIBLE_TAG: 'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag',
    WAS_CONFETTI_SEEN: 'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen'
};
const $62a1556a5bf2ef38$export$fdbc8dd83db637ed = [
    ...Object.values($62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab)
];
module.exports["CONTEXTUAL_INVITE_NUDGE"] = $62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab;
module.exports["ContextualInviteNudgeOnboardingKeys"] = $62a1556a5bf2ef38$export$fdbc8dd83db637ed;

});

parcelRegister("da9fp", function(module, exports) {
const $565de75ce1406587$export$9228568dbaf24cda = {
    tourSeenAt: 'optional-nth-user-guided-tour:tourSeenAt',
    hasDismissedTour: 'optional-nth-user-guided-tour:hasDismissedTour',
    hasCompletedTour: 'optional-nth-user-guided-tour:hasCompletedTour',
    hasSeenFinishNudge: 'optional-nth-user-guided-tour:hasSeenFinishNudge',
    isEnrolledAsNewUser: 'optional-nth-user-guided-tour:isEnrolledAsNewUser'
};
const $565de75ce1406587$export$c9a13a78a28b997a = [
    ...Object.values($565de75ce1406587$export$9228568dbaf24cda)
];
module.exports["OPTIONAL_NTH_USER_GUIDED_TOUR_ONBOARDING_STATE_KEYS"] = $565de75ce1406587$export$9228568dbaf24cda;
module.exports["OptionalNthUserGuidedTourOnboardingKeys"] = $565de75ce1406587$export$c9a13a78a28b997a;

});

parcelRegister("lohHj", function(module, exports) {
const $3f26c87821b680a5$export$215d0f9cb557eff8 = 'onboarding-popular-feed-card:isDismissed';
const $3f26c87821b680a5$export$84bf53f359485dfc = [
    $3f26c87821b680a5$export$215d0f9cb557eff8
];
module.exports["ONBOARDING_POPULAR_FEED_CARD_SEEN_KEY"] = $3f26c87821b680a5$export$215d0f9cb557eff8;
module.exports["FeedOnboardingKeys"] = $3f26c87821b680a5$export$84bf53f359485dfc;

});

parcelRegister("b4VFP", function(module, exports) {
const $390e454b1ae488b2$export$1d1c13df264a094 = {
    hasSeenHomeNudge: 'home-onboarding-takeover-v2:hasSeenHomeNudge',
    isHomeNudgeScheduledAt: 'home-onboarding-takeover-v2:isHomeNudgeScheduledAt',
    takeoverSeenAt: 'home-onboarding-takeover-v2:takeoverSeenAt',
    onboardingActionStates: 'home-onboarding-takeover-v2:onboardingActionStates',
    isCollapsed: 'home-onboarding-takeover-v2:isCollapsed',
    hasSeenConfetti: 'home-onboarding-takeover-v2:hasSeenConfetti',
    hasDismissedCarousel: 'home-onboarding-takeover-v2:hasDismissedCarousel',
    hasDismissedLearningResources: 'home-onboarding-takeover-v2:hasDismissedLearningResources',
    hasDismissedTakeover: 'home-onboarding-takeover-v2:hasDismissedTakeover'
};
const $390e454b1ae488b2$export$3392b5b28b589b00 = Object.values($390e454b1ae488b2$export$1d1c13df264a094);
module.exports["HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS"] = $390e454b1ae488b2$export$1d1c13df264a094;
module.exports["HomeTakeoverOnboardingKeys"] = $390e454b1ae488b2$export$3392b5b28b589b00;

});

parcelRegister("d282Z", function(module, exports) {
const $a18eeb1d05dccc62$export$fc9b2402bb5adac2 = {
    CONTEXTUAL_FLOATING_BUTTON_NUDGE: 'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    AUDIO_BRIEFING: 'onboarding-insights:hasAudioBriefingChangeboardingBeenSeen'
};
const $a18eeb1d05dccc62$export$fac0a92023e58acd = [
    ...Object.values($a18eeb1d05dccc62$export$fc9b2402bb5adac2)
];
module.exports["ONBOARDING_INSIGHTS"] = $a18eeb1d05dccc62$export$fc9b2402bb5adac2;
module.exports["InsightsOnboardingKeys"] = $a18eeb1d05dccc62$export$fac0a92023e58acd;

});

parcelRegister("d0hiC", function(module, exports) {
const $fd31f36c9d251c72$export$3b7e7c8d78a4b783 = {
    hasDismissedBanner: 'land-in-sample-space:hasDismissedBanner',
    hasSeenSampleContentFlag: 'land-in-sample-space:hasSeenSampleContentFlag'
};
const $fd31f36c9d251c72$export$12692b0da4497e60 = [
    ...Object.values($fd31f36c9d251c72$export$3b7e7c8d78a4b783)
];
module.exports["LandInSpampleSpaceOnboardingKeys"] = $fd31f36c9d251c72$export$12692b0da4497e60;

});

parcelRegister("9DBk6", function(module, exports) {
const $d9e19a0d44ee3302$export$9b7b03214c03f17d = {
    hasDismissedIntroSpotlight: 'onboarding-live-doc-changeboarding:hasDismissedIntroSpotlight',
    hasDismissedLiveDocTour: 'onboarding-live-doc-changeboarding:hasDismissedLiveDocTour',
    hasDismissedLiveDocModal: 'onboarding-live-doc-changeboarding:hasDismissedLiveDocModal',
    hasDismissedContentWrapperTour: 'onboarding-live-doc-changeboarding:hasDismissedContentWrapperTour',
    hasDismissedAiButtonTour: 'onboarding-live-doc-changeboarding:hasDismissedAiButtonTour',
    hasDismissedConvertToPageSpotlight: 'onboarding-live-doc-changeboarding:hasDismissedConvertToPageSpotlight'
};
const $d9e19a0d44ee3302$export$b02e3be205ee7739 = {
    LIVE_PAGE_CONTEXTUAL_NUDGE_SEEN: 'live-page-nudge:wasLivePageNudgeSeen',
    LIVE_PAGE_CONTEXTUAL_NUDGE_ELIGIBLE: 'live-page-nudge:shareNudgeSpotlightEligible',
    // used to limit calls to the invite permissions API
    LIVE_PAGE_INVITE_INELIGIBLE: 'live-page-nudge:livePageNudgeInviteIneligible'
};
const $d9e19a0d44ee3302$export$b3d9533dbdf35d0 = [
    ...Object.values($d9e19a0d44ee3302$export$9b7b03214c03f17d),
    ...Object.values($d9e19a0d44ee3302$export$b02e3be205ee7739)
];
module.exports["LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS"] = $d9e19a0d44ee3302$export$9b7b03214c03f17d;
module.exports["LIVE_PAGE_NUDGE"] = $d9e19a0d44ee3302$export$b02e3be205ee7739;
module.exports["LiveDocsOnboardingKeys"] = $d9e19a0d44ee3302$export$b3d9533dbdf35d0;

});

parcelRegister("isKLx", function(module, exports) {
const $d14f8037089c8dc2$export$92d46364e5595a5a = {
    SPACE_SETTINGS_CHANGEBOARDING_FIRST_SEEN_AT: 'space-mission-control-onboarding:spaceSettingsChangeboardingFirstSeenAt',
    SPACE_SETTINGS_CHANGEBOARDING_DISMISSED_AT: 'space-mission-control-onboarding:spaceSettingsChangeboardingDismissedAt'
};
const $d14f8037089c8dc2$export$d9eb44525b9507f7 = [
    ...Object.values($d14f8037089c8dc2$export$92d46364e5595a5a)
];
module.exports["ONBOARDING_SPACE_MISSION_CONTROL"] = $d14f8037089c8dc2$export$92d46364e5595a5a;
module.exports["SpaceMissionControlOnboardingKeys"] = $d14f8037089c8dc2$export$d9eb44525b9507f7;

});

parcelRegister("1gy7x", function(module, exports) {
const $071869849092e495$export$d8593f7ef284bfd8 = {
    onboardingActionStates: 'personalized-templates-v2:onboardingActionStates',
    hasDismissedOnboardingActions: 'personalized-templates-v2:hasDismissedOnboardingActions',
    takeoverSeenAt: 'personalized-templates-v2:takeoverSeenAt',
    isTemplateListDismissed: 'personalized-templates-v2:isTemplateListDismissed',
    templateUsageValues: 'personalized-templates-v2:templateUsageValues'
};
const $071869849092e495$export$67c979693bf8551b = [
    ...Object.values($071869849092e495$export$d8593f7ef284bfd8)
];
module.exports["PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS"] = $071869849092e495$export$d8593f7ef284bfd8;
module.exports["PersonalizedTemplatesOnboardingKeys"] = $071869849092e495$export$67c979693bf8551b;

});

parcelRegister("h86CY", function(module, exports) {
const $1dd4a0157170f997$export$f8474b3e5d170456 = {
    PRESENCE_ADMIN_FEEDBACK_SEEN: 'presence-feedback-survey:hasAdminSeenFeedbackSurvey'
};
const $1dd4a0157170f997$export$dcc0ca03f6f8c68d = [
    ...Object.values($1dd4a0157170f997$export$f8474b3e5d170456)
];
module.exports["ONBOARDING_PRESENCE_ADMIN_FEEDBACK_SURVEY_KEYS"] = $1dd4a0157170f997$export$f8474b3e5d170456;
module.exports["PresenceAdminFeedbackSurveyOnboardingKeys"] = $1dd4a0157170f997$export$dcc0ca03f6f8c68d;

});

parcelRegister("jbYIt", function(module, exports) {
const $15e5f1cf9df2e13c$export$67837434b2dea54f = {
    USERS_TABLE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:usersTableSpotlightSeen',
    DEFAULTS_ROLE_TABLE_MODAL_SEEN: 'RoleBasedAccessControl:defaultsRoleTableModalSeen',
    PRODUCT_ADMIN_MODAL_SEEN: 'RoleBasedAccessControl:productAdminModalSeen',
    DEFAULT_ROLE_TABLE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:defaultRoleTableSpotlightSeen',
    CUSTOM_ROLE_PAGE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:customRolePageSpotlightSeen'
};
const $15e5f1cf9df2e13c$export$134f165f9f20f01c = [
    ...Object.values($15e5f1cf9df2e13c$export$67837434b2dea54f)
];
module.exports["ONBOARDING_ROLE_BASED_ACCESS_CONTROL"] = $15e5f1cf9df2e13c$export$67837434b2dea54f;
module.exports["RoleBasedAccessControlOnboardingKeys"] = $15e5f1cf9df2e13c$export$134f165f9f20f01c;

});

parcelRegister("ccGoc", function(module, exports) {
const $1acbcc6f3166a324$export$fa80c824b7402d9f = {
    ROVO_VIDEO_PLAYER_SEEN: 'onboarding-rovo-video-player:rovoVideoPlayerSeen'
};
const $1acbcc6f3166a324$export$d42bdf2f6333fafd = [
    ...Object.values($1acbcc6f3166a324$export$fa80c824b7402d9f)
];
module.exports["ONBOARDING_ROVO_VIDEO_PLAYER_STATE_KEYS"] = $1acbcc6f3166a324$export$fa80c824b7402d9f;
module.exports["RovoVideoPlayerStateOnboardingKeys"] = $1acbcc6f3166a324$export$d42bdf2f6333fafd;

});

parcelRegister("eoU1C", function(module, exports) {
const $b3332cb66ea1a913$export$7f1c6b461c54348b = {
    DIALOG_SPOTLIGHT_SEEN: 'random:ShareAndRestrictDialog:spotlightSeen',
    PUBLIC_LINK_FOOTER_BUTTON_SEEN: 'ShareAndRestrictDialog:editPublicLinkFooterSpotLightSeen',
    EDIT_PUBLIC_LINK_PERMISSION_SEEN: 'ShareAndRestrictDialog:editPublicLinkPermissionSpotLightSeen',
    GENERAL_AND_SPECIFIC_ACCESS_SEEN: 'ShareAndRestrictDialog:generalAndSpecificAccessSpotLightSeen',
    CTA_NOTIFY_MESSAGE_FOOTER_SEEN: 'ShareAndRestrictDialog:ctaNotifyMessageFooterSpotLightSeen'
};
const $b3332cb66ea1a913$export$e5c211f9c9c7792f = [
    ...Object.values($b3332cb66ea1a913$export$7f1c6b461c54348b)
];
module.exports["ONBOARDING_SHARE_AND_RESTRICT_DIALOG"] = $b3332cb66ea1a913$export$7f1c6b461c54348b;
module.exports["ShareAndRestrictDialogOnboardingKeys"] = $b3332cb66ea1a913$export$e5c211f9c9c7792f;

});

parcelRegister("2wUAJ", function(module, exports) {
const $70d55b678e14166c$export$13e578b1c1856d6f = {
    FLAGS_DISMISSED_FREE_THRESHOLD: 'storage-enforcement-state:flagsDismissedFreeThreshold'
};
const $70d55b678e14166c$export$abe3d9e5b5171ebf = [
    ...Object.values($70d55b678e14166c$export$13e578b1c1856d6f)
];
module.exports["STORAGE_ENFORCEMENT_STATE_KEYS"] = $70d55b678e14166c$export$13e578b1c1856d6f;
module.exports["StorageEnforcementOnboardingKeys"] = $70d55b678e14166c$export$abe3d9e5b5171ebf;

});

parcelRegister("6eN5W", function(module, exports) {
const $e04ddb4a5df5bba6$export$840dd6f6c8ecd45f = {
    ACTION_MENU_OPENED: 'trial-components:actionMenuOpened',
    // The trial grace period is formally known as the "pre-dunning" period
    GRACE_PERIOD_BANNER_DISMISSED: 'trial-components:trialGracePeriodBannerDismissed',
    TRIAL_1_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrial1DayFlag',
    TRIAL_3_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrial3DayFlag',
    GRACE_PERIOD_0_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning0DayFlag',
    GRACE_PERIOD_1_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning1DayFlag',
    GRACE_PERIOD_2_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning2DayFlag',
    GRACE_PERIOD_3_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning3DayFlag',
    TRIAL_UNHANDLED_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrialUnhandledDayFlag'
};
const $e04ddb4a5df5bba6$export$8001dc7a7ed753e1 = [
    ...Object.values($e04ddb4a5df5bba6$export$840dd6f6c8ecd45f)
];
module.exports["TRIAL_COMPONENTS_EXPERIENCES"] = $e04ddb4a5df5bba6$export$840dd6f6c8ecd45f;
module.exports["TrialComponentsOnboardingKeys"] = $e04ddb4a5df5bba6$export$8001dc7a7ed753e1;

});

parcelRegister("kNKrY", function(module, exports) {
const $9b3060c835515c41$export$ff14eab135fe9584 = {
    headerSeenAt: 'create-intro-first-step:headerSeenAt',
    headerCompleted: 'create-intro-first-step:headerCompleted',
    headerDismissed: 'create-intro-first-step:headerDismissed'
};
const $9b3060c835515c41$export$1c0fd29b58a87c97 = [
    ...Object.values($9b3060c835515c41$export$ff14eab135fe9584)
];
module.exports["CreateIntroFirstStepOnboardingStateKeys"] = $9b3060c835515c41$export$1c0fd29b58a87c97;

});

parcelRegister("eAuT4", function(module, exports) {
const $5fc4daf9e891ce6f$export$b5d8775ad37f8a3d = {
    SPOTLIGHT_DISMISSED: 'notes-onboarding:hasSpotlightDismissed'
};
const $5fc4daf9e891ce6f$export$983b584b282200ba = [
    ...Object.values($5fc4daf9e891ce6f$export$b5d8775ad37f8a3d)
];
module.exports["NOTES_ONBOARDING_SPOTLIGHT"] = $5fc4daf9e891ce6f$export$b5d8775ad37f8a3d;
module.exports["NotesOnboardingSpotlightKeys"] = $5fc4daf9e891ce6f$export$983b584b282200ba;

});

parcelRegister("lIcXr", function(module, exports) {
const $06a9ae8b05df4a8c$export$561442d092b808c6 = {
    HAS_SEEN_SPOTLIGHT: 'new-content-history-onboarding:hasSeenSpotlight'
};
const $06a9ae8b05df4a8c$export$a8854c7bde991ac7 = [
    ...Object.values($06a9ae8b05df4a8c$export$561442d092b808c6)
];
module.exports["NEW_CONTENT_HISTORY_ONBOARDING_STATE_KEYS"] = $06a9ae8b05df4a8c$export$561442d092b808c6;
module.exports["NewContentHistoryOnboardingStateKeys"] = $06a9ae8b05df4a8c$export$a8854c7bde991ac7;

});

parcelRegister("bPDOf", function(module, exports) {
const $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575 = {
    hasSeenAIFCSpotlight: 'aifc-onboarding:hasSeenAIFCSpotlight',
    isAIFCSpotlightActive: 'aifc-onboarding:isAIFCSpotlightActive',
    hasSeenWhiteboardSmartCreateSpotlight: 'aifc-onboarding:hasSeenWhiteboardSmartCreateSpotlight',
    hasSeenTrackChangesStreamingSpotlight: 'aifc-onboarding:hasSeenTrackChangesStreamingSpotlight',
    isAIFCChatSpotlightActive: 'aifc-onboarding:isAIFCChatSpotlightActive',
    hasSeenAIFCChatSpotlight: 'aifc-onboarding:hasSeenAIFCChatSpotlight',
    hasDismissedGettingStartedTour: 'aifc-onboarding:hasDismissedGettingStartedTour'
};
const $4fc1e4c0ecd68c6d$export$6024bf9594f957fe = [
    ...Object.values($4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575)
];
module.exports["AIFC_ONBOARDING_STATE_KEYS"] = $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575;
module.exports["AIFCOnboardingKeys"] = $4fc1e4c0ecd68c6d$export$6024bf9594f957fe;

});

parcelRegister("eyUJP", function(module, exports) {
const $37b72543ace58c19$export$a266d7c13575e674 = {
    onboardingActionStates: 'nth-user-home-onboarding-revamp:onboardingActionStates',
    areAllActionsDismissed: 'nth-user-home-onboarding-revamp:areAllActionsDismissed',
    takeoverSeenAt: 'nth-user-home-onboarding-revamp:takeoverSeenAt',
    isTemplateListDismissed: 'nth-user-home-onboarding-revamp:isTemplateListDismissed',
    templateUsageValues: 'nth-user-home-onboarding-revamp:templateUsageValues'
};
const $37b72543ace58c19$export$f9348e90ce13bd50 = [
    ...Object.values($37b72543ace58c19$export$a266d7c13575e674)
];
module.exports["NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS"] = $37b72543ace58c19$export$a266d7c13575e674;
module.exports["NthUserHomeOnboardingRevampKeys"] = $37b72543ace58c19$export$f9348e90ce13bd50;

});

parcelRegister("9qLVv", function(module, exports) {
const $495b6b1f8e6e5795$export$994240b15b0ff991 = {
    hasDismissedHomeBanner: 'rovo-awareness:hasDismissedHomeBanner'
};
const $495b6b1f8e6e5795$export$b2ac58e92bc06a02 = [
    ...Object.values($495b6b1f8e6e5795$export$994240b15b0ff991)
];
module.exports["ROVO_AWARENESS_ONBOARDING_STATE_KEYS"] = $495b6b1f8e6e5795$export$994240b15b0ff991;
module.exports["RovoAwarenessOnboardingKeys"] = $495b6b1f8e6e5795$export$b2ac58e92bc06a02;

});

parcelRegister("eC276", function(module, exports) {
const $6acee6b0894846a1$export$fe11c6170169891b = {
    TOUR_COMPLETED: 'random:ExportJiraContextToPage:tourCompleted',
    TOUR_DISMISSED: 'random:ExportJiraContextToPage:tourDismissed'
};
const $6acee6b0894846a1$export$7eebc92289f9ff40 = [
    ...Object.values($6acee6b0894846a1$export$fe11c6170169891b)
];
module.exports["EXPORT_JIRA_CONTEXT_TO_PAGE_TOUR"] = $6acee6b0894846a1$export$fe11c6170169891b;
module.exports["ExportJiraContextToPageTourKeys"] = $6acee6b0894846a1$export$7eebc92289f9ff40;

});

parcelRegister("fsF73", function(module, exports) {
const $29520d740d888926$export$84bb2ff8e52d4c63 = {
    HAS_SEEN_PUBLISH_SPOTLIGHT: 'confluence-recap:hasSeenPublishSpotlight'
};
const $29520d740d888926$export$42e96b8eba35eec9 = [
    ...Object.values($29520d740d888926$export$84bb2ff8e52d4c63)
];
module.exports["CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS"] = $29520d740d888926$export$84bb2ff8e52d4c63;
module.exports["ConfluenceRecapOnboardingKeys"] = $29520d740d888926$export$42e96b8eba35eec9;

});

parcelRegister("1cHqV", function(module, exports) {
// Cache for filtered onboarding state results.
// Uses WeakMap keyed by data object (auto-clears when data is garbage collected),
// with nested Map keyed by keys string for O(1) lookup.
const $e7b7b792910c4288$var$filteredStateCache = new WeakMap();
/**
 * Creates a cache key from the requested keys.
 */ const $e7b7b792910c4288$var$createCacheKey = (keys)=>{
    return Array.isArray(keys) ? keys.join(',') : keys;
};
/**
 * Performs the actual filtering of onboarding state data.
 */ const $e7b7b792910c4288$var$filterData = (data, requestedKeys)=>{
    const keysArray = Array.isArray(requestedKeys) ? requestedKeys : [
        requestedKeys
    ];
    const keySet = new Set(keysArray);
    return {
        ...data,
        onboardingState: data.onboardingState.filter(({ key: key })=>{
            // Check both the full key and the parsed key (without prefix)
            // Keys come back as "{prefix}:{property}" format
            const parsedKey = key.split(':')[1] || key;
            return keySet.has(key) || keySet.has(parsedKey);
        })
    };
};
const $e7b7b792910c4288$export$c1dd389f39afa62f = (data, requestedKeys)=>{
    if (!data?.onboardingState) // Convert null to undefined to maintain backward compatibility with consumers
    // that expect `T | undefined` rather than `T | null | undefined`
    return data ?? undefined;
    const cacheKey = $e7b7b792910c4288$var$createCacheKey(requestedKeys);
    let dataCache = $e7b7b792910c4288$var$filteredStateCache.get(data);
    if (!dataCache) {
        dataCache = new Map();
        $e7b7b792910c4288$var$filteredStateCache.set(data, dataCache);
    }
    if (dataCache.has(cacheKey)) return dataCache.get(cacheKey);
    const filteredResult = $e7b7b792910c4288$var$filterData(data, requestedKeys);
    dataCache.set(cacheKey, filteredResult);
    return filteredResult;
};
module.exports["filterOnboardingState"] = $e7b7b792910c4288$export$c1dd389f39afa62f;

});

parcelRegister("66UJS", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $6d1fd49d30c18d78$export$dfae498b41374c60 = (0, $eSUdr.default)`query GetOnboardingState($key:[String]){onboardingState(key:$key){key value}}`;
const $6d1fd49d30c18d78$export$c27b6f5527b13ff2 = (0, $eSUdr.default)`mutation SetOnboardingState($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key value}}`;
module.exports["getOnboardingStateGQL"] = $6d1fd49d30c18d78$export$dfae498b41374c60;
module.exports["setOnboardingStateGQL"] = $6d1fd49d30c18d78$export$c27b6f5527b13ff2;

});

parcelRegister("8ul25", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $37973aa3dd0a7e4f$export$4da26a7e02cd5140 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireGetEditorOnboardingStateFailed = (0, $42omo.useCallback)((source)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'getOnboardingState',
                actionSubjectId: 'editorOnboarding',
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireEditorPublishSuccessFlagViewed = (0, $42omo.useCallback)((type)=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'onboardingEditorPublishSuccessFlag',
                attributes: {
                    type: type
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireEditorModalPromptClosed = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'onboardingEditorModalPrompt',
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'closeButton'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireEditorModalPromptPublished = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'onboardingEditorModalPrompt',
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'publishButton'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireGetEditorOnboardingStateFailed: fireGetEditorOnboardingStateFailed,
        fireEditorPublishSuccessFlagViewed: fireEditorPublishSuccessFlagViewed,
        fireEditorModalPromptClosed: fireEditorModalPromptClosed,
        fireEditorModalPromptPublished: fireEditorModalPromptPublished
    };
};
module.exports["useEditorOnboardingEvents"] = $37973aa3dd0a7e4f$export$4da26a7e02cd5140;

});

parcelRegister("btgif", function(module, exports) {
/* EditorModalPromptStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $8387ef6c90ca0a23$export$f50a68e3694789ee = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8lodh _syazi7uo _n3tdpxbi _1e0c1txw _1bah1yb4 _4cvr1h6o _z6mmtlke _10pb1tcg",
            __cmplp.className
        ])
    });
});
const $8387ef6c90ca0a23$export$70584796f9410aa4 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazi7uo _n3tdpxbi",
            __cmplp.className
        ])
    });
});
module.exports["ModalDescription"] = $8387ef6c90ca0a23$export$70584796f9410aa4;

});

parcelRegister("lEVfb", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $xQxzY = parcelRequire("xQxzY");


var $eSUdr = parcelRequire("eSUdr");


var $1uFM6 = parcelRequire("1uFM6");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");

const $8a729a72887c33f8$var$useIsEditorToolbarDockedAtTopEditorPreferencesQuery = (0, $eSUdr.default)`query useIsEditorToolbarDockedAtTopEditorPreferencesQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}`;
const $8a729a72887c33f8$export$39186427447356b2 = ({ defaultDockedAtTop: defaultDockedAtTop = false } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)($8a729a72887c33f8$var$useIsEditorToolbarDockedAtTopEditorPreferencesQuery, {
        fetchPolicy: 'cache-only',
        skip: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'control')
    });
    if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'control')) return true;
    if (loading) // while loading use the default docking preference
    return defaultDockedAtTop;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        // couldn't query for user's docking preference, use the default docking preference
        return defaultDockedAtTop;
    }
    // get graphql user preference value
    const dockingPreference = data?.userPreferences?.confluenceEditorSettings?.toolbarDockingInitialPosition;
    if (dockingPreference === 'top') return true;
    if (dockingPreference === 'none') return false;
    return defaultDockedAtTop;
};
module.exports["useIsEditorToolbarDockedAtTop"] = $8a729a72887c33f8$export$39186427447356b2;

});

parcelRegister("3wSkK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $3sFtD = parcelRequire("3sFtD");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $bT0se = parcelRequire("bT0se");


var $g01A4 = parcelRequire("g01A4");


var $6mKj3 = parcelRequire("6mKj3");


var $4VJDS = parcelRequire("4VJDS");


var $9wGTI = parcelRequire("9wGTI");


var $18HQ4 = parcelRequire("18HQ4");


var $kVuKK = parcelRequire("kVuKK");

const $a527c2e06cc0891d$var$AnimatedEllipsis = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.EllipsisContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.AnimatedDot), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.AnimatedDot), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.AnimatedDot), null));
const $a527c2e06cc0891d$var$EditorConnectionBannerComponent = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})((0, $gmMgo.default)(({ editorType: editorType, triggerAnalyticsEvent: triggerAnalyticsEvent, collabEditInternetLost: collabEditInternetLost, collabEditConnectionTimedOut: collabEditConnectionTimedOut = false, willEditorDisable: willEditorDisable = false, contentType: contentType, contentId: contentId, isEditorToolbarHidden: isEditorToolbarHidden, intl: { formatMessage: formatMessage } })=>{
    const [showIndicator, setShowIndicator] = (0, $42omo.useState)(false);
    const [restrictionUpdate, setRestrictionUpdate] = (0, $42omo.useState)(false);
    // initialize offlineData with defaults
    const offlineData = (0, $42omo.useRef)({
        browserNetworkStatus: true,
        documentVisibilityState: '',
        connectionTimeoutStartTime: 0,
        offlineStartTime: 0
    });
    const onRestrictionUpdated = (0, $42omo.useCallback)(()=>{
        triggerAnalyticsEvent('offline.banner.restriction.updated', {
            editorType: editorType,
            restrictionUpdate: restrictionUpdate
        });
        return editorType === 'classic' && setRestrictionUpdate(true);
    }, [
        editorType,
        restrictionUpdate,
        triggerAnalyticsEvent
    ]);
    const onRestrictionUpdatedPubSubEvent = (0, $42omo.useCallback)(()=>{
        if (![
            'DUAL',
            'GRAPHQL'
        ].includes((0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', '')) || !(0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false)) onRestrictionUpdated();
    }, [
        onRestrictionUpdated
    ]);
    const toggleIndicator = (0, $42omo.useCallback)((indicatorToggleCondition, showIndicatorCallback, hideIndicatorCallback)=>{
        let hideTimeout;
        let delayTimeout;
        const HIDE_FLAG_TIMEOUT = 3000;
        const DELAY_TIMEOUT = 3000;
        if (indicatorToggleCondition) delayTimeout = setTimeout(()=>{
            if (showIndicatorCallback) showIndicatorCallback();
            return setShowIndicator(true);
        }, DELAY_TIMEOUT);
        else hideTimeout = setTimeout(()=>{
            if (hideIndicatorCallback) hideIndicatorCallback();
            //hide show indicator only when both disabling conditions are false
            //to handle edge case where both banners got set to true but we want
            // to be able to show connected banner when restored
            if (!collabEditInternetLost && !collabEditConnectionTimedOut) return setShowIndicator(false);
        }, HIDE_FLAG_TIMEOUT);
        return {
            hideTimeout: hideTimeout,
            delayTimeout: delayTimeout
        };
    }, [
        collabEditConnectionTimedOut,
        collabEditInternetLost
    ]);
    // Upon receiving a permission change pubsub event, prepare the banner to show alternative text
    // Note: Only classic (Synchrony) editor gets offline and back online due to permission changes
    (0, $bT0se.usePubSubEvent)({
        contentId: contentId,
        contentType: contentType,
        eventName: `restrictionUpdated:${contentType}`,
        onEvent: onRestrictionUpdatedPubSubEvent,
        skip: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false) && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') && (0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', '') === 'GRAPHQL'
    });
    (0, $g01A4.useContentRestrictionSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        callback: onRestrictionUpdated,
        subscriberId: 'EditorConnectionBannerSubscription'
    });
    (0, $42omo.useEffect)(()=>{
        if (!willEditorDisable) // Reset restriction update boolean upon editor re-connection so next time editor goes offline it will show default messages
        setRestrictionUpdate(false);
    }, [
        willEditorDisable
    ]);
    (0, $42omo.useEffect)(()=>{
        const showIndicatorCB = ()=>{
            // save browser network status, start time of banner display, and document visibility state when user goes offline
            offlineData.current = {
                browserNetworkStatus: navigator.onLine,
                documentVisibilityState: document.visibilityState,
                offlineStartTime: performance.now()
            };
            triggerAnalyticsEvent('offline.banner.show.indicator', {
                editorType: editorType,
                restrictionUpdate: restrictionUpdate
            });
        };
        const hideIndicatorCB = ()=>{
            if (showIndicator) // if offline banner was displayed, fire analytics
            triggerAnalyticsEvent('offline.banner.displayed', {
                browserNetworkStatus: offlineData?.current.browserNetworkStatus,
                editorType: editorType,
                documentVisibilityState: offlineData?.current.documentVisibilityState,
                duration: offlineData?.current.offlineStartTime ? performance.now() - offlineData?.current.offlineStartTime : 0
            });
        };
        const { hideTimeout: hideTimeout, delayTimeout: delayTimeout } = toggleIndicator(collabEditInternetLost, showIndicatorCB, hideIndicatorCB);
        return ()=>{
            clearTimeout(hideTimeout);
            clearTimeout(delayTimeout);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditInternetLost
    ]);
    (0, $42omo.useEffect)(()=>{
        if (collabEditInternetLost) return;
        const showIndicatorCB = ()=>{
            offlineData.current = {
                browserNetworkStatus: navigator.onLine,
                documentVisibilityState: document.visibilityState,
                connectionTimeoutStartTime: performance.now()
            };
            triggerAnalyticsEvent('collab.edit.connection.timeout.show.indicator', {
                contentId: contentId,
                contentType: contentType
            });
        };
        const hideIndicatorCB = ()=>{
            if (showIndicator) // if connection timeout banner was displayed, fire analytics
            triggerAnalyticsEvent('connection.timeout.banner.displayed', {
                browserNetworkStatus: offlineData?.current.browserNetworkStatus,
                editorType: editorType,
                documentVisibilityState: offlineData?.current.documentVisibilityState,
                duration: offlineData?.current.connectionTimeoutStartTime ? performance.now() - offlineData?.current.connectionTimeoutStartTime : 0
            });
        };
        const { hideTimeout: hideTimeout, delayTimeout: delayTimeout } = toggleIndicator(collabEditConnectionTimedOut, showIndicatorCB, hideIndicatorCB);
        return ()=>{
            clearTimeout(hideTimeout);
            clearTimeout(delayTimeout);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditConnectionTimedOut
    ]);
    let bannerMessage;
    if (willEditorDisable) {
        if (restrictionUpdate) bannerMessage = (0, $kVuKK.i18n).editorDisabledDueToPermissionChange;
        else if (collabEditConnectionTimedOut && !collabEditInternetLost) bannerMessage = (0, $kVuKK.i18n).collabEditConnectionTimeout;
        else bannerMessage = (0, $kVuKK.i18n).editorDisabled;
    } else bannerMessage = (0, $kVuKK.i18n).editorEnabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.StatusIndicator), {
        "data-testid": "status-indicator",
        show: showIndicator,
        showOnlineBackground: !collabEditInternetLost && !collabEditConnectionTimedOut,
        toolbarHidden: isEditorToolbarHidden
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.FadingSpan), {
        "data-testid": "status-indicator-online-text",
        role: "alert",
        show: !collabEditInternetLost && !collabEditConnectionTimedOut && showIndicator
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        label: "online-indicator",
        color: "var(--ds-icon-success, #6A9A23)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.StyledText), {
        mediaMaxWidth: "150px",
        "data-testid": "online-text"
    }, formatMessage((0, $kVuKK.i18n).backOnline))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.FadingSpan), {
        "data-testid": "status-indicator-offline-text",
        role: "alert",
        show: collabEditInternetLost || collabEditConnectionTimedOut
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.StyledText), {
        "data-testid": "offline-text"
    }, formatMessage(bannerMessage)), (collabEditInternetLost || collabEditConnectionTimedOut) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a527c2e06cc0891d$var$AnimatedEllipsis, null)));
}));
const $a527c2e06cc0891d$export$810003fd2aab11e5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($a527c2e06cc0891d$var$EditorConnectionBannerComponent);
module.exports["EditorConnectionBanner"] = $a527c2e06cc0891d$export$810003fd2aab11e5;

});

parcelRegister("g01A4", function(module, exports) {

var $i9VoI = parcelRequire("i9VoI");


var $9wGTI = parcelRequire("9wGTI");


var $4VJDS = parcelRequire("4VJDS");


var $6mKj3 = parcelRequire("6mKj3");

const $e0f671e8616dafd9$export$c6d4df78386dbff6 = ({ callback: callback, subscriberId: subscriberId, contentId: contentId, contentType: contentType })=>{
    (0, $i9VoI.useSubscriptionEvent)({
        onDataReceived: callback,
        delta: 'contentRestrictionUpdated',
        subscriberId: subscriberId,
        contentType: contentType,
        contentId: contentId,
        skip: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        !(0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false) || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') || ![
            'DUAL',
            'GRAPHQL'
        ].includes((0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', ''))
    });
};
module.exports["useContentRestrictionSubscriptionEvent"] = $e0f671e8616dafd9$export$c6d4df78386dbff6;

});

parcelRegister("18HQ4", function(module, exports) {
/* BrowserIndicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");

const $4dfb2d8a6603cd21$export$adb584737d712b70 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { toolbarHidden: toolbarHidden, show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_v56417u1 _1e0c1txw _kqswstnw _1bsb1osq _1pbykb7n _1bah1h6o _4cvr1h6o _1ltvze3t _4t3ixy5q _bfhkysee _8hrzjp4b",
            __cmplp.toolbarHidden ? "_154iidpf" : "_154i1ady",
            __cmplp.show ? "_t9ecp8ia" : "_t9ecdgp5",
            __cmplp.toolbarHidden ? "_1911idpf" : "_19111ady",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$b4f88f0ca5784eef = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $4dfb2d8a6603cd21$export$adb584737d712b70, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1pby1fw0",
            __cmplp.show && __cmplp.showOnlineBackground ? "_bfhk1y9u" : "_bfhkysee",
            __cmplp.className
        ])
    });
}); // TODO: Figure out why @compiled is having trouble with the @media lambda function below.
const $4dfb2d8a6603cd21$export$31ea92f3997410dd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { mediaMaxWidth: mediaMaxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1enk3bj": (0, $7sObp.default)(__cmplp.mediaMaxWidth)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _ect41kw7 _k48pmoej _1wyb1crf _syaz1rpy _18u0u2gc _o5721q9c _1hma11y2",
            __cmplp.className
        ])
    });
});
$4dfb2d8a6603cd21$export$31ea92f3997410dd.defaultProps = {
    mediaMaxWidth: '650px'
};
const $4dfb2d8a6603cd21$export$bb5d4b172e6970cd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4dfb2d8a6603cd21$var$FadingSpanInternal, {
        "aria-hidden": !props?.show,
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $4dfb2d8a6603cd21$var$FadingSpanInternal = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_v564ayzn _1e0c1txw _4cvr1h6o _kqswstnw",
            __cmplp.show ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$91672a4b819b5126 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvresu3 _4t3iu2gc _18u0v77o",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$c30cc6d619162254 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _11q71rpy _y44v1dpe _1e0c1o8l _1bsbv77o _4t3iv77o _2hwxv77o _1dvn10n5 _8rwrg43g",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$b9ead157d7292e86 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81o8v _k48pmoej _syaz1oa5",
            __cmplp.className
        ])
    });
});
module.exports["StatusIndicator"] = $4dfb2d8a6603cd21$export$b4f88f0ca5784eef;
module.exports["StyledText"] = $4dfb2d8a6603cd21$export$31ea92f3997410dd;
module.exports["FadingSpan"] = $4dfb2d8a6603cd21$export$bb5d4b172e6970cd;
module.exports["EllipsisContainer"] = $4dfb2d8a6603cd21$export$91672a4b819b5126;
module.exports["AnimatedDot"] = $4dfb2d8a6603cd21$export$c30cc6d619162254;
module.exports["StyledRefreshLink"] = $4dfb2d8a6603cd21$export$b9ead157d7292e86;

});

parcelRegister("kVuKK", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $da4fb2730df63d94$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    editorEnabled: {
        id: "browser-status-indicator.user.offline.editor.enabled",
        defaultMessage: "We\u2019ve lost our connection to you. Your changes will be saved when we reconnect. Trying to reconnect"
    },
    editorEnabledOfflineMode: {
        id: "browser-status-indicator.user.offline.editor.offline-mode.enabled",
        defaultMessage: "You\u2019re back online. You can now use all editing features."
    },
    editorDisabled: {
        id: "browser-status-indicator.user.offline.editor.disabled",
        defaultMessage: "We\u2019ve lost our connection to you, so we\u2019ve disabled editing to prevent any issues. You\u2019ll be able to edit once we reconnect. Trying to reconnect"
    },
    editorDisabledOfflineMode: {
        id: "browser-status-indicator.user.offline.editor.offline-mode.disabled",
        defaultMessage: "Looks like you\u2019re offline. Any changes you make will be automatically saved. Some features will be unavailable."
    },
    backOnline: {
        id: "browser-status-indicator.back.online",
        defaultMessage: "Editing restored"
    },
    editorDisabledDueToPermissionChange: {
        id: "browser-status-indicator.permission.change.offline",
        defaultMessage: "The access update you made is taking longer than expected to save, so we\u2019ve disabled editing to prevent any issues. You\u2019ll be able to edit once the changes finish saving. Saving"
    },
    collabEditConnectionTimeout: {
        id: "browser-status-indicator.collab.edit.timeout",
        defaultMessage: "We\u2019ve lost our connection to you, so editing is paused to prevent any issues. You can edit again once we reconnect, but you may want to copy and save this work now. Trying to reconnect"
    },
    // TODO: Remove when platform_editor_offline_editing_web_ga_fixes is cleaned up - replaced by editorSyncFailedDueToConflictsUpdated
    editorSyncFailedDueToConflicts: {
        id: "browser-status-indicator.collab.edit.conflicts.non-final",
        defaultMessage: "{conflictIcon} We found <conflictLink>{conflictCount, plural, =1 {# conflict} other {# conflicts}}</conflictLink> while syncing your offline edits. Review them below or <saveCopy>save a copy</saveCopy> of your offline edits."
    },
    editorSyncFailedDueToConflictsUpdated: {
        id: "browser-status-indicator.collab.edit.conflicts",
        defaultMessage: "{conflictIcon} We found {conflictCount, plural, one {# conflict} other {# conflicts}} while syncing your offline edits. <conflictLink>Review conflicts</conflictLink>"
    },
    resyncingEditorDisabled: {
        id: "browser-status-indicator.user.offline.editor.resyncing-editor-disabled",
        defaultMessage: "Your offline edits are currently being synced in another tab. You\u2019ll be able to edit once your offline edits finish syncing."
    }
});
module.exports["i18n"] = $da4fb2730df63d94$export$a7357cdd1f0b0168;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("4tuiZ", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $677e07da7eecc531$var$ContentHistoryStore = (0, $1P1Tu.createStore)({
    initialState: {
        shouldShowNewContentHistory: false,
        wasTransitionedFromEditor: false
    },
    actions: {
        showNewContentHistory: ()=>({ setState: setState })=>{
                setState({
                    shouldShowNewContentHistory: true
                });
            },
        hideNewContentHistory: ()=>({ setState: setState })=>{
                setState({
                    shouldShowNewContentHistory: false
                });
            },
        setWasTransitionedFromEditor: (wasTransitionedFromEditor)=>({ setState: setState })=>{
                setState({
                    wasTransitionedFromEditor: wasTransitionedFromEditor
                });
            }
    },
    name: 'newContentHistoryState'
});
const $677e07da7eecc531$export$90587b2a92cba8d5 = (0, $9zUhf.createStateHook)($677e07da7eecc531$var$ContentHistoryStore);
const $677e07da7eecc531$export$9b1a939bc5c5d3b = (0, $9zUhf.createActionsHook)($677e07da7eecc531$var$ContentHistoryStore);
const $677e07da7eecc531$export$1039ffcfa1dfeed2 = (0, $9zUhf.createHook)($677e07da7eecc531$var$ContentHistoryStore);
module.exports["useNewContentHistoryState"] = $677e07da7eecc531$export$90587b2a92cba8d5;
module.exports["useNewContentHistoryActions"] = $677e07da7eecc531$export$9b1a939bc5c5d3b;
module.exports["useNewContentHistory"] = $677e07da7eecc531$export$1039ffcfa1dfeed2;

});

parcelRegister("e6u60", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $dpqzw = parcelRequire("dpqzw");

const $cb9ccc7e1f68f6bb$export$22499ff95fdadf06 = (contentId)=>{
    // grab the element object from local storage
    const { elementObject: elementObject } = $cb9ccc7e1f68f6bb$var$getScrollParams();
    // cleanup local storage once we have the object
    $cb9ccc7e1f68f6bb$var$cleanUpLocalStorageScrolls();
    // return if elementObject doesn't exist or have index and contentId properties
    if (!elementObject?.index || !elementObject?.contentId) return;
    // return if the index is -1 or stored contentId doesn't match current contentId
    if (elementObject?.index < 0 || elementObject?.contentId !== contentId) return;
    // grab the editor parent element
    const scrollParentElement = Array.from(document.getElementsByClassName((0, $dpqzw.EDITOR_PARENT_CLASS)))[0];
    // return if editor parent doesn't exist
    if (!scrollParentElement) return;
    // set scroll behavior to auto, which will make it "jump" instead of scroll
    scrollParentElement.style.scrollBehavior = 'auto';
    // grab all of the direct children elements from the editor parent
    const elements = Array.from(scrollParentElement.querySelectorAll((0, $dpqzw.EDITOR_CHILDREN_SELECTOR)));
    if (elements.length > 0) {
        const idealElement = elements[elementObject.index];
        if (idealElement) {
            // minor offset for visual whitespace
            const addtlOffset = 10;
            scrollParentElement.scrollTo({
                top: idealElement.offsetTop - addtlOffset
            });
            $cb9ccc7e1f68f6bb$var$placeCursor(idealElement);
        }
    }
    // cleanup scrollBehavior
    scrollParentElement.style.scrollBehavior = '';
};
const $cb9ccc7e1f68f6bb$var$placeCursor = (idealElement)=>{
    // we need to use range to place the cursor inside a contenteditable element
    if (document.createRange) {
        // check to see if the direct child of the selected element is a text node, and return if not
        if (!(idealElement?.childNodes[0]?.nodeType === Node.TEXT_NODE)) return;
        // sets the range to contain the contents of the idealElement node, collapse indicating it should be at the end of the text node
        const range = document.createRange();
        range.selectNodeContents(idealElement);
        range.collapse(false);
        // clear existing ranges and add the newly created range
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
};
const $cb9ccc7e1f68f6bb$var$getScrollParams = ()=>{
    return {
        elementObject: (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION)
    };
};
const $cb9ccc7e1f68f6bb$var$cleanUpLocalStorageScrolls = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION);
};
module.exports["scrollToLastViewedPosition"] = $cb9ccc7e1f68f6bb$export$22499ff95fdadf06;

});

parcelRegister("dpqzw", function(module, exports) {
const $e10f62297c04a73f$export$51c8f3f20bd49804 = 'fabric-editor-popup-scroll-parent';
const $e10f62297c04a73f$export$547bf96576574b25 = '.ProseMirror > *';
const $e10f62297c04a73f$export$f76b40820c13783a = '.ak-renderer-document';
const $e10f62297c04a73f$export$7718f42d39a9217b = 'content';
module.exports["EDITOR_PARENT_CLASS"] = $e10f62297c04a73f$export$51c8f3f20bd49804;
module.exports["EDITOR_CHILDREN_SELECTOR"] = $e10f62297c04a73f$export$547bf96576574b25;
module.exports["RENDERED_CONTENT_SELECTOR"] = $e10f62297c04a73f$export$f76b40820c13783a;
module.exports["FABRIC_PAGE_CONTENT_ID"] = $e10f62297c04a73f$export$7718f42d39a9217b;

});

parcelRegister("gkIgp", function(module, exports) {
var $44e99c386783fe05$export$ea1a2a449eaeaa2d = /*#__PURE__*/ function(CollabServiceProperty) {
    CollabServiceProperty["NCS"] = "ncs";
    CollabServiceProperty["SYNCHRONY"] = "synchrony";
    return CollabServiceProperty;
}({});
module.exports["CollabServiceProperty"] = $44e99c386783fe05$export$ea1a2a449eaeaa2d;

});

parcelRegister("kXAjP", function(module, exports) {
$parcel$export(module.exports, "useConnectionsPanel", () => (parcelRequire("39X8O")).useConnectionsPanel);

var $jmjWc = parcelRequire("jmjWc");


var $39X8O = parcelRequire("39X8O");


const $a2d4e70bef17fdaf$export$2dabaf13426958f5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "B5cUO",
    name: "EditorContextConnectionsPanel",
    loader: async ()=>(await (parcelRequire("9vnT2"))).EditorContextConnectionsPanel
});
module.exports["EditorContextConnectionsPanel"] = $a2d4e70bef17fdaf$export$2dabaf13426958f5;

});

parcelRegister("39X8O", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d49dc00c3f0d1c58$export$7e80a76e7cd27a75 = ()=>{
    const [connectionsPanelActiveNodeLocalId, setConnectionsPanelActiveNodeLocalId] = (0, $42omo.useState)(null);
    const openConnectionsPanel = (0, $42omo.useCallback)((localId)=>{
        setConnectionsPanelActiveNodeLocalId(localId);
    }, [
        setConnectionsPanelActiveNodeLocalId
    ]);
    const closeConnectionsPanel = (0, $42omo.useCallback)((localId)=>{
        if (!localId || localId && localId !== connectionsPanelActiveNodeLocalId) setConnectionsPanelActiveNodeLocalId(null);
    }, [
        connectionsPanelActiveNodeLocalId,
        setConnectionsPanelActiveNodeLocalId
    ]);
    return (0, $42omo.useMemo)(()=>({
            connectionsPanelActiveNodeLocalId: connectionsPanelActiveNodeLocalId,
            setConnectionsPanelActiveNodeLocalId: setConnectionsPanelActiveNodeLocalId,
            openConnectionsPanel: openConnectionsPanel,
            closeConnectionsPanel: closeConnectionsPanel
        }), [
        connectionsPanelActiveNodeLocalId,
        setConnectionsPanelActiveNodeLocalId,
        openConnectionsPanel,
        closeConnectionsPanel
    ]);
};
module.exports["useConnectionsPanel"] = $d49dc00c3f0d1c58$export$7e80a76e7cd27a75;

});

parcelRegister("9vnT2", function(module, exports) {

let $6eb989b4e1acb8a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6eb989b4e1acb8a5$var$load("fiOV9"),
    $6eb989b4e1acb8a5$var$load("lPQcc"),
    $6eb989b4e1acb8a5$var$load("WlGjZ")
]).then(()=>parcelRequire('gUdsz'));

});

parcelRegister("6dTPw", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $dx8CK = parcelRequire("dx8CK");


var $hS1eb = parcelRequire("hS1eb");


var $fySJw = parcelRequire("fySJw");

const $dffc47041c3d315b$export$fdfa01513f7f82e4 = (0, $2XqLN.default)((createAnalyticsEvent, contentId, appearance = 'full-page', extensionHandlers, __rendererExtensionOptions, getExtensionHeight)=>{
    const editorAnalyticsAPI = (0, $hS1eb.getEditorAnalyticsAPI)(contentId, createAnalyticsEvent);
    const options = {
        editorAnalyticsAPI: editorAnalyticsAPI,
        appearance: appearance,
        featureFlags: {
            confluence_frontend_macro_interaction_design: true
        },
        externalObservers: [
            (0, $fySJw.getConnectDataListener)()
        ],
        extensionHandlers: extensionHandlers,
        __rendererExtensionOptions: __rendererExtensionOptions,
        getExtensionHeight: getExtensionHeight
    };
    return {
        ...(0, $dx8CK.createReferentiality)(options),
        options: options
    };
});
module.exports["getReferentialityContext"] = $dffc47041c3d315b$export$fdfa01513f7f82e4;

});

parcelRegister("hS1eb", function(module, exports) {

var $f0QSp = parcelRequire("f0QSp");

const $126cb09ff218d79b$export$a46cea14076acdff = (contentId, createAnalyticsEvent)=>(0, $f0QSp.editorAnalyticsAPI).analyticsCallback(contentId, createAnalyticsEvent);
module.exports["getEditorAnalyticsAPI"] = $126cb09ff218d79b$export$a46cea14076acdff;

});

parcelRegister("f0QSp", function(module, exports) {
const $b9a08ec7cb2f821d$var$normalizePayload = (payload)=>{
    const typeMap = {
        operational: 'sendOperationalEvent',
        screen: 'sendScreenEvent',
        track: 'sendTrackEvent',
        ui: 'sendUIEvent'
    };
    return {
        //adding "type" and "source", as they're originally omitted but expected by createAnalyticsEvent
        data: {
            ...payload,
            source: 'editorComponent'
        },
        type: typeMap[payload.eventType]
    };
};
const $b9a08ec7cb2f821d$export$5affe9476a7b3d5b = {
    analyticsCallback: (contentId, createAnalyticsEvent)=>{
        const fireAnalyticsEvent = (payload)=>{
            if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function' && createAnalyticsEvent) window.requestAnimationFrame(()=>{
                const analyticsPayload = $b9a08ec7cb2f821d$var$normalizePayload(payload);
                if (contentId) analyticsPayload.data.attributes = {
                    ...analyticsPayload.data.attributes,
                    objectId: contentId
                };
                createAnalyticsEvent(analyticsPayload).fire();
            });
        };
        const attachAnalyticsEvent = (payload)=>{
            fireAnalyticsEvent(payload);
            return (_tr)=>{
                return true;
            };
        };
        return {
            attachAnalyticsEvent: attachAnalyticsEvent,
            fireAnalyticsEvent: fireAnalyticsEvent
        };
    }
};
module.exports["editorAnalyticsAPI"] = $b9a08ec7cb2f821d$export$5affe9476a7b3d5b;

});

parcelRegister("fySJw", function(module, exports) {

var $2XKS9 = parcelRequire("2XKS9");


var $dc2v6 = parcelRequire("dc2v6");


var $3LvmY = parcelRequire("3LvmY");

let $8e595456ec3aa5d5$var$connectDataListener;


class $8e595456ec3aa5d5$var$ConnectDataListener {
    init({ emit: emit }) {
        this.emit = emit;
    }
    static async validate(extensionKey, data) {
        const { validateSchema: validateSchema, DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("fNtDT"));
        if (!data.eventData) throw new DataTransferValidationError({
            message: "Passed data is missing 'eventData'."
        });
        const keys = Object.keys(data.eventData);
        if (keys.length !== 1) throw new DataTransferValidationError({
            message: "'eventData' should only include a single key. The key should be same with 'refDataSchema.outputType'."
        });
        const connectMacroKeyRefOutputTypeMap = await (0, $dc2v6.getConnectMacroKeyRefOutputTypeMap)();
        if (!connectMacroKeyRefOutputTypeMap.has(extensionKey)) // This is a case that shouldn't really happen. Throwing a regular error instead of DataTransferValidationError
        // because this error is not related to what the vendor emitted data.
        throw new Error('extensionKey is not found in the macro metadata.');
        if (connectMacroKeyRefOutputTypeMap.get(extensionKey) !== keys[0]) throw new DataTransferValidationError({
            message: `'eventData' should contain 'refDataSchema.outputType' defined in the app manifest (${connectMacroKeyRefOutputTypeMap.get(extensionKey)}).`
        });
        validateSchema(keys[0], data.eventData[keys[0]]);
    }
    async transfer(extensionKey, localId, data, createAnalyticsEvent, isViewPage) {
        if (this.emit && localId && data) {
            const { DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("fNtDT"));
            try {
                await $8e595456ec3aa5d5$var$ConnectDataListener.validate(extensionKey, data);
            } catch (e) {
                const event = (0, $3LvmY.getValidationFailedEvent)({
                    isViewPage: isViewPage,
                    extensionKey: extensionKey,
                    error: e
                });
                createAnalyticsEvent(event).fire();
                if (e instanceof DataTransferValidationError) return {
                    status: (0, $2XKS9.ConnectDataTransferStatus).Error,
                    message: e.message,
                    module: 'data_provider',
                    errors: e.errors
                };
                throw e;
            }
            this.emit(localId, data.eventData);
            return {
                status: (0, $2XKS9.ConnectDataTransferStatus).Success,
                message: 'Data accepted and emitted',
                module: 'data_provider'
            };
        }
        return {
            status: (0, $2XKS9.ConnectDataTransferStatus).Error,
            message: 'There was an issue accepting the data',
            module: 'data_provider'
        };
    }
    constructor(){
        this.emit = void 0;
    }
}
const $8e595456ec3aa5d5$export$605049a72d9f563 = ()=>{
    if (!$8e595456ec3aa5d5$var$connectDataListener) $8e595456ec3aa5d5$var$connectDataListener = new $8e595456ec3aa5d5$var$ConnectDataListener();
    return $8e595456ec3aa5d5$var$connectDataListener;
};
module.exports["getConnectDataListener"] = $8e595456ec3aa5d5$export$605049a72d9f563;

});

parcelRegister("2XKS9", function(module, exports) {
var $606590dfce3163d6$export$f9f405499e653992 = /*#__PURE__*/ function(ConnectDataTransferStatus) {
    ConnectDataTransferStatus["Success"] = "Success";
    ConnectDataTransferStatus["Error"] = "Error";
    return ConnectDataTransferStatus;
}({});
module.exports["ConnectDataTransferStatus"] = $606590dfce3163d6$export$f9f405499e653992;

});

parcelRegister("dc2v6", function(module, exports) {

var $3IXUB = parcelRequire("3IXUB");

let $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
let $a1018373af446f97$var$initialized = false;
async function $a1018373af446f97$var$createMacroKeyRefOutputTypeMap() {
    const macros = await (0, $3IXUB.getMacroMetaData)();
    const result = macros.filter((macro)=>macro.refDataSchema != null).map((macro)=>[
            macro.macroName,
            macro.refDataSchema.outputType
        ]);
    return new Map(result);
}
async function $a1018373af446f97$export$9fde119d071a7062() {
    // used this initialized variable because I was seeing that connectMacroKeyRefOutputTypeMap may
    // be null errors otherwise
    if (!$a1018373af446f97$var$initialized) {
        $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap = await $a1018373af446f97$var$createMacroKeyRefOutputTypeMap();
        $a1018373af446f97$var$initialized = true;
    }
    return $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
}
module.exports["getConnectMacroKeyRefOutputTypeMap"] = $a1018373af446f97$export$9fde119d071a7062;

});

parcelRegister("3LvmY", function(module, exports) {
const $a60398d8d7606d16$export$16d909a88d49df97 = ({ isViewPage: isViewPage, extensionKey: extensionKey, error: error })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'failed',
            actionSubject: 'connectRefEventDataValidation',
            attributes: {
                extensionKey: extensionKey,
                message: error.message
            }
        }
    };
};
const $a60398d8d7606d16$export$f472af28e6312d6e = ({ isViewPage: isViewPage, extensionKey: extensionKey })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'received',
            actionSubject: 'connectRefEventData',
            attributes: {
                extensionKey: extensionKey
            }
        }
    };
};
module.exports["getValidationFailedEvent"] = $a60398d8d7606d16$export$16d909a88d49df97;
module.exports["getReceivedConnectRefDataEvent"] = $a60398d8d7606d16$export$f472af28e6312d6e;

});

parcelRegister("fNtDT", function(module, exports) {

let $b8026cfc4781e004$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8026cfc4781e004$var$load("iEvs6").then(()=>parcelRequire('bppNh'));

});

parcelRegister("aG1TG", function(module, exports) {

let $7c5f4c5ec7299f2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7c5f4c5ec7299f2d$var$load("lUlCu"),
    $7c5f4c5ec7299f2d$var$load("gt1ja")
]).then(()=>parcelRequire('98w9o'));

});

parcelRegister("4ri4I", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4d309a7dc7a1cda3$export$64697004958d0ff1 = {
    editSource: ''
};
const $4d309a7dc7a1cda3$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        ...$4d309a7dc7a1cda3$export$64697004958d0ff1
    },
    actions: {
        setEditSource: (editSource)=>({ setState: setState })=>{
                setState({
                    editSource: editSource
                });
            }
    },
    name: 'setEditSource'
});
const $4d309a7dc7a1cda3$export$ee479a8e5902b302 = (0, $9zUhf.createHook)($4d309a7dc7a1cda3$var$Store);
const $4d309a7dc7a1cda3$export$7e972f51583fdb8e = (0, $9zUhf.createActionsHook)($4d309a7dc7a1cda3$var$Store);
module.exports["useEditSource"] = $4d309a7dc7a1cda3$export$ee479a8e5902b302;
module.exports["useEditSourceActions"] = $4d309a7dc7a1cda3$export$7e972f51583fdb8e;

});

parcelRegister("c0BUW", function(module, exports) {

let $8be2e5baac3b35a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8be2e5baac3b35a8$var$load("kD057").then(()=>parcelRequire('KcDfp'));

});

parcelRegister("kXsBa", function(module, exports) {

var $cXQmG = parcelRequire("cXQmG");


var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");


var $cgpF0 = parcelRequire("cgpF0");


var $ij4CE = parcelRequire("ij4CE");


var $9wGTI = parcelRequire("9wGTI");

const $563fbe27571904a7$export$57b25de3525e313f = (contentId, currentTitle)=>{
    const [isEditing, setIsEditing] = (0, $42omo.useState)(false);
    const [updatedTitleFromPubsub, setUpdatedTitleFromPubsub] = (0, $42omo.useState)(undefined);
    const isProcessingTitleUpdate = (0, $42omo.useRef)(false);
    const onMutationComplete = ()=>{
        setUpdateError(undefined);
        setIsEditing(false);
    };
    const [updateError, setUpdateError] = (0, $42omo.useState)(undefined);
    const [updateContentTitle, { loading: updateLoading }] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useContentTypesTitleUpdateContentTitleMutation($contentId:ID!$title:String){updateTitle(contentId:$contentId title:$title){id title links{editui webui}}}`, {
        onCompleted: onMutationComplete,
        onError: setUpdateError
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $cXQmG.default)
    });
    const updateCache = (0, $42omo.useCallback)((value)=>{
        writeFragmentInterop({
            fragmentId: `Content:${contentId}`,
            data: {
                id: contentId,
                title: value,
                __typename: 'Content'
            }
        });
    }, [
        contentId,
        writeFragmentInterop
    ]);
    const updateTitle = (0, $42omo.useCallback)(async (value_0)=>{
        if (value_0 === currentTitle) {
            setIsEditing(false);
            // We have to manually clear the error here because it is no longer relevant to this most recent call to `updateTitle`,
            // since we're now attempting to set the title back to the current title, which should be valid.
            setUpdateError(undefined);
            if (updatedTitleFromPubsub && updatedTitleFromPubsub !== currentTitle) {
                updateCache(updatedTitleFromPubsub);
                setUpdatedTitleFromPubsub(undefined);
            }
            if (!isProcessingTitleUpdate.current) return;
        }
        try {
            await updateContentTitle({
                variables: {
                    contentId: contentId,
                    title: value_0
                }
            });
        } catch  {
        // error handled by useMutation result updateError
        }
    }, [
        contentId,
        currentTitle,
        updateCache,
        updateContentTitle,
        updatedTitleFromPubsub
    ]);
    /**
   * The following section is a mutation queue to ensure that title updates are processed sequentially and that the
   * latest title is always the one that gets applied.
   * This is important because multiple title updates can be triggered in quick succession when AI inline streaming
   * occurs and we want to avoid stale state errors from the GQL store, but also ensure the latest title is the one that
   * gets applied.
   */ const latestCachedTitle = (0, $42omo.useRef)();
    const processQueue = (0, $42omo.useCallback)(async ()=>{
        if (isProcessingTitleUpdate.current) return;
        isProcessingTitleUpdate.current = true;
        let nextTitle = latestCachedTitle.current;
        latestCachedTitle.current = undefined;
        // We keep updating the title until there are no more titles in the cache
        while(!!nextTitle){
            await updateTitle(nextTitle);
            nextTitle = latestCachedTitle.current;
            latestCachedTitle.current = undefined;
        }
        isProcessingTitleUpdate.current = false;
    }, [
        updateTitle
    ]);
    const enqueueTitle = (0, $42omo.useCallback)(async (title)=>{
        latestCachedTitle.current = title;
        if (!isProcessingTitleUpdate.current) await processQueue();
    }, [
        processQueue
    ]);
    // Set the title change handler when the component mounts
    // Content types use this method to update the title from within the iframe
    (0, $42omo.useEffect)(()=>{
        (0, $cgpF0.contentTypesTitleServiceSingleton).setTitleChangeHandler(updateTitle);
        return ()=>{
            (0, $cgpF0.contentTypesTitleServiceSingleton).setTitleChangeHandler(()=>{});
        };
    }, [
        updateTitle
    ]);
    return {
        isEditing: isEditing,
        setIsEditing: setIsEditing,
        setUpdatedTitleFromPubsub: setUpdatedTitleFromPubsub,
        updateLoading: updateLoading,
        updateError: updateError,
        updateTitle: (0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? enqueueTitle : updateTitle,
        updateCache: updateCache
    };
};
module.exports["useContentTypesTitleUpdate"] = $563fbe27571904a7$export$57b25de3525e313f;

});

parcelRegister("cXQmG", function(module, exports) {
/**
 * @generated SignedSource<<3a0cc20ba43170d4195e7743f00dc422>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d6b675ba61ab7de1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useContentTypesTitleUpdateContentTitleWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$d6b675ba61ab7de1$var$node.hash = "3d624df929b7f5b6bedfdab8b98fb427";
var $d6b675ba61ab7de1$export$2e2bcd8739ae039 = $d6b675ba61ab7de1$var$node;
module.exports["default"] = $d6b675ba61ab7de1$export$2e2bcd8739ae039;

});

parcelRegister("cgpF0", function(module, exports) {
class $ef2bdef46a40b8c0$export$b44304baa0bf4e7b {
    updateTitle(title) {
        this.titleChangeHandler(title);
    }
    setTitleChangeHandler(cb) {
        this.titleChangeHandler = cb;
    }
    constructor(){
        this.titleChangeHandler = void 0;
        this.titleChangeHandler = ()=>{};
    }
}
const $ef2bdef46a40b8c0$export$6450770420296206 = new $ef2bdef46a40b8c0$export$b44304baa0bf4e7b();
module.exports["contentTypesTitleServiceSingleton"] = $ef2bdef46a40b8c0$export$6450770420296206;

});

parcelRegister("1B6Lx", function(module, exports) {

var $hm7Pp = parcelRequire("hm7Pp");


var $fgrom = parcelRequire("fgrom");


var $1dRHU = parcelRequire("1dRHU");


var $ej7SU = parcelRequire("ej7SU");


var $42omo = parcelRequire("42omo");


var $7hXu9 = parcelRequire("7hXu9");


var $eSUdr = parcelRequire("eSUdr");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $de2j9 = parcelRequire("de2j9");


var $6mKj3 = parcelRequire("6mKj3");

const $42cdb37fcd4a7f68$export$751dd0cb1bbd0638 = ()=>{
    const apolloClient = (0, $7hXu9.useApolloClient)();
    const readLastEditedDraftVersionFragmentFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $ej7SU.default)
    });
    const readLastEditedVersionFragmentFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $1dRHU.default)
    });
    const writeLastEditedDraftVersionFragmentFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $fgrom.default)
    });
    const writeLastEditedVersionFragmentFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $hm7Pp.default)
    });
    const { displayName: displayName } = (0, $bQm3c.useSessionData)();
    const [currentPageContentId] = (0, $ep3mz.usePageContentId)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const updateTimestampCache = ({ contentId: contentId })=>{
        const newWhen = new Date().toISOString();
        const isEditingThisContent = isOnEditRoute && contentId === currentPageContentId;
        const fragment = (0, $eSUdr.default)`fragment useUpdateLastEditedTimestampVersionCacheOldFragment on Version{by{displayName}when}`;
        const id = `$Content:${contentId}.${isEditingThisContent ? 'draftVersion' : 'version'}`;
        let prevTypename = 'KnownUser';
        if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) {
            try {
                const readFragmentInterop = isEditingThisContent ? readLastEditedDraftVersionFragmentFragmentInterop : readLastEditedVersionFragmentFragmentInterop;
                const prevCache = readFragmentInterop({
                    id: id
                });
                if (prevCache?.by?.__typename) prevTypename = prevCache.by.__typename;
            } catch  {
            // silently fallback to default typename "KnownUser"
            }
            try {
                const writeFragmentInterop = isEditingThisContent ? writeLastEditedDraftVersionFragmentFragmentInterop : writeLastEditedVersionFragmentFragmentInterop;
                writeFragmentInterop({
                    fragmentId: id,
                    data: {
                        by: {
                            displayName: displayName,
                            __typename: prevTypename
                        },
                        when: newWhen,
                        __typename: 'Version'
                    }
                });
            } catch  {
            // silently fail write to cache
            }
        } else {
            try {
                const prevCache = apolloClient.readFragment({
                    id: id,
                    fragment: fragment
                });
                if (prevCache?.by?.__typename) prevTypename = prevCache.by.__typename;
            } catch  {
            // silently fallback to default typename "KnownUser"
            }
            try {
                apolloClient.writeFragment({
                    id: id,
                    fragment: fragment,
                    data: {
                        by: {
                            displayName: displayName,
                            __typename: prevTypename
                        },
                        when: newWhen,
                        __typename: 'Version'
                    }
                });
            } catch  {
            // silently fail write to cache
            }
        }
    };
    const updateTimestampCacheWithCallback = (0, $42omo.useCallback)(updateTimestampCache, [
        apolloClient,
        currentPageContentId,
        isOnEditRoute,
        displayName,
        readLastEditedDraftVersionFragmentFragmentInterop,
        readLastEditedVersionFragmentFragmentInterop,
        writeLastEditedDraftVersionFragmentFragmentInterop,
        writeLastEditedVersionFragmentFragmentInterop
    ]);
    if ((0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true)) return updateTimestampCacheWithCallback;
    return updateTimestampCache;
};
module.exports["useUpdateLastEditedTimestampVersionCache"] = $42cdb37fcd4a7f68$export$751dd0cb1bbd0638;

});

parcelRegister("hm7Pp", function(module, exports) {
/**
 * @generated SignedSource<<2ac329da81149c1c3666eddb688657bd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03557d594dff4afc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionWriteFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$03557d594dff4afc$var$node.hash = "c18ed3f2e877d3ca1cd623e5a0859ba4";
var $03557d594dff4afc$export$2e2bcd8739ae039 = $03557d594dff4afc$var$node;
module.exports["default"] = $03557d594dff4afc$export$2e2bcd8739ae039;

});

parcelRegister("fgrom", function(module, exports) {
/**
 * @generated SignedSource<<0a1c88ca4a42ad82ed80e88345c91c0b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $61389ca52d0a73e1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionWriteFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$61389ca52d0a73e1$var$node.hash = "f2546d473e081d7f407ad1cb2c10a7c2";
var $61389ca52d0a73e1$export$2e2bcd8739ae039 = $61389ca52d0a73e1$var$node;
module.exports["default"] = $61389ca52d0a73e1$export$2e2bcd8739ae039;

});

parcelRegister("1dRHU", function(module, exports) {
/**
 * @generated SignedSource<<375bcded8b18381e41f1464677a39a40>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $342531e247c7cf4b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionReadFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$342531e247c7cf4b$var$node.hash = "e1d2099945c80fbb0be34791a561397b";
var $342531e247c7cf4b$export$2e2bcd8739ae039 = $342531e247c7cf4b$var$node;
module.exports["default"] = $342531e247c7cf4b$export$2e2bcd8739ae039;

});

parcelRegister("ej7SU", function(module, exports) {
/**
 * @generated SignedSource<<faed0d1cb93aff3affdab8bcefc50ba6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4982d7036fccc1ba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionReadFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$4982d7036fccc1ba$var$node.hash = "52ad41feb7c48850dc9ff2da1dd55879";
var $4982d7036fccc1ba$export$2e2bcd8739ae039 = $4982d7036fccc1ba$var$node;
module.exports["default"] = $4982d7036fccc1ba$export$2e2bcd8739ae039;

});

parcelRegister("3o3i5", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $2XqLN = parcelRequire("2XqLN");

const $d83b6646de023a51$var$defaultRetrieveEditorTitleAndContent = ()=>Promise.resolve({
        title: '',
        adf: {
            type: ''
        }
    });
const $d83b6646de023a51$var$defaultEditorObjectHeaderContext = {
    saveDraft: ()=>Promise.resolve(),
    navigateOnClose: ()=>{},
    triggerAnalyticsEvent: ()=>{},
    version: 0,
    editorActions: {
        isDocumentEmpty: ()=>{}
    },
    title: '',
    retrieveEditorTitleAndContent: $d83b6646de023a51$var$defaultRetrieveEditorTitleAndContent,
    onPreviewClicked: ()=>{},
    isPublishingContent: false,
    userOffline: false,
    editorTitle: null,
    collabLimitReached: false,
    collabEditConnected: false,
    onClickPublish: ()=>{},
    shouldRenderPreview: false,
    shouldShowNewContentHistory: false,
    isUnpublishedDraft: false,
    onHoverPublish: ()=>{}
};
const $d83b6646de023a51$var$EditorObjectHeaderContext = /*#__PURE__*/ (0, $42omo.createContext)($d83b6646de023a51$var$defaultEditorObjectHeaderContext);
const $d83b6646de023a51$var$memoizeDeepEq = (0, $2XqLN.default)((obj)=>obj, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $d83b6646de023a51$export$7cf4636ad0f38e12 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, value: value } = t0;
    let t1;
    if ($[0] !== value) {
        t1 = $d83b6646de023a51$var$memoizeDeepEq(value);
        $[0] = value;
        $[1] = t1;
    } else t1 = $[1];
    const memoizedValue = t1;
    const t2 = memoizedValue;
    let t3;
    if ($[2] !== children || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d83b6646de023a51$var$EditorObjectHeaderContext.Provider, {
            value: t2
        }, children);
        $[2] = children;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, value: value })=>{
    const memoizedValue = $d83b6646de023a51$var$memoizeDeepEq(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d83b6646de023a51$var$EditorObjectHeaderContext.Provider, {
        value: memoizedValue
    }, children);
};
const $d83b6646de023a51$export$54525653dcbc614a = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($d83b6646de023a51$var$EditorObjectHeaderContext);
    if (!context) throw new Error("useEditorObjectHeaderContext must be used within a EditorObjectHeaderContextProvider, and a `value` must be provided to EditorObjectHeaderContextProvider");
    return context;
} : ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($d83b6646de023a51$var$EditorObjectHeaderContext);
    if (!context) throw new Error('useEditorObjectHeaderContext must be used within a EditorObjectHeaderContextProvider, and a `value` must be provided to EditorObjectHeaderContextProvider');
    return context;
};
module.exports["EditorObjectHeaderContextProvider"] = $d83b6646de023a51$export$7cf4636ad0f38e12;
module.exports["useEditorObjectHeaderContext"] = $d83b6646de023a51$export$54525653dcbc614a;

});

parcelRegister("kSPGK", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

class $5d6af3820d303892$var$OptimisticTitleChangeEventBus {
    emit(contentId, title) {
        if (this.listeners[contentId]) this.listeners[contentId].forEach((fn)=>{
            fn(title);
        });
    }
    subscribe(contentId, fn) {
        if (!this.listeners[contentId]) this.listeners[contentId] = [];
        this.listeners[contentId].push(fn);
    }
    unsubcribe(contentId, fn) {
        if (this.listeners[contentId]) {
            const index = this.listeners[contentId].findIndex((item)=>item[0] === fn);
            if (index !== -1) this.listeners[contentId].splice(index, 1);
        }
    }
    constructor(){
        this.listeners = void 0;
        this.listeners = {};
    }
}
const $5d6af3820d303892$var$optimisticTitleChangeEventBus = new $5d6af3820d303892$var$OptimisticTitleChangeEventBus();
const $5d6af3820d303892$export$255638cdf0226b65 = (0, $3u0dr.isReactCompilerActiveV1)() ? (contentId, initialTitle, onOptimisticUpdate)=>{
    const $ = (0, $frIzR.c)(16);
    const [optimisticTitle, setOptimisticTitle] = (0, $42omo.useState)(initialTitle);
    let t0;
    if ($[0] !== contentId || $[1] !== optimisticTitle) {
        t0 = (value)=>{
            if (value !== optimisticTitle) $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.emit(contentId, value);
        };
        $[0] = contentId;
        $[1] = optimisticTitle;
        $[2] = t0;
    } else t0 = $[2];
    const publishOptimisticTitle = t0;
    let t1;
    if ($[3] !== contentId || $[4] !== onOptimisticUpdate) {
        t1 = (title)=>{
            setOptimisticTitle(title);
            onOptimisticUpdate && onOptimisticUpdate(contentId, title);
        };
        $[3] = contentId;
        $[4] = onOptimisticUpdate;
        $[5] = t1;
    } else t1 = $[5];
    const handleTitleChanged = t1;
    let t2;
    let t3;
    if ($[6] !== contentId || $[7] !== handleTitleChanged) {
        t2 = ()=>{
            $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.subscribe(contentId, handleTitleChanged);
            return ()=>{
                $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.unsubcribe(contentId, handleTitleChanged);
            };
        };
        t3 = [
            contentId,
            handleTitleChanged
        ];
        $[6] = contentId;
        $[7] = handleTitleChanged;
        $[8] = t2;
        $[9] = t3;
    } else {
        t2 = $[8];
        t3 = $[9];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[10] !== initialTitle) {
        t4 = ()=>{
            setOptimisticTitle(initialTitle);
        };
        t5 = [
            initialTitle
        ];
        $[10] = initialTitle;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[13] !== optimisticTitle || $[14] !== publishOptimisticTitle) {
        t6 = {
            optimisticTitle: optimisticTitle,
            setOptimisticTitle: publishOptimisticTitle
        };
        $[13] = optimisticTitle;
        $[14] = publishOptimisticTitle;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : (contentId, initialTitle, onOptimisticUpdate)=>{
    const [optimisticTitle, setOptimisticTitle] = (0, $42omo.useState)(initialTitle);
    const publishOptimisticTitle = (0, $42omo.useCallback)((value)=>{
        if (value !== optimisticTitle) $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.emit(contentId, value);
    }, [
        contentId,
        optimisticTitle
    ]);
    const handleTitleChanged = (0, $42omo.useCallback)((title)=>{
        setOptimisticTitle(title);
        onOptimisticUpdate && onOptimisticUpdate(contentId, title);
    }, [
        contentId,
        setOptimisticTitle,
        onOptimisticUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.subscribe(contentId, handleTitleChanged);
        return ()=>{
            $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.unsubcribe(contentId, handleTitleChanged);
        };
    }, [
        contentId,
        handleTitleChanged
    ]);
    // If initialTitle changes, update optimistic title to match new initialTitle.
    // Why? This fixes scenarios where the BE title of the page changes without the title changing on the FE, e.g. when a draft with no title is converted to a live page with a title generated by the BE.
    //      Without this useEffect, the title will undesirably stay as the original initialTitle of "Untitled" instead of using the new title from the BE.
    (0, $42omo.useEffect)(()=>{
        setOptimisticTitle(initialTitle);
    }, [
        initialTitle
    ]);
    return {
        optimisticTitle: optimisticTitle,
        setOptimisticTitle: publishOptimisticTitle
    };
};
module.exports["useOptimisticTitleChange"] = $5d6af3820d303892$export$255638cdf0226b65;

});

parcelRegister("bMmhd", function(module, exports) {

let $893575106a7dd9f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $893575106a7dd9f1$var$load("d9TJ0"),
    $893575106a7dd9f1$var$load("8nWJU"),
    $893575106a7dd9f1$var$load("cgmWe"),
    $893575106a7dd9f1$var$load("1wZEW"),
    $893575106a7dd9f1$var$load("2B6wT"),
    $893575106a7dd9f1$var$load("gKYwM"),
    $893575106a7dd9f1$var$load("8KWDC"),
    $893575106a7dd9f1$var$load("a5wu4"),
    $893575106a7dd9f1$var$load("hwLGf"),
    $893575106a7dd9f1$var$load("dVAT5"),
    $893575106a7dd9f1$var$load("fIFgO"),
    $893575106a7dd9f1$var$load("ht5OT"),
    $893575106a7dd9f1$var$load("sj9Xz"),
    $893575106a7dd9f1$var$load("eHDb1"),
    $893575106a7dd9f1$var$load("2zUEf"),
    $893575106a7dd9f1$var$load("f1NVy"),
    $893575106a7dd9f1$var$load("dChec"),
    $893575106a7dd9f1$var$load("2YffH"),
    $893575106a7dd9f1$var$load("f35QR"),
    $893575106a7dd9f1$var$load("eVYW1"),
    $893575106a7dd9f1$var$load("ls0Um"),
    $893575106a7dd9f1$var$load("020xd"),
    $893575106a7dd9f1$var$load("eTBsW"),
    $893575106a7dd9f1$var$load("bYxCZ"),
    $893575106a7dd9f1$var$load("6HBYC"),
    $893575106a7dd9f1$var$load("1oiJ6"),
    $893575106a7dd9f1$var$load("huUvS"),
    $893575106a7dd9f1$var$load("3RdRc"),
    $893575106a7dd9f1$var$load("98UJI"),
    $893575106a7dd9f1$var$load("b0cmi"),
    $893575106a7dd9f1$var$load("51haJ"),
    $893575106a7dd9f1$var$load("7f9Fz"),
    $893575106a7dd9f1$var$load("9XYQ9"),
    $893575106a7dd9f1$var$load("jp3gT"),
    $893575106a7dd9f1$var$load("5EQhG"),
    $893575106a7dd9f1$var$load("8fXIr"),
    $893575106a7dd9f1$var$load("dVkhd"),
    $893575106a7dd9f1$var$load("7jSfd"),
    $893575106a7dd9f1$var$load("4HZlX"),
    $893575106a7dd9f1$var$load("kDqHr"),
    $893575106a7dd9f1$var$load("kjZZD"),
    $893575106a7dd9f1$var$load("dTsOE"),
    $893575106a7dd9f1$var$load("hhss7"),
    $893575106a7dd9f1$var$load("7EorR"),
    $893575106a7dd9f1$var$load("Wowvf"),
    $893575106a7dd9f1$var$load("bTmOC"),
    $893575106a7dd9f1$var$load("lFZaH"),
    $893575106a7dd9f1$var$load("lPQcc"),
    $893575106a7dd9f1$var$load("jg5LT"),
    $893575106a7dd9f1$var$load("6wr18"),
    $893575106a7dd9f1$var$load("ffEVr"),
    $893575106a7dd9f1$var$load("cMlHc"),
    $893575106a7dd9f1$var$load("5IgYU"),
    $893575106a7dd9f1$var$load("keUAv")
]).then(()=>parcelRequire('jeJjF'));

});

parcelRegister("4cOi8", function(module, exports) {
var $c7f67cb608b5916f$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $c7f67cb608b5916f$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $c7f67cb608b5916f$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $c7f67cb608b5916f$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $c7f67cb608b5916f$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $c7f67cb608b5916f$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $c7f67cb608b5916f$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $c7f67cb608b5916f$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $c7f67cb608b5916f$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $c7f67cb608b5916f$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $c7f67cb608b5916f$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $c7f67cb608b5916f$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
module.exports["ButtonStyle"] = $c7f67cb608b5916f$export$bdc3c19374266b98;
module.exports["CornerStyle"] = $c7f67cb608b5916f$export$a6e645fda5339bf8;
module.exports["Height"] = $c7f67cb608b5916f$export$8954cfac7c08d16a;
module.exports["Alignment"] = $c7f67cb608b5916f$export$9d7927214ed7d2cf;
module.exports["Orientation"] = $c7f67cb608b5916f$export$df54d73aa0ec5e82;
module.exports["CommonLayout"] = $c7f67cb608b5916f$export$42809f9f1496f50d;
module.exports["FeedbackType"] = $c7f67cb608b5916f$export$d4c0482bf980ef26;
module.exports["ExtensionMode"] = $c7f67cb608b5916f$export$533ae1c1b7b7ac6;
module.exports["RenderVariant"] = $c7f67cb608b5916f$export$1f60141b6ce5efed;
module.exports["SegmentationTargets"] = $c7f67cb608b5916f$export$f6cd408cac7f930c;
module.exports["ITEM_FIELDS"] = $c7f67cb608b5916f$export$bf7ebf7fed6e7189;

});

parcelRegister("cQhbe", function(module, exports) {
var $3ddd96eb421fb45c$export$c184dc244f9dacf4 = /*#__PURE__*/ function(AutoConvertEvent) {
    AutoConvertEvent["VIEWED"] = "pageViewed";
    AutoConvertEvent["EDITED"] = "pageEdited";
    AutoConvertEvent["PUBLISHED"] = "pagePublished";
    AutoConvertEvent["NOTIFICATION_SHOWN"] = "notificationShown";
    AutoConvertEvent["NOTIFICATION_ERROR"] = "notificationError";
    return AutoConvertEvent;
}({});
var $3ddd96eb421fb45c$export$a248ed70ead7ff08 = /*#__PURE__*/ function(AutoConvertActionSubject) {
    AutoConvertActionSubject["AUTO_CONVERSION"] = "autoConversion";
    AutoConvertActionSubject["AUTO_CONVERSION_BYLINE"] = "autoConversionByLine";
    return AutoConvertActionSubject;
}({});
var $3ddd96eb421fb45c$export$d8b435b7aa875953 = /*#__PURE__*/ function(RevertAutoConvertEvent) {
    RevertAutoConvertEvent["DIALOG_OPEN"] = "revertDialogOpen";
    RevertAutoConvertEvent["CLICKED"] = "revertClicked";
    RevertAutoConvertEvent["CANCELLED"] = "revertCancelled";
    RevertAutoConvertEvent["CONFIRMED"] = "revertConfirmed";
    RevertAutoConvertEvent["ERROR"] = "revertError";
    return RevertAutoConvertEvent;
}({});
var $3ddd96eb421fb45c$export$b22548c36d783030 = /*#__PURE__*/ function(AutoConvertPanelEvent) {
    AutoConvertPanelEvent["VIEWED"] = "panelViewed";
    AutoConvertPanelEvent["SUPPORTED"] = "panelSupported";
    AutoConvertPanelEvent["NONE"] = "panelNone";
    AutoConvertPanelEvent["GET_ERROR"] = "panelGetError";
    AutoConvertPanelEvent["SET_ERROR"] = "panelSetError";
    return AutoConvertPanelEvent;
}({});
var $3ddd96eb421fb45c$export$e8dbd545dc7c3af0 = /*#__PURE__*/ function(AutoConversionByLineEvent) {
    AutoConversionByLineEvent["CLICKED"] = "bylineClicked";
    AutoConversionByLineEvent["NEW_EDITOR_MODAL_OPENED"] = "newEditorModalOpened";
    AutoConversionByLineEvent["NEW_EDITOR_MODAL_CLOSED"] = "newEditorModalClosed";
    return AutoConversionByLineEvent;
}({});
const $3ddd96eb421fb45c$export$b4535793cfa6d80a = (createAnalyticsEvent, analytics, actionSubject)=>{
    const { pageAction: pageAction, source: source, setting: setting } = analytics;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'triggered',
            actionSubject: actionSubject,
            source: source,
            actionSubjectId: 'page',
            attributes: {
                pageAction: pageAction,
                setting: setting
            }
        }
    }).fire();
};
const $3ddd96eb421fb45c$export$e045315387fc4262 = (createAnalyticsEvent, analytics)=>{
    const { level: level, panelAction: panelAction, source: source } = analytics;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'autoConversion',
            source: source,
            actionSubjectId: 'panel',
            attributes: {
                level: level,
                panelAction: panelAction
            }
        }
    }).fire();
};
module.exports["AutoConvertEvent"] = $3ddd96eb421fb45c$export$c184dc244f9dacf4;
module.exports["AutoConvertActionSubject"] = $3ddd96eb421fb45c$export$a248ed70ead7ff08;
module.exports["RevertAutoConvertEvent"] = $3ddd96eb421fb45c$export$d8b435b7aa875953;
module.exports["AutoConvertPanelEvent"] = $3ddd96eb421fb45c$export$b22548c36d783030;
module.exports["AutoConversionByLineEvent"] = $3ddd96eb421fb45c$export$e8dbd545dc7c3af0;
module.exports["sendEditorConversionAnalyticsPageEvent"] = $3ddd96eb421fb45c$export$b4535793cfa6d80a;
module.exports["sendEditorConversionAnalyticsPanelEvent"] = $3ddd96eb421fb45c$export$e045315387fc4262;

});

parcelRegister("1Vx7O", function(module, exports) {
const $3b89d048e09c7153$export$d9eb6707f6a1e3a = ({ title: title, isPublishingContent: isPublishingContent, userOffline: userOffline = false, forceDisabled: forceDisabled = false })=>{
    if (userOffline || forceDisabled) // no tooltip for publish button when disabled due to internet lost, banner will be shown indicating lost connection
    // no tooltip for publish button when editor is force disabled, this happens when page is converted to blog or converted between live and non live page
    return '';
    else if (!title) return 'editor.buttons.disable.by.empty.title.tooltip';
    else if (isPublishingContent) return 'editor.buttons.disable.by.saving.tooltip';
    return '';
};
module.exports["getPublishButtonDisabledReason"] = $3b89d048e09c7153$export$d9eb6707f6a1e3a;

});

parcelRegister("1ch0f", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $inoU6 = parcelRequire("inoU6");


var $baNhC = parcelRequire("baNhC");

const $70727fac6b2369a2$export$20904b77028459e9 = ({ isUnpublishedDraft: isUnpublishedDraft, isSingleUserSession: isSingleUserSession, hasTitle: hasTitle, hasBody: hasBody, hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, hasContentState: hasContentState, hasRestrictions: hasRestrictions, hasLabels: hasLabels })=>{
    const isBlank = isSingleUserSession && isUnpublishedDraft && !hasTitle && !hasBody && !hasEmoji && !hasEmoji && !hasCoverPicture && !hasContentState && !hasRestrictions && !hasLabels;
    return {
        isBlank: isBlank,
        isUnpublishedDraft: isUnpublishedDraft,
        isSingleUserSession: isSingleUserSession,
        hasTitle: hasTitle,
        hasBody: hasBody,
        hasEmoji: hasEmoji,
        hasCoverPicture: hasCoverPicture,
        hasContentState: hasContentState,
        hasRestrictions: hasRestrictions,
        hasLabels: hasLabels
    };
};
const $70727fac6b2369a2$export$96599dcc2d34575a = ({ contentId: contentId, deleteOnlyIfBlank: deleteOnlyIfBlank })=>(0, $hp2SH.getApolloClient)().mutate({
        mutation: (0, $inoU6.DeleteDraftMutation),
        variables: {
            contentId: contentId,
            action: deleteOnlyIfBlank ? (0, $baNhC.ContentDeleteActionType).DELETE_DRAFT_IF_BLANK : (0, $baNhC.ContentDeleteActionType).DELETE_DRAFT
        }
    });
module.exports["blankDraftInfo"] = $70727fac6b2369a2$export$20904b77028459e9;
module.exports["deleteDraft"] = $70727fac6b2369a2$export$96599dcc2d34575a;

});

parcelRegister("inoU6", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $71092054b022cd94$export$423f03de91e6fdb = (0, $eSUdr.default)`mutation DeleteDraftMutation($contentId:ID!$action:ContentDeleteActionType!){deleteContent(contentId:$contentId action:$action){contentId wasDeleted}}`;
module.exports["DeleteDraftMutation"] = $71092054b022cd94$export$423f03de91e6fdb;

});

parcelRegister("baNhC", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $358df202dbcafed8$export$e0db935847b66dda = /*#__PURE__*/ function(ContentDeleteActionType) {
    ContentDeleteActionType["DELETE_DRAFT"] = "DELETE_DRAFT";
    ContentDeleteActionType["DELETE_DRAFT_IF_BLANK"] = "DELETE_DRAFT_IF_BLANK";
    ContentDeleteActionType["MOVE_TO_TRASH"] = "MOVE_TO_TRASH";
    ContentDeleteActionType["PURGE_FROM_TRASH"] = "PURGE_FROM_TRASH";
    return ContentDeleteActionType;
}({});
module.exports["ContentDeleteActionType"] = $358df202dbcafed8$export$e0db935847b66dda;

});

parcelRegister("2unW6", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");

const $0c936a0ccc8709d1$export$d6875122194c7b44 = (contentId)=>{
    const [hasLabels, setHasLabels] = (0, $42omo.useState)(true);
    const { data: data } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useLabelsLabelCountQuery($contentId:ID!){content(id:$contentId status:["current" "draft"]){nodes{id labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING}){count}}}}`, {
        variables: {
            contentId: contentId
        }
    });
    (0, $42omo.useEffect)(()=>{
        setHasLabels((data?.content?.nodes?.[0]?.labels?.count ?? 0) > 0);
    }, [
        data
    ]);
    return hasLabels;
};
module.exports["useLabels"] = $0c936a0ccc8709d1$export$d6875122194c7b44;

});

parcelRegister("6yCgm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


const $41e0b21c174fc489$var$MainButtonsLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "4iG9v",
    name: "MainButtonsLoader",
    loader: async ()=>{
        return (await (parcelRequire("gsqvN"))).MainButtons;
    }
});

const $41e0b21c174fc489$var$MainButtonsSSRLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "g2Qnu",
    name: "MainButtonsSSRLoader",
    loader: async ()=>{
        return (await (parcelRequire("gsqvN"))).MainButtons;
    }
});
const $41e0b21c174fc489$export$f636d1325d93ee35 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($41e0b21c174fc489$var$MainButtonsLoader, props) : (0, $9wGTI.fg)('confluence_frontend_usd_ssr') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($41e0b21c174fc489$var$MainButtonsSSRLoader, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($41e0b21c174fc489$var$MainButtonsLoader, props));
const $41e0b21c174fc489$export$4fca0dd91afb40c6 = async ()=>$41e0b21c174fc489$var$MainButtonsLoader.preload();
module.exports["MainButtons"] = $41e0b21c174fc489$export$f636d1325d93ee35;
module.exports["loadMainButtons"] = $41e0b21c174fc489$export$4fca0dd91afb40c6;

});

parcelRegister("gsqvN", function(module, exports) {

let $bfb3d3916fd4bb0f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bfb3d3916fd4bb0f$var$load("aLLXO"),
    $bfb3d3916fd4bb0f$var$load("5U3YO"),
    $bfb3d3916fd4bb0f$var$load("eHDb1"),
    $bfb3d3916fd4bb0f$var$load("2zUEf"),
    $bfb3d3916fd4bb0f$var$load("8FbYE"),
    $bfb3d3916fd4bb0f$var$load("dUevD"),
    $bfb3d3916fd4bb0f$var$load("f1NVy"),
    $bfb3d3916fd4bb0f$var$load("6wr18"),
    $bfb3d3916fd4bb0f$var$load("li9sm"),
    $bfb3d3916fd4bb0f$var$load("jFI2g"),
    $bfb3d3916fd4bb0f$var$load("jwWp5"),
    $bfb3d3916fd4bb0f$var$load("4t77a"),
    $bfb3d3916fd4bb0f$var$load("9jS5g"),
    $bfb3d3916fd4bb0f$var$load("i1fe2"),
    $bfb3d3916fd4bb0f$var$load("3qsjq"),
    $bfb3d3916fd4bb0f$var$load("jXx9i"),
    $bfb3d3916fd4bb0f$var$load("fZt2F"),
    $bfb3d3916fd4bb0f$var$load("kCMj8"),
    $bfb3d3916fd4bb0f$var$load("ffEVr"),
    $bfb3d3916fd4bb0f$var$load("dS0Pr"),
    $bfb3d3916fd4bb0f$var$load("huYla"),
    $bfb3d3916fd4bb0f$var$load("amUNi"),
    $bfb3d3916fd4bb0f$var$load("2haIE"),
    $bfb3d3916fd4bb0f$var$load("9K4jq"),
    $bfb3d3916fd4bb0f$var$load("7EorR"),
    $bfb3d3916fd4bb0f$var$load("9ftJe"),
    $bfb3d3916fd4bb0f$var$load("e9JE4"),
    $bfb3d3916fd4bb0f$var$load("e4GNb"),
    $bfb3d3916fd4bb0f$var$load("hhss7"),
    $bfb3d3916fd4bb0f$var$load("7Omhy"),
    $bfb3d3916fd4bb0f$var$load("kC80R"),
    $bfb3d3916fd4bb0f$var$load("lP66B")
]).then(()=>parcelRequire('dcfqD'));

});

parcelRegister("aYZaZ", function(module, exports) {
$parcel$export(module.exports, "Buttons", () => (parcelRequire("iQb1R")).Buttons);

var $jmjWc = parcelRequire("jmjWc");


var $6tSjb = parcelRequire("6tSjb");


var $iQb1R = parcelRequire("iQb1R");


const $ecc7cc41466863e8$export$82d507aca0e648e3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZRz6B",
    name: "EllipsisDropdownComponent",
    loader: async ()=>(await (parcelRequire("96kIh"))).EllipsisDropdownComponent,
    loading: (0, $6tSjb.EllipsisPlaceholder)
});
module.exports["EllipsisDropdownComponent"] = $ecc7cc41466863e8$export$82d507aca0e648e3;

});

parcelRegister("6tSjb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $4KS7f = parcelRequire("4KS7f");


var $9VJDA = parcelRequire("9VJDA");

const $565f8db62106cdff$var$i18n = (0, $cgtv4.defineMessages)({
    more: {
        id: "editor-ellipsis-dropdown.placeholder.ellipsis.more",
        defaultMessage: "More"
    }
});
const $565f8db62106cdff$export$2edf2f3658d4e349 = ()=>{
    const intl = (0, $8C5kA.default)();
    const label = intl.formatMessage($565f8db62106cdff$var$i18n.more);
    const moreIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        color: "currentColor",
        spacing: "spacious",
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        testId: "ellipsis-placeholder",
        isDisabled: true,
        iconBefore: moreIcon,
        appearance: "subtle"
    });
};
module.exports["EllipsisPlaceholder"] = $565f8db62106cdff$export$2edf2f3658d4e349;

});

parcelRegister("96kIh", function(module, exports) {

let $6a04bdcc8f282e9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6a04bdcc8f282e9a$var$load("3VLKz"),
    $6a04bdcc8f282e9a$var$load("2Mq3f"),
    $6a04bdcc8f282e9a$var$load("4t77a"),
    $6a04bdcc8f282e9a$var$load("7EorR"),
    $6a04bdcc8f282e9a$var$load("e9JE4"),
    $6a04bdcc8f282e9a$var$load("e4GNb"),
    $6a04bdcc8f282e9a$var$load("iY5MP")
]).then(()=>parcelRequire('3d2EW'));

});

parcelRegister("iQb1R", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $f15550a75cff81e6$export$665d5a662b7213f3 = /*#__PURE__*/ function(Buttons) {
    Buttons["DELETE_DRAFT"] = "delete-draft";
    Buttons["EDIT_LABELS"] = "edit-labels";
    Buttons["MOVE_PAGE"] = "move-page";
    Buttons["PREVIEW"] = "preview";
    Buttons["PUBLISH_WITHOUT_NOTIFY"] = "publish-without-notify";
    Buttons["RESOLVED_COMMENTS"] = "resolved-comments";
    Buttons["TEMPLATE_BROWSER"] = "template-browser";
    Buttons["VIEW_CHANGES"] = "view-changes";
    Buttons["EXPORT"] = "export";
    Buttons["ADVANCED"] = "advanced";
    Buttons["ARCHIVE"] = "archive";
    Buttons["ATTACHMENTS"] = "attachments";
    Buttons["SWITCH_TO_LIVE_EDIT"] = "switch-to-live-edit";
    Buttons["CLASSIFY_CONTENT"] = "classify-content";
    Buttons["MANAGE"] = "manage";
    Buttons["PRESENT"] = "presentation-mode";
    return Buttons;
}({});
module.exports["Buttons"] = $f15550a75cff81e6$export$665d5a662b7213f3;

});

parcelRegister("4LVRL", function(module, exports) {

let $3798703ed614dc53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3798703ed614dc53$var$load("jFI2g"),
    $3798703ed614dc53$var$load("jdHbV"),
    $3798703ed614dc53$var$load("3VLKz"),
    $3798703ed614dc53$var$load("jwSno"),
    $3798703ed614dc53$var$load("4XFRu"),
    $3798703ed614dc53$var$load("4sZyu")
]).then(()=>parcelRequire('3iK0z'));

});

parcelRegister("ecUYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $7xVCs = parcelRequire("7xVCs");

function $1b739b5871223ff5$export$347bd2772961ad32(WrappedComponent) {
    function withPageTreeStateUpdater(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $7xVCs.PageTreeStateUpdater)
            ]
        }, (pageTreeStateUpdater)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                pageTreeStateUpdater: pageTreeStateUpdater,
                ...props
            }));
    }
    return withPageTreeStateUpdater;
}
module.exports["withPageTreeStateUpdater"] = $1b739b5871223ff5$export$347bd2772961ad32;

});

parcelRegister("5rEAe", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $6mKj3 = parcelRequire("6mKj3");


var $ann9t = parcelRequire("ann9t");

const $15544693a6bca546$export$15562ab063498253 = async (contentId, readFragmentInterop)=>{
    const apolloClient = (0, $hp2SH.getApolloClient)();
    // Apollo's `readQuery` method will throw an error if ANY of the requested fields are missing.
    // We want to gracefully handle this and return `undefined`, so we use the try/catch block to swallow errors.
    let parentId = undefined;
    try {
        if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) {
            const draftData = readFragmentInterop({
                id: `Content:${contentId}`
            });
            parentId = draftData?.ancestors?.slice(-1)?.[0]?.id;
        } else {
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const draftParentQueryResult = await apolloClient.readQuery({
                query: (0, $ann9t.GetDraftParentQuery),
                variables: {
                    contentId: contentId
                }
            });
            parentId = draftParentQueryResult?.content?.nodes?.[0]?.ancestors?.slice(-1)?.[0]?.id;
        }
    } catch  {}
    return parentId;
};
module.exports["getParentOfDraft"] = $15544693a6bca546$export$15562ab063498253;

});

parcelRegister("ann9t", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $4aac1a034faa729a$export$450983e01fc665dd = (0, $eSUdr.default)`query GetDraftParentQuery($contentId:ID!){content(id:$contentId status:["draft"]){nodes{id ancestors{id}}}}`;
module.exports["GetDraftParentQuery"] = $4aac1a034faa729a$export$450983e01fc665dd;

});

parcelRegister("3mmDo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hYoU4 = parcelRequire("hYoU4");


var $1ch0f = parcelRequire("1ch0f");

const $f928d6004096ea67$export$a0b893b7ce6fdcb3 = ({ isUnpublishedDraft: isUnpublishedDraft, isSingleUserSession: isSingleUserSession, hasTitle: hasTitle, hasBody: hasBody, hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, hasContentState: hasContentState, hasRestrictions: hasRestrictions, hasLabels: hasLabels })=>{
    const [willDeleteBlankDraftOnClose, setWillDeleteBlankDraftOnClose] = (0, $42omo.useState)(false);
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    (0, $42omo.useEffect)(()=>{
        // necessary for showing correct tooltip on close button
        const { isBlank: isBlank } = (0, $1ch0f.blankDraftInfo)({
            isUnpublishedDraft: isUnpublishedDraft,
            isSingleUserSession: isSingleUserSession,
            hasTitle: hasTitle,
            hasBody: hasBody,
            hasEmoji: hasEmoji,
            hasCoverPicture: hasCoverPicture,
            hasContentState: hasContentState,
            hasRestrictions: hasRestrictions,
            hasLabels: hasLabels
        });
        setWillDeleteBlankDraftOnClose(collabEditConnected && isBlank);
    }, [
        isUnpublishedDraft,
        isSingleUserSession,
        hasTitle,
        hasBody,
        hasEmoji,
        hasCoverPicture,
        hasContentState,
        hasRestrictions,
        hasLabels,
        collabEditConnected
    ]);
    return willDeleteBlankDraftOnClose;
};
module.exports["useWillDeleteBlankDraftOnClose"] = $f928d6004096ea67$export$a0b893b7ce6fdcb3;

});

parcelRegister("lHzSp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $ktUCG = parcelRequire("ktUCG");


var $i5zxs = parcelRequire("i5zxs");


var $bJX6u = parcelRequire("bJX6u");

const $fb2260515fd87e61$export$5ebd549b1d465b39 = ()=>{
    const [hasEmoji, setHasEmoji] = (0, $42omo.useState)(false);
    const [hasCoverPicture, setHasCoverPicture] = (0, $42omo.useState)(false);
    const [hasContentState, setHasContentState] = (0, $42omo.useState)(false);
    const emojiCoverPictureAndContentStateSubscription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $ktUCG.EmojiTitleStateContainer)
        ]
    }, (emojiTitleState)=>{
        setHasEmoji(!!emojiTitleState.state.selectedEmoji);
        return null;
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $i5zxs.CoverPictureStateContainer)
        ]
    }, (coverPictureState)=>{
        setHasCoverPicture(coverPictureState.state.hasCoverPicture);
        return null;
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $bJX6u.ContentStateStateContainer)
        ]
    }, (contentStateState)=>{
        setHasContentState(!!contentStateState.state.contentState);
        return null;
    }));
    return {
        emojiCoverPictureAndContentStateSubscription: emojiCoverPictureAndContentStateSubscription,
        hasCoverPicture: hasCoverPicture,
        hasEmoji: hasEmoji,
        hasContentState: hasContentState
    };
};
module.exports["useEmojiTitleCoverPictureAndContentState"] = $fb2260515fd87e61$export$5ebd549b1d465b39;

});

parcelRegister("ktUCG", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $8rneB = parcelRequire("8rneB");

class $122734ff4c4db131$export$c7d05d5ff2632978 extends (0, $T1bCI.Container) {
    populateState(ssrEmojiTitleData) {
        const { emojiStatusFieldName: emojiStatusFieldName, queryData: queryData, isLivePage: isLivePage } = ssrEmojiTitleData;
        const emojiId = (0, $8rneB.getEmojiId)(queryData, emojiStatusFieldName);
        const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(queryData);
        this.setSelectedEmoji(emojiId || null);
        this.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji && isLivePage);
    }
    constructor(ssrEmojiTitleData){
        super();
        this.state = {
            emojiPickerLoaded: false,
            isLoading: true,
            isMouseEnterTitle: false,
            isUpdatingEmoji: false,
            openFirstEmojiPicker: false,
            openSecondEmojiPicker: false,
            selectedEmoji: null,
            isEmojiButtonFocused: false,
            isRemovingEmoji: false,
            hasLiveDocsDefaultEmoji: false
        };
        this.onUpdateStart = ()=>this.setState({
                isUpdatingEmoji: true
            });
        this.onUpdateEnd = ()=>{
            this.setState({
                isUpdatingEmoji: false
            });
            this.setState({
                isRemovingEmoji: false
            });
        };
        this.setIsEmojiButtonFocused = (isEmojiButtonFocused)=>this.setState({
                isEmojiButtonFocused: isEmojiButtonFocused
            });
        this.setIsRemovingEmoji = (isRemovingEmoji)=>this.setState({
                isRemovingEmoji: isRemovingEmoji
            });
        this.setIsUpdatingEmoji = (isUpdatingEmoji)=>this.setState({
                isUpdatingEmoji: isUpdatingEmoji
            });
        // first emoji picker is open when user already selected an emoji
        // click on the emoji and want to change it to different emoji
        this.setOpenFirstEmojiPicker = (isOpen)=>{
            if (this.state.openFirstEmojiPicker !== isOpen) this.setState({
                openFirstEmojiPicker: isOpen
            });
        };
        // second emoji picker is open when not yet selected an emoji
        // and want to add emoji via Add emoji button
        this.setOpenSecondEmojiPicker = (isOpen)=>{
            if (this.state.openSecondEmojiPicker !== isOpen) this.setState({
                openSecondEmojiPicker: isOpen
            });
        };
        this.setSelectedEmoji = (emoji)=>this.setState({
                selectedEmoji: emoji
            });
        this.onEmojiPickerLoaded = ()=>{
            if (!this.state.emojiPickerLoaded) this.setState({
                emojiPickerLoaded: true
            });
        };
        // for testing
        this.setContainerState = (newState)=>this.setState((state)=>({
                    ...state,
                    ...newState
                }));
        this.setLoadingEmoji = (isLoading)=>this.setState({
                isLoading: isLoading
            });
        this.setHasLiveDocsDefaultEmoji = (hasDefaultEmoji)=>this.setState({
                hasLiveDocsDefaultEmoji: hasDefaultEmoji
            });
        if (ssrEmojiTitleData) this.populateState(ssrEmojiTitleData);
    }
}
module.exports["EmojiTitleStateContainer"] = $122734ff4c4db131$export$c7d05d5ff2632978;

});

parcelRegister("8rneB", function(module, exports) {

var $ibzAc = parcelRequire("ibzAc");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: property?.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    const nodes = (data?.content?.nodes?.[0] || data?.singleContent)?.[emojiFieldName]?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["getHasEmojiPublished"] = $61659933fe71a4ee$export$53519180ca077ff2;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("5amrO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (0, $3u0dr.isReactCompilerActiveV1)() ? (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
} : (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    // whiteboards and live pages are always published, so return EMOJI_TITLE_PUBLISHED_FIELD
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("i5zxs", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $jVylI = parcelRequire("jVylI");

class $e6a27c260ce1aef4$export$edf095fb7f09a5c0 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            hasCoverPicture: false,
            isUploadingPicture: false,
            isModalOpen: false,
            isRemovingPicture: false,
            isRepositioningPicture: false,
            isAddHeaderImageButtonFocused: false,
            coverPictureId: '',
            shouldShowReposition: false,
            isChangingPicture: false,
            coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL,
            isAIUnsplashImage: false,
            aiSuggestedUnsplashImages: undefined,
            shouldShowAIUnsplashHeaderToolbar: false
        };
        this.setHasCoverPicture = (hasCoverPicture)=>this.setState({
                hasCoverPicture: hasCoverPicture
            });
        this.toggleCoverPictureWidthButton = (coverPictureWidth)=>this.setState({
                coverPictureWidth: coverPictureWidth
            });
        this.setCoverPictureId = (coverPictureId)=>this.setState({
                coverPictureId: coverPictureId
            });
        this.setIsUploadingPicture = (isUploadingPicture)=>this.setState({
                isUploadingPicture: isUploadingPicture
            });
        this.setIsModalOpen = (isModalOpen)=>this.setState({
                isModalOpen: isModalOpen
            });
        this.setIsChangingPicture = (isChangingPicture)=>this.setState({
                isChangingPicture: isChangingPicture
            });
        this.setIsRemovingPicture = (isRemovingPicture)=>this.setState({
                isRemovingPicture: isRemovingPicture
            });
        this.setIsRepositioningPicture = (isRepositioningPicture)=>this.setState({
                isRepositioningPicture: isRepositioningPicture
            });
        this.setShouldShowReposition = (shouldShowReposition)=>this.setState({
                shouldShowReposition: shouldShowReposition
            });
        this.setIsAddHeaderImageButtonFocused = (isAddHeaderImageButtonFocused)=>this.setState({
                isAddHeaderImageButtonFocused: isAddHeaderImageButtonFocused
            });
        this.setIsAIUnsplashImage = (isAIUnsplashImage)=>this.setState({
                isAIUnsplashImage: isAIUnsplashImage
            });
        this.setAISuggestedUnsplashImages = (aiSuggestedUnsplashImages)=>this.setState({
                aiSuggestedUnsplashImages: aiSuggestedUnsplashImages
            });
        this.setShouldShowAIUnsplashHeaderToolbar = (shouldShowAIUnsplashHeaderToolbar)=>this.setState({
                shouldShowAIUnsplashHeaderToolbar: shouldShowAIUnsplashHeaderToolbar
            });
        this.resetToDefaults = ()=>{
            this.setIsAddHeaderImageButtonFocused(false);
            this.setIsUploadingPicture(false);
            this.setIsChangingPicture(false);
            this.setIsRemovingPicture(false);
            this.setShouldShowReposition(false);
            this.toggleCoverPictureWidthButton((0, $jVylI.COVERPICTUREWIDTH).FULL);
            this.setIsAIUnsplashImage(false);
            this.setAISuggestedUnsplashImages(undefined);
            this.setShouldShowAIUnsplashHeaderToolbar(false);
        };
    }
}
module.exports["CoverPictureStateContainer"] = $e6a27c260ce1aef4$export$edf095fb7f09a5c0;

});

parcelRegister("jVylI", function(module, exports) {
var $341ba7bb7f83b82d$export$18feebdc268a3ef1 = /*#__PURE__*/ function(TitleAlignmentType) {
    TitleAlignmentType["LEFT"] = "LEFT";
    TitleAlignmentType["CENTER"] = "CENTER";
    return TitleAlignmentType;
}({});
const $341ba7bb7f83b82d$export$f5c76f9de4274e9b = {
    titleLayoutAlignment: "LEFT",
    titlePropertySubtitle: '',
    titlePropertySubtitleEnabled: false,
    titlePropertyBylineEnabled: false,
    titlePropertyEmojiEnabled: true,
    headerImageStylingEnabled: false
};
var $341ba7bb7f83b82d$export$f84f565b1b747c24 = /*#__PURE__*/ function(COVERPICTUREWIDTH) {
    COVERPICTUREWIDTH["FULL"] = "full";
    COVERPICTUREWIDTH["FIXED"] = "fixed";
    return COVERPICTUREWIDTH;
}({});
module.exports["TitleAlignmentType"] = $341ba7bb7f83b82d$export$18feebdc268a3ef1;
module.exports["defaultPropertyValue"] = $341ba7bb7f83b82d$export$f5c76f9de4274e9b;
module.exports["COVERPICTUREWIDTH"] = $341ba7bb7f83b82d$export$f84f565b1b747c24;

});

parcelRegister("bJX6u", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");

const $258e0d668fcd3778$export$7e292eecf5a8f340 = {
    contentState: null,
    shouldRunContentStateEffect: true,
    defaultStatesArray: [],
    customStatesArray: [],
    isContentStateEnabled: true,
    isSuggestedEnabled: true,
    isCustomEnabled: true,
    isUpdating: false
};
class $258e0d668fcd3778$export$ade89fbf99f42685 extends (0, $T1bCI.Container) {
    populateState(ssrContentStateData) {
        const newContentStateValues = Object.assign({}, $258e0d668fcd3778$export$7e292eecf5a8f340);
        newContentStateValues.shouldRunContentStateEffect = false;
        newContentStateValues.contentState = ssrContentStateData?.singleContent?.contentState || null;
        newContentStateValues.defaultStatesArray = ssrContentStateData?.availableContentStates?.spaceContentStates?.filter((i)=>!!i) || [];
        newContentStateValues.customStatesArray = ssrContentStateData?.availableContentStates?.customContentStates?.filter((i)=>!!i) || [];
        // If an admin has turned off a toggle, BE returns us the value as null
        // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
        // if both return as null it means the admin disabled content states
        const isSuggestedContentStatesDisabled = !ssrContentStateData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !ssrContentStateData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
        newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
        newContentStateValues.isCustomEnabled = false;
        this.state = newContentStateValues;
    }
    constructor(ssrContentStateData){
        super();
        this.state = {
            ...$258e0d668fcd3778$export$7e292eecf5a8f340
        };
        this.setContentState = (contentState)=>this.setState({
                contentState: contentState
            });
        this.setShouldRunContentStateEffect = (shouldRunContentStateEffect)=>this.setState({
                shouldRunContentStateEffect: shouldRunContentStateEffect
            });
        this.setDefaultStatesArray = (defaultStatesArray)=>this.setState({
                defaultStatesArray: defaultStatesArray
            });
        this.setCustomStatesArray = (customStatesArray)=>this.setState({
                customStatesArray: customStatesArray
            });
        this.setIsContentStateEnabled = (isContentStateEnabled)=>this.setState({
                isContentStateEnabled: isContentStateEnabled
            });
        this.setIsSuggestedEnabled = (isSuggestedEnabled)=>this.setState({
                isSuggestedEnabled: isSuggestedEnabled
            });
        this.setIsCustomEnabled = (isCustomEnabled)=>this.setState({
                isCustomEnabled: isCustomEnabled
            });
        this.setIsUpdating = (isUpdating)=>this.setState({
                isUpdating: isUpdating
            });
        this.setInitialValues = (contentStateState)=>this.setState(contentStateState);
        this.resetToDefaults = ()=>this.setState({
                ...$258e0d668fcd3778$export$7e292eecf5a8f340
            });
        if (ssrContentStateData) this.populateState(ssrContentStateData);
    }
}
module.exports["defaultValues"] = $258e0d668fcd3778$export$7e292eecf5a8f340;
module.exports["ContentStateStateContainer"] = $258e0d668fcd3778$export$ade89fbf99f42685;

});

parcelRegister("atF9V", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $5nr5P = parcelRequire("5nr5P");

const $5d4782fa577ebcb8$export$e6d5ad5483367d52 = ()=>{
    const [hasRestrictions, setHasRestrictions] = (0, $42omo.useState)(false);
    const hasRestrictionsSubscription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $5nr5P.RestrictionsDataContainer)
        ]
    }, (restrictionsState)=>{
        setHasRestrictions(restrictionsState.state.hasRestrictions);
        return null;
    });
    return {
        hasRestrictionsSubscription: hasRestrictionsSubscription,
        hasRestrictions: hasRestrictions
    };
};
module.exports["useRestrictions"] = $5d4782fa577ebcb8$export$e6d5ad5483367d52;

});

parcelRegister("5nr5P", function(module, exports) {

var $T1bCI = parcelRequire("T1bCI");

class $22dbf97de39b4a94$export$8428b29fbe35d5c extends (0, $T1bCI.Container) {
    constructor({ loadUuid: loadUuid = '', contentId: contentId = null, userCanEditRestrictions: userCanEditRestrictions = false, currentUserInfo: currentUserInfo = null, hasInheritedRestrictions: hasInheritedRestrictions = false, hasRestrictions: hasRestrictions = false, isLoaded: isLoaded = false, restrictionsDetails: restrictionsDetails = null, spaceKey: spaceKey = null, spaceContainsExternalCollaborators: spaceContainsExternalCollaborators = false, externalCollaboratorCount: externalCollaboratorCount = 0, operations: operations = null, contentTitle: contentTitle = null, edition: edition = null, isSiteAdmin: isSiteAdmin = false, contentType: contentType = null, contentSubType: contentSubType = null, isExternalShareEnabledForSite: isExternalShareEnabledForSite = false, isPageExternallyShared: isPageExternallyShared = false, isExternalShareVariation: isExternalShareVariation = false, isContentExternallySharable: isContentExternallySharable = false, canEditPublicLink: canEditPublicLink = false, ancestors: ancestors = [] } = {}){
        super();
        this.getData = ()=>{
            return this.state;
        };
        this.resetData = ()=>{
            this.setState({
                loadUuid: '',
                contentId: null,
                contentPermissions: null,
                currentUserInfo: null,
                hasInheritedRestrictions: false,
                hasRestrictions: false,
                isLoaded: false,
                restrictionsDetails: null,
                spaceKey: null,
                spaceContainsExternalCollaborators: false,
                externalCollaboratorCount: 0,
                operations: null,
                contentTitle: null,
                edition: null,
                isSiteAdmin: false,
                contentType: null,
                contentSubType: null,
                contentStatus: undefined,
                isExternalShareEnabledForSite: false,
                isPageExternallyShared: false,
                isExternalShareVariation: false,
                isContentExternallySharable: false,
                canEditPublicLink: false,
                ancestors: []
            });
        };
        this.setData = (data)=>{
            if (Object.keys(data).some((k)=>data[k] !== this.state[k])) this.setState(data);
        };
        this.getIsLoaded = ()=>{
            return this.state.isLoaded;
        };
        this.getContentId = ()=>{
            return this.state.contentId;
        };
        this.getLoadUuid = ()=>{
            return this.state.loadUuid;
        };
        this.state = {
            loadUuid: loadUuid,
            contentId: contentId,
            userCanEditRestrictions: userCanEditRestrictions,
            currentUserInfo: //   currentUserInfo: PropTypes.shape({
            //     id: PropTypes.string.isRequired,
            //     displayName: PropTypes.string.isRequired,
            //     isSuperAdmin: PropTypes.bool,
            //     profilePicture: PropTypes.shape({
            //       path: PropTypes.string
            //     })
            //   }).isRequired,
            currentUserInfo,
            hasInheritedRestrictions: hasInheritedRestrictions,
            hasRestrictions: hasRestrictions,
            isLoaded: isLoaded,
            restrictionsDetails: // const restrictionsShape = {
            //   restrictions: PropTypes.shape({
            //     user: PropTypes.shape({
            //       nodes: PropTypes.arrayOf(
            //         PropTypes.shape({
            //           accountId: PropTypes.string,
            //           displayName: PropTypes.string,
            //           type: PropTypes.string
            //         })
            //       )
            //     }),
            //     group: PropTypes.shape({
            //       nodes: PropTypes.arrayOf(
            //         PropTypes.shape({
            //           name: PropTypes.string
            //         })
            //       )
            //     })
            //   })
            // };
            restrictionsDetails,
            spaceKey: spaceKey,
            spaceContainsExternalCollaborators: spaceContainsExternalCollaborators,
            externalCollaboratorCount: externalCollaboratorCount,
            operations: operations,
            contentTitle: contentTitle,
            edition: edition,
            isSiteAdmin: isSiteAdmin,
            contentType: contentType,
            contentSubType: contentSubType,
            isExternalShareEnabledForSite: isExternalShareEnabledForSite,
            isPageExternallyShared: isPageExternallyShared,
            isExternalShareVariation: isExternalShareVariation,
            isContentExternallySharable: isContentExternallySharable,
            canEditPublicLink: canEditPublicLink,
            ancestors: ancestors
        };
    }
}
module.exports["RestrictionsDataContainer"] = $22dbf97de39b4a94$export$8428b29fbe35d5c;

});

parcelRegister("cgsIj", function(module, exports) {
$parcel$export(module.exports, "FixedSpaceHeaderContainer", () => (parcelRequire("8MMdp")).FixedSpaceHeaderContainer);

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $eCJDV = parcelRequire("eCJDV");


var $8MMdp = parcelRequire("8MMdp");


const $b7f6794681d506d9$export$74cf87e24679ef23 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Z3pve",
    name: "BreadcrumbsLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).Breadcrumbs,
    loading: (0, $eCJDV.BreadcrumbsPlaceholder)
});
const $b7f6794681d506d9$export$2dc68d50d56fbbd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b7f6794681d506d9$export$74cf87e24679ef23, props);
const $b7f6794681d506d9$export$8bb26699ba16d6a3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8MMdp.Breadcrumbs), props);

const $b7f6794681d506d9$export$f979c33d59431f8e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "G1kJd",
    name: "FixedBreadcrumbsNavForPageLayoutLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).FixedBreadcrumbsNavForPageLayout
});
module.exports["BreadcrumbsLoader"] = $b7f6794681d506d9$export$74cf87e24679ef23;
module.exports["Breadcrumbs"] = $b7f6794681d506d9$export$2dc68d50d56fbbd;
module.exports["BreadcrumbsNonLoadable"] = $b7f6794681d506d9$export$8bb26699ba16d6a3;
module.exports["FixedBreadcrumbsNavForPageLayoutLoader"] = $b7f6794681d506d9$export$f979c33d59431f8e;

});

parcelRegister("eCJDV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fwDOR = parcelRequire("fwDOR");

function $0c4308f795e44815$export$98d1f051069dd73b() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "BreadcrumbsPlaceholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "breadcrumbs-placeholder",
        "data-vc": "breadcrumbs-placeholder"
    }));
}
module.exports["BreadcrumbsPlaceholder"] = $0c4308f795e44815$export$98d1f051069dd73b;

});

parcelRegister("8MMdp", function(module, exports) {
/* Breadcrumbs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $inPa6 = parcelRequire("inPa6");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $4PPzL = parcelRequire("4PPzL");


var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $jmjWc = parcelRequire("jmjWc");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $gz8ZY = parcelRequire("gz8ZY");


var $6mKj3 = parcelRequire("6mKj3");


var $5Vf1r = parcelRequire("5Vf1r");

const $6d14bad88596319b$var$hideDuringPdfPrint = null;

const $6d14bad88596319b$var$CompanyHubBreadcrumbs = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rj-y7",
    name: "CompanyHubBreadcrumbs",
    loader: async ()=>(await (parcelRequire("hwMZ5"))).CompanyHubBreadcrumbs
}); // Keep this in sync with entry-points/breadcrumbsConstants.ts
const $6d14bad88596319b$var$BREADCRUMB_HEADER_HEIGHT = 56; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $6d14bad88596319b$export$ba9528a5a0141231 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNav4Enabled: isNav4Enabled, isFullWidth: isFullWidth, isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, shouldShowAifcCreateBanner: shouldShowAifcCreateBanner, isTransparent: isTransparent, justifyContent: justifyContent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ji2brd": (0, $7sObp.default)(__cmplp.justifyContent || 'space-between')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n7zlglyw _4t3i8vuz _1pby1ial _1bsb1osq _1e0c1txw _4cvr1h6o _vchhusvi _1bah1vxp",
            !__cmplp.isNav4Enabled && __cmplp.isFullWidth ? "_p12fglyw" : "_p12f18ua",
            __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
            __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf",
            __cmplp.shouldShowAifcCreateBanner ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.isTransparent ? "_bfhk1j28" : "_bfhkvuon",
            __cmplp.isNav4Enabled ? "_1ltv1d4h" : "_1ltv1wug",
            __cmplp.className
        ])
    });
});
const $6d14bad88596319b$var$SpaceHeaderWithBannerWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFullWidth: isFullWidth, isThemed: isThemed, isTransparent: isTransparent, isNav4Enabled: isNav4Enabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n7zlglyw _1pby1ial _1bsb1osq _1e0c1txw _2lx21bp4 _vchhusvi",
            __cmplp.isFullWidth ? "_p12fglyw" : "_p12f18ua",
            __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
            __cmplp.isTransparent ? "_bfhk1j28" : "_bfhkvuon",
            !__cmplp.isNav4Enabled && __cmplp.isFullWidth ? "_1ltvidpf" : "_1ltv1d4h",
            __cmplp.isNav4Enabled ? "_18u0idpf" : "_18u0yh40",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $6d14bad88596319b$var$SpaceHeaderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpv77o _4t3i8vuz _1e0c1txw _4cvr1h6o",
            __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf",
            __cmplp.className
        ])
    });
});
function $6d14bad88596319b$export$2dc68d50d56fbbd({ contentId: contentId, contentTitle: contentTitle, spaceKey: spaceKey, testId: testId, showInlineRename: showInlineRename, shouldDisableMoveButton: shouldDisableMoveButton, displayMode: displayMode = (0, $5Vf1r.BREADCRUMBS_MODES).FULL, contentLink: contentLink, contentType: contentType, subType: subType }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (!spaceKey) return null;
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$var$CompanyHubBreadcrumbs, null);
    const fireBreadcrumbError = (error)=>{
        let err;
        let nativeError;
        try {
            err = JSON.stringify(error, Object.getOwnPropertyNames(error)); // https://stackoverflow.com/a/26199752
            nativeError = JSON.stringify(error['nativeError']);
        } catch  {
            // if no error, means it failed to stringify so just set as empty string
            if (!err) err = '';
            if (!nativeError) nativeError = '';
        } finally{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'breadcrumbs',
                    action: 'errored',
                    actionSubject: 'viewPageBreadcrumbs',
                    attributes: {
                        message: error.message,
                        error: err,
                        nativeError: nativeError
                    }
                }
            }).fire();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO,
        onError: fireBreadcrumbError,
        renderOnError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Vf1r.BreadcrumbsWithSpaceNameDropdown), {
        contentTitle: contentTitle,
        spaceKey: spaceKey || '',
        contentId: contentId,
        testId: testId,
        showInlineRename: showInlineRename,
        shouldDisableMoveButton: shouldDisableMoveButton,
        displayMode: displayMode,
        contentLink: contentLink,
        contentType: contentType,
        subType: subType
    })));
}
const $6d14bad88596319b$export$7d2750c639212b06 = ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$export$ba9528a5a0141231, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$export$2dc68d50d56fbbd, {
        spaceKey: spaceKey
    }));
};
const $6d14bad88596319b$export$5adc3a1912461c1e = ({ children: children, banner: banner, isThemed: isThemed, shouldHavePadding: shouldHavePadding, isFullWidth: isFullWidth, isTransparent: isTransparent, testId: testId })=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$var$SpaceHeaderWithBannerWrapper, {
        isThemed: isThemed,
        isFullWidth: isFullWidth,
        isTransparent: isTransparent,
        isNav4Enabled: isNav4Enabled,
        className: (0, $gMc0m.default)([
            (0, $6mKj3.expValEquals)('afm-hide-elements-from-pdf-print', 'isEnabled', true) && "_24zuglyw"
        ])
    }, banner, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$var$SpaceHeaderWrapper, {
        isThemed: isThemed,
        "data-testid": testId,
        isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
        shouldHavePadding: shouldHavePadding
    }, children));
};
module.exports["FixedSpaceHeaderContainer"] = $6d14bad88596319b$export$ba9528a5a0141231;
module.exports["Breadcrumbs"] = $6d14bad88596319b$export$2dc68d50d56fbbd;
module.exports["FixedBreadcrumbsNavForPageLayout"] = $6d14bad88596319b$export$7d2750c639212b06;
module.exports["FixedSpaceHeaderWithBannerContainer"] = $6d14bad88596319b$export$5adc3a1912461c1e;

});

parcelRegister("5Vf1r", function(module, exports) {
/* BreadcrumbsWithSpaceNameDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ghftu = parcelRequire("ghftu");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $lGgRw = parcelRequire("lGgRw");


var $3gadb = parcelRequire("3gadb");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $bMPhU = parcelRequire("bMPhU");


var $kqIWy = parcelRequire("kqIWy");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $b3j2Y = parcelRequire("b3j2Y");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $bCECL = parcelRequire("bCECL");


var $kM55L = parcelRequire("kM55L");


var $1jQpq = parcelRequire("1jQpq");


var $6mKj3 = parcelRequire("6mKj3");


var $ePiuX = parcelRequire("ePiuX");


var $hzkzq = parcelRequire("hzkzq");


const $7c978e5ad74fbe60$var$BreadcrumbsDropdownContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "d_JWZ",
    name: "BreadcrumbsDropdownContent",
    loader: async ()=>(await (parcelRequire("cqAbY"))).BreadcrumbsDropdownContent
});

const $7c978e5ad74fbe60$var$BreadcrumbsPlaceholder = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "YZZqh",
    name: "BreadcrumbsPlaceholder",
    loader: async ()=>(await Promise.resolve((parcelRequire("eCJDV")))).BreadcrumbsPlaceholder
});
const $7c978e5ad74fbe60$var$separatorStyles = null;
const $7c978e5ad74fbe60$var$hiddenStyles = null;
const $7c978e5ad74fbe60$var$hiddenContentTitleStyles = null;
const $7c978e5ad74fbe60$var$hideSeparatorStyles = null;
const $7c978e5ad74fbe60$var$breadcrumbsStyles = (0, $ecnYn.xcss)({
    minWidth: '32px',
    // needed for responsive breadcrumbs, 32px is the width of the chevron button
    alignItems: 'center',
    flex: '0 1 auto',
    gap: 'space.100'
});
const $7c978e5ad74fbe60$var$inlineRenameBreadcrumbsStyles = (0, $ecnYn.xcss)({
    flex: '0 0 auto'
});
const $7c978e5ad74fbe60$var$fadedSpaceNameTextStyles = null;
const $7c978e5ad74fbe60$var$spaceNameTextStyles = null;
const $7c978e5ad74fbe60$var$noEllipsisStyles = null;
const $7c978e5ad74fbe60$var$breadcrumbDropdownTriggerStyles = null;
const $7c978e5ad74fbe60$var$maxWidthBreadcrumbsDropdownTriggerStyles = null;
const $7c978e5ad74fbe60$var$onlySpaceNameTriggerStyles = null;
const $7c978e5ad74fbe60$var$maxWidthOnlyContentTitleTriggerStyles = null;
const $7c978e5ad74fbe60$var$currentPageBreadcrumbStyles = null;
const $7c978e5ad74fbe60$var$currentPageLinkBreadcrumbStyles = null;
const $7c978e5ad74fbe60$var$contentTitleStyles = null;
const $7c978e5ad74fbe60$var$dropdownLessContentTitleStyles = null;
const $7c978e5ad74fbe60$var$chevronBaseStyles = (0, $ecnYn.xcss)({
    width: '32px',
    minWidth: '32px',
    height: '32px',
    borderRadius: "var(--ds-radius-small, 4px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'color.background.neutral.subtle'
});
const $7c978e5ad74fbe60$var$chevronHoverStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
var $7c978e5ad74fbe60$export$14e8342ddf0a4616 = /*#__PURE__*/ function(BREADCRUMBS_MODES) {
    BREADCRUMBS_MODES["ONLY_CONTENT_TITLE"] = "ONLY_CONTENT_TITLE";
    BREADCRUMBS_MODES["ONLY_SPACE_NAME"] = "ONLY_SPACE_NAME";
    BREADCRUMBS_MODES["FULL"] = "FULL";
    BREADCRUMBS_MODES["HIDDEN"] = "HIDDEN";
    return BREADCRUMBS_MODES;
}({});
const $7c978e5ad74fbe60$export$c71a066c29807b48 = ({ contentTitle: contentTitle, spaceKey: spaceKey, contentId: contentId, testId: testId = 'breadcrumbs-with-space-name-dropdown', showInlineRename: showInlineRename = false, shouldDisableMoveButton: shouldDisableMoveButton = false, displayMode: displayMode, contentLink: contentLink, contentType: contentType, subType: subType })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isBreadcrumbsPopupOpen, setIsBreadcrumbsPopupOpen] = (0, $42omo.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { data: spaceData, error: error } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const spaceHomepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isModernEmbeddedConfluence = (0, $1jQpq.useEmbeddedModernHeader)();
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)(); // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override'); // Note don't check for loading as when refreshing data we will get data={...} and loading=true
    // In this case if we display the placeholder it will flash before the data is displayed
    // We should continue render with existing data and then update when the new data is available
    if (error || !spaceData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE),
        error: error
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c978e5ad74fbe60$var$BreadcrumbsPlaceholder, null));
    const spaceName = spaceData.name || spaceData.alias || spaceKey;
    const isSpaceNameLongerThan6Letters = spaceName?.length > 6;
    const contentTitleToRender = contentTitle === '' ? intl.formatMessage($7c978e5ad74fbe60$var$i18n.untitledPage) : contentTitle;
    const shouldOpenDropdown = contentTitleToRender || showInlineRename;
    const shouldShowCurrentContentTitle = contentTitleToRender && !showInlineRename;
    const spaceOverviewPath = (0, $hzkzq.buildContentPath)({
        contentType: 'page',
        isSpaceOverview: true,
        query: spaceHomepageId ? {
            [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: spaceHomepageId
        } : undefined,
        spaceAlias: spaceData.alias,
        spaceKey: spaceKey
    });
    const handleBreadcrumbDropdownTriggerClick = ()=>{
        if (shouldOpenDropdown) {
            if (!isBreadcrumbsPopupOpen) {
                experienceTracker.start({
                    name: (0, $irVI7.BREADCRUMBS_DROPDOWN_EXPERIENCE)
                });
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'opened',
                        actionSubject: 'breadcrumbsDropdown',
                        source: 'breadcrumbs',
                        attributes: {
                            isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                        }
                    }
                }).fire();
            }
            setIsBreadcrumbsPopupOpen(!isBreadcrumbsPopupOpen);
        } else push(spaceOverviewPath);
    };
    const popupContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c978e5ad74fbe60$var$BreadcrumbsDropdownContent, {
            spaceKey: spaceKey,
            contentId: contentId,
            closeDropdownOnClickOfBreadcrumbItem: closeDropdownOnClickOfBreadcrumbItem,
            spaceOverviewPath: spaceOverviewPath,
            shouldDisableMoveButton: shouldDisableMoveButton,
            contentTitle: contentTitleToRender
        });
    };
    const closeDropdownOnClickOfBreadcrumbItem = ()=>{
        setIsBreadcrumbsPopupOpen(false);
    };
    const preloadBreadcrumbsDropdownOnSpaceNameHover = ()=>{
        (0, $ePiuX.preloadBreadcrumbsDropdown)({
            spaceKey: spaceKey,
            contentId: contentId
        });
    }; /* TODO: Add `shouldRenderToParent` to resolve accessibility issues. See https://a11y.atlassian.net/browse/JCATS-788 */ 
    const renderPopup = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isBreadcrumbsPopupOpen,
            onClose: ()=>setIsBreadcrumbsPopupOpen(false),
            placement: "bottom-start",
            content: popupContent,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                    id: "breadcrumbs-dropdown-chevron-button",
                    "data-testid": "breadcrumbs-dropdown-chevron-button",
                    disabled: isNetworkDisabled,
                    onClick: handleBreadcrumbDropdownTriggerClick,
                    onMouseEnter: preloadBreadcrumbsDropdownOnSpaceNameHover,
                    onFocus: preloadBreadcrumbsDropdownOnSpaceNameHover,
                    "aria-label": intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonAriaLabel),
                    ...triggerProps,
                    ...ssrPlaceholderIdProp,
                    className: (0, $gMc0m.default)([
                        "_2rko12b0 _19it1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1rjcidpf _18zridpf _1e0c1o8l _80omtlke _1o9zidpf _1bsb1osq _bfhksm61 _syaz1rpy _1vnv1r31 _1b5cglyw _1avfnqa1 _10fu1rpy _j5dh73ad _f8pjazsu _mizu1v1w _1ah3v77o _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _9h8hi7uo",
                        shouldOpenDropdown && "_p12fp3fh _1bsbn7od _8fz6ucft",
                        displayMode === "ONLY_SPACE_NAME" && "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _p12f1kdj _1bsbn7od _8fz61kdj",
                        displayMode === "ONLY_CONTENT_TITLE" && "_p12f1osq _1bto1l2s _8fz61osq",
                        displayMode === "HIDDEN" && "_1e0cglyw"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                    alignItems: "center",
                    gap: "space.100"
                }, shouldOpenDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: !isNetworkDisabled && intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonTooltip),
                    hideTooltipOnClick: true
                }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                        xcss: [
                            $7c978e5ad74fbe60$var$chevronBaseStyles,
                            !isNetworkDisabled && $7c978e5ad74fbe60$var$chevronHoverStyles
                        ],
                        ...tooltipProps
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)",
                        size: "small"
                    }))), renderSpaceName()))
        }), shouldOpenDropdown && renderSeparator());
    const renderContentTitle = ()=>{
        const titleElement = contentLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            href: contentLink,
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _11c8140y _o5721q9c _1bto1l2s _1ul91tcg _syazi7uo _1053i7uo _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _1vhvi7uo _1m0aglyw"
            ])
        }, contentTitleToRender) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _11c8140y _o5721q9c _1bto1l2s _1ul91tcg _syazi7uo _1m0aglyw"
            ])
        }, contentTitleToRender);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            id: "breadcrumbs-content-title",
            className: (0, $gMc0m.default)([
                "_zulpu2gc _1reo15vq _18m915vq _v564glyw _1e0c1txw _4cvr1h6o _tzy4kb7n _p12f1c3h",
                (displayMode === "HIDDEN" || displayMode === "ONLY_SPACE_NAME") && "_tzy4idpf _p12fidpf",
                isModernEmbeddedConfluence && "_bozgu2gc"
            ])
        }, (contentType === 'page' || contentType === 'blogpost') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
            type: contentType,
            subType: subType,
            color: "var(--ds-text, #292A2E)"
        }), titleElement);
    };
    const renderSpaceName = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            id: "breadcrumbs-space-name",
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _11c82smr _1bto1l2s _1bsb1osq _o5721q9c _p12f1osq",
                shouldOpenDropdown && displayMode === "FULL" && "_1bton7od",
                shouldOpenDropdown && isSpaceNameLongerThan6Letters && displayMode === "FULL" && "_1nwpsavl _1w80savl",
                (displayMode === "HIDDEN" || displayMode === "ONLY_CONTENT_TITLE") && "_1e0cglyw"
            ])
        }, spaceName);
    };
    const renderSeparator = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            id: "breadcrumbs-separator",
            className: (0, $gMc0m.default)([
                "_syazazsu _lcxvglyw _1o9zidpf _2hwx1b66 _18u01b66",
                !showInlineRename && "_1m0aglyw",
                displayMode != "FULL" && "_1e0cglyw"
            ])
        }, "/");
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: [
            $7c978e5ad74fbe60$var$breadcrumbsStyles,
            showInlineRename && $7c978e5ad74fbe60$var$inlineRenameBreadcrumbsStyles
        ],
        testId: testId,
        "data-vc": testId
    }, !isModernEmbeddedConfluence && renderPopup(), shouldShowCurrentContentTitle && renderContentTitle(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
    }));
};
const $7c978e5ad74fbe60$var$i18n = (0, $cgtv4.defineMessages)({
    breadcrumbsChevronButtonAriaLabel: {
        id: "breadcrumbs.dropdown.button.chevron.aria-label",
        defaultMessage: "Breadcrumbs"
    },
    untitledPage: {
        id: "breadcrumbs.dropdown.untitled-page.default-title",
        defaultMessage: "Untitled"
    },
    breadcrumbsChevronButtonTooltip: {
        id: "breadcrumbs.dropdown.button.chevron.tooltip",
        defaultMessage: "Show navigation path"
    }
});
module.exports["BREADCRUMBS_MODES"] = $7c978e5ad74fbe60$export$14e8342ddf0a4616;
module.exports["BreadcrumbsWithSpaceNameDropdown"] = $7c978e5ad74fbe60$export$c71a066c29807b48;

});

parcelRegister("luv00", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

function $8a88875ffe13fd4c$export$30b62f74ca853d7d() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
}
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("bMPhU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $ep3mz = parcelRequire("ep3mz");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (0, $3u0dr.isReactCompilerActiveV1)() ? (spaceKey)=>{
    const $ = (0, $frIzR.c)(6);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $eSUdr.default)`query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id}}}`;
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== spaceKey) {
        t1 = {
            spaceKey: spaceKey
        };
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = !spaceKey;
    let t3;
    if ($[3] !== t1 || $[4] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const { data: data } = (0, $xQxzY.useQuery)(t0, t3);
    return data?.space?.homepage?.id || undefined;
} : (spaceKey)=>{
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    const { data: data } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id}}}`, {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey
    });
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("kqIWy", function(module, exports) {

var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey)=>{
    /** @schema cc */ const useSpaceDetailQuery = (0, $4ZxLt.default);
    const options = {
        variables: {
            spaceKey: spaceKey
        }
    };
    const { loading: loading, data: data, error: error } = (0, $9wGTI.fg)('stop_watching_more_queries') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)(useSpaceDetailQuery, options) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)(useSpaceDetailQuery, options);
    return {
        loading: loading,
        data: data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path
        } : undefined,
        error: error
    };
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<dba482b8278907dc3da4caa91ab1ec66>>
 * @relayHash 5ea23e55ef5088b9c4837d3773b81cb1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e1e2926e708d3fd40690e6907effdf9227a54de6cc9fa82c15ff0acd3a82250d
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v2 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5ea23e55ef5088b9c4837d3773b81cb1",
            "id": "e1e2926e708d3fd40690e6907effdf9227a54de6cc9fa82c15ff0acd3a82250d",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "a1e29398bca6058e29a8240f26bd213b";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("bCECL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $e0ycV = parcelRequire("e0ycV");


var $jRsqV = parcelRequire("jRsqV");


var $8jHAi = parcelRequire("8jHAi");


var $9RVmI = parcelRequire("9RVmI");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $5tmwS = parcelRequire("5tmwS");


var $cHaKZ = parcelRequire("cHaKZ");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $gTyTP = parcelRequire("gTyTP");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16 })=>{
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    const defaultedType = type === 'liveDoc' ? 'page' : type; // Prevent using 'liveDoc' type directly
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: defaultedType,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const definition = isLivePage && isLivePagesFeatureEnabled ? $b2e0c504f331f5cc$var$iconDefinitions['liveDoc'] : $b2e0c504f331f5cc$var$iconDefinitions[defaultedType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $cgtv4.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jRsqV))),
        label: $b2e0c504f331f5cc$var$i18n.note
    }
};
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("jRsqV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e75905caaf7b6b39$var$_react = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("42omo")));

var $e75905caaf7b6b39$var$_baseNew = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e75905caaf7b6b39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e75905caaf7b6b39$var$NotepadIcon = (props)=>/*#__PURE__*/ $e75905caaf7b6b39$var$_react.default.createElement($e75905caaf7b6b39$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$e75905caaf7b6b39$var$NotepadIcon.displayName = 'NotepadIcon';
var $e75905caaf7b6b39$var$_default = module.exports.default = $e75905caaf7b6b39$var$NotepadIcon;

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("hpTea"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $gMc0m.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const PLACEHOLDER_SIZE = props.height || 26;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: "left"
    }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            ...animationProps,
            "data-testid": "emoji-placeholder",
            "data-css-target": "emoji-placeholder",
            className: (0, $gMc0m.default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: {
                width: `${PLACEHOLDER_SIZE}px`,
                height: `${PLACEHOLDER_SIZE}px`,
                margin: props.loadingMargin
            },
            className: (0, $gMc0m.default)([
                "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
            ])
        })));
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("hpTea", function(module, exports) {

let $cadf9c7e3681c020$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cadf9c7e3681c020$var$load("ioQAS"),
    $cadf9c7e3681c020$var$load("6wr18"),
    $cadf9c7e3681c020$var$load("kjZZD"),
    $cadf9c7e3681c020$var$load("ffEVr"),
    $cadf9c7e3681c020$var$load("2bmVk"),
    $cadf9c7e3681c020$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("1jQpq", function(module, exports) {

var $1iSzD = parcelRequire("1iSzD");


var $cxu5H = parcelRequire("cxu5H");

const $951eaa69b00dd6e9$export$f183b986124d184 = ()=>{
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasModernHeader: hasModernHeader } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    return isEmbeddedConfluence && hasModernHeader;
};
module.exports["useEmbeddedModernHeader"] = $951eaa69b00dd6e9$export$f183b986124d184;

});

parcelRegister("ePiuX", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $f4Qot = parcelRequire("f4Qot");

function $e956eba1dd4bb7db$export$e5d3f19aa88b9c61({ spaceKey: spaceKey, contentId: contentId }) {
    return (0, $dYU3e.query)({
        query: (0, $f4Qot.default),
        variables: {
            spaceKey: spaceKey,
            contentId: contentId,
            skipContent: !contentId
        }
    });
}
module.exports["preloadBreadcrumbsDropdown"] = $e956eba1dd4bb7db$export$e5d3f19aa88b9c61;

});

parcelRegister("f4Qot", function(module, exports) {
/**
 * @generated SignedSource<<57236f8f935c7bdf910c3b9d7d169bce>>
 * @relayHash eacc72b6f9ecbeb5ab52a1b74d6064a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b8a86e7d74a33ca56fd7bd765cf5fe7190dcc5b4651d4e2fc4666574c7cc9b4
const $ef0655697d43d9a3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipContent"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        {
            "condition": "skipContent",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": [
                                "current",
                                "draft",
                                "archived"
                            ]
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "keys",
                                            "value": [
                                                "emoji-title-published",
                                                "emoji-title-draft"
                                            ]
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v7 /*: any*/ ,
                                    "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
                                },
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "keys",
                                                    "value": [
                                                        "emoji-title-published"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": v7 /*: any*/ ,
                                            "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BreadcrumbsDropdownContentQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BreadcrumbsDropdownContentQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "eacc72b6f9ecbeb5ab52a1b74d6064a5",
            "id": "4b8a86e7d74a33ca56fd7bd765cf5fe7190dcc5b4651d4e2fc4666574c7cc9b4",
            "metadata": {},
            "name": "BreadcrumbsDropdownContentQuery",
            "operationKind": "query",
            "text": "query BreadcrumbsDropdownContentQuery($spaceKey:String!,$contentId:ID,$skipContent:Boolean!){space(key:$spaceKey){alias,id,name,icon{path},homepage{id}},content(id:$contentId,status:[\"current\",\"draft\",\"archived\"])@skip(if:$skipContent){nodes{id,type,subType,status,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}},ancestors{id,type,subType,title,status,properties(keys:[\"emoji-title-published\"]){nodes{id,key,value}}}}}}"
        }
    };
}();
$ef0655697d43d9a3$var$node.hash = "3e4a9d4b445d7d646b220e3bab421884";
var $ef0655697d43d9a3$export$2e2bcd8739ae039 = $ef0655697d43d9a3$var$node;
module.exports["default"] = $ef0655697d43d9a3$export$2e2bcd8739ae039;

});

parcelRegister("hzkzq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b055c0b5c16164d3$export$41b2e06f27dfe96e = 'archived';
const $b055c0b5c16164d3$export$6b45500787cf696 = ({ contentId: contentId, contentSlug: contentSlug, contentType: contentType, isSpaceOverview: isSpaceOverview, query: query, spaceAlias: spaceAlias, spaceKey: spaceKey })=>{
    if (contentType === 'folder') return '#';
    let route;
    if (isSpaceOverview) route = (0, $1NBp8.SPACE_OVERVIEW);
    else switch(contentType){
        case 'blogpost':
            route = (0, $1NBp8.VIEW_BLOG);
            break;
        case 'page':
            route = (0, $1NBp8.VIEW_PAGE);
            break;
        case 'whiteboard':
            route = (0, $1NBp8.WHITEBOARD_BOARD);
            break;
        case 'database':
            route = (0, $1NBp8.DATABASE_VIEW);
            break;
        case 'embed':
            route = (0, $1NBp8.EMBED_VIEW);
            break;
        default:
            throw new Error(`Received an unexpected content type: '${contentType}'`);
    }
    return route.toUrl({
        contentId: contentId,
        contentSlug: contentSlug,
        spaceKey: spaceAlias || spaceKey
    }, {
        query: query
    });
};
const $b055c0b5c16164d3$export$d3865786a3f7be67 = ({ ancestors: ancestors, status: status }, spaceHomepageId)=>{
    if (!ancestors) return [];
    // If current page is archived, filter out non-archived ancestors
    if (status === $b055c0b5c16164d3$export$41b2e06f27dfe96e) ancestors = ancestors.filter((ancestor)=>ancestor && ancestor.status === $b055c0b5c16164d3$export$41b2e06f27dfe96e);
    else // technically array elements can be null
    ancestors = ancestors.filter((node)=>node);
    if (!ancestors.length) return ancestors;
    if (ancestors[0].id !== spaceHomepageId && ancestors[ancestors.length - 1].id === spaceHomepageId) return [
        ...ancestors
    ].reverse().slice(1);
    if (ancestors[0].id === spaceHomepageId) return ancestors.slice(1);
    return ancestors;
};
const $b055c0b5c16164d3$export$f6641c501f8a1aee = (properties)=>{
    if (!properties) return undefined;
    const values = properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $b055c0b5c16164d3$export$e1cb12562674727b = (properties)=>{
    if (!properties) return undefined;
    const values = properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $b055c0b5c16164d3$export$52c8bba571728790 = (textRef)=>{
    if (textRef.current) return textRef.current.scrollWidth > textRef.current.clientWidth;
    return false;
};
module.exports["buildContentPath"] = $b055c0b5c16164d3$export$6b45500787cf696;
module.exports["filterAncestors"] = $b055c0b5c16164d3$export$d3865786a3f7be67;
module.exports["getEmojiFromPublishedPageProperties"] = $b055c0b5c16164d3$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $b055c0b5c16164d3$export$e1cb12562674727b;
module.exports["getIsTextTruncated"] = $b055c0b5c16164d3$export$52c8bba571728790;

});

parcelRegister("cqAbY", function(module, exports) {

let $90c3fcc2b2e4c238$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90c3fcc2b2e4c238$var$load("6wr18"),
    $90c3fcc2b2e4c238$var$load("hhss7"),
    $90c3fcc2b2e4c238$var$load("ffEVr"),
    $90c3fcc2b2e4c238$var$load("7EorR"),
    $90c3fcc2b2e4c238$var$load("1GyAj")
]).then(()=>parcelRequire('auDgK'));

});

parcelRegister("hwMZ5", function(module, exports) {

let $cc2b6c1448322496$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cc2b6c1448322496$var$load("6wr18"),
    $cc2b6c1448322496$var$load("ffEVr"),
    $cc2b6c1448322496$var$load("Wowvf"),
    $cc2b6c1448322496$var$load("hhss7"),
    $cc2b6c1448322496$var$load("b6JBs")
]).then(()=>parcelRequire('g3Wvh'));

});

parcelRegister("cF2C3", function(module, exports) {

var $dWCFT = parcelRequire("dWCFT");


var $cgtv4 = parcelRequire("cgtv4");

const $9428fa9f64a90dcf$var$i18n = (0, $cgtv4.defineMessages)({
    aMomentAgo: {
        id: "save-indicator.tooltip.time.aMomentAgo",
        defaultMessage: "just a moment ago"
    },
    lessThanAMinuteAgo: {
        id: "save-indicator.tooltip.time.lessThanAMinuteAgo",
        defaultMessage: "less than a minute ago"
    },
    oneMinuteAgo: {
        id: "save-indicator.tooltip.time.oneMinuteAgo",
        defaultMessage: "a minute ago"
    },
    xMinutesAgo: {
        id: "save-indicator.tooltip.time.xMinutesAgo",
        defaultMessage: "{time} minutes ago"
    },
    oneHourAgo: {
        id: "save-indicator.tooltip.time.oneHourAgo",
        defaultMessage: "about an hour ago"
    },
    xHoursAgo: {
        id: "save-indicator.tooltip.time.xHoursAgo",
        defaultMessage: "about {time} hours ago"
    },
    yesterday: {
        id: "save-indicator.tooltip.time.yesterday",
        defaultMessage: "yesterday at {time}"
    }
});
const $9428fa9f64a90dcf$var$MILLISECONDS_TO_SECONDS = 1000;
const $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES = 60000;
const $9428fa9f64a90dcf$var$MILLISECONDS_TO_HOUR = 3600000;
const $9428fa9f64a90dcf$var$MILLISECONDS_TO_DAY = 86400000;
const $9428fa9f64a90dcf$export$5a00511f040384d7 = (savedTime, formatMessage)=>{
    let formattedTime;
    const timeNow = new Date();
    const timeDifference = timeNow.getTime() - savedTime.getTime();
    if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_SECONDS < 4) formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.aMomentAgo);
    else if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES < 1) formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.lessThanAMinuteAgo);
    else if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES < 2) formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.oneMinuteAgo);
    else if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES < 50) {
        const roundedMinutes = Math.round(timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES);
        formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.xMinutesAgo, {
            time: roundedMinutes
        });
    } else if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES < 90) formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.oneHourAgo);
    else {
        const yesterday = timeNow;
        yesterday.setDate(timeNow.getDate() - 1);
        const savedTimeWasYesterday = yesterday.toLocaleDateString() === savedTime.toLocaleDateString();
        if (savedTimeWasYesterday && timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_HOUR > 5) // yesterday and more than 5 hours ago
        formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.yesterday, {
            time: (0, $dWCFT.default)(savedTime, 'p')
        });
        else if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_DAY < 1) {
            const roundedHours = Math.round(timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_HOUR);
            formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.xHoursAgo, {
                time: roundedHours
            });
        } else formattedTime = (0, $dWCFT.default)(savedTime, 'PP');
    }
    return formattedTime;
};
module.exports["timeFormatter"] = $9428fa9f64a90dcf$export$5a00511f040384d7;

});

parcelRegister("40pD8", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $512bc11813ea6463$var$ClassificationModalContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isClassificationModalOpen: false
});
$512bc11813ea6463$var$ClassificationModalContext.displayName = 'ClassificationModalContext';
const $512bc11813ea6463$export$ed3f7b1d90b3e679 = /*#__PURE__*/ (0, $42omo.createContext)({
    setIsClassificationModalOpen: ()=>{}
});
$512bc11813ea6463$export$ed3f7b1d90b3e679.displayName = 'ClassificationModalDispatchContext';
const $512bc11813ea6463$export$dd63fef46bf243c2 = ({ children: children })=>{
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $42omo.useState)(false);
    const contextValue = (0, $42omo.useMemo)(()=>({
            isClassificationModalOpen: isClassificationModalOpen
        }), [
        isClassificationModalOpen
    ]);
    const dispatchContextValue = (0, $42omo.useMemo)(()=>({
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        }), [
        setIsClassificationModalOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
        value: dispatchContextValue
    }, children));
};
const $512bc11813ea6463$export$3e27c86e4ac00950 = ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$var$ClassificationModalContext);
};
const $512bc11813ea6463$export$6c62639a7ca504f5 = ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
};
module.exports["ClassificationModalContextProvider"] = $512bc11813ea6463$export$dd63fef46bf243c2;
module.exports["useClassificationModalContext"] = $512bc11813ea6463$export$3e27c86e4ac00950;
module.exports["useClassificationModalDispatchContext"] = $512bc11813ea6463$export$6c62639a7ca504f5;

});

parcelRegister("Q2uE4", function(module, exports) {
$parcel$export(module.exports, "ClassificationEditModal", () => (parcelRequire("knzfV")).ClassificationEditModal);

var $jmjWc = parcelRequire("jmjWc");


var $knzfV = parcelRequire("knzfV");


const $28573d5d42b5e4db$export$7bc5797721050165 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "lVPXF",
    name: 'ClassificationEditModalLazyLoader',
    loader: async ()=>(await Promise.resolve((parcelRequire("knzfV")))).ClassificationEditModal
});
module.exports["ClassificationEditModalLazyLoader"] = $28573d5d42b5e4db$export$7bc5797721050165;

});

parcelRegister("knzfV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $8CZUH = parcelRequire("8CZUH");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $40pD8 = parcelRequire("40pD8");


var $fGQzQ = parcelRequire("fGQzQ");


var $earLp = parcelRequire("earLp");


var $8KSlr = parcelRequire("8KSlr");


var $93WhG = parcelRequire("93WhG");

const $5cd13874f5033207$export$d7e008c8afea1e79 = ({ contentId: contentId, spaceKey: spaceKey, contentClassificationMetadata: contentClassificationMetadata })=>{
    const { isClassificationModalOpen: isClassificationModalOpen } = (0, $40pD8.useClassificationModalContext)();
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)({
        contentId: contentId,
        contentClassificationMetadata: contentClassificationMetadata
    });
    const { classification: classification, spaceDefaultIsOverridden: spaceDefaultIsOverridden } = contentClassificationMetadata;
    const intl = (0, $8C5kA.default)();
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? classification : undefined;
    const onEditSubmit = (0, $42omo.useCallback)((classificationOption)=>{
        handleSubmit(classificationOption);
        setIsClassificationModalOpen(false);
    }, [
        handleSubmit,
        setIsClassificationModalOpen
    ]);
    const onEditCancel = (0, $42omo.useCallback)(()=>{
        setIsClassificationModalOpen(false);
    }, [
        setIsClassificationModalOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isClassificationModalOpen) trackEditPopupViewed((0, $earLp.ActionSubjectId).GENERIC_DATA_CLASSIFICATION_MODAL_POPUP);
    }, [
        isClassificationModalOpen,
        trackEditPopupViewed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isClassificationModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        onClose: ()=>setIsClassificationModalOpen(false),
        width: "330px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, intl.formatMessage((0, $93WhG.sharedMessages).classifyContent))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8KSlr.ClassificationEditViewPopup), {
        onEditSubmit: onEditSubmit,
        onEditCancel: onEditCancel,
        selectedOption: defaultSelectedEditOption ?? undefined,
        spaceKey: spaceKey,
        shouldShowHeading: false
    })));
};
module.exports["ClassificationEditModal"] = $5cd13874f5033207$export$d7e008c8afea1e79;

});

parcelRegister("fGQzQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7tHGa = parcelRequire("7tHGa");


var $in5LX = parcelRequire("in5LX");


var $4oYaK = parcelRequire("4oYaK");


var $3tzmY = parcelRequire("3tzmY");


var $45d60 = parcelRequire("45d60");


var $fcQxC = parcelRequire("fcQxC");

const $3ebf4e9018306b37$export$9756cece5bf0eb59 = (contentStatus)=>{
    switch(contentStatus){
        case (0, $7tHGa.ContentStatus).DRAFT:
            return (0, $45d60.ContentDataClassificationMutationContentStatus).DRAFT;
        default:
            return (0, $45d60.ContentDataClassificationMutationContentStatus).CURRENT;
    }
};
const $3ebf4e9018306b37$export$94cbb2414d06bc8b = ({ contentId: contentId, contentClassificationMetadata: contentClassificationMetadata })=>{
    const { setSubmittedClassification: setSubmittedClassification, setFlagStatus: setFlagStatus, updateContentDataClassificationLevel: updateClassificationMutation, deleteContentDataClassificationLevel: deleteClassificationMutation, contentStatusContext: contentStatusContext } = contentClassificationMetadata;
    return (0, $42omo.useCallback)((classificationOption)=>{
        // Provides type safety for the mutation variables
        if (!classificationOption?.id) return;
        setFlagStatus((0, $in5LX.FlagStatus).LOADING);
        const { writeContext: contentStatusWriteContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext ?? 'current-only');
        const contentStatuses = contentStatusWriteContext.map($3ebf4e9018306b37$export$9756cece5bf0eb59);
        const baseVariables = {
            id: parseInt(contentId),
            contentStatuses: contentStatuses
        };
        const optionIsNoClassificationOption = classificationOption?.id === (0, $4oYaK.NO_CLASSIFICATION_OPTION_ID);
        const optionIsSpaceDefaultClassificationOption = classificationOption?.id === (0, $3tzmY.SPACE_DEFAULT_CLASSIFICATION_OPTION_ID);
        const shouldDeleteClassification = optionIsNoClassificationOption || optionIsSpaceDefaultClassificationOption;
        if (shouldDeleteClassification) {
            if (optionIsNoClassificationOption) setSubmittedClassification(null);
            if (optionIsSpaceDefaultClassificationOption) setSubmittedClassification(classificationOption?.classificationOverride ?? null);
            deleteClassificationMutation({
                variables: baseVariables
            });
        } else {
            setSubmittedClassification(classificationOption);
            updateClassificationMutation({
                variables: {
                    ...baseVariables,
                    classificationLevelId: classificationOption.id
                }
            });
        }
    }, [
        contentId,
        setFlagStatus,
        contentStatusContext,
        updateClassificationMutation,
        deleteClassificationMutation,
        setSubmittedClassification
    ]);
};
module.exports["useEditSubmitCallback"] = $3ebf4e9018306b37$export$94cbb2414d06bc8b;

});

parcelRegister("7tHGa", function(module, exports) {
var $c76572742e8d6c54$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "CURRENT";
    ContentStatus["DRAFT"] = "DRAFT";
    ContentStatus["ARCHIVED"] = "ARCHIVED";
    return ContentStatus;
}({});
module.exports["ContentStatus"] = $c76572742e8d6c54$export$b2be22e9d5dd3927;

});

parcelRegister("in5LX", function(module, exports) {
var $4e391701f1805c48$export$4417bd7c8606be45 = /*#__PURE__*/ function(FlagStatus) {
    FlagStatus["NONE"] = "NONE";
    FlagStatus["SUCCESS"] = "SUCCESS";
    FlagStatus["ERROR"] = "ERROR";
    FlagStatus["LOADING"] = "LOADING";
    return FlagStatus;
}({});
module.exports["FlagStatus"] = $4e391701f1805c48$export$4417bd7c8606be45;

});

parcelRegister("4oYaK", function(module, exports) {
const $8d28ed91f3c96188$export$ea52aaec0b4536b2 = 'data-classification.no-classification-option';
module.exports["NO_CLASSIFICATION_OPTION_ID"] = $8d28ed91f3c96188$export$ea52aaec0b4536b2;

});

parcelRegister("3tzmY", function(module, exports) {
const $1cdd6556a0b2e638$export$8942d0d7876f8b98 = 'data-classification.space-default-classification-option';
module.exports["SPACE_DEFAULT_CLASSIFICATION_OPTION_ID"] = $1cdd6556a0b2e638$export$8942d0d7876f8b98;

});

parcelRegister("45d60", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $d94436a169325872$export$8be450ac125d65b9 = /*#__PURE__*/ function(ContentDataClassificationMutationContentStatus) {
    ContentDataClassificationMutationContentStatus["CURRENT"] = "CURRENT";
    ContentDataClassificationMutationContentStatus["DRAFT"] = "DRAFT";
    return ContentDataClassificationMutationContentStatus;
}({});
module.exports["ContentDataClassificationMutationContentStatus"] = $d94436a169325872$export$8be450ac125d65b9;

});

parcelRegister("fcQxC", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $304e5e6450715c84$export$20226314cf99189a = (context)=>{
    let readContext;
    let writeContext;
    switch(context){
        case 'draft-only':
            readContext = [
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            break;
        case 'current-only':
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT
            ];
            break;
        case 'current-and-draft':
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            break;
        default:
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT
            ];
    }
    return {
        readContext: readContext,
        writeContext: writeContext
    };
};
module.exports["getReadAndWriteContextFromQueryContext"] = $304e5e6450715c84$export$20226314cf99189a;

});

parcelRegister("earLp", function(module, exports) {

var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");

var $a91836006a246f35$export$cb7d54f314e067cb = /*#__PURE__*/ function(ActionSubjectId) {
    ActionSubjectId["EDITOR_TITLE_DATA_CLASSIFICATION_POPUP"] = "editorTitleDataClassificationPopup";
    ActionSubjectId["CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP"] = "contentTypeTitleDataClassificationPopup";
    ActionSubjectId["GENERIC_DATA_CLASSIFICATION_MODAL_POPUP"] = "genericDataClassificationModalPopup";
    return ActionSubjectId;
}({});
const $a91836006a246f35$var$getEditPopupViewedScreenEvent = ({ cloudId: cloudId, spaceId: spaceId, orgId: orgId, actionSubjectId: actionSubjectId })=>({
        type: 'sendScreenEvent',
        data: {
            name: 'dataClassificationEditPopup',
            action: 'viewed',
            actionSubject: 'popup',
            actionSubjectId: actionSubjectId,
            attributes: {
                cloudId: cloudId,
                spaceId: spaceId,
                orgId: orgId
            }
        }
    });
const $a91836006a246f35$export$c5f7a48280d6f361 = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return {
        trackEditPopupViewed: (actionSubjectId)=>{
            if (!spaceId || !cloudId || !orgId) return;
            createAnalyticsEvent($a91836006a246f35$var$getEditPopupViewedScreenEvent({
                cloudId: cloudId,
                spaceId: spaceId,
                orgId: orgId,
                actionSubjectId: actionSubjectId
            })).fire();
        },
        trackRenderTagError: (errorMessage)=>{
            if (!spaceId || !cloudId || !orgId) return;
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'dataClassificationTagRender',
                    source: 'confluence-frontend',
                    attributes: {
                        cloudId: cloudId,
                        spaceId: spaceId,
                        orgId: orgId,
                        error: errorMessage
                    }
                }
            }).fire();
        }
    };
};
module.exports["ActionSubjectId"] = $a91836006a246f35$export$cb7d54f314e067cb;
module.exports["useTrackClassificationAnalytics"] = $a91836006a246f35$export$c5f7a48280d6f361;

});

parcelRegister("8KSlr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $cd3ua = parcelRequire("cd3ua");


var $cwD0R = parcelRequire("cwD0R");


var $huR5x = parcelRequire("huR5x");


var $l4l51 = parcelRequire("l4l51");


var $93WhG = parcelRequire("93WhG");

const $45d21f3c639a715a$export$df1a42b01f6d3dd1 = ({ spaceKey: spaceKey, selectedOption: selectedOptionProp, onEditCancel: onEditCancel, onEditSubmit: onEditSubmit, loading: loading = false, shouldShowHeading: shouldShowHeading = true })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { defaultClassification: spaceDefaultClassification, classificationLevels: classificationLevels, getClassificationLevelFromId: getClassificationLevelFromId, expectedError: expectedError, loading: spaceAndDefaultLoading } = (0, $cwD0R.useDefaultAndSpaceClassificationLevels)({
        spaceKey: spaceKey,
        shouldPreloadData: true
    });
    const { defaultClassificationOption: defaultOption, error: defaultClassificationError, loading: orgDefaultLoading } = (0, $l4l51.useComputeDefaultClassificationDropdownOption)({
        spaceDefaultClassificationLevel: spaceDefaultClassification,
        getClassificationLevelFromId: getClassificationLevelFromId
    });
    const selectedOption = selectedOptionProp || defaultOption;
    const allClassificationLevels = [
        ...(0, $huR5x.getAllClassificationLevels)(classificationLevels),
        defaultOption
    ];
    const hasError = !!expectedError || !!defaultClassificationError;
    // Note: If we do not re-render the EditPopup after loading is completed,
    // the selectedOption may not be correct, as its only used in EditPopup
    // for the initial useState value; it is not a controlled value.
    const combinedLoadingCondition = loading || spaceAndDefaultLoading || orgDefaultLoading;
    if (combinedLoadingCondition) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cd3ua.EditPopup), {
        options: allClassificationLevels,
        selectedOption: selectedOption,
        onEditCancel: onEditCancel,
        onEditSubmit: onEditSubmit,
        loading: combinedLoadingCondition,
        errorMessage: hasError ? formatMessage((0, $93WhG.sharedMessages).fetchErrorTextPrimary) : undefined,
        shouldShowHeading: shouldShowHeading,
        menuPosition: "fixed"
    });
};
module.exports["ClassificationEditViewPopup"] = $45d21f3c639a715a$export$df1a42b01f6d3dd1;

});

parcelRegister("cd3ua", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $7hXDW = parcelRequire("7hXDW");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $lRogx = parcelRequire("lRogx");


var $1HYxw = parcelRequire("1HYxw");

const $0a0eca5e529a383f$var$popupContainerStyles = (0, $ecnYn.xcss)({
    width: '330px',
    padding: 'space.250'
});
const $0a0eca5e529a383f$export$646a7c8e1b78fd89 = ({ options: options, selectedOption: selectedOption, customHeading: customHeading, loading: loading = false, errorMessage: errorMessage, onEditCancel: onEditCancel, onEditSubmit: onEditSubmit, onChange: onChange, isDisabled: isDisabled = false, menuShouldScrollIntoView: menuShouldScrollIntoView = false, shouldShowHeading: // default to false as it is a popup, disable scroll behavor of select in popup https://product-fabric.atlassian.net/browse/DSP-22142,
shouldShowHeading = true, menuPosition: // default to true,
menuPosition = 'absolute' })=>{
    const intl = (0, $8C5kA.default)();
    // This keeps track of the selected classification in the dropdown. selectedOption is the classification that was selected before the edit popup was opened.
    const [selectedClassification, setSelectedClassification] = (0, $42omo.useState)(selectedOption);
    const onDropdownChange = (selected)=>{
        setSelectedClassification(selected);
    };
    const onUpdateClick = ()=>{
        selectedClassification && onEditSubmit && onEditSubmit(selectedClassification);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $0a0eca5e529a383f$var$popupContainerStyles,
        role: "dialog",
        "aria-labelledby": "data-classification-edit-content-label",
        "aria-modal": "true",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
            space: "space.200",
            children: [
                shouldShowHeading && /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                    size: "small",
                    id: "data-classification-edit-content-label",
                    children: customHeading || intl.formatMessage((0, $1HYxw.messages).classifyContent)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $lRogx.DataClassificationDropdown), {
                    label: intl.formatMessage((0, $1HYxw.messages).selectClassification),
                    options: options,
                    value: selectedClassification,
                    onChange: onDropdownChange,
                    onInputChange: onChange,
                    errorMessage: errorMessage,
                    isDisabled: isDisabled,
                    menuShouldScrollIntoView: menuShouldScrollIntoView,
                    menuPosition: menuPosition
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                    justifyContent: "end",
                    gap: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            onClick: onEditCancel,
                            appearance: "subtle",
                            children: intl.formatMessage((0, $1HYxw.messages).cancelButton)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            isLoading: loading,
                            onClick: onUpdateClick,
                            appearance: "primary",
                            isDisabled: !selectedClassification || Boolean(errorMessage) || isDisabled,
                            children: intl.formatMessage((0, $1HYxw.messages).updateButton)
                        })
                    ]
                })
            ]
        })
    });
};
module.exports["EditPopup"] = $0a0eca5e529a383f$export$646a7c8e1b78fd89;

});

parcelRegister("lRogx", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7CLBv = parcelRequire("7CLBv");


var $a4TK8 = parcelRequire("a4TK8");


var $2Agkp = parcelRequire("2Agkp");


var $bUlM5 = parcelRequire("bUlM5");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $3hOY6 = parcelRequire("3hOY6");

var $2gD2K = parcelRequire("2gD2K");


var $3gadb = parcelRequire("3gadb");


var $5HQ8i = parcelRequire("5HQ8i");


var $gWldI = parcelRequire("gWldI");


var $83UUG = parcelRequire("83UUG");

const $9f225016dccf8e60$var$dangerTextStyles = (0, $ecnYn.xcss)({
    color: 'color.text.danger',
    paddingInlineStart: 'space.025'
});
const $9f225016dccf8e60$var$selectOptionStyles = {
    root: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $9f225016dccf8e60$var$selectMenuPortalStyles = {
    root: "_1pbydx66"
};
const $9f225016dccf8e60$var$CustomSingleValue = ({ children: children, ...props })=>{
    const { data: data } = props;
    const { name: name, nameLabel: nameLabel, definition: definition, color: color = 'GREY', includeIcon: includeIcon = true, classificationOverride: classificationOverride, nameFormatter: nameFormatter } = data || {};
    const inputName = classificationOverride?.name ?? name ?? nameLabel ?? definition;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $83UUG.ContainerLabel), {
            children: nameFormatter ? nameFormatter(data) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $83UUG.ContainerIcon), {
                colorsConfig: (0, $5HQ8i.colorsConfig)[color],
                isIconOnly: includeIcon && !inputName,
                children: [
                    includeIcon && /*#__PURE__*/ (0, $l998X.jsx)((0, $gWldI.ClassificationIcon), {
                        width: 14,
                        height: 14,
                        color: (0, $5HQ8i.colorsConfig)[color].iconColor
                    }),
                    inputName && /*#__PURE__*/ (0, $l998X.jsx)((0, $83UUG.Name), {
                        children: inputName
                    })
                ]
            })
        })
    });
}; /**
    * CustomOption component is used to render each option in the dropdown.
    **/ 
const $9f225016dccf8e60$var$CustomOption = (props)=>{
    const { data: data } = props;
    const { name: name, definition: definition, nameLabel: nameLabel, includeIcon: includeIcon = true, nameFormatter: nameFormatter } = data || {};
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Option, {
        ...props,
        xcss: $9f225016dccf8e60$var$selectOptionStyles.root,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
            space: "space.050",
            children: [
                (name || nameLabel || includeIcon) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $83UUG.ContainerLabel), {
                    definitionExists: Boolean(definition),
                    children: [
                        nameFormatter ? nameFormatter(data) : /*#__PURE__*/ (0, $l998X.jsx)($9f225016dccf8e60$export$f31d135f91971ac4, {
                            ...data
                        }),
                        nameLabel && /*#__PURE__*/ (0, $l998X.jsx)((0, $83UUG.NameLabel), {
                            children: nameLabel
                        })
                    ]
                }),
                definition && /*#__PURE__*/ (0, $l998X.jsx)((0, $83UUG.Definition), {
                    children: definition
                })
            ]
        })
    });
};
const $9f225016dccf8e60$export$f31d135f91971ac4 = (data)=>{
    const { name: name, nameLabel: nameLabel, includeIcon: includeIcon = true, color: color = 'GREY', colorOnlyIconBackground: colorOnlyIconBackground = false } = data || {}; // if name and label are both present, trim name to fit nameLabel in the same row
    const shouldTrimBothNameAndLabel = Boolean(name && nameLabel);
    const iconComponent = includeIcon && /*#__PURE__*/ (0, $l998X.jsx)((0, $gWldI.ClassificationIcon), {
        width: 14,
        height: 14,
        color: (0, $5HQ8i.colorsConfig)[color].iconColor
    }); /* name inside a lozenge will only be a string and not a reactNode */ 
    const nameComponent = name && /*#__PURE__*/ (0, $l998X.jsx)((0, $83UUG.Name), {
        children: name.substring(0, (0, $5HQ8i.nameMaxLength) / (shouldTrimBothNameAndLabel ? 2 : 1))
    });
    return colorOnlyIconBackground ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $83UUG.ContainerIcon), {
                colorsConfig: (0, $5HQ8i.colorsConfig)[color],
                isIconOnly: includeIcon && !name,
                children: iconComponent
            }),
            nameComponent
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $83UUG.ContainerIcon), {
        colorsConfig: (0, $5HQ8i.colorsConfig)[color],
        isIconOnly: includeIcon && !name,
        children: [
            iconComponent,
            nameComponent
        ]
    });
};
const $9f225016dccf8e60$export$37a6278f2f470b5e = ({ label: label, options: options, value: value, errorMessage: errorMessage, disabledTooltipMessage: disabledTooltipMessage, isDisabled: isDisabled, onChange: onChange, onInputChange: onInputChange, menuShouldScrollIntoView: menuShouldScrollIntoView, menuPosition: menuPosition = 'absolute' })=>{
    // find selected classification in options
    const onSelectChange = (option)=>{
        // we want to identify the selected option by these properties
        const selectedOption = {
            name: option?.name,
            definition: option?.definition,
            label: option?.nameLabel
        }; // find corresponding classification in options based on identifying properties
        const selectedClassification = options.find((opt)=>(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))({
                name: opt.name,
                definition: opt.definition,
                label: opt.label
            }, selectedOption));
        if (!selectedOption || !selectedClassification) return;
        if (onChange) onChange(selectedClassification);
    }; /*
        Since select component requires label & value props in list of options, we'll transform "options" prop to include these values.
      */ 
    const transformToOptionType = (0, $42omo.useCallback)((classification)=>({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(classification),
            // either name, label, or definition must exist, so we can safely use ! here
            label: classification.name ?? classification.label ?? classification.definition,
            // Asserting this as a string to keep lint happy. This wont be an issue, since CustomOption component will handle scenarios where name is a ReactNode.
            value: classification.name ?? classification.label ?? classification.definition,
            nameLabel: classification.label // since label is reserved for an option, we'll use nameLabel
        }), []);
    const transformedOptions = (0, $42omo.useMemo)(()=>options.map(transformToOptionType), [
        options,
        transformToOptionType
    ]);
    const renderDropdown = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
            label: "data-classification-select",
            inputId: "data-classification-dropdown-input",
            options: transformedOptions,
            value: !value || errorMessage ? null : transformToOptionType(value),
            onChange: onSelectChange,
            onInputChange: onInputChange,
            isInvalid: Boolean(errorMessage),
            isDisabled: isDisabled,
            components: {
                Option: $9f225016dccf8e60$var$CustomOption,
                SingleValue: $9f225016dccf8e60$var$CustomSingleValue,
                MenuPortal: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).MenuPortal, {
                        ...props,
                        xcss: $9f225016dccf8e60$var$selectMenuPortalStyles.root
                    })
            },
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            menuPosition: menuPosition,
            styles: {
                option: (baseStyles)=>({
                        ...baseStyles,
                        padding: "var(--ds-space-200, 16px)"
                    }),
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999
                    })
            },
            menuPortalTarget: document.body
        });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        space: "space.100",
        children: [
            label && /*#__PURE__*/ (0, $l998X.jsx)((0, $83UUG.DropdownLabel), {
                htmlFor: "data-classification-dropdown-input",
                children: label
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                space: "space.050",
                children: [
                    isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                        content: disabledTooltipMessage,
                        children: renderDropdown()
                    }) : renderDropdown(),
                    errorMessage && /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                        alignItems: "center",
                        gap: "space.050",
                        xcss: $9f225016dccf8e60$var$dangerTextStyles,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Agkp))), {
                                color: "currentColor",
                                LEGACY_size: "small",
                                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
                                label: "",
                                size: "small"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                as: "p",
                                size: "small",
                                color: "inherit",
                                children: errorMessage
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
module.exports["ClassificationLozenge"] = $9f225016dccf8e60$export$f31d135f91971ac4;
module.exports["DataClassificationDropdown"] = $9f225016dccf8e60$export$37a6278f2f470b5e;

});

parcelRegister("5HQ8i", function(module, exports) {

var $1e2E5 = parcelRequire("1e2E5");


var $1HYxw = parcelRequire("1HYxw");

const { formatMessage: $e53ad3413efcb6ae$var$formatMessage } = (0, $1e2E5.createIntl)({
    locale: 'en'
});
const $e53ad3413efcb6ae$export$89b67151eed9295a = {
    definition: $e53ad3413efcb6ae$var$formatMessage((0, $1HYxw.messages).noClassification),
    includeIcon: false
};
const $e53ad3413efcb6ae$export$253bdad208569777 = 50;
const $e53ad3413efcb6ae$export$cbc3cef853d1014b = 1000;
const $e53ad3413efcb6ae$export$e1444e5b0a63d793 = 1000;
const $e53ad3413efcb6ae$export$fb2992e82b83582a = {
    YELLOW: {
        iconColor: "var(--ds-icon-accent-yellow, #B38600)",
        bgColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    ORANGE: {
        iconColor: "var(--ds-icon-accent-orange, #E06C00)",
        bgColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    RED: {
        iconColor: "var(--ds-icon-accent-red, #C9372C)",
        bgColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    RED_BOLD: {
        iconColor: "var(--ds-icon-inverse, #FFFFFF)",
        bgColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        fontColor: "var(--ds-text-inverse, #FFFFFF)"
    },
    PURPLE: {
        iconColor: "var(--ds-icon-accent-purple, #AF59E1)",
        bgColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    BLUE: {
        iconColor: "var(--ds-icon-accent-blue, #357DE8)",
        bgColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    TEAL: {
        iconColor: "var(--ds-icon-accent-teal, #2898BD)",
        bgColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    GREEN: {
        iconColor: "var(--ds-icon-accent-green, #22A06B)",
        bgColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    GREY: {
        iconColor: "var(--ds-icon-accent-gray, #7D818A)",
        bgColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    LIME: {
        iconColor: "var(--ds-icon-accent-lime, #6A9A23)",
        bgColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        fontColor: "var(--ds-text, #292A2E)"
    }
};
const $e53ad3413efcb6ae$export$9cdea53b8993b139 = {
    iconColor: "var(--ds-icon-disabled, #080F214A)",
    bgColor: "var(--ds-background-disabled, #17171708)",
    fontColor: "var(--ds-text-disabled, #080F214A)"
};
module.exports["nameMaxLength"] = $e53ad3413efcb6ae$export$253bdad208569777;
module.exports["guidelineMaxLength"] = $e53ad3413efcb6ae$export$e1444e5b0a63d793;
module.exports["colorsConfig"] = $e53ad3413efcb6ae$export$fb2992e82b83582a;
module.exports["disabledColorConfig"] = $e53ad3413efcb6ae$export$9cdea53b8993b139;

});

parcelRegister("1HYxw", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $eac3d8fc17e23def$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    noClassification: {
        id: "data-classification-level.no-classification",
        defaultMessage: "No classification"
    },
    classifyContent: {
        id: "data-classification-level.edit-popup.classify-content",
        defaultMessage: "Classify content"
    },
    selectClassification: {
        id: "data-classification-level.edit-popup.select-classification",
        defaultMessage: "Select classification"
    },
    updateButton: {
        id: "data-classification-level.edit-popup.update-button",
        defaultMessage: "Update"
    },
    cancelButton: {
        id: "data-classification-level.edit-popup.cancel-button",
        defaultMessage: "Cancel"
    },
    changeLevel: {
        id: "data-classification-level.read-popup.change-level",
        defaultMessage: "Change level"
    },
    rules: {
        id: "data-classification-level.rules",
        defaultMessage: "({associatedPoliciesCount, plural, one {# rule} other {# rules}})"
    },
    dataClassificationLevel: {
        id: "data-classification-level.data-classification-level",
        defaultMessage: "Data classification level"
    },
    dataClassificationLevelDialog: {
        id: "data-classification-level.read-popup.data-classification-level",
        defaultMessage: "Data classification level Dialog"
    }
});
module.exports["messages"] = $eac3d8fc17e23def$export$defe85febe8b728c;

});

parcelRegister("gWldI", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $cf27063ba0229f9a$export$d2e14829910b9b7d = ({ color: color, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 22",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.6309 0.724217L10.6368 0.729015L10.6564 0.744926C10.674 0.759116 10.7003 0.780345 10.7346 0.807883C10.8033 0.86297 10.9038 0.94325 11.03 1.04291C11.2825 1.24238 11.637 1.51872 12.0437 1.82565C12.8662 2.44636 13.8693 3.16677 14.6721 3.63718C15.3586 4.03945 16.2922 4.34531 17.1042 4.55315C17.5006 4.65463 17.8498 4.72824 18.0989 4.7763C18.2232 4.80028 18.3219 4.81775 18.3882 4.82904C18.4214 4.83469 18.4464 4.83877 18.4625 4.84135L18.4797 4.84408L18.4828 4.84456C18.9716 4.91866 19.3332 5.33888 19.3332 5.8333C19.3332 11.6129 17.1353 15.5513 14.9124 18.041C13.8065 19.2797 12.6995 20.1547 11.8642 20.7227C11.4461 21.0071 11.0944 21.2155 10.8427 21.3551C10.7168 21.4249 10.6157 21.4775 10.5435 21.5139C10.5074 21.5321 10.4785 21.5462 10.4574 21.5564C10.4469 21.5615 10.4382 21.5655 10.4316 21.5687L10.4231 21.5726L10.4201 21.5741L10.4188 21.5746C10.4183 21.5749 10.4177 21.5751 9.99984 20.6666C9.58193 21.5751 9.58142 21.5749 9.58087 21.5746L9.57961 21.5741L9.57653 21.5726L9.56808 21.5687C9.56477 21.5671 9.56096 21.5653 9.55666 21.5633C9.55235 21.5612 9.54754 21.5589 9.54226 21.5564C9.52113 21.5462 9.49227 21.5321 9.45618 21.5139C9.38402 21.4775 9.2829 21.4249 9.15697 21.3551C8.90523 21.2155 8.55357 21.0071 8.13544 20.7227C7.30013 20.1547 6.19319 19.2797 5.08723 18.041C2.86434 15.5513 0.666504 11.6129 0.666504 5.8333C0.666504 5.56667 0.772986 5.31108 0.962294 5.12331C1.15074 4.9364 1.40573 4.8321 1.67105 4.83331L1.67917 4.83324C1.68856 4.83313 1.70565 4.83282 1.72992 4.832C1.77849 4.83035 1.85559 4.82664 1.9571 4.81831C2.1605 4.80162 2.45966 4.76655 2.82229 4.69315C3.55079 4.5457 4.51413 4.24791 5.47072 3.65142C6.36007 3.09685 7.32664 2.37311 8.08223 1.77725C8.45737 1.48141 8.77527 1.22127 8.99892 1.03546C9.11068 0.942624 9.1987 0.868514 9.25835 0.817986C9.28817 0.792727 9.31088 0.773375 9.3259 0.760538L9.3426 0.74625L9.34728 0.742228C9.7143 0.426181 10.2551 0.418601 10.6309 0.724217ZM2.68698 6.74634C2.9006 11.4629 4.75094 14.6614 6.57911 16.709C7.55649 17.8036 8.53288 18.5744 9.26006 19.0689C9.55402 19.2688 9.80621 19.4228 9.99984 19.5342C10.1935 19.4228 10.4457 19.2688 10.7396 19.0689C11.4668 18.5744 12.4432 17.8036 13.4206 16.709C15.2602 14.6486 17.1222 11.4228 17.3165 6.65758C17.106 6.61216 16.8662 6.55674 16.6082 6.49068C15.741 6.26872 14.5913 5.90791 13.6609 5.36276C12.7521 4.83022 11.6718 4.05063 10.8389 3.42208C10.5278 3.18731 10.2466 2.97006 10.0155 2.78938C9.81835 2.95079 9.58294 3.14086 9.32067 3.34769C8.544 3.96016 7.51057 4.73642 6.52896 5.34851C5.31888 6.10307 4.11556 6.47195 3.21905 6.6534C3.02778 6.69212 2.84951 6.7225 2.68698 6.74634ZM9.99984 20.6666L9.58087 21.5746C9.84611 21.6966 10.1536 21.6966 10.4188 21.5746L9.99984 20.6666Z",
            fill: color
        })
    });
};
module.exports["ClassificationIcon"] = $cf27063ba0229f9a$export$d2e14829910b9b7d;

});

parcelRegister("83UUG", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");

const $7c84d638dc0ae584$export$bef68440ec6a6159 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c82smr _k48p1pd9",
            __cmplp.className
        ])
    });
});
const $7c84d638dc0ae584$export$63077572f44eb437 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _18u0u2gc _syazazsu _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $7c84d638dc0ae584$export$3944a9dffaf20407 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { definitionExists: definitionExists, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_t9f321": (0, $7sObp.default)(__cmplp.definitionExists ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _otyrmjfo",
            __cmplp.className
        ])
    });
});
const $7c84d638dc0ae584$export$6d6da6edaddd5876 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIconOnly: isIconOnly, colorsConfig: colorsConfig, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_139b6h8": (0, $7sObp.default)(__cmplp.isIconOnly ? "var(--ds-space-025, 2px)" : "var(--ds-space-050, 4px)"),
            "--_1udd052": (0, $7sObp.default)(__cmplp.colorsConfig.fontColor),
            "--_s8jg64": (0, $7sObp.default)(__cmplp.colorsConfig.bgColor)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4v77o _2rkofajl _11q71iaf _1e0c116y _p12f1osq _o5721q9c _1bsb1wug _4cvr1h6o _u5f31gh9 _syaz1tdf _uiztglyw",
            __cmplp.className
        ])
    });
});
const $7c84d638dc0ae584$export$c7bd411105e2dec3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c82smr _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _k48p1wq8 _vwz4dlk8 _18u0v77o _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $7c84d638dc0ae584$export$cf0290ef4b5a4f61 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazazsu _o5721jtm _1i4q1hna _slp31hna",
            __cmplp.className
        ])
    });
});
module.exports["DropdownLabel"] = $7c84d638dc0ae584$export$bef68440ec6a6159;
module.exports["NameLabel"] = $7c84d638dc0ae584$export$63077572f44eb437;
module.exports["ContainerLabel"] = $7c84d638dc0ae584$export$3944a9dffaf20407;
module.exports["ContainerIcon"] = $7c84d638dc0ae584$export$6d6da6edaddd5876;
module.exports["Name"] = $7c84d638dc0ae584$export$c7bd411105e2dec3;
module.exports["Definition"] = $7c84d638dc0ae584$export$cf0290ef4b5a4f61;

});

parcelRegister("cwD0R", function(module, exports) {

var $hZ48t = parcelRequire("hZ48t");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $kknEZ = parcelRequire("kknEZ");


var $1cYlh = parcelRequire("1cYlh");

const $8cba0a28a1fd2043$var$UseDefaultAndSpaceClassificationLevelsQuery = (0, $hZ48t.default);
const $8cba0a28a1fd2043$export$3601b6f432c64987 = ({ spaceKey: spaceKey, isAdmin: isAdmin, setClassificationsEnabledForSpace: setClassificationsEnabledForSpace, skipQuery: skipQuery = false, shouldPreloadData: shouldPreloadData = false })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($8cba0a28a1fd2043$var$UseDefaultAndSpaceClassificationLevelsQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey || isAdmin === false || skipQuery,
        errorPolicy: 'all',
        fetchPolicy: shouldPreloadData ? 'cache-first' : 'network-only'
    });
    // If there was a 404 status error,
    // then classifications are not enabled for that space
    const isEnabled = !error || error && !error?.message.includes('Feature is disabled');
    if (setClassificationsEnabledForSpace) setClassificationsEnabledForSpace(isEnabled);
    // If no default classification is set for the space, then we want
    // to send a fallback No Classification option instead of throwing an error
    const noDefaultClassification = error?.message.includes('No default classification set for space with ID');
    const expectedError = error && !noDefaultClassification && (0, $aMcHK.isStatusCodeError)(error, '404') || (0, $aMcHK.isStatusCodeError)(error, '500') || (0, $aMcHK.isStatusCodeError)(error, '400');
    // Mark error as handled if 1) feature is not enabled, 2) there is no default
    // classification set, or 3) there was another kind of expected error
    if (!isEnabled || noDefaultClassification || expectedError) (0, $7Sm4c.markErrorAsHandled)(error);
    // Classification levels to display - ordered, and filtered by status
    // (to only display published levels)
    const classificationLevels = (0, $42omo.useMemo)(()=>loading || expectedError || !data ? [] : data['classificationLevels']?.filter((classification)=>classification.status === (0, $kknEZ.Status).PUBLISHED).sort((a, b)=>(a.order ?? 0) - (b.order ?? 0)) ?? [], [
        loading,
        expectedError,
        data
    ]);
    const defaultId = noDefaultClassification ? (0, $1cYlh.NO_CLASSIFICATION_OPTION_ID) : data?.space?.['defaultClassificationLevelId'] ?? '';
    const [unfilteredClassificationId, setUnfilteredClassificationId] = (0, $42omo.useState)(defaultId);
    if (!unfilteredClassificationId && defaultId) setUnfilteredClassificationId(defaultId);
    const spaceName = data?.space?.name ?? '';
    const totalCurrentPages = data?.space?.metadata.totalCurrentPages ?? 0;
    // Find default classification from unfiltered list,
    // in case classification is not published
    const defaultClassification = noDefaultClassification ? (0, $1cYlh.NO_CLASSIFICATION_OPTION) : data?.['classificationLevels']?.find((level)=>level.id === unfilteredClassificationId);
    const getClassificationLevelFromId = (0, $42omo.useCallback)((classificationLevelId)=>{
        return classificationLevels?.find((level)=>level.id === classificationLevelId);
    }, [
        classificationLevels
    ]);
    return {
        classificationLevels: classificationLevels,
        defaultClassification: defaultClassification,
        defaultId: defaultId,
        loading: loading,
        isEnabled: isEnabled,
        expectedError: expectedError,
        spaceName: spaceName,
        totalCurrentPages: totalCurrentPages,
        setUnfilteredClassificationId: setUnfilteredClassificationId,
        getClassificationLevelFromId: getClassificationLevelFromId
    };
};
module.exports["useDefaultAndSpaceClassificationLevels"] = $8cba0a28a1fd2043$export$3601b6f432c64987;

});

parcelRegister("hZ48t", function(module, exports) {
/**
 * @generated SignedSource<<ebb07556405c2188141b9495b20266d4>>
 * @relayHash fbf771726e463887b742ac4d94e994f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9d351c6f302837de6d700036aed8b75ba3ee259f41dab092f3216999720404f5
const $14b6d2cab9e57b52$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "defaultClassificationLevelId"
                },
                {
                    "concreteType": "SpaceMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCurrentPages"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "ContentDataClassificationLevel",
            "kind": "LinkedField",
            "name": "classificationLevels",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "order"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "kind": "ScalarField",
                    "name": "color"
                },
                {
                    "kind": "ScalarField",
                    "name": "description"
                },
                {
                    "kind": "ScalarField",
                    "name": "guideline"
                },
                v2 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDefaultAndSpaceClassificationLevelsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDefaultAndSpaceClassificationLevelsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "fbf771726e463887b742ac4d94e994f9",
            "id": "9d351c6f302837de6d700036aed8b75ba3ee259f41dab092f3216999720404f5",
            "metadata": {},
            "name": "useDefaultAndSpaceClassificationLevelsQuery",
            "operationKind": "query",
            "text": "query useDefaultAndSpaceClassificationLevelsQuery($spaceKey:String!){space(key:$spaceKey){id,name,defaultClassificationLevelId,metadata{totalCurrentPages}},classificationLevels{id,order,status,color,description,guideline,name}}"
        }
    };
}();
$14b6d2cab9e57b52$var$node.hash = "0204187a42c76123b2656dae3e3e9f65";
var $14b6d2cab9e57b52$export$2e2bcd8739ae039 = $14b6d2cab9e57b52$var$node;
module.exports["default"] = $14b6d2cab9e57b52$export$2e2bcd8739ae039;

});

parcelRegister("kknEZ", function(module, exports) {
var $ac489c3aaa697fba$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["PUBLISHED"] = "PUBLISHED";
    Status["ARCHIVED"] = "ARCHIVED";
    Status["DRAFT"] = "DRAFT";
    return Status;
}({});
module.exports["Status"] = $ac489c3aaa697fba$export$96e9906d6d93a972;

});

parcelRegister("1cYlh", function(module, exports) {

var $kknEZ = parcelRequire("kknEZ");

const $e02e634ce8a36ce5$export$44086dc4ad5eb01b = 'NO_CLASSIFICATION';
const $e02e634ce8a36ce5$export$ea52aaec0b4536b2 = 'NO_CLASSIFICATION_OPTION';
const $e02e634ce8a36ce5$export$89b67151eed9295a = {
    id: $e02e634ce8a36ce5$export$ea52aaec0b4536b2,
    name: 'No default',
    order: 0,
    definition: "Pages in this space aren\u2019t classified by default.",
    color: 'NONE',
    status: (0, $kknEZ.Status).PUBLISHED
};
module.exports["NO_CLASSIFICATION"] = $e02e634ce8a36ce5$export$44086dc4ad5eb01b;
module.exports["NO_CLASSIFICATION_OPTION_ID"] = $e02e634ce8a36ce5$export$ea52aaec0b4536b2;
module.exports["NO_CLASSIFICATION_OPTION"] = $e02e634ce8a36ce5$export$89b67151eed9295a;

});

parcelRegister("huR5x", function(module, exports) {
const $bc2f28c1af54773b$export$14c071c2473cc4e7 = (classificationLevels)=>{
    // Data classification dropdown in edit popup accepts definition property for displaying descriptions per classification
    const classificationLevelsWithDefinitions = classificationLevels.map((level)=>({
            ...level,
            definition: level.description
        }));
    return [
        ...classificationLevelsWithDefinitions
    ];
};
module.exports["getAllClassificationLevels"] = $bc2f28c1af54773b$export$14c071c2473cc4e7;

});

parcelRegister("l4l51", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lqrF0 = parcelRequire("lqrF0");


var $hWQlw = parcelRequire("hWQlw");

const $31b05ea5b7dd16b4$export$bd9775df29f26b2b = ({ getClassificationLevelFromId: getClassificationLevelFromId, spaceDefaultClassificationLevel: spaceDefaultClassificationLevel, skipQuery: skipQuery = false })=>{
    const { orgDefaultClassificationLevelId: orgDefaultClassificationLevelId, orgDefaultClasificationLoading: orgDefaultClasificationLoading, orgDefaultClassificationError: orgDefaultClassificationError } = (0, $lqrF0.useOrgDefaultClassificationLevelId)({
        skip: skipQuery
    });
    const orgDefaultClassificationLevel = getClassificationLevelFromId(orgDefaultClassificationLevelId);
    const defaultLevel = (0, $42omo.useMemo)(()=>{
        return spaceDefaultClassificationLevel || orgDefaultClassificationLevel;
    }, [
        spaceDefaultClassificationLevel,
        orgDefaultClassificationLevel
    ]);
    const defaultClassificationOption = (0, $hWQlw.useSpaceDefaultClassificationLevelOption)(defaultLevel);
    return {
        defaultClassificationOption: defaultClassificationOption,
        loading: orgDefaultClasificationLoading,
        error: orgDefaultClassificationError
    };
};
module.exports["useComputeDefaultClassificationDropdownOption"] = $31b05ea5b7dd16b4$export$bd9775df29f26b2b;

});

parcelRegister("lqrF0", function(module, exports) {

var $l5Tyv = parcelRequire("l5Tyv");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");

const $b11e379d60d4ef23$var$shouldMarkErrorAsHandled = (error)=>{
    if (!error) return true;
    const statusCode = (0, $aMcHK.getStatusCode)(error?.graphQLErrors?.[0]);
    if (!statusCode) return true;
    return !!(parseInt(statusCode) >= 400 && parseInt(statusCode) < 500);
};
const $b11e379d60d4ef23$export$6abe98b0568ffc06 = ({ skip: skip })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $l5Tyv.default), {
        skip: skip
    });
    if ($b11e379d60d4ef23$var$shouldMarkErrorAsHandled(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const orgDefaultClassificationLevelId = data?.orgDefaultClassificationLevelId ?? null;
    return {
        orgDefaultClassificationLevelId: orgDefaultClassificationLevelId,
        orgDefaultClasificationLoading: loading,
        orgDefaultClassificationError: !$b11e379d60d4ef23$var$shouldMarkErrorAsHandled(error) ? error : undefined
    };
};
module.exports["useOrgDefaultClassificationLevelId"] = $b11e379d60d4ef23$export$6abe98b0568ffc06;

});

parcelRegister("l5Tyv", function(module, exports) {
/**
 * @generated SignedSource<<5a8354a3dd311b28b0dddd8361abd888>>
 * @relayHash 3d89323afb1137acce0d20d056dd1c17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f1ecfc7a34867858bd95b303bf33163c2d02cb84969a8c6c8b7dc13cd9c2d14a
const $3efae83372f9f881$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "orgDefaultClassificationLevelId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "3d89323afb1137acce0d20d056dd1c17",
            "id": "f1ecfc7a34867858bd95b303bf33163c2d02cb84969a8c6c8b7dc13cd9c2d14a",
            "metadata": {},
            "name": "useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery",
            "operationKind": "query",
            "text": "query useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery{orgDefaultClassificationLevelId}"
        }
    };
}();
$3efae83372f9f881$var$node.hash = "ca879e2beb9cc23922da0259b6f540ab";
var $3efae83372f9f881$export$2e2bcd8739ae039 = $3efae83372f9f881$var$node;
module.exports["default"] = $3efae83372f9f881$export$2e2bcd8739ae039;

});

parcelRegister("hWQlw", function(module, exports) {
/* useSpaceDefaultClassificationLevelOption.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $lRogx = parcelRequire("lRogx");

const $8f53943699900624$var$i18n = (0, $cgtv4.defineMessages)({
    spaceDefaultClassificationOption: {
        id: "data-classification.space-default-classification-option",
        defaultMessage: "Space default"
    },
    noClassificationOption: {
        id: "data-classification.no-classification-option",
        defaultMessage: "Space default - No classification"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f53943699900624$var$OverflowWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $8f53943699900624$var$SpaceDefaultTextWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _154i1i6y",
            __cmplp.className
        ])
    });
});
const $8f53943699900624$export$87415fc87251a143 = (value)=>{
    const intl = (0, $8C5kA.default)();
    return (0, $42omo.useMemo)(()=>{
        if (!value) {
            const noClassificationOption = {
                id: $8f53943699900624$var$i18n.noClassificationOption.id,
                definition: intl.formatMessage($8f53943699900624$var$i18n.noClassificationOption),
                color: 'GREY',
                includeIcon: false
            };
            return noClassificationOption;
        }
        return {
            id: $8f53943699900624$var$i18n.spaceDefaultClassificationOption.id,
            nameFormatter: (classification)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8f53943699900624$var$OverflowWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8f53943699900624$var$SpaceDefaultTextWrapper, null, intl.formatMessage($8f53943699900624$var$i18n.spaceDefaultClassificationOption), " -", ' '), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lRogx.ClassificationLozenge), {
                    ...classification,
                    name: value?.name || ''
                })),
            color: value?.color,
            definition: '',
            classificationOverride: value
        };
    }, [
        value,
        intl
    ]);
};
module.exports["useSpaceDefaultClassificationLevelOption"] = $8f53943699900624$export$87415fc87251a143;

});

parcelRegister("93WhG", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $81f08aaba4f97dd2$export$39a13631616da233 = (0, $cgtv4.defineMessages)({
    classifyContent: {
        id: "data-classification.shared-messages.edit-popup.classify-content",
        defaultMessage: "Classify content"
    },
    fetchErrorTextPrimary: {
        id: "data-classification.shared-messages.fetch-error.primary",
        defaultMessage: "Unable to load classification. Try again."
    },
    fetchErrorTextSecondary: {
        id: "data-classification.shared-messages.fetch-error.secondary",
        defaultMessage: "Try reloading now."
    },
    saveErrorTextPrimary: {
        id: "data-classification.shared-messages.save-error.primary",
        defaultMessage: "Update to classification failed to save"
    },
    saveErrorTextSecondary: {
        id: "data-classification.shared-messages.save-error.secondary",
        defaultMessage: "Please try again."
    }
});
module.exports["sharedMessages"] = $81f08aaba4f97dd2$export$39a13631616da233;

});

parcelRegister("g5ZRs", function(module, exports) {

let $bb7d194d5913f379$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bb7d194d5913f379$var$load("2mt3f"),
    $bb7d194d5913f379$var$load("5odbj"),
    $bb7d194d5913f379$var$load("9wTW2")
]).then(()=>parcelRequire('dFOTO'));

});

parcelRegister("d6K5N", function(module, exports) {

let $98af96e55caa3c47$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $98af96e55caa3c47$var$load("4eWEr").then(()=>parcelRequire('2YWxz'));

});

parcelRegister("5mJom", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $fae6b037fdec4166$export$965fac7e99de5b4c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "asP3B",
    name: "ContentHeaderPresenceLoader",
    loader: async ()=>(await (parcelRequire("kKWDV"))).ContentHeaderPresence
});
module.exports["ContentHeaderPresenceLoader"] = $fae6b037fdec4166$export$965fac7e99de5b4c;

});

parcelRegister("kKWDV", function(module, exports) {

let $f1c597c55227b388$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f1c597c55227b388$var$load("dA13Y"),
    $f1c597c55227b388$var$load("fjOTL"),
    $f1c597c55227b388$var$load("h4Nf7"),
    $f1c597c55227b388$var$load("cLdBj"),
    $f1c597c55227b388$var$load("6RKDP"),
    $f1c597c55227b388$var$load("6XCf4"),
    $f1c597c55227b388$var$load("1qlDN"),
    $f1c597c55227b388$var$load("1yVM6"),
    $f1c597c55227b388$var$load("cyGuT"),
    $f1c597c55227b388$var$load("jXx9i"),
    $f1c597c55227b388$var$load("iZU4p"),
    $f1c597c55227b388$var$load("bunf9"),
    $f1c597c55227b388$var$load("kUbUu"),
    $f1c597c55227b388$var$load("7Q5vz"),
    $f1c597c55227b388$var$load("6FuHS"),
    $f1c597c55227b388$var$load("eyaRC"),
    $f1c597c55227b388$var$load("f1NVy"),
    $f1c597c55227b388$var$load("6wr18"),
    $f1c597c55227b388$var$load("kjZZD"),
    $f1c597c55227b388$var$load("Wowvf"),
    $f1c597c55227b388$var$load("hhss7"),
    $f1c597c55227b388$var$load("ffEVr"),
    $f1c597c55227b388$var$load("c4Kdp"),
    $f1c597c55227b388$var$load("7EorR"),
    $f1c597c55227b388$var$load("3YiKe")
]).then(()=>parcelRequire('bLtXM'));

});

parcelRegister("fwwrH", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0ba5a3a0ecf1d3dc$export$b44f4ceffd8a6e44 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "0XSep",
    name: "SmartCreateFeedbackBannerLoader",
    loader: async ()=>(await (parcelRequire("hWcNL"))).SmartCreateFeedbackBanner
});
module.exports["SmartCreateFeedbackBannerLoader"] = $0ba5a3a0ecf1d3dc$export$b44f4ceffd8a6e44;

});

parcelRegister("hWcNL", function(module, exports) {

let $d0f1c896472e451a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d0f1c896472e451a$var$load("drv5I"),
    $d0f1c896472e451a$var$load("hhss7"),
    $d0f1c896472e451a$var$load("hzVe9")
]).then(()=>parcelRequire('dSB3l'));

});

parcelRegister("b8Qzg", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7d2Nc = parcelRequire("7d2Nc");


var $5qUgM = parcelRequire("5qUgM");


var $8nrOs = parcelRequire("8nrOs");

const $3bf7bf5bf675da82$export$e3980b758fe4ea84 = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
            metric: (0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8nrOs.ContentTypesHeaderLoader), props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8nrOs.ContentTypesHeaderLoader), props));
module.exports["ContentTypesHeader"] = $3bf7bf5bf675da82$export$e3980b758fe4ea84;

});

parcelRegister("5qUgM", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");


var $14SPd = parcelRequire("14SPd");


var $7d41Y = parcelRequire("7d41Y");


var $15M40 = parcelRequire("15M40");

const $325dcacdd45838d0$export$fd9c234c55ebf87b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS = [
    $325dcacdd45838d0$export$fd9c234c55ebf87b,
    (0, $7d41Y.FAVOURITE_BUTTON_METRIC),
    (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
];
const $325dcacdd45838d0$export$31dafa10be5579b1 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$export$13d0f4f758cb96f = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS
];
const $325dcacdd45838d0$export$2afecd1facfcf464 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.DATABASE_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$13d0f4f758cb96f
});
const $325dcacdd45838d0$export$48a0148c0fcdf96 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $15M40.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$a8f0e1718c3ba46b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$48a0148c0fcdf96
});
const $325dcacdd45838d0$export$585906e42509a641 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $15M40.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$de21700de0084df7 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WHITEBOARD_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$585906e42509a641
});
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT"] = $325dcacdd45838d0$export$fd9c234c55ebf87b;
module.exports["OBJECT_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$31dafa10be5579b1;
module.exports["DATABASE_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$13d0f4f758cb96f;
module.exports["DATABASE_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$2afecd1facfcf464;
module.exports["SMART_LINK_EMBED_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$48a0148c0fcdf96;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$a8f0e1718c3ba46b;
module.exports["WHITEBOARD_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$585906e42509a641;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$de21700de0084df7;

});

parcelRegister("14SPd", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

var $jIOyV = parcelRequire("jIOyV");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;
module.exports["RESTRICTIONS_DIALOG_METRIC"] = $8ab24ab9418ac89d$export$2ba38536ff91e2a7;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["VIEW_AI_PRESENTATION_INTERACTION"] = $4fa41f80373a2ebe$export$af1eb8557193d022;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("7d41Y", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $9b3034aec76dfadd$export$ecb802558c1ba05e = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["FAVOURITE_BUTTON_METRIC"] = $9b3034aec76dfadd$export$ecb802558c1ba05e;

});

parcelRegister("15M40", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $8336b070b3684358$export$8fdec53caa79133c = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
});
module.exports["SHARE_BUTTON_PAGE_SEGMENT_LOAD"] = $8336b070b3684358$export$8fdec53caa79133c;

});

parcelRegister("8nrOs", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $7b80359059e5668e$export$17777490bbedaf3a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "i-H0G",
    name: "ContentTypesHeaderLoader",
    loader: async ()=>(await (parcelRequire("hVjML"))).ContentTypesHeader
});
module.exports["ContentTypesHeaderLoader"] = $7b80359059e5668e$export$17777490bbedaf3a;

});

parcelRegister("hVjML", function(module, exports) {

let $d0c71b834e9c2936$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d0c71b834e9c2936$var$load("2spqH"),
    $d0c71b834e9c2936$var$load("gWSdF"),
    $d0c71b834e9c2936$var$load("1Cs7t"),
    $d0c71b834e9c2936$var$load("gTC01"),
    $d0c71b834e9c2936$var$load("f1NVy"),
    $d0c71b834e9c2936$var$load("ioQAS"),
    $d0c71b834e9c2936$var$load("e9JE4"),
    $d0c71b834e9c2936$var$load("e4GNb"),
    $d0c71b834e9c2936$var$load("6wr18"),
    $d0c71b834e9c2936$var$load("8ADTD"),
    $d0c71b834e9c2936$var$load("aHhj2"),
    $d0c71b834e9c2936$var$load("6tsCm"),
    $d0c71b834e9c2936$var$load("jdHbV"),
    $d0c71b834e9c2936$var$load("3VLKz"),
    $d0c71b834e9c2936$var$load("2SjHp"),
    $d0c71b834e9c2936$var$load("li9sm"),
    $d0c71b834e9c2936$var$load("eRoc9"),
    $d0c71b834e9c2936$var$load("jwSno"),
    $d0c71b834e9c2936$var$load("aLLXO"),
    $d0c71b834e9c2936$var$load("jFI2g"),
    $d0c71b834e9c2936$var$load("9ZkgN"),
    $d0c71b834e9c2936$var$load("2mt3f"),
    $d0c71b834e9c2936$var$load("lnnYm"),
    $d0c71b834e9c2936$var$load("4XFRu"),
    $d0c71b834e9c2936$var$load("2F69B"),
    $d0c71b834e9c2936$var$load("gctwz"),
    $d0c71b834e9c2936$var$load("2t3HP"),
    $d0c71b834e9c2936$var$load("coJiW"),
    $d0c71b834e9c2936$var$load("iAqyW"),
    $d0c71b834e9c2936$var$load("5U3YO"),
    $d0c71b834e9c2936$var$load("8YSo7"),
    $d0c71b834e9c2936$var$load("3qsjq"),
    $d0c71b834e9c2936$var$load("lUlCu"),
    $d0c71b834e9c2936$var$load("6FuHS"),
    $d0c71b834e9c2936$var$load("eyaRC"),
    $d0c71b834e9c2936$var$load("hRUX7"),
    $d0c71b834e9c2936$var$load("g4oYs"),
    $d0c71b834e9c2936$var$load("36QeB"),
    $d0c71b834e9c2936$var$load("awqCy"),
    $d0c71b834e9c2936$var$load("kHOMt"),
    $d0c71b834e9c2936$var$load("jXx9i"),
    $d0c71b834e9c2936$var$load("8FbYE"),
    $d0c71b834e9c2936$var$load("dUevD"),
    $d0c71b834e9c2936$var$load("iZU4p"),
    $d0c71b834e9c2936$var$load("fZt2F"),
    $d0c71b834e9c2936$var$load("Wowvf"),
    $d0c71b834e9c2936$var$load("let0D"),
    $d0c71b834e9c2936$var$load("aqr2D"),
    $d0c71b834e9c2936$var$load("ffEVr"),
    $d0c71b834e9c2936$var$load("kUbUu"),
    $d0c71b834e9c2936$var$load("4Lgj0"),
    $d0c71b834e9c2936$var$load("kSJiq"),
    $d0c71b834e9c2936$var$load("g7g2y"),
    $d0c71b834e9c2936$var$load("9ftJe"),
    $d0c71b834e9c2936$var$load("hhss7"),
    $d0c71b834e9c2936$var$load("7EorR"),
    $d0c71b834e9c2936$var$load("KS1sL")
]).then(()=>parcelRequire('JJ6wk'));

});

parcelRegister("3pvXE", function(module, exports) {

let $27bc7fb7ce15423a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $27bc7fb7ce15423a$var$load("adH3p"),
    $27bc7fb7ce15423a$var$load("9VvWo"),
    $27bc7fb7ce15423a$var$load("5uN9h"),
    $27bc7fb7ce15423a$var$load("jzQ6f")
]).then(()=>parcelRequire('ylKHA'));

});

parcelRegister("hV9Q1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $42a2f15877153857$export$48a171bbad47b95a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kR_kE",
    name: "TemplatePreview",
    loader: async ()=>(await (parcelRequire("lYojD"))).TemplatePreview
});
module.exports["TemplatePreview"] = $42a2f15877153857$export$48a171bbad47b95a;

});

parcelRegister("lYojD", function(module, exports) {

let $fff210244864549d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fff210244864549d$var$load("e1cuZ"),
    $fff210244864549d$var$load("6kXh6"),
    $fff210244864549d$var$load("hvHZS")
]).then(()=>parcelRequire('5QLLH'));

});

parcelRegister("bUiJC", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $22ad974994dfbc0b$var$applyDefaultWidth = ()=>{
    const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
    if (editorScrollParent) return editorScrollParent.clientWidth || 0;
    return 0;
};
const $22ad974994dfbc0b$export$5308d1e625847f03 = ({ isFixedWidth: isFixedWidth = false })=>{
    const defaultWidth = $22ad974994dfbc0b$var$applyDefaultWidth();
    const [width, setWidth] = (0, $42omo.useState)(defaultWidth);
    const observerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
        if (editorScrollParent && !isFixedWidth) {
            observerRef.current = new ResizeObserver((entries)=>{
                setWidth(Math.floor(entries[0]?.target.clientWidth));
            });
            observerRef.current.observe(editorScrollParent);
            return ()=>observerRef?.current?.disconnect();
        }
    }, [
        observerRef,
        isFixedWidth
    ]);
    return {
        width: width,
        observerRef: observerRef.current
    };
};
module.exports["useEditorWidthObserver"] = $22ad974994dfbc0b$export$5308d1e625847f03;

});

parcelRegister("ixblh", function(module, exports) {
/* bpqaStyled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $2932c138a6a4fe83$export$899fff719d224ef5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zs12fajl _kewefbnq _xlob1h6o",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$5f734e3a73651e57 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c82smr _k48pi7a9",
            __cmplp.isDisabled ? "_syaz1gmx" : "_syazazsu",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$25a86e6d831757c1 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1tcg _4t3i1tcg _wh9on7od _1an5n7od",
            __cmplp.isDisabled ? "_tzy41ou4" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$2285fc416017f7ef = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx21bp4 _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$61367bcbe6096b19 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTemplatesPanelOpen: isTemplatesPanelOpen, shouldAdjustForContextPanel: shouldAdjustForContextPanel, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4pxbi _19itia51 _zulputpp _2rko1mok _2lx21bp4 _1e0c1txw _94n51ejb _bfhkvuon _1pbycs5v",
            __cmplp.isTemplatesPanelOpen && __cmplp.shouldAdjustForContextPanel ? "_2hwxa3o1" : "_2hwxidpf",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$17a2f9655d167e3f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4pxbi _1e0c1txw _1bsb1wug _1bah1h6o _n3tdv47k _kqswstnw _94n5idpf",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$f8e573bbc82f4efb = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bsb1osq _1bah1h6o _kqswh2mm _bfhkvuon",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zs12fajl _kewefbnq _xlob1h6o",
            __cmplp.isActive ? "_jmnr9yc7" : "_jmnrmzrp",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$f4922e2dc59c62b7 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShowTemplatePreview: shouldShowTemplatePreview, editorWidth: editorWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswstnw _n3td68cl _bfhkvuon _1bsb1osq _1pbykb7n _1e0oidpf _jvszidpf _d7r2idpf _uhh2idpf _kvd7n7od _1oxg1osq _pnc7vuon _gdo5idpf _1jndidpf _1h8zidpf _1hblidpf _uzron7od _169tglyw _10pb1wug _1cpl1jfw _fkwnvuon",
            __cmplp.shouldShowTemplatePreview ? "_1e0c1wug" : "_1e0cglyw",
            __cmplp.editorWidth < 500 ? "_154i1bdq" : __cmplp.editorWidth < 820 ? "_154i1cg9" : "_154ikfja",
            __cmplp.className
        ])
    });
});
module.exports["QuickCardContainer"] = $2932c138a6a4fe83$export$899fff719d224ef5;
module.exports["ButtonText"] = $2932c138a6a4fe83$export$5f734e3a73651e57;
module.exports["QuickCardIcon"] = $2932c138a6a4fe83$export$25a86e6d831757c1;
module.exports["QuickCardColumn"] = $2932c138a6a4fe83$export$2285fc416017f7ef;
module.exports["BlankPageQuickActionsCardContainer"] = $2932c138a6a4fe83$export$61367bcbe6096b19;
module.exports["BlankPageQuickActionsWrapper"] = $2932c138a6a4fe83$export$17a2f9655d167e3f;
module.exports["BlankPageQuickActionsTemplatePreviewWrapper"] = $2932c138a6a4fe83$export$f8e573bbc82f4efb;
module.exports["Link"] = $2932c138a6a4fe83$export$a6c7ac8248d6e38a;
module.exports["BlankPageQuickActionsTemplatePreviewContainer"] = $2932c138a6a4fe83$export$f4922e2dc59c62b7;

});

parcelRegister("c06us", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $ae5hk = parcelRequire("ae5hk");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");

/** @graphql agg **/ 
var $eSUdr = parcelRequire("eSUdr");


var $8C5kA = parcelRequire("8C5kA");





var $aiWdm = parcelRequire("aiWdm");

const $48e6cac0e3cb7731$export$da219dd41e9a36c6 = (teamType)=>{
    const names = teamType ? (0, $aiWdm.TEMPLATES_FOR_TEAM_TYPE)[teamType] : (0, $aiWdm.DEFAULT_TEMPLATES);
    return [
        (0, $aiWdm.TEMPLATE_DETAILS)[names[0]],
        (0, $aiWdm.TEMPLATE_DETAILS)[names[1]],
        (0, $aiWdm.TEMPLATE_DETAILS)[names[2]]
    ];
};



var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $8Lx5S = parcelRequire("8Lx5S");


var $dE3yd = parcelRequire("dE3yd");

const $f0a3375858601913$export$e61a948785bd7b17 = ()=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)((0, $9wGTI.fg)('cfind-4971-improved-templates-bar-gate') ? [
        ...Object.values((0, $dBcar.LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA)),
        (0, $dBcar.FOUNDING_ADMIN_REVAMPED_BPQA_ELIGIBLE)
    ] : [
        ...Object.values((0, $dBcar.LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA))
    ], !isLicensed);
    const { revampedBpqaShownAt: revampedBpqaShownAt, foundingAdminRevampedBpqaEligible: foundingAdminRevampedBpqaEligible } = (0, $ivb8S.deserializeState)(data);
    const shownAtWithinLastWeek = (0, $dE3yd.isWithinLastWeek)(revampedBpqaShownAt);
    if (!isLicensed) return {
        showNewUserTemplates: false,
        loading: false
    };
    if (loading) return {
        showNewUserTemplates: false,
        loading: true
    };
    if (error) return {
        showNewUserTemplates: false,
        loading: false,
        error: error
    };
    return {
        showNewUserTemplates: foundingAdminRevampedBpqaEligible && // This is where we actually enroll users for CFIND-4971, this means that if a Founding Admin is going to see a templates bar
        // 50% will see the old one and 50% will see the improved one
        (0, $6mKj3.expVal)('cfind-4971-improved-templates-bar', 'isEnabled', false) || shownAtWithinLastWeek && ((0, $6mKj3.expValEquals)('land_users_in_editor_with_revamped_bpqa_new', 'cohort', 'experiment') || (0, $6mKj3.expValEquals)('land_users_in_editor_with_revamped_bpqa_existing', 'cohort', 'experiment')),
        loading: false
    };
};


/** @graphql agg **/ 









var $bQm3c = parcelRequire("bQm3c");


var $gKr8t = parcelRequire("gKr8t");




const $b12d442de7f1e3d8$var$teamTypeQuery = (0, $eSUdr.default)`query useTeamTypeUserQuery($userId:ID!){user(accountId:$userId){__typename ...on AtlassianAccountUser{extendedProfile{teamType}}}}`;
const $b12d442de7f1e3d8$var$TEAM_TYPES = Object.keys((0, $aiWdm.TEMPLATES_FOR_TEAM_TYPE));
const $b12d442de7f1e3d8$var$sanitizeTeamType = (teamType)=>{
    if (teamType && $b12d442de7f1e3d8$var$TEAM_TYPES.includes(teamType)) return teamType;
    return undefined;
};
const $b12d442de7f1e3d8$export$243eb30ff3b311dd = ({ skip: skip })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)(/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ $b12d442de7f1e3d8$var$teamTypeQuery, {
        variables: {
            userId: userId ?? ''
        },
        skip: skip || !isLicensed || !userId,
        client: (0, $gKr8t.getAGGClient)()
    });
    if (loading) return {
        teamType: undefined,
        loading: true
    };
    if (error) return {
        teamType: undefined,
        loading: false,
        error: error
    };
    if (data?.user?.__typename === 'AtlassianAccountUser') return {
        teamType: $b12d442de7f1e3d8$var$sanitizeTeamType(data.user.extendedProfile?.teamType),
        loading: false
    };
    return {
        teamType: undefined,
        loading: false
    };
};


const $7042ac65234fccd4$var$templateInfo = (0, $eSUdr.default)`query useNewUserTemplatesGetMultipleTemplateInfoQuery($templateId0:ID!$templateId1:ID!$templateId2:ID!){template0:templateInfo(id:$templateId0){templateId contentBlueprintId blueprintModuleCompleteKey itemModuleCompleteKey templateType name description iconURL darkModeIconURL styleClass hasWizard isNew isPromoted isFavourite hasGlobalBlueprintContent categoryIds keywords recommendationRank author}template1:templateInfo(id:$templateId1){templateId contentBlueprintId blueprintModuleCompleteKey itemModuleCompleteKey templateType name description iconURL darkModeIconURL styleClass hasWizard isNew isPromoted isFavourite hasGlobalBlueprintContent categoryIds keywords recommendationRank author}template2:templateInfo(id:$templateId2){templateId contentBlueprintId blueprintModuleCompleteKey itemModuleCompleteKey templateType name description iconURL darkModeIconURL styleClass hasWizard isNew isPromoted isFavourite hasGlobalBlueprintContent categoryIds keywords recommendationRank author}}`;
const $7042ac65234fccd4$export$377e0a64bacf7634 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { showNewUserTemplates: showNewUserTemplates, loading: shouldShowLoading, error: shouldShowError } = (0, $f0a3375858601913$export$e61a948785bd7b17)();
    const skip = !showNewUserTemplates;
    const { teamType: teamType, error: teamTypeError, loading: teamTypeLoading } = (0, $b12d442de7f1e3d8$export$243eb30ff3b311dd)({
        skip: skip
    });
    const templates = (0, $48e6cac0e3cb7731$export$da219dd41e9a36c6)(teamType);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)(/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ $7042ac65234fccd4$var$templateInfo, {
        variables: {
            templateId0: templates[0].blueprintModuleCompleteKey,
            templateId1: templates[1].blueprintModuleCompleteKey,
            templateId2: templates[2].blueprintModuleCompleteKey
        },
        skip: skip || teamTypeLoading
    });
    if (shouldShowLoading || teamTypeLoading || loading) return {
        loading: true,
        templates: null
    };
    if (shouldShowError || teamTypeError || error) return {
        loading: false,
        templates: null,
        error: shouldShowError || teamTypeError || error
    };
    if (!showNewUserTemplates) return {
        loading: false,
        templates: null
    };
    if (!(data?.template0 && data?.template1 && data?.template2)) return {
        loading: false,
        templates: null
    };
    return {
        loading: false,
        templates: [
            {
                ...data.template0,
                name: formatMessage(templates[0].name)
            },
            {
                ...data.template1,
                name: formatMessage(templates[1].name)
            },
            {
                ...data.template2,
                name: formatMessage(templates[2].name)
            }
        ]
    };
};


/**
 * @generated SignedSource<<fe571911745669516f11a74ed9e0569f>>
 * @relayHash 305bfba629f3fb1fcf0b98802abf2507
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 69cd3740366e8d29b1c6a6a4156b7f2fcdf259b3466473ee99895304547b640a
const $563193a81ba03362$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortingScheme"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                },
                {
                    "kind": "Variable",
                    "name": "sortingScheme",
                    "variableName": "sortingScheme"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PaginatedTemplateInfoList",
            "kind": "LinkedField",
            "name": "allTemplates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TemplateInfo",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "templateId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentBlueprintId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blueprintModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "itemModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "templateType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "description"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "iconURL"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "darkModeIconURL"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "styleClass"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasWizard"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isNew"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPromoted"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isFavourite"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasGlobalBlueprintContent"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "categoryIds"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "keywords"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "recommendationRank"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "author"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSuggestedTemplatesQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSuggestedTemplatesQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "305bfba629f3fb1fcf0b98802abf2507",
            "id": "69cd3740366e8d29b1c6a6a4156b7f2fcdf259b3466473ee99895304547b640a",
            "metadata": {},
            "name": "useSuggestedTemplatesQuery",
            "operationKind": "query",
            "text": "query useSuggestedTemplatesQuery($spaceKey:String!,$sortingScheme:String,$limit:Int!){allTemplates(spaceKey:$spaceKey,sortingScheme:$sortingScheme,limit:$limit){nodes{templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author}}}"
        }
    };
}();
$563193a81ba03362$var$node.hash = "0e72a917d2ed7c5fe874a55ae939d049";
var $563193a81ba03362$export$2e2bcd8739ae039 = $563193a81ba03362$var$node;



var $fDlC6 = parcelRequire("fDlC6");

const $7fc37f1065645929$export$39dea997638a7196 = ({ spaceKey: spaceKey })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { templates: newUserTemplates, error: newUserTemplatesError, loading: newUserTemplatesLoading } = (0, $7042ac65234fccd4$export$377e0a64bacf7634)();
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $563193a81ba03362$export$2e2bcd8739ae039), {
        variables: {
            spaceKey: spaceKey,
            sortingScheme: (0, $ae5hk.SortOrders).RELEVANCY_SORT,
            limit: (0, $fDlC6.TEMPLATE_LIMIT)
        },
        skip: !spaceKey
    });
    if (error || newUserTemplatesError) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        if ((0, $1uFM6.isUnauthorizedError)(newUserTemplatesError)) (0, $7Sm4c.markErrorAsHandled)(newUserTemplatesError);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'BlankPageQuickActions',
                action: 'error',
                actionSubject: 'useSuggestedTemplates',
                attributes: {
                    version: '2',
                    revampedBpqaError: Boolean(newUserTemplatesError)
                }
            }
        }).fire();
    }
    if (loading || newUserTemplatesLoading) return {
        templates: [],
        loading: true,
        error: error || newUserTemplatesError
    };
    if (newUserTemplates) return {
        templates: newUserTemplates,
        loading: false,
        error: error || newUserTemplatesError,
        isNewUserTemplates: true
    };
    const suggestedTemplates = data?.allTemplates?.nodes || [];
    // we want to filter out the blog post template and legacy
    // editor template, so we get 5 templates and return the
    // first 3 excluding them if they exist
    const templates = suggestedTemplates?.filter((template)=>template.itemModuleCompleteKey !== (0, $fDlC6.BPQA_EXCLUDED_TEMPLATE_KEYS).BLOG_POST && template.blueprintModuleCompleteKey !== (0, $fDlC6.BPQA_EXCLUDED_TEMPLATE_KEYS).LEGACY_EDITOR)?.slice(0, 3);
    return {
        error: error || newUserTemplatesError,
        templates: templates,
        loading: loading
    };
};


const $5c0cf15fa14bb16f$export$e155e043455d63c1 = /*#__PURE__*/ (0, $42omo.createContext)({
    templates: [],
    templateIndex: 0,
    buttonHovered: false,
    loading: false,
    error: undefined,
    setButtonHovered: ()=>{},
    setTemplateIndex: ()=>{},
    revampedBpqa: false
});
const $5c0cf15fa14bb16f$export$124ad6efb514134c = ({ children: children, spaceKey: spaceKey })=>{
    const [templateIndex, setTemplateIndex] = (0, $42omo.useState)(0);
    const [buttonHovered, setButtonHovered] = (0, $42omo.useState)(false);
    const { error: error, loading: loading, templates: templates, isNewUserTemplates: isNewUserTemplates } = (0, $7fc37f1065645929$export$39dea997638a7196)({
        spaceKey: spaceKey
    });
    const contextValue = (0, $42omo.useMemo)(()=>{
        return {
            templates: templates,
            error: error,
            loading: loading,
            templateIndex: templateIndex,
            setTemplateIndex: setTemplateIndex,
            buttonHovered: buttonHovered,
            setButtonHovered: setButtonHovered,
            revampedBpqa: Boolean(isNewUserTemplates)
        };
    }, [
        templates,
        error,
        loading,
        templateIndex,
        setTemplateIndex,
        buttonHovered,
        setButtonHovered,
        isNewUserTemplates
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c0cf15fa14bb16f$export$e155e043455d63c1.Provider, {
        value: contextValue
    }, children);
};
const $5c0cf15fa14bb16f$export$ba95a878db10004d = ()=>(0, $42omo.useContext)($5c0cf15fa14bb16f$export$e155e043455d63c1);
module.exports["BlankPageQuickActionsProvider"] = $5c0cf15fa14bb16f$export$124ad6efb514134c;
module.exports["useBlankPageQuickActionsContext"] = $5c0cf15fa14bb16f$export$ba95a878db10004d;

});

parcelRegister("ae5hk", function(module, exports) {
var $5ff79979c9f78c44$export$edd0ae81c67ebc59 = /*#__PURE__*/ function(SortOrders) {
    SortOrders["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    SortOrders["ALPHABETICAL_SORT"] = "web.item.sorting.scheme.alphabetical";
    return SortOrders;
}({});
module.exports["SortOrders"] = $5ff79979c9f78c44$export$edd0ae81c67ebc59;

});

parcelRegister("aiWdm", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $47eb490faf71feb2$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    brainstormingTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.brainstorming-name",
        defaultMessage: "Brainstorming"
    },
    brainstormingTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.brainstorming-description",
        defaultMessage: "Generate and group ideas"
    },
    businesStatusUpdateTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.business-status-update-name",
        defaultMessage: "Business Status Update"
    },
    businesStatusUpdateTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.business-status-update-description",
        defaultMessage: "Share team-wide updates"
    },
    DACIDecisionDocumentTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.daci-decision-document-name",
        defaultMessage: "DACI:Decision Document"
    },
    DACIDecisionDocumentTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.brainstorming-description",
        defaultMessage: "Drive clarity on decisions"
    },
    designDecisionTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.design-decision-name",
        defaultMessage: "Design Decision"
    },
    designDecisionTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.design-decision-description",
        defaultMessage: "Document design outcomes"
    },
    designSprintTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.design-sprint-name",
        defaultMessage: "Design Sprint"
    },
    designSprintTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.design-sprint-description",
        defaultMessage: "Run a structured sprint cycle"
    },
    employeeHandbookTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.employee-handbook-name",
        defaultMessage: "Employee Handbook"
    },
    employeeHandbookTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.employee-handbook-description",
        defaultMessage: "Centralize company policies"
    },
    fundraisingDatabaseTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.fundraising-database-name",
        defaultMessage: "Fundraising Database"
    },
    fundraisingDatabaseTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.fundraising-database-description",
        defaultMessage: "Track investor outreach"
    },
    hiringProcessTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.hiring-process-name",
        defaultMessage: "Hiring Process"
    },
    hiringProcessTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.hiring-process-description",
        defaultMessage: "Outline each hiring step"
    },
    ITSMRunbookTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.itsm-runbook-name",
        defaultMessage: "ITSM Runbook"
    },
    ITSMRunbookTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.itsm-runbook-description",
        defaultMessage: "Standardize incident response"
    },
    marketingCampaignTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.marketing-campaign-name",
        defaultMessage: "Marketing Campaign"
    },
    marketingCampaignTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.marketing-campaign-description",
        defaultMessage: "Plan campaign work"
    },
    marketingPlanTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.marketing-plan-name",
        defaultMessage: "Marketing Plan"
    },
    marketingPlanTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.marketing-plan-description",
        defaultMessage: "Outline marketing goals"
    },
    meetingNotesTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.meeting-notes-name",
        defaultMessage: "Meeting notes"
    },
    meetingNotesTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.meeting-notes-description",
        defaultMessage: "Capture meeting outcomes"
    },
    productRequirementsTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.product-requirements-name",
        defaultMessage: "Product Requirements"
    },
    productRequirementsTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.product-requirements-description",
        defaultMessage: "Align product goals and scope"
    },
    projectPlanTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.project-plan-name",
        defaultMessage: "Project Plan"
    },
    projectPlanTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.project-plan-description",
        defaultMessage: "Align teams on project scope"
    },
    projectStatusTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.project-status-report-name",
        defaultMessage: "Project Status Report"
    },
    projectStatusTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.project-status-report-description",
        defaultMessage: "Share team status updates"
    },
    retrospectiveTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.retrospective-name",
        defaultMessage: "Retrospective"
    },
    retrospectiveTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.retrospective-description",
        defaultMessage: "Reflect and improve as a team"
    },
    salesAccountPlanningTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.sales-account-planning-name",
        defaultMessage: "Sales Account Planning"
    },
    salesAccountPlanningTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.sales-account-planning-description",
        defaultMessage: "Set goals for key accounts"
    },
    salesPortalTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.sales-portal-name",
        defaultMessage: "Sales Portal"
    },
    salesPortalTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.sales-portal-description",
        defaultMessage: "Organize sales resources"
    },
    softwareArchitectureReviewTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.software-architecture-review-name",
        defaultMessage: "Software Architecture Review"
    },
    softwareArchitectureReviewTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.software-architecture-review-description",
        defaultMessage: "Evaluate technical designs"
    },
    standardOperatingProcedureTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.standard-operating-procedure-name",
        defaultMessage: "Standard Operating Procedure"
    },
    standardOperatingProcedureTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.standard-operating-procedure-description",
        defaultMessage: "Document recurring steps"
    },
    troubleshootingArticleTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.troubleshooting-article-name",
        defaultMessage: "Troubleshooting article"
    },
    troubleshootingArticleTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.troubleshooting-article-description",
        defaultMessage: "Guide users to resolve issues"
    }
});


var $4392621abe69b953$exports = {};
$4392621abe69b953$exports = new URL("Brainstorming.94b58c6a.svg", import.meta.url).toString();


var $67e1b265c54e2397$exports = {};
$67e1b265c54e2397$exports = new URL("Brainstorming Hover.84a73d80.svg", import.meta.url).toString();


var $85a919892eb4d84a$exports = {};
$85a919892eb4d84a$exports = new URL("Business Status Update.1efc1ace.svg", import.meta.url).toString();


var $c077e40dc9aabac0$exports = {};
$c077e40dc9aabac0$exports = new URL("Business Status Update Hover.cc17fbf4.svg", import.meta.url).toString();


var $9dd8fb39916d123f$exports = {};
$9dd8fb39916d123f$exports = new URL("DACI.8156ef8f.svg", import.meta.url).toString();


var $80f3554cd55d11ee$exports = {};
$80f3554cd55d11ee$exports = new URL("DACI Hover.236fac19.svg", import.meta.url).toString();


var $adfb30cd378a71c8$exports = {};
$adfb30cd378a71c8$exports = new URL("Design Decision.aea9ef88.svg", import.meta.url).toString();


var $019d57760f62f149$exports = {};
$019d57760f62f149$exports = new URL("Design Decision Hover.2b270b62.svg", import.meta.url).toString();


var $69383ee2456b9f5c$exports = {};
$69383ee2456b9f5c$exports = new URL("Design Sprint.b98d94bb.svg", import.meta.url).toString();


var $a96b5c83c7c9ee26$exports = {};
$a96b5c83c7c9ee26$exports = new URL("Design Sprint Hover.aceafcc7.svg", import.meta.url).toString();


var $11c92e15ef222d17$exports = {};
$11c92e15ef222d17$exports = new URL("Employee Handbook.fb183623.svg", import.meta.url).toString();


var $9dfc97e380eef4ae$exports = {};
$9dfc97e380eef4ae$exports = new URL("Employee Handbook Hover.40d99a75.svg", import.meta.url).toString();


var $e73f4e0fb9420563$exports = {};
$e73f4e0fb9420563$exports = new URL("Fundraising.0a1781f3.svg", import.meta.url).toString();


var $40f74ccc3e5e5ebf$exports = {};
$40f74ccc3e5e5ebf$exports = new URL("Fundraising Database Hover.e1687271.svg", import.meta.url).toString();


var $3d4e75fc04469d0a$exports = {};
$3d4e75fc04469d0a$exports = new URL("Hiring Process.1a46f9b1.svg", import.meta.url).toString();


var $703480c6c1f11297$exports = {};
$703480c6c1f11297$exports = new URL("Hiring Process Hover.a7af5d46.svg", import.meta.url).toString();


var $5e73d83ce559a68b$exports = {};
$5e73d83ce559a68b$exports = new URL("ITSM Runbook.272077bd.svg", import.meta.url).toString();


var $98cf534c08d87a5e$exports = {};
$98cf534c08d87a5e$exports = new URL("ITSM Runbook Hover.dfaa2fae.svg", import.meta.url).toString();


var $7e5f3cf9e6fc0afb$exports = {};
$7e5f3cf9e6fc0afb$exports = new URL("Marketing Campaign.45dd758d.svg", import.meta.url).toString();


var $6293a1a6c443799d$exports = {};
$6293a1a6c443799d$exports = new URL("Marketing Campaign Hover.5c2b5955.svg", import.meta.url).toString();


var $d24c4c30304a8307$exports = {};
$d24c4c30304a8307$exports = new URL("OKR Tracking.a04718bb.svg", import.meta.url).toString();


var $e654f1d3a2087284$exports = {};
$e654f1d3a2087284$exports = new URL("OKR Tracking Hover.1ed55ab5.svg", import.meta.url).toString();


var $bc8686804f8b8dc0$exports = {};
$bc8686804f8b8dc0$exports = new URL("Meeting notes.431ccf5e.svg", import.meta.url).toString();


var $10d8ba13d8f13371$exports = {};
$10d8ba13d8f13371$exports = new URL("Meeting notes Hover.7ae587e9.svg", import.meta.url).toString();


var $66664187cf128435$exports = {};
$66664187cf128435$exports = new URL("Mkt Plan.cf8b450c.svg", import.meta.url).toString();


var $6379b6fd8b6cdac1$exports = {};
$6379b6fd8b6cdac1$exports = new URL("Mkt Plan Hover.8897bfdd.svg", import.meta.url).toString();


var $6c30a3e17b19299f$exports = {};
$6c30a3e17b19299f$exports = new URL("PRD.56426dd9.svg", import.meta.url).toString();


var $c070b4951fa044b4$exports = {};
$c070b4951fa044b4$exports = new URL("PRD Hover.cb81c0eb.svg", import.meta.url).toString();


var $b9715a92a16b3e8f$exports = {};
$b9715a92a16b3e8f$exports = new URL("Project Plan.f28f7914.svg", import.meta.url).toString();


var $6d18d0481e528a05$exports = {};
$6d18d0481e528a05$exports = new URL("Project Plan Hover.48617613.svg", import.meta.url).toString();


var $b29e8f42600397f6$exports = {};
$b29e8f42600397f6$exports = new URL("Proj Status Report.972dc052.svg", import.meta.url).toString();


var $634b93063fdf34bc$exports = {};
$634b93063fdf34bc$exports = new URL("Project Status Hover.a6f2e4f1.svg", import.meta.url).toString();


var $f0e73592c99f8acd$exports = {};
$f0e73592c99f8acd$exports = new URL("Retro.0a7a990a.svg", import.meta.url).toString();


var $fca08ae507a4df2d$exports = {};
$fca08ae507a4df2d$exports = new URL("Retro Hover.17d739ed.svg", import.meta.url).toString();


var $8fc19fe69bc4106c$exports = {};
$8fc19fe69bc4106c$exports = new URL("Sales Account Planning.7875e2a4.svg", import.meta.url).toString();


var $c6b28e7a2bdd6bfb$exports = {};
$c6b28e7a2bdd6bfb$exports = new URL("Sales Account Planning Hover.f968f550.svg", import.meta.url).toString();


var $f64f324c9b1e7b4a$exports = {};
$f64f324c9b1e7b4a$exports = new URL("Sales Portal.53643a97.svg", import.meta.url).toString();


var $48758013a23af4d1$exports = {};
$48758013a23af4d1$exports = new URL("Sales Portal Hover.64b2d259.svg", import.meta.url).toString();


var $1de9cf356e4bda52$exports = {};
$1de9cf356e4bda52$exports = new URL("Software Arch Review.77a3a9da.svg", import.meta.url).toString();


var $2f1e3c1c4fb0bf3e$exports = {};
$2f1e3c1c4fb0bf3e$exports = new URL("Software Arch Review Hover.e52e609b.svg", import.meta.url).toString();


var $53bde8978e73ceaa$exports = {};
$53bde8978e73ceaa$exports = new URL("Troubleshooting Article.29206918.svg", import.meta.url).toString();


var $64411924b1c80ea8$exports = {};
$64411924b1c80ea8$exports = new URL("Troubleshooting Article Hover.a6ecd9aa.svg", import.meta.url).toString();


var $7c44d98f2ce80fa6$exports = {};
$7c44d98f2ce80fa6$exports = new URL("Brainstorming.f240c002.svg", import.meta.url).toString();


var $d3619229f78a3f42$exports = {};
$d3619229f78a3f42$exports = new URL("Brainstorming Hover.e1c833f7.svg", import.meta.url).toString();


var $d2e5c6575592daa8$exports = {};
$d2e5c6575592daa8$exports = new URL("Business Status Update.60b38516.svg", import.meta.url).toString();


var $cf28e58ca0204494$exports = {};
$cf28e58ca0204494$exports = new URL("Business Status Update Hover.d2aa938c.svg", import.meta.url).toString();


var $e041ccfe7342b9f1$exports = {};
$e041ccfe7342b9f1$exports = new URL("DACI.3cadbee0.svg", import.meta.url).toString();


var $e01cb0f4e35e0256$exports = {};
$e01cb0f4e35e0256$exports = new URL("DACI Hover.c4a9d2d6.svg", import.meta.url).toString();


var $82a20256e8bac3ff$exports = {};
$82a20256e8bac3ff$exports = new URL("Design Decision.6306cc24.svg", import.meta.url).toString();


var $d216864a8f19b6d3$exports = {};
$d216864a8f19b6d3$exports = new URL("Design Decision Hover.c4751033.svg", import.meta.url).toString();


var $4cdba2501835fb92$exports = {};
$4cdba2501835fb92$exports = new URL("Design Sprint.261d030b.svg", import.meta.url).toString();


var $33f2011447c761cd$exports = {};
$33f2011447c761cd$exports = new URL("Design Sprint Hover.e398d42e.svg", import.meta.url).toString();


var $23d499320706e9dd$exports = {};
$23d499320706e9dd$exports = new URL("Employee Handbook.b58ecb32.svg", import.meta.url).toString();


var $8827fbf78bb09a3f$exports = {};
$8827fbf78bb09a3f$exports = new URL("Employee Handbook Hover.94b5de04.svg", import.meta.url).toString();


var $8115584b71ad6b34$exports = {};
$8115584b71ad6b34$exports = new URL("Fundraising.0b5ad295.svg", import.meta.url).toString();


var $252b508e60e81e78$exports = {};
$252b508e60e81e78$exports = new URL("Fundraising Database Hover.6c691554.svg", import.meta.url).toString();


var $22d70e35084ccfba$exports = {};
$22d70e35084ccfba$exports = new URL("Hiring Process.7a363ddb.svg", import.meta.url).toString();


var $54fda51d89da9313$exports = {};
$54fda51d89da9313$exports = new URL("Hiring Process Hover.c4281ae3.svg", import.meta.url).toString();


var $efd12af1051263cc$exports = {};
$efd12af1051263cc$exports = new URL("ITSM Runbook.2a44e062.svg", import.meta.url).toString();


var $255e1f0d9cd1620a$exports = {};
$255e1f0d9cd1620a$exports = new URL("ITSM Runbook Hover.69e2eef4.svg", import.meta.url).toString();


var $b2472dd8fe31846e$exports = {};
$b2472dd8fe31846e$exports = new URL("Marketing Campaign.496d08ac.svg", import.meta.url).toString();


var $28963e653cacdd6d$exports = {};
$28963e653cacdd6d$exports = new URL("Marketing Campaign Hover.5784e467.svg", import.meta.url).toString();


var $bec357e7d088a566$exports = {};
$bec357e7d088a566$exports = new URL("OKR Tracking.3e82c60a.svg", import.meta.url).toString();


var $2530e99155f28d5a$exports = {};
$2530e99155f28d5a$exports = new URL("OKR Tracking Hover.047609df.svg", import.meta.url).toString();


var $906975d8f9cea568$exports = {};
$906975d8f9cea568$exports = new URL("Meeting notes.14684091.svg", import.meta.url).toString();


var $bfc8e328d23fa0ab$exports = {};
$bfc8e328d23fa0ab$exports = new URL("Meeting notes Hover.418d408b.svg", import.meta.url).toString();


var $deb2d54df1033035$exports = {};
$deb2d54df1033035$exports = new URL("Mkt Plan.51fd454e.svg", import.meta.url).toString();


var $1f3b8781f3cc8cf6$exports = {};
$1f3b8781f3cc8cf6$exports = new URL("Mkt Plan Hover.eec8532b.svg", import.meta.url).toString();


var $395ed034d2b0f22c$exports = {};
$395ed034d2b0f22c$exports = new URL("PRD.b38857d1.svg", import.meta.url).toString();


var $dd97f811a0c5d5a8$exports = {};
$dd97f811a0c5d5a8$exports = new URL("PRD Hover.599187af.svg", import.meta.url).toString();


var $4e2cc57b6d27098b$exports = {};
$4e2cc57b6d27098b$exports = new URL("Project Plan.dc0a681a.svg", import.meta.url).toString();


var $cf2773701a4c0368$exports = {};
$cf2773701a4c0368$exports = new URL("Project Plan Hover.579bdd0f.svg", import.meta.url).toString();


var $1e112a5d4bc79485$exports = {};
$1e112a5d4bc79485$exports = new URL("Proj Status Report.91e4cee0.svg", import.meta.url).toString();


var $eab0b91717991a96$exports = {};
$eab0b91717991a96$exports = new URL("Project Status Hover.d317ca8f.svg", import.meta.url).toString();


var $80f0edb550be670c$exports = {};
$80f0edb550be670c$exports = new URL("Retro.f40bdbc6.svg", import.meta.url).toString();


var $eb81cca049bc2104$exports = {};
$eb81cca049bc2104$exports = new URL("Retro Hover.fbb2e555.svg", import.meta.url).toString();


var $aaffd15eaa6c65d5$exports = {};
$aaffd15eaa6c65d5$exports = new URL("Sales Account Planning.1824dc16.svg", import.meta.url).toString();


var $6682b35e7e88a40d$exports = {};
$6682b35e7e88a40d$exports = new URL("Sales Account Planning Hover.e1bd2a06.svg", import.meta.url).toString();


var $893424cf034868bd$exports = {};
$893424cf034868bd$exports = new URL("Sales Portal.753ff2da.svg", import.meta.url).toString();


var $2df6c13e6c7c9398$exports = {};
$2df6c13e6c7c9398$exports = new URL("Sales Portal Hover.f29ecdcb.svg", import.meta.url).toString();


var $8fcc2cc6662ba220$exports = {};
$8fcc2cc6662ba220$exports = new URL("Software Arch Review.baf8365c.svg", import.meta.url).toString();


var $b6ac790d527ee68a$exports = {};
$b6ac790d527ee68a$exports = new URL("Software Arch Review Hover.0efbbff0.svg", import.meta.url).toString();


var $7fdf62e52c226d49$exports = {};
$7fdf62e52c226d49$exports = new URL("Troubleshooting Article.300207db.svg", import.meta.url).toString();


var $288ef0fa7c4a07c1$exports = {};
$288ef0fa7c4a07c1$exports = new URL("Troubleshooting Article Hover.e0b7be9f.svg", import.meta.url).toString();


const $d8ff577dc849af37$export$d5b92d67f1b42228 = [
    'Project plan',
    'Meeting notes',
    'Brainstorming'
];
const $d8ff577dc849af37$export$52608caa2693c2d2 = {
    'Software development': [
        'Software Architecture Review',
        'Meeting notes',
        'Retrospective'
    ],
    'Product management': [
        'Product Requirements',
        'Meeting notes',
        'Brainstorming'
    ],
    Finance: [
        'Business status update',
        'Meeting notes',
        'Fundraising database'
    ],
    'Human resources': [
        'Employee handbook',
        'Meeting notes',
        'Hiring Process Template'
    ],
    Legal: [
        'Project plan',
        'Meeting notes',
        'DACI: Decision documentation'
    ],
    Marketing: [
        'Marketing campaign',
        'Meeting notes',
        'Marketing plan'
    ],
    Operations: [
        'Standard Operating Procedure (SOP) Template',
        'Meeting notes',
        'Project plan'
    ],
    Sales: [
        'Sales account planning',
        'Meeting notes',
        'Sales portal'
    ],
    Design: [
        'Design decision',
        'Meeting notes',
        'Design sprint'
    ],
    'Project management': [
        'Project plan',
        'Meeting notes',
        'Project status report'
    ],
    'IT support': [
        'Troubleshooting article',
        'Meeting notes',
        'ITSM runbook'
    ]
};
const $d8ff577dc849af37$export$18a5b6d9b6e10951 = {
    Brainstorming: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).brainstormingTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($4392621abe69b953$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($67e1b265c54e2397$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($7c44d98f2ce80fa6$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($d3619229f78a3f42$exports)))
            }
        }
    },
    'Business status update': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).businesStatusUpdateTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($85a919892eb4d84a$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($c077e40dc9aabac0$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($d2e5c6575592daa8$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($cf28e58ca0204494$exports)))
            }
        }
    },
    'DACI: Decision documentation': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).DACIDecisionDocumentTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($9dd8fb39916d123f$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($80f3554cd55d11ee$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($e041ccfe7342b9f1$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($e01cb0f4e35e0256$exports)))
            }
        }
    },
    'Design decision': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).designDecisionTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($adfb30cd378a71c8$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($019d57760f62f149$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($82a20256e8bac3ff$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($d216864a8f19b6d3$exports)))
            }
        }
    },
    'Design sprint': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).designSprintTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($69383ee2456b9f5c$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($a96b5c83c7c9ee26$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($4cdba2501835fb92$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($33f2011447c761cd$exports)))
            }
        }
    },
    'Employee handbook': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).employeeHandbookTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($11c92e15ef222d17$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($9dfc97e380eef4ae$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($23d499320706e9dd$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($8827fbf78bb09a3f$exports)))
            }
        }
    },
    'Fundraising database': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:fundraising-database-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).fundraisingDatabaseTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($e73f4e0fb9420563$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($40f74ccc3e5e5ebf$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($8115584b71ad6b34$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($252b508e60e81e78$exports)))
            }
        }
    },
    'Hiring Process Template': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).hiringProcessTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($3d4e75fc04469d0a$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($703480c6c1f11297$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($22d70e35084ccfba$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($54fda51d89da9313$exports)))
            }
        }
    },
    'ITSM runbook': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).ITSMRunbookTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($5e73d83ce559a68b$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($98cf534c08d87a5e$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($efd12af1051263cc$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($255e1f0d9cd1620a$exports)))
            }
        }
    },
    'Marketing campaign': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).marketingCampaignTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($7e5f3cf9e6fc0afb$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($6293a1a6c443799d$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($b2472dd8fe31846e$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($28963e653cacdd6d$exports)))
            }
        }
    },
    'Marketing plan': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).marketingPlanTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($66664187cf128435$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($6379b6fd8b6cdac1$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($deb2d54df1033035$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($1f3b8781f3cc8cf6$exports)))
            }
        }
    },
    'Meeting notes': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).meetingNotesTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($bc8686804f8b8dc0$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($10d8ba13d8f13371$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($906975d8f9cea568$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($bfc8e328d23fa0ab$exports)))
            }
        }
    },
    'Product Requirements': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).productRequirementsTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($6c30a3e17b19299f$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($c070b4951fa044b4$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($395ed034d2b0f22c$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($dd97f811a0c5d5a8$exports)))
            }
        }
    },
    'Project plan': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).projectPlanTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($b9715a92a16b3e8f$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($6d18d0481e528a05$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($4e2cc57b6d27098b$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($cf2773701a4c0368$exports)))
            }
        }
    },
    'Project status report': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).projectStatusTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($b29e8f42600397f6$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($634b93063fdf34bc$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($1e112a5d4bc79485$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($eab0b91717991a96$exports)))
            }
        }
    },
    Retrospective: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).retrospectiveTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($f0e73592c99f8acd$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($fca08ae507a4df2d$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($80f0edb550be670c$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($eb81cca049bc2104$exports)))
            }
        }
    },
    'Sales account planning': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).salesAccountPlanningTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($8fc19fe69bc4106c$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($c6b28e7a2bdd6bfb$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($aaffd15eaa6c65d5$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($6682b35e7e88a40d$exports)))
            }
        }
    },
    'Sales portal': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).salesPortalTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($f64f324c9b1e7b4a$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($48758013a23af4d1$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($893424cf034868bd$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($2df6c13e6c7c9398$exports)))
            }
        }
    },
    'Software Architecture Review': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).softwareArchitectureReviewTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($1de9cf356e4bda52$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($2f1e3c1c4fb0bf3e$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($8fcc2cc6662ba220$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($b6ac790d527ee68a$exports)))
            }
        }
    },
    'Standard Operating Procedure (SOP) Template': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).standardOperatingProcedureTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($d24c4c30304a8307$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($e654f1d3a2087284$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($bec357e7d088a566$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($2530e99155f28d5a$exports)))
            }
        }
    },
    'Troubleshooting article': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint',
        name: (0, $47eb490faf71feb2$export$a7357cdd1f0b0168).troubleshootingArticleTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($53bde8978e73ceaa$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($64411924b1c80ea8$exports)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($7fdf62e52c226d49$exports))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($288ef0fa7c4a07c1$exports)))
            }
        }
    }
};
module.exports["DEFAULT_TEMPLATES"] = $d8ff577dc849af37$export$d5b92d67f1b42228;
module.exports["TEMPLATES_FOR_TEAM_TYPE"] = $d8ff577dc849af37$export$52608caa2693c2d2;
module.exports["TEMPLATE_DETAILS"] = $d8ff577dc849af37$export$18a5b6d9b6e10951;

});

parcelRegister("dE3yd", function(module, exports) {

var $lvvx5 = parcelRequire("lvvx5");

var $cFEpk = parcelRequire("cFEpk");

const $49d42e0354c3a49f$export$29f82b09627f4ff0 = (timestamp)=>{
    if (!timestamp || timestamp.trim() === '') return false;
    const timestampDate = new Date(timestamp);
    if (!(0, $cFEpk.default)(timestampDate)) return false;
    return (0, $lvvx5.default)(new Date(), timestampDate) < 1;
};
module.exports["isWithinLastWeek"] = $49d42e0354c3a49f$export$29f82b09627f4ff0;

});

parcelRegister("lvvx5", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa84f3f15ff2b5dc$export$2e2bcd8739ae039);

var $917iu = parcelRequire("917iu");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $fa84f3f15ff2b5dc$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $917iu.default)(dateLeft, dateRight) / 7;
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("fDlC6", function(module, exports) {

var $9KolL = parcelRequire("9KolL");


var $bxEVw = parcelRequire("bxEVw");

const $7074b9818e0cdece$export$3d370c33621572df = 'cohort';
var $7074b9818e0cdece$export$9597a1504e32193b = /*#__PURE__*/ function(BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS) {
    BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS["NOT_ENROLLED"] = "not-enrolled";
    BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS["CONTROL"] = "control";
    BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS["VARIANT1"] = "variant1";
    BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS["VARIANT2"] = "variant2";
    return BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS;
}({});
var $7074b9818e0cdece$export$ffc89054ddebf9 = /*#__PURE__*/ function(BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS) {
    BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS["NOT_ENROLLED"] = "not-enrolled";
    BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS["CONTROL"] = "control";
    BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS["TEST"] = "test";
    return BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS;
}({});
const $7074b9818e0cdece$var$TABLE = (shouldTableBeFullWidth = false)=>({
        id: 'Table',
        testId: 'table-quick-action',
        name: {
            ...(0, $bxEVw.i18n).tableName
        },
        alt: {
            ...(0, $bxEVw.i18n).tableAltText
        },
        type: 'document',
        shortName: 'table',
        onClick: (editorView, editorApi, setLocalIdForOnboarding)=>{
            if (!editorView || !editorApi || !setLocalIdForOnboarding) return;
            // find inserted table node's local id
            const tableInfo = (0, $9KolL.getSelectedTableInfo)(editorView.state.selection);
            if (!tableInfo) return;
            const { table: table } = tableInfo;
            const localId = table?.node.attrs.localId;
            setLocalIdForOnboarding(localId);
        },
        adf: [
            {
                type: 'table',
                attrs: {
                    layout: 'default',
                    width: shouldTableBeFullWidth ? 1800 : 760
                },
                content: [
                    {
                        type: 'tableRow',
                        content: [
                            {
                                type: 'tableHeader',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            },
                            {
                                type: 'tableHeader',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            },
                            {
                                type: 'tableHeader',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'tableRow',
                        content: [
                            {
                                type: 'tableCell',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            },
                            {
                                type: 'tableCell',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            },
                            {
                                type: 'tableCell',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'tableRow',
                        content: [
                            {
                                type: 'tableCell',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            },
                            {
                                type: 'tableCell',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            },
                            {
                                type: 'tableCell',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    });
const $7074b9818e0cdece$var$INFO_PANEL = {
    id: 'InfoPanel',
    testId: 'info-panel-quick-action',
    name: {
        ...(0, $bxEVw.i18n).infoPanelName
    },
    alt: {
        ...(0, $bxEVw.i18n).infoPanelAltText
    },
    type: 'document',
    shortName: 'panel',
    adf: [
        {
            type: 'panel',
            attrs: {
                panelType: 'info'
            },
            content: [
                {
                    type: 'paragraph'
                }
            ]
        }
    ]
};
const $7074b9818e0cdece$export$3d2accbe7ffa0024 = {
    id: 'StartWithAI',
    testId: 'start-with-ai-quick-action',
    name: (0, $bxEVw.i18n).startWithAI,
    alt: (0, $bxEVw.i18n).startWithAI,
    type: 'plugin',
    shortName: 'ai',
    onClick: (_editorView, editorApi, _setLocalIdForOnboarding)=>{
        editorApi?.aiExperience?.actions?.openAIModal({
            invokedFrom: 'blankPageQuickActions'
        });
    },
    adf: []
};
const $7074b9818e0cdece$var$TABLE_OF_CONTENTS = {
    id: 'TableOfContents',
    testId: 'table-of-contents-quick-action',
    name: {
        ...(0, $bxEVw.i18n).tableOfContentsName
    },
    alt: {
        ...(0, $bxEVw.i18n).tableOfContentsAltText
    },
    title: {
        ...(0, $bxEVw.i18n).tableOfContentsTitle
    },
    type: 'macro',
    shortName: 'toc',
    adf: [
        {
            type: 'extension',
            attrs: {
                layout: 'default',
                extensionType: 'com.atlassian.confluence.macro.core',
                extensionKey: 'toc',
                parameters: {
                    macroParams: {
                        style: {
                            value: 'none'
                        }
                    },
                    macroMetadata: {
                        schemaVersion: {
                            value: '1'
                        },
                        title: 'Table of Contents'
                    }
                }
            }
        }
    ]
};
const $7074b9818e0cdece$export$2525a2a8fd05dd3 = {
    id: 'ShowMore'
};
const $7074b9818e0cdece$export$c23518f40bf2594 = (shouldTableBeFullWidth = false)=>[
        $7074b9818e0cdece$var$TABLE(shouldTableBeFullWidth),
        $7074b9818e0cdece$var$INFO_PANEL,
        $7074b9818e0cdece$var$TABLE_OF_CONTENTS
    ];
var $7074b9818e0cdece$export$4a7d3275dddb1c6d = /*#__PURE__*/ function(BPQA_TOP_TEMPLATE_KEYS) {
    BPQA_TOP_TEMPLATE_KEYS["HOW_TO_ARTICLE"] = "com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint";
    BPQA_TOP_TEMPLATE_KEYS["PRODUCT_REQUIREMENTS"] = "com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint";
    BPQA_TOP_TEMPLATE_KEYS["PROJECT_PLAN"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint";
    BPQA_TOP_TEMPLATE_KEYS["RETROSPECTIVE"] = "com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint";
    BPQA_TOP_TEMPLATE_KEYS["PRODUCT_ROADMAP"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint";
    BPQA_TOP_TEMPLATE_KEYS["WEEKLY_MEETING_NOTES"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-blueprint";
    BPQA_TOP_TEMPLATE_KEYS["DECISIONS"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint";
    BPQA_TOP_TEMPLATE_KEYS["FILE_LIST"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:file-list-blueprint";
    return BPQA_TOP_TEMPLATE_KEYS;
}({});
var $7074b9818e0cdece$export$bead38a319d5af74 = /*#__PURE__*/ function(BPQA_EXCLUDED_TEMPLATE_KEYS) {
    // blog post is the one itemModuleCompleteKey because
    // it has no blueprintModuleCompleteKey
    BPQA_EXCLUDED_TEMPLATE_KEYS["BLOG_POST"] = "com.atlassian.confluence.plugins.confluence-create-content-plugin:create-blog-post";
    BPQA_EXCLUDED_TEMPLATE_KEYS["LEGACY_EDITOR"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:tinyeditor-blueprint";
    return BPQA_EXCLUDED_TEMPLATE_KEYS;
}({});
const $7074b9818e0cdece$export$3d118b17c778eb8a = 3 + Object.keys($7074b9818e0cdece$export$bead38a319d5af74).length; // Number of templates to show + possible exclusions
const $7074b9818e0cdece$export$3e62b34d6fa050da = 3;
const $7074b9818e0cdece$export$52c9019030c737ed = 250;
module.exports["START_WITH_AI"] = $7074b9818e0cdece$export$3d2accbe7ffa0024;
module.exports["SHOW_MORE_ELEMENTS"] = $7074b9818e0cdece$export$2525a2a8fd05dd3;
module.exports["QUICK_ACTIONS"] = $7074b9818e0cdece$export$c23518f40bf2594;
module.exports["BPQA_TOP_TEMPLATE_KEYS"] = $7074b9818e0cdece$export$4a7d3275dddb1c6d;
module.exports["BPQA_EXCLUDED_TEMPLATE_KEYS"] = $7074b9818e0cdece$export$bead38a319d5af74;
module.exports["TEMPLATE_LIMIT"] = $7074b9818e0cdece$export$3d118b17c778eb8a;
module.exports["TEMPLATE_SKELETONS"] = $7074b9818e0cdece$export$3e62b34d6fa050da;
module.exports["TEMPLATE_PREVIEW_DELAY"] = $7074b9818e0cdece$export$52c9019030c737ed;

});

parcelRegister("bxEVw", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $bda044cad4f1d661$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    allTemplates: {
        id: "blank-page-quick-actions.allTemplates",
        defaultMessage: "All templates"
    },
    moreElements: {
        id: "blank-page-quick-actions.moreElements",
        defaultMessage: "More elements"
    },
    helperText: {
        id: "blank-page-quick-actions.helperText",
        defaultMessage: "Select an element to get started, or just type"
    },
    brainstormName: {
        id: "blank-page-quick-actions.brainstormName",
        defaultMessage: "Brainstorm"
    },
    brainstormDescription: {
        id: "blank-page-quick-actions.brainstormDescription",
        defaultMessage: "Use Brainstorm to insert content"
    },
    brainstormAltText: {
        id: "blank-page-quick-actions.brainstormAltText",
        defaultMessage: "Use Brainstorm to insert content"
    },
    startWithAI: {
        id: "blank-page-quick-actions.startWithAI",
        defaultMessage: "Start with AI"
    },
    tableName: {
        id: "blank-page-quick-actions.tableName",
        defaultMessage: "Table"
    },
    tableDescription: {
        id: "blank-page-quick-actions.tableDescription",
        defaultMessage: "Insert a table"
    },
    tableAltText: {
        id: "blank-page-quick-actions.tableAltText",
        defaultMessage: "Insert a table"
    },
    infoPanelName: {
        id: "blank-page-quick-actions.infoPanelName",
        defaultMessage: "Info panel"
    },
    infoPanelDescription: {
        id: "blank-page-quick-actions.infoPanelDescription",
        defaultMessage: "Highlight information in a colored panel"
    },
    infoPanelAltText: {
        id: "blank-page-quick-actions.infoPanelAltText",
        defaultMessage: "Insert an info panel to highlight information in a colored panel"
    },
    tableOfContentsName: {
        id: "blank-page-quick-actions.tableOfContentsName",
        defaultMessage: "Table of contents"
    },
    tableOfContentsDescription: {
        id: "blank-page-quick-actions.tableOfContentsDescription",
        defaultMessage: "Create a table of contents based on your content\u2019s headings"
    },
    tableOfContentsAltText: {
        id: "blank-page-quick-actions.tableOfContentsAltText",
        defaultMessage: "Insert a table of contents"
    },
    tableOfContentsTitle: {
        id: "blank-page-quick-actions.tableOfContentsTitle",
        defaultMessage: "Table of Contents"
    },
    templateLoadError: {
        id: "blank-page-quick-actions.templateLoadError",
        defaultMessage: "We\u2019re having trouble loading suggested templates - refresh, or go to <button>all templates.</button>"
    },
    templateSuccessFlagTitle: {
        id: "blank-page-quick-actions.templateSuccessFlagTitle",
        defaultMessage: "\u201C{templateName}\u201D template chosen"
    },
    templateSuccessFlagDescription: {
        id: "blank-page-quick-actions.templateSuccessFlagDescription",
        defaultMessage: "You can change templates any time."
    },
    templateSuccessFlagBrowserOtherTemplatesLink: {
        id: "blank-page-quick-actions.templateSuccessFlagBrowserOtherTemplatesLink",
        defaultMessage: "Browse other templates"
    },
    templateSuccessFlagClearEditorLink: {
        id: "blank-page-quick-actions.templateSuccessFlagClearEditorLink",
        defaultMessage: "Clear all"
    },
    revampedBpqaTemplatePrefix: {
        id: "blank-page-quick-actions.revampedBpqaTemplatePrefix",
        defaultMessage: "For you:"
    }
});
module.exports["i18n"] = $bda044cad4f1d661$export$a7357cdd1f0b0168;

});

parcelRegister("lG7DR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $4kvYv = parcelRequire("4kvYv");


var $30D0J = parcelRequire("30D0J");


var $gxTpP = parcelRequire("gxTpP");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");


var $2FNNv = parcelRequire("2FNNv");


var $4krqA = parcelRequire("4krqA");


var $9DBk6 = parcelRequire("9DBk6");

const $4eb4c2cd5aab6b56$var$CONFLUENCE_KEY = 'confluence';
const $4eb4c2cd5aab6b56$export$8334391e845b66cf = ()=>{
    const [isEligibleTag, setIsEligibleTag] = (0, $42omo.useState)(false);
    // Contexts and hooks
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    // Onboarding state
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $gxTpP.CONTEXTUAL_INVITE_NUDGE).EXPERIMENT_ELIGIBLE_TAG,
        (0, $gxTpP.CONTEXTUAL_INVITE_NUDGE).WAS_CONFETTI_SEEN,
        (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).HAS_USER_PUBLISHED,
        (0, $9DBk6.LIVE_PAGE_NUDGE).LIVE_PAGE_CONTEXTUAL_NUDGE_SEEN
    ], !(0, $9wGTI.fg)('cc_onboarding_experience'));
    const onboardingState = (0, $ivb8S.deserializeState)(onboardingStateData);
    const { contextualInviteNudgeEligibleTag: contextualInviteNudgeEligibleTag, hasUserPublished: hasUserPublished, wasLivePageNudgeSeen: wasLivePageNudgeSeen } = onboardingState;
    const skip = !isLicensed || onboardingStateLoading || Boolean(contextualInviteNudgeEligibleTag) || Boolean(hasUserPublished) || Boolean(wasLivePageNudgeSeen) || !(0, $9wGTI.fg)('cc_onboarding_experience');
    const userPersonalizationQueryArgs = {
        variables: {
            userId: userId ?? ''
        },
        skip: skip
    };
    // User personalization query for isEstablishedUser
    const { data: userPersonalizationQueryData, loading: userPersonalizationQueryLoading, error: userPersonalizationQueryError } = (0, $6mKj3.expValEquals)('confluence_deprecate_experimental_personalization', 'isEnabled', true) ? (0, $30D0J.useExperimentalUserPersonalizationQuery)(userPersonalizationQueryArgs) : (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $4kvYv.UserPersonalizationQuery), userPersonalizationQueryArgs);
    const attributes = userPersonalizationQueryData?.experimentalUserPersonalization?.attributes ?? [];
    const isEstablishedUser = attributes.find((attr)=>attr?.name === isEstablishedUserTraitName)?.value === 'true';
    // Combined loading and error states
    const loading = userPersonalizationQueryLoading || onboardingStateLoading;
    const error = userPersonalizationQueryError || onboardingStateError;
    (0, $42omo.useEffect)(()=>{
        if (skip || loading || error || isEstablishedUser) return;
        const fetchInvitePermsAndSetEligibility = async ()=>{
            const response = await (0, $4krqA.memoizedGetInvitePermissions)(cloudId);
            if (response instanceof Error) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'editorOrViewPage',
                    action: 'failed',
                    actionSubject: 'getInvitePermissions',
                    attributes: {
                        message: response?.message
                    }
                }
            }).fire();
            const canInviteToConfluence = [
                ...response?.directInvite ?? [],
                ...response?.invitePendingApproval ?? []
            ].some((item)=>item.includes($4eb4c2cd5aab6b56$var$CONFLUENCE_KEY));
            if (canInviteToConfluence) {
                setOnboardingState({
                    key: (0, $gxTpP.CONTEXTUAL_INVITE_NUDGE).EXPERIMENT_ELIGIBLE_TAG,
                    value: 'true'
                });
                setIsEligibleTag(true);
            }
        };
        fetchInvitePermsAndSetEligibility();
    }, [
        error,
        loading,
        skip,
        cloudId,
        contextualInviteNudgeEligibleTag,
        isEstablishedUser,
        setOnboardingState,
        createAnalyticsEvent
    ]);
    return {
        contextualInviteNudgeEligibleTag: Boolean(isEligibleTag || contextualInviteNudgeEligibleTag),
        onboardingState: onboardingState
    };
};
module.exports["useContextualInviteNudge"] = $4eb4c2cd5aab6b56$export$8334391e845b66cf;

});

parcelRegister("4kvYv", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $add7c7c099668999$export$87c8216babb705a0 = // eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
(0, $eSUdr.default)`query PersonalizationQuery($userId:String!)@experimental{experimentalUserPersonalization(userId:$userId){attributes{name value}}}`;
module.exports["UserPersonalizationQuery"] = $add7c7c099668999$export$87c8216babb705a0;

});

parcelRegister("30D0J", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $0f856dd8e4045e89$export$241fc4ad38d78de1 = ({ skip: skip, onError: onError, variables: variables })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`,
        method: 'GET',
        parseResult: (response)=>({
                experimentalUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(response.attributes)
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables
    });
};
module.exports["useExperimentalUserPersonalizationQuery"] = $0f856dd8e4045e89$export$241fc4ad38d78de1;

});

parcelRegister("2FNNv", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");

// Production trait: https://data-portal.internal.atlassian.com/targeting/traits/f0c5d949-91be-46e0-b440-7d7a953c9159
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME = 'confluence_is_established_user';
// Staging trait: https://data-portal-stg.internal.atlassian.com/targeting/traits/4015e85e-221b-4d95-a945-c68548e21a8b
// NOTE: DO NOT USE Staging trait named as `confluence_is_established_user` - this is a legacy trait created with wrong evaluation type and won't work for staging
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING = 'confluence_is_established_user_stg';
const $f30477d177bb95bd$export$a284916a4d5ed017 = ()=>{
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    if (environment !== 'PRODUCTION') return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING;
    return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME;
};
module.exports["useIsEstablishedUserTraitName"] = $f30477d177bb95bd$export$a284916a4d5ed017;

});

parcelRegister("4krqA", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $f7B1p = parcelRequire("f7B1p");

const $205c154f2fef63b0$export$ab2f49a861856bab = '/gateway/api';
const $205c154f2fef63b0$export$df4d1d71f09676b7 = '/v3/invitations/capabilities';
function $205c154f2fef63b0$var$handleCapabilitiesResponse(response) {
    const directInvite = new Set();
    const invitePendingApproval = new Set();
    if (Array.isArray(response)) response.forEach((entry)=>{
        if (!directInvite.has(entry.resourceARI) && 'NONE' !== entry.directInvite.mode) directInvite.add(entry.resourceARI);
        if (!invitePendingApproval.has(entry.resourceARI) && 'NONE' !== entry.invitePendingApproval.mode) invitePendingApproval.add(entry.resourceARI);
    });
    return {
        directInvite: [
            ...directInvite
        ],
        invitePendingApproval: [
            ...invitePendingApproval
        ]
    };
}
// This closely follows the implementation of the client from the Invite People package
// platform/packages/people-and-teams/invite-people/src/clients/InviteApiClient.ts
// This logic is subject to change at any time and should only be used for experimental purposes
const $205c154f2fef63b0$var$getInvitePermissions = async (cloudId)=>{
    const resource = `ari:cloud:platform::site/${cloudId}`;
    try {
        const response = await (0, $f7B1p.cfetch)(`${$205c154f2fef63b0$export$ab2f49a861856bab}${$205c154f2fef63b0$export$df4d1d71f09676b7}?resource=${resource}`);
        const inviteResponse = await response.json();
        return $205c154f2fef63b0$var$handleCapabilitiesResponse(inviteResponse);
    } catch (error) {
        return error;
    }
};
const $205c154f2fef63b0$export$669226fe425132b5 = (0, $2XqLN.default)($205c154f2fef63b0$var$getInvitePermissions);
module.exports["memoizedGetInvitePermissions"] = $205c154f2fef63b0$export$669226fe425132b5;

});

parcelRegister("bFMG7", function(module, exports) {

var $5dyIT = parcelRequire("5dyIT");


var $cod3r = parcelRequire("cod3r");


var $79mss = parcelRequire("79mss");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $e4o8D = parcelRequire("e4o8D");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $86okN = parcelRequire("86okN");


var $1cYlh = parcelRequire("1cYlh");


var $in5LX = parcelRequire("in5LX");


var $kknEZ = parcelRequire("kknEZ");


var $gSfo4 = parcelRequire("gSfo4");


var $fcQxC = parcelRequire("fcQxC");


var $lwZTW = parcelRequire("lwZTW");


var $9wGTI = parcelRequire("9wGTI");

const $8f8b1f599c43d665$var$useContentClassificationContentDataClassificationQuery = (0, $79mss.default);
const $8f8b1f599c43d665$export$160e6dbb5cf9582 = ({ flagStatus: flagStatus, submittedClassification: submittedClassification, setClassification: setClassification, setFlagStatus: setFlagStatus })=>{
    // Updates the classification state with the value of submittedClassification
    // on flag success, ensuring consistent behavior across edit tag & edit modal
    (0, $42omo.useEffect)(()=>{
        if (flagStatus === (0, $in5LX.FlagStatus).SUCCESS) {
            setClassification(submittedClassification ?? null);
            setFlagStatus((0, $in5LX.FlagStatus).NONE);
        }
    }, [
        flagStatus,
        submittedClassification,
        setClassification,
        setFlagStatus
    ]);
};
const $8f8b1f599c43d665$export$e948ce957637ade5 = ({ contentId: contentId, contentStatusContext: contentStatusContext = 'current-only', shouldSkipQueries: shouldSkipQueries = false, shouldPreloadData: shouldPreloadData = false, shouldReadFromQueries: shouldReadFromQueries = false })=>{
    const shouldPreloadContentClassificationData = window.__SSR_RENDERED__ || shouldPreloadData;
    const [flagStatus, setFlagStatus] = (0, $42omo.useState)((0, $in5LX.FlagStatus).NONE);
    const [classification, setClassification] = (0, $42omo.useState)(null);
    const [currentContentId, setCurrentContentId] = (0, $42omo.useState)(undefined);
    const [submittedClassification, setSubmittedClassification] = (0, $42omo.useState)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
    $8f8b1f599c43d665$export$160e6dbb5cf9582({
        flagStatus: flagStatus,
        submittedClassification: submittedClassification,
        setClassification: setClassification,
        setFlagStatus: setFlagStatus
    });
    // The following two mutation functions are returned by this hook, behavior upon completion is handled within the hook
    const [updateContentDataClassificationLevel] = (0, $308Wd.useMutationInterop)((0, $cod3r.default), {
        awaitRefetchQueries: true,
        onError: (updateClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(updateClassificationError);
        },
        onCompleted: (data)=>{
            if (data?.bulkUpdateContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        },
        refetchQueries: ()=>[
                {
                    query: (0, $86okN.toDocumentNode)($8f8b1f599c43d665$var$useContentClassificationContentDataClassificationQuery),
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ]
    });
    const [deleteContentDataClassificationLevel, { loading: deleteLoading }] = (0, $308Wd.useMutationInterop)((0, $5dyIT.default), {
        awaitRefetchQueries: true,
        onError: (deleteClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(deleteClassificationError);
        },
        onCompleted: (data)=>{
            if (data?.bulkDeleteContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        },
        refetchQueries: ()=>[
                {
                    query: (0, $86okN.toDocumentNode)($8f8b1f599c43d665$var$useContentClassificationContentDataClassificationQuery),
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ]
    });
    const shouldSkipQueriesForClassification = shouldSkipQueries || !contentId;
    const { data: objectLevelData, loading: objectLevelLoading, error: objectLevelError } = (0, $jMyy4.useQueryInterop)($8f8b1f599c43d665$var$useContentClassificationContentDataClassificationQuery, {
        variables: {
            contentId: contentId ?? '',
            lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
        },
        skip: shouldSkipQueriesForClassification,
        errorPolicy: 'all',
        fetchPolicy: shouldPreloadContentClassificationData ? 'cache-first' : 'network-only'
    });
    const classificationLevelDetails = objectLevelData?.singleContent?.classificationLevelDetails;
    const contentClassification = classificationLevelDetails?.classificationLevel;
    const contentLevelLoading = objectLevelLoading;
    const contentLevelError = objectLevelError;
    const spaceDefaultIsOverridden = classificationLevelDetails?.source === 'CONTENT';
    const errorState = (0, $lwZTW.useClassificationErrorState)(classification, undefined, contentLevelError);
    // Determine whether to set classification either content level classification, or space default classification, or null through a series of booleans.
    // Cases where we should not display content classification:
    // 1. If "No classification" option is selected as content classification
    // 2. If content classification was archived
    // 3. If classification value from state hook is null (i.e. classification was deleted) and delete mutation is still loading
    // 4. If delete was successful and classification value from state hook is null
    // 5. If there was an error fetching content level classification
    const shouldNotDisplayContentClassification = contentClassification?.id === (0, $1cYlh.NO_CLASSIFICATION_OPTION_ID) || contentClassification?.status === (0, $kknEZ.Status).ARCHIVED || classification === null && deleteLoading || Boolean(contentLevelError);
    // This ternary determines whether to display content classification value from query or from state hook.
    // Checks whether content ID has changed since the last render, and if it has then we display the classification value from query.
    // (Resolves bug where classification wasn't properly updating when navigating between pages via page tree)
    const contentClassificationFromQueryOrState = shouldReadFromQueries ? contentClassification : currentContentId === contentId && !!classification ? classification : contentClassification;
    // Ultimately, we'll be displaying one of the two values as a content's current classification (in order of priority):
    // 1. Content level classification
    // 2. No classification (may render Add Classification button instead)
    const updatedClassification = shouldNotDisplayContentClassification ? null : contentClassificationFromQueryOrState;
    (0, $42omo.useEffect)(()=>{
        if (updatedClassification !== classification) {
            setClassification(updatedClassification ?? null);
            setCurrentContentId(contentId);
        }
    }, [
        updatedClassification,
        classification,
        contentId
    ]);
    const isClassificationPublished = classification?.status === (0, $kknEZ.Status).PUBLISHED || updatedClassification?.status === (0, $kknEZ.Status).PUBLISHED;
    const classificationFeatureEnabled = Boolean(objectLevelData?.singleContent?.classificationLevelDetails?.featureEnabled);
    const shouldDisplayClassification = classificationFeatureEnabled && (!!classification || !!updatedClassification) && !contentLevelLoading && isClassificationPublished;
    const hasNoClassification = !contentLevelLoading && !classification && !updatedClassification;
    const isReclassificationPermitted = (objectLevelData?.singleContent?.classificationLevelDetails?.isReclassificationPermitted ?? false) || !(0, $9wGTI.fg)('dlp_classification_access');
    //useEffect is not run during SSR, so we can't use classification from the state.
    //we cant use setClassification either as it causes side effects which causes unnecessary re-renders.
    //Instead, we can use updatedClassification for initial load for SSR.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSRedWithClassification = renderServerPlaceholder && updatedClassification;
    const classificationValue = isSSRedWithClassification ? updatedClassification ?? null : classification ?? updatedClassification ?? null;
    return (0, $42omo.useMemo)(()=>({
            classification: classificationValue ?? null,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            contentLevelLoading: contentLevelLoading,
            contentLevelError: contentLevelError,
            updateContentDataClassificationLevel: updateContentDataClassificationLevel,
            deleteContentDataClassificationLevel: deleteContentDataClassificationLevel,
            setSubmittedClassification: setSubmittedClassification,
            flagStatus: flagStatus,
            setFlagStatus: setFlagStatus,
            errorState: errorState,
            shouldDisplayClassification: shouldDisplayClassification,
            hasNoClassification: hasNoClassification,
            contentStatusContext: contentStatusContext,
            featureEnabled: classificationFeatureEnabled,
            isReclassificationPermitted: isReclassificationPermitted
        }), [
        classificationValue,
        spaceDefaultIsOverridden,
        contentLevelLoading,
        contentLevelError,
        updateContentDataClassificationLevel,
        deleteContentDataClassificationLevel,
        setSubmittedClassification,
        flagStatus,
        setFlagStatus,
        errorState,
        shouldDisplayClassification,
        hasNoClassification,
        contentStatusContext,
        classificationFeatureEnabled,
        isReclassificationPermitted
    ]);
};
module.exports["useContentClassification"] = $8f8b1f599c43d665$export$e948ce957637ade5;

});

parcelRegister("5dyIT", function(module, exports) {
/**
 * @generated SignedSource<<7ddda2a4b17eec333f90d2ef9c5f2022>>
 * @relayHash ee02cd6160cc1cfee6fa6d1fba84a159
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2
const $916e4ca779bc282e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatuses"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentStatuses",
                            "variableName": "contentStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkDeleteContentDataClassificationLevelPayload",
            "kind": "LinkedField",
            "name": "bulkDeleteContentDataClassificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ee02cd6160cc1cfee6fa6d1fba84a159",
            "id": "4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2",
            "metadata": {},
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useContentClassificationBulkDeleteContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!){bulkDeleteContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses}){success,errors{message}}}"
        }
    };
}();
$916e4ca779bc282e$var$node.hash = "482a842e925e6082fc32c6749e95ba4b";
var $916e4ca779bc282e$export$2e2bcd8739ae039 = $916e4ca779bc282e$var$node;
module.exports["default"] = $916e4ca779bc282e$export$2e2bcd8739ae039;

});

parcelRegister("cod3r", function(module, exports) {
/**
 * @generated SignedSource<<9d63004e94947b72a82b1d2926f80d5f>>
 * @relayHash e435d6d2ef1fb5eebfc9d5c505f1e65c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba
const $cca7f8f2e7a5e122$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "classificationLevelId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatuses"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "classificationLevelId",
                            "variableName": "classificationLevelId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatuses",
                            "variableName": "contentStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkUpdateContentDataClassificationLevelPayload",
            "kind": "LinkedField",
            "name": "bulkUpdateContentDataClassificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "e435d6d2ef1fb5eebfc9d5c505f1e65c",
            "id": "c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba",
            "metadata": {},
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useContentClassificationBulkUpdateContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!,$classificationLevelId:ID!){bulkUpdateContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses,classificationLevelId:$classificationLevelId}){success,errors{message}}}"
        }
    };
}();
$cca7f8f2e7a5e122$var$node.hash = "9839fe96ab36e63f6aab91bb7d0d00f7";
var $cca7f8f2e7a5e122$export$2e2bcd8739ae039 = $cca7f8f2e7a5e122$var$node;
module.exports["default"] = $cca7f8f2e7a5e122$export$2e2bcd8739ae039;

});

parcelRegister("79mss", function(module, exports) {
/**
 * @generated SignedSource<<610ef5d59757084c5c735b88bfdb9d49>>
 * @relayHash c33a4203c746101786d53936f44b1619
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4ef10dac3898c01071d9db8da37b88a5e022cc46419c343458d7958799000fd4
const $22165adc85ae14ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "lowerCaseContentStatusArray"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "lowerCaseContentStatusArray"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ClassificationLevelDetails",
                    "kind": "LinkedField",
                    "name": "classificationLevelDetails",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevel",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "guideline"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "color"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "featureEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReclassificationPermitted"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c33a4203c746101786d53936f44b1619",
            "id": "4ef10dac3898c01071d9db8da37b88a5e022cc46419c343458d7958799000fd4",
            "metadata": {},
            "name": "useContentClassificationContentDataClassificationQuery",
            "operationKind": "query",
            "text": "query useContentClassificationContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevel{id,guideline,description,color,name,status},featureEnabled,source,isReclassificationPermitted}}}"
        }
    };
}();
$22165adc85ae14ea$var$node.hash = "677a732ef8b9ed562b6751493462953b";
var $22165adc85ae14ea$export$2e2bcd8739ae039 = $22165adc85ae14ea$var$node;
module.exports["default"] = $22165adc85ae14ea$export$2e2bcd8739ae039;

});

parcelRegister("e4o8D", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $2679ebd914f0a083$export$96e8e9e8e57310bb = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    return renderServerPlaceholder;
} : (renderServerPlaceholderOnNonHydrate = false)=>{
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    !isTransition || Boolean(undefined) : // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    (0, $42omo.useEffect)(()=>{
        setRenderServerPlaceholder(false);
    }, []);
    return renderServerPlaceholder;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("gSfo4", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap = {
    [(0, $7tHGa.ContentStatus).CURRENT]: 'current',
    [(0, $7tHGa.ContentStatus).DRAFT]: 'draft',
    [(0, $7tHGa.ContentStatus).ARCHIVED]: 'archived'
};
const $d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus = (status)=>{
    return $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap[status];
};
const $d569ee9ba15fe187$export$930e5fd4dd47a5f1 = (statuses)=>{
    return statuses.map((status)=>$d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus(status)).filter(Boolean);
};
module.exports["getQuerySingleContentStatusArrayVariable"] = $d569ee9ba15fe187$export$930e5fd4dd47a5f1;

});

parcelRegister("lwZTW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $79yie = parcelRequire("79yie");

const $68e08446abc76753$export$a992cfb755534ea3 = (currentClassification, spaceLevelError, contentLevelError)=>{
    const [errorState, setErrorState] = (0, $42omo.useState)((0, $79yie.ErrorState).NO_ERROR);
    (0, $42omo.useEffect)(()=>{
        // If error exists, display corresponding components
        if (!currentClassification) {
            if (spaceLevelError || contentLevelError) {
                if ((0, $aMcHK.isStatusCodeError)(contentLevelError, '404') || (0, $aMcHK.isStatusCodeError)(spaceLevelError, '404')) {
                    (0, $7Sm4c.markErrorAsHandled)(contentLevelError);
                    (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                    // If there is a handled error (404), return nothing
                    setErrorState((0, $79yie.ErrorState).NULL);
                } else // If there is an unhandled error (a non-404 error), return error message with error displays
                setErrorState((0, $79yie.ErrorState).MESSAGE);
            }
        } else {
            // If there's a content classification, we don't want to render null nor an error message for a space level error. We'll just mark the error as handled.
            if (spaceLevelError) (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
            setErrorState((0, $79yie.ErrorState).NO_ERROR);
        }
    }, [
        currentClassification,
        spaceLevelError,
        contentLevelError
    ]);
    return errorState;
};
module.exports["useClassificationErrorState"] = $68e08446abc76753$export$a992cfb755534ea3;

});

parcelRegister("79yie", function(module, exports) {
var $b3b9916290115f64$export$c1ed4f415b9e7023 = /*#__PURE__*/ function(ErrorState) {
    ErrorState["NULL"] = "NULL";
    ErrorState["MESSAGE"] = "MESSAGE";
    ErrorState["NO_ERROR"] = "NO_ERROR";
    return ErrorState;
}({});
module.exports["ErrorState"] = $b3b9916290115f64$export$c1ed4f415b9e7023;

});

parcelRegister("l2hqi", function(module, exports) {
var $d6376875f96c1896$export$2df6d049e5bad28e = /*#__PURE__*/ function(InlineCommentMode) {
    InlineCommentMode["EDIT"] = "edit";
    InlineCommentMode["VIEW"] = "view";
    InlineCommentMode["LIVE"] = "live";
    return InlineCommentMode;
}({});
module.exports["InlineCommentMode"] = $d6376875f96c1896$export$2df6d049e5bad28e;

});

parcelRegister("fMO7O", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $3pfAb = parcelRequire("3pfAb");


var $kDuN4 = parcelRequire("kDuN4");

var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $8Lx5S = parcelRequire("8Lx5S");


var $lyF5K = parcelRequire("lyF5K");


var $ftdAe = parcelRequire("ftdAe");


var $dUYlk = parcelRequire("dUYlk");


var $e8W3S = parcelRequire("e8W3S");


var $ebwTS = parcelRequire("ebwTS");

const $f160a6540be71b28$var$TRACK_EVENT = 'sendTrackEvent';
const $f160a6540be71b28$var$ANALYTICS_SOURCE = 'guestAttemptedMention';
const $f160a6540be71b28$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    mentionFlagTitle: {
        id: "external-collab-ui.guest-mention.restricted.flag.title",
        defaultMessage: "You can\u2019t mention people as a guest"
    },
    mentionFlagDescription: {
        id: "external-collab-ui.guest-mention.restricted.flag.description",
        defaultMessage: "To mention people, you need full access to Confluence."
    },
    learnMoreButton: {
        id: "external-collab-ui.guest-mention.learn-more-button",
        defaultMessage: "Learn more"
    },
    flagSuccessTitle: {
        id: "external-collab-ui.guest-request-to-upgrade.flag-success-title",
        defaultMessage: "Licensed user request sent!"
    },
    flagSuccessDescription: {
        id: "external-collab-ui.guest-request-to-upgrade.flag-success-description",
        defaultMessage: "If approved, you\u2019ll get a confirmation message from admin"
    },
    flagErrorTitle: {
        id: "external-collab-ui.guest-request-to-upgrade.flag-error-title",
        defaultMessage: "Request not sent"
    },
    flagErrorDescription: {
        id: "external-collab-ui.guest-request-to-upgrade.flag-error-description",
        defaultMessage: "Refresh the page to resubmit your request, or try again later."
    }
});
const $f160a6540be71b28$var$requestButtonContainerStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.150',
    marginTop: 'space.negative.025'
});
const $f160a6540be71b28$var$learnMoreButtonContainerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.negative.025'
});
const $f160a6540be71b28$export$f9673a1f06bb6e52 = ({ children: children, dialogs: dialogs, flags: flags, suppressListener: suppressListener = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [attemptedMention, setAttemptedMention] = (0, $42omo.useState)(false);
    const [flagNeedsUpdate, setFlagNeedsUpdate] = (0, $42omo.useState)(false);
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const shouldDisplayGuestUpgradeFlow = isGuest && attemptedMention;
    const handleFlagClose = (0, $42omo.useCallback)(()=>{
        flags.hideAllFlags();
        setAttemptedMention(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'flag',
                actionSubjectId: 'guestMentionRequestAccess',
                source: $f160a6540be71b28$var$ANALYTICS_SOURCE,
                attributes: {
                    touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        flags
    ]);
    const showErrorFlag = (0, $42omo.useCallback)((submissionError)=>{
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f160a6540be71b28$export$a7357cdd1f0b0168.flagErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f160a6540be71b28$export$a7357cdd1f0b0168.flagErrorDescription)
        });
        experienceTracker.fail({
            name: (0, $irVI7.SUBMIT_GUEST_MENTIONS_UPGRADE_FLOW_EXPERIENCE),
            error: submissionError
        });
    }, [
        experienceTracker,
        flags
    ]);
    const onGuestUpgradeRequestSubmitted = (0, $42omo.useCallback)(()=>{
        handleFlagClose();
        flags.showSuccessFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f160a6540be71b28$export$a7357cdd1f0b0168.flagSuccessTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f160a6540be71b28$export$a7357cdd1f0b0168.flagSuccessDescription)
        });
        experienceTracker.succeed({
            name: (0, $irVI7.SUBMIT_GUEST_MENTIONS_UPGRADE_FLOW_EXPERIENCE)
        });
    }, [
        experienceTracker,
        flags,
        handleFlagClose
    ]);
    const handleOnSubmit = (error)=>{
        createAnalyticsEvent({
            type: $f160a6540be71b28$var$TRACK_EVENT,
            data: {
                action: !!error ? 'failed' : 'requested',
                actionSubject: 'productAccess',
                source: $f160a6540be71b28$var$ANALYTICS_SOURCE,
                attributes: {
                    touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
                }
            }
        }).fire();
        if (!error) onGuestUpgradeRequestSubmitted();
        else showErrorFlag(error);
    };
    const [submitGuestUpgradeRequest, { loading: guestUpgradeRequestIsLoading, isSubmitted: guestUpgradeSubmitted }] = (0, $e8W3S.useSubmitGuestUpgradeRequest)({
        onCompleted: handleOnSubmit
    });
    const { upgradeStatus: upgradeStatus, loading: permissionLoading } = (0, $lyF5K.useGuestRequestToUpgradeStatus)(!shouldDisplayGuestUpgradeFlow);
    const permissionDenied = upgradeStatus === (0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL;
    const requestPending = guestUpgradeSubmitted || upgradeStatus === (0, $ebwTS.UpgradeStatus).AN_UPGRADE_REQUEST_IS_PENDING;
    (0, $42omo.useEffect)(()=>{
        if (permissionLoading || !shouldDisplayGuestUpgradeFlow) return;
        const submitGuestUpgradeRequestWithAnalytics = (_, analyticsEvent)=>{
            setFlagNeedsUpdate(true);
            const analyticsAttributes = {
                ...analyticsEvent.payload.attributes,
                touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
            };
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    ...analyticsEvent.payload,
                    actionSubjectId: 'submitGuestUpgradeRequest',
                    source: 'guestRequestAccess',
                    attributes: analyticsAttributes
                }
            }).fire();
            experienceTracker.start({
                name: (0, $irVI7.SUBMIT_GUEST_MENTIONS_UPGRADE_FLOW_EXPERIENCE)
            });
            submitGuestUpgradeRequest();
        };
        const handleOnSubmit = (error)=>{
            createAnalyticsEvent({
                type: $f160a6540be71b28$var$TRACK_EVENT,
                data: {
                    action: !!error ? 'failed' : 'requested',
                    actionSubject: 'productAccess',
                    source: $f160a6540be71b28$var$ANALYTICS_SOURCE,
                    attributes: {
                        touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
                    }
                }
            }).fire();
            if (!error) onGuestUpgradeRequestSubmitted();
            else showErrorFlag(error);
        };
        const openLearnMoreModal = (_, analyticsEvent)=>{
            handleFlagClose();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    ...analyticsEvent.payload,
                    actionSubjectId: 'guestUpgradeRequestLearnMore',
                    source: 'guestRequestAccess',
                    attributes: {
                        requested: requestPending
                    }
                }
            }).fire();
            dialogs.showModal((0, $dUYlk.GuestRequestToUpgradeLearnMoreDialogModal), {
                onSubmit: handleOnSubmit,
                requestPending: requestPending,
                analytics: {
                    touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
                }
            });
        };
        const requestUpgradeFlagId = 'guest-request-upgrade-flag';
        if (attemptedMention && flags.state.flags.length === 0) {
            flags.showCustomFlag({
                id: requestUpgradeFlagId,
                title: formatMessage($f160a6540be71b28$export$a7357cdd1f0b0168.mentionFlagTitle),
                description: formatMessage($f160a6540be71b28$export$a7357cdd1f0b0168.mentionFlagDescription),
                isAutoDismiss: false,
                onClose: handleFlagClose,
                actions: permissionDenied ? [] : [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                            xcss: $f160a6540be71b28$var$requestButtonContainerStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ftdAe.GuestRequestUpgradeButton), {
                            appearance: "link",
                            requestPending: requestPending,
                            loading: guestUpgradeRequestIsLoading,
                            onClick: submitGuestUpgradeRequestWithAnalytics
                        }))
                    },
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                            xcss: $f160a6540be71b28$var$learnMoreButtonContainerStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                            appearance: "link",
                            onClick: openLearnMoreModal
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f160a6540be71b28$export$a7357cdd1f0b0168.learnMoreButton)))
                    }
                ]
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'shown',
                    actionSubject: 'button',
                    actionSubjectId: 'submitGuestUpgradeRequest',
                    source: $f160a6540be71b28$var$ANALYTICS_SOURCE,
                    attributes: {
                        touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
                    }
                }
            }).fire();
        } else if (flagNeedsUpdate && guestUpgradeRequestIsLoading && flags.state.flags.length === 1) {
            flags.updateFlag(requestUpgradeFlagId, {
                actions: permissionDenied ? [] : [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                            xcss: $f160a6540be71b28$var$requestButtonContainerStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ftdAe.GuestRequestUpgradeButton), {
                            appearance: "link",
                            requestPending: requestPending,
                            loading: guestUpgradeRequestIsLoading,
                            onClick: submitGuestUpgradeRequestWithAnalytics
                        }))
                    },
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                            xcss: $f160a6540be71b28$var$learnMoreButtonContainerStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                            appearance: "link",
                            onClick: openLearnMoreModal
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f160a6540be71b28$export$a7357cdd1f0b0168.learnMoreButton)))
                    }
                ]
            });
            setFlagNeedsUpdate(false);
        }
    }, [
        attemptedMention,
        createAnalyticsEvent,
        dialogs,
        experienceTracker,
        flags,
        flagNeedsUpdate,
        formatMessage,
        guestUpgradeRequestIsLoading,
        handleFlagClose,
        onGuestUpgradeRequestSubmitted,
        permissionDenied,
        permissionLoading,
        requestPending,
        setFlagNeedsUpdate,
        shouldDisplayGuestUpgradeFlow,
        showErrorFlag,
        submitGuestUpgradeRequest
    ]);
    const handleGuestMentionEvent = (event)=>{
        const { actionSubject: actionSubject, actionSubjectId: actionSubjectId } = event.payload;
        if (actionSubject === 'typeAhead' && actionSubjectId === 'mentionTypeAhead') setTimeout(()=>{
            setAttemptedMention(true);
        }, 5);
    };
    if (!isGuest || suppressListener) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: handleGuestMentionEvent,
        channel: (0, $3pfAb.FabricChannel).editor
    }, children);
};
module.exports["GuestMentionsNotificationsWrapper"] = $f160a6540be71b28$export$f9673a1f06bb6e52;

});

parcelRegister("lyF5K", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $f7B1p = parcelRequire("f7B1p");


var $ebwTS = parcelRequire("ebwTS");

const $14503a2aea2a4136$export$1ee9ed72ffc111c1 = [
    // If a guest has "direct access", they will simply upgrade to a user immediately upon submitting a request without needing admin approval.
    (0, $ebwTS.CapabilityValues).DIRECT_ACCESS,
    // ... otherwise, they have the ability to request access, and wait for admin approval.
    (0, $ebwTS.CapabilityValues).REQUEST_ACCESS
];
const $14503a2aea2a4136$export$3ed095546414dc67 = [
    // The ones a Guest should never get, but technically exist on the endpoint:
    (0, $ebwTS.CapabilityValues).ACCESS_EXISTS,
    (0, $ebwTS.CapabilityValues).APPROVED_REQUEST_EXISTS,
    // The ones we expect to potentially get:
    (0, $ebwTS.CapabilityValues).DENIED_REQUEST_EXISTS,
    (0, $ebwTS.CapabilityValues).FORBIDDEN
];
const $14503a2aea2a4136$export$4e4260b083de0708 = 'product/member';
const $14503a2aea2a4136$export$d3e4104c62036f39 = (skip = false)=>{
    // if skip is true, we are not going to fetch the status, so we're not loading anything and it can be false
    // if skip is false, we are going to fetch the status and invoke API immediately, so loading can be true (same as previous implementation)
    const [loading, setLoading] = (0, $42omo.useState)(!skip);
    const [error, setError] = (0, $42omo.useState)();
    const [upgradeStatus, setUpgradeStatus] = (0, $42omo.useState)(undefined);
    const [upgradeStatusReason, setUpgradeStatusReason] = (0, $42omo.useState)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const fetchGuestUpgradeRequestStatus = (0, $42omo.useCallback)(async ()=>{
        setLoading(true);
        const resource = `ari:cloud:confluence::site/${cloudId}`;
        const params = new URLSearchParams({
            resource: resource
        });
        return (0, $f7B1p.cfetch)(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }).then((response)=>response.json()).then((data)=>{
            const statusArray = data.resultsV2[resource];
            const userCapabilityEntry = statusArray.find((entry)=>entry.role === $14503a2aea2a4136$export$4e4260b083de0708) || {};
            const status = userCapabilityEntry.accessMode;
            setUpgradeStatusReason(status);
            if ($14503a2aea2a4136$export$3ed095546414dc67.includes(status)) setUpgradeStatus((0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL);
            else if (status === (0, $ebwTS.CapabilityValues).PENDING_REQUEST_EXISTS) setUpgradeStatus((0, $ebwTS.UpgradeStatus).AN_UPGRADE_REQUEST_IS_PENDING);
            else if ($14503a2aea2a4136$export$1ee9ed72ffc111c1.includes(status)) setUpgradeStatus((0, $ebwTS.UpgradeStatus).CAN_REQUEST);
            else // We didn't get a valid value
            throw Error(`Did not receive a valid value for the accessMode status: ${status}.`);
        }).catch((caughtError)=>{
            // If anything fails, we just state you're not eligible, because we can't confirm it.
            setUpgradeStatus((0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL);
            setError(caughtError instanceof Error ? caughtError : new Error('Guest request to upgrade status load error', {
                cause: caughtError
            }));
        }).finally(()=>setLoading(false));
    }, [
        cloudId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        fetchGuestUpgradeRequestStatus();
    }, [
        fetchGuestUpgradeRequestStatus,
        skip
    ]);
    return {
        upgradeStatus: upgradeStatus,
        upgradeStatusReason: upgradeStatusReason,
        loading: loading,
        error: error
    };
};
module.exports["useGuestRequestToUpgradeStatus"] = $14503a2aea2a4136$export$d3e4104c62036f39;

});

parcelRegister("ebwTS", function(module, exports) {
const $2f24b685c1e47a17$export$408edfc5a854220e = {
    ACCESS_EXISTS: 'ACCESS_EXISTS',
    DIRECT_ACCESS: 'DIRECT_ACCESS',
    APPROVED_REQUEST_EXISTS: 'APPROVED_REQUEST_EXISTS',
    DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
    FORBIDDEN: 'FORBIDDEN',
    PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
    REQUEST_ACCESS: 'REQUEST_ACCESS'
};
var $2f24b685c1e47a17$export$309264bca7eef03f = /*#__PURE__*/ function(UpgradeStatus) {
    UpgradeStatus["CAN_REQUEST"] = "CAN_REQUEST";
    UpgradeStatus["AN_UPGRADE_REQUEST_IS_PENDING"] = "AN_UPGRADE_REQUEST_IS_PENDING";
    UpgradeStatus["NOT_ELIGIBLE_TO_UPGRADE_AT_ALL"] = "NOT_ELIGIBLE_TO_UPGRADE_AT_ALL";
    return UpgradeStatus;
}({});
module.exports["CapabilityValues"] = $2f24b685c1e47a17$export$408edfc5a854220e;
module.exports["UpgradeStatus"] = $2f24b685c1e47a17$export$309264bca7eef03f;

});

parcelRegister("ftdAe", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $9YwaJ = parcelRequire("9YwaJ");

const $141cc20ec350ae53$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    requestToUpgradeButton: {
        id: "external-collab-ui.guest-request-to-upgrade-page-tree.request-to-upgrade-button",
        defaultMessage: "Request full access"
    },
    requestToUpgradePendingButton: {
        id: "external-collab-ui.guest-request-to-upgrade-page-tree.request-to-upgrade-pending-button",
        defaultMessage: "Request pending approval"
    }
});
const $141cc20ec350ae53$export$2e85b5934aa19199 = ({ appearance: appearance, requestPending: requestPending, loading: loading, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
        appearance: appearance,
        isDisabled: requestPending,
        isLoading: loading,
        onClick: onClick
    }, requestPending ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $141cc20ec350ae53$export$a7357cdd1f0b0168.requestToUpgradePendingButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $141cc20ec350ae53$export$a7357cdd1f0b0168.requestToUpgradeButton));
module.exports["GuestRequestUpgradeButton"] = $141cc20ec350ae53$export$2e85b5934aa19199;

});

parcelRegister("dUYlk", function(module, exports) {
/* GuestRequestToUpgradeLearnMoreModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $7hXDW = parcelRequire("7hXDW");


var $8TTLA = parcelRequire("8TTLA");

var $8o1lj = parcelRequire("8o1lj");


var $eEA8O = parcelRequire("eEA8O");


var $5nBzc = parcelRequire("5nBzc");


var $3sFtD = parcelRequire("3sFtD");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $lsxnT = parcelRequire("lsxnT");


var $7pv6k = parcelRequire("7pv6k");


var $eveQW = parcelRequire("eveQW");


var $ftdAe = parcelRequire("ftdAe");


var $e8W3S = parcelRequire("e8W3S");

const $6f1a718cab8b04f2$var$i18n = (0, $cgtv4.defineMessages)({
    guestRequestToUpgradeLearnMoreModalTitle: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-title",
        defaultMessage: "Request licensed user access to join your teammates"
    },
    guestRequestToUpgradeLearnMoreModalTitleSpacesMenu: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-title-spaces-menu",
        defaultMessage: "Request full access"
    },
    guestRequestToUpgradeLearnMoreModalCopy: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-copy",
        defaultMessage: "You are a guest on this Confluence site. Request licensed user access to unlock new features, and an admin will review your request."
    },
    guestRequestToUpgradeLearnMoreModalCopySpacesMenu: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-copy-spaces-menu",
        defaultMessage: "As a guest, you have limited access to this Confluence site but can request full access to unlock new ways to collaborate."
    },
    guestRequestToUpgradeLearnMoreModalGuestCardTitle: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-title",
        defaultMessage: "Guest"
    },
    guestRequestToUpgradeLearnMoreModalGuestCardTitleLozenge: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-title-lozenge",
        defaultMessage: "YOU"
    },
    guestRequestToUpgradeLearnMoreModalGuestCardCopy: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-copy",
        defaultMessage: "Your admin may further restrict your functionality from these default settings."
    },
    guestRequestToUpgradeLearnMoreModalGuestCardCopySpacesMenu: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-copy-spaces-menu",
        defaultMessage: "Your access is limited to:"
    },
    guestRequestToUpgradeLearnMoreModalGuestCardBenefitRowOne: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-benefit-row-one",
        defaultMessage: "View, create, and edit in this space"
    },
    guestRequestToUpgradeLearnMoreModalGuestCardBenefitRowTwo: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-benefit-row-two",
        defaultMessage: "Leave comments in this space"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardTitle: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-title",
        defaultMessage: "Licensed user"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardTitleSpacesMenu: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-title-spaces-menu",
        defaultMessage: "Full access"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardCopy: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-copy",
        defaultMessage: "Everything in guest plus,"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardCopySpacesMenu: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-copy-spaces-menu",
        defaultMessage: "Unlocks:"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowOne: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-one",
        defaultMessage: "Create your own space"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowTwo: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-two",
        defaultMessage: "View and collaborate in other spaces"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowThree: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-three",
        defaultMessage: "See other people\u2019s profiles"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowFour: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-four",
        defaultMessage: "Mention other people"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowFive: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-five",
        defaultMessage: "Create and join teams"
    },
    guestRequestToUpgradeLearnMoreModalFooterSecondaryButton: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-footer-secondary-button",
        defaultMessage: "Maybe later"
    },
    guestRequestToUpgradeLearnMoreModalFooterSecondaryButtonWhenPrimaryDisabled: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-footer-secondary-button-when-primary-disabled",
        defaultMessage: "Close"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f1a718cab8b04f2$var$ModalHeader = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ejb _1bsb1osq _vchhusvi _y3gn1h6o _ca0qxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f1a718cab8b04f2$var$ModalBody = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f1a718cab8b04f2$var$ModalCopy = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8kzvm _1yt45gjp _p12f1lk4 _vchhusvi _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$ValuePropCardContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp1ejb _1yt45gjp _1e0c1txw _1n261q9c _otyrv77o _dl4n1g80",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$ValuePropCard = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itno8c _2rkog72m _16jlkb7n _1o9zkb7n _i0dl5x59 _vchhusvi _1e0c1txw _2lx21bp4 _1n261g80 _4cvr1y6m _1tke7ivc _16qst7xp",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$CardTitleImage = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8glhf _1bsb1osq _4t3ixncg",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$CardHeader = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8lodh _zulpu2gc _1yt41big _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1osq _vchhusvi _y3gn1h6o _19pkidpf",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$CardContent = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt45gjp _y3gn1e5h",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$CardCopy = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_otyrv47k _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$BenefitRowContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1y6m _otyru2gc",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$GUEST_BENEFITS = [
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardBenefitRowOne
    },
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardBenefitRowTwo
    }
];
const $6f1a718cab8b04f2$var$USER_BENEFITS = [
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowOne,
        highlighted: true
    },
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowTwo,
        highlighted: true
    },
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowThree,
        highlighted: true
    },
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowFour,
        highlighted: true
    },
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowFive,
        highlighted: true
    }
];
const $6f1a718cab8b04f2$var$BenefitRow = ({ highlighted: highlighted = false, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$BenefitRowContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        color: highlighted ? "var(--ds-icon-success, #6A9A23)" : "var(--ds-icon-accent-gray, #7D818A)",
        spacing: "none",
        label: ""
    }), children);
};
const $6f1a718cab8b04f2$var$determineCloseTrigger = (event, analyticsEvent)=>{
    return analyticsEvent.payload.actionSubject === 'button' ? 'closeButton' : analyticsEvent.payload.actionSubject === 'modalDialog' ? event instanceof KeyboardEvent && event.key === 'Escape' ? 'escapeKey' : 'outsideClick' : 'unknown';
};
const $6f1a718cab8b04f2$export$adda263aa585eebf = ({ onSubmit: onSubmit, requestPending: requestPending, closeModal: closeModal, analytics: analytics })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const headerRef = (0, $42omo.useRef)(null);
    const [submitGuestUpgradeRequest, { loading: loading }] = (0, $e8W3S.useSubmitGuestUpgradeRequest)({
        onCompleted: onSubmit
    });
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'guestRequestAccessValuePropModal',
                attributes: {
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        analytics
    ]);
    const scrollToTop = ()=>headerRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    const submitGuestUpgradeRequestWithAnalytics = async (_, analyticsEvent)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                ...analyticsEvent.payload,
                actionSubjectId: 'submitGuestUpgradeRequest',
                source: 'guestRequestAccessValuePropModal',
                attributes: {
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
        experienceTracker.start({
            name: (0, $irVI7.SUBMIT_GUEST_REQUEST_TO_UPGRADE_EXPERIENCE)
        });
        await submitGuestUpgradeRequest();
        closeModal();
    };
    const closeModalWithAnalytics = (event, analyticsEvent)=>{
        closeModal();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'closed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'guestRequestAccessValuePropModal',
                source: 'guestRequestAccessValuePropModal',
                attributes: {
                    requested: requestPending,
                    closeTrigger: $6f1a718cab8b04f2$var$determineCloseTrigger(event, analyticsEvent),
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
    };
    const secondaryButtonCopy = requestPending ? $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalFooterSecondaryButtonWhenPrimaryDisabled : $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalFooterSecondaryButton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: 752,
        onClose: closeModalWithAnalytics,
        onOpenComplete: scrollToTop,
        shouldScrollInViewport: true,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalHeader, {
        ref: headerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "large",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: closeModalWithAnalytics
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCard, {
        className: "first"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7pv6k)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitleLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardCopy)), $6f1a718cab8b04f2$var$GUEST_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), benefit.message))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eveQW)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardCopy)), $6f1a718cab8b04f2$var$USER_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), benefit.message))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: closeModalWithAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), secondaryButtonCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ftdAe.GuestRequestUpgradeButton), {
        appearance: "primary",
        requestPending: requestPending,
        loading: loading,
        onClick: submitGuestUpgradeRequestWithAnalytics
    })));
};
const $6f1a718cab8b04f2$export$c9be8187bfbfd769 = ({ onClose: onClose, onCloseComplete: onCloseComplete, onSubmit: onSubmit, requestPending: requestPending, analytics: analytics, isSpacesMenu: isSpacesMenu = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const headerRef = (0, $42omo.useRef)(null);
    const [submitGuestUpgradeRequest, { loading: loading }] = (0, $e8W3S.useSubmitGuestUpgradeRequest)({
        onCompleted: onSubmit
    });
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'guestRequestAccessValuePropModal',
                attributes: {
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        analytics
    ]);
    const scrollToTop = ()=>headerRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    const submitGuestUpgradeRequestWithAnalytics = async (_, analyticsEvent)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                ...analyticsEvent.payload,
                actionSubjectId: 'submitGuestUpgradeRequest',
                source: 'guestRequestAccessValuePropModal',
                attributes: {
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
        experienceTracker.start({
            name: (0, $irVI7.SUBMIT_GUEST_REQUEST_TO_UPGRADE_EXPERIENCE)
        });
        await submitGuestUpgradeRequest();
        onClose();
    };
    const closeModalWithAnalytics = (event, analyticsEvent)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'closed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'guestRequestAccessValuePropModal',
                source: 'guestRequestAccessValuePropModal',
                attributes: {
                    requested: requestPending,
                    closeTrigger: $6f1a718cab8b04f2$var$determineCloseTrigger(event, analyticsEvent),
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
        onClose();
    };
    const secondaryButtonCopy = requestPending ? $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalFooterSecondaryButtonWhenPrimaryDisabled : $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalFooterSecondaryButton;
    return isSpacesMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: 752,
        onClose: closeModalWithAnalytics,
        onCloseComplete: onCloseComplete,
        onOpenComplete: scrollToTop,
        shouldScrollInViewport: true,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalHeader, {
        ref: headerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "large",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalTitleSpacesMenu), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: closeModalWithAnalytics
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalCopySpacesMenu)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCard, {
        className: "first"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7pv6k)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitleLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardCopySpacesMenu)), $6f1a718cab8b04f2$var$GUEST_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), benefit.message))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eveQW)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardTitleSpacesMenu)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardCopySpacesMenu)), $6f1a718cab8b04f2$var$USER_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), benefit.message))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: closeModalWithAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), secondaryButtonCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ftdAe.GuestRequestUpgradeButton), {
        appearance: "primary",
        requestPending: requestPending,
        loading: loading,
        onClick: submitGuestUpgradeRequestWithAnalytics
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: 752,
        onClose: closeModalWithAnalytics,
        onCloseComplete: onCloseComplete,
        onOpenComplete: scrollToTop,
        shouldScrollInViewport: true,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalHeader, {
        ref: headerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "large",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: closeModalWithAnalytics
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCard, {
        className: "first"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7pv6k)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitleLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardCopy)), $6f1a718cab8b04f2$var$GUEST_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), benefit.message))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eveQW)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardCopy)), $6f1a718cab8b04f2$var$USER_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), benefit.message))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: closeModalWithAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), secondaryButtonCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ftdAe.GuestRequestUpgradeButton), {
        appearance: "primary",
        requestPending: requestPending,
        loading: loading,
        onClick: submitGuestUpgradeRequestWithAnalytics
    })));
};
const $6f1a718cab8b04f2$export$aa10072a5720d721 = (args)=>(closeModal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$export$adda263aa585eebf, {
            ...args,
            closeModal: closeModal
        });
module.exports["GuestRequestToUpgradeLearnMoreModal"] = $6f1a718cab8b04f2$export$adda263aa585eebf;
module.exports["GuestRequestToUpgradeLearnMoreDialogModal"] = $6f1a718cab8b04f2$export$c9be8187bfbfd769;
module.exports["GuestRequestToUpgradeLearnMoreModalFactory"] = $6f1a718cab8b04f2$export$aa10072a5720d721;

});

parcelRegister("7pv6k", function(module, exports) {
module.exports = new URL("Guest-Avatar.ebdf69f1.svg", import.meta.url).toString();

});

parcelRegister("eveQW", function(module, exports) {
module.exports = new URL("Team-Avatars.4f1b07ad.svg", import.meta.url).toString();

});

parcelRegister("e8W3S", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $bQm3c = parcelRequire("bQm3c");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $eh0mb = parcelRequire("eh0mb");

const $b1ebfcc93144065b$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    upgradeRequestNote: {
        id: "external-collab-ui.guest-request-to-upgrade.upgrade-request-note",
        defaultMessage: "This guest requested a Confluence license"
    }
});
const $b1ebfcc93144065b$export$4f101f8b41ecae81 = (cloudId, upgradeRequestNote)=>JSON.stringify({
        resource: `ari:cloud:confluence::site/${cloudId}`,
        note: upgradeRequestNote
    });
const $b1ebfcc93144065b$export$1fcc21aa81264365 = '/gateway/api/invitations/v1/access-requests/request';
const $b1ebfcc93144065b$export$dce8274ecfbb9f9e = ({ onCompleted: onCompleted })=>{
    const intl = (0, $8C5kA.default)();
    const [{ requestAccessState: requestAccessState }, { setRequestAccessState: setRequestAccessState }] = (0, $eh0mb.useGuestRequestUpgradeStore)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const submitGuestUpgradeRequest = (0, $42omo.useCallback)(async ()=>{
        setRequestAccessState('loading');
        return (0, $f7B1p.cfetch)($b1ebfcc93144065b$export$1fcc21aa81264365, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $b1ebfcc93144065b$export$4f101f8b41ecae81(cloudId, intl.formatMessage($b1ebfcc93144065b$export$a7357cdd1f0b0168.upgradeRequestNote))
        }).then((response)=>{
            if (response.ok && response.status === 200) {
                setRequestAccessState('submitted');
                onCompleted();
            } else {
                setRequestAccessState(undefined);
                throw new (0, $hBkCm.BadStatusError)(`${response.status}: ${response.statusText}`, response);
            }
        }).catch((caughtError)=>{
            setRequestAccessState(undefined);
            onCompleted(caughtError instanceof Error ? caughtError : new Error('Unknown error occurred during submission'));
        });
    }, [
        cloudId,
        intl,
        onCompleted,
        setRequestAccessState
    ]);
    return [
        submitGuestUpgradeRequest,
        {
            loading: requestAccessState === 'loading',
            isSubmitted: requestAccessState === 'submitted'
        }
    ];
};
module.exports["useSubmitGuestUpgradeRequest"] = $b1ebfcc93144065b$export$dce8274ecfbb9f9e;

});

parcelRegister("eh0mb", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4708f874261747c2$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        requestAccessState: undefined
    },
    actions: {
        setRequestAccessState: (value)=>({ setState: setState })=>{
                setState({
                    requestAccessState: value
                });
            }
    },
    name: 'guestRequestUpgradeStore'
});
const $4708f874261747c2$export$b72090e4288882db = (0, $9zUhf.createHook)($4708f874261747c2$var$Store);
module.exports["useGuestRequestUpgradeStore"] = $4708f874261747c2$export$b72090e4288882db;

});

parcelRegister("ewVsQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $8C5kA = parcelRequire("8C5kA");


var $eSUdr = parcelRequire("eSUdr");


var $6mKj3 = parcelRequire("6mKj3");


var $aXWbQ = parcelRequire("aXWbQ");

const $820cfbe605341dee$var$useRequestToEditContentRequestPageAccessMutation = (0, $eSUdr.default)`mutation useRequestToEditContentRequestPageAccessMutation($requestPageAccessInput:RequestPageAccessInput!){requestPageAccess(requestPageAccessInput:$requestPageAccessInput){displayName}}`;
const $820cfbe605341dee$var$REQUEST_SENT_FLAG_ID = 'request-to-edit-sent';
const $820cfbe605341dee$export$c3a30e09778accb4 = ({ contentId: contentId, flags: flags, triggerAnalyticsEvent: triggerAnalyticsEvent })=>{
    const [requestSent, setRequestSent] = (0, $42omo.useState)(false);
    const intl = (0, $8C5kA.default)();
    const showRequestToEditFailedFlag = (0, $42omo.useCallback)(()=>{
        if (triggerAnalyticsEvent) triggerAnalyticsEvent('content.request.to.edit.failed');
        if (!flags) return;
        flags.showWarningFlag({
            title: intl.formatMessage((0, $aXWbQ.messages).notSentFlagTitle),
            description: intl.formatMessage((0, $aXWbQ.messages).notSentFlagDescription),
            appearance: 'warning',
            isAutoDismiss: true
        });
    }, [
        flags,
        intl,
        triggerAnalyticsEvent
    ]);
    const showRequestToEditSentFlag = (0, $42omo.useCallback)(()=>{
        if (triggerAnalyticsEvent) triggerAnalyticsEvent('content.request.to.edit.success');
        if (!flags) return;
        if (!(0, $6mKj3.expValEquals)('confluence_ask_to_edit_across_content_type', 'cohort', 'test')) // Old flag
        flags.showSuccessFlag({
            id: $820cfbe605341dee$var$REQUEST_SENT_FLAG_ID,
            title: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagTitle),
            description: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagDescription),
            actions: [
                {
                    content: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagAction),
                    onClick: ()=>flags.hideFlag($820cfbe605341dee$var$REQUEST_SENT_FLAG_ID)
                }
            ]
        });
        else // New flag
        flags.showSuccessFlag({
            id: $820cfbe605341dee$var$REQUEST_SENT_FLAG_ID,
            title: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagShortTitle),
            description: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagDescription),
            isAutoDismiss: true
        });
    }, [
        flags,
        intl,
        triggerAnalyticsEvent
    ]);
    const handleRequestComplete = (result)=>{
        if (result?.requestPageAccess) {
            setRequestSent(true);
            showRequestToEditSentFlag();
        } else {
            showRequestToEditFailedFlag();
            setRequestSent(false);
        }
    };
    const handleRequestError = ()=>{
        showRequestToEditFailedFlag();
        setRequestSent(false);
    };
    const [requestToEditContent, { loading: loading }] = (0, $j1Ss3.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    $820cfbe605341dee$var$useRequestToEditContentRequestPageAccessMutation, {
        variables: {
            requestPageAccessInput: {
                pageId: contentId || '',
                accessType: 'EDIT'
            }
        },
        onCompleted: handleRequestComplete,
        onError: handleRequestError
    });
    return {
        requestToEditContent: requestToEditContent,
        loading: loading,
        hasRequestedEditPermission: requestSent
    };
};
module.exports["useRequestToEditContent"] = $820cfbe605341dee$export$c3a30e09778accb4;

});

parcelRegister("aXWbQ", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $b8ad22721a0e1a1a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    requestToEdit: {
        defaultMessage: "Request to edit",
        id: "no-permission.request.to.edit.button.label"
    },
    editRequestSent: {
        defaultMessage: "Request sent",
        id: "no-permission.edit.request.sent.button.label"
    },
    notSentFlagTitle: {
        defaultMessage: "Your request wasn\u2019t sent",
        id: "no-permission.request.to.edit.not.sent.flag.title"
    },
    notSentFlagDescription: {
        defaultMessage: "We ran into a problem submitting your edit request. Try again or contact your admin.",
        id: "no-permission.request.to.edit.not.sent.flag.description"
    },
    requestSentFlagTitle: {
        defaultMessage: "Request to edit sent",
        id: "no-permission.request.to.edit.request.sent.flag.title"
    },
    requestSentFlagShortTitle: {
        defaultMessage: "Request sent",
        id: "no-permission.request.to.edit.request.sent.flag.short.title"
    },
    requestSentFlagDescription: {
        defaultMessage: "We've asked the owner to give you edit access. You'll get an email once the request is approved.",
        id: "no-permission.request.to.edit.request.sent.flag.description"
    },
    requestSentFlagAction: {
        defaultMessage: "Got it",
        id: "no-permission.request.to.edit.request.sent.flag.action"
    }
});
module.exports["messages"] = $b8ad22721a0e1a1a$export$defe85febe8b728c;

});

parcelRegister("a3Xby", function(module, exports) {

let $75381832f5bc297c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $75381832f5bc297c$var$load("e1cuZ"),
    $75381832f5bc297c$var$load("6kXh6"),
    $75381832f5bc297c$var$load("9u8bR")
]).then(()=>parcelRequire('5w2FB'));

});

parcelRegister("b1pD4", function(module, exports) {
$parcel$export(module.exports, "CommentsSectionLoader", () => (parcelRequire("3ACqI")).CommentsSectionLoader);

var $3ACqI = parcelRequire("3ACqI");


});

parcelRegister("3ACqI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $hnvzE = parcelRequire("hnvzE");


var $7d2Nc = parcelRequire("7d2Nc");


var $eHtji = parcelRequire("eHtji");


var $jmjWc = parcelRequire("jmjWc");


var $deTj5 = parcelRequire("deTj5");


var $6Hogt = parcelRequire("6Hogt");


var $2YUV8 = parcelRequire("2YUV8");


var $dDqLo = parcelRequire("dDqLo");


var $3Am3T = parcelRequire("3Am3T");


var $bQm3c = parcelRequire("bQm3c");


var $dkkKv = parcelRequire("dkkKv");


var $7Oxky = parcelRequire("7Oxky");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


const $bab3bd054370fc67$export$a378d01c696bd81e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "SZ3wU",
    name: "CommentsSectionFabric",
    // eslint-disable-next-line react/prop-types
    //@ts-ignore
    loading: ({ handlePageCommentsRender: handlePageCommentsRender })=>{
        return !handlePageCommentsRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deTj5.CommentPlaceholder), null) : null;
    },
    loader: ()=>//@ts-ignore
        (parcelRequire("ghXyo"))
});

const $bab3bd054370fc67$export$4740f0dffd11e693 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Y3qpe",
    name: "CommentsSectionFabricPaint",
    loader: ()=>//@ts-ignore
        (parcelRequire("ghXyo"))
});
const $bab3bd054370fc67$export$2fa3aacacd7711f1 = ({ contentId: contentId, ...props })=>{
    // This information is available in the CommentsCountContext, but it also needs to be available to the legacy class
    // component so passing in directly from the hook as well
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $dDqLo.useCommentCounts)(contentId);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const allowNestedComments = (0, $2YUV8.useAllowNestedComments)();
    const commentsDataActions = (0, $8i27m.useCommentsDataActions)();
    const { refetch: refetchActiveComments } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId
    });
    const { refetch: refetchActiveInlineComments } = (0, $7Oxky.useActiveInlineCommentsQuery)({
        pageId: contentId,
        markerRefList: []
    });
    return(// @ts-ignore
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "page-comments"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        key: props.contentId,
        metric: (0, $6Hogt.PAGE_COMMENTS_METRIC),
        isCustomStart: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eHtji.PageSegmentLoadMark), {
        markName: "pageCommentsRenderStart",
        metric: (0, $6Hogt.PAGE_COMMENTS_METRIC)
    }), (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bab3bd054370fc67$export$4740f0dffd11e693, {
        ...props,
        // @ts-ignore
        contentId: contentId,
        inlineCommentsCount: unresolvedInlineCommentsCount,
        cloudId: cloudId,
        allowNestedComments: allowNestedComments,
        commentsDataActions: commentsDataActions,
        refetchCommentsPanel: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? refetchActiveComments : refetchActiveInlineComments
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bab3bd054370fc67$export$a378d01c696bd81e, {
        ...props,
        // @ts-ignore
        contentId: contentId,
        inlineCommentsCount: unresolvedInlineCommentsCount,
        cloudId: cloudId,
        allowNestedComments: allowNestedComments,
        commentsDataActions: commentsDataActions,
        refetchCommentsPanel: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? refetchActiveComments : refetchActiveInlineComments
    }))));
};
$bab3bd054370fc67$export$2fa3aacacd7711f1.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired
};
module.exports["CommentsSectionLoader"] = $bab3bd054370fc67$export$2fa3aacacd7711f1;

});

parcelRegister("deTj5", function(module, exports) {
/* CommentPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$FlexComment = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$CommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _i0dl1osq _otyru2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Circle = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _bfhkizff _1bsbzwfg _4t3izwfg _19pk1b66 _2hwxutpp",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$BeforeStylesContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n7zlia51 _1sb2f705 _1e0c1ule _otyrpxbi _ca0qutpp _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$commentWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.250',
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$CommentAddPromptContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _1bsb1osq _4t3i1ylp _syaz1rpy _ca0qze3t _1e0c1o8l _s7n4jp4b _18u0u2gc _16jlkb7n _bfhkizff",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$GridContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c11p5 _yv0ehpgh _727q19bv _bfhk1j28 _1bsbdgin _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Author = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_nd5lzmlf _1yt45uws _19itglyw _2rkofajl _bfhkizff _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$InnerComment = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_nd5lbahz _1yt41h4g _19itglyw _2rkofajl _bfhkizff _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$export$46096a93b7c122b2 = ({ showPlaceholder: showPlaceholder = false })=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if ((0, window.__SSR_RENDERED__) || showPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c27f350b69a05b43$var$commentWrapperStyles,
        "data-vc": "comment-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$GridContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Author, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$InnerComment, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$BeforeStylesContainer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$FlexComment, {
        "data-testid": "comment-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentAddPromptContainer, null))));
    else return null;
};
module.exports["CommentPlaceholder"] = $c27f350b69a05b43$export$46096a93b7c122b2;

});

parcelRegister("6Hogt", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_COMMENTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'pageCommentsRender',
            startMark: 'pageCommentsRenderStart',
            endMark: 'pageCommentsRenderEnd'
        }
    ]
});
module.exports["PAGE_COMMENTS_METRIC"] = $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17;

});

parcelRegister("2YUV8", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $ep3mz = parcelRequire("ep3mz");


var $9wGTI = parcelRequire("9wGTI");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");

const $d2978a0663607f28$var$useAllowNestedCommentsDetailsPanelContentCreatedDateQuery = (0, $eSUdr.default)`query useAllowNestedCommentsDetailsPanelContentCreatedDateQuery($contentId:ID!$status:String!){content(id:$contentId status:[$status]){nodes{id metadata{createdDate}}}}`;
const $d2978a0663607f28$var$NESTED_COMMENTS_LAUNCH_DATE = new Date(Date.UTC(2025, 2, 6)); // 6th March 2025. Only month is 0 indexed.
const $d2978a0663607f28$export$3044701888c6e050 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { data: createdDateData, loading: loading, error: error } = (0, $xQxzY.useQuery)($d2978a0663607f28$var$useAllowNestedCommentsDetailsPanelContentCreatedDateQuery, {
        variables: {
            contentId: contentId ?? '',
            status: 'current'
        },
        skip: !contentId
    });
    // If the feature flag is not enabled, we should always allow nested comments
    if (!(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return true;
    const pageCreatedDate = createdDateData?.content?.nodes?.[0]?.metadata.createdDate;
    const isLivePage = pageMode === (0, $cD1qu.PageMode).LIVE;
    if (loading || error || !pageCreatedDate) return false;
    const pageCreateDateObject = new Date(pageCreatedDate);
    const isBeforeLaunchDate = pageCreateDateObject < $d2978a0663607f28$var$NESTED_COMMENTS_LAUNCH_DATE;
    return isBeforeLaunchDate && !isLivePage;
};
module.exports["useAllowNestedComments"] = $d2978a0663607f28$export$3044701888c6e050;

});

parcelRegister("dDqLo", function(module, exports) {
/**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $dkkKv = parcelRequire("dkkKv");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $f5Wgm = parcelRequire("f5Wgm");


var $aPT9H = parcelRequire("aPT9H");

const $c085ac79a8833850$export$453b7c79178856e5 = (contentId)=>{
    // Always call both hooks to follow React rules, but skip the queries conditionally
    // Legacy implementation using CommentsSectionQuery
    const legacyResult = (0, $aPT9H.useCommentCountsLegacy)(contentId);
    // New comments data manager - get processed data from the store
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // ActiveCommentsQuery implementation - only used when confluence_comment_use_active_comment_query_exp is enabled
    // but NOT when cc_comments_new_comments_data_manager is enabled
    // Call without type filter to get both inline and footer comments, then filter by location.type
    const { data: allCommentsData } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId,
        // Don't pass type to get all comment types (both CommentsType.INLINE and CommentsType.FOOTER)
        skip: !contentId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) || !(0, $6mKj3.expValEquals)('confluence_comment_use_active_comment_query_exp', 'isEnabled', true)
    });
    return (0, $42omo.useMemo)(()=>{
        // Priority 1: Use new comments data manager when enabled
        if (processedCommentsData.isDataProcessed && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            const unresolvedInlineCommentsCount = processedCommentsData.openInlineComments.length;
            const footerCommentsCount = processedCommentsData.openFooterComments.length;
            return {
                unresolvedInlineCommentsCount: unresolvedInlineCommentsCount,
                footerCommentsCount: footerCommentsCount
            };
        }
        // Priority 2: Use ActiveCommentsQuery when confluence_comment_use_active_comment_query_exp is enabled
        if (allCommentsData?.comments?.nodes && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && (0, $6mKj3.expValEquals)('confluence_comment_use_active_comment_query_exp', 'isEnabled', true)) {
            // New implementation using ActiveCommentsQuery
            // ActiveCommentsQuery already filters by commentState: UNRESOLVED, so all comments are unresolved
            // Filter comments by location.type to count inline vs footer separately
            const unresolvedInlineCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === (0, $f5Wgm.CommentType).INLINE).length;
            const footerCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === (0, $f5Wgm.CommentType).FOOTER).length;
            return {
                unresolvedInlineCommentsCount: unresolvedInlineCommentsCount,
                footerCommentsCount: footerCommentsCount
            };
        }
        // Priority 3: Legacy implementation using CommentsSectionQuery
        // Return legacy result if available, otherwise return default values
        if (legacyResult) return legacyResult;
        // Fallback when experiment is enabled but data hasn't loaded yet
        return {
            unresolvedInlineCommentsCount: 0,
            footerCommentsCount: 0
        };
    }, [
        processedCommentsData.isDataProcessed,
        processedCommentsData.openInlineComments.length,
        processedCommentsData.openFooterComments.length,
        allCommentsData?.comments?.nodes,
        legacyResult
    ]);
};
module.exports["useCommentCounts"] = $c085ac79a8833850$export$453b7c79178856e5;

});

parcelRegister("aPT9H", function(module, exports) {
/**
 * @graphql cc
 */ 
var $j1Ss3 = parcelRequire("j1Ss3");


var $k8e76 = parcelRequire("k8e76");


var $ftXPY = parcelRequire("ftXPY");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $l5y3Y = parcelRequire("l5y3Y");

const $a2300d29b43bb5dd$export$e32e67cfb7516912 = (contentId)=>{
    const { unresolvedInlineComments: unresolvedInlineComments } = (0, $k8e76.useInlineCommentsState)();
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    // Instead of requesting 0 comments with the 'first' param here I am reusing the query that is preloaded and fetched
    // for page comments themselves. This allows me to take advantage of the caching and updates that occur in the
    // legacy classes. I've also just marked all errors as handled as we don't particularly care about the results here
    // and the page comments component has much more robust error handling than we'd want to add here.
    const { data: footerCommentsData, error: error } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- This is not preloaded but there is a name collision with a preloaded query
    isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery), {
        variables: {
            contentId: contentId,
            offset: '',
            first: 100
        },
        fetchPolicy: window.__SSR_RENDERED__ && (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? 'cache-first' : undefined,
        skip: (0, $9wGTI.fg)('confluence_comment_use_active_comment_query') || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) || !contentId
    });
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    // Return undefined when feature gate or experiment is enabled
    if ((0, $9wGTI.fg)('confluence_comment_use_active_comment_query') || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return undefined;
    return {
        unresolvedInlineCommentsCount: (unresolvedInlineComments && unresolvedInlineComments.length) ?? 0,
        footerCommentsCount: (footerCommentsData && footerCommentsData.comments?.totalCount) ?? 0
    };
};
module.exports["useCommentCountsLegacy"] = $a2300d29b43bb5dd$export$e32e67cfb7516912;

});

parcelRegister("ftXPY", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $75943abbc80ed84d$export$fd7e2403f7d3fed9 = (0, $eSUdr.default)`query CommentsSectionQuery($offset:String$first:Long$contentId:ID!)@allowHigherTimeout{comments(pageId:$contentId type:FOOTER depth:ALL confluenceCommentFilter:{commentState:UNRESOLVED commentType:FOOTER}first:$first after:$offset){totalCount pageInfo{hasNextPage endCursor}edges{cursor node{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}reactionsSummary(pageId:$contentId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}content(id:$contentId){nodes{subType id operations{operation targetType}space{id homepageId}type history{createdBy{...on KnownUser{accountId}}}}}user:confluence_atlassianUser(current:true){displayName photos{isPrimary value}id}}`;
const $75943abbc80ed84d$export$274156b7c7eb3601 = (0, $eSUdr.default)`query CommentsSectionWithoutReactionsQuery($offset:String$first:Long$contentId:ID!){comments(pageId:$contentId type:FOOTER depth:ALL confluenceCommentFilter:{commentState:UNRESOLVED commentType:FOOTER}first:$first after:$offset){totalCount pageInfo{hasNextPage endCursor}edges{cursor node{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}}}}content(id:$contentId){nodes{subType id operations{operation targetType}space{id homepageId}type history{createdBy{...on KnownUser{accountId}}}}}user:confluence_atlassianUser(current:true){displayName photos{isPrimary value}id}}`;
module.exports["CommentsSectionQuery"] = $75943abbc80ed84d$export$fd7e2403f7d3fed9;
module.exports["CommentsSectionWithoutReactionsQuery"] = $75943abbc80ed84d$export$274156b7c7eb3601;

});

parcelRegister("3Am3T", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDqLo = parcelRequire("dDqLo");

const $7428cb96b7623c11$export$cf1f48e05bf093f2 = /*#__PURE__*/ (0, $42omo.createContext)({
    footerCommentsCount: 0,
    unresolvedInlineCommentsCount: 0
});
const $7428cb96b7623c11$export$c2f6e8ee3b0be174 = ({ contentId: contentId, children: children })=>{
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
        value: commentCounts
    }, children);
};
module.exports["CommentCountsContext"] = $7428cb96b7623c11$export$cf1f48e05bf093f2;
module.exports["CommentCountsProvider"] = $7428cb96b7623c11$export$c2f6e8ee3b0be174;

});

parcelRegister("ghXyo", function(module, exports) {

let $bdbc6e05d64e727e$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    $bdbc6e05d64e727e$var$load("1Jgsw"),
    $bdbc6e05d64e727e$var$load("duPDN"),
    $bdbc6e05d64e727e$var$load("afXyT"),
    $bdbc6e05d64e727e$var$load("gYeBT"),
    $bdbc6e05d64e727e$var$load("fwmQF"),
    $bdbc6e05d64e727e$var$load("6wr18"),
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("1YwJ8"), 5)),
    $bdbc6e05d64e727e$var$load("i0ttV"),
    $bdbc6e05d64e727e$var$load("1QdXB"),
    $bdbc6e05d64e727e$var$load("1c1XO"),
    $bdbc6e05d64e727e$var$load("9Z7qK"),
    $bdbc6e05d64e727e$var$load("gLGsg"),
    $bdbc6e05d64e727e$var$load("ffEVr"),
    $bdbc6e05d64e727e$var$load("8Gekp"),
    $bdbc6e05d64e727e$var$load("2zqtv")
]).then(()=>parcelRequire('kXPQu'));

});

parcelRegister("alui6", function(module, exports) {
"use strict";

var $h4lNe = parcelRequire("h4lNe");

module.exports = $h4lNe(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});

parcelRegister("h4lNe", function(module, exports) {
"use strict";
let $c6d3b70899d3a8aa$var$cachedBundles = {};
let $c6d3b70899d3a8aa$var$cachedPreloads = {};
let $c6d3b70899d3a8aa$var$cachedPrefetches = {};
function $c6d3b70899d3a8aa$var$getCache(type) {
    switch(type){
        case 'preload':
            return $c6d3b70899d3a8aa$var$cachedPreloads;
        case 'prefetch':
            return $c6d3b70899d3a8aa$var$cachedPrefetches;
        default:
            return $c6d3b70899d3a8aa$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $c6d3b70899d3a8aa$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});

parcelRegister("2i3To", function(module, exports) {
const $a410f94860ee0eb3$export$ebc5ec3267fbcf57 = 100;
const $a410f94860ee0eb3$export$55256f24239e6668 = 0;
module.exports["DEFAULT_LIMIT"] = $a410f94860ee0eb3$export$ebc5ec3267fbcf57;

});

parcelRegister("6XpHo", function(module, exports) {

let $510c30087ef8e8f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $510c30087ef8e8f6$var$load("kXcA7").then(()=>parcelRequire('bAPy4'));

});

parcelRegister("5D6c6", function(module, exports) {

let $4195665107f1d724$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4195665107f1d724$var$load("cYWWR"),
    $4195665107f1d724$var$load("h2HOI")
]).then(()=>parcelRequire('2hWDW'));

});

parcelRegister("1N2OF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1ggpj = parcelRequire("1ggpj");


var $5ZqQS = parcelRequire("5ZqQS");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $3jwuS = parcelRequire("3jwuS");


var $7mpOv = parcelRequire("7mpOv");


var $f5bZm = parcelRequire("f5bZm");


var $h7eE1 = parcelRequire("h7eE1");


var $jVFPV = parcelRequire("jVFPV");

const $f6c5568d6d5a516f$export$3d87df4b3544fccb = ({ contentId: contentId, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft, flags: flags, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, onBeforeValidation: onBeforeValidation, onValidationSuccess: onValidationSuccess, analyticsSource: analyticsSource, optimisticTitle: optimisticTitle })=>{
    const intl = (0, $8C5kA.default)();
    // Since the validatePageAndOpenModal function may be running after this component has unmounted,
    // we have to query the apolloClient directly rather than using useQuery's refetch function.
    const apolloClient = (0, $hp2SH.getApolloClient)();
    // Changes to EditorTitle are debounced if the page is a draft, which we need to account for
    const titleDebounceTime = isUnpublishedDraft ? (0, $1ggpj.onChangeTitleDebounceTime) : 0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f5bZm.usePublishModalAnalyticsEvent)();
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const validatePageAndOpenModal = (0, $42omo.useCallback)((actionSubjectId)=>{
        const validatePage = async ()=>{
            // Live Pages only save changes to the `realTitle` when it is valid,
            // so we need to use the `optimisticTitle` here to get what the user
            // has actually typed into the title field, and then show the correct flag.
            const { title: realTitle } = await retrieveEditorTitleAndContent();
            // ?? must be used here to explicitly check null and undefined because we want to use optmisticTitle if it is an empty string, which is also falsey.
            const title = optimisticTitle ?? realTitle;
            try {
                // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
                const { data: data } = await apolloClient.query({
                    query: (0, $h7eE1.ValidatePagePublishQuery),
                    errorPolicy: 'all',
                    fetchPolicy: 'network-only',
                    variables: {
                        contentId: contentId,
                        type: contentType,
                        title: title
                    }
                });
                // This is the same logic used to calculate `isTitleEmpty` in EditorPrimaryToolbarComponents.
                const isTitleEmpty = !title;
                if (!data.validatePagePublish?.isValid) await (0, $jVFPV.displayPublishErrorFlag)({
                    validationMessage: data.validatePagePublish?.message,
                    isTitleEmpty: isTitleEmpty,
                    flags: flags,
                    formatMessage: intl.formatMessage,
                    publish: validatePageAndOpenModal('PublishButtonInFlag'),
                    isAIEnabledForContent: isAIEnabledForContent,
                    isLivePage: isLivePage
                });
                else onValidationSuccess();
            } catch (error) {
                if (error) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    if (!(0, $6fil2.containsNetworkError)(error) && !(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                        attribution: (0, $3IBnw.Attribution).PAGE_MODES
                    });
                }
            }
        };
        return async ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    actionSubject: 'button',
                    action: 'clicked',
                    actionSubjectId: actionSubjectId,
                    source: analyticsSource,
                    attributes: {
                        isUnpublishedDraft: isUnpublishedDraft
                    }
                }
            }).fire();
            setTimeout(async ()=>{
                onBeforeValidation();
                await validatePage();
            }, titleDebounceTime);
        };
    }, [
        contentId,
        contentType,
        retrieveEditorTitleAndContent,
        createAnalyticsEvent,
        flags,
        intl.formatMessage,
        titleDebounceTime,
        isUnpublishedDraft,
        analyticsSource,
        onBeforeValidation,
        onValidationSuccess,
        apolloClient,
        optimisticTitle,
        isAIEnabledForContent,
        isLivePage
    ]);
    return validatePageAndOpenModal;
};
module.exports["usePrePublishTitleValidation"] = $f6c5568d6d5a516f$export$3d87df4b3544fccb;

});

parcelRegister("f5bZm", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $inPa6 = parcelRequire("inPa6");


var $ep3mz = parcelRequire("ep3mz");

const $d6a7ecdd01e28d6c$export$cd6c3e8c6818dcba = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: akCreateAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    /**
   * cache-only since it is utilizing the same query that the PublishButtonWithMoreOptions component
   * is using, so the data should already be available within the cache which is why there is no
   * error or loading checks as well.
   */ const { data: data } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query usePublishModalAnalyticsEventPublishModalWithMoreOptionsQuery($contentId:ID){singleContent(id:$contentId){id type space{id}schedulePublishInfo{date versionComment minorEdit targetType targetLocation{parentId destinationSpace{id key alias}}restrictions{update{user:personConnection{edges{node{email permissionType displayName accountId publicName profilePicture{path}}}}group{edges{node{name id}}}}read{user:personConnection{edges{node{email permissionType displayName accountId publicName profilePicture{path}}}}group{edges{node{name id}}}}}}}}`, {
        errorPolicy: 'all',
        fetchPolicy: 'cache-only',
        variables: {
            contentId: contentId
        }
    });
    // Setup the rest of the necessary info for our analytics events that came from the query
    const analyticEventData = (0, $42omo.useMemo)(()=>{
        return {
            objectId: contentId,
            objectType: data?.singleContent?.type ?? undefined,
            containerId: data?.singleContent?.space?.id ?? undefined
        };
    }, [
        data,
        contentId
    ]);
    const createAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        payload.data.objectType = analyticEventData.objectType;
        payload.data.objectId = analyticEventData.objectId;
        payload.data.containerType = 'space';
        payload.data.containerId = analyticEventData.containerId;
        return akCreateAnalyticsEvent(payload);
    }, [
        analyticEventData,
        akCreateAnalyticsEvent
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
};
module.exports["usePublishModalAnalyticsEvent"] = $d6a7ecdd01e28d6c$export$cd6c3e8c6818dcba;

});

parcelRegister("h7eE1", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $a57349b93ecbf15f$export$6d6976f1200f02ec = (0, $eSUdr.default)`query ValidatePagePublishQuery($contentId:ID!$type:String$title:String){validatePagePublish(id:$contentId status:"draft" type:$type title:$title){isValid message}}`;
module.exports["ValidatePagePublishQuery"] = $a57349b93ecbf15f$export$6d6976f1200f02ec;

});

parcelRegister("jVFPV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cFEpk = parcelRequire("cFEpk");


var $da71s = parcelRequire("da71s");


var $gsubZ = parcelRequire("gsubZ");


var $cgtv4 = parcelRequire("cgtv4");


var $6f0Oj = parcelRequire("6f0Oj");


var $lAFHW = parcelRequire("lAFHW");


var $hp2SH = parcelRequire("hp2SH");


var $cHfGW = parcelRequire("cHfGW");


var $1mHQU = parcelRequire("1mHQU");


var $8mrqR = parcelRequire("8mrqR");


var $1Z5gD = parcelRequire("1Z5gD");


var $6mKj3 = parcelRequire("6mKj3");


var $c6abH = parcelRequire("c6abH");


var $hFmJ6 = parcelRequire("hFmJ6");

function $431bc41fbb9babca$export$2d18ca8a66126a1d() {
    const hasWindow = typeof window !== 'undefined';
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    return {
        width: width,
        height: height
    };
}
const $431bc41fbb9babca$var$ALL_TIMES_ARRAY = Array(48).fill(0).map((_, i)=>`${Math.floor(i / 2).toString().padStart(2, '0')}:${i % 2 ? '30' : '00'}`);
const $431bc41fbb9babca$var$i18n = (0, $cgtv4.defineMessages)({
    acceptTitle: {
        id: "publish-modal.flag.accept",
        defaultMessage: "Accept"
    }
});
const $431bc41fbb9babca$export$b182675d91dd4643 = (scheduledDate)=>{
    const currTime = new Date();
    const baseTime = (0, $gsubZ.default)(currTime, 5);
    // Return empty array when it is already 5 minutes until tomorrow
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (baseTime.toDateString() === tomorrow.toDateString()) return [];
    // Return array of valid time selections
    if (!!scheduledDate && (0, $da71s.default)(scheduledDate).toDateString() === baseTime.toDateString()) {
        // User selected same day, only return time in the future
        const baseHour = baseTime.getHours();
        const nextHour = baseHour + 1;
        // Time array
        const timesArray = Array(48 - nextHour * 2).fill(0).map((_, i)=>`${Math.floor((i + nextHour * 2) / 2).toString().padStart(2, '0')}:${i % 2 ? '30' : '00'}`);
        if (baseTime.getMinutes() < 30) // If current time is in first half of the hour, add {currentHour:30} to the time array
        timesArray.unshift(`${baseHour.toString().padStart(2, '0')}:30`);
        return timesArray;
    } else // User selected future day, return all times array
    return $431bc41fbb9babca$var$ALL_TIMES_ARRAY;
};
const $431bc41fbb9babca$export$6195456a656da885 = (date, time)=>{
    return date && time && (0, $cFEpk.default)(date) && (0, $cFEpk.default)(time) ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds()) : undefined;
};
const $431bc41fbb9babca$export$9295f91b059cbee5 = ({ contentId: contentId, schedulePublishDate: schedulePublishDate, fragmentWriterInterop: fragmentWriterInterop })=>{
    const apollo = (0, $hp2SH.getApolloClient)();
    if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) try {
        fragmentWriterInterop({
            fragmentId: `Content:${contentId}`,
            data: {
                schedulePublishInfo: {
                    __typename: 'SchedulePublishInfo',
                    date: schedulePublishDate,
                    minorEdit: false,
                    targetType: 'page',
                    versionComment: ''
                },
                __typename: 'Content'
            }
        });
    } catch (error) {}
    else try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const data = apollo.readQuery({
            query: (0, $hFmJ6.PublishModalWithMoreOptionsQuery),
            variables: {
                contentId: contentId
            }
        });
        data.singleContent.schedulePublishInfo = {
            __typename: 'SchedulePublishInfo',
            date: schedulePublishDate,
            minorEdit: false,
            targetType: 'page',
            versionComment: ''
        };
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        apollo.writeQuery({
            query: (0, $hFmJ6.PublishModalWithMoreOptionsQuery),
            variables: {
                contentId: contentId
            },
            data: data
        });
    } catch (error) {}
};
const $431bc41fbb9babca$export$19a3e0c18ebaf6e6 = async ({ validationMessage: validationMessage, isTitleEmpty: isTitleEmpty, flags: flags, formatMessage: formatMessage, publish: publish, isAIEnabledForContent: isAIEnabledForContent, isLivePage: isLivePage })=>{
    let flagErrorId;
    // Will show a generic error flag if these three conditions not met
    // The validation query results do not differentiate b/w blank and whitespace title so we use isTitleEmpty to do so on the frontend side
    if (isTitleEmpty && validationMessage === (0, $c6abH.PublishErrorFlagKeys).TITLE_IS_BLANK && isAIEnabledForContent && !isLivePage && (0, $6mKj3.expValEquals)('confluence_ai_title_generation', 'cohort', 'test')) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE;
    else if (isTitleEmpty && validationMessage === (0, $c6abH.PublishErrorFlagKeys).TITLE_IS_BLANK) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_REQUIRED;
    else if (validationMessage === (0, $c6abH.PublishErrorFlagKeys).TITLE_IS_BLANK) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).INVALID_PAGE_TITLE;
    else if (validationMessage === (0, $c6abH.PublishErrorFlagKeys).DUPLICATE_TITLE) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE;
    const flagMessage = (0, $cHfGW.buildEditorFlagMessage)({
        errorData: {
            [flagErrorId]: true
        },
        formatMessage: formatMessage
    });
    if (flagErrorId === (0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE) {
        await flags.hideFlag('ai-generated-title-flag');
        await flags.showCustomFlag({
            id: 'ai-generated-title-flag',
            title: flagMessage?.title,
            description: flagMessage?.description,
            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                paddingBlockStart: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
                label: "",
                size: "xsmall"
            })),
            actions: [
                {
                    content: formatMessage($431bc41fbb9babca$var$i18n.acceptTitle),
                    onClick: publish
                }
            ]
        });
    } else await flags.showErrorFlag({
        title: flagMessage?.title,
        description: flagMessage?.description
    });
};
const $431bc41fbb9babca$export$3b8de2468aab001b = (permissionsRestrictionsObj)=>{
    const result = {};
    permissionsRestrictionsObj.forEach((element)=>{
        // The `email` field must be removed from this object because the BE/experimental mutation does not expect it.
        result[element.operation] = $431bc41fbb9babca$var$removeEmailFromUsers(element);
    });
    // Sanitize for GraphQL compatibility (removes usageType from groups)
    if ((0, $6mKj3.expValEquals)('cpe-3645_fix_publish_modal_blog_conversion', 'cohort', 'test')) return (0, $1Z5gD.sanitizeRestrictionsForGraphQL)(result);
    return result;
};
// TODO Add types to these new functions.
const $431bc41fbb9babca$var$removeEmailFromUsers = (operationObj)=>({
        operation: operationObj?.operation,
        restrictions: {
            group: operationObj?.restrictions?.group,
            user: {
                results: operationObj?.restrictions?.user?.results?.map($431bc41fbb9babca$var$removeEmail)
            }
        }
    });
const $431bc41fbb9babca$var$removeEmail = (user)=>({
        accountId: user?.accountId,
        displayName: user?.displayName,
        isExternalCollaborator: user?.isExternalCollaborator,
        profilePicture: {
            path: user?.profilePicture?.path
        },
        publicName: user?.publicName,
        type: 'known'
    });
const $431bc41fbb9babca$export$7521340df7373a8f = (scheduledRestrictions)=>{
    const readRestriction = scheduledRestrictions?.read;
    const updateRestriction = scheduledRestrictions?.update;
    const usersWithReadRestriction = readRestriction?.user?.edges ?? [];
    const groupsWithReadRestriction = readRestriction?.group?.edges ?? [];
    const usersWithUpdateRestriction = updateRestriction?.user?.edges ?? [];
    const groupsWithUpdateRestriction = updateRestriction?.group?.edges ?? [];
    const processUserEdgesArray = (userEdgesArray)=>userEdgesArray.map((element)=>(0, $8mrqR.transformUserToREST)({
                ...element.node,
                hasSpaceEditPermission: true,
                hasSpaceViewPermission: true
            }));
    const processGroupEdgesArray = (groupEdgesArray)=>groupEdgesArray.map((element)=>(0, $8mrqR.transformGroupToREST)(element.node));
    const createRestrictionsObject = (operation, users, groups)=>({
            operation: operation,
            restrictions: {
                user: {
                    results: processUserEdgesArray(users)
                },
                group: {
                    results: processGroupEdgesArray(groups)
                }
            }
        });
    const readObj = createRestrictionsObject('read', usersWithReadRestriction, groupsWithReadRestriction);
    const updateObj = createRestrictionsObject('update', usersWithUpdateRestriction, groupsWithUpdateRestriction);
    return [
        readObj,
        updateObj
    ];
};
module.exports["getTimesArray"] = $431bc41fbb9babca$export$b182675d91dd4643;
module.exports["mergeDateTime"] = $431bc41fbb9babca$export$6195456a656da885;
module.exports["cacheSchedulePublishTime"] = $431bc41fbb9babca$export$9295f91b059cbee5;
module.exports["displayPublishErrorFlag"] = $431bc41fbb9babca$export$19a3e0c18ebaf6e6;
module.exports["convertRestrictionsObjForContentREST"] = $431bc41fbb9babca$export$3b8de2468aab001b;
module.exports["convertRestrictionsObjFromSchedulePublishInfo"] = $431bc41fbb9babca$export$7521340df7373a8f;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("gsubZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfb6ae770a72c6aa$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $lshox = parcelRequire("lshox");


var $b5utg = parcelRequire("b5utg");

var $bfb6ae770a72c6aa$var$MILLISECONDS_IN_MINUTE = 60000;
function $bfb6ae770a72c6aa$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $lshox.default)(dirtyDate, amount * $bfb6ae770a72c6aa$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("8mrqR", function(module, exports) {

var $7CLBv = parcelRequire("7CLBv");


var $c4ECQ = parcelRequire("c4ECQ");


var $9lU4Z = parcelRequire("9lU4Z");

class $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError extends Error {
    constructor(){
        super("Invalid restrictions object provided.  Restrictions objects must contain a 'read' ContentRestriction and an 'update' ContentRestriction.");
    }
}
class $5c6f8af6b02c47e8$var$InvalidGraphQLRestrictionsError extends Error {
    constructor(){
        super('Invalid restrictions were fetched from GraphQL.');
    }
}
const $5c6f8af6b02c47e8$var$restrictionIsEmpty = (contentRestriction)=>{
    return contentRestriction.restrictions.user.results.length === 0 && contentRestriction.restrictions.group.results.length === 0;
};
const $5c6f8af6b02c47e8$export$54aeac99fafa79ed = (restObj)=>{
    const readRestriction = restObj.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObj.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    if ($5c6f8af6b02c47e8$var$restrictionIsEmpty(readRestriction) && $5c6f8af6b02c47e8$var$restrictionIsEmpty(updateRestriction)) return (0, $c4ECQ.ContentRestrictionType).NO_RESTRICTIONS;
    else if ($5c6f8af6b02c47e8$var$restrictionIsEmpty(readRestriction)) return (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT;
    else return (0, $c4ECQ.ContentRestrictionType).RESTRICT_VIEW;
};
const $5c6f8af6b02c47e8$export$b1e5e678c0890199 = (restObj, newRestrictionType, currentUser)=>{
    // This function applies a restrictionType to a RestrictionsRESTObj.
    // Some of the logic here is duplicated by `getPermissionsGroupsBasedOnRestrictionsType`
    // in RestrictionsDialog/restrictions-data-transform-helpers.tsx
    // Be sure that any changes you make to how this logic works are also made in that file.
    const oldRestrictionType = $5c6f8af6b02c47e8$export$54aeac99fafa79ed(restObj);
    const currentUserObj = {
        type: 'known',
        // The `as "known"` is needed to satisfy a Typescript error, since `type` gets assigned the type "string"
        accountId: currentUser.id,
        profilePicture: {
            path: currentUser.profilePicture.path
        },
        displayName: currentUser.displayName,
        publicName: currentUser.displayName,
        isExternalCollaborator: false
    };
    // First make a deep copy of the restObj.
    const restObjCopy = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(restObj);
    const readRestriction = restObjCopy.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObjCopy.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    if (newRestrictionType === (0, $c4ECQ.ContentRestrictionType).NO_RESTRICTIONS) {
        // Empty out update and read arrays.
        readRestriction.restrictions.user.results = [];
        readRestriction.restrictions.group.results = [];
        updateRestriction.restrictions.user.results = [];
        updateRestriction.restrictions.group.results = [];
        return restObjCopy;
    } else if (newRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT) {
        if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_VIEW) {
            readRestriction.restrictions.user.results = [];
            readRestriction.restrictions.group.results = [];
            return restObjCopy;
        } else if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT) return restObjCopy;
        else {
            // oldRestrictionType === ContentRestrictionType.NO_RESTRICTIONS
            updateRestriction.restrictions.user.results.push(currentUserObj);
            return restObjCopy;
        }
    } else {
        // newRestrictionType === ContentRestrictionType.RESTRICT_VIEW
        if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_VIEW) return restObjCopy;
        else if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT) {
            readRestriction.restrictions.user.results.push(currentUserObj);
            return restObjCopy;
        } else {
            // oldRestrictionType === ContentRestrictionType.NO_RESTRICTIONS
            readRestriction.restrictions.user.results.push(currentUserObj);
            updateRestriction.restrictions.user.results.push(currentUserObj);
            return restObjCopy;
        }
    }
// Permissions levels:
// NO_RESTRICTIONS
// RESTRICT_EDIT
// RESTRICT_VIEW
//
// To move upwards on that list, just empty out the restrictions arrays.
// To move downwards on that list, you have to add the current user into the correct restrictions segment.
};
const $5c6f8af6b02c47e8$var$convertRESTUser = (restUser)=>{
    return {
        key: `USER-${restUser.accountId}`,
        entityType: (0, $c4ECQ.EntityType).USER,
        permissions: [],
        displayName: restUser.displayName,
        accountId: restUser.accountId,
        profilePicture: {
            path: restUser.profilePicture.path
        },
        hasSpaceViewPermission: restUser?.hasSpaceViewPermission ?? true,
        hasSpaceEditPermission: restUser?.hasSpaceEditPermission ?? true,
        permissionType: restUser.isExternalCollaborator ? (0, $9lU4Z.SitePermissionType).EXTERNAL : (0, $9lU4Z.SitePermissionType).INTERNAL
    };
};
const $5c6f8af6b02c47e8$var$convertRESTGroup = (restGroup)=>{
    return {
        key: `GROUP-${restGroup.id}`,
        entityType: (0, $c4ECQ.EntityType).GROUP,
        permissions: [],
        name: restGroup.name,
        permissionType: (0, $9lU4Z.SitePermissionType).INTERNAL
    };
};
const $5c6f8af6b02c47e8$export$a9b84852f592ee6c = (restObj)=>{
    const readRestriction = restObj.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObj.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    // TODO It may be possible to re-use some of the logic in
    // restrictions-data-transform-helpers.tsx here.
    // First, make a map from accountIds or group ids to their corresponding objects.
    const userGroupMap = new Map();
    for (const user of readRestriction.restrictions.user.results){
        if (!userGroupMap.has(user.accountId)) userGroupMap.set(user.accountId, $5c6f8af6b02c47e8$var$convertRESTUser(user));
        userGroupMap.get(user.accountId).permissions.push((0, $c4ECQ.PermissionType).VIEW);
    }
    for (const group of readRestriction.restrictions.group.results){
        if (!userGroupMap.has(group.id)) userGroupMap.set(group.id, $5c6f8af6b02c47e8$var$convertRESTGroup(group));
        userGroupMap.get(group.id).permissions.push((0, $c4ECQ.PermissionType).VIEW);
    }
    for (const user of updateRestriction.restrictions.user.results){
        if (!userGroupMap.has(user.accountId)) userGroupMap.set(user.accountId, $5c6f8af6b02c47e8$var$convertRESTUser(user));
        userGroupMap.get(user.accountId).permissions.push((0, $c4ECQ.PermissionType).EDIT);
    }
    for (const group of updateRestriction.restrictions.group.results){
        if (!userGroupMap.has(group.id)) userGroupMap.set(group.id, $5c6f8af6b02c47e8$var$convertRESTGroup(group));
        userGroupMap.get(group.id).permissions.push((0, $c4ECQ.PermissionType).EDIT);
    }
    // Return an array out of all the values from the map.
    // This matches the format of the usersAndGroups object.
    return Array.from(userGroupMap).map(([, value])=>value);
};
const $5c6f8af6b02c47e8$export$dfb1e6e2e25bf061 = (user)=>{
    return {
        type: 'known',
        accountId: user?.accountId ?? '',
        publicName: user?.publicName ?? '',
        profilePicture: {
            path: user?.profilePicture?.path ?? ''
        },
        email: user?.email ?? '',
        displayName: user?.displayName ?? '',
        hasSpaceViewPermission: user?.hasSpaceViewPermission ?? true,
        hasSpaceEditPermission: user?.hasSpaceEditPermission ?? true,
        isExternalCollaborator: user.permissionType === (0, $9lU4Z.SitePermissionType).EXTERNAL
    };
};
const $5c6f8af6b02c47e8$export$354ad6f5846ff4ac = (group)=>{
    return {
        type: 'group',
        name: group?.name ?? '',
        id: group?.id ?? '',
        usageType: group?.usageType
    };
};
const $5c6f8af6b02c47e8$var$isNotNull = (value)=>{
    return value !== null;
};
const $5c6f8af6b02c47e8$export$a57b08835223f9b8 = (queryData)=>{
    const readRestriction = queryData?.content?.nodes?.[0]?.restrictions?.read?.restrictions;
    const updateRestriction = queryData?.content?.nodes?.[0]?.restrictions?.update?.restrictions;
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidGraphQLRestrictionsError();
    const readObj = {
        operation: 'read',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const updateObj = {
        operation: 'update',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    readObj.restrictions.user.results = (readRestriction?.userWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isNotNull).map($5c6f8af6b02c47e8$export$dfb1e6e2e25bf061);
    readObj.restrictions.group.results = (readRestriction?.groupWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isNotNull).map($5c6f8af6b02c47e8$export$354ad6f5846ff4ac);
    updateObj.restrictions.user.results = (updateRestriction?.userWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isNotNull).map($5c6f8af6b02c47e8$export$dfb1e6e2e25bf061);
    updateObj.restrictions.group.results = (updateRestriction?.groupWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isNotNull).map($5c6f8af6b02c47e8$export$354ad6f5846ff4ac);
    return [
        readObj,
        updateObj
    ];
};
const $5c6f8af6b02c47e8$export$9281fb4d0a89ade8 = (restObj)=>{
    const readRestriction = restObj.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObj.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    const onlyOneUserCanRead = readRestriction.restrictions.user.results.length === 1;
    const noGroupsCanRead = readRestriction.restrictions.group.results.length === 0;
    const onlyOneUserCanUpdate = updateRestriction.restrictions.user.results.length === 1;
    const noGroupsCanUpdate = updateRestriction.restrictions.group.results.length === 0;
    return onlyOneUserCanRead && noGroupsCanRead && onlyOneUserCanUpdate && noGroupsCanUpdate;
};
module.exports["getRestrictionsTypeFromRESTObj"] = $5c6f8af6b02c47e8$export$54aeac99fafa79ed;
module.exports["getUsersAndGroupsFromRESTObj"] = $5c6f8af6b02c47e8$export$a9b84852f592ee6c;
module.exports["transformUserToREST"] = $5c6f8af6b02c47e8$export$dfb1e6e2e25bf061;
module.exports["transformGroupToREST"] = $5c6f8af6b02c47e8$export$354ad6f5846ff4ac;
module.exports["transformGraphQLQueryToRESTObj"] = $5c6f8af6b02c47e8$export$a57b08835223f9b8;
module.exports["restrictionsArePrivateToYouOnly"] = $5c6f8af6b02c47e8$export$9281fb4d0a89ade8;

});

parcelRegister("c4ECQ", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $e40ae21eed558c2b$export$91111a1ebace330 = /*#__PURE__*/ function(ContentRestrictionType) {
    ContentRestrictionType["NO_RESTRICTIONS"] = "NO_RESTRICTIONS";
    ContentRestrictionType["RESTRICT_EDIT"] = "RESTRICT_EDIT";
    ContentRestrictionType["RESTRICT_VIEW"] = "RESTRICT_VIEW";
    return ContentRestrictionType;
}({});
var $e40ae21eed558c2b$export$7602248773d1f745 = /*#__PURE__*/ function(RestrictionFrom) {
    RestrictionFrom["DIRECT"] = "DIRECT";
    RestrictionFrom["MULTIPLE"] = "MULTIPLE";
    RestrictionFrom["NONE"] = "NONE";
    RestrictionFrom["PAGE_INHERITED"] = "PAGE_INHERITED";
    RestrictionFrom["SPACE"] = "SPACE";
    return RestrictionFrom;
}({});
var $e40ae21eed558c2b$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["GROUP"] = "GROUP";
    EntityType["USER"] = "USER";
    return EntityType;
}({});
var $e40ae21eed558c2b$export$af2022a36dc13b47 = /*#__PURE__*/ function(PermissionType) {
    PermissionType["EDIT"] = "EDIT";
    PermissionType["VIEW"] = "VIEW";
    return PermissionType;
}({});
var $e40ae21eed558c2b$export$efe8384a5aa2f235 = /*#__PURE__*/ function(ErrorMessageType) {
    ErrorMessageType["NO_ANCESTOR_VIEW"] = "NO_ANCESTOR_VIEW";
    ErrorMessageType["NO_SPACE_VIEW"] = "NO_SPACE_VIEW";
    ErrorMessageType["NO_SPACE_EDIT"] = "NO_SPACE_EDIT";
    return ErrorMessageType;
}({});
var $e40ae21eed558c2b$export$4ecc254c2ddad822 = /*#__PURE__*/ function(OpenDialogType) {
    OpenDialogType["INSPECT_PERMISSIONS"] = "INSPECT_PERMISSIONS";
    OpenDialogType["ACCESS_DETAILS"] = "ACCESS_DETAILS";
    OpenDialogType["RESTRICTIONS"] = "RESTRICTIONS";
    OpenDialogType["PUBLIC_LINKS_VALIDATION"] = "PUBLIC_LINKS_VALIDATION";
    return OpenDialogType;
}({});
module.exports["ContentRestrictionType"] = $e40ae21eed558c2b$export$91111a1ebace330;
module.exports["RestrictionFrom"] = $e40ae21eed558c2b$export$7602248773d1f745;
module.exports["EntityType"] = $e40ae21eed558c2b$export$8eda7e02f8f033b2;
module.exports["PermissionType"] = $e40ae21eed558c2b$export$af2022a36dc13b47;
module.exports["ErrorMessageType"] = $e40ae21eed558c2b$export$efe8384a5aa2f235;
module.exports["OpenDialogType"] = $e40ae21eed558c2b$export$4ecc254c2ddad822;

});

parcelRegister("9lU4Z", function(module, exports) {
/**
 * @generated SignedSource<<702dcff845a2fa326efa462282b4bee2>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $4fac0aee9a82e652$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $4fac0aee9a82e652$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $4fac0aee9a82e652$export$8995abb8169b2cb8;

});

parcelRegister("1Z5gD", function(module, exports) {
function $17840b2543ea5a50$export$2df47a0d4dfb6635(data) {
    // If there is no data to sanitize, just return it
    if (!data) return data;
    // Deep clone to avoid mutating the original data - with proper typing
    const sanitizedData = JSON.parse(JSON.stringify(data));
    // Iterate through all restriction operations (read, update, etc.)
    Object.keys(sanitizedData).forEach((operation)=>{
        const contentRestriction = sanitizedData[operation];
        const groupResults = contentRestriction?.restrictions?.group?.results;
        if (Array.isArray(groupResults)) groupResults.forEach((group)=>{
            // Remove usageType field if it exists (Teams have this field)
            if ('usageType' in group) Reflect.deleteProperty(group, 'usageType');
        });
    });
    return sanitizedData;
}
module.exports["sanitizeRestrictionsForGraphQL"] = $17840b2543ea5a50$export$2df47a0d4dfb6635;

});

parcelRegister("c6abH", function(module, exports) {
const $39da9b0f89d8b5d0$export$e089b3c2861d2024 = '9:00';
const $39da9b0f89d8b5d0$export$c4e1e4e065ff5bd8 = 'HH:mm';
const $39da9b0f89d8b5d0$export$ec93f019c59056da = 5;
const $39da9b0f89d8b5d0$export$45c85543ba71221d = 'yyyy-MM-dd';
var $39da9b0f89d8b5d0$export$377e0d8530a6da1a = /*#__PURE__*/ function(PublishErrorFlagKeys) {
    PublishErrorFlagKeys["TITLE_IS_BLANK"] = "TITLE_IS_BLANK";
    PublishErrorFlagKeys["DUPLICATE_TITLE"] = "TITLE_EXISTS_IN_SPACE";
    return PublishErrorFlagKeys;
}({});
const $39da9b0f89d8b5d0$export$9467f27273d92816 = {
    PMF1: 'PMF1',
    PMF2: 'PMF2',
    USB1: 'USB1',
    PBWMO1: 'PBWMO1',
    PBWMO2: 'PBWMO2',
    PBWMO3: 'PBWMO3',
    PBWMO4: 'PBWMO4',
    PBWMO5: 'PBWMO5',
    PMKS1: 'PMKS1',
    PMKS2: 'PMKS2'
};
module.exports["DEFAULT_TIME"] = $39da9b0f89d8b5d0$export$e089b3c2861d2024;
module.exports["TIME_FORMAT"] = $39da9b0f89d8b5d0$export$c4e1e4e065ff5bd8;
module.exports["MINUTES_IN_FUTURE"] = $39da9b0f89d8b5d0$export$ec93f019c59056da;
module.exports["DATE_FORMAT"] = $39da9b0f89d8b5d0$export$45c85543ba71221d;
module.exports["PublishErrorFlagKeys"] = $39da9b0f89d8b5d0$export$377e0d8530a6da1a;
module.exports["SHORTCUT_KEYS"] = $39da9b0f89d8b5d0$export$9467f27273d92816;

});

parcelRegister("hFmJ6", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $5741aa37d7d9aa33$export$f89e455c6b94692 = (0, $eSUdr.default)`query PublishModalWithMoreOptionsQuery($contentId:ID){singleContent(id:$contentId){id type space{id}schedulePublishInfo{date versionComment minorEdit targetType targetLocation{parentId destinationSpace{id key alias}}restrictions{update{user:personConnection{edges{node{email permissionType displayName accountId publicName profilePicture{path}}}}group{edges{node{name id}}}}read{user:personConnection{edges{node{email permissionType displayName accountId publicName profilePicture{path}}}}group{edges{node{name id}}}}}}}}`;
module.exports["PublishModalWithMoreOptionsQuery"] = $5741aa37d7d9aa33$export$f89e455c6b94692;

});

parcelRegister("6pob4", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $11195e31c84c0d05$export$f2a208b9886d2628 = (0, $1P1Tu.createStore)({
    name: 'PublishModalMountStore',
    initialState: {
        shouldDisplayPublishModal: false,
        initialFocusTarget: undefined
    },
    actions: {
        openPublishModal: ()=>({ setState: setState })=>setState({
                    shouldDisplayPublishModal: true
                }),
        closePublishModal: ()=>({ setState: setState })=>setState({
                    shouldDisplayPublishModal: false
                }),
        setInitialFocusTarget: (newFocusTarget)=>({ setState: setState })=>setState({
                    initialFocusTarget: newFocusTarget
                })
    }
});
const $11195e31c84c0d05$export$7cf94392fd4ac5a6 = (0, $9zUhf.createStateHook)($11195e31c84c0d05$export$f2a208b9886d2628);
const $11195e31c84c0d05$export$19811b111083a6d = (0, $9zUhf.createActionsHook)($11195e31c84c0d05$export$f2a208b9886d2628);
module.exports["usePublishModalMountStore"] = $11195e31c84c0d05$export$7cf94392fd4ac5a6;
module.exports["usePublishModalMountActions"] = $11195e31c84c0d05$export$19811b111083a6d;

});

parcelRegister("dpPtd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $c997cd3fd9f4ee84$export$2879604e6aec4ab() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c997cd3fd9f4ee84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
                    return /*#__PURE__*/ (0, $42omo.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$export$a4270ab432ac8a58, {
        children: fn()
    });
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("essql", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $jMyy4 = parcelRequire("jMyy4");


var $4L9ve = parcelRequire("4L9ve");


var $aUU0C = parcelRequire("aUU0C");


var $bQm3c = parcelRequire("bQm3c");


var $8WQTF = parcelRequire("8WQTF");


var $htsj6 = parcelRequire("htsj6");


var $aqBZ0 = parcelRequire("aqBZ0");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $9nXVV = parcelRequire("9nXVV");


var $3bH25 = parcelRequire("3bH25");


var $9SEzS = parcelRequire("9SEzS");


var $e4kZB = parcelRequire("e4kZB");

const $2524304961e9b056$var$MAX_UNREAD_COMMENTS_SUPPORTED = 1000;
const $2524304961e9b056$var$unreadCommentsQuery = (0, $eSUdr.default)`query useUnreadCommentsSetupQuery($pageId:ID!$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId contentStatus:$contentStatus type:UNRESOLVED depth:ROOT){nodes{id location{type ...on InlineComment{inlineMarkerRef inlineResolveProperties{resolved isDangling}}}author{permissionType ...on KnownUser{accountId}}createdAt{value}replies{id author{permissionType ...on KnownUser{accountId}}createdAt{value}location{type ...on InlineComment{inlineMarkerRef inlineResolveProperties{resolved}}}}}totalCount}}`;
const $2524304961e9b056$export$3c5a4187b7dbe412 = ({ pageId: pageId, pageContentTypeProps: pageContentTypeProps, onCommentRead: onCommentRead })=>{
    const [{ shouldUpdateUnreadCommentsOnFirstRender: shouldUpdateUnreadCommentsOnFirstRender }, { updateUnreadCommentsOnFirstRender: updateUnreadCommentsOnFirstRender, setIsUnreadQueryLoading: setIsUnreadQueryLoading, updateUnreadCommentIDSet: updateUnreadCommentIDSet, setShouldClearVisibleThreads: setShouldClearVisibleThreads }] = (0, $fHAwL.useUnreadComments)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    // Setup observer for unread comments
    (0, $9nXVV.useUnreadCommentsObserverSetup)({
        pageId: pageId,
        onCommentRead: onCommentRead
    });
    // Destructure pageContentTypeProps with defaults
    const { pageMode: pageMode, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList = [], commentsDataMap: legacyCommentsDataMap = {
        inline: {},
        general: {}
    }, addNewCommentThreads: addNewCommentThreads } = pageContentTypeProps || {};
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const { isDanglingCallback: isDanglingCallback } = (0, $3bH25.useIsDanglingCallback)({
        pageMode: pageMode
    });
    // We still need these for the logic in handleUpdateUnreadComments
    const [editorAnnotationsState] = (0, $aUU0C.useEditorAnnotations)();
    const { annotations: annotations, pageId: editorPageId } = editorAnnotationsState;
    const isRenderer = pageMode === 'view';
    const rendererActionsResult = (0, $8WQTF.useRendererActions)();
    const { rendererActions: rendererActions, pageId: rendererPageId } = rendererActionsResult || {};
    const { getViewedCommentsFresh: getViewedCommentsFresh } = (0, $d3bcC.useViewedComments)({
        pageId: pageId || ''
    });
    const legacyQueryResult = (0, $jMyy4.useQueryInterop)($2524304961e9b056$var$unreadCommentsQuery, {
        variables: {
            pageId: pageId || '',
            contentStatus: !isRenderer ? [
                (0, $9SEzS.GraphQLContentStatus).CURRENT,
                (0, $9SEzS.GraphQLContentStatus).DRAFT
            ] : [
                (0, $9SEzS.GraphQLContentStatus).CURRENT
            ]
        },
        skip: !pageId || !(0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes') || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    const loading = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? !processedCommentsData.isDataProcessed : legacyQueryResult.loading;
    const error = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.error : legacyQueryResult.error;
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        // isUnreadQueryLoading is used in other areas of the code to make sure unread logic is processed before further logic
        setIsUnreadQueryLoading(loading);
    }, [
        loading,
        setIsUnreadQueryLoading
    ]);
    // Handle GraphQL query errors with proper error handling
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes') || !error || !pageId) return;
        // Handle expected errors (403/unauthorized, network errors) - just mark as handled
        if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return;
        }
        // Handle unexpected errors (including 500) - track them with context
        (0, $fJlJm.setContentErrorAttributes)(error, {
            objectId: pageId,
            objectType: 'page'
        });
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMMENTS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error,
        pageId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        if (pageId) {
            updateUnreadCommentIDSet(new Set(), 'removeAll');
            setShouldClearVisibleThreads(false);
            // reset so we can recreate the set for the page that the user is changing to
            updateUnreadCommentsOnFirstRender(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageId
    ]);
    const resetStates = (0, $42omo.useCallback)(()=>{
        updateUnreadCommentsOnFirstRender(false);
    }, [
        updateUnreadCommentsOnFirstRender
    ]);
    const handleUpdateUnreadComments = (0, $42omo.useCallback)(async ()=>{
        if (userId && shouldUpdateUnreadCommentsOnFirstRender) {
            if (loading) return [];
            if (!pageId) return;
            const currentAllCommentsFromQuery = (()=>{
                // When feature flag is enabled, use data from ProcessedCommentsDataStore
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return processedCommentsData.openComments || [];
                // Legacy path: use data from unreadCommentsQuery
                // Validate that the query was executed for the current page
                if (legacyQueryResult.variables?.pageId !== pageId) return [];
                const filteredNodes = legacyQueryResult.data?.comments?.nodes?.filter((node)=>node !== null) || [];
                if (filteredNodes.length === 0) return [];
                return filteredNodes;
            })();
            if (currentAllCommentsFromQuery.length === 0) {
                resetStates(); // we no longer need to create the set if there are no comments on the page
                return;
            }
            // Skip if renderer actions or editor annotations are for different page
            if (pageMode && (isRenderer && rendererActions && rendererPageId !== pageId || !isRenderer && annotations && editorPageId !== pageId)) return; // Wait for next rerender when rendererActions / annotations are updated for the current page
            const rendererAnnotations = rendererActions?.getAnnotationMarks() || [];
            const annotationsInEditorDoc = new Set(annotations || []);
            if (currentAllCommentsFromQuery.length < $2524304961e9b056$var$MAX_UNREAD_COMMENTS_SUPPORTED) {
                const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
                const hasPageComments = currentAllCommentsFromQuery.some((comment)=>comment?.location?.type === 'FOOTER');
                // skip creating unread comments set if the page is archived
                // or if there are no page comments and inline comments
                if (isArchived || pageMode && !hasPageComments && (isRenderer && rendererAnnotations?.length === 0 || !isRenderer && annotationsInEditorDoc?.size === 0)) return;
                // continuing here means one of these 3 scenarios are true so we do want to check for unread comments
                // 1. no inline comments, yes page comments
                // 2. yes inline comments, no page comments
                // 3. yes inline comments, yes page comments
                const viewedComments = await getViewedCommentsFresh();
                if (viewedComments.success && viewedComments.data) (0, $e4kZB.createUnreadCommentsSet)({
                    allComments: currentAllCommentsFromQuery,
                    currentUserId: userId,
                    pageId: pageId,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    resetStates: resetStates,
                    viewedComments: viewedComments.data,
                    isDanglingCallback: isDanglingCallback,
                    addNewCommentThreads: addNewCommentThreads
                });
            }
        }
    }, [
        userId,
        shouldUpdateUnreadCommentsOnFirstRender,
        loading,
        pageId,
        pageMode,
        isRenderer,
        rendererActions,
        rendererPageId,
        annotations,
        editorPageId,
        legacyQueryResult.variables?.pageId,
        legacyQueryResult.data?.comments?.nodes,
        processedCommentsData.openComments,
        resetStates,
        contentStatus,
        getViewedCommentsFresh,
        updateUnreadCommentIDSet,
        isDanglingCallback,
        addNewCommentThreads
    ]);
    (0, $3bH25.useDanglingAndResolvedHandler)({
        orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
        commentsDataMap: commentsDataMap,
        userId: userId || '',
        pageId: pageId || '',
        isDanglingCallback: pageMode ? isDanglingCallback : undefined // use dangling callback if content type is a page
    });
    (0, $42omo.useEffect)(()=>{
        const isNotPageContentType = !pageContentTypeProps;
        if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        isNotPageContentType && !(0, $9wGTI.fg)('cc-whiteboards-consolidating-comments-unread') || pageContentTypeProps && !(0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        handleUpdateUnreadComments();
    }, [
        handleUpdateUnreadComments,
        rendererActions,
        annotations,
        pageContentTypeProps
    ]);
};
module.exports["useUnreadCommentsSetup"] = $2524304961e9b056$export$3c5a4187b7dbe412;

});

parcelRegister("d3bcC", function(module, exports) {

var $5VFXo = parcelRequire("5VFXo");


var $aXiya = parcelRequire("aXiya");


var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $jMyy4 = parcelRequire("jMyy4");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");


var $ep3mz = parcelRequire("ep3mz");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $18a2fd912dfb58ac$var$ContentAnalyticsViewedComments = (0, $eSUdr.default)`query useViewedCommentsQuery($contentId:ID!$contentType:ConfluenceAnalyticsCommentContentType!){contentAnalyticsViewedComments(contentId:$contentId contentType:$contentType){commentIds}}`;
// Helper function to safely convert content type for the viewed comments query
const $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments = (contentType)=>{
    // Only page, database, and whiteboard support the viewed comments query
    if (contentType === 'page' || contentType === 'database' || contentType === 'whiteboard') return contentType;
    // Fallback to page for other content types (blogpost, embed, etc.)
    return 'page';
};
// Helper to generate stable ROOT_QUERY cache key
// Ensures consistent key format regardless of object property order
const $18a2fd912dfb58ac$var$getRootQueryCacheId = (pageId, contentType)=>{
    const validContentType = $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType);
    // Sort keys to ensure stable JSON.stringify output
    const variables = {
        contentId: pageId,
        contentType: validContentType
    };
    return `$ROOT_QUERY.contentAnalyticsViewedComments(${JSON.stringify(variables)})`;
};
const $18a2fd912dfb58ac$export$cd81a9ad0848990 = ({ pageId: pageId })=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $aXiya.default)
    });
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5VFXo.default)
    });
    // Network-only query for fresh data
    const { refetch: refetch } = (0, $jMyy4.useQueryInterop)(/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ $18a2fd912dfb58ac$var$ContentAnalyticsViewedComments, {
        skip: true,
        // Never query on render
        fetchPolicy: 'network-only',
        variables: {
            contentId: pageId,
            contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
        }
    });
    // Helper function to process the query result
    const processQueryResult = (0, $42omo.useCallback)((data)=>{
        const commentIds = data?.contentAnalyticsViewedComments?.commentIds ?? [];
        const viewedCommentsSet = new Set(commentIds.filter((id)=>id !== null));
        return {
            success: true,
            data: viewedCommentsSet
        };
    }, []);
    // Helper function for cache-only queries
    const executeCacheOnlyQuery = (0, $42omo.useCallback)(()=>{
        if (!pageId || !contentType) throw new Error('Page ID and content type are required');
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            if (rootQueryData) {
                // Convert fragment data to query result format
                const queryResult = {
                    contentAnalyticsViewedComments: {
                        commentIds: rootQueryData.commentIds,
                        __typename: 'ViewedComments'
                    }
                };
                return processQueryResult(queryResult);
            }
            return {
                success: false,
                error: new Error('No viewed comments data found in cache')
            };
        } catch (error) {
            // Handle cache read errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        readFragmentInterop
    ]);
    // Helper function for network-only queries
    const executeNetworkOnlyQuery = (0, $42omo.useCallback)(async ()=>{
        if (!pageId) throw new Error('Page ID and content type are required');
        try {
            const result = await refetch({
                contentId: pageId,
                contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
            });
            // Apollo automatically writes query results to ROOT_QUERY cache, so we don't need to explicitly write
            // The executeCacheOnlyQuery function will read from ROOT_QUERY directly
            return processQueryResult(result.data);
        } catch (error) {
            // Handle expected errors (403/unauthorized, network errors) - just mark as handled
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return {
                    success: false,
                    error: error
                };
            }
            // Handle unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        refetch
    ]);
    // Cached data query - uses cache-only for performance
    const getViewedCommentsCacheOnly = (0, $42omo.useCallback)(()=>{
        try {
            return executeCacheOnlyQuery();
        } catch (error) {
            return {
                success: false,
                error: error
            };
        }
    }, [
        executeCacheOnlyQuery
    ]);
    // Fresh data query - always uses network-only for latest data
    const getViewedCommentsFresh = (0, $42omo.useCallback)(()=>executeNetworkOnlyQuery(), [
        executeNetworkOnlyQuery
    ]);
    // Function to update the viewed comments cache
    // This is used for optimistic updates when comments are viewed locally
    const updateViewedCommentsCache = (0, $42omo.useCallback)((commentIds)=>{
        if (!pageId || !contentType || commentIds.length === 0) return;
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            const existingCommentIds = rootQueryData?.commentIds ?? [];
            // Merge new comment IDs with existing ones
            const existingSet = new Set(existingCommentIds.filter((id)=>id !== null));
            commentIds.forEach((id)=>existingSet.add(id));
            const mergedCommentIds = Array.from(existingSet);
            // Update ROOT_QUERY cache
            writeFragmentInterop({
                fragmentId: rootQueryCacheId,
                data: {
                    commentIds: mergedCommentIds,
                    __typename: 'ViewedComments'
                }
            });
        } catch (error) {
            // Handle cache writing errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        pageId,
        contentType,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    return {
        getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
        getViewedCommentsFresh: getViewedCommentsFresh,
        updateViewedCommentsCache: updateViewedCommentsCache
    };
};
module.exports["useViewedComments"] = $18a2fd912dfb58ac$export$cd81a9ad0848990;

});

parcelRegister("5VFXo", function(module, exports) {
/**
 * @generated SignedSource<<d7ff2c3ce2ccb5f9937eae905c203b17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a1027eddc6949c38$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_read",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$a1027eddc6949c38$var$node.hash = "8133cc01831582777d2e0911570e19eb";
var $a1027eddc6949c38$export$2e2bcd8739ae039 = $a1027eddc6949c38$var$node;
module.exports["default"] = $a1027eddc6949c38$export$2e2bcd8739ae039;

});

parcelRegister("aXiya", function(module, exports) {
/**
 * @generated SignedSource<<4105699bb3b57f32cd10410da7fded55>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7e3d4a4e06abb15d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_write",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$7e3d4a4e06abb15d$var$node.hash = "d155cf7774eeec1efd57aa640539aef9";
var $7e3d4a4e06abb15d$export$2e2bcd8739ae039 = $7e3d4a4e06abb15d$var$node;
module.exports["default"] = $7e3d4a4e06abb15d$export$2e2bcd8739ae039;

});

parcelRegister("9nXVV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $c1UWH = parcelRequire("c1UWH");


var $fHAwL = parcelRequire("fHAwL");


var $1czFr = parcelRequire("1czFr");


var $d3bcC = parcelRequire("d3bcC");

const $b14365a28be63efb$var$MARK_COMMENTS_AS_READ_DEBOUNCE_MS = 1000;
const $b14365a28be63efb$export$d5d84acfffa9b3ca = ({ pageId: pageId, onCommentRead: onCommentRead })=>{
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { debouncedMarkCommentsAsRead: debouncedMarkCommentsAsRead, flushPendingComments: flushPendingComments } = (0, $1czFr.useDebouncedMarkCommentsAsRead)($b14365a28be63efb$var$MARK_COMMENTS_AS_READ_DEBOUNCE_MS);
    const { updateViewedCommentsCache: updateViewedCommentsCache } = (0, $d3bcC.useViewedComments)({
        pageId: pageId || ''
    });
    const intersectionCallback = (0, $42omo.useCallback)((commentId)=>{
        if (commentId) {
            updateUnreadCommentIDSet(new Set([
                commentId
            ]), 'remove');
            debouncedMarkCommentsAsRead(commentId);
            updateViewedCommentsCache([
                commentId
            ]);
            if ((0, $9wGTI.fg)('cc-whiteboards-consolidating-comments-unread')) // Notify external systems about the comment being read (e.g. content types, whiteboards, databases)
            onCommentRead?.([
                commentId
            ]);
        }
    }, [
        updateUnreadCommentIDSet,
        debouncedMarkCommentsAsRead,
        updateViewedCommentsCache,
        onCommentRead
    ]);
    // Create refs to avoid stale closures in useEffect
    const intersectionCallbackRef = (0, $42omo.useRef)(intersectionCallback);
    intersectionCallbackRef.current = intersectionCallback;
    const flushPendingCommentsRef = (0, $42omo.useRef)(flushPendingComments);
    flushPendingCommentsRef.current = flushPendingComments;
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes') || !pageId) return;
        const observer = (0, $c1UWH.getUnreadCommentsIntersectionObserver)();
        observer.registerIntersectionCallback((commentId)=>{
            intersectionCallbackRef.current(commentId);
        });
        return ()=>{
            observer.disconnect();
            flushPendingCommentsRef.current();
        };
    }, [
        pageId
    ]);
};
module.exports["useUnreadCommentsObserverSetup"] = $b14365a28be63efb$export$d5d84acfffa9b3ca;

});

parcelRegister("c1UWH", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

class $992a1265dc051ead$var$UnreadCommentsIntersectionObserver {
    createObserver() {
        try {
            if (typeof IntersectionObserver === 'undefined') return;
            this.observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    const commentId = entry.target.getAttribute('data-comment-id');
                    if (!commentId) return;
                    if (entry.isIntersecting) {
                        // Comment became visible - set new timer for this specific comment
                        const timer = setTimeout(()=>{
                            this.intersectionCallbacks.forEach((callback)=>{
                                callback(commentId);
                            });
                            // Clear the timer for this comment
                            this.commentTimersMap.delete(commentId);
                            // Unobserve this element since it's been processed
                            if (this.observer) {
                                this.observer.unobserve(entry.target);
                                this.observedElementsSet.delete(entry.target);
                            }
                        }, 2000); // 2 seconds default
                        this.commentTimersMap.set(commentId, timer);
                    } else // Comment became invisible - clear timer for this comment
                    if (this.commentTimersMap.has(commentId)) {
                        clearTimeout(this.commentTimersMap.get(commentId));
                        this.commentTimersMap.delete(commentId);
                    }
                });
            }, {
                threshold: [
                    0.25
                ],
                // add a bottom root margin to account for sticky elements at the bottom of the observable viewport such as the sticky footer
                // this is because the intersection observer doesn't know about elements that are above the observed comments, and so we can avoid
                // marking comments as read when they're not actually visible to the user. this is a best effort approach
                rootMargin: '0px 0px -65px 0px',
                // Add a custom name to identify this as the unread comments observer
                // This helps in tests to distinguish it from other intersection observers
                name: 'unreadCommentsObserver'
            });
        } catch  {
            this.observer = null;
        }
    }
    observeComment(targetElement) {
        // don't observe if the observer is not initialized
        if (!this.observer) return;
        // don't observe if the targetElement is not a valid element
        if (!targetElement) return;
        // don't observe the same element twice
        if (this.observedElementsSet.has(targetElement)) return;
        this.observer.observe(targetElement);
        this.observedElementsSet.add(targetElement);
    }
    unobserveComment(targetElement) {
        // don't unobserve if the observer is not initialized
        if (!this.observer) return;
        // don't unobserve if the targetElement is not a valid element
        if (!targetElement) return;
        // only unobserve if we're actually observing this element
        if (!this.observedElementsSet.has(targetElement)) return;
        // Clear any running timer for this comment
        const commentId = targetElement.getAttribute('data-comment-id');
        if (commentId && this.commentTimersMap.has(commentId)) {
            clearTimeout(this.commentTimersMap.get(commentId));
            this.commentTimersMap.delete(commentId);
        }
        this.observer.unobserve(targetElement);
        this.observedElementsSet.delete(targetElement);
    }
    // By exposing this function, we allow consumers to register callbacks
    registerIntersectionCallback(callback) {
        this.intersectionCallbacks.push(callback);
    }
    // Reconnect the observer if it was disconnected
    reconnect() {
        if (!this.observer) this.createObserver();
    }
    // Clean up method
    disconnect() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        // Clear all timers
        this.commentTimersMap.forEach((timer)=>clearTimeout(timer));
        this.commentTimersMap.clear();
        // Clear observed elements
        this.observedElementsSet.clear();
        // Clear callbacks
        this.intersectionCallbacks = [];
    }
    constructor(){
        this.observer = null;
        this.commentTimersMap = new Map();
        this.observedElementsSet = new Set();
        this.intersectionCallbacks = [];
        this.createObserver();
    }
}
// memoize ensures an IntersectionObserver is instantiated only once
const $992a1265dc051ead$var$getStableIntersectionObserver = (0, $2XqLN.default)(()=>{
    return new $992a1265dc051ead$var$UnreadCommentsIntersectionObserver();
});
const $992a1265dc051ead$export$ad65f5516d9692ed = ()=>{
    const intersectionObserver = $992a1265dc051ead$var$getStableIntersectionObserver();
    intersectionObserver.reconnect();
    return intersectionObserver;
};
module.exports["getUnreadCommentsIntersectionObserver"] = $992a1265dc051ead$export$ad65f5516d9692ed;

});

parcelRegister("1czFr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gi0WF = parcelRequire("gi0WF");

const $e63c8ea486e09ced$export$faaf0da9552bb131 = (debounceMs = 1000)=>{
    const markCommentsAsRead = (0, $gi0WF.useMarkCommentsAsRead)();
    const pendingCommentIds = (0, $42omo.useRef)(new Set());
    const timeoutRef = (0, $42omo.useRef)(null);
    const beforeUnloadHandlerRef = (0, $42omo.useRef)(null);
    const debouncedMarkCommentsAsRead = (0, $42omo.useCallback)((commentId)=>{
        // Add the comment ID to the pending set
        pendingCommentIds.current.add(commentId);
        // Clear any existing timeout
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        // Set a new timeout to batch and send the request
        timeoutRef.current = setTimeout(()=>{
            const commentIdsToMark = Array.from(pendingCommentIds.current);
            // Clear the pending set
            pendingCommentIds.current.clear();
            // Reset the timeout ref
            timeoutRef.current = null;
            // Only call the mutation if there are comments to mark
            if (commentIdsToMark.length > 0) markCommentsAsRead(commentIdsToMark);
        }, debounceMs);
    }, [
        markCommentsAsRead,
        debounceMs
    ]);
    // Function to send pending comment IDs
    const sendPendingComments = (0, $42omo.useCallback)(()=>{
        const commentIdsToMark = Array.from(pendingCommentIds.current);
        if (commentIdsToMark.length === 0) return;
        // Clear the pending set
        pendingCommentIds.current.clear();
        // Just call the existing mutation function
        markCommentsAsRead(commentIdsToMark);
    }, [
        markCommentsAsRead
    ]);
    // Beforeunload event handler (e.g. when the user closes the tab or window)
    const handleBeforeUnload = (0, $42omo.useCallback)((_event)=>{
        sendPendingComments();
    }, [
        sendPendingComments
    ]);
    // Set up beforeunload event listener
    (0, $42omo.useEffect)(()=>{
        beforeUnloadHandlerRef.current = handleBeforeUnload;
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [
        handleBeforeUnload
    ]);
    // Flush pending comments and clear timeout
    const flushPendingComments = (0, $42omo.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        // Send any pending comments
        sendPendingComments();
    }, [
        sendPendingComments
    ]);
    return {
        debouncedMarkCommentsAsRead: debouncedMarkCommentsAsRead,
        flushPendingComments: flushPendingComments
    };
};
module.exports["useDebouncedMarkCommentsAsRead"] = $e63c8ea486e09ced$export$faaf0da9552bb131;

});

parcelRegister("gi0WF", function(module, exports) {
/** @graphql agg **/ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $308Wd = parcelRequire("308Wd");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $bMmYR = parcelRequire("bMmYR");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");

const $170c9bba7ed44542$var$markCommentsAsReadMutation = (0, $eSUdr.default)`mutation useMarkCommentsAsReadMutation($commentIds:[ID!]!){markCommentsAsRead(input:{commentIds:$commentIds}){success errors}}`;
const $170c9bba7ed44542$export$db614d7d47784b95 = ()=>{
    const [markCommentsAsRead] = (0, $308Wd.useMutationInterop)(// @ts-expect-error -- http://go/cfe-use-relay-artifacts
    $170c9bba7ed44542$var$markCommentsAsReadMutation);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const markCommentsAsReadFn = (0, $42omo.useCallback)(async (commentIds)=>{
        if (commentIds.length === 0) return;
        // Start experience tracking for marking comments as read
        experienceTracker.start({
            name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
            attributes: {
                commentIds: commentIds,
                commentCount: commentIds.length
            }
        });
        let attemptNumber = 1;
        try {
            const result = await (0, $bMmYR.retry)(async (attempt)=>{
                attemptNumber = attempt + 1;
                return await markCommentsAsRead({
                    variables: {
                        commentIds: commentIds
                    }
                });
            }, {}, async (error)=>{
                // Don't retry for expected errors (403/unauthorized, network errors)
                return !(0, $1uFM6.isUnauthorizedError)(error) && !(0, $6fil2.containsNetworkError)(error);
            });
            // Check if the mutation succeeded
            if (result?.data?.markCommentsAsRead?.success) // Mark experience as successful
            experienceTracker.succeed({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                attributes: {
                    commentIds: commentIds,
                    commentCount: commentIds.length,
                    attemptNumber: attemptNumber
                }
            });
            else // Backend returned success: false
            experienceTracker.fail({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                error: new Error('Backend returned success: false'),
                attributes: {
                    attemptNumber: attemptNumber
                }
            });
        } catch (err) {
            // Handle expected errors (403/unauthorized, network errors) - abort experience tracking
            if ((0, $1uFM6.isUnauthorizedError)(err) || (0, $6fil2.containsNetworkError)(err)) {
                experienceTracker.abort({
                    name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                    reason: 'Expected error (unauthorized or network error)'
                });
                (0, $7Sm4c.markErrorAsHandled)(err);
                return;
            }
            // Mark experience as failed for unexpected errors
            experienceTracker.fail({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                error: err,
                attributes: {
                    attemptNumber: attemptNumber
                }
            });
            // Handle unexpected errors (including 500) - track them with context
            (0, $fJlJm.setContentErrorAttributes)(err, {
                objectType: 'comment'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(err);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- experienceTracker from context doesn't need to be in deps
    [
        markCommentsAsRead
    ]);
    return markCommentsAsReadFn;
};
module.exports["useMarkCommentsAsRead"] = $170c9bba7ed44542$export$db614d7d47784b95;

});

parcelRegister("3bH25", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $aUU0C = parcelRequire("aUU0C");


var $8WQTF = parcelRequire("8WQTF");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $e4kZB = parcelRequire("e4kZB");

const $280745ffe1b8b376$export$30b625574e8a38c7 = ({ pageMode: pageMode })=>{
    const [editorAnnotationsState] = (0, $aUU0C.useEditorAnnotations)();
    const { annotations: annotations } = editorAnnotationsState;
    const rendererActionsResult = (0, $8WQTF.useRendererActions)();
    const { rendererActions: rendererActions } = rendererActionsResult || {};
    const isDanglingCallback = (0, $42omo.useCallback)((markerRef)=>{
        if (!pageMode) return false;
        return (0, $e4kZB.commentIsDangling)({
            pageMode: pageMode,
            annotationsInEditorDoc: new Set(annotations),
            rendererAnnotations: new Set(rendererActions?.getAnnotationMarks()?.map((ann)=>ann.attrs.id).filter(Boolean) || [])
        })(markerRef);
    }, [
        annotations,
        rendererActions,
        pageMode
    ]);
    return {
        isDanglingCallback: isDanglingCallback
    };
};
// Helper function to process added annotations (reopened / undangled)
const $280745ffe1b8b376$var$processAddedAnnotations = ({ currentList: currentList, previousThreadKeys: previousThreadKeys, commentsDataMap: commentsDataMap, viewedComments: viewedComments, userId: userId, isDanglingCallback: isDanglingCallback })=>{
    const addedCommentIds = new Set();
    for (const annotation of currentList)if (!previousThreadKeys.has(annotation.threadKey)) {
        const commentData = commentsDataMap.inline[annotation.threadKey];
        if (commentData) {
            // Early return if comment is already viewed
            if (viewedComments.has(commentData.id)) return addedCommentIds;
            // Add the main comment ID if it's a valid unread comment
            if ((0, $e4kZB.isValidUnreadComment)({
                comment: commentData,
                currentUserId: userId,
                viewedComments: viewedComments,
                isDanglingCallback: isDanglingCallback
            })) addedCommentIds.add(commentData.id);
            // Add all reply IDs if they're valid unread comments
            commentData.replies?.forEach((reply)=>{
                if (reply) {
                    // Skip if reply is already viewed
                    if (viewedComments.has(reply.id)) return;
                    if ((0, $e4kZB.isValidUnreadComment)({
                        comment: reply,
                        currentUserId: userId,
                        viewedComments: viewedComments,
                        isDanglingCallback: isDanglingCallback
                    })) addedCommentIds.add(reply.id);
                }
            });
        }
    }
    return addedCommentIds;
};
// Helper function to process removed annotations (resolved / dangled)
const $280745ffe1b8b376$var$processRemovedAnnotations = ({ previousList: previousList, currentThreadKeys: currentThreadKeys, commentsDataMap: commentsDataMap })=>{
    const removedCommentIds = new Set();
    for (const annotation of previousList)if (!currentThreadKeys.has(annotation.threadKey)) {
        const commentData = commentsDataMap.inline[annotation.threadKey];
        if (commentData) {
            // Add the main comment ID
            removedCommentIds.add(commentData.id);
            // Add all reply IDs
            commentData.replies?.forEach((reply)=>{
                if (reply) removedCommentIds.add(reply.id);
            });
        }
    }
    return removedCommentIds;
};
const $280745ffe1b8b376$export$ce2ddc24e5a132d = ({ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: commentsDataMap, userId: userId, pageId: pageId, isDanglingCallback: isDanglingCallback })=>{
    const [{ shouldUpdateUnreadCommentsOnFirstRender: shouldUpdateUnreadCommentsOnFirstRender }, { updateUnreadCommentIDSet: updateUnreadCommentIDSet }] = (0, $fHAwL.useUnreadComments)();
    const { getViewedCommentsCacheOnly: getViewedCommentsCacheOnly } = (0, $d3bcC.useViewedComments)({
        pageId: pageId
    });
    // Keep track of the previous orderedActiveAnnotationIdList
    const previousOrderedActiveAnnotationIdListRef = (0, $42omo.useRef)(orderedActiveAnnotationIdList);
    // Handle the async getViewedComments call
    const processAnnotations = (0, $42omo.useCallback)(async ()=>{
        const previousList = previousOrderedActiveAnnotationIdListRef.current;
        const currentList = orderedActiveAnnotationIdList;
        // Early exit if lists are identical (same length)
        if (previousList.length === currentList.length) return;
        // Build thread key sets for processing
        const previousThreadKeys = new Set(previousList.map((annotation)=>annotation.threadKey));
        const currentThreadKeys = new Set(currentList.map((annotation)=>annotation.threadKey));
        const viewedCommentsResult = getViewedCommentsCacheOnly();
        if (!viewedCommentsResult.success || !viewedCommentsResult.data) return;
        const viewedComments = viewedCommentsResult.data;
        // Process added annotations (reopened / undangled)
        const addedCommentIds = $280745ffe1b8b376$var$processAddedAnnotations({
            currentList: currentList,
            previousThreadKeys: previousThreadKeys,
            commentsDataMap: commentsDataMap,
            viewedComments: viewedComments,
            userId: userId,
            isDanglingCallback: isDanglingCallback
        });
        // Process removed annotations (resolved / dangled)
        const removedCommentIds = $280745ffe1b8b376$var$processRemovedAnnotations({
            previousList: previousList,
            currentThreadKeys: currentThreadKeys,
            commentsDataMap: commentsDataMap
        });
        // Update unread comment ID set for added annotations
        if (addedCommentIds.size > 0) updateUnreadCommentIDSet(addedCommentIds, 'add');
        // Update unread comment ID set for removed annotations
        if (removedCommentIds.size > 0) updateUnreadCommentIDSet(removedCommentIds, 'remove');
        // Update the previous list ref to current list for next comparison
        previousOrderedActiveAnnotationIdListRef.current = currentList;
    }, [
        orderedActiveAnnotationIdList,
        commentsDataMap,
        userId,
        isDanglingCallback,
        getViewedCommentsCacheOnly,
        updateUnreadCommentIDSet
    ]);
    (0, $42omo.useEffect)(()=>{
        // skip entirely if:
        // - feature flag is disabled
        // - isDanglingCallback check is not enabled
        // - shouldUpdateUnreadCommentsOnFirstRender being true means the unread query and viewed comments query are not complete yet, which means we shouldn't process the annotations yet
        if (!isDanglingCallback || shouldUpdateUnreadCommentsOnFirstRender || !(0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        processAnnotations();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- exclude commentsDataMap because we don't need to rerun this hook when it changes
    }, [
        processAnnotations,
        shouldUpdateUnreadCommentsOnFirstRender
    ]);
};
module.exports["useIsDanglingCallback"] = $280745ffe1b8b376$export$30b625574e8a38c7;
module.exports["useDanglingAndResolvedHandler"] = $280745ffe1b8b376$export$ce2ddc24e5a132d;

});

parcelRegister("e4kZB", function(module, exports) {
const $5243889752facbc2$export$446c7c25f5f55821 = (comment)=>{
    return {
        id: comment.id,
        author: {
            accountId: comment.author?.__typename === 'KnownUser' ? comment.author.accountId : undefined
        },
        createdAt: {
            value: comment.createdAt?.value || ''
        },
        location: {
            type: comment.location.type,
            inlineMarkerRef: comment.location?.inlineMarkerRef,
            inlineResolveProperties: comment.location?.inlineResolveProperties,
            commentResolveProperties: comment.location?.commentResolveProperties
        }
    };
};
const $5243889752facbc2$export$77349abd6de54bd8 = ({ commentId: commentId, userId: userId, createdAt: createdAt, commentType: commentType, resolveProperties: resolveProperties })=>{
    return {
        id: commentId,
        author: {
            accountId: userId || undefined
        },
        createdAt: {
            value: createdAt || ''
        },
        location: {
            type: commentType,
            ...commentType === 'INLINE' ? {
                inlineResolveProperties: resolveProperties || {
                    resolved: false
                }
            } : {
                commentResolveProperties: resolveProperties || {
                    resolved: false
                }
            }
        }
    };
};
const $5243889752facbc2$export$8df0b6c8bcdda615 = ({ pageMode: pageMode = 'view', annotationsInEditorDoc: annotationsInEditorDoc, rendererAnnotations: rendererAnnotations })=>(markerRef)=>{
        if (!markerRef) return false; // default to false if no marker ref
        // Treat 'live' mode as 'edit' mode
        const effectivePageMode = pageMode === 'live' ? 'edit' : pageMode;
        return effectivePageMode === 'view' ? !rendererAnnotations.has(markerRef) : !annotationsInEditorDoc.has(markerRef);
    };
const $5243889752facbc2$export$22ce26f7ba09f326 = ({ comment: comment, currentUserId: currentUserId, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback })=>{
    // Early return if comment is already viewed
    if (viewedComments.has(comment.id)) return false;
    const isNotOwnComment = comment.author?.accountId && comment.author.accountId !== currentUserId;
    const createdLast30Days = new Date(comment.createdAt?.value) > new Date(Date.now() - 2592000000);
    const commentLocation = comment?.location;
    const markerRef = commentLocation?.inlineMarkerRef;
    const isDanglingInlineComment = isDanglingCallback ? isDanglingCallback(markerRef) : false;
    const isPageComment = comment?.location.type === 'FOOTER';
    const isResolved = comment?.location?.inlineResolveProperties?.resolved || comment?.location?.commentResolveProperties?.resolved;
    return !isResolved && isNotOwnComment && createdLast30Days && (!isDanglingInlineComment || isPageComment);
};
const $5243889752facbc2$export$92c1e243fe45a57f = async ({ allComments: allComments, currentUserId: currentUserId, pageId: pageId, updateUnreadCommentIDSet: updateUnreadCommentIDSet, resetStates: resetStates, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback, addNewCommentThreads: addNewCommentThreads })=>{
    if (!allComments || !pageId) return;
    const unreadCommentIds = new Set();
    // keep track inline comment threads so we can prepopulate comments data map in order to keep track of dangling and resolved comments for unread
    const inlineCommentThreadsToAdd = {};
    allComments.forEach((comment)=>{
        if (!comment) return;
        if (comment.location.type === 'INLINE') {
            const commentLocation = comment.location;
            const threadKey = commentLocation?.inlineMarkerRef;
            if (threadKey) // Our query only returns open comments, so we need to set the isOpen status to true
            inlineCommentThreadsToAdd[threadKey] = {
                ...comment,
                isOpen: true,
                wasRemovedByAnotherUser: false
            };
        }
        if (currentUserId) {
            const parentCommentForValidation = $5243889752facbc2$export$446c7c25f5f55821(comment);
            if ($5243889752facbc2$export$22ce26f7ba09f326({
                comment: parentCommentForValidation,
                currentUserId: currentUserId,
                viewedComments: viewedComments,
                isDanglingCallback: isDanglingCallback
            })) unreadCommentIds.add(comment.id);
            if (comment.replies) comment.replies.forEach((reply)=>{
                if (reply) {
                    const replyForValidation = $5243889752facbc2$export$446c7c25f5f55821(reply);
                    if ($5243889752facbc2$export$22ce26f7ba09f326({
                        comment: replyForValidation,
                        currentUserId: currentUserId,
                        viewedComments: viewedComments,
                        isDanglingCallback: isDanglingCallback
                    })) unreadCommentIds.add(reply.id);
                }
            });
        }
    });
    updateUnreadCommentIDSet(unreadCommentIds, 'initialize');
    // Add the comment threads for inline comments at the end
    addNewCommentThreads && addNewCommentThreads({
        inline: inlineCommentThreadsToAdd,
        general: {}
    });
    // Once we are done updating the unread list, need to reset the states.
    resetStates();
};
module.exports["buildValidationObjectFromProps"] = $5243889752facbc2$export$77349abd6de54bd8;
module.exports["commentIsDangling"] = $5243889752facbc2$export$8df0b6c8bcdda615;
module.exports["isValidUnreadComment"] = $5243889752facbc2$export$22ce26f7ba09f326;
module.exports["createUnreadCommentsSet"] = $5243889752facbc2$export$92c1e243fe45a57f;

});

parcelRegister("9SEzS", function(module, exports) {
/**
 * @generated SignedSource<<261cad5b30367f2060b0057c0724e8e5>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $6771fdd733157350$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
var $6771fdd733157350$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["GraphQLContentStatus"] = $6771fdd733157350$export$b634e5de755b7d35;

});

parcelRegister("7oCdN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2FNjD = parcelRequire("2FNjD");


var $1e2E5 = parcelRequire("1e2E5");


var $1xywh = parcelRequire("1xywh");


var $iEYBu = parcelRequire("iEYBu");


var $bHWAG = parcelRequire("bHWAG");

const $3b7fa3742d344605$var$TARGET_SELECTOR = '#AkMainContent';
const $3b7fa3742d344605$var$COVER_ID = 'print-cover-page';
const $3b7fa3742d344605$var$STYLE_DATA_ATTR = 'data-print-cover-style';
function $3b7fa3742d344605$var$ensurePrintStyles() {
    if (typeof document === 'undefined') return;
    if (document.head.querySelector(`style[${$3b7fa3742d344605$var$STYLE_DATA_ATTR}="true"]`)) return;
    const style = document.createElement('style');
    style.setAttribute($3b7fa3742d344605$var$STYLE_DATA_ATTR, 'true');
    style.textContent = `
				/* Hidden on screen; visible when printing */
				#${$3b7fa3742d344605$var$COVER_ID} { display: none; }

				@media print {
				#${$3b7fa3742d344605$var$COVER_ID} {
					display: block !important;
					break-after: page;        /* modern */
					page-break-after: always; /* legacy */
				}
					
				/* Hide only the layout header when printing */
					header[data-layout-slot="true"] {
						display: none !important;
						visibility: hidden !important;
				}
			}`;
    document.head.appendChild(style);
}
function $3b7fa3742d344605$export$4b3266eb0ec6c746(enabled, intl) {
    const rootRef = (0, $42omo.useRef)(null);
    const hostRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!enabled || typeof window === 'undefined' || typeof document === 'undefined') return;
        $3b7fa3742d344605$var$ensurePrintStyles();
        (0, $bHWAG.preloadImage)((0, (/*@__PURE__*/$parcel$interopDefault($1xywh))));
        const before = ()=>{
            if (!(0, $bHWAG.isPageViewRoute)(window.location.pathname)) return;
            // find the main content container where we'll inject the cover page
            const target = document.querySelector($3b7fa3742d344605$var$TARGET_SELECTOR);
            // exit early if target element doesn't exist
            if (!target) return;
            // check if the cover page host container already exists in the DOM
            let host = document.getElementById($3b7fa3742d344605$var$COVER_ID);
            if (!host) {
                // Create a new host container if it doesn't exist
                host = document.createElement('div');
                host.id = $3b7fa3742d344605$var$COVER_ID;
            }
            /* insert the host as the first child of target so the cover page prints before content
      only insert if it's not already the first child (prevents duplicate insertions) */ if (target.firstChild !== host) target.insertBefore(host, target.firstChild);
            /* create a React root for the host container if it doesn't exist yet
      This allows us to render React components into this DOM node */ if (!rootRef.current) rootRef.current = (0, $2FNjD.createRoot)(host);
            // render the cover page component with internationalization support
            // wrap it in IntlProvider to provide translations from the parent app
            rootRef.current.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
                locale: intl.locale,
                messages: intl.messages,
                defaultLocale: "en"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iEYBu.CoverPageComponent), null)));
            // store reference to the host element for cleanup later
            hostRef.current = host;
        };
        const after = ()=>{
            // clean up the React root to prevent memory leaks
            if (rootRef.current) {
                // unmount the React component tree from the DOM
                rootRef.current.unmount();
                rootRef.current = null;
            }
            // remove the host container from the DOM if it exists and has a parent
            if (hostRef.current?.parentNode) // remove the cover page element from its parent node
            hostRef.current.parentNode.removeChild(hostRef.current);
            // clear the host element reference
            hostRef.current = null;
        };
        window.addEventListener('beforeprint', before);
        window.addEventListener('afterprint', after);
        // safety: some browsers may skip afterprint on cancel
        const onVisibility = ()=>{
            if (document.visibilityState === 'visible') after();
        };
        document.addEventListener('visibilitychange', onVisibility);
        return ()=>{
            window.removeEventListener('beforeprint', before);
            window.removeEventListener('afterprint', after);
            document.removeEventListener('visibilitychange', onVisibility);
            after();
        };
    }, [
        enabled,
        intl
    ]);
}
module.exports["usePrintCoverInjector"] = $3b7fa3742d344605$export$4b3266eb0ec6c746;

});

parcelRegister("1xywh", function(module, exports) {
module.exports = new URL("PDFexport.298a755d.png", import.meta.url).toString();

});

parcelRegister("iEYBu", function(module, exports) {
/* PrintCoverComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $1xywh = parcelRequire("1xywh");

const $182813799a742845$export$d7f7fd46ad566704 = (0, $cgtv4.defineMessages)({
    printCoverHeader: {
        id: "pdf-print-utils.print-cover.header",
        defaultMessage: "Your page may not be formatted properly if you print now."
    },
    printCoverSubheader: {
        id: "pdf-print-utils.print-cover.subheader",
        defaultMessage: "To maintain your page's format, export it as a PDF before printing - either with \u2318P/Ctrl+P or by following these steps:"
    },
    printStep1: {
        id: "pdf-print-utils.print-cover.step1",
        defaultMessage: "Close this window"
    },
    printStep2: {
        id: "pdf-print-utils.print-cover.step2",
        defaultMessage: "Select More actions (\u2022\u2022\u2022) in the upper right."
    },
    printStep3: {
        id: "pdf-print-utils.print-cover.step3",
        defaultMessage: "Select Export > Export as PDF."
    },
    printStep4: {
        id: "pdf-print-utils.print-cover.step4",
        defaultMessage: "Download and open the PDF to print."
    },
    imageAlt: {
        id: "pdf-print-utils.print-cover.image-alt",
        defaultMessage: "PDF export instructions diagram"
    }
});
const $182813799a742845$var$coverWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    padding: 'space.500',
    boxSizing: 'border-box',
    marginTop: 'space.100'
});
const $182813799a742845$var$headingStyles = null;
const $182813799a742845$var$subHeadingStyles = null;
const $182813799a742845$var$imgContStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.100',
    borderRadius: 'radius.large',
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay'
});
const $182813799a742845$var$imageStyles = null;
const $182813799a742845$var$listStyles = null;
const $182813799a742845$var$listItemStyles = null;
const $182813799a742845$export$a01b7b078c69ca5a = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $182813799a742845$var$coverWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("h1", {
        className: (0, $gMc0m.default)([
            "_1wybldb6 _k48p1wq8 _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $182813799a742845$export$d7f7fd46ad566704.printCoverHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("h1", {
        className: (0, $gMc0m.default)([
            "_1wyb1ou6 _19pk1ejb _k48p1wq8 _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $182813799a742845$export$d7f7fd46ad566704.printCoverSubheader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $182813799a742845$var$imgContStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        alt: intl.formatMessage($182813799a742845$export$d7f7fd46ad566704.imageAlt),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1xywh))),
        className: (0, $gMc0m.default)([
            "_1bsb1osq _1e0c1ule"
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ol", {
        className: (0, $gMc0m.default)([
            "_19pku2gc _bozgxy5q"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        className: (0, $gMc0m.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $182813799a742845$export$d7f7fd46ad566704.printStep1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        className: (0, $gMc0m.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $182813799a742845$export$d7f7fd46ad566704.printStep2)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        className: (0, $gMc0m.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $182813799a742845$export$d7f7fd46ad566704.printStep3)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        className: (0, $gMc0m.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $182813799a742845$export$d7f7fd46ad566704.printStep4))));
};
module.exports["CoverPageComponent"] = $182813799a742845$export$a01b7b078c69ca5a;

});

parcelRegister("bHWAG", function(module, exports) {
function $661369be983dfb69$export$7b6f372ddaf80f4a() {
    // in SSR or non-browser contexts there is no document
    if (typeof document === 'undefined') return null;
    // try the meta tag first: <meta name="ajs-atl-token" content="...">
    // use a typed querySelector so .content is available on HTMLMetaElement
    const metaToken = document.querySelector('meta[name="ajs-atl-token"]')?.content ?? // fallback to attribute read in case DOM typings differ
    document.querySelector('meta[name="ajs-atl-token"]')?.getAttribute('content');
    if (metaToken) return metaToken;
    // fallback to cookies if readable in this environment
    const m = document.cookie.match(/(?:^|;\s*)(atl\.xsrf\.token|atlassian\.account\.xsrf\.token)=([^;]+)/);
    // group 2 is the token value
    return m ? m[2] : null;
}
function $661369be983dfb69$export$2ce6e339a89daf7a(path) {
    const m = path.match(/\/pages\/(\d+)/);
    return m ? m[1] : null;
}
function $661369be983dfb69$export$1ae14b4842b49ade(path) {
    // Manual pathname check instead of using VIEW_PAGE.match() to avoid circular dependency
    // Using @confluence/named-routes -> @confluence/view-page-common creates a circular dependency:
    // @confluence/content-renderer -> @confluence/pdf-export -> @confluence/view-page-common -> @confluence/content-renderer
    // Pattern matches: /spaces/:spaceKey/pages/:contentId(digits)/:contentSlug?
    return path.match(/\/spaces\/[^/]+\/pages\/\d+/) !== null;
}
function $661369be983dfb69$export$bc4e1d0ebda8ad2c() {
    try {
        return window.self !== window.top;
    } catch (e) {
        // accessing window.top can throw in some cross-origin scenarios
        return true;
    }
}
const $661369be983dfb69$export$d8536155e595e20f = (imagePath)=>{
    const img = new Image();
    img.src = imagePath;
};
module.exports["getLiveAtlToken"] = $661369be983dfb69$export$7b6f372ddaf80f4a;
module.exports["getPageId"] = $661369be983dfb69$export$2ce6e339a89daf7a;
module.exports["isPageViewRoute"] = $661369be983dfb69$export$1ae14b4842b49ade;
module.exports["isInsideIframe"] = $661369be983dfb69$export$bc4e1d0ebda8ad2c;
module.exports["preloadImage"] = $661369be983dfb69$export$d8536155e595e20f;

});

parcelRegister("88Nzy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $2ZJmt = parcelRequire("2ZJmt");


var $bHWAG = parcelRequire("bHWAG");

const $86935ecd4293d578$var$i18n = (0, $cgtv4.defineMessages)({
    lockoutMessage: {
        id: "pdf-print-utils.navigation-lockout-message",
        defaultMessage: "You have unsaved changes. Please save before printing."
    }
});
function $86935ecd4293d578$var$tryGetAtlToken() {
    try {
        return (0, $bHWAG.getLiveAtlToken)();
    } catch  {
        return null;
    }
}
async function $86935ecd4293d578$export$94dac1f6a6cc2b5b(maxTries = 12, interval = 250) {
    let tries = 0;
    for(;;){
        const t = $86935ecd4293d578$var$tryGetAtlToken();
        if (t) return t;
        tries += 1;
        if (tries >= maxTries) throw new Error('atlToken not available');
        await new Promise((r)=>setTimeout(r, interval));
    }
}
function $86935ecd4293d578$export$36438d970303153({ enabled: enabled, shouldBlockPrint: shouldBlockPrint, onPrintBlocked: onPrintBlocked }) {
    const attachedRef = (0, $42omo.useRef)(false);
    const shouldBlockPrintRef = (0, $42omo.useRef)(shouldBlockPrint);
    const [showLockout, setShowLockout] = (0, $42omo.useState)(false);
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        shouldBlockPrintRef.current = shouldBlockPrint;
    }, [
        shouldBlockPrint
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!enabled) return;
        if (attachedRef.current) return;
        attachedRef.current = true;
        if ((0, $bHWAG.isInsideIframe)()) return;
        const handler = async (e)=>{
            const key = typeof e.key === 'string' ? e.key : '';
            const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
            const isPrintCombo = isMac ? e.metaKey && (key === 'p' || key === 'P' // mac: only cmd+P
            ) : e.ctrlKey && (key === 'p' || key === 'P'); // windows/linux: only ctrl+P
            if (!isPrintCombo) return;
            const shouldBlock = shouldBlockPrintRef.current ? shouldBlockPrintRef.current() : false;
            if (shouldBlock) {
                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();
                setShowLockout(true);
                onPrintBlocked?.();
                return;
            }
            if (!(0, $bHWAG.isPageViewRoute)(window.location.pathname)) return;
            const pageId = (0, $bHWAG.getPageId)(window.location.pathname);
            if (!pageId) return;
            let atlToken = $86935ecd4293d578$var$tryGetAtlToken();
            if (!atlToken) try {
                atlToken = await $86935ecd4293d578$export$94dac1f6a6cc2b5b();
            } catch  {
                return;
            }
            if (!atlToken || !pageId) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            const params = new URLSearchParams({
                pageId: pageId,
                atl_token: atlToken,
                showPdfBanner: 'true'
            });
            const url = `${window.location.origin}/wiki/spaces/flyingpdf/pdfpageexport.action?${params.toString()}`;
            window.location.assign(url);
        };
        const opts = {
            capture: true,
            passive: false
        };
        window.addEventListener('keydown', handler, opts);
        document.addEventListener('keydown', handler, opts);
        return ()=>{
            window.removeEventListener('keydown', handler, opts);
            document.removeEventListener('keydown', handler, opts);
            attachedRef.current = false;
        };
    }, [
        enabled,
        onPrintBlocked
    ]);
    const lockoutComponent = showLockout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZJmt.NavigationLockout), {
        message: intl.formatMessage($86935ecd4293d578$var$i18n.lockoutMessage)
    }) : null;
    return lockoutComponent;
}
module.exports["usePrintIntercept"] = $86935ecd4293d578$export$36438d970303153;

});

parcelRegister("8HrX3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $dPJCf = parcelRequire("dPJCf");

const $a7f86182a225a9f3$var$useFocusedTaskIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedTaskId');
const $a7f86182a225a9f3$var$TaskScrollComponentInner = ()=>{
    const focusedTaskId = $a7f86182a225a9f3$var$useFocusedTaskIdQueryParam();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    if (focusedTaskId) {
        const taskElement = document.querySelector(`[data-task-local-id="${focusedTaskId}"]`);
        if (taskElement) {
            taskElement.scrollIntoView({
                behavior: 'instant',
                inline: 'center',
                block: 'center'
            });
            // Remove the query param immediately after task scroll is complete
            setQueryParams({
                focusedTaskId: undefined
            });
        }
    }
    return null;
};
const $a7f86182a225a9f3$export$d9ea3940454347d1 = ()=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_focused-task-scroll')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a7f86182a225a9f3$var$TaskScrollComponentInner, null);
};
module.exports["TaskScrollComponent"] = $a7f86182a225a9f3$export$d9ea3940454347d1;

});

parcelRegister("fWGpT", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $5d9b4 = parcelRequire("5d9b4");


var $hvdlr = parcelRequire("hvdlr");


var $1iSzD = parcelRequire("1iSzD");


var $04e9M = parcelRequire("04e9M");


var $9137z = parcelRequire("9137z");


var $j8hiR = parcelRequire("j8hiR");


var $1VB1N = parcelRequire("1VB1N");


var $8VXwD = parcelRequire("8VXwD");


var $bNHtR = parcelRequire("bNHtR");


var $gNjy8 = parcelRequire("gNjy8");

const $6e4f6ea8730b931f$export$1504d130127dbc5f = (options)=>{
    const cloudId = options?.cloudId ?? '';
    const contentId = options?.contentId ?? '';
    const contentType = options?.contentType ?? '';
    const fetchUsersClient = options?.fetchUsersClient ?? '';
    return `${cloudId}_${contentId}_${contentType}_${fetchUsersClient}`;
};
const $6e4f6ea8730b931f$export$3c298c8b4091db27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((options)=>{
    // start measuring duration for initializing the provider
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_INIT);
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH);
    const { contentId: contentId, cloudId: cloudId, contentType: contentType, permissionTokenRefresh: permissionTokenRefresh, initialDraft: initialDraft, isLivePage: isLivePage, onUserFetchError: onUserFetchError, presenceId: presenceId, presenceActivity: presenceActivity, userId: userId, fetchUsersClient: fetchUsersClient } = options;
    const url = (0, $1VB1N.getCollabProviderUrl)();
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const product = isEmbeddedConfluence ? 'embeddedConfluence' : 'confluence';
    const documentAri = `ari:cloud:confluence:${cloudId}:${contentType}/${contentId}`;
    const subProduct = isEmbeddedConfluence ? (0, $jiJCD.parse)(location.search, true).query.parentProduct : isLivePage ? 'live' : undefined;
    const fetchAnonymousAssetCallback = async (id)=>{
        try {
            return await (0, $gNjy8.fetchAnonymousAsset)(id);
        } catch (error) {
            onUserFetchError?.(error);
        }
        return undefined;
    };
    // In order to support deduplication of the collaborator, presenceId will be set to the userId if it exists.
    // This means that anonymous users will still rely on presenceId and not get deduplicated.
    const collaboratorPresenceId = userId ?? presenceId;
    (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH);
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_CREATED);
    // DO NOT add any asynchronous calls/behavior to the collab provider creation. This has caused incidents
    // in the past where the provider promise never resolves and editing breaks.
    // Context: https://hello.atlassian.net/wiki/spaces/~589311246/pages/2554442259/Investigate+async+issue+HOT-103180
    return (0, $hvdlr.createSocketIOCollabProvider)({
        documentAri: documentAri,
        url: url,
        batchProps: {
            getUsers: fetchUsersClient === 'agg' ? (0, $8VXwD.fetchNativeCollabAGGUsers) : (0, $bNHtR.fetchNativeCollabConfluenceUsers),
            batchSize: 50,
            onError: onUserFetchError
        },
        getAnalyticsWebClient: (0, $04e9M.getAnalyticsWebClient)(),
        permissionTokenRefresh: permissionTokenRefresh,
        need404: true,
        productInfo: {
            product: product,
            subProduct: Array.isArray(subProduct) ? subProduct.join('-') : subProduct
        },
        // either pass the initialDraft that was fetched on hover, or the draftResponse that was fetched on click
        initialDraft: initialDraft || undefined,
        isBufferingEnabled: Boolean(initialDraft),
        __livePage: isLivePage,
        presenceId: collaboratorPresenceId,
        presenceActivity: presenceActivity,
        throwOnNotConnected: true,
        fetchAnonymousAsset: fetchAnonymousAssetCallback
    });
}, $6e4f6ea8730b931f$export$1504d130127dbc5f);
module.exports["getCollabEditProvider"] = $6e4f6ea8730b931f$export$3c298c8b4091db27;

});

parcelRegister("hvdlr", function(module, exports) {

var $1daQW = parcelRequire("1daQW");


var $dh538 = parcelRequire("dh538");


var $T9xHm = parcelRequire("T9xHm");


var $1oCLl = parcelRequire("1oCLl");


var $eOOPa = parcelRequire("eOOPa");


var $4frCv = parcelRequire("4frCv");


var $1jdMD = parcelRequire("1jdMD");

function $28639aaa801abbd1$export$2326b022d5973f36(url, auth, productInfo, isPresenceOnly, analyticsHelper, path) {
    const { pathname: pathname } = new URL(url);
    let socketIOOptions = (0, $1jdMD.SOCKET_IO_OPTIONS);
    // Polling first
    let transports = [
        'polling',
        'websocket'
    ];
    let usePMR = false;
    // Limit this change to Presence only
    if (isPresenceOnly) {
        if ((0, $dh538.fg)('platform-editor-presence-websocket-only')) // https://socket.io/docs/v4/client-options/#transports
        // WebSocket first, if fails, try polling
        transports = [
            'websocket'
        ];
        socketIOOptions = (0, $1jdMD.SOCKET_IO_OPTIONS_WITH_HIGH_JITTER);
        if ((0, $T9xHm.isIsolatedCloud)() && (0, $1oCLl.expValEquals)('platform_editor_use_pmr_for_collab_presence_in_ic', 'isEnabled', true, false) || !(0, $T9xHm.isIsolatedCloud)() && (0, $1oCLl.expValEquals)('platform_editor_use_pmr_for_collab_presence_non_ic', 'isEnabled', true, false)) usePMR = true;
    }
    const client = (0, $1daQW.io)(url, {
        reconnectionDelayMax: socketIOOptions.RECONNECTION_DELAY_MAX,
        reconnectionDelay: socketIOOptions.RECONNECTION_DELAY,
        randomizationFactor: socketIOOptions.RANDOMIZATION_FACTOR,
        closeOnBeforeunload: false,
        withCredentials: true,
        transports: transports,
        path: usePMR && path ? `${path}/socket.io` : `/${pathname.split('/')[1]}/socket.io`,
        auth: auth,
        extraHeaders: {
            'x-product': (0, $4frCv.getProduct)(productInfo),
            'x-subproduct': (0, $4frCv.getSubProduct)(productInfo)
        }
    });
    return client;
}
function $28639aaa801abbd1$export$a301b940c71eb349(config) {
    return new (0, $eOOPa.Provider)({
        ...config,
        createSocket: $28639aaa801abbd1$export$2326b022d5973f36
    });
}
module.exports["createSocketIOCollabProvider"] = $28639aaa801abbd1$export$a301b940c71eb349;

});

parcelRegister("1daQW", function(module, exports) {

var $k7xA3 = parcelRequire("k7xA3");


var $1bCsq = parcelRequire("1bCsq");


var $12VqB = parcelRequire("12VqB");


var $gjFYM = parcelRequire("gjFYM");

/**
 * Managers cache.
 */ const $0e1f6c82808e4270$var$cache = {};
function $0e1f6c82808e4270$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $k7xA3.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $0e1f6c82808e4270$var$cache[id] && path in $0e1f6c82808e4270$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $1bCsq.Manager)(source, opts);
    else {
        if (!$0e1f6c82808e4270$var$cache[id]) $0e1f6c82808e4270$var$cache[id] = new (0, $1bCsq.Manager)(source, opts);
        io = $0e1f6c82808e4270$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($0e1f6c82808e4270$export$841407ceb083bd74, {
    Manager: $1bCsq.Manager,
    Socket: $12VqB.Socket,
    io: $0e1f6c82808e4270$export$841407ceb083bd74,
    connect: $0e1f6c82808e4270$export$841407ceb083bd74
});
module.exports["io"] = $0e1f6c82808e4270$export$841407ceb083bd74;

});

parcelRegister("k7xA3", function(module, exports) {
parcelRequire("3nOvZ");
var $glDPj = parcelRequire("glDPj");

function $ea5e82796b5c2d27$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $glDPj.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}
module.exports["url"] = $ea5e82796b5c2d27$export$128fa18b7194ef;

});

parcelRegister("3nOvZ", function(module, exports) {
$parcel$export(module.exports, "Socket", () => (parcelRequire("iHsSr")).Socket);
$parcel$export(module.exports, "installTimerFunctions", () => (parcelRequire("8LtnI")).installTimerFunctions);
$parcel$export(module.exports, "parse", () => (parcelRequire("glDPj")).parse);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("cDUk6")).nextTick);

var $iHsSr = parcelRequire("iHsSr");


var $cQb3o = parcelRequire("cQb3o");


var $l7SQD = parcelRequire("l7SQD");


var $8LtnI = parcelRequire("8LtnI");


var $glDPj = parcelRequire("glDPj");


var $cDUk6 = parcelRequire("cDUk6");

const $276ab44fafc54dec$export$a51d6b395ff4c65a = (0, $iHsSr.Socket).protocol;

});

parcelRegister("iHsSr", function(module, exports) {

var $l7SQD = parcelRequire("l7SQD");


var $8LtnI = parcelRequire("8LtnI");


var $7TImw = parcelRequire("7TImw");


var $glDPj = parcelRequire("glDPj");


var $1odXU = parcelRequire("1odXU");


var $j2gtm = parcelRequire("j2gtm");


var $cDUk6 = parcelRequire("cDUk6");

class $d9d2a4881db5a9d2$export$4798917dbf149b79 extends (0, $1odXU.Emitter) {
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $j2gtm.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new (0, $l7SQD.transports)[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ open() {
        let transport;
        if (this.opts.rememberUpgrade && $d9d2a4881db5a9d2$export$4798917dbf149b79.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) transport = "websocket";
        else if (0 === this.transports.length) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        } else transport = this.transports[0];
        this.readyState = "opening";
        // Retry with the next transport if the transport is disabled (jsonp: false)
        try {
            transport = this.createTransport(transport);
        } catch (e) {
            this.transports.shift();
            this.open();
            return;
        }
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (reason)=>this.onClose("transport close", reason));
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $d9d2a4881db5a9d2$export$4798917dbf149b79.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $d9d2a4881db5a9d2$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this.upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $d9d2a4881db5a9d2$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        // we check for `readyState` in case an `open`
        // listener already closed the socket
        if ("open" === this.readyState && this.opts.upgrade) {
            let i = 0;
            const l = this.upgrades.length;
            for(; i < l; i++)this.probe(this.upgrades[i]);
        }
    }
    /**
     * Handles a packet.
     *
     * @private
     */ onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            this.resetPingTimeout();
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this.sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this.onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this.upgrades = this.filterUpgrades(data.upgrades);
        this.pingInterval = data.pingInterval;
        this.pingTimeout = data.pingTimeout;
        this.maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ resetPingTimeout() {
        this.clearTimeoutFn(this.pingTimeoutTimer);
        this.pingTimeoutTimer = this.setTimeoutFn(()=>{
            this.onClose("ping timeout");
        }, this.pingInterval + this.pingTimeout);
        if (this.opts.autoUnref) this.pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ onDrain() {
        this.writeBuffer.splice(0, this.prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this.prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this.getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this.prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ getWritablePackets() {
        const shouldCheckPayloadSize = this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $8LtnI.byteLength)(data);
            if (i > 0 && payloadSize > this.maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    send(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this.onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ onError(err) {
        $d9d2a4881db5a9d2$export$4798917dbf149b79.priorWebsocketSuccess = false;
        this.emitReserved("error", err);
        this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this.pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (typeof removeEventListener === "function") {
                removeEventListener("beforeunload", this.beforeunloadEventListener, false);
                removeEventListener("offline", this.offlineEventListener, false);
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this.prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        let i = 0;
        const j = upgrades.length;
        for(; i < j; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts = {}){
        super();
        this.binaryType = (0, $cDUk6.defaultBinaryType);
        this.writeBuffer = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            uri = (0, $glDPj.parse)(uri);
            opts.hostname = uri.host;
            opts.secure = uri.protocol === "https" || uri.protocol === "wss";
            opts.port = uri.port;
            if (uri.query) opts.query = uri.query;
        } else if (opts.host) opts.hostname = (0, $glDPj.parse)(opts.host).host;
        (0, $8LtnI.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = opts.transports || [
            "polling",
            "websocket",
            "webtransport"
        ];
        this.writeBuffer = [];
        this.prevBufferLen = 0;
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $7TImw.decode)(this.opts.query);
        // set on handshake
        this.id = null;
        this.upgrades = null;
        this.pingInterval = null;
        this.pingTimeout = null;
        // set on heartbeat
        this.pingTimeoutTimer = null;
        if (typeof addEventListener === "function") {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this.beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this.beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this.offlineEventListener = ()=>{
                    this.onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                addEventListener("offline", this.offlineEventListener, false);
            }
        }
        this.open();
    }
}
$d9d2a4881db5a9d2$export$4798917dbf149b79.protocol = (0, $j2gtm.protocol);
module.exports["Socket"] = $d9d2a4881db5a9d2$export$4798917dbf149b79;

});

parcelRegister("l7SQD", function(module, exports) {

var $c68Xz = parcelRequire("c68Xz");


var $br29j = parcelRequire("br29j");


var $kVgT5 = parcelRequire("kVgT5");

const $f614cc0f77cd5157$export$46dec00755c1153b = {
    websocket: (0, $br29j.WS),
    webtransport: (0, $kVgT5.WT),
    polling: (0, $c68Xz.Polling)
};
module.exports["transports"] = $f614cc0f77cd5157$export$46dec00755c1153b;

});

parcelRegister("c68Xz", function(module, exports) {

var $cQb3o = parcelRequire("cQb3o");


var $a9lLT = parcelRequire("a9lLT");


var $j2gtm = parcelRequire("j2gtm");


var $epKiJ = parcelRequire("epKiJ");


var $1odXU = parcelRequire("1odXU");


var $8LtnI = parcelRequire("8LtnI");


var $5Y5Gn = parcelRequire("5Y5Gn");

function $8cecfed38aaf6691$var$empty() {}
const $8cecfed38aaf6691$var$hasXHR2 = function() {
    const xhr = new (0, $epKiJ.XHR)({
        xdomain: false
    });
    return null != xhr.responseType;
}();
class $8cecfed38aaf6691$export$265ee5eefd4c309b extends (0, $cQb3o.Transport) {
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this.polling || !this.writable) {
            let total = 0;
            if (this.polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ poll() {
        this.polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $j2gtm.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this.polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this.poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $j2gtm.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $a9lLT.yeast)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Creates a request.
     *
     * @param {String} method
     * @private
     */ request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd,
            cookieJar: this.cookieJar
        }, this.opts);
        return new $8cecfed38aaf6691$export$7fa6c5b6f8193917(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        this.polling = false;
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
        /**
         * XHR supports binary
         */ const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $8cecfed38aaf6691$var$hasXHR2 && !forceBase64;
        if (this.opts.withCredentials) this.cookieJar = (0, $epKiJ.createCookieJar)();
    }
}
class $8cecfed38aaf6691$export$7fa6c5b6f8193917 extends (0, $1odXU.Emitter) {
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ create() {
        var _a;
        const opts = (0, $8LtnI.pick)(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this.opts.xd;
        const xhr = this.xhr = new (0, $epKiJ.XHR)(opts);
        try {
            xhr.open(this.method, this.uri, true);
            try {
                if (this.opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this.opts.extraHeaders)if (this.opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this.method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this.opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this.opts.withCredentials;
            if (this.opts.requestTimeout) xhr.timeout = this.opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this.opts.cookieJar) === null || _a === void 0 || _a.parseCookies(xhr);
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this.onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this.onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this.data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this.onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this.index = $8cecfed38aaf6691$export$7fa6c5b6f8193917.requestsCount++;
            $8cecfed38aaf6691$export$7fa6c5b6f8193917.requests[this.index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ onError(err) {
        this.emitReserved("error", err, this.xhr);
        this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ cleanup(fromError) {
        if ("undefined" === typeof this.xhr || null === this.xhr) return;
        this.xhr.onreadystatechange = $8cecfed38aaf6691$var$empty;
        if (fromError) try {
            this.xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $8cecfed38aaf6691$export$7fa6c5b6f8193917.requests[this.index];
        this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ onLoad() {
        const data = this.xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this.cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this.cleanup();
    }
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(uri, opts){
        super();
        (0, $8LtnI.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.method = opts.method || "GET";
        this.uri = uri;
        this.data = undefined !== opts.data ? opts.data : null;
        this.create();
    }
}
$8cecfed38aaf6691$export$7fa6c5b6f8193917.requestsCount = 0;
$8cecfed38aaf6691$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $8cecfed38aaf6691$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $5Y5Gn.globalThisShim) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $8cecfed38aaf6691$var$unloadHandler, false);
    }
}
function $8cecfed38aaf6691$var$unloadHandler() {
    for(let i in $8cecfed38aaf6691$export$7fa6c5b6f8193917.requests)if ($8cecfed38aaf6691$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $8cecfed38aaf6691$export$7fa6c5b6f8193917.requests[i].abort();
}
module.exports["Polling"] = $8cecfed38aaf6691$export$265ee5eefd4c309b;

});

parcelRegister("cQb3o", function(module, exports) {
parcelRequire("j2gtm");
var $9RqqE = parcelRequire("9RqqE");


var $1odXU = parcelRequire("1odXU");


var $8LtnI = parcelRequire("8LtnI");


var $7TImw = parcelRequire("7TImw");

class $9592ea6a39756981$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $9592ea6a39756981$export$86495b081fef8e52 extends (0, $1odXU.Emitter) {
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $9592ea6a39756981$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $9RqqE.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $7TImw.encode)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $8LtnI.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
    }
}
module.exports["Transport"] = $9592ea6a39756981$export$86495b081fef8e52;

});

parcelRegister("j2gtm", function(module, exports) {
$parcel$export(module.exports, "encodePacket", () => (parcelRequire("eDcVq")).encodePacket);
$parcel$export(module.exports, "decodePacket", () => (parcelRequire("9RqqE")).decodePacket);

var $eDcVq = parcelRequire("eDcVq");


var $9RqqE = parcelRequire("9RqqE");


var $g8mBf = parcelRequire("g8mBf");

const $ddbafb4ec5d26431$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $ddbafb4ec5d26431$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $eDcVq.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($ddbafb4ec5d26431$var$SEPARATOR));
        });
    });
};
const $ddbafb4ec5d26431$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($ddbafb4ec5d26431$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $9RqqE.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $ddbafb4ec5d26431$export$a525fb718e9c623a() {
    // @ts-expect-error
    return new TransformStream({
        transform (packet, controller) {
            (0, $eDcVq.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $ddbafb4ec5d26431$var$TEXT_DECODER;
function $ddbafb4ec5d26431$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $ddbafb4ec5d26431$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $ddbafb4ec5d26431$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$ddbafb4ec5d26431$var$TEXT_DECODER) $ddbafb4ec5d26431$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    // @ts-expect-error
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* READ_HEADER */ ) {
                    if ($ddbafb4ec5d26431$var$totalLength(chunks) < 1) break;
                    const header = $ddbafb4ec5d26431$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* READ_EXTENDED_LENGTH_16 */ ) {
                    if ($ddbafb4ec5d26431$var$totalLength(chunks) < 2) break;
                    const headerArray = $ddbafb4ec5d26431$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* READ_PAYLOAD */ ;
                } else if (state === 2 /* READ_EXTENDED_LENGTH_64 */ ) {
                    if ($ddbafb4ec5d26431$var$totalLength(chunks) < 8) break;
                    const headerArray = $ddbafb4ec5d26431$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $g8mBf.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* READ_PAYLOAD */ ;
                } else {
                    if ($ddbafb4ec5d26431$var$totalLength(chunks) < expectedLength) break;
                    const data = $ddbafb4ec5d26431$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $9RqqE.decodePacket)(isBinary ? data : $ddbafb4ec5d26431$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $g8mBf.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const $ddbafb4ec5d26431$export$a51d6b395ff4c65a = 4;
module.exports["encodePayload"] = $ddbafb4ec5d26431$export$144d64fe58dad441;
module.exports["decodePayload"] = $ddbafb4ec5d26431$export$d10cc2e7f7566a2d;
module.exports["createPacketEncoderStream"] = $ddbafb4ec5d26431$export$a525fb718e9c623a;
module.exports["createPacketDecoderStream"] = $ddbafb4ec5d26431$export$552d20aac7500f47;
module.exports["protocol"] = $ddbafb4ec5d26431$export$a51d6b395ff4c65a;

});

parcelRegister("eDcVq", function(module, exports) {

var $g8mBf = parcelRequire("g8mBf");

const $aa6ebbe008757ebd$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $aa6ebbe008757ebd$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $aa6ebbe008757ebd$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $aa6ebbe008757ebd$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($aa6ebbe008757ebd$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $aa6ebbe008757ebd$var$encodeBlobAsBase64(data, callback);
    } else if ($aa6ebbe008757ebd$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $aa6ebbe008757ebd$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $aa6ebbe008757ebd$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $g8mBf.PACKET_TYPES)[type] + (data || ""));
};
const $aa6ebbe008757ebd$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $aa6ebbe008757ebd$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $aa6ebbe008757ebd$var$TEXT_ENCODER;
function $aa6ebbe008757ebd$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($aa6ebbe008757ebd$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($aa6ebbe008757ebd$var$toArray).then(callback);
    else if ($aa6ebbe008757ebd$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $aa6ebbe008757ebd$var$isView(packet.data))) return callback($aa6ebbe008757ebd$var$toArray(packet.data));
    $aa6ebbe008757ebd$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$aa6ebbe008757ebd$var$TEXT_ENCODER) $aa6ebbe008757ebd$var$TEXT_ENCODER = new TextEncoder();
        callback($aa6ebbe008757ebd$var$TEXT_ENCODER.encode(encoded));
    });
}
module.exports["encodePacket"] = $aa6ebbe008757ebd$export$57852049361a8e62;
module.exports["encodePacketToBinary"] = $aa6ebbe008757ebd$export$ec0c9b9013ee0ef5;

});

parcelRegister("g8mBf", function(module, exports) {
const $bbeeec8bf61d59e6$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$bbeeec8bf61d59e6$export$c169aefb7330cccb["open"] = "0";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["close"] = "1";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["ping"] = "2";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["pong"] = "3";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["message"] = "4";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["upgrade"] = "5";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["noop"] = "6";
const $bbeeec8bf61d59e6$export$47791e8004edd485 = Object.create(null);
Object.keys($bbeeec8bf61d59e6$export$c169aefb7330cccb).forEach((key)=>{
    $bbeeec8bf61d59e6$export$47791e8004edd485[$bbeeec8bf61d59e6$export$c169aefb7330cccb[key]] = key;
});
const $bbeeec8bf61d59e6$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};
module.exports["PACKET_TYPES"] = $bbeeec8bf61d59e6$export$c169aefb7330cccb;
module.exports["PACKET_TYPES_REVERSE"] = $bbeeec8bf61d59e6$export$47791e8004edd485;
module.exports["ERROR_PACKET"] = $bbeeec8bf61d59e6$export$c718b5840781f8a7;

});

parcelRegister("9RqqE", function(module, exports) {

var $g8mBf = parcelRequire("g8mBf");


var $ky20u = parcelRequire("ky20u");

const $72dd9088c237fe2b$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $72dd9088c237fe2b$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $72dd9088c237fe2b$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $72dd9088c237fe2b$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $g8mBf.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $g8mBf.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $g8mBf.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $g8mBf.PACKET_TYPES_REVERSE)[type]
    };
};
const $72dd9088c237fe2b$var$decodeBase64Packet = (data, binaryType)=>{
    if ($72dd9088c237fe2b$var$withNativeArrayBuffer) {
        const decoded = (0, $ky20u.decode)(data);
        return $72dd9088c237fe2b$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $72dd9088c237fe2b$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};
module.exports["decodePacket"] = $72dd9088c237fe2b$export$4647901878f33f31;

});

parcelRegister("ky20u", function(module, exports) {
// imported from https://github.com/socketio/base64-arraybuffer
const $ef588a29a27a4f0c$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $ef588a29a27a4f0c$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $ef588a29a27a4f0c$var$chars.length; i++)$ef588a29a27a4f0c$var$lookup[$ef588a29a27a4f0c$var$chars.charCodeAt(i)] = i;
const $ef588a29a27a4f0c$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $ef588a29a27a4f0c$var$chars[bytes[i] >> 2];
        base64 += $ef588a29a27a4f0c$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $ef588a29a27a4f0c$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $ef588a29a27a4f0c$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $ef588a29a27a4f0c$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $ef588a29a27a4f0c$var$lookup[base64.charCodeAt(i)];
        encoded2 = $ef588a29a27a4f0c$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $ef588a29a27a4f0c$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $ef588a29a27a4f0c$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};
module.exports["decode"] = $ef588a29a27a4f0c$export$2f872c0f2117be69;

});

parcelRegister("1odXU", function(module, exports) {
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $1032dd8c99dcfaba$export$4293555f241ae35a(obj) {
    if (obj) return $1032dd8c99dcfaba$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $1032dd8c99dcfaba$var$mixin(obj) {
    for(var key in $1032dd8c99dcfaba$export$4293555f241ae35a.prototype)obj[key] = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.on = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.off = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.removeListener = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.removeAllListeners = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$1032dd8c99dcfaba$export$4293555f241ae35a.prototype.emitReserved = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};
module.exports["Emitter"] = $1032dd8c99dcfaba$export$4293555f241ae35a;

});

parcelRegister("8LtnI", function(module, exports) {

var $5Y5Gn = parcelRequire("5Y5Gn");

function $6619810c021a58f6$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $6619810c021a58f6$var$NATIVE_SET_TIMEOUT = (0, $5Y5Gn.globalThisShim).setTimeout;
const $6619810c021a58f6$var$NATIVE_CLEAR_TIMEOUT = (0, $5Y5Gn.globalThisShim).clearTimeout;
function $6619810c021a58f6$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $6619810c021a58f6$var$NATIVE_SET_TIMEOUT.bind((0, $5Y5Gn.globalThisShim));
        obj.clearTimeoutFn = $6619810c021a58f6$var$NATIVE_CLEAR_TIMEOUT.bind((0, $5Y5Gn.globalThisShim));
    } else {
        obj.setTimeoutFn = (0, $5Y5Gn.globalThisShim).setTimeout.bind((0, $5Y5Gn.globalThisShim));
        obj.clearTimeoutFn = (0, $5Y5Gn.globalThisShim).clearTimeout.bind((0, $5Y5Gn.globalThisShim));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $6619810c021a58f6$var$BASE64_OVERHEAD = 1.33;
function $6619810c021a58f6$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $6619810c021a58f6$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $6619810c021a58f6$var$BASE64_OVERHEAD);
}
function $6619810c021a58f6$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
module.exports["pick"] = $6619810c021a58f6$export$357523c63a2253b9;
module.exports["installTimerFunctions"] = $6619810c021a58f6$export$2f67576668b97183;
module.exports["byteLength"] = $6619810c021a58f6$export$a48f0734ac7c2329;

});

parcelRegister("5Y5Gn", function(module, exports) {
const $4586f6c761acbc2b$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
module.exports["globalThisShim"] = $4586f6c761acbc2b$export$394f9358f6231289;

});

parcelRegister("7TImw", function(module, exports) {
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $5c0014e3a134c3e4$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $5c0014e3a134c3e4$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}
module.exports["encode"] = $5c0014e3a134c3e4$export$c564cdbbe6da493;
module.exports["decode"] = $5c0014e3a134c3e4$export$2f872c0f2117be69;

});

parcelRegister("a9lLT", function(module, exports) {
// imported from https://github.com/unshiftio/yeast
'use strict';
const $763ba2042e4d4eb9$var$alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split(''), $763ba2042e4d4eb9$var$length = 64, $763ba2042e4d4eb9$var$map = {};
let $763ba2042e4d4eb9$var$seed = 0, $763ba2042e4d4eb9$var$i = 0, $763ba2042e4d4eb9$var$prev;
function $763ba2042e4d4eb9$export$c564cdbbe6da493(num) {
    let encoded = '';
    do {
        encoded = $763ba2042e4d4eb9$var$alphabet[num % $763ba2042e4d4eb9$var$length] + encoded;
        num = Math.floor(num / $763ba2042e4d4eb9$var$length);
    }while (num > 0);
    return encoded;
}
function $763ba2042e4d4eb9$export$2f872c0f2117be69(str) {
    let decoded = 0;
    for($763ba2042e4d4eb9$var$i = 0; $763ba2042e4d4eb9$var$i < str.length; $763ba2042e4d4eb9$var$i++)decoded = decoded * $763ba2042e4d4eb9$var$length + $763ba2042e4d4eb9$var$map[str.charAt($763ba2042e4d4eb9$var$i)];
    return decoded;
}
function $763ba2042e4d4eb9$export$5bb64b92cb4135a() {
    const now = $763ba2042e4d4eb9$export$c564cdbbe6da493(+new Date());
    if (now !== $763ba2042e4d4eb9$var$prev) return $763ba2042e4d4eb9$var$seed = 0, $763ba2042e4d4eb9$var$prev = now;
    return now + '.' + $763ba2042e4d4eb9$export$c564cdbbe6da493($763ba2042e4d4eb9$var$seed++);
}
//
// Map each character to its index.
//
for(; $763ba2042e4d4eb9$var$i < $763ba2042e4d4eb9$var$length; $763ba2042e4d4eb9$var$i++)$763ba2042e4d4eb9$var$map[$763ba2042e4d4eb9$var$alphabet[$763ba2042e4d4eb9$var$i]] = $763ba2042e4d4eb9$var$i;
module.exports["yeast"] = $763ba2042e4d4eb9$export$5bb64b92cb4135a;

});

parcelRegister("epKiJ", function(module, exports) {
// browser shim for xmlhttprequest module

var $e5XvD = parcelRequire("e5XvD");


var $5Y5Gn = parcelRequire("5Y5Gn");

function $a7e750ed0f96e195$export$a2d42eb087c10497(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $e5XvD.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $5Y5Gn.globalThisShim)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}
function $a7e750ed0f96e195$export$19413efcf2fac759() {}
module.exports["XHR"] = $a7e750ed0f96e195$export$a2d42eb087c10497;
module.exports["createCookieJar"] = $a7e750ed0f96e195$export$19413efcf2fac759;

});

parcelRegister("e5XvD", function(module, exports) {
// imported from https://github.com/component/has-cors
let $a42fb1a1e9c41568$var$value = false;
try {
    $a42fb1a1e9c41568$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $a42fb1a1e9c41568$export$5235bbd4a1ef06e = $a42fb1a1e9c41568$var$value;
module.exports["hasCORS"] = $a42fb1a1e9c41568$export$5235bbd4a1ef06e;

});

parcelRegister("br29j", function(module, exports) {

var $cQb3o = parcelRequire("cQb3o");


var $a9lLT = parcelRequire("a9lLT");


var $8LtnI = parcelRequire("8LtnI");


var $cDUk6 = parcelRequire("cDUk6");

parcelRequire("j2gtm");
var $eDcVq = parcelRequire("eDcVq");


var $iA9co = parcelRequire("iA9co");

var $8533e219b2af82c1$require$Buffer = $iA9co.Buffer;
// detect ReactNative environment
const $8533e219b2af82c1$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $8533e219b2af82c1$export$911baa0677ac404c extends (0, $cQb3o.Transport) {
    get name() {
        return "websocket";
    }
    doOpen() {
        if (!this.check()) // let probe timeout
        return;
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $8533e219b2af82c1$var$isReactNative ? {} : (0, $8LtnI.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = (0, $cDUk6.usingBrowserWebSocket) && !$8533e219b2af82c1$var$isReactNative ? protocols ? new (0, $cDUk6.WebSocket)(uri, protocols) : new (0, $cDUk6.WebSocket)(uri) : new (0, $cDUk6.WebSocket)(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $eDcVq.encodePacket)(packet, this.supportsBinary, (data)=>{
                // always create a new object (GH-437)
                const opts = {};
                if (!(0, $cDUk6.usingBrowserWebSocket)) {
                    if (packet.options) opts.compress = packet.options.compress;
                    if (this.opts.perMessageDeflate) {
                        const len = // @ts-ignore
                        "string" === typeof data ? $8533e219b2af82c1$require$Buffer.byteLength(data) : data.length;
                        if (len < this.opts.perMessageDeflate.threshold) opts.compress = false;
                    }
                }
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    if (0, $cDUk6.usingBrowserWebSocket) // TypeError is thrown when passing the second argument on Safari
                    this.ws.send(data);
                    else this.ws.send(data, opts);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $cDUk6.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $a9lLT.yeast)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @private
     */ check() {
        return !!(0, $cDUk6.WebSocket);
    }
    /**
     * WebSocket transport constructor.
     *
     * @param {Object} opts - connection options
     * @protected
     */ constructor(opts){
        super(opts);
        this.supportsBinary = !opts.forceBase64;
    }
}
module.exports["WS"] = $8533e219b2af82c1$export$911baa0677ac404c;

});

parcelRegister("cDUk6", function(module, exports) {

var $5Y5Gn = parcelRequire("5Y5Gn");

const $9344d126b47ec216$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $9344d126b47ec216$export$3909fb301d3dc8c9 = (0, $5Y5Gn.globalThisShim).WebSocket || (0, $5Y5Gn.globalThisShim).MozWebSocket;
const $9344d126b47ec216$export$3407ba5dfb7a683d = true;
const $9344d126b47ec216$export$790dcbc41e2d75d5 = "arraybuffer";
module.exports["nextTick"] = $9344d126b47ec216$export$bdd553fddd433dcb;
module.exports["WebSocket"] = $9344d126b47ec216$export$3909fb301d3dc8c9;
module.exports["usingBrowserWebSocket"] = $9344d126b47ec216$export$3407ba5dfb7a683d;
module.exports["defaultBinaryType"] = $9344d126b47ec216$export$790dcbc41e2d75d5;

});

parcelRegister("kVgT5", function(module, exports) {

var $cQb3o = parcelRequire("cQb3o");


var $cDUk6 = parcelRequire("cDUk6");


var $j2gtm = parcelRequire("j2gtm");

class $f3b63b067a93fecb$export$961c930859384407 extends (0, $cQb3o.Transport) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        // @ts-ignore
        if (typeof WebTransport !== "function") return;
        // @ts-ignore
        this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        this.transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this.transport.ready.then(()=>{
            this.transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $j2gtm.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $j2gtm.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this.writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this.writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this.writer.write(packet).then(()=>{
                if (lastPacket) (0, $cDUk6.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this.transport) === null || _a === void 0 || _a.close();
    }
}
module.exports["WT"] = $f3b63b067a93fecb$export$961c930859384407;

});

parcelRegister("glDPj", function(module, exports) {
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $be6d803df662636b$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $be6d803df662636b$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $be6d803df662636b$export$98e6a39c04603d36(str) {
    if (str.length > 2000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $be6d803df662636b$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$be6d803df662636b$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $be6d803df662636b$var$pathNames(uri, uri['path']);
    uri.queryKey = $be6d803df662636b$var$queryKey(uri, uri['query']);
    return uri;
}
function $be6d803df662636b$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $be6d803df662636b$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}
module.exports["parse"] = $be6d803df662636b$export$98e6a39c04603d36;

});

parcelRegister("1bCsq", function(module, exports) {
parcelRequire("3nOvZ");
var $8LtnI = parcelRequire("8LtnI");
var $cDUk6 = parcelRequire("cDUk6");
var $iHsSr = parcelRequire("iHsSr");


var $12VqB = parcelRequire("12VqB");


var $gjFYM = parcelRequire("gjFYM");


var $e6joS = parcelRequire("e6joS");


var $liT4p = parcelRequire("liT4p");


var $1odXU = parcelRequire("1odXU");

class $0dd4a65fac43516f$export$d0d38e7dec7a1a61 extends (0, $1odXU.Emitter) {
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $iHsSr.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $e6joS.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $e6joS.on)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $e6joS.on)(socket, "ping", this.onping.bind(this)), (0, $e6joS.on)(socket, "data", this.ondata.bind(this)), (0, $e6joS.on)(socket, "error", this.onerror.bind(this)), (0, $e6joS.on)(socket, "close", this.onclose.bind(this)), (0, $e6joS.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $cDUk6.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $12VqB.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
        if (this.engine) this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */ onclose(reason, description) {
        this.cleanup();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $8LtnI.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $liT4p.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $gjFYM;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
}
module.exports["Manager"] = $0dd4a65fac43516f$export$d0d38e7dec7a1a61;

});

parcelRegister("12VqB", function(module, exports) {

var $gjFYM = parcelRequire("gjFYM");


var $e6joS = parcelRequire("e6joS");


var $1odXU = parcelRequire("1odXU");

/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $0c32865cdab9ae8e$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $0c32865cdab9ae8e$export$4798917dbf149b79 extends (0, $1odXU.Emitter) {
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $e6joS.on)(io, "open", this.onopen.bind(this)),
            (0, $e6joS.on)(io, "packet", this.onpacket.bind(this)),
            (0, $e6joS.on)(io, "error", this.onerror.bind(this)),
            (0, $e6joS.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        if ($0c32865cdab9ae8e$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $gjFYM.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
        const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
        if (discardPacket) ;
        else if (this.connected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $gjFYM.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $gjFYM.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $gjFYM.PacketType).EVENT:
            case (0, $gjFYM.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $gjFYM.PacketType).ACK:
            case (0, $gjFYM.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $gjFYM.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $gjFYM.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $gjFYM.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $gjFYM.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
}
module.exports["Socket"] = $0c32865cdab9ae8e$export$4798917dbf149b79;

});

parcelRegister("gjFYM", function(module, exports) {
$parcel$export(module.exports, "PacketType", () => $0310c1ff85201954$export$84d4095e16c6fc19);

var $1odXU = parcelRequire("1odXU");


var $fWhxz = parcelRequire("fWhxz");


var $6qMhJ = parcelRequire("6qMhJ");

/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $0310c1ff85201954$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $0310c1ff85201954$export$a51d6b395ff4c65a = 5;
var $0310c1ff85201954$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($0310c1ff85201954$export$84d4095e16c6fc19 || ($0310c1ff85201954$export$84d4095e16c6fc19 = {}));
class $0310c1ff85201954$export$a50aceb0e02a00aa {
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $0310c1ff85201954$export$84d4095e16c6fc19.EVENT || obj.type === $0310c1ff85201954$export$84d4095e16c6fc19.ACK) {
            if ((0, $6qMhJ.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $0310c1ff85201954$export$84d4095e16c6fc19.EVENT ? $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_EVENT : $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $fWhxz.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $0310c1ff85201954$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $0310c1ff85201954$export$f9de6ca0bc043724 extends (0, $1odXU.Emitter) {
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $0310c1ff85201954$export$84d4095e16c6fc19.EVENT : $0310c1ff85201954$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $0310c1ff85201954$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $6qMhJ.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($0310c1ff85201954$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($0310c1ff85201954$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $0310c1ff85201954$export$84d4095e16c6fc19.CONNECT:
                return $0310c1ff85201954$var$isObject(payload);
            case $0310c1ff85201954$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $0310c1ff85201954$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $0310c1ff85201954$var$isObject(payload);
            case $0310c1ff85201954$export$84d4095e16c6fc19.EVENT:
            case $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $0310c1ff85201954$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $0310c1ff85201954$export$84d4095e16c6fc19.ACK:
            case $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $0310c1ff85201954$var$BinaryReconstructor {
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $fWhxz.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
}
module.exports["protocol"] = $0310c1ff85201954$export$a51d6b395ff4c65a;
module.exports["Encoder"] = $0310c1ff85201954$export$a50aceb0e02a00aa;
module.exports["Decoder"] = $0310c1ff85201954$export$f9de6ca0bc043724;

});

parcelRegister("fWhxz", function(module, exports) {

var $6qMhJ = parcelRequire("6qMhJ");

function $b9a9e0f6ffd208ba$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $b9a9e0f6ffd208ba$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $b9a9e0f6ffd208ba$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $6qMhJ.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $b9a9e0f6ffd208ba$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $b9a9e0f6ffd208ba$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $b9a9e0f6ffd208ba$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $b9a9e0f6ffd208ba$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $b9a9e0f6ffd208ba$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $b9a9e0f6ffd208ba$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $b9a9e0f6ffd208ba$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}
module.exports["deconstructPacket"] = $b9a9e0f6ffd208ba$export$ac2edb9eb7af56f6;
module.exports["reconstructPacket"] = $b9a9e0f6ffd208ba$export$a00da3b1ec037a04;

});

parcelRegister("6qMhJ", function(module, exports) {
const $4aeaa029a9e7e8ab$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $4aeaa029a9e7e8ab$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $4aeaa029a9e7e8ab$var$toString = Object.prototype.toString;
const $4aeaa029a9e7e8ab$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $4aeaa029a9e7e8ab$var$toString.call(Blob) === "[object BlobConstructor]";
const $4aeaa029a9e7e8ab$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $4aeaa029a9e7e8ab$var$toString.call(File) === "[object FileConstructor]";
function $4aeaa029a9e7e8ab$export$37488ff1135b1696(obj) {
    return $4aeaa029a9e7e8ab$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $4aeaa029a9e7e8ab$var$isView(obj)) || $4aeaa029a9e7e8ab$var$withNativeBlob && obj instanceof Blob || $4aeaa029a9e7e8ab$var$withNativeFile && obj instanceof File;
}
function $4aeaa029a9e7e8ab$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($4aeaa029a9e7e8ab$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($4aeaa029a9e7e8ab$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $4aeaa029a9e7e8ab$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $4aeaa029a9e7e8ab$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}
module.exports["isBinary"] = $4aeaa029a9e7e8ab$export$37488ff1135b1696;
module.exports["hasBinary"] = $4aeaa029a9e7e8ab$export$5234c529abdb5610;

});

parcelRegister("e6joS", function(module, exports) {
function $a440acb1a369a030$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}
module.exports["on"] = $a440acb1a369a030$export$af631764ddc44097;

});

parcelRegister("liT4p", function(module, exports) {
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $f825ff317086dbca$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $f825ff317086dbca$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $f825ff317086dbca$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $f825ff317086dbca$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $f825ff317086dbca$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $f825ff317086dbca$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};
module.exports["Backoff"] = $f825ff317086dbca$export$2d38012449449c89;

});

parcelRegister("eOOPa", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $hdVgM = parcelRequire("hdVgM");


var $boc9Y = parcelRequire("boc9Y");


var $iu6m9 = parcelRequire("iu6m9");


var $4frCv = parcelRequire("4frCv");


var $aX0Lv = parcelRequire("aX0Lv");


var $gVzjB = parcelRequire("gVzjB");


var $ixa9X = parcelRequire("ixa9X");


var $6Ted9 = parcelRequire("6Ted9");


var $aPvdt = parcelRequire("aPvdt");


var $84uMS = parcelRequire("84uMS");


var $bxMv2 = parcelRequire("bxMv2");


var $eSqCh = parcelRequire("eSqCh");


var $pyHw9 = parcelRequire("pyHw9");


var $8NlH6 = parcelRequire("8NlH6");


var $6MIiQ = parcelRequire("6MIiQ");


var $flwxq = parcelRequire("flwxq");


var $3LSA5 = parcelRequire("3LSA5");


var $h6NFo = parcelRequire("h6NFo");


var $9w9et = parcelRequire("9w9et");


var $dh538 = parcelRequire("dh538");


var $b0ow0 = parcelRequire("b0ow0");

const $6136c3b5ee822bdd$var$logger = (0, $4frCv.createLogger)('Provider', 'black');
const $6136c3b5ee822bdd$var$OUT_OF_SYNC_PERIOD = 3000; // 3 seconds
const $6136c3b5ee822bdd$export$5330735bb8365155 = 15;
const $6136c3b5ee822bdd$export$5124359d21eb0335 = 2;
class $6136c3b5ee822bdd$export$2881499e37b75b9a extends (0, $hdVgM.Emitter) {
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * Initialisation logic, called by Jira with a dummy getState function, deprecated in favour of the setup method which allows more configuration
   * @param {Function} getState Function that returns the editor state, used to retrieve collab-edit properties and to interact with prosemirror-collab
   * @throws {ProviderInitialisationError} Something went wrong during provider initialisation
   * @deprecated Use setup method instead
   */ initialize(getState) {
        return this.setup({
            getState: getState
        });
    }
    /**
   * Initialisation logic, called by the editor in the collab-edit plugin.
   *
   * @param {Function} options.getState Function that returns the editor state, used to retrieve collab-edit properties and to interact with prosemirror-collab
   * @param options.editorApi
   * @param {SyncUpErrorFunction} options.onSyncUpError (Optional) Function that gets called when the sync of steps fails after retrying 30 times, used by Editor to log to analytics
   * @throws {ProviderInitialisationError} Something went wrong during provider initialisation
   */ setup({ getState: getState, editorApi: editorApi, onSyncUpError: onSyncUpError }) {
        this.checkForCookies();
        try {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const collabPlugin = getState().plugins.find((p)=>p.key === 'collab$');
            if (collabPlugin === undefined) throw new (0, $ixa9X.ProviderInitialisationError)('Collab provider attempted to initialise, but Editor state is missing collab plugin');
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.clientId = collabPlugin.spec.config.clientID;
            // generate a temporary id as clientId when it is undefined
            // prefix temp-cp- indicates collab-provider
            if (!this.clientId) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            this.clientId = `temp-cp-${(0, $dQl1W.v4)()}`;
            this.documentService.setup({
                getState: getState,
                onSyncUpError: onSyncUpError,
                clientId: this.clientId
            });
            if (this.isBufferingEnabled && this.initialDraft && !this.isProviderInitialized) {
                const { document: document, version: version, metadata: metadata } = this.initialDraft;
                this.updateDocumentAndMetadata({
                    doc: document,
                    version: version,
                    metadata: metadata,
                    caller: 'Provider.setup'
                });
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).PROVIDER_INITIALIZED, (0, $flwxq.EVENT_STATUS).INFO, {
                    isBuffered: true
                });
            }
            if (!this.isChannelInitialized) {
                this.initializeChannel();
                this.isChannelInitialized = true;
            }
        } catch (initError) {
            this.analyticsHelper?.sendErrorEvent(initError, 'Error while initialising the provider');
            // Throw error so consumers are aware the initialisation failed when initialising themselves
            throw new (0, $ixa9X.ProviderInitialisationError)('Provider initialisation error', initError);
        }
        return this;
    }
    // Only used for the presence - opts out of the document service and api service
    setupForPresenceOnly(clientId) {
        this.clientId = clientId;
        this.checkForCookies();
        try {
            if (!this.isChannelInitialized) {
                this.initializeChannel();
                this.isChannelInitialized = true;
            }
        } catch (initError) {
            this.analyticsHelper?.sendErrorEvent(initError, 'Error while initialising the provider');
            // Throw error so consumers are aware the initialisation failed when initialising themselves
            throw new (0, $ixa9X.ProviderInitialisationError)('Provider initialisation error', initError);
        }
        return this;
    }
    checkForCookies() {
        if (!$parcel$global.navigator.cookieEnabled) {
            const initError = new (0, $ixa9X.ProviderInitialisationError)('Cookies are not enabled. Please enable cookies to use collaborative editing.');
            this.analyticsHelper?.sendErrorEvent(initError, 'Error while initialising the provider - cookies disabled');
            throw new (0, $ixa9X.ProviderInitialisationError)('Provider initialisation error - cookies disabled', initError);
        }
    }
    /**
   * Send steps from transaction to NCS (and as a consequence to other participants), called from the collab-edit plugin in the editor
   * @param {Transaction} _tr Deprecated, included to keep API consistent with Synchrony provider
   * @param {EditorState} _oldState Deprecated, included to keep API consistent with Synchrony provider
   * @param {EditorState} newState The editor state after applying the transaction
   * @throws {SendTransactionError} Something went wrong while sending the steps for this transaction
   */ send(_tr, _oldState, newState) {
        try {
            if (this.isViewOnly()) {
                const error = {
                    message: 'Attempted to send steps in view only mode',
                    data: {
                        code: (0, $6MIiQ.INTERNAL_ERROR_CODE).VIEW_ONLY_STEPS_ERROR
                    }
                };
                (0, $4frCv.logObfuscatedSteps)(_oldState, newState).then((attributes)=>{
                    const stepAttributes = attributes instanceof (0, $ixa9X.CustomError) ? {} : {
                        ...attributes
                    };
                    const stepsError = new (0, $ixa9X.CustomError)(error.message, error, {
                        ...stepAttributes
                    });
                    this.analyticsHelper?.sendErrorEvent(stepsError, stepsError.message);
                }).catch((err)=>this.analyticsHelper?.sendErrorEvent(err, err.message));
                return;
            }
            // Don't send steps while the document is locked (eg. when restoring the document)
            if (this.namespaceService.getIsNamespaceLocked()) {
                $6136c3b5ee822bdd$var$logger('The document is temporary locked');
                return;
            }
            this.documentService.send(_tr, _oldState, newState);
        } catch (error) {
            this.analyticsHelper?.sendErrorEvent(error, 'Error while sending steps for a transaction');
            throw new (0, $ixa9X.SendTransactionError)('Error while sending steps for a transaction', error);
        }
    }
    isViewOnly() {
        return this.permit && // isPermittedToEdit or isPermittedToView can be undefined, must use `===` here.
        this.permit.isPermittedToEdit === false && this.permit.isPermittedToView === true;
    }
    /**
   * Send messages, such as telepointers,  and AI provider changes to NCS and other participants.
   * Only used for telepointer data (text and node selections) in the editor and JWM.
   * JWM does some weird serialisation stuff on the node selections.
   * Silently fails if an error occurs, since Presence isn't a critical functionality and self-restores over time.
   *
   * @param {CollabTelepointerPayload} data Data you want to send to NCS / the other participants
   * @param {string} data.type Can only be 'telepointer' for now, we don't support anything else yet
   * @param {CollabSendableSelection} data.selection Object representing the selected element
   * @param {string} data.sessionId Identifier identifying the session
   */ sendMessage(data) {
        const basePayload = {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            userId: this.userId,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            sessionId: this.sessionId,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            clientId: this.clientId,
            permit: this.permit
        };
        try {
            if (data?.type === 'telepointer') this.channel.broadcast('participant:telepointer', {
                ...basePayload,
                selection: data.selection
            }, (0, $h6NFo.shouldTelepointerBeSampled)() ? (0, $gVzjB.telepointerCallback)(this.config.documentAri) : undefined);
            else if (data?.type === 'ai-provider:change') this.participantsService.sendAIProviderChanged({
                ...basePayload,
                ...data
            });
            else if (data?.type === 'participant:activity') {
                this.setPresenceActivity(data.activity);
                this.participantsService.sendPresenceActivityChanged();
            }
        } catch (error) {
            // We don't want to throw errors for Presence features as they tend to self-restore
            this.analyticsHelper?.sendErrorEvent(error, 'Error while sending message - telepointer');
        }
    }
    setAIProviderActiveIds(ids = []) {
        this.aiProviderActiveIds = ids;
    }
    /**
   * "Destroy" the provider, disconnect it's connection to the back-end service and unsubscribe all event listeners on the provider.
   * Used by Jira products (JWM, JPD) to disable the provider
   * @throws {DestroyError} Something went wrong while shutting down the collab provider
   */ destroy() {
        return this.unsubscribeAll();
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * Disconnect the provider, disconnect it's connection to the back-end service and unsubscribe all event listeners on the provider.
   * Used by Confluence to disable the provider when a user doesn't have access to a resource.
   * @deprecated use destroy instead, it does the same thing
   * @throws {DestroyError} Something went wrong while shutting down the collab provider
   */ disconnect() {
        return this.unsubscribeAll();
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * Disconnect the provider's connection to the back-end service and unsubscribe from all events emitted by this provider. Kept to keep roughly aligned to Synchrony API, which you need to call for each event.
   * @deprecated use destroy instead, it does the same thing
   * @throws {DestroyError} Something went wrong while shutting down the collab provider
   */ unsubscribeAll() {
        try {
            super.unsubscribeAll();
            this.channel.disconnect();
            if (this.sendStepsTimer) {
                clearInterval(this.sendStepsTimer);
                this.sendStepsTimer = undefined;
            }
        } catch (error) {
            this.analyticsHelper?.sendErrorEvent(error, 'Error while shutting down the collab provider');
            throw new (0, $ixa9X.DestroyError)('Error while shutting down the collab provider', error);
        }
        this.clearTimers();
        return this;
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * Update the title of the document in the collab provider and optionally broadcast it to other participants and NCS
   * @deprecated use setMetadata instead, it does the same thing
   * @param {string} title Title you want to set on the document
   * @param {boolean} broadcast (Optional) Flag indicating whether you want to broadcast the title change to the other participants, always true for now (otherwise we would lose title changes)
   * @throws {SetTitleError} Something went wrong while setting the title
   */ setTitle(title, broadcast) {
        try {
            if (this.isViewOnly()) return;
            this.metadataService.setTitle(title, broadcast);
        } catch (error) {
            this.analyticsHelper?.sendErrorEvent(error, 'Error while setting title');
            throw new (0, $ixa9X.SetTitleError)('Error while setting title', error);
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * Set editor width, not used any more
   * @deprecated use setMetadata instead, it does the same thing
   * @param {string} editorWidth string? indicating the editor width
   * @param {boolean} broadcast (Optional) Flag indicating whether you want to broadcast the editor width change
   * @throws {SetEditorWidthError} Something went wrong while setting the editor width
   */ setEditorWidth(editorWidth, broadcast) {
        try {
            this.metadataService.setEditorWidth(editorWidth, broadcast);
        } catch (error) {
            this.analyticsHelper?.sendErrorEvent(error, 'Error while setting editor width');
            throw new (0, $ixa9X.SetEditorWidthError)('Error while setting editor width', error);
        }
    }
    /**
   * Set the editor width and title and distribute it to all participants. Used by Confluence
   * @param {Metadata} metadata The metadata you want to update
   * @throws {ExampleError} Something went wrong while setting the metadata
   */ setMetadata(metadata) {
        try {
            if (this.isViewOnly()) return;
            this.metadataService.setMetadata(metadata);
        } catch (error) {
            this.analyticsHelper?.sendErrorEvent(error, 'Error while setting metadata');
            throw new (0, $ixa9X.SetMetadataError)('Error while setting metadata', error);
        }
    }
    /**
   * Returns the namespace locking status via true/false
   */ getIsNamespaceLocked() {
        return this.namespaceService.getIsNamespaceLocked();
    }
    constructor(config){
        super();
        this.api = void 0;
        this.channel = void 0;
        this.config = void 0;
        this.analyticsHelper = void 0;
        this.isChannelInitialized = false;
        this.initialDraft = void 0;
        this.isProviderInitialized = false;
        this.isBuffered = false;
        // User permit is used to determine if the user is allowed to view, comment or edit the document
        // Therefore, the initial value is false for all three
        this.permit = {
            isPermittedToView: false,
            isPermittedToComment: false,
            isPermittedToEdit: false
        };
        // isBufferingEnabled is a boolean value passed to the config during provider creation.
        // It determines if the provider should initialize immediately and will only be true if:
        // the feature flag is enabled and the initial draft fetched from NCS is also passed in the config.
        this.isBufferingEnabled = false;
        // SessionID is the unique socket-session.
        this.sessionId = void 0;
        // ClientID is the unique ID for a prosemirror client. Used for step-rebasing.
        this.clientId = void 0;
        // UserID is the users actual account id.
        this.userId = void 0;
        // PresenceId is used to correlate to independent websocket connections together (presence and editor)
        this.presenceId = void 0;
        // PresenceActivity is used to determine if the user is a viewer or editor, only used in the presence connection
        this.presenceActivity = void 0;
        this.presenceUpdateTimeout = void 0;
        this.disconnectedAt = void 0;
        this.sendStepsTimer = void 0;
        this.participantsService = void 0;
        this.metadataService = void 0;
        this.documentService = void 0;
        this.namespaceService = void 0;
        // Local IDs of active AI Providers
        this.aiProviderActiveIds = [];
        /**
     * Wrapper for this.emit, it binds scope for callbacks and waits for initialising of the editor before emitting events.
     * Waiting for the collab provider to become connected to the editor ensures the editor doesn't miss any events.
     * @param evt - Event name to emit to subscribers
     * @param data - Event data to emit to subscribers
     */ // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.emitCallback = (evt, data)=>this.emit(evt, data);
        /**
     * Wrapper to update document and metadata.
     * Catches and logs any errors thrown by document service's updateDocument and updateMetadata methods and destroys the provider in case of errors.
     * Passing the document, metadata, version (either from the initial draft or from collab service)
     */ this.updateDocumentAndMetadata = ({ doc: doc, version: version, metadata: metadata, caller: caller })=>{
            try {
                this.documentService.updateDocument({
                    doc: doc,
                    version: version,
                    metadata: metadata,
                    caller: caller
                });
                this.metadataService.updateMetadata(metadata);
                this.isProviderInitialized = true;
            } catch (e) {
                this.analyticsHelper?.sendErrorEvent(e, 'Failed to update with the init document, destroying provider');
                // Stop events and connections to step us trying to talk to the backend with an invalid state.
                this.destroy();
            }
        };
        this.initializeChannel = ()=>{
            this.emit('connecting', {
                initial: true
            });
            // shouldSkipDocumentInit will bypass the NCS draft fetch if the initial draft is passed to the provider
            const shouldSkipDocumentInit = Boolean(this.initialDraft);
            this.channel.on('connected', ({ sid: sid, initialized: initialized })=>{
                this.sessionId = sid;
                this.emit('connected', {
                    sid: sid,
                    initial: !initialized
                });
                const unconfirmedStepsLength = this.documentService.getUnconfirmedSteps()?.length;
                // if buffering is enabled and the provider is initialized before connection,
                // send any unconfirmed steps
                if (this.isBufferingEnabled && this.isProviderInitialized && !this.isBuffered) {
                    this.isBuffered = true; // setting buffering to true so that the sending of unconfirmed steps happens only on first connection
                    this.documentService.sendStepsFromCurrentState(true);
                }
                // Early initialization with initial draft passed via provider
                if (this.initialDraft && initialized && !this.isProviderInitialized) {
                    const { document: document, version: version, metadata: metadata } = this.initialDraft;
                    this.updateDocumentAndMetadata({
                        doc: document,
                        version: version,
                        metadata: metadata,
                        caller: 'connectedHandler'
                    });
                }
                // If already initialized, `connected` means reconnected
                if (initialized && this.disconnectedAt && // Offline longer than `OUT_OF_SYNC_PERIOD`
                Date.now() - this.disconnectedAt >= $6136c3b5ee822bdd$var$OUT_OF_SYNC_PERIOD) this.documentService.throttledCatchupv2((0, $flwxq.CatchupEventReason).RECONNECTED, {
                    disconnectionPeriodSeconds: Math.floor((Date.now() - this.disconnectedAt) / 1000),
                    offlineStepsLength: (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) ? (0, $b0ow0.getOfflineStepsLength)(this.documentService.getUnconfirmedSteps(), this.documentService.getUnconfirmedStepsOrigins()) : undefined,
                    offlineReplaceStepsLength: (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) ? (0, $b0ow0.getOfflineReplaceStepsLength)(this.documentService.getUnconfirmedSteps(), this.documentService.getUnconfirmedStepsOrigins()) : undefined,
                    unconfirmedStepsLength: unconfirmedStepsLength
                }, (0, $dh538.fg)('add_session_id_to_catchup_query') ? this.sessionId : undefined);
                this.participantsService.startInactiveRemover(this.sessionId);
                if (this.config.batchProps) {
                    if (this.config.getUser) throw new (0, $ixa9X.ProviderInitialisationError)('Cannot supply getUser and batchProps together');
                    this.participantsService.initializeFirstBatchFetchUsers();
                }
                this.disconnectedAt = undefined;
            }).on('init', ({ doc: doc, version: version, metadata: metadata })=>{
                // Initial document and version
                this.updateDocumentAndMetadata({
                    doc: doc,
                    version: version,
                    metadata: metadata,
                    caller: 'initHandler'
                });
            }).on('restore', this.documentService.onRestore).on('permission', (permit)=>{
                this.permit = Object.assign(this.permit, permit);
                this.emit('permission', permit);
            }).on('steps:added', this.documentService.onStepsAdded).on('metadata:changed', this.metadataService.onMetadataChanged).on('participant:telepointer', (payload)=>this.participantsService.onParticipantTelepointer(payload, this.sessionId)).on('presence:joined', this.participantsService.onPresenceJoined).on('presence', this.participantsService.onPresence).on('participant:left', this.participantsService.onParticipantLeft).on('participant:updated', this.participantsService.onParticipantUpdated).on('disconnect', this.onDisconnected.bind(this)).on('error', this.onErrorHandled).on('status', async (status)=>{
                await this.namespaceService.onNamespaceStatusChanged(status);
                const isLocked = this.namespaceService.getIsNamespaceLocked();
                this.emit('namespace-lock:check', {
                    isLocked: isLocked
                });
            }).connect(shouldSkipDocumentInit);
        };
        this.setUserId = (id)=>{
            this.userId = id;
        };
        this.getPresenceData = ()=>{
            return {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                sessionId: this.sessionId,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                userId: this.userId,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                clientId: this.clientId,
                permit: this.permit,
                presenceId: this.presenceId,
                presenceActivity: this.presenceActivity
            };
        };
        this.setPresenceActivity = (activity)=>{
            this.presenceActivity = activity;
        };
        /**
     * @param {InternalError} error The error to handle
     */ this.onErrorHandled = (error)=>{
            // User tried committing steps but they were rejected because:
            // HEAD_VERSION_UPDATE_FAILED: the collab service's latest stored step tail version didn't correspond to the head version of the first step submitted
            // VERSION_NUMBER_ALREADY_EXISTS: while storing the steps there was a conflict meaning someone else wrote steps into the database more quickly
            if (error.data?.code === (0, $6Ted9.NCS_ERROR_CODE).HEAD_VERSION_UPDATE_FAILED || error.data?.code === (0, $6Ted9.NCS_ERROR_CODE).VERSION_NUMBER_ALREADY_EXISTS) this.documentService.onStepRejectedError();
            else {
                this.analyticsHelper?.sendErrorEvent(error, error.message);
                const mappedError = (0, $8NlH6.errorCodeMapper)(error);
                // Only emit errors to Confluence very intentionally because they will disconnect the collab provider
                if (mappedError) {
                    this.analyticsHelper?.sendProviderErrorEvent(mappedError);
                    this.emit('error', mappedError);
                }
            }
        };
        this.getAIProviderActiveIds = ()=>{
            return this.aiProviderActiveIds;
        };
        // Note: this gets triggered on page reload for Firefox (not other browsers) because of closeOnBeforeunload: false
        this.onDisconnected = ({ reason: reason })=>{
            this.disconnectedAt = Date.now();
            this.participantsService.disconnect(reason, this.sessionId);
        };
        /**
     * Returns the documents metadata
     */ this.getMetadata = ()=>{
            return this.metadataService.getMetaData();
        };
        /**
     * Return the ADF version of the current draft document, together with it's title and the current step version.
     * Used for draft sync, a process running every 5s for the first editor of a document to sync the document to the Confluence back-end.
     * @throws {GetCurrentStateError} Something went wrong while returning the current state
     */ this.getCurrentState = async ()=>{
            try {
                return await this.documentService.getCurrentState();
            } catch (error) {
                this.analyticsHelper?.sendErrorEvent(error, 'Error while returning ADF version of current draft document');
                throw new (0, $ixa9X.GetCurrentStateError)('Error while returning the current state of the draft document', error); // Reject the promise so the consumer can react to it failing
            }
        };
        /**
     * Return the final acknowledged (by NCS) ADF version of the current draft document, together with it's title and the current step version.
     * Used when returning the document to Confluence on publish.
     * @throws {GetFinalAcknowledgedStateError} Something went wrong while returning the acknowledged state
     */ this.getFinalAcknowledgedState = async (reason)=>{
            try {
                return await this.documentService.getFinalAcknowledgedState(reason);
            } catch (error) {
                this.analyticsHelper?.sendErrorEvent(error, 'Error while returning ADF version of the final draft document');
                throw new (0, $ixa9X.GetFinalAcknowledgedStateError)('Error while returning the final acknowledged state of the draft document', error); // Reject the promise so the consumer can react to it failing
            }
        };
        this.getUnconfirmedSteps = ()=>{
            return this.documentService.getUnconfirmedSteps();
        };
        /**
     * Provides a synchronous method to retreive the version from the Document Service / Editor State
     *
     * @returns {number} Returns the current ProseMirror version from the Editor State
     */ this.getCurrentPmVersion = ()=>{
            return this.documentService.getCurrentPmVersion();
        };
        /**
     * Used when the provider is disconnected or destroyed to prevent perpetual timers from continuously running
     */ this.clearTimers = ()=>{
            clearTimeout(this.presenceUpdateTimeout);
            this.participantsService.clearTimers();
        };
        this.getParticipants = ()=>{
            return this.participantsService.getParticipants();
        };
        this.getUniqueParticipantSize = ()=>{
            return this.participantsService.getUniqueParticipantSize();
        };
        this.getUniqueParticipants = ()=>{
            return this.participantsService.getUniqueParticipants({
                isHydrated: false
            });
        };
        this.getUniqueHydratedParticipants = ()=>{
            return this.participantsService.getUniqueParticipants({
                isHydrated: true
            });
        };
        this.getAIProviderParticipants = ()=>{
            return this.participantsService.getAIProviderParticipants();
        };
        this.fetchMore = async (props)=>{
            if (this.config.batchProps) await this.participantsService.enrichParticipants({
                ...this.config.batchProps,
                batchSize: props?.fetchSize ?? this.config.batchProps.batchSize
            });
            else throw new Error('Must provide batch properties to use fetchMore');
        };
        this.getSessionId = ()=>{
            return this.sessionId;
        };
        this.getDocumentAri = ()=>{
            return this.config.documentAri;
        };
        this.config = config;
        this.analyticsHelper = new (0, $aX0Lv.default)(this.config.documentAri, this.config.productInfo?.subProduct, this.config.analyticsClient, this.config.getAnalyticsWebClient);
        this.channel = new (0, $boc9Y.Channel)(config, this.analyticsHelper);
        this.isChannelInitialized = false;
        this.initialDraft = this.config.initialDraft;
        this.isBufferingEnabled = Boolean(this.config.isBufferingEnabled);
        this.isProviderInitialized = false;
        this.participantsService = new (0, $pyHw9.ParticipantsService)(this.analyticsHelper, undefined, this.emitCallback, this.config.getUser, this.config.batchProps, this.channel.broadcast, this.channel.sendPresenceJoined, this.getPresenceData, this.setUserId, this.getAIProviderActiveIds, this.config.fetchAnonymousAsset);
        this.metadataService = new (0, $aPvdt.MetadataService)(this.emitCallback, this.channel.sendMetadata);
        this.namespaceService = new (0, $eSqCh.NamespaceService)();
        this.presenceId = this.config.presenceId;
        this.presenceActivity = this.config.presenceActivity;
        if (config.isPresenceOnly) {
            // this check is specifically for the presence only
            // This presence feature is only for the confluence view page & jira presence which do not need the document service or api
            this.documentService = new (0, $bxMv2.NullDocumentService)();
            this.api = new (0, $9w9et.NullApi)();
        } else {
            this.documentService = new (0, $84uMS.DocumentService)(this.participantsService, this.analyticsHelper, this.channel.fetchCatchupv2, this.channel.fetchReconcile, this.channel.fetchGeneratedDiffSteps, this.emitCallback, this.channel.broadcast, ()=>this.userId, this.onErrorHandled, this.metadataService, this.namespaceService.getIsNamespaceLocked.bind(this.namespaceService), this.config.enableErrorOnFailedDocumentApply, {
                __livePage: this.config.__livePage || false
            }, this.channel.getConnected);
            this.api = new (0, $3LSA5.Api)(config, this.documentService, this.channel);
        }
        this.sendStepsTimer = setInterval(()=>{
            $6136c3b5ee822bdd$var$logger('Intervally sendStepsFromCurrentState');
            this.documentService.sendStepsFromCurrentState(true, undefined);
        }, 5000);
    }
}
module.exports["MAX_STEP_REJECTED_ERROR"] = $6136c3b5ee822bdd$export$5330735bb8365155;
module.exports["MAX_STEP_REJECTED_ERROR_AGGRESSIVE"] = $6136c3b5ee822bdd$export$5124359d21eb0335;
module.exports["Provider"] = $6136c3b5ee822bdd$export$2881499e37b75b9a;

});

parcelRegister("hdVgM", function(module, exports) {

var $majy4 = parcelRequire("majy4");

class $74d79b69f01a47f7$export$4293555f241ae35a {
    /**
   * Emit events to subscribers
   */ emit(evt, data) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventEmitter.emit(evt, data);
        return this;
    }
    /**
   * Subscribe to events emitted by this provider
   */ on(evt, handler) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventEmitter.on(evt, handler);
        return this;
    }
    /**
   * Unsubscribe from events emitted by this provider
   */ off(evt, handler) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventEmitter.off(evt, handler);
        return this;
    }
    /**
   * Unsubscribe from all events emitted by this provider.
   */ unsubscribeAll(evt) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventEmitter.removeAllListeners(evt);
        return this;
    }
    constructor(){
        this.eventEmitter = new (0, $majy4.EventEmitter2)();
    }
}
module.exports["Emitter"] = $74d79b69f01a47f7$export$4293555f241ae35a;

});

parcelRegister("boc9Y", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $hdVgM = parcelRequire("hdVgM");


var $4frCv = parcelRequire("4frCv");


var $h6NFo = parcelRequire("h6NFo");


var $flwxq = parcelRequire("flwxq");


var $5TBlQ = parcelRequire("5TBlQ");


var $a5At1 = parcelRequire("a5At1");


var $7W8Hz = parcelRequire("7W8Hz");


var $a0Jyl = parcelRequire("a0Jyl");


var $6MIiQ = parcelRequire("6MIiQ");


var $6Ted9 = parcelRequire("6Ted9");


var $ixa9X = parcelRequire("ixa9X");


var $fFa3V = parcelRequire("fFa3V");

const $2c3ccd3818e40940$var$logger = (0, $4frCv.createLogger)('Channel', 'green');
class $2c3ccd3818e40940$export$cfdacaa37f9b4dd7 extends (0, $hdVgM.Emitter) {
    /**
   * Connect to collab service using websockets
   */ connect(shouldInitialize = false) {
        (0, $h6NFo.startMeasure)((0, $h6NFo.MEASURE_NAME).SOCKET_CONNECT, this.analyticsHelper);
        // If provider already has access to the initial draft, explicitly set channel as initialized
        // to bypass BE doc retrieval
        if (shouldInitialize) this.initialized = true;
        if (!this.initialized) {
            (0, $h6NFo.startMeasure)((0, $h6NFo.MEASURE_NAME).DOCUMENT_INIT, this.analyticsHelper);
            this.initExperience?.start();
        }
        const { documentAri: documentAri, url: url, path: path, createSocket: createSocket, permissionTokenRefresh: permissionTokenRefresh } = this.config;
        let auth;
        if (permissionTokenRefresh) auth = async (cb)=>{
            // Rebuild authData to ensure values are current
            const authData = {
                // The initialized status. If false, BE will send document, otherwise not.
                initialized: this.initialized,
                // ESS-1009 Allow to opt-in into 404 response
                need404: this.config.need404
            };
            try {
                const token = await permissionTokenRefresh();
                if (token) authData.token = token;
                else authData.token = undefined;
                cb(authData);
            } catch (error) {
                // Pass the error back to the consumers so they can deal with exceptional cases themselves (eg. no permissions because the page was deleted)
                const authenticationError = {
                    message: 'Insufficient editing permissions',
                    data: {
                        status: 403,
                        code: (0, $6MIiQ.INTERNAL_ERROR_CODE).TOKEN_PERMISSION_ERROR,
                        meta: {
                            originalError: error,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            reason: error?.data?.meta?.reason // Should always be 'RESOURCE_DELETED' Temporary, until Confluence Cloud removes their hack
                        }
                    }
                };
                this.emit('error', authenticationError);
            }
        };
        else // Ignored via go/ees005
        // eslint-disable-next-line require-await
        auth = async (cb)=>{
            // Rebuild authData to ensure values are current
            const authData = {
                // The initialized status. If false, BE will send document, otherwise not.
                initialized: this.initialized,
                // ESS-1009 Allow to opt-in into 404 response
                need404: this.config.need404
            };
            cb(authData);
        };
        this.socket = createSocket(`${url}/session/${documentAri}`, auth, this.config.productInfo, this.config.isPresenceOnly, this.analyticsHelper, path);
        // Due to https://github.com/socketio/socket.io-client/issues/1473,
        // reconnect no longer fired on the socket.
        // We should use `connect` for better cross platform compatibility(Mobile/Web).
        this.socket.on('connect', this.onConnect);
        this.socket.on('data', this.onReceiveData);
        this.socket.on('permission', (permit)=>{
            this.emit('permission', permit);
        });
        this.socket.on('steps:added', (data)=>{
            this.emit('steps:added', data);
        });
        this.socket.on('participant:telepointer', ({ timestamp: timestamp, data: data })=>{
            // data is TelepointerPayload without timestamp
            this.emit('participant:telepointer', {
                timestamp: timestamp,
                ...data
            });
        });
        this.socket.on('presence:joined', (data)=>{
            this.emit('presence:joined', data);
        });
        this.socket.on('presence', (data)=>{
            this.emit('presence', data);
        });
        this.socket.on('participant:left', (data)=>{
            this.emit('participant:left', data);
        });
        this.socket.on('participant:updated', ({ sessionId: sessionId, timestamp: timestamp, data: data, clientId: clientId })=>{
            this.emit('participant:updated', {
                sessionId: sessionId,
                timestamp: timestamp,
                clientId: clientId,
                ...data
            });
        });
        this.socket.on('metadata:changed', (payload)=>{
            this.emit('metadata:changed', payload);
        });
        // ESS-2916 namespace status event - lock/unlock
        this.socket.on('status', (data)=>{
            this.emit('status', data);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-await
        this.socket.on('disconnect', async (reason)=>{
            this.connected = false;
            $2c3ccd3818e40940$var$logger(`disconnect reason: ${reason}`);
            this.emit('disconnect', {
                reason: reason
            });
            if (reason === (0, $7W8Hz.socketIOReasons).IO_SERVER_DISCONNECT && this.socket) // The disconnection was initiated by the server, we need to reconnect manually.
            try {
                this.socket.connect();
            } catch (error) {
                this.analyticsHelper?.sendErrorEvent(error, 'Error while reconnecting the channel');
                const reconnectionError = {
                    message: 'Caught error during reconnection',
                    data: {
                        status: 500,
                        code: (0, $6MIiQ.INTERNAL_ERROR_CODE).RECONNECTION_ERROR
                    }
                };
                this.emit('error', reconnectionError);
            }
        });
        // Socket error, including errors from `packetMiddleware`, `controllers` and `onconnect` and more. Parameter is a plain JSON object.
        this.socket.on('error', (socketError)=>{
            this.emit('error', socketError);
        });
        // `connect_error`'s parameter type is `Error`.
        // Ensure the error emit to the provider has the same structure, so we can handle them unified.
        this.socket.on('connect_error', this.onConnectError);
        this.socket.on('permission:invalidateToken', this.handlePermissionInvalidateToken);
        this.socket.onAnyOutgoing((_, ...args)=>this.onAnyOutgoingHandler(Date.now(), args));
        // To trigger reconnection when browser comes back online
        if (!this.network) this.network = new (0, $a0Jyl.default)({
            onlineCallback: this.onOnlineHandler
        });
        // Helper class to track reconnection issues, to emit an error if too many failed reconnection attempts happen
        this.reconnectHelper = new (0, $5TBlQ.default)();
        // Fired upon a reconnection attempt error (from Socket.IO Manager)
        this.socket.io.on('reconnect_error', this.onReconnectError);
        // Automatic disconnect on tab background with delay, to keep presence UX accurate
        // and reduce wasted connections. Reconnects upon tab becoming active again
        this.addVisiblityListener();
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onAnyOutgoingHandler(currentTimeMs, args) {
        const rateLimitType = this.config.rateLimitType || this.RATE_LIMIT_TYPE_NONE;
        if (rateLimitType === this.RATE_LIMIT_TYPE_NONE) return;
        const stepLimit = this.config.rateLimitStepCount || 0;
        const stepSizeLimit = this.config.rateLimitTotalStepSize || 0;
        const maxStepSizeLimit = this.config.rateLimitMaxStepSize || 0;
        for (const arg of args)if (arg.type === 'steps:commit') {
            if (currentTimeMs - this.rateLimitWindowStartMs > this.rateLimitWindowDurationMs) {
                // Start a new window
                this.rateLimitWindowStartMs = currentTimeMs;
                this.stepCounter = 0;
                this.stepSizeCounter = 0;
                this.maxStepSize = 0;
            }
            this.stepCounter += arg.steps.length;
            for (const step of arg.steps){
                const stepSize = JSON.stringify(step).length;
                this.stepSizeCounter += stepSize;
                if (stepSize > this.maxStepSize) this.maxStepSize = stepSize;
            }
            if (this.isLimitExceeded(stepLimit, stepSizeLimit, maxStepSizeLimit)) {
                const rateLimitError = {
                    message: 'Rate limited',
                    data: {
                        code: (0, $6Ted9.NCS_ERROR_CODE).RATE_LIMIT_ERROR,
                        status: 500,
                        meta: {
                            rateLimitType: rateLimitType,
                            maxStepSize: this.maxStepSize,
                            stepSizeCounter: this.stepSizeCounter,
                            stepCounter: this.stepCounter
                        }
                    }
                };
                if (rateLimitType === this.RATE_LIMIT_TYPE_HARD) {
                    this.emit('error', rateLimitError);
                    throw new Error();
                } else if (rateLimitType === this.RATE_LIMIT_TYPE_SOFT) this.analyticsHelper?.sendErrorEvent(rateLimitError, 'Rate limited');
            }
        }
    }
    async commonHeaders() {
        return {
            ...this.config.permissionTokenRefresh ? {
                'x-token': await this.getChannelToken()
            } : {},
            'x-product': (0, $4frCv.getProduct)(this.config.productInfo),
            'x-subproduct': (0, $4frCv.getSubProduct)(this.config.productInfo)
        };
    }
    isLimitExceeded(stepLimit, stepSizeLimit, maxStepSizeLimit) {
        return stepLimit > 0 && this.stepCounter > stepLimit || stepSizeLimit > 0 && this.stepSizeCounter > stepSizeLimit || maxStepSizeLimit > 0 && this.maxStepSize > maxStepSizeLimit;
    }
    /**
   * Adds an event listener for visibilitychange events to automatically close the socket
   * connection  if tab is in background for longer than disconnectDelay
   */ addVisiblityListener() {
        const disconnectDelay = 60;
        if (this.config.isPresenceOnly) this.unbindVisibilityListener = (0, $fFa3V.bind)(document, {
            type: 'visibilitychange',
            listener: ()=>{
                this.disconnectTimer = this.autoDisconnect(this.disconnectTimer, disconnectDelay);
            }
        });
    }
    disconnect() {
        this.unsubscribeAll();
        this.cleanupAutoDisconnect();
        this.network?.destroy();
        this.network = null;
        if (this.socket) {
            this.socket.close();
            this.socket = null;
            this.reconnectHelper?.destroy();
        }
    }
    constructor(config, analyticsHelper){
        super();
        this.RATE_LIMIT_TYPE_NONE = 0;
        this.RATE_LIMIT_TYPE_SOFT = 1;
        this.RATE_LIMIT_TYPE_HARD = 2;
        this.connected = false;
        this.config = void 0;
        this.socket = null;
        this.reconnectHelper = null;
        this.initialized = false;
        this.analyticsHelper = void 0;
        this.initExperience = void 0;
        this.token = void 0;
        this.network = null;
        this.disconnectTimer = void 0;
        this.rateLimitWindowDurationMs = 60000;
        this.rateLimitWindowStartMs = 0;
        this.stepCounter = 0;
        this.stepSizeCounter = 0;
        this.maxStepSize = 0;
        // read-only getters used for tests
        this.getInitialized = ()=>this.initialized;
        this.getConnected = ()=>this.connected;
        this.getSocket = ()=>this.socket;
        this.getToken = ()=>this.token;
        // Used to retrieve the x-token for API requests
        this.getChannelToken = async ()=>{
            if (this.token) return this.token;
            if (!this.config.permissionTokenRefresh) return undefined;
            const token = await this.config.permissionTokenRefresh() ?? undefined;
            return token;
        };
        this.handlePermissionInvalidateToken = (data)=>{
            $2c3ccd3818e40940$var$logger('Received permission invalidate event ', data);
            this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).INVALIDATE_TOKEN, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                reason: data.reason,
                // Potentially incorrect when value of token changes between connecting and connect.
                // See: https://bitbucket.org/atlassian/%7Bc8e2f021-38d2-46d0-9b7a-b3f7b428f724%7D/pull-requests/29905#comment-375308874
                usedCachedToken: !!this.token
            });
        };
        this.onConnectError = (error)=>{
            const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).SOCKET_CONNECT, this.analyticsHelper);
            this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).CONNECTION, (0, $flwxq.EVENT_STATUS).FAILURE, {
                latency: measure?.duration,
                // Potentially incorrect when value of token changes between connecting and connect.
                // See: https://bitbucket.org/atlassian/%7Bc8e2f021-38d2-46d0-9b7a-b3f7b428f724%7D/pull-requests/29905#comment-375308874
                usedCachedToken: !!this.token
            });
            this.analyticsHelper?.sendErrorEvent(error, 'Error while establishing connection');
            // If error received with `data`, it means the connection is rejected
            // by the server on purpose for example no permission, so no need to
            // keep the underneath connection, need to close. But some error like
            // `xhr polling error` needs to retry.
            const errorData = error.data;
            if (errorData) this.socket?.close();
            const connectionError = {
                message: error.message ?? 'Connection error without message',
                data: {
                    // @ts-expect-error I bet we'll see some connection errors, for the Socket IO errors
                    code: errorData?.code ?? (0, $6MIiQ.INTERNAL_ERROR_CODE).CONNECTION_ERROR,
                    ...errorData
                }
            };
            this.emit('error', connectionError);
        };
        this.onReconnectError = (error)=>{
            this.reconnectHelper?.countReconnectError();
            if (this.reconnectHelper?.isLikelyNetworkIssue()) {
                this.analyticsHelper?.sendErrorEvent(error, 'Likely network issue while reconnecting the channel');
                const reconnectionError = {
                    message: 'Reconnection failed 8 times when browser was offline, likely there was a network issue',
                    data: {
                        code: (0, $6MIiQ.INTERNAL_ERROR_CODE).RECONNECTION_NETWORK_ISSUE
                    }
                };
                this.emit('error', reconnectionError);
            }
        };
        this.onConnect = ()=>{
            this.connected = true;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $2c3ccd3818e40940$var$logger('Connected.', this.socket.id);
            const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).SOCKET_CONNECT, this.analyticsHelper);
            this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).CONNECTION, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                latency: measure?.duration,
                // Potentially incorrect when value of token changes between connecting and connect.
                // See: https://bitbucket.org/atlassian/%7Bc8e2f021-38d2-46d0-9b7a-b3f7b428f724%7D/pull-requests/29905#comment-375308874
                usedCachedToken: !!this.token
            });
            this.emit('connected', {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                sid: this.socket.id,
                initialized: this.initialized
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onReceiveData = (data)=>{
            $2c3ccd3818e40940$var$logger('Received data', data);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $2c3ccd3818e40940$var$logger('Session ID is', this.socket.id);
            if (data.type === 'initial') {
                if (!this.initialized) {
                    const { doc: doc, version: version, userId: userId, metadata: metadata } = data;
                    const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).DOCUMENT_INIT, this.analyticsHelper);
                    this.initExperience?.success();
                    this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).DOCUMENT_INIT, // TODO: ED-26957 - detect when document init fails and fire corresponding event for it
                    (0, $flwxq.EVENT_STATUS).SUCCESS, {
                        latency: measure?.duration,
                        resetReason: data.resetReason,
                        hasTitle: !!data.metadata?.title
                    });
                    this.initialized = true;
                    this.emit('init', {
                        doc: doc,
                        version: version,
                        userId: userId,
                        metadata: metadata
                    });
                } else {
                    // Page has just been restored, need to fix all the participants as well.
                    const { doc: doc, version: version, userId: userId, metadata: metadata, targetClientId: targetClientId } = data;
                    this.emit('restore', {
                        doc: doc,
                        version: version,
                        userId: userId,
                        metadata: metadata,
                        targetClientId: targetClientId
                    });
                }
            } else this.emit('steps:added', data);
        };
        this.fetchCatchupv2 = async (fromVersion, clientId, catchUpOutofSync, reason, sessionId)=>{
            try {
                const { steps: steps, metadata: metadata } = await (0, $dwp40.utils).requestService(this.config, {
                    path: `document/${encodeURIComponent(this.config.documentAri)}/catchupv2`,
                    queryParams: {
                        version: fromVersion,
                        clientId: clientId,
                        catchUpOutofSync: catchUpOutofSync,
                        reason: reason,
                        sessionId: sessionId
                    },
                    requestInit: {
                        headers: await this.commonHeaders()
                    }
                });
                return {
                    steps: steps,
                    metadata: metadata
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (error.code === 404) {
                    const errorNotFound = {
                        message: 'The requested document is not found',
                        data: {
                            status: error.code,
                            code: (0, $6MIiQ.INTERNAL_ERROR_CODE).DOCUMENT_NOT_FOUND
                        }
                    };
                    this.emit('error', errorNotFound);
                    return {};
                }
                $2c3ccd3818e40940$var$logger("Can't fetch the catchupv2", error.message);
                const errorCatchupv2 = {
                    message: 'Cannot fetch catchupv2 from collab service',
                    data: {
                        status: error.status,
                        code: (0, $6MIiQ.INTERNAL_ERROR_CODE).CATCHUP_FAILED
                    }
                };
                this.emit('error', errorCatchupv2);
                throw error;
            }
        };
        this.fetchReconcile = async (currentStateDoc, reason)=>{
            try {
                const reqBody = JSON.stringify({
                    doc: currentStateDoc,
                    productId: 'ccollab',
                    reason: reason
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const reconcileResponse = await (0, $dwp40.utils).requestService(this.config, {
                    path: `document/${encodeURIComponent(this.config.documentAri)}/reconcile`,
                    requestInit: {
                        headers: {
                            ...await this.commonHeaders(),
                            'Content-Type': 'application/json'
                        },
                        method: 'POST',
                        body: reqBody
                    }
                });
                return reconcileResponse;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                this.analyticsHelper?.sendErrorEvent(error, 'Error while fetching reconciled document');
                throw error;
            }
        };
        /**
     * Fetch generated diff steps from the back-end service
     * @param currentStateDoc - The current state document
     * @param reason - The reason for generating diff steps
     * @returns {Promise<GenerateDiffStepsResponseBody>} - The generated diff steps response body
     */ this.fetchGeneratedDiffSteps = async (currentStateDoc, reason)=>{
            try {
                const reqBody = JSON.stringify({
                    doc: currentStateDoc,
                    productId: 'ccollab',
                    reason: reason
                });
                const reconcileResponse = await (0, $dwp40.utils).requestService(this.config, {
                    path: `document/${encodeURIComponent(this.config.documentAri)}/generate-diff-steps`,
                    requestInit: {
                        headers: {
                            ...await this.commonHeaders(),
                            'Content-Type': 'application/json'
                        },
                        method: 'POST',
                        body: reqBody
                    }
                });
                return reconcileResponse;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                this.analyticsHelper?.sendErrorEvent(error, 'Error while fetching generated steps from the BE server');
                throw error;
            }
        };
        /**
     * Send message to the back-end service over the channel. Timestamp will be added server side.
     * @throws {NotInitializedError} Channel not initialized
     * @throws {NotConnectedError} Channel not connected
     */ this.broadcast = (type, data, callback)=>{
            if (!this.socket) throw new (0, $ixa9X.NotInitializedError)('Cannot broadcast, not initialized yet');
            if (!this.connected) {
                if (this.config.throwOnNotConnected) throw new (0, $ixa9X.NotConnectedError)('Cannot broadcast, currently offline.');
                return;
            }
            this.socket.emit('broadcast', {
                type: type,
                ...data
            }, callback);
        };
        /**
     * Send metadata to the back-end service over the channel
     * @throws {NotInitializedError} Channel not initialized
     * @throws {NotConnectedError} Channel not connected
     */ this.sendMetadata = (metadata)=>{
            if (!this.socket) throw new (0, $ixa9X.NotInitializedError)('Cannot send metadata, not initialized yet');
            if (!this.connected) {
                if (this.config.throwOnNotConnected) throw new (0, $ixa9X.NotConnectedError)('Cannot send metadata, currently offline.');
            }
            this.socket.emit('metadata', metadata);
        };
        this.sendPresenceJoined = ()=>{
            if (!this.connected || !this.socket) return;
            this.socket.emit('presence:joined');
        };
        this.onOnlineHandler = ()=>{
            // Force an immediate reconnect, the socket must first be closed to reset reconnection delay logic
            if (!this.connected) {
                this.socket?.close();
                this.socket?.connect();
            }
        };
        /**
     * Unbinds event listeners and timers used when handling connection auto-close when tab is hidden
     */ this.cleanupAutoDisconnect = ()=>{
            this.unbindVisibilityListener();
            if (this.disconnectTimer) {
                clearTimeout(this.disconnectTimer);
                this.disconnectTimer = undefined;
            }
        };
        /**
     * Cleanup the visiblitychange listener upon Collab Provider destroy
     * Value set when the listener is binded in addVisiblityListener
     */ this.unbindVisibilityListener = ()=>{};
        this.autoDisconnect = (disconnectTimer, disconnectDelay)=>{
            if (document.hidden) {
                $2c3ccd3818e40940$var$logger('visibilitychange: hidden');
                return setTimeout(()=>{
                    $2c3ccd3818e40940$var$logger('visibilitychange: closing connection');
                    this.socket?.close();
                }, disconnectDelay || disconnectDelay === 0 ? disconnectDelay * 1000 : 60000);
            } else {
                $2c3ccd3818e40940$var$logger('visibilitychange: visible');
                if (disconnectTimer) clearTimeout(disconnectTimer);
                $2c3ccd3818e40940$var$logger('visibilitychange: re-connecting');
                this.socket?.connect();
                return;
            }
        };
        this.config = config;
        this.analyticsHelper = analyticsHelper;
        this.initExperience = (0, $a5At1.createDocInitExp)(this.analyticsHelper);
    }
}
module.exports["Channel"] = $2c3ccd3818e40940$export$cfdacaa37f9b4dd7;

});

parcelRegister("4frCv", function(module, exports) {

var $8BTgu = parcelRequire("8BTgu");


var $9NwnH = parcelRequire("9NwnH");


var $ixa9X = parcelRequire("ixa9X");


var $iA9co = parcelRequire("iA9co");

var $d7309fc3556f972b$require$Buffer = $iA9co.Buffer;
const $d7309fc3556f972b$export$fe2e61603b61130d = (prefix, color = 'blue')=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (msg, data = null)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.COLLAB_PROVIDER_LOGGER) // eslint-disable-next-line no-console
        console.log(`%cCollab-${prefix}: ${msg}`, `color: ${color}; font-weight: bold`, data);
    };
function $d7309fc3556f972b$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
const $d7309fc3556f972b$export$5cf1c5fc6dfa8400 = (id)=>typeof id === 'string' && id.startsWith('agent:');
const $d7309fc3556f972b$export$e2005c9600188ac7 = (productInfo)=>productInfo?.product ?? 'unknown';
const $d7309fc3556f972b$export$1cc4a77342446611 = (productInfo)=>productInfo?.subProduct ?? (!!productInfo?.product ? 'none' : 'unknown');
const $d7309fc3556f972b$export$cbe99aded6131d03 = (step)=>{
    let stepJson;
    try {
        stepJson = step.toJSON();
    } catch (e) {
        return {
            type: 'unknown',
            contentTypes: '',
            stepSizeInBytes: $d7309fc3556f972b$require$Buffer.byteLength(JSON.stringify(step))
        };
    }
    let contentTypes = '';
    if (stepJson.slice?.content && Array.isArray(stepJson.slice?.content)) contentTypes = stepJson.slice.content// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((c)=>{
        return c?.type || 'unknown';
    }).join(', ');
    return {
        type: stepJson.stepType || 'unknown',
        contentTypes: contentTypes,
        stepSizeInBytes: $d7309fc3556f972b$require$Buffer.byteLength(JSON.stringify(step))
    };
};
const $d7309fc3556f972b$var$stepWithNextDocument = (stepJson)=>{
    return stepJson.stepType === 'override-document' && 'nextDocument' in stepJson;
};
const $d7309fc3556f972b$var$stepWithMark = (stepJson)=>{
    return stepJson.stepType === 'addMark' || stepJson.stepType === 'addNodeMark';
};
const $d7309fc3556f972b$var$stepWithAttrs = (stepJson)=>{
    return stepJson.stepType === 'setAttrs' && 'attrs' in stepJson;
};
const $d7309fc3556f972b$var$stepWithBatchAttrs = (stepJson)=>{
    return stepJson.stepType === 'batchAttrs' && 'data' in stepJson;
};
const $d7309fc3556f972b$var$stepWithFromTo = (stepJson)=>{
    return 'from' in stepJson && typeof stepJson.from === 'number' && 'to' in stepJson && typeof stepJson.to === 'number';
};
const $d7309fc3556f972b$var$stepWithGapFromTo = (stepJson)=>{
    return 'gapFrom' in stepJson && typeof stepJson.gapFrom === 'number' && 'gapTo' in stepJson && typeof stepJson.gapTo === 'number';
};
const $d7309fc3556f972b$var$stepWithInsert = (stepJson)=>{
    return 'insert' in stepJson && typeof stepJson.insert === 'number';
};
const $d7309fc3556f972b$var$stepWithPos = (stepJson)=>{
    return 'pos' in stepJson && typeof stepJson.pos === 'number';
};
const $d7309fc3556f972b$var$stepWithSlice = (stepJson)=>{
    return 'slice' in stepJson && Array.isArray(stepJson.slice?.content);
};
const $d7309fc3556f972b$export$c3999f755e5119b6 = (stepJson)=>{
    let contentTypes = null;
    if ($d7309fc3556f972b$var$stepWithSlice(stepJson)) contentTypes = stepJson.slice.content.map((c)=>{
        return c?.type || 'unknown';
    }).join(', ');
    return {
        type: stepJson.stepType || 'unknown',
        contentTypes: contentTypes
    };
};
const $d7309fc3556f972b$export$5a4db1b11509b097 = (stepJson)=>{
    const stepContentAsAdf = $d7309fc3556f972b$var$stepToAdf(stepJson);
    if (!stepContentAsAdf) return null;
    const scrubbedSteps = stepContentAsAdf.map((adf)=>(0, $8BTgu.default)(adf)).filter((adf)=>!!adf);
    return scrubbedSteps;
};
const $d7309fc3556f972b$export$c34327e5d6b409e1 = (doc)=>{
    const docJson = doc.toJSON();
    const scrubbedDoc = (0, $8BTgu.default)(docJson);
    if (!scrubbedDoc) return null;
    return scrubbedDoc;
};
const $d7309fc3556f972b$export$2afb2cb2393bffc = (docJson)=>{
    const scrubbedDoc = (0, $8BTgu.default)(docJson);
    if (!scrubbedDoc) return null;
    return scrubbedDoc;
};
const $d7309fc3556f972b$export$5332347b0103ece3 = (stepJson)=>{
    return {
        ...$d7309fc3556f972b$var$stepWithFromTo(stepJson) && {
            from: stepJson.from,
            to: stepJson.to
        },
        ...$d7309fc3556f972b$var$stepWithGapFromTo(stepJson) && {
            gapFrom: stepJson.gapFrom,
            gapTo: stepJson.gapTo
        },
        ...$d7309fc3556f972b$var$stepWithInsert(stepJson) && {
            insert: stepJson.insert
        },
        ...$d7309fc3556f972b$var$stepWithPos(stepJson) && {
            pos: stepJson.pos
        }
    };
};
/**
 * Returns the metadata for Step
 * @description metadata is applied by transform overrides [here](https://bitbucket.org/atlassian/adf-schema/src/e13bbece84ede8f245067dc53dd7ce694f427eda/packages/editor-prosemirror/src/transform-override.ts#lines-12)
 */ const $d7309fc3556f972b$var$getStepMetadata = (stepJson)=>{
    return stepJson.metadata;
};
const $d7309fc3556f972b$export$4b189f5a6c196cb1 = (steps, endIndex)=>{
    return steps.slice(0, endIndex).map((step)=>{
        return {
            stepType: $d7309fc3556f972b$export$c3999f755e5119b6(step),
            stepContent: $d7309fc3556f972b$export$5a4db1b11509b097(step),
            stepPositions: $d7309fc3556f972b$export$5332347b0103ece3(step),
            stepMetadata: $d7309fc3556f972b$var$getStepMetadata(step)
        };
    });
};
const $d7309fc3556f972b$var$stepToAdf = (step)=>{
    if ($d7309fc3556f972b$var$stepWithSlice(step)) return [
        {
            type: 'doc',
            content: step.slice.content.filter((el)=>el !== null)
        }
    ];
    else if ($d7309fc3556f972b$var$stepWithNextDocument(step)) return [
        {
            type: 'doc',
            content: step.nextDocument.content
        }
    ];
    else if ($d7309fc3556f972b$var$stepWithMark(step) && step.mark) return [
        {
            type: 'doc',
            marks: [
                {
                    type: step.mark.type || 'unknown',
                    attrs: step.mark.attrs
                }
            ]
        }
    ];
    else if ($d7309fc3556f972b$var$stepWithAttrs(step)) return [
        {
            type: 'doc',
            attrs: step.attrs
        }
    ];
    else if ($d7309fc3556f972b$var$stepWithBatchAttrs(step)) return step.data.map((stepData)=>{
        return {
            type: 'doc',
            attrs: stepData.attrs
        };
    });
    return [];
};
async function $d7309fc3556f972b$export$66e82726d1c3b152(oldState, newState) {
    try {
        let stepsFromOldState = '', stepsFromNewState = '';
        const states = {
            old: oldState ? (0, $9NwnH.sendableSteps)(oldState) : null,
            new: (0, $9NwnH.sendableSteps)(newState)
        };
        if (states.new?.steps) stepsFromNewState = await $d7309fc3556f972b$export$86b85b7b97208cd9(states.new.steps);
        if (states.old?.steps) stepsFromOldState = await $d7309fc3556f972b$export$86b85b7b97208cd9(states.old.steps);
        return {
            stepsFromOldState: stepsFromOldState,
            stepsFromNewState: stepsFromNewState
        };
    } catch (err) {
        return new (0, $ixa9X.CustomError)('Failed to obfuscate steps', err);
    }
}
async function $d7309fc3556f972b$export$86b85b7b97208cd9(steps) {
    const _steps = await Promise.resolve(steps.slice().map((s)=>s.toJSON()));
    return JSON.stringify($d7309fc3556f972b$export$4b189f5a6c196cb1(_steps));
}
module.exports["createLogger"] = $d7309fc3556f972b$export$fe2e61603b61130d;
module.exports["sleep"] = $d7309fc3556f972b$export$e772c8ff12451969;
module.exports["isAIProviderID"] = $d7309fc3556f972b$export$5cf1c5fc6dfa8400;
module.exports["getProduct"] = $d7309fc3556f972b$export$e2005c9600188ac7;
module.exports["getSubProduct"] = $d7309fc3556f972b$export$1cc4a77342446611;
module.exports["getStepUGCFreeDetails"] = $d7309fc3556f972b$export$cbe99aded6131d03;
module.exports["getDocAdfWithObfuscation"] = $d7309fc3556f972b$export$c34327e5d6b409e1;
module.exports["getDocAdfWithObfuscationFromJSON"] = $d7309fc3556f972b$export$2afb2cb2393bffc;
module.exports["getObfuscatedSteps"] = $d7309fc3556f972b$export$4b189f5a6c196cb1;
module.exports["logObfuscatedSteps"] = $d7309fc3556f972b$export$66e82726d1c3b152;

});

parcelRegister("8BTgu", function(module, exports) {
$parcel$export(module.exports, "default", () => $f289a9a961759679$export$2e2bcd8739ae039);

var $6jPem = parcelRequire("6jPem");


var $4QzBR = parcelRequire("4QzBR");


var $5u0tf = parcelRequire("5u0tf");


var $3CUWl = parcelRequire("3CUWl");

var $f289a9a961759679$export$2e2bcd8739ae039 = (adf, options = {})=>{
    const nodeReplacements = {
        ...(0, $5u0tf.defaultNodeReplacements),
        ...options.nodeReplacements
    };
    const valueReplacements = {
        ...(0, $3CUWl.defaultValueReplacements),
        ...options.valueReplacements
    };
    return (0, $6jPem.traverse)(adf, {
        any: (node, parent)=>{
            const replacement = nodeReplacements[node.type];
            if (typeof replacement === 'function') {
                const result = replacement(node, {
                    parent: parent,
                    valueReplacements: valueReplacements
                });
                if (result !== false) return result;
            }
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const updatedNode = {};
            Object.entries(node).forEach(([key, value])=>{
                if ([
                    'version',
                    'type',
                    'content',
                    'marks'
                ].includes(key)) updatedNode[key] = value;
            });
            if (node.text && node.marks) updatedNode.marks = (0, $4QzBR.scrubLink)(node.marks ?? [], {
                valueReplacements: valueReplacements
            });
            if (node.text) updatedNode.text = (0, $4QzBR.scrubStr)(node.text);
            if (node.attrs) updatedNode.attrs = (0, $4QzBR.scrubAttrs)(node.type, node.attrs);
            return updatedNode;
        }
    });
};

});

parcelRegister("4QzBR", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $55e912ee1103ff6a$var$DUMMY_TEXT = `Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur Excepteur sint occaecat cupidatat non proident sunt in culpa qui officia deserunt mollit anim id est laborum`;
const $55e912ee1103ff6a$var$DUMMY_DIGITS = [
    '2',
    '7',
    '4',
    '3',
    '5',
    '9',
    '1',
    '8',
    '0',
    '5'
];
const $55e912ee1103ff6a$var$BYPASS_ATTR_LIST = {
    bodiedExtension: [
        'extensionKey',
        'extensionType',
        'layout'
    ],
    codeBlock: [
        'language'
    ],
    decisionItem: [
        'state'
    ],
    embedCard: [
        'layout',
        'originalHeight',
        'originalWidth',
        'width'
    ],
    extension: [
        'extensionKey',
        'extensionType',
        'layout',
        'type'
    ],
    heading: [
        'level'
    ],
    inlineExtension: [
        'extensionKey',
        'extensionType',
        'layout'
    ],
    layoutColumn: [
        'width'
    ],
    media: [
        '__fileMimeType',
        '__fileSize',
        'height',
        'width',
        'type'
    ],
    mediaSingle: [
        'layout',
        'width',
        'widthType'
    ],
    orderedList: [
        'order'
    ],
    panel: [
        'panelType'
    ],
    status: [
        'color',
        'style'
    ],
    table: [
        'isNumberColumnEnabled',
        'layout',
        'width'
    ],
    tableCell: [
        'background',
        'colspan',
        'colwidth',
        'defaultMarks',
        'rowspan'
    ],
    tableHeader: [
        'background',
        'colspan',
        'colwidth',
        'defaultMarks',
        'rowspan'
    ],
    tableRow: [
        'defaultMarks'
    ],
    taskItem: [
        'state'
    ],
    blockTaskItem: [
        'state'
    ]
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $55e912ee1103ff6a$var$fromEntries = (iterable)=>{
    return [
        ...iterable
    ].reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
};
const $55e912ee1103ff6a$var$scrubNum = (val, start = 0)=>{
    return parseInt(val.toString().split('').map((_, index)=>{
        const base = start + index;
        const len = $55e912ee1103ff6a$var$DUMMY_DIGITS.length - 1;
        return $55e912ee1103ff6a$var$DUMMY_DIGITS[base % len];
    }).join(''), 10);
};
const $55e912ee1103ff6a$export$f8a660e92bd813ff = (val, offset = 0)=>{
    const base = $55e912ee1103ff6a$var$DUMMY_TEXT.repeat(Math.ceil((offset + val.length) / $55e912ee1103ff6a$var$DUMMY_TEXT.length));
    // using [...val] splits emoji character pairs correctly, compared to
    // something like "".split('')
    return [
        ...val
    ].map((char, index, chars)=>{
        // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
        if (RegExp("^\\p{Nd}$", "u").test(char)) // Decimal digits
        return $55e912ee1103ff6a$var$scrubNum(parseInt(char, 10), index).toString();
        else if (RegExp("^\\p{So}$", "u").test(char)) // Emoji
        return chars[index - 1]?.codePointAt(0) === 8205 ? '' : "\u2B50\uFE0F";
        else if (RegExp("^\\p{Sc}$", "u").test(char)) // Currency
        return '$';
        else if (RegExp("^[\\p{P}\\p{Z}\\p{C}]$", "u").test(char)) // Punctuation, Seperators, Control
        return char;
        else if (char.codePointAt(0) === 65039 && RegExp("^\\p{So}$", "u").test(chars[index - 1])) // Ingore compound emoji control char
        return '';
        else {
            // Everything else
            // modulo to ensure wrapping occurs around base string (no OOB access)
            const correction = base[offset % base.length] === ' ' ? 1 : 0;
            const raw = (0, $dh538.fg)('platform_adf-utils_fix-dummy-text-index-oob') ? base[(offset + correction) % base.length] : base[offset + correction];
            const isLower = char.toLowerCase() === char;
            const result = isLower ? raw.toLowerCase() : raw.toUpperCase();
            offset += 1 + correction;
            return result;
        }
    }).join('');
};
const $55e912ee1103ff6a$export$efa6f3a45942fa49 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marks, { valueReplacements: valueReplacements })=>{
    return marks.map((mark)=>{
        if (mark.type === 'link' && mark.attrs.href) return {
            ...mark,
            attrs: {
                ...mark.attrs,
                href: valueReplacements.href(mark.attrs.href)
            }
        };
        return mark;
    });
};
const $55e912ee1103ff6a$var$scrubObj = (nodeType, attrsObj)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const entries = Object.entries(attrsObj).map(([key, value])=>$55e912ee1103ff6a$var$BYPASS_ATTR_LIST[nodeType]?.includes(key) ? [
            key,
            value
        ] : [
            key,
            $55e912ee1103ff6a$export$e7384e231c3a8592(nodeType, value)
        ]);
    return $55e912ee1103ff6a$var$fromEntries(entries);
};
const $55e912ee1103ff6a$export$e7384e231c3a8592 = (nodeType, attrs, offset = 0)=>{
    if (typeof attrs === 'number') return $55e912ee1103ff6a$var$scrubNum(attrs, offset);
    if (typeof attrs === 'string') return $55e912ee1103ff6a$export$f8a660e92bd813ff(attrs, offset);
    if (typeof attrs === 'boolean') return attrs;
    if (!attrs) return attrs;
    const attrsObj = attrs;
    if (attrsObj && attrsObj.constructor === Object && Object.keys(attrsObj).length === 0) return {};
    if (typeof attrsObj === 'object' && !Array.isArray(attrsObj)) return $55e912ee1103ff6a$var$scrubObj(nodeType, attrsObj);
    if (Array.isArray(attrsObj)) return attrsObj.map((el)=>{
        return typeof el === 'object' ? $55e912ee1103ff6a$var$scrubObj(nodeType, el) : $55e912ee1103ff6a$export$e7384e231c3a8592(nodeType, el);
    });
    throw new TypeError(`scrubAttrs: encountered unsupported attributes type "${typeof attrsObj}"
    of value ${JSON.stringify(attrsObj)}`);
};
module.exports["scrubStr"] = $55e912ee1103ff6a$export$f8a660e92bd813ff;
module.exports["scrubLink"] = $55e912ee1103ff6a$export$efa6f3a45942fa49;
module.exports["scrubAttrs"] = $55e912ee1103ff6a$export$e7384e231c3a8592;

});

parcelRegister("5u0tf", function(module, exports) {

var $4QzBR = parcelRequire("4QzBR");

const $725cb18ca25f70fb$var$card = (node, { valueReplacements: valueReplacements })=>({
        type: node.type,
        attrs: {
            ...node.attrs || {},
            url: valueReplacements.href(node.attrs?.url)
        }
    });
const $725cb18ca25f70fb$var$mediaParent = (node)=>({
        type: node.type,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: node.attrs ? (0, $4QzBR.scrubAttrs)(node.type, node.attrs) : undefined,
        content: node.content?.filter((c)=>c?.type === 'media')
    });
const $725cb18ca25f70fb$export$9ead654a0051b376 = {
    emoji: ()=>({
            type: 'emoji',
            attrs: {
                shortName: ':blue_star:',
                id: 'atlassian-blue_star',
                text: ':blue_star:'
            }
        }),
    date: ()=>({
            type: 'date',
            attrs: {
                timestamp: new Date('2020-01-01').getTime()
            }
        }),
    mention: ()=>({
            type: 'mention',
            attrs: {
                id: 'error:NotFound',
                text: '@Nemo',
                accessLevel: 'CONTAINER'
            }
        }),
    inlineCard: $725cb18ca25f70fb$var$card,
    blockCard: $725cb18ca25f70fb$var$card,
    mediaSingle: $725cb18ca25f70fb$var$mediaParent,
    mediaGroup: $725cb18ca25f70fb$var$mediaParent,
    media: (node, { parent: parent })=>{
        const defaults = parent.node?.type === 'mediaSingle' ? {
            width: 600,
            height: 400
        } : {
            width: 150,
            height: 125
        };
        const width = node.attrs?.width ?? defaults.width;
        const height = node.attrs?.height ?? defaults.height;
        return {
            type: 'media',
            attrs: {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                ...(0, $4QzBR.scrubAttrs)('media', node.attrs),
                type: 'external',
                url: `https://dummyimage.com/${width}x${height}/f4f5f7/a5adba`
            }
        };
    }
};
module.exports["defaultNodeReplacements"] = $725cb18ca25f70fb$export$9ead654a0051b376;

});

parcelRegister("3CUWl", function(module, exports) {

var $5fEks = parcelRequire("5fEks");

const $8fe8606b28501032$export$be3aa623e32b055f = {
    href: (href)=>`https://hello.atlassian.net/wiki/spaces/ET/pages/968692273?${(0, $5fEks.hash)(href)}`
};
module.exports["defaultValueReplacements"] = $8fe8606b28501032$export$be3aa623e32b055f;

});

parcelRegister("5fEks", function(module, exports) {
// djb2 hashing algorithm www.cse.yorku.ca/~oz/hash.html
const $33376f9878629398$export$d6af199866bfb566 = (input)=>{
    let result = 5381;
    let index = input.length;
    while(index > 0)result = result * 33 ^ input.charCodeAt(--index);
    return (result >>> 0).toString();
};
module.exports["hash"] = $33376f9878629398$export$d6af199866bfb566;

});

parcelRegister("9NwnH", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $ks2lK = parcelRequire("ks2lK");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $5jGZY = parcelRequire("5jGZY");

class $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd {
    constructor(step, inverted, origin){
        this.step = step;
        this.inverted = inverted;
        this.origin = origin;
    }
}
function $c4b7da7a59ba31a1$export$bced9e015fcf3afa(steps, over, transform) {
    for(let i = steps.length - 1; i >= 0; i--)transform.step(steps[i].inverted);
    for(let i = 0; i < over.length; i++)transform.step(over[i]);
    const result = [];
    for(let i = 0, mapFrom = steps.length; i < steps.length; i++){
        const mapped = steps[i].step.map(transform.mapping.slice(mapFrom));
        const movedStep = (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) ? (0, $5jGZY.mapStep)(steps, transform, i, mapped) : undefined;
        mapFrom--;
        if (mapped && !transform.maybeStep(mapped).failed) {
            // Open ticket for setMirror https://github.com/ProseMirror/prosemirror/issues/869
            // @ts-expect-error
            transform.mapping.setMirror(mapFrom, transform.steps.length - 1);
            result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(mapped, mapped.invert(transform.docs[transform.docs.length - 1]), steps[i].origin));
        }
        // If the step is a "move" step - apply the additional step
        if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
            if (movedStep && !transform.maybeStep(movedStep).failed) result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(movedStep, movedStep.invert(transform.docs[transform.docs.length - 1]), transform));
        }
    }
    return result;
}
// This state field accumulates changes that have to be sent to the
// central authority in the collaborating group and makes it possible
// to integrate changes made by peers into our local document. It is
// defined by the plugin, and will be available as the `collab` field
// in the resulting editor state.
class $c4b7da7a59ba31a1$var$CollabState {
    constructor(// The version number of the last update received from the central
    // authority. Starts at 0 or the value of the `version` property
    // in the option object, for the editor's value when the option
    // was enabled.
    version, // The local steps that havent been successfully sent to the
    // server yet.
    unconfirmed){
        this.version = version;
        this.unconfirmed = unconfirmed;
    }
}
function $c4b7da7a59ba31a1$var$unconfirmedFrom(transform) {
    const result = [];
    for(let i = 0; i < transform.steps.length; i++)result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(transform.steps[i], transform.steps[i].invert(transform.docs[i]), transform));
    return result;
}
const $c4b7da7a59ba31a1$var$collabKey = new (0, $ks2lK.PluginKey)('collab');
function $c4b7da7a59ba31a1$export$995d9de96d1b2e26(config = {}) {
    const conf = {
        version: config.version || 0,
        clientID: // eslint-disable-next-line eqeqeq
        // generate a temporary id as clientId when it is null or undefined
        // prefix temp-pc- indicates prosemirror-collab
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        config.clientID == null || !config.clientID ? `temp-pc-${(0, $dQl1W.v4)()}` : config.clientID
    };
    const transformUnconfirmed = config.transformUnconfirmed ?? ((steps)=>steps);
    return new (0, $ks2lK.Plugin)({
        key: $c4b7da7a59ba31a1$var$collabKey,
        state: {
            init: ()=>new $c4b7da7a59ba31a1$var$CollabState(conf.version, []),
            apply (tr, collab) {
                const newState = tr.getMeta($c4b7da7a59ba31a1$var$collabKey);
                if (newState) {
                    if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) || (0, $1oCLl.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true)) return new $c4b7da7a59ba31a1$var$CollabState(newState.version, transformUnconfirmed(newState.unconfirmed));
                    else return newState;
                }
                if (tr.docChanged) return new $c4b7da7a59ba31a1$var$CollabState(collab.version, transformUnconfirmed(collab.unconfirmed.concat($c4b7da7a59ba31a1$var$unconfirmedFrom(tr))));
                return collab;
            }
        },
        config: conf,
        // This is used to notify the history plugin to not merge steps,
        // so that the history can be rebased.
        historyPreserveItems: true
    });
}
function $c4b7da7a59ba31a1$export$5af1c9a2797f6d8e(state) {
    const tr = state.tr;
    const { version: version, unconfirmed: unconfirmed } = $c4b7da7a59ba31a1$var$collabKey.getState(state) ?? {};
    if (version === undefined || !unconfirmed) return tr.doc;
    // undo unconfirmed steps
    for(let i = unconfirmed.length - 1; i >= 0; i--)tr.step(unconfirmed[i].inverted);
    return tr.doc;
}
function $c4b7da7a59ba31a1$export$852bd88de4de2d35(state, version, // eslint-disable-next-line @typescript-eslint/no-explicit-any
docJSON, unconfirmedSteps) {
    const tr = state.tr;
    const doc = state.schema.nodeFromJSON(docJSON);
    const { from: from, to: to } = tr.selection;
    tr.replaceWith(0, state.doc.content.size, doc);
    // apply new unconfirmed steps to doc
    for(let i = 0; i < unconfirmedSteps.length; i++)tr.step(unconfirmedSteps[i]);
    const offset = 1; // offset by 1 to account for the initial replace step
    const newUnconfirmed = tr.steps.slice(offset).map((step, i)=>{
        const index = i + offset;
        const doc = tr.docs[index];
        return new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(step, step.invert(doc), tr);
    });
    // Because we are replacing the entire document from 0 to end, the selection mapping is incorrect.
    // For now, the best we can do is set the selection to the original positions. Otherwise, it will move to the end of the doc on every change.
    tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, Math.min(from, tr.doc.content.size), Math.min(to, tr.doc.content.size)));
    return tr.setMeta('addToHistory', false).setMeta($c4b7da7a59ba31a1$var$collabKey, new $c4b7da7a59ba31a1$var$CollabState(version, newUnconfirmed));
}
function $c4b7da7a59ba31a1$export$7581d8ca0d559ec6(state, steps, clientIDs, options = {}) {
    // Pushes a set of steps (received from the central authority) into
    // the editor state (which should have the collab plugin enabled).
    // Will recognize its own changes, and confirm unconfirmed steps as
    // appropriate. Remaining unconfirmed steps will be rebased over
    // remote steps.
    const collabState = $c4b7da7a59ba31a1$var$collabKey.getState(state);
    const version = (collabState?.version || 0) + steps.length;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion,  @typescript-eslint/no-explicit-any
    const ourID = $c4b7da7a59ba31a1$var$collabKey.get(state).spec.config.clientID;
    // Find out which prefix of the steps originated with us
    let ours = 0;
    // eslint-disable-next-line eqeqeq
    while(ours < clientIDs.length && clientIDs[ours] == ourID)++ours;
    let unconfirmed = collabState?.unconfirmed.slice(ours) || [];
    steps = ours ? steps.slice(ours) : steps;
    // If all steps originated with us, we're done.
    if (!steps.length) return state.tr.setMeta($c4b7da7a59ba31a1$var$collabKey, new $c4b7da7a59ba31a1$var$CollabState(version, unconfirmed));
    const nUnconfirmed = unconfirmed.length;
    const tr = state.tr;
    if (nUnconfirmed) unconfirmed = $c4b7da7a59ba31a1$export$bced9e015fcf3afa(unconfirmed, steps, tr);
    else {
        for(let i = 0; i < steps.length; i++)tr.step(steps[i]);
        unconfirmed = [];
    }
    const newCollabState = new $c4b7da7a59ba31a1$var$CollabState(version, unconfirmed);
    if (options && options.mapSelectionBackward && state.selection instanceof (0, $ks2lK.TextSelection)) {
        tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(tr.mapping.map(state.selection.anchor, -1)), tr.doc.resolve(tr.mapping.map(state.selection.head, -1))));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tr.updated &= -2;
    }
    return tr.setMeta('rebased', nUnconfirmed).setMeta('rebasedData', {
        unconfirmedSteps: collabState?.unconfirmed.slice(ours) || [],
        remoteSteps: steps,
        stepsAfterRebase: unconfirmed,
        versionBefore: version
    }).setMeta('addToHistory', false).setMeta($c4b7da7a59ba31a1$var$collabKey, newCollabState);
}
function $c4b7da7a59ba31a1$export$4da2109e7644e6c2(state) {
    const collabState = $c4b7da7a59ba31a1$var$collabKey.getState(state);
    if (!collabState) return null;
    // eslint-disable-next-line eqeqeq
    if (collabState.unconfirmed.length == 0) return null;
    return {
        version: collabState.version,
        steps: collabState.unconfirmed.map((s)=>s.step),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
        clientID: $c4b7da7a59ba31a1$var$collabKey.get(state).spec.config.clientID,
        get origins () {
            return(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins || (// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins = collabState?.unconfirmed.map((s)=>s.origin)));
        }
    };
}
function $c4b7da7a59ba31a1$export$971539697c176258(state) {
    return $c4b7da7a59ba31a1$var$collabKey.getState(state);
}
module.exports["Rebaseable"] = $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd;
module.exports["rebaseSteps"] = $c4b7da7a59ba31a1$export$bced9e015fcf3afa;
module.exports["collab"] = $c4b7da7a59ba31a1$export$995d9de96d1b2e26;
module.exports["getDocBeforeUnconfirmedSteps"] = $c4b7da7a59ba31a1$export$5af1c9a2797f6d8e;
module.exports["syncFromAnotherSource"] = $c4b7da7a59ba31a1$export$852bd88de4de2d35;
module.exports["receiveTransaction"] = $c4b7da7a59ba31a1$export$7581d8ca0d559ec6;
module.exports["sendableSteps"] = $c4b7da7a59ba31a1$export$4da2109e7644e6c2;
module.exports["getCollabState"] = $c4b7da7a59ba31a1$export$971539697c176258;

});

parcelRegister("5jGZY", function(module, exports) {

var $jy7VG = parcelRequire("jy7VG");


var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");

// Iterate from the specified starting index down to 0
const $33dcd085767efb3e$var$findPreviousStepInverseIndex = (steps, startIndex = steps.length - 1)=>{
    for(let i = startIndex; i >= 0; i--){
        if (!(steps[i] instanceof (0, $jy7VG.AnalyticsStep))) return i;
    }
};
const $33dcd085767efb3e$export$798cdecdcbbf9755 = (steps, transform, index, mapped)=>{
    if (index < 1) return undefined;
    const previousRebaseableStepIndex = $33dcd085767efb3e$var$findPreviousStepInverseIndex(steps.map((s)=>s.step), index - 1);
    // This checks the local steps are a "move" sequence
    if (previousRebaseableStepIndex !== undefined && $33dcd085767efb3e$export$17bbdbb89ac2acbd(steps[previousRebaseableStepIndex], steps[index].step)) {
        const previousStepInverseIndex = $33dcd085767efb3e$var$findPreviousStepInverseIndex(transform.steps);
        // Creates a new step based on the "current" steps (partially through the rebase)
        if (previousStepInverseIndex !== undefined) return $33dcd085767efb3e$export$ad07b298545ed98d(mapped, transform.steps[previousStepInverseIndex], transform, previousStepInverseIndex);
    }
};
// Only consider ReplaceStep (ReplaceAroundStep do not occur for moves)
const $33dcd085767efb3e$var$isReplaceTypeStep = (step)=>step instanceof (0, $aXG5V.ReplaceStep);
const $33dcd085767efb3e$export$17bbdbb89ac2acbd = (previousRebaseableStep, currentStep)=>{
    if (// The both steps are replace
    $33dcd085767efb3e$var$isReplaceTypeStep(previousRebaseableStep.step) && $33dcd085767efb3e$var$isReplaceTypeStep(currentStep) && // The current step is a deletion
    previousRebaseableStep.step.slice.size === 0 && // The following step is an insertion with the same length that was deleted by the current step
    Math.abs(previousRebaseableStep.step.to - previousRebaseableStep.step.from) === currentStep.slice.size) {
        // Ensure we're getting the doc before our step changes so we can compare node contents
        const originStepIndex = previousRebaseableStep.origin.steps.findIndex((s)=>s === previousRebaseableStep.step);
        if (originStepIndex === -1) return false;
        const originalDoc = previousRebaseableStep.origin.docs[originStepIndex];
        if (!originalDoc) return false;
        const currentSlice = originalDoc.slice(previousRebaseableStep.step.from, previousRebaseableStep.step.to);
        // The content from the deleted + inserted slice is exactly the same (cut + paste or drag + drop)
        if (currentSlice.eq(currentStep.slice)) return true;
    }
    return false;
};
const $33dcd085767efb3e$export$ad07b298545ed98d = (mapped, previousStep, transform, previousStepIndex)=>{
    if (!$33dcd085767efb3e$var$isReplaceTypeStep(previousStep) || mapped && !$33dcd085767efb3e$var$isReplaceTypeStep(mapped) || !mapped || // Ensure previous step index is valid
    !(previousStepIndex >= 0 && previousStepIndex < transform.docs.length && typeof previousStep?.from === 'number')) return undefined;
    const newSlice = transform.docs[previousStepIndex].slice(previousStep?.from, previousStep?.to);
    const diff = $33dcd085767efb3e$var$getDiffRange(mapped.slice.content, newSlice.content);
    if (diff === undefined) return undefined;
    const start = mapped.from + diff.start;
    const offset = newSlice.content.size - mapped.slice.content.size === 0 ? diff.end - diff.start : 0;
    // If the new slice is smaller then we're doing a deletion of content - this needs
    // to be a replace step with empty content to delete content
    if (newSlice.content.size - mapped.slice.content.size < 0) return new (0, $aXG5V.ReplaceStep)(start, start + mapped.slice.content.size - newSlice.content.size, (0, $5SAOw.Slice).empty);
    // Replace the diff range with the latest content in the document (at the old position)
    return new (0, $aXG5V.ReplaceStep)(start, start + offset, transform.docs[previousStepIndex].slice(previousStep?.from + diff.start, previousStep?.from + diff.end));
};
/**
 * Get start and end diff position values for two fragments (old, new).
 * @param {Fragment} before - content that is planned to move
 * @param {Fragment} after - content that was in paragraph being deleted (updated content)
 * @returns {object} - { start, end }
 */ function $33dcd085767efb3e$var$getDiffRange(before, after) {
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffStart
    const start = before.findDiffStart(after);
    // Important: diffEnd value is {a,b} object since end pos will differ.
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffEnd
    const diffEnd = before.findDiffEnd(after);
    if (start === null || diffEnd === null) return undefined;
    // WARNING: diffEnd may be lower than diffStart.
    // If so, add overlap to get correct range.
    // https://discuss.prosemirror.net/t/overlap-handling-of-finddiffstart-and-finddiffend/2856
    const overlap = start - Math.min(diffEnd.a, diffEnd.b);
    let end = diffEnd.b;
    if (overlap > 0) end += overlap;
    return {
        start: start,
        end: end
    };
}
module.exports["mapStep"] = $33dcd085767efb3e$export$798cdecdcbbf9755;

});

parcelRegister("ixa9X", function(module, exports) {
class $1307bfb35243cc15$export$f7a70f5f17339408 extends Error {
    toJSON() {
        return {
            name: this.name,
            message: this.message
        };
    }
    constructor(message, error, extraEventAttributes){
        super(message);
        this.extraEventAttributes = void 0;
        this.getExtraErrorEventAttributes = ()=>this.extraEventAttributes;
        if (typeof error?.message === 'string') this.message = error.message;
        if (extraEventAttributes) this.extraEventAttributes = extraEventAttributes;
    }
}
class $1307bfb35243cc15$export$ee94a7f51f58b1f0 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'NotConnectedError';
    }
}
class $1307bfb35243cc15$export$92624542437ba748 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'NotInitializedError';
    }
}
class $1307bfb35243cc15$export$f96efbf9586f7f39 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'ProviderInitialisationError';
    }
}
class $1307bfb35243cc15$export$121e803f723b3045 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'SendTransactionError';
    }
}
class $1307bfb35243cc15$export$be0713d3b74f5c22 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'DestroyError';
    }
}
class $1307bfb35243cc15$export$a444b7fe9d0904eb extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'SetTitleError';
    }
}
class $1307bfb35243cc15$export$70274e29104db434 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'SetEditorWidthError';
    }
}
class $1307bfb35243cc15$export$c72e7ac58ad6e295 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'SetMetadataError';
    }
}
class $1307bfb35243cc15$export$29880dc4d51a91ac extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'GetCurrentStateError';
    }
}
class $1307bfb35243cc15$export$5d0dd2f3f3417c74 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'GetFinalAcknowledgedStateError';
    }
}
class $1307bfb35243cc15$export$b8b1b847e9447ca7 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(message, extraAttributes){
        super(message, undefined, extraAttributes);
        this.name = 'UpdateDocumentError';
    }
}
class $1307bfb35243cc15$export$a2465e73e4ff8efe extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(message, extraAttributes){
        super(message, undefined, extraAttributes);
        this.name = 'CantSyncUpError';
    }
}
module.exports["CustomError"] = $1307bfb35243cc15$export$f7a70f5f17339408;
module.exports["NotConnectedError"] = $1307bfb35243cc15$export$ee94a7f51f58b1f0;
module.exports["NotInitializedError"] = $1307bfb35243cc15$export$92624542437ba748;
module.exports["ProviderInitialisationError"] = $1307bfb35243cc15$export$f96efbf9586f7f39;
module.exports["SendTransactionError"] = $1307bfb35243cc15$export$121e803f723b3045;
module.exports["DestroyError"] = $1307bfb35243cc15$export$be0713d3b74f5c22;
module.exports["SetTitleError"] = $1307bfb35243cc15$export$a444b7fe9d0904eb;
module.exports["SetEditorWidthError"] = $1307bfb35243cc15$export$70274e29104db434;
module.exports["SetMetadataError"] = $1307bfb35243cc15$export$c72e7ac58ad6e295;
module.exports["GetCurrentStateError"] = $1307bfb35243cc15$export$29880dc4d51a91ac;
module.exports["GetFinalAcknowledgedStateError"] = $1307bfb35243cc15$export$5d0dd2f3f3417c74;
module.exports["UpdateDocumentError"] = $1307bfb35243cc15$export$b8b1b847e9447ca7;
module.exports["CantSyncUpError"] = $1307bfb35243cc15$export$a2465e73e4ff8efe;

});

parcelRegister("h6NFo", function(module, exports) {
// Initialize the random sampling rate
const $79f52cb3897d035a$var$TELEPOINTER_SAMPLE_RATE = 0.0001;
var $79f52cb3897d035a$export$5cb1f459478c70e = /*#__PURE__*/ function(MEASURE_NAME) {
    MEASURE_NAME["SOCKET_CONNECT"] = "socketConnect";
    MEASURE_NAME["DOCUMENT_INIT"] = "documentInit";
    MEASURE_NAME["COMMIT_UNCONFIRMED_STEPS"] = "commitUnconfirmedSteps";
    MEASURE_NAME["PUBLISH_PAGE"] = "publishPage";
    MEASURE_NAME["GET_CURRENT_STATE"] = "getCurrentState";
    return MEASURE_NAME;
}({});
const $79f52cb3897d035a$export$b5717a625dd4a3eb = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (api)=>!!performance[api]);
};
const $79f52cb3897d035a$export$3ebda12358c8b9c = new Map();
function $79f52cb3897d035a$export$b62aa2130c86b59b(measureName, analyticsHelper) {
    try {
        if (!$79f52cb3897d035a$export$b5717a625dd4a3eb()) return;
        performance.mark(`${measureName}::start`);
        $79f52cb3897d035a$export$3ebda12358c8b9c.set(measureName, performance.now());
    } catch (error) {
        analyticsHelper?.sendErrorEvent(error, 'Error while measuring performance when marking the start');
    }
}
function $79f52cb3897d035a$export$37c25be427bec097(measureName, analyticsHelper, onMeasureComplete) {
    let start;
    try {
        if (!$79f52cb3897d035a$export$b5717a625dd4a3eb()) return;
        // `startMeasure` is not called with `measureName` before.
        if (!$79f52cb3897d035a$export$3ebda12358c8b9c.get(measureName)) return;
        performance.mark(`${measureName}::end`);
        start = onMeasureComplete ? $79f52cb3897d035a$export$3ebda12358c8b9c.get(measureName) : undefined;
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {
        analyticsHelper?.sendErrorEvent(error, 'Error while measuring performance when marking the end');
    }
    try {
        const entry = performance.getEntriesByName(measureName).pop();
        $79f52cb3897d035a$var$clearMeasure(measureName);
        let measure;
        if (entry) measure = {
            duration: entry.duration,
            startTime: entry.startTime
        };
        else if (start) measure = {
            duration: performance.now() - start,
            startTime: start
        };
        if (measure && onMeasureComplete) onMeasureComplete(measure.duration, measure.startTime);
        return measure;
    } catch (error) {
        analyticsHelper?.sendErrorEvent(error, 'Error while measuring performance when completing the measurement');
    }
}
function $79f52cb3897d035a$var$clearMeasure(measureName) {
    if (!$79f52cb3897d035a$export$b5717a625dd4a3eb()) return;
    $79f52cb3897d035a$export$3ebda12358c8b9c.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
const $79f52cb3897d035a$export$2afa64d53a381f1a = ()=>// At peak usage, telepointer we had 200M events per day. The goal is to sample 1:10000 of the events. (20k per day)
    // Math.random() generates a random floating-point number between 0 (inclusive) and 1 (exclusive).
    // The condition Math.random() < TELEPOINTER_SAMPLE_RATE (0.0001) will be true approximately 0.01% of the time.
    // This means that approximately 1 in 10,000 events will be sampled.
    Math.random() < $79f52cb3897d035a$var$TELEPOINTER_SAMPLE_RATE;
module.exports["MEASURE_NAME"] = $79f52cb3897d035a$export$5cb1f459478c70e;
module.exports["startMeasure"] = $79f52cb3897d035a$export$b62aa2130c86b59b;
module.exports["stopMeasure"] = $79f52cb3897d035a$export$37c25be427bec097;
module.exports["shouldTelepointerBeSampled"] = $79f52cb3897d035a$export$2afa64d53a381f1a;

});

parcelRegister("flwxq", function(module, exports) {
var $75e91bfdfa7553f9$export$9282cde89f62615f = /*#__PURE__*/ function(EVENT_ACTION) {
    EVENT_ACTION["CONNECTION"] = "connection";
    EVENT_ACTION["CATCHUP"] = "catchup";
    EVENT_ACTION["DOCUMENT_INIT"] = "documentInit";
    EVENT_ACTION["ADD_STEPS"] = "addSteps";
    EVENT_ACTION["UPDATE_PARTICIPANTS"] = "updateParticipants";
    EVENT_ACTION["UPDATE_DOCUMENT"] = "updateDocument";
    EVENT_ACTION["COMMIT_UNCONFIRMED_STEPS"] = "commitUnconfirmedSteps";
    EVENT_ACTION["REINITIALISE_DOCUMENT"] = "reinitialiseDocument";
    EVENT_ACTION["ERROR"] = "error";
    EVENT_ACTION["PUBLISH_PAGE"] = "publishPage";
    EVENT_ACTION["GET_CURRENT_STATE"] = "getCurrentState";
    EVENT_ACTION["INVALIDATE_TOKEN"] = "invalidateToken";
    EVENT_ACTION["SEND_STEPS_RETRY"] = "sendStepsRetry";
    EVENT_ACTION["CATCHUP_AFTER_MAX_SEND_STEPS_RETRY"] = "catchupAfterMaxSendStepsRetry";
    EVENT_ACTION["DROPPED_STEPS"] = "droppedStepInCatchup";
    EVENT_ACTION["WEBSOCKET_MESSAGE_VOLUME_METRIC"] = "websocketMessageVolumeMetric";
    EVENT_ACTION["PROVIDER_INITIALIZED"] = "providerInitialized";
    EVENT_ACTION["RECONNECTION"] = "providerReconnection";
    EVENT_ACTION["PROVIDER_SETUP"] = "providerSetup";
    EVENT_ACTION["HAS_UNCONFIRMED_STEPS"] = "hasUnconfirmedSteps";
    EVENT_ACTION["OUT_OF_SYNC"] = "outOfSync";
    EVENT_ACTION["STEPS_REBASED"] = "stepsRebased";
    EVENT_ACTION["POLLING_FALLBACK"] = "pollingFallback";
    EVENT_ACTION["PROCESS_STEPS"] = "processSteps";
    return EVENT_ACTION;
}({});
var $75e91bfdfa7553f9$export$5ab9b99d22ba6de0 = /*#__PURE__*/ function(EVENT_STATUS) {
    EVENT_STATUS["SUCCESS"] = "SUCCESS";
    EVENT_STATUS["FAILURE"] = "FAILURE";
    EVENT_STATUS["INFO"] = "INFO";
    EVENT_STATUS["SUCCESS_10x_SAMPLED"] = "SUCCESS_10x_SAMPLED";
    return EVENT_STATUS;
}({});
var $75e91bfdfa7553f9$export$4026f1a4d5b398bb = /*#__PURE__*/ function(ADD_STEPS_TYPE) {
    ADD_STEPS_TYPE["ACCEPTED"] = "ACCEPTED";
    ADD_STEPS_TYPE["REJECTED"] = "REJECTED";
    ADD_STEPS_TYPE["ERROR"] = "ERROR";
    return ADD_STEPS_TYPE;
}({});
const $75e91bfdfa7553f9$export$20f6a175f3aa35a2 = 60;
const $75e91bfdfa7553f9$export$c811f21c9ad05dc2 = 'confluence';
var $75e91bfdfa7553f9$export$2df0974445100a00 = /*#__PURE__*/ function(CatchupEventReason) {
    CatchupEventReason["STEPS_ADDED"] = "onStepsAdded";
    CatchupEventReason["STEPS_REJECTED"] = "onStepsRejected";
    CatchupEventReason["PROCESS_STEPS"] = "processSteps";
    CatchupEventReason["RECONNECTED"] = "reconnected";
    return CatchupEventReason;
}({});
module.exports["EVENT_ACTION"] = $75e91bfdfa7553f9$export$9282cde89f62615f;
module.exports["EVENT_STATUS"] = $75e91bfdfa7553f9$export$5ab9b99d22ba6de0;
module.exports["ADD_STEPS_TYPE"] = $75e91bfdfa7553f9$export$4026f1a4d5b398bb;
module.exports["ACK_MAX_TRY"] = $75e91bfdfa7553f9$export$20f6a175f3aa35a2;
module.exports["CatchupEventReason"] = $75e91bfdfa7553f9$export$2df0974445100a00;

});

parcelRegister("5TBlQ", function(module, exports) {

var $a0Jyl = parcelRequire("a0Jyl");


var $dPDqN = parcelRequire("dPDqN");

// Calculation for max 8 offline reconnect attempts, with reconnection delay 200ms, randomization factor 0.5, reconnection delay max 128s
// Min: 800ms, Avg: 51s, Max: 6m
const $f69c85fac4dc7f60$var$FAILED_RECONNECTS_WHILE_OFFLINE_THRESHOLD = 8;
class $f69c85fac4dc7f60$export$2e2bcd8739ae039 {
    countReconnectError() {
        // Only count the reconnection attempts when offline
        if ((0, $dPDqN.network).getStatus() === (0, $a0Jyl.NetworkStatus).OFFLINE) this.failedReconnectCount++;
    }
    isLikelyNetworkIssue() {
        const isLikelyNetworkIssue = this.failedReconnectCount >= $f69c85fac4dc7f60$var$FAILED_RECONNECTS_WHILE_OFFLINE_THRESHOLD;
        return isLikelyNetworkIssue;
    }
    destroy() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('online', this.onlineHandler);
    }
    constructor(){
        this.failedReconnectCount = 0;
        this.onlineHandler = ()=>{
            this.failedReconnectCount = 0;
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('online', this.onlineHandler);
    }
}
module.exports["default"] = $f69c85fac4dc7f60$export$2e2bcd8739ae039;

});

parcelRegister("a0Jyl", function(module, exports) {
var $edeb3c1a6e44827d$export$bd096ddbd246c79c = /*#__PURE__*/ function(NetworkStatus) {
    NetworkStatus["ONLINE"] = "ONLINE";
    NetworkStatus["OFFLINE"] = "OFFLINE";
    return NetworkStatus;
}({});
class $edeb3c1a6e44827d$export$2e2bcd8739ae039 {
    getStatus() {
        return this.status || null;
    }
    destroy() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('offline', this.offlineHandler);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('online', this.onlineHandler);
    }
    constructor(props){
        this.status = void 0;
        this.onlineCallback = void 0;
        this.offlineHandler = ()=>{
            this.status = "OFFLINE";
        };
        this.onlineHandler = ()=>{
            this.status = "ONLINE";
            if (this.onlineCallback) this.onlineCallback();
        };
        if (props?.initialStatus) this.status = props.initialStatus;
        if (props?.onlineCallback) this.onlineCallback = props.onlineCallback;
        if (typeof window !== 'undefined') {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('offline', this.offlineHandler);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('online', this.onlineHandler);
        }
    }
}
module.exports["NetworkStatus"] = $edeb3c1a6e44827d$export$bd096ddbd246c79c;
module.exports["default"] = $edeb3c1a6e44827d$export$2e2bcd8739ae039;

});

parcelRegister("dPDqN", function(module, exports) {

var $a0Jyl = parcelRequire("a0Jyl");

// Assume the connection is established at first
const $76ee835a3a594506$export$21fcfd9d5c6ebbd4 = new (0, $a0Jyl.default)({
    initialStatus: (0, $a0Jyl.NetworkStatus).ONLINE
});
module.exports["network"] = $76ee835a3a594506$export$21fcfd9d5c6ebbd4;

});

parcelRegister("a5At1", function(module, exports) {

var $iqaft = parcelRequire("iqaft");

var $4SCyD = parcelRequire("4SCyD");

const $5cb013b01c4605d1$var$createDocumentInitExperience = ()=>new (0, $4SCyD.UFOExperience)('collab-provider.document-init', {
        type: (0, $iqaft.ExperienceTypes).Load,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).Custom,
        performanceConfig: {
            histogram: {
                [(0, $iqaft.ExperiencePerformanceTypes).Custom]: {
                    duration: '250_500_1000_1500_2000_3000_4000'
                }
            }
        }
    });
const $5cb013b01c4605d1$var$withErrorHandling = (createExperience, analyticsHelper)=>{
    let initExperience;
    try {
        initExperience = createExperience();
    } catch (error) {
        analyticsHelper?.sendErrorEvent(error, 'Error while initialising a UFO experience');
    }
    return initExperience;
};
const $5cb013b01c4605d1$export$41daeddae2dd4619 = (analyticsHelper)=>$5cb013b01c4605d1$var$withErrorHandling($5cb013b01c4605d1$var$createDocumentInitExperience, analyticsHelper);
module.exports["createDocInitExp"] = $5cb013b01c4605d1$export$41daeddae2dd4619;

});

parcelRegister("7W8Hz", function(module, exports) {

var $h3X17 = parcelRequire("h3X17");

const $a6d9eece4894f88c$export$f9a0e0c2c8938695 = {
    IO_CLIENT_DISCONNECT: 'io client disconnect',
    IO_SERVER_DISCONNECT: 'io server disconnect',
    TRANSPORT_CLOSED: 'transport close',
    TRANSPORT_ERROR: 'transport error',
    PING_TIMEOUT: 'ping timeout'
};
const $a6d9eece4894f88c$export$5a38c81d972d63e3 = (reason)=>{
    switch(reason){
        case $a6d9eece4894f88c$export$f9a0e0c2c8938695.IO_CLIENT_DISCONNECT:
            return (0, $h3X17.DisconnectReason).CLIENT_DISCONNECT;
        case $a6d9eece4894f88c$export$f9a0e0c2c8938695.IO_SERVER_DISCONNECT:
            return (0, $h3X17.DisconnectReason).SERVER_DISCONNECT;
        case $a6d9eece4894f88c$export$f9a0e0c2c8938695.TRANSPORT_CLOSED:
            return (0, $h3X17.DisconnectReason).SOCKET_CLOSED;
        case $a6d9eece4894f88c$export$f9a0e0c2c8938695.TRANSPORT_ERROR:
            return (0, $h3X17.DisconnectReason).SOCKET_ERROR;
        case $a6d9eece4894f88c$export$f9a0e0c2c8938695.PING_TIMEOUT:
            return (0, $h3X17.DisconnectReason).SOCKET_TIMEOUT;
        default:
            return (0, $h3X17.DisconnectReason).UNKNOWN_DISCONNECT;
    }
};
module.exports["socketIOReasons"] = $a6d9eece4894f88c$export$f9a0e0c2c8938695;
module.exports["disconnectedReasonMapper"] = $a6d9eece4894f88c$export$5a38c81d972d63e3;

});

parcelRegister("6MIiQ", function(module, exports) {
var $9cd382ee64cec7e1$export$c14aa697065dcc24 = /*#__PURE__*/ function(INTERNAL_ERROR_CODE) {
    INTERNAL_ERROR_CODE["TOKEN_PERMISSION_ERROR"] = "TOKEN_PERMISSION_ERROR";
    INTERNAL_ERROR_CODE["RECONNECTION_NETWORK_ISSUE"] = "RECONNECTION_NETWORK_ISSUE";
    INTERNAL_ERROR_CODE["CONNECTION_ERROR"] = "CONNECTION_ERROR";
    INTERNAL_ERROR_CODE["RECONNECTION_ERROR"] = "RECONNECTION_ERROR";
    INTERNAL_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    INTERNAL_ERROR_CODE["CATCHUP_FAILED"] = "CATCHUP_FAILED";
    INTERNAL_ERROR_CODE["DOCUMENT_RESTORE_ERROR"] = "DOCUMENT_RESTORE_ERROR";
    INTERNAL_ERROR_CODE["ADD_STEPS_ERROR"] = "ADD_STEPS_ERROR";
    INTERNAL_ERROR_CODE["DOCUMENT_UPDATE_ERROR"] = "DOCUMENT_UPDATE_ERROR";
    INTERNAL_ERROR_CODE["VIEW_ONLY_STEPS_ERROR"] = "VIEW_ONLY_STEPS_ERROR";
    INTERNAL_ERROR_CODE["OUT_OF_SYNC_CLIENT_DATA_LOSS_EVENT"] = "OUT_OF_SYNC_CLIENT_DATA_LOSS_EVENT";
    return INTERNAL_ERROR_CODE;
}({});
 /*
 * This is what a generic ProviderError type would look like:
 * type ProviderError = {
 *   // Unique code, identifies the specific emitted error
 *   // Also exposed as a PROVIDER_ERROR_CODE enum to allow subscribers to use them
 *   code: PROVIDER_ERROR_CODE;
 *   // Informative message describing what went wrong
 *   message: string;
 *   // Flag indicating whether an error is recoverable or not
 *   // used by consumers to disable the provider and show an error message
 *   recoverable: boolean;
 *   // A reason code used to give more detail about why a certain error was thrown
 *   reason?: string;
 * }
 */ module.exports["INTERNAL_ERROR_CODE"] = $9cd382ee64cec7e1$export$c14aa697065dcc24;

});

parcelRegister("6Ted9", function(module, exports) {
// NCS error coded (generated by NCS)
var $7e69bc8716b47ec2$export$168e5dfca773ce7a = /*#__PURE__*/ function(NCS_ERROR_CODE) {
    NCS_ERROR_CODE["HEAD_VERSION_UPDATE_FAILED"] = "HEAD_VERSION_UPDATE_FAILED";
    NCS_ERROR_CODE["VERSION_NUMBER_ALREADY_EXISTS"] = "VERSION_NUMBER_ALREADY_EXISTS";
    NCS_ERROR_CODE["INSUFFICIENT_EDITING_PERMISSION"] = "INSUFFICIENT_EDITING_PERMISSION";
    NCS_ERROR_CODE["FORBIDDEN_USER_TOKEN"] = "FORBIDDEN_USER_TOKEN";
    NCS_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    NCS_ERROR_CODE["INIT_DATA_LOAD_FAILED"] = "INIT_DATA_LOAD_FAILED";
    NCS_ERROR_CODE["ERROR_MAPPING_ERROR"] = "ERROR_MAPPING_ERROR";
    NCS_ERROR_CODE["NAMESPACE_INVALID"] = "NAMESPACE_INVALID";
    NCS_ERROR_CODE["NAMESPACE_NOT_FOUND"] = "NAMESPACE_NOT_FOUND";
    NCS_ERROR_CODE["TENANT_INSTANCE_MAINTENANCE"] = "TENANT_INSTANCE_MAINTENANCE";
    NCS_ERROR_CODE["LOCKED_DOCUMENT"] = "LOCKED_DOCUMENT";
    NCS_ERROR_CODE["EMPTY_BROADCAST"] = "EMPTY_BROADCAST";
    NCS_ERROR_CODE["DYNAMO_ERROR"] = "DYNAMO_ERROR";
    NCS_ERROR_CODE["INVALID_ACTIVATION_ID"] = "INVALID_ACTIVATION_ID";
    NCS_ERROR_CODE["INVALID_DOCUMENT_ARI"] = "INVALID_DOCUMENT_ARI";
    NCS_ERROR_CODE["INVALID_CLOUD_ID"] = "INVALID_CLOUD_ID";
    NCS_ERROR_CODE["RATE_LIMIT_ERROR"] = "RATE_LIMIT_ERROR";
    NCS_ERROR_CODE["PROSEMIRROR_SCHEMA_VALIDATION_ERROR"] = "PROSEMIRROR_SCHEMA_VALIDATION_ERROR";
    return NCS_ERROR_CODE;
}({});
module.exports["NCS_ERROR_CODE"] = $7e69bc8716b47ec2$export$168e5dfca773ce7a;

});

parcelRegister("aX0Lv", function(module, exports) {

var $flwxq = parcelRequire("flwxq");


var $dmolA = parcelRequire("dmolA");


var $dPDqN = parcelRequire("dPDqN");


var $ixa9X = parcelRequire("ixa9X");

const $47363a476d445944$var$EVENT_SUBJECT = 'collab';
const $47363a476d445944$var$loggableErrorName = [
    'RangeError',
    'TypeError',
    'TransformError',
    'NodeNestingTransformError'
];
var $47363a476d445944$var$COLLAB_SERVICE = /*#__PURE__*/ function(COLLAB_SERVICE) {
    COLLAB_SERVICE["NCS"] = "ncs";
    COLLAB_SERVICE["SYNCHRONY"] = "synchrony";
    return COLLAB_SERVICE;
}($47363a476d445944$var$COLLAB_SERVICE || {});
const $47363a476d445944$var$triggerAnalyticsEvent = (analyticsEvent, analyticsClient)=>{
    if (!analyticsClient) return;
    const payload = {
        actionSubject: $47363a476d445944$var$EVENT_SUBJECT,
        attributes: {
            packageName: $dmolA.name,
            packageVersion: $dmolA.version,
            collabService: "ncs",
            network: {
                status: (0, $dPDqN.network).getStatus()
            },
            ...analyticsEvent.attributes
        },
        tags: [
            'editor'
        ],
        action: analyticsEvent.eventAction,
        source: 'unknown' // Adds zero analytics value, but event validation throws an error if you don't add it :-(
    };
    if (analyticsEvent.eventAction === (0, $flwxq.EVENT_ACTION).ERROR) {
        payload.nonPrivacySafeAttributes = analyticsEvent.nonPrivacySafeAttributes;
        try {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const requestIdleCallbackFunction = window.requestIdleCallback;
            const runItLater = typeof requestIdleCallbackFunction === 'function' ? requestIdleCallbackFunction : window.requestAnimationFrame;
            runItLater(()=>{
                analyticsClient.sendTrackEvent(payload);
            });
        } catch (error) {
        // silently fail for now https://product-fabric.atlassian.net/browse/ESS-3112
        }
    } else // Let the browser figure out
    // when it should send those events
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const requestIdleCallbackFunction = window.requestIdleCallback;
        const runItLater = typeof requestIdleCallbackFunction === 'function' ? requestIdleCallbackFunction : window.requestAnimationFrame;
        runItLater(()=>{
            analyticsClient.sendOperationalEvent(payload);
        });
    } catch (error) {
    // silently fail for now https://product-fabric.atlassian.net/browse/ESS-3112
    }
};
class $47363a476d445944$export$2e2bcd8739ae039 {
    sendErrorEvent(error, errorMessage) {
        let errorExtraAttributes = {};
        if (error instanceof (0, $ixa9X.CustomError)) errorExtraAttributes = error.getExtraErrorEventAttributes() || {};
        const errorAnalyticsEvent = {
            eventAction: (0, $flwxq.EVENT_ACTION).ERROR,
            attributes: {
                documentAri: this.documentAri,
                subProduct: this.subProduct,
                errorMessage: errorMessage,
                errorName: error instanceof Error ? error.name : undefined,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                errorCode: error.data?.code ?? undefined,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                errorStatus: error.data?.status ?? undefined,
                errorStack: error instanceof Error && $47363a476d445944$var$loggableErrorName.includes(error.name) ? error.stack : undefined,
                originalErrorMessage: this.getUGCFreeErrorMessage(error),
                ...errorExtraAttributes
            },
            nonPrivacySafeAttributes: {
                error: error
            }
        };
        this.sendEvent(errorAnalyticsEvent);
    }
    sendProviderErrorEvent(error) {
        const errorAnalyticsEvent = {
            eventAction: (0, $flwxq.EVENT_ACTION).ERROR,
            attributes: {
                documentAri: this.documentAri,
                subProduct: this.subProduct,
                errorMessage: 'Error emitted',
                originalErrorMessage: error.message,
                errorCode: error.code,
                mappedError: error
            }
        };
        this.sendEvent(errorAnalyticsEvent);
    }
    sendActionEvent(action, status, attributes // This breaks discriminated unions, because there is no obvious field to discriminate against any more
    ) {
        const analyticsEvent = {
            eventAction: action,
            attributes: {
                documentAri: this.documentAri,
                subProduct: this.subProduct,
                eventStatus: status,
                ...attributes
            }
        };
        this.sendEvent(analyticsEvent);
    }
    async sendEvent(event) {
        if (this.getAnalyticsClient && !this.analyticsClient) try {
            this.analyticsClient = await this.getAnalyticsClient;
        } catch (error) {
        // fail silently
        }
        $47363a476d445944$var$triggerAnalyticsEvent(event, this.analyticsClient);
    }
    getUGCFreeErrorMessage(error) {
        if (error instanceof Error && $47363a476d445944$var$loggableErrorName.includes(error.name)) return error.message;
        else return undefined;
    }
    constructor(documentAri, subProduct, analyticsClient, getAnalyticsClient){
        this.analyticsClient = void 0;
        this.getAnalyticsClient = void 0;
        this.documentAri = void 0;
        this.subProduct = void 0;
        this.documentAri = documentAri;
        this.subProduct = subProduct;
        this.analyticsClient = analyticsClient;
        this.getAnalyticsClient = getAnalyticsClient;
    }
}
module.exports["default"] = $47363a476d445944$export$2e2bcd8739ae039;

});

parcelRegister("dmolA", function(module, exports) {
const $824a7fe97f9fcc7b$export$a8ff84c12d48cfa6 = "platform-pkg";
const $824a7fe97f9fcc7b$export$83d89fbfd8236492 = "0.0.0-use.local";
const $824a7fe97f9fcc7b$export$49a9c95426e73961 = ()=>{
    return [
        Number($824a7fe97f9fcc7b$export$83d89fbfd8236492.split('.')[0]) + 1,
        0,
        0
    ].join('.');
};
module.exports["name"] = $824a7fe97f9fcc7b$export$a8ff84c12d48cfa6;
module.exports["version"] = $824a7fe97f9fcc7b$export$83d89fbfd8236492;

});

parcelRegister("gVzjB", function(module, exports) {

var $4frCv = parcelRequire("4frCv");


var $iqaft = parcelRequire("iqaft");

var $4SCyD = parcelRequire("4SCyD");


var $fdOBD = parcelRequire("fdOBD");

const $f7b6fd07244084eb$var$logger = (0, $4frCv.createLogger)('Telepointer', 'green');
const $f7b6fd07244084eb$export$eaaa064fda0476c4 = (participants, step)=>{
    const [participant] = participants.filter((p)=>p.clientId === step.clientId);
    if (participant) {
        const { stepType: stepType, to: to, from: from, slice: slice = {
            content: []
        } } = step;
        const [node] = slice.content;
        if (to && from && stepType === 'replace' && to === from && slice.content.length === 1 && node?.type === 'text' && node?.text?.length === 1) return {
            sessionId: participant.sessionId,
            selection: {
                type: 'textSelection',
                anchor: from + 1,
                head: to + 1
            },
            type: 'telepointer'
        };
    }
};
const $f7b6fd07244084eb$export$8aee63d4597b3f93 = (documentAri)=>{
    const telepointerExperience = new (0, $4SCyD.UFOExperience)('collab-provider.telepointer', {
        type: (0, $iqaft.ExperienceTypes).Operation,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).Custom,
        performanceConfig: {
            histogram: {
                [(0, $iqaft.ExperiencePerformanceTypes).Custom]: {
                    duration: '250_500_1000_1500_2000_3000_4000'
                }
            }
        }
    });
    telepointerExperience.addMetadata({
        documentAri: documentAri
    });
    telepointerExperience.start();
    return (response)=>{
        if (response.type === (0, $fdOBD.AcknowledgementResponseTypes).SUCCESS) telepointerExperience.success();
        else if (response.type === (0, $fdOBD.AcknowledgementResponseTypes).ERROR) {
            const errorMessage = response.error;
            telepointerExperience.addMetadata({
                error: errorMessage
            });
            $f7b6fd07244084eb$var$logger('Error from collab service with telepointer broadcast', errorMessage);
            telepointerExperience.failure();
        } else {
            $f7b6fd07244084eb$var$logger('Invalid ACK from collab service with telepointer broadcast');
            telepointerExperience.addMetadata({
                error: 'Invalid ACK from collab service with telepointer broadcast'
            });
            telepointerExperience.failure();
        }
    };
};
module.exports["telepointerFromStep"] = $f7b6fd07244084eb$export$eaaa064fda0476c4;
module.exports["telepointerCallback"] = $f7b6fd07244084eb$export$8aee63d4597b3f93;

});

parcelRegister("fdOBD", function(module, exports) {
var $1e717904817dfc51$export$49ed9ecf1b22773d = /*#__PURE__*/ function(AcknowledgementResponseTypes) {
    AcknowledgementResponseTypes["SUCCESS"] = "SUCCESS";
    AcknowledgementResponseTypes["ERROR"] = "ERROR";
    return AcknowledgementResponseTypes;
}({});
module.exports["AcknowledgementResponseTypes"] = $1e717904817dfc51$export$49ed9ecf1b22773d;

});

parcelRegister("aPvdt", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");

class $488feb4a36d568ce$export$b732ab16be80c4ec {
    setTitle(title, broadcast) {
        if (broadcast) this.broadcastMetadata({
            title: title
        });
        this.metadata.title = title;
    }
    setEditorWidth(editorWidth, broadcast) {
        if (broadcast) this.broadcastMetadata({
            editorWidth: editorWidth
        });
        this.metadata.editorWidth = editorWidth;
    }
    constructor(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providerEmitCallback, broadcastMetadata){
        this.providerEmitCallback = providerEmitCallback;
        this.broadcastMetadata = broadcastMetadata;
        this.metadata = {};
        this.getMetaData = ()=>this.metadata;
        this.getTitle = ()=>{
            return this.metadata.title?.toString();
        };
        /**
     * Called when a metadata is changed externally from other clients/backend.
     */ this.onMetadataChanged = (metadata)=>{
            if (metadata !== undefined && !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.metadata, metadata) && Object.keys(metadata).length > 0) {
                this.metadata = metadata;
                this.providerEmitCallback('metadata:changed', metadata);
            }
        };
        /**
     * Updates the local metadata and broadcasts the metadata to other clients/backend.
     * @param metadata
     */ this.setMetadata = (metadata)=>{
            this.broadcastMetadata(metadata);
            this.metadata = metadata;
        };
        /**
     * Emits a change in document's metadata
     * @param metadata
     */ this.updateMetadata = (metadata)=>{
            if (metadata && Object.keys(metadata).length > 0) {
                this.metadata = metadata;
                this.providerEmitCallback('metadata:changed', metadata);
            }
        };
    }
}
module.exports["MetadataService"] = $488feb4a36d568ce$export$b732ab16be80c4ec;

});

parcelRegister("84uMS", function(module, exports) {

var $8Yfbq = parcelRequire("8Yfbq");


var $cO9ey = parcelRequire("cO9ey");


var $9NwnH = parcelRequire("9NwnH");


var $ks2lK = parcelRequire("ks2lK");


var $h9yJL = parcelRequire("h9yJL");


var $iu6m9 = parcelRequire("iu6m9");


var $1oCLl = parcelRequire("1oCLl");


var $flwxq = parcelRequire("flwxq");


var $h6NFo = parcelRequire("h6NFo");


var $6MIiQ = parcelRequire("6MIiQ");


var $4frCv = parcelRequire("4frCv");


var $eOOPa = parcelRequire("eOOPa");


var $enTxz = parcelRequire("enTxz");


var $ixa9X = parcelRequire("ixa9X");


var $86Ccb = parcelRequire("86Ccb");


var $3QAb4 = parcelRequire("3QAb4");


var $c7fJY = parcelRequire("c7fJY");

const $18b8a2fb76cb9149$var$CATCHUP_THROTTLE = 1000; // 1 second
const $18b8a2fb76cb9149$var$noop = ()=>{};
const $18b8a2fb76cb9149$var$logger = (0, $4frCv.createLogger)('documentService', 'red');
class $18b8a2fb76cb9149$export$136703b96b9b8f33 {
    getVersionFromCollabState(state, resource) {
        const collabState = (0, $9NwnH.getCollabState)(state);
        if (!collabState) {
            this.analyticsHelper?.sendErrorEvent(new Error('No collab state when calling ProseMirror function'), `${resource} called without collab state`);
            return 0;
        }
        // This should not happen in usual, just add error event in case it happens
        if (collabState.version === undefined) {
            this.analyticsHelper?.sendErrorEvent(new Error('Collab state missing version info when calling ProseMirror function'), `${resource} called with collab state missing version info`);
            return 0;
        }
        return collabState.version;
    }
    /**
   * In the event we reconnect check if we have existing unconfirmed steps and if so
   * notify the editor that we have a potential conflict to resolve on the frontend.
   *
   * @param data remote steps payload
   * @param steps
   * @example
   */ notifyReconnectionConflict(steps) {
        if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', false)) return;
        const state = this.getState?.();
        const unconfirmedSteps = state ? (0, $9NwnH.getCollabState)(state)?.unconfirmed : undefined;
        if (steps.length > 0 && state && unconfirmedSteps && unconfirmedSteps.length > 0) {
            const { schema: schema, tr: tr } = state;
            const remoteSteps = steps.map((s)=>(0, $cO9ey.Step).fromJSON(schema, s));
            const conflicts = (0, $c7fJY.getConflictChanges)({
                localSteps: unconfirmedSteps,
                remoteSteps: remoteSteps,
                tr: tr
            });
            if (conflicts.deleted.length > 0 || conflicts.inserted.length > 0) this.providerEmitCallback('data:conflict', {
                offlineDoc: state.doc,
                ...conflicts
            });
        }
    }
    processQueue() {
        if (this.stepQueue.isPaused()) {
            $18b8a2fb76cb9149$var$logger(`Queue is paused. Aborting.`);
            return;
        }
        $18b8a2fb76cb9149$var$logger(`Looking for processable data.`);
        if (this.stepQueue.getQueue().length > 0) {
            const firstItem = this.stepQueue.shift();
            const currentVersion = this.getCurrentPmVersion();
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const expectedVersion = currentVersion + firstItem.steps.length;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (firstItem.version === expectedVersion) {
                $18b8a2fb76cb9149$var$logger(`Applying data from queue!`);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.processSteps(firstItem);
                // recur
                this.processQueue();
            }
        }
    }
    processSteps(data) {
        const { version: version, steps: steps } = data;
        $18b8a2fb76cb9149$var$logger(`Processing data. Version "${version}".`);
        if (steps?.length) try {
            const clientIds = steps.map(({ clientId: clientId })=>clientId);
            this.providerEmitCallback('data', {
                json: steps,
                version: version,
                userIds: clientIds
            });
            // If steps can apply to local editor successfully, no need to accumulate the error counter.
            this.stepRejectCounter = 0;
            this.participantsService.emitTelepointersFromSteps(steps);
            // Resend local steps if none of the received steps originated with us!
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (clientIds.indexOf(this.clientId) === -1) setTimeout(()=>this.sendStepsFromCurrentState(), 100);
            this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).PROCESS_STEPS, (0, $flwxq.EVENT_STATUS).SUCCESS);
        } catch (error) {
            // ESS-6421: log if error processing steps when there are steps from the same userId but not the same clientId
            const userIdMatch = this.isStepsFromNewClientIdForSameUserId(steps);
            $18b8a2fb76cb9149$var$logger(`Processing steps failed with error: ${error}. Triggering catch up call.`);
            this.analyticsHelper?.sendErrorEvent(error, userIdMatch ? `Error while processing steps with new clientId` : `Error while processing steps`);
            this.throttledCatchupv2((0, $flwxq.CatchupEventReason).PROCESS_STEPS);
        }
    }
    /**
   *
   * @example
   */ getIsNamespaceLocked() {
        return this.isNameSpaceLocked();
    }
    /**
   *
   * @param root0
   * @param root0.getState
   * @param root0.onSyncUpError
   * @param root0.clientId
   * @example
   */ setup({ getState: getState, onSyncUpError: onSyncUpError, clientId: clientId }) {
        this.getState = getState;
        this.onSyncUpError = onSyncUpError || $18b8a2fb76cb9149$var$noop;
        this.clientId = clientId;
        return this;
    }
    /**
   * We can use this function to throttle/delay
   * Any send steps operation
   *
   * The getState function will return the current EditorState
   * from the EditorView.
   * @param sendAnalyticsEvent
   * @param reason
   * @example
   */ sendStepsFromCurrentState(sendAnalyticsEvent, reason) {
        const state = this.getState?.();
        if (!state) {
            this.analyticsHelper?.sendErrorEvent(new Error('Editor state is undefined'), 'sendStepsFromCurrentState called without state');
            return;
        }
        this.send(null, null, state, sendAnalyticsEvent, reason);
    }
    /**
   * Send steps from transaction to other participants
   * It needs the superfluous arguments because we keep the interface of the send API the same as the Synchrony plugin
   * @param tr
   * @param _oldState
   * @param newState
   * @param sendAnalyticsEvent
   * @param reason
   * @example
   */ send(tr, _oldState, _newState, sendAnalyticsEvent, reason // only used for publish and draft-sync events - when called through getFinalAcknowledgedState
    ) {
        const offlineEditingEnabled = (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true);
        const onlineStepMergingEnabled = (0, $1oCLl.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true);
        // We don't trust `_newState` not to be stale
        // ED-29051 - the `onEditorViewStateUpdated` can have a stale state in edge cases. We need
        // to always ensure we're sending the latest state and unconfirmed steps so we use the state
        // from editorView directly (via getState).
        const newState = onlineStepMergingEnabled ? this.getState?.() ?? _newState : _newState;
        // Don't send any steps before we're ready.
        if (offlineEditingEnabled || onlineStepMergingEnabled) {
            const enableOnlineStepMerging = onlineStepMergingEnabled && !this.commitStepService.getReadyToCommitStatus();
            if (!this.getConnected() || enableOnlineStepMerging) return;
        }
        const unconfirmedStepsData = (0, $9NwnH.sendableSteps)(newState);
        const version = this.getVersionFromCollabState(newState, 'collab-provider: send');
        if (!unconfirmedStepsData) return;
        if (offlineEditingEnabled || onlineStepMergingEnabled) this.lockStepOrigins(unconfirmedStepsData.origins);
        const unconfirmedSteps = unconfirmedStepsData.steps;
        // sendAnalyticsEvent is only true when buffering is enabled,
        // to ensure that analytics events with the number of unconfirmed steps is only
        // sent once on connection (as opposed to on every step)
        if (sendAnalyticsEvent) this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).HAS_UNCONFIRMED_STEPS, (0, $flwxq.EVENT_STATUS).INFO, {
            numUnconfirmedSteps: unconfirmedSteps?.length || 0
        });
        if (!unconfirmedSteps?.length) return;
        const rebased = tr?.getMeta('rebasedData');
        if (rebased) {
            const obfuscatedUnconfirmedSteps = this.obfuscateStepsAndState(rebased.unconfirmedSteps).obfuscatedSteps;
            const obfuscatedRemoteSteps = this.obfuscateStepsAndState(rebased.remoteSteps);
            const obfuscatedRebasedSteps = this.obfuscateStepsAndState(unconfirmedSteps).obfuscatedSteps;
            // send analtyics on unconfirmed steps
            this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).STEPS_REBASED, (0, $flwxq.EVENT_STATUS).INFO, {
                obfuscatedUnconfirmedSteps: obfuscatedUnconfirmedSteps,
                obfuscatedRemoteSteps: obfuscatedRemoteSteps,
                obfuscatedRebasedSteps: obfuscatedRebasedSteps,
                clientID: this.clientId,
                userId: this.getUserId(),
                versionBefore: rebased.versionBefore,
                versionAfter: version
            });
        }
        if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
            const containsOfflineSteps = unconfirmedStepsData?.origins.some((tr)=>{
                return tr instanceof (0, $ks2lK.Transaction) ? tr.getMeta('isOffline') ?? false : false;
            });
            if (containsOfflineSteps && !this.timeoutExceeded) {
                // Only start timer if we're online and don't already have one running
                if (this.getConnected() && !this.timeout) this.timeout = setTimeout(()=>{
                    // If the timer expires and we're still online, handle the offline steps.
                    // Otherwise, clear the timer so it can restart when we're online again.
                    if (this.getConnected()) {
                        this.timeoutExceeded = true;
                        const updatedUnconfirmedStepsData = (0, $9NwnH.sendableSteps)(newState);
                        updatedUnconfirmedStepsData?.origins.forEach((origin)=>{
                            if (origin instanceof (0, $ks2lK.Transaction) && origin.getMeta('isOffline')) origin.setMeta('isOffline', false);
                        });
                    } else this.timeout = undefined;
                }, 6000);
                return;
            } else if (this.timeoutExceeded) {
                this.timeoutExceeded = false;
                if (this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = undefined;
                }
            }
        }
        // Avoid reference issues using a
        // method outside of the provider
        // scope
        this.commitStepService.commitStepQueue({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            userId: this.getUserId(),
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            clientId: this.clientId,
            steps: unconfirmedSteps,
            version: version,
            onStepsAdded: this.onStepsAdded,
            __livePage: this.options.__livePage,
            hasRecovered: this.hasRecovered,
            collabMode: this.participantsService.getCollabMode(),
            reason: reason,
            lockSteps: this.lockSteps,
            stepOrigins: unconfirmedStepsData.origins
        });
    }
    /**
   *
   * @param participantsService - The participants service, used when users are detected active when making changes to the document
   * and to emit their telepointers from steps they add
   * @param analyticsHelper - Helper for analytics events
   * @param fetchCatchupv2 - Step based - Function to fetch "catchupv2" data, data required to rebase current steps to the latest version.
   * @param fetchReconcile - Function to call "reconcile" from NCS backend
   * @param fetchGeneratedDiffSteps - Function to call "generateDiffSteps" from NCS backend
   * @param providerEmitCallback - Callback for emitting events to listeners on the provider
   * @param broadcast - Callback for broadcasting events to other clients
   * @param getUserId - Callback to fetch the current user's ID
   * @param onErrorHandled - Callback to handle
   * @param metadataService
   * @param isNameSpaceLocked
   * @param enableErrorOnFailedDocumentApply - Enable failed document update exceptions.
   * @param options.__livePage
   * @param options
   * @param getConnected - if the channel is currently connected
   * @example
   */ constructor(participantsService, analyticsHelper, fetchCatchupv2, fetchReconcile, fetchGeneratedDiffSteps, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providerEmitCallback, broadcast, getUserId, onErrorHandled, metadataService, isNameSpaceLocked, enableErrorOnFailedDocumentApply = false, options = {
        __livePage: false
    }, getConnected){
        this.participantsService = participantsService;
        this.analyticsHelper = analyticsHelper;
        this.fetchCatchupv2 = fetchCatchupv2;
        this.fetchReconcile = fetchReconcile;
        this.fetchGeneratedDiffSteps = fetchGeneratedDiffSteps;
        this.providerEmitCallback = providerEmitCallback;
        this.broadcast = broadcast;
        this.getUserId = getUserId;
        this.metadataService = metadataService;
        this.isNameSpaceLocked = isNameSpaceLocked;
        this.enableErrorOnFailedDocumentApply = enableErrorOnFailedDocumentApply;
        this.options = options;
        this.getConnected = getConnected;
        this.getState = void 0;
        // Fires analytics to editor when collab editor cannot sync up
        this.onSyncUpError = void 0;
        this.stepQueue = void 0;
        this.stepRejectCounter = 0;
        this.aggressiveCatchup = false;
        this.catchUpOutofSync = false;
        this.hasRecovered = false;
        this.commitStepService = void 0;
        this.timeout = void 0;
        this.timeoutExceeded = false;
        // ClientID is the unique ID for a prosemirror client. Used for step-rebasing.
        this.clientId = void 0;
        this.onErrorHandled = void 0;
        /**
     * To prevent calling catchup to often, use lodash throttle to reduce the frequency
     * @param reason - optional reason to attach.
     */ this.throttledCatchupv2 = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))((reason, reconnectionMetadata, sessionId)=>this.catchupv2(reason, reconnectionMetadata, sessionId), $18b8a2fb76cb9149$var$CATCHUP_THROTTLE, {
            leading: false,
            // TODO: ED-26957 - why shouldn't this be leading?
            trailing: true
        });
        /**
     * Called when:
     *   * session established(offline -> online)
     *   * try to accept steps but version is behind.
     * @param reason - optional reason to attach.
     * @param reconnectionMetadata
     * @example
     */ this.catchupv2 = async (reason, reconnectionMetadata, sessionId)=>{
            const start = new Date().getTime();
            // if the queue is already paused, we are busy with something else, so don't proceed.
            if (this.stepQueue.isPaused()) {
                $18b8a2fb76cb9149$var$logger(`Queue is paused. Aborting.`);
                return;
            }
            /**
       * If the database is in a transitionary state (i.e locked),
       * it likely that another user may already be in the process of catching up.
       *
       * If multiple users are trying to catch up at the same time, it can lead to
       * the database being stuck in a transitionary state due to duplicated page recovery requests.
       * We don't wanna be stuck in a transitionary state as that will cause issues with
       * content reconciliation and other operations.
       */ // check if the document is locked -> noop
            if (this.isNameSpaceLocked()) {
                $18b8a2fb76cb9149$var$logger(`catchupv2: Document is locked. Aborting.`);
                return;
            }
            this.stepQueue.pauseQueue();
            try {
                /**
         * We have two options when out of sync:
         * - Check a boolean that ensures we reset the document next time we catchup
         * - Immediately catchup
         *
         * Immediately catching up has some complexity invovled with it - do we call catchupv2 again, fetchCatchupv2 again, or documentService.catchupV2 again?
         * If we call either catchupv2 or documentService.catchupv2, we run the risk of creating an infinite loop of reset catchup requests.
         * We can slow down the loop by calling throttledCatchupv2, and can add booleans that check if we're already doing a reset catchup request.
         *
         * But this all adds complexity that can be avoided by choosing the first option.
         * Collab provider will already call catchup again, so this time we can ensure we call it with reset.
         */ this.catchUpOutofSync = await (0, $86Ccb.catchupv2)({
                    getCurrentPmVersion: this.getCurrentPmVersion,
                    fetchCatchupv2: this.fetchCatchupv2,
                    updateMetadata: this.metadataService.updateMetadata,
                    analyticsHelper: this.analyticsHelper,
                    clientId: this.clientId,
                    onStepsAdded: this.onStepsAdded,
                    catchUpOutofSync: this.catchUpOutofSync,
                    reason: reason,
                    sessionId: sessionId,
                    onCatchupComplete: (steps)=>{
                        // We want to capture the number of steps made while offline vs. online
                        if (reason === (0, $flwxq.CatchupEventReason).RECONNECTED) {
                            this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).RECONNECTION, (0, $flwxq.EVENT_STATUS).INFO, {
                                ...reconnectionMetadata,
                                remoteStepsLength: steps?.length ?? 0
                            });
                            this.notifyReconnectionConflict(steps);
                        }
                    },
                    getState: this.getState
                });
                const latency = new Date().getTime() - start;
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).CATCHUP, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                    latency: latency,
                    version: this.getCurrentPmVersion()
                });
            } catch (error) {
                const latency = new Date().getTime() - start;
                // Skip client side errors; TypeErrors are client side errors https://developer.mozilla.org/en-US/docs/Web/API/Window/fetch
                const errorMessage = error instanceof Error ? error.message : String(error);
                if (!errorMessage.includes('TypeError') && !(error instanceof TypeError)) this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).CATCHUP, (0, $flwxq.EVENT_STATUS).FAILURE, {
                    latency: latency,
                    reason: reason,
                    unconfirmedStepsLength: reconnectionMetadata?.unconfirmedStepsLength,
                    disconnectionPeriodSeconds: reconnectionMetadata?.disconnectionPeriodSeconds
                });
            } finally{
                this.stepQueue.resumeQueue();
                this.processQueue();
                this.sendStepsFromCurrentState(); // this will eventually retry catchup as it calls throttledCommitStep which will either catchup on onStepsAdded or onErrorHandled
                this.stepRejectCounter = 0;
            }
        };
        this.getCurrentPmVersion = ()=>{
            const state = this.getState?.();
            if (!state) {
                this.analyticsHelper?.sendErrorEvent(new Error('No editor state when calling ProseMirror function'), 'getCurrentPmVersion called without state');
                return 0;
            }
            return this.getVersionFromCollabState(state, 'collab-provider: getCurrentPmVersion');
        };
        // Ignored via go/ees005
        // eslint-disable-next-line require-await
        this.getCurrentState = async ()=>{
            try {
                (0, $h6NFo.startMeasure)((0, $h6NFo.MEASURE_NAME).GET_CURRENT_STATE, this.analyticsHelper);
                // Convert ProseMirror document in Editor state to ADF document
                if (!this.getState?.()) this.analyticsHelper?.sendErrorEvent(new Error('Editor state is undefined'), 'getCurrentState called without state');
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const state = this.getState();
                const adfDocument = new (0, $h9yJL.JSONTransformer)().encode(state.doc);
                const version = this.getVersionFromCollabState(state, 'collab-provider: getCurrentState');
                const currentState = {
                    content: adfDocument,
                    title: this.metadataService.getTitle(),
                    stepVersion: version
                };
                const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).GET_CURRENT_STATE, this.analyticsHelper);
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).GET_CURRENT_STATE, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                    latency: measure?.duration
                });
                return currentState;
            } catch (error) {
                const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).GET_CURRENT_STATE, this.analyticsHelper);
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).GET_CURRENT_STATE, (0, $flwxq.EVENT_STATUS).FAILURE, {
                    latency: measure?.duration
                });
                this.analyticsHelper?.sendErrorEvent(error, 'Error while returning ADF version of current draft document');
                throw error; // Reject the promise so the consumer can react to it failing
            }
        };
        this.isStepsFromNewClientIdForSameUserId = (steps)=>{
            try {
                if (!Array.isArray(steps) || steps.length === 0) return false;
                const clientIds = new Set(steps.map(({ clientId: clientId })=>clientId));
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (!clientIds.has(this.clientId)) {
                    const userIds = new Set(steps.map(({ userId: userId })=>userId));
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    if (userIds.has(this.getUserId())) return true;
                }
                return false;
            } catch (err) {
                this.analyticsHelper?.sendErrorEvent(err, 'Error while checking for new clientId for same userId in steps');
                return false;
            }
        };
        this.getUnconfirmedStepsOrigins = ()=>{
            const state = this.getState?.();
            if (!state) {
                this.analyticsHelper?.sendErrorEvent(new Error('No editor state when calling ProseMirror function'), 'getUnconfirmedStepsOrigins called without state');
                return;
            }
            return (0, $9NwnH.sendableSteps)(state)?.origins;
        };
        this.getUnconfirmedSteps = ()=>{
            const state = this.getState?.();
            if (!state) {
                this.analyticsHelper?.sendErrorEvent(new Error('No editor state when calling ProseMirror function'), 'getUnconfirmedSteps called without state');
                return;
            }
            return (0, $9NwnH.sendableSteps)(state)?.steps;
        };
        this.applyLocalSteps = (steps)=>{
            // Re-apply local steps
            this.providerEmitCallback('local-steps', {
                steps: steps
            });
        };
        /**
     * Called when we receive steps from the service
     * @param data
     * @example
     */ this.onStepsAdded = (data)=>{
            $18b8a2fb76cb9149$var$logger(`Received steps`, {
                steps: data.steps,
                version: data.version
            });
            if (!data.steps) {
                $18b8a2fb76cb9149$var$logger(`No steps.. waiting..`);
                return;
            }
            const ADD_STEPS_PROVIDER_ERROR_MSG = 'Error while adding steps in the provider';
            try {
                const currentVersion = this.getCurrentPmVersion();
                const expectedVersion = currentVersion + data.steps.length;
                if (data.version <= currentVersion) $18b8a2fb76cb9149$var$logger(`Received steps we already have. Ignoring.`);
                else if (data.version === expectedVersion) this.processSteps(data);
                else if (data.version > expectedVersion) {
                    $18b8a2fb76cb9149$var$logger(`Version too high. Expected "${expectedVersion}" but got "${data.version}. Current local version is ${currentVersion}.`);
                    this.stepQueue.queueSteps(data);
                    this.throttledCatchupv2((0, $flwxq.CatchupEventReason).STEPS_ADDED);
                }
                this.participantsService.updateLastActive(data.steps.map(({ userId: userId })=>userId));
            } catch (stepsAddedError) {
                this.analyticsHelper?.sendErrorEvent(stepsAddedError, ADD_STEPS_PROVIDER_ERROR_MSG);
                this.onErrorHandled({
                    message: ADD_STEPS_PROVIDER_ERROR_MSG,
                    data: {
                        status: 500,
                        // Meaningless, remove when we review error structure
                        code: (0, $6MIiQ.INTERNAL_ERROR_CODE).ADD_STEPS_ERROR
                    }
                });
                // eslint-disable-next-line no-console
                console.error(ADD_STEPS_PROVIDER_ERROR_MSG);
            }
        };
        this.obfuscateStepsAndState = (unconfirmedSteps, currentState)=>{
            let obfuscatedSteps;
            try {
                obfuscatedSteps = unconfirmedSteps ? (0, $4frCv.getObfuscatedSteps)(unconfirmedSteps.map((pmStep)=>pmStep.toJSON())) : 'None';
            } catch (error) {
                // Note that we do not log this error immediately - this string will be logged later.
                // This avoids double logging and keeps this function pure.
                obfuscatedSteps = 'Failed to obfuscate steps';
            }
            let obfuscatedDoc;
            if (currentState) try {
                obfuscatedDoc = (0, $4frCv.getDocAdfWithObfuscationFromJSON)(currentState.content);
            } catch (error) {
                obfuscatedDoc = 'Failed to obfuscate doc';
            }
            return {
                obfuscatedSteps: obfuscatedSteps,
                obfuscatedDoc: obfuscatedDoc
            };
        };
        // Triggered when page recovery has emitted an 'init' event on a page client is currently connected to.
        this.onRestore = async ({ doc: doc, version: version, metadata: metadata, targetClientId: targetClientId })=>{
            if (!targetClientId) this.hasRecovered = true;
            if (targetClientId && this.clientId !== targetClientId) return;
            // We preserve these as they will be lost apon this.updateDocument. This is because we are using document recovery.
            // We can then reconcile the document with the preserved state.
            const unconfirmedSteps = this.getUnconfirmedSteps();
            const currentState = await this.getCurrentState();
            let useReconcile = Boolean(unconfirmedSteps?.length && currentState && !targetClientId);
            const { obfuscatedSteps: obfuscatedSteps, obfuscatedDoc: obfuscatedDoc } = this.obfuscateStepsAndState(unconfirmedSteps, currentState);
            try {
                // Reset the editor,
                //  - Replace the document, keep in sync with the server
                //  - Replace the version number, so editor is in sync with NCS server and can commit new changes.
                //  - Replace the metadata
                //  - Reserve the cursor position, in case a cursor jump.
                this.updateDocument({
                    doc: doc,
                    version: version,
                    metadata: metadata,
                    reserveCursor: true,
                    caller: 'onRestore'
                });
                this.metadataService.updateMetadata(metadata);
                try {
                    this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).REINITIALISE_DOCUMENT, (0, $flwxq.EVENT_STATUS).INFO, {
                        numUnconfirmedSteps: unconfirmedSteps?.length,
                        obfuscatedSteps: obfuscatedSteps,
                        obfuscatedDoc: obfuscatedDoc,
                        hasTitle: !!metadata?.title,
                        clientId: this.clientId,
                        targetClientId: targetClientId,
                        triggeredByCatchup: !!targetClientId
                    });
                    if (unconfirmedSteps?.length) this.applyLocalSteps(unconfirmedSteps);
                } catch (applyLocalStepsError) {
                    // Extract generatedSteps from fetchReconcile response
                    // and apply them to the editor state.
                    this.onErrorHandled({
                        message: `Content synced with your team's edits. You may want to check for conflicting edits that could override your changes.`,
                        data: {
                            code: (0, $6MIiQ.INTERNAL_ERROR_CODE).OUT_OF_SYNC_CLIENT_DATA_LOSS_EVENT,
                            meta: {
                                reason: 'fe-restore-fetch-generated-steps'
                            }
                        }
                    });
                    useReconcile = false;
                    try {
                        const generatedDiffStepsResponse = await this.fetchGeneratedDiffSteps(JSON.stringify(currentState.content), 'fe-restore-fetch-generated-steps');
                        const { generatedSteps: generatedSteps } = generatedDiffStepsResponse;
                        const state = this.getState?.();
                        if (state?.schema) {
                            const stepsToBeApplied = generatedSteps?.map((s)=>(0, $cO9ey.Step).fromJSON(state.schema, s));
                            if (stepsToBeApplied && stepsToBeApplied.length > 0) {
                                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).REINITIALISE_DOCUMENT, (0, $flwxq.EVENT_STATUS).INFO, {
                                    stepsCount: stepsToBeApplied.length
                                });
                                this.applyLocalSteps(stepsToBeApplied);
                            } else this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).REINITIALISE_DOCUMENT, (0, $flwxq.EVENT_STATUS).INFO, {
                                reason: 'fetchGeneratedDiffSteps returned no steps'
                            });
                        }
                    } catch (reconcileError) {
                        this.analyticsHelper?.sendErrorEvent(reconcileError, `Error fetchGeneratedDiffSteps with steps-only mode`);
                    }
                }
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).REINITIALISE_DOCUMENT, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                    numUnconfirmedSteps: unconfirmedSteps?.length,
                    hasTitle: !!metadata?.title,
                    useReconcile: useReconcile,
                    clientId: this.clientId,
                    targetClientId: targetClientId,
                    triggeredByCatchup: !!targetClientId
                });
            } catch (restoreError) {
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).REINITIALISE_DOCUMENT, (0, $flwxq.EVENT_STATUS).FAILURE, {
                    numUnconfirmedSteps: unconfirmedSteps?.length,
                    useReconcile: useReconcile,
                    clientId: this.clientId,
                    targetClientId: targetClientId,
                    triggeredByCatchup: !!targetClientId
                });
                this.analyticsHelper?.sendErrorEvent(restoreError, `Error while reinitialising document. Use Reconcile: ${useReconcile}`);
                this.onErrorHandled({
                    message: 'Caught error while trying to recover the document',
                    data: {
                        status: 500,
                        // Meaningless, remove when we review error structure
                        code: (0, $6MIiQ.INTERNAL_ERROR_CODE).DOCUMENT_RESTORE_ERROR
                    }
                });
            }
        };
        this.getFinalAcknowledgedState = async (reason)=>{
            this.aggressiveCatchup = true;
            try {
                (0, $h6NFo.startMeasure)((0, $h6NFo.MEASURE_NAME).PUBLISH_PAGE, this.analyticsHelper);
                let finalAcknowledgedState;
                try {
                    await this.commitUnconfirmedSteps(reason);
                    finalAcknowledgedState = await this.getCurrentState();
                } catch (error) {
                    // if fails to commit unconfirmed steps, send reconcile request to NCS BE and return the doc to CC
                    const currentState = await this.getCurrentState();
                    const reconcileResponse = await this.fetchReconcile(JSON.stringify(currentState.content), 'fe-final-ack');
                    finalAcknowledgedState = {
                        content: JSON.parse(reconcileResponse.document),
                        title: currentState.title,
                        stepVersion: reconcileResponse.version
                    };
                }
                const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).PUBLISH_PAGE, this.analyticsHelper);
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).PUBLISH_PAGE, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                    latency: measure?.duration
                });
                this.aggressiveCatchup = false;
                return finalAcknowledgedState;
            } catch (error) {
                this.aggressiveCatchup = false;
                const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).PUBLISH_PAGE, this.analyticsHelper);
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).PUBLISH_PAGE, (0, $flwxq.EVENT_STATUS).FAILURE, {
                    latency: measure?.duration
                });
                this.analyticsHelper?.sendErrorEvent(error, 'Error while returning ADF version of the final draft document');
                throw error; // Reject the promise so the consumer can react to it failing
            }
        };
        this.updateDocument = ({ doc: doc, version: version, metadata: metadata, reserveCursor: reserveCursor, caller: caller })=>{
            this.providerEmitCallback('init', {
                doc: doc,
                version: version,
                metadata: metadata,
                ...reserveCursor ? {
                    reserveCursor: reserveCursor
                } : {}
            });
            this.updateDocumentAnalytics(doc, version, caller);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.updateDocumentAnalytics = (doc, version, caller)=>{
            const updatedVersion = this.getCurrentPmVersion();
            const isDocContentValid = this.validatePMJSONDocument(doc);
            // ESS-5023: only emit error event if updated client version is still behind server version
            // client version could become higher than server version due to user editing or plugin adding steps
            if (updatedVersion < version) {
                const error = new (0, $ixa9X.UpdateDocumentError)('Failed to update the document', {
                    newVersion: version,
                    editorVersion: updatedVersion,
                    isDocTruthy: !!doc,
                    docHasContent: doc?.content?.length >= 1,
                    isDocContentValid: isDocContentValid,
                    caller: caller
                });
                this.analyticsHelper?.sendErrorEvent(error, 'Failed to update the document in document service');
                if (this.enableErrorOnFailedDocumentApply) {
                    this.onErrorHandled({
                        message: 'The provider failed to apply changes to the editor',
                        data: {
                            code: (0, $6MIiQ.INTERNAL_ERROR_CODE).DOCUMENT_UPDATE_ERROR,
                            meta: {
                                newVersion: version,
                                editorVersion: updatedVersion
                            },
                            status: 500
                        }
                    });
                    throw error;
                }
            // Otherwise just fail silently for now
            } else this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).UPDATE_DOCUMENT, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                newVersion: version,
                editorVersion: updatedVersion,
                isDocTruthy: !!doc,
                docHasContent: doc?.content?.length >= 1,
                isDocContentValid: isDocContentValid
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.validatePMJSONDocument = (doc)=>{
            try {
                if (!this.getState?.()) this.analyticsHelper?.sendErrorEvent(new Error('Editor state is undefined'), 'validatePMJSONDocument called without state');
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const state = this.getState();
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const content = (doc.content || []).map((child)=>state.schema.nodeFromJSON(child));
                return content.every((node)=>{
                    try {
                        node.check(); // this will throw an error if the node is invalid
                    } catch (error) {
                        return false;
                    }
                    return true;
                });
            } catch (e) {
                return false;
            }
        };
        /**
     * Commit the unconfirmed local steps to the back-end service
     * @param reason
     * @throws {Error} Couldn't sync the steps after retrying 30 times
     * @example
     */ this.commitUnconfirmedSteps = async (reason)=>{
            const unconfirmedSteps = this.getUnconfirmedSteps();
            try {
                if (unconfirmedSteps?.length) {
                    (0, $h6NFo.startMeasure)((0, $h6NFo.MEASURE_NAME).COMMIT_UNCONFIRMED_STEPS, this.analyticsHelper);
                    let count = 0;
                    // We use origins here as steps can be rebased. When steps are rebased a new step is created.
                    // This means that we can not track if it has been removed from the unconfirmed array or not.
                    // Origins points to the original transaction that the step was created in. This is never changed
                    // and gets passed down when a step is rebased.
                    const unconfirmedTrs = this.getUnconfirmedStepsOrigins();
                    const lastTr = unconfirmedTrs?.[unconfirmedTrs.length - 1];
                    let isLastTrConfirmed = false;
                    if (!this.getState?.()) this.analyticsHelper?.sendErrorEvent(new Error('Editor state is undefined'), 'commitUnconfirmedSteps called without state');
                    while(!isLastTrConfirmed){
                        // this makes all commitUnconfirmedSteps skip the waiting time, which means draft-sync is sped up too.
                        this.sendStepsFromCurrentState(undefined, 'publish');
                        await (0, $4frCv.sleep)(500);
                        const nextUnconfirmedSteps = this.getUnconfirmedSteps();
                        if (nextUnconfirmedSteps?.length) {
                            const nextUnconfirmedTrs = this.getUnconfirmedStepsOrigins();
                            isLastTrConfirmed = !nextUnconfirmedTrs?.some((tr)=>tr === lastTr);
                        } else isLastTrConfirmed = true;
                        if (!isLastTrConfirmed && count++ >= (0, $flwxq.ACK_MAX_TRY)) {
                            if (this.onSyncUpError) {
                                // Ignored via go/ees005
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                const state = this.getState();
                                const version = this.getVersionFromCollabState(state, 'collab-provider: commitUnconfirmedSteps');
                                this.onSyncUpError({
                                    lengthOfUnconfirmedSteps: nextUnconfirmedSteps?.length,
                                    tries: count,
                                    maxRetries: (0, $flwxq.ACK_MAX_TRY),
                                    clientId: this.clientId,
                                    version: version
                                });
                            }
                            const unconfirmedStepsInfoUGCRemoved = this.getUnconfirmedSteps()?.map((step)=>(0, $4frCv.getStepUGCFreeDetails)(step));
                            const error = new (0, $ixa9X.CantSyncUpError)("Can't sync up with Collab Service: unable to send unconfirmed steps and max retry reached", {
                                unconfirmedStepsInfo: unconfirmedStepsInfoUGCRemoved ? JSON.stringify(unconfirmedStepsInfoUGCRemoved) : 'Unable to generate UGC removed step info'
                            });
                            throw error;
                        }
                    }
                    const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).COMMIT_UNCONFIRMED_STEPS, this.analyticsHelper);
                    this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).COMMIT_UNCONFIRMED_STEPS, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                        latency: measure?.duration,
                        // upon success, emit the total number of unconfirmed steps we synced
                        numUnconfirmedSteps: unconfirmedSteps?.length
                    });
                }
            } catch (error) {
                const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).COMMIT_UNCONFIRMED_STEPS, this.analyticsHelper);
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).COMMIT_UNCONFIRMED_STEPS, (0, $flwxq.EVENT_STATUS).FAILURE, {
                    latency: measure?.duration,
                    numUnconfirmedSteps: unconfirmedSteps?.length
                });
                this.analyticsHelper?.sendErrorEvent(error, 'Error while committing unconfirmed steps');
                throw error;
            }
        };
        this.onStepRejectedError = ()=>{
            this.stepRejectCounter++;
            $18b8a2fb76cb9149$var$logger(`Steps rejected (tries=${this.stepRejectCounter})`);
            this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).SEND_STEPS_RETRY, (0, $flwxq.EVENT_STATUS).INFO, {
                count: this.stepRejectCounter
            });
            const maxRetries = this.aggressiveCatchup ? (0, $eOOPa.MAX_STEP_REJECTED_ERROR_AGGRESSIVE) : (0, $eOOPa.MAX_STEP_REJECTED_ERROR);
            if (this.stepRejectCounter >= maxRetries) {
                $18b8a2fb76cb9149$var$logger(`The steps were rejected too many times (tries=${this.stepRejectCounter}, limit=${(0, $eOOPa.MAX_STEP_REJECTED_ERROR)}). Trying to catch-up.`);
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).CATCHUP_AFTER_MAX_SEND_STEPS_RETRY, (0, $flwxq.EVENT_STATUS).INFO);
                this.throttledCatchupv2((0, $flwxq.CatchupEventReason).STEPS_REJECTED);
            } else // If committing steps failed try again automatically in 1s
            // This makes it more likely that unconfirmed steps trigger a catch-up
            // within 15s even if there is no one editing actively (or draft sync polling)
            // reducing the risk of data loss at the expense of step commits
            setTimeout(()=>this.sendStepsFromCurrentState(), 1000);
        };
        /**
     * If we are going to commit unconfirmed steps
     * we need to lock them to ensure they don't get
     * mutated in: `packages/editor/editor-plugin-collab-edit/src/pm-plugins/mergeUnconfirmed.ts`
     */ this.lockSteps = ()=>{
            if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) || (0, $1oCLl.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true)) {
                const currentState = this.getState?.();
                if (currentState) this.lockStepOrigins((0, $9NwnH.sendableSteps)(currentState)?.origins ?? []);
            }
        };
        this.lockStepOrigins = (origins)=>{
            origins?.forEach((origin)=>{
                if (origin instanceof (0, $ks2lK.Transaction)) return origin.setMeta('mergeIsLocked', true);
            });
        };
        this.stepQueue = new (0, $3QAb4.StepQueueState)();
        this.onErrorHandled = onErrorHandled;
        this.commitStepService = new (0, $enTxz.CommitStepService)(this.broadcast, this.analyticsHelper, this.providerEmitCallback, this.onErrorHandled);
    }
}
module.exports["DocumentService"] = $18b8a2fb76cb9149$export$136703b96b9b8f33;

});

parcelRegister("8Yfbq", function(module, exports) {

var $jSnXV = parcelRequire("jSnXV");


var $lc9ud = parcelRequire("lc9ud");

/** Error message constants. */ var $687fb4659a5afde2$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $687fb4659a5afde2$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($687fb4659a5afde2$var$FUNC_ERROR_TEXT);
    if ($lc9ud(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $jSnXV(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $687fb4659a5afde2$var$throttle;

});

parcelRegister("enTxz", function(module, exports) {

var $3GH4X = parcelRequire("3GH4X");


var $flwxq = parcelRequire("flwxq");


var $fdOBD = parcelRequire("fdOBD");


var $6Ted9 = parcelRequire("6Ted9");


var $4frCv = parcelRequire("4frCv");


var $1oCLl = parcelRequire("1oCLl");

const $24a15250db2473e6$var$logger = (0, $4frCv.createLogger)('commit-step', 'black');
const $24a15250db2473e6$export$e52e10f4c6d18d66 = 5000;
class $24a15250db2473e6$export$1507ea63539b16e5 {
    commitStepQueue({ steps: steps, version: version, userId: userId, clientId: clientId, onStepsAdded: onStepsAdded, __livePage: __livePage, hasRecovered: hasRecovered, collabMode: collabMode, reason: reason, lockSteps: lockSteps, stepOrigins: stepOrigins }) {
        // this timer is for waiting to send the next batch in between acks from the BE
        let commitWaitTimer;
        // if publishing and not waiting for an ACK, then clear the commit timer and proceed, skipping the timer
        if (reason === 'publish' && this.lastBroadcastRequestAcked) {
            clearTimeout(commitWaitTimer);
            lockSteps();
            this.readyToCommit = true;
        }
        if (!this.readyToCommit) {
            $24a15250db2473e6$var$logger('Not ready to commit, skip');
            return;
        }
        // Block other sending request, before ACK
        this.readyToCommit = false;
        this.lastBroadcastRequestAcked = false;
        // this timer is a fallback for if an ACK from BE is lost - stop the queue from getting indefinitely locked
        const fallbackTimer = setTimeout(()=>{
            lockSteps();
            this.readyToCommit = true;
            this.lastBroadcastRequestAcked = true;
            $24a15250db2473e6$var$logger('reset readyToCommit by timer');
        }, $24a15250db2473e6$export$e52e10f4c6d18d66);
        let stepsWithClientAndUserId = steps.map((step)=>({
                ...step.toJSON(),
                clientId: clientId,
                userId: userId
            }));
        // Mutate steps to ignore expand expand/collapse changes in live pages
        // This is expected to be a temporary divergence from standard editor behaviour
        // and will be removed in Q4 when editor and live view pages align on a single
        // behaviour for expands.
        // While not recommended by the Editor content services team, this has been discussed
        // as being low risk as the expand change via a setAttrs step;
        // - doesn't impact any indexes,
        // - is setup for last write wins,
        // - and is just a boolean -- so no real risk of data loss.
        if (__livePage) stepsWithClientAndUserId = stepsWithClientAndUserId.map((step)=>{
            if (this.isExpandChangeStep(step)) // The title is also updated via this step, which we do want to send to the server.
            // so we strip out the __expanded attribute from the step.
            return {
                ...step,
                attrs: {
                    title: step.attrs.title
                }
            };
            return step;
        });
        // tag unconfirmed steps sent after page has been recovered during client's editing session
        if (hasRecovered) stepsWithClientAndUserId = stepsWithClientAndUserId.map((step)=>{
            step.metadata = {
                ...step.metadata,
                unconfirmedStepAfterRecovery: true
            };
            return step;
        });
        if ((0, $1oCLl.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) stepsWithClientAndUserId = this.addOfflineMetadata(stepsWithClientAndUserId, stepOrigins);
        const start = new Date().getTime();
        const ADD_STEPS_ACKNOWLEDGEMENT_ERROR_MSG = 'Error while adding steps - Invalid Acknowledgement';
        const ADD_STEPS_BROADCAST_ERROR_MSG = 'Error while adding steps - Broadcast threw exception';
        this.emit('commit-status', {
            status: 'attempt',
            version: version
        });
        try {
            this.broadcast('steps:commit', {
                collabMode: collabMode,
                steps: stepsWithClientAndUserId,
                version: version,
                userId: userId
            }, (response)=>{
                this.lastBroadcastRequestAcked = true;
                const latency = new Date().getTime() - start;
                // this most closely replicates the BE ack delay behaviour. 500ms hardcoded + 180ms network delay (tested on hello)
                // more context: https://hello.atlassian.net/wiki/spaces/CEPS/pages/5020556010/Spike+Moving+BE+delay+to+the+FE
                // to be switched over to backpressure delay sent from the BE in https://hello.jira.atlassian.cloud/browse/CEPS-1030
                let delay = latency < 680 ? 680 - latency : 1;
                if (response.delay) delay = response.delay;
                 // if backpressure delay is sent, overwrite it
                clearTimeout(fallbackTimer); // clear the fallback timer, ack was successfully sent/recieved
                commitWaitTimer = setTimeout(()=>{
                    lockSteps();
                    // unlock the queue after waiting for delay
                    this.readyToCommit = true;
                    $24a15250db2473e6$var$logger('reset readyToCommit');
                }, delay);
                if (response.type === (0, $fdOBD.AcknowledgementResponseTypes).SUCCESS) {
                    onStepsAdded({
                        steps: stepsWithClientAndUserId,
                        version: response.version
                    });
                    this.sendSuccessAnalytics(latency, stepsWithClientAndUserId);
                    this.emit('commit-status', {
                        status: 'success',
                        version: response.version
                    });
                } else if (response.type === (0, $fdOBD.AcknowledgementResponseTypes).ERROR) {
                    this.onErrorHandled(response.error);
                    this.sendFailureAnalytics(response, latency);
                    this.emit('commit-status', {
                        status: 'failure',
                        version: version
                    });
                    // eslint-disable-next-line no-console
                    console.error(ADD_STEPS_ACKNOWLEDGEMENT_ERROR_MSG);
                } else {
                    this.analyticsHelper?.sendErrorEvent(// @ts-expect-error We didn't type the invalid type case
                    new Error(`Response type: ${response?.type || 'No response type'}`), ADD_STEPS_ACKNOWLEDGEMENT_ERROR_MSG);
                    this.emit('commit-status', {
                        status: 'failure',
                        version: version
                    });
                    // eslint-disable-next-line no-console
                    console.error(ADD_STEPS_ACKNOWLEDGEMENT_ERROR_MSG);
                }
            });
        } catch (error) {
            // if the broadcast failed for any reason, we shouldn't keep the queue locked as the BE has not recieved any message
            lockSteps();
            this.readyToCommit = true;
            this.analyticsHelper?.sendErrorEvent(error, ADD_STEPS_BROADCAST_ERROR_MSG);
            this.emit('commit-status', {
                status: 'failure',
                version: version
            });
            // eslint-disable-next-line no-console
            console.error(ADD_STEPS_BROADCAST_ERROR_MSG);
        }
    }
    isExpandChangeStep(step) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (step.stepType === 'setAttrs' && '__expanded' in step.attrs) return true;
        return false;
    }
    addOfflineMetadata(stepsWithClientAndUserId, origins) {
        if (origins.some((s)=>s.getMeta('isOffline') === true || s.getMeta('wasOffline') === true)) return stepsWithClientAndUserId.map((step, idx)=>{
            const origin = origins[idx];
            if (!origin) return step;
            const createdOffline = origin.getMeta('isOffline') || origin.getMeta('wasOffline');
            if (createdOffline === true) step.metadata = {
                ...step.metadata,
                createdOffline: createdOffline
            };
            return step;
        });
        return stepsWithClientAndUserId;
    }
    sendSuccessAnalytics(latency, stepsWithClientAndUserId) {
        // Sample only 10% of add steps events to avoid overwhelming the analytics
        if (Math.random() < 0.1) this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).ADD_STEPS, (0, $flwxq.EVENT_STATUS).SUCCESS_10x_SAMPLED, {
            type: (0, $flwxq.ADD_STEPS_TYPE).ACCEPTED,
            latency: latency,
            stepType: (0, (/*@__PURE__*/$parcel$interopDefault($3GH4X)))(stepsWithClientAndUserId, // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (stepWithClientAndUserId)=>stepWithClientAndUserId.stepType)
        });
    }
    sendFailureAnalytics(response, latency) {
        this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).ADD_STEPS, (0, $flwxq.EVENT_STATUS).FAILURE, {
            // User tried committing steps but they were rejected because:
            // - HEAD_VERSION_UPDATE_FAILED: the collab service's latest stored step tail version didn't correspond to the head version of the first step submitted
            // - VERSION_NUMBER_ALREADY_EXISTS: while storing the steps there was a conflict meaning someone else wrote steps into the database more quickly
            type: response.error.data.code === (0, $6Ted9.NCS_ERROR_CODE).HEAD_VERSION_UPDATE_FAILED || response.error.data.code === (0, $6Ted9.NCS_ERROR_CODE).VERSION_NUMBER_ALREADY_EXISTS ? (0, $flwxq.ADD_STEPS_TYPE).REJECTED : (0, $flwxq.ADD_STEPS_TYPE).ERROR,
            latency: latency
        });
        this.analyticsHelper?.sendErrorEvent(response.error, 'Error while adding steps - Acknowledgement Error');
    }
    getReadyToCommitStatus() {
        return this.readyToCommit;
    }
    /**
   * @param broadcast - Callback for broadcasting events to other clients
   * @param analyticsHelper - Helper for analytics events
   * @param emit - Callback for emitting events to listeners on the provider
   * @param onErrorHandled - Callback to handle
   */ constructor(broadcast, analyticsHelper, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    emit, onErrorHandled){
        this.broadcast = broadcast;
        this.analyticsHelper = analyticsHelper;
        this.emit = emit;
        this.onErrorHandled = onErrorHandled;
        this.readyToCommit = void 0;
        this.lastBroadcastRequestAcked = void 0;
        this.readyToCommit = true;
        this.lastBroadcastRequestAcked = true;
    }
}
module.exports["CommitStepService"] = $24a15250db2473e6$export$1507ea63539b16e5;

});

parcelRegister("3GH4X", function(module, exports) {

var $3PAnx = parcelRequire("3PAnx");


var $77wHb = parcelRequire("77wHb");

/** Used for built-in method references. */ var $2af6b5f2fc42996a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2af6b5f2fc42996a$var$hasOwnProperty = $2af6b5f2fc42996a$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $2af6b5f2fc42996a$var$countBy = $77wHb(function(result, value, key) {
    if ($2af6b5f2fc42996a$var$hasOwnProperty.call(result, key)) ++result[key];
    else $3PAnx(result, key, 1);
});
module.exports = $2af6b5f2fc42996a$var$countBy;

});

parcelRegister("77wHb", function(module, exports) {

var $gETEr = parcelRequire("gETEr");


var $bSxMj = parcelRequire("bSxMj");


var $hWvFC = parcelRequire("hWvFC");


var $fZxmY = parcelRequire("fZxmY");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $52f28c800c0dec0e$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $fZxmY(collection) ? $gETEr : $bSxMj, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $hWvFC(iteratee, 2), accumulator);
    };
}
module.exports = $52f28c800c0dec0e$var$createAggregator;

});

parcelRegister("gETEr", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c20b8cf123ccbac3$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $c20b8cf123ccbac3$var$arrayAggregator;

});

parcelRegister("bSxMj", function(module, exports) {

var $iawSg = parcelRequire("iawSg");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $8a5ef07d195ea024$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $iawSg(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $8a5ef07d195ea024$var$baseAggregator;

});

parcelRegister("86Ccb", function(module, exports) {

var $flwxq = parcelRequire("flwxq");


var $4frCv = parcelRequire("4frCv");

const $a77c90d12a129f65$var$logger = (0, $4frCv.createLogger)('Catchupv2', 'red');
const $a77c90d12a129f65$export$f32ba3eea9c226f8 = async (opt)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let steps;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let metadata;
    const fromVersion = opt.getCurrentPmVersion();
    try {
        ({ steps: steps, metadata: metadata } = await opt.fetchCatchupv2(fromVersion, opt.clientId, opt.catchUpOutofSync, opt.reason, opt.sessionId));
    } catch (error) {
        opt.analyticsHelper?.sendErrorEvent(error, 'Error while fetching catchupv2 from server');
        $a77c90d12a129f65$var$logger(`Fetch catchupv2 from server failed:`, error.message);
        throw error;
    }
    try {
        opt.onCatchupComplete?.(steps);
        // skip onStepsAdded if steps are undefined or empty
        if (!steps || steps.length === 0) {
            opt.updateMetadata(metadata);
            return false;
        }
        const version = fromVersion + steps.length;
        const stepsPayload = {
            version: version,
            steps: steps
        };
        opt.onStepsAdded(stepsPayload);
        opt.updateMetadata(metadata);
        const clientOutOfSync = Boolean(opt.clientId && $a77c90d12a129f65$export$f11b7fb226059e83(fromVersion, opt.getCurrentPmVersion(), steps, opt.clientId));
        if (clientOutOfSync) $a77c90d12a129f65$var$logObfuscatedSteps(steps, opt);
        return clientOutOfSync;
    } catch (error) {
        opt.analyticsHelper?.sendErrorEvent(error, 'Failed to apply catchupv2 result in the editor');
        $a77c90d12a129f65$var$logger(`Apply catchupv2 steps failed:`, error.message);
        throw error;
    }
};
const $a77c90d12a129f65$var$logObfuscatedSteps = (steps, opt)=>{
    const state = opt.getState?.();
    opt.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).OUT_OF_SYNC, (0, $flwxq.EVENT_STATUS).FAILURE, {
        obfuscatedSteps: (0, $4frCv.getObfuscatedSteps)(steps),
        obfuscatedDoc: state ? (0, $4frCv.getDocAdfWithObfuscation)(state.doc) : null,
        catchupReason: opt.reason
    });
};
const $a77c90d12a129f65$export$f11b7fb226059e83 = (fromVersion, currentVersion, steps, clientId)=>// If version number hasn't increased, and steps are not from our client, we're out of sync
    Boolean(fromVersion >= currentVersion && steps.some((step)=>step.clientId !== clientId));
module.exports["catchupv2"] = $a77c90d12a129f65$export$f32ba3eea9c226f8;

});

parcelRegister("3QAb4", function(module, exports) {

var $4frCv = parcelRequire("4frCv");

const $00615c02e15b50b9$var$logger = (0, $4frCv.createLogger)('documentService-queue', 'black');
class $00615c02e15b50b9$export$ec73f9ac65128a78 {
    queueSteps(data) {
        $00615c02e15b50b9$var$logger(`Queueing data for version "${data.version}".`);
        const orderedQueue = [
            ...this.queue,
            data
        ].sort((a, b)=>a.version > b.version ? 1 : -1);
        this.queue = orderedQueue;
    }
    constructor(){
        this.queuePaused = false;
        this.queue = [];
        this.getQueue = ()=>{
            return this.queue;
        };
        this.filterQueue = (condition)=>{
            this.queue = this.queue.filter(condition);
        };
        /**
     * Get whether the document service has stopped processing new steps whilst it carries out processes such as catchup.
     * Exposed for testing
     */ this.isPaused = ()=>this.queuePaused;
        this.pauseQueue = ()=>{
            this.queuePaused = true;
        };
        this.resumeQueue = ()=>{
            this.queuePaused = false;
        };
        this.shift = ()=>{
            return this.queue.shift();
        };
    }
}
module.exports["StepQueueState"] = $00615c02e15b50b9$export$ec73f9ac65128a78;

});

parcelRegister("c7fJY", function(module, exports) {

var $6rMOj = parcelRequire("6rMOj");


var $9NwnH = parcelRequire("9NwnH");

const $4989f81e598a2973$var$simplifySteps = (steps)=>{
    return steps.reduce((acc, step)=>{
        const lastStep = acc[acc.length - 1];
        if (lastStep) {
            const mergedStep = lastStep.merge(step);
            if (mergedStep) {
                acc[acc.length - 1] = mergedStep;
                return acc;
            }
        }
        return acc.concat(step);
    }, []);
};
function $4989f81e598a2973$var$findContentChanges(doc, steps) {
    let changes = (0, $6rMOj.ChangeSet).create(doc);
    let latestDoc = doc;
    $4989f81e598a2973$var$simplifySteps(steps).forEach((step, index)=>{
        const stepResult = step.apply(latestDoc);
        if (stepResult.failed !== null || stepResult.doc === null) return;
        latestDoc = stepResult.doc;
        changes = changes.addSteps(latestDoc, [
            step.getMap()
        ], {
            step: index
        });
    });
    return changes;
}
/**
 * Iterate through the changesets to find overlapping regions that indicate conflicting
 * changes
 */ const $4989f81e598a2973$var$getConflicts = ({ localChanges: localChanges, localDoc: localDoc, remoteChanges: remoteChanges, remoteDoc: remoteDoc })=>{
    const conflictingChanges = [];
    localChanges.changes.forEach((localChange)=>{
        remoteChanges.changes.forEach((remoteChange)=>{
            if (// Local change is inside remote change
            localChange.fromA >= remoteChange.fromA && localChange.toA <= remoteChange.toA || // Remote change is inside local change
            remoteChange.fromA >= localChange.fromA && remoteChange.toA <= localChange.toA || // Partial overlap with the end
            localChange.fromA >= remoteChange.fromA && localChange.fromA < remoteChange.toA && localChange.toA > remoteChange.toA || // Partial overlap with the start
            localChange.fromA < remoteChange.fromA && localChange.toA > remoteChange.fromA && localChange.toA <= remoteChange.toA || // One of the edges match
            localChange.fromA === remoteChange.toA || remoteChange.fromA === localChange.toA) {
                const remoteSlice = remoteDoc.slice(remoteChange.fromB, remoteChange.toB);
                const isDeletion = remoteSlice.size === 0;
                conflictingChanges.push({
                    from: Math.min(localChange.fromA, remoteChange.fromA),
                    to: Math.max(localChange.toA, remoteChange.toA),
                    // We only want to capture the exact slice deleted (without parents) so we can display and insert as expected
                    local: localDoc.slice(localChange.fromB, localChange.toB, !isDeletion),
                    remote: remoteSlice
                });
            }
        });
    });
    return conflictingChanges;
};
/**
 * This runs a collab rebase (that is run synchronously after this)
 * and extracts the local doc (before changes), remote doc and the
 * mapping to determine any conflicts.
 * See: `packages/editor/prosemirror-collab/src/index.ts`
 */ const $4989f81e598a2973$var$rebaseSteps = ({ localSteps: localSteps, remoteSteps: remoteSteps, tr: tr })=>{
    const originalMapsLength = tr.mapping.maps?.length;
    const originalDocsLength = tr.docs.length;
    (0, $9NwnH.rebaseSteps)(localSteps, remoteSteps, tr);
    /**
	 * `tr.docs` contains the documents before each change.
	 *
	 * To get "originalDoc" we need to get the document immediately after the local steps are inverted
	 * which is the equal to the number of local steps. If there are no remote steps this will be undefined and
	 * the most current document is appropriate
	 *
	 * To get the "remoteDoc" we need to get the document immediately after the local steps have been inverted
	 * and the remote steps re-applied. If there are no local steps or they are all lost in rebase this will be
	 * undefined and the most current document is appropriate
	 *
	 */ const originalDoc = tr.docs[originalDocsLength + localSteps.length] ?? tr.doc;
    const remoteDoc = tr.docs[originalDocsLength + localSteps.length + remoteSteps.length] ?? tr.doc;
    const mapStart = originalMapsLength + localSteps.length;
    return {
        mapStart: mapStart,
        originalDoc: originalDoc,
        remoteDoc: remoteDoc
    };
};
function $4989f81e598a2973$export$daa1eb0d72f5b266({ localSteps: localSteps, remoteSteps: remoteSteps, tr: tr }) {
    const localDoc = tr.doc;
    const { originalDoc: originalDoc, remoteDoc: remoteDoc, mapStart: mapStart } = $4989f81e598a2973$var$rebaseSteps({
        localSteps: localSteps,
        remoteSteps: remoteSteps,
        tr: tr
    });
    const localChanges = $4989f81e598a2973$var$findContentChanges(originalDoc, localSteps.map((s)=>s.step));
    const remoteChanges = $4989f81e598a2973$var$findContentChanges(originalDoc, remoteSteps);
    // This is the mapping between the original document and our final one which can be used to
    // map conflict positions (which are based on the original doc)
    const mapping = tr.mapping.slice(mapStart);
    // Find the overlapping conflicts - these are based on the positions of the original document so are
    // common to both local and remote documents.
    // The above mapping allows us to bring these positions to where they are in the current document
    const conflictingChanges = $4989f81e598a2973$var$getConflicts({
        localChanges: localChanges,
        localDoc: localDoc,
        remoteDoc: remoteDoc,
        remoteChanges: remoteChanges
    });
    const isConflictChange = (value)=>Boolean(value);
    // Prevent duplicate ranges occuring
    const seenInsertions = new Set();
    return {
        inserted: conflictingChanges.filter((i)=>i.remote.size !== 0).map((i)=>({
                ...i,
                from: mapping.map(i.from, -1),
                to: mapping.map(i.to)
            })).filter((i)=>{
            const identifier = `${i.from}-${i.to}`;
            if (seenInsertions.has(identifier)) return false;
            seenInsertions.add(identifier);
            return isConflictChange(i);
        }),
        deleted: conflictingChanges.filter((d)=>d.remote.size === 0).map((d)=>({
                ...d,
                from: mapping.map(d.from),
                to: mapping.map(d.to)
            })).filter(isConflictChange)
    };
}
module.exports["getConflictChanges"] = $4989f81e598a2973$export$daa1eb0d72f5b266;

});

parcelRegister("6rMOj", function(module, exports) {
// Convert the given range of a fragment to tokens, where node open
// tokens are encoded as strings holding the node name, characters as
// their character code, and node close tokens as -1.
function $4b1b2076c473e44f$var$tokens(frag, start, end, target) {
    for(let i = 0, off = 0; i < frag.childCount; i++){
        let child = frag.child(i), endOff = off + child.nodeSize;
        let from = Math.max(off, start), to = Math.min(endOff, end);
        if (from < to) {
            if (child.isText) for(let j = from; j < to; j++)target.push(child.text.charCodeAt(j - off));
            else if (child.isLeaf) target.push(child.type.name);
            else {
                if (from == off) target.push(child.type.name);
                $4b1b2076c473e44f$var$tokens(child.content, Math.max(off + 1, from) - off - 1, Math.min(endOff - 1, to) - off - 1, target);
                if (to == endOff) target.push(-1);
            }
        }
        off = endOff;
    }
    return target;
}
// The code below will refuse to compute a diff with more than 5000
// insertions or deletions, which takes about 300ms to reach on my
// machine. This is a safeguard against runaway computations.
const $4b1b2076c473e44f$var$MAX_DIFF_SIZE = 5000;
// This obscure mess of constants computes the minimum length of an
// unchanged range (not at the start/end of the compared content). The
// idea is to make it higher in bigger replacements, so that you don't
// get a diff soup of coincidentally identical letters when replacing
// a paragraph.
function $4b1b2076c473e44f$var$minUnchanged(sizeA, sizeB) {
    return Math.min(15, Math.max(2, Math.floor(Math.max(sizeA, sizeB) / 10)));
}
function $4b1b2076c473e44f$var$computeDiff(fragA, fragB, range) {
    let tokA = $4b1b2076c473e44f$var$tokens(fragA, range.fromA, range.toA, []);
    let tokB = $4b1b2076c473e44f$var$tokens(fragB, range.fromB, range.toB, []);
    // Scan from both sides to cheaply eliminate work
    let start = 0, endA = tokA.length, endB = tokB.length;
    while(start < tokA.length && start < tokB.length && tokA[start] === tokB[start])start++;
    if (start == tokA.length && start == tokB.length) return [];
    while(endA > start && endB > start && tokA[endA - 1] === tokB[endB - 1])endA--, endB--;
    // If the result is simple _or_ too big to cheaply compute, return
    // the remaining region as the diff
    if (endA == start || endB == start || endA == endB && endA == start + 1) return [
        range.slice(start, endA, start, endB)
    ];
    // This is an implementation of Myers' diff algorithm
    // See https://neil.fraser.name/writing/diff/myers.pdf and
    // https://blog.jcoglan.com/2017/02/12/the-myers-diff-algorithm-part-1/
    let lenA = endA - start, lenB = endB - start;
    let max = Math.min($4b1b2076c473e44f$var$MAX_DIFF_SIZE, lenA + lenB), off = max + 1;
    let history = [];
    let frontier = [];
    for(let len = off * 2, i = 0; i < len; i++)frontier[i] = -1;
    for(let size = 0; size <= max; size++){
        for(let diag = -size; diag <= size; diag += 2){
            let next = frontier[diag + 1 + max], prev = frontier[diag - 1 + max];
            let x = next < prev ? prev : next + 1, y = x + diag;
            while(x < lenA && y < lenB && tokA[start + x] === tokB[start + y])x++, y++;
            frontier[diag + max] = x;
            // Found a match
            if (x >= lenA && y >= lenB) {
                // Trace back through the history to build up a set of changed ranges.
                let diff = [], minSpan = $4b1b2076c473e44f$var$minUnchanged(endA - start, endB - start);
                // Used to add steps to a diff one at a time, back to front, merging
                // ones that are less than minSpan tokens apart
                let fromA = -1, toA = -1, fromB = -1, toB = -1;
                let add = (fA, tA, fB, tB)=>{
                    if (fromA > -1 && fromA < tA + minSpan) {
                        fromA = fA;
                        fromB = fB;
                    } else {
                        if (fromA > -1) diff.push(range.slice(fromA, toA, fromB, toB));
                        fromA = fA;
                        toA = tA;
                        fromB = fB;
                        toB = tB;
                    }
                };
                for(let i = size - 1; i >= 0; i--){
                    let next = frontier[diag + 1 + max], prev = frontier[diag - 1 + max];
                    if (next < prev) {
                        diag--;
                        x = prev + start;
                        y = x + diag;
                        add(x, x, y, y + 1);
                    } else {
                        diag++;
                        x = next + start;
                        y = x + diag;
                        add(x, x + 1, y, y);
                    }
                    frontier = history[i >> 1];
                }
                if (fromA > -1) diff.push(range.slice(fromA, toA, fromB, toB));
                return diff.reverse();
            }
        }
        // Since only either odd or even diagonals are read from each
        // frontier, we only copy them every other iteration.
        if (size % 2 == 0) history.push(frontier.slice());
    }
    // The loop exited, meaning the maximum amount of work was done.
    // Just return a change spanning the entire range.
    return [
        range.slice(start, endA, start, endB)
    ];
}
/**
Stores metadata for a part of a change.
*/ class $4b1b2076c473e44f$export$5f1714a13ed34c01 {
    /**
    @internal
    */ cut(length) {
        return length == this.length ? this : new $4b1b2076c473e44f$export$5f1714a13ed34c01(length, this.data);
    }
    /**
    @internal
    */ static slice(spans, from, to) {
        if (from == to) return $4b1b2076c473e44f$export$5f1714a13ed34c01.none;
        if (from == 0 && to == $4b1b2076c473e44f$export$5f1714a13ed34c01.len(spans)) return spans;
        let result = [];
        for(let i = 0, off = 0; off < to; i++){
            let span = spans[i], end = off + span.length;
            let overlap = Math.min(to, end) - Math.max(from, off);
            if (overlap > 0) result.push(span.cut(overlap));
            off = end;
        }
        return result;
    }
    /**
    @internal
    */ static join(a, b, combine) {
        if (a.length == 0) return b;
        if (b.length == 0) return a;
        let combined = combine(a[a.length - 1].data, b[0].data);
        if (combined == null) return a.concat(b);
        let result = a.slice(0, a.length - 1);
        result.push(new $4b1b2076c473e44f$export$5f1714a13ed34c01(a[a.length - 1].length + b[0].length, combined));
        for(let i = 1; i < b.length; i++)result.push(b[i]);
        return result;
    }
    /**
    @internal
    */ static len(spans) {
        let len = 0;
        for(let i = 0; i < spans.length; i++)len += spans[i].length;
        return len;
    }
    /**
    @internal
    */ constructor(/**
    The length of this span.
    */ length, /**
    The data associated with this span.
    */ data){
        this.length = length;
        this.data = data;
    }
}
/**
@internal
*/ $4b1b2076c473e44f$export$5f1714a13ed34c01.none = [];
/**
A replaced range with metadata associated with it.
*/ class $4b1b2076c473e44f$export$fb8e829a68c430bd {
    /**
    @internal
    */ get lenA() {
        return this.toA - this.fromA;
    }
    /**
    @internal
    */ get lenB() {
        return this.toB - this.fromB;
    }
    /**
    @internal
    */ slice(startA, endA, startB, endB) {
        if (startA == 0 && startB == 0 && endA == this.toA - this.fromA && endB == this.toB - this.fromB) return this;
        return new $4b1b2076c473e44f$export$fb8e829a68c430bd(this.fromA + startA, this.fromA + endA, this.fromB + startB, this.fromB + endB, $4b1b2076c473e44f$export$5f1714a13ed34c01.slice(this.deleted, startA, endA), $4b1b2076c473e44f$export$5f1714a13ed34c01.slice(this.inserted, startB, endB));
    }
    /**
    This merges two changesets (the end document of x should be the
    start document of y) into a single one spanning the start of x to
    the end of y.
    */ static merge(x, y, combine) {
        if (x.length == 0) return y;
        if (y.length == 0) return x;
        let result = [];
        // Iterate over both sets in parallel, using the middle coordinate
        // system (B in x, A in y) to synchronize.
        for(let iX = 0, iY = 0, curX = x[0], curY = y[0];;){
            if (!curX && !curY) return result;
            else if (curX && (!curY || curX.toB < curY.fromA)) {
                let off = iY ? y[iY - 1].toB - y[iY - 1].toA : 0;
                result.push(off == 0 ? curX : new $4b1b2076c473e44f$export$fb8e829a68c430bd(curX.fromA, curX.toA, curX.fromB + off, curX.toB + off, curX.deleted, curX.inserted));
                curX = iX++ == x.length ? null : x[iX];
            } else if (curY && (!curX || curY.toA < curX.fromB)) {
                let off = iX ? x[iX - 1].toB - x[iX - 1].toA : 0;
                result.push(off == 0 ? curY : new $4b1b2076c473e44f$export$fb8e829a68c430bd(curY.fromA - off, curY.toA - off, curY.fromB, curY.toB, curY.deleted, curY.inserted));
                curY = iY++ == y.length ? null : y[iY];
            } else {
                // The rules for merging ranges are that deletions from the
                // old set and insertions from the new are kept. Areas of the
                // middle document covered by a but not by b are insertions
                // from a that need to be added, and areas covered by b but
                // not a are deletions from b that need to be added.
                let pos = Math.min(curX.fromB, curY.fromA);
                let fromA = Math.min(curX.fromA, curY.fromA - (iX ? x[iX - 1].toB - x[iX - 1].toA : 0)), toA = fromA;
                let fromB = Math.min(curY.fromB, curX.fromB + (iY ? y[iY - 1].toB - y[iY - 1].toA : 0)), toB = fromB;
                let deleted = $4b1b2076c473e44f$export$5f1714a13ed34c01.none, inserted = $4b1b2076c473e44f$export$5f1714a13ed34c01.none;
                // Used to prevent appending ins/del range for the same Change twice
                let enteredX = false, enteredY = false;
                // Need to have an inner loop since any number of further
                // ranges might be touching this group
                for(;;){
                    let nextX = !curX ? 2e8 : pos >= curX.fromB ? curX.toB : curX.fromB;
                    let nextY = !curY ? 2e8 : pos >= curY.fromA ? curY.toA : curY.fromA;
                    let next = Math.min(nextX, nextY);
                    let inX = curX && pos >= curX.fromB, inY = curY && pos >= curY.fromA;
                    if (!inX && !inY) break;
                    if (inX && pos == curX.fromB && !enteredX) {
                        deleted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(deleted, curX.deleted, combine);
                        toA += curX.lenA;
                        enteredX = true;
                    }
                    if (inX && !inY) {
                        inserted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(inserted, $4b1b2076c473e44f$export$5f1714a13ed34c01.slice(curX.inserted, pos - curX.fromB, next - curX.fromB), combine);
                        toB += next - pos;
                    }
                    if (inY && pos == curY.fromA && !enteredY) {
                        inserted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(inserted, curY.inserted, combine);
                        toB += curY.lenB;
                        enteredY = true;
                    }
                    if (inY && !inX) {
                        deleted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(deleted, $4b1b2076c473e44f$export$5f1714a13ed34c01.slice(curY.deleted, pos - curY.fromA, next - curY.fromA), combine);
                        toA += next - pos;
                    }
                    if (inX && next == curX.toB) {
                        curX = iX++ == x.length ? null : x[iX];
                        enteredX = false;
                    }
                    if (inY && next == curY.toA) {
                        curY = iY++ == y.length ? null : y[iY];
                        enteredY = false;
                    }
                    pos = next;
                }
                if (fromA < toA || fromB < toB) result.push(new $4b1b2076c473e44f$export$fb8e829a68c430bd(fromA, toA, fromB, toB, deleted, inserted));
            }
        }
    }
    /**
    @internal
    */ constructor(/**
    The start of the range deleted/replaced in the old document.
    */ fromA, /**
    The end of the range in the old document.
    */ toA, /**
    The start of the range inserted in the new document.
    */ fromB, /**
    The end of the range in the new document.
    */ toB, /**
    Data associated with the deleted content. The length of these
    spans adds up to `this.toA - this.fromA`.
    */ deleted, /**
    Data associated with the inserted content. Length adds up to
    `this.toB - this.toA`.
    */ inserted){
        this.fromA = fromA;
        this.toA = toA;
        this.fromB = fromB;
        this.toB = toB;
        this.deleted = deleted;
        this.inserted = inserted;
    }
}
let $4b1b2076c473e44f$var$letter;
// If the runtime support unicode properties in regexps, that's a good
// source of info on whether something is a letter.
try {
    $4b1b2076c473e44f$var$letter = new RegExp("[\\p{Alphabetic}_]", "u");
} catch (_) {}
// Otherwise, we see if the character changes when upper/lowercased,
// or if it is part of these common single-case scripts.
const $4b1b2076c473e44f$var$nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
function $4b1b2076c473e44f$var$isLetter(code) {
    if (code < 128) return code >= 48 && code <= 57 || code >= 65 && code <= 90 || code >= 79 && code <= 122;
    let ch = String.fromCharCode(code);
    if ($4b1b2076c473e44f$var$letter) return $4b1b2076c473e44f$var$letter.test(ch);
    return ch.toUpperCase() != ch.toLowerCase() || $4b1b2076c473e44f$var$nonASCIISingleCaseWordChar.test(ch);
}
// Convert a range of document into a string, so that we can easily
// access characters at a given position. Treat non-text tokens as
// spaces so that they aren't considered part of a word.
function $4b1b2076c473e44f$var$getText(frag, start, end) {
    let out = "";
    function convert(frag, start, end) {
        for(let i = 0, off = 0; i < frag.childCount; i++){
            let child = frag.child(i), endOff = off + child.nodeSize;
            let from = Math.max(off, start), to = Math.min(endOff, end);
            if (from < to) {
                if (child.isText) out += child.text.slice(Math.max(0, start - off), Math.min(child.text.length, end - off));
                else if (child.isLeaf) out += " ";
                else {
                    if (from == off) out += " ";
                    convert(child.content, Math.max(0, from - off - 1), Math.min(child.content.size, end - off));
                    if (to == endOff) out += " ";
                }
            }
            off = endOff;
        }
    }
    convert(frag, start, end);
    return out;
}
// The distance changes have to be apart for us to not consider them
// candidates for merging.
const $4b1b2076c473e44f$var$MAX_SIMPLIFY_DISTANCE = 30;
/**
Simplifies a set of changes for presentation. This makes the
assumption that having both insertions and deletions within a word
is confusing, and, when such changes occur without a word boundary
between them, they should be expanded to cover the entire set of
words (in the new document) they touch. An exception is made for
single-character replacements.
*/ function $4b1b2076c473e44f$export$eaf5c9077675701a(changes, doc) {
    let result = [];
    for(let i = 0; i < changes.length; i++){
        let end = changes[i].toB, start = i;
        while(i < changes.length - 1 && changes[i + 1].fromB <= end + $4b1b2076c473e44f$var$MAX_SIMPLIFY_DISTANCE)end = changes[++i].toB;
        $4b1b2076c473e44f$var$simplifyAdjacentChanges(changes, start, i + 1, doc, result);
    }
    return result;
}
function $4b1b2076c473e44f$var$simplifyAdjacentChanges(changes, from, to, doc, target) {
    let start = Math.max(0, changes[from].fromB - $4b1b2076c473e44f$var$MAX_SIMPLIFY_DISTANCE);
    let end = Math.min(doc.content.size, changes[to - 1].toB + $4b1b2076c473e44f$var$MAX_SIMPLIFY_DISTANCE);
    let text = $4b1b2076c473e44f$var$getText(doc.content, start, end);
    for(let i = from; i < to; i++){
        let startI = i, last = changes[i], deleted = last.lenA, inserted = last.lenB;
        while(i < to - 1){
            let next = changes[i + 1], boundary = false;
            let prevLetter = last.toB == end ? false : $4b1b2076c473e44f$var$isLetter(text.charCodeAt(last.toB - 1 - start));
            for(let pos = last.toB; !boundary && pos < next.fromB; pos++){
                let nextLetter = pos == end ? false : $4b1b2076c473e44f$var$isLetter(text.charCodeAt(pos - start));
                if ((!prevLetter || !nextLetter) && pos != changes[startI].fromB) boundary = true;
                prevLetter = nextLetter;
            }
            if (boundary) break;
            deleted += next.lenA;
            inserted += next.lenB;
            last = next;
            i++;
        }
        if (inserted > 0 && deleted > 0 && !(inserted == 1 && deleted == 1)) {
            let from = changes[startI].fromB, to = changes[i].toB;
            if (from < end && $4b1b2076c473e44f$var$isLetter(text.charCodeAt(from - start))) while(from > start && $4b1b2076c473e44f$var$isLetter(text.charCodeAt(from - 1 - start)))from--;
            if (to > start && $4b1b2076c473e44f$var$isLetter(text.charCodeAt(to - 1 - start))) while(to < end && $4b1b2076c473e44f$var$isLetter(text.charCodeAt(to - start)))to++;
            let joined = $4b1b2076c473e44f$var$fillChange(changes.slice(startI, i + 1), from, to);
            let last = target.length ? target[target.length - 1] : null;
            if (last && last.toA == joined.fromA) target[target.length - 1] = new $4b1b2076c473e44f$export$fb8e829a68c430bd(last.fromA, joined.toA, last.fromB, joined.toB, last.deleted.concat(joined.deleted), last.inserted.concat(joined.inserted));
            else target.push(joined);
        } else for(let j = startI; j <= i; j++)target.push(changes[j]);
    }
    return changes;
}
function $4b1b2076c473e44f$var$combine(a, b) {
    return a === b ? a : null;
}
function $4b1b2076c473e44f$var$fillChange(changes, fromB, toB) {
    let fromA = changes[0].fromA - (changes[0].fromB - fromB);
    let last = changes[changes.length - 1];
    let toA = last.toA + (toB - last.toB);
    let deleted = $4b1b2076c473e44f$export$5f1714a13ed34c01.none, inserted = $4b1b2076c473e44f$export$5f1714a13ed34c01.none;
    let delData = (changes[0].deleted.length ? changes[0].deleted : changes[0].inserted)[0].data;
    let insData = (changes[0].inserted.length ? changes[0].inserted : changes[0].deleted)[0].data;
    for(let posA = fromA, posB = fromB, i = 0;; i++){
        let next = i == changes.length ? null : changes[i];
        let endA = next ? next.fromA : toA, endB = next ? next.fromB : toB;
        if (endA > posA) deleted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(deleted, [
            new $4b1b2076c473e44f$export$5f1714a13ed34c01(endA - posA, delData)
        ], $4b1b2076c473e44f$var$combine);
        if (endB > posB) inserted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(inserted, [
            new $4b1b2076c473e44f$export$5f1714a13ed34c01(endB - posB, insData)
        ], $4b1b2076c473e44f$var$combine);
        if (!next) break;
        deleted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(deleted, next.deleted, $4b1b2076c473e44f$var$combine);
        inserted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(inserted, next.inserted, $4b1b2076c473e44f$var$combine);
        if (deleted.length) delData = deleted[deleted.length - 1].data;
        if (inserted.length) insData = inserted[inserted.length - 1].data;
        posA = next.toA;
        posB = next.toB;
    }
    return new $4b1b2076c473e44f$export$fb8e829a68c430bd(fromA, toA, fromB, toB, deleted, inserted);
}
/**
A change set tracks the changes to a document from a given point
in the past. It condenses a number of step maps down to a flat
sequence of replacements, and simplifies replacments that
partially undo themselves by comparing their content.
*/ class $4b1b2076c473e44f$export$29d7fbdcb1f8b71c {
    /**
    Computes a new changeset by adding the given step maps and
    metadata (either as an array, per-map, or as a single value to be
    associated with all maps) to the current set. Will not mutate the
    old set.
    
    Note that due to simplification that happens after each add,
    incrementally adding steps might create a different final set
    than adding all those changes at once, since different document
    tokens might be matched during simplification depending on the
    boundaries of the current changed ranges.
    */ addSteps(newDoc, maps, data) {
        // This works by inspecting the position maps for the changes,
        // which indicate what parts of the document were replaced by new
        // content, and the size of that new content. It uses these to
        // build up Change objects.
        //
        // These change objects are put in sets and merged together using
        // Change.merge, giving us the changes created by the new steps.
        // Those changes can then be merged with the existing set of
        // changes.
        //
        // For each change that was touched by the new steps, we recompute
        // a diff to try to minimize the change by dropping matching
        // pieces of the old and new document from the change.
        let stepChanges = [];
        // Add spans for new steps.
        for(let i = 0; i < maps.length; i++){
            let d = Array.isArray(data) ? data[i] : data;
            let off = 0;
            maps[i].forEach((fromA, toA, fromB, toB)=>{
                stepChanges.push(new $4b1b2076c473e44f$export$fb8e829a68c430bd(fromA + off, toA + off, fromB, toB, fromA == toA ? $4b1b2076c473e44f$export$5f1714a13ed34c01.none : [
                    new $4b1b2076c473e44f$export$5f1714a13ed34c01(toA - fromA, d)
                ], fromB == toB ? $4b1b2076c473e44f$export$5f1714a13ed34c01.none : [
                    new $4b1b2076c473e44f$export$5f1714a13ed34c01(toB - fromB, d)
                ]));
                off = toB - fromB - (toA - fromA);
            });
        }
        if (stepChanges.length == 0) return this;
        let newChanges = $4b1b2076c473e44f$var$mergeAll(stepChanges, this.config.combine);
        let changes = $4b1b2076c473e44f$export$fb8e829a68c430bd.merge(this.changes, newChanges, this.config.combine);
        let updated = changes;
        // Minimize changes when possible
        for(let i = 0; i < updated.length; i++){
            let change = updated[i];
            if (change.fromA == change.toA || change.fromB == change.toB || // Only look at changes that touch newly added changed ranges
            !newChanges.some((r)=>r.toB > change.fromB && r.fromB < change.toB)) continue;
            let diff = $4b1b2076c473e44f$var$computeDiff(this.config.doc.content, newDoc.content, change);
            // Fast path: If they are completely different, don't do anything
            if (diff.length == 1 && diff[0].fromB == 0 && diff[0].toB == change.toB - change.fromB) continue;
            if (updated == changes) updated = changes.slice();
            if (diff.length == 1) updated[i] = diff[0];
            else {
                updated.splice(i, 1, ...diff);
                i += diff.length - 1;
            }
        }
        return new $4b1b2076c473e44f$export$29d7fbdcb1f8b71c(this.config, updated);
    }
    /**
    The starting document of the change set.
    */ get startDoc() {
        return this.config.doc;
    }
    /**
    Map the span's data values in the given set through a function
    and construct a new set with the resulting data.
    */ map(f) {
        let mapSpan = (span)=>{
            let newData = f(span);
            return newData === span.data ? span : new $4b1b2076c473e44f$export$5f1714a13ed34c01(span.length, newData);
        };
        return new $4b1b2076c473e44f$export$29d7fbdcb1f8b71c(this.config, this.changes.map((ch)=>{
            return new $4b1b2076c473e44f$export$fb8e829a68c430bd(ch.fromA, ch.toA, ch.fromB, ch.toB, ch.deleted.map(mapSpan), ch.inserted.map(mapSpan));
        }));
    }
    /**
    Compare two changesets and return the range in which they are
    changed, if any. If the document changed between the maps, pass
    the maps for the steps that changed it as second argument, and
    make sure the method is called on the old set and passed the new
    set. The returned positions will be in new document coordinates.
    */ changedRange(b, maps) {
        if (b == this) return null;
        let touched = maps && $4b1b2076c473e44f$var$touchedRange(maps);
        let moved = touched ? touched.toB - touched.fromB - (touched.toA - touched.fromA) : 0;
        function map(p) {
            return !touched || p <= touched.fromA ? p : p + moved;
        }
        let from = touched ? touched.fromB : 2e8, to = touched ? touched.toB : -200000000;
        function add(start, end = start) {
            from = Math.min(start, from);
            to = Math.max(end, to);
        }
        let rA = this.changes, rB = b.changes;
        for(let iA = 0, iB = 0; iA < rA.length && iB < rB.length;){
            let rangeA = rA[iA], rangeB = rB[iB];
            if (rangeA && rangeB && $4b1b2076c473e44f$var$sameRanges(rangeA, rangeB, map)) {
                iA++;
                iB++;
            } else if (rangeB && (!rangeA || map(rangeA.fromB) >= rangeB.fromB)) {
                add(rangeB.fromB, rangeB.toB);
                iB++;
            } else {
                add(map(rangeA.fromB), map(rangeA.toB));
                iA++;
            }
        }
        return from <= to ? {
            from: from,
            to: to
        } : null;
    }
    /**
    Create a changeset with the given base object and configuration.
    The `combine` function is used to compare and combine metadata—it
    should return null when metadata isn't compatible, and a combined
    version for a merged range when it is.
    */ static create(doc, combine = (a, b)=>a === b ? a : null) {
        return new $4b1b2076c473e44f$export$29d7fbdcb1f8b71c({
            combine: combine,
            doc: doc
        }, []);
    }
    /**
    @internal
    */ constructor(/**
    @internal
    */ config, /**
    Replaced regions.
    */ changes){
        this.config = config;
        this.changes = changes;
    }
}
/**
Exported for testing @internal
*/ $4b1b2076c473e44f$export$29d7fbdcb1f8b71c.computeDiff = $4b1b2076c473e44f$var$computeDiff;
// Divide-and-conquer approach to merging a series of ranges.
function $4b1b2076c473e44f$var$mergeAll(ranges, combine, start = 0, end = ranges.length) {
    if (end == start + 1) return [
        ranges[start]
    ];
    let mid = start + end >> 1;
    return $4b1b2076c473e44f$export$fb8e829a68c430bd.merge($4b1b2076c473e44f$var$mergeAll(ranges, combine, start, mid), $4b1b2076c473e44f$var$mergeAll(ranges, combine, mid, end), combine);
}
function $4b1b2076c473e44f$var$endRange(maps) {
    let from = 2e8, to = -200000000;
    for(let i = 0; i < maps.length; i++){
        let map = maps[i];
        if (from != 2e8) {
            from = map.map(from, -1);
            to = map.map(to, 1);
        }
        map.forEach((_s, _e, start, end)=>{
            from = Math.min(from, start);
            to = Math.max(to, end);
        });
    }
    return from == 2e8 ? null : {
        from: from,
        to: to
    };
}
function $4b1b2076c473e44f$var$touchedRange(maps) {
    let b = $4b1b2076c473e44f$var$endRange(maps);
    if (!b) return null;
    let a = $4b1b2076c473e44f$var$endRange(maps.map((m)=>m.invert()).reverse());
    return {
        fromA: a.from,
        toA: a.to,
        fromB: b.from,
        toB: b.to
    };
}
function $4b1b2076c473e44f$var$sameRanges(a, b, map) {
    return map(a.fromB) == b.fromB && map(a.toB) == b.toB && $4b1b2076c473e44f$var$sameSpans(a.deleted, b.deleted) && $4b1b2076c473e44f$var$sameSpans(a.inserted, b.inserted);
}
function $4b1b2076c473e44f$var$sameSpans(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (a[i].length != b[i].length || a[i].data !== b[i].data) return false;
    return true;
}
module.exports["simplifyChanges"] = $4b1b2076c473e44f$export$eaf5c9077675701a;
module.exports["ChangeSet"] = $4b1b2076c473e44f$export$29d7fbdcb1f8b71c;

});

parcelRegister("bxMv2", function(module, exports) {
class $a01622ae08ff8e07$export$e38ee16b142fca71 {
    updateDocument() {}
    onRestore() {}
    onStepsAdded() {}
    onStepRejectedError() {}
    send() {}
    sendStepsFromCurrentState() {}
    throttledCatchupv2() {}
    getCurrentState() {
        return Promise.resolve({});
    }
    getFinalAcknowledgedState(reason) {
        return Promise.resolve({});
    }
    getIsNamespaceLocked() {
        return false;
    }
    getUnconfirmedSteps() {
        return undefined;
    }
    getUnconfirmedStepsOrigins() {
        return undefined;
    }
    getCurrentPmVersion() {
        return -1;
    }
    constructor(){
        this.setup = ()=>{
            return this;
        };
        this.onErrorHandled = ()=>{};
    }
}
module.exports["NullDocumentService"] = $a01622ae08ff8e07$export$e38ee16b142fca71;

});

parcelRegister("eSqCh", function(module, exports) {

var $4frCv = parcelRequire("4frCv");

const $da3d455a97c05426$var$logger = (0, $4frCv.createLogger)('Provider', 'orange');
class $da3d455a97c05426$export$a3879ef7b3971bae {
    constructor(isNamespaceLocked = false){
        this.isNamespaceLocked = isNamespaceLocked;
        // Primitive values are always copied
        this.getIsNamespaceLocked = ()=>this.isNamespaceLocked;
        /**
     * ESS-2916 namespace status event- lock/unlock
     */ // Ignored via go/ees005
        // eslint-disable-next-line require-await
        this.onNamespaceStatusChanged = async ({ isLocked: isLocked, waitTimeInMs: waitTimeInMs, timestamp: timestamp })=>{
            const start = Date.now();
            $da3d455a97c05426$var$logger(`Received a namespace status changed event `, {
                isLocked: isLocked,
                waitTimeInMs: waitTimeInMs,
                timestamp: timestamp
            });
            if (isLocked && waitTimeInMs) {
                this.isNamespaceLocked = true;
                $da3d455a97c05426$var$logger(`Received a namespace status change event `, {
                    isLocked: isLocked
                });
                // To protect the collab editing process from locked out due to BE
                setTimeout(()=>{
                    $da3d455a97c05426$var$logger(`The namespace lock has expired`, {
                        waitTime: Date.now() - start,
                        timestamp: timestamp
                    });
                    this.isNamespaceLocked = false;
                }, waitTimeInMs);
                return;
            }
            this.isNamespaceLocked = false;
            $da3d455a97c05426$var$logger(`The page lock has expired`);
        };
    }
}
module.exports["NamespaceService"] = $da3d455a97c05426$export$a3879ef7b3971bae;

});

parcelRegister("pyHw9", function(module, exports) {

var $7W8Hz = parcelRequire("7W8Hz");


var $flwxq = parcelRequire("flwxq");


var $gVzjB = parcelRequire("gVzjB");


var $8Gmho = parcelRequire("8Gmho");


var $fFg2r = parcelRequire("fFg2r");


var $4frCv = parcelRequire("4frCv");

const $702978599b8486be$var$logger = (0, $4frCv.createLogger)('PresenceService', 'pink');
const $702978599b8486be$var$SEND_PRESENCE_INTERVAL = 150000; // 150 seconds
const $702978599b8486be$var$DEFAULT_FETCH_USERS_INTERVAL = 500; // 0.5 second
const $702978599b8486be$var$UNIDENTIFIED = 'unidentified';
const $702978599b8486be$export$b293c70097dddf3c = 'single';
const $702978599b8486be$export$e39d952916d6fd50 = 'collab';
class $702978599b8486be$export$b15b55f2d386264 {
    /**
   * Called on receiving steps, emits each step's telepointer
   * @param steps Steps to extract telepointers from
   * @example
   */ emitTelepointersFromSteps(steps) {
        steps.forEach((step)=>{
            const event = (0, $gVzjB.telepointerFromStep)(this.participantsState.getParticipants(), step);
            if (event) this.emitTelepointer(event, 'emitting telepointers from steps');
        });
    }
    /**
   * Wrapper function to emit with error handling and analytics
   * @param data Data to emit
   * @param errorMessage Error message for analytics
   * @example
   */ emitPresenceActivityChange(data, errorMessage) {
        try {
            this.emit('presence:changed', data);
        } catch (error) {
            // We don't want to throw errors for Presence features as they tend to self-restore
            this.analyticsHelper?.sendErrorEvent(error, `Error while ${errorMessage}`);
        }
    }
    /**
   * constructor
   *
   * @param analyticsHelper
   * @param participantsState
   * @param emit
   * @param getUser
   * @param batchProps
   * @param channelBroadcast
   * @param sendPresenceJoined
   * @param getPresenceData
   * @param setUserId
   * @param getAIProviderActiveIds
   * @param fetchAnonymousAsset
   * @example
   */ constructor(analyticsHelper, participantsState = new (0, $fFg2r.ParticipantsState)(), emit, getUser, batchProps, channelBroadcast, sendPresenceJoined, getPresenceData, setUserId, getAIProviderActiveIds, fetchAnonymousAsset){
        this.analyticsHelper = analyticsHelper;
        this.participantsState = participantsState;
        this.emit = emit;
        this.getUser = getUser;
        this.batchProps = batchProps;
        this.channelBroadcast = channelBroadcast;
        this.sendPresenceJoined = sendPresenceJoined;
        this.getPresenceData = getPresenceData;
        this.setUserId = setUserId;
        this.getAIProviderActiveIds = getAIProviderActiveIds;
        this.fetchAnonymousAsset = fetchAnonymousAsset;
        this.participantUpdateTimeout = void 0;
        this.presenceUpdateTimeout = void 0;
        this.presenceFetchTimeout = void 0;
        this.currentlyPollingFetchUsers = true;
        this.hasBatchFetchError = false;
        this.sendPresenceActivityChanged = ()=>{
            this.sendPresence();
        };
        this.sendAIProviderChanged = (payload)=>{
            if (payload.providerId) {
                for(const propKey in payload.permit)if (payload.permit.hasOwnProperty(propKey)) payload.permit[propKey] = false;
                const presencePayload = this.buildAIProviderPresencePayload(payload.providerId);
                if (payload.action === 'add') this.sendAIProviderParticipantUpdated(presencePayload);
                else if (payload.action === 'remove') this.sendAIProviderParticipantLeft(presencePayload);
            }
        };
        this.buildAIProviderPresencePayload = (providerId)=>{
            const defaultPresenceData = this.getPresenceData();
            const presencePayload = {
                sessionId: `${providerId}::${defaultPresenceData.sessionId}`,
                userId: providerId,
                clientId: `${providerId}::${defaultPresenceData.clientId}`,
                permit: {
                    isPermittedToComment: false,
                    isPermittedToEdit: false,
                    isPermittedToView: false
                },
                timestamp: Date.now()
            };
            return presencePayload;
        };
        this.sendAIProviderParticipantUpdated = (payload)=>{
            this.channelBroadcast('participant:updated', payload);
        };
        this.sendAIProviderParticipantLeft = (payload)=>{
            this.channelBroadcast('participant:left', payload);
        };
        // Refresh current AI providers
        this.sendAIProvidersPresence = ()=>{
            if (this.getAIProviderActiveIds) this.getAIProviderActiveIds().forEach((aiProviderId)=>{
                const presenceData = this.buildAIProviderPresencePayload(aiProviderId);
                this.sendAIProviderParticipantUpdated(presenceData);
            });
        };
        this.hasPresenceActivityChanged = (previous, current)=>{
            return previous.presenceActivity !== current.presenceActivity;
        };
        this.handleAnonymousUser = async (payload)=>{
            const { sessionId: sessionId } = payload;
            const previousParticipant = this.participantsState.getBySessionId(sessionId);
            let asset;
            let name = previousParticipant?.name ?? '';
            if (!previousParticipant && this.fetchAnonymousAsset) {
                try {
                    asset = await this.fetchAnonymousAsset(payload.presenceId);
                } catch (error) {
                    this.analyticsHelper?.sendErrorEvent(error, 'Error while fetching anonymous assets');
                }
                name = asset?.name ?? name;
            }
            const participant = {
                ...payload,
                lastActive: payload.timestamp,
                name: name,
                avatar: previousParticipant?.avatar ?? asset?.src ?? '',
                email: '',
                userId: $702978599b8486be$var$UNIDENTIFIED,
                isHydrated: true
            };
            this.participantsState.setBySessionId(sessionId, participant);
            this.emitPresence({
                joined: [
                    participant
                ]
            }, 'handling updated anonymous participant');
        };
        /**
     * Carries out 3 things: 1) enriches the participant with user data, 2) updates the participantsState, 3) emits the presence event
     * @param payload Payload from incoming socket event
     * @example
     */ this.updateParticipantEager = async (payload)=>{
            const { userId: userId } = payload;
            if (!userId || userId === $702978599b8486be$var$UNIDENTIFIED) {
                await this.handleAnonymousUser(payload);
                return;
            }
            let participant;
            // getUser is a failable callback, hence try-catch
            try {
                participant = await (0, $8Gmho.createParticipantFromPayload)(// userId _must_ be defined, this lets the compiler know
                {
                    ...payload,
                    userId: userId
                }, this.getUser);
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, 'Error while enriching participant');
            }
            if (!participant) return;
            const previousParticipant = this.participantsState.getBySessionId(participant.sessionId);
            this.participantsState.setBySessionId(participant.sessionId, participant);
            if (previousParticipant) {
                if (this.hasPresenceActivityChanged(previousParticipant, participant)) this.emitPresenceActivityChange({
                    type: 'participant:activity',
                    activity: participant.presenceActivity
                }, 'handling participant activity changed event');
                return;
            }
            // Only emit the joined presence event if this is a new participant
            this.emitPresence({
                joined: [
                    participant
                ]
            }, 'handling participant updated event');
        };
        /**
     * Will update participant state without attempting to hydrate the participant, which is handled in {@link #batchFetchUsers}
     * Here's the TLDR of what this method handles
     *
     * 1. If participant that joined is anonymous, update state, emit event and return
     * 2. If incoming participant is new, update state and emit event
     * 3. If incoming participant is not new, update previous state with new values (timestamp, activity)
     *
     * @param payload Payload from incoming socket event
     * @example
     */ this.updateParticipantLazy = async (payload)=>{
            const { userId: userId, sessionId: sessionId } = payload;
            // anonymous users always skip hydration but are marked as hydrated since we don't want to attempt to fetch data
            // this can cause interesting behavior if batchProps.participantsLimit exists
            // for example if limit = 5 and we've hydrated 5 real users and 2 anonymous users join, it'll look like we've hydrated 7 users
            if (!userId || userId === $702978599b8486be$var$UNIDENTIFIED) {
                await this.handleAnonymousUser(payload);
                return;
            }
            const previousParticipant = this.participantsState.getBySessionId(sessionId);
            if (!previousParticipant) {
                const participant = {
                    ...payload,
                    lastActive: payload.timestamp,
                    name: '',
                    avatar: '',
                    email: '',
                    userId: userId
                };
                this.participantsState.setBySessionId(sessionId, participant);
                if ((0, $4frCv.isAIProviderID)(userId)) {
                    this.emitPresence({
                        joined: [
                            participant
                        ]
                    }, 'handling updated new agent lazy');
                    return;
                }
                // prevent running multiple debounces concurrently
                if (!this.currentlyPollingFetchUsers) this.batchFetchUsers();
                // while this doesn't completely eliminate extra events from firing, it does help reduce it.
                // batchFetchUsers will always emitPresence when no participantsLimit is present;
                // however, if the limit has been reached, we need to ensure we emit the joined participants
                // current alternatives to this logic would add even more complexity
                if (this.batchProps?.participantsLimit) this.emitPresence({
                    joined: [
                        participant
                    ]
                }, 'handling updated new participant lazy');
                return;
            }
            // would handle activity and lastActive changes
            const participant = {
                ...previousParticipant,
                presenceActivity: payload.presenceActivity,
                lastActive: payload.timestamp
            };
            if (this.hasPresenceActivityChanged(previousParticipant, participant)) {
                this.participantsState.setBySessionId(sessionId, participant);
                this.emitPresenceActivityChange({
                    type: 'participant:activity',
                    activity: participant.presenceActivity
                }, 'handling participant activity changed event');
            }
            return;
        };
        this.onParticipantUpdated = async (payload)=>{
            if (this.batchProps) this.updateParticipantLazy(payload);
            else await this.updateParticipantEager(payload);
        };
        /**
     * Called when a participant leaves the session.
     * We emit the `presence` event to update the active avatars in the editor.
     * @param payload
     * @example
     */ this.onParticipantLeft = (payload)=>{
            let sessionId = payload.sessionId;
            // When an agent leaves a session, the backend service returns the original user's
            // session ID accompanied by a payload containing the agent's session ID.
            // If the user session leaves, we also want to remove all agent sessions associated.
            if (payload?.data?.sessionId && (0, $4frCv.isAIProviderID)(payload.data.sessionId)) sessionId = payload.data.sessionId;
            else {
                const associatedAgents = this.getAIProviderParticipants().filter((ap)=>ap.sessionId.endsWith(sessionId));
                associatedAgents.forEach((agent)=>{
                    this.onParticipantLeft({
                        sessionId: sessionId,
                        timestamp: payload.timestamp,
                        data: agent,
                        userId: undefined,
                        clientId: ''
                    });
                });
            }
            this.participantsState.removeBySessionId(sessionId);
            this.emitPresence({
                left: [
                    {
                        sessionId: sessionId
                    }
                ]
            }, 'participant leaving');
        };
        this.disconnect = (reason, sessionId)=>{
            const left = this.participantsState.getParticipants();
            this.participantsState.clear();
            try {
                this.emit('disconnected', {
                    reason: (0, $7W8Hz.disconnectedReasonMapper)(reason),
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    sid: sessionId
                });
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, 'Error while emitting disconnected data');
            }
            if (left.length) this.emitPresence({
                left: left
            }, 'emitting presence update on disconnect');
        };
        /**
     * Updates when users were last active
     * @param userIds Users in most recent steps
     * @example
     */ this.updateLastActive = (userIds = [])=>this.participantsState.updateLastActive(Date.now(), userIds);
        /**
     * Called when we receive a telepointer update from another
     * participant.
     * @param payload
     * @param thisSessionId
     * @example
     */ this.onParticipantTelepointer = (payload, thisSessionId)=>{
            const { sessionId: sessionId, selection: selection, timestamp: timestamp } = payload;
            const participant = this.participantsState.getBySessionId(sessionId);
            if (sessionId === thisSessionId || // Ignore old telepointer events
            participant && participant.lastActive > timestamp) return;
            const userId = payload.userId ? [
                payload.userId
            ] : undefined;
            // Set last active
            this.updateLastActive(userId);
            this.emitTelepointer({
                type: 'telepointer',
                selection: selection,
                sessionId: sessionId
            }, 'handling participant telepointer event');
        };
        /**
     * Every 5 minutes (PARTICIPANT_UPDATE_INTERVAL), removes inactive participants and emits the update to other participants.
     * Needs to be kicked off in the Provider.
     * @param sessionId SessionId from provider's connection
     * @example
     */ this.startInactiveRemover = (sessionId)=>{
            clearTimeout(this.participantUpdateTimeout);
            try {
                this.filterInactive(sessionId);
            } catch (err) {
                this.analyticsHelper?.sendErrorEvent(err, 'Failed filtering inactive participants');
            }
            this.participantUpdateTimeout = window.setTimeout(()=>this.startInactiveRemover(sessionId), (0, $8Gmho.PARTICIPANT_UPDATE_INTERVAL));
        };
        this.enrichParticipants = async (props)=>{
            try {
                const participants = await (0, $8Gmho.fetchParticipants)(this.participantsState, props);
                if (participants.length) this.emitPresence({
                    joined: participants
                }, 'handling participant updated event');
            } catch (err) {
                props.onError?.(err);
                this.hasBatchFetchError = true;
                this.analyticsHelper?.sendErrorEvent(err, 'Failed while fetching participants');
            }
        };
        /**
     * a debounce so we can wait until participants join before hydrating the user and perform batch calls in a timely manner.
     *
     * if {@link BatchProps#participantsLimit} is supplied
     *  1. Fetch users until we've reached the participantsLimit
     *  2. If there are no more participants to hydrate and we haven't reached the participantsLimit, stop polling
     *  3. If we've reached our participantLimit, stop polling
     *
     * if no {@link BatchProps#participantsLimit} is supplied
     *  1. Fetch users until there are no more participants to hydrate
     * @example
     */ this.batchFetchUsers = async ()=>{
            if (!this.batchProps) return;
            if (this.hasBatchFetchError) {
                // no retry logic yet
                $702978599b8486be$var$logger('Cannot continue to fetch users due to fetch error');
                clearTimeout(this.presenceFetchTimeout);
                return;
            }
            this.currentlyPollingFetchUsers = true;
            clearTimeout(this.presenceFetchTimeout);
            const { debounceTime: debounceTime, participantsLimit: participantsLimit } = this.batchProps;
            if (participantsLimit) {
                const size = this.participantsState.getUniqueParticipants({
                    isHydrated: true
                }).length;
                if (size < participantsLimit) {
                    await this.enrichParticipants({
                        ...this.batchProps,
                        batchSize: participantsLimit
                    });
                    this.currentlyPollingFetchUsers = this.participantsState.hasMoreParticipantsToHydrate();
                } else this.currentlyPollingFetchUsers = false;
            } else if (!participantsLimit) {
                await this.enrichParticipants(this.batchProps);
                this.currentlyPollingFetchUsers = this.participantsState.hasMoreParticipantsToHydrate();
            }
            if (this.currentlyPollingFetchUsers) this.presenceFetchTimeout = window.setTimeout(()=>this.batchFetchUsers(), debounceTime ?? $702978599b8486be$var$DEFAULT_FETCH_USERS_INTERVAL);
        };
        /**
     * We want to give some time for users to initially join before attempting to fetch users
     * otherwise we'll always make at least 2 calls if there's more than 1 participant
     * @example
     */ this.initializeFirstBatchFetchUsers = async ()=>{
            await new Promise((r)=>window.setTimeout(r, this.batchProps?.debounceTime ?? $702978599b8486be$var$DEFAULT_FETCH_USERS_INTERVAL));
            this.batchFetchUsers();
        };
        /**
     * Keep list of participants up to date. Filter out inactive users etc.
     * @param sessionId
     * @example
     */ this.filterInactive = (sessionId)=>{
            const now = Date.now();
            const left = this.participantsState.getParticipants().filter((p)=>p.sessionId !== sessionId && now - p.lastActive > (0, $8Gmho.PARTICIPANT_UPDATE_INTERVAL));
            left.forEach((p)=>this.participantsState.removeBySessionId(p.sessionId));
            left.length && this.emitPresence({
                left: left
            }, 'filtering inactive participants');
        };
        /**
     * Wrapper function to emit with error handling and analytics
     * @param data Data to emit
     * @param emit Emit function from Provider
     * @param errorMessage
     * @example
     */ this.emitPresence = (data, errorMessage)=>{
            try {
                this.emit('presence', data);
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).UPDATE_PARTICIPANTS, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                    participants: this.participantsState.size()
                });
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, `Error while ${errorMessage}`);
            }
        };
        /**
     * Wrapper function to emit with error handling and analytics
     * @param data Data to emit
     * @param emit Emit function from Provider
     * @param errorMessage
     * @example
     */ this.emitTelepointer = (data, errorMessage)=>{
            try {
                this.emit('telepointer', data);
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, `Error while ${errorMessage}`);
            }
        };
        /**
     * Used when the provider is disconnected or destroyed to prevent perpetual timers from continuously running
     * @example
     */ this.clearTimers = ()=>{
            clearTimeout(this.participantUpdateTimeout);
            clearTimeout(this.presenceFetchTimeout);
        };
        this.sendPresence = ()=>{
            try {
                clearTimeout(this.presenceUpdateTimeout);
                const data = this.getPresenceData();
                this.channelBroadcast('participant:updated', data);
                this.presenceUpdateTimeout = window.setTimeout(()=>this.sendPresence(), $702978599b8486be$var$SEND_PRESENCE_INTERVAL);
                // Expose existing AI providers to the newly joined user
                this.sendAIProvidersPresence();
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, 'Error while sending presence');
            }
        };
        /**
     * Called when a participant joins the session.
     *
     * We keep track of participants internally, and emit the `presence` event to update
     * the active avatars in the editor.
     * This method will be triggered from backend to notify all participants to exchange presence
     * @param payload
     * @example
     */ this.onPresenceJoined = (payload)=>{
            try {
                $702978599b8486be$var$logger('Participant joined with session: ', payload.sessionId);
                // This expose existing users to the newly joined user
                this.sendPresence();
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, 'Error while joining presence');
            }
        };
        /**
     * Called when the current user joins the session.
     *
     * This will send both a 'presence' event and a 'participant:updated' event.
     * This updates both the avatars and the participants list.
     * @param payload
     * @example
     */ this.onPresence = (payload)=>{
            try {
                $702978599b8486be$var$logger('onPresence userId: ', payload.userId);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.setUserId(payload.userId);
                this.sendPresence();
                this.sendPresenceJoined();
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, 'Error while receiving presence');
            }
        };
        this.getParticipants = ()=>{
            return this.participantsState.getParticipants();
        };
        this.getUniqueParticipantSize = ()=>{
            return this.participantsState.getUniqueParticipantSize();
        };
        this.getUniqueParticipants = (filter)=>{
            return this.participantsState.getUniqueParticipants(filter);
        };
        this.getAIProviderParticipants = ()=>{
            return this.participantsState.getAIProviderParticipants();
        };
        this.getCollabMode = ()=>{
            return this.participantsState.size() > 1 ? $702978599b8486be$export$e39d952916d6fd50 : $702978599b8486be$export$b293c70097dddf3c;
        };
    }
}
module.exports["ParticipantsService"] = $702978599b8486be$export$b15b55f2d386264;

});

parcelRegister("8Gmho", function(module, exports) {
const $0320d5ed697c9c23$export$488470c175a39c99 = 300000; // 300 seconds
const $0320d5ed697c9c23$var$DEFAULT_BATCH_FETCH_SIZE = 25;
const $0320d5ed697c9c23$export$8c7e237b2e82904f = async (// userId must be defined, unlike in PresencePayload
payload, getUser)=>{
    const { sessionId: sessionId, timestamp: timestamp, clientId: clientId, userId: userId, permit: permit, presenceId: presenceId, presenceActivity: presenceActivity } = payload;
    const user = await getUser?.(userId);
    const participant = {
        name: user?.name || '',
        avatar: user?.avatar || '',
        email: user?.email || '',
        sessionId: sessionId,
        lastActive: timestamp,
        userId: userId,
        clientId: clientId,
        permit: permit,
        isGuest: user?.isGuest,
        presenceId: presenceId,
        presenceActivity: presenceActivity,
        isHydrated: !!user
    };
    return participant;
};
const $0320d5ed697c9c23$export$f481f329110b897f = async (participantsState, batchProps)=>{
    const { batchSize: batchSize = $0320d5ed697c9c23$var$DEFAULT_BATCH_FETCH_SIZE, getUsers: getUsers } = batchProps;
    const participantsToHydrate = participantsState.getUniqueParticipants({
        isHydrated: false
    });
    const participants = participantsToHydrate.splice(0, batchSize);
    if (!participants.length) return [];
    const aaids = new Set();
    participants.forEach((p)=>{
        aaids.add(p.userId);
    });
    const users = await getUsers?.([
        ...aaids.values()
    ]);
    const hydratedParticipants = [];
    users?.forEach((user)=>{
        // find all sessions of the user we just hydrated and populate data
        participantsState.getParticipants().filter((p)=>p.userId === user.userId).forEach((participant)=>{
            const { sessionId: sessionId } = participant;
            const hydratedParticipant = {
                name: user.name,
                avatar: user.avatar,
                email: user.email,
                userId: user.userId,
                isGuest: user.isGuest,
                sessionId: sessionId,
                lastActive: participant.lastActive,
                clientId: participant.clientId,
                permit: participant.permit,
                presenceId: participant.presenceId,
                presenceActivity: participant.presenceActivity,
                isHydrated: true
            };
            participantsState.setBySessionId(sessionId, hydratedParticipant);
            hydratedParticipants.push(hydratedParticipant);
        });
    });
    return hydratedParticipants;
};
module.exports["PARTICIPANT_UPDATE_INTERVAL"] = $0320d5ed697c9c23$export$488470c175a39c99;
module.exports["createParticipantFromPayload"] = $0320d5ed697c9c23$export$8c7e237b2e82904f;
module.exports["fetchParticipants"] = $0320d5ed697c9c23$export$f481f329110b897f;

});

parcelRegister("fFg2r", function(module, exports) {

var $4frCv = parcelRequire("4frCv");

class $d1e24f6ec89df86f$export$a4f3536b6f975d50 {
    constructor(baseParticipants = new Map()){
        this.participants = void 0;
        this.getBySessionId = (sessionId)=>{
            const participant = this.participants.get(sessionId);
            // Spread to ensure we get a deep copy
            return participant ? {
                ...participant
            } : undefined;
        };
        this.setBySessionId = (sessionId, participant)=>{
            this.participants.set(sessionId, participant);
        };
        this.getParticipants = ()=>// Spread to get deep copy
            [
                ...this.participants.values()
            ].filter((p)=>!(0, $4frCv.isAIProviderID)(p.userId)).map((p)=>({
                    ...p
                }));
        this.getAIProviderParticipants = ()=>// Spread to get deep copy
            [
                ...this.participants.values()
            ].filter((p)=>(0, $4frCv.isAIProviderID)(p.userId)).map((p)=>({
                    ...p
                }));
        /**
     * A user may contain multiple sessions, only return the unique users based on aaid.
     * If multiple participants with same aaid exist, will return the most recent entry
     * @param filter additional filter to narrow down results
     * @param filter.isHydrated
     */ this.getUniqueParticipants = ({ isHydrated: isHydrated = false })=>{
            const uniqueParticipants = new Map();
            const participants = this.getParticipants();
            participants.forEach((p)=>{
                if (!!p.isHydrated === isHydrated) {
                    const previous = uniqueParticipants.get(p.userId);
                    uniqueParticipants.set(p.userId, previous ? {
                        ...previous,
                        lastActive: p.lastActive,
                        sessionId: p.sessionId,
                        presenceActivity: p.presenceActivity
                    } : p);
                }
            });
            return [
                ...uniqueParticipants.values()
            ];
        };
        this.hasMoreParticipantsToHydrate = ()=>{
            return this.getUniqueParticipants({
                isHydrated: false
            }).length > 0;
        };
        this.removeBySessionId = (sessionId)=>this.participants.delete(sessionId);
        this.clear = ()=>this.participants.clear();
        this.doesntHave = (sessionId)=>!this.participants.has(sessionId);
        this.size = ()=>this.participants.size;
        this.getUniqueParticipantSize = ()=>{
            const result = new Set();
            this.getParticipants().forEach((p)=>result.add(p.userId));
            return result.size;
        };
        // If userId of participant in userIds, set lastActive to now
        this.updateLastActive = (now, userIds)=>this.participants.forEach((p)=>{
                p.lastActive = userIds.includes(p.userId) ? now : p.lastActive;
            });
        this.participants = baseParticipants;
    }
}
module.exports["ParticipantsState"] = $d1e24f6ec89df86f$export$a4f3536b6f975d50;

});

parcelRegister("8NlH6", function(module, exports) {

var $6Ted9 = parcelRequire("6Ted9");


var $6MIiQ = parcelRequire("6MIiQ");


var $h3X17 = parcelRequire("h3X17");

const $91627c828403cd19$export$b222f35b2c811336 = (error)=>{
    switch(error.data?.code){
        case (0, $6Ted9.NCS_ERROR_CODE).HEAD_VERSION_UPDATE_FAILED:
        case (0, $6Ted9.NCS_ERROR_CODE).VERSION_NUMBER_ALREADY_EXISTS:
            // This should never be called with these errors
            return;
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).ADD_STEPS_ERROR:
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).RECONNECTION_ERROR:
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).CONNECTION_ERROR:
            // These errors shouldn't be emitted, we're hoping the provider self-recovers over time
            return;
        case (0, $6Ted9.NCS_ERROR_CODE).INSUFFICIENT_EDITING_PERMISSION:
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).TOKEN_PERMISSION_ERROR:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).NO_PERMISSION_ERROR,
                message: 'User does not have permissions to access this document or document is not found',
                reason: error.data.meta.reason,
                recoverable: true,
                status: 403
            };
        case (0, $6Ted9.NCS_ERROR_CODE).FORBIDDEN_USER_TOKEN:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).INVALID_USER_TOKEN,
                message: 'The user token was invalid',
                recoverable: true,
                status: 403
            };
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).DOCUMENT_NOT_FOUND:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).DOCUMENT_NOT_FOUND,
                message: 'The requested document is not found',
                recoverable: true,
                status: 404
            };
        case (0, $6Ted9.NCS_ERROR_CODE).TENANT_INSTANCE_MAINTENANCE:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).LOCKED,
                message: 'The document is currently not available, please try again later',
                recoverable: true,
                status: 423
            };
        case (0, $6Ted9.NCS_ERROR_CODE).LOCKED_DOCUMENT:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).LOCKED,
                message: 'The document is currently not available, please try again later',
                recoverable: true
            };
        case (0, $6Ted9.NCS_ERROR_CODE).DYNAMO_ERROR:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).FAIL_TO_SAVE,
                message: 'Collab service is not able to save changes',
                recoverable: false,
                status: 500
            };
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).DOCUMENT_RESTORE_ERROR:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).DOCUMENT_RESTORE_ERROR,
                message: 'Collab service unable to restore document',
                recoverable: false,
                status: 500
            };
        case (0, $6Ted9.NCS_ERROR_CODE).INIT_DATA_LOAD_FAILED:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).INITIALISATION_ERROR,
                message: "The initial document couldn't be loaded from the collab service",
                recoverable: false,
                status: 500
            };
        case (0, $6Ted9.NCS_ERROR_CODE).PROSEMIRROR_SCHEMA_VALIDATION_ERROR:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).INITIALISATION_ERROR,
                message: "The initial document couldn't be loaded from the collab service due to a prosemirror schema validation error",
                recoverable: false
            };
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).DOCUMENT_UPDATE_ERROR:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).DOCUMENT_UPDATE_ERROR,
                message: 'The provider failed to apply changes to the editor',
                recoverable: false,
                status: 500
            };
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).RECONNECTION_NETWORK_ISSUE:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).NETWORK_ISSUE,
                message: "Couldn't reconnect to the collab service due to network issues",
                recoverable: true,
                status: 500
            };
        case (0, $6Ted9.NCS_ERROR_CODE).NAMESPACE_INVALID:
        case (0, $6Ted9.NCS_ERROR_CODE).INVALID_ACTIVATION_ID:
        case (0, $6Ted9.NCS_ERROR_CODE).INVALID_DOCUMENT_ARI:
        case (0, $6Ted9.NCS_ERROR_CODE).INVALID_CLOUD_ID:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).INVALID_PROVIDER_CONFIGURATION,
                message: 'Invalid provider configuration',
                recoverable: false,
                reason: error.data?.code,
                status: 400
            };
        case (0, $6Ted9.NCS_ERROR_CODE).NAMESPACE_NOT_FOUND:
        case (0, $6Ted9.NCS_ERROR_CODE).ERROR_MAPPING_ERROR:
        case (0, $6Ted9.NCS_ERROR_CODE).EMPTY_BROADCAST:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).INTERNAL_SERVICE_ERROR,
                message: 'Collab Provider experienced an unrecoverable error',
                recoverable: true,
                reason: error.data?.code,
                status: 500
            };
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).CATCHUP_FAILED:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).INTERNAL_SERVICE_ERROR,
                message: 'Collab Provider experienced an unrecoverable error',
                recoverable: true,
                reason: error.data?.code,
                status: 500
            };
        case (0, $6Ted9.NCS_ERROR_CODE).RATE_LIMIT_ERROR:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).FAIL_TO_SAVE,
                message: 'Document rate limit',
                recoverable: false
            };
        default:
            return;
    }
};
module.exports["errorCodeMapper"] = $91627c828403cd19$export$b222f35b2c811336;

});

parcelRegister("3LSA5", function(module, exports) {

var $4frCv = parcelRequire("4frCv");


var $lMdlY = parcelRequire("lMdlY");

const $7d130921f7e0d933$var$logger = (0, $4frCv.createLogger)('Api', 'blue');
class $7d130921f7e0d933$var$AddCommentError extends Error {
    constructor(message, status, meta){
        super(message);
        this.status = void 0;
        this.meta = void 0;
        this.name = 'AddCommentError';
        this.status = status;
        this.meta = meta;
    }
}
class $7d130921f7e0d933$export$bf71da7aebe9ddc1 {
    async addComment(steps) {
        const stepVersion = this.documentService.getCurrentPmVersion();
        try {
            const response = await this.submitComment(steps, stepVersion);
            const status = response.status;
            const { message: message, meta: meta } = await response.json();
            // If the HTTP status code is 201, then the operation was successful
            if (status === 201) {
                $7d130921f7e0d933$var$logger(`NCS response: ${message}`);
                return {
                    message: message
                };
            }
            // If the HTTP status code is between 400 and 499, then there was a client error
            if (status >= 400 && status <= 499) {
                $7d130921f7e0d933$var$logger(`NCS error meta: ${JSON.stringify(meta)}`);
                // Include details in error response
                throw new $7d130921f7e0d933$var$AddCommentError(`Failed to add comment - Client error: ${message}`, status, JSON.stringify(meta));
            }
            // If the code execution reaches this point, then there was a server error
            throw new $7d130921f7e0d933$var$AddCommentError(`Failed to add comment - Server error`, status);
        } catch (err) {
            if (err instanceof $7d130921f7e0d933$var$AddCommentError) throw err;
            else throw new Error(`Error submitting comment: ${err}`);
        }
    }
    constructor(config, documentService, channel){
        this.config = void 0;
        this.documentService = void 0;
        this.channel = void 0;
        this.submitComment = async (steps, version)=>{
            const reqBody = JSON.stringify({
                productId: 'ccollab',
                version: version,
                steps: steps
            });
            const url = `${this.config.url}/document/${encodeURIComponent(this.config.documentAri)}/comment`;
            $7d130921f7e0d933$var$logger(`Request url: `, url);
            const tracingHeaders = (0, $lMdlY.getActiveTraceHttpRequestHeaders)(url);
            const fetchOptions = {
                credentials: 'include',
                headers: {
                    ...this.config.permissionTokenRefresh ? {
                        'x-token': await this.channel.getChannelToken()
                    } : {},
                    'x-product': (0, $4frCv.getProduct)(this.config.productInfo),
                    'x-subproduct': (0, $4frCv.getSubProduct)(this.config.productInfo),
                    'Content-Type': 'application/json',
                    ...tracingHeaders
                },
                method: 'POST',
                body: reqBody
            };
            return await fetch(url, fetchOptions);
        };
        this.config = config;
        this.documentService = documentService;
        this.channel = channel;
    }
}
module.exports["Api"] = $7d130921f7e0d933$export$bf71da7aebe9ddc1;

});

parcelRegister("9w9et", function(module, exports) {
// A mock for the actual Api class designed for the experiment teammate presence (ATLAS-53155)
class $0cdcfe7cd8acc14c$export$fe345bbcb4b3b9fe {
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    async addComment() {
        return;
    }
}
module.exports["NullApi"] = $0cdcfe7cd8acc14c$export$fe345bbcb4b3b9fe;

});

parcelRegister("b0ow0", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");

function $22e87c8266a2e784$var$getOfflineSteps(steps, origins) {
    if (!steps || !origins || steps.length !== origins.length) return undefined;
    if (origins.some((s)=>s?.getMeta('isOffline') === true || s?.getMeta('wasOffline') === true)) {
        const mapped = steps.filter((step, idx)=>{
            const origin = origins[idx];
            if (!origin) return false;
            const createdOffline = origin.getMeta('isOffline') || origin.getMeta('wasOffline');
            return createdOffline;
        });
        return mapped;
    }
}
function $22e87c8266a2e784$export$4cdf4b1fc99387ca(steps, origins) {
    return $22e87c8266a2e784$var$getOfflineSteps(steps, origins)?.length;
}
function $22e87c8266a2e784$export$4d647e09fb4b200d(steps, origins) {
    return $22e87c8266a2e784$var$getOfflineSteps(steps, origins)?.filter((s)=>s instanceof (0, $aXG5V.ReplaceStep)).length;
}
module.exports["getOfflineStepsLength"] = $22e87c8266a2e784$export$4cdf4b1fc99387ca;
module.exports["getOfflineReplaceStepsLength"] = $22e87c8266a2e784$export$4d647e09fb4b200d;

});

parcelRegister("1jdMD", function(module, exports) {
/**
 * https://socket.io/docs/v4/client-options/#randomizationfactor
 * 1st reconnection attempt happens between 100 - 300 ms
 * 2nd reconnection attempt happens between 200 - 600 ms
 * 3rd reconnection attempt happens between 400 - 1200 ms
 * 4th 800 - 2400 ms
 * 5th 1600 - 4800 ms
 * 6th 3200 - 9600 ms
 * 7th 6400 - 19200 ms
 * 8th 12800 - 38400 ms
 * 9th 25600 - 76800 ms
 * 10th 51200 - 128000 ms (capped at max delay)
 * nth 128000 ms
 */ const $f64b9931b63de03f$export$33eb5f668d5e0d74 = {
    RECONNECTION_DELAY_MAX: 128000,
    RECONNECTION_DELAY: 200,
    RANDOMIZATION_FACTOR: 0.5
};
const $f64b9931b63de03f$export$273323b1c5196ad5 = {
    RECONNECTION_DELAY_MAX: 128000,
    RECONNECTION_DELAY: 1000,
    RANDOMIZATION_FACTOR: 0.75
};
module.exports["SOCKET_IO_OPTIONS"] = $f64b9931b63de03f$export$33eb5f668d5e0d74;
module.exports["SOCKET_IO_OPTIONS_WITH_HIGH_JITTER"] = $f64b9931b63de03f$export$273323b1c5196ad5;

});

parcelRegister("1VB1N", function(module, exports) {
const $aa17610eab1e6010$var$COLLAB_PATH = 'ccollab'; // the extra c is for Confluence
const $aa17610eab1e6010$export$33a46e9ce425ca1f = ()=>{
    return `${window.location.origin}/${$aa17610eab1e6010$var$COLLAB_PATH}`;
};
module.exports["getCollabProviderUrl"] = $aa17610eab1e6010$export$33a46e9ce425ca1f;

});

parcelRegister("8VXwD", function(module, exports) {
/** @graphql agg **/ 
var $eSUdr = parcelRequire("eSUdr");


var $gKr8t = parcelRequire("gKr8t");

const $b6adfd51a2226747$export$c510c686c47533e5 = (accountIds)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $gKr8t.getAGGClient)().query({
        query: (0, $eSUdr.default)`query fetchNativeCollabAGGUsersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){accountId name picture}}`,
        variables: {
            accountIds: accountIds
        }
    }).then(({ data: data })=>{
        return data?.users?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user.picture ?? '',
                email: '',
                name: user.name ?? '',
                userId: user.accountId
            })) ?? [];
    });
};
module.exports["fetchNativeCollabAGGUsers"] = $b6adfd51a2226747$export$c510c686c47533e5;

});

parcelRegister("bNHtR", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");


var $hp2SH = parcelRequire("hp2SH");

const $5bd57447223249dc$export$1db9c46a0728e686 = (accountIds)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $eSUdr.default)`query fetchNativeCollabConfluenceUsersQuery($accountIds:[String]){confluenceUsers(accountIds:$accountIds){nodes{profilePicture{isDefault path(type:RELATIVE)}...on KnownUser{accountId}...on UnknownUser{accountId}displayName}}}`,
        variables: {
            accountIds: accountIds
        }
    }).then(({ data: data })=>{
        return data?.confluenceUsers?.nodes?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user.profilePicture?.path ?? '',
                email: '',
                isGuest: undefined,
                name: user.displayName ?? '',
                userId: user.accountId
            })) ?? [];
    });
};
module.exports["fetchNativeCollabConfluenceUsers"] = $5bd57447223249dc$export$1db9c46a0728e686;

});

parcelRegister("gNjy8", function(module, exports) {

var $jyw2s = parcelRequire("jyw2s");

var $aFUXX = parcelRequire("aFUXX");


var $83Vfg = parcelRequire("83Vfg");

const $f7e4e12795ac08a6$export$e42cca8419da94fc = (presenceId)=>{
    const hashCode = presenceId ? (0, $jyw2s.getHashCode)(presenceId) : 0;
    const primaryIndex = hashCode;
    const secondaryIndex = hashCode % (0, $aFUXX.participantColors).length;
    const svgBackgroundColor = (0, $aFUXX.participantColors)[secondaryIndex].svgBackgroundColor;
    return (0, $83Vfg.getAnonymousAvatarWithStyling)({
        styleProperties: {
            'background-color': svgBackgroundColor
        },
        index: primaryIndex
    });
};
module.exports["fetchAnonymousAsset"] = $f7e4e12795ac08a6$export$e42cca8419da94fc;

});

parcelRegister("jyw2s", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");

function $514d44140915e951$export$c14f61804029af13(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = (hash & hash) >>> 0;
    /* eslint-enable no-bitwise */ }
    return hash;
}
function $514d44140915e951$export$60ba61eca4eb64f2(str) {
    const index = $514d44140915e951$export$c14f61804029af13(str) % (0, $aFUXX.participantColors).length;
    return {
        index: index,
        color: (0, $aFUXX.participantColors)[index]
    };
}
module.exports["getHashCode"] = $514d44140915e951$export$c14f61804029af13;
module.exports["getParticipantColor"] = $514d44140915e951$export$60ba61eca4eb64f2;

});

parcelRegister("83Vfg", function(module, exports) {

var $8ocXC = parcelRequire("8ocXC");


var $fDtVg = parcelRequire("fDtVg");


var $99F08 = parcelRequire("99F08");

const $eeb5105c6a539702$export$101d00feadd67b75 = (svgRoot)=>{
    // by this point we have a safe SVG string: we can safely string interpolate to encode as a
    // data:image to enable passing it to an <img> src attribute
    return `data:image/svg+xml;base64,${btoa(new XMLSerializer().serializeToString(svgRoot))}`;
};
const $eeb5105c6a539702$export$ad5dfe87b2150403 = (cssProperties)=>{
    let styleString = '';
    Object.keys(cssProperties).forEach((key)=>{
        styleString += `${key}: ${cssProperties[key]}; `;
    });
    return styleString;
};
const $eeb5105c6a539702$export$1ce458cf91bd8e41 = (svgRoot, cssProperties)=>{
    const styleRule = new CSSStyleSheet();
    const styleString = $eeb5105c6a539702$export$ad5dfe87b2150403(cssProperties);
    // even if styling is malicious, it will be sanitized by the CSSStyleSheet with the string being empty, ensuring safety
    styleRule.insertRule(`svg { ${styleString} }`);
    // we need to cast to CSSStyleRule to access the .style property
    const styleRuleString = styleRule.cssRules[0].style.cssText;
    svgRoot.setAttribute('style', styleRuleString);
};
const $eeb5105c6a539702$export$7572e098f6cf1a37 = (index)=>{
    return index !== undefined ? index % (0, $8ocXC.ANONYMOUS_ASSETS).length : Math.floor(Math.random() * (0, $8ocXC.ANONYMOUS_ASSETS).length);
};
const $eeb5105c6a539702$export$e79675c646a31542 = (svgString)=>{
    return new DOMParser().parseFromString(svgString, 'image/svg+xml');
};
const $eeb5105c6a539702$export$65fe496f5eb91c21 = async (props)=>{
    const index = $eeb5105c6a539702$export$7572e098f6cf1a37(props?.index);
    const { id: id, messageDescriptor: messageDescriptor, src: src } = (0, $8ocXC.ANONYMOUS_ASSETS)[index];
    const intl = await (0, $fDtVg.getIntl)();
    const response = await (0, $99F08.fetchWithRetry)({
        url: src,
        shouldRetryOnApiError: true,
        retries: props.retries || 3,
        options: props.options,
        baseDelay: props.baseDelay,
        maxDelay: props.maxDelay
    });
    const svgString = await response.result?.text();
    if (!response.success) throw new Error(`Error while fetching svg ${id} with src ${src}`);
    if (!svgString) throw new Error(`svg returned null with svg ${id} with src ${src}`);
    const doc = $eeb5105c6a539702$export$e79675c646a31542(svgString);
    const svg = doc.documentElement;
    $eeb5105c6a539702$export$1ce458cf91bd8e41(svg, props.styleProperties);
    return {
        id: id,
        name: intl.formatMessage(messageDescriptor),
        src: $eeb5105c6a539702$export$101d00feadd67b75(svg)
    };
};
const $eeb5105c6a539702$export$da26b707e2b53fcf = async (props)=>{
    const index = $eeb5105c6a539702$export$7572e098f6cf1a37(props?.index);
    const asset = (0, $8ocXC.ANONYMOUS_ASSETS)[index];
    const intl = await (0, $fDtVg.getIntl)();
    return {
        ...asset,
        name: intl.formatMessage(asset.messageDescriptor)
    };
};
const $eeb5105c6a539702$export$aa51d138a7f855d7 = async ()=>{
    const intl = await (0, $fDtVg.getIntl)();
    return (0, $8ocXC.ANONYMOUS_ASSETS).map((asset)=>({
            id: asset.id,
            name: intl.formatMessage(asset.messageDescriptor),
            src: asset.src
        }));
};
module.exports["getAnonymousAvatarWithStyling"] = $eeb5105c6a539702$export$65fe496f5eb91c21;

});

parcelRegister("8ocXC", function(module, exports) {

var $lfFy6 = parcelRequire("lfFy6");


var $45p5c = parcelRequire("45p5c");

var $66aLS = parcelRequire("66aLS");

var $eA5k9 = parcelRequire("eA5k9");

var $dLHML = parcelRequire("dLHML");

var $5QM3U = parcelRequire("5QM3U");

var $1zbJy = parcelRequire("1zbJy");

var $absgL = parcelRequire("absgL");

var $i9wU3 = parcelRequire("i9wU3");

var $7BD8h = parcelRequire("7BD8h");

var $ipNYr = parcelRequire("ipNYr");

var $5Fo99 = parcelRequire("5Fo99");

var $futbp = parcelRequire("futbp");

var $1tL0q = parcelRequire("1tL0q");

var $gsqYV = parcelRequire("gsqYV");

var $aV0Ix = parcelRequire("aV0Ix");

var $7f8BP = parcelRequire("7f8BP");

var $w2g3p = parcelRequire("w2g3p");

var $7pNkU = parcelRequire("7pNkU");

var $3saEQ = parcelRequire("3saEQ");

var $bBrvm = parcelRequire("bBrvm");

var $2MJ1F = parcelRequire("2MJ1F");

var $62PyO = parcelRequire("62PyO");

var $ct5mQ = parcelRequire("ct5mQ");

var $geCWF = parcelRequire("geCWF");

var $cA6yA = parcelRequire("cA6yA");

var $gE9fP = parcelRequire("gE9fP");

var $6Cmrb = parcelRequire("6Cmrb");

var $7Za1I = parcelRequire("7Za1I");

var $kgPFA = parcelRequire("kgPFA");

var $2hRuV = parcelRequire("2hRuV");

var $8H1nG = parcelRequire("8H1nG");

var $jfdMm = parcelRequire("jfdMm");

var $jAnMk = parcelRequire("jAnMk");

var $kiped = parcelRequire("kiped");

var $ijRK6 = parcelRequire("ijRK6");

var $hQTrZ = parcelRequire("hQTrZ");

var $3ussC = parcelRequire("3ussC");

var $bfQlR = parcelRequire("bfQlR");

var $g2zNl = parcelRequire("g2zNl");

var $dnUXX = parcelRequire("dnUXX");

var $ldCFU = parcelRequire("ldCFU");

var $gcvuo = parcelRequire("gcvuo");

var $3aulr = parcelRequire("3aulr");

var $jj7JF = parcelRequire("jj7JF");

var $gFh8H = parcelRequire("gFh8H");

var $ib1i9 = parcelRequire("ib1i9");

var $7vWf2 = parcelRequire("7vWf2");

var $MAw5A = parcelRequire("MAw5A");

var $4R6fR = parcelRequire("4R6fR");

var $3G8sv = parcelRequire("3G8sv");

var $5L3ZL = parcelRequire("5L3ZL");

var $1tIXy = parcelRequire("1tIXy");

var $gIr5o = parcelRequire("gIr5o");

var $jMi9Z = parcelRequire("jMi9Z");

var $5fTd1 = parcelRequire("5fTd1");

var $70IXo = parcelRequire("70IXo");

var $k45BN = parcelRequire("k45BN");

var $5t7IX = parcelRequire("5t7IX");

var $7y9m7 = parcelRequire("7y9m7");

var $kRP7t = parcelRequire("kRP7t");

var $dLJHp = parcelRequire("dLJHp");

var $MvguA = parcelRequire("MvguA");

var $i2wVj = parcelRequire("i2wVj");

var $bqNy3 = parcelRequire("bqNy3");

var $5RzHY = parcelRequire("5RzHY");

var $jN43s = parcelRequire("jN43s");

var $018bO = parcelRequire("018bO");

var $c3T8r = parcelRequire("c3T8r");

var $h0256 = parcelRequire("h0256");

var $8O3eM = parcelRequire("8O3eM");

var $8BcsQ = parcelRequire("8BcsQ");

var $ctuOo = parcelRequire("ctuOo");

var $9wms3 = parcelRequire("9wms3");

var $1j7TY = parcelRequire("1j7TY");

var $4ux8O = parcelRequire("4ux8O");

var $44Sb4 = parcelRequire("44Sb4");

var $dQMZo = parcelRequire("dQMZo");

var $zYoHs = parcelRequire("zYoHs");

var $04PGh = parcelRequire("04PGh");

var $ddSO1 = parcelRequire("ddSO1");

var $ivVMv = parcelRequire("ivVMv");

var $eJnd2 = parcelRequire("eJnd2");

var $98ut7 = parcelRequire("98ut7");

var $9q1Vk = parcelRequire("9q1Vk");

var $eMHgQ = parcelRequire("eMHgQ");

var $3LKHJ = parcelRequire("3LKHJ");

var $3ZCOi = parcelRequire("3ZCOi");

var $5xoX8 = parcelRequire("5xoX8");

var $5qhol = parcelRequire("5qhol");

var $dGRYO = parcelRequire("dGRYO");

var $6dhVt = parcelRequire("6dhVt");

var $ighEF = parcelRequire("ighEF");

var $jiyfa = parcelRequire("jiyfa");

var $aRWto = parcelRequire("aRWto");

var $3VNps = parcelRequire("3VNps");

var $62BuW = parcelRequire("62BuW");

var $54a3y = parcelRequire("54a3y");

var $cjnzF = parcelRequire("cjnzF");

var $faukZ = parcelRequire("faukZ");

var $Ox4am = parcelRequire("Ox4am");

var $hembw = parcelRequire("hembw");

var $5gEBh = parcelRequire("5gEBh");

var $76eQq = parcelRequire("76eQq");

var $68Yx0 = parcelRequire("68Yx0");

var $l08I5 = parcelRequire("l08I5");

const $40b74b738da6af36$export$4522d3d70312bbdc = [
    {
        id: 'alligator',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2hRuV))),
        messageDescriptor: (0, $lfFy6.messages).alligator
    },
    {
        id: 'alpaca',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($70IXo))),
        messageDescriptor: (0, $lfFy6.messages).alpaca
    },
    {
        id: 'ape',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5RzHY))),
        messageDescriptor: (0, $lfFy6.messages).ape
    },
    {
        id: 'apple',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($45p5c))),
        messageDescriptor: (0, $lfFy6.messages).apple
    },
    {
        id: 'avocado',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($66aLS))),
        messageDescriptor: (0, $lfFy6.messages).avocado
    },
    {
        id: 'baboon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5RzHY))),
        messageDescriptor: (0, $lfFy6.messages).baboon
    },
    {
        id: 'badger',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eA5k9))),
        messageDescriptor: (0, $lfFy6.messages).badger
    },
    {
        id: 'bat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dLHML))),
        messageDescriptor: (0, $lfFy6.messages).bat
    },
    {
        id: 'bear',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5QM3U))),
        messageDescriptor: (0, $lfFy6.messages).bear
    },
    {
        id: 'beaver',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1zbJy))),
        messageDescriptor: (0, $lfFy6.messages).beaver
    },
    {
        id: 'bee',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($absgL))),
        messageDescriptor: (0, $lfFy6.messages).bee
    },
    {
        id: 'bird',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($018bO))),
        messageDescriptor: (0, $lfFy6.messages).bird
    },
    {
        id: 'bison',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i9wU3))),
        messageDescriptor: (0, $lfFy6.messages).bison
    },
    {
        id: 'blobfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).blobfish
    },
    {
        id: 'blossom',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7BD8h))),
        messageDescriptor: (0, $lfFy6.messages).blossom
    },
    {
        id: 'blowfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ipNYr))),
        messageDescriptor: (0, $lfFy6.messages).blowfish
    },
    {
        id: 'blueberries',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5Fo99))),
        messageDescriptor: (0, $lfFy6.messages).blueberries
    },
    {
        id: 'boar',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($futbp))),
        messageDescriptor: (0, $lfFy6.messages).boar
    },
    {
        id: 'broccoli',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1tL0q))),
        messageDescriptor: (0, $lfFy6.messages).broccoli
    },
    {
        id: 'buffalo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i9wU3))),
        messageDescriptor: (0, $lfFy6.messages).buffalo
    },
    {
        id: 'bug',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gsqYV))),
        messageDescriptor: (0, $lfFy6.messages).bug
    },
    {
        id: 'bull',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7Za1I))),
        messageDescriptor: (0, $lfFy6.messages).bull
    },
    {
        id: 'bunny',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($zYoHs))),
        messageDescriptor: (0, $lfFy6.messages).bunny
    },
    {
        id: 'butterfly',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gsqYV))),
        messageDescriptor: (0, $lfFy6.messages).butterfly
    },
    {
        id: 'cactus',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aV0Ix))),
        messageDescriptor: (0, $lfFy6.messages).cactus
    },
    {
        id: 'camel',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7f8BP))),
        messageDescriptor: (0, $lfFy6.messages).camel
    },
    {
        id: 'candy',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($w2g3p))),
        messageDescriptor: (0, $lfFy6.messages).candy
    },
    {
        id: 'cantaloupe',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7y9m7))),
        messageDescriptor: (0, $lfFy6.messages).cantaloupe
    },
    {
        id: 'capsicum',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7pNkU))),
        messageDescriptor: (0, $lfFy6.messages).capsicum
    },
    {
        id: 'carrot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3saEQ))),
        messageDescriptor: (0, $lfFy6.messages).carrot
    },
    {
        id: 'cat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bBrvm))),
        messageDescriptor: (0, $lfFy6.messages).cat
    },
    {
        id: 'caterpiller',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2MJ1F))),
        messageDescriptor: (0, $lfFy6.messages).caterpiller
    },
    {
        id: 'chameleon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5fTd1))),
        messageDescriptor: (0, $lfFy6.messages).chameleon
    },
    {
        id: 'cherry',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($62PyO))),
        messageDescriptor: (0, $lfFy6.messages).cherry
    },
    {
        id: 'chili',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ct5mQ))),
        messageDescriptor: (0, $lfFy6.messages).chili
    },
    {
        id: 'chimp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).chimp
    },
    {
        id: 'chimpanzee',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).chimpanzee
    },
    {
        id: 'clover',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($geCWF))),
        messageDescriptor: (0, $lfFy6.messages).clover
    },
    {
        id: 'clownfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($Ox4am))),
        messageDescriptor: (0, $lfFy6.messages).clownfish
    },
    {
        id: 'cobra',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dGRYO))),
        messageDescriptor: (0, $lfFy6.messages).cobra
    },
    {
        id: 'coconut',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cA6yA))),
        messageDescriptor: (0, $lfFy6.messages).coconut
    },
    {
        id: 'cod',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).cod
    },
    {
        id: 'cookie',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gE9fP))),
        messageDescriptor: (0, $lfFy6.messages).cookie
    },
    {
        id: 'corn',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6Cmrb))),
        messageDescriptor: (0, $lfFy6.messages).corn
    },
    {
        id: 'cow',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7Za1I))),
        messageDescriptor: (0, $lfFy6.messages).cow
    },
    {
        id: 'crab',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kgPFA))),
        messageDescriptor: (0, $lfFy6.messages).crab
    },
    {
        id: 'crocodile',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2hRuV))),
        messageDescriptor: (0, $lfFy6.messages).crocodile
    },
    {
        id: 'deer',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8H1nG))),
        messageDescriptor: (0, $lfFy6.messages).deer
    },
    {
        id: 'dinosaur',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jfdMm))),
        messageDescriptor: (0, $lfFy6.messages).dinosaur
    },
    {
        id: 'dodo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jAnMk))),
        messageDescriptor: (0, $lfFy6.messages).dodo
    },
    {
        id: 'dog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kiped))),
        messageDescriptor: (0, $lfFy6.messages).dog
    },
    {
        id: 'dolphin',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ijRK6))),
        messageDescriptor: (0, $lfFy6.messages).dolphin
    },
    {
        id: 'donut',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hQTrZ))),
        messageDescriptor: (0, $lfFy6.messages).donut
    },
    {
        id: 'dragon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3ussC))),
        messageDescriptor: (0, $lfFy6.messages).dragon
    },
    {
        id: 'duck',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bfQlR))),
        messageDescriptor: (0, $lfFy6.messages).duck
    },
    {
        id: 'elephant',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($g2zNl))),
        messageDescriptor: (0, $lfFy6.messages).elephant
    },
    {
        id: 'elk',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8H1nG))),
        messageDescriptor: (0, $lfFy6.messages).elk
    },
    {
        id: 'fish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).fish
    },
    {
        id: 'flamingo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ldCFU))),
        messageDescriptor: (0, $lfFy6.messages).flamingo
    },
    {
        id: 'fox',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gcvuo))),
        messageDescriptor: (0, $lfFy6.messages).fox
    },
    {
        id: 'frog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3aulr))),
        messageDescriptor: (0, $lfFy6.messages).frog
    },
    {
        id: 'gecko',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5fTd1))),
        messageDescriptor: (0, $lfFy6.messages).gecko
    },
    {
        id: 'giraffe',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jj7JF))),
        messageDescriptor: (0, $lfFy6.messages).giraffe
    },
    {
        id: 'gorilla',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gFh8H))),
        messageDescriptor: (0, $lfFy6.messages).gorilla
    },
    {
        id: 'grape',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ib1i9))),
        messageDescriptor: (0, $lfFy6.messages).grape
    },
    {
        id: 'hammerhead',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eMHgQ))),
        messageDescriptor: (0, $lfFy6.messages).hammerhead
    },
    {
        id: 'hedgehog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7vWf2))),
        messageDescriptor: (0, $lfFy6.messages).hedgehog
    },
    {
        id: 'hippo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($MAw5A))),
        messageDescriptor: (0, $lfFy6.messages).hippo
    },
    {
        id: 'kangaroo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4R6fR))),
        messageDescriptor: (0, $lfFy6.messages).kangaroo
    },
    {
        id: 'kitten',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bBrvm))),
        messageDescriptor: (0, $lfFy6.messages).kitten
    },
    {
        id: 'kiwi',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3G8sv))),
        messageDescriptor: (0, $lfFy6.messages).kiwi
    },
    {
        id: 'koala',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5L3ZL))),
        messageDescriptor: (0, $lfFy6.messages).koala
    },
    {
        id: 'lemon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1tIXy))),
        messageDescriptor: (0, $lfFy6.messages).lemon
    },
    {
        id: 'leopard',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($62BuW))),
        messageDescriptor: (0, $lfFy6.messages).leopard
    },
    {
        id: 'lettuce',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gIr5o))),
        messageDescriptor: (0, $lfFy6.messages).lettuce
    },
    {
        id: 'lion',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jMi9Z))),
        messageDescriptor: (0, $lfFy6.messages).lion
    },
    {
        id: 'lizard',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5fTd1))),
        messageDescriptor: (0, $lfFy6.messages).lizard
    },
    {
        id: 'llama',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($70IXo))),
        messageDescriptor: (0, $lfFy6.messages).llama
    },
    {
        id: 'lobster',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($k45BN))),
        messageDescriptor: (0, $lfFy6.messages).lobster
    },
    {
        id: 'macaque',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).macaque
    },
    {
        id: 'mango',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5t7IX))),
        messageDescriptor: (0, $lfFy6.messages).mango
    },
    {
        id: 'melon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($76eQq))),
        messageDescriptor: (0, $lfFy6.messages).melon
    },
    {
        id: 'millipede',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2MJ1F))),
        messageDescriptor: (0, $lfFy6.messages).millipede
    },
    {
        id: 'monkey',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).monkey
    },
    {
        id: 'mouse',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dLJHp))),
        messageDescriptor: (0, $lfFy6.messages).mouse
    },
    {
        id: 'octopus',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($MvguA))),
        messageDescriptor: (0, $lfFy6.messages).octopus
    },
    {
        id: 'olive',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i2wVj))),
        messageDescriptor: (0, $lfFy6.messages).olive
    },
    {
        id: 'orange',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bqNy3))),
        messageDescriptor: (0, $lfFy6.messages).orange
    },
    {
        id: 'orangutan',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5RzHY))),
        messageDescriptor: (0, $lfFy6.messages).orangutan
    },
    {
        id: 'otter',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jN43s))),
        messageDescriptor: (0, $lfFy6.messages).otter
    },
    {
        id: 'owl',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($018bO))),
        messageDescriptor: (0, $lfFy6.messages).owl
    },
    {
        id: 'ox',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c3T8r))),
        messageDescriptor: (0, $lfFy6.messages).ox
    },
    {
        id: 'oyster',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($h0256))),
        messageDescriptor: (0, $lfFy6.messages).oyster
    },
    {
        id: 'panda',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8O3eM))),
        messageDescriptor: (0, $lfFy6.messages).panda
    },
    {
        id: 'parrot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8BcsQ))),
        messageDescriptor: (0, $lfFy6.messages).parrot
    },
    {
        id: 'peacock',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ctuOo))),
        messageDescriptor: (0, $lfFy6.messages).peacock
    },
    {
        id: 'pear',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9wms3))),
        messageDescriptor: (0, $lfFy6.messages).pear
    },
    {
        id: 'penguin',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1j7TY))),
        messageDescriptor: (0, $lfFy6.messages).penguin
    },
    {
        id: 'pig',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4ux8O))),
        messageDescriptor: (0, $lfFy6.messages).pig
    },
    {
        id: 'pineapple',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($44Sb4))),
        messageDescriptor: (0, $lfFy6.messages).pineapple
    },
    {
        id: 'poodle',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dQMZo))),
        messageDescriptor: (0, $lfFy6.messages).poodle
    },
    {
        id: 'puppy',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kiped))),
        messageDescriptor: (0, $lfFy6.messages).puppy
    },
    {
        id: 'python',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dGRYO))),
        messageDescriptor: (0, $lfFy6.messages).python
    },
    {
        id: 'rabbit',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($zYoHs))),
        messageDescriptor: (0, $lfFy6.messages).rabbit
    },
    {
        id: 'raccoon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($04PGh))),
        messageDescriptor: (0, $lfFy6.messages).raccoon
    },
    {
        id: 'rat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dLJHp))),
        messageDescriptor: (0, $lfFy6.messages).rat
    },
    {
        id: 'rhino',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ddSO1))),
        messageDescriptor: (0, $lfFy6.messages).rhino
    },
    {
        id: 'robot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ivVMv))),
        messageDescriptor: (0, $lfFy6.messages).robot
    },
    {
        id: 'rose',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eJnd2))),
        messageDescriptor: (0, $lfFy6.messages).rose
    },
    {
        id: 'seal',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($98ut7))),
        messageDescriptor: (0, $lfFy6.messages).seal
    },
    {
        id: 'seedling',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9q1Vk))),
        messageDescriptor: (0, $lfFy6.messages).seedling
    },
    {
        id: 'shark',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eMHgQ))),
        messageDescriptor: (0, $lfFy6.messages).shark
    },
    {
        id: 'shrimp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3LKHJ))),
        messageDescriptor: (0, $lfFy6.messages).shrimp
    },
    {
        id: 'skunk',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3ZCOi))),
        messageDescriptor: (0, $lfFy6.messages).skunk
    },
    {
        id: 'sloth',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5xoX8))),
        messageDescriptor: (0, $lfFy6.messages).sloth
    },
    {
        id: 'snail',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5qhol))),
        messageDescriptor: (0, $lfFy6.messages).snail
    },
    {
        id: 'snake',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dGRYO))),
        messageDescriptor: (0, $lfFy6.messages).snake
    },
    {
        id: 'snowman',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6dhVt))),
        messageDescriptor: (0, $lfFy6.messages).snowman
    },
    {
        id: 'squid',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ighEF))),
        messageDescriptor: (0, $lfFy6.messages).squid
    },
    {
        id: 'squirrel',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jiyfa))),
        messageDescriptor: (0, $lfFy6.messages).squirrel
    },
    {
        id: 'strawberry',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aRWto))),
        messageDescriptor: (0, $lfFy6.messages).strawberry
    },
    {
        id: 'sunfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($Ox4am))),
        messageDescriptor: (0, $lfFy6.messages).sunfish
    },
    {
        id: 'sunflower',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3VNps))),
        messageDescriptor: (0, $lfFy6.messages).sunflower
    },
    {
        id: 'tiger',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($62BuW))),
        messageDescriptor: (0, $lfFy6.messages).tiger
    },
    {
        id: 'tomato',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($54a3y))),
        messageDescriptor: (0, $lfFy6.messages).tomato
    },
    {
        id: 'tortoise',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5gEBh))),
        messageDescriptor: (0, $lfFy6.messages).tortoise
    },
    {
        id: 'tree',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cjnzF))),
        messageDescriptor: (0, $lfFy6.messages).tree
    },
    {
        id: 'trex',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($faukZ))),
        messageDescriptor: (0, $lfFy6.messages).trex
    },
    {
        id: 'trout',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).trout
    },
    {
        id: 'turkey',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hembw))),
        messageDescriptor: (0, $lfFy6.messages).turkey
    },
    {
        id: 'turtle',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5gEBh))),
        messageDescriptor: (0, $lfFy6.messages).turtle
    },
    {
        id: 'wasp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($absgL))),
        messageDescriptor: (0, $lfFy6.messages).wasp
    },
    {
        id: 'watermelon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($76eQq))),
        messageDescriptor: (0, $lfFy6.messages).watermelon
    },
    {
        id: 'whale',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($68Yx0))),
        messageDescriptor: (0, $lfFy6.messages).whale
    },
    {
        id: 'wolf',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l08I5))),
        messageDescriptor: (0, $lfFy6.messages).wolf
    }
];
module.exports["ANONYMOUS_ASSETS"] = $40b74b738da6af36$export$4522d3d70312bbdc;

});

parcelRegister("lfFy6", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $11f365f4e13bb9e0$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    alligator: {
        id: "platform.anonymous-asset-name.alligator",
        defaultMessage: "Anonymous Alligator"
    },
    alpaca: {
        id: "platform.anonymous-asset-name.alpaca",
        defaultMessage: "Anonymous Alpaca"
    },
    ape: {
        id: "platform.anonymous-asset-name.ape",
        defaultMessage: "Anonymous Ape"
    },
    apple: {
        id: "platform.anonymous-asset-name.apple",
        defaultMessage: "Anonymous Apple"
    },
    avocado: {
        id: "platform.anonymous-asset-name.avocado",
        defaultMessage: "Anonymous Avocado"
    },
    baboon: {
        id: "platform.anonymous-asset-name.baboon",
        defaultMessage: "Anonymous Baboon"
    },
    badger: {
        id: "platform.anonymous-asset-name.badger",
        defaultMessage: "Anonymous Badger"
    },
    bat: {
        id: "platform.anonymous-asset-name.bat",
        defaultMessage: "Anonymous Bat"
    },
    bear: {
        id: "platform.anonymous-asset-name.bear",
        defaultMessage: "Anonymous Bear"
    },
    beaver: {
        id: "platform.anonymous-asset-name.beaver",
        defaultMessage: "Anonymous Beaver"
    },
    bee: {
        id: "platform.anonymous-asset-name.bee",
        defaultMessage: "Anonymous Bee"
    },
    bird: {
        id: "platform.anonymous-asset-name.bird",
        defaultMessage: "Anonymous Bird"
    },
    bison: {
        id: "platform.anonymous-asset-name.bison",
        defaultMessage: "Anonymous Bison"
    },
    blobfish: {
        id: "platform.anonymous-asset-name.blobfish",
        defaultMessage: "Anonymous Blobfish"
    },
    blossom: {
        id: "platform.anonymous-asset-name.blossom",
        defaultMessage: "Anonymous Blossom"
    },
    blowfish: {
        id: "platform.anonymous-asset-name.blowfish",
        defaultMessage: "Anonymous Blowfish"
    },
    blueberries: {
        id: "platform.anonymous-asset-name.blueberries",
        defaultMessage: "Anonymous Blueberries"
    },
    boar: {
        id: "platform.anonymous-asset-name.boar",
        defaultMessage: "Anonymous Boar"
    },
    broccoli: {
        id: "platform.anonymous-asset-name.broccoli",
        defaultMessage: "Anonymous Broccoli"
    },
    buffalo: {
        id: "platform.anonymous-asset-name.buffalo",
        defaultMessage: "Anonymous Buffalo"
    },
    bug: {
        id: "platform.anonymous-asset-name.bug",
        defaultMessage: "Anonymous Bug"
    },
    bull: {
        id: "platform.anonymous-asset-name.bull",
        defaultMessage: "Anonymous Bull"
    },
    bunny: {
        id: "platform.anonymous-asset-name.bunny",
        defaultMessage: "Anonymous Bunny"
    },
    butterfly: {
        id: "platform.anonymous-asset-name.butterfly",
        defaultMessage: "Anonymous Butterfly"
    },
    cactus: {
        id: "platform.anonymous-asset-name.cactus",
        defaultMessage: "Anonymous Cactus"
    },
    camel: {
        id: "platform.anonymous-asset-name.camel",
        defaultMessage: "Anonymous Camel"
    },
    candy: {
        id: "platform.anonymous-asset-name.candy",
        defaultMessage: "Anonymous Candy"
    },
    cantaloupe: {
        id: "platform.anonymous-asset-name.cantaloupe",
        defaultMessage: "Anonymous Cantaloupe"
    },
    capsicum: {
        id: "platform.anonymous-asset-name.capsicum",
        defaultMessage: "Anonymous Capsicum"
    },
    carrot: {
        id: "platform.anonymous-asset-name.carrot",
        defaultMessage: "Anonymous Carrot"
    },
    cat: {
        id: "platform.anonymous-asset-name.cat",
        defaultMessage: "Anonymous Cat"
    },
    caterpiller: {
        id: "platform.anonymous-asset-name.caterpiller",
        defaultMessage: "Anonymous Caterpiller"
    },
    chameleon: {
        id: "platform.anonymous-asset-name.chameleon",
        defaultMessage: "Anonymous Chameleon"
    },
    cherry: {
        id: "platform.anonymous-asset-name.cherry",
        defaultMessage: "Anonymous Cherry"
    },
    chili: {
        id: "platform.anonymous-asset-name.chili",
        defaultMessage: "Anonymous Chili"
    },
    chimp: {
        id: "platform.anonymous-asset-name.chimp",
        defaultMessage: "Anonymous Chimp"
    },
    chimpanzee: {
        id: "platform.anonymous-asset-name.chimpanzee",
        defaultMessage: "Anonymous Chimpanzee"
    },
    clover: {
        id: "platform.anonymous-asset-name.clover",
        defaultMessage: "Anonymous Clover"
    },
    clownfish: {
        id: "platform.anonymous-asset-name.clownfish",
        defaultMessage: "Anonymous Clownfish"
    },
    cobra: {
        id: "platform.anonymous-asset-name.cobra",
        defaultMessage: "Anonymous Cobra"
    },
    coconut: {
        id: "platform.anonymous-asset-name.coconut",
        defaultMessage: "Anonymous Coconut"
    },
    cod: {
        id: "platform.anonymous-asset-name.cod",
        defaultMessage: "Anonymous Cod"
    },
    cookie: {
        id: "platform.anonymous-asset-name.cookie",
        defaultMessage: "Anonymous Cookie"
    },
    corn: {
        id: "platform.anonymous-asset-name.corn",
        defaultMessage: "Anonymous Corn"
    },
    cow: {
        id: "platform.anonymous-asset-name.cow",
        defaultMessage: "Anonymous Cow"
    },
    crab: {
        id: "platform.anonymous-asset-name.crab",
        defaultMessage: "Anonymous Crab"
    },
    crocodile: {
        id: "platform.anonymous-asset-name.crocodile",
        defaultMessage: "Anonymous Crocodile"
    },
    deer: {
        id: "platform.anonymous-asset-name.deer",
        defaultMessage: "Anonymous Deer"
    },
    dinosaur: {
        id: "platform.anonymous-asset-name.dinosaur",
        defaultMessage: "Anonymous Dinosaur"
    },
    dodo: {
        id: "platform.anonymous-asset-name.dodo",
        defaultMessage: "Anonymous Dodo"
    },
    dog: {
        id: "platform.anonymous-asset-name.dog",
        defaultMessage: "Anonymous Dog"
    },
    dolphin: {
        id: "platform.anonymous-asset-name.dolphin",
        defaultMessage: "Anonymous Dolphin"
    },
    donut: {
        id: "platform.anonymous-asset-name.donut",
        defaultMessage: "Anonymous Donut"
    },
    dragon: {
        id: "platform.anonymous-asset-name.dragon",
        defaultMessage: "Anonymous Dragon"
    },
    duck: {
        id: "platform.anonymous-asset-name.duck",
        defaultMessage: "Anonymous Duck"
    },
    elephant: {
        id: "platform.anonymous-asset-name.elephant",
        defaultMessage: "Anonymous Elephant"
    },
    elk: {
        id: "platform.anonymous-asset-name.elk",
        defaultMessage: "Anonymous Elk"
    },
    fish: {
        id: "platform.anonymous-asset-name.fish",
        defaultMessage: "Anonymous Fish"
    },
    flamingo: {
        id: "platform.anonymous-asset-name.flamingo",
        defaultMessage: "Anonymous Flamingo"
    },
    fox: {
        id: "platform.anonymous-asset-name.fox",
        defaultMessage: "Anonymous Fox"
    },
    frog: {
        id: "platform.anonymous-asset-name.frog",
        defaultMessage: "Anonymous Frog"
    },
    gecko: {
        id: "platform.anonymous-asset-name.gecko",
        defaultMessage: "Anonymous Gecko"
    },
    giraffe: {
        id: "platform.anonymous-asset-name.giraffe",
        defaultMessage: "Anonymous Giraffe"
    },
    gorilla: {
        id: "platform.anonymous-asset-name.gorilla",
        defaultMessage: "Anonymous Gorilla"
    },
    grape: {
        id: "platform.anonymous-asset-name.grape",
        defaultMessage: "Anonymous Grape"
    },
    hammerhead: {
        id: "platform.anonymous-asset-name.hammerhead",
        defaultMessage: "Anonymous Hammerhead"
    },
    hedgehog: {
        id: "platform.anonymous-asset-name.hedgehog",
        defaultMessage: "Anonymous Hedgehog"
    },
    hippo: {
        id: "platform.anonymous-asset-name.hippo",
        defaultMessage: "Anonymous Hippo"
    },
    kangaroo: {
        id: "platform.anonymous-asset-name.kangaroo",
        defaultMessage: "Anonymous Kangaroo"
    },
    kitten: {
        id: "platform.anonymous-asset-name.kitten",
        defaultMessage: "Anonymous Kitten"
    },
    kiwi: {
        id: "platform.anonymous-asset-name.kiwi",
        defaultMessage: "Anonymous Kiwi"
    },
    koala: {
        id: "platform.anonymous-asset-name.koala",
        defaultMessage: "Anonymous Koala"
    },
    lemon: {
        id: "platform.anonymous-asset-name.lemon",
        defaultMessage: "Anonymous Lemon"
    },
    leopard: {
        id: "platform.anonymous-asset-name.leopard",
        defaultMessage: "Anonymous Leopard"
    },
    lettuce: {
        id: "platform.anonymous-asset-name.lettuce",
        defaultMessage: "Anonymous Lettuce"
    },
    lion: {
        id: "platform.anonymous-asset-name.lion",
        defaultMessage: "Anonymous Lion"
    },
    lizard: {
        id: "platform.anonymous-asset-name.lizard",
        defaultMessage: "Anonymous Lizard"
    },
    llama: {
        id: "platform.anonymous-asset-name.llama",
        defaultMessage: "Anonymous Llama"
    },
    lobster: {
        id: "platform.anonymous-asset-name.lobster",
        defaultMessage: "Anonymous Lobster"
    },
    macaque: {
        id: "platform.anonymous-asset-name.macaque",
        defaultMessage: "Anonymous Macaque"
    },
    mango: {
        id: "platform.anonymous-asset-name.mango",
        defaultMessage: "Anonymous Mango"
    },
    melon: {
        id: "platform.anonymous-asset-name.melon",
        defaultMessage: "Anonymous Melon"
    },
    millipede: {
        id: "platform.anonymous-asset-name.millipede",
        defaultMessage: "Anonymous Millipede"
    },
    monkey: {
        id: "platform.anonymous-asset-name.monkey",
        defaultMessage: "Anonymous Monkey"
    },
    mouse: {
        id: "platform.anonymous-asset-name.mouse",
        defaultMessage: "Anonymous Mouse"
    },
    octopus: {
        id: "platform.anonymous-asset-name.octopus",
        defaultMessage: "Anonymous Octopus"
    },
    olive: {
        id: "platform.anonymous-asset-name.olive",
        defaultMessage: "Anonymous Olive"
    },
    orange: {
        id: "platform.anonymous-asset-name.orange",
        defaultMessage: "Anonymous Orange"
    },
    orangutan: {
        id: "platform.anonymous-asset-name.orangutan",
        defaultMessage: "Anonymous Orangutan"
    },
    otter: {
        id: "platform.anonymous-asset-name.otter",
        defaultMessage: "Anonymous Otter"
    },
    owl: {
        id: "platform.anonymous-asset-name.owl",
        defaultMessage: "Anonymous Owl"
    },
    ox: {
        id: "platform.anonymous-asset-name.ox",
        defaultMessage: "Anonymous Ox"
    },
    oyster: {
        id: "platform.anonymous-asset-name.oyster",
        defaultMessage: "Anonymous Oyster"
    },
    panda: {
        id: "platform.anonymous-asset-name.panda",
        defaultMessage: "Anonymous Panda"
    },
    parrot: {
        id: "platform.anonymous-asset-name.parrot",
        defaultMessage: "Anonymous Parrot"
    },
    peacock: {
        id: "platform.anonymous-asset-name.peacock",
        defaultMessage: "Anonymous Peacock"
    },
    pear: {
        id: "platform.anonymous-asset-name.pear",
        defaultMessage: "Anonymous Pear"
    },
    penguin: {
        id: "platform.anonymous-asset-name.penguin",
        defaultMessage: "Anonymous Penguin"
    },
    pig: {
        id: "platform.anonymous-asset-name.pig",
        defaultMessage: "Anonymous Pig"
    },
    pineapple: {
        id: "platform.anonymous-asset-name.pineapple",
        defaultMessage: "Anonymous Pineapple"
    },
    poodle: {
        id: "platform.anonymous-asset-name.poodle",
        defaultMessage: "Anonymous Poodle"
    },
    puppy: {
        id: "platform.anonymous-asset-name.puppy",
        defaultMessage: "Anonymous Puppy"
    },
    python: {
        id: "platform.anonymous-asset-name.python",
        defaultMessage: "Anonymous Python"
    },
    rabbit: {
        id: "platform.anonymous-asset-name.rabbit",
        defaultMessage: "Anonymous Rabbit"
    },
    raccoon: {
        id: "platform.anonymous-asset-name.raccoon",
        defaultMessage: "Anonymous Raccoon"
    },
    rat: {
        id: "platform.anonymous-asset-name.rat",
        defaultMessage: "Anonymous Rat"
    },
    rhino: {
        id: "platform.anonymous-asset-name.rhino",
        defaultMessage: "Anonymous Rhino"
    },
    robot: {
        id: "platform.anonymous-asset-name.robot",
        defaultMessage: "Anonymous Robot"
    },
    rose: {
        id: "platform.anonymous-asset-name.rose",
        defaultMessage: "Anonymous Rose"
    },
    seal: {
        id: "platform.anonymous-asset-name.seal",
        defaultMessage: "Anonymous Seal"
    },
    seedling: {
        id: "platform.anonymous-asset-name.seedling",
        defaultMessage: "Anonymous Seedling"
    },
    shark: {
        id: "platform.anonymous-asset-name.shark",
        defaultMessage: "Anonymous Shark"
    },
    shrimp: {
        id: "platform.anonymous-asset-name.shrimp",
        defaultMessage: "Anonymous Shrimp"
    },
    skunk: {
        id: "platform.anonymous-asset-name.skunk",
        defaultMessage: "Anonymous Skunk"
    },
    sloth: {
        id: "platform.anonymous-asset-name.sloth",
        defaultMessage: "Anonymous Sloth"
    },
    snail: {
        id: "platform.anonymous-asset-name.snail",
        defaultMessage: "Anonymous Snail"
    },
    snake: {
        id: "platform.anonymous-asset-name.snake",
        defaultMessage: "Anonymous Snake"
    },
    snowman: {
        id: "platform.anonymous-asset-name.snowman",
        defaultMessage: "Anonymous Snowman"
    },
    squid: {
        id: "platform.anonymous-asset-name.squid",
        defaultMessage: "Anonymous Squid"
    },
    squirrel: {
        id: "platform.anonymous-asset-name.squirrel",
        defaultMessage: "Anonymous Squirrel"
    },
    strawberry: {
        id: "platform.anonymous-asset-name.strawberry",
        defaultMessage: "Anonymous Strawberry"
    },
    sunfish: {
        id: "platform.anonymous-asset-name.sunfish",
        defaultMessage: "Anonymous Sunfish"
    },
    sunflower: {
        id: "platform.anonymous-asset-name.sunflower",
        defaultMessage: "Anonymous Sunflower"
    },
    tiger: {
        id: "platform.anonymous-asset-name.tiger",
        defaultMessage: "Anonymous Tiger"
    },
    tomato: {
        id: "platform.anonymous-asset-name.tomato",
        defaultMessage: "Anonymous Tomato"
    },
    tortoise: {
        id: "platform.anonymous-asset-name.tortoise",
        defaultMessage: "Anonymous Tortoise"
    },
    tree: {
        id: "platform.anonymous-asset-name.tree",
        defaultMessage: "Anonymous Tree"
    },
    trex: {
        id: "platform.anonymous-asset-name.trex",
        defaultMessage: "Anonymous T-rex"
    },
    trout: {
        id: "platform.anonymous-asset-name.trout",
        defaultMessage: "Anonymous Trout"
    },
    turkey: {
        id: "platform.anonymous-asset-name.turkey",
        defaultMessage: "Anonymous Turkey"
    },
    turtle: {
        id: "platform.anonymous-asset-name.turtle",
        defaultMessage: "Anonymous Turtle"
    },
    wasp: {
        id: "platform.anonymous-asset-name.wasp",
        defaultMessage: "Anonymous Wasp"
    },
    watermelon: {
        id: "platform.anonymous-asset-name.watermelon",
        defaultMessage: "Anonymous Watermelon"
    },
    whale: {
        id: "platform.anonymous-asset-name.whale",
        defaultMessage: "Anonymous Whale"
    },
    wolf: {
        id: "platform.anonymous-asset-name.wolf",
        defaultMessage: "Anonymous Wolf"
    }
});
module.exports["messages"] = $11f365f4e13bb9e0$export$defe85febe8b728c;

});

parcelRegister("45p5c", function(module, exports) {
module.exports = new URL("apple.ee886279.svg", import.meta.url).toString();

});

parcelRegister("66aLS", function(module, exports) {
module.exports = new URL("avocado.8855629b.svg", import.meta.url).toString();

});

parcelRegister("eA5k9", function(module, exports) {
module.exports = new URL("badger.0fb3ff8d.svg", import.meta.url).toString();

});

parcelRegister("dLHML", function(module, exports) {
module.exports = new URL("bat.3a3e8172.svg", import.meta.url).toString();

});

parcelRegister("5QM3U", function(module, exports) {
module.exports = new URL("bear.6250dade.svg", import.meta.url).toString();

});

parcelRegister("1zbJy", function(module, exports) {
module.exports = new URL("beaver.72239cbc.svg", import.meta.url).toString();

});

parcelRegister("absgL", function(module, exports) {
module.exports = new URL("bee.1d8bfe50.svg", import.meta.url).toString();

});

parcelRegister("i9wU3", function(module, exports) {
module.exports = new URL("bison.4fe77735.svg", import.meta.url).toString();

});

parcelRegister("7BD8h", function(module, exports) {
module.exports = new URL("blossom.90b2a1c3.svg", import.meta.url).toString();

});

parcelRegister("ipNYr", function(module, exports) {
module.exports = new URL("blowfish.8afad7f1.svg", import.meta.url).toString();

});

parcelRegister("5Fo99", function(module, exports) {
module.exports = new URL("blueberries.688d225d.svg", import.meta.url).toString();

});

parcelRegister("futbp", function(module, exports) {
module.exports = new URL("boar.15310caf.svg", import.meta.url).toString();

});

parcelRegister("1tL0q", function(module, exports) {
module.exports = new URL("broccoli.fa9fd55e.svg", import.meta.url).toString();

});

parcelRegister("gsqYV", function(module, exports) {
module.exports = new URL("butterfly.f41d19d4.svg", import.meta.url).toString();

});

parcelRegister("aV0Ix", function(module, exports) {
module.exports = new URL("cactus.0c5c265c.svg", import.meta.url).toString();

});

parcelRegister("7f8BP", function(module, exports) {
module.exports = new URL("camel.6111d481.svg", import.meta.url).toString();

});

parcelRegister("w2g3p", function(module, exports) {
module.exports = new URL("candy.ffd5e59f.svg", import.meta.url).toString();

});

parcelRegister("7pNkU", function(module, exports) {
module.exports = new URL("capsicum.30f76734.svg", import.meta.url).toString();

});

parcelRegister("3saEQ", function(module, exports) {
module.exports = new URL("carrot.6193f6d7.svg", import.meta.url).toString();

});

parcelRegister("bBrvm", function(module, exports) {
module.exports = new URL("cat.154e1595.svg", import.meta.url).toString();

});

parcelRegister("2MJ1F", function(module, exports) {
module.exports = new URL("caterpiller.1b6fd239.svg", import.meta.url).toString();

});

parcelRegister("62PyO", function(module, exports) {
module.exports = new URL("cherry.087938da.svg", import.meta.url).toString();

});

parcelRegister("ct5mQ", function(module, exports) {
module.exports = new URL("chili.27401d1a.svg", import.meta.url).toString();

});

parcelRegister("geCWF", function(module, exports) {
module.exports = new URL("clover.296ea840.svg", import.meta.url).toString();

});

parcelRegister("cA6yA", function(module, exports) {
module.exports = new URL("coconut.69480f00.svg", import.meta.url).toString();

});

parcelRegister("gE9fP", function(module, exports) {
module.exports = new URL("cookie.099bb841.svg", import.meta.url).toString();

});

parcelRegister("6Cmrb", function(module, exports) {
module.exports = new URL("corn.f527dc60.svg", import.meta.url).toString();

});

parcelRegister("7Za1I", function(module, exports) {
module.exports = new URL("cow.e41482e6.svg", import.meta.url).toString();

});

parcelRegister("kgPFA", function(module, exports) {
module.exports = new URL("crab.39812367.svg", import.meta.url).toString();

});

parcelRegister("2hRuV", function(module, exports) {
module.exports = new URL("crocodile.221fa99c.svg", import.meta.url).toString();

});

parcelRegister("8H1nG", function(module, exports) {
module.exports = new URL("deer.3662e324.svg", import.meta.url).toString();

});

parcelRegister("jfdMm", function(module, exports) {
module.exports = new URL("dinosaur.e5c6efb5.svg", import.meta.url).toString();

});

parcelRegister("jAnMk", function(module, exports) {
module.exports = new URL("dodo.a7114237.svg", import.meta.url).toString();

});

parcelRegister("kiped", function(module, exports) {
module.exports = new URL("dog.6630bd37.svg", import.meta.url).toString();

});

parcelRegister("ijRK6", function(module, exports) {
module.exports = new URL("dolphin.3052ec02.svg", import.meta.url).toString();

});

parcelRegister("hQTrZ", function(module, exports) {
module.exports = new URL("donut.e4649522.svg", import.meta.url).toString();

});

parcelRegister("3ussC", function(module, exports) {
module.exports = new URL("dragon.4b6d8278.svg", import.meta.url).toString();

});

parcelRegister("bfQlR", function(module, exports) {
module.exports = new URL("duck.e8819dfa.svg", import.meta.url).toString();

});

parcelRegister("g2zNl", function(module, exports) {
module.exports = new URL("elephant.f64545b1.svg", import.meta.url).toString();

});

parcelRegister("dnUXX", function(module, exports) {
module.exports = new URL("fish.91063cf4.svg", import.meta.url).toString();

});

parcelRegister("ldCFU", function(module, exports) {
module.exports = new URL("flamingo.2d59f884.svg", import.meta.url).toString();

});

parcelRegister("gcvuo", function(module, exports) {
module.exports = new URL("fox.c1068dfa.svg", import.meta.url).toString();

});

parcelRegister("3aulr", function(module, exports) {
module.exports = new URL("frog.4c69f05a.svg", import.meta.url).toString();

});

parcelRegister("jj7JF", function(module, exports) {
module.exports = new URL("giraffe.65216e18.svg", import.meta.url).toString();

});

parcelRegister("gFh8H", function(module, exports) {
module.exports = new URL("gorilla.51f05093.svg", import.meta.url).toString();

});

parcelRegister("ib1i9", function(module, exports) {
module.exports = new URL("grapes.6a50728f.svg", import.meta.url).toString();

});

parcelRegister("7vWf2", function(module, exports) {
module.exports = new URL("hedgehog.4cc9668b.svg", import.meta.url).toString();

});

parcelRegister("MAw5A", function(module, exports) {
module.exports = new URL("hippo.81684e99.svg", import.meta.url).toString();

});

parcelRegister("4R6fR", function(module, exports) {
module.exports = new URL("kangaroo.099f9dd4.svg", import.meta.url).toString();

});

parcelRegister("3G8sv", function(module, exports) {
module.exports = new URL("kiwi.13ce1a05.svg", import.meta.url).toString();

});

parcelRegister("5L3ZL", function(module, exports) {
module.exports = new URL("koala.730a01eb.svg", import.meta.url).toString();

});

parcelRegister("1tIXy", function(module, exports) {
module.exports = new URL("lemon.7d7dfe19.svg", import.meta.url).toString();

});

parcelRegister("gIr5o", function(module, exports) {
module.exports = new URL("lettuce.39b86ec6.svg", import.meta.url).toString();

});

parcelRegister("jMi9Z", function(module, exports) {
module.exports = new URL("lion.191125b1.svg", import.meta.url).toString();

});

parcelRegister("5fTd1", function(module, exports) {
module.exports = new URL("lizard.de3c3103.svg", import.meta.url).toString();

});

parcelRegister("70IXo", function(module, exports) {
module.exports = new URL("llama.d767d641.svg", import.meta.url).toString();

});

parcelRegister("k45BN", function(module, exports) {
module.exports = new URL("lobster.2b4a4d94.svg", import.meta.url).toString();

});

parcelRegister("5t7IX", function(module, exports) {
module.exports = new URL("mango.6b9252cb.svg", import.meta.url).toString();

});

parcelRegister("7y9m7", function(module, exports) {
module.exports = new URL("melon.9c97f1e1.svg", import.meta.url).toString();

});

parcelRegister("kRP7t", function(module, exports) {
module.exports = new URL("monkey.423f2177.svg", import.meta.url).toString();

});

parcelRegister("dLJHp", function(module, exports) {
module.exports = new URL("mouse.3d0aefe8.svg", import.meta.url).toString();

});

parcelRegister("MvguA", function(module, exports) {
module.exports = new URL("octopus.2c0d1056.svg", import.meta.url).toString();

});

parcelRegister("i2wVj", function(module, exports) {
module.exports = new URL("olive.3e3e2c53.svg", import.meta.url).toString();

});

parcelRegister("bqNy3", function(module, exports) {
module.exports = new URL("orange.ed5e97f9.svg", import.meta.url).toString();

});

parcelRegister("5RzHY", function(module, exports) {
module.exports = new URL("orangutan.9fa13362.svg", import.meta.url).toString();

});

parcelRegister("jN43s", function(module, exports) {
module.exports = new URL("otter.1b9e17fe.svg", import.meta.url).toString();

});

parcelRegister("018bO", function(module, exports) {
module.exports = new URL("owl.13d3c4d9.svg", import.meta.url).toString();

});

parcelRegister("c3T8r", function(module, exports) {
module.exports = new URL("ox.0ed06fd3.svg", import.meta.url).toString();

});

parcelRegister("h0256", function(module, exports) {
module.exports = new URL("oyster.ad23795d.svg", import.meta.url).toString();

});

parcelRegister("8O3eM", function(module, exports) {
module.exports = new URL("panda.0b0047af.svg", import.meta.url).toString();

});

parcelRegister("8BcsQ", function(module, exports) {
module.exports = new URL("parrot.6fd92eec.svg", import.meta.url).toString();

});

parcelRegister("ctuOo", function(module, exports) {
module.exports = new URL("peacock.80ac60a6.svg", import.meta.url).toString();

});

parcelRegister("9wms3", function(module, exports) {
module.exports = new URL("pear.c8d37fb0.svg", import.meta.url).toString();

});

parcelRegister("1j7TY", function(module, exports) {
module.exports = new URL("penguin.6577e559.svg", import.meta.url).toString();

});

parcelRegister("4ux8O", function(module, exports) {
module.exports = new URL("pig.2ba131ea.svg", import.meta.url).toString();

});

parcelRegister("44Sb4", function(module, exports) {
module.exports = new URL("pineapple.61ebb967.svg", import.meta.url).toString();

});

parcelRegister("dQMZo", function(module, exports) {
module.exports = new URL("poodle.b40487d6.svg", import.meta.url).toString();

});

parcelRegister("zYoHs", function(module, exports) {
module.exports = new URL("rabbit.b4ce71c1.svg", import.meta.url).toString();

});

parcelRegister("04PGh", function(module, exports) {
module.exports = new URL("raccoon.16b4372e.svg", import.meta.url).toString();

});

parcelRegister("ddSO1", function(module, exports) {
module.exports = new URL("rhino.6dcdebb2.svg", import.meta.url).toString();

});

parcelRegister("ivVMv", function(module, exports) {
module.exports = new URL("robot.fdf311ba.svg", import.meta.url).toString();

});

parcelRegister("eJnd2", function(module, exports) {
module.exports = new URL("rose.22a6e8e6.svg", import.meta.url).toString();

});

parcelRegister("98ut7", function(module, exports) {
module.exports = new URL("seal.de226e3b.svg", import.meta.url).toString();

});

parcelRegister("9q1Vk", function(module, exports) {
module.exports = new URL("seedling.562f3bc0.svg", import.meta.url).toString();

});

parcelRegister("eMHgQ", function(module, exports) {
module.exports = new URL("shark.af44e0c5.svg", import.meta.url).toString();

});

parcelRegister("3LKHJ", function(module, exports) {
module.exports = new URL("shrimp.116d9eea.svg", import.meta.url).toString();

});

parcelRegister("3ZCOi", function(module, exports) {
module.exports = new URL("skunk.a5578a4f.svg", import.meta.url).toString();

});

parcelRegister("5xoX8", function(module, exports) {
module.exports = new URL("sloth.f3e9da22.svg", import.meta.url).toString();

});

parcelRegister("5qhol", function(module, exports) {
module.exports = new URL("snail.06380b65.svg", import.meta.url).toString();

});

parcelRegister("dGRYO", function(module, exports) {
module.exports = new URL("snake.3ead898b.svg", import.meta.url).toString();

});

parcelRegister("6dhVt", function(module, exports) {
module.exports = new URL("snowman.cdcd9574.svg", import.meta.url).toString();

});

parcelRegister("ighEF", function(module, exports) {
module.exports = new URL("squid.0638299b.svg", import.meta.url).toString();

});

parcelRegister("jiyfa", function(module, exports) {
module.exports = new URL("squirrel.e3a31ee3.svg", import.meta.url).toString();

});

parcelRegister("aRWto", function(module, exports) {
module.exports = new URL("strawberry.4111dfb6.svg", import.meta.url).toString();

});

parcelRegister("3VNps", function(module, exports) {
module.exports = new URL("sunflower.ff291a55.svg", import.meta.url).toString();

});

parcelRegister("62BuW", function(module, exports) {
module.exports = new URL("tiger.2ba2da26.svg", import.meta.url).toString();

});

parcelRegister("54a3y", function(module, exports) {
module.exports = new URL("tomato.e755033f.svg", import.meta.url).toString();

});

parcelRegister("cjnzF", function(module, exports) {
module.exports = new URL("tree.e62f2602.svg", import.meta.url).toString();

});

parcelRegister("faukZ", function(module, exports) {
module.exports = new URL("t-rex.d85831fb.svg", import.meta.url).toString();

});

parcelRegister("Ox4am", function(module, exports) {
module.exports = new URL("tropical-fish.797d455e.svg", import.meta.url).toString();

});

parcelRegister("hembw", function(module, exports) {
module.exports = new URL("turkey.a79defab.svg", import.meta.url).toString();

});

parcelRegister("5gEBh", function(module, exports) {
module.exports = new URL("turtle.acbe0058.svg", import.meta.url).toString();

});

parcelRegister("76eQq", function(module, exports) {
module.exports = new URL("watermelon.199e013c.svg", import.meta.url).toString();

});

parcelRegister("68Yx0", function(module, exports) {
module.exports = new URL("whale.cc048b8e.svg", import.meta.url).toString();

});

parcelRegister("l08I5", function(module, exports) {
module.exports = new URL("wolf.a39956da.svg", import.meta.url).toString();

});

parcelRegister("fDtVg", function(module, exports) {

var $1e2E5 = parcelRequire("1e2E5");

var $fI8ba = parcelRequire("fI8ba");


var $hTKp4 = parcelRequire("hTKp4");


var $eUBDm = parcelRequire("eUBDm");


var $hFOxw = parcelRequire("hFOxw");

const $9e6967f04f453315$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $9e6967f04f453315$var$intlCacheMap = new Map();
const $9e6967f04f453315$export$51771ec7613ad564 = async ()=>{
    const key = (0, $hTKp4.getDocument)()?.documentElement?.lang || 'en-US';
    if (!$9e6967f04f453315$var$intlCacheMap.has(key)) {
        const messages = await $9e6967f04f453315$var$fetchMessages(key);
        const cache = (0, $fI8ba.createIntlCache)();
        const intl = (0, $1e2E5.createIntl)({
            locale: key,
            messages: messages
        }, cache);
        $9e6967f04f453315$var$intlCacheMap.set(key, intl);
    }
    return $9e6967f04f453315$var$intlCacheMap.get(key);
};
const $9e6967f04f453315$var$fetchMessages = async (locale)=>{
    try {
        const targetLocale = ($9e6967f04f453315$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $eUBDm.locales)) {
            const messages = await (0, $eUBDm.locales)[targetLocale]();
            return messages.default;
        }
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $eUBDm.locales)) {
            const messages = await (0, $eUBDm.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
   * English bundled by default as this is the majority of users
   */ return 0, $hFOxw.default;
};
module.exports["getIntl"] = $9e6967f04f453315$export$51771ec7613ad564;

});

parcelRegister("eUBDm", function(module, exports) {




























const $6e63713db070a09c$export$df1c34db1371eeed = {
    en: ()=>Promise.resolve((parcelRequire("hFOxw"))),
    cs: ()=>(parcelRequire("kc8TR")),
    da: ()=>(parcelRequire("l3Kdd")),
    de: ()=>(parcelRequire("69yb2")),
    en_GB: ()=>(parcelRequire("cSOaW")),
    en_ZZ: ()=>(parcelRequire("ctTgM")),
    es: ()=>(parcelRequire("7UFmH")),
    fi: ()=>(parcelRequire("9H5BD")),
    fr: ()=>(parcelRequire("gXf6j")),
    hr: ()=>(parcelRequire("3qf4b")),
    hu: ()=>(parcelRequire("d7gDR")),
    it: ()=>(parcelRequire("l2XrF")),
    ja: ()=>(parcelRequire("VVLwh")),
    ko: ()=>(parcelRequire("8mka3")),
    nb: ()=>(parcelRequire("16UCW")),
    nl: ()=>(parcelRequire("6xRKn")),
    pl: ()=>(parcelRequire("1tICX")),
    pt_BR: ()=>(parcelRequire("1nGwo")),
    ru: ()=>(parcelRequire("aVCyQ")),
    sr_RS: ()=>(parcelRequire("gJHrP")),
    sr_YR: ()=>(parcelRequire("lmyN0")),
    sv: ()=>(parcelRequire("fgOYH")),
    th: ()=>(parcelRequire("iASA2")),
    tr: ()=>(parcelRequire("gK9Le")),
    uk: ()=>(parcelRequire("5TJ1f")),
    vi: ()=>(parcelRequire("aaIRG")),
    zh: ()=>(parcelRequire("9nWlJ")),
    zh_TW: ()=>(parcelRequire("4oaks"))
};
module.exports["locales"] = $6e63713db070a09c$export$df1c34db1371eeed;

});

parcelRegister("kc8TR", function(module, exports) {

let $eb3bd4f74933f558$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb3bd4f74933f558$var$load("jMBLi").then(()=>parcelRequire('7ZLoJ'));

});

parcelRegister("l3Kdd", function(module, exports) {

let $f54db99165770b8b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f54db99165770b8b$var$load("dKSPa").then(()=>parcelRequire('aEN3l'));

});

parcelRegister("69yb2", function(module, exports) {

let $0127f821ddfc863b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0127f821ddfc863b$var$load("aNGGp").then(()=>parcelRequire('33xoI'));

});

parcelRegister("cSOaW", function(module, exports) {

let $961172f85f6e3edb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $961172f85f6e3edb$var$load("16eqk").then(()=>parcelRequire('kWJx6'));

});

parcelRegister("ctTgM", function(module, exports) {

let $916310dbaec8ddd8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $916310dbaec8ddd8$var$load("smHwh").then(()=>parcelRequire('dbZYo'));

});

parcelRegister("7UFmH", function(module, exports) {

let $5c2dd99cb70ac8a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5c2dd99cb70ac8a2$var$load("lLAhl").then(()=>parcelRequire('9KFoy'));

});

parcelRegister("9H5BD", function(module, exports) {

let $70ec7a6fe087c63a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70ec7a6fe087c63a$var$load("7lUpZ").then(()=>parcelRequire('4qdbO'));

});

parcelRegister("gXf6j", function(module, exports) {

let $c57ddebbf836b105$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c57ddebbf836b105$var$load("iFuRL").then(()=>parcelRequire('bIVe0'));

});

parcelRegister("3qf4b", function(module, exports) {

let $27df7cab7356feaf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $27df7cab7356feaf$var$load("bwpap").then(()=>parcelRequire('8NtSc'));

});

parcelRegister("d7gDR", function(module, exports) {

let $98c8d68f3df49e25$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $98c8d68f3df49e25$var$load("2qkmI").then(()=>parcelRequire('cGCVy'));

});

parcelRegister("l2XrF", function(module, exports) {

let $f527e57b693e6f21$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f527e57b693e6f21$var$load("kxYID").then(()=>parcelRequire('9bmhY'));

});

parcelRegister("VVLwh", function(module, exports) {

let $0ae221fff906b001$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ae221fff906b001$var$load("iHsNL").then(()=>parcelRequire('51o1K'));

});

parcelRegister("8mka3", function(module, exports) {

let $6160045ed2e1ab4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6160045ed2e1ab4f$var$load("jGOT0").then(()=>parcelRequire('gLajM'));

});

parcelRegister("16UCW", function(module, exports) {

let $0cf246f0069fd885$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0cf246f0069fd885$var$load("3s5dS").then(()=>parcelRequire('2zKQ5'));

});

parcelRegister("6xRKn", function(module, exports) {

let $4c3f843445da2586$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c3f843445da2586$var$load("ffRdF").then(()=>parcelRequire('1nf4f'));

});

parcelRegister("1tICX", function(module, exports) {

let $113b1df702e7a97e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $113b1df702e7a97e$var$load("bS9i1").then(()=>parcelRequire('8l63g'));

});

parcelRegister("1nGwo", function(module, exports) {

let $1018ec47e040097d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1018ec47e040097d$var$load("3ydLu").then(()=>parcelRequire('asVO6'));

});

parcelRegister("aVCyQ", function(module, exports) {

let $7f4d23afc1ab1ef8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f4d23afc1ab1ef8$var$load("lqmbR").then(()=>parcelRequire('FrAje'));

});

parcelRegister("gJHrP", function(module, exports) {

let $c2f28d20061ad1be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c2f28d20061ad1be$var$load("3px1j").then(()=>parcelRequire('54f3C'));

});

parcelRegister("lmyN0", function(module, exports) {

let $f8d6a37afb93b948$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f8d6a37afb93b948$var$load("1NiRW").then(()=>parcelRequire('3pGwL'));

});

parcelRegister("fgOYH", function(module, exports) {

let $b1dfe4ceecde867c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1dfe4ceecde867c$var$load("auBTD").then(()=>parcelRequire('5D8Rs'));

});

parcelRegister("iASA2", function(module, exports) {

let $d895ed4bca06a46b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d895ed4bca06a46b$var$load("fxn2i").then(()=>parcelRequire('aWxTt'));

});

parcelRegister("gK9Le", function(module, exports) {

let $c30883821cb64545$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c30883821cb64545$var$load("adwGb").then(()=>parcelRequire('34LZI'));

});

parcelRegister("5TJ1f", function(module, exports) {

let $44b502b0c10ff069$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44b502b0c10ff069$var$load("guUGa").then(()=>parcelRequire('2u29z'));

});

parcelRegister("aaIRG", function(module, exports) {

let $767da3c31aa6ce24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $767da3c31aa6ce24$var$load("9bAgX").then(()=>parcelRequire('clDBP'));

});

parcelRegister("9nWlJ", function(module, exports) {

let $01c369634d8d2eb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $01c369634d8d2eb9$var$load("HLzfe").then(()=>parcelRequire('9dypO'));

});

parcelRegister("4oaks", function(module, exports) {

let $33216a6e72302c57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33216a6e72302c57$var$load("in5qk").then(()=>parcelRequire('2iJQj'));

});

parcelRegister("hFOxw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1afed9367fc4c445$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $1afed9367fc4c445$export$2e2bcd8739ae039 = {
    'platform.anonymous-asset-name.alligator': 'Anonymous Alligator',
    'platform.anonymous-asset-name.alpaca': 'Anonymous Alpaca',
    'platform.anonymous-asset-name.ape': 'Anonymous Ape',
    'platform.anonymous-asset-name.apple': 'Anonymous Apple',
    'platform.anonymous-asset-name.avocado': 'Anonymous Avocado',
    'platform.anonymous-asset-name.baboon': 'Anonymous Baboon',
    'platform.anonymous-asset-name.badger': 'Anonymous Badger',
    'platform.anonymous-asset-name.bat': 'Anonymous Bat',
    'platform.anonymous-asset-name.bear': 'Anonymous Bear',
    'platform.anonymous-asset-name.beaver': 'Anonymous Beaver',
    'platform.anonymous-asset-name.bee': 'Anonymous Bee',
    'platform.anonymous-asset-name.bird': 'Anonymous Bird',
    'platform.anonymous-asset-name.bison': 'Anonymous Bison',
    'platform.anonymous-asset-name.blobfish': 'Anonymous Blobfish',
    'platform.anonymous-asset-name.blossom': 'Anonymous Blossom',
    'platform.anonymous-asset-name.blowfish': 'Anonymous Blowfish',
    'platform.anonymous-asset-name.blueberries': 'Anonymous Blueberries',
    'platform.anonymous-asset-name.boar': 'Anonymous Boar',
    'platform.anonymous-asset-name.broccoli': 'Anonymous Broccoli',
    'platform.anonymous-asset-name.buffalo': 'Anonymous Buffalo',
    'platform.anonymous-asset-name.bug': 'Anonymous Bug',
    'platform.anonymous-asset-name.bull': 'Anonymous Bull',
    'platform.anonymous-asset-name.bunny': 'Anonymous Bunny',
    'platform.anonymous-asset-name.butterfly': 'Anonymous Butterfly',
    'platform.anonymous-asset-name.cactus': 'Anonymous Cactus',
    'platform.anonymous-asset-name.camel': 'Anonymous Camel',
    'platform.anonymous-asset-name.candy': 'Anonymous Candy',
    'platform.anonymous-asset-name.cantaloupe': 'Anonymous Cantaloupe',
    'platform.anonymous-asset-name.capsicum': 'Anonymous Capsicum',
    'platform.anonymous-asset-name.carrot': 'Anonymous Carrot',
    'platform.anonymous-asset-name.cat': 'Anonymous Cat',
    'platform.anonymous-asset-name.caterpiller': 'Anonymous Caterpiller',
    'platform.anonymous-asset-name.chameleon': 'Anonymous Chameleon',
    'platform.anonymous-asset-name.cherry': 'Anonymous Cherry',
    'platform.anonymous-asset-name.chili': 'Anonymous Chili',
    'platform.anonymous-asset-name.chimp': 'Anonymous Chimp',
    'platform.anonymous-asset-name.chimpanzee': 'Anonymous Chimpanzee',
    'platform.anonymous-asset-name.clover': 'Anonymous Clover',
    'platform.anonymous-asset-name.clownfish': 'Anonymous Clownfish',
    'platform.anonymous-asset-name.cobra': 'Anonymous Cobra',
    'platform.anonymous-asset-name.coconut': 'Anonymous Coconut',
    'platform.anonymous-asset-name.cod': 'Anonymous Cod',
    'platform.anonymous-asset-name.cookie': 'Anonymous Cookie',
    'platform.anonymous-asset-name.corn': 'Anonymous Corn',
    'platform.anonymous-asset-name.cow': 'Anonymous Cow',
    'platform.anonymous-asset-name.crab': 'Anonymous Crab',
    'platform.anonymous-asset-name.crocodile': 'Anonymous Crocodile',
    'platform.anonymous-asset-name.deer': 'Anonymous Deer',
    'platform.anonymous-asset-name.dinosaur': 'Anonymous Dinosaur',
    'platform.anonymous-asset-name.dodo': 'Anonymous Dodo',
    'platform.anonymous-asset-name.dog': 'Anonymous Dog',
    'platform.anonymous-asset-name.dolphin': 'Anonymous Dolphin',
    'platform.anonymous-asset-name.donut': 'Anonymous Donut',
    'platform.anonymous-asset-name.dragon': 'Anonymous Dragon',
    'platform.anonymous-asset-name.duck': 'Anonymous Duck',
    'platform.anonymous-asset-name.elephant': 'Anonymous Elephant',
    'platform.anonymous-asset-name.elk': 'Anonymous Elk',
    'platform.anonymous-asset-name.fish': 'Anonymous Fish',
    'platform.anonymous-asset-name.flamingo': 'Anonymous Flamingo',
    'platform.anonymous-asset-name.fox': 'Anonymous Fox',
    'platform.anonymous-asset-name.frog': 'Anonymous Frog',
    'platform.anonymous-asset-name.gecko': 'Anonymous Gecko',
    'platform.anonymous-asset-name.giraffe': 'Anonymous Giraffe',
    'platform.anonymous-asset-name.gorilla': 'Anonymous Gorilla',
    'platform.anonymous-asset-name.grape': 'Anonymous Grape',
    'platform.anonymous-asset-name.hammerhead': 'Anonymous Hammerhead',
    'platform.anonymous-asset-name.hedgehog': 'Anonymous Hedgehog',
    'platform.anonymous-asset-name.hippo': 'Anonymous Hippo',
    'platform.anonymous-asset-name.kangaroo': 'Anonymous Kangaroo',
    'platform.anonymous-asset-name.kitten': 'Anonymous Kitten',
    'platform.anonymous-asset-name.kiwi': 'Anonymous Kiwi',
    'platform.anonymous-asset-name.koala': 'Anonymous Koala',
    'platform.anonymous-asset-name.lemon': 'Anonymous Lemon',
    'platform.anonymous-asset-name.leopard': 'Anonymous Leopard',
    'platform.anonymous-asset-name.lettuce': 'Anonymous Lettuce',
    'platform.anonymous-asset-name.lion': 'Anonymous Lion',
    'platform.anonymous-asset-name.lizard': 'Anonymous Lizard',
    'platform.anonymous-asset-name.llama': 'Anonymous Llama',
    'platform.anonymous-asset-name.lobster': 'Anonymous Lobster',
    'platform.anonymous-asset-name.macaque': 'Anonymous Macaque',
    'platform.anonymous-asset-name.mango': 'Anonymous Mango',
    'platform.anonymous-asset-name.melon': 'Anonymous Melon',
    'platform.anonymous-asset-name.millipede': 'Anonymous Millipede',
    'platform.anonymous-asset-name.monkey': 'Anonymous Monkey',
    'platform.anonymous-asset-name.mouse': 'Anonymous Mouse',
    'platform.anonymous-asset-name.octopus': 'Anonymous Octopus',
    'platform.anonymous-asset-name.olive': 'Anonymous Olive',
    'platform.anonymous-asset-name.orange': 'Anonymous Orange',
    'platform.anonymous-asset-name.orangutan': 'Anonymous Orangutan',
    'platform.anonymous-asset-name.otter': 'Anonymous Otter',
    'platform.anonymous-asset-name.owl': 'Anonymous Owl',
    'platform.anonymous-asset-name.ox': 'Anonymous Ox',
    'platform.anonymous-asset-name.oyster': 'Anonymous Oyster',
    'platform.anonymous-asset-name.panda': 'Anonymous Panda',
    'platform.anonymous-asset-name.parrot': 'Anonymous Parrot',
    'platform.anonymous-asset-name.peacock': 'Anonymous Peacock',
    'platform.anonymous-asset-name.pear': 'Anonymous Pear',
    'platform.anonymous-asset-name.penguin': 'Anonymous Penguin',
    'platform.anonymous-asset-name.pig': 'Anonymous Pig',
    'platform.anonymous-asset-name.pineapple': 'Anonymous Pineapple',
    'platform.anonymous-asset-name.poodle': 'Anonymous Poodle',
    'platform.anonymous-asset-name.puppy': 'Anonymous Puppy',
    'platform.anonymous-asset-name.python': 'Anonymous Python',
    'platform.anonymous-asset-name.rabbit': 'Anonymous Rabbit',
    'platform.anonymous-asset-name.raccoon': 'Anonymous Raccoon',
    'platform.anonymous-asset-name.rat': 'Anonymous Rat',
    'platform.anonymous-asset-name.rhino': 'Anonymous Rhino',
    'platform.anonymous-asset-name.robot': 'Anonymous Robot',
    'platform.anonymous-asset-name.rose': 'Anonymous Rose',
    'platform.anonymous-asset-name.seal': 'Anonymous Seal',
    'platform.anonymous-asset-name.seedling': 'Anonymous Seedling',
    'platform.anonymous-asset-name.shark': 'Anonymous Shark',
    'platform.anonymous-asset-name.shrimp': 'Anonymous Shrimp',
    'platform.anonymous-asset-name.skunk': 'Anonymous Skunk',
    'platform.anonymous-asset-name.sloth': 'Anonymous Sloth',
    'platform.anonymous-asset-name.snail': 'Anonymous Snail',
    'platform.anonymous-asset-name.snake': 'Anonymous Snake',
    'platform.anonymous-asset-name.snowman': 'Anonymous Snowman',
    'platform.anonymous-asset-name.squid': 'Anonymous Squid',
    'platform.anonymous-asset-name.squirrel': 'Anonymous Squirrel',
    'platform.anonymous-asset-name.strawberry': 'Anonymous Strawberry',
    'platform.anonymous-asset-name.sunfish': 'Anonymous Sunfish',
    'platform.anonymous-asset-name.sunflower': 'Anonymous Sunflower',
    'platform.anonymous-asset-name.tiger': 'Anonymous Tiger',
    'platform.anonymous-asset-name.tomato': 'Anonymous Tomato',
    'platform.anonymous-asset-name.tortoise': 'Anonymous Tortoise',
    'platform.anonymous-asset-name.tree': 'Anonymous Tree',
    'platform.anonymous-asset-name.trex': 'Anonymous T-rex',
    'platform.anonymous-asset-name.trout': 'Anonymous Trout',
    'platform.anonymous-asset-name.turkey': 'Anonymous Turkey',
    'platform.anonymous-asset-name.turtle': 'Anonymous Turtle',
    'platform.anonymous-asset-name.wasp': 'Anonymous Wasp',
    'platform.anonymous-asset-name.watermelon': 'Anonymous Watermelon',
    'platform.anonymous-asset-name.whale': 'Anonymous Whale',
    'platform.anonymous-asset-name.wolf': 'Anonymous Wolf'
};

});

parcelRegister("99F08", function(module, exports) {
const $a1227471ca9b2621$export$435a991cb82816ff = (retryCount, initialDelay = 1000, maxDelay = 30000, factor = 2)=>{
    // Calculate exponential backoff
    const delay = Math.min(initialDelay * Math.pow(factor, retryCount), maxDelay);
    // Add random jitter (between 0 and current delay value)
    return Math.floor(Math.random() * delay);
};
const $a1227471ca9b2621$export$cffaac380b94df26 = async ({ url: url, options: options, shouldRetryOnApiError: shouldRetryOnApiError, retries: retries = 3, baseDelay: baseDelay = 300, maxDelay: maxDelay = 10000 })=>{
    try {
        const response = await fetch(url, options);
        if (response.ok) return {
            success: true,
            result: response
        };
        if (shouldRetryOnApiError) throw new Error('Failed request with an error');
        const errorBody = await response.json();
        return {
            success: false,
            error: new Error(errorBody)
        };
    } catch (error) {
        if (retries > 0) {
            const retryDelay = $a1227471ca9b2621$export$435a991cb82816ff(retries, baseDelay, maxDelay);
            await new Promise((resolve)=>setTimeout(resolve, retryDelay));
            return $a1227471ca9b2621$export$cffaac380b94df26({
                url: url,
                options: options,
                shouldRetryOnApiError: shouldRetryOnApiError,
                retries: retries - 1,
                baseDelay: baseDelay,
                maxDelay: maxDelay
            });
        }
        const newError = error instanceof Error ? error : new Error('An unknown error occurred');
        return {
            success: false,
            error: newError
        };
    }
};
module.exports["fetchWithRetry"] = $a1227471ca9b2621$export$cffaac380b94df26;

});

parcelRegister("5Za2S", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");


var $04e9M = parcelRequire("04e9M");


var $9137z = parcelRequire("9137z");


var $j8hiR = parcelRequire("j8hiR");


var $747ya = parcelRequire("747ya");


var $iby4Y = parcelRequire("iby4Y");

const $8ae4f0f25e352c24$var$STATUS_NOT_FOUND = 404;
const $8ae4f0f25e352c24$var$performRecovery = async (contentId)=>{
    return (0, $iby4Y.experimentalResetCollabServiceMutate)({
        variables: {
            behind: 'COLLAB',
            contentId: contentId
        }
    });
};
const $8ae4f0f25e352c24$var$fireDraftFailureEvent = (error, recoverySucceeded, recoveryError)=>{
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            source: 'NativeCollabProvider',
            action: 'getDraft',
            actionSubject: 'failure',
            attributes: {
                error: error,
                recoverySucceeded: recoverySucceeded,
                recoveryError: recoveryError
            }
        });
    });
};
const $8ae4f0f25e352c24$var$fireDraftFetchEvent = (state)=>{
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            source: 'NativeCollabProvider',
            action: 'sentRequest',
            actionSubject: 'NcsDraftEndpoint',
            attributes: {
                state: state
            }
        });
    });
};
const $8ae4f0f25e352c24$var$fetchDraftPromiseWithMetrics = (fetchDraftPromise)=>{
    return fetchDraftPromise.then((response)=>{
        if (response.error) $8ae4f0f25e352c24$var$fireDraftFetchEvent('failure');
        else $8ae4f0f25e352c24$var$fireDraftFetchEvent('success');
        return response;
    }).catch((error)=>{
        $8ae4f0f25e352c24$var$fireDraftFetchEvent('failure');
        throw error;
    });
};
const $8ae4f0f25e352c24$export$1a473231c51c1d5b = (contentId, draftShareId)=>$8ae4f0f25e352c24$export$9a3b244f90691dba(contentId, (0, $747ya.fetchDraft)(contentId, draftShareId));
const $8ae4f0f25e352c24$export$9a3b244f90691dba = (contentId, fetchDraftPromise)=>{
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT);
    return $8ae4f0f25e352c24$var$fetchDraftPromiseWithMetrics(fetchDraftPromise).then(async ({ draft: draft })=>{
        (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT);
        if (draft) {
            const version = draft?.version;
            if (!version) {
                (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                    client.sendOperationalEvent({
                        source: 'NativeCollabProvider',
                        action: 'getDraft',
                        actionSubject: 'version is 0',
                        attributes: {
                            version: version
                        }
                    });
                });
                return null;
            }
            return draft;
        }
        return null;
    }).catch((error)=>{
        (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT);
        if (error instanceof (0, $hBkCm.BadStatusError) && error?.response?.status === $8ae4f0f25e352c24$var$STATUS_NOT_FOUND) return $8ae4f0f25e352c24$var$performRecovery(contentId).then((_recoveryResponse)=>{
            $8ae4f0f25e352c24$var$fireDraftFailureEvent(error, true);
            return null;
        }).catch((recoveryError)=>{
            $8ae4f0f25e352c24$var$fireDraftFailureEvent(error, false, recoveryError);
            return null;
        });
        $8ae4f0f25e352c24$var$fireDraftFailureEvent(error, null);
        return null;
    });
};
module.exports["getDraft"] = $8ae4f0f25e352c24$export$1a473231c51c1d5b;
module.exports["getDraftFromPromise"] = $8ae4f0f25e352c24$export$9a3b244f90691dba;

});

parcelRegister("747ya", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $7ZQNA = parcelRequire("7ZQNA");

async function $67d2826966f59cb2$export$af6160a01d539948(contentId, draftShareId) {
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const response = await (0, $hp2SH.getApolloClient)().query({
        query: (0, $7ZQNA.CollabDraftQuery),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'network-only'
    });
    const { data: data, errors: errors } = response;
    if (errors || !data.collabDraft) return {
        draft: null,
        response: response
    };
    const { document: document, version: version, metadata: metadata } = data.collabDraft;
    const draft = {
        version: version,
        metadata: $67d2826966f59cb2$var$excludeTypename(metadata),
        document: JSON.parse(document || '')
    };
    return {
        draft: draft,
        response: response
    };
}
function $67d2826966f59cb2$var$excludeTypename(metadata) {
    if (!metadata) return metadata;
    const { __typename: __typename, ...rest } = metadata;
    return rest;
}
module.exports["fetchDraft"] = $67d2826966f59cb2$export$af6160a01d539948;

});

parcelRegister("iby4Y", function(module, exports) {

var $4GGNn = parcelRequire("4GGNn");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

var $9kGfD = parcelRequire("9kGfD");


var $b4EKK = parcelRequire("b4EKK");

const $41df7c78720ad922$export$6d7c9d246960833d = ({ variables: variables })=>{
    return (0, $4GGNn.experimentalMutate)({
        url: `/wiki/rest/collab/1.0/content/${variables.contentId}/reset?behind=${variables.behind || 'COLLAB'}`,
        method: 'PUT',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        parseResponseOnSuccess: (response)=>({
                traceId: (0, $9kGfD.getTraceIdFromResponse)(response) ?? ''
            }),
        parseResult: (response)=>({
                experimentalResetCollabService: {
                    traceId: response.traceId
                }
            })
    }).catch(async (error)=>{
        const response = error instanceof (0, $hBkCm.BadStatusError) ? error.response : undefined;
        if (response) throw (0, $b4EKK.getErrorWithResponse)(error, response);
        throw error;
    });
};
module.exports["experimentalResetCollabServiceMutate"] = $41df7c78720ad922$export$6d7c9d246960833d;

});

parcelRegister("j7xMJ", function(module, exports) {

var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");

const $8264c3c0961f9494$export$5ca6730fa0e353e8 = ()=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const client = isGuest || !isLoggedIn || !isLicensed ? 'agg' : 'ccgraphql';
    return {
        client: client
    };
};
module.exports["useFetchUsersClient"] = $8264c3c0961f9494$export$5ca6730fa0e353e8;

});

parcelRegister("2VZOl", function(module, exports) {

var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $9HkI0 = parcelRequire("9HkI0");

const $a3221c0e46c131d6$export$cd763072e62a98fa = (0, $FOT9i.createContainer)();
const $a3221c0e46c131d6$var$Store = (0, $1P1Tu.createStore)({
    containedBy: $a3221c0e46c131d6$export$cd763072e62a98fa,
    initialState: {
        presenceId: ''
    },
    actions: {},
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    presenceId: (0, $9HkI0.v4)()
                });
            }
    }
});
const $a3221c0e46c131d6$export$f529db6cceb299f5 = (0, $9zUhf.createHook)($a3221c0e46c131d6$var$Store);
module.exports["NativeCollabPresenceStateContainer"] = $a3221c0e46c131d6$export$cd763072e62a98fa;
module.exports["useNativeCollabPresenceState"] = $a3221c0e46c131d6$export$f529db6cceb299f5;

});

parcelRegister("8KbKw", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $j8hiR = parcelRequire("j8hiR");


var $9137z = parcelRequire("9137z");


var $3pJBd = parcelRequire("3pJBd");


var $1sAC2 = parcelRequire("1sAC2");

const $6f395e426fb151a0$var$isContentNotFoundError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.message.includes('Invalid content id'));
    return false;
};
const $6f395e426fb151a0$export$e344958ab47793df = (0, $2XqLN.default)((contentId, draftShareId)=>async ()=>{
        const permissionsTokenState = (0, $1sAC2.nativeCollabPermissionsTokenState).getPermissionsTokenState(contentId);
        if (permissionsTokenState) {
            const { getToken: getToken, isUsedForDraftFetch: isUsedForDraftFetch, isUsedForWSInitialization: isUsedForWSInitialization } = permissionsTokenState;
            // fetchCollabPermissionToken should only return the token if it is valid and has successfully been passed to the getDraft call
            if (isUsedForDraftFetch && !isUsedForWSInitialization) {
                const token = await getToken;
                if (token) {
                    (0, $1sAC2.nativeCollabPermissionsTokenState).setIsUsedForWSInitialization(contentId, true);
                    return token;
                }
            }
        }
        const apolloClient = (0, $hp2SH.getApolloClient)();
        try {
            (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const result = await apolloClient.query({
                query: (0, $3pJBd.GetCollabPermissionTokenQuery),
                variables: {
                    contentId: contentId,
                    ...draftShareId && {
                        draftShareId: draftShareId
                    }
                },
                fetchPolicy: 'network-only',
                context: {
                    fetchOptions: {
                        // If we have a "no network error" this will never resolve and subsequent calls will
                        // be in limbo. This means we are unable to ever connect to NCS again (requiring a page reset)
                        ignoreNoNetworkError: true
                    }
                }
            });
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            return result.data?.collabToken?.token ?? null; // if token is null, collab service will fall back to permissions service check
        } catch (e) {
            (0, $7Sm4c.markErrorAsHandled)(e);
            if ($6f395e426fb151a0$var$isContentNotFoundError(e)) // nasty fragile hack, mimic 404 exception which goes through collab-provider, then gets wrapped and emitted and handled in `useError`.
            // collab provider simply emits errors thrown in permissionTokenRefresh directly on its internal channel, so we have to conform to their error type
            // prettier-ignore
            throw {
                message: "Content not found",
                data: {
                    status: 404,
                    code: "INSUFFICIENT_EDITING_PERMISSION",
                    meta: {
                        description: "RESOURCE_DELETED",
                        reason: "RESOURCE_DELETED"
                    }
                }
            };
            else if (e?.networkError?.response?.status === 503) // prettier-ignore
            throw {
                message: "Service unavailable",
                data: {
                    meta: {
                        reason: "RESOURCE_DELETED"
                    }
                }
            }; // temporary hack to ensure draft cannot be edited during tenant migration, but we should throw TENANT_INSTANCE_MAINTENANCE once supported by collab-provider
            return null;
        }
    });
module.exports["fetchCollabPermissionToken"] = $6f395e426fb151a0$export$e344958ab47793df;

});

parcelRegister("3pJBd", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $8fbe44097771f132$export$20260f2c545eeec0 = (0, $eSUdr.default)`query getCollabToken($contentId:ID!$draftShareId:String){collabToken(id:$contentId draftShareId:$draftShareId){token}}`;
module.exports["GetCollabPermissionTokenQuery"] = $8fbe44097771f132$export$20260f2c545eeec0;

});

parcelRegister("1sAC2", function(module, exports) {
class $3f756fb591e8330c$export$88b5d10ee0ed72d9 {
    getPermissionsTokenState(contentId) {
        return this.tokenState[contentId];
    }
    setToken(contentId, tokenPromise = Promise.resolve(null)) {
        // clear any existing tokens/bools in state
        this.tokenState[contentId] = {
            getToken: tokenPromise,
            isUsedForDraftFetch: false,
            isUsedForWSInitialization: false
        };
    }
    setIsUsedForDraftFetch(contentId, isUsedForDraftFetch) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForDraftFetch = isUsedForDraftFetch;
    }
    setIsUsedForWSInitialization(contentId, isUsedForWSInitialization) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForWSInitialization = isUsedForWSInitialization;
    }
    setTimestamp(contentId) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].timestamp = performance.now();
    }
    clearPermissionsTokenState(contentId) {
        if (this.tokenState[contentId]) delete this.tokenState[contentId];
    }
    constructor(){
        this.tokenState = {};
    }
}
const $3f756fb591e8330c$export$8e63d30e585828b3 = new $3f756fb591e8330c$export$88b5d10ee0ed72d9();
module.exports["nativeCollabPermissionsTokenState"] = $3f756fb591e8330c$export$8e63d30e585828b3;

});

parcelRegister("9sGCn", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $hp2SH = parcelRequire("hp2SH");


var $gKr8t = parcelRequire("gKr8t");


var $ge2sX = parcelRequire("ge2sX");


var $9p0fU = parcelRequire("9p0fU");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $9p0fU.ContentSubTypeAndStatusFragment)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $9p0fU.ContentSubTypeFragment)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $9p0fU.PTPageSubTypeFragment)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $9p0fU.SearchConfluencePageBlogAttachmentSubTypeFragment)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $2XqLN.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    const ccGqlClient = (0, $hp2SH.getApolloClient)();
    const aggGqlClient = (0, $gKr8t.getAGGClient)();
    const clientMap = {
        ["Cc graphql client"]: ccGqlClient,
        ["Agg graphql client"]: aggGqlClient
    };
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
            const fragmentData = clientMap[client].readFragment({
                id: id,
                fragment: fragment
            });
            if (fragmentData?.subType) {
                subType = fragmentData.subType;
                isArchived = fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData?.confluenceEntity?.subtype) {
                // In search graphql query's response, subtype exists in the confluenceEntity object
                subType = fragmentData.confluenceEntity.subtype.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("9p0fU", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f3357fc24ccca23a$export$6345dfb10a0b6cbe = (0, $eSUdr.default)`fragment SubTypeAndStatusContentFragment on Content{id subType status}`;
const $f3357fc24ccca23a$export$4121dd5434380612 = (0, $eSUdr.default)`fragment SubTypeContentFragment on Content{id subType}`;
const $f3357fc24ccca23a$export$e7df79006c7c4a55 = (0, $eSUdr.default)`fragment SubTypePageTreeFragment on PTPage{id subType}`;
const $f3357fc24ccca23a$export$e77fa03b04da6df0 = (0, $eSUdr.default)`fragment SubTypeFragment on SearchConfluencePageBlogAttachment{id confluenceEntity{subtype}}`;
module.exports["ContentSubTypeAndStatusFragment"] = $f3357fc24ccca23a$export$6345dfb10a0b6cbe;
module.exports["ContentSubTypeFragment"] = $f3357fc24ccca23a$export$4121dd5434380612;
module.exports["PTPageSubTypeFragment"] = $f3357fc24ccca23a$export$e7df79006c7c4a55;
module.exports["SearchConfluencePageBlogAttachmentSubTypeFragment"] = $f3357fc24ccca23a$export$e77fa03b04da6df0;

});

parcelRegister("7PuC4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $bQm3c = parcelRequire("bQm3c");


var $lSOAM = parcelRequire("lSOAM");

var $i3c1S = parcelRequire("i3c1S");


var $jX1qB = parcelRequire("jX1qB");

var $1UCmC = parcelRequire("1UCmC");


var $6VdZc = parcelRequire("6VdZc");

var $7fw2E = parcelRequire("7fw2E");


var $7sK8i = parcelRequire("7sK8i");


var $8w1c1 = parcelRequire("8w1c1");


var $1q7H7 = parcelRequire("1q7H7");


var $gw4Bt = parcelRequire("gw4Bt");


var $aWrnw = parcelRequire("aWrnw");


var $fgdVB = parcelRequire("fgdVB");


var $5qUgM = parcelRequire("5qUgM");


var $3VbV8 = parcelRequire("3VbV8");


var $kmyZQ = parcelRequire("kmyZQ");


var $9wGTI = parcelRequire("9wGTI");

const $dcbb265953b20b9a$var$baseConfig = {
    histogram: {
        initial: {
            fmp: '5000_6000_7000_8000_10000_12000_14000',
            tti: '5000_6000_7000_8000_10000_12000_14000'
        },
        transition: {
            fmp: '2000_2500_3000_3500_4000_4500_5000',
            tti: '2000_2500_3000_3500_4000_4500_5000'
        }
    },
    timings: [
        // breakdowns in order of occurrence
        {
            key: 'html',
            endMark: 'html'
        },
        {
            key: 'appLoad',
            startMark: 'html',
            endMark: 'app'
        },
        {
            key: 'appRootRender',
            startMark: 'app',
            endMark: 'root-component-render'
        },
        {
            key: 'routerMatched',
            startMark: 'root-component-render',
            endMark: 'route-manager-initialized'
        }
    ]
};
const $dcbb265953b20b9a$var$NOOP = ()=>{};
const $dcbb265953b20b9a$export$2d5e2a82ee58820b = ({ isAnonymous: isAnonymous, isInitialLoad: isInitialLoad, viewMode: viewMode })=>{
    const segments = [
        (0, $3VbV8.EDITOR_METRIC)
    ];
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) segments.push((0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC));
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) segments.push((0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC));
    if (isInitialLoad) segments.push((0, $8w1c1.APP_NAVIGATION_METRIC), (0, $aWrnw.SPACE_NAVIGATION_METRIC), (0, $1q7H7.PAGE_TREE_METRIC));
    if (!isAnonymous && viewMode === false) segments.push((0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD));
    return segments;
};
/**
 * fmpAsUntilStopTimeMetrics
 *
 * UPDATE 2025-04-29: TTI is deprecated. Going forward, new segments should be included here by default in order to
 * preserve the original TTI definition. Segments should be included even if they are not minimally interactive.
 *
 * What is minimally interactive?
 * Minimally interactive during the SSR phase at it's core, is determined if the component/element is clickable,
 * can register the action, and display a visual response that the action has been received.
 * The SSR phase can be stalled by appending ?NO_SPA=1 at the end of a CONNIE url.
 *
 * I.E. If you click on an inline comment/highlight, the click is registered, and displays a loading sidebar component.
 *
 * If a required segment is SSR'd and determined to be minimally interactive at FMP, ADD TO THIS LIST
 * If a required segment is SSR'd but determined to NOT be minimally interactive at FMP, DO NOT ADD TO THIS LIST
 * If a required segment is yet to be SSR'd, this config will not update TTI for that segment, by default is OFF.
 *
 * CONTEXT
 * the returned segments are considered to be minimally interactive during SSR
 * hence we want to use FMP (ssr-ttr mark)
 *
 * PageSegment TTI is measured: useFmpAsUntilStopTime ? FMP : Eventual load time
 * Content-renderer TTI: macros are SSRed ? FMP : Eventual Load Time
 *
 * View Page TTI is measured: Math.max(Non SSR PageSegments TTI, Content-renderer TTI)
 *
 */ const $dcbb265953b20b9a$var$fmpAsUntilStopTimeMetrics = ()=>{
    return [
        (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY),
        (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
    ];
};
const $dcbb265953b20b9a$export$53cdaf364e318f0b = ({ viewMode: viewMode, userId: userId })=>{
    const _isInitialLoad = (0, $6VdZc.isInitial)();
    const expectedPageSegments = $dcbb265953b20b9a$export$2d5e2a82ee58820b({
        isAnonymous: Boolean(!userId),
        isInitialLoad: _isInitialLoad,
        viewMode: viewMode
    });
    const untilExperienceMetricNames = $dcbb265953b20b9a$var$fmpAsUntilStopTimeMetrics();
    // Create a list of untilPageSegments
    // This wraps the segments into an UntilExperience, so that @atlassian/browser-metrics can handle useFmpAsUntilStopTime gracefully
    // Note - this only affect initial load since transitions are not SSR'd, hence page-segments do not have fmp marks
    // More information why useFmpAsUntilStopTime can be found here
    // https://hello.atlassian.net/wiki/spaces/~484600559/pages/1515596554/Toolings+Update+Browser-Metrics+FMP+TTI
    const untilPageSegments = expectedPageSegments.map((segment)=>({
            experience: segment,
            useFmpAsUntilStopTime: untilExperienceMetricNames.includes(segment.key)
        }));
    const pageLoadMetric = (0, $lSOAM.createPageLoadMetric)({
        ...$dcbb265953b20b9a$var$baseConfig,
        key: (0, $1UCmC.LIVE_PAGE_LOAD_KEY),
        timings: [
            ...$dcbb265953b20b9a$var$baseConfig.timings,
            ...(0, $i3c1S.getWaterfallTimings)(expectedPageSegments)
        ],
        include: expectedPageSegments,
        until: untilPageSegments,
        reactUFOName: (0, $1UCmC.LIVE_PAGE_REACT_UFO_LOAD_KEY)
    });
    if (!_isInitialLoad) // Make sure all segments are re-started and not currently marked as finished from a previous navigation
    expectedPageSegments.forEach((m)=>m.startFromPageLoad());
    pageLoadMetric.startPageLoad();
    pageLoadMetric.onStop(()=>{
        (0, $7fw2E.markBrowserMetricEnd)(pageLoadMetric);
    }, $dcbb265953b20b9a$var$NOOP);
    pageLoadMetric.onStop((0, $7sK8i.resumeLowPriorityEvents), (0, $7sK8i.resumeLowPriorityEvents));
    return pageLoadMetric;
};
const $dcbb265953b20b9a$export$22d97e8b0fdc8888 = ({ contentId: contentId, viewMode: viewMode })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const progressBarRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const pageLoadMetric = $dcbb265953b20b9a$export$53cdaf364e318f0b({
            viewMode: viewMode,
            userId: userId ?? undefined
        });
        pageLoadMetric.onStop(()=>{
            if (progressBarRef?.current) progressBarRef.current.finish();
        }, $dcbb265953b20b9a$var$NOOP);
        return ()=>{
            pageLoadMetric?.cancel();
            if (progressBarRef) progressBarRef.current = null;
        };
    }, [
        contentId,
        userId,
        viewMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kmyZQ.ProgressBarContainer)
        ]
    }, (progressBar)=>{
        progressBarRef.current = progressBar;
        return null;
    });
};
module.exports["startLivePageLoadMetrics"] = $dcbb265953b20b9a$export$53cdaf364e318f0b;
module.exports["StartLivePageLoad"] = $dcbb265953b20b9a$export$22d97e8b0fdc8888;

});

parcelRegister("8w1c1", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $73e19354f9924125$export$d9a22aa9387ada7a = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["APP_NAVIGATION_METRIC"] = $73e19354f9924125$export$d9a22aa9387ada7a;

});

parcelRegister("1q7H7", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

var $jX1qB = parcelRequire("jX1qB");

const $108e3019fffb7b94$export$6e28125ef9389dc6 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $108e3019fffb7b94$export$45b21bbf8961b519 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.MOVE_PAGE_DIALOG_INTERACTION)
});
module.exports["PAGE_TREE_METRIC"] = $108e3019fffb7b94$export$6e28125ef9389dc6;
module.exports["MOVE_PAGE_DIALOG_INTERACTION_METRIC"] = $108e3019fffb7b94$export$45b21bbf8961b519;

});

parcelRegister("gw4Bt", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $08e48bbb9421afc0$export$8fdec53caa79133c = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
});
module.exports["SHARE_BUTTON_PAGE_SEGMENT_LOAD"] = $08e48bbb9421afc0$export$8fdec53caa79133c;

});

parcelRegister("aWrnw", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");


var $1Hqbt = parcelRequire("1Hqbt");

const $d4615ab6ca7803f7$export$b9931e60e47a0122 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
const $d4615ab6ca7803f7$export$618f453a5683e37b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_APPS_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
module.exports["SPACE_NAVIGATION_METRIC"] = $d4615ab6ca7803f7$export$b9931e60e47a0122;
module.exports["SPACE_APPS_METRIC"] = $d4615ab6ca7803f7$export$618f453a5683e37b;

});

parcelRegister("1Hqbt", function(module, exports) {
const $a75b16828791e7fd$export$ea92d4e542ec02b3 = ()=>Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined;
module.exports["ssrConfig"] = $a75b16828791e7fd$export$ea92d4e542ec02b3;

});

parcelRegister("fgdVB", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $70b3fb0961586b52$export$ac619e1da09d5f80 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["OBJECT_SIDEBAR_CONTROL_METRIC"] = $70b3fb0961586b52$export$ac619e1da09d5f80;

});

parcelRegister("9ohnn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j8hiR = parcelRequire("j8hiR");


var $9137z = parcelRequire("9137z");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $hYoU4 = parcelRequire("hYoU4");


var $1sAC2 = parcelRequire("1sAC2");

const $173e9417c57854b2$export$2257bd3a33884363 = (collabEditProvider, contentId)=>{
    const [{ collabEditConnected: collabEditConnected }, nativeCollabActions] = (0, $hYoU4.useNativeCollabConnected)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleConnected = ()=>{
            nativeCollabActions.setCollabEditConnected(true);
            (0, $1sAC2.nativeCollabPermissionsTokenState).clearPermissionsTokenState(contentId);
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_CONNECTED);
            // tracking time between when connection has been established and 'init' event is fired
            (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_INIT_DOC);
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
                message: 'NCS Connected'
            });
        };
        collabEditProvider.on('connected', handleConnected);
        return ()=>{
            collabEditProvider.off('connected', handleConnected);
        };
    }, [
        collabEditProvider,
        nativeCollabActions,
        contentId,
        experienceTracker
    ]);
    return {
        isCollabProviderConnected: collabEditConnected
    };
};
module.exports["useConnected"] = $173e9417c57854b2$export$2257bd3a33884363;

});

parcelRegister("9uAPw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $8aF6s = parcelRequire("8aF6s");


var $bQm3c = parcelRequire("bQm3c");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $7dgT3 = parcelRequire("7dgT3");


var $cl98v = parcelRequire("cl98v");


var $jHGaM = parcelRequire("jHGaM");


var $4R3wx = parcelRequire("4R3wx");

const $a5710166add0079d$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorTitleRecordingAlreadyInProgress: {
        id: "loom-utils.error-flag.title.recording-already-in-progress",
        defaultMessage: "Recording already in progress"
    },
    errorTitleNotReady: {
        id: "loom-utils.error-flag.title.not-ready",
        defaultMessage: "The Loom recorder wasn\u2019t ready"
    },
    errorIncompatibleBrowser: {
        id: "loom-utils.error-flag.description.incompatible-browser",
        defaultMessage: "The browser you\u2019re currently using isn\u2019t compatible with Loom (or you could be trying to use it in private/incognito mode). <a>Which browsers are compatible?</a>"
    },
    errorThirdPartyCookieDisabled: {
        id: "loom-utils.error-flag.description.third-party-cookie-disabled",
        defaultMessage: "Check that you have third-party cookies enabled, then try again."
    },
    errorNoMediaStreamSupport: {
        id: "loom-utils.error-flag.description.no-media-stream-support",
        defaultMessage: "You might need to try a different browser. <a>Which browsers are compatible?</a>"
    },
    errorSDKNotInitialized: {
        id: "loom-utils.error-flag.description.sdk-not-initialized",
        defaultMessage: "Try to start recording again now."
    },
    errorBackendFFNotEnabledYet: {
        id: "loom-utils.error-flag.description.be-ff-not-enabled-yet",
        defaultMessage: "Loom was recently enabled. Try again in a few minutes."
    },
    errorUnexpectedAuthTokenFailure: {
        id: "loom-utils.error-flag.description.unexpected-auth-token-failure",
        defaultMessage: "Something went wrong with the Loom recorder. Try again later, or contact Atlassian Support for help."
    },
    errorLoomUserNotCreatedYet: {
        id: "loom-utils.error-flag.description.loom-user-not-created-yet",
        defaultMessage: "Loom is enabled, just give us a few minutes to set everything up. You can try recording again in a bit."
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    },
    errorRecordingAlreadyInProgress: {
        id: "loom-utils.error-flag.description.recording-already-in-progress",
        defaultMessage: "Finish your current Loom video so you can start another."
    }
});
const $a5710166add0079d$var$LoomSDKSupportLink = 'https://support.loom.com/hc/en-us/articles/360020667617-loomSDK-FAQ';
function $a5710166add0079d$var$getUnsupportedSDKErrorDescription(error) {
    if (error === 'third-party-cookies-disabled') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorThirdPartyCookieDisabled);
    else if (error === 'no-media-streams-support') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$a5710166add0079d$export$a7357cdd1f0b0168.errorNoMediaStreamSupport,
        values: {
            a: (chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__integrations') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks)
        }
    });
    else if (error === 'incompatible-browser') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$a5710166add0079d$export$a7357cdd1f0b0168.errorIncompatibleBrowser,
        values: {
            a: (chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__integrations') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks)
        }
    });
}
const $a5710166add0079d$export$c8d9dc913e9e33ec = ({ entryPointLocation: entryPointLocation, flags: flags, resetInsertFunctionOnUnmount: resetInsertFunctionOnUnmount = false })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const [singletonLoomSDK, { initLoomSDK: initLoomSDK }] = (0, $jHGaM.useLoomEntryPointGlobalState)();
    const [isOpeningRecorder, setIsOpeningRecorder] = (0, $42omo.useState)(false);
    const runningSDKButton = (0, $42omo.useRef)(null);
    // the call site for openLoomRecorder might be outside of React lifecycle
    // (e.g. editor DOM button onclick) so we need to ensure we maintain reference
    const singletonLoomSDKRef = (0, $42omo.useRef)(singletonLoomSDK);
    singletonLoomSDKRef.current = singletonLoomSDK;
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (entryPointVariant === 'BETA' || entryPointVariant === 'CO_USE') initLoomSDK({
            cloudId: cloudId,
            environment: environment,
            entryPointLocation: entryPointLocation
        });
    }, [
        initLoomSDK,
        cloudId,
        createAnalyticsEvent,
        environment,
        entryPointVariant,
        entryPointLocation
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (resetInsertFunctionOnUnmount && runningSDKButton.current && singletonLoomSDKRef.current.initializedLoomSDK) {
                singletonLoomSDKRef.current.initializedLoomSDK.updateConfig({
                    config: {
                        insertButtonText: 'Open on Loom'
                    }
                });
                runningSDKButton.current.off('insert-click');
                runningSDKButton.current.on('insert-click', (video)=>{
                    window.open(video.sharedUrl, '_blank');
                    experienceTracker.succeed({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        attributes: {
                            inserted: true,
                            insertFunctionWasReset: true
                        }
                    });
                    /**
           * Why do we need to add sendUIEvent if we are already sending a experienceTracker.succeed(ui taskSuccess) event?
           * "ui taskSuccess" does not have Statsig as destination, so we need to send a sendUIEvent to Statsig
           */ createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: entryPointLocation,
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'insertVideoLink',
                            attributes: {
                                insertFunctionWasReset: true
                            }
                        }
                    }).fire();
                });
            }
        };
    }, [
        entryPointLocation,
        resetInsertFunctionOnUnmount,
        experienceTracker,
        createAnalyticsEvent
    ]);
    const openLoomRecorder = (0, $42omo.useCallback)(async (loomRecorderParams)=>{
        if (singletonLoomSDKRef.current.initializedLoomSDK && singletonLoomSDKRef.current.initializedLoomSDK.status().state === 'active-recording') {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleRecordingAlreadyInProgress),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorRecordingAlreadyInProgress)
            });
            return;
        }
        experienceTracker.start({
            name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        if (singletonLoomSDKRef.current.isInitializing) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleNotReady),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorSDKNotInitialized)
            });
            experienceTracker.abort({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                reason: 'SDK has not been configured yet.'
            });
            return;
        }
        // TODO CTIA- 2019: fire a clicked UI event here
        if (singletonLoomSDKRef.current.isLoomSDKSupportedError) {
            const description = $a5710166add0079d$var$getUnsupportedSDKErrorDescription(singletonLoomSDKRef.current.isLoomSDKSupportedError);
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                description: description
            });
            experienceTracker.abort({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                reason: `SDK not supported: ${singletonLoomSDKRef.current.isLoomSDKSupportedError}.`
            });
            return;
        }
        if (!singletonLoomSDKRef.current.hasRecordingAccess) {
            const noRecordingAccessReason = singletonLoomSDKRef.current.noRecordingAccessReason;
            if (noRecordingAccessReason === 'backendFF') {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorBackendFFNotEnabledYet)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'loom enablement in progress'
                });
            } else if (noRecordingAccessReason === 'not-created') {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorLoomUserNotCreatedYet)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'user not created yet'
                });
            } else if (noRecordingAccessReason === 'not-mastered' || noRecordingAccessReason === 'not-mastered-enterprise') {
                // mastering for enterprise users is not available until M3
                const isMasteringFlowEnabledForEdition = noRecordingAccessReason !== 'not-mastered-enterprise';
                showModal((0, $7dgT3.NonMasteredUserModalLoader), {
                    isMasteringFlowEnabled: isMasteringFlowEnabledForEdition
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'Does not have access to record looms from Confluence.',
                    attributes: {
                        noRecordingAccessReason: noRecordingAccessReason
                    }
                });
            } else {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorUnexpectedAuthTokenFailure)
                });
                experienceTracker.fail({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    error: singletonLoomSDKRef.current.authTokenError || new Error('unexpected error from Loom auth token or Loom user status')
                });
            }
            return;
        }
        if (!singletonLoomSDKRef.current.initializedLoomSDK || !singletonLoomSDKRef.current.initializedLoomSDK.status().success) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorSDKFailedToInitialize)
            });
            experienceTracker.fail({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                error: singletonLoomSDKRef.current.initializedLoomSDKError || new Error('Loom SDK did not successfully initialize.'),
                attributes: {
                    loomSDKSuccessStatus: singletonLoomSDKRef.current.initializedLoomSDK?.status()?.success
                }
            });
            return;
        }
        (0, $cl98v.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        setIsOpeningRecorder(true);
        createAnalyticsEvent({
            // a track event is fired once recorder is opened, this event is speficially used for monitoring in StatSig
            type: 'sendTrackEvent',
            data: {
                source: entryPointLocation,
                action: 'opened',
                actionSubject: 'loomSdkRecorder'
            }
        }).fire();
        const { configureButton: configureButton, updateConfig: updateConfig } = singletonLoomSDKRef.current.initializedLoomSDK;
        const sdkButton = configureButton();
        updateConfig({
            config: {
                insertButtonText: loomRecorderParams ? loomRecorderParams.insertButtonText : undefined,
                entryPointName: entryPointLocation
            }
        });
        if (loomRecorderParams) sdkButton.on('insert-click', async (video)=>{
            // TODO CTIA-2019: fire a inserted track event here
            loomRecorderParams.onInsert(video.sharedUrl, video);
            experienceTracker.succeed({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    inserted: true
                }
            });
            /**
         * Why do we need to add sendUIEvent if we are already sending a experienceTracker.succeed(ui taskSuccess) event?
         * "ui taskSuccess" does not have Statsig as destination, so we need to send a sendUIEvent to Statsig
         */ createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'insertVideoLink',
                    attributes: {
                        insertFunctionWasReset: false
                    }
                }
            }).fire();
        });
        sdkButton.on('start', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingStart'
                }
            }).fire();
        });
        sdkButton.on('recording-start', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'started',
                    actionSubject: 'loomRecording'
                }
            }).fire();
        });
        sdkButton.on('cancel', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingCancel'
                }
            }).fire();
        });
        sdkButton.on('complete', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingComplete',
                    attributes: {
                        location: loomRecorderParams?.location
                    }
                }
            }).fire();
        });
        sdkButton.on('recording-complete', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'completed',
                    actionSubject: 'loomRecording',
                    attributes: {
                        location: loomRecorderParams?.location
                    }
                }
            }).fire();
        });
        sdkButton.on('upload-complete', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'uploaded',
                    actionSubject: 'loomRecording'
                }
            }).fire();
        });
        sdkButton.on('lifecycle-update', (lifecycleState)=>{
            if (lifecycleState === 'pre-recording') {
                (0, $cl98v.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
                setIsOpeningRecorder(false);
            } else if (lifecycleState === 'closed') {
                runningSDKButton.current = null;
                experienceTracker.succeed({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    attributes: {
                        closed: true,
                        insertFunctionDefined: loomRecorderParams !== undefined
                    }
                });
            } else if (lifecycleState === 'cascaded') experienceTracker.succeed({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    cascaded: true,
                    entryPointLocation: entryPointLocation
                }
            });
        });
        sdkButton.openPreRecordPanel();
        runningSDKButton.current = sdkButton;
    }, [
        entryPointLocation,
        experienceTracker,
        flags,
        showModal,
        createAnalyticsEvent
    ]);
    return {
        openLoomRecorder: openLoomRecorder,
        isOpeningRecorder: isOpeningRecorder,
        isLoomRecorderInitialized: !singletonLoomSDKRef.current.isInitializing,
        hasRecordingAccess: singletonLoomSDKRef.current.hasRecordingAccess
    };
};
module.exports["useLoomRecorderEntryPoint"] = $a5710166add0079d$export$c8d9dc913e9e33ec;

});

parcelRegister("7dgT3", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e2faf2da1cbb0cf6$export$fc2bc837ff93e32f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "n2Ktr",
    name: "NonMasteredUserModalLoader",
    loader: async ()=>(await (parcelRequire("g2fKo"))).NonMasteredUserModal
});
module.exports["NonMasteredUserModalLoader"] = $e2faf2da1cbb0cf6$export$fc2bc837ff93e32f;

});

parcelRegister("g2fKo", function(module, exports) {

let $bac90c565c4e75f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bac90c565c4e75f7$var$load("hhss7"),
    $bac90c565c4e75f7$var$load("np2ZB")
]).then(()=>parcelRequire('6i2Ga'));

});

parcelRegister("cl98v", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

const $dd21d598b55c38cc$export$873f91e3be81ab94 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.OPEN_LOOM_RECORDER_SDK_INTERACTION)
});
const $dd21d598b55c38cc$export$bf1068aa9f020d8f = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION)
});
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $dd21d598b55c38cc$export$873f91e3be81ab94;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $dd21d598b55c38cc$export$bf1068aa9f020d8f;

});

parcelRegister("jHGaM", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cl98v = parcelRequire("cl98v");


var $3d6VZ = parcelRequire("3d6VZ");


var $gmNpb = parcelRequire("gmNpb");


var $38NxZ = parcelRequire("38NxZ");

const $82feff28757ef801$var$initialState = {
    isInitializing: true,
    initializedLoomSDK: null,
    _hasLoomSDKInitializationStarted: false,
    hasRecordingAccess: false,
    noRecordingAccessReason: undefined,
    authTokenError: undefined,
    isLoomSDKSupportedError: undefined,
    initializedLoomSDKError: null
};


const $82feff28757ef801$var$initSDK = ({ cloudId: cloudId, environment: environment, entryPointLocation: entryPointLocation })=>async ({ getState: getState, setState: setState })=>{
        if (getState().initializedLoomSDK || getState()._hasLoomSDKInitializationStarted) // singleton: only want 1 Loom SDK instance
        return;
        setState({
            _hasLoomSDKInitializationStarted: true
        });
        (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        try {
            const { isSupported: isSupported } = await (parcelRequire("aWuvK"));
            const { supported: supported, error: isLoomSDKSupportedError } = await isSupported();
            if (!supported) {
                setState({
                    isLoomSDKSupportedError: isLoomSDKSupportedError,
                    isInitializing: false
                });
                (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
                return;
            }
        } catch  {
            // If SDK isSupported import/exec fails: treat as incompatible browser
            setState({
                isLoomSDKSupportedError: 'incompatible-browser',
                isInitializing: false
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            return;
        }
        const { recorderToken: recorderToken, tokenError: tokenError } = await (0, $3d6VZ.getAuthToken)();
        if (!recorderToken || tokenError) {
            const noRecordingAccessReason = await (0, $38NxZ.getNoRecordingAccessReason)(tokenError);
            setState({
                isInitializing: false,
                noRecordingAccessReason: noRecordingAccessReason,
                authTokenError: tokenError
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            return;
        }
        setState({
            hasRecordingAccess: true
        });
        try {
            const { createInstance: createInstance } = await (parcelRequire("42lVp"));
            const initializedLoomSDK = await createInstance((0, $gmNpb.getLoomInstanceDataByEnvironment)({
                environment: environment,
                jws: recorderToken,
                siteId: cloudId,
                entryPointName: entryPointLocation
            }));
            setState({
                initializedLoomSDK: initializedLoomSDK,
                isInitializing: false
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
        } catch (err) {
            setState({
                isInitializing: false,
                initializedLoomSDKError: err
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
        }
    };
const $82feff28757ef801$var$actions = {
    initLoomSDK: $82feff28757ef801$var$initSDK
};
const $82feff28757ef801$export$6f57813fe9f31bf9 = (0, $1P1Tu.createStore)({
    initialState: $82feff28757ef801$var$initialState,
    actions: $82feff28757ef801$var$actions,
    name: 'loomEntryPointGlobalStateStore'
});
const $82feff28757ef801$export$160753b85ca93fc7 = (0, $9zUhf.createHook)($82feff28757ef801$export$6f57813fe9f31bf9);
module.exports["useLoomEntryPointGlobalState"] = $82feff28757ef801$export$160753b85ca93fc7;

});

parcelRegister("3d6VZ", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $e01Lp = parcelRequire("e01Lp");


var $55UbZ = parcelRequire("55UbZ");

const $000d418a80b56fba$export$38e1f53b76ec7fed = async ()=>{
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const tokenQuery = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $e01Lp.LoomAuthTokenQuery),
            fetchPolicy: 'network-only'
        });
        return {
            recorderToken: tokenQuery.data.loomToken?.token
        };
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return {
            tokenError: e
        };
    }
};
const $000d418a80b56fba$export$36491da625b5403b = async ()=>{
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const authStateQuery = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $55UbZ.LoomAuthStateQuery)
        });
        return authStateQuery.data.loomUserStatus;
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return undefined;
    }
};
module.exports["getAuthToken"] = $000d418a80b56fba$export$38e1f53b76ec7fed;
module.exports["getAuthState"] = $000d418a80b56fba$export$36491da625b5403b;

});

parcelRegister("e01Lp", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $eeb31b52c8d53ac0$export$68069cc596b806b = (0, $eSUdr.default)`query LoomAuthTokenQuery{loomToken{token}}`;
module.exports["LoomAuthTokenQuery"] = $eeb31b52c8d53ac0$export$68069cc596b806b;

});

parcelRegister("55UbZ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $80afd1194d3d0c84$export$ee3fd3c5221b99c = (0, $eSUdr.default)`query LoomAuthStateQuery{loomUserStatus}`;
module.exports["LoomAuthStateQuery"] = $80afd1194d3d0c84$export$ee3fd3c5221b99c;

});

parcelRegister("gmNpb", function(module, exports) {
const $39913087ba6f73e2$var$PUBLIC_APP_IDS = {
    noBackend: 'a3f31403-5892-4b68-baf9-a8b1c1f9ef80',
    staging: '811e05d4-b0aa-4ec9-80e4-68cf5e924102',
    production: {
        development: 'dba4f6db-8419-44f6-ac25-32b6fc352747',
        userFacing: '8e345daf-482a-4abf-a612-cb6457110817'
    }
};
const $39913087ba6f73e2$export$c150e4a8d8a3ab35 = ({ environment: environment, jws: jws, siteId: siteId, entryPointName: entryPointName })=>{
    const commonParams = {
        jws: jws,
        siteId: siteId,
        config: {
            enableNewUi: true,
            productName: 'Confluence',
            entryPointName: entryPointName
        }
    };
    if (environment === 'DEVELOPMENT') return {
        ...commonParams,
        mode: 'standard',
        publicAppId: $39913087ba6f73e2$var$PUBLIC_APP_IDS.noBackend,
        environment: 'production'
    };
    if (environment === 'STAGING') return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: $39913087ba6f73e2$var$PUBLIC_APP_IDS.staging,
        environment: 'staging'
    };
    return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: (0, $39913087ba6f73e2$var$PUBLIC_APP_IDS.production.userFacing),
        environment: 'production'
    };
};
module.exports["getLoomInstanceDataByEnvironment"] = $39913087ba6f73e2$export$c150e4a8d8a3ab35;

});

parcelRegister("38NxZ", function(module, exports) {

var $3d6VZ = parcelRequire("3d6VZ");


var $dn8bs = parcelRequire("dn8bs");

const $0e5a08ec05b30096$var$graphqlErrorHasMessage = (error, messageMatch)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>message.includes(messageMatch));
    return false;
};
const $0e5a08ec05b30096$var$FF_DISABLED_MESSAGE = 'Attempted to fetch Loom token without feature flag enabled';
const $0e5a08ec05b30096$var$UNFOUND_OR_UNMASTERED_USER_MESSAGE = 'Failed to fetch loom auth token. Status code: 404';
const $0e5a08ec05b30096$export$5a9a2c39ccb5534c = async (tokenError)=>{
    if ($0e5a08ec05b30096$var$graphqlErrorHasMessage(tokenError, $0e5a08ec05b30096$var$FF_DISABLED_MESSAGE)) return 'backendFF';
    if ($0e5a08ec05b30096$var$graphqlErrorHasMessage(tokenError, $0e5a08ec05b30096$var$UNFOUND_OR_UNMASTERED_USER_MESSAGE)) {
        const authState = await (0, $3d6VZ.getAuthState)();
        if (authState === (0, $dn8bs.LoomUserStatus).NOT_FOUND) return 'not-created';
        if (authState === (0, $dn8bs.LoomUserStatus).LINKED) return 'not-mastered';
        if (authState === (0, $dn8bs.LoomUserStatus).LINKED_ENTERPRISE) return 'not-mastered-enterprise';
    }
    return 'unexpected';
};
module.exports["getNoRecordingAccessReason"] = $0e5a08ec05b30096$export$5a9a2c39ccb5534c;

});

parcelRegister("dn8bs", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $80735413f00f04fc$export$9d643cbb1392f8e6 = /*#__PURE__*/ function(LoomUserStatus) {
    LoomUserStatus["LINKED"] = "LINKED";
    LoomUserStatus["LINKED_ENTERPRISE"] = "LINKED_ENTERPRISE";
    LoomUserStatus["MASTERED"] = "MASTERED";
    LoomUserStatus["NOT_FOUND"] = "NOT_FOUND";
    return LoomUserStatus;
}({});
module.exports["LoomUserStatus"] = $80735413f00f04fc$export$9d643cbb1392f8e6;

});

parcelRegister("aWuvK", function(module, exports) {

let $7f76fd05798145a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f76fd05798145a7$var$load("lwKXH"),
    $7f76fd05798145a7$var$load("4byV5")
]).then(()=>parcelRequire('3f9PV'));

});

parcelRegister("42lVp", function(module, exports) {

let $2f085b2d31f6e000$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2f085b2d31f6e000$var$load("lkOIY"),
    $2f085b2d31f6e000$var$load("f1NVy"),
    $2f085b2d31f6e000$var$load("2haIE"),
    $2f085b2d31f6e000$var$load("9K4jq"),
    $2f085b2d31f6e000$var$load("6wr18"),
    $2f085b2d31f6e000$var$load("a3Uq6"),
    $2f085b2d31f6e000$var$load("xvDzM"),
    $2f085b2d31f6e000$var$load("jle6Z"),
    $2f085b2d31f6e000$var$load("4drdS"),
    $2f085b2d31f6e000$var$load("lLK0D"),
    $2f085b2d31f6e000$var$load("9LQGG"),
    $2f085b2d31f6e000$var$load("wIOhQ"),
    $2f085b2d31f6e000$var$load("lwKXH"),
    $2f085b2d31f6e000$var$load("fisfU"),
    $2f085b2d31f6e000$var$load("ffEVr"),
    $2f085b2d31f6e000$var$load("7EorR"),
    $2f085b2d31f6e000$var$load("btYwu")
]).then(()=>parcelRequire('fIeud'));

});

parcelRegister("4R3wx", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");

const $45094daeb894a50e$export$5d821a9fc4b7faa = ()=>{
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useIsLoomEntryPointsEnabledQuery($cloudId:ID!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled}}`, {
        variables: {
            cloudId: cloudId
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("cYe4v", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId,
        environment
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("5CUwy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cbc8g = parcelRequire("cbc8g");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $bxT4f = parcelRequire("bxT4f");


var $4zCDj = parcelRequire("4zCDj");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const licensedProducts = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $4zCDj.GetLicensedProductsQuery)
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === (0, $bxT4f.LicenseStatus).ACTIVE);
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    retryWait: 500
                });
                (0, $cbc8g.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $1P1Tu.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $9zUhf.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $9zUhf.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserPermissionStatus"] = $9633e2f0bea217d1$export$85de6c803181afa9;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;
module.exports["useLoomEntryPointVariantActions"] = $9633e2f0bea217d1$export$fd0650c7a15c6ef2;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("bxT4f", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $1b0cd2a957a24400$export$902181cb056f3d0b = /*#__PURE__*/ function(LicenseStatus) {
    LicenseStatus["ACTIVE"] = "ACTIVE";
    LicenseStatus["SUSPENDED"] = "SUSPENDED";
    LicenseStatus["UNLICENSED"] = "UNLICENSED";
    return LicenseStatus;
}({});
module.exports["LicenseStatus"] = $1b0cd2a957a24400$export$902181cb056f3d0b;

});

parcelRegister("4zCDj", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $55302aa376569ead$export$e367407479ee8cd8 = (0, $eSUdr.default)`query GetLicensedProductsQuery{confluence_tenantContext{licensedProducts{licenseStatus productKey}}}`;
module.exports["GetLicensedProductsQuery"] = $55302aa376569ead$export$e367407479ee8cd8;

});

parcelRegister("eNjW4", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $lzcvT = parcelRequire("lzcvT");


var $9wGTI = parcelRequire("9wGTI");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = ()=>{
    const isInFedRamp = (0, $lzcvT.isFedRamp)();
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    // When the gate is ON, we use the feature-encoding SDK to check if the feature is enabled in the current environment
    const isLoomFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-loom-integration') : !isInFedRamp;
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("9Zt9E", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4R3wx = parcelRequire("4R3wx");

const $bd6eb7a689d25f96$export$4e56214a02095203 = ({ EditorButtonComponent: EditorButtonComponent, editorAPIRef: editorAPIRef, editorShouldShowToolbarLoomButton: editorShouldShowToolbarLoomButton })=>{
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    /**
	 * The Loom plugin should be enabled for all non-disabled Loom entrypoints.
	 *
	 * This has to be determined on the initial call of the hook (due to the way plugin initialization works).
	 * It should also still be OK if the plugin is enabled even for edge cases where the entrypoint is
	 * asynchronously determined to be disabled (e.g., when a site has opted out of cross-flow ads) because:
	 *
	 * `useInitializeLoomPlugin` will handle the conditions for initializing the plugin (to enable recording) and
	 * `EditorButtonComponent` will handle conditional rendering (in some cases, even returning `null` to dynamically
	 * hide the button)
	 */ const isPluginEnabled = entryPointVariant !== 'DISABLED';
    // [ED-27497] IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/loomPluginOptions.ts
    const pluginOptions = (0, $42omo.useMemo)(()=>{
        return {
            renderButton: (ButtonComponent)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(EditorButtonComponent, {
                    buttonComponent: ButtonComponent,
                    editorAPIRef: editorAPIRef
                });
            },
            ...editorShouldShowToolbarLoomButton !== undefined ? {
                shouldShowToolbarButton: editorShouldShowToolbarLoomButton
            } : {}
        };
    // Intentionally not recreating/updating the plugin options in order to remain consistent with
    // the behavior of the editor preset that uses this hook to generate the loom plugin options
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        isPluginEnabled: isPluginEnabled,
        pluginOptions: pluginOptions
    };
};
module.exports["useLoomPluginOptions"] = $bd6eb7a689d25f96$export$4e56214a02095203;

});

parcelRegister("3GtBN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cnJLk = parcelRequire("cnJLk");


var $4R3wx = parcelRequire("4R3wx");

const $3144bf078b5ec5f7$export$a8d5ff7665612fc7 = ({ loomPlugin: loomPlugin, providerConfig: providerConfig })=>{
    const hasInitialized = (0, $42omo.useRef)(false);
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const isLoomRecordingEligible = [
        'BETA',
        'CO_USE'
    ].includes(entryPointVariant);
    const initLoom = loomPlugin?.actions.initLoom;
    (0, $42omo.useEffect)(()=>{
        if (!hasInitialized.current && initLoom && isLoomRecordingEligible) {
            hasInitialized.current = true;
            initLoom({
                loomProvider: (0, $cnJLk.getLoomProvider)(providerConfig)
            });
        }
    }, [
        initLoom,
        isLoomRecordingEligible,
        providerConfig
    ]);
};
module.exports["useInitializeLoomPlugin"] = $3144bf078b5ec5f7$export$a8d5ff7665612fc7;

});

parcelRegister("cnJLk", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

const $7ac005878fa67dea$export$c58a153e42b1c02d = (0, $2XqLN.default)((config)=>{
    return {
        getClient: async ()=>({
                status: 'loaded',
                client: {
                    attachToButton: ({ button: button, onInsert: onInsert })=>{
                        button.addEventListener('click', ()=>{
                            config.openLoomRecorder({
                                onInsert: (_, video)=>{
                                    onInsert(video);
                                },
                                // intentionally not localized because Loom RecordSDK does not support i18n
                                insertButtonText: 'Insert Loom video'
                            });
                        });
                    }
                }
            })
    };
});
module.exports["getLoomProvider"] = $7ac005878fa67dea$export$c58a153e42b1c02d;

});

parcelRegister("yuV6Z", function(module, exports) {
const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>`${$378a693b2c26358e$export$ca6dda5263526f75}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("gj7hi", function(module, exports) {
$parcel$export(module.exports, "default", () => $df095e8eefdd8265$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cv8Bu = parcelRequire("cv8Bu");


var $cOrQJ = parcelRequire("cOrQJ");

const $df095e8eefdd8265$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $df095e8eefdd8265$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $42omo.useRef)(null);
    const providedColorMode = (0, $cv8Bu.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $cOrQJ.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $42omo.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $gMc0m.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});

parcelRegister("cv8Bu", function(module, exports) {
/* theme-provider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");


var $8z9j5 = parcelRequire("8z9j5");

var $hY0xh = parcelRequire("hY0xh");

var $bRSdj = parcelRequire("bRSdj");

var $60yhz = parcelRequire("60yhz");

const $d32a212d6e794c84$var$defaultThemeSettings = ()=>({
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: 'typography'
    });
const $d32a212d6e794c84$var$ColorModeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $d32a212d6e794c84$var$SetColorModeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $d32a212d6e794c84$var$ThemeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $d32a212d6e794c84$var$SetThemeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined); /**
                                                                                                  * __UNSAFE_useColorModeForMigration()__
                                                                                                  *
                                                                                                  * Returns the current color mode when inside the app provider.
                                                                                                  * Unlike useColorMode, this utility returns undefined, instead of throwing an error, when the app provider is missing.
                                                                                                  * This allows it to be used by components that need to operate with and without an app provider.
                                                                                                  */ 
function $d32a212d6e794c84$export$ce91654eb9fea460() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$ColorModeContext);
    return value;
} /**
   * __useColorMode()__
   *
   * Returns the current color mode when inside the app provider.
   */ 
function $d32a212d6e794c84$export$20f3076712c8dfa() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$ColorModeContext);
    const { colorMode: colorMode } = (0, $8z9j5.default)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $42omo.useState)(colorMode || 'light');
    (0, $42omo.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $60yhz.default)((theme)=>{
            setResolvedColorMode(theme.colorMode || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}
function $d32a212d6e794c84$export$e2afe7397c3d11c7() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
} /**
   * __useTheme()__
   *
   * Returns the current theme settings when inside the app provider.
   */ 
function $d32a212d6e794c84$export$93d4e7f90805808f() {
    const theme = (0, $42omo.useContext)($d32a212d6e794c84$var$ThemeContext);
    const [resolvedTheme, setResolvedTheme] = (0, $42omo.useState)(theme || (0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        const observer = new (0, $60yhz.default)(setResolvedTheme);
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    return theme ? theme : resolvedTheme;
} /**
   * __useSetTheme()__
   *
   * Returns the theme setter when inside the app provider.
   */ 
function $d32a212d6e794c84$export$501aa0dcd5527a48() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $d32a212d6e794c84$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $d32a212d6e794c84$var$prefersDarkModeMql = $d32a212d6e794c84$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined; // TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $d32a212d6e794c84$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $d32a212d6e794c84$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
const $d32a212d6e794c84$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $d32a212d6e794c84$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode, defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $42omo.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $42omo.useState)($d32a212d6e794c84$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $42omo.useState)(()=>({
            ...$d32a212d6e794c84$var$defaultThemeSettings(),
            ...defaultTheme
        }));
    const setColorMode = (0, $42omo.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($d32a212d6e794c84$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $42omo.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        // If fg enabled avoid mounting themes
        if ((0, $dh538.fg)('platform-static-theme-loading')) return;
         /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ 
        const cleanupLastFnCall = async ()=>{
            if (lastSetGlobalThemePromiseRef.current) {
                const unbindFn = await lastSetGlobalThemePromiseRef.current;
                unbindFn();
                lastSetGlobalThemePromiseRef.current = null;
            }
        };
        const safelySetGlobalTheme = async ()=>{
            await cleanupLastFnCall();
            const promise = (0, $bRSdj.default)({
                ...theme,
                colorMode: reconciledColorMode
            });
            lastSetGlobalThemePromiseRef.current = promise;
        };
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!$d32a212d6e794c84$var$prefersDarkModeMql) return;
        const unbindListener = (0, $fFa3V.bind)($d32a212d6e794c84$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = (0, $hY0xh.default)({
        ...theme,
        colorMode: reconciledColorMode
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$ColorModeContext.Provider, {
        value: reconciledColorMode,
        children: /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$SetColorModeContext.Provider, {
            value: setColorMode,
            children: /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$ThemeContext.Provider, {
                value: theme,
                children: /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$SetThemeContext.Provider, {
                    value: setPartialTheme,
                    children: (0, $dh538.fg)('platform-static-theme-loading') ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        "data-theme": attrs['data-theme'],
                        "data-color-mode": attrs['data-color-mode'],
                        className: (0, $gMc0m.default)([
                            $d32a212d6e794c84$var$contentStyles.body
                        ]),
                        children: children
                    }) : children
                })
            })
        })
    });
}
var $d32a212d6e794c84$export$2e2bcd8739ae039 = $d32a212d6e794c84$var$ThemeProvider;
module.exports["UNSAFE_useColorModeForMigration"] = $d32a212d6e794c84$export$ce91654eb9fea460;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("3b6WO", function(module, exports) {

var $8C5kA = parcelRequire("8C5kA");


var $42omo = parcelRequire("42omo");


var $7zIsq = parcelRequire("7zIsq");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, spaceContextOnly: spaceContextOnly })=>{
    const { locale: locale } = (0, $8C5kA.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const options = (0, $42omo.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: queryOptions,
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        spaceKey,
        contentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = (0, $7zIsq.usePrefilteredExtensionList)(options);
    (0, $42omo.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("7zIsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $grQpA = parcelRequire("grQpA");


var $5U2YR = parcelRequire("5U2YR");


var $39Ajm = parcelRequire("39Ajm");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $1Igmn = parcelRequire("1Igmn");


var $8VYSW = parcelRequire("8VYSW");


var $c6GJD = parcelRequire("c6GJD");

const $f6a9c96fc0de3888$export$7f11ec46a05c7477 = (cloudId, context, client, types, locale, includeHidden, queryOptions, contextIds = [
    cloudId
])=>{
    const variables = {
        cloudId: cloudId,
        context: context,
        includeHidden: includeHidden ?? false,
        types: types,
        locale: locale
    };
    return {
        variables: variables,
        ...queryOptions,
        client: client,
        /**
		 * We don't want to set 'ignore' because that discards errors and we need to inspect
		 * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
		 * https://www.apollographql.com/docs/react/data/error-handling/
		 */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
            },
            // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
            allowOnExternalPage: (0, $c6GJD.default).getExperimentValue('confluence_cgraphql_client_for_forge_extensions', 'isEnabled', false) ? true : undefined
        }
    };
};
const $f6a9c96fc0de3888$export$88e0391b02a3c5c9 = ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions })=>{
    const requestOptions = $f6a9c96fc0de3888$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)((0, $39Ajm.FetchPreFilteredForgeAppsQuery), requestOptions);
    const extensions = $f6a9c96fc0de3888$export$55348c7eb6377fe1({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err = error.graphQLErrors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'usePrefilteredExtensionList',
                        errorName: err ? (0, $grQpA.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $f6a9c96fc0de3888$export$55348c7eb6377fe1 = ({ loading: loading, data: data })=>{
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (!loading && extensions.length > 0) return (0, $8VYSW.transformPreFilteredExtensions)(extensions);
    return null;
};
module.exports["createUsePrefilteredExtensionListQueryOptions"] = $f6a9c96fc0de3888$export$7f11ec46a05c7477;
module.exports["usePrefilteredExtensionList"] = $f6a9c96fc0de3888$export$88e0391b02a3c5c9;
module.exports["getPrefilteredExtensionsGQLResult"] = $f6a9c96fc0de3888$export$55348c7eb6377fe1;

});

parcelRegister("grQpA", function(module, exports) {
var $3afb5a6a58db13d7$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $3afb5a6a58db13d7$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $3afb5a6a58db13d7$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';
module.exports["GQLExtensionContextsFilterType"] = $3afb5a6a58db13d7$export$d76ef0f862d061a6;
module.exports["isGQLGatewayError"] = $3afb5a6a58db13d7$export$8d1c210bc17223c1;
module.exports["isGQLUnderlyingServiceError"] = $3afb5a6a58db13d7$export$9c0545f564a8227f;

});

parcelRegister("5U2YR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hQK66 = parcelRequire("hQK66");


var $jIiuI = parcelRequire("jIiuI");

const $a50a0967117e6a0e$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $42omo.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $a50a0967117e6a0e$export$163ecee29aa3a8f = ({ value: value, children: children })=>{
    const envFromContext = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $hQK66.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a50a0967117e6a0e$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue
    }, children);
};
const $a50a0967117e6a0e$export$dba2dab0d0f39612 = ()=>{
    return (0, $42omo.useContext)($a50a0967117e6a0e$export$b438ce9ad9530ae5);
};
module.exports["MetricsContext"] = $a50a0967117e6a0e$export$b438ce9ad9530ae5;
module.exports["MetricsContextProvider"] = $a50a0967117e6a0e$export$163ecee29aa3a8f;
module.exports["useMetricsContext"] = $a50a0967117e6a0e$export$dba2dab0d0f39612;

});

parcelRegister("jIiuI", function(module, exports) {

var $42omo = parcelRequire("42omo");

parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $669e2d348d1011a7$export$6a671bebd9daad64 = (0, $42omo.createContext)((0, $1Aku8.ProductEnvironment).PRODUCTION);
module.exports["EnvironmentContext"] = $669e2d348d1011a7$export$6a671bebd9daad64;

});

parcelRegister("39Ajm", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $dh538 = parcelRequire("dh538");

const $2ce486181186726b$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $2ce486181186726b$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $eSUdr.default)`${query}`;
};
const $2ce486181186726b$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $eSUdr.default)`${query}`;
};
const $2ce486181186726b$export$54ff27488d768aba = (0, $eSUdr.default)`query FetchPreFilteredForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner environmentId environmentType environmentKey consentUrl migrationKey userAccess{enabled hasAccess}key properties{key value}egress{addresses category type inScopeEUD}scopes license{active capabilitySet billingPeriod ccpEntitlementId ccpEntitlementSlug isEvaluation subscriptionEndDate trialEndDate type}type installationId hiddenBy}}`;
module.exports["getExtensionListQueryOld"] = $2ce486181186726b$export$b4649e379af92913;
module.exports["getExtensionListQuery"] = $2ce486181186726b$export$23f6ad93bea7724;
module.exports["FetchPreFilteredForgeAppsQuery"] = $2ce486181186726b$export$54ff27488d768aba;

});

parcelRegister("3Spjc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $7TH2w = parcelRequire("7TH2w");

const $ee4a4828226e63ce$export$d28801614368e543 = 'forge-ui';
const $ee4a4828226e63ce$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $7TH2w.UI_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $7TH2w.TRACK_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $7TH2w.SCREEN_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $ee4a4828226e63ce$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
const $ee4a4828226e63ce$var$ForgeUIAnalyticsListener = ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $ee4a4828226e63ce$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...event.context.reduce((prev, curr)=>{
                    // Only extract attributes passed as an object via the forgeUIAttributes key
                    const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
                    return {
                        ...prev,
                        ...forgeUIAttributes
                    };
                }, {}),
                ...attributes
            },
            tags: tags
        };
        $ee4a4828226e63ce$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: listenerHandler,
        channel: $ee4a4828226e63ce$export$d28801614368e543
    }, children);
};
var $ee4a4828226e63ce$export$2e2bcd8739ae039 = $ee4a4828226e63ce$var$ForgeUIAnalyticsListener;
module.exports["FORGE_UI_ANALYTICS_CHANNEL"] = $ee4a4828226e63ce$export$d28801614368e543;
module.exports["sendEvent"] = $ee4a4828226e63ce$export$7329bcdc3edcd90e;
module.exports["default"] = $ee4a4828226e63ce$export$2e2bcd8739ae039;

});

parcelRegister("1Igmn", function(module, exports) {
// our service
const $0be0f811af274f82$var$SERVICE = 'forge-ui';
const $0be0f811af274f82$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $0be0f811af274f82$var$SERVICE
    });
};
module.exports["createAtlAttributionHeader"] = $0be0f811af274f82$export$14ef296862e3705e;

});

parcelRegister("8VYSW", function(module, exports) {
parcelRequire("1c598");
var $2JC3k = parcelRequire("2JC3k");


var $dh538 = parcelRequire("dh538");

const $2303076e1c638c7b$var$cache = new Map();
const $2303076e1c638c7b$export$9ff84ea1b2ab439c = (extensions)=>{
    const extensionsIds = (extensions || []).map((ext)=>ext.id).join(',');
    if ((0, $dh538.fg)('memoize_prefiltered_extensions')) {
        if ($2303076e1c638c7b$var$cache.has(extensionsIds)) return $2303076e1c638c7b$var$cache.get(extensionsIds);
    }
    const result = (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).STAGING || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: extension.properties.reduce((acc, property)=>{
                    if (!property.value || !property.key) return acc;
                    try {
                        const jsonValue = JSON.parse(property.value);
                        acc[property.key] = jsonValue;
                    } catch (error) {
                        acc[property.key] = property.value;
                    }
                    return acc;
                }, {}),
                license: extension.license ? {
                    ...extension.license,
                    capabilitySet: $2303076e1c638c7b$var$mapCapabilitySet(extension.license.capabilitySet)
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
    if ((0, $dh538.fg)('memoize_prefiltered_extensions')) $2303076e1c638c7b$var$cache.set(extensionsIds, result);
    return result;
};
const $2303076e1c638c7b$var$mapCapabilitySet = (capabilitySet)=>{
    switch(capabilitySet){
        case 'CAPABILITY_ADVANCED':
            return 'capabilityAdvanced';
        default:
            return 'capabilityStandard';
    }
};
module.exports["transformPreFilteredExtensions"] = $2303076e1c638c7b$export$9ff84ea1b2ab439c;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $gKr8t = parcelRequire("gKr8t");


var $hp2SH = parcelRequire("hp2SH");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, spaceContextOnly: spaceContextOnly = false })=>{
    const options = {
        client: (0, $6mKj3.expVal)('confluence_cgraphql_client_for_forge_extensions', 'isEnabled', false) ? (0, $hp2SH.getApolloClient)() : (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: spaceContextOnly && (0, $6mKj3.expVal)('confluence_fix_space_apps_flickering', 'isEnabled', false) ? {
            spaceKey: spaceKey
        } : {
            spaceKey: spaceKey,
            contentId: contentId
        },
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("6ld6a", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $xQxzY = parcelRequire("xQxzY");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $fjiOd = parcelRequire("fjiOd");


var $62BfR = parcelRequire("62BfR");

const $f64809aa9d8f3ca2$export$13a30d244c53e90d = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(26);
    const { location: location, contentId: t1, spaceKey: t2, version: t3, fetchPolicy: t4, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery } = t0;
    const contentId = t1 === undefined ? null : t1;
    const spaceKey = t2 === undefined ? null : t2;
    const version = t3 === undefined ? null : t3;
    const fetchPolicy = t4 === undefined ? "cache-and-network" : t4;
    const t5 = Array.isArray(location) ? null : location;
    let t6;
    if ($[0] !== location) {
        t6 = Array.isArray(location) ? location : [];
        $[0] = location;
        $[1] = t6;
    } else t6 = $[1];
    let t7;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t5 || $[5] !== t6 || $[6] !== version) {
        t7 = {
            location: t5,
            locations: t6,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t5;
        $[5] = t6;
        $[6] = version;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== fetchPolicy || $[9] !== skipQuery || $[10] !== t7) {
        t8 = {
            fetchPolicy: fetchPolicy,
            variables: t7,
            skip: skipQuery
        };
        $[8] = fetchPolicy;
        $[9] = skipQuery;
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)((0, $fjiOd.WebItemLocationQuery), t8);
    if (!data) {
        let t10;
        let t9;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t9 = [];
            t10 = [];
            $[12] = t10;
            $[13] = t9;
        } else {
            t10 = $[12];
            t9 = $[13];
        }
        let t11;
        if ($[14] !== error || $[15] !== loading) {
            t11 = {
                loading: loading,
                error: error,
                webItems: t9,
                webSections: t10
            };
            $[14] = error;
            $[15] = loading;
            $[16] = t11;
        } else t11 = $[16];
        return t11;
    }
    let webItems;
    let webSections;
    if ($[17] !== allowedWebItems || $[18] !== data || $[19] !== notAllowedWebItems) {
        webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections, {
            allowedWebItems: allowedWebItems,
            notAllowedWebItems: notAllowedWebItems
        });
        webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(webItems.map($f64809aa9d8f3ca2$var$_temp));
        webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
        $[17] = allowedWebItems;
        $[18] = data;
        $[19] = notAllowedWebItems;
        $[20] = webItems;
        $[21] = webSections;
    } else {
        webItems = $[20];
        webSections = $[21];
    }
    let t9;
    if ($[22] !== error || $[23] !== webItems || $[24] !== webSections) {
        t9 = {
            loading: false,
            error: error,
            webItems: webItems,
            webSections: webSections
        };
        $[22] = error;
        $[23] = webItems;
        $[24] = webSections;
        $[25] = t9;
    } else t9 = $[25];
    return t9;
} : ({ location: location, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null, fetchPolicy: fetchPolicy = 'cache-and-network', allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery })=>{
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $fjiOd.WebItemLocationQuery), {
        fetchPolicy: fetchPolicy,
        variables: {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        },
        skip: skipQuery
    });
    if (!data) return {
        loading: loading,
        error: error,
        webItems: [],
        webSections: []
    };
    // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
    // with the atlToken in all section items
    const webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections, {
        allowedWebItems: allowedWebItems,
        notAllowedWebItems: notAllowedWebItems
    });
    const webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(webItems.map((webItem)=>webItem.section));
    webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
    return {
        // Since the default fetchPolicy is cache-and-network
        // loading field will be true, false, true (background refetch), false
        // Query is refreshing when data not empty but loading is true
        // Padding loading false to avoid reverting back to the empty state or loading skeleton.
        // This aligns with confluence/next/packages/web-item-location/src/WebItemLocation.tsx
        loading: false,
        error: error,
        webItems: webItems,
        webSections: webSections
    };
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (item === null || item.completeKey === null) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};
function $f64809aa9d8f3ca2$var$_temp(webItem) {
    return webItem.section;
}
module.exports["useWebItemLocation"] = $f64809aa9d8f3ca2$export$13a30d244c53e90d;

});

parcelRegister("da6ky", function(module, exports) {

var $ghltV = parcelRequire("ghltV");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $99511ea06e3a3663$var$uniq(array) {
    return array && array.length ? $ghltV(array) : [];
}
module.exports = $99511ea06e3a3663$var$uniq;

});

parcelRegister("fjiOd", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $78914c14925ace72$export$abf96c374bfacb58 = (0, $eSUdr.default)`query WebItemLocationQuery($location:String$locations:[String]$contentId:ID$spaceKey:String$version:Int){webItemSections(location:$location locations:$locations contentId:$contentId key:$spaceKey version:$version){id label cacheKey styleClass items{accessKey completeKey hasCondition id icon{height width path}params{key value}label moduleKey section styleClass tooltip url urlWithoutContextPath weight}}}`;
const $78914c14925ace72$export$c4b66d2db87918fa = (0, $eSUdr.default)`query WebItemLocationWithSpaceKeyQuery($location:String$locations:[String]$spaceKey:String$version:Int){space(key:$spaceKey){id homepageId homepageWebSections(location:$location locations:$locations version:$version){id label cacheKey styleClass items{accessKey completeKey hasCondition id icon{height width path}params{key value}label moduleKey section styleClass tooltip url urlWithoutContextPath weight}}}}`;
module.exports["WebItemLocationQuery"] = $78914c14925ace72$export$abf96c374bfacb58;
module.exports["WebItemLocationWithSpaceKeyQuery"] = $78914c14925ace72$export$c4b66d2db87918fa;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("2Awp2", function(module, exports) {
/* HighlightActions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $T1bCI = parcelRequire("T1bCI");


var $ccHMk = parcelRequire("ccHMk");


var $1yB28 = parcelRequire("1yB28");

var $8tSmd = parcelRequire("8tSmd");

var $48SU7 = parcelRequire("48SU7");

var $7ERUE = parcelRequire("7ERUE");

var $kDB94 = parcelRequire("kDB94");

var $iIVVb = parcelRequire("iIVVb");


var $g5gZt = parcelRequire("g5gZt");








var $lAFHW = parcelRequire("lAFHW");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");


var $8dvlB = parcelRequire("8dvlB");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $inPa6 = parcelRequire("inPa6");


var $2Rith = parcelRequire("2Rith");


var $1iSzD = parcelRequire("1iSzD");


var $abUsF = parcelRequire("abUsF");


var $5qqdA = parcelRequire("5qqdA");


var $eqKgz = parcelRequire("eqKgz");


var $aWwYt = parcelRequire("aWwYt");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $eSLr0 = parcelRequire("eSLr0");


var $kxhju = parcelRequire("kxhju");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $9wGTI = parcelRequire("9wGTI");


var $7Ndnw = parcelRequire("7Ndnw");


var $dizL5 = parcelRequire("dizL5");


var $2A8CJ = parcelRequire("2A8CJ");


var $hrAmX = parcelRequire("hrAmX");


var $hl1Kw = parcelRequire("hl1Kw");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $brNvA = parcelRequire("brNvA");


var $cMvMc = parcelRequire("cMvMc");


var $dANtQ = parcelRequire("dANtQ");


var $kRW4Y = parcelRequire("kRW4Y");


var $jmjWc = parcelRequire("jmjWc");


var $7W8i8 = parcelRequire("7W8i8");


var $2Jxlo = parcelRequire("2Jxlo");


var $a3Fla = parcelRequire("a3Fla");

parcelRequire("9ikgN");
var $cR1lV = parcelRequire("cR1lV");
var $9ikgN = parcelRequire("9ikgN");


var $7rLBD = parcelRequire("7rLBD");


var $bjVRl = parcelRequire("bjVRl");


var $9oxdN = parcelRequire("9oxdN");


var $7Sm4c = parcelRequire("7Sm4c");


var $eDk57 = parcelRequire("eDk57");


var $98CLM = parcelRequire("98CLM");

parcelRequire("aiS08");
var $1L1jV = parcelRequire("1L1jV");


var $jln20 = parcelRequire("jln20");


var $7mpOv = parcelRequire("7mpOv");


var $lJlG6 = parcelRequire("lJlG6");


var $6mKj3 = parcelRequire("6mKj3");


var $jAbYs = parcelRequire("jAbYs");


var $4VJDS = parcelRequire("4VJDS");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $4DJgG = parcelRequire("4DJgG");


var $6W81y = parcelRequire("6W81y");


var $4oXkq = parcelRequire("4oXkq");


var $lEDve = parcelRequire("lEDve");


var $bEdUx = parcelRequire("bEdUx");


var $2W2Mk = parcelRequire("2W2Mk");


var $l4eiF = parcelRequire("l4eiF");


var $2zMIV = parcelRequire("2zMIV");


var $b1ynj = parcelRequire("b1ynj");


var $dj3mI = parcelRequire("dj3mI");


var $6zmDz = parcelRequire("6zmDz");


var $97kfW = parcelRequire("97kfW");


var $joYQz = parcelRequire("joYQz");

const $9755f908a54a6c5b$var$builtInActionsStyles = null;
const $9755f908a54a6c5b$var$builtInActionsWithoutOtherActionsStyles = null;
const $9755f908a54a6c5b$var$POPUP_MOUSEUP_DISTANCE_THRESHOLD = 100;
const $9755f908a54a6c5b$var$BUILT_IN_ITEMS = [
    'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary',
    'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture'
];
const $9755f908a54a6c5b$export$9205c47465d0942 = [
    'com.atlassian.confluence.plugins.confluence-inline-comments:create-inline-comment',
    'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary'
];
const $9755f908a54a6c5b$var$i18n = (0, $cgtv4.defineMessages)({
    commentTooltip: {
        id: "highlight-actions.inline.comment.tooltip",
        defaultMessage: "Comment"
    },
    defineTooltip: {
        id: "highlight-actions.define.tooltip",
        defaultMessage: "Define"
    }
});
const $9755f908a54a6c5b$var$logger = (0, $7W8i8.getLogger)('inline-comment');

const $9755f908a54a6c5b$var$ForgeAction = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wTC7w",
    name: "ForgeAction",
    loader: async ()=>(await (parcelRequire("5iBet"))).ForgeAction
});

const $9755f908a54a6c5b$var$DefinitionAction = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wKsW8",
    name: "DefinitionAction",
    loader: async ()=>(await (parcelRequire("hTOMB"))).DefinitionAction
});
const $9755f908a54a6c5b$export$c1823fc1996a2ebd = (evt)=>{
    const highlightActionsToolbar = document.querySelector('[data-testid="highlightActionsPopup"]');
    const focusedElement = document.activeElement;
    if (highlightActionsToolbar && !highlightActionsToolbar?.contains(focusedElement) && evt.key === 'Tab' && !evt.ctrlKey && !evt.altKey) {
        evt.preventDefault();
        document.querySelector('[data-testid="createInlineCommentButton"]')?.focus();
    }
};
function $9755f908a54a6c5b$var$trapFocusInSelectionToolbar(event) {
    const highlightActionsToolbar = document.querySelector('#highlightActionsPopup');
    if (highlightActionsToolbar && event.key === 'Tab' && !event.ctrlKey && !event.altKey) {
        event.preventDefault();
        event.stopPropagation(); // Get all focusable elements in the toolbar
        const elements = Array.from(highlightActionsToolbar.querySelectorAll('button, a')).filter((curr)=>{
            if (curr instanceof HTMLButtonElement) return !curr.disabled;
            if (curr instanceof HTMLAnchorElement) return !!curr.href;
            return false;
        }); // Find the index of the currently focused element
        let idx = event.shiftKey ? elements.length : -1;
        const focusedElement = document.activeElement;
        if (highlightActionsToolbar.contains(focusedElement)) {
            for(let i = 0; i < elements.length; i++)if (elements[i] === focusedElement) {
                idx = i;
                break;
            }
        } // Focus the next element to focus
        event.shiftKey ? idx-- : idx++;
        if (idx < 0) idx = elements.length - 1;
        else if (idx >= elements.length) idx = 0;
        const next = elements[idx];
        if (next && (next instanceof HTMLButtonElement || next instanceof HTMLAnchorElement)) next.focus();
    }
} // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9755f908a54a6c5b$var$CustomLineWrapTooltip = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $afneb.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ppf _zulpu2gc _11q71aqn _2rkofajl _11c81o8v _1e0c1txw _2lx2vrvc _4cvr1y6m _kqswh2mm _syaz15cr _k48pi7a9",
            __cmplp.className
        ])
    });
});
const $9755f908a54a6c5b$export$c0b63e9f99a74f33 = (components, hasOtherActions)=>{
    const dividerLast = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.Divider), {
        key: "divider-last",
        "data-testid": "divider-last"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DividerOld), {
        key: "divider-last",
        "data-testid": "divider-last"
    });
    return components.reduce((result, component, i)=>{
        // Add the current component
        result.push(component); // Add a divider after each component except the last one
        if (i < components.length - 1) result.push((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.Divider), {
            key: `divider-${i}`,
            "data-testid": "divider"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DividerOld), {
            key: `divider-${i}`,
            "data-testid": "divider"
        }));
        return result; // If there are other actions, add a divider at the end
    }, []).concat(hasOtherActions ? dividerLast : []);
};
const $9755f908a54a6c5b$export$a6299569dd2a354f = ({ contentId: contentId, children: children, hasInlineComments: hasInlineComments = true, actions: actions, lastModifiedDate: lastModifiedDate, isArchived: isArchived, contentStatusError: contentStatusError, range: range, isAnnotationAllowed: isAnnotationAllowed, onCommentButtonPress: onCommentButtonPress, isFabric: isFabric, contentType: contentType, inlineNodeTypes: inlineNodeTypes, onCommentButtonMount: onCommentButtonMount })=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const [actionStates, setActionStates] = (0, $42omo.useState)({
        firstHighlightShown: false,
        show: false,
        top: 0,
        left: 0,
        forgeExtension: null,
        activeSelection: null,
        selectionRect: null,
        isReadingAidsOpen: false,
        readingAidsChangeboardingStep: 'disabled'
    });
    const [position, setPosition] = (0, $42omo.useState)(null);
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach, isInReattachMode: isInReattachMode } = (0, $brNvA.useReattachComment)();
    const { setReattachHighlight: setReattachHighlight } = (0, $brNvA.useReattachCommentDispatch)();
    const { lastModificationDate: lastModificationDate } = (0, $42omo.useContext)((0, $2A8CJ.ContentBodyContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { canAddComments: canAddComments, contentQueryError: contentQueryError } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId);
    const [{ searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics }] = (0, $hl1Kw.useSearchSessionId)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR)
    });
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const [isWarningDialogOpen, setIsWarningDialogOpen] = (0, $42omo.useState)(false);
    const [recordedClick, setRecordedClick] = (0, $42omo.useState)();
    const { setDefineDefinitionOpen: setDefineDefinitionOpen } = (0, $bjVRl.useReadingAidsActions)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true);
    const { firstHighlightShown: firstHighlightShown, show: show, top: top, left: left, forgeExtension: forgeExtension, activeSelection: activeSelection, selectionRect: selectionRect, isReadingAidsOpen: isReadingAidsOpen, readingAidsChangeboardingStep: readingAidsChangeboardingStep } = actionStates;
    const mountedRef = (0, $42omo.useRef)(false);
    const screenEventFiredRef = (0, $42omo.useRef)(false);
    const highlightActionsShownRef = (0, $42omo.useRef)(false);
    const content = (0, $42omo.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    const [showReadingAidsChangeboarding, stopReadingAidsChangeboarding] = (0, $9oxdN.useFeatureDiscovery)('highlight-actions.reading-aids.changeboarding');
    const isReadingAidsChangeboardingActive = readingAidsChangeboardingStep.match(/^modal|spotlight/);
    const highlightActionsContextValue = (0, $42omo.useMemo)(()=>({
            firstHighlightShown: firstHighlightShown
        }), [
        firstHighlightShown
    ]); // start the reading aids changeboarding
    (0, $42omo.useEffect)(()=>{
        setActionStates((prevState)=>({
                ...prevState,
                readingAidsChangeboardingStep: showReadingAidsChangeboarding && isAIEnabledForContent ? 'idle' : 'disabled'
            }));
    }, [
        showReadingAidsChangeboarding,
        isAIEnabledForContent
    ]);
    (0, $42omo.useEffect)(()=>{
        // Manually trigger resize to ensure spotlight is properly aligned
        window.setTimeout(()=>window.dispatchEvent(new Event('resize')), 0);
        if (!show) {
            // Force a redraw of portalContainer, which fixes an issue where the popup is removed from DOM but is
            // still visible on the page __in Safari__. (https://product-fabric.atlassian.net/browse/COMMENTS-5335)
            // This rendering issue occurring in Safari's WebKit engine seems to be known and has a long history.
            // Only do this when `show === false`, since the issue only occurs when attepmting to hide the popup.
            const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`);
            if (portalContainer) {
                portalContainer.style.transform = 'translateZ(0)'; // This line below reads this layout property, which triggers a reflow + redraw as side effect.
                portalContainer.offsetHeight; // NOSONAR - Sonar would complain: "Expected an assignment or function call and instead saw an expression"
                portalContainer.style.transform = '';
            }
        }
    }, [
        show
    ]); // freeze the user's selection while reading aids changeboarding is active
    (0, $42omo.useEffect)(()=>{
        const akPortalContainer = document.querySelector('.atlaskit-portal-container');
        if (akPortalContainer) {
            if (isReadingAidsChangeboardingActive) {
                akPortalContainer.style.userSelect = 'none';
                return ()=>{
                    akPortalContainer.style.userSelect = 'auto';
                };
            } else akPortalContainer.style.userSelect = 'auto';
        }
    }, [
        isReadingAidsChangeboardingActive
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
            document.addEventListener('keydown', $9755f908a54a6c5b$var$trapFocusInSelectionToolbar);
            return ()=>{
                document.removeEventListener('keydown', $9755f908a54a6c5b$var$trapFocusInSelectionToolbar);
            };
        }
    }, []);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('mouseup', onMouseUp);
        window.addEventListener('highlight-actions.container.resized', onContainerResized);
        return ()=>{
            window.removeEventListener('mouseup', onMouseUp);
            window.removeEventListener('highlight-actions.container.resized', onContainerResized);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        commentToReattach,
        isReadingAidsChangeboardingActive
    ]); // Close reading aids popup when navigating to another page
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            setDefineDefinitionOpen({
                defineDefinitionOpen: false
            });
            setActionStates((prevState)=>({
                    ...prevState,
                    isReadingAidsOpen: false
                }));
        };
    }, [
        contentId,
        setDefineDefinitionOpen
    ]);
    const onContainerResized = ()=>{
        setActionStates((prevState)=>({
                ...prevState,
                show: false,
                forgeExtension: null
            }));
    };
    function getScrollParent(node) {
        if (!node) return null;
        if (node.nodeType !== Node.TEXT_NODE && node.scrollWidth > node.clientWidth) return node;
        else return getScrollParent(node.parentNode);
    }
    function getParentNode(node) {
        if (!node) return null;
        if (node.nodeType !== Node.TEXT_NODE) return node;
        else return getParentNode(node.parentNode);
    }
    const getPosition = (range)=>{
        const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`);
        const portalRect = portalContainer?.getBoundingClientRect() || {
            left: 0,
            top: 0
        };
        const { left: leftRect, top: topRect, width: width, height: height } = range.getBoundingClientRect(); // Popup can't be rendered outside the body area
        const contentRect = getParentNode(range.commonAncestorContainer).getBoundingClientRect();
        let leftLimit = contentRect.left;
        let rightLimit = contentRect.right; // If the selected text has a parent that is scrollable for example like text inside table.
        // The popup is limited to be shown within the scrollable area.
        const firstParentThatCanScroll = getScrollParent(range.startContainer);
        if (firstParentThatCanScroll) {
            const scrollParentRect = firstParentThatCanScroll.getBoundingClientRect();
            leftLimit = Math.max(leftLimit, scrollParentRect.left);
            rightLimit = Math.min(rightLimit, scrollParentRect.right);
        }
        let x = width / 2 + leftRect;
        if (!(0, $9wGTI.fg)('kd_definitions_skip_displacement_computation')) x = Math.max(leftLimit, Math.min(rightLimit, x));
        return {
            pos: {
                left: x - portalRect.left,
                top: topRect - portalRect.top
            },
            selectionRect: {
                left: x - portalRect.left,
                top: topRect - portalRect.top,
                width: width,
                height: height
            }
        };
    };
    (0, $42omo.useEffect)(()=>{
        if (range) {
            const { pos: pos, selectionRect: selectionRectangle } = getPosition(range);
            highlightActionsShownRef.current = false;
            setPosition(pos);
            setActionStates((prevState)=>({
                    ...prevState,
                    selectionRect: selectionRectangle,
                    show: true
                }));
        } else {
            setPosition(null);
            setActionStates((prevState)=>({
                    ...prevState,
                    show: false
                }));
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        range
    ]);
    const updatePosition = (0, $42omo.useCallback)(()=>{
        if (range) {
            const { pos: pos } = getPosition(range);
            setPosition(pos);
            return pos;
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        range
    ]);
    const prepareAndSetHighlightForReattachMode = ()=>{
        const convertedSelectionObj = (0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach,
            actions: actions
        }); // Only set the highlight if it's valid
        if (convertedSelectionObj.numMatches > 0 && convertedSelectionObj.matchIndex !== -1) setReattachHighlight(convertedSelectionObj);
    };
    const isDatasourceHighlighted = (range)=>{
        const datasourceContainers = document.querySelectorAll('.datasource-table');
        return Array.from(datasourceContainers).some((container)=>container.contains(range.startContainer) || container.contains(range.endContainer));
    };
    const onMouseUp = (e)=>{
        return requestAnimationFrame(()=>{
            if (!mountedRef.current) return;
            const range = (0, $2zMIV.getRange)();
            const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`); // WS-1576/WS-2355 - Ignore any highlights in the Inline Comments sidebar
            const inlineCommentSidebarContainer = document.querySelector('#inline-comment-sidebar'); // InlineCommentNudge handles its own content selection and opening of the Comment Editor
            if (e.target.closest('#inline-comment-nudge')) return;
             // freeze the actions popup if reading aids changeboarding is active
            if (isReadingAidsChangeboardingActive) return;
             // freeze the actions popup if the input is clicked in the rovo chat more options popup
            if (e.target.closest('#context-menu-rovo-chat-custom-prompt')) return;
            const isCommentButtonDisabledAndClicked = e.target.closest('button[disabled]');
            const isContextMenuOtherAppsButtonClicked = e.target.closest('#context-menu-other-apps');
            const isCreateJiraIssueButtonClicked = e.target.closest('#create-jira-issue-trigger');
            const isRovoChatMoreOptionsButtonClicked = e.target.closest('#context-menu-rovo-chat-more-options');
            const isNotesButtonClicked = e.target.closest('#highlight-actions-notes-button');
            const shouldHideContextMenu = !(isCommentButtonDisabledAndClicked || isContextMenuOtherAppsButtonClicked || isCreateJiraIssueButtonClicked || isRovoChatMoreOptionsButtonClicked || isNotesButtonClicked);
            if (!range || !portalContainer || !content.current || inlineCommentSidebarContainer?.contains(range.startContainer) || inlineCommentSidebarContainer?.contains(range.endContainer) || isDatasourceHighlighted(range) || !content.current.contains(e.target) && content.current !== e.target && shouldHideContextMenu) {
                if (isInReattachMode()) setReattachHighlight(null);
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            } // COMMENTS-332 - In reattach mode, skip the measuring of the screen, just set the mode with the highlight
            if (isInReattachMode()) {
                prepareAndSetHighlightForReattachMode();
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            }
            const portalRect = portalContainer.getBoundingClientRect();
            const contentRect = content.current.getBoundingClientRect();
            const rects = range.getClientRects();
            if (!rects || !rects.length) {
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            } // Find first selection area that width is not 0
            // Sometimes there is a chance that user is selecting an empty DOM node.
            const rect = Array.from(rects).find((rect)=>rect.width !== 0 && rect.height !== 0);
            if (rect) {
                const { left: left, right: right, top: top, width: width, height: height } = rect;
                const mouseUpX = e.clientX; // This is a LEGACY disable statement after rule addition. Use `Math.floor(width/2)` next time
                // eslint-disable-next-line no-bitwise
                const selectedLineCenter = left + (width >> 1); // Popup can't be rendered outside the body area
                let leftLimit = contentRect.left;
                let rightLimit = contentRect.right; // If the selected text has a parent that is scrollable for example like text inside table.
                // The popup is limited to be shown within the scrollable area.
                const firstParentThatCanScroll = getScrollParent(range.startContainer);
                if (firstParentThatCanScroll) {
                    const scrollParentRect = firstParentThatCanScroll.getBoundingClientRect();
                    leftLimit = Math.max(leftLimit, scrollParentRect.left);
                    rightLimit = Math.min(rightLimit, scrollParentRect.right);
                } // Use the X-axis position if the center of selected line is POPUP_MOUSEUP_DISTANCE_THRESHOLD away from mouse up position.
                // POPUP_MOUSEUP_DISTANCE_THRESHOLD is an arbitrary number I made up.
                // The idea is the popup will always show up within POPUP_MOUSEUP_DISTANCE_THRESHOLD of the end of the selection.
                // Right near what user selects. However when the selection is too short - like a phase,
                // it will show up at the middle of the selection because it looks better.
                let x = Math.abs(mouseUpX - selectedLineCenter) > $9755f908a54a6c5b$var$POPUP_MOUSEUP_DISTANCE_THRESHOLD && left <= mouseUpX && mouseUpX <= right ? mouseUpX : selectedLineCenter; // However it is still bounded by the left and right boundary of the first line.
                // This is because the mouse up can be off screen.
                // For example: Make selection, then drag on a scroll bar.
                if (!(0, $9wGTI.fg)('kd_definitions_skip_displacement_computation')) x = Math.max(leftLimit, Math.min(rightLimit, x));
                if (!isFabric) highlightActionsShownRef.current = false;
                setActionStates((prevState)=>({
                        ...prevState,
                        firstHighlightShown: true,
                        // COMMENTS-332 - Don't show the popup when a selection is made in reattach mode
                        show: !isInReattachMode(),
                        left: x - portalRect.left,
                        top: top - portalRect.top,
                        selectionRect: {
                            left: x - portalRect.left,
                            top: top - portalRect.top,
                            width: width,
                            height: height
                        }
                    }));
            }
        });
    };
    const createReactInlineCommentHighlight = ()=>{
        if (isObjectSidebarShown) hideObjectSidebar();
        if (isFabric) onCommentButtonPress && onCommentButtonPress();
        else // Show the sidebar when the "Comment" button is clicked with the selection object
        createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach,
            actions: actions
        }));
    };
    const handleCommentButtonClick = (dialogs)=>{
        if (hasContentChanged) dialogs.showDialog((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>createReactInlineCommentHighlight()
        });
        else createReactInlineCommentHighlight();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'highlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createInlineCommentFromHighlightActionsMenu',
                type: 'ui',
                attributes: {
                    contentId: contentId,
                    pageMode: 'view',
                    searchSessionId: searchSessionId,
                    ...additionalAnalytics
                }
            }
        }).fire();
    };
    const extractNodeDetailsToString = (node)=>{
        if (!node) return '';
        while(node?.nodeType === Node.TEXT_NODE || node.tagName === 'MARK')node = node?.parentNode;
        if (node) {
            const elem = node;
            const classListStr = Array.from(elem.classList).join(',');
            let attrListStr = '';
            Object.entries(elem.dataset).forEach((attrEntry, idx)=>{
                if (idx > 0) attrListStr += ',';
                 // COMMENTS-1916 - Remove any emails that are in any values for attributes
                if (attrEntry.length > 1) {
                    const field = attrEntry[0];
                    if (field && field.includes('testMediaName')) attrEntry[1] = '';
                }
                attrListStr += attrEntry.join('=');
            }); // Get the tag name and stringify the class list and attribute list
            return `${elem.tagName}${classListStr.length ? `.${classListStr}` : ''}${attrListStr.length ? `[${attrListStr}]` : ''}`;
        }
        return '';
    };
    const CreateInlineCommentButton = ()=>{
        const { documentNeedsUpdate: documentNeedsUpdate, currentDocumentVersion: currentDocumentVersion, publishedDocumentVersion: publishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
        (0, $42omo.useEffect)(()=>{
            if (!(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
                document.addEventListener('keydown', $9755f908a54a6c5b$export$c1823fc1996a2ebd);
                return ()=>{
                    document.removeEventListener('keydown', $9755f908a54a6c5b$export$c1823fc1996a2ebd);
                };
            }
        }, []);
        (0, $42omo.useEffect)(()=>{
            onCommentButtonMount && onCommentButtonMount();
        }, []);
        if (!content.current) return null;
        const isHighlightValid = isFabric ? isAnnotationAllowed : (0, $2zMIV.isHighlightValidForInlineComment)(content.current, contentId);
        const shouldDisableCommentWhenDocumentNeedsUpdate = (selectedInlineNodeTypes)=>{
            // If document is outdated, only disable the comment button when selection is exactly 1 of the 4 types below.
            return selectedInlineNodeTypes?.length === 1 && [
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(selectedInlineNodeTypes[0]);
        }; // Cases where we want to disable the create button:
        // 1. The content is archived.
        // 2. The user does not have the "Comment - Add" permission.
        // 3. The highlight was invalid (over elements we don't support commenting on).
        // 4. The document needs to be updated (i.e. is outdated) AND selected node is one of [status, date, mention, inlineCard].
        // This order matters when communicating to users, as checking "Comment - Add" permission for archived pages
        // will return false.
        const needsUpdateToComment = shouldDisableCommentWhenDocumentNeedsUpdate(inlineNodeTypes) && (!!documentNeedsUpdate && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated', 'isEnabled', true) || currentDocumentVersion !== publishedDocumentVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true));
        const isCreateButtonEnabled = !isArchived && canAddComments && !needsUpdateToComment && isHighlightValid; // Check if the comment is on a selection that includes an non-text inline node
        const isNonTextInlineNodeIncludedInComment = (inlineNodeTypes ?? []).filter((nodeType)=>nodeType !== 'text').length > 0; // Track the nodes in which the highlight was made on to send in the event
        if (!highlightActionsShownRef.current) {
            highlightActionsShownRef.current = true;
            try {
                const selection = window.getSelection();
                const startingNode = extractNodeDetailsToString(selection?.anchorNode);
                const endingNode = extractNodeDetailsToString(selection?.focusNode); // Track when the menu is shown to users and if it's disabled
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'highlightActionsMenu',
                        action: 'shown',
                        actionSubject: 'toolbar',
                        actionSubjectId: 'highlightActionsMenu',
                        attributes: {
                            isDisabled: !isCreateButtonEnabled,
                            pageMode: 'view',
                            startingNode: startingNode,
                            endingNode: endingNode,
                            inlineNodeTypes: inlineNodeTypes,
                            isNonTextInlineNodeIncludedInComment: /**
               * This attribute is used as the trigger to display an engagement platform promotion message
               * when isNonTextInlineNodeIncludedInComment is true, and isDisabled is false,
               * A spotlight/flag will be shown to the user to encourage them to comment on inline nodes.
               */ isNonTextInlineNodeIncludedInComment
                        }
                    }
                }).fire();
            } catch (e) {
                $9755f908a54a6c5b$var$logger.error`Unable to send highlight actions event; ${e}`;
            }
        }
        const createButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $kRW4Y.DialogsStateContainer)
            ]
        }, (dialogs)=>{
            const commonCreateButtonProps = {
                'data-key': 'com.atlassian.confluence.plugins.confluence-inline-comments:create-inline-comment',
                // Needed for integration tests
                isDisabled: !isCreateButtonEnabled,
                testId: 'createInlineCommentButton',
                interactionName: 'start-inline-comment-action',
                onClick: ()=>{
                    handleCommentButtonClick(dialogs);
                },
                id: 'create-inline-comment-button'
            };
            return isNewToolbarEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
                ...commonCreateButtonProps,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                    label: "",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: "highlight-actions.inline-comments.comment",
                defaultMessage: "Comment"
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...commonCreateButtonProps,
                appearance: "subtle",
                iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                        label: ""
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: "highlight-actions.inline-comments.comment",
                defaultMessage: "Comment"
            })));
        }); // WS-2802 - We need to wrap the disabled button and put a transparent absolute overlay over the button
        //           in order to show the tooltip correctly as the disabled button swallows all events on the element
        //           and ADG doesn't allow tooltips on disabled buttons for accessibility reasons...
        if (isNewToolbarEnabled) return isCreateButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            content: (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? formatMessage($9755f908a54a6c5b$var$i18n.commentTooltip) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
                contentBefore: formatMessage($9755f908a54a6c5b$var$i18n.commentTooltip),
                isTooltip: true
            }),
            shortcut: (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? commentShortcutStrings : undefined
        }, createButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            delay: 0,
            content: (0, $dj3mI.getCreateButtonDisabledMessage)(isArchived, canAddComments, needsUpdateToComment, contentType)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonWrapper), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonOverlay), null), createButton));
        return isCreateButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? formatMessage($9755f908a54a6c5b$var$i18n.commentTooltip) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
                contentBefore: formatMessage($9755f908a54a6c5b$var$i18n.commentTooltip),
                isTooltip: true
            }),
            shortcut: (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? commentShortcutStrings : undefined
        }, createButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            delay: 0,
            position: "top",
            content: (0, $dj3mI.getCreateButtonDisabledMessage)(isArchived, canAddComments, needsUpdateToComment, contentType)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonWrapper), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonOverlay), null), createButton));
    };
    const createJiraIssueButton = (completeKey)=>{
        if (!content.current || (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return null;
        if (!(0, $4VJDS.default).getBoolean('confluence_legacy_single_jira_work_create', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eDk57.SingleIssueCreateProvidersWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
            config: {
                // Required configuration
                product: 'confluence',
                subproduct: 'jira',
                aiFeatureName: 'confluenceAiWorkCreation',
                proactiveGeneratedAI: 0,
                userGeneratedAI: 1,
                // Optional configuration
                source: 'highlightActionsMenu',
                skipAISessionValidation: true
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6W81y.CreateJiraIssueActions), {
            activeSelection: window.getSelection(),
            completeKey: completeKey,
            container: content.current,
            contentId: contentId,
            contentType: contentType,
            lastModified: lastModifiedDate || lastModificationDate,
            showCreateMultipleIssuesButton: (0, $2zMIV.isHighlightValidForBulkCreateJiraIssues)(),
            setRecordedClick: setRecordedClick,
            setIsWarningDialogOpen: setIsWarningDialogOpen
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                    label: ""
                }),
            "data-key": completeKey,
            testId: "createJiraIssueButton",
            onClick: (0, $2W2Mk.createJiraIssueSummaryHandle)(content.current, contentId, lastModifiedDate || lastModificationDate)
        }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "highlight-actions.create-issue-issue-term-refresh",
            defaultMessage: "Create work item"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "highlight-actions.create-issue",
            defaultMessage: "Create issue"
        }));
    };
    const createTrelloInboxButton = (completeKey)=>{
        if (!content.current || (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4oXkq.AddToTrelloInboxActions), {
            activeSelection: window.getSelection(),
            completeKey: completeKey,
            contentId: contentId
        });
    };
    const createReadingAidsDefineButton = ({ selectedRange: selectedRange, selectedText: selectedText, isOverWordLimit: isOverWordLimit })=>{
        if (!content.current) return null;
        const isDisabled = isOverWordLimit && readingAidsChangeboardingStep === 'disabled' || // only check word limit when changeboarding is disabled
        readingAidsChangeboardingStep === 'spotlight'; // always disable when spotlight is active
        const commonDefineButtonProps = {
            testId: 'defineButton',
            isDisabled: isDisabled,
            onClick: ()=>{
                if (!selectedRange) return;
                if (!selectedText) return;
                if (isAIEnabledForContent || isRovoEnabledForContent) experienceTracker.start({
                    name: (0, $irVI7.READING_AIDS_EXPERIENCE),
                    attributes: {
                        contentId: contentId,
                        source: 'defineButton'
                    }
                });
                setDefineDefinitionOpen({
                    defineDefinitionOpen: true
                });
                setActionStates((prevState)=>({
                        ...prevState,
                        ...isOverWordLimit && readingAidsChangeboardingStep === 'idle' ? {
                            readingAidsChangeboardingStep: 'modal-word-count'
                        } : {
                            isReadingAidsOpen: true
                        },
                        show: false,
                        activeSelection: {
                            selectedText: selectedText,
                            selectedRange: selectedRange
                        }
                    }));
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'highlightActionsMenu',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'defineButton',
                        type: 'ui',
                        attributes: {
                            contentId: contentId,
                            isAIOptedIn: isAIEnabledForContent
                        }
                    }
                }).fire();
            }
        };
        const oldDefineButtonIcon = isRovoEnabledForContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $97kfW.AtlassianIntelligenceIcon), {
            size: "large",
            greyed: isDisabled
        });
        const defineButtonIcon = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
            label: ""
        }) : oldDefineButtonIcon;
        const defineButton = isNewToolbarEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: (0, $cR1lV.READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            content: formatMessage($9755f908a54a6c5b$var$i18n.defineTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
            ...commonDefineButtonProps,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
                label: "",
                size: "small"
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "highlight-actions.define",
            defaultMessage: "Define"
        }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: (0, $cR1lV.READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            ...commonDefineButtonProps,
            appearance: "subtle",
            iconBefore: ()=>defineButtonIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "highlight-actions.define",
            defaultMessage: "Define"
        })));
        return isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            delay: 0,
            position: "top",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: "highlight-actions.define.unsupported",
                defaultMessage: "Highlight a term, acronym, or abbreviation"
            }),
            component: $9755f908a54a6c5b$var$CustomLineWrapTooltip
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonOverlay), null), defineButton)) : defineButton;
    };
    const handleClickChat = (0, $42omo.useCallback)(()=>{
        const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
        const isChatActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
        if (!isChatActive) rightSidebarContext.open((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
    }, [
        rightSidebarContext
    ]);
    const createRovoChatHighlightActionsButton = (selectedADFContent)=>{
        if ((0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abUsF.RovoChatHighlightActions), {
            selectedContent: selectedADFContent,
            product: "confluence",
            onClickChat: handleClickChat
        });
    };
    const renderBuiltInWebItemActionsOld = (builtInWebItems, hasOtherActions)=>{
        const baseComponents = [];
        if (hasInlineComments && !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) baseComponents.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CreateInlineCommentButton, null));
        if ((0, $6mKj3.expValEquals)('cc_notes', 'isEnabled', true)) baseComponents.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAbYs.HighlightActionsNotesButton), null));
        const selectedRange = (0, $2zMIV.getRange)();
        const selectedText = (0, $2zMIV.textNormalize)(String(window.getSelection())).replace(/\n/, ' ').trim();
        const wordCount = selectedText.split(/\s+/).length;
        const isOverWordLimit = wordCount > (0, $7rLBD.READING_AIDS_MAX_WORD_COUNT);
        const showReadingAidsDefineButton = isAIEnabledForContent || isRovoEnabledForContent;
        if (isRovoEnabledForContent) {
            const selectionString = (0, $joYQz.getHTMLString)(window.getSelection());
            const selectedADFContent = (0, $eqKgz.htmlToADF)(selectionString);
            const itemToPush = isOverWordLimit ? createRovoChatHighlightActionsButton(selectedADFContent) : createReadingAidsDefineButton({
                selectedRange: selectedRange,
                selectedText: selectedText,
                isOverWordLimit: isOverWordLimit
            });
            baseComponents.push(itemToPush);
        } else if (showReadingAidsDefineButton) baseComponents.push(createReadingAidsDefineButton({
            selectedRange: selectedRange,
            selectedText: selectedText,
            isOverWordLimit: isOverWordLimit
        }));
        const builtInComponents = builtInWebItems.map((item)=>{
            const { completeKey: completeKey } = item;
            if (completeKey === 'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary') return createJiraIssueButton(completeKey);
            else if (completeKey === 'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture') return createTrelloInboxButton(completeKey);
            return null;
        }).filter(Boolean);
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.BuiltInActionsPatch), {
            key: "built-in-actions"
        }, $9755f908a54a6c5b$export$c0b63e9f99a74f33([
            ...baseComponents,
            ...builtInComponents,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CreateInlineCommentButton, {
                key: "CreateInlineCommentButton"
            }),
            ...(0, $6mKj3.expValEquals)('cc_notes', 'isEnabled', true) ? [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAbYs.HighlightActionsNotesButton), {
                    key: "NotesButton"
                })
            ] : []
        ], hasOtherActions));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.BuiltInActionsOld), {
            key: "built-in-actions"
        }, $9755f908a54a6c5b$export$c0b63e9f99a74f33([
            ...baseComponents,
            ...builtInComponents
        ], hasOtherActions));
    };
    const renderBuiltInWebItemActions = (builtInWebItems, hasOtherActions)=>{
        const componentsAI = [];
        const components = [];
        const showMoreActions = [];
        let defineButton = null;
        const selectedRange = (0, $2zMIV.getRange)();
        const selectedText = (0, $2zMIV.textNormalize)(String(window.getSelection())).replace(/\n/, ' ').trim();
        const wordCount = selectedText.split(/\s+/).length;
        const isOverWordLimit = wordCount > (0, $7rLBD.READING_AIDS_MAX_WORD_COUNT);
        const showReadingAidsDefineButton = isAIEnabledForContent || isRovoEnabledForContent;
        const selectionString = (0, $joYQz.getHTMLString)(window.getSelection());
        const selectedADFContent = (0, $eqKgz.htmlToADF)(selectionString);
        if (isNewToolbarEnabled) {
            if (isRovoEnabledForContent) {
                const askRovoButton = createRovoChatHighlightActionsButton(selectedADFContent);
                if (askRovoButton) {
                    if ((0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) componentsAI.push(askRovoButton);
                    else components.push(askRovoButton);
                }
            }
            if (showReadingAidsDefineButton && !isOverWordLimit) {
                const defineButton = createReadingAidsDefineButton({
                    selectedRange: selectedRange,
                    selectedText: selectedText,
                    isOverWordLimit: isOverWordLimit
                });
                if (defineButton) {
                    if ((0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) componentsAI.push(defineButton);
                    else components.push(defineButton);
                }
            }
        } else {
            if (isRovoEnabledForContent) defineButton = isOverWordLimit ? createRovoChatHighlightActionsButton(selectedADFContent) : createReadingAidsDefineButton({
                selectedRange: selectedRange,
                selectedText: selectedText,
                isOverWordLimit: isOverWordLimit
            });
            else if (showReadingAidsDefineButton) defineButton = createReadingAidsDefineButton({
                selectedRange: selectedRange,
                selectedText: selectedText,
                isOverWordLimit: isOverWordLimit
            });
            if (defineButton) components.push(defineButton);
        }
        const commentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CreateInlineCommentButton, {
            key: "CreateInlineCommentButton"
        });
        components.push(commentButton);
        const notesButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAbYs.HighlightActionsNotesButton), {
            key: "NotesButton"
        });
        if ((0, $6mKj3.expValEquals)('cc_notes', 'isEnabled', true)) components.push(notesButton);
        let jiraButton = null;
        let trelloButton = null;
        builtInWebItems.forEach((item)=>{
            const { completeKey: completeKey } = item;
            if (completeKey === 'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary') jiraButton = createJiraIssueButton(completeKey);
            else if (completeKey === 'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture') trelloButton = createTrelloInboxButton(completeKey);
        });
        if (jiraButton) showMoreActions.push(jiraButton);
        if (trelloButton) showMoreActions.push(trelloButton);
        const _hasOtherActions = Boolean(hasOtherActions || showMoreActions.length > 0);
        if (isNewToolbarEnabled) {
            if (componentsAI.length > 0 && (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) // if there are AI components, render them in a ToolbarSection with a separator at the end
            return {
                builtInActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48SU7.ToolbarSection), {
                    key: "built-in-actions-ai",
                    hasSeparator: (0, $48SU7.SeparatorPosition).END
                }, componentsAI), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48SU7.ToolbarSection), {
                    key: "built-in-actions"
                }, components)),
                showMoreActions: showMoreActions
            };
            return {
                builtInActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48SU7.ToolbarSection), {
                    key: "built-in-actions"
                }, components),
                showMoreActions: showMoreActions
            };
        }
        return {
            builtInActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                key: "built-in-actions",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _ca0q1b66 _n3td1b66 _19bv1b66",
                    !_hasOtherActions && "_u5f31b66"
                ])
            }, $9755f908a54a6c5b$export$c0b63e9f99a74f33(components, _hasOtherActions)),
            showMoreActions: showMoreActions
        };
    };
    const getComponentsForPopup = (webItems, forgeItems = [])=>{
        const webItemsWithTrello = (0, $9wGTI.fg)('quick_capture_trello_inbox') ? [
            ...webItems,
            {
                completeKey: 'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture'
            }
        ] : webItems;
        const builtInWebItems = webItemsWithTrello.filter((item)=>$9755f908a54a6c5b$var$BUILT_IN_ITEMS.includes(item.completeKey));
        const connectItems = webItems.filter((item)=>!$9755f908a54a6c5b$export$9205c47465d0942.includes(item.completeKey));
        const hasOtherActions = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? Boolean(forgeItems?.length || connectItems?.length) : forgeItems?.length || connectItems?.length;
        const { builtInActions: builtInActions, showMoreActions: showMoreActions } = renderBuiltInWebItemActions(builtInWebItems, hasOtherActions); // TODO: ED-29221 - use ToolbarSection
        if (isNewToolbarEnabled) return [
            builtInActions,
            // <ToolbarSection>
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), {
                key: "other-components"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1ynj.OtherActions), {
                builtInActions: showMoreActions,
                connectItems: connectItems,
                forgeItems: forgeItems,
                selectForgeExtension: (forgeExtension)=>{
                    const selectedRange = (0, $2zMIV.getRange)();
                    if (!selectedRange) return;
                    const selectedText = (0, $2zMIV.textNormalize)(String(selectedRange)).trim();
                    if (!selectedText) return;
                    setActionStates((prevState)=>({
                            ...prevState,
                            forgeExtension: forgeExtension,
                            activeSelection: {
                                selectedText: selectedText,
                                selectedRange: selectedRange
                            }
                        }));
                }
            })) // </ToolbarSection>
        ];
        return [
            (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? builtInActions : renderBuiltInWebItemActionsOld(builtInWebItems, hasOtherActions),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1ynj.OtherActions), {
                key: "other-components",
                builtInActions: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? showMoreActions : undefined,
                connectItems: connectItems,
                forgeItems: forgeItems,
                selectForgeExtension: (forgeExtension)=>{
                    const selectedRange = (0, $2zMIV.getRange)();
                    if (!selectedRange) return;
                    const selectedText = (0, $2zMIV.textNormalize)(String(selectedRange)).trim();
                    if (!selectedText) return;
                    setActionStates((prevState)=>({
                            ...prevState,
                            forgeExtension: forgeExtension,
                            activeSelection: {
                                selectedText: selectedText,
                                selectedRange: selectedRange
                            }
                        }));
                }
            })
        ];
    };
    const renderPopup = (components)=>components.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $hrAmX.BannerStateContainer)
            ]
        }, (bannerState)=>{
            // if there's a sticky header we want to position the toolbar below
            // the nav, the page header (if visible) and the sticky header
            let stickyHeaderHeight = 0;
            const range = (0, $2zMIV.getRange)();
            if (range) {
                const header = (0, $2zMIV.findStickyHeader)(range.commonAncestorContainer);
                if (header && bannerState) stickyHeaderHeight = bannerState.getTotalHeight() + header.clientHeight;
            }
            if (!screenEventFiredRef.current) createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'highlightActionsMenu',
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
            screenEventFiredRef.current = true;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lEDve.Popup), {
                top: stickyHeaderHeight + (position?.top ?? top),
                left: position?.left ?? left,
                updatePosition: updatePosition
            }, components), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_EXPERIENCE)
            }));
        }) : null;
    const isCreateSingleJiraIssueHandleParams = (params)=>{
        return params?.fireAiAnalytics === undefined;
    };
    const handleConfirm = (0, $42omo.useCallback)(async ()=>{
        const callRightSidebarClose = async ()=>rightSidebarContext.close((0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID)); // Need to make sure sidebar is closed before creating a new one issue
        await callRightSidebarClose(); // Sorry this block sucks because of TS types
        if (isCreateSingleJiraIssueHandleParams(recordedClick)) (0, $joYQz.createSingleJiraIssueHandle)(recordedClick);
        else recordedClick && (0, $joYQz.createSingleAiJiraIssueHandle)(recordedClick);
        setIsWarningDialogOpen(false);
    }, [
        setIsWarningDialogOpen,
        recordedClick,
        rightSidebarContext
    ]);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        setIsWarningDialogOpen(false);
    }, [
        setIsWarningDialogOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, isWarningDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $98CLM.IssueCreateWarningDialog), {
        onConfirm: handleConfirm,
        onCancel: handleCancel
    }), contentStatusError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentStatusError
    }), contentQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentQueryError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
        render: (_apps, _loading, error)=>{
            if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            return null;
        }
    }), forgeExtension && activeSelection && !show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9755f908a54a6c5b$var$ForgeAction, {
        content: content.current,
        contentId: contentId,
        forgeExtension: forgeExtension,
        activeSelection: activeSelection,
        onClose: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    forgeExtension: null
                }));
        }
    }), (0, $9wGTI.fg)('kd_definitions_confluence_enable_platform') ? isReadingAidsOpen && activeSelection && !show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9755f908a54a6c5b$var$DefinitionAction, {
        contentId: contentId,
        contentType: contentType,
        onClose: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    isReadingAidsOpen: false
                }));
        },
        selectedText: activeSelection.selectedText,
        selectionRect: selectionRect
    }) : isReadingAidsOpen && activeSelection && !show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Jxlo.ReadingAidsPopup), {
        selectedText: activeSelection.selectedText,
        selectionRange: activeSelection.selectedRange,
        selectionRect: selectionRect,
        isReadingAidsOpen: isReadingAidsOpen,
        onClose: ()=>{
            setDefineDefinitionOpen({
                defineDefinitionOpen: false
            });
            setActionStates((prevState)=>({
                    ...prevState,
                    isReadingAidsOpen: false
                }));
        },
        contentId: contentId,
        popupPortalContainerId: (0, $bEdUx.popupPortalContainerId),
        onResult: (result)=>{
            if (readingAidsChangeboardingStep === 'idle') {
                if (result?.nlpSearch?.errorState?.startsWith('NO_ANSWER')) setActionStates((prevState)=>({
                        ...prevState,
                        isReadingAidsOpen: false,
                        readingAidsChangeboardingStep: 'modal-undefined'
                    }));
                else stopReadingAidsChangeboarding();
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8dvlB.default), null, readingAidsChangeboardingStep.startsWith('modal') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a3Fla.ReadingAidsChangeboardingModal), {
        onNextClick: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    readingAidsChangeboardingStep: 'spotlight',
                    show: true
                }));
        },
        modalVersion: readingAidsChangeboardingStep,
        contentId: contentId
    }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, readingAidsChangeboardingStep === 'spotlight' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ikgN.ReadingAidsChangeboardingSpotlight), {
        contentId: contentId,
        onGotItClick: stopReadingAidsChangeboarding
    }) : null), !isFabric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l4eiF.HighlightActionsContext).Provider, {
        value: highlightActionsContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        key: "content-container",
        ref: content
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        id: contentId,
        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kxhju.WebItemLocation), {
        key: "action-panel",
        contentId: contentId,
        location: (0, $eSLr0.ACTION_PANEL),
        fetchPolicy: "cache-first"
    }, ({ webItems: webItems })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
            moduleType: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
            render: (forgeItems, loading, error)=>{
                if (loading) return null;
                if (error) {
                    if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                        error: error
                    });
                    return null;
                }
                return renderPopup(getComponentsForPopup(webItems, forgeItems));
            }
        }))) : null));
};
module.exports["DROPDOWN_EXCLUDED_ITEMS"] = $9755f908a54a6c5b$export$9205c47465d0942;
module.exports["HighlightActions"] = $9755f908a54a6c5b$export$a6299569dd2a354f;

});

parcelRegister("8dvlB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce20a225af4b866c$export$2e2bcd8739ae039);
/**
 * We re-export this because products may have multiple versions of
 * `@atlaskit/modal-dialog`.
 *
 * If a consumer uses the onboarding `Modal` with the `ModalTransition` from an
 * incompatible version of `@atlaskit/modal-dialog`, then the modal can get
 * stuck in an open state.
 *
 * See https://product-fabric.atlassian.net/browse/DSP-796 for more details
 * and a reproduction.
 *
 */ 
var $6xdDU = parcelRequire("6xdDU");

var /**
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ $ce20a225af4b866c$export$2e2bcd8739ae039 = (0, $6xdDU.default);

});

parcelRegister("5izcQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $QiYCb = parcelRequire("QiYCb");


var $6cnUO = parcelRequire("6cnUO");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$f788f1551fff696f$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;
module.exports["default"] = $f788f1551fff696f$export$2e2bcd8739ae039;

});

parcelRegister("QiYCb", function(module, exports) {
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $e8Hkv = parcelRequire("e8Hkv");

const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8Hkv))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: divRef,
        className: (0, $gMc0m.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
$9a3edd35791f2369$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;
module.exports["default"] = $9a3edd35791f2369$export$2e2bcd8739ae039;

});

parcelRegister("2Rith", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $j4EkW = parcelRequire("j4EkW");

const $0f73dde994861ed0$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $0f73dde994861ed0$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $j4EkW.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $42omo.useMemo)(()=>{
        $0f73dde994861ed0$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ifW2H.AIEventsInstrumentationContext).Provider, {
        value: contextValue,
        children: children
    });
};
module.exports["AIEventsInstrumentationProvider"] = $0f73dde994861ed0$export$b5d4bc85dfbaa4f8;

});

parcelRegister("ifW2H", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $62e0541727c97e34$export$4f059feb37b5835e = (0, $42omo.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $62e0541727c97e34$export$4f059feb37b5835e;

});

parcelRegister("8Y3mE", function(module, exports) {

var $ea2ui = parcelRequire("ea2ui");

const $a544c5804dc19870$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $ea2ui.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $a544c5804dc19870$export$5013b36eeed4ec19;

});

parcelRegister("ea2ui", function(module, exports) {
var $5a6bb3bf0e14987c$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $5a6bb3bf0e14987c$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $5a6bb3bf0e14987c$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $5a6bb3bf0e14987c$export$7052d5b66e36f60f;

});

parcelRegister("j4EkW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kTkuM = parcelRequire("kTkuM");


var $a4NM6 = parcelRequire("a4NM6");


var $ea2ui = parcelRequire("ea2ui");

const $a4ec83494ea42b83$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $42omo.useRef)(undefined);
    const aiSessionStateRef = (0, $42omo.useRef)((0, $ea2ui.AISessionState).unset);
    const setAISessionState = (0, $42omo.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $42omo.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $42omo.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $kTkuM.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $a4NM6.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $42omo.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $a4NM6.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $a4ec83494ea42b83$export$259576f4e7ac6488;

});

parcelRegister("kTkuM", function(module, exports) {

var $dWJ5i = parcelRequire("dWJ5i");


var $cUcZ5 = parcelRequire("cUcZ5");

function $9779584a42635fbf$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $dWJ5i.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
}
module.exports["getNewSingleInstrumentationID"] = $9779584a42635fbf$export$cee2a1482be61648;

});

parcelRegister("dWJ5i", function(module, exports) {
const $a273a9fd41301c8f$var$t = Symbol.for("@ts-pattern/matcher"), $a273a9fd41301c8f$var$e = Symbol.for("@ts-pattern/isVariadic"), $a273a9fd41301c8f$var$n = "@ts-pattern/anonymous-select-key", $a273a9fd41301c8f$var$r = (t)=>Boolean(t && "object" == typeof t), $a273a9fd41301c8f$var$i = (e)=>e && !!e[$a273a9fd41301c8f$var$t], $a273a9fd41301c8f$var$o = (n, s, c)=>{
    if ($a273a9fd41301c8f$var$i(n)) {
        const e = n[$a273a9fd41301c8f$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($a273a9fd41301c8f$var$r(n)) {
        if (!$a273a9fd41301c8f$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $a273a9fd41301c8f$var$i(s) && s[$a273a9fd41301c8f$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$a273a9fd41301c8f$var$o(t, e[n], c)) && r.every((t, e)=>$a273a9fd41301c8f$var$o(t, n[e], c)) && (0 === a.length || $a273a9fd41301c8f$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$a273a9fd41301c8f$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $a273a9fd41301c8f$var$i(a = r) && "optional" === a[$a273a9fd41301c8f$var$t]().matcherType) && $a273a9fd41301c8f$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $a273a9fd41301c8f$var$s = (e)=>{
    var n, o, a;
    return $a273a9fd41301c8f$var$r(e) ? $a273a9fd41301c8f$var$i(e) ? null != (n = null == (o = (a = e[$a273a9fd41301c8f$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s) : $a273a9fd41301c8f$var$c(Object.values(e), $a273a9fd41301c8f$var$s) : [];
}, $a273a9fd41301c8f$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $a273a9fd41301c8f$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$a273a9fd41301c8f$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $a273a9fd41301c8f$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $a273a9fd41301c8f$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$a273a9fd41301c8f$var$l(t),
        and: (e)=>$a273a9fd41301c8f$var$m(t, e),
        or: (e)=>$a273a9fd41301c8f$var$d(t, e),
        select: (e)=>void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t)
    });
}
function $a273a9fd41301c8f$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$a273a9fd41301c8f$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$a273a9fd41301c8f$var$h($a273a9fd41301c8f$var$l(t)),
        select: (e)=>$a273a9fd41301c8f$var$h(void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t))
    });
}
function $a273a9fd41301c8f$var$l(e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($a273a9fd41301c8f$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $a273a9fd41301c8f$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$s(e),
                matcherType: "optional"
            })
    });
}
const $a273a9fd41301c8f$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $a273a9fd41301c8f$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $a273a9fd41301c8f$var$m(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "and"
            })
    });
}
function $a273a9fd41301c8f$var$d(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "or"
            })
    });
}
function $a273a9fd41301c8f$var$p(e) {
    return {
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $a273a9fd41301c8f$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $a273a9fd41301c8f$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $a273a9fd41301c8f$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $a273a9fd41301c8f$var$n
                    ].concat(void 0 === i ? [] : $a273a9fd41301c8f$var$s(i))
            })
    });
}
function $a273a9fd41301c8f$var$v(t) {
    return "number" == typeof t;
}
function $a273a9fd41301c8f$var$b(t) {
    return "string" == typeof t;
}
function $a273a9fd41301c8f$var$w(t) {
    return "bigint" == typeof t;
}
const $a273a9fd41301c8f$var$S = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return !0;
})), $a273a9fd41301c8f$var$O = $a273a9fd41301c8f$var$S, $a273a9fd41301c8f$var$j = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length >= t))(e))),
        length: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && Boolean(t.match(n))))));
        }
    }), $a273a9fd41301c8f$var$K = $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$b)), $a273a9fd41301c8f$var$x = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e >= t))(e))),
        int: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t < 0)))
    }), $a273a9fd41301c8f$var$E = $a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$v)), $a273a9fd41301c8f$var$A = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e >= t))(e))),
        positive: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t < 0)))
    }), $a273a9fd41301c8f$var$P = $a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$w)), $a273a9fd41301c8f$var$T = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "boolean" == typeof t;
})), $a273a9fd41301c8f$var$B = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "symbol" == typeof t;
})), $a273a9fd41301c8f$var$_ = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null == t;
})), $a273a9fd41301c8f$var$k = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null != t;
}));
var $a273a9fd41301c8f$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $a273a9fd41301c8f$var$t,
    optional: $a273a9fd41301c8f$var$l,
    array: function(...e) {
        return $a273a9fd41301c8f$var$h({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $a273a9fd41301c8f$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$a273a9fd41301c8f$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $a273a9fd41301c8f$var$f(t, (t)=>$a273a9fd41301c8f$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $a273a9fd41301c8f$var$g(t, (t, e)=>{
                                const n = $a273a9fd41301c8f$var$o(s, e, r), i = $a273a9fd41301c8f$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$a273a9fd41301c8f$var$s(e[0]),
                            ...$a273a9fd41301c8f$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $a273a9fd41301c8f$var$m,
    union: $a273a9fd41301c8f$var$d,
    not: function(e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$a273a9fd41301c8f$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $a273a9fd41301c8f$var$p,
    select: $a273a9fd41301c8f$var$y,
    any: $a273a9fd41301c8f$var$S,
    _: $a273a9fd41301c8f$var$O,
    string: $a273a9fd41301c8f$var$K,
    number: $a273a9fd41301c8f$var$E,
    bigint: $a273a9fd41301c8f$var$P,
    boolean: $a273a9fd41301c8f$var$T,
    symbol: $a273a9fd41301c8f$var$B,
    nullish: $a273a9fd41301c8f$var$_,
    nonNullable: $a273a9fd41301c8f$var$k,
    instanceOf: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p($a273a9fd41301c8f$export$ce1e7a33533a73d9(t)));
    }
};
class $a273a9fd41301c8f$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $a273a9fd41301c8f$var$$ = {
    matched: !1,
    value: void 0
};
function $a273a9fd41301c8f$export$4659b591c19bdf3d(t) {
    return new $a273a9fd41301c8f$var$I(t, $a273a9fd41301c8f$var$$);
}
class $a273a9fd41301c8f$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$a273a9fd41301c8f$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $a273a9fd41301c8f$var$$ : {
            matched: !0,
            value: e(s ? $a273a9fd41301c8f$var$n in c ? c[$a273a9fd41301c8f$var$n] : c : this.input, this.input)
        };
        return new $a273a9fd41301c8f$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $a273a9fd41301c8f$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $a273a9fd41301c8f$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $a273a9fd41301c8f$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $a273a9fd41301c8f$var$L(t) {
    throw new $a273a9fd41301c8f$export$6c1467edb54d3773(t);
}
module.exports["P"] = $a273a9fd41301c8f$export$56c0d5a1e737357d;
module.exports["match"] = $a273a9fd41301c8f$export$4659b591c19bdf3d;

});

parcelRegister("a4NM6", function(module, exports) {

var $hEbxW = parcelRequire("hEbxW");

var $eGd7K = parcelRequire("eGd7K");

const $2674cc9dba61bfc1$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $2674cc9dba61bfc1$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $2674cc9dba61bfc1$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $eGd7K.setCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $2674cc9dba61bfc1$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $hEbxW.getCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $2674cc9dba61bfc1$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$d6fb1caea334c7c7;

});

parcelRegister("abUsF", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $fBMbo = parcelRequire("fBMbo");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $9J8UT = parcelRequire("9J8UT");

var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");


var $c6GJD = parcelRequire("c6GJD");


var $fzqvY = parcelRequire("fzqvY");

var $fb3kw = parcelRequire("fb3kw");


var $ghftu = parcelRequire("ghftu");


var $4fdTR = parcelRequire("4fdTR");


var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $lBFuf = parcelRequire("lBFuf");


var $i25hX = parcelRequire("i25hX");


var $4noo5 = parcelRequire("4noo5");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");


var $kIvLT = parcelRequire("kIvLT");


var $ygGKm = parcelRequire("ygGKm");


var $gncRT = parcelRequire("gncRT");


var $gjr93 = parcelRequire("gjr93");


var $jmorr = parcelRequire("jmorr");

const $157c507ad23459f7$var$styles = {
    popupContainer: "_ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    formWrapper: "_1pfhx0bf",
    sendIconWrapper: "_y4tiutpp",
    rovoChatMoreOptionsButtonContainer: "_ahbqx0bf",
    rovoChatOpenChatIcon: "_bozgv77o"
};
const $157c507ad23459f7$export$1ccbc9113b239d47 = ({ selectedContent: selectedContent, product: product, onClickChat: onClickChat, onClickPromptOverride: onClickPromptOverride, onSubmitCustomPromptOverride: onSubmitCustomPromptOverride })=>{
    (0, $fBMbo.di)((0, $c6GJD.default), (0, $gncRT.useRovoChatHighlightActions));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { setIsMoreOptionsPopupOpen: setIsMoreOptionsPopupOpen } = (0, $gncRT.useRovoChatHighlightActionsActions)();
    const [{ isMoreOptionsPopupOpen: isMoreOptionsPopupOpen }] = (0, $gncRT.useRovoChatHighlightActions)();
    const { insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder } = (0, $gjr93.useHighlightActionsEditorPlaceholder)();
    (0, $42omo.useEffect)(()=>{
        sendAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'contextualMenuItem',
            actionSubjectId: 'rovoChatHighlightActions',
            attributes: {
                product: product
            }
        });
    }, [
        sendAnalyticsEvent,
        product
    ]);
    const onClose = (0, $42omo.useCallback)(()=>{
        setIsMoreOptionsPopupOpen(false);
    }, [
        setIsMoreOptionsPopupOpen
    ]);
    const handleClickChat = (0, $42omo.useCallback)(async ()=>{
        onClickChat();
        insertHighlightActionsEditorPlaceholder(selectedContent);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuRovoChatButton',
            attributes: {
                product: product
            }
        });
    }, [
        onClickChat,
        insertHighlightActionsEditorPlaceholder,
        selectedContent,
        sendAnalyticsEvent,
        product
    ]);
    const handlePromptSubmit = (0, $42omo.useCallback)((values, form)=>{
        const formattedPrompt = (0, $ygGKm.appendADFContent)(selectedContent, values.prompt);
        if (onSubmitCustomPromptOverride) {
            onSubmitCustomPromptOverride(formattedPrompt);
            form.reset();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
                attributes: {
                    product: product
                }
            });
            return;
        }
        publish({
            type: 'chat-new',
            source: `${product}-context-menu`,
            data: {
                name: values.prompt.substring(0, 30),
                dialogues: [],
                prompt: formattedPrompt
            }
        });
        form.reset();
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
            attributes: {
                product: product
            }
        });
    }, [
        publish,
        sendAnalyticsEvent,
        product,
        onSubmitCustomPromptOverride,
        selectedContent
    ]);
    const rovoChatPromptOptions = [
        {
            id: 'context-menu-rovo-chat-summarize-option',
            actionType: 'summarize',
            prompt: formatMessage((0, $jmorr.default).rovoChatSummarizePrompt),
            optionText: formatMessage((0, $jmorr.default).rovoChatSummarizeOptionText)
        },
        {
            id: 'context-menu-rovo-chat-explain-option',
            actionType: 'explain',
            prompt: formatMessage((0, $jmorr.default).rovoChatExplainPrompt),
            optionText: formatMessage((0, $jmorr.default).rovoChatExplainOptionText)
        },
        {
            id: 'context-menu-rovo-chat-find-resources-option',
            actionType: 'find-resources',
            prompt: formatMessage((0, $jmorr.default).rovoChatFindResourcesPrompt),
            optionText: formatMessage((0, $jmorr.default).rovoChatFindResourcesOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-feedback-option',
            actionType: 'give-feedback',
            prompt: formatMessage((0, $jmorr.default).rovoChatGiveFeedbackPrompt),
            optionText: formatMessage((0, $jmorr.default).rovoChatGiveFeedbackOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-examples-option',
            actionType: 'give-examples',
            prompt: formatMessage((0, $jmorr.default).rovoChatGiveExamplesPrompt),
            optionText: formatMessage((0, $jmorr.default).rovoChatGiveExamplesOptionText)
        }
    ];
    const renderPopupContent = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            testId: "context-menu-rovo-chat-popup",
            xcss: $157c507ad23459f7$var$styles.popupContainer,
            space: "space.150",
            children: [
                rovoChatPromptOptions.map((option)=>{
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lBFuf.ChatPill), {
                        testId: option.id,
                        onClick: ()=>{
                            const formattedPrompt = (0, $ygGKm.appendADFContent)(selectedContent, option.prompt);
                            if (onClickPromptOverride) {
                                onClickPromptOverride(formattedPrompt);
                                sendAnalyticsEvent({
                                    action: 'clicked',
                                    actionSubject: 'button',
                                    actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                                    attributes: {
                                        actionType: option.actionType,
                                        product: product
                                    }
                                });
                                return;
                            }
                            publish({
                                type: 'chat-new',
                                source: `${product}-context-menu`,
                                data: {
                                    name: option.prompt.substring(0, 30),
                                    dialogues: [],
                                    prompt: formattedPrompt
                                }
                            });
                            sendAnalyticsEvent({
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                                attributes: {
                                    actionType: option.actionType,
                                    product: product
                                }
                            });
                        },
                        children: option.optionText
                    }, option.id);
                }),
                (0, $dh538.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
                    onSubmit: handlePromptSubmit,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                        name: "prompt",
                        children: ({ fieldProps: { value: value, ...fieldPropsRest }, meta: { dirty: dirty } })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default // this prevents the highlight actions popup from closing when clicking on the input
                            ), {
                                onClick: (e)=>e.stopPropagation(),
                                ...fieldPropsRest,
                                testId: "context-menu-rovo-chat-custom-prompt",
                                id: "context-menu-rovo-chat-custom-prompt",
                                autoComplete: "off",
                                elemAfterInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $157c507ad23459f7$var$styles.sendIconWrapper,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                        testId: "context-menu-rovo-chat-custom-prompt-submit",
                                        isDisabled: !dirty || !value,
                                        label: formatMessage((0, $jmorr.default).rovoChatCustomPromptSubmitButtonText),
                                        type: "submit",
                                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4fdTR))),
                                        spacing: "compact"
                                    })
                                }),
                                placeholder: formatMessage((0, $jmorr.default).rovoChatCustomPromptPlaceholder),
                                "aria-label": formatMessage((0, $jmorr.default).rovoChatCustomPromptPlaceholder)
                            })
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
                    onSubmit: handlePromptSubmit,
                    children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $157c507ad23459f7$var$styles.formWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)("form", {
                                ...formProps,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                    name: "prompt",
                                    children: ({ fieldProps: { value: value, ...fieldPropsRest }, meta: { dirty: dirty } })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default // this prevents the highlight actions popup from closing when clicking on the input
                                        ), {
                                            onClick: (e)=>e.stopPropagation(),
                                            ...fieldPropsRest,
                                            testId: "context-menu-rovo-chat-custom-prompt",
                                            id: "context-menu-rovo-chat-custom-prompt",
                                            autoComplete: "off",
                                            elemAfterInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $157c507ad23459f7$var$styles.sendIconWrapper,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                                    testId: "context-menu-rovo-chat-custom-prompt-submit",
                                                    isDisabled: !dirty || !value,
                                                    label: formatMessage((0, $jmorr.default).rovoChatCustomPromptSubmitButtonText),
                                                    type: "submit",
                                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4fdTR))),
                                                    spacing: "compact"
                                                })
                                            }),
                                            placeholder: formatMessage((0, $jmorr.default).rovoChatCustomPromptPlaceholder),
                                            "aria-label": formatMessage((0, $jmorr.default).rovoChatCustomPromptPlaceholder)
                                        })
                                })
                            })
                        })
                })
            ]
        });
    };
    const isToolbarAIFCEnabled = (0, $iu6m9.editorExperiment)('platform_editor_toolbar_aifc', true);
    if (product === 'confluence' && isToolbarAIFCEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: formatMessage((0, $jmorr.default).rovoChatOpenChatTooltip),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $9J8UT.AIChatIcon), {
                label: ""
            }),
            onClick: handleClickChat,
            testId: "context-menu-rovo-chat-button",
            children: formatMessage((0, $jmorr.default).rovoChatAskRovoButtonText)
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: formatMessage((0, $jmorr.default).rovoChatOpenChatTooltip),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    appearance: "subtle",
                    iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            xcss: $157c507ad23459f7$var$styles.rovoChatOpenChatIcon,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                                size: "xsmall"
                            })
                        }),
                    onClick: handleClickChat,
                    testId: "context-menu-rovo-chat-button",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        weight: "medium",
                        children: formatMessage((0, $jmorr.default).rovoChatAskRovoButtonText)
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                placement: "bottom-start",
                isOpen: isMoreOptionsPopupOpen,
                onClose: onClose,
                content: renderPopupContent,
                zIndex: 600,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $157c507ad23459f7$var$styles.rovoChatMoreOptionsButtonContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            ...triggerProps,
                            appearance: "subtle",
                            id: "context-menu-rovo-chat-more-options",
                            testId: "context-menu-rovo-chat-more-options",
                            isTooltipDisabled: false,
                            icon: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                    ...props,
                                    label: formatMessage((0, $jmorr.default).rovoChatMoreOptionsTooltip),
                                    size: "small"
                                }),
                            label: formatMessage((0, $jmorr.default).rovoChatMoreOptionsTooltip),
                            onClick: ()=>{
                                setIsMoreOptionsPopupOpen(!isMoreOptionsPopupOpen);
                                sendAnalyticsEvent({
                                    action: 'clicked',
                                    actionSubject: 'button',
                                    actionSubjectId: 'highlightActionsMenuRovoChatMoreOptionsButton',
                                    attributes: {
                                        product: product
                                    }
                                });
                            }
                        })
                    }),
                shouldRenderToParent: (0, $dh538.fg)('should-render-to-parent-should-be-true-ai-mate')
            })
        ]
    });
};
module.exports["RovoChatHighlightActions"] = $157c507ad23459f7$export$1ccbc9113b239d47;

});

parcelRegister("fBMbo", function(module, exports) {

var $dNGPK = parcelRequire("dNGPK");


var $7qH1e = parcelRequire("7qH1e");

function $b5cfafc926496f98$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $dNGPK.Context)._currentRenderer2 && (0, $dNGPK.Context)._currentValue2 || // grab value from default renderer
    (0, $dNGPK.Context)._currentValue || (0, $7qH1e.globalDi);
    return getDependencies(deps, target);
}
module.exports["di"] = $b5cfafc926496f98$export$479d1ccc5f2ab701;

});

parcelRegister("dNGPK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7qH1e = parcelRequire("7qH1e");

const $a0c113d1cdcf525c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getDependencies: (0, $7qH1e.globalDi).getDependencies
});
module.exports["Context"] = $a0c113d1cdcf525c$export$841858b892ce1f4c;

});

parcelRegister("7qH1e", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $b1tX2 = parcelRequire("b1tX2");

const $568c54c2a75aa99b$var$replacementMap = new Map();
const $568c54c2a75aa99b$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($568c54c2a75aa99b$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $b1tX2.findInjectable)($568c54c2a75aa99b$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($568c54c2a75aa99b$var$replacementMap.size) throw new Error(`${(0, $ipvr6.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj));
    },
    clear () {
        $568c54c2a75aa99b$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $ipvr6.diRegistry).get(inj).global) (0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $b1tX2.removeInjectableFromMap)($568c54c2a75aa99b$var$replacementMap, inj));
    }
};
function $568c54c2a75aa99b$export$b887ce09d70113f9(thunk, deps) {
    $568c54c2a75aa99b$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function' && typeof result.finally === 'function') result.finally($568c54c2a75aa99b$export$a775919ebd7dd28a.clear);
        else $568c54c2a75aa99b$export$a775919ebd7dd28a.clear();
    }
}
module.exports["globalDi"] = $568c54c2a75aa99b$export$a775919ebd7dd28a;

});

parcelRegister("ipvr6", function(module, exports) {
const $d672f259068efdcd$export$4203fb010fad9bf0 = new WeakMap();
const $d672f259068efdcd$export$b8b9d90f9e5bd72b = 'react-magnetic-di';
module.exports["diRegistry"] = $d672f259068efdcd$export$4203fb010fad9bf0;
module.exports["PACKAGE_NAME"] = $d672f259068efdcd$export$b8b9d90f9e5bd72b;

});

parcelRegister("b1tX2", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $aqxLC = parcelRequire("aqxLC");

let $80670563c880fcd1$var$hasWarned = false;
function $80670563c880fcd1$export$5b28268982f175ba(message) {
    if (!$80670563c880fcd1$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $80670563c880fcd1$var$hasWarned = true;
    }
}
function $80670563c880fcd1$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $aqxLC.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $80670563c880fcd1$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $80670563c880fcd1$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $80670563c880fcd1$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $80670563c880fcd1$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $aqxLC.stats).track(candidate);
    return candidate;
}
module.exports["addInjectableToMap"] = $80670563c880fcd1$export$7a7134bdd2f9ae2e;
module.exports["removeInjectableFromMap"] = $80670563c880fcd1$export$8057a2244a849b7b;
module.exports["findInjectable"] = $80670563c880fcd1$export$7c436e151c3ee289;

});

parcelRegister("aqxLC", function(module, exports) {
const $79768685dc5c2f62$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $79768685dc5c2f62$export$7804429c45dff272 = {
    state: $79768685dc5c2f62$var$createState(),
    set (injObj) {
        var _injObj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === injObj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(injObj, new Error(`Unused "di" injectable: ${((_injObj$value = injObj.value) == null ? void 0 : _injObj$value.displayName) || injObj.value}.`, {
            cause: injObj.cause
        }));
        // reset to avoid potential memory leaks via stack traces
        injObj.cause = null;
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
    },
    reset () {
        this.state = $79768685dc5c2f62$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};
module.exports["stats"] = $79768685dc5c2f62$export$7804429c45dff272;

});

parcelRegister("9J8UT", function(module, exports) {
/* AIChatIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $8aef4f4f02d5b2fe$var$styles = {
    container: "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1crf _1bsb1crf"
};
const $8aef4f4f02d5b2fe$var$ROVO_SVG_PATH = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L10.7381 2.50115C11.1589 2.7437 11.4193 3.1937 11.4193 3.67848V8.31707C11.4193 8.80377 11.1604 9.25178 10.7385 9.4942L7.71671 11.2376C7.72332 11.219 7.72963 11.2003 7.73565 11.1815C7.79172 11.0077 7.82146 10.8241 7.82146 10.6363V5.99777C7.82146 5.36053 7.4823 4.7729 6.92908 4.45501L6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224Z" fill="#FCA700"/>
		<path d="M4.35709 0.762451L1.33533 2.50585C0.91337 2.74828 0.654541 3.19629 0.654541 3.68299V8.32158C0.654541 8.80636 0.914895 9.25633 1.33561 9.49887L2.05206 9.91223L5.35553 11.8182C5.76872 12.0563 6.27717 12.0606 6.69373 11.8308C6.70128 11.825 6.7093 11.8196 6.71781 11.8147C7.01463 11.6435 7.2317 11.3691 7.33376 11.0521C7.3753 10.9211 7.39725 10.7826 7.39725 10.6409V8.84408L5.64872 7.83569L5.14485 7.54513C4.59174 7.22722 4.25234 6.63946 4.25234 6.00228V1.3637C4.25234 1.17625 4.28199 0.992849 4.33793 0.81927C4.344 0.800208 4.35039 0.781265 4.35709 0.762451Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64872 7.83569L2.05206 9.91223L1.33561 9.49887C0.914895 9.25633 0.654541 8.80636 0.654541 8.32158V3.68299C0.654541 3.19629 0.91337 2.74828 1.33533 2.50585L4.35709 0.762451C4.35039 0.781265 4.344 0.800208 4.33793 0.81927C4.28199 0.992849 4.25234 1.17625 4.25234 1.3637V6.00228C4.25234 6.63946 4.59174 7.22722 5.14485 7.54513L5.64872 7.83569Z" fill="#1868DB"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L6.37094 4.13313Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M10.7381 2.5012L9.9676 2.05664L6.37094 4.13318L6.92907 4.45507C7.48229 4.77296 7.82146 5.36059 7.82146 5.99783V10.6364C7.82146 10.8241 7.79172 11.0078 7.73565 11.1816C7.72963 11.2004 7.72332 11.2191 7.71671 11.2377L10.7385 9.49426C11.1604 9.25184 11.4193 8.80382 11.4193 8.31712V3.67853C11.4193 3.19376 11.1589 2.74376 10.7381 2.5012Z" fill="#AF59E0"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64873 7.83569L2.05206 9.91224L5.35553 11.8182C5.76873 12.0564 6.27718 12.0606 6.69373 11.8308C6.70128 11.825 6.70931 11.8196 6.71782 11.8147C7.01463 11.6436 7.2317 11.3691 7.33377 11.0521C7.37531 10.9211 7.39726 10.7826 7.39726 10.6409V8.84409L5.64873 7.83569Z" fill="#6A9A23"/>
	</svg>`;
const $8aef4f4f02d5b2fe$var$RovoLogoSVG = ({ label: label, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        role: "img",
        "aria-label": label,
        "data-testid": testId,
        dangerouslySetInnerHTML: {
            __html: $8aef4f4f02d5b2fe$var$ROVO_SVG_PATH
        },
        className: (0, $gMc0m.default)([
            $8aef4f4f02d5b2fe$var$styles.container
        ])
    });
const $8aef4f4f02d5b2fe$export$4476d508de061a72 = ({ label: label, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)($8aef4f4f02d5b2fe$var$RovoLogoSVG, {
        label: label,
        testId: testId
    });
module.exports["AIChatIcon"] = $8aef4f4f02d5b2fe$export$4476d508de061a72;

});

parcelRegister("lBFuf", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $hge3g = parcelRequire("hge3g");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");


var $7Y4kW = parcelRequire("7Y4kW");


var $jz7J7 = parcelRequire("jz7J7");

const $204b57ff8caef44c$var$stylesCompiled = {
    pillLineHeight: "_vwz47vkz"
};
const $204b57ff8caef44c$var$styles = {
    button: "_2rko12b0 _11c82smr _189ee4h9 _1dqonqa1 _1h6d1l7x _syazazsu _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _bfhksm61 _irr31dpa _1di6fcek",
    buttonInline: "_18zrv77o",
    queryText: "_1nmz1hna _y3gn1e5h",
    whiteSpacePreWrap: "_o5721jtm"
};
const $204b57ff8caef44c$export$e33faa86e0996d96 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, renderIcon: renderIcon = true, ...props }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ref: ref,
        ...props,
        xcss: $204b57ff8caef44c$var$styles.button,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $204b57ff8caef44c$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.075",
                alignBlock: "baseline",
                children: [
                    renderIcon ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7Y4kW.ChatPillIcon), {}) : null,
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($204b57ff8caef44c$var$styles.queryText, whiteSpacePreWrap && $204b57ff8caef44c$var$styles.whiteSpacePreWrap),
                        children: children
                    })
                ]
            })
        })
    }));
const $204b57ff8caef44c$export$76b47032dcd9063b = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ref: ref,
        ...props,
        xcss: $204b57ff8caef44c$var$styles.button,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $204b57ff8caef44c$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.050",
                xcss: $204b57ff8caef44c$var$styles.buttonInline,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hge3g))), {
                        color: "currentColor",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $204b57ff8caef44c$var$styles.queryText,
                        children: formatMessage((0, $jz7J7.default).browseAgentsPillLabel)
                    })
                ]
            })
        })
    });
});
module.exports["ChatPill"] = $204b57ff8caef44c$export$e33faa86e0996d96;
module.exports["BrowseAgentsPill"] = $204b57ff8caef44c$export$76b47032dcd9063b;

});

parcelRegister("7Y4kW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lDwiy = parcelRequire("lDwiy");

const $eb50cc4a563796fc$export$38f9b635c1c454e7 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
        ...props,
        label: ""
    });
module.exports["ChatPillIcon"] = $eb50cc4a563796fc$export$38f9b635c1c454e7;

});

parcelRegister("jz7J7", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fc6573ead9ef7c8$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $5fc6573ead9ef7c8$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    browseAgentsPillLabel: {
        id: "ai-mate.rovo-agent-components.browse-agents-pill.label",
        defaultMessage: "Browse Agents"
    }
});

});

parcelRegister("i25hX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c5134eb78e10703c$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed'
]);
const $c5134eb78e10703c$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let subIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
		 * Log that this Topic received a published event, regardless of whether it has subscribers or not.
		 * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
		 */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$c5134eb78e10703c$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $c5134eb78e10703c$var$pubSub = $c5134eb78e10703c$var$createPubSub();
const $c5134eb78e10703c$var$usePubSub = ()=>{
    return $c5134eb78e10703c$var$pubSub;
};
const $c5134eb78e10703c$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $c5134eb78e10703c$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $c5134eb78e10703c$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $c5134eb78e10703c$var$usePubSub();
    (0, $42omo.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $c5134eb78e10703c$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $c5134eb78e10703c$var$usePubSub();
    const publishFn = (0, $42omo.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $c5134eb78e10703c$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $c5134eb78e10703c$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $c5134eb78e10703c$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};
module.exports["useSubscribe"] = $c5134eb78e10703c$export$d3d523392640272;
module.exports["useSubscribeAll"] = $c5134eb78e10703c$export$2570c8aa24b6d327;
module.exports["usePublish"] = $c5134eb78e10703c$export$d55c81786220731c;
module.exports["Subscriber"] = $c5134eb78e10703c$export$60959659b2c22881;

});

parcelRegister("kIvLT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6v6KC = parcelRequire("6v6KC");

var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $fYQcF = parcelRequire("fYQcF");


var $TwPkE = parcelRequire("TwPkE");


var $jA9SA = parcelRequire("jA9SA");


var $bQGO7 = parcelRequire("bQGO7");


var $lUZCl = parcelRequire("lUZCl");

const $6e0837af2bd4bfd5$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host.includes(host));
const $6e0837af2bd4bfd5$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $6e0837af2bd4bfd5$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef, mode: mode } = (0, $TwPkE.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $42omo.useCallback)((inputPayload)=>{
        const payload = (0, $6v6KC.isUIAnalyticsEvent)(inputPayload) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $6e0837af2bd4bfd5$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const tagsForAIAnalytics = [
        ...$6e0837af2bd4bfd5$var$DEFAULT_TAGS
    ];
    if ($6e0837af2bd4bfd5$var$isTownSquareEvent()) tagsForAIAnalytics.push('townsquare');
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)({
        // Required configruation
        product: propertiesRef.current.product,
        subproduct: propertiesRef.current.product,
        aiFeatureName: 'aiChat',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        tags: tagsForAIAnalytics,
        customAnalyticsFire: (rawEvent, _createdEvent)=>{
            // Build event and apply context attributes
            const event = createAnalyticsEvent(rawEvent);
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(event.context);
            // Fire
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $bQGO7.ANALYTICS_CHANNEL));
        }
    });
    const getDefaultAttributes = (0, $42omo.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, conversationChannelId: conversationChannelId, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader, mode: mode } = propertiesRef.current;
        return {
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).mode]: mode
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $42omo.useCallback)((payload)=>{
        // Handle tags
        const tags = [
            ...$6e0837af2bd4bfd5$var$DEFAULT_TAGS
        ];
        if ($6e0837af2bd4bfd5$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: source, subjectId: subjectId, proactive: proactive, userGenerated: userGenerated, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, sourceProducts: sourceProducts, sourceProduct: sourceProduct, invokedPlugins: invokedPlugins, responseSources: responseSources, usesJsm: usesJsm, invokedFrom: invokedFrom, conversationChannelId: conversationChannelId, attributes: customAttributes } = payload;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            aiFeatureName: 'aiChat',
            citedProductList: citedProductList,
            citedProduct: citedProduct,
            sourceProducts: sourceProducts,
            sourceProduct: sourceProduct,
            ...customAttributes
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (invokedFrom) attributes.invokedFrom = invokedFrom;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (invokedPlugins) attributes.invokedPlugins = invokedPlugins;
        if (responseSources) attributes.responseSources = responseSources;
        if (usesJsm !== undefined) attributes.usesJsm = usesJsm;
        if (deepResearchEnabled) attributes.deepResearchEnabled = deepResearchEnabled;
        if (webSearchEnabled) attributes.webSearchEnabled = webSearchEnabled;
        if (conversationChannelId) attributes.conversationChannelId = conversationChannelId;
        // Core AI MAU payload
        let eventPayload = {
            eventType: 'track',
            tags: tags,
            source: source,
            actionSubjectId: subjectId,
            attributes: attributes
        };
        const migrationEnabled = (0, $dh538.fg)('rovo_ai_events_tracking_migration');
        if (migrationEnabled) {
            let libAttributes = {
                ...attributes,
                aiFeatureName: 'aiChat',
                proactiveGeneratedAI: proactive ? 1 : 0,
                userGeneratedAI: userGenerated ? 1 : 0
            };
            switch(payload.type){
                case 'initiated':
                    trackAIInteractionInit({
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                case 'viewed':
                    trackAIResultView({
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                case 'error':
                    trackAIResultError({
                        aiErrorMessage: payload.errorMessage
                    }, {
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                case 'dismissed':
                    trackAIInteractionDismiss({
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                case 'actioned':
                    trackAIResultAction(payload.actionResult, {
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                case 'feedback':
                    trackAIFeedbackSubmit(payload.feedbackResult, {
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
            }
        } else {
            switch(payload.type){
                case 'initiated':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiInteraction',
                        action: 'initiated'
                    };
                    break;
                case 'viewed':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiResult',
                        action: 'viewed'
                    };
                    break;
                case 'error':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiResult',
                        action: 'error'
                    };
                    break;
                case 'dismissed':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiInteraction',
                        action: 'dismissed'
                    };
                    break;
                case 'actioned':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiResult',
                        action: 'actioned',
                        attributes: {
                            ...eventPayload.attributes,
                            aiResultAction: payload.actionResult
                        }
                    };
                    break;
                case 'feedback':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiFeedback',
                        action: 'submitted',
                        attributes: {
                            ...eventPayload.attributes,
                            aiFeedbackResult: payload.feedbackResult
                        }
                    };
                    break;
            }
            // Build event and apply context attributes
            const event = createAnalyticsEvent(eventPayload);
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(event.context);
            // Fire
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $bQGO7.ANALYTICS_CHANNEL));
        }
    // Handle specific AI MAU events
    }, [
        createAnalyticsEvent,
        getDefaultAttributes,
        trackAIInteractionInit,
        trackAIResultView,
        trackAIResultError,
        trackAIInteractionDismiss,
        trackAIResultAction,
        trackAIFeedbackSubmit
    ]);
    const sendAnalyticsEvent = (0, $42omo.useCallback)((payload, options)=>{
        const extraTags = options?.removeDefaultTags ? [] : $6e0837af2bd4bfd5$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...payload.tags || [],
            ...maybeAtlasOperationalTags(payload)
        ]));
        const defaultAttributes = getDefaultAttributes();
        if ((0, $6v6KC.isUIAnalyticsEvent)(payload)) {
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(payload.context);
            payload.update({
                ...payload.payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $bQGO7.ANALYTICS_CHANNEL));
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.attributes
                }
            });
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(event.context);
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $bQGO7.ANALYTICS_CHANNEL));
        }
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        mode: mode
    };
};
module.exports["useAnalytics"] = $6e0837af2bd4bfd5$export$e955abb82869dc84;

});

parcelRegister("fYQcF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dWJ5i = parcelRequire("dWJ5i");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $oWrxz = parcelRequire("oWrxz");


var $ea2ui = parcelRequire("ea2ui");


var $j4EkW = parcelRequire("j4EkW");

const $a22fd04a8888d493$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $42omo.useContext)((0, $ifW2H.AIEventsInstrumentationContext));
    if (customConfig) context = {
        config: {
            ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $j4EkW.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const aiEventAttributesOverride = (0, $42omo.useRef)({});
    const validateAndUpdateAISession = (0, $42omo.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $dWJ5i.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $ea2ui.AISessionState).unset,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).viewed, (0, $ea2ui.AISessionState).error, (0, $ea2ui.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $ea2ui.AISessionState).initiated,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).submitted, (0, $ea2ui.AISessionState).actioned, (0, $ea2ui.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $42omo.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $3pfAb.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const getCurrentAttributes = (0, $42omo.useCallback)(()=>{
        const { config: config } = context;
        const aiEventAttributesOverrideSnapshot = aiEventAttributesOverride.current;
        const aiExperienceName = aiEventAttributesOverrideSnapshot.aiExperienceName || config.aiExperienceName;
        const aiFeatureName = aiEventAttributesOverrideSnapshot.aiFeatureName || config.aiFeatureName;
        const proactiveGeneratedAI = aiEventAttributesOverrideSnapshot.proactiveGeneratedAI || config.proactiveGeneratedAI;
        const userGeneratedAI = aiEventAttributesOverrideSnapshot.userGeneratedAI || config.userGeneratedAI;
        const isAIFeature = aiEventAttributesOverrideSnapshot.isAIFeature || config.isAIFeature;
        return {
            aiExperienceName: aiExperienceName,
            aiFeatureName: aiFeatureName,
            proactiveGeneratedAI: proactiveGeneratedAI,
            userGeneratedAI: userGeneratedAI,
            isAIFeature: isAIFeature
        };
    }, [
        context
    ]);
    const createAndMergeEventPayload = (0, $42omo.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const { aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature } = getCurrentAttributes();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes
            }
        };
        return (0, $dWJ5i.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $oWrxz.getTagsWithPlatfromTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        getCurrentAttributes
    ]);
    const trackAIInteractionInit = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $42omo.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $42omo.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $42omo.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    return {
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        updateAIAttributes: updateAIAttributes
    };
};
module.exports["useAIEventsInstrumentation"] = $a22fd04a8888d493$export$ddf49ad062368ad2;

});

parcelRegister("oWrxz", function(module, exports) {
const $b35ed956ecf5e00e$export$8dd34cb3211cf994 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatfromTag"] = $b35ed956ecf5e00e$export$8dd34cb3211cf994;

});

parcelRegister("TwPkE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");

const $19e5e9ef880dfbce$var$initialState = {
    conversationChannelId: '',
    experienceId: '',
    product: '',
    productHeader: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: '',
    mode: undefined
};
const $19e5e9ef880dfbce$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $42omo.createContext)({
    propertiesRef: {
        current: {
            ...$19e5e9ef880dfbce$var$initialState
        }
    },
    mode: undefined,
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $19e5e9ef880dfbce$export$5ae3634fdb64882c = /*#__PURE__*/ (0, $42omo.createContext)({
    sharedFeaturesInstrumentationId: undefined,
    isInSmartCreateFlow: undefined
});
const $19e5e9ef880dfbce$export$1aefd27d2ed3c1c9 = ({ children: children, mode: mode })=>{
    const propertiesRef = (0, $42omo.useRef)({
        ...$19e5e9ef880dfbce$var$initialState
    });
    const setAnalyticsPropertiesWithoutRerender = (0, $42omo.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender,
        mode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$var$AnalyticsPropertiesContext.Provider, {
        value: value,
        children: children
    });
};
const $19e5e9ef880dfbce$export$a00cd3c213413389 = ({ source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow })=>{
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $42omo.useContext)($19e5e9ef880dfbce$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const data = (0, $42omo.useMemo)(()=>({
            source: source,
            attributes: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            }
        }), [
        source,
        sharedFeaturesInstrumentationId,
        parentSharedFeaturesInstrumentationId,
        isInSmartCreateFlow
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: data,
        children: /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$export$5ae3634fdb64882c.Provider, {
            value: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$export$1aefd27d2ed3c1c9, {
                mode: mode,
                children: children
            })
        })
    });
};
const $19e5e9ef880dfbce$export$ab8aa3dfd687f012 = ()=>{
    return (0, $42omo.useContext)($19e5e9ef880dfbce$var$AnalyticsPropertiesContext);
};
module.exports["SharedFeaturesInstrumentationIdContext"] = $19e5e9ef880dfbce$export$5ae3634fdb64882c;
module.exports["AnalyticsContextWithSourceAndProperties"] = $19e5e9ef880dfbce$export$a00cd3c213413389;
module.exports["useAnalyticsPropertiesContext"] = $19e5e9ef880dfbce$export$ab8aa3dfd687f012;

});

parcelRegister("jA9SA", function(module, exports) {
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $eb66f40a0f078927$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    conversationChannelId: 'conversationChannelId',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    mode: 'mode',
    product: 'product',
    productHeader: 'productHeader',
    singleInstrumentationID: 'singleInstrumentationID',
    sharedFeaturesInstrumentationId: 'sharedFeaturesInstrumentationId'
};
module.exports["AI_MATE_ATTRIBUTES"] = $eb66f40a0f078927$export$8cffc8b2c93affd4;

});

parcelRegister("bQGO7", function(module, exports) {

var $3pfAb = parcelRequire("3pfAb");

const $7940b633dc028a3e$export$85183a312807388d = (0, $3pfAb.FabricChannel).aiMate;
var $7940b633dc028a3e$export$406073150b1a408 = /*#__PURE__*/ function(AUTOSUGGEST_SOURCE) {
    AUTOSUGGEST_SOURCE["ROVO_CHAT"] = "rovo-chat";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC"] = "confluence-aifc";
    return AUTOSUGGEST_SOURCE;
}({});
module.exports["ANALYTICS_CHANNEL"] = $7940b633dc028a3e$export$85183a312807388d;
module.exports["AUTOSUGGEST_SOURCE"] = $7940b633dc028a3e$export$406073150b1a408;

});

parcelRegister("lUZCl", function(module, exports) {

var $ffCOo = parcelRequire("ffCOo");


var $iN5LM = parcelRequire("iN5LM");

const $ee6ebd3561b1c806$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return (0, $iN5LM.ALLOWED_AI_MATE_SOURCES).includes(x.source);
};
const $ee6ebd3561b1c806$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let contextsThatHaveAttributes = context.filter((x)=>$ee6ebd3561b1c806$var$isSourceAndAttributes(x) || x[0, $ffCOo.AI_MATE_CONTEXT]);
    return contextsThatHaveAttributes.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $ffCOo.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getAttributesFromContexts"] = $ee6ebd3561b1c806$export$d97c97ed77ff09e8;

});

parcelRegister("iN5LM", function(module, exports) {
const $79e4722581e5fb43$export$e31e24b63b7085fd = [
    'AIMate',
    'smart-create',
    'CSMAI',
    'CSMAIEmbed',
    'rovoServiceAgent'
];
module.exports["ALLOWED_AI_MATE_SOURCES"] = $79e4722581e5fb43$export$e31e24b63b7085fd;

});

parcelRegister("ygGKm", function(module, exports) {
const $604298656c254432$export$f00236a854eaa848 = (content, suggestionContent)=>{
    const updatedContent = Array.isArray(content.content) ? content.content : [
        content.content
    ];
    // Append the new paragraph node
    updatedContent.push({
        type: 'paragraph',
        content: [
            {
                type: 'text',
                text: suggestionContent
            }
        ]
    });
    // Return the updated DocNode
    return {
        ...content,
        content: updatedContent
    };
};
module.exports["appendADFContent"] = $604298656c254432$export$f00236a854eaa848;

});

parcelRegister("gncRT", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $0d32633bd323405d$var$store = (0, $1P1Tu.createStore)({
    name: 'RovoChatHighlightActionsStore',
    initialState: {
        isMoreOptionsPopupOpen: false
    },
    actions: {
        setIsMoreOptionsPopupOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isMoreOptionsPopupOpen: isOpen
                });
            }
    }
});
const $0d32633bd323405d$export$6c9cf98a64763bb1 = (0, $9zUhf.createHook)($0d32633bd323405d$var$store);
const $0d32633bd323405d$export$f1e33ed2d48967b4 = (0, $9zUhf.createActionsHook)($0d32633bd323405d$var$store);
module.exports["useRovoChatHighlightActions"] = $0d32633bd323405d$export$6c9cf98a64763bb1;
module.exports["useRovoChatHighlightActionsActions"] = $0d32633bd323405d$export$f1e33ed2d48967b4;

});

parcelRegister("gjr93", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $ygGKm = parcelRequire("ygGKm");


var $iUl0E = parcelRequire("iUl0E");

const $574c86f95ed7997c$var$state = (0, $1P1Tu.createStore)({
    initialState: {
        highlightActionsEditorPlaceholder: null
    },
    actions: {
        setHighlightActionsEditorPlaceholder: (highlightActionsEditorPlaceholder)=>({ setState: setState })=>{
                setState({
                    highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder
                });
            }
    }
});
const $574c86f95ed7997c$export$e638cf26ae51308d = (0, $9zUhf.createHook)($574c86f95ed7997c$var$state);
const $574c86f95ed7997c$var$getHighlightActionPlaceholderData = (prompt, placeholderText)=>{
    const promptContent = (0, $ygGKm.appendADFContent)(prompt, placeholderText);
    return promptContent;
};
const $574c86f95ed7997c$export$21b2d5ca0689f678 = ()=>{
    const [{ highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder }, { setHighlightActionsEditorPlaceholder: setHighlightActionsEditorPlaceholder }] = $574c86f95ed7997c$export$e638cf26ae51308d();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const insertHighlightActionsEditorPlaceholder = (0, $42omo.useCallback)((prompt)=>{
        const highlightActionsPlaceholderPrompt = formatMessage((0, $iUl0E.default).highlightActionsPlaceholderPrompt);
        const placeholderData = $574c86f95ed7997c$var$getHighlightActionPlaceholderData(prompt, highlightActionsPlaceholderPrompt);
        setHighlightActionsEditorPlaceholder(placeholderData);
    }, [
        setHighlightActionsEditorPlaceholder,
        formatMessage
    ]);
    const clearHighlightActionsEditorPlaceholder = (0, $42omo.useCallback)(()=>{
        setHighlightActionsEditorPlaceholder(null);
    }, [
        setHighlightActionsEditorPlaceholder
    ]);
    return {
        highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
        insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
        clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder
    };
};
module.exports["useHighlightActionsEditorPlaceholder"] = $574c86f95ed7997c$export$21b2d5ca0689f678;

});

parcelRegister("iUl0E", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fd64f51ce2261f9$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $2fd64f51ce2261f9$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    highlightActionsPlaceholderPrompt: {
        id: "highlight-actions.rovo-chat.placeholder-prompt",
        defaultMessage: "Ask a question about this."
    }
});

});

parcelRegister("jmorr", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ee4456065df4341$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $1ee4456065df4341$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    rovoChatAskInChatButtonText: {
        id: "highlight-actions.rovo-chat.ask-in-chat-button-text",
        defaultMessage: "Ask in Chat"
    },
    rovoChatAskRovoButtonText: {
        id: "highlight-actions.rovo-chat.ask-rovo-button-text",
        defaultMessage: "Ask Rovo"
    },
    rovoChatOpenChatTooltip: {
        id: "highlight-actions.rovo-chat-open-chat.tooltip",
        defaultMessage: "Open Chat"
    },
    rovoChatMoreOptionsTooltip: {
        id: "highlight-actions.rovo-chat-more-options.tooltip",
        defaultMessage: "Chat recommendations"
    },
    rovoChatSummarizeOptionText: {
        id: "highlight-actions.rovo-chat-summarize-option.text",
        defaultMessage: "Summarize"
    },
    rovoChatExplainOptionText: {
        id: "highlight-actions.rovo-chat-explain-option.text",
        defaultMessage: "Explain"
    },
    rovoChatFindResourcesOptionText: {
        id: "highlight-actions.rovo-chat-find-resources-option.text",
        defaultMessage: "Find resources"
    },
    rovoChatGiveFeedbackOptionText: {
        id: "highlight-actions.rovo-chat-give-feedback-option.text",
        defaultMessage: "Give feedback"
    },
    rovoChatGiveExamplesOptionText: {
        id: "highlight-actions.rovo-chat-give-examples-option.text",
        defaultMessage: "Give examples"
    },
    rovoChatSummarizePrompt: {
        id: "highlight-actions.rovo-chat-summarize-prompt",
        defaultMessage: "Highlight the key points from this. Focus on essential information and exclude unnecessary details. Provide a concise overview in a single paragraph."
    },
    rovoChatExplainPrompt: {
        id: "highlight-actions.rovo-chat-explain-prompt",
        defaultMessage: "Explain this by rephrasing it and adding additional detail, but use very simple language, short sentences, and provide examples or definitions to any technical terminology used in the original phrasing."
    },
    rovoChatFindResourcesPrompt: {
        id: "highlight-actions.rovo-chat-find-resources-prompt",
        defaultMessage: "Find resources within organizational knowledge only that supports the statements made."
    },
    rovoChatGiveFeedbackPrompt: {
        id: "highlight-actions.rovo-chat-give-feedback-prompt",
        defaultMessage: "Give feedback by reviewing the phrasing of this. Provide commentary on word choice, grammar, punctuation. Be positive and enthusiastic but always provide at least one thing to improve or change."
    },
    rovoChatGiveExamplesPrompt: {
        id: "highlight-actions.rovo-chat-give-examples-prompt",
        defaultMessage: "Give examples of this from organizational resources or public knowledge. If there are no resources to provide attempt to give a metaphorical example that may help someone understand this more."
    },
    rovoChatCustomPromptPlaceholder: {
        id: "highlight-actions.rovo-chat-custom-prompt.placeholder",
        defaultMessage: "Ask AI about this"
    },
    rovoChatCustomPromptSubmitButtonText: {
        id: "highlight-actions.rovo-chat-custom-prompt-submit-button.text",
        defaultMessage: "Send"
    }
});

});

parcelRegister("5qqdA", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $76e32f06e038930c$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $76e32f06e038930c$export$64aee74ba59709e5 = 439; // px
const $76e32f06e038930c$export$1c07393c5bb1bc27 = 439; // px
const $76e32f06e038930c$export$aa3478deee7adbeb = 350; // px
const $76e32f06e038930c$export$21e515a86cd1733b = 'Chat';
const $76e32f06e038930c$export$e942bf04e23ff966 = 'Rovo';
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $76e32f06e038930c$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $76e32f06e038930c$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $76e32f06e038930c$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $76e32f06e038930c$export$e942bf04e23ff966;

});

parcelRegister("kxhju", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $gTyTP = parcelRequire("gTyTP");


var $1gjU5 = parcelRequire("1gjU5");


var $fjiOd = parcelRequire("fjiOd");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $42omo.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch, isLiveDocsEnabled: isLiveDocsEnabled } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $fjiOd.WebItemLocationQuery),
            variables: variables,
            fetchPolicy: fetchPolicy
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            if (isLiveDocsEnabled) webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    let t0;
    if ($[0] !== isLivePagesFeatureEnabled || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, {
            ...props,
            isLiveDocsEnabled: isLivePagesFeatureEnabled
        });
        $[0] = isLivePagesFeatureEnabled;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, {
        ...props,
        isLiveDocsEnabled: isLivePagesFeatureEnabled
    });
};
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("1gjU5", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw140y _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw140y _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ])
    });
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("bSdpv"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("bSdpv", function(module, exports) {

let $8a4f23dbcd20a889$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a4f23dbcd20a889$var$load("2PePB"),
    $8a4f23dbcd20a889$var$load("1W4KB"),
    $8a4f23dbcd20a889$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("2A8CJ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dae2c2bf6a5fe745$export$6d9b0a4fb48787a7 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    lastModificationDate: null
});
$dae2c2bf6a5fe745$export$6d9b0a4fb48787a7.displayName = 'ContentBodyContext';
module.exports["ContentBodyContext"] = $dae2c2bf6a5fe745$export$6d9b0a4fb48787a7;

});

parcelRegister("2Jxlo", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8c38d1311bce6ee3$export$15b21f0ead27e4bf = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qNGEh",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("7v7EZ"))).ReadingAidsPopup
});
module.exports["ReadingAidsPopup"] = $8c38d1311bce6ee3$export$15b21f0ead27e4bf;

});

parcelRegister("7v7EZ", function(module, exports) {

let $57615eca3a986a75$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $57615eca3a986a75$var$load("2YffH"),
    $57615eca3a986a75$var$load("1FvvC"),
    $57615eca3a986a75$var$load("6mHrv"),
    $57615eca3a986a75$var$load("9zkjw"),
    $57615eca3a986a75$var$load("88Shx"),
    $57615eca3a986a75$var$load("1QdXB"),
    $57615eca3a986a75$var$load("8hSeL"),
    $57615eca3a986a75$var$load("7RXky"),
    $57615eca3a986a75$var$load("lVO3w"),
    $57615eca3a986a75$var$load("hyzoX"),
    $57615eca3a986a75$var$load("h9Ed7"),
    $57615eca3a986a75$var$load("9A0ig"),
    $57615eca3a986a75$var$load("dVAT5"),
    $57615eca3a986a75$var$load("fIFgO"),
    $57615eca3a986a75$var$load("86sUJ"),
    $57615eca3a986a75$var$load("8VzWv"),
    $57615eca3a986a75$var$load("8YSo7"),
    $57615eca3a986a75$var$load("gryT8"),
    $57615eca3a986a75$var$load("1d7Ag"),
    $57615eca3a986a75$var$load("9XYQ9"),
    $57615eca3a986a75$var$load("kiGNy"),
    $57615eca3a986a75$var$load("St9Nk"),
    $57615eca3a986a75$var$load("8JZKd"),
    $57615eca3a986a75$var$load("7jH9e"),
    $57615eca3a986a75$var$load("6FuHS"),
    $57615eca3a986a75$var$load("eyaRC"),
    $57615eca3a986a75$var$load("drv5I"),
    $57615eca3a986a75$var$load("g9CVe"),
    $57615eca3a986a75$var$load("5EQhG"),
    $57615eca3a986a75$var$load("36QeB"),
    $57615eca3a986a75$var$load("8fXIr"),
    $57615eca3a986a75$var$load("dVkhd"),
    $57615eca3a986a75$var$load("hv4mn"),
    $57615eca3a986a75$var$load("hhss7"),
    $57615eca3a986a75$var$load("7jSfd"),
    $57615eca3a986a75$var$load("4HZlX"),
    $57615eca3a986a75$var$load("kDqHr"),
    $57615eca3a986a75$var$load("6wr18"),
    $57615eca3a986a75$var$load("kjZZD"),
    $57615eca3a986a75$var$load("ht5OT"),
    $57615eca3a986a75$var$load("sj9Xz"),
    $57615eca3a986a75$var$load("eHDb1"),
    $57615eca3a986a75$var$load("2zUEf"),
    $57615eca3a986a75$var$load("Wowvf"),
    $57615eca3a986a75$var$load("37ldp"),
    $57615eca3a986a75$var$load("dTsOE"),
    $57615eca3a986a75$var$load("8FbYE"),
    $57615eca3a986a75$var$load("dUevD"),
    $57615eca3a986a75$var$load("ffEVr"),
    $57615eca3a986a75$var$load("f1NVy"),
    $57615eca3a986a75$var$load("8Gekp"),
    $57615eca3a986a75$var$load("7e13v"),
    $57615eca3a986a75$var$load("aqr2D"),
    $57615eca3a986a75$var$load("7EorR"),
    $57615eca3a986a75$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});

parcelRegister("a3Fla", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $371bfa624b8f4825$export$d9088a53cb7c38b4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "W_5EK",
    name: "ReadingAidsChangeboardingModal",
    loader: async ()=>(await (parcelRequire("d7fiu"))).ReadingAidsChangeboardingModal
});
module.exports["ReadingAidsChangeboardingModal"] = $371bfa624b8f4825$export$d9088a53cb7c38b4;

});

parcelRegister("d7fiu", function(module, exports) {

let $98c7cb83b0c6308d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $98c7cb83b0c6308d$var$load("6wr18"),
    $98c7cb83b0c6308d$var$load("ffEVr"),
    $98c7cb83b0c6308d$var$load("kwiXK")
]).then(()=>parcelRequire('iPt4B'));

});

parcelRegister("9ikgN", function(module, exports) {
$parcel$export(module.exports, "READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID", () => (parcelRequire("cR1lV")).READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID);

var $jmjWc = parcelRequire("jmjWc");


var $cR1lV = parcelRequire("cR1lV");


const $ade6da7539ba5902$export$1942ca99b3c33b66 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "B2kdC",
    name: "ReadingAidsChangeboardingSpotlight",
    loader: async ()=>(await Promise.resolve((parcelRequire("cR1lV")))).ReadingAidsChangeboardingSpotlight
});
module.exports["ReadingAidsChangeboardingSpotlight"] = $ade6da7539ba5902$export$1942ca99b3c33b66;

});

parcelRegister("cR1lV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $lsxnT = parcelRequire("lsxnT");

const $83df18abc582ef5a$export$a21884ebed08a664 = 'reading-aids-spotlight';
const $83df18abc582ef5a$var$i18n = (0, $cgtv4.defineMessages)({
    changeboardingSpotlightGotItButton: {
        id: "contextual-reading-aids.changeboarding-spotlight.got-it-button",
        defaultMessage: "Got it"
    },
    changeboardingSpotlightText: {
        id: "contextual-reading-aids.changeboarding-spotlight.text",
        defaultMessage: "Remember, this feature works best when you select specific terms, acronyms, or internal project/team names."
    }
});
const $83df18abc582ef5a$export$1942ca99b3c33b66 = ({ contentId: contentId, onGotItClick: onGotItClick })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleOnClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'readingAidsSpotlightChangeboarding',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'readingAidsSpotlightGotItButton',
                attributes: {
                    contentId: contentId
                }
            }
        });
        onGotItClick();
    };
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
        actions: [
            {
                text: intl.formatMessage($83df18abc582ef5a$var$i18n.changeboardingSpotlightGotItButton),
                onClick: handleOnClick
            }
        ],
        target: $83df18abc582ef5a$export$a21884ebed08a664,
        targetRadius: 4
    }, intl.formatMessage($83df18abc582ef5a$var$i18n.changeboardingSpotlightText));
};
module.exports["READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID"] = $83df18abc582ef5a$export$a21884ebed08a664;
module.exports["ReadingAidsChangeboardingSpotlight"] = $83df18abc582ef5a$export$1942ca99b3c33b66;

});

parcelRegister("7rLBD", function(module, exports) {

var $7Zbm6 = parcelRequire("7Zbm6");

const $40851a06f2d6c64a$export$cd08f5c9e05f94dd = (contentId, cloudID, contentType)=>{
    if (!contentType) return '';
    return `ari:cloud:confluence:${cloudID}:${contentType}/${contentId}`;
};
const $40851a06f2d6c64a$export$8530183f316e301c = (activationId, cloudId)=>`ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
const $40851a06f2d6c64a$export$b381579634332aed = (curatedDefinition)=>{
    const curatedDefinitionReference = curatedDefinition.confluenceEntity;
    return {
        nlpResult: curatedDefinition.definition,
        uniqueSources: curatedDefinitionReference ? [
            {
                id: curatedDefinitionReference?.id || '',
                title: curatedDefinitionReference?.title || '',
                url: curatedDefinition.referenceUrl || '',
                type: curatedDefinitionReference?.type || '',
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: curatedDefinitionReference?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: curatedDefinition.editor?.name ? {
            name: curatedDefinition.editor.name || '',
            id: curatedDefinition.editor.accountId || ''
        } : undefined,
        disclaimer: null,
        errorState: null,
        format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN
    };
};
const $40851a06f2d6c64a$export$479750843803fc13 = 5;
const $40851a06f2d6c64a$export$f600f3124ea5916b = (nodes)=>{
    const categories = new Map();
    try {
        nodes.forEach((node)=>{
            const curCategoryCount = categories.get(node.category);
            if (!!curCategoryCount) categories.set(node.category, curCategoryCount + 1);
            else categories.set(node.category, 1);
        });
    } catch  {
        return undefined;
    }
    return Object.fromEntries(categories);
};
module.exports["generatePageARI"] = $40851a06f2d6c64a$export$cd08f5c9e05f94dd;
module.exports["generateWorkspaceId"] = $40851a06f2d6c64a$export$8530183f316e301c;
module.exports["READING_AIDS_MAX_WORD_COUNT"] = $40851a06f2d6c64a$export$479750843803fc13;
module.exports["getHighlightCategories"] = $40851a06f2d6c64a$export$f600f3124ea5916b;

});

parcelRegister("7Zbm6", function(module, exports) {
var $313b937e83fff73c$export$e20550b618a28239 = /*#__PURE__*/ function(NLPSearchResultFormat) {
    NLPSearchResultFormat["PLAINTEXT"] = "PLAIN_TEXT";
    NLPSearchResultFormat["ADF"] = "ADF";
    NLPSearchResultFormat["JSON"] = "JSON";
    NLPSearchResultFormat["MARKDOWN"] = "MARKDOWN";
    return NLPSearchResultFormat;
}({});
var $313b937e83fff73c$export$eae917983a0398aa = /*#__PURE__*/ function(NLPSearchJSONResultFormat) {
    NLPSearchJSONResultFormat["WHO"] = "who";
    NLPSearchJSONResultFormat["WORK"] = "work";
    NLPSearchJSONResultFormat["TEAM"] = "team";
    NLPSearchJSONResultFormat["PERSON"] = "person";
    NLPSearchJSONResultFormat["AGENT"] = "agent";
    return NLPSearchJSONResultFormat;
}({});
var $313b937e83fff73c$export$49d1ac864ca8db3a = /*#__PURE__*/ function(NLPSearchDisclaimerType) {
    NLPSearchDisclaimerType["WhoDisclaimer"] = "WHO_QUESTION";
    return NLPSearchDisclaimerType;
}({});
var $313b937e83fff73c$export$9405d23bea8d0d8b = /*#__PURE__*/ function(NLPSearchErrorState) {
    NLPSearchErrorState["NoAnswer"] = "NO_ANSWER";
    NLPSearchErrorState["NoAnswerKeywords"] = "NO_ANSWER_KEYWORDS";
    NLPSearchErrorState["NoAnswerSearchResults"] = "NO_ANSWER_SEARCH_RESULTS";
    NLPSearchErrorState["NoAnswerHydration"] = "NO_ANSWER_HYDRATION";
    NLPSearchErrorState["NoAnswerRelevantContent"] = "NO_ANSWER_RELEVANT_CONTENT";
    NLPSearchErrorState["NoAnswerOpenAIResponseError"] = "NO_ANSWER_OPEN_AI_RESPONSE_ERR";
    NLPSearchErrorState["NoAnswerOpenAIRateLimitUserAbuse"] = "OPENAI_RATE_LIMIT_USER_ABUSE";
    NLPSearchErrorState["NoAnswerWhoQuestion"] = "NO_ANSWER_WHO_QUESTION";
    NLPSearchErrorState["SubjectiveQuery"] = "SUBJECTIVE_QUERY";
    NLPSearchErrorState["AcceptableUseViolation"] = "ACCEPTABLE_USE_VIOLATIONS";
    NLPSearchErrorState["AIDisabled"] = "AI_DISABLED";
    // These values are not returned from the BE and are only used by the FE
    NLPSearchErrorState["Default"] = "DEFAULT";
    // Value at component initialization
    NLPSearchErrorState["NetworkError"] = "NETWORK_ERROR";
    // Value if the network call fails
    NLPSearchErrorState["TimeoutError"] = "TIMEOUT_ERROR";
    // Value if the network call times out
    NLPSearchErrorState["HIPAAError"] = "HIPAA_ERROR";
    return NLPSearchErrorState;
}({});
var $313b937e83fff73c$export$6b1112c70cca65d3 = /*#__PURE__*/ function(NLPSearchErrorCodes) {
    NLPSearchErrorCodes["HIPAA_ENABLED_ERROR"] = "convoai.rest.browsing.product.has.hipaa.enabled";
    return NLPSearchErrorCodes;
}({});
var $313b937e83fff73c$export$7c6c2f9c68de2e45 = /*#__PURE__*/ function(NLPSearchResultContainerDataTypeContainerType) {
    NLPSearchResultContainerDataTypeContainerType["ConfluenceSpace"] = "confluenceSpace";
    NLPSearchResultContainerDataTypeContainerType["JiraProject"] = "jiraProject";
    return NLPSearchResultContainerDataTypeContainerType;
}({});
var $313b937e83fff73c$export$12b805d25b464b8d = /*#__PURE__*/ function(NLPSearchCustomDefinitionType) {
    NLPSearchCustomDefinitionType["CURATED"] = "CURATED";
    NLPSearchCustomDefinitionType["PRECOMPUTED"] = "PRECOMPUTED";
    return NLPSearchCustomDefinitionType;
}({});
var $313b937e83fff73c$export$130eddddf4243f3f = /*#__PURE__*/ function(AIAnswerQueryStreamType) {
    AIAnswerQueryStreamType["AnswerType"] = "ANSWER_TYPE";
    AIAnswerQueryStreamType["GenerationType"] = "ANSWER_GENERATION_TYPE";
    AIAnswerQueryStreamType["AnswerPart"] = "ANSWER_PART";
    AIAnswerQueryStreamType["FinalResponse"] = "FINAL_RESPONSE";
    AIAnswerQueryStreamType["Trace"] = "TRACE";
    AIAnswerQueryStreamType["ErrorStateQuerySuggestions"] = "ERROR_STATE_QUERY_SUGGESTIONS";
    AIAnswerQueryStreamType["DynamicLayoutSubAgentMessage"] = "DL_SUB_AGENT";
    return AIAnswerQueryStreamType;
}({});
var $313b937e83fff73c$export$e7b798431c659b80 = /*#__PURE__*/ function(AIAnswerAPIType) {
    AIAnswerAPIType["STREAM"] = "STREAM";
    return AIAnswerAPIType;
}({});
var $313b937e83fff73c$export$c13e418beaf43d1c = /*#__PURE__*/ function(DefinitionAnswerState) {
    DefinitionAnswerState["LOADING"] = "loading";
    DefinitionAnswerState["ANSWERED"] = "answered";
    DefinitionAnswerState["ERRORED"] = "errored";
    return DefinitionAnswerState;
}({});
module.exports["NLPSearchResultFormat"] = $313b937e83fff73c$export$e20550b618a28239;
module.exports["NLPSearchJSONResultFormat"] = $313b937e83fff73c$export$eae917983a0398aa;
module.exports["NLPSearchErrorState"] = $313b937e83fff73c$export$9405d23bea8d0d8b;
module.exports["NLPSearchErrorCodes"] = $313b937e83fff73c$export$6b1112c70cca65d3;
module.exports["NLPSearchResultContainerDataTypeContainerType"] = $313b937e83fff73c$export$7c6c2f9c68de2e45;
module.exports["NLPSearchCustomDefinitionType"] = $313b937e83fff73c$export$12b805d25b464b8d;
module.exports["AIAnswerQueryStreamType"] = $313b937e83fff73c$export$130eddddf4243f3f;
module.exports["AIAnswerAPIType"] = $313b937e83fff73c$export$e7b798431c659b80;

});

parcelRegister("bjVRl", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $1P1Tu.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $9zUhf.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $9zUhf.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("9oxdN", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");

var $xQxzY = parcelRequire("xQxzY");


var $7W8i8 = parcelRequire("7W8i8");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $iyPd9 = parcelRequire("iyPd9");

const $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery = (0, $eSUdr.default)`query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey featureKey}}`;
const $112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation = (0, $eSUdr.default)`mutation useFeatureDiscoveryMarkFeatureDiscoveredMutation($featureKey:String!$pluginKey:String!){markFeatureDiscovered(featureKey:$featureKey pluginKey:$pluginKey){pluginKey featureKey}}`;
const $112f5732a615f62f$var$logger = (0, $7W8i8.getLogger)('useFeatureDiscovery');
const $112f5732a615f62f$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $112f5732a615f62f$var$updateCache = (cache, { data: data })=>{
    const newMarkedFeature = data?.markFeatureDiscovered;
    const cachedFeatureData = cache.readQuery({
        query: (0, $iyPd9.FeatureDiscoveryQuery)
    });
    if (newMarkedFeature && cachedFeatureData?.featureDiscovery) cache.writeQuery({
        query: (0, $iyPd9.FeatureDiscoveryQuery),
        data: {
            featureDiscovery: cachedFeatureData.featureDiscovery.concat(newMarkedFeature)
        }
    });
};
const $112f5732a615f62f$var$getLocalOverrideValue = (featureKey)=>{
    try {
        if ((0, $17wUi.confluenceSessionStorageInstance).getItem(`${(0, $1UApO.keys).FEATURE_DISCOVERY_OVERRIDE_PREFIX}${featureKey}`)) return true;
    } catch (e) {
        $112f5732a615f62f$var$logger.error(e);
    }
    return false;
};
const $112f5732a615f62f$var$noop = ()=>{};
const $112f5732a615f62f$export$6de1a7573792d1a9 = (featureKey, skip)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const skipFeatureDiscoveryQuery = !isLoggedIn || skip;
    const { data: data, loading: queryLoading, error: queryError } = (0, $xQxzY.useQuery)($112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery, {
        skip: skipFeatureDiscoveryQuery
    });
    const [markFeatureDiscovered, { loading: mutationLoading, error: mutationError }] = (0, $1KmJq.useMutation)($112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation, {
        variables: {
            featureKey: featureKey,
            pluginKey: $112f5732a615f62f$export$2dd355223baa0569
        },
        update: $112f5732a615f62f$var$updateCache
    });
    const loading = queryLoading || mutationLoading;
    const error = queryError || mutationError;
    const showFeature = !loading && !error && !data?.featureDiscovery?.some((feature)=>feature?.pluginKey === $112f5732a615f62f$export$2dd355223baa0569 && feature?.featureKey === featureKey);
    const handleStop = (0, $42omo.useCallback)(()=>{
        if (showFeature) // error is handled in the useMutation result
        markFeatureDiscovered().catch(()=>{});
    }, [
        showFeature,
        markFeatureDiscovered
    ]);
    if (skipFeatureDiscoveryQuery) return [
        false,
        $112f5732a615f62f$var$noop,
        undefined
    ];
    // this is for dev/testing, since we cant easily remove data from the featureDiscovery array
    const forceShowFeature = showFeature || $112f5732a615f62f$var$getLocalOverrideValue(featureKey);
    return [
        forceShowFeature,
        handleStop,
        error
    ];
};
module.exports["useFeatureDiscovery"] = $112f5732a615f62f$export$6de1a7573792d1a9;

});

parcelRegister("iyPd9", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $b4e2a77d9a5ab99b$export$b3c271f2152800f6 = (0, $eSUdr.default)`query FeatureDiscoveryQuery{featureDiscovery{pluginKey featureKey}}`;
module.exports["FeatureDiscoveryQuery"] = $b4e2a77d9a5ab99b$export$b3c271f2152800f6;

});

parcelRegister("eDk57", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4aiCO = parcelRequire("4aiCO");


var $1mDVg = parcelRequire("1mDVg");

const $45dbb5af31f3f8d0$export$bc90850968906652 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1mDVg.IssueCreateSidePanelContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4aiCO.IssueCreateWarningDialogContainer), null, children));
};
module.exports["SingleIssueCreateProvidersWrapper"] = $45dbb5af31f3f8d0$export$bc90850968906652;

});

parcelRegister("aiS08", function(module, exports) {
$parcel$export(module.exports, "ISSUE_CREATE_SIDE_PANEL_ID", () => (parcelRequire("1L1jV")).ISSUE_CREATE_SIDE_PANEL_ID);
$parcel$export(module.exports, "ISSUE_CREATE_SIDE_PANEL_WIDTH", () => (parcelRequire("1L1jV")).ISSUE_CREATE_SIDE_PANEL_WIDTH);

var $jmjWc = parcelRequire("jmjWc");


var $1L1jV = parcelRequire("1L1jV");


const $8c03994ca3756429$export$808956d96594cb81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dU97j",
    name: "IssueCreateSidePanel",
    loader: async ()=>(await Promise.resolve((parcelRequire("1L1jV")))).IssueCreateSidePanel
});
module.exports["IssueCreateSidePanel"] = $8c03994ca3756429$export$808956d96594cb81;

});

parcelRegister("1L1jV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $2Rith = parcelRequire("2Rith");

var $fYQcF = parcelRequire("fYQcF");


var $7aRa9 = parcelRequire("7aRa9");


var $ai7NK = parcelRequire("ai7NK");


var $3yh4a = parcelRequire("3yh4a");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $98CLM = parcelRequire("98CLM");


var $kJYUO = parcelRequire("kJYUO");


var $1mDVg = parcelRequire("1mDVg");


var $eDk57 = parcelRequire("eDk57");


var $5Ew1A = parcelRequire("5Ew1A");


var $jwedr = parcelRequire("jwedr");


var $3AAT8 = parcelRequire("3AAT8");


var $hib1D = parcelRequire("hib1D");


var $6pbwW = parcelRequire("6pbwW");

const $7dea7a25aec9b259$export$3318bd9d18742c1e = 'issue-create-side-panel';
const $7dea7a25aec9b259$export$e760a8f02240cc6d = 'issue-create-side-panel';
const $7dea7a25aec9b259$export$d030b92b162b528d = 320;
const $7dea7a25aec9b259$var$sidePanelStyle = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $7dea7a25aec9b259$var$IssueCreateSidePanelComponent = ({ onClose: onClose, flags: flags })=>{
    const { showSidePanel: showSidePanel, hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const { isWarningDialogOpen: isWarningDialogOpen, handleConfirm: handleConfirm, handleCancel: handleCancel } = (0, $jwedr.useGetWarningDialogActions)(onClose);
    const [state, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { aiState: aiState, isCreatedWithAi: isCreatedWithAi, aiAnalyticsContext: aiAnalyticsContext, isCreatedFromActionItems: isCreatedFromActionItems } = state;
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const { trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const shouldShowAiFooter = isCreatedWithAi && aiState !== 'error';
    const isAiLoading = aiState === 'loading';
    const handleOnClose = (0, $42omo.useCallback)((isCreateSuccess)=>{
        if (isCreatedWithAi && !isCreateSuccess) trackAIInteractionDismiss({
            attributes: aiAnalyticsContext
        });
        if (!isCreateSuccess) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightIssueCreate',
                action: 'closed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'linkCreate',
                type: 'ui',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    isAiLoading: isAiLoading,
                    aiEnablement: aiIssueCreationEnablement?.enablement,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    // We don't invoke table creation from highlighting a single row
                    isCreatedFromTable: false
                }
            }
        }).fire();
        hideSidePanel();
        onClose();
        actions.setAiState('idle');
    }, [
        isCreatedWithAi,
        hideSidePanel,
        onClose,
        actions,
        trackAIInteractionDismiss,
        aiAnalyticsContext,
        createAnalyticsEvent,
        state.pageMode,
        isAiLoading,
        aiIssueCreationEnablement?.enablement,
        state.hasEditPermission,
        isCreatedFromActionItems
    ]);
    const handleOnConfirm = (0, $42omo.useCallback)(()=>{
        actions.setAiState('idle');
        handleConfirm();
    }, [
        actions,
        handleConfirm
    ]);
    (0, $42omo.useEffect)(()=>{
        showSidePanel();
    }, [
        showSidePanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: $7dea7a25aec9b259$export$3318bd9d18742c1e,
        xcss: $7dea7a25aec9b259$var$sidePanelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Ew1A.SidePanelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kJYUO.IssueCreateAiLoadingSidebar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6pbwW.IssueCreateSidePanelHeader), {
        onClose: handleOnClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3AAT8.IssueCreateSidePanelBody), {
        onClose: handleOnClose,
        flags: flags
    }), shouldShowAiFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hib1D.IssueCreateSidePanelFooter), null))), isWarningDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $98CLM.IssueCreateWarningDialog), {
        onCancel: handleCancel,
        onConfirm: handleOnConfirm,
        issuesCount: 1
    }));
};
const $7dea7a25aec9b259$var$IssueCreateSidePanelComponentWithProvider = ({ onClose: onClose, flags: flags })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eDk57.SingleIssueCreateProvidersWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: {
            // Required configruation
            product: 'confluence',
            subproduct: 'jira',
            aiFeatureName: 'confluenceAiWorkCreation',
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            // Optional configuration
            source: 'confluenceHighlightIssueCreate',
            skipAISessionValidation: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7dea7a25aec9b259$var$IssueCreateSidePanelComponent, {
        onClose: onClose,
        flags: flags
    })));
};
const $7dea7a25aec9b259$var$IssueCreateSidePanelWithFlags = (0, $7aRa9.withFlags)($7dea7a25aec9b259$var$IssueCreateSidePanelComponentWithProvider);
const $7dea7a25aec9b259$var$IssueCreateSidePanelWithErrorBoundary = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).INTEGRATIONS
})($7dea7a25aec9b259$var$IssueCreateSidePanelWithFlags);
const $7dea7a25aec9b259$export$808956d96594cb81 = (0, $3yh4a.componentWithFG)('jira_ai_aiwc_in_confluence_set_up_error_boundary', $7dea7a25aec9b259$var$IssueCreateSidePanelWithErrorBoundary, $7dea7a25aec9b259$var$IssueCreateSidePanelWithFlags);
module.exports["sidePanelTestId"] = $7dea7a25aec9b259$export$3318bd9d18742c1e;
module.exports["ISSUE_CREATE_SIDE_PANEL_ID"] = $7dea7a25aec9b259$export$e760a8f02240cc6d;
module.exports["ISSUE_CREATE_SIDE_PANEL_WIDTH"] = $7dea7a25aec9b259$export$d030b92b162b528d;
module.exports["IssueCreateSidePanel"] = $7dea7a25aec9b259$export$808956d96594cb81;

});

parcelRegister("ai7NK", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $30dd91193859fc54$export$4f97fa3245bb0e31 = {
    isSidePanelOpen: false
};
const $30dd91193859fc54$export$e324594224ef24da = {
    showSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: true
            });
        },
    hideSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: false
            });
        }
};
const $30dd91193859fc54$var$Store = (0, $1P1Tu.createStore)({
    initialState: $30dd91193859fc54$export$4f97fa3245bb0e31,
    actions: $30dd91193859fc54$export$e324594224ef24da,
    name: 'SidePanelState'
});
const $30dd91193859fc54$export$d4bcf572fecd48f5 = (0, $9zUhf.createActionsHook)($30dd91193859fc54$var$Store);
const $30dd91193859fc54$export$f3f6191f6fee6235 = (0, $9zUhf.createStateHook)($30dd91193859fc54$var$Store, {
    selector: (state)=>state.isSidePanelOpen
});
module.exports["useSidePanelStateActions"] = $30dd91193859fc54$export$d4bcf572fecd48f5;
module.exports["useIsSidePanelOpen"] = $30dd91193859fc54$export$f3f6191f6fee6235;

});

parcelRegister("3yh4a", function(module, exports) {

var $8YePs = parcelRequire("8YePs");


var $9wGTI = parcelRequire("9wGTI");

const $d415184962066c9b$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $8YePs.componentWithCondition)(()=>(0, $9wGTI.fg)(gateName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $d415184962066c9b$export$cf56d0f54cfcce4;

});

parcelRegister("8YePs", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $b3ddd992633db411$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $b3ddd992633db411$export$6e8ea24b15199873;

});

parcelRegister("kJYUO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1mDVg = parcelRequire("1mDVg");


var $hq2Sz = parcelRequire("hq2Sz");


var $1uJpg = parcelRequire("1uJpg");

const $e4ab54f04ea47f96$export$dcc317fc4f9228b3 = ({ children: children })=>{
    const [{ aiState: aiState, pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const [{ isCreatedFromActionItems: isCreatedFromActionItems, isCreatedFromTable: isCreatedFromTable }] = (0, $hq2Sz.useBulkCreateContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const isAiLoading = aiState === 'loading';
    const aiEnablement = aiIssueCreationEnablement?.enablement;
    (0, $42omo.useEffect)(()=>{
        if (isAiLoading) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'AI loading state',
                source: 'confluenceHighlightIssueCreate',
                attributes: {
                    aiEnablement: aiEnablement,
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    isCreatedFromTable: isCreatedFromTable
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isAiLoading,
        aiEnablement,
        pageMode,
        hasEditPermission,
        isCreatedFromActionItems,
        isCreatedFromTable
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1uJpg.RainbowLoadingSidebar), {
        isShown: isAiLoading
    }, children);
};
module.exports["IssueCreateAiLoadingSidebar"] = $e4ab54f04ea47f96$export$dcc317fc4f9228b3;

});

parcelRegister("3AAT8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $cfwlu = parcelRequire("cfwlu");


var $fYQcF = parcelRequire("fYQcF");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1mDVg = parcelRequire("1mDVg");


var $5FJ5W = parcelRequire("5FJ5W");


var $3E5yu = parcelRequire("3E5yu");


var $1Q0l6 = parcelRequire("1Q0l6");


var $9K9na = parcelRequire("9K9na");


var $2ay9q = parcelRequire("2ay9q");


var $bImpr = parcelRequire("bImpr");


var $kcLnq = parcelRequire("kcLnq");


var $bZC8A = parcelRequire("bZC8A");


var $jE0Gg = parcelRequire("jE0Gg");


var $aXkRG = parcelRequire("aXkRG");

const $889e5fc4cfbacead$var$aiContentWrapperBaseStyles = (0, $ecnYn.xcss)({
    display: 'inherit',
    flexGrow: 1
});
const $889e5fc4cfbacead$var$aiContentWrapperHiddenStyles = (0, $ecnYn.xcss)({
    display: 'none'
});
const $889e5fc4cfbacead$export$b5988d25d9f45521 = ({ onClose: onClose, flags: flags })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [state, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { contentId: contentId, contentType: contentType, summary: summary, descriptionAdf: descriptionAdf, aiState: aiState, isCreatedWithAi: isCreatedWithAi, highlightedText: highlightedText, insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload, totalRetries: totalRetries, firstAttempt: firstAttempt, aiAnalyticsContext: aiAnalyticsContext, currentSiteSelection: currentSiteSelection, currentProjectSelection: currentProjectSelection, isGicIframeReady: isGicIframeReady, isCreatedFromActionItems: isCreatedFromActionItems } = state;
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const aiError = aiState === 'error';
    // no need to override if it's the same site
    const persistedOverrideCloudId = (0, $2ay9q.getPersistedOverrideCloudId)();
    const [overrideCloudIdForSitePicker, setOverrideCloudIdForSitePicker] = (0, $42omo.useState)(persistedOverrideCloudId !== cloudId ? persistedOverrideCloudId : undefined);
    const [overrideProjectId, setOverrideProjectId] = (0, $42omo.useState)(undefined);
    const [showCreateWithAiToggle, setShowCreateWithAiToggle] = (0, $42omo.useState)(false);
    const defaultErrorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefresh : (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescription;
    const [errorMessage, setErrorMessage] = (0, $42omo.useState)(defaultErrorMessage);
    const [errorMessageValues, setErrorMessageValues] = (0, $42omo.useState)();
    const [hideTryAgain, setHideTryAgain] = (0, $42omo.useState)(false);
    (0, $jE0Gg.useMessageListener)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'linkCreateScreen',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    // We don't invoke table creation from highlighting a single row
                    isCreatedFromTable: false,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                },
                source: 'confluenceHighlightIssueCreate'
            }
        }).fire();
    }, [
        isCreatedWithAi,
        createAnalyticsEvent,
        aiIssueCreationEnablement?.enablement,
        state.pageMode,
        state.hasEditPermission,
        isCreatedFromActionItems
    ]);
    const isAiLoading = aiState === 'loading';
    const triggerFlag = (0, $9K9na.useTriggerFlagIssueCreated)(flags);
    const handleTryAgain = (0, $42omo.useCallback)(()=>{
        actions.setTotalRetries();
        actions.setFirstAttempt(false);
        actions.setAiState('idle');
        // trigger a new AI interaction init event retries
        trackAIInteractionInit({
            attributes: {
                pageMode: state.pageMode,
                totalRetries: totalRetries + 1,
                firstAttempt: false,
                aiEnablement: aiIssueCreationEnablement?.enablement
            }
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'issueCreateSidePanelErrorScreen',
                action: 'retry',
                actionSubject: 'issueCreate',
                attributes: {
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    createManually: !isCreatedWithAi,
                    tryAgainWithAi: isCreatedWithAi,
                    totalRetries: totalRetries + 1,
                    firstAttempt: false,
                    ...aiAnalyticsContext
                }
            }
        }).fire();
    }, [
        actions,
        trackAIInteractionInit,
        totalRetries,
        aiIssueCreationEnablement?.enablement,
        createAnalyticsEvent,
        state.pageMode,
        isCreatedWithAi,
        aiAnalyticsContext,
        state.hasEditPermission
    ]);
    const handleCreateManually = (0, $42omo.useCallback)(()=>{
        actions.setIsCreatedWithAi(false);
        actions.setAiState('idle');
        setShowCreateWithAiToggle(false);
    }, [
        actions
    ]);
    const handleCreateWithAi = (0, $42omo.useCallback)(()=>{
        actions.setIsCreatedWithAi(true);
        actions.setAiState('loading');
        setShowCreateWithAiToggle(false);
    }, [
        actions
    ]);
    const handleCreateManuallyAfterError = (0, $42omo.useCallback)(()=>{
        actions.setTotalRetries();
        actions.setFirstAttempt(false);
        actions.setIsCreateManuallyPressed(true);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'issueCreateSidePanelErrorScreen',
                action: 'retry',
                actionSubject: 'issueCreate',
                attributes: {
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    createManually: true,
                    tryAgainWithAi: false,
                    totalRetries: totalRetries + 1,
                    firstAttempt: false,
                    ...aiAnalyticsContext
                }
            }
        }).fire();
        handleCreateManually();
    }, [
        actions,
        createAnalyticsEvent,
        state.pageMode,
        state.hasEditPermission,
        totalRetries,
        aiAnalyticsContext,
        handleCreateManually
    ]);
    const onIssueCreateInit = (0, $42omo.useCallback)(()=>{
        setShowCreateWithAiToggle(aiIssueCreationEnablement?.isEnabled ?? false);
        /*
		 * When ConfluenceAI=OFF & JiraAI=ON this component will manually create the issue first until
		 * selected site & project info is available to check Jira's AI enablement.  If JiraAI=ON then
		 * we can setIsCreatedWithAi to what the user's personal AI enablement to trigger a rerender.
		 */ if (aiIssueCreationEnablement?.isEnabled) actions.setIsCreatedWithAi((0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)());
        else actions.setIsCreatedWithAi(false);
        if (!(0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)()) return;
        /*
		 * requiresComponentChange is important since we are switching between manaul create (GicAnywhere) and
		 * ConfluenceAiIssueCreate (which uses GicAnywhere under the hood).  The GicAnywhere has limitations where
		 * changes to overrideCloudId after initial load can cause iframe rendering issues.  A component swap happens only when
		 * the isCreatedWithAi state is changed so we can bundle these prop updates together.
		 */ const requiresComponentChange = aiIssueCreationEnablement?.isEnabled !== isCreatedWithAi;
        if (requiresComponentChange) {
            setOverrideCloudIdForSitePicker(currentSiteSelection);
            setOverrideProjectId(currentProjectSelection?.selectedProjectId);
            // During component switch the iframe will be replaced and there is no event for this.
            // We need to reset it here manually.
            actions.setIsGicIframeReady(false);
        }
        if (currentSiteSelection && currentSiteSelection !== overrideCloudIdForSitePicker) setOverrideProjectId(currentProjectSelection?.selectedProjectId);
    }, [
        aiIssueCreationEnablement?.isEnabled,
        isCreatedWithAi,
        currentSiteSelection,
        overrideCloudIdForSitePicker,
        actions,
        currentProjectSelection?.selectedProjectId
    ]);
    const onAiIssueCreateInit = (0, $42omo.useCallback)(()=>{
        onIssueCreateInit();
        const analyticAttributes = {
            attributes: {
                ...aiAnalyticsContext,
                aiEnablement: aiIssueCreationEnablement?.enablement,
                pageMode: state.pageMode,
                hasEditPermission: state.hasEditPermission
            }
        };
        trackAIResultView({
            actionSubjectId: 'aiIssueCreatOnInitComplete',
            ...analyticAttributes
        });
    }, [
        onIssueCreateInit,
        aiAnalyticsContext,
        aiIssueCreationEnablement?.enablement,
        state.pageMode,
        trackAIResultView,
        state.hasEditPermission
    ]);
    const isSuggestedIssuesErrorMessage = (error)=>{
        return error && typeof error === 'object' && 'message_template' in error;
    };
    const onFailure = (0, $42omo.useCallback)((error)=>{
        // reset
        if (hideTryAgain) {
            setHideTryAgain(false);
            setErrorMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefresh : (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescription);
            setErrorMessageValues({});
        }
        if (isSuggestedIssuesErrorMessage(error)) {
            const aiIssueCreateError = (0, $bZC8A.handleAiIssueCreateError)(error);
            if (aiIssueCreateError !== undefined) {
                setErrorMessage(aiIssueCreateError.errorMessage);
                setErrorMessageValues(aiIssueCreateError.errorMessageValues);
                setHideTryAgain(aiIssueCreateError.hideTryAgain);
            }
        }
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'confluenceHighlightIssueCreate',
                action: 'error',
                actionSubject: 'globalIssueCreate',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    error: error,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            }
        }).fire();
        if (isCreatedWithAi) trackAIResultError({
            aiErrorMessage: error.message
        }, {
            attributes: {
                pageMode: state.pageMode,
                hasEditPermission: state.hasEditPermission,
                totalRetries: totalRetries,
                firstAttempt: firstAttempt,
                ...aiAnalyticsContext
            }
        });
    }, [
        hideTryAgain,
        createAnalyticsEvent,
        isCreatedWithAi,
        state.pageMode,
        state.hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        trackAIResultError,
        totalRetries,
        firstAttempt,
        aiAnalyticsContext
    ]);
    const onSuccess = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'confluenceHighlightIssueCreate',
                action: 'created',
                actionSubject: 'issue',
                actionSubjectId: 'confluenceIssueCreate',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    // We don't invoke table creation from highlighting a single row
                    isCreatedFromTable: false,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            }
        }).fire();
        if (isCreatedWithAi) trackAIResultAction('issue created', {
            attributes: {
                pageMode: state.pageMode,
                hasEditPermission: state.hasEditPermission,
                isCreatedFromActionItems: isCreatedFromActionItems,
                // We don't invoke table creation from highlighting a single row
                isCreatedFromTable: false,
                totalRetries: totalRetries,
                firstAttempt: firstAttempt,
                issueId: payload?.issueId || '',
                aiEnablement: aiIssueCreationEnablement?.enablement,
                ...aiAnalyticsContext
            }
        });
        triggerFlag(payload, 'success-circle', (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelSingleIssueCreateSuccessFlagTitleIssueTermRefresh : (0, $3E5yu.messages).sidePanelSingleIssueCreateSuccessFlagTitle);
        // Save the cloud id in localStorage if an issue is created
        (0, $2ay9q.saveCloudIdToLocalStorage)(payload);
        if (insertStorageFragmentRequestPayload && state.hasEditPermission) {
            insertStorageFragmentRequestPayload.xmlModification = isCreatedFromActionItems && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items') ? (0, $1Q0l6.constructBreakContainerTag)((0, $1Q0l6.constructSmartlinkTag)(payload.link)) : (0, $1Q0l6.constructSmartlinkTag)(payload.link);
            (0, $1Q0l6.updateLastFetchTimeIfNotViewMode)(insertStorageFragmentRequestPayload, state.pageMode);
            (0, $1Q0l6.insertContentAtSelectionEnd)(insertStorageFragmentRequestPayload).then((data)=>{
                // There is a case where the API response is OK, but the response data is false.
                // When this happens, the backend has trouble inserting the ticket to the page and we should show an error toast.
                if (data === false) throw new Error('Failed to insert storage fragment');
                return createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'confluenceHighlightIssueCreate',
                        action: 'created',
                        actionSubject: 'link',
                        actionSubjectId: 'confluenceIssueCreate',
                        attributes: {
                            isManuallyCreated: !isCreatedWithAi,
                            isCreatedWithAi: isCreatedWithAi,
                            pageMode: state.pageMode,
                            hasEditPermission: state.hasEditPermission
                        }
                    }
                }).fire();
            }).then(()=>{
                // Refresh the page only if the current mode is VIEW, as other modes receive live updates.
                if (state.pageMode === (0, $1mDVg.PageMode).VIEW) (0, $1Q0l6.refreshPageWithTimeout)();
            }).catch((_error)=>triggerFlag(payload, 'error', (0, $3E5yu.messages).sidePanelIssueCreateInsertionFailed));
        }
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromActionItems,
        state.pageMode,
        state.hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        triggerFlag,
        insertStorageFragmentRequestPayload,
        trackAIResultAction,
        totalRetries,
        firstAttempt,
        aiAnalyticsContext
    ]);
    const handleStateChange = (0, $42omo.useCallback)((state, source)=>{
        // Keep loading animation active when get Confluence page completes but field suggestions are still loading
        if (source === 'aiIssueCreateGetConfluencePageState' && (state === 'idle' || state === 'loading')) return;
        actions.setAiState(state);
    }, [
        actions
    ]);
    const onAiToggleChange = (0, $42omo.useCallback)((enabled)=>{
        if (enabled) {
            trackAIInteractionInit({
                attributes: {
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            });
            handleCreateWithAi();
        } else handleCreateManually();
    }, [
        trackAIInteractionInit,
        state.pageMode,
        state.hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        handleCreateWithAi,
        handleCreateManually
    ]);
    if (aiError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXkRG.WorkItemCreationError), {
        creationSource: "confluenceHighlightIssueCreate",
        errorMessage: errorMessage,
        errorMessageValues: hideTryAgain ? errorMessageValues : undefined,
        onTryAgain: hideTryAgain ? undefined : handleTryAgain,
        onCreateManually: handleCreateManuallyAfterError,
        isCreatedWithAi: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !isAiLoading && isGicIframeReady && showCreateWithAiToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bImpr.IssueCreateWithAiToggle), {
        onChange: onAiToggleChange
    }), isCreatedWithAi ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAiLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5FJ5W.IssueCreateAiLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $889e5fc4cfbacead$var$aiContentWrapperBaseStyles,
            isAiLoading && $889e5fc4cfbacead$var$aiContentWrapperHiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kcLnq.ConfluenceAiIssueCreate), {
        cloudId: cloudId,
        contentType: contentType,
        pageId: contentId,
        highlightedTextAdf: highlightedText,
        consumer: "confluence-highlight-issue-create-ai",
        onInit: onAiIssueCreateInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onStateChange: handleStateChange,
        overrideCloudIdForSitePicker: overrideCloudIdForSitePicker,
        overrideProjectIdForProjectPicker: overrideProjectId,
        setAiAnalyticsContext: actions.setAiAnalyticsContext,
        aIIssueCreationEnablement: aiIssueCreationEnablement
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfwlu.GicAnywhere), {
        cloudId: cloudId,
        consumer: "confluence-highlight-issue-create",
        onInit: onIssueCreateInit,
        onSuccess: onSuccess,
        onClose: onClose,
        onFailure: onFailure,
        summary: summary,
        descriptionAdf: descriptionAdf,
        overrideCloudId: overrideCloudIdForSitePicker,
        isPayloadReady: true,
        projectId: overrideProjectId
    }));
};
module.exports["IssueCreateSidePanelBody"] = $889e5fc4cfbacead$export$b5988d25d9f45521;

});

parcelRegister("cfwlu", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $fBMbo = parcelRequire("fBMbo");


var $b4emg = parcelRequire("b4emg");


var $inPa6 = parcelRequire("inPa6");


var $7p4As = parcelRequire("7p4As");


var $1Whri = parcelRequire("1Whri");


var $abC4X = parcelRequire("abC4X");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $fwDOR = parcelRequire("fwDOR");


var $9hlns = parcelRequire("9hlns");


var $cOrQJ = parcelRequire("cOrQJ");


var $fVTNs = parcelRequire("fVTNs");

var $3C50A = parcelRequire("3C50A");

var $bHD89 = parcelRequire("bHD89");


var $liF9q = parcelRequire("liF9q");


var $4KAVh = parcelRequire("4KAVh");


var $0XxK1 = parcelRequire("0XxK1");


var $g5o3i = parcelRequire("g5o3i");


var $7u9UW = parcelRequire("7u9UW");


var $4SDuV = parcelRequire("4SDuV");

const $0e7ff5291d49736a$var$phases = {
    loading: 'loading',
    timeout: 'timeout',
    error: 'error',
    idle: 'idle'
};
const $0e7ff5291d49736a$export$9af19a1ca8685214 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $0XxK1.AnalyticsProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVTNs.ContextWrapper), {
            sourceType: (0, $bHD89.MODAL),
            sourceName: "gicAnywhere",
            children: /*#__PURE__*/ (0, $l998X.jsx)($0e7ff5291d49736a$export$c43a9e8a05acb520, {
                ...props
            })
        })
    });
};
const $0e7ff5291d49736a$var$styles = {
    hiddenDisplay: "_1e0cglyw",
    gicAnywhere: "_1bsb1osq _4t3i1osq",
    loadingScreen: "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _y3gn1h6o"
};
const $0e7ff5291d49736a$export$c43a9e8a05acb520 = ({ cloudId: cloudId, overrideCloudId: overrideCloudId, configuration: configuration, summary: summary, assignee: assignee, descriptionAdf: descriptionAdf, consumer: consumer, timeoutMs: timeoutMs = (0, $7u9UW.DEFAULT_TIMEOUT), onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, projectId: projectId, issueTypeId: issueTypeId, issueTypes: issueTypes, isPayloadReady: isPayloadReady = false, additionalMappedFields: additionalMappedFields, baseUrlForAvailableSites: baseUrlForAvailableSites })=>{
    const { availableSites: availableSites, domainName: domainName, isOverrideSiteAvailable: isOverrideSiteAvailable } = (0, $g5o3i.useGetDomainAndAvailableSites)({
        cloudId: cloudId,
        overrideCloudId: overrideCloudId,
        baseUrlForAvailableSites: baseUrlForAvailableSites
    });
    const displaySitePicker = availableSites && availableSites.length > 1;
    const [phase, setPhase] = (0, $42omo.useState)($0e7ff5291d49736a$var$phases.loading);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        const timeout = (()=>{
            switch(phase){
                case $0e7ff5291d49736a$var$phases.loading:
                    return setTimeout(()=>{
                        (0, $3C50A.fireOperationalAnalytics)(createAnalyticsEvent({}), 'globalIssueCreateEmbed timedOut', {
                            consumer: consumer,
                            timeoutMs: timeoutMs
                        });
                        setPhase($0e7ff5291d49736a$var$phases.timeout);
                        onTimeout?.();
                    }, timeoutMs);
                case $0e7ff5291d49736a$var$phases.timeout:
                    // if timeoutMs passes again after initial timeout, assume GIC is not loading and set to error state
                    return setTimeout(()=>{
                        (0, $3C50A.fireOperationalAnalytics)(createAnalyticsEvent({}), 'globalIssueCreateEmbed error', {
                            consumer: consumer,
                            timeoutMs: timeoutMs * 2
                        });
                        setPhase($0e7ff5291d49736a$var$phases.error);
                        onFailure(new Error('GIC has timed out'));
                    }, timeoutMs);
            }
        })(); // set Timeout for loading, reset for any other state.
        return ()=>timeout && clearTimeout(timeout);
    }, [
        consumer,
        createAnalyticsEvent,
        onFailure,
        onTimeout,
        phase,
        timeoutMs
    ]); // we mimic "external callback" for our needs
    const onGICReady = (0, $42omo.useCallback)(()=>{
        setPhase($0e7ff5291d49736a$var$phases.idle);
        return {
            summary: summary || 'No summary provided' /* this is impossible case */ ,
            descriptionAdf: descriptionAdf || (0, $b4emg.getEmptyADF)(),
            projectId: projectId,
            issueTypeId: issueTypeId,
            issueTypes: issueTypes?.join(','),
            assignee: assignee,
            fieldData: additionalMappedFields
        };
    }, [
        summary,
        descriptionAdf,
        projectId,
        issueTypeId,
        issueTypes,
        assignee,
        additionalMappedFields
    ]);
    const renderPhaseInformation = (0, $42omo.useMemo)(()=>{
        switch(phase){
            case $0e7ff5291d49736a$var$phases.timeout:
            case $0e7ff5291d49736a$var$phases.loading:
                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    testId: "gic-anywhere-loading",
                    xcss: (0, $1Whri.cx)($0e7ff5291d49736a$var$styles.gicAnywhere, $0e7ff5291d49736a$var$styles.loadingScreen),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                            size: "large"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: formatMessage(phase === $0e7ff5291d49736a$var$phases.timeout ? (0, $4SDuV.messages).iFrameSlowLoading : (0, $4SDuV.messages).iFrameLoading, {
                                br: /*#__PURE__*/ (0, $l998X.jsx)("br", {})
                            })
                        })
                    ]
                });
            case $0e7ff5291d49736a$var$phases.error:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    testId: "gic-anywhere-error",
                    xcss: $0e7ff5291d49736a$var$styles.gicAnywhere,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
                        header: formatMessage((0, $4SDuV.messages).errorHeader),
                        description: formatMessage((0, $4SDuV.messages).errorBody),
                        primaryAction: /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                            onClick: ()=>{
                                onClose();
                            },
                            href: domainName || '/',
                            target: "_blank",
                            appearance: "primary",
                            children: formatMessage((0, $4SDuV.messages).openInJiraButton)
                        }),
                        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($liF9q))),
                        imageWidth: (0, $7u9UW.MAX_ERROR_IMAGE_WIDTH),
                        maxImageWidth: (0, $7u9UW.MAX_ERROR_IMAGE_WIDTH),
                        maxImageHeight: (0, $7u9UW.MAX_ERROR_IMAGE_HEIGHT)
                    })
                });
            default:
                return undefined;
        }
    }, [
        phase,
        formatMessage,
        domainName,
        onClose
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            renderPhaseInformation,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                name: "gic-anywhere-iframe-loading",
                hold: phase === $0e7ff5291d49736a$var$phases.loading
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: phase !== $0e7ff5291d49736a$var$phases.idle ? $0e7ff5291d49736a$var$styles.hiddenDisplay : $0e7ff5291d49736a$var$styles.gicAnywhere,
                children: domainName !== undefined && /*#__PURE__*/ (0, $l998X.jsx)($0e7ff5291d49736a$export$ae3b6dcb03669e81, {
                    domainName: domainName,
                    consumer: consumer,
                    onGICReady: onGICReady,
                    onInit: onInit,
                    onSuccess: onSuccess,
                    onFailure: onFailure,
                    onClose: onClose,
                    configuration: configuration,
                    displaySitePicker: displaySitePicker,
                    isPayloadReady: isPayloadReady,
                    overrideCloudId: isOverrideSiteAvailable ? overrideCloudId : undefined
                })
            })
        ]
    });
};
const $0e7ff5291d49736a$export$ae3b6dcb03669e81 = ({ onGICReady: onGICReady, consumer: consumer, domainName: domainName, overrideCloudId: overrideCloudId, onClose: onClose, onFailure: onFailure, onSuccess: onSuccess, onInit: onInit, configuration: configuration, displaySitePicker: displaySitePicker = true, isPayloadReady: isPayloadReady = false })=>{
    (0, $fBMbo.di)($0e7ff5291d49736a$export$b32b5f1ee4493319);
    const iframeRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const [isCreateSuccess, setIsCreateSuccess] = (0, $42omo.useState)(false);
    const [isGicReady, setIsGicReady] = (0, $42omo.useState)(false);
    const isGicReadyRef = (0, $42omo.useRef)(isGicReady); // we will react on this event only once
    // we dont want to reattach handlers on every render
    const onGICReadyRef = (0, $42omo.useRef)(onGICReady);
    onGICReadyRef.current = onGICReady;
    const params = (0, $42omo.useMemo)(()=>({
            product: consumer,
            actionSource: 'issue-create-anywhere-embed'
        }), [
        consumer
    ]); // Create a debounced version of onInit that will only execute the latest call after 2 seconds
    const debouncedOnInit = (0, $42omo.useMemo)(()=>{
        if (!onInit) return undefined;
        if (!(0, $dh538.fg)('jira_ai_fix_aiwc_duplicated_analytics')) return onInit;
        return (0, $0XxK1.debounce)(()=>onInit(), 2000);
    }, [
        onInit
    ]); // Cleanup the debounced function on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            const debouncedFn = debouncedOnInit; // Only call cancel if debouncedOnInit is actually a debounced function
            if (debouncedFn && typeof debouncedFn.cancel === 'function') debouncedFn.cancel();
        };
    }, [
        debouncedOnInit
    ]);
    (0, $42omo.useEffect)(()=>{
        const messageHandler = async (message)=>{
            const iframe = iframeRef.current?.contentWindow;
            if (!iframe) return;
            const eventName = message?.data?.event;
            const event = createAnalyticsEvent({});
            switch(eventName){
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_READY:
                    (0, $3C50A.fireOperationalAnalytics)(event, 'globalIssueCreateEmbed initialised', {
                        consumer: consumer
                    });
                    setIsGicReady(true);
                    break;
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_SUCCESS:
                    setIsCreateSuccess(true);
                    onSuccess(message.data.payload);
                    (0, $3C50A.fireTrackAnalytics)(event, 'globalIssueCreateEmbed succeeded', {
                        consumer: consumer
                    });
                    break;
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_FAILURE:
                    onFailure(new Error('issueCreate failed to save'));
                    (0, $3C50A.fireOperationalAnalytics)(event, 'globalIssueCreateEmbed failed', {
                        consumer: consumer
                    });
                    break;
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_CLOSE:
                    onClose(isCreateSuccess); // GIC sends a closeEvent even when created succesfully. Hence
                    // checking if no issue was created
                    if (!isCreateSuccess) (0, $3C50A.fireUIAnalytics)(event, 'globalIssueCreateEmbed closed', {
                        consumer: consumer
                    });
                    break;
                default:
            }
        }; // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('message', messageHandler);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('message', messageHandler);
        };
    }, [
        iframeRef,
        consumer,
        createAnalyticsEvent,
        onInit,
        onClose,
        onFailure,
        onSuccess,
        isCreateSuccess,
        setIsCreateSuccess,
        setIsGicReady
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isPayloadReady && isGicReady) // Only resolve the Promise if isPayloadReady is true, and the message has been received
        Promise.resolve(onGICReadyRef.current()).then((issuePayload)=>{
            const iframe = iframeRef.current?.contentWindow;
            if (iframe) {
                const { fieldData: fieldData, ...defaultValues } = issuePayload ?? {}; // Send GIC data used for initialization
                iframe.postMessage({
                    event: (0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_INIT),
                    payload: {
                        defaultValues: defaultValues,
                        ...fieldData && {
                            fieldData: {
                                ...fieldData,
                                ...defaultValues
                            }
                        }
                    }
                }, // Broadcast this message to all listeners for now
                '*');
                debouncedOnInit?.();
            }
        });
    }, [
        isPayloadReady,
        isGicReady,
        onGICReadyRef,
        debouncedOnInit
    ]);
    const iframeSrc = (0, $0XxK1.getIframeSrc)({
        colorMode: colorMode,
        domainName: domainName,
        params: params,
        displaySitePicker: (0, $dh538.fg)('jira_ai_gic_embed_exception_on_timeout') ? displaySitePicker : true,
        ...configuration,
        overrideCloudId: overrideCloudId
    });
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('jira_ai_gic_embed_exception_on_timeout')) return;
        isGicReadyRef.current = isGicReady;
    }, [
        isGicReady
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('jira_ai_gic_embed_exception_on_timeout')) return;
         // We need to reset the isGicReady state to avoid sending another postMessage to the GIC iframe window
        setIsGicReady(false);
    }, [
        iframeSrc
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('jira_ai_gic_embed_exception_on_timeout')) return;
        const TIMEOUT_10_SECONDS = 10000;
        const timeout = setTimeout(()=>{
            // We need to use a ref to check if GIC is ready because the isGicReady state is updated asynchronously
            if (!isGicReadyRef.current) // This is a fallback for the case when the GIC iframe window is not initialized
            throw new Error('jira-ai/gic-anywhere: The latest GIC iframe window was not initialized');
        }, TIMEOUT_10_SECONDS);
        return ()=>clearTimeout(timeout);
    }, [
        iframeSrc
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($0e7ff5291d49736a$export$b32b5f1ee4493319, {
        name: "gic-anywhere-iframe",
        sandbox: undefined,
        ref: iframeRef,
        height: "100%",
        width: "100%",
        frameBorder: 0,
        // onError={}
        src: iframeSrc,
        "data-testid": "gic-anywhere"
    });
};
const $0e7ff5291d49736a$export$b32b5f1ee4493319 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("iframe", {
        title: "Jira Embed Global Issue Create",
        ref: ref,
        ...props
    });
});
module.exports["GicAnywhere"] = $0e7ff5291d49736a$export$9af19a1ca8685214;

});

parcelRegister("b4emg", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hbEec = parcelRequire("hbEec");

const $8841f32d2d46ed1f$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });
module.exports["getEmptyADF"] = $8841f32d2d46ed1f$export$d109ab46c9575565;

});

parcelRegister("fVTNs", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e7URT = parcelRequire("e7URT");


var $1j3sF = parcelRequire("1j3sF");


var $bYRk6 = parcelRequire("bYRk6");

const $c32683c3f1554789$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))));
};
const $c32683c3f1554789$export$34282a1f95511a11 = (props)=>{
    const data = $c32683c3f1554789$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: data,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: props.children
        })
    });
};
module.exports["ContextWrapper"] = $c32683c3f1554789$export$34282a1f95511a11;

});

parcelRegister("e7URT", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a48dd4fd18e75a65$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a48dd4fd18e75a65$var$isUndefined;

});

parcelRegister("3C50A", function(module, exports) {

var $apAFY = parcelRequire("apAFY");


var $bHD89 = parcelRequire("bHD89");


var $1J0ov = parcelRequire("1J0ov");

const $24a3efb1cf8e29fc$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $bHD89.ANALYTICS_BRIDGE_CHANNEL));
};
const $24a3efb1cf8e29fc$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $24a3efb1cf8e29fc$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};
module.exports["fireAnalytics"] = $24a3efb1cf8e29fc$export$34ac71ce24cddec2;
module.exports["fireUIAnalytics"] = $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94;
module.exports["fireTrackAnalytics"] = $24a3efb1cf8e29fc$export$13990ad4625571ed;
module.exports["fireOperationalAnalytics"] = $24a3efb1cf8e29fc$export$79f423cc3fd39762;

});

parcelRegister("bHD89", function(module, exports) {
const $f220a889fcad0dca$export$f636b5b56f1d624a = 'Screen';
const $f220a889fcad0dca$export$9d2de6eebf7462b5 = 'Drawer';
const $f220a889fcad0dca$export$1171103ea9083ffa = 'Modal';
const $f220a889fcad0dca$export$cae2783c9279926 = 'InlineDialog';
const $f220a889fcad0dca$export$d1123261ca8831d2 = 'Dropdown';
const $f220a889fcad0dca$export$a1562d08625f5d7e = 'UI';
const $f220a889fcad0dca$export$947dac6c72b26f81 = 'TRACK';
const $f220a889fcad0dca$export$f1d537d508d2945a = 'SCREEN';
const $f220a889fcad0dca$export$12346a674644c156 = 'OPERATIONAL';
const $f220a889fcad0dca$export$2ceccf177fae277c = 'analyticsBridge';
module.exports["MODAL"] = $f220a889fcad0dca$export$1171103ea9083ffa;
module.exports["UI_EVENT_TYPE"] = $f220a889fcad0dca$export$a1562d08625f5d7e;
module.exports["TRACK_EVENT_TYPE"] = $f220a889fcad0dca$export$947dac6c72b26f81;
module.exports["SCREEN_EVENT_TYPE"] = $f220a889fcad0dca$export$f1d537d508d2945a;
module.exports["OPERATIONAL_EVENT_TYPE"] = $f220a889fcad0dca$export$12346a674644c156;
module.exports["ANALYTICS_BRIDGE_CHANNEL"] = $f220a889fcad0dca$export$2ceccf177fae277c;

});

parcelRegister("1J0ov", function(module, exports) {
const $9c601e99598456fc$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $9c601e99598456fc$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $9c601e99598456fc$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $9c601e99598456fc$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $9c601e99598456fc$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $9c601e99598456fc$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};
module.exports["getImperativeAnalyticsDataFromArguments"] = $9c601e99598456fc$export$e6baab532ef8c6bf;

});

parcelRegister("liF9q", function(module, exports) {
module.exports = new URL("error.5fbc7fe9.png", import.meta.url).toString();

});

parcelRegister("4KAVh", function(module, exports) {
// Error messages
const $2ad7ca53e97d3c24$export$bdb28edf034fd38 = 'Jira GIC Anywhere - Iframe Source character limit exceeded';
const $2ad7ca53e97d3c24$export$b342b407e829290 = 'jiraEmbedIssueCreateInit';
const $2ad7ca53e97d3c24$export$fa02f6b8f65042dd = 'jiraEmbedIssueCreateReady';
const $2ad7ca53e97d3c24$export$8679ecb6b6b13aa9 = 'jiraEmbedIssueCreateSuccess';
const $2ad7ca53e97d3c24$export$c1caf9536ed579cc = 'jiraEmbedIssueCreateAppFailed';
const $2ad7ca53e97d3c24$export$a402043ad8e6699 = 'jiraEmbedIssueCreateClose';
module.exports["ERROR_IFRAME_SOURCE_CHAR_LIMIT_EXCEEDED"] = $2ad7ca53e97d3c24$export$bdb28edf034fd38;
module.exports["JIRA_EMBED_ISSUE_CREATE_INIT"] = $2ad7ca53e97d3c24$export$b342b407e829290;
module.exports["JIRA_EMBED_ISSUE_CREATE_READY"] = $2ad7ca53e97d3c24$export$fa02f6b8f65042dd;
module.exports["JIRA_EMBED_ISSUE_CREATE_SUCCESS"] = $2ad7ca53e97d3c24$export$8679ecb6b6b13aa9;
module.exports["JIRA_EMBED_ISSUE_CREATE_FAILURE"] = $2ad7ca53e97d3c24$export$c1caf9536ed579cc;
module.exports["JIRA_EMBED_ISSUE_CREATE_CLOSE"] = $2ad7ca53e97d3c24$export$a402043ad8e6699;

});

parcelRegister("0XxK1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $a9sR2 = parcelRequire("a9sR2");


var $kDuN4 = parcelRequire("kDuN4");


var $dh538 = parcelRequire("dh538");


var $bHD89 = parcelRequire("bHD89");

var $hzZxz = parcelRequire("hzZxz");


var $4KAVh = parcelRequire("4KAVh");

const $5588f1d8fd0b9255$var$analyticsClientInfo = {
    env: 'prod',
    product: 'jira'
};
const $5588f1d8fd0b9255$var$LIGHT_MODE = 'light';
const $5588f1d8fd0b9255$var$DARK_MODE = 'dark';
const $5588f1d8fd0b9255$var$AUTO = 'auto';
const $5588f1d8fd0b9255$var$AVAILABLE_SITES_PATH = '/gateway/api/available-sites';
const $5588f1d8fd0b9255$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/available-sites';
const $5588f1d8fd0b9255$export$a31dd10290664cf6 = 2048;
const $5588f1d8fd0b9255$export$584bd4ae64a8d7e2 = ({ colorMode: colorMode = $5588f1d8fd0b9255$var$AUTO, domainName: domainName = '', overrideCloudId: overrideCloudId, params: params, onFailure: onFailure, displaySitePicker: displaySitePicker, disableProjectDropdown: disableProjectDropdown, displayOnlyRequiredFields: displayOnlyRequiredFields })=>{
    const iframeParams = new URLSearchParams(params);
    iframeParams.append('postMessageInit', '1');
    if (displaySitePicker === false) iframeParams.append('displaySitePicker', 'false');
    if (disableProjectDropdown) iframeParams.append('disableProjectDropdown', 'true');
    if (displayOnlyRequiredFields) iframeParams.append('displayOnlyRequiredFields', 'true');
    if (colorMode) iframeParams.append('themeMode', colorMode);
    if (overrideCloudId) iframeParams.append('overrideCloudId', overrideCloudId);
    /**
	 * We want to use the postMessageInit param to instruct the Jira embed iframe
	 * to wait before mounting Issue Create.
	 * It will send a message back to us when it's ready to receive the init message
	 */ const srcUrl = `${domainName}/jira/issues/create/embed?${iframeParams}`;
    if (srcUrl.length > $5588f1d8fd0b9255$export$a31dd10290664cf6) onFailure?.(new Error((0, $4KAVh.ERROR_IFRAME_SOURCE_CHAR_LIMIT_EXCEEDED)));
    return srcUrl;
};
const $5588f1d8fd0b9255$export$61874183278c256e = [
    'jira-software.ondemand',
    'jira-core.ondemand',
    'jira-servicedesk.ondemand',
    'jira-product-discovery'
];
async function $5588f1d8fd0b9255$export$5e195155111b6846(baseUrlForAvailableSites) {
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: $5588f1d8fd0b9255$export$61874183278c256e
        })
    };
    const base = baseUrlForAvailableSites ? baseUrlForAvailableSites.replace(/\/$/, '') : '';
    const availableSitesPath = (0, $dh538.fg)('issue_create_modal_site_picker_api_unit_compliant') ? $5588f1d8fd0b9255$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH : $5588f1d8fd0b9255$var$AVAILABLE_SITES_PATH;
    const response = await fetch(`${base}${availableSitesPath}`, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
const $5588f1d8fd0b9255$export$1b581a2ec13e37f1 = (props)=>{
    const analyticsClient = (0, $42omo.useRef)(new (0, $a9sR2.default)($5588f1d8fd0b9255$var$analyticsClientInfo, {}));
    const sendEvent = (0, $42omo.useCallback)((event)=>{
        const { type: type, payload: payload } = event;
        switch(type){
            case 0, $bHD89.UI_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendUIEvent(payload);
                break;
            case 0, $bHD89.TRACK_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendTrackEvent(payload);
                break;
            case 0, $bHD89.OPERATIONAL_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendOperationalEvent(payload);
                break;
            case 0, $bHD89.SCREEN_EVENT_TYPE:
                analyticsClient.current.sendScreenEvent(payload.name, null, payload.attributes);
                break;
            default:
                break;
        }
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kDuN4.default), {
        channel: (0, $bHD89.ANALYTICS_BRIDGE_CHANNEL),
        onEvent: (event)=>sendEvent((0, $hzZxz.extractAWCDataFromEvent)(event)),
        children: props.children
    });
};
const $5588f1d8fd0b9255$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    if (!(0, $dh538.fg)('jira_ai_fix_aiwc_duplicated_analytics')) return func;
    const debounced = (...args)=>{
        const later = ()=>{
            timeout = undefined;
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
    debounced.cancel = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
};
module.exports["getIframeSrc"] = $5588f1d8fd0b9255$export$584bd4ae64a8d7e2;
module.exports["getAvailableJiraSites"] = $5588f1d8fd0b9255$export$5e195155111b6846;
module.exports["AnalyticsProvider"] = $5588f1d8fd0b9255$export$1b581a2ec13e37f1;
module.exports["debounce"] = $5588f1d8fd0b9255$export$61fc7d43ac8f84b0;

});

parcelRegister("hzZxz", function(module, exports) {

var $e7URT = parcelRequire("e7URT");


var $1j3sF = parcelRequire("1j3sF");


var $bHD89 = parcelRequire("bHD89");


var $01od0 = parcelRequire("01od0");

const $50a1a1624abaf5e4$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $01od0.getAnalyticsType)(castedEvent);
    const attributes = (0, $01od0.getAttributes)(castedEvent);
    const source = (0, $01od0.getSource)(castedEvent);
    const actionSubject = (0, $01od0.getActionSubject)(castedEvent);
    if (analyticsType === (0, $bHD89.SCREEN_EVENT_TYPE)) return {
        type: (0, $bHD89.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $bHD89.UI_EVENT_TYPE:
        case 0, $bHD89.TRACK_EVENT_TYPE:
        case 0, $bHD89.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $01od0.getAction)(castedEvent);
                const actionSubjectId = (0, $01od0.getActionSubjectId)(castedEvent);
                const containerId = (0, $01od0.getContainerId)(castedEvent);
                const containerType = (0, $01od0.getContainerType)(castedEvent);
                const objectId = (0, $01od0.getObjectId)(castedEvent);
                const objectType = (0, $01od0.getObjectType)(castedEvent);
                const tags = (0, $01od0.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};
module.exports["extractAWCDataFromEvent"] = $50a1a1624abaf5e4$export$1c850cf68c053906;

});

parcelRegister("01od0", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $e7URT = parcelRequire("e7URT");


var $apAFY = parcelRequire("apAFY");


var $lgmus = parcelRequire("lgmus");


var $1j3sF = parcelRequire("1j3sF");


var $da6ky = parcelRequire("da6ky");

const $4b9739432bab74fb$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $4b9739432bab74fb$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $4b9739432bab74fb$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $4b9739432bab74fb$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $4b9739432bab74fb$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))));
};
const $4b9739432bab74fb$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'source').filter(Boolean));
const $4b9739432bab74fb$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $4b9739432bab74fb$export$6ca3170acb89054 = (event)=>event.payload.action;
const $4b9739432bab74fb$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $4b9739432bab74fb$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'containerId').filter(Boolean));
const $4b9739432bab74fb$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'containerType').filter(Boolean));
const $4b9739432bab74fb$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'objectId').filter(Boolean));
const $4b9739432bab74fb$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'objectType').filter(Boolean));
const $4b9739432bab74fb$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))((0, (/*@__PURE__*/$parcel$interopDefault($5qOzM)))($4b9739432bab74fb$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
module.exports["getAnalyticsType"] = $4b9739432bab74fb$export$a3569ac53b82a914;
module.exports["getAttributes"] = $4b9739432bab74fb$export$fe94072fee8a6976;
module.exports["getSource"] = $4b9739432bab74fb$export$dd2b6e807fb37ba3;
module.exports["getActionSubject"] = $4b9739432bab74fb$export$6f40cdf6d42c018d;
module.exports["getAction"] = $4b9739432bab74fb$export$6ca3170acb89054;
module.exports["getActionSubjectId"] = $4b9739432bab74fb$export$b6f8db3ad0711b02;
module.exports["getContainerId"] = $4b9739432bab74fb$export$7c8178cc9001d237;
module.exports["getContainerType"] = $4b9739432bab74fb$export$acc6f3e19803b3dc;
module.exports["getObjectId"] = $4b9739432bab74fb$export$fa986b91291934c7;
module.exports["getObjectType"] = $4b9739432bab74fb$export$11cc42aebef2ef3a;
module.exports["getTags"] = $4b9739432bab74fb$export$af63d7414243dad3;

});

parcelRegister("g5o3i", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $0XxK1 = parcelRequire("0XxK1");

const $5909ab59f28be203$export$930bddfd3ad23bb7 = ({ preferredCloudId: preferredCloudId, onComplete: onComplete, onError: onError })=>{
    (0, $fBMbo.di)((0, $0XxK1.getAvailableJiraSites));
    const [domain, setDomain] = (0, $42omo.useState)(undefined);
    const [availableSites, setAvailableSites] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        const fetchAvailableJiraSites = async ()=>{
            setLoading(true);
            try {
                const { sites: sites } = await (0, $0XxK1.getAvailableJiraSites)();
                setAvailableSites(sites ?? []);
                const computedDomain = (sites.find((site)=>site.cloudId === preferredCloudId) ?? sites[0])?.url ?? '';
                setDomain(computedDomain);
                onComplete?.({
                    domain: computedDomain,
                    availableSites: sites
                });
            } catch (e) {
                onError && onError(e);
                setError(e.message);
            } finally{
                setLoading(false);
            }
        };
        fetchAvailableJiraSites();
    }, [
        preferredCloudId,
        onComplete,
        onError
    ]);
    return {
        domain: domain,
        availableSites: availableSites,
        loading: loading,
        error: error
    };
};
const $5909ab59f28be203$export$7872bb66f9195035 = ({ onComplete: onComplete, onError: onError, baseUrlForAvailableSites: baseUrlForAvailableSites })=>{
    (0, $fBMbo.di)((0, $0XxK1.getAvailableJiraSites));
    const [availableSites, setAvailableSites] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const hasMount = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasMount.current) return;
        setLoading(true);
        const fetchAvailableJiraSites = async ()=>{
            try {
                const { sites: sites } = await (0, $0XxK1.getAvailableJiraSites)(baseUrlForAvailableSites);
                setAvailableSites(sites ?? []);
                onComplete?.({
                    availableSites: sites
                });
            } catch (e) {
                onError && onError(e);
                setError(e.message);
            } finally{
                setLoading(false);
            }
        };
        fetchAvailableJiraSites();
        hasMount.current = true;
    }, [
        baseUrlForAvailableSites,
        onComplete,
        onError
    ]);
    return {
        availableSites: availableSites,
        loading: loading,
        error: error
    };
};
const $5909ab59f28be203$export$60b2cad7400d36b3 = ({ sites: sites, preferredCloudId: preferredCloudId })=>{
    const domain = (sites.find((site)=>site.cloudId === preferredCloudId) ?? sites[0])?.url ?? '';
    return {
        domain: domain
    };
};
const $5909ab59f28be203$export$48ca77029c1208c2 = ({ cloudId: cloudId, overrideCloudId: overrideCloudId, baseUrlForAvailableSites: baseUrlForAvailableSites })=>{
    const { availableSites: availableSites, loading: loading, error: error } = $5909ab59f28be203$export$7872bb66f9195035({
        baseUrlForAvailableSites: baseUrlForAvailableSites
    });
    const { domain: domainName } = $5909ab59f28be203$export$60b2cad7400d36b3({
        sites: availableSites,
        preferredCloudId: cloudId
    });
    const { domain: isOverrideSiteAvailable } = $5909ab59f28be203$export$60b2cad7400d36b3({
        sites: availableSites,
        preferredCloudId: overrideCloudId
    });
    if (error) throw new Error('Failed to fetch available sites');
    return loading ? {
        availableSites: [],
        domainName: undefined,
        isOverrideSiteAvailable: undefined
    } : {
        availableSites: availableSites,
        domainName: domainName,
        isOverrideSiteAvailable: isOverrideSiteAvailable
    };
};
module.exports["useGetFirstAvailableSiteDomain"] = $5909ab59f28be203$export$930bddfd3ad23bb7;
module.exports["useGetDomainAndAvailableSites"] = $5909ab59f28be203$export$48ca77029c1208c2;

});

parcelRegister("7u9UW", function(module, exports) {
const $f25a4ef78ed97248$export$7bd623b29ec8e1eb = 7000; // 7s timeout, typical GIC load is ~3s
const $f25a4ef78ed97248$export$6dfc55fc5e2544ae = 188;
const $f25a4ef78ed97248$export$85d8afb0902718e2 = 250;
module.exports["DEFAULT_TIMEOUT"] = $f25a4ef78ed97248$export$7bd623b29ec8e1eb;
module.exports["MAX_ERROR_IMAGE_WIDTH"] = $f25a4ef78ed97248$export$6dfc55fc5e2544ae;
module.exports["MAX_ERROR_IMAGE_HEIGHT"] = $f25a4ef78ed97248$export$85d8afb0902718e2;

});

parcelRegister("4SDuV", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $2b8c8c7153d4d991$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    iFrameLoading: {
        id: "jira-ai.gic-anywhere.iframe-loading",
        defaultMessage: "Loading work item details, this might take a few seconds."
    },
    iFrameSlowLoading: {
        id: "jira-ai.gic-anywhere.iframe-slow-loading",
        defaultMessage: "It is taking longer than usual to load your work item.{br}Give it a few more seconds, or try again later."
    },
    openInJiraButton: {
        id: "jira-ai.gic-anywhere.open-in-jira-button",
        defaultMessage: "Log in to Jira to view"
    },
    errorHeader: {
        id: "jira-ai.gic-anywhere.error-header",
        defaultMessage: "Something's gone wrong"
    },
    errorBody: {
        id: "jira-ai.gic-anywhere.error-body",
        defaultMessage: "Try opening this in Jira. If the problem persists, please contact Atlassian support."
    }
});
module.exports["messages"] = $2b8c8c7153d4d991$export$defe85febe8b728c;

});

parcelRegister("9K9na", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $auNCB = parcelRequire("auNCB");

const $c2473cc34e5c9c56$export$8ecee5edd581c23a = (flags)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return (0, $42omo.useCallback)((payload, flagType, message)=>{
        flags.showFlag({
            type: flagType,
            title: formatMessage(message, {
                issueKey: payload?.issueKey,
                issueSummary: payload?.summary,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
                        href: payload?.link,
                        target: "_blank"
                    }, chunks)
            }),
            close: 'auto'
        });
    }, [
        flags,
        formatMessage
    ]);
};
module.exports["useTriggerFlagIssueCreated"] = $c2473cc34e5c9c56$export$8ecee5edd581c23a;

});

parcelRegister("kcLnq", function(module, exports) {
/* ConfluenceAiIssueCreate.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $caRYB = parcelRequire("caRYB");

var $2FFuS = parcelRequire("2FFuS");


var $gdv5Z = parcelRequire("gdv5Z");


var $fwDOR = parcelRequire("fwDOR");


var $7pE6f = parcelRequire("7pE6f");

var $4sbrV = parcelRequire("4sbrV");


var $2Rith = parcelRequire("2Rith");


var $cfwlu = parcelRequire("cfwlu");


var $cLj22 = parcelRequire("cLj22");


var $1ASvP = parcelRequire("1ASvP");


var $kfViO = parcelRequire("kfViO");


var $9BGuq = parcelRequire("9BGuq");


var $arvSz = parcelRequire("arvSz");


var $gqQUx = parcelRequire("gqQUx");

const $0aab3fed706492b4$export$7bd623b29ec8e1eb = 7000; // 7s timeout, typical GIC load is ~3s
const $0aab3fed706492b4$var$style = {
    aiIssueCreateWrapper: "_16jlkb7n"
};
const $0aab3fed706492b4$export$fbdfb25d3cad524a = ({ confluencePage: confluencePage, highlightedText: highlightedText, isReady: isReady, overrideXProduct: overrideXProduct, handleAiSuggestedFieldsStateChange: handleAiSuggestedFieldsStateChange })=>{
    const streamingHookProps = (0, $arvSz.useStreamingHookProps)({
        confluencePage: confluencePage,
        highlightedText: highlightedText,
        overrideXProduct: overrideXProduct
    });
    const { suggestions: suggestions, isStreaming: isStreaming, error: error, onAIResultView: onAIResultView } = (0, $cLj22.useAiWorkSuggestionStreaming)(streamingHookProps);
    // Transform streaming suggestions to match the expected fields format
    const transformedFields = (0, $42omo.useMemo)(()=>{
        // Only use suggestions when streaming is complete
        if (isStreaming) return {
            summary: '',
            description: ''
        };
        return {
            summary: suggestions?.[0]?.field_values?.Summary || '',
            description: suggestions?.[0]?.field_values?.Description || ''
        };
    }, [
        suggestions,
        isStreaming
    ]);
    const getServiceState = ()=>{
        if (error) return 'error';
        if (isStreaming) return 'loading';
        return 'idle';
    };
    (0, $42omo.useEffect)(()=>{
        if (error) handleAiSuggestedFieldsStateChange({
            state: 'error',
            error: $0aab3fed706492b4$export$98d40c5fd23ef716(error)
        });
        else if (isStreaming) handleAiSuggestedFieldsStateChange({
            state: 'loading',
            fields: transformedFields
        });
        else handleAiSuggestedFieldsStateChange({
            state: 'idle',
            fields: transformedFields
        });
    }, [
        error,
        isStreaming,
        transformedFields,
        handleAiSuggestedFieldsStateChange
    ]);
    if (!isReady) return {
        state: 'loading',
        fields: null
    };
    return {
        state: getServiceState(),
        fields: transformedFields,
        onAIResultView: onAIResultView,
        suggestions: suggestions,
        isStreaming: isStreaming
    };
};
const $0aab3fed706492b4$export$98d40c5fd23ef716 = (error)=>{
    return {
        message_template: error?.message?.message_template,
        statusCode: error?.message?.status_code,
        message: error?.message?.content,
        content: error?.message?.content
    };
};
const $0aab3fed706492b4$export$a653b3ac3dd182f4 = ({ cloudId: cloudId, overrideCloudIdForSitePicker: overrideCloudIdForSitePicker, overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker, contentType: contentType, pageId: pageId, pageMode: pageMode, highlightedTextAdf: highlightedTextAdf, timeoutMs: timeoutMs = $0aab3fed706492b4$export$7bd623b29ec8e1eb, onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, testId: testId, onStateChange: onStateChange, consumer: consumer, setAiAnalyticsContext: setAiAnalyticsContext, aIIssueCreationEnablement: aIIssueCreationEnablement })=>{
    const { fireTrack: fireTrack } = (0, $9BGuq.useAiIssueCreateAnalytics)();
    const [confluencePage, setConfluencePage] = (0, $42omo.useState)('');
    const [idMap, setIdMap] = (0, $42omo.useState)({});
    const [isIdMapReady, setIsIdMapReady] = (0, $42omo.useState)(false);
    // Custom handler to wrap multiple onStateChange calls
    const handleStateChange = (0, $42omo.useCallback)((source, state)=>{
        // trigger error if any state is errored
        if (onFailure && state?.state === 'error') {
            onFailure(state.error, state.message_template);
            fireTrack(`${source} failed`);
        }
        if (onStateChange) {
            onStateChange(state.state, source);
            fireTrack(`${source} updated`, {
                state: state.state
            });
        }
    }, [
        onFailure,
        onStateChange,
        fireTrack
    ]);
    const handleConfluencePageStateChange = (0, $42omo.useCallback)((newState)=>handleStateChange('aiIssueCreateGetConfluencePageState', newState), [
        handleStateChange
    ]);
    // Fetch confluence page
    const { state: confluencePageState, confluencePage: confluencePageAsAdf } = (0, $gqQUx.useGetConfluencePage)({
        cloudId: cloudId,
        contentType: contentType,
        experienceId: 'ai-issue-create-confluence-single',
        pageId: pageId,
        pageMode: pageMode,
        onStateChange: handleConfluencePageStateChange
    });
    // Effect to transform confluence page ADF to markdown after fetching
    (0, $42omo.useEffect)(()=>{
        if (confluencePageState === 'idle' && confluencePageAsAdf) {
            const { markdown: markdown, idMap: newIdMap } = (0, $7pE6f.adfToMarkdownPlus)(confluencePageAsAdf, {
                markdownPlusUseNextLayoutSection: true
            });
            setAiAnalyticsContext && setAiAnalyticsContext('pageContextLength', (0, $kfViO.countADFChars)(confluencePageAsAdf));
            setConfluencePage(markdown);
            setIdMap(newIdMap);
            setIsIdMapReady(true); // Set idMap ready when it's set
        }
    }, [
        confluencePageState,
        confluencePageAsAdf,
        setAiAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $0aab3fed706492b4$var$style.aiIssueCreateWrapper,
        testId: testId ?? 'default-confluence-ai-issue-create'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "ai-issue-create.adf-to-markdown-plus",
        hold: confluencePageState !== 'loading' && !isIdMapReady
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "ai-issue-create.confluence-page-loading",
        hold: confluencePageState === 'loading'
    }), isIdMapReady ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0aab3fed706492b4$export$9da61cee87ff5851, {
        handleStateChange: handleStateChange,
        confluencePageState: confluencePageState,
        confluencePage: confluencePage,
        idMap: idMap,
        useService: $0aab3fed706492b4$export$fbdfb25d3cad524a,
        cloudId: cloudId,
        contentType: contentType,
        pageId: pageId,
        pageMode: pageMode,
        highlightedTextAdf: highlightedTextAdf,
        timeoutMs: timeoutMs,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onTimeout: onTimeout,
        onStateChange: onStateChange,
        consumer: consumer,
        setAiAnalyticsContext: setAiAnalyticsContext,
        aIIssueCreationEnablement: aIIssueCreationEnablement,
        overrideCloudIdForSitePicker: overrideCloudIdForSitePicker,
        overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker
    }) : null));
};
const $0aab3fed706492b4$export$9da61cee87ff5851 = ({ cloudId: cloudId, overrideCloudIdForSitePicker: overrideCloudIdForSitePicker, highlightedTextAdf: highlightedTextAdf = (0, $caRYB.doc)((0, $2FFuS.paragraph)('')), timeoutMs: timeoutMs = $0aab3fed706492b4$export$7bd623b29ec8e1eb, onInit: onInit, onSuccess: onSuccess, idMap: idMap, confluencePage: confluencePage, confluencePageState: confluencePageState, handleStateChange: handleStateChange, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, consumer: consumer, setAiAnalyticsContext: setAiAnalyticsContext, useService: useService, aIIssueCreationEnablement: aIIssueCreationEnablement, overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker })=>{
    const handleAiSuggestedFieldsStateChange = (0, $42omo.useCallback)((newState)=>handleStateChange('aiIssueCreateFetchSuggestedFieldsState', newState), [
        handleStateChange
    ]);
    const highlightedText = (0, $42omo.useMemo)(()=>{
        return (0, $7pE6f.adfToMarkdownPlus)(highlightedTextAdf, {
            markdownPlusUseNextLayoutSection: true
        }, idMap).markdown;
    }, [
        highlightedTextAdf,
        idMap
    ]);
    // Only call SuggestionComponent when highlightedText is ready
    const { state: suggestedFieldsState, fields: fields, onAIResultView: onAIResultView, isStreaming: isStreaming, suggestions: suggestions } = useService({
        cloudId: cloudId,
        confluencePage: confluencePage,
        highlightedText: highlightedText,
        handleAiSuggestedFieldsStateChange: handleAiSuggestedFieldsStateChange,
        isReady: highlightedText !== '',
        overrideXProduct: aIIssueCreationEnablement?.enablement
    });
    const isLoading = confluencePageState === 'loading' || suggestedFieldsState === 'loading';
    const isErrored = confluencePageState === 'error' || suggestedFieldsState === 'error';
    const isPayloadReady = confluencePageState === 'idle' && suggestedFieldsState === 'idle';
    const descriptionADF = (0, $42omo.useMemo)(()=>{
        if (isLoading || isErrored || !fields?.description) return (0, $caRYB.doc)((0, $2FFuS.paragraph)(''));
        return (0, $4sbrV.markdownPlusToAdf)({
            markdown: fields.description,
            idMap: idMap
        });
    }, [
        isLoading,
        isErrored,
        fields,
        idMap
    ]);
    (0, $42omo.useEffect)(()=>{
        setAiAnalyticsContext && setAiAnalyticsContext('aiResponseLength', (0, $kfViO.countADFChars)(descriptionADF));
    }, [
        descriptionADF,
        setAiAnalyticsContext
    ]);
    (0, $42omo.useEffect)(()=>{
        setAiAnalyticsContext && setAiAnalyticsContext('highlightedTextLength', (0, $kfViO.countADFChars)(highlightedTextAdf));
    }, [
        highlightedTextAdf,
        setAiAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "ai-issue-create.suggested-fields-loading",
        hold: suggestedFieldsState === 'loading'
    }), !isErrored && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfwlu.GicAnywhere), {
        cloudId: cloudId,
        summary: fields?.summary || '',
        descriptionAdf: descriptionADF,
        timeoutMs: timeoutMs,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onTimeout: onTimeout,
        consumer: consumer,
        isPayloadReady: isPayloadReady,
        overrideCloudId: overrideCloudIdForSitePicker,
        projectId: overrideProjectIdForProjectPicker
    }), !isStreaming && Boolean(suggestions?.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1ASvP.MountEvent), {
        onMount: onAIResultView
    }));
};
const $0aab3fed706492b4$export$56bb8aafd9fb646e = ({ cloudId: cloudId, contentType: contentType, pageId: pageId, pageMode: pageMode, overrideCloudIdForSitePicker: overrideCloudIdForSitePicker, overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker, highlightedTextAdf: highlightedTextAdf = (0, $caRYB.doc)((0, $2FFuS.paragraph)('')), timeoutMs: timeoutMs = $0aab3fed706492b4$export$7bd623b29ec8e1eb, onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, testId: testId, onStateChange: onStateChange, consumer: consumer = 'confluenceHighlight', setAiAnalyticsContext: setAiAnalyticsContext, aIIssueCreationEnablement: aIIssueCreationEnablement })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: {
            // Required configruation
            product: 'confluence',
            subproduct: 'jira',
            aiFeatureName: 'confluenceAiWorkCreation',
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            // Optional configuration
            source: 'confluenceHighlightIssueCreate',
            skipAISessionValidation: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0aab3fed706492b4$export$a653b3ac3dd182f4, {
        cloudId: cloudId,
        contentType: contentType,
        pageId: pageId,
        pageMode: pageMode,
        highlightedTextAdf: highlightedTextAdf,
        timeoutMs: timeoutMs,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onTimeout: onTimeout,
        testId: testId,
        onStateChange: onStateChange,
        consumer: consumer,
        overrideCloudIdForSitePicker: overrideCloudIdForSitePicker,
        overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker,
        setAiAnalyticsContext: setAiAnalyticsContext,
        aIIssueCreationEnablement: aIIssueCreationEnablement
    }));
};
module.exports["ConfluenceAiIssueCreate"] = $0aab3fed706492b4$export$56bb8aafd9fb646e;

});

parcelRegister("caRYB", function(module, exports) {
const $d9000e0d99d20134$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });
module.exports["doc"] = $d9000e0d99d20134$export$2a111da947c407d2;

});

parcelRegister("cLj22", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fYQcF = parcelRequire("fYQcF");


var $j1XmT = parcelRequire("j1XmT");


var $9ZanP = parcelRequire("9ZanP");

const $4a7a945da70edda5$export$5fe969aa6ed2f349 = ({ analyticsConfig: analyticsConfig, issueConfig: issueConfig, onCompletion: onCompletion, customExperienceTracker: customExperienceTracker, requestHeaderOverrides: requestHeaderOverrides, ...streamingProps })=>{
    // **** setup ****
    const { updateSuggestions: updateSuggestions, suggestions: suggestions, fullSuggestionList: fullSuggestionList, reset: resetSuggestion, hideSuggestion: hideSuggestion } = (0, $j1XmT.useSuggestions)();
    const [error, setError] = (0, $42omo.useState)();
    const analyticsContext = {
        ...analyticsConfig,
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        isAIFeature: 1
    };
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction, trackAIResultError: trackAIResultError, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)(analyticsContext);
    const onStreamError = (0, $42omo.useCallback)((error)=>{
        customExperienceTracker?.fail?.(error);
        trackAIResultError({
            aiErrorCode: error.message.status_code,
            aiErrorMessage: error.message.message_template
        }, !(0, $9ZanP.isWhitelistedSLOError)(error) ? {
            attributes: {
                aiResultErrorCategory: 'server-error'
            }
        } : undefined);
        setError(error);
    }, [
        trackAIResultError,
        customExperienceTracker
    ]);
    const onStreamInit = (0, $42omo.useCallback)((retryCount)=>{
        resetSuggestion();
        setError(undefined);
        customExperienceTracker?.start?.();
        trackAIInteractionInit({
            attributes: {
                totalRetries: retryCount
            }
        });
    }, [
        trackAIInteractionInit,
        resetSuggestion,
        customExperienceTracker
    ]);
    const onStreamAborted = (0, $42omo.useCallback)(()=>{
        customExperienceTracker?.abort?.();
        trackAIInteractionDismiss();
    }, [
        trackAIInteractionDismiss,
        customExperienceTracker
    ]);
    const { isStreaming: isStreaming, isInitiating: isInitiatingStreaming, reset: resetStreaming, refetch: refetch, getIsStreamingRef: getIsStreamingRef } = (0, $9ZanP.useStreaming)({
        analyticsContext: analyticsContext,
        streamingProps: streamingProps,
        issueConfig: issueConfig,
        requestHeaderOverrides: requestHeaderOverrides,
        onSuggestionStreamUpdated: updateSuggestions,
        onStreamError: onStreamError,
        onStreamInit: onStreamInit,
        onStreamAbortedByInitNew: onStreamAborted
    });
    // **** callbacks ****
    const terminate = (0, $42omo.useCallback)(()=>{
        if (isStreaming) // stream aborted by terminating service
        onStreamAborted();
        resetSuggestion();
        resetStreaming();
        setError(undefined);
    // leave for side effect to invoke `onCompletion`
    }, [
        onStreamAborted,
        isStreaming,
        resetSuggestion,
        resetStreaming
    ]);
    const hideSuggestions = (0, $42omo.useCallback)((ids, action)=>{
        if (action) ids.forEach((_)=>trackAIResultAction(action));
        ids.forEach((id)=>hideSuggestion(id));
    }, [
        trackAIResultAction,
        hideSuggestion
    ]);
    // **** event handlers ****
    const onAIResultView = (0, $42omo.useCallback)(()=>{
        customExperienceTracker?.succeed?.();
        trackAIResultView({
            attributes: {
                suggestedNumber: suggestions.length
            }
        });
    }, [
        trackAIResultView,
        suggestions.length,
        customExperienceTracker
    ]);
    // **** side effects ****
    (0, $42omo.useEffect)(()=>{
        // work is considered done, if
        // - no suggestions are available
        // - no error exist
        // - no streaming is active
        if (!isInitiatingStreaming && !isStreaming && !error && suggestions.length === 0) onCompletion();
    }, [
        error,
        suggestions,
        isStreaming,
        onCompletion,
        isInitiatingStreaming
    ]);
    // report aborted on unmount if still streaming
    (0, $42omo.useEffect)(()=>()=>{
            if (getIsStreamingRef.current()) onStreamAborted();
        }, [
        onStreamAborted,
        getIsStreamingRef
    ]);
    return {
        suggestions: suggestions,
        fullSuggestionList: fullSuggestionList,
        isStreaming: isStreaming,
        error: error,
        onAIResultView: // event handlers
        onAIResultView,
        onAIFeedbackSubmit: trackAIFeedbackSubmit,
        refetch: // callbacks
        refetch,
        hideSuggestions: hideSuggestions,
        terminate: terminate
    };
};
module.exports["useAiWorkSuggestionStreaming"] = $4a7a945da70edda5$export$5fe969aa6ed2f349;

});

parcelRegister("j1XmT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");

const $6264d1e35540fc04$export$378f0080e636ce63 = ()=>{
    const [hiddenSuggestionIds, setHiddenSuggestionIds] = (0, $42omo.useState)(new Set());
    const [fullSuggestionList, setFullSuggestionList] = (0, $42omo.useState)([]);
    // used to avoid calling `setSuggestions` too many times during streaming - could break devtools
    const streamedIssueCount = (0, $42omo.useRef)(0);
    const suggestions = (0, $42omo.useMemo)(()=>fullSuggestionList.filter((suggestion)=>!hiddenSuggestionIds.has(suggestion.localId)), [
        fullSuggestionList,
        hiddenSuggestionIds
    ]);
    const hideSuggestion = (0, $42omo.useCallback)((id)=>{
        setHiddenSuggestionIds((set)=>new Set(set).add(id));
    }, []);
    const reset = (0, $42omo.useCallback)(()=>{
        setFullSuggestionList([]);
        setHiddenSuggestionIds(new Set());
        streamedIssueCount.current = 0;
    }, []);
    const addSuggestion = (0, $42omo.useCallback)((suggestion)=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        setFullSuggestionList((suggestions)=>[
                ...suggestions,
                {
                    ...suggestion,
                    localId: (0, $dQl1W.v4)()
                }
            ]);
    }, []);
    const updateSuggestions = (0, $42omo.useCallback)((newSuggestionList)=>{
        while(streamedIssueCount.current < newSuggestionList.length){
            addSuggestion(newSuggestionList[streamedIssueCount.current]);
            streamedIssueCount.current++;
        }
    }, [
        addSuggestion
    ]);
    return {
        fullSuggestionList: fullSuggestionList,
        suggestions: suggestions,
        hideSuggestion: hideSuggestion,
        updateSuggestions: updateSuggestions,
        reset: reset
    };
};
module.exports["useSuggestions"] = $6264d1e35540fc04$export$378f0080e636ce63;

});

parcelRegister("9ZanP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $93WqG = parcelRequire("93WqG");

var $kAaxz = parcelRequire("kAaxz");

var $d3UlG = parcelRequire("d3UlG");

const $9518a1ee412d4b03$export$4177e9b841c72d1e = (error)=>{
    const whitelistedSLOErrors = [
        (0, $93WqG.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS,
        (0, $93WqG.ConvoAIErrorMessage).NOT_ENOUGH_CONTENT_ERROR,
        (0, $93WqG.ConvoAIErrorMessage).ANSWER_UNAVAILABLE_FOR_CONTENT,
        (0, $93WqG.ConvoAIErrorMessage).NOT_FOUND,
        (0, $93WqG.ConvoAIErrorMessage).BAD_REQUEST
    ];
    return whitelistedSLOErrors.includes(error.message.message_template);
};
const $9518a1ee412d4b03$var$TIMEOUT_DELAY = 60000;
const $9518a1ee412d4b03$export$734279c1f8caf5b9 = ({ analyticsContext: analyticsContext, issueConfig: issueConfig, streamingProps: streamingProps, requestHeaderOverrides: requestHeaderOverrides, onSuggestionStreamUpdated: onSuggestionStreamUpdated, onStreamError: onStreamError, onStreamInit: onStreamInit, onStreamAbortedByInitNew: onStreamAbortedByInitNew })=>{
    const [isStreaming, setIsStreaming] = (0, $42omo.useState)(false);
    const [isInitiating, setIsInitiating] = (0, $42omo.useState)(true);
    const prevResponseState = (0, $42omo.useRef)(null);
    const streamCountRef = (0, $42omo.useRef)(0);
    const getIsStreamingRef = (0, $42omo.useRef)(()=>false);
    getIsStreamingRef.current = ()=>isStreaming;
    const streamingRequest = (0, $42omo.useMemo)(()=>({
            ai_feature_input: {
                ...streamingProps.input,
                suggested_issues_config: issueConfig
            }
        }), [
        issueConfig,
        streamingProps.input
    ]);
    const streamingConfig = (0, $42omo.useMemo)(()=>({
            apiPath: `v2/ai-feature/jira/issue/source-type/${streamingProps.sourceType}/suggestions/stream`,
            enablePartialJson: true,
            enableFollowUp: false,
            headers: {
                'x-experience-id': streamingProps.experienceId,
                'x-product': requestHeaderOverrides?.overrideXProduct ?? analyticsContext.product,
                'x-channel-id': streamingProps?.channelId
            },
            skip: streamingProps.skip ?? false,
            timeoutDelay: $9518a1ee412d4b03$var$TIMEOUT_DELAY
        }), [
        analyticsContext.product,
        streamingProps.experienceId,
        streamingProps.sourceType,
        requestHeaderOverrides?.overrideXProduct,
        streamingProps?.channelId,
        streamingProps?.skip
    ]);
    const onStateChange = (0, $42omo.useCallback)((state)=>{
        if (prevResponseState.current !== state.responseState) {
            if (state.responseState === (0, $kAaxz.ConvoAIResponseState).Initialization) {
                if (isStreaming) onStreamAbortedByInitNew();
                onStreamInit(streamCountRef.current); // argument is "retryCount", so before self-increment
                setIsStreaming(true);
                if (isInitiating) setIsInitiating(false);
                streamCountRef.current++;
            }
            prevResponseState.current = state.responseState;
        }
        if (!isStreaming) return;
        switch(state.responseState){
            case (0, $kAaxz.ConvoAIResponseState).AnswerPart:
                {
                    const fullyFormedIssues = state.content?.suggested_issues?.slice?.(0, -1) ?? [];
                    onSuggestionStreamUpdated(fullyFormedIssues);
                    break;
                }
            case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
                setIsStreaming(false);
                // builds kept failing when using ConvoAIErrorMessage.SOME_ERROR
                // fixed by typecasting as ConvoAIErrorMessage
                if (!('suggested_issues' in state.content)) {
                    // if there are are no suggested_issues, it's potentially due to bad json
                    // log as an unexpected error as we are unsure if this pops up in ConvoAI
                    onStreamError({
                        type: 'ERROR',
                        message: {
                            message_template: 'UNEXPECTED',
                            content: `Bad JSON: ${Object.keys(state.content).toString()}`,
                            status_code: 500
                        }
                    });
                    break;
                }
                if (state.content?.suggested_issues.length === 0) {
                    // no child issue information came back from the LLM
                    // we clasify this as a not engouh information error
                    onStreamError({
                        type: 'ERROR',
                        message: {
                            message_template: 'NOT_ENOUGH_CONTENT_ERROR',
                            content: 'Not enough content to generate work items from Confluence link.',
                            status_code: 400
                        }
                    });
                    break;
                }
                onSuggestionStreamUpdated(state.content?.suggested_issues);
                break;
            case (0, $kAaxz.ConvoAIResponseState).Error:
                setIsStreaming(false);
                onStreamError(state.error);
                break;
            default:
        }
    }, [
        onSuggestionStreamUpdated,
        onStreamError,
        isStreaming,
        isInitiating,
        onStreamAbortedByInitNew,
        onStreamInit
    ]);
    const [_, refetch] = (0, $d3UlG.useConvoAIStreaming)(streamingRequest, streamingConfig, onStateChange);
    const reset = (0, $42omo.useCallback)(()=>{
        setIsStreaming(false);
    }, []);
    return {
        isInitiating: isInitiating,
        isStreaming: isStreaming,
        getIsStreamingRef: getIsStreamingRef,
        refetch: refetch,
        reset: reset
    };
};
module.exports["isWhitelistedSLOError"] = $9518a1ee412d4b03$export$4177e9b841c72d1e;
module.exports["useStreaming"] = $9518a1ee412d4b03$export$734279c1f8caf5b9;

});

parcelRegister("d3UlG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5NXxU = parcelRequire("5NXxU");


var $iIEgX = parcelRequire("iIEgX");

var $6yCLg = parcelRequire("6yCLg");


var $cPtvM = parcelRequire("cPtvM");


var $kAaxz = parcelRequire("kAaxz");

function $d7c3e272b37735b1$export$d6e2ae1e990d7e71(request, config, onStateChange) {
    const refetchId = (0, $42omo.useRef)(crypto.randomUUID());
    const [state, setState] = (0, $6yCLg.useStatefulObservableEffect)((0, $cPtvM.convoAIStreamingEffect), (0, $kAaxz.getDefaultConvoAIStreamingState)(), [
        request,
        config,
        refetchId.current
    ]);
    (0, $iIEgX.useObservableEffect)((input$)=>input$.pipe((0, $5NXxU.tap)(([nextState, onStateChangeCalback])=>onStateChangeCalback?.(nextState))), [
        state,
        onStateChange
    ]);
    const refetch = (0, $42omo.useCallback)(()=>{
        refetchId.current = crypto.randomUUID();
        setState({
            inputs: [
                request,
                config,
                refetchId.current
            ],
            state: (0, $kAaxz.getDefaultConvoAIStreamingState)()
        });
    }, [
        request,
        config,
        setState
    ]);
    return [
        state,
        refetch
    ];
}
module.exports["useConvoAIStreaming"] = $d7c3e272b37735b1$export$d6e2ae1e990d7e71;

});

parcelRegister("6yCLg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXpOY = parcelRequire("aXpOY");

function $725c584c19c66c44$export$916f6bbdfa1987d0(onObservableInit, initialState, inputs) {
    const [state, callback] = (0, $aXpOY.useStatefulObservableLazyEffect)(onObservableInit, initialState);
    (0, $42omo.useEffect)(()=>{
        callback({
            inputs: inputs,
            state: initialState
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return [
        state,
        callback
    ];
}
module.exports["useStatefulObservableEffect"] = $725c584c19c66c44$export$916f6bbdfa1987d0;

});

parcelRegister("1ASvP", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1DWH0 = parcelRequire("1DWH0");

class $648b40683bbc8a0b$var$MountEventComponent extends (0, $42omo.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $648b40683bbc8a0b$var$MountEventComponentWithHOC = (0, $1DWH0.default)()($648b40683bbc8a0b$var$MountEventComponent);
const $648b40683bbc8a0b$export$2c6963927dbc68f1 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)($648b40683bbc8a0b$var$MountEventComponentWithHOC, {
        ...props
    });
module.exports["MountEvent"] = $648b40683bbc8a0b$export$2c6963927dbc68f1;

});

parcelRegister("kfViO", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

const $1716be1127a34d35$export$2d424d3a12064a81 = (value)=>{
    if (!value) return 0;
    let chars = 0;
    (0, $6jPem.traverse)(value, {
        text: (node)=>{
            if (node.text) chars += node.text.length;
        },
        emoji: ({ attrs: attrs })=>{
            if (attrs?.text) chars += attrs.text.length;
        },
        paragraph: ()=>{
            chars += 1;
        },
        mention: ({ attrs: attrs })=>{
            if (attrs?.text) chars += attrs.text.length;
        }
    });
    // Subtract 1 due to doc node
    return chars ? chars - 1 : chars;
};
module.exports["countADFChars"] = $1716be1127a34d35$export$2d424d3a12064a81;

});

parcelRegister("9BGuq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1mDVg = parcelRequire("1mDVg");

const $8d6a0c1fb56b5ffe$export$f6ae4d64a1b3fc6e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    return (0, $42omo.useMemo)(()=>({
            fireTrack: (name, attributes)=>{
                const source = 'aiIssueCreate';
                const [actionSubject, action] = name.split(' ');
                const eventAttributes = {
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission,
                    ...attributes
                };
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: source,
                        action: action,
                        actionSubject: actionSubject,
                        attributes: eventAttributes
                    }
                }).fire();
            }
        }), [
        createAnalyticsEvent,
        pageMode,
        hasEditPermission
    ]);
};
module.exports["useAiIssueCreateAnalytics"] = $8d6a0c1fb56b5ffe$export$f6ae4d64a1b3fc6e;

});

parcelRegister("arvSz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $93WqG = parcelRequire("93WqG");


var $9BGuq = parcelRequire("9BGuq");

const $5dcd84d787afdff9$export$4177e9b841c72d1e = (error)=>{
    const whitelistedSLOErrors = [
        (0, $93WqG.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS,
        (0, $93WqG.ConvoAIErrorMessage).NOT_ENOUGH_CONTENT_ERROR,
        (0, $93WqG.ConvoAIErrorMessage).ANSWER_UNAVAILABLE_FOR_CONTENT,
        (0, $93WqG.ConvoAIErrorMessage).NOT_FOUND,
        (0, $93WqG.ConvoAIErrorMessage).BAD_REQUEST
    ];
    return whitelistedSLOErrors.includes(error.message.message_template);
};
const $5dcd84d787afdff9$export$8b355f71d361cab7 = ({ confluencePage: confluencePage, highlightedText: highlightedText, overrideXProduct: overrideXProduct })=>{
    const { fireTrack: fireTrack } = (0, $9BGuq.useAiIssueCreateAnalytics)();
    const { locale: locale } = (0, $8C5kA.default)();
    return (0, $42omo.useMemo)(()=>({
            analyticsConfig: {
                aiFeatureName: 'confluenceAiWorkCreationConvoAI',
                product: 'confluence',
                subproduct: 'jira',
                useDefaultGASv3EventSchema: false,
                source: 'highlightActionsMenu',
                skipAISessionValidation: true
            },
            requestHeaderOverrides: {
                overrideXProduct: overrideXProduct
            },
            issueConfig: {
                max_issues: 1,
                suggested_issue_field_types: [
                    {
                        issue_type: 'Task',
                        fields: [
                            {
                                field_name: 'Summary',
                                field_type: 'Short-Text'
                            },
                            {
                                field_name: 'Description',
                                field_type: 'Paragraph'
                            }
                        ]
                    }
                ]
            },
            experienceId: 'ai-issue-create-confluence-single',
            sourceType: 'documentation',
            input: {
                source: 'CONFLUENCE',
                context: {
                    primary_text: confluencePage,
                    highlighted_text: highlightedText
                },
                locale: locale
            },
            onCompletion: ()=>{},
            customExperienceTracker: {
                start: ()=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest start', {
                        locale: locale
                    });
                },
                succeed: ()=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest complete', {
                        haveResult: true,
                        locale: locale
                    });
                },
                fail: (convoAIStreamError)=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest fail', {
                        errorMessage: convoAIStreamError?.message?.content,
                        statusCode: convoAIStreamError?.message?.status_code,
                        message_template: convoAIStreamError?.message?.message_template,
                        shouldSlo: !$5dcd84d787afdff9$export$4177e9b841c72d1e(convoAIStreamError),
                        locale: locale
                    });
                },
                abort: ()=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest abort', {
                        locale: locale
                    });
                }
            }
        }), [
        confluencePage,
        highlightedText,
        overrideXProduct,
        fireTrack,
        locale
    ]);
};
module.exports["useStreamingHookProps"] = $5dcd84d787afdff9$export$8b355f71d361cab7;

});

parcelRegister("gqQUx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iY4nM = parcelRequire("iY4nM");


var $kDhla = parcelRequire("kDhla");


var $1mDVg = parcelRequire("1mDVg");


var $9BGuq = parcelRequire("9BGuq");


var $iT03Z = parcelRequire("iT03Z");

const $1a87d70e3d885601$var$getConfluencePageAdf = async ({ cloudId: cloudId, contentType: contentType, pageId: pageId, pageMode: pageMode = (0, $1mDVg.PageMode).VIEW, signal: signal, product: product = 'confluence', experienceId: experienceId = 'ai-issue-create', editorApi: editorApi })=>{
    if (pageMode === (0, $1mDVg.PageMode).EDIT || pageMode === (0, $1mDVg.PageMode).LIVE_EDIT || pageMode === (0, $1mDVg.PageMode).LIVE_VIEW) return (0, $iT03Z.getConfluencePageAdfFromEditor)(editorApi);
    return (0, $iY4nM.getConfluencePageAdfFromApi)({
        cloudId: cloudId,
        contentType: contentType,
        pageId: pageId,
        signal: signal,
        product: product,
        experienceId: experienceId
    });
};
const $1a87d70e3d885601$export$e411256f856842c7 = ({ cloudId: cloudId, contentType: contentType, experienceId: experienceId, pageId: pageId, pageMode: pageMode, product: product, onStateChange: onStateChange })=>{
    const { fireTrack: fireTrack } = (0, $9BGuq.useAiIssueCreateAnalytics)();
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const [fetchState, setGetConfluencePageState] = (0, $42omo.useState)({
        state: 'loading',
        confluencePage: undefined
    });
    const abortControllerRef = (0, $42omo.useRef)(null);
    const fetchConfluencePage = (0, $42omo.useCallback)(async ()=>{
        if (abortControllerRef.current) abortControllerRef.current.abort();
        abortControllerRef.current = new AbortController();
        const currentAbortController = abortControllerRef.current;
        setGetConfluencePageState({
            state: 'loading',
            confluencePage: undefined
        });
        try {
            fireTrack('issueCreateSidePanelGetConfluencePageRequest start');
            const confluencePage = await $1a87d70e3d885601$var$getConfluencePageAdf({
                cloudId: cloudId,
                contentType: contentType,
                experienceId: experienceId,
                pageId: pageId,
                pageMode: pageMode,
                product: product,
                signal: currentAbortController.signal,
                editorApi: fullPageEditorPresetAPI
            });
            fireTrack('issueCreateSidePanelGetConfluencePageRequest complete', {
                haveResult: !!confluencePage
            });
            if (currentAbortController.signal.aborted) {
                setGetConfluencePageState({
                    state: 'abort',
                    confluencePage: undefined
                });
                return;
            }
            if (confluencePage) setGetConfluencePageState({
                state: 'idle',
                confluencePage: confluencePage
            });
            else setGetConfluencePageState({
                state: 'error',
                error: new Error('Error on getting confluence page as ADF'),
                confluencePage: undefined
            });
        } catch (e) {
            fireTrack('issueCreateSidePanelGetConfluencePageRequest fail', {
                message: e.message
            });
            if (currentAbortController.signal.aborted) {
                setGetConfluencePageState({
                    state: 'abort',
                    confluencePage: undefined
                });
                return;
            }
            setGetConfluencePageState({
                state: 'error',
                error: e,
                confluencePage: undefined
            });
        }
    }, [
        cloudId,
        contentType,
        experienceId,
        pageId,
        product,
        setGetConfluencePageState,
        fireTrack,
        pageMode,
        fullPageEditorPresetAPI
    ]);
    (0, $42omo.useEffect)(()=>{
        fetchConfluencePage();
        return ()=>{
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, [
        fetchConfluencePage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (onStateChange) onStateChange(fetchState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchState.state,
        fetchState.confluencePage,
        onStateChange
    ]);
    return {
        ...fetchState,
        trigger: fetchConfluencePage
    };
};
module.exports["useGetConfluencePage"] = $1a87d70e3d885601$export$e411256f856842c7;

});

parcelRegister("iY4nM", function(module, exports) {
const $98a3645fea1a46e5$export$9ae725848caea23f = async ({ cloudId: cloudId, contentType: contentType, pageId: pageId, signal: signal, product: product = 'confluence', experienceId: experienceId = 'ai-issue-create' })=>{
    try {
        const endpointAPI = contentType === 'blogpost' ? `blogposts` : `pages`;
        const response = await fetch(`/wiki/api/v2/${endpointAPI}/${pageId}?body-format=atlas_doc_format`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'X-Experience-Id': experienceId,
                'X-Product': product,
                'Atl-CloudId': cloudId
            },
            credentials: 'include',
            signal: signal
        });
        const data = await response.json();
        if (!data.body?.atlas_doc_format) throw new Error('No atlas doc format found in confluence page');
        return JSON.parse(data.body.atlas_doc_format.value);
    } catch (error) {
        throw new Error('Request to get confluence page failed');
    }
};
module.exports["getConfluencePageAdfFromApi"] = $98a3645fea1a46e5$export$9ae725848caea23f;

});

parcelRegister("iT03Z", function(module, exports) {
const $12940757b485c304$export$21b6e0bf8d10cc8 = async (editorApi)=>{
    return new Promise((resolve)=>{
        editorApi?.core.actions.requestDocument((doc)=>{
            if (!doc) throw new Error('No adf document found in editor');
            resolve(doc);
        });
    });
};
module.exports["getConfluencePageAdfFromEditor"] = $12940757b485c304$export$21b6e0bf8d10cc8;

});

parcelRegister("bZC8A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2Nwuj = parcelRequire("2Nwuj");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $3E5yu = parcelRequire("3E5yu");

const $d2ef8f1ef1cac15d$export$844cd257c85281a = (error)=>{
    let errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefresh : (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescription;
    let errorMessageValues;
    let hideTryAgain = false;
    if (error.message_template !== undefined && [
        'ACCEPTABLE_USE_VIOLATIONS',
        'ACCEPTABLE_USE_EVALUATION_EXCEPTION'
    ].includes(error.message_template)) {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).ethicalViolationErrorDescriptionIssueTermRefresh : (0, $3E5yu.messages).ethicalViolationErrorDescription;
        errorMessageValues = {
            link: (anchorText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: "https://www.atlassian.com/legal/acceptable-use-policy",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, anchorText)
        };
        hideTryAgain = true;
        return {
            errorMessage: errorMessage,
            errorMessageValues: errorMessageValues,
            hideTryAgain: hideTryAgain
        };
    }
    if (error.message_template === 'RATE_LIMIT') {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).rateLimitErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).rateLimitErrorDescriptionIssueTermRefresh : (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).rateLimitErrorDescriptionRebrandToRovo : (0, $3E5yu.messages).rateLimitErrorDescription;
        errorMessageValues = {
            link: (anchorText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, anchorText)
        };
        hideTryAgain = true;
        return {
            errorMessage: errorMessage,
            errorMessageValues: errorMessageValues,
            hideTryAgain: hideTryAgain
        };
    }
    if (error.message_template === 'FE_REQUEST_EXCEEDING_TOKEN_LENGTH') {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).exceedingTokenLimitDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).exceedingTokenLimitDescriptionIssueTermRefresh : (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).exceedingTokenLimitDescriptionRebrandToRovo : (0, $3E5yu.messages).exceedingTokenLimitDescription;
        hideTryAgain = true;
        return {
            errorMessage: errorMessage,
            errorMessageValues: errorMessageValues,
            hideTryAgain: hideTryAgain
        };
    }
    if (error.message_template === 'NO_ANSWER_SUGGESTED_ISSUES') {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).noAnswerSuggestedIssuesIssueTermRefresh : (0, $3E5yu.messages).noAnswerSuggestedIssues;
        hideTryAgain = true;
    }
    return {
        errorMessage: errorMessage,
        errorMessageValues: errorMessageValues,
        hideTryAgain: hideTryAgain
    };
};
module.exports["handleAiIssueCreateError"] = $d2ef8f1ef1cac15d$export$844cd257c85281a;

});

parcelRegister("jE0Gg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3E5yu = parcelRequire("3E5yu");


var $1mDVg = parcelRequire("1mDVg");

const $3fdc1d9372d96a0e$export$2ac688f17b22f89f = ()=>{
    const [{ currentSiteSelection: currentSiteSelection }, { setCurrentSiteSelection: setCurrentSiteSelection, setCurrentProjectSelection: setCurrentProjectSelection, setAiIssueCreationEnablement: setAiIssueCreationEnablement, setIsGicIframeReady: setIsGicIframeReady }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    (0, $42omo.useEffect)(()=>{
        const messageHandler = (message)=>{
            const eventName = message?.data?.event;
            const payload = message.data?.payload;
            switch(eventName){
                // Recieve message from GIC anywhere component for current site selection since it is in an inner iframe.
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_SITE_SELECTED:
                    if (payload?.selectedCloudId && payload?.selectedCloudId !== '') {
                        // reset currentProjectSelection on site change since projects are tied per site
                        if (currentSiteSelection && payload?.selectedCloudId !== currentSiteSelection) setCurrentProjectSelection(undefined);
                        setCurrentSiteSelection(payload.selectedCloudId);
                    }
                    break;
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_PROJECT_SELECTED:
                    const project = {
                        selectedProjectType: payload?.selectedProjectType,
                        selectedProjectId: payload?.selectedProjectId,
                        selectedProjectKey: payload?.selectedProjectKey
                    };
                    setCurrentProjectSelection(project);
                    break;
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_READY:
                    setIsGicIframeReady(true);
                    break;
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_CLOSE:
                    setIsGicIframeReady(false);
                    break;
                default:
            }
        };
        window.addEventListener('message', messageHandler);
        return ()=>{
            window.removeEventListener('message', messageHandler);
        };
    }, [
        setCurrentSiteSelection,
        setCurrentProjectSelection,
        currentSiteSelection,
        setAiIssueCreationEnablement,
        setIsGicIframeReady
    ]);
};
module.exports["useMessageListener"] = $3fdc1d9372d96a0e$export$2ac688f17b22f89f;

});

parcelRegister("hib1D", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $74xbC = parcelRequire("74xbC");


var $1mDVg = parcelRequire("1mDVg");


var $hiixe = parcelRequire("hiixe");

const $c160271417b290c8$var$footerContainerStyle = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.sunken'
});
const $c160271417b290c8$var$SINGLE_ISSUE_CREATE_FEEDBACK_ENTRYPOINT_ID = '5dd040e8-af22-4ef1-803e-136f659a1092';
const $c160271417b290c8$export$5e203ab8a2a5043e = ()=>{
    const [{ contentId: contentId }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $c160271417b290c8$var$footerContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $74xbC.IssueCreateAiFeedback), {
        contentId: contentId,
        entrypointId: $c160271417b290c8$var$SINGLE_ISSUE_CREATE_FEEDBACK_ENTRYPOINT_ID
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiixe.AiSubFooter), null));
};
module.exports["IssueCreateSidePanelFooter"] = $c160271417b290c8$export$5e203ab8a2a5043e;

});

parcelRegister("6pbwW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $7hXDW = parcelRequire("7hXDW");


var $hmuev = parcelRequire("hmuev");


var $1qfLF = parcelRequire("1qfLF");


var $lAFHW = parcelRequire("lAFHW");


var $4WZFP = parcelRequire("4WZFP");


var $9wGTI = parcelRequire("9wGTI");


var $3E5yu = parcelRequire("3E5yu");

const $47081d53dba235a2$var$headerMessageStyle = (0, $ecnYn.xcss)({
    paddingInline: 'space.100',
    font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.025'
});
const $47081d53dba235a2$export$7b151ed3fccdded0 = ({ onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WZFP.SidePanelHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "medium",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
        size: "small",
        appearance: "brand"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $47081d53dba235a2$var$headerMessageStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelHeaderIssueTermRefresh : (0, $3E5yu.messages).sidePanelHeader)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: "close-icon",
                spacing: "none"
            }),
        appearance: "subtle",
        label: "close",
        onClick: ()=>onClose(),
        testId: "close-issue-create-panel-button"
    })));
};
module.exports["IssueCreateSidePanelHeader"] = $47081d53dba235a2$export$7b151ed3fccdded0;

});

parcelRegister("4WZFP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $72d7920b18bf3596$export$70e0922268f2e08b = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlock: "space.100",
            paddingInlineStart: "space.300",
            paddingInlineEnd: "space.150"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlock: "space.100",
        paddingInlineStart: "space.300",
        paddingInlineEnd: "space.150"
    }, children);
};
module.exports["SidePanelHeader"] = $72d7920b18bf3596$export$70e0922268f2e08b;

});

parcelRegister("jln20", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
} : ()=>(0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ children: children })=>{
    const [sidebars, setSidebars] = (0, $42omo.useState)([]);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    const contextValue = (0, $42omo.useMemo)(()=>$8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        }), [
        sidebars,
        triggerButtonRef,
        hideObjectSidebar,
        hidePreviewPanel,
        isPreviewPanelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleCloseGlobalSidebar = ()=>{
            setSidebars([]);
        };
        // Register the global window event when the component mounts
        window.addEventListener('closeGlobalSidebar', handleCloseGlobalSidebar);
        return ()=>{
            // Unregister the global window event when the component unmounts
            window.removeEventListener('closeGlobalSidebar', handleCloseGlobalSidebar);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
        value: contextValue
    }, children);
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("jAbYs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $g5gZt = parcelRequire("g5gZt");


var $4Hqhn = parcelRequire("4Hqhn");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $1qfLF = parcelRequire("1qfLF");


var $cnH0s = parcelRequire("cnH0s");


var $1pnTI = parcelRequire("1pnTI");


var $8rBRl = parcelRequire("8rBRl");

const $2bf805ca23bfc153$var$NotesItems = ({ handleAddToNoteClick: handleAddToNoteClick })=>{
    const { notesList: notesList } = (0, $8rBRl.useContextualNotesList)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
        id: "recent-notes"
    }, notesList?.map((note, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4Hqhn))), {
                label: ""
            }),
            key: index,
            onClick: ()=>handleAddToNoteClick(note.ari)
        }, note.label)));
};
const $2bf805ca23bfc153$export$9d2bcbf6df74548c = ()=>{
    const intl = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { handleCreateNoteClick: handleCreateNoteClick, handleAddToNoteClick: handleAddToNoteClick } = (0, $1pnTI.useContextualNoteCreation)({
        source: 'highlightActionsNotesButton'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        isOpen: isOpen,
        onOpenChange: (attrs)=>{
            setIsOpen(attrs.isOpen);
        },
        shouldRenderToParent: true,
        placement: "bottom-start",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ...triggerProps,
                ref: triggerProps.triggerRef,
                id: "highlight-actions-notes-button" // HighlightActions relies on this id to keep the menu open when this button is clicked
                ,
                "data-testId": "highlight-actions-notes-button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4Hqhn))),
                appearance: "subtle",
                isSelected: isOpen,
                label: intl.formatMessage((0, $cnH0s.sharedI18n).addToNote),
                isTooltipDisabled: false,
                testId: "highlight-actions-notes"
            }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2bf805ca23bfc153$var$NotesItems, {
        handleAddToNoteClick: handleAddToNoteClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
        id: "create-note",
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
            label: ""
        }),
        onClick: handleCreateNoteClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $cnH0s.sharedI18n).createNote))));
};
module.exports["HighlightActionsNotesButton"] = $2bf805ca23bfc153$export$9d2bcbf6df74548c;

});

parcelRegister("52EPl", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ccHMk = parcelRequire("ccHMk");


var $4JWgN = parcelRequire("4JWgN");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $6mkwk = parcelRequire("6mkwk");


var $loiTn = parcelRequire("loiTn");


var $7kzZ3 = parcelRequire("7kzZ3");


var $16xFS = parcelRequire("16xFS");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $dTk3A = parcelRequire("dTk3A");


var $4hF42 = parcelRequire("4hF42");


var $rTIrg = parcelRequire("rTIrg");


var $nVQ0B = parcelRequire("nVQ0B");


var $dhBFe = parcelRequire("dhBFe");


var $6XsRH = parcelRequire("6XsRH");

const $58fceacc21a186da$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $58fceacc21a186da$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $58fceacc21a186da$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${crossAxis}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-start`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $58fceacc21a186da$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $58fceacc21a186da$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $ee7An.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $dTk3A.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $6mkwk.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $42omo.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const id = (0, $6XsRH.default)();
    const itemRef = (0, $dhBFe.default)();
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    const fallbackPlacements = (0, $42omo.useMemo)(()=>$58fceacc21a186da$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $42omo.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        const isTabOrEscapeKey = $58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape');
        if (event !== null && !isTabOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape')) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $42omo.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $ee7An.default;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $4JWgN.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $4JWgN.KEY_SPACE) || e.key === (0, $4JWgN.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $4JWgN.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $nVQ0B.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 && (0, $dh538.fg)('platform-dst-nested-dropdown-menu-role') ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    ...bindFocus,
                    ref: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kzZ3))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4hF42.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $rTIrg.default), {
                        spacing: spacing,
                        maxHeight: $58fceacc21a186da$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
};
var $58fceacc21a186da$export$2e2bcd8739ae039 = $58fceacc21a186da$var$DropdownMenu;
module.exports["default"] = $58fceacc21a186da$export$2e2bcd8739ae039;

});

parcelRegister("6mkwk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b752f7534b8d0112$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $b752f7534b8d0112$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $42omo.useState)(getDefaultPropValue);
    const isControlledRef = (0, $42omo.useRef)(isControlled);
    (0, $42omo.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $42omo.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("loiTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $48d42f44838c1016$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $48d42f44838c1016$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $42omo.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $42omo.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("4hF42", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ee7An = parcelRequire("ee7An");


var $16xFS = parcelRequire("16xFS");


var $ijhQY = parcelRequire("ijhQY");

const $72bf3d2a48c5b2ec$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
/**
 * Focus manager logic.
 */ const $72bf3d2a48c5b2ec$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $42omo.useState)(0);
    const registerMode = (0, $42omo.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled } = (0, $16xFS.useLayering)();
    // Intentionally rebinding on each render
    (0, $42omo.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $42omo.useEffect)(()=>(0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $ijhQY.default)(menuItemRefs, isLayerDisabled, onClose)
        }), [
        isLayerDisabled,
        onClose
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($72bf3d2a48c5b2ec$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $72bf3d2a48c5b2ec$export$2e2bcd8739ae039 = $72bf3d2a48c5b2ec$var$FocusManager;
module.exports["FocusManagerContext"] = $72bf3d2a48c5b2ec$export$f18c1d4fc7326096;
module.exports["default"] = $72bf3d2a48c5b2ec$export$2e2bcd8739ae039;

});

parcelRegister("ijhQY", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb43cdb6098a100$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");


var $dh538 = parcelRequire("dh538");


var $6XsRH = parcelRequire("6XsRH");

const $8cb43cdb6098a100$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $8cb43cdb6098a100$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $dh538.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $6XsRH.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $8cb43cdb6098a100$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("6XsRH", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ec4c4b23458ff7f$export$2e2bcd8739ae039);

var $c0qxy = parcelRequire("c0qxy");

const $6ec4c4b23458ff7f$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $6ec4c4b23458ff7f$export$2e2bcd8739ae039() {
    const id = (0, $c0qxy.useId)();
    return `${$6ec4c4b23458ff7f$export$8a682ae47622dbb9}${id}`;
}
module.exports["PREFIX"] = $6ec4c4b23458ff7f$export$8a682ae47622dbb9;

});

parcelRegister("rTIrg", function(module, exports) {
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");


var $51SOF = parcelRequire("51SOF");


var $4AsMp = parcelRequire("4AsMp");


var $4hF42 = parcelRequire("4hF42");

const $b799d0b248957a2a$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k"
};
const $b799d0b248957a2a$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b799d0b248957a2a$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $b799d0b248957a2a$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $4hF42.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $51SOF.default)(menuItem) || (0, $4AsMp.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $42omo.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)($b799d0b248957a2a$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $b799d0b248957a2a$export$2e2bcd8739ae039 = $b799d0b248957a2a$var$MenuWrapper;
module.exports["default"] = $b799d0b248957a2a$export$2e2bcd8739ae039;

});

parcelRegister("51SOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e12d4b588eba9c45$export$2e2bcd8739ae039);
function $e12d4b588eba9c45$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("4AsMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b1db4379970383b$export$2e2bcd8739ae039);
function $9b1db4379970383b$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});

parcelRegister("nVQ0B", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $02b3fc6de2f24ae9$export$756f795847463ebd = /*#__PURE__*/ (0, $42omo.createContext)({
    setItemState: (0, $ee7An.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $ee7An.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $02b3fc6de2f24ae9$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $42omo.useRef)({});
    const context = (0, $42omo.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($02b3fc6de2f24ae9$export$756f795847463ebd.Provider, {
        value: context,
        children: children
    });
};
var $02b3fc6de2f24ae9$export$2e2bcd8739ae039 = $02b3fc6de2f24ae9$var$SelectionStore;
module.exports["SelectionStoreContext"] = $02b3fc6de2f24ae9$export$756f795847463ebd;
module.exports["default"] = $02b3fc6de2f24ae9$export$2e2bcd8739ae039;

});

parcelRegister("dhBFe", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $4hF42 = parcelRequire("4hF42");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $167560b2a39794c6$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $4hF42.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (hasPopup && (0, $dh538.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $167560b2a39794c6$export$2e2bcd8739ae039 = $167560b2a39794c6$var$useRegisterItemWithFocusManager;
module.exports["default"] = $167560b2a39794c6$export$2e2bcd8739ae039;

});

parcelRegister("dAYOx", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");


var $d77M1 = parcelRequire("d77M1");


var $cGtPE = parcelRequire("cGtPE");


var $dhBFe = parcelRequire("dhBFe");

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $cdf608dda9733d23$var$DropdownMenuItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $dhBFe.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $42omo.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d77M1.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
});
var $cdf608dda9733d23$export$2e2bcd8739ae039 = $cdf608dda9733d23$var$DropdownMenuItem;
module.exports["default"] = $cdf608dda9733d23$export$2e2bcd8739ae039;

});

parcelRegister("ahaN7", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $88990be4c91574c4$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $l998X.jsx)((0, $2UQGL.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $88990be4c91574c4$export$2e2bcd8739ae039 = $88990be4c91574c4$var$DropdownMenuItemGroup;
module.exports["default"] = $88990be4c91574c4$export$2e2bcd8739ae039;

});

parcelRegister("2UQGL", function(module, exports) {
/* group-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $19018ee1ec1e6aca$var$styles = {
    heading: "_11c81vhk _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $19018ee1ec1e6aca$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $19018ee1ec1e6aca$var$styles.heading,
        children: title
    });
var $19018ee1ec1e6aca$export$2e2bcd8739ae039 = $19018ee1ec1e6aca$var$GroupTitle;
module.exports["default"] = $19018ee1ec1e6aca$export$2e2bcd8739ae039;

});

parcelRegister("cnH0s", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $f9cacb8a3eba69cb$export$3f5b411add82afdd = (0, $cgtv4.defineMessages)({
    addToNote: {
        id: "note-contextual-create.add-to-note-button",
        defaultMessage: "Add to note"
    },
    createNote: {
        id: "note-contextual-create.create-note-button",
        defaultMessage: "Create a note"
    },
    untitledNote: {
        id: "note-contextual-create.untitled-note",
        defaultMessage: "Untitled note"
    }
});
module.exports["sharedI18n"] = $f9cacb8a3eba69cb$export$3f5b411add82afdd;

});

parcelRegister("1pnTI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $caRYB = parcelRequire("caRYB");


var $lKMTm = parcelRequire("lKMTm");


var $6JI2k = parcelRequire("6JI2k");


var $ep3mz = parcelRequire("ep3mz");


var $6abPE = parcelRequire("6abPE");


var $de2j9 = parcelRequire("de2j9");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $hmsJ3 = parcelRequire("hmsJ3");

const $e03e1c3cc4a945c4$var$handleErrors = (errors)=>{
    errors.forEach((e)=>{
        (0, $7Sm4c.markErrorAsHandled)(e);
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
    });
};
const $e03e1c3cc4a945c4$export$b430ac6aa93e4510 = ({ source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { createNote: createNote, updateNote: updateNote, notesData: notesData } = (0, $lKMTm.useNotesData)();
    const { setActiveNoteId: setActiveNoteId } = (0, $6JI2k.useNotesActions)();
    const [activeNoteId] = (0, $6JI2k.useActiveNoteId)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isEditRoute = (0, $de2j9.useIsEditorPage)();
    const [{ noteEditorApi: noteEditorApi }] = (0, $6JI2k.useNoteEditorApi)();
    const { makeContentLink: makeContentLink } = (0, $6abPE.useCopyContentLink)({
        pageMode: isEditRoute ? 'edit' : 'view',
        contentType: contentType ?? '',
        contentId: contentId ?? '',
        spaceKey: spaceKey ?? '',
        source: source
    });
    const pageUrl = makeContentLink() ?? '';
    // The two refs makes sure the hook tracks the latest state of the active note
    const noteEditorApiRef = (0, $42omo.useRef)();
    const activeNoteIdRef = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        noteEditorApiRef.current = noteEditorApi;
    }, [
        noteEditorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        activeNoteIdRef.current = activeNoteId;
    }, [
        activeNoteId
    ]);
    const fireAnalyticsEvent = (0, $42omo.useCallback)(({ actionSubjectId: actionSubjectId })=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: actionSubjectId
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const handleCreateNoteClick = (0, $42omo.useCallback)(async ()=>{
        fireAnalyticsEvent({
            actionSubjectId: 'createNote'
        });
        const activeSelection = window.getSelection();
        const highlightedText = activeSelection?.toString() || '';
        const { data: data, errors: errors } = await createNote({
            variables: {
                body: JSON.stringify((0, $hmsJ3.generateQuote)(highlightedText, pageUrl))
            }
        });
        const createNoteErrors = errors || data?.createNote?.errors;
        if (createNoteErrors) $e03e1c3cc4a945c4$var$handleErrors(createNoteErrors);
        setActiveNoteId(data?.createNote?.note?.ari);
    }, [
        fireAnalyticsEvent,
        createNote,
        setActiveNoteId,
        pageUrl
    ]);
    const getNoteFromEditor = async ()=>{
        return new Promise((resolve)=>{
            noteEditorApiRef.current?.core.actions.requestDocument((noteDoc)=>{
                if (!noteDoc) resolve((0, $caRYB.doc)());
                resolve(noteDoc);
            });
        });
    };
    const handleAddToNoteClick = (0, $42omo.useCallback)(async (noteAri)=>{
        fireAnalyticsEvent({
            actionSubjectId: 'addToNote'
        });
        const activeSelection = window.getSelection();
        const highlightedText = activeSelection?.toString() || '';
        const quote = (0, $hmsJ3.generateQuote)(highlightedText, pageUrl);
        // Get existing note data to merge with
        const existingNoteAdf = activeNoteIdRef.current === noteAri ? await getNoteFromEditor() : notesData.find((note)=>note.ari === noteAri)?.adf;
        // Parse existing note body and merge with quote
        const mergedContent = (0, $hmsJ3.appendAdf)({
            existingAdf: existingNoteAdf ?? (0, $caRYB.doc)(),
            newAdf: quote
        });
        if (activeNoteIdRef.current === noteAri) noteEditorApiRef.current?.core.actions.replaceDocument(mergedContent);
        const { data: data, errors: errors } = await updateNote({
            variables: {
                body: JSON.stringify(mergedContent),
                ari: noteAri
            }
        });
        const updateNoteErrors = errors || data?.updateNote?.errors;
        if (updateNoteErrors) $e03e1c3cc4a945c4$var$handleErrors(updateNoteErrors);
        if (activeNoteIdRef.current !== noteAri) setActiveNoteId(noteAri);
    }, [
        fireAnalyticsEvent,
        setActiveNoteId,
        updateNote,
        pageUrl,
        notesData,
        activeNoteIdRef
    ]);
    return {
        handleCreateNoteClick: handleCreateNoteClick,
        handleAddToNoteClick: handleAddToNoteClick
    };
};
module.exports["useContextualNoteCreation"] = $e03e1c3cc4a945c4$export$b430ac6aa93e4510;

});

parcelRegister("lKMTm", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");

var $xQxzY = parcelRequire("xQxzY");


var $91csT = parcelRequire("91csT");


var $1Z9af = parcelRequire("1Z9af");

const $12fcc847cd6ca878$var$EAP_MAX_LIMIT_OF_NOTES = 50;
const $12fcc847cd6ca878$var$getNotesQueryOptions = {
    query: (0, $1Z9af.GetNotesQuery),
    variables: {
        limit: $12fcc847cd6ca878$var$EAP_MAX_LIMIT_OF_NOTES
    }
};
const $12fcc847cd6ca878$export$30b78dd9f3a45abb = ()=>{
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useNotesDataNotesByCreatorQuery($limit:Int!){notesByCreator(input:{isAscending:true first:$limit}){nodes{ari title body bodyExcerpt createdAt updatedAt isPinned backgroundColor}}}`, {
        ...$12fcc847cd6ca878$var$getNotesQueryOptions,
        errorPolicy: 'all'
    });
    const transformDataToCacheFormat = (currentCache, dataToCache)=>{
        return {
            ...currentCache,
            notesByCreator: {
                ...currentCache.notesByCreator,
                nodes: dataToCache
            }
        };
    };
    const readCache = (cache)=>cache.readQuery($12fcc847cd6ca878$var$getNotesQueryOptions);
    const writeCache = (cache, notesByCreatorData)=>{
        cache.writeQuery({
            ...$12fcc847cd6ca878$var$getNotesQueryOptions,
            data: notesByCreatorData
        });
    };
    const [createNoteMutation, { loading: createNoteLoading }] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useNotesDataCreateNoteMutation($title:String$body:String){createNote(input:{title:$title body:$body}){errors{message}success note{ari title body bodyExcerpt collectionName isPinned thumbnailId labels createdAt updatedAt backgroundColor extraProps{key value}}}}`, {
        update: (cache, { data: responseData })=>{
            const cachedData = readCache(cache);
            if (cachedData?.notesByCreator?.nodes && responseData?.createNote?.note) {
                const newCacheData = [
                    responseData.createNote.note,
                    ...cachedData.notesByCreator.nodes
                ];
                writeCache(cache, transformDataToCacheFormat(cachedData, newCacheData));
            }
        }
    });
    const [updateNoteMutation] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useNotesDataUpdateNoteMutation($ari:String!$title:String$body:String$isPinned:Boolean=false$backgroundColor:String){updateNote(input:{title:$title body:$body backgroundColor:$backgroundColor metadata:{ari:$ari isPinned:$isPinned}}){errors{message extensions{errorType statusCode}}success note{ari title body bodyExcerpt collectionName isPinned updatedAt backgroundColor}}}`, {
        update: (cache, { data: responseData })=>{
            const cachedData = readCache(cache);
            if (cachedData?.notesByCreator?.nodes && responseData?.updateNote?.note?.ari) {
                // find old cache note index
                const cachedNoteIndex = cachedData.notesByCreator.nodes.findIndex((note)=>note?.ari === responseData.updateNote?.note?.ari);
                if (cachedNoteIndex >= 0) {
                    // if exist get the cache note data
                    const cachedNoteData = cachedData.notesByCreator.nodes[cachedNoteIndex];
                    if (cachedNoteData) {
                        // if data is not null, delete cache note and add updated note to top
                        const updatedNoteData = {
                            ...cachedNoteData,
                            ...responseData.updateNote?.note
                        }; // added null to keep types happy
                        const newCacheData = [
                            updatedNoteData
                        ].concat(cachedData.notesByCreator.nodes.slice(0, cachedNoteIndex), cachedData.notesByCreator.nodes.slice(cachedNoteIndex + 1));
                        writeCache(cache, transformDataToCacheFormat(cachedData, newCacheData));
                    }
                }
            }
        }
    });
    const [deleteNoteMutation, { error: deleteNoteError, loading: deleteNoteLoading, data: deleteNoteData }] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useNotesDataDeleteNoteMutation($ari:String!){deleteNote(input:{ari:$ari}){errors{message}success ari}}`, {
        update: (cache, { data: responseData })=>{
            const cachedData = readCache(cache);
            if (cachedData?.notesByCreator?.nodes && responseData?.deleteNote?.ari) {
                const newCacheData = cachedData.notesByCreator.nodes.filter((note)=>note?.ari !== responseData?.deleteNote?.ari);
                writeCache(cache, transformDataToCacheFormat(cachedData, newCacheData));
            }
        }
    });
    const all = data?.notesByCreator;
    const notes = (all?.nodes || []).map((note)=>(0, $91csT.transformToNote)(note || undefined));
    // This has been created just for the early access program since we are limiting users to only 50 notes.
    const userHasMaxNumberOfNotes = notes.length >= $12fcc847cd6ca878$var$EAP_MAX_LIMIT_OF_NOTES;
    return {
        notesData: notes,
        createNote: createNoteMutation,
        createNoteLoading: createNoteLoading,
        deleteNote: deleteNoteMutation,
        deleteNoteError: deleteNoteError,
        deleteNoteLoading: deleteNoteLoading,
        deleteNoteData: deleteNoteData,
        updateNote: updateNoteMutation,
        loading: loading,
        error: error,
        userHasMaxNumberOfNotes: userHasMaxNumberOfNotes
    };
};
module.exports["useNotesData"] = $12fcc847cd6ca878$export$30b78dd9f3a45abb;

});

parcelRegister("91csT", function(module, exports) {
const $77980f4c3c79dff6$export$c24f25c953d270b8 = (payload)=>{
    if (!payload) return {};
    const { body: body, ...noteData } = payload;
    let adf;
    // This try catch has been added temporarily because plaintext non-adf/json was added to the DB
    // TODO: remove once we sanitize all of those test entries
    try {
        adf = body ? JSON.parse(body) : undefined;
    } catch (e) {
        adf = undefined;
    }
    return {
        ...noteData,
        adf: adf
    };
};
module.exports["transformToNote"] = $77980f4c3c79dff6$export$c24f25c953d270b8;

});

parcelRegister("1Z9af", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $b216a6ab139869d9$export$34a99364d28fe306 = (0, $eSUdr.default)`query NotesByCreator($limit:Int!){notesByCreator(input:{isAscending:true first:$limit}){nodes{ari title body bodyExcerpt createdAt updatedAt isPinned backgroundColor}}}`;
module.exports["GetNotesQuery"] = $b216a6ab139869d9$export$34a99364d28fe306;

});

parcelRegister("6JI2k", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $3b74fcc841254653$var$notesInitialState = {
    activeNoteId: undefined
};
const $3b74fcc841254653$var$noteEditorApiInitialState = {
    noteEditorApi: undefined
};
const $3b74fcc841254653$var$notesActions = {
    setActiveNoteId: (activeNoteId)=>({ setState: setState })=>{
            setState({
                activeNoteId: activeNoteId
            });
        },
    resetActiveNoteId: ()=>({ setState: setState })=>{
            setState({
                activeNoteId: undefined
            });
        }
};
const $3b74fcc841254653$var$noteEditorApiActions = {
    setNoteEditorApi: (noteEditorApi)=>({ setState: setState })=>{
            setState({
                noteEditorApi: noteEditorApi
            });
        },
    resetNoteEditorApi: ()=>({ setState: setState })=>{
            setState($3b74fcc841254653$var$noteEditorApiInitialState);
        }
};
const $3b74fcc841254653$var$NotesStore = (0, $1P1Tu.createStore)({
    initialState: $3b74fcc841254653$var$notesInitialState,
    actions: $3b74fcc841254653$var$notesActions,
    name: 'NotesStore'
});
const $3b74fcc841254653$var$NoteEditorApiStore = (0, $1P1Tu.createStore)({
    initialState: $3b74fcc841254653$var$noteEditorApiInitialState,
    actions: $3b74fcc841254653$var$noteEditorApiActions,
    name: 'NoteEditorApiStore'
});
const $3b74fcc841254653$export$ecce9ae725432b7b = (0, $9zUhf.createActionsHook)($3b74fcc841254653$var$NotesStore);
const $3b74fcc841254653$var$selectActiveNoteId = (state)=>state.activeNoteId;
const $3b74fcc841254653$export$2e974306a61c660e = (0, $9zUhf.createHook)($3b74fcc841254653$var$NotesStore, {
    selector: $3b74fcc841254653$var$selectActiveNoteId
});
const $3b74fcc841254653$export$b2bc9c556f5ab60 = (0, $9zUhf.createHook)($3b74fcc841254653$var$NoteEditorApiStore);
const $3b74fcc841254653$export$510fc84c2883e9ba = (0, $9zUhf.createActionsHook)($3b74fcc841254653$var$NoteEditorApiStore);
module.exports["useNotesActions"] = $3b74fcc841254653$export$ecce9ae725432b7b;
module.exports["useActiveNoteId"] = $3b74fcc841254653$export$2e974306a61c660e;
module.exports["useNoteEditorApi"] = $3b74fcc841254653$export$b2bc9c556f5ab60;
module.exports["useNoteEditorApiActions"] = $3b74fcc841254653$export$510fc84c2883e9ba;

});

parcelRegister("hmsJ3", function(module, exports) {

var $aAj6E = parcelRequire("aAj6E");

var $caRYB = parcelRequire("caRYB");

var $5x0y1 = parcelRequire("5x0y1");

var $2FFuS = parcelRequire("2FFuS");

var $aoDcQ = parcelRequire("aoDcQ");

const $d709276985b010bc$var$processTextToParagraphs = (input)=>{
    return input.split('\n').map((section)=>!!section ? (0, $2FFuS.paragraph)((0, $aoDcQ.text)(section)) : (0, $2FFuS.paragraph)());
};
const $d709276985b010bc$var$convertUrlToInlineCardParagraph = (url)=>{
    return !!url ? (0, $2FFuS.paragraph)((0, $5x0y1.inlineCard)({
        url: url
    })) : (0, $2FFuS.paragraph)();
};
const $d709276985b010bc$export$75e366a7c667671f = (input, pageUrl)=>{
    return (0, $caRYB.doc)((0, $aAj6E.blockQuote)(...$d709276985b010bc$var$processTextToParagraphs(input), $d709276985b010bc$var$convertUrlToInlineCardParagraph(pageUrl)));
};
const $d709276985b010bc$export$a5e18aa7ab693c7a = ({ existingAdf: existingAdf, newAdf: newAdf })=>{
    // Get existing content from the existing adf
    const existingContent = existingAdf.content;
    // Get content from the new adf (excluding the doc wrapper)
    const newContent = newAdf.content;
    // Merge both content arrays
    return (0, $caRYB.doc)(...existingContent, ...newContent);
};
module.exports["generateQuote"] = $d709276985b010bc$export$75e366a7c667671f;
module.exports["appendAdf"] = $d709276985b010bc$export$a5e18aa7ab693c7a;

});

parcelRegister("aAj6E", function(module, exports) {
const $1f2b71b0315184bd$export$200dcd0a5903c968 = (...content)=>({
        type: 'blockquote',
        content: content
    });
module.exports["blockQuote"] = $1f2b71b0315184bd$export$200dcd0a5903c968;

});

parcelRegister("8rBRl", function(module, exports) {

var $8C5kA = parcelRequire("8C5kA");


var $lKMTm = parcelRequire("lKMTm");


var $6JI2k = parcelRequire("6JI2k");


var $aPZGK = parcelRequire("aPZGK");


var $cnH0s = parcelRequire("cnH0s");

const $efa62e48b6241011$var$MAX_NOTES_TO_SHOW = 5;
const $efa62e48b6241011$var$MAX_NOTE_LABEL_LENGTH = 20;
const $efa62e48b6241011$export$a0a2ac383499d7f9 = ()=>{
    const { notesData: notesData } = (0, $lKMTm.useNotesData)();
    const [activeNoteId] = (0, $6JI2k.useActiveNoteId)();
    const intl = (0, $8C5kA.default)();
    // MODES-7071 Add any linked notes to the list
    const slicedNotes = notesData?.slice(0, $efa62e48b6241011$var$MAX_NOTES_TO_SHOW) || [];
    const activeIndex = slicedNotes.findIndex((note)=>note.ari === activeNoteId);
    if (activeIndex > 0) {
        // If active note is in the list but not at the top, bump it to the top
        const [activeNote] = slicedNotes.splice(activeIndex, 1);
        slicedNotes.unshift(activeNote);
    } else if (activeIndex === -1 && activeNoteId) {
        // If active note is not in the list, try to find it in notesData and add it to the top
        const activeNote = notesData.find((note)=>note.ari === activeNoteId);
        if (activeNote) {
            slicedNotes.unshift(activeNote);
            // Remove last item to maintain MAX_NOTES_TO_SHOW
            if (slicedNotes.length > $efa62e48b6241011$var$MAX_NOTES_TO_SHOW) slicedNotes.pop();
        }
    }
    // Generate the notes items to be used in the dropdown menu, each note have ari and label
    const notesList = slicedNotes.map((note)=>({
            ari: note.ari,
            label: (()=>{
                const text = note?.title ? note.title : (()=>{
                    const extracted = (0, $aPZGK.extractAdfText)(note?.adf);
                    if (!extracted) return intl.formatMessage((0, $cnH0s.sharedI18n).untitledNote);
                    return extracted;
                })();
                return text.length > $efa62e48b6241011$var$MAX_NOTE_LABEL_LENGTH ? text.slice(0, $efa62e48b6241011$var$MAX_NOTE_LABEL_LENGTH - 1) + '...' : text;
            })()
        }));
    return {
        notesList: notesList
    };
};
module.exports["useContextualNotesList"] = $efa62e48b6241011$export$a0a2ac383499d7f9;

});

parcelRegister("aPZGK", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");

const $9cba950ac61e4fac$export$6b103b516a87812f = (adf)=>{
    /* Temporary way to get text from ADF in order to generate an excerpt before BE query is finished
	 * Also used for frontend filtering/search
	 * We want to get the text entries of any content nodes in the adf labelled with type: text
	 */ if (adf) return (0, $1A9t2.reduce)(adf, (currentValue, node)=>{
        if (node.type === 'text') return `${currentValue} ${node.text}`.trim(); // trim to ensure we remove the space from template string if empty node.text
        else return currentValue;
    }, '');
    return '';
};
const $9cba950ac61e4fac$export$1eb0427f7c98fb36 = (note)=>{
    if (note) {
        const noteHasContent = note.adf && note.adf.content && note.adf.content.length > 0;
        return !noteHasContent && !note.title;
    }
    return true;
};
module.exports["extractAdfText"] = $9cba950ac61e4fac$export$6b103b516a87812f;
module.exports["isNoteBlank"] = $9cba950ac61e4fac$export$1eb0427f7c98fb36;

});

parcelRegister("6W81y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $ccHMk = parcelRequire("ccHMk");


var $dAYOx = parcelRequire("dAYOx");


var $g5gZt = parcelRequire("g5gZt");


var $2qVkt = parcelRequire("2qVkt");


var $7ZcJJ = parcelRequire("7ZcJJ");


var $inPa6 = parcelRequire("inPa6");


var $1pSma = parcelRequire("1pSma");


var $iu6m9 = parcelRequire("iu6m9");


var $cHaKZ = parcelRequire("cHaKZ");

var $2GVu1 = parcelRequire("2GVu1");






var $fYQcF = parcelRequire("fYQcF");


var $jln20 = parcelRequire("jln20");


var $hq2Sz = parcelRequire("hq2Sz");


var $1mDVg = parcelRequire("1mDVg");


var $frJep = parcelRequire("frJep");


var $cSSgB = parcelRequire("cSSgB");


var $ai7NK = parcelRequire("ai7NK");


var $9wGTI = parcelRequire("9wGTI");


var $cAdj8 = parcelRequire("cAdj8");


var $4VJDS = parcelRequire("4VJDS");


var $6mKj3 = parcelRequire("6mKj3");


var $2W2Mk = parcelRequire("2W2Mk");


var $joYQz = parcelRequire("joYQz");

const $ae4b6329110effd0$export$67bda1dbd5f0074c = {
    SINGLE_ISSUE: 'SINGLE_ISSUE',
    MULTIPLE_ISSUE: 'MULTIPLE_ISSUE',
    AI_ISSUE: 'AI_ISSUE'
};
// Helper function to find the parent <table> element of a given node
const $ae4b6329110effd0$var$findParentTable = (node)=>{
    let currentNode = node;
    while(currentNode){
        if (currentNode.nodeType === Node.ELEMENT_NODE && currentNode.tagName === 'TABLE') return currentNode;
        currentNode = currentNode.parentNode;
    }
    return null;
};
// Use this helper function when we have the modernized bulk create ready.
const $ae4b6329110effd0$var$isMultiRowTableSelection = (selection)=>{
    if (!selection || selection.rangeCount === 0) return false;
    const range = selection.getRangeAt(0);
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;
    // Helper function to find the parent <tr> element of a given node
    const findParentTableRow = (node)=>{
        while(node){
            if (node.tagName === 'TR') return node;
            node = node.parentNode;
        }
        return null;
    };
    // Find the closest <tr> ancestor for both start and end of the selection
    const startRow = findParentTableRow(startContainer);
    const endRow = findParentTableRow(endContainer);
    if (!startRow || !endRow) return false;
    // If the start and end are not in the same row, it's a multi-row selection
    return startRow !== endRow;
};
/**
 * isTableSelection: returns true if the user highlights over only
 * table content.
 * @param selection
 * @returns {boolean}
 */ const $ae4b6329110effd0$var$isTableSelection = (selection)=>{
    if (!selection || selection.rangeCount === 0) return false;
    const range = selection.getRangeAt(0);
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;
    // Check if both the start and end container are within a table
    const startInTable = $ae4b6329110effd0$var$findParentTable(startContainer) !== null;
    const endInTable = $ae4b6329110effd0$var$findParentTable(endContainer) !== null;
    return startInTable && endInTable;
};
const $ae4b6329110effd0$export$50d84a2be082120 = (selection)=>{
    if (!selection || selection.rangeCount === 0) return 0;
    const range = selection.getRangeAt(0);
    if (range.collapsed) return 0;
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;
    const startInActionContainer = (0, $cSSgB.findActionItemElement)(startContainer);
    const endInActionContainer = (0, $cSSgB.findActionItemElement)(endContainer);
    let commonAncestor;
    if (startInActionContainer || endInActionContainer) {
        const actionItemRange = range.cloneRange();
        actionItemRange.setStart(startInActionContainer || startContainer, 0);
        actionItemRange.setEnd(endInActionContainer || endContainer, 0);
        commonAncestor = actionItemRange.commonAncestorContainer;
    } else // the selection might span across different containers
    // or be in between the start and end highlight
    commonAncestor = range.commonAncestorContainer;
    const walker = document.createTreeWalker(commonAncestor, NodeFilter.SHOW_ELEMENT, null);
    let node = walker.currentNode;
    let actionItemsInSelection = 0;
    while(node){
        if (range.intersectsNode(node)) {
            const element = node;
            if (element.dataset?.taskLocalId !== undefined) actionItemsInSelection++;
        }
        node = walker.nextNode();
    }
    return actionItemsInSelection;
};
const $ae4b6329110effd0$var$getIssueCreationType = ({ isAIIssueCreationEnabled: isAIIssueCreationEnabled })=>{
    if (isAIIssueCreationEnabled) return $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE;
    else return $ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE;
};
const $ae4b6329110effd0$var$userHasEditPermission = (pageInfo)=>{
    if (!pageInfo) return false;
    const contentType = pageInfo.type;
    return pageInfo.operations?.some((op)=>op?.operation === 'update' && op?.targetType === contentType) || false;
};
const $ae4b6329110effd0$var$ConsolidatedCreateJiraIssueButton = ({ completeKey: completeKey, handleCreateIssueItemClicked: handleCreateIssueItemClicked, isAIIssueCreationEnabled: isAIIssueCreationEnabled, isSelectionMultipleRows: isSelectionMultipleRows })=>{
    const issueCreationType = isSelectionMultipleRows ? $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE : $ae4b6329110effd0$var$getIssueCreationType({
        isAIIssueCreationEnabled: isAIIssueCreationEnabled
    });
    const getIcon = (iconProps)=>{
        if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
            ...iconProps,
            label: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))), {
            ...iconProps,
            label: ""
        });
    };
    const getIconAIFC = (iconProps)=>{
        if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
            ...iconProps,
            size: "small",
            label: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))), {
            ...iconProps,
            size: "small",
            label: ""
        });
    };
    const getButtonText = ()=>{
        if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "highlight-actions.create-multiple-jira-work-items",
            defaultMessage: "Create Jira work items"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "highlight-actions.create-jira-work-item",
            defaultMessage: "Create Jira work item"
        });
    };
    if ((0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        testId: "consolidated-create-jira-issue-button",
        "data-key": completeKey,
        shouldTitleWrap: false,
        elemBefore: (0, $9wGTI.fg)('platform_editor_toolbar_aifc_patch_8') ? getIconAIFC({}) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))), {
            size: "small",
            label: ""
        }),
        onClick: handleCreateIssueItemClicked(issueCreationType)
    }, getButtonText());
    return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        testId: "consolidated-create-jira-issue-button",
        "data-key": completeKey,
        shouldTitleWrap: false,
        elemBefore: getIcon({}),
        onClick: handleCreateIssueItemClicked(issueCreationType)
    }, getButtonText()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        id: "create-jira-issue-button",
        appearance: "subtle",
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                ...iconProps,
                label: ""
            }),
        "data-key": completeKey,
        testId: "consolidated-create-jira-issue-button",
        onClick: handleCreateIssueItemClicked(isSelectionMultipleRows ? 'MULTIPLE_ISSUE' : $ae4b6329110effd0$var$getIssueCreationType({
            isAIIssueCreationEnabled: isAIIssueCreationEnabled
        })),
        spacing: "compact"
    }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "highlight-actions.create-jira-issue-issue-term-refresh",
        defaultMessage: "Jira work item"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "highlight-actions.create-jira-issue",
        defaultMessage: "Jira issue"
    }));
};
const $ae4b6329110effd0$export$f91cf3aef874f6f = ({ activeSelection: activeSelection, completeKey: completeKey, container: container, contentId: contentId, contentType: contentType, lastModified: lastModified, setRecordedClick: setRecordedClick, setIsWarningDialogOpen: setIsWarningDialogOpen })=>{
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const pressTracing = (0, $1pSma.default)('highlight-actions.ai-issue-create.dropdown-item-click');
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsCreatedFromActionItems = (0, $hq2Sz.useSetIsCreatedFromActionItems)();
    const isSidePanelOpen = (0, $ai7NK.useIsSidePanelOpen)();
    const isAIIssueCreationEnabled = (0, $frJep.useIsAIIssueCreationEnabled)();
    const isSelectionInTable = $ae4b6329110effd0$var$isTableSelection(activeSelection);
    // table creation has higher priority than action item creation
    const actionItemsInSelection = $ae4b6329110effd0$export$50d84a2be082120(activeSelection);
    const isActionItemInSelection = actionItemsInSelection > 0 && !isSelectionInTable && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items');
    const isMultiActionItemsInSelection = actionItemsInSelection > 1 && !isSelectionInTable && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items');
    const isSelectionMultipleRows = $ae4b6329110effd0$var$isMultiRowTableSelection(activeSelection) || isMultiActionItemsInSelection;
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first'
    });
    const hasEditPermission = (0, $42omo.useMemo)(()=>$ae4b6329110effd0$var$userHasEditPermission(pageInfo), [
        pageInfo
    ]);
    const fireCreateIssueButtonClickedAnalytics = (0, $42omo.useCallback)((issueCreationType, isCreatedFromTable, isCreatedFromActionItems)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'jiraIssueLink',
                type: 'ui',
                attributes: {
                    issueCreationType: issueCreationType,
                    isDropdownItem: false,
                    isCreatedFromTable: isCreatedFromTable,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    hasEditPermission: hasEditPermission,
                    pageMode: (0, $1mDVg.PageMode).VIEW
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        hasEditPermission
    ]);
    const handleCreateIssueItemClicked = (0, $42omo.useCallback)((issueCreationType)=>()=>{
            if (!isSidePanelOpen) switch(issueCreationType){
                case $ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE:
                    fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                    (0, $joYQz.createSingleJiraIssueHandle)({
                        rightSidebarContext: rightSidebarContext,
                        actions: actions,
                        activeSelection: activeSelection,
                        contentId: contentId,
                        contentType: contentType,
                        container: container,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        isActionItemInSelection: isActionItemInSelection,
                        pageMode: (0, $1mDVg.PageMode).VIEW
                    });
                    break;
                case $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE:
                    fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                    !(0, $4VJDS.default).getBoolean('confluence_legacy_bulk_jira_work_create', false) ? (0, $joYQz.createMultipleJiraIssuesHandleModernized)({
                        rightSidebarContext: rightSidebarContext,
                        pressTracing: pressTracing,
                        activeSelection: activeSelection,
                        actions: actions,
                        setIsCreatedWithAi: setIsCreatedWithAi,
                        setIsCreatedFromTable: setIsCreatedFromTable,
                        setIsCreatedFromActionItems: setIsCreatedFromActionItems,
                        contentId: contentId,
                        container: container,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        pageMode: (0, $1mDVg.PageMode).VIEW
                    }) : (0, $2W2Mk.createMultipleJiraIssuesHandle)(container, contentId, lastModified);
                    break;
                case $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE:
                    fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE, isSelectionInTable, isActionItemInSelection);
                    (0, $joYQz.createSingleAiJiraIssueHandle)({
                        rightSidebarContext: rightSidebarContext,
                        actions: actions,
                        activeSelection: activeSelection,
                        contentId: contentId,
                        contentType: contentType,
                        container: container,
                        fireAiAnalytics: trackAIInteractionInit,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        pageMode: (0, $1mDVg.PageMode).VIEW,
                        isActionItemInSelection: isActionItemInSelection
                    });
                    pressTracing();
                    break;
            }
            else {
                // ai specific data
                const aiData = {
                    contentType: contentType,
                    fireAiAnalytics: trackAIInteractionInit
                };
                // record temp data
                const tempData = {
                    rightSidebarContext: rightSidebarContext,
                    actions: actions,
                    activeSelection: activeSelection,
                    contentId: contentId,
                    container: container,
                    lastModified: lastModified,
                    hasEditPermission: hasEditPermission,
                    ...issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE ? aiData : {}
                };
                setRecordedClick(tempData);
                setIsWarningDialogOpen(true);
            }
        }, [
        isSidePanelOpen,
        fireCreateIssueButtonClickedAnalytics,
        isSelectionInTable,
        rightSidebarContext,
        actions,
        activeSelection,
        contentId,
        contentType,
        container,
        lastModified,
        pressTracing,
        setIsCreatedWithAi,
        setIsCreatedFromTable,
        setIsCreatedFromActionItems,
        trackAIInteractionInit,
        setRecordedClick,
        setIsWarningDialogOpen,
        hasEditPermission,
        isActionItemInSelection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae4b6329110effd0$var$ConsolidatedCreateJiraIssueButton, {
        completeKey: completeKey,
        handleCreateIssueItemClicked: handleCreateIssueItemClicked,
        isAIIssueCreationEnabled: isAIIssueCreationEnabled,
        isSelectionMultipleRows: isSelectionMultipleRows
    });
};
module.exports["CreateJiraIssueActions"] = $ae4b6329110effd0$export$f91cf3aef874f6f;

});

parcelRegister("frJep", function(module, exports) {

var $1mDVg = parcelRequire("1mDVg");


var $dAg4H = parcelRequire("dAg4H");


var $2ay9q = parcelRequire("2ay9q");

const $ae678835b2293c93$export$58de3335a79e10d3 = ()=>{
    const [{ contentId: contentId }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const aiIssueCreationEnablement = (0, $dAg4H.useIsAIIssueCreationAllowed)({
        contentId: contentId
    });
    const isAiEnabled = aiIssueCreationEnablement?.isEnabled ?? false;
    const isCreateIssueWithAiEnabledByUser = (0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)();
    return isAiEnabled && isCreateIssueWithAiEnabledByUser;
};
module.exports["useIsAIIssueCreationEnabled"] = $ae678835b2293c93$export$58de3335a79e10d3;

});

parcelRegister("2W2Mk", function(module, exports) {

var $04e9M = parcelRequire("04e9M");


var $aUTn5 = parcelRequire("aUTn5");

const $fc9c79783a6d919a$export$b5c53601259f278e = (container, contentId, lastModified)=>()=>{
        const selection = window.getSelection();
        if (selection) {
            // Send an event to track the user clicking the JIRA Link
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendUIEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'jiraIssueLink',
                    source: 'HighlightContextMenu'
                });
            });
            window.dispatchEvent(new CustomEvent('create-jira-issue-summary', // Convert window.getSelection() to legacy format used in jira issue summary.
            // Once we Reactified it this should be deleted.
            {
                detail: (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId, lastModified)
            }));
        }
    };
const $fc9c79783a6d919a$export$92ec81e7ac5e7973 = (container, contentId, lastModified)=>{
    const selection = window.getSelection();
    if (selection) {
        window.dispatchEvent(new CustomEvent('create-jira-issue-summary', {
            detail: (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId, lastModified)
        }));
        const observer = new MutationObserver((_mutations, observer)=>{
            const createMultipleButton = document.querySelector('.aui-button.aui-button-link.js-text-suggestion.js-go-to-create-multiple-issues');
            if (createMultipleButton) {
                createMultipleButton.click();
                observer.disconnect();
            }
            const createSingleButton = document.querySelector('.aui-button.aui-button-link.js-text-suggestion.js-go-to-create-single-issue');
            if (createSingleButton) createSingleButton.style.display = 'none';
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
};
module.exports["createJiraIssueSummaryHandle"] = $fc9c79783a6d919a$export$b5c53601259f278e;
module.exports["createMultipleJiraIssuesHandle"] = $fc9c79783a6d919a$export$92ec81e7ac5e7973;

});

parcelRegister("joYQz", function(module, exports) {

var $eqKgz = parcelRequire("eqKgz");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $3TWPv = parcelRequire("3TWPv");


var $cSSgB = parcelRequire("cSSgB");


var $euVTc = parcelRequire("euVTc");


var $1Q0l6 = parcelRequire("1Q0l6");


var $2ViZo = parcelRequire("2ViZo");


var $UNr39 = parcelRequire("UNr39");

parcelRequire("aiS08");
var $1L1jV = parcelRequire("1L1jV");


var $aUTn5 = parcelRequire("aUTn5");

const $4d90dab75b68bf7b$export$a25c0fd63a5cc834 = (activeSelection)=>{
    if (!activeSelection || 'rangeCount' in activeSelection && activeSelection.rangeCount === 0) return '';
    const range = 'getRangeAt' in activeSelection ? activeSelection.getRangeAt(0) : activeSelection;
    const docFragment = range.cloneContents();
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(docFragment);
    return tempDiv.innerHTML;
};
const $4d90dab75b68bf7b$export$233a92718b28d19e = 254;
const $4d90dab75b68bf7b$export$2878cc467c8be8fe = (text, maxLength)=>{
    const horizontalEllipsis = "\u2026";
    if (text.length <= maxLength) return [
        text,
        ''
    ];
    // Calculate the length of the first part without including the ellipsis
    const firstPartLength = maxLength - horizontalEllipsis.length;
    // Split the text into two parts
    const firstPart = text.substring(0, firstPartLength);
    const firstPartWithHorizontalEllipis = firstPart + horizontalEllipsis;
    return [
        firstPartWithHorizontalEllipis,
        text
    ];
};
const $4d90dab75b68bf7b$export$5645fd1d37220db2 = (activeSelection)=>{
    const selectionString = activeSelection?.toString() || '';
    const htmlString = $4d90dab75b68bf7b$export$a25c0fd63a5cc834(activeSelection);
    const [summary] = $4d90dab75b68bf7b$export$2878cc467c8be8fe(selectionString, $4d90dab75b68bf7b$export$233a92718b28d19e);
    /*
	 The regex matches one or more occurrences of any line break (\r, \n) or tab (\t)
	 and replaces them all with a single space. (We only consider whitespace characters because
	 these are the only ones that ultimately stick when parsing the summary.)
  */ const summaryWithoutFormatting = summary.replace(/[\r\n\t]+/g, ' ');
    // Convert the full HTML content to ADF for the description
    const descriptionAdf = (0, $eqKgz.htmlToADF)(htmlString);
    return [
        summaryWithoutFormatting,
        descriptionAdf
    ];
};
const $4d90dab75b68bf7b$var$createSingleJiraIssueHandleCommon = ({ actions: actions, activeSelection: activeSelection, contentId: contentId, contentType: contentType, container: container, lastModified: lastModified, hasEditPermission: hasEditPermission, isActionItemInSelection: isActionItemInSelection, pageMode: pageMode })=>{
    let updatedSelection = activeSelection;
    let activeSelectionRange = (0, $1Q0l6.getValidRange)(activeSelection?.getRangeAt(0));
    if (isActionItemInSelection && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) {
        const updatedActiveSelection = (0, $cSSgB.includeEntireActionItemInSelection)(activeSelection);
        if (updatedActiveSelection instanceof Range) {
            updatedSelection = updatedActiveSelection;
            activeSelectionRange = (0, $1Q0l6.getValidRangeForActionItem)(updatedActiveSelection);
        }
    }
    const highlightedText = (0, $eqKgz.htmlToADF)($4d90dab75b68bf7b$export$a25c0fd63a5cc834(updatedSelection));
    const insertStorageFragmentRequestPayload = (0, $1Q0l6.constructInsertStorageFragmentRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), activeSelectionRange, container, lastModified);
    const [summaryWithoutFormatting, descriptionAdf] = $4d90dab75b68bf7b$export$5645fd1d37220db2(updatedSelection);
    actions.setSummary(summaryWithoutFormatting);
    actions.setDescriptionAdf(descriptionAdf);
    actions.setContentId(contentId);
    contentType && actions.setContentType(contentType);
    actions.setHighlightedText(highlightedText);
    actions.setInsertStorageFragmentRequestPayload(insertStorageFragmentRequestPayload);
    actions.setHasEditPermission(hasEditPermission);
    actions.setPageMode(pageMode);
};
const $4d90dab75b68bf7b$export$358d16442308a1f3 = ({ rightSidebarContext: rightSidebarContext, actions: actions, activeSelection: activeSelection, contentId: contentId, contentType: contentType, container: container, lastModified: lastModified, hasEditPermission: hasEditPermission, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection })=>{
    if ((0, $9wGTI.fg)('confluence_editor_single_work_create_improvements')) {
        actions.setIsCreatedWithAi(false);
        actions.setHasEditPermission(hasEditPermission);
        (0, $3TWPv.openSingleIssueSidePanelWithSelection)({
            actions: actions,
            rightSidebarContext: rightSidebarContext,
            activeSelection: activeSelection,
            contentId: contentId,
            contentType: contentType,
            container: container,
            lastModified: lastModified,
            pageMode: pageMode,
            isActionItemInSelection: isActionItemInSelection,
            convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
        });
        return;
    }
    $4d90dab75b68bf7b$var$createSingleJiraIssueHandleCommon({
        actions: actions,
        activeSelection: activeSelection,
        contentId: contentId,
        contentType: contentType,
        container: container,
        lastModified: lastModified,
        hasEditPermission: hasEditPermission,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection
    });
    actions.setIsCreatedWithAi(false);
    actions.setIsCreatedFromActionItem(!!isActionItemInSelection);
    rightSidebarContext.open((0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID), (0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_WIDTH));
};
const $4d90dab75b68bf7b$export$5378c6b60bde04bf = ({ rightSidebarContext: rightSidebarContext, actions: actions, activeSelection: activeSelection, contentId: contentId, contentType: contentType, container: container, fireAiAnalytics: fireAiAnalytics, lastModified: lastModified, pressTracing: pressTracing, hasEditPermission: hasEditPermission, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection })=>{
    fireAiAnalytics();
    if ((0, $9wGTI.fg)('confluence_editor_single_work_create_improvements')) {
        actions.setIsCreatedWithAi(true);
        actions.setHasEditPermission(hasEditPermission);
        (0, $3TWPv.openSingleIssueSidePanelWithSelection)({
            actions: actions,
            rightSidebarContext: rightSidebarContext,
            activeSelection: activeSelection,
            contentId: contentId,
            contentType: contentType,
            container: container,
            lastModified: lastModified,
            pageMode: pageMode,
            isActionItemInSelection: isActionItemInSelection,
            convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
        });
        pressTracing?.();
        return;
    }
    $4d90dab75b68bf7b$var$createSingleJiraIssueHandleCommon({
        actions: actions,
        activeSelection: activeSelection,
        contentId: contentId,
        contentType: contentType,
        container: container,
        lastModified: lastModified,
        hasEditPermission: hasEditPermission,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection
    });
    actions.setIsCreatedWithAi(true);
    actions.setIsCreatedFromActionItem(!!isActionItemInSelection);
    rightSidebarContext.open((0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID), (0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_WIDTH));
    pressTracing?.();
};
const $4d90dab75b68bf7b$export$83a48a684a9c82ca = ({ actions: actions, setIsCreatedWithAi: setIsCreatedWithAi, setIsCreatedFromTable: setIsCreatedFromTable, setIsCreatedFromActionItems: setIsCreatedFromActionItems, rightSidebarContext: rightSidebarContext, pressTracing: pressTracing, activeSelection: activeSelection, contentId: contentId, container: container, lastModified: lastModified, hasEditPermission: hasEditPermission, pageMode: pageMode })=>{
    if ((0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false)) {
        const result = (0, $2ViZo.prepareBulkCreateFromSelection)({
            actions: actions,
            activeSelection: activeSelection,
            contentId: contentId,
            pageMode: pageMode,
            hasEditPermission: hasEditPermission,
            container: container,
            lastModified: lastModified,
            setIsCreatedFromTable: setIsCreatedFromTable,
            setIsCreatedFromActionItems: setIsCreatedFromActionItems,
            convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
        });
        if (result === (0, $2ViZo.BulkSelectionResult).None) return;
    } else {
        const selectedActionList = (0, $cSSgB.getClosestActionListFromSelection)(activeSelection);
        const selectedTable = (0, $euVTc.getClosestTableFromSelection)(activeSelection);
        if (!selectedTable && !selectedActionList && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) // We have checks to ensure that the activeSelection is in a table or contains action items, so this should never happen.
        return;
        if (selectedTable) {
            actions.setSelectedTable(selectedTable);
            const insertStorageColumnTableRequestPayload = (0, $1Q0l6.constructInsertStorageColumnTableRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), (0, $1Q0l6.getValidRange)(activeSelection?.getRangeAt(0)), container, lastModified);
            actions.setInsertStorageColumnTableRequestPayload(insertStorageColumnTableRequestPayload);
            setIsCreatedFromTable(true);
            $4d90dab75b68bf7b$var$resetActionItemsState(setIsCreatedFromActionItems, actions);
        } else if (selectedActionList && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) {
            actions.setSelectedActionItems(selectedActionList);
            const actionItems = selectedActionList.querySelectorAll('div[data-task-local-id]:not([data-task-local-id=""])');
            const ranges = [];
            actionItems.forEach((actionItem)=>{
                const range = new Range();
                range.selectNodeContents(actionItem);
                const validRange = (0, $1Q0l6.getValidRangeForActionItem)(range);
                if (validRange) ranges.push(validRange);
            });
            const insertMultipleStorageFragmentsRequestPayload = (0, $1Q0l6.constructInsertMultipleStorageFragmentsRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), ranges, container, lastModified);
            actions.setInsertMultipleStorageFragmentsRequestPayload(insertMultipleStorageFragmentsRequestPayload);
            setIsCreatedFromActionItems(true);
            $4d90dab75b68bf7b$var$resetTableState(setIsCreatedFromTable, actions);
        }
        actions.setContentId(contentId);
        actions.setPageMode(pageMode);
        actions.setHasEditPermission(hasEditPermission);
        setIsCreatedWithAi(false);
    }
    rightSidebarContext.open((0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID), (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
    pressTracing?.();
};
const $4d90dab75b68bf7b$var$resetTableState = (setIsCreatedFromTable, actions)=>{
    setIsCreatedFromTable(false);
    actions.setSelectedTable(undefined);
    actions.setInsertStorageColumnTableRequestPayload(undefined);
};
const $4d90dab75b68bf7b$var$resetActionItemsState = (setIsCreatedFromActionItems, actions)=>{
    setIsCreatedFromActionItems(false);
    actions.setSelectedActionItems(undefined);
    actions.setInsertMultipleStorageFragmentsRequestPayload(undefined);
};
module.exports["getHTMLString"] = $4d90dab75b68bf7b$export$a25c0fd63a5cc834;
module.exports["createSingleJiraIssueHandle"] = $4d90dab75b68bf7b$export$358d16442308a1f3;
module.exports["createSingleAiJiraIssueHandle"] = $4d90dab75b68bf7b$export$5378c6b60bde04bf;
module.exports["createMultipleJiraIssuesHandleModernized"] = $4d90dab75b68bf7b$export$83a48a684a9c82ca;

});

parcelRegister("3TWPv", function(module, exports) {

var $eqKgz = parcelRequire("eqKgz");


var $9wGTI = parcelRequire("9wGTI");


var $1Q0l6 = parcelRequire("1Q0l6");


var $1mDVg = parcelRequire("1mDVg");


var $1L1jV = parcelRequire("1L1jV");


var $cSSgB = parcelRequire("cSSgB");

const $918fba8df3fbcc13$export$233a92718b28d19e = 254;
const $918fba8df3fbcc13$var$getHTMLString = (activeSelection)=>{
    if (!activeSelection || 'rangeCount' in activeSelection && activeSelection.rangeCount === 0) return '';
    const range = 'getRangeAt' in activeSelection ? activeSelection.getRangeAt(0) : activeSelection;
    const docFragment = range.cloneContents();
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(docFragment);
    return tempDiv.innerHTML;
};
const $918fba8df3fbcc13$export$2878cc467c8be8fe = (text, maxLength)=>{
    const horizontalEllipsis = "\u2026";
    if (text.length <= maxLength) return [
        text,
        ''
    ];
    const firstPartLength = maxLength - horizontalEllipsis.length;
    const firstPart = text.substring(0, firstPartLength);
    const firstPartWithHorizontalEllipis = firstPart + horizontalEllipsis;
    return [
        firstPartWithHorizontalEllipis,
        text
    ];
};
const $918fba8df3fbcc13$export$5645fd1d37220db2 = (activeSelection)=>{
    const selectionString = activeSelection?.toString() || '';
    const htmlString = $918fba8df3fbcc13$var$getHTMLString(activeSelection);
    const [summary] = $918fba8df3fbcc13$export$2878cc467c8be8fe(selectionString, $918fba8df3fbcc13$export$233a92718b28d19e);
    const summaryWithoutFormatting = summary.replace(/[\r\n\t]+/g, ' ');
    const descriptionAdf = (0, $eqKgz.htmlToADF)(htmlString);
    return [
        summaryWithoutFormatting,
        descriptionAdf
    ];
};
const $918fba8df3fbcc13$export$41bb5569f66eae2a = ({ actions: actions, rightSidebarContext: rightSidebarContext, activeSelection: activeSelection, contentId: contentId, contentType: contentType, container: container, lastModified: lastModified, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection, convertSelectionToLegacyFormat: convertSelectionToLegacyFormat })=>{
    const { updatedSelection: updatedSelection, activeSelectionRange: activeSelectionRange } = $918fba8df3fbcc13$var$expandSelectionIfActionItemsSelected({
        activeSelection: activeSelection,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection
    });
    const highlightedText = (0, $eqKgz.htmlToADF)($918fba8df3fbcc13$var$getHTMLString(updatedSelection));
    const insertStorageFragmentRequestPayload = (0, $1Q0l6.constructInsertStorageFragmentRequestPayload)(contentId, convertSelectionToLegacyFormat, activeSelectionRange, container, lastModified);
    const [summaryWithoutFormatting, descriptionAdf] = $918fba8df3fbcc13$export$5645fd1d37220db2(updatedSelection);
    actions.setSummary(summaryWithoutFormatting);
    actions.setDescriptionAdf(descriptionAdf);
    actions.setContentId(contentId);
    contentType && actions.setContentType(contentType);
    actions.setHighlightedText(highlightedText);
    actions.setInsertStorageFragmentRequestPayload(insertStorageFragmentRequestPayload);
    actions.setIsCreatedFromActionItem(!!isActionItemInSelection);
    actions.setPageMode(pageMode);
    rightSidebarContext.open((0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID), (0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_WIDTH));
};
const $918fba8df3fbcc13$var$expandSelectionIfActionItemsSelected = ({ activeSelection: activeSelection, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection })=>{
    let updatedSelection = activeSelection;
    let activeSelectionRange = (0, $1Q0l6.getValidRange)(activeSelection?.getRangeAt(0));
    if (isActionItemInSelection && pageMode === (0, $1mDVg.PageMode).VIEW && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) {
        const updatedActiveSelection = (0, $cSSgB.includeEntireActionItemInSelection)(activeSelection);
        if (updatedActiveSelection instanceof Range) {
            updatedSelection = updatedActiveSelection;
            activeSelectionRange = (0, $1Q0l6.getValidRangeForActionItem)(updatedActiveSelection);
        } else activeSelectionRange = activeSelection && 'getRangeAt' in activeSelection ? (0, $1Q0l6.getValidRange)(activeSelection.getRangeAt(0)) : undefined;
    }
    return {
        updatedSelection: updatedSelection,
        activeSelectionRange: activeSelectionRange
    };
};
module.exports["openSingleIssueSidePanelWithSelection"] = $918fba8df3fbcc13$export$41bb5569f66eae2a;

});

parcelRegister("4oXkq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $dAYOx = parcelRequire("dAYOx");


var $lAFHW = parcelRequire("lAFHW");


var $inPa6 = parcelRequire("inPa6");


var $iu6m9 = parcelRequire("iu6m9");


var $2GVu1 = parcelRequire("2GVu1");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");


var $lpGuF = parcelRequire("lpGuF");

const $ed7cf63fc877d47c$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $ed7cf63fc877d47c$var$getHighlightedText = (selection)=>{
    if (!selection || selection.rangeCount === 0) return '';
    return selection.toString().trim();
};
const $ed7cf63fc877d47c$var$i18n = (0, $cgtv4.defineMessages)({
    trelloLabel: {
        id: "highlight-actions.create-trello-card",
        defaultMessage: "Send to your Trello Inbox"
    },
    errorTitle: {
        id: "highlight-actions.trello.create.error",
        defaultMessage: "Couldn't create Trello card. Try again later."
    },
    successTitle: {
        id: "highlight-actions.trello.create.success",
        defaultMessage: "Trello card created"
    },
    openCard: {
        id: "highlight-actions.trello.openCard",
        defaultMessage: "Open card"
    }
});
const $ed7cf63fc877d47c$var$AddToTrelloInboxActionsComponent = ({ activeSelection: activeSelection, completeKey: completeKey, contentId: contentId, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const fireTrelloCardCreatedAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'trelloInboxCard',
                type: 'ui',
                attributes: {
                    contentId: contentId,
                    hasSelection: Boolean(activeSelection && activeSelection.toString().trim())
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        activeSelection
    ]);
    const showCreateErrorFlag = (0, $42omo.useCallback)(()=>{
        flags.showFlag({
            id: 'trello-inbox-create-error',
            type: 'error',
            title: intl.formatMessage($ed7cf63fc877d47c$var$i18n.errorTitle),
            close: 'auto'
        });
    }, [
        flags,
        intl
    ]);
    const makeHandleCreateTrelloCardClick = (0, $42omo.useCallback)(async ()=>{
        const highlightedText = $ed7cf63fc877d47c$var$getHighlightedText(activeSelection);
        if (!highlightedText) return;
        try {
            fireTrelloCardCreatedAnalytics();
            const result = await (0, $lpGuF.createTrelloCardHandle)({
                text: highlightedText,
                contentId: contentId
            });
            if (result && result.success) {
                const actions = result.cardUrl ? [
                    {
                        content: intl.formatMessage($ed7cf63fc877d47c$var$i18n.openCard),
                        href: result.cardUrl,
                        target: '_blank'
                    }
                ] : undefined;
                flags.showFlag({
                    id: 'trello-inbox-create-success',
                    type: 'success-circle',
                    title: intl.formatMessage($ed7cf63fc877d47c$var$i18n.successTitle),
                    actions: actions,
                    close: 'auto'
                });
            } else showCreateErrorFlag();
        } catch (error) {
            $ed7cf63fc877d47c$var$logger.error`Error creating Trello card for contentId=${contentId}`;
            showCreateErrorFlag();
        }
    }, [
        activeSelection,
        contentId,
        fireTrelloCardCreatedAnalytics,
        flags,
        showCreateErrorFlag,
        intl
    ]);
    if (!(0, $9wGTI.fg)('quick_capture_trello_inbox')) return null;
    if ((0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        testId: "create-trello-card-button",
        "data-key": completeKey,
        shouldTitleWrap: false,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.TrelloIcon), {
            label: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel),
            appearance: "brand",
            size: "small"
        }),
        onClick: makeHandleCreateTrelloCardClick
    }, intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel));
    return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        testId: "create-trello-card-button",
        "aria-label": intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel),
        "data-key": completeKey,
        shouldTitleWrap: false,
        title: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.TrelloIcon), {
            label: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel),
            appearance: "brand",
            size: "small"
        }),
        onClick: makeHandleCreateTrelloCardClick
    }, intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        id: "create-trello-card-button",
        appearance: "subtle",
        iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.TrelloIcon), {
                label: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel),
                appearance: "brand",
                size: "small"
            }),
        "data-key": completeKey,
        testId: "create-trello-card-button",
        onClick: makeHandleCreateTrelloCardClick,
        spacing: "compact"
    }, intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel));
};
const $ed7cf63fc877d47c$export$12f6e4d1b0812953 = (0, $7aRa9.withFlags)($ed7cf63fc877d47c$var$AddToTrelloInboxActionsComponent);
module.exports["AddToTrelloInboxActions"] = $ed7cf63fc877d47c$export$12f6e4d1b0812953;

});

parcelRegister("lpGuF", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

const $988c838c2543c991$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $988c838c2543c991$var$CREATE_TRELLO_CARD_ENDPOINT = '/wiki/rest/trello/1.0/inbox-card';
const $988c838c2543c991$var$CARD_NAME_MAX_LENGTH = 254;
const $988c838c2543c991$var$HORIZONTAL_ELLIPSIS = "\u2026";
const $988c838c2543c991$var$toPayloadSafeName = (raw, maxLength = $988c838c2543c991$var$CARD_NAME_MAX_LENGTH)=>{
    const normalized = String(raw).replace(/[\r\n\t]+/g, ' ').trim();
    if (normalized.length <= maxLength) return normalized;
    const firstPartLength = Math.max(0, maxLength - $988c838c2543c991$var$HORIZONTAL_ELLIPSIS.length);
    return normalized.substring(0, firstPartLength) + $988c838c2543c991$var$HORIZONTAL_ELLIPSIS;
};
const $988c838c2543c991$export$750e0c983aee1f51 = async ({ text: text, contentId: contentId })=>{
    const payload = {
        name: $988c838c2543c991$var$toPayloadSafeName(text, $988c838c2543c991$var$CARD_NAME_MAX_LENGTH),
        description: text || 'Created via Confluence',
        sourceContentId: contentId,
        sourceUrl: typeof location !== 'undefined' ? location.href : undefined
    };
    try {
        const resp = await fetch($988c838c2543c991$var$CREATE_TRELLO_CARD_ENDPOINT, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify(payload)
        });
        if (!resp.ok) {
            $988c838c2543c991$var$logger.error`Failed to create Trello card for contentId=${contentId} status=${resp.status}`;
            return null;
        }
        const data = await resp.json();
        const idCandidate = data.cardId;
        const urlCandidate = data.cardUrl;
        if (!idCandidate || !urlCandidate) {
            $988c838c2543c991$var$logger.error`Invalid Trello response for contentId=${contentId}`;
            return null;
        }
        const response = {
            cardId: idCandidate || '',
            cardUrl: urlCandidate || '',
            success: true
        };
        return response;
    } catch (error) {
        $988c838c2543c991$var$logger.error`Error creating Trello card for contentId=${contentId}`;
        return null;
    }
};
module.exports["createTrelloCardHandle"] = $988c838c2543c991$export$750e0c983aee1f51;

});

parcelRegister("lEDve", function(module, exports) {
/* Popup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $jTxSS = parcelRequire("jTxSS");


var $6F6hl = parcelRequire("6F6hl");


var $l7fKC = parcelRequire("l7fKC");


var $6mKj3 = parcelRequire("6mKj3");


var $id4ij = parcelRequire("id4ij");


var $gz8ZY = parcelRequire("gz8ZY");


var $9wGTI = parcelRequire("9wGTI");


var $bEdUx = parcelRequire("bEdUx");

const $709c5a5818d3675c$var$popupAnimation = null;
const $709c5a5818d3675c$var$popupPanelStyles = null;
const $709c5a5818d3675c$var$popupTransition = null;
const $709c5a5818d3675c$var$buttonContainerStyle = null;
const $709c5a5818d3675c$var$toolbarContainerStyle = null;
const $709c5a5818d3675c$var$i18n = (0, $cgtv4.defineMessages)({
    toolbarAlert: {
        id: "highlight-actions.toolbar.alert",
        defaultMessage: "Floating toolbar is available. Press tab to access it"
    }
});
const $709c5a5818d3675c$export$129a32eedafa97c5 = ({ children: children, top: top, left: left, needTransition: needTransition = true, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, updatePosition: updatePosition })=>{
    const popupContainerRef = (0, $42omo.useRef)(null);
    $709c5a5818d3675c$var$useAdjustedTop(updatePosition, popupContainerRef);
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true);
    const popupRef = (0, $42omo.useRef)(null);
    const popupLeft = $709c5a5818d3675c$var$useAdjustedLeft(left, popupRef);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        const portalContainer = document.getElementById((0, $bEdUx.popupPortalContainerId));
        if (!portalContainer) return;
        const screenreaderCb = (_mutationsList, observer)=>{
            //These accessibility attributes are added dynamically here rather than directly on the VisuallyHidden element because it did not get read by the NVDA screenreader properly on Firefox. This is due to the screenreader sometimes only reading content when there has been a dynamic change to an element
            const accessibleDiv = document.getElementById('toolbar-alert');
            if (accessibleDiv instanceof HTMLElement) {
                accessibleDiv?.setAttribute('role', 'alert');
                accessibleDiv?.setAttribute('aria-live', 'polite');
                observer.disconnect();
            }
        };
        const observer = new MutationObserver(screenreaderCb);
        observer.observe(portalContainer, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    const portalContainer = document.getElementById((0, $bEdUx.popupPortalContainerId));
    const mouseMoveHandlers = onMouseEnter && onMouseLeave && {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    };
    return portalContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ $42omo.createElement("div", {
        ref: popupContainerRef,
        style: {
            top: top
        },
        ...mouseMoveHandlers,
        className: (0, $gMc0m.default)([
            "_y44vlq9g _kqswstnw",
            needTransition && "_v564zagr"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $6F6hl.default), {
        id: "toolbar-alert"
    }, formatMessage($709c5a5818d3675c$var$i18n.toolbarAlert)), isNewToolbarEnabled ? /*#__PURE__*/ $42omo.createElement("div", {
        ref: popupRef,
        style: {
            left: `${popupLeft || 0}px`
        },
        "data-testid": "highlightActionsPopup",
        id: "highlightActionsPopup",
        className: (0, $gMc0m.default)([
            "_t9ecm79d _kqswstnw _154iidpf"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $l7fKC.Toolbar), {
        label: "Renderer toolbar"
    }, children)) : /*#__PURE__*/ $42omo.createElement("div", {
        ref: popupRef,
        style: {
            left: `${popupLeft || 0}px`
        },
        "data-testid": "highlightActionsPopup",
        id: "highlightActionsPopup",
        className: (0, $gMc0m.default)([
            "_2rkofajl _t9ecm79d _16qs130s _kqswstnw _154iidpf _bfhk1bhr _1e0c1txw"
        ])
    }, children)), portalContainer) : null;
};
function $709c5a5818d3675c$var$useAdjustedLeft(left, popupRef) {
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const WINDOW_PADDING = 20;
    const [adjustedLeft, setAdjustedLeft] = (0, $42omo.useState)(left);
    const [adjustedLeftOrigin, setAdjustedLeftOrigin] = (0, $42omo.useState)(left);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!popupRef.current) return;
        const { left: elementLeft, right: right } = (0, $id4ij.getElementBounds)(popupRef.current);
        const windowWidth = window.innerWidth;
        let containerBounds = {
            left: 0,
            right: windowWidth
        }; // In Nav3, the window is the container
        if (isNav4Enabled) {
            const nav4ContentContainer = document.getElementById('AkMainContent');
            if (nav4ContentContainer) containerBounds = (0, $id4ij.getElementBounds)(nav4ContentContainer);
        } // WS-1703 - If the popup menu is off either side of the screen or outside of the scrollable content area in Nav4,
        // set it so it's inside the WINDOW_PADDING
        if (elementLeft < containerBounds.left) setAdjustedLeft(left + (containerBounds.left - elementLeft) + WINDOW_PADDING);
        else if (right > containerBounds.right) setAdjustedLeft(left - (right - containerBounds.right) - WINDOW_PADDING);
        else setAdjustedLeft(left);
        setAdjustedLeftOrigin(left);
    }, [
        isNav4Enabled,
        left,
        popupRef
    ]); // Only use the adjustedLeft if it was calculated relative to the current left prop
    return adjustedLeftOrigin === left ? adjustedLeft : left;
} /**
   * `popupPortalContainerId` is after the ADF renderer in the HTML DOM.
   * Consequently, when there is vertical layout shift before `popupPortalContainerId` such as in the ADF renderer, the `Popup` will automatically shift away from the selected range.
   * This automatic shift is undesirable and `useAdjustedTop` is attempting to undo it in a way as imperceptible to the user as possible.
   *
   * Inspired by {@link https://floating-ui.com/} which is "The Future of Popper". Both Popper and Floating UI are used by Design System to deal with popups including to reposition them.
   */ 
function $709c5a5818d3675c$var$useAdjustedTop(updatePosition, popupContainerRef) {
    const portalContainer = document.getElementById((0, $bEdUx.popupPortalContainerId));
    (0, $42omo.useEffect)(()=>{
        if (!portalContainer || !updatePosition || !('ResizeObserver' in window)) return; // The position of `popupPortalContainerId` relative to the selected range will change when the parent element of `popupPortalContainerId` is resized.
        const { parentElement: parentElement } = portalContainer;
        if (!parentElement) return;
        const observer = new ResizeObserver(()=>{
            if (!popupContainerRef.current) return;
            const newPosition = updatePosition();
            if (!newPosition) return;
            const { style: style } = popupContainerRef.current;
            const newTop = `${newPosition.top}px`;
            if (style.top !== newTop) {
                // `popupPortalContainerId` moved and automatically shifted `popupContainerRef` away from the selected range.
                // This automatic shift is undesirable and here we're attempting to undo it in a way as imperceptible to the user as possible.
                // Imperceptible here means that a transition animation cannot be used.
                style.transition = 'none';
                style.top = newTop;
            }
        });
        observer.observe(parentElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        popupContainerRef,
        portalContainer,
        updatePosition
    ]);
}
module.exports["Popup"] = $709c5a5818d3675c$export$129a32eedafa97c5;

});

parcelRegister("l7fKC", function(module, exports) {
/* Toolbar.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");


var $8hoW2 = parcelRequire("8hoW2");


var $9jB2n = parcelRequire("9jB2n");


var $12Oyv = parcelRequire("12Oyv");


var $j0UQK = parcelRequire("j0UQK");

const $a3c14e992c9fdb13$var$styles = {
    toolbarBase: "_2rko1qi0 _zulp1b66 _1e0c1txw _4cvr1h6o",
    toolbar: "_bfhk1bhr _4t3i14no _u5f31b66 _19bv1b66 _16qs130s",
    toolbarResponsive: "_195gpxbi",
    primaryToolbar: "_bfhkvuon _1tkezwfg",
    toolbarSeparator: "_1mj714no",
    hiddenSelectors: "_fy9oglyw _18shglyw _ze7rglyw",
    hiddenSelectorsPatch: "_z5m7glyw"
};
const $a3c14e992c9fdb13$export$4c260019440d418f = ({ children: children, label: label, actionSubjectId: actionSubjectId, testId: testId })=>{
    const isResponsiveEnabled = (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true);
    const toolbar = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.toolbar, isResponsiveEnabled && $a3c14e992c9fdb13$var$styles.toolbarResponsive, isResponsiveEnabled && $a3c14e992c9fdb13$var$styles.hiddenSelectors, (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) && $a3c14e992c9fdb13$var$styles.toolbarSeparator, (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) && $a3c14e992c9fdb13$var$styles.hiddenSelectorsPatch),
        role: "toolbar",
        "aria-label": label,
        testId: testId,
        "data-toolbar-type": (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? 'inline' : undefined,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $j0UQK.ViewEventEmitter), {
                actionSubject: (0, $j0UQK.ACTION_SUBJECT).TOOLBAR,
                actionSubjectId: actionSubjectId
            }),
            children
        ]
    });
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $8hoW2.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        wrappedToolbar = /*#__PURE__*/ (0, $l998X.jsx)((0, $12Oyv.ToolbarKeyboardNavigationProvider), {
            childComponentSelector: childComponentSelector,
            dom: dom,
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            handleFocus: handleFocus,
            ariaControls: ariaControls,
            ariaLabel: ariaLabel,
            children: toolbar
        });
    }
    if (isResponsiveEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9jB2n.ResponsiveWrapper), {
        children: wrappedToolbar
    });
    return wrappedToolbar;
};
const $a3c14e992c9fdb13$export$7469f9986edfc2 = ({ children: children, label: label, breakpointPreset: breakpointPreset, reducedBreakpoints: reducedBreakpoints })=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9jB2n.ResponsiveContainer), {
        breakpointPreset: breakpointPreset,
        reducedBreakpoints: reducedBreakpoints,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.primaryToolbar, $a3c14e992c9fdb13$var$styles.hiddenSelectors),
            role: "toolbar",
            "aria-label": label,
            "data-toolbar-type": (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? 'primary' : undefined,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.primaryToolbar),
        role: "toolbar",
        "aria-label": label,
        "data-toolbar-type": (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? 'primary' : undefined,
        children: children
    });
};
module.exports["Toolbar"] = $a3c14e992c9fdb13$export$4c260019440d418f;
module.exports["PrimaryToolbar"] = $a3c14e992c9fdb13$export$7469f9986edfc2;

});

parcelRegister("9jB2n", function(module, exports) {
/* ResponsiveContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-container-queries */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");

const $bc8e1bf6110fb52a$var$styles = {
    responsiveContainer: "_1bsb1osq _7cca15wb _1f38ptqj _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    responsiveContainerFullPage: "_1bsb1ns9 _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    fullpage: "_luoiglyw _2ojp1ule _11uvglyw _fj2k1ule _1nqyglyw _jd611ule _syrzglyw _fr6v1ule _1je21ule _1btx1ule _biad1ule _1ana1ule",
    reduced: "_kkyiglyw _1dj81ule _1cg81ule _j3qgglyw _xh1i1ule _oj3l1ule _13s9glyw _4nul1ule _wt211ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssue: "_152xglyw _1cn41ule _4cj71ule _afriglyw _ozjb1ule _w81r1ule _1mckglyw _r2nv1ule _1ym01ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmComment: "_s2iiglyw _o4331ule _1jvu1ule _lankglyw _1xpy1ule _1vu31ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    confluenceComment: "_15nrglyw _cm5a1ule _7qjy1ule _13ioglyw _8urt1ule _cpaf1ule _18zmglyw _1uj01ule _1oqh1ule _tzm6glyw _ktne1ule _87bn1ule",
    responsiveRules: "_t3a8glyw _1x5z1ule _6nrqglyw _1fq21ule _1ireglyw _zy2m1ule _hfbeglyw _gw6d1ule",
    responsiveRulesReduced: "_j094glyw _1mc51ule _gipeglyw _311r1ule _11u4glyw _v1i61ule _19x4glyw _qck01ule",
    responsiveRulesReducedOverridden: "_e2nbglyw _ol4q1ule",
    responsiveRulesWrapper: "_1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _33p2glyw _1dre1ule _u47mglyw _rut51ule _fj5dglyw _5wt61ule _hmx4glyw _1rrm1ule _ut18glyw _1nwo1ule _19fzglyw _1r831ule"
};
const $bc8e1bf6110fb52a$var$presetStyleMap = {
    fullpage: $bc8e1bf6110fb52a$var$styles.fullpage,
    reduced: $bc8e1bf6110fb52a$var$styles.reduced,
    'jira-issue': $bc8e1bf6110fb52a$var$styles.jiraIssue,
    'jsm-comment': $bc8e1bf6110fb52a$var$styles.jsmComment,
    'confluence-comment': $bc8e1bf6110fb52a$var$styles.confluenceComment
};
const $bc8e1bf6110fb52a$export$e60a4704009a0009 = ({ children: children, breakpointPreset: breakpointPreset, reducedBreakpoints: reducedBreakpoints })=>{
    // Use new preset-based logic when preset is provided and feature gate is enabled
    if (breakpointPreset && (0, $dh538.fg)('platform_editor_toolbar_aifc_responsive_improve')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)((0, $1oCLl.expValEquals)('platform_editor_reduce_toolbar_vc_impact', 'isEnabled', true) && breakpointPreset === 'fullpage' ? $bc8e1bf6110fb52a$var$styles.responsiveContainerFullPage : $bc8e1bf6110fb52a$var$styles.responsiveContainer, $bc8e1bf6110fb52a$var$presetStyleMap[breakpointPreset]),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)((0, $1oCLl.expValEquals)('platform_editor_reduce_toolbar_vc_impact', 'isEnabled', true) && breakpointPreset === 'fullpage' ? $bc8e1bf6110fb52a$var$styles.responsiveContainerFullPage : $bc8e1bf6110fb52a$var$styles.responsiveContainer, reducedBreakpoints ? $bc8e1bf6110fb52a$var$styles.responsiveRulesReduced : $bc8e1bf6110fb52a$var$styles.responsiveRules, reducedBreakpoints && (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) && $bc8e1bf6110fb52a$var$styles.responsiveRulesReducedOverridden),
        children: children
    });
}; /**
    * A wrapper that supports responsiveness with media queries. It needs to used together with Show component
    */ 
const $bc8e1bf6110fb52a$export$fa6e408d6a7d6214 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $bc8e1bf6110fb52a$var$styles.responsiveRulesWrapper,
        children: children
    });
};
module.exports["ResponsiveContainer"] = $bc8e1bf6110fb52a$export$e60a4704009a0009;
module.exports["ResponsiveWrapper"] = $bc8e1bf6110fb52a$export$fa6e408d6a7d6214;

});

parcelRegister("12Oyv", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hTKp4 = parcelRequire("hTKp4");


var $dh538 = parcelRequire("dh538");

const $b79e6ddf5e0c34a1$export$881345eb2554ea9e = ({ children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        const { current: element } = wrapperRef;
        const getFocusableElements = ()=>{
            if (!element) return [];
            // Find all focusable elements within the toolbar that match the child component selector
            const focusableSelectors = [
                'button:not([disabled])',
                '[role="button"]:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
            // Filter to only include elements that are:
            // 1. Within the child component selector
            // 2. Visible (not hidden by display:none on itself or any parent)
            return allFocusable.filter((el)=>{
                if (!el.closest(`${childComponentSelector}`)) return false;
                // Check if the element or any of its parents have display: none
                let currentEl = el;
                while(currentEl && currentEl !== element){
                    const computedStyle = window.getComputedStyle(currentEl);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
                    currentEl = currentEl.parentElement;
                }
                return true;
            });
        };
        const moveFocus = (direction)=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $hTKp4.getDocument)();
            const currentIndex = focusableElements.findIndex((el)=>el === doc?.activeElement);
            let nextIndex;
            if (currentIndex === -1) // No element currently focused, focus the first one
            nextIndex = 0;
            else if (direction === 'right') // Move right, wrap to beginning if at end
            nextIndex = (currentIndex + 1) % focusableElements.length;
            else // Move left, wrap to end if at beginning
            nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
            focusableElements[nextIndex]?.focus();
        };
        const handleTab = ()=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $hTKp4.getDocument)();
            let index = doc?.activeElement ? focusableElements.findIndex((el)=>el === doc?.activeElement) : 0;
            if (index < 0) index = 0;
            focusableElements.forEach((el)=>el.setAttribute('tabindex', '-1'));
            focusableElements[index].setAttribute('tabindex', '0');
        };
        const handleKeyDown = (event)=>{
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if ((0, $dh538.fg)('platform_editor_toolbar_aifc_patch_7')) switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    moveFocus('left');
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    moveFocus('right');
                    break;
                case 'Tab':
                    handleTab();
                    break;
                default:
            }
            else switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event)) handleFocus(event);
        };
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            dom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        wrapperRef,
        childComponentSelector,
        dom,
        isShortcutToFocusToolbar,
        handleFocus,
        handleEscape
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        children: children
    });
};
module.exports["ToolbarKeyboardNavigationProvider"] = $b79e6ddf5e0c34a1$export$881345eb2554ea9e;

});

parcelRegister("j0UQK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8hoW2 = parcelRequire("8hoW2");

const $e7817ef9ea32a2ec$export$7525482b5931e326 = {
    TOOLBAR: 'toolbar',
    TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
const $e7817ef9ea32a2ec$export$58d0f383acf77599 = ({ actionSubjectId: actionSubjectId, actionSubject: actionSubject })=>{
    const isMountedRef = (0, $42omo.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $8hoW2.useToolbarUI)();
    (0, $42omo.useEffect)(()=>{
        if (isMountedRef.current) return;
        isMountedRef.current = true;
        const payload = {
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: 'ui'
        };
        fireAnalyticsEvent && fireAnalyticsEvent(payload);
    }, [
        actionSubjectId,
        actionSubject,
        fireAnalyticsEvent
    ]);
    return null;
};
module.exports["ACTION_SUBJECT"] = $e7817ef9ea32a2ec$export$7525482b5931e326;
module.exports["ViewEventEmitter"] = $e7817ef9ea32a2ec$export$58d0f383acf77599;

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || document.scrollingElement || document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        document.body.appendChild(el);
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});

parcelRegister("bEdUx", function(module, exports) {
/* HighlightActionsProvider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4JDbp = parcelRequire("4JDbp");


var $1dnxO = parcelRequire("1dnxO");


var $e4o8D = parcelRequire("e4o8D");

const $cef29f59925fac19$var$styles = null;
const $cef29f59925fac19$export$873f34bfb1875202 = 'highlight-actions-portal-container';
let $cef29f59925fac19$var$popupPortalContainerWidth;
function $cef29f59925fac19$var$onResize(width) {
    // Hide popup when the container is resized.
    if (width !== $cef29f59925fac19$var$popupPortalContainerWidth) {
        $cef29f59925fac19$var$popupPortalContainerWidth = width;
        window.dispatchEvent(new CustomEvent('highlight-actions.container.resized'));
    }
}
const $cef29f59925fac19$export$8b383aca014c1850 = ()=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        id: $cef29f59925fac19$export$873f34bfb1875202,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pbyilow"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $4JDbp.WidthObserver), {
        setWidth: $cef29f59925fac19$var$onResize
    }));
}; /**
    *  In Nav4, we need to render the HighlightActionsProvider inside the #AkMainContent container instead of at the top of
    *  our app in <App />. This is because Nav4 uses a grid. So in Nav4 the window itself no longer scrolls; the #AkMainContent
    *  element does.
    *
    *  These HighlightActionsProviderForNav3 and HighlightActionsProviderForNav4 components allow us to render
    *  HighlightActions in different places depending on which nav is enabled.
    */ 
const $cef29f59925fac19$export$84dec73d5759755c = ()=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(); // render null for first render during hydration to prevent mismatch
    if (renderServerPlaceholder) return null;
    return (0, $1dnxO.getIsNav4Enabled)() ? null : /*#__PURE__*/ $42omo.createElement($cef29f59925fac19$export$8b383aca014c1850, null);
}; // Only renders the Highlight Actions Provider if we're using Nav4
const $cef29f59925fac19$export$68a992a5cacaa78b = ()=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(); // render null for first render during hydration to prevent mismatch
    if (renderServerPlaceholder) return null;
    return (0, $1dnxO.getIsNav4Enabled)() ? /*#__PURE__*/ $42omo.createElement($cef29f59925fac19$export$8b383aca014c1850, null) : null;
};
module.exports["popupPortalContainerId"] = $cef29f59925fac19$export$873f34bfb1875202;
module.exports["HighlightActionsProviderForNav3"] = $cef29f59925fac19$export$84dec73d5759755c;
module.exports["HighlightActionsProviderForNav4"] = $cef29f59925fac19$export$68a992a5cacaa78b;

});

parcelRegister("4JDbp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $i7RGj = parcelRequire("i7RGj");

const $b400565b9de87bc3$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$export$b2ad68b9bc407b80;
module.exports["WidthObserver"] = $b400565b9de87bc3$export$b2ad68b9bc407b80;

});

parcelRegister("i7RGj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5EteX = parcelRequire("5EteX");

const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5EteX.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $0e043a05e9b77ebf$export$ff983d2a2b6112ea;

});

parcelRegister("5EteX", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $63cd7642b16dfa22$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}
module.exports["useInView"] = $63cd7642b16dfa22$export$2f62ee6831462844;

});

parcelRegister("l4eiF", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $79f107ddc4d1b489$var$defaultState = {
    firstHighlightShown: false
};
const $79f107ddc4d1b489$export$ca9047e33beaf8b2 = (0, $42omo.createContext)($79f107ddc4d1b489$var$defaultState);
$79f107ddc4d1b489$export$ca9047e33beaf8b2.displayName = 'HighlightActionsContext';
module.exports["HighlightActionsContext"] = $79f107ddc4d1b489$export$ca9047e33beaf8b2;

});

parcelRegister("b1ynj", function(module, exports) {
/* OtherActions.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ghftu = parcelRequire("ghftu");


var $4KS7f = parcelRequire("4KS7f");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $1s5hv = parcelRequire("1s5hv");


var $9VJDA = parcelRequire("9VJDA");


var $jdPfT = parcelRequire("jdPfT");


var $tvI67 = parcelRequire("tvI67");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");


var $gj7hi = parcelRequire("gj7hi");


var $inPa6 = parcelRequire("inPa6");


var $6UWPx = parcelRequire("6UWPx");

var $iIVVb = parcelRequire("iIVVb");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4vC63 = parcelRequire("4vC63");


var $9fBoq = parcelRequire("9fBoq");


var $4GDP8 = parcelRequire("4GDP8");


var $1mDVg = parcelRequire("1mDVg");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $f5df649ae1312176$var$i18n = (0, $cgtv4.defineMessages)({
    selectApp: {
        id: "highlight-actions.select.app",
        defaultMessage: "Select app"
    },
    apps: {
        id: "highlight-actions.dropdown-group.apps",
        defaultMessage: "Apps"
    }
});
const $f5df649ae1312176$var$oldDropdownTriggerWrapperStyle = null;
const $f5df649ae1312176$var$dropdownTriggerWrapperStyle = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5df649ae1312176$var$PopupPaddingContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt44ar7",
            __cmplp.className
        ])
    });
});
const $f5df649ae1312176$var$dropdownComponentListStyle = null;
const $f5df649ae1312176$var$iconImageStyle = null;
const $f5df649ae1312176$var$noIconWrapperStyle = null;
const $f5df649ae1312176$export$c01fdef1354c759b = ({ builtInActions: builtInActions = [], connectItems: connectItems, forgeItems: forgeItems = [], selectForgeExtension: selectForgeExtension = ()=>{} })=>{
    const intl = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true);
    const fireOverflowMenuAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                name: 'button clicked - highlightActionsMenuOverflow',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'highlightActionsMenuOverflow',
                source: 'highlightActionsMenu',
                type: 'ui',
                attributes: {
                    pageMode: (0, $1mDVg.PageMode).VIEW
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onClose = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]); // TODO: ED-29224 - update DropdownItem to ToolbarDropdownItem
    const connectComponents = (0, $42omo.useMemo)(()=>connectItems.map((item)=>{
            return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ $42omo.createElement("div", {
                className: item.styleClass
            }, /*#__PURE__*/ $42omo.createElement((0, $dAYOx.default), {
                key: item.completeKey,
                "data-key": item.completeKey,
                href: item.url,
                title: item.label,
                shouldTitleWrap: false,
                elemBefore: item?.icon?.path ? /*#__PURE__*/ $42omo.createElement((0, $gj7hi.default), {
                    src: item.icon.path,
                    className: (0, $gMc0m.default)([
                        "_4t3i1tcg _1bsb1tcg"
                    ])
                }) : /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                    label: ""
                })
            }, item.label)) : /*#__PURE__*/ $42omo.createElement((0, $4KS7f.default), {
                iconBefore: item?.icon?.path ? /*#__PURE__*/ $42omo.createElement((0, $gj7hi.default), {
                    src: item.icon.path,
                    className: (0, $gMc0m.default)([
                        "_4t3i1tcg _1bsb1tcg"
                    ])
                }) : /*#__PURE__*/ $42omo.createElement("div", {
                    className: (0, $gMc0m.default)([
                        "_2rko1rr0 _1bsb1tcg _4t3i1tcg _bfhkby5v _1e0c1txw _4cvr1h6o _1bah1b1v"
                    ])
                }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                    label: "No icon",
                    color: "var(--ds-icon-disabled, #080F214A)"
                })),
                key: item.completeKey,
                appearance: "subtle",
                "data-key": item.completeKey,
                className: item.styleClass,
                href: item.url,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    textAlign: 'left',
                    // we can't wrap Button with `styled` as inner styles override this
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    borderRadius: 0
                },
                shouldFitContainer: true,
                title: item.label
            }, item.label);
        }), [
        connectItems
    ]); // TODO: ED-29224 - update DropdownItem to ToolbarDropdownItem
    const forgeComponents = (0, $42omo.useMemo)(()=>forgeItems.map((item)=>{
            const appTitle = (0, $9fBoq.extensionTitle)(item);
            return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $42omo.createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
                key: item.id,
                module: item
            }, /*#__PURE__*/ $42omo.createElement((0, $dAYOx.default), {
                key: item.id,
                title: appTitle,
                shouldTitleWrap: false,
                elemBefore: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                    label: ""
                }),
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_FORGE_EXPERIENCE),
                        id: item.id,
                        timeout: 10000
                    });
                    selectForgeExtension(item);
                }
            }, appTitle)) : /*#__PURE__*/ $42omo.createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
                key: item.id,
                module: item
            }, /*#__PURE__*/ $42omo.createElement((0, $4KS7f.default), {
                key: item.id,
                id: item.id,
                appearance: "subtle",
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    textAlign: 'left',
                    // we can't wrap Button with `styled` as inner styles override this
                    paddingLeft: connectItems.length ? '40px' : '8px',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    borderRadius: 0
                },
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_FORGE_EXPERIENCE),
                        id: item.id,
                        timeout: 10000
                    });
                    selectForgeExtension(item);
                },
                shouldFitContainer: true,
                title: appTitle
            }, appTitle));
        }), [
        connectItems,
        forgeItems,
        selectForgeExtension,
        experienceTracker
    ]);
    const forgeKeyboardShortcuts = (0, $42omo.useMemo)(()=>forgeItems.map((module)=>/*#__PURE__*/ $42omo.createElement((0, $4vC63.ForgeKeyboardShortcut), {
                key: module.id,
                module: module,
                action: ()=>{
                    (0, $4GDP8.openContextMenuClick)();
                    (0, $4GDP8.simulateItemClick)(module.id);
                    (0, $4GDP8.simulateItemMouseOver)(module.id);
                }
            })), [
        forgeItems
    ]);
    const dropDownComponents = (0, $42omo.useMemo)(()=>{
        const oldToolbarComponents = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $42omo.createElement("div", {
            "data-testid": "context-menu-dropdown-groups"
        }, builtInActions.length > 0 && /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), {
            testId: "context-menu-dropdown-group-builtin"
        }, builtInActions), Boolean(connectItems.length || forgeItems.length) && /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), {
            hasSeparator: builtInActions.length > 0,
            title: intl.formatMessage($f5df649ae1312176$var$i18n.apps),
            testId: "context-menu-dropdown-group-apps"
        }, connectComponents, forgeComponents)) : /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                "_18s8ax2b _1e0c1txw _2lx21bp4 _ca0qu2gc _n3tdu2gc _18m91wug _c71l1mjv _p12f1mjv"
            ])
        }, connectComponents, forgeComponents);
        return isNewToolbarEnabled ? /*#__PURE__*/ $42omo.createElement("div", {
            "data-testid": "context-menu-dropdown-groups"
        }, builtInActions.length > 0 && /*#__PURE__*/ $42omo.createElement((0, $6UWPx.ToolbarDropdownItemSection), {
            testId: "context-menu-dropdown-group-builtin"
        }, builtInActions), Boolean(connectItems.length || forgeItems.length) && /*#__PURE__*/ $42omo.createElement((0, $6UWPx.ToolbarDropdownItemSection), {
            hasSeparator: builtInActions.length > 0,
            title: intl.formatMessage($f5df649ae1312176$var$i18n.apps),
            testId: "context-menu-dropdown-group-apps"
        }, connectComponents, forgeComponents)) : oldToolbarComponents;
    }, [
        isNewToolbarEnabled,
        builtInActions,
        connectItems.length,
        forgeItems.length,
        intl,
        connectComponents,
        forgeComponents
    ]); // TODO: ED-29221 - use ToolbarDropdownMenu
    if (isNewToolbarEnabled) {
        if (!connectItems.length && !forgeItems.length && !builtInActions.length) return null;
        return /*#__PURE__*/ $42omo.createElement((0, $iIVVb.ToolbarTooltip), {
            content: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp)
        }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
            shouldRenderToParent: true,
            placement: "bottom-start",
            isOpen: isOpen,
            onOpenChange: (attrs)=>{
                setIsOpen(attrs.isOpen);
            },
            trigger: (triggerProps)=>/*#__PURE__*/ $42omo.createElement("div", {
                    ...triggerProps,
                    ref: triggerProps.triggerRef,
                    id: "context-menu-other-apps",
                    "data-testId": "context-menu-other-apps",
                    className: (0, $gMc0m.default)([
                        "_1e0c1txw _4cvr1h6o _ca0q1b66 _n3td1b66 _u5f31b66"
                    ])
                }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                    appearance: "subtle",
                    isSelected: isOpen,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                    isTooltipDisabled: false,
                    label: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp),
                    testId: "highlight-actions-show-more",
                    onClick: fireOverflowMenuAnalytics
                }), forgeKeyboardShortcuts)
        }, dropDownComponents));
    }
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
        if (!connectItems.length && !forgeItems.length && !builtInActions.length) return null;
    } else {
        if (!connectItems.length && !forgeItems.length) return null;
    }
    return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        isOpen: isOpen,
        onOpenChange: (attrs)=>{
            setIsOpen(attrs.isOpen);
        },
        trigger: (triggerProps)=>/*#__PURE__*/ $42omo.createElement("div", {
                ...triggerProps,
                ref: triggerProps.triggerRef,
                id: "context-menu-other-apps",
                "data-testId": "context-menu-other-apps",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _4cvr1h6o _ca0q1b66 _n3td1b66 _u5f31b66"
                ])
            }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                appearance: "subtle",
                isSelected: isOpen,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                isTooltipDisabled: false,
                label: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp),
                testId: "highlight-actions-show-more",
                onClick: fireOverflowMenuAnalytics
            }), forgeKeyboardShortcuts)
    }, dropDownComponents) : /*#__PURE__*/ $42omo.createElement((0, $lGgRw.default), {
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        autoFocus: false,
        content: ()=>/*#__PURE__*/ $42omo.createElement($f5df649ae1312176$var$PopupPaddingContainer, null, dropDownComponents),
        trigger: (triggerProps)=>/*#__PURE__*/ $42omo.createElement("div", {
                ...triggerProps,
                className: (0, $gMc0m.default)([
                    (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && "_1yt4v77o _1e0c1txw _4cvr1h6o _f7xt1osq _16711osq _5jgi1h6o _1d841h6o"
                ])
            }, /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
                content: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp)
            }, (tooltipProps)=>/*#__PURE__*/ $42omo.createElement((0, $4KS7f.default), {
                    ...tooltipProps,
                    id: "context-menu-other-apps",
                    "aria-expanded": isOpen,
                    appearance: "subtle",
                    isSelected: isOpen,
                    onClick: ()=>setIsOpen(!isOpen),
                    iconBefore: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                        label: "",
                        spacing: "spacious",
                        testId: "highlight-actions-show-more"
                    }) : /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
                        alignItems: "center",
                        gap: "space.050"
                    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
                        label: ""
                    }), /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        label: "Drop down",
                        testId: "highlight-actions-show-more",
                        size: "small"
                    })),
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        margin: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? undefined : "var(--ds-space-025, 2px)",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        marginLeft: "var(--ds-space-negative-025, -2px)"
                    },
                    testId: "context-menu-other-apps"
                })), forgeKeyboardShortcuts),
        shouldRenderToParent: (0, $dh538.fg)('should-render-to-parent-should-be-truecomments')
    });
};
module.exports["OtherActions"] = $f5df649ae1312176$export$c01fdef1354c759b;

});

parcelRegister("4vC63", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("bflGB", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $lisKW = parcelRequire("lisKW");

parcelRequire("4ARHe");


var $l65Bo = parcelRequire("l65Bo");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $1k6sE = parcelRequire("1k6sE");


var $4q9NN = parcelRequire("4q9NN");

if (typeof window !== 'undefined') {
    // allow to track events on specific elements
    const originalStopCallback = (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).prototype.stopCallback;
    // Note here should be function instead of arrow function as we want to preserve the context of this
    (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).prototype.stopCallback = function(...[e, element, combo]) {
        const isAllowed = (0, $1k6sE.MOUSETRAP_ALLOWED_ELEMENTS).map((className)=>element.classList.contains(className)).some((truthful)=>truthful);
        const isAllowedInModal = (0, $1k6sE.MOUSETRAP_ALLOWED_MODALS).map((className)=>element.closest(`.${className}`)).some((truthful)=>truthful);
        return isAllowed || isAllowedInModal ? false : originalStopCallback.call(this, e, element, combo);
    };
}
const $299ae5ea83dc6310$var$ALLOWED_MIN_TIME = 150;
var $299ae5ea83dc6310$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["Confluence"] = "Confluence";
    ShortcutType["Forge"] = "Forge";
    return ShortcutType;
}({});
class $299ae5ea83dc6310$export$d29b063d6e86bfeb extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        this.checkConflictThenBindAccelerator(accelerator, shortcutType);
    }
    componentDidUpdate(prevProps) {
        const { accelerator: prevAccelerator } = prevProps;
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        const prevAccelerators = this.getAccelerators(prevAccelerator);
        // Using JSON.stringify to compare because accelerator may be a list of strings
        if (JSON.stringify(prevAccelerator) !== JSON.stringify(accelerator)) {
            this.unbindAccelerators(prevAccelerators);
            this.checkConflictThenBindAccelerator(accelerator, shortcutType);
        }
    }
    componentWillUnmount() {
        const { accelerator: accelerator } = this.props;
        const accelerators = this.getAccelerators(accelerator);
        this.unbindAccelerators(accelerators);
    }
    getAccelerators(accelerator) {
        return Array.isArray(accelerator) ? accelerator : [
            accelerator
        ];
    }
    getShortcutConflicts(accelerators) {
        return accelerators.map((a)=>({
                accelerator: a,
                conflictType: $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a]
            })).filter((o)=>o.conflictType);
    }
    isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts) {
        return shortcutType === "Confluence" && shortcutConflicts.every((o)=>o.conflictType === "Forge");
    }
    checkConflictThenBindAccelerator(accelerator, shortcutType) {
        const accelerators = this.getAccelerators(accelerator);
        const shortcutConflicts = this.getShortcutConflicts(accelerators);
        if (!shortcutConflicts.length) this.bindAccelerators(accelerators, shortcutType);
        else if (this.isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts)) {
            shortcutConflicts.forEach((c)=>(0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).unbind(c.accelerator));
            this.bindAccelerators(accelerators, shortcutType);
        }
    }
    bindAccelerators(accelerators, shortcutType) {
        accelerators.forEach((a)=>{
            if (a.includes('+') && shortcutType !== "Forge" && typeof (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).bindGlobal === 'function') // bindGlobal allows shortcut to work when a input field is focused, see https://github.com/ccampbell/mousetrap/blob/master/plugins/global-bind/README.md
            // This allows user to use shortcut to publish the page when focusing on editor title
            (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).bindGlobal(a, this._call);
            else (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).bind(a, this._call);
            $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a] = shortcutType;
        });
    }
    unbindAccelerators(accelerators) {
        accelerators.forEach((a)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).unbind(a);
            delete $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a];
        });
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.listeners = {};
        this.lastFired = 0;
        this._call = (e, combo)=>{
            // User can only fire a shortcut event in every 150ms
            // This can avoid a part of sequence being recognized as a single key shortcut
            // eg: "s" will be triggered when user enters "g s" without this
            const now = Date.now();
            if (now - this.lastFired >= $299ae5ea83dc6310$var$ALLOWED_MIN_TIME) {
                if (this.props.allowInDialog || !(0, $l65Bo.isDialogShown)()) {
                    this.lastFired = now;
                    this.props.listener(e, combo);
                }
            }
        };
    }
}
$299ae5ea83dc6310$export$d29b063d6e86bfeb.defaultProps = {
    allowInDialog: false,
    shortcutType: "Confluence"
};
$299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners = {};
const $299ae5ea83dc6310$var$ShortcutListenerFC = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(22);
    let accelerator;
    let deprecatedAccelerator;
    let flags;
    let listener;
    let otherProps;
    if ($[0] !== t0) {
        ({ flags: flags, deprecatedAccelerator: deprecatedAccelerator, accelerator: accelerator, listener: listener, ...otherProps } = t0);
        $[0] = t0;
        $[1] = accelerator;
        $[2] = deprecatedAccelerator;
        $[3] = flags;
        $[4] = listener;
        $[5] = otherProps;
    } else {
        accelerator = $[1];
        deprecatedAccelerator = $[2];
        flags = $[3];
        listener = $[4];
        otherProps = $[5];
    }
    let t1;
    if ($[6] !== accelerator || $[7] !== deprecatedAccelerator || $[8] !== flags || $[9] !== listener) {
        t1 = (e, combo)=>{
            if ((0, $9wGTI.fg)("confluence_frontend_shortcut_deprecation_flag")) (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
                flags: flags,
                acceleratorTriggered: combo,
                accelerator: accelerator,
                deprecatedAccelerator: deprecatedAccelerator
            });
            listener(e, combo);
        };
        $[6] = accelerator;
        $[7] = deprecatedAccelerator;
        $[8] = flags;
        $[9] = listener;
        $[10] = t1;
    } else t1 = $[10];
    const deprecatedListener = t1;
    let t2;
    if ($[11] !== deprecatedAccelerator || $[12] !== deprecatedListener || $[13] !== otherProps) {
        t2 = deprecatedAccelerator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: deprecatedAccelerator,
            listener: deprecatedListener,
            ...otherProps
        });
        $[11] = deprecatedAccelerator;
        $[12] = deprecatedListener;
        $[13] = otherProps;
        $[14] = t2;
    } else t2 = $[14];
    let t3;
    if ($[15] !== accelerator || $[16] !== listener || $[17] !== otherProps) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: accelerator,
            listener: listener,
            ...otherProps
        });
        $[15] = accelerator;
        $[16] = listener;
        $[17] = otherProps;
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== t2 || $[20] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t2, t3);
        $[19] = t2;
        $[20] = t3;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
} : ({ flags: flags, deprecatedAccelerator: deprecatedAccelerator, accelerator: accelerator, listener: listener, ...otherProps })=>{
    const deprecatedListener = (0, $42omo.useCallback)((e, combo)=>{
        if ((0, $9wGTI.fg)('confluence_frontend_shortcut_deprecation_flag')) (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
            flags: flags,
            acceleratorTriggered: combo,
            accelerator: accelerator,
            deprecatedAccelerator: deprecatedAccelerator
        });
        listener(e, combo);
    }, [
        listener,
        accelerator,
        deprecatedAccelerator,
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /* This 2nd ShortcutListenerInternal is used to also display a flag informing the user
        that the shortcut they used is deprecated, while still triggering the listener. */ deprecatedAccelerator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
        accelerator: deprecatedAccelerator,
        listener: deprecatedListener,
        ...otherProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
        accelerator: accelerator,
        listener: listener,
        ...otherProps
    }));
};
const $299ae5ea83dc6310$export$52e6eadeebf8c534 = (0, $7aRa9.withFlags)($299ae5ea83dc6310$var$ShortcutListenerFC);
module.exports["ShortcutType"] = $299ae5ea83dc6310$export$99058db374262376;
module.exports["ShortcutListener"] = $299ae5ea83dc6310$export$52e6eadeebf8c534;

});

parcelRegister("lisKW", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.5
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */ var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
     * loop through to map numbers on the numeric keypad
     */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
         * element to attach key events to
         *
         * @type {Element}
         */ self.target = targetElement;
        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */ self._callbacks = {};
        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */ self._directMap = {};
        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */ var _sequenceLevels = {};
        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */ var _resetTimer;
        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */ var _ignoreNextKeyup = false;
        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */ var _ignoreNextKeypress = false;
        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */ var _nextExpectedAction = false;
        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
        // not the initial event target in the shadow tree. Note that not all events cross the
        // shadow boundary.
        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
        // target cannot be obtained.
        if ('composedPath' in e && typeof e.composedPath === 'function') {
            // For open shadow trees, update `element` so that the following check works.
            var initialEventTarget = e.composedPath()[0];
            if (initialEventTarget !== e.target) element = initialEventTarget;
        }
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (0, module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});

parcelRegister("4ARHe", function(module, exports) {
/**
 * adds a bindGlobal method to Mousetrap that allows you to
 * bind specific keyboard shortcuts that will still work
 * inside a text input field
 *
 * usage:
 * Mousetrap.bindGlobal('ctrl+s', _saveChanges);
 */ /* global Mousetrap:true */ (function(Mousetrap1) {
    if (!Mousetrap1) return;
    var _globalCallbacks = {};
    var _originalStopCallback = Mousetrap1.prototype.stopCallback;
    Mousetrap1.prototype.stopCallback = function(e, element, combo, sequence) {
        var self = this;
        if (self.paused) return true;
        if (_globalCallbacks[combo] || _globalCallbacks[sequence]) return false;
        return _originalStopCallback.call(self, e, element, combo);
    };
    Mousetrap1.prototype.bindGlobal = function(keys, callback, action) {
        var self = this;
        self.bind(keys, callback, action);
        if (keys instanceof Array) {
            for(var i = 0; i < keys.length; i++)_globalCallbacks[keys[i]] = true;
            return;
        }
        _globalCallbacks[keys] = true;
    };
    Mousetrap1.init();
})(typeof Mousetrap !== "undefined" ? Mousetrap : undefined);

});

parcelRegister("l65Bo", function(module, exports) {
// we'd like to be able to check if the dialog is displaying right now
const $0afa19b4dc37db45$export$f0b76e53a3d1db73 = ()=>{
    const portals = Array.from(document.getElementsByClassName('atlaskit-portal')).filter((portal)=>portal.firstChild);
    const isAtlaskitDialogShown = Boolean(portals.filter((item)=>item.querySelectorAll('[role="dialog"]').length).length);
    const isLoomRecorderDialogShown = Boolean(document.getElementById('loom-sdk-record-overlay-shadow-root-id')?.shadowRoot?.getElementById('preview-recording'));
    return isAtlaskitDialogShown || isLoomRecorderDialogShown;
};
module.exports["isDialogShown"] = $0afa19b4dc37db45$export$f0b76e53a3d1db73;

});

parcelRegister("1k6sE", function(module, exports) {

var $gnkil = parcelRequire("gnkil");


var $9aQ0J = parcelRequire("9aQ0J");

const $ca7c59da1dc6c0fe$export$d05888cf23195902 = 'shortcuts-are-allowed';
const $ca7c59da1dc6c0fe$export$ccca490433ac184a = 'shortcuts-are-allowed-in-modal';
const $ca7c59da1dc6c0fe$export$95466aa5e4023a13 = [
    'ProseMirror-focused',
    $ca7c59da1dc6c0fe$export$d05888cf23195902
];
const $ca7c59da1dc6c0fe$export$eca1f9acdad825ae = [
    $ca7c59da1dc6c0fe$export$ccca490433ac184a
];
const $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7 = Object.values($gnkil).reduce((0, $9aQ0J.getShortcutValues), []);
module.exports["ALLOW_SHORTCUTS_CLASS"] = $ca7c59da1dc6c0fe$export$d05888cf23195902;
module.exports["ALLOW_SHORTCUTS_CLASS_IN_MODAL"] = $ca7c59da1dc6c0fe$export$ccca490433ac184a;
module.exports["MOUSETRAP_ALLOWED_ELEMENTS"] = $ca7c59da1dc6c0fe$export$95466aa5e4023a13;
module.exports["MOUSETRAP_ALLOWED_MODALS"] = $ca7c59da1dc6c0fe$export$eca1f9acdad825ae;
module.exports["RESERVED_SHORTCUTS"] = $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7;

});

parcelRegister("9aQ0J", function(module, exports) {
const $a5d5607ba4daeddb$export$58cbf3bcb054e9cd = (accumulated, current)=>{
    if (typeof current === 'string') accumulated.push(current);
    else if (typeof current === 'object') accumulated.push(...Object.values(current).reduce($a5d5607ba4daeddb$export$58cbf3bcb054e9cd, []));
    return accumulated;
};
module.exports["getShortcutValues"] = $a5d5607ba4daeddb$export$58cbf3bcb054e9cd;

});

parcelRegister("4q9NN", function(module, exports) {
/* DeprecatedShortcutFlag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $4tOXV = parcelRequire("4tOXV");

const $3c4669a4d8882aac$var$i18n = (0, $cgtv4.defineMessages)({
    deprecatedShortcutFlagTitle: {
        id: "shortcuts.deprecated-shortcut-flag.title",
        defaultMessage: "This shortcut is about to change"
    },
    deprecatedShortcutFlagDescription: {
        id: "shortcuts.deprecated-shortcut-flag.description",
        defaultMessage: "Shortcuts are switching to a <supportLink>universal format</supportLink>. <inline>{oldShortcut} will now be {newShortcut}</inline>"
    },
    remindMeLaterButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.remind-me-later",
        defaultMessage: "Remind me later"
    },
    dontTellMeAgainButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.dont-tell-me-again",
        defaultMessage: "Don\u2019t tell me again"
    }
});
const $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/keyboard-shortcuts-markdown-and-autocomplete/';
const $3c4669a4d8882aac$var$shortcutSentenceCss = null;
const $3c4669a4d8882aac$var$getShortcutDescription = ({ oldShortcut: oldShortcut, newShortcut: newShortcut, acceleratorTriggered: acceleratorTriggered })=>{
    let newS = Array.isArray(newShortcut) ? newShortcut[0] : newShortcut; // ShortcutListener allows for multiple accelerators to be specified for one callback.  Ex. ["a", "mod+9"].
    // If any of those are triggerred, the callback will activate.
    // This makes it a little tricky to figure out what accelerator to recommend as a replacement.
    // Ex. deprecatedAccelerator: ["a", "b"], accelerator: ["mod+a", "mod+b"]
    // - If multiple accelerators are available in `newShortcut`, we default to the first one.
    // - However, if an equal number of accelerators are available in `oldShortcut` and `newShortcut`,
    //   then we look for the accelerator corresponding with the one that was actually triggered,
    //   based on array index.
    if (Array.isArray(oldShortcut) && Array.isArray(newShortcut) && oldShortcut.length === newShortcut.length) {
        const triggeredIndex = oldShortcut.indexOf(acceleratorTriggered);
        if (triggeredIndex >= 0 && triggeredIndex < newShortcut.length) newS = newShortcut[triggeredIndex];
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagDescription,
        values: {
            supportLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK
                }, chunks),
            oldShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: acceleratorTriggered
            }),
            newShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: newS
            }),
            inline: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    className: (0, $gMc0m.default)([
                        "_zulpv77o _1e0c1txw _4cvr1h6o"
                    ])
                }, chunks)
        }
    });
};
const $3c4669a4d8882aac$var$FOREVER = 'forever';
const $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID = 'deprecatedShortcutFlag';
const $3c4669a4d8882aac$var$shouldShowDeprecationFlag = ()=>{
    const hiddenUntilTime = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL) || '';
    if (hiddenUntilTime === $3c4669a4d8882aac$var$FOREVER) return false;
    else if (hiddenUntilTime !== '') {
        const hiddenUntilTimeInMs = Number(hiddenUntilTime);
        if (!isNaN(hiddenUntilTimeInMs)) return Date.now() > hiddenUntilTimeInMs;
    }
    return true;
};
const $3c4669a4d8882aac$export$799f01f4b30e66c7 = ({ flags: flags, acceleratorTriggered: acceleratorTriggered, accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator })=>{
    if ($3c4669a4d8882aac$var$shouldShowDeprecationFlag()) flags.showFlag({
        id: $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagTitle),
        description: $3c4669a4d8882aac$var$getShortcutDescription({
            oldShortcut: deprecatedAccelerator,
            newShortcut: accelerator,
            acceleratorTriggered: acceleratorTriggered
        }),
        type: 'success',
        close: 'never',
        // Needed to bypass the flags.hideAllFlags() that happens on some page transitions.
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3c4669a4d8882aac$var$i18n.remindMeLaterButton),
                onClick: ()=>{
                    // Hide the prompt for 7 days.
                    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, Date.now() + 604800000);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3c4669a4d8882aac$var$i18n.dontTellMeAgainButton),
                onClick: ()=>{
                    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, $3c4669a4d8882aac$var$FOREVER);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            }
        ]
    });
};
module.exports["maybeShowDeprecatedShortcutFlag"] = $3c4669a4d8882aac$export$799f01f4b30e66c7;

});

parcelRegister("4GDP8", function(module, exports) {
function $d27310b4a47ce627$var$keepTrying(fn, times, interval) {
    if (!fn() && times) setTimeout(()=>$d27310b4a47ce627$var$keepTrying(fn, times - 1, interval), interval);
}
function $d27310b4a47ce627$var$waitForDom(itemId) {
    return new Promise((resolve)=>{
        function lookForItem() {
            const targetItem = document.querySelector(itemId);
            if (targetItem) {
                clearInterval(checkInterval);
                resolve(true);
            }
        }
        // Start an interval to check for the item every 10ms
        const checkInterval = setInterval(lookForItem, 10);
        // Fail silently if the item isn't found after 5000ms
        setTimeout(()=>{
            clearInterval(checkInterval);
            resolve(false);
        }, 5000);
    });
}
function $d27310b4a47ce627$var$isForgeModule(itemId) {
    return itemId.startsWith('ari:cloud:ecosystem::extension');
}
function $d27310b4a47ce627$var$escapeForgeModuleKey(itemId) {
    return itemId.replace(/\//g, '\\/').replace(/:/g, '\\:');
}
function $d27310b4a47ce627$var$getItemSelector(itemId) {
    if (!itemId || !itemId.length) return;
    let itemSelector = itemId[0] === '#' ? itemId : `#${itemId}`;
    if ($d27310b4a47ce627$var$isForgeModule(itemId)) itemSelector = $d27310b4a47ce627$var$escapeForgeModuleKey(itemSelector);
    return itemSelector;
}
async function $d27310b4a47ce627$export$6bd4cdcdf3940391({ parentmenuId: parentmenuId, submenuId: submenuId, forgeItemId: forgeItemId }) {
    // Make sure the forge item has a valid id
    const forgeItemSelector = $d27310b4a47ce627$var$getItemSelector(forgeItemId);
    if (!forgeItemSelector) return;
    $d27310b4a47ce627$var$openMenu(parentmenuId);
    const foundSubmenu = await $d27310b4a47ce627$var$waitForDom(submenuId);
    if (!foundSubmenu) return;
    $d27310b4a47ce627$var$openMenu(submenuId);
    const foundForgeItem = await $d27310b4a47ce627$var$waitForDom(forgeItemSelector);
    if (!foundForgeItem) return;
    const forgeItem = document.querySelector(forgeItemSelector);
    forgeItem?.click();
}
function $d27310b4a47ce627$var$openMenu(menuId) {
    const triggerButton = document.querySelector(menuId);
    if (!triggerButton) return;
    const isOpen = triggerButton.getAttribute('aria-expanded') === 'true';
    //only care about closed case, otherwise let legacy event listener handle
    if (!isOpen) triggerButton.click();
}
function $d27310b4a47ce627$export$73ebde48694f32cd(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    $d27310b4a47ce627$var$keepTrying(()=>{
        const item = document.querySelector(itemSelector);
        if (item) {
            item.click();
            return true;
        }
    }, 100, 5);
}
function $d27310b4a47ce627$export$96aa6f6c7286ecb4(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    const event = new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true
    });
    document.querySelector(itemSelector)?.dispatchEvent(event);
}
function $d27310b4a47ce627$export$1d6f959e29b7f60d() {
    $d27310b4a47ce627$var$openMenu('#tools-menu-trigger');
}
function $d27310b4a47ce627$export$3d4ff948da3c7dd3() {
    $d27310b4a47ce627$var$openMenu('#context-menu-other-apps');
}
function $d27310b4a47ce627$export$94323a98da3bb62c() {
    $d27310b4a47ce627$var$openMenu('#more-actions-trigger');
}
module.exports["openForgeAppFromSubmenu"] = $d27310b4a47ce627$export$6bd4cdcdf3940391;
module.exports["simulateItemClick"] = $d27310b4a47ce627$export$73ebde48694f32cd;
module.exports["simulateItemMouseOver"] = $d27310b4a47ce627$export$96aa6f6c7286ecb4;
module.exports["openMenuClick"] = $d27310b4a47ce627$export$1d6f959e29b7f60d;
module.exports["openContextMenuClick"] = $d27310b4a47ce627$export$3d4ff948da3c7dd3;
module.exports["openMoreActionsMenuClick"] = $d27310b4a47ce627$export$94323a98da3bb62c;

});

parcelRegister("dj3mI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $54a4a16d7bb73c56$export$52cdeba2896092f6 = (isContentArchived, userCanAddComments, needsUpdateToComment, contentType)=>{
    if (isContentArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "highlight-actions.inline-comments.comment.unsupported.archive",
        defaultMessage: "Comments can\u2019t be added to archived items"
    });
    else if (!userCanAddComments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "highlight-actions.inline-comments.comment.no.permission",
        defaultMessage: "{contentType, select, blogpost {You do not have permission to add comments to this blogpost} page {You do not have permission to add comments to this page} other {You do not have permission to add comments to this page}}",
        values: {
            contentType: contentType
        }
    });
    else if (needsUpdateToComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "highlight-actions.inline-comments.comment.needs.update",
        defaultMessage: "Page is outdated, refresh to comment"
    });
    else if ((0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "highlight-actions.inline-comments.comment.unable.to.create",
        defaultMessage: "Unable to comment on this element"
    });
    else return (0, $9wGTI.fg)('editor_inline_comments_on_inline_nodes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "highlight-actions.inline-comments.comment.create.disabled",
        defaultMessage: "You can only comment on text, headings, emojis, dates, mentions, links, and statuses."
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "highlight-actions.inline-comments.comment.unsupported",
        defaultMessage: "Comments can only be added to text that doesn\u2019t contain an emoji, a macro, or an @mention"
    });
};
module.exports["getCreateButtonDisabledMessage"] = $54a4a16d7bb73c56$export$52cdeba2896092f6;

});

parcelRegister("6zmDz", function(module, exports) {
/* highlightActionsStyled.tsx generated by @compiled/babel-plugin v0.36.1 */ // remove this when cleanup platform_editor_controls
// WS-2881 - We need to adjust the padding for the buttons to match the editor and shrink the "Add issue" icon
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $164fd7006e7d8160$export$c5fb2fd13b5122a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4v77o _1e0c1txw _f7xt1kw7 _16711kw7 _1msb1txw _11ik1txw _5jgi1h6o _1d841h6o _3nzugktf _l4g2gktf",
            __cmplp.className
        ])
    });
});
const $164fd7006e7d8160$export$8729c6345a54240d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4v77o _1e0c1txw _f7xt1kw7 _16711kw7 _1msb1txw _11ik1txw _5jgi1h6o _1d841h6o _wzf91osq _9uby1osq _1dbr1txw _14ts1txw _1mu51h6o _wfjv1h6o _3nzugktf _l4g2gktf",
            __cmplp.className
        ])
    });
}); // remove this when cleanup platform_editor_controls
const $164fd7006e7d8160$export$d7f009f4a3abb74 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41b66 _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $164fd7006e7d8160$var$disabledButtonWrapperStyle = null;
const $164fd7006e7d8160$export$b065c4c0e869841d = (props)=>/*#__PURE__*/ $42omo.createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ])
    });
const $164fd7006e7d8160$var$disabledButtonOverlayStyle = null;
const $164fd7006e7d8160$export$dea79eb12e1f6e1f = (props)=>/*#__PURE__*/ $42omo.createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _1pby15gg _bfhk1j28 _80om13gf"
        ])
    });
const $164fd7006e7d8160$var$dividerStyleOld = null;
const $164fd7006e7d8160$export$fb1f035d38cc4d20 = (props)=>/*#__PURE__*/ $42omo.createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_18s81o9c _1bsbt94y _bfhk1l7x"
        ])
    });
const $164fd7006e7d8160$var$dividerStyle = null;
const $164fd7006e7d8160$export$2e0a83ec2e27ecbb = (props)=>/*#__PURE__*/ $42omo.createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsbt94y _bfhk1l7x _18u01b66 _2hwx1b66 _19pkr5cr _otyrr5cr"
        ])
    });
module.exports["BuiltInActionsOld"] = $164fd7006e7d8160$export$c5fb2fd13b5122a;
module.exports["BuiltInActionsPatch"] = $164fd7006e7d8160$export$8729c6345a54240d;
module.exports["BuiltInActionsSimple"] = $164fd7006e7d8160$export$d7f009f4a3abb74;
module.exports["DisabledButtonWrapper"] = $164fd7006e7d8160$export$b065c4c0e869841d;
module.exports["DisabledButtonOverlay"] = $164fd7006e7d8160$export$dea79eb12e1f6e1f;
module.exports["DividerOld"] = $164fd7006e7d8160$export$fb1f035d38cc4d20;
module.exports["Divider"] = $164fd7006e7d8160$export$2e0a83ec2e27ecbb;

});

parcelRegister("97kfW", function(module, exports) {
// want color of icon to be the same for regular/light/dark modes

var $42omo = parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");

const $12914a8fd53705f4$var$lightBlueColor = (0, $6fnsQ.B200);
const $12914a8fd53705f4$var$blueColor = (0, $6fnsQ.B400);
const $12914a8fd53705f4$var$greyColor = "var(--ds-icon-disabled, #080F214A)";
const $12914a8fd53705f4$export$eaf821108be3620b = ({ greyed: greyed = false, size: size = 'small' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: size === 'smaller' ? '16' : size === 'small' ? '18' : '24',
        height: size === 'smaller' ? '16' : size === 'small' ? '18' : '24',
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.1699 12C17.1699 11.4477 17.6176 11 18.1699 11H19.9999C20.5522 11 20.9999 11.4477 20.9999 12C20.9999 12.5523 20.5522 13 19.9999 13H18.1699C17.6176 13 17.1699 12.5523 17.1699 12Z",
        fill: "url(#paint0_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: "url(#paint1_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: "url(#paint2_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.1699C12.5523 17.1699 13 17.6176 13 18.1699V19.9999C13 20.5522 12.5523 20.9999 12 20.9999C11.4477 20.9999 11 20.5522 11 19.9999V18.1699C11 17.6176 11.4477 17.1699 12 17.1699Z",
        fill: "url(#paint3_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6834 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint0_linear_1733_293438",
        x1: "20.9999",
        y1: "12",
        x2: "17.4999",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.270833",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint1_linear_1733_293438",
        x1: "12.5",
        y1: "3",
        x2: "12.5",
        y2: "6.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.1875",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint2_linear_1733_293438",
        x1: "6.82996",
        y1: "12",
        x2: "3.32996",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.791667",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint3_linear_1733_293438",
        x1: "12.5",
        y1: "16.9999",
        x2: "12.5",
        y2: "20.9999",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.802083",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }))));
module.exports["AtlassianIntelligenceIcon"] = $12914a8fd53705f4$export$eaf821108be3620b;

});

parcelRegister("5iBet", function(module, exports) {

let $3dbb83cc91d556d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3dbb83cc91d556d0$var$load("hpN5y").then(()=>parcelRequire('jhEjP'));

});

parcelRegister("hTOMB", function(module, exports) {

let $d07ef72b83014dce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d07ef72b83014dce$var$load("1QdXB"),
    $d07ef72b83014dce$var$load("6wr18"),
    $d07ef72b83014dce$var$load("ffEVr"),
    $d07ef72b83014dce$var$load("8Gekp"),
    $d07ef72b83014dce$var$load("aSmvL")
]).then(()=>parcelRequire('1TWCG'));

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("hikEX"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("bDrX3"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("dRnHK"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("Xa6vQ"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("eAfoq"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("ky4sQ"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("6mzeb"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("9wO8q"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("grnpV"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("6Dnfz"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("dPozq"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("gWkGT"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("hikEX", function(module, exports) {

let $c97424b18591c027$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c97424b18591c027$var$load("2YffH"),
    $c97424b18591c027$var$load("8Kivm"),
    $c97424b18591c027$var$load("cf5vC"),
    $c97424b18591c027$var$load("fCnmZ"),
    $c97424b18591c027$var$load("6bYkZ"),
    $c97424b18591c027$var$load("iQ0Jm"),
    $c97424b18591c027$var$load("coJiW"),
    $c97424b18591c027$var$load("dVAT5"),
    $c97424b18591c027$var$load("fIFgO"),
    $c97424b18591c027$var$load("h4Nf7"),
    $c97424b18591c027$var$load("7f9Fz"),
    $c97424b18591c027$var$load("8YSo7"),
    $c97424b18591c027$var$load("9AHrA"),
    $c97424b18591c027$var$load("2spqH"),
    $c97424b18591c027$var$load("gWSdF"),
    $c97424b18591c027$var$load("6FuHS"),
    $c97424b18591c027$var$load("eyaRC"),
    $c97424b18591c027$var$load("g9CVe"),
    $c97424b18591c027$var$load("aeEUI"),
    $c97424b18591c027$var$load("hRUX7"),
    $c97424b18591c027$var$load("g4oYs"),
    $c97424b18591c027$var$load("6wr18"),
    $c97424b18591c027$var$load("kjZZD"),
    $c97424b18591c027$var$load("a71qb"),
    $c97424b18591c027$var$load("eHDb1"),
    $c97424b18591c027$var$load("2zUEf"),
    $c97424b18591c027$var$load("37ldp"),
    $c97424b18591c027$var$load("awqCy"),
    $c97424b18591c027$var$load("kHOMt"),
    $c97424b18591c027$var$load("hhss7"),
    $c97424b18591c027$var$load("8FbYE"),
    $c97424b18591c027$var$load("dUevD"),
    $c97424b18591c027$var$load("iZU4p"),
    $c97424b18591c027$var$load("Wowvf"),
    $c97424b18591c027$var$load("dS0Pr"),
    $c97424b18591c027$var$load("huYla"),
    $c97424b18591c027$var$load("f1NVy"),
    $c97424b18591c027$var$load("2haIE"),
    $c97424b18591c027$var$load("9K4jq"),
    $c97424b18591c027$var$load("let0D"),
    $c97424b18591c027$var$load("aqr2D"),
    $c97424b18591c027$var$load("6M36W"),
    $c97424b18591c027$var$load("ffEVr"),
    $c97424b18591c027$var$load("kUbUu"),
    $c97424b18591c027$var$load("2PePB"),
    $c97424b18591c027$var$load("1W4KB"),
    $c97424b18591c027$var$load("lnKog"),
    $c97424b18591c027$var$load("9ftJe"),
    $c97424b18591c027$var$load("7Omhy"),
    $c97424b18591c027$var$load("kC80R"),
    $c97424b18591c027$var$load("7EorR"),
    $c97424b18591c027$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("bDrX3", function(module, exports) {

let $878904d0f55e07f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $878904d0f55e07f9$var$load("2YffH"),
    $878904d0f55e07f9$var$load("8Kivm"),
    $878904d0f55e07f9$var$load("cf5vC"),
    $878904d0f55e07f9$var$load("fCnmZ"),
    $878904d0f55e07f9$var$load("6bYkZ"),
    $878904d0f55e07f9$var$load("iQ0Jm"),
    $878904d0f55e07f9$var$load("coJiW"),
    $878904d0f55e07f9$var$load("dVAT5"),
    $878904d0f55e07f9$var$load("fIFgO"),
    $878904d0f55e07f9$var$load("h4Nf7"),
    $878904d0f55e07f9$var$load("7f9Fz"),
    $878904d0f55e07f9$var$load("8YSo7"),
    $878904d0f55e07f9$var$load("9AHrA"),
    $878904d0f55e07f9$var$load("2spqH"),
    $878904d0f55e07f9$var$load("gWSdF"),
    $878904d0f55e07f9$var$load("6FuHS"),
    $878904d0f55e07f9$var$load("eyaRC"),
    $878904d0f55e07f9$var$load("g9CVe"),
    $878904d0f55e07f9$var$load("aeEUI"),
    $878904d0f55e07f9$var$load("hRUX7"),
    $878904d0f55e07f9$var$load("g4oYs"),
    $878904d0f55e07f9$var$load("6wr18"),
    $878904d0f55e07f9$var$load("kjZZD"),
    $878904d0f55e07f9$var$load("a71qb"),
    $878904d0f55e07f9$var$load("eHDb1"),
    $878904d0f55e07f9$var$load("2zUEf"),
    $878904d0f55e07f9$var$load("37ldp"),
    $878904d0f55e07f9$var$load("awqCy"),
    $878904d0f55e07f9$var$load("kHOMt"),
    $878904d0f55e07f9$var$load("hhss7"),
    $878904d0f55e07f9$var$load("8FbYE"),
    $878904d0f55e07f9$var$load("dUevD"),
    $878904d0f55e07f9$var$load("iZU4p"),
    $878904d0f55e07f9$var$load("Wowvf"),
    $878904d0f55e07f9$var$load("dS0Pr"),
    $878904d0f55e07f9$var$load("huYla"),
    $878904d0f55e07f9$var$load("f1NVy"),
    $878904d0f55e07f9$var$load("2haIE"),
    $878904d0f55e07f9$var$load("9K4jq"),
    $878904d0f55e07f9$var$load("let0D"),
    $878904d0f55e07f9$var$load("aqr2D"),
    $878904d0f55e07f9$var$load("6M36W"),
    $878904d0f55e07f9$var$load("ffEVr"),
    $878904d0f55e07f9$var$load("kUbUu"),
    $878904d0f55e07f9$var$load("2PePB"),
    $878904d0f55e07f9$var$load("1W4KB"),
    $878904d0f55e07f9$var$load("lnKog"),
    $878904d0f55e07f9$var$load("9ftJe"),
    $878904d0f55e07f9$var$load("7Omhy"),
    $878904d0f55e07f9$var$load("kC80R"),
    $878904d0f55e07f9$var$load("7EorR"),
    $878904d0f55e07f9$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("dRnHK", function(module, exports) {

let $a1729cd63030e7f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a1729cd63030e7f6$var$load("2YffH"),
    $a1729cd63030e7f6$var$load("8Kivm"),
    $a1729cd63030e7f6$var$load("cf5vC"),
    $a1729cd63030e7f6$var$load("fCnmZ"),
    $a1729cd63030e7f6$var$load("6bYkZ"),
    $a1729cd63030e7f6$var$load("iQ0Jm"),
    $a1729cd63030e7f6$var$load("coJiW"),
    $a1729cd63030e7f6$var$load("dVAT5"),
    $a1729cd63030e7f6$var$load("fIFgO"),
    $a1729cd63030e7f6$var$load("h4Nf7"),
    $a1729cd63030e7f6$var$load("7f9Fz"),
    $a1729cd63030e7f6$var$load("8YSo7"),
    $a1729cd63030e7f6$var$load("9AHrA"),
    $a1729cd63030e7f6$var$load("2spqH"),
    $a1729cd63030e7f6$var$load("gWSdF"),
    $a1729cd63030e7f6$var$load("6FuHS"),
    $a1729cd63030e7f6$var$load("eyaRC"),
    $a1729cd63030e7f6$var$load("g9CVe"),
    $a1729cd63030e7f6$var$load("aeEUI"),
    $a1729cd63030e7f6$var$load("hRUX7"),
    $a1729cd63030e7f6$var$load("g4oYs"),
    $a1729cd63030e7f6$var$load("6wr18"),
    $a1729cd63030e7f6$var$load("kjZZD"),
    $a1729cd63030e7f6$var$load("a71qb"),
    $a1729cd63030e7f6$var$load("eHDb1"),
    $a1729cd63030e7f6$var$load("2zUEf"),
    $a1729cd63030e7f6$var$load("37ldp"),
    $a1729cd63030e7f6$var$load("awqCy"),
    $a1729cd63030e7f6$var$load("kHOMt"),
    $a1729cd63030e7f6$var$load("hhss7"),
    $a1729cd63030e7f6$var$load("8FbYE"),
    $a1729cd63030e7f6$var$load("dUevD"),
    $a1729cd63030e7f6$var$load("iZU4p"),
    $a1729cd63030e7f6$var$load("Wowvf"),
    $a1729cd63030e7f6$var$load("dS0Pr"),
    $a1729cd63030e7f6$var$load("huYla"),
    $a1729cd63030e7f6$var$load("f1NVy"),
    $a1729cd63030e7f6$var$load("2haIE"),
    $a1729cd63030e7f6$var$load("9K4jq"),
    $a1729cd63030e7f6$var$load("let0D"),
    $a1729cd63030e7f6$var$load("aqr2D"),
    $a1729cd63030e7f6$var$load("6M36W"),
    $a1729cd63030e7f6$var$load("ffEVr"),
    $a1729cd63030e7f6$var$load("kUbUu"),
    $a1729cd63030e7f6$var$load("2PePB"),
    $a1729cd63030e7f6$var$load("1W4KB"),
    $a1729cd63030e7f6$var$load("lnKog"),
    $a1729cd63030e7f6$var$load("9ftJe"),
    $a1729cd63030e7f6$var$load("7Omhy"),
    $a1729cd63030e7f6$var$load("kC80R"),
    $a1729cd63030e7f6$var$load("7EorR"),
    $a1729cd63030e7f6$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("Xa6vQ", function(module, exports) {

let $0b1d5941551aac63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0b1d5941551aac63$var$load("6FuHS"),
    $0b1d5941551aac63$var$load("eyaRC"),
    $0b1d5941551aac63$var$load("2YffH"),
    $0b1d5941551aac63$var$load("cf5vC"),
    $0b1d5941551aac63$var$load("2PePB"),
    $0b1d5941551aac63$var$load("fCnmZ"),
    $0b1d5941551aac63$var$load("6bYkZ"),
    $0b1d5941551aac63$var$load("dVAT5"),
    $0b1d5941551aac63$var$load("fIFgO"),
    $0b1d5941551aac63$var$load("h4Nf7"),
    $0b1d5941551aac63$var$load("7f9Fz"),
    $0b1d5941551aac63$var$load("8YSo7"),
    $0b1d5941551aac63$var$load("9AHrA"),
    $0b1d5941551aac63$var$load("2spqH"),
    $0b1d5941551aac63$var$load("gWSdF"),
    $0b1d5941551aac63$var$load("g9CVe"),
    $0b1d5941551aac63$var$load("aeEUI"),
    $0b1d5941551aac63$var$load("hRUX7"),
    $0b1d5941551aac63$var$load("g4oYs"),
    $0b1d5941551aac63$var$load("6wr18"),
    $0b1d5941551aac63$var$load("kjZZD"),
    $0b1d5941551aac63$var$load("a71qb"),
    $0b1d5941551aac63$var$load("eHDb1"),
    $0b1d5941551aac63$var$load("2zUEf"),
    $0b1d5941551aac63$var$load("37ldp"),
    $0b1d5941551aac63$var$load("awqCy"),
    $0b1d5941551aac63$var$load("kHOMt"),
    $0b1d5941551aac63$var$load("hhss7"),
    $0b1d5941551aac63$var$load("8FbYE"),
    $0b1d5941551aac63$var$load("dUevD"),
    $0b1d5941551aac63$var$load("iZU4p"),
    $0b1d5941551aac63$var$load("Wowvf"),
    $0b1d5941551aac63$var$load("dS0Pr"),
    $0b1d5941551aac63$var$load("huYla"),
    $0b1d5941551aac63$var$load("f1NVy"),
    $0b1d5941551aac63$var$load("2haIE"),
    $0b1d5941551aac63$var$load("9K4jq"),
    $0b1d5941551aac63$var$load("let0D"),
    $0b1d5941551aac63$var$load("aqr2D"),
    $0b1d5941551aac63$var$load("6M36W"),
    $0b1d5941551aac63$var$load("1W4KB"),
    $0b1d5941551aac63$var$load("ffEVr"),
    $0b1d5941551aac63$var$load("kUbUu"),
    $0b1d5941551aac63$var$load("9ftJe"),
    $0b1d5941551aac63$var$load("7Omhy"),
    $0b1d5941551aac63$var$load("kC80R"),
    $0b1d5941551aac63$var$load("7EorR"),
    $0b1d5941551aac63$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("eAfoq", function(module, exports) {

let $a9e05e361af95885$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a9e05e361af95885$var$load("6FuHS"),
    $a9e05e361af95885$var$load("eyaRC"),
    $a9e05e361af95885$var$load("2YffH"),
    $a9e05e361af95885$var$load("cf5vC"),
    $a9e05e361af95885$var$load("2PePB"),
    $a9e05e361af95885$var$load("fCnmZ"),
    $a9e05e361af95885$var$load("6bYkZ"),
    $a9e05e361af95885$var$load("dVAT5"),
    $a9e05e361af95885$var$load("fIFgO"),
    $a9e05e361af95885$var$load("h4Nf7"),
    $a9e05e361af95885$var$load("7f9Fz"),
    $a9e05e361af95885$var$load("8YSo7"),
    $a9e05e361af95885$var$load("9AHrA"),
    $a9e05e361af95885$var$load("2spqH"),
    $a9e05e361af95885$var$load("gWSdF"),
    $a9e05e361af95885$var$load("g9CVe"),
    $a9e05e361af95885$var$load("aeEUI"),
    $a9e05e361af95885$var$load("hRUX7"),
    $a9e05e361af95885$var$load("g4oYs"),
    $a9e05e361af95885$var$load("6wr18"),
    $a9e05e361af95885$var$load("kjZZD"),
    $a9e05e361af95885$var$load("a71qb"),
    $a9e05e361af95885$var$load("eHDb1"),
    $a9e05e361af95885$var$load("2zUEf"),
    $a9e05e361af95885$var$load("37ldp"),
    $a9e05e361af95885$var$load("awqCy"),
    $a9e05e361af95885$var$load("kHOMt"),
    $a9e05e361af95885$var$load("hhss7"),
    $a9e05e361af95885$var$load("8FbYE"),
    $a9e05e361af95885$var$load("dUevD"),
    $a9e05e361af95885$var$load("iZU4p"),
    $a9e05e361af95885$var$load("Wowvf"),
    $a9e05e361af95885$var$load("dS0Pr"),
    $a9e05e361af95885$var$load("huYla"),
    $a9e05e361af95885$var$load("f1NVy"),
    $a9e05e361af95885$var$load("2haIE"),
    $a9e05e361af95885$var$load("9K4jq"),
    $a9e05e361af95885$var$load("let0D"),
    $a9e05e361af95885$var$load("aqr2D"),
    $a9e05e361af95885$var$load("6M36W"),
    $a9e05e361af95885$var$load("1W4KB"),
    $a9e05e361af95885$var$load("ffEVr"),
    $a9e05e361af95885$var$load("kUbUu"),
    $a9e05e361af95885$var$load("9ftJe"),
    $a9e05e361af95885$var$load("7Omhy"),
    $a9e05e361af95885$var$load("kC80R"),
    $a9e05e361af95885$var$load("7EorR"),
    $a9e05e361af95885$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("ky4sQ", function(module, exports) {

let $ef5a722605c90f43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef5a722605c90f43$var$load("6FuHS"),
    $ef5a722605c90f43$var$load("eyaRC"),
    $ef5a722605c90f43$var$load("2YffH"),
    $ef5a722605c90f43$var$load("cf5vC"),
    $ef5a722605c90f43$var$load("2PePB"),
    $ef5a722605c90f43$var$load("fCnmZ"),
    $ef5a722605c90f43$var$load("6bYkZ"),
    $ef5a722605c90f43$var$load("dVAT5"),
    $ef5a722605c90f43$var$load("fIFgO"),
    $ef5a722605c90f43$var$load("h4Nf7"),
    $ef5a722605c90f43$var$load("7f9Fz"),
    $ef5a722605c90f43$var$load("8YSo7"),
    $ef5a722605c90f43$var$load("9AHrA"),
    $ef5a722605c90f43$var$load("2spqH"),
    $ef5a722605c90f43$var$load("gWSdF"),
    $ef5a722605c90f43$var$load("g9CVe"),
    $ef5a722605c90f43$var$load("aeEUI"),
    $ef5a722605c90f43$var$load("hRUX7"),
    $ef5a722605c90f43$var$load("g4oYs"),
    $ef5a722605c90f43$var$load("6wr18"),
    $ef5a722605c90f43$var$load("kjZZD"),
    $ef5a722605c90f43$var$load("a71qb"),
    $ef5a722605c90f43$var$load("eHDb1"),
    $ef5a722605c90f43$var$load("2zUEf"),
    $ef5a722605c90f43$var$load("37ldp"),
    $ef5a722605c90f43$var$load("awqCy"),
    $ef5a722605c90f43$var$load("kHOMt"),
    $ef5a722605c90f43$var$load("hhss7"),
    $ef5a722605c90f43$var$load("8FbYE"),
    $ef5a722605c90f43$var$load("dUevD"),
    $ef5a722605c90f43$var$load("iZU4p"),
    $ef5a722605c90f43$var$load("Wowvf"),
    $ef5a722605c90f43$var$load("dS0Pr"),
    $ef5a722605c90f43$var$load("huYla"),
    $ef5a722605c90f43$var$load("f1NVy"),
    $ef5a722605c90f43$var$load("2haIE"),
    $ef5a722605c90f43$var$load("9K4jq"),
    $ef5a722605c90f43$var$load("let0D"),
    $ef5a722605c90f43$var$load("aqr2D"),
    $ef5a722605c90f43$var$load("6M36W"),
    $ef5a722605c90f43$var$load("1W4KB"),
    $ef5a722605c90f43$var$load("ffEVr"),
    $ef5a722605c90f43$var$load("kUbUu"),
    $ef5a722605c90f43$var$load("9ftJe"),
    $ef5a722605c90f43$var$load("7Omhy"),
    $ef5a722605c90f43$var$load("kC80R"),
    $ef5a722605c90f43$var$load("7EorR"),
    $ef5a722605c90f43$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("6mzeb", function(module, exports) {

let $4a201fa2aa5f8fd6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4a201fa2aa5f8fd6$var$load("6FuHS"),
    $4a201fa2aa5f8fd6$var$load("eyaRC"),
    $4a201fa2aa5f8fd6$var$load("2YffH"),
    $4a201fa2aa5f8fd6$var$load("cf5vC"),
    $4a201fa2aa5f8fd6$var$load("fCnmZ"),
    $4a201fa2aa5f8fd6$var$load("6bYkZ"),
    $4a201fa2aa5f8fd6$var$load("dVAT5"),
    $4a201fa2aa5f8fd6$var$load("fIFgO"),
    $4a201fa2aa5f8fd6$var$load("h4Nf7"),
    $4a201fa2aa5f8fd6$var$load("7f9Fz"),
    $4a201fa2aa5f8fd6$var$load("8YSo7"),
    $4a201fa2aa5f8fd6$var$load("9AHrA"),
    $4a201fa2aa5f8fd6$var$load("2spqH"),
    $4a201fa2aa5f8fd6$var$load("gWSdF"),
    $4a201fa2aa5f8fd6$var$load("g9CVe"),
    $4a201fa2aa5f8fd6$var$load("aeEUI"),
    $4a201fa2aa5f8fd6$var$load("hRUX7"),
    $4a201fa2aa5f8fd6$var$load("g4oYs"),
    $4a201fa2aa5f8fd6$var$load("6wr18"),
    $4a201fa2aa5f8fd6$var$load("kjZZD"),
    $4a201fa2aa5f8fd6$var$load("a71qb"),
    $4a201fa2aa5f8fd6$var$load("eHDb1"),
    $4a201fa2aa5f8fd6$var$load("2zUEf"),
    $4a201fa2aa5f8fd6$var$load("37ldp"),
    $4a201fa2aa5f8fd6$var$load("awqCy"),
    $4a201fa2aa5f8fd6$var$load("kHOMt"),
    $4a201fa2aa5f8fd6$var$load("hhss7"),
    $4a201fa2aa5f8fd6$var$load("8FbYE"),
    $4a201fa2aa5f8fd6$var$load("dUevD"),
    $4a201fa2aa5f8fd6$var$load("iZU4p"),
    $4a201fa2aa5f8fd6$var$load("Wowvf"),
    $4a201fa2aa5f8fd6$var$load("dS0Pr"),
    $4a201fa2aa5f8fd6$var$load("huYla"),
    $4a201fa2aa5f8fd6$var$load("f1NVy"),
    $4a201fa2aa5f8fd6$var$load("2haIE"),
    $4a201fa2aa5f8fd6$var$load("9K4jq"),
    $4a201fa2aa5f8fd6$var$load("let0D"),
    $4a201fa2aa5f8fd6$var$load("aqr2D"),
    $4a201fa2aa5f8fd6$var$load("6M36W"),
    $4a201fa2aa5f8fd6$var$load("ffEVr"),
    $4a201fa2aa5f8fd6$var$load("kUbUu"),
    $4a201fa2aa5f8fd6$var$load("2PePB"),
    $4a201fa2aa5f8fd6$var$load("1W4KB"),
    $4a201fa2aa5f8fd6$var$load("lnKog"),
    $4a201fa2aa5f8fd6$var$load("9ftJe"),
    $4a201fa2aa5f8fd6$var$load("7Omhy"),
    $4a201fa2aa5f8fd6$var$load("kC80R"),
    $4a201fa2aa5f8fd6$var$load("7EorR"),
    $4a201fa2aa5f8fd6$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("9wO8q", function(module, exports) {

let $6efdfdf3fb19c57a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6efdfdf3fb19c57a$var$load("2YffH"),
    $6efdfdf3fb19c57a$var$load("cf5vC"),
    $6efdfdf3fb19c57a$var$load("fCnmZ"),
    $6efdfdf3fb19c57a$var$load("6bYkZ"),
    $6efdfdf3fb19c57a$var$load("coJiW"),
    $6efdfdf3fb19c57a$var$load("dVAT5"),
    $6efdfdf3fb19c57a$var$load("fIFgO"),
    $6efdfdf3fb19c57a$var$load("h4Nf7"),
    $6efdfdf3fb19c57a$var$load("7f9Fz"),
    $6efdfdf3fb19c57a$var$load("8YSo7"),
    $6efdfdf3fb19c57a$var$load("9AHrA"),
    $6efdfdf3fb19c57a$var$load("2spqH"),
    $6efdfdf3fb19c57a$var$load("gWSdF"),
    $6efdfdf3fb19c57a$var$load("6FuHS"),
    $6efdfdf3fb19c57a$var$load("eyaRC"),
    $6efdfdf3fb19c57a$var$load("g9CVe"),
    $6efdfdf3fb19c57a$var$load("aeEUI"),
    $6efdfdf3fb19c57a$var$load("hRUX7"),
    $6efdfdf3fb19c57a$var$load("g4oYs"),
    $6efdfdf3fb19c57a$var$load("6wr18"),
    $6efdfdf3fb19c57a$var$load("kjZZD"),
    $6efdfdf3fb19c57a$var$load("a71qb"),
    $6efdfdf3fb19c57a$var$load("eHDb1"),
    $6efdfdf3fb19c57a$var$load("2zUEf"),
    $6efdfdf3fb19c57a$var$load("37ldp"),
    $6efdfdf3fb19c57a$var$load("dTsOE"),
    $6efdfdf3fb19c57a$var$load("awqCy"),
    $6efdfdf3fb19c57a$var$load("kHOMt"),
    $6efdfdf3fb19c57a$var$load("hhss7"),
    $6efdfdf3fb19c57a$var$load("8FbYE"),
    $6efdfdf3fb19c57a$var$load("dUevD"),
    $6efdfdf3fb19c57a$var$load("iZU4p"),
    $6efdfdf3fb19c57a$var$load("Wowvf"),
    $6efdfdf3fb19c57a$var$load("dS0Pr"),
    $6efdfdf3fb19c57a$var$load("huYla"),
    $6efdfdf3fb19c57a$var$load("f1NVy"),
    $6efdfdf3fb19c57a$var$load("2haIE"),
    $6efdfdf3fb19c57a$var$load("9K4jq"),
    $6efdfdf3fb19c57a$var$load("let0D"),
    $6efdfdf3fb19c57a$var$load("aqr2D"),
    $6efdfdf3fb19c57a$var$load("6M36W"),
    $6efdfdf3fb19c57a$var$load("ffEVr"),
    $6efdfdf3fb19c57a$var$load("kUbUu"),
    $6efdfdf3fb19c57a$var$load("2PePB"),
    $6efdfdf3fb19c57a$var$load("1W4KB"),
    $6efdfdf3fb19c57a$var$load("lnKog"),
    $6efdfdf3fb19c57a$var$load("9ftJe"),
    $6efdfdf3fb19c57a$var$load("7Omhy"),
    $6efdfdf3fb19c57a$var$load("kC80R"),
    $6efdfdf3fb19c57a$var$load("7EorR"),
    $6efdfdf3fb19c57a$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("grnpV", function(module, exports) {

let $bf81551b58a5fc7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bf81551b58a5fc7b$var$load("2YffH"),
    $bf81551b58a5fc7b$var$load("cf5vC"),
    $bf81551b58a5fc7b$var$load("fCnmZ"),
    $bf81551b58a5fc7b$var$load("6bYkZ"),
    $bf81551b58a5fc7b$var$load("coJiW"),
    $bf81551b58a5fc7b$var$load("dVAT5"),
    $bf81551b58a5fc7b$var$load("fIFgO"),
    $bf81551b58a5fc7b$var$load("h4Nf7"),
    $bf81551b58a5fc7b$var$load("7f9Fz"),
    $bf81551b58a5fc7b$var$load("8YSo7"),
    $bf81551b58a5fc7b$var$load("9AHrA"),
    $bf81551b58a5fc7b$var$load("2spqH"),
    $bf81551b58a5fc7b$var$load("gWSdF"),
    $bf81551b58a5fc7b$var$load("6FuHS"),
    $bf81551b58a5fc7b$var$load("eyaRC"),
    $bf81551b58a5fc7b$var$load("g9CVe"),
    $bf81551b58a5fc7b$var$load("aeEUI"),
    $bf81551b58a5fc7b$var$load("hRUX7"),
    $bf81551b58a5fc7b$var$load("g4oYs"),
    $bf81551b58a5fc7b$var$load("6wr18"),
    $bf81551b58a5fc7b$var$load("kjZZD"),
    $bf81551b58a5fc7b$var$load("a71qb"),
    $bf81551b58a5fc7b$var$load("eHDb1"),
    $bf81551b58a5fc7b$var$load("2zUEf"),
    $bf81551b58a5fc7b$var$load("37ldp"),
    $bf81551b58a5fc7b$var$load("dTsOE"),
    $bf81551b58a5fc7b$var$load("awqCy"),
    $bf81551b58a5fc7b$var$load("kHOMt"),
    $bf81551b58a5fc7b$var$load("hhss7"),
    $bf81551b58a5fc7b$var$load("8FbYE"),
    $bf81551b58a5fc7b$var$load("dUevD"),
    $bf81551b58a5fc7b$var$load("iZU4p"),
    $bf81551b58a5fc7b$var$load("Wowvf"),
    $bf81551b58a5fc7b$var$load("dS0Pr"),
    $bf81551b58a5fc7b$var$load("huYla"),
    $bf81551b58a5fc7b$var$load("f1NVy"),
    $bf81551b58a5fc7b$var$load("2haIE"),
    $bf81551b58a5fc7b$var$load("9K4jq"),
    $bf81551b58a5fc7b$var$load("let0D"),
    $bf81551b58a5fc7b$var$load("aqr2D"),
    $bf81551b58a5fc7b$var$load("6M36W"),
    $bf81551b58a5fc7b$var$load("ffEVr"),
    $bf81551b58a5fc7b$var$load("kUbUu"),
    $bf81551b58a5fc7b$var$load("2PePB"),
    $bf81551b58a5fc7b$var$load("1W4KB"),
    $bf81551b58a5fc7b$var$load("lnKog"),
    $bf81551b58a5fc7b$var$load("9ftJe"),
    $bf81551b58a5fc7b$var$load("7Omhy"),
    $bf81551b58a5fc7b$var$load("kC80R"),
    $bf81551b58a5fc7b$var$load("7EorR"),
    $bf81551b58a5fc7b$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("6Dnfz", function(module, exports) {

let $4d486b9aa60f05b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4d486b9aa60f05b4$var$load("6FuHS"),
    $4d486b9aa60f05b4$var$load("eyaRC"),
    $4d486b9aa60f05b4$var$load("2YffH"),
    $4d486b9aa60f05b4$var$load("cf5vC"),
    $4d486b9aa60f05b4$var$load("2PePB"),
    $4d486b9aa60f05b4$var$load("fCnmZ"),
    $4d486b9aa60f05b4$var$load("6bYkZ"),
    $4d486b9aa60f05b4$var$load("dVAT5"),
    $4d486b9aa60f05b4$var$load("fIFgO"),
    $4d486b9aa60f05b4$var$load("h4Nf7"),
    $4d486b9aa60f05b4$var$load("7f9Fz"),
    $4d486b9aa60f05b4$var$load("8YSo7"),
    $4d486b9aa60f05b4$var$load("9AHrA"),
    $4d486b9aa60f05b4$var$load("2spqH"),
    $4d486b9aa60f05b4$var$load("gWSdF"),
    $4d486b9aa60f05b4$var$load("g9CVe"),
    $4d486b9aa60f05b4$var$load("aeEUI"),
    $4d486b9aa60f05b4$var$load("hRUX7"),
    $4d486b9aa60f05b4$var$load("g4oYs"),
    $4d486b9aa60f05b4$var$load("6wr18"),
    $4d486b9aa60f05b4$var$load("kjZZD"),
    $4d486b9aa60f05b4$var$load("a71qb"),
    $4d486b9aa60f05b4$var$load("eHDb1"),
    $4d486b9aa60f05b4$var$load("2zUEf"),
    $4d486b9aa60f05b4$var$load("37ldp"),
    $4d486b9aa60f05b4$var$load("awqCy"),
    $4d486b9aa60f05b4$var$load("kHOMt"),
    $4d486b9aa60f05b4$var$load("hhss7"),
    $4d486b9aa60f05b4$var$load("8FbYE"),
    $4d486b9aa60f05b4$var$load("dUevD"),
    $4d486b9aa60f05b4$var$load("iZU4p"),
    $4d486b9aa60f05b4$var$load("Wowvf"),
    $4d486b9aa60f05b4$var$load("dS0Pr"),
    $4d486b9aa60f05b4$var$load("huYla"),
    $4d486b9aa60f05b4$var$load("f1NVy"),
    $4d486b9aa60f05b4$var$load("2haIE"),
    $4d486b9aa60f05b4$var$load("9K4jq"),
    $4d486b9aa60f05b4$var$load("let0D"),
    $4d486b9aa60f05b4$var$load("aqr2D"),
    $4d486b9aa60f05b4$var$load("6M36W"),
    $4d486b9aa60f05b4$var$load("1W4KB"),
    $4d486b9aa60f05b4$var$load("ffEVr"),
    $4d486b9aa60f05b4$var$load("kUbUu"),
    $4d486b9aa60f05b4$var$load("9ftJe"),
    $4d486b9aa60f05b4$var$load("7Omhy"),
    $4d486b9aa60f05b4$var$load("kC80R"),
    $4d486b9aa60f05b4$var$load("7EorR"),
    $4d486b9aa60f05b4$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("dPozq", function(module, exports) {

let $a11318f5db99caaa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a11318f5db99caaa$var$load("6FuHS"),
    $a11318f5db99caaa$var$load("eyaRC"),
    $a11318f5db99caaa$var$load("2YffH"),
    $a11318f5db99caaa$var$load("cf5vC"),
    $a11318f5db99caaa$var$load("fCnmZ"),
    $a11318f5db99caaa$var$load("6bYkZ"),
    $a11318f5db99caaa$var$load("dVAT5"),
    $a11318f5db99caaa$var$load("fIFgO"),
    $a11318f5db99caaa$var$load("h4Nf7"),
    $a11318f5db99caaa$var$load("7f9Fz"),
    $a11318f5db99caaa$var$load("8YSo7"),
    $a11318f5db99caaa$var$load("9AHrA"),
    $a11318f5db99caaa$var$load("2spqH"),
    $a11318f5db99caaa$var$load("gWSdF"),
    $a11318f5db99caaa$var$load("g9CVe"),
    $a11318f5db99caaa$var$load("aeEUI"),
    $a11318f5db99caaa$var$load("hRUX7"),
    $a11318f5db99caaa$var$load("g4oYs"),
    $a11318f5db99caaa$var$load("6wr18"),
    $a11318f5db99caaa$var$load("kjZZD"),
    $a11318f5db99caaa$var$load("a71qb"),
    $a11318f5db99caaa$var$load("eHDb1"),
    $a11318f5db99caaa$var$load("2zUEf"),
    $a11318f5db99caaa$var$load("37ldp"),
    $a11318f5db99caaa$var$load("awqCy"),
    $a11318f5db99caaa$var$load("kHOMt"),
    $a11318f5db99caaa$var$load("hhss7"),
    $a11318f5db99caaa$var$load("8FbYE"),
    $a11318f5db99caaa$var$load("dUevD"),
    $a11318f5db99caaa$var$load("iZU4p"),
    $a11318f5db99caaa$var$load("Wowvf"),
    $a11318f5db99caaa$var$load("dS0Pr"),
    $a11318f5db99caaa$var$load("huYla"),
    $a11318f5db99caaa$var$load("f1NVy"),
    $a11318f5db99caaa$var$load("2haIE"),
    $a11318f5db99caaa$var$load("9K4jq"),
    $a11318f5db99caaa$var$load("let0D"),
    $a11318f5db99caaa$var$load("aqr2D"),
    $a11318f5db99caaa$var$load("6M36W"),
    $a11318f5db99caaa$var$load("ffEVr"),
    $a11318f5db99caaa$var$load("kUbUu"),
    $a11318f5db99caaa$var$load("2PePB"),
    $a11318f5db99caaa$var$load("1W4KB"),
    $a11318f5db99caaa$var$load("lnKog"),
    $a11318f5db99caaa$var$load("9ftJe"),
    $a11318f5db99caaa$var$load("7Omhy"),
    $a11318f5db99caaa$var$load("kC80R"),
    $a11318f5db99caaa$var$load("7EorR"),
    $a11318f5db99caaa$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("gWkGT", function(module, exports) {

let $c5521cde500efcc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c5521cde500efcc9$var$load("6FuHS"),
    $c5521cde500efcc9$var$load("eyaRC"),
    $c5521cde500efcc9$var$load("2YffH"),
    $c5521cde500efcc9$var$load("cf5vC"),
    $c5521cde500efcc9$var$load("fCnmZ"),
    $c5521cde500efcc9$var$load("6bYkZ"),
    $c5521cde500efcc9$var$load("dVAT5"),
    $c5521cde500efcc9$var$load("fIFgO"),
    $c5521cde500efcc9$var$load("h4Nf7"),
    $c5521cde500efcc9$var$load("7f9Fz"),
    $c5521cde500efcc9$var$load("8YSo7"),
    $c5521cde500efcc9$var$load("9AHrA"),
    $c5521cde500efcc9$var$load("2spqH"),
    $c5521cde500efcc9$var$load("gWSdF"),
    $c5521cde500efcc9$var$load("g9CVe"),
    $c5521cde500efcc9$var$load("aeEUI"),
    $c5521cde500efcc9$var$load("hRUX7"),
    $c5521cde500efcc9$var$load("g4oYs"),
    $c5521cde500efcc9$var$load("6wr18"),
    $c5521cde500efcc9$var$load("kjZZD"),
    $c5521cde500efcc9$var$load("a71qb"),
    $c5521cde500efcc9$var$load("eHDb1"),
    $c5521cde500efcc9$var$load("2zUEf"),
    $c5521cde500efcc9$var$load("37ldp"),
    $c5521cde500efcc9$var$load("awqCy"),
    $c5521cde500efcc9$var$load("kHOMt"),
    $c5521cde500efcc9$var$load("hhss7"),
    $c5521cde500efcc9$var$load("8FbYE"),
    $c5521cde500efcc9$var$load("dUevD"),
    $c5521cde500efcc9$var$load("iZU4p"),
    $c5521cde500efcc9$var$load("Wowvf"),
    $c5521cde500efcc9$var$load("dS0Pr"),
    $c5521cde500efcc9$var$load("huYla"),
    $c5521cde500efcc9$var$load("f1NVy"),
    $c5521cde500efcc9$var$load("2haIE"),
    $c5521cde500efcc9$var$load("9K4jq"),
    $c5521cde500efcc9$var$load("let0D"),
    $c5521cde500efcc9$var$load("aqr2D"),
    $c5521cde500efcc9$var$load("6M36W"),
    $c5521cde500efcc9$var$load("ffEVr"),
    $c5521cde500efcc9$var$load("kUbUu"),
    $c5521cde500efcc9$var$load("2PePB"),
    $c5521cde500efcc9$var$load("1W4KB"),
    $c5521cde500efcc9$var$load("lnKog"),
    $c5521cde500efcc9$var$load("9ftJe"),
    $c5521cde500efcc9$var$load("7Omhy"),
    $c5521cde500efcc9$var$load("kC80R"),
    $c5521cde500efcc9$var$load("7EorR"),
    $c5521cde500efcc9$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("isFEX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdccba3d7742a12d1dd259bf333308d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d70b2843323b118c$var$_react = $d70b2843323b118c$var$_interopRequireDefault((parcelRequire("42omo")));

var $d70b2843323b118c$var$_baseNew = $d70b2843323b118c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d70b2843323b118c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Template".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved fore templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d70b2843323b118c$var$TemplateIcon = (props)=>/*#__PURE__*/ $d70b2843323b118c$var$_react.default.createElement($d70b2843323b118c$var$_baseNew.default, Object.assign({
        name: "TemplateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 6h-7v7.5H13a.5.5 0 0 0 .5-.5zm-11 7a.5.5 0 0 0 .5.5h2V6H2.5zm11-10a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.5h11zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$d70b2843323b118c$var$TemplateIcon.displayName = 'TemplateIcon';
var $d70b2843323b118c$var$_default = module.exports.default = $d70b2843323b118c$var$TemplateIcon;

});

parcelRegister("9EtP6", function(module, exports) {
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $dh538 = parcelRequire("dh538");

const $82c18ff824db72a8$var$packageName = "platform-pkg";
const $82c18ff824db72a8$var$packageVersion = "0.0.0-use.local";
const $82c18ff824db72a8$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $82c18ff824db72a8$var$packageName,
    packageVersion: $82c18ff824db72a8$var$packageVersion
};
const $82c18ff824db72a8$var$lineHeightBase = 20;
const $82c18ff824db72a8$var$lineHeightCompact = 16;
const $82c18ff824db72a8$var$compactVerticalPadding = 2;
const $82c18ff824db72a8$var$verticalPadding = 6;
const $82c18ff824db72a8$var$transitionDuration = '0.2s';
const $82c18ff824db72a8$var$borderWidth = 2;
const $82c18ff824db72a8$var$baseStyles = null;
const $82c18ff824db72a8$var$baseStylesT26Shape = null;
const $82c18ff824db72a8$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pvby5v _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18by5v",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $82c18ff824db72a8$var$fontStyles = {
    default: "_11c81ixg _1tn22smr",
    monospace: "_11c81ixg _ect41odn _1tn22smr _14mdudxr"
};
const $82c18ff824db72a8$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $82c18ff824db72a8$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $82c18ff824db72a8$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $82c18ff824db72a8$var$InnerTextArea = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const ourRef = (0, $42omo.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $42omo.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $42omo.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $42omo.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $l998X.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0by5v _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $82c18ff824db72a8$var$appearanceStyles[appearance],
            $82c18ff824db72a8$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $82c18ff824db72a8$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightCompact * minimumRows + $82c18ff824db72a8$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightBase * minimumRows + $82c18ff824db72a8$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $82c18ff824db72a8$var$TextArea = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($82c18ff824db72a8$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$82c18ff824db72a8$var$TextArea.displayName = 'TextArea';
var $82c18ff824db72a8$export$2e2bcd8739ae039 = $82c18ff824db72a8$var$TextArea;
module.exports["default"] = $82c18ff824db72a8$export$2e2bcd8739ae039;

});

parcelRegister("jO6sX", function(module, exports) {

var $bPFvq = parcelRequire("bPFvq");


var $cbHql = parcelRequire("cbHql");


var $42omo = parcelRequire("42omo");


var $iu6m9 = parcelRequire("iu6m9");


var $9wGTI = parcelRequire("9wGTI");


var $hp2SH = parcelRequire("hp2SH");


var $bQm3c = parcelRequire("bQm3c");


var $c0rhi = parcelRequire("c0rhi");


var $6s78L = parcelRequire("6s78L");


var $fEmGS = parcelRequire("fEmGS");


var $44LO1 = parcelRequire("44LO1");


var $iGI5F = parcelRequire("iGI5F");

const $0d17c8f0adf5cf3d$var$EditorPreferencesQuery = (0, $cbHql.default);
const $0d17c8f0adf5cf3d$var$EditorPreferencesMutation = (0, $bPFvq.default);
const $0d17c8f0adf5cf3d$export$3ece90ca9e31f585 = (confluenceEditorSettings)=>{
    if (confluenceEditorSettings && confluenceEditorSettings) return confluenceEditorSettings;
    return {};
};
class $0d17c8f0adf5cf3d$export$accffe59bc474b30 {
    init() {
        if (!this.initialized) this.fetchPreferences().catch(()=>{
        // Do nothing
        });
    }
    // add this to implment the UserPreferensProvider interface.
    loadPreferences() {
        return Promise.reject();
    }
    async fetchPreferences() {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        try {
            if (!this.initialized) {
                const { data: data } = await (0, $c0rhi.queryInterop)({
                    query: $0d17c8f0adf5cf3d$var$EditorPreferencesQuery
                });
                this.userPreferences = $0d17c8f0adf5cf3d$export$3ece90ca9e31f585(data?.userPreferences?.confluenceEditorSettings);
                this.initialized = true;
            }
            return Promise.resolve();
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async updatePreference(key, value) {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        this.userPreferences[key] = value;
        const variables = {
            [key]: value
        };
        try {
            const response = await (0, $6s78L.mutateInterop)({
                mutation: $0d17c8f0adf5cf3d$var$EditorPreferencesMutation,
                variables: variables,
                update: ()=>{
                    // this is required to indicate toolbar changes to progressive object header
                    (0, $fEmGS.writeQueryInterop)({
                        query: $0d17c8f0adf5cf3d$var$EditorPreferencesQuery,
                        data: {
                            userPreferences: {
                                __typename: 'UserPreferences',
                                confluenceEditorSettings: {
                                    __typename: 'ConfluenceEditorSettings',
                                    toolbarDockingInitialPosition: value === 'top' ? value : null // Null is required since apollo cache uses shallow reference equality
                                }
                            }
                        }
                    });
                }
            });
            const confluenceEditorSettings = $0d17c8f0adf5cf3d$export$3ece90ca9e31f585(response.data?.updateUserPreferences?.confluenceEditorSettings);
            this.userPreferences[key] = confluenceEditorSettings[key];
            return Promise.resolve();
        } catch (error) {
            return Promise.reject(error);
        }
    }
    getPreference(key) {
        return this.userPreferences[key];
    }
    constructor(){
        this.userPreferences = {};
        // We use getApolloClient to get the apollo client instance
        // This is to avoid adding required apollo context
        this.apolloClient = (0, $hp2SH.getApolloClient)();
        this.initialized = false;
        this.init();
    }
}
const $0d17c8f0adf5cf3d$var$createUserPreferencesProvider = (options)=>{
    if ((0, $9wGTI.fg)('platform_editor_user_preferences_provider_update')) {
        const getFallbackUserPreferences = ()=>({
                toolbarDockingInitialPosition: options?.getCurrentIsLivePage?.() ? 'none' : 'top'
            });
        return new (0, $44LO1.EditorUserPreferencesProvider)({
            getFallbackUserPreferences: getFallbackUserPreferences
        });
    }
    return new $0d17c8f0adf5cf3d$export$accffe59bc474b30();
};
const $0d17c8f0adf5cf3d$export$c88c6b9f15f77aea = (options)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const confluenceEditorPreferencesProvider = (0, $42omo.useRef)();
    const editorPreferencesProvider = (0, $42omo.useRef)();
    const persistenceAPI = (0, $42omo.useRef)();
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
        if ((0, $9wGTI.fg)('platform_editor_use_preferences_plugin')) {
            if (!editorPreferencesProvider.current) {
                const isLivePage = options?.getCurrentIsLivePage?.() ?? false;
                persistenceAPI.current = new (0, $iGI5F.UserPreferencesPersistenceAPI)(isLoggedIn);
                editorPreferencesProvider.current = (0, $iGI5F.getUserPreferencesProvider)({
                    isLivePage: isLivePage,
                    persistenceAPI: persistenceAPI.current
                });
            }
        } else if (!confluenceEditorPreferencesProvider.current) confluenceEditorPreferencesProvider.current = isLoggedIn ? $0d17c8f0adf5cf3d$var$createUserPreferencesProvider(options) : undefined;
    }
    (0, $42omo.useEffect)(()=>{
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
            if (persistenceAPI.current && (0, $9wGTI.fg)('platform_editor_use_preferences_plugin')) persistenceAPI.current.setIsLoggedIn(isLoggedIn);
        }
    }, [
        isLoggedIn
    ]);
    return {
        confluenceEditorPreferencesProvider: confluenceEditorPreferencesProvider.current,
        editorPreferencesProvider: editorPreferencesProvider.current ?? undefined
    };
};
module.exports["parseConfluenceEditorSettings"] = $0d17c8f0adf5cf3d$export$3ece90ca9e31f585;
module.exports["useEditorPreferencesProvider"] = $0d17c8f0adf5cf3d$export$c88c6b9f15f77aea;

});

parcelRegister("bPFvq", function(module, exports) {
/**
 * @generated SignedSource<<f1d3fe8fe25bffc8959c6cc50fe2d338>>
 * @relayHash 1b2bc31ac42719bf8add4db3a6390b58
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 127d43e36b149ae142a2ec8732d260390b2cd6c7260cd15d254197587add32cb
const $185ebb8cafff52fb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "toolbarDockingInitialPosition"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "toolbarDockingInitialPosition",
                                    "variableName": "toolbarDockingInitialPosition"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "confluenceEditorSettingsInput"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorPreferencesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorPreferencesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1b2bc31ac42719bf8add4db3a6390b58",
            "id": "127d43e36b149ae142a2ec8732d260390b2cd6c7260cd15d254197587add32cb",
            "metadata": {},
            "name": "EditorPreferencesMutation",
            "operationKind": "mutation",
            "text": "mutation EditorPreferencesMutation($toolbarDockingInitialPosition:String!){updateUserPreferences(userPreferences:{confluenceEditorSettingsInput:{toolbarDockingInitialPosition:$toolbarDockingInitialPosition}}){confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$185ebb8cafff52fb$var$node.hash = "37475c1d65dabe41f55ac97eba30ddfa";
var $185ebb8cafff52fb$export$2e2bcd8739ae039 = $185ebb8cafff52fb$var$node;
module.exports["default"] = $185ebb8cafff52fb$export$2e2bcd8739ae039;

});

parcelRegister("6s78L", function(module, exports) {

var $75HqD = parcelRequire("75HqD");


var $86okN = parcelRequire("86okN");

function $0b6144addfe7c9d4$export$7bf8518c2628f671(params) {
    return $0b6144addfe7c9d4$var$mutateInteropApollo(params);
}
const $0b6144addfe7c9d4$var$UNSUPPORTED_RELAY_OPTIONS = [
    'optimisticResponse',
    'update',
    'refetchQueries',
    'awaitRefetchQueries'
];
function $0b6144addfe7c9d4$var$mutateInteropRelay(params) {
    // Check for unsupported options
    const unsupportedOptions = Object.keys(params).filter((key)=>$0b6144addfe7c9d4$var$UNSUPPORTED_RELAY_OPTIONS.includes(key));
    if (unsupportedOptions.length > 0) throw new Error(`[Relay migration] ${unsupportedOptions} are not supported yet`);
    return (0, $75HqD.commitMutation)(window.GLOBAL_RELAY_ENV, {
        mutation: params.mutation,
        variables: params.variables ?? {}
    }).then((result)=>{
        return {
            data: result
        };
    }).catch((error)=>{
        if (params.errorPolicy === 'ignore' || params.errorPolicy === 'all') return {
            data: null,
            errors: error.graphQLErrors || [
                error
            ]
        };
        throw error;
    });
}
function $0b6144addfe7c9d4$var$mutateInteropApollo({ mutation: mutation, ...rest }) {
    return window['GLOBAL_APOLLO_CLIENT'].mutate({
        ...rest,
        mutation: (0, $86okN.toDocumentNode)(mutation)
    });
}
module.exports["mutateInterop"] = $0b6144addfe7c9d4$export$7bf8518c2628f671;

});

parcelRegister("75HqD", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");


var $422HI = parcelRequire("422HI");

const $998dea875afc431e$export$e454457a489de4f6 = (relayEnvironment, mutation)=>new Promise((resolve, reject)=>{
        (0, $3e6Uc.commitMutation)(relayEnvironment, {
            ...mutation,
            onCompleted: (response, errors)=>{
                if (errors) reject(new (0, $422HI.ApolloErrorInterop)({
                    graphQLErrors: errors.map((error)=>({
                            ...error,
                            path: error.path?.map(String)
                        }))
                }));
                resolve(response);
            },
            onError: (error)=>{
                reject(error);
            }
        });
    });
module.exports["commitMutation"] = $998dea875afc431e$export$e454457a489de4f6;

});

parcelRegister("44LO1", function(module, exports) {

var $6ryhQ = parcelRequire("6ryhQ");


var $18dXR = parcelRequire("18dXR");


var $hp2SH = parcelRequire("hp2SH");


var $17wUi = parcelRequire("17wUi");


var $lmtWR = parcelRequire("lmtWR");


var $l1uFv = parcelRequire("l1uFv");


var $c0rhi = parcelRequire("c0rhi");


var $6s78L = parcelRequire("6s78L");


var $fEmGS = parcelRequire("fEmGS");


var $jO6sX = parcelRequire("jO6sX");

const $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery = (0, $18dXR.default);
const $fa29ff75a45929c5$var$EditorUserPreferencesProviderMutation = (0, $6ryhQ.default);
var $fa29ff75a45929c5$var$Status = /*#__PURE__*/ function(Status) {
    Status["Complete"] = "complete";
    Status["Error"] = "error";
    Status["Pending"] = "pending";
    return Status;
}($fa29ff75a45929c5$var$Status || {});
const $fa29ff75a45929c5$export$48d7c418edadb60c = ()=>Boolean(undefined);
const $fa29ff75a45929c5$export$d8474cff104280f3 = 'editor-controls.initial-preferences';
class $fa29ff75a45929c5$export$7f7007b732b93d85 {
    // synchronously load preferences from cache
    loadPreferencesFromCache() {
        if (!$fa29ff75a45929c5$export$48d7c418edadb60c()) {
            const userPreferenceStorage = (0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).getItem($fa29ff75a45929c5$export$d8474cff104280f3);
            if (userPreferenceStorage) this.userPreferences = JSON.parse(userPreferenceStorage);
        }
        if (!this.apolloClient) return undefined;
        try {
            const result = (0, $l1uFv.readQueryInterop)({
                query: $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery
            });
            if (result?.userPreferences) {
                this.userPreferences = (0, $jO6sX.parseConfluenceEditorSettings)(result.userPreferences?.confluenceEditorSettings);
                // if we have a cached value, we can set the status to complete
                // since we are not going to make a network request
                // to fetch the preferences with loadPreferencesInternal and not skipCache
                if (this.providerStatus !== "complete") this.providerStatus = "complete";
            }
            return this.userPreferences;
        } catch (error) {
            return this.userPreferences;
        }
    }
    async loadPreferencesInternal(options) {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery,
            fetchPolicy: options?.skipCache ? 'no-cache' : 'cache-first'
        });
        this.userPreferences = (0, $jO6sX.parseConfluenceEditorSettings)(data?.userPreferences?.confluenceEditorSettings);
        this.updateLocalStorage();
        return this.userPreferences;
    }
    async loadPreferences() {
        try {
            const userPreferences = await this.loadPreferencesInternal({
                skipCache: true
            });
            // can recover from the status previous error
            if (this.providerStatus !== "complete") this.providerStatus = "complete";
            return userPreferences;
        } catch (error) {
            // We will ignore subssequent errors if thte status was complete
            // And will use the data from previous request
            if (this.providerStatus !== "complete") this.providerStatus = "error";
            return Promise.reject(error);
        }
    }
    updateLocalStorage() {
        if (!$fa29ff75a45929c5$export$48d7c418edadb60c()) (0, $17wUi.confluenceLocalStorageInstance).setItem($fa29ff75a45929c5$export$d8474cff104280f3, JSON.stringify(this.userPreferences));
    }
    async updatePreference(key, value) {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        const variables = {
            [key]: value
        };
        this.userPreferences[key] = value;
        const { data: data } = await (0, $6s78L.mutateInterop)({
            mutation: $fa29ff75a45929c5$var$EditorUserPreferencesProviderMutation,
            variables: variables,
            update: ()=>{
                // this is required to indicate toolbar changes to any useQuery for EditorPreferencesQuery, particularly progressive object header
                const getValue = ()=>value ?? null;
                (0, $fEmGS.writeQueryInterop)({
                    query: $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery,
                    data: {
                        userPreferences: {
                            __typename: 'UserPreferences',
                            confluenceEditorSettings: {
                                __typename: 'ConfluenceEditorSettings',
                                toolbarDockingInitialPosition: getValue()
                            }
                        }
                    }
                });
            }
        });
        const updatedUserPreferences = (0, $jO6sX.parseConfluenceEditorSettings)(data?.updateUserPreferences?.confluenceEditorSettings);
        this.userPreferences = {
            ...this.userPreferences,
            ...updatedUserPreferences
        };
        if (value === 'top') (0, $lmtWR.persistBannerDismissalNewPinning)('toolbar-inline');
        else if (value === 'none') (0, $lmtWR.persistBannerDismissalNewPinning)('toolbar-top');
        this.updateLocalStorage();
    }
    getPreference(key) {
        const fallbackUserPreferences = this.getFallbackUserPreferences?.() || {};
        return this.userPreferences[key] || fallbackUserPreferences[key];
    }
    constructor(options = {}){
        this.userPreferences = {};
        this.getFallbackUserPreferences = void 0;
        // We use getApolloClient to get the apollo client instance
        // This is to avoid adding required apollo context
        this.apolloClient = (0, $hp2SH.getApolloClient)();
        this.providerStatus = "pending";
        this.getFallbackUserPreferences = options.getFallbackUserPreferences;
        this.loadPreferencesFromCache();
        this.loadPreferencesInternal().then(()=>{
            this.providerStatus = "complete";
        }).catch(()=>{
            this.providerStatus = "error";
        });
    }
}
module.exports["isSSR"] = $fa29ff75a45929c5$export$48d7c418edadb60c;
module.exports["LOCAL_STORAGE_KEY"] = $fa29ff75a45929c5$export$d8474cff104280f3;
module.exports["EditorUserPreferencesProvider"] = $fa29ff75a45929c5$export$7f7007b732b93d85;

});

parcelRegister("6ryhQ", function(module, exports) {
/**
 * @generated SignedSource<<3e96611bf508829f767f52513a274d61>>
 * @relayHash abbe28b997f121d37d2a6bcf9de50587
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5be2854f68d3367f4e7c42520108fad469d661f65c300a3a4d181891edb92ec
const $90a65d92fac4dfbd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "toolbarDockingInitialPosition"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "toolbarDockingInitialPosition",
                                    "variableName": "toolbarDockingInitialPosition"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "confluenceEditorSettingsInput"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorUserPreferencesProviderMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorUserPreferencesProviderMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "abbe28b997f121d37d2a6bcf9de50587",
            "id": "f5be2854f68d3367f4e7c42520108fad469d661f65c300a3a4d181891edb92ec",
            "metadata": {},
            "name": "EditorUserPreferencesProviderMutation",
            "operationKind": "mutation",
            "text": "mutation EditorUserPreferencesProviderMutation($toolbarDockingInitialPosition:String!){updateUserPreferences(userPreferences:{confluenceEditorSettingsInput:{toolbarDockingInitialPosition:$toolbarDockingInitialPosition}}){confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$90a65d92fac4dfbd$var$node.hash = "58cff6da35ff84f165c997ef5ed48166";
var $90a65d92fac4dfbd$export$2e2bcd8739ae039 = $90a65d92fac4dfbd$var$node;
module.exports["default"] = $90a65d92fac4dfbd$export$2e2bcd8739ae039;

});

parcelRegister("18dXR", function(module, exports) {
/**
 * @generated SignedSource<<7fc3c5a74ec35d3eba8e51340b57f5de>>
 * @relayHash 63854a4c84372d699a45f9c1a07dc352
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e409706ac010c745c55960052598708ff7eaf469154eb4c8db7ff920f81b76e
const $e4a48aa60613f0b2$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "EditorUserPreferencesProviderQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "EditorUserPreferencesProviderQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "63854a4c84372d699a45f9c1a07dc352",
            "id": "3e409706ac010c745c55960052598708ff7eaf469154eb4c8db7ff920f81b76e",
            "metadata": {},
            "name": "EditorUserPreferencesProviderQuery",
            "operationKind": "query",
            "text": "query EditorUserPreferencesProviderQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$e4a48aa60613f0b2$var$node.hash = "22c44eb8a7e5e6240c1d402a68a09da0";
var $e4a48aa60613f0b2$export$2e2bcd8739ae039 = $e4a48aa60613f0b2$var$node;
module.exports["default"] = $e4a48aa60613f0b2$export$2e2bcd8739ae039;

});

parcelRegister("lmtWR", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7W8i8 = parcelRequire("7W8i8");

const $087f019a02b7077e$var$logger = (0, $7W8i8.getLogger)('EditorControlsBannerDismissal');
const $087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY = (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_EDITOR_CONTROLS_ONBOARDING_BANNER_NEW_PINNING_DISMISSED;
const $087f019a02b7077e$var$AUTO_DISMISSAL_THRESHOLD = 604800000; // 7 days in milliseconds
const $087f019a02b7077e$export$b16c0225931fdfcf = (isTopBanner)=>{
    return isTopBanner ? 'toolbar-top' : 'toolbar-inline';
};
const $087f019a02b7077e$var$getLocalStorageItem = (storageKey)=>{
    try {
        const itemString = (0, $17wUi.confluenceLocalStorageInstance).getItem(storageKey);
        if (!itemString) return undefined;
        const item = JSON.parse(itemString);
        if (typeof item === 'object' && item !== null && !Array.isArray(item) && Object.keys(item).every((key)=>[
                'toolbar-top',
                'toolbar-inline'
            ].includes(key))) return item;
    } catch (error) {
        $087f019a02b7077e$var$logger.error`Error parsing local storage key(${storageKey}): ${error}`;
    }
    return undefined;
};
const $087f019a02b7077e$var$recordFirstViewTime = (bannerType, item)=>{
    const firstViewed = {
        firstViewed: Date.now()
    };
    try {
        if (!item) (0, $17wUi.confluenceLocalStorageInstance).setItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY, JSON.stringify({
            [bannerType]: firstViewed
        }));
        else {
            item[bannerType] = {
                ...item[bannerType],
                ...firstViewed
            };
            (0, $17wUi.confluenceLocalStorageInstance).setItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY, JSON.stringify(item));
        }
    } catch (error) {
        $087f019a02b7077e$var$logger.error`Error setting local storage key(${$087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY}): ${error}`;
    }
};
const $087f019a02b7077e$export$7b46a18b5966c9f8 = (bannerType)=>{
    const localStorageItem = $087f019a02b7077e$var$getLocalStorageItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY);
    const { firstViewed: firstViewed, count: dismissalCount } = localStorageItem?.[bannerType] || {};
    // Record first view time if it does not exist. Do this before returning to
    // ensure we record a time even if there are no prior records
    if (firstViewed === undefined) $087f019a02b7077e$var$recordFirstViewTime(bannerType, localStorageItem);
    // No local storage = no banner dismissal
    if (!localStorageItem) return false;
    // If banner was first viewed more than a week ago, hide it even if it had not been dismissed
    const shouldAutoDismiss = firstViewed && Date.now() - firstViewed > $087f019a02b7077e$var$AUTO_DISMISSAL_THRESHOLD;
    if (shouldAutoDismiss) return true;
    // If count is anything other than undefined, it means the banner has been dismissed (including if count is 0!)
    return dismissalCount !== undefined;
};
const $087f019a02b7077e$export$1f63bcf565c85af4 = (bannerType)=>{
    let item = $087f019a02b7077e$var$getLocalStorageItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY);
    if (!item) item = {
        [bannerType]: {
            count: 0
        }
    };
    else {
        const existingDismissal = item[bannerType];
        item[bannerType] = {
            ...existingDismissal,
            count: 0
        };
    }
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY, JSON.stringify(item));
    } catch (error) {
        $087f019a02b7077e$var$logger.error`Error setting local storage key(${$087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY}): ${error}`;
    }
};
module.exports["getBannerType"] = $087f019a02b7077e$export$b16c0225931fdfcf;
module.exports["isBannerDismissedInLocalStorage"] = $087f019a02b7077e$export$7b46a18b5966c9f8;
module.exports["persistBannerDismissalNewPinning"] = $087f019a02b7077e$export$1f63bcf565c85af4;

});

parcelRegister("iGI5F", function(module, exports) {

var $iraTI = parcelRequire("iraTI");

var $kwopk = parcelRequire("kwopk");


var $17wUi = parcelRequire("17wUi");


var $l1uFv = parcelRequire("l1uFv");


var $c0rhi = parcelRequire("c0rhi");


var $6s78L = parcelRequire("6s78L");


var $fEmGS = parcelRequire("fEmGS");


var $cbHql = parcelRequire("cbHql");


var $bPFvq = parcelRequire("bPFvq");


var $44LO1 = parcelRequire("44LO1");


var $6mKj3 = parcelRequire("6mKj3");

const $5fb34be1fffb3f33$var$parseConfluenceEditorSettings = (confluenceEditorSettings)=>{
    if (confluenceEditorSettings) {
        const result = {};
        const entries = Object.entries(confluenceEditorSettings);
        for (const [key, value] of entries){
            if (key === 'toolbarDockingInitialPosition' && value && (0, $iraTI.TOOLBAR_DOCKING_POSITIONS).includes(value)) result.toolbarDockingPosition = value;
            else if (value !== null && value !== undefined) // Pass through other settings as-is
            result[key] = value;
        }
        return result;
    }
    return {};
};
const $5fb34be1fffb3f33$var$updateLocalStorage = (userPreferences)=>{
    // confluenceLocalStorageInstance is only available in the browser environment
    if (!(0, $44LO1.isSSR)() && (0, $17wUi.confluenceLocalStorageInstance)) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $44LO1.LOCAL_STORAGE_KEY), JSON.stringify(userPreferences));
};
class $5fb34be1fffb3f33$export$acb1a00758cac9cd {
    setIsLoggedIn(isLoggedin) {
        this.isLoggedin = isLoggedin;
    }
    getInitialUserPreferences() {
        let initialUserPreferences;
        try {
            const result = (0, $l1uFv.readQueryInterop)({
                query: (0, $cbHql.default)
            });
            if (result?.userPreferences) initialUserPreferences = $5fb34be1fffb3f33$var$parseConfluenceEditorSettings(result.userPreferences?.confluenceEditorSettings);
        } catch (_error) {
            initialUserPreferences = undefined;
        }
        // If we don't have values from the Apollo cache, we try to fetch from local storage
        if (!initialUserPreferences && !(0, $44LO1.isSSR)()) try {
            const userPreferenceStorage = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $44LO1.LOCAL_STORAGE_KEY));
            if (userPreferenceStorage) initialUserPreferences = JSON.parse(userPreferenceStorage);
        } catch (_error) {
            // If the local storage is corrupted or not available, we ignore the error and return undefined
            initialUserPreferences = undefined;
        }
        return initialUserPreferences;
    }
    async updateUserPreference(key, value) {
        if (!this.isLoggedin) // If the user is not logged in, we return the key with updated value
        // This is to ensure that the editor can still function without flaws
        // but the value will not be persisted to the server
        return Promise.resolve({
            [key]: value
        });
        // we only support updating the toolbarDockingInitialPosition preference ATM,
        // need to update this if we add more preferences
        const variables = {
            toolbarDockingInitialPosition: value
        };
        try {
            const { data: data } = await (0, $6s78L.mutateInterop)({
                mutation: (0, $bPFvq.default),
                variables: variables
            });
            // this is required to indicate toolbar changes to any useQuery for EditorPreferencesQuery, particularly progressive object header
            (0, $fEmGS.writeQueryInterop)({
                query: (0, $cbHql.default),
                data: {
                    userPreferences: {
                        __typename: 'UserPreferences',
                        confluenceEditorSettings: {
                            toolbarDockingInitialPosition: value ?? null
                        }
                    }
                }
            });
            const userPreferences = $5fb34be1fffb3f33$var$parseConfluenceEditorSettings(data?.updateUserPreferences?.confluenceEditorSettings);
            $5fb34be1fffb3f33$var$updateLocalStorage(userPreferences);
            return {
                [key]: userPreferences[key]
            };
        } catch (_error) {
            // In case of an error, we return the key with updated value
            // This is to ensure that the editor can still function without flaws
            // but the value might not be persisted to the server
            return {
                [key]: value
            };
        }
    }
    async loadUserPreferences() {
        let userPreferences = {};
        if (!this.isLoggedin) // If the user is not logged in, we return an empty object
        return Promise.resolve(userPreferences);
        try {
            // first time we load we use cache-first policy to avoid unnecessary network requests
            // after the first load we always use no-cache to ensure we have the latest preferences
            // this is particularly important when user has multiple tabs open and changes preferences in one tab
            // we want to ensure other tabs have the latest preferences
            const fetchPolicy = !this.isInitialLoad && (0, $6mKj3.expVal)('cc_editor_preferences_query_optimisation', 'isEnabled', false) ? 'cache-first' : 'no-cache';
            this.isInitialLoad = true;
            const { data: data } = await (0, $c0rhi.queryInterop)({
                query: (0, $cbHql.default),
                fetchPolicy: fetchPolicy
            });
            userPreferences = $5fb34be1fffb3f33$var$parseConfluenceEditorSettings(data?.userPreferences?.confluenceEditorSettings);
            $5fb34be1fffb3f33$var$updateLocalStorage(userPreferences);
            return userPreferences;
        } catch (_error) {
            // if upload local storage fails, we will still return the user preferences
            return userPreferences;
        }
    }
    constructor(isLoggedin = true){
        this.isLoggedin = true;
        this.isInitialLoad = false;
        this.setIsLoggedIn(isLoggedin);
    }
}
const $5fb34be1fffb3f33$export$c53529b5ad54089d = (options)=>{
    const persistenceAPI = options.persistenceAPI || new $5fb34be1fffb3f33$export$acb1a00758cac9cd();
    return new (0, $kwopk.UserPreferencesProvider)(persistenceAPI, {
        toolbarDockingPosition: options.isLivePage ? 'none' : 'top'
    });
};
module.exports["UserPreferencesPersistenceAPI"] = $5fb34be1fffb3f33$export$acb1a00758cac9cd;
module.exports["getUserPreferencesProvider"] = $5fb34be1fffb3f33$export$c53529b5ad54089d;

});

parcelRegister("iraTI", function(module, exports) {
const $eb340c49362f17be$export$e2238e88752bfc4a = [
    'top',
    'none'
];
module.exports["TOOLBAR_DOCKING_POSITIONS"] = $eb340c49362f17be$export$e2238e88752bfc4a;

});

parcelRegister("kwopk", function(module, exports) {

var $6Npva = parcelRequire("6Npva");

class $94172f9fef348b93$export$42096c77943a6f6f {
    /**
   * This method returns the initialized state of the user preferences provider
   * @returns true if the user preferences provider is initialized, false otherwise
   * @example userPreferencesProvider.isInitialized
   */ get isInitialized() {
        return this.initialized;
    }
    /**
   * This method fetches the latest user preferences
   * @returns a promise that resolves with the user preferences, or rejects if error occurs
   * @throws Error if there is an error loading user preferences
   * @example userPreferencesProvider.loadPreferences()
   */ async loadPreferences() {
        const userPreferences = await this.persistenceAPI.loadUserPreferences();
        this.setUserPreferences(userPreferences);
    }
    /**
   * This method updates a user preference
   * @param key
   * @param value
   * @returns a promise that resolves when the user preference is updated
   * @throws Error if there is an error updating user preferences
   * @example userPreferencesProvider.updatePreference('toolbarDockingPosition', 'top')
   */ async updatePreference(key, value) {
        const userPreferences = await this.persistenceAPI.updateUserPreference(key, value);
        this.setUserPreferences(userPreferences);
    }
    /**
   * get a user preference, Note that this function is a not async function,
   * meaning that consumers should prefetch the user preference and make it available initially
   * @param key
   * @returns the user preference
   * @example userPreferencesProvider.getPreference('toolbarDockingPosition')
   */ getPreference(key) {
        return this.resolvedUserPreferences[key];
    }
    /**
   * get all user preferences
   * @returns the user preferences
   * @example userPreferencesProvider.getPreferences()
   */ getPreferences() {
        return this.resolvedUserPreferences;
    }
    /**
   * This method fetches the latest user preferences
   * @param onUpdate
   * @returns a function to unsubscribe from the updates
   * @example
   */ onUpdate(onUpdate) {
        this.updateCallbacks.push(onUpdate);
        // Return the cleanup function to unsubscribe from the updates
        return ()=>{
            this.updateCallbacks = this.updateCallbacks.filter((callback)=>callback !== onUpdate);
        };
    }
    /**
   * This method is used to set the default user preferences,
   * setting the default user preferences will also trigger an update
   * This is useful when the default user preferences dynamically based on the context
   * @param preferences
   * @example
   */ setDefaultPreferences(preferences) {
        this.defaultPreferences = preferences;
        const hasUpdated = this.resolveUserPreferences();
        if (hasUpdated) this.notifyUserPreferencesUpdated();
    }
    setUserPreferences(userPreferences) {
        this.userPreferences = userPreferences;
        const hasUpdated = this.resolveUserPreferences();
        if (hasUpdated || !this.initialized) {
            if (!this.initialized) this.initialized = true;
            this.notifyUserPreferencesUpdated();
        }
    }
    /**
   * This method is used to notify the user preferences updated
   * @example userPreferencesProvider.notifyUserPreferencesUpdated()
   */ notifyUserPreferencesUpdated() {
        this.updateCallbacks.forEach((callback)=>{
            callback(this.resolvedUserPreferences);
        });
    }
    /**
   * This method resolves the user preferences by merging the default preferences
   * with the user preferences and filtering out any undefined or null values
   * to avoid overwriting default preferences with null values
   * @returns true if the user preferences were updated, false otherwise
   * @example userPreferencesProvider.resolveUserPreferences()
   */ resolveUserPreferences() {
        // Merge default preferences with user preferences
        // and filter out any undefined or null values
        // to avoid overwriting default preferences with null values
        const newResolvedUserPreferences = (0, $6Npva.mergeUserPreferences)(this.userPreferences, this.defaultPreferences);
        // if the user preferences is NOT initialized, we need to update and notify
        // the user preferences
        // if the user preferences is initialized, we need to check if the new user preferences
        // is different from the old user preferences
        const isSame = (0, $6Npva.areUserPreferencesEqual)(newResolvedUserPreferences, this.resolvedUserPreferences);
        const needUpdate = !isSame;
        if (needUpdate) this.resolvedUserPreferences = newResolvedUserPreferences;
        return needUpdate;
    }
    /**
   * This is the constructor for the UserPreferencesProvider class.
   * @param persistenceAPI - The persistence API to use for loading and updating user preferences
   * @param defaultPreferences - The default user preferences to use
   * @param initialUserPreferences - The initial user preferences to use (optional)
   * @example const userPreferencesProvider = new UserPreferencesProvider(persistenceAPI, defaultPreferences);
   */ constructor(persistenceAPI, defaultPreferences){
        this.updateCallbacks = [];
        this.userPreferences = {};
        this.defaultPreferences = void 0;
        this.resolvedUserPreferences = void 0;
        this.initialized = false;
        this.persistenceAPI = void 0;
        this.persistenceAPI = persistenceAPI;
        this.defaultPreferences = defaultPreferences;
        this.resolvedUserPreferences = defaultPreferences;
        const initialUserPreferences = this.persistenceAPI.getInitialUserPreferences?.();
        if (initialUserPreferences) this.setUserPreferences(initialUserPreferences);
        // the initial user preferences might come from the local cache,
        // so we need to always load the preferences
        this.loadPreferences();
    }
}
module.exports["UserPreferencesProvider"] = $94172f9fef348b93$export$42096c77943a6f6f;

});

parcelRegister("6Npva", function(module, exports) {

var $iraTI = parcelRequire("iraTI");

const $4717a3a92f858726$export$c583bb83c793248b = (userPreferences, defaultPreferences)=>{
    const newResolvedUserPreferences = {
        ...defaultPreferences,
        ...Object.fromEntries(Object.entries(userPreferences).filter(([key, value])=>{
            if (key === 'toolbarDockingPosition') return (0, $iraTI.TOOLBAR_DOCKING_POSITIONS).includes(value);
            return value !== undefined && value !== null;
        }))
    };
    return newResolvedUserPreferences;
};
const $4717a3a92f858726$export$6d64c804b8f53798 = (left, right)=>{
    return Object.entries(left).every(([key, value])=>{
        return value === right[key];
    });
};
module.exports["mergeUserPreferences"] = $4717a3a92f858726$export$c583bb83c793248b;
module.exports["areUserPreferencesEqual"] = $4717a3a92f858726$export$6d64c804b8f53798;

});

parcelRegister("2RJaj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $5RBJ9 = parcelRequire("5RBJ9");

var $6cnUO = parcelRequire("6cnUO");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $inPa6 = parcelRequire("inPa6");


var $d925B = parcelRequire("d925B");


var $8fj5s = parcelRequire("8fj5s");


var $7aRa9 = parcelRequire("7aRa9");


var $9uAPw = parcelRequire("9uAPw");


var $9wGTI = parcelRequire("9wGTI");


var $hQYP3 = parcelRequire("hQYP3");

const $c20dabc729e51c55$var$i18n = (0, $cgtv4.defineMessages)({
    body: {
        id: "loom-onboarding.editor-toolbar-button-spotlight.content",
        defaultMessage: "Record a Loom video to add context or a content walkthrough."
    },
    dismissButton: {
        id: "loom-onboarding.editor-toolbar-button-spotlight.dismissButton",
        defaultMessage: "Dismiss"
    },
    tryItOutButton: {
        id: "loom-onboarding.editor-toolbar-button-spotlight.tryItOutButton",
        defaultMessage: "Try it out"
    }
});
const $c20dabc729e51c55$var$SCREEN_NAME = 'editorToolbarLoomButtonOnboardingSpotlight';
const $c20dabc729e51c55$var$EditorToolbarLoomButtonSpotlightComponent = ({ children: children, editorAPIRef: editorAPIRef, spotlightPlacement: spotlightPlacement, nudgeSource: nudgeSource, epMessage: epMessage, flags: flags, isCircle: isCircle })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isLoomRecorderInitialized: isLoomRecorderInitialized, hasRecordingAccess: hasRecordingAccess } = (0, $9uAPw.useLoomRecorderEntryPoint)({
        flags: flags,
        entryPointLocation: 'editor-spotlight'
    });
    const [isLoomGAOnboardingActive, stopLoomGAOnboarding] = (0, $8fj5s.useSkippableCoordination)(epMessage, !(0, $9wGTI.fg)('confluence_m25_onboarding_spotlights') || !(isLoomRecorderInitialized && hasRecordingAccess));
    const [isClosed, setIsClosed] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: $c20dabc729e51c55$var$SCREEN_NAME,
                attributes: {
                    nudgeSource: nudgeSource
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const closeSpotlight = (0, $42omo.useCallback)(()=>{
        if (!isClosed) {
            stopLoomGAOnboarding();
            setIsClosed(true);
        }
    }, [
        isClosed,
        setIsClosed,
        stopLoomGAOnboarding
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: $c20dabc729e51c55$var$SCREEN_NAME,
                attributes: {
                    nudgeSource: nudgeSource
                }
            }
        }).fire();
        closeSpotlight();
    }, [
        closeSpotlight,
        createAnalyticsEvent,
        nudgeSource
    ]);
    const handleTryItOut = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'tryItOut',
                source: $c20dabc729e51c55$var$SCREEN_NAME,
                attributes: {
                    nudgeSource: nudgeSource
                }
            }
        }).fire();
        if (editorAPIRef.current && editorAPIRef.current?.loom && editorAPIRef.current?.analytics) editorAPIRef.current.core?.actions.execute(editorAPIRef.current.loom.actions.recordVideo({
            inputMethod: (0, $d925B.INPUT_METHOD).BUTTON,
            editorAnalyticsAPI: editorAPIRef.current.analytics.actions
        }));
        closeSpotlight();
    }, [
        closeSpotlight,
        createAnalyticsEvent,
        editorAPIRef,
        nudgeSource
    ]);
    if (isLoomGAOnboardingActive && !isClosed && (0, $9wGTI.fg)('confluence_m25_onboarding_spotlights')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "editor-toolbar-loom-button-spotlight"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RBJ9.default), {
        target: "editor-toolbar-loom-button-spotlight",
        targetBgColor: "var(--ds-text-inverse, #FFFFFF)",
        targetRadius: isCircle ? 24 : 6,
        dialogWidth: 275,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($hQYP3))),
        dialogPlacement: spotlightPlacement,
        actions: [
            {
                text: intl.formatMessage($c20dabc729e51c55$var$i18n.tryItOutButton),
                onClick: handleTryItOut
            },
            {
                text: intl.formatMessage($c20dabc729e51c55$var$i18n.dismissButton),
                onClick: handleDismiss,
                appearance: 'subtle'
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c20dabc729e51c55$var$i18n.body))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $c20dabc729e51c55$export$89c032d487dc8fb7 = (0, $7aRa9.withFlags)($c20dabc729e51c55$var$EditorToolbarLoomButtonSpotlightComponent);
module.exports["EditorToolbarLoomButtonSpotlight"] = $c20dabc729e51c55$export$89c032d487dc8fb7;

});

parcelRegister("8fj5s", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lwNi3 = parcelRequire("lwNi3");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");

const $595fe854badba39a$export$a691d616fae8bb9d = (messageId, skip = false, withChoreographer = true)=>{
    const [isMessageActive, setisMessageActive] = (0, $42omo.useState)(false);
    const [isLoading, setLoading] = (0, $42omo.useState)(true);
    const coordinationClient = (0, $lwNi3.useCoordinationClient)(withChoreographer);
    (0, $42omo.useEffect)(()=>{
        async function startMessage() {
            try {
                const _isMessageActive = await coordinationClient.start(messageId);
                setisMessageActive(_isMessageActive);
            } catch (err) {
                (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                    attribution: (0, $3IBnw.Attribution).CONTENPLATES
                });
            }
            setLoading(false);
        }
        if (skip) return;
        startMessage();
    }, [
        coordinationClient,
        messageId,
        skip
    ]);
    const stop = (0, $42omo.useCallback)(async (force = false)=>{
        if (!force && !isMessageActive) return;
        try {
            await coordinationClient.stop(messageId);
            setisMessageActive(false);
        } catch (err) {
            (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                attribution: (0, $3IBnw.Attribution).CONTENPLATES
            });
        }
    }, [
        isMessageActive,
        coordinationClient,
        messageId
    ]);
    return [
        isMessageActive,
        stop,
        skip ? false : isLoading
    ];
};
module.exports["useSkippableCoordination"] = $595fe854badba39a$export$a691d616fae8bb9d;

});

parcelRegister("lwNi3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $04e9M = parcelRequire("04e9M");


var $jOtRZ = parcelRequire("jOtRZ");


var $lBR3p = parcelRequire("lBR3p");

const $5efec5cf952678ca$export$ddc368dc94a41e62 = (withChoreographer = true)=>{
    const { cloudId: cloudId, activationId: activationId, environment: environment } = (0, $bQm3c.useSessionData)();
    const workspaceId = (0, $04e9M.getWorkspaceId)(cloudId, activationId);
    const disableEngagementForTests = sessionStorage.getItem('confluence.disable-engagement-for-tests') === 'true';
    const envType = (0, $jOtRZ.useAnalyticsEnvironment)(environment);
    return (0, $42omo.useMemo)(()=>(0, $lBR3p.getCoordinationClient)(disableEngagementForTests, cloudId, workspaceId, withChoreographer, envType), [
        disableEngagementForTests,
        cloudId,
        workspaceId,
        withChoreographer,
        envType
    ]);
};
module.exports["useCoordinationClient"] = $5efec5cf952678ca$export$ddc368dc94a41e62;

});

parcelRegister("lBR3p", function(module, exports) {

var $5loD0 = parcelRequire("5loD0");


var $fw9LG = parcelRequire("fw9LG");

const $b379edbfb382bc54$var$noop = async ()=>false;
const $b379edbfb382bc54$export$a3f969ef7d35205d = (disableEngagementForTests, cloudId, workspaceId, enableChoreographer, environment)=>{
    if (disableEngagementForTests) return {
        start: $b379edbfb382bc54$var$noop,
        stop: $b379edbfb382bc54$var$noop
    };
    else {
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: environment,
            additionalData: {
                sourceProductId: (0, $fw9LG.ProductIds).CONFLUENCE
            }
        };
        return new (0, $5loD0.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            isFedRAMPEnvironment: false,
            workspaceId: workspaceId,
            coordinationOptions: coordinationOptions
        });
    }
};
module.exports["getCoordinationClient"] = $b379edbfb382bc54$export$a3f969ef7d35205d;

});

parcelRegister("5loD0", function(module, exports) {

var $ll2sR = parcelRequire("ll2sR");


var $4nGsu = parcelRequire("4nGsu");

class $4b61f610720049a6$export$2e2bcd8739ae039 {
    async start(messageId, variationId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    constructor(configOrCloudId, stargateUrl){
        this.cloudId = void 0;
        this.stargateUrl = void 0;
        this.orgId = void 0;
        this.workspaceId = void 0;
        this.coordinationOptions = void 0;
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
}
module.exports["default"] = $4b61f610720049a6$export$2e2bcd8739ae039;

});

parcelRegister("hQYP3", function(module, exports) {
module.exports = new URL("pageHeaderSpotlightImage.b1e98e59.png", import.meta.url).toString();

});

parcelRegister("2pBiX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");

const $e5ba90f4b97bd7c1$var$i18n = (0, $cgtv4.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    }
});
const $e5ba90f4b97bd7c1$export$b8f10a3122c10d73 = ({ flags: flags })=>{
    const intl = (0, $8C5kA.default)();
    return (0, $42omo.useCallback)(()=>{
        flags.showInfoFlag({
            title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
            description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
        });
    }, [
        flags,
        intl
    ]);
};
module.exports["useLoomEntryPointErrorCallback"] = $e5ba90f4b97bd7c1$export$b8f10a3122c10d73;

});

parcelRegister("hMfsx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $9wGTI = parcelRequire("9wGTI");


var $ej7WH = parcelRequire("ej7WH");


var $k0DFC = parcelRequire("k0DFC");


var $f5Ulo = parcelRequire("f5Ulo");


var $erVVf = parcelRequire("erVVf");

const $985cb37370034aac$var$crossFlowAdType = 'crossFlow';
const $985cb37370034aac$var$crossJoinAdType = 'crossJoin';
const $985cb37370034aac$export$26447b7789af7a96 = ({ buttonComponent: ButtonComponent, sourceActionSubjectId: sourceActionSubjectId, entryPointId: entryPointId, sourceComponent: sourceComponent, sourceContext: sourceContext })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const triggerCrossFlow = (0, $ej7WH.useLoomCrossFlowRequestAccessCallback)({
        sourceComponent: sourceComponent,
        sourceContext: sourceContext
    });
    const { isInterestedInLoom: isInterestedInLoom } = (0, $k0DFC.useLoomAdControlState)({
        touchpoint: entryPointId
    });
    const onCrossFlowTriggerClick = (0, $42omo.useCallback)(async (triggerName)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: triggerName,
                source: triggerName === 'tryNow' ? 'loomCrossFlowPopupCard' : sourceActionSubjectId,
                attributes: {
                    adType: $985cb37370034aac$var$crossFlowAdType,
                    entrypoint: entryPointId
                }
            }
        }).fire();
        await triggerCrossFlow();
    }, [
        createAnalyticsEvent,
        entryPointId,
        triggerCrossFlow,
        sourceActionSubjectId
    ]);
    if (!isInterestedInLoom) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, {
        onClickBeforeInit: ()=>onCrossFlowTriggerClick(sourceActionSubjectId)
    });
};
const $985cb37370034aac$export$53b6c16ae8132c96 = ({ buttonComponent: ButtonComponent, sourceActionSubjectId: sourceActionSubjectId, entryPointId: entryPointId, sourceComponent: sourceComponent, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const streamliningCrossJoinOnButtonClicked = (0, $erVVf.useStreamliningCrossJoin)({
        entryPointId: entryPointId,
        flags: flags,
        source: sourceActionSubjectId,
        sourceAdType: $985cb37370034aac$var$crossJoinAdType,
        sourceComponent: sourceComponent
    });
    const onCrossJoinSuccess = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: entryPointId,
                adType: $985cb37370034aac$var$crossJoinAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker
    ]);
    const onCrossJoinTriggerClick = (0, $42omo.useCallback)(async ()=>{
        if ((0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate')) await streamliningCrossJoinOnButtonClicked();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: sourceActionSubjectId,
                source: sourceActionSubjectId,
                attributes: {
                    adType: $985cb37370034aac$var$crossJoinAdType,
                    entrypoint: entryPointId,
                    sourceComponent: sourceComponent
                }
            }
        }).fire();
        onCrossJoinSuccess();
    }, [
        createAnalyticsEvent,
        entryPointId,
        onCrossJoinSuccess,
        sourceActionSubjectId,
        sourceComponent,
        streamliningCrossJoinOnButtonClicked
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, {
        onClickBeforeInit: onCrossJoinTriggerClick,
        href: !(0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? crossJoinHref : undefined,
        target: "_blank",
        rel: "noreferrer"
    });
};
module.exports["CrossFlowMenuItem"] = $985cb37370034aac$export$26447b7789af7a96;
module.exports["CrossJoinMenuItem"] = $985cb37370034aac$export$53b6c16ae8132c96;

});

parcelRegister("ej7WH", function(module, exports) {

var $42omo = parcelRequire("42omo");

parcelRequire("2YerA");
var $fqrVl = parcelRequire("fqrVl");
var $jCM2u = parcelRequire("jCM2u");
parcelRequire("49sr4");
var $82BVR = parcelRequire("82BVR");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $a763567c6da5be00$export$fa70eeb8352dd55e = ({ sourceComponent: sourceComponent, sourceContext: sourceContext })=>{
    const crossFlow = (0, $jCM2u.useCrossFlow)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    return (0, $42omo.useCallback)(async ()=>{
        if (!crossFlow.isEnabled) {
            experienceTracker.fail({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                error: new Error('Loom crossflow is not enabled'),
                attributes: {
                    sourceComponent: sourceComponent,
                    adType: 'crossFlow'
                }
            });
            return;
        }
        experienceTracker.succeed({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: sourceComponent,
                adType: 'crossFlow'
            }
        });
        try {
            /**
			 * Additionally, if the user *does* go through cross-flow, they'll be navigated to Loom.com and
			 * not return to this code path.
			 */ await crossFlow.apiV1.open({
                journey: (0, $fqrVl.Journeys).GET_STARTED,
                sourceComponent: sourceComponent,
                sourceContext: sourceContext,
                targetProduct: (0, $82BVR.Targets).LOOM,
                v1: true
            });
        } catch (error) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
            });
        }
    }, [
        crossFlow,
        sourceComponent,
        experienceTracker,
        sourceContext
    ]);
};
module.exports["useLoomCrossFlowRequestAccessCallback"] = $a763567c6da5be00$export$fa70eeb8352dd55e;

});

parcelRegister("2YerA", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("jCM2u")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("jCM2u")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("jCM2u")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("fqrVl")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("fqrVl")).Reasons);

var $jCM2u = parcelRequire("jCM2u");


var $fqrVl = parcelRequire("fqrVl");


});

parcelRegister("jCM2u", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5xIym = parcelRequire("5xIym");


var $5B9n6 = parcelRequire("5B9n6");


var $fqrVl = parcelRequire("fqrVl");

const $32c19fce160b377b$var$LATEST_VERSION = (0, $5B9n6.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $32c19fce160b377b$var$CrossFlowContext = /*#__PURE__*/ (0, $42omo.createContext)(()=>({
        isEnabled: false,
        reason: (0, $fqrVl.Reasons).NO_PROVIDER
    }));
const $32c19fce160b377b$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $5B9n6.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $5xIym.createAPIv0)(onOpen),
                    apiV1: (0, $5B9n6.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $fqrVl.Reasons).NO_API_SUPPORT
                };
        }
    };
const $32c19fce160b377b$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $42omo.useMemo)(()=>$32c19fce160b377b$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($32c19fce160b377b$var$CrossFlowContext.Provider, {
        value: negotiateApi,
        children: children
    });
};
const $32c19fce160b377b$export$6e7a10fe635a0dfc = ()=>{
    const negotiateApi = (0, $42omo.useContext)($32c19fce160b377b$var$CrossFlowContext);
    return (0, $42omo.useMemo)(()=>negotiateApi($32c19fce160b377b$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $32c19fce160b377b$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (props)=>{
        const crossFlow = $32c19fce160b377b$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}
module.exports["BaseCrossFlowApiProvider"] = $32c19fce160b377b$export$c0ddec072762f62a;
module.exports["useCrossFlow"] = $32c19fce160b377b$export$6e7a10fe635a0dfc;
module.exports["withCrossFlow"] = $32c19fce160b377b$export$655b6c19a0daddb8;

});

parcelRegister("5xIym", function(module, exports) {
const $1eb0c594c750199f$export$a4ad2735b021c132 = 0;
const $1eb0c594c750199f$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["createAPIv0"] = $1eb0c594c750199f$export$9ff7368ac93fcf2d;

});

parcelRegister("5B9n6", function(module, exports) {
const $12de2f6721823415$export$a4ad2735b021c132 = 1;
const $12de2f6721823415$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["VERSION"] = $12de2f6721823415$export$a4ad2735b021c132;
module.exports["createAPIv1"] = $12de2f6721823415$export$8fd5792fc468459f;

});

parcelRegister("fqrVl", function(module, exports) {
const $4db9b154d66dd01a$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $4db9b154d66dd01a$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};
module.exports["Journeys"] = $4db9b154d66dd01a$export$3411873bfd520bb6;
module.exports["Reasons"] = $4db9b154d66dd01a$export$da2d4f2f250d6f84;

});

parcelRegister("49sr4", function(module, exports) {
$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("ctMWd")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("82BVR")).Targets);

var $ctMWd = parcelRequire("ctMWd");


var $82BVR = parcelRequire("82BVR");


});

parcelRegister("ctMWd", function(module, exports) {
class $0081b4f618dff6fe$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}
module.exports["CrossFlowExtensions"] = $0081b4f618dff6fe$export$a5e53d1dcbd6eb61;

});

parcelRegister("82BVR", function(module, exports) {
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $49d7ae8ec7eae7d8$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand',
    TEAMWORK_COLLECTION: 'teamwork-collection'
};
module.exports["Targets"] = $49d7ae8ec7eae7d8$export$59a8eb9cff113544;

});

parcelRegister("k0DFC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $66b8bcdb334754ff$var$getCachedValuesArray = ()=>{
    try {
        const cachedValues = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED);
        if (cachedValues !== null && cachedValues !== 'undefined') return String(cachedValues).split(',');
    } catch (e) {} // Swallow any errors and return empty array
    return [];
};
const $66b8bcdb334754ff$export$83d1e1540840fcd3 = ({ touchpoint: touchpoint })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const valueToBeCached = `${touchpoint}.${userId}.${cloudId}`;
    const cachedValuesArray = $66b8bcdb334754ff$var$getCachedValuesArray();
    const [isInterestedInLoom, setIsInterestedInLoom] = (0, $42omo.useState)(!cachedValuesArray || !cachedValuesArray.includes(valueToBeCached));
    const notInterestedInLoomCallback = (0, $42omo.useCallback)(async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'notInterested',
                source: 'loomAdControlDropdown',
                attributes: {
                    adType: 'crossFlow',
                    entrypoint: touchpoint
                }
            }
        }).fire();
        // Avoid duplicate values being added to cache
        if (!isInterestedInLoom) return;
        // Ensure fresh cache values array by reading from storage
        const freshCachedValuesArray = $66b8bcdb334754ff$var$getCachedValuesArray();
        freshCachedValuesArray.push(valueToBeCached);
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED, freshCachedValuesArray);
        setIsInterestedInLoom(false);
    }, [
        isInterestedInLoom,
        valueToBeCached,
        createAnalyticsEvent,
        touchpoint
    ]);
    return {
        isInterestedInLoom: isInterestedInLoom,
        notInterestedInLoomCallback: notInterestedInLoomCallback
    };
};
module.exports["useLoomAdControlState"] = $66b8bcdb334754ff$export$83d1e1540840fcd3;

});

parcelRegister("f5Ulo", function(module, exports) {

var $dedJV = parcelRequire("dedJV");


var $bQm3c = parcelRequire("bQm3c");

const $3326fe0c1f9a5868$var$environmentMap = {
    DEVELOPMENT: 'dev',
    STAGING: 'stg',
    PRODUCTION: 'prod'
};
const $3326fe0c1f9a5868$export$80677895f41c9591 = ()=>{
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    // Using `environment` from session data (rather than letting `getATLContextDomain` determine it
    // internally) in order to better support local development that can be targeted at different
    // Confluence BE environments
    const identityDomain = (0, $dedJV.getATLContextDomain)('id', [
        $3326fe0c1f9a5868$var$environmentMap[environment],
        'commercial'
    ]);
    const loomResourceAri = `ari:cloud:loom::site/${cloudId}`;
    const continueUrl = environment === 'PRODUCTION' ? 'https://loom.com/api/auth/atlassian' : 'https://stage.loom.com/api/auth/atlassian';
    const userAccessUrl = encodeURIComponent(`https://${identityDomain}/join/user-access?resource=${loomResourceAri}&continue=${continueUrl}`);
    return `https://${identityDomain}/login?continue=${userAccessUrl}`;
};
module.exports["useLoomCrossJoinUrl"] = $3326fe0c1f9a5868$export$80677895f41c9591;

});

parcelRegister("erVVf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $7p4As = parcelRequire("7p4As");


var $6mKj3 = parcelRequire("6mKj3");


var $f5Ulo = parcelRequire("f5Ulo");


var $64hvi = parcelRequire("64hvi");

const $7197be9efeb6a957$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    requestAccessSuccessFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.title",
        defaultMessage: "Your admins were notified of your request"
    },
    requestAccessSuccessFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.description",
        defaultMessage: "You\u2019ll receive an email once they\u2019ve approved it."
    },
    requestAccessErrorFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.title",
        defaultMessage: "We couldn't add you to Loom"
    },
    requestAccessErrorFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.description",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join,"
    },
    requestAccessErrorFlagActionTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.action.title",
        defaultMessage: "contact support"
    }
});
const $7197be9efeb6a957$export$76d3f97e5e2f022d = ({ entryPointId: entryPointId, flags: flags, source: source, sourceAdType: sourceAdType, sourceComponent: sourceComponent })=>{
    const intl = (0, $8C5kA.default)();
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const requestAccess = (0, $64hvi.useRequestAccessService)({
        entryPointId: entryPointId,
        source: source,
        sourceAdType: sourceAdType
    });
    const fetchRequestAccessCapability = (0, $64hvi.useFetchRequestAccessCapability)({
        entryPointId: entryPointId,
        source: source,
        sourceAdType: sourceAdType
    });
    return (0, $42omo.useCallback)(async ()=>{
        const capability = await fetchRequestAccessCapability();
        if (capability === 'REQUEST_ACCESS') {
            if ([
                'control',
                'variation'
            ].includes((0, $6mKj3.expVal)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'not-enrolled'))) {
                // fire manual feature exposed event for control and variation cohorts only
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'exposed',
                        actionSubject: 'feature',
                        source: source,
                        attributes: {
                            adType: sourceAdType,
                            entrypoint: entryPointId,
                            flagKey: 'twcg-1241_streamlining_loom_cross_join',
                            cohort: (0, $6mKj3.expVal)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'not-enrolled')
                        }
                    }
                }).fire();
                // streamlining access request flow for variation cohort
                if ((0, $6mKj3.expValEquals)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'variation')) try {
                    const requestedAccess = await requestAccess();
                    if (requestedAccess) {
                        flags && flags.showSuccessFlag({
                            title: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessSuccessFlagTitle),
                            description: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessSuccessFlagDescription)
                        });
                        // after successful access request, we do not proceed to open the cross join link
                        return;
                    }
                } catch (error) {
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'failed',
                            actionSubject: 'requestAccess',
                            source: source,
                            attributes: {
                                adType: sourceAdType,
                                entrypoint: entryPointId,
                                sourceComponent: sourceComponent,
                                error: error instanceof Error ? error.message : 'unknown'
                            }
                        }
                    }).fire();
                    flags && flags.showErrorFlag({
                        title: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
                            href: "https://support.atlassian.com/contact",
                            target: "_blank",
                            rel: "noreferrer"
                        }, intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagActionTitle)))
                    });
                }
            }
        }
        // for other capability, we bring back the default link behaviour here
        // as we have disabled the default link behaviour for the trigger button
        window && window.open(crossJoinHref, '_blank');
    }, [
        createAnalyticsEvent,
        crossJoinHref,
        entryPointId,
        fetchRequestAccessCapability,
        flags,
        intl,
        requestAccess,
        source,
        sourceAdType,
        sourceComponent
    ]);
};
module.exports["useStreamliningCrossJoin"] = $7197be9efeb6a957$export$76d3f97e5e2f022d;

});

parcelRegister("64hvi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hCOLa = parcelRequire("hCOLa");


var $fNwcJ = parcelRequire("fNwcJ");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");

const $92f7d7126b973070$var$fetchJson = async (input)=>{
    const { url: url, ...options } = input;
    const response = await (0, $f7B1p.cfetch)(url, options);
    return response.json();
};
const $92f7d7126b973070$export$1c1d3bfbd79d853f = ({ entryPointId: entryPointId, source: source, sourceAdType: sourceAdType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const deps = (0, $42omo.useMemo)(()=>({
            createAnalyticsEvent: ({ type: type, data: data })=>createAnalyticsEvent({
                    type: type,
                    data: {
                        source: source,
                        ...data
                    }
                }),
            fetchJSON: $92f7d7126b973070$var$fetchJson,
            getCurrentCloudId: ()=>cloudId,
            getCurrentUserId: ()=>userId ?? '',
            getCurrentProduct: ()=>'confluence'
        }), [
        createAnalyticsEvent,
        cloudId,
        source,
        userId
    ]);
    const requestAccess = (0, $hCOLa.useService)((0, $fNwcJ.requestAccess), deps);
    return (0, $42omo.useCallback)(async ()=>{
        try {
            const { result: result = '' } = await requestAccess({
                product: 'loom',
                integration: entryPointId
            });
            const success = result === 'PENDING_REQUEST_CREATED';
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccess',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        result: result,
                        success: success
                    }
                }
            }).fire();
            return success;
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccess',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        error: error instanceof Error ? error.message : 'unknown',
                        result: undefined,
                        success: false
                    }
                }
            }).fire();
            throw error;
        }
    }, [
        entryPointId,
        requestAccess,
        source,
        sourceAdType,
        createAnalyticsEvent
    ]);
};
const $92f7d7126b973070$export$a74078d93650d63f = ({ entryPointId: entryPointId, source: source, sourceAdType: sourceAdType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return (0, $42omo.useCallback)(async ()=>{
        const resource = `ari:cloud:loom::site/${cloudId}`;
        try {
            const params = new URLSearchParams({
                resource: resource
            });
            const url = `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
            const response = await $92f7d7126b973070$var$fetchJson({
                url: url
            });
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccessCapability',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        resource: resource
                    }
                }
            }).fire();
            return response.results[resource] || undefined;
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccessCapability',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        error: error instanceof Error ? error.message : 'unknown',
                        resource: resource
                    }
                }
            }).fire();
        }
        return undefined;
    }, [
        cloudId,
        createAnalyticsEvent,
        entryPointId,
        source,
        sourceAdType
    ]);
};
module.exports["useRequestAccessService"] = $92f7d7126b973070$export$1c1d3bfbd79d853f;
module.exports["useFetchRequestAccessCapability"] = $92f7d7126b973070$export$a74078d93650d63f;

});

parcelRegister("fNwcJ", function(module, exports) {
/**
 * This file defines the requestAccess() service.
 */ 
var $7DBey = parcelRequire("7DBey");


var $2Q94g = parcelRequire("2Q94g");


var $bmTr3 = parcelRequire("bmTr3");

// Dependencies - generally common to all RA's/joins:
const $bf9bb0e4c78e4bdb$var$dependencies = {
    fetchJSON: $bmTr3.fetchJSON,
    createAnalyticsEvent: $2Q94g.createAnalyticsEvent,
    getStargateURL: $2Q94g.getStargateURL,
    getCurrentUserId: $2Q94g.getCurrentUserId,
    getCurrentCloudId: $2Q94g.getCurrentCloudId,
    getCurrentProduct: $2Q94g.getCurrentProduct
};
const $bf9bb0e4c78e4bdb$export$cd9e5995821603e1 = Object.assign($bf9bb0e4c78e4bdb$var$requestAccessImpl, {
    dependencies: $bf9bb0e4c78e4bdb$var$dependencies
});
async function $bf9bb0e4c78e4bdb$var$requestAccessImpl(input, context) {
    const deps = context.dependencies();
    const cloudId = input.cloudId ?? deps.getCurrentCloudId();
    const userId = deps.getCurrentUserId();
    let result;
    const resource = `ari:cloud:${input.product}::site/${cloudId}`;
    try {
        // https://developer.atlassian.com/platform/identity/rest/v1/api-group-access-requests/#api-v2-access-requests-request-post
        const response = await deps.fetchJSON({
            url: deps.getStargateURL('/invitations/v1/access-requests/request'),
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource
            })
        });
        result = $bf9bb0e4c78e4bdb$var$mapRequestAccessResponse(response, {
            resource: resource,
            userId: userId,
            ...input
        });
    } catch (error) {
        result = {
            error: (0, $7DBey.toError)(error),
            ...input,
            result: null,
            resource: resource,
            userId: userId
        };
    }
    $bf9bb0e4c78e4bdb$var$fireRequestAccessAnalytics({
        ...input,
        ...result
    }, context);
    return result;
}
function $bf9bb0e4c78e4bdb$var$mapRequestAccessResponse(response, input) {
    return {
        error: null,
        result: response.results[input.resource],
        ...input
    };
}
// Analytics functions for these common events might later become
// exported for standalone use
function $bf9bb0e4c78e4bdb$var$fireRequestAccessAnalytics({ error: error, product: product, result: result }, context) {
    if (!error) {
        const currentUserId = context.dependencies().getCurrentUserId();
        const attributes = {
            userAaid: currentUserId,
            actorAaid: currentUserId,
            roleName: 'product/member',
            inviteStatus: result,
            sourceProduct: context.dependencies().getCurrentProduct(),
            sourceTenantId: context.dependencies().getCurrentCloudId(),
            product: product
        };
        if (result === 'ACCESS_GRANTED') $bf9bb0e4c78e4bdb$var$fireProductJoined(attributes, context);
        else $bf9bb0e4c78e4bdb$var$fireProductAccessRequested(attributes, context);
    }
}
function $bf9bb0e4c78e4bdb$var$fireProductAccessRequested(input, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'productAccess',
            action: 'requested',
            actionSujectId: input.userAaid,
            attributes: input
        }
    }).fire();
}
function $bf9bb0e4c78e4bdb$var$fireProductJoined({ userUuid: userUuid, userAaid: userAaid, roleName: roleName, sourceTenantId: sourceTenantId, sourceProduct: sourceProduct, recommendationSources: recommendationSources, product: product }, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'product',
            action: 'joined',
            actionSujectId: product,
            attributes: {
                userUuid: userUuid,
                userAaid: userAaid,
                roleName: roleName,
                sourceTenantId: sourceTenantId,
                sourceProduct: sourceProduct,
                recommendationSources: recommendationSources,
                product: product
            }
        }
    }).fire();
}
module.exports["requestAccess"] = $bf9bb0e4c78e4bdb$export$cd9e5995821603e1;

});

parcelRegister("8Q0mA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $aFmsO = parcelRequire("aFmsO");


var $jHpN3 = parcelRequire("jHpN3");


var $erVVf = parcelRequire("erVVf");


var $f5Ulo = parcelRequire("f5Ulo");


var $cnQgR = parcelRequire("cnQgR");

const $012e0fafda229e4e$var$sourceAdType = 'crossJoin';
const $012e0fafda229e4e$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    crossJoinCTA: {
        id: "loom-utils.loom-cross-sell-popup-card.crossJoinCTA",
        defaultMessage: "Try now"
    },
    requestAccessSuccessFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.title",
        defaultMessage: "Your admins were notified of your request"
    },
    requestAccessSuccessFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.description",
        defaultMessage: "You\u2019ll receive an email once they\u2019ve approved it."
    },
    requestAccessErrorFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.title",
        defaultMessage: "We couldn't add you to Loom"
    },
    requestAccessErrorFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.description",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join,"
    },
    requestAccessErrorFlagActionTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.action.title",
        defaultMessage: "contact support"
    }
});
const $012e0fafda229e4e$export$9937e9f99bf53911 = ({ description: description, entryPointId: entryPointId, placement: placement, shouldRenderToParent: shouldRenderToParent, sourceActionSubjectId: sourceActionSubjectId, sourceComponent: sourceComponent, title: title, triggerLink: triggerLink, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { stopPulse: stopPulse } = (0, $aFmsO.useDiscoverabilityPulseActions)();
    const { stopPostOffice: stopPostOffice } = (0, $jHpN3.useDiscoverabilityPulseActions)();
    const streamliningCrossJoinOnButtonClicked = (0, $erVVf.useStreamliningCrossJoin)({
        entryPointId: entryPointId,
        flags: flags,
        source: 'loomCrossJoinPopupCard',
        sourceAdType: $012e0fafda229e4e$var$sourceAdType,
        sourceComponent: sourceComponent
    });
    const stopDiscoverabilityPulse = (0, $42omo.useCallback)(()=>{
        if ((0, $9wGTI.fg)('confluence_loom_x-sell_ep_po_migration')) {
            stopPostOffice();
            return;
        }
        stopPulse();
    }, [
        stopPostOffice,
        stopPulse
    ]);
    const onCrossJoinSuccess = (0, $42omo.useCallback)(()=>{
        stopDiscoverabilityPulse();
        experienceTracker.succeed({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: entryPointId,
                adType: $012e0fafda229e4e$var$sourceAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker,
        stopDiscoverabilityPulse
    ]);
    const onTryNowButtonClick = (0, $42omo.useCallback)(async ()=>{
        if ((0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate')) await streamliningCrossJoinOnButtonClicked();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'tryNow',
                source: 'loomCrossJoinPopupCard',
                attributes: {
                    adType: $012e0fafda229e4e$var$sourceAdType,
                    entrypoint: entryPointId,
                    sourceComponent: sourceComponent
                }
            }
        }).fire();
        onCrossJoinSuccess();
    }, [
        createAnalyticsEvent,
        entryPointId,
        onCrossJoinSuccess,
        sourceComponent,
        streamliningCrossJoinOnButtonClicked
    ]);
    const onCrossJoinTriggerClick = (0, $42omo.useCallback)(async ()=>{
        if ((0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate')) await streamliningCrossJoinOnButtonClicked();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: sourceActionSubjectId,
                source: sourceActionSubjectId,
                attributes: {
                    adType: $012e0fafda229e4e$var$sourceAdType,
                    entrypoint: entryPointId,
                    sourceComponent: sourceComponent
                }
            }
        }).fire();
        onCrossJoinSuccess();
    }, [
        createAnalyticsEvent,
        entryPointId,
        onCrossJoinSuccess,
        sourceActionSubjectId,
        sourceComponent,
        streamliningCrossJoinOnButtonClicked
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cnQgR.BaseLoomPopupCard), {
        actions: (0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "discovery",
            onClick: onTryNowButtonClick
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: "discovery",
            href: crossJoinHref,
            onClick: onTryNowButtonClick,
            rel: "noreferrer",
            target: "_blank"
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA)),
        description: description,
        entryPointId: entryPointId,
        placement: placement,
        shouldRenderToParent: shouldRenderToParent,
        title: title,
        trigger: (popupTriggerProps)=>// the link button behaviour is handled in streamliningCrossJoinOnButtonClicked
            // when feature gate is on for Loom crossjoin experiment
            triggerLink(!(0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? crossJoinHref : '', {
                ...popupTriggerProps,
                onClick: onCrossJoinTriggerClick
            }),
        sourceAdType: $012e0fafda229e4e$var$sourceAdType,
        sourceComponent: sourceComponent
    });
};
module.exports["LoomCrossJoinPopupCard"] = $012e0fafda229e4e$export$9937e9f99bf53911;

});

parcelRegister("aFmsO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lwNi3 = parcelRequire("lwNi3");


var $9wGTI = parcelRequire("9wGTI");


var $gd8AW = parcelRequire("gd8AW");

const $9c43e73b872d5b9c$export$5628ed37e6d9f626 = ()=>{
    const coordinationClient = (0, $lwNi3.useCoordinationClient)();
    const { stop: stop } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    const stopPulse = (0, $42omo.useCallback)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_loom_discoverability_pulse')) return;
        stop(coordinationClient);
    }, [
        coordinationClient,
        stop
    ]);
    return {
        stopPulse: stopPulse
    };
};
const $9c43e73b872d5b9c$export$2002ab0670152c89 = (entryPointId)=>{
    const coordinationClient = (0, $lwNi3.useCoordinationClient)();
    const { start: startPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    const isPulseActive = (0, $gd8AW.useIsPulseActive)(entryPointId);
    const skipRefreshPulseStatus = isPulseActive || (0, $gd8AW.havePulsesEnded)();
    (0, $42omo.useEffect)(()=>{
        if (skipRefreshPulseStatus || !(0, $9wGTI.fg)('confluence_frontend_loom_discoverability_pulse')) return;
        const showPulseIfEligible = async (messageId)=>{
            const isMessageActive = Boolean(await coordinationClient.start(messageId));
            if (isMessageActive) startPulse(entryPointId, messageId);
            return isMessageActive;
        };
        const refreshPulseStatus = async ()=>{
            if (await showPulseIfEligible('cc-loom-x-sell-discoverability-pulse-1')) return;
            if (await showPulseIfEligible('cc-loom-x-sell-discoverability-pulse-2')) return;
            if (await showPulseIfEligible('cc-loom-x-sell-discoverability-pulse-3')) return;
            if (await showPulseIfEligible('cc-loom-x-sell-discoverability-pulse-4')) return;
            if (await showPulseIfEligible('cc-loom-x-sell-discoverability-pulse-5')) {
                /**
				 * Mark the EP message as "complete" and disable Loom discoverability in localStorage
				 * immediately after showing the final pulse. Otherwise, if a user ignores the entrypoints
				 * entirely and never clicks on one while it's pulsing, they'll:
				 *
				 * - Remain in the TAP audience forever
				 * - Continue making 5 API requests to check the EP messages every time an entrypoint renders
				 *
				 * This will technically unlock EP to show other messages, but the pulse is subtle enough that
				 * this shouldn't result in poor UX
				 */ (0, $gd8AW.endPulses)();
                coordinationClient.stop('cc-loom-x-sell-discoverability-pulse-5');
            }
        };
        refreshPulseStatus();
    }, [
        coordinationClient,
        entryPointId,
        skipRefreshPulseStatus,
        startPulse
    ]);
    /**
	 * Do not include a check of `havePulsesEnded()` here in order to continue showing the pulse
	 * immediately after viewing it a 5th time. Otherwise, the next time the button re-renders
	 * (for any reason), the pulse would disappear due to value set in localStorage
	 *
	 * see: the code comment within the `showPulseIfEligible('cc-loom-x-sell-discoverability-pulse-5')`
	 * check for more context on the special behavior
	 */ return {
        isPulseActive: isPulseActive && (0, $9wGTI.fg)('confluence_frontend_loom_discoverability_pulse')
    };
};
module.exports["useDiscoverabilityPulseActions"] = $9c43e73b872d5b9c$export$5628ed37e6d9f626;
module.exports["useDiscoverabilityPulse"] = $9c43e73b872d5b9c$export$2002ab0670152c89;

});

parcelRegister("gd8AW", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $f4d1b21b30388c2e$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $f4d1b21b30388c2e$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $f4d1b21b30388c2e$var$initialState = {
    entryPointId: null,
    messageId: null
};
const $f4d1b21b30388c2e$var$actions = {
    start: (entryPointId, messageId)=>({ setState: setState })=>{
            setState({
                entryPointId: entryPointId,
                messageId: messageId
            });
        },
    stop: (coordinationClient)=>({ getState: getState, setState: setState })=>{
            const { messageId: messageId } = getState();
            if (messageId) coordinationClient.stop(messageId);
            if (!$f4d1b21b30388c2e$export$48bd74b0cdc86564()) $f4d1b21b30388c2e$export$675fdafde077272f();
            setState({
                entryPointId: null,
                messageId: null
            });
        }
};
const $f4d1b21b30388c2e$var$Store = (0, $1P1Tu.createStore)({
    initialState: $f4d1b21b30388c2e$var$initialState,
    actions: $f4d1b21b30388c2e$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $f4d1b21b30388c2e$export$e812389786ffbfd0 = (0, $9zUhf.createStateHook)($f4d1b21b30388c2e$var$Store, {
    selector: (state, entryPointId)=>state.entryPointId === entryPointId
});
const $f4d1b21b30388c2e$export$5628ed37e6d9f626 = (0, $9zUhf.createActionsHook)($f4d1b21b30388c2e$var$Store);
module.exports["havePulsesEnded"] = $f4d1b21b30388c2e$export$48bd74b0cdc86564;
module.exports["endPulses"] = $f4d1b21b30388c2e$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $f4d1b21b30388c2e$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $f4d1b21b30388c2e$export$5628ed37e6d9f626;

});

parcelRegister("jHpN3", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $0f0ccc6155f7d7fb$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $0f0ccc6155f7d7fb$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $0f0ccc6155f7d7fb$var$initialState = {
    activeMessageId: null,
    entryPointIds: [],
    clickTrackingHandler: null,
    dismissHandler: null,
    wasDismissedByUser: false
};
const $0f0ccc6155f7d7fb$var$actions = {
    start: (entryPointId, messageId, handlers)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const nextState = state.activeMessageId !== messageId ? {
                activeMessageId: messageId,
                entryPointIds: [
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? null,
                dismissHandler: handlers?.onDismiss ?? null,
                wasDismissedByUser: false
            } : {
                activeMessageId: messageId,
                entryPointIds: state.entryPointIds.includes(entryPointId) ? state.entryPointIds : [
                    ...state.entryPointIds,
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? state.clickTrackingHandler,
                dismissHandler: handlers?.onDismiss ?? state.dismissHandler,
                wasDismissedByUser: false
            };
            const hasEntryPointListChanged = nextState.entryPointIds !== state.entryPointIds;
            const hasClickHandlerChanged = nextState.clickTrackingHandler !== state.clickTrackingHandler;
            const hasDismissHandlerChanged = nextState.dismissHandler !== state.dismissHandler;
            const hasMessageChanged = nextState.activeMessageId !== state.activeMessageId;
            const hasDismissalReset = state.wasDismissedByUser;
            if (!hasEntryPointListChanged && !hasClickHandlerChanged && !hasDismissHandlerChanged && !hasMessageChanged && !hasDismissalReset) return;
            setState(nextState);
        },
    stopPostOffice: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            state.clickTrackingHandler?.();
            state.dismissHandler?.();
            if (!$0f0ccc6155f7d7fb$export$48bd74b0cdc86564()) $0f0ccc6155f7d7fb$export$675fdafde077272f();
            if (state.activeMessageId === null && state.entryPointIds.length === 0 && state.dismissHandler === null && state.clickTrackingHandler === null && state.wasDismissedByUser) return;
            setState({
                activeMessageId: null,
                entryPointIds: [],
                clickTrackingHandler: null,
                dismissHandler: null,
                wasDismissedByUser: true
            });
        }
};
const $0f0ccc6155f7d7fb$var$Store = (0, $1P1Tu.createStore)({
    initialState: $0f0ccc6155f7d7fb$var$initialState,
    actions: $0f0ccc6155f7d7fb$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $0f0ccc6155f7d7fb$export$e812389786ffbfd0 = (0, $9zUhf.createStateHook)($0f0ccc6155f7d7fb$var$Store, {
    selector: (state, entryPointId)=>state.entryPointIds.includes(entryPointId) && !state.wasDismissedByUser
});
const $0f0ccc6155f7d7fb$export$5628ed37e6d9f626 = (0, $9zUhf.createActionsHook)($0f0ccc6155f7d7fb$var$Store);
module.exports["havePulsesEnded"] = $0f0ccc6155f7d7fb$export$48bd74b0cdc86564;
module.exports["endPulses"] = $0f0ccc6155f7d7fb$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $0f0ccc6155f7d7fb$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $0f0ccc6155f7d7fb$export$5628ed37e6d9f626;

});

parcelRegister("cnQgR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4rwCt = parcelRequire("4rwCt");


var $inPa6 = parcelRequire("inPa6");


var $7hXDW = parcelRequire("7hXDW");


var $gj7hi = parcelRequire("gj7hi");


var $lAFHW = parcelRequire("lAFHW");


var $lGgRw = parcelRequire("lGgRw");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $2fvAC = parcelRequire("2fvAC");

const $282df3a04f7add9c$export$e4ecefef0a48fd72 = 400;
const $282df3a04f7add9c$var$cardStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    overflow: 'auto',
    width: '352px'
});
const $282df3a04f7add9c$var$cardContentStyles = (0, $ecnYn.xcss)({
    padding: 'space.300'
});
const $282df3a04f7add9c$var$imageContainerStyles = (0, $ecnYn.xcss)({
    height: '201px'
});
const $282df3a04f7add9c$export$48e89f1cdc429537 = ({ actions: actions, description: description, entryPointId: entryPointId, placement: placement, shouldRenderToParent: shouldRenderToParent = true, title: title, trigger: trigger, sourceAdType: sourceAdType, sourceComponent: sourceComponent })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const hasStartedPreloadingImage = (0, $42omo.useRef)(false);
    const closePopupTimerRef = (0, $42omo.useRef)(null);
    const openPopupTimerRef = (0, $42omo.useRef)(null);
    const contentWrapperElementRef = (0, $42omo.useRef)(null);
    const triggerElementRef = (0, $42omo.useRef)(null);
    const isOpenOnFocusDisabled = (0, $42omo.useRef)(false);
    const clearClosePopupTimer = (0, $42omo.useCallback)(()=>{
        if (closePopupTimerRef.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, []);
    const clearOpenPopupTimer = (0, $42omo.useCallback)(()=>{
        if (openPopupTimerRef.current) {
            clearTimeout(openPopupTimerRef.current);
            openPopupTimerRef.current = null;
        }
    }, []);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        if (isOpen) experienceTracker.start({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: entryPointId,
                adType: sourceAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker,
        isOpen,
        sourceAdType
    ]);
    /**
	 * Temporarily disable the popup from re-opening (for a tick) on focus
	 * because in many cases, closing the popup returns focus back to the
	 * trigger, which would normally open the popup again.
	 */ const safeClosePopup = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
        experienceTracker.abort({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            reason: 'Loom pop up closed',
            attributes: {
                sourceComponent: entryPointId,
                adType: sourceAdType
            }
        });
        isOpenOnFocusDisabled.current = true;
        setTimeout(()=>{
            isOpenOnFocusDisabled.current = false;
        }, 0);
    }, [
        entryPointId,
        experienceTracker,
        sourceAdType
    ]);
    const startClosePopupTimer = (0, $42omo.useCallback)(()=>{
        clearOpenPopupTimer();
        if (!closePopupTimerRef.current) closePopupTimerRef.current = setTimeout(()=>{
            safeClosePopup();
            closePopupTimerRef.current = null;
        }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
    }, [
        clearOpenPopupTimer,
        safeClosePopup
    ]);
    /**
	 * Don't open the popup card immediately on hover or focus
	 *
	 * 1) Focus: We want KB users to be able to quickly navigate through areas with entrypoints that
	 * are alongside many other UI controls (e.g., Page Header, Page Editor Toolbar) without triggering
	 * the popup card and getting "stuck" (needing to hit "esc" to continue).
	 *
	 * 2) Hover: We don't want users to feel like the popup card gets in their way of clicking other
	 * things in the UI just because their mouse briefly brushed over the entrypoint button.
	 *
	 * This was heavily inspired by the hover cards used in the Page Tree (`useHoverPageCard`)
	 */ const startOpenPopupTimer = (0, $42omo.useCallback)(()=>{
        clearClosePopupTimer();
        if (!hasStartedPreloadingImage.current) {
            hasStartedPreloadingImage.current = true;
            const img = new Image();
            img.src = (0, (/*@__PURE__*/$parcel$interopDefault($2fvAC)));
        }
        if (!openPopupTimerRef.current) openPopupTimerRef.current = setTimeout(()=>{
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'loomAdPopupCard',
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent
                    }
                }
            }).fire();
            setIsOpen(true);
            openPopupTimerRef.current = null;
        }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
    }, [
        clearClosePopupTimer,
        createAnalyticsEvent,
        entryPointId,
        sourceAdType,
        sourceComponent
    ]);
    const handleTriggerBlur = (0, $42omo.useCallback)(()=>{
        clearOpenPopupTimer();
    }, [
        clearOpenPopupTimer
    ]);
    const handleTriggerFocus = (0, $42omo.useCallback)(()=>{
        if (!isOpenOnFocusDisabled.current) startOpenPopupTimer();
    }, [
        startOpenPopupTimer
    ]);
    const handleTriggerMouseEnter = (0, $42omo.useCallback)(()=>{
        startOpenPopupTimer();
    }, [
        startOpenPopupTimer
    ]);
    const handleCardMouseEnter = (0, $42omo.useCallback)(()=>{
        clearClosePopupTimer();
    }, [
        clearClosePopupTimer
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        /**
		 * Don't close the popup card when moving the mouse outside of it (or the trigger) if something
		 * inside it (or the trigger itself) is focused
		 */ if (!contentWrapperElementRef.current?.contains(document.activeElement) && document.activeElement !== triggerElementRef.current) startClosePopupTimer();
    }, [
        startClosePopupTimer
    ]);
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            onMouseEnter: handleCardMouseEnter,
            onMouseLeave: handleMouseLeave,
            ref: contentWrapperElementRef,
            xcss: $282df3a04f7add9c$var$cardStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $282df3a04f7add9c$var$imageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            alt: "",
            height: "201px",
            width: "352px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($2fvAC)))
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.300",
            xcss: $282df3a04f7add9c$var$cardContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
            as: "h2",
            size: "small"
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            as: "p",
            color: "color.text.subtle"
        }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.LoomAttributionLogo), {
            appearance: "brand",
            size: "medium"
        }), actions)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        autoFocus: false,
        content: content,
        isOpen: isOpen,
        /**
			 * Using `titleId` and adding the same value as an `id` to the Heading in the popup content
			 * does not announce properly in macOS VoiceOver
			 */ label: title,
        onClose: safeClosePopup,
        placement: placement || 'auto',
        role: "dialog",
        shouldRenderToParent: shouldRenderToParent,
        trigger: (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onFocus: handleTriggerFocus,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: (0, $4rwCt.mergeRefs)([
                    popupTriggerProps.ref,
                    triggerElementRef
                ])
            })
    });
};
module.exports["BaseLoomPopupCard"] = $282df3a04f7add9c$export$48e89f1cdc429537;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("2fvAC", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImage.6e60c328.png", import.meta.url).toString();

});

parcelRegister("6T0Pj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");


var $u9agA = parcelRequire("u9agA");


var $1cfhF = parcelRequire("1cfhF");

var $lfQiY = parcelRequire("lfQiY");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $9wGTI = parcelRequire("9wGTI");


var $aFmsO = parcelRequire("aFmsO");


var $jHpN3 = parcelRequire("jHpN3");


var $ej7WH = parcelRequire("ej7WH");


var $jkI1v = parcelRequire("jkI1v");


var $k0DFC = parcelRequire("k0DFC");


var $cnQgR = parcelRequire("cnQgR");

const $9bb41a4fe26f7df4$var$sourceAdType = 'crossFlow';
const $9bb41a4fe26f7df4$var$i18n = (0, $cgtv4.defineMessages)({
    tryNow: {
        id: "loom-utils.loom-cross-sell-popup-card.tryNow",
        defaultMessage: "Try now"
    }
});
const $9bb41a4fe26f7df4$var$env = 'prod';
const $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID = (0, $1cfhF.FIRST_PARTY_CCP_PRODUCT_IDS)[$9bb41a4fe26f7df4$var$env].loom;
const $9bb41a4fe26f7df4$var$getCrossFlowInteractionSource = (entrypointId)=>{
    switch(entrypointId){
        case 'loom-confluence-inline-comment':
            return 'loomConfluenceInlineCommentButton';
        case 'loom-confluence-page-editor-toolbar':
            return 'loomConfluencePageEditorToolbarButton';
        case 'loom-confluence-page-header':
            return 'loomConfluencePageHeaderButton';
        default:
            return null;
    }
};
const $9bb41a4fe26f7df4$export$7232e4c8af3c9680 = ({ description: description, entryPointId: entryPointId, placement: placement, shouldRenderToParent: shouldRenderToParent, sourceActionSubjectId: sourceActionSubjectId, title: title, trigger: trigger, sourceComponent: sourceComponent, sourceContext: sourceContext })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $lfQiY.useFireCrossFlowAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const ctaRef = (0, $42omo.useRef)(null);
    const triggerCrossFlow = (0, $ej7WH.useLoomCrossFlowRequestAccessCallback)({
        sourceComponent: sourceComponent,
        sourceContext: sourceContext
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isInterestedInLoom: isInterestedInLoom, notInterestedInLoomCallback: notInterestedInLoomCallback } = (0, $k0DFC.useLoomAdControlState)({
        touchpoint: entryPointId
    });
    const { stopPulse: stopPulse } = (0, $aFmsO.useDiscoverabilityPulseActions)();
    const { stopPostOffice: stopPostOffice } = (0, $jHpN3.useDiscoverabilityPulseActions)();
    const stopDiscoverabilityPulse = (0, $42omo.useCallback)(()=>{
        if ((0, $9wGTI.fg)('confluence_loom_x-sell_ep_po_migration')) {
            stopPostOffice();
            return;
        }
        stopPulse();
    }, [
        stopPostOffice,
        stopPulse
    ]);
    // View event for go/BMD crossflow funnel
    (0, $42omo.useEffect)(()=>{
        fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'button',
            actionSubjectId: sourceComponent
        }, {
            source: entryPointId,
            recommendedProductIds: [
                $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
            ]
        });
    }, [
        fireViewedUIEvent,
        sourceComponent,
        entryPointId
    ]);
    const onCrossFlowTriggerClick = (0, $42omo.useCallback)(async (triggerName)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: triggerName,
                source: triggerName === 'tryNow' ? 'loomCrossFlowPopupCard' : sourceActionSubjectId,
                attributes: {
                    adType: $9bb41a4fe26f7df4$var$sourceAdType,
                    entrypoint: entryPointId
                }
            }
        }).fire();
        // Interaction event for go/BMD crossflow funnel. Only fire if entryPointId is registered in @atlassian/surface-analytics-specs package
        const crossFlowInteractionSource = $9bb41a4fe26f7df4$var$getCrossFlowInteractionSource(entryPointId);
        crossFlowInteractionSource && fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: sourceContext
        }, {
            source: crossFlowInteractionSource,
            recommendedProductIds: [
                $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
            ],
            targetProductId: $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
        });
        stopDiscoverabilityPulse();
        await triggerCrossFlow();
    }, [
        createAnalyticsEvent,
        entryPointId,
        triggerCrossFlow,
        sourceActionSubjectId,
        sourceContext,
        fireInteractedUIEvent,
        stopDiscoverabilityPulse
    ]);
    const handleNotInterested = (0, $42omo.useCallback)(async ()=>{
        experienceTracker.abort({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            reason: 'User not interested in Loom',
            attributes: {
                sourceComponent: entryPointId,
                adType: $9bb41a4fe26f7df4$var$sourceAdType
            }
        });
        stopDiscoverabilityPulse();
        await notInterestedInLoomCallback();
    }, [
        entryPointId,
        experienceTracker,
        notInterestedInLoomCallback,
        stopDiscoverabilityPulse
    ]);
    if (!isInterestedInLoom) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cnQgR.BaseLoomPopupCard), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkI1v.LoomAdControl), {
            onDismiss: handleNotInterested,
            entryPointId: entryPointId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "discovery",
            onClick: ()=>onCrossFlowTriggerClick('tryNow'),
            ref: ctaRef
        }, intl.formatMessage($9bb41a4fe26f7df4$var$i18n.tryNow))),
        description: description,
        entryPointId: entryPointId,
        placement: placement,
        shouldRenderToParent: shouldRenderToParent,
        title: title,
        trigger: (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                onClick: ()=>onCrossFlowTriggerClick(sourceActionSubjectId),
                onKeyDown: (e)=>{
                    if (e.key === 'Tab') ctaRef.current?.focus();
                }
            }),
        sourceAdType: $9bb41a4fe26f7df4$var$sourceAdType
    });
};
module.exports["LoomCrossFlowPopupCard"] = $9bb41a4fe26f7df4$export$7232e4c8af3c9680;

});

parcelRegister("1cfhF", function(module, exports) {
const $bd349f0afc0f2270$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$6c053e1694ef181c = {
    prod: $bd349f0afc0f2270$export$31048cb2a0753b12,
    staging: $bd349f0afc0f2270$export$9d8f18312db80469
};
const $bd349f0afc0f2270$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};
module.exports["FIRST_PARTY_CCP_PRODUCT_IDS"] = $bd349f0afc0f2270$export$6c053e1694ef181c;
module.exports["SURFACE_ANALYTICS_PRODUCT_MAP"] = $bd349f0afc0f2270$export$54e3fc09a2a3347a;

});

parcelRegister("lfQiY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1cfhF = parcelRequire("1cfhF");


var $kfKKN = parcelRequire("kfKKN");

function $d96a3db7fec61911$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $42omo.useRef)();
    const firedViewedUIEventId = (0, $42omo.useRef)();
    const mapToCcpProductKeys = (0, $42omo.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $42omo.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}
module.exports["useFireCrossFlowAnalyticsEvents"] = $d96a3db7fec61911$export$c2095165ae2bdcda;

});

parcelRegister("kfKKN", function(module, exports) {
const $f3fd7ff29ab4c819$export$c536a7e29a0739b8 = 'crossFlow';
var $f3fd7ff29ab4c819$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});
module.exports["CROSS_FLOW_CHANNEL"] = $f3fd7ff29ab4c819$export$c536a7e29a0739b8;
module.exports["eventTypes"] = $f3fd7ff29ab4c819$export$285f3d0989f9023f;

});

parcelRegister("jkI1v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $1qfLF = parcelRequire("1qfLF");


var $9VJDA = parcelRequire("9VJDA");


var $irxfF = parcelRequire("irxfF");

var $2zUpm = parcelRequire("2zUpm");

var $3ylo6 = parcelRequire("3ylo6");

var $hEz36 = parcelRequire("hEz36");

const $8b615b773eb5cff4$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';
const $8b615b773eb5cff4$export$81624a1cb6914931 = (0, $cgtv4.defineMessages)({
    dismissFlagTitle: {
        id: "loom-utils.loom-ad-control.dismiss-flag-title",
        defaultMessage: "Got it, thanks for letting us know"
    },
    dismissFlagDescription: {
        id: "loom-utils.loom-ad-control.dismiss-flag-description",
        defaultMessage: "You won\u2019t see this here as often."
    },
    reasonsModalTitle: {
        id: "loom-utils.loom-ad-control.reasons-modal-title",
        defaultMessage: "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        id: "loom-utils.loom-ad-control.reasons-modal-explanation",
        defaultMessage: "We think that <strong>Loom</strong> will improve your team\u2019s productivity. The recommendation is based on:"
    },
    reasonsModalBulletOne: {
        id: "loom-utils.loom-ad-control.reasons-modal-bullet-one",
        defaultMessage: "the size of your team"
    },
    reasonsModalBulletTwo: {
        id: "loom-utils.loom-ad-control.reasons-modal-bullet-two",
        defaultMessage: "your existing Atlassian products"
    },
    privacyPolicy: {
        id: "loom-utils.loom-ad-control.privacy-policy",
        defaultMessage: "Learn more about your data privacy with Atlassian"
    }
});
const $8b615b773eb5cff4$var$linkStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.150'
});
const $8b615b773eb5cff4$var$moreIconStyles = (0, $ecnYn.xcss)({
    alignSelf: 'center'
});
const $8b615b773eb5cff4$var$LoomAdControlReasonModalBody = ({ entryPointId: entryPointId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'loomAdControlReasonsModal',
                attributes: {
                    adType: 'crossFlow',
                    entrypoint: entryPointId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        entryPointId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalExplanation, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                weight: "bold"
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalBulletOne)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalBulletTwo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $8b615b773eb5cff4$var$linkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
        href: $8b615b773eb5cff4$export$aefe1c8741b24a28,
        target: "_blank"
    }, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.privacyPolicy))));
};
const $8b615b773eb5cff4$export$5922fd76035890d5 = ({ onDismiss: onDismiss, entryPointId: entryPointId, spacing: spacing = 'compact' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2zUpm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irxfF.default), {
        itemId: "loom-ad-controls",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $8b615b773eb5cff4$var$moreIconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...props,
                onClick: (e)=>{
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'toggleLoomAdControlDropdown',
                            source: 'loomCrossFlowPopupCard',
                            attributes: {
                                adType: 'crossFlow',
                                entrypoint: entryPointId
                            }
                        }
                    }).fire();
                    props.onClick?.(e);
                },
                appearance: "subtle",
                spacing: spacing,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                label: "LoomAdControl",
                testId: "loom-utils.loom-ad-control.button"
            }))
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ylo6.default), {
            ...props,
            flagProps: {
                title: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.dismissFlagTitle),
                description: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.dismissFlagDescription)
            },
            onClick: onDismiss
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEz36.default), {
            ...props,
            onClick: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'toggleLoomAdControlReasonsModal',
                        source: 'loomAdControlDropdown',
                        attributes: {
                            adType: 'crossFlow',
                            entrypoint: entryPointId
                        }
                    }
                }).fire();
            },
            modalProps: {
                title: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalTitle),
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8b615b773eb5cff4$var$LoomAdControlReasonModalBody, {
                    entryPointId: entryPointId
                })
            }
        }))));
};
module.exports["LoomAdControl"] = $8b615b773eb5cff4$export$5922fd76035890d5;

});

parcelRegister("irxfF", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $52EPl = parcelRequire("52EPl");

var $ahaN7 = parcelRequire("ahaN7");


var $dh538 = parcelRequire("dh538");


var $fRta5 = parcelRequire("fRta5");


var $kSW34 = parcelRequire("kSW34");


var $h9hzU = parcelRequire("h9hzU");

const $bdcc218e6a1dcb18$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsDropdown'
};
const $bdcc218e6a1dcb18$var$AdControlDropdownMenu = ({ children: children, itemId: itemId, onOpenChange: onOpenChange = ()=>{}, ...rest })=>{
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kSW34.default)();
    const { createEventDispatcher: createEventDispatcher } = (0, $h9hzU.useAdControlProvider)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        ...rest,
        onOpenChange: (onOpenChangeArgs)=>{
            eventDispatcher.dispatch(onOpenChangeArgs.isOpen ? (0, $fRta5.AD_CONTROL_DROP_DOWN_MENU_OPENED) : (0, $fRta5.AD_CONTROL_DROP_DOWN_MENU_CLOSED), createInteractedUIEvent($bdcc218e6a1dcb18$var$interactedUIEventAction));
            onOpenChange(onOpenChangeArgs);
        },
        shouldFitContainer: false,
        shouldRenderToParent: (0, $dh538.fg)('should-render-to-parent-should-be-true-growth-trai'),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
            children: typeof children === 'function' ? children({
                itemId: itemId
            }) : children
        })
    });
};
var $bdcc218e6a1dcb18$export$2e2bcd8739ae039 = $bdcc218e6a1dcb18$var$AdControlDropdownMenu;
module.exports["default"] = $bdcc218e6a1dcb18$export$2e2bcd8739ae039;

});

parcelRegister("fRta5", function(module, exports) {
// ACT Event types
// AdControlDropdownMenu
const $6a9218f106f63d94$export$17ff257e1f6e39f5 = 'AD_CONTROL_DROP_DOWN_MENU_OPENED';
const $6a9218f106f63d94$export$7fc09cf740f33ed4 = 'AD_CONTROL_DROP_DOWN_MENU_CLOSED';
const $6a9218f106f63d94$export$e33200507ac1d20a = 'DISMISS_STARTED';
const $6a9218f106f63d94$export$103f41d1f3bf374e = 'DISMISS_SUCCEEDED';
const $6a9218f106f63d94$export$6d3088110036f124 = 'DISMISS_FAILED';
const $6a9218f106f63d94$export$5595c6967e83d351 = 'REASONS_BUTTON_CLICKED';
const $6a9218f106f63d94$export$ff50ad60f08a4bc0 = 'REASONS_MODAL_SHOWN';
const $6a9218f106f63d94$export$6bd2d8eacca15ce1 = 'REASONS_MODAL_DISMISSED';
const $6a9218f106f63d94$export$5c5fc6956b7600ea = 'FLAG_DISMISSED';
module.exports["AD_CONTROL_DROP_DOWN_MENU_OPENED"] = $6a9218f106f63d94$export$17ff257e1f6e39f5;
module.exports["AD_CONTROL_DROP_DOWN_MENU_CLOSED"] = $6a9218f106f63d94$export$7fc09cf740f33ed4;
module.exports["DISMISS_STARTED"] = $6a9218f106f63d94$export$e33200507ac1d20a;
module.exports["DISMISS_SUCCEEDED"] = $6a9218f106f63d94$export$103f41d1f3bf374e;
module.exports["DISMISS_FAILED"] = $6a9218f106f63d94$export$6d3088110036f124;
module.exports["REASONS_BUTTON_CLICKED"] = $6a9218f106f63d94$export$5595c6967e83d351;
module.exports["REASONS_MODAL_SHOWN"] = $6a9218f106f63d94$export$ff50ad60f08a4bc0;
module.exports["REASONS_MODAL_DISMISSED"] = $6a9218f106f63d94$export$6bd2d8eacca15ce1;
module.exports["FLAG_DISMISSED"] = $6a9218f106f63d94$export$5c5fc6956b7600ea;

});

parcelRegister("kSW34", function(module, exports) {
$parcel$export(module.exports, "default", () => $07e3ec5bbd654613$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $7TH2w = parcelRequire("7TH2w");


var $inPa6 = parcelRequire("inPa6");

function $07e3ec5bbd654613$export$2e2bcd8739ae039() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const createInteractedUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((action)=>createAnalyticsEvent({
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            ...action
        }), [
        createAnalyticsEvent
    ]);
    const createScreenUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((name)=>createAnalyticsEvent({
            eventType: (0, $7TH2w.SCREEN_EVENT_TYPE),
            name: name
        }), [
        createAnalyticsEvent
    ]);
    return {
        createInteractedUIEvent: createInteractedUIEvent,
        createScreenUIEvent: createScreenUIEvent
    };
}

});

parcelRegister("h9hzU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fRta5 = parcelRequire("fRta5");


var $9c9yH = parcelRequire("9c9yH");


var $8L1Fu = parcelRequire("8L1Fu");

function $80d3df06c6f273d3$export$450072b04d50916() {
    const { state: state, modalPropsRef: modalPropsRef, dispatch: dispatch, onEvents: onEvents, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $8L1Fu.useAdControlContext)();
    /**
	 * Add a flag with flagProps to state for the item was dismissed
	 * {@link https://atlassian.design/components/flag/examples}
	 */ const addFlag = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((itemId, flagProps)=>{
        dispatch({
            type: 'ADD_FLAG',
            payload: {
                itemId: itemId,
                flagProps: flagProps
            }
        });
    }, [
        dispatch
    ]);
    /**
	 * Open a modal and set the modal props reference
	 */ const openModal = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((modalProps, modalItemId)=>{
        modalPropsRef.current = modalProps;
        dispatch({
            type: 'OPEN_MODAL',
            payload: modalItemId
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * Close a modal and clear the modal props reference
	 */ const closeModal = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        modalPropsRef.current = undefined;
        dispatch({
            type: 'CLOSE_MODAL'
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * The internal event handler that is used by the ACTEventDispatcher
	 */ const handleOnEvents = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        // Handle the events that have side effects on the state.
        switch(event.type){
            case 0, $fRta5.FLAG_DISMISSED:
                dispatch({
                    type: 'REMOVE_FLAG',
                    payload: event.itemId
                });
                break;
        }
        // Call the onEvents handler that is passed from the consumer.
        onEvents(event);
    }, [
        dispatch,
        onEvents
    ]);
    /**
	 * Create an event dispatcher for the given item id
	 */ const createEventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((itemId)=>{
        return new (0, $9c9yH.default)(itemId, handleOnEvents);
    }, [
        handleOnEvents
    ]);
    return {
        state: state,
        openModal: openModal,
        closeModal: closeModal,
        createEventDispatcher: createEventDispatcher,
        addFlag: addFlag,
        shouldShowDismissFlag: shouldShowDismissFlag
    };
}
module.exports["useAdControlProvider"] = $80d3df06c6f273d3$export$450072b04d50916;

});

parcelRegister("9c9yH", function(module, exports) {
class $99f724af69d7c626$export$2e2bcd8739ae039 {
    dispatch(type, analyticsEvent) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            analyticsEvent: analyticsEvent
        });
    }
    dispatchError(type, error) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            error: error
        });
    }
    _dispatch(event) {
        if (this.handler) this.handler(event);
    }
    constructor(itemId, handler){
        this.itemId = itemId;
        this.handler = handler;
    }
}
module.exports["default"] = $99f724af69d7c626$export$2e2bcd8739ae039;

});

parcelRegister("8L1Fu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $35IL4 = parcelRequire("35IL4");

function $d1d018053c996795$export$4e82dc865a56141b() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $35IL4.AdControlContext));
}
module.exports["useAdControlContext"] = $d1d018053c996795$export$4e82dc865a56141b;

});

parcelRegister("35IL4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1dZ5H = parcelRequire("1dZ5H");

const $8a2d05ab8b5622c4$export$554b2f9bd0a293df = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    state: {
        ...(0, $1dZ5H.initialAdControlProviderState)
    },
    modalPropsRef: undefined,
    dispatch: ()=>{},
    onEvents: ()=>{},
    shouldShowDismissFlag: true
});
module.exports["AdControlContext"] = $8a2d05ab8b5622c4$export$554b2f9bd0a293df;

});

parcelRegister("1dZ5H", function(module, exports) {
const $abc4c02fc3dda9d3$export$22776e7a42f7089d = {
    flags: new Map()
};
const $abc4c02fc3dda9d3$export$5f3557676ca801eb = (state, action)=>{
    switch(action.type){
        case 'ADD_FLAG':
            return {
                ...state,
                flags: new Map(state.flags).set(action.payload.itemId, action.payload.flagProps)
            };
        case 'REMOVE_FLAG':
            {
                // Clone the flags map and delete the flag
                const flags = new Map(state.flags);
                flags.delete(action.payload);
                return {
                    ...state,
                    flags: flags
                };
            }
        case 'OPEN_MODAL':
            return {
                ...state,
                modalItemId: action.payload
            };
        case 'CLOSE_MODAL':
            return {
                ...state,
                modalItemId: undefined
            };
        default:
            return state;
    }
};
module.exports["initialAdControlProviderState"] = $abc4c02fc3dda9d3$export$22776e7a42f7089d;
module.exports["adControlProviderReducer"] = $abc4c02fc3dda9d3$export$5f3557676ca801eb;

});

parcelRegister("2zUpm", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $35IL4 = parcelRequire("35IL4");


var $1dZ5H = parcelRequire("1dZ5H");


var $kL1O8 = parcelRequire("kL1O8");


var $85Wse = parcelRequire("85Wse");


var $jC7C7 = parcelRequire("jC7C7");

const $f0fb9a90e64cd61d$var$AdControlProvider = ({ children: children, onEvents: onEvents = ()=>{}, shouldShowDismissFlag: shouldShowDismissFlag = true })=>{
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useReducer((0, $1dZ5H.adControlProviderReducer), (0, $1dZ5H.initialAdControlProviderState));
    const modalPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const modalProps = modalPropsRef.current ?? {
        body: '',
        title: '',
        hasCloseButton: true
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kL1O8.default), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $35IL4.AdControlContext).Provider, {
            value: {
                state: state,
                modalPropsRef: modalPropsRef,
                dispatch: dispatch,
                onEvents: onEvents,
                shouldShowDismissFlag: shouldShowDismissFlag
            },
            children: [
                children,
                /*#__PURE__*/ (0, $l998X.jsx)((0, $jC7C7.default), {
                    itemId: state.modalItemId,
                    ...modalProps
                }),
                (0, $dh538.fg)('jfp-magma-hydration-fix-ad-control') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $85Wse.default), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {}),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $85Wse.default), {})
                })
            ]
        })
    });
};
var $f0fb9a90e64cd61d$export$2e2bcd8739ae039 = $f0fb9a90e64cd61d$var$AdControlProvider;
module.exports["default"] = $f0fb9a90e64cd61d$export$2e2bcd8739ae039;

});

parcelRegister("kL1O8", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $dqUnB = parcelRequire("dqUnB");


var $i9bNu = parcelRequire("i9bNu");

const $b308713f20b40665$var$ActIntlProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $i9bNu.default),
        loaderFn: (0, $dqUnB.fetchMessagesForLocale),
        children: children
    });
};
var $b308713f20b40665$export$2e2bcd8739ae039 = $b308713f20b40665$var$ActIntlProvider;
module.exports["default"] = $b308713f20b40665$export$2e2bcd8739ae039;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the context and pass them downstream
   * This prevents the missing messages error
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    (0, $42omo.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
        return undefined;
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $fI8ba = parcelRequire("fI8ba");

var $gmMgo = parcelRequire("gmMgo");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $fI8ba.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $gmMgo.Context));
    if (!context) return (0, $1e2E5.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("dqUnB", function(module, exports) {

var $k1MFX = parcelRequire("k1MFX");


var $i9bNu = parcelRequire("i9bNu");

const $06c066c00d1ae0fc$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $06c066c00d1ae0fc$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const targetLocale = ($06c066c00d1ae0fc$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $k1MFX.locales)) {
            const messages = await (0, $k1MFX.locales)[targetLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $k1MFX.locales)) {
            const messages = await (0, $k1MFX.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
	 * English bundled by default as this is the majority of users
	 */ return 0, $i9bNu.default;
};
module.exports["fetchMessagesForLocale"] = $06c066c00d1ae0fc$export$2b153a2030b0feb2;

});

parcelRegister("k1MFX", function(module, exports) {


























const $21a44ec23de25ffe$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("4eMQd")),
    da: ()=>(parcelRequire("6xcXa")),
    de: ()=>(parcelRequire("ge2eI")),
    en_GB: ()=>(parcelRequire("kFjnq")),
    en_ZZ: ()=>(parcelRequire("bxcHY")),
    en: ()=>Promise.resolve((parcelRequire("i9bNu"))),
    es: ()=>(parcelRequire("lRPwm")),
    fi: ()=>(parcelRequire("ebB32")),
    fr: ()=>(parcelRequire("5uZHO")),
    hu: ()=>(parcelRequire("1JxHc")),
    it: ()=>(parcelRequire("7IBBJ")),
    ja: ()=>(parcelRequire("jrej6")),
    ko: ()=>(parcelRequire("1JX7s")),
    nb: ()=>(parcelRequire("jMOHK")),
    nl: ()=>(parcelRequire("9nNiG")),
    pl: ()=>(parcelRequire("5BSNH")),
    pt_BR: ()=>(parcelRequire("jm3ex")),
    ru: ()=>(parcelRequire("eZ80I")),
    sv: ()=>(parcelRequire("3ZEFq")),
    th: ()=>(parcelRequire("kEPri")),
    tr: ()=>(parcelRequire("h4TBY")),
    uk: ()=>(parcelRequire("9eHWu")),
    vi: ()=>(parcelRequire("a2Nsn")),
    zh_TW: ()=>(parcelRequire("9Ihm1")),
    zh: ()=>(parcelRequire("S8Ege"))
};
module.exports["locales"] = $21a44ec23de25ffe$export$df1c34db1371eeed;

});

parcelRegister("i9bNu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $3654660649c0d4bb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $3654660649c0d4bb$export$2e2bcd8739ae039 = {
    'act.action.dismissalMessage.common.text': "You won\u2019t see this here as often.",
    'act.action.notInterested.button.text': 'Not interested',
    'act.action.notInterestedFlag.flag.text': 'Got it, thanks for letting us know',
    'act.action.reasonsModalOkButton.common.text': 'OK',
    'act.action.showReasons.common.text': 'Why am I seeing this?'
};

});

parcelRegister("4eMQd", function(module, exports) {

let $315e5b0eff786d5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $315e5b0eff786d5a$var$load("3FT39").then(()=>parcelRequire('4Yleb'));

});

parcelRegister("6xcXa", function(module, exports) {

let $4c1fdf6b12b37a17$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c1fdf6b12b37a17$var$load("7QoTg").then(()=>parcelRequire('jDakE'));

});

parcelRegister("ge2eI", function(module, exports) {

let $bcffb037722ea990$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bcffb037722ea990$var$load("d1Lrf").then(()=>parcelRequire('6RK0u'));

});

parcelRegister("kFjnq", function(module, exports) {

let $f0b6aacbdb40b5ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0b6aacbdb40b5ad$var$load("kM5GB").then(()=>parcelRequire('kzcZp'));

});

parcelRegister("bxcHY", function(module, exports) {

let $865ca262a9055aad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $865ca262a9055aad$var$load("5506N").then(()=>parcelRequire('33OOq'));

});

parcelRegister("lRPwm", function(module, exports) {

let $feb683360f3c545f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $feb683360f3c545f$var$load("7ioy0").then(()=>parcelRequire('gMkb6'));

});

parcelRegister("ebB32", function(module, exports) {

let $a53ed4b86a0b887f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a53ed4b86a0b887f$var$load("kZ6zs").then(()=>parcelRequire('1OjJD'));

});

parcelRegister("5uZHO", function(module, exports) {

let $400f9e8fda48b9de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $400f9e8fda48b9de$var$load("phbpE").then(()=>parcelRequire('jvMdy'));

});

parcelRegister("1JxHc", function(module, exports) {

let $143421b071e9854c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $143421b071e9854c$var$load("6pKhl").then(()=>parcelRequire('gVnbl'));

});

parcelRegister("7IBBJ", function(module, exports) {

let $59e9d08f20e946d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $59e9d08f20e946d5$var$load("hzLOt").then(()=>parcelRequire('d0lkZ'));

});

parcelRegister("jrej6", function(module, exports) {

let $e26ba30433a0b5bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e26ba30433a0b5bf$var$load("1M8mW").then(()=>parcelRequire('4TGbq'));

});

parcelRegister("1JX7s", function(module, exports) {

let $1447da49ec6cfdc7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1447da49ec6cfdc7$var$load("eHQAY").then(()=>parcelRequire('hGfMv'));

});

parcelRegister("jMOHK", function(module, exports) {

let $e679d4de95e3657e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e679d4de95e3657e$var$load("8exPB").then(()=>parcelRequire('aYgYT'));

});

parcelRegister("9nNiG", function(module, exports) {

let $6d4c8109597ab866$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d4c8109597ab866$var$load("knfAP").then(()=>parcelRequire('2GadI'));

});

parcelRegister("5BSNH", function(module, exports) {

let $415aeabc10236ce4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $415aeabc10236ce4$var$load("ljRXP").then(()=>parcelRequire('eoRvM'));

});

parcelRegister("jm3ex", function(module, exports) {

let $e172947b685f7336$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e172947b685f7336$var$load("bEb8c").then(()=>parcelRequire('5mSqI'));

});

parcelRegister("eZ80I", function(module, exports) {

let $ae8cf9e6f09d976b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ae8cf9e6f09d976b$var$load("c7JYF").then(()=>parcelRequire('5zX31'));

});

parcelRegister("3ZEFq", function(module, exports) {

let $2e869d3f88a75530$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2e869d3f88a75530$var$load("ari8V").then(()=>parcelRequire('j4Pzu'));

});

parcelRegister("kEPri", function(module, exports) {

let $f09f71dda87efcbd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f09f71dda87efcbd$var$load("kfrHX").then(()=>parcelRequire('bdGVV'));

});

parcelRegister("h4TBY", function(module, exports) {

let $c6edf2b09dd62781$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c6edf2b09dd62781$var$load("aWToy").then(()=>parcelRequire('bg9up'));

});

parcelRegister("9eHWu", function(module, exports) {

let $6b9781e1cddd22ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b9781e1cddd22ce$var$load("4ns5x").then(()=>parcelRequire('jG5jM'));

});

parcelRegister("a2Nsn", function(module, exports) {

let $7500745ca11310a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7500745ca11310a3$var$load("7bfAn").then(()=>parcelRequire('jgloM'));

});

parcelRegister("9Ihm1", function(module, exports) {

let $7125af4652facd67$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7125af4652facd67$var$load("gftgT").then(()=>parcelRequire('i0bIF'));

});

parcelRegister("S8Ege", function(module, exports) {

let $0a2bc0a564e10417$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0a2bc0a564e10417$var$load("6YVlG").then(()=>parcelRequire('4a8Ly'));

});

parcelRegister("85Wse", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $aD1SW = parcelRequire("aD1SW");

var $6uGcC = parcelRequire("6uGcC");


var $eqRDX = parcelRequire("eqRDX");


var $gdv5Z = parcelRequire("gdv5Z");


var $6fnsQ = parcelRequire("6fnsQ");


var $fRta5 = parcelRequire("fRta5");


var $kSW34 = parcelRequire("kSW34");


var $h9hzU = parcelRequire("h9hzU");


var $7R3FL = parcelRequire("7R3FL");


var $2bASh = parcelRequire("2bASh");

const $0f8daac9763b8054$var$ACT_FLAG_WRAPPER = 'act-flag-wrapper';
const $0f8daac9763b8054$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsFlagClose'
};
const $0f8daac9763b8054$var$DismissalFlagGroup = ()=>{
    (0, $2bASh.overridePortalIndex)($0f8daac9763b8054$var$ACT_FLAG_WRAPPER);
    const { state: { flags: flags }, createEventDispatcher: createEventDispatcher } = (0, $h9hzU.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kSW34.default)();
    const handleOnDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((id)=>{
        createEventDispatcher(id).dispatch((0, $fRta5.FLAG_DISMISSED), createInteractedUIEvent($0f8daac9763b8054$var$interactedUIEventAction));
    }, [
        createEventDispatcher,
        createInteractedUIEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
        onDismissed: handleOnDismissed,
        children: Array.from(flags.entries()).map(([itemId, { actions: actions = [], ...flagProps } = {
            actions: []
        }], i)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                id: $0f8daac9763b8054$var$ACT_FLAG_WRAPPER,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aD1SW.default), {
                    id: itemId,
                    testId: `act-flag-${itemId}`,
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eqRDX))), {
                        label: "Success",
                        spacing: "spacious",
                        color: `var(--ds-icon-success, ${(0, $6fnsQ.G300)})`
                    }),
                    title: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $7R3FL.messages).notInterestedFlag
                    }),
                    description: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $7R3FL.messages).dismissalMessage
                    }),
                    ...flagProps,
                    actions: actions.map((action)=>({
                            ...action,
                            onClick: (e)=>{
                                action.onClick?.(e, ()=>handleOnDismissed(itemId));
                            }
                        }))
                })
            }, i))
    });
};
var $0f8daac9763b8054$export$2e2bcd8739ae039 = $0f8daac9763b8054$var$DismissalFlagGroup;
module.exports["default"] = $0f8daac9763b8054$export$2e2bcd8739ae039;

});

parcelRegister("7R3FL", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $c156cf06b085a120$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    notInterested: {
        id: "act.action.notInterested.button.text",
        defaultMessage: "Not interested"
    },
    notInterestedFlag: {
        id: "act.action.notInterestedFlag.flag.text",
        defaultMessage: "Got it, thanks for letting us know"
    },
    showReasons: {
        id: "act.action.showReasons.common.text",
        defaultMessage: "Why am I seeing this?"
    },
    dismissalMessage: {
        id: "act.action.dismissalMessage.common.text",
        defaultMessage: "You won\u2019t see this here as often."
    },
    reasonsModalOkButton: {
        id: "act.action.reasonsModalOkButton.common.text",
        defaultMessage: "OK"
    }
});
module.exports["messages"] = $c156cf06b085a120$export$defe85febe8b728c;

});

parcelRegister("2bASh", function(module, exports) {
const $5cf66c7a3cd119b9$export$335243096683aa37 = 900;
function $5cf66c7a3cd119b9$export$61df98316049b30(elementId, index = $5cf66c7a3cd119b9$export$335243096683aa37) {
    setTimeout(()=>{
        if (typeof document !== 'undefined') {
            const parentPortal = $5cf66c7a3cd119b9$export$148feac3be949786(document.getElementById(elementId), '.atlaskit-portal');
            if (parentPortal) parentPortal.setAttribute('style', `z-index:${index};`);
        }
    }, 0);
}
function $5cf66c7a3cd119b9$var$collectionHas(all, curr) {
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
}
function $5cf66c7a3cd119b9$export$148feac3be949786(elm, selector) {
    let all = document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$5cf66c7a3cd119b9$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
}
module.exports["DEFAULT_PORTAL_OVERRIDE_INDEX"] = $5cf66c7a3cd119b9$export$335243096683aa37;
module.exports["overridePortalIndex"] = $5cf66c7a3cd119b9$export$61df98316049b30;

});

parcelRegister("jC7C7", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $ccHMk = parcelRequire("ccHMk");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $gdv5Z = parcelRequire("gdv5Z");


var $fRta5 = parcelRequire("fRta5");


var $kSW34 = parcelRequire("kSW34");


var $h9hzU = parcelRequire("h9hzU");


var $7R3FL = parcelRequire("7R3FL");


var $2bASh = parcelRequire("2bASh");

const $139ac0b427a5c906$var$adControlScreenName = 'adControlsReasonsModal';
const $139ac0b427a5c906$var$ACT_MODAL_CONTENT = 'ACT_MODAL_CONTENT';
const $139ac0b427a5c906$var$ReasonsModal = ({ body: body, itemId: itemId, title: title, zIndexOverride: zIndexOverride = (0, $2bASh.DEFAULT_PORTAL_OVERRIDE_INDEX), hasCloseButton: hasCloseButton = true, ...props })=>{
    const { closeModal: closeModal, createEventDispatcher: createEventDispatcher } = (0, $h9hzU.useAdControlProvider)();
    const { createScreenUIEvent: createScreenUIEvent } = (0, $kSW34.default)();
    const isMounted = (0, $42omo.useRef)(false);
    const eventDispatcherRef = (0, $42omo.useRef)();
    eventDispatcherRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>itemId !== undefined ? createEventDispatcher(itemId) : eventDispatcherRef.current, [
        createEventDispatcher,
        itemId
    ]);
    const isOpen = itemId !== undefined;
    (0, $42omo.useEffect)(()=>{
        const eventDispatcher = eventDispatcherRef.current;
        if (!eventDispatcher) return;
        if (isOpen) eventDispatcher.dispatch((0, $fRta5.REASONS_MODAL_SHOWN), createScreenUIEvent($139ac0b427a5c906$var$adControlScreenName));
        else if (isMounted.current && !isOpen) eventDispatcher.dispatch((0, $fRta5.REASONS_MODAL_DISMISSED), createScreenUIEvent($139ac0b427a5c906$var$adControlScreenName));
    }, [
        createScreenUIEvent,
        isOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    if (isOpen && zIndexOverride) (0, $2bASh.overridePortalIndex)($139ac0b427a5c906$var$ACT_MODAL_CONTENT, zIndexOverride);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
            shouldCloseOnEscapePress: true,
            onClose: closeModal,
            ...props,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                id: $139ac0b427a5c906$var$ACT_MODAL_CONTENT,
                children: [
                    title !== null && /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                        hasCloseButton: hasCloseButton,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                            children: title ?? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $7R3FL.messages).showReasons
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                        children: body
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "primary",
                            onClick: closeModal,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $7R3FL.messages).reasonsModalOkButton
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $139ac0b427a5c906$export$2e2bcd8739ae039 = $139ac0b427a5c906$var$ReasonsModal;
module.exports["default"] = $139ac0b427a5c906$export$2e2bcd8739ae039;

});

parcelRegister("3ylo6", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $dAYOx = parcelRequire("dAYOx");


var $fRta5 = parcelRequire("fRta5");


var $kSW34 = parcelRequire("kSW34");


var $h9hzU = parcelRequire("h9hzU");


var $7R3FL = parcelRequire("7R3FL");

const $08a2895c8eb1cea2$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'notInterested'
};
const $08a2895c8eb1cea2$var$DismissalButton = ({ itemId: itemId, onClick: onClick, children: children, flagProps: flagProps, ...props })=>{
    const { addFlag: addFlag, createEventDispatcher: createEventDispatcher, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $h9hzU.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kSW34.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async (e)=>{
        eventDispatcher.dispatch((0, $fRta5.DISMISS_STARTED), createInteractedUIEvent($08a2895c8eb1cea2$var$interactedUIEventAction));
        shouldShowDismissFlag && addFlag(itemId, flagProps);
        try {
            await onClick?.(e, itemId);
            eventDispatcher.dispatch((0, $fRta5.DISMISS_SUCCEEDED));
        } catch (e) {
            eventDispatcher.dispatchError((0, $fRta5.DISMISS_FAILED), e);
        }
    }, [
        addFlag,
        createInteractedUIEvent,
        eventDispatcher,
        flagProps,
        itemId,
        onClick,
        shouldShowDismissFlag
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $7R3FL.messages).notInterested
        })
    });
};
var $08a2895c8eb1cea2$export$2e2bcd8739ae039 = $08a2895c8eb1cea2$var$DismissalButton;
module.exports["default"] = $08a2895c8eb1cea2$export$2e2bcd8739ae039;

});

parcelRegister("hEz36", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $dAYOx = parcelRequire("dAYOx");


var $fRta5 = parcelRequire("fRta5");


var $kSW34 = parcelRequire("kSW34");


var $h9hzU = parcelRequire("h9hzU");


var $7R3FL = parcelRequire("7R3FL");

const $3b87ab993ce1d1b1$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsReasons'
};
const $3b87ab993ce1d1b1$var$ReasonsButton = ({ children: children, itemId: itemId, modalProps: modalProps, onClick: onClick, ...props })=>{
    const { createEventDispatcher: createEventDispatcher, openModal: openModal } = (0, $h9hzU.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kSW34.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        eventDispatcher.dispatch((0, $fRta5.REASONS_BUTTON_CLICKED), createInteractedUIEvent($3b87ab993ce1d1b1$var$interactedUIEventAction));
        openModal(modalProps, itemId);
        onClick?.(e, itemId);
    }, [
        createInteractedUIEvent,
        eventDispatcher,
        itemId,
        modalProps,
        onClick,
        openModal
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $7R3FL.messages).showReasons
        })
    });
};
var $3b87ab993ce1d1b1$export$2e2bcd8739ae039 = $3b87ab993ce1d1b1$var$ReasonsButton;
module.exports["default"] = $3b87ab993ce1d1b1$export$2e2bcd8739ae039;

});

parcelRegister("5i3ci", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1lhEF = parcelRequire("1lhEF");


var $9wGTI = parcelRequire("9wGTI");


var $aFmsO = parcelRequire("aFmsO");


var $ma85v = parcelRequire("ma85v");

const $9fbe62170cacfcf3$export$d6e697640576fe29 = ({ children: children, entryPointId: entryPointId, isCircle: isCircle })=>{
    const { isPulseActive: isPulseActiveEP } = (0, $aFmsO.useDiscoverabilityPulse)(entryPointId);
    const { isPulseActive: isPulseActivePostOffice } = (0, $ma85v.useDiscoverabilityPulsePostOffice)(entryPointId);
    const isPulseActive = (0, $9wGTI.fg)('confluence_loom_x-sell_ep_po_migration') ? isPulseActivePostOffice : isPulseActiveEP;
    if (!isPulseActive) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lhEF.Pulse), {
        radius: isCircle ? 24 : 3,
        testId: "loom-cross-sell-discoverability-pulse"
    }, children);
};
module.exports["DiscoverabilityPulse"] = $9fbe62170cacfcf3$export$d6e697640576fe29;

});

parcelRegister("ma85v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXjWU = parcelRequire("aXjWU");


var $9wGTI = parcelRequire("9wGTI");


var $jHpN3 = parcelRequire("jHpN3");

const $486bcfa61be9017c$var$PULSE_MESSAGE_IDS = [
    'cc-loom-x-sell-discoverability-pulse-1',
    'cc-loom-x-sell-discoverability-pulse-2',
    'cc-loom-x-sell-discoverability-pulse-3',
    'cc-loom-x-sell-discoverability-pulse-4',
    'cc-loom-x-sell-discoverability-pulse-5'
];
const $486bcfa61be9017c$var$TIMEOUT_MS = 300;
const $486bcfa61be9017c$var$LAST_PULSE_INDEX = $486bcfa61be9017c$var$PULSE_MESSAGE_IDS.length - 1;
const $486bcfa61be9017c$var$requestNextPulse = (nextIndex, pulseHooks, hasRequestedRef, lastRequestedRef)=>{
    if (nextIndex < pulseHooks.length && !hasRequestedRef.current.has(nextIndex)) {
        hasRequestedRef.current.add(nextIndex);
        lastRequestedRef.current = {
            index: nextIndex,
            timestamp: Date.now()
        };
        pulseHooks[nextIndex].requestMessageStart();
    }
};
const $486bcfa61be9017c$export$c4b0090b21b70d1d = (entryPointId)=>{
    // All hooks must be called unconditionally (Rules of Hooks)
    const isPulseActive = (0, $jHpN3.useIsPulseActive)(entryPointId);
    const { start: startPulse } = (0, $jHpN3.useDiscoverabilityPulseActions)();
    const skipRefreshPulseStatus = isPulseActive && (0, $jHpN3.havePulsesEnded)();
    // Call hooks at the top level for all message IDs
    const pulse1 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($486bcfa61be9017c$var$PULSE_MESSAGE_IDS[0]);
    const pulse2 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($486bcfa61be9017c$var$PULSE_MESSAGE_IDS[1]);
    const pulse3 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($486bcfa61be9017c$var$PULSE_MESSAGE_IDS[2]);
    const pulse4 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($486bcfa61be9017c$var$PULSE_MESSAGE_IDS[3]);
    const pulse5 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($486bcfa61be9017c$var$PULSE_MESSAGE_IDS[4]);
    const pulseHooks = (0, $42omo.useMemo)(()=>[
            pulse1,
            pulse2,
            pulse3,
            pulse4,
            pulse5
        ], [
        pulse1,
        pulse2,
        pulse3,
        pulse4,
        pulse5
    ]);
    // Track which messages we've requested to avoid duplicate requests
    const hasRequestedRef = (0, $42omo.useRef)(new Set());
    // Track the last requested message index and when it was requested (for timeout)
    const lastRequestedRef = (0, $42omo.useRef)(null);
    // Track which message index was last started (to detect dismissal)
    const lastStartedIndexRef = (0, $42omo.useRef)(null);
    // State trigger to force re-evaluation when timeout expires
    const [timeoutTrigger, setTimeoutTrigger] = (0, $42omo.useState)(0);
    // Request messages sequentially - only request the next one if previous ones haven't started
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_loom_x-sell_ep_po_migration') || skipRefreshPulseStatus) return;
        // Find the first message that hasn't started and request it
        // If a previous message has started, we stop (handled by the other effect)
        for(let i = 0; i < pulseHooks.length; i++){
            const pulseHook = pulseHooks[i];
            // If this message has started, we're done - don't request any more
            if (pulseHook.hasMessageStarted) {
                // Clear the timeout tracking since we found an active message
                lastRequestedRef.current = null;
                // Track which message is started (will be set by the activation effect, but set here too for consistency)
                lastStartedIndexRef.current = i;
                break;
            }
            // If we haven't requested this one yet, request it and stop
            // The effect will re-run when hasMessageStarted changes, allowing us to move to the next one
            if (!hasRequestedRef.current.has(i)) {
                hasRequestedRef.current.add(i);
                lastRequestedRef.current = {
                    index: i,
                    timestamp: Date.now()
                };
                pulseHook.requestMessageStart();
                break;
            }
        }
    }, [
        skipRefreshPulseStatus,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted,
        pulse1.requestMessageStart,
        pulse2.requestMessageStart,
        pulse3.requestMessageStart,
        pulse4.requestMessageStart,
        pulse5.requestMessageStart,
        pulse1.handlePostOfficeClickTracking,
        pulse2.handlePostOfficeClickTracking,
        pulse3.handlePostOfficeClickTracking,
        pulse4.handlePostOfficeClickTracking,
        pulse5.handlePostOfficeClickTracking
    ]);
    // Timeout handler: if a requested message hasn't started after a delay, try the next one
    // Note: If a message was already dismissed, Post Office filters it before page load
    // so we only need time for the initial load and state updates (~200-300ms)
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_loom_x-sell_ep_po_migration') || skipRefreshPulseStatus || !lastRequestedRef.current || isPulseActive) return;
        const { index: index, timestamp: timestamp } = lastRequestedRef.current;
        const pulseHook = pulseHooks[index];
        // If the message has started, clear the timeout tracking
        if (pulseHook.hasMessageStarted) {
            lastRequestedRef.current = null;
            return;
        }
        // If enough time has passed and the message still hasn't started, move to the next one
        const elapsed = Date.now() - timestamp;
        if (elapsed >= $486bcfa61be9017c$var$TIMEOUT_MS) {
            // Clear the current request tracking
            lastRequestedRef.current = null;
            // Try the next message if available
            $486bcfa61be9017c$var$requestNextPulse(index + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
        } else {
            // Set a timeout to trigger re-evaluation when the timeout period elapses
            const remainingTime = $486bcfa61be9017c$var$TIMEOUT_MS - elapsed;
            const timeoutId = setTimeout(()=>{
                setTimeoutTrigger((prev)=>prev + 1);
            }, remainingTime);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        skipRefreshPulseStatus,
        isPulseActive,
        timeoutTrigger,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    // Reactively respond when a message starts - activate the pulse
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_loom_x-sell_ep_po_migration') || skipRefreshPulseStatus) return;
        // Check each pulse in sequence - activate the first one that has started
        for(let i = 0; i < pulseHooks.length; i++){
            const pulseHook = pulseHooks[i];
            const messageId = $486bcfa61be9017c$var$PULSE_MESSAGE_IDS[i];
            if (pulseHook.hasMessageStarted) {
                lastStartedIndexRef.current = i;
                startPulse(entryPointId, messageId, {
                    onDismiss: ()=>pulseHook.dismissMessage(),
                    onClick: ()=>pulseHook.handlePostOfficeClickTracking?.()
                });
                // If this is the last pulse, mark pulses as ended
                if (i === $486bcfa61be9017c$var$LAST_PULSE_INDEX) /**
					 * Mark the EP message as "complete" and disable Loom discoverability in localStorage
					 * immediately after showing the final pulse. Otherwise, if a user ignores the entrypoints
					 * entirely and never clicks on one while it's pulsing, they'll:
					 *
					 * - Remain in the TAP audience forever
					 * - Continue to check the EP messages every time an entrypoint renders
					 *
					 * This will technically unlock EP to show other messages, but the pulse is subtle enough that
					 * this shouldn't result in poor UX
					 */ (0, $jHpN3.endPulses)();
                break;
            }
        }
    }, [
        skipRefreshPulseStatus,
        entryPointId,
        startPulse,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    // Handle message dismissal: if a started message becomes not started, request the next one
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_loom_x-sell_ep_po_migration') || skipRefreshPulseStatus || lastStartedIndexRef.current === null || isPulseActive) return;
        const startedIndex = lastStartedIndexRef.current;
        const startedPulseHook = pulseHooks[startedIndex];
        // If the message that was started is no longer started, it was dismissed
        if (!startedPulseHook.hasMessageStarted) {
            // Clear the tracking for this message so we can move forward
            hasRequestedRef.current.delete(startedIndex);
            lastStartedIndexRef.current = null;
            // Request the next message if available
            $486bcfa61be9017c$var$requestNextPulse(startedIndex + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
        }
    }, [
        skipRefreshPulseStatus,
        isPulseActive,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    return (0, $9wGTI.fg)('confluence_loom_x-sell_ep_po_migration') ? {
        isPulseActive: isPulseActive
    } : {
        isPulseActive: false
    };
};
module.exports["useDiscoverabilityPulsePostOffice"] = $486bcfa61be9017c$export$c4b0090b21b70d1d;

});

parcelRegister("aXjWU", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $42omo.useState)($6d6c82fa2f331bd2$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $42omo.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $42omo.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $42omo.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $42omo.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6d6c82fa2f331bd2$export$e45375ff75169f = (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $42omo.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $42omo.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $42omo.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $6d6c82fa2f331bd2$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $6d6c82fa2f331bd2$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $6d6c82fa2f331bd2$export$e45375ff75169f;

});

parcelRegister("cauOq", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $9JpPs = parcelRequire("9JpPs");


var $jmjWc = parcelRequire("jmjWc");


var $6mKj3 = parcelRequire("6mKj3");


const $5d7856924c94f859$var$EditorHelpCenterBackground = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "hR0dw",
    name: "EditorHelpCenterBackground",
    loader: async ()=>(await (parcelRequire("5Mh4X"))).EditorHelpCenter
});

const $5d7856924c94f859$var$EditorHelpCenterOnPaint = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "V131B",
    name: "EditorHelpCenterOnPaint",
    loader: async ()=>(await (parcelRequire("5Mh4X"))).EditorHelpCenter
});
const $5d7856924c94f859$export$8ffe1e824479312f = (0, $9JpPs.componentWithCondition)(()=>(0, $6mKj3.expValEquals)('platform_editor_help_center_background_load', 'variant', 'test'), $5d7856924c94f859$var$EditorHelpCenterBackground, $5d7856924c94f859$var$EditorHelpCenterOnPaint);
module.exports["EditorHelpCenter"] = $5d7856924c94f859$export$8ffe1e824479312f;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("5Mh4X", function(module, exports) {

let $434eaef767dc83f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $434eaef767dc83f7$var$load("kiGNy"),
    $434eaef767dc83f7$var$load("2nk6f")
]).then(()=>parcelRequire('cix6s'));

});

parcelRegister("7WFax", function(module, exports) {
/* HelpWidget.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $ci7Ox = parcelRequire("ci7Ox");


var $3gadb = parcelRequire("3gadb");


var $6xdDU = parcelRequire("6xdDU");


var $9mLIQ = parcelRequire("9mLIQ");


var $dcvq8 = parcelRequire("dcvq8");


var $lx6jn = parcelRequire("lx6jn");


var $8ViO5 = parcelRequire("8ViO5");

const $42fef2b06f093364$var$styles = {
    root: "_kqswstnw _94n51ejb _1ltvv47k _1pby1nn1"
};
const $42fef2b06f093364$var$i18n = (0, $cgtv4.defineMessages)({
    helpName: {
        id: "editor-help.help.name",
        defaultMessage: "Help"
    }
});
const $42fef2b06f093364$export$c7125cce544d6ba9 = /*#__PURE__*/ (0, $42omo.memo)(({ openHelpDialog: openHelpDialog, contentId: contentId, isNCSEditor: isNCSEditor, isTemplateEditor: isTemplateEditor, isCompanyHub: isCompanyHub, setIsOpen: setIsOpen, isOpen: isOpen })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [shouldShowDevTools, setShouldShowDevTools] = (0, $42omo.useState)(false);
    const [shouldShowGlobalFeedbackCollector, setShouldShowGlobalFeedbackCollector] = (0, $42omo.useState)(false);
    const triggerRef = (0, $42omo.useRef)(null);
    const handleButtonClick = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        setIsOpen?.(!isOpen);
    }, [
        isOpen,
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "help-widget",
        className: (0, $gMc0m.default)([
            $42fef2b06f093364$var$styles.root
        ])
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8ViO5.HelpMenu), {
        openHelpDialog: openHelpDialog,
        contentId: contentId,
        isNCSEditor: isNCSEditor,
        isTemplateEditor: isTemplateEditor,
        isCompanyHub: isCompanyHub,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        setShouldShowDevTools: setShouldShowDevTools,
        setShouldShowGlobalFeedbackCollector: setShouldShowGlobalFeedbackCollector,
        triggerRef: triggerRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($42fef2b06f093364$var$i18n.helpName),
        position: "right",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        ref: triggerRef,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))),
        shape: "circle",
        appearance: "subtle",
        label: formatMessage($42fef2b06f093364$var$i18n.helpName),
        testId: "help-menu-icon-button",
        onClick: handleButtonClick,
        isSelected: isOpen,
        "aria-expanded": isOpen,
        "aria-haspopup": "menu",
        color: "color.icon.subtlest"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, shouldShowDevTools && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mLIQ.LazyDevToolsDialog), {
        onClose: ()=>setShouldShowDevTools(false)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, shouldShowGlobalFeedbackCollector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcvq8.LazyGlobalFeedbackCollector), {
        feedbackSource: (0, $lx6jn.FeedbackSource).EDITOR,
        onClose: ()=>setShouldShowGlobalFeedbackCollector(false),
        onCloseComplete: ()=>{},
        contentType: "page" // TODO: add contentType
    })));
});
module.exports["HelpWidget"] = $42fef2b06f093364$export$c7125cce544d6ba9;

});

parcelRegister("9mLIQ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $6d1b2fcade0e4c0b$export$23eed8de2215911d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "J4uP_",
    name: "DevToolsDialog",
    loader: async ()=>(await (parcelRequire("647z4"))).DevToolsDialog
});

const $6d1b2fcade0e4c0b$export$edf3a07292eacd91 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "-mSEo",
    name: "LazyDevToolsDialog",
    loader: async ()=>(await (parcelRequire("647z4"))).DevToolsDialog
});

const $6d1b2fcade0e4c0b$export$a08fb8aab8d5eb82 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "rSlGt",
    name: "DevToolsBanner",
    loader: async ()=>(await (parcelRequire("ddmQY"))).DevToolsBanner
});
module.exports["DevToolsDialog"] = $6d1b2fcade0e4c0b$export$23eed8de2215911d;
module.exports["LazyDevToolsDialog"] = $6d1b2fcade0e4c0b$export$edf3a07292eacd91;
module.exports["DevToolsBanner"] = $6d1b2fcade0e4c0b$export$a08fb8aab8d5eb82;

});

parcelRegister("647z4", function(module, exports) {

let $46a8fbf94bf2c4e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $46a8fbf94bf2c4e0$var$load("lkOIY"),
    $46a8fbf94bf2c4e0$var$load("2spqH"),
    $46a8fbf94bf2c4e0$var$load("gWSdF"),
    $46a8fbf94bf2c4e0$var$load("awqCy"),
    $46a8fbf94bf2c4e0$var$load("6wr18"),
    $46a8fbf94bf2c4e0$var$load("kHOMt"),
    $46a8fbf94bf2c4e0$var$load("hhss7"),
    $46a8fbf94bf2c4e0$var$load("Wowvf"),
    $46a8fbf94bf2c4e0$var$load("7EorR"),
    $46a8fbf94bf2c4e0$var$load("ffEVr"),
    $46a8fbf94bf2c4e0$var$load("kUbUu"),
    $46a8fbf94bf2c4e0$var$load("i4Poh")
]).then(()=>parcelRequire('FAgdQ'));

});

parcelRegister("ddmQY", function(module, exports) {

let $99ee3773125bddc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99ee3773125bddc9$var$load("C72jX").then(()=>parcelRequire('5uV65'));

});

parcelRegister("8ViO5", function(module, exports) {
/* HelpMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $8tdj3 = parcelRequire("8tdj3");


var $56M4r = parcelRequire("56M4r");

var $cGtPE = parcelRequire("cGtPE");

var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");


var $bavCP = parcelRequire("bavCP");


var $4tOXV = parcelRequire("4tOXV");


var $bw3p5 = parcelRequire("bw3p5");


var $gHANe = parcelRequire("gHANe");


var $jmjWc = parcelRequire("jmjWc");


var $lREFo = parcelRequire("lREFo");


var $6mKj3 = parcelRequire("6mKj3");


var $79V5c = parcelRequire("79V5c");


var $gi8bo = parcelRequire("gi8bo");


var $ep7kE = parcelRequire("ep7kE");

const $9fef5514b8b73423$var$styles = {
    base: "_2rko12b0 _1rjc12x7 _1mouu2gc _195g1wug _bfhk1bhr _16qs130s _p12fnklw",
    shortcut: "_syaz1rpy"
};
const $9fef5514b8b73423$export$d3e032c62ea2d293 = ({ openHelpDialog: openHelpDialog, contentId: contentId, isNCSEditor: isNCSEditor, isTemplateEditor: isTemplateEditor, isCompanyHub: isCompanyHub, isOpen: isOpen, setIsOpen: setIsOpen, setShouldShowDevTools: setShouldShowDevTools, setShouldShowGlobalFeedbackCollector: setShouldShowGlobalFeedbackCollector, triggerRef: triggerRef })=>{
    const containerRef = (0, $42omo.useRef)(null);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const blueprintType = (0, $lREFo.useBlueprintType)(contentId, isTemplateEditor);
    const handleCloseHelpMenu = (0, $42omo.useCallback)(()=>{
        setIsOpen?.(false);
    }, [
        setIsOpen
    ]); // Callback ref to focus the menu container when it mounts for a11y
    const setContainerRef = (0, $42omo.useCallback)((node)=>{
        containerRef.current = node;
        if (node && (0, $6mKj3.expValEquals)('confluence_editor_help_menu_keyboard_a11y', 'isEnabled', true)) // Focus the menu container directly - it has tabIndex={-1} to receive programmatic focus
        node.focus();
    }, []); // Arrow key navigation for keyboard a11y
    // Implemented manually here because this is not yet supported by the AK Menu component
    // and the DropdownMenu is avoided for performance reasons
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        if (!containerRef.current || !(0, $6mKj3.expValEquals)('confluence_editor_help_menu_keyboard_a11y', 'isEnabled', true)) return;
        const items = containerRef.current.querySelectorAll('button, a, [role="menuitem"]');
        if (!items.length) return;
         // Check if focus is on the container itself (not on a menu item)
        const focusOnContainer = document.activeElement === containerRef.current;
        const currentIndex = focusOnContainer ? -1 : Array.from(items).findIndex((item)=>item === document.activeElement);
        switch(event.key){
            case 'ArrowDown':
                event.preventDefault();
                if (focusOnContainer || currentIndex === -1) // Focus first item when pressing down from container
                items[0].focus();
                else {
                    const nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
                    items[nextIndex].focus();
                }
                break;
            case 'ArrowUp':
                event.preventDefault();
                if (focusOnContainer || currentIndex === -1) // Focus last item when pressing up from container
                items[items.length - 1].focus();
                else {
                    const prevIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
                    items[prevIndex].focus();
                }
                break;
            case 'Tab':
                event.preventDefault();
                if (event.shiftKey) {
                    // Shift+Tab - move backwards
                    if (focusOnContainer || currentIndex === -1) items[items.length - 1].focus();
                    else {
                        const prevIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
                        items[prevIndex].focus();
                    }
                } else // Tab - move forwards
                if (focusOnContainer || currentIndex === -1) items[0].focus();
                else {
                    const nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
                    items[nextIndex].focus();
                }
                break;
            case 'Escape':
                event.preventDefault();
                handleCloseHelpMenu(); // Return focus to trigger button
                triggerRef?.current?.focus();
                break;
        }
    }, [
        containerRef,
        handleCloseHelpMenu,
        triggerRef
    ]);
    const handleClickOutside = (0, $42omo.useCallback)((event)=>{
        const target = event.target;
        const targetIsNotUnmountedByReact = target.offsetParent;
        if (isOpen && targetIsNotUnmountedByReact && !(0, $79V5c.isDescendant)(containerRef.current, target)) handleCloseHelpMenu();
    }, [
        isOpen,
        handleCloseHelpMenu
    ]);
    (0, $42omo.useEffect)(()=>{
        window.document.addEventListener('click', handleClickOutside);
        return ()=>{
            window.document.removeEventListener('click', handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    const onItemClick = (0, $42omo.useCallback)((_event, callback)=>{
        if (callback) return ()=>{
            handleCloseHelpMenu();
            if ((0, $6mKj3.expValEquals)('confluence_editor_help_menu_keyboard_a11y', 'isEnabled', true)) {
                triggerRef?.current?.focus(); // Wrap callback in requestAnimationFrame to ensure it is triggered async after focus is moved
                // This allows focus to return to the help icon after the opened modal is closed for a11y
                requestAnimationFrame(()=>{
                    callback();
                });
            } else callback();
        };
        handleCloseHelpMenu();
    }, [
        handleCloseHelpMenu,
        triggerRef
    ]);
    const renderHelpShortcutDropDownItem = (0, $42omo.useMemo)(()=>/*#__PURE__*/ $42omo.createElement((0, $56M4r.default), {
            onClick: onItemClick(null, openHelpDialog),
            iconAfter: /*#__PURE__*/ $42omo.createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: "mod+/"
            })
        }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
            id: "editor.shortcuts"
        })), [
        onItemClick,
        openHelpDialog
    ]);
    const renderHelpCenter = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ $42omo.createElement((0, $ep7kE.HelpMenuHelpCenterItem), {
            closeHelpMenu: handleCloseHelpMenu
        });
    }, [
        handleCloseHelpMenu
    ]);
    const renderBlueprintTypeBasedDropdownItems = (0, $42omo.useMemo)(()=>{
        if ((0, $gi8bo.CONTEXTUAL_EDITOR_HELP_LINKS).hasOwnProperty(blueprintType)) {
            const i18nMessage = {
                id: (0, $gi8bo.PREDEFINED_BLUEPRINT_TYPES_TITLES)[blueprintType]
            };
            const blueprintTitle = formatMessage(i18nMessage);
            return (0, $gi8bo.CONTEXTUAL_EDITOR_HELP_LINKS)[blueprintType].map((item, index)=>/*#__PURE__*/ $42omo.createElement((0, $cGtPE.default), {
                    key: index,
                    onClick: (e)=>onItemClick(e, null),
                    href: item.href,
                    target: "_blank"
                }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
                    id: "editor.help.how.to.use.blueprint",
                    values: {
                        blueprintType: blueprintTitle
                    }
                })));
        }
        return null;
    }, [
        blueprintType,
        formatMessage,
        onItemClick
    ]);
    const renderDevTools = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ $42omo.createElement((0, $bavCP.QueryInterop), {
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $gHANe.UserContextQuery)
        }, ({ data: data })=>{
            const atlassianStaff = (0, $bw3p5.isAtlassianStaff)(data);
            const showDevTools = ()=>setShouldShowDevTools?.(true);
            return atlassianStaff ? /*#__PURE__*/ $42omo.createElement((0, $56M4r.default), {
                onClick: onItemClick(null, showDevTools)
            }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
                id: "editor.help.dev-tools",
                defaultMessage: "Dev Tools"
            })) : null;
        });
    }, [
        setShouldShowDevTools,
        onItemClick
    ]);
    const renderExternalLinkItems = (0, $42omo.useMemo)(()=>{
        if (isTemplateEditor) return null;
        return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement((0, $cGtPE.default), {
            href: (0, $gi8bo.EDITOR_IMPROVEMENTS_URL),
            target: "_blank",
            iconAfter: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                color: "currentColor",
                label: formatMessage({
                    id: "help.name"
                })
            })
        }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
            id: "editor.help.updates"
        })), !isCompanyHub ? /*#__PURE__*/ $42omo.createElement((0, $cGtPE.default), {
            href: (0, $gi8bo.EDITOR_TEMPLATES_URL),
            target: "_blank",
            iconAfter: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                color: "currentColor",
                label: formatMessage({
                    id: "help.name"
                })
            })
        }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
            id: "editor.help.templates",
            defaultMessage: "Use page templates"
        })) : null);
    }, [
        isTemplateEditor,
        isCompanyHub,
        formatMessage
    ]);
    const renderNCSSynchronyIndicator = (0, $42omo.useMemo)(()=>/*#__PURE__*/ $42omo.createElement((0, $bavCP.QueryInterop), {
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $gHANe.UserContextQuery)
        }, ({ data: data })=>{
            const atlassianStaff = (0, $bw3p5.isAtlassianStaff)(data);
            if (!atlassianStaff) return null;
            if (isTemplateEditor) return null;
            const indicator = isNCSEditor ? /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
                id: "editor.help.dev-only-ncs-editor",
                defaultMessage: "DEV ONLY: NCS editor"
            }) : /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
                id: "editor.help.dev-only-synchrony-editor",
                defaultMessage: "DEV ONLY: Synchrony editor"
            });
            return /*#__PURE__*/ $42omo.createElement((0, $56M4r.default), null, indicator);
        }), [
        isNCSEditor,
        isTemplateEditor
    ]);
    const renderFeedbackItem = (0, $42omo.useMemo)(()=>{
        const openGlobalFeedbackCollector = ()=>{
            setShouldShowGlobalFeedbackCollector?.(true);
        };
        return /*#__PURE__*/ $42omo.createElement((0, $56M4r.default), {
            onClick: onItemClick(null, openGlobalFeedbackCollector)
        }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
            id: "editor-help.fabric.help.center.feedback.item",
            defaultMessage: "Feedback"
        }));
    }, [
        onItemClick,
        setShouldShowGlobalFeedbackCollector
    ]);
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": "help-menu-component",
        ref: setContainerRef,
        role: "menu",
        "aria-label": formatMessage({
            id: "editor-help.help.name",
            defaultMessage: "Help menu"
        }),
        ...(0, $6mKj3.expValEquals)('confluence_editor_help_menu_keyboard_a11y', 'isEnabled', true) && {
            onKeyDown: handleKeyDown,
            tabIndex: -1
        },
        className: (0, $gMc0m.default)([
            $9fef5514b8b73423$var$styles.base
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $2SlZp.default), {
        role: "none"
    }, /*#__PURE__*/ $42omo.createElement((0, $7rvPL.default), null, renderNCSSynchronyIndicator, renderDevTools, renderHelpShortcutDropDownItem, renderExternalLinkItems, renderHelpCenter, renderBlueprintTypeBasedDropdownItems, renderFeedbackItem)));
};

const $9fef5514b8b73423$export$c95a604f5f13c815 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "P9Lue",
    name: "HelpMenu",
    loader: async ()=>(await Promise.resolve(module.exports)).HelpMenuComponent
});
module.exports["HelpMenuComponent"] = $9fef5514b8b73423$export$d3e032c62ea2d293;
module.exports["HelpMenu"] = $9fef5514b8b73423$export$c95a604f5f13c815;

});

parcelRegister("bw3p5", function(module, exports) {
const $94cc6fb69dc46872$export$c447f2d04f7089f6 = (data)=>{
    return data?.user?.emails?.some((email)=>email?.value && (email.value.endsWith('@atlassian.com') || email.value.endsWith('@atlassian.com.invalid') || email.value.endsWith('@usersinbuckets.com'))) || false;
};
module.exports["isAtlassianStaff"] = $94cc6fb69dc46872$export$c447f2d04f7089f6;

});

parcelRegister("gHANe", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $d5213b14145490b2$export$4dfd297558414f12 = (0, $eSUdr.default)`query UserContextQuery{user:confluence_atlassianUser(current:true){id displayName emails{value isPrimary}}}`;
module.exports["UserContextQuery"] = $d5213b14145490b2$export$4dfd297558414f12;

});

parcelRegister("79V5c", function(module, exports) {
const $61ebe33edfdd9c82$export$8503f9d2928f9a64 = (parent, child)=>{
    let node = child.parentNode;
    while(node !== null){
        if (node === parent) return true;
        node = node.parentNode;
    }
    return false;
};
module.exports["isDescendant"] = $61ebe33edfdd9c82$export$8503f9d2928f9a64;

});

parcelRegister("gi8bo", function(module, exports) {
const $b321bf2443957350$export$94242db98fef807c = 'fabric-editor-onboarding-spotlight';
const $b321bf2443957350$export$29775c4096cc1552 = 'editor.help.center.spotlight.on.help.menu';
const $b321bf2443957350$export$d9e6ed86eee859f9 = 'https://confluence.atlassian.com/confcloud/confluence-editing-improvements-945107733.html';
const $b321bf2443957350$export$27957730b2c962c0 = 'https://confluence.atlassian.com/display/ConfCloud/Create+a+page+from+a+template';
const $b321bf2443957350$export$4b54359533b49a0a = {
    EDITING_IMPROVEMENTS: 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Editing+Improvements',
    MEETING_NOTES: 'https://www.atlassian.com/software/confluence/templates/meeting-notes',
    BLOGS_UPDATE: 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Editing+Improvements#ConfluenceEditingImprovements-blogposts',
    MEETING_NOTES_UPDATE: 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Editing+Improvements#ConfluenceEditingImprovements-meetingnotes'
};
const $b321bf2443957350$export$8ef3900260e04cce = {
    'meeting-notes': [
        {
            href: $b321bf2443957350$export$4b54359533b49a0a.MEETING_NOTES,
            title: 'editor.help.how.to.use.blueprint'
        }
    ]
};
const $b321bf2443957350$export$3e2a3fad4e0315ba = {
    'meeting-notes': 'content.kind.meeting-notes',
    decisions: 'content.kind.decisions',
    'kb-how-to-article': 'content.kind.kb-how-to-article',
    'file-list': 'content.kind.file-list',
    retrospective: 'content.kind.retrospective',
    requirements: 'content.kind.product-requirements',
    'shared-links': 'content.kind.shared-links',
    'kb-troubleshooting-article': 'content.kind.kb-troubleshooting-article',
    'task-report': 'content.kind.task-report',
    jirareport: 'content.kind.jirareport'
};
module.exports["HELP_MENU_SPOTLIGHT"] = $b321bf2443957350$export$29775c4096cc1552;
module.exports["EDITOR_IMPROVEMENTS_URL"] = $b321bf2443957350$export$d9e6ed86eee859f9;
module.exports["EDITOR_TEMPLATES_URL"] = $b321bf2443957350$export$27957730b2c962c0;
module.exports["CONTEXTUAL_EDITOR_HELP_LINKS"] = $b321bf2443957350$export$8ef3900260e04cce;
module.exports["PREDEFINED_BLUEPRINT_TYPES_TITLES"] = $b321bf2443957350$export$3e2a3fad4e0315ba;

});

parcelRegister("ep7kE", function(module, exports) {
/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage */ /*
This component represents the help center list item in the editor help menu
(currently in the bottom left of the editor view).

It is broken out as a component because of the need to add/remove a listener in
componentDidUpdate.
 */ 
var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $dAYOx = parcelRequire("dAYOx");


var $1DWH0 = parcelRequire("1DWH0");


var $giS6h = parcelRequire("giS6h");


var $3RNrC = parcelRequire("3RNrC");


var $gi8bo = parcelRequire("gi8bo");


var $29Qpd = parcelRequire("29Qpd");

const $763e12daea84475e$var$HelpMenuHelpCenterItemWithContext = (props)=>{
    const classicEditorContext = (0, $42omo.useContext)((0, $giS6h.ClassicEditorContext));
    const helpMenuClassicContext = (0, $42omo.useContext)((0, $3RNrC.HelpMenuClassicContext));
    // The next editor uses the ClassicEditorContext, while classic uses the HelpMenuClassicContext
    const { Changeboarding: Changeboarding } = classicEditorContext.Changeboarding ? classicEditorContext : helpMenuClassicContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($763e12daea84475e$var$HelpMenuHelpCenterItemClass, {
        ...props,
        Changeboarding: Changeboarding
    });
};
const $763e12daea84475e$var$HelpMenuHelpCenterItemClass = ({ closeHelpMenu: closeHelpMenu, createAnalyticsEvent: createAnalyticsEvent, Changeboarding: Changeboarding })=>{
    const [helpCenterSweetState, { openHelpCenter: openHelpCenter, hideHelpMenuSpotlight: hideHelpMenuSpotlight }] = (0, $29Qpd.useHelpMenuState)();
    const onOpenHelpCenter = ()=>{
        openHelpCenter();
        closeHelpMenu();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'helpMenuItemForEditorHelpCenter',
                source: 'editorHelpMenu'
            }
        }).fire();
    };
    /**
   * When the last changeboard in the current sequence is closed, call this
   * callback to set the state of the spotlight in helpCenterState.
   * @param helpCenterState
   */ const changeboardingFinished = ()=>{
        hideHelpMenuSpotlight();
        closeHelpMenu();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'spotlightForEditorHelpCenter',
                source: 'editor help menu spotlight'
            }
        }).fire();
    };
    const isHelpCenterOpen = helpCenterSweetState.isHelpCenterOpen;
    return helpCenterSweetState.shouldShowHelpMenuSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Changeboarding, {
        spotlightId: (0, $gi8bo.HELP_MENU_SPOTLIGHT),
        delaySpotlight: 200,
        changeboardFlowFinished: changeboardingFinished
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        isDisabled: isHelpCenterOpen,
        onClick: onOpenHelpCenter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "fabric.help.center.menuitem.title"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        testId: "help-center-menuitem-title",
        isDisabled: isHelpCenterOpen,
        onClick: onOpenHelpCenter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "fabric.help.center.menuitem.title"
    }));
};
const $763e12daea84475e$export$9fbf8d846e1f1108 = (0, $1DWH0.default)()($763e12daea84475e$var$HelpMenuHelpCenterItemWithContext);
module.exports["HelpMenuHelpCenterItem"] = $763e12daea84475e$export$9fbf8d846e1f1108;

});

parcelRegister("3RNrC", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d5243bcfa2782ca1$export$c6b672e180f71a34 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
module.exports["HelpMenuClassicContext"] = $d5243bcfa2782ca1$export$c6b672e180f71a34;

});

parcelRegister("29Qpd", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $cdc66bc83bc87cd7$var$initialState = {
    isHelpCenterOpen: false,
    isHelpCenterManuallyOpened: false,
    shouldShowHelpMenuSpotlight: null,
    isFeatureDiscovered: false
};
const $cdc66bc83bc87cd7$export$e324594224ef24da = {
    openHelpCenter: (isHelpCenterManuallyOpened = false)=>({ setState: setState })=>{
            setState({
                isHelpCenterOpen: true,
                isHelpCenterManuallyOpened: isHelpCenterManuallyOpened
            });
        },
    closeHelpCenter: ()=>({ setState: setState })=>{
            setState({
                isHelpCenterOpen: false,
                isHelpCenterManuallyOpened: false
            });
        },
    showHelpMenuSpotlight: ()=>({ setState: setState })=>{
            setState({
                shouldShowHelpMenuSpotlight: true
            });
        },
    hideHelpMenuSpotlight: ()=>({ setState: setState })=>{
            setState({
                shouldShowHelpMenuSpotlight: false
            });
        },
    setFeatureDiscovered: (discoveryState)=>({ setState: setState })=>{
            setState({
                isFeatureDiscovered: discoveryState
            });
        }
};
const $cdc66bc83bc87cd7$var$store = (0, $1P1Tu.createStore)({
    initialState: $cdc66bc83bc87cd7$var$initialState,
    actions: $cdc66bc83bc87cd7$export$e324594224ef24da
});
const $cdc66bc83bc87cd7$export$cfc41c159d64eee0 = (0, $9zUhf.createHook)($cdc66bc83bc87cd7$var$store);
const $cdc66bc83bc87cd7$export$e72a86a116ee4bad = (0, $9zUhf.createActionsHook)($cdc66bc83bc87cd7$var$store);
module.exports["useHelpMenuState"] = $cdc66bc83bc87cd7$export$cfc41c159d64eee0;
module.exports["useHelpMenuActions"] = $cdc66bc83bc87cd7$export$e72a86a116ee4bad;

});

parcelRegister("hQDqA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $81dy3 = parcelRequire("81dy3");


var $Uf8ZT = parcelRequire("Uf8ZT");


var $6ZneI = parcelRequire("6ZneI");


var $1wNUR = parcelRequire("1wNUR");

const $ebcc6a166a2bc753$export$fb51ab5e8dce5cd = (props)=>{
    const { contentId: contentId, version: version, isShowingOfflineBanner: isShowingOfflineBanner, spaceKey: spaceKey, editorActions: editorActions, setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded, handleTitleChange: handleTitleChange, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel } = props;
    const { isVisible: isVisible, setIsVisible: setIsVisible, isLandInEditorBannerShown: isLandInEditorBannerShown, showingOfflineBanner: showingOfflineBanner, onboardingStateData: onboardingStateData, onboardingStateError: onboardingStateError, deserializedData: deserializedData, editorOnboardingEligiblity: editorOnboardingEligiblity, wasDraftBannerSeen: wasDraftBannerSeen, labelsError: labelsError, hasQueryErrors: hasQueryErrors } = (0, $1wNUR.useOnboardingBannerLogic)({
        contentId: contentId,
        version: version,
        isShowingOfflineBanner: isShowingOfflineBanner,
        spaceKey: spaceKey,
        setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded
    });
    const { shouldHideFeatureForCfind3673: shouldHideFeatureForCfind3673, isLoading: isLoadingShouldHideFeatureForCfind3673 } = (0, $81dy3.useShouldHideFeatureForCfind3673)();
    // note: unauthorized errors are handled in the queries themselves
    if (onboardingStateError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: onboardingStateError
    });
    else if (labelsError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: labelsError
    });
    if (isLoadingShouldHideFeatureForCfind3673 || shouldHideFeatureForCfind3673) return null;
    if (!isVisible) {
        // TODO: Manage logic in a separate component https://hello.atlassian.net/browse/CONFONBO-1674
        // These are all conditions where we should not block the Editor Help Center from rendering
        const finishedLoading = // there are any errors in the queries
        onboardingStateError || labelsError || hasQueryErrors || // the user is not eligible for the experiment
        onboardingStateData && !editorOnboardingEligiblity || wasDraftBannerSeen;
        if (finishedLoading) setIsOnboardingBannerDataLoaded(true);
        return null;
    }
    const [BannerComponent, experienceName] = isLandInEditorBannerShown ? [
        (0, $6ZneI.LandInEditorBanner),
        (0, $irVI7.ONBOARDING_LAND_IN_EDITOR_BANNER_EXPERIENCE)
    ] : [
        (0, $Uf8ZT.EditorDraftBanner),
        (0, $irVI7.ONBOARDING_EDITOR_DRAFT_BANNER_EXPERIENCE)
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isLandInEditorBannerShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: experienceName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BannerComponent, {
        ...props,
        showingOfflineBanner: showingOfflineBanner,
        setIsVisible: setIsVisible,
        deserializedData: onboardingStateData && deserializedData,
        editorActions: editorActions,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        handleTitleChange: handleTitleChange
    }));
};
const $ebcc6a166a2bc753$export$d450ceafc6a31d4 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ebcc6a166a2bc753$export$fb51ab5e8dce5cd, props));
};
module.exports["OnboardingEditorBanner"] = $ebcc6a166a2bc753$export$d450ceafc6a31d4;

});

parcelRegister("81dy3", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $7ce2B = parcelRequire("7ce2B");

const $34f6dc7e03fb88c7$export$dff93228ce9847d9 = ()=>{
    const { templateOnboardingViewedTime: templateOnboardingViewedTime, isLoading: isLoading } = (0, $7ce2B.useGetTemplateOnboardingViewedTime)();
    if (isLoading) return {
        isLoading: true,
        shouldHideFeatureForCfind3673: undefined
    };
    const msSinceOnboardingViewed = Date.now() - templateOnboardingViewedTime;
    const daysSinceOnboardingViewed = Math.floor(msSinceOnboardingViewed / 86400000);
    const isFirstDayAfterTemplateOnboardingViewed = daysSinceOnboardingViewed === 0;
    const shouldHideFeatureForCfind3673 = isFirstDayAfterTemplateOnboardingViewed && // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
    (0, $6mKj3.UNSAFE_expValNoExposure)('cfind-3673-update-onboarding-for-template-signups', 'isTreatment', false);
    return {
        isLoading: isLoading,
        shouldHideFeatureForCfind3673: shouldHideFeatureForCfind3673
    };
};
module.exports["useShouldHideFeatureForCfind3673"] = $34f6dc7e03fb88c7$export$dff93228ce9847d9;

});

parcelRegister("7ce2B", function(module, exports) {

var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

const $89ae17dfeb2700c5$export$51c1a6087b7be3d9 = ()=>{
    const { data: onboardingStateData, loading: isLoading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).TEMPLATE_ONBOARDING_VIEWED_TIME
    ]);
    if (error) return {
        isLoading: false,
        templateOnboardingViewedTime: 0
    };
    if (isLoading) return {
        isLoading: isLoading,
        templateOnboardingViewedTime: 0
    };
    const { templateOnboardingViewedTime: templateOnboardingViewedTime } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const templateOnboardingViewedTimeNumber = +templateOnboardingViewedTime;
    return {
        isLoading: false,
        templateOnboardingViewedTime: Number.isNaN(templateOnboardingViewedTimeNumber) ? 0 : templateOnboardingViewedTimeNumber
    };
};
const $89ae17dfeb2700c5$export$ab4c942452c94059 = ()=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    return {
        setTemplateOnboardingViewedNow: ()=>{
            const now = Date.now().toString();
            setOnboardingState({
                key: (0, $dBcar.ONBOARDING_EXPERIENCES).TEMPLATE_ONBOARDING_VIEWED_TIME,
                value: now
            });
        }
    };
};
module.exports["useGetTemplateOnboardingViewedTime"] = $89ae17dfeb2700c5$export$51c1a6087b7be3d9;
module.exports["useSetTemplateOnboardingViewedTime"] = $89ae17dfeb2700c5$export$ab4c942452c94059;

});

parcelRegister("Uf8ZT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $hmuev = parcelRequire("hmuev");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ivb8S = parcelRequire("ivb8S");


var $5cryL = parcelRequire("5cryL");


var $2Csej = parcelRequire("2Csej");


var $lf5Wg = parcelRequire("lf5Wg");

const $3f811c71e472125a$var$i18n = (0, $cgtv4.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    bannerMessage: {
        id: "onboarding-editor.draft.banner",
        defaultMessage: "{boldedUnpublishedDraftText} Only you can see it until you publish it or give someone the link. {learnMoreLink}"
    },
    unpublishedDraftText: {
        id: "onboarding-editor.unpublished.draft",
        defaultMessage: "<b>This is an unpublished draft.</b>"
    },
    learnMore: {
        id: "onboarding-editor.learn.more",
        defaultMessage: "Learn more"
    }
});
const $3f811c71e472125a$export$b786d9c272de6a0b = (props)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, showingOfflineBanner: showingOfflineBanner, setIsVisible: setIsVisible, deserializedData: { wasDraftBannerSeen: wasDraftBannerSeen } = {}, setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $6mKj3.expValEquals)('cc_editor_ttvc_release_bundle_one', 'onboardingUseEffectFix', true)) {
            if (!wasDraftBannerSeen) {
                const editorNode = document.querySelector('.ak-editor-content-area');
                if (editorNode) editorNode.style.marginTop = '52px';
                return ()=>{
                    if (editorNode) editorNode.style.marginTop = '0';
                };
            }
        }
    }, [
        wasDraftBannerSeen
    ]);
    // Adjusting the margins after mount in this useEffect is causing a TTVC regression. Remove this useEffect after removing cc_editor_ttvc_release_bundle_one.
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('cc_editor_ttvc_release_bundle_one', 'onboardingUseEffectFix', true)) {
            if (!wasDraftBannerSeen) {
                const editorNode = document.querySelector('.ak-editor-content-area');
                if (editorNode) editorNode.style.marginTop = '52px';
                return ()=>{
                    if (editorNode) editorNode.style.marginTop = '0';
                };
            }
        }
    }, [
        wasDraftBannerSeen
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!wasDraftBannerSeen) {
            setOnboardingState([
                {
                    key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).WAS_DRAFT_BANNER_SEEN,
                    value: 'true'
                },
                {
                    key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).IS_DRAFT_BANNER_VISIBLE,
                    value: 'true'
                }
            ]);
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'onboardingEditorDraft'
                }
            }).fire();
            // TODO: Refactor https://hello.atlassian.net/browse/CONFONBO-1674
            setTimeout(()=>{
                setIsOnboardingBannerDataLoaded(true);
            }, 0);
        }
    }, [
        createAnalyticsEvent,
        setIsOnboardingBannerDataLoaded,
        setOnboardingState,
        wasDraftBannerSeen
    ]);
    const _onDismiss = ()=>{
        setIsVisible(false);
        // Move all the content back up 52px to adjust for the banner disappearing
        const editorNode = document.querySelector('.ak-editor-content-area');
        if (editorNode) editorNode.style.marginTop = '0px';
    };
    // compiled shouldn't handle a complicated runtime CSS, hence the inlined style
    const calculatedTop = (0, $42omo.useMemo)(()=>(0, $2Csej.getAdjustedTopPropertyValue)(showingOfflineBanner), [
        showingOfflineBanner
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lf5Wg.BannerContainer), {
        style: {
            top: calculatedTop
        },
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        "data-testid": "onboarding-editor-draft-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lf5Wg.Banner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$3f811c71e472125a$var$i18n.bannerMessage,
        values: {
            boldedUnpublishedDraftText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$3f811c71e472125a$var$i18n.unpublishedDraftText,
                values: {
                    b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
                }
            }),
            learnMoreLink: (0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__flywheel-adopt') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                href: "https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/",
                target: "_blank"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3f811c71e472125a$var$i18n.learnMore)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                href: "https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/",
                target: "_blank"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3f811c71e472125a$var$i18n.learnMore))
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lf5Wg.IconContainer), {
        "data-testid": "onboarding-editor-close-banner",
        onClick: _onDismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        label: "dismiss"
    }))));
};
module.exports["EditorDraftBanner"] = $3f811c71e472125a$export$b786d9c272de6a0b;

});

parcelRegister("2Csej", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");

const $962512f38cbacac9$export$4b0deb0da32f3c86 = (userOffline)=>{
    const offlineBannerHeight = 32;
    let toolbarHeight = (0, $aFUXX.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    if (userOffline) toolbarHeight = `calc(${toolbarHeight} + ${offlineBannerHeight}px)`;
    return toolbarHeight;
};
module.exports["getAdjustedTopPropertyValue"] = $962512f38cbacac9$export$4b0deb0da32f3c86;

});

parcelRegister("lf5Wg", function(module, exports) {
/* EditorDraftBannerStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ // File excluded from token migration due to dynamic nature
// https://atlassian.slack.com/archives/CFJ9DU39U/p1709665443238399

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $50c9ab69d3957b00$export$f316edcbf748c37b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71nm4 _v564rftg _4t3i1ex1 _kqswstnw _1ltvidpf _1pbyb4wl",
            __cmplp.isContentCreationPanelOpen ? "_1xi2nklw" : "_1xi2idpf",
            __cmplp.className
        ])
    });
});
const $50c9ab69d3957b00$export$3b4e64e77073e307 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41gu9 _kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1osq _y3gn1h6o _vchhusvi",
            __cmplp.className
        ])
    });
});
const $50c9ab69d3957b00$export$8f314e512d92575f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswstnw _1xi2v47k _154ipxbi _80omtlke _1pbyb4wl",
            __cmplp.className
        ])
    });
});
module.exports["BannerContainer"] = $50c9ab69d3957b00$export$f316edcbf748c37b;
module.exports["Banner"] = $50c9ab69d3957b00$export$3b4e64e77073e307;
module.exports["IconContainer"] = $50c9ab69d3957b00$export$8f314e512d92575f;

});

parcelRegister("6ZneI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $hmuev = parcelRequire("hmuev");


var $cOrQJ = parcelRequire("cOrQJ");


var $inPa6 = parcelRequire("inPa6");


var $u9agA = parcelRequire("u9agA");


var $eEA8O = parcelRequire("eEA8O");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $ivb8S = parcelRequire("ivb8S");


var $5cryL = parcelRequire("5cryL");


var $hl0fg = parcelRequire("hl0fg");


var $6mKj3 = parcelRequire("6mKj3");


var $2Csej = parcelRequire("2Csej");


var $2vb0O = parcelRequire("2vb0O");


var $2FB93 = parcelRequire("2FB93");

var $lf5Wg = parcelRequire("lf5Wg");


var $dz5dy = parcelRequire("dz5dy");


var $iiztD = parcelRequire("iiztD");


var $1e4h8 = parcelRequire("1e4h8");

const $f8787e8012c53a80$var$i18n = (0, $cgtv4.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    bannerTitle: {
        id: "onboarding-editor.land-in-editor.banner.title",
        defaultMessage: "There\u2019s a template for that"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    bannerDescription: {
        id: "onboarding-editor.land-in-editor.banner.description",
        defaultMessage: "Based on your responses, here\u2019s a template best suited to help you get started."
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    exploreCTA: {
        id: "onboarding-editor.land-in-editor.explore-templates",
        defaultMessage: "Explore all templates"
    },
    blankPageCTA: {
        id: "onboarding-editor.land-in-editor.blank-page",
        defaultMessage: "Start with a blank page"
    }
});
const $f8787e8012c53a80$export$8cf2982a68e0098c = (props)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, showingOfflineBanner: showingOfflineBanner, setIsVisible: setIsVisible, deserializedData: { isLandInEditorBannerVisible: isLandInEditorBannerVisible } = {}, setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded, editorActions: editorActions, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, handleTitleChange: handleTitleChange } = props;
    const { setHasLandInEditorBannerVisible: setHasLandInEditorBannerVisible } = (0, $dz5dy.useOnboardingEditorActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    (0, $42omo.useEffect)(()=>{
        if (isLandInEditorBannerVisible) {
            setOnboardingState([
                {
                    key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).IS_LAND_IN_EDITOR_BANNER_VISIBLE,
                    value: 'false'
                }
            ]);
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'landInEditorBanner'
                }
            }).fire();
            setHasLandInEditorBannerVisible(true);
        }
        // TODO: Refactor https://hello.atlassian.net/browse/CONFONBO-1674
        setTimeout(()=>{
            setIsOnboardingBannerDataLoaded(true);
        }, 0);
    }, [
        setOnboardingState,
        isLandInEditorBannerVisible,
        createAnalyticsEvent,
        setIsOnboardingBannerDataLoaded,
        setHasLandInEditorBannerVisible
    ]);
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    // Apply margin-top with useLayoutEffect (before paint). This prevents TTVC mutations.
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $6mKj3.expValEquals)('cc_editor_ttvc_release_bundle_one', 'onboardingUseEffectFix', true)) {
            const editorNode = document.querySelector('.ak-editor-content-area');
            // shift the editor content down for different banner breakpoints
            if (editorNode) {
                if (windowWidth <= 375) editorNode.style.marginTop = '300px';
                else if (windowWidth <= 1024 || isContentCreationPanelOpen && windowWidth <= 1024 + (0, $2FB93.templateSidebarWidth)) editorNode.style.marginTop = '291px';
                else editorNode.style.marginTop = '174px';
            }
            return ()=>{
                if (editorNode) editorNode.style.marginTop = '0';
            };
        }
    }, [
        windowWidth,
        isContentCreationPanelOpen
    ]);
    // Adjusting the margins after mount in this useEffect is causing a TTVC regression. Remove this useEffect after removing cc_editor_ttvc_release_bundle_one.
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('cc_editor_ttvc_release_bundle_one', 'onboardingUseEffectFix', true)) {
            const editorNode = document.querySelector('.ak-editor-content-area');
            // shift the editor content down for different banner breakpoints
            if (editorNode) {
                if (windowWidth <= 375) editorNode.style.marginTop = '300px';
                else if (windowWidth <= 1024 || isContentCreationPanelOpen && windowWidth <= 1024 + (0, $2FB93.templateSidebarWidth)) editorNode.style.marginTop = '291px';
                else editorNode.style.marginTop = '174px';
            }
            return ()=>{
                if (editorNode) editorNode.style.marginTop = '0';
            };
        }
    }, [
        windowWidth,
        isContentCreationPanelOpen
    ]);
    const handleExploreCTA = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lieBannerExploreTemplates',
                source: 'landInEditorBanner'
            }
        }).fire();
        onClickOpenContentCreationPanel();
        setIsVisible(false);
    };
    const handleBlankPageCTA = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lieBannerBlankPage',
                source: 'landInEditorBanner'
            }
        }).fire();
        onClickOpenContentCreationPanel();
        editorActions.clear();
        setIsVisible(false);
        handleTitleChange('');
    };
    const _onDismiss = ()=>{
        // this will start the animation, and onAnimationEnd we should hide the component
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lieBannerDismiss',
                source: 'landInEditorBanner'
            }
        }).fire();
        setIsVisible(false);
    };
    // compiled shouldn't handle a complicated runtime CSS, hence the inlined style
    const calculatedTop = (0, $42omo.useMemo)(()=>(0, $2Csej.getAdjustedTopPropertyValue)(showingOfflineBanner), [
        showingOfflineBanner
    ]);
    const theme = (0, $cOrQJ.default)();
    const backgroundImageUrl = theme.colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($1e4h8))) : (0, (/*@__PURE__*/$parcel$interopDefault($iiztD)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2FB93.TemplateBannerContainer), {
        style: {
            top: calculatedTop,
            backgroundImage: `url(${backgroundImageUrl})`
        },
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        "data-testid": "onboarding-land-in-editor-banner",
        fade: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2FB93.LeftWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2vb0O.TemplateBannerIllustration), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2FB93.RightWrapper), {
        isContentCreationPanelOpen: isContentCreationPanelOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2FB93.TitleWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f8787e8012c53a80$var$i18n.bannerTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2FB93.BodyWrapper), {
        isContentCreationPanelOpen: isContentCreationPanelOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f8787e8012c53a80$var$i18n.bannerDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2FB93.StyledButton), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: 'fit-content'
        },
        onClick: handleExploreCTA
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f8787e8012c53a80$var$i18n.exploreCTA)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: handleBlankPageCTA
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f8787e8012c53a80$var$i18n.blankPageCTA)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lf5Wg.IconContainer), {
        "data-testid": "onboarding-land-in-editor-banner-close",
        onClick: _onDismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        label: "dismiss"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.ONBOARDING_LAND_IN_EDITOR_BANNER_EXPERIENCE)
    }));
};
module.exports["LandInEditorBanner"] = $f8787e8012c53a80$export$8cf2982a68e0098c;

});

parcelRegister("hl0fg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

const $9b206d933744c82f$export$42c02f33970a2afa = ()=>{
    const isClient = typeof window === 'object';
    const getSize = ()=>{
        return {
            width: isClient ? window.innerWidth : 0,
            height: isClient ? window.innerHeight : 0
        };
    };
    const [windowSize, setWindowSize] = (0, $42omo.useState)(getSize);
    (0, $42omo.useEffect)(()=>{
        const handleResize = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setWindowSize(getSize());
        }, 200);
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
            handleResize.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
};
module.exports["useWindowSize"] = $9b206d933744c82f$export$42c02f33970a2afa;

});

parcelRegister("2vb0O", function(module, exports) {
/* TemplateBannerIllustration.tsx generated by @compiled/babel-plugin v0.36.1 */ // File excluded from token migration due to custom illustration
// https://atlassian.slack.com/archives/CFJ9DU39U/p1709665443238399

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gj7hi = parcelRequire("gj7hi");


var $k29GF = parcelRequire("k29GF");


var $9YG2V = parcelRequire("9YG2V");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $936e99c91b0f8b74$var$IllustrationContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko14xi _n7zljaz9 _1bsbp2n4 _4t3i1w81 _19pk1ejb _bfhkvuon _3okf1ejb _534poahv",
            __cmplp.className
        ])
    });
});
const $936e99c91b0f8b74$export$f60cdccc39dd0674 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($936e99c91b0f8b74$var$IllustrationContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9YG2V))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($k29GF))),
        alt: "",
        testId: "template-banner-illustration"
    }));
};
module.exports["TemplateBannerIllustration"] = $936e99c91b0f8b74$export$f60cdccc39dd0674;

});

parcelRegister("k29GF", function(module, exports) {
module.exports = new URL("LandInEditorIllustrationDark.2f9f7913.svg", import.meta.url).toString();

});

parcelRegister("9YG2V", function(module, exports) {
module.exports = new URL("LandInEditorIllustrationLight.28460c36.svg", import.meta.url).toString();

});

parcelRegister("2FB93", function(module, exports) {
/* EditorTemplateBannerStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ // File excluded from token migration due to dynamic nature
// https://atlassian.slack.com/archives/CFJ9DU39U/p1709665443238399

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");

const $4923552e618c34e5$export$edc250a38d698468 = 320;
const $4923552e618c34e5$var$shrinkUp = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$37a12d5fd88d0bab = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, fade: fade, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4t3ic4ae _1lrw1dfr _12vemgnk _kqswstnw _1ltvidpf _1pbyb4wl _l60l1sxn _1gwz14u9 _n7es1mjv",
            __cmplp.isContentCreationPanelOpen ? "_1xi2nklw" : "_1xi2idpf",
            __cmplp.isContentCreationPanelOpen && "_16q81sxn",
            __cmplp.isContentCreationPanelOpen && "_1dwk14u9",
            __cmplp.fade && "",
            __cmplp.fade && "_y44v1m2i",
            __cmplp.className
        ])
    });
});
const $4923552e618c34e5$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_nup9u5tj _1w901gfe _w1ap146b _ge1rfqeg _1fh11gfe _r7sm1f1m _1l5a1gfe",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$c3d2343a748f64d3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _kqswh2mm _4t3i1osq _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$8e62e599821d99ec = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1bah1y6m _ca0q1ejb _1nzlidpf _1w22idpf _n71r1wug _1lzu1ejb _1ehg1ejb",
            __cmplp.isContentCreationPanelOpen && "_c5lf1tcg",
            __cmplp.isContentCreationPanelOpen && "_yy4t1tcg",
            __cmplp.isContentCreationPanelOpen && "_1oz9idpf _sxtsidpf _33eu1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$585a3b23e887288b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8lodh _syazi7uo _otyr1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$14966827497f4695 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c82smr _syazi7uo _otyrpxbi _1bsb1osq _1i4q1hna _slp31hna _p12f13jv _1428glyw",
            __cmplp.isContentCreationPanelOpen && "_5aflglyw",
            __cmplp.className
        ])
    });
});
module.exports["templateSidebarWidth"] = $4923552e618c34e5$export$edc250a38d698468;
module.exports["TemplateBannerContainer"] = $4923552e618c34e5$export$37a12d5fd88d0bab;
module.exports["StyledButton"] = $4923552e618c34e5$export$2d5d2ba3c7c8c40b;
module.exports["LeftWrapper"] = $4923552e618c34e5$export$c3d2343a748f64d3;
module.exports["RightWrapper"] = $4923552e618c34e5$export$8e62e599821d99ec;
module.exports["TitleWrapper"] = $4923552e618c34e5$export$585a3b23e887288b;
module.exports["BodyWrapper"] = $4923552e618c34e5$export$14966827497f4695;

});

parcelRegister("dz5dy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $f3a77a444e363c9b$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        /**
		 * The user has published their first page ever in the current session
		 * If they publish more than one page, this condition is invalidated
		 */ hasMetPublishNudgeConditions: false,
        hasLandInEditorBannerVisible: false
    },
    actions: {
        setHasMetPublishNudgeConditions: (hasMetPublishNudgeConditions)=>({ setState: setState })=>{
                setState({
                    hasMetPublishNudgeConditions: hasMetPublishNudgeConditions
                });
            },
        setHasLandInEditorBannerVisible: (hasLandInEditorBannerVisible)=>({ setState: setState })=>{
                setState({
                    hasLandInEditorBannerVisible: hasLandInEditorBannerVisible
                });
            }
    },
    name: 'useOnboardingEditorState'
});
const $f3a77a444e363c9b$export$b4e2284668311d45 = (0, $9zUhf.createStateHook)($f3a77a444e363c9b$var$Store, {
    selector: (state)=>({
            hasMetPublishNudgeConditions: state.hasMetPublishNudgeConditions,
            hasLandInEditorBannerVisible: state.hasLandInEditorBannerVisible
        })
});
const $f3a77a444e363c9b$export$e1d5565bc8c0d054 = (0, $9zUhf.createActionsHook)($f3a77a444e363c9b$var$Store);
module.exports["useOnboardingEditorState"] = $f3a77a444e363c9b$export$b4e2284668311d45;
module.exports["useOnboardingEditorActions"] = $f3a77a444e363c9b$export$e1d5565bc8c0d054;

});

parcelRegister("iiztD", function(module, exports) {
module.exports = new URL("LandInEditorBannerBackgroundLight.5f156b32.svg", import.meta.url).toString();

});

parcelRegister("1e4h8", function(module, exports) {
module.exports = new URL("LandInEditorBannerBackgroundDark.f8ccb0f3.svg", import.meta.url).toString();

});

parcelRegister("1wNUR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gci8t = parcelRequire("gci8t");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");


var $66Dsm = parcelRequire("66Dsm");


var $bQm3c = parcelRequire("bQm3c");

const $550262a7e0b7f3e1$var$DELAY_TIMEOUT = 3000;
const $550262a7e0b7f3e1$export$d80357b11b6fd623 = ({ contentId: contentId, version: version, isShowingOfflineBanner: isShowingOfflineBanner, spaceKey: spaceKey, setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded })=>{
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [isLandInEditorBannerShown, setIsLandInEditorBannerShown] = (0, $42omo.useState)(false);
    const [showingOfflineBanner, setShowingOfflineBanner] = (0, $42omo.useState)(false);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)), version !== 1 && version?.number !== 1);
    const deserializedData = (0, $ivb8S.deserializeState)(onboardingStateData);
    const { editorOnboardingEligiblity: editorOnboardingEligiblity, wasDraftBannerSeen: wasDraftBannerSeen, isLandInEditorBannerVisible: isLandInEditorBannerVisible } = deserializedData;
    // Only check the labels, if they are eligible for the tutorial experiment to begin with.
    const skip = !onboardingStateData || onboardingStateLoading || Boolean(onboardingStateError) || /* Check to see if they are a new user */ !editorOnboardingEligiblity || isLandInEditorBannerVisible; //Skip if user is eligible for Land In Editor Banner
    const { isTemplate: isTemplate, isOnboardingTemplate: isOnboardingTemplate, labelsData: labelsData, labelsLoading: labelsLoading, labelsError: labelsError } = (0, $gci8t.useCheckIfOnboardingEditorTemplate)({
        contentId: contentId,
        skip: skip
    });
    const { shouldIncludeEditorTutorialTemplate: shouldIncludeEditorTutorialTemplate, hasQueryErrors: hasQueryErrors } = (0, $66Dsm.useIncludeEditorTutorialTemplate)();
    // Connection banner height has a delay to appear, adjust the draft banner height to reflect this delay
    (0, $42omo.useEffect)(()=>{
        const delayTimeout = setTimeout(()=>setShowingOfflineBanner(isShowingOfflineBanner), $550262a7e0b7f3e1$var$DELAY_TIMEOUT);
        return ()=>clearTimeout(delayTimeout);
    }, [
        isShowingOfflineBanner
    ]);
    (0, $42omo.useEffect)(()=>{
        if (labelsData && !labelsLoading) {
            // the original onboarding template should not have the draft banner
            if (isOnboardingTemplate || !shouldIncludeEditorTutorialTemplate) {
                setIsOnboardingBannerDataLoaded(true);
                return;
            }
            if (!wasDraftBannerSeen) setIsVisible(true);
        // land in editor banner has no labelsData
        } else if (isLandInEditorBannerVisible) {
            setIsVisible(true);
            setIsLandInEditorBannerShown(true);
        }
    }, [
        isOnboardingTemplate,
        isTemplate,
        labelsData,
        labelsLoading,
        locale,
        shouldIncludeEditorTutorialTemplate,
        setIsOnboardingBannerDataLoaded,
        spaceKey,
        wasDraftBannerSeen,
        isLandInEditorBannerVisible
    ]);
    return {
        isVisible: isVisible,
        setIsVisible: setIsVisible,
        isLandInEditorBannerShown: isLandInEditorBannerShown,
        showingOfflineBanner: showingOfflineBanner,
        onboardingStateData: onboardingStateData,
        onboardingStateLoading: onboardingStateLoading,
        onboardingStateError: onboardingStateError,
        deserializedData: deserializedData,
        editorOnboardingEligiblity: editorOnboardingEligiblity,
        wasDraftBannerSeen: wasDraftBannerSeen,
        isLandInEditorBannerVisible: isLandInEditorBannerVisible,
        isTemplate: isTemplate,
        isOnboardingTemplate: isOnboardingTemplate,
        labelsData: labelsData,
        labelsLoading: labelsLoading,
        labelsError: labelsError,
        shouldIncludeEditorTutorialTemplate: shouldIncludeEditorTutorialTemplate,
        hasQueryErrors: hasQueryErrors
    };
};
module.exports["useOnboardingBannerLogic"] = $550262a7e0b7f3e1$export$d80357b11b6fd623;

});

parcelRegister("gci8t", function(module, exports) {

var $j1Ss3 = parcelRequire("j1Ss3");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $5cryL = parcelRequire("5cryL");


var $cQ5By = parcelRequire("cQ5By");

const $36eef014bcae96ba$export$9870b3b3798cc923 = ({ contentId: contentId, skip: skip })=>{
    const { data: labelsData, loading: labelsLoading, error: labelsError } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $cQ5By.LabelsQuery), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        skip: skip
    });
    const labels = labelsData?.content?.nodes?.[0]?.labels?.nodes || [];
    const sourceTemplateEntityId = labelsData?.content?.nodes?.[0]?.metadata?.sourceTemplateEntityId || undefined;
    // If the current editor is NOT the onboarding editor tutorial, show the draft banner.
    const isOnboardingTemplate = Boolean(labels.find((label)=>label?.label === (0, $5cryL.ONBOARDING_TUTORIAL_LABEL)));
    if (labelsError && (0, $1uFM6.isUnauthorizedError)(labelsError)) (0, $7Sm4c.markErrorAsHandled)(labelsError);
    return {
        isTemplate: !!sourceTemplateEntityId,
        isOnboardingTemplate: isOnboardingTemplate,
        labelsData: labelsData,
        labelsLoading: labelsLoading,
        labelsError: labelsError
    };
};
module.exports["useCheckIfOnboardingEditorTemplate"] = $36eef014bcae96ba$export$9870b3b3798cc923;

});

parcelRegister("cQ5By", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f25f5641eac8f6ae$export$8f13056fc1e2a814 = (0, $eSUdr.default)`query OnboardingLabelsQuery($contentId:ID!$status:[String]){content(id:$contentId status:$status){nodes{id labels{nodes{id label}}metadata{sourceTemplateEntityId}}}}`;
module.exports["LabelsQuery"] = $f25f5641eac8f6ae$export$8f13056fc1e2a814;

});

parcelRegister("66Dsm", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");


var $bQm3c = parcelRequire("bQm3c");


var $1JEqL = parcelRequire("1JEqL");

const $13240525381ea71e$export$10e7c37d48e20bae = 11;
const $13240525381ea71e$export$d227e9a2756e8472 = 7;
const $13240525381ea71e$export$d18f171722e15763 = ()=>{
    const { isLicensed: isLicensed, userId: userId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { data: editorOnboardingData, loading: editorOnboardingLoading, error: editorOnboardingError } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)));
    const { data: userContentData, loading: userContentLoading, error: userContentError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useIncludeEditorTutorialTemplateGetUserContentQuery($cql:String!){search:confluence_search(cql:$cql first:12){count}isSiteAdmin}`, {
        variables: {
            cql: `type = 'page' AND creator = '${userId}'`
        },
        skip: !isLicensed || !isLoggedIn
    });
    const { data: privilegeData, loading: privilegeLoading, error: privilegeError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useIncludeEditorTutorialTemplateGetUserPrivilegesQuery{user:confluence_atlassianUser(current:true){id confluence{operations{operation targetType}}}isSiteAdmin hasUserAccessAdminRole}`);
    // Onboarding related variables
    const deserializedEditorOnboardingState = (0, $ivb8S.deserializeState)(editorOnboardingData);
    const { editorOnboardingEligiblity: editorOnboardingEligiblity } = deserializedEditorOnboardingState;
    const queriesLoadingOrErrored = editorOnboardingLoading || Boolean(editorOnboardingError) || userContentLoading || Boolean(userContentError) || privilegeLoading || Boolean(privilegeError);
    const isProductOrSiteAdmin = (0, $1JEqL.getIsProductOrSiteAdminFromQuery)(privilegeData);
    const hasQueryErrors = Boolean(editorOnboardingError) || Boolean(userContentError) || Boolean(privilegeError);
    // Admins get automatically created 9 pages, while Nth users only get created 5.
    const publishedPagesThreshold = isProductOrSiteAdmin ? $13240525381ea71e$export$10e7c37d48e20bae : $13240525381ea71e$export$d227e9a2756e8472;
    // If there is no data on how many pages they published, then assume that the template shouldn't be visible.
    const numberOfPagesPublished = userContentData?.search?.count ?? publishedPagesThreshold;
    const shouldIncludeEditorTutorialTemplate = !queriesLoadingOrErrored && // Show the template if onboarding state is not loading / has an error
    Boolean(editorOnboardingEligiblity) && // Has to be onboarding eligible (new user)
    numberOfPagesPublished < publishedPagesThreshold; // Don't show if they have published 2 pages (excluding the auto-generated pages)
    return {
        shouldIncludeEditorTutorialTemplate: shouldIncludeEditorTutorialTemplate,
        userContentError: userContentError,
        editorOnboardingError: editorOnboardingError,
        privilegeError: privilegeError,
        isProductOrSiteAdmin: isProductOrSiteAdmin,
        queriesLoadingOrErrored: queriesLoadingOrErrored,
        hasQueryErrors: hasQueryErrors
    };
};
module.exports["useIncludeEditorTutorialTemplate"] = $13240525381ea71e$export$d18f171722e15763;

});

parcelRegister("i4dNk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");

const $0451aea256d3610a$export$5ff0b879ab65d0b0 = 'd1';
const $0451aea256d3610a$export$46c1c92549715335 = 'loading';
const $0451aea256d3610a$export$61c0af74ec47d243 = 'd0';
const $0451aea256d3610a$export$f883a24d5edde77c = 'none';
const $0451aea256d3610a$export$a226a5c24cc00b77 = (updateState = false)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { cohort: cohort, delayInMinutes: delayInMinutes } = $0451aea256d3610a$var$getExperimentData();
    const hasUpdatedState = (0, $42omo.useRef)(false);
    const isInExperimentControl = cohort !== 'treatment';
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
        (0, $dBcar.CREATION_FOCUSED_NAV_START_TIME)
    ], isInExperimentControl);
    const spotlightShown = ()=>{
        setOnboardingState({
            key: (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
            value: 'false'
        });
    };
    if (isInExperimentControl) return {
        isSpotlightVisible: false,
        areBannersHidden: false,
        navCustomization: $0451aea256d3610a$export$f883a24d5edde77c
    };
    if (onboardingStateLoading) // Simplify nav and hide banners while loading, to minimize flashing
    return {
        isSpotlightVisible: false,
        areBannersHidden: true,
        navCustomization: $0451aea256d3610a$export$46c1c92549715335
    };
    if (onboardingStateError) // Control behavior if there are any errors
    return {
        isSpotlightVisible: false,
        areBannersHidden: false,
        navCustomization: $0451aea256d3610a$export$f883a24d5edde77c
    };
    const { shouldShowSpotlight: shouldShowSpotlight, startTime: startTime } = (0, $ivb8S.deserializeState)(onboardingStateData);
    if ($0451aea256d3610a$var$isSiteOlderThanDelay(delayInMinutes, startTime)) {
        if (shouldShowSpotlight) // Spotlight ready to show --> Show spotlight, bring nav features back, but don't bring banners back
        return {
            isSpotlightVisible: true,
            areBannersHidden: true,
            navCustomization: $0451aea256d3610a$export$5ff0b879ab65d0b0,
            onSpotlightShown: spotlightShown
        };
        else if (shouldShowSpotlight === false) // Spotlight has already shown --> Don't show spotlight, bring nav features back, but don't bring banners back
        return {
            isSpotlightVisible: false,
            areBannersHidden: true,
            navCustomization: $0451aea256d3610a$export$5ff0b879ab65d0b0
        };
        // This account was created before the experiment started, so we won't change anything even though statsig returned "treatment"
        return {
            isSpotlightVisible: false,
            areBannersHidden: false,
            navCustomization: $0451aea256d3610a$export$f883a24d5edde77c
        };
    } else if (shouldShowSpotlight === undefined && updateState && !hasUpdatedState.current) {
        hasUpdatedState.current = true;
        setOnboardingState({
            key: (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
            value: 'true'
        });
    }
    return {
        isSpotlightVisible: false,
        areBannersHidden: true,
        navCustomization: $0451aea256d3610a$export$61c0af74ec47d243
    };
};
const $0451aea256d3610a$var$getExperimentData = ()=>{
    // eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
    const [expConfig] = (0, $6mKj3.UNSAFE_noExposureExp)('cfind-4473-creation-focused-nav'); // Experiment exposure is fired in the backend
    const cohort = expConfig.get('cohort', 'control');
    const minutesPerHour = 60;
    const hoursPerDay = 24;
    const defaultDelayInMinutes = minutesPerHour * hoursPerDay;
    const delayInMinutes = expConfig.get('delayInMinutes', defaultDelayInMinutes.toString());
    return {
        cohort: cohort,
        delayInMinutes: parseInt(delayInMinutes)
    };
};
const $0451aea256d3610a$var$isSiteOlderThanDelay = (delayInMinutes, siteActivationDateString)=>{
    if (!siteActivationDateString) return true; // If site has no activation date, assume it is old
    const siteActivationDateNumber = Number(siteActivationDateString);
    const siteActivationDate = new Date(siteActivationDateNumber ?? '');
    if (isNaN(siteActivationDate.getTime())) return true; // If site has no activation date, assume it is old
    const createdAtTimestamp = siteActivationDate.getTime();
    const millisecondsSinceCreation = Date.now() - createdAtTimestamp;
    const secondsPerMinute = 60;
    const millisecondsPerSecond = 1000;
    const millisecondsInDelayTime = delayInMinutes * secondsPerMinute * millisecondsPerSecond;
    return millisecondsSinceCreation > millisecondsInDelayTime;
};
module.exports["d1"] = $0451aea256d3610a$export$5ff0b879ab65d0b0;
module.exports["loading"] = $0451aea256d3610a$export$46c1c92549715335;
module.exports["d0"] = $0451aea256d3610a$export$61c0af74ec47d243;
module.exports["useCfind4473CreationFocusedNav"] = $0451aea256d3610a$export$a226a5c24cc00b77;

});

parcelRegister("eLnQS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");

const $5e22f724447894e7$export$367f35882b7b4a5b = ()=>{
    // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    return (0, $42omo.useMemo)(()=>({
            'table-drag-and-drop': (0, $6mKj3.expVal)('platform_editor_tables_drag_and_drop', 'isEnabled', false),
            'table-selector': (0, $6mKj3.expVal)('platform_editor_tables_table_selector', 'isEnabled', false),
            'macro-interaction-updates': true,
            'table-with-fixed-column-widths-option': true,
            'more-elements-in-quick-insert-view': true
        }), []);
};
module.exports["useEditorFullPageExperiments"] = $5e22f724447894e7$export$367f35882b7b4a5b;

});

parcelRegister("7vJCW", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3bfd7e130592105d$export$18f927573c4993d5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-VTjB",
    name: "EditorBreadcrumbs",
    loader: async ()=>{
        const { EditorBreadcrumbsComponent: EditorBreadcrumbsComponent } = await (parcelRequire("3cFXU"));
        return EditorBreadcrumbsComponent;
    }
});
module.exports["EditorBreadcrumbs"] = $3bfd7e130592105d$export$18f927573c4993d5;

});

parcelRegister("3cFXU", function(module, exports) {

let $25530b836bdd55cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $25530b836bdd55cc$var$load("g7g2y"),
    $25530b836bdd55cc$var$load("6wr18"),
    $25530b836bdd55cc$var$load("lPQcc"),
    $25530b836bdd55cc$var$load("ffEVr"),
    $25530b836bdd55cc$var$load("jXx9i"),
    $25530b836bdd55cc$var$load("9ftJe"),
    $25530b836bdd55cc$var$load("hhss7"),
    $25530b836bdd55cc$var$load("aIkc8")
]).then(()=>parcelRequire('aNZDi'));

});

parcelRegister("5RPbY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9ee3ba3f5fa2cebc$export$b00e22884b6dd9a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1hM5R",
    name: "EditorAppearanceButtonNext",
    loader: async ()=>{
        const { EditorAppearanceButtonNext: EditorAppearanceButtonNext } = await (parcelRequire("hbcfL"));
        return EditorAppearanceButtonNext;
    }
});
module.exports["EditorAppearanceButtonNext"] = $9ee3ba3f5fa2cebc$export$b00e22884b6dd9a;

});

parcelRegister("hbcfL", function(module, exports) {

let $c81cf802c96f79e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c81cf802c96f79e1$var$load("6wr18"),
    $c81cf802c96f79e1$var$load("dlm6q"),
    $c81cf802c96f79e1$var$load("ffEVr"),
    $c81cf802c96f79e1$var$load("7GtpA")
]).then(()=>parcelRequire('Vjn6T'));

});

parcelRegister("ausiN", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");

const $8793d7ec6175f186$var$bylineStyles = (0, $ecnYn.xcss)({
    height: '32px' // this value MUST match the fixed height of the LivePagesBylineStyledMainDiv in PresentationalComponents.tsx
});
const $8793d7ec6175f186$var$circleStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.skeleton',
    width: '20px',
    height: '20px',
    borderRadius: 'radius.full',
    margin: 'space.025'
});
const $8793d7ec6175f186$var$lineStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.skeleton',
    width: '100px',
    height: '16px',
    borderRadius: 'radius.xsmall'
});
const $8793d7ec6175f186$export$391f24cd221656e1 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center",
            gap: "space.050",
            xcss: $8793d7ec6175f186$var$bylineStyles,
            testId: "live-pages-by-line-placeholder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $8793d7ec6175f186$var$circleStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $8793d7ec6175f186$var$lineStyles
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.050",
        xcss: $8793d7ec6175f186$var$bylineStyles,
        testId: "live-pages-by-line-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $8793d7ec6175f186$var$circleStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $8793d7ec6175f186$var$lineStyles
    }));
};
module.exports["LivePagesByLinePlaceholderComponent"] = $8793d7ec6175f186$export$391f24cd221656e1;

});

parcelRegister("abFjU", function(module, exports) {

let $76aafbcaf4a96720$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $76aafbcaf4a96720$var$load("2mt3f"),
    $76aafbcaf4a96720$var$load("jFI2g"),
    $76aafbcaf4a96720$var$load("4tiwv"),
    $76aafbcaf4a96720$var$load("dlm6q"),
    $76aafbcaf4a96720$var$load("4XFRu"),
    $76aafbcaf4a96720$var$load("hhss7"),
    $76aafbcaf4a96720$var$load("eK94l")
]).then(()=>parcelRequire('8fb5x'));

});

parcelRegister("9iTNj", function(module, exports) {
/* TitleAreaContentComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jmjWc = parcelRequire("jmjWc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $554a9c527b7ebc79$var$EmptyTitleArea = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTemplateEditor: isTemplateEditor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq",
            __cmplp.isTemplateEditor ? "_4t3ibi2l" : "_4t3i1nlq",
            __cmplp.className
        ])
    });
});

const $554a9c527b7ebc79$export$24c87f0cb1dfb811 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-4zEr",
    name: "TitleAreaContentComponents",
    loader: async ()=>(await (parcelRequire("kZ6Q6"))).TitleAreaContentComponents,
    loading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($554a9c527b7ebc79$var$EmptyTitleArea, {
            isTemplateEditor: props.isTemplateEditor
        })
});

const $554a9c527b7ebc79$export$94a078f0640d9238 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JPi6Y",
    name: "SmartCreateTitleAreaContentComponents",
    loader: async ()=>(await (parcelRequire("bj0WU"))).SmartCreateTitleAreaContentComponents,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($554a9c527b7ebc79$var$EmptyTitleArea, null)
});
module.exports["TitleAreaContentComponents"] = $554a9c527b7ebc79$export$24c87f0cb1dfb811;

});

parcelRegister("kZ6Q6", function(module, exports) {

let $f46ecf485e028ad6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f46ecf485e028ad6$var$load("5U3YO"),
    $f46ecf485e028ad6$var$load("6wr18"),
    $f46ecf485e028ad6$var$load("4pDu6"),
    $f46ecf485e028ad6$var$load("dlm6q"),
    $f46ecf485e028ad6$var$load("lnnYm"),
    $f46ecf485e028ad6$var$load("1Jgsw"),
    $f46ecf485e028ad6$var$load("4eboO"),
    $f46ecf485e028ad6$var$load("ffiE4"),
    $f46ecf485e028ad6$var$load("5zDuS"),
    $f46ecf485e028ad6$var$load("9ijrN"),
    $f46ecf485e028ad6$var$load("7EorR"),
    $f46ecf485e028ad6$var$load("awqCy"),
    $f46ecf485e028ad6$var$load("kHOMt"),
    $f46ecf485e028ad6$var$load("jXx9i"),
    $f46ecf485e028ad6$var$load("fZt2F"),
    $f46ecf485e028ad6$var$load("7u4WP"),
    $f46ecf485e028ad6$var$load("dS0Pr"),
    $f46ecf485e028ad6$var$load("huYla"),
    $f46ecf485e028ad6$var$load("amUNi"),
    $f46ecf485e028ad6$var$load("2haIE"),
    $f46ecf485e028ad6$var$load("9K4jq"),
    $f46ecf485e028ad6$var$load("let0D"),
    $f46ecf485e028ad6$var$load("2bmVk"),
    $f46ecf485e028ad6$var$load("ffEVr"),
    $f46ecf485e028ad6$var$load("g7g2y"),
    $f46ecf485e028ad6$var$load("hhss7"),
    $f46ecf485e028ad6$var$load("7Omhy"),
    $f46ecf485e028ad6$var$load("kC80R"),
    $f46ecf485e028ad6$var$load("hbc6v")
]).then(()=>parcelRequire('bbYj5'));

});

parcelRegister("bj0WU", function(module, exports) {

let $83b23485bc47439e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $83b23485bc47439e$var$load("5U3YO"),
    $83b23485bc47439e$var$load("6wr18"),
    $83b23485bc47439e$var$load("4pDu6"),
    $83b23485bc47439e$var$load("dlm6q"),
    $83b23485bc47439e$var$load("1Jgsw"),
    $83b23485bc47439e$var$load("4eboO"),
    $83b23485bc47439e$var$load("ffiE4"),
    $83b23485bc47439e$var$load("5zDuS"),
    $83b23485bc47439e$var$load("9ijrN"),
    $83b23485bc47439e$var$load("7EorR"),
    $83b23485bc47439e$var$load("awqCy"),
    $83b23485bc47439e$var$load("jXx9i"),
    $83b23485bc47439e$var$load("fZt2F"),
    $83b23485bc47439e$var$load("7u4WP"),
    $83b23485bc47439e$var$load("dS0Pr"),
    $83b23485bc47439e$var$load("huYla"),
    $83b23485bc47439e$var$load("amUNi"),
    $83b23485bc47439e$var$load("2haIE"),
    $83b23485bc47439e$var$load("9K4jq"),
    $83b23485bc47439e$var$load("let0D"),
    $83b23485bc47439e$var$load("2bmVk"),
    $83b23485bc47439e$var$load("ffEVr"),
    $83b23485bc47439e$var$load("g7g2y"),
    $83b23485bc47439e$var$load("hhss7"),
    $83b23485bc47439e$var$load("7Omhy"),
    $83b23485bc47439e$var$load("kC80R"),
    $83b23485bc47439e$var$load("dUTj8")
]).then(()=>parcelRequire('fKhxN'));

});

parcelRegister("38qvz", function(module, exports) {

var $kqIWy = parcelRequire("kqIWy");

const $f0e4954369e4b2a4$export$6c92cd4e39d5997c = ({ spaceKey: spaceKey })=>{
    const { data: spaceData } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    return {
        spaceType: spaceData?.type,
        isKnowledgeBaseSpace: spaceData?.type === 'knowledge_base'
    };
};
module.exports["useSpaceType"] = $f0e4954369e4b2a4$export$6c92cd4e39d5997c;

});

parcelRegister("ikPi2", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $2748374594b3931f$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        fullPageEditorLoomUrl: undefined,
        pageCommentEditorLoomUrl: undefined,
        inlineCommentEditorLoomUrl: undefined
    },
    actions: {
        updateFullPageEditorLoomUrl: (video)=>({ setState: setState })=>{
                setState({
                    fullPageEditorLoomUrl: video
                });
            },
        updatePageCommentEditorLoomUrl: (video)=>({ setState: setState })=>{
                setState({
                    pageCommentEditorLoomUrl: video
                });
            }
    },
    name: 'loomUrlToInsert'
});
const $2748374594b3931f$export$f76207310d699374 = (0, $9zUhf.createHook)($2748374594b3931f$var$Store);
const $2748374594b3931f$export$b51bf851d750866c = ()=>$2748374594b3931f$export$f76207310d699374()[1];
module.exports["useLoomInsertUrlState"] = $2748374594b3931f$export$f76207310d699374;

});

parcelRegister("j5cB3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $cOrQJ = parcelRequire("cOrQJ");


const $43c705326a57355f$export$c720381daa58fcbb = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const adsTheme = (0, $cOrQJ.default)();
    let t0;
    if ($[0] !== adsTheme) {
        t0 = adsTheme;
        $[0] = adsTheme;
        $[1] = t0;
    } else t0 = $[1];
    const effectiveTheme = t0;
    return effectiveTheme?.colorMode === "dark";
} : ()=>{
    // Using hook and getTokenValue() vs token() because of equality comparison used in generateValidTheme()
    //    The hook allows these variables to re-compute when the theme is changed.
    //    Even when the look-and-feel defaults are tokenized, if the site has configured and reverted back to the original
    //      colors, if they aren't using the css var w/ tokens, the value here would not match if just using token()
    const adsTheme = (0, $cOrQJ.default)();
    // Use locally stored theme for SSR because `useThemeObserver()` won't work in SSR
    //  also, "auto" won't work in SSR if resolves to "dark" because we cannot get the system preference off the window
    //  see https://product-fabric.atlassian.net/browse/DSP-9781
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const effectiveTheme = adsTheme;
    return effectiveTheme?.colorMode === 'dark';
};
module.exports["useIsDarkMode"] = $43c705326a57355f$export$c720381daa58fcbb;

});

parcelRegister("4Dj8n", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dlSEv = parcelRequire("dlSEv");

var $cFEpk = parcelRequire("cFEpk");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7LI3Q = parcelRequire("7LI3Q");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $f7MuR = parcelRequire("f7MuR");


var $gqypm = parcelRequire("gqypm");


var $6vgLy = parcelRequire("6vgLy");


var $fv7de = parcelRequire("fv7de");

const $f70a72dbc1235d39$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $f70a72dbc1235d39$var$EMBEDDED_CONFLUENCE_FIRST_ACTIVE_TRAIT = 'embedded_confluence_user_first_active';
const $f70a72dbc1235d39$export$7baca885d79a7d1e = ({ children: children, activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate, excludeEmbeddedConfluence: excludeEmbeddedConfluence = false, onExclude: onExclude })=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: newData, loading: newLoading, error: newError } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: !(0, $9wGTI.fg)('cc_activation_hide_changeboarding_for_new_users')
    });
    const { data: oldData, loading: oldLoading, error: oldError } = (0, $gqypm.useExperimentalSiteUserPersonalization)({
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: (0, $9wGTI.fg)('cc_activation_hide_changeboarding_for_new_users') || !isLicensed || !userId
    });
    let attributes;
    let loading;
    let error;
    if ((0, $9wGTI.fg)('cc_activation_hide_changeboarding_for_new_users')) {
        attributes = newData?.attributes ?? null;
        loading = newLoading;
        error = newError;
    } else {
        attributes = oldData?.experimentalSiteUserPersonalization?.attributes ?? null;
        loading = oldLoading;
        error = oldError;
    }
    const confluenceFirstActive = attributes?.find(({ name: name })=>name === $f70a72dbc1235d39$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const embeddedConfluenceFirstActive = attributes?.find(({ name: name })=>name === $f70a72dbc1235d39$var$EMBEDDED_CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActive = excludeEmbeddedConfluence ? confluenceFirstActive : $f70a72dbc1235d39$var$getEarliestDate(confluenceFirstActive, embeddedConfluenceFirstActive);
    const firstActiveDate = firstActive ? new Date(firstActive) : null;
    const { shouldExclude: shouldExclude } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return null;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $7LI3Q.isUnauthorizedError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
    }
    if (shouldExclude) return onExclude ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fv7de.ExcludeHandler), {
        onExclude: onExclude
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
/**
 * Returns the earliest valid date from two date strings, or null if neither is valid
 */ const $f70a72dbc1235d39$var$getEarliestDate = (date1, date2)=>{
    const validDates = [
        date1,
        date2
    ].filter(Boolean).map((date)=>new Date(date || '')).filter((0, $cFEpk.default));
    if (validDates.length === 0) return null;
    if (validDates.length === 1) return validDates[0].toISOString();
    return (0, $dlSEv.default)(validDates[0], validDates[1]) ? validDates[0].toISOString() : validDates[1].toISOString();
};
module.exports["ExcludeNewConfluenceActiveUser"] = $f70a72dbc1235d39$export$7baca885d79a7d1e;

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("7LI3Q", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $02289dc82bb02982$export$55152de1f925fd05 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '401');
module.exports["isUnauthorizedError"] = $02289dc82bb02982$export$55152de1f925fd05;

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($26d702ce000cc6e9$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId || !userId) return;
        $26d702ce000cc6e9$var$hasFetched = true;
        storeActions.start();
        $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("6vgLy", function(module, exports) {

var $922yL = parcelRequire("922yL");

var $e0SBo = parcelRequire("e0SBo");

var $cFEpk = parcelRequire("cFEpk");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, fallback to excluding the user
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: false,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $e0SBo.default)((0, $922yL.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $cFEpk.default)(cutoffDate) ? (0, $e0SBo.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("e0SBo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33b6ba3d9a58f3b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $a33b6ba3d9a58f3b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("fv7de", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f7052e6541e23622$export$efe806c5aa871995 = ({ onExclude: onExclude })=>{
    const hasFiredRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!hasFiredRef.current) {
            hasFiredRef.current = true;
            onExclude?.();
        }
    }, [
        onExclude
    ]);
    return null;
};
module.exports["ExcludeHandler"] = $f7052e6541e23622$export$efe806c5aa871995;

});

parcelRegister("lrMxq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7d2Nc = parcelRequire("7d2Nc");


var $jmjWc = parcelRequire("jmjWc");


var $fgdVB = parcelRequire("fgdVB");


const $172892494f392667$var$ObjectSidebarControlLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "liSnz",
    name: "ObjectSidebarControlLoader",
    loader: async ()=>(await (parcelRequire("2UGSj"))).ObjectSidebarControl
});
const $172892494f392667$export$3fab07431350539e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($172892494f392667$var$ObjectSidebarControlLoader, props));
module.exports["ObjectSidebarControl"] = $172892494f392667$export$3fab07431350539e;

});

parcelRegister("2UGSj", function(module, exports) {

let $21f211cff7e0d40c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $21f211cff7e0d40c$var$load("li9sm"),
    $21f211cff7e0d40c$var$load("aLLXO"),
    $21f211cff7e0d40c$var$load("9AHrA"),
    $21f211cff7e0d40c$var$load("1Cs7t"),
    $21f211cff7e0d40c$var$load("gTC01"),
    $21f211cff7e0d40c$var$load("6wr18"),
    $21f211cff7e0d40c$var$load("dFVoN"),
    $21f211cff7e0d40c$var$load("kTdzk"),
    $21f211cff7e0d40c$var$load("2dtmW"),
    $21f211cff7e0d40c$var$load("i0ttV"),
    $21f211cff7e0d40c$var$load("2O2Xv"),
    $21f211cff7e0d40c$var$load("jcLEv"),
    $21f211cff7e0d40c$var$load("6mV9H"),
    $21f211cff7e0d40c$var$load("736as"),
    $21f211cff7e0d40c$var$load("2Mq3f"),
    $21f211cff7e0d40c$var$load("1Jgsw"),
    $21f211cff7e0d40c$var$load("dclpt"),
    $21f211cff7e0d40c$var$load("tKhaz"),
    $21f211cff7e0d40c$var$load("iK6Gk"),
    $21f211cff7e0d40c$var$load("jxz2q"),
    $21f211cff7e0d40c$var$load("9jS5g"),
    $21f211cff7e0d40c$var$load("ffiE4"),
    $21f211cff7e0d40c$var$load("fD0v8"),
    $21f211cff7e0d40c$var$load("6XCf4"),
    $21f211cff7e0d40c$var$load("5pvpJ"),
    $21f211cff7e0d40c$var$load("1qlDN"),
    $21f211cff7e0d40c$var$load("1yVM6"),
    $21f211cff7e0d40c$var$load("7EorR"),
    $21f211cff7e0d40c$var$load("ffEVr"),
    $21f211cff7e0d40c$var$load("hHIPg")
]).then(()=>parcelRequire('lVF98'));

});

parcelRegister("8Psje", function(module, exports) {
const $5c0c9a15440579bc$export$fb74cd09fc20f0c3 = (spaceKey)=>{
    if (!spaceKey) return false;
    return spaceKey.startsWith('~ROVO') && spaceKey.endsWith('~');
};
module.exports["isRovoSystemSpaceKey"] = $5c0c9a15440579bc$export$fb74cd09fc20f0c3;

});

parcelRegister("fh45B", function(module, exports) {

let $b1eb9d9ca134cb98$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b1eb9d9ca134cb98$var$load("dLgKY"),
    $b1eb9d9ca134cb98$var$load("frlpE"),
    $b1eb9d9ca134cb98$var$load("9A0ig"),
    $b1eb9d9ca134cb98$var$load("9Uze4"),
    $b1eb9d9ca134cb98$var$load("6rkrn"),
    $b1eb9d9ca134cb98$var$load("e9JE4"),
    $b1eb9d9ca134cb98$var$load("e4GNb"),
    $b1eb9d9ca134cb98$var$load("7WaUI"),
    $b1eb9d9ca134cb98$var$load("kgxfY"),
    $b1eb9d9ca134cb98$var$load("cZcsn"),
    $b1eb9d9ca134cb98$var$load("iK6Gk"),
    $b1eb9d9ca134cb98$var$load("6SPW3"),
    $b1eb9d9ca134cb98$var$load("fwZcf"),
    $b1eb9d9ca134cb98$var$load("g5HUX"),
    $b1eb9d9ca134cb98$var$load("fm4rz"),
    $b1eb9d9ca134cb98$var$load("39kma"),
    $b1eb9d9ca134cb98$var$load("86sUJ"),
    $b1eb9d9ca134cb98$var$load("cu8No"),
    $b1eb9d9ca134cb98$var$load("6sohm"),
    $b1eb9d9ca134cb98$var$load("kEwWf"),
    $b1eb9d9ca134cb98$var$load("fD0v8"),
    $b1eb9d9ca134cb98$var$load("6XCf4"),
    $b1eb9d9ca134cb98$var$load("fGT64"),
    $b1eb9d9ca134cb98$var$load("5abXM"),
    $b1eb9d9ca134cb98$var$load("k78EM"),
    $b1eb9d9ca134cb98$var$load("5pvpJ"),
    $b1eb9d9ca134cb98$var$load("lUQAm"),
    $b1eb9d9ca134cb98$var$load("hshEG"),
    $b1eb9d9ca134cb98$var$load("5CdWD"),
    $b1eb9d9ca134cb98$var$load("deebc"),
    $b1eb9d9ca134cb98$var$load("5EQhG"),
    $b1eb9d9ca134cb98$var$load("8fXIr"),
    $b1eb9d9ca134cb98$var$load("dVkhd"),
    $b1eb9d9ca134cb98$var$load("7jSfd"),
    $b1eb9d9ca134cb98$var$load("4HZlX"),
    $b1eb9d9ca134cb98$var$load("kDqHr"),
    $b1eb9d9ca134cb98$var$load("6wr18"),
    $b1eb9d9ca134cb98$var$load("kjZZD"),
    $b1eb9d9ca134cb98$var$load("ht5OT"),
    $b1eb9d9ca134cb98$var$load("sj9Xz"),
    $b1eb9d9ca134cb98$var$load("1qlDN"),
    $b1eb9d9ca134cb98$var$load("1yVM6"),
    $b1eb9d9ca134cb98$var$load("dTsOE"),
    $b1eb9d9ca134cb98$var$load("ffEVr"),
    $b1eb9d9ca134cb98$var$load("iq6Zv")
]).then(()=>parcelRequire('8pP5E'));

});

parcelRegister("7hGsm", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $54db0de22feedc16$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("2UWw0")));

var $hXuPC = parcelRequire("hXuPC");


var $iIf3l = parcelRequire("iIf3l");


var $a5jIU = parcelRequire("a5jIU");


var $fkDf0 = parcelRequire("fkDf0");


var $6yHbi = parcelRequire("6yHbi");


var $2UWw0 = parcelRequire("2UWw0");

var $54db0de22feedc16$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $54db0de22feedc16$var$_window = (0, $fkDf0.getGlobalObject)();
if ($54db0de22feedc16$var$_window.Sentry && $54db0de22feedc16$var$_window.Sentry.Integrations) $54db0de22feedc16$var$windowIntegrations = $54db0de22feedc16$var$_window.Sentry.Integrations;
var $54db0de22feedc16$export$99d02219d259eb94 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $54db0de22feedc16$var$windowIntegrations), (0, $a5jIU)), $6yHbi);
$parcel$exportWildcard(module.exports, $iIf3l);

});

parcelRegister("iIf3l", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("dcvJ5")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("euURg")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("805AA")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("805AA")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("805AA")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("805AA")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("805AA")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("k3i2h")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("k3i2h")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("k3i2h")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("k3i2h")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("euURg")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("cSJat")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("805AA")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("cTFwF")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("805AA")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("805AA")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("805AA")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("805AA")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("805AA")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("805AA")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("805AA")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("cW7ac")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1cvC0")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("a7P2i")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("a7P2i")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("ffG6S")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("ffG6S")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("ffG6S")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("ffG6S")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("ffG6S")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("ffG6S")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("ffG6S")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("ffG6S")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("ffG6S")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("brq4Q")).SDK_NAME);

var $dcvJ5 = parcelRequire("dcvJ5");


var $805AA = parcelRequire("805AA");

var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

var $cTFwF = parcelRequire("cTFwF");

var $cSJat = parcelRequire("cSJat");


var $cW7ac = parcelRequire("cW7ac");


var $1cvC0 = parcelRequire("1cvC0");


var $a7P2i = parcelRequire("a7P2i");


var $ffG6S = parcelRequire("ffG6S");


var $brq4Q = parcelRequire("brq4Q");


});

parcelRegister("brq4Q", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $854671b7fcc6622a$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $854671b7fcc6622a$export$ca61d37259221480;

});

parcelRegister("6yHbi", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("3BsQh")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("lIIKi")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bISXm")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("63fUW")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("eLUbA")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("fCIwr")).Dedupe);

var $3BsQh = parcelRequire("3BsQh");


var $lIIKi = parcelRequire("lIIKi");


var $bISXm = parcelRequire("bISXm");


var $63fUW = parcelRequire("63fUW");


var $eLUbA = parcelRequire("eLUbA");


var $fCIwr = parcelRequire("fCIwr");


});

parcelRegister("2UWw0", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("1l2dO")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("8LVWj")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("2yXKF")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hB2rb")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("lgAM0")).makeNewXHRTransport);

var $1l2dO = parcelRequire("1l2dO");


var $8LVWj = parcelRequire("8LVWj");


var $2yXKF = parcelRequire("2yXKF");


var $hB2rb = parcelRequire("hB2rb");


var $lgAM0 = parcelRequire("lgAM0");


});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("lyWac", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");

function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return Promise.allSettled(values).then((results)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            const errors = [];
            for (const result of results){
                if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
                else if (result.status === 'fulfilled') {
                    const fulfilledValue = result.value;
                    if (fulfilledValue instanceof Error) errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue));
                    else if (Array.isArray(fulfilledValue)) {
                        const filteredErrors = fulfilledValue.filter((value)=>value instanceof Error);
                        errors.push(...filteredErrors.flatMap($6e8f7926b945fe5e$var$expandErrorToErrors));
                    }
                }
            }
            if (errors.length > 0) {
                // Errors on preloader functions are not meant to break anything.
                // But we still want to know them...
                // eslint-disable-next-line no-console
                console.error('Errors caught by waitForAllReturnWhenError', {
                    errors: errors.map((error)=>error.message)
                });
                return errors;
            }
        });
    })();
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("4vyfK", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $dYU3e = parcelRequire("dYU3e");


var $fjiOd = parcelRequire("fjiOd");

function $2272f3d6a41ef128$export$8120ee10837c1dd({ location: location = null, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null } = {}) {
    if (!contentId && spaceKey) return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $fjiOd.WebItemLocationWithSpaceKeyQuery),
            variables: {
                location: Array.isArray(location) ? null : location,
                locations: Array.isArray(location) ? location : [],
                spaceKey: spaceKey,
                version: version
            }
        }).then(({ data: data })=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            if (data?.space?.homepageId) (0, $dYU3e.writeQuery)({
                /* @ts-expect-error http://go/cfe-use-relay-artifacts */ query: (0, $fjiOd.WebItemLocationQuery),
                variables: {
                    location: Array.isArray(location) ? null : location,
                    locations: Array.isArray(location) ? location : [],
                    contentId: data?.space?.homepageId,
                    spaceKey: null,
                    version: version
                },
                data: {
                    webItemSections: data?.space?.homepageWebSections || []
                }
            });
        });
    })();
    const variables = {
        // GraphQL doesn't cache single location strings properly when passed to locations
        // unless we're using multiple locations we should be using the location variable
        location: Array.isArray(location) ? null : location,
        locations: Array.isArray(location) ? location : [],
        contentId: contentId,
        spaceKey: spaceKey,
        version: version
    };
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $fjiOd.WebItemLocationQuery),
        variables: variables
    });
}
module.exports["preloadWebItemLocation"] = $2272f3d6a41ef128$export$8120ee10837c1dd;

});

parcelRegister("3mugH", function(module, exports) {

var $lrjR8 = parcelRequire("lrjR8");

const $d967841d02dde0d1$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
module.exports["ssrPrepareErrorsClient"] = $d967841d02dde0d1$export$17bc715070d0e7ef;

});

parcelRegister("lrjR8", function(module, exports) {
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}
module.exports["SSRPrepareErrorsClient"] = $7cc20c0ac0ad5b24$export$622a2782a1f9c63;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("gHaxX", function(module, exports) {

var $973aB = parcelRequire("973aB");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/user/manifest.ts
var $c278d7dccfa97a86$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $973aB.IdentityUserAriResourceOwner),
    resourceType: (0, $973aB.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $c278d7dccfa97a86$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $3NXcb.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $c278d7dccfa97a86$export$1e9d09c2be53e55e;

});

parcelRegister("973aB", function(module, exports) {
// src/identity/user/types.ts
var $6a2739fa6e7a2528$export$b4c14c54282a779d = "identity", $6a2739fa6e7a2528$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $6a2739fa6e7a2528$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $6a2739fa6e7a2528$export$e9b50e20f4fbfb71;

});

parcelRegister("8CHHT", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $9WAeG = parcelRequire("9WAeG");


var $xwvlW = parcelRequire("xwvlW");


var $3mugH = parcelRequire("3mugH");


var $8n0y0 = parcelRequire("8n0y0");

const $23196774779b9db8$var$setWindowExtensions = (moduleType, extensions, error)=>{
    window.__SSR_FORGE_EXTENSIONS__ = window.__SSR_FORGE_EXTENSIONS__ || {};
    window.__SSR_FORGE_EXTENSIONS__[moduleType] = {
        extensions: extensions,
        error: error
    };
};
async function $23196774779b9db8$export$afb6180712276ba1({ contentId: contentId, spaceKey: spaceKey, moduleType: moduleType }) {
    const { cloudId: cloudId, locale: locale } = (0, $xwvlW.getPreloaderFnContext)();
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:ForgeExtensionList', async ()=>{
        try {
            const extensions = await (async ()=>{
                const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
                const _asyncResult = await (0, $8n0y0.preloadForgeApps)({
                    cloudId: cloudId,
                    locale: locale,
                    types: [
                        moduleType
                    ],
                    context: {
                        spaceKey: spaceKey,
                        contentId: contentId
                    },
                    includeHidden: false
                });
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
                return _asyncResult;
            })();
            if (extensions) $23196774779b9db8$var$setWindowExtensions(moduleType, extensions, undefined);
        } catch (e) {
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Filed to get forge extension list: ${e.message}`));
        }
    });
}
module.exports["preloadUseExtensionList"] = $23196774779b9db8$export$afb6180712276ba1;

});

parcelRegister("8n0y0", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $eSUdr = parcelRequire("eSUdr");


var $aIwYp = parcelRequire("aIwYp");


var $dYU3e = parcelRequire("dYU3e");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $8pJsP = parcelRequire("8pJsP");

const $0469ff9a24207ab9$export$e95a50d7f0e263b5 = async ({ cloudId: cloudId, locale: locale, types: types, context: context, includeHidden: includeHidden })=>{
    if ((0, $9wGTI.fg)('memoize_prefiltered_extensions')) return (0, $aIwYp.preloadPrefilteredExtensionList)((0, $6mKj3.expVal)('confluence_cgraphql_client_for_forge_extensions', 'isEnabled', false) ? (0, $dYU3e.query) : (0, $dYU3e.queryAgg), {
        cloudId: cloudId,
        locale: locale,
        types: types,
        context: context,
        includeHidden: includeHidden
    });
    else {
        const { data: data } = await (async ()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult = await ((0, $6mKj3.expVal)('confluence_cgraphql_client_for_forge_extensions', 'isEnabled', false) ? (0, $dYU3e.query) : (0, $dYU3e.queryAgg))({
                /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ // eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming
                query: (0, $eSUdr.default)`query FetchPreFilteredForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner consentUrl environmentId environmentKey environmentType migrationKey key properties{key value}egress{addresses category type inScopeEUD}scopes license{active capabilitySet}userAccess{enabled hasAccess}type installationId installationConfig{key value}hiddenBy}}`,
                variables: {
                    cloudId: cloudId,
                    context: context,
                    includeHidden: includeHidden ?? false,
                    types: types,
                    locale: locale
                }
            });
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            return _asyncResult;
        })();
        return $0469ff9a24207ab9$var$transformForgeApps(data);
    }
};
const $0469ff9a24207ab9$var$transformForgeApps = (data)=>{
    if (!data || !data.confluence_forgeExtensionsByType) return null;
    return (0, $8pJsP.transformPreFilteredExtensions)(data.confluence_forgeExtensionsByType);
};
module.exports["preloadForgeApps"] = $0469ff9a24207ab9$export$e95a50d7f0e263b5;

});

parcelRegister("aIwYp", function(module, exports) {

var $8VYSW = parcelRequire("8VYSW");


var $7zIsq = parcelRequire("7zIsq");


var $39Ajm = parcelRequire("39Ajm");

const $1539bb55e97e95bf$export$689e6fec3c3a045c = async (query, { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, queryOptions: queryOptions })=>{
    const { fetchPolicy: _, ...requestOptions } = (0, $7zIsq.createUsePrefilteredExtensionListQueryOptions)(cloudId, context, undefined, types, locale, includeHidden, queryOptions);
    const { data: data } = await query({
        query: (0, $39Ajm.FetchPreFilteredForgeAppsQuery),
        ...requestOptions
    });
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (extensions.length > 0) return (0, $8VYSW.transformPreFilteredExtensions)(extensions);
    return null;
};
module.exports["preloadPrefilteredExtensionList"] = $1539bb55e97e95bf$export$689e6fec3c3a045c;

});

parcelRegister("8pJsP", function(module, exports) {
parcelRequire("1c598");
var $2JC3k = parcelRequire("2JC3k");

const $be0a345f7ae1b5e4$export$9ff84ea1b2ab439c = (extensions)=>{
    return (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).STAGING || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: extension.properties.reduce((acc, property)=>{
                    if (!property.value || !property.key) return acc;
                    try {
                        const jsonValue = JSON.parse(property.value);
                        acc[property.key] = jsonValue;
                    } catch (error) {
                        acc[property.key] = property.value;
                    }
                    return acc;
                }, {}),
                license: extension.license ? {
                    ...extension.license,
                    //@ts-ignore capabilitySet mapped to valid value
                    capabilitySet: extension.license.capabilitySet === 'CAPABILITY_ADVANCED' ? 'capabilityAdvanced' : 'capabilityStandard'
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
};
module.exports["transformPreFilteredExtensions"] = $be0a345f7ae1b5e4$export$9ff84ea1b2ab439c;

});

parcelRegister("4YBSq", function(module, exports) {
/**
 * @generated SignedSource<<2f52473be21986bee58c241e9bbdbeb7>>
 * @relayHash f85bb73042ebe75e2cb50dec93f9b7c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139
const $16e983e3bee16ecd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "embedded"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "collabService"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f85bb73042ebe75e2cb50dec93f9b7c4",
            "id": "ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139",
            "metadata": {},
            "name": "EditContentButtonQuery",
            "operationKind": "query",
            "text": "query EditContentButtonQuery($contentId:ID!){content(id:$contentId){nodes{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}}}"
        }
    };
}();
$16e983e3bee16ecd$var$node.hash = "94b096c536d2633f3df010c4409c1c2a";
var $16e983e3bee16ecd$export$2e2bcd8739ae039 = $16e983e3bee16ecd$var$node;
module.exports["default"] = $16e983e3bee16ecd$export$2e2bcd8739ae039;

});

parcelRegister("kwDQA", function(module, exports) {
/**
 * @generated SignedSource<<fcaabb8124ebaff8ea124886ff923a1a>>
 * @relayHash dc72ca00e2d1457e65f0598584181ac4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c301260df5a4466153ed3f56d8be0b24166ae188507e59c4709e8a0159d8500
const $377c093245c44338$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fromDate"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "fromDate",
                    "variableName": "fromDate"
                }
            ],
            "concreteType": "ContentAnalyticsViewers",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewers",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAnalyticsByLineQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAnalyticsByLineQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "dc72ca00e2d1457e65f0598584181ac4",
            "id": "4c301260df5a4466153ed3f56d8be0b24166ae188507e59c4709e8a0159d8500",
            "metadata": {},
            "name": "useAnalyticsByLineQuery",
            "operationKind": "query",
            "text": "query useAnalyticsByLineQuery($contentId:ID!,$fromDate:String){contentAnalyticsViewers(contentId:$contentId,fromDate:$fromDate){count},user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}"
        }
    };
}();
$377c093245c44338$var$node.hash = "bc547488b58318aeb15d566ad5044ad7";
var $377c093245c44338$export$2e2bcd8739ae039 = $377c093245c44338$var$node;
module.exports["default"] = $377c093245c44338$export$2e2bcd8739ae039;

});

parcelRegister("e3X7L", function(module, exports) {
/**
 * @generated SignedSource<<018f680a41f998d85b2f3329e18a2d4f>>
 * @relayHash 6ea58338105a015fd443972b8fa8bd85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c621ba09ccc6f35017033687da8b71cefb7d4fe258097148bd0d767f32870c64
const $05607cbb6652fe1b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GrantAccessDialogLoaderQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GrantAccessDialogLoaderQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6ea58338105a015fd443972b8fa8bd85",
            "id": "c621ba09ccc6f35017033687da8b71cefb7d4fe258097148bd0d767f32870c64",
            "metadata": {},
            "name": "GrantAccessDialogLoaderQuery",
            "operationKind": "query",
            "text": "query GrantAccessDialogLoaderQuery($contentId:ID!,$accountId:ID!){singleContent(id:$contentId){id,title},user:confluence_atlassianUser(id:$accountId){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$05607cbb6652fe1b$var$node.hash = "65e9fca072feda54403e4da52299bc66";
var $05607cbb6652fe1b$export$2e2bcd8739ae039 = $05607cbb6652fe1b$var$node;
module.exports["default"] = $05607cbb6652fe1b$export$2e2bcd8739ae039;

});

parcelRegister("8EyOs", function(module, exports) {
/**
 * @generated SignedSource<<2f2dfe426bd1e7dfe41d164e303a602e>>
 * @relayHash 0c7e59589b279881378fc2baf2dcf71b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb
const $231a29dfed7a7165$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "restrictionLevel"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "format",
                            "variableName": "format"
                        }
                    ],
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "contentStateLastUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "0c7e59589b279881378fc2baf2dcf71b",
            "id": "0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb",
            "metadata": {},
            "name": "RendererContentStateQuery",
            "operationKind": "query",
            "text": "query RendererContentStateQuery($contentId:ID!,$isDraft:Boolean!,$format:GraphQLDateFormat){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel},contentStateLastUpdated(format:$format){value}}}"
        }
    };
}();
$231a29dfed7a7165$var$node.hash = "a7f67982771d8fe760ba232b1260bced";
var $231a29dfed7a7165$export$2e2bcd8739ae039 = $231a29dfed7a7165$var$node;
module.exports["default"] = $231a29dfed7a7165$export$2e2bcd8739ae039;

});

parcelRegister("727Kl", function(module, exports) {
/**
 * @generated SignedSource<<23657cfa28253feae2148e6790afe577>>
 * @relayHash 44db9f450e28b26d3fd0636099f11bcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f26dec82fc176d621569044513f48281be3108ad88f94424ece034aa9b3aef45
const $e037c5037ae7dbbf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": v1 /*: any*/ ,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                            "kind": "LinkedField",
                            "name": "currentuser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "FavouritedSummary",
                                    "kind": "LinkedField",
                                    "name": "favourited",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "alias": "contentOperations",
            "args": v1 /*: any*/ ,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FavouriteButtonComponentQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FavouriteButtonComponentQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "44db9f450e28b26d3fd0636099f11bcf",
            "id": "f26dec82fc176d621569044513f48281be3108ad88f94424ece034aa9b3aef45",
            "metadata": {},
            "name": "FavouriteButtonComponentQuery",
            "operationKind": "query",
            "text": "query FavouriteButtonComponentQuery($contentId:ID!){singleContent(id:$contentId){id,type,metadata{currentuser{favourited{isFavourite}}}},contentOperations:singleContent(id:$contentId){id,operations{operation,targetType}}}"
        }
    };
}();
$e037c5037ae7dbbf$var$node.hash = "c0d9982d75aa14c419a4e3cb6fb450f1";
var $e037c5037ae7dbbf$export$2e2bcd8739ae039 = $e037c5037ae7dbbf$var$node;
module.exports["default"] = $e037c5037ae7dbbf$export$2e2bcd8739ae039;

});

parcelRegister("hpr9b", function(module, exports) {

var $6XxzN = parcelRequire("6XxzN");

const $0010f8f7298777ae$export$7db5b17cce09ecf7 = ()=>{
    return 0, $6XxzN.WatchDialogQueryWithWatchChildren;
};
module.exports["getWatchDialogQuery"] = $0010f8f7298777ae$export$7db5b17cce09ecf7;

});

parcelRegister("6XxzN", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $51124c5b395b8390$export$ff412db8b959e059 = (0, $eSUdr.default)`query WatchDialogQueryWithWatchChildren($contentId:ID!){singleContent(id:$contentId){id ...WatchDialogContentFragmentWithWatchChildren}}fragment WatchDialogContentFragmentWithWatchChildren on Content{id currentUserIsWatching currentUserIsWatchingChildren currentUserHasAncestorWatchingChildren type space{id key currentUser{isWatched isWatchingBlogs}operations{operation targetType}}}`;
module.exports["WatchDialogQueryWithWatchChildren"] = $51124c5b395b8390$export$ff412db8b959e059;

});

parcelRegister("fiBb3", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $23261b803687ce64$export$2b17287e63c772da = (0, $eSUdr.default)`query ContentHeaderUnifiedQuery($contentId:ID!$spaceKey:String$versionOverride:Int$embeddedContentRender:String$limit:Int$useNewContentTopper:Boolean=false$status:[String]$includeGeneratedBy:Boolean=false){content(id:$contentId version:$versionOverride embeddedContentRender:$embeddedContentRender status:$status){nodes{id type subType title status appearancePublished:properties(key:"content-appearance-published"){nodes{id key value version{number}}}history{createdDate createdBy{type displayName ...on KnownUser{accountId}profilePicture{path}}ownedBy{type displayName ...on KnownUser{accountId}profilePicture{path}}lastOwnedBy{type displayName ...on KnownUser{accountId}profilePicture{path}}}emojiTitlePublished:properties(key:"emoji-title-published"){nodes{id key value version{number}}}pageTitlePublished:properties(key:"page-title-property-published")@include(if:$useNewContentTopper){nodes{id key value version{number}}}properties(key:"editor"){nodes{id key value}}space{id name homepageId}version{message by{type displayName ...on KnownUser{accountId}profilePicture{path}}friendlyWhen when number contentTypeModified}contentProperties@include(if:$includeGeneratedBy){latest{generatedBy}}metadata{sourceTemplateEntityId lastModifiedDate frontend{fabricEditorSupported coverPictureWidth@include(if:$useNewContentTopper)}}}}contentContributors(id:$contentId limit:$limit){count isCurrentUserContributor isOwnerContributor nodes{type displayName ...on KnownUser{accountId}profilePicture{path}}}space(key:$spaceKey){id theme{themeKey}lookAndFeel{headings{key value}content{header{background backgroundAttachment backgroundBlendMode backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPosition backgroundRepeat backgroundSize borderRadius padding}}}}}`;
module.exports["ContentHeaderUnifiedQuery"] = $23261b803687ce64$export$2b17287e63c772da;

});

parcelRegister("80xNa", function(module, exports) {
const $5d488939c8bec967$export$21191b0c00ca25f4 = 4;
const $5d488939c8bec967$export$4b915fb24c39b396 = {
    //copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD'
};
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $5d488939c8bec967$export$21191b0c00ca25f4;
module.exports["CONFLUENCE_EDITION"] = $5d488939c8bec967$export$4b915fb24c39b396;

});

parcelRegister("6LsQQ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $g2gGv = parcelRequire("g2gGv");

const $f8780459a3f4abf6$export$7da3cd10eb68919e = (0, $eSUdr.default)`query ContentTypesHeaderQuery($contentId:ID$useObjectHeader:Boolean!){content(id:$contentId status:["archived" "current" "draft"]){nodes{id title operations{operation targetType}space{id name key alias}type subType status version@include(if:$useObjectHeader){contentTypeModified number friendlyWhen ...LastEditedVersionFragment}draftVersion@include(if:$useObjectHeader){contentTypeModified number friendlyWhen ...LastEditedDraftVersionFragment}}}}${(0, $g2gGv.LastEditedVersionFragment)}${(0, $g2gGv.LastEditedDraftVersionFragment)}`;
module.exports["ContentTypesHeaderQuery"] = $f8780459a3f4abf6$export$7da3cd10eb68919e;

});

parcelRegister("g2gGv", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $82f60ea6bd1b627b$export$deecf62d8ca1b922 = (0, $eSUdr.default)`fragment LastEditedVersionFragment on Version{by{displayName}when}`;
const $82f60ea6bd1b627b$export$36bc043d85f07c8 = (0, $eSUdr.default)`fragment LastEditedDraftVersionFragment on Version{by{displayName}when}`;
module.exports["LastEditedVersionFragment"] = $82f60ea6bd1b627b$export$deecf62d8ca1b922;
module.exports["LastEditedDraftVersionFragment"] = $82f60ea6bd1b627b$export$36bc043d85f07c8;

});

parcelRegister("lPNkm", function(module, exports) {
/**
 * @generated SignedSource<<3732ec9e4e0a55bb3c7b36210917bc39>>
 * @relayHash 19081691cac2c634716f82092efd5e14
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d5dc74f8943db901b65da9952c21aedcb442dbab7bde8fc78fddd85434811f3
const $98f50c7d6961f0d8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "html"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        },
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "concreteType": "SpaUnfriendlyMacro",
            "kind": "LinkedField",
            "name": "spaUnfriendlyMacros",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SpaceSettingsMetadata",
                            "kind": "LinkedField",
                            "name": "customHeaderAndFooter",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HtmlMeta",
                                    "kind": "LinkedField",
                                    "name": "header",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "HtmlMeta",
                                    "kind": "LinkedField",
                                    "name": "footer",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CustomHeaderFooterQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CustomHeaderFooterQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "19081691cac2c634716f82092efd5e14",
            "id": "3d5dc74f8943db901b65da9952c21aedcb442dbab7bde8fc78fddd85434811f3",
            "metadata": {},
            "name": "CustomHeaderFooterQuery",
            "operationKind": "query",
            "text": "query CustomHeaderFooterQuery($spaceKey:String){space(key:$spaceKey){id,settings{customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}}}}"
        }
    };
}();
$98f50c7d6961f0d8$var$node.hash = "deed3f087b4973bd7d276b1389cfb125";
var $98f50c7d6961f0d8$export$2e2bcd8739ae039 = $98f50c7d6961f0d8$var$node;
module.exports["default"] = $98f50c7d6961f0d8$export$2e2bcd8739ae039;

});

parcelRegister("fyUox", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $1Y111 = parcelRequire("1Y111");


var $zalpJ = parcelRequire("zalpJ");

const $bf604cb6b214d1ef$var$preloadHomepageId = async (spaceKey)=>{
    const res = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $dYU3e.query)({
            query: (0, $zalpJ.PreloadHomepageIdQuery),
            variables: {
                spaceKey: spaceKey
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    return res?.data?.space?.homepage?.id;
};
const $bf604cb6b214d1ef$var$preloadTitleContentProperty = (contentId, fetchPolicy = 'cache-first')=>(0, $dYU3e.query)({
        query: (0, $1Y111.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: fetchPolicy
    });
const $bf604cb6b214d1ef$export$a65164d365713802 = async ({ contentId: contentId, contentIdPromise: contentIdPromise, spaceKey: spaceKey, fetchPolicy: fetchPolicy = 'cache-first' })=>{
    const promises = [];
    if (!contentId) {
        const homepageIdPromise = contentIdPromise || $bf604cb6b214d1ef$var$preloadHomepageId(spaceKey);
        promises.push(homepageIdPromise.then((homepageId)=>{
            return homepageId ? $bf604cb6b214d1ef$var$preloadTitleContentProperty(homepageId) : Promise.resolve({});
        }));
    } else promises.push($bf604cb6b214d1ef$var$preloadTitleContentProperty(contentId, fetchPolicy));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};
module.exports["preloadPageTitleContentProperties"] = $bf604cb6b214d1ef$export$a65164d365713802;

});

parcelRegister("1Y111", function(module, exports) {
/**
 * @generated SignedSource<<c65934a9e331ff8701130392e383f058>>
 * @relayHash 6af15886385d86202fbacd0200dc99eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0
const $66bccefa41a7dece$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6af15886385d86202fbacd0200dc99eb",
            "id": "2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPageQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$66bccefa41a7dece$var$node.hash = "9a5b243b4d944acf33577dfb16711cea";
var $66bccefa41a7dece$export$2e2bcd8739ae039 = $66bccefa41a7dece$var$node;
module.exports["default"] = $66bccefa41a7dece$export$2e2bcd8739ae039;

});

parcelRegister("zalpJ", function(module, exports) {

var $4lSsc = parcelRequire("4lSsc");


var $1Y111 = parcelRequire("1Y111");


var $jMyy4 = parcelRequire("jMyy4");


var $jVylI = parcelRequire("jVylI");


var $gzIc1 = parcelRequire("gzIc1");

'use no memo';
const $20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery = (0, $1Y111.default);
const $20e32f1deb8c1fe0$export$c9b63bbfd869a91 = (0, $4lSsc.default);
const $20e32f1deb8c1fe0$export$cef8b8531fa62d5f = (data)=>{
    const titlePropertyContent = data?.content?.nodes?.[0]?.pageTitlePublished?.nodes?.find((node)=>node?.key == 'page-title-property-published');
    const coverPictureWidth = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    if (titlePropertyContent?.value) try {
        return {
            titleContentProperties: (0, $gzIc1.contentPropertyHelper)(titlePropertyContent),
            coverPictureWidth: coverPictureWidth
        };
    } catch (e) {
        return {
            titleContentProperties: (0, $jVylI.defaultPropertyValue),
            coverPictureWidth: coverPictureWidth
        };
    }
    else return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: coverPictureWidth
    };
};
const $20e32f1deb8c1fe0$export$9e9d248809e028e8 = ({ contentId: contentId })=>{
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: 'cache-first'
    });
    if (!loading && data && !error) {
        const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f(data);
        return {
            titleContentProperties: titleContentProperties,
            coverPictureWidth: coverPictureWidth
        };
    }
    return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL
    };
};
module.exports["PreloadHomepageIdQuery"] = $20e32f1deb8c1fe0$export$c9b63bbfd869a91;
module.exports["getTitleContentProperty"] = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f;
module.exports["useTitleContentPropertiesForPublishedPage"] = $20e32f1deb8c1fe0$export$9e9d248809e028e8;

});

parcelRegister("4lSsc", function(module, exports) {
/**
 * @generated SignedSource<<edc256fe5c5e6d649d0fd080ebecc4d6>>
 * @relayHash 9a31bcd84d31650a9d9bf2ee5045af08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb
const $f70a6e2cb787614b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9a31bcd84d31650a9d9bf2ee5045af08",
            "id": "d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
        }
    };
}();
$f70a6e2cb787614b$var$node.hash = "57678666b7eece7bec595c782b54d686";
var $f70a6e2cb787614b$export$2e2bcd8739ae039 = $f70a6e2cb787614b$var$node;
module.exports["default"] = $f70a6e2cb787614b$export$2e2bcd8739ae039;

});

parcelRegister("gzIc1", function(module, exports) {

var $jVylI = parcelRequire("jVylI");

const $bda1e030ddde07df$export$e2d610ec02a291e1 = (jsonProperty)=>{
    let value;
    try {
        value = JSON.parse(jsonProperty.value);
        // objects returned from the content property can be double stringified
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this means that the object is double wrapped as a string and needs to be parsed again
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (error) {
            value = (0, $jVylI.defaultPropertyValue);
            throw new Error(`unable to parse value: ${error.message}`);
        }
    } catch (error) {
        value = (0, $jVylI.defaultPropertyValue);
        throw error;
    }
    return value;
};
module.exports["contentPropertyHelper"] = $bda1e030ddde07df$export$e2d610ec02a291e1;

});

parcelRegister("8Ya23", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $7d9def60e65e7ab6$export$4fc8ddb10c5d05fd = (0, $eSUdr.default)`query FocusedInlineCommentQuery($commentId:ID!$contentId:ID){content(id:$contentId){nodes{id type space{id}operations{operation targetType}}}comments(commentId:$commentId depth:ALL type:UNRESOLVED){nodes{ancestors{id body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized isInlineComment permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}links{webui editui}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}replies{id body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized isInlineComment permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}links{webui editui}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}}}id body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized isInlineComment permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}links{webui editui}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}replies{id body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized isInlineComment permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}links{webui editui}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}}}}user:confluence_atlassianUser(current:true){id displayName photos{value isPrimary}}}`;
module.exports["FocusedInlineCommentQuery"] = $7d9def60e65e7ab6$export$4fc8ddb10c5d05fd;

});

parcelRegister("cvj7x", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $6mKj3 = parcelRequire("6mKj3");


var $7W8i8 = parcelRequire("7W8i8");


var $65pdw = parcelRequire("65pdw");


var $1TElT = parcelRequire("1TElT");


var $3cpum = parcelRequire("3cpum");


var $7PLO8 = parcelRequire("7PLO8");


var $irrTO = parcelRequire("irrTO");


var $9sGCn = parcelRequire("9sGCn");


var $4trRg = parcelRequire("4trRg");

parcelRequire("kGDoD");
var $9nGwZ = parcelRequire("9nGwZ");


var $1c0dB = parcelRequire("1c0dB");


var $kDt9L = parcelRequire("kDt9L");


var $4vyfK = parcelRequire("4vyfK");


var $cRQNp = parcelRequire("cRQNp");


var $eSLr0 = parcelRequire("eSLr0");


var $8CHHT = parcelRequire("8CHHT");


var $7Ndnw = parcelRequire("7Ndnw");


var $lyWac = parcelRequire("lyWac");


var $9wGTI = parcelRequire("9wGTI");


var $9OYfw = parcelRequire("9OYfw");


var $hr9NW = parcelRequire("hr9NW");

const $c13994d6914d469f$var$logger = (0, $7W8i8.getLogger)('load-edit-page');
async function $c13994d6914d469f$export$1149cf9041c3e7b8({ spaceKey: spaceKey, contentId: contentId, shouldPreloadMentionsProvider: shouldPreloadMentionsProvider = false, useCache: useCache = false, catchFn: // use cache for native editor data
catchFn, isLivePage: isLivePage = false }) {
    // note: explicitly casting to Promise<any> to avoid typescript incorrectly inferring tuple types; although we don't use the return value of this function regardless
    $c13994d6914d469f$var$logger.debug`Calling preloadEditorData ${performance.now() / 1000}`;
    const draftShareId = (0, $7PLO8.getDraftShareIdFromQueryParam)();
    // preload queries shared by Synchrony and Native Collab editors
    const immediateResultsPromises = [
        (0, $irrTO.preloadDraftContentAppearance)(contentId, useCache)
    ];
    // specific native collab editor queries
    if (!!contentId) {
        immediateResultsPromises.push((0, $9OYfw.preloadCollabDraftContent)(contentId, draftShareId, useCache));
        if ((0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_emoji_otp', 'isEnabled', false)) immediateResultsPromises.push((0, $hr9NW.preloadEditorNodeDataProvidersData)(contentId));
        if ((0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp')) {
            const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId ?? undefined);
            immediateResultsPromises.push((0, $4trRg.preloadContentMode)({
                contentId: contentId,
                isDraft: !isLivePage,
                useCache: useCache,
                isArchived: isArchived
            }));
        }
        immediateResultsPromises.push((0, $1TElT.preloadEmojiTitle)(contentId, draftShareId, useCache), (0, $9OYfw.preloadNativeCollab)(contentId, draftShareId, useCache));
    }
    immediateResultsPromises.push((0, $65pdw.preloadEditorPageCoverPicture)(contentId, draftShareId, useCache), (0, $3cpum.preloadEditorContentState)({
        contentId: contentId,
        useCache: useCache,
        shouldGetDraftVersion: !isLivePage
    }));
    if (isLivePage) {
        // Pre-loading apps in the byline area for live pages. Currently only live pages have extension point apps and not classic editor.
        immediateResultsPromises.push((0, $4vyfK.preloadWebItemLocation)({
            contentId: contentId,
            location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
        }), // For some reason the addition of the filter (uses new Forge query) is causing SSR to timeout - workaround by skipping the filter
        (0, $8CHHT.preloadUseExtensionList)({
            spaceKey: spaceKey || '',
            moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE),
            skipFilter: true
        }));
        immediateResultsPromises.push((0, $9nGwZ.preloadLastUpdated)(contentId, useCache));
        immediateResultsPromises.push((0, $cRQNp.preloadReadTime)({
            contentId: contentId,
            useCache: useCache
        }));
    }
    if (shouldPreloadMentionsProvider) immediateResultsPromises.push((0, $kDt9L.preloadMentionsProvider)());
    immediateResultsPromises.push((0, $1c0dB.preloadEditorPageTitleContentProperties)({
        contentId: contentId,
        draftShareId: draftShareId,
        useCache: useCache
    }));
    await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $lyWac.waitForAllReturnWhenError)(immediateResultsPromises.map((p)=>!!catchFn ? p?.catch(catchFn) : p));
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    $c13994d6914d469f$var$logger.debug`preloadEditorData complete ${performance.now() / 1000}`;
}
module.exports["preloadEditorData"] = $c13994d6914d469f$export$1149cf9041c3e7b8;

});

parcelRegister("65pdw", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $gr7Mm = parcelRequire("gr7Mm");

function $4e9d3c2f55d09139$export$cca2a63dd6cc6345(contentId, draftShareId, useCache) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $gr7Mm.CoverPictureQuery),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: draftShareId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}
module.exports["preloadEditorPageCoverPicture"] = $4e9d3c2f55d09139$export$cca2a63dd6cc6345;

});

parcelRegister("gr7Mm", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $34fb18e1eff4cb9b$export$32667dced0d2dcef = (0, $eSUdr.default)`query CoverPictureQuery($contentId:ID$status:[String]$draftShareId:String){content(id:$contentId draftShareId:$draftShareId status:$status){nodes{id properties(keys:["cover-picture-id-draft" "cover-picture-id-published"]){nodes{id key value version{number}}}}}}`;
module.exports["CoverPictureQuery"] = $34fb18e1eff4cb9b$export$32667dced0d2dcef;

});

parcelRegister("1TElT", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $87Z8O = parcelRequire("87Z8O");

const $0272cf4ae0232c26$export$a9fe7043b42a1476 = (contentId, draftShareId, useCache)=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $87Z8O.getEmojiTitleProperty),
        variables: {
            contentId: contentId,
            draftShareId: draftShareId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
};
module.exports["preloadEmojiTitle"] = $0272cf4ae0232c26$export$a9fe7043b42a1476;

});

parcelRegister("87Z8O", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $30f101ece1f63b68$export$a6ac8a3b189818d7 = (0, $eSUdr.default)`query getEmojiTitlePropertyQuery($contentId:ID$status:[String]$draftShareId:String$skipPublishedFragment:Boolean!){content(id:$contentId draftShareId:$draftShareId status:$status){nodes{id emojiTitlePublished:properties(key:"emoji-title-published")@skip(if:$skipPublishedFragment){nodes{id key value version{number}}}emojiTitleDraft:properties(key:"emoji-title-draft"){nodes{id key value version{number}}}contentProperties{latest{defaultTitleEmoji}}}}}`;
module.exports["getEmojiTitleProperty"] = $30f101ece1f63b68$export$a6ac8a3b189818d7;

});

parcelRegister("3cpum", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $3lWl0 = parcelRequire("3lWl0");

function $3c6dabb2bbdb2dae$export$fd17b4d4de258fd0({ contentId: contentId, useCache: useCache, shouldGetDraftVersion: shouldGetDraftVersion }) {
    return (0, $dYU3e.query)({
        query: (0, $3lWl0.default),
        variables: {
            contentId: contentId,
            isDraft: shouldGetDraftVersion
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}
module.exports["preloadEditorContentState"] = $3c6dabb2bbdb2dae$export$fd17b4d4de258fd0;

});

parcelRegister("3lWl0", function(module, exports) {
/**
 * @generated SignedSource<<1fc101d910bfadb2619a1fc2d260f5a7>>
 * @relayHash a709390c581a22540e729216746ca889
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a90c8a354e986913f279369cfa4d048ae0d56c417c3d0ac292b15666f329274a
const $34dd87dd4e33f987$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "color"
    }, v4 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isCallerPermitted"
                        }
                    ]
                },
                {
                    "condition": "isDraft",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "format",
                                    "value": "USER_FRIENDLY"
                                }
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ],
                            "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "AvailableContentStates",
            "kind": "LinkedField",
            "name": "availableContentStates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "customContentStates",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "spaceContentStates",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v1 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorContentStateQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorContentStateQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "a709390c581a22540e729216746ca889",
            "id": "a90c8a354e986913f279369cfa4d048ae0d56c417c3d0ac292b15666f329274a",
            "metadata": {},
            "name": "EditorContentStateQuery",
            "operationKind": "query",
            "text": "query EditorContentStateQuery($contentId:ID!,$isDraft:Boolean!){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted},contentStateLastUpdated(format:USER_FRIENDLY)@skip(if:$isDraft){value}},availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$34dd87dd4e33f987$var$node.hash = "6fa3f178648bfd26c6dbf7026f2328a3";
var $34dd87dd4e33f987$export$2e2bcd8739ae039 = $34dd87dd4e33f987$var$node;
module.exports["default"] = $34dd87dd4e33f987$export$2e2bcd8739ae039;

});

parcelRegister("irrTO", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $lztxY = parcelRequire("lztxY");

const $e1546bd447729439$export$f4a1f447ac6a7a9a = (contentId, useCache = true)=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $lztxY.getDraftContentAppearanceProperty),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
};
module.exports["preloadDraftContentAppearance"] = $e1546bd447729439$export$f4a1f447ac6a7a9a;

});

parcelRegister("4trRg", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $flWvL = parcelRequire("flWvL");


var $joyRP = parcelRequire("joyRP");

const $b51af1b6a5dfb3b5$export$79f4fda3b987b044 = ({ contentId: contentId, isDraft: isDraft, useCache: useCache = false, isArchived: isArchived })=>{
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    return (0, $dYU3e.query)({
        query: (0, $joyRP.default),
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
};
module.exports["preloadContentMode"] = $b51af1b6a5dfb3b5$export$79f4fda3b987b044;

});

parcelRegister("kGDoD", function(module, exports) {
$parcel$export(module.exports, "preloadLastUpdated", () => (parcelRequire("9nGwZ")).preloadLastUpdated);

var $9nGwZ = parcelRequire("9nGwZ");


var $9BupY = parcelRequire("9BupY");


});

parcelRegister("9nGwZ", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9BupY = parcelRequire("9BupY");

function $693a95aca15bff58$export$e7a15421d1327843(contentId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $9BupY.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}
module.exports["preloadLastUpdated"] = $693a95aca15bff58$export$e7a15421d1327843;

});

parcelRegister("9BupY", function(module, exports) {
/**
 * @generated SignedSource<<6cd69bb600740f6a687eaabe82eab755>>
 * @relayHash 596c33f2627461693b923b812b6e225f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6f2f69ce739ced471a1cd1301a6cc419fb9a9219690e4c2e066d590fc835235
const $173882722a7c2e36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "when"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LivePagesByLineLastUpdatedQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LivePagesByLineLastUpdatedQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "596c33f2627461693b923b812b6e225f",
            "id": "a6f2f69ce739ced471a1cd1301a6cc419fb9a9219690e4c2e066d590fc835235",
            "metadata": {},
            "name": "LivePagesByLineLastUpdatedQuery",
            "operationKind": "query",
            "text": "query LivePagesByLineLastUpdatedQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,version{friendlyWhen,when}}}}"
        }
    };
}();
$173882722a7c2e36$var$node.hash = "4e6df5756d13dcdcef29e05d538280a7";
var $173882722a7c2e36$export$2e2bcd8739ae039 = $173882722a7c2e36$var$node;
module.exports["default"] = $173882722a7c2e36$export$2e2bcd8739ae039;

});

parcelRegister("1c0dB", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $kae7O = parcelRequire("kae7O");

const $cb49cba09ddc32ea$export$2ea86854c75d3ec8 = async ({ contentId: contentId, draftShareId: draftShareId, useCache: useCache })=>{
    const variables = {
        contentId: contentId,
        status: [
            'current',
            'draft',
            'archived'
        ],
        draftShareId: draftShareId,
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    };
    return (0, $dYU3e.query)({
        query: (0, $kae7O.default),
        variables: variables
    });
};
module.exports["preloadEditorPageTitleContentProperties"] = $cb49cba09ddc32ea$export$2ea86854c75d3ec8;

});

parcelRegister("kae7O", function(module, exports) {
/**
 * @generated SignedSource<<1ac0869ec5d868a961896d33c5ef93ef>>
 * @relayHash 177df4e8b836b390b9636d650c93a7b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612
const $99e3ac9ccccf9f94$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "177df4e8b836b390b9636d650c93a7b2",
            "id": "73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612",
            "metadata": {},
            "name": "useTitleContentPropertiesForEditorQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForEditorQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$99e3ac9ccccf9f94$var$node.hash = "cdd7743e3348e4dc97a35c6808323ae0";
var $99e3ac9ccccf9f94$export$2e2bcd8739ae039 = $99e3ac9ccccf9f94$var$node;
module.exports["default"] = $99e3ac9ccccf9f94$export$2e2bcd8739ae039;

});

parcelRegister("kDt9L", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $egFdh = parcelRequire("egFdh");

const $6bd71bdc26599ad9$export$45c648ba9bf4e12f = async ()=>(0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $egFdh.MentionsProviderQuery)
    });
module.exports["preloadMentionsProvider"] = $6bd71bdc26599ad9$export$45c648ba9bf4e12f;

});

parcelRegister("cRQNp", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $3T2Zj = parcelRequire("3T2Zj");

function $345f814d0887da7c$export$8301c585ee328ce0({ contentId: contentId, includeContentBody: includeContentBody = true, status: status, useCache: useCache }) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $3T2Zj.ReadTimeQuery),
        variables: {
            contentId: contentId,
            includeContentBody: includeContentBody,
            status: status
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}
module.exports["preloadReadTime"] = $345f814d0887da7c$export$8301c585ee328ce0;

});

parcelRegister("3T2Zj", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $bb1db1cfcc51cbce$export$9a0a69714186a2dc = (0, $eSUdr.default)`query ReadTimeQuery($contentId:ID$status:[String]$includeContentBody:Boolean=true){content(id:$contentId status:$status){nodes{id type body@include(if:$includeContentBody){dynamic{value representation}}operations{operation targetType}}}}`;
module.exports["ReadTimeQuery"] = $bb1db1cfcc51cbce$export$9a0a69714186a2dc;

});

parcelRegister("9OYfw", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $dYU3e = parcelRequire("dYU3e");


var $l1kdf = parcelRequire("l1kdf");


var $7ZQNA = parcelRequire("7ZQNA");


var $8R0gj = parcelRequire("8R0gj");


var $hNtOj = parcelRequire("hNtOj");


var $6mKj3 = parcelRequire("6mKj3");


var $27Dus = parcelRequire("27Dus");

function $cb117090d47a4a62$export$952cf09a216eb6d(contentId, draftShareId, useCache) {
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $7ZQNA.CollabDraftQuery),
            variables: {
                id: contentId,
                hydrateAdf: true,
                ...draftShareId ? {
                    draftShareId: draftShareId
                } : undefined
            },
            fetchPolicy: useCache ? 'cache-first' : 'network-only'
        }).then(async (result)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            // There is a bug in appolo client (https://github.com/apollographql/react-apollo/issues/3918)
            // that doesn't preserve the result in caches if there is an error in SSR
            // So we need to preserve the error, to be able to verify it later during render phase in SSR
            if (result?.errors?.some((err)=>(0, $8R0gj.isDraftSSRPreloadPermissionError)(err?.message))) (0, $hNtOj.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('edit');
            // When `platform_editor_smart_card_otp` is enabled, we don't need to set __PRELOADED_LINKS_IN_DRAFT__,
            // because smart link data will be handled by editor's one tick provider.
            if (!(0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'isEnabled', false)) {
                // Preloaded smartlinks don't have contentSlug, while preloaded draft does.
                // Extracting smartlinks from preloaded draft here, so it can be used to fix preloaded smartlinks.
                const preloadedDraftADF = result?.data?.collabDraft?.document || '';
                const urlMatch = /https?:\/\/[^\s"'<>()]+/g;
                window['__PRELOADED_LINKS_IN_DRAFT__'] = preloadedDraftADF.match(urlMatch) || [];
            }
            if ((0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'isEnabled', false)) // There are two reasons to store smart card URLs on the window object:
            // 1. The OTP uses a document snapshot from Confluence that may be outdated and miss recently added or removed smart cards,
            //    so we must reconcile the list of smart cards with the draft content.
            // 2. The draft content stores links with slugs, but the Confluence snapshot does not,
            //    so we need to add slugs sourced from the draft content.
            // Therefore, we extract smart cards from the draft content here, save them on the window object,
            // and later use them to align the Confluence snapshot with the draft content.
            window['__SMART_CARDS_IN_DRAFT__'] = (0, $27Dus.findSmartCardNodes)(result?.data?.collabDraft?.document || '');
            return result;
        });
    })();
}
function $cb117090d47a4a62$export$7c1f00ae06ab82b8(contentId, draftShareId, useCache, status) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $l1kdf.NativeCollabQuery),
        variables: {
            contentId: contentId,
            ...draftShareId && {
                draftShareId: draftShareId
            },
            status: status ?? [
                'draft',
                'current'
            ]
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        context: {
            single: 'true'
        }
    });
}
module.exports["preloadCollabDraftContent"] = $cb117090d47a4a62$export$952cf09a216eb6d;
module.exports["preloadNativeCollab"] = $cb117090d47a4a62$export$7c1f00ae06ab82b8;

});

parcelRegister("8R0gj", function(module, exports) {

var $747ya = parcelRequire("747ya");

async function $65899b702fdd32b1$export$dfd3c4c0aa957792(contentId, draftShareId) {
    window.__PRELOAD_DRAFT__ = {
        contentId: contentId,
        draftFetchPromise: (0, $747ya.fetchDraft)(contentId, draftShareId),
        startTime: window?.performance?.now?.()
    };
}
const $65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR = '.PermissionException: User does not have permission';
function $65899b702fdd32b1$export$9d45b1b64b2cb8e1(message) {
    if (!message) return false;
    return message.indexOf($65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR) > -1 || false;
}
module.exports["preloadDraft"] = $65899b702fdd32b1$export$dfd3c4c0aa957792;
module.exports["isDraftSSRPreloadPermissionError"] = $65899b702fdd32b1$export$9d45b1b64b2cb8e1;

});

parcelRegister("27Dus", function(module, exports) {

var $477dG = parcelRequire("477dG");


var $et4nk = parcelRequire("et4nk");


var $aN0qB = parcelRequire("aN0qB");

function $010c1dfc98319256$export$1970baffe86d32af(docJsonString) {
    if (!docJsonString) return [];
    const doc = JSON.parse(docJsonString);
    const cardProvider = new (0, $477dG.EditorCardProvider)('custom', undefined, 'CONFLUENCE');
    return (0, $et4nk.findNodesToPrefetch)(doc, [
        {
            provider: cardProvider,
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
        }
    ], (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT))[0].nodes;
}
module.exports["findSmartCardNodes"] = $010c1dfc98319256$export$1970baffe86d32af;

});

parcelRegister("et4nk", function(module, exports) {
function $7f5b74af20e3e05b$export$41263783ff0932a8(doc, providers, maxNodesToVisit) {
    // Counter for the total number of visited nodes to limit the traversal.
    let totalVisitedNodesCount = 0;
    // A map to store the results, with the provider name as the key.
    const resultMap = providers.reduce((acc, { provider: provider })=>{
        acc[provider.name] = {
            provider: provider,
            nodes: []
        };
        return acc;
    }, {});
    // It doesn't use `filter` function from `@atlaskit/adf-utils/traverse` because it does not support early stopping.
    // We need to stop traversing when we reach the maximum number of nodes to visit to support large documents.
    // Create a list of providers for which we still need to find nodes.
    const providersToLookup = providers.filter(({ maxNodesToPrefetch: maxNodesToPrefetch })=>maxNodesToPrefetch > 0).map(({ provider: provider, maxNodesToPrefetch: maxNodesToPrefetch })=>({
            provider: provider,
            maxNodesToPrefetch: maxNodesToPrefetch,
            foundNodes: 0
        }));
    // Stack for the depth-first search (DFS), starting with the root document node.
    const nodesToVisit = [
        doc
    ];
    // The loop continues as long as there are nodes to visit, providers to look for,
    // and the visited nodes limit has not been reached.
    while(nodesToVisit.length > 0 && providersToLookup.length > 0 && totalVisitedNodesCount < maxNodesToVisit){
        totalVisitedNodesCount += 1;
        // Pop from the end to maintain DFS order (LIFO - Last In, First Out)
        const currentNode = nodesToVisit.pop();
        if (!currentNode) continue;
        // Using a reverse loop to avoid issues with array mutation (when removing elements).
        for(let i = providersToLookup.length - 1; i >= 0; i--){
            const providerToFind = providersToLookup[i];
            // Check if the current provider supports this node.
            if (providerToFind.provider.isNodeSupported(currentNode)) {
                // If provider supports the node, add it to the result map.
                resultMap[providerToFind.provider.name].nodes.push(currentNode);
                // Increment the count of found nodes for this provider.
                providerToFind.foundNodes += 1;
                // If the provider has found enough nodes, remove it from the lookup list.
                if (providerToFind.foundNodes >= providerToFind.maxNodesToPrefetch) providersToLookup.splice(i, 1);
            }
        }
        // If the current node has children, add them to the stack in reverse order
        // to maintain left-to-right traversal when popping from the stack,
        // because it's LIFO.
        if (currentNode.content) // Push children in reverse order to maintain correct DFS traversal order
        for(let i = currentNode.content.length - 1; i >= 0; i--){
            const node = currentNode.content[i];
            if (node) nodesToVisit.push(node);
        }
    }
    // Return an array of the found nodes, grouped by provider.
    return Object.values(resultMap);
}
module.exports["findNodesToPrefetch"] = $7f5b74af20e3e05b$export$41263783ff0932a8;

});

parcelRegister("aN0qB", function(module, exports) {
// Usually, one screen contains about 2_500 nodes, so 10_000 is more than enough.
const $e5ce665804adc727$export$d723a039341399fc = 10000;
const $e5ce665804adc727$export$109b6787e4cb0d4c = {
    smartCard: 10,
    emoji: 500
};
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT"] = $e5ce665804adc727$export$d723a039341399fc;
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH"] = $e5ce665804adc727$export$109b6787e4cb0d4c;

});

parcelRegister("hr9NW", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $477dG = parcelRequire("477dG");


var $ibzAc = parcelRequire("ibzAc");


var $loQgl = parcelRequire("loQgl");


var $k00oi = parcelRequire("k00oi");


var $ge2sX = parcelRequire("ge2sX");


var $yuV6Z = parcelRequire("yuV6Z");


var $32x2E = parcelRequire("32x2E");


var $9WAeG = parcelRequire("9WAeG");


var $jQQYu = parcelRequire("jQQYu");


var $6mKj3 = parcelRequire("6mKj3");


var $dYU3e = parcelRequire("dYU3e");


var $60cDW = parcelRequire("60cDW");


var $aN0qB = parcelRequire("aN0qB");


var $hXGAG = parcelRequire("hXGAG");


var $kyRHQ = parcelRequire("kyRHQ");

const $8323d63e0ec880b7$var$MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/editor/nodeDataProvidersData';
const $8323d63e0ec880b7$var$DEFAULT_TIMEOUT = 500;
async function $8323d63e0ec880b7$export$82c96ba69b54d1e5(contentId) {
    if (!contentId) return;
    if (!$8323d63e0ec880b7$var$isSSR()) // If we are not in SSR, we don't need to preload node data providers data.
    return;
    await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $9WAeG.SSRMeasures).run($8323d63e0ec880b7$var$MEASURE_SEGMENT, async ()=>{
            const fetchAdfStart = performance.now();
            const docJsonString = await (async ()=>{
                const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
                const _asyncResult2 = await $8323d63e0ec880b7$var$fetchAdf(contentId);
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
                return _asyncResult2;
            })();
            const fetchAdfDuration = performance.now() - fetchAdfStart;
            if (!docJsonString) return;
            const doc = JSON.parse(docJsonString);
            // Should be removed when all experiments are removed
            const experimentTimeouts = [];
            const providers = [];
            if ((0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'isEnabled', false)) {
                providers.push({
                    provider: $8323d63e0ec880b7$var$ssrEditorCardProvider(),
                    maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
                });
                experimentTimeouts.push(Math.max(0, (0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'timeoutStrategy', 'total') === 'total' ? Math.round((0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'timeout', 500) - fetchAdfDuration) : (0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'timeout', 500)));
            }
            if ((0, $6mKj3.expVal)('platform_editor_emoji_otp', 'isEnabled', false)) {
                const sessionData = await (async ()=>{
                    const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
                    const _asyncResult3 = await $8323d63e0ec880b7$var$getSessionData();
                    (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
                    return _asyncResult3;
                })();
                const provider = $8323d63e0ec880b7$var$ssrEmojiNodeDataProvider(sessionData);
                if (provider) {
                    providers.push({
                        provider: provider,
                        maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).emoji
                    });
                    experimentTimeouts.push((0, $6mKj3.expVal)('platform_editor_emoji_otp', 'timeout', 500));
                }
            }
            providers.forEach(({ provider: provider })=>{
                (0, $9WAeG.SSRMeasures).markMeasureStart($8323d63e0ec880b7$var$measureProviderSegment(provider.name));
            });
            const editorNodeDataProvidersData = await (async ()=>{
                const _beforeResult4 = (0, $4JHZe.beforePreloaderAsyncCall)();
                const _asyncResult4 = await (0, $loQgl.prefetchNodeDataProvidersData)({
                    doc: doc,
                    providers: providers,
                    timeout: experimentTimeouts.length > 0 ? Math.min(...experimentTimeouts) : $8323d63e0ec880b7$var$DEFAULT_TIMEOUT,
                    maxNodesToVisit: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT)
                });
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult4);
                return _asyncResult4;
            })();
            Object.entries(editorNodeDataProvidersData).forEach(([providerName, { duration: duration }])=>{
                (0, $9WAeG.SSRMeasures).setMeasureDuration($8323d63e0ec880b7$var$measureProviderSegment(providerName), duration);
            });
            window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] = Object.fromEntries(Object.entries(editorNodeDataProvidersData).map(([providerName, { data: data }])=>[
                    providerName,
                    data
                ]));
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
}
function $8323d63e0ec880b7$var$fetchAdf(contentId) {
    return (0, $9WAeG.SSRMeasures).run(`${$8323d63e0ec880b7$var$MEASURE_SEGMENT}/fetch:AdfDocQuery`, async ()=>{
        try {
            const result = await (async ()=>{
                const _beforeResult5 = (0, $4JHZe.beforePreloaderAsyncCall)();
                const _asyncResult5 = await (0, $dYU3e.query)({
                    /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $hXGAG.AdfDocQuery),
                    variables: {
                        contentId: contentId,
                        status: [
                            'draft'
                        ]
                    },
                    fetchPolicy: 'network-only'
                });
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult5);
                return _asyncResult5;
            })();
            if (result.hasErrors) return undefined;
            return result.data?.singleContent?.body?.atlas_doc_format?.value || undefined;
        } catch  {
            return undefined;
        }
    });
}
function $8323d63e0ec880b7$var$getSessionData() {
    return (0, $9WAeG.SSRMeasures).run(`${$8323d63e0ec880b7$var$MEASURE_SEGMENT}/getSessionData`, async ()=>{
        return (0, $ge2sX.getSessionData)();
    });
}
function $8323d63e0ec880b7$var$ssrEmojiNodeDataProvider(sessionData) {
    const { userId: userId, cloudId: cloudId, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = sessionData;
    // We need a special emoji parameters that supports SSR load optimization here.
    const emojiResourceParams = (0, $yuV6Z.createEmojiProviderParameters)({
        cloudId: cloudId,
        userId: userId,
        isLicensed: isLicensed,
        isLoggedIn: isLoggedIn
    });
    return (0, $32x2E.getEmojiNodeDataProvider)((0, $ibzAc.default), {
        ...emojiResourceParams,
        allowAnonymousAccess: true
    });
}
function $8323d63e0ec880b7$var$ssrEditorCardProvider() {
    const { host: host, cloudId: cloudId, userContext: userContext, customURLs: customURLs } = (0, $60cDW.getSSRRenderInputs)();
    // This URL will be something like `https://object-resolver.staging.atl-paas.net/resolve/batch`.
    // We need only protocol and host to pass it to the EditorCardProvider,
    // because path will be added by `CardClient`.
    const objectResolverURL = customURLs?.['object-resolver-service']?.match(/^(https?:\/\/[^/]+)/)?.[0];
    // We need to define a custom CardClient for SSR, because the default one works through public API gateway.
    const ssrCardClient = new (0, $k00oi.default)('custom', objectResolverURL);
    // Headers from `fetchORSForSSR` from confluence/next/packages/content-smartlinks/src/index.ts
    ssrCardClient.setHeaders({
        Cookie: (0, $jQQYu.createCookie)(userContext),
        Origin: host.startsWith('http') ? host : `https://${host}`,
        CloudId: cloudId
    });
    return new (0, $477dG.EditorCardProvider)('custom', objectResolverURL, 'CONFLUENCE', undefined, ssrCardClient);
}
function $8323d63e0ec880b7$var$isSSR() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        typeof $kyRHQ !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}
function $8323d63e0ec880b7$var$measureProviderSegment(providerName) {
    return `${$8323d63e0ec880b7$var$MEASURE_SEGMENT}/${providerName}`;
}
module.exports["preloadEditorNodeDataProvidersData"] = $8323d63e0ec880b7$export$82c96ba69b54d1e5;

});

parcelRegister("loQgl", function(module, exports) {

var $et4nk = parcelRequire("et4nk");

async function $33eee30649b8eece$export$65217f7ac34c2278({ providers: providers, doc: doc, timeout: timeout, maxNodesToVisit: maxNodesToVisit = Infinity }) {
    if (timeout <= 0) // If the global timeout is 0 or negative, skip fetching entirely.
    return providers.reduce((acc, { provider: provider })=>{
        acc[provider.name] = {
            data: {},
            success: false,
            duration: 0
        };
        return acc;
    }, {});
    const providersWithDefaults = providers.map(({ provider: provider, maxNodesToPrefetch: maxNodesToPrefetch = Infinity, timeout: providerTimeout = Infinity })=>({
            provider: provider,
            maxNodesToPrefetch: maxNodesToPrefetch,
            // Use the minimum of the global timeout and the provider-specific timeout
            timeout: Math.min(providerTimeout, timeout)
        }));
    const providerTimeouts = providersWithDefaults.reduce((acc, { provider: provider, timeout: timeout })=>{
        acc[provider.name] = timeout;
        return acc;
    }, {});
    const nodesWithProviders = (0, $et4nk.findNodesToPrefetch)(doc, providersWithDefaults, maxNodesToVisit).map(({ provider: provider, nodes: nodes })=>({
            provider: provider,
            nodes: nodes,
            timeout: providerTimeouts[provider.name]
        }));
    const promises = nodesWithProviders.map(async ({ nodes: nodes, provider: provider, timeout: timeout })=>{
        if (timeout <= 0) return {
            provider: provider,
            success: false,
            duration: 0,
            nodes: nodes,
            data: []
        };
        const start = performance.now();
        function getDurationFromStart() {
            return Math.min(performance.now() - start, timeout);
        }
        try {
            const timeoutPromise = new Promise((_, reject)=>{
                setTimeout(()=>{
                    reject();
                }, timeout);
            });
            const data = await Promise.race([
                provider.fetchNodesData(nodes),
                timeoutPromise
            ]);
            return {
                provider: provider,
                success: true,
                duration: getDurationFromStart(),
                nodes: nodes,
                data: data
            };
        } catch  {
            return {
                provider: provider,
                success: false,
                duration: getDurationFromStart(),
                nodes: nodes,
                data: []
            };
        }
    });
    const results = await Promise.all(promises);
    return results.reduce((acc, { provider: provider, success: success, duration: duration, nodes: nodes, data: data })=>{
        const ssrData = data.reduce((providerSsrData, nodeData, nodeIndex)=>{
            const node = nodes[nodeIndex];
            const nodeDataKey = provider.nodeDataKey(node);
            providerSsrData[nodeDataKey] = nodeData;
            return providerSsrData;
        }, {});
        acc[provider.name] = {
            data: ssrData,
            success: success,
            duration: duration
        };
        return acc;
    }, {});
}
module.exports["prefetchNodeDataProvidersData"] = $33eee30649b8eece$export$65217f7ac34c2278;

});

parcelRegister("jQQYu", function(module, exports) {
// Creates a cookie for object-resolver header
const $64671b371f568ec9$export$7892c26d6c7a7447 = (userContext)=>{
    const cookieTarget = 'cloud.session.token';
    return `${cookieTarget}=${userContext}`;
};
module.exports["createCookie"] = $64671b371f568ec9$export$7892c26d6c7a7447;

});

parcelRegister("hXGAG", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $c207ef781d729b17$export$689ef413c8a1032c = (0, $eSUdr.default)`query AdfDocQuery($contentId:ID$status:[String]){singleContent(id:$contentId status:$status){id body{atlas_doc_format{value}}}}`;
module.exports["AdfDocQuery"] = $c207ef781d729b17$export$689ef413c8a1032c;

});

parcelRegister("7azCD", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");



/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.10.1
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2023
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    'use strict';
    var ERROR = 'input is invalid type';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof $kyRHQ === 'object' && $kyRHQ.versions && $kyRHQ.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    var OUTPUT_TYPES = [
        'hex',
        'array',
        'digest',
        'arrayBuffer'
    ];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, is224) {
        return function(message) {
            return new Sha256(is224, true).update(message)[outputType]();
        };
    };
    var createMethod = function(is224) {
        var method = createOutputMethod('hex', is224);
        if (NODE_JS) method = nodeWrap(method, is224);
        method.create = function() {
            return new Sha256(is224);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, is224);
        }
        return method;
    };
    var nodeWrap = function(method, is224) {
        var crypto = (parcelRequire("h1hUh"));
        var Buffer = (parcelRequire("h1hUh")).Buffer;
        var algorithm = is224 ? 'sha224' : 'sha256';
        var bufferFrom;
        if (Buffer.from && !root.JS_SHA256_NO_BUFFER_FROM) bufferFrom = Buffer.from;
        else bufferFrom = function(message) {
            return new Buffer(message);
        };
        var nodeMethod = function(message) {
            if (typeof message === 'string') return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
            else {
                if (message === null || message === undefined) throw new Error(ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) return crypto.createHash(algorithm).update(bufferFrom(message)).digest('hex');
            else return method(message);
        };
        return nodeMethod;
    };
    var createHmacOutputMethod = function(outputType, is224) {
        return function(key, message) {
            return new HmacSha256(key, is224, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(is224) {
        var method = createHmacOutputMethod('hex', is224);
        method.create = function(key) {
            return new HmacSha256(key, is224);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, is224);
        }
        return method;
    };
    function Sha256(is224, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (is224) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
        } else {
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
        }
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
        this.is224 = is224;
    }
    Sha256.prototype.update = function(message) {
        if (this.finalized) return;
        var notString, type = typeof message;
        if (type !== 'string') {
            if (type === 'object') {
                if (message === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 64; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.block = blocks[16];
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha256.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[16] = this.block;
        blocks[i >> 2] |= EXTRA[i & 3];
        this.block = blocks[16];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[15] = this.bytes << 3;
        this.hash();
    };
    Sha256.prototype.hash = function() {
        var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
        for(j = 16; j < 64; ++j){
            // rightrotate
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
        }
        bc = b & c;
        for(j = 0; j < 64; j += 4){
            if (this.first) {
                if (this.is224) {
                    ab = 300032;
                    t1 = blocks[0] - 1413257819;
                    h = t1 - 150054599 << 0;
                    d = t1 + 24177077 << 0;
                } else {
                    ab = 704751109;
                    t1 = blocks[0] - 210244248;
                    h = t1 - 1521486534 << 0;
                    d = t1 + 143694565 << 0;
                }
                this.first = false;
            } else {
                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                ab = a & b;
                maj = ab ^ a & c ^ bc;
                ch = e & f ^ ~e & g;
                t1 = h + s1 + ch + K[j] + blocks[j];
                t2 = s0 + maj;
                h = d + t1 << 0;
                d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
            this.chromeBugWorkAround = true;
        }
        this.h0 = this.h0 + a << 0;
        this.h1 = this.h1 + b << 0;
        this.h2 = this.h2 + c << 0;
        this.h3 = this.h3 + d << 0;
        this.h4 = this.h4 + e << 0;
        this.h5 = this.h5 + f << 0;
        this.h6 = this.h6 + g << 0;
        this.h7 = this.h7 + h << 0;
    };
    Sha256.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var hex = HEX_CHARS[h0 >> 28 & 0x0F] + HEX_CHARS[h0 >> 24 & 0x0F] + HEX_CHARS[h0 >> 20 & 0x0F] + HEX_CHARS[h0 >> 16 & 0x0F] + HEX_CHARS[h0 >> 12 & 0x0F] + HEX_CHARS[h0 >> 8 & 0x0F] + HEX_CHARS[h0 >> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >> 28 & 0x0F] + HEX_CHARS[h1 >> 24 & 0x0F] + HEX_CHARS[h1 >> 20 & 0x0F] + HEX_CHARS[h1 >> 16 & 0x0F] + HEX_CHARS[h1 >> 12 & 0x0F] + HEX_CHARS[h1 >> 8 & 0x0F] + HEX_CHARS[h1 >> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >> 28 & 0x0F] + HEX_CHARS[h2 >> 24 & 0x0F] + HEX_CHARS[h2 >> 20 & 0x0F] + HEX_CHARS[h2 >> 16 & 0x0F] + HEX_CHARS[h2 >> 12 & 0x0F] + HEX_CHARS[h2 >> 8 & 0x0F] + HEX_CHARS[h2 >> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >> 28 & 0x0F] + HEX_CHARS[h3 >> 24 & 0x0F] + HEX_CHARS[h3 >> 20 & 0x0F] + HEX_CHARS[h3 >> 16 & 0x0F] + HEX_CHARS[h3 >> 12 & 0x0F] + HEX_CHARS[h3 >> 8 & 0x0F] + HEX_CHARS[h3 >> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >> 28 & 0x0F] + HEX_CHARS[h4 >> 24 & 0x0F] + HEX_CHARS[h4 >> 20 & 0x0F] + HEX_CHARS[h4 >> 16 & 0x0F] + HEX_CHARS[h4 >> 12 & 0x0F] + HEX_CHARS[h4 >> 8 & 0x0F] + HEX_CHARS[h4 >> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >> 28 & 0x0F] + HEX_CHARS[h5 >> 24 & 0x0F] + HEX_CHARS[h5 >> 20 & 0x0F] + HEX_CHARS[h5 >> 16 & 0x0F] + HEX_CHARS[h5 >> 12 & 0x0F] + HEX_CHARS[h5 >> 8 & 0x0F] + HEX_CHARS[h5 >> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >> 28 & 0x0F] + HEX_CHARS[h6 >> 24 & 0x0F] + HEX_CHARS[h6 >> 20 & 0x0F] + HEX_CHARS[h6 >> 16 & 0x0F] + HEX_CHARS[h6 >> 12 & 0x0F] + HEX_CHARS[h6 >> 8 & 0x0F] + HEX_CHARS[h6 >> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
        if (!this.is224) hex += HEX_CHARS[h7 >> 28 & 0x0F] + HEX_CHARS[h7 >> 24 & 0x0F] + HEX_CHARS[h7 >> 20 & 0x0F] + HEX_CHARS[h7 >> 16 & 0x0F] + HEX_CHARS[h7 >> 12 & 0x0F] + HEX_CHARS[h7 >> 8 & 0x0F] + HEX_CHARS[h7 >> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
        return hex;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var arr = [
            h0 >> 24 & 0xFF,
            h0 >> 16 & 0xFF,
            h0 >> 8 & 0xFF,
            h0 & 0xFF,
            h1 >> 24 & 0xFF,
            h1 >> 16 & 0xFF,
            h1 >> 8 & 0xFF,
            h1 & 0xFF,
            h2 >> 24 & 0xFF,
            h2 >> 16 & 0xFF,
            h2 >> 8 & 0xFF,
            h2 & 0xFF,
            h3 >> 24 & 0xFF,
            h3 >> 16 & 0xFF,
            h3 >> 8 & 0xFF,
            h3 & 0xFF,
            h4 >> 24 & 0xFF,
            h4 >> 16 & 0xFF,
            h4 >> 8 & 0xFF,
            h4 & 0xFF,
            h5 >> 24 & 0xFF,
            h5 >> 16 & 0xFF,
            h5 >> 8 & 0xFF,
            h5 & 0xFF,
            h6 >> 24 & 0xFF,
            h6 >> 16 & 0xFF,
            h6 >> 8 & 0xFF,
            h6 & 0xFF
        ];
        if (!this.is224) arr.push(h7 >> 24 & 0xFF, h7 >> 16 & 0xFF, h7 >> 8 & 0xFF, h7 & 0xFF);
        return arr;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0);
        dataView.setUint32(4, this.h1);
        dataView.setUint32(8, this.h2);
        dataView.setUint32(12, this.h3);
        dataView.setUint32(16, this.h4);
        dataView.setUint32(20, this.h5);
        dataView.setUint32(24, this.h6);
        if (!this.is224) dataView.setUint32(28, this.h7);
        return buffer;
    };
    function HmacSha256(key, is224, sharedMemory) {
        var i, type = typeof key;
        if (type === 'string') {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >> 12;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >> 18;
                    bytes[index++] = 0x80 | code >> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        } else {
            if (type === 'object') {
                if (key === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
        }
        if (key.length > 64) key = new Sha256(is224, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha256.call(this, is224, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
        Sha256.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha256.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha256 = exports.sha256;
        root.sha224 = exports.sha224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});

parcelRegister("1R4Hk", function(module, exports) {

var $cOrQJ = parcelRequire("cOrQJ");

const $c6444b27b54a07b6$export$a38bb9a8c9e5bc30 = ()=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    return {
        iconThemed: (colors)=>{
            return colorMode && colorMode === 'dark' ? colors['dark'] : colors['light'];
        }
    };
};
module.exports["useIconThemed"] = $c6444b27b54a07b6$export$a38bb9a8c9e5bc30;

});

parcelRegister("lvsjl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa82743632a2ad8f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $fa82743632a2ad8f$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $42omo.useRef)(null);
    var maxWaitArgs = (0, $42omo.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $42omo.useRef)(false);
    var functionTimeoutHandler = (0, $42omo.useRef)(null);
    var isComponentUnmounted = (0, $42omo.useRef)(false);
    var debouncedFunction = (0, $42omo.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $42omo.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $42omo.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $42omo.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $42omo.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("8wyJO", function(module, exports) {

var $ibGN4 = parcelRequire("ibGN4");


var $3V1KT = parcelRequire("3V1KT");

const $01eec1a417789222$export$17ab88ef0193bb4 = (data)=>{
    if (!data) return data;
    if ($01eec1a417789222$var$isConfluenceContentReactions(data)) return data?.confluence_contentReactionsSummary?.contentReactionsSummary?.[0];
    if ($01eec1a417789222$var$isContentReactions(data)) return data?.content?.nodes?.[0]?.contentReactionsSummary;
    if ($01eec1a417789222$var$isCommentReactions(data)) return data?.comments?.nodes?.[0]?.reactionsSummary;
};
const $01eec1a417789222$var$isConfluenceContentReactions = (data)=>Boolean(data.confluence_contentReactionsSummary);
const $01eec1a417789222$var$isContentReactions = (data)=>Boolean(data.content);
const $01eec1a417789222$var$isCommentReactions = (data)=>Boolean(data.comments);
const $01eec1a417789222$var$getReactionsContentQuery = ()=>{
    return 0, $3V1KT.ReactionsContentQuery;
};
const $01eec1a417789222$export$d765e1092b1f36ff = (isComment, contentId, containerId)=>{
    const query = isComment ? (0, $ibGN4.ReactionsCommentsQuery) : $01eec1a417789222$var$getReactionsContentQuery();
    const queryVariables = isComment ? {
        contentId: contentId,
        containerId: containerId
    } : {
        contentId: contentId
    };
    return {
        query: query,
        queryVariables: queryVariables
    };
};
module.exports["getReactionsSummary"] = $01eec1a417789222$export$17ab88ef0193bb4;
module.exports["getReactionsQueryInfo"] = $01eec1a417789222$export$d765e1092b1f36ff;

});

parcelRegister("ibGN4", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $0c4d3fd1a40dc0de$export$c0002d0cc70e364a = (0, $eSUdr.default)`query ReactionsCommentsQuery($contentId:ID!$containerId:ID!){comments(commentId:$contentId contentStatus:[DRAFT CURRENT]){nodes{id reactionsSummary(pageId:$containerId contentType:"page" childType:"comment"){reactionsCount ari containerAri reactionsSummaryForEmoji{emojiId count reacted id}}}}}`;
module.exports["ReactionsCommentsQuery"] = $0c4d3fd1a40dc0de$export$c0002d0cc70e364a;

});

parcelRegister("3V1KT", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $bb6fcff23ee99252$export$d1ed7f06ad741aec = (0, $eSUdr.default)`query ReactionsContentQuery($contentId:ID!){content(id:$contentId){nodes{id contentReactionsSummary{reactionsCount ari containerAri reactionsSummaryForEmoji{emojiId count reacted id}}}}}`;
const $bb6fcff23ee99252$export$d86780bd83b9ba91 = (0, $eSUdr.default)`query ConfluenceReactionsContentQuery($cloudId:ID!$contentId:ID!$contentType:GraphQLReactionContentType!){confluence_contentReactionsSummary(cloudId:$cloudId contentType:$contentType contentId:$contentId){contentReactionsSummary:reactionsSummary{reactionsCount ari containerAri reactionsSummaryForEmoji{emojiId count reacted id}}}}`;
module.exports["ReactionsContentQuery"] = $bb6fcff23ee99252$export$d1ed7f06ad741aec;

});

parcelRegister("9inwL", function(module, exports) {
/**
 * @generated SignedSource<<967d9b0950589c371f008ac197749b99>>
 * @relayHash 84e141f4639993fa671b560586b064ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8efac480ec4a436c1a451826fa401d62a5e1cb57c29989be5ed579813655fbf2
const $5791e6e7c338c837$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "missingSpaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "missingSpaceKey",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "84e141f4639993fa671b560586b064ac",
            "id": "8efac480ec4a436c1a451826fa401d62a5e1cb57c29989be5ed579813655fbf2",
            "metadata": {},
            "name": "ContentPrerequisitesQuery",
            "operationKind": "query",
            "text": "query ContentPrerequisitesQuery($contentId:ID!,$missingSpaceKey:Boolean=false,$spaceKey:String){content(id:$contentId){nodes{id,type,space{id,key,alias}}},space(key:$spaceKey)@skip(if:$missingSpaceKey){id,name}}"
        }
    };
}();
$5791e6e7c338c837$var$node.hash = "0027e387b6111f3e5ddcfb9450c87857";
var $5791e6e7c338c837$export$2e2bcd8739ae039 = $5791e6e7c338c837$var$node;
module.exports["default"] = $5791e6e7c338c837$export$2e2bcd8739ae039;

});

parcelRegister("4uNpa", function(module, exports) {
/**
 * @generated SignedSource<<9fa9040e4353965e7d75ef028f1e3386>>
 * @relayHash 81e3b75d8ec7e8341dfb9fe5d7c36fac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911
const $2411ee21620b66c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionOverride"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "versionOverride"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "homepageId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "81e3b75d8ec7e8341dfb9fe5d7c36fac",
            "id": "9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911",
            "metadata": {},
            "name": "ContentRedirectQuery",
            "operationKind": "query",
            "text": "query ContentRedirectQuery($contentId:ID,$versionOverride:Int){content(id:$contentId,version:$versionOverride){nodes{id,title,space{id,homepageId,key,alias},history{createdDate}}}}"
        }
    };
}();
$2411ee21620b66c4$var$node.hash = "440c7fc38cc16d750fa69bd87e3ba7c2";
var $2411ee21620b66c4$export$2e2bcd8739ae039 = $2411ee21620b66c4$var$node;
module.exports["default"] = $2411ee21620b66c4$export$2e2bcd8739ae039;

});

parcelRegister("4XcQZ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $dcd0924fd6cc7ace$export$d322defea4af96d5 = (0, $eSUdr.default)`query EndOfPageRecommendationQuery($type:String!$id:ID!$exp:String!$key:ID!$keyString:String!){space(key:$keyString){id}getRecommendedPages(entityType:$type entityId:$id experience:$exp){recommendedPages{content{id title type subType creatorId links{webui}history{ownedBy{displayName}}space{id key name}emoji:properties(key:"emoji-title-published"){nodes{id key value}}}strategy}status{userCanToggle isEnabled}}getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled defaultBehavior}}`;
module.exports["EndOfPageRecommendationQuery"] = $dcd0924fd6cc7ace$export$d322defea4af96d5;

});

parcelRegister("8G3G6", function(module, exports) {
/**
 * @generated SignedSource<<6f07c4fac57f6dc212d11302afa5f44f>>
 * @relayHash 4454a52ea4ab532f76ee4e80586f3a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87
const $3a0ab9c788e793cd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4454a52ea4ab532f76ee4e80586f3a56",
            "id": "1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87",
            "metadata": {},
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonCatchupLastViewedTimeQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$3a0ab9c788e793cd$var$node.hash = "4580906c8b823122d6a7f5ad8c2e2c6c";
var $3a0ab9c788e793cd$export$2e2bcd8739ae039 = $3a0ab9c788e793cd$var$node;
module.exports["default"] = $3a0ab9c788e793cd$export$2e2bcd8739ae039;

});

parcelRegister("gyneS", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $b0a4ea0e16bf0a49$export$c154c9d0522d550a = (0, $eSUdr.default)`query ShareAndRestrictButtonQuery($contentId:ID!$isContentTypePublicLinkEligible:Boolean!){singleContent(id:$contentId){id hasInheritedRestrictions hasRestrictions hasViewRestrictions title}publicLinkPage(pageId:$contentId)@include(if:$isContentTypePublicLinkEligible){pageId pageStatus}}`;
module.exports["ShareAndRestrictButtonQuery"] = $b0a4ea0e16bf0a49$export$c154c9d0522d550a;

});

parcelRegister("1ydBT", function(module, exports) {
/**
 * @generated SignedSource<<6688445582ee3073cb3b58fe45106be1>>
 * @relayHash 917128614372b454a0c92f921e265a3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d247e68f7dc475170950704c1ecdbb1f5c61bcfd1fd837a33a67fbd4b418b0bb
const $4edc52e24113851d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v11 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v13 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v14 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v11 /*: any*/ 
    }, v15 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v21 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v23 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v24 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "number"
    }, v26 = {
        "kind": "ScalarField",
        "name": "when"
    }, v27 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "confluenceCommentFilter",
                    "value": {
                        "commentState": "UNRESOLVED",
                        "commentType": "FOOTER"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": [
                        "FOOTER"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v21 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": v27 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": v27 /*: any*/ 
        },
        "params": {
            "cacheID": "917128614372b454a0c92f921e265a3f",
            "id": "d247e68f7dc475170950704c1ecdbb1f5c61bcfd1fd837a33a67fbd4b418b0bb",
            "metadata": {},
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "operationKind": "query",
            "text": "query ObjectCommentContainerPreloadObjectCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first,type:[FOOTER],confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER}){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$4edc52e24113851d$var$node.hash = "0538003061ae5e768497e01082e44e58";
var $4edc52e24113851d$export$2e2bcd8739ae039 = $4edc52e24113851d$var$node;
module.exports["default"] = $4edc52e24113851d$export$2e2bcd8739ae039;

});

parcelRegister("MJaSd", function(module, exports) {

var $kgNLQ = parcelRequire("kgNLQ");

const $eeebfa790a4a25a5$export$c6ff0a0df62acf44 = 3;
const $eeebfa790a4a25a5$export$533048ab2aed5b1a = -1;
// Default empty preload data structure (can be spread and isDataProcessed overridden)
const $eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA = {
    allComments: [],
    allFilteredComments: [],
    openInlineComments: [],
    openFooterComments: [],
    resolvedComments: [],
    openComments: [],
    commentsDataMap: {
        inline: {},
        general: {}
    },
    flatCommentsMap: {},
    hasNestedComments: false,
    commentCount: 0,
    hasAnyComments: false,
    isDataProcessed: false
};
const $eeebfa790a4a25a5$export$fa19d42490144c8 = (contentId)=>({
        pageId: contentId,
        // Query for all comments regardless of status (although skip deleted since we have no way to show it), we'll filter on the FE
        contentStatus: [
            'DRAFT',
            'CURRENT',
            'ARCHIVED'
        ],
        first: $eeebfa790a4a25a5$export$c6ff0a0df62acf44
    });
const $eeebfa790a4a25a5$export$7cc295d5a932445b = (processedPreloadData, preloadCacheData)=>{
    if (!processedPreloadData.isDataProcessed || !preloadCacheData?.comments) return false;
    const totalCount = preloadCacheData.comments.totalCount;
    // If totalCount is the loading flag, we're still loading
    if (totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a) return false;
    // Calculate loaded comment count (parent comments + replies)
    const loadedCommentCount = preloadCacheData.comments.nodes?.reduce((acc, comment)=>{
        if (!comment) return acc;
        return acc + (comment?.replies?.length || 0) + 1; // parent + reply count
    }, 0) ?? 0;
    // Check if we've loaded all available comments
    return loadedCommentCount === totalCount;
};
const $eeebfa790a4a25a5$export$e229b0e2973dcb38 = (processedCommentsData, preloadCacheData, contentStatus)=>{
    // Check cache value to determine if we're in a loading state (totalCount === -1)
    const isPreloadLoadingFromCache = preloadCacheData?.comments?.totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a;
    // Process preload data
    // Don't process if we're loading (check cache value, not loading state)
    let processedPreloadData;
    if (isPreloadLoadingFromCache) processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    else if (preloadCacheData?.comments) {
        if (preloadCacheData.comments.nodes) {
            const allComments = (preloadCacheData.comments.nodes || []).filter((node)=>node !== null);
            // Filter preload comments by the contentStatus prop (same as CommentsDataBackgroundLoader does)
            // This ensures we only show comments that match the current page's content status
            const categorized = (0, $kgNLQ.categorizeComments)(allComments, contentStatus);
            processedPreloadData = {
                allComments: allComments,
                ...categorized,
                isDataProcessed: true
            };
        } else processedPreloadData = {
            ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
            isDataProcessed: true
        };
    } else processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    // Determine which data source to use
    // If ProcessedCommentsDataStore has processed data, use that
    // Otherwise, use the preload query data
    const hasFullData = processedCommentsData.isDataProcessed;
    // Calculate if all data has been preloaded
    const allDataPreloaded = $eeebfa790a4a25a5$export$7cc295d5a932445b(processedPreloadData, preloadCacheData);
    // Dynamically determine the data to return based on current state
    // isDataProcessed always comes from ProcessedCommentsDataStore
    // Only the comment data itself comes from preload when full data isn't available
    const finalData = hasFullData ? processedCommentsData : {
        ...processedCommentsData,
        // Override comment data with preload data, but keep isDataProcessed from store
        ...processedPreloadData,
        isDataProcessed: processedCommentsData.isDataProcessed,
        error: processedCommentsData.error
    };
    return {
        ...finalData,
        // Keep separate vars for preload loading status so we don't have to assert isPreloading && ... everywhere
        isPreloadLoading: isPreloadLoadingFromCache,
        isPreloadDataProcessed: processedPreloadData.isDataProcessed,
        // Indicate whether preload completed with comments (for SSR placeholder display)
        preloadCompletedWithComments: processedPreloadData.isDataProcessed && processedPreloadData.allFilteredComments.length > 0,
        allDataPreloaded: // Indicate whether the preload contained ALL comments
        allDataPreloaded,
        // Indicate whether we're currently using full data or preload data
        isUsingFullData: hasFullData
    };
};
module.exports["PRELOAD_LOADING_FLAG"] = $eeebfa790a4a25a5$export$533048ab2aed5b1a;
module.exports["buildPreloadObjectCommentsQueryVariables"] = $eeebfa790a4a25a5$export$fa19d42490144c8;
module.exports["getPreloadAwareObjectComments"] = $eeebfa790a4a25a5$export$e229b0e2973dcb38;

});

parcelRegister("jW8MZ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $a0da224f0094931c$export$658cf1ccfcb3ce94 = (0, $eSUdr.default)`query ViewSpaceExternalCollaboratorsDialogQuery($spaceKey:String){space(key:$spaceKey){id name externalCollaboratorCount currentUser{isAdmin}}}`;
module.exports["ViewSpaceExternalCollaboratorsDialogQuery"] = $a0da224f0094931c$export$658cf1ccfcb3ce94;

});

parcelRegister("eohUr", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $59d9e9a16ad897c7$export$944151d365bd26d2 = (0, $eSUdr.default)`query SpaceShortcutsSpaceNavigationQuery($spaceKey:String){spaceSidebarLinks(spaceKey:$spaceKey){quick{id url position title styleClass}}}`;
module.exports["SpaceShortcutsSpaceNavigationQuery"] = $59d9e9a16ad897c7$export$944151d365bd26d2;

});

parcelRegister("MyxIQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bnKhH = parcelRequire("bnKhH");


var $5dPMD = parcelRequire("5dPMD");


var $301rJ = parcelRequire("301rJ");



var $60cDW = parcelRequire("60cDW");


var $d6NtA = parcelRequire("d6NtA");


var $d5fg6 = parcelRequire("d5fg6");


var $0VKZa = parcelRequire("0VKZa");

/**
 * Post Office class for managing in memory cache of Placement queries.
 * We store the cache reference on the global object to persist across SSR requests.
 */ const $cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE = globalThis?.__POST_OFFICE_QUERY_CACHE__ || {};
const $cdd1e9f9feeb24fd$var$postOfficeClient = new (0, $d5fg6.PostOfficeCacheClient)($cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE);
const $cdd1e9f9feeb24fd$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $cdd1e9f9feeb24fd$export$b3732c8ff6f9c463 = (res)=>{
    if (typeof res === 'undefined') throw new Error('No response from server');
    if (res.ok) return res;
    throw new Error($cdd1e9f9feeb24fd$export$18a0019e5439b209(res));
};
const $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse = (data)=>{
    const init = {
        status: 200,
        statusText: 'ok!'
    };
    return new Response(JSON.stringify(data), init);
};
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $cdd1e9f9feeb24fd$var$getIsSSR = ()=>Boolean(undefined);
const $cdd1e9f9feeb24fd$var$confluenceFetcher = async (url, headers, requestInit)=>{
    // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Transition preloaders
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
        const cachedFetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
        if (cachedFetcher) return cachedFetcher;
    }
    let fetcher;
    fetcher = (0, $5dPMD.defaultFetcher)(url, headers, requestInit);
    fetcher = fetcher.then($cdd1e9f9feeb24fd$export$b3732c8ff6f9c463).then((res)=>res.json()).then((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithUrl(url, data);
        return $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data);
    });
    // When we're in SPA mode, we want to cache the fetcher so that it can be reused
    // if the network request takes too long and the data doesn't come back in time
    // before another request is requested by <Placement>
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) $cdd1e9f9feeb24fd$var$postOfficeClient.setFetcherWithUrl(url, fetcher);
    return fetcher;
};
const $cdd1e9f9feeb24fd$var$cookieMap = new Map([
    [
        'consentToken',
        (0, $301rJ.ATLASSIAN_CONSENT_COOKIE_KEY)
    ],
    [
        'fallbackConsentToken',
        (0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)
    ]
]);
const $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders = (cookies)=>{
    if (typeof cookies !== 'object' || cookies === null) return undefined;
    return Array.from($cdd1e9f9feeb24fd$var$cookieMap.entries()).map(([key, value])=>{
        if (cookies[key]) return `${value}=${cookies[key]}`;
        return '';
    }).filter(Boolean).join(';');
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $cdd1e9f9feeb24fd$var$preloadPostOfficePlacement = async (placementId, contextOptions, extraFetchOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    const confluenceFetcherWithS2SHeaders = async (url)=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        if (isSSR) {
            let hostEnv = 'prod';
            if (environment.currentEnv !== 'production') hostEnv = 'staging';
            const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken } = (0, $60cDW.getSSRRenderInputs)();
            const cookies = $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders({
                consentToken: cookiesConsentToken,
                fallbackConsentToken: cookiesFallbackToken
            });
            const fetchHeaders = !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'post-office',
                // Tells Tesseract to S2S with `post-office`
                'x-ssr-service-env': hostEnv // Defaults to current Env, however Post Office is not in dev
            } : {};
            if (cookies) fetchHeaders.Cookie = cookies;
            const finalUrl = (0, $d6NtA.isLocal)() ? url : url.replace('gateway/api/post-office/', '');
            return $cdd1e9f9feeb24fd$var$confluenceFetcher(finalUrl, fetchHeaders, extraFetchOptions?.requestInit);
        }
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, undefined, extraFetchOptions?.requestInit);
    };
    const basePath = (0, $bnKhH.buildBasePath)(environment.currentEnv, environment.envConfigs);
    return (0, $5dPMD.requestInitialData)(placementId, postOfficeContext, confluenceFetcherWithS2SHeaders, {
        ...basePath,
        resource: extraFetchOptions?.resource
    });
};
const $cdd1e9f9feeb24fd$export$420f2f91a928b3b6 = ()=>{
    return (0, $42omo.useCallback)((url, requestOptions)=>{
        // Use data in cache if it exists
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithUrl(url);
        if (data) /**
       * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
       * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
       */ return Promise.resolve($cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data));
        // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Placement component
        if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
            const fetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
            if (fetcher) return fetcher;
        }
        // Convert headers to Record<string, string> if present
        let headers = {};
        if (requestOptions?.headers) {
            if (requestOptions.headers instanceof Headers) requestOptions.headers.forEach((value, name)=>{
                headers[name] = value;
            });
            else if (Array.isArray(requestOptions.headers)) requestOptions.headers.forEach(([name, value])=>{
                headers[name] = value;
            });
            else headers = requestOptions.headers;
        }
        // Use a new fetcher if neither data nor fetcher is in cache
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, headers, requestOptions);
    }, []);
};
const $cdd1e9f9feeb24fd$export$17b92961ead3f211 = (placementId)=>{
    const [preloadedData, setPreloadedData] = (0, $42omo.useState)(()=>{
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithPlacementId(placementId);
        if (data) return data;
        return undefined;
    });
    const setter = (0, $42omo.useCallback)((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithPlacementId(placementId, data);
        setPreloadedData(data);
    }, [
        placementId
    ]);
    return [
        preloadedData,
        setter
    ];
};
const $cdd1e9f9feeb24fd$export$1d2f4123d64ba093 = async (placementId, preloadedSessionContext, extraFetchOptions)=>{
    return $cdd1e9f9feeb24fd$var$preloadPostOfficePlacement(placementId, {
        postOfficeContext: (0, $0VKZa.sessionToPostOfficeContext)(preloadedSessionContext),
        environment: {
            currentEnv: (0, $0VKZa.transformConfluenceEnvToPostOfficeEnvironment)(preloadedSessionContext.environment)
        }
    }, extraFetchOptions);
};
module.exports["usePlacementSSRFetch"] = $cdd1e9f9feeb24fd$export$420f2f91a928b3b6;
module.exports["usePlacementPreloadedData"] = $cdd1e9f9feeb24fd$export$17b92961ead3f211;
module.exports["preloadPostOfficePlacementWithSessionContext"] = $cdd1e9f9feeb24fd$export$1d2f4123d64ba093;

});

parcelRegister("bnKhH", function(module, exports) {

var $7kqqb = parcelRequire("7kqqb");


var $c3xd8 = parcelRequire("c3xd8");

const $121828a65173ad3f$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $c3xd8.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $7kqqb.API_PATHNAME_STG_PROD);
    return {
        baseUrl: baseUrl,
        path: path
    };
};
module.exports["buildBasePath"] = $121828a65173ad3f$export$e8b30f9c4a80230f;

});

parcelRegister("7kqqb", function(module, exports) {
const $5d54839cd273dd72$export$5ca004be156a127a = 'http://localhost:4224';
const $5d54839cd273dd72$export$a5c5394c951a9848 = '/gateway/api/post-office/api/v1/placements/';
const $5d54839cd273dd72$export$1e9fed4c0197724c = 'http://localhost:8081';
const $5d54839cd273dd72$export$919a9569bce66f17 = '/api/v1/placements/';
const $5d54839cd273dd72$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $5d54839cd273dd72$export$67be2569ef5d7666 = 'http://localhost:9009';
const $5d54839cd273dd72$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $5d54839cd273dd72$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';
module.exports["API_ORIGIN_TEST_SERVER"] = $5d54839cd273dd72$export$5ca004be156a127a;
module.exports["API_PATHNAME_TEST_SERVER"] = $5d54839cd273dd72$export$a5c5394c951a9848;
module.exports["API_ORIGIN_LOCAL"] = $5d54839cd273dd72$export$1e9fed4c0197724c;
module.exports["API_PATHNAME_LOCAL"] = $5d54839cd273dd72$export$919a9569bce66f17;
module.exports["API_PATHNAME_STG_PROD"] = $5d54839cd273dd72$export$d4fe3482c88e73a8;
module.exports["REMOTE_MODULE_URI_LOCAL"] = $5d54839cd273dd72$export$67be2569ef5d7666;
module.exports["REMOTE_MODULE_URI_STG"] = $5d54839cd273dd72$export$b49738b89db261cd;
module.exports["REMOTE_MODULE_URI_PROD"] = $5d54839cd273dd72$export$bbd96cd490b0df63;

});

parcelRegister("c3xd8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7kqqb = parcelRequire("7kqqb");

const $de5791e01a0486f7$export$b4ede87479bfcf09 = {
    currentEnv: 'local',
    envConfigs: {
        'test-server': {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $7kqqb.API_ORIGIN_TEST_SERVER),
                pathname: (0, $7kqqb.API_ORIGIN_TEST_SERVER),
                searchParams: undefined
            }
        },
        test: {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $7kqqb.API_ORIGIN_LOCAL),
                pathname: (0, $7kqqb.API_PATHNAME_LOCAL),
                searchParams: undefined
            }
        },
        local: {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $7kqqb.API_ORIGIN_LOCAL),
                pathname: (0, $7kqqb.API_PATHNAME_LOCAL),
                searchParams: undefined
            }
        },
        dev: {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $7kqqb.API_ORIGIN_LOCAL),
                pathname: (0, $7kqqb.API_PATHNAME_LOCAL),
                searchParams: undefined
            }
        },
        staging: {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_STG),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                searchParams: undefined
            }
        },
        'stg-fedm-east': {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_STG),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                searchParams: undefined
            }
        },
        production: {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_PROD),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                searchParams: undefined
            }
        },
        'prod-fedm-east': {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_PROD),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                searchParams: undefined
            }
        }
    }
};
const $de5791e01a0486f7$export$fceca2c399b32565 = (0, $42omo.createContext)($de5791e01a0486f7$export$b4ede87479bfcf09);
const $de5791e01a0486f7$export$604607f913ef367c = $de5791e01a0486f7$export$fceca2c399b32565.Provider;
const $de5791e01a0486f7$export$877b97169cc75e8b = ()=>(0, $42omo.useContext)($de5791e01a0486f7$export$fceca2c399b32565);
module.exports["defaultEnvironmentValues"] = $de5791e01a0486f7$export$b4ede87479bfcf09;
module.exports["PostOfficeEnvironmentProvider"] = $de5791e01a0486f7$export$604607f913ef367c;
module.exports["usePostOfficeEnvironment"] = $de5791e01a0486f7$export$877b97169cc75e8b;

});

parcelRegister("5dPMD", function(module, exports) {
const $99c9a9fbdb7e3c13$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $99c9a9fbdb7e3c13$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $99c9a9fbdb7e3c13$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};
module.exports["defaultFetcher"] = $99c9a9fbdb7e3c13$export$77754e0ac9f8aba3;
module.exports["requestInitialData"] = $99c9a9fbdb7e3c13$export$c4c39037cc4b06ab;

});

parcelRegister("d5fg6", function(module, exports) {
class $2eb32372f08d498d$export$11e1da55bed53d18 {
    getKey(url) {
        const urlMatches = url.match(/placements\/([\w\-\/]+)(?:.*updateKey=)?(\w+)?/);
        if (urlMatches?.length && urlMatches.length > 1) return urlMatches.slice(1).filter(Boolean).join('/');
        return url;
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
    getDataWithPlacementId(placementId) {
        return this.get(`placements/${placementId}`)?.data;
    }
    setDataWithPlacementId(placementId, data) {
        this.set(`placements/${placementId}`, {
            data: data,
            fetcher: undefined
        });
    }
    getDataWithUrl(url) {
        return this.get('placements/' + this.getKey(url))?.data;
    }
    setDataWithUrl(url, data) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            fetcher: cache?.fetcher,
            data: data
        });
    }
    getFetcherWithUrl(url) {
        return this.get(`placements/${this.getKey(url)}`)?.fetcher;
    }
    setFetcherWithUrl(url, fetcher) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            data: cache?.data,
            fetcher: fetcher
        });
    }
    constructor(cache){
        this.cache = cache;
        globalThis.__POST_OFFICE_QUERY_CACHE__ = cache;
    }
}
module.exports["PostOfficeCacheClient"] = $2eb32372f08d498d$export$11e1da55bed53d18;

});

parcelRegister("0VKZa", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");

const $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT = 'confluence';
const $e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT,
    locale: 'en'
};
const $e888fb1bd5b30926$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $e888fb1bd5b30926$export$40fdfb947dabfc30 = (sessionData)=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, locale: locale, orgId: orgId, edition: edition } = sessionData;
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const workspaceAri = $e888fb1bd5b30926$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        orgId: orgId,
        isSiteAdmin: isAdmin,
        tenantId: cloudId === '' ? undefined : cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        subproduct: undefined,
        productEdition: edition || undefined
    };
};
const $e888fb1bd5b30926$export$76d03739bfe0286a = (environment)=>{
    switch(environment){
        case 'STAGING':
            return 'staging';
        case 'PRODUCTION':
            return 'production';
        case 'DEVELOPMENT':
            return 'local';
        default:
            return 'local';
    }
};
module.exports["sessionToPostOfficeContext"] = $e888fb1bd5b30926$export$40fdfb947dabfc30;
module.exports["transformConfluenceEnvToPostOfficeEnvironment"] = $e888fb1bd5b30926$export$76d03739bfe0286a;

});

parcelRegister("8q3aB", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $9090acc33078fd99$export$40bc69a2d697f368 = (0, $eSUdr.default)`query SpaceNavigationQuery($spaceKey:String$isLicensed:Boolean!){user:confluence_atlassianUser(current:true){id confluence{permissionType}}spaceSidebarLinks(spaceKey:$spaceKey){main(includeHidden:true){id webItemKey webItemCompleteKey title url position styleClass icon{path width height isDefault}iconClass hidden canHide tooltip linkIdentifier type}quick{id url position title styleClass}}space(key:$spaceKey){id key name type status icon{path}homepage{id}currentUser@include(if:$isLicensed){isAdmin isFavourited isWatched}operations{operation targetType}containsExternalCollaborators history{createdDate}didContainUserContent}}`;
module.exports["SpaceNavigationQuery"] = $9090acc33078fd99$export$40bc69a2d697f368;

});

parcelRegister("27YEi", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $c4f1707e011f7101$export$dd691f55898fe398 = (0, $eSUdr.default)`query SpaceViewsPersistenceQuery($spaceKey:String!){userPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}}`;
const $c4f1707e011f7101$export$c5ec5e7c6d75ef98 = (0, $eSUdr.default)`mutation SpaceViewsPersistenceMutation($spaceKey:String!$persistenceOption:SpaceViewsPersistenceOption!){updateUserPreferences(userPreferences:{spaceViewsPersistence:{spaceKey:$spaceKey persistenceOption:$persistenceOption}}){spaceViewsPersistence(spaceKey:$spaceKey)}}`;
module.exports["PersistenceQuery"] = $c4f1707e011f7101$export$dd691f55898fe398;

});

parcelRegister("aGl35", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $c55f8973455480ec$export$e117a947a993af37 = (0, $eSUdr.default)`query SpaceViewsSpaceRootQuery($spaceKey:String!){space(key:$spaceKey){id homepage{id}operations{operation targetType}}}`;
const $c55f8973455480ec$export$e8210f1d97ec99cd = (0, $eSUdr.default)`query SpaceViewsContentQuery($first:Int!$spaceKey:String!$token:String$sort:String!$navigationType:String){content(first:$first spaceKey:$spaceKey orderby:$sort after:$token status:"current" navigationType:$navigationType){nodes{id title type subType hasRestrictions hasInheritedRestrictions links{webui base}properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value version{number}}}}pageInfo{hasNextPage endCursor}}}`;
const $c55f8973455480ec$export$4e20ef3fda88f1f1 = (0, $eSUdr.default)`query SpaceViewsRecentlyViewedQuery($cloudId:ID!$first:Int!$after:String$spaceId:ID!){activities{myActivities{viewed(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:[PAGE]cloudIds:[$cloudId]containerIds:[$spaceId]}}]first:$first after:$after){edges{node{id object{id localResourceId content{id title hasRestrictions hasInheritedRestrictions properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value version{number}}}}}}cursor}pageInfo{hasNextPage}}}}}`;
module.exports["SpaceRootQuery"] = $c55f8973455480ec$export$e117a947a993af37;
module.exports["SpaceViewsContentQuery"] = $c55f8973455480ec$export$e8210f1d97ec99cd;

});

parcelRegister("2fQCH", function(module, exports) {
/**
 * @generated SignedSource<<6cf1e4c8a6130739babc01b85cd1175a>>
 * @relayHash 5841807a4e3bf2a59de617588db23f8f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1590a2caf1a18e2c8f39c97c955bfbcd2ed31d253f236ac687f9d10cfa2a64f8
const $3b3e50e8050cb646$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "didContainUserContent"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FooterCreateButtonsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FooterCreateButtonsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5841807a4e3bf2a59de617588db23f8f",
            "id": "1590a2caf1a18e2c8f39c97c955bfbcd2ed31d253f236ac687f9d10cfa2a64f8",
            "metadata": {},
            "name": "FooterCreateButtonsQuery",
            "operationKind": "query",
            "text": "query FooterCreateButtonsQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled}},didContainUserContent,operations{operation,targetType}}}"
        }
    };
}();
$3b3e50e8050cb646$var$node.hash = "8f908e5cb8da1d069802e69ea3d7f563";
var $3b3e50e8050cb646$export$2e2bcd8739ae039 = $3b3e50e8050cb646$var$node;
module.exports["default"] = $3b3e50e8050cb646$export$2e2bcd8739ae039;

});

parcelRegister("1oGPE", function(module, exports) {
const $00840277cc5ce9b5$export$90091b93f6cf4241 = 80;
const $00840277cc5ce9b5$export$3cf9a7263d7d2d28 = 100; // INITIAL_PAGE_SIZE was previously 160 but we reduced it to 80. Should we also reduce this?
module.exports["INITIAL_PAGE_SIZE"] = $00840277cc5ce9b5$export$90091b93f6cf4241;
module.exports["CHILDREN_PAGE_SIZE"] = $00840277cc5ce9b5$export$3cf9a7263d7d2d28;

});

parcelRegister("inLKs", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $7ec1eb52421f9faa$export$8d5511a885429a32 = (0, $eSUdr.default)`query PageTreeQuery($spaceKey:String!$statuses:[GraphQLPageStatus]$ptStatuses:[PTGraphQLPageStatus]$contentId:ID!$paginationLimit:Int$isSuperAdmin:Boolean!$isReplacePagesWithPTPageEnabled:Boolean!=false){currentPage:ptpage(id:$contentId spaceKey:$spaceKey pageTree:$paginationLimit status:$ptStatuses enablePaging:true){id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}nearestAncestors{pageInfo{hasNextPage endCursor}nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}previousSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}}previousSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}children{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}ptpage(spaceKey:$spaceKey pageTree:$paginationLimit status:$ptStatuses enablePaging:true)@include(if:$isReplacePagesWithPTPageEnabled){id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}rootLevelPages:pages(spaceKey:$spaceKey status:$statuses)@skip(if:$isReplacePagesWithPTPageEnabled){nodes{id title status hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}}space(key:$spaceKey){id homepage{id}operations{operation targetType}}}`;
const $7ec1eb52421f9faa$export$f67032c82d01c852 = (0, $eSUdr.default)`query PageTreeWithSpaceKeyQuery($spaceKey:String!$statuses:[GraphQLPageStatus]$ptStatuses:[PTGraphQLPageStatus]$paginationLimit:Int$isSuperAdmin:Boolean!$isReplacePagesWithPTPageEnabled:Boolean!){space(key:$spaceKey){id homepageId pageTree(pageTree:$paginationLimit status:$ptStatuses enablePaging:true){id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}nearestAncestors{pageInfo{hasNextPage endCursor}nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}previousSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}}previousSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}children{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}operations{operation targetType}}ptpage(spaceKey:$spaceKey status:$ptStatuses)@include(if:$isReplacePagesWithPTPageEnabled){id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}rootLevelPages:pages(spaceKey:$spaceKey status:$statuses)@skip(if:$isReplacePagesWithPTPageEnabled){nodes{id title status hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}}}`;
module.exports["PageTreeQuery"] = $7ec1eb52421f9faa$export$8d5511a885429a32;
module.exports["PageTreeWithSpaceKeyQuery"] = $7ec1eb52421f9faa$export$f67032c82d01c852;

});

parcelRegister("fL5TY", function(module, exports) {
/**
 * @generated SignedSource<<b72ab3593890fa91ef84036390360c22>>
 * @relayHash 32d094adde43b53166e21c73e0e18466
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8ba3ae6faaa2b1672d7eef93310782aed4bc09c157af62ec4f49eb5fa49b05db
const $b517e71d543026da$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endCursor"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderBy"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "statuses"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "endCursor"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "orderby",
                    "variableName": "orderBy"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "statuses"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "blogpost"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blank"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published",
                                        "emoji-title-draft",
                                        "editor"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BlogTreeRootComponentQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BlogTreeRootComponentQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "32d094adde43b53166e21c73e0e18466",
            "id": "8ba3ae6faaa2b1672d7eef93310782aed4bc09c157af62ec4f49eb5fa49b05db",
            "metadata": {},
            "name": "BlogTreeRootComponentQuery",
            "operationKind": "query",
            "text": "query BlogTreeRootComponentQuery($spaceKey:String!,$first:Int,$endCursor:String,$statuses:[String],$orderBy:String){content(spaceKey:$spaceKey,type:\"blogpost\",first:$first,orderby:$orderBy,after:$endCursor,status:$statuses){pageInfo{hasNextPage,endCursor},nodes{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}}}"
        }
    };
}();
$b517e71d543026da$var$node.hash = "dcdc7591048a9e478035919db8a4bcd0";
var $b517e71d543026da$export$2e2bcd8739ae039 = $b517e71d543026da$var$node;
module.exports["default"] = $b517e71d543026da$export$2e2bcd8739ae039;

});

parcelRegister("6DMfJ", function(module, exports) {
const $4d5bd09a97238678$export$e3c11860ad35ba05 = [
    'current',
    'draft'
];
const $4d5bd09a97238678$export$70918a400db2b6af = 'VIRTUAL_ROOT_ID';
const $4d5bd09a97238678$export$8ec3d08588d2eeda = 40;
const $4d5bd09a97238678$export$130b26c73bb9d040 = 16;
module.exports["BLOG_STATUSES"] = $4d5bd09a97238678$export$e3c11860ad35ba05;
module.exports["VIRTUAL_ROOT_ID"] = $4d5bd09a97238678$export$70918a400db2b6af;
module.exports["PAGE_SIZE"] = $4d5bd09a97238678$export$8ec3d08588d2eeda;
module.exports["INDENT_PER_LEVEL"] = $4d5bd09a97238678$export$130b26c73bb9d040;

});

parcelRegister("ivyMZ", function(module, exports) {
var $4eb170397cdf11a9$export$bcac0c74873fee96 = /*#__PURE__*/ function(GraphQLPageStatus) {
    GraphQLPageStatus["CURRENT"] = "CURRENT";
    GraphQLPageStatus["DRAFT"] = "DRAFT";
    return GraphQLPageStatus;
}({});
const $4eb170397cdf11a9$export$48ccce95f626ae31 = [
    "CURRENT",
    "DRAFT"
];
const $4eb170397cdf11a9$export$5522fe3493552101 = [
    'current',
    'draft'
];
module.exports["PAGE_TREE_STATUSES"] = $4eb170397cdf11a9$export$48ccce95f626ae31;

});

parcelRegister("gRzR4", function(module, exports) {
/**
 * @generated SignedSource<<6050f94e69307ca99b98b624b9d08371>>
 * @relayHash a2b7f78fbc7a4e9ecead01083cfe8f24
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2f8168270ed250fa33f38610fa3b20029664886f16e5db1184bbca7a9821266
const $7836e6257492ac35$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "generatedBy"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "creatorId"
                },
                {
                    "concreteType": "ContentProperties",
                    "kind": "LinkedField",
                    "name": "contentProperties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DraftContentProperties",
                            "kind": "LinkedField",
                            "name": "draft",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "PublishedContentProperties",
                            "kind": "LinkedField",
                            "name": "latest",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "a2b7f78fbc7a4e9ecead01083cfe8f24",
            "id": "e2f8168270ed250fa33f38610fa3b20029664886f16e5db1184bbca7a9821266",
            "metadata": {},
            "name": "SmartCreateFeedbackBannerQuery",
            "operationKind": "query",
            "text": "query SmartCreateFeedbackBannerQuery($contentId:ID!){singleContent(id:$contentId){title,id,type,creatorId,contentProperties{draft{generatedBy},latest{generatedBy}}}}"
        }
    };
}();
$7836e6257492ac35$var$node.hash = "4f4f276100c2961c7227836999fc58e5";
var $7836e6257492ac35$export$2e2bcd8739ae039 = $7836e6257492ac35$var$node;
module.exports["default"] = $7836e6257492ac35$export$2e2bcd8739ae039;

});

parcelRegister("1k2r8", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9xoMO = parcelRequire("9xoMO");


var $66UJS = parcelRequire("66UJS");

const $2daa64592339f2ce$export$ce5c629ae8376218 = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: (0, $9xoMO.OnboardingKeysCombined)
        }
    });
};
module.exports["preloadAllOnboardingState"] = $2daa64592339f2ce$export$ce5c629ae8376218;

});

parcelRegister("b2p4s", function(module, exports) {
/**
 * @generated SignedSource<<64029d77bc7e5ee7f768e71ebae7af94>>
 * @relayHash aa12b95dc97d2068b03de4a55dcec507
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c
const $ac606d0e22e5c37c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"editor\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "aa12b95dc97d2068b03de4a55dcec507",
            "id": "0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c",
            "metadata": {},
            "name": "NotFoundContainerQuery",
            "operationKind": "query",
            "text": "query NotFoundContainerQuery($contentId:ID!,$draftShareId:String,$status:[String]){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,links{webui},properties(key:\"editor\"){nodes{id,key,value}}}}}"
        }
    };
}();
$ac606d0e22e5c37c$var$node.hash = "df3b0c202e5cf0f97257fa8a583747bc";
var $ac606d0e22e5c37c$export$2e2bcd8739ae039 = $ac606d0e22e5c37c$var$node;
module.exports["default"] = $ac606d0e22e5c37c$export$2e2bcd8739ae039;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("82xkT", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $47b3b3d107c9e3d8$export$8c574c46798ffe77 = (0, $eSUdr.default)`query SpaceOverviewQuery($spaceKey:String!$excludeOperations:Boolean!){space(key:$spaceKey){id currentUser{isAdmin}name theme{themeKey}icon{path}homepage{id operations@skip(if:$excludeOperations){operation}properties(keys:["emoji-title-published"]){nodes{id key value}}}}}`;
module.exports["SpaceOverviewQuery"] = $47b3b3d107c9e3d8$export$8c574c46798ffe77;

});

parcelRegister("yuLaV", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");


var $5spQU = parcelRequire("5spQU");


var $9wGTI = parcelRequire("9wGTI");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard') {
        // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKey = contentType === 'database' ? 'confluence-databases' : 'confluence-whiteboards';
            return (0, $5spQU.isFeatureEnabled)('confluence', featureKey);
        }
        return !(0, $lzcvT.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("PAiZW", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6cd46b79c049adec$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $6cd46b79c049adec$export$a228be81fcb77b42 = (0, $42omo.createContext)($6cd46b79c049adec$export$da5dc9062cba6715);
const $6cd46b79c049adec$export$3a10495c2cd2db0c = $6cd46b79c049adec$export$a228be81fcb77b42.Provider;
const $6cd46b79c049adec$export$b77983be89bb0a4e = $6cd46b79c049adec$export$3a10495c2cd2db0c;
const $6cd46b79c049adec$export$5bd9099e0ae94a43 = ()=>(0, $42omo.useContext)($6cd46b79c049adec$export$a228be81fcb77b42);
module.exports["defaultPostOfficeContextValue"] = $6cd46b79c049adec$export$da5dc9062cba6715;
module.exports["InternalPostOfficeContextProvider"] = $6cd46b79c049adec$export$3a10495c2cd2db0c;
module.exports["PostOfficeContextProvider"] = $6cd46b79c049adec$export$b77983be89bb0a4e;
module.exports["usePostOfficeContext"] = $6cd46b79c049adec$export$5bd9099e0ae94a43;

});

parcelRegister("6yHRM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxT4C = parcelRequire("hxT4C");


var $4H1Ql = parcelRequire("4H1Ql");

const $d8346e8a2779e8cd$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $d8346e8a2779e8cd$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $d8346e8a2779e8cd$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $hxT4C.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $4H1Ql.useStableObject)(route);
};
const $d8346e8a2779e8cd$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $d8346e8a2779e8cd$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$d8346e8a2779e8cd$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $d8346e8a2779e8cd$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $42omo.createContext)($d8346e8a2779e8cd$var$initialState);
const $d8346e8a2779e8cd$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $42omo.useRef)();
    if (!ref.current) ref.current = $d8346e8a2779e8cd$export$98c77e1bd702ed15(props);
    const route = $d8346e8a2779e8cd$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d8346e8a2779e8cd$export$f7f47a74e8b47b1f.Provider, {
        value: route
    }, children);
};
const $d8346e8a2779e8cd$export$79301b66f7808cd8 = ()=>(0, $42omo.useContext)($d8346e8a2779e8cd$export$f7f47a74e8b47b1f); //Route listener
module.exports["PostOfficeRouteContext"] = $d8346e8a2779e8cd$export$f7f47a74e8b47b1f;
module.exports["PostOfficeRouteProvider"] = $d8346e8a2779e8cd$export$89eadc6b3e5f4e9e;
module.exports["usePostOfficeRoute"] = $d8346e8a2779e8cd$export$79301b66f7808cd8;

});

parcelRegister("4H1Ql", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $6932c2b531d219ac$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $6932c2b531d219ac$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $42omo.useMemo)(()=>obj, $6932c2b531d219ac$export$cdf98ded28406f69(obj));
}
module.exports["useStableObject"] = $6932c2b531d219ac$export$ed02d4adf2068b08;

});

parcelRegister("2mPpz", function(module, exports) {

var $byfJM = parcelRequire("byfJM");

const $479bf4f98cf9c8c7$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $byfJM.createPlacementComponent)(placementId, Component, placementConfigurationOptions);
module.exports["createPlacementComponent"] = $479bf4f98cf9c8c7$export$8a57effc6307f916;

});

parcelRegister("byfJM", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $T9xHm = parcelRequire("T9xHm");


var $4H1Ql = parcelRequire("4H1Ql");


var $a8wvv = parcelRequire("a8wvv");


var $9dOtv = parcelRequire("9dOtv");


var $eXPKf = parcelRequire("eXPKf");

var $MnX4h = parcelRequire("MnX4h");


var $2HRxT = parcelRequire("2HRxT");

const $573f4005c25c6dbc$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $2HRxT.withErrorBoundary)((props)=>{
        // Hide placement in Isolated Cloud environments if configured
        // The typeof document check ensures we don't call isIsolatedCloud() during SSR
        if (placementConfigurationOptions?.hideInIsolatedCloud && typeof document !== 'undefined' && (0, $T9xHm.isIsolatedCloud)()) return null;
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        const stableContext = (0, $4H1Ql.useStableObject)(context);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eXPKf.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $MnX4h.StableProviders), {
                route: route,
                context: stableContext,
                placement: {
                    placementId: placementId
                },
                choreographer: placementConfigurationOptions?.choreographer,
                children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    context: stableContext,
                    initialData: initialData,
                    ...componentProps
                })
            })
        });
    });
const $573f4005c25c6dbc$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $573f4005c25c6dbc$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $9dOtv.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $a8wvv.ERROR_BOUNDARY_LOCATION),
            placementId: placementId,
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};
module.exports["createPlacementComponent"] = $573f4005c25c6dbc$export$8a57effc6307f916;

});

parcelRegister("a8wvv", function(module, exports) {
const $f5ba185a6bfa7119$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $f5ba185a6bfa7119$export$71ff7382870ef1b0 = 'create-placement-component';
module.exports["DEFAULT_CONTEXT"] = $f5ba185a6bfa7119$export$9c542858adf7dcd0;
module.exports["ERROR_BOUNDARY_LOCATION"] = $f5ba185a6bfa7119$export$71ff7382870ef1b0;

});

parcelRegister("9dOtv", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $94fea169e2cb8de7$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $42omo.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};
module.exports["useComponentErrorHandling"] = $94fea169e2cb8de7$export$3d127465d22fe4e5;

});

parcelRegister("eXPKf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $h6POP = parcelRequire("h6POP");


var $42omo = parcelRequire("42omo");


var $fUB5z = parcelRequire("fUB5z");


var $a39tv = parcelRequire("a39tv");

const $3a8bbfb177ab8743$export$9a335a42ce02bdb8 = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, ...props })=>{
    const isUFOEnabled = (0, $c6GJD.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $a39tv.usePerformanceTracking)(props);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
                name: (0, $h6POP.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fUB5z.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
});
const $3a8bbfb177ab8743$export$b35129264a401b3c = /*#__PURE__*/ (0, $42omo.memo)(({ placementId: placementId, children: children })=>{
    const isEnabled = (0, $c6GJD.default).checkGate('post_office_update_ufov2_placements');
    /**
		 * If feature gate is not enabled, then we just return the children without the
		 * UFO segments attached.
		 */ if (!isEnabled) return children;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
        name: (0, $h6POP.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
            name: `${(0, $h6POP.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
});
module.exports["PerformanceTracking"] = $3a8bbfb177ab8743$export$9a335a42ce02bdb8;
module.exports["PerformanceTrackingSegment"] = $3a8bbfb177ab8743$export$b35129264a401b3c;

});

parcelRegister("h6POP", function(module, exports) {

var $fwDOR = parcelRequire("fwDOR");


var $hnvzE = parcelRequire("hnvzE");

const $7e9b04f8bb48d01d$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: $fwDOR.default,
    UFOSegment: $hnvzE.default
};
module.exports["UFOv2"] = $7e9b04f8bb48d01d$export$c91b09caa8ecbab1;

});

parcelRegister("fUB5z", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $28f53716d0e10e9b$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $42omo.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["TrackMount"] = $28f53716d0e10e9b$export$21b400a8c8ebc91a;

});

parcelRegister("a39tv", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6d839c5f036ae335$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    const onMount = (0, $42omo.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $42omo.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};
module.exports["usePerformanceTracking"] = $6d839c5f036ae335$export$317d52099614f316;

});

parcelRegister("MnX4h", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $jfBff = parcelRequire("jfBff");


var $1Ah4R = parcelRequire("1Ah4R");


var $3zCGc = parcelRequire("3zCGc");


var $kzyrP = parcelRequire("kzyrP");


var $goPQE = parcelRequire("goPQE");


var $coAgb = parcelRequire("coAgb");


var $eXPKf = parcelRequire("eXPKf");

const $e96f8aedef8f7ae2$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $kzyrP.StableContextProvider), {
        context: context,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $goPQE.StablePlacementProvider), {
            placement: placement,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $coAgb.StableRouteProvider), {
                route: route,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1Ah4R.StableAnaltyicsProvider), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3zCGc.StableChoreographerProvider), {
                        choreographer: choreographer,
                        placementId: placement.placementId,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jfBff.RenderTrackerProvider), {
                            placementId: placement.placementId,
                            children: children
                        })
                    })
                })
            })
        })
    });
module.exports["StableProviders"] = $e96f8aedef8f7ae2$export$2b6596bcb1383a71;

});

parcelRegister("jfBff", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $7XIdu = parcelRequire("7XIdu");


var $42omo = parcelRequire("42omo");

/**
 * List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
 */ const $5ba220ca4e76952d$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    'screen-space-flags'
];
const $5ba220ca4e76952d$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if ($5ba220ca4e76952d$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'placement'
        });
    }, [
        fireAnalyticsEvent,
        placementId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["RenderTrackerProvider"] = $5ba220ca4e76952d$export$2d84fd9af6c9e378;

});

parcelRegister("7XIdu", function(module, exports) {

var $inPa6 = parcelRequire("inPa6");


var $42omo = parcelRequire("42omo");

const $ddf71c7c19f3c4df$export$85183a312807388d = 'postOffice';
const $ddf71c7c19f3c4df$export$33911828b25deac7 = 'engagementPlatform';
const $ddf71c7c19f3c4df$export$57d19d18d6e255a5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((eventPayload, attributes)=>{
        createAnalyticsEvent({
            ...eventPayload,
            side: 'client',
            attributes: {
                ...eventPayload.attributes,
                ...attributes
            }
        }).fire($ddf71c7c19f3c4df$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};
const $ddf71c7c19f3c4df$export$f7fadc54a04f9307 = {
    eventType: 'track',
    action: 'exposed',
    actionSubject: 'feature',
    source: 'engagement-platform',
    tenantType: 'cloudId',
    userType: 'atlassianAccount',
    attributes: {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        sourceProduct: 'postOffice'
    },
    tags: [
        'engagementPlatform'
    ]
};
const $ddf71c7c19f3c4df$export$e0b2a6bfc6c6f992 = {
    eventType: 'operational',
    action: 'stopped',
    actionSubject: 'message',
    source: 'epTargeting',
    tenantType: 'cloudId',
    userType: 'atlassianAccount',
    attributes: {
        sourceProduct: 'postOffice'
    },
    tags: [
        'engagementPlatform'
    ],
    product: 'engagementPlatform'
};
const $ddf71c7c19f3c4df$export$f14470c9a12428fc = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((eventPayload, attributes)=>{
        if (eventPayload.messageType === 'inapp') {
            const epMessageId = `engagement.inproduct.${eventPayload.messageId}`;
            createAnalyticsEvent({
                ...$ddf71c7c19f3c4df$export$f7fadc54a04f9307,
                ...eventPayload,
                actionSubjectId: epMessageId,
                attributes: {
                    ...$ddf71c7c19f3c4df$export$f7fadc54a04f9307.attributes,
                    ...eventPayload.locale && {
                        locale: eventPayload.locale
                    },
                    ...attributes,
                    flagKey: epMessageId
                }
            }).fire($ddf71c7c19f3c4df$export$33911828b25deac7);
        } else createAnalyticsEvent({
            ...$ddf71c7c19f3c4df$export$e0b2a6bfc6c6f992,
            ...eventPayload,
            actionSubjectId: eventPayload.messageId,
            attributes: {
                ...$ddf71c7c19f3c4df$export$e0b2a6bfc6c6f992.attributes,
                ...eventPayload.locale && {
                    locale: eventPayload.locale
                },
                ...attributes
            }
        }).fire($ddf71c7c19f3c4df$export$33911828b25deac7);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};
module.exports["useFirePostOfficeAnalyticsEvents"] = $ddf71c7c19f3c4df$export$57d19d18d6e255a5;
module.exports["useFireEngagementPlatformAnalyticsEvents"] = $ddf71c7c19f3c4df$export$f14470c9a12428fc;

});

parcelRegister("1Ah4R", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $ffCOo = parcelRequire("ffCOo");

const $6622e517a1cb034d$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: "3f17185c22658cc9a5ed90243dac23b69eaaa473",
            b: "10031274",
            t: undefined
        }
    }
};
const $6622e517a1cb034d$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.PostOfficeAnalyticsContext), {
        data: $6622e517a1cb034d$var$postOfficeAnalyticsContextData,
        children: children
    });
};
module.exports["StableAnaltyicsProvider"] = $6622e517a1cb034d$export$5a66cdc9893b43e;

});

parcelRegister("3zCGc", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $PAiZW = parcelRequire("PAiZW");

var $c3xd8 = parcelRequire("c3xd8");


var $6zKHU = parcelRequire("6zKHU");


var $42omo = parcelRequire("42omo");

/**
 * Choreographer-specific debug logger instance
 */ const $a6536447802fda47$var$choreographerLogger = (0, $6zKHU.createInBrowserDebugLogger)('choreographer');
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ const $a6536447802fda47$var$importHelper = (mod)=>{
    if (typeof mod.ChoreographerRegistry === 'function') {
        // CommonJS module
        $a6536447802fda47$var$choreographerLogger.debug('Using CommonJS module format', {
            moduleType: 'CommonJS'
        });
        return mod.ChoreographerRegistry;
    } else if (typeof mod.default === 'function') {
        // ESM module in browser
        $a6536447802fda47$var$choreographerLogger.debug('Using ESM module format (browser)', {
            moduleType: 'ESM-browser'
        });
        return mod.default;
    } else if (typeof mod?.default === 'object' && typeof mod.default.ChoreographerRegistry === 'function') {
        // ESM module in Node.js
        $a6536447802fda47$var$choreographerLogger.debug('Using ESM module format (Node.js)', {
            moduleType: 'ESM-node'
        });
        return mod.default.ChoreographerRegistry;
    }
    $a6536447802fda47$var$choreographerLogger.warn('Using fallback module format', {
        moduleType: 'fallback'
    });
    return mod;
};
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ const $a6536447802fda47$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $a6536447802fda47$var$defaultContext = {
    choreographerEnabled: $a6536447802fda47$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $a6536447802fda47$var$ChoreographerContext = /*#__PURE__*/ (0, $42omo.createContext)($a6536447802fda47$var$defaultContext);

const $a6536447802fda47$export$e68b2c75bfb5682a = ({ children: children, choreographer: choreographer, placementId: placementId })=>{
    const [choreographerFactory, setChoreographerFactory] = (0, $42omo.useState)(undefined);
    const [choreographerEnabled, setChoreographerEnabled] = (0, $42omo.useState)(choreographer?.isDefaultEnabled ?? $a6536447802fda47$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $c3xd8.usePostOfficeEnvironment)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    (0, $42omo.useEffect)(()=>{
        if (choreographerEnabled) (parcelRequire("bh3sZ")).then((m)=>{
            // Autoresolve the ChoreographerRegistry class depending on whether the module is an ESM or CommonJS module
            const ChoreographerRegistryClass = $a6536447802fda47$var$importHelper(m);
            setChoreographerFactory(new ChoreographerRegistryClass(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory());
            $a6536447802fda47$var$choreographerLogger.info('ChoreographerFactory created', {
                choreographerEnabled: choreographerEnabled,
                product: context.product,
                placementId: placementId
            });
        }).catch((error)=>{
            $a6536447802fda47$var$choreographerLogger.error('ChoreographerRegistry import failed', {
                error: error instanceof Error ? error.message : String(error),
                stack: error instanceof Error ? error.stack : undefined,
                product: context.product,
                placementId: placementId
            });
            $a6536447802fda47$var$choreographerLogger.warn('Disabling Choreographer due to import failure');
            setChoreographerEnabled(false);
        });
        else $a6536447802fda47$var$choreographerLogger.debug('Choreographer disabled, skipping import', {
            product: context.product,
            placementId: placementId
        });
    }, [
        choreographerEnabled,
        context.product,
        environmentContext.currentEnv,
        placementId
    ]);
    const stableChoreographerContext = (0, $42omo.useMemo)(()=>{
        return {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        };
    }, [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    // Log context changes outside of useMemo to avoid performance impact
    (0, $42omo.useEffect)(()=>{
        $a6536447802fda47$var$choreographerLogger.debug('Setting ChoreographerContext', {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            product: context.product,
            placementId: placementId
        });
    }, [
        stableChoreographerContext,
        context.product,
        placementId,
        choreographerEnabled,
        choreographerFactory
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($a6536447802fda47$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext,
        children: children
    });
};
const $a6536447802fda47$export$cab5a8adbabcee23 = ()=>(0, $42omo.useContext)($a6536447802fda47$var$ChoreographerContext);
module.exports["StableChoreographerProvider"] = $a6536447802fda47$export$e68b2c75bfb5682a;
module.exports["useChoreographerContext"] = $a6536447802fda47$export$cab5a8adbabcee23;

});

parcelRegister("6zKHU", function(module, exports) {
/* eslint-disable no-console */ /**
 * Simple browser debug logger for Post Office components
 *
 * Usage:
 * - Enable: window.postOfficeChoreographerDebug = true
 * - Disable: window.postOfficeChoreographerDebug = false
 *
 * Example:
 * ```typescript
 * const logger = createInBrowserDebugLogger('Choreographer');
 * logger.debug('Component loaded', { config: 'value' });
 * ```
 */ const $101ad7de46cb7b68$export$806eda59584e395d = (component)=>{
    const windowKey = `postOffice${component}Debug`;
    const isEnabled = ()=>{
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            return typeof window !== 'undefined' && window[windowKey] === true;
        } catch  {
            return false;
        }
    };
    const log = (level, message, data)=>{
        if (!isEnabled()) return;
        const prefix = `[Post Office - ${component}]`;
        // Use appropriate console method for each level
        if (level === 'debug') console.log(`${prefix} ${message}`, data || '');
        else if (level === 'info') console.info(`${prefix} ${message}`, data || '');
        else if (level === 'warn') console.warn(`${prefix} ${message}`, data || '');
        else if (level === 'error') console.error(`${prefix} ${message}`, data || '');
    };
    return {
        debug: (msg, data)=>log('debug', msg, data),
        info: (msg, data)=>log('info', msg, data),
        warn: (msg, data)=>log('warn', msg, data),
        error: (msg, data)=>log('error', msg, data)
    };
};
module.exports["createInBrowserDebugLogger"] = $101ad7de46cb7b68$export$806eda59584e395d;

});

parcelRegister("bh3sZ", function(module, exports) {

let $8353f8a5b3bf3a40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8353f8a5b3bf3a40$var$load("69dSh").then(()=>parcelRequire('fuev4'));

});

parcelRegister("kzyrP", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $PAiZW = parcelRequire("PAiZW");

var $4H1Ql = parcelRequire("4H1Ql");


var $a8wvv = parcelRequire("a8wvv");

const $d8708472710e950a$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $4H1Ql.useStableObject)({
        ...(0, $a8wvv.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $PAiZW.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};
module.exports["StableContextProvider"] = $d8708472710e950a$export$d4982c0a28b18f63;

});

parcelRegister("goPQE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4H1Ql = parcelRequire("4H1Ql");


var $8Bzrf = parcelRequire("8Bzrf");

const $2119b7887220da1c$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $4H1Ql.useStableObject)(placement);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8Bzrf.PlacementProvider), {
        value: stableValue,
        children: children
    });
};
module.exports["StablePlacementProvider"] = $2119b7887220da1c$export$e9fd288527498af6;

});

parcelRegister("8Bzrf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $ffCOo = parcelRequire("ffCOo");


var $3Bn1T = parcelRequire("3Bn1T");


var $42omo = parcelRequire("42omo");

const $d26f31a8de6bf192$export$6394bf86db095a8 = /*#__PURE__*/ (0, $42omo.createContext)({
    placementId: undefined
});
const $d26f31a8de6bf192$export$6272e220478c7f1d = ({ value: value, children: children })=>{
    const memoizedValue = (0, $42omo.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $3Bn1T.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, $l998X.jsx)($d26f31a8de6bf192$export$6394bf86db095a8.Provider, {
        value: memoizedValue,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.PostOfficeAnalyticsContext), {
            data: memoizedValue,
            children: children
        })
    });
};
const $d26f31a8de6bf192$export$4fc0446ee742ad80 = ()=>(0, $42omo.useContext)($d26f31a8de6bf192$export$6394bf86db095a8);
module.exports["PlacementProvider"] = $d26f31a8de6bf192$export$6272e220478c7f1d;
module.exports["usePlacementContext"] = $d26f31a8de6bf192$export$4fc0446ee742ad80;

});

parcelRegister("3Bn1T", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6sni0 = parcelRequire("6sni0");

const $37d7f318e8260291$var$initialPlacementState = {
    currentlyMounted: [],
    hasMounted: []
};
const $37d7f318e8260291$var$PostOfficeScreenContext = /*#__PURE__*/ (0, $42omo.createContext)({
    placements: $37d7f318e8260291$var$initialPlacementState
});
const $37d7f318e8260291$export$70e19226ddeaf957 = ()=>(0, $42omo.useContext)($37d7f318e8260291$var$PostOfficeScreenContext);
const $37d7f318e8260291$var$PostOfficeScreenUpdateContext = /*#__PURE__*/ (0, $42omo.createContext)({
    placementMount: ()=>{},
    placementUnmount: ()=>{}
});
const $37d7f318e8260291$export$5d27c0ee02be2a23 = ()=>(0, $42omo.useContext)($37d7f318e8260291$var$PostOfficeScreenUpdateContext);
const $37d7f318e8260291$export$ca77a8cbe94108fe = ({ children: children })=>{
    const [placements, setPlacements] = (0, $42omo.useState)($37d7f318e8260291$var$initialPlacementState);
    const placementMount = (0, $42omo.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: (0, $6sni0.uniqueArray)([
                    ...state.currentlyMounted,
                    placementId
                ]),
                hasMounted: (0, $6sni0.uniqueArray)([
                    ...state.hasMounted,
                    placementId
                ])
            }), []);
    const placementUnmount = (0, $42omo.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
            }), []);
    const postOfficeScreenUpdateContext = (0, $42omo.useMemo)(()=>({
            placementMount: placementMount,
            placementUnmount: placementUnmount
        }), [
        placementMount,
        placementUnmount
    ]);
    const postOfficeScreenContext = (0, $42omo.useMemo)(()=>({
            placements: placements
        }), [
        placements
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($37d7f318e8260291$var$PostOfficeScreenUpdateContext.Provider, {
        value: postOfficeScreenUpdateContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($37d7f318e8260291$var$PostOfficeScreenContext.Provider, {
        value: postOfficeScreenContext
    }, children));
};
const $37d7f318e8260291$export$f51d04a086368016 = ({ placementId: placementId })=>{
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $37d7f318e8260291$export$5d27c0ee02be2a23();
    (0, $42omo.useEffect)(()=>{
        if (!placementId) return;
        placementMount({
            placementId: placementId
        });
        return ()=>{
            placementUnmount({
                placementId: placementId
            });
        };
    }, [
        placementId,
        placementMount,
        placementUnmount
    ]);
};
module.exports["PostOfficeScreenContextProvider"] = $37d7f318e8260291$export$ca77a8cbe94108fe;
module.exports["usePostOfficeScreenPlacement"] = $37d7f318e8260291$export$f51d04a086368016;

});

parcelRegister("6sni0", function(module, exports) {
const $df02b7ceef3465b9$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());
module.exports["uniqueArray"] = $df02b7ceef3465b9$export$bbd17ecb0679edd7;

});

parcelRegister("coAgb", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $6yHRM = parcelRequire("6yHRM");

var $4H1Ql = parcelRequire("4H1Ql");


var $kbN4i = parcelRequire("kbN4i");

const $ee97961d0a968e6e$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $kbN4i.useLocationHref)();
    const stableRoute = (0, $4H1Ql.useStableObject)(route ?? {
        previous: href,
        current: href,
        searchParams: href ? new URL(href).searchParams : undefined
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6yHRM.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};
module.exports["StableRouteProvider"] = $ee97961d0a968e6e$export$ce13d00e696dfc96;

});

parcelRegister("kbN4i", function(module, exports) {
const $b036fb6e61b1c432$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $b036fb6e61b1c432$export$49fc3f3d8c7f99 = ()=>{
    return $b036fb6e61b1c432$var$isLocationAvailable() ? globalThis.location.href : undefined;
};
module.exports["useLocationHref"] = $b036fb6e61b1c432$export$49fc3f3d8c7f99;

});

parcelRegister("2HRxT", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $7TH2w = parcelRequire("7TH2w");


var $7XIdu = parcelRequire("7XIdu");


var $lAJUP = parcelRequire("lAJUP");

const $efad4e1316fb199e$export$f0c7a449e0cfaec7 = (Component)=>({ errorBoundaryLocation: errorBoundaryLocation, placementId: placementId, fallbackRender: fallbackRender, onError: onError, ...data })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: error,
                    info: info,
                    errorBoundaryLocation: additionalAnalytics.errorBoundaryLocation,
                    placementId: additionalAnalytics.placementId
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $l998X.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation,
                placementId: placementId
            }, onError),
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...data
            })
        });
    };
module.exports["withErrorBoundary"] = $efad4e1316fb199e$export$f0c7a449e0cfaec7;

});

parcelRegister("cyz5M", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $4H1Ql = parcelRequire("4H1Ql");


var $3NyPa = parcelRequire("3NyPa");

var $h6POP = parcelRequire("h6POP");


var $hOVIX = parcelRequire("hOVIX");


var $3Shv6 = parcelRequire("3Shv6");


var $aEUWC = parcelRequire("aEUWC");


var $jVzfH = parcelRequire("jVzfH");


var $2amyA = parcelRequire("2amyA");


var $fUB5z = parcelRequire("fUB5z");


var $2HRxT = parcelRequire("2HRxT");


var $hyvHs = parcelRequire("hyvHs");


var $42omo = parcelRequire("42omo");


var $lVEBn = parcelRequire("lVEBn");

const $765afc5340447923$var$STABLE_EMPTY_OBJECT = {};
const $765afc5340447923$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        ...props,
        children: children
    });
};
const $765afc5340447923$export$7b7e5a348ef9a7c1 = (messageComponents, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $42omo.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, SuspenseBoundary: SuspenseBoundary = (0, $42omo.Suspense), ...data })=>{
            const isUFOEnabled = (0, $c6GJD.default).checkGate('enable_ufo_tracking_in_post_office');
            const recommendationSessionStable = (0, $4H1Ql.useStableObject)(recommendationSession ?? $765afc5340447923$var$STABLE_EMPTY_OBJECT);
            const postOfficeStable = (0, $4H1Ql.useStableObject)(postOffice ?? $765afc5340447923$var$STABLE_EMPTY_OBJECT);
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $42omo.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $3NyPa.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $fUB5z.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $42omo.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $hOVIX.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $hOVIX.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $42omo.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
                        name: (0, $h6POP.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                        children: loadingFallback ?? null
                    }), // oxlint-disable-next-line react-hooks/exhaustive-deps
                [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                const componentPropsStable = (0, $4H1Ql.useStableObject)(componentProps);
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                return (0, $c6GJD.default).checkGate('po-refactor-message-renderer-provider') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $jVzfH.MessageRendererProvider), {
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    recommendationSession: recommendationSessionStable === $765afc5340447923$var$STABLE_EMPTY_OBJECT ? undefined : recommendationSessionStable,
                    messageSuccessComponent: messageSuccessComponent,
                    componentProps: componentPropsStable,
                    loadingFallback: loadingFallback,
                    triggerId: triggerId,
                    messageCreationType: messageCreationType,
                    postOffice: postOfficeStable,
                    isUFOEnabled: isUFOEnabled,
                    SuspenseBoundary: SuspenseBoundary,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                        onError: onError,
                        ...componentProps
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $lVEBn.ChoreographerWrapper), {
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2amyA.FeatureFlaggedUfoWrapper), {
                        messageTemplateId: messageTemplateId,
                        isEnabled: isUFOEnabled,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3Shv6.MessageContextProvider), {
                            value: {
                                messageInstanceId: messageInstanceId,
                                messageTemplateId: messageTemplateId,
                                triggerId: triggerId,
                                messageCreationType: messageCreationType,
                                transactionAccountId: componentProps.transactionAccountId,
                                analyticsDetails: postOffice?.analyticsDetails,
                                journeyId: journeyId,
                                journeyTriggerId: journeyTriggerId
                            },
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hyvHs.RecommendationProvider), {
                                value: recommendationSession ?? {},
                                children: /*#__PURE__*/ (0, $l998X.jsx)(SuspenseBoundary, {
                                    fallback: loadingComponent,
                                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $aEUWC.MessageAnalyticsContextProvider), {
                                        children: [
                                            messageSuccessComponent,
                                            /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                                onError: onError,
                                                messageInstanceId: messageInstanceId,
                                                ...componentProps
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                });
            };
            return (0, $2HRxT.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};
module.exports["MaybeSuspenseBoundary"] = $765afc5340447923$export$9750eb54d7c7e789;
module.exports["asMessageRenderer"] = $765afc5340447923$export$7b7e5a348ef9a7c1;

});

parcelRegister("3NyPa", function(module, exports) {

var $jTlSd = parcelRequire("jTlSd");


var $koKWt = parcelRequire("koKWt");

const $959aa8656bf0972c$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $jTlSd.MessagePerformanceTracker,
    PlacementPerformanceTracker: $koKWt.PlacementPerformanceTracker
};
module.exports["UFOv1"] = $959aa8656bf0972c$export$96236906ebaa7f87;

});

parcelRegister("jTlSd", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");


var $haNjI = parcelRequire("haNjI");

class $71d7f78b2ff13923$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.aggregatedExperience = void 0;
        this.messageSpecificExperience = void 0;
        this.experiences = void 0;
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $5aVN7.UFOExperience)((0, $haNjI.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $9NDUe.ExperienceTypes).Load,
            platform: {
                component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $5aVN7.UFOExperience)(`${(0, $haNjI.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $9NDUe.ExperienceTypes).Load,
            platform: {
                component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}
module.exports["MessagePerformanceTracker"] = $71d7f78b2ff13923$export$ae5c73c7c4f454e6;

});

parcelRegister("haNjI", function(module, exports) {
const $ac68ec5e99dfa5a8$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $ac68ec5e99dfa5a8$export$6d482cfa20c9d220 = 'post-office';
module.exports["UFOExperienceNames"] = $ac68ec5e99dfa5a8$export$cc7ddf8ca628f6f1;
module.exports["POST_OFFICE_PLATFORM_NAME"] = $ac68ec5e99dfa5a8$export$6d482cfa20c9d220;

});

parcelRegister("koKWt", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");


var $haNjI = parcelRequire("haNjI");

const $f3e04d171a04c0ba$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $9NDUe.ExperienceTypes).Load,
    platform: {
        component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $f3e04d171a04c0ba$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        /** UFO experience for tracking the performance of all placements in aggregate.
     * This supports setting up a single platform-level SLO for all placements.
     */ this.aggregatedExperience = void 0;
        /** UFO experience for tracking the performance of a specific placement.
     * This supports setting up a placement-specific SLOs.
     */ this.placementSpecificExperience = void 0;
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $5aVN7.UFOExperience)((0, $haNjI.UFOExperienceNames).PLACEMENT, $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $5aVN7.UFOExperience)(`${(0, $haNjI.UFOExperienceNames).PLACEMENT}.${placementId}`, $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}
module.exports["PlacementPerformanceTracker"] = $f3e04d171a04c0ba$export$8b48c2105ba0b35a;

});

parcelRegister("hOVIX", function(module, exports) {
var $0a8f0e83dcf5160a$export$b9722560029694e7 = /*#__PURE__*/ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    return PostOfficeErrorCodes;
}({});
class $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 extends Error {
}
class $0a8f0e83dcf5160a$export$627bc00a5ef5f6ae extends Error {
}
class $0a8f0e83dcf5160a$export$d145ea5319863172 extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), this.code = code;
    }
}
function $0a8f0e83dcf5160a$export$4cb1ea6034a33155(error) {
    return typeof error === 'object' && !!error && 'status' in error && typeof error.status === 'number';
}
function $0a8f0e83dcf5160a$export$aed524b0009b5631(error) {
    return typeof error === 'object' && !!error && 'logLevel' in error && typeof error.logLevel === 'string';
}
class $0a8f0e83dcf5160a$export$ed601cd0dc1a1be7 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(args){
        /**
     * It is expected that this error message can be not deterministic.
     * This error message can be displayed in the "Failures" and "Preview It" tabs for message makers.
     * Showing the error cause helps them understand what was the problem with their payload.
     *
     * On Post Office (platform) side, we use "instanceof MessageTemplateError" check
     * to distinguish between message makers code errors and platform errors,
     * but we don't rely on the error message itself.
     */ const errMessage = args.cause instanceof Error ? args.cause.message : 'Error in message template code';
        super(errMessage, "MessageTemplateError", args.cause);
        this.function = void 0;
        this.messageTemplateId = void 0;
        this.triggerId = void 0;
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2833d4759f81601b extends $0a8f0e83dcf5160a$export$ed601cd0dc1a1be7 {
    constructor(args){
        super(args);
        this.message = 'Invalid CSS property could not be processed by Juice';
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$8d39b103586e9fd4 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, cause){
        super(message, "NotAbleToProcessEmailTemplateError", cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$f649da38897d27f7 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$c2852c1c4d9aba3e extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$4b7b4e09547e4bb3 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$360a094a97597d87 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$4d068b43eb55165b extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$ac007ee150add337 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$19cb89dd679394cb extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$78651662ad470cc5 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Message Template not found', "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$8a5041670cdd8db2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Journey not found', "JourneyNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$1240ddc25cf964e6 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Message Template action handler validation error', "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$3c4884b7ae7fe517 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$913b8e68dc7ae8fe extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Placement not found', "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$3dfc27a8d3942f4d extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$e5ccdf8bbfead7a2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$823733742d803ae6 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$1caa32527f23acd2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(errorCause){
        super('Failed to send digest event to orchestration queue', "DigestEngineFailedSendError");
        this.errorCause = void 0;
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$a6f2aad8fa094b39 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? 'Unable to get user details for the given account ID', "UnableToGetUserDetailsError"), this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2f1e27130c2bf271 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError");
        this.payloadSize = void 0;
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$d0dc094613469f2b extends $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message);
        this.workspaceId = void 0;
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$5603eab37ce562f5 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(fileType){
        super('The attachment file is not supported', "UnsupportedAttachmentType");
        this.fileType = void 0;
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$e0e9aa0e9c6b37ff extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader");
        this.error = void 0;
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$3ad818f64601e141 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$25470bb6cba4fba0 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
        this.messageTemplateId = void 0;
        this.placementId = void 0;
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$ce14d445679448b6 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? 'unknown error', "HydrationFailureAtPlacementError");
        this.messageTemplateId = void 0;
        this.messageInstanceId = void 0;
        this.placementId = void 0;
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
}
class $0a8f0e83dcf5160a$export$c9a26a17db1045c8 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super('All messages failed at placement', "AllMessagesFailureHydrationAtPlacementError");
        this.placementId = void 0;
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$8ab4fb362168b928 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2afd69f57fe5285f extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Recipient expander not found for mapper', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$7635d2b1a281d626 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError");
        this.errors = void 0;
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$9e1c6d00e675bc86 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, recipient){
        super(message, "RichRecipientError");
        this.recipient = void 0;
        this.name = this.constructor.name;
        this.recipient = recipient;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$90bef7fa95eca3fa extends Error {
    constructor(status){
        super('Posting Mobile Notifications message failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$6d1a4929f6ff1a32 extends $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$c19fc5e8aa4e064d extends Error {
    constructor(){
        super('Ingestion source is required when custom profile is specified');
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2d3a68dab93b8cc4 extends Error {
    constructor(){
        super('A renderRedacted function is required when redactionLevel is set to a non-null value');
        this.name = this.constructor.name;
    }
}
class $0a8f0e83dcf5160a$export$175c1dbb0d7c238a extends Error {
    constructor(status){
        super('Enqueueing email failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
const $0a8f0e83dcf5160a$export$5c9840cf9181ada = 'post-office_enable_ca-ignore-upstream-errors';
const $0a8f0e83dcf5160a$export$a1f2446abf1cd73 = '1';
class $0a8f0e83dcf5160a$export$23fab744b3076342 extends Error {
    constructor(message, status){
        super(message), this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$194adecfa0265ea1 extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg);
        this.msg = void 0;
        this.messageInstanceId = void 0;
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
}
class $0a8f0e83dcf5160a$export$c504492f06c975b5 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super('hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user', "HydrationDeliveryNoDataFoundError");
        this.ipmNumber = void 0;
        this.variantFromStatsig = void 0;
        this.contentfulLocale = void 0;
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$1c932b9d1680ee0b extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$5d5d1885c87ef4bc extends Error {
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$f177e7d3a356e715 extends $0a8f0e83dcf5160a$export$5d5d1885c87ef4bc {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
module.exports["PostOfficeErrorCodes"] = $0a8f0e83dcf5160a$export$b9722560029694e7;
module.exports["PostOfficeError"] = $0a8f0e83dcf5160a$export$d145ea5319863172;
module.exports["InvalidMessageTemplateIdError"] = $0a8f0e83dcf5160a$export$19cb89dd679394cb;
module.exports["MessageRendererEmptyValidationResponseError"] = $0a8f0e83dcf5160a$export$3dfc27a8d3942f4d;

});

parcelRegister("3Shv6", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f1cd061039c521e8$var$initialValue = {};
const $f1cd061039c521e8$export$b060d577040138d8 = (0, $42omo.createContext)($f1cd061039c521e8$var$initialValue);
const $f1cd061039c521e8$export$42de33f7652dc3de = $f1cd061039c521e8$export$b060d577040138d8.Provider;
const $f1cd061039c521e8$export$a5b6d14a2e25725a = ()=>(0, $42omo.useContext)($f1cd061039c521e8$export$b060d577040138d8);
module.exports["MessageContextProvider"] = $f1cd061039c521e8$export$42de33f7652dc3de;
module.exports["useMessageContext"] = $f1cd061039c521e8$export$a5b6d14a2e25725a;

});

parcelRegister("aEUWC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $03b25510c5956e6e$var$defaultMessageAnalyticsContextValue = {
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
};
const $03b25510c5956e6e$export$c81717973c6c4a90 = /*#__PURE__*/ (0, $42omo.createContext)($03b25510c5956e6e$var$defaultMessageAnalyticsContextValue);
const $03b25510c5956e6e$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $42omo.useRef)(false);
    const contextValue = (0, $42omo.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($03b25510c5956e6e$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
const $03b25510c5956e6e$export$bb426ba114b64992 = ()=>(0, $42omo.useContext)($03b25510c5956e6e$export$c81717973c6c4a90);
module.exports["MessageAnalyticsContextProvider"] = $03b25510c5956e6e$export$1737ab199e83455e;
module.exports["useMessageAnalyticsContext"] = $03b25510c5956e6e$export$bb426ba114b64992;

});

parcelRegister("jVzfH", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $h6POP = parcelRequire("h6POP");


var $3Shv6 = parcelRequire("3Shv6");


var $hyvHs = parcelRequire("hyvHs");


var $42omo = parcelRequire("42omo");


var $5RZ3F = parcelRequire("5RZ3F");


var $2amyA = parcelRequire("2amyA");


var $aEUWC = parcelRequire("aEUWC");

const $121622f1adade9d3$var$DEFAULT_RECOMMENDATION_SESSION = {};
const $121622f1adade9d3$export$5fe06fe68913d493 = ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, recommendationSession: recommendationSession, messageSuccessComponent: messageSuccessComponent, componentProps: componentProps, loadingFallback: loadingFallback, triggerId: triggerId, messageCreationType: messageCreationType, postOffice: postOffice, isUFOEnabled: isUFOEnabled, children: children, SuspenseBoundary: SuspenseBoundary = (0, $42omo.Suspense) })=>{
    const loadingComponent = (0, $42omo.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
            name: (0, $h6POP.UFOv2).HoldNames.MESSAGE,
            children: loadingFallback ?? null
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: loadingFallback ?? null
        }), [
        loadingFallback,
        isUFOEnabled
    ]);
    const messageContextMemo = (0, $42omo.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            componentProps: componentProps,
            analyticsDetails: postOffice?.analyticsDetails
        }), [
        messageInstanceId,
        messageTemplateId,
        triggerId,
        messageCreationType,
        componentProps,
        postOffice
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5RZ3F.ChoreographerWrapper), {
        messageId: messageInstanceId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2amyA.FeatureFlaggedUfoWrapper), {
            messageTemplateId: messageTemplateId,
            isEnabled: isUFOEnabled,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3Shv6.MessageContextProvider), {
                value: messageContextMemo,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hyvHs.RecommendationProvider), {
                    value: recommendationSession ?? $121622f1adade9d3$var$DEFAULT_RECOMMENDATION_SESSION,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(SuspenseBoundary, {
                        fallback: loadingComponent,
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $aEUWC.MessageAnalyticsContextProvider), {
                            children: [
                                messageSuccessComponent,
                                children
                            ]
                        })
                    })
                })
            })
        })
    });
};
module.exports["MessageRendererProvider"] = $121622f1adade9d3$export$5fe06fe68913d493;

});

parcelRegister("hyvHs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $bYRk6 = parcelRequire("bYRk6");


var $42omo = parcelRequire("42omo");

const $68ebcc2083a05cc4$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $42omo.createContext)({
    sessionId: undefined,
    entityId: undefined
});
const $68ebcc2083a05cc4$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($68ebcc2083a05cc4$export$ba2f44035effd9c1.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
            data: value,
            children: children
        })
    });
};
const $68ebcc2083a05cc4$export$3321c0b02f750bcc = ()=>(0, $42omo.useContext)($68ebcc2083a05cc4$export$ba2f44035effd9c1);
module.exports["RecommendationProvider"] = $68ebcc2083a05cc4$export$f60e87d7b5f59562;
module.exports["useRecommendationContext"] = $68ebcc2083a05cc4$export$3321c0b02f750bcc;

});

parcelRegister("5RZ3F", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $7XIdu = parcelRequire("7XIdu");


var $42omo = parcelRequire("42omo");


var $3zCGc = parcelRequire("3zCGc");

const $92519f251282f573$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return null;
};
const $92519f251282f573$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $3zCGc.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $l998X.jsx)($92519f251282f573$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $92519f251282f573$export$8db7ba034addcd65;

});

parcelRegister("2amyA", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $h6POP = parcelRequire("h6POP");

const $5a78db0628042bee$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
        name: (0, $h6POP.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
            name: `${(0, $h6POP.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["FeatureFlaggedUfoWrapper"] = $5a78db0628042bee$export$8e6fb7035018b3e4;

});

parcelRegister("lVEBn", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $7XIdu = parcelRequire("7XIdu");


var $3zCGc = parcelRequire("3zCGc");


var $42omo = parcelRequire("42omo");

const $5d2b57d7f45b3b6a$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return null;
};
const $5d2b57d7f45b3b6a$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $3zCGc.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $l998X.jsx)($5d2b57d7f45b3b6a$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $5d2b57d7f45b3b6a$export$8db7ba034addcd65;

});

parcelRegister("6Ht9d", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gAOec = parcelRequire("gAOec");

const $876859b1b10b173e$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $42omo.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $gAOec.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};
module.exports["useInitialData"] = $876859b1b10b173e$export$5523c5f3222291d0;

});

parcelRegister("gAOec", function(module, exports) {

var $7XIdu = parcelRequire("7XIdu");


var $5nZsM = parcelRequire("5nZsM");


var $42omo = parcelRequire("42omo");


var $6IMPA = parcelRequire("6IMPA");

class $a8acaf5fcf658c6f$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $a8acaf5fcf658c6f$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $42omo.useState)((0, $6IMPA.toLoading)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $42omo.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then(async (res)=>{
            if (!res) return;
            if ((0, $6IMPA.assertResponseIsOk)(res)) {
                const data = await res.json();
                setState((0, $6IMPA.toData)(data));
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            }
        }).catch((err)=>{
            if (err instanceof $a8acaf5fcf658c6f$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $6IMPA.toError)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};
module.exports["AlreadyRunningError"] = $a8acaf5fcf658c6f$export$8c5224d3af2f3c8b;
module.exports["useData"] = $a8acaf5fcf658c6f$export$c1cf1cf4c5d51937;

});

parcelRegister("6IMPA", function(module, exports) {
const $7d79f12ff0021e5f$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $7d79f12ff0021e5f$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($7d79f12ff0021e5f$export$18a0019e5439b209(res));
};
const $7d79f12ff0021e5f$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $7d79f12ff0021e5f$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $7d79f12ff0021e5f$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });
module.exports["assertResponseIsOk"] = $7d79f12ff0021e5f$export$b3732c8ff6f9c463;
module.exports["toLoading"] = $7d79f12ff0021e5f$export$f9a5bd0ffba29ffc;
module.exports["toError"] = $7d79f12ff0021e5f$export$cc3b967c039ed3e7;
module.exports["toData"] = $7d79f12ff0021e5f$export$24a6b176bdc41ce5;

});

parcelRegister("j0Fou", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $PAiZW = parcelRequire("PAiZW");


var $kO3gu = parcelRequire("kO3gu");


var $8Bzrf = parcelRequire("8Bzrf");


var $eHv8q = parcelRequire("eHv8q");


var $9OLUt = parcelRequire("9OLUt");


var $42omo = parcelRequire("42omo");

const $68a42afbf7553230$export$201bbce8187a6e3c = (path, config)=>{
    const { placementId: placementId } = (0, $8Bzrf.usePlacementContext)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const fetcher = (0, $kO3gu.usePlacementFetchingContext)();
    const placementApi = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!placementId) return ()=>({
                isLoading: false,
                data: undefined,
                error: new Error('No placementId found, make this is used as a child of PlacementProvider')
            });
        if ((0, $c6GJD.default).checkGate('post-office-use-placement-with-client')) return (0, $9OLUt.createUsePlacementWithClient)(placementId, fetcher);
        return (0, $eHv8q.createUsePlacement)(placementId, fetcher);
    }, [
        placementId,
        fetcher
    ]);
    const { queryParams: queryParams = {} } = config ?? {};
    const placementParams = {
        ...context,
        ...queryParams
    };
    const apiDependencies = (0, $42omo.useMemo)(()=>{
        return [
            config?.autoRefetch?.updateKey
        ];
    }, [
        config?.autoRefetch?.updateKey
    ]);
    return placementApi(path, placementParams, config?.requestOptions, {
        throttleTime: config?.throttleTime,
        isEnabled: config?.autoRefetch?.isEnabled,
        deps: apiDependencies
    });
};
module.exports["usePlacementApi"] = $68a42afbf7553230$export$201bbce8187a6e3c;

});

parcelRegister("kO3gu", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1235947cddcdc3a4$export$afec669dc416ee7e = /*#__PURE__*/ (0, $42omo.createContext)({
    fetch: (...args)=>globalThis.fetch(...args)
});
const $1235947cddcdc3a4$export$e1e2cdb0425a9fa8 = ()=>(0, $42omo.useContext)($1235947cddcdc3a4$export$afec669dc416ee7e);
const $1235947cddcdc3a4$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
    const value = (0, $42omo.useMemo)(()=>({
            fetch: fetch
        }), [
        fetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1235947cddcdc3a4$export$afec669dc416ee7e.Provider, {
        value: value
    }, children);
};
module.exports["usePlacementFetchingContext"] = $1235947cddcdc3a4$export$e1e2cdb0425a9fa8;
module.exports["PlacementFetchingProvider"] = $1235947cddcdc3a4$export$5f25a6ddf0324fa8;

});

parcelRegister("eHv8q", function(module, exports) {

var $2OGMq = parcelRequire("2OGMq");


var $42omo = parcelRequire("42omo");


var $gAOec = parcelRequire("gAOec");

const $872a969cc90d2799$export$ee1d67e435d25cb5 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const timerRef = (0, $42omo.useRef)();
        const isRunningPromise = (0, $42omo.useRef)(false);
        (0, $42omo.useEffect)(()=>{
            return ()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            };
        }, []);
        const promiseToResolve = (0, $42omo.useMemo)(()=>{
            if (config?.isEnabled === false) return undefined;
            return ({ signal: signal })=>{
                if (isRunningPromise.current) return Promise.reject(new (0, $gAOec.AlreadyRunningError)());
                isRunningPromise.current = true;
                timerRef.current = setTimeout(()=>{
                    isRunningPromise.current = false;
                }, config?.throttleTime ?? 0);
                return (0, $2OGMq.fetchPlacementData)(placementId, path, context, fetcher, {
                    ...requestOptions,
                    signal: signal
                });
            };
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            config?.deps,
            path
        ]);
        return (0, $gAOec.useData)(promiseToResolve, {
            analytics: {
                name: placementId,
                path: path
            }
        });
    };
};
module.exports["createUsePlacement"] = $872a969cc90d2799$export$ee1d67e435d25cb5;

});

parcelRegister("2OGMq", function(module, exports) {
const $c9d2f99792ae105c$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $c9d2f99792ae105c$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $c9d2f99792ae105c$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$c9d2f99792ae105c$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $c9d2f99792ae105c$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
    const defaultHeaders = {
        credentials: 'include',
        mode: 'cors',
        'Content-Type': 'application/json'
    };
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = new URLSearchParams($c9d2f99792ae105c$var$stringifyObjectValues(context));
    queryParams.sort();
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$c9d2f99792ae105c$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return fetcher.fetch(url, {
        ...requestOptions,
        headers: {
            ...defaultHeaders,
            ...requestOptions?.headers
        }
    });
};
module.exports["fetchPlacementData"] = $c9d2f99792ae105c$export$ce743d02f83ee521;

});

parcelRegister("9OLUt", function(module, exports) {

var $hy3a0 = parcelRequire("hy3a0");


var $7XIdu = parcelRequire("7XIdu");


var $5nZsM = parcelRequire("5nZsM");

const $c40dbd4b4a40e84f$export$7a2a7b6f48ac7d1 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
        const analyticsSubjectId = placementId;
        const analyticsAttributes = {
            path: path
        };
        const { data: data, error: error } = (0, $hy3a0.useFetchPlacementData)(config?.isEnabled === false ? null : placementId, path, context, fetcher, requestOptions, {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            onSuccess: ()=>{
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            },
            onError: (error)=>{
                fireAnalyticsEvent({
                    action: 'rejected',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes,
                        errorName: error?.name ?? 'unknown',
                        errorMessage: error?.message ?? 'unknown'
                    }
                });
            }
        });
        if (data) return {
            isLoading: false,
            error: undefined,
            data: data
        };
        if (error) return {
            isLoading: false,
            error: error,
            data: undefined
        };
        return {
            isLoading: true,
            error: undefined,
            data: undefined
        };
    };
};
module.exports["createUsePlacementWithClient"] = $c40dbd4b4a40e84f$export$7a2a7b6f48ac7d1;

});

parcelRegister("hy3a0", function(module, exports) {

var $fCcUZ = parcelRequire("fCcUZ");

const $785c8761b65409e5$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $785c8761b65409e5$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $785c8761b65409e5$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$785c8761b65409e5$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $785c8761b65409e5$var$defaultHeaders = {
    credentials: 'include',
    mode: 'cors',
    'Content-Type': 'application/json'
};
const $785c8761b65409e5$export$ef70136078f15deb = (placementId, path, context, fetcher, requestOptions, useSWROptions)=>{
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = new URLSearchParams($785c8761b65409e5$var$stringifyObjectValues(context));
    queryParams.sort();
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$785c8761b65409e5$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return (0, $fCcUZ.default)(placementId ? url : null, (url)=>fetcher.fetch(url, {
            ...requestOptions,
            headers: {
                ...$785c8761b65409e5$var$defaultHeaders,
                ...requestOptions?.headers
            }
        })?.then((res)=>{
            if (!res) throw new Error('No response from fetch');
            return res.json();
        }), useSWROptions);
};
module.exports["useFetchPlacementData"] = $785c8761b65409e5$export$ef70136078f15deb;

});

parcelRegister("fCcUZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxT4C = parcelRequire("hxT4C");


var $96T14 = parcelRequire("96T14");
parcelRequire("ltrno");
var $ltrno = parcelRequire("ltrno");

var $hKRm8 = parcelRequire("hKRm8");

// Shared state between server components and client components
const $b5e46ce872016a0c$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $b5e46ce872016a0c$var$UNDEFINED = /*#__NOINLINE__*/ $b5e46ce872016a0c$var$noop();
const $b5e46ce872016a0c$var$OBJECT = Object;
const $b5e46ce872016a0c$var$isUndefined = (v)=>v === $b5e46ce872016a0c$var$UNDEFINED;
const $b5e46ce872016a0c$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $b5e46ce872016a0c$var$table = new WeakMap();
const $b5e46ce872016a0c$var$getTypeName = (value)=>$b5e46ce872016a0c$var$OBJECT.prototype.toString.call(value);
const $b5e46ce872016a0c$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $b5e46ce872016a0c$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $b5e46ce872016a0c$var$stableHash = (arg)=>{
    const type = typeof arg;
    const typeName = $b5e46ce872016a0c$var$getTypeName(arg);
    const isDate = $b5e46ce872016a0c$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $b5e46ce872016a0c$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $b5e46ce872016a0c$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($b5e46ce872016a0c$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $b5e46ce872016a0c$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$b5e46ce872016a0c$var$counter + '~';
        $b5e46ce872016a0c$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $b5e46ce872016a0c$var$stableHash(arg[index]) + ',';
            $b5e46ce872016a0c$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $b5e46ce872016a0c$var$OBJECT.keys(arg).sort();
            while(!$b5e46ce872016a0c$var$isUndefined(index = keys.pop()))if (!$b5e46ce872016a0c$var$isUndefined(arg[index])) result += index + ':' + $b5e46ce872016a0c$var$stableHash(arg[index]) + ',';
            $b5e46ce872016a0c$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $b5e46ce872016a0c$var$serialize = (key)=>{
    if ($b5e46ce872016a0c$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $b5e46ce872016a0c$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $b5e46ce872016a0c$export$dbab534a48e651ef = (key)=>$b5e46ce872016a0c$var$serialize(key)[0];
/// <reference types="react/experimental" />
const $b5e46ce872016a0c$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((thenable)=>{
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then((v)=>{
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, (e)=>{
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
});
const $b5e46ce872016a0c$var$WITH_DEDUPE = {
    dedupe: true
};
const $b5e46ce872016a0c$var$resolvedUndef = Promise.resolve((0, $96T14.U));
const $b5e46ce872016a0c$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $96T14.b).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $96T14.s)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $42omo.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $42omo.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $42omo.useRef)(key);
    const fetcherRef = (0, $42omo.useRef)(fetcher);
    const configRef = (0, $42omo.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $96T14.z)(cache, key);
    const stateDependencies = (0, $42omo.useRef)({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    const fallback = (0, $96T14.e)(fallbackData) ? (0, $96T14.e)(config.fallback) ? (0, $96T14.U) : config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $96T14.e)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $42omo.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $96T14.e)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            return revalidateIfStale !== false;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $96T14.m)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $hxT4C.useSyncExternalStore)((0, $42omo.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $96T14.e)(cachedData) ? fallback && (0, $96T14.B)(fallback) ? $b5e46ce872016a0c$var$use(fallback) : fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $42omo.useRef)(data);
    const returnedData = keepPreviousData ? (0, $96T14.e)(cachedData) ? (0, $96T14.e)(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $96T14.e)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $96T14.e)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $96T14.e)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $96T14.e)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $96T14.e)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $96T14.e)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $42omo.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $96T14.I) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $96T14.e)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $96T14.e)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $96T14.o)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $96T14.U);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $96T14.e)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $96T14.a)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $hKRm8).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $42omo.useCallback)((...args)=>{
        return (0, $96T14.n)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $96T14.u)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $96T14.e)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $96T14.u)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $96T14.U), $b5e46ce872016a0c$var$WITH_DEDUPE);
        let nextFocusRevalidatedAt = 0;
        if (getConfig().revalidateOnFocus) {
            const initNow = Date.now();
            nextFocusRevalidatedAt = initNow + getConfig().focusThrottleInterval;
        }
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $hKRm8).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $hKRm8).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $hKRm8).MUTATE_EVENT) return revalidate();
            else if (type == (0, $hKRm8).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $ltrno.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) // Performance optimization: if a request is already in progress for this key,
        // skip the revalidation to avoid redundant work
        {
            if (!FETCH[key]) {
                if ((0, $96T14.e)(data) || (0, $96T14.r)) // Revalidate immediately.
                softRevalidate();
                else // Delay the revalidate if we have data to return so we won't block
                // rendering.
                (0, $96T14.t)(softRevalidate);
            }
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $96T14.u)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $96T14.a)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($b5e46ce872016a0c$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $42omo.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense) {
        const hasKeyButNoData = key && (0, $96T14.e)(data);
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $96T14.I) && (0, $96T14.r) && hasKeyButNoData) throw new Error('Fallback data is required when using Suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        if (hasKeyButNoData) {
            fetcherRef.current = fetcher;
            configRef.current = config;
            unmountedRef.current = false;
        }
        const req = PRELOAD[key];
        const mutateReq = !(0, $96T14.e)(req) && hasKeyButNoData ? boundMutate(req) : $b5e46ce872016a0c$var$resolvedUndef;
        $b5e46ce872016a0c$var$use(mutateReq);
        if (!(0, $96T14.e)(error) && hasKeyButNoData) throw error;
        const revalidation = hasKeyButNoData ? revalidate($b5e46ce872016a0c$var$WITH_DEDUPE) : $b5e46ce872016a0c$var$resolvedUndef;
        if (!(0, $96T14.e)(returnedData) && hasKeyButNoData) {
            // @ts-ignore modify react promise status
            revalidation.status = 'fulfilled';
            // @ts-ignore modify react promise value
            revalidation.value = true;
        }
        $b5e46ce872016a0c$var$use(revalidation);
    }
    const swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
const $b5e46ce872016a0c$export$4c7bbecdacc3ca2c = (0, $96T14.O).defineProperty((0, $96T14.g), 'defaultValue', {
    value: (0, $96T14.d)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $b5e46ce872016a0c$export$2e2bcd8739ae039 = (0, $ltrno.withArgs)($b5e46ce872016a0c$var$useSWRHandler);
module.exports["SWRConfig"] = $b5e46ce872016a0c$export$4c7bbecdacc3ca2c;
module.exports["default"] = $b5e46ce872016a0c$export$2e2bcd8739ae039;

});

parcelRegister("96T14", function(module, exports) {
$parcel$export(module.exports, "c", () => $6a1f59ad6a5062ba$export$db3b6bfb95261072);

var $42omo = parcelRequire("42omo");


var $hKRm8 = parcelRequire("hKRm8");


var $hrSFW = parcelRequire("hrSFW");

'use client';
// Global state used to deduplicate requests and store listeners
const $6a1f59ad6a5062ba$export$8b22cf2602fb60ce = new WeakMap();
// Shared state between server components and client components
const $6a1f59ad6a5062ba$export$ebd11618f299a286 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08 = /*#__NOINLINE__*/ $6a1f59ad6a5062ba$export$ebd11618f299a286();
const $6a1f59ad6a5062ba$export$c4ce752e73470fba = Object;
const $6a1f59ad6a5062ba$export$f1e1789686576879 = (v)=>v === $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08;
const $6a1f59ad6a5062ba$export$407448d2b89b1813 = (v)=>typeof v == 'function';
const $6a1f59ad6a5062ba$export$953cecd6e717a553 = (a, b)=>({
        ...a,
        ...b
    });
const $6a1f59ad6a5062ba$export$ef35774e6d314e91 = (x)=>$6a1f59ad6a5062ba$export$407448d2b89b1813(x.then);
const $6a1f59ad6a5062ba$var$EMPTY_CACHE = {};
const $6a1f59ad6a5062ba$var$INITIAL_CACHE = {};
const $6a1f59ad6a5062ba$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $6a1f59ad6a5062ba$export$23f2a1d2818174ef = typeof window != $6a1f59ad6a5062ba$var$STR_UNDEFINED;
const $6a1f59ad6a5062ba$export$efccba1c4a2ef57b = typeof document != $6a1f59ad6a5062ba$var$STR_UNDEFINED;
const $6a1f59ad6a5062ba$export$d141bba7fdc215a3 = $6a1f59ad6a5062ba$export$23f2a1d2818174ef && 'Deno' in window;
const $6a1f59ad6a5062ba$export$4a5767248b18ef41 = ()=>$6a1f59ad6a5062ba$export$23f2a1d2818174ef && typeof window['requestAnimationFrame'] != $6a1f59ad6a5062ba$var$STR_UNDEFINED;
const $6a1f59ad6a5062ba$export$df995fae86a55f06 = (cache, key)=>{
    const state = $6a1f59ad6a5062ba$export$8b22cf2602fb60ce.get(cache);
    return [
        // Getter
        ()=>!$6a1f59ad6a5062ba$export$f1e1789686576879(key) && cache.get(key) || $6a1f59ad6a5062ba$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$6a1f59ad6a5062ba$export$f1e1789686576879(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $6a1f59ad6a5062ba$var$INITIAL_CACHE)) $6a1f59ad6a5062ba$var$INITIAL_CACHE[key] = prev;
                state[5](key, $6a1f59ad6a5062ba$export$953cecd6e717a553(prev, info), prev || $6a1f59ad6a5062ba$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$6a1f59ad6a5062ba$export$f1e1789686576879(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $6a1f59ad6a5062ba$var$INITIAL_CACHE) return $6a1f59ad6a5062ba$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$6a1f59ad6a5062ba$export$f1e1789686576879(key) && cache.get(key) || $6a1f59ad6a5062ba$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $6a1f59ad6a5062ba$var$online = true;
const $6a1f59ad6a5062ba$var$isOnline = ()=>$6a1f59ad6a5062ba$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$6a1f59ad6a5062ba$var$onWindowEvent, $6a1f59ad6a5062ba$var$offWindowEvent] = $6a1f59ad6a5062ba$export$23f2a1d2818174ef && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $6a1f59ad6a5062ba$export$ebd11618f299a286,
    $6a1f59ad6a5062ba$export$ebd11618f299a286
];
const $6a1f59ad6a5062ba$var$isVisible = ()=>{
    const visibilityState = $6a1f59ad6a5062ba$export$efccba1c4a2ef57b && document.visibilityState;
    return $6a1f59ad6a5062ba$export$f1e1789686576879(visibilityState) || visibilityState !== 'hidden';
};
const $6a1f59ad6a5062ba$var$initFocus = (callback)=>{
    // focus revalidate
    if ($6a1f59ad6a5062ba$export$efccba1c4a2ef57b) document.addEventListener('visibilitychange', callback);
    $6a1f59ad6a5062ba$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($6a1f59ad6a5062ba$export$efccba1c4a2ef57b) document.removeEventListener('visibilitychange', callback);
        $6a1f59ad6a5062ba$var$offWindowEvent('focus', callback);
    };
};
const $6a1f59ad6a5062ba$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $6a1f59ad6a5062ba$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $6a1f59ad6a5062ba$var$online = false;
    };
    $6a1f59ad6a5062ba$var$onWindowEvent('online', onOnline);
    $6a1f59ad6a5062ba$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $6a1f59ad6a5062ba$var$offWindowEvent('online', onOnline);
        $6a1f59ad6a5062ba$var$offWindowEvent('offline', onOffline);
    };
};
const $6a1f59ad6a5062ba$export$ffb5f4729a158638 = {
    isOnline: $6a1f59ad6a5062ba$var$isOnline,
    isVisible: $6a1f59ad6a5062ba$var$isVisible
};
const $6a1f59ad6a5062ba$export$9e5f44173e64f162 = {
    initFocus: $6a1f59ad6a5062ba$var$initFocus,
    initReconnect: $6a1f59ad6a5062ba$var$initReconnect
};
const $6a1f59ad6a5062ba$export$9bb611d729802a56 = !(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useId;
const $6a1f59ad6a5062ba$export$43caf9889c228507 = !$6a1f59ad6a5062ba$export$23f2a1d2818174ef || $6a1f59ad6a5062ba$export$d141bba7fdc215a3;
// Polyfill requestAnimationFrame
const $6a1f59ad6a5062ba$export$625550452a3fa3ec = (f)=>$6a1f59ad6a5062ba$export$4a5767248b18ef41() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $6a1f59ad6a5062ba$export$3b14a55fb2447963 = $6a1f59ad6a5062ba$export$43caf9889c228507 ? (0, $42omo.useEffect) : (0, $42omo.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $6a1f59ad6a5062ba$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $6a1f59ad6a5062ba$export$90a7f3efeed30595 = !$6a1f59ad6a5062ba$export$43caf9889c228507 && $6a1f59ad6a5062ba$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($6a1f59ad6a5062ba$var$navigatorConnection.effectiveType) || $6a1f59ad6a5062ba$var$navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $6a1f59ad6a5062ba$var$table = new WeakMap();
const $6a1f59ad6a5062ba$var$getTypeName = (value)=>$6a1f59ad6a5062ba$export$c4ce752e73470fba.prototype.toString.call(value);
const $6a1f59ad6a5062ba$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $6a1f59ad6a5062ba$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $6a1f59ad6a5062ba$export$882b5998b3b9117c = (arg)=>{
    const type = typeof arg;
    const typeName = $6a1f59ad6a5062ba$var$getTypeName(arg);
    const isDate = $6a1f59ad6a5062ba$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $6a1f59ad6a5062ba$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $6a1f59ad6a5062ba$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($6a1f59ad6a5062ba$export$c4ce752e73470fba(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $6a1f59ad6a5062ba$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$6a1f59ad6a5062ba$var$counter + '~';
        $6a1f59ad6a5062ba$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $6a1f59ad6a5062ba$export$882b5998b3b9117c(arg[index]) + ',';
            $6a1f59ad6a5062ba$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $6a1f59ad6a5062ba$export$c4ce752e73470fba.keys(arg).sort();
            while(!$6a1f59ad6a5062ba$export$f1e1789686576879(index = keys.pop()))if (!$6a1f59ad6a5062ba$export$f1e1789686576879(arg[index])) result += index + ':' + $6a1f59ad6a5062ba$export$882b5998b3b9117c(arg[index]) + ',';
            $6a1f59ad6a5062ba$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $6a1f59ad6a5062ba$export$2408f22a0fab9ae5 = (key)=>{
    if ($6a1f59ad6a5062ba$export$407448d2b89b1813(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $6a1f59ad6a5062ba$export$882b5998b3b9117c(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $6a1f59ad6a5062ba$var$__timestamp = 0;
const $6a1f59ad6a5062ba$export$ae1af26003f05816 = ()=>++$6a1f59ad6a5062ba$var$__timestamp;
async function $6a1f59ad6a5062ba$export$7ccc53e8f1e7dfc5(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $6a1f59ad6a5062ba$export$953cecd6e717a553({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($6a1f59ad6a5062ba$export$407448d2b89b1813(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $6a1f59ad6a5062ba$export$2408f22a0fab9ae5(_k);
        if (!key) return;
        const [get, set] = $6a1f59ad6a5062ba$export$df995fae86a55f06(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $6a1f59ad6a5062ba$export$8b22cf2602fb60ce.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $6a1f59ad6a5062ba$export$407448d2b89b1813(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($hKRm8.MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        let isError = false;
        // Update global timestamps.
        const beforeMutationTs = $6a1f59ad6a5062ba$export$ae1af26003f05816();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$6a1f59ad6a5062ba$export$f1e1789686576879(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $6a1f59ad6a5062ba$export$f1e1789686576879(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $6a1f59ad6a5062ba$export$407448d2b89b1813(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($6a1f59ad6a5062ba$export$407448d2b89b1813(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
            isError = true;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $6a1f59ad6a5062ba$export$ef35774e6d314e91(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
                isError = true;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (isError) throw error;
                return data;
            } else if (isError && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!isError) {
                // Transform the result into data.
                if ($6a1f59ad6a5062ba$export$407448d2b89b1813(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08,
                        _c: $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08,
                    _c: $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $6a1f59ad6a5062ba$export$ae1af26003f05816();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08
            });
        });
        // Throw error or return data
        if (isError) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $6a1f59ad6a5062ba$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $6a1f59ad6a5062ba$export$dda1d9f60106f0e9 = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$6a1f59ad6a5062ba$export$8b22cf2602fb60ce.has(provider)) {
        const opts = $6a1f59ad6a5062ba$export$953cecd6e717a553($6a1f59ad6a5062ba$export$9e5f44173e64f162, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = Object.create(null);
        const mutate = $6a1f59ad6a5062ba$export$7ccc53e8f1e7dfc5.bind($6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08, provider);
        let unmount = $6a1f59ad6a5062ba$export$ebd11618f299a286;
        const subscriptions = Object.create(null);
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$6a1f59ad6a5062ba$export$8b22cf2602fb60ce.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $6a1f59ad6a5062ba$export$8b22cf2602fb60ce.set(provider, [
                    EVENT_REVALIDATORS,
                    Object.create(null),
                    Object.create(null),
                    Object.create(null),
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$6a1f59ad6a5062ba$export$43caf9889c228507) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08, $6a1f59ad6a5062ba$var$revalidateAllKeys.bind($6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $hKRm8.FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08, $6a1f59ad6a5062ba$var$revalidateAllKeys.bind($6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $hKRm8.RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $6a1f59ad6a5062ba$export$8b22cf2602fb60ce.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $6a1f59ad6a5062ba$export$8b22cf2602fb60ce.get(provider)[4]
    ];
};
// error retry
const $6a1f59ad6a5062ba$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$6a1f59ad6a5062ba$export$f1e1789686576879(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $6a1f59ad6a5062ba$export$342063e11d6c3cad = (0, $hrSFW.dequal);
// Default cache provider
const [$6a1f59ad6a5062ba$export$db3b6bfb95261072, $6a1f59ad6a5062ba$export$35e795649ee09318] = $6a1f59ad6a5062ba$export$dda1d9f60106f0e9(new Map());
// Default config
const $6a1f59ad6a5062ba$export$4368d992c4eafac0 = $6a1f59ad6a5062ba$export$953cecd6e717a553({
    // events
    onLoadingSlow: $6a1f59ad6a5062ba$export$ebd11618f299a286,
    onSuccess: $6a1f59ad6a5062ba$export$ebd11618f299a286,
    onError: $6a1f59ad6a5062ba$export$ebd11618f299a286,
    onErrorRetry: $6a1f59ad6a5062ba$var$onErrorRetry,
    onDiscarded: $6a1f59ad6a5062ba$export$ebd11618f299a286,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $6a1f59ad6a5062ba$export$90a7f3efeed30595 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $6a1f59ad6a5062ba$export$90a7f3efeed30595 ? 5000 : 3000,
    compare: // providers
    $6a1f59ad6a5062ba$export$342063e11d6c3cad,
    isPaused: ()=>false,
    cache: $6a1f59ad6a5062ba$export$db3b6bfb95261072,
    mutate: $6a1f59ad6a5062ba$export$35e795649ee09318,
    fallback: {}
}, $6a1f59ad6a5062ba$export$ffb5f4729a158638);
const $6a1f59ad6a5062ba$export$2d1720544b23b823 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $6a1f59ad6a5062ba$export$953cecd6e717a553(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $6a1f59ad6a5062ba$export$953cecd6e717a553(f1, f2);
    }
    return v;
};
const $6a1f59ad6a5062ba$export$25ce5a424b770e84 = (0, $42omo.createContext)({});
const $6a1f59ad6a5062ba$export$39b482c5e57630a8 = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $42omo.useContext)($6a1f59ad6a5062ba$export$25ce5a424b770e84);
    const isFunctionalConfig = $6a1f59ad6a5062ba$export$407448d2b89b1813(value);
    const config = (0, $42omo.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $42omo.useMemo)(()=>isFunctionalConfig ? config : $6a1f59ad6a5062ba$export$2d1720544b23b823(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $42omo.useRef)($6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $6a1f59ad6a5062ba$export$dda1d9f60106f0e9(provider(extendedConfig.cache || $6a1f59ad6a5062ba$export$db3b6bfb95261072), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $6a1f59ad6a5062ba$export$3b14a55fb2447963(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $42omo.createElement)($6a1f59ad6a5062ba$export$25ce5a424b770e84.Provider, $6a1f59ad6a5062ba$export$953cecd6e717a553(props, {
        value: extendedConfig
    }));
};
module.exports["b"] = $6a1f59ad6a5062ba$export$8b22cf2602fb60ce;
module.exports["U"] = $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08;
module.exports["O"] = $6a1f59ad6a5062ba$export$c4ce752e73470fba;
module.exports["e"] = $6a1f59ad6a5062ba$export$f1e1789686576879;
module.exports["a"] = $6a1f59ad6a5062ba$export$407448d2b89b1813;
module.exports["m"] = $6a1f59ad6a5062ba$export$953cecd6e717a553;
module.exports["B"] = $6a1f59ad6a5062ba$export$ef35774e6d314e91;
module.exports["i"] = $6a1f59ad6a5062ba$export$23f2a1d2818174ef;
module.exports["z"] = $6a1f59ad6a5062ba$export$df995fae86a55f06;
module.exports["I"] = $6a1f59ad6a5062ba$export$9bb611d729802a56;
module.exports["r"] = $6a1f59ad6a5062ba$export$43caf9889c228507;
module.exports["t"] = $6a1f59ad6a5062ba$export$625550452a3fa3ec;
module.exports["u"] = $6a1f59ad6a5062ba$export$3b14a55fb2447963;
module.exports["s"] = $6a1f59ad6a5062ba$export$2408f22a0fab9ae5;
module.exports["o"] = $6a1f59ad6a5062ba$export$ae1af26003f05816;
module.exports["n"] = $6a1f59ad6a5062ba$export$7ccc53e8f1e7dfc5;
module.exports["d"] = $6a1f59ad6a5062ba$export$4368d992c4eafac0;
module.exports["f"] = $6a1f59ad6a5062ba$export$2d1720544b23b823;
module.exports["S"] = $6a1f59ad6a5062ba$export$25ce5a424b770e84;
module.exports["g"] = $6a1f59ad6a5062ba$export$39b482c5e57630a8;

});

parcelRegister("hKRm8", function(module, exports) {
const $0355effb9da30fde$export$831c820ad60f9d12 = 0;
const $0355effb9da30fde$export$24e9454cb99a11dc = 1;
const $0355effb9da30fde$export$75ea288459391154 = 2;
const $0355effb9da30fde$export$b019c3839228f243 = 3;
module.exports["FOCUS_EVENT"] = $0355effb9da30fde$export$831c820ad60f9d12;
module.exports["RECONNECT_EVENT"] = $0355effb9da30fde$export$24e9454cb99a11dc;
module.exports["MUTATE_EVENT"] = $0355effb9da30fde$export$75ea288459391154;
module.exports["ERROR_REVALIDATE_EVENT"] = $0355effb9da30fde$export$b019c3839228f243;

});

parcelRegister("hrSFW", function(module, exports) {
var $cb3f5eae1efed147$var$has = Object.prototype.hasOwnProperty;
function $cb3f5eae1efed147$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $cb3f5eae1efed147$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($cb3f5eae1efed147$var$has.call(foo, ctor) && ++len && !$cb3f5eae1efed147$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$cb3f5eae1efed147$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
module.exports["dequal"] = $cb3f5eae1efed147$export$de8294bb3be0322f;

});

parcelRegister("ltrno", function(module, exports) {
$parcel$export(module.exports, "useSWRConfig", () => $fa218ac480f8609c$export$f1dc0e282d4c1c0);
$parcel$export(module.exports, "withArgs", () => $fa218ac480f8609c$export$84d44e54e14b0133);
$parcel$export(module.exports, "subscribeCallback", () => $fa218ac480f8609c$export$e005210ed621746);
$parcel$export(module.exports, "SWRGlobalState", () => (parcelRequire("96T14")).b);
$parcel$export(module.exports, "defaultConfig", () => (parcelRequire("96T14")).d);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("96T14")).a);
$parcel$export(module.exports, "isUndefined", () => (parcelRequire("96T14")).e);
$parcel$export(module.exports, "mergeObjects", () => (parcelRequire("96T14")).m);
$parcel$export(module.exports, "serialize", () => (parcelRequire("96T14")).s);

var $96T14 = parcelRequire("96T14");


var $hKRm8 = parcelRequire("hKRm8");


var $aQZOK = parcelRequire("aQZOK");


var $42omo = parcelRequire("42omo");


// @ts-expect-error
const $fa218ac480f8609c$var$enableDevtools = (0, $96T14.i) && window.__SWR_DEVTOOLS_USE__;
const $fa218ac480f8609c$var$use = $fa218ac480f8609c$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $fa218ac480f8609c$var$setupDevTools = ()=>{
    if ($fa218ac480f8609c$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
};
const $fa218ac480f8609c$export$a3295358bff77e = (args)=>{
    return (0, $96T14.a)(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $fa218ac480f8609c$export$f1dc0e282d4c1c0 = ()=>{
    const parentConfig = (0, $42omo.useContext)((0, $96T14.S));
    const mergedConfig = (0, $42omo.useMemo)(()=>(0, $96T14.m)((0, $96T14.d), parentConfig), [
        parentConfig
    ]);
    return mergedConfig;
};
const $fa218ac480f8609c$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = (0, $96T14.s)(key_);
    const [, , , PRELOAD] = (0, $96T14.b).get((0, $96T14.c));
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $fa218ac480f8609c$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = (0, $96T14.s)(key_);
            const [, , , PRELOAD] = (0, $96T14.b).get((0, $96T14.c));
            if (key.startsWith((0, $aQZOK.INFINITE_PREFIX))) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ((0, $96T14.e)(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $fa218ac480f8609c$var$BUILT_IN_MIDDLEWARE = $fa218ac480f8609c$var$use.concat($fa218ac480f8609c$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $fa218ac480f8609c$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $fa218ac480f8609c$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $fa218ac480f8609c$export$a3295358bff77e(args);
        // Merge configurations.
        const config = (0, $96T14.f)(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($fa218ac480f8609c$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $fa218ac480f8609c$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $fa218ac480f8609c$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $fa218ac480f8609c$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$fa218ac480f8609c$var$setupDevTools();

});

parcelRegister("aQZOK", function(module, exports) {
const $7e6eb65cf45696a8$export$8667f065faedc62c = '$inf$';
module.exports["INFINITE_PREFIX"] = $7e6eb65cf45696a8$export$8667f065faedc62c;

});

parcelRegister("k7Tf7", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2xusd = parcelRequire("2xusd");


var $2MPqq = parcelRequire("2MPqq");

const $94cea1b432ccea5e$export$bf694c7c431c162a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2MPqq.SpotlightContextProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2xusd.Manager), {
            children: children
        })
    });
};
module.exports["PopoverProvider"] = $94cea1b432ccea5e$export$bf694c7c431c162a;

});

parcelRegister("a90ar", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cs0ez = parcelRequire("cs0ez");

const $fcb2cc293f5cb422$export$5ad0c0856b469f13 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cs0ez.Reference), {
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: ref,
                children: children
            })
    });
};
module.exports["PopoverTarget"] = $fcb2cc293f5cb422$export$5ad0c0856b469f13;

});

parcelRegister("3chlW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

const $497b092596857daa$var$styles = {
    root: "_1bsb1osq"
};
const $497b092596857daa$export$205c28213090dc52 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        ref: ref,
        testId: testId,
        xcss: $497b092596857daa$var$styles.root,
        role: "group",
        justifyContent: "end",
        gap: "space.050",
        children: children
    });
});
module.exports["SpotlightActions"] = $497b092596857daa$export$205c28213090dc52;

});

parcelRegister("f1UQW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $8f17e6224eab722b$var$styles = {
    root: "_18zrpxbi _syaz15cr _1q51u2gc"
};
const $8f17e6224eab722b$export$4ae665cf62a00c3f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: ref,
        xcss: $8f17e6224eab722b$var$styles.root,
        testId: testId,
        children: children
    });
});
module.exports["SpotlightBody"] = $8f17e6224eab722b$export$4ae665cf62a00c3f;

});

parcelRegister("71521", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $2MPqq = parcelRequire("2MPqq");


var $jEGan = parcelRequire("jEGan");

const $632f68eebac3d948$var$styles = {
    root: "_kqswh2mm",
    card: "_2rko1mok _zulpu2gc _kqswstnw _1bsbaq3k _1q51u2gc _85i5utpp _1e0c1txw _2lx21bp4 _16qs1nax"
};
const $632f68eebac3d948$var$placementStyles = {
    'top-start': "_u7co12x7 _rjxpc7mi",
    'top-center': "_u7co12x7 _1e021qz4",
    'top-end': "_u7co12x7 _1e02c7mi",
    'right-start': "_1e0212x7 _u7comgjw",
    'right-end': "_1e0212x7 _152tmgjw",
    'bottom-start': "_152t12x7 _rjxpc7mi",
    'bottom-center': "_152t12x7 _1e021qz4",
    'bottom-end': "_152t12x7 _1e02c7mi",
    'left-start': "_rjxp12x7 _u7comgjw",
    'left-end': "_rjxp12x7 _152tmgjw"
};
const $632f68eebac3d948$export$14710e13fc01d383 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    const { card: card } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const cardRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        card.setRef(cardRef);
    }, [
        card
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": testId,
        ref: ref,
        className: (0, $gMc0m.default)([
            $632f68eebac3d948$var$styles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $jEGan.Caret), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ref: cardRef,
                backgroundColor: "color.background.neutral.bold",
                xcss: (0, $1Whri.cx)($632f68eebac3d948$var$styles.card, $632f68eebac3d948$var$placementStyles[card.placement]),
                children: children
            })
        ]
    });
});
module.exports["SpotlightCard"] = $632f68eebac3d948$export$14710e13fc01d383;

});

parcelRegister("jEGan", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $2MPqq = parcelRequire("2MPqq");

const $8ca37cde5226694e$var$styles = {
    root: "_bfhk1aqn _mkrzmhja _4t3io7ao _kqswh2mm _1bsbo7ao _1pby1fw0",
    'top-start': "_t9ec71a3",
    'top-center': "_t9ec71a3",
    'top-end': "_t9ec71a3",
    'bottom-start': "_t9ec1hke",
    'bottom-center': "_t9ec1hke",
    'bottom-end': "_t9ec1hke",
    'right-start': "_t9ecjyd4",
    'right-end': "_t9ecjyd4",
    'left-start': "_t9ecebzf",
    'left-end': "_t9ecebzf"
};
const $8ca37cde5226694e$export$88fca06e22f21720 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId }, ref)=>{
    const { card: card } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            borderEndStartRadius: '1px'
        },
        className: (0, $gMc0m.default)([
            $8ca37cde5226694e$var$styles.root,
            $8ca37cde5226694e$var$styles[card.placement]
        ])
    });
});
module.exports["Caret"] = $8ca37cde5226694e$export$88fca06e22f21720;

});

parcelRegister("aVS0S", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $b2d7675e2e3d4813$var$styles = {
    root: "_zulpu2gc _1e0c1txw _2lx21sbv"
};
const $b2d7675e2e3d4813$export$67fb68d4ebe55a86 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        role: "group",
        className: (0, $gMc0m.default)([
            $b2d7675e2e3d4813$var$styles.root
        ]),
        children: children
    });
});
module.exports["SpotlightControls"] = $b2d7675e2e3d4813$export$67fb68d4ebe55a86;

});

parcelRegister("2owmo", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hmuev = parcelRequire("hmuev");


var $fVUfS = parcelRequire("fVUfS");


var $2MPqq = parcelRequire("2MPqq");

const $e90e33f81b492555$var$styles = {
    root: "_2rko12b0 _1rjc12x7 _syaz15cr _bfhk1aqn _irr31ibz _1di6of27"
};
const $e90e33f81b492555$export$4eef19754b0d485e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ autoFocus: autoFocus = true, onClick: onClick, testId: testId }, ref)=>{
    const { popoverContent: popoverContent } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const dismiss = (event)=>{
        popoverContent.dismiss.current(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        autoFocus: autoFocus,
        onClick: onClick || dismiss,
        ref: ref,
        testId: testId,
        xcss: $e90e33f81b492555$var$styles.root,
        "aria-label": "Dismiss",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: "Close"
        })
    });
});
module.exports["SpotlightDismissControl"] = $e90e33f81b492555$export$4eef19754b0d485e;

});

parcelRegister("eopLP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

const $c18394162d9dc107$var$styles = {
    root: "_bozgpxbi _y4tiutpp _1bsb1osq"
};
const $c18394162d9dc107$export$f76dbc85ba76ccc2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        ref: ref,
        testId: testId,
        xcss: $c18394162d9dc107$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        children: children
    });
});
module.exports["SpotlightFooter"] = $c18394162d9dc107$export$f76dbc85ba76ccc2;

});

parcelRegister("aZQ5F", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

const $ad24be9a70db7ad2$var$styles = {
    root: "_bozgpxbi _y4tiutpp"
};
const $ad24be9a70db7ad2$export$d646029b3ba8ab76 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        ref: ref,
        testId: testId,
        xcss: $ad24be9a70db7ad2$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.100",
        children: children
    });
});
module.exports["SpotlightHeader"] = $ad24be9a70db7ad2$export$d646029b3ba8ab76;

});

parcelRegister("bUJpY", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7hXDW = parcelRequire("7hXDW");


var $2MPqq = parcelRequire("2MPqq");

const $7a1f3efc02714981$export$b57275b1b6b9863b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    const { heading: heading } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
        id: heading.id,
        ref: ref,
        testId: testId,
        size: "xsmall",
        children: children
    });
});
module.exports["SpotlightHeadline"] = $7a1f3efc02714981$export$b57275b1b6b9863b;

});

parcelRegister("fNcP1", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $2MPqq = parcelRequire("2MPqq");

const $456a9b1f10f70d47$var$styles = {
    root: "_2rko12b0 _1dqonqa1 _189ee4h9 _1h6d8yml _syaz15cr _bfhk1aqn _irr31ibz _1di6of27"
};
const $456a9b1f10f70d47$export$eea27caf91a85655 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId }, ref)=>{
    const { primaryAction: primaryAction } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const done = (event)=>{
        primaryAction.action.current(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $456a9b1f10f70d47$var$styles.root,
        onClick: onClick || done,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            as: "span",
            children: children
        })
    });
});
module.exports["SpotlightPrimaryAction"] = $456a9b1f10f70d47$export$eea27caf91a85655;

});

parcelRegister("19Jj3", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $2MPqq = parcelRequire("2MPqq");

const $b6d455d4ca0de162$var$styles = {
    root: "_2rko12b0 _syaz15cr _bfhk1aqn _irr31ibz _1di6of27"
};
const $b6d455d4ca0de162$export$869dfff69399fe87 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId }, ref)=>{
    const { secondaryAction: secondaryAction } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const back = (event)=>{
        secondaryAction.action.current(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $b6d455d4ca0de162$var$styles.root,
        onClick: onClick || back,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            as: "span",
            children: children
        })
    });
});
module.exports["SpotlightSecondaryAction"] = $b6d455d4ca0de162$export$869dfff69399fe87;

});

parcelRegister("aG6kF", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $6F6hl = parcelRequire("6F6hl");

const $2d58ceeae1d26536$var$styles = {
    root: "_1ul91ris"
};
const $2d58ceeae1d26536$export$f4d9def8bfebca = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        xcss: $2d58ceeae1d26536$var$styles.root,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
            ref: ref,
            testId: testId,
            children: [
                children,
                " ",
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                    children: "steps"
                })
            ]
        })
    });
});
module.exports["SpotlightStepCount"] = $2d58ceeae1d26536$export$f4d9def8bfebca;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");

var $9wgn8 = parcelRequire("9wgn8");

var $cVrnQ = parcelRequire("cVrnQ");

var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzgdfik _1dk7dfik _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $d6Fdl = parcelRequire("d6Fdl");


var $dh538 = parcelRequire("dh538");

const $71feb0a29953fded$var$svgStyles = null;
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        if ((0, $dh538.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $l998X.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        if ((0, $dh538.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    } // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    if ((0, $dh538.fg)('platform-custom-icon-migration')) return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: 'var(--checkbox-background-color)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: 'var(--checkbox-tick-color)'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $l998X.jsx)((0, $d6Fdl.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: (0, $dh538.fg)('platform-dst-shape-theme-default') ? '2' : '1.5'
                }) : /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    }));
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null;
const $edf27753e59bf881$var$disabledStyles = null;
const $edf27753e59bf881$var$labelStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazi7uo _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1gmx _80om13gf",
            "_h5e31j9a _1nzsr01l _1eszjmqp _yp0j1q28 _ay2wby5v _d51ul4ek _phftrsbi _1g1f1l7x _l6wkjmqp _1dik1q28 _1sfg1bqt _fpdjby5v _1yjc1v1w _oaj1rsbi _1j3h1bqt _eawb5w2r _1rda5w2r _18q02sac _13hr1j28",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("k9Smn", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");

//      
var $eaced0a9c3d84a94$var$charCodeOfDot = ".".charCodeAt(0);
var $eaced0a9c3d84a94$var$reEscapeChar = /\\(\\)?/g;
var $eaced0a9c3d84a94$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $eaced0a9c3d84a94$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $eaced0a9c3d84a94$var$charCodeOfDot) result.push("");
    string.replace($eaced0a9c3d84a94$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($eaced0a9c3d84a94$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $eaced0a9c3d84a94$var$keysCache = {};
var $eaced0a9c3d84a94$var$keysRegex = /[.[\]]+/;
var $eaced0a9c3d84a94$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($eaced0a9c3d84a94$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $eaced0a9c3d84a94$var$keysCache[key] = key.split($eaced0a9c3d84a94$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $eaced0a9c3d84a94$var$keysCache[key] = $eaced0a9c3d84a94$var$stringToPath(key);
    }
    return $eaced0a9c3d84a94$var$keysCache[key];
};
//      
var $eaced0a9c3d84a94$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $eaced0a9c3d84a94$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $eaced0a9c3d84a94$var$_toPropertyKey(arg) {
    var key = $eaced0a9c3d84a94$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $eaced0a9c3d84a94$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $eaced0a9c3d84a94$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $bDniu.default)(current, [
                key
            ].map($eaced0a9c3d84a94$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $7Q5yr.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $eaced0a9c3d84a94$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $eaced0a9c3d84a94$var$setInRecursor(state, 0, $eaced0a9c3d84a94$var$toPath(key), value1, destroyArrays);
};
var $eaced0a9c3d84a94$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $eaced0a9c3d84a94$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $eaced0a9c3d84a94$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $eaced0a9c3d84a94$export$c52e5867d5879e24(values, name);
    var error = $eaced0a9c3d84a94$export$c52e5867d5879e24(errors, name);
    if (error && error[$eaced0a9c3d84a94$export$735bebc8ffabf28a]) error = error[$eaced0a9c3d84a94$export$735bebc8ffabf28a];
    var submitError = submitErrors && $eaced0a9c3d84a94$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $eaced0a9c3d84a94$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $eaced0a9c3d84a94$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $eaced0a9c3d84a94$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $eaced0a9c3d84a94$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$eaced0a9c3d84a94$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $eaced0a9c3d84a94$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $eaced0a9c3d84a94$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $eaced0a9c3d84a94$var$subscriptionFilter(result, state, previousState, subscription, $eaced0a9c3d84a94$export$41e855cb628c1b55, $eaced0a9c3d84a94$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $eaced0a9c3d84a94$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $eaced0a9c3d84a94$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $eaced0a9c3d84a94$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $eaced0a9c3d84a94$var$subscriptionFilter(result, state, previousState, subscription, $eaced0a9c3d84a94$export$f1ff97b9d1c7a3c3, $eaced0a9c3d84a94$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $eaced0a9c3d84a94$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$eaced0a9c3d84a94$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $eaced0a9c3d84a94$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $eaced0a9c3d84a94$export$83d89fbfd8236492 = "4.20.10";
var $eaced0a9c3d84a94$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $eaced0a9c3d84a94$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $eaced0a9c3d84a94$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $eaced0a9c3d84a94$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $eaced0a9c3d84a94$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $eaced0a9c3d84a94$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $eaced0a9c3d84a94$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $eaced0a9c3d84a94$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($eaced0a9c3d84a94$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $eaced0a9c3d84a94$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $7Q5yr.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $7Q5yr.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $7Q5yr.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $7Q5yr.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $7Q5yr.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $eaced0a9c3d84a94$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $eaced0a9c3d84a94$export$e6bdf135a54e021b,
                    shallowEqual: $eaced0a9c3d84a94$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $7Q5yr.default)({}, state.formState.values)); // clone to avoid writing
            if ($eaced0a9c3d84a94$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $eaced0a9c3d84a94$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $eaced0a9c3d84a94$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $7Q5yr.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $7Q5yr.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $eaced0a9c3d84a94$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $eaced0a9c3d84a94$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $eaced0a9c3d84a94$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$eaced0a9c3d84a94$export$735bebc8ffabf28a]) {
                    var existing = $eaced0a9c3d84a94$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$eaced0a9c3d84a94$export$735bebc8ffabf28a] = error[$eaced0a9c3d84a94$export$735bebc8ffabf28a];
                    merged = $eaced0a9c3d84a94$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$eaced0a9c3d84a94$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$eaced0a9c3d84a94$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $7Q5yr.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $eaced0a9c3d84a94$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $eaced0a9c3d84a94$var$notify(fieldSubscriber, fieldState, lastFieldState, $eaced0a9c3d84a94$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $eaced0a9c3d84a94$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $7Q5yr.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key), $eaced0a9c3d84a94$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key), $eaced0a9c3d84a94$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$eaced0a9c3d84a94$var$hasAnyError(formState.errors) && !(formState.submitErrors && $eaced0a9c3d84a94$var$hasAnyError(formState.submitErrors));
        var nextFormState = $eaced0a9c3d84a94$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $eaced0a9c3d84a94$var$notify(state.subscribers, nextFormState, lastFormState, $eaced0a9c3d84a94$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $7Q5yr.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $7Q5yr.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $7Q5yr.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key), $eaced0a9c3d84a94$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $eaced0a9c3d84a94$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $eaced0a9c3d84a94$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, name) === $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $7Q5yr.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $7Q5yr.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $7Q5yr.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $eaced0a9c3d84a94$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$eaced0a9c3d84a94$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $7Q5yr.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $eaced0a9c3d84a94$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $eaced0a9c3d84a94$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $eaced0a9c3d84a94$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $eaced0a9c3d84a94$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}
module.exports["getIn"] = $eaced0a9c3d84a94$export$c52e5867d5879e24;
module.exports["FORM_ERROR"] = $eaced0a9c3d84a94$export$97cd7fc25dd32915;
module.exports["fieldSubscriptionItems"] = $eaced0a9c3d84a94$export$41e855cb628c1b55;
module.exports["formSubscriptionItems"] = $eaced0a9c3d84a94$export$f1ff97b9d1c7a3c3;
module.exports["version"] = $eaced0a9c3d84a94$export$83d89fbfd8236492;
module.exports["createForm"] = $eaced0a9c3d84a94$export$f681a8129d2e9d28;

});

parcelRegister("jTvbt", function(module, exports) {

var $k9Smn = parcelRequire("k9Smn");

//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $e7bb57e5fe20696d$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $e7bb57e5fe20696d$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($e7bb57e5fe20696d$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $e7bb57e5fe20696d$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $k9Smn.getIn)(errors, input.name);
    });
};
//      
var $e7bb57e5fe20696d$var$noop = function noop() {};
var $e7bb57e5fe20696d$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $e7bb57e5fe20696d$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $e7bb57e5fe20696d$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $e7bb57e5fe20696d$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $e7bb57e5fe20696d$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($e7bb57e5fe20696d$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$e7bb57e5fe20696d$export$2e2bcd8739ae039 = $e7bb57e5fe20696d$var$createDecorator;
module.exports["default"] = $e7bb57e5fe20696d$export$2e2bcd8739ae039;

});

parcelRegister("abN8T", function(module, exports) {

var $92z90 = parcelRequire("92z90");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $76b10d1eacd527b2$var$set(object, path, value) {
    return object == null ? object : $92z90(object, path, value);
}
module.exports = $76b10d1eacd527b2$var$set;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("1To4a", function(module, exports) {


var $1vDIt = parcelRequire("1vDIt");


var $kyRHQ = parcelRequire("kyRHQ");

/**
 * Takes a dot-separated token name and and an optional fallback, and returns the current computed CSS value for the
 * resulting CSS Custom Property.
 * This should be used for when the CSS cascade isn't available, eg. `<canvas>` elements, JS charting libraries, etc.
 *
 * Note: these values change depending on the theme so consider pairing them with `useThemeObserver` in React, or the
 * `ThemeMutationObserver` class elsewhere.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * const theme = useThemeObserver();
 *
 * useEffect(() => {
 *  const lineColor = getTokenValue('color.background.accent.blue.subtle', B400);
 * }, [theme]);
 * ```
 *
 */ function $cd5eb1a9b0824c7e$var$getTokenValue(tokenId, fallback = '') {
    let token = (0, $1vDIt.default)[tokenId];
    let tokenValue = fallback;
    typeof $kyRHQ;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $cd5eb1a9b0824c7e$export$2e2bcd8739ae039 = $cd5eb1a9b0824c7e$var$getTokenValue;
module.exports["default"] = $cd5eb1a9b0824c7e$export$2e2bcd8739ae039;

});

parcelRegister("g7Pc3", function(module, exports) {
$parcel$export(module.exports, "default", () => $e34dc1cd2084e09d$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $lHMuy = parcelRequire("lHMuy");

function $e34dc1cd2084e09d$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: label,
        tag: $e34dc1cd2084e09d$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lHMuy.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: shouldSkip ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lHMuy.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: shouldSkip ? null : bidiCharacter
    });
}
const $e34dc1cd2084e09d$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});

parcelRegister("lHMuy", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6F6hl = parcelRequire("6F6hl");

const $994b46f1e25bb927$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is061xn9 _1rus1917 _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rba1xn9 _1xqc19zu"
};
function $994b46f1e25bb927$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $994b46f1e25bb927$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $gMc0m.default)([
                    $994b46f1e25bb927$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $l998X.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $994b46f1e25bb927$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}
module.exports["Decorator"] = $994b46f1e25bb927$export$a592b67c93d52467;

});

parcelRegister("03WRT", function(module, exports) {
$parcel$export(module.exports, "default", () => $484d2d2be4c10078$export$2e2bcd8739ae039);
const $484d2d2be4c10078$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $484d2d2be4c10078$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($484d2d2be4c10078$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("9QfXi", function(module, exports) {
/* code-block.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fFa3V = parcelRequire("fFa3V");


var $2P8Ax = parcelRequire("2P8Ax");


var $dh538 = parcelRequire("dh538");


var $eFvgJ = parcelRequire("eFvgJ");


var $ei7H8 = parcelRequire("ei7H8");


var $e2ssP = parcelRequire("e2ssP");


var $lQ9rc = parcelRequire("lQ9rc");

const $05e49d7ff5fc6a12$var$getCodeBlockStyles = {
    rootT26Shape: "_2rko1mok",
    root: "_11c81u0j _2rko12b0 _1dqoglyw _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhk187e _syazi7uo _1ozdn7od _7xinn7od _t7aun7od _r28du2gc _tajqu2gc _1ohiu2gc _m802u2gc _i6ntu2gc _1w2xu2gc _1hmyegat _vblregat _vbulegat _196q1xv3 _1vbw1xv3 _1v9c1xv3 _1srnt0uh _18r6myb0 _vyvc1n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _ra6gsb9t _13cdh2mm _1pp0126e _zvy9f705 _qcxof705 _qzn01a66 _j0l11wug _1weckb7n _1na21hna _vsnzgrf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909i8nm _scgayz1z _ipl81e17 _40uk1l04 _i81p1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _pyovu2gc _ccm6u2gc _1ascu2gc _1yuau2gc _xr0w1a66 _4io21a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgc124n _bu7z124n _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3moej _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eiht5x2v _t9zb5x2v _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t36i7uo _137bh55r _1k7di7uo _97li16jw _12nh9lu1 _1g0517qg _i2igqmo9 _326zi7uo _113p1rpy _1n6t16jw _tgu817qg _1k4716jw _g0lxi7uo _ys4e1rpy _7gp8h55r _1yvqqmo9 _1vwwqmo9 _1rjuqmo9 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o6qmo9 _kxov17qg _1np517qg _m2f517qg _1b9t16jw _1tq616jw _1rd216jw _1pbk16jw _k3li16jw _13zt1rpy _2g12fb2s _k86bqmo9 _b5iy1rpy _gti31rpy _1f0g16jw _9d3e17qg _qdia16jw _72uv16jw",
    showLineNumbers: "_1707efft _1i3h1txw _16noidpf _h4fuidpf _pp6yidpf _1g4tidpf _11wmidpf _1bx8idpf",
    dontShowLineNumbers: "_1i3h1ule _16nou2gc _h4fuu2gc _pp6yu2gc _1g4tu2gc _11wmu2gc _1bx8u2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $05e49d7ff5fc6a12$var$CodeBlock = /*#__PURE__*/ (0, $42omo.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, shouldShowLineNumbers: shouldShowLineNumbers, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' }) {
    const scrollableRef = (0, $42omo.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $42omo.useState)(false); // Use children if provided, otherwise fall back to deprecated text prop
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $ei7H8.getLineNumWidth)(numLines) : 0; // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled; // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $42omo.useEffect)(()=>{
        const schedule = (0, $2P8Ax.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $eFvgJ.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $42omo.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $42omo.useMemo)(()=>(0, $e2ssP.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]); // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lQ9rc.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: shouldShowLineNumbersValue,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: shouldShowBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $gMc0m.default)([
            $05e49d7ff5fc6a12$var$getCodeBlockStyles.root,
            (0, $dh538.fg)('platform-dst-shape-theme-default') && $05e49d7ff5fc6a12$var$getCodeBlockStyles.rootT26Shape,
            shouldWrapLongLines ? $05e49d7ff5fc6a12$var$getCodeBlockStyles.shouldWrapLongLines : $05e49d7ff5fc6a12$var$getCodeBlockStyles.dontWrapLongLines,
            shouldShowLineNumbersValue ? $05e49d7ff5fc6a12$var$getCodeBlockStyles.showLineNumbers : $05e49d7ff5fc6a12$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $05e49d7ff5fc6a12$export$2e2bcd8739ae039 = $05e49d7ff5fc6a12$var$CodeBlock;
module.exports["default"] = $05e49d7ff5fc6a12$export$2e2bcd8739ae039;

});

parcelRegister("eFvgJ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $762b8efdd2f451a9$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $762b8efdd2f451a9$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$762b8efdd2f451a9$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $762b8efdd2f451a9$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $762b8efdd2f451a9$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $42omo.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $42omo.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $762b8efdd2f451a9$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$762b8efdd2f451a9$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $762b8efdd2f451a9$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};
module.exports["useHighlightLines"] = $762b8efdd2f451a9$export$84415a200bdf33ed;

});

parcelRegister("ei7H8", function(module, exports) {
const $89bf9ce5f21eb7b0$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};
module.exports["getLineNumWidth"] = $89bf9ce5f21eb7b0$export$cb7aec0206b595d2;

});

parcelRegister("e2ssP", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $cTQmR = parcelRequire("cTQmR");

const $93742eb3c537aef5$export$f38728011c178796 = (0, $2XqLN.default)((language)=>{
    if (!language) return '';
    const match = (0, $cTQmR.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});
module.exports["normalizeLanguage"] = $93742eb3c537aef5$export$f38728011c178796;

});

parcelRegister("lQ9rc", function(module, exports) {
$parcel$export(module.exports, "default", () => $e33420ccf6f6f193$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $fjCXq = parcelRequire("fjCXq");

var $e33420ccf6f6f193$export$2e2bcd8739ae039 = (0, $fjCXq.default);

});

parcelRegister("fjCXq", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5sMDX = parcelRequire("5sMDX");

// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $d73ab72549e3e177$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $l998X.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    AsyncHighlighter.astGenerator = null;
    AsyncHighlighter.highlightInstance = (0, $5sMDX.default);
    AsyncHighlighter.astGeneratorPromise = void 0;
    return AsyncHighlighter;
};

const $d73ab72549e3e177$var$asyncGenerator = $d73ab72549e3e177$var$generator({
    loader: ()=>(parcelRequire("bhcM2")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $d73ab72549e3e177$export$2e2bcd8739ae039 = $d73ab72549e3e177$var$asyncGenerator;
module.exports["default"] = $d73ab72549e3e177$export$2e2bcd8739ae039;

});

parcelRegister("5sMDX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9THMM = parcelRequire("9THMM");


var $39xAV = parcelRequire("39xAV");

/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $65cd19df82755559$var$Highlight = /*#__PURE__*/ (0, $42omo.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $9THMM.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $39xAV.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $65cd19df82755559$export$2e2bcd8739ae039 = $65cd19df82755559$var$Highlight;
module.exports["default"] = $65cd19df82755559$export$2e2bcd8739ae039;

});

parcelRegister("9THMM", function(module, exports) {
$parcel$export(module.exports, "default", () => $91ea43af234a8926$export$2e2bcd8739ae039);

var $5izKv = parcelRequire("5izKv");


var $gOgW3 = parcelRequire("gOgW3");


var $6RvGZ = parcelRequire("6RvGZ");


var $dA1U5 = parcelRequire("dA1U5");

const $91ea43af234a8926$var$newLineRegex = /\n/g;
function $91ea43af234a8926$var$getNewLines(str) {
    return str.match($91ea43af234a8926$var$newLineRegex);
}
function $91ea43af234a8926$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $dA1U5.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $5izKv.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $6RvGZ.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $91ea43af234a8926$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $gOgW3.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $gOgW3.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});

parcelRegister("5izKv", function(module, exports) {

var $gOgW3 = parcelRequire("gOgW3");


var $2hcc9 = parcelRequire("2hcc9");

function $837f3297854d8fe5$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $gOgW3.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $2hcc9.default)(lineNumber));
            return children;
        }
    };
}
var $837f3297854d8fe5$export$2e2bcd8739ae039 = $837f3297854d8fe5$var$createLineGenerator;
module.exports["default"] = $837f3297854d8fe5$export$2e2bcd8739ae039;

});

parcelRegister("gOgW3", function(module, exports) {
$parcel$export(module.exports, "default", () => $09aff78a89d513cf$export$2e2bcd8739ae039);

var $2hcc9 = parcelRequire("2hcc9");

function $09aff78a89d513cf$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, shouldShowLineNumbers: shouldShowLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    // Use new prop if provided, otherwise fall back to deprecated prop
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && shouldShowLineNumbersValue) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $2hcc9.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $2hcc9.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});

parcelRegister("2hcc9", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c2f4afe5a9a95f7$export$2e2bcd8739ae039);
function $3c2f4afe5a9a95f7$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});

parcelRegister("6RvGZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7ca1712ff76e68a$export$2e2bcd8739ae039);

var $gOgW3 = parcelRequire("gOgW3");

function $f7ca1712ff76e68a$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $gOgW3.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $f7ca1712ff76e68a$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("dA1U5", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a86ea0fafcbd9c5$export$2e2bcd8739ae039);
function $1a86ea0fafcbd9c5$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch  {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});

parcelRegister("39xAV", function(module, exports) {
$parcel$export(module.exports, "default", () => $33a0d4443c5f07c9$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dalCl = parcelRequire("dalCl");

function $33a0d4443c5f07c9$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $dalCl.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $l998X.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});

parcelRegister("dalCl", function(module, exports) {
$parcel$export(module.exports, "default", () => $60fb1400ee6b4dd3$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $g7Pc3 = parcelRequire("g7Pc3");


var $03WRT = parcelRequire("03WRT");


var $8L2tn = parcelRequire("8L2tn");

function $60fb1400ee6b4dd3$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $60fb1400ee6b4dd3$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $03WRT.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $g7Pc3.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    isTooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $8L2tn.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $60fb1400ee6b4dd3$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});

parcelRegister("8L2tn", function(module, exports) {
$parcel$export(module.exports, "default", () => $cef41ad946a85b2e$export$2e2bcd8739ae039);

var $dalCl = parcelRequire("dalCl");

function $cef41ad946a85b2e$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $dalCl.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});

parcelRegister("bhcM2", function(module, exports) {

let $835b30d7ea57673f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $835b30d7ea57673f$var$load("7PMju").then(()=>parcelRequire('kw2OH'));

});

parcelRegister("eUDtA", function(module, exports) {
/* Status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5nBzc = parcelRequire("5nBzc");


var $1DWH0 = parcelRequire("1DWH0");


var $hFf4D = parcelRequire("hFf4D");


var $aLypr = parcelRequire("aLypr");

function $fb06ceb36ba8e92b$var$_defineProperty(e, r, t) {
    return (r = $fb06ceb36ba8e92b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fb06ceb36ba8e92b$var$_toPropertyKey(t) {
    var i = $fb06ceb36ba8e92b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fb06ceb36ba8e92b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fb06ceb36ba8e92b$var$colorToLozengeAppearanceMap = {
    neutral: 'default',
    purple: 'new',
    blue: 'inprogress',
    red: 'removed',
    yellow: 'moved',
    green: 'success'
};
const $fb06ceb36ba8e92b$var$DEFAULT_APPEARANCE = 'default';
const $fb06ceb36ba8e92b$var$MAX_WIDTH = 200; /**
                        * This is to account for a bug in android chromium and should be removed
                        * when the editor fixes its focus handling with respect to Status.
                        *
                        * See DSP-7701 for additional context.
                        */ 
const $fb06ceb36ba8e92b$var$inlineBlockStyles = null; // eg. Version/4.0 Chrome/95.0.4638.50
const $fb06ceb36ba8e92b$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $fb06ceb36ba8e92b$var$StatusInternal extends (0, $42omo.PureComponent) {
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = $fb06ceb36ba8e92b$var$colorToLozengeAppearanceMap[color] || $fb06ceb36ba8e92b$var$DEFAULT_APPEARANCE; // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ $42omo.createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $gMc0m.default)([
                $fb06ceb36ba8e92b$var$isAndroidChromium && "_d0dzdf4r _1k0l7vkz _1frxnkob",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            "data-node-type": "status",
            "data-color": color,
            "data-style": style,
            role: role
        }, /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
            appearance: appearance,
            maxWidth: $fb06ceb36ba8e92b$var$MAX_WIDTH,
            isBold: isBold
        }, text));
    }
    constructor(...args){
        super(...args);
        $fb06ceb36ba8e92b$var$_defineProperty(this, "hoverStartTime", 0);
        $fb06ceb36ba8e92b$var$_defineProperty(this, "handleMouseEnter", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $fb06ceb36ba8e92b$var$_defineProperty(this, "handleMouseLeave", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $aLypr.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
    }
}
$fb06ceb36ba8e92b$var$_defineProperty($fb06ceb36ba8e92b$var$StatusInternal, "displayName", 'StatusInternal');
const $fb06ceb36ba8e92b$export$96e9906d6d93a972 = (0, $1DWH0.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $hFf4D.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $hFf4D.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($fb06ceb36ba8e92b$var$StatusInternal);
module.exports["Status"] = $fb06ceb36ba8e92b$export$96e9906d6d93a972;

});

parcelRegister("hFf4D", function(module, exports) {
const $d7337cb21e4187c0$export$d821aa4c8afb384e = 'fabric-elements';
const $d7337cb21e4187c0$var$packageName = "platform-pkg";
const $d7337cb21e4187c0$var$packageVersion = "0.0.0-use.local";
const $d7337cb21e4187c0$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $d7337cb21e4187c0$var$packageName;
        statusPayload.attributes.packageVersion = $d7337cb21e4187c0$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($d7337cb21e4187c0$export$d821aa4c8afb384e);
        return event;
    };
module.exports["createStatusAnalyticsAndFire"] = $d7337cb21e4187c0$export$aa98853957f9f5aa;

});

parcelRegister("aLypr", function(module, exports) {
const $e5e607f963e2ce3b$export$7452d7062a4d0634 = 1000;
module.exports["ANALYTICS_HOVER_DELAY"] = $e5e607f963e2ce3b$export$7452d7062a4d0634;

});

parcelRegister("cQMhV", function(module, exports) {
$parcel$export(module.exports, "PanelInfoIcon", () => (parcelRequire("9h6tL")).PanelInfoIcon);
$parcel$export(module.exports, "PanelWarningIcon", () => (parcelRequire("7aW37")).PanelWarningIcon);
$parcel$export(module.exports, "PanelErrorIcon", () => (parcelRequire("9f7tI")).PanelErrorIcon);
$parcel$export(module.exports, "PanelSuccessIcon", () => (parcelRequire("5Eiz2")).PanelSuccessIcon);
$parcel$export(module.exports, "PanelNoteIcon", () => (parcelRequire("9jJiA")).PanelNoteIcon);
$parcel$export(module.exports, "SteppedRainbowIconDecoration", () => (parcelRequire("i0DZE")).SteppedRainbowIconDecoration);
$parcel$export(module.exports, "DynamicStrokeIconDecoration", () => (parcelRequire("c0czl")).DynamicStrokeIconDecoration);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4wH3g = parcelRequire("4wH3g");


var $9h6tL = parcelRequire("9h6tL");


var $7aW37 = parcelRequire("7aW37");


var $9f7tI = parcelRequire("9f7tI");


var $5Eiz2 = parcelRequire("5Eiz2");


var $9jJiA = parcelRequire("9jJiA");



var $i0DZE = parcelRequire("i0DZE");


var $c0czl = parcelRequire("c0czl");


const $37f04d4596614e71$export$84f497075f5b07be = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "7Wa7q",
    name: "IconTable",
    loader: ()=>(parcelRequire("jbX4H")).then((module)=>module.default),
    loading: ()=>null
});
module.exports["IconTable"] = $37f04d4596614e71$export$84f497075f5b07be;

});

parcelRegister("9h6tL", function(module, exports) {
/* PanelInfoIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $id7ja = parcelRequire("id7ja");


var $dh538 = parcelRequire("dh538");

const $4e1d4745b1e8289e$var$iconStyles = null;
const $4e1d4745b1e8289e$var$PanelInfoGlyph = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg" // Ignored via go/ees005
        ,
        ...props
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
        fill: "currentColor"
    }));
};
const $4e1d4745b1e8289e$export$2187dc2d495c3efc = (props)=>{
    return (0, $dh538.fg)('platform-custom-icon-migration') ? /*#__PURE__*/ $42omo.createElement("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($4e1d4745b1e8289e$var$PanelInfoGlyph, {
        role: "presentation"
    })) : // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ $42omo.createElement((0, $id7ja.default), {
        glyph: $4e1d4745b1e8289e$var$PanelInfoGlyph,
        ...props
    });
};
module.exports["PanelInfoIcon"] = $4e1d4745b1e8289e$export$2187dc2d495c3efc;

});

parcelRegister("7aW37", function(module, exports) {
/* PanelWarningIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $id7ja = parcelRequire("id7ja");


var $dh538 = parcelRequire("dh538");

const $c82a733b017451e7$var$iconStyles = null;
const $c82a733b017451e7$var$PanelWarningGlyph = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg" // Ignored via go/ees005
        ,
        ...props
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
        fill: "currentColor"
    }));
};
const $c82a733b017451e7$export$246c5468186717b7 = (props)=>{
    return (0, $dh538.fg)('platform-custom-icon-migration') ? /*#__PURE__*/ $42omo.createElement("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($c82a733b017451e7$var$PanelWarningGlyph, {
        "aria-label": props.label
    })) : // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ $42omo.createElement((0, $id7ja.default), {
        glyph: $c82a733b017451e7$var$PanelWarningGlyph,
        ...props
    });
};
module.exports["PanelWarningIcon"] = $c82a733b017451e7$export$246c5468186717b7;

});

parcelRegister("9f7tI", function(module, exports) {
/* PanelErrorIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $id7ja = parcelRequire("id7ja");


var $dh538 = parcelRequire("dh538");

const $2c603864430226d2$var$iconStyles = null;
const $2c603864430226d2$var$PanelErrorGlyph = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg" // Ignored via go/ees005
        ,
        ...props
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
        fill: "currentColor"
    }));
};
const $2c603864430226d2$export$76fa6c311f4e2871 = (props)=>{
    return (0, $dh538.fg)('platform-custom-icon-migration') ? /*#__PURE__*/ $42omo.createElement("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($2c603864430226d2$var$PanelErrorGlyph, {
        "aria-label": props.label
    })) : // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ $42omo.createElement((0, $id7ja.default), {
        glyph: $2c603864430226d2$var$PanelErrorGlyph,
        ...props
    });
};
module.exports["PanelErrorIcon"] = $2c603864430226d2$export$76fa6c311f4e2871;

});

parcelRegister("5Eiz2", function(module, exports) {
/* PanelSuccessIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $id7ja = parcelRequire("id7ja");


var $dh538 = parcelRequire("dh538");

const $12304797f5f70131$var$iconStyles = null;
const $12304797f5f70131$var$PanelSuccessGlyph = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg" // Ignored via go/ees005
        ,
        ...props
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
        fill: "currentColor"
    }));
};
const $12304797f5f70131$export$a5a5162e21242c3c = (props)=>{
    return (0, $dh538.fg)('platform-custom-icon-migration') ? /*#__PURE__*/ $42omo.createElement("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($12304797f5f70131$var$PanelSuccessGlyph, {
        "aria-label": props.label
    })) : // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ $42omo.createElement((0, $id7ja.default), {
        glyph: $12304797f5f70131$var$PanelSuccessGlyph,
        ...props
    });
};
module.exports["PanelSuccessIcon"] = $12304797f5f70131$export$a5a5162e21242c3c;

});

parcelRegister("9jJiA", function(module, exports) {
/* PanelNoteIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $id7ja = parcelRequire("id7ja");


var $dh538 = parcelRequire("dh538");

const $0eeb07e0bc008878$var$iconStyles = null;
const $0eeb07e0bc008878$var$PanelNoteGlyph = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg" // Ignored via go/ees005
        ,
        ...props
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
        fill: "currentColor"
    }));
};
const $0eeb07e0bc008878$export$d4f894f0c3f0db6 = (props)=>{
    return (0, $dh538.fg)('platform-custom-icon-migration') ? /*#__PURE__*/ $42omo.createElement("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($0eeb07e0bc008878$var$PanelNoteGlyph, {
        "aria-label": props.label
    })) : // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ $42omo.createElement((0, $id7ja.default), {
        glyph: $0eeb07e0bc008878$var$PanelNoteGlyph,
        ...props
    });
};
module.exports["PanelNoteIcon"] = $0eeb07e0bc008878$export$d4f894f0c3f0db6;

});

parcelRegister("i0DZE", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

function $f085c45c6ac6dbc6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f085c45c6ac6dbc6$var$createSteppedRainbow = (colors)=>{
    return `
    linear-gradient(
      to right,
      ${colors.map((color, i)=>{
        const inc = 100 / colors.length;
        const pos = i + 1;
        if (i === 0) return `${color} ${pos * inc}%,`;
        if (i === colors.length - 1) return `${color} ${(pos - 1) * inc}%`;
        return `
            ${color} ${(pos - 1) * inc}%,
            ${color} ${pos * inc}%,
          `;
    }).join('\n')}
    )`;
};
const $f085c45c6ac6dbc6$export$8025971e8c08a5b8 = $f085c45c6ac6dbc6$var$createSteppedRainbow([
    "var(--ds-background-accent-purple-bolder, #964AC0)",
    "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    "var(--ds-background-accent-orange-subtle, #FCA700)",
    "var(--ds-background-accent-red-bolder, #C9372C)"
]);
const $f085c45c6ac6dbc6$export$9427247cfe66d53e = $f085c45c6ac6dbc6$var$createSteppedRainbow([
    "var(--ds-background-accent-gray-subtle, #8C8F97)",
    "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)"
]);
const $f085c45c6ac6dbc6$var$barStyles = {
    name: "ox20r",
    styles: "position:absolute;left:0;right:0;top:var(--ds-space-200, 16px);margin:auto;width:12px;height:3px;border-radius:var(--ds-radius-small, 3px)"
};
const $f085c45c6ac6dbc6$var$textColorIconWrapper = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $f085c45c6ac6dbc6$var$getBackground = (selectedColor, disabled)=>{
    if (selectedColor) return selectedColor;
    if (disabled) return $f085c45c6ac6dbc6$export$9427247cfe66d53e;
    return $f085c45c6ac6dbc6$export$8025971e8c08a5b8;
};
const $f085c45c6ac6dbc6$export$9141b78f26ee217c = ({ selectedColor: selectedColor, disabled: disabled, icon: icon })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $f085c45c6ac6dbc6$var$textColorIconWrapper
    }, icon, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "toolbar-icon-stepped-rainbow",
        style: {
            background: $f085c45c6ac6dbc6$var$getBackground(selectedColor, disabled)
        },
        css: $f085c45c6ac6dbc6$var$barStyles
    }));
};
module.exports["SteppedRainbowIconDecoration"] = $f085c45c6ac6dbc6$export$9141b78f26ee217c;

});

parcelRegister("c0czl", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

function $3ae2a3e708a69581$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3ae2a3e708a69581$var$barStyles = {
    name: "k9tay8",
    styles: "position:absolute;left:0;right:0;top:18px;margin:auto;width:var(--ds-space-200, 16px);height:3px"
};
const $3ae2a3e708a69581$var$textColorIconWrapper = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $3ae2a3e708a69581$var$getBackground = (selectedColor, disabled)=>{
    if (selectedColor) return selectedColor;
    return disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon, #292A2E)";
};
const $3ae2a3e708a69581$export$76b0278e018f8601 = ({ selectedColor: selectedColor, disabled: disabled, icon: icon })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $3ae2a3e708a69581$var$textColorIconWrapper
    }, icon, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "toolbar-icon-dynamic-stroke",
        style: {
            background: $3ae2a3e708a69581$var$getBackground(selectedColor, disabled)
        },
        css: $3ae2a3e708a69581$var$barStyles
    }));
};
module.exports["DynamicStrokeIconDecoration"] = $3ae2a3e708a69581$export$76b0278e018f8601;

});

parcelRegister("jbX4H", function(module, exports) {

let $df8cde70d2882e2f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df8cde70d2882e2f$var$load("7Vmxp").then(()=>parcelRequire('aJWwp'));

});

parcelRegister("lgqac", function(module, exports) {
const $a2012143faf474ac$export$85183a312807388d = 'media';
const $a2012143faf474ac$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $a2012143faf474ac$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $a2012143faf474ac$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $a2012143faf474ac$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $a2012143faf474ac$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $a2012143faf474ac$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($a2012143faf474ac$export$85183a312807388d);
};
module.exports["ANALYTICS_CHANNEL"] = $a2012143faf474ac$export$85183a312807388d;
module.exports["context"] = $a2012143faf474ac$export$a078c61943f9dbbe;
module.exports["TrackQuickActionType"] = $a2012143faf474ac$export$72af824fa910c33e;
module.exports["TrackQuickActionFailureReason"] = $a2012143faf474ac$export$c89e475f7f7174c2;
module.exports["SmartLinkEvents"] = $a2012143faf474ac$export$b91e0203b928470c;

});

parcelRegister("kKODE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::676f76a2e45920437adc8c35a9af8b37>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1PKWZ = parcelRequire("1PKWZ");


var $cGziR = parcelRequire("cGziR");

const $5b5d947ab1fa491a$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEvent = (0, $42omo.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $cGziR.default)(...params));
        event.fire((0, $1PKWZ.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $5b5d947ab1fa491a$export$5bf35293e545f20c;

});

parcelRegister("1PKWZ", function(module, exports) {
const $6678419bc4dceb3a$export$3f072f06b90c3985 = 'media';
module.exports["EVENT_CHANNEL"] = $6678419bc4dceb3a$export$3f072f06b90c3985;

});

parcelRegister("cGziR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::f914fb83fac56e7154ef460866628f7d>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $4575fec4bf8df71a$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $4575fec4bf8df71a$export$2e2bcd8739ae039 = $4575fec4bf8df71a$var$createEventPayload;
module.exports["default"] = $4575fec4bf8df71a$export$2e2bcd8739ae039;

});

parcelRegister("bIll3", function(module, exports) {

var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $fe01df8db47f84d1$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Experience,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
};
const $fe01df8db47f84d1$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
};
const $fe01df8db47f84d1$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Experience,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
};
const $fe01df8db47f84d1$var$ufoExperiences = {
    'smart-link-rendered': new (0, $9801n.ConcurrentExperience)('smart-link-rendered', $fe01df8db47f84d1$var$renderExperience),
    'smart-link-authenticated': new (0, $9801n.ConcurrentExperience)('smart-link-authenticated', $fe01df8db47f84d1$var$inlineExperience),
    'smart-link-action-invocation': new (0, $9801n.ConcurrentExperience)('smart-link-action-invocation', $fe01df8db47f84d1$var$inlineExperience),
    'smart-link-ai-summary': new (0, $9801n.ConcurrentExperience)('smart-link-ai-summary', $fe01df8db47f84d1$var$aiExperience)
};
const $fe01df8db47f84d1$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $fe01df8db47f84d1$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $fe01df8db47f84d1$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $fe01df8db47f84d1$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};
module.exports["startUfoExperience"] = $fe01df8db47f84d1$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $fe01df8db47f84d1$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $fe01df8db47f84d1$export$8dda83bafca11b77;
module.exports["addMetadataToExperience"] = $fe01df8db47f84d1$export$4084c0df4a03a6af;

});

parcelRegister("5TXU5", function(module, exports) {
const $d747218f543c7aaa$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $d747218f543c7aaa$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $d747218f543c7aaa$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $d747218f543c7aaa$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $d747218f543c7aaa$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $d747218f543c7aaa$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $d747218f543c7aaa$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $d747218f543c7aaa$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $d747218f543c7aaa$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $d747218f543c7aaa$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $d747218f543c7aaa$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $d747218f543c7aaa$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $d747218f543c7aaa$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $d747218f543c7aaa$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    ElementName["HostName"] = "HostName";
    return ElementName;
}({});
var $d747218f543c7aaa$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $d747218f543c7aaa$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $d747218f543c7aaa$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $d747218f543c7aaa$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $d747218f543c7aaa$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $d747218f543c7aaa$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});
module.exports["CONTENT_URL_SECURITY_AND_PERMISSIONS"] = $d747218f543c7aaa$export$5c881701926acbef;
module.exports["CONTENT_URL_3P_ACCOUNT_AUTH"] = $d747218f543c7aaa$export$93d67ab022d9f8d2;
module.exports["CONTENT_URL_AI"] = $d747218f543c7aaa$export$70d24f0465ae60f8;
module.exports["CONTENT_URL_AI_TROUBLESHOOTING"] = $d747218f543c7aaa$export$a3ed5c4e9d9599b7;
module.exports["CONTENT_URL_ACCEPTABLE_USE_POLICY"] = $d747218f543c7aaa$export$73b198e73554a323;
module.exports["SmartLinkAlignment"] = $d747218f543c7aaa$export$8910bf86027fe6be;
module.exports["SmartLinkDirection"] = $d747218f543c7aaa$export$60831686b0574c86;
module.exports["SmartLinkPosition"] = $d747218f543c7aaa$export$d58e6377644d1dcf;
module.exports["SmartLinkSize"] = $d747218f543c7aaa$export$51f13ced115cbdae;
module.exports["SmartLinkStatus"] = $d747218f543c7aaa$export$61cff06be26816f;
module.exports["SmartLinkTheme"] = $d747218f543c7aaa$export$aed0f1e801ad691f;
module.exports["SmartLinkInternalTheme"] = $d747218f543c7aaa$export$9aafec380d7005da;
module.exports["SmartLinkWidth"] = $d747218f543c7aaa$export$19c60054ee783de6;
module.exports["ElementName"] = $d747218f543c7aaa$export$d65b168331104a46;
module.exports["ActionName"] = $d747218f543c7aaa$export$9c95d6e1614bad84;
module.exports["InternalActionName"] = $d747218f543c7aaa$export$4871a84b35cf8eb9;
module.exports["IconType"] = $d747218f543c7aaa$export$13ff1290a9e22e77;
module.exports["MediaType"] = $d747218f543c7aaa$export$483c11740a902fcd;
module.exports["MediaPlacement"] = $d747218f543c7aaa$export$f9f4737e25ab90fa;
module.exports["CardDisplay"] = $d747218f543c7aaa$export$6ca4ef8b3dc2c804;

});

parcelRegister("5mB97", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3e7bd247c2a15a57$var$_react = $3e7bd247c2a15a57$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $3e7bd247c2a15a57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e7bd247c2a15a57$var$Document16Icon = (props)=>/*#__PURE__*/ $3e7bd247c2a15a57$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$3e7bd247c2a15a57$var$Document16Icon.displayName = 'Document16Icon';
var $3e7bd247c2a15a57$var$_default = module.exports.default = $3e7bd247c2a15a57$var$Document16Icon;

});

parcelRegister("i9cac", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36280b20a14c4f7$var$_react = $d36280b20a14c4f7$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d36280b20a14c4f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36280b20a14c4f7$var$Document24Icon = (props)=>/*#__PURE__*/ $d36280b20a14c4f7$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36280b20a14c4f7$var$Document24Icon.displayName = 'Document24Icon';
var $d36280b20a14c4f7$var$_default = module.exports.default = $d36280b20a14c4f7$var$Document24Icon;

});

parcelRegister("6iY4P", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e9f22edb5bbb2a5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $kXb3C = parcelRequire("kXb3C");

function $0e9f22edb5bbb2a5$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("kXb3C", function(module, exports) {
$parcel$export(module.exports, "default", () => $5412502140f64e3a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $5412502140f64e3a$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});

parcelRegister("j6GAe", function(module, exports) {
$parcel$export(module.exports, "default", () => $90028f2cad692a01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

function $90028f2cad692a01$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fP78j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce53c8d1c9f5417$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

function $fce53c8d1c9f5417$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});

parcelRegister("7t8Pn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $570216d1bcbf60e3$var$_react = $570216d1bcbf60e3$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $570216d1bcbf60e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $570216d1bcbf60e3$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $570216d1bcbf60e3$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$570216d1bcbf60e3$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $570216d1bcbf60e3$var$_default = module.exports.default = $570216d1bcbf60e3$var$SourceCode24Icon;

});

parcelRegister("9JsQ8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8DZd1 = parcelRequire("8DZd1");


var $djgQ6 = parcelRequire("djgQ6");


var $chO1Z = parcelRequire("chO1Z");


var $7CgcZ = parcelRequire("7CgcZ");

const $b894277b0121d160$var$FileIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), 'grayBold', (0, $7CgcZ.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($8DZd1))), (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))));
$b894277b0121d160$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $b894277b0121d160$export$2e2bcd8739ae039 = $b894277b0121d160$var$FileIconWithColor;
module.exports["default"] = $b894277b0121d160$export$2e2bcd8739ae039;

});

parcelRegister("8DZd1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $64b1721c286de662$var$_react = $64b1721c286de662$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $64b1721c286de662$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64b1721c286de662$var$Generic16Icon = (props)=>/*#__PURE__*/ $64b1721c286de662$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$64b1721c286de662$var$Generic16Icon.displayName = 'Generic16Icon';
var $64b1721c286de662$var$_default = module.exports.default = $64b1721c286de662$var$Generic16Icon;

});

parcelRegister("djgQ6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9b0a1cae716cd1ca$var$_react = $9b0a1cae716cd1ca$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $9b0a1cae716cd1ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9b0a1cae716cd1ca$var$Generic24Icon = (props)=>/*#__PURE__*/ $9b0a1cae716cd1ca$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9b0a1cae716cd1ca$var$Generic24Icon.displayName = 'Generic24Icon';
var $9b0a1cae716cd1ca$var$_default = module.exports.default = $9b0a1cae716cd1ca$var$Generic24Icon;

});

parcelRegister("41GKb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2ee869754fb919da$var$_react = $2ee869754fb919da$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $2ee869754fb919da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ee869754fb919da$var$Image16Icon = (props)=>/*#__PURE__*/ $2ee869754fb919da$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4.75 11.75-.543-.543a1 1 0 0 0-1.414 0L3 13h10v-2.25l-1.795-1.974a1 1 0 0 0-1.447-.034zM4.667 6.333a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"/></svg>`
    }, props, {
        size: 'small'
    }));
$2ee869754fb919da$var$Image16Icon.displayName = 'Image16Icon';
var $2ee869754fb919da$var$_default = module.exports.default = $2ee869754fb919da$var$Image16Icon;

});

parcelRegister("1w5AW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $jKhX7 = parcelRequire("jKhX7");


var $cQbj1 = parcelRequire("cQbj1");


var $1zLiv = parcelRequire("1zLiv");


var $7CgcZ = parcelRequire("7CgcZ");

const $236bd638115a684a$var$ChartBarIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($1zLiv))), 'purpleBold', (0, $7CgcZ.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($jKhX7))), (0, (/*@__PURE__*/$parcel$interopDefault($cQbj1)))));
$236bd638115a684a$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $236bd638115a684a$export$2e2bcd8739ae039 = $236bd638115a684a$var$ChartBarIconWithColor;
module.exports["default"] = $236bd638115a684a$export$2e2bcd8739ae039;

});

parcelRegister("jKhX7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6003d2deb1d9822$var$_react = $e6003d2deb1d9822$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $e6003d2deb1d9822$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6003d2deb1d9822$var$Presentation16Icon = (props)=>/*#__PURE__*/ $e6003d2deb1d9822$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m10 3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1M8 6a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1M4 9a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'small'
    }));
$e6003d2deb1d9822$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $e6003d2deb1d9822$var$_default = module.exports.default = $e6003d2deb1d9822$var$Presentation16Icon;

});

parcelRegister("cQbj1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $95931c783b128167$var$_react = $95931c783b128167$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $95931c783b128167$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $95931c783b128167$var$Presentation24Icon = (props)=>/*#__PURE__*/ $95931c783b128167$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$95931c783b128167$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $95931c783b128167$var$_default = module.exports.default = $95931c783b128167$var$Presentation24Icon;

});

parcelRegister("h45kr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $lxsNd = parcelRequire("lxsNd");


var $iFCP2 = parcelRequire("iFCP2");


var $cUQMr = parcelRequire("cUQMr");


var $7CgcZ = parcelRequire("7CgcZ");

const $55cc43e42726cbf8$var$ListBulletedIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), 'greenBold', (0, $7CgcZ.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($lxsNd))), (0, (/*@__PURE__*/$parcel$interopDefault($iFCP2)))));
$55cc43e42726cbf8$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $55cc43e42726cbf8$export$2e2bcd8739ae039 = $55cc43e42726cbf8$var$ListBulletedIconWithColor;
module.exports["default"] = $55cc43e42726cbf8$export$2e2bcd8739ae039;

});

parcelRegister("lxsNd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fae303b458ee3eba$var$_react = $fae303b458ee3eba$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $fae303b458ee3eba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fae303b458ee3eba$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $fae303b458ee3eba$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5-8a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$fae303b458ee3eba$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $fae303b458ee3eba$var$_default = module.exports.default = $fae303b458ee3eba$var$Spreadsheet16Icon;

});

parcelRegister("iFCP2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d97a2b9af590931e$var$_react = $d97a2b9af590931e$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d97a2b9af590931e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d97a2b9af590931e$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d97a2b9af590931e$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d97a2b9af590931e$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d97a2b9af590931e$var$_default = module.exports.default = $d97a2b9af590931e$var$Spreadsheet24Icon;

});

parcelRegister("2ixko", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1ac71d7218c06efe$var$_react = $1ac71d7218c06efe$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $1ac71d7218c06efe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ac71d7218c06efe$var$Executable16Icon = (props)=>/*#__PURE__*/ $1ac71d7218c06efe$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zm3 6.72v3.572c0 .394.32.714.714.714h8.572c.394 0 .714-.32.714-.714V8.714zM4.345 3a.714.714 0 0 0-.709.626L3 8.714h10l-.636-5.088A.714.714 0 0 0 11.655 3zm.798 7.143h5.714a.714.714 0 0 1 0 1.428H5.143a.714.714 0 1 1 0-1.428"/></svg>`
    }, props, {
        size: 'small'
    }));
$1ac71d7218c06efe$var$Executable16Icon.displayName = 'Executable16Icon';
var $1ac71d7218c06efe$var$_default = module.exports.default = $1ac71d7218c06efe$var$Executable16Icon;

});

parcelRegister("4dLYc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $312d962237f997a8$var$_react = $312d962237f997a8$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $312d962237f997a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $312d962237f997a8$var$Executable24Icon = (props)=>/*#__PURE__*/ $312d962237f997a8$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$312d962237f997a8$var$Executable24Icon.displayName = 'Executable24Icon';
var $312d962237f997a8$var$_default = module.exports.default = $312d962237f997a8$var$Executable24Icon;

});

parcelRegister("d5BUD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $987926a28539ecdc$var$_react = $987926a28539ecdc$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $987926a28539ecdc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $987926a28539ecdc$var$Gif16Icon = (props)=>/*#__PURE__*/ $987926a28539ecdc$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m7.042 11.09H7.755a.16.16 0 0 1-.162-.161v-5.34c0-.09.072-.162.162-.162h1.287c.09 0 .163.072.163.163v5.339c0 .09-.073.162-.163.162m2.528 0h-1.288a.16.16 0 0 1-.162-.162v-5.34c0-.09.072-.162.162-.162h3.556c.089 0 .162.072.162.163v1.048c0 .09-.073.162-.162.162h-2.106v.947h1.898c.09 0 .162.073.162.162v1.013c0 .09-.072.162-.162.162h-1.898v1.845c0 .09-.074.162-.162.162m-7.045.097C2.944 11.188 2 10.207 2 8.562v-.641c0-1.597.968-2.588 2.528-2.588 1.544 0 2.291.978 2.349 1.948a.16.16 0 0 1-.162.172H5.463a.16.16 0 0 1-.16-.133c-.066-.367-.368-.595-.786-.595-.74 0-.894.657-.894 1.207v.626c0 .822.312 1.238.929 1.238.59 0 .8-.359.8-.667v-.06h-.77a.16.16 0 0 1-.161-.163v-.915c0-.09.072-.162.162-.162h2.144c.09 0 .162.072.162.162v1.036c0 .997-.62 2.161-2.364 2.161"/></svg>`
    }, props, {
        size: 'small'
    }));
$987926a28539ecdc$var$Gif16Icon.displayName = 'Gif16Icon';
var $987926a28539ecdc$var$_default = module.exports.default = $987926a28539ecdc$var$Gif16Icon;

});

parcelRegister("b4DX7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $80ff0f2ee8339e7f$var$_react = $80ff0f2ee8339e7f$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $80ff0f2ee8339e7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $80ff0f2ee8339e7f$var$Gif24Icon = (props)=>/*#__PURE__*/ $80ff0f2ee8339e7f$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$80ff0f2ee8339e7f$var$Gif24Icon.displayName = 'Gif24Icon';
var $80ff0f2ee8339e7f$var$_default = module.exports.default = $80ff0f2ee8339e7f$var$Gif24Icon;

});

parcelRegister("4rkAw", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $33b9a76c1d425a4b$var$_react = $33b9a76c1d425a4b$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $33b9a76c1d425a4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $33b9a76c1d425a4b$var$GoogleDoc16Icon = (props)=>/*#__PURE__*/ $33b9a76c1d425a4b$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$33b9a76c1d425a4b$var$GoogleDoc16Icon.displayName = 'GoogleDoc16Icon';
var $33b9a76c1d425a4b$var$_default = module.exports.default = $33b9a76c1d425a4b$var$GoogleDoc16Icon;

});

parcelRegister("5W6v1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $45276929af089f1e$var$_react = $45276929af089f1e$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $45276929af089f1e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $45276929af089f1e$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $45276929af089f1e$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$45276929af089f1e$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $45276929af089f1e$var$_default = module.exports.default = $45276929af089f1e$var$GoogleDoc24Icon;

});

parcelRegister("jDMpf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e4c73548be2d77b2$var$_react = $e4c73548be2d77b2$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $e4c73548be2d77b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e4c73548be2d77b2$var$GoogleForm16Icon = (props)=>/*#__PURE__*/ $e4c73548be2d77b2$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$e4c73548be2d77b2$var$GoogleForm16Icon.displayName = 'GoogleForm16Icon';
var $e4c73548be2d77b2$var$_default = module.exports.default = $e4c73548be2d77b2$var$GoogleForm16Icon;

});

parcelRegister("av4P2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7a508a3974c868b6$var$_react = $7a508a3974c868b6$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $7a508a3974c868b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a508a3974c868b6$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $7a508a3974c868b6$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$7a508a3974c868b6$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $7a508a3974c868b6$var$_default = module.exports.default = $7a508a3974c868b6$var$GoogleForm24Icon;

});

parcelRegister("l59oX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f5915b8e34e2cce4$var$_react = $f5915b8e34e2cce4$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $f5915b8e34e2cce4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f5915b8e34e2cce4$var$GoogleSheet16Icon = (props)=>/*#__PURE__*/ $f5915b8e34e2cce4$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$f5915b8e34e2cce4$var$GoogleSheet16Icon.displayName = 'GoogleSheet16Icon';
var $f5915b8e34e2cce4$var$_default = module.exports.default = $f5915b8e34e2cce4$var$GoogleSheet16Icon;

});

parcelRegister("giYeH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $bded0d6c49d90549$var$_react = $bded0d6c49d90549$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $bded0d6c49d90549$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bded0d6c49d90549$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $bded0d6c49d90549$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$bded0d6c49d90549$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $bded0d6c49d90549$var$_default = module.exports.default = $bded0d6c49d90549$var$GoogleSheet24Icon;

});

parcelRegister("jOGxt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6d3af3126d12bf0$var$_react = $e6d3af3126d12bf0$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $e6d3af3126d12bf0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6d3af3126d12bf0$var$GoogleSlide16Icon = (props)=>/*#__PURE__*/ $e6d3af3126d12bf0$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$e6d3af3126d12bf0$var$GoogleSlide16Icon.displayName = 'GoogleSlide16Icon';
var $e6d3af3126d12bf0$var$_default = module.exports.default = $e6d3af3126d12bf0$var$GoogleSlide16Icon;

});

parcelRegister("eWLPt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ae1b9556e1933b44$var$_react = $ae1b9556e1933b44$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $ae1b9556e1933b44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ae1b9556e1933b44$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $ae1b9556e1933b44$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ae1b9556e1933b44$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $ae1b9556e1933b44$var$_default = module.exports.default = $ae1b9556e1933b44$var$GoogleSlide24Icon;

});

parcelRegister("d8Kpd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $991004eb95b782af$var$_react = $991004eb95b782af$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $991004eb95b782af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $991004eb95b782af$var$ExcelSpreadsheet16Icon = (props)=>/*#__PURE__*/ $991004eb95b782af$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM4.858 10.2l1.35-2.13-1.341-2.098h1.04l.881 1.48h.053l.89-1.48h.991L7.33 8.085 8.702 10.2H7.694l-.908-1.433h-.053l-.92 1.433z"/></svg>`
    }, props, {
        size: 'small'
    }));
$991004eb95b782af$var$ExcelSpreadsheet16Icon.displayName = 'ExcelSpreadsheet16Icon';
var $991004eb95b782af$var$_default = module.exports.default = $991004eb95b782af$var$ExcelSpreadsheet16Icon;

});

parcelRegister("gH8Rx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c277896da6578a99$var$_react = $c277896da6578a99$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $c277896da6578a99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c277896da6578a99$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $c277896da6578a99$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c277896da6578a99$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $c277896da6578a99$var$_default = module.exports.default = $c277896da6578a99$var$ExcelSpreadsheet24Icon;

});

parcelRegister("hY1Uy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d14985c3ed2ec0ae$var$_react = $d14985c3ed2ec0ae$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d14985c3ed2ec0ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d14985c3ed2ec0ae$var$PowerpointPresentation16Icon = (props)=>/*#__PURE__*/ $d14985c3ed2ec0ae$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM5.313 6.072h1.763c.87 0 1.465.583 1.465 1.462 0 .87-.618 1.454-1.509 1.454h-.835V10.3h-.884zm.884.727v1.47h.642c.507 0 .803-.257.803-.732 0-.48-.29-.738-.8-.738z"/></svg>`
    }, props, {
        size: 'small'
    }));
$d14985c3ed2ec0ae$var$PowerpointPresentation16Icon.displayName = 'PowerpointPresentation16Icon';
var $d14985c3ed2ec0ae$var$_default = module.exports.default = $d14985c3ed2ec0ae$var$PowerpointPresentation16Icon;

});

parcelRegister("dfQbH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9a652876e1a65311$var$_react = $9a652876e1a65311$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $9a652876e1a65311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9a652876e1a65311$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $9a652876e1a65311$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9a652876e1a65311$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $9a652876e1a65311$var$_default = module.exports.default = $9a652876e1a65311$var$PowerpointPresentation24Icon;

});

parcelRegister("90Icb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $68f6656ee3eec0b2$var$_react = $68f6656ee3eec0b2$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $68f6656ee3eec0b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $68f6656ee3eec0b2$var$WordDocument16Icon = (props)=>/*#__PURE__*/ $68f6656ee3eec0b2$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM6.803 7.602 6.012 10.4h-.835l-1.12-4.228h.92l.66 2.98h.047l.77-2.98h.747l.786 2.98h.046l.654-2.98H9.6L8.479 10.4h-.83l-.8-2.798z"/></svg>`
    }, props, {
        size: 'small'
    }));
$68f6656ee3eec0b2$var$WordDocument16Icon.displayName = 'WordDocument16Icon';
var $68f6656ee3eec0b2$var$_default = module.exports.default = $68f6656ee3eec0b2$var$WordDocument16Icon;

});

parcelRegister("lkBga", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f8785e41f79a32cd$var$_react = $f8785e41f79a32cd$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $f8785e41f79a32cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8785e41f79a32cd$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $f8785e41f79a32cd$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f8785e41f79a32cd$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $f8785e41f79a32cd$var$_default = module.exports.default = $f8785e41f79a32cd$var$WordDocument24Icon;

});

parcelRegister("11LZV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0bfb1dce28d59ddd$var$_react = $0bfb1dce28d59ddd$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $0bfb1dce28d59ddd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0bfb1dce28d59ddd$var$PdfDocument16Icon = (props)=>/*#__PURE__*/ $0bfb1dce28d59ddd$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.23 8.113h.323c.744 0 .802-.214.802-.517 0-.346-.179-.514-.545-.514h-.58zm4.194 1.456h.443c.494 0 1-.147 1-1.237 0-1.1-.534-1.24-1-1.24h-.443zM2.975 10.66h-.72A.256.256 0 0 1 2 10.404V6.255c0-.14.114-.255.255-.255h1.663c.989 0 1.68.656 1.68 1.596 0 .953-.677 1.593-1.683 1.593H3.23v1.215a.256.256 0 0 1-.256.256m4.968 0H6.448a.256.256 0 0 1-.255-.256V6.255c0-.14.114-.255.255-.255h1.495c1.404 0 2.178.825 2.178 2.323 0 1.507-.774 2.337-2.178 2.337m3.85 0h-.72a.256.256 0 0 1-.256-.256V6.255c0-.14.114-.255.255-.255h2.673c.14 0 .255.115.255.255v.587a.256.256 0 0 1-.255.255h-1.697v.76h1.528c.141 0 .255.115.255.256v.577c0 .14-.114.256-.255.256h-1.528v1.458a.256.256 0 0 1-.255.256"/></svg>`
    }, props, {
        size: 'small'
    }));
$0bfb1dce28d59ddd$var$PdfDocument16Icon.displayName = 'PdfDocument16Icon';
var $0bfb1dce28d59ddd$var$_default = module.exports.default = $0bfb1dce28d59ddd$var$PdfDocument16Icon;

});

parcelRegister("lzyQK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fb47e6517d9f8e39$var$_react = $fb47e6517d9f8e39$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $fb47e6517d9f8e39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fb47e6517d9f8e39$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $fb47e6517d9f8e39$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$fb47e6517d9f8e39$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $fb47e6517d9f8e39$var$_default = module.exports.default = $fb47e6517d9f8e39$var$PdfDocument24Icon;

});

parcelRegister("9W0IA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $73ba16739a647a26$var$_react = $73ba16739a647a26$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $73ba16739a647a26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $73ba16739a647a26$var$Sketch16Icon = (props)=>/*#__PURE__*/ $73ba16739a647a26$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6.02 13.333a.67.67 0 0 0 .502-.228L13.17 7.77a.67.67 0 0 0 .063-.79l-1.657-2.666A.67.67 0 0 0 11.01 4H5.116a.67.67 0 0 0-.554.296L2.779 6.963a.67.67 0 0 0 .054.81l4.686 5.334a.67.67 0 0 0 .5.226"/></svg>`
    }, props, {
        size: 'small'
    }));
$73ba16739a647a26$var$Sketch16Icon.displayName = 'Sketch16Icon';
var $73ba16739a647a26$var$_default = module.exports.default = $73ba16739a647a26$var$Sketch16Icon;

});

parcelRegister("9AnKp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6fa9e5979f68da4f$var$_react = $6fa9e5979f68da4f$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $6fa9e5979f68da4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6fa9e5979f68da4f$var$Sketch24Icon = (props)=>/*#__PURE__*/ $6fa9e5979f68da4f$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6fa9e5979f68da4f$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $6fa9e5979f68da4f$var$_default = module.exports.default = $6fa9e5979f68da4f$var$Sketch24Icon;

});

parcelRegister("66dpz", function(module, exports) {
$parcel$export(module.exports, "default", () => $893c7e3925139b9a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

function $893c7e3925139b9a$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});

parcelRegister("fAGae", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f3b40ffeda05888$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

function $0f3b40ffeda05888$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
}

});

parcelRegister("5MkWK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $c6GJD = parcelRequire("c6GJD");


var $1xKpK = parcelRequire("1xKpK");


var $eIleF = parcelRequire("eIleF");


var $6q0AE = parcelRequire("6q0AE");


var $dh538 = parcelRequire("dh538");


var $lz9QA = parcelRequire("lz9QA");


var $lgqac = parcelRequire("lgqac");

const $9dd53b67e285af98$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $1xKpK.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $9dd53b67e285af98$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const isHyperlinkConnectExperimentEnabled = (0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false);
    const resolvedAttributes = isHyperlinkConnectExperimentEnabled ? $9dd53b67e285af98$var$getExtendedResolvedAttributes({
        url: url,
        displayCategory: display === 'url' ? 'link' : 'smartLink'
    }, response, status, error) : $9dd53b67e285af98$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $lgqac.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $9dd53b67e285af98$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const state = store ? (0, $6q0AE.getUrl)(store, url) : undefined;
    return (0, $42omo.useMemo)(()=>{
        return $9dd53b67e285af98$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $9dd53b67e285af98$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $lz9QA.useSmartCardState)(url);
    const data = $9dd53b67e285af98$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $dh538.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: data
    }, children);
};
module.exports["useSmartLinkAnalyticsContext"] = $9dd53b67e285af98$export$ac28ada90c4970b7;
module.exports["SmartLinkAnalyticsContext"] = $9dd53b67e285af98$export$eaff10f7ec59c455;

});

parcelRegister("1xKpK", function(module, exports) {

var $btw9C = parcelRequire("btw9C");


var $8Wacp = parcelRequire("8Wacp");


var $dh538 = parcelRequire("dh538");

const $6804f58a391a686f$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $btw9C.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $8Wacp.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $dh538.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};
module.exports["getResolvedAttributes"] = $6804f58a391a686f$export$7243431f5325a7b;

});

parcelRegister("8Wacp", function(module, exports) {
const $637663634becf001$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};
module.exports["getDisplayCategory"] = $637663634becf001$export$28ddbae335bd80b5;

});

parcelRegister("eIleF", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $38c931550e91452f$export$156b523e63b4f63a = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
function $38c931550e91452f$export$e1d190b530cf0ee9() {
    const context = (0, $42omo.useContext)($38c931550e91452f$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $38c931550e91452f$export$10e9cca30e50f657 = ()=>$38c931550e91452f$var$useContextMemoized($38c931550e91452f$export$156b523e63b4f63a);
const $38c931550e91452f$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $38c931550e91452f$export$10e9cca30e50f657();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
function $38c931550e91452f$var$useContextMemoized(reactContext) {
    const value = (0, $42omo.useContext)(reactContext);
    const context = (0, $42omo.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $38c931550e91452f$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $38c931550e91452f$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, $l998X.jsx)(Provider, {
        value: cardContext.value,
        children: children
    });
};
var $38c931550e91452f$export$2e2bcd8739ae039 = $38c931550e91452f$export$156b523e63b4f63a;
module.exports["SmartCardContext"] = $38c931550e91452f$export$156b523e63b4f63a;
module.exports["useSmartLinkContext"] = $38c931550e91452f$export$e1d190b530cf0ee9;
module.exports["useSmartCardContext"] = $38c931550e91452f$export$10e9cca30e50f657;
module.exports["EditorSmartCardProviderValueGuard"] = $38c931550e91452f$export$797e3658f090919c;
module.exports["EditorSmartCardProvider"] = $38c931550e91452f$export$2a29ca11e08dc129;

});

parcelRegister("7bZ3i", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $99uSl = parcelRequire("99uSl");


var $lgmus = parcelRequire("lgmus");


var $6q0AE = parcelRequire("6q0AE");


var $79vw2 = parcelRequire("79vw2");


var $dE3t3 = parcelRequire("dE3t3");


var $eIleF = parcelRequire("eIleF");


var $k00oi = parcelRequire("k00oi");

function $4cf4ff4aa0c52ddf$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel }) {
    const parentContext = (0, $42omo.useContext)((0, $eIleF.SmartCardContext));
    const defaultInitialState = (0, $42omo.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $42omo.useMemo)(()=>{
        return (0, $99uSl.createStore)((0, $dE3t3.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $42omo.useMemo)(()=>{
        const client = customClient || new (0, $k00oi.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, // @deprecated The support for platform will be removed and default to `web`
        _platform)=>{
            const cardState = (0, $6q0AE.getUrl)(store, url);
            return cardState.details ? (0, $79vw2.extractSmartLinkEmbed)(cardState.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        };
    }, [
        customAuthFlow,
        customClient,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        store
    ]);
    const value = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eIleF.SmartCardContext).Provider, {
        value: value,
        children: children
    });
}
var $4cf4ff4aa0c52ddf$export$2e2bcd8739ae039 = $4cf4ff4aa0c52ddf$export$497ecb0280204df4;
module.exports["SmartCardProvider"] = $4cf4ff4aa0c52ddf$export$497ecb0280204df4;

});

parcelRegister("6q0AE", function(module, exports) {
const $30e97e7594f3b00b$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};
module.exports["getUrl"] = $30e97e7594f3b00b$export$94df0e59ebebf4a7;

});

parcelRegister("dE3t3", function(module, exports) {

var $9gPkz = parcelRequire("9gPkz");

var $btw9C = parcelRequire("btw9C");

const $93945b5bac9d9f43$var$isCardAction = (action)=>{
    return [
        (0, $9gPkz.ACTION_PENDING),
        (0, $9gPkz.ACTION_RESOLVING),
        (0, $9gPkz.ACTION_RESOLVED),
        (0, $9gPkz.ACTION_RELOADING),
        (0, $9gPkz.ACTION_ERROR),
        (0, $9gPkz.ACTION_ERROR_FALLBACK),
        (0, $9gPkz.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $93945b5bac9d9f43$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $btw9C.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $93945b5bac9d9f43$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $9gPkz.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $9gPkz.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $9gPkz.ACTION_RESOLVED:
            return $93945b5bac9d9f43$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $9gPkz.ACTION_RELOADING:
            return $93945b5bac9d9f43$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $9gPkz.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $9gPkz.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $9gPkz.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $93945b5bac9d9f43$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$93945b5bac9d9f43$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $93945b5bac9d9f43$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};
module.exports["cardReducer"] = $93945b5bac9d9f43$export$3c7c3113a97b6492;

});

parcelRegister("9gPkz", function(module, exports) {
// TODO: eventually move this file to @atlaskit/link-actions
const $4165c6e5bfa202ae$export$6e470aad5ba8952e = 'pending';
const $4165c6e5bfa202ae$export$9a6a932a0a39498e = 'resolving';
const $4165c6e5bfa202ae$export$63ec8bc7a8a75482 = 'resolved';
const $4165c6e5bfa202ae$export$b8cfaa842c9ab487 = 'reloading';
const $4165c6e5bfa202ae$export$6d8ed3f9433dd372 = 'errored';
const $4165c6e5bfa202ae$export$cfbbb7126bc8a0c6 = 'fallback';
const $4165c6e5bfa202ae$export$76b5c1aca20759c6 = 'preload';
const $4165c6e5bfa202ae$export$2c5edb971b673330 = 'metadata';
const $4165c6e5bfa202ae$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });
module.exports["ACTION_PENDING"] = $4165c6e5bfa202ae$export$6e470aad5ba8952e;
module.exports["ACTION_RESOLVING"] = $4165c6e5bfa202ae$export$9a6a932a0a39498e;
module.exports["ACTION_RESOLVED"] = $4165c6e5bfa202ae$export$63ec8bc7a8a75482;
module.exports["ACTION_RELOADING"] = $4165c6e5bfa202ae$export$b8cfaa842c9ab487;
module.exports["ACTION_ERROR"] = $4165c6e5bfa202ae$export$6d8ed3f9433dd372;
module.exports["ACTION_ERROR_FALLBACK"] = $4165c6e5bfa202ae$export$cfbbb7126bc8a0c6;
module.exports["ACTION_UPDATE_METADATA_STATUS"] = $4165c6e5bfa202ae$export$2c5edb971b673330;
module.exports["cardAction"] = $4165c6e5bfa202ae$export$a884a52152489cc3;

});

parcelRegister("lz9QA", function(module, exports) {

var $hpRUx = parcelRequire("hpRUx");


var $eIleF = parcelRequire("eIleF");

const $206782ec364200b6$var$PENDING_STATE = {
    status: 'pending'
};
function $206782ec364200b6$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const cardState = (0, $hpRUx.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $206782ec364200b6$var$PENDING_STATE;
}
module.exports["useSmartCardState"] = $206782ec364200b6$export$b0444d00ba7313c6;

});

parcelRegister("4P6U3", function(module, exports) {
const $9f845e05fed92a58$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $9f845e05fed92a58$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $9f845e05fed92a58$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $9f845e05fed92a58$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $9f845e05fed92a58$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $9f845e05fed92a58$var$result.android = /Android \d/.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $9f845e05fed92a58$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $9f845e05fed92a58$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $9f845e05fed92a58$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $9f845e05fed92a58$export$3f2684e5d7cb1006() {
    return $9f845e05fed92a58$var$result;
}
module.exports["browser"] = $9f845e05fed92a58$export$3f2684e5d7cb1006;

});

parcelRegister("afp1H", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $8ae4cb49ca93b6d8$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    actions: {
        id: "fabric.linking.actions",
        defaultMessage: "Actions"
    },
    add_account: {
        id: "fabric.linking.add_account",
        defaultMessage: "Add account"
    },
    ai_summarize: {
        id: "fabric.linking.ai_summarize",
        defaultMessage: "Summarize"
    },
    ai_summarized: {
        id: "fabric.linking.ai_summarized",
        defaultMessage: "Summarized by Atlassian Intelligence"
    },
    ai_summarized_abbreviation: {
        id: "fabric.linking.ai_summarized_abbreviation",
        defaultMessage: "Summarized by AI"
    },
    ai_summarized_info: {
        id: "fabric.linking.ai_summarized_info",
        defaultMessage: "Information quality may vary. <a>Learn more</a>"
    },
    ai_summarized_info_short: {
        id: "fabric.linking.ai_summarized_info_short",
        defaultMessage: "Content quality may vary"
    },
    ai_summarizing: {
        id: "fabric.linking.ai_summarizing",
        defaultMessage: "Atlassian Intelligence is working..."
    },
    ai_summary_error_generic: {
        id: "fabric.linking.ai_summary_error_generic",
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>."
    },
    ai_summary_error_acceptable_use_violation: {
        id: "fabric.linking.ai_summary_error_acceptable_use_violation",
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>."
    },
    ai_summary_error_hipaa_content_detected: {
        id: "fabric.linking.ai_summary_error_hipaa_content_detected",
        defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content."
    },
    ai_summary_error_exceeding_context_length_error: {
        id: "fabric.linking.ai_summary_error_exceeding_context_length_error",
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize."
    },
    assigned_to: {
        id: "fabric.linking.assigned_to",
        defaultMessage: "Assigned to {context}"
    },
    automation_action_title: {
        id: "fabric.linking.automation-action.title",
        defaultMessage: "View automation rules"
    },
    automation_action_icon_label: {
        id: "fabric.linking.automation-action.icon.label",
        defaultMessage: "Automation icon"
    },
    automation_action_tooltip: {
        id: "fabric.linking.automation-action.tooltip",
        defaultMessage: "Select an automation rule to run"
    },
    automation_action_confluence_page_modal_title: {
        id: "fabric.linking.automation-action.confluence.page.modal.title",
        defaultMessage: "Page automations"
    },
    automation_action_confluence_page_modal_description: {
        id: "fabric.linking.automation-action.confluence.page.modal.description",
        defaultMessage: "Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators."
    },
    cancel: {
        id: "fabric.linking.cancel",
        defaultMessage: "Cancel"
    },
    beta: {
        id: "fabric.linking.beta",
        defaultMessage: "Beta"
    },
    cannot_connect: {
        id: "fabric.linking.cannot_connect",
        defaultMessage: "Can't connect, try again"
    },
    cannot_find_link: {
        id: "fabric.linking.cannot_find_link",
        defaultMessage: "Can't find link"
    },
    click_to_join: {
        id: "fabric.linking.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.linking.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    close: {
        id: "fabric.linking.close",
        defaultMessage: "Close"
    },
    check_this_link: {
        id: "fabric.linking.check_this_link",
        defaultMessage: "Check this link"
    },
    compass_applied_components_count: {
        id: "compass.applied_components_count.non-final",
        defaultMessage: "Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component} other {{numberOfComponents, number} components}}"
    },
    connect_to: {
        id: "fabric.linking.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.linking.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.linking.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.linking.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.linking.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_card_description: {
        id: "fabric.linking.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    connect_unauthorised_account_action: {
        id: "fabric.linking.connect_unauthorised_account_action",
        defaultMessage: "Connect to {context}"
    },
    connect_unauthorised_account_description: {
        id: "fabric.linking.connect_unauthorised_account_description",
        defaultMessage: "Connect your {context} account to collaborate on work across Atlassian products."
    },
    connect_unauthorised_account_description_no_provider: {
        id: "fabric.linking.connect_unauthorised_account_description_no_provider",
        defaultMessage: "Connect your account to collaborate on work across Atlassian products."
    },
    continue: {
        id: "fabric.linking.continue",
        defaultMessage: "Continue"
    },
    copy_url_to_clipboard: {
        id: "fabric.linking.copy_url_to_clipboard",
        defaultMessage: "Copy link"
    },
    copied_url_to_clipboard: {
        id: "fabric.linking.copied_url_to_clipboard",
        defaultMessage: "Copied!"
    },
    could_not_load_link: {
        id: "fabric.linking.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    created_by: {
        id: "fabric.linking.created_by",
        defaultMessage: "Created by {context}"
    },
    created_on_relative: {
        id: "fabric.linking.create_on_relative",
        defaultMessage: "Created {context}"
    },
    created_on_absolute: {
        id: "fabric.linking.create_on_absolute",
        defaultMessage: "Created on {context}"
    },
    delete: {
        id: "fabric.linking.delete",
        defaultMessage: "Delete"
    },
    download: {
        id: "fabric.linking.download",
        defaultMessage: "Download"
    },
    download_description: {
        id: "fabric.linking.download_description",
        defaultMessage: "Download this file into your local storage"
    },
    download_file: {
        id: "fabric.linking.download_file",
        defaultMessage: "Download file"
    },
    ai_summary_action: {
        id: "fabric.linking.ai_summary_action",
        defaultMessage: "Summarize with AI"
    },
    ai_summary_action_description: {
        id: "fabric.linking.ai_summary_action_description",
        defaultMessage: "Summarize the content of this link using Atlassian Intelligence."
    },
    copy_summary_action: {
        id: "fabric.linking.copy_summary_action",
        defaultMessage: "Copy summary"
    },
    copy_summary_action_description: {
        id: "fabric.linking.copy_summary_action_description",
        defaultMessage: "Copy summary"
    },
    copied_summary_action_description: {
        id: "fabric.linking.copied_summary_action_description",
        defaultMessage: "Copied summary to clipboard"
    },
    edit: {
        id: "fabric.linking.edit",
        defaultMessage: "Edit"
    },
    follow: {
        id: "fabric.linking.follow",
        defaultMessage: "Follow"
    },
    follow_project_description: {
        id: "fabric.linking.follow_project_description",
        defaultMessage: "Follow to get notifications on this project"
    },
    follow_project: {
        id: "fabric.linking.follow_project",
        defaultMessage: "Follow project"
    },
    follow_project_error: {
        id: "fabric.linking.follow_project_error",
        defaultMessage: "We encountered an error while trying to follow the project. Check your connection or refresh the page and try again."
    },
    follow_goal_description: {
        id: "fabric.linking.follow_goal_description",
        defaultMessage: "Follow this goal to get notifications on updates"
    },
    follow_goal: {
        id: "fabric.linking.follow_goal",
        defaultMessage: "Follow goal"
    },
    follow_goal_error: {
        id: "fabric.linking.follow_goal_error",
        defaultMessage: "We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again."
    },
    go_back: {
        id: "fabric.linking.go_back",
        defaultMessage: "Go back"
    },
    invalid_permissions: {
        id: "fabric.linking.invalid_permissions",
        defaultMessage: "Restricted content"
    },
    invalid_permissions_description: {
        id: "fabric.linking.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    join_to_view: {
        id: "fabric.linking.join_to_view",
        defaultMessage: "Join {context} to view this issue"
    },
    learn_more_about_smart_links: {
        id: "fabric.linking.learn_more_about_smart_links",
        defaultMessage: "Learn more about Smart Links."
    },
    learn_more_about_connecting_account: {
        id: "fabric.linking.learn_more_about_connecting_account",
        defaultMessage: "Learn more about connecting your account to Atlassian products."
    },
    loading: {
        id: "fabric.linking.loading",
        defaultMessage: "Loading..."
    },
    modified_by: {
        id: "fabric.linking.updated_by",
        defaultMessage: "Modified by {context}"
    },
    modified_on_relative: {
        id: "fabric.linking.modified_on_relative",
        defaultMessage: "Updated {context}"
    },
    modified_on_absolute: {
        id: "fabric.linking.modified_on_absolute",
        defaultMessage: "Updated on {context}"
    },
    more_actions: {
        id: "fabric.linking.more_actions",
        defaultMessage: "More actions"
    },
    open_issue_in_jira: {
        id: "fabric.linking.open_issue_in_jira",
        defaultMessage: "Open issue in Jira"
    },
    open_link_in_a_new_tab: {
        id: "fabric.linking.open_link_in_a_new_tab",
        defaultMessage: "Open link in a new tab"
    },
    owned_by: {
        id: "fabric.linking.owned_by",
        defaultMessage: "Owned by {context}"
    },
    owned_by_override: {
        id: "fabric.linking.owned_by_override",
        defaultMessage: "By {context}"
    },
    preview_description: {
        id: "fabric.linking.preview_description",
        defaultMessage: "Open a full screen preview of this link"
    },
    preview_improved: {
        id: "fabric.linking.preview_improved",
        defaultMessage: "Open preview"
    },
    preview_modal: {
        id: "fabric.linking.preview_modal",
        defaultMessage: "Open preview modal"
    },
    preview_panel: {
        id: "fabric.linking.preview_panel",
        defaultMessage: "Open preview panel"
    },
    preview_close: {
        id: "fabric.linking.preview_close",
        defaultMessage: "Close preview"
    },
    preview_max_size: {
        id: "fabric.linking.preview_max_size",
        defaultMessage: "View full screen"
    },
    preview_min_size: {
        id: "fabric.linking.preview_min_size",
        defaultMessage: "Close full screen"
    },
    priority_blocker: {
        id: "fabric.linking.priority_blocker",
        defaultMessage: "Blocker"
    },
    priority_critical: {
        id: "fabric.linking.priority_critical",
        defaultMessage: "Critical"
    },
    priority_high: {
        id: "fabric.linking.priority_high",
        defaultMessage: "High"
    },
    priority_highest: {
        id: "fabric.linking.priority_highest",
        defaultMessage: "Highest"
    },
    priority_low: {
        id: "fabric.linking.priority_low",
        defaultMessage: "Low"
    },
    priority_lowest: {
        id: "fabric.linking.priority_lowest",
        defaultMessage: "Lowest"
    },
    priority_major: {
        id: "fabric.linking.priority_major",
        defaultMessage: "Major"
    },
    priority_medium: {
        id: "fabric.linking.priority_medium",
        defaultMessage: "Medium"
    },
    priority_minor: {
        id: "fabric.linking.priority_minor",
        defaultMessage: "Minor"
    },
    priority_trivial: {
        id: "fabric.linking.priority_trivial",
        defaultMessage: "Trivial"
    },
    priority_undefined: {
        id: "fabric.linking.priority_undefined",
        defaultMessage: "Undefined"
    },
    forbidden_access: {
        id: "fabric.linking.forbidden_access",
        defaultMessage: "Your access is forbidden"
    },
    pending_request: {
        id: "fabric.linking.pending_request",
        defaultMessage: "Your access request is pending"
    },
    read_time: {
        id: "fabric.linking.read_time",
        defaultMessage: "{context} min read"
    },
    restricted_link: {
        id: "fabric.linking.restricted_link",
        defaultMessage: "Restricted link, try another account"
    },
    request_access_to_view: {
        id: "fabric.linking.request_access_to_view",
        defaultMessage: "Request access to {context} to view this issue"
    },
    request_denied: {
        id: "fabric.linking.request_denied",
        defaultMessage: "Your access request was denied"
    },
    retry: {
        id: "fabric.linking.retry",
        defaultMessage: "Retry"
    },
    save: {
        id: "fabric.linking.save",
        defaultMessage: "Save"
    },
    sent_on_relative: {
        id: "fabric.linking.sent_on_relative",
        defaultMessage: "Sent {context}"
    },
    sent_on_absolute: {
        id: "fabric.linking.sent_on_absolute",
        defaultMessage: "Sent on {context}"
    },
    status_change_load_error: {
        id: "fabric.linking.status_change_load_error",
        defaultMessage: "We couldn\u2019t load the statuses and transitions"
    },
    status_change_permission_error: {
        id: "fabric.linking.status_change_permission_error",
        defaultMessage: "You don\u2019t have permission to transition this issue."
    },
    status_change_update_error: {
        id: "fabric.linking.status_change_update_error",
        defaultMessage: "We couldn\u2019t update the status"
    },
    try_again: {
        id: "fabric.linking.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.linking.try_another_account",
        defaultMessage: "Try another account"
    },
    link_safety_warning_message: {
        id: "fabric.linking.link_safety_warning_message",
        defaultMessage: "The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>"
    },
    unauthorised_account_description: {
        id: "fabric.linking.unauthorised_account_description",
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner."
    },
    unauthorised_account_description_no_provider: {
        id: "fabric.linking.unauthorised_account_description_no_provider",
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner."
    },
    unauthorised_account_name: {
        id: "fabric.linking.unauthorised_account_name",
        defaultMessage: "We can't display private pages from {context}"
    },
    unauthorised_account_name_no_provider: {
        id: "fabric.linking.unauthorised_account_name_no_provider",
        defaultMessage: "We can't display private pages"
    },
    unassigned: {
        id: "fabric.linking.unassigned",
        defaultMessage: "Unassigned"
    },
    unfollow: {
        id: "fabric.linking.unfollow",
        defaultMessage: "Unfollow"
    },
    unfollow_project_description: {
        id: "fabric.linking.unfollow_project_description",
        defaultMessage: "Unfollow to stop receiving project notifications"
    },
    unfollow_project: {
        id: "fabric.linking.unfollow_project",
        defaultMessage: "Unfollow project"
    },
    unfollow_project_error: {
        id: "fabric.linking.unfollow_project_error",
        defaultMessage: "We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again."
    },
    unfollow_goal_description: {
        id: "fabric.linking.unfollow_goal_description",
        defaultMessage: "Unfollow to stop receiving notifications for this goal"
    },
    unfollow_goal: {
        id: "fabric.linking.unfollow_goal",
        defaultMessage: "Unfollow goal"
    },
    unfollow_goal_error: {
        id: "fabric.linking.unfollow_goal_error",
        defaultMessage: "We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again."
    },
    unlink_account: {
        id: "fabric.linking.unlink_account",
        defaultMessage: "Unlink Account"
    },
    view: {
        id: "fabric.linking.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.linking.srclink",
        defaultMessage: "View in"
    },
    viewOriginal: {
        id: "fabric.linking.srclinkunknown",
        defaultMessage: "View Original"
    },
    default_no_access_title: {
        id: "fabric.linking.no_access_title",
        defaultMessage: "Join {product} to view this content"
    },
    direct_access_title: {
        id: "fabric.linking.direct_access_title",
        defaultMessage: "Join {product} to view this content"
    },
    direct_access_description: {
        id: "fabric.linking.direct_access_description",
        defaultMessage: "Your team uses {product} to collaborate and you can start using it right away!"
    },
    direct_access: {
        id: "fabric.linking.direct_access",
        defaultMessage: "Join now"
    },
    request_access_description: {
        id: "fabric.linking.request_access_description",
        defaultMessage: "Your team uses {product} to collaborate. Send your admin a request for access."
    },
    request_access: {
        id: "fabric.linking.request_access",
        defaultMessage: "Request access"
    },
    request_access_pending_title: {
        id: "fabric.linking.request_access_pending_title",
        defaultMessage: "Access to {product} is pending"
    },
    request_access_pending_description: {
        id: "fabric.linking.request_access_pending_description",
        defaultMessage: "Your request to access {hostname} is awaiting admin approval."
    },
    request_access_pending: {
        id: "fabric.linking.request_access_pending",
        defaultMessage: "Pending approval"
    },
    request_denied_description: {
        id: "fabric.linking.request_denied_description",
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}."
    },
    access_exists_description: {
        id: "fabric.linking.access_exists_description",
        defaultMessage: "Request access to view this content from {hostname}."
    },
    not_found_description: {
        id: "fabric.linking.not_found_description",
        defaultMessage: "The page doesn't exist or it may have changed after this link was added."
    },
    not_found_title: {
        id: "fabric.linking.not_found_title",
        defaultMessage: "We can't show you this {product} page"
    },
    forbidden_title: {
        id: "fabric.linking.forbidden_title",
        defaultMessage: "You don't have access to this content"
    },
    forbidden_description: {
        id: "fabric.linking.forbidden_description",
        defaultMessage: "Contact your admin to request access to {hostname}."
    },
    related: {
        id: "fabric.linking.related",
        defaultMessage: "Related"
    },
    generic_error_message: {
        id: "fabric.linking.generic_error_message",
        defaultMessage: "An error occurred"
    },
    related_links_modal_title: {
        id: "fabric.linking.related_links_modal_title",
        defaultMessage: "Related links"
    },
    related_links_view_related_urls: {
        id: "fabric.linking.related_links_view_related_urls",
        defaultMessage: "View recent links"
    },
    related_links_view_related_links: {
        id: "fabric.linking.related_links_view_related_links",
        defaultMessage: "View related links"
    },
    related_links_found_in: {
        id: "fabric.linking.related_links_found_in",
        defaultMessage: "Found in"
    },
    related_links_not_found: {
        id: "fabric.linking.related_links_not_found",
        defaultMessage: "We didn't find any links to show here."
    },
    related_links_includes_links_to: {
        id: "fabric.linking.related_links_includes_links_to",
        defaultMessage: "Includes links to"
    },
    related_links_modal_error_title: {
        id: "fabric.linking.related_links_modal_error_title",
        defaultMessage: "We're having trouble loading related links"
    },
    related_links_modal_unavailable_title: {
        id: "fabric.linking.related_links_modal_unavailable_title",
        defaultMessage: "We couldn't find any related links"
    },
    related_links_modal_error_description: {
        id: "fabric.linking.related_links_modal_error_description",
        defaultMessage: "Check your connection or refresh the page to try again"
    },
    related_links_modal_unavailable_description: {
        id: "fabric.linking.related_links_modal_unavailable_description",
        defaultMessage: "We continuously review and add related links for updated pages or other content types"
    },
    join_to_viewIssueTermRefresh: {
        id: "fabric.linking.join_to_view-issue-term-refresh",
        defaultMessage: "Join {context} to view this work item"
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: "fabric.linking.open_issue_in_jira-issue-term-refresh",
        defaultMessage: "Open work item in Jira"
    },
    request_access_to_viewIssueTermRefresh: {
        id: "fabric.linking.request_access_to_view-issue-term-refresh",
        defaultMessage: "Request access to {context} to view this work item"
    },
    status_change_permission_errorIssueTermRefresh: {
        id: "fabric.linking.status_change_permission_error-issue-term-refresh",
        defaultMessage: "You don\u2019t have permission to transition this work item."
    },
    team_members_count: {
        id: "fabric.linking.team_members_count",
        defaultMessage: "{context} members"
    },
    user_attributes: {
        id: "fabric.linking.user_attributes",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{context}"
    },
    follow_project_descriptionGalaxia: {
        id: "fabric.linking.follow_project_description-galaxia",
        defaultMessage: "Follow to get notifications on this space"
    },
    follow_project_errorGalaxia: {
        id: "fabric.linking.follow_project_error-galaxia",
        defaultMessage: "We encountered an error while trying to follow the space. Check your connection or refresh the page and try again."
    },
    unfollow_project_descriptionGalaxia: {
        id: "fabric.linking.unfollow_project_description-galaxia",
        defaultMessage: "Unfollow to stop receiving space notifications"
    },
    unfollow_project_errorGalaxia: {
        id: "fabric.linking.unfollow_project_error-galaxia",
        defaultMessage: "We encountered an error while trying to unfollow the space. Check your connection or refresh the page and try again."
    },
    connect_unauthorised_account_description_appify: {
        id: "fabric.linking.connect_unauthorised_account_description-appify",
        defaultMessage: "Connect your {context} account to collaborate on work across Atlassian apps."
    },
    connect_unauthorised_account_description_no_provider_appify: {
        id: "fabric.linking.connect_unauthorised_account_description_no_provider-appify",
        defaultMessage: "Connect your account to collaborate on work across Atlassian apps."
    },
    learn_more_about_connecting_account_appify: {
        id: "fabric.linking.learn_more_about_connecting_account-appify",
        defaultMessage: "Learn more about connecting your account to Atlassian apps."
    },
    learn_more_about_connecting_account_experiment_shorter: {
        id: "fabric.linking.learn_more_about_connecting_account_experiment_short",
        defaultMessage: "Turn your URLs into rich, interactive previews."
    }
});
module.exports["messages"] = $8ae4cb49ca93b6d8$export$defe85febe8b728c;

});

parcelRegister("6Eovk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d797c8c4e4c6494$export$2e2bcd8739ae039);
/* eslint-disable import/no-default-export */ /* eslint-disable react/prop-types */ 
var $42omo = parcelRequire("42omo");


var $cMypa = parcelRequire("cMypa");


var $9wGTI = parcelRequire("9wGTI");

function $4d797c8c4e4c6494$export$2e2bcd8739ae039(props) {
    // Produce the image tag as is because there is no onLoad event in SSR
    // Also render image tag directly if the page was SSRed because react-render-image always render placeholder first.
    // This will make image flicker
    return props.src && (0, window.__SSR_RENDERED__) && (0, $9wGTI.fg)('replace_react_render_image_with_image_tag') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.loaded) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMypa))), props);
}

});

parcelRegister("cMypa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94e4a7d853f8088a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $94e4a7d853f8088a$var$React = $94e4a7d853f8088a$var$_interopRequireWildcard($42omo);
function $94e4a7d853f8088a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $94e4a7d853f8088a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $94e4a7d853f8088a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $94e4a7d853f8088a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $94e4a7d853f8088a$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $94e4a7d853f8088a$var$loaded() {
    return {
        isLoaded: true
    };
}
function $94e4a7d853f8088a$var$errored() {
    return {
        isErrored: true
    };
}
function $94e4a7d853f8088a$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $94e4a7d853f8088a$var$ImageRenderer = function(_React$Component) {
    $94e4a7d853f8088a$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $94e4a7d853f8088a$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $94e4a7d853f8088a$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $94e4a7d853f8088a$var$_possibleConstructorReturn(_this, _ret);
    }
    $94e4a7d853f8088a$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(this.props, nextProps)) this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($94e4a7d853f8088a$var$React.Component);
module.exports.default = $94e4a7d853f8088a$var$ImageRenderer;

});

parcelRegister("1Okf1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDhJe = parcelRequire("dDhJe");

const $6833d9101ef67c08$export$d08617a365fbe694 = (cardClient)=>(0, $42omo.useMemo)(()=>(0, $dDhJe.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $6833d9101ef67c08$export$d08617a365fbe694;

});

parcelRegister("7DSoa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lyclm = parcelRequire("lyclm");


var $eIleF = parcelRequire("eIleF");


var $5TXU5 = parcelRequire("5TXU5");


var $bIll3 = parcelRequire("bIll3");


var $4IQbU = parcelRequire("4IQbU");

const $8fe2ac6ef7785039$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $4IQbU.default)();
    return (0, $42omo.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $5TXU5.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $lyclm.isEntityPresent)(details));
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $bIll3.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $8fe2ac6ef7785039$export$2e2bcd8739ae039 = $8fe2ac6ef7785039$var$useResolve;
module.exports["default"] = $8fe2ac6ef7785039$export$2e2bcd8739ae039;

});

parcelRegister("4IQbU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $eIleF = parcelRequire("eIleF");


var $9gPkz = parcelRequire("9gPkz");

var $jHnts = parcelRequire("jHnts");

var $btw9C = parcelRequire("btw9C");


var $5TXU5 = parcelRequire("5TXU5");


var $4ibS1 = parcelRequire("4ibS1");


var $bKqKH = parcelRequire("bKqKH");

const $afe444b12e732e06$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $42omo.useCallback)((url, metadataStatus)=>{
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $42omo.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $5TXU5.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
            url: url
        }, (0, $4ibS1.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $42omo.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $42omo.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $btw9C.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('fallback', hostname, (0, $bKqKH.ERROR_MESSAGE_OAUTH)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('fatal', hostname, (0, $bKqKH.ERROR_MESSAGE_FATAL)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('error', hostname, (0, $bKqKH.ERROR_MESSAGE_METADATA)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $jTxSS.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $42omo.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $afe444b12e732e06$export$2e2bcd8739ae039 = $afe444b12e732e06$var$useResponse;
module.exports["default"] = $afe444b12e732e06$export$2e2bcd8739ae039;

});

parcelRegister("4ibS1", function(module, exports) {
const $edbc823e59ec01a7$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $edbc823e59ec01a7$export$2796a804c6e44f63 = ()=>$edbc823e59ec01a7$var$emptyData;
const $edbc823e59ec01a7$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$edbc823e59ec01a7$var$emptyData
        }
    });
const $edbc823e59ec01a7$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$edbc823e59ec01a7$var$emptyData
        }
    });
module.exports["getEmptyJsonLd"] = $edbc823e59ec01a7$export$2796a804c6e44f63;
module.exports["getUnauthorizedJsonLd"] = $edbc823e59ec01a7$export$b9482e0f6d365cc7;
module.exports["getForbiddenJsonLd"] = $edbc823e59ec01a7$export$e32193033a594efb;

});

parcelRegister("bKqKH", function(module, exports) {
const $96d7cda9026a4858$export$297c39c8b9bfca0 = 'resolving';
const $96d7cda9026a4858$export$b64a888338c24e0e = 'errored';
const $96d7cda9026a4858$export$677b6edfa0002c70 = 'fallback';
const $96d7cda9026a4858$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $96d7cda9026a4858$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $96d7cda9026a4858$export$338f7d9ccca1975d = 'Error resolving metadata.';
module.exports["ERROR_MESSAGE_OAUTH"] = $96d7cda9026a4858$export$3e81ce851ffda0ad;
module.exports["ERROR_MESSAGE_FATAL"] = $96d7cda9026a4858$export$45e7dda0d43d7f55;
module.exports["ERROR_MESSAGE_METADATA"] = $96d7cda9026a4858$export$338f7d9ccca1975d;

});

parcelRegister("9oOnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $kKODE = parcelRequire("kKODE");


var $l6tPN = parcelRequire("l6tPN");


var $bIll3 = parcelRequire("bIll3");

const $458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $458a31c3ca98bc55$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $42omo.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $l6tPN.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $bIll3.startUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $l6tPN.mark(markName, 'resolved');
            (0, $bIll3.succeedUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $l6tPN.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $l6tPN.mark(markName, 'errored');
            (0, $bIll3.failUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $l6tPN.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $458a31c3ca98bc55$export$2e2bcd8739ae039 = $458a31c3ca98bc55$var$useInvokeClientAction;
module.exports["default"] = $458a31c3ca98bc55$export$2e2bcd8739ae039;

});

parcelRegister("l6tPN", function(module, exports) {
const $f72103dc56ec53a8$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $f72103dc56ec53a8$var$hasPerformanceAPIAvailable = $f72103dc56ec53a8$var$isPerformanceAPIAvailable();
const $f72103dc56ec53a8$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $f72103dc56ec53a8$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $f72103dc56ec53a8$export$1a717feb4df1a945 = (id)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $f72103dc56ec53a8$export$de42547d395c8271 = (id)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $f72103dc56ec53a8$var$getMark = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $f72103dc56ec53a8$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $f72103dc56ec53a8$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $f72103dc56ec53a8$export$185802fd694ee1f5 = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$984df7f61dd7928f(id, status);
        const measure = $f72103dc56ec53a8$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $f72103dc56ec53a8$var$getMark(id, 'pending');
            const endMark = $f72103dc56ec53a8$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};
module.exports["clearMarks"] = $f72103dc56ec53a8$export$1a717feb4df1a945;
module.exports["clearMeasures"] = $f72103dc56ec53a8$export$de42547d395c8271;
module.exports["getMeasure"] = $f72103dc56ec53a8$export$d6e97a903ae9a3aa;
module.exports["mark"] = $f72103dc56ec53a8$export$bf7f2fce5c1cf636;
module.exports["create"] = $f72103dc56ec53a8$export$185802fd694ee1f5;

});

parcelRegister("4gM1A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6wQZE = parcelRequire("6wQZE");

var $77752028a2bf334b$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $77752028a2bf334b$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return (0, $42omo.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $6wQZE.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $77752028a2bf334b$var$isNotLeftClick = (event)=>event.button !== 0;
const $77752028a2bf334b$export$df67f318ded0283c = (onMouseDown)=>{
    return $77752028a2bf334b$export$5993d3ca6c85f774(onMouseDown, $77752028a2bf334b$var$isNotLeftClick);
};
module.exports["useLinkClicked"] = $77752028a2bf334b$export$5993d3ca6c85f774;
module.exports["useMouseDownEvent"] = $77752028a2bf334b$export$df67f318ded0283c;

});

parcelRegister("6wQZE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4P6U3 = parcelRequire("4P6U3");


var $1I43V = parcelRequire("1I43V");


var $1oCLl = parcelRequire("1oCLl");


var $4gM1A = parcelRequire("4gM1A");


var $lgqac = parcelRequire("lgqac");

const $8b02aa09be31a1d9$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $8b02aa09be31a1d9$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $8b02aa09be31a1d9$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $8b02aa09be31a1d9$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $4P6U3.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($8b02aa09be31a1d9$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $8b02aa09be31a1d9$var$linkClickedEventOld = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $8b02aa09be31a1d9$var$linkClickedEventWithShortLink = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented, isConfluenceShortLink: isConfluenceShortLink })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented,
            isConfluenceShortLink: isConfluenceShortLink
        }
    });
const $8b02aa09be31a1d9$export$880d2168464029dd = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $8b02aa09be31a1d9$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $8b02aa09be31a1d9$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $8b02aa09be31a1d9$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $8b02aa09be31a1d9$var$linkClickedEventOld({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $8b02aa09be31a1d9$export$fb40cb818618aeeb = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $8b02aa09be31a1d9$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $8b02aa09be31a1d9$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $8b02aa09be31a1d9$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    // Check if the URL is a Confluence shortLink (contains "/l/cp/")
    let isConfluenceShortLink = false;
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        isConfluenceShortLink = url.includes('/l/cp/');
    }
    const linkClickedEventResult = $8b02aa09be31a1d9$var$linkClickedEventWithShortLink({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented,
        isConfluenceShortLink: isConfluenceShortLink
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $8b02aa09be31a1d9$export$7fedc699766c16de = (0, $1I43V.functionWithCondition)(()=>(0, $1oCLl.expValEquals)('smart_link_confluence_short_link_analytics', 'cohort', 'test'), $8b02aa09be31a1d9$export$fb40cb818618aeeb, $8b02aa09be31a1d9$export$880d2168464029dd);
const $8b02aa09be31a1d9$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $8b02aa09be31a1d9$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $lgqac.ANALYTICS_CHANNEL));
    };
const $8b02aa09be31a1d9$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $8b02aa09be31a1d9$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $4gM1A.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $4gM1A.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$8b02aa09be31a1d9$var$getDisplayName(WrappedComponent)})`;
    return Component;
}
module.exports["fireLinkClickedEvent"] = $8b02aa09be31a1d9$export$7987de3055fbdcb0;
module.exports["withLinkClickedEvent"] = $8b02aa09be31a1d9$export$263352d59c0c5966;

});

parcelRegister("1I43V", function(module, exports) {
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $4bac077259c47cd6$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $4bac077259c47cd6$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $4bac077259c47cd6$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}
module.exports["functionWithCondition"] = $4bac077259c47cd6$export$af3c0e82a18fc057;

});

parcelRegister("e6pbP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4452a63831cbd09$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $a4452a63831cbd09$var$t() {
    return $a4452a63831cbd09$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $a4452a63831cbd09$var$t.apply(this, arguments);
}
const $a4452a63831cbd09$var$n = [
    "children",
    "options"
], $a4452a63831cbd09$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $a4452a63831cbd09$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($a4452a63831cbd09$var$i || ($a4452a63831cbd09$var$i = {}));
const $a4452a63831cbd09$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    for: "htmlFor"
}), $a4452a63831cbd09$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $a4452a63831cbd09$var$o = [
    "style",
    "script"
], $a4452a63831cbd09$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $a4452a63831cbd09$var$s = /mailto:/i, $a4452a63831cbd09$var$d = /\n{2,}$/, $a4452a63831cbd09$var$u = /^(\s*>[\s\S]*?)(?=\n{2,})/, $a4452a63831cbd09$var$p = /^ *> ?/gm, $a4452a63831cbd09$var$f = /^ {2,}\n/, $a4452a63831cbd09$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $a4452a63831cbd09$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $a4452a63831cbd09$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $a4452a63831cbd09$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $a4452a63831cbd09$var$k = /^(?:\n *)*\n/, $a4452a63831cbd09$var$x = /\r\n?/g, $a4452a63831cbd09$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $a4452a63831cbd09$var$v = /^\[\^([^\]]+)]/, $a4452a63831cbd09$var$S = /\f/g, $a4452a63831cbd09$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $a4452a63831cbd09$var$$ = /^\s*?\[(x|\s)\]/, $a4452a63831cbd09$var$w = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $a4452a63831cbd09$var$C = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $a4452a63831cbd09$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $a4452a63831cbd09$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $a4452a63831cbd09$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $a4452a63831cbd09$var$T = /^<!--[\s\S]*?(?:-->)/, $a4452a63831cbd09$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $a4452a63831cbd09$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $a4452a63831cbd09$var$M = /^\{.*\}$/, $a4452a63831cbd09$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $a4452a63831cbd09$var$I = /^<([^ >]+@[^ >]+)>/, $a4452a63831cbd09$var$U = /^<([^ >]+:\/[^ >]+)>/, $a4452a63831cbd09$var$D = /-([a-z])?/gi, $a4452a63831cbd09$var$j = /^(.*\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $a4452a63831cbd09$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $a4452a63831cbd09$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $a4452a63831cbd09$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $a4452a63831cbd09$var$P = /(\[|\])/g, $a4452a63831cbd09$var$_ = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $a4452a63831cbd09$var$W = /\t/g, $a4452a63831cbd09$var$G = /(^ *\||\| *$)/g, $a4452a63831cbd09$var$Z = /^ *:-+: *$/, $a4452a63831cbd09$var$q = /^ *:-+ *$/, $a4452a63831cbd09$var$Q = /^ *-+: *$/, $a4452a63831cbd09$var$V = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $a4452a63831cbd09$var$X = new RegExp(`^([*_])\\1${$a4452a63831cbd09$var$V}\\1\\1(?!\\1)`), $a4452a63831cbd09$var$J = new RegExp(`^([*_])${$a4452a63831cbd09$var$V}\\1(?!\\1|\\w)`), $a4452a63831cbd09$var$K = new RegExp(`^==${$a4452a63831cbd09$var$V}==`), $a4452a63831cbd09$var$Y = new RegExp(`^~~${$a4452a63831cbd09$var$V}~~`), $a4452a63831cbd09$var$ee = /^\\([^0-9A-Za-z\s])/, $a4452a63831cbd09$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $a4452a63831cbd09$var$ne = /^\n+/, $a4452a63831cbd09$var$re = /^([ \t]*)/, $a4452a63831cbd09$var$ie = /\\([^\\])/g, $a4452a63831cbd09$var$le = / *\n+$/, $a4452a63831cbd09$var$ae = /(?:^|\n)( *)$/, $a4452a63831cbd09$var$oe = "(?:\\d+\\.)", $a4452a63831cbd09$var$ce = "(?:[*+-])";
function $a4452a63831cbd09$var$se(e) {
    return "( *)(" + (1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce) + ") +";
}
const $a4452a63831cbd09$var$de = $a4452a63831cbd09$var$se(1), $a4452a63831cbd09$var$ue = $a4452a63831cbd09$var$se(2);
function $a4452a63831cbd09$var$pe(e) {
    return new RegExp("^" + (1 === e ? $a4452a63831cbd09$var$de : $a4452a63831cbd09$var$ue));
}
const $a4452a63831cbd09$var$fe = $a4452a63831cbd09$var$pe(1), $a4452a63831cbd09$var$he = $a4452a63831cbd09$var$pe(2);
function $a4452a63831cbd09$var$me(e) {
    return new RegExp("^" + (1 === e ? $a4452a63831cbd09$var$de : $a4452a63831cbd09$var$ue) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $a4452a63831cbd09$var$ge = $a4452a63831cbd09$var$me(1), $a4452a63831cbd09$var$ye = $a4452a63831cbd09$var$me(2);
function $a4452a63831cbd09$var$ke(e) {
    const t = 1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $a4452a63831cbd09$var$xe = $a4452a63831cbd09$var$ke(1), $a4452a63831cbd09$var$be = $a4452a63831cbd09$var$ke(2);
function $a4452a63831cbd09$var$ve(e, t) {
    const n = 1 === t, i = n ? $a4452a63831cbd09$var$xe : $a4452a63831cbd09$var$be, l = n ? $a4452a63831cbd09$var$ge : $a4452a63831cbd09$var$ye, a = n ? $a4452a63831cbd09$var$fe : $a4452a63831cbd09$var$he;
    return {
        match (e, t, n) {
            const r = $a4452a63831cbd09$var$ae.exec(n);
            return r && (t.list || !t.inline && !t.simple) ? i.exec(e = r[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($a4452a63831cbd09$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, u = -1 !== s.indexOf("\n\n") || d && c;
                    c = u;
                    const p = r.inline, f = r.list;
                    let h;
                    r.list = !0, u ? (r.inline = !1, h = s.replace($a4452a63831cbd09$var$le, "\n\n")) : (r.inline = !0, h = s.replace($a4452a63831cbd09$var$le, ""));
                    const m = t(h, r);
                    return r.inline = p, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $a4452a63831cbd09$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $a4452a63831cbd09$var$Se = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $a4452a63831cbd09$var$Ee = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $a4452a63831cbd09$var$$e = [
    $a4452a63831cbd09$var$u,
    $a4452a63831cbd09$var$m,
    $a4452a63831cbd09$var$g,
    $a4452a63831cbd09$var$w,
    $a4452a63831cbd09$var$z,
    $a4452a63831cbd09$var$C,
    $a4452a63831cbd09$var$T,
    $a4452a63831cbd09$var$j,
    $a4452a63831cbd09$var$ge,
    $a4452a63831cbd09$var$xe,
    $a4452a63831cbd09$var$ye,
    $a4452a63831cbd09$var$be
], $a4452a63831cbd09$var$we = [
    ...$a4452a63831cbd09$var$$e,
    /^[^\n]+(?:  \n|\n{2,})/,
    $a4452a63831cbd09$var$L,
    $a4452a63831cbd09$var$B
];
function $a4452a63831cbd09$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $a4452a63831cbd09$var$ze(e) {
    return $a4452a63831cbd09$var$Q.test(e) ? "right" : $a4452a63831cbd09$var$Z.test(e) ? "center" : $a4452a63831cbd09$var$q.test(e) ? "left" : null;
}
function $a4452a63831cbd09$var$Le(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $a4452a63831cbd09$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $a4452a63831cbd09$var$Ae(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($a4452a63831cbd09$var$G, "").split("|").map($a4452a63831cbd09$var$ze) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $a4452a63831cbd09$var$Le(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $a4452a63831cbd09$var$Le(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $a4452a63831cbd09$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $a4452a63831cbd09$export$e0aa44767d8750d5.paragraph
    };
}
function $a4452a63831cbd09$var$Te(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $a4452a63831cbd09$var$Oe(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $a4452a63831cbd09$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $a4452a63831cbd09$var$Me(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $a4452a63831cbd09$var$Re(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $a4452a63831cbd09$var$Ie(e, t, n) {
    if (t.inline || t.simple) return null;
    if (n && !n.endsWith("\n")) return null;
    let r = "";
    e.split("\n").every((e)=>!$a4452a63831cbd09$var$$e.some((t)=>t.test(e)) && (r += e + "\n", e.trim()));
    const i = r.trimEnd();
    return "" == i ? null : [
        r,
        i
    ];
}
function $a4452a63831cbd09$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $a4452a63831cbd09$var$De(e) {
    return e.replace($a4452a63831cbd09$var$ie, "$1");
}
function $a4452a63831cbd09$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $a4452a63831cbd09$var$Ne(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $a4452a63831cbd09$var$He(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $a4452a63831cbd09$var$Fe = (e, t, n)=>({
        children: $a4452a63831cbd09$var$je(t, e[1], n)
    });
function $a4452a63831cbd09$var$Pe() {
    return {};
}
function $a4452a63831cbd09$var$_e() {
    return null;
}
function $a4452a63831cbd09$var$We(...e) {
    return e.filter(Boolean).join(" ");
}
function $a4452a63831cbd09$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $a4452a63831cbd09$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $a4452a63831cbd09$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $a4452a63831cbd09$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $a4452a63831cbd09$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $a4452a63831cbd09$var$t({}, n, l, {
            className: $a4452a63831cbd09$var$We(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($a4452a63831cbd09$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $a4452a63831cbd09$var$_.test(t));
        const r = le(ie(n ? t : `${t.trimEnd().replace($a4452a63831cbd09$var$ne, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $42omo.createElement(l, {
            key: "outer"
        }, a);
    }
    function Z(t, n) {
        const r = n.match($a4452a63831cbd09$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($a4452a63831cbd09$var$O) && (e = e.replace($a4452a63831cbd09$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $a4452a63831cbd09$var$l[c] || c, u = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($a4452a63831cbd09$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof u && ($a4452a63831cbd09$var$L.test(u) || $a4452a63831cbd09$var$B.test(u)) && (n[d] = $42omo.cloneElement(G(u.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$a4452a63831cbd09$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $a4452a63831cbd09$export$3e2338ea76b578c9, i.slugify = i.slugify || $a4452a63831cbd09$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $a4452a63831cbd09$var$t({}, $a4452a63831cbd09$var$a, i.namedCodesToUnicode) : $a4452a63831cbd09$var$a, i.createElement = i.createElement || $42omo.createElement;
    const q = [], Q = {}, V = {
        [$a4452a63831cbd09$export$e0aa44767d8750d5.blockQuote]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$u),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($a4452a63831cbd09$var$p, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.breakLine]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$f),
            order: 1,
            parse: $a4452a63831cbd09$var$Pe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.breakThematic]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$h),
            order: 1,
            parse: $a4452a63831cbd09$var$Pe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeBlock]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $a4452a63831cbd09$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeFenced]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: Z("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeInline]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.footnote]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$b),
            order: 0,
            parse: (e)=>(q.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.footnoteReference]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $a4452a63831cbd09$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.gfmTask]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$$),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.heading]: {
            match: $a4452a63831cbd09$var$Me(i.enforceAtxHeadings ? $a4452a63831cbd09$var$C : $a4452a63831cbd09$var$w),
            order: 1,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$je(t, e[2], n),
                    id: i.slugify(e[2], $a4452a63831cbd09$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.headingSetext]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$je(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.heading
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlBlock]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($a4452a63831cbd09$var$re), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $a4452a63831cbd09$var$we.some((e)=>e.test(c)) ? $a4452a63831cbd09$var$He : $a4452a63831cbd09$var$je);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $a4452a63831cbd09$var$o.indexOf(s), u = (d ? s : e[1]).trim(), p = {
                    attrs: Z(u, e[2]),
                    noInnerParse: d,
                    tag: u
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? p.text = e[3] : p.children = a(t, l, n), n.inAnchor = !1, p;
            },
            render: (e, n, r)=>d(e.tag, $a4452a63831cbd09$var$t({
                    key: r.key
                }, e.attrs), e.text || n(e.children, r))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: Z(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $a4452a63831cbd09$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlComment]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$T),
            order: 1,
            parse: ()=>({}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.image]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$Ee),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $a4452a63831cbd09$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.link]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$Se),
            order: 3,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$Ne(t, e[1], n),
                    target: $a4452a63831cbd09$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor ? null : $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $a4452a63831cbd09$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                };
            }
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.orderedList]: $a4452a63831cbd09$var$ve(d, 1),
        [$a4452a63831cbd09$export$e0aa44767d8750d5.unorderedList]: $a4452a63831cbd09$var$ve(d, 2),
        [$a4452a63831cbd09$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$k),
            order: 3,
            parse: $a4452a63831cbd09$var$Pe,
            render: ()=>"\n"
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.paragraph]: {
            match: $a4452a63831cbd09$var$Ie,
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.ref]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$N),
            order: 0,
            parse: (e)=>(Q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.refImage]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(Q[e.ref].target, "img", "src"),
                    title: Q[e.ref].title
                }) : null
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.refLink]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: t(e[0].replace($a4452a63831cbd09$var$P, "\\$1"), n),
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(Q[e.ref].target, "a", "href"),
                    title: Q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, t(e.fallbackChildren, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.table]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$j),
            order: 1,
            parse: $a4452a63831cbd09$var$Ae,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $a4452a63831cbd09$var$Te(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $a4452a63831cbd09$var$Te(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.text]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$te),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($a4452a63831cbd09$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textBolded]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$X),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textEmphasized]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$J),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textEscaped]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$ee),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textMarked]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$K),
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$Y),
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete V[$a4452a63831cbd09$export$e0aa44767d8750d5.htmlBlock], delete V[$a4452a63831cbd09$export$e0aa44767d8750d5.htmlSelfClosing]);
    const ie = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [], a = "";
            for(; r;){
                let o = 0;
                for(; o < t.length;){
                    const c = t[o], s = e[c], d = s.match(r, i, a);
                    if (d) {
                        const e = d[0];
                        r = r.substring(e.length);
                        const t = s.parse(d, n, i);
                        null == t.type && (t.type = c), l.push(t), a = e;
                        break;
                    }
                    o++;
                }
            }
            return l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($a4452a63831cbd09$var$x, "\n").replace($a4452a63831cbd09$var$S, "").replace($a4452a63831cbd09$var$W, "    ");
            }(e), t);
        };
    }(V), le = (ae = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(V, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return ae(t, e, n);
    });
    var ae;
    const oe = G(n);
    return q.length ? d("div", null, oe, d("footer", {
        key: "footer"
    }, q.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $a4452a63831cbd09$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, le(ie(e.footnote, {
            inline: !0
        })));
    }))) : oe;
}
var $a4452a63831cbd09$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $a4452a63831cbd09$var$n);
    return $42omo.cloneElement($a4452a63831cbd09$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("aeAfU", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $g68Gk = parcelRequire("g68Gk");


var $7Rqpr = parcelRequire("7Rqpr");


var $8ihu7 = parcelRequire("8ihu7");

function $92366aa0166a9d31$var$expValInternal({ experimentName: experimentName, experimentParam: experimentParam, defaultValue: defaultValue, fireExperimentExposure: fireExperimentExposure }) {
    const experimentConfig = (0, $7Rqpr.editorExperimentsConfig)[experimentName];
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $8ihu7._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $8ihu7._overrides)[experimentName];
    // Check for parameter overrides
    const paramOverride = (0, $8ihu7._paramOverrides)[experimentName]?.[experimentParam];
    if (paramOverride !== undefined) return paramOverride;
    // If client is not initialized, we return the default value
    if (!(0, $c6GJD.default).initializeCompleted()) return defaultValue;
    if (!(0, $8ihu7._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return defaultValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $8ihu7._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $c6GJD.default).getExperimentValue(experimentName, experimentParam, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $c6GJD.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting_expval', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $g68Gk.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
}
function $92366aa0166a9d31$export$9db1624a8af791a4(experimentName, experimentParam, defaultValue) {
    return $92366aa0166a9d31$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: true
    });
} /**
 * Use to check a any param value for an experiment without firing an exposure event
 *
 * **Note**: this will return the default value when the experiment;
 * - is not being served to the client (ie. pre start)
 * - or is not configured in experiments-config
 *
 * @example
 * ```ts
 * const delay = expParamEqualsNoExposure('experiment-name', 'param-name', defaultValue)
 * await new Promise(res => setTimeout(res, delay)
 * ```
 */ 
function $92366aa0166a9d31$export$94f132839aec533f(experimentName, experimentParam, defaultValue) {
    return $92366aa0166a9d31$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: false
    });
}
module.exports["expVal"] = $92366aa0166a9d31$export$9db1624a8af791a4;
module.exports["expValNoExposure"] = $92366aa0166a9d31$export$94f132839aec533f;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("a43ao", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");


var $9gPkz = parcelRequire("9gPkz");


var $3uVVG = parcelRequire("3uVVG");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");


var $bIll3 = parcelRequire("bIll3");


var $226XV = parcelRequire("226XV");


var $9oOnT = parcelRequire("9oOnT");


var $7DSoa = parcelRequire("7DSoa");

const $35a2bf75aa5e3412$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $7DSoa.default)();
    const invokeClientAction = (0, $9oOnT.default)({});
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $42omo.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $5TXU5.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $42omo.useCallback)((metadataStatus)=>{
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $42omo.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $42omo.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $42omo.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $226XV.getDefinitionId)(details);
        if (definitionId) (0, $226XV.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $42omo.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $42omo.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $226XV.getDefinitionId)(details);
        const extensionKey = (0, $226XV.getExtensionKey)(details);
        const services = (0, $226XV.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $3uVVG.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $bIll3.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $bIll3.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $42omo.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $42omo.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};
module.exports["useSmartCardActions"] = $35a2bf75aa5e3412$export$f7c340395f31e832;

});

parcelRegister("3uVVG", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => (parcelRequire("uvNb9")).AuthError);

var $uvNb9 = parcelRequire("uvNb9");


var $9P47v = parcelRequire("9P47v");

function $81514351a4f15f99$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $9P47v.isOfTypeAuthError)(errorType)) reject(new (0, $uvNb9.AuthError)(data.message, errorType));
                    else reject(new (0, $uvNb9.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $uvNb9.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}
module.exports["auth"] = $81514351a4f15f99$export$73693bad9f5880b0;

});

parcelRegister("uvNb9", function(module, exports) {
class $2c5766e42a4da15d$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}
module.exports["AuthError"] = $2c5766e42a4da15d$export$145273558d58e0ac;

});

parcelRegister("9P47v", function(module, exports) {
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $cd3cb472abe3f4ba$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};
module.exports["isOfTypeAuthError"] = $cd3cb472abe3f4ba$export$400e64c8451aa84f;

});

parcelRegister("226XV", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $15C2j = parcelRequire("15C2j");

const $c8f51fccdd166527$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $c8f51fccdd166527$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $15C2j.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $c8f51fccdd166527$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $c8f51fccdd166527$export$218d96312e385949 = (details)=>details?.meta?.key;
const $c8f51fccdd166527$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $c8f51fccdd166527$export$e029950864672b4 = (details)=>{
    if ((0, $dh538.fg)('platform_smartlink_3pclick_analytics')) {
        if (details?.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
        if (details?.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
            const ari = details.data['atlassian:ari'];
            if (ari.includes('ari:third-party')) return ari;
        }
    }
    return undefined;
};
const $c8f51fccdd166527$export$48b4e58cdb8031ba = ()=>{
    if (!(0, $dh538.fg)('platform_smartlink_3pclick_analytics')) return undefined;
    const product = $c8f51fccdd166527$var$getProductFromWindowURL();
    const currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            const contentId = $c8f51fccdd166527$var$extractContentIdFromURL(currentURL);
            if (contentId) return `ConfluenceContentId:${contentId}`;
        }
        const pageId = $c8f51fccdd166527$var$extractPageIdFromURL(currentURL);
        if (pageId) return `ConfluencePageId:${pageId}`;
    } else if (product === 'jira') {
        const issueKey = $c8f51fccdd166527$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return `JiraIssueKey:${issueKey}`;
    }
    return undefined;
};
const $c8f51fccdd166527$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $c8f51fccdd166527$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $c8f51fccdd166527$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $c8f51fccdd166527$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $c8f51fccdd166527$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $c8f51fccdd166527$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $c8f51fccdd166527$export$ac5d414b1ebfab5a = (details)=>details && $c8f51fccdd166527$export$cd41ae544cfc2a65(details) && $c8f51fccdd166527$export$795910f5f15a9633(details);
const $c8f51fccdd166527$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $c8f51fccdd166527$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $c8f51fccdd166527$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $c8f51fccdd166527$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $c8f51fccdd166527$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $c8f51fccdd166527$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $c8f51fccdd166527$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $c8f51fccdd166527$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;
// Helper function to extract page ID from standard Confluence page URLs
const $c8f51fccdd166527$var$extractPageIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        const pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        const pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        const displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $c8f51fccdd166527$var$extractContentIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        const contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        const match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $c8f51fccdd166527$var$extractJiraIssueIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        const browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        const jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        const selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        const issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch  {
        return undefined;
    }
    return undefined;
};
const $c8f51fccdd166527$var$getProductFromWindowURL = ()=>{
    try {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const hostname = urlObj.hostname.toLowerCase();
        const pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["getByDefinitionId"] = $c8f51fccdd166527$export$f75b0b690ab4dfb9;
module.exports["getClickUrl"] = $c8f51fccdd166527$export$cf3c5acf9e9d0f02;
module.exports["getDefinitionId"] = $c8f51fccdd166527$export$46fa3e7718c82e41;
module.exports["getExtensionKey"] = $c8f51fccdd166527$export$218d96312e385949;
module.exports["getObjectAri"] = $c8f51fccdd166527$export$81164c1570bcd038;
module.exports["getThirdPartyARI"] = $c8f51fccdd166527$export$e029950864672b4;
module.exports["getFirstPartyIdentifier"] = $c8f51fccdd166527$export$48b4e58cdb8031ba;
module.exports["getObjectName"] = $c8f51fccdd166527$export$5615361d76a8be5;
module.exports["getObjectIconUrl"] = $c8f51fccdd166527$export$bcf275804417edda;
module.exports["getResourceType"] = $c8f51fccdd166527$export$16c0ebb0de9b767b;
module.exports["getServices"] = $c8f51fccdd166527$export$a009e3a1163d46fb;
module.exports["isFinalState"] = $c8f51fccdd166527$export$d590d08942abc17a;
module.exports["hasAuthScopeOverrides"] = $c8f51fccdd166527$export$3f9446bb21b945a0;

});

parcelRegister("15C2j", function(module, exports) {
const $4a791b5829124355$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};
module.exports["extractVisitUrl"] = $4a791b5829124355$export$c81497d3681f24f4;

});

parcelRegister("hcMBV", function(module, exports) {
var $87ac0097385af1df$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});
module.exports["CardAction"] = $87ac0097385af1df$export$f40b7e0b762b928b;

});

parcelRegister("I1nNR", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $chRg6 = parcelRequire("chRg6");

const $7834fba73424be0b$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $chRg6.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $42omo.useState)();
    const locale = (0, $42omo.useMemo)(()=>(0, $chRg6.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $42omo.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $chRg6.DEFAULT_LOCALE),
        children: children
    });
};
module.exports["I18nProvider"] = $7834fba73424be0b$export$a54013f0d02a8f82;

});

parcelRegister("chRg6", function(module, exports) {
const $22ba11b592de8836$var$DEFAULT_LANGUAGE = 'en';
const $22ba11b592de8836$var$DEFAULT_REGION = 'US';
const $22ba11b592de8836$export$1af4c7e47ad72f44 = `${$22ba11b592de8836$var$DEFAULT_LANGUAGE}-${$22ba11b592de8836$var$DEFAULT_REGION}`;
const $22ba11b592de8836$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $22ba11b592de8836$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $22ba11b592de8836$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $22ba11b592de8836$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $22ba11b592de8836$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $22ba11b592de8836$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $22ba11b592de8836$export$dca0327c9b9c6498;

});

parcelRegister("cGc86", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $diaaX = parcelRequire("diaaX");

const $b9b017651fce2f05$var$UniqueKeyContext = /*#__PURE__*/ (0, $42omo.createContext)({
    uniqueKey: undefined
});
const $b9b017651fce2f05$export$71829d27b87a2006 = ({ children: children })=>{
    const uniqueKey = (0, $42omo.useMemo)(()=>(0, $diaaX.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($b9b017651fce2f05$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        },
        children: children
    });
};
const $b9b017651fce2f05$export$cef64a0cfb90e369 = ()=>{
    return (0, $42omo.useContext)($b9b017651fce2f05$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $b9b017651fce2f05$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $b9b017651fce2f05$export$cef64a0cfb90e369;

});

parcelRegister("kudeD", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $khmAd = parcelRequire("khmAd");


var $4icDV = parcelRequire("4icDV");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $0a26766864270169$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $0a26766864270169$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $0a26766864270169$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $42omo.useState)(contentType);
    const isInitialized = (0, $42omo.useRef)(true);
    const iframeLoadMetrics = (0, $42omo.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $42omo.useRef)();
    (0, $42omo.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $khmAd.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $42omo.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $khmAd.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $42omo.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $42omo.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        },
        children: children
    });
};
const $0a26766864270169$export$865423e6f8e2e839 = ()=>{
    return (0, $42omo.useContext)($0a26766864270169$var$PerformanceMetricsContext);
};
const $0a26766864270169$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $0a26766864270169$export$865423e6f8e2e839();
    (0, $42omo.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["usePerformanceMetrics"] = $0a26766864270169$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $0a26766864270169$export$c6f19d9afc6c86c8;

});

parcelRegister("khmAd", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");


var $j4jXg = parcelRequire("j4jXg");

const $078bd495543d458c$export$4de078c3b9971f9b = ()=>(0, $kyiqo.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $078bd495543d458c$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $078bd495543d458c$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    }
};
const $078bd495543d458c$export$a23245993532c751 = (contentType)=>(0, $kyiqo.metrics).pageSegmentLoad($078bd495543d458c$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $078bd495543d458c$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $078bd495543d458c$export$a23245993532c751;

});

parcelRegister("3WsBD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j6S25 = parcelRequire("j6S25");


var $dh538 = parcelRequire("dh538");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");


var $hpNab = parcelRequire("hpNab");


var $8C5kA = parcelRequire("8C5kA");


var $cezNv = parcelRequire("cezNv");


var $cGc86 = parcelRequire("cGc86");

const $5a8d62fce039da42$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $j6S25.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $5a8d62fce039da42$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $5a8d62fce039da42$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $42omo.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $42omo.useMemo)(()=>allowedFeatures === 'all' ? (0, $hpNab.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature)=>feature !== 'edit' && feature !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature)=>!$5a8d62fce039da42$var$nonAllFeatures.includes(feature)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature)=>(0, $cezNv.isRedirectionEnabled)(feature)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $cezNv.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $8C5kA.default)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const queryParams = (0, $42omo.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $5a8d62fce039da42$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey && (0, $dh538.fg)('platform_deprecate_lp_cc_embed')) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        return `?${new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery,
            ...contentConfiguration?.queryParams
        }).toString()}`;
    }, [
        contentConfiguration,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...$5a8d62fce039da42$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $5a8d62fce039da42$var$CONTEXT_PATH = '/wiki/spaces';
const $5a8d62fce039da42$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $5a8d62fce039da42$var$constructUrl(mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$5a8d62fce039da42$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$5a8d62fce039da42$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $5a8d62fce039da42$export$6e43e60d51b79331;
module.exports["useUrl"] = $5a8d62fce039da42$export$305222dff575c4e3;

});

parcelRegister("cezNv", function(module, exports) {
const $d21a741e0de1277a$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch (error) {
        return false;
    }
    return false;
};
const $d21a741e0de1277a$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch (error) {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isRedirectionEnabled"] = $d21a741e0de1277a$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $d21a741e0de1277a$export$243fbba563b8aa8e;

});

parcelRegister("7Vxvp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fVUfS = parcelRequire("fVUfS");


var $aeAfU = parcelRequire("aeAfU");

const $fee91c6d88bcaa54$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syazi7uo _80omtlke _bfhki8nm _irr3plhp _1di61gdz",
    disabled: "_syaz1gmx _80om13gf _bfhkby5v"
};
const $fee91c6d88bcaa54$var$experimentEnabledStyles = {
    control: "_syazi7uo _80omtlke _bfhki8nm _irr3plhp _1di61gdz",
    test1: "_syaz15cr _80omtlke _bfhkjmqp _qrwqlb4i _1o0zlb4i _13lilb4i _mrkblb4i _ca0qt94y _n3tdt94y _2hwxt94y _k48pi7a9 _irr31q28 _1di612kk",
    test2: "_syaz15cr _80omtlke _bfhk1i45 _qrwqlb4i _1o0zlb4i _irr3byip _1di61van"
};
const $fee91c6d88bcaa54$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, isDisabled: isDisabled, viewType: viewType = 'default', ...props }, ref)=>{
    const experimentValue = viewType === 'unauthorised' ? (0, $aeAfU.expVal)('platform_inline_smartcard_connect_button_exp', 'cohort', 'control') : 'control';
    return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $fee91c6d88bcaa54$var$styles.button
    }, /*#__PURE__*/ $42omo.createElement("span", {
        tabIndex: isDisabled ? undefined : 0,
        className: (0, $gMc0m.default)([
            $fee91c6d88bcaa54$var$styles.innerContainer,
            isDisabled ? $fee91c6d88bcaa54$var$styles.disabled : experimentValue !== 'control' ? $fee91c6d88bcaa54$var$experimentEnabledStyles[experimentValue] : $fee91c6d88bcaa54$var$styles.enabled
        ])
    }, children));
});
module.exports["ActionButton"] = $fee91c6d88bcaa54$export$cfc7921d29ef7b80;

});

parcelRegister("dLAsE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $lgqac = parcelRequire("lgqac");

function $ff5fb1232cd87c62$export$ed70996d478e16d3() {
    /**
	 * this utility maybe extended in the future to include
	 * more contextual info about SLs
	 */ const events = (0, $42omo.useMemo)(()=>new (0, $lgqac.SmartLinkEvents)(), []);
    return events;
}
function $ff5fb1232cd87c62$export$e682245dc886cff2(firstPartyIdentifier, thirdPartyARI) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return ()=>{
        const smartlinkClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
            eventType: 'ui',
            attributes: {
                eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                firstPartyIdentifier: firstPartyIdentifier
            },
            nonPrivacySafeAttributes: {
                thirdPartyARI: thirdPartyARI
            }
        });
        smartlinkClickAnalyticsEvent.fire('media');
    };
}
module.exports["useSmartLinkEvents"] = $ff5fb1232cd87c62$export$ed70996d478e16d3;
module.exports["useFire3PWorkflowsClickEvent"] = $ff5fb1232cd87c62$export$e682245dc886cff2;

});

parcelRegister("9ISlX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kVnOi = parcelRequire("kVnOi");

class $d6477c19fa37ad04$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        };
        this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + (0, $kVnOi.embedHeaderHeight);
            onHeightUpdate(height);
        };
    }
}
module.exports["EmbedResizeMessageListener"] = $d6477c19fa37ad04$export$3482036c37e627f4;

});

parcelRegister("9CM6e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $dQl1W = parcelRequire("dQl1W");


var $bYRk6 = parcelRequire("bYRk6");


var $dh538 = parcelRequire("dh538");


var $lgqac = parcelRequire("lgqac");


var $aylI0 = parcelRequire("aylI0");


var $5Tie7 = parcelRequire("5Tie7");

const $21c8f9d8a5ab2bc3$export$7b5e1b7f9a325b6 = (props)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $42omo.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))());
    const cardProps = {
        ...props,
        id: id
    };
    const ErrorFallbackComponent = cardProps.fallbackComponent;
    const errorBoundaryFallbackComponent = ()=>{
        if (ErrorFallbackComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ErrorFallbackComponent, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Tie7.LoadingCardLink), cardProps);
    };
    if ((0, $dh538.fg)('platform_editor_inline_card_selected_state_fix')) {
        const Component = cardProps.appearance === 'inline' ? 'span' : 'div';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
            data: (0, $lgqac.context)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
            FallbackComponent: errorBoundaryFallbackComponent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            className: "loader-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aylI0.CardWithUrlContent), cardProps))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: (0, $lgqac.context)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: errorBoundaryFallbackComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aylI0.CardWithUrlContent), cardProps)));
};
module.exports["CardSSR"] = $21c8f9d8a5ab2bc3$export$7b5e1b7f9a325b6;

});

parcelRegister("6CRn4", function(module, exports) {
$parcel$export(module.exports, "default", () => $5311f5d282e4b997$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $gxsT9 = parcelRequire("gxsT9");


var $gAARK = parcelRequire("gAARK");


var $kfJSC = parcelRequire("kfJSC");


var $lqWNh = parcelRequire("lqWNh");


var $1OLls = parcelRequire("1OLls");

function $5311f5d282e4b997$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, isInRenderer: isInRenderer = false }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $lqWNh.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    if (mediaSingleWidth) {
        const pxWidth = (0, $kfJSC.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $aFUXX.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH) - (0, $aFUXX.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $1OLls.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isInRenderer: isInRenderer && (0, $dh538.fg)('media-perf-uplift-mutation-fix')
        }),
        ...!(0, $dh538.fg)('platform_editor_fix_media_in_renderer') ? {} : {
            'data-layout': layout
        },
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $gxsT9.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1OLls.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});

parcelRegister("kfJSC", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $aFUXX = parcelRequire("aFUXX");


var $iu6m9 = parcelRequire("iu6m9");


var $lqWNh = parcelRequire("lqWNh");


var $gAARK = parcelRequire("gAARK");

function $7eac1e1fe0a5dbb7$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
const $7eac1e1fe0a5dbb7$export$5091b2c0d1cd2361 = ({ width: width, widthType: widthType = 'percentage', origWidth: origWidth, layout: layout, contentWidth: contentWidth, containerWidth: containerWidth, gutterOffset: gutterOffset = 0 })=>{
    if (widthType === 'pixel' && width) return width;
    switch(layout){
        case 'wide':
            return $7eac1e1fe0a5dbb7$var$calcLegacyWideWidth(containerWidth, origWidth, contentWidth);
        case 'full-width':
            // legacy and new experience have different definitions of full-width,
            // since it's for new experience, we convert to the new definition
            return $7eac1e1fe0a5dbb7$export$a2e7f6320d796a21(containerWidth);
        default:
            if (width) return Math.ceil(((contentWidth || containerWidth) + gutterOffset) * (width / 100) - gutterOffset);
    }
    // Handle the case of not resized node with wrapped layout
    // It's possible that the node is first inserted with align layout (e.g. jira)
    // in which the legacy image would render the width as min(origWidth, halfContentWidth).
    // However, new experience won't be able to distinguish the two. Thus, we render halfContentWidth
    // to make sure confluence legacy node is renderered correctly
    if ((0, $gAARK.wrappedLayouts).includes(layout)) return Math.ceil((contentWidth || containerWidth) / 2);
    // set initial width for not resized legacy image
    return $7eac1e1fe0a5dbb7$export$4ab195f543459515(origWidth, // in case containerWidth is 0, we fallback to undefined to use akEditorDefaultLayoutWidth
    contentWidth || containerWidth || undefined);
};
/**
 * Calculate pixel width for legacy media single
 * @param contentWidth editor content width
 * @param containerWidth editor container width
 */ const $7eac1e1fe0a5dbb7$var$calcLegacyWideWidth = (containerWidth, origWidth, contentWidth)=>{
    if (contentWidth) {
        const wideWidth = Math.ceil(contentWidth * (0, $aFUXX.breakoutWideScaleRatio));
        return wideWidth > containerWidth ? contentWidth : wideWidth;
    }
    return origWidth;
};
const $7eac1e1fe0a5dbb7$export$a2e7f6320d796a21 = (containerWidth, editorAppearance)=>{
    const fullPagePadding = editorAppearance === 'full-page' && containerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
    const fullWidthPadding = editorAppearance === 'full-page' ? fullPagePadding * 2 : (0, $aFUXX.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $aFUXX.akEditorFullWidthLayoutWidth));
};
const $7eac1e1fe0a5dbb7$export$4ab195f543459515 = (origWidth = (0, $gAARK.DEFAULT_IMAGE_WIDTH), maxWidth = (0, $aFUXX.akEditorDefaultLayoutWidth), minWidth = (0, $gAARK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))=>{
    return Math.max(Math.min(origWidth, maxWidth), minWidth);
};
function $7eac1e1fe0a5dbb7$export$ab1f1890e4428242(insideInlineLike, insideLayout, pmViewDom, wrapper) {
    let offsetLeft = 0;
    if (wrapper && insideInlineLike && !insideLayout) {
        const currentNode = wrapper;
        const boundingRect = currentNode.getBoundingClientRect();
        offsetLeft = boundingRect.left - pmViewDom.getBoundingClientRect().left;
    }
    return offsetLeft;
}
const $7eac1e1fe0a5dbb7$export$f72673597dacfcfa = (value, interval = (0, $gAARK.DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;
const $7eac1e1fe0a5dbb7$export$c7eaa4d46a45395 = (isVideoFile, contentWidth)=>{
    return Math.min(contentWidth, isVideoFile ? (0, $gAARK.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $gAARK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
const $7eac1e1fe0a5dbb7$export$4147ff5cc31ec064 = (view, pos)=>{
    if (typeof pos !== 'number') return null;
    if ((0, $lqWNh.isRichMediaInsideOfBlockNode)(view, pos)) {
        const $pos = view.state.doc.resolve(pos);
        const domNode = view.nodeDOM($pos.pos);
        if ($pos.nodeAfter && (0, $lqWNh.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
        if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    }
    return null;
};
const $7eac1e1fe0a5dbb7$var$calcParentPadding = (view, resolvedPos)=>{
    // since table has constant padding, use hardcoded constant instead of query the dom
    const tablePadding = 8;
    const { tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].includes(resolvedPos.parent.type) ? tablePadding * 2 : 0;
};
const $7eac1e1fe0a5dbb7$export$bcefe8f1d5d7bbf3 = (view, pos, forInsertion)=>{
    if (typeof pos !== 'number') return null;
    const $pos = view.state.doc.resolve(pos);
    if ($pos && $pos.parent.type.name !== 'doc') return forInsertion ? $7eac1e1fe0a5dbb7$export$7cc71489edfd26f8($pos, view) : $7eac1e1fe0a5dbb7$export$4226a56ec6bfa71c($pos, view);
    return null;
};
const $7eac1e1fe0a5dbb7$export$4226a56ec6bfa71c = (resolvedPos, view)=>{
    const domNode = view.nodeDOM(resolvedPos.pos);
    if (resolvedPos.nodeAfter && (0, $lqWNh.floatingLayouts).includes(resolvedPos.nodeAfter.attrs.layout) && domNode && domNode.parentElement) {
        const parentPadding = $7eac1e1fe0a5dbb7$var$calcParentPadding(view, resolvedPos);
        return domNode.parentElement.offsetWidth - parentPadding;
    }
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return null;
};
const $7eac1e1fe0a5dbb7$export$7cc71489edfd26f8 = (resolvedPos, view)=>{
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const parentDomNode = view.nodeDOM(parentPos);
    const parentPadding = $7eac1e1fe0a5dbb7$var$calcParentPadding(view, resolvedPos);
    if (parentDomNode instanceof HTMLElement) return parentDomNode.offsetWidth - parentPadding;
    return null;
};
const $7eac1e1fe0a5dbb7$export$22e4c8c04f58169d = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $ks2lK.NodeSelection)) || selection.node.type !== schema.nodes.mediaSingle) return;
    const pos = selection.$anchor.pos + 1;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.media) return;
    return {
        node: node,
        pos: pos
    };
};
module.exports["getMediaSinglePixelWidth"] = $7eac1e1fe0a5dbb7$export$a6f4ec2edd25b07e;
module.exports["calcMediaSinglePixelWidth"] = $7eac1e1fe0a5dbb7$export$5091b2c0d1cd2361;
module.exports["calcMediaSingleMaxWidth"] = $7eac1e1fe0a5dbb7$export$a2e7f6320d796a21;
module.exports["getMediaSingleInitialWidth"] = $7eac1e1fe0a5dbb7$export$4ab195f543459515;
module.exports["calculateOffsetLeft"] = $7eac1e1fe0a5dbb7$export$ab1f1890e4428242;
module.exports["roundToNearest"] = $7eac1e1fe0a5dbb7$export$f72673597dacfcfa;
module.exports["calcMinWidth"] = $7eac1e1fe0a5dbb7$export$c7eaa4d46a45395;
module.exports["getMaxWidthForNestedNode"] = $7eac1e1fe0a5dbb7$export$4147ff5cc31ec064;
module.exports["getMaxWidthForNestedNodeNext"] = $7eac1e1fe0a5dbb7$export$bcefe8f1d5d7bbf3;
module.exports["currentMediaNodeWithPos"] = $7eac1e1fe0a5dbb7$export$22e4c8c04f58169d;

});

parcelRegister("1OLls", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");


var $lqWNh = parcelRequire("lqWNh");


var $fJNzZ = parcelRequire("fJNzZ");

function $0ef555bed3f3ee7f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $0ef555bed3f3ee7f$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $0ef555bed3f3ee7f$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $aFUXX.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $aFUXX.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $aFUXX.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $0ef555bed3f3ee7f$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $aFUXX.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $aFUXX.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $aFUXX.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $0ef555bed3f3ee7f$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $fJNzZ.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $fJNzZ.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $fJNzZ.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $0ef555bed3f3ee7f$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $0ef555bed3f3ee7f$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $0ef555bed3f3ee7f$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $fJNzZ.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $fJNzZ.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $0ef555bed3f3ee7f$var$getWidthIfFullWidthMode(width, containerWidth) : $0ef555bed3f3ee7f$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $0ef555bed3f3ee7f$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $fJNzZ.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $fJNzZ.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
function $0ef555bed3f3ee7f$var$calcMaxWidth(layout, containerWidth) {
    switch(layout){
        case 'wide':
            return (0, $fJNzZ.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $fJNzZ.calcBreakoutWidth)(layout, containerWidth);
        default:
            return '100%';
    }
}
function $0ef555bed3f3ee7f$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $0ef555bed3f3ee7f$var$calcMaxCssForPercentageTypeMedia(layout) {
    switch(layout){
        case 'wide':
            return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor-max-container-width))`;
        case 'full-width':
            return `min(var(--ak-editor--full-width-layout-width), var(--ak-editor-max-container-width))`;
        default:
            return 'var(--ak-editor-max-container-width)';
    }
}
function $0ef555bed3f3ee7f$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
function $0ef555bed3f3ee7f$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.isInRenderer
 * @example
 */ var $0ef555bed3f3ee7f$var$_ref = {
    name: "1il1ars",
    styles: "@container ak-renderer-wrapper (min-width: 1px){max-width:100cqw;}"
};
var $0ef555bed3f3ee7f$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $0ef555bed3f3ee7f$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, isInRenderer: isInRenderer = false })=>{
    const calculatedWidth = $0ef555bed3f3ee7f$export$c832331b07480714(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? $0ef555bed3f3ee7f$export$d48e8f24f681763e(layout, width || 0, containerWidth) : $0ef555bed3f3ee7f$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const calculatedMaxWidth = $0ef555bed3f3ee7f$export$c832331b07480714(isExtendedResizeExperienceOn ? `${containerWidth}px` : $0ef555bed3f3ee7f$var$calcMaxWidth(layout, containerWidth));
    const cssMaxWidth = isExtendedResizeExperienceOn ? 'var(--ak-editor-max-container-width)' : $0ef555bed3f3ee7f$var$calcMaxCssForPercentageTypeMedia(layout);
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $9K4OG.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $0ef555bed3f3ee7f$var$_ref2, " ", isInRenderer ? $0ef555bed3f3ee7f$var$_ref : (0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true) ? `max-width: ${cssMaxWidth};` : `max-width: ${calculatedMaxWidth};`, " ", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $lqWNh.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $0ef555bed3f3ee7f$var$float(layout), ";margin:", $0ef555bed3f3ee7f$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $lqWNh.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $0ef555bed3f3ee7f$var$isImageAligned(layout), ";");
};
const $0ef555bed3f3ee7f$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $9K4OG.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $0ef555bed3f3ee7f$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $9K4OG.css)("position:relative;", $0ef555bed3f3ee7f$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;>div{position:absolute;height:100%;}}");
const $0ef555bed3f3ee7f$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $0ef555bed3f3ee7f$export$9e3fd9f6215dd7b6(rest)
    }, children);
$0ef555bed3f3ee7f$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $0ef555bed3f3ee7f$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '1px'
        }
    });
};
module.exports["MediaSingleDimensionHelper"] = $0ef555bed3f3ee7f$export$2b2737a2ef2f5b46;
module.exports["MediaWrapper"] = $0ef555bed3f3ee7f$export$542000db99cecf28;
module.exports["MediaBorderGapFiller"] = $0ef555bed3f3ee7f$export$e18e95249d813157;

});

parcelRegister("fBAKC", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $7850275dc402dd65$var$LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("69fUv")));
const $7850275dc402dd65$export$f386473e8f104bcb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7850275dc402dd65$var$LazyDatasourceRenderFailedAnalyticsWrapper, props));
module.exports["LazyLoadedDatasourceRenderFailedAnalyticsWrapper"] = $7850275dc402dd65$export$f386473e8f104bcb;

});

parcelRegister("69fUv", function(module, exports) {

let $479fecd0aea59d37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $479fecd0aea59d37$var$load("koKgZ").then(()=>parcelRequire('7Fmwh'));

});

parcelRegister("h8cpw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $eIleF = parcelRequire("eIleF");


var $1oCLl = parcelRequire("1oCLl");


var $kKODE = parcelRequire("kKODE");


var $eB2Ls = parcelRequire("eB2Ls");


var $4gOU2 = parcelRequire("4gOU2");


var $dOvUN = parcelRequire("dOvUN");


var $afp1H = parcelRequire("afp1H");


var $bz6dj = parcelRequire("bz6dj");


var $9oOnT = parcelRequire("9oOnT");


var $7DSoa = parcelRequire("7DSoa");


var $lz9QA = parcelRequire("lz9QA");

function $4a6a130a5859a503$export$a95296ded9241771({ url: url, appearance: appearance, origin: origin, actionOptions: actionOptions, prefetch: prefetch }) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))(), []);
    const linkState = (0, $lz9QA.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $eIleF.useSmartLinkContext)();
    const invokeClientAction = (0, $9oOnT.default)({
        fireEvent: fireEvent
    });
    const resolve = (0, $7DSoa.default)();
    if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && prefetch && !linkState.details) resolve(url);
    if (linkState.details && !actionOptions?.hide) {
        const actions = [];
        const invokeParam = {
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: linkState.details
        };
        const downloadActionProps = (0, $eB2Ls.extractInvokeDownloadAction)(invokeParam);
        if (downloadActionProps) actions.push((0, $bz6dj.toAction)(downloadActionProps, invokeClientAction, (0, $afp1H.messages).download, 'download-content'));
        const viewActionProps = (0, $dOvUN.extractInvokeViewAction)(invokeParam);
        if (viewActionProps) actions.push((0, $bz6dj.toAction)(viewActionProps, invokeClientAction, (0, $afp1H.messages).view, 'view-content'));
        const previewActionProps = (0, $4gOU2.extractInvokePreviewAction)({
            ...invokeParam,
            fireEvent: fireEvent,
            origin: origin,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        });
        if (previewActionProps) actions.push((0, $bz6dj.toAction)(previewActionProps.invokeAction, invokeClientAction, (0, $afp1H.messages).preview_improved, 'preview-content'));
        return actions;
    }
    return [];
}
module.exports["useSmartLinkActions"] = $4a6a130a5859a503$export$a95296ded9241771;

});

parcelRegister("bz6dj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

const $2752aec5c6b5a722$export$9d52be0dab870c7 = (action, invokeClientAction, message, id)=>{
    return {
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), message),
        invoke: ()=>invokeClientAction(action)
    };
};
module.exports["toAction"] = $2752aec5c6b5a722$export$9d52be0dab870c7;

});

parcelRegister("7FiWH", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $8C5kA = parcelRequire("8C5kA");


var $ks2lK = parcelRequire("ks2lK");


var $aFUXX = parcelRequire("aFUXX");


var $lOzEN = parcelRequire("lOzEN");


var $8tdj3 = parcelRequire("8tdj3");


var $jypE9 = parcelRequire("jypE9");


var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");


var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $iGbqR = parcelRequire("iGbqR");

var $d925B = parcelRequire("d925B");


var $3RxtY = parcelRequire("3RxtY");

function $f7a722354e8e82d7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Dynamic padding value that adjusts based on the editor's base font size.
 * When base font size is <= akEditorFullPageDenseFontSize (13px), uses 1px padding.
 * Otherwise, uses default value with token('space.025').
 */ const $f7a722354e8e82d7$var$DYNAMIC_PADDING_BLOCK = `clamp(1px, calc((var(--ak-editor-base-font-size, ${(0, $aFUXX.akEditorFullPageDefaultFontSize)}px) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px) * 999), ${"var(--ds-space-025, 2px)"})`;
const $f7a722354e8e82d7$var$containerStylesOld = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $f7a722354e8e82d7$var$containerStyles = {
    name: "s1rv5c",
    styles: "position:relative;white-space:nowrap"
};
const $f7a722354e8e82d7$var$iconWrapperStylesOld = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '17px',
    width: '17px'
});
const $f7a722354e8e82d7$var$iconWrapperStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $f7a722354e8e82d7$var$hiddenTextStyle = {
    name: "1hr6gib",
    styles: "overflow:hidden;white-space:nowrap;position:absolute;visibility:hidden"
};
const $f7a722354e8e82d7$var$linkStylesCommon = (0, $ecnYn.xcss)({
    position: 'absolute',
    left: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingBlock: 'space.025',
    paddingInline: 'space.050',
    gap: 'space.025',
    overflow: 'hidden',
    zIndex: 'card',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text.subtle',
        textDecoration: 'none'
    }
});
const $f7a722354e8e82d7$var$linkStylesOld = (0, $ecnYn.xcss)({
    top: '-1px'
});
const $f7a722354e8e82d7$var$linkStylesHeightFix = (0, $ecnYn.xcss)({
    top: '0px',
    height: '1.2em'
});
const $f7a722354e8e82d7$var$linkStylesNewWithHeightFix = (0, $ecnYn.xcss)({
    top: '0px',
    visibility: 'hidden',
    height: '1.2em'
});
const $f7a722354e8e82d7$var$linkStylesVisible = (0, $ecnYn.xcss)({
    visibility: 'visible'
});
const $f7a722354e8e82d7$var$iconAndLabelStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    gap: 'space.025'
});
const $f7a722354e8e82d7$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY = 45;
const $f7a722354e8e82d7$var$ICON_WIDTH = 16;
const $f7a722354e8e82d7$var$DEFAULT_OPEN_TEXT_WIDTH = 28; // Default open text width in English
const $f7a722354e8e82d7$var$MIN_CARD_WIDTH_NOT_COVERED_BY_OVERLAY = 30;
const $f7a722354e8e82d7$var$visitCardLinkAnalytics = (editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $ks2lK.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $iGbqR.buildVisitedNonHyperLinkPayload)(type.name, inputMethod))(tr);
            dispatch(tr);
        }
        return true;
    };
const $f7a722354e8e82d7$var$HoverLinkOverlayOriginal = ({ children: children, isVisible: isVisible = false, url: url, compactPadding: compactPadding = false, editorAnalyticsApi: editorAnalyticsApi, view: view, onClick: onClick, showPanelButton: showPanelButton = false, showPanelButtonIcon: showPanelButtonIcon })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const containerRef = (0, $42omo.useRef)(null);
    const hoverLinkButtonRef = (0, $42omo.useRef)(null);
    const hiddenTextRef = (0, $42omo.useRef)(null);
    const [showLabel, setShowLabel] = (0, $42omo.useState)(true);
    const [isHovered, setHovered] = (0, $42omo.useState)(false);
    const openTextWidthRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!isVisible || !isHovered) return;
        const cardWidth = containerRef.current?.offsetWidth;
        const openButtonWidth = hoverLinkButtonRef.current?.offsetWidth;
        // Get the hidden text width
        if (!openTextWidthRef.current) {
            const hiddenText = hiddenTextRef.current;
            if (hiddenText) {
                // Measure the width of the hidden text
                // Temporarily make the element visible to measure its width
                hiddenText.style.visibility = 'hidden';
                hiddenText.style.display = 'inline';
                openTextWidthRef.current = hiddenText.offsetWidth;
                // Reset the hiddenText's display property
                hiddenText.style.display = 'none';
                hiddenText.style.visibility = 'inherit';
            } else openTextWidthRef.current = $f7a722354e8e82d7$var$DEFAULT_OPEN_TEXT_WIDTH;
        }
        if (!cardWidth || !openButtonWidth) return;
        const openTextWidth = openTextWidthRef.current || $f7a722354e8e82d7$var$DEFAULT_OPEN_TEXT_WIDTH;
        let canShowLabel = cardWidth - openTextWidth > $f7a722354e8e82d7$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY + $f7a722354e8e82d7$var$ICON_WIDTH;
        // When a smart link wraps to multiple lines in a constrained container (e.g. table cell),
        // the hover button can overflow beyond the container bounds. We detect this by comparing
        // the button's right edge to the container's right edge, and hide the label if it overflows.
        if ((0, $iu6m9.editorExperiment)('cc_editor_hover_link_overlay_css_fix', true)) {
            if (containerRef.current && hoverLinkButtonRef.current) {
                const containerRight = containerRef.current.getBoundingClientRect().right;
                const buttonRight = hoverLinkButtonRef.current.getBoundingClientRect().right;
                if (buttonRight > containerRight) canShowLabel = false;
            }
        }
        setShowLabel(canShowLabel);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
        // Reset label visibility on hover start so we can measure if it overflows.
        // Without this, the label stays hidden from a previous hover and won't be re-measured.
        if ((0, $iu6m9.editorExperiment)('cc_editor_hover_link_overlay_css_fix', true)) {
            if (isHovered) setShowLabel(true);
        }
    };
    const sendVisitLinkAnalytics = (inputMethod)=>{
        if (editorAnalyticsApi && view) $f7a722354e8e82d7$var$visitCardLinkAnalytics(editorAnalyticsApi, inputMethod)(view.state, view.dispatch);
    };
    const handleDoubleClick = ()=>{
        if (!showPanelButton) {
            sendVisitLinkAnalytics((0, $d925B.INPUT_METHOD).DOUBLE_CLICK);
            // Double click opens the link in a new tab
            window.open(url, '_blank');
        }
    };
    const handleClick = (event)=>{
        if (showPanelButton && onClick) onClick(event);
        else sendVisitLinkAnalytics((0, $d925B.INPUT_METHOD).BUTTON);
    };
    const isPreviewButton = showPanelButton && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true);
    const label = isPreviewButton ? formatMessage((0, $3RxtY.messages).previewButtonTitle) : formatMessage((0, $3RxtY.messages).openButtonTitle);
    let icon = null;
    if (isPreviewButton && showPanelButtonIcon === 'panel') icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jypE9))), {
        label: ""
    });
    else if (isPreviewButton && showPanelButtonIcon === 'modal') icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))), {
        label: ""
    });
    else icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        label: ""
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ref: containerRef,
        css: $f7a722354e8e82d7$var$containerStylesOld,
        onDoubleClick: handleDoubleClick,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: ()=>handleOverlayChange(true),
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: ()=>handleOverlayChange(false)
    }, children, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $f7a722354e8e82d7$var$hiddenTextStyle,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        ref: hiddenTextRef,
        size: "small",
        maxLines: 1
    }, label)), isHovered && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fpGTa.default), {
        ref: hoverLinkButtonRef,
        xcss: [
            $f7a722354e8e82d7$var$linkStylesCommon,
            (0, $1oCLl.expValEquals)('platform_editor_hoverlink_ui_fixes_exp', 'cohort', 'css_changes_only') ? $f7a722354e8e82d7$var$linkStylesHeightFix : $f7a722354e8e82d7$var$linkStylesOld
        ],
        href: url,
        target: "_blank",
        style: {
            paddingBlock: compactPadding ? '1px' : (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? $f7a722354e8e82d7$var$DYNAMIC_PADDING_BLOCK : "var(--ds-space-025, 2px)"
        },
        onClick: handleClick,
        testId: "inline-card-hoverlink-overlay"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $f7a722354e8e82d7$var$iconWrapperStylesOld,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height",
        testId: "inline-card-hoverlink-overlay-icon"
    }, icon), showLabel && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1,
        testId: "inline-card-hoverlink-overlay-label"
    }, label)));
};
const $f7a722354e8e82d7$var$HoverLinkOverlayNew = ({ children: children, isVisible: isVisible = false, url: url, compactPadding: compactPadding = false, editorAnalyticsApi: editorAnalyticsApi, view: view, onClick: onClick, showPanelButton: showPanelButton = false, showPanelButtonIcon: showPanelButtonIcon })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const containerRef = (0, $42omo.useRef)(null);
    const iconRef = (0, $42omo.useRef)(null);
    const iconLeftRef = (0, $42omo.useRef)(0);
    const iconAndLabelRef = (0, $42omo.useRef)(null);
    const minMaxWidthRef = (0, $42omo.useRef)();
    const [showLabel, setShowLabel] = (0, $42omo.useState)(false);
    const [isHovered, setHovered] = (0, $42omo.useState)(false);
    const [showOverlay, setShowOverlay] = (0, $42omo.useState)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!isVisible && !isHovered) return;
        if (!containerRef.current) return;
        if (iconRef.current && iconAndLabelRef.current) {
            const iconRect = iconRef.current.getBoundingClientRect();
            iconLeftRef.current = iconRect.left;
            minMaxWidthRef.current = {
                min: iconRect.width,
                max: iconAndLabelRef.current.getBoundingClientRect().width
            };
        }
        if (!iconLeftRef.current || !minMaxWidthRef.current) return;
        const containerDomRect = containerRef.current.getBoundingClientRect();
        const containerStyles = getComputedStyle(containerRef.current);
        const containerHeight = containerDomRect.height - parseFloat(containerStyles.paddingTop) - parseFloat(containerStyles.paddingBottom) - parseFloat(containerStyles.borderTopWidth) - parseFloat(containerStyles.borderBottomWidth);
        const oneLine = parseFloat(containerStyles.lineHeight) >= containerHeight;
        const firstLineWidth = containerDomRect.right - iconLeftRef.current;
        // We don't want HoverLinkOverlay to cover the entire card if it is oneline. It allows the user to click on the card itself.
        const reservedWidth = oneLine ? $f7a722354e8e82d7$var$MIN_CARD_WIDTH_NOT_COVERED_BY_OVERLAY : 0;
        const availableWidth = firstLineWidth - reservedWidth;
        // True when icon and label can be shown
        setShowLabel(availableWidth >= minMaxWidthRef.current.max);
        // True when at least an icon can be shown
        setShowOverlay(availableWidth >= minMaxWidthRef.current.min);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
    };
    const sendVisitLinkAnalytics = (inputMethod)=>{
        if (editorAnalyticsApi && view) $f7a722354e8e82d7$var$visitCardLinkAnalytics(editorAnalyticsApi, inputMethod)(view.state, view.dispatch);
    };
    const handleDoubleClick = ()=>{
        if (!showPanelButton) {
            sendVisitLinkAnalytics((0, $d925B.INPUT_METHOD).DOUBLE_CLICK);
            // Double click opens the link in a new tab
            window.open(url, '_blank');
        }
    };
    const handleClick = (event)=>{
        if (showPanelButton && onClick) onClick(event);
        else sendVisitLinkAnalytics((0, $d925B.INPUT_METHOD).BUTTON);
    };
    const isPreviewButton = showPanelButton && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true);
    const label = isPreviewButton ? formatMessage((0, $3RxtY.messages).previewButtonTitle) : formatMessage((0, $3RxtY.messages).openButtonTitle);
    let icon = null;
    if (isPreviewButton && showPanelButtonIcon === 'panel') icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jypE9))), {
        label: ""
    });
    else if (isPreviewButton && showPanelButtonIcon === 'modal') icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))), {
        label: ""
    });
    else icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        label: ""
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ref: containerRef,
        css: $f7a722354e8e82d7$var$containerStyles,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: ()=>handleOverlayChange(true),
        onMouseLeave: ()=>handleOverlayChange(false),
        role: "presentation" // remove as part of platform_editor_hoverlink_ui_fixes_exp cleanup
        ,
        onFocus: ()=>{},
        onBlur: ()=>{}
    }, isHovered && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fpGTa.default), {
        xcss: [
            $f7a722354e8e82d7$var$linkStylesCommon,
            $f7a722354e8e82d7$var$linkStylesNewWithHeightFix,
            showOverlay && $f7a722354e8e82d7$var$linkStylesVisible
        ],
        href: url,
        target: "_blank",
        style: {
            paddingBlock: compactPadding ? '1px' : (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? $f7a722354e8e82d7$var$DYNAMIC_PADDING_BLOCK : "var(--ds-space-025, 2px)"
        },
        onClick: handleClick,
        testId: "inline-card-hoverlink-overlay"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        as: "span",
        xcss: $f7a722354e8e82d7$var$iconAndLabelStyles,
        ref: iconAndLabelRef
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        ref: iconRef,
        as: "span",
        xcss: $f7a722354e8e82d7$var$iconWrapperStyles,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height",
        testId: "inline-card-hoverlink-overlay-icon"
    }, icon), (showLabel || !minMaxWidthRef.current) && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1,
        testId: "inline-card-hoverlink-overlay-label"
    }, label))), children);
};
const $f7a722354e8e82d7$var$HoverLinkOverlay = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_hoverlink_ui_fixes_exp', 'cohort', 'css_js_changes'), $f7a722354e8e82d7$var$HoverLinkOverlayNew, $f7a722354e8e82d7$var$HoverLinkOverlayOriginal);
var $f7a722354e8e82d7$export$2e2bcd8739ae039 = $f7a722354e8e82d7$var$HoverLinkOverlay;
module.exports["default"] = $f7a722354e8e82d7$export$2e2bcd8739ae039;

});

parcelRegister("eLQM6", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $b100a9eece33ac5b$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("927mj")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $b100a9eece33ac5b$var$DatasourceTableViewWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": 'datasource-table-view-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b100a9eece33ac5b$var$LazyDatasourceTableView, props));
};
var $b100a9eece33ac5b$export$2e2bcd8739ae039 = $b100a9eece33ac5b$var$DatasourceTableViewWithWrappers;
module.exports["default"] = $b100a9eece33ac5b$export$2e2bcd8739ae039;

});

parcelRegister("927mj", function(module, exports) {

let $693a0246d4052ece$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $693a0246d4052ece$var$load("f1NVy"),
    $693a0246d4052ece$var$load("aqr2D"),
    $693a0246d4052ece$var$load("6wr18"),
    $693a0246d4052ece$var$load("jBtK5"),
    $693a0246d4052ece$var$load("5pvpJ"),
    $693a0246d4052ece$var$load("8JZKd"),
    $693a0246d4052ece$var$load("gxkWc"),
    $693a0246d4052ece$var$load("lUQAm"),
    $693a0246d4052ece$var$load("8makw"),
    $693a0246d4052ece$var$load("hRUX7"),
    $693a0246d4052ece$var$load("g4oYs"),
    $693a0246d4052ece$var$load("eO0qk"),
    $693a0246d4052ece$var$load("kHOMt"),
    $693a0246d4052ece$var$load("hhss7"),
    $693a0246d4052ece$var$load("Wowvf"),
    $693a0246d4052ece$var$load("7EorR"),
    $693a0246d4052ece$var$load("ffEVr"),
    $693a0246d4052ece$var$load("kUbUu"),
    $693a0246d4052ece$var$load("7ixUU")
]).then(()=>parcelRequire('jfuml'));

});

parcelRegister("655oj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9trs7 = parcelRequire("9trs7");


var $eIleF = parcelRequire("eIleF");


var $gmi3X = parcelRequire("gmi3X");


var $1Okf1 = parcelRequire("1Okf1");

const $b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE = 50;
const $b1fdc4e801245f01$export$f82fcd766a8daa7f = new (0, $9trs7.LRUMap)($b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE);
const $b1fdc4e801245f01$export$40b1dd31340bd5c2 = new (0, $9trs7.LRUMap)($b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE);
const $b1fdc4e801245f01$export$15cd58682efec5a5 = new (0, $9trs7.LRUMap)($b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE);
const $b1fdc4e801245f01$export$5e074c0b68e2ce03 = 20;
const $b1fdc4e801245f01$export$7d812bb756889442 = ()=>{
    const { connections: { client: client } } = (0, $eIleF.useSmartLinkContext)();
    const resolverUrl = (0, $1Okf1.useResolverUrl)(client);
    const cachedRequest = async (cacheKeyId, data, url, lruMap, force)=>{
        const cacheKeyData = {
            ...data,
            // Sort fields to use cached version of response regardless of the order
            ...'fields' in data ? {
                fields: [
                    ...data.fields || []
                ].sort()
            } : {},
            ...'fieldKeys' in data ? {
                fieldKeys: [
                    ...data.fieldKeys || []
                ].sort()
            } : {}
        };
        const cacheKey = JSON.stringify({
            cacheKeyId: cacheKeyId,
            cacheKeyData: cacheKeyData
        });
        if (force) lruMap.delete(cacheKey);
        let responsePromise = lruMap.get(cacheKey);
        if (responsePromise) return responsePromise;
        const headers = {
            /**
			 * This header exists to enable the backend to process relative time, eg: "today", with respect to user timezone.
			 * eg: used in "confluence-object-provider" to process confluence SLLV requests to filter data for relative time.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
        };
        try {
            responsePromise = (0, $gmi3X.request)('post', url, data, headers, [
                200,
                201,
                202,
                203,
                204
            ]);
            lruMap.set(cacheKey, responsePromise);
            return await responsePromise;
        } catch (e) {
            lruMap.delete(cacheKey);
            throw e;
        }
    };
    const uncachedRequest = async (data, url)=>{
        const responsePromise = (0, $gmi3X.request)('post', url, data, undefined, [
            200,
            201,
            202,
            203,
            204
        ]);
        return responsePromise;
    };
    const getDatasourceDetails = (0, $42omo.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $b1fdc4e801245f01$export$f82fcd766a8daa7f, force), [
        resolverUrl
    ]);
    const getDatasourceData = (0, $42omo.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/data`, $b1fdc4e801245f01$export$40b1dd31340bd5c2, force), [
        resolverUrl
    ]);
    const getDatasourceActionsAndPermissions = (0, $42omo.useCallback)(async (data, force = false)=>{
        const resolvedCacheIdKey = 'datasourceId' in data ? data.datasourceId : data.integrationKey;
        // This is just to prevent empty string being passed up to ORS and causing issues.
        if (!resolvedCacheIdKey) throw new Error('No target was supplied to retrieve actions for');
        return cachedRequest(resolvedCacheIdKey, data, `${resolverUrl}/actions`, $b1fdc4e801245f01$export$15cd58682efec5a5, force);
    }, [
        resolverUrl
    ]);
    const executeAtomicAction = (0, $42omo.useCallback)(async (data)=>uncachedRequest(data, `${resolverUrl}/actions/execute`), [
        resolverUrl
    ]);
    const invalidateDatasourceDataCacheByAri = (0, $42omo.useCallback)((ari)=>{
        $b1fdc4e801245f01$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
            const response = await value;
            const targetFound = response.data.items.some((item)=>{
                return item['ari']?.data === ari;
            });
            if (targetFound) $b1fdc4e801245f01$export$40b1dd31340bd5c2.delete(key);
        });
    }, []);
    return (0, $42omo.useMemo)(()=>({
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        }), [
        getDatasourceDetails,
        getDatasourceData,
        getDatasourceActionsAndPermissions,
        executeAtomicAction,
        invalidateDatasourceDataCacheByAri
    ]);
};
module.exports["DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE"] = $b1fdc4e801245f01$export$5e074c0b68e2ce03;
module.exports["useDatasourceClientExtension"] = $b1fdc4e801245f01$export$7d812bb756889442;

});

parcelRegister("4Z0ju", function(module, exports) {
const $706ca8480df97452$export$1de3504963fc32f2 = (datasource, url)=>{
    return {
        type: 'blockCard',
        attrs: {
            url: url,
            datasource: datasource
        }
    };
};
module.exports["buildDatasourceAdf"] = $706ca8480df97452$export$1de3504963fc32f2;

});

parcelRegister("fPkhr", function(module, exports) {
function $b85b59ac70a06546$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $b85b59ac70a06546$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $b85b59ac70a06546$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $b85b59ac70a06546$export$967a6b9924a689f7(a, b);
    return $b85b59ac70a06546$export$3e67810a3f0e9f1c(a, b);
}
module.exports["shallowEqualObjects"] = $b85b59ac70a06546$export$3e67810a3f0e9f1c;

});

parcelRegister("2WHHL", function(module, exports) {
const $4de09c96514ff692$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $4de09c96514ff692$var$uniqueKey = Symbol('closestEdge');
function $4de09c96514ff692$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $4de09c96514ff692$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$4de09c96514ff692$var$uniqueKey]: addClosestEdge
    };
}
function $4de09c96514ff692$export$945a571f3b658bf(userData) {
    return userData[$4de09c96514ff692$var$uniqueKey] ?? null;
}
module.exports["attachClosestEdge"] = $4de09c96514ff692$export$f0cafff222395e89;
module.exports["extractClosestEdge"] = $4de09c96514ff692$export$945a571f3b658bf;

});

parcelRegister("5jQxm", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("66utD")).getElementFromPointWithoutHoneypot);

var $66utD = parcelRequire("66utD");


});

parcelRegister("2n8po", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $31bj1 = parcelRequire("31bj1");


var $9JSVA = parcelRequire("9JSVA");

function $f0c37d2844a91b76$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $31bj1.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $9JSVA.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$f0c37d2844a91b76$export$2e2bcd8739ae039 = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["default"] = $f0c37d2844a91b76$export$2e2bcd8739ae039;

});

parcelRegister("31bj1", function(module, exports) {
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9JSVA = parcelRequire("9JSVA");

const $1707735fc36ab082$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $1707735fc36ab082$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $1707735fc36ab082$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $1707735fc36ab082$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $1707735fc36ab082$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $1707735fc36ab082$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $9JSVA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9JSVA.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $1707735fc36ab082$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $1707735fc36ab082$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $gMc0m.default)([
            $1707735fc36ab082$var$baseStyles.root,
            $1707735fc36ab082$var$orientationStyles[orientation],
            $1707735fc36ab082$var$edgeStyles[edge]
        ])
    });
} // For React.lazy
var $1707735fc36ab082$export$2e2bcd8739ae039 = $1707735fc36ab082$export$17d680238e50603e;
module.exports["Line"] = $1707735fc36ab082$export$17d680238e50603e;

});

parcelRegister("9JSVA", function(module, exports) {
const $795a0d6001dc944e$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $795a0d6001dc944e$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $795a0d6001dc944e$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $795a0d6001dc944e$export$45db03aa04b685e3;

});

parcelRegister("5X6QO", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("eOL5r")).disableNativeDragPreview);

var $eOL5r = parcelRequire("eOL5r");


});

parcelRegister("eOL5r", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $20c6df176d77bef6$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $20c6df176d77bef6$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $20c6df176d77bef6$var$tinyTransparentImage) nativeSetDragImage($20c6df176d77bef6$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $20c6df176d77bef6$export$c588cb30ff3b876e;

});

parcelRegister("afUmf", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("3ts5j")).setCustomNativeDragPreview);

var $3ts5j = parcelRequire("3ts5j");


});

parcelRegister("3ts5j", function(module, exports) {

var $3CnSH = parcelRequire("3CnSH");


var $e880Z = parcelRequire("e880Z");


var $f7qXf = parcelRequire("f7qXf");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $90430ceac724b72d$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $90430ceac724b72d$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $90430ceac724b72d$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $f7qXf.maxZIndex),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $e880Z.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $3CnSH.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}
module.exports["setCustomNativeDragPreview"] = $90430ceac724b72d$export$52d889c66db0f96e;

});

parcelRegister("gZctg", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("ihBqS")).preventUnhandled);

var $ihBqS = parcelRequire("ihBqS");


});

parcelRegister("ihBqS", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $cmcCB = parcelRequire("cmcCB");

function $713d889559578e2f$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $713d889559578e2f$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $713d889559578e2f$var$start() {
    $713d889559578e2f$var$cleanup();
    $713d889559578e2f$var$unbindEvents = (0, $fFa3V.bindAll)(window, [
        {
            type: 'dragover',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $713d889559578e2f$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $713d889559578e2f$var$cleanup
        },
        ...(0, $cmcCB.getBindingsForBrokenDrags)({
            onDragEnd: $713d889559578e2f$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $713d889559578e2f$var$cleanup() {
    $713d889559578e2f$var$unbindEvents?.();
    $713d889559578e2f$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $713d889559578e2f$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $713d889559578e2f$var$cleanup();
}
const $713d889559578e2f$export$453c0582481cc59d = {
    start: $713d889559578e2f$var$start,
    stop: $713d889559578e2f$var$stop
};
module.exports["preventUnhandled"] = $713d889559578e2f$export$453c0582481cc59d;

});

parcelRegister("4TIFs", function(module, exports) {
$parcel$export(module.exports, "default", () => $390ef28ea0b1f2a7$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $390ef28ea0b1f2a7$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("hn4RR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e81c36a83f2b3e0f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $ggbZE = parcelRequire("ggbZE");


var $c6GJD = parcelRequire("c6GJD");


var $2Nwuj = parcelRequire("2Nwuj");


var $6wQZE = parcelRequire("6wQZE");


var $6wR36 = parcelRequire("6wR36");


var $18ASy = parcelRequire("18ASy");


var $gIdjl = parcelRequire("gIdjl");


var $jUMCq = parcelRequire("jUMCq");


var $lKhNz = parcelRequire("lKhNz");

const $e81c36a83f2b3e0f$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
const $e81c36a83f2b3e0f$var$Anchor = (0, $6wQZE.withLinkClickedEvent)('a');
const $e81c36a83f2b3e0f$export$8c0773eab230d49e = (0, $6wQZE.withLinkClickedEvent)((0, $2Nwuj.default));
const $e81c36a83f2b3e0f$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, enableResolve: enableResolve = false, ...props })=>{
    (0, $fBMbo.di)($e81c36a83f2b3e0f$export$8c0773eab230d49e, (0, $lKhNz.useLinkWarningModal));
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $lKhNz.useLinkWarningModal)();
    const resolveHyperlinkFG = (0, $c6GJD.default).checkGate('platform_editor_resolve_hyperlinks_killswitch');
    if (resolveHyperlinkFG) {
        const Link = enableResolve ? (0, $gIdjl.HyperlinkWithSmartLinkResolver) : (0, $18ASy.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR36.LinkAnalyticsContext), {
            url: href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Link, {
            href: href,
            isLinkComponent: isLinkComponent,
            onClick: (e)=>{
                if (!checkSafety) {
                    onClick && onClick(e);
                    return;
                }
                // Only call the onClick if the link is safe
                if (isLinkSafe(e, href)) onClick && onClick(e);
                else showSafetyWarningModal(e, href);
            },
            ...props
        }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jUMCq.default), linkWarningModalProps));
    }
    const Link = isLinkComponent ? $e81c36a83f2b3e0f$export$8c0773eab230d49e : $e81c36a83f2b3e0f$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR36.LinkAnalyticsContext), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        onClick: (e)=>{
            if (!checkSafety) {
                onClick && onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) onClick && onClick(e);
            else showSafetyWarningModal(e, href);
        },
        ...props
    }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jUMCq.default), linkWarningModalProps));
};
var $e81c36a83f2b3e0f$export$2e2bcd8739ae039 = (0, $ggbZE.default)($e81c36a83f2b3e0f$var$PACKAGE_DATA)($e81c36a83f2b3e0f$var$LinkUrl);

});

parcelRegister("6wR36", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");

const $13440d2ce08719fa$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};
module.exports["LinkAnalyticsContext"] = $13440d2ce08719fa$export$9458cdec663b9ff1;

});

parcelRegister("18ASy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2Nwuj = parcelRequire("2Nwuj");


var $6wQZE = parcelRequire("6wQZE");

const $3be2cafa97b66d1a$var$Anchor = (0, $6wQZE.withLinkClickedEvent)('a');
const $3be2cafa97b66d1a$export$8c0773eab230d49e = (0, $6wQZE.withLinkClickedEvent)((0, $2Nwuj.default));
const $3be2cafa97b66d1a$var$Hyperlink = ({ href: href, children: children, testId: testId, isLinkComponent: isLinkComponent = false, ...props })=>{
    const Link = isLinkComponent ? $3be2cafa97b66d1a$export$8c0773eab230d49e : $3be2cafa97b66d1a$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        ...props
    }, children);
};
var $3be2cafa97b66d1a$export$2e2bcd8739ae039 = $3be2cafa97b66d1a$var$Hyperlink;
module.exports["default"] = $3be2cafa97b66d1a$export$2e2bcd8739ae039;

});

parcelRegister("gIdjl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $gmMgo = parcelRequire("gmMgo");


var $c6GJD = parcelRequire("c6GJD");


var $79vw2 = parcelRequire("79vw2");


var $dh538 = parcelRequire("dh538");


var $226XV = parcelRequire("226XV");


var $jMHhY = parcelRequire("jMHhY");


var $g6cf7 = parcelRequire("g6cf7");


var $5MkWK = parcelRequire("5MkWK");


var $8jBuy = parcelRequire("8jBuy");


var $dLAsE = parcelRequire("dLAsE");


var $18ASy = parcelRequire("18ASy");


var $055M6 = parcelRequire("055M6");

const $05b0889a04ec2be1$var$HyperlinkFallbackComponent = ()=>null;
const $05b0889a04ec2be1$var$withValidator = (Component, DefaultComponent)=>(props)=>{
        const shouldResolveHyperlink = (0, $g6cf7.default)(props?.href);
        return shouldResolveHyperlink && props.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5MkWK.SmartLinkAnalyticsContext), {
            url: props.href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DefaultComponent, props);
    };
const $05b0889a04ec2be1$var$HyperlinkWithSmartLinkResolverInner = ({ onClick: onClickCallback, ...props })=>{
    const { actions: actions, state: state } = (0, $jMHhY.default)({
        href: props.href || ''
    });
    const services = (0, $226XV.getServices)(state?.details);
    const thirdPartyARI = (0, $226XV.getThirdPartyARI)(state?.details);
    const firstPartyIdentifier = (0, $226XV.getFirstPartyIdentifier)();
    const fire3PClickEvent = (0, $dh538.fg)('platform_smartlink_3pclick_analytics') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $dLAsE.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    const onClick = (0, $42omo.useCallback)((e)=>{
        // Only fire the event if the feature flag is on and other conditions are met
        if (state?.status === 'resolved' && e?.button === 0 && fire3PClickEvent && (0, $dh538.fg)('platform_smartlink_3pclick_analytics')) // 0 taken from button state representation -
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        fire3PClickEvent();
        onClickCallback?.(e);
    }, [
        onClickCallback,
        fire3PClickEvent,
        state?.status
    ]);
    const onAuthorize = (0, $42omo.useCallback)(()=>actions.authorize('url'), [
        actions
    ]);
    const shouldRenderConnectBtn = ()=>{
        if (!props.children || !Array.isArray(props.children) || props.children.length === 0) return false;
        const firstChild = props.children[0];
        try {
            // Check if first child has a string matching href
            if (typeof firstChild === 'string') return props.href === firstChild;
            // Check if first child has another child object containing matching href. This aligns with the behavior of the TextWrapper component used by editor to render link nodes
            if (firstChild?.props?.children && typeof firstChild.props.children === 'string') return props.href === firstChild.props.children;
        } catch (_) {
            return false;
        }
    };
    if (state?.status === 'unauthorized' && shouldRenderConnectBtn() && ((0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false))) {
        const provider = (0, $79vw2.extractSmartLinkProvider)(state?.details);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $055M6.default), {
            ...props,
            onAuthorize: services?.length ? onAuthorize : undefined,
            onClick: onClick,
            showConnectBtn: services?.length > 0,
            provider: provider
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18ASy.default), {
        ...props,
        onClick: onClick
    });
};
const $05b0889a04ec2be1$export$1fdb4f77fe528a52 = (0, $lAJUP.withErrorBoundary)($05b0889a04ec2be1$var$withValidator((0, $gmMgo.default)((0, $8jBuy.default)($05b0889a04ec2be1$var$HyperlinkWithSmartLinkResolverInner), {
    enforceContext: false
}), (0, $18ASy.default)), {
    FallbackComponent: $05b0889a04ec2be1$var$HyperlinkFallbackComponent
});
module.exports["HyperlinkWithSmartLinkResolver"] = $05b0889a04ec2be1$export$1fdb4f77fe528a52;

});

parcelRegister("jMHhY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $kKODE = parcelRequire("kKODE");


var $l6tPN = parcelRequire("l6tPN");


var $a43ao = parcelRequire("a43ao");


var $226XV = parcelRequire("226XV");


var $lz9QA = parcelRequire("lz9QA");


var $lUh1d = parcelRequire("lUh1d");

const $8ce3085c5c5a77bd$var$useResolveHyperlink = ({ href: href })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $42omo.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))());
    const state = (0, $lz9QA.useSmartCardState)(href);
    const definitionId = (0, $226XV.getDefinitionId)(state.details);
    const extensionKey = (0, $226XV.getExtensionKey)(state.details);
    const resourceType = (0, $226XV.getResourceType)(state.details);
    const actions = (0, $a43ao.useSmartCardActions)(id, href);
    const scheduledRegister = (0, $lUh1d.useScheduledRegister)(href, actions.register);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        scheduledRegister().catch((error)=>{
            throw error;
        });
    }, [
        scheduledRegister
    ]);
    (0, $42omo.useEffect)(()=>{
        $l6tPN.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $l6tPN.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.hyperlink.resolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                duration: $l6tPN.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.hyperlink.unresolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    return {
        state: state,
        actions: actions
    };
};
var $8ce3085c5c5a77bd$export$2e2bcd8739ae039 = $8ce3085c5c5a77bd$var$useResolveHyperlink;
module.exports["default"] = $8ce3085c5c5a77bd$export$2e2bcd8739ae039;

});

parcelRegister("lUh1d", function(module, exports) {
/**
 * This is a scheduled batched register mechanism for resolving blue hyperlinks while the page is idle.
 * i.e. SharePoint tenants with the same hostname will be grouped together before the register is made.
 */ 
var $42omo = parcelRequire("42omo");

const $30de6a1f90cac3ee$var$batchQueue = new Map();
const $30de6a1f90cac3ee$var$batchTimeouts = new Map();
const $30de6a1f90cac3ee$var$BATCH_DELAY = 250;
const $30de6a1f90cac3ee$var$executeBatch = (hostname)=>{
    const items = $30de6a1f90cac3ee$var$batchQueue.get(hostname) || [];
    if (items.length === 0) return;
    $30de6a1f90cac3ee$var$batchQueue.delete(hostname);
    $30de6a1f90cac3ee$var$batchTimeouts.delete(hostname);
    items.forEach(({ register: register, resolve: resolve, reject: reject })=>{
        register().then(resolve).catch(reject);
    });
};
const $30de6a1f90cac3ee$var$addToBatch = (hostname, item)=>{
    if (!$30de6a1f90cac3ee$var$batchQueue.has(hostname)) $30de6a1f90cac3ee$var$batchQueue.set(hostname, []);
    $30de6a1f90cac3ee$var$batchQueue.get(hostname).push(item);
    if ($30de6a1f90cac3ee$var$batchTimeouts.has(hostname)) clearTimeout($30de6a1f90cac3ee$var$batchTimeouts.get(hostname));
    $30de6a1f90cac3ee$var$batchTimeouts.set(hostname, setTimeout(()=>{
        $30de6a1f90cac3ee$var$executeBatch(hostname);
    }, $30de6a1f90cac3ee$var$BATCH_DELAY));
};
const $30de6a1f90cac3ee$export$db80d61271e4d5af = (href, register)=>{
    const isScheduled = (0, $42omo.useRef)(false);
    const scheduledRegister = (0, $42omo.useCallback)(()=>{
        if (!href || !register || isScheduled.current) return Promise.resolve();
        isScheduled.current = true;
        return new Promise((resolve, reject)=>{
            const scheduleRegister = ()=>{
                try {
                    const hostname = new URL(href).hostname;
                    $30de6a1f90cac3ee$var$addToBatch(hostname, {
                        href: href,
                        register: register,
                        resolve: (value)=>{
                            isScheduled.current = false;
                            resolve(value);
                        },
                        reject: (error)=>{
                            isScheduled.current = false;
                            reject(error);
                        }
                    });
                } catch (error) {
                    isScheduled.current = false;
                    register().then(resolve).catch(reject);
                }
            };
            if (typeof window !== 'undefined') {
                if ('requestIdleCallback' in window) window.requestIdleCallback(scheduleRegister);
                else setTimeout(scheduleRegister, 0);
            } else scheduleRegister();
        });
    }, [
        href,
        register
    ]);
    return scheduledRegister;
};
module.exports["useScheduledRegister"] = $30de6a1f90cac3ee$export$db80d61271e4d5af;

});

parcelRegister("g6cf7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");

const $13849139a87405b6$var$allowedHostnames = [
    'sharepoint.com',
    'onedrive.live.com',
    'docs.google.com',
    'drive.google.com'
];
const $13849139a87405b6$export$aa45d36a96427452 = (href)=>{
    try {
        const hostname = new URL(href).hostname.toLowerCase();
        return $13849139a87405b6$var$allowedHostnames.some((allowedHostname)=>hostname.includes(allowedHostname));
    } catch  {
        return false;
    }
};
const $13849139a87405b6$var$useResolveHyperlinkValidator = (href = '')=>{
    const hasSmartCardProvider = !!(0, $42omo.useContext)((0, $eIleF.SmartCardContext));
    return hasSmartCardProvider && $13849139a87405b6$export$aa45d36a96427452(href);
};
var $13849139a87405b6$export$2e2bcd8739ae039 = $13849139a87405b6$var$useResolveHyperlinkValidator;
module.exports["default"] = $13849139a87405b6$export$2e2bcd8739ae039;

});

parcelRegister("8jBuy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

/**
 * HOC to wrap component with IntlProvider if not available
 */ const $255ccdc0ab7e7f63$var$withIntlProvider = (Component)=>(props)=>{
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props);
        return props?.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
            locale: "en"
        }, content);
    };
var $255ccdc0ab7e7f63$export$2e2bcd8739ae039 = $255ccdc0ab7e7f63$var$withIntlProvider;
module.exports["default"] = $255ccdc0ab7e7f63$export$2e2bcd8739ae039;

});

parcelRegister("055M6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $afp1H = parcelRequire("afp1H");


var $7Vxvp = parcelRequire("7Vxvp");


var $18ASy = parcelRequire("18ASy");

const $9a1c9ba5dc2a7a31$var$HyperlinkUnauthorizedView = ({ onAuthorize: onAuthorize, provider: provider, showConnectBtn: showConnectBtn, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18ASy.default), props), showConnectBtn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Vxvp.ActionButton), {
        onClick: onAuthorize,
        testId: "button-connect-account"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages).connect_link_account_card_name,
        values: {
            context: provider?.text
        }
    }))));
};
var $9a1c9ba5dc2a7a31$export$2e2bcd8739ae039 = $9a1c9ba5dc2a7a31$var$HyperlinkUnauthorizedView;
module.exports["default"] = $9a1c9ba5dc2a7a31$export$2e2bcd8739ae039;

});

parcelRegister("jUMCq", function(module, exports) {
$parcel$export(module.exports, "default", () => $edc36e514c97f3fa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");

var $1e2E5 = parcelRequire("1e2E5");


var $eEA8O = parcelRequire("eEA8O");


var $2Nwuj = parcelRequire("2Nwuj");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $afp1H = parcelRequire("afp1H");

const $edc36e514c97f3fa$var$breakWordsCss = null;
const $edc36e514c97f3fa$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), {
        appearance: "warning"
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).check_this_link))), /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_o5726vc6 _1nmz9jpi"
        ])
    }, url && unsafeLinkText && /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages).link_safety_warning_message,
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>/*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    }))), /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).go_back)), /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).continue)))));
    return intl ? content : /*#__PURE__*/ $42omo.createElement((0, $1e2E5.default), {
        locale: "en"
    }, content);
};
var $edc36e514c97f3fa$export$2e2bcd8739ae039 = (0, $gmMgo.default)($edc36e514c97f3fa$var$WarningModal, {
    enforceContext: false
});

});

parcelRegister("lKhNz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $l3dur = parcelRequire("l3dur");


var $lgqac = parcelRequire("lgqac");

const $83b01bdf128d776a$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $83b01bdf128d776a$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $42omo.useState)(null);
    const [url, setUrl] = (0, $42omo.useState)(null);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $lgqac.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $lgqac.ANALYTICS_CHANNEL));
    };
    /**
	 * It checks and warns if a link text is a URL and different from an actual link destination
	 */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $l3dur.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $83b01bdf128d776a$var$toUrl(href, window.location.origin);
        const linkTextUrl = $83b01bdf128d776a$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const currentAtlassianProductOrigin = window.location.origin;
        const isSafeToIgnoreNonOriginDifferences = hrefUrl?.origin === currentAtlassianProductOrigin && linkTextUrl?.origin === currentAtlassianProductOrigin;
        if (isSafeToIgnoreNonOriginDifferences) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};
module.exports["useLinkWarningModal"] = $83b01bdf128d776a$export$32b76c003683c2ec;

});

parcelRegister("l3dur", function(module, exports) {
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $2Gb84 = parcelRequire("2Gb84");

const $8a7492fb362aaff8$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
$8a7492fb362aaff8$var$linkify.add('sourcetree:', 'http:');
$8a7492fb362aaff8$var$linkify.add('jamfselfservice:', 'http:');
$8a7492fb362aaff8$var$linkify.add('notes:', 'http:');
const $8a7492fb362aaff8$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $8a7492fb362aaff8$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$8a7492fb362aaff8$var$tlds.push($8a7492fb362aaff8$var$tlds2Char);
$8a7492fb362aaff8$var$linkify.tlds($8a7492fb362aaff8$var$tlds, false);
const $8a7492fb362aaff8$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $8a7492fb362aaff8$var$normaliseLinkHref = (url)=>{
    const match = $8a7492fb362aaff8$var$getLinkMatch(url);
    return match && match.url || null;
};
const $8a7492fb362aaff8$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $8a7492fb362aaff8$var$linkifyMatch(str);
    if (!match.length) match = $8a7492fb362aaff8$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $8a7492fb362aaff8$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $8a7492fb362aaff8$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$8a7492fb362aaff8$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($8a7492fb362aaff8$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($8a7492fb362aaff8$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $8a7492fb362aaff8$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $8a7492fb362aaff8$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $8a7492fb362aaff8$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($8a7492fb362aaff8$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $8a7492fb362aaff8$var$normaliseLinkHref(urlWithoutNewlines);
}
module.exports["isSafeUrl"] = $8a7492fb362aaff8$export$c9f92f5469372e0f;
module.exports["normalizeUrl"] = $8a7492fb362aaff8$export$6535eb414fa2c8b6;

});

parcelRegister("8DMug", function(module, exports) {

var $4c48T = parcelRequire("4c48T");


var $jtTDB = parcelRequire("jtTDB");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $g9Srd = parcelRequire("g9Srd");

/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $7a0922b43eeb26f0$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const exiting = (0, $g9Srd.useExitingPersistence)();
    const requestAnimationFrame = (0, $jtTDB.useRequestAnimationFrame)();
    const setTimeout = (0, $jtTDB.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $dclyF.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $4c48T.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $4c48T.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $7a0922b43eeb26f0$export$2e2bcd8739ae039 = $7a0922b43eeb26f0$var$ShrinkOut;
module.exports["default"] = $7a0922b43eeb26f0$export$2e2bcd8739ae039;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("hBNGD", function(module, exports) {
const $eb5d052cb0327301$export$85183a312807388d = 'media';
const $eb5d052cb0327301$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $eb5d052cb0327301$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $eb5d052cb0327301$export$60efea3f80310017;

});

parcelRegister("c4Cbx", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $75Pwq = parcelRequire("75Pwq");


var $gkYRS = parcelRequire("gkYRS");


var $eavF5 = parcelRequire("eavF5");

const $cdb1236235110757$var$DatePicker = (0, $75Pwq.componentWithCondition)(()=>(0, $dh538.fg)('dst-date-picker-use-functional-component'), (0, $eavF5.default), (0, $gkYRS.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cdb1236235110757$export$2e2bcd8739ae039 = $cdb1236235110757$var$DatePicker;
module.exports["default"] = $cdb1236235110757$export$2e2bcd8739ae039;

});

parcelRegister("75Pwq", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $dc6d37b9ef0ba7b4$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        condition() ? /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $dc6d37b9ef0ba7b4$export$6e8ea24b15199873;

});

parcelRegister("gkYRS", function(module, exports) {
/* date-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cFEpk = parcelRequire("cFEpk");

var $da71s = parcelRequire("da71s");


var $eWRwJ = parcelRequire("eWRwJ");

var $ggbZE = parcelRequire("ggbZE");

var $1DWH0 = parcelRequire("1DWH0");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $c0qxy = parcelRequire("c0qxy");


var $9RVYh = parcelRequire("9RVYh");


var $9KYtE = parcelRequire("9KYtE");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $2gD2K = parcelRequire("2gD2K");

var $eKXGE = parcelRequire("eKXGE");


var $2oOe7 = parcelRequire("2oOe7");


var $huehD = parcelRequire("huehD");


var $53oCz = parcelRequire("53oCz");


var $813W4 = parcelRequire("813W4");


var $afQaI = parcelRequire("afQaI");


var $cda8t = parcelRequire("cda8t");

function $dcb2c3debbb79a5d$var$_defineProperty(e, r, t) {
    return (r = $dcb2c3debbb79a5d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $dcb2c3debbb79a5d$var$_toPropertyKey(t) {
    var i = $dcb2c3debbb79a5d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $dcb2c3debbb79a5d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /// <reference types="node" />
const $dcb2c3debbb79a5d$var$packageName = "platform-pkg";
const $dcb2c3debbb79a5d$var$packageVersion = "0.0.0-use.local";
const $dcb2c3debbb79a5d$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $dcb2c3debbb79a5d$var$styles = {
    pickerContainerStyles: "_kqswh2mm",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz1rpy _152tze3t _rjxpze3t _30l3azsu",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o"
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $dcb2c3debbb79a5d$export$df43d21f5faca9f7 extends (0, $42omo.Component) {
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $9KYtE.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($9RVYh))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        if ((0, $dh538.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $dcb2c3debbb79a5d$var$styles.dropdownIndicatorStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                    ...props
                })
            });
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $2oOe7.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $53oCz.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $813W4.Menu,
            // SingleValue is defined in the render because of UI generator limitations
            ...!showClearIndicator && {
                ClearIndicator: (0, $2oOe7.EmptyComponent)
            },
            ...selectProps.components
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, #080F214A)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $afQaI.getShortISOString)((0, $da71s.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay,
            menuInnerWrapper: this.props.menuInnerWrapper
        }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $eKXGE.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $huehD.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null; // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`,
            className: (0, $gMc0m.default)([
                $dcb2c3debbb79a5d$var$styles.pickerContainerStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $c0qxy.IdProvider), {
                    children: ({ id: valueId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                            appearance: this.props.appearance,
                            "aria-describedby": ariaDescribedBy ? `${ariaDescribedBy} ${valueId}` : valueId,
                            label: label || undefined,
                            autoFocus: autoFocus,
                            clearControlLabel: clearControlLabel,
                            closeMenuOnSelect: true,
                            enableAnimation: false,
                            inputId: id,
                            inputValue: actualSelectInputValue,
                            isDisabled: isDisabled,
                            isRequired: isRequired,
                            menuIsOpen: menuIsOpen,
                            onBlur: this.onSelectBlur,
                            onChange: this.onSelectChange,
                            onFocus: this.onSelectFocus,
                            onInputChange: this.handleSelectInputChange,
                            placeholder: (0, $huehD.getPlaceholder)({
                                placeholder: this.props.placeholder,
                                l10n: this.state.l10n
                            }),
                            styles: mergedStyles,
                            value: initialValue,
                            ...selectProps,
                            // up when you alter some of the properties in the `selectComponents`
                            // object. These errors are still present, and I suspect have always
                            // been present, without changing the unrelated code. Ignoring as the
                            // component still works as expected despite this error. And also
                            // because the select refresh team may solve it later.
                            components: {
                                ...selectComponents,
                                SingleValue: (0, $cda8t.makeSingleValue)({
                                    id: valueId,
                                    lang: this.props.locale
                                })
                            },
                            // selectProps or not and what wil be overwritten
                            isClearable: true,
                            isInvalid: isInvalid,
                            spacing: spacing,
                            testId: testId,
                            // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                            calendarContainerRef: calendarProps.calendarContainerRef,
                            calendarDisabled: calendarProps.calendarDisabled,
                            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                            calendarLocale: calendarProps.calendarLocale,
                            calendarMaxDate: calendarProps.calendarMaxDate,
                            calendarMinDate: calendarProps.calendarMinDate,
                            calendarRef: calendarProps.calendarRef,
                            calendarValue: calendarProps.calendarValue,
                            calendarView: calendarProps.calendarView,
                            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                            nextMonthLabel: nextMonthLabel,
                            onCalendarChange: calendarProps.onCalendarChange,
                            onCalendarSelect: calendarProps.onCalendarSelect,
                            previousMonthLabel: previousMonthLabel,
                            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                            menuInnerWrapper: calendarProps.menuInnerWrapper
                        })
                }),
                shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $c0qxy.IdProvider), {
                    prefix: "open-calendar-label--",
                    children: ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($dcb2c3debbb79a5d$var$styles.iconContainerStyles, value && !hideIcon ? $dcb2c3debbb79a5d$var$styles.iconSpacingWithClearButtonStyles : $dcb2c3debbb79a5d$var$styles.iconSpacingWithoutClearButtonStyles),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                appearance: "subtle",
                                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                                id: openCalendarLabelId,
                                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9RVYh))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #292A2E)"
                                    }),
                                onClick: this.onCalendarButtonClick,
                                onKeyDown: this.onCalendarButtonKeyDown,
                                ref: this.calendarButtonRef,
                                testId: testId && `${testId}--open-calendar-button`
                            })
                        })
                }) : null
            ]
        });
    }
    constructor(props){
        super(props);
        $dcb2c3debbb79a5d$var$_defineProperty(this, "containerRef", null);
        $dcb2c3debbb79a5d$var$_defineProperty(this, "calendarRef", /*#__PURE__*/ (0, $42omo.createRef)());
        $dcb2c3debbb79a5d$var$_defineProperty(this, "calendarButtonRef", /*#__PURE__*/ (0, $42omo.createRef)()); // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        $dcb2c3debbb79a5d$var$_defineProperty(this, "getValue", ()=>this.props.value ?? this.state.value);
        $dcb2c3debbb79a5d$var$_defineProperty(this, "getIsOpen", ()=>this.props.isOpen ?? this.state.isOpen);
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onCalendarChange", ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $huehD.getParsedISO)({
                    iso: iso
                })
            });
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onCalendarSelect", ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onInputClick", ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onContainerBlur", (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onContainerFocus", ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onSelectBlur", (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onSelectFocus", (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onTextInput", (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $huehD.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }); // Only try to set the date if we have month & day
                if (parsed && (0, $cFEpk.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $afQaI.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onInputKeyDown", (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                     // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $huehD.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $afQaI.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onCalendarButtonKeyDown", (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
             // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        }); // This event handler is triggered from both keydown and click. It's weird.
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onCalendarButtonClick", (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                }); // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onClear", ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $afQaI.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        }); // `unknown` is used because `value` is unused so it does not matter.
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onSelectChange", (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "handleSelectInputChange", (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "getContainerRef", (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        });
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $afQaI.getShortISOString)(new Date()),
            l10n: (0, $9KYtE.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
}
$dcb2c3debbb79a5d$var$_defineProperty($dcb2c3debbb79a5d$export$df43d21f5faca9f7, "defaultProps", $dcb2c3debbb79a5d$var$datePickerDefaultProps);
const $dcb2c3debbb79a5d$var$DatePicker = (0, $ggbZE.default)({
    componentName: 'datePicker',
    packageName: $dcb2c3debbb79a5d$var$packageName,
    packageVersion: $dcb2c3debbb79a5d$var$packageVersion
})((0, $1DWH0.default)({
    onChange: (0, $eWRwJ.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $dcb2c3debbb79a5d$var$packageName,
            packageVersion: $dcb2c3debbb79a5d$var$packageVersion
        }
    })
})($dcb2c3debbb79a5d$export$df43d21f5faca9f7));
var $dcb2c3debbb79a5d$export$2e2bcd8739ae039 = $dcb2c3debbb79a5d$var$DatePicker;
module.exports["default"] = $dcb2c3debbb79a5d$export$2e2bcd8739ae039;

});

parcelRegister("9KYtE", function(module, exports) {

var $kZZJD = parcelRequire("kZZJD");


var $fimv6 = parcelRequire("fimv6");


var $ekA6C = parcelRequire("ekA6C");

const $33f16c2c57b5906d$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $kZZJD.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $fimv6.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $ekA6C.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $ekA6C.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};
module.exports["createLocalizationProvider"] = $33f16c2c57b5906d$export$ea56ca58f08ffa52;

});

parcelRegister("kZZJD", function(module, exports) {
const $afb1d33712cd2f2f$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
module.exports["normalizeLocale"] = $afb1d33712cd2f2f$export$dca0327c9b9c6498;

});

parcelRegister("fimv6", function(module, exports) {

var $kZZJD = parcelRequire("kZZJD");


var $2h5MO = parcelRequire("2h5MO");

const $de7c077ce1369583$var$INVALID_DATE = new Date(NaN);
const $de7c077ce1369583$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $de7c077ce1369583$var$INVARIANT_DATE = (0, $2h5MO.toDate)($de7c077ce1369583$var$INVARIANT);
const $de7c077ce1369583$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $de7c077ce1369583$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $de7c077ce1369583$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $de7c077ce1369583$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $de7c077ce1369583$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $kZZJD.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($de7c077ce1369583$var$INVARIANT_DATE);
    const shortDate = $de7c077ce1369583$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($de7c077ce1369583$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $de7c077ce1369583$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($de7c077ce1369583$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($de7c077ce1369583$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($de7c077ce1369583$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $de7c077ce1369583$var$stripExtras(date).match($de7c077ce1369583$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $de7c077ce1369583$var$INVALID_DATE;
        const dateParts = $de7c077ce1369583$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $2h5MO.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $2h5MO.isValid)(normalizedDate)) return $de7c077ce1369583$var$INVALID_DATE;
        return (0, $2h5MO.toDate)(normalizedDate);
    };
};
module.exports["createDateParser"] = $de7c077ce1369583$export$cfa2ef2687faeda2;

});

parcelRegister("2h5MO", function(module, exports) {
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $312c560df75c9b9c$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $312c560df75c9b9c$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $312c560df75c9b9c$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $312c560df75c9b9c$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $312c560df75c9b9c$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $312c560df75c9b9c$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $312c560df75c9b9c$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $312c560df75c9b9c$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $312c560df75c9b9c$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};
module.exports["toDate"] = $312c560df75c9b9c$export$e67a095c620b86fe;
module.exports["isValid"] = $312c560df75c9b9c$export$1ea939691cdc45b8;
module.exports["normalizeDate"] = $312c560df75c9b9c$export$fcc71269590ba0a8;

});

parcelRegister("ekA6C", function(module, exports) {
const $d6d12117fc0f7cb0$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});
module.exports["toFormattedParts"] = $d6d12117fc0f7cb0$export$9b7ca29af37c192;

});

parcelRegister("2oOe7", function(module, exports) {
/**
 * This component is used to hide portions of Select component.
 */ const $65b9c14f421da27f$export$5e30e9a24d6c1203 = ()=>null;
const $65b9c14f421da27f$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $65b9c14f421da27f$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $65b9c14f421da27f$export$9e6d8fcf62256b85 = 'h:mma';
const $65b9c14f421da27f$export$75032c84f56650eb = 'YYYY/MM/DD';
function $65b9c14f421da27f$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $65b9c14f421da27f$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}
module.exports["EmptyComponent"] = $65b9c14f421da27f$export$5e30e9a24d6c1203;
module.exports["placeholderDatetime"] = $65b9c14f421da27f$export$fff8babee5abe3e2;
module.exports["defaultTimes"] = $65b9c14f421da27f$export$b42ffb9f09b1861b;
module.exports["defaultTimeFormat"] = $65b9c14f421da27f$export$9e6d8fcf62256b85;
module.exports["defaultDateFormat"] = $65b9c14f421da27f$export$75032c84f56650eb;
module.exports["padToTwo"] = $65b9c14f421da27f$export$a7de57e5b672ccdb;
module.exports["formatDateTimeZoneIntoIso"] = $65b9c14f421da27f$export$2eeb05a2ecc2ce0a;

});

parcelRegister("huehD", function(module, exports) {
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $dWCFT = parcelRequire("dWCFT");

var $jqWS9 = parcelRequire("jqWS9");

var $da71s = parcelRequire("da71s");


var $7lMCw = parcelRequire("7lMCw");


var $2oOe7 = parcelRequire("2oOe7");

const $85f2897621056512$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $85f2897621056512$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $jqWS9.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $2oOe7.padToTwo)(parsedMonth)}-${(0, $2oOe7.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $2oOe7.padToTwo)(parsedMonth)}-${(0, $2oOe7.padToTwo)(parsedDate)}`;
    return newIso;
};
const $85f2897621056512$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $2oOe7.defaultDateFormat));
    return l10n.parseDate(date);
};
const $85f2897621056512$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $2oOe7.defaultDateFormat));
    const date = (0, $da71s.default)(value);
    return dateFormat ? (0, $dWCFT.default)(date, (0, $7lMCw.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $85f2897621056512$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $2oOe7.placeholderDatetime));
};
module.exports["isDateDisabled"] = $85f2897621056512$export$d38e7e283938128c;
module.exports["getParsedISO"] = $85f2897621056512$export$38db26406d1a1ee2;
module.exports["parseDate"] = $85f2897621056512$export$6b862160d295c8e;
module.exports["formatDate"] = $85f2897621056512$export$3ae94a2503e890a1;
module.exports["getPlaceholder"] = $85f2897621056512$export$d3f5c5e0a5023fa0;

});

parcelRegister("jqWS9", function(module, exports) {
$parcel$export(module.exports, "default", () => $e25e1cd73cddce6c$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $e25e1cd73cddce6c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("7lMCw", function(module, exports) {
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $b5826e8cf22189ea$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $b5826e8cf22189ea$var$v1tokens = Object.keys($b5826e8cf22189ea$var$tokensMap).sort().reverse();
const $b5826e8cf22189ea$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$b5826e8cf22189ea$var$v1tokens.join('|') + '|.)', 'g');
function $b5826e8cf22189ea$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($b5826e8cf22189ea$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $b5826e8cf22189ea$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}
module.exports["convertTokens"] = $b5826e8cf22189ea$export$4d5430175be73d45;

});

parcelRegister("53oCz", function(module, exports) {
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3hOY6 = parcelRequire("3hOY6");

const $c26bf47b337ba3d5$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $c26bf47b337ba3d5$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            showClearIndicator ? $c26bf47b337ba3d5$var$styles.calendarButtonInclusionStyles : $c26bf47b337ba3d5$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).IndicatorsContainer, {
            ...rest
        })
    });
module.exports["IndicatorsContainer"] = $c26bf47b337ba3d5$export$d0ffd7e649cab6f;

});

parcelRegister("813W4", function(module, exports) {
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cFEpk = parcelRequire("cFEpk");

var $da71s = parcelRequire("da71s");


var $91bEl = parcelRequire("91bEl");


var $iug2J = parcelRequire("iug2J");


var $hq1yX = parcelRequire("hq1yX");

function $25a48d284d5ccc39$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $da71s.default)(iso);
        return (0, $cFEpk.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $25a48d284d5ccc39$var$menuStyles = null; /**
                          * This is the menu used in the select of the date picker.
                          */ 
const $25a48d284d5ccc39$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $25a48d284d5ccc39$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $42omo.Fragment);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iug2J.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hq1yX.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $gMc0m.default)([
                    "_2rko12b0 _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs130s"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $91bEl.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};
module.exports["Menu"] = $25a48d284d5ccc39$export$d9b273488cd8ce6f;

});

parcelRegister("91bEl", function(module, exports) {
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $c0qxy = parcelRequire("c0qxy");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");


var $2XUih = parcelRequire("2XUih");


var $bR9Dp = parcelRequire("bR9Dp");


var $a6vtp = parcelRequire("a6vtp");


var $2ack0 = parcelRequire("2ack0");


var $3oVyw = parcelRequire("3oVyw");


var $cKHjJ = parcelRequire("cKHjJ");


var $3PoNw = parcelRequire("3PoNw");


var $fwvxa = parcelRequire("fwvxa");


var $gGqGY = parcelRequire("gGqGY");


var $1YcZ7 = parcelRequire("1YcZ7");

const $d7a40ddbec5b8284$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $d7a40ddbec5b8284$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $d7a40ddbec5b8284$var$InnerCalendar = /*#__PURE__*/ (0, $42omo.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $2ack0.blankStringArray), defaultSelected: defaultSelected = (0, $2ack0.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $ee7An.default), onChange: onChange = (0, $ee7An.default), onFocus: onFocus = (0, $ee7An.default), onSelect: onSelect = (0, $ee7An.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $3oVyw.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $42omo.useState)(false);
    const onChangeWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$d7a40ddbec5b8284$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $fwvxa.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$d7a40ddbec5b8284$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $gGqGY.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $cKHjJ.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $1YcZ7.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $3PoNw.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $c0qxy.useId)();
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $d7a40ddbec5b8284$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2XUih.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $a6vtp.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $bR9Dp.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    });
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $d7a40ddbec5b8284$var$Calendar = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($d7a40ddbec5b8284$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$d7a40ddbec5b8284$var$Calendar.displayName = 'Calendar';
var $d7a40ddbec5b8284$export$2e2bcd8739ae039 = $d7a40ddbec5b8284$var$Calendar;
module.exports["default"] = $d7a40ddbec5b8284$export$2e2bcd8739ae039;

});

parcelRegister("2XUih", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $c0qxy = parcelRequire("c0qxy");


var $7hXDW = parcelRequire("7hXDW");


var $ey1uv = parcelRequire("ey1uv");


var $iSulU = parcelRequire("iSulU");


var $laHi9 = parcelRequire("laHi9");


var $6R5uz = parcelRequire("6R5uz");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

const $56c413dce376864e$var$Header = /*#__PURE__*/ (0, $42omo.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $c0qxy.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $42omo.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ey1uv))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSulU))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$56c413dce376864e$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$56c413dce376864e$export$2e2bcd8739ae039 = $56c413dce376864e$var$Header;
module.exports["default"] = $56c413dce376864e$export$2e2bcd8739ae039;

});

parcelRegister("bR9Dp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");


var $hKrof = parcelRequire("hKrof");


var $dY80g = parcelRequire("dY80g");

const $4ba945c9b05a81e4$var$WeekDays = /*#__PURE__*/ (0, $42omo.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dY80g.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hKrof.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$4ba945c9b05a81e4$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4ba945c9b05a81e4$export$2e2bcd8739ae039 = $4ba945c9b05a81e4$var$WeekDays;
module.exports["default"] = $4ba945c9b05a81e4$export$2e2bcd8739ae039;

});

parcelRegister("hKrof", function(module, exports) {
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $ee7An = parcelRequire("ee7An");


var $dh538 = parcelRequire("dh538");


var $d8SNb = parcelRequire("d8SNb");

const $51ea448395b49484$var$dateCellSiblingStyle = null;
const $51ea448395b49484$var$dateCellTodayStyle = null;
const $51ea448395b49484$var$dateCellPrevSelectedStyle = null;
const $51ea448395b49484$var$dateCellSelectedStyle = null;
const $51ea448395b49484$var$dateCellDisabledStyle = null;
const $51ea448395b49484$var$dateCellStyles = null; // platform-dst-shape-theme-default TODO: Merge into base after rollout
const $51ea448395b49484$var$dateCellStylesT26Shape = null;
const $51ea448395b49484$var$Date = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $ee7An.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $42omo.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $42omo.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $42omo.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $l998X.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $gMc0m.default)([
                "_kkk2n7od _2rkofajl _11c82smr _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk1j28 _syazi7uo _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj1v1w _10knnqa1 _1wysdkaa _irr31dpa _30l3i7uo _1di6fcek _9h8hi7uo",
                (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
                isSibling && "_syaz1rpy _30l31rpy",
                isToday && "_syaz6x5g _k48pmoej _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk15s3 _syazazsu _30l3azsu",
                isSelected && "_bfhk15s3 _syaz6x5g _irr3ufnl _30l36x5g",
                isDisabled && "_syaz1gmx _80om13gf _irr31j28 _30l31gmx"
            ]),
            children: day
        })
    });
}));
$51ea448395b49484$var$Date.displayName = 'Date'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $51ea448395b49484$export$2e2bcd8739ae039 = $51ea448395b49484$var$Date;
module.exports["default"] = $51ea448395b49484$export$2e2bcd8739ae039;

});

parcelRegister("dY80g", function(module, exports) {
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d8SNb = parcelRequire("d8SNb");

const $43425f893909ddbd$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $43425f893909ddbd$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
        testId: testId,
        xcss: $43425f893909ddbd$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $43425f893909ddbd$export$2e2bcd8739ae039 = $43425f893909ddbd$var$WeekDayGrid;
module.exports["default"] = $43425f893909ddbd$export$2e2bcd8739ae039;

});

parcelRegister("a6vtp", function(module, exports) {
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $dY80g = parcelRequire("dY80g");

const $a885473fdfbb1dd4$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $a885473fdfbb1dd4$var$WeekHeader = /*#__PURE__*/ (0, $42omo.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dY80g.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                padding: "space.100",
                xcss: $a885473fdfbb1dd4$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$a885473fdfbb1dd4$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a885473fdfbb1dd4$export$2e2bcd8739ae039 = $a885473fdfbb1dd4$var$WeekHeader;
module.exports["default"] = $a885473fdfbb1dd4$export$2e2bcd8739ae039;

});

parcelRegister("2ack0", function(module, exports) {
const $9af94d164628a3a8$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $9af94d164628a3a8$export$3ae905d9742bef55 = 7;
const $9af94d164628a3a8$export$c9b7c010035d60c6 = 12;
const $9af94d164628a3a8$export$8fa20d70624f8b9d = [];
module.exports["arrowKeys"] = $9af94d164628a3a8$export$8b15eca9c6d5c48a;
module.exports["daysPerWeek"] = $9af94d164628a3a8$export$3ae905d9742bef55;
module.exports["monthsPerYear"] = $9af94d164628a3a8$export$c9b7c010035d60c6;
module.exports["blankStringArray"] = $9af94d164628a3a8$export$8fa20d70624f8b9d;

});

parcelRegister("3oVyw", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea43d7ef0e095eed$export$2e2bcd8739ae039);

var $6mkwk = parcelRequire("6mkwk");


var $9GKca = parcelRequire("9GKca");


var $6Nn7f = parcelRequire("6Nn7f");

function $ea43d7ef0e095eed$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $9GKca.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $6mkwk.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $6mkwk.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $6mkwk.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $6mkwk.default)(today, ()=>today || `${thisYear}-${(0, $6Nn7f.default)(thisMonth)}-${(0, $6Nn7f.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $6mkwk.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $6mkwk.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});

parcelRegister("6Nn7f", function(module, exports) {
$parcel$export(module.exports, "default", () => $f02dc32cc8cbca94$export$2e2bcd8739ae039);
function $f02dc32cc8cbca94$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});

parcelRegister("cKHjJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $dddbc69a80aa3e99$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $dddbc69a80aa3e99$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $42omo.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $42omo.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("3PoNw", function(module, exports) {
$parcel$export(module.exports, "default", () => $0359114b86aba571$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $da71s = parcelRequire("da71s");


var $2ack0 = parcelRequire("2ack0");


var $h8WCF = parcelRequire("h8WCF");


var $4SC50 = parcelRequire("4SC50");

function $0359114b86aba571$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $42omo.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $2ack0.daysPerWeek) : 0;
            return (0, $4SC50.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $2ack0.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
        return [];
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $0359114b86aba571$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $42omo.useMemo)(()=>(0, $4SC50.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $0359114b86aba571$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $da71s.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $da71s.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $42omo.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $h8WCF.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $da71s.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});

parcelRegister("h8WCF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e56c786f8652328$export$2e2bcd8739ae039);

var $6Nn7f = parcelRequire("6Nn7f");

function $2e56c786f8652328$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $6Nn7f.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $6Nn7f.default)(date.day)}`;
}

});

parcelRegister("4SC50", function(module, exports) {
$parcel$export(module.exports, "default", () => $73a2ab129b65a12d$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $2ack0 = parcelRequire("2ack0");


var $b1Uz6 = parcelRequire("b1Uz6");

function $73a2ab129b65a12d$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $2ack0.daysPerWeek) - weekStartDay + firstDay) % (0, $2ack0.daysPerWeek));
    const lastDate = (0, $b1Uz6.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $2ack0.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $b1Uz6.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $2ack0.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $2ack0.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $2ack0.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $2ack0.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $2ack0.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});

parcelRegister("b1Uz6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bc5f72de966b731$export$2e2bcd8739ae039);
function $2bc5f72de966b731$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});

parcelRegister("fwvxa", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bae543de1d5a89e$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $2ack0 = parcelRequire("2ack0");


var $h8WCF = parcelRequire("h8WCF");


var $b1Uz6 = parcelRequire("b1Uz6");

const $4bae543de1d5a89e$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $2ack0.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $4bae543de1d5a89e$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $2ack0.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $4bae543de1d5a89e$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $42omo.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $42omo.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $42omo.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $h8WCF.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $42omo.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $2ack0.daysPerWeek);
            const daysInMonth = (0, $b1Uz6.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $4bae543de1d5a89e$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $4bae543de1d5a89e$var$getPrevMonth(month, year);
                const prevDay = (0, $b1Uz6.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $b1Uz6.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $4bae543de1d5a89e$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $2ack0.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $4bae543de1d5a89e$var$getPrevMonth(month, year);
                const prevDay = (0, $b1Uz6.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $42omo.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$4bae543de1d5a89e$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $42omo.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $42omo.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$4bae543de1d5a89e$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $42omo.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("gGqGY", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d692683ec562e03$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $2ack0 = parcelRequire("2ack0");


var $h8WCF = parcelRequire("h8WCF");

function $9d692683ec562e03$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $42omo.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $42omo.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $42omo.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $h8WCF.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $42omo.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $42omo.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $2ack0.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("1YcZ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a9118030077bfb7$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $9KYtE = parcelRequire("9KYtE");

function $8a9118030077bfb7$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $42omo.useMemo)(()=>(0, $9KYtE.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $42omo.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $42omo.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $42omo.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});

parcelRegister("hq1yX", function(module, exports) {
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $SZOxu = parcelRequire("SZOxu");


var $2xusd = parcelRequire("2xusd");

var $lqsSp = parcelRequire("lqsSp");

var $cs0ez = parcelRequire("cs0ez");

function $c20f43530238761f$var$_defineProperty(e, r, t) {
    return (r = $c20f43530238761f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c20f43530238761f$var$_toPropertyKey(t) {
    var i = $c20f43530238761f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c20f43530238761f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $c20f43530238761f$var$styles = {
    root: "_bfhk1j28 _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $c20f43530238761f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props; // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $l998X.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $SZOxu.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $l998X.jsxs)((0, $2xusd.Manager), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $cs0ez.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $gMc0m.default)([
                                $c20f43530238761f$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $lqsSp.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            ref: ref,
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $gMc0m.default)([
                                $c20f43530238761f$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args);
        $c20f43530238761f$var$_defineProperty(this, "update", (0, $ee7An.default));
    }
}
module.exports["default"] = $c20f43530238761f$export$2e2bcd8739ae039;

});

parcelRegister("afQaI", function(module, exports) {

var $dWCFT = parcelRequire("dWCFT");


var $7lMCw = parcelRequire("7lMCw");

function $3a91e7335c61042e$export$77d5bc49fed7ef14(date) {
    return (0, $dWCFT.default)(date, (0, $7lMCw.convertTokens)('YYYY-MM-DD'));
}
function $3a91e7335c61042e$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $3a91e7335c61042e$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}
module.exports["getShortISOString"] = $3a91e7335c61042e$export$77d5bc49fed7ef14;
module.exports["getSafeCalendarValue"] = $3a91e7335c61042e$export$ff525416014fb67d;

});

parcelRegister("cda8t", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");

const $ca1b90749f7f26ad$export$6e30bf8cb1347b56 = // TODO: Make ID required
({ id: id, lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                id: id,
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };
module.exports["makeSingleValue"] = $ca1b90749f7f26ad$export$6e30bf8cb1347b56;

});

parcelRegister("eavF5", function(module, exports) {
/* date-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />
// for typing `process`

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cFEpk = parcelRequire("cFEpk");

var $da71s = parcelRequire("da71s");


var $gxtzC = parcelRequire("gxtzC");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $c0qxy = parcelRequire("c0qxy");


var $9RVYh = parcelRequire("9RVYh");


var $9KYtE = parcelRequire("9KYtE");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $2gD2K = parcelRequire("2gD2K");

var $eKXGE = parcelRequire("eKXGE");


var $2oOe7 = parcelRequire("2oOe7");


var $huehD = parcelRequire("huehD");


var $53oCz = parcelRequire("53oCz");


var $813W4 = parcelRequire("813W4");


var $afQaI = parcelRequire("afQaI");


var $cda8t = parcelRequire("cda8t");

const $7010dbb7432366df$var$packageName = "platform-pkg";
const $7010dbb7432366df$var$packageVersion = "0.0.0-use.local";
const $7010dbb7432366df$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz1rpy _152tze3t _rjxpze3t _30l3azsu",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $7010dbb7432366df$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $7010dbb7432366df$var$packageName,
    packageVersion: $7010dbb7432366df$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $7010dbb7432366df$var$DatePicker = /*#__PURE__*/ (0, $42omo.forwardRef)((props, _forwardedRef)=>{
    const containerRef = (0, $42omo.useRef)(null);
    const calendarRef = (0, $42omo.useRef)(null);
    const calendarButtonRef = (0, $42omo.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($9RVYh))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: /* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, selectProps: /* eslint-enable @repo/internal/react/use-noop */ selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $42omo.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $42omo.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $42omo.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $42omo.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $42omo.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $42omo.useState)(propValue || defaultValue || (0, $afQaI.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $42omo.useState)((0, $9KYtE.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $42omo.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $42omo.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $42omo.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $42omo.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $42omo.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$7010dbb7432366df$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $9KYtE.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $42omo.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $huehD.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $huehD.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $cFEpk.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $afQaI.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $huehD.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $afQaI.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen((isOpen)=>{
            if (isOpen) {
                props.selectProps?.onMenuClose?.();
                return false;
            } else {
                props.selectProps?.onMenuOpen?.();
                return true;
            }
        });
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $afQaI.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $42omo.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon;
    if ((0, $dh538.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $7010dbb7432366df$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const valueId = (0, $c0qxy.useId)();
    const SingleValue = (0, $cda8t.makeSingleValue)({
        id: valueId,
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $2oOe7.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $53oCz.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $813W4.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $2oOe7.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, #080F214A)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $afQaI.getShortISOString)((0, $da71s.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $eKXGE.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $huehD.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $c0qxy.useId)()}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $gMc0m.default)([
            $7010dbb7432366df$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                appearance: appearance,
                "aria-describedby": ariaDescribedBy ? `${ariaDescribedBy} ${valueId}` : valueId,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $huehD.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($7010dbb7432366df$var$styles.iconContainerStyles, value && !hideIcon ? $7010dbb7432366df$var$styles.iconSpacingWithClearButtonStyles : $7010dbb7432366df$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9RVYh))), {
                            ...iconProps,
                            color: "var(--ds-icon, #292A2E)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $7010dbb7432366df$export$2e2bcd8739ae039 = $7010dbb7432366df$var$DatePicker;
module.exports["default"] = $7010dbb7432366df$export$2e2bcd8739ae039;

});

parcelRegister("5kTPO", function(module, exports) {

var $74ZOc = parcelRequire("74ZOc");


var $g2dtt = parcelRequire("g2dtt");

const $fb7b59d200301a0e$var$getUserRecommendations = (request, intl)=>{
    const url = (0, $g2dtt.config).getRecommendationServiceUrl(request.baseUrl || '');
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            includeNonLicensedUsers: request.includeNonLicensedUsers,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                ...request.context?.productAttributes?.isEntitledConfluenceExternalCollaborator && {
                    productAccessPermissionIds: [
                        'write',
                        'external-collaborator-write'
                    ]
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false,
                searchEmail: request.searchEmail
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
            statusCode: response.status
        });
    }).then((response)=>(0, $74ZOc.transformUsers)(response, intl));
};
var $fb7b59d200301a0e$export$2e2bcd8739ae039 = $fb7b59d200301a0e$var$getUserRecommendations;
module.exports["default"] = $fb7b59d200301a0e$export$2e2bcd8739ae039;

});

parcelRegister("74ZOc", function(module, exports) {

var $RMvle = parcelRequire("RMvle");


var $bicYK = parcelRequire("bicYK");


var $b4tkb = parcelRequire("b4tkb");

const $465f7c420800703a$var$getLozenzeProperties = (entity, intl)=>{
    if (entity.attributes?.workspaceMember) return intl.formatMessage((0, $bicYK.messages).memberLozengeText);
    if (entity.attributes?.isConfluenceExternalCollaborator) {
        const lozengeTooltipMessage = entity.entityType === (0, $b4tkb.EntityType).GROUP ? (0, $bicYK.messages).guestGroupLozengeTooltip : (0, $bicYK.messages).guestUserLozengeTooltip;
        return {
            text: intl.formatMessage((0, $bicYK.messages).guestLozengeText),
            tooltip: intl.formatMessage(lozengeTooltipMessage),
            appearance: 'default'
        };
    }
    return undefined;
};
const $465f7c420800703a$var$transformUser = (item, intl)=>{
    const type = item.entityType;
    if (type === (0, $b4tkb.EntityType).USER) {
        const user = item;
        const lozenge = $465f7c420800703a$var$getLozenzeProperties(user, intl);
        return {
            id: user.id,
            type: user.nonLicensedUser ? (0, $RMvle.ExternalUserType) : (0, $RMvle.UserType),
            userType: user.userType,
            avatarUrl: user.avatarUrl,
            name: user.name,
            email: user.email,
            title: user.title,
            lozenge: lozenge,
            tooltip: user.name,
            isExternal: Boolean(user.nonLicensedUser),
            sources: user.nonLicensedUser ? [
                'other-atlassian'
            ] : undefined
        };
    }
    if (type === (0, $b4tkb.EntityType).TEAM) {
        const team = item;
        return {
            id: team.id,
            type: (0, $RMvle.TeamType),
            description: team.description || '',
            name: team.displayName || '',
            memberCount: team.memberCount,
            members: team.members,
            includesYou: team.includesYou,
            avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
            tooltip: team.displayName,
            verified: team.verified
        };
    }
    if (type === (0, $b4tkb.EntityType).GROUP) {
        const group = item;
        const lozenge = $465f7c420800703a$var$getLozenzeProperties(group, intl);
        return {
            id: group.id,
            type: (0, $RMvle.GroupType),
            name: group.name || '',
            lozenge: lozenge
        };
    }
    return;
};
const $465f7c420800703a$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$465f7c420800703a$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);
module.exports["transformUsers"] = $465f7c420800703a$export$fb8c90bfc4beaa59;

});

parcelRegister("RMvle", function(module, exports) {
const $9aa1f267f5b06881$export$8436e53e45ffe15b = 'user';
const $9aa1f267f5b06881$export$50042ec1d2e00e63 = 'external_user';
const $9aa1f267f5b06881$export$26bc40b960693765 = 'team';
const $9aa1f267f5b06881$export$d460f747b73abb10 = 'group';
const $9aa1f267f5b06881$export$6662b3461398ef8c = 'email';
const $9aa1f267f5b06881$export$eafd0979afa5b224 = 'custom';
module.exports["UserType"] = $9aa1f267f5b06881$export$8436e53e45ffe15b;
module.exports["ExternalUserType"] = $9aa1f267f5b06881$export$50042ec1d2e00e63;
module.exports["TeamType"] = $9aa1f267f5b06881$export$26bc40b960693765;
module.exports["GroupType"] = $9aa1f267f5b06881$export$d460f747b73abb10;
module.exports["EmailType"] = $9aa1f267f5b06881$export$6662b3461398ef8c;
module.exports["CustomType"] = $9aa1f267f5b06881$export$eafd0979afa5b224;

});

parcelRegister("bicYK", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $5083ba0e2c523183$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    externalUserSourcesHeading: {
        id: "fabric.elements.user-picker.external.sourced.from",
        defaultMessage: "Found in:"
    },
    slackProvider: {
        id: "fabric.elements.user-picker.slack.provider",
        defaultMessage: "Slack"
    },
    googleProvider: {
        id: "fabric.elements.user-picker.google.provider",
        defaultMessage: "Google"
    },
    microsoftProvider: {
        id: "fabric.elements.user-picker.microsoft.provider",
        defaultMessage: "Microsoft"
    },
    gitHubProvider: {
        id: "fabric.elements.user-picker.github.provider",
        defaultMessage: "GitHub"
    },
    memberLozengeText: {
        id: "fabric.elements.user-picker.member.lozenge.text",
        defaultMessage: "MEMBER"
    },
    guestLozengeText: {
        id: "fabric.elements.user-picker.guest.lozenge.text",
        defaultMessage: "GUEST"
    },
    guestUserLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.user",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    },
    guestGroupLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.group",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
module.exports["messages"] = $5083ba0e2c523183$export$defe85febe8b728c;

});

parcelRegister("b4tkb", function(module, exports) {
var $bc15afc2f3227082$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});
var $bc15afc2f3227082$export$ef0ef29634e52a6b = /*#__PURE__*/ function(UserEntityType) {
    UserEntityType["DEFAULT"] = "DEFAULT";
    UserEntityType["APP"] = "APP";
    UserEntityType["CUSTOMER"] = "CUSTOMER";
    UserEntityType["SYSTEM"] = "SYSTEM";
    return UserEntityType;
}({});
module.exports["EntityType"] = $bc15afc2f3227082$export$8eda7e02f8f033b2;
module.exports["UserEntityType"] = $bc15afc2f3227082$export$ef0ef29634e52a6b;

});

parcelRegister("g2dtt", function(module, exports) {
const $bdd893fcacf86342$export$e506a1d27d1eaa20 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey, baseUrl = '') {
        return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (id, baseUrl, siteId) {
        return baseUrl ? `${baseUrl}/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}` : `/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}`;
    }
};
module.exports["config"] = $bdd893fcacf86342$export$e506a1d27d1eaa20;

});

parcelRegister("9ir1r", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $kyRHQ = parcelRequire("kyRHQ");

'use strict';
function $6c4ac1879293f4a7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6c4ac1879293f4a7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6c4ac1879293f4a7$var$_typeof(o);
}
function $6c4ac1879293f4a7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6c4ac1879293f4a7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6c4ac1879293f4a7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6c4ac1879293f4a7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6c4ac1879293f4a7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6c4ac1879293f4a7$var$_toPropertyKey(arg) {
    var key = $6c4ac1879293f4a7$var$_toPrimitive(arg, "string");
    return $6c4ac1879293f4a7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6c4ac1879293f4a7$var$_toPrimitive(input, hint) {
    if ($6c4ac1879293f4a7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6c4ac1879293f4a7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6c4ac1879293f4a7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $f5M9x = parcelRequire("f5M9x");

var $6c4ac1879293f4a7$var$_require$codes = $f5M9x.codes, $6c4ac1879293f4a7$var$ERR_AMBIGUOUS_ARGUMENT = $6c4ac1879293f4a7$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $6c4ac1879293f4a7$var$ERR_INVALID_ARG_TYPE = $6c4ac1879293f4a7$var$_require$codes.ERR_INVALID_ARG_TYPE, $6c4ac1879293f4a7$var$ERR_INVALID_ARG_VALUE = $6c4ac1879293f4a7$var$_require$codes.ERR_INVALID_ARG_VALUE, $6c4ac1879293f4a7$var$ERR_INVALID_RETURN_VALUE = $6c4ac1879293f4a7$var$_require$codes.ERR_INVALID_RETURN_VALUE, $6c4ac1879293f4a7$var$ERR_MISSING_ARGS = $6c4ac1879293f4a7$var$_require$codes.ERR_MISSING_ARGS;

var $1siW5 = parcelRequire("1siW5");


var $b0OmS = parcelRequire("b0OmS");

var $6c4ac1879293f4a7$var$inspect = $b0OmS.inspect;



var $6c4ac1879293f4a7$require$_require$types = $b0OmS.types;
var $6c4ac1879293f4a7$var$isPromise = $6c4ac1879293f4a7$require$_require$types.isPromise, $6c4ac1879293f4a7$var$isRegExp = $6c4ac1879293f4a7$require$_require$types.isRegExp;

var $6c4ac1879293f4a7$var$objectAssign = (parcelRequire("h1v6R"))();

var $6c4ac1879293f4a7$var$objectIs = (parcelRequire("d9tvR"))();

var $6c4ac1879293f4a7$var$RegExpPrototypeTest = (parcelRequire("bbt7I"))('RegExp.prototype.test');
var $6c4ac1879293f4a7$var$errorCache = new Map();
var $6c4ac1879293f4a7$var$isDeepEqual;
var $6c4ac1879293f4a7$var$isDeepStrictEqual;
var $6c4ac1879293f4a7$var$parseExpressionAt;
var $6c4ac1879293f4a7$var$findNodeAround;
var $6c4ac1879293f4a7$var$decoder;

function $6c4ac1879293f4a7$var$lazyLoadComparison() {
    var comparison = (parcelRequire("2BOM9"));
    $6c4ac1879293f4a7$var$isDeepEqual = comparison.isDeepEqual;
    $6c4ac1879293f4a7$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $6c4ac1879293f4a7$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $6c4ac1879293f4a7$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $6c4ac1879293f4a7$var$escapeFn = function escapeFn(str) {
    return $6c4ac1879293f4a7$var$meta[str.charCodeAt(0)];
};
var $6c4ac1879293f4a7$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $6c4ac1879293f4a7$var$assert = module.exports = $6c4ac1879293f4a7$var$ok;
var $6c4ac1879293f4a7$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $6c4ac1879293f4a7$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $1siW5(obj);
}
function $6c4ac1879293f4a7$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($6c4ac1879293f4a7$var$warned === false) {
            $6c4ac1879293f4a7$var$warned = true;
            var warn = $kyRHQ.emitWarning ? $kyRHQ.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $6c4ac1879293f4a7$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $1siW5(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$6c4ac1879293f4a7$var$assert.fail = $6c4ac1879293f4a7$var$fail;
// The AssertionError is defined in internal/error.
$6c4ac1879293f4a7$var$assert.AssertionError = $1siW5;
function $6c4ac1879293f4a7$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $1siW5({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $6c4ac1879293f4a7$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $6c4ac1879293f4a7$var$innerOk.apply(void 0, [
        $6c4ac1879293f4a7$var$ok,
        args.length
    ].concat(args));
}
$6c4ac1879293f4a7$var$assert.ok = $6c4ac1879293f4a7$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $6c4ac1879293f4a7$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$6c4ac1879293f4a7$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$6c4ac1879293f4a7$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($6c4ac1879293f4a7$var$isDeepEqual === undefined) $6c4ac1879293f4a7$var$lazyLoadComparison();
    if (!$6c4ac1879293f4a7$var$isDeepEqual(actual, expected)) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$6c4ac1879293f4a7$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($6c4ac1879293f4a7$var$isDeepEqual === undefined) $6c4ac1879293f4a7$var$lazyLoadComparison();
    if ($6c4ac1879293f4a7$var$isDeepEqual(actual, expected)) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $6c4ac1879293f4a7$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($6c4ac1879293f4a7$var$isDeepEqual === undefined) $6c4ac1879293f4a7$var$lazyLoadComparison();
    if (!$6c4ac1879293f4a7$var$isDeepStrictEqual(actual, expected)) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$6c4ac1879293f4a7$var$assert.notDeepStrictEqual = $6c4ac1879293f4a7$var$notDeepStrictEqual;
function $6c4ac1879293f4a7$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($6c4ac1879293f4a7$var$isDeepEqual === undefined) $6c4ac1879293f4a7$var$lazyLoadComparison();
    if ($6c4ac1879293f4a7$var$isDeepStrictEqual(actual, expected)) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $6c4ac1879293f4a7$var$notDeepStrictEqual
    });
}
$6c4ac1879293f4a7$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$6c4ac1879293f4a7$var$objectIs(actual, expected)) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$6c4ac1879293f4a7$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($6c4ac1879293f4a7$var$objectIs(actual, expected)) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $6c4ac1879293f4a7$var$Comparison = /*#__PURE__*/ $6c4ac1879293f4a7$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $6c4ac1879293f4a7$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $6c4ac1879293f4a7$var$isRegExp(obj[key]) && $6c4ac1879293f4a7$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $6c4ac1879293f4a7$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$6c4ac1879293f4a7$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $6c4ac1879293f4a7$var$Comparison(actual, keys);
            var b = new $6c4ac1879293f4a7$var$Comparison(expected, keys, actual);
            var err = new $1siW5({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $6c4ac1879293f4a7$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $6c4ac1879293f4a7$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($6c4ac1879293f4a7$var$isRegExp(expected)) return $6c4ac1879293f4a7$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $6c4ac1879293f4a7$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($6c4ac1879293f4a7$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $1siW5({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $6c4ac1879293f4a7$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($6c4ac1879293f4a7$var$isDeepEqual === undefined) $6c4ac1879293f4a7$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $6c4ac1879293f4a7$var$isRegExp(expected[key]) && $6c4ac1879293f4a7$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $6c4ac1879293f4a7$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $6c4ac1879293f4a7$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $6c4ac1879293f4a7$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $6c4ac1879293f4a7$var$NO_EXCEPTION_SENTINEL;
}
function $6c4ac1879293f4a7$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $6c4ac1879293f4a7$var$isPromise(obj) || obj !== null && $6c4ac1879293f4a7$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $6c4ac1879293f4a7$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$6c4ac1879293f4a7$var$checkIsPromise(resultPromise)) throw new $6c4ac1879293f4a7$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($6c4ac1879293f4a7$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $6c4ac1879293f4a7$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $6c4ac1879293f4a7$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $6c4ac1879293f4a7$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $6c4ac1879293f4a7$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($6c4ac1879293f4a7$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $6c4ac1879293f4a7$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $6c4ac1879293f4a7$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $6c4ac1879293f4a7$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $6c4ac1879293f4a7$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $6c4ac1879293f4a7$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $6c4ac1879293f4a7$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$6c4ac1879293f4a7$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $6c4ac1879293f4a7$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $6c4ac1879293f4a7$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $6c4ac1879293f4a7$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $6c4ac1879293f4a7$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$6c4ac1879293f4a7$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $6c4ac1879293f4a7$var$expectsError.apply(void 0, [
        throws,
        $6c4ac1879293f4a7$var$getActual(promiseFn)
    ].concat(args));
};
$6c4ac1879293f4a7$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $6c4ac1879293f4a7$var$waitForActual(promiseFn).then(function(result) {
        return $6c4ac1879293f4a7$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$6c4ac1879293f4a7$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $6c4ac1879293f4a7$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $6c4ac1879293f4a7$var$getActual(fn)
    ].concat(args));
};
$6c4ac1879293f4a7$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $6c4ac1879293f4a7$var$waitForActual(fn).then(function(result) {
        return $6c4ac1879293f4a7$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$6c4ac1879293f4a7$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($6c4ac1879293f4a7$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $6c4ac1879293f4a7$var$inspect(err);
        var newErr = new $1siW5({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $6c4ac1879293f4a7$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$6c4ac1879293f4a7$var$isRegExp(regexp)) throw new $6c4ac1879293f4a7$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $6c4ac1879293f4a7$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($6c4ac1879293f4a7$var$_typeof(string), " (").concat($6c4ac1879293f4a7$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($6c4ac1879293f4a7$var$inspect(regexp), ". Input:\n\n").concat($6c4ac1879293f4a7$var$inspect(string), "\n"));
        var err = new $1siW5({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$6c4ac1879293f4a7$var$assert.match = function match(string, regexp, message) {
    $6c4ac1879293f4a7$var$internalMatch(string, regexp, message, match, 'match');
};
$6c4ac1879293f4a7$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $6c4ac1879293f4a7$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $6c4ac1879293f4a7$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $6c4ac1879293f4a7$var$innerOk.apply(void 0, [
        $6c4ac1879293f4a7$var$strict,
        args.length
    ].concat(args));
}
$6c4ac1879293f4a7$var$assert.strict = $6c4ac1879293f4a7$var$objectAssign($6c4ac1879293f4a7$var$strict, $6c4ac1879293f4a7$var$assert, {
    equal: $6c4ac1879293f4a7$var$assert.strictEqual,
    deepEqual: $6c4ac1879293f4a7$var$assert.deepStrictEqual,
    notEqual: $6c4ac1879293f4a7$var$assert.notStrictEqual,
    notDeepEqual: $6c4ac1879293f4a7$var$assert.notDeepStrictEqual
});
$6c4ac1879293f4a7$var$assert.strict.strict = $6c4ac1879293f4a7$var$assert.strict;

});

parcelRegister("f5M9x", function(module, exports) {
$parcel$export(module.exports, "codes", () => $afccaccef25c16b2$export$e45cb6485273080e, (v) => $afccaccef25c16b2$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $afccaccef25c16b2$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $afccaccef25c16b2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $afccaccef25c16b2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $afccaccef25c16b2$var$_typeof(o);
}
function $afccaccef25c16b2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $afccaccef25c16b2$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $afccaccef25c16b2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $afccaccef25c16b2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $afccaccef25c16b2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $afccaccef25c16b2$var$_toPropertyKey(arg) {
    var key = $afccaccef25c16b2$var$_toPrimitive(arg, "string");
    return $afccaccef25c16b2$var$_typeof(key) === "symbol" ? key : String(key);
}
function $afccaccef25c16b2$var$_toPrimitive(input, hint) {
    if ($afccaccef25c16b2$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($afccaccef25c16b2$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $afccaccef25c16b2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $afccaccef25c16b2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $afccaccef25c16b2$var$_setPrototypeOf(subClass, superClass);
}
function $afccaccef25c16b2$var$_setPrototypeOf(o, p) {
    $afccaccef25c16b2$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $afccaccef25c16b2$var$_setPrototypeOf(o, p);
}
function $afccaccef25c16b2$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $afccaccef25c16b2$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $afccaccef25c16b2$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $afccaccef25c16b2$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $afccaccef25c16b2$var$_possibleConstructorReturn(this, result);
    };
}
function $afccaccef25c16b2$var$_possibleConstructorReturn(self, call) {
    if (call && ($afccaccef25c16b2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $afccaccef25c16b2$var$_assertThisInitialized(self);
}
function $afccaccef25c16b2$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $afccaccef25c16b2$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $afccaccef25c16b2$var$_getPrototypeOf(o) {
    $afccaccef25c16b2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $afccaccef25c16b2$var$_getPrototypeOf(o);
}
var $afccaccef25c16b2$var$codes = {};
// Lazy loaded
var $afccaccef25c16b2$var$assert;
var $afccaccef25c16b2$var$util;
function $afccaccef25c16b2$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $afccaccef25c16b2$var$_inherits(NodeError, _Base);
        var _super = $afccaccef25c16b2$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $afccaccef25c16b2$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $afccaccef25c16b2$var$_createClass(NodeError);
    }(Base);
    $afccaccef25c16b2$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $afccaccef25c16b2$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $afccaccef25c16b2$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $afccaccef25c16b2$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $afccaccef25c16b2$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$afccaccef25c16b2$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$afccaccef25c16b2$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($afccaccef25c16b2$var$assert === undefined) $afccaccef25c16b2$var$assert = (parcelRequire("9ir1r"));
    $afccaccef25c16b2$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $afccaccef25c16b2$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($afccaccef25c16b2$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($afccaccef25c16b2$var$oneOf(expected, 'type'));
    else {
        var type = $afccaccef25c16b2$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($afccaccef25c16b2$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($afccaccef25c16b2$var$_typeof(actual));
    return msg;
}, TypeError);

$afccaccef25c16b2$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($afccaccef25c16b2$var$util === undefined) $afccaccef25c16b2$var$util = (parcelRequire("b0OmS"));
    var inspected = $afccaccef25c16b2$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$afccaccef25c16b2$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($afccaccef25c16b2$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$afccaccef25c16b2$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($afccaccef25c16b2$var$assert === undefined) $afccaccef25c16b2$var$assert = (parcelRequire("9ir1r"));
    $afccaccef25c16b2$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$afccaccef25c16b2$export$e45cb6485273080e = $afccaccef25c16b2$var$codes;

});

parcelRegister("b0OmS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $kyRHQ = parcelRequire("kyRHQ");

var $8046c3ce1b0e4212$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $8046c3ce1b0e4212$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$8046c3ce1b0e4212$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($8046c3ce1b0e4212$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($8046c3ce1b0e4212$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($8046c3ce1b0e4212$var$isNull(x) || !$8046c3ce1b0e4212$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $8046c3ce1b0e4212$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $kyRHQ !== 'undefined' && $kyRHQ.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $kyRHQ === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($kyRHQ.throwDeprecation) throw new Error(msg);
            else if ($kyRHQ.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $8046c3ce1b0e4212$var$debugs = {};
var $8046c3ce1b0e4212$var$debugEnvRegex = /^$/;
var $8046c3ce1b0e4212$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$8046c3ce1b0e4212$var$debugs[set]) {
        if ($8046c3ce1b0e4212$var$debugEnvRegex.test(set)) {
            var pid = $kyRHQ.pid;
            $8046c3ce1b0e4212$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $8046c3ce1b0e4212$var$debugs[set] = function() {};
    }
    return $8046c3ce1b0e4212$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $8046c3ce1b0e4212$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $8046c3ce1b0e4212$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($8046c3ce1b0e4212$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($8046c3ce1b0e4212$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($8046c3ce1b0e4212$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($8046c3ce1b0e4212$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($8046c3ce1b0e4212$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $8046c3ce1b0e4212$var$stylizeWithColor;
    return $8046c3ce1b0e4212$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $8046c3ce1b0e4212$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$8046c3ce1b0e4212$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$8046c3ce1b0e4212$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $8046c3ce1b0e4212$var$stylizeWithColor(str, styleType) {
    var style = $8046c3ce1b0e4212$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $8046c3ce1b0e4212$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $8046c3ce1b0e4212$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $8046c3ce1b0e4212$var$stylizeNoColor(str, styleType) {
    return str;
}
function $8046c3ce1b0e4212$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $8046c3ce1b0e4212$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $8046c3ce1b0e4212$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$8046c3ce1b0e4212$var$isString(ret)) ret = $8046c3ce1b0e4212$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $8046c3ce1b0e4212$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $8046c3ce1b0e4212$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($8046c3ce1b0e4212$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $8046c3ce1b0e4212$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($8046c3ce1b0e4212$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($8046c3ce1b0e4212$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($8046c3ce1b0e4212$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($8046c3ce1b0e4212$var$isError(value)) return $8046c3ce1b0e4212$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($8046c3ce1b0e4212$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($8046c3ce1b0e4212$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($8046c3ce1b0e4212$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($8046c3ce1b0e4212$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($8046c3ce1b0e4212$var$isError(value)) base = ' ' + $8046c3ce1b0e4212$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($8046c3ce1b0e4212$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $8046c3ce1b0e4212$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $8046c3ce1b0e4212$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $8046c3ce1b0e4212$var$reduceToSingleString(output, base, braces);
}
function $8046c3ce1b0e4212$var$formatPrimitive(ctx, value) {
    if ($8046c3ce1b0e4212$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($8046c3ce1b0e4212$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($8046c3ce1b0e4212$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($8046c3ce1b0e4212$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($8046c3ce1b0e4212$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $8046c3ce1b0e4212$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $8046c3ce1b0e4212$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($8046c3ce1b0e4212$var$hasOwnProperty(value, String(i))) output.push($8046c3ce1b0e4212$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($8046c3ce1b0e4212$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $8046c3ce1b0e4212$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$8046c3ce1b0e4212$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($8046c3ce1b0e4212$var$isNull(recurseTimes)) str = $8046c3ce1b0e4212$var$formatValue(ctx, desc.value, null);
            else str = $8046c3ce1b0e4212$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($8046c3ce1b0e4212$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $8046c3ce1b0e4212$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("6o2Ml"));
function $8046c3ce1b0e4212$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $8046c3ce1b0e4212$var$isArray;
function $8046c3ce1b0e4212$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $8046c3ce1b0e4212$var$isBoolean;
function $8046c3ce1b0e4212$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $8046c3ce1b0e4212$var$isNull;
function $8046c3ce1b0e4212$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $8046c3ce1b0e4212$var$isNullOrUndefined;
function $8046c3ce1b0e4212$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $8046c3ce1b0e4212$var$isNumber;
function $8046c3ce1b0e4212$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $8046c3ce1b0e4212$var$isString;
function $8046c3ce1b0e4212$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $8046c3ce1b0e4212$var$isSymbol;
function $8046c3ce1b0e4212$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $8046c3ce1b0e4212$var$isUndefined;
function $8046c3ce1b0e4212$var$isRegExp(re) {
    return $8046c3ce1b0e4212$var$isObject(re) && $8046c3ce1b0e4212$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $8046c3ce1b0e4212$var$isRegExp;
module.exports.types.isRegExp = $8046c3ce1b0e4212$var$isRegExp;
function $8046c3ce1b0e4212$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $8046c3ce1b0e4212$var$isObject;
function $8046c3ce1b0e4212$var$isDate(d) {
    return $8046c3ce1b0e4212$var$isObject(d) && $8046c3ce1b0e4212$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $8046c3ce1b0e4212$var$isDate;
module.exports.types.isDate = $8046c3ce1b0e4212$var$isDate;
function $8046c3ce1b0e4212$var$isError(e) {
    return $8046c3ce1b0e4212$var$isObject(e) && ($8046c3ce1b0e4212$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $8046c3ce1b0e4212$var$isError;
module.exports.types.isNativeError = $8046c3ce1b0e4212$var$isError;
function $8046c3ce1b0e4212$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $8046c3ce1b0e4212$var$isFunction;
function $8046c3ce1b0e4212$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $8046c3ce1b0e4212$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("ciKgI"));
function $8046c3ce1b0e4212$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $8046c3ce1b0e4212$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $8046c3ce1b0e4212$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $8046c3ce1b0e4212$var$timestamp() {
    var d = new Date();
    var time = [
        $8046c3ce1b0e4212$var$pad(d.getHours()),
        $8046c3ce1b0e4212$var$pad(d.getMinutes()),
        $8046c3ce1b0e4212$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $8046c3ce1b0e4212$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $8046c3ce1b0e4212$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dMzRp"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$8046c3ce1b0e4212$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $8046c3ce1b0e4212$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $8046c3ce1b0e4212$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($8046c3ce1b0e4212$var$kCustomPromisifiedSymbol && original[$8046c3ce1b0e4212$var$kCustomPromisifiedSymbol]) {
        var fn = original[$8046c3ce1b0e4212$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $8046c3ce1b0e4212$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($8046c3ce1b0e4212$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $8046c3ce1b0e4212$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $8046c3ce1b0e4212$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $8046c3ce1b0e4212$var$kCustomPromisifiedSymbol;
function $8046c3ce1b0e4212$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $8046c3ce1b0e4212$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $kyRHQ.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $kyRHQ.nextTick($8046c3ce1b0e4212$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $8046c3ce1b0e4212$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $8046c3ce1b0e4212$var$callbackify;

});

parcelRegister("6o2Ml", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $bz2Iq = parcelRequire("bz2Iq");


var $3cWlp = parcelRequire("3cWlp");


var $khd9U = parcelRequire("khd9U");


var $7vkYj = parcelRequire("7vkYj");

function $4a6723c0633fbcbf$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $4a6723c0633fbcbf$var$BigIntSupported = typeof BigInt !== 'undefined';
var $4a6723c0633fbcbf$var$SymbolSupported = typeof Symbol !== 'undefined';
var $4a6723c0633fbcbf$var$ObjectToString = $4a6723c0633fbcbf$var$uncurryThis(Object.prototype.toString);
var $4a6723c0633fbcbf$var$numberValue = $4a6723c0633fbcbf$var$uncurryThis(Number.prototype.valueOf);
var $4a6723c0633fbcbf$var$stringValue = $4a6723c0633fbcbf$var$uncurryThis(String.prototype.valueOf);
var $4a6723c0633fbcbf$var$booleanValue = $4a6723c0633fbcbf$var$uncurryThis(Boolean.prototype.valueOf);
if ($4a6723c0633fbcbf$var$BigIntSupported) var $4a6723c0633fbcbf$var$bigIntValue = $4a6723c0633fbcbf$var$uncurryThis(BigInt.prototype.valueOf);
if ($4a6723c0633fbcbf$var$SymbolSupported) var $4a6723c0633fbcbf$var$symbolValue = $4a6723c0633fbcbf$var$uncurryThis(Symbol.prototype.valueOf);
function $4a6723c0633fbcbf$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $bz2Iq;
module.exports.isGeneratorFunction = $3cWlp;
module.exports.isTypedArray = $7vkYj;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $4a6723c0633fbcbf$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $4a6723c0633fbcbf$var$isPromise;
function $4a6723c0633fbcbf$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $7vkYj(value) || $4a6723c0633fbcbf$var$isDataView(value);
}
module.exports.isArrayBufferView = $4a6723c0633fbcbf$var$isArrayBufferView;
function $4a6723c0633fbcbf$var$isUint8Array(value) {
    return $khd9U(value) === 'Uint8Array';
}
module.exports.isUint8Array = $4a6723c0633fbcbf$var$isUint8Array;
function $4a6723c0633fbcbf$var$isUint8ClampedArray(value) {
    return $khd9U(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $4a6723c0633fbcbf$var$isUint8ClampedArray;
function $4a6723c0633fbcbf$var$isUint16Array(value) {
    return $khd9U(value) === 'Uint16Array';
}
module.exports.isUint16Array = $4a6723c0633fbcbf$var$isUint16Array;
function $4a6723c0633fbcbf$var$isUint32Array(value) {
    return $khd9U(value) === 'Uint32Array';
}
module.exports.isUint32Array = $4a6723c0633fbcbf$var$isUint32Array;
function $4a6723c0633fbcbf$var$isInt8Array(value) {
    return $khd9U(value) === 'Int8Array';
}
module.exports.isInt8Array = $4a6723c0633fbcbf$var$isInt8Array;
function $4a6723c0633fbcbf$var$isInt16Array(value) {
    return $khd9U(value) === 'Int16Array';
}
module.exports.isInt16Array = $4a6723c0633fbcbf$var$isInt16Array;
function $4a6723c0633fbcbf$var$isInt32Array(value) {
    return $khd9U(value) === 'Int32Array';
}
module.exports.isInt32Array = $4a6723c0633fbcbf$var$isInt32Array;
function $4a6723c0633fbcbf$var$isFloat32Array(value) {
    return $khd9U(value) === 'Float32Array';
}
module.exports.isFloat32Array = $4a6723c0633fbcbf$var$isFloat32Array;
function $4a6723c0633fbcbf$var$isFloat64Array(value) {
    return $khd9U(value) === 'Float64Array';
}
module.exports.isFloat64Array = $4a6723c0633fbcbf$var$isFloat64Array;
function $4a6723c0633fbcbf$var$isBigInt64Array(value) {
    return $khd9U(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $4a6723c0633fbcbf$var$isBigInt64Array;
function $4a6723c0633fbcbf$var$isBigUint64Array(value) {
    return $khd9U(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $4a6723c0633fbcbf$var$isBigUint64Array;
function $4a6723c0633fbcbf$var$isMapToString(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object Map]';
}
$4a6723c0633fbcbf$var$isMapToString.working = typeof Map !== 'undefined' && $4a6723c0633fbcbf$var$isMapToString(new Map());
function $4a6723c0633fbcbf$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $4a6723c0633fbcbf$var$isMapToString.working ? $4a6723c0633fbcbf$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $4a6723c0633fbcbf$var$isMap;
function $4a6723c0633fbcbf$var$isSetToString(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object Set]';
}
$4a6723c0633fbcbf$var$isSetToString.working = typeof Set !== 'undefined' && $4a6723c0633fbcbf$var$isSetToString(new Set());
function $4a6723c0633fbcbf$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $4a6723c0633fbcbf$var$isSetToString.working ? $4a6723c0633fbcbf$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $4a6723c0633fbcbf$var$isSet;
function $4a6723c0633fbcbf$var$isWeakMapToString(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object WeakMap]';
}
$4a6723c0633fbcbf$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $4a6723c0633fbcbf$var$isWeakMapToString(new WeakMap());
function $4a6723c0633fbcbf$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $4a6723c0633fbcbf$var$isWeakMapToString.working ? $4a6723c0633fbcbf$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $4a6723c0633fbcbf$var$isWeakMap;
function $4a6723c0633fbcbf$var$isWeakSetToString(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object WeakSet]';
}
$4a6723c0633fbcbf$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $4a6723c0633fbcbf$var$isWeakSetToString(new WeakSet());
function $4a6723c0633fbcbf$var$isWeakSet(value) {
    return $4a6723c0633fbcbf$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $4a6723c0633fbcbf$var$isWeakSet;
function $4a6723c0633fbcbf$var$isArrayBufferToString(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$4a6723c0633fbcbf$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $4a6723c0633fbcbf$var$isArrayBufferToString(new ArrayBuffer());
function $4a6723c0633fbcbf$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $4a6723c0633fbcbf$var$isArrayBufferToString.working ? $4a6723c0633fbcbf$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $4a6723c0633fbcbf$var$isArrayBuffer;
function $4a6723c0633fbcbf$var$isDataViewToString(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object DataView]';
}
$4a6723c0633fbcbf$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $4a6723c0633fbcbf$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $4a6723c0633fbcbf$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $4a6723c0633fbcbf$var$isDataViewToString.working ? $4a6723c0633fbcbf$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $4a6723c0633fbcbf$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $4a6723c0633fbcbf$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $4a6723c0633fbcbf$var$isSharedArrayBufferToString(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $4a6723c0633fbcbf$var$isSharedArrayBuffer(value) {
    if (typeof $4a6723c0633fbcbf$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $4a6723c0633fbcbf$var$isSharedArrayBufferToString.working === 'undefined') $4a6723c0633fbcbf$var$isSharedArrayBufferToString.working = $4a6723c0633fbcbf$var$isSharedArrayBufferToString(new $4a6723c0633fbcbf$var$SharedArrayBufferCopy());
    return $4a6723c0633fbcbf$var$isSharedArrayBufferToString.working ? $4a6723c0633fbcbf$var$isSharedArrayBufferToString(value) : value instanceof $4a6723c0633fbcbf$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $4a6723c0633fbcbf$var$isSharedArrayBuffer;
function $4a6723c0633fbcbf$var$isAsyncFunction(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $4a6723c0633fbcbf$var$isAsyncFunction;
function $4a6723c0633fbcbf$var$isMapIterator(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $4a6723c0633fbcbf$var$isMapIterator;
function $4a6723c0633fbcbf$var$isSetIterator(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $4a6723c0633fbcbf$var$isSetIterator;
function $4a6723c0633fbcbf$var$isGeneratorObject(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $4a6723c0633fbcbf$var$isGeneratorObject;
function $4a6723c0633fbcbf$var$isWebAssemblyCompiledModule(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $4a6723c0633fbcbf$var$isWebAssemblyCompiledModule;
function $4a6723c0633fbcbf$var$isNumberObject(value) {
    return $4a6723c0633fbcbf$var$checkBoxedPrimitive(value, $4a6723c0633fbcbf$var$numberValue);
}
module.exports.isNumberObject = $4a6723c0633fbcbf$var$isNumberObject;
function $4a6723c0633fbcbf$var$isStringObject(value) {
    return $4a6723c0633fbcbf$var$checkBoxedPrimitive(value, $4a6723c0633fbcbf$var$stringValue);
}
module.exports.isStringObject = $4a6723c0633fbcbf$var$isStringObject;
function $4a6723c0633fbcbf$var$isBooleanObject(value) {
    return $4a6723c0633fbcbf$var$checkBoxedPrimitive(value, $4a6723c0633fbcbf$var$booleanValue);
}
module.exports.isBooleanObject = $4a6723c0633fbcbf$var$isBooleanObject;
function $4a6723c0633fbcbf$var$isBigIntObject(value) {
    return $4a6723c0633fbcbf$var$BigIntSupported && $4a6723c0633fbcbf$var$checkBoxedPrimitive(value, $4a6723c0633fbcbf$var$bigIntValue);
}
module.exports.isBigIntObject = $4a6723c0633fbcbf$var$isBigIntObject;
function $4a6723c0633fbcbf$var$isSymbolObject(value) {
    return $4a6723c0633fbcbf$var$SymbolSupported && $4a6723c0633fbcbf$var$checkBoxedPrimitive(value, $4a6723c0633fbcbf$var$symbolValue);
}
module.exports.isSymbolObject = $4a6723c0633fbcbf$var$isSymbolObject;
function $4a6723c0633fbcbf$var$isBoxedPrimitive(value) {
    return $4a6723c0633fbcbf$var$isNumberObject(value) || $4a6723c0633fbcbf$var$isStringObject(value) || $4a6723c0633fbcbf$var$isBooleanObject(value) || $4a6723c0633fbcbf$var$isBigIntObject(value) || $4a6723c0633fbcbf$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $4a6723c0633fbcbf$var$isBoxedPrimitive;
function $4a6723c0633fbcbf$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($4a6723c0633fbcbf$var$isArrayBuffer(value) || $4a6723c0633fbcbf$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $4a6723c0633fbcbf$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});

parcelRegister("bz2Iq", function(module, exports) {
'use strict';

var $86b511da6386f62f$var$hasToStringTag = (parcelRequire("8an01"))();

var $bbt7I = parcelRequire("bbt7I");

var $86b511da6386f62f$var$$toString = $bbt7I('Object.prototype.toString');
var $86b511da6386f62f$var$isStandardArguments = function isArguments(value) {
    if ($86b511da6386f62f$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $86b511da6386f62f$var$$toString(value) === '[object Arguments]';
};
var $86b511da6386f62f$var$isLegacyArguments = function isArguments(value) {
    if ($86b511da6386f62f$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $86b511da6386f62f$var$$toString(value) !== '[object Array]' && $86b511da6386f62f$var$$toString(value.callee) === '[object Function]';
};
var $86b511da6386f62f$var$supportsStandardArguments = function() {
    return $86b511da6386f62f$var$isStandardArguments(arguments);
}();
$86b511da6386f62f$var$isStandardArguments.isLegacyArguments = $86b511da6386f62f$var$isLegacyArguments; // for tests
module.exports = $86b511da6386f62f$var$supportsStandardArguments ? $86b511da6386f62f$var$isStandardArguments : $86b511da6386f62f$var$isLegacyArguments;

});

parcelRegister("bbt7I", function(module, exports) {
'use strict';

var $92atP = parcelRequire("92atP");


var $i3fmO = parcelRequire("i3fmO");

var $8247501a17a70da7$var$$indexOf = $i3fmO($92atP('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $92atP(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $8247501a17a70da7$var$$indexOf(name, '.prototype.') > -1) return $i3fmO(intrinsic);
    return intrinsic;
};

});

parcelRegister("3cWlp", function(module, exports) {
'use strict';
var $255fc00e314822ed$var$toStr = Object.prototype.toString;
var $255fc00e314822ed$var$fnToStr = Function.prototype.toString;
var $255fc00e314822ed$var$isFnRegex = /^\s*(?:function)?\*/;

var $255fc00e314822ed$var$hasToStringTag = (parcelRequire("8an01"))();
var $255fc00e314822ed$var$getProto = Object.getPrototypeOf;
var $255fc00e314822ed$var$getGeneratorFunc = function() {
    if (!$255fc00e314822ed$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $255fc00e314822ed$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($255fc00e314822ed$var$isFnRegex.test($255fc00e314822ed$var$fnToStr.call(fn))) return true;
    if (!$255fc00e314822ed$var$hasToStringTag) {
        var str = $255fc00e314822ed$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$255fc00e314822ed$var$getProto) return false;
    if (typeof $255fc00e314822ed$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $255fc00e314822ed$var$getGeneratorFunc();
        $255fc00e314822ed$var$GeneratorFunction = generatorFunc ? $255fc00e314822ed$var$getProto(generatorFunc) : false;
    }
    return $255fc00e314822ed$var$getProto(fn) === $255fc00e314822ed$var$GeneratorFunction;
};

});

parcelRegister("ciKgI", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("1siW5", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $kyRHQ = parcelRequire("kyRHQ");

'use strict';
function $10f718393718d8b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $10f718393718d8b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $10f718393718d8b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $10f718393718d8b8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $10f718393718d8b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $10f718393718d8b8$var$_defineProperty(obj, key, value) {
    key = $10f718393718d8b8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $10f718393718d8b8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $10f718393718d8b8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $10f718393718d8b8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $10f718393718d8b8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $10f718393718d8b8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $10f718393718d8b8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $10f718393718d8b8$var$_toPropertyKey(arg) {
    var key = $10f718393718d8b8$var$_toPrimitive(arg, "string");
    return $10f718393718d8b8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $10f718393718d8b8$var$_toPrimitive(input, hint) {
    if ($10f718393718d8b8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($10f718393718d8b8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $10f718393718d8b8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $10f718393718d8b8$var$_setPrototypeOf(subClass, superClass);
}
function $10f718393718d8b8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $10f718393718d8b8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $10f718393718d8b8$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $10f718393718d8b8$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $10f718393718d8b8$var$_possibleConstructorReturn(this, result);
    };
}
function $10f718393718d8b8$var$_possibleConstructorReturn(self, call) {
    if (call && ($10f718393718d8b8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $10f718393718d8b8$var$_assertThisInitialized(self);
}
function $10f718393718d8b8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $10f718393718d8b8$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $10f718393718d8b8$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$10f718393718d8b8$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $10f718393718d8b8$var$_construct(Class, arguments, $10f718393718d8b8$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $10f718393718d8b8$var$_setPrototypeOf(Wrapper, Class);
    };
    return $10f718393718d8b8$var$_wrapNativeSuper(Class);
}
function $10f718393718d8b8$var$_construct(Parent, args, Class) {
    if ($10f718393718d8b8$var$_isNativeReflectConstruct()) $10f718393718d8b8$var$_construct = Reflect.construct.bind();
    else $10f718393718d8b8$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $10f718393718d8b8$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $10f718393718d8b8$var$_construct.apply(null, arguments);
}
function $10f718393718d8b8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $10f718393718d8b8$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $10f718393718d8b8$var$_setPrototypeOf(o, p) {
    $10f718393718d8b8$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $10f718393718d8b8$var$_setPrototypeOf(o, p);
}
function $10f718393718d8b8$var$_getPrototypeOf(o) {
    $10f718393718d8b8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $10f718393718d8b8$var$_getPrototypeOf(o);
}
function $10f718393718d8b8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $10f718393718d8b8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $10f718393718d8b8$var$_typeof(o);
}

var $b0OmS = parcelRequire("b0OmS");

var $10f718393718d8b8$var$inspect = $b0OmS.inspect;

var $f5M9x = parcelRequire("f5M9x");

var $10f718393718d8b8$var$ERR_INVALID_ARG_TYPE = $f5M9x.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $10f718393718d8b8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $10f718393718d8b8$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $10f718393718d8b8$var$blue = '';
var $10f718393718d8b8$var$green = '';
var $10f718393718d8b8$var$red = '';
var $10f718393718d8b8$var$white = '';
var $10f718393718d8b8$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $10f718393718d8b8$var$kMaxShortLength = 10;
function $10f718393718d8b8$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $10f718393718d8b8$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $10f718393718d8b8$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $10f718393718d8b8$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $10f718393718d8b8$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $10f718393718d8b8$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $10f718393718d8b8$var$_typeof(actual) === 'object' && $10f718393718d8b8$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $10f718393718d8b8$var$kMaxShortLength) {
            if (($10f718393718d8b8$var$_typeof(actual) !== 'object' || actual === null) && ($10f718393718d8b8$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($10f718393718d8b8$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $kyRHQ.stderr && $kyRHQ.stderr.isTTY ? $kyRHQ.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($10f718393718d8b8$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($10f718393718d8b8$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $10f718393718d8b8$var$kReadableOperator[operator] + "\n".concat($10f718393718d8b8$var$green, "+ actual").concat($10f718393718d8b8$var$white, " ").concat($10f718393718d8b8$var$red, "- expected").concat($10f718393718d8b8$var$white);
    var skippedMsg = " ".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($10f718393718d8b8$var$red, "-").concat($10f718393718d8b8$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($10f718393718d8b8$var$green, "+").concat($10f718393718d8b8$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$10f718393718d8b8$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $10f718393718d8b8$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($10f718393718d8b8$var$green, "+").concat($10f718393718d8b8$var$white, " ").concat(actualLine);
                other += "\n".concat($10f718393718d8b8$var$red, "-").concat($10f718393718d8b8$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white).concat(other, "\n") + "".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $10f718393718d8b8$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $10f718393718d8b8$var$_inherits(AssertionError, _Error);
    var _super = $10f718393718d8b8$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $10f718393718d8b8$var$_classCallCheck(this, AssertionError);
        if ($10f718393718d8b8$var$_typeof(options) !== 'object' || options === null) throw new $10f718393718d8b8$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($kyRHQ.stderr && $kyRHQ.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($kyRHQ.stderr && $kyRHQ.stderr.getColorDepth && $kyRHQ.stderr.getColorDepth() !== 1) {
                    $10f718393718d8b8$var$blue = "\x1B[34m";
                    $10f718393718d8b8$var$green = "\x1B[32m";
                    $10f718393718d8b8$var$white = "\x1B[39m";
                    $10f718393718d8b8$var$red = "\x1B[31m";
                } else {
                    $10f718393718d8b8$var$blue = '';
                    $10f718393718d8b8$var$green = '';
                    $10f718393718d8b8$var$white = '';
                    $10f718393718d8b8$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($10f718393718d8b8$var$_typeof(actual) === 'object' && actual !== null && $10f718393718d8b8$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $10f718393718d8b8$var$copyError(actual);
                expected = $10f718393718d8b8$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $10f718393718d8b8$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $10f718393718d8b8$var$kReadableOperator[operator];
                var res = $10f718393718d8b8$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $10f718393718d8b8$var$_typeof(actual) === 'object' && actual !== null) base = $10f718393718d8b8$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $10f718393718d8b8$var$inspectValue(actual);
                var other = '';
                var knownOperators = $10f718393718d8b8$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($10f718393718d8b8$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($10f718393718d8b8$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($10f718393718d8b8$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($10f718393718d8b8$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $10f718393718d8b8$var$_possibleConstructorReturn(_this);
    }
    $10f718393718d8b8$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $10f718393718d8b8$var$inspect(this, $10f718393718d8b8$var$_objectSpread($10f718393718d8b8$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $10f718393718d8b8$var$_wrapNativeSuper(Error), $10f718393718d8b8$var$inspect.custom);
module.exports = $10f718393718d8b8$var$AssertionError;

});

parcelRegister("h1v6R", function(module, exports) {
'use strict';

var $8Fult = parcelRequire("8Fult");

var $c64aa95e9c42a904$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $c64aa95e9c42a904$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $8Fult;
    if ($c64aa95e9c42a904$var$lacksProperEnumerationOrder()) return $8Fult;
    if ($c64aa95e9c42a904$var$assignHasPendingExceptions()) return $8Fult;
    return Object.assign;
};

});

parcelRegister("8Fult", function(module, exports) {
'use strict';

var $70R9c = parcelRequire("70R9c");


var $64f9b1077ce826d5$var$hasSymbols = (parcelRequire("23Da1"))();

var $aahHV = parcelRequire("aahHV");


var $j4PUi = parcelRequire("j4PUi");

var $64f9b1077ce826d5$var$$push = $aahHV('Array.prototype.push');
var $64f9b1077ce826d5$var$$propIsEnumerable = $aahHV('Object.prototype.propertyIsEnumerable');
var $64f9b1077ce826d5$var$originalGetSymbols = $64f9b1077ce826d5$var$hasSymbols ? $j4PUi.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $j4PUi(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $j4PUi(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $70R9c(from);
        var getSymbols = $64f9b1077ce826d5$var$hasSymbols && ($j4PUi.getOwnPropertySymbols || $64f9b1077ce826d5$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($64f9b1077ce826d5$var$$propIsEnumerable(from, key)) $64f9b1077ce826d5$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($64f9b1077ce826d5$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});

parcelRegister("70R9c", function(module, exports) {
'use strict';
var $51b1c276532d198e$var$slice = Array.prototype.slice;

var $75XcH = parcelRequire("75XcH");

var $51b1c276532d198e$var$origKeys = Object.keys;

var $51b1c276532d198e$var$keysShim = $51b1c276532d198e$var$origKeys ? function keys(o) {
    return $51b1c276532d198e$var$origKeys(o);
} : (parcelRequire("8vcFU"));
var $51b1c276532d198e$var$originalKeys = Object.keys;
$51b1c276532d198e$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($75XcH(object)) return $51b1c276532d198e$var$originalKeys($51b1c276532d198e$var$slice.call(object));
            return $51b1c276532d198e$var$originalKeys(object);
        };
    } else Object.keys = $51b1c276532d198e$var$keysShim;
    return Object.keys || $51b1c276532d198e$var$keysShim;
};
module.exports = $51b1c276532d198e$var$keysShim;

});

parcelRegister("75XcH", function(module, exports) {
'use strict';
var $52a6ecac25e6c24e$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $52a6ecac25e6c24e$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $52a6ecac25e6c24e$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("8vcFU", function(module, exports) {
'use strict';
var $630b0cf713a4b00d$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $630b0cf713a4b00d$var$has = Object.prototype.hasOwnProperty;
    var $630b0cf713a4b00d$var$toStr = Object.prototype.toString;
    var $630b0cf713a4b00d$var$isArgs = (parcelRequire("75XcH")); // eslint-disable-line global-require
    var $630b0cf713a4b00d$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $630b0cf713a4b00d$var$hasDontEnumBug = !$630b0cf713a4b00d$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $630b0cf713a4b00d$var$hasProtoEnumBug = $630b0cf713a4b00d$var$isEnumerable.call(function() {}, 'prototype');
    var $630b0cf713a4b00d$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $630b0cf713a4b00d$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $630b0cf713a4b00d$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $630b0cf713a4b00d$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$630b0cf713a4b00d$var$excludedKeys['$' + k] && $630b0cf713a4b00d$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $630b0cf713a4b00d$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $630b0cf713a4b00d$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$630b0cf713a4b00d$var$hasAutomationEqualityBug) return $630b0cf713a4b00d$var$equalsConstructorPrototype(o);
        try {
            return $630b0cf713a4b00d$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $630b0cf713a4b00d$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $630b0cf713a4b00d$var$toStr.call(object) === '[object Function]';
        var isArguments = $630b0cf713a4b00d$var$isArgs(object);
        var isString = isObject && $630b0cf713a4b00d$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $630b0cf713a4b00d$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$630b0cf713a4b00d$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $630b0cf713a4b00d$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($630b0cf713a4b00d$var$hasDontEnumBug) {
            var skipConstructor = $630b0cf713a4b00d$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $630b0cf713a4b00d$var$dontEnums.length; ++k)if (!(skipConstructor && $630b0cf713a4b00d$var$dontEnums[k] === 'constructor') && $630b0cf713a4b00d$var$has.call(object, $630b0cf713a4b00d$var$dontEnums[k])) theKeys.push($630b0cf713a4b00d$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $630b0cf713a4b00d$var$keysShim;

});

parcelRegister("d9tvR", function(module, exports) {
'use strict';

var $3oQFO = parcelRequire("3oQFO");

module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $3oQFO;
};

});

parcelRegister("3oQFO", function(module, exports) {
'use strict';
var $279c78d5a2041951$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($279c78d5a2041951$var$numberIsNaN(a) && $279c78d5a2041951$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("2BOM9", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $1e666c76a5838678$var$_slicedToArray(arr, i) {
    return $1e666c76a5838678$var$_arrayWithHoles(arr) || $1e666c76a5838678$var$_iterableToArrayLimit(arr, i) || $1e666c76a5838678$var$_unsupportedIterableToArray(arr, i) || $1e666c76a5838678$var$_nonIterableRest();
}
function $1e666c76a5838678$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1e666c76a5838678$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1e666c76a5838678$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1e666c76a5838678$var$_arrayLikeToArray(o, minLen);
}
function $1e666c76a5838678$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1e666c76a5838678$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $1e666c76a5838678$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1e666c76a5838678$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1e666c76a5838678$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1e666c76a5838678$var$_typeof(o);
}
var $1e666c76a5838678$var$regexFlagsSupported = /a/g.flags !== undefined;
var $1e666c76a5838678$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $1e666c76a5838678$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $1e666c76a5838678$var$objectIs = Object.is ? Object.is : (parcelRequire("1lWVG"));
var $1e666c76a5838678$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $1e666c76a5838678$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("3LzxK"));
function $1e666c76a5838678$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $1e666c76a5838678$var$hasOwnProperty = $1e666c76a5838678$var$uncurryThis(Object.prototype.hasOwnProperty);
var $1e666c76a5838678$var$propertyIsEnumerable = $1e666c76a5838678$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $1e666c76a5838678$var$objectToString = $1e666c76a5838678$var$uncurryThis(Object.prototype.toString);

var $b0OmS = parcelRequire("b0OmS");

var $1e666c76a5838678$require$_require$types = $b0OmS.types;
var $1e666c76a5838678$var$isAnyArrayBuffer = $1e666c76a5838678$require$_require$types.isAnyArrayBuffer, $1e666c76a5838678$var$isArrayBufferView = $1e666c76a5838678$require$_require$types.isArrayBufferView, $1e666c76a5838678$var$isDate = $1e666c76a5838678$require$_require$types.isDate, $1e666c76a5838678$var$isMap = $1e666c76a5838678$require$_require$types.isMap, $1e666c76a5838678$var$isRegExp = $1e666c76a5838678$require$_require$types.isRegExp, $1e666c76a5838678$var$isSet = $1e666c76a5838678$require$_require$types.isSet, $1e666c76a5838678$var$isNativeError = $1e666c76a5838678$require$_require$types.isNativeError, $1e666c76a5838678$var$isBoxedPrimitive = $1e666c76a5838678$require$_require$types.isBoxedPrimitive, $1e666c76a5838678$var$isNumberObject = $1e666c76a5838678$require$_require$types.isNumberObject, $1e666c76a5838678$var$isStringObject = $1e666c76a5838678$require$_require$types.isStringObject, $1e666c76a5838678$var$isBooleanObject = $1e666c76a5838678$require$_require$types.isBooleanObject, $1e666c76a5838678$var$isBigIntObject = $1e666c76a5838678$require$_require$types.isBigIntObject, $1e666c76a5838678$var$isSymbolObject = $1e666c76a5838678$require$_require$types.isSymbolObject, $1e666c76a5838678$var$isFloat32Array = $1e666c76a5838678$require$_require$types.isFloat32Array, $1e666c76a5838678$var$isFloat64Array = $1e666c76a5838678$require$_require$types.isFloat64Array;
function $1e666c76a5838678$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $1e666c76a5838678$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($1e666c76a5838678$var$isNonIndex).concat($1e666c76a5838678$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $1e666c76a5838678$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $1e666c76a5838678$var$ONLY_ENUMERABLE = undefined;
var $1e666c76a5838678$var$kStrict = true;
var $1e666c76a5838678$var$kLoose = false;
var $1e666c76a5838678$var$kNoIterator = 0;
var $1e666c76a5838678$var$kIsArray = 1;
var $1e666c76a5838678$var$kIsSet = 2;
var $1e666c76a5838678$var$kIsMap = 3;
// Check if they have the same source and flags
function $1e666c76a5838678$var$areSimilarRegExps(a, b) {
    return $1e666c76a5838678$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $1e666c76a5838678$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $1e666c76a5838678$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $1e666c76a5838678$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $1e666c76a5838678$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $1e666c76a5838678$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $1e666c76a5838678$var$isEqualBoxedPrimitive(val1, val2) {
    if ($1e666c76a5838678$var$isNumberObject(val1)) return $1e666c76a5838678$var$isNumberObject(val2) && $1e666c76a5838678$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($1e666c76a5838678$var$isStringObject(val1)) return $1e666c76a5838678$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($1e666c76a5838678$var$isBooleanObject(val1)) return $1e666c76a5838678$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($1e666c76a5838678$var$isBigIntObject(val1)) return $1e666c76a5838678$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $1e666c76a5838678$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $1e666c76a5838678$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $1e666c76a5838678$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($1e666c76a5838678$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $1e666c76a5838678$var$numberIsNaN(val1) && $1e666c76a5838678$var$numberIsNaN(val2);
        if ($1e666c76a5838678$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $1e666c76a5838678$var$_typeof(val1) !== 'object') {
            if (val2 === null || $1e666c76a5838678$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $1e666c76a5838678$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $1e666c76a5838678$var$objectToString(val1);
    var val2Tag = $1e666c76a5838678$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $1e666c76a5838678$var$getOwnNonIndexProperties(val1, $1e666c76a5838678$var$ONLY_ENUMERABLE);
        var keys2 = $1e666c76a5838678$var$getOwnNonIndexProperties(val2, $1e666c76a5838678$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $1e666c76a5838678$var$keyCheck(val1, val2, strict, memos, $1e666c76a5838678$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$1e666c76a5838678$var$isMap(val1) && $1e666c76a5838678$var$isMap(val2) || !$1e666c76a5838678$var$isSet(val1) && $1e666c76a5838678$var$isSet(val2)) return false;
    }
    if ($1e666c76a5838678$var$isDate(val1)) {
        if (!$1e666c76a5838678$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($1e666c76a5838678$var$isRegExp(val1)) {
        if (!$1e666c76a5838678$var$isRegExp(val2) || !$1e666c76a5838678$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($1e666c76a5838678$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($1e666c76a5838678$var$isArrayBufferView(val1)) {
        if (!strict && ($1e666c76a5838678$var$isFloat32Array(val1) || $1e666c76a5838678$var$isFloat64Array(val1))) {
            if (!$1e666c76a5838678$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$1e666c76a5838678$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $1e666c76a5838678$var$getOwnNonIndexProperties(val1, $1e666c76a5838678$var$ONLY_ENUMERABLE);
        var _keys2 = $1e666c76a5838678$var$getOwnNonIndexProperties(val2, $1e666c76a5838678$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $1e666c76a5838678$var$keyCheck(val1, val2, strict, memos, $1e666c76a5838678$var$kNoIterator, _keys);
    } else if ($1e666c76a5838678$var$isSet(val1)) {
        if (!$1e666c76a5838678$var$isSet(val2) || val1.size !== val2.size) return false;
        return $1e666c76a5838678$var$keyCheck(val1, val2, strict, memos, $1e666c76a5838678$var$kIsSet);
    } else if ($1e666c76a5838678$var$isMap(val1)) {
        if (!$1e666c76a5838678$var$isMap(val2) || val1.size !== val2.size) return false;
        return $1e666c76a5838678$var$keyCheck(val1, val2, strict, memos, $1e666c76a5838678$var$kIsMap);
    } else if ($1e666c76a5838678$var$isAnyArrayBuffer(val1)) {
        if (!$1e666c76a5838678$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($1e666c76a5838678$var$isBoxedPrimitive(val1) && !$1e666c76a5838678$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $1e666c76a5838678$var$keyCheck(val1, val2, strict, memos, $1e666c76a5838678$var$kNoIterator);
}
function $1e666c76a5838678$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $1e666c76a5838678$var$propertyIsEnumerable(val, k);
    });
}
function $1e666c76a5838678$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$1e666c76a5838678$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $1e666c76a5838678$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($1e666c76a5838678$var$propertyIsEnumerable(val1, key)) {
                    if (!$1e666c76a5838678$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($1e666c76a5838678$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $1e666c76a5838678$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $1e666c76a5838678$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $1e666c76a5838678$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $1e666c76a5838678$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $1e666c76a5838678$var$kNoIterator || iterationType === $1e666c76a5838678$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $1e666c76a5838678$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $1e666c76a5838678$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $1e666c76a5838678$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($1e666c76a5838678$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $1e666c76a5838678$var$findLooseMatchingPrimitives(prim) {
    switch($1e666c76a5838678$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($1e666c76a5838678$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $1e666c76a5838678$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $1e666c76a5838678$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $1e666c76a5838678$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $1e666c76a5838678$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$1e666c76a5838678$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $1e666c76a5838678$var$innerDeepEqual(item, curB, false, memo);
}
function $1e666c76a5838678$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $1e666c76a5838678$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($1e666c76a5838678$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$1e666c76a5838678$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $1e666c76a5838678$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($1e666c76a5838678$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$1e666c76a5838678$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$1e666c76a5838678$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $1e666c76a5838678$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $1e666c76a5838678$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($1e666c76a5838678$var$innerDeepEqual(key1, key2, strict, memo) && $1e666c76a5838678$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $1e666c76a5838678$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $1e666c76a5838678$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $1e666c76a5838678$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($1e666c76a5838678$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$1e666c76a5838678$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$1e666c76a5838678$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $1e666c76a5838678$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $1e666c76a5838678$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($1e666c76a5838678$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$1e666c76a5838678$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$1e666c76a5838678$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$1e666c76a5838678$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $1e666c76a5838678$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $1e666c76a5838678$var$kIsSet) {
        if (!$1e666c76a5838678$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $1e666c76a5838678$var$kIsMap) {
        if (!$1e666c76a5838678$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $1e666c76a5838678$var$kIsArray) for(; i < a.length; i++){
        if ($1e666c76a5838678$var$hasOwnProperty(a, i)) {
            if (!$1e666c76a5838678$var$hasOwnProperty(b, i) || !$1e666c76a5838678$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($1e666c76a5838678$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$1e666c76a5838678$var$hasOwnProperty(b, key) || !$1e666c76a5838678$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$1e666c76a5838678$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $1e666c76a5838678$var$isDeepEqual(val1, val2) {
    return $1e666c76a5838678$var$innerDeepEqual(val1, val2, $1e666c76a5838678$var$kLoose);
}
function $1e666c76a5838678$var$isDeepStrictEqual(val1, val2) {
    return $1e666c76a5838678$var$innerDeepEqual(val1, val2, $1e666c76a5838678$var$kStrict);
}
module.exports = {
    isDeepEqual: $1e666c76a5838678$var$isDeepEqual,
    isDeepStrictEqual: $1e666c76a5838678$var$isDeepStrictEqual
};

});

parcelRegister("1lWVG", function(module, exports) {
'use strict';

var $eeQAO = parcelRequire("eeQAO");


var $i3fmO = parcelRequire("i3fmO");


var $3oQFO = parcelRequire("3oQFO");


var $d9tvR = parcelRequire("d9tvR");


var $enjtz = parcelRequire("enjtz");

var $0fc576c14e1f3493$var$polyfill = $i3fmO($d9tvR(), Object);
$eeQAO($0fc576c14e1f3493$var$polyfill, {
    getPolyfill: $d9tvR,
    implementation: $3oQFO,
    shim: $enjtz
});
module.exports = $0fc576c14e1f3493$var$polyfill;

});

parcelRegister("eeQAO", function(module, exports) {
'use strict';

var $70R9c = parcelRequire("70R9c");

var $a5db2b50bead88e3$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $a5db2b50bead88e3$var$toStr = Object.prototype.toString;
var $a5db2b50bead88e3$var$concat = Array.prototype.concat;

var $gglQq = parcelRequire("gglQq");

var $a5db2b50bead88e3$var$isFunction = function(fn) {
    return typeof fn === 'function' && $a5db2b50bead88e3$var$toStr.call(fn) === '[object Function]';
};

var $a5db2b50bead88e3$var$supportsDescriptors = (parcelRequire("lUjLg"))();
var $a5db2b50bead88e3$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$a5db2b50bead88e3$var$isFunction(predicate) || !predicate()) return;
    }
    if ($a5db2b50bead88e3$var$supportsDescriptors) $gglQq(object, name, value, true);
    else $gglQq(object, name, value);
};
var $a5db2b50bead88e3$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $70R9c(map);
    if ($a5db2b50bead88e3$var$hasSymbols) props = $a5db2b50bead88e3$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$a5db2b50bead88e3$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$a5db2b50bead88e3$var$defineProperties.supportsDescriptors = !!$a5db2b50bead88e3$var$supportsDescriptors;
module.exports = $a5db2b50bead88e3$var$defineProperties;

});

parcelRegister("enjtz", function(module, exports) {
'use strict';

var $d9tvR = parcelRequire("d9tvR");


var $eeQAO = parcelRequire("eeQAO");

module.exports = function shimObjectIs() {
    var polyfill = $d9tvR();
    $eeQAO(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});

parcelRegister("3LzxK", function(module, exports) {
'use strict';

var $i3fmO = parcelRequire("i3fmO");


var $eeQAO = parcelRequire("eeQAO");


var $fWwv5 = parcelRequire("fWwv5");


var $bMM0q = parcelRequire("bMM0q");


var $5OG3Y = parcelRequire("5OG3Y");

var $2be1550e2ae24faf$var$polyfill = $i3fmO($bMM0q(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $eeQAO($2be1550e2ae24faf$var$polyfill, {
    getPolyfill: $bMM0q,
    implementation: $fWwv5,
    shim: $5OG3Y
});
module.exports = $2be1550e2ae24faf$var$polyfill;

});

parcelRegister("fWwv5", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("bMM0q", function(module, exports) {
'use strict';

var $fWwv5 = parcelRequire("fWwv5");

module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $fWwv5;
};

});

parcelRegister("5OG3Y", function(module, exports) {
'use strict';

var $eeQAO = parcelRequire("eeQAO");


var $bMM0q = parcelRequire("bMM0q");

/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $bMM0q();
    $eeQAO(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});

parcelRegister("cStGJ", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $9K4OG = parcelRequire("9K4OG");


var $g2YHK = parcelRequire("g2YHK");


var $dStU0 = parcelRequire("dStU0");


var $dmgN7 = parcelRequire("dmgN7");


var $42omo = parcelRequire("42omo");


var $c58zA = parcelRequire("c58zA");

var $96018e9e3b3d2b35$var$isDevelopment = false;
var $96018e9e3b3d2b35$var$testOmitPropsOnStringTag = (0, $c58zA.default);
var $96018e9e3b3d2b35$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $96018e9e3b3d2b35$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $96018e9e3b3d2b35$var$testOmitPropsOnStringTag : $96018e9e3b3d2b35$var$testOmitPropsOnComponent;
};
var $96018e9e3b3d2b35$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $96018e9e3b3d2b35$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dmgN7.registerStyles)(cache, serialized, isStringTag);
    (0, $dStU0.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dmgN7.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $96018e9e3b3d2b35$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $96018e9e3b3d2b35$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $9K4OG.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $42omo.useContext((0, $9K4OG.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $dmgN7.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $g2YHK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement($96018e9e3b3d2b35$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $42omo.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $96018e9e3b3d2b35$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $7Q5yr.default)({}, options, nextOptions, {
                shouldForwardProp: $96018e9e3b3d2b35$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $96018e9e3b3d2b35$export$2e2bcd8739ae039;

});

parcelRegister("dStU0", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $a1a7838157a2757d$var$syncFallback = function syncFallback(create) {
    return create();
};
var $a1a7838157a2757d$var$useInsertionEffect = $42omo.useInsertionEffect ? $42omo.useInsertionEffect : false;
var $a1a7838157a2757d$export$db21c7ffa21794e7 = $a1a7838157a2757d$var$useInsertionEffect || $a1a7838157a2757d$var$syncFallback;
var $a1a7838157a2757d$export$811a713a7276cb9d = $a1a7838157a2757d$var$useInsertionEffect || $42omo.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $a1a7838157a2757d$export$db21c7ffa21794e7;

});

parcelRegister("c58zA", function(module, exports) {

var $9bLS2 = parcelRequire("9bLS2");

// eslint-disable-next-line no-undef
var $8cbc9a10962c1be8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8cbc9a10962c1be8$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9bLS2.default)(function(prop) {
    return $8cbc9a10962c1be8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $8cbc9a10962c1be8$export$2e2bcd8739ae039;

});

parcelRegister("7HI7Y", function(module, exports) {
$parcel$export(module.exports, "merge", () => $59bec75d4837f566$export$4950aa0f605343fb, (v) => $59bec75d4837f566$export$4950aa0f605343fb = v);
var $59bec75d4837f566$export$4950aa0f605343fb;
"use strict";

var $YgydF = parcelRequire("YgydF");


var $HHFyQ = parcelRequire("HHFyQ");


var $5Dgek = parcelRequire("5Dgek");


var $kQ0lo = parcelRequire("kQ0lo");

/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */ function $59bec75d4837f566$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ($5Dgek.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') concurrent = observables.pop();
    } else if (typeof last === 'number') concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof $YgydF.Observable) return observables[0];
    return $kQ0lo.mergeAll(concurrent)(new $HHFyQ.ArrayObservable(observables, scheduler));
}
$59bec75d4837f566$export$4950aa0f605343fb = $59bec75d4837f566$var$merge;

});

parcelRegister("kQ0lo", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $f2b8ee495d9150ab$export$18aef43295bbe906, (v) => $f2b8ee495d9150ab$export$18aef43295bbe906 = v);
var $f2b8ee495d9150ab$export$18aef43295bbe906;
"use strict";

var $XrDsM = parcelRequire("XrDsM");


var $hsCka = parcelRequire("hsCka");

/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $f2b8ee495d9150ab$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $XrDsM.mergeMap($hsCka.identity, null, concurrent);
}
$f2b8ee495d9150ab$export$18aef43295bbe906 = $f2b8ee495d9150ab$var$mergeAll;

});

parcelRegister("hsCka", function(module, exports) {
$parcel$export(module.exports, "identity", () => $cb62c79807c8a85d$export$f0954fd7d5368655, (v) => $cb62c79807c8a85d$export$f0954fd7d5368655 = v);
var $cb62c79807c8a85d$export$f0954fd7d5368655;
"use strict";
function $cb62c79807c8a85d$var$identity(x) {
    return x;
}
$cb62c79807c8a85d$export$f0954fd7d5368655 = $cb62c79807c8a85d$var$identity;

});

parcelRegister("eVpDl", function(module, exports) {
"use strict";
var $adda45daebf3b6ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $adda45daebf3b6ff$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $adda45daebf3b6ff$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $adda45daebf3b6ff$var$filter;
var $adda45daebf3b6ff$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $adda45daebf3b6ff$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $adda45daebf3b6ff$var$FilterSubscriber = function(_super) {
    $adda45daebf3b6ff$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($axeml.Subscriber);

});

parcelRegister("kXEyd", function(module, exports) {
"use strict";
var $f428c5e2ee2b390f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $2g0GA = parcelRequire("2g0GA");


var $b5CQv = parcelRequire("b5CQv");

/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $f428c5e2ee2b390f$var$take(count) {
    return function(source) {
        if (count === 0) return new $b5CQv.EmptyObservable();
        else return source.lift(new $f428c5e2ee2b390f$var$TakeOperator(count));
    };
}
module.exports.take = $f428c5e2ee2b390f$var$take;
var $f428c5e2ee2b390f$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $2g0GA.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f428c5e2ee2b390f$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f428c5e2ee2b390f$var$TakeSubscriber = function(_super) {
    $f428c5e2ee2b390f$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($axeml.Subscriber);

});

parcelRegister("2g0GA", function(module, exports) {
"use strict";
var $1a4d9b96869ee1a1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $1a4d9b96869ee1a1$var$ArgumentOutOfRangeError = function(_super) {
    $1a4d9b96869ee1a1$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $1a4d9b96869ee1a1$var$ArgumentOutOfRangeError;

});

parcelRegister("1Ria2", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $15a8d410ba774044$export$45b10814cc054894, (v) => $15a8d410ba774044$export$45b10814cc054894 = v);
var $15a8d410ba774044$export$45b10814cc054894;
"use strict";

var $244gB = parcelRequire("244gB");

function $15a8d410ba774044$var$toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function $15a8d410ba774044$var$toArray() {
    return $244gB.reduce($15a8d410ba774044$var$toArrayReducer, []);
}
$15a8d410ba774044$export$45b10814cc054894 = $15a8d410ba774044$var$toArray;

});

parcelRegister("244gB", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $180f43c63924c6e6$export$533b26079ad0b4b, (v) => $180f43c63924c6e6$export$533b26079ad0b4b = v);
var $180f43c63924c6e6$export$533b26079ad0b4b;
"use strict";

var $kiSup = parcelRequire("kiSup");


var $ib5HR = parcelRequire("ib5HR");


var $avZwt = parcelRequire("avZwt");


var $5wWzN = parcelRequire("5wWzN");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $180f43c63924c6e6$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return $5wWzN.pipe($kiSup.scan(accumulator, seed), $ib5HR.takeLast(1), $avZwt.defaultIfEmpty(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return $5wWzN.pipe($kiSup.scan(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), $ib5HR.takeLast(1))(source);
    };
}
$180f43c63924c6e6$export$533b26079ad0b4b = $180f43c63924c6e6$var$reduce;

});

parcelRegister("kiSup", function(module, exports) {
"use strict";
var $ec7fc18d41270381$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $ec7fc18d41270381$var$scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new $ec7fc18d41270381$var$ScanOperator(accumulator, seed, hasSeed));
    };
}
module.exports.scan = $ec7fc18d41270381$var$scan;
var $ec7fc18d41270381$var$ScanOperator = function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ec7fc18d41270381$var$ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ec7fc18d41270381$var$ScanSubscriber = function(_super) {
    $ec7fc18d41270381$var$__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}($axeml.Subscriber);

});

parcelRegister("ib5HR", function(module, exports) {
"use strict";
var $d3bdae4589ae3cf1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $2g0GA = parcelRequire("2g0GA");


var $b5CQv = parcelRequire("b5CQv");

/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $d3bdae4589ae3cf1$var$takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return new $b5CQv.EmptyObservable();
        else return source.lift(new $d3bdae4589ae3cf1$var$TakeLastOperator(count));
    };
}
module.exports.takeLast = $d3bdae4589ae3cf1$var$takeLast;
var $d3bdae4589ae3cf1$var$TakeLastOperator = function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $2g0GA.ArgumentOutOfRangeError;
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d3bdae4589ae3cf1$var$TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d3bdae4589ae3cf1$var$TakeLastSubscriber = function(_super) {
    $d3bdae4589ae3cf1$var$__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}($axeml.Subscriber);

});

parcelRegister("avZwt", function(module, exports) {
"use strict";
var $7a7c85c9732247d4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $7a7c85c9732247d4$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $7a7c85c9732247d4$var$DefaultIfEmptyOperator(defaultValue));
    };
}
module.exports.defaultIfEmpty = $7a7c85c9732247d4$var$defaultIfEmpty;
var $7a7c85c9732247d4$var$DefaultIfEmptyOperator = function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7a7c85c9732247d4$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7a7c85c9732247d4$var$DefaultIfEmptySubscriber = function(_super) {
    $7a7c85c9732247d4$var$__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}($axeml.Subscriber);

});

parcelRegister("hu8We", function(module, exports) {
$parcel$export(module.exports, "of", () => $cbac2bf0af029aab$export$ba255e9e49e00608, (v) => $cbac2bf0af029aab$export$ba255e9e49e00608 = v);
var $cbac2bf0af029aab$export$ba255e9e49e00608;
"use strict";

var $HHFyQ = parcelRequire("HHFyQ");

$cbac2bf0af029aab$export$ba255e9e49e00608 = $HHFyQ.ArrayObservable.of;

});

parcelRegister("fulrs", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $kVeeY = parcelRequire("kVeeY");


var $axeml = parcelRequire("axeml");


var $6j5QO = parcelRequire("6j5QO");

/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    var absoluteDelay = $kVeeY.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($6j5QO.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($6j5QO.Notification.createComplete());
    };
    return DelaySubscriber;
}($axeml.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});

parcelRegister("3u6GG", function(module, exports) {
$parcel$export(module.exports, "async", () => $28995c6d2039be6b$export$12af436354f1a4f7, (v) => $28995c6d2039be6b$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $28995c6d2039be6b$export$12af436354f1a4f7;
"use strict";

var $k8JsH = parcelRequire("k8JsH");


var $iOeLv = parcelRequire("iOeLv");

$28995c6d2039be6b$export$12af436354f1a4f7 = new $iOeLv.AsyncScheduler($k8JsH.AsyncAction);

});

parcelRegister("kVeeY", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $f3b42d67f4ad5339$export$871608497c498473, (v) => $f3b42d67f4ad5339$export$871608497c498473 = v);
var $f3b42d67f4ad5339$export$871608497c498473;
"use strict";
function $f3b42d67f4ad5339$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$f3b42d67f4ad5339$export$871608497c498473 = $f3b42d67f4ad5339$var$isDate;

});

parcelRegister("7soXU", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");


var $grxv4 = parcelRequire("grxv4");


var $3rvSa = parcelRequire("3rvSa");

const $9f89bc087ab3777e$export$9f7977d4a2561bee = (Component)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)('media-perf-uplift-mutation-fix'), ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>{
        const existingMediaClient = (0, $42omo.useContext)((0, $3rvSa.MediaClientContext));
        const mediaClient = (0, $42omo.useMemo)(()=>existingMediaClient ?? (0, $grxv4.getMediaClient)(mediaClientConfig), [
            mediaClientConfig,
            existingMediaClient
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3rvSa.MediaClientContext).Provider, {
            value: mediaClient,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...otherProps,
                mediaClient: mediaClient
            })
        });
    }, ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3rvSa.MediaClientContext).Consumer, {
            children: (value)=>value ? /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...otherProps,
                    mediaClient: value
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $3rvSa.MediaClientProvider), {
                    clientConfig: mediaClientConfig,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3rvSa.MediaClientContext).Consumer, {
                        children: (client)=>/*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                ...otherProps,
                                mediaClient: client
                            })
                    })
                })
        }));
module.exports["withMediaClient"] = $9f89bc087ab3777e$export$9f7977d4a2561bee;

});

parcelRegister("3rvSa", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");

const $1c0162128aea5b38$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $1c0162128aea5b38$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1c0162128aea5b38$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};
module.exports["MediaClientContext"] = $1c0162128aea5b38$export$ba5d7212f2b4619f;
module.exports["MediaClientProvider"] = $1c0162128aea5b38$export$5bff351c86f56d97;

});

parcelRegister("9k33u", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");


var $8IHds = parcelRequire("8IHds");

const $93e9546cb0a1512c$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $93e9546cb0a1512c$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $l998X.jsx)($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};
module.exports["MediaContext"] = $93e9546cb0a1512c$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $93e9546cb0a1512c$export$57164260bc1f1218;

});

parcelRegister("8IHds", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $82Dle = parcelRequire("82Dle");

const $ad9bb6183b9f6f81$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $42omo.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $82Dle.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $ad9bb6183b9f6f81$export$d54af28440a5efc0;

});

parcelRegister("82Dle", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $3a61632aaf261ebb$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $3a61632aaf261ebb$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($3a61632aaf261ebb$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $3a61632aaf261ebb$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $3a61632aaf261ebb$export$2d23ed2854ac1650 = $3a61632aaf261ebb$export$7e209e67b965bc63($3a61632aaf261ebb$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $3a61632aaf261ebb$export$2d23ed2854ac1650;

});

parcelRegister("3BZZG", function(module, exports) {
const $b77837f445efd10f$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $b77837f445efd10f$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $b77837f445efd10f$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $b77837f445efd10f$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $b77837f445efd10f$export$d87a47989c00f322;
    if (appearance === 'square') return $b77837f445efd10f$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $b77837f445efd10f$export$aeb48196afcd236a;
    return $b77837f445efd10f$export$d87a47989c00f322;
};
module.exports["defaultImageCardDimensions"] = $b77837f445efd10f$export$d87a47989c00f322;
module.exports["getDefaultCardDimensions"] = $b77837f445efd10f$export$ed7b8a4728e9c63;

});

parcelRegister("7bPHJ", function(module, exports) {
const $f5d20cba8da3e43a$export$ec1779cb96554e1 = 'media';
module.exports["ANALYTICS_MEDIA_CHANNEL"] = $f5d20cba8da3e43a$export$ec1779cb96554e1;

});

parcelRegister("hL7bb", function(module, exports) {
var $cedc651d64f014e0$var$pSlice = Array.prototype.slice;

var $gFqzn = parcelRequire("gFqzn");


var $2EuUq = parcelRequire("2EuUq");

var $cedc651d64f014e0$var$deepEqual = module.exports = function(actual, expected, opts) {
    if (!opts) opts = {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
    else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') return opts.strict ? actual === expected : actual == expected;
    else return $cedc651d64f014e0$var$objEquiv(actual, expected, opts);
};
function $cedc651d64f014e0$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $cedc651d64f014e0$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $cedc651d64f014e0$var$objEquiv(a, b, opts) {
    var i, key;
    if ($cedc651d64f014e0$var$isUndefinedOrNull(a) || $cedc651d64f014e0$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    //~~~I've managed to break Object.keys through screwy arguments passing.
    //   Converting to array solves the problem.
    if ($2EuUq(a)) {
        if (!$2EuUq(b)) return false;
        a = $cedc651d64f014e0$var$pSlice.call(a);
        b = $cedc651d64f014e0$var$pSlice.call(b);
        return $cedc651d64f014e0$var$deepEqual(a, b, opts);
    }
    if ($cedc651d64f014e0$var$isBuffer(a)) {
        if (!$cedc651d64f014e0$var$isBuffer(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    try {
        var ka = $gFqzn(a), kb = $gFqzn(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length != kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$cedc651d64f014e0$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return typeof a === typeof b;
}

});

parcelRegister("gFqzn", function(module, exports) {
exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;
exports.shim = shim;
function shim(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
}

});

parcelRegister("2EuUq", function(module, exports) {
var supportsArgumentsClass = function() {
    return Object.prototype.toString.call(arguments);
}() == '[object Arguments]';
exports = module.exports = supportsArgumentsClass ? supported : unsupported;
exports.supported = supported;
function supported(object) {
    return Object.prototype.toString.call(object) == '[object Arguments]';
}
exports.unsupported = unsupported;
function unsupported(object) {
    return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
}

});

parcelRegister("hc71J", function(module, exports) {
function $484fceb19a2d8a9d$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $484fceb19a2d8a9d$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $484fceb19a2d8a9d$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $484fceb19a2d8a9d$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $484fceb19a2d8a9d$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $484fceb19a2d8a9d$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $484fceb19a2d8a9d$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            if (mimetype === 'text/plain') return 'text';
            return null;
    }
}
module.exports["getExtension"] = $484fceb19a2d8a9d$export$78d71f9ed5534abe;
module.exports["isCodeViewerItem"] = $484fceb19a2d8a9d$export$bb139b46f345ca28;
module.exports["getLanguageType"] = $484fceb19a2d8a9d$export$ba4368c844580f9e;

});

parcelRegister("2nsxJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jRNsq = parcelRequire("jRNsq");


var $i2CQL = parcelRequire("i2CQL");

function $d27af5912c8c4782$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const fileState = (0, $i2CQL.useMediaStore)((state)=>state.files[id]);
    (0, $42omo.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}
module.exports["useFileState"] = $d27af5912c8c4782$export$90ff537b0999afb;

});

parcelRegister("jRNsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3rvSa = parcelRequire("3rvSa");


var $9k33u = parcelRequire("9k33u");

const $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345;

});

parcelRegister("i2CQL", function(module, exports) {

var $equi6 = parcelRequire("equi6");


var $jRNsq = parcelRequire("jRNsq");

const $4af3bbf76333cbc2$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $equi6.useStore)(store, selector, equals);
function $4af3bbf76333cbc2$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $4af3bbf76333cbc2$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $4af3bbf76333cbc2$export$8a9cc8c330400af8;

});

parcelRegister("equi6", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $a80afd8c2b9b4a58$export$6ccbb43953eebf8);

var $l7KxQ = parcelRequire("l7KxQ");


var $42omo = parcelRequire("42omo");


var $hpRUx = parcelRequire("hpRUx");

var $a80afd8c2b9b4a58$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $a80afd8c2b9b4a58$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
const { useSyncExternalStoreWithSelector: $a80afd8c2b9b4a58$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($hpRUx)));
let $a80afd8c2b9b4a58$var$didWarnAboutEqualityFn = false;
const $a80afd8c2b9b4a58$var$identity = (arg)=>arg;
function $a80afd8c2b9b4a58$export$6ccbb43953eebf8(api, selector = $a80afd8c2b9b4a58$var$identity, equalityFn) {
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$a80afd8c2b9b4a58$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $a80afd8c2b9b4a58$var$didWarnAboutEqualityFn = true;
    }
    const slice = $a80afd8c2b9b4a58$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $a80afd8c2b9b4a58$var$useDebugValue(slice);
    return slice;
}
const $a80afd8c2b9b4a58$var$createImpl = (createState)=>{
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $l7KxQ.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$a80afd8c2b9b4a58$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $a80afd8c2b9b4a58$export$185802fd694ee1f5 = (createState)=>createState ? $a80afd8c2b9b4a58$var$createImpl(createState) : $a80afd8c2b9b4a58$var$createImpl;
var $a80afd8c2b9b4a58$export$2e2bcd8739ae039 = (createState)=>{
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $a80afd8c2b9b4a58$export$185802fd694ee1f5(createState);
};

});

parcelRegister("8QL6C", function(module, exports) {

var $6mxnm = parcelRequire("6mxnm");


var $hMBjV = parcelRequire("hMBjV");


var $78fzv = parcelRequire("78fzv");

const $586e61da7604bdbd$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $586e61da7604bdbd$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $hMBjV.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $6mxnm.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $586e61da7604bdbd$export$836625761e76d373 = {
    mediaInline: false
};
function $586e61da7604bdbd$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $78fzv.getGenericFeatureFlag)(flagName, $586e61da7604bdbd$export$836625761e76d373, featureFlags);
}
module.exports["getFeatureFlagKeysAllProducts"] = $586e61da7604bdbd$export$c8bcd5e6111ea1f3;
module.exports["getMediaFeatureFlag"] = $586e61da7604bdbd$export$383e8f51978266d;

});

parcelRegister("6mxnm", function(module, exports) {
// Media feature flags - type and defaults defined here in one source of truth
const $6b97f3fad80b5910$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];
module.exports["supportedProducts"] = $6b97f3fad80b5910$export$2db74afa1ef496f1;

});

parcelRegister("hMBjV", function(module, exports) {
const $d17c6572fbd16cff$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $d17c6572fbd16cff$export$189fe120be7e73fc = ()=>$d17c6572fbd16cff$var$productKeys;
module.exports["getProductKeys"] = $d17c6572fbd16cff$export$189fe120be7e73fc;

});

parcelRegister("78fzv", function(module, exports) {

var $bcpPc = parcelRequire("bcpPc");

function $18475707c4faede4$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $bcpPc.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}
module.exports["getGenericFeatureFlag"] = $18475707c4faede4$export$f2687d0de19e4973;

});

parcelRegister("bcpPc", function(module, exports) {
// window.localStorage is easier to mock in tests if wrapped in this module
const $6c56cea62b261d1c$export$d125817a2695dbc9 = (key)=>{
    try {
        return typeof window !== 'undefined' && window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};
module.exports["getLocalMediaFeatureFlag"] = $6c56cea62b261d1c$export$d125817a2695dbc9;

});

parcelRegister("21oLb", function(module, exports) {
const $fc8b4ffdd5763df8$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $fc8b4ffdd5763df8$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $fc8b4ffdd5763df8$export$43142f95b8de7a91 = (orientation)=>{
    return $fc8b4ffdd5763df8$var$ORIENT_TRANSFORMS[orientation];
};
module.exports["isRotated"] = $fc8b4ffdd5763df8$export$8af433705f41088f;
module.exports["getCssFromImageOrientation"] = $fc8b4ffdd5763df8$export$43142f95b8de7a91;

});

parcelRegister("6YcJ1", function(module, exports) {

var $ek6ZB = parcelRequire("ek6ZB");


var $5kpUJ = parcelRequire("5kpUJ");


var $a6JW6 = parcelRequire("a6JW6");


var $21oLb = parcelRequire("21oLb");

const { Orientation: $42560c37dcf792ae$var$Orientation, XResolution: $42560c37dcf792ae$var$XResolution } = (0, $ek6ZB.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $42560c37dcf792ae$var$DPI_WEB_BASELINE = 72;
async function $42560c37dcf792ae$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $42560c37dcf792ae$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $42560c37dcf792ae$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $42560c37dcf792ae$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $42560c37dcf792ae$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $42560c37dcf792ae$var$DPI_WEB_BASELINE;
        else return $42560c37dcf792ae$export$268f92356524130b(tags, $42560c37dcf792ae$var$XResolution, $42560c37dcf792ae$var$DPI_WEB_BASELINE) / $42560c37dcf792ae$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $42560c37dcf792ae$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$42560c37dcf792ae$var$Orientation]) {
        const tagValue = tags[$42560c37dcf792ae$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $ek6ZB.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $42560c37dcf792ae$export$67689507e8404821(file) {
    const tags = await (0, $5kpUJ.readImageMetaTags)(file);
    return $42560c37dcf792ae$var$getOrientationFromTags(tags);
}
function $42560c37dcf792ae$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $42560c37dcf792ae$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $42560c37dcf792ae$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $5kpUJ.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $42560c37dcf792ae$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $42560c37dcf792ae$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $a6JW6.loadImage)(src);
        const { width: width, height: height } = (0, $a6JW6.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}
module.exports["getImageInfo"] = $42560c37dcf792ae$export$2176b0e68c10508f;
module.exports["getOrientation"] = $42560c37dcf792ae$export$67689507e8404821;

});

parcelRegister("ek6ZB", function(module, exports) {
var $8a97053409898982$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $8a97053409898982$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $8a97053409898982$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};
module.exports["ImageType"] = $8a97053409898982$export$48c85e6e32ef0825;
module.exports["SupportedImageMetaTag"] = $8a97053409898982$export$e369bb48cf33e564;
module.exports["ExifOrientation"] = $8a97053409898982$export$f6ea0c89fd7d156;

});

parcelRegister("5kpUJ", function(module, exports) {

var $ek6ZB = parcelRequire("ek6ZB");


var $gg2Io = parcelRequire("gg2Io");


var $284pz = parcelRequire("284pz");


var $joOsL = parcelRequire("joOsL");

async function $291ad249ab0ec7e3$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $ek6ZB.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $284pz.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $joOsL.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $ek6ZB.ImageType).JPEG) return await (0, $gg2Io.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}
module.exports["readImageMetaTags"] = $291ad249ab0ec7e3$export$41982b5c7acb23c4;

});

parcelRegister("gg2Io", function(module, exports) {

var $ek6ZB = parcelRequire("ek6ZB");

const { XResolution: $b1cf2398fd086f5b$var$XResolution, YResolution: $b1cf2398fd086f5b$var$YResolution } = (0, $ek6ZB.SupportedImageMetaTag);
let $b1cf2398fd086f5b$var$loadImage;

function $b1cf2398fd086f5b$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$b1cf2398fd086f5b$var$loadImage) {
            const module = await (parcelRequire("8vQIW"));
            $b1cf2398fd086f5b$var$loadImage = module.default || module;
        }
        $b1cf2398fd086f5b$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $b1cf2398fd086f5b$var$XResolution || key === $b1cf2398fd086f5b$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}
module.exports["readJPEGExifMetaData"] = $b1cf2398fd086f5b$export$556b2ccec62d7f2a;

});

parcelRegister("8vQIW", function(module, exports) {

let $632a1dd47094042d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $632a1dd47094042d$var$load("b8BDn").then(()=>parcelRequire('6fuwe'));

});

parcelRegister("284pz", function(module, exports) {

var $a6JW6 = parcelRequire("a6JW6");

let $0075b80fbc950777$var$pngChunksExtract;

async function $0075b80fbc950777$export$5fb37736440fca6f(file) {
    if (!$0075b80fbc950777$var$pngChunksExtract) {
        const module = await (parcelRequire("9MxN8"));
        $0075b80fbc950777$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $a6JW6.fileToArrayBuffer)(file);
    const chunks = $0075b80fbc950777$var$pngChunksExtract(buffer);
    return await $0075b80fbc950777$export$9185743fdd58ce45(chunks);
}
async function $0075b80fbc950777$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}
module.exports["readPNGXMPMetaData"] = $0075b80fbc950777$export$5fb37736440fca6f;

});

parcelRegister("a6JW6", function(module, exports) {

var $lzyQK = parcelRequire("lzyQK");


var $b4DX7 = parcelRequire("b4DX7");


var $dfQbH = parcelRequire("dfQbH");


var $lkBga = parcelRequire("lkBga");


var $9AnKp = parcelRequire("9AnKp");


var $d77HU = parcelRequire("d77HU");


var $4dLYc = parcelRequire("4dLYc");


var $5W6v1 = parcelRequire("5W6v1");


var $av4P2 = parcelRequire("av4P2");


var $giYeH = parcelRequire("giYeH");


var $eWLPt = parcelRequire("eWLPt");


var $gH8Rx = parcelRequire("gH8Rx");


var $iFCP2 = parcelRequire("iFCP2");


var $cQbj1 = parcelRequire("cQbj1");


var $7t8Pn = parcelRequire("7t8Pn");


var $hc71J = parcelRequire("hc71J");

function $a344fc5ee1d7372a$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $a344fc5ee1d7372a$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $a344fc5ee1d7372a$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $a344fc5ee1d7372a$export$849633012686f7ee(file)
    };
}
async function $a344fc5ee1d7372a$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $a344fc5ee1d7372a$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $a344fc5ee1d7372a$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $a344fc5ee1d7372a$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $a344fc5ee1d7372a$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $a344fc5ee1d7372a$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $a344fc5ee1d7372a$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lzyQK)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($av4P2)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eWLPt)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($av4P2)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($giYeH)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5W6v1)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cQbj1)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b4DX7)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iFCP2)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
    }
];
function $a344fc5ee1d7372a$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $a344fc5ee1d7372a$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $hc71J.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9AnKp)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d77HU)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4dLYc)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}
module.exports["dataURItoFile"] = $a344fc5ee1d7372a$export$80d19edb7b1ae293;
module.exports["fileToDataURI"] = $a344fc5ee1d7372a$export$849633012686f7ee;
module.exports["getFileInfo"] = $a344fc5ee1d7372a$export$ca39f27fe4f7d9b4;
module.exports["fileToArrayBuffer"] = $a344fc5ee1d7372a$export$956310555b96755a;
module.exports["loadImage"] = $a344fc5ee1d7372a$export$fe58198efe02b173;
module.exports["readImageNaturalOrientationFromDOM"] = $a344fc5ee1d7372a$export$325d46491952db2d;
module.exports["findParentByClassname"] = $a344fc5ee1d7372a$export$89ff65f1d45dfb03;
module.exports["getMimeIcon"] = $a344fc5ee1d7372a$export$61a1de0822e2820;

});

parcelRegister("d77HU", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $98c1e84a3b388e2b$var$_react = $98c1e84a3b388e2b$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $98c1e84a3b388e2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $98c1e84a3b388e2b$var$Figma24Icon = (props)=>/*#__PURE__*/ $98c1e84a3b388e2b$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$98c1e84a3b388e2b$var$Figma24Icon.displayName = 'Figma24Icon';
var $98c1e84a3b388e2b$var$_default = module.exports.default = $98c1e84a3b388e2b$var$Figma24Icon;

});

parcelRegister("9MxN8", function(module, exports) {

let $71f2cf053b480bb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $71f2cf053b480bb9$var$load("dLFEp").then(()=>parcelRequire('ahNRS'));

});

parcelRegister("joOsL", function(module, exports) {
function $2efab4fabe8932ef$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}
module.exports["parseXMPMetaData"] = $2efab4fabe8932ef$export$55c3bc9841b19de2;

});

parcelRegister("aWYXa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gxsT9 = parcelRequire("gxsT9");


var $cbc8g = parcelRequire("cbc8g");


var $2wyC2 = parcelRequire("2wyC2");


var $21oLb = parcelRequire("21oLb");


var $iP9n7 = parcelRequire("iP9n7");

const $e496909ca63f7b47$export$1f97dc1e9d072692 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ dataURI: dataURI, alt: alt = '', crop: crop = false, stretch: stretch = false, previewOrientation: previewOrientation = 1, crossOrigin: crossOrigin, onImageLoad: onImageLoad, onImageError: onImageError, loading: loading, forceSyncDisplay: forceSyncDisplay = false }, ref)=>{
    const [{ width: parentWidth, height: parentHeight }, setParentDimensions] = (0, $42omo.useState)({
        width: Infinity,
        height: Infinity
    });
    const [{ width: imgWidth, height: imgHeight }, setImageDimensions] = (0, $42omo.useState)({
        width: 0,
        height: 0
    });
    const [isImageLoaded, setIsImageLoaded] = (0, $42omo.useState)(false);
    const imgRef = (0, $42omo.useRef)(null);
    const imageRef = (0, $42omo.useCallback)((imgElem)=>{
        if (!imgElem || imgRef.current) return;
        if (imgElem.parentElement) {
            const { width: width, height: height } = imgElem.parentElement.getBoundingClientRect();
            setParentDimensions({
                width: width,
                height: height
            });
        }
        imgRef.current = imgElem;
    }, []);
    const mergedRef = (0, $iP9n7.useMergeRefs)([
        imageRef,
        ref
    ]);
    const imageLoadHandler = (e)=>{
        if (!imgRef.current) return;
        setImageDimensions({
            width: imgRef.current.naturalWidth,
            height: imgRef.current.naturalHeight
        });
        setIsImageLoaded(true);
        onImageLoad?.(e.currentTarget);
    };
    const parentRatio = parentWidth / parentHeight;
    let imgRatio = imgWidth / imgHeight;
    let percentSize = '100%';
    /*
      Cover strategy means we want to full entire screen with an image. Here is an example:

         Image           Container   Result (░ - is what cropped out)
     ┌──────────────┐    ┌──────┐    ┌───┬──────┬───┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    └──────┘    └───┴──────┴───┘
     └──────────────┘
    */ const isCoverStrategy = crop;
    /*
      Fit strategy means image is fully inside container even if there is empty space left.
      Here is an example:

             Image            Container     Result
     ┌────────────────────┐    ┌──────┐    ┌──────┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     └────────────────────┘    └──────┘    └──────┘
     */ const isFitStrategy = !crop;
    const isImageRotated = previewOrientation !== 'from-image' && (0, $21oLb.isRotated)(previewOrientation);
    /*
      When photo has orientation of 90deg or 270deg (stored in EXIF meta data)
      things get very tricky. Let me go through an two examples to explain how we deal with that:

      Example #1:

      Image comes in as    ________    But it needs to be     ┌──────┐
      horizontal picture  |        |   displayed as 750x1000  │      │
      of 1000x750         |        |   because orientation    │      │
                          |________|   say it must be rotated │      │
                                       90 degrees             │      │
                                                              └──────┘

      Container is smaller, and has dimensions of 100x200.
      So, input parameters are:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: true (means we want to cover)
        stretch: true
        previewOrientation: 6

      To see what true value of isImageMoreLandscapyThanContainer is we need to flip imgRatio.
      Since initial value is 1000/750 = 1.33 we can just do 1/1.3333 = 0.75.

      In this situation final values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: true
        isFitStrategy: false
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

      According to this variables state css will become:
        height: 100%;

      Now here is what going to happened.
      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply height: 100%.

      ┌────┬──────┬────┐  This will scale an image according to rules of proportions:
      │░░░░│▓▓▓▓▓▓│░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      │░░░░│▓▓▓▓▓▓│░░░░│  (orig img height) -> (scaled down img height)
      │░░░░│▓▓▓▓▓▓│░░░░│  750px             -> 200px  (is === container height, since `height: 100%`)
      └────┴──────┴────┘  (orig img width)  -> (scaled down img width)
              ↑           1000px            -> (200 x 1000) / 750 = 266.66px
       266x200 image in
       100x200 container.

      And only NOW browser will apply rotate: 90deg and turn image around.
      And we end up with this:

      ┌──────────┐   Where 200x266 image
      │░░░░░░░░░░│   in the 100x200 container.
      │░┌──────┐░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░└──────┘░│
      │░░░░░░░░░░│
      └──────────┘

      To combat this we will not make height: 100% but use ratio of an image.
      In this case imgRatio is now 0.75 (after flipping)

      New math will look like this:
      (orig img height) -> (scaled down img height)
      750px             -> (0.75 x 200px) = 150px (since `height: 75%`)
      (orig img width)  -> (scaled down img width)
      1000px            -> (150 x 1000) / 750 = 200px

      ┌─┬──────┬─┐  Now 150x200 image
      │░│▓▓▓▓▓▓│░│  is in 100x200 container.
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      └─┴──────┴─┘

      Unfortunately this is not over yet.



      Example #2:

      Input parameters:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: false (means we want to fit)  <-- This is only changed parameter
        stretch: true
        previewOrientation: 6

      Final variable values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: false
        isFitStrategy: true
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

       According to this variables state css will become:
        width: 100%;

      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply width: 100%.

      ┌────────┐  This will scale an image according to rules of proportions:
      │░░░░░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      ├────────┤  (orig img width)  -> (scaled down img width)
      │▓▓▓▓▓▓▓▓│  1000px            -> 100px (is === container width, since `width: 100%`)
      │▓▓▓▓▓▓▓▓│  (orig img height) -> (scaled down img height)
      ├────────┤  750px             -> (750x100) / 1000 = 75px
      │░░░░░░░░│
      └────────┘
          ↑
       100x75 image in
       100x200 container.

      Now browser will turn image 90degrees and we und up with:
      ┌──────────┐
      │          │  75x100 image in
      │ ┌──────┐ │  100x200 container
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ └──────┘ │
      │          │
      └──────────┘

      This looks familiar, and you might want to try what we did before and apply 75% not 100%.
      Unfortunately this will make it even worse. If you do calculation you will find out that
      final result will be 75x56 image in 100x200 container. For this and one more specific
      variables state we need to use original imgRatio for percent size. In this case it's 1.333, so
      134%

      New math will look like this:
      (orig img width)  -> (scaled down img width)
      1000px            -> (100px * 1.34) = 134px (since `width: 134%`)
      (orig img height) -> (scaled down img height)
      750px             -> (750x134) / 1000 = 100px

      So, 100x134 image in 100x200 container.
     */ if (isImageRotated) {
        imgRatio = 1 / imgRatio;
        percentSize = `${Math.ceil(imgRatio * 100)}%`;
    }
    /*
      Here is an example of when isImageMoreLandscapyThanContainer is true:

        Image      Container   OR   Image      Container
       ________      _____          ____           __
      |        | -> |     |        |    |   ->    |  |
      |________|    |_____|        |    |         |  |
                                   |    |         |  |
                                   |    |         |  |
                                   |____|         |__|

      For false just swap "Image" and "Container" in the example above.
     */ const isImageMoreLandscapyThanContainer = imgRatio > parentRatio;
    const isImgLandscape = imgWidth > imgHeight;
    /*
    This is two cases we need to cover as described in Example #2 above, but only for rotated landscape images.
     */ if (isImageRotated && isImgLandscape) {
        if (isFitStrategy || isImageMoreLandscapyThanContainer || isCoverStrategy && !isImageMoreLandscapyThanContainer) percentSize = `${Math.ceil(1 / imgRatio * 100)}%`;
    }
    /*
      When isStretchingAllowed is false image is as big as it is, but as small as container
      (according to strategy - cover or fit).
      isStretchingAllowed is true if image is bigger then container.
     */ const isStretchingAllowed = stretch;
    /*
      We do not want to show image until we finish deciding on sizing strategy.
      Though if it is a "fit" strategy (and image hasn't been rotated) we can display it right away,
      since it doesn't depend on isImageMoreLandscapyThanContainer nor it will change when isStretchingAllowed
      changes it's value after imgRatio and parentRatio get defined.
      The reason for exclude isImageRotated is that we need to calculate percentSize variable
      and we can do that only when image is loaded (and we have image size)
     */ const showImage = forceSyncDisplay || isImageLoaded || isFitStrategy && !isImageRotated;
    const style = {
        transform: 'translate(-50%, -50%)'
    };
    if (isStretchingAllowed) {
        if (isFitStrategy && isImageMoreLandscapyThanContainer) /*
          Image matches its width to container's and height scales accordingly.

            Image       Container       Result
                       ┌─────────┐    ┌─────────┐
           ┌──────┐    │         │    ├─────────┤
           │▓▓▓▓▓▓│ -> │         │ => │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           └──────┘    │         │    ├─────────┤
                       └─────────┘    └─────────┘
         */ style.width = percentSize;
        else if (isFitStrategy && !isImageMoreLandscapyThanContainer) /*
          Image matches its height to container's and width scales accordingly.
         */ style.height = percentSize;
        else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          In order to cover whole container guaranteed (even in expense of stretching)
          image matches its height to container's. Width scales accordingly and crops out sides.

             Image       Container    Result (░ - is what cropped out)
                       ┌─────────┐    ┌──┬──────┬──┐
           ┌──────┐    │         │    │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│ -> │         │ => │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│    │         │    │░░│▓▓▓▓▓▓│░░│
           └──────┘    │         │    │░░│▓▓▓▓▓▓│░░│
                       └─────────┘    └──┴──────┴──┘
         */ style.height = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.width = percentSize;
    } else {
        if (isFitStrategy) {
            /*
          We want image to be as wide and as height as container but not bigger then it's own size.

            Image       Container       Result
           ┌───────────┐    ┌─────────┐    ┌─────────┐
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    ├─────────┤
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓▓▓▓▓▓│->  │         │ => │▓▓▓▓▓▓▓▓▓│
           └───────────┘    │         │    │▓▓▓▓▓▓▓▓▓│
                            │         │    ├─────────┤
                            └─────────┘    └─────────┘

         And if image is smaller it doesn't change its size

            Image       Container       Result
                       ┌──────────┐    ┌──────────┐
                       │          │    │          │
           ┌──────┐    │          │    │ ┌──────┐ │
           │▓▓▓▓▓▓│ -> │          │ => │ │▓▓▓▓▓▓│ │
           │▓▓▓▓▓▓│    │          │    │ │▓▓▓▓▓▓│ │
           └──────┘    │          │    │ └──────┘ │
                       │          │    │          │
                       └──────────┘    └──────────┘
         */ style.maxWidth = percentSize;
            style.maxHeight = percentSize;
        } else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          We want to fill container but we can't stretch an image if it's smaller then container.

            Image            Container       Result
           ┌────────────┐    ┌───────┐    ┌──┬───────┬──┐
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│->  │       │ => │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    └───────┘    └──┴───────┴──┘
           └────────────┘

         */ style.maxHeight = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.maxWidth = percentSize;
    }
    if (!showImage || !dataURI) style.display = 'none';
    if (previewOrientation === 'from-image') style.imageOrientation = 'from-image';
    else if (previewOrientation > 1) {
        const transform = (0, $21oLb.getCssFromImageOrientation)(previewOrientation);
        style.transform += ` ${transform}`;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbc8g.default), {
        data: {
            hasMediaComponent: true
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2wyC2.ImageComponent), {
        loading: loading,
        "data-testid": "media-image",
        "data-vc": "media-image",
        draggable: false,
        alt: alt,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onLoad: imageLoadHandler,
        onError: onImageError,
        imageRef: mergedRef,
        src: dataURI,
        crossOrigin: crossOrigin,
        ...(0, $gxsT9.VcMediaWrapperProps)
    }));
});
module.exports["MediaImage"] = $e496909ca63f7b47$export$1f97dc1e9d072692;

});

parcelRegister("2wyC2", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 
var $42omo = parcelRequire("42omo");

/*
  TODO: https://product-fabric.atlassian.net/browse/CXP-3132

  We need to revisit omitting percentage values for Design Token since the parent applies transform(-50%, -50%) on it (packages/media/media-ui/src/mediaImage/index.tsx). This styling is complex and may potentially cause a bug if not treaded carefully.
*/ const $a49532cd1c66edc2$var$imgStyle = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    objectFit: 'contain',
    imageOrientation: 'none'
};
const $a49532cd1c66edc2$export$fd536c918b58ab76 = (props)=>{
    const { style: style, imageRef: imageRef, ...otherProps } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlassian/a11y/alt-text -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        ...otherProps,
        ref: imageRef,
        style: {
            ...$a49532cd1c66edc2$var$imgStyle,
            ...style
        }
    }));
};
module.exports["ImageComponent"] = $a49532cd1c66edc2$export$fd536c918b58ab76;

});

parcelRegister("k0QVR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hZ6O7 = parcelRequire("hZ6O7");

var $dIgeg = parcelRequire("dIgeg");


var $hXlr4 = parcelRequire("hXlr4");

var $2nsxJ = parcelRequire("2nsxJ");

var $jRNsq = parcelRequire("jRNsq");


var $JXmwv = parcelRequire("JXmwv");


var $dh538 = parcelRequire("dh538");


var $9x4nt = parcelRequire("9x4nt");


var $fgSvy = parcelRequire("fgSvy");


var $cCL2U = parcelRequire("cCL2U");


var $kJP4J = parcelRequire("kJP4J");

var $2dkDS = parcelRequire("2dkDS");

var $gL31c = parcelRequire("gL31c");


var $CPDDv = parcelRequire("CPDDv");

var $dXMn6 = parcelRequire("dXMn6");


var $hNBEk = parcelRequire("hNBEk");

// invisible gif for SSR preview to show the underlying spinner until the src is replaced by
// the actual image src in the inline script
const $24cb43d67162c399$var$DEFAULT_SSR_PREVIEW = {
    dataURI: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    dimensions: {
        width: 100,
        height: 100
    },
    source: 'ssr-server'
};
const $24cb43d67162c399$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, useSrcSet: useSrcSet = false, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const [status, setStatus] = (0, $42omo.useState)('loading');
    const [error, setError] = (0, $42omo.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $42omo.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $42omo.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $42omo.useState)('not-resolved');
    const ssrReliabilityRef = (0, $42omo.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $9x4nt.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        if (isLoading && (0, $dh538.fg)('platform_close_image_blindspot_2')) return ufoContext?.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $42omo.useMemo)(()=>dimensions ? (0, $hNBEk.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $hNBEk.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $gL31c.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $dXMn6.getSSRData)(identifier, resizeMode);
            if (ssrData?.error) ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                server: {
                    status: 'fail',
                    ...ssrData.error
                }
            };
            if (!ssrData?.dataURI) try {
                return (0, $kJP4J.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current = {
                    ...ssrReliabilityRef.current,
                    [ssr]: {
                        status: 'fail',
                        ...(0, $fgSvy.extractErrorInfo)(e, traceContext)
                    }
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI, srcSet: srcSet, loading: loading } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data',
                    srcSet: srcSet,
                    lazy: loading === 'lazy'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $42omo.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $2nsxJ.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $hZ6O7.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $42omo.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $42omo.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $cCL2U.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $cCL2U.MediaFilePreviewError)('metadata-fetch', (0, $dIgeg.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // SSR Loading
    //----------------------------------------------------------------
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('media-perf-uplift-mutation-fix')) return;
        const loadPromise = (0, $dXMn6.getSSRData)(identifier, resizeMode)?.loadPromise;
        if (preview && (0, $kJP4J.isSSRDataPreview)(preview) && loadPromise) loadPromise.then(()=>{
            setStatus('complete');
        }).catch(()=>{
            setPreview(undefined);
        });
    }, [
        preview,
        identifier,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $hNBEk.useCurrentValueRef)(()=>{
        return (0, $kJP4J.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $42omo.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $hNBEk.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $hNBEk.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $42omo.useEffect)(()=>{
        const cachedPreview = (0, $gL31c.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $hNBEk.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $2dkDS.isSupportedLocalPreview)(mediaType) && (0, $JXmwv.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $kJP4J.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview || (0, $hNBEk.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $kJP4J.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            // If the preview is SSR, we can skip the refetch as it will be handled by the global scope promise
            // If the preview is not wider than the requested dimensions, we can skip the refetch
            if (preview && (0, $kJP4J.isSSRPreview)(preview) && !(0, $hNBEk.isWider)(preview.dimensions, dimensions) && (0, $dh538.fg)('media-perf-uplift-mutation-fix')) return;
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
                const wrappedError = (0, $cCL2U.ensureMediaFilePreviewError)('preview-fetch', e);
                if (!preview) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus,
        dimensions
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $42omo.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $kJP4J.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current = {
            ...ssrReliabilityRef.current,
            client: (0, $fgSvy.createFailedSSRObject)(failedPreview, traceContext)
        };
        const isSSR = (0, $kJP4J.isSSRDataPreview)(failedPreview) || (0, $kJP4J.isSSRClientPreview)(failedPreview);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if (isSSR) ssrReliabilityRef.current = {
            server: (0, $fgSvy.createFailedSSRObject)(failedPreview, traceContext),
            client: (0, $fgSvy.createFailedSSRObject)(failedPreview, traceContext)
        };
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $kJP4J.isLocalPreview)(failedPreview);
        const isRemote = (0, $kJP4J.isRemotePreview)(failedPreview);
        if (isLocal || isRemote || isSSR) {
            const error = new (0, $cCL2U.ImageLoadError)(failedPreview?.source);
            (0, $gL31c.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $42omo.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $kJP4J.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                client: {
                    status: 'success'
                }
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $kJP4J.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') ssrReliabilityRef.current = {
                server: {
                    status: 'success'
                },
                client: {
                    status: 'success'
                }
            };
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $CPDDv.generateScriptProps)(identifier, preview?.dataURI, resizeMode, preview?.srcSet, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined, {
            'media-perf-uplift-mutation-fix': (0, $dh538.fg)('media-perf-uplift-mutation-fix'),
            'media-perf-lazy-loading-optimisation': (0, $dh538.fg)('media-perf-lazy-loading-optimisation')
        }) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $hXlr4.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: ssr === 'server' && useSrcSet && (0, $dh538.fg)('media-perf-uplift-mutation-fix') ? $24cb43d67162c399$var$DEFAULT_SSR_PREVIEW : preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};
module.exports["useFilePreview"] = $24cb43d67162c399$export$4eaebdef02112fe4;

});

parcelRegister("hXlr4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $jRNsq = parcelRequire("jRNsq");


var $c5usV = parcelRequire("c5usV");


var $fLL9S = parcelRequire("fLL9S");

function $cc642dccb112c2b8$var$useCurrentValueRef(value) {
    const ref = (0, $42omo.useRef)(value);
    ref.current = value;
    return ref;
}
const $cc642dccb112c2b8$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const innerRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const registerCopyIntentRef = $cc642dccb112c2b8$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $c5usV.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $c5usV.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $42omo.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $dh538.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $42omo.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('platform_media_cross_client_copy')) (0, $fLL9S.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $fLL9S.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};
module.exports["useCopyIntent"] = $cc642dccb112c2b8$export$46fd859414de9d62;

});

parcelRegister("c5usV", function(module, exports) {

var $2ASLw = parcelRequire("2ASLw");

const $e6e8f319cddd6152$var$getRequestErrorDetails = (err)=>{
    if ((0, $2ASLw.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
    return undefined;
};
const $e6e8f319cddd6152$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $2ASLw.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$e6e8f319cddd6152$var$getRequestErrorDetails(error)
        }
    };
};
const $e6e8f319cddd6152$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};
module.exports["getCopyIntentErrorPayload"] = $e6e8f319cddd6152$export$3ab52330b662b987;
module.exports["getCopyIntentSuccessPayload"] = $e6e8f319cddd6152$export$aacb463551da2e8f;

});

parcelRegister("fLL9S", function(module, exports) {
const $88290e8f8b3102b1$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};
module.exports["getDocument"] = $88290e8f8b3102b1$export$f65ca476c09acec0;

});

parcelRegister("fgSvy", function(module, exports) {

var $dIgeg = parcelRequire("dIgeg");


var $cCL2U = parcelRequire("cCL2U");

const $2de7fc98fb618862$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $2de7fc98fb618862$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $2de7fc98fb618862$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $2de7fc98fb618862$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $2de7fc98fb618862$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $2de7fc98fb618862$export$4af9d71992e89714(error),
        error: $2de7fc98fb618862$export$88c61dcad53762da(error),
        errorDetail: $2de7fc98fb618862$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $2de7fc98fb618862$export$29aa614726672b2e(error)
    };
};
const $2de7fc98fb618862$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$2de7fc98fb618862$export$74aaf4784c2edb2c(new (0, $cCL2U.ImageLoadError)(preview.source), metadataTraceContext)
    });
module.exports["extractErrorInfo"] = $2de7fc98fb618862$export$74aaf4784c2edb2c;
module.exports["createFailedSSRObject"] = $2de7fc98fb618862$export$768c370ed0dbaeb3;

});

parcelRegister("cCL2U", function(module, exports) {
class $3c049ab9f06e4fad$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $3c049ab9f06e4fad$export$2c035820a31723e extends $3c049ab9f06e4fad$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $3c049ab9f06e4fad$export$10ab445310d30114 extends $3c049ab9f06e4fad$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $3c049ab9f06e4fad$export$18e89b7e50818288 extends $3c049ab9f06e4fad$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $3c049ab9f06e4fad$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $3c049ab9f06e4fad$export$d0a45ab59b4606b extends $3c049ab9f06e4fad$export$96e559194c287cf4 {
    constructor(source){
        super($3c049ab9f06e4fad$var$getImageLoadPrimaryReason(source));
    }
}
function $3c049ab9f06e4fad$export$553696a6e769784c(err) {
    return err instanceof $3c049ab9f06e4fad$export$96e559194c287cf4;
}
const $3c049ab9f06e4fad$export$b380593ba3516c6f = (err)=>err instanceof $3c049ab9f06e4fad$export$2c035820a31723e;
const $3c049ab9f06e4fad$export$e1d87830b3784f94 = (err)=>err instanceof $3c049ab9f06e4fad$export$10ab445310d30114;
const $3c049ab9f06e4fad$export$443aeb298d35d79d = (err)=>$3c049ab9f06e4fad$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $3c049ab9f06e4fad$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($3c049ab9f06e4fad$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $3c049ab9f06e4fad$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $3c049ab9f06e4fad$export$96e559194c287cf4(primaryReason, error);
};
module.exports["MediaFilePreviewError"] = $3c049ab9f06e4fad$export$96e559194c287cf4;
module.exports["LocalPreviewError"] = $3c049ab9f06e4fad$export$2c035820a31723e;
module.exports["RemotePreviewError"] = $3c049ab9f06e4fad$export$10ab445310d30114;
module.exports["SsrPreviewError"] = $3c049ab9f06e4fad$export$18e89b7e50818288;
module.exports["ImageLoadError"] = $3c049ab9f06e4fad$export$d0a45ab59b4606b;
module.exports["ensureMediaFilePreviewError"] = $3c049ab9f06e4fad$export$7156ce7b78b49bd7;

});

parcelRegister("kJP4J", function(module, exports) {

var $Girkv = parcelRequire("Girkv");


var $cCL2U = parcelRequire("cCL2U");


var $gL31c = parcelRequire("gL31c");


var $2dkDS = parcelRequire("2dkDS");

const $8efa99034f89c3f1$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $Girkv.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $gL31c.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $8efa99034f89c3f1$var$getDataUri = (mediaClient, id, params, mediaBlobUrlAttrs)=>{
    const rawDataURI = mediaClient.getImageUrlSync(id, params);
    return mediaBlobUrlAttrs ? (0, $Girkv.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
};
const $8efa99034f89c3f1$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    try {
        const dataURI = $8efa99034f89c3f1$var$getDataUri(mediaClient, id, params, mediaBlobUrlAttrs);
        let srcSet = `${dataURI} 1x`;
        if (params.width) {
            const doubleDataURI = $8efa99034f89c3f1$var$getDataUri(mediaClient, id, {
                ...params,
                width: params.width * 2,
                height: params.height && params.height * 2
            }, mediaBlobUrlAttrs);
            // We want to embed some meta context into dataURI for Copy/Paste to work.
            srcSet += `, ${doubleDataURI} 2x`;
        }
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1,
            srcSet: srcSet
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $cCL2U.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $8efa99034f89c3f1$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $8efa99034f89c3f1$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $8efa99034f89c3f1$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $8efa99034f89c3f1$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $8efa99034f89c3f1$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $8efa99034f89c3f1$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $2dkDS.getRemotePreview)(mediaClient, id, params, traceContext);
    return $8efa99034f89c3f1$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $8efa99034f89c3f1$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $2dkDS.getLocalPreview)(filePreview);
    return $8efa99034f89c3f1$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
module.exports["getSSRPreview"] = $8efa99034f89c3f1$export$faf1c301c59a1bdc;
module.exports["isLocalPreview"] = $8efa99034f89c3f1$export$78ad02c5efc361c9;
module.exports["isRemotePreview"] = $8efa99034f89c3f1$export$87442a14a8a19e0;
module.exports["isSSRClientPreview"] = $8efa99034f89c3f1$export$36aae1afbc0a9661;
module.exports["isSSRDataPreview"] = $8efa99034f89c3f1$export$f366c2c8a792cce6;
module.exports["isSSRPreview"] = $8efa99034f89c3f1$export$dea79d05143ccf4;
module.exports["getAndCacheRemotePreview"] = $8efa99034f89c3f1$export$49721bcc26fb9388;
module.exports["getAndCacheLocalPreview"] = $8efa99034f89c3f1$export$98e935d981c884d;

});

parcelRegister("gL31c", function(module, exports) {

var $2hUgu = parcelRequire("2hUgu");

const $35b59c22b0648810$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $35b59c22b0648810$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $35b59c22b0648810$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $35b59c22b0648810$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $35b59c22b0648810$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $35b59c22b0648810$export$b7e8ee3f7a41459 = new $35b59c22b0648810$export$7b50526c091bb915((0, $2hUgu.createObjectURLCache)());
module.exports["mediaFilePreviewCache"] = $35b59c22b0648810$export$b7e8ee3f7a41459;

});

parcelRegister("2hUgu", function(module, exports) {

var $majy4 = parcelRequire("majy4");


var $9trs7 = parcelRequire("9trs7");

const $0bd1a53c7b384653$export$36d0f9859761643d = 50;
class $0bd1a53c7b384653$var$ExtendedLRUCache extends (0, $9trs7.LRUMap) {
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
    constructor(limit){
        super(limit);
        this.eventEmitter = void 0;
        this.eventEmitter = new (0, $majy4.EventEmitter2)();
    }
}
class $0bd1a53c7b384653$export$75d1c8c9ba1d0773 {
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
    constructor(size){
        this.cache = void 0;
        this.cache = new $0bd1a53c7b384653$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
}
const $0bd1a53c7b384653$export$ba71be67d5c32535 = ()=>new $0bd1a53c7b384653$export$75d1c8c9ba1d0773($0bd1a53c7b384653$export$36d0f9859761643d);
module.exports["createObjectURLCache"] = $0bd1a53c7b384653$export$ba71be67d5c32535;

});

parcelRegister("2dkDS", function(module, exports) {

var $24z7I = parcelRequire("24z7I");


var $6YcJ1 = parcelRequire("6YcJ1");


var $cCL2U = parcelRequire("cCL2U");


var $eyZtk = parcelRequire("eyZtk");

const $706888ba5ac0fb3d$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $706888ba5ac0fb3d$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $6YcJ1.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $cCL2U.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $706888ba5ac0fb3d$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $eyZtk.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $cCL2U.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $706888ba5ac0fb3d$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $cCL2U.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $24z7I.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $706888ba5ac0fb3d$var$getImageLocalPreview(value);
            case 'video':
                return $706888ba5ac0fb3d$var$getVideoLocalPreview(value);
            default:
                throw new (0, $cCL2U.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $cCL2U.LocalPreviewError)('local-preview-unsupported');
};
const $706888ba5ac0fb3d$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $cCL2U.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};
module.exports["isSupportedLocalPreview"] = $706888ba5ac0fb3d$export$1fa85b75e8662d54;
module.exports["getLocalPreview"] = $706888ba5ac0fb3d$export$3d6ed68e437b8c99;
module.exports["getRemotePreview"] = $706888ba5ac0fb3d$export$bfe20bd01db02b3;

});

parcelRegister("eyZtk", function(module, exports) {
const $5b6ea74f3cda8ff5$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};
module.exports["takeSnapshot"] = $5b6ea74f3cda8ff5$export$4269d30173168e5c;

});

parcelRegister("CPDDv", function(module, exports) {
const $bd2cdc2cc4d0320a$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $bd2cdc2cc4d0320a$export$d26005e8749921c9 = 'mediaCountSsr';
const $bd2cdc2cc4d0320a$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
const $bd2cdc2cc4d0320a$var$MAX_EAGER_LOAD_COUNT = 6;
function $bd2cdc2cc4d0320a$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $bd2cdc2cc4d0320a$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $bd2cdc2cc4d0320a$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $bd2cdc2cc4d0320a$var$dashed = (param)=>param ? `-${param}` : '';
const $bd2cdc2cc4d0320a$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey }, resizeMode)=>`${id}${$bd2cdc2cc4d0320a$var$dashed(collectionName)}${$bd2cdc2cc4d0320a$var$dashed(occurrenceKey)}${$bd2cdc2cc4d0320a$var$dashed(resizeMode)}`;
const $bd2cdc2cc4d0320a$var$generateScript = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>{
    const key = $bd2cdc2cc4d0320a$export$a47fb462a08de82f(identifier, mode);
    // Serialize the parameters for injection into the script
    const params = {
        key: key,
        dataURI: dataURI,
        mode: mode,
        srcSet: srcSet,
        dimensions: dimensions,
        error: error,
        featureFlags: featureFlags,
        maxEagerLoadCount: $bd2cdc2cc4d0320a$var$MAX_EAGER_LOAD_COUNT
    };
    // Read originalScriptCode.ts before making changes
    return `!function(){function e(){const e="__MEDIA_INTERNAL";return window[e]||(window[e]={}),window[e]}!function(n){var t;const i=document.currentScript,o=function(){const n=e(),t="mediaCardSsr";return n[t]||(n[t]={}),n[t]}(),r=function(){const n=e(),t="mediaCountSsr";return n[t]||(n[t]=0),n[t]}(),{key:d}=n,a=n.dataURI,s=n.mode,c=n.srcSet,{dimensions:m}=n,{error:u}=n,{featureFlags:l}=n;if(l["media-perf-uplift-mutation-fix"]){const t=o[d],f=t&&t.mode===s&&t.dimensions&&t.dimensions.width&&m&&m.width&&t.dimensions.width>m.width,w=f?t.srcSet:c,g=f?t.dataURI:a,p={dataURI:g,dimensions:m,error:u,srcSet:w,loading:"lazy",loadPromise:void 0,mode:s},S=i&&i.parentElement&&i.parentElement.querySelector("img");S&&l["media-perf-lazy-loading-optimisation"]&&r<n.maxEagerLoadCount&&(!function(){const n=e(),t="mediaCountSsr";n[t]||(n[t]=0),n[t]++}(),"lazy"===S.getAttribute("loading")&&S.removeAttribute("loading"),p.loading=""),S&&g&&(S.src=g),S&&w&&(S.srcset=w),p.loadPromise=new Promise((function(e,n){S&&(S.addEventListener("load",(function(){e(void 0)})),S.addEventListener("error",(function(){n(new Error("Failed to load image"))})))})),o[d]=f?t:p}else o[d]={dataURI:a,dimensions:m,error:u};null===(t=document.currentScript)||void 0===t||t.remove()}({replace:""})}();`.replace('{replace:""}', JSON.stringify(params));
};
const $bd2cdc2cc4d0320a$export$de7c49925e44d75d = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>({
        dangerouslySetInnerHTML: {
            __html: $bd2cdc2cc4d0320a$var$generateScript(identifier, dataURI, mode, srcSet, dimensions, error, featureFlags)
        }
    });
module.exports["getMediaCardSSR"] = $bd2cdc2cc4d0320a$export$ede93d4564eaa8da;
module.exports["getKey"] = $bd2cdc2cc4d0320a$export$a47fb462a08de82f;
module.exports["generateScriptProps"] = $bd2cdc2cc4d0320a$export$de7c49925e44d75d;

});

parcelRegister("dXMn6", function(module, exports) {

var $CPDDv = parcelRequire("CPDDv");

const $f006128302984542$export$d3a890b0f7844b6f = (identifier, resizeMode)=>{
    const mediaCardSsr = (0, $CPDDv.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $CPDDv.getKey)(identifier, resizeMode)];
};
module.exports["getSSRData"] = $f006128302984542$export$d3a890b0f7844b6f;

});

parcelRegister("hNBEk", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5debdc9c0997a52e$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
const $5debdc9c0997a52e$export$ae6224430098bc5f = (current, next)=>{
    if (current === undefined && next !== undefined) return true;
    const currentWidth = current?.width || 0;
    const nextWidth = next?.width || 0;
    return currentWidth < nextWidth;
};
/** Verifies if the current screen is retina display */ function $5debdc9c0997a52e$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $5debdc9c0997a52e$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $5debdc9c0997a52e$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $5debdc9c0997a52e$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $42omo.useRef)(value);
    ref.current = value;
    return ref;
}
module.exports["isBigger"] = $5debdc9c0997a52e$export$912a00e9a5470d9a;
module.exports["isWider"] = $5debdc9c0997a52e$export$ae6224430098bc5f;
module.exports["createRequestDimensions"] = $5debdc9c0997a52e$export$3063221e86a58f9;
module.exports["useCurrentValueRef"] = $5debdc9c0997a52e$export$b3e10e1f0fbb71db;

});

parcelRegister("46EIy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cewj5 = parcelRequire("cewj5");


var $6ZDLj = parcelRequire("6ZDLj");


var $dh538 = parcelRequire("dh538");

const $340ce807e864e408$var$DURATION_MIN = 0.5;
const $340ce807e864e408$var$DURATION_MAX = 1.0;
const $340ce807e864e408$var$EXTRA_PADDING = 4;
const $340ce807e864e408$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $340ce807e864e408$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $340ce807e864e408$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
   * The furthest we can scroll, where the end of the buffer is just in view
   */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $340ce807e864e408$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $340ce807e864e408$var$DURATION_MAX - $340ce807e864e408$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $340ce807e864e408$var$DURATION_MAX), $340ce807e864e408$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $340ce807e864e408$export$ba458cf715b18bd1);
        }
    }
    triggerScrollEvent() {
        if (!this.windowElement) return;
        const event = document.createEvent('MouseEvents');
        event.initEvent('scroll', true, true);
        this.windowElement.dispatchEvent(event);
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $340ce807e864e408$var$EXTRA_PADDING) return newOffset - $340ce807e864e408$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $340ce807e864e408$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $340ce807e864e408$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
        if (!(0, $dh538.fg)('platform_editor_disable_trigger_scroll_event')) // trigger a "real" scroll event so lazily loaded cards realize they've been shown
        // note: we have to wait for the transition to end, otherwise the cards not visible when the scroll
        // event is triggered will be forever stuck in the loading screen (due to the lazy load)
        window.setTimeout(()=>this.triggerScrollEvent(), this.transitionDuration * 1000);
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripViewWrapper), {
            "data-testid": testId
        }, this.renderLeftArrow(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripListWrapper), {
            ref: this.handleWindowElementChange,
            onWheel: this.handleScroll,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            "data-testid": "filmstrip-list-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripList), {
            ref: this.handleBufferElementChange,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                transform: transform,
                transitionProperty: transitionProperty,
                transitionDuration: transitionDuration
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, $340ce807e864e408$var$mapReactChildToReactNode))), this.renderRightArrow());
    }
    constructor(props){
        super(props);
        this.bufferElement = void 0;
        this.windowElement = void 0;
        this.mutationObserver = void 0;
        this.childOffsets = void 0;
        this.previousOffset = 0;
        this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        };
        this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, _index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        };
        this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        };
        this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        };
        this.handleMutation = (_mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        };
        this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        };
        this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        };
        this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($cewj5)))(this.handleMutation, 30, true));
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
}
$340ce807e864e408$export$817db220b90d8024.defaultProps = {
    animate: false,
    offset: 0
};
function $340ce807e864e408$var$mapReactChildToReactNode(child, index) {
    const key = $340ce807e864e408$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripListItem), {
        key: key,
        index: key
    }, child);
}
function $340ce807e864e408$var$isReactElement(child) {
    return !!child.type;
}
module.exports["MediaFilmStripListItemSelector"] = $340ce807e864e408$export$9f2ec2b609810bce;
module.exports["FilmstripView"] = $340ce807e864e408$export$817db220b90d8024;

});

parcelRegister("cewj5", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $8e7fda51b7396b67$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$8e7fda51b7396b67$var$debounce.debounce = $8e7fda51b7396b67$var$debounce;
module.exports = $8e7fda51b7396b67$var$debounce;

});

parcelRegister("6ZDLj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bwcZT = parcelRequire("bwcZT");

const $15c7f4a4aa94e52b$export$924abd21043fc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ArrowLeftWrapper), props);
const $15c7f4a4aa94e52b$export$a5ffe38c17bbc0a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ShadowRight), props);
const $15c7f4a4aa94e52b$export$abf07652016c7e56 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ArrowRightWrapper), props);
const $15c7f4a4aa94e52b$export$b39b1b86b48b621f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.LeftArrow), props);
const $15c7f4a4aa94e52b$export$6208675820d4cc50 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.RightArrow), props);
const $15c7f4a4aa94e52b$export$d37eb83491863cbb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripViewWrapper), props);
const $15c7f4a4aa94e52b$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $15c7f4a4aa94e52b$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripList), {
        ...props,
        ref: ref
    }));
const $15c7f4a4aa94e52b$export$54cfc70c184c0713 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripListItem), props);
module.exports["LeftArrow"] = $15c7f4a4aa94e52b$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $15c7f4a4aa94e52b$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $15c7f4a4aa94e52b$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $15c7f4a4aa94e52b$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $15c7f4a4aa94e52b$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $15c7f4a4aa94e52b$export$54cfc70c184c0713;

});

parcelRegister("bwcZT", function(module, exports) {
/* wrappers-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3bV1Q = parcelRequire("3bV1Q");


var $4HvFx = parcelRequire("4HvFx");


var $46EIy = parcelRequire("46EIy");

const $1156f5d5007639c5$var$filmStripViewStyles = null;
const $1156f5d5007639c5$var$filmStripListWrapperStyles = null;
const $1156f5d5007639c5$var$filmStripListStyles = null;
const $1156f5d5007639c5$var$filmStripListItemStyles = null;
const $1156f5d5007639c5$var$arrowWrapperStyles = null;
const $1156f5d5007639c5$var$arrowLeftWrapperStyles = null;
const $1156f5d5007639c5$var$arrowRightWrapperStyles = null;
const $1156f5d5007639c5$var$shadowStyles = null;
const $1156f5d5007639c5$var$shadowLeftStyles = null;
const $1156f5d5007639c5$var$shadowRightStyles = null;
const $1156f5d5007639c5$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1ltvidpf"
        ])
    }, children);
const $1156f5d5007639c5$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: onClick
    }, children);
const $1156f5d5007639c5$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1xi2idpf"
        ])
    }, children);
const $1156f5d5007639c5$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: onClick
    }, children);
const $1156f5d5007639c5$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3bV1Q))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $1156f5d5007639c5$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4HvFx))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $1156f5d5007639c5$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": dataTestId,
        className: (0, $gMc0m.default)([
            "_2rkofajl _kqswh2mm _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _1yqxkb7n _1ajs4jg8"
        ])
    }, children);
const $1156f5d5007639c5$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1kw7 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
        ])
    }, children));
const $1156f5d5007639c5$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
        ref: ref,
        style: style,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _k8m01e03 _6fl41kli _o5721q9c _1e0c1o8l"
        ])
    }, children));
const $1156f5d5007639c5$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1o8l _s7n4nkob _1wybidpf _1lhcidpf",
            (0, $46EIy.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);
module.exports["ArrowLeftWrapper"] = $1156f5d5007639c5$export$924abd21043fc000;
module.exports["ShadowRight"] = $1156f5d5007639c5$export$a5ffe38c17bbc0a1;
module.exports["ArrowRightWrapper"] = $1156f5d5007639c5$export$abf07652016c7e56;
module.exports["LeftArrow"] = $1156f5d5007639c5$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $1156f5d5007639c5$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $1156f5d5007639c5$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $1156f5d5007639c5$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $1156f5d5007639c5$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $1156f5d5007639c5$export$54cfc70c184c0713;

});

parcelRegister("aL0VQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hZ6O7 = parcelRequire("hZ6O7");


var $jRNsq = parcelRequire("jRNsq");


var $i2CQL = parcelRequire("i2CQL");


var $jQCJ9 = parcelRequire("jQCJ9");

const $4cae511015088d55$var$areFilesPotentiallyDuplicated = (file1, file2)=>file1.status === file2.status && file1.name === file2.name && file1.size === file2.size && file1.mimeType === file2.mimeType && file1.id !== file2.id;
function $4cae511015088d55$export$f91c9e51e5ab027d(ids) {
    const nonErrorFiles = (0, $i2CQL.useMediaStore)((state)=>Object.values(state.files).filter((0, $hZ6O7.isNonErrorFinalFileState)));
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const collections = (0, $42omo.useMemo)(()=>Object.fromEntries(ids.map(({ id: id, collectionName: collectionName })=>[
                id,
                collectionName
            ])), [
        ids
    ]);
    const files = (0, $42omo.useMemo)(()=>nonErrorFiles.filter((file)=>ids.some(({ id: id })=>file.id === id)), [
        nonErrorFiles,
        ids
    ]);
    const prevFiles = (0, $jQCJ9.usePrevious)(files);
    (0, $42omo.useEffect)(()=>{
        const prev = prevFiles ?? [];
        // Get the files that have been added or whose status has changed since last time.
        const addedOrChangedFiles = files.filter((file)=>file && prev.every((prevFile)=>prevFile.id !== file.id || prevFile.status !== file.status));
        // Get the files from the list that are duplicates of the added / changed files
        const potentialDuplicates = files.filter((file)=>addedOrChangedFiles.some((addedFile)=>$4cae511015088d55$var$areFilesPotentiallyDuplicated(file, addedFile)));
        if (potentialDuplicates.length) // if any duplicates are found then fetch their hashes along with the added files
        [
            ...addedOrChangedFiles,
            ...potentialDuplicates
        ].forEach((file)=>{
            const collectionName = collections[file.id];
            mediaClient.file.getFileState(file.id, {
                collectionName: collectionName,
                includeHashForDuplicateFiles: true,
                forceRefresh: true
            });
        });
    }, [
        files,
        prevFiles,
        mediaClient,
        collections
    ]);
    const hashMap = (0, $42omo.useMemo)(()=>Object.fromEntries(files.map((file)=>[
                file.id,
                file.hash
            ])), [
        files
    ]);
    return hashMap;
}
module.exports["useFileHashes"] = $4cae511015088d55$export$f91c9e51e5ab027d;

});

parcelRegister("jQCJ9", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $8227eceacc56cecd$export$5cae361ad82dce8b(value) {
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
module.exports["usePrevious"] = $8227eceacc56cecd$export$5cae361ad82dce8b;

});

parcelRegister("9EfFC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dOMrE = parcelRequire("dOMrE");


var $i0btU = parcelRequire("i0btU");


var $4qXXo = parcelRequire("4qXXo");


var $l2474 = parcelRequire("l2474");


var $6mYMS = parcelRequire("6mYMS");


var $3jsXx = parcelRequire("3jsXx");


var $1DWH0 = parcelRequire("1DWH0");


var $28cxD = parcelRequire("28cxD");


var $bwC67 = parcelRequire("bwC67");


var $g6YCz = parcelRequire("g6YCz");

const $893da78086ca16ac$export$7452d7062a4d0634 = 1000;
const $893da78086ca16ac$export$af8124aa496797f2 = '_|unknown|_';
class $893da78086ca16ac$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        (0, $g6YCz.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $g6YCz.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $28cxD.UFOExperienceState)['STARTED'],
            (0, $28cxD.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwC67.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            }
        }, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, `@${message}`));
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$893da78086ca16ac$export$af8124aa496797f2}`;
        const showTooltip = mentionType === (0, $6mYMS.MentionType).RESTRICTED;
        const mentionComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dOMrE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4qXXo.default), {
            mentionType: mentionType,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            spellCheck: false,
            "data-testid": `mention-${id}`,
            "data-mention-type": mentionType,
            "data-mention-tooltip": showTooltip
        }, failedMention ? this.renderUnknownUserError(id) : text || '@...'));
        const ssrPlaceholderProp = props.ssrPlaceholderId ? {
            'data-ssr-placeholder': props.ssrPlaceholderId
        } : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g6YCz.UfoErrorBoundary), {
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            id: localId,
            "data-mention-id": id,
            "data-local-id": localId,
            "data-access-level": accessLevel,
            spellCheck: false,
            ...ssrPlaceholderProp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i0btU.default), null, showTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
            fallback: mentionComponent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l2474.default), {
            name: text
        }, mentionComponent)) : mentionComponent)));
    }
    constructor(props){
        super(props);
        this.hoverTimeout = void 0;
        this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick } = this.props;
            if (onClick) onClick(id, text, e);
        };
        this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $893da78086ca16ac$export$7452d7062a4d0634);
        };
        this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        };
        this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
            if (isHighlighted) return (0, $6mYMS.MentionType).SELF;
            if ((0, $6mYMS.isRestricted)(accessLevel)) return (0, $6mYMS.MentionType).RESTRICTED;
            return (0, $6mYMS.MentionType).DEFAULT;
        };
        (0, $g6YCz.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
}
const $893da78086ca16ac$var$MentionWithAnalytics = (0, $1DWH0.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $3jsXx.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $3jsXx.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($893da78086ca16ac$export$92ab8442e7a15cef);
const $893da78086ca16ac$var$Mention = $893da78086ca16ac$var$MentionWithAnalytics;
var $893da78086ca16ac$export$2e2bcd8739ae039 = $893da78086ca16ac$var$Mention;
module.exports["UNKNOWN_USER_ID"] = $893da78086ca16ac$export$af8124aa496797f2;
module.exports["default"] = $893da78086ca16ac$export$2e2bcd8739ae039;

});

parcelRegister("i0btU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $8C5kA = parcelRequire("8C5kA");


var $bwC67 = parcelRequire("bwC67");

const $806263e9564ebacc$var$EMPTY = {};
const $806263e9564ebacc$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState($806263e9564ebacc$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        let aborted = false;
        setMessages($806263e9564ebacc$var$EMPTY);
        (0, $bwC67.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $806263e9564ebacc$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $8C5kA.default)();
    const messages = $806263e9564ebacc$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
        ...intl,
        messages: messages
    }, children);
};
var $806263e9564ebacc$export$2e2bcd8739ae039 = $806263e9564ebacc$var$MessagesIntlProvider;
module.exports["default"] = $806263e9564ebacc$export$2e2bcd8739ae039;

});

parcelRegister("bwC67", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $gjAAG = parcelRequire("gjAAG");

const $1cb8431546098045$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $8C5kA.default)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            values: values,
            ...messageDescriptor
        });
    };
const $1cb8431546098045$export$98e06fe7a6174253 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).unknownUserError);
const $1cb8431546098045$export$58bd5a2057b6b855 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessWarning);
const $1cb8431546098045$export$da9f8ce14593162f = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessLabel);
const $1cb8431546098045$export$4a258ffee7316766 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultHeadline);
const $1cb8431546098045$export$702321a50d74536e = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultAdvisedAction);
const $1cb8431546098045$export$ed7f16088a93ae9d = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).loginAgain);
const $1cb8431546098045$export$3ab158df56460d1c = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).differentText);































const $1cb8431546098045$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("j6Lhv")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("iYVse")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("gIKPA")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("5twea")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("6Aql9")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("5s0nG")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("1Xsn1")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("8ZVHr")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("lFIEi")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("7XNdm")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("lq1mj")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("dJ6Pi")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("5tIPp")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("buvNS")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("2cosb")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("908iT")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("i1irp")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("lRDPo")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("aQ7uz")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("eD8co")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("kjxyJ")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("kSSgO")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("dVKWy")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("6tn9d")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("dct7i")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("k8Qz7")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("9677e")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("lksJj")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("7rI0d")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("gofEx")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $1cb8431546098045$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("5twea")).then((mod)=>mod.default);
            }
    }
};
module.exports["UnknownUserError"] = $1cb8431546098045$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $1cb8431546098045$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $1cb8431546098045$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $1cb8431546098045$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $1cb8431546098045$export$702321a50d74536e;
module.exports["LoginAgain"] = $1cb8431546098045$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $1cb8431546098045$export$3ab158df56460d1c;
module.exports["getMessagesForLocale"] = $1cb8431546098045$export$d0a3169680473b6c;

});

parcelRegister("gjAAG", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $898c0db98da1400a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    }
});
module.exports["messages"] = $898c0db98da1400a$export$defe85febe8b728c;

});

parcelRegister("j6Lhv", function(module, exports) {

let $de9340f01ef828f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $de9340f01ef828f7$var$load("1jsQH"),
    $de9340f01ef828f7$var$load("bv8GZ"),
    $de9340f01ef828f7$var$load("i5eMd"),
    $de9340f01ef828f7$var$load("4DYJ5"),
    $de9340f01ef828f7$var$load("gyXEE"),
    $de9340f01ef828f7$var$load("hoPZ9")
]).then(()=>parcelRequire('6Yuab'));

});

parcelRegister("iYVse", function(module, exports) {

let $dd1a65cfbea21e3b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dd1a65cfbea21e3b$var$load("deyvi"),
    $dd1a65cfbea21e3b$var$load("cdeuH"),
    $dd1a65cfbea21e3b$var$load("4UPfH"),
    $dd1a65cfbea21e3b$var$load("hfFxJ"),
    $dd1a65cfbea21e3b$var$load("1Mp9N"),
    $dd1a65cfbea21e3b$var$load("2Fu3d")
]).then(()=>parcelRequire('biDFC'));

});

parcelRegister("gIKPA", function(module, exports) {

let $c2c5150cd718b547$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c2c5150cd718b547$var$load("6dERU"),
    $c2c5150cd718b547$var$load("7gF8f"),
    $c2c5150cd718b547$var$load("gd4qs"),
    $c2c5150cd718b547$var$load("gofGr"),
    $c2c5150cd718b547$var$load("dBb6q"),
    $c2c5150cd718b547$var$load("eJgH8")
]).then(()=>parcelRequire('e7zr1'));

});

parcelRegister("5twea", function(module, exports) {

let $3fc8a8e755b35ba7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fc8a8e755b35ba7$var$load("2YffH").then(()=>parcelRequire('gbdrY'));

});

parcelRegister("6Aql9", function(module, exports) {

let $4cba897da0f0ec7a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4cba897da0f0ec7a$var$load("kTurq"),
    $4cba897da0f0ec7a$var$load("djb49"),
    $4cba897da0f0ec7a$var$load("fviv5"),
    $4cba897da0f0ec7a$var$load("2RQvP"),
    $4cba897da0f0ec7a$var$load("7Lkvk")
]).then(()=>parcelRequire('4ykQ2'));

});

parcelRegister("5s0nG", function(module, exports) {

let $3f7fdcef74f97a1a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f7fdcef74f97a1a$var$load("j0PWv"),
    $3f7fdcef74f97a1a$var$load("ksTQ6"),
    $3f7fdcef74f97a1a$var$load("eBoC7"),
    $3f7fdcef74f97a1a$var$load("7NpX8"),
    $3f7fdcef74f97a1a$var$load("cukQS"),
    $3f7fdcef74f97a1a$var$load("5FaEJ")
]).then(()=>parcelRequire('4FRcU'));

});

parcelRegister("1Xsn1", function(module, exports) {

let $16d14ee2d081775e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $16d14ee2d081775e$var$load("dlmud"),
    $16d14ee2d081775e$var$load("5CGnz"),
    $16d14ee2d081775e$var$load("bNv64"),
    $16d14ee2d081775e$var$load("bFU3Y"),
    $16d14ee2d081775e$var$load("3CucM"),
    $16d14ee2d081775e$var$load("9yemY")
]).then(()=>parcelRequire('bG4aH'));

});

parcelRegister("8ZVHr", function(module, exports) {

let $68d0c72d3e46e583$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $68d0c72d3e46e583$var$load("7snhF"),
    $68d0c72d3e46e583$var$load("X0Jic"),
    $68d0c72d3e46e583$var$load("bAoKR"),
    $68d0c72d3e46e583$var$load("5IaSN")
]).then(()=>parcelRequire('kVRsY'));

});

parcelRegister("lFIEi", function(module, exports) {

let $fc700fac699efb68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fc700fac699efb68$var$load("cbkj0"),
    $fc700fac699efb68$var$load("9Oxgj"),
    $fc700fac699efb68$var$load("4Afgd"),
    $fc700fac699efb68$var$load("exaJ2"),
    $fc700fac699efb68$var$load("lp8Wm"),
    $fc700fac699efb68$var$load("l2LZP")
]).then(()=>parcelRequire('FrZOj'));

});

parcelRegister("7XNdm", function(module, exports) {

let $5cc4380c68be9728$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5cc4380c68be9728$var$load("17m16"),
    $5cc4380c68be9728$var$load("kAg8V"),
    $5cc4380c68be9728$var$load("cMubu"),
    $5cc4380c68be9728$var$load("hcCcg"),
    $5cc4380c68be9728$var$load("cHWSM"),
    $5cc4380c68be9728$var$load("35Ssm")
]).then(()=>parcelRequire('225Fx'));

});

parcelRegister("lq1mj", function(module, exports) {

let $f97d1482ff3b8259$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f97d1482ff3b8259$var$load("b4NO6"),
    $f97d1482ff3b8259$var$load("fM2oh"),
    $f97d1482ff3b8259$var$load("3fLE9"),
    $f97d1482ff3b8259$var$load("j9KTb"),
    $f97d1482ff3b8259$var$load("b37xN"),
    $f97d1482ff3b8259$var$load("ik6u5")
]).then(()=>parcelRequire('alG1N'));

});

parcelRegister("dJ6Pi", function(module, exports) {

let $9fe4c5e3bbeeb3c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9fe4c5e3bbeeb3c3$var$load("fModo").then(()=>parcelRequire('lQyzT'));

});

parcelRegister("5tIPp", function(module, exports) {

let $3fd26f220ca7d4ef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3fd26f220ca7d4ef$var$load("1K1Fj"),
    $3fd26f220ca7d4ef$var$load("xnqy2"),
    $3fd26f220ca7d4ef$var$load("8hOn0"),
    $3fd26f220ca7d4ef$var$load("3hjAq"),
    $3fd26f220ca7d4ef$var$load("7PjNK"),
    $3fd26f220ca7d4ef$var$load("Vt6S9")
]).then(()=>parcelRequire('gSUUF'));

});

parcelRegister("buvNS", function(module, exports) {

let $85db2a928aefbff9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $85db2a928aefbff9$var$load("38sfA"),
    $85db2a928aefbff9$var$load("awkVi"),
    $85db2a928aefbff9$var$load("h4OCL"),
    $85db2a928aefbff9$var$load("2bCHJ"),
    $85db2a928aefbff9$var$load("ktSfi"),
    $85db2a928aefbff9$var$load("9GZ76")
]).then(()=>parcelRequire('cF55v'));

});

parcelRegister("2cosb", function(module, exports) {

let $199fabba5890e18c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $199fabba5890e18c$var$load("bjmre"),
    $199fabba5890e18c$var$load("11DLa"),
    $199fabba5890e18c$var$load("bcQs2"),
    $199fabba5890e18c$var$load("fdXnq"),
    $199fabba5890e18c$var$load("iouLY"),
    $199fabba5890e18c$var$load("4sOIV")
]).then(()=>parcelRequire('4IbNl'));

});

parcelRegister("908iT", function(module, exports) {

let $68da8e17ff346b9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $68da8e17ff346b9a$var$load("asvK9"),
    $68da8e17ff346b9a$var$load("barSq"),
    $68da8e17ff346b9a$var$load("aBa7j"),
    $68da8e17ff346b9a$var$load("cItJR"),
    $68da8e17ff346b9a$var$load("hPZE5"),
    $68da8e17ff346b9a$var$load("QTjdE")
]).then(()=>parcelRequire('jKge3'));

});

parcelRegister("i1irp", function(module, exports) {

let $d1e69ffd7d33a6dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d1e69ffd7d33a6dd$var$load("7v6wU"),
    $d1e69ffd7d33a6dd$var$load("a8heY"),
    $d1e69ffd7d33a6dd$var$load("b544F"),
    $d1e69ffd7d33a6dd$var$load("SctKm"),
    $d1e69ffd7d33a6dd$var$load("dzIm8"),
    $d1e69ffd7d33a6dd$var$load("hrf1M")
]).then(()=>parcelRequire('lGLcJ'));

});

parcelRegister("lRDPo", function(module, exports) {

let $fead713b50dff4c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fead713b50dff4c1$var$load("aEpRh"),
    $fead713b50dff4c1$var$load("6hlNE"),
    $fead713b50dff4c1$var$load("K6fhx"),
    $fead713b50dff4c1$var$load("1fJz1"),
    $fead713b50dff4c1$var$load("jqwnR"),
    $fead713b50dff4c1$var$load("lsloj")
]).then(()=>parcelRequire('d7PIu'));

});

parcelRegister("aQ7uz", function(module, exports) {

let $7e44927a919a92c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7e44927a919a92c1$var$load("3fuR9"),
    $7e44927a919a92c1$var$load("2bqSD"),
    $7e44927a919a92c1$var$load("gZU54"),
    $7e44927a919a92c1$var$load("9yA8o"),
    $7e44927a919a92c1$var$load("bGhLc"),
    $7e44927a919a92c1$var$load("iRKhU")
]).then(()=>parcelRequire('jwd3r'));

});

parcelRegister("eD8co", function(module, exports) {

let $aa6b115a311b9fd0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa6b115a311b9fd0$var$load("aGECO").then(()=>parcelRequire('c2Dmg'));

});

parcelRegister("kjxyJ", function(module, exports) {

let $ec9f9d22a0e12245$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ec9f9d22a0e12245$var$load("bSjyK"),
    $ec9f9d22a0e12245$var$load("j6IGj"),
    $ec9f9d22a0e12245$var$load("hlJc4"),
    $ec9f9d22a0e12245$var$load("aOdaf")
]).then(()=>parcelRequire('l9Ug4'));

});

parcelRegister("kSSgO", function(module, exports) {

let $f342f2b4c1be2dfc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f342f2b4c1be2dfc$var$load("fMrUo"),
    $f342f2b4c1be2dfc$var$load("bJykp"),
    $f342f2b4c1be2dfc$var$load("4Wdqb"),
    $f342f2b4c1be2dfc$var$load("448N7"),
    $f342f2b4c1be2dfc$var$load("9v6ER"),
    $f342f2b4c1be2dfc$var$load("aEAsN")
]).then(()=>parcelRequire('fkCIe'));

});

parcelRegister("dVKWy", function(module, exports) {

let $a245033a20d44784$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a245033a20d44784$var$load("5WkxF").then(()=>parcelRequire('hW2zm'));

});

parcelRegister("6tn9d", function(module, exports) {

let $4b676824db9cc0ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4b676824db9cc0ad$var$load("9eNkX"),
    $4b676824db9cc0ad$var$load("dh2Er"),
    $4b676824db9cc0ad$var$load("k10Cs"),
    $4b676824db9cc0ad$var$load("gBDdh"),
    $4b676824db9cc0ad$var$load("8Mz40"),
    $4b676824db9cc0ad$var$load("l6YHr")
]).then(()=>parcelRequire('gR0Ux'));

});

parcelRegister("dct7i", function(module, exports) {

let $99c2fb5138729985$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99c2fb5138729985$var$load("l7PQP").then(()=>parcelRequire('bRxNE'));

});

parcelRegister("k8Qz7", function(module, exports) {

let $ea9d54674e2a5646$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ea9d54674e2a5646$var$load("h0uBE"),
    $ea9d54674e2a5646$var$load("eBLgB"),
    $ea9d54674e2a5646$var$load("1n8w9"),
    $ea9d54674e2a5646$var$load("6NHX3"),
    $ea9d54674e2a5646$var$load("77dzh")
]).then(()=>parcelRequire('4dnaM'));

});

parcelRegister("9677e", function(module, exports) {

let $69fa319b49dca515$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69fa319b49dca515$var$load("fLjHM").then(()=>parcelRequire('2qq54'));

});

parcelRegister("lksJj", function(module, exports) {

let $f871c05e7ad2e071$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f871c05e7ad2e071$var$load("3YGga").then(()=>parcelRequire('7iyzo'));

});

parcelRegister("7rI0d", function(module, exports) {

let $56bd2ffef0441182$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $56bd2ffef0441182$var$load("j9OUx"),
    $56bd2ffef0441182$var$load("bV8sS"),
    $56bd2ffef0441182$var$load("l079e"),
    $56bd2ffef0441182$var$load("ebljE"),
    $56bd2ffef0441182$var$load("hF4v3"),
    $56bd2ffef0441182$var$load("afU9w")
]).then(()=>parcelRequire('lRTsu'));

});

parcelRegister("gofEx", function(module, exports) {

let $beeb078c973d8034$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $beeb078c973d8034$var$load("gDiIK"),
    $beeb078c973d8034$var$load("eLlpV"),
    $beeb078c973d8034$var$load("f1B4n"),
    $beeb078c973d8034$var$load("j4dSZ"),
    $beeb078c973d8034$var$load("1Tuyb"),
    $beeb078c973d8034$var$load("7iCpI")
]).then(()=>parcelRequire('jKBtA'));

});

parcelRegister("4qXXo", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $6fnsQ = parcelRequire("6fnsQ");


var $6mYMS = parcelRequire("6mYMS");


var $42omo = parcelRequire("42omo");

const $1278ab3a4b348f22$var$mentionStyle = {
    [(0, $6mYMS.MentionType).SELF]: {
        background: `var(--ds-background-brand-bold, ${(0, $6fnsQ.B400)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-inverse, ${(0, $6fnsQ.N20)})`,
        hoveredBackground: `var(--ds-background-brand-bold-hovered, ${(0, $6fnsQ.B400)})`,
        pressedBackground: `var(--ds-background-brand-bold-pressed, ${(0, $6fnsQ.B400)})`
    },
    [(0, $6mYMS.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: `var(--ds-border-bold, ${(0, $6fnsQ.N500)})`,
        text: `var(--ds-text, ${(0, $6fnsQ.N500)})`,
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $6mYMS.MentionType).DEFAULT]: {
        background: `var(--ds-background-neutral, ${(0, $6fnsQ.N30A)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`,
        hoveredBackground: `var(--ds-background-neutral-hovered, ${(0, $6fnsQ.N30A)})`,
        pressedBackground: `var(--ds-background-neutral-pressed, ${(0, $6fnsQ.N30A)})`
    }
};
const $1278ab3a4b348f22$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $1278ab3a4b348f22$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $1278ab3a4b348f22$var$PrimitiveMention = /*#__PURE__*/ (0, $42omo.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $9K4OG.css)("display:inline;border:var(--ds-border-width, 1px) solid ", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&:hover{background:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $1278ab3a4b348f22$export$2e2bcd8739ae039 = $1278ab3a4b348f22$var$PrimitiveMention;
module.exports["default"] = $1278ab3a4b348f22$export$2e2bcd8739ae039;

});

parcelRegister("l2474", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $d23df821b2d2d994$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("gURmQ")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $d23df821b2d2d994$export$2e2bcd8739ae039 = $d23df821b2d2d994$var$AsyncNoAccessTooltip;
module.exports["default"] = $d23df821b2d2d994$export$2e2bcd8739ae039;

});

parcelRegister("gURmQ", function(module, exports) {

let $c50b45f90fc6d653$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c50b45f90fc6d653$var$load("2lsX7").then(()=>parcelRequire('5zTqW'));

});

parcelRegister("g6YCz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $af19f55bb4052571$export$1d011e4240507c78 = new (0, $9801n.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
});
class $af19f55bb4052571$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch() {
        $af19f55bb4052571$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["mentionRenderedUfoExperience"] = $af19f55bb4052571$export$1d011e4240507c78;
module.exports["UfoErrorBoundary"] = $af19f55bb4052571$export$5ef1c2550074a375;

});

parcelRegister("hezkK", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $huXH9 = parcelRequire("huXH9");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $9yt4X = parcelRequire("9yt4X");


var $4Ve7Q = parcelRequire("4Ve7Q");

const $4efd70df50f13ebd$export$2f5dfaa7873e8973 = `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`;
const $4efd70df50f13ebd$var$styles = {
    agentAvatar: "_1e0c1txw _1bah1h6o _4cvr1h6o _mkrz1k6g",
    image: "_5ral1dfr _4t3i1osq _1bsb1osq",
    avatarContentContainer: "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o"
};
const $4efd70df50f13ebd$var$stylesCompiled = {
    innerShape: "_4t3i1lk2 _1bsb1lk2 _mkrz1k6g"
};
const $4efd70df50f13ebd$export$38b71b080e1832c8 = ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: showBorder = true, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        "aria-label": label,
        xcss: $4efd70df50f13ebd$var$styles.agentAvatar,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $huXH9.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $huXH9.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
            ...showBorder ? {
                backgroundColor: '#fff'
            } : {},
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...(0, $dh538.fg)('rovo_chat_bugfix_agent_avatar_squish') ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minHeight: (0, $huXH9.AVATAR_SIZES)[size],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minWidth: (0, $huXH9.AVATAR_SIZES)[size]
            } : {}
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $4efd70df50f13ebd$var$stylesCompiled.innerShape
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $4efd70df50f13ebd$var$styles.avatarContentContainer,
                children: imgUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "img",
                    xcss: $4efd70df50f13ebd$var$styles.image,
                    src: imgUrl,
                    alt: name || label || formatMessage((0, $4Ve7Q.messages).agentAvatarLabel)
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9yt4X.GeneratedAvatar), {
                    agentId: agentId,
                    agentNamedId: agentNamedId,
                    agentIdentityAccountId: agentIdentityAccountId,
                    size: size
                })
            })
        })
    });
};
module.exports["AGENT_AVATAR_CLIP_PATH"] = $4efd70df50f13ebd$export$2f5dfaa7873e8973;
module.exports["AgentAvatar"] = $4efd70df50f13ebd$export$38b71b080e1832c8;

});

parcelRegister("9yt4X", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $huXH9 = parcelRequire("huXH9");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

const $087487947faf3e7f$var$styles = {
    image: "_5ral1dfr _4t3i1osq _1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o",
    banner: "_1bsb1osq",
    bannerFillSpace: "_1bsb1osq _4t3i1osq _5ral1dfr"
};
const $087487947faf3e7f$var$Observer = ({ onLoad: onLoad })=>{
    (0, $42omo.useEffect)(()=>{
        onLoad();
    }, [
        onLoad
    ]);
    return null;
};

const $087487947faf3e7f$var$AutoDevAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1Jp34")));

const $087487947faf3e7f$var$AutoFixAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iXcnT")));

const $087487947faf3e7f$var$AutoReviewAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aUp1o")));

const $087487947faf3e7f$var$BacklogBuddyAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3KJ0b")));

const $087487947faf3e7f$var$CommsCrafterAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eKuAc")));

const $087487947faf3e7f$var$CultureAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6kpkG")));

const $087487947faf3e7f$var$CustomerInsightAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1Q4wY")));

const $087487947faf3e7f$var$DecisionDirectorAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dRCU8")));

const $087487947faf3e7f$var$FeatureFlagAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kQTXK")));

const $087487947faf3e7f$var$GenericAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kFBSF")));

const $087487947faf3e7f$var$HireWriterAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("44XTS")));

const $087487947faf3e7f$var$MarketingMessageMaestroAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2SnMt")));

const $087487947faf3e7f$var$MyUserManualAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cXu7g")));

const $087487947faf3e7f$var$OkrOracleAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3EvKg")));

const $087487947faf3e7f$var$OpsAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("htmh0")));

const $087487947faf3e7f$var$PitchPerfectorAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kTVse")));

const $087487947faf3e7f$var$ProductRequirementAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("emHN5")));

const $087487947faf3e7f$var$ReleaseNotesAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9Oxg9")));

const $087487947faf3e7f$var$ResearchScoutAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("doqXm")));

const $087487947faf3e7f$var$RovoDevAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("k0SSx")));

const $087487947faf3e7f$var$SocialMediaScribeAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kVvzt")));

const $087487947faf3e7f$var$TeamConnectionAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2Hx38")));

const $087487947faf3e7f$var$WorkflowBuilderAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3v9w9")));

const $087487947faf3e7f$var$TrialGuideAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("58iCo")));
const $087487947faf3e7f$export$cf7c9ad03f4a70b2 = {
    primary: '#FCA700',
    secondary: '#FFC716'
};
const $087487947faf3e7f$export$3e344798f7855e62 = {
    primary: '#BF63F3',
    secondary: '#D8A0F7'
};
const $087487947faf3e7f$export$a3d0897f023251ae = {
    primary: '#82B536',
    secondary: '#B3DF72'
};
const $087487947faf3e7f$export$d933daaf7b69e6ee = {
    primary: '#357DE8',
    secondary: '#669DF1'
};
const $087487947faf3e7f$var$colorList = [
    $087487947faf3e7f$export$cf7c9ad03f4a70b2,
    $087487947faf3e7f$export$3e344798f7855e62,
    $087487947faf3e7f$export$a3d0897f023251ae,
    $087487947faf3e7f$export$d933daaf7b69e6ee
];
const $087487947faf3e7f$var$avatarList = [
    $087487947faf3e7f$var$CustomerInsightAvatar,
    $087487947faf3e7f$var$BacklogBuddyAvatar,
    $087487947faf3e7f$var$DecisionDirectorAvatar,
    $087487947faf3e7f$var$CommsCrafterAvatar,
    $087487947faf3e7f$var$AutoDevAvatar,
    $087487947faf3e7f$var$OkrOracleAvatar,
    $087487947faf3e7f$var$CultureAvatar,
    $087487947faf3e7f$var$SocialMediaScribeAvatar,
    $087487947faf3e7f$var$TeamConnectionAvatar,
    $087487947faf3e7f$var$HireWriterAvatar,
    $087487947faf3e7f$var$OpsAgentAvatar,
    $087487947faf3e7f$var$ResearchScoutAvatar,
    $087487947faf3e7f$var$ReleaseNotesAvatar,
    $087487947faf3e7f$var$MyUserManualAvatar,
    $087487947faf3e7f$var$PitchPerfectorAvatar,
    $087487947faf3e7f$var$AutoDevAvatar,
    $087487947faf3e7f$var$AutoFixAvatar,
    $087487947faf3e7f$var$AutoReviewAvatar,
    $087487947faf3e7f$var$MarketingMessageMaestroAvatar,
    $087487947faf3e7f$var$FeatureFlagAvatar,
    $087487947faf3e7f$var$ProductRequirementAvatar
];
const $087487947faf3e7f$export$a834793a4d0d739e = $087487947faf3e7f$var$avatarList.length * $087487947faf3e7f$var$colorList.length;
const $087487947faf3e7f$var$outOfTheBoxAgentAvatar = {
    autodev_template_unit_test_creator: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$AutoFixAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_migration_config_changer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$OpsAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_vulnerable_dependency_updater_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$MarketingMessageMaestroAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_code_standardizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$MyUserManualAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_code_observer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$ResearchScoutAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_code_accessibility_checker_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$HireWriterAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_code_documentation_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$SocialMediaScribeAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_feature_flag_cleaner_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$FeatureFlagAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    decision_director_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$DecisionDirectorAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    user_manual_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$MyUserManualAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    product_requirements_expert_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$ProductRequirementAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    issue_organizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$BacklogBuddyAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    ops_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$OpsAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    jira_workflow_builder_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$WorkflowBuilderAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.primary,
                secondaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.secondary
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    itops_rca_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$AutoReviewAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    jira_trial_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$TrialGuideAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.primary,
                secondaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.secondary
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    }
}; /**
    * agentIdentityAccountId examples:
    * 5b985e7c96cb052b5f65c830
    * 712020:19e57f67-c132-462b-8503-0c19953122cd
    *
    * agentId examples:
    * cd002f25-46e4-4023-80ff-32e4d90849b4
    */ 
const $087487947faf3e7f$export$c84eb7708138dd4 = ({ agentIdentityAccountId: agentIdentityAccountId, agentId: agentId })=>{
    // we prioritise agentIdentityAccountId first if it is available
    // this is because agentIdentityAccountId is more widely available (e.g. in ProfilePage)
    const idForAgentAvatar = agentIdentityAccountId || agentId;
    if (idForAgentAvatar) {
        // Take the last 8 characters of the id because JS can't handle 16 digit numbers
        const trimmedId = idForAgentAvatar.slice(-8).replace(/[-:]/g, '');
        const parsedId = parseInt(trimmedId, 16);
        if (isNaN(parsedId)) return 0;
        else return parsedId;
    }
    return null;
};
const $087487947faf3e7f$var$ROVO_DEV_AGENT_ID = '027f0676-e8e9-4939-8962-3850987d78bb';
const $087487947faf3e7f$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, size: size })=>{
    //@TODO CRCS-3129: Remove Rovo Dev hardcoded icon after TeamEU demos
    // Handle Rovo Dev agent avatar for TeamEU Demo
    if (agentId === $087487947faf3e7f$var$ROVO_DEV_AGENT_ID && (0, $dh538.fg)('jira_ai_force_rovo_dev_avatar')) return {
        render: /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$RovoDevAvatar, {
            size: (0, $huXH9.AVATAR_SIZES)[size],
            primaryColor: "",
            secondaryColor: ""
        }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    };
    if (typeof agentNamedId === 'string' && $087487947faf3e7f$var$outOfTheBoxAgentAvatar[agentNamedId]) {
        const ootbAvatarResult = $087487947faf3e7f$var$outOfTheBoxAgentAvatar[agentNamedId];
        return {
            render: ootbAvatarResult.getRender(size),
            color: ootbAvatarResult.color
        };
    }
    const numberId = $087487947faf3e7f$export$c84eb7708138dd4({
        agentIdentityAccountId: agentIdentityAccountId,
        agentId: agentId
    });
    if (numberId !== null) {
        /**
     * this create all possible combinations of avatars and colors
     * e.g. [[avatar1, color1], [avatar1, color2], [avatar2, color1], [avatar2, color2]]
     * then choose 1 based on agentId
     */ const totalCombinations = $087487947faf3e7f$var$avatarList.length * $087487947faf3e7f$var$colorList.length;
        const combinationIndex = numberId % totalCombinations;
        const avatarIndex = Math.floor(combinationIndex / $087487947faf3e7f$var$colorList.length);
        const colorIndex = combinationIndex % $087487947faf3e7f$var$colorList.length;
        const Avatar = $087487947faf3e7f$var$avatarList[avatarIndex];
        const color = $087487947faf3e7f$var$colorList[colorIndex];
        return {
            render: /*#__PURE__*/ (0, $l998X.jsx)(Avatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: color.primary,
                secondaryColor: color.secondary
            }),
            color: color
        };
    }
    return {
        render: /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$GenericAvatar, {
            size: (0, $huXH9.AVATAR_SIZES)[size],
            primaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.primary,
            secondaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.secondary
        }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    };
};
const $087487947faf3e7f$export$6efaefb8ad2fba40 = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, height: height, fillSpace: fillSpace })=>{
    const { color: color } = $087487947faf3e7f$var$getAvatarRender({
        agentNamedId: agentNamedId,
        agentId: agentId,
        agentIdentityAccountId: agentIdentityAccountId,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($087487947faf3e7f$var$styles.banner, fillSpace ? $087487947faf3e7f$var$styles.bannerFillSpace : undefined),
        style: {
            backgroundColor: color.primary,
            height: height ? `${height}px` : undefined
        }
    });
};
const $087487947faf3e7f$export$96bb253b7de22616 = (props)=>{
    const { render: render, color: color } = $087487947faf3e7f$var$getAvatarRender(props);
    const { onLoad: onLoad } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $087487947faf3e7f$var$styles.image,
        style: {
            backgroundColor: color.primary
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Suspense), {
            fallback: null,
            children: [
                onLoad && /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$Observer, {
                    onLoad: onLoad
                }),
                render
            ]
        })
    });
};
module.exports["AgentBanner"] = $087487947faf3e7f$export$6efaefb8ad2fba40;
module.exports["GeneratedAvatar"] = $087487947faf3e7f$export$96bb253b7de22616;

});

parcelRegister("1Jp34", function(module, exports) {

let $142d6c869fc93f1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $142d6c869fc93f1c$var$load("c9Qqc").then(()=>parcelRequire('f0XYo'));

});

parcelRegister("iXcnT", function(module, exports) {

let $dcc757fb35de9e43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dcc757fb35de9e43$var$load("1TK6P").then(()=>parcelRequire('kdo1N'));

});

parcelRegister("aUp1o", function(module, exports) {

let $7f128b1159aaf0b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f128b1159aaf0b3$var$load("grvAy").then(()=>parcelRequire('1xsEe'));

});

parcelRegister("3KJ0b", function(module, exports) {

let $2bb8937090f7886d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bb8937090f7886d$var$load("23K0q").then(()=>parcelRequire('iOx72'));

});

parcelRegister("eKuAc", function(module, exports) {

let $abcd15b4f7a895b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $abcd15b4f7a895b0$var$load("3kQkj").then(()=>parcelRequire('5yA7f'));

});

parcelRegister("6kpkG", function(module, exports) {

let $49b842e0f53b0840$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $49b842e0f53b0840$var$load("6OXgE").then(()=>parcelRequire('40gXx'));

});

parcelRegister("1Q4wY", function(module, exports) {

let $156e297d03d850f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $156e297d03d850f4$var$load("cbucA").then(()=>parcelRequire('e6WCz'));

});

parcelRegister("dRCU8", function(module, exports) {

let $a17e67305e32e080$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a17e67305e32e080$var$load("bVhr1").then(()=>parcelRequire('b4yf3'));

});

parcelRegister("kQTXK", function(module, exports) {

let $f2e41300efb7f39f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f2e41300efb7f39f$var$load("kE0QC").then(()=>parcelRequire('lRRwN'));

});

parcelRegister("kFBSF", function(module, exports) {

let $f0c5054f72bf4788$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0c5054f72bf4788$var$load("eVFXf").then(()=>parcelRequire('xXksI'));

});

parcelRegister("44XTS", function(module, exports) {

let $2f86000f50552006$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f86000f50552006$var$load("9FhBz").then(()=>parcelRequire('gHjiO'));

});

parcelRegister("2SnMt", function(module, exports) {

let $21831245fa81e40e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21831245fa81e40e$var$load("6zB8z").then(()=>parcelRequire('9sJzD'));

});

parcelRegister("cXu7g", function(module, exports) {

let $96f25b251372ce30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $96f25b251372ce30$var$load("eENGY").then(()=>parcelRequire('cxxnV'));

});

parcelRegister("3EvKg", function(module, exports) {

let $2a8dbb6f12744413$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a8dbb6f12744413$var$load("hmlb0").then(()=>parcelRequire('8nSrm'));

});

parcelRegister("htmh0", function(module, exports) {

let $cb866c206a5b0b04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb866c206a5b0b04$var$load("2NGxc").then(()=>parcelRequire('hGaQU'));

});

parcelRegister("kTVse", function(module, exports) {

let $f37582f3db40c2c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f37582f3db40c2c1$var$load("bPgcq").then(()=>parcelRequire('4zXPl'));

});

parcelRegister("emHN5", function(module, exports) {

let $a75516b19f472f5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a75516b19f472f5d$var$load("31b1q").then(()=>parcelRequire('1xC4V'));

});

parcelRegister("9Oxg9", function(module, exports) {

let $725295393c538ed1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $725295393c538ed1$var$load("8Lh9U").then(()=>parcelRequire('kqZOw'));

});

parcelRegister("doqXm", function(module, exports) {

let $9c026d43c7a38bfd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c026d43c7a38bfd$var$load("6ZzYJ").then(()=>parcelRequire('bZPun'));

});

parcelRegister("k0SSx", function(module, exports) {

let $e91e6080a2f1e543$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e91e6080a2f1e543$var$load("2zIbn").then(()=>parcelRequire('bXyC6'));

});

parcelRegister("kVvzt", function(module, exports) {

let $f3c19ee75daa2848$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3c19ee75daa2848$var$load("410SS").then(()=>parcelRequire('aY5Ef'));

});

parcelRegister("2Hx38", function(module, exports) {

let $1f793be472254651$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f793be472254651$var$load("z3s9q").then(()=>parcelRequire('9mYoH'));

});

parcelRegister("3v9w9", function(module, exports) {

let $28cba65833e09a5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28cba65833e09a5e$var$load("9gqcE").then(()=>parcelRequire('3hbTz'));

});

parcelRegister("58iCo", function(module, exports) {

let $3bcc244b8daf70af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3bcc244b8daf70af$var$load("eipnW").then(()=>parcelRequire('3AA8L'));

});

parcelRegister("4Ve7Q", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $c1395595ab243cbd$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    agentAvatarLabel: {
        id: "ai-mate.agent-avatar-label",
        defaultMessage: "Agent avatar"
    }
});
module.exports["messages"] = $c1395595ab243cbd$export$defe85febe8b728c;

});

parcelRegister("jMZdB", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $d8ohW = parcelRequire("d8ohW");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");


var $3h2i4 = parcelRequire("3h2i4");


var $lBFuf = parcelRequire("lBFuf");


var $gMCDH = parcelRequire("gMCDH");

const $1694d7942d86318a$var$styles = {
    conversationStartersList: "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
    conversationStartersListRefresh: "_1bsb1osq",
    conversationStarterIcon: "_1o9zidpf",
    conversationStarterText: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1o9zkb7n _1ul9idpf",
    button: "_11c82smr _2rko12b0 _syazazsu _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7 _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _1bsb1osq _bfhksm61 _irr31dpa _1di6fcek"
};
const $1694d7942d86318a$export$c2d882153e0984c5 = ({ userDefinedConversationStarters: userDefinedConversationStartersParam, isAgentDefault: isAgentDefault })=>{
    const type = 'static';
    const customAgentConversationStarters = [
        {
            message: (0, $gMCDH.messages).agentEmptyStateSuggestion1,
            type: type
        },
        {
            message: (0, $gMCDH.messages).agentEmptyStateSuggestion2,
            type: type
        },
        {
            message: (0, $gMCDH.messages).agentEmptyStateSuggestion3,
            type: type
        }
    ];
    const userDefinedConversationStarters = userDefinedConversationStartersParam ?? [];
    const defaultAgentConversationStarters = [
        {
            message: (0, $gMCDH.messages).emptyStateSuggestion1,
            type: type
        },
        {
            message: (0, $gMCDH.messages).emptyStateSuggestion2,
            type: type
        },
        {
            message: (0, $gMCDH.messages).emptyStateSuggestion3,
            type: type
        }
    ];
    const getCombinedConversationStarters = ()=>{
        const shouldCombine = !isAgentDefault;
        if (shouldCombine) // Return user defined suggestions + static fallback suggestions with a max of 3 suggestions (user defined taking precendence over fallback)
        return [
            ...userDefinedConversationStarters,
            ...customAgentConversationStarters
        ].slice(0, 3);
        return defaultAgentConversationStarters;
    };
    return {
        userDefinedConversationStarters: userDefinedConversationStarters,
        customAgentConversationStarters: customAgentConversationStarters,
        defaultAgentConversationStarters: defaultAgentConversationStarters,
        combinedConversationStarters: getCombinedConversationStarters()
    };
};
const $1694d7942d86318a$export$171adfc74aa509c3 = ({ userDefinedConversationStarters: userDefinedConversationStarters, isAgentDefault: isAgentDefault, ...props })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { combinedConversationStarters: combinedConversationStarters } = (0, $42omo.useMemo)(()=>$1694d7942d86318a$export$c2d882153e0984c5({
            userDefinedConversationStarters: userDefinedConversationStarters,
            isAgentDefault: isAgentDefault
        }), [
        userDefinedConversationStarters,
        isAgentDefault
    ]);
    const starters = (0, $42omo.useMemo)(()=>combinedConversationStarters.map((starter)=>typeof starter.message === 'string' ? {
                message: starter.message,
                type: starter.type
            } : {
                message: formatMessage(starter.message),
                type: starter.type
            }), [
        combinedConversationStarters,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1694d7942d86318a$export$ea338c37011da44c, {
        starters: starters,
        ...props
    });
};
const $1694d7942d86318a$export$ea338c37011da44c = ({ starters: starters, onConversationStarterClick: onConversationStarterClick, showReloadButton: showReloadButton = false, onReloadButtonClick: onReloadButtonClick = ()=>{}, onBrowseAgentsClick: onBrowseAgentsClick })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        as: "ul",
        space: "space.050",
        xcss: (0, $1Whri.cx)($1694d7942d86318a$var$styles.conversationStartersList, (0, $dh538.fg)('rovo_agent_empty_state_refresh') && $1694d7942d86318a$var$styles.conversationStartersListRefresh),
        children: [
            starters.map((starter, index)=>{
                const isLastStarter = index === starters.length - 1;
                const chatPill = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "li",
                    children: (0, $dh538.fg)('rovo_agent_empty_state_refresh') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                        xcss: $1694d7942d86318a$var$styles.button,
                        onClick: ()=>onConversationStarterClick(starter),
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.150",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $1694d7942d86318a$var$styles.conversationStarterIcon,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3h2i4.AgentChatIcon), {})
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $1694d7942d86318a$var$styles.conversationStarterText,
                                    children: starter.message
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $lBFuf.ChatPill), {
                        testId: "conversation-starter",
                        onClick: ()=>onConversationStarterClick(starter),
                        children: starter.message
                    }, starter.message)
                }, starter.message);
                return isLastStarter && showReloadButton ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.050",
                    grow: "fill",
                    alignInline: "end",
                    children: [
                        chatPill,
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d8ohW))),
                            onClick: onReloadButtonClick,
                            appearance: "subtle",
                            label: ""
                        })
                    ]
                }, starter.message) : chatPill;
            }),
            !!onBrowseAgentsClick && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "li",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lBFuf.BrowseAgentsPill), {
                    onClick: onBrowseAgentsClick
                })
            })
        ]
    });
};
module.exports["getConversationStarters"] = $1694d7942d86318a$export$c2d882153e0984c5;
module.exports["AgentConversationStarters"] = $1694d7942d86318a$export$171adfc74aa509c3;

});

parcelRegister("3h2i4", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cOQz3 = parcelRequire("cOQz3");


var $1s5hv = parcelRequire("1s5hv");

const $ea5bd56cfe7af0a8$var$styles = {
    agentChatIcon: "_2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsbzwfg _4t3izwfg"
};
const $ea5bd56cfe7af0a8$export$f33bbc5f5534c8a4 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        xcss: $ea5bd56cfe7af0a8$var$styles.agentChatIcon,
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))), {
            label: "",
            color: "var(--ds-icon-subtlest, #6B6E76)"
        })
    });
};
module.exports["AgentChatIcon"] = $ea5bd56cfe7af0a8$export$f33bbc5f5534c8a4;

});

parcelRegister("gMCDH", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $e1133cfae3bfd440$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    emptyStateSuggestion1: {
        id: "ai-mate.chat-history.empty-state.suggestion1",
        defaultMessage: "Are any of my tickets overdue?"
    },
    emptyStateSuggestion2: {
        id: "ai-mate.chat-history.empty-state.suggestion2",
        defaultMessage: "What should I work on next?"
    },
    emptyStateSuggestion3: {
        id: "ai-mate.chat-history.empty-state.suggestion3",
        defaultMessage: "Write an update about my week"
    },
    agentEmptyStateSuggestion1: {
        id: "ai-mate.chat-history.empty-state.agent-suggestion1",
        defaultMessage: "Tell me about yourself"
    },
    agentEmptyStateSuggestion2: {
        id: "ai-mate.chat-history.empty-state.agent-suggestion2",
        defaultMessage: "What can you help me with?"
    },
    agentEmptyStateSuggestion3: {
        id: "ai-mate.chat-history.empty-state.agent-suggestion3",
        defaultMessage: "Summarize what I'm looking at"
    }
});
module.exports["messages"] = $e1133cfae3bfd440$export$defe85febe8b728c;

});

parcelRegister("kSoKM", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $cgtv4 = parcelRequire("cgtv4");


var $aFUXX = parcelRequire("aFUXX");

function $095aa81eb4c35edf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $095aa81eb4c35edf$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    collapseNode: {
        id: "fabric.editor.collapseNode",
        defaultMessage: "Collapse content"
    },
    expandDefaultTitle: {
        id: "fabric.editor.expandDefaultTitle",
        defaultMessage: "Click here to expand..."
    },
    expandNode: {
        id: "fabric.editor.expandNode",
        defaultMessage: "Expand content"
    },
    expandPlaceholderText: {
        id: "fabric.editor.expandPlaceholder",
        defaultMessage: "Give this expand a title..."
    },
    expandArialabel: {
        id: "fabric.editor.expandAriaLabel",
        defaultMessage: "Give this expand a title"
    }
});
const $095aa81eb4c35edf$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: ()=>expanded ? [
                $095aa81eb4c35edf$var$expandIconWrapperStyle(),
                $095aa81eb4c35edf$var$expandIconWrapperExpandedStyle
            ] : $095aa81eb4c35edf$var$expandIconWrapperStyle()
    }, children);
};
const $095aa81eb4c35edf$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $aFUXX.akEditorSwoopCubicBezier)}`
        }
    });
const $095aa81eb4c35edf$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $095aa81eb4c35edf$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $095aa81eb4c35edf$export$c67faf67c1185cba = /*#__PURE__*/ (0, $42omo.forwardRef)(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props, ref)=>{
    const { children: children, ...rest } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @typescript-eslint/no-explicit-any
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $095aa81eb4c35edf$export$a7ed6bf20867161a,
        ...rest,
        ref: ref
    }, children));
});
module.exports["messages"] = $095aa81eb4c35edf$export$defe85febe8b728c;
module.exports["ExpandIconWrapper"] = $095aa81eb4c35edf$export$4eeef63d68e77552;
module.exports["expandLayoutWrapperStyle"] = $095aa81eb4c35edf$export$a7ed6bf20867161a;
module.exports["ExpandLayoutWrapperWithRef"] = $095aa81eb4c35edf$export$c67faf67c1185cba;

});

parcelRegister("6UBEn", function(module, exports) {
/* progress-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $3cc01bd0176870aa$var$MIN_VALUE = 0;
const $3cc01bd0176870aa$var$MAX_VALUE = 1;
const $3cc01bd0176870aa$var$increasingBarAnimation = null;
const $3cc01bd0176870aa$var$decreasingBarAnimation = null;
const $3cc01bd0176870aa$var$containerStyles = null;
const $3cc01bd0176870aa$var$containerStylesT26Shape = null;
const $3cc01bd0176870aa$var$containerAppearance = {
    default: "_bfhki8nm",
    success: "_bfhki8nm",
    inverse: "_bfhk1vck"
};
const $3cc01bd0176870aa$var$barAppearance = {
    default: "_bfhk1aqn",
    success: "_bfhkkcmj",
    inverse: "_bfhkvuon"
};
const $3cc01bd0176870aa$var$barStyles = null;
const $3cc01bd0176870aa$var$barStylesT26Shape = null;
const $3cc01bd0176870aa$var$determinateBarStyles = null;
const $3cc01bd0176870aa$var$increasingBarStyles = null;
const $3cc01bd0176870aa$var$decreasingBarStyles = null; /**
                                   * __Progress bar__
                                   *
                                   * A progress bar displays the status of a given process.
                                   *
                                   * - [Examples](https://atlassian.design/components/progress-bar/examples)
                                   * - [Code](https://atlassian.design/components/progress-bar/code)
                                   * - [Usage](https://atlassian.design/components/progress-bar/usage)
                                   */ 
const $3cc01bd0176870aa$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $3cc01bd0176870aa$var$MIN_VALUE : Math.max($3cc01bd0176870aa$var$MIN_VALUE, Math.min(value, $3cc01bd0176870aa$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $3cc01bd0176870aa$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $3cc01bd0176870aa$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhki8nm",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rkoidpf",
            $3cc01bd0176870aa$var$containerAppearance[appearance]
        ]),
        children: isIndeterminate ? /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $3cc01bd0176870aa$var$barAppearance[appearance],
                        "_5sagymdr _tip812c5 _j7hq7g40",
                        (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rkoidpf"
                    ])
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $3cc01bd0176870aa$var$barAppearance[appearance],
                        "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v",
                        (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rkoidpf"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $gMc0m.default)([
                "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                $3cc01bd0176870aa$var$barAppearance[appearance],
                "_v564calv",
                (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rkoidpf"
            ])
        })
    });
};
var $3cc01bd0176870aa$export$2e2bcd8739ae039 = $3cc01bd0176870aa$var$ProgressBar;
module.exports["default"] = $3cc01bd0176870aa$export$2e2bcd8739ae039;

});

parcelRegister("9QvUi", function(module, exports) {
$parcel$export(module.exports, "default", () => $13bb23ac78effffb$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $4H1Ql = parcelRequire("4H1Ql");


var $NT2w1 = parcelRequire("NT2w1");


var $2mPpz = parcelRequire("2mPpz");


var $eXPKf = parcelRequire("eXPKf");


var $42omo = parcelRequire("42omo");


var $2xYsH = parcelRequire("2xYsH");


var $hnA4H = parcelRequire("hnA4H");

const $13bb23ac78effffb$var$STABLE_OBJECT = {};
const $13bb23ac78effffb$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $42omo.useMemo)(()=>(0, $2mPpz.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $4H1Ql.useStableObject)(placementProps ?? $13bb23ac78effffb$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eXPKf.PerformanceTrackingSegment), {
        placementId: placementId,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $NT2w1.default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2xYsH.default), {
                    analyticsChannel: (0, $hnA4H.ANALYTICS_CHANNEL),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        onEvent: sharedOnEvent,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
        })
    });
};
var $13bb23ac78effffb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $42omo.memo)($13bb23ac78effffb$var$Placement);

});

parcelRegister("NT2w1", function(module, exports) {

var $ffCOo = parcelRequire("ffCOo");


var $PAiZW = parcelRequire("PAiZW");

var $6yHRM = parcelRequire("6yHRM");

var $4H1Ql = parcelRequire("4H1Ql");


var $3NyPa = parcelRequire("3NyPa");


var $kO3gu = parcelRequire("kO3gu");


var $42omo = parcelRequire("42omo");


var $4u5NT = parcelRequire("4u5NT");


var $dE7qQ = parcelRequire("dE7qQ");


var $5dPMD = parcelRequire("5dPMD");


var $dug7n = parcelRequire("dug7n");


var $feexy = parcelRequire("feexy");


var $9x4nt = parcelRequire("9x4nt");


var $dh538 = parcelRequire("dh538");

const $80ab3a0c2f45d583$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $kO3gu.usePlacementFetchingContext)();
    return (0, $42omo.useMemo)(()=>disableInitialData ? undefined : (0, $5dPMD.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
/**
 * Validates error is a standard Error instance. If not, wraps in new Error instance.
 */ const $80ab3a0c2f45d583$var$validateErrorFromEventType = (err, eventType)=>{
    if (err instanceof Error) return err;
    if (typeof err === 'string') return new Error(err);
    return new Error(`Unknown error during ${eventType}`);
};
/**
 * Reports an error to UFO v2 for a given placement, on the current UFO v2 active interaction.
 * @param ufoV2Interaction Context of the current active UFO v2 interaction
 * @param placementId Post Office placement identifier
 * @param error
 * @param errorEventType Event type that triggered the error
 * @returns void
 */ const $80ab3a0c2f45d583$var$handleUfoV2Error = ({ ufoV2Interaction: ufoV2Interaction, placementId: placementId, error: error, errorEventType: errorEventType })=>{
    const validatedError = $80ab3a0c2f45d583$var$validateErrorFromEventType(error, errorEventType);
    const { interactionId: interactionId, labelStack: labelStack } = ufoV2Interaction;
    if (interactionId) (0, $4u5NT.addError)(interactionId, `${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
    else (0, $4u5NT.addErrorToAll)(`${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
};
const $80ab3a0c2f45d583$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $6yHRM.usePostOfficeRoute)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $dug7n.useBuildBasePath)();
    const stableContextWithRoute = (0, $4H1Ql.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $42omo.useMemo)(()=>isUFOEnabled ? new (0, $3NyPa.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    const ufoV2InteractionId = (0, $42omo.useContext)((0, $feexy.default));
    const ufoV2InteractionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const stableUfoV2Interaction = (0, $4H1Ql.useStableObject)({
        interactionId: ufoV2InteractionId.current,
        labelStack: ufoV2InteractionContext?.labelStack
    });
    // Callback function to listen to the different stages of the component and track its performance
    const componentOnEvent = (0, $42omo.useCallback)(({ type: type, error: error })=>{
        // Used for local placement components, UFO v2 events
        if (consumptionType === 'local') {
            switch(type){
                case 'fetch-error':
                case 'component-error':
                case 'render-error':
                    if ((0, $dh538.fg)('post-office_enable_ufo-v2-add-error')) $80ab3a0c2f45d583$var$handleUfoV2Error({
                        ufoV2Interaction: stableUfoV2Interaction,
                        placementId: placementId,
                        error: error,
                        errorEventType: type
                    });
            }
            return;
        }
        // Used for remote placement components, UFO v1 events
        if (consumptionType === 'remote') {
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker,
        consumptionType,
        placementId,
        stableUfoV2Interaction
    ]);
    const initialData = $80ab3a0c2f45d583$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $42omo.useMemo)(()=>({
            source: (0, $dE7qQ.ANALYTICS_SOURCE),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ffCOo.PostOfficeAnalyticsContext), {
        data: placementAnalyticsContext
    }, children({
        initialData: initialData,
        context: stableContextWithRoute,
        onEvent: componentOnEvent
    }));
};
var $80ab3a0c2f45d583$export$2e2bcd8739ae039 = $80ab3a0c2f45d583$var$Placement;
module.exports["default"] = $80ab3a0c2f45d583$export$2e2bcd8739ae039;

});

parcelRegister("dE7qQ", function(module, exports) {
const $2d2adb07a8ea6d4a$export$85183a312807388d = 'postOffice';
const $2d2adb07a8ea6d4a$export$f7109619a5e9e0d6 = 'post-office-frontend';
module.exports["ANALYTICS_SOURCE"] = $2d2adb07a8ea6d4a$export$f7109619a5e9e0d6;

});

parcelRegister("dug7n", function(module, exports) {

var $bnKhH = parcelRequire("bnKhH");

var $c3xd8 = parcelRequire("c3xd8");


var $42omo = parcelRequire("42omo");

const $f2f503b4228c54ff$export$83d6c58b7ab7ae67 = ()=>{
    const postOfficeEnvironment = (0, $c3xd8.usePostOfficeEnvironment)();
    return (0, $42omo.useMemo)(()=>(0, $bnKhH.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};
module.exports["useBuildBasePath"] = $f2f503b4228c54ff$export$83d6c58b7ab7ae67;

});

parcelRegister("2xYsH", function(module, exports) {
$parcel$export(module.exports, "default", () => $1916333c8b5a116e$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $1DWH0 = parcelRequire("1DWH0");


var $42omo = parcelRequire("42omo");

class $1916333c8b5a116e$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
var $1916333c8b5a116e$export$2e2bcd8739ae039 = (0, $1DWH0.default)()($1916333c8b5a116e$var$ErrorBoundary);

});

parcelRegister("hnA4H", function(module, exports) {
const $f3b0e253e752d4df$export$85183a312807388d = 'postOffice';
module.exports["ANALYTICS_CHANNEL"] = $f3b0e253e752d4df$export$85183a312807388d;

});

parcelRegister("9oJIg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kO3gu = parcelRequire("kO3gu");


var $MyxIQ = parcelRequire("MyxIQ");

const $5176b2e7fefe99e5$export$9be10e5cc29463c9 = ({ children: children })=>{
    const fetch = (0, $MyxIQ.usePlacementSSRFetch)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kO3gu.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
module.exports["PlacementFetchProvider"] = $5176b2e7fefe99e5$export$9be10e5cc29463c9;

});

parcelRegister("8dbvt", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");

const $d8f8e39152f0bc27$export$19f6fc45ac74736 = (data, strategiesCounter)=>{
    const pageCardData = (0, $cxMI6.transformGlobalContent)(data.content);
    pageCardData.likesCount = 0;
    pageCardData.commentsCount = 0;
    pageCardData.recommendationStrategy = $d8f8e39152f0bc27$export$7c50bf2d337b5c51(data, strategiesCounter);
    return pageCardData;
};
const $d8f8e39152f0bc27$export$7c50bf2d337b5c51 = (data, strategiesCounter)=>{
    const strategies = data.strategy;
    if (strategies.includes('CONTENT_TO_CONTENT')) return 'CONTENT_TO_CONTENT';
    const currentCounter = new Map();
    strategies.forEach((entry)=>{
        const entryCount = strategiesCounter.get(entry) || 0;
        currentCounter.set(entry, entryCount);
    });
    const sortedCounter = new Map([
        ...currentCounter.entries()
    ].sort((a, b)=>a[1] - b[1]));
    const strategy = [
        ...sortedCounter.keys()
    ][0];
    const count = strategiesCounter.get(strategy) || 0;
    strategiesCounter.set(strategy, count + 1);
    return strategy;
};
const $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7 = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>$d8f8e39152f0bc27$export$19f6fc45ac74736(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const el = transformedRecs.find((card)=>card.id === rec.content.id);
        pageCards.push(el);
    });
    return pageCards;
};
module.exports["transformEndOfPageRecContent"] = $d8f8e39152f0bc27$export$19f6fc45ac74736;
module.exports["transformAndOrderRecs"] = $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7;

});

parcelRegister("cxMI6", function(module, exports) {

var $brn6e = parcelRequire("brn6e");


var $8rneB = parcelRequire("8rneB");


var $huWyw = parcelRequire("huWyw");


var $c7GB4 = parcelRequire("c7GB4");

const $c6273926c8df4325$var$ALL_CONTENT_TYPE = [
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'embed',
    'folder'
];
const $c6273926c8df4325$var$resumeDraftWebUiBypass = (urlPath, content)=>{
    const bypassUrl = (0, $huWyw.getURLBypassingResumeDraftAction)({
        url: urlPath || '',
        spaceKey: content?.space?.alias || content?.space?.key || '',
        contentType: content?.type,
        editorVersion: content?.editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, ''),
        contentId: content?.id || '',
        noContextPath: true
    });
    return bypassUrl;
};
const $c6273926c8df4325$export$a0bd4958aceee288 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent)=>{
    const EMOJI_CONTENT_TYPE = isWhiteboardEmojiFGEnabled ? [
        'page',
        'blogpost',
        'embed',
        'whiteboard'
    ] : [
        'page',
        'blogpost',
        'embed'
    ];
    const contentType = $c6273926c8df4325$var$ALL_CONTENT_TYPE.includes(content?.type) ? content.type : 'page';
    if (isActivityV3HomeRecent) return {
        id: (0, $c7GB4.getIdFromConfluenceContentAri)({
            ari: content?.id,
            resourceType: contentType
        }) || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, content?.metadata?.titleEmojiPublished?.value || '', content?.metadata?.titleEmojiDraft?.value || '', content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subtype,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editUi, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webUi, content)
        },
        isStarred: content?.viewer?.favoritedSummary?.isFavorite || false,
        likesCount: content?.likesSummary?.count || 0,
        commentsCount: content?.commentCountSummary?.total || 0,
        excerpt: content?.body?.excerpt?.trim()
    };
    return {
        id: content?.id || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, (0, $8rneB.getEmojiPublishedFromProperties)(content), (0, $8rneB.getEmojiDraftFromProperties)(content), content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subType,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editui, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webui, content)
        },
        isStarred: content?.metadata?.currentuser?.favourited?.isFavourite || false,
        likesCount: content?.likes?.count || 0,
        commentsCount: content?.metadata?.comments?.commentsCount || 0,
        excerpt: content?.excerpt?.trim(),
        lastAction: {
            when: content?.metadata?.lastModifiedDate || '',
            action: 'updated'
        }
    };
};
const $c6273926c8df4325$export$898674fde3fd0597 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled = false, isActivityV3HomeRecent = false)=>{
    const spaceAlias = content?.space?.alias || content?.space?.key;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        space: {
            spaceKey: spaceAlias || '',
            name: content?.space?.name || ''
        },
        creatorId: content?.creatorId || '',
        history: {
            ownedBy: {
                displayName: content?.history?.ownedBy?.displayName || ''
            }
        }
    };
};
const $c6273926c8df4325$export$1e1d4cb60561af2b = (content, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    const ownedBy = content?.status === 'draft' ? content?.version?.by : content?.history?.ownedBy;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled),
        createdBy: {
            displayName: createdBy?.displayName || '',
            profilePicture: createdBy?.profilePicture?.path || '',
            accountId: createdBy?.accountId || ''
        },
        ownedBy: {
            displayName: ownedBy?.displayName || '',
            profilePicture: ownedBy?.profilePicture?.path || '',
            accountId: ownedBy?.accountId || ''
        }
    };
};
const $c6273926c8df4325$export$ee67d5d6f48183b0 = (card)=>Boolean(card.createdBy);
module.exports["transformGlobalContent"] = $c6273926c8df4325$export$898674fde3fd0597;
module.exports["transformSpaceContent"] = $c6273926c8df4325$export$1e1d4cb60561af2b;
module.exports["isSpacePageCard"] = $c6273926c8df4325$export$ee67d5d6f48183b0;

});

parcelRegister("brn6e", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $7PLO8 = parcelRequire("7PLO8");


var $6mKj3 = parcelRequire("6mKj3");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $3shHM = parcelRequire("3shHM");


var $8rneB = parcelRequire("8rneB");


var $87Z8O = parcelRequire("87Z8O");


var $5amrO = parcelRequire("5amrO");

const $a7a7184e7345058e$export$8807f1cb55bf77de = async ({ userId: userId, cloudId: cloudId, emojiId: emojiId })=>{
    const provider = await (0, $8rneB.getEmojiProvider)(cloudId, userId);
    if (provider) {
        const emoji = await provider.findById(emojiId);
        if (emoji) return provider.loadMediaEmoji(emoji);
    }
    return Promise.resolve(null);
};
const $a7a7184e7345058e$export$66e71aac8865f81a = /([a-z\d_-]+):/;
let $a7a7184e7345058e$var$hasSetFavicon = false;
let $a7a7184e7345058e$var$previousFavicon = null;
const $a7a7184e7345058e$var$updateFaviconHref = (href)=>{
    const favIcons = document.querySelectorAll("link[rel~='icon']");
    favIcons.forEach((linkEl)=>{
        // remember default favicon on first change in case we need to revert
        if (!$a7a7184e7345058e$var$hasSetFavicon) {
            $a7a7184e7345058e$var$previousFavicon = linkEl.href;
            $a7a7184e7345058e$var$hasSetFavicon = true;
        }
        linkEl.href = href;
    });
};
const $a7a7184e7345058e$export$4bb2c221b7e4cc0 = (emoji)=>{
    if (!(0, $dh538.fg)('confluence_emoji_title_favicon')) return;
    if (!emoji) {
        if ($a7a7184e7345058e$var$hasSetFavicon && $a7a7184e7345058e$var$previousFavicon) $a7a7184e7345058e$var$updateFaviconHref($a7a7184e7345058e$var$previousFavicon);
        return;
    }
    $a7a7184e7345058e$var$updateFaviconHref(emoji);
};
const $a7a7184e7345058e$export$ea48fb6f63107646 = async ({ selectedEmoji: selectedEmoji, emojiProvider: emojiProvider, onUpdateStartEmoji: onUpdateStartEmoji, createAnalyticsEvent: createAnalyticsEvent, emojiTitleState: emojiTitleState, onEmojiUpdated: onEmojiUpdated, onUpdateEndEmoji: onUpdateEndEmoji, updateContentPropertyExperimentalMutation: updateContentPropertyExperimentalMutation, updateContentProperty: updateContentProperty, contentId: contentId, componentName: componentName, isLivePage: isLivePage, emojiStatusFieldName: emojiStatusFieldName }, _event)=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    (0, $3shHM.sendAnalyticsEvent)(createAnalyticsEvent, {
        eventType: 'sendUIEvent',
        element: 'button',
        action: 'clicked',
        actionSubject: 'emojiPicker',
        actionSubjectId: 'emoji',
        attributes: {
            emojiId: selectedEmoji?.id,
            inputMethod: 'title',
            isLivePage: isLivePage
        }
    });
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    const loadedEmoji = await emojiProvider.loadMediaEmoji(selectedEmoji, true);
    emojiTitleState.setOpenSecondEmojiPicker(false);
    emojiTitleState.setSelectedEmoji(loadedEmoji);
    return onEmojiUpdated().then(({ data: data })=>{
        const versionNumber = (0, $8rneB.getVersionNumber)(data, emojiStatusFieldName);
        const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
        const emojiValue = selectedEmoji?.id?.replace(/['"]+/g, '') ?? '';
        if ((0, $6mKj3.expValEquals)('migrate_off_experimentalupdatecontentproperty', 'isEnabled', true)) return updateContentProperty({
            propertyKey: propertyKey,
            propertyValue: emojiValue,
            hasExistingProperty: versionNumber > 0,
            options: {
                update: ()=>{
                    try {
                        const cacheData = (0, $l1uFv.readQueryInterop)({
                            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $87Z8O.getEmojiTitleProperty),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            }
                        });
                        if (cacheData.content.nodes[0][emojiStatusFieldName]) cacheData.content.nodes[0][emojiStatusFieldName].nodes[0] = {
                            ...cacheData.content.nodes[0][emojiStatusFieldName].nodes[0],
                            id: contentId,
                            key: propertyKey,
                            value: emojiValue,
                            version: {
                                number: newVersionNumber,
                                __typename: 'Version'
                            }
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $87Z8O.getEmojiTitleProperty),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating ${propertyKey} content property after user selecting emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).then(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
            emojiTitleState.setSelectedEmoji(loadedEmoji);
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user selecting emoji ${error.message}`);
        });
        else return updateContentPropertyExperimentalMutation({
            variables: {
                contentId: contentId,
                propertyKey: propertyKey,
                propertyValue: emojiValue,
                versionNumber: String(newVersionNumber)
            },
            update: (proxy)=>{
                try {
                    const cacheData = proxy.readQuery({
                        query: (0, $87Z8O.getEmojiTitleProperty),
                        variables: {
                            contentId: contentId,
                            status: [
                                'current',
                                'draft'
                            ],
                            skipPublishedFragment: true,
                            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                        }
                    });
                    if (cacheData.content.nodes[0][emojiStatusFieldName]) cacheData.content.nodes[0][emojiStatusFieldName].nodes[0] = {
                        ...cacheData.content.nodes[0][emojiStatusFieldName].nodes[0],
                        id: contentId,
                        key: propertyKey,
                        value: emojiValue,
                        version: {
                            number: newVersionNumber,
                            __typename: 'Version'
                        }
                    };
                    proxy.writeQuery({
                        query: (0, $87Z8O.getEmojiTitleProperty),
                        variables: {
                            contentId: contentId,
                            status: [
                                'current',
                                'draft'
                            ],
                            skipPublishedFragment: true,
                            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                        },
                        data: data
                    });
                } catch (error) {
                    throw new Error(`${componentName} failed to write to cache while updating ${propertyKey} content property after user selecting emoji ${error.message}`);
                }
            },
            optimisticResponse: {
                __typename: 'Mutation',
                experimentalUpdateContentProperty: {
                    __typename: 'ExperimentalUpdateContentProperty',
                    success: true,
                    id: contentId,
                    key: propertyKey,
                    value: emojiValue
                }
            }
        }).then(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
            emojiTitleState.setSelectedEmoji(loadedEmoji);
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user selecting emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$fbfb144f0da80edc = (_event, { onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, onEmojiUpdated: onEmojiUpdated, contentId: contentId, updateContentPropertyExperimentalMutation: updateContentPropertyExperimentalMutation, updateContentProperty: updateContentProperty, componentName: componentName = '', emojiStatusFieldName: emojiStatusFieldName })=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    return onEmojiUpdated().then(()=>{
        if ((0, $6mKj3.expValEquals)('migrate_off_experimentalupdatecontentproperty', 'isEnabled', true)) return updateContentProperty({
            propertyKey: propertyKey,
            isDelete: true,
            options: {
                update: ()=>{
                    try {
                        const data = (0, $l1uFv.readQueryInterop)({
                            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $87Z8O.getEmojiTitleProperty),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            }
                        });
                        data.content.nodes[0][emojiStatusFieldName] = {
                            nodes: [],
                            __typename: 'PaginatedJsonContentPropertyList'
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $87Z8O.getEmojiTitleProperty),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating content property after user removing emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).finally(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user removing emoji ${error.message}`);
        });
        else return updateContentPropertyExperimentalMutation({
            variables: {
                contentId: contentId,
                propertyKey: propertyKey,
                isDelete: true
            },
            update: (proxy)=>{
                try {
                    const data = proxy.readQuery({
                        query: (0, $87Z8O.getEmojiTitleProperty),
                        variables: {
                            contentId: contentId,
                            status: [
                                'current',
                                'draft'
                            ],
                            skipPublishedFragment: true,
                            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                        }
                    });
                    data.content.nodes[0][emojiStatusFieldName] = {
                        nodes: [],
                        __typename: 'PaginatedJsonContentPropertyList'
                    };
                    proxy.writeQuery({
                        query: (0, $87Z8O.getEmojiTitleProperty),
                        variables: {
                            contentId: contentId,
                            status: [
                                'current',
                                'draft'
                            ],
                            skipPublishedFragment: true,
                            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                        },
                        data: data
                    });
                } catch (error) {
                    throw new Error(`${componentName} failed to write to cache while updating content property after user removing emoji ${error.message}`);
                }
            },
            optimisticResponse: {
                __typename: 'Mutation',
                experimentalUpdateContentProperty: {
                    __typename: 'ExperimentalUpdateContentProperty',
                    success: true
                }
            }
        }).finally(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user removing emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$8c0236acf4c550c0 = RegExp("^(\\p{RI}\\p{RI}|\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?(\\u{200D}\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?)*)", "u");
const $a7a7184e7345058e$export$cb9bb843138d9261 = (title)=>title && title.replace($a7a7184e7345058e$export$8c0236acf4c550c0, '').trimLeft() || '';
const $a7a7184e7345058e$export$9d1875ac2476f6b6 = (title)=>title && $a7a7184e7345058e$export$8c0236acf4c550c0.exec(title)?.[0] || '';
const $a7a7184e7345058e$export$388f90f8e727e4d5 = (rawTitle = '', rawPublishedEmoji = '', rawDraftEmoji = '', status = '', untitledDraftText = '', getEmoji = true)=>{
    const nativeEmoji = getEmoji ? $a7a7184e7345058e$export$9d1875ac2476f6b6(rawTitle) : '';
    let selectedEmoji = '';
    if (getEmoji) selectedEmoji = status?.toLowerCase() === 'draft' ? rawDraftEmoji : rawPublishedEmoji;
    const hasNativeEmoji = nativeEmoji.length > 0;
    const hasSelectedEmoji = selectedEmoji.length > 0;
    const emoji = hasSelectedEmoji ? selectedEmoji : nativeEmoji;
    let text = hasNativeEmoji && !hasSelectedEmoji ? $a7a7184e7345058e$export$cb9bb843138d9261(rawTitle) : rawTitle;
    if (status === 'draft' && !text) text = untitledDraftText;
    return {
        text: text,
        emoji: emoji,
        selectedEmoji: selectedEmoji
    };
};
module.exports["getEmojiFromEmojiId"] = $a7a7184e7345058e$export$8807f1cb55bf77de;
module.exports["maybeOverrideFaviconWithEmoji"] = $a7a7184e7345058e$export$4bb2c221b7e4cc0;
module.exports["onSelectEmoji"] = $a7a7184e7345058e$export$ea48fb6f63107646;
module.exports["onRemoveEmoji"] = $a7a7184e7345058e$export$fbfb144f0da80edc;
module.exports["emojiExp"] = $a7a7184e7345058e$export$8c0236acf4c550c0;
module.exports["removeEmojiFromTitle"] = $a7a7184e7345058e$export$cb9bb843138d9261;
module.exports["getEmojiFromTitle"] = $a7a7184e7345058e$export$9d1875ac2476f6b6;
module.exports["getTitleAndEmoji"] = $a7a7184e7345058e$export$388f90f8e727e4d5;

});

parcelRegister("3shHM", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");


var $87Z8O = parcelRequire("87Z8O");

const $d6c558249b167bda$export$5e53520e517ec9ab = (createAnalyticsEvent, { eventType: eventType, element: element, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        type: eventType,
        data: {
            action: action,
            source: 'EmojiTitleSection',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                element: element,
                ...attributes
            }
        }
    }).fire();
};
const $d6c558249b167bda$export$1fa99c5c7c4cc530 = async ({ createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isLivePage: isLivePage })=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const { data: data } = await (0, $hp2SH.getApolloClient)().query({
        query: (0, $87Z8O.getEmojiTitleProperty),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        }
    });
    const emojiId = (0, $8rneB.getEmojiId)(data, (0, $5amrO.EMOJI_TITLE_DRAFT_FIELD));
    const hasDraftEmoji = emojiId.length >= 0 && emojiId !== '';
    // only track draft with emoji
    if (hasDraftEmoji) $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: '',
        action: 'created',
        actionSubject: 'draftWithEmoji',
        actionSubjectId: '',
        attributes: {
            emojiId: emojiId,
            isLivePage: isLivePage
        }
    });
};
const $d6c558249b167bda$export$5a8401d422e6e576 = ({ createAnalyticsEvent: createAnalyticsEvent, emoji: emoji, context: context, error: error = {
    message: ''
}, isLivePage: isLivePage })=>{
    $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: 'emoji',
        action: 'error',
        actionSubject: 'renderEmoji',
        actionSubjectId: 'renderEmojiError',
        attributes: {
            emojiShortName: emoji && emoji.shortName,
            emojiId: emoji && emoji.id,
            context: context,
            errorMessage: error.message,
            isLivePage: isLivePage
        }
    });
};
module.exports["sendAnalyticsEvent"] = $d6c558249b167bda$export$5e53520e517ec9ab;
module.exports["trackDraftCreatedWithEmoji"] = $d6c558249b167bda$export$1fa99c5c7c4cc530;
module.exports["onFailedToLoadEmoji"] = $d6c558249b167bda$export$5a8401d422e6e576;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("c7GB4", function(module, exports) {

var $eB56w = parcelRequire("eB56w");

var $iH7AG = parcelRequire("iH7AG");

var $dM0Qh = parcelRequire("dM0Qh");

var $lb1Mg = parcelRequire("lb1Mg");

var $a2xFu = parcelRequire("a2xFu");

var $a5Dk4 = parcelRequire("a5Dk4");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $a2xFu.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $eB56w.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $a5Dk4.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $iH7AG.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $dM0Qh.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $lb1Mg.ConfluenceFolderAri).parse(ari).folderId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("iH7AG", function(module, exports) {

var $hIjpx = parcelRequire("hIjpx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/database/manifest.ts
var $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $hIjpx.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $hIjpx.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $d9c22183dba005c8$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $d9c22183dba005c8$export$317cd32472deea7e;

});

parcelRegister("hIjpx", function(module, exports) {
// src/confluence/database/types.ts
var $ce559a57d4ba003b$export$e83bc7b627335f1d = "confluence", $ce559a57d4ba003b$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $ce559a57d4ba003b$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $ce559a57d4ba003b$export$d26db9a1a0b750aa;

});

parcelRegister("dM0Qh", function(module, exports) {

var $dPsPU = parcelRequire("dPsPU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/embed/manifest.ts
var $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $dPsPU.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $dPsPU.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $a070694ffdc5cb3b$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $a070694ffdc5cb3b$export$47d4b4205d0ac61a;

});

parcelRegister("dPsPU", function(module, exports) {
// src/confluence/embed/types.ts
var $a116681263506e39$export$7a02af293cacddd2 = "confluence", $a116681263506e39$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $a116681263506e39$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $a116681263506e39$export$f817d48842ea0d4a;

});

parcelRegister("6bHqX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gstll = parcelRequire("gstll");

var $6H9BA = parcelRequire("6H9BA");


var $4Twfb = parcelRequire("4Twfb");


var $3yFL2 = parcelRequire("3yFL2");

var $3SLm1 = parcelRequire("3SLm1");

var $cEhot = parcelRequire("cEhot");


var $1Y5Zp = parcelRequire("1Y5Zp");

const $30c48f23b8aa47be$var$BILLING_API_GATEWAY_URL = `${(0, $gstll.GATEWAY_URL)}/bag`;
const $30c48f23b8aa47be$export$56507f8f3f7349a5 = 'HAMS';
const $30c48f23b8aa47be$export$9a39331b1bb2f849 = 'CCP';
const $30c48f23b8aa47be$export$49ab1426acf387e4 = async (params, { fetch: fetch })=>{
    try {
        const response = await fetch(`${$30c48f23b8aa47be$var$BILLING_API_GATEWAY_URL}/rollout/service?cloudId=${encodeURIComponent(params.cloudId)}`);
        if (response.status !== 200) return {
            payload: undefined,
            error: `Failed to fetch commerce rollout information: ${response.statusText}`,
            exception: undefined
        };
        const service = (await response.json()).service;
        return {
            payload: service === 'CCP' ? {
                commerceBackend: service,
                ccp: {}
            } : {
                commerceBackend: service,
                hams: {}
            },
            error: undefined,
            exception: undefined
        };
    } catch (exception) {
        return {
            payload: undefined,
            error: undefined,
            exception: exception
        };
    }
};
const $30c48f23b8aa47be$export$532017a098b73852 = (params, options)=>{
    const fetch = (0, $6H9BA.useCommerceFetch)();
    const effectiveOptions = (0, $42omo.useMemo)(()=>({
            fetch: fetch,
            ...options
        }), [
        fetch,
        options
    ]);
    const startTask = (0, $cEhot.useTaskTracker)({
        action: 'fetched',
        actionSubject: 'commerceRolloutInformation',
        source: 'unknown'
    });
    return (0, $4Twfb.useFetchService)((0, $42omo.useCallback)(async ()=>{
        const taskResult = await startTask(async ()=>{
            const result = await $30c48f23b8aa47be$export$49ab1426acf387e4(params, effectiveOptions);
            if ((0, $1Y5Zp.isSuccessful)(result)) return {
                succeed: {
                    payload: result.payload
                }
            };
            else if ((0, $1Y5Zp.isException)(result)) // fetch can sometimes throw, but most likely this is a bug
            return {
                fail: {
                    payload: result.exception,
                    loggablePayload: result.exception,
                    responsibleService: (0, $3SLm1).COMMERCE_LIBRARIES,
                    probabilityOfBug: (0, $3yFL2).GUARANTEED
                }
            };
            return {
                // Failed response from server.
                fail: {
                    payload: result.error,
                    responsibleService: (0, $3SLm1).BILLING_API_GATEWAY,
                    // TODO: Review HTTP codes to differentiate between bug and normal errors
                    probabilityOfBug: (0, $3yFL2).MAYBE
                }
            };
        });
        if (taskResult.succeed !== undefined) return taskResult.succeed.payload;
        throw taskResult.fail.payload;
    }, [
        startTask,
        params,
        effectiveOptions
    ]));
};
module.exports["COMMERCE_BACKEND_HAMS"] = $30c48f23b8aa47be$export$56507f8f3f7349a5;
module.exports["COMMERCE_BACKEND_CCP"] = $30c48f23b8aa47be$export$9a39331b1bb2f849;
module.exports["fetchCommerceRolloutInformation"] = $30c48f23b8aa47be$export$49ab1426acf387e4;

});

parcelRegister("gstll", function(module, exports) {
// top level domain should have a stargate proxy under this path
// see https://developer.atlassian.com/platform/stargate/concepts/domains/
const $973c3a69f9510c45$export$91e8019c72e4e6d = `/gateway/api`;
module.exports["GATEWAY_URL"] = $973c3a69f9510c45$export$91e8019c72e4e6d;

});

parcelRegister("6H9BA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4u5NT = parcelRequire("4u5NT");


var $goqBE = parcelRequire("goqBE");


var $bIMHH = parcelRequire("bIMHH");


var $1cK19 = parcelRequire("1cK19");


var $1EMUC = parcelRequire("1EMUC");


var $lzJ3V = parcelRequire("lzJ3V");

const $5f57f8a421838b9c$export$5f844fc0012b62a = ()=>{
    const commerceContextFetch = (0, $1EMUC.useCommerceOverride)(fetch);
    const dispatchSentryException = (0, $bIMHH.useSentryExceptionDispatch)();
    return (0, $42omo.useCallback)(async (...args)=>{
        const startTime = performance.now();
        const [fetchInput] = args;
        const sanitizedUrl = (0, $1cK19.sanitizeUrlString)((0, $lzJ3V.getRequestUrl)(fetchInput));
        try {
            const response = await commerceContextFetch(...args);
            if (response.status >= 400) dispatchSentryException({
                exception: new Error(`Status: ${response.status}\nURL: ${sanitizedUrl}`)
            });
            (0, $4u5NT.addSpanToAll)('fetch', sanitizedUrl, [
                {
                    name: 'network'
                }
            ], startTime, performance.now(), JSON.stringify(response).length);
            return response;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
            const oldErrorMessage = (()=>{
                if (error instanceof Error) return error.stack ?? error.toString();
                else return JSON.stringify(error);
            })();
            const newErrorMessage = `An error occurred when fetching from ${sanitizedUrl}\n\n ${oldErrorMessage}`;
            const wrappedError = new Error(newErrorMessage);
            dispatchSentryException({
                exception: wrappedError
            });
            throw error;
        }
    }, [
        commerceContextFetch,
        dispatchSentryException
    ]);
};
const $5f57f8a421838b9c$export$2eeff918208c7909 = (request, dispatchSentryException)=>request.catch((error)=>{
        // reportHttpError doesn't dispatch url as HttpResponseError has a resource name in the message
        if (error instanceof (0, $goqBE.HttpResponseError)) dispatchSentryException({
            exception: error
        });
        const oldErrorMessage = (()=>{
            if (error instanceof Error) return error.stack ?? error.toString();
            else return JSON.stringify(error);
        })();
        const newErrorMessage = `An error occurred when fetching data\n\n ${oldErrorMessage}`;
        dispatchSentryException({
            exception: new Error(newErrorMessage)
        });
        return error;
    });
module.exports["useCommerceFetch"] = $5f57f8a421838b9c$export$5f844fc0012b62a;

});

parcelRegister("goqBE", function(module, exports) {
class $de24e055bcb736b9$export$d2f2761cbe9cebf2 extends Error {
    constructor(resourceName, statusCode, body){
        super(`Unable to fetch ${resourceName}, status: ${statusCode}`);
        this.statusCode = void 0;
        this.body = void 0;
        this.name = 'HttpResponseError';
        this.statusCode = statusCode;
        this.body = body;
        // necessary as Subclassing Error needs special treatment in typescript for some compilation targets
        //https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $de24e055bcb736b9$export$d2f2761cbe9cebf2.prototype);
    }
}
const $de24e055bcb736b9$export$a4c208475de70990 = async (resourceName, response)=>{
    const res = await response;
    if (res.ok) return response;
    throw new $de24e055bcb736b9$export$d2f2761cbe9cebf2(resourceName, res.status, // ignore error if there is no body,
    // there is no way to check if body is set as https://developer.mozilla.org/en-US/docs/Web/API/Body/bodyUsed is not supported by many browsers
    await res.json().catch(()=>undefined));
};
module.exports["HttpResponseError"] = $de24e055bcb736b9$export$d2f2761cbe9cebf2;
module.exports["rejectOnHttpError"] = $de24e055bcb736b9$export$a4c208475de70990;

});

parcelRegister("bIMHH", function(module, exports) {

var $aNwpq = parcelRequire("aNwpq");


var $k6lJw = parcelRequire("k6lJw");


var $6YLhE = parcelRequire("6YLhE");

const $48dc7deec6188f73$export$3c3f21d4489e178a = (0, $aNwpq.internalGasV3UIEventChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$5e75c4fb0a07e6f4 = (0, $aNwpq.internalGasV3ScreenEventChannel).useEventDispatch;
const $48dc7deec6188f73$export$eb1dac57abae25e8 = (0, $aNwpq.internalGasV3TrackEventChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$ab6d20b2228c09c6 = (0, $aNwpq.internalGasV3OperationalEventChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$cf4d833c52e18bed = (0, $aNwpq.internalSentryExceptionChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$8eb9a37a282b8ea6 = (0, $k6lJw.createAtlaskitToEventChannelRepackager)($48dc7deec6188f73$export$3c3f21d4489e178a);
const $48dc7deec6188f73$export$d6cab26720f11779 = (0, $aNwpq.breadcrumbMountedEventChannel).Listener;
const $48dc7deec6188f73$export$794ea2871d096951 = (Component, name, attributes)=>(0, $6YLhE.withBreadcrumb)(Component, (0, $aNwpq.Breadcrumb), name, attributes);
module.exports["useSentryExceptionDispatch"] = $48dc7deec6188f73$export$cf4d833c52e18bed;

});

parcelRegister("aNwpq", function(module, exports) {

var $6YLhE = parcelRequire("6YLhE");


var $eUjEX = parcelRequire("eUjEX");

const $48f3d8edf25a7fa7$var$breadcrumbAPI = (0, $6YLhE.createBreadcrumbAPI)();
const $48f3d8edf25a7fa7$export$1622e7b9340efb0 = $48f3d8edf25a7fa7$var$breadcrumbAPI.breadcrumbMountedEventChannel;
const $48f3d8edf25a7fa7$export$dabcc1ec9dd9d1cc = $48f3d8edf25a7fa7$var$breadcrumbAPI.Breadcrumb;
const $48f3d8edf25a7fa7$export$a841c408695b0137 = $48f3d8edf25a7fa7$var$breadcrumbAPI.useGetBreadcrumbs;
const $48f3d8edf25a7fa7$export$58a908b728d2cddc = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$34eb9485fd3a664a = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$fb5e587076f78057 = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$f92d259194a988f8 = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$d9c23c680d73705d = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$b7973f9532f3f87f = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$5a78c7e669ed705e = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$90a2fbbf51eb525f = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$c70a8fa9e6b52c91 = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$d9101fe70b7457a1 = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
module.exports["breadcrumbMountedEventChannel"] = $48f3d8edf25a7fa7$export$1622e7b9340efb0;
module.exports["Breadcrumb"] = $48f3d8edf25a7fa7$export$dabcc1ec9dd9d1cc;
module.exports["internalGasV3UIEventChannel"] = $48f3d8edf25a7fa7$export$b7973f9532f3f87f;
module.exports["internalGasV3ScreenEventChannel"] = $48f3d8edf25a7fa7$export$5a78c7e669ed705e;
module.exports["internalGasV3TrackEventChannel"] = $48f3d8edf25a7fa7$export$90a2fbbf51eb525f;
module.exports["internalGasV3OperationalEventChannel"] = $48f3d8edf25a7fa7$export$c70a8fa9e6b52c91;
module.exports["internalSentryExceptionChannel"] = $48f3d8edf25a7fa7$export$d9101fe70b7457a1;

});

parcelRegister("6YLhE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $eUjEX = parcelRequire("eUjEX");

const $098bf883a354e4d9$var$emptyObject = {};
const $098bf883a354e4d9$export$783e5d823c500873 = ()=>{
    const context = /*#__PURE__*/ (0, $42omo.createContext)(()=>undefined);
    const useGetBreadcrumbs = ()=>(0, $42omo.useContext)(context);
    const breadcrumbMountedEventChannel = (0, $eUjEX.createEventChannel)();
    const { useEventDispatch: useEventDispatch } = breadcrumbMountedEventChannel;
    const EmitEventOnMount = ({ name: name, getMountedBreadcrumbPayload: getMountedBreadcrumbPayload })=>{
        const eventDispatch = useEventDispatch();
        (0, $42omo.useEffect)(()=>{
            // Should always be defined at this point.
            eventDispatch(getMountedBreadcrumbPayload());
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            name
        ]);
        return null;
    };
    const Breadcrumb = ({ children: children, ...breadcrumbPayload })=>{
        const getParentBreadcrumbs = useGetBreadcrumbs();
        // TODO: Type inference doesn't seem to understand that children and name are never a part of breadcrumbPayload. Investigate and fix.
        const castBreadcrumbPayload = breadcrumbPayload;
        // Prevents breadcrumb callback from being recreated everytime props change/every-render
        const breadcrumbRef = (0, $42omo.useRef)(castBreadcrumbPayload);
        (0, $42omo.useLayoutEffect)(()=>{
            // Ensures that the breadcrumb only updates when it component is mounted
            breadcrumbRef.current = castBreadcrumbPayload;
        });
        // TODO: Memoize this in the future?
        const getMountedBreadcrumbPayload = (0, $42omo.useCallback)(()=>({
                breadcrumbs: [
                    ...getParentBreadcrumbs()?.breadcrumbs ?? [],
                    breadcrumbRef.current
                ],
                payload: breadcrumbRef.current
            }), [
            getParentBreadcrumbs
        ]);
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(EmitEventOnMount, {
                    name: breadcrumbPayload.name,
                    getMountedBreadcrumbPayload: getMountedBreadcrumbPayload
                }),
                /*#__PURE__*/ (0, $l998X.jsx)(context.Provider, {
                    value: getMountedBreadcrumbPayload,
                    children: children
                })
            ]
        });
    };
    return {
        breadcrumbMountedEventChannel: /**
		 * An event channel whos event represents that a breadcrumb was mounted
		 */ breadcrumbMountedEventChannel,
        Breadcrumb: Breadcrumb,
        useGetBreadcrumbs: useGetBreadcrumbs
    };
};
const $098bf883a354e4d9$export$d3653322274df895 = ({ useGetBreadcrumbs: useGetBreadcrumbs }, createEventChannelFn = (0, $eUjEX.createEventChannel))=>{
    const { Listener: Listener, useEventDispatch: useEventDispatch } = createEventChannelFn();
    const useBreadcrumbedEventDispatch = ()=>{
        const eventDispatch = useEventDispatch();
        const getParentBreadcrumbs = useGetBreadcrumbs();
        const breadcrumbedEventDispatch = (0, $42omo.useCallback)((payload)=>eventDispatch({
                breadcrumbs: getParentBreadcrumbs()?.breadcrumbs ?? [],
                payload: payload
            }), [
            getParentBreadcrumbs,
            eventDispatch
        ]);
        return breadcrumbedEventDispatch;
    };
    return {
        Listener: Listener,
        useEventDispatch: useEventDispatch,
        useBreadcrumbedEventDispatch: useBreadcrumbedEventDispatch
    };
};
const $098bf883a354e4d9$export$794ea2871d096951 = (Component, Breadcrumb, name, // TODO: Fix up this type
breadcrumbFields = $098bf883a354e4d9$var$emptyObject)=>{
    const ComponentWithBreadcrumb = (props)=>/*#__PURE__*/ (0, $l998X.jsx)(Breadcrumb, {
            ...breadcrumbFields,
            name: name,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...props
            })
        });
    return ComponentWithBreadcrumb;
};
module.exports["createBreadcrumbAPI"] = $098bf883a354e4d9$export$783e5d823c500873;
module.exports["createBreadcrumbedEventChannel"] = $098bf883a354e4d9$export$d3653322274df895;
module.exports["withBreadcrumb"] = $098bf883a354e4d9$export$794ea2871d096951;

});

parcelRegister("eUjEX", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e = (defaultOnEventCallback)=>{
    const context = /*#__PURE__*/ (0, $42omo.createContext)(defaultOnEventCallback);
    const useEventDispatch = ()=>{
        const onEventCallback = (0, $42omo.useContext)(context);
        const fireEventCallback = (0, $42omo.useCallback)((event)=>{
            onEventCallback?.(event);
        }, [
            onEventCallback
        ]);
        return fireEventCallback;
    };
    const EventCatcher = ({ onEvent: onEvent, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)(context.Provider, {
            value: onEvent,
            children: children
        });
    return {
        Listener: EventCatcher,
        useEventDispatch: useEventDispatch
    };
};
const $e0bd124d99ee3c1b$export$7b182ad6fa711a33 = ()=>{
    const catchingEventChannel = $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e();
    const ListenerThatDoesntConsumeEvent = $e0bd124d99ee3c1b$export$a5fa32b3c7f79e99({
        from: catchingEventChannel.Listener,
        to: catchingEventChannel.useEventDispatch
    });
    return {
        Listener: ListenerThatDoesntConsumeEvent,
        useEventDispatch: catchingEventChannel.useEventDispatch
    };
};
const $e0bd124d99ee3c1b$export$21d0f08655d40180 = (...listenersToCombine)=>{
    const CombinedListener = ({ children: children, onEvent: onEvent })=>{
        let wrappedChildren = children;
        for (const ListenerToCombine of listenersToCombine)wrappedChildren = ListenerToCombine({
            onEvent: onEvent,
            children: wrappedChildren
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: wrappedChildren
        });
    };
    return CombinedListener;
};
const $e0bd124d99ee3c1b$export$9591aa59b8e3deeb = ({ from: inboundListenerValue, to: useOutboundEventDispatch, useTransformer: useTransformer })=>{
    const InboundListener = Array.isArray(inboundListenerValue) ? $e0bd124d99ee3c1b$export$21d0f08655d40180(...inboundListenerValue) : inboundListenerValue;
    const Transformer = ({ children: children, ...transformerProps })=>{
        const dispatchTransformedEvent = useOutboundEventDispatch();
        const transform = useTransformer(transformerProps);
        const transformFn = (0, $42omo.useCallback)((payload)=>{
            const transformed = transform(payload);
            dispatchTransformedEvent(transformed);
        }, [
            dispatchTransformedEvent,
            transform
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)(InboundListener, {
            onEvent: transformFn,
            children: children
        });
    };
    return Transformer;
};
const $e0bd124d99ee3c1b$export$a5fa32b3c7f79e99 = ({ from: from, to: to })=>{
    const ListenerThatDoesntConsumeEvent = $e0bd124d99ee3c1b$export$9591aa59b8e3deeb({
        from: from,
        to: to,
        useTransformer: ({ onEvent: onEvent })=>(0, $42omo.useCallback)((payload)=>{
                onEvent(payload);
                return payload;
            }, [
                onEvent
            ])
    });
    return ListenerThatDoesntConsumeEvent;
};
const $e0bd124d99ee3c1b$export$6c91a1925c226122 = (Listener, filter)=>{
    const FilteredListener = ({ onEvent: onEvent, ...other })=>{
        const filteredOnEvent = (0, $42omo.useCallback)((eventPayload)=>{
            if (filter(eventPayload)) onEvent(eventPayload);
        }, [
            onEvent
        ]);
        return Listener({
            onEvent: filteredOnEvent,
            ...other
        });
    };
    return FilteredListener;
};
const $e0bd124d99ee3c1b$export$acca048df1683b81 = (children, components)=>{
    let wrappedChildren = /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    for(let i = components.length - 1; i >= 0; i--){
        const { Listener: Listener, onEvent: onEvent } = components[i];
        wrappedChildren = /*#__PURE__*/ (0, $l998X.jsx)(Listener, {
            onEvent: onEvent,
            children: wrappedChildren
        });
    }
    return wrappedChildren;
};
module.exports["createCatchingEventChannel"] = $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e;
module.exports["createEventChannel"] = $e0bd124d99ee3c1b$export$7b182ad6fa711a33;

});

parcelRegister("k6lJw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");

var $inPa6 = parcelRequire("inPa6");

const $39d282bcf5375d57$var$ATLASKIT_CHANNEL = 'atlaskit';
const $39d282bcf5375d57$export$b1e3a2222bb9a86d = (useEventDispatch, channel)=>{
    const RepackageAnalyticsNextEvent = ({ children: children, ...uiProperties })=>{
        const dispatchAnalytics = useEventDispatch();
        const repackageAtlaskitEvent = (0, $42omo.useCallback)((event)=>{
            dispatchAnalytics({
                ...uiProperties,
                ...event.payload,
                attributes: {
                    ...uiProperties.attributes,
                    ...event.payload.attributes
                }
            });
        }, [
            dispatchAnalytics,
            uiProperties
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $kDuN4.default), {
            channel: channel,
            onEvent: repackageAtlaskitEvent,
            children: children
        });
    };
    return RepackageAnalyticsNextEvent;
};
const $39d282bcf5375d57$export$1ec809871e34d2f0 = (// TODO: Technically, we can make the type more specific than just UIAnalyticsPayload
useEventDispatch)=>{
    const RepackageAtlaskitEvent = $39d282bcf5375d57$export$b1e3a2222bb9a86d(useEventDispatch, 'atlaskit');
    return RepackageAtlaskitEvent;
};
const $39d282bcf5375d57$export$ad0c43fbe23d07ab = (Listener, channel = $39d282bcf5375d57$var$ATLASKIT_CHANNEL)=>{
    return ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
        const fireAsAtlaskitEvent = (0, $42omo.useCallback)((payload)=>{
            createAnalyticsEvent(payload).fire(channel);
        }, [
            createAnalyticsEvent
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)(Listener, {
            onEvent: fireAsAtlaskitEvent,
            children: children
        });
    };
};
module.exports["createAtlaskitToEventChannelRepackager"] = $39d282bcf5375d57$export$1ec809871e34d2f0;

});

parcelRegister("1cK19", function(module, exports) {
/**
 * @param url The URL you want to sanitize
 * @returns A URL string without any user generated content (UGC) or PII (personally identifiable information). The URL will not necessarily be valid URL.
 */ const $3031758fc3a9c9bd$export$ceb09b958e605eff = (url)=>{
    // TODO: Should redact anything not from atlassian.com/atlassian.net/bitbucket.org/etc
    return url.replace(/\?.*$/, '');
};
module.exports["sanitizeUrlString"] = $3031758fc3a9c9bd$export$ceb09b958e605eff;

});

parcelRegister("1EMUC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9Bcp3 = parcelRequire("9Bcp3");

const $fb2833db791c8fde$export$8d3ccdf5c3b9600a = ({ children: children, overrides: overrides })=>{
    const [registry] = (0, $42omo.useState)(()=>new Map(overrides));
    (0, $42omo.useEffect)(()=>{
        const callbacks = overrides.map(([subject, target])=>$fb2833db791c8fde$export$87a46fc2314946e0(registry, subject, target));
        return ()=>callbacks.forEach((cb)=>cb());
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    overrides);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9Bcp3.overrideContext).Provider, {
        value: registry,
        children: children
    });
};
const $fb2833db791c8fde$export$edb6244a86733174 = ()=>(0, $42omo.useContext)((0, $9Bcp3.overrideContext));
const $fb2833db791c8fde$export$87a46fc2314946e0 = (registry, subject, override)=>{
    registry.set(subject, override);
    return ()=>{
        registry.delete(subject);
    };
};
const $fb2833db791c8fde$export$9218bfcced62f524 = (registry, subject)=>{
    return registry.get(subject) || subject;
};
const $fb2833db791c8fde$export$cf6f15ae0c6d3b84 = (subject)=>{
    const registry = $fb2833db791c8fde$export$edb6244a86733174();
    return (registry || new Map()).get(subject) || subject;
};
const $fb2833db791c8fde$export$ef191f4a42af511d = (subject, target)=>[
        subject,
        target
    ];
module.exports["useCommerceOverride"] = $fb2833db791c8fde$export$cf6f15ae0c6d3b84;

});

parcelRegister("9Bcp3", function(module, exports) {
// eslint-disable-next-line import/no-extraneous-dependencies

var $42omo = parcelRequire("42omo");

const $0f5923cabface8ba$export$81b0387840a1a60c = (0, $42omo.createContext)(new Map());
module.exports["overrideContext"] = $0f5923cabface8ba$export$81b0387840a1a60c;

});

parcelRegister("lzJ3V", function(module, exports) {
const $8b805f09b2bef0e7$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
module.exports["getRequestUrl"] = $8b805f09b2bef0e7$export$14619c0eed01a470;

});

parcelRegister("4Twfb", function(module, exports) {
// eslint-disable-next-line import/no-extraneous-dependencies

var $42omo = parcelRequire("42omo");

const $b022c09cd7385a9a$export$6de4685a6c88b4e9 = (request, initialState = {
    loading: false,
    data: undefined,
    error: undefined
})=>{
    const [state, setState] = (0, $42omo.useState)(initialState);
    const fetchData = (0, $42omo.useCallback)(async (...requestArgs)=>{
        setState({
            loading: true,
            data: undefined,
            error: undefined
        });
        try {
            const data = await request(...requestArgs);
            setState({
                loading: false,
                data: data,
                error: undefined
            });
            return data;
        } catch (error) {
            // Casting promise error to provided type. I assumes that the person that
            // provides types know that kind of type promise will return on reject.
            setState({
                loading: false,
                data: undefined,
                error: error
            });
            throw error;
        }
    }, [
        request
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...state,
            fetchData: fetchData
        }), [
        state,
        fetchData
    ]);
};
const $b022c09cd7385a9a$export$ff7e5879ade03276 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request, {
        loading: true,
        data: undefined,
        error: undefined
    });
    const { fetchData: fetchData } = service;
    (0, $42omo.useEffect)(()=>{
        // on error promise will be resolved to undefined, error instance available in state
        // eslint-disable-next-line no-console
        fetchData().catch((error)=>console.warn(error));
    }, [
        fetchData
    ]);
    return (0, $42omo.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            refresh: ()=>fetchData()
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$18e513c1248d8ad5 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request, {
        loading: false,
        data: undefined,
        error: undefined
    });
    return (0, $42omo.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            update: fetchData
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$d9765c5cd98039 = (request)=>{
    const service = $b022c09cd7385a9a$export$18e513c1248d8ad5(request);
    return (0, $42omo.useMemo)(()=>{
        const { update: update, ...state } = service;
        return {
            ...state,
            fetch: update
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$7077fee76310bc60 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request);
    return (0, $42omo.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            create: fetchData
        };
    }, [
        service
    ]);
};
module.exports["useFetchService"] = $b022c09cd7385a9a$export$ff7e5879ade03276;
module.exports["useUpdateService"] = $b022c09cd7385a9a$export$18e513c1248d8ad5;

});

parcelRegister("3yFL2", function(module, exports) {
/**
 * For when the code is meant to only ever executed when a bug has ocurred.
 *
 * Note: Choosing a probability-of-bug value should not be speculate/account for specific bugs in the code base
 *
 * Examples:
 * - A top-level try-catch whos only purpose is to prevent your entire application from crashing when random exceptions are thrown
 * - HTTP 500 status code handling logic (assuming 500s only happen when the server has experienced a bug/crash)
 * - Server responses that signal that the JSON payload frontend sent was completely wrong
 * - Part of your app unexpectedly crashes
 * - Any response bodys/HTTP statuses you were not expecting to receive
 */ const $46d5cbdb1ec76aac$export$6af268b89fae390b = 'guaranteed';
const $46d5cbdb1ec76aac$export$dab33e9f81ed2cbf = 'maybe';
const $46d5cbdb1ec76aac$export$c53d0f541b41b88e = 'none';
module.exports["GUARANTEED"] = $46d5cbdb1ec76aac$export$6af268b89fae390b;
module.exports["MAYBE"] = $46d5cbdb1ec76aac$export$dab33e9f81ed2cbf;
module.exports["NONE"] = $46d5cbdb1ec76aac$export$c53d0f541b41b88e;

});

parcelRegister("3SLm1", function(module, exports) {
/**
 * Note: If you add a service here please name after what's mentioned in Microscope.
 * It'll make figuring out who to page (if we need to) easier. See: https://microscope.prod.atl-paas.net/services/commerce-libraries
 *
 * TODO: Probably worth adding some sort of build check to make sure this is enforced
 */ /**
 * It's not enforced, but if you add a service here
 */ /**
 * Generally, you'll want to use this value if you're not 100% sure who can cause the error.
 */ const $a2df338368098843$export$78244dbb77cfa6b6 = 'unknown';
const $a2df338368098843$export$aed27a6561cc0f5c = 'unknown-external';
const $a2df338368098843$export$983d8427a452c1b = 'commerce-libraries';
const $a2df338368098843$export$d5a5208541f78b0 = 'hams';
const $a2df338368098843$export$856303030f6df405 = 'billing-api-gateway';
module.exports["UNKNOWN"] = $a2df338368098843$export$78244dbb77cfa6b6;
module.exports["UNKNOWN_EXTERNAL"] = $a2df338368098843$export$aed27a6561cc0f5c;
module.exports["COMMERCE_LIBRARIES"] = $a2df338368098843$export$983d8427a452c1b;
module.exports["HAMS"] = $a2df338368098843$export$d5a5208541f78b0;
module.exports["BILLING_API_GATEWAY"] = $a2df338368098843$export$856303030f6df405;

});

parcelRegister("cEhot", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3yFL2 = parcelRequire("3yFL2");


var $aNwpq = parcelRequire("aNwpq");


var $in0Xj = parcelRequire("in0Xj");


var $3SLm1 = parcelRequire("3SLm1");


var $jVQXW = parcelRequire("jVQXW");

const $d09c0c9679eec46e$export$9a00dee1beb8f576 = (actionSubject)=>{
    return actionSubject.charAt(0).toUpperCase() + actionSubject.substring(1);
};
const $d09c0c9679eec46e$export$4903c942fa101973 = {
    TASK_FAILURE: 'fe.user.task.failure',
    TASK_SUCCESS: 'fe.user.task.success'
};
const $d09c0c9679eec46e$export$b921bb722afe30af = ({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, histogramBuckets: _histogramBuckets = '4000' })=>{
    const dispatchGasV3Track = (0, $aNwpq.internalGasV3TrackEventChannel).useBreadcrumbedEventDispatch();
    const dispatchSentry = (0, $aNwpq.internalSentryExceptionChannel).useBreadcrumbedEventDispatch();
    const task = actionSubjectId ? `${actionSubjectId}` : `${action}${$d09c0c9679eec46e$export$9a00dee1beb8f576(actionSubject)}`;
    return (0, $42omo.useCallback)((payload)=>{
        const sharedGasV3Payload = {
            ...payload
        };
        const sendSentryEvent = (loggablePayload, eventName, eventTaskId, exceptionTags)=>{
            if (loggablePayload === undefined && [
                (0, $3yFL2.MAYBE),
                (0, $3yFL2.NONE)
            ].includes(exceptionTags.probabilityOfBug)) // Don't bother sending a payload if it's undefined and the probability of bug isn't guaranteed
            // TODO: Should enforce that it's never undefined for ProbabilityOfBug.GUARANTEED
            return;
            dispatchSentry({
                exception: loggablePayload,
                scopeContext: (0, $in0Xj.withTelemetryInfoScopeContext)({
                    tags: {
                        task: task,
                        eventName: eventName,
                        ...exceptionTags,
                        ...eventTaskId !== undefined ? {
                            eventTaskId: eventTaskId
                        } : undefined,
                        ...payload.actionSubjectId !== undefined ? {
                            actionSubjectId: payload.actionSubjectId
                        } : undefined
                    }
                })
            });
        };
        const fail = ({ loggablePayload: loggablePayload, probabilityOfBug: probabilityOfBug = (0, $3yFL2.MAYBE), eventTaskId: baseEventTaskId, responsibleService: responsibleService = (0, $3SLm1.UNKNOWN) } = {})=>{
            const eventTaskId = (()=>{
                if (baseEventTaskId !== undefined) return baseEventTaskId;
                if (probabilityOfBug === (0, $3yFL2.GUARANTEED)) {
                    if ((0, $jVQXW.responsibleServiceIncludesCommerceLibraries)(responsibleService)) return 'guaranteed-bug';
                    return 'external-bug';
                }
                // Not sending any other values in fear of cardinality problems
                return undefined;
            })();
            sendSentryEvent(loggablePayload, $d09c0c9679eec46e$export$4903c942fa101973.TASK_FAILURE, eventTaskId, {
                probabilityOfBug: probabilityOfBug,
                responsibleService: responsibleService
            });
        // TODO: Consider sending some sort of GasV3 failure information
        };
        const succeed = ({ loggablePayload: loggablePayload, eventTaskId: eventTaskId, responsibleService: responsibleService = (0, $3SLm1.UNKNOWN) } = {})=>{
            sendSentryEvent(loggablePayload, $d09c0c9679eec46e$export$4903c942fa101973.TASK_SUCCESS, eventTaskId, {
                probabilityOfBug: (0, $3yFL2.NONE),
                responsibleService: responsibleService
            });
            dispatchGasV3Track(sharedGasV3Payload);
        };
        return {
            fail: fail,
            succeed: succeed
        };
    }, [
        dispatchGasV3Track,
        dispatchSentry,
        task
    ]);
};
const $d09c0c9679eec46e$export$94273a7593441cd3 = (x)=>x.succeed !== undefined;
const $d09c0c9679eec46e$export$8ea5335bded027a0 = (taskInfo)=>{
    const startTask = $d09c0c9679eec46e$export$b921bb722afe30af(taskInfo);
    const taskInfoRef = (0, $42omo.useRef)(taskInfo);
    // TODO: replace by useEvent once it is available. Ponyfilling with useRef for now
    const higherLevelStartTask = (0, $42omo.useCallback)(/**
		 * Please note that thrown errors will be interpreted as guaranteed buggy failures.
		 * @param payload This data passed into this function will be shared between both failure and successful tasks
		 */ async (callback, payload)=>{
        const { fail: fail, succeed: succeed } = startTask(payload || taskInfoRef.current);
        try {
            const result = await callback();
            if (result.succeed !== undefined) succeed(result.succeed);
            else if (result.fail !== undefined) fail(result.fail);
            else fail({
                probabilityOfBug: (0, $3yFL2.GUARANTEED),
                loggablePayload: {
                    result: result,
                    error: new Error('Could not find succeed nor fail')
                }
            });
            return result;
        } catch (err) {
            if (err instanceof TypeError && err.message === 'Failed to fetch') fail({
                probabilityOfBug: (0, $3yFL2.MAYBE),
                loggablePayload: err
            });
            else fail({
                probabilityOfBug: (0, $3yFL2.GUARANTEED),
                loggablePayload: err
            });
            throw err;
        }
    }, [
        startTask
    ]);
    return higherLevelStartTask;
};
module.exports["useTaskTracker"] = $d09c0c9679eec46e$export$8ea5335bded027a0;

});

parcelRegister("in0Xj", function(module, exports) {

var $3yFL2 = parcelRequire("3yFL2");


var $3SLm1 = parcelRequire("3SLm1");


var $jVQXW = parcelRequire("jVQXW");

const $2cec5ac4f8c71665$export$bf5f90a1a9d2de58 = ({ probabilityOfBug: probabilityOfBug, responsibleService: responsibleService })=>{
    switch(probabilityOfBug){
        case 0, $3yFL2.GUARANTEED:
            if ((0, $jVQXW.responsibleServiceIncludesCommerceLibraries)(responsibleService)) return 'fatal';
            return 'error';
        case 0, $3yFL2.MAYBE:
            return 'warning';
        case 0, $3yFL2.NONE:
            return 'log';
        default:
            // Should never happen so sending critical :3
            return 'fatal';
    }
};
const $2cec5ac4f8c71665$var$severityOrdering = new Map([
    [
        'fatal',
        0
    ],
    [
        'fatal',
        1
    ],
    [
        'error',
        2
    ],
    [
        'warning',
        3
    ],
    [
        'info',
        4
    ],
    [
        'log',
        5
    ],
    [
        undefined,
        6
    ]
]);
const $2cec5ac4f8c71665$export$cae73843c52c598b = (severity1, severity2)=>{
    if ($2cec5ac4f8c71665$var$severityOrdering.get(severity1) <= $2cec5ac4f8c71665$var$severityOrdering.get(severity2)) return severity1;
    return severity2;
};
const $2cec5ac4f8c71665$export$c7063fd1387b3458 = (scopeContext)=>{
    const tags = {
        ...scopeContext.tags,
        responsibleService: scopeContext.tags.responsibleService ?? (0, $3SLm1.UNKNOWN)
    };
    return {
        ...scopeContext,
        tags: tags,
        level: $2cec5ac4f8c71665$export$bf5f90a1a9d2de58(tags)
    };
};
module.exports["withTelemetryInfoScopeContext"] = $2cec5ac4f8c71665$export$c7063fd1387b3458;

});

parcelRegister("jVQXW", function(module, exports) {

var $3SLm1 = parcelRequire("3SLm1");

const $d91c14f6a33096f8$export$6d5fcf71bce583e2 = (responsibleService)=>responsibleService === (0, $3SLm1.COMMERCE_LIBRARIES) || responsibleService === (0, $3SLm1.UNKNOWN);
module.exports["responsibleServiceIncludesCommerceLibraries"] = $d91c14f6a33096f8$export$6d5fcf71bce583e2;

});

parcelRegister("1Y5Zp", function(module, exports) {
const $1fb762876766bde5$export$40f07171f4b6ee01 = (result)=>result.exception !== undefined;
const $1fb762876766bde5$export$e6127cc7fe7395c3 = (result)=>result.error !== undefined;
const $1fb762876766bde5$export$a7324067d5b1efd6 = (result)=>result.payload !== undefined;
const $1fb762876766bde5$export$4ece3b219cb1e8e7 = (result)=>result.payload === undefined;
const $1fb762876766bde5$export$d0a8c5cfb02e95fe = (error)=>({
        error: error,
        payload: undefined,
        exception: undefined
    });
const $1fb762876766bde5$export$6338ef6f72008c7 = (payload)=>({
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $1fb762876766bde5$export$89242b2b73a7bdd = (exception)=>{
    return {
        payload: undefined,
        error: undefined,
        exception: exception
    };
};
module.exports["isException"] = $1fb762876766bde5$export$40f07171f4b6ee01;
module.exports["isSuccessful"] = $1fb762876766bde5$export$a7324067d5b1efd6;

});

parcelRegister("bXe73", function(module, exports) {
const $f975479e12996987$export$40f07171f4b6ee01 = (result)=>result.exception !== undefined;
const $f975479e12996987$export$e6127cc7fe7395c3 = (result)=>result.error !== undefined;
const $f975479e12996987$export$a7324067d5b1efd6 = (result)=>result.payload !== undefined;
const $f975479e12996987$export$4ece3b219cb1e8e7 = (result)=>result.payload === undefined;
const $f975479e12996987$export$d0a8c5cfb02e95fe = (error)=>({
        error: error,
        payload: undefined,
        exception: undefined
    });
const $f975479e12996987$export$6338ef6f72008c7 = (payload)=>({
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $f975479e12996987$export$89242b2b73a7bdd = (exception)=>{
    return {
        payload: undefined,
        error: undefined,
        exception: exception
    };
};
module.exports["isException"] = $f975479e12996987$export$40f07171f4b6ee01;
module.exports["isSuccessful"] = $f975479e12996987$export$a7324067d5b1efd6;

});

parcelRegister("lh1MN", function(module, exports) {
const $7f1ee6750f4adf66$export$db45730c9afae012 = (data)=>{
    if (!data) return undefined;
    return data.confluence_tenantContext?.licenseStates?.confluence?.ccpEntitlementId || undefined;
};
module.exports["getCcpEntitlementFromQuery"] = $7f1ee6750f4adf66$export$db45730c9afae012;

});

parcelRegister("gsZdA", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ const $f57489e4f8cda39e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Cloud+plans';
var $f57489e4f8cda39e$export$fd53124e1292f3e0 = /*#__PURE__*/ function(SECTION_MESSAGE_APPEARANCE_TYPES) {
    SECTION_MESSAGE_APPEARANCE_TYPES["DEFAULT"] = "default";
    SECTION_MESSAGE_APPEARANCE_TYPES["FLAT"] = "flat";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE"] = "inline";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE_MODAL"] = "inline-modal";
    return SECTION_MESSAGE_APPEARANCE_TYPES;
}({});
const $f57489e4f8cda39e$export$9d01cd0779f8a694 = 'confluence-up-flow-modal';
module.exports["LEARN_MORE_LINK"] = $f57489e4f8cda39e$export$997e23a0aec74966;
module.exports["SECTION_MESSAGE_APPEARANCE_TYPES"] = $f57489e4f8cda39e$export$fd53124e1292f3e0;
module.exports["UP_FLOW_EP_MESSAGE_ID"] = $f57489e4f8cda39e$export$9d01cd0779f8a694;

});

parcelRegister("fDbEj", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $6mKj3 = parcelRequire("6mKj3");


var $gQY3Y = parcelRequire("gQY3Y");


var $jKFU9 = parcelRequire("jKFU9");

const $3737157ebbad3bf6$var$timeNow = ()=>new Date().getTime();
const $3737157ebbad3bf6$export$66d311bf29d5c89c = new Error('TIMEOUT');
const $3737157ebbad3bf6$export$d63cfb67ca7b2a0 = (currentEdition, writeFragmentInterop)=>{
    if (!currentEdition) return Promise.reject(new Error('No currentEdition supplied'));
    const pollEndTime = new Date($3737157ebbad3bf6$var$timeNow() + (0, $jKFU9.CHANGE_EDITION_POLL_DURATION_MINS) * 60000).getTime();
    const pollAndResolve = (resolve, reject)=>{
        if ($3737157ebbad3bf6$var$timeNow() > pollEndTime) reject($3737157ebbad3bf6$export$66d311bf29d5c89c);
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        (0, $hp2SH.getApolloClient)().query({
            query: (0, $gQY3Y.waitForEditionChangeQuery),
            errorPolicy: 'all',
            fetchPolicy: 'network-only'
        }).then((response)=>{
            const polledEdition = response.data?.tenant?.editions?.confluence;
            if (polledEdition && currentEdition !== polledEdition) {
                // Write the latest edition to cache.
                if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) writeFragmentInterop({
                    fragmentId: '$ROOT_QUERY.confluence_tenantContext',
                    data: {
                        editions: {
                            confluence: polledEdition,
                            __typename: 'ConfluenceEditions'
                        },
                        __typename: 'Tenant'
                    }
                });
                else // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
                (0, $hp2SH.getApolloClient)().writeQuery({
                    query: (0, $gQY3Y.waitForEditionChangeQuery),
                    data: {
                        tenant: {
                            editions: {
                                confluence: polledEdition,
                                __typename: 'ConfluenceEditions'
                            },
                            __typename: 'Tenant'
                        }
                    }
                });
                resolve(polledEdition);
            } else setTimeout(()=>{
                pollAndResolve(resolve, reject);
            }, (0, $jKFU9.CHANGE_EDITION_POLL_INTERVAL_SECS) * 1000);
        }).catch(reject);
    };
    return new Promise((resolve, reject)=>pollAndResolve(resolve, reject));
};
module.exports["TimeoutError"] = $3737157ebbad3bf6$export$66d311bf29d5c89c;
module.exports["waitForEditionChange"] = $3737157ebbad3bf6$export$d63cfb67ca7b2a0;

});

parcelRegister("gQY3Y", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $1047f6c600fde1f6$export$291c2fa2b3781c67 = (0, $eSUdr.default)`query waitForEditionChangeQuery{tenant:confluence_tenantContext{editions{confluence}}}`;
module.exports["waitForEditionChangeQuery"] = $1047f6c600fde1f6$export$291c2fa2b3781c67;

});

parcelRegister("jKFU9", function(module, exports) {
const $97f7046950ca68f7$export$4f9b7eb5b7999045 = 3;
const $97f7046950ca68f7$export$6925031fb600919f = 1;
module.exports["CHANGE_EDITION_POLL_INTERVAL_SECS"] = $97f7046950ca68f7$export$4f9b7eb5b7999045;
module.exports["CHANGE_EDITION_POLL_DURATION_MINS"] = $97f7046950ca68f7$export$6925031fb600919f;

});

parcelRegister("gWF6I", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $JyXl5 = parcelRequire("JyXl5");

function $8122506f239babd4$export$6c22afad970ad5ac({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $irOoi.RelayEnvironmentProvider), {
        environment: (0, $JyXl5.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__),
        children: children
    });
}
const $8122506f239babd4$export$43b1f3e917d65526 = $8122506f239babd4$export$6c22afad970ad5ac;
const $8122506f239babd4$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, $l998X.jsx)($8122506f239babd4$export$6c22afad970ad5ac, {
        children: children
    });
};
function $8122506f239babd4$export$e237a628f59c9f4e() {
    const environment = (0, $irOoi.useRelayEnvironment)();
    return (0, $42omo.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}
module.exports["AtlassianRelayEnvironmentProvider"] = $8122506f239babd4$export$6c22afad970ad5ac;
module.exports["RelayEnvironmentProvider"] = $8122506f239babd4$export$43b1f3e917d65526;
module.exports["ConditionalRelayEnvironmentProvider"] = $8122506f239babd4$export$2f6292af3d34630d;
module.exports["useRelayEnvironmentProvider"] = $8122506f239babd4$export$e237a628f59c9f4e;

});

parcelRegister("JyXl5", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");


var $dh538 = parcelRequire("dh538");


var $3tMMZ = parcelRequire("3tMMZ");


var $hvWxm = parcelRequire("hvWxm");


var $59hua = parcelRequire("59hua");


var $kzjMJ = parcelRequire("kzjMJ");


var $7gNIX = parcelRequire("7gNIX");

const $e443eef90c98bdab$var$getLoggingAndMetricsHelper = ()=>{
    return {
        logNonBreakingErrors: ()=>{},
        logError: ()=>{},
        logErrorRetry: ()=>{},
        logQueryFallbackToPost: ()=>{}
    };
};
const $e443eef90c98bdab$export$df54517d175e6d6b = new (0, $3e6Uc.Environment)((0, $3tMMZ.getDefaultRelayEnvironmentConfig)({
    network: (0, $3e6Uc.Network).create((request, variables, cacheConfig)=>{
        return (0, $59hua.fetch)(request, variables, cacheConfig, {
            getLoggingAndMetricsHelper: $e443eef90c98bdab$var$getLoggingAndMetricsHelper,
            withErrorHandling: (source)=>source,
            validateResponse: (request, response)=>{
                const errors = 'errors' in response ? response.errors : undefined;
                if (errors != null) {
                    const requestId = response?.extensions?.gateway?.request_id;
                    (0, $hvWxm.captureErrors)(errors, {
                        operationName: request.name,
                        requestId: requestId
                    });
                    if ((0, $dh538.fg)('platform_relay_redirect_on_step_up_auth_studio')) {
                        const { hasStepUpAuthError: hasStepUpAuthError, stepUpUrl: stepUpUrl } = (0, $hvWxm.isStepUpAuthError)(errors);
                        if (hasStepUpAuthError && stepUpUrl) window.location.href = stepUpUrl;
                    }
                }
                return true;
            },
            onInvalidResponse: ()=>{},
            queryResponseCache: new (0, $kzjMJ.SSRQueryResponseCache)({
                cacheName: 'relay-cache/v2/AGG',
                size: Infinity,
                ttl: Infinity
            }),
            isServer: globalThis.__SERVER__
        });
    }, (0, $7gNIX.subscribe))
}));
module.exports["__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__"] = $e443eef90c98bdab$export$df54517d175e6d6b;

});

parcelRegister("kzjMJ", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");

function $55e864d84c99338e$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $3e6Uc.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $55e864d84c99338e$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $55e864d84c99338e$export$be21c283b097d175 extends (0, $3e6Uc.QueryResponseCache) {
    /**
   * @deprecated only sets a single response; does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
   * Stores a GraphQLRepsonse along with metadata about the call.
   * If called multiple times (such as when incremental payloads are received),
   * will update the stored response to be an array of GraphQLSingularResponse objects,
   * which Relay is happy to handle.
   * @deprecated works, but does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
   * Deletes a request from the store, if found.
   *
   * IMPORTANT: Make sure DELETE method always has tests that include get/set
   * to ensure our `getCacheKey` matches Relay's.
   *
   * @returns {boolean} indicating if an entry in the cache was deleted
   */ delete(queryID, variables) {
        const cacheKey = $55e864d84c99338e$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
    constructor({ cacheName: cacheName, size: size, ttl: ttl, timeoutCallback: timeoutCallback }){
        super({
            size: size,
            ttl: ttl
        });
        this.cacheName = void 0;
        this.requestMetadata = void 0;
        const isServer = typeof window === 'undefined';
        const cachedData = isServer ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(()=>{
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback?.(this._responses, this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
}
module.exports["SSRQueryResponseCache"] = $55e864d84c99338e$export$be21c283b097d175;

});

parcelRegister("bRPo1", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e569016d63746a22$var$baseStyles = null;
const $e569016d63746a22$var$justifyStartStyles = null;
const $e569016d63746a22$var$justifyEndStyles = null; /**
                                * __Tag group__
                                *
                                * A tag group controls the layout and alignment for a collection of tags.
                                *
                                * - [Examples](https://atlassian.design/components/tag-group/examples)
                                * - [Code](https://atlassian.design/components/tag-group/code)
                                * - [Usage](https://atlassian.design/components/tag-group/usage)
                                */ 
const $e569016d63746a22$var$TagGroup = /*#__PURE__*/ (0, $42omo.forwardRef)(({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bsb1osq _1n261g80",
            alignment === 'start' && "_1bah1y6m",
            alignment === 'end' && "_1bahesu3"
        ]),
        children: children
    });
});
var $e569016d63746a22$export$2e2bcd8739ae039 = $e569016d63746a22$var$TagGroup;
module.exports["default"] = $e569016d63746a22$export$2e2bcd8739ae039;

});

parcelRegister("kSKAi", function(module, exports) {
/* UserPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $1DWH0 = parcelRequire("1DWH0");


var $bS1VQ = parcelRequire("bS1VQ");

var $2gD2K = parcelRequire("2gD2K");


var $28cxD = parcelRequire("28cxD");


var $42omo = parcelRequire("42omo");


var $89I2S = parcelRequire("89I2S");


var $lugM7 = parcelRequire("lugM7");


var $e1cJ5 = parcelRequire("e1cJ5");


var $dTofT = parcelRequire("dTofT");


var $bYlb2 = parcelRequire("bYlb2");


var $39zOH = parcelRequire("39zOH");


var $aahZc = parcelRequire("aahZc");


var $8hAFq = parcelRequire("8hAFq");


var $dQl1W = parcelRequire("dQl1W");


var $dh538 = parcelRequire("dh538");

function $f70d9dc6cc3ace22$var$_defineProperty(e, r, t) {
    return (r = $f70d9dc6cc3ace22$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f70d9dc6cc3ace22$var$_toPropertyKey(t) {
    var i = $f70d9dc6cc3ace22$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f70d9dc6cc3ace22$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $f70d9dc6cc3ace22$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        const experienceForId = (0, $8hAFq.userPickerRenderedUfoExperience).getInstance(this.ufoId); // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $28cxD.UFOExperienceState).IN_PROGRESS.id,
            (0, $28cxD.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, menuIsOpen: menuIsOpen, required: required = false, showClearIndicator: showClearIndicator = false, includeTeamsUpdates: includeTeamsUpdates = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $bS1VQ.default) : (0, $2gD2K.default);
        const creatableProps = suggestEmailsForDomain ? (0, $bYlb2.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $dTofT.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required,
            includeTeamsUpdates: includeTeamsUpdates,
            menuIsOpen: menuIsOpen
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $8hAFq.UfoErrorBoundary), {
            id: this.ufoId,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $39zOH.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aahZc.ExusUserSourceProvider), {
                    fetchUserSource: loadUserSource,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $89I2S.BaseUserPickerWithoutAnalytics), {
                        ...this.props,
                        forwardedRef: this.props.forwardedRef,
                        width: width,
                        SelectComponent: SelectComponent,
                        styles: (0, $lugM7.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, (0, $dh538.fg)('platform-component-visual-refresh'), false, (0, $dh538.fg)('jifjam_bulk_operations') ? this.props.height : undefined),
                        components: (0, $e1cJ5.getComponents)(isMulti, anchor, showClearIndicator, this.props?.components ? this.props.components : {}),
                        pickerProps: pickerProps
                    })
                })
            })
        });
    }
    constructor(props){
        super(props); // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        $f70d9dc6cc3ace22$var$_defineProperty(this, "ufoId", void 0);
        this.ufoId = (0, $dQl1W.v4)();
        const experienceForId = (0, $8hAFq.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $28cxD.UFOExperienceState).IN_PROGRESS.id,
            (0, $28cxD.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
}
$f70d9dc6cc3ace22$var$_defineProperty($f70d9dc6cc3ace22$export$164f4d95e5d7e2f5, "defaultProps", {
    width: 350,
    isMulti: false
});
const $f70d9dc6cc3ace22$export$83e0c73b09b3a9cd = (0, $1DWH0.default)()($f70d9dc6cc3ace22$export$164f4d95e5d7e2f5);
module.exports["UserPicker"] = $f70d9dc6cc3ace22$export$83e0c73b09b3a9cd;

});

parcelRegister("89I2S", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $1DWH0 = parcelRequire("1DWH0");


var $28cxD = parcelRequire("28cxD");


var $jSnXV = parcelRequire("jSnXV");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $dQl1W = parcelRequire("dQl1W");


var $dlhVH = parcelRequire("dlhVH");


var $chpH1 = parcelRequire("chpH1");


var $3aPpx = parcelRequire("3aPpx");


var $6O3OC = parcelRequire("6O3OC");


var $8UAzT = parcelRequire("8UAzT");


var $8hAFq = parcelRequire("8hAFq");


var $dh538 = parcelRequire("dh538");

const $c504d7760af5313e$var$loadingMessage = ()=>null;
const $c504d7760af5313e$var$classNamePrefix = 'fabric-user-picker';
class $c504d7760af5313e$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $6O3OC.optionToSelectableOptions)(nextProps.value);
        else if ((0, $6O3OC.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $6O3OC.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    get isCreateTeamA11yEnabled() {
        return (0, $dh538.fg)('a11y-create-team-is-not-focusable-and-has-no-btn');
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Close menu when isFooterFocused changes from true to false
        if (this.isCreateTeamA11yEnabled && menuIsOpen && prevProps.isFooterFocused === true && this.props.isFooterFocused === false && !this.shouldKeepMenuOpen()) {
            this.resetInputState();
            (0, $6O3OC.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $dlhVH.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $dlhVH.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!prevProps.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $28cxD.UFOExperienceState).STARTED.id,
            (0, $28cxD.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        const { 'aria-labelledby': ariaLabelledByStandard, 'aria-describedby': ariaDescribedByStandard, ...restAriaProps } = this.ariaProps;
        return /*#__PURE__*/ (0, $l998X.jsx)(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            labelId: ariaLabelledBy ?? ariaLabelledByStandard,
            descriptionId: ariaDescribedBy ?? ariaDescribedByStandard,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $c504d7760af5313e$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).placeholder
            }),
            label: ariaLabel,
            addMoreMessage: addMoreMessage,
            classNamePrefix: $c504d7760af5313e$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...restAriaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
    constructor(props){
        super(props);
        this.selectRef = void 0;
        this.session = void 0;
        // session id for focus to blur
        this.journeyId = void 0;
        this.optionsShownUfoExperienceInstance = void 0;
        this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined;
        this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            };
        this.nextOption = this.withSelectRef((select)=>select.focusOption('down'));
        this.previousOption = this.withSelectRef((select)=>select.focusOption('up'));
        this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        };
        this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        };
        this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        });
        // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $6O3OC.callCallback)(onChange, (0, $6O3OC.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $6O3OC.callCallback)(onSelection, (0, $6O3OC.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $dlhVH.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $dlhVH.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $6O3OC.callCallback)(onClear);
                    this.fireEvent((0, $dlhVH.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $dlhVH.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $dlhVH.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        };
        this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        this.addOptions = (0, $chpH1.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        });
        this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $dlhVH.failedEvent));
        };
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $6O3OC.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200);
        this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $28cxD.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        };
        this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        };
        this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        };
        this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $6O3OC.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $6O3OC.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        };
        this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $6O3OC.callCallback)(this.props.onInputChange, '', this.getSessionId());
        };
        this.handleOpen = ()=>{
            (0, $6O3OC.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        };
        this.handleBlur = ()=>{
            if (this.isCreateTeamA11yEnabled && this.props.isFooterFocused) return;
            (0, $6O3OC.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $6O3OC.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        };
        this.handleClose = ()=>{
            if (this.isCreateTeamA11yEnabled && this.props.isFooterFocused) return;
            this.resetInputState();
            (0, $6O3OC.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        };
        this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $6O3OC.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        };
        this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $dlhVH.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        };
        this.startSession = ()=>{
            this.session = (0, $dlhVH.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $dlhVH.focusEvent));
        };
        this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
            if (this.isCreateTeamA11yEnabled) {
                if (event.key === 'Escape') {
                    this.setState({
                        menuIsOpen: false,
                        options: []
                    });
                    this.props.setIsFooterFocused && this.props.setIsFooterFocused(false);
                }
                if (event.key === 'Tab' && this.props.setIsFooterFocused && this.props.footer) this.props.setIsFooterFocused(true);
            }
        };
        this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        };
        this.getOptions = ()=>{
            const options = (0, $6O3OC.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder ? (0, $8UAzT.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder ? (0, $8UAzT.groupOptionsByType)(options, groupByTypeOrder) : options;
        };
        this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal';
        this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.shouldKeepMenuOpen = ()=>Boolean(!!this.props.footer) && Boolean(this.props.isFooterFocused);
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        (0, $8hAFq.userPickerOptionsShownUfoExperience).getInstance((0, $dQl1W.v4)());
        if (this.props.forwardedRef) {
            const refValue = {
                focus: this.focus,
                blur: this.blur
            };
            if (typeof this.props.forwardedRef === 'function') this.props.forwardedRef(refValue);
            else this.props.forwardedRef.current = refValue;
        }
    }
}
$c504d7760af5313e$export$b4ff48c8d43b18c3.defaultProps = {
    isMulti: false,
    subtle: false,
    noBorder: false,
    textFieldBackgroundColor: false,
    isClearable: true,
    loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $3aPpx.messages).errorMessage
        }),
    openMenuOnClick: false
};
const $c504d7760af5313e$export$d099ade7b4f4d2a4 = (0, $1DWH0.default)()($c504d7760af5313e$export$b4ff48c8d43b18c3);
module.exports["BaseUserPickerWithoutAnalytics"] = $c504d7760af5313e$export$b4ff48c8d43b18c3;

});

parcelRegister("dlhVH", function(module, exports) {

var $eWRwJ = parcelRequire("eWRwJ");


var $dQl1W = parcelRequire("dQl1W");


var $6O3OC = parcelRequire("6O3OC");

const $02b4d9c4beeba836$var$packageName = "platform-pkg";
const $02b4d9c4beeba836$var$packageVersion = "0.0.0-use.local";
const $02b4d9c4beeba836$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $02b4d9c4beeba836$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $02b4d9c4beeba836$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $02b4d9c4beeba836$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $dQl1W.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $02b4d9c4beeba836$export$53eef0dcd9611650 = (0, $eWRwJ.default)('fabric-elements');
const $02b4d9c4beeba836$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $02b4d9c4beeba836$var$packageName,
            packageVersion: $02b4d9c4beeba836$var$packageVersion,
            ...attributes
        }
    });
const $02b4d9c4beeba836$var$checkValidId = (id)=>{
    return $02b4d9c4beeba836$var$UUID_REGEXP_NEW_AAID.test(id) || $02b4d9c4beeba836$var$UUID_REGEXP_OLD_AAID.test(id) || $02b4d9c4beeba836$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $02b4d9c4beeba836$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $02b4d9c4beeba836$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $6O3OC.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $6O3OC.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $02b4d9c4beeba836$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$02b4d9c4beeba836$var$optionData2Analytics(data));
    }
    return [];
};
const $02b4d9c4beeba836$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $02b4d9c4beeba836$var$sessionId(session),
        pickerType: $02b4d9c4beeba836$var$pickerType(props),
        journeyId: journeyId
    });
const $02b4d9c4beeba836$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$02b4d9c4beeba836$var$createEvent('ui', 'focused', 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $02b4d9c4beeba836$var$buildValueForAnalytics(state.value)
    });
const $02b4d9c4beeba836$export$7b5800e732182efb = (props, state, session, journeyId)=>$02b4d9c4beeba836$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $02b4d9c4beeba836$var$values(state)
    });
const $02b4d9c4beeba836$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$02b4d9c4beeba836$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $02b4d9c4beeba836$var$sessionId(session),
        journeyId: journeyId,
        value: $02b4d9c4beeba836$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $02b4d9c4beeba836$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$02b4d9c4beeba836$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $02b4d9c4beeba836$var$sessionDuration(session),
        queryLength: $02b4d9c4beeba836$var$queryLength(args[0]),
        spaceInQuery: $02b4d9c4beeba836$var$spaceInQuery(args[0]),
        upKeyCount: $02b4d9c4beeba836$var$upKeyCount(session),
        downKeyCount: $02b4d9c4beeba836$var$downKeyCount(session)
    });
const $02b4d9c4beeba836$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $02b4d9c4beeba836$var$createEvent('ui', $02b4d9c4beeba836$var$selectEventType(session), 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $02b4d9c4beeba836$var$sessionDuration(session),
        position: $02b4d9c4beeba836$var$position(state, args[0]),
        queryLength: $02b4d9c4beeba836$var$queryLength(state),
        spaceInQuery: $02b4d9c4beeba836$var$spaceInQuery(state),
        upKeyCount: $02b4d9c4beeba836$var$upKeyCount(session),
        downKeyCount: $02b4d9c4beeba836$var$downKeyCount(session),
        result: $02b4d9c4beeba836$var$result(args[0]),
        numberOfResults: $02b4d9c4beeba836$var$numberOfResults(state)
    });
};
const $02b4d9c4beeba836$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $02b4d9c4beeba836$var$results(state);
    return $02b4d9c4beeba836$var$createEvent('operational', 'searched', 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $02b4d9c4beeba836$var$sessionDuration(session),
        durationSinceInputChange: $02b4d9c4beeba836$var$durationSinceInputChange(session),
        queryLength: $02b4d9c4beeba836$var$queryLength(state),
        isLoading: $02b4d9c4beeba836$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $02b4d9c4beeba836$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$02b4d9c4beeba836$var$createEvent('operational', 'failed', 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $02b4d9c4beeba836$export$f541f04954b0c11e = (sources, accountId)=>$02b4d9c4beeba836$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $02b4d9c4beeba836$var$checkValidId(accountId) ? accountId : null
    });
function $02b4d9c4beeba836$var$queryLength(state) {
    return state.inputValue.length;
}
function $02b4d9c4beeba836$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $02b4d9c4beeba836$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $02b4d9c4beeba836$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $02b4d9c4beeba836$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $02b4d9c4beeba836$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $02b4d9c4beeba836$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $02b4d9c4beeba836$var$sessionId(session) {
    return session && session.id;
}
function $02b4d9c4beeba836$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $02b4d9c4beeba836$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $02b4d9c4beeba836$var$result(option) {
    return option ? $02b4d9c4beeba836$var$optionData2Analytics(option.data) : null;
}
function $02b4d9c4beeba836$var$results(state) {
    return (state.options || []).map($02b4d9c4beeba836$var$optionData2Analytics);
}
function $02b4d9c4beeba836$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $02b4d9c4beeba836$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$02b4d9c4beeba836$var$optionData2Analytics(option.data)) : [
        $02b4d9c4beeba836$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $02b4d9c4beeba836$var$numberOfResults(state) {
    return (state.options || []).length;
}
module.exports["startSession"] = $02b4d9c4beeba836$export$c0d84948cecf78d8;
module.exports["createAndFireEventInElementsChannel"] = $02b4d9c4beeba836$export$53eef0dcd9611650;
module.exports["focusEvent"] = $02b4d9c4beeba836$export$e7818c470f37c4bd;
module.exports["clearEvent"] = $02b4d9c4beeba836$export$7b5800e732182efb;
module.exports["deleteEvent"] = $02b4d9c4beeba836$export$95711ec6c6227e9a;
module.exports["cancelEvent"] = $02b4d9c4beeba836$export$e9caaaecfee38128;
module.exports["selectEvent"] = $02b4d9c4beeba836$export$48143d759475d90f;
module.exports["searchedEvent"] = $02b4d9c4beeba836$export$911fb7184b6037eb;
module.exports["failedEvent"] = $02b4d9c4beeba836$export$c2aec355fef65c9c;
module.exports["userInfoEvent"] = $02b4d9c4beeba836$export$f541f04954b0c11e;

});

parcelRegister("6O3OC", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $RMvle = parcelRequire("RMvle");


var $cuAuQ = parcelRequire("cuAuQ");

const $e3824e6fb8890c7f$export$f6058dbcb5980cb = (option)=>option.type === (0, $RMvle.ExternalUserType) || Boolean(option.isExternal);
const $e3824e6fb8890c7f$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $RMvle.UserType);
const $e3824e6fb8890c7f$export$f8c4277cb588611f = (option)=>option.type === (0, $RMvle.TeamType);
const $e3824e6fb8890c7f$export$d7976824e9f55785 = (option)=>option.type === (0, $RMvle.GroupType);
const $e3824e6fb8890c7f$export$7fbbfbca30081d0 = (option)=>option.type === (0, $RMvle.EmailType);
const $e3824e6fb8890c7f$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $RMvle.CustomType);
const $e3824e6fb8890c7f$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $e3824e6fb8890c7f$var$isOptionData = (option)=>option.name !== undefined;
const $e3824e6fb8890c7f$export$3f993c492bd6c728 = (option)=>{
    if ($e3824e6fb8890c7f$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $e3824e6fb8890c7f$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $e3824e6fb8890c7f$export$9652023d9040757 = (a)=>typeof a?.[Symbol.iterator] === 'function';
const $e3824e6fb8890c7f$export$d2312e68e1f5ad00 = (0, $2XqLN.default)((options)=>options.map($e3824e6fb8890c7f$export$3f993c492bd6c728));
const $e3824e6fb8890c7f$export$e6fda14a194bcbcc = (0, $2XqLN.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($e3824e6fb8890c7f$export$3f993c492bd6c728);
    return $e3824e6fb8890c7f$export$3f993c492bd6c728(defaultValue);
});
const $e3824e6fb8890c7f$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $e3824e6fb8890c7f$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $e3824e6fb8890c7f$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $e3824e6fb8890c7f$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $e3824e6fb8890c7f$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
    return undefined;
};
const $e3824e6fb8890c7f$export$b4f8f1f54acec99b = (optionData)=>{
    if ($e3824e6fb8890c7f$export$2e44165f1da65304(optionData) || $e3824e6fb8890c7f$export$f8c4277cb588611f(optionData) || $e3824e6fb8890c7f$export$d3a8f0b77e9737fc(optionData) || $e3824e6fb8890c7f$export$f6058dbcb5980cb(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $e3824e6fb8890c7f$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $cuAuQ.default);
const $e3824e6fb8890c7f$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $e3824e6fb8890c7f$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};
module.exports["isExternalUser"] = $e3824e6fb8890c7f$export$f6058dbcb5980cb;
module.exports["isUser"] = $e3824e6fb8890c7f$export$2e44165f1da65304;
module.exports["isTeam"] = $e3824e6fb8890c7f$export$f8c4277cb588611f;
module.exports["isGroup"] = $e3824e6fb8890c7f$export$d7976824e9f55785;
module.exports["isEmail"] = $e3824e6fb8890c7f$export$7fbbfbca30081d0;
module.exports["isCustom"] = $e3824e6fb8890c7f$export$d3a8f0b77e9737fc;
module.exports["isDefaultValuePopulated"] = $e3824e6fb8890c7f$export$d6978985a41b0c8;
module.exports["extractOptionValue"] = $e3824e6fb8890c7f$export$7ae97131df521bff;
module.exports["isIterable"] = $e3824e6fb8890c7f$export$9652023d9040757;
module.exports["getOptions"] = $e3824e6fb8890c7f$export$d2312e68e1f5ad00;
module.exports["optionToSelectableOptions"] = $e3824e6fb8890c7f$export$e6fda14a194bcbcc;
module.exports["getAvatarSize"] = $e3824e6fb8890c7f$export$695fb564e621339a;
module.exports["isChildInput"] = $e3824e6fb8890c7f$export$3c62cf9a01367f27;
module.exports["isSingleValue"] = $e3824e6fb8890c7f$export$203c2bd2662d1ca2;
module.exports["hasValue"] = $e3824e6fb8890c7f$export$96bdbc84526f3739;
module.exports["callCallback"] = $e3824e6fb8890c7f$export$df325aa844b03c31;
module.exports["getAvatarUrl"] = $e3824e6fb8890c7f$export$b4f8f1f54acec99b;
module.exports["isPopupUserPickerByComponent"] = $e3824e6fb8890c7f$export$4f60a74234178416;
module.exports["isLozengeText"] = $e3824e6fb8890c7f$export$5419897287f5f1c7;

});

parcelRegister("chpH1", function(module, exports) {
function $f35c9d88e8abf7dd$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}
module.exports["batchByKey"] = $f35c9d88e8abf7dd$export$da86c38211c1c0a8;

});

parcelRegister("3aPpx", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $4f3ddb26b3e05986$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    placeholder: {
        id: "fabric.elements.user-picker.placeholder",
        defaultMessage: "Enter people or teams..."
    },
    addMore: {
        id: "fabric.elements.user-picker.placeholder.add-more",
        defaultMessage: "add more people..."
    },
    remove: {
        id: "fabric.elements.user-picker.multi.remove-item",
        defaultMessage: "Remove"
    },
    clear: {
        id: "fabric.elements.user-picker.single.clear",
        defaultMessage: "Clear"
    },
    errorMessage: {
        id: "fabric.elements.user-picker.error.message",
        defaultMessage: "Something went wrong"
    },
    teamByline: {
        id: "fabric.elements.user-picker.team.byline",
        defaultMessage: "Team"
    },
    officialTeamByline: {
        id: "fabric.elements.user-picker.team.byline.official",
        defaultMessage: "Official team {verifiedIcon}"
    },
    officialMemberCountWithoutYou: {
        id: "fabric.elements.user-picker.team.member.count.official",
        defaultMessage: "Official team {verifiedIcon} \u2022 {count} {count, plural, one {member} other {members}}"
    },
    officialMemberCountWithYou: {
        id: "fabric.elements.user-picker.team.member.count.official.including.you",
        defaultMessage: "Official team {verifiedIcon} \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.user-picker.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.user-picker.team.member.count.including.you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    officialPlus50MembersWithoutYou: {
        id: "fabric.elements.user-picker.team.member.50plus.official",
        defaultMessage: "Official team {verifiedIcon} \u2022 50+ members"
    },
    officialPlus50MembersWithYou: {
        id: "fabric.elements.user-picker.team.member.50plus.official.including.you",
        defaultMessage: "Official team {verifiedIcon} \u2022 50+ members, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.user-picker.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.user-picker.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    addEmail: {
        id: "fabric.elements.user-picker.email.add",
        defaultMessage: "Add user"
    },
    selectToAddEmail: {
        id: "fabric.elements.user-picker.email.select.to.add",
        defaultMessage: "Select an email address"
    },
    continueToAddEmail: {
        id: "fabric.elements.user-picker.email.add.potential",
        defaultMessage: "Enter an email address"
    },
    adminManagedGroupByline: {
        id: "fabric.elements.user-picker.group.byline.admin-managed",
        defaultMessage: "Admin group {verifiedIcon}"
    },
    groupByline: {
        id: "fabric.elements.user-picker.group.byline",
        defaultMessage: "Admin-managed group"
    },
    externalUserSourcesHeading: {
        id: "fabric.elements.user-picker.external.sourced.from",
        defaultMessage: "Found in:"
    },
    externalUserSourcesError: {
        id: "fabric.elements.user-picker.external.sourced.error",
        defaultMessage: "We can't connect you right now."
    },
    slackProvider: {
        id: "fabric.elements.user-picker.slack.provider",
        defaultMessage: "Slack"
    },
    googleProvider: {
        id: "fabric.elements.user-picker.google.provider",
        defaultMessage: "Google"
    },
    microsoftProvider: {
        id: "fabric.elements.user-picker.microsoft.provider",
        defaultMessage: "Microsoft"
    },
    gitHubProvider: {
        id: "fabric.elements.user-picker.github.provider",
        defaultMessage: "GitHub"
    },
    jiraSource: {
        id: "fabric.elements.user-picker.source.jira",
        defaultMessage: "Jira"
    },
    confluenceSource: {
        id: "fabric.elements.user-picker.source.confluence",
        defaultMessage: "Confluence"
    },
    otherAtlassianSource: {
        id: "fabric.elements.user-picker.source.other-atlassian",
        defaultMessage: "Other Atlassian products"
    },
    otherAtlassianSourceAppify: {
        id: "fabric.elements.user-picker.source.other-atlassian-appify",
        defaultMessage: "Other Atlassian apps"
    },
    memberLozengeText: {
        id: "fabric.elements.user-picker.member.lozenge.text",
        defaultMessage: "MEMBER"
    },
    guestLozengeText: {
        id: "fabric.elements.user-picker.guest.lozenge.text",
        defaultMessage: "GUEST"
    },
    guestUserLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.user",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    },
    guestGroupLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.group",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    },
    userTypeLabel: {
        id: "fabric.elements.user-picker.user.type.label",
        defaultMessage: "People"
    },
    teamTypeLabel: {
        id: "fabric.elements.user-picker.team.type.label",
        defaultMessage: "Teams"
    },
    emailTypeLabel: {
        id: "fabric.elements.user-picker.email.type.label",
        defaultMessage: "Emails"
    },
    groupTypeLabel: {
        id: "fabric.elements.user-picker.group.type.label",
        defaultMessage: "Groups"
    },
    externalUserTypeLabel: {
        id: "fabric.elements.user-picker.external.user.type.label",
        defaultMessage: "External Users"
    },
    customTypeLabel: {
        id: "fabric.elements.user-picker.custom.type.label",
        defaultMessage: "Customs"
    },
    otherTypeLabel: {
        id: "fabric.elements.user-picker.other.type.label",
        defaultMessage: "Others"
    }
});
module.exports["messages"] = $4f3ddb26b3e05986$export$defe85febe8b728c;

});

parcelRegister("8UAzT", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $2XqLN = parcelRequire("2XqLN");


var $3aPpx = parcelRequire("3aPpx");

const $ca249474c88b0d42$var$getLabelForType = (type)=>{
    switch(type){
        case 'user':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).userTypeLabel
            });
        case 'team':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).teamTypeLabel
            });
        case 'group':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).groupTypeLabel
            });
        case 'custom':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).customTypeLabel
            });
        case 'external_user':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).externalUserTypeLabel
            });
        default:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).otherTypeLabel
            });
    }
};
const $ca249474c88b0d42$export$393a985f7dd07cfe = (0, $2XqLN.default)((options, groupByTypeOrder)=>{
    // If groupByTypeOrder is empty, just return the original options
    if (groupByTypeOrder.length === 0) return options;
    const groupedMap = new Map();
    options.forEach((option)=>{
        const type = option.data.type || 'other';
        if (!groupedMap.has(type)) groupedMap.set(type, []);
        groupedMap.get(type).push(option);
    });
    const result = [];
    // add groups in the specified order
    // type is not in groupByTypeOrder, don't add it to the result
    groupByTypeOrder.forEach((type)=>{
        if (groupedMap.has(type)) {
            result.push({
                label: $ca249474c88b0d42$var$getLabelForType(type),
                options: groupedMap.get(type)
            });
            groupedMap.delete(type);
        }
    });
    return result;
});
module.exports["groupOptionsByType"] = $ca249474c88b0d42$export$393a985f7dd07cfe;

});

parcelRegister("8hAFq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

var $28cxD = parcelRequire("28cxD");

const $6d031c0252e61ff0$export$b49757166e1acfc2 = new (0, $9801n.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
});
const $6d031c0252e61ff0$export$135a264e0da507ae = new (0, $9801n.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $iqaft.ExperienceTypes).Operation,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
});
class $6d031c0252e61ff0$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch() {
        const instance = $6d031c0252e61ff0$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $28cxD.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["userPickerRenderedUfoExperience"] = $6d031c0252e61ff0$export$b49757166e1acfc2;
module.exports["userPickerOptionsShownUfoExperience"] = $6d031c0252e61ff0$export$135a264e0da507ae;
module.exports["UfoErrorBoundary"] = $6d031c0252e61ff0$export$5ef1c2550074a375;

});

parcelRegister("lugM7", function(module, exports) {

var $6fnsQ = parcelRequire("6fnsQ");


var $2XqLN = parcelRequire("2XqLN");


var $eKXGE = parcelRequire("eKXGE");


var $dh538 = parcelRequire("dh538");

const $4ce04523015976a9$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $4ce04523015976a9$export$53937c04f7dfc2ae = 6;
const $4ce04523015976a9$export$2c62ba763e976c54 = 39;
const $4ce04523015976a9$export$ffd58b7f6f099a57 = (0, $2XqLN.default)((width, isMulti, isCompact, overrideStyles, isVisualRefresh, isPopupStyles, height)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.isInvalid ? `var(--ds-border-danger, ${0, $6fnsQ.R400})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $6fnsQ.N90})`,
                backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $6fnsQ.N10})` : `var(--ds-background-input, ${0, $6fnsQ.N20})`,
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $6fnsQ.B100})` : state.isInvalid ? `var(--ds-border-danger, ${0, $6fnsQ.R400})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $6fnsQ.N90})`,
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $6fnsQ.R50})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $6fnsQ.N0})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $6fnsQ.N10})` : `var(--ds-background-input-hovered, ${0, $6fnsQ.N30})`
                },
                padding: 0,
                minHeight: height && (0, $dh538.fg)('jifjam_bulk_operations') || isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: height && (0, $dh538.fg)('jifjam_bulk_operations') ? height : isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: `var(--ds-icon-danger, ${0, $6fnsQ.R400})`
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $4ce04523015976a9$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $4ce04523015976a9$export$59c188914e58c94b,
                paddingLeft: isMulti ? $4ce04523015976a9$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$4ce04523015976a9$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $4ce04523015976a9$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $4ce04523015976a9$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: `var(--ds-text-subtlest, ${0, $6fnsQ.N100})`,
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: `var(--ds-text-subtlest, ${0, $6fnsQ.N100})`
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $eKXGE.mergeStyles)(styles, overrideStyles) : styles;
});
const $4ce04523015976a9$export$4e983f376ad8a3af = (0, $2XqLN.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$4ce04523015976a9$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, isVisualRefresh, true)
    }));
module.exports["getStyles"] = $4ce04523015976a9$export$ffd58b7f6f099a57;

});

parcelRegister("e1cJ5", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $8BxoE = parcelRequire("8BxoE");


var $8Z5lp = parcelRequire("8Z5lp");


var $djtLL = parcelRequire("djtLL");


var $d1LXW = parcelRequire("d1LXW");


var $biJXh = parcelRequire("biJXh");


var $gtKKr = parcelRequire("gtKKr");


var $95uM8 = parcelRequire("95uM8");


var $aoWT3 = parcelRequire("aoWT3");


var $91jwt = parcelRequire("91jwt");


var $8lAE4 = parcelRequire("8lAE4");


var $8LA5n = parcelRequire("8LA5n");

const $55820c8d7312f5f6$export$4e811121b221213b = (0, $2XqLN.default)((multi, anchor, showClearIndicator, customComponents)=>{
    if (anchor) return {
        Control: anchor,
        Option: $d1LXW.Option
    };
    else return {
        MultiValue: $8Z5lp.MultiValue,
        DropdownIndicator: null,
        SingleValue: $biJXh.SingleValue,
        ClearIndicator: showClearIndicator || !multi ? (0, $8BxoE.ClearIndicator) : null,
        Option: $d1LXW.Option,
        ValueContainer: multi ? (0, $djtLL.MultiValueContainer) : (0, $95uM8.SingleValueContainer),
        Input: $gtKKr.Input,
        Menu: $8lAE4.Menu,
        Control: $8LA5n.default,
        ...customComponents ? customComponents : {}
    };
});
const $55820c8d7312f5f6$export$19205fd341a6bb08 = (0, $2XqLN.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $biJXh.SingleValue,
        ClearIndicator: $8BxoE.ClearIndicator,
        Option: $d1LXW.Option,
        ValueContainer: (0, $95uM8.SingleValueContainer),
        Input: (0, $aoWT3.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $91jwt.PopupControl)
    };
    return baseProps;
});
module.exports["getComponents"] = $55820c8d7312f5f6$export$4e811121b221213b;

});

parcelRegister("8BxoE", function(module, exports) {
/* ClearIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");

function $a971b05a8af6e488$var$_defineProperty(e, r, t) {
    return (r = $a971b05a8af6e488$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a971b05a8af6e488$var$_toPropertyKey(t) {
    var i = $a971b05a8af6e488$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a971b05a8af6e488$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

const $a971b05a8af6e488$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dWRcP")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $a971b05a8af6e488$var$clearIndicatorStyles = {
    root: "_v5641ppt _tzy4kb7n _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _30l3s4qr _1mhjgrf3"
};
class $a971b05a8af6e488$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            },
            xcss: $a971b05a8af6e488$var$clearIndicatorStyles.root
        });
        return clearValueLabel ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
            fallback: Indicator,
            children: /*#__PURE__*/ (0, $l998X.jsx)($a971b05a8af6e488$var$AsyncTooltip, {
                content: clearValueLabel,
                children: Indicator
            })
        }) : Indicator;
    }
    constructor(...args){
        super(...args);
        $a971b05a8af6e488$var$_defineProperty(this, "handleMouseDown", (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
             // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue(); //@ts-ignore react-select unsupported props
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        });
    }
}
module.exports["ClearIndicator"] = $a971b05a8af6e488$export$ecf9cf59142dd54a;

});

parcelRegister("dWRcP", function(module, exports) {

let $a279f6b565ca3fab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a279f6b565ca3fab$var$load("764nc").then(()=>parcelRequire('SMbnh'));

});

parcelRegister("8Z5lp", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $3hOY6 = parcelRequire("3hOY6");


var $9K4OG = parcelRequire("9K4OG");


var $7NrQn = parcelRequire("7NrQn");


var $gElw0 = parcelRequire("gElw0");


var $daWcu = parcelRequire("daWcu");


var $6O3OC = parcelRequire("6O3OC");


var $7D93v = parcelRequire("7D93v");


var $cO3Oi = parcelRequire("cO3Oi");


var $dh538 = parcelRequire("dh538");

function $926971438bfd3fb0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $926971438bfd3fb0$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $926971438bfd3fb0$var$groupTagContainer = (0, $ecnYn.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $926971438bfd3fb0$var$nameWrapper = {
    name: "1ebbz80",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
class $926971438bfd3fb0$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $926971438bfd3fb0$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3hOY6.components).MultiValue, {
            ...rest,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dcJ7R.default), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $926971438bfd3fb0$var$nameWrapper
        }, children), this.getElemAfter()));
    }
    constructor(props){
        super(props);
        this.containerRef = void 0;
        this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $6O3OC.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7NrQn.AddOptionAvatar), {
                isLozenge: true,
                isPendingAction: data.isPendingAction
            });
            if ((0, $6O3OC.isGroup)(data)) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                xcss: $926971438bfd3fb0$var$groupTagContainer
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7D93v))), {
                LEGACY_margin: "-2px 0 0 0",
                color: "currentColor",
                label: "" // This element is a decorative icon and does not require a label
                ,
                LEGACY_size: "small"
            }));
            // Only use icon if feature gate is enabled
            if (data.icon && (0, $dh538.fg)('atlaskit_user_picker_support_icon')) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gElw0.AvatarOrIcon), {
                appearance: "multi",
                icon: data.icon,
                iconColor: data.iconColor,
                src: (0, $6O3OC.getAvatarUrl)(data),
                type: (0, $6O3OC.isTeam)(data) ? 'team' : 'person'
            });
            // Fallback to original behavior
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $daWcu.SizeableAvatar), {
                appearance: "multi",
                src: (0, $6O3OC.getAvatarUrl)(data),
                type: (0, $6O3OC.isTeam)(data) ? 'team' : 'person'
            });
        };
        this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $6O3OC.isGroup)(data) && data.includeTeamsUpdates || (0, $6O3OC.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $cO3Oi.VerifiedTeamIcon), {
                size: data.includeTeamsUpdates ? 'small' : 'medium'
            });
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
    }
}
module.exports["MultiValue"] = $926971438bfd3fb0$export$419cdf50db8b579;

});

parcelRegister("7NrQn", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5GDNB = parcelRequire("5GDNB");


var $6fnsQ = parcelRequire("6fnsQ");


var $9K4OG = parcelRequire("9K4OG");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $1a863c2fdda060de$var$getEmailAvatarWrapperStyle = (isLozenge, isPendingAction)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    const backgroundColor = isPendingAction && (0, $dh538.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-background-warning, #FFF5DB)" : `var(--ds-background-neutral, ${0, $6fnsQ.N40})`;
    return /*#__PURE__*/ (0, $9K4OG.css)({
        padding: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding,
        backgroundColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor,
        borderRadius: "var(--ds-radius-full, 9999px)",
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $1a863c2fdda060de$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label, isPendingAction: isPendingAction })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $1a863c2fdda060de$var$getEmailAvatarWrapperStyle(isLozenge, isPendingAction)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5GDNB))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        LEGACY_size: isLozenge ? 'small' : 'medium',
        LEGACY_margin: "0 0 0 -2px",
        color: isPendingAction && (0, $dh538.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-text-warning, #9E4C00)" : `var(--ds-text-subtle, ${0, $6fnsQ.N500})`
    })));
};
module.exports["AddOptionAvatar"] = $1a863c2fdda060de$export$df396db45e491922;

});

parcelRegister("gElw0", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $daWcu = parcelRequire("daWcu");


var $6O3OC = parcelRequire("6O3OC");


var $9K4OG = parcelRequire("9K4OG");

function $063475195e4c8312$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $063475195e4c8312$var$iconStyle = {
    name: "sjfyf",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0"
};
const $063475195e4c8312$var$iconSizes = {
    xsmall: {
        name: "1aynuae",
        styles: "width:20px;height:20px"
    },
    small: {
        name: "1c76jn8",
        styles: "width:28px;height:28px"
    },
    medium: {
        name: "bgbjt4",
        styles: "width:36px;height:36px"
    }
};
const $063475195e4c8312$export$60751fd23180a0ed = ({ appearance: appearance = 'big', avatarAppearanceShape: avatarAppearanceShape, icon: icon, iconColor: iconColor, presence: presence, src: src, type: type = 'person' })=>{
    // If icon is provided, render it instead of avatar
    if (icon) {
        const avatarSize = (0, $6O3OC.getAvatarSize)(appearance);
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: [
                $063475195e4c8312$var$iconStyle,
                $063475195e4c8312$var$iconSizes[avatarSize]
            ],
            style: {
                color: iconColor
            }
        }, icon);
    }
    // Otherwise, render the avatar as before
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $daWcu.SizeableAvatar), {
        appearance: appearance,
        src: src,
        presence: presence,
        type: type,
        avatarAppearanceShape: avatarAppearanceShape
    });
};
module.exports["AvatarOrIcon"] = $063475195e4c8312$export$60751fd23180a0ed;

});

parcelRegister("daWcu", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $esRft = parcelRequire("esRft");


var $alaek = parcelRequire("alaek");


var $42omo = parcelRequire("42omo");


var $6O3OC = parcelRequire("6O3OC");

class $7c01c0d05ab0848d$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person', avatarAppearanceShape: avatarAppearanceShape } = this.props;
        const props = {
            size: (0, $6O3OC.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence,
            ...avatarAppearanceShape && {
                appearance: avatarAppearanceShape
            }
        };
        return type === 'team' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $alaek.default), {
            ...props
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
            ...props
        });
    }
}
module.exports["SizeableAvatar"] = $7c01c0d05ab0848d$export$44d81a88129649da;

});

parcelRegister("cO3Oi", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $bh5s2 = parcelRequire("bh5s2");


var $3gadb = parcelRequire("3gadb");


var $fk7e8 = parcelRequire("fk7e8");

const $5c856781f75583e4$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent, size: size = 'medium', spacing: spacing = 'spacious' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $fk7e8.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $l998X.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
                    color: "var(--ds-icon-accent-blue, #357DE8)",
                    size: size,
                    label: tooltipContent,
                    spacing: spacing
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
        color: "var(--ds-icon-accent-blue, #357DE8)",
        size: size,
        spacing: spacing,
        label: label
    });
};
module.exports["VerifiedTeamIcon"] = $5c856781f75583e4$export$d7949f68d31e5edd;

});

parcelRegister("fk7e8", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $81eb31bb2f17e3e1$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: "ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip",
        defaultMessage: "Managed teams are verified because they can only be changed by an admin."
    }
});
module.exports["messages"] = $81eb31bb2f17e3e1$export$defe85febe8b728c;

});

parcelRegister("djtLL", function(module, exports) {
/* MultiValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $3hOY6 = parcelRequire("3hOY6");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $3aPpx = parcelRequire("3aPpx");


var $6O3OC = parcelRequire("6O3OC");


var $5zTZv = parcelRequire("5zTZv");

function $583428e46a5d063b$var$_defineProperty(e, r, t) {
    return (r = $583428e46a5d063b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $583428e46a5d063b$var$_toPropertyKey(t) {
    var i = $583428e46a5d063b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $583428e46a5d063b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $583428e46a5d063b$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bv12x7 _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq1j28 _1ke8idpf"
};
class $583428e46a5d063b$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        //@ts-ignore react-select unsupported props
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5zTZv.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).ValueContainer, {
                ...props,
                xcss: $583428e46a5d063b$var$valueContainerStyles.root,
                children: this.renderChildren()
            })
        });
    }
    constructor(props){
        super(props);
        $583428e46a5d063b$var$_defineProperty(this, "valueContainerInnerProps", void 0);
        $583428e46a5d063b$var$_defineProperty(this, "timeoutId", null);
        $583428e46a5d063b$var$_defineProperty(this, "scrollToBottom", ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) current.scrollTop = current.scrollHeight;
                this.timeoutId = null;
            });
        });
        $583428e46a5d063b$var$_defineProperty(this, "showPlaceholder", ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        });
        $583428e46a5d063b$var$_defineProperty(this, "addPlaceholder", (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(this.props.children, (child)=>(0, $6O3OC.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                children: children
            });
        });
        $583428e46a5d063b$var$_defineProperty(this, "renderChildren", ()=>{
            const { //@ts-ignore react-select unsupported props
            selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props; // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).addMore,
                children: (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                }
            });
            return this.addPlaceholder(addMoreMessage);
        }); //@ts-ignore react-select unsupported props
        $583428e46a5d063b$var$_defineProperty(this, "onValueContainerClick", this.props.selectProps.onValueContainerClick);
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef()
        };
    }
}
module.exports["MultiValueContainer"] = $583428e46a5d063b$export$cf9cf2a30a59265c;

});

parcelRegister("5zTZv", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

function $e7cd9ff8a2bfdfe9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $e7cd9ff8a2bfdfe9$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $e7cd9ff8a2bfdfe9$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlassian/a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $e7cd9ff8a2bfdfe9$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $e7cd9ff8a2bfdfe9$export$2e2bcd8739ae039 = $e7cd9ff8a2bfdfe9$var$ValueContainerWrapper;
module.exports["default"] = $e7cd9ff8a2bfdfe9$export$2e2bcd8739ae039;

});

parcelRegister("d1LXW", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $gdv5Z = parcelRequire("gdv5Z");


var $3hOY6 = parcelRequire("3hOY6");


var $3gadb = parcelRequire("3gadb");


var $42omo = parcelRequire("42omo");


var $gIEXj = parcelRequire("gIEXj");


var $5MuqH = parcelRequire("5MuqH");


var $8bByc = parcelRequire("8bByc");


var $gQDzG = parcelRequire("gQDzG");


var $5SlZw = parcelRequire("5SlZw");


var $2OK2a = parcelRequire("2OK2a");


var $6O3OC = parcelRequire("6O3OC");


var $9xsgQ = parcelRequire("9xsgQ");

const $5421d1d84d0948a5$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, $l998X.jsx)((0, $gIEXj.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $5421d1d84d0948a5$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $6O3OC.isExternalUser)(data)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5MuqH.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $6O3OC.isUser)(data)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gIEXj.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $6O3OC.isEmail)(data)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5SlZw.default), {
        email: data,
        emailValidity: (0, $9xsgQ.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $6O3OC.isTeam)(data)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $8bByc.default), {
        team: data,
        isSelected: isSelected,
        includeTeamsUpdates: data.includeTeamsUpdates
    });
    if ((0, $6O3OC.isGroup)(data)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gQDzG.default), {
        group: data,
        isSelected: isSelected,
        includeTeamsUpdates: data.includeTeamsUpdates
    });
    if ((0, $6O3OC.isCustom)(data)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $2OK2a.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $5421d1d84d0948a5$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: props.data?.data?.tooltip,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ...tooltipProps,
                children: $5421d1d84d0948a5$var$dataOption(props)
            })
    });
    return $5421d1d84d0948a5$var$dataOption(props);
};
const $5421d1d84d0948a5$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
            fallback: $5421d1d84d0948a5$var$defaultOption(props),
            children: $5421d1d84d0948a5$var$dataOptionWithTooltip(props)
        })
    });
module.exports["Option"] = $5421d1d84d0948a5$export$36d18380658d5d20;

});

parcelRegister("gIEXj", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5sA9S = parcelRequire("5sA9S");


var $6fnsQ = parcelRequire("6fnsQ");


var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $a1Cju = parcelRequire("a1Cju");


var $a3dA4 = parcelRequire("a3dA4");


var $gElw0 = parcelRequire("gElw0");


var $daWcu = parcelRequire("daWcu");


var $6O3OC = parcelRequire("6O3OC");


var $dh538 = parcelRequire("dh538");

const $ca21a62b4eb173f5$var$styles = (color)=>/*#__PURE__*/ (0, $9K4OG.css)({
        display: 'inline',
        verticalAlign: 'top',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        color
    });
class $ca21a62b4eb173f5$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a1Cju.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args);
        this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $a1Cju.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $6fnsQ.B400})` : `var(--ds-text, ${0, $6fnsQ.N800})`)
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a3dA4.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $6O3OC.hasValue)(publicName) && name.trim() !== publicName.trim()) {
                const color = this.props.isSelected ? `var(--ds-text-selected, ${0, $6fnsQ.B400})` : `var(--ds-text-subtlest, ${0, $6fnsQ.N200})`;
                result.push(/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                    key: "publicName"
                }, ' ', /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $dh538.fg)('platform_user_picker_firefox_tab_fix') ? $ca21a62b4eb173f5$var$styles(color) : (0, $a1Cju.textWrapper)(color)
                }, "(", /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a3dA4.HighlightText), {
                    highlights: highlight && highlight.publicName
                }, publicName), ")")));
            }
            return result;
        };
        this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $a1Cju.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $6fnsQ.B400})` : `var(--ds-text-subtlest, ${0, $6fnsQ.N200})`)
            }, this.props.user.byline) : undefined;
        this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl, appType: appType, icon: icon, iconColor: iconColor }, status: status } = this.props;
            const appearance = (0, $dh538.fg)('platform-component-visual-refresh') ? 'medium' : 'big';
            // Only use icon if feature gate is enabled
            if (icon && (0, $dh538.fg)('atlaskit_user_picker_support_icon')) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gElw0.AvatarOrIcon), {
                appearance: appearance,
                icon: icon,
                iconColor: iconColor,
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $dh538.fg)('jira_ai_agent_avatar_user_picker_user_option') ? (0, $5sA9S.getAppearanceForAppType)(appType) : undefined
            });
            // Fallback to original behavior
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $daWcu.SizeableAvatar), {
                appearance: appearance,
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $dh538.fg)('jira_ai_agent_avatar_user_picker_user_option') ? (0, $5sA9S.getAppearanceForAppType)(appType) : undefined
            });
        };
        this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}
module.exports["UserOption"] = $ca21a62b4eb173f5$export$8e59f78010871662;

});

parcelRegister("a1Cju", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $5nBzc = parcelRequire("5nBzc");


var $6O3OC = parcelRequire("6O3OC");


var $dh538 = parcelRequire("dh538");

function $96ea07b7daa86f4d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $96ea07b7daa86f4d$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dWRcP")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $96ea07b7daa86f4d$var$wrapper = (isDisabled)=>{
    if ((0, $dh538.fg)('platform_user_picker_firefox_tab_fix')) return /*#__PURE__*/ (0, $9K4OG.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
    return /*#__PURE__*/ (0, $9K4OG.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
};
const $96ea07b7daa86f4d$var$optionWrapper = {
    name: "13552d7",
    styles: "max-width:100%;min-width:0;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $96ea07b7daa86f4d$var$optionWrapperFix = {
    name: "18gxn58",
    styles: "display:inline-block;overflow:hidden;min-width:0;max-width:100%;padding-left:var(--ds-space-100, 8px)"
};
const $96ea07b7daa86f4d$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    if ((0, $dh538.fg)('platform_user_picker_firefox_tab_fix')) return /*#__PURE__*/ (0, $9K4OG.css)({
        margin: 0,
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
    return /*#__PURE__*/ (0, $9K4OG.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $96ea07b7daa86f4d$var$additionalInfo = {
    name: "1hvgowa",
    styles: "float:right;margin-left:var(--ds-space-100, 8px)"
};
const $96ea07b7daa86f4d$export$aa6223da92b253dd = (color)=>{
    if ((0, $dh538.fg)('platform_user_picker_firefox_tab_fix')) return /*#__PURE__*/ (0, $9K4OG.css)({
        display: 'inline-block',
        verticalAlign: 'bottom',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
    return /*#__PURE__*/ (0, $9K4OG.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
};
const $96ea07b7daa86f4d$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $6O3OC.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
                fallback: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5nBzc.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)($96ea07b7daa86f4d$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5nBzc.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5nBzc.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $96ea07b7daa86f4d$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $dh538.fg)('platform_user_picker_firefox_tab_fix') ? $96ea07b7daa86f4d$var$optionWrapperFix : $96ea07b7daa86f4d$var$optionWrapper
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", null, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $96ea07b7daa86f4d$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $96ea07b7daa86f4d$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $96ea07b7daa86f4d$var$additionalInfo
    }, renderLozenge())));
};
module.exports["textWrapper"] = $96ea07b7daa86f4d$export$aa6223da92b253dd;
module.exports["AvatarItemOption"] = $96ea07b7daa86f4d$export$164a9d9b3b86dd0c;

});

parcelRegister("a3dA4", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

class $9b44487d553c26e3$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, $l998X.jsx)("b", {
                children: part.value
            }, index);
            return part.value;
        });
    }
}
module.exports["HighlightText"] = $9b44487d553c26e3$export$bb02e7bc6e1a7119;

});

parcelRegister("5MuqH", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $9552d5b64b4732c1$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("7adFK")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $9552d5b64b4732c1$export$2e2bcd8739ae039 = $9552d5b64b4732c1$var$AsyncExternalUserOption;
module.exports["default"] = $9552d5b64b4732c1$export$2e2bcd8739ae039;

});

parcelRegister("7adFK", function(module, exports) {

let $537412991a32c5ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $537412991a32c5ce$var$load("6wr18"),
    $537412991a32c5ce$var$load("ffEVr"),
    $537412991a32c5ce$var$load("let0D"),
    $537412991a32c5ce$var$load("faXeM")
]).then(()=>parcelRequire('antvm'));

});

parcelRegister("8bByc", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $7087fdc05d26f437$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("efg1X")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $7087fdc05d26f437$export$2e2bcd8739ae039 = $7087fdc05d26f437$var$AsyncTeamOption;
module.exports["default"] = $7087fdc05d26f437$export$2e2bcd8739ae039;

});

parcelRegister("efg1X", function(module, exports) {

let $a5eee6b7b14d7452$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a5eee6b7b14d7452$var$load("7eOUa").then(()=>parcelRequire('3Ylqf'));

});

parcelRegister("gQDzG", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $b48b06ade47a1f85$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("jNY3N")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $b48b06ade47a1f85$export$2e2bcd8739ae039 = $b48b06ade47a1f85$var$AsyncGroupOption;
module.exports["default"] = $b48b06ade47a1f85$export$2e2bcd8739ae039;

});

parcelRegister("jNY3N", function(module, exports) {

let $e6b12e9eee2c8d12$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6b12e9eee2c8d12$var$load("9zjWJ").then(()=>parcelRequire('g2CU3'));

});

parcelRegister("5SlZw", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $b3aa7260631192b5$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("e2jHL")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $b3aa7260631192b5$export$2e2bcd8739ae039 = $b3aa7260631192b5$var$AsyncEmailOption;
module.exports["default"] = $b3aa7260631192b5$export$2e2bcd8739ae039;

});

parcelRegister("e2jHL", function(module, exports) {

let $a380898d18b524af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a380898d18b524af$var$load("cwwPf").then(()=>parcelRequire('gqFgq'));

});

parcelRegister("2OK2a", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $8b75c704d969ea14$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("hilZh")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $8b75c704d969ea14$export$2e2bcd8739ae039 = $8b75c704d969ea14$var$AsyncCustomOption;
module.exports["default"] = $8b75c704d969ea14$export$2e2bcd8739ae039;

});

parcelRegister("hilZh", function(module, exports) {

let $c9752c5bfc29a902$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9752c5bfc29a902$var$load("3a4K1").then(()=>parcelRequire('1oHUa'));

});

parcelRegister("9xsgQ", function(module, exports) {
const $bade09abd4a5fb04$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $bade09abd4a5fb04$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $bade09abd4a5fb04$export$371e338370561054 = (inputText)=>{
    if (inputText.match($bade09abd4a5fb04$var$validRegex)) return 'VALID';
    if (inputText.match($bade09abd4a5fb04$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};
module.exports["isValidEmail"] = $bade09abd4a5fb04$export$371e338370561054;

});

parcelRegister("biJXh", function(module, exports) {
/* SingleValue.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3hOY6 = parcelRequire("3hOY6");


var $gElw0 = parcelRequire("gElw0");


var $daWcu = parcelRequire("daWcu");


var $6O3OC = parcelRequire("6O3OC");


var $5sA9S = parcelRequire("5sA9S");


var $dh538 = parcelRequire("dh538");


var $cO3Oi = parcelRequire("cO3Oi");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

const $c82e4369df94e7c9$var$styles = {
    avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
    avatarItemText: "_syazi7uo _1reo15vq _1bto1l2s _o5721q9c"
};
const $c82e4369df94e7c9$var$ElementAfter = (props)=>{
    const { data: { data: data }, shouldShowVerifiedIcon: shouldShowVerifiedIcon } = props;
    const showIcon = shouldShowVerifiedIcon ? shouldShowVerifiedIcon(data) : (0, $6O3OC.isTeam)(data) && data.verified || (0, $6O3OC.isGroup)(data) && data.includeTeamsUpdates;
    if (showIcon) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cO3Oi.VerifiedTeamIcon), {
        size: data.includeTeamsUpdates ? 'small' : 'medium'
    });
    return null;
};
const $c82e4369df94e7c9$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, //@ts-ignore react-select unsupported props
    selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            xcss: $c82e4369df94e7c9$var$styles.avatarItem,
            children: [
                data.icon && (0, $dh538.fg)('atlaskit_user_picker_support_icon') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gElw0.AvatarOrIcon), {
                    icon: data.icon,
                    iconColor: data.iconColor,
                    src: (0, $6O3OC.getAvatarUrl)(data),
                    appearance: appearance,
                    type: (0, $6O3OC.isTeam)(data) ? 'team' : 'person',
                    avatarAppearanceShape: (0, $dh538.fg)('jira_ai_agent_avatar_user_picker_user_option') ? (0, $5sA9S.getAppearanceForAppType)(data.appType) : undefined
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $daWcu.SizeableAvatar), {
                    src: (0, $6O3OC.getAvatarUrl)(data),
                    appearance: appearance,
                    type: (0, $6O3OC.isTeam)(data) ? 'team' : 'person',
                    avatarAppearanceShape: (0, $dh538.fg)('jira_ai_agent_avatar_user_picker_user_option') ? (0, $5sA9S.getAppearanceForAppType)(data.appType) : undefined
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $c82e4369df94e7c9$var$styles.avatarItem,
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $c82e4369df94e7c9$var$styles.avatarItemTextWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $c82e4369df94e7c9$var$styles.avatarItemText,
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                alignBlock: "center",
                                children: [
                                    label,
                                    /*#__PURE__*/ (0, $l998X.jsx)($c82e4369df94e7c9$var$ElementAfter, {
                                        ...props
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    }) : null;
};
module.exports["SingleValue"] = $c82e4369df94e7c9$export$1949dac661ba6e3a;

});

parcelRegister("gtKKr", function(module, exports) {
/* Input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");

function $d235b09878379c1c$var$_defineProperty(e, r, t) {
    return (r = $d235b09878379c1c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d235b09878379c1c$var$_toPropertyKey(t) {
    var i = $d235b09878379c1c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d235b09878379c1c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $d235b09878379c1c$var$inputStyles = {
    root: "_5ce61rpy _1ir3kb7n _h5gq1rpy"
};
class $d235b09878379c1c$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress,
            xcss: $d235b09878379c1c$var$inputStyles.root
        });
    }
    constructor(...args){
        super(...args); // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        $d235b09878379c1c$var$_defineProperty(this, "handleKeyPress", (e)=>{
            if (e.key === 'Enter') e.preventDefault();
             //@ts-ignore react-select unsupported props
            if (this.props.selectProps?.disableInput) e.preventDefault();
        });
    }
}
module.exports["Input"] = $d235b09878379c1c$export$f5b8910cec6cf069;

});

parcelRegister("95uM8", function(module, exports) {
/* SingleValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");


var $gElw0 = parcelRequire("gElw0");


var $daWcu = parcelRequire("daWcu");


var $5zTZv = parcelRequire("5zTZv");


var $5sA9S = parcelRequire("5sA9S");


var $dh538 = parcelRequire("dh538");

function $32eecf62664383f6$var$_defineProperty(e, r, t) {
    return (r = $32eecf62664383f6$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $32eecf62664383f6$var$_toPropertyKey(t) {
    var i = $32eecf62664383f6$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $32eecf62664383f6$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $32eecf62664383f6$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bvze3t _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq1j28 _1ke8idpf"
};
const $32eecf62664383f6$var$placeholderIconContainer = null;
const $32eecf62664383f6$var$wrapperStyle = null;
const $32eecf62664383f6$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
class $32eecf62664383f6$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5zTZv.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $3hOY6.components).ValueContainer, {
                ...valueContainerProps,
                xcss: $32eecf62664383f6$var$valueContainerStyles.root,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_nd5l1kqh _19bv12x7 _vwz4idpf"
                        ]),
                        children: this.renderAvatar()
                    }),
                    children
                ]
            })
        });
    }
    constructor(...args){
        super(...args);
        $32eecf62664383f6$var$_defineProperty(this, "renderAvatar", ()=>{
            const { hasValue: hasValue, //@ts-ignore react-select unsupported props
            selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) {
                const userData = $32eecf62664383f6$var$showUserAvatar(inputValue, value) ? value.data : undefined; // Only use icon if feature gate is enabled
                if (userData?.icon && (0, $dh538.fg)('atlaskit_user_picker_support_icon')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gElw0.AvatarOrIcon), {
                    appearance: appearance,
                    icon: userData.icon,
                    iconColor: userData.iconColor,
                    type: placeholderAvatar,
                    src: userData.avatarUrl,
                    avatarAppearanceShape: userData && (0, $dh538.fg)('jira_ai_agent_avatar_user_picker_user_option') ? (0, $5sA9S.getAppearanceForAppType)(userData.appType) : undefined
                });
                 // Fallback to original behavior
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $daWcu.SizeableAvatar), {
                    appearance: appearance,
                    type: placeholderAvatar,
                    src: userData?.avatarUrl,
                    avatarAppearanceShape: userData && (0, $dh538.fg)('jira_ai_agent_avatar_user_picker_user_option') ? (0, $5sA9S.getAppearanceForAppType)(userData.appType) : undefined
                });
            }
            return null;
        }); //@ts-ignore react-select unsupported props
        $32eecf62664383f6$var$_defineProperty(this, "onValueContainerClick", this.props.selectProps.onValueContainerClick);
        $32eecf62664383f6$var$_defineProperty(this, "Wrapper", ({ children: children })=>{
            return this.onValueContainerClick ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                onMouseDown: this.onValueContainerClick,
                className: (0, $gMc0m.default)([
                    "_16jlkb7n"
                ]),
                children: children
            }) : children;
        });
    }
}
module.exports["SingleValueContainer"] = $32eecf62664383f6$export$afa5f855316c6a48;

});

parcelRegister("aoWT3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtKKr = parcelRequire("gtKKr");

class $66df8f81b00f76a0$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtKKr.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args);
        this.ref = null;
        this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}
module.exports["PopupInput"] = $66df8f81b00f76a0$export$d8edbfd510a7db82;

});

parcelRegister("91jwt", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $6fnsQ = parcelRequire("6fnsQ");


var $8LA5n = parcelRequire("8LA5n");

const $6b1648b7e3dcb30f$var$controlWrapper = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $6b1648b7e3dcb30f$var$labelStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    paddingBottom: "var(--ds-space-050, 4px)",
    paddingLeft: "var(--ds-space-0, 0px)",
    paddingRight: "var(--ds-space-0, 0px)",
    paddingTop: "var(--ds-space-250, 20px)"
});
class $6b1648b7e3dcb30f$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $6b1648b7e3dcb30f$var$controlWrapper
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $6b1648b7e3dcb30f$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8LA5n.default), this.props));
    }
}
module.exports["PopupControl"] = $6b1648b7e3dcb30f$export$a0cb1b4352357fcc;

});

parcelRegister("8LA5n", function(module, exports) {
/* Control.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");


var $1bHXt = parcelRequire("1bHXt");

const $c39fb557d4d2ab16$var$controlStyles = {
    invalid: "_1h6d1bqt _4cvx1bqt",
    focused: "_1h6d1v1w _bfhk1j9a _4cvx1v1w _irr31j9a",
    disabled: "_irr3by5v",
    subtle: "_1h6d1j28 _bfhk1j28 _4cvx1j28 _irr31gly",
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1h6drsbi _bfhk1j9a _p12f1osq _14regrf3 _4cvxrsbi _irr3l4ek _1a98zg3v",
    compact: "_1tke1wug"
};
const $c39fb557d4d2ab16$var$Control = (props)=>{
    const isCompact = props.appearance === 'compact';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Control, {
        ...props,
        xcss: (0, $1bHXt.cx)($c39fb557d4d2ab16$var$controlStyles.root, isCompact && $c39fb557d4d2ab16$var$controlStyles.compact, (props.selectProps.subtle || props.selectProps.noBorder) && $c39fb557d4d2ab16$var$controlStyles.subtle, props.isFocused && $c39fb557d4d2ab16$var$controlStyles.focused, props.isInvalid && $c39fb557d4d2ab16$var$controlStyles.invalid, props.isDisabled && $c39fb557d4d2ab16$var$controlStyles.disabled)
    });
};
var $c39fb557d4d2ab16$export$2e2bcd8739ae039 = $c39fb557d4d2ab16$var$Control;
module.exports["default"] = $c39fb557d4d2ab16$export$2e2bcd8739ae039;

});

parcelRegister("8lAE4", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");


var $9K4OG = parcelRequire("9K4OG");

const $d10d1e7e5aa26e90$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $d10d1e7e5aa26e90$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3hOY6.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $d10d1e7e5aa26e90$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}
module.exports["Menu"] = $d10d1e7e5aa26e90$export$d9b273488cd8ce6f;

});

parcelRegister("dTofT", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $RMvle = parcelRequire("RMvle");


var $9xsgQ = parcelRequire("9xsgQ");


var $6O3OC = parcelRequire("6O3OC");

const $bfc99c5b192cefdf$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $bfc99c5b192cefdf$var$isValidNewOption = (isValidEmail = (0, $9xsgQ.isValidEmail))=>(inputValue)=>inputValue && $bfc99c5b192cefdf$var$validOption.includes(isValidEmail(inputValue));
const $bfc99c5b192cefdf$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $RMvle.EmailType)
        }
    });
const $bfc99c5b192cefdf$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $bfc99c5b192cefdf$var$isOptionDisabled = (isValidEmail = (0, $9xsgQ.isValidEmail))=>(option)=>{
        if ((0, $6O3OC.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $bfc99c5b192cefdf$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $bfc99c5b192cefdf$var$isValidNewOption(isValidEmail),
        getNewOptionData: $bfc99c5b192cefdf$var$getNewOptionData,
        formatCreateLabel: $bfc99c5b192cefdf$var$formatCreateLabel,
        isOptionDisabled: $bfc99c5b192cefdf$var$isOptionDisabled(isValidEmail)
    };
}
const $bfc99c5b192cefdf$export$36f97d8afa97203d = (0, $2XqLN.default)($bfc99c5b192cefdf$var$creatableProps);
module.exports["getCreatableProps"] = $bfc99c5b192cefdf$export$36f97d8afa97203d;

});

parcelRegister("bYlb2", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $RMvle = parcelRequire("RMvle");


var $9xsgQ = parcelRequire("9xsgQ");


var $6O3OC = parcelRequire("6O3OC");

const $981facf0cd076fa1$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $981facf0cd076fa1$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $981facf0cd076fa1$var$getNewOptionData = (isValidEmail = (0, $9xsgQ.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $981facf0cd076fa1$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $RMvle.EmailType),
                suggestion: true
            }
        };
    };
const $981facf0cd076fa1$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $981facf0cd076fa1$var$isOptionDisabled = (isValidEmail = (0, $9xsgQ.isValidEmail))=>(option)=>{
        if ((0, $6O3OC.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $981facf0cd076fa1$export$34b9dd2dd6a225e5 = (0, $2XqLN.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $981facf0cd076fa1$var$isValidNewOption,
        getNewOptionData: $981facf0cd076fa1$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $981facf0cd076fa1$var$formatCreateLabel,
        isOptionDisabled: $981facf0cd076fa1$var$isOptionDisabled(isValidEmail)
    }));
module.exports["getCreatableSuggestedEmailProps"] = $981facf0cd076fa1$export$34b9dd2dd6a225e5;

});

parcelRegister("39zOH", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $8C5kA = parcelRequire("8C5kA");


var $czxno = parcelRequire("czxno");

const $f33aff4e4306ad48$var$EMPTY = {};
const $f33aff4e4306ad48$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState($f33aff4e4306ad48$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        let aborted = false;
        setMessages($f33aff4e4306ad48$var$EMPTY);
        (0, $czxno.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $f33aff4e4306ad48$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $8C5kA.default)();
    const { children: children } = props;
    const messages = $f33aff4e4306ad48$var$useI18n(intl.locale);
    const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $f33aff4e4306ad48$export$2e2bcd8739ae039 = $f33aff4e4306ad48$var$MessagesIntlProvider;
module.exports["default"] = $f33aff4e4306ad48$export$2e2bcd8739ae039;

});

parcelRegister("czxno", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $4ae2a92de5b04374$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("gGm07")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("iMgoY")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("a2F4a")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("exio3")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("ht5Af")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("67KWz")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("2ITUY")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("bmV2y")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("bDfHw")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("l6Jrp")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("5Fgxz")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("giE6R")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("aFqW6")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("6qm5B")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("4pTGn")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("5KU7n")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("6Q6st")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("hfezP")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("5lXJD")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("3NE2V")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("csvdv")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("7xuSk")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("43nDx")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("iV5JJ")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("cnB93")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("vqivz")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("6yfCT")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("1XdJ8")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("jUGvI")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("cg7pQ")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $4ae2a92de5b04374$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("exio3")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $4ae2a92de5b04374$export$d0a3169680473b6c;

});

parcelRegister("gGm07", function(module, exports) {

let $c251a28321a837d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c251a28321a837d3$var$load("9J4KV").then(()=>parcelRequire('g1PaI'));

});

parcelRegister("iMgoY", function(module, exports) {

let $dab96ec43e6f3eb4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dab96ec43e6f3eb4$var$load("8Y9JE").then(()=>parcelRequire('5cPWG'));

});

parcelRegister("a2F4a", function(module, exports) {

let $74f9f22fcdef1db1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74f9f22fcdef1db1$var$load("gWrRN").then(()=>parcelRequire('1YU5Y'));

});

parcelRegister("exio3", function(module, exports) {

let $a95269083b6eacd9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a95269083b6eacd9$var$load("irKcy").then(()=>parcelRequire('6aEWI'));

});

parcelRegister("ht5Af", function(module, exports) {

let $cb7979ea7781b247$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb7979ea7781b247$var$load("1aghR").then(()=>parcelRequire('97wEb'));

});

parcelRegister("67KWz", function(module, exports) {

let $4757cf8a3567ee77$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4757cf8a3567ee77$var$load("3jFnE").then(()=>parcelRequire('F3yzi'));

});

parcelRegister("2ITUY", function(module, exports) {

let $1fbb10fa632caa58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fbb10fa632caa58$var$load("11Khz").then(()=>parcelRequire('ewRdG'));

});

parcelRegister("bmV2y", function(module, exports) {

let $846dfec790105370$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $846dfec790105370$var$load("ap0LY").then(()=>parcelRequire('IpO3b'));

});

parcelRegister("bDfHw", function(module, exports) {

let $877f84210d06b4a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $877f84210d06b4a6$var$load("34Ma8").then(()=>parcelRequire('cp7FA'));

});

parcelRegister("l6Jrp", function(module, exports) {

let $f5dd68287f6311f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f5dd68287f6311f0$var$load("lBwDa").then(()=>parcelRequire('kADLe'));

});

parcelRegister("5Fgxz", function(module, exports) {

let $41fd9caed43226bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $41fd9caed43226bf$var$load("32Pvr").then(()=>parcelRequire('bVNYH'));

});

parcelRegister("giE6R", function(module, exports) {

let $bddd70b947d92280$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bddd70b947d92280$var$load("b7bFd").then(()=>parcelRequire('3MhWk'));

});

parcelRegister("aFqW6", function(module, exports) {

let $7c42a0a6d53b297d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c42a0a6d53b297d$var$load("6h8Ae").then(()=>parcelRequire('461Di'));

});

parcelRegister("6qm5B", function(module, exports) {

let $4ad64e444a7941dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ad64e444a7941dc$var$load("dW8Ws").then(()=>parcelRequire('2gGqw'));

});

parcelRegister("4pTGn", function(module, exports) {

let $3374b0a133257fc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3374b0a133257fc8$var$load("fJZdm").then(()=>parcelRequire('b0fTR'));

});

parcelRegister("5KU7n", function(module, exports) {

let $0114d9ed76b2fdf6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0114d9ed76b2fdf6$var$load("kfTIE").then(()=>parcelRequire('e3XiS'));

});

parcelRegister("6Q6st", function(module, exports) {

let $4fac9be16220acb5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4fac9be16220acb5$var$load("b8M9e").then(()=>parcelRequire('k1tgV'));

});

parcelRegister("hfezP", function(module, exports) {

let $c8df2505f9f73711$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c8df2505f9f73711$var$load("jMchi").then(()=>parcelRequire('6tsQH'));

});

parcelRegister("5lXJD", function(module, exports) {

let $3e5d400f8ffeb9df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e5d400f8ffeb9df$var$load("2xsmF").then(()=>parcelRequire('8LiMQ'));

});

parcelRegister("3NE2V", function(module, exports) {

let $2c450305321bb93d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2c450305321bb93d$var$load("hHyCx").then(()=>parcelRequire('5jasV'));

});

parcelRegister("csvdv", function(module, exports) {

let $9120508f7983bf02$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9120508f7983bf02$var$load("gw4Pw").then(()=>parcelRequire('9yLSY'));

});

parcelRegister("7xuSk", function(module, exports) {

let $57d390a3a4646107$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57d390a3a4646107$var$load("8rhcn").then(()=>parcelRequire('abrYV'));

});

parcelRegister("43nDx", function(module, exports) {

let $2f39c70088433ef0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f39c70088433ef0$var$load("fh5Vk").then(()=>parcelRequire('hBPGx'));

});

parcelRegister("iV5JJ", function(module, exports) {

let $dc62000857df1f57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc62000857df1f57$var$load("aP4eD").then(()=>parcelRequire('8ch0x'));

});

parcelRegister("cnB93", function(module, exports) {

let $903472462aaf91f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $903472462aaf91f1$var$load("aJWAE").then(()=>parcelRequire('7qoEH'));

});

parcelRegister("vqivz", function(module, exports) {

let $05e74b813d03b672$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05e74b813d03b672$var$load("b96A2").then(()=>parcelRequire('6WyHk'));

});

parcelRegister("6yfCT", function(module, exports) {

let $4c520a22aa4bea6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c520a22aa4bea6b$var$load("g0ukK").then(()=>parcelRequire('1CggD'));

});

parcelRegister("1XdJ8", function(module, exports) {

let $16c5f30bb0fb803b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $16c5f30bb0fb803b$var$load("8DuKk").then(()=>parcelRequire('d2VHY'));

});

parcelRegister("jUGvI", function(module, exports) {

let $e7f4390275d6775d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7f4390275d6775d$var$load("5aSRq").then(()=>parcelRequire('f5vpO'));

});

parcelRegister("cg7pQ", function(module, exports) {

let $8eccbb4928f4b8f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8eccbb4928f4b8f1$var$load("eQT38").then(()=>parcelRequire('5Olm2'));

});

parcelRegister("aahZc", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $60cba41939987423$var$ExusUserSourceContext = /*#__PURE__*/ (0, $42omo.createContext)({});
const $60cba41939987423$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)($60cba41939987423$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        },
        children: children
    });
const $60cba41939987423$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $42omo.useContext)($60cba41939987423$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(null);
    const abortController = (0, $42omo.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $42omo.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $42omo.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};
module.exports["ExusUserSourceProvider"] = $60cba41939987423$export$bcd5c65b586ee3c3;
module.exports["useUserSource"] = $60cba41939987423$export$c6c0c1a2bac363f;

});

parcelRegister("4XUIT", function(module, exports) {
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("8lfDt")).default);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $jb7rL = parcelRequire("jb7rL");


var $8lfDt = parcelRequire("8lfDt");


var $kjDWr = parcelRequire("kjDWr");

const $632da732d9a46658$var$CreatableSelect = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const creatableProps = (0, $kjDWr.default)(props);
    const selectProps = (0, $8lfDt.default)(creatableProps);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jb7rL.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$632da732d9a46658$export$2e2bcd8739ae039 = $632da732d9a46658$var$CreatableSelect;
module.exports["default"] = $632da732d9a46658$export$2e2bcd8739ae039;

});

parcelRegister("8lfDt", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0dda67548c7e875$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $1Ywmy = parcelRequire("1Ywmy");


var $A6wna = parcelRequire("A6wna");

const $a0dda67548c7e875$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $a0dda67548c7e875$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$a0dda67548c7e875$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$a0dda67548c7e875$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $a0dda67548c7e875$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $a0dda67548c7e875$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $a0dda67548c7e875$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $a0dda67548c7e875$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $1Ywmy.getOptionValue), getOptionLabel: getOptionLabel = (0, $1Ywmy.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $42omo.useMemo)(()=>isValidNewOption(inputValue, (0, $A6wna.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $42omo.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $42omo.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $A6wna.valueTernary)(isMulti, [
                    ...(0, $A6wna.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});

parcelRegister("hjygH", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

const $1aeb691895c5954d$export$85823f26dca064c3 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ExperienceStop(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>{
            if (error) experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
            else experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        };
        t2 = [
            experienceTracker,
            name,
            attributes,
            error
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
} : function ExperienceStop({ name: name, error: error, attributes: attributes }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        if (error) experienceTracker.stopOnError({
            name: name,
            error: error,
            attributes: attributes
        });
        else experienceTracker.succeed({
            name: name,
            attributes: attributes
        });
    }, [
        experienceTracker,
        name,
        attributes,
        error
    ]);
    return null;
};
module.exports["ExperienceStop"] = $1aeb691895c5954d$export$85823f26dca064c3;

});

parcelRegister("dYcT6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $601vk = parcelRequire("601vk");

const $2e3f617799d734b5$var$EditorFlagsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    showEditorFlag: ()=>{}
});
const $2e3f617799d734b5$export$ad7226c60a7baa4f = ({ contentId: contentId, children: children })=>{
    const [flag, setFlag] = (0, $42omo.useState)(undefined);
    const showEditorFlag = (0, $42omo.useCallback)((flagData)=>{
        setFlag(flagData);
    }, [
        setFlag
    ]);
    // memoize to return the same reference to object and prevent render of multiple error flag with the same message
    const errorData = (0, $42omo.useMemo)(()=>flag?.errorName ? {
            [flag.errorName]: true
        } : undefined, [
        flag
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>{
        return {
            showEditorFlag: showEditorFlag
        };
    }, [
        showEditorFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2e3f617799d734b5$var$EditorFlagsContext.Provider, {
        value: contextValue
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $601vk.EditorErrorFlags), {
        contentId: contentId,
        statusCode: flag?.statusCode,
        errorData: errorData,
        lastPublisher: flag?.lastPublisher,
        collabService: flag?.collabService,
        isUnpublishedDraft: flag?.isUnpublishedDraft
    }));
};
function $2e3f617799d734b5$export$5368f855bc23a165(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2e3f617799d734b5$export$ad7226c60a7baa4f, {
            contentId: props.contentId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, props));
}
const $2e3f617799d734b5$export$32aceb9a79692418 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($2e3f617799d734b5$var$EditorFlagsContext);
};
module.exports["withEditorFlagsContext"] = $2e3f617799d734b5$export$5368f855bc23a165;
module.exports["useEditorFlagsContext"] = $2e3f617799d734b5$export$32aceb9a79692418;

});

parcelRegister("jv3O2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $jhwJP = parcelRequire("jhwJP");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $de2j9 = parcelRequire("de2j9");


var $ep3mz = parcelRequire("ep3mz");

const $a23dc1f066cda204$var$i18nBase = (0, $cgtv4.defineMessages)({
    flagTitle: {
        id: "editor-flags.convert-to-live-page-flag.flagTitle",
        defaultMessage: "This page was switched to a live page"
    },
    switcherFlagTitle: {
        id: "editor-flags.convert-to-live-page-flag.switcherFlagTitle",
        defaultMessage: "You\u2019ve switched to a live page"
    },
    flagBody: {
        id: "editor-flags.convert-to-live-page-flag.flagBody",
        defaultMessage: "Updates to this page will now be instant and visible in real time."
    },
    findOutMore: {
        id: "editor-flags.convert-to-live-page-flag.findOutMore",
        defaultMessage: "Find out more"
    },
    reloadButton: {
        id: "editor-flags.convert-to-live-page-flag.reloadButton",
        defaultMessage: "Reload"
    }
});
const $a23dc1f066cda204$var$i18nLiveDocs = (0, $cgtv4.defineMessages)({
    flagTitle: {
        id: "editor-flags.convert-to-live-page-flag.flagTitle.livedocs",
        defaultMessage: "This page was converted to a live doc"
    },
    switcherFlagTitle: {
        id: "editor-flags.convert-to-live-page-flag.switcherFlagTitle.livedocs",
        defaultMessage: "You\u2019ve converted to a live doc"
    },
    flagBody: {
        id: "editor-flags.convert-to-live-page-flag.flagBody.livedocs",
        defaultMessage: "Updates to this doc will now be instant and visible in real time."
    },
    findOutMore: {
        id: "editor-flags.convert-to-live-page-flag.findOutMore.livedocs",
        defaultMessage: "Find out more about live docs"
    }
});
const $a23dc1f066cda204$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($a23dc1f066cda204$var$i18nBase, $a23dc1f066cda204$var$i18nLiveDocs);
const $a23dc1f066cda204$var$LEARN_MORE_URL = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $a23dc1f066cda204$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME = 11000;
const $a23dc1f066cda204$export$cb5a789d90de377 = ({ flags: flags })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const intl = (0, $8C5kA.default)();
    const { replace: replace } = (0, $dPJCf.useRouteActions)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const handleOnClick = (0, $42omo.useCallback)(()=>{
        const livePageLink = (0, $1NBp8.VIEW_PAGE).toUrl({
            spaceKey: spaceKey,
            contentId: contentId
        });
        return isOnEditRoute ? replace(livePageLink) : window.location.reload();
    }, [
        isOnEditRoute,
        replace,
        spaceKey,
        contentId
    ]);
    return (0, $42omo.useCallback)(async ({ converterWasCurrentUser: converterWasCurrentUser })=>{
        const successFlag = await flags.showFlag({
            title: converterWasCurrentUser ? intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.switcherFlagTitle) : intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.flagTitle),
            description: intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.flagBody),
            type: 'success',
            id: 'convert-to-live-page-flag',
            close: 'never',
            // Needed to bypass the flags.hideAllFlags() call in EditorFlags.tsx on editor unmount.
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                        "data-testid": "reload-button"
                    }, intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.reloadButton)),
                    onClick: handleOnClick
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                        "data-testid": "find-out-more-button"
                    }, intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.findOutMore)),
                    onClick: ()=>window.open($a23dc1f066cda204$var$LEARN_MORE_URL, '_blank')
                }
            ]
        });
        // We don't want to auto-close the flag when a different user converts the page,
        // because there's no auto-redirect, so the user must click "Reload" in the flag to continue.
        if (converterWasCurrentUser) // Manually set a timeout so the flag auto-closes after the page transition completes.
        setTimeout(()=>flags.hideFlag(successFlag.id), $a23dc1f066cda204$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME);
    }, [
        intl,
        flags,
        handleOnClick
    ]);
};
module.exports["useShowConvertToLivePageFlag"] = $a23dc1f066cda204$export$cb5a789d90de377;

});

parcelRegister("hwWwS", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $9b64448510e1eff4$export$3c29cca421979b0e = (coordinationClient, messageId)=>{
    const [started, setStarted] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        (async ()=>{
            try {
                const started = await coordinationClient.start(messageId);
                if (started) setStarted(true);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to start flow message ${messageId}. ${err}`);
            }
        })();
    }, [
        coordinationClient,
        messageId
    ]);
    const stop = (0, $42omo.useCallback)(async (force)=>{
        if (!force && !started) return;
        try {
            await coordinationClient.stop(messageId);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to stop flow message ${messageId}. ${err}`);
        }
    }, [
        started,
        coordinationClient,
        messageId
    ]);
    return [
        started,
        stop
    ];
};
module.exports["useCoordination"] = $9b64448510e1eff4$export$3c29cca421979b0e;

});

parcelRegister("7rus4", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8JuIs = parcelRequire("8JuIs");


var $44RZm = parcelRequire("44RZm");


var $hnmbx = parcelRequire("hnmbx");

const $e8ee834aaf2971c0$var$SmartUserPickerWithIntlProvider = (props)=>{
    const ufoId = props.inputId || props.fieldId;
    (0, $hnmbx.useUFOConcurrentExperience)((0, $hnmbx.smartUserPickerRenderedUfoExperience), ufoId);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnmbx.UfoErrorBoundary), {
        id: ufoId,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $44RZm.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8JuIs.SmartUserPicker), {
                ...props
            })
        })
    });
};
var $e8ee834aaf2971c0$export$2e2bcd8739ae039 = $e8ee834aaf2971c0$var$SmartUserPickerWithIntlProvider;
module.exports["default"] = $e8ee834aaf2971c0$export$2e2bcd8739ae039;

});

parcelRegister("8JuIs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");


var $dQl1W = parcelRequire("dQl1W");


var $1DWH0 = parcelRequire("1DWH0");


var $2XqLN = parcelRequire("2XqLN");


var $gmMgo = parcelRequire("gmMgo");


var $28cxD = parcelRequire("28cxD");


var $kSKAi = parcelRequire("kSKAi");

var $6O3OC = parcelRequire("6O3OC");

var $9xsgQ = parcelRequire("9xsgQ");


var $dh538 = parcelRequire("dh538");


var $8CB5E = parcelRequire("8CB5E");


var $44RZm = parcelRequire("44RZm");


var $b4tkb = parcelRequire("b4tkb");


var $5kTPO = parcelRequire("5kTPO");

var $52K9w = parcelRequire("52K9w");


var $hnmbx = parcelRequire("hnmbx");

const $40c1c58d6de383a6$var$DEFAULT_DEBOUNCE_TIME_MS = 150;
const $40c1c58d6de383a6$var$ufoEndStateConfig = (fieldId)=>{
    return {
        metadata: {
            contextType: fieldId
        }
    };
};
const $40c1c58d6de383a6$var$hasContextChanged = (oldContext, newContext)=>oldContext.siteId !== newContext.siteId || oldContext.orgId !== newContext.orgId || oldContext.productKey !== newContext.productKey || oldContext.principalId !== newContext.principalId || oldContext.containerId !== newContext.containerId || oldContext.objectId !== newContext.objectId || oldContext.childObjectId !== newContext.childObjectId;
const $40c1c58d6de383a6$var$stringContains = (str, substr)=>{
    if (str === null || str === undefined) return false;
    if (substr === null || substr === '' || substr === undefined) return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $40c1c58d6de383a6$var$getUsersForAnalytics = (users)=>(users || []).map(({ id: id, type: type })=>({
            id: id,
            type: type
        }));
const $40c1c58d6de383a6$var$checkIf500Event = (statusCode)=>500 <= statusCode && statusCode < 600;
const $40c1c58d6de383a6$var$isEmailQuery = (query)=>{
    return (0, $9xsgQ.isValidEmail)(query.trim()) === 'VALID';
};
class $40c1c58d6de383a6$export$9b9bd453d1d4e4ce extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    async componentDidMount() {
        try {
            const value = await (0, $52K9w.default)(this.props.baseUrl, this.props.defaultValue, this.props.productKey, this.props.siteId);
            this.setState({
                defaultValue: value
            });
        } catch (e) {
            const defaultValue = await (this.props.onValueError ? this.props.onValueError(e, this.props.defaultValue) || Promise.resolve([]) : Promise.resolve([]));
            this.setState({
                defaultValue: defaultValue
            });
        }
        const { prefetch: prefetch } = this.props;
        if (prefetch) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const sessionId = (0, $dQl1W.v4)();
            this.fireEvent((0, $8CB5E.mountedWithPrefetchEvent), {
                sessionId: sessionId
            });
            this.setState({
                sessionId: sessionId
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if ($40c1c58d6de383a6$var$hasContextChanged(prevProps, this.props) || this.props.fieldId !== prevProps.fieldId) this.setState({
            users: []
        });
        if ((this.state.sessionId !== prevState.sessionId || this.state.query !== prevState.query) && (this.state.query !== '' || !this.props.bootstrapOptions)) this.getUsers();
        else if (!this.state.closed && !this.state.loading) // If the component has rendered (including its dropdown list) and it
        // is not loading anything further, send the success UFO event
        {
            if (![
                (0, $28cxD.UFOExperienceState).FAILED.id,
                (0, $28cxD.UFOExperienceState).SUCCEEDED.id,
                (0, $28cxD.UFOExperienceState).ABORTED.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success($40c1c58d6de383a6$var$ufoEndStateConfig(this.props.fieldId));
        }
    }
    render() {
        const { allowEmail: allowEmail, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, ...restProps } = this.props;
        // Determine whether to allow email selection based on allowEmailSelectionWhenEmailMatched, if needed
        let shouldAllowEmail = allowEmail;
        if (allowEmail && enableEmailSearch && !allowEmailSelectionWhenEmailMatched) {
            // Only allow email selection if we're in an email search that found no matches
            const isCurrentQueryEmail = $40c1c58d6de383a6$var$isEmailQuery(this.state.query);
            shouldAllowEmail = !isCurrentQueryEmail || !this.lastEmailSearchFoundMatches;
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $44RZm.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kSKAi.UserPicker), {
                ...restProps,
                allowEmail: shouldAllowEmail,
                onInputChange: this.onInputChange,
                onBlur: this.onBlur,
                onFocus: this.onFocus,
                defaultValue: this.state.defaultValue,
                isLoading: this.props.isLoading || this.state.loading && !this.state.closed && (!this.props.bootstrapOptions || this.state.query !== ''),
                options: this.filterUsers(),
                menuIsOpen: this.props.menuIsOpen
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {
            users: [],
            loading: false,
            closed: true,
            query: '',
            defaultValue: [],
            bootstrapOptions: []
        };
        // Track if the last search was an email search that found matches
        this.lastEmailSearchFoundMatches = false;
        this.optionsShownUfoExperienceInstance = void 0;
        this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $28cxD.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        };
        this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        };
        this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $8CB5E.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, ...args))(createAnalyticsEvent);
        };
        this.filterOptions = (users, query, propFilterOptions)=>propFilterOptions ? propFilterOptions(users, query) : users;
        this.memoizedFilterOptions = (0, $2XqLN.default)(this.filterOptions);
        this.getUsers = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(async ()=>{
            const { query: query, sessionId: sessionId, closed: closed } = this.state;
            const { baseUrl: baseUrl, childObjectId: childObjectId, containerId: containerId, fieldId: fieldId, includeGroups: includeGroups, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, includeUsers: includeUsers, includeNonLicensedUsers: includeNonLicensedUsers, intl: intl, maxOptions: maxOptions, objectId: objectId, onEmpty: onEmpty, onError: onError, overrideByline: overrideByline, displayEmailInByline: displayEmailInByline, orgId: orgId, principalId: principalId, productAttributes: productAttributes, productKey: productKey, searchQueryFilter: searchQueryFilter, siteId: siteId, transformOptions: transformOptions, userResolvers: userResolvers, enableEmailSearch: enableEmailSearch } = this.props;
            const maxNumberOfResults = maxOptions || 100;
            const startTime = window.performance.now();
            // Check if this is an email search
            const isEmail = enableEmailSearch && $40c1c58d6de383a6$var$isEmailQuery(query);
            const recommendationsRequest = {
                baseUrl: baseUrl,
                context: {
                    containerId: containerId,
                    contextType: fieldId,
                    objectId: objectId,
                    principalId: principalId,
                    productKey: productKey,
                    siteId: siteId,
                    organizationId: orgId,
                    childObjectId: childObjectId,
                    sessionId: sessionId,
                    productAttributes: productAttributes
                },
                includeUsers: includeUsers,
                includeGroups: // For email searches, disable groups and teams
                includeGroups,
                includeTeams: includeTeams,
                includeNonLicensedUsers: includeNonLicensedUsers,
                maxNumberOfResults: maxNumberOfResults,
                query: query,
                searchEmail: isEmail,
                /*
        	For email-based searches, we have decided to filter out apps.
        	Also - because the other 2 filters ((NOT not_mentionable:true) AND (account_status:active)) are included
        	when filter is empty, they have been added here to maintain consistency.
        		Further ref: https://developer.atlassian.com/platform/user-recommendations/guides/frequently-asked-questions/#filter-behavior
         */ searchQueryFilter: isEmail && !searchQueryFilter ? '(NOT not_mentionable:true) AND (account_status:active) AND (NOT account_type:app)' : searchQueryFilter
            };
            try {
                const { query: query } = this.state;
                this.fireEvent((0, $8CB5E.requestUsersEvent));
                let recommendedUsers;
                if ((0, $dh538.fg)('twcg-444-invite-usd-improvements-m2-gate')) {
                    const userRecommendationsPromise = (0, $5kTPO.default)(recommendationsRequest, intl);
                    const userResolversPromises = (userResolvers ?? []).map((resolver)=>resolver(query).catch((error)=>{
                            this.fireEvent((0, $8CB5E.failedUserResolversEvent), {
                                resolverName: resolver.name,
                                error: error
                            });
                            return [];
                        }));
                    const [mainRecommendations, ...userResolverResults] = await Promise.all([
                        userRecommendationsPromise,
                        ...userResolversPromises
                    ]);
                    recommendedUsers = [
                        mainRecommendations,
                        ...userResolverResults
                    ].flat();
                } else recommendedUsers = await (0, $5kTPO.default)(recommendationsRequest, intl);
                if (overrideByline) {
                    for (let option of recommendedUsers)if ((0, $6O3OC.isUser)(option) || (0, $6O3OC.isExternalUser)(option) || (0, $6O3OC.isTeam)(option)) option.byline = overrideByline(option);
                }
                if (displayEmailInByline) {
                    for (let option of recommendedUsers)if ((0, $6O3OC.isUser)(option) || (0, $6O3OC.isExternalUser)(option)) {
                        if (option.userType === (0, $b4tkb.UserEntityType).DEFAULT || option.userType === (0, $b4tkb.UserEntityType).CUSTOMER) // Respect existing byline if present
                        {
                            if (option.email && !option.byline) option.byline = option.email;
                        }
                    }
                }
                if (includeTeamsUpdates) {
                    for (let option of recommendedUsers)if ((0, $6O3OC.isGroup)(option) || (0, $6O3OC.isTeam)(option)) option.includeTeamsUpdates = includeTeamsUpdates;
                }
                // Track if email search found matches for conditional allowEmail logic
                if (isEmail) this.lastEmailSearchFoundMatches = recommendedUsers.length > 0;
                else this.lastEmailSearchFoundMatches = false;
                const elapsedTimeMilli = window.performance.now() - startTime;
                const transformedOptions = transformOptions ? await transformOptions(recommendedUsers, query) : recommendedUsers;
                const displayedUsers = transformedOptions.length === 0 && onEmpty ? await onEmpty(query) ?? [] : transformedOptions;
                this.setState((state)=>{
                    const applicable = state.query === query;
                    const users = applicable ? displayedUsers : state.users;
                    const loading = !applicable;
                    this.fireEvent((0, $8CB5E.successfulRequestUsersEvent), {
                        users: $40c1c58d6de383a6$var$getUsersForAnalytics(recommendedUsers),
                        elapsedTimeMilli: elapsedTimeMilli,
                        displayedUsers: $40c1c58d6de383a6$var$getUsersForAnalytics(displayedUsers),
                        productAttributes: productAttributes,
                        applicable: applicable,
                        ...(0, $dh538.fg)('twcg-444-invite-usd-improvements-m2-gate') && {
                            userResolvers: Array.isArray(userResolvers) ? userResolvers.map((resolver)=>resolver.name) : []
                        }
                    });
                    return {
                        users: users,
                        loading: loading
                    };
                });
            } catch (e) {
                const is5xxEvent = $40c1c58d6de383a6$var$checkIf500Event(e.statusCode);
                if (!closed && !onError && is5xxEvent) // If the user lookup fails while the menu is open, and the consumer is not providing a
                // fallback data source via the onError prop, then send UFO failure
                this.optionsShownUfoExperienceInstance.failure($40c1c58d6de383a6$var$ufoEndStateConfig(this.props.fieldId));
                this.setState({
                    users: []
                });
                let onErrorProducedError = false;
                let defaultUsers = [];
                try {
                    defaultUsers = onError ? await onError(e, recommendationsRequest) || [] : [];
                } catch (error) {
                    onErrorProducedError = true;
                }
                if (onErrorProducedError && is5xxEvent) // Log error from fallback data source `onError` to UFO
                this.optionsShownUfoExperienceInstance.failure($40c1c58d6de383a6$var$ufoEndStateConfig(this.props.fieldId));
                if (!is5xxEvent && (!onError && !closed || onErrorProducedError)) this.abortOptionsShownUfoExperience();
                this.setState({
                    users: defaultUsers,
                    loading: false
                });
                const elapsedTimeMilli = window.performance.now() - startTime;
                this.fireEvent((0, $8CB5E.failedRequestUsersEvent), {
                    elapsedTimeMilli: elapsedTimeMilli,
                    productAttributes: productAttributes
                });
            }
        }, this.props.debounceTime ?? 0);
        this.onInputChange = (newQuery, sessionId)=>{
            const query = newQuery || '';
            const { closed: closed } = this.state;
            if (query === this.state.query) return;
            if (!closed) {
                // If the input has been typed into and the dropdown has not been closed
                // (i.e. input blurred) then start the UFO timer.
                // If there's a previous UFO timer running for the same "options shown" experience,
                // it will be aborted first.
                this.startOptionsShownUfoExperience();
                this.setState({
                    loading: true,
                    query: query,
                    sessionId: sessionId
                });
                if (this.props.onInputChange) this.props.onInputChange(query, sessionId);
            }
        };
        this.filterUsers = ()=>{
            const { loading: loading, users: users, query: query } = this.state;
            const filteredUsers = this.memoizedFilterOptions(users, query, this.props.filterOptions);
            //If bootstrapOptions have been passed in and it is bootstrap
            if (this.props.bootstrapOptions && this.props.bootstrapOptions.length !== 0 && query === '') {
                const bootstrapFilteredUsers = this.memoizedFilterOptions(this.props.bootstrapOptions, query, this.props.filterOptions);
                this.fireEvent((0, $8CB5E.filterUsersEvent), {
                    filtered: $40c1c58d6de383a6$var$getUsersForAnalytics(bootstrapFilteredUsers),
                    all: $40c1c58d6de383a6$var$getUsersForAnalytics(this.props.bootstrapOptions)
                });
                return bootstrapFilteredUsers;
            }
            // while when not loading just return already filtered result from server.
            if (!loading) return filteredUsers;
            const queryFilteredUsers = filteredUsers.filter((user)=>$40c1c58d6de383a6$var$stringContains(user.name, query));
            this.fireEvent((0, $8CB5E.filterUsersEvent), {
                filtered: $40c1c58d6de383a6$var$getUsersForAnalytics(queryFilteredUsers),
                all: $40c1c58d6de383a6$var$getUsersForAnalytics(users)
            });
            // when loading filter previous result.
            return filteredUsers;
        };
        this.onFocus = (sessionId)=>{
            const state = {
                closed: false
            };
            this.startOptionsShownUfoExperience();
            if (this.state.users.length === 0) {
                state.sessionId = sessionId;
                state.loading = true;
            } else this.fireEvent((0, $8CB5E.preparedUsersLoadedEvent), {
                users: $40c1c58d6de383a6$var$getUsersForAnalytics(this.state.users),
                preparedSessionId: this.state.sessionId,
                sessionId: sessionId
            });
            this.setState((currentState)=>({
                    ...currentState,
                    ...state
                }));
            if (this.props.onFocus) this.props.onFocus(sessionId);
        };
        this.onBlur = (sessionId)=>{
            this.getUsers.cancel();
            this.abortOptionsShownUfoExperience();
            // clear old users if query is populated so that on refocus,
            // the old list is not shown
            const users = this.state.query.length === 0 ? this.state.users : [];
            this.setState({
                loading: false,
                closed: true,
                users: users
            });
            if (this.props.onBlur) this.props.onBlur(sessionId);
        };
        this.optionsShownUfoExperienceInstance = (0, $hnmbx.smartUserPickerOptionsShownUfoExperience).getInstance(props.inputId || props.fieldId);
    }
}
// TODO: Smart User picker team will have to add a type annotation here
$40c1c58d6de383a6$export$9b9bd453d1d4e4ce.defaultProps = {
    baseUrl: '',
    includeUsers: true,
    includeGroups: false,
    includeTeams: false,
    includeTeamsUpdates: false,
    includeNonLicensedUsers: false,
    displayEmailInByline: false,
    prefetch: false,
    principalId: 'Context',
    debounceTime: $40c1c58d6de383a6$var$DEFAULT_DEBOUNCE_TIME_MS,
    userResolvers: [],
    enableEmailSearch: false,
    allowEmailSelectionWhenEmailMatched: true
};
const $40c1c58d6de383a6$export$9eedb6e5d313efdb = (0, $1DWH0.default)()((0, $gmMgo.default)($40c1c58d6de383a6$export$9b9bd453d1d4e4ce));
module.exports["SmartUserPicker"] = $40c1c58d6de383a6$export$9eedb6e5d313efdb;

});

parcelRegister("8CB5E", function(module, exports) {

var $eWRwJ = parcelRequire("eWRwJ");


var $dQl1W = parcelRequire("dQl1W");

const $652153700385f927$var$packageName = "platform-pkg";
const $652153700385f927$var$packageVersion = "0.0.0-use.local";
const $652153700385f927$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $dQl1W.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $652153700385f927$export$53eef0dcd9611650 = (0, $eWRwJ.default)('fabric-elements');
const $652153700385f927$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $652153700385f927$var$packageName,
            packageVersion: $652153700385f927$var$packageVersion,
            ...attributes
        }
    });
const $652153700385f927$var$createDefaultSmartPickerAttributes = (props, state)=>{
    const { fieldId: fieldId, objectId: objectId, containerId: containerId, childObjectId: childObjectId, prefetch: prefetch, maxOptions: maxOptions, includeTeams: includeTeams, productKey: productKey, principalId: principalId, siteId: siteId, orgId: orgId, filterOptions: filterOptions } = props;
    const { sessionId: sessionId, query: query } = state;
    const maxNumberOfResults = maxOptions || 100;
    return {
        context: fieldId,
        childObjectId: childObjectId,
        containerId: containerId,
        hasFilterOptions: Boolean(filterOptions),
        includeTeams: includeTeams,
        maxNumberOfResults: maxNumberOfResults,
        objectId: objectId,
        prefetch: prefetch,
        principalId: principalId,
        productKey: productKey,
        queryLength: (query || '').length,
        siteId: siteId,
        orgId: orgId,
        sessionId: sessionId
    };
};
const $652153700385f927$var$createSmartUserPickerEvent = (action, actionSubect, attributes = {})=>({
        source: 'smart-user-picker',
        ...$652153700385f927$var$createEvent('operational', action, actionSubect, attributes)
    });
const $652153700385f927$export$185f4c3d9b7ef9bf = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('loaded', 'preparedUsers', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$9cfb4251e50d7b91 = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('mounted', 'prefetch', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$fbba77127d7cb173 = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('filtered', 'users', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$1762ed8845ff2d9b = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('requested', 'users', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$bfc020018aa738d0 = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('successful', 'usersRequest', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$738aca68b593db8e = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('failed', 'usersRequest', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$b9358131e14a4b0b = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('failed', 'userResolversRequest', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
module.exports["createAndFireEventInElementsChannel"] = $652153700385f927$export$53eef0dcd9611650;
module.exports["preparedUsersLoadedEvent"] = $652153700385f927$export$185f4c3d9b7ef9bf;
module.exports["mountedWithPrefetchEvent"] = $652153700385f927$export$9cfb4251e50d7b91;
module.exports["filterUsersEvent"] = $652153700385f927$export$fbba77127d7cb173;
module.exports["requestUsersEvent"] = $652153700385f927$export$1762ed8845ff2d9b;
module.exports["successfulRequestUsersEvent"] = $652153700385f927$export$bfc020018aa738d0;
module.exports["failedRequestUsersEvent"] = $652153700385f927$export$738aca68b593db8e;
module.exports["failedUserResolversEvent"] = $652153700385f927$export$b9358131e14a4b0b;

});

parcelRegister("44RZm", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc4fb65506569ed6$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");

var $1e2E5 = parcelRequire("1e2E5");


var $lRpQD = parcelRequire("lRpQD");

const $bc4fb65506569ed6$var$EMPTY = {};
const $bc4fb65506569ed6$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState($bc4fb65506569ed6$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        let aborted = false;
        setMessages($bc4fb65506569ed6$var$EMPTY);
        (0, $lRpQD.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $bc4fb65506569ed6$var$MessagesIntlProvider = (props)=>{
    const { intl: intl, children: children } = props;
    const messages = $bc4fb65506569ed6$var$useI18n(intl.locale);
    const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $bc4fb65506569ed6$export$2e2bcd8739ae039 = (0, $gmMgo.default)($bc4fb65506569ed6$var$MessagesIntlProvider);

});

parcelRegister("lRpQD", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $c819b58c07849348$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("bTsn1")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("6GCvk")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("aVRkS")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("9RUlw")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("9qWAB")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("hwi20")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("ffmF0")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("7akr7")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("dG5bn")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("ixFnS")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("b4pNT")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("jY0MO")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("OdTh3")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("9xDn8")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("edhsD")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("6HDVJ")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("a1EUA")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("6eF92")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("e84Bi")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("i6OJ2")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("b2Ob5")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("epyll")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("87x5R")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("gKeCQ")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("ViznQ")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("gRnrF")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("fTMVb")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("5RDfj")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("g6dca")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $c819b58c07849348$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("9RUlw")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $c819b58c07849348$export$d0a3169680473b6c;

});

parcelRegister("bTsn1", function(module, exports) {

let $8a8ad67e7884d3ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a8ad67e7884d3ee$var$load("9J4KV").then(()=>parcelRequire('cn04M'));

});

parcelRegister("6GCvk", function(module, exports) {

let $4de488764c6cfa0a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4de488764c6cfa0a$var$load("8Y9JE").then(()=>parcelRequire('1zktf'));

});

parcelRegister("aVRkS", function(module, exports) {

let $7f58999a79e6349b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f58999a79e6349b$var$load("gWrRN").then(()=>parcelRequire('8wiEy'));

});

parcelRegister("9RUlw", function(module, exports) {

let $72f4c575475b8ff2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $72f4c575475b8ff2$var$load("irKcy").then(()=>parcelRequire('gOk31'));

});

parcelRegister("9qWAB", function(module, exports) {

let $6de3fd6373f80610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6de3fd6373f80610$var$load("1aghR").then(()=>parcelRequire('fy2oQ'));

});

parcelRegister("hwi20", function(module, exports) {

let $cc13697e056477b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cc13697e056477b4$var$load("11Khz").then(()=>parcelRequire('5oLnX'));

});

parcelRegister("ffmF0", function(module, exports) {

let $b199d5a16bac3489$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b199d5a16bac3489$var$load("ap0LY").then(()=>parcelRequire('lsKPD'));

});

parcelRegister("7akr7", function(module, exports) {

let $537951d668c4233a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $537951d668c4233a$var$load("34Ma8").then(()=>parcelRequire('qBAp9'));

});

parcelRegister("dG5bn", function(module, exports) {

let $9f5337b8d9e430bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9f5337b8d9e430bb$var$load("lBwDa").then(()=>parcelRequire('iwM0U'));

});

parcelRegister("ixFnS", function(module, exports) {

let $d7fb6910ad50dffa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d7fb6910ad50dffa$var$load("32Pvr").then(()=>parcelRequire('emQB1'));

});

parcelRegister("b4pNT", function(module, exports) {

let $80f415843c58387f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80f415843c58387f$var$load("b7bFd").then(()=>parcelRequire('gsrSx'));

});

parcelRegister("jY0MO", function(module, exports) {

let $e8943b15c1095f0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e8943b15c1095f0b$var$load("6h8Ae").then(()=>parcelRequire('fy2dB'));

});

parcelRegister("OdTh3", function(module, exports) {

let $096f71fe6a133344$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $096f71fe6a133344$var$load("dW8Ws").then(()=>parcelRequire('gaGnN'));

});

parcelRegister("9xDn8", function(module, exports) {

let $6f25bca05c93306d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6f25bca05c93306d$var$load("fJZdm").then(()=>parcelRequire('h47Xp'));

});

parcelRegister("edhsD", function(module, exports) {

let $a58fd2ef4859e4c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a58fd2ef4859e4c2$var$load("kfTIE").then(()=>parcelRequire('kPwYW'));

});

parcelRegister("6HDVJ", function(module, exports) {

let $4e15bb82c38bbb9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e15bb82c38bbb9b$var$load("b8M9e").then(()=>parcelRequire('2ghCe'));

});

parcelRegister("a1EUA", function(module, exports) {

let $74c9bb98590c44dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74c9bb98590c44dc$var$load("jMchi").then(()=>parcelRequire('5Dvg5'));

});

parcelRegister("6eF92", function(module, exports) {

let $48a3f75c40936ce0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48a3f75c40936ce0$var$load("2xsmF").then(()=>parcelRequire('7JChl'));

});

parcelRegister("e84Bi", function(module, exports) {

let $a49561987d0955ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a49561987d0955ea$var$load("hHyCx").then(()=>parcelRequire('iYJQV'));

});

parcelRegister("i6OJ2", function(module, exports) {

let $d2f0228f4b9611b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d2f0228f4b9611b3$var$load("gw4Pw").then(()=>parcelRequire('8RsTW'));

});

parcelRegister("b2Ob5", function(module, exports) {

let $80a6cde59d00f370$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80a6cde59d00f370$var$load("8rhcn").then(()=>parcelRequire('cpBhe'));

});

parcelRegister("epyll", function(module, exports) {

let $a7de0a56fe167aca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7de0a56fe167aca$var$load("fh5Vk").then(()=>parcelRequire('1qgZZ'));

});

parcelRegister("87x5R", function(module, exports) {

let $5e98a5df9723a0ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5e98a5df9723a0ca$var$load("aP4eD").then(()=>parcelRequire('bkrR7'));

});

parcelRegister("gKeCQ", function(module, exports) {

let $c30c498bdaf770fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c30c498bdaf770fc$var$load("aJWAE").then(()=>parcelRequire('7VxDp'));

});

parcelRegister("ViznQ", function(module, exports) {

let $0ac3ba8ab2ce85a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ac3ba8ab2ce85a5$var$load("b96A2").then(()=>parcelRequire('aq3KW'));

});

parcelRegister("gRnrF", function(module, exports) {

let $c463c852d03859d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c463c852d03859d2$var$load("g0ukK").then(()=>parcelRequire('djjDV'));

});

parcelRegister("fTMVb", function(module, exports) {

let $b931f0d132593dec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b931f0d132593dec$var$load("8DuKk").then(()=>parcelRequire('7D0E8'));

});

parcelRegister("5RDfj", function(module, exports) {

let $4450586e03add784$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4450586e03add784$var$load("5aSRq").then(()=>parcelRequire('cU76k'));

});

parcelRegister("g6dca", function(module, exports) {

let $bb8771308e18862d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bb8771308e18862d$var$load("eQT38").then(()=>parcelRequire('5c5SM'));

});

parcelRegister("52K9w", function(module, exports) {

var $RMvle = parcelRequire("RMvle");


var $g2dtt = parcelRequire("g2dtt");


var $5tNjN = parcelRequire("5tNjN");


var $byRSb = parcelRequire("byRSb");


var $1h51z = parcelRequire("1h51z");

const $19437af1da52fb39$var$getHydratedUsersFromProducts = (request)=>{
    const url = `${(0, $g2dtt.config).getUsersServiceUrl(request.productKey, request.baseUrl)}`;
    let params = new URLSearchParams();
    request.accountIds.map((id)=>params.append('accountId', id));
    params.append('maxResults', '2000');
    return fetch(`${url}?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling users service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then(request.productKey === 'jira' ? $19437af1da52fb39$var$transformJiraUsers : $19437af1da52fb39$var$transformConfluenceUsers);
};
const $19437af1da52fb39$var$transformJiraUsers = (userResponse)=>userResponse.values.map($19437af1da52fb39$var$transformJiraUser).filter((user)=>!!user).map((user)=>user);
const $19437af1da52fb39$var$transformJiraUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $RMvle.UserType),
        avatarUrl: item.avatarUrls ? item.avatarUrls['16x16'] : '',
        name: item.displayName,
        email: item.emailAddress
    };
};
const $19437af1da52fb39$var$transformConfluenceUsers = (userResponse)=>userResponse.results.map($19437af1da52fb39$var$transformConfluenceUser).filter((user)=>!!user).map((user)=>user);
const $19437af1da52fb39$var$transformConfluenceUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $RMvle.UserType),
        avatarUrl: item.profilePicture ? item.profilePicture.path : '',
        name: item.publicName,
        email: item.email
    };
};
const $19437af1da52fb39$var$sortResults = (options, sortIds)=>{
    const resultsMap = new Map(options.map((option)=>[
            option && option.id,
            option
        ]));
    return sortIds.map((option)=>{
        const user = resultsMap.get(option.id);
        if (user) return user;
        return {
            id: option.id,
            type: option.type,
            name: (0, $1h51z.UNKNOWN)
        };
    });
};
const $19437af1da52fb39$var$isOptionData = (option)=>{
    return option.name !== undefined;
};
const $19437af1da52fb39$var$hydrateTeamIds = async (baseUrl, values, siteId)=>{
    if (values.length === 0) return [];
    const legionPromises = values.map((value)=>(0, $byRSb.default)({
            baseUrl: baseUrl,
            id: value.id,
            siteId: siteId
        }));
    return await Promise.all(legionPromises);
};
const $19437af1da52fb39$var$hydrateAccountIds = async (baseUrl, productKey, values)=>{
    if (values.length === 0) return [];
    const accountIds = values.map((val)=>val.id);
    //if we are not jira or confluence then use PRS platform hydration
    return productKey === 'jira' || productKey === 'confluence' ? await $19437af1da52fb39$var$getHydratedUsersFromProducts({
        baseUrl: baseUrl,
        productKey: productKey,
        accountIds: accountIds
    }) : await (0, $5tNjN.default)(baseUrl, accountIds);
};
async function $19437af1da52fb39$var$hydrateDefaultValues(baseUrl, value, productKey, siteId) {
    //return if no value
    if (!value || Array.isArray(value) && value.length === 0) return [];
    const values = Array.isArray(value) ? value : [
        value
    ];
    // return if all hydrated
    if (!values.some((val)=>!$19437af1da52fb39$var$isOptionData(val))) return value;
    const [hydratedUsers, hydratedTeams] = await Promise.all([
        $19437af1da52fb39$var$hydrateAccountIds(baseUrl, productKey, values.filter((val)=>!$19437af1da52fb39$var$isOptionData(val) && val.type === 'user')),
        $19437af1da52fb39$var$hydrateTeamIds(baseUrl, values.filter((val)=>!$19437af1da52fb39$var$isOptionData(val) && val.type === 'team'), siteId)
    ]);
    const hydratedOptions = values.filter((val)=>$19437af1da52fb39$var$isOptionData(val)).map((val)=>val).concat(hydratedUsers).concat(hydratedTeams);
    return $19437af1da52fb39$var$sortResults(hydratedOptions, values);
}
var $19437af1da52fb39$export$2e2bcd8739ae039 = $19437af1da52fb39$var$hydrateDefaultValues;
module.exports["default"] = $19437af1da52fb39$export$2e2bcd8739ae039;

});

parcelRegister("5tNjN", function(module, exports) {

var $1h51z = parcelRequire("1h51z");


var $5y06K = parcelRequire("5y06K");


var $g2dtt = parcelRequire("g2dtt");

/**
 * @param  {string} accountIds ids to hydrate
 * @return GraphQL Query
 */ const $26288bf672f514b3$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
      picture
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $26288bf672f514b3$var$makeRequest = async (url, accountIds)=>{
    const query = $26288bf672f514b3$var$buildUsersQuery(accountIds);
    return await (0, $5y06K.graphqlQuery)(url, query);
};
const $26288bf672f514b3$var$modifyResponse = (users)=>users.map(({ accountId: accountId, name: name, picture: picture })=>({
            avatarUrl: picture,
            id: accountId,
            name: name,
            type: 'user'
        }));
const $26288bf672f514b3$var$getHydratedUsers = (baseUrl, userIds)=>{
    const url = (0, $g2dtt.config).getGraphQLUrl(baseUrl);
    return new Promise((resolve)=>{
        $26288bf672f514b3$var$makeRequest(url, userIds).then((data)=>{
            resolve($26288bf672f514b3$var$modifyResponse(data.users));
        }).catch(()=>{
            // on network error, return original list with label 'Unknown'
            resolve(userIds.map((id)=>({
                    ...(0, $1h51z.UNKNOWN_USER),
                    id: id
                })));
        });
    });
};
var $26288bf672f514b3$export$2e2bcd8739ae039 = $26288bf672f514b3$var$getHydratedUsers;
module.exports["default"] = $26288bf672f514b3$export$2e2bcd8739ae039;

});

parcelRegister("1h51z", function(module, exports) {
const $690e1ddcc04ff137$export$78244dbb77cfa6b6 = 'Unknown';
const $690e1ddcc04ff137$export$d1f5101c0939e3fe = {
    id: $690e1ddcc04ff137$export$78244dbb77cfa6b6,
    name: $690e1ddcc04ff137$export$78244dbb77cfa6b6,
    type: 'user'
};
const $690e1ddcc04ff137$export$8144dcfc9025ca57 = {
    id: $690e1ddcc04ff137$export$78244dbb77cfa6b6,
    name: $690e1ddcc04ff137$export$78244dbb77cfa6b6,
    type: 'team'
};
module.exports["UNKNOWN"] = $690e1ddcc04ff137$export$78244dbb77cfa6b6;
module.exports["UNKNOWN_USER"] = $690e1ddcc04ff137$export$d1f5101c0939e3fe;
module.exports["UNKNOWN_TEAM"] = $690e1ddcc04ff137$export$8144dcfc9025ca57;

});

parcelRegister("5y06K", function(module, exports) {
const $7113235240a12c5e$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
function $7113235240a12c5e$export$74eb8d79ae3e02b5(serviceUrl, query) {
    const headers = $7113235240a12c5e$var$buildHeaders();
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}
module.exports["graphqlQuery"] = $7113235240a12c5e$export$74eb8d79ae3e02b5;

});

parcelRegister("byRSb", function(module, exports) {

var $g2dtt = parcelRequire("g2dtt");


var $1h51z = parcelRequire("1h51z");

const $5847a110ae2c5370$var$transformTeam = (team, id)=>{
    return {
        id: id,
        name: team.displayName,
        type: 'team',
        avatarUrl: team.smallAvatarImageUrl
    };
};
const $5847a110ae2c5370$var$hydrateTeamFromLegion = (request)=>{
    const url = (0, $g2dtt.config).getTeamsUrl(request.id, request.baseUrl, request.siteId);
    return fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>{
        return $5847a110ae2c5370$var$transformTeam(response, request.id);
    }).catch(()=>({
            ...(0, $1h51z.UNKNOWN_TEAM),
            id: request.id
        }));
};
var $5847a110ae2c5370$export$2e2bcd8739ae039 = $5847a110ae2c5370$var$hydrateTeamFromLegion;
module.exports["default"] = $5847a110ae2c5370$export$2e2bcd8739ae039;

});

parcelRegister("hnmbx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

var $28cxD = parcelRequire("28cxD");

const $06ae62c086839e8d$var$COMPONENT_NAME = 'smart-user-picker';
const $06ae62c086839e8d$export$df77da4c0210f1c1 = new (0, $9801n.ConcurrentExperience)('smart-user-picker-rendered', {
    platform: {
        component: $06ae62c086839e8d$var$COMPONENT_NAME
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
});
const $06ae62c086839e8d$export$a0e7cca3ab9586eb = new (0, $9801n.ConcurrentExperience)('smart-user-picker-options-shown', {
    platform: {
        component: $06ae62c086839e8d$var$COMPONENT_NAME
    },
    type: (0, $iqaft.ExperienceTypes).Operation,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
});
const $06ae62c086839e8d$export$e5e0512991825310 = (experience, id)=>{
    const experienceForId = experience.getInstance(id);
    // Equivalent to componentWillMount - replace with @atlaskit/ufo's
    // useUFOComponentExperience when it supports ConcurrentExperience.
    (0, $42omo.useState)(()=>{
        experienceForId.start();
    });
    // Replace with @atlaskit/ufo's <ExperienceSuccess> when it supports ConcurrentExperience
    (0, $42omo.useEffect)(()=>{
        if (experienceForId.state !== (0, $28cxD.UFOExperienceState)['FAILED']) experienceForId.success();
        return ()=>{
            if ([
                (0, $28cxD.UFOExperienceState)['STARTED'],
                (0, $28cxD.UFOExperienceState)['IN_PROGRESS']
            ].includes(experienceForId.state)) experienceForId.abort();
        };
    // We only want this useEffect to run once after component mount, so no deps are needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
class $06ae62c086839e8d$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch() {
        $06ae62c086839e8d$export$df77da4c0210f1c1.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["smartUserPickerRenderedUfoExperience"] = $06ae62c086839e8d$export$df77da4c0210f1c1;
module.exports["smartUserPickerOptionsShownUfoExperience"] = $06ae62c086839e8d$export$a0e7cca3ab9586eb;
module.exports["useUFOConcurrentExperience"] = $06ae62c086839e8d$export$e5e0512991825310;
module.exports["UfoErrorBoundary"] = $06ae62c086839e8d$export$5ef1c2550074a375;

});

parcelRegister("cl74W", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $3sFtD = parcelRequire("3sFtD");


var $hmuev = parcelRequire("hmuev");


var $eEA8O = parcelRequire("eEA8O");


var $7hXDW = parcelRequire("7hXDW");


var $inPa6 = parcelRequire("inPa6");


var $fxBfz = parcelRequire("fxBfz");


var $lsxnT = parcelRequire("lsxnT");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $hTxAd = parcelRequire("hTxAd");


var $fiFCv = parcelRequire("fiFCv");


var $5v7QA = parcelRequire("5v7QA");

const $6518ada37406f39b$var$insightMessageStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.300'
});
const $6518ada37406f39b$var$i18n = (0, $cgtv4.defineMessages)({
    successIconLabel: {
        id: "automation-discovery.global-public-link.success.icon.label",
        defaultMessage: "Success check icon"
    },
    modalCloseIconLabel: {
        id: "automation-discovery.global-public-link.modal.close.icon.label",
        defaultMessage: "Close icon for modal"
    }
});
const $6518ada37406f39b$var$BaseAutomationDiscoveryDialogComponent = ({ onClose: onClose, templateUrl: templateUrl, templateName: templateName, spaceKey: spaceKey, header: header, cta: cta, eventSourceName: eventSourceName, localStorageKey: localStorageKey, discoveryExperience: discoveryExperience, customBody: customBody, children: children, templateId: templateId = '', onDismiss: onDismiss = ()=>{}, onRedirectToRuleBuilder: onRedirectToRuleBuilder = ()=>{}, onCreateRuleSuccess: onCreateRuleSuccess = ()=>{}, onRuleCreateStart: onRuleCreateStart, onCreateRuleFail: onCreateRuleFail, disableCreateRule: disableCreateRule, testId: testId, insightMessage: insightMessage })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: discoveryExperience,
                source: eventSourceName
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        eventSourceName,
        discoveryExperience
    ]);
    const handleDismiss = ()=>{
        (0, $hTxAd.markDiscoveryExperienceAsSeen)(localStorageKey);
        onClose();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${discoveryExperience}Dismiss`,
                source: eventSourceName,
                attributes: {
                    spaceKey: spaceKey
                }
            }
        }).fire();
    };
    const handleProceed = ()=>{
        window.open(templateUrl, '_blank');
        (0, $hTxAd.markDiscoveryExperienceAsSeen)(localStorageKey);
        onClose();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${discoveryExperience}Proceed`,
                source: eventSourceName,
                attributes: {
                    spaceKey: spaceKey,
                    template: templateName
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: "small",
        onClose: onClose,
        testId: testId,
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "end",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $ecnYn.xcss)({
            padding: 'space.100',
            paddingRight: 'space.200'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        "aria-label": formatMessage((0, $5v7QA.meetingNotesI18n).modalCloseIconLabel),
        appearance: "link",
        onClick: onClose,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: "",
            color: "var(--ds-text-subtle, #505258)"
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        label: formatMessage($6518ada37406f39b$var$i18n.successIconLabel),
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "small"
    }, header)), customBody), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fiFCv.InContextAutomationPrompt), {
        ruleComponentAlignment: "stack",
        templateId: templateId,
        templateDescription: templateName,
        spaceKey: spaceKey,
        message: cta,
        insightMessage: insightMessage,
        handleRedirectToRuleBuilder: onRedirectToRuleBuilder,
        handleDismiss: onDismiss,
        handleRuleCreationSuccess: onCreateRuleSuccess,
        handleRuleCreationStart: onRuleCreateStart,
        handleRuleCreationFail: onCreateRuleFail,
        checkIsInContextRuleBuilderStateValid: ()=>true,
        automationDiscoveryParent: eventSourceName,
        displayMode: "modal",
        disableCreateRule: disableCreateRule
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        grow: "fill",
        space: "space.150",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $ecnYn.xcss)({
            padding: 'space.150',
            backgroundColor: 'color.background.accent.gray.subtlest'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "xsmall"
    }, cta)), insightMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $6518ada37406f39b$var$insightMessageStyles
    }, insightMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.200",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        onClick: handleDismiss,
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $5v7QA.commonI18n).dismiss)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        onClick: handleProceed,
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $5v7QA.commonI18n).showMeHow))))));
};
const $6518ada37406f39b$export$50558003331d128c = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).AUTOMATION_FOR_CONFLUENCE
})($6518ada37406f39b$var$BaseAutomationDiscoveryDialogComponent);
module.exports["BaseAutomationDiscoveryDialog"] = $6518ada37406f39b$export$50558003331d128c;

});

parcelRegister("hTxAd", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $tgs13 = parcelRequire("tgs13");

const $a5f7b05a2384a497$export$9f585226e9430b76 = (experienceKey)=>{
    (0, $17wUi.confluenceLocalStorageInstance).setItem(experienceKey, true, (0, $tgs13.TWENTY_EIGHT_DAYS_IN_SECONDS));
};
module.exports["markDiscoveryExperienceAsSeen"] = $a5f7b05a2384a497$export$9f585226e9430b76;

});

parcelRegister("tgs13", function(module, exports) {
const $2e9fe66aaea8de6a$export$f09b8e10e3913161 = 2419200;
const $2e9fe66aaea8de6a$export$885b9d72bc39ecdb = 2592000000;
const $2e9fe66aaea8de6a$export$6ec716a28918c083 = 31536000;
module.exports["TWENTY_EIGHT_DAYS_IN_SECONDS"] = $2e9fe66aaea8de6a$export$f09b8e10e3913161;
module.exports["THREE_HUNDRED_SIXTY_FIVE_DAYS_IN_SECONDS"] = $2e9fe66aaea8de6a$export$6ec716a28918c083;

});

parcelRegister("fiFCv", function(module, exports) {
/* InContextAutomationPrompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $cvXh8 = parcelRequire("cvXh8");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");

var $9YwaJ = parcelRequire("9YwaJ");


var $7hXDW = parcelRequire("7hXDW");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $fxBfz = parcelRequire("fxBfz");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $9KNO1 = parcelRequire("9KNO1");


var $d0Ide = parcelRequire("d0Ide");


var $2HPSp = parcelRequire("2HPSp");


var $5v7QA = parcelRequire("5v7QA");


var $5scZK = parcelRequire("5scZK");

const $3dbeeac5567d9c48$var$insightMessageStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.300'
});
const $3dbeeac5567d9c48$var$insightMessageInContextStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.300',
    marginTop: 'space.050'
});
const $3dbeeac5567d9c48$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    buildingRule: {
        id: "automation-discovery.common.building-rule",
        defaultMessage: "Building rule"
    },
    createRule: {
        id: "automation-discovery.common.create-rule",
        defaultMessage: "Turn on rule"
    },
    createRuleSuccess: {
        id: "automation-discovery.common.create-rule-success",
        defaultMessage: "Rule has been turned on"
    },
    viewRule: {
        id: "automation-discovery.common.view-rule",
        defaultMessage: "View rule"
    },
    editInRuleBuilder: {
        id: "automation-discovery.common.edit-in-rule-builder",
        defaultMessage: "Edit in rule builder"
    },
    errorFlagTitle: {
        id: "automation-discovery.common.error-flag.title",
        defaultMessage: "Failed to create rule"
    },
    errorFlagDescription: {
        id: "automation-discovery.common.error-flag.description",
        defaultMessage: "An unexpected error occurred while creating the rule."
    }
});
const $3dbeeac5567d9c48$var$ConditionalWrapper = ({ condition: condition, WrapperIfTrue: WrapperIfTrue, WrapperIfFalse: WrapperIfFalse, children: children })=>condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrapperIfTrue, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrapperIfFalse, null, children);
const $3dbeeac5567d9c48$var$StackWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, children);
const $3dbeeac5567d9c48$var$InlineWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        shouldWrap: true
    }, children);
const $3dbeeac5567d9c48$var$defaultInContextPromptContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.150',
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.small',
    marginBottom: 'space.200',
    marginRight: 'space.0',
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3dbeeac5567d9c48$var$BouncingDot = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _j7hqu8hp _5sag3sne _tip812c5 _1pgl6ui8 _xg4k6ebc _1lac188d",
            __cmplp.className
        ])
    });
});
const $3dbeeac5567d9c48$var$InContextRuleBuilder = ({ templateId: templateId, spaceKey: spaceKey, templateDescription: templateDescription, handleRedirectToRuleBuilder: handleRedirectToRuleBuilder, handleRuleCreationStart: handleRuleCreationStart, handleRuleCreationSuccess: handleRuleCreationSuccess, flags: flags, children: children, automationDiscoveryParent: automationDiscoveryParent, customContainerStyles: customContainerStyles, checkIsInContextRuleBuilderStateValid: checkIsInContextRuleBuilderStateValid, ruleComponentAlignment: ruleComponentAlignment = 'stack', displayMode: displayMode = 'in-context', handleRuleCreationFail: handleRuleCreationFail, disableCreateRule: disableCreateRule, handleDismiss: handleDismiss, message: message, insightMessage: insightMessage })=>{
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const { templateApiParameters: templateApiParameters } = (0, $42omo.useContext)((0, $2HPSp.InContextRuleBuilderContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey || undefined);
    const [createdRuleId, setCreatedRuleId] = (0, $42omo.useState)(null);
    const [displayPrompt, setShouldDisplayPrompt] = (0, $42omo.useState)(true);
    const [animationState, setAnimationState] = (0, $42omo.useState)(-1);
    const timeoutID = (0, $42omo.useRef)(null);
    const isAnimationFinished = animationState >= (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) + 1;
    const onCompleted = (result)=>{
        if (result?.experimentalCreateAutomationRuleFromTemplate?.ruleId) {
            handleRuleCreationSuccess();
            setCreatedRuleId(result.experimentalCreateAutomationRuleFromTemplate.ruleId);
        }
    };
    const onError = (err)=>{
        handleRuleCreationFail?.(err);
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.errorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.errorFlagDescription),
            isAutoDismiss: true
        });
    };
    const [createAutomationRuleFromTemplate, { data: data, loading: loading, error: mutationError }] = (0, $5scZK.useExperimentalCreateAutomationRuleFromTemplateMutation)({
        onCompleted: onCompleted,
        onError: onError
    });
    (0, $42omo.useEffect)(()=>{
        if (isAnimationFinished) {
            clearTimeout(timeoutID.current);
            timeoutID.current = null;
            return;
        } // Count up to the # of components in the rule we want to render
        if (!displayPrompt) timeoutID.current = setTimeout(()=>{
            setAnimationState((value)=>value + 1);
        }, 1000);
        return ()=>clearTimeout(timeoutID.current);
    }, [
        animationState,
        isAnimationFinished,
        displayPrompt
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: (0, $d0Ide.EventSourceName).IN_CONTEXT_RULE_BUILDER,
                source: (0, $d0Ide.EventSourceName).IN_CONTEXT_RULE_BUILDER,
                attributes: {
                    automationDiscoveryParent: automationDiscoveryParent
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        automationDiscoveryParent
    ]);
    const handleOnClickCreateRule = async ()=>{
        if (checkIsInContextRuleBuilderStateValid()) {
            handleRuleCreationStart?.(); // This is really fast in prod (no remote call)
            const automationStack = await (0, $9KNO1.getAutomationStack)(environment);
            const formattedParameters = Object.entries(templateApiParameters).map(([parameterName, parameterValue])=>({
                    name: parameterName,
                    type: parameterValue.type,
                    value: String(parameterValue.value)
                }));
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'automationDiscoveryInContextRuleBuilderTurnOn',
                    source: (0, $d0Ide.EventSourceName).IN_CONTEXT_RULE_BUILDER,
                    attributes: {
                        spaceKey: spaceKey,
                        automationDiscoveryParent: automationDiscoveryParent
                    }
                }
            }).fire();
            await createAutomationRuleFromTemplate({
                variables: {
                    templateId: templateId,
                    cloudId: cloudId,
                    automationStack: automationStack,
                    spaceId: spaceId,
                    parameters: formattedParameters
                }
            });
        }
    };
    const renderInContextActionButtons = ()=>{
        if (data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "link",
            href: `/wiki/spaces/${spaceKey}/settings/automation#/rule/${createdRuleId}`,
            target: "_blank",
            spacing: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.viewRule)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            ,
            xcss: (0, $ecnYn.xcss)({
                color: 'color.text.success'
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
            label: "",
            color: "var(--ds-icon-accent-green, #22A06B)",
            size: "small"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.createRuleSuccess)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: disableCreateRule ? 'primary' : 'link',
            onClick: ()=>{
                handleRedirectToRuleBuilder();
            },
            spacing: disableCreateRule ? 'compact' : 'none'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.editInRuleBuilder)), !disableCreateRule ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
            appearance: "primary",
            spacing: "compact",
            isLoading: loading,
            onClick: handleOnClickCreateRule
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.createRule)) : null);
    };
    if (displayPrompt) return displayMode === 'modal' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        grow: "fill",
        space: "space.150" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        ,
        xcss: (0, $ecnYn.xcss)({
            padding: 'space.150',
            backgroundColor: 'color.background.accent.gray.subtlest'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "xsmall"
    }, message)), insightMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3dbeeac5567d9c48$var$insightMessageStyles
    }, insightMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.200",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        onClick: handleDismiss,
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $5v7QA.commonI18n).dismiss)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        onClick: ()=>setShouldDisplayPrompt(false),
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $5v7QA.commonI18n).showMeHow)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    ), {
        xcss: (0, $ecnYn.xcss)({
            borderColor: 'color.border',
            borderStyle: 'solid',
            borderRadius: 'radius.large',
            borderWidth: 'border.width',
            backgroundColor: 'color.background.neutral',
            padding: 'space.200'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "xsmall"
    }, message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle-link",
        onClick: handleDismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $5v7QA.commonI18n).dismiss)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        onClick: ()=>setShouldDisplayPrompt(false),
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $5v7QA.commonI18n).showMeHow)))), insightMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3dbeeac5567d9c48$var$insightMessageInContextStyles
    }, insightMessage));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        grow: "fill",
        space: "space.150" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        ,
        xcss: [
            $3dbeeac5567d9c48$var$defaultInContextPromptContainerStyles,
            customContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.200",
        xcss: (0, $ecnYn.xcss)({
            width: '100%'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        spread: "space-between",
        space: "space.200",
        alignBlock: "center"
    }, isAnimationFinished ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "xsmall"
    }, templateDescription), displayMode === 'in-context' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.200"
    }, renderInContextActionButtons())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.buildingRule), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3dbeeac5567d9c48$var$BouncingDot, null, "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3dbeeac5567d9c48$var$BouncingDot, null, "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3dbeeac5567d9c48$var$BouncingDot, null, ".")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3dbeeac5567d9c48$var$ConditionalWrapper, {
        condition: ruleComponentAlignment === 'stack',
        WrapperIfTrue: $3dbeeac5567d9c48$var$StackWrapper,
        WrapperIfFalse: $3dbeeac5567d9c48$var$InlineWrapper
    }, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child, componentNumber)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
            isSkeleton: componentNumber === animationState,
            isHidden: componentNumber > animationState
        });
        return child;
    })), !!insightMessage && isAnimationFinished && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, insightMessage), isAnimationFinished && displayMode === 'modal' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "end",
        space: "space.200"
    }, renderInContextActionButtons())), mutationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: mutationError
    }));
};
const $3dbeeac5567d9c48$export$bff0256bf4beef8c = (0, $7aRa9.withFlags)((0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).AUTOMATION_FOR_CONFLUENCE
})($3dbeeac5567d9c48$var$InContextRuleBuilder));
module.exports["InContextAutomationPrompt"] = $3dbeeac5567d9c48$export$bff0256bf4beef8c;

});

parcelRegister("9KNO1", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");

/**
 * Here we will check if devWatch is running and if so, we will use the associated dev stack.
 */ const $0691681f8bad8323$var$getAutomationDevStackFromLocalServer = async ()=>{
    try {
        const devStackResponse = await (0, $f7B1p.cfetch)('https://localhost:8082/devStack.json', {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'omit'
        });
        const devStack = await devStackResponse.json();
        return devStack.name;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch dev stack from https://localhost:8082/devStack.json with error: ${e}`);
        return null;
    }
};
const $0691681f8bad8323$export$6123178d3f5fb24d = async (environment)=>{
    switch(environment){
        case 'DEVELOPMENT':
        case 'STAGING':
            return await $0691681f8bad8323$var$getAutomationDevStackFromLocalServer() || window.localStorage.getItem(`automationPlatform:automationStack`) || 'staging';
        default:
            return 'pro';
    }
};
module.exports["getAutomationStack"] = $0691681f8bad8323$export$6123178d3f5fb24d;

});

parcelRegister("d0Ide", function(module, exports) {
var $fe73de88bf54921d$export$288b04954abdcf5 = /*#__PURE__*/ function(EventSourceName) {
    EventSourceName["ADD_LABEL_TO_PAGE"] = "automationDiscoveryWhenLabelAddedToPage";
    EventSourceName["MEETING_NOTES"] = "automationDiscoveryWhenPublishingMeetingNotes";
    EventSourceName["ARCHIVE_PAGE"] = "automationDiscoveryWhenArchivingPage";
    EventSourceName["HOVER_OVER_PAGE_TITLE"] = "automationDiscoveryFromHoverOverPageTitle";
    EventSourceName["JIRA_LINK"] = "automationDiscoveryJiraLink";
    EventSourceName["MANUAL_TRIGGER"] = "automationDiscoveryManualTrigger";
    EventSourceName["MANUAL_TRIGGER_SMART_BUTTON"] = "automationDiscoveryManualTriggerSmartButton";
    EventSourceName["IN_CONTEXT_RULE_BUILDER"] = "automationDiscoveryInContextRuleBuilder";
    EventSourceName["VERIFED_CONTENT"] = "automationDiscoveryVerifiedContent";
    EventSourceName["BULK_ARCHIVE"] = "automationDiscoveryBulkArchive";
    EventSourceName["GLOBAL_PUBLIC_LINKS"] = "automationDiscoveryGlobalPermissions";
    EventSourceName["PAGE_PUBLIC_LINKS"] = "automationDiscoverPageShare";
    EventSourceName["BULK_ASSIGN"] = "automationDiscoverySpaceAssignedBulk";
    EventSourceName["SINGLE_ASSIGN"] = "automationDiscoverySpaceAssignedSingle";
    EventSourceName["DEFAULT_SPACE_ASSIGN"] = "automationDiscoveryDefaultSpaceAssigned";
    EventSourceName["WHITE_BOARDS"] = "automationDiscoveryPublishWhiteBoards";
    EventSourceName["SHARE_SLACK"] = "automationDiscoveryShareSlack";
    EventSourceName["BULK_CHANGE_OWNER"] = "automationDiscoveryBulkChangePageOwner";
    EventSourceName["PRODUCT_REQUIREMENTS"] = "automationDiscoveryProductRequirements";
    EventSourceName["FEEDBACK_ANALYSIS"] = "automationDiscoveryFeedbackAnalysis";
    EventSourceName["RELEASE_NOTES"] = "automationDiscoveryReleaseNotes";
    return EventSourceName;
}({});
module.exports["EventSourceName"] = $fe73de88bf54921d$export$288b04954abdcf5;

});

parcelRegister("2HPSp", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $02196f736713ab99$export$869e231d926edfce = /*#__PURE__*/ function(TemplateParameterTypeEnum) {
    TemplateParameterTypeEnum["TEXT"] = "TEXT";
    TemplateParameterTypeEnum["NUMBER"] = "NUMBER";
    TemplateParameterTypeEnum["BOOLEAN"] = "BOOLEAN";
    return TemplateParameterTypeEnum;
}({});
const $02196f736713ab99$var$defaultContext = {
    templateApiParameters: {},
    setParameterByKey: ()=>{},
    removeParameterByKey: ()=>{}
};
const $02196f736713ab99$export$b1e136c3301c05ad = /*#__PURE__*/ (0, $42omo.createContext)($02196f736713ab99$var$defaultContext);
const $02196f736713ab99$export$6cdc09e06812d6d1 = ({ children: children })=>{
    const [parameters, setParameters] = (0, $42omo.useState)({});
    const setParameterByKey = (0, $42omo.useCallback)((key, value)=>{
        setParameters((prev)=>({
                ...prev,
                [key]: value
            }));
    }, [
        setParameters
    ]);
    const removeParameterByKey = (0, $42omo.useCallback)((key)=>{
        setParameters((prev)=>{
            const newParameters = {
                ...prev
            };
            delete newParameters[key];
            return newParameters;
        });
    }, [
        setParameters
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            templateApiParameters: parameters,
            setParameterByKey: setParameterByKey,
            removeParameterByKey: removeParameterByKey
        }), [
        parameters,
        setParameterByKey,
        removeParameterByKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($02196f736713ab99$export$b1e136c3301c05ad.Provider, {
        value: contextValue
    }, children);
};
module.exports["TemplateParameterTypeEnum"] = $02196f736713ab99$export$869e231d926edfce;
module.exports["InContextRuleBuilderContext"] = $02196f736713ab99$export$b1e136c3301c05ad;
module.exports["InContextRuleBuilderProvider"] = $02196f736713ab99$export$6cdc09e06812d6d1;

});

parcelRegister("5v7QA", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $cgtv4 = parcelRequire("cgtv4");

const $9b11c5b093926f82$export$242890b69747c0cf = (0, $cgtv4.defineMessages)({
    dismiss: {
        id: "automation-discovery.common.dismiss",
        defaultMessage: "Not now"
    },
    showMeHow: {
        id: "automation-discovery.common.show-me-how",
        defaultMessage: "Show me how"
    },
    spotlightCta: {
        id: "automation-discovery.manual-trigger.cta.text",
        defaultMessage: "Build rule"
    },
    spotlightDismiss: {
        id: "automation-discovery.manual-trigger.dismiss",
        defaultMessage: "Done"
    }
});
const $9b11c5b093926f82$export$eaeae0ae54954c9a = (0, $cgtv4.defineMessages)({
    header: {
        id: "automation-discovery.hover-page-title.header",
        defaultMessage: "Auto-archive old pages?"
    },
    message: {
        id: "automation-discovery.hover-page-title.message",
        defaultMessage: "This page hasn\u2019t been updated lately. An Automation rule could archive old pages once a month."
    }
});
const $9b11c5b093926f82$export$6216ba99d37b53d2 = (0, $cgtv4.defineMessages)({
    header: {
        id: "automation-discovery.archive.from-archive-modal",
        defaultMessage: "Confluence can auto-archive old pages"
    },
    message: {
        id: "automation-discovery.archive.message",
        defaultMessage: // eslint-disable-next-line no-restricted-syntax
        "Try building this Automation rule: Archive pages in this space that haven't been updated in at least 3 months."
    },
    success: {
        id: "automation-discovery.archive.success",
        defaultMessage: "Your page was archived"
    },
    successHeader: {
        id: "automation-discovery.archive.success-header",
        defaultMessage: "Archived successfully"
    },
    viewInArchive: {
        id: "automation-discovery.archive.view-in-archive",
        defaultMessage: "View in archive"
    }
});
const $9b11c5b093926f82$export$e252be6159b8f418 = (0, $cgtv4.defineMessages)({
    title: {
        id: "automation-discovery.add-label.title",
        defaultMessage: "Confluence can auto-add labels"
    },
    message: {
        id: "automation-discovery.add-label.message",
        defaultMessage: "Try building this Automation rule: When the user you choose publishes a new page, label it with their name."
    }
});
const $9b11c5b093926f82$export$defcdcbe29897057 = (0, $cgtv4.defineMessages)({
    success: {
        id: "automation-discovery.meeting-notes.success",
        defaultMessage: "Your page was published"
    },
    title: {
        id: "automation-discovery.meeting-notes.title",
        defaultMessage: "Confluence can auto-publish pages"
    },
    message: {
        id: "automation-discovery.meeting-notes.message",
        defaultMessage: "Try building this Automation rule: Publish a new Meeting notes page according to your meeting schedule."
    },
    ctaText: {
        id: "automation-discovery.meeting-notes.cta.text",
        defaultMessage: "Auto-summarize pages?"
    },
    modalBody: {
        id: "automation-discovery.meeting-notes.modal.body",
        defaultMessage: "{publishedPageTitle} was successfully published in the {spaceName} space"
    },
    successIconLabel: {
        id: "automation-discovery.meeting-notes.success.icon.label",
        defaultMessage: "Success check icon"
    },
    modalCloseIconLabel: {
        id: "automation-discovery.meeting-notes.modal.close.icon.label",
        defaultMessage: "Close icon for modal"
    }
});
const $9b11c5b093926f82$export$ce468634859ccf2b = (0, $cgtv4.defineMessages)({
    ctaText: {
        id: "automation-discovery.jira-link.cta.text",
        defaultMessage: "Auto-link Jira issues?"
    }
});
const $9b11c5b093926f82$export$51183073ec843a06 = (0, $cgtv4.defineMessages)({
    title: {
        id: "automation-discovery.manual-trigger.title",
        defaultMessage: "Page automation menu"
    },
    body: {
        id: "automation-discovery.manual-trigger.body",
        defaultMessage: "Teammates can apply rules from this menu to a single page."
    }
});
const $9b11c5b093926f82$export$4cf5be76251112af = (0, $cgtv4.defineMessages)({
    title: {
        id: "automation-discovery.verified-content.title",
        defaultMessage: "Want to manage your verified pages?"
    },
    body: {
        id: "automation-discovery.verified-content.body",
        defaultMessage: "Use Confluence automation to schedule reviews for verified content."
    }
});
const $9b11c5b093926f82$export$6b1f7d6fd8c7714c = (0, $cgtv4.defineMessages)({
    productivityTimeSavedMessage: {
        id: "automation-discovery.productivity-insights.time-saved.message",
        defaultMessage: "Save your team <b>{timeSaved, plural, one {{timeSaved} minute} other {{timeSaved} minutes}}</b> per quarter by setting up this automation rule!"
    }
});
module.exports["commonI18n"] = $9b11c5b093926f82$export$242890b69747c0cf;
module.exports["hoverPageTitleI18n"] = $9b11c5b093926f82$export$eaeae0ae54954c9a;
module.exports["archiveMessagesI18n"] = $9b11c5b093926f82$export$6216ba99d37b53d2;
module.exports["labelMessagesI18n"] = $9b11c5b093926f82$export$e252be6159b8f418;
module.exports["meetingNotesI18n"] = $9b11c5b093926f82$export$defcdcbe29897057;
module.exports["jiraLinkI18n"] = $9b11c5b093926f82$export$ce468634859ccf2b;
module.exports["verifiedContentI18n"] = $9b11c5b093926f82$export$4cf5be76251112af;
module.exports["productivityInsightsI18n"] = $9b11c5b093926f82$export$6b1f7d6fd8c7714c;

});

parcelRegister("5scZK", function(module, exports) {

var $9o40q = parcelRequire("9o40q");

const $d71603234ecc6b8d$export$b60b821c3d861f36 = ({ onCompleted: onCompleted, onError: onError })=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: ({ cloudId: cloudId, automationStack: automationStack })=>`/gateway/api/automation/internal-api/confluence/${cloudId}/${automationStack}/public/rest/v1/template/create`,
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: ({ templateId: templateId, cloudId: cloudId, spaceId: spaceId, parameters: parameters })=>{
            const ruleHome = spaceId ? `ari:cloud:confluence:${cloudId}:space/${spaceId}` : `ari:cloud:confluence::site/${cloudId}`;
            let formattedParameters = null;
            if (parameters) {
                formattedParameters = {};
                for (const parameter of parameters)formattedParameters[parameter.name] = {
                    value: parameter.value,
                    type: parameter.type
                };
            }
            return JSON.stringify({
                templateId: templateId,
                ruleHome: ruleHome,
                parameters: formattedParameters
            });
        },
        parseResult: ({ ruleId: ruleId, ruleUuid: ruleUuid })=>({
                experimentalCreateAutomationRuleFromTemplate: {
                    ruleId: ruleId,
                    ruleUuid: ruleUuid
                }
            }),
        onCompleted: onCompleted,
        onError: onError
    });
};
var $d71603234ecc6b8d$var$TemplateParameterTypeEnum = /*#__PURE__*/ function(TemplateParameterTypeEnum) {
    TemplateParameterTypeEnum["BOOLEAN"] = "BOOLEAN";
    TemplateParameterTypeEnum["NUMBER"] = "NUMBER";
    TemplateParameterTypeEnum["TEXT"] = "TEXT";
    return TemplateParameterTypeEnum;
}($d71603234ecc6b8d$var$TemplateParameterTypeEnum || {});
module.exports["useExperimentalCreateAutomationRuleFromTemplateMutation"] = $d71603234ecc6b8d$export$b60b821c3d861f36;

});

parcelRegister("iJ9aA", function(module, exports) {

var $bsrY7 = parcelRequire("bsrY7");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $eEA8O = parcelRequire("eEA8O");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2KmnS = parcelRequire("2KmnS");


var $bQm3c = parcelRequire("bQm3c");


var $f7tt0 = parcelRequire("f7tt0");


var $gsZdA = parcelRequire("gsZdA");


var $f7Bnv = parcelRequire("f7Bnv");


var $iC1wS = parcelRequire("iC1wS");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");


var $k4Vdy = parcelRequire("k4Vdy");

const $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    margin: 'auto'
});
const $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding = (0, $ecnYn.xcss)({
    padding: 'space.0'
});
const $c00269aedb3a5e7e$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    tryItFree: {
        id: "change-edition.section.message.try.free",
        defaultMessage: "Try it free"
    },
    learnMoreButton: {
        id: "change-edition.section.message.general.button.link",
        defaultMessage: "Learn more"
    }
});
const $c00269aedb3a5e7e$export$628b38b203828231 = ({ analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, isGrandfathered: isGrandfathered = false, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps })=>{
    const intl = (0, $8C5kA.default)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE);
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    const message = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
    const iconOnly = icon && !message;
    (0, $42omo.useEffect)(()=>()=>{
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    const fireClickAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'freeLearnMore',
                ...analyticsProps,
                attributes: {
                    currentEdition: edition,
                    isSiteAdmin: isSiteAdmin,
                    linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                    targetEdition: targetEdition,
                    ...analyticsProps.attributes
                }
            }
        }).fire();
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: edition,
                linkClicked: actionSubjectId || 'freeLearnMore',
                source: source,
                targetEdition: targetEdition
            }
        });
    };
    const onUpFlowClose = ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bsrY7)))(onUpFlowOpen)) // only attempt to close if there is no onUpFlowOpen handler (as
        // UpFlowComponent will invoke it to unmount our parent already)
        setIsUpFlowOpen(false);
    };
    const renderLearnMoreButton = (props = {})=>{
        if (appearance === 'inline-link') return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props, message));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: appearance,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: appearance === 'subtle-link' ? undefined : 'primaryButton',
            id: "learnMoreLink",
            spacing: iconOnly ? 'none' : 'default',
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    const fireAnalyticsEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'helpLink',
                source: 'adminKeyUpSell',
                attributes: {
                    targetArticleId: inProductHelpId,
                    isSPA: true
                }
            }
        }).fire();
    };
    if (isGrandfathered && !isSiteAdmin) return null;
    // prioritizing href if it passed by the consumer regardless of edition type
    if (!href) href = showUpFlow ? '#' : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith('#') ? undefined : '_blank';
    const buttonProps = {
        target: target,
        href: href,
        onClick: (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        },
        'aria-label': ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !showUpFlow && inProductHelpId && inProductHelpTopic ? /**
     * Special handling In Product Help Button
     * InProductHelpButton force the spacing to none, thus creating a BOX here to add back the padding and margin
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps), showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
        cloudId: cloudId,
        atlassianAccountId: userId || undefined,
        canChangeEdition: isSiteAdmin,
        currentEdition: edition || undefined,
        targetEdition: targetEdition,
        flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
        product: "confluence",
        touchpointId: source,
        onClose: onUpFlowClose,
        onOpen: onUpFlowOpen,
        isExperienceTrackerEnabled: true,
        epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
    }));
};
const $c00269aedb3a5e7e$export$176492db868efc7f = (0, $f7Bnv.withIsSiteAdmin)($c00269aedb3a5e7e$export$628b38b203828231);
module.exports["i18n"] = $c00269aedb3a5e7e$export$a7357cdd1f0b0168;
module.exports["LearnMoreButtonComponent"] = $c00269aedb3a5e7e$export$628b38b203828231;
module.exports["LearnMoreButton"] = $c00269aedb3a5e7e$export$176492db868efc7f;

});

parcelRegister("2KmnS", function(module, exports) {
var $af6754ea8048b03c$export$a719c036dcaa8cea = /*#__PURE__*/ function(UpFlowComponentFlowType) {
    UpFlowComponentFlowType["LEARN_MORE"] = "learn-more";
    UpFlowComponentFlowType["UPGRADE"] = "upgrade";
    UpFlowComponentFlowType["REQUEST_UPGRADE"] = "request-upgrade";
    UpFlowComponentFlowType["REQUEST_LEARN_MORE"] = "request-learn-more";
    return UpFlowComponentFlowType;
}({});
module.exports["UpFlowComponentFlowType"] = $af6754ea8048b03c$export$a719c036dcaa8cea;

});

parcelRegister("f7tt0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0dfdd35e9850cea$export$b14685a9b52779e1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xD_n9",
    name: "InProductHelpButton",
    loader: async ()=>(await (parcelRequire("j0wkI"))).InProductHelpButton
});
module.exports["InProductHelpButton"] = $d0dfdd35e9850cea$export$b14685a9b52779e1;

});

parcelRegister("j0wkI", function(module, exports) {

let $dd671919af841761$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd671919af841761$var$load("82QsP").then(()=>parcelRequire('lcEzf'));

});

parcelRegister("f7Bnv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1ytiN = parcelRequire("1ytiN");

function $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5(WrappedComponent) {
    return function WithIsSiteAdminComponent(props) {
        const { isSiteAdmin: isSiteAdmin, error: error, loading: loading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
        if (error || loading) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isSiteAdmin: isSiteAdmin
        });
    };
}
module.exports["withIsSiteAdmin"] = $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5;

});

parcelRegister("iC1wS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");

const $8ea1c6a3abbe8170$var$EditionsAnalyticsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $8ea1c6a3abbe8170$export$198c73506737f848 = (payload, data)=>({
        ...payload,
        data: {
            ...payload.data,
            attributes: {
                ...payload.data.attributes,
                ...data?.customAttributes
            }
        }
    });
const $8ea1c6a3abbe8170$export$cf1d63b4a60d4ea = ()=>{
    const internalData = (0, $42omo.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const wrapAnalyticsEventPayload = (0, $42omo.useCallback)((data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData), [
        internalData
    ]);
    const wrappedCreateAnalyticsEvent = (0, $42omo.useCallback)((initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload)), [
        createAnalyticsEvent,
        wrapAnalyticsEventPayload
    ]);
    return {
        createAnalyticsEvent: wrappedCreateAnalyticsEvent,
        wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
    };
};
const $8ea1c6a3abbe8170$export$9190afc902e08eb3 = ()=>{
    const internalData = (0, $42omo.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const wrapAnalyticsEventPayload = (0, $42omo.useCallback)((data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData), [
        internalData
    ]);
    const wrappedCreateAnalyticsEvent = (0, $42omo.useCallback)((initialPayload)=>{
        const event = createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload));
        const experimentMeta = event.context?.find((ctx)=>ctx?.attributes?.experimentMeta)?.attributes?.experimentMeta;
        event.payload = {
            ...event.payload,
            data: {
                ...event.payload?.data,
                attributes: {
                    ...event.payload?.data?.attributes,
                    ...experimentMeta?.key && experimentMeta?.cohort && {
                        experiments: {
                            [experimentMeta.key]: {
                                cohort: experimentMeta.cohort
                            }
                        }
                    }
                }
            }
        };
        return event;
    }, [
        createAnalyticsEvent,
        wrapAnalyticsEventPayload
    ]);
    return {
        createAnalyticsEvent: wrappedCreateAnalyticsEvent,
        wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
    };
};
const $8ea1c6a3abbe8170$export$ce3e4b18be9c194b = ()=>{
    const contextWithExperiments = $8ea1c6a3abbe8170$export$9190afc902e08eb3();
    const contextImpl = $8ea1c6a3abbe8170$export$cf1d63b4a60d4ea();
    return (0, $9wGTI.fg)('replace_upsell_cta_content_fg') ? contextWithExperiments : contextImpl;
};
const $8ea1c6a3abbe8170$var$emptyAttributes = {};
const $8ea1c6a3abbe8170$export$1b581a2ec13e37f1 = ({ children: children, customAttributes: customAttributes = $8ea1c6a3abbe8170$var$emptyAttributes })=>{
    const editionsAnalyticsContextValue = (0, $42omo.useMemo)(()=>({
            customAttributes: customAttributes
        }), [
        customAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
        value: editionsAnalyticsContextValue
    }, children);
};
const $8ea1c6a3abbe8170$export$19bbfac2f7120ab5 = (Component)=>{
    const WrappedComponent = (props)=>{
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ...props,
            ...context
        });
    };
    return WrappedComponent;
};
module.exports["useEditionsAnalyticsContext"] = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b;
module.exports["AnalyticsProvider"] = $8ea1c6a3abbe8170$export$1b581a2ec13e37f1;

});

parcelRegister("k4Vdy", function(module, exports) {

var $12IaO = parcelRequire("12IaO");

const $b05bae0ef566e919$export$b1556774836001f5 = ({ actionSubjectId: actionSubjectId, source: source })=>actionSubjectId !== undefined ? `${source}${(0, (/*@__PURE__*/$parcel$interopDefault($12IaO)))(actionSubjectId)}` : undefined;
module.exports["calculateTestId"] = $b05bae0ef566e919$export$b1556774836001f5;

});

parcelRegister("ki6F7", function(module, exports) {

var $ey6Pt = parcelRequire("ey6Pt");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $4KS7f = parcelRequire("4KS7f");


var $ccHMk = parcelRequire("ccHMk");


var $izVB4 = parcelRequire("izVB4");


var $lgF8o = parcelRequire("lgF8o");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $b3j2Y = parcelRequire("b3j2Y");


var $bQm3c = parcelRequire("bQm3c");


var $ij4CE = parcelRequire("ij4CE");


var $b0Zto = parcelRequire("b0Zto");


var $3yh4a = parcelRequire("3yh4a");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $2UjZJ = parcelRequire("2UjZJ");


var $gsZdA = parcelRequire("gsZdA");


var $5M47w = parcelRequire("5M47w");


var $dqdrq = parcelRequire("dqdrq");


var $ktelT = parcelRequire("ktelT");


var $l0DoV = parcelRequire("l0DoV");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");


var $fDbEj = parcelRequire("fDbEj");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");

const $3615035320db7a8b$var$i18n = (0, $cgtv4.defineMessages)({
    tryItFree: {
        id: "change-edition.upgrade.try.free",
        defaultMessage: "Try it free"
    },
    tryItNow: {
        id: "change-edition.upgrade.try.now",
        defaultMessage: "Try it now"
    },
    tryPremium: {
        id: "change-edition.upgrade.try.premium",
        defaultMessage: "Try Premium"
    }
});
const $3615035320db7a8b$var$editionMap = {
    [(0, $euL71.ConfluenceEdition).FREE]: (0, $5M47w.CommerceDeepLinksTargetEdition).FREE,
    [(0, $euL71.ConfluenceEdition).STANDARD]: (0, $5M47w.CommerceDeepLinksTargetEdition).STANDARD,
    [(0, $euL71.ConfluenceEdition).PREMIUM]: (0, $5M47w.CommerceDeepLinksTargetEdition).PREMIUM
};
const $3615035320db7a8b$var$determineButtonComponent = (appearance)=>{
    if (appearance === 'primary') return 0, $dqdrq.GradientCTAButton;
    if (appearance === 'subtle-link') return 0, $ktelT.GradientSubtleLinkButton;
    return 0, $4KS7f.default;
};
/**
 * @deprecated Please reach out to #cc-flywheel-engagement for details before use. Please read https://hello.atlassian.net/wiki/spaces/CE2/pages/2797298237/Contribution+Consumption+Guidelines+For+Common+Feature+Gate+Upsell+Component
 */ const $3615035320db7a8b$var$UpgradeEditionButtonImpl = ({ analyticsProps: { actionSubjectId: actionSubjectId, attributes: attributes, source: source }, appearance: appearance = 'primary', children: children, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, onUpgradeButtonClick: onUpgradeButtonClick })=>{
    const [openUpFlow, setOpenUpFlow] = (0, $42omo.useState)(false);
    const [pollingError, setPollingError] = (0, $42omo.useState)();
    const { cloudId: cloudId, edition: currentEdition, userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $ey6Pt.default)
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // free -> standard: upflow spa;
    // free/standard -> premium: adminhub
    const showUpFlow = targetEdition === (0, $euL71.ConfluenceEdition).STANDARD;
    const { cohort: upflowV2ExperimentCohort, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, loading: upflowV2EligibilityHookLoading } = (0, $2UjZJ.useUpflowV2ConfluenceStandardFGsExperiment)({
        skip: !showUpFlow || !openUpFlow,
        touchpointId: source,
        currentEdition: currentEdition,
        targetEdition: targetEdition
    });
    const { commerceBackendName: commerceBackendName, planConsentDeepLink: planConsentDeepLink, errorMessage: commerceDeepLinksError } = (0, $5M47w.useCommerceDeepLinks)({
        targetEdition: $3615035320db7a8b$var$editionMap[targetEdition],
        skipDeepLinks: showUpFlow
    });
    (0, $42omo.useEffect)(()=>()=>{
            // 1. With upflow enabled, when the user clicks on the upgrade CTA, the
            //    upflow dialog opens and this component unmounts; the upsell experience
            //    continues and experience tracking is subsequently handled by the
            //    UpFlow component.
            // or
            // 2. With upflow DISabled, unmounting here simply means user navigated away
            //    from the upsell UI and we DO want to signal an aborted experience.
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    (0, $42omo.useEffect)(()=>{
        // Using a TRACK event for tacking the traffic to the UpgradeEditionButton.
        // This will help us gauage Commerce API traffic to compute the deep links.
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'upgradeEditionButton',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition
                }
            }
        }).fire();
    // We only need this to fire once, when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireClickAnalytics = ()=>{
        if (attributes) {
            attributes.currentEdition = currentEdition;
            attributes.targetEdition = targetEdition;
            attributes.commerceBackend = commerceBackendName;
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: attributes
            }
        }).fire();
        if (commerceDeepLinksError) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'errored',
                actionSubject: 'useCommerceDeepLinks',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition,
                    upsellDeepLink: planConsentDeepLink ? planConsentDeepLink.split('?')[0] : undefined,
                    errorMessage: commerceDeepLinksError
                }
            }
        }).fire();
    };
    const onTryWithoutUpFlowClick = async ()=>{
        if (onUpgradeButtonClick) onUpgradeButtonClick();
        // start polling and reload the page when done
        try {
            const updatedEdition = await (0, $fDbEj.waitForEditionChange)(currentEdition, writeFragmentInterop);
            experienceTracker.succeed({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                attributes: {
                    currentEdition: currentEdition,
                    targetEdition: updatedEdition
                }
            });
            // Default behavior
            window.location.reload();
        } catch (error) {
            if (error === (0, $fDbEj.TimeoutError)) // We don't expect the user to always proceed to upgrade in Admin Hub after seeing the estimated billing info.
            experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Possibly canceled by user'
            });
            else {
                (0, $fGzMp.stopExperienceOnError)((0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE), error);
                setPollingError(error);
            }
        }
    };
    const onUpFlowClose = ()=>{
        setOpenUpFlow(false);
    };
    const onTryButtonClick = ()=>{
        // we always want to fire both the exposure event as well as the click event
        fireClickAnalytics();
        // start the experience tracker
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: currentEdition,
                linkClicked: actionSubjectId,
                source: source,
                targetEdition: targetEdition
            }
        });
        // then handle the click behaviour based on FF
        if (showUpFlow) setOpenUpFlow(true);
        else onTryWithoutUpFlowClick();
    };
    const buttonProps = {
        appearance: appearance,
        className: 'primaryButton',
        href: showUpFlow ? undefined : planConsentDeepLink,
        onClick: onTryButtonClick,
        target: showUpFlow ? undefined : '_blank',
        iconBefore: appearance === 'primary' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }) : undefined,
        testId: (0, $k4Vdy.calculateTestId)({
            source: source,
            actionSubjectId: actionSubjectId
        })
    };
    const upflowV2ExperimentButtonProps = {
        appearance: appearance,
        testId: 'upflowV2ExperimentLoadingButton',
        isDisabled: true,
        isLoading: true,
        iconBefore: appearance === 'primary' ? (0, (/*@__PURE__*/$parcel$interopDefault($izVB4))) : undefined
    };
    const buttonChildren = children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3615035320db7a8b$var$i18n.tryItFree);
    const ButtonComponent = $3615035320db7a8b$var$determineButtonComponent(appearance);
    const renderModalContent = ()=>{
        if (upflowV2EligibilityHookLoading) return null;
        if (upflowV2ExperimentCohort === 'variation') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l0DoV.TryStandardUpflowV2ExperimentTreatmentModalLoadable), {
            isOpen: openUpFlow,
            closeModal: onUpFlowClose,
            touchpointId: source,
            targetEdition: targetEdition,
            isBillingAdmin: isBillingAdmin,
            isSiteAdmin: isSiteAdmin,
            currentEdition: currentEdition
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
            canChangeEdition: true // this component should only ever be used for site admins
            ,
            cloudId: cloudId,
            currentEdition: currentEdition || undefined,
            atlassianAccountId: userId || undefined,
            flow: "upgrade",
            product: "confluence",
            targetEdition: targetEdition,
            touchpointId: source,
            isExperienceTrackerEnabled: true,
            onClose: // Note: onUpFlowOpen function closes the parent component which
            // means we don't need to trigger the onClose.
            onUpFlowOpen ? undefined : onUpFlowClose,
            onOpen: onUpFlowOpen,
            epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, pollingError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: pollingError
    }) : null, upflowV2EligibilityHookLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), upflowV2ExperimentButtonProps, buttonChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, buttonProps, buttonChildren), showUpFlow && openUpFlow ? renderModalContent() : null);
};
const $3615035320db7a8b$var$UpgradeEditionButtonWithExperiment = ({ analyticsProps: { actionSubjectId: actionSubjectId, attributes: attributes, source: source }, appearance: appearance = 'primary', children: children, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, onUpgradeButtonClick: onUpgradeButtonClick })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { upgradeButtonContent: upgradeButtonContent, cohort: cohort } = (0, $b0Zto.useChangeEditionUpgradeButtonContentExperiment)({
        targetEdition: targetEdition,
        featureGateId: actionSubjectId || source
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
        onError: (error, info)=>{
            const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                product: (0, $gwZbZ.Product).CONFLUENCE,
                team: (0, $6o7wX.Team).GROWTH_LUNA,
                experimentMeta: {
                    experimentKey: 'replace_upsell_cta_content'
                },
                errorType: (0, $gwZbZ.ErrorType).ERROR_BOUNDARY,
                errorMessage: error.message,
                severity: (0, $gwZbZ.Severity).MEDIUM,
                source: 'replace_upsell_cta_content',
                additionalAttributes: {
                    ...info,
                    feature_gate: actionSubjectId || source,
                    attributes: attributes,
                    source: source
                }
            });
            createAnalyticsEvent(eventPayload).fire();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lgF8o.ExperimentAnalyticsContext), {
        experimentMeta: {
            key: 'replace_upsell_cta_content',
            cohort: cohort,
            targetEdition: targetEdition,
            currentEdition: edition,
            content: upgradeButtonContent || children
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3615035320db7a8b$var$UpgradeEditionButtonImpl, {
        analyticsProps: {
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            source: source
        },
        appearance: appearance,
        onUpFlowOpen: onUpFlowOpen,
        targetEdition: targetEdition,
        onUpgradeButtonClick: onUpgradeButtonClick
    }, upgradeButtonContent || children)));
};
const $3615035320db7a8b$export$2f4bd8d23e81b246 = (0, $3yh4a.componentWithFG)('replace_upsell_cta_content_fg', $3615035320db7a8b$var$UpgradeEditionButtonWithExperiment, $3615035320db7a8b$var$UpgradeEditionButtonImpl);
module.exports["UpgradeEditionButton"] = $3615035320db7a8b$export$2f4bd8d23e81b246;

});

parcelRegister("ey6Pt", function(module, exports) {
/**
 * @generated SignedSource<<9788b38f2bb32f836366310152c95cca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $377a05a3faea70b3$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "UpgradeEditionButtonFragment",
        "selections": [
            {
                "concreteType": "Editions",
                "kind": "LinkedField",
                "name": "editions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "confluence"
                    },
                    v0 /*: any*/ 
                ]
            },
            v0 /*: any*/ 
        ],
        "type": "ConfluenceTenantContext"
    };
}();
$377a05a3faea70b3$var$node.hash = "bee007bb99f1be1656322a1f41effd37";
var $377a05a3faea70b3$export$2e2bcd8739ae039 = $377a05a3faea70b3$var$node;
module.exports["default"] = $377a05a3faea70b3$export$2e2bcd8739ae039;

});

parcelRegister("izVB4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56b88a11fb19ee4bef2fa0f940debca3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8682c67cc42b6ad$var$_react = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("42omo")));

var $d8682c67cc42b6ad$var$_baseNew = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d8682c67cc42b6ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing premium features and functionality. Editions may replace the current premium sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8682c67cc42b6ad$var$EditionsIcon = (props)=>/*#__PURE__*/ $d8682c67cc42b6ad$var$_react.default.createElement($d8682c67cc42b6ad$var$_baseNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.614 1.353A.75.75 0 0 1 3.25 1h9.5a.75.75 0 0 1 .636.353l2.5 4a.75.75 0 0 1-.065.884l-7.25 8.5a.75.75 0 0 1-1.142 0l-7.25-8.5a.75.75 0 0 1-.065-.885zM3.666 2.5 2.103 5H4.7l.78-2.5zm3.385 0L6.271 5H9.73l-.781-2.5zm3.47 0L11.3 5h2.596l-1.563-2.5zm3.103 4h-2.328l-1.424 4.399zM8 11.813 9.72 6.5H6.28zM4.704 6.5l1.424 4.399L2.375 6.5z" clip-rule="evenodd"/>`
    }, props));
$d8682c67cc42b6ad$var$EditionsIcon.displayName = 'EditionsIcon';
var $d8682c67cc42b6ad$var$_default = module.exports.default = $d8682c67cc42b6ad$var$EditionsIcon;

});

parcelRegister("lgF8o", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");

const $8918255f2a9fee62$export$b8a9d3f49ba5a590 = ({ experimentMeta: experimentMeta, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: {
            attributes: {
                experimentMeta: experimentMeta
            }
        },
        children: children
    });
};
module.exports["ExperimentAnalyticsContext"] = $8918255f2a9fee62$export$b8a9d3f49ba5a590;

});

parcelRegister("b0Zto", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $6mKj3 = parcelRequire("6mKj3");


var $d9tcB = parcelRequire("d9tcB");

const $daeecc56e3f5b5fd$var$messages = (0, $cgtv4.defineMessages)({
    upgradeButtonText: {
        id: "experiment-change-edition-upgrade-button-content.upgrade-button.text",
        defaultMessage: "Upgrade"
    },
    getStartedButtonText: {
        id: "experiment-change-edition-upgrade-button-content.get-started-button.text",
        defaultMessage: "Get started"
    }
});
const $daeecc56e3f5b5fd$var$isEligibleForExperiment = ({ targetEdition: targetEdition, featureGateId: featureGateId })=>{
    const excludedFeatureGates = [
        'editorAITryPremium',
        'quickSummaryTryPremium',
        'whiteboardPaywallLearnMoreButton',
        'elevateAutomationUpsellExploreAutomation',
        'elevateAutomationUpsellTryPremium'
    ];
    if (!featureGateId) return false;
    return targetEdition === (0, $d9tcB.ConfluenceEdition).PREMIUM && !excludedFeatureGates.includes(featureGateId);
};
const $daeecc56e3f5b5fd$export$8be5e1b5b37b4586 = (eligibilityParams)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligible = eligibilityParams ? $daeecc56e3f5b5fd$var$isEligibleForExperiment(eligibilityParams) : false;
    const cohort = isEligible ? (0, $6mKj3.expVal)('replace_upsell_cta_content', 'cohort', 'not-enrolled') : 'not-enrolled';
    (0, $42omo.useEffect)(()=>{
        if (cohort === 'not-enrolled') return;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'feature',
                source: 'replace_upsell_cta_content',
                attributes: {
                    flagKey: 'replace_upsell_cta_content',
                    cohort: cohort
                }
            }
        }).fire();
    }, [
        cohort,
        createAnalyticsEvent
    ]);
    if (cohort === 'variant-upgrade') return {
        upgradeButtonContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $daeecc56e3f5b5fd$var$messages.upgradeButtonText),
        cohort: cohort
    };
    if (cohort === 'variant-get-started') return {
        upgradeButtonContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $daeecc56e3f5b5fd$var$messages.getStartedButtonText),
        cohort: cohort
    };
    return {
        upgradeButtonContent: null,
        cohort: cohort
    };
};
module.exports["useChangeEditionUpgradeButtonContentExperiment"] = $daeecc56e3f5b5fd$export$8be5e1b5b37b4586;

});

parcelRegister("2UjZJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $gXR0B = parcelRequire("gXR0B");


var $f1B2z = parcelRequire("f1B2z");

const $dd8da84ad086336b$export$2bbc11bf12d076a0 = ({ skip: skip, touchpointId: touchpointId, currentEdition: currentEdition, targetEdition: targetEdition })=>{
    const fireExperimentExposureEvent = (0, $gXR0B.useFeatureExposedAnalytics)();
    const [abCohort, setAbCohort] = (0, $42omo.useState)(null);
    const { isEligible: isEligible, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, error: eligibilityHookError, loading: eligibilityHookLoading } = (0, $f1B2z.useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment)({
        skip: skip,
        currentEdition: currentEdition,
        targetEdition: targetEdition
    });
    (0, $42omo.useEffect)(()=>{
        if (isEligible) {
            fireExperimentExposureEvent({
                flagKey: 'grw-1930_confluence_upv2_standard_ab',
                cohort: (0, $6mKj3.expVal)('grw-1930_confluence_upv2_standard_ab', 'cohort', 'not-enrolled'),
                growthInitiative: 'luna',
                touchpointId: touchpointId,
                additionalAttributes: {
                    currentEdition: currentEdition,
                    targetEdition: targetEdition,
                    isSiteAdmin: isSiteAdmin,
                    isBillingAdmin: isBillingAdmin
                }
            });
            setAbCohort((0, $6mKj3.expVal)('grw-1930_confluence_upv2_standard_ab', 'cohort', 'not-enrolled'));
        } else if (eligibilityHookError) // Error occurred, reset to null
        setAbCohort(null);
        else setAbCohort('not-enrolled');
    }, [
        fireExperimentExposureEvent,
        isEligible,
        eligibilityHookError,
        currentEdition,
        targetEdition,
        isSiteAdmin,
        isBillingAdmin,
        touchpointId
    ]);
    return {
        cohort: abCohort,
        isSiteAdmin: isSiteAdmin,
        isBillingAdmin: isBillingAdmin,
        loading: eligibilityHookLoading,
        error: eligibilityHookError
    };
};
module.exports["useUpflowV2ConfluenceStandardFGsExperiment"] = $dd8da84ad086336b$export$2bbc11bf12d076a0;

});

parcelRegister("gXR0B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $c07cc869290551b6$export$5218ddb3d9c658c0 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sentFlagKeys = (0, $42omo.useRef)([]);
    // This ensures the experiment exposure event is only fired once per flagKey / touchpoint combination.
    return (0, $42omo.useCallback)(({ flagKey: flagKey, cohort: cohort, touchpointId: touchpointId, growthInitiative: growthInitiative, additionalAttributes: additionalAttributes = {} })=>{
        const flagTouchpointKey = `${flagKey}:${touchpointId}`;
        if (sentFlagKeys.current.includes(flagTouchpointKey)) return;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'experiment',
                actionSubjectId: `${flagKey}-exposed`,
                source: flagKey,
                attributes: {
                    cohort: cohort,
                    touchpointId: touchpointId,
                    growthInitiative: growthInitiative,
                    ...additionalAttributes
                }
            }
        }).fire();
        sentFlagKeys.current.push(flagTouchpointKey);
    }, [
        createAnalyticsEvent
    ]);
};
module.exports["useFeatureExposedAnalytics"] = $c07cc869290551b6$export$5218ddb3d9c658c0;

});

parcelRegister("f1B2z", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql agg
 */ 
var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $inPa6 = parcelRequire("inPa6");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");


var $1ytiN = parcelRequire("1ytiN");


var $bQm3c = parcelRequire("bQm3c");


var $gKr8t = parcelRequire("gKr8t");


var $euL71 = parcelRequire("euL71");

const $26baada861c32413$var$extractBillingAdminStatus = (billingData)=>{
    return billingData?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.transactionAccount?.isCurrentUserBillingAdmin;
};
const $26baada861c32413$export$6da6d4db5c51c32 = ({ skip: skip = false, currentEdition: currentEdition, targetEdition: targetEdition })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const isBasicEligible = Boolean(cloudId && currentEdition === (0, $euL71.ConfluenceEdition).FREE && targetEdition === (0, $euL71.ConfluenceEdition).STANDARD && isSiteAdmin);
    const { data: billingAdminData, loading: isBillingAdminQueryLoading, error: billingAdminQueryError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:"confluence.ondemand"){entitlement{id transactionAccount{...on Node{id __typename}isCurrentUserBillingAdmin}}}}}`, {
        client: (0, $gKr8t.getAGGClient)(),
        variables: {
            cloudId: cloudId
        },
        skip: skip || !isBasicEligible
    });
    (0, $42omo.useEffect)(()=>{
        if (billingAdminQueryError) {
            const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                product: (0, $gwZbZ.Product).CONFLUENCE,
                team: (0, $6o7wX.Team).GROWTH_LUNA,
                experimentMeta: {
                    experimentKey: 'grw-1930_confluence_upv2_standard_ab'
                },
                errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
                errorMessage: billingAdminQueryError.message,
                source: 'useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment hook',
                severity: (0, $gwZbZ.Severity).HIGH
            });
            createAnalyticsEvent(eventPayload).fire();
        }
    }, [
        billingAdminQueryError,
        createAnalyticsEvent
    ]);
    const isBillingAdmin = (0, $42omo.useMemo)(()=>{
        return $26baada861c32413$var$extractBillingAdminStatus(billingAdminData);
    }, [
        billingAdminData
    ]);
    return {
        isEligible: Boolean(isBasicEligible && isBillingAdmin),
        isSiteAdmin: isSiteAdmin,
        isBillingAdmin: isBillingAdmin,
        loading: isBillingAdminQueryLoading,
        error: billingAdminQueryError
    };
};
module.exports["useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment"] = $26baada861c32413$export$6da6d4db5c51c32;

});

parcelRegister("5M47w", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $6Co6F = parcelRequire("6Co6F");


var $6bHqX = parcelRequire("6bHqX");


var $lzcvT = parcelRequire("lzcvT");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $1ytiN = parcelRequire("1ytiN");


var $gKr8t = parcelRequire("gKr8t");


var $8H5XZ = parcelRequire("8H5XZ");


var $7Sm4c = parcelRequire("7Sm4c");





var $lh1MN = parcelRequire("lh1MN");


var $hfUvC = parcelRequire("hfUvC");

var $ae96eb60e6557b8b$export$92b15cc7e26a62fb = /*#__PURE__*/ function(CommerceDeepLinksTargetEdition) {
    CommerceDeepLinksTargetEdition["FREE"] = "free";
    CommerceDeepLinksTargetEdition["STANDARD"] = "standard";
    CommerceDeepLinksTargetEdition["PREMIUM"] = "premium";
    return CommerceDeepLinksTargetEdition;
}({});
const $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS = {
    PRODUCTION: 'https://admin.atlassian.com',
    STAGING: 'https://admin.stg.atlassian.com'
};
const $ae96eb60e6557b8b$export$16287b6da0e34b4e = '/admin/billing/applications/change-edition/confluence.ondemand';
const $ae96eb60e6557b8b$export$4591cf268e289775 = '/admin/billing/applications';
const $ae96eb60e6557b8b$var$addAtlOriginToUrl = (url)=>{
    const origin = new (0, $6Co6F.default)({
        product: 'confluence'
    });
    return origin.addToUrl(url);
};
const $ae96eb60e6557b8b$export$39685ba9de2c4192 = ({ cloudId: cloudId, environment: environment, orgId: orgId })=>{
    const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
    if (orgId || cloudId) return orgId ? `${CLOUD_ADMIN_URL}/o/${orgId}/billing-preview` : `${CLOUD_ADMIN_URL}/s/${cloudId}/billing-preview`;
    // In an extreme case where we cannot detect cloudId or orgId, we route user to main AdminHub page.
    return CLOUD_ADMIN_URL;
};
const $ae96eb60e6557b8b$var$buildPlanSelectionLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, environment: environment, entitlementId: entitlementId, transactionAccountId: transactionAccountId, orgId: orgId } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return $ae96eb60e6557b8b$export$16287b6da0e34b4e;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) {
        const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
        // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId/change-plan?referrer=[referrer]
        // See https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2652063891/How+to+Deeplink+to+BAC+s+change+plan
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=confluence`;
    }
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
const $ae96eb60e6557b8b$var$buildPlanConsentLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, entitlementId: entitlementId, environment: environment, orgId: orgId, transactionAccountId: transactionAccountId, targetEdition: targetEdition } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return targetEdition ? `${$ae96eb60e6557b8b$var$buildPlanSelectionLink(params)}/${targetEdition}` : $ae96eb60e6557b8b$var$buildPlanSelectionLink(params);
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId/change-plan?offeringName=[offering name]&referrer=[referrer]
    // See https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2820329173/How+to+Deeplink+change+plan+consent
    return targetEdition ? `${$ae96eb60e6557b8b$var$buildPlanSelectionLink(params)}&offeringName=${targetEdition}` : $ae96eb60e6557b8b$var$buildPlanSelectionLink(params);
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
const $ae96eb60e6557b8b$var$buildSubscriptionDetailsLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, environment: environment, entitlementId: entitlementId, orgId: orgId, transactionAccountId: transactionAccountId } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return $ae96eb60e6557b8b$export$4591cf268e289775;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) {
        const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
        // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}`;
    }
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
// (Concept is adopted from Kent C. Dodds here:
//  https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript)
const $ae96eb60e6557b8b$var$getErrorMessage = (label, error)=>{
    const message = error instanceof Error ? error.message : String(error);
    return `${label}: ${message}`;
};
const $ae96eb60e6557b8b$export$91505ae0b86ded0b = ({ targetEdition: targetEdition, skipDeepLinks: skipDeepLinks = false })=>{
    const { environment: environment, cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    if (!isSiteAdmin || !cloudId) skipDeepLinks = true;
    /**
   * The best practice advocates for one graphql per component and ideally no graphql quries in a hook
   * but to construct the deeplink, we need to:
   * 1. first call Commerce API to retrieve the Confluence instance backend service (CCP or HAMS),
   * 2. for CCP, call ccgraphql to retrieve the ccpEntitlementId
   * 3. for CCP, call AGG to retrieve the CCP transaction account Id using the ccpEntitlementId retrieved in step #2.
   *
   * This is a stop gap solution while we work with Commerce to eventually have one AGG query
   * to provide everything we need with just a CloudId and the product key (e.g. confluence
   */ const { commerceBackendName: commerceBackendName, loading: commerceBackendNameLoading, error: commerceBackendNameError } = (0, $hfUvC.useCommerceRolloutInformation)(skipDeepLinks || (0, $lzcvT.isFedRamp)());
    // If it is in FedRamp, we can assume it is CCP backend.
    // More details -> https://atlassian.slack.com/archives/C04LF8UKAE4/p1734981625650579
    const isCcpBackend = commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) || (0, $lzcvT.isFedRamp)();
    const { data: ccpEntitlementIdData, loading: ccpEntitlementIdLoading, error: ccpEntitlementIdError } = (0, $j1Ss3.useQuery)(/** @schema cc */ (0, $eSUdr.default)`query useCommerceDeepLinksCcpEntitlementQuery{confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}}}tenant{cloudId}}`, {
        skip: skipDeepLinks || !isCcpBackend
    });
    const ccpEntitlementId = !ccpEntitlementIdLoading ? (0, $lh1MN.getCcpEntitlementFromQuery)(ccpEntitlementIdData) : undefined;
    const { data: ccpEntitlementTxaIdData, loading: ccpEntitlementTxaIdLoading, error: ccpEntitlementTxaIdError } = (0, $j1Ss3.useQuery)(/** @schema agg */ (0, $eSUdr.default)`query useCommerceDeepLinksCcpTransactionAccountIdQuery($entitlementId:ID!$targetEditionName:String$shouldFetchChangeOffering:Boolean!){ccp{entitlement(id:$entitlementId){transactionAccountId experienceCapabilities@include(if:$shouldFetchChangeOffering){changeOfferingV2(offeringName:$targetEditionName){experienceUrl}}}}}`, {
        variables: {
            entitlementId: ccpEntitlementId || '',
            targetEditionName: targetEdition || '',
            shouldFetchChangeOffering: (0, $9wGTI.fg)('ld-74-fetch-change-offering-url-in-upgrade-edition')
        },
        skip: skipDeepLinks || !isCcpBackend || !ccpEntitlementId,
        client: (0, $gKr8t.getAGGClient)()
    });
    if (skipDeepLinks) return {
        commerceBackendName: null,
        planSelectionDeepLink: undefined,
        planConsentDeepLink: undefined,
        subscriptionDetailsDeepLink: undefined,
        loading: false,
        errorMessage: undefined
    };
    let errorMessage;
    let planSelectionDeepLink;
    let planConsentDeepLink;
    let subscriptionDetailsDeepLink;
    let changeOfferingDeepLink;
    try {
        const entitlementId = ccpEntitlementId;
        const transactionAccountId = ccpEntitlementTxaIdData?.ccp?.entitlement?.transactionAccountId;
        // format -> https://admin.stg.atlassian.com/billing/UUID/entitlement/TWC-UUID-OR-CONF/change-plan?requireAtlOrigin=true&referrer=
        const changeOfferingExperienceUrl = ccpEntitlementTxaIdData?.ccp?.entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl ?? undefined;
        const commerceParams = {
            cloudId: cloudId,
            commerceBackendName: commerceBackendName,
            environment: environment,
            entitlementId: entitlementId,
            orgId: orgId,
            transactionAccountId: transactionAccountId || undefined
        };
        planSelectionDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildPlanSelectionLink(commerceParams));
        planConsentDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildPlanConsentLink({
            targetEdition: targetEdition,
            ...commerceParams
        }));
        changeOfferingDeepLink = changeOfferingExperienceUrl ? $ae96eb60e6557b8b$var$addAtlOriginToUrl(`${changeOfferingExperienceUrl}confluence`) : undefined;
        subscriptionDetailsDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildSubscriptionDetailsLink(commerceParams));
        // Mark all graphql errors as handled since we will return the fallback plan selection url
        if ((0, $8H5XZ.isGraphQLError)(ccpEntitlementIdError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(ccpEntitlementIdError)) (0, $7Sm4c.markErrorAsHandled)(ccpEntitlementIdError);
        if ((0, $8H5XZ.isGraphQLError)(ccpEntitlementTxaIdError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(ccpEntitlementTxaIdError)) (0, $7Sm4c.markErrorAsHandled)(ccpEntitlementTxaIdError);
        if (commerceBackendNameError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving Commerce Backend Service', commerceBackendNameError);
        else if (ccpEntitlementIdError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving CCP Entitlement Id', ccpEntitlementIdError);
        else if (ccpEntitlementTxaIdError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving CCP Transaction Account Id', ccpEntitlementTxaIdError);
    } catch (e) {
        errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error in useCommerceDeepLinks', e);
    }
    const loading = commerceBackendNameLoading || ccpEntitlementIdLoading || ccpEntitlementTxaIdLoading;
    return {
        commerceBackendName: commerceBackendName,
        planSelectionDeepLink: planSelectionDeepLink,
        planConsentDeepLink: changeOfferingDeepLink || planConsentDeepLink,
        subscriptionDetailsDeepLink: subscriptionDetailsDeepLink,
        loading: loading,
        errorMessage: errorMessage
    };
};
module.exports["CommerceDeepLinksTargetEdition"] = $ae96eb60e6557b8b$export$92b15cc7e26a62fb;
module.exports["useCommerceDeepLinks"] = $ae96eb60e6557b8b$export$91505ae0b86ded0b;

});

parcelRegister("hfUvC", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $42omo = parcelRequire("42omo");


var $6bHqX = parcelRequire("6bHqX");


var $bXe73 = parcelRequire("bXe73");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");

const $e7daf7179cc3ad9e$export$b65b36d21c9a62a9 = 'confluence.ondemand';
const $e7daf7179cc3ad9e$var$memoizedFetchCommerceRolloutInformation = (0, $2XqLN.default)(async (cloudId)=>{
    const rolloutInfoResult = await (0, $6bHqX.fetchCommerceRolloutInformation)({
        cloudId: cloudId,
        productKey: $e7daf7179cc3ad9e$export$b65b36d21c9a62a9
    }, {
        fetch: (0, $f7B1p.cfetch)
    });
    return rolloutInfoResult;
});
const $e7daf7179cc3ad9e$export$44d1450d6b2633f0 = (skip = false)=>{
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(null);
    const [commerceBackendName, setCommerceBackendName] = (0, $42omo.useState)(null);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    if (!cloudId) skip = true;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        const fetchCommerceRolloutInformation = async ()=>{
            try {
                const rolloutInfoResult = await $e7daf7179cc3ad9e$var$memoizedFetchCommerceRolloutInformation(cloudId);
                if ((0, $bXe73.isSuccessful)(rolloutInfoResult)) setCommerceBackendName(rolloutInfoResult.payload.commerceBackend);
                else {
                    const error = (0, $bXe73.isException)(rolloutInfoResult) ? rolloutInfoResult.exception : rolloutInfoResult.error;
                    setError(error);
                }
            } catch (error) {
                error.message = `useCommerceBackendName: ${error.message}`;
                setError(error);
            } finally{
                setLoading(false);
            }
        };
        fetchCommerceRolloutInformation();
    }, [
        cloudId,
        skip
    ]);
    return {
        commerceBackendName: skip ? null : commerceBackendName,
        loading: skip ? false : loading,
        error: skip ? null : error
    };
};
module.exports["useCommerceRolloutInformation"] = $e7daf7179cc3ad9e$export$44d1450d6b2633f0;

});

parcelRegister("dqdrq", function(module, exports) {
/* GradientCTAButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $izVB4 = parcelRequire("izVB4");


var $j4WDj = parcelRequire("j4WDj");


var $6J7Bn = parcelRequire("6J7Bn");

const $ce55fe36479bc4cf$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $6J7Bn.ButtonBase), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_iozncj": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_START)),
            "--_id2ec3": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_END)),
            "--_1wa1xp5": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_START)),
            "--_1ck0ygl": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_END)),
            "--_1jf6nc6": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START)),
            "--_1kksnqn": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1wgmglyw _1tnq12b0 _nup9qsa8 _ge1r1cay _h99ltlke _r7sm1uxc _1xlotlke _1jypidpf _1fm3idpf _12z9idpf _1dwpidpf _kl6h116y _1w901gfe _1l5a1gfe _zelm1gfe _1fh11gfe _1f1j1gfe",
            __cmplp.className
        ])
    });
});
const $ce55fe36479bc4cf$var$ButtonText = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c82smr _1e0c1txw _4cvr1h6o _1bah1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
}); /**
     * A styled button with a gradient background, intended to be used as a product edition upgrade CTA button.
     */ 
const $ce55fe36479bc4cf$export$d1aef6466b5ecaa5 = ({ children: children, ...buttonProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$StyledButton, {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        }),
        ...buttonProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$ButtonText, null, children));
};
module.exports["GradientCTAButton"] = $ce55fe36479bc4cf$export$d1aef6466b5ecaa5;

});

parcelRegister("j4WDj", function(module, exports) {
const $67193f3c2d75b820$export$3ff4048780acdec9 = "var(--ds-chart-purple-bolder, #AF59E1)";
const $67193f3c2d75b820$export$ac8ee41608bff6f4 = "var(--ds-chart-blue-bolder, #357DE8)";
const $67193f3c2d75b820$export$12fbdde791205cea = "var(--ds-chart-purple-bolder-hovered, #964AC0)";
const $67193f3c2d75b820$export$7653c62635354aaf = "var(--ds-chart-blue-bolder-hovered, #1868DB)";
const $67193f3c2d75b820$export$d4accc94291dcf84 = "var(--ds-chart-purple-boldest, #803FA5)";
const $67193f3c2d75b820$export$16a15d5a9b73591b = "var(--ds-chart-blue-boldest, #1558BC)";
const $67193f3c2d75b820$export$fca70c3c81bb0f58 = "var(--ds-background-accent-blue-subtlest, #E9F2FE)";
const $67193f3c2d75b820$export$f737ffc625de304f = "var(--ds-background-accent-purple-subtlest, #F8EEFE)";
const $67193f3c2d75b820$export$b1ab5fb618714abb = "var(--ds-border-accent-purple, #AF59E1)";
const $67193f3c2d75b820$export$7a262e0e9c5a1e2a = "var(--ds-border-accent-blue, #357DE8)";
const $67193f3c2d75b820$export$71b6aed4f8256b2 = "var(--ds-background-discovery-bold-pressed, #673286)";
const $67193f3c2d75b820$export$c9d89eb8e0b59a5a = "var(--ds-background-selected-bold-pressed, #123263)";
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_START"] = $67193f3c2d75b820$export$3ff4048780acdec9;
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_END"] = $67193f3c2d75b820$export$ac8ee41608bff6f4;
module.exports["GRADIENT_CTA_BUTTON_HOVER_START"] = $67193f3c2d75b820$export$12fbdde791205cea;
module.exports["GRADIENT_CTA_BUTTON_HOVER_END"] = $67193f3c2d75b820$export$7653c62635354aaf;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_START"] = $67193f3c2d75b820$export$d4accc94291dcf84;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_END"] = $67193f3c2d75b820$export$16a15d5a9b73591b;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_START"] = $67193f3c2d75b820$export$fca70c3c81bb0f58;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_END"] = $67193f3c2d75b820$export$f737ffc625de304f;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_START"] = $67193f3c2d75b820$export$b1ab5fb618714abb;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_END"] = $67193f3c2d75b820$export$7a262e0e9c5a1e2a;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_START"] = $67193f3c2d75b820$export$71b6aed4f8256b2;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_END"] = $67193f3c2d75b820$export$c9d89eb8e0b59a5a;

});

parcelRegister("6J7Bn", function(module, exports) {
/* GradientCTAButtonBase.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");

const $e9beab952dc913a3$export$b0bb876e969289cd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_d16p1ano _1dqt12x7 _1toh1r31 _5jyqglyw _mrqmnqa1 _if29116y _1kba1h6o",
            __cmplp.className
        ])
    });
});
module.exports["ButtonBase"] = $e9beab952dc913a3$export$b0bb876e969289cd;

});

parcelRegister("ktelT", function(module, exports) {
/* GradientSubtleLinkButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $izVB4 = parcelRequire("izVB4");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-html-anchor -- To migrate as part of go/ui-styling-standard
const $903332396267b541$var$LinkWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71879 _11c82smr _zulpv77o _1e0c116y _4cvr1h6o _80omtlke _k48pmoej _1bsb1ns9 _pjrq1758 _oo9g1j28 _18u01b66 _1xjxgktf _1nj1uyj3 _13r27vkz _1nm57vkz _19lc19y2 _1fyq1yf3 _1h7d1kdv _v6kc1j28",
            __cmplp.className
        ])
    });
});
const $903332396267b541$export$7e6e2bf13161f2a = ({ href: href, onClick: onClick, target: target, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($903332396267b541$var$LinkWrapper, {
        href: href,
        onClick: onClick,
        target: target,
        role: "link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
        label: ""
    }), children);
};
module.exports["GradientSubtleLinkButton"] = $903332396267b541$export$7e6e2bf13161f2a;

});

parcelRegister("l0DoV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $537ed6b0b56c707f$export$5422bd88477f90e5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uHF1j",
    name: "TryStandardUpflowV2ExperimentTreatmentModalLoadable",
    loader: async ()=>(await (parcelRequire("2LGpS"))).TryStandardUpflowV2ExperimentTreatmentModalWithErrorBoundary
});
module.exports["TryStandardUpflowV2ExperimentTreatmentModalLoadable"] = $537ed6b0b56c707f$export$5422bd88477f90e5;

});

parcelRegister("2LGpS", function(module, exports) {

let $2040df96a77ac203$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2040df96a77ac203$var$load("6wr18"),
    $2040df96a77ac203$var$load("eeaKR"),
    $2040df96a77ac203$var$load("ffEVr"),
    $2040df96a77ac203$var$load("let0D"),
    $2040df96a77ac203$var$load("hhss7"),
    $2040df96a77ac203$var$load("fYFVU")
]).then(()=>parcelRequire('h60zh'));

});

parcelRegister("3JQXa", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $e2866f1e30f0246d$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = (0, $42omo.useCallback)(async (value)=>{
        // check if the browser supports the clipboard API
        if (value && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') await navigator.clipboard.writeText(value);
    }, []);
    return (0, $42omo.useMemo)(()=>({
            copyToClipboard: copyToClipboard
        }), [
        copyToClipboard
    ]);
};
module.exports["useCopyToClipboard"] = $e2866f1e30f0246d$export$b2199c37e85de4a7;

});

parcelRegister("iPfZG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1e26a6c07491d4a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EngagementSpotlight", () => $d1e26a6c07491d4a$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $2Fndw = parcelRequire("2Fndw");


var $iiBJH = parcelRequire("iiBJH");


var $3Npfo = parcelRequire("3Npfo");


var $k5HOq = parcelRequire("k5HOq");


var $8cBM8 = parcelRequire("8cBM8");

const $d1e26a6c07491d4a$var$SpotlightWithVariables = (0, $iiBJH.default)((0, $8cBM8.default));
const $d1e26a6c07491d4a$export$f57123e11f24bec9 = (0, $3Npfo.default)($d1e26a6c07491d4a$var$SpotlightWithVariables);
const $d1e26a6c07491d4a$var$SpotlightWithMessage = (0, $k5HOq.default)($d1e26a6c07491d4a$export$f57123e11f24bec9, 'spotlight');
function $d1e26a6c07491d4a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d1e26a6c07491d4a$var$SpotlightWithMessage, props));
}

});

parcelRegister("iiBJH", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cfa45347111319c$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $3Sftg = parcelRequire("3Sftg");

function $3cfa45347111319c$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $42omo.Component) {
        render() {
            const props = $3cfa45347111319c$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TargetComponent, props);
        }
    }
    WithVariables.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $3cfa45347111319c$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $3Sftg.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $3Sftg.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $3Sftg.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});

parcelRegister("3Sftg", function(module, exports) {

var $g47C5 = parcelRequire("g47C5");

var $4xewT = parcelRequire("4xewT");

function $e4ebe363c373022b$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $e4ebe363c373022b$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $4xewT.runTemplateForUrl)(input, variables) : (0, $4xewT.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $g47C5.REPLACEMENT_ERROR)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}
module.exports["rebuildButtonAction"] = $e4ebe363c373022b$export$5d0ec4f796aceeb1;
module.exports["runTemplateOnInputs"] = $e4ebe363c373022b$export$d808999430a3f186;

});

parcelRegister("g47C5", function(module, exports) {
const $e428a4697dceb24e$export$e26f00bd90899835 = 'success';
const $e428a4697dceb24e$export$edb46161045fece7 = 'error';
module.exports["REPLACEMENT_ERROR"] = $e428a4697dceb24e$export$edb46161045fece7;

});

parcelRegister("4xewT", function(module, exports) {

var $i0lyP = parcelRequire("i0lyP");


var $cpDxi = parcelRequire("cpDxi");


var $g47C5 = parcelRequire("g47C5");


var $cuEWu = parcelRequire("cuEWu");

function $ace38877ac0d85ab$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $i0lyP.default)(template);
    return (0, $cuEWu.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $ace38877ac0d85ab$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $i0lyP.default)(template);
    return (0, $cpDxi.replaceForUrl)(epTemplate, variables);
}
function $ace38877ac0d85ab$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $i0lyP.default)(template);
    return (0, $cpDxi.replaceForHtml)(epTemplate, variables);
}
module.exports["runTemplateForUrl"] = $ace38877ac0d85ab$export$416b2ef51d91ea20;
module.exports["runTemplateForHtml"] = $ace38877ac0d85ab$export$5681b97796b74884;

});

parcelRegister("i0lyP", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2be59bfe0ce0113$export$2e2bcd8739ae039);

var $bz2UO = parcelRequire("bz2UO");

/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $e2be59bfe0ce0113$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $e2be59bfe0ce0113$var$UNESCAPED_MATCH = 1;
const $e2be59bfe0ce0113$var$UNESCAPED_GROUP_CONTENTS = 2;
const $e2be59bfe0ce0113$var$ESCAPED_GROUP_CONTENTS = 5;
function $e2be59bfe0ce0113$export$2e2bcd8739ae039(template) {
    const parts = (0, $bz2UO.regexpParts)(template, $e2be59bfe0ce0113$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$e2be59bfe0ce0113$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$e2be59bfe0ce0113$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$e2be59bfe0ce0113$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});

parcelRegister("bz2UO", function(module, exports) {
function $78901a26ed98192e$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $78901a26ed98192e$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $78901a26ed98192e$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $78901a26ed98192e$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $78901a26ed98192e$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}
module.exports["regexpParts"] = $78901a26ed98192e$export$b16d411b3b6d6dff;

});

parcelRegister("cpDxi", function(module, exports) {

var $cuEWu = parcelRequire("cuEWu");


var $48gB0 = parcelRequire("48gB0");

/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $9d422126fe4600e0$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $cuEWu.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $9d422126fe4600e0$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $9d422126fe4600e0$var$rawReplaceVariablesForUrl(template, variables) {
    return $9d422126fe4600e0$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $9d422126fe4600e0$var$rawReplaceVariablesForHtml(template, variables) {
    return $9d422126fe4600e0$var$rawReplaceVariables(template, variables, (0, $48gB0.default));
}
function $9d422126fe4600e0$export$d10ae881b12b8ef2(template, variables) {
    return $9d422126fe4600e0$var$withVariableValidation(template, variables, $9d422126fe4600e0$var$rawReplaceVariablesForUrl);
}
function $9d422126fe4600e0$export$ca536300dbd6350(template, variables) {
    return $9d422126fe4600e0$var$withVariableValidation(template, variables, $9d422126fe4600e0$var$rawReplaceVariablesForHtml);
}
module.exports["replaceForUrl"] = $9d422126fe4600e0$export$d10ae881b12b8ef2;
module.exports["replaceForHtml"] = $9d422126fe4600e0$export$ca536300dbd6350;

});

parcelRegister("cuEWu", function(module, exports) {

var $1rjmQ = parcelRequire("1rjmQ");

function $5e0333abe2221126$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $5e0333abe2221126$export$4a33186abb06007b(template) {
    const variableParts = $5e0333abe2221126$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $1rjmQ.uniqStrings)(variableNames);
}
module.exports["getRequiredVariablesFromTemplate"] = $5e0333abe2221126$export$4a33186abb06007b;

});

parcelRegister("1rjmQ", function(module, exports) {
/**
 * Removes duplicate strings from an array.
 */ function $56c35590cbe5b17a$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}
module.exports["uniqStrings"] = $56c35590cbe5b17a$export$c150c7c1a29f33d8;

});

parcelRegister("48gB0", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d527f6527719db2$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $8d527f6527719db2$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});

parcelRegister("3Npfo", function(module, exports) {
$parcel$export(module.exports, "default", () => $924fbb9a636b21af$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $1DWH0 = parcelRequire("1DWH0");

var $924fbb9a636b21af$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $42omo.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args);
            this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $1DWH0.default)()(EngagementEventsWrapper);
};

});

parcelRegister("k5HOq", function(module, exports) {
$parcel$export(module.exports, "default", () => $e47b6edde9367a4f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");

var $e47b6edde9367a4f$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(StoreWrapperInner, {
                ...this.props,
                context: this.context
            });
        }
        constructor(...args){
            super(...args);
            this.context = void 0;
        }
    }
    StoreWrapper.contextTypes = {
        subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
        setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    };
    const StoreWrapperInner = (allProps)=>{
        const { context: context, ...props } = allProps;
        const { children: children, engagementId: engagementId, messageType: messageType, onMessageDisposition: onMessageDisposition } = props;
        const [message, setMessage] = (0, $42omo.useState)(null);
        const unsubscribeRef = (0, $42omo.useRef)(null);
        const removeConfigRef = (0, $42omo.useRef)(null);
        const canSubscribe = (0, $42omo.useCallback)(()=>{
            return context && !!context?.subscribeEngagementState;
        }, [
            context
        ]);
        const canSetConfig = (0, $42omo.useCallback)(()=>{
            return context && !!context?.setComponentConfig;
        }, [
            context
        ]);
        const onStoreChange = (0, $42omo.useCallback)((state)=>{
            setMessage(computeNewState(state).message);
        }, []);
        const subscribeToStore = (0, $42omo.useCallback)(()=>{
            return context?.subscribeEngagementState?.(onStoreChange);
        }, [
            context,
            onStoreChange
        ]);
        const setChoreographerConfig = (0, $42omo.useCallback)((propsToUse = props)=>{
            return context?.setComponentConfig?.(getComponentType(), {
                messageType: propsToUse.messageType,
                onMessageDisposition: propsToUse.onMessageDisposition
            }, propsToUse.engagementId);
        }, [
            context,
            props
        ]);
        // Handle initial mount (equivalent to UNSAFE_componentWillMount)
        (0, $42omo.useEffect)(()=>{
            if (canSubscribe()) unsubscribeRef.current = subscribeToStore() || null;
            if (canSetConfig()) removeConfigRef.current = setChoreographerConfig() || null;
            return ()=>{
                if (unsubscribeRef.current) unsubscribeRef.current();
                if (removeConfigRef.current) removeConfigRef.current();
            };
        }, [
            canSubscribe,
            canSetConfig,
            subscribeToStore,
            setChoreographerConfig
        ]);
        // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
        const previousEngagementId = (0, $42omo.useRef)(engagementId);
        const previousMessageType = (0, $42omo.useRef)(messageType);
        const previousOnMessageDisposition = (0, $42omo.useRef)(onMessageDisposition);
        (0, $42omo.useEffect)(()=>{
            if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
                removeConfigRef.current();
                removeConfigRef.current = setChoreographerConfig(props) || null;
            } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) setChoreographerConfig(props);
            previousEngagementId.current = engagementId;
            previousMessageType.current = messageType;
            previousOnMessageDisposition.current = onMessageDisposition;
        }, [
            props,
            setChoreographerConfig,
            canSetConfig,
            engagementId,
            messageType,
            onMessageDisposition
        ]);
        if (!message) {
            if (componentType === 'inlineDialog') return children || null;
            return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
        const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
            key: messageKey,
            ...props,
            ...message
        });
    };
    return StoreWrapper;
};

});

parcelRegister("8cBM8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hQNhB = parcelRequire("hQNhB");


var $5RBJ9 = parcelRequire("5RBJ9");


var $7cTWR = parcelRequire("7cTWR");


var $9A5yV = parcelRequire("9A5yV");

class $86110ead6fe3e8af$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $7cTWR.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RBJ9.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9A5yV.default), {
            html: body
        }));
    }
}
$86110ead6fe3e8af$export$2e2bcd8739ae039.defaultProps = {
    fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB)))
};
module.exports["default"] = $86110ead6fe3e8af$export$2e2bcd8739ae039;

});

parcelRegister("7cTWR", function(module, exports) {
const $31e3ef3c9b5f37b6$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};
module.exports["buttonActionTypes"] = $31e3ef3c9b5f37b6$export$e7d79186651244da;

});

parcelRegister("9A5yV", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $8cb2cd879eafccd1$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}
module.exports["default"] = $8cb2cd879eafccd1$export$2e2bcd8739ae039;

});

parcelRegister("2wSyg", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext = /*#__PURE__*/ (0, $42omo.createContext)({
    getIsPublishing: ()=>false,
    setIsPublishing: (_)=>{
    // Intentional no-op
    },
    isPublishing: false
});
const $87bc0f5ac3c4b9fb$export$dc8d83ecee528ce8 = ({ children: children })=>{
    // These should remain in sync. The ref is used while a draft sync occurs, while
    // the state variable is used for re-rendering.
    const isPublishingRef = (0, $42omo.useRef)(false);
    const [isPublishing, setIsPublishing] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const getIsPublishing = (0, $42omo.useCallback)(()=>isPublishingRef.current, []);
    const setPublishing = (0, $42omo.useCallback)((value)=>{
        isPublishingRef.current = value;
        setIsPublishing(value);
    }, []);
    const contextValue = (0, $42omo.useMemo)(()=>({
            getIsPublishing: getIsPublishing,
            setIsPublishing: setPublishing,
            isPublishing: isPublishing
        }), [
        getIsPublishing,
        setPublishing,
        isPublishing
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext.Provider, {
        value: contextValue
    }, children);
};
const $87bc0f5ac3c4b9fb$export$bceb447197cf2e23 = ({ children: children })=>{
    const context = $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4();
    return children(context);
};
const $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4 = ()=>{
    return (0, $42omo.useContext)($87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext);
};
module.exports["DraftSyncAndPublishContextProvider"] = $87bc0f5ac3c4b9fb$export$dc8d83ecee528ce8;
module.exports["DraftSyncAndPublishContextConsumer"] = $87bc0f5ac3c4b9fb$export$bceb447197cf2e23;
module.exports["useDraftSyncAndPublishContext"] = $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4;

});

parcelRegister("awHlv", function(module, exports) {
var $14957aea32c8ee8e$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    SyncBlockError["InvalidRequest"] = "invalid_request";
    SyncBlockError["RateLimited"] = "rate_limited";
    SyncBlockError["Conflict"] = "conflict";
    SyncBlockError["ServerError"] = "server_error";
    SyncBlockError["InvalidContent"] = "invalid_content";
    SyncBlockError["Offline"] = "offline";
    return SyncBlockError;
}({});
module.exports["SyncBlockError"] = $14957aea32c8ee8e$export$686dd843fdf311d4;

});

parcelRegister("cFpEg", function(module, exports) {

var $d925B = parcelRequire("d925B");

const $22be2fac1f3375a4$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};
const $22be2fac1f3375a4$export$999ed1af1b20ac2d = (actionSubjectId, error)=>({
        action: (0, $d925B.ACTION).ERROR,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: actionSubjectId,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            error: error
        }
    });
const $22be2fac1f3375a4$export$94dcd08406353dba = (error)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error);
const $22be2fac1f3375a4$export$c5131f589148b9d3 = (error)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO, error);
const $22be2fac1f3375a4$export$adc2363832f8735d = (error)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE, error);
const $22be2fac1f3375a4$export$154595d209a77913 = (error)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_UPDATE, error);
const $22be2fac1f3375a4$export$5d2f0c264cf49280 = (error)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE, error);
const $22be2fac1f3375a4$export$cd0aaab38ff32ec2 = (error)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE, error);
const $22be2fac1f3375a4$export$e40ed1768baf5d1e = (error)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE_CACHE, error);
module.exports["stringifyError"] = $22be2fac1f3375a4$export$7fc2c997455452c8;
module.exports["fetchErrorPayload"] = $22be2fac1f3375a4$export$94dcd08406353dba;
module.exports["getSourceInfoErrorPayload"] = $22be2fac1f3375a4$export$c5131f589148b9d3;
module.exports["updateErrorPayload"] = $22be2fac1f3375a4$export$adc2363832f8735d;
module.exports["updateReferenceErrorPayload"] = $22be2fac1f3375a4$export$154595d209a77913;
module.exports["createErrorPayload"] = $22be2fac1f3375a4$export$5d2f0c264cf49280;
module.exports["deleteErrorPayload"] = $22be2fac1f3375a4$export$cd0aaab38ff32ec2;
module.exports["updateCacheErrorPayload"] = $22be2fac1f3375a4$export$e40ed1768baf5d1e;

});

parcelRegister("d9uxk", function(module, exports) {
/**
 * @generated SignedSource<<b75deca64f0533d7fe2b70cf54f2ff13>>
 * @relayHash 3e8398ac4cc35cda2ed93f4628fc8a69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd
const $39137d315768d978$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceDataLifecycleManagementPolicy",
            "kind": "LinkedField",
            "name": "confluence_dataLifecycleManagementPolicy",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceDataRetentionPolicyStatus",
                    "kind": "LinkedField",
                    "name": "dataRetentionPolicyDetailsForWorkspace",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "policyEnabledStatus"
                        },
                        {
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "disabledOnDate",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDataRetentionDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDataRetentionDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3e8398ac4cc35cda2ed93f4628fc8a69",
            "id": "011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd",
            "metadata": {},
            "name": "useDataRetentionDetailsQuery",
            "operationKind": "query",
            "text": "query useDataRetentionDetailsQuery($cloudId:ID!){confluence_dataLifecycleManagementPolicy(cloudId:$cloudId){dataRetentionPolicyDetailsForWorkspace{policyEnabledStatus,disabledOnDate{value}}}}"
        }
    };
}();
$39137d315768d978$var$node.hash = "0241f940fae6659cf9e57c7aaae37fa7";
var $39137d315768d978$export$2e2bcd8739ae039 = $39137d315768d978$var$node;
module.exports["default"] = $39137d315768d978$export$2e2bcd8739ae039;

});

parcelRegister("fy5yb", function(module, exports) {

var $cUycv = parcelRequire("cUycv");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");

const $747cae967af72a91$var$setCommentProperties = (properties, comments)=>Object.fromEntries(Object.entries(comments).map(([id, comment])=>[
            id,
            {
                ...comment,
                ...properties
            }
        ]));
const $747cae967af72a91$export$765c3cc11af57952 = (unresolvedInlineComments)=>Object.fromEntries(unresolvedInlineComments.map((annotationId)=>[
            annotationId,
            {
                id: annotationId,
                annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
                state: (0, $cUycv.AnnotationMarkStates).RESOLVED
            }
        ]));
const $747cae967af72a91$var$createCommentsDataMap = (commentsDataMap, propertyUpdate)=>Object.entries(commentsDataMap).reduce((updatedCommentsDataMap, [type, comments])=>({
            ...updatedCommentsDataMap,
            [type]: $747cae967af72a91$var$setCommentProperties(propertyUpdate, comments)
        }), {});
const $747cae967af72a91$var$transformCommentsToIdSets = (dataMap)=>{
    return Object.fromEntries(Object.entries(dataMap).map(([commentId, comment])=>[
            commentId,
            new Set([
                comment.id,
                ...comment.replies ? comment.replies.map(({ id: id })=>id) : []
            ])
        ]));
};
const $747cae967af72a91$export$4022ebdd60549871 = (commentsDataMap)=>({
        inline: $747cae967af72a91$var$transformCommentsToIdSets(commentsDataMap.inline),
        general: $747cae967af72a91$var$transformCommentsToIdSets(commentsDataMap.general)
    });
const $747cae967af72a91$export$9dbbea976afc91ec = (commentsDataMap)=>$747cae967af72a91$var$createCommentsDataMap(commentsDataMap, {
        isUnread: false
    });
const $747cae967af72a91$export$f3aa68d52552526d = (obj)=>Object.values(obj).reduce((combinedSet, nestedObj)=>new Set([
            ...combinedSet,
            ...Object.values(nestedObj).flatMap((set)=>[
                    ...set
                ])
        ]), new Set());
const $747cae967af72a91$var$extractAllComments = (commentsDataMap)=>Object.values(commentsDataMap).flatMap((dataMap)=>Object.values(dataMap));
const $747cae967af72a91$var$excludeDraftComments = (comments)=>comments.filter((comment)=>comment.contentStatus !== 'draft');
const $747cae967af72a91$var$extractUnreadCommentIds = (comments)=>comments.filter((comment)=>comment.isUnread).map((comment)=>comment.id);
const $747cae967af72a91$export$80da35dda4637638 = (commentsDataMap, commentsMarkedAsRead, includeDrafts)=>{
    const allParentComments = includeDrafts ? $747cae967af72a91$var$extractAllComments(commentsDataMap) : $747cae967af72a91$var$excludeDraftComments($747cae967af72a91$var$extractAllComments(commentsDataMap));
    const allCommentReplies = allParentComments.flatMap(({ replies: replies })=>replies);
    const allComments = [
        ...allParentComments,
        ...allCommentReplies
    ];
    const unreadIds = $747cae967af72a91$var$extractUnreadCommentIds(allComments);
    const readIds = $747cae967af72a91$export$f3aa68d52552526d(commentsMarkedAsRead);
    return new Set(unreadIds.filter((id)=>!readIds.has(id)));
};
const $747cae967af72a91$var$extractUnresolvedCommentIds = (comments)=>comments.filter((comment)=>comment.isOpen).map((comment)=>comment.id);
const $747cae967af72a91$export$8407ff9f3ad87778 = (commentsDataMap, includeDrafts)=>{
    const allParentComments = includeDrafts ? $747cae967af72a91$var$extractAllComments(commentsDataMap) : $747cae967af72a91$var$excludeDraftComments($747cae967af72a91$var$extractAllComments(commentsDataMap));
    return $747cae967af72a91$var$extractUnresolvedCommentIds(allParentComments);
};
const $747cae967af72a91$var$COMMENTS_LOCATIONS = {
    INLINE: 'INLINE',
    FOOTER: 'FOOTER'
};
const $747cae967af72a91$export$e25befbc00a116b = (resolvedComments, commentData)=>{
    if (!resolvedComments?.comments?.nodes) return commentData;
    const resolvedCommentNodes = resolvedComments.comments.nodes.filter((node)=>node !== null);
    const updateComments = (comments, locationType, commentType)=>Object.keys(comments).reduce((acc, key)=>{
            const comment = comments[key];
            const resolvedComment = resolvedCommentNodes.find((resolved)=>locationType === $747cae967af72a91$var$COMMENTS_LOCATIONS.INLINE ? resolved.location.inlineMarkerRef === key && resolved.location.type === locationType : resolved.id === key && resolved.location.type === locationType);
            if (resolvedComment && (comment.isOpen || comment.isUnread)) return {
                ...acc,
                [key]: {
                    ...resolvedComment,
                    isOpen: false,
                    isUnread: false,
                    type: commentType
                }
            };
            else return {
                ...acc,
                [key]: comment
            };
        }, {});
    const updatedInlineComments = updateComments(commentData.inline, $747cae967af72a91$var$COMMENTS_LOCATIONS.INLINE, (0, $8i27m.CommentType).INLINE);
    const updatedGeneralComments = updateComments(commentData.general, $747cae967af72a91$var$COMMENTS_LOCATIONS.FOOTER, (0, $8i27m.CommentType).GENERAL);
    return {
        inline: updatedInlineComments,
        general: updatedGeneralComments
    };
};
const $747cae967af72a91$export$4e544898773875e3 = ({ isReply: isReply, threadKey: threadKey, commentType: commentType, commentsDataMap: commentsDataMap, deleteParentComment: deleteParentComment })=>{
    if (isReply || !(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return null;
    const deletedParentComment = {
        [(0, $8i27m.CommentType).INLINE]: {
            [threadKey]: commentsDataMap.inline[threadKey]
        },
        [(0, $8i27m.CommentType).GENERAL]: {}
    };
    deleteParentComment({
        threadKey: threadKey,
        commentType: commentType
    });
    return deletedParentComment;
};
module.exports["getResolvedAnnotationState"] = $747cae967af72a91$export$765c3cc11af57952;
module.exports["getCommentIdsByTypeAndAnnotationId"] = $747cae967af72a91$export$4022ebdd60549871;
module.exports["createReadCommentsDataMap"] = $747cae967af72a91$export$9dbbea976afc91ec;
module.exports["computeUnreadCommentIds"] = $747cae967af72a91$export$80da35dda4637638;
module.exports["computeResolvedCommentIds"] = $747cae967af72a91$export$8407ff9f3ad87778;
module.exports["updateResolvedComments"] = $747cae967af72a91$export$e25befbc00a116b;
module.exports["deleteInlineParentComment"] = $747cae967af72a91$export$4e544898773875e3;

});

parcelRegister("6hmtW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $83FW4 = parcelRequire("83FW4");


var $jil6p = parcelRequire("jil6p");

const $99a81cd20c880202$export$1cacdacf9568d373 = ()=>{
    const context = (0, $42omo.useContext)((0, $83FW4.CommentContext));
    const memoizedCommentService = (0, $42omo.useMemo)(()=>new (0, $jil6p.ContentTypesCommentService)(), []);
    if (!context) return {
        commentService: (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedCommentService : new (0, $jil6p.ContentTypesCommentService)()
    };
    return context;
};
module.exports["useCommentService"] = $99a81cd20c880202$export$1cacdacf9568d373;

});

parcelRegister("83FW4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jil6p = parcelRequire("jil6p");

const $c63b34a18b0f8af5$export$f70cbd0dcaa225fc = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $c63b34a18b0f8af5$export$71e478688b05b68d = ({ children: children })=>{
    const commentService = (0, $42omo.useRef)(new (0, $jil6p.ContentTypesCommentService)()).current;
    (0, $42omo.useEffect)(()=>{
        // Cleanup on unmount
        return ()=>{
            commentService.dispose();
        };
    }, [
        commentService
    ]);
    const handleSelectThread = (0, $42omo.useCallback)((threadId)=>{
        commentService.selectCommentThread(threadId);
    }, [
        commentService
    ]);
    (0, $42omo.useEffect)(()=>{
        commentService.registerSelectThreadHandler(handleSelectThread);
        return ()=>{
            // un-set the handler on component unmount
            commentService.registerSelectThreadHandler(undefined);
        };
    }, [
        commentService,
        handleSelectThread
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            commentService: commentService
        }), [
        commentService
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c63b34a18b0f8af5$export$f70cbd0dcaa225fc.Provider, {
        value: contextValue
    }, children);
};
module.exports["CommentContext"] = $c63b34a18b0f8af5$export$f70cbd0dcaa225fc;
module.exports["CommentProvider"] = $c63b34a18b0f8af5$export$71e478688b05b68d;

});

parcelRegister("jil6p", function(module, exports) {
class $569106325e18c3c1$export$6c0a8b19f951b1bc {
    dispose() {
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
    /**
   * Register a handler for thread selection events
   */ registerSelectThreadHandler(handler) {
        this.selectThreadHandler = handler;
    }
    /**
   * Handle thread selection events
   */ handleSelectThread(threadId) {
        this.selectThreadHandler?.(threadId);
    }
    /**
   * Register a handler for show panel events
   */ registerShowPanelHandler(handler) {
        this.showPanelHandler = handler;
    }
    /**
   * Show the comments panel
   */ showPanel(threadId) {
        this.showPanelHandler?.(threadId);
    }
    /**
   * Register a handler for hide panel events
   */ registerHidePanelHandler(handler) {
        this.hidePanelHandler = handler;
    }
    /**
   * Hide the comments panel
   */ hidePanel() {
        this.hidePanelHandler?.();
    }
    /**
   * Register a handler for select comment thread events
   */ registerSelectCommentThreadHandler(handler) {
        this.selectCommentThreadHandler = handler;
    }
    /**
   * Select a specific comment thread
   */ selectCommentThread(threadId) {
        this.selectCommentThreadHandler?.(threadId);
    }
    /**
   * This is called in databases to register the callback confluence FE
   * will call after a resolved comment has been reopened
   */ registerOnReopenResolvedComment(callback) {
        this.reopenResolvedCommentHandler = callback;
    }
    /**
   * This will be called in confluence FE after we have successfully
   * reopened a resolved comment. This allows databases to re-fetch and re-render
   * the comment
   */ onReopenResolvedComment(commentIds) {
        this.reopenResolvedCommentHandler?.(commentIds);
    }
    /**
   * Register a handler for delete comment events (called by content types)
   */ registerOnDeleteComment(callback) {
        this.onDeleteCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onDeleteComment(threadKey) {
        this.onDeleteCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for update comment events (called by content types)
   */ registerOnUpdateComment(callback) {
        this.onUpdateCommentHandler = callback;
    }
    /**
   * Handle an update comment event (fired by CF)
   */ onUpdateComment(threadKey) {
        this.onUpdateCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for trigger comment panel refresh events (called by content types)
   */ registerTriggerCommentPanelRefresh(handler) {
        this.triggerCommentPanelRefreshHandler = handler;
        // If a refresh was requested while no handler was registered, trigger it now
        // so the newly mounted view refetches immediately.
        if (handler && this.hasPendingCommentPanelRefresh) {
            this.hasPendingCommentPanelRefresh = false;
            handler();
        }
    }
    /**
   * Register a handler for resolve comment events (called by content types)
   */ registerOnResolveComment(callback) {
        this.onResolveCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onResolveComment(threadKey) {
        this.onResolveCommentHandler?.(threadKey);
    }
    /**
   * Trigger a refresh of the comment panel
   */ async triggerCommentPanelRefresh() {
        if (this.triggerCommentPanelRefreshHandler) {
            await this.triggerCommentPanelRefreshHandler();
            return;
        }
        // No handler registered means the panel is likely closed/unmounted.
        // Remember to refresh on next registration.
        this.hasPendingCommentPanelRefresh = true;
    }
    /**
   * Register a handler for update reaction events (called by content types)
   * @param callback - A callback function that will be called when a reaction is updated
   */ registerOnUpdateReaction(callback) {
        this.onUpdateReactionHandler = callback;
    }
    /**
   * Handle an update reaction event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param emojiId - The emoji ID of the reaction
   * @param actionType - The action type of the reaction
   * @returns
   */ onUpdateReaction(threadKey, emojiId, actionType) {
        return this.onUpdateReactionHandler?.(threadKey, emojiId, actionType);
    }
    /**
   * Register a handler for update unread comments events (called by content types)
   * @param handler - A callback function that will be called by content types (whiteboards, databases) to register a handler that CFE can use
   * to notify about the comment being read (e.g. update the unread comments status).
   */ registerOnUpdateUnreadComments(handler) {
        this.onUpdateUnreadCommentsHandler = handler;
    }
    /**
   * Handle an update unread comments event (fired by CF)
   * CFE -> Content Types (whiteboards, databases)
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread
   * @see triggerReadStatusComment for the counterpart method
   */ onUpdateUnreadComments(commentIds, read = false) {
        return this.onUpdateUnreadCommentsHandler?.(commentIds, read);
    }
    /**
   * Register a handler for trigger read status comment events (called by CF)
   * @param handler - A callback function used by CFE to register a handler that can be used when content types notifies CFE about a comment being read.
   */ registerTriggerReadStatusComment(handler) {
        this.triggerReadStatusCommentHandler = handler;
    }
    /**
   * Triggers an update of the unread comments status (fired by content types)
   * Content Types (whiteboards, databases) -> CFE
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread.
   * @see onUpdateUnreadComments for the counterpart method
   */ triggerReadStatusComment(commentIds, read = false) {
        return this.triggerReadStatusCommentHandler?.(commentIds, read);
    }
    constructor(){
        this.selectThreadHandler = void 0;
        this.reopenResolvedCommentHandler = void 0;
        this.showPanelHandler = void 0;
        this.hidePanelHandler = void 0;
        this.selectCommentThreadHandler = void 0;
        this.onDeleteCommentHandler = void 0;
        this.triggerCommentPanelRefreshHandler = void 0;
        // When a refresh is requested while the comments panel is unmounted (no handler
        // registered), we set this flag so the next registration triggers a refetch.
        this.hasPendingCommentPanelRefresh = false;
        this.onUpdateCommentHandler = void 0;
        this.onResolveCommentHandler = void 0;
        this.onUpdateReactionHandler = void 0;
        this.onUpdateUnreadCommentsHandler = void 0;
        this.triggerReadStatusCommentHandler = void 0;
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.hasPendingCommentPanelRefresh = false;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
}
module.exports["ContentTypesCommentService"] = $569106325e18c3c1$export$6c0a8b19f951b1bc;

});

parcelRegister("b4BfG", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $lesF8 = parcelRequire("lesF8");


var $7EEGh = parcelRequire("7EEGh");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $hXzKU = parcelRequire("hXzKU");


var $ep3mz = parcelRequire("ep3mz");


var $7QM6o = parcelRequire("7QM6o");


var $9wGTI = parcelRequire("9wGTI");

const $a75b2138c8eb75e6$export$b9905c4f8315d0a1 = ({ mode: mode, saveHandler: saveHandler, cancelHandler: cancelHandler, onEditorLoaded: onEditorLoaded, onEditorReady: onEditorReady, onEditorContentChanged: onEditorContentChanged, onEditorContentChangedWithData: onEditorContentChangedWithData, afterActivate: afterActivate, content: content, useNewExperienceAbort: useNewExperienceAbort, expandEditor: expandEditor, isCommentsPanel: isCommentsPanel, isFooterComment: isFooterComment = false, isOffline: isOffline = false })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { data: data } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query PageCommentEditorContentOperationsQuery($contentId:ID!$status:[String]){content(id:$contentId status:$status){nodes{id type operations{operation targetType}}}}`, {
        variables: {
            contentId: contentId ?? ''
        },
        skip: !contentId
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const operations = data?.content?.nodes?.[0]?.operations ?? [];
    const canEditPage = operations.filter((op)=>op?.operation === 'update' && op?.targetType === contentType).length > 0;
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment : canEditPage;
    // Simulate the unmount function for the other editor
    (0, $42omo.useEffect)(()=>()=>{
            cancelHandler({
                isEditorAborted: false
            });
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $42omo.useEffect)(()=>{
        const handleExperienceAbort = ()=>{
            const reason = 'Navigated away from page';
            if (mode === 'edit') experienceTracker.abort({
                name: (0, $irVI7.EDIT_PAGE_COMMENT_EXPERIENCE),
                reason: reason
            });
            else if (mode === 'reply') experienceTracker.abort({
                name: (0, $irVI7.REPLY_TO_PAGE_COMMENT_EXPERIENCE),
                reason: reason
            });
            else experienceTracker.abort({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                reason: reason
            });
        };
        if (useNewExperienceAbort) window.addEventListener('beforeunload', handleExperienceAbort);
        return ()=>{
            if (useNewExperienceAbort) window.removeEventListener('beforeunload', handleExperienceAbort);
        };
    }, [
        experienceTracker,
        mode,
        useNewExperienceAbort
    ]);
    const handleSave = (0, $42omo.useCallback)((adf, onSuccess)=>saveHandler({
            adf: adf
        }, onSuccess).catch((err)=>{
            // There is another handler higher up to re-enable the buttons, throw the error to allow for that
            throw err;
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        saveHandler
    ]);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        cancelHandler({
            isEditorAborted: true
        });
    }, [
        cancelHandler
    ]);
    const handleEditorReady = (0, $42omo.useCallback)((editorActions)=>{
        onEditorLoaded();
        onEditorReady?.(editorActions);
    }, [
        onEditorLoaded,
        onEditorReady
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditorWithoutSpinner), {
        pageId: contentId,
        pageType: contentType,
        appearance: isCommentsPanel ? 'chromeless' : 'comment',
        EditorComponent: isCommentsPanel ? (0, $7EEGh.ChromelessEditor) : (0, $lesF8.CommentEditor),
        commentMode: mode,
        commentType: "page",
        spaceId: spaceId,
        onSaveComment: handleSave,
        content: content,
        onCancelComment: handleCancel,
        onEditorReady: handleEditorReady,
        onContentChange: onEditorContentChanged,
        onContentChangeWithData: onEditorContentChangedWithData,
        afterActivation: afterActivate,
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        shouldWarnOnInternalNavigation: true,
        expandEditor: expandEditor,
        showCancelButton: isCommentsPanel || isFooterComment,
        useNewWarningModal: isCommentsPanel || isFooterComment,
        isCommentsPanel: isCommentsPanel,
        isFooterComment: isFooterComment,
        isOffline: isOffline
    });
};
module.exports["PageCommentEditor"] = $a75b2138c8eb75e6$export$b9905c4f8315d0a1;

});

parcelRegister("lesF8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $6cQbn = parcelRequire("6cQbn");

function $0eec8481dd12dbe1$export$4153d6fbc2386422(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: "comment",
        AppearanceComponent: (0, $6cQbn.CommentEditorWithIntl)
    });
}
module.exports["CommentEditor"] = $0eec8481dd12dbe1$export$4153d6fbc2386422;

});

parcelRegister("7EEGh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $1PKpt = parcelRequire("1PKpt");

function $c97a308eea576e63$export$5252bd745392dcde(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: "chromeless",
        AppearanceComponent: (0, $1PKpt.default)
    });
}
module.exports["ChromelessEditor"] = $c97a308eea576e63$export$5252bd745392dcde;

});

parcelRegister("9ImuD", function(module, exports) {

























const $efd7e121efbbc6f0$var$importTranslations = async (locale)=>{
    switch(locale){
        case 'cs-CZ':
            return (parcelRequire("5Ndvb"));
        case 'da-DK':
            return (parcelRequire("iiIXH"));
        case 'de-DE':
            return (parcelRequire("2Tsxu"));
        case 'en-US':
            return (parcelRequire("kcHy2"));
        case 'en-GB':
            return (parcelRequire("itcXa"));
        case 'en-ZZ':
            return (parcelRequire("gchso"));
        case 'es-ES':
            return (parcelRequire("96L2T"));
        case 'fi-FI':
            return (parcelRequire("jaVup"));
        case 'fr-FR':
            return (parcelRequire("97KoO"));
        case 'hu-HU':
            return (parcelRequire("8lubX"));
        case 'it-IT':
            return (parcelRequire("eNKAp"));
        case 'ja-JP':
            return (parcelRequire("eVHt2"));
        case 'ko-KR':
            return (parcelRequire("9l54B"));
        case 'no-NO':
            return (parcelRequire("9lkMC"));
        case 'nl-NL':
            return (parcelRequire("7m1Mp"));
        case 'pl-PL':
            return (parcelRequire("fGUyM"));
        case 'pt-BR':
            return (parcelRequire("4jTFc"));
        case 'ru-RU':
            return (parcelRequire("aHFLL"));
        case 'sv-SE':
            return (parcelRequire("iNU9J"));
        case 'tr-TR':
            return (parcelRequire("iHxcT"));
        case 'th-TH':
            return (parcelRequire("bhuCG"));
        case 'uk-UA':
            return (parcelRequire("lLUi2"));
        case 'vi-VN':
            return (parcelRequire("fL5hj"));
        case 'zh-TW':
            return (parcelRequire("fpOoD"));
        case 'zh-CN':
            return (parcelRequire("ag1zA"));
        default:
            return Promise.resolve({
                default: {}
            });
    }
};
const $efd7e121efbbc6f0$var$fetchTranslations = async (locale)=>{
    const module = await $efd7e121efbbc6f0$var$importTranslations(locale);
    return module.default;
};
var $efd7e121efbbc6f0$export$2e2bcd8739ae039 = $efd7e121efbbc6f0$var$fetchTranslations;
module.exports["default"] = $efd7e121efbbc6f0$export$2e2bcd8739ae039;

});

parcelRegister("5Ndvb", function(module, exports) {

let $437c00935acb14ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $437c00935acb14ea$var$load("i1TuF").then(()=>parcelRequire('1jUpD'));

});

parcelRegister("iiIXH", function(module, exports) {

let $d52cc8f43585e630$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d52cc8f43585e630$var$load("eEPT4").then(()=>parcelRequire('jPcpM'));

});

parcelRegister("2Tsxu", function(module, exports) {

let $21b6db1ee7e67ba5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21b6db1ee7e67ba5$var$load("gkfGT").then(()=>parcelRequire('2HnQV'));

});

parcelRegister("kcHy2", function(module, exports) {

let $eb56b55f48170862$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb56b55f48170862$var$load("6kSRw").then(()=>parcelRequire('9NBPE'));

});

parcelRegister("itcXa", function(module, exports) {

let $d724fbaf6f612dc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d724fbaf6f612dc2$var$load("2dFTF").then(()=>parcelRequire('hIkMa'));

});

parcelRegister("gchso", function(module, exports) {

let $bcab4eeeab7106ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bcab4eeeab7106ed$var$load("auo6z").then(()=>parcelRequire('7hjEd'));

});

parcelRegister("96L2T", function(module, exports) {

let $6a192ae0f9ce7ae7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a192ae0f9ce7ae7$var$load("685rk").then(()=>parcelRequire('3knLh'));

});

parcelRegister("jaVup", function(module, exports) {

let $df5b8bb747e71066$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df5b8bb747e71066$var$load("fp6pG").then(()=>parcelRequire('QPojr'));

});

parcelRegister("97KoO", function(module, exports) {

let $6a48c2662010f84a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a48c2662010f84a$var$load("6bt8l").then(()=>parcelRequire('lTPon'));

});

parcelRegister("8lubX", function(module, exports) {

let $6137b461e0c0d233$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6137b461e0c0d233$var$load("jjvsl").then(()=>parcelRequire('goIHn'));

});

parcelRegister("eNKAp", function(module, exports) {

let $ac69c757ef6ed44a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac69c757ef6ed44a$var$load("bAfbH").then(()=>parcelRequire('gwGzH'));

});

parcelRegister("eVHt2", function(module, exports) {

let $ade81b488ae26811$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ade81b488ae26811$var$load("5Q9X0").then(()=>parcelRequire('56b4I'));

});

parcelRegister("9l54B", function(module, exports) {

let $6cca02a75f916cfb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cca02a75f916cfb$var$load("ePkyJ").then(()=>parcelRequire('69j0k'));

});

parcelRegister("9lkMC", function(module, exports) {

let $6cd63251145b2739$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cd63251145b2739$var$load("hpdFn").then(()=>parcelRequire('7suyn'));

});

parcelRegister("7m1Mp", function(module, exports) {

let $55abf7e453b9933f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55abf7e453b9933f$var$load("8qW90").then(()=>parcelRequire('1l5oU'));

});

parcelRegister("fGUyM", function(module, exports) {

let $b6c6a6ea694df539$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b6c6a6ea694df539$var$load("a1OSV").then(()=>parcelRequire('7azO9'));

});

parcelRegister("4jTFc", function(module, exports) {

let $32541d63110b786f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32541d63110b786f$var$load("8AvOI").then(()=>parcelRequire('cqo8f'));

});

parcelRegister("aHFLL", function(module, exports) {

let $7cae5214955aa781$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7cae5214955aa781$var$load("jxu37").then(()=>parcelRequire('2ob2Z'));

});

parcelRegister("iNU9J", function(module, exports) {

let $db085cfb205ba45c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db085cfb205ba45c$var$load("10YQF").then(()=>parcelRequire('6bYmv'));

});

parcelRegister("iHxcT", function(module, exports) {

let $d9d6005709d91a65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d9d6005709d91a65$var$load("daBgp").then(()=>parcelRequire('eURXY'));

});

parcelRegister("bhuCG", function(module, exports) {

let $8369094a4603e1c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8369094a4603e1c8$var$load("bI6N0").then(()=>parcelRequire('evqpq'));

});

parcelRegister("lLUi2", function(module, exports) {

let $fd99a6c46b5179db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd99a6c46b5179db$var$load("3Qhls").then(()=>parcelRequire('3uadp'));

});

parcelRegister("fL5hj", function(module, exports) {

let $b78f56f44c93f165$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b78f56f44c93f165$var$load("dgXIC").then(()=>parcelRequire('1Aznz'));

});

parcelRegister("fpOoD", function(module, exports) {

let $b39048758b7c76b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b39048758b7c76b0$var$load("jh4hi").then(()=>parcelRequire('am6cJ'));

});

parcelRegister("ag1zA", function(module, exports) {

let $777c9e58e5d8ad11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $777c9e58e5d8ad11$var$load("2AL0H").then(()=>parcelRequire('5vTPX'));

});

parcelRegister("cOau5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kycWk = parcelRequire("kycWk");


var $F4YLX = parcelRequire("F4YLX");


const $831f4393e6328081$export$8c5d88a1b5304a38 = ({ contentId: contentId, isCommentContext: isCommentContext = false })=>{
    return {
        title: 'Redaction',
        type: (0, $kycWk.REDACTION_EXTENSION_TYPE),
        key: 'redaction',
        description: 'Inserts redacted block.',
        icons: {
            // eslint-disable-next-line import/dynamic-import-chunkname
            '48': ()=>(parcelRequire("fSxYU"))
        },
        modules: {
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>(args)=>{
                            const node = args.node;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $F4YLX.TourableRedactionExtensionLoader), {
                                contentId: contentId,
                                extensionNode: node,
                                isCommentContext: isCommentContext
                            });
                        }
                }
            }
        }
    };
};
module.exports["createTourableRedactionExtension"] = $831f4393e6328081$export$8c5d88a1b5304a38;

});

parcelRegister("kycWk", function(module, exports) {
// Extension
const $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1 = 'com.atlassian.guard-premium';
const $a7399ed0bcbe7ac9$export$d20f6356992396b7 = 'false';
var $a7399ed0bcbe7ac9$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
var $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a = /*#__PURE__*/ function(RedactionsTourSteps) {
    RedactionsTourSteps[RedactionsTourSteps["FIRST"] = 0] = "FIRST";
    RedactionsTourSteps[RedactionsTourSteps["SECOND"] = 1] = "SECOND";
    return RedactionsTourSteps;
}({});
const $a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX = 'redactions-tour:';
const $a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $a7399ed0bcbe7ac9$export$4ac8baee730e0515 = {
    REDACTION_EXTENSION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}redaction-extension`,
    TITLE_REDACTION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}title-redaction`,
    // Note: SpotlightTarget already exist on this element, so we must target that one
    SIDEBAR_DETAILS_BUTTON: `${$a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
const $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f = 'https://support.atlassian.com/confluence-cloud/docs/how-redaction-works/';
module.exports["REDACTION_EXTENSION_TYPE"] = $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1;
module.exports["IS_DISMISSED_FLAG"] = $a7399ed0bcbe7ac9$export$d20f6356992396b7;
module.exports["MessageType"] = $a7399ed0bcbe7ac9$export$80edbf15fa61a4db;
module.exports["RedactionsTourSteps"] = $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a;
module.exports["REDACTIONS_TOUR_TARGETS"] = $a7399ed0bcbe7ac9$export$4ac8baee730e0515;
module.exports["READ_MORE_URL"] = $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f;

});

parcelRegister("fSxYU", function(module, exports) {

let $b8f6422d7c09d941$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8f6422d7c09d941$var$load("3XbzG").then(()=>parcelRequire('4s2T0'));

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("i5WUp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $1Whri = parcelRequire("1Whri");


var $c6GJD = parcelRequire("c6GJD");


var $dpPtd = parcelRequire("dpPtd");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $2Rith = parcelRequire("2Rith");

var $fYQcF = parcelRequire("fYQcF");


var $9Rf00 = parcelRequire("9Rf00");

var $au4KV = parcelRequire("au4KV");


var $gWF6I = parcelRequire("gWF6I");


var $9NDUe = parcelRequire("9NDUe");

var $2Gu9D = parcelRequire("2Gu9D");


var $in8wv = parcelRequire("in8wv");


var $kt1Xc = parcelRequire("kt1Xc");


var $2UyBL = parcelRequire("2UyBL");

const $990b0c00f1a7800f$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $990b0c00f1a7800f$var$ANALYTICS_FROM_CODE = 'SMARTLINK';
const $990b0c00f1a7800f$var$DEFAULT_MAX_LINES = 4;
const $990b0c00f1a7800f$var$styles = {
    container: "_11c81o8v"
};
const $990b0c00f1a7800f$var$getContentTypeParam = (contentType)=>contentType === 'page' ? 'PAGE' : contentType === 'blogpost' ? 'BLOGPOST' : null;
const $990b0c00f1a7800f$var$getAnalyticsConfig = (props)=>({
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'aiSnippet',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        additionalAttributes: {
            contentId: props.contentId,
            contentType: props.contentType,
            from: props.from ?? $990b0c00f1a7800f$var$ANALYTICS_FROM_CODE,
            productAttributionOverride: 'confluence'
        },
        enablePlatformEvents: true
    });
const $990b0c00f1a7800f$export$1b2af18ca4bb327b = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
        config: $990b0c00f1a7800f$var$getAnalyticsConfig(props),
        children: /*#__PURE__*/ (0, $l998X.jsx)($990b0c00f1a7800f$export$ac90160f7ae1e32f, {
            ...props
        })
    });
};
const $990b0c00f1a7800f$export$ac90160f7ae1e32f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId, fallbackText: fallbackText, fallbackComponent: fallbackComponent, userId: userId, displayName: displayName, source: source = 'smartlink', maxLines: maxLines = $990b0c00f1a7800f$var$DEFAULT_MAX_LINES, isHidden: isHidden = false, onLoadComplete: onLoadComplete, showFooter: showFooter, showAwareness: showAwareness })=>{
    const [queryRef, loadQuery] = (0, $irOoi.useQueryLoader)((0, $2UyBL.default));
    const isLoadingRef = (0, $42omo.useRef)(true);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { start: start, success: success, failure: failure } = (0, $2Gu9D.useUFOExperience)({
        id: 'ai-snippet-load',
        component: 'ai-snippet',
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult
    });
    const contentTypeParam = $990b0c00f1a7800f$var$getContentTypeParam(contentType);
    const isValidQuery = contentType && cloudId && contentId && contentTypeParam;
    const isEnabledForJira = (0, $dh538.fg)('jira-cc-ai-snippet-gate');
    const isTrackingEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-experiment-tracking', 'isEnabled', false);
    (0, $42omo.useEffect)(()=>{
        if (!isHidden) trackAIInteractionInit();
        return ()=>{
            if (isLoadingRef.current && !isHidden) trackAIInteractionDismiss();
        };
    // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        isLoadingRef.current = !queryRef;
        if (queryRef) {
            if (isTrackingEnabled) success();
            onLoadComplete?.();
        }
    }, [
        queryRef,
        onLoadComplete,
        success,
        isTrackingEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isValidQuery) // Skip query if we don't have valid params as we'll just return the fallback component
        return;
        if (isTrackingEnabled) start();
        loadQuery({
            contentId: contentId,
            contentType: contentTypeParam,
            cloudId: cloudId,
            includeMe: isEnabledForJira
        });
    }, [
        contentId,
        contentTypeParam,
        cloudId,
        loadQuery,
        isValidQuery,
        isEnabledForJira,
        start,
        isTrackingEnabled
    ]);
    if (!isValidQuery) return fallbackComponent;
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $in8wv.AISnippetContent), {
            text: fallbackText,
            contentId: contentId,
            showFooter: false,
            showAwareness: showAwareness,
            source: source,
            isHidden: isHidden,
            maxLines: maxLines
        }),
        onError: (error)=>{
            if (!isHidden) {
                if (isTrackingEnabled) failure({
                    metadata: {
                        errorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                        errorMessage: error.message || 'Unknown error'
                    }
                });
                trackAIResultError({
                    aiErrorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                    aiErrorMessage: error.message || 'Unknown error'
                });
            }
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($990b0c00f1a7800f$var$styles.container),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $au4KV.AIStreamLoading), {}),
                children: queryRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $kt1Xc.AISnippetLoader), {
                    queryRef: queryRef,
                    fallbackText: fallbackText,
                    contentId: contentId,
                    source: source,
                    isHidden: isHidden,
                    maxLines: maxLines,
                    showFooter: showFooter,
                    showAwareness: showAwareness
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $au4KV.AIStreamLoading), {})
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
        children: isEnabledForJira ? content : /*#__PURE__*/ (0, $l998X.jsx)((0, $9Rf00.AIFeedbackPropertiesProvider), {
            entrypointId: $990b0c00f1a7800f$var$SNIPPET_ENTRYPOINT_ID,
            userId: userId,
            displayName: displayName,
            children: content
        })
    });
};
const $990b0c00f1a7800f$export$c9a07cebec67e951 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.RelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($990b0c00f1a7800f$export$1b2af18ca4bb327b, {
            ...props
        })
    });
};
module.exports["AISnippetWithRelayEnvironment"] = $990b0c00f1a7800f$export$c9a07cebec67e951;

});

parcelRegister("9Rf00", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");

const $a07f007de41f1483$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $a07f007de41f1483$export$f906c21bacdb2d8e = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $a07f007de41f1483$export$e9e654940dee103b = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $a07f007de41f1483$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { locale: intlLocale } = (0, $8C5kA.default)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $42omo.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId,
            displayName: displayName
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        displayName
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($a07f007de41f1483$export$f906c21bacdb2d8e.Provider, {
        value: contextValue,
        children: children
    });
};
const $a07f007de41f1483$export$ff3deb4415ee32e3 = ()=>{
    const context = (0, $42omo.useContext)($a07f007de41f1483$export$f906c21bacdb2d8e);
    if (context === undefined) throw new Error('useAIFeedbackProperties must be used within a AIFeedbackPropertiesProvider');
    return context;
};
module.exports["AIFeedbackPropertiesProvider"] = $a07f007de41f1483$export$e9e654940dee103b;
module.exports["useAIFeedbackProperties"] = $a07f007de41f1483$export$ff3deb4415ee32e3;

});

parcelRegister("au4KV", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $igbBp = parcelRequire("igbBp");

const $fe7ceaa3509ef4fa$var$styles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle'
});
const $fe7ceaa3509ef4fa$var$i18n = (0, $cgtv4.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        padding: padding,
        xcss: $fe7ceaa3509ef4fa$var$styles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.025",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $igbBp.GeneratingStreamAnimation), {
                    alt: formatMessage($fe7ceaa3509ef4fa$var$i18n.generatingSummaryAnimationAlt)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$fe7ceaa3509ef4fa$var$i18n.generatingSummaryText
                })
            ]
        })
    });
};
module.exports["AIStreamLoading"] = $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef;

});

parcelRegister("igbBp", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $dd45fdb3e38904f6$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "#0C66E4",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "#1D7AFC",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "#388BFF",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
module.exports["GeneratingStreamAnimation"] = $dd45fdb3e38904f6$export$3709887a1be0e305;

});

parcelRegister("2Gu9D", function(module, exports) {
/* eslint-disable perfectionist/sort-object-types */ 
var $42omo = parcelRequire("42omo");


var $5aVN7 = parcelRequire("5aVN7");

const $b5fd5f50ef335781$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $42omo.useRef)(new (0, $5aVN7.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $42omo.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $42omo.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $42omo.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $42omo.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $42omo.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["useUFOExperience"] = $b5fd5f50ef335781$export$fade2d05a6320d49;

});

parcelRegister("in8wv", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $e6pbP = parcelRequire("e6pbP");


var $c6GJD = parcelRequire("c6GJD");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $fYQcF = parcelRequire("fYQcF");


var $aFC6o = parcelRequire("aFC6o");

var $iuafG = parcelRequire("iuafG");

var $aXh2V = parcelRequire("aXh2V");


var $fXbFR = parcelRequire("fXbFR");

const $b015c3cc5e677900$var$MAU_CRITERIA_DWELL_TIME = 3000;
const $b015c3cc5e677900$var$sanitizeMarkdown = (text)=>{
    if (!text) return '';
    return text.replace(/={4,}/g, '===') // h1 headers
    .replace(/-{4,}/g, '---'); // h2 headers
};
const $b015c3cc5e677900$export$3cf37822a11d3ff3 = ({ text: text, contentId: contentId, showFooter: showFooter = true, showAwareness: showAwareness = false, source: source, isHidden: isHidden, maxLines: maxLines })=>{
    const ref = (0, $42omo.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(ref, 250);
    const { trackAIResultView: trackAIResultView } = (0, $fYQcF.useAIEventsInstrumentation)();
    // This is needed to keep the snippet value in scope when running the unmount effect
    const snippetValueRef = (0, $42omo.useRef)(text);
    const isExperimentEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-fixes-1025', 'isEnabled', false);
    (0, $42omo.useEffect)(()=>{
        const currentText = snippetValueRef.current;
        return ()=>{
            const dwellTime = getDwellTime();
            if (!isHidden) {
                if (showFooter && currentText && dwellTime >= $b015c3cc5e677900$var$MAU_CRITERIA_DWELL_TIME) trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: true
                    }
                });
                else trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: showFooter && !!currentText
                    },
                    doesNotMeetMAUCriteria: true
                });
            }
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.100",
        ref: ref,
        children: [
            showAwareness && /*#__PURE__*/ (0, $l998X.jsx)((0, $aFC6o.AIAwareness), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                maxLines: maxLines,
                children: isExperimentEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
                    options: {
                        disableParsingRawHTML: true
                    },
                    children: $b015c3cc5e677900$var$sanitizeMarkdown(text || '')
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
                    children: text || ''
                })
            }),
            showFooter && text && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iuafG.AIDisclaimer), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $aXh2V.AIFeedbackComponent), {
                        contentId: contentId
                    })
                ]
            })
        ]
    });
};
module.exports["AISnippetContent"] = $b015c3cc5e677900$export$3cf37822a11d3ff3;

});

parcelRegister("aFC6o", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $lAFHW = parcelRequire("lAFHW");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $eLAh6 = parcelRequire("eLAh6");

const $902b2990c09c9892$var$styles = {
    text: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $902b2990c09c9892$export$fde99ed387d90f1 = ({ variant: variant = 'summary' })=>{
    const MESSAGE_MAP = {
        summary: (0, $eLAh6.i18n).rovoAwarenessMessage,
        define: (0, $eLAh6.i18n).rovoAwarenessDefineMessage
    };
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const message = MESSAGE_MAP[variant];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($902b2990c09c9892$var$styles.text),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                    size: "xxsmall",
                    appearance: "brand",
                    shouldUseNewLogoDesign: true
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtlest",
                    children: formatMessage(message)
                })
            ]
        })
    });
};
module.exports["AIAwareness"] = $902b2990c09c9892$export$fde99ed387d90f1;

});

parcelRegister("eLAh6", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $8e99185ad20025a1$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    rovoAwarenessMessage: {
        id: "ai-awareness.rovoAwarenessMessage",
        defaultMessage: "Summary by Rovo"
    },
    rovoAwarenessDefineMessage: {
        id: "ai-awareness-define.message",
        defaultMessage: "Definition by Rovo"
    }
});
module.exports["i18n"] = $8e99185ad20025a1$export$a7357cdd1f0b0168;

});

parcelRegister("iuafG", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $fSglY = parcelRequire("fSglY");

const $8fdbd961e8c69c33$var$styles = {
    text: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $8fdbd961e8c69c33$export$e0542ba0c737fe5c = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const disclaimerMessage = formatMessage((0, $fSglY.i18n).disclaimerMessage);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($8fdbd961e8c69c33$var$styles.text),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest",
            children: disclaimerMessage
        })
    });
};
module.exports["AIDisclaimer"] = $8fdbd961e8c69c33$export$e0542ba0c737fe5c;

});

parcelRegister("fSglY", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $fe37a92cb7b3dd3c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    disclaimerMessage: {
        id: "ai-disclaimer.disclaimerMessage",
        defaultMessage: "Uses AI. Verify results."
    }
});
module.exports["i18n"] = $fe37a92cb7b3dd3c$export$a7357cdd1f0b0168;

});

parcelRegister("aXh2V", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $eEA8O = parcelRequire("eEA8O");


var $biiXa = parcelRequire("biiXa");


var $dpPtd = parcelRequire("dpPtd");


var $3sFtD = parcelRequire("3sFtD");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $6fnsQ = parcelRequire("6fnsQ");


var $3gadb = parcelRequire("3gadb");


var $9Rf00 = parcelRequire("9Rf00");


var $aFwxm = parcelRequire("aFwxm");

const $00b0d3bf57a2c2c6$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $00b0d3bf57a2c2c6$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $00b0d3bf57a2c2c6$var$i18n = (0, $cgtv4.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Good response"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Bad response"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    improveAtlassianTextAppify: {
        id: "quick-summary.feedback.improve-atlassian-appify",
        defaultMessage: "I\u2019d like to help improve Atlassian apps by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $00b0d3bf57a2c2c6$var$PrivacyPolicyLink = ({ link: link })=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__confluence-ai') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$00b0d3bf57a2c2c6$var$i18n.privacyPolicyLink
        })
    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $l998X.jsx)("a", {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$00b0d3bf57a2c2c6$var$i18n.privacyPolicyLink
        })
    });
const $00b0d3bf57a2c2c6$var$ResearchGroupLink = ({ link: link })=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__confluence-ai') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$00b0d3bf57a2c2c6$var$i18n.researchGroupLink
        })
    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $l998X.jsx)("a", {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$00b0d3bf57a2c2c6$var$i18n.researchGroupLink
        })
    });
const $00b0d3bf57a2c2c6$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...$00b0d3bf57a2c2c6$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$PrivacyPolicyLink, {
                link: $00b0d3bf57a2c2c6$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $00b0d3bf57a2c2c6$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $dh538.fg)('product-terminology-refresh') ? $00b0d3bf57a2c2c6$var$i18n.improveAtlassianTextAppify : $00b0d3bf57a2c2c6$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$ResearchGroupLink, {
                link: $00b0d3bf57a2c2c6$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $00b0d3bf57a2c2c6$var$DislikeIconWrapperXCSS = (0, $ecnYn.xcss)({
    transform: 'rotate(180deg)'
});
const $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS = (0, $ecnYn.xcss)({
    height: '24px',
    width: '24px'
});
const $00b0d3bf57a2c2c6$export$f9f34317e5bc3551 = ({ contentId: contentId })=>{
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $42omo.useState)(false);
    const feedbackCollectorProperties = (0, $9Rf00.useAIFeedbackProperties)();
    const [sentiment, setSentiment] = (0, $42omo.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const feedbackContextString = `contentId: ${contentId} sentiment: ${sentiment}${feedbackCollectorProperties.feedbackContext.length > 0 ? ` ${feedbackCollectorProperties.feedbackContext}` : ''}`;
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($00b0d3bf57a2c2c6$var$i18n.flagTitle),
            description: formatMessage($00b0d3bf57a2c2c6$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                spacing: "spacious",
                color: `var(--ds-icon-success, ${(0, $6fnsQ.G300)})`,
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const onLikeClicked = ()=>{
        setIsFeedbackOpen(true);
        setSentiment('good');
    };
    const onDislikeClicked = ()=>{
        setIsFeedbackOpen(true);
        setSentiment('bad');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        role: "none",
        onClick: (e)=>e.stopPropagation(),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    hideTooltipOnMouseDown: true,
                    content: formatMessage($00b0d3bf57a2c2c6$var$i18n.likeTooltip),
                    position: "top",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "subtle",
                            "aria-label": formatMessage($00b0d3bf57a2c2c6$var$i18n.likeTooltip),
                            spacing: "none",
                            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $aFwxm.ThumbIcon), {
                                isSelected: hasGoodFeedbackBeenSubmitted
                            }),
                            onClick: onLikeClicked,
                            testId: "feedback-like-button",
                            isDisabled: hasGoodFeedbackBeenSubmitted
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    hideTooltipOnMouseDown: true,
                    content: formatMessage($00b0d3bf57a2c2c6$var$i18n.dislikeTooltip),
                    position: "top",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "subtle",
                            "aria-label": formatMessage($00b0d3bf57a2c2c6$var$i18n.dislikeTooltip),
                            spacing: "none",
                            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: $00b0d3bf57a2c2c6$var$DislikeIconWrapperXCSS,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aFwxm.ThumbIcon), {
                                    isSelected: hasBadFeedbackBeenSubmitted
                                })
                            }),
                            onClick: onDislikeClicked,
                            testId: "feedback-dislike-button",
                            isDisabled: hasBadFeedbackBeenSubmitted
                        })
                    })
                }),
                isFeedbackOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $biiXa.default), {
                    locale: feedbackCollectorProperties.locale,
                    onSubmit: onFeedbackSubmit,
                    onClose: ()=>setIsFeedbackOpen(false),
                    atlassianAccountId: feedbackCollectorProperties.userId,
                    name: feedbackCollectorProperties.displayName,
                    entrypointId: feedbackCollectorProperties.entrypointId,
                    summaryPlaceholder: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackSummaryPlaceholder),
                    additionalFields: [
                        {
                            id: feedbackCollectorProperties.feedbackContextId,
                            value: feedbackContextString
                        }
                    ],
                    feedbackTitle: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackTitle),
                    showTypeField: false,
                    customTextAreaLabel: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackSummaryTitle),
                    canBeContactedLabel: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$CanContactLabel, {}),
                    enrolInResearchLabel: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$EnrolLabel, {})
                })
            ]
        })
    });
};
module.exports["AIFeedbackComponent"] = $00b0d3bf57a2c2c6$export$f9f34317e5bc3551;

});

parcelRegister("biiXa", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c4c27c8e6323826$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeedbackFlag", () => (parcelRequire("29DUH")).default);


var $hrGQb = parcelRequire("hrGQb");


var $29DUH = parcelRequire("29DUH");


var $3c4c27c8e6323826$export$2e2bcd8739ae039 = (0, $hrGQb.default);

});

parcelRegister("hrGQb", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $iA9co = parcelRequire("iA9co");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $2KPHZ = parcelRequire("2KPHZ");


var $gpfq4 = parcelRequire("gpfq4");


var $8zkrp = parcelRequire("8zkrp");

const $6b78f3070669f383$var$MAX_SUMMARY_LENGTH_CHARS = 100;
const $6b78f3070669f383$var$singleLineTruncatedText = (text, length = $6b78f3070669f383$var$MAX_SUMMARY_LENGTH_CHARS)=>{
    const singleLineText = text.replace(/\n/g, ' ');
    return (0, $gpfq4.default)(singleLineText, length);
};
class $6b78f3070669f383$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    async componentDidMount() {
        const anonymousFeedback = !await this.shouldShowOptInCheckboxesNew();
        this.setState({
            anonymousFeedback: anonymousFeedback
        });
    }
    getGatewayUrl() {
        const { customGatewayUrl: customGatewayUrl, url: url } = this.props;
        if (customGatewayUrl) return customGatewayUrl;
        if (url) return url;
        return $6b78f3070669f383$export$2e2bcd8739ae039.defaultProps.url;
    }
    getFeedbackUrl() {
        const { customFeedbackUrl: customFeedbackUrl, url: url } = this.props;
        if (customFeedbackUrl) return customFeedbackUrl;
        if (url) return url;
        return $6b78f3070669f383$export$2e2bcd8739ae039.defaultProps.url;
    }
    getPackageVersion() {
        return "0.0.0-use.local";
    }
    async getEntitlementInformation() {
        const url = this.getGatewayUrl();
        // jira / confluence / bitbucket / trello
        let productName;
        let productEntitlement;
        let entitlementDetails;
        let productKey;
        if (window.location.host.includes('bitbucket.org')) {
            productName = 'Bitbucket';
            productKey = 'bitbucket';
            entitlementDetails = JSON.parse(JSON.stringify(document.querySelector('meta[id="bb-bootstrap"]')?.getAttribute('data-current-user')));
            const hasPremium = entitlementDetails['hasPremium'];
            productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
        } else if ([
            'trellis.coffee',
            'trello.com'
        ].includes(window.location.host)) {
            productName = 'Trello';
            productKey = 'trello';
        } else {
            if (document.querySelector('meta[id="confluence-context-path"]')) {
                productName = 'Confluence';
                productKey = 'pricingplan.confluence.ondemand';
            } else {
                productName = 'Jira';
                productKey = 'jira-software.ondemand';
            }
            try {
                entitlementDetails = await fetch(`${url}/customer-context/entitlements/${window.location.host}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ...(0, $2KPHZ.isApiGatewayUrl)(url) ? {
                        credentials: 'include'
                    } : {}
                });
            } catch (e) {
                entitlementDetails = undefined;
            }
        }
        let entitlement;
        const entitlementInformation = [];
        const cloudSiteId = entitlementDetails?.cloudSiteId || '';
        if (entitlementDetails?.children) entitlement = entitlementDetails?.children.find((entitlement)=>{
            return entitlement.key === productKey;
        });
        entitlementInformation.push({
            id: 'product',
            value: productName ? productName?.toLowerCase() : ''
        }, {
            id: 'hostingType',
            value: entitlement?.product ? entitlement.product.hostingType : 'CLOUD'
        }, {
            id: 'entitlementEdition',
            value: productEntitlement ?? ''
        }, {
            id: 'cloudId',
            value: cloudSiteId
        });
        return entitlementInformation;
    }
    getTypeFieldValue(dtype) {
        switch(dtype){
            case 'bug':
                return this.props.typeBugDefaultValue;
            case 'comment':
                return this.props.typeCommentDefaultValue;
            case 'suggestion':
                return this.props.typeSuggestionDefaultValue;
            case 'question':
                return this.props.typeQuestionDefaultValue;
            case 'empty':
            default:
                return this.props.typeEmptyDefaultValue;
        }
    }
    async getAtlassianID() {
        const { atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails } = this.props;
        try {
            if (atlassianAccountId || !shouldGetEntitlementDetails) return atlassianAccountId;
            const url = this.getGatewayUrl();
            const result = await fetch(`${url}/me`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(0, $2KPHZ.isApiGatewayUrl)(url) ? {
                    credentials: 'include'
                } : {}
            });
            const json = await result.json();
            return json.account_id;
        } catch (e) {
            return undefined;
        }
    }
    shouldShowOptInCheckboxes() {
        if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
        if (this.props.atlassianAccountId) return true;
        let response;
        this.getAtlassianID().then((result)=>{
            response = result !== undefined;
        }).catch(()=>{
            response = false;
        });
        // @ts-ignore
        return response;
    }
    shouldShowOptInCheckboxesNew() {
        return new Promise((resolve)=>{
            if (this.props.anonymousFeedback) resolve(!this.props.anonymousFeedback);
            if (this.props.atlassianAccountId) resolve(true);
            this.getAtlassianID().then((result)=>{
                resolve(result !== undefined);
            }).catch(()=>{
                resolve(false);
            });
        });
    }
    getDescription(formValues) {
        return formValues.description || this.props.descriptionDefaultValue;
    }
    getSummary(formValues) {
        return $6b78f3070669f383$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
    }
    getCustomerName() {
        return this.props.name ?? this.props.customerNameDefaultValue;
    }
    addEmailToContext() {
        const contextField = this.props.additionalFields.find((field)=>{
            return field.id === 'customfield_10047';
        });
        if (contextField) contextField.value = `${contextField.value}
        email: ${this.props.email}`;
        else this.props.additionalFields.push({
            id: 'customfield_10047',
            value: `email: ${this.props.email}`
        });
    }
    addAccountIdToContext(atlassianID) {
        if (atlassianID) {
            const contextField = this.props.additionalFields.find((field)=>{
                return field.id === 'customfield_10047';
            });
            if (contextField) contextField.value = `${contextField.value}
			atlassian-account-id: ${atlassianID}`;
        }
    }
    async mapFormToJSD(formValues) {
        let entitlementInformation = null;
        if (this.props?.shouldGetEntitlementDetails) entitlementInformation = await this.getEntitlementInformation();
        if (this.props?.email) this.addEmailToContext();
        const atlassianID = await this.getAtlassianID();
        this.addAccountIdToContext(atlassianID);
        return {
            fields: [
                ...entitlementInformation !== null && entitlementInformation || [],
                this.props.showTypeField ? {
                    id: this.props.typeFieldId,
                    value: this.getTypeFieldValue(formValues.type)
                } : undefined,
                {
                    id: this.props.summaryFieldId,
                    value: this.getSummary(formValues)
                },
                {
                    id: this.props.descriptionFieldId,
                    value: this.getDescription(formValues)
                },
                {
                    id: 'aaidOrHash',
                    value: formValues.canBeContacted ? atlassianID : undefined
                },
                {
                    id: this.props.customerNameFieldId,
                    value: this.getCustomerName()
                },
                formValues.canBeContacted ? {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedAgreeValue
                } : {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedDeclineValue
                },
                formValues.enrollInResearchGroup ? {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchAgreeValue
                } : {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchDeclineValue
                },
                ...this.props.additionalFields
            ].filter(Boolean)
        };
    }
    render() {
        const anonymousFeedback = !this.shouldShowOptInCheckboxes();
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $8zkrp.default), {
            customContent: this.props.customContent,
            feedbackTitle: this.props.feedbackTitle,
            feedbackTitleDetails: this.props.feedbackTitleDetails,
            showTypeField: this.props.showTypeField,
            showDefaultTextFields: this.props.showDefaultTextFields,
            hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
            canBeContactedLabel: this.props.canBeContactedLabel,
            enrolInResearchLabel: this.props.enrolInResearchLabel,
            summaryPlaceholder: this.props.summaryPlaceholder,
            submitButtonLabel: this.props.submitButtonLabel,
            cancelButtonLabel: this.props.cancelButtonLabel,
            feedbackGroupLabels: this.props.feedbackGroupLabels,
            onSubmit: this.postFeedback,
            onClose: this.props.onClose,
            locale: this.props.locale,
            anonymousFeedback: (0, $dh538.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
            selectLabel: this.props.selectLabel,
            customTextAreaLabel: this.props.customTextAreaLabel,
            customFeedbackOptions: this.props.customFeedbackOptions,
            shouldReturnFocusRef: this.props.shouldReturnFocusRef,
            disableSubmitButton: this.props.disableSubmitButton,
            ...(0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                enrolInResearchLink: this.props.enrolInResearchLink,
                canBeContactedLink: this.props.canBeContactedLink
            },
            showRequiredFieldsSummary: this.props.showRequiredFieldsSummary
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            anonymousFeedback: true
        };
        this.postFeedback = async (formValues)=>{
            const entrypointId = this.props.entrypointId;
            let fetchUrl = this.getFeedbackUrl();
            // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
            if (entrypointId) {
                const formData = await this.mapFormToJSD(formValues);
                const body = {
                    feedback: {
                        entrypointId: this.props.entrypointId,
                        entrypointUiVersion: this.getPackageVersion(),
                        ...formData
                    }
                };
                if ((0, $2KPHZ.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                else if (!this.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                const postData = (0, $iA9co.Buffer).from(JSON.stringify(body)).toString('base64');
                fetch(`${fetchUrl}/v2/feedback`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: postData
                    }),
                    credentials: 'include'
                });
            }
            this.props.onClose();
            // slightly delay confirming submit since we don't wait for the REST call to succeed
            //
            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
            //
            setTimeout(()=>this.props.onSubmit(formValues), this.props.timeoutOnSubmit);
        };
    }
}
$6b78f3070669f383$export$2e2bcd8739ae039.defaultProps = {
    locale: 'en',
    url: '/gateway/api',
    shouldGetEntitlementDetails: true,
    canBeContactedFieldId: 'customfield_10043',
    canBeContactedAgreeValue: [
        {
            id: '10109'
        }
    ],
    canBeContactedDeclineValue: [
        {
            id: '10111'
        }
    ],
    additionalFields: [],
    customerNameFieldId: 'customfield_10045',
    customerNameDefaultValue: 'unknown',
    descriptionFieldId: 'description',
    descriptionDefaultValue: '',
    enrollInResearchFieldId: 'customfield_10044',
    enrollInResearchAgreeValue: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDeclineValue: [
        {
            id: '10112'
        }
    ],
    summaryFieldId: 'summary',
    summaryDefaultValue: '',
    summaryTruncateLength: 100,
    timeoutOnSubmit: 700,
    typeFieldId: 'customfield_10042',
    typeBugDefaultValue: {
        id: '10105'
    },
    typeCommentDefaultValue: {
        id: '10106'
    },
    typeSuggestionDefaultValue: {
        id: '10107'
    },
    typeQuestionDefaultValue: {
        id: '10108'
    },
    typeEmptyDefaultValue: {
        id: 'empty'
    },
    showTypeField: true,
    showDefaultTextFields: true,
    anonymousFeedback: false,
    onClose: ()=>{},
    onSubmit: ()=>{}
};
module.exports["default"] = $6b78f3070669f383$export$2e2bcd8739ae039;

});

parcelRegister("2KPHZ", function(module, exports) {
const $defa15de0313af4d$export$f0f6fc934288a17c = (url)=>[
        '/gateway/api'
    ].includes(url);
module.exports["isApiGatewayUrl"] = $defa15de0313af4d$export$f0f6fc934288a17c;

});

parcelRegister("gpfq4", function(module, exports) {
$parcel$export(module.exports, "default", () => $bab40c5fbb12059f$export$2e2bcd8739ae039);
function $bab40c5fbb12059f$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

});

parcelRegister("8zkrp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $eEA8O = parcelRequire("eEA8O");


var $7gpC4 = parcelRequire("7gpC4");


var $fzqvY = parcelRequire("fzqvY");

var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");

var $kuB2l = parcelRequire("kuB2l");

var $jVhgp = parcelRequire("jVhgp");


var $2Nwuj = parcelRequire("2Nwuj");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $dh538 = parcelRequire("dh538");


var $aoVih = parcelRequire("aoVih");


var $2gD2K = parcelRequire("2gD2K");


var $9EtP6 = parcelRequire("9EtP6");


var $6fnsQ = parcelRequire("6fnsQ");


var $fSdY7 = parcelRequire("fSdY7");


var $giCws = parcelRequire("giCws");

const $27c5bd5943874410$var$LinkWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        },
        children: children
    });
};
const $27c5bd5943874410$var$FeedbackForm = ({ showTypeField: showTypeField = true, showDefaultTextFields: showDefaultTextFields = true, customContent: customContent, onClose: onClose, onSubmit: onSubmit, feedbackTitle: feedbackTitle, feedbackTitleDetails: feedbackTitleDetails, feedbackGroupLabels: feedbackGroupLabels, summaryPlaceholder: summaryPlaceholder, canBeContactedLabel: canBeContactedLabel, canBeContactedLink: canBeContactedLink, enrolInResearchLabel: enrolInResearchLabel, enrolInResearchLink: enrolInResearchLink, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, anonymousFeedback: anonymousFeedback, hasDescriptionDefaultValue: hasDescriptionDefaultValue, selectLabel: selectLabel, customTextAreaLabel: customTextAreaLabel, customFeedbackOptions: customFeedbackOptions = [], shouldReturnFocusRef: shouldReturnFocusRef, disableSubmitButton: disableSubmitButton, showRequiredFieldsSummary: showRequiredFieldsSummary = true })=>{
    const [canBeContacted, setCanBeContacted] = (0, $42omo.useState)(false);
    const [description, setDescription] = (0, $42omo.useState)('');
    const [enrollInResearchGroup, setEnrollInResearchGroup] = (0, $42omo.useState)(false);
    const [type, setType] = (0, $42omo.useState)('empty');
    const [isSubmitting, setIsSubmitting] = (0, $42omo.useState)(false);
    const [validationErrors, setValidationErrors] = (0, $42omo.useState)({});
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isTypeSelected = ()=>type !== 'empty';
    const canShowTextField = isTypeSelected() || !showTypeField;
    const hasDescription = description || hasDescriptionDefaultValue;
    // Feature flag determines validation behavior
    const useNewValidation = (0, $dh538.fg)('feedback-collector-custom-validation');
    const isDisabled = useNewValidation ? isSubmitting || disableSubmitButton // New: only disable when submitting or explicitly disabled
     : disableSubmitButton || (showTypeField ? !isTypeSelected() || !hasDescription : !hasDescription); // Old: disable based on form validation
    const getValidationErrors = ()=>{
        const errors = {};
        // Validate type selection if showTypeField is true
        if (showTypeField && !isTypeSelected()) errors.type = formatMessage((0, $fSdY7.messages).validationErrorTypeRequired);
        // Validate description if showDefaultTextFields is true
        if (showDefaultTextFields && !hasDescription) errors.description = formatMessage((0, $fSdY7.messages).validationErrorDescriptionRequired);
        return errors;
    };
    const getFieldLabels = (record)=>({
            bug: record?.bug?.fieldLabel || formatMessage((0, $fSdY7.messages).formBugLabel),
            comment: record?.comment?.fieldLabel || formatMessage((0, $fSdY7.messages).formCommentLabel),
            suggestion: record?.suggestion?.fieldLabel || formatMessage((0, $fSdY7.messages).formSuggestionLabel),
            question: record?.question?.fieldLabel || formatMessage((0, $fSdY7.messages).formQuestionLabel),
            empty: record?.empty?.fieldLabel || formatMessage((0, $fSdY7.messages).formEmptyLabel),
            not_relevant: record?.not_relevant?.fieldLabel || formatMessage((0, $fSdY7.messages).formNotRelevantLabel),
            not_accurate: record?.not_accurate?.fieldLabel || formatMessage((0, $fSdY7.messages).formNotAccurateLabel),
            too_slow: record?.too_slow?.fieldLabel || formatMessage((0, $fSdY7.messages).formTooSlowLabel),
            unhelpful_links: record?.unhelpful_links?.fieldLabel || formatMessage((0, $fSdY7.messages).formUnhelpfulLinksLabel),
            other: record?.other?.fieldLabel || formatMessage((0, $fSdY7.messages).formOtherLabel)
        });
    const getSelectOptions = (record)=>[
            {
                label: record?.question?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: record?.comment?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: record?.bug?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: record?.suggestion?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    const getDefaultPlaceholder = (record)=>record?.empty?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionDefaultPlaceholder);
    const focusRef = (0, $42omo.useRef)();
    const selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    const renderContactLabelAppify = ()=>{
        if ((0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $fSdY7.messages).canBeContactedLabelAppifyWithoutLink;
        return (0, $fSdY7.messages).canBeContactedLabelAppify;
    };
    const renderContactLabel = ()=>{
        if ((0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $fSdY7.messages).canBeContactedLabelWithoutLink;
        return (0, $fSdY7.messages).canBeContactedLabel;
    };
    const requiredFieldsSummary = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $l998X.jsxs)("p", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: `var(--ds-text-subtle, ${(0, $6fnsQ.N300)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-300, 24px)"
        },
        children: [
            formatMessage((0, $fSdY7.messages).requiredFieldsSummary),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $jVhgp.default), {})
        ]
    });
    const feedbackIsAnonymous = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $l998X.jsx)("p", {
        children: formatMessage((0, $fSdY7.messages).feedbackIsAnonymous)
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true,
        children: (0, $dh538.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $fzqvY.default), {
            onSubmit: async ()=>{
                if (useNewValidation) {
                    // New validation: validate on submit and show errors
                    const errors = getValidationErrors();
                    // If there are validation errors, show them and don't submit
                    if (Object.keys(errors).length > 0) {
                        setValidationErrors(errors);
                        return;
                    }
                }
                // Submit the form (both old and new validation paths reach here)
                setIsSubmitting(true);
                try {
                    await onSubmit({
                        canBeContacted: canBeContacted,
                        description: description,
                        enrollInResearchGroup: enrollInResearchGroup,
                        type: type
                    });
                } finally{
                    setIsSubmitting(false);
                }
            },
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                        children: feedbackTitle || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $fSdY7.messages).feedbackTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                    children: [
                        (0, $dh538.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary,
                        feedbackTitleDetails,
                        customContent,
                        showTypeField ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                            name: "topic",
                            label: selectLabel || formatMessage((0, $fSdY7.messages).selectionOptionDefaultLabel),
                            isRequired: true,
                            children: ({ fieldProps: { id: id, ...restProps } })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                                            ...restProps,
                                            onChange: (option)=>{
                                                if (!option || option instanceof Array) return;
                                                setType(option.value);
                                                // Clear validation error when user selects a type (only for new validation)
                                                if (useNewValidation && validationErrors.type) setValidationErrors((prev)=>({
                                                        ...prev,
                                                        type: undefined
                                                    }));
                                            },
                                            menuPortalTarget: document.body,
                                            styles: {
                                                menuPortal: (base)=>({
                                                        ...base,
                                                        zIndex: 9999
                                                    })
                                            },
                                            options: selectOptions,
                                            // @ts-ignore
                                            ref: focusRef,
                                            placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                                            inputId: id
                                        }),
                                        useNewValidation && validationErrors.type && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                            children: validationErrors.type
                                        })
                                    ]
                                })
                        }) : null,
                        showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                    label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $fSdY7.messages).defaultCustomTextAreaLabel),
                                    isRequired: true,
                                    name: "description",
                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                                                    ...fieldProps,
                                                    name: "foo",
                                                    minimumRows: 6,
                                                    placeholder: summaryPlaceholder || undefined,
                                                    onChange: (e)=>{
                                                        setDescription(e.target.value);
                                                        // Clear validation error when user types
                                                        if (useNewValidation && validationErrors.description) setValidationErrors((prev)=>({
                                                                ...prev,
                                                                description: undefined
                                                            }));
                                                    },
                                                    value: description
                                                }),
                                                useNewValidation && validationErrors.description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                    children: validationErrors.description
                                                })
                                            ]
                                        })
                                }),
                                !anonymousFeedback && /*#__PURE__*/ (0, $l998X.jsxs)((0, $kuB2l.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)("legend", {
                                            "aria-hidden": false,
                                            hidden: true,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                ...(0, $fSdY7.messages).optInOptionsLegend
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                            name: "can-be-contacted",
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                            ...fieldProps,
                                                            "aria-describedby": undefined,
                                                            label: canBeContactedLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                                ...(0, $dh538.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                                                                ...!(0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                                                                    values: {
                                                                        a: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                                href: "https://www.atlassian.com/legal/privacy-policy",
                                                                                target: "_blank",
                                                                                children: chunks
                                                                            })
                                                                    }
                                                                }
                                                            }),
                                                            onChange: (event)=>setCanBeContacted(event.target.checked)
                                                        }),
                                                        canBeContactedLabel && canBeContactedLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                            children: canBeContactedLink
                                                        }),
                                                        !canBeContactedLabel && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                href: "https://www.atlassian.com/legal/privacy-policy",
                                                                target: "_blank",
                                                                children: formatMessage((0, $fSdY7.messages).privacyPolicy)
                                                            })
                                                        })
                                                    ]
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                            name: "enroll-in-research-group",
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                            ...fieldProps,
                                                            "aria-describedby": undefined,
                                                            label: enrolInResearchLabel || formatMessage((0, $fSdY7.messages).enrolInResearchLabel),
                                                            onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
                                                        }),
                                                        enrolInResearchLabel && enrolInResearchLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                            children: enrolInResearchLink
                                                        })
                                                    ]
                                                })
                                        })
                                    ]
                                }) || /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                        name: 'anonymousFeedback',
                                        children: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
                                                title: formatMessage((0, $fSdY7.messages).feedbackIsAnonymousTitle),
                                                appearance: 'information',
                                                children: feedbackIsAnonymous
                                            })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: cancelButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $fSdY7.messages).cancelButtonLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "primary",
                            type: "submit",
                            isDisabled: isSubmitting || isDisabled,
                            testId: "feedbackCollectorSubmitBtn",
                            children: submitButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $fSdY7.messages).submitButtonLabel
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
            onSubmit: async ()=>{
                if (useNewValidation) {
                    // New validation: validate on submit and show errors
                    const errors = getValidationErrors();
                    // If there are validation errors, show them and don't submit
                    if (Object.keys(errors).length > 0) {
                        setValidationErrors(errors);
                        return;
                    }
                }
                // Submit the form (both old and new validation paths reach here)
                setIsSubmitting(true);
                try {
                    await onSubmit({
                        canBeContacted: canBeContacted,
                        description: description,
                        enrollInResearchGroup: enrollInResearchGroup,
                        type: type
                    });
                } finally{
                    setIsSubmitting(false);
                }
            },
            children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $l998X.jsxs)("form", {
                    ...formProps,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                            hasCloseButton: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                                children: feedbackTitle || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $fSdY7.messages).feedbackTitle
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                            children: [
                                (0, $dh538.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary,
                                feedbackTitleDetails,
                                customContent,
                                showTypeField ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                    name: "topic",
                                    label: selectLabel || formatMessage((0, $fSdY7.messages).selectionOptionDefaultLabel),
                                    isRequired: true,
                                    children: ({ fieldProps: { id: id, ...restProps } })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                                                    ...restProps,
                                                    onChange: (option)=>{
                                                        if (!option || option instanceof Array) return;
                                                        setType(option.value);
                                                        // Clear validation error when user selects a type (only for new validation)
                                                        if (useNewValidation && validationErrors.type) setValidationErrors((prev)=>({
                                                                ...prev,
                                                                type: undefined
                                                            }));
                                                    },
                                                    menuPortalTarget: document.body,
                                                    styles: {
                                                        menuPortal: (base)=>({
                                                                ...base,
                                                                zIndex: 9999
                                                            })
                                                    },
                                                    options: selectOptions,
                                                    // @ts-ignore
                                                    ref: focusRef,
                                                    placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                                                    inputId: id
                                                }),
                                                useNewValidation && validationErrors.type && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                    children: validationErrors.type
                                                })
                                            ]
                                        })
                                }) : null,
                                showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                            label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $fSdY7.messages).defaultCustomTextAreaLabel),
                                            isRequired: true,
                                            name: "description",
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                                                            ...fieldProps,
                                                            name: "foo",
                                                            minimumRows: 6,
                                                            placeholder: summaryPlaceholder || undefined,
                                                            onChange: (e)=>{
                                                                setDescription(e.target.value);
                                                                // Clear validation error when user types
                                                                if (useNewValidation && validationErrors.description) setValidationErrors((prev)=>({
                                                                        ...prev,
                                                                        description: undefined
                                                                    }));
                                                            },
                                                            value: description
                                                        }),
                                                        useNewValidation && validationErrors.description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                            children: validationErrors.description
                                                        })
                                                    ]
                                                })
                                        }),
                                        !anonymousFeedback && /*#__PURE__*/ (0, $l998X.jsxs)((0, $kuB2l.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)("legend", {
                                                    "aria-hidden": false,
                                                    hidden: true,
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                        ...(0, $fSdY7.messages).optInOptionsLegend
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                    name: "can-be-contacted",
                                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                                    ...fieldProps,
                                                                    "aria-describedby": undefined,
                                                                    label: canBeContactedLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                                        ...(0, $dh538.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                                                                        ...!(0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                                                                            values: {
                                                                                a: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                                        href: "https://www.atlassian.com/legal/privacy-policy",
                                                                                        target: "_blank",
                                                                                        children: chunks
                                                                                    })
                                                                            }
                                                                        }
                                                                    }),
                                                                    onChange: (event)=>setCanBeContacted(event.target.checked)
                                                                }),
                                                                canBeContactedLabel && canBeContactedLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                                    children: canBeContactedLink
                                                                }),
                                                                !canBeContactedLabel && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                        href: "https://www.atlassian.com/legal/privacy-policy",
                                                                        target: "_blank",
                                                                        children: formatMessage((0, $fSdY7.messages).privacyPolicy)
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                    name: "enroll-in-research-group",
                                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                                    ...fieldProps,
                                                                    "aria-describedby": undefined,
                                                                    label: enrolInResearchLabel || formatMessage((0, $fSdY7.messages).enrolInResearchLabel),
                                                                    onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
                                                                }),
                                                                enrolInResearchLabel && enrolInResearchLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                                    children: enrolInResearchLink
                                                                })
                                                            ]
                                                        })
                                                })
                                            ]
                                        }) || /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                name: 'anonymousFeedback',
                                                children: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
                                                        title: formatMessage((0, $fSdY7.messages).feedbackIsAnonymousTitle),
                                                        appearance: 'information',
                                                        children: feedbackIsAnonymous
                                                    })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                    appearance: "subtle",
                                    onClick: onClose,
                                    children: cancelButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $fSdY7.messages).cancelButtonLabel
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isDisabled: isSubmitting || isDisabled,
                                    testId: "feedbackCollectorSubmitBtn",
                                    children: submitButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $fSdY7.messages).submitButtonLabel
                                    })
                                })
                            ]
                        })
                    ]
                })
        })
    });
};
const $27c5bd5943874410$var$FeedbackFormWithIntl = ({ locale: locale, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $giCws.IntlProviderWithResolvedMessages), {
        locale: locale,
        children: /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$FeedbackForm, {
            ...props
        })
    });
};
var $27c5bd5943874410$export$2e2bcd8739ae039 = $27c5bd5943874410$var$FeedbackFormWithIntl;
module.exports["default"] = $27c5bd5943874410$export$2e2bcd8739ae039;

});

parcelRegister("fSdY7", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $a10dc5cbcf39e7b4$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    feedbackTitle: {
        id: "feedback-collector.feedback-title",
        defaultMessage: "Share your thoughts"
    },
    enrolInResearchLabel: {
        id: "feedback-collector.enrol-in-research.label",
        defaultMessage: "I'd like to participate in product research"
    },
    canBeContactedLabel: {
        id: "feedback-collector.can-be-contacted.label",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy."
    },
    privacyPolicy: {
        id: "feedback-collector.privacy-policy",
        defaultMessage: "Atlassian Privacy Policy"
    },
    summaryPlaceholder: {
        id: "feedback-collector.summary-placeholder",
        defaultMessage: "Let us know what's on your mind"
    },
    formCommentLabel: {
        id: "feedback-collector.form.comment.label",
        defaultMessage: "Let us know what's on your mind"
    },
    submitButtonLabel: {
        id: "feedback-collector.submit-button.label",
        defaultMessage: "Send feedback"
    },
    cancelButtonLabel: {
        id: "feedback-collector.cancel-button.label",
        defaultMessage: "Cancel"
    },
    giveFeedback: {
        id: "proforma-form-builder.give-feedback",
        defaultMessage: "Give feedback"
    },
    formBugLabel: {
        id: "feedback-collector.form.bug.label",
        defaultMessage: "Describe the bug or issue"
    },
    formSuggestionLabel: {
        id: "feedback-collector.form.suggestion.label",
        defaultMessage: "Let us know what you'd like to improve"
    },
    formQuestionLabel: {
        id: "feedback-collector.form.question.label",
        defaultMessage: "What would you like to know?"
    },
    formEmptyLabel: {
        id: "feedback-collector.form.empty.label",
        defaultMessage: "Select an option"
    },
    formNotRelevantLabel: {
        id: "feedback-collector.form.not-relevant.label",
        defaultMessage: "Wasn't relevant"
    },
    formNotAccurateLabel: {
        id: "feedback-collector.form.not-accurate.label",
        defaultMessage: "Wasn't accurate"
    },
    formTooSlowLabel: {
        id: "feedback-collector.form.too-slow.label",
        defaultMessage: "Too slow"
    },
    formUnhelpfulLinksLabel: {
        id: "feedback-collector.form.unhelpful-links.label",
        defaultMessage: "Unhelpful links"
    },
    formOtherLabel: {
        id: "feedback-collector.form.other.label",
        defaultMessage: "Other"
    },
    selectionOptionQuestionLabel: {
        id: "feedback-collector.option.question.label",
        defaultMessage: "Ask a question"
    },
    selectionOptionCommentLabel: {
        id: "feedback-collector.option.comment.label",
        defaultMessage: "Leave a comment"
    },
    selectionOptionBugLabel: {
        id: "feedback-collector.option.bug.label",
        defaultMessage: "Report a bug"
    },
    selectionOptionSuggestionLabel: {
        id: "feedback-collector.option.suggestion.label",
        defaultMessage: "Suggest an improvement"
    },
    selectionOptionDefaultLabel: {
        id: "feedback-collector.option.default.label",
        defaultMessage: "Select feedback"
    },
    selectionOptionDefaultPlaceholder: {
        id: "feedback-collector.option.default.placeholder",
        defaultMessage: "Choose one"
    },
    feedbackIconLabel: {
        id: "proforma-form-builder.feedback-icon-label",
        defaultMessage: "Feedback"
    },
    feedbackSuccessFlagDescription: {
        id: "feedback-collector.success-flag.description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    },
    feedbackSuccessFlagTitle: {
        id: "feedback-collector.success-flag.title",
        defaultMessage: "Thanks!"
    },
    feedbackIsAnonymousTitle: {
        id: "feedback-collector.anonymous.title",
        defaultMessage: "Anonymous feedback"
    },
    feedbackIsAnonymous: {
        id: "feedback-collector.anonymous",
        defaultMessage: "This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback"
    },
    requiredFieldsSummary: {
        id: "feedback-collector.required.fields.summary",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    defaultCustomTextAreaLabel: {
        id: "feedback-collector.default.custom.textarea.label",
        defaultMessage: "What's on your mind?"
    },
    canBeContactedLabelAppify: {
        id: "feedback-collector.can-be-contacted.label-appify",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelAppifyWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-appify-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the Atlassian Privacy Policy."
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: "feedback-collector.success-flag.description-appify",
        defaultMessage: "Your valuable feedback helps us continually improve our apps."
    },
    validationErrorTypeRequired: {
        id: "feedback-collector.validation.type.required",
        defaultMessage: "Please select a feedback type"
    },
    validationErrorDescriptionRequired: {
        id: "feedback-collector.validation.description.required",
        defaultMessage: "Please provide a description"
    },
    optInOptionsLegend: {
        id: "feedback-collector.opt-in.options.legend",
        defaultMessage: "Atlassian opt-in options"
    }
});
module.exports["messages"] = $a10dc5cbcf39e7b4$export$defe85febe8b728c;

});

parcelRegister("giCws", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $1tbUg = parcelRequire("1tbUg");

const $9a574d55f4cfa28d$export$f793de1293176fe6 = ({ children: children, locale: locale })=>{
    const [resolvedMessagesForLocale, setResolvedMessagesForLocale] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        const fetchMessageLocale = async ()=>{
            if (locale) {
                const messages = await (0, $1tbUg.getMessagesForLocale)(locale);
                setResolvedMessagesForLocale(messages);
            }
        };
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale,
        children: children
    });
};
module.exports["IntlProviderWithResolvedMessages"] = $9a574d55f4cfa28d$export$f793de1293176fe6;

});

parcelRegister("1tbUg", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ const $c02f8c9a6f146725$export$d0a3169680473b6c = async (locale)=>{
    locale = locale.replace('-', '_');
    try {
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${locale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${parentLocale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
};
module.exports["getMessagesForLocale"] = $c02f8c9a6f146725$export$d0a3169680473b6c;

});

parcelRegister("29DUH", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $aD1SW = parcelRequire("aD1SW");


var $8Y8Qi = parcelRequire("8Y8Qi");


var $dh538 = parcelRequire("dh538");


var $6fnsQ = parcelRequire("6fnsQ");


var $fSdY7 = parcelRequire("fSdY7");


var $giCws = parcelRequire("giCws");

const $36b921ab0de27528$var$FeedbackFlag = ({ description: description, title: title })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aD1SW.default), {
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Y8Qi))), {
            spacing: "spacious",
            color: `var(--ds-icon-success, ${(0, $6fnsQ.G300)})`,
            label: "Success"
        }),
        id: "feedbackSent",
        description: description || formatMessage((0, $dh538.fg)('product-terminology-refresh') ? (0, $fSdY7.messages).feedbackSuccessFlagDescriptionAppify : (0, $fSdY7.messages).feedbackSuccessFlagDescription),
        title: title || formatMessage((0, $fSdY7.messages).feedbackSuccessFlagTitle)
    });
};
const $36b921ab0de27528$var$FeedbackFlagWithIntl = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $giCws.IntlProviderWithResolvedMessages), {
        locale: props.locale,
        children: /*#__PURE__*/ (0, $l998X.jsx)($36b921ab0de27528$var$FeedbackFlag, {
            ...props
        })
    });
var $36b921ab0de27528$export$2e2bcd8739ae039 = $36b921ab0de27528$var$FeedbackFlagWithIntl;
module.exports["default"] = $36b921ab0de27528$export$2e2bcd8739ae039;

});

parcelRegister("aFwxm", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9FnLD = parcelRequire("9FnLD");

const $321f16821ba8d88a$export$ec2ba0e929740f73 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        label: ""
    });
module.exports["ThumbIcon"] = $321f16821ba8d88a$export$ec2ba0e929740f73;

});

parcelRegister("fXbFR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PxT5 = parcelRequire("4PxT5");

const $d2d9cd8fe7c899bb$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $4PxT5.useOnScreen)(ref);
    const dwellTimeRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $d2d9cd8fe7c899bb$export$15dda63faa44a0df;

});

parcelRegister("4PxT5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $944e21aa736984a5$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $944e21aa736984a5$export$edb9b52ab3f1abbb;

});

parcelRegister("kt1Xc", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $2UyBL = parcelRequire("2UyBL");

parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $dh538 = parcelRequire("dh538");


var $9Rf00 = parcelRequire("9Rf00");


var $in8wv = parcelRequire("in8wv");

const $45557925e309956a$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $45557925e309956a$export$f50b64530422ea99 = ({ contentId: contentId, fallbackText: fallbackText, queryRef: queryRef, source: source, isHidden: isHidden, maxLines: maxLines, showFooter: showFooter, showAwareness: showAwareness })=>{
    const data = (0, $irOoi.usePreloadedQuery)((0, $2UyBL.default), queryRef);
    const aiSnippetText = data?.confluence_latestKnowledgeGraphObjectV2?.objectData;
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $in8wv.AISnippetContent), {
        text: aiSnippetText || fallbackText,
        contentId: contentId,
        showFooter: !!aiSnippetText && showFooter,
        showAwareness: !!aiSnippetText && showAwareness,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines
    });
    if ((0, $dh538.fg)('jira-cc-ai-snippet-gate')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9Rf00.AIFeedbackPropertiesProvider), {
        entrypointId: $45557925e309956a$var$SNIPPET_ENTRYPOINT_ID,
        userId: data?.me?.user?.accountId,
        displayName: data?.me?.user?.name,
        children: content
    });
    return content;
};
module.exports["AISnippetLoader"] = $45557925e309956a$export$f50b64530422ea99;

});

parcelRegister("2UyBL", function(module, exports) {
/**
 * @generated SignedSource<<83c7dc86ba34b94d5c11c0df299d770d>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40
const $06d2529594a8e25b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMe"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            },
            {
                "kind": "Variable",
                "name": "contentType",
                "variableName": "contentType"
            },
            {
                "kind": "Literal",
                "name": "objectType",
                "value": "snippet_v2"
            }
        ],
        "concreteType": "KnowledgeGraphObjectResponseV2",
        "kind": "LinkedField",
        "name": "confluence_latestKnowledgeGraphObjectV2",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "objectData"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
            "metadata": {},
            "name": "aiSnippetLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$06d2529594a8e25b$var$node.hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";
var $06d2529594a8e25b$export$2e2bcd8739ae039 = $06d2529594a8e25b$var$node;
module.exports["default"] = $06d2529594a8e25b$export$2e2bcd8739ae039;

});

parcelRegister("84PmI", function(module, exports) {

var $8C5kA = parcelRequire("8C5kA");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $22cce201c1053098$export$8d219f4743712a45 = ()=>{
    const { isLoggedIn: isLoggedIn, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const { locale: locale } = (0, $8C5kA.default)();
    const isRovoEnabled = isRovoLLMEnabled && isLoggedIn && accessStatus !== (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    // Will remove this after translation is ready
    // https://hello.jira.atlassian.cloud/browse/CFFD-871
    const isEnglishLocale = locale.toLowerCase().startsWith('en');
    return isRovoEnabled && isEnglishLocale && (0, $9wGTI.fg)('rovo_awareness_enabled');
};
module.exports["useIsEligibleRovoAwareness"] = $22cce201c1053098$export$8d219f4743712a45;

});

parcelRegister("dtVue", function(module, exports) {

var $jubk3 = parcelRequire("jubk3");

function $c25f711fd5cdf3ef$export$72aeabfc882e7732(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick) {
    return (0, $jubk3.getMentionsConfig)(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick);
}
module.exports["createMentionsConfig"] = $c25f711fd5cdf3ef$export$72aeabfc882e7732;

});

parcelRegister("24amZ", function(module, exports) {
var $0096831e5a63492d$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $0096831e5a63492d$export$b21a3980a7aad169;

});

parcelRegister("e4JJO", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");


var $ij2FZ = parcelRequire("ij2FZ");

const $8d8bfd1ce8e7d438$var$wordCount = (text)=>{
    if (text) {
        const matches = text.match(/\S+/g);
        if (matches) return matches.length;
    }
    return 0;
};
const $8d8bfd1ce8e7d438$var$processADFNode = (currentValue, node)=>{
    switch(node.type){
        case 'text':
            const linkCount = node.marks?.some((mark)=>mark.type === 'link') ? currentValue.linkCount + 1 : currentValue.linkCount;
            return {
                ...currentValue,
                textLength: currentValue.textLength + (node.text ? node.text.length : 0),
                wordCount: currentValue.wordCount + $8d8bfd1ce8e7d438$var$wordCount(node.text),
                linkCount: linkCount
            };
        case 'mention':
            return {
                ...currentValue,
                mentionCount: currentValue.mentionCount + 1
            };
        case 'inlineCard':
        case 'embedCard':
            return {
                ...currentValue,
                linkCount: currentValue.linkCount + 1
            };
        case 'inlineExtension':
            if (node.attrs?.extensionKey === (0, $ij2FZ.ROVO_SKILL_COMBINED_EXTENSION_KEY) && node.attrs?.parameters?.slug) return {
                ...currentValue,
                explicitSkills: [
                    ...currentValue.explicitSkills,
                    node.attrs.parameters.slug
                ]
            };
            return currentValue;
    }
    return currentValue;
};
const $8d8bfd1ce8e7d438$export$a148305df2eb5487 = (adf)=>{
    const initialFeatures = {
        adfLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        linkCount: 0,
        mentionCount: 0,
        explicitSkills: []
    };
    return (0, $1A9t2.reduce)(adf, (currentValue, node)=>$8d8bfd1ce8e7d438$var$processADFNode(currentValue, node), initialFeatures);
};
module.exports["extractContentFeatures"] = $8d8bfd1ce8e7d438$export$a148305df2eb5487;

});

parcelRegister("ij2FZ", function(module, exports) {
const $d70a1b66183cdb12$export$d0e832101df0ac96 = 'com.atlassian.rovo.skill';
const $d70a1b66183cdb12$export$d4f002c79ea2ad20 = 'skill';
const $d70a1b66183cdb12$export$e4d0b30afd49f7df = 'skillTag';
const $d70a1b66183cdb12$export$18f911e214c46d8 = /\/([a-zA-Z0-9-]+)/g;
const $d70a1b66183cdb12$export$aae1b80712c1b67b = `${$d70a1b66183cdb12$export$d4f002c79ea2ad20}:${$d70a1b66183cdb12$export$e4d0b30afd49f7df}`;
const $d70a1b66183cdb12$export$b22d8560058c60e1 = (extensionType, extensionKey)=>{
    return extensionType === $d70a1b66183cdb12$export$d0e832101df0ac96 && extensionKey === $d70a1b66183cdb12$export$aae1b80712c1b67b;
};
module.exports["ROVO_SKILL_EXTENSION_TYPE"] = $d70a1b66183cdb12$export$d0e832101df0ac96;
module.exports["ROVO_SKILL_EXTENSION_KEY"] = $d70a1b66183cdb12$export$d4f002c79ea2ad20;
module.exports["ROVO_SKILL_TAG_PATTERN"] = $d70a1b66183cdb12$export$18f911e214c46d8;
module.exports["ROVO_SKILL_COMBINED_EXTENSION_KEY"] = $d70a1b66183cdb12$export$aae1b80712c1b67b;
module.exports["isSkillTagExtension"] = $d70a1b66183cdb12$export$b22d8560058c60e1;

});

parcelRegister("16lEl", function(module, exports) {
const $99e3e594de94f1bc$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    FETCH_CHAT: 'aiMateFetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated',
    FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference',
    FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData',
    FETCH_AGENT_DEBUG_MODAL_CONVERSATION_REVIEW: 'aiMateFetchAgentDebugModalDataConversationReview',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent',
    SEND_DR_MESSAGE: 'aiMateSendDRMessage',
    SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage',
    SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    HYDRATE_CONVERSATION: 'aiMateHydrateConversation',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
    CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
    GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
    AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent',
    PREVIEW_CONTENT: 'aiMatePreviewContent',
    PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender',
    FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions',
    SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
    GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
    UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
    VALIDATE_FILES: 'aiMateValidateFiles',
    GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
    AIFC_MESSAGE: 'aiMateAifcMessage',
    AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal',
    AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent',
    AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat',
    AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived',
    AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled',
    AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent',
    AIFC_MODAL_SESSION: 'aiMateAifcModalSession',
    CSM_WIDGET_RENDER: 'csmWidgetRender',
    CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
    CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
    CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
    CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage',
    CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters',
    CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters',
    GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState',
    SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState',
    AGENTS_MODAL_AND_SIDEBAR_LIST: 'aiMateAgentsModalAndSidebarList',
    AGENTS_MODAL_FAVOURITE_AGENTS: 'aiMateAgentsModalFavouriteAgents',
    AGENTS_FULLSCREEN_AGENT_LIST: 'aiMateAgentsFullscreenAgentList'
};
var $99e3e594de94f1bc$export$3615d040a39afa1e = /*#__PURE__*/ function(ExperienceNamePostfix) {
    ExperienceNamePostfix["MINI_MODAL"] = "miniModal";
    return ExperienceNamePostfix;
}({});
const $99e3e594de94f1bc$export$97bfa295b10f6f9e = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, isCustomRovoAgent: isCustomRovoAgent })=>{
    if (isCustomRovoAgent) return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (deepResearchEnabled) return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_DR_MESSAGE;
    if (thinkDeeperEnabled) return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_TD_MESSAGE;
    return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_MESSAGE;
};
const $99e3e594de94f1bc$export$233a4307e330ea30 = [
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT_IN_CHAT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_UPDATE_CONTENT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_FINALIZE_CONTENT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_LOAD_STAGING_AREA_MODAL,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_MODAL_SESSION
];
const $99e3e594de94f1bc$export$449b821dadec8760 = [
    // Experiences with timeouts must be listed first:
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_INITIAL_DATA_RECEIVED,
    // Experiences without timeouts:
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_ALL_DATA_HANDLED,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.PREVIEW_CONTENT,
    ...$99e3e594de94f1bc$export$233a4307e330ea30
];
module.exports["ExperienceName"] = $99e3e594de94f1bc$export$b881bd9f00ed8ed1;
module.exports["ExperienceNamePostfix"] = $99e3e594de94f1bc$export$3615d040a39afa1e;
module.exports["sendMessageExperienceName"] = $99e3e594de94f1bc$export$97bfa295b10f6f9e;
module.exports["AIFC_EXPERIENCES_TO_FAIL"] = $99e3e594de94f1bc$export$233a4307e330ea30;
module.exports["AIFC_EXPERIENCES_TO_ABORT"] = $99e3e594de94f1bc$export$449b821dadec8760;

});

parcelRegister("2O3ot", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $abb9e481ac8f38e8$var$initialState = {
    messageIdSelectedForPreview: null,
    invocationIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: ''
};
const $abb9e481ac8f38e8$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        },
    setInvocationIdSelectedForPreview: (invocationId)=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId
            });
        }
};
const $abb9e481ac8f38e8$var$store = (0, $1P1Tu.createStore)({
    initialState: $abb9e481ac8f38e8$var$initialState,
    actions: $abb9e481ac8f38e8$var$actions
});
const $abb9e481ac8f38e8$export$a2795b51ce92008f = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $abb9e481ac8f38e8$export$916334da9df8d04 = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$8f9a13b17bec42d5 = (0, $9zUhf.createActionsHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$5a57f796673aabea = (0, $9zUhf.createStateHook)($abb9e481ac8f38e8$var$store);
module.exports["useStagingArea"] = $abb9e481ac8f38e8$export$916334da9df8d04;
module.exports["useStagingAreaActions"] = $abb9e481ac8f38e8$export$8f9a13b17bec42d5;
module.exports["useStagingAreaState"] = $abb9e481ac8f38e8$export$5a57f796673aabea;

});

parcelRegister("9cZ1w", function(module, exports) {

var $epLE5 = parcelRequire("epLE5");


const $486bada329940e5a$export$f6e059b56d9aeb26 = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("hLwhk"))).showCreateWithRovoModalCloseFeedbackFlagThunk);
module.exports["useLazyShowFeedbackFlag"] = $486bada329940e5a$export$f6e059b56d9aeb26;

});

parcelRegister("epLE5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $42omo.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("hLwhk", function(module, exports) {

let $ceefdd443b638e58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ceefdd443b638e58$var$load("drv5I"),
    $ceefdd443b638e58$var$load("k7MRD")
]).then(()=>parcelRequire('hlCkz'));

});

parcelRegister("8Igpw", function(module, exports) {
const $43e5bdc11d95b8bf$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $43e5bdc11d95b8bf$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $43e5bdc11d95b8bf$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $43e5bdc11d95b8bf$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $43e5bdc11d95b8bf$var$processHttpErrorResponse({
            response: response
        });
        return await response.json();
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        throw new $43e5bdc11d95b8bf$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError'
        });
    }
};
const $43e5bdc11d95b8bf$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $43e5bdc11d95b8bf$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $43e5bdc11d95b8bf$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $43e5bdc11d95b8bf$export$9f229e40eb65abfc;
module.exports["FetchError"] = $43e5bdc11d95b8bf$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $43e5bdc11d95b8bf$export$a38d93aa782475f6;

});

parcelRegister("cJeDc", function(module, exports) {
var $c39b3ef3793f3f0e$export$3f98ccc336fde004 = /*#__PURE__*/ function(FeedbackVariant) {
    FeedbackVariant["AFTER_AIFC_MODAL_CLOSE"] = "after-aifc-modal-close";
    FeedbackVariant["AFTER_UPDATE_STREAM_COMPLETE"] = "after-update-stream-complete";
    return FeedbackVariant;
}({});
module.exports["FeedbackVariant"] = $c39b3ef3793f3f0e$export$3f98ccc336fde004;

});

parcelRegister("jyA9t", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    entryPoint: 'confluenceUnknown'
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: (entryPoint, spaceKey, parentContent, stagingAreaActive, content)=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: true,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                content: undefined,
                stagingAreaActive: false,
                entryPoint: 'confluenceUnknown'
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $9zUhf.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $9zUhf.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $9zUhf.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("lpRYt", function(module, exports) {

var $2Yzoe = parcelRequire("2Yzoe");


var $csam1 = parcelRequire("csam1");


var $aRZzN = parcelRequire("aRZzN");


var $42JDa = parcelRequire("42JDa");


var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $aFrN0 = parcelRequire("aFrN0");


var $kVuPa = parcelRequire("kVuPa");


var $kbmYM = parcelRequire("kbmYM");


var $6RXI6 = parcelRequire("6RXI6");


var $3Jbpl = parcelRequire("3Jbpl");


var $j0P3F = parcelRequire("j0P3F");


var $dSj2z = parcelRequire("dSj2z");


var $1Ce64 = parcelRequire("1Ce64");


var $5XYXq = parcelRequire("5XYXq");


var $7ai6d = parcelRequire("7ai6d");


var $bCKHR = parcelRequire("bCKHR");

class $2d26328991932579$export$614853bf2169db97 extends (0, $aRZzN.MarkdownTransformer) {
    parse(content) {
        const node = this.parser.parse(content);
        if (!node) return new (0, $5SAOw.Node)();
        return node;
    }
    constructor(schema, pluginConfig, streaming, isExperimentEnabled){
        super();
        this.parser = void 0;
        const md = (0, (/*@__PURE__*/$parcel$interopDefault($2Yzoe)))('zero', {
            html: false
        });
        md.enable([
            // Process html entity - &#123;, &#xAF;, &quot;, ...
            'entity',
            // Process escaped chars and hardbreaks
            'escape',
            'newline'
        ]);
        (0, $bCKHR.enableSchemaPlugins)(md, schema);
        // enable modified version of linkify plugin
        // @see https://product-fabric.atlassian.net/browse/ED-3097
        md.use((0, $6RXI6.createLinkifyPlugin)(pluginConfig.linkify));
        md.use((0, $aFrN0.default));
        if ((0, $dh538.fg)('rovo_enable_data_sculptor')) md.use((0, $kVuPa.default));
        if ((0, $dh538.fg)('di_chat_enable_expandables')) md.use((0, $kbmYM.default));
        md.use((0, $5XYXq.default));
        // Convert links with Linking Platform supported URLs to Smart Links
        if (!streaming && (schema.nodes.inlineCard || schema.nodes.blockCard || schema.nodes.embedCard)) md.use((0, $dSj2z.createSmartLinksPlugin)(pluginConfig.smartLinks, isExperimentEnabled));
        // Convert links matching people directory URLs to mentions
        if (schema.nodes.mention) md.use((0, $j0P3F.default));
        // Table support
        if (schema.nodes.table) {
            md.use((0, $csam1.markdownItTable));
            if ((0, $dh538.fg)('rovo_chat_enable_markdown_table_break_tags')) md.use((0, $1Ce64.default));
        }
        // Image support
        if (schema.nodes.media && schema.nodes.mediaSingle) md.use((0, $3Jbpl.default));
        const filter = (0, $bCKHR.filterSchemaMapping)(schema, (0, $7ai6d.mdToPmSchema));
        this.parser = new (0, $42JDa.MarkdownParser)(schema, md, filter);
    }
}
module.exports["AiMateMarkdownTransformer"] = $2d26328991932579$export$614853bf2169db97;

});

parcelRegister("aFrN0", function(module, exports) {
$parcel$export(module.exports, "default", () => $eedc127a683be258$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

const $eedc127a683be258$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $eedc127a683be258$var$citation = (state)=>{
    const tokens = [];
    // TODO: Remove the next two lines when rovo_chat_simplify_citation_logic enabled and cleaned up
    const citationIndexMap = {};
    let currentIndex = 1;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $eedc127a683be258$var$CITATION_REGEX.test(childToken.content)) {
                /**
					 * Example content: `Hello [^1^][^1^].`
					 * `parts` will be ['Hello ', '1', '', '1', '.']
					 */ const parts = childToken.content.split($eedc127a683be258$var$CITATION_REGEX);
                const newChildren = [];
                /**
					 * we want to remove consecutive citation
					 * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
					 * should be transformed to `Hello 1. How are you 1 2`
					 */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
							 * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
							 * So it doesn't end up rendering empty space that will end up with multi empty spaces
							 * because previous valid citation already added 1 empty space
							 *
							 * Example: For `[^1^][^1^]`
							 * it will be split into parts: ['', '1', '', '1', ''],
							 * This code will skip any rendering for the last empty string (index=4)
							 * Because the empty string at index=2 already added 1 empty space from the code below
							 */ if (isLastCitationDuplicate && part.trim() === '') return;
                        if (part.trim() !== '') /**
								 * if the text part is not an empty string, we want to reset the last citation
								 * because the text part is a valid text, and not a space between citations
								 * so that we can render citation again, even if the next number is the same as the last number
								 *
								 * Example:
								 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
								 */ lastCitation = null;
                        const textToken = new state.Token('text', '', 0);
                        if (index === parts.length - 1) textToken.content = part;
                        else textToken.content = part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        const citationToken = new state.Token('status', '', 0);
                        citationToken.content = '';
                        citationToken.block = false;
                        citationToken.level = childToken.level;
                        let citationText = part;
                        if (!(0, $dh538.fg)('rovo_chat_simplify_citation_logic')) {
                            citationText = citationIndexMap[part] ? citationIndexMap[part].toString() : currentIndex.toString();
                            if (!citationIndexMap[part]) {
                                citationIndexMap[part] = currentIndex;
                                currentIndex++;
                            }
                        }
                        citationToken.attrs = [
                            [
                                'color',
                                'blue'
                            ],
                            [
                                'text',
                                citationText
                            ],
                            // localId is used to identify the citation token in the DOM
                            // this overrides the uuid that is normally used
                            [
                                'localId',
                                `citation-${citationText}`
                            ]
                        ];
                        citationToken.content = citationText;
                        newChildren.push(citationToken);
                    }
                });
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $eedc127a683be258$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $eedc127a683be258$var$citation);

});

parcelRegister("kVuPa", function(module, exports) {
$parcel$export(module.exports, "default", () => $85f34bd2edc9da4d$export$2e2bcd8739ae039);
const $85f34bd2edc9da4d$var$SCULPTOR_REGEX = /\[\^(sculptor)\^\]/;
const $85f34bd2edc9da4d$var$dataSculptor = (state)=>{
    const tokens = [];
    let sculptorCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $85f34bd2edc9da4d$var$SCULPTOR_REGEX.test(childToken.content)) {
                const citationToken = new state.Token('status', '', 0);
                citationToken.content = '';
                citationToken.block = false;
                citationToken.level = childToken.level;
                const parts = childToken.content.split($85f34bd2edc9da4d$var$SCULPTOR_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        citationToken.attrs = [
                            [
                                'localId',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'text',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(citationToken);
                        sculptorCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $85f34bd2edc9da4d$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('data-sculptor', $85f34bd2edc9da4d$var$dataSculptor);

});

parcelRegister("kbmYM", function(module, exports) {
const $8d6eacbf9e066d7e$var$EXPAND_REGEX = /\[\^(expand)\^\]/;
const $8d6eacbf9e066d7e$var$expandable = (state)=>{
    const tokens = [];
    let expandCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children?.length === 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $8d6eacbf9e066d7e$var$EXPAND_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($8d6eacbf9e066d7e$var$EXPAND_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const expandToken = new state.Token('status', '', 0);
                        expandToken.content = '';
                        expandToken.block = false;
                        expandToken.level = childToken.level;
                        expandToken.attrs = [
                            [
                                'localId',
                                'expandable-' + expandCounter
                            ],
                            [
                                'text',
                                'expandable-' + expandCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(expandToken);
                        expandCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
const $8d6eacbf9e066d7e$var$mdPluginExpandable = (md)=>{
    md.core.ruler.push('expandable', $8d6eacbf9e066d7e$var$expandable);
};
var $8d6eacbf9e066d7e$export$2e2bcd8739ae039 = $8d6eacbf9e066d7e$var$mdPluginExpandable;
module.exports["default"] = $8d6eacbf9e066d7e$export$2e2bcd8739ae039;

});

parcelRegister("6RXI6", function(module, exports) {

var $2Gb84 = parcelRequire("2Gb84");


var $81OAa = parcelRequire("81OAa");

// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
const $146b6bae45423f24$var$arrayReplaceAt = (src, pos, newElements)=>{
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $146b6bae45423f24$var$isLinkOpen = (str)=>{
    return /^<a[>\s]/i.test(str);
};
const $146b6bae45423f24$var$isLinkClose = (str)=>{
    return /^<\/a\s*>/i.test(str);
};
const $146b6bae45423f24$export$8cd7d1ec2e6808da = ({ findFilepaths: findFilepaths, isLinkInMatches: isLinkInMatches })=>(state)=>{
        const blockTokens = state.tokens;
        const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
        for(let j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
            let tokens = blockTokens[j].children;
            let htmlLinkLevel = 0;
            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for(let i = tokens.length - 1; i >= 0; i--){
                const currentToken = tokens[i];
                // Skip content of markdown links
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                // Skip content of html tag links
                if (currentToken.type === 'html_inline') {
                    if ($146b6bae45423f24$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($146b6bae45423f24$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                    const text = currentToken.content;
                    let links = (0, $81OAa.linkifyMatch)(text);
                    if (!links.length) links = linkify.match(text) || [];
                    // Now split string to nodes
                    const nodes = [];
                    let level = currentToken.level;
                    let lastPos = 0;
                    const filepaths = findFilepaths(text);
                    for(let ln = 0; ln < links.length; ln++){
                        if (isLinkInMatches(links[ln].index, filepaths)) continue;
                        const { url: url } = links[ln];
                        const fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        let urlText = links[ln].text;
                        // Linkifier might send raw hostnames like "example.com", where url
                        // starts with domain name. So we prepend http:// in those cases,
                        // and remove it afterwards.
                        //
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        const pos = links[ln].index;
                        if (pos > lastPos) {
                            const token = new state.Token('text', '', 0);
                            token.content = text.slice(lastPos, pos);
                            token.level = level;
                            nodes.push(token);
                        }
                        let token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < text.length) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos);
                        token.level = level;
                        nodes.push(token);
                    }
                    // replace current node
                    blockTokens[j].children = tokens = $146b6bae45423f24$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };
const $146b6bae45423f24$export$763ac077c9998026 = (params)=>(md)=>md.core.ruler.push('custom-linkify', $146b6bae45423f24$export$8cd7d1ec2e6808da(params));
module.exports["createLinkifyPlugin"] = $146b6bae45423f24$export$763ac077c9998026;

});

parcelRegister("3Jbpl", function(module, exports) {
$parcel$export(module.exports, "default", () => $536a5df99342df46$export$2e2bcd8739ae039);
/**
Note: This implementation was built by referencing Editor AI
packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/md/media-md-plugin.ts

Aside from a refactor, the key differences in logic are:
- Our regex is more specific, and will only match images that are not inside single backticks otherwise we'll see AI Mate render images surrounded by single backticks
*/ function $536a5df99342df46$var$createRule() {
    // Match any images that aren't inside single backticks
    const mdImageRegex = RegExp("(?<!`)!\\[[^\\]]*\\]\\([^\\)]+\\)(?!`)", "g");
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open'
    ];
    return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && mdImageRegex.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                // Loop backwards through the tokens until a valid parent token is found
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                // If the previous token is not a valid parent token, add it to the start of the opening tokens array
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                // Create closing tokens for each opening token and reverse the array
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                const matches = token.content.match(mdImageRegex);
                // Process all images in the inline token
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substring(0, start);
                    inlineContentStack = inlineContentStack.substring(start + match.length);
                    // Add the inline tokens and media tokens to the subtree
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                // If there is any remaining content in the stack, add the inline tokens to the subtree
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $536a5df99342df46$export$2e2bcd8739ae039 = (md)=>{
    md.core.ruler.before('inline', 'media', $536a5df99342df46$var$createRule());
};

});

parcelRegister("j0P3F", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab169cc784e6afd4$export$2e2bcd8739ae039);
// Regex test is based on what's documented here:
// https://hello.atlassian.net/wiki/spaces/I/pages/1124693006/AAID+Format
const $ab169cc784e6afd4$var$isPeopleLink = (url)=>{
    return /^\/people\/[a-zA-Z0-9_\|\-\:]{1,128}$/g.test(url);
};
const $ab169cc784e6afd4$var$getAccountId = (url)=>{
    const match = url.match(/\/people\/([a-zA-Z0-9_\|\-\:]{1,128})/);
    return match ? match[1] : null;
};
const $ab169cc784e6afd4$var$mentionLinks = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        // We're only looking for inline children
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken, i)=>{
            const url = childToken.attrGet('href') ?? '';
            const discardedToken = [
                'link_close',
                'text'
            ].includes(childToken.type) && [
                tokenChildren[i - 1]?.type,
                tokenChildren[i - 2]?.type
            ].includes('mention');
            // Discarded tokens are preserved as `null` so index
            // cross-referencing between processed and raw tokens may
            // be preserved, however null are filtered out later.
            if (discardedToken) {
                tokenChildren.push(null);
                return;
            }
            if (childToken.type === 'link_open' && $ab169cc784e6afd4$var$isPeopleLink(url)) {
                const mentionText = token.children?.[i + 1]?.content ?? '';
                let mentionToken = new state.Token('mention', '', 0);
                mentionToken.content = '';
                mentionToken.block = false;
                mentionToken.level = childToken.level;
                mentionToken.attrSet('id', `${$ab169cc784e6afd4$var$getAccountId(url)}`);
                if (mentionText) mentionToken.attrSet('text', `@${mentionText}`);
                tokenChildren.push(mentionToken);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $ab169cc784e6afd4$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('mention', $ab169cc784e6afd4$var$mentionLinks);

});

parcelRegister("dSj2z", function(module, exports) {

var $gEMk1 = parcelRequire("gEMk1");

const $d5cccf701aceb868$var$linkPatternStart = '\\bhttps?:\\/\\/(?:www\\.)?';
const $d5cccf701aceb868$var$linkPatternEnd = '[^\\s\\]\\)]*';
// If we want to re-introduce canva support, please use the regex from this
// PR which was made redundant: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/135407/commits/0fcf626f035396cfcb87153a4d8d4721c844b07a#platform%2Fpackages%2Fai-mate%2Fconversation-assistant%2Fsrc%2Fcommon%2Futils%2Fcontent-transformer%2Fmd-tokenizer%2Fmd-plugin-smartlink%2Findex.ts
// Right now the support is dropped in favour of supporting what the Canva Agent needs.
// It's likely first-class Enhanced Smart links  (e.g `(my canva link "smartCard-embed")[http://some.canva.link]`
// will be how we support this in the future
const $d5cccf701aceb868$var$linkRegex = {
    youtube: `${$d5cccf701aceb868$var$linkPatternStart}youtube\\.com${$d5cccf701aceb868$var$linkPatternEnd}`,
    youtubeShortUrl: `${$d5cccf701aceb868$var$linkPatternStart}youtu\\.be${$d5cccf701aceb868$var$linkPatternEnd}`,
    loomVideo: `${$d5cccf701aceb868$var$linkPatternStart}loom\\.com\\/share\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    figmaFile: `${$d5cccf701aceb868$var$linkPatternStart}figma\\.com\\/(file|design)\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    confluenceWhiteboard: `${$d5cccf701aceb868$var$linkPatternStart}.*\\/wiki\\/spaces\\/.*\\/whiteboard\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googlePresentationAndSpreadsheet: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/(presentation|spreadsheets)\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googleDoc: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/(document)\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googleForm: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/forms\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    microsoftForm: `${$d5cccf701aceb868$var$linkPatternStart}forms\\.office\\.com\\/Pages\\/ResponsePage\\.aspx\\?id\\=${$d5cccf701aceb868$var$linkPatternEnd}`,
    analyticsChart: `\\bhttps://[^.]+\\.(atlassian\\.net|jira-dev\\.com)/analytics/[^/]+/chart-${$d5cccf701aceb868$var$linkPatternEnd}`
};
const $d5cccf701aceb868$var$supportedEmbedProviders = Object.values($d5cccf701aceb868$var$linkRegex).join('|');
const $d5cccf701aceb868$var$embedRegex = new RegExp($d5cccf701aceb868$var$supportedEmbedProviders, 'g');
const $d5cccf701aceb868$var$embedInlineRegex = [
    // avpRovoSkillsChart
    `${$d5cccf701aceb868$var$linkPatternStart}avp-rovo-skills\\.[-\\w]+.frontend.public.atl-paas.net/v1/chart[^\\s\\)]+${$d5cccf701aceb868$var$linkPatternEnd}`
];
// Provider keys from the Linking Platform API that should be rendered as embed cards
// These keys come from the PROVIDERS_API response
const $d5cccf701aceb868$var$supportedEmbedProviderKeys = [
    'youtube-object-provider',
    'loom-object-provider',
    'figma-object-provider',
    'google-object-provider',
    'microsoft-object-provider',
    'jira-object-provider'
];
const $d5cccf701aceb868$var$createSmartLinks = ({ regexStorage: regexStorage, isExperimentEnabled: isExperimentEnabled })=>(state)=>{
        const tokens = [];
        const embedTokens = [];
        let embedMatches = [];
        let filteredTokens = [];
        const renderedInlineEmbeds = new Set();
        let shouldRenderEmbedAtEnd = true;
        // process each token to determine if the link should be converted to a smartlink
        for (const token of state.tokens){
            let processedTokenChildren = [];
            const regexMatchesRaw = token.content?.trim().match($d5cccf701aceb868$var$embedRegex);
            const regexMatches = regexMatchesRaw ? Array.from(new Set(regexMatchesRaw)) : [];
            embedMatches = [
                ...embedMatches,
                ...regexMatches
            ];
            // Any block or embed Smart Card links will be in an "inline" token. If
            // the current token is anything other than "inline", or there's no child tokens
            // to process, then we add it to the list of tokens to keep and move forward
            if (token.type !== 'inline' || !token.children) {
                tokens.push(token);
                continue;
            }
            var outputToken = new state.Token('inline', '', 0);
            let tokensToAppend = [
                outputToken
            ];
            if (token.children) {
                let discardUntilIndex = -1;
                token.children.forEach((childToken, i)=>{
                    const discardedToken = i <= discardUntilIndex && [
                        'link_close',
                        'text'
                    ].includes(childToken.type);
                    if (discardedToken) return;
                    const url = childToken.attrGet('href') ?? '';
                    const isInlineLink = url === token.children?.[i + 1]?.content;
                    if (childToken?.type === 'link_open' && ((0, $gEMk1.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                        // Discard the next two tokens. We're now processing the opening node for a URL
                        // that will result in a new node that replaces it, therefore the subsequent link content and
                        // closing node are no longer needed
                        discardUntilIndex = i + 2;
                        // Check if this link should be rendered as an embed card inline (e.g., Loom, YouTube, Figma) at end of result
                        const matchesEmbedRegex = url.match($d5cccf701aceb868$var$embedRegex);
                        if (matchesEmbedRegex && !embedMatches.includes(url)) embedMatches.push(url);
                        const providerKey = (0, $gEMk1.getProviderKeyFromUrl)(url, regexStorage);
                        const isEmbedProvider = providerKey !== null && $d5cccf701aceb868$var$supportedEmbedProviderKeys.includes(providerKey);
                        // handle condition for when link in the token content matches the linkRegex or provider key
                        const shouldRenderLinksAsEmbed = matchesEmbedRegex || isEmbedProvider;
                        //Render inline embed only for Rovo avp skill links
                        const shouldRenderAvpRovoSkillsEmbedInline = token.level <= 1 && $d5cccf701aceb868$var$embedInlineRegex.some((r)=>url.match(r));
                        // Render inline embed if either regex matches OR provider key matches, and token content is not part of a list
                        const shouldRenderEmbedInline = shouldRenderLinksAsEmbed && token.level <= 1;
                        if (shouldRenderAvpRovoSkillsEmbedInline) {
                            outputToken.children = processedTokenChildren;
                            tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                            processedTokenChildren = [];
                            let embedToken = new state.Token('embedCard', '', 0);
                            embedToken.content = '';
                            embedToken.block = true;
                            embedToken.attrSet('url', url);
                            embedToken.attrSet('layout', 'center');
                            tokensToAppend.push(embedToken);
                            tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                            outputToken = new state.Token('inline', '', 0);
                            tokensToAppend.push(outputToken);
                            // Track that we've rendered this URL as an inline embed
                            renderedInlineEmbeds.add(url);
                            return;
                        } else if (shouldRenderLinksAsEmbed && isExperimentEnabled?.('rovo_chat_smartlink_embedcard_improvements')) {
                            shouldRenderEmbedAtEnd = false;
                            if (shouldRenderEmbedInline) {
                                outputToken.children = processedTokenChildren;
                                tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                                processedTokenChildren = [];
                                let embedToken = new state.Token('embedCard', '', 0);
                                embedToken.content = '';
                                embedToken.block = true;
                                embedToken.attrSet('url', url);
                                embedToken.attrSet('layout', 'center');
                                tokensToAppend.push(embedToken);
                                tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                                outputToken = new state.Token('inline', '', 0);
                                tokensToAppend.push(outputToken);
                                // Track that we've rendered this URL as an inline embed
                                renderedInlineEmbeds.add(url);
                                return;
                            }
                        }
                        // create an inline card for the links that don't qualify
                        let cardToken = new state.Token('inlineCard', '', 0);
                        cardToken.content = '';
                        cardToken.block = false;
                        cardToken.level = childToken.level;
                        cardToken.attrSet('url', url);
                        processedTokenChildren.push(cardToken);
                        return;
                    }
                    // pushes non link tokens as is
                    processedTokenChildren.push(childToken);
                });
            }
            // set processed children to the output token
            outputToken.children = processedTokenChildren;
            // Keeps inline tokens that have children and all non-inline tokens.
            const blockTokensWithContent = tokensToAppend.filter((t)=>t.type !== 'inline' || t.children?.length);
            tokens.push(...blockTokensWithContent);
        }
        // Remove empty paragraphs otherwise add it to the filteredTokens
        for(let i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') i = i + 1;
        else filteredTokens.push(tokens[i]);
        // Render all embeds at the end of the results if not rendering as inline
        if (embedMatches?.length && shouldRenderEmbedAtEnd) // Default behavior: render all embeds at the end
        [
            ...new Set(embedMatches)
        ].forEach((match)=>{
            let embedToken = new state.Token('embedCard', '', 0);
            embedToken.content = '';
            embedToken.block = true;
            embedToken.attrSet('url', match);
            embedToken.attrSet('layout', 'center');
            embedTokens.push(embedToken);
        });
        state.tokens = [
            ...filteredTokens,
            ...embedTokens
        ];
        return;
    };
const $d5cccf701aceb868$export$9625a798761643ac = (params, isExperimentEnabled)=>(md)=>md.core.ruler.push('inlineCard', $d5cccf701aceb868$var$createSmartLinks({
            ...params,
            isExperimentEnabled: isExperimentEnabled
        }));
module.exports["createSmartLinksPlugin"] = $d5cccf701aceb868$export$9625a798761643ac;

});

parcelRegister("gEMk1", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $lBWya = parcelRequire("lBWya");

const $bf5d74ffdabdc3d2$export$4b1056d02426889c = (url, regexStorage)=>{
    const cachedProviderRegex = $bf5d74ffdabdc3d2$export$90caa0c170ea581(regexStorage);
    if (!cachedProviderRegex.length || !url.length) return false;
    const regexPattern = new RegExp(cachedProviderRegex, 'g');
    return regexPattern.test(url);
};
const $bf5d74ffdabdc3d2$export$90caa0c170ea581 = (regexStorage)=>{
    if (regexStorage.getItem((0, $lBWya.LS_PROVIDER_KEY))) return JSON.parse(`${regexStorage.getItem((0, $lBWya.LS_PROVIDER_KEY))}`);
    return '';
};
const $bf5d74ffdabdc3d2$export$5af966b3aa3b1d83 = (regexStorage, providerRegex)=>{
    regexStorage?.setItem((0, $lBWya.LS_PROVIDER_KEY), JSON.stringify(providerRegex));
};
const $bf5d74ffdabdc3d2$export$d08c351b3b4e4934 = async (regexStorage, baseUrl)=>{
    const providerData = await $bf5d74ffdabdc3d2$export$dfebbb511ada4128(baseUrl);
    if (providerData) {
        const providerRegex = $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a(providerData);
        $bf5d74ffdabdc3d2$export$5af966b3aa3b1d83(regexStorage, providerRegex);
        const providerMapping = $bf5d74ffdabdc3d2$export$8eafd18d19de7df5(providerData);
        $bf5d74ffdabdc3d2$export$b22dfe84603542b1(regexStorage, providerMapping);
    }
};
const $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return '';
    const sources = data.providers.reduce((acc, provider)=>{
        const providerSources = provider.patterns?.map((pattern)=>pattern.source) || [];
        return [
            ...acc,
            ...providerSources
        ];
    }, []);
    return sources.join('|');
};
const $bf5d74ffdabdc3d2$export$8eafd18d19de7df5 = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return {
        combinedRegex: '',
        patterns: []
    };
    const patterns = data.providers.flatMap((provider)=>(provider.patterns || []).map((pattern)=>({
                key: provider.key,
                regex: pattern.source
            })));
    const combinedRegex = patterns.map((p)=>p.regex).join('|');
    return {
        combinedRegex: combinedRegex,
        patterns: patterns
    };
};
const $bf5d74ffdabdc3d2$export$25b8a9cebf834f6e = (regexStorage)=>{
    const stored = regexStorage.getItem((0, $lBWya.LS_PROVIDER_MAPPING_KEY));
    if (stored) try {
        return JSON.parse(stored);
    } catch  {
        return null;
    }
    return null;
};
const $bf5d74ffdabdc3d2$export$b22dfe84603542b1 = (regexStorage, providerMapping)=>{
    regexStorage?.setItem((0, $lBWya.LS_PROVIDER_MAPPING_KEY), JSON.stringify(providerMapping));
};
const $bf5d74ffdabdc3d2$export$c38f83b54395f6dd = (url, regexStorage)=>{
    const mapping = $bf5d74ffdabdc3d2$export$25b8a9cebf834f6e(regexStorage);
    if (!mapping || !url) return null;
    // Test each pattern to find which provider matches
    for (const pattern of mapping.patterns)try {
        const regex = new RegExp(pattern.regex);
        if (regex.test(url)) return pattern.key;
    } catch  {
        continue;
    }
    return null;
};
const $bf5d74ffdabdc3d2$export$dfebbb511ada4128 = (0, $2XqLN.default)(async (baseUrl = '')=>{
    try {
        const response = await fetch(baseUrl + (0, $lBWya.PROVIDERS_API), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type: 'resolve'
            })
        });
        const data = await response.json();
        return data || null;
    } catch  {
        return null;
    }
});
const $bf5d74ffdabdc3d2$export$ab8eaff0f2d596bd = (0, $2XqLN.default)(async (baseUrl = '')=>{
    const data = await $bf5d74ffdabdc3d2$export$dfebbb511ada4128(baseUrl);
    return data ? $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a(data) : '';
});
module.exports["isSupportedByLinkingPlatform"] = $bf5d74ffdabdc3d2$export$4b1056d02426889c;
module.exports["hydrateLinkingPlatformCache"] = $bf5d74ffdabdc3d2$export$d08c351b3b4e4934;
module.exports["getProviderKeyFromUrl"] = $bf5d74ffdabdc3d2$export$c38f83b54395f6dd;

});

parcelRegister("lBWya", function(module, exports) {
const $9088146284880a5b$export$57ad190cdc563df3 = `/gateway/api/object-resolver/providers`;
const $9088146284880a5b$export$1a30f994aeced995 = `/gateway/api/object-resolver/resolve/batch`;
const $9088146284880a5b$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $9088146284880a5b$export$b9858121ed269ff3 = 'aiMateSmartLinkProviderMapping';
module.exports["PROVIDERS_API"] = $9088146284880a5b$export$57ad190cdc563df3;
module.exports["LS_PROVIDER_KEY"] = $9088146284880a5b$export$56bec2f197c16818;
module.exports["LS_PROVIDER_MAPPING_KEY"] = $9088146284880a5b$export$b9858121ed269ff3;

});

parcelRegister("1Ce64", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ff6b0f828ae5055$export$2e2bcd8739ae039);
const $9ff6b0f828ae5055$var$tableBreakTags = (state)=>{
    const tokens = state.tokens;
    // Find all table tokens
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Check if we're inside a table
        if (token.type === 'table_open') {
            // Process all tokens until the matching table_close
            let j = i + 1;
            while(j < tokens.length && tokens[j].type !== 'table_close'){
                // If we're in a table cell content
                if (tokens && tokens[j]?.type === 'inline' && tokens[j]?.children && tokens[j]?.children?.length) {
                    // Process the content of the cell
                    const children = tokens[j]?.children;
                    if (!children) continue;
                    for(let k = 0; k < children.length; k++){
                        const child = children[k];
                        if (!child) continue;
                        // Replace <br>, <br/>, and <br /> tags with newlines
                        // Match different variations of <br> tags
                        const brRegex = /<br\s*\/?>/gi;
                        if (brRegex.test(child.content)) {
                            child.content = child.content.replace(brRegex, '\n');
                            // If the content is now just a newline, change the token type
                            if (child.content === '\n') child.type = 'hardbreak';
                        }
                    }
                }
                j++;
            }
            // Skip to the end of the table
            i = j;
        }
    }
    return;
};
var $9ff6b0f828ae5055$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('table-break-tags', $9ff6b0f828ae5055$var$tableBreakTags);

});

parcelRegister("5XYXq", function(module, exports) {
$parcel$export(module.exports, "default", () => $28815f35966a9eaf$export$2e2bcd8739ae039);
const $28815f35966a9eaf$var$CHART_REGEX = /\[\^(chart)\^\]/;
const $28815f35966a9eaf$var$visualizationChart = (state)=>{
    const tokens = [];
    let chartCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $28815f35966a9eaf$var$CHART_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($28815f35966a9eaf$var$CHART_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        // Create a new token for each chart match
                        const chartToken = new state.Token('status', '', 0);
                        chartToken.content = '';
                        chartToken.block = false;
                        chartToken.level = childToken.level;
                        chartToken.attrs = [
                            [
                                'localId',
                                'chart-' + chartCounter
                            ],
                            [
                                'text',
                                'loading chart-' + chartCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(chartToken);
                        chartCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $28815f35966a9eaf$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('chart', $28815f35966a9eaf$var$visualizationChart);
}

});

parcelRegister("7ai6d", function(module, exports) {
const $a1a032ec05100051$export$cd54a56af01ba875 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $a1a032ec05100051$export$eb83d753215c78a2 = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        attrs: (tok)=>({
                state: tok.meta
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    code_inline: {
        mark: 'code'
    },
    ordered_list: {
        block: 'orderedList',
        attrs: (tok)=>{
            const order = +(tok.attrGet('order') || 1);
            return {
                order: order
            };
        }
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        attrs: (tok)=>({
                language: tok.info?.trim() || null
            })
    },
    image: {
        node: 'image',
        attrs: (_tok)=>{
            return {};
        }
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                type: 'external'
            };
        }
    },
    // Enable ADF SmartLinks, produced by our SmartLink MD plugin
    inlineCard: {
        node: 'inlineCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    blockCard: {
        node: 'blockCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    embedCard: {
        node: 'embedCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    // Enable ADF Mentions, produced by our Mentions MD plugin which converts /people links
    mention: {
        node: 'mention',
        attrs: (tok)=>{
            return {
                id: tok.attrGet('id'),
                text: tok.attrGet('text'),
                type: 'mention'
            };
        }
    },
    status: {
        node: 'status',
        attrs: (token)=>({
                text: token.attrGet('text'),
                color: token.attrGet('color'),
                localId: token.attrGet('localId')
            })
    }
};
module.exports["pmToMd"] = $a1a032ec05100051$export$cd54a56af01ba875;
module.exports["mdToPmSchema"] = $a1a032ec05100051$export$eb83d753215c78a2;

});

parcelRegister("bCKHR", function(module, exports) {

var $7ai6d = parcelRequire("7ai6d");

const $8bba972fb5d34921$export$155749302793c60c = (schema, map)=>Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
const $8bba972fb5d34921$export$a1cf9d9b96e16789 = (md, schema)=>{
    for(const k in 0, $7ai6d.pmToMd){
        const key = k;
        for(const i in (0, $7ai6d.pmToMd)[key]){
            const idx = i;
            if (schema[key][idx]) md.enable((0, $7ai6d.pmToMd)[key][idx]);
        }
    }
};
module.exports["filterSchemaMapping"] = $8bba972fb5d34921$export$155749302793c60c;
module.exports["enableSchemaPlugins"] = $8bba972fb5d34921$export$a1cf9d9b96e16789;

});

parcelRegister("eMqrF", function(module, exports) {

var $02AY0 = parcelRequire("02AY0");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/team/manifest.ts
var $ac2a0fd84662e75e$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $02AY0.IdentityTeamAriResourceOwner),
    resourceType: (0, $02AY0.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $ac2a0fd84662e75e$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $3NXcb.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts), this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["IdentityTeamAri"] = $ac2a0fd84662e75e$export$33bbb2d79e520118;

});

parcelRegister("02AY0", function(module, exports) {
// src/identity/team/types.ts
var $007cdcdc857abd84$export$49beddf48ffb3f35 = "identity", $007cdcdc857abd84$export$b2079a2a841afe32 = "team";
module.exports["IdentityTeamAriResourceOwner"] = $007cdcdc857abd84$export$49beddf48ffb3f35;
module.exports["IdentityTeamAriResourceType"] = $007cdcdc857abd84$export$b2079a2a841afe32;

});

parcelRegister("b8JCF", function(module, exports) {

var $1VjMI = parcelRequire("1VjMI");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/jira/issue/manifest.ts
var $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1VjMI.JiraIssueAriResourceOwner),
    resourceType: (0, $1VjMI.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $81c3d4c7dce903d7$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
};
module.exports["JiraIssueAri"] = $81c3d4c7dce903d7$export$1da6808e89ee03e;

});

parcelRegister("1VjMI", function(module, exports) {
// src/jira/issue/types.ts
var $166a76280cbc11fa$export$665a39f1b4e29e0a = "jira", $166a76280cbc11fa$export$76beb4d0da177ad4 = "issue";
module.exports["JiraIssueAriResourceOwner"] = $166a76280cbc11fa$export$665a39f1b4e29e0a;
module.exports["JiraIssueAriResourceType"] = $166a76280cbc11fa$export$76beb4d0da177ad4;

});

parcelRegister("5JRMI", function(module, exports) {

var $ehowZ = parcelRequire("ehowZ");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/townsquare/project/manifest.ts
var $01140be010796b0a$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ehowZ.TownsquareProjectAriResourceOwner),
    resourceType: (0, $ehowZ.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $01140be010796b0a$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
};
module.exports["TownsquareProjectAri"] = $01140be010796b0a$export$41215e8d01921e7d;

});

parcelRegister("ehowZ", function(module, exports) {
// src/townsquare/project/types.ts
var $a655ae9218632ad3$export$a258bc824c789b17 = "townsquare", $a655ae9218632ad3$export$aa8900dadffaa32a = "project";
module.exports["TownsquareProjectAriResourceOwner"] = $a655ae9218632ad3$export$a258bc824c789b17;
module.exports["TownsquareProjectAriResourceType"] = $a655ae9218632ad3$export$aa8900dadffaa32a;

});

parcelRegister("dj7jL", function(module, exports) {
const $e6073c916b049162$export$bc4191f7b8dfa3a4 = {
    CONFLUENCE: 'confluence',
    JIRA: 'jira'
};
module.exports["PARENT_PRODUCTS"] = $e6073c916b049162$export$bc4191f7b8dfa3a4;

});

parcelRegister("1DfVr", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $4BDAe = parcelRequire("4BDAe");


var $io4wE = parcelRequire("io4wE");

const $af9c2f3d9e69f02f$export$46eb6ca3d43ca839 = (parentProduct, cloudId, onClose)=>{
    const { open: open, close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const openConfluencePagePreviewPanel = (0, $42omo.useCallback)((url, onOpen, panelData)=>{
        open({
            panel: {
                id: `confluence-page-preview-panel_${url.split('/').pop()}`,
                type: 'confluence-page',
                content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $io4wE.default), {
                        props: {
                            url: url,
                            parentProduct: parentProduct,
                            cloudId: cloudId,
                            panelData: panelData
                        },
                        entryPoints: {},
                        extraProps: {},
                        queries: {}
                    }),
                product: 'confluencePreviewPanel'
            },
            onOpen: onOpen
        });
    }, [
        open,
        parentProduct,
        cloudId
    ]);
    const closeConfluencePagePreviewPanel = (0, $42omo.useCallback)(()=>{
        close(onClose);
    }, [
        close,
        onClose
    ]);
    return {
        openConfluencePagePreviewPanel: openConfluencePagePreviewPanel,
        closeConfluencePagePreviewPanel: closeConfluencePagePreviewPanel
    };
};
module.exports["useConfluencePagePreviewPanel"] = $af9c2f3d9e69f02f$export$46eb6ca3d43ca839;

});

parcelRegister("io4wE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $8jHAi = parcelRequire("8jHAi");


var $cOrQJ = parcelRequire("cOrQJ");


var $bHGk9 = parcelRequire("bHGk9");


var $ibFXh = parcelRequire("ibFXh");

var $1GJJf = parcelRequire("1GJJf");

var $aSy6D = parcelRequire("aSy6D");

var $8APLM = parcelRequire("8APLM");

var $3ZVni = parcelRequire("3ZVni");

var $3R2u2 = parcelRequire("3R2u2");


var $4BDAe = parcelRequire("4BDAe");


var $cu1WV = parcelRequire("cu1WV");


var $aXOz9 = parcelRequire("aXOz9");

const $178f91e075c3dc2a$var$styles = {
    body: "_16jlkb7n _18m915vq _ca0q1ejb _u5f31ejb _19bv1ejb"
};
const $178f91e075c3dc2a$var$ConfluencePagePreviewPanel = ({ props: { url: url, parentProduct: parentProduct, cloudId: cloudId, panelData: panelData } })=>{
    const { close: close, setPanelWidth: setPanelWidth } = (0, $4BDAe.usePreviewPanelsActions)();
    const [analyticsClient, setAnalyticsClient] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const themeState = (0, $cOrQJ.default)();
    const { actions: actions } = panelData || {};
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        setAnalyticsClient((0, $aXOz9.initializeAnalyticsClient)(cloudId));
    }, [
        cloudId,
        setAnalyticsClient
    ]);
    const onModeChange = (mode)=>(0, $aXOz9.onEditMode)(mode, setPanelWidth);
    const onClose = ()=>{
        actions?.onClose?.();
        close();
    };
    const formattedUrl = (0, $42omo.useMemo)(()=>(0, $aXOz9.constructUrl)(themeState, url, panelData), [
        panelData,
        url,
        themeState
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $ibFXh.PreviewPanel), {
        testId: "confluence-preview-panel",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $3ZVni.PreviewPanelHeader), {
                analyticsClient: analyticsClient,
                parentProduct: parentProduct,
                panelType: 'confluence-page',
                onClose: onClose,
                onOpenInNewTab: actions?.onOpenInNewTab,
                url: formattedUrl,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $3R2u2.PreviewPanelTitle), {
                        title: formatMessage((0, $cu1WV.messages).pageTitle),
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                            label: "",
                            size: "medium"
                        })
                    }),
                    !!actions && /*#__PURE__*/ (0, $l998X.jsx)((0, $1GJJf.PreviewPanelActionGroup), {
                        children: actions.onExpand && /*#__PURE__*/ (0, $l998X.jsx)((0, $8APLM.PreviewPanelExpand), {
                            onClick: actions.onExpand
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $aSy6D.PreviewPanelBody), {
                analyticsClient: analyticsClient,
                parentProduct: parentProduct,
                panelType: 'confluence-page',
                styles: $178f91e075c3dc2a$var$styles.body,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bHGk9.EmbeddedConfluence), {
                    url: formattedUrl,
                    showFooter: false,
                    hasFooterLogo: false,
                    onModeChange: onModeChange,
                    parentProduct: parentProduct,
                    embeddedConfluenceSource: "confluence-page-preview-panel",
                    themeState: themeState
                })
            })
        ]
    });
};
var $178f91e075c3dc2a$export$2e2bcd8739ae039 = $178f91e075c3dc2a$var$ConfluencePagePreviewPanel;
module.exports["default"] = $178f91e075c3dc2a$export$2e2bcd8739ae039;

});

parcelRegister("bHGk9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

parcelRequire("aqrhZ");
var $96msn = parcelRequire("96msn");
var $jyd5r = parcelRequire("jyd5r");


var $kFwgS = parcelRequire("kFwgS");

var $I1nNR = parcelRequire("I1nNR");

var $kudeD = parcelRequire("kudeD");


var $9ImuD = parcelRequire("9ImuD");

const $4a221c0892a490b0$var$styles = {
    fallback: "_1bsb1osq _4t3i1osq"
}; // @ts-ignore

const $4a221c0892a490b0$var$LazyEmbeddedConfluence = (0, $96msn.lazyForPaint)(()=>(parcelRequire("k5VGT")));
const $4a221c0892a490b0$export$c4789cfd0b0cd2c4 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $9ImuD.default),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kudeD.PerformanceMetricsProvider), {
            contentType: props.mode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? 'editPage' : 'viewPage',
            sourceComponent: 'EmbeddedConfluence',
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jyd5r.LazySuspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $4a221c0892a490b0$var$styles.fallback
                }),
                children: /*#__PURE__*/ (0, $l998X.jsx)($4a221c0892a490b0$var$LazyEmbeddedConfluence, {
                    ...props
                })
            })
        })
    });
module.exports["EmbeddedConfluence"] = $4a221c0892a490b0$export$c4789cfd0b0cd2c4;

});

parcelRegister("k5VGT", function(module, exports) {

let $ea11067ab3fd72d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ea11067ab3fd72d6$var$load("5EQhG"),
    $ea11067ab3fd72d6$var$load("Wowvf"),
    $ea11067ab3fd72d6$var$load("hhss7"),
    $ea11067ab3fd72d6$var$load("kG8pF")
]).then(()=>parcelRequire('9bXIX'));

});

parcelRegister("ibFXh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eyWa4 = parcelRequire("eyWa4");

const $0f4f34a4aa7da555$var$styles = {
    wrapper: "_4t3i1osq _bfhkvuon"
};
const $0f4f34a4aa7da555$export$9520f072db304aa0 = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        xcss: $0f4f34a4aa7da555$var$styles.wrapper,
        testId: testId,
        children: children
    });
};
module.exports["PreviewPanel"] = $0f4f34a4aa7da555$export$9520f072db304aa0;

});

parcelRegister("1GJJf", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");

const $1fc8fb56653d2345$export$b3bbf50939c515ce = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        testId: testId,
        space: "space.050",
        alignBlock: "center",
        children: children
    });
};
module.exports["PreviewPanelActionGroup"] = $1fc8fb56653d2345$export$b3bbf50939c515ce;

});

parcelRegister("aSy6D", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

const $dd1efdb181d94706$export$cda5e69749e7aeee = ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: styles })=>{
    (0, $42omo.useEffect)(()=>{
        if (analyticsClient) {
            analyticsClient.sendTrackEvent({
                action: 'viewed',
                actionSubject: 'preview-panel',
                actionSubjectId: 'preview-panel-view',
                source: 'preview-panel',
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? analyticsAttributes : {}
                }
            });
            // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
            // Fires at most once per hour, per product.
            // Requires tenantInfo and userInfo to be set
            analyticsClient?.startUIViewedEvent();
        }
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(!!styles && styles),
        children: children
    });
};
module.exports["PreviewPanelBody"] = $dd1efdb181d94706$export$cda5e69749e7aeee;

});

parcelRegister("8APLM", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $lOzEN = parcelRequire("lOzEN");


var $fZVub = parcelRequire("fZVub");


var $2os6v = parcelRequire("2os6v");

const $91e6116a3cc9352a$export$40b251582cb3e1fe = ({ onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2os6v.PreviewPanelAction), {
        label: formatMessage((0, $fZVub.default).previewPanelExpandActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))),
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelExpand"] = $91e6116a3cc9352a$export$40b251582cb3e1fe;

});

parcelRegister("fZVub", function(module, exports) {
$parcel$export(module.exports, "default", () => $920790d5dac34360$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $920790d5dac34360$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: "navigation.preview-panel.preview-panel-header.close-button-label",
        defaultMessage: "Close"
    },
    previewPanelExpandActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label",
        defaultMessage: "Expand"
    },
    previewPanelNewTabActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label",
        defaultMessage: "Open in new tab"
    },
    previewPanelMoreDropdownActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label",
        defaultMessage: "More"
    },
    previewPanelOpenInNewWindowLabel: {
        id: "navigation.preview-panel.preview-panel-header.open-in-new-window-label",
        defaultMessage: "Open in new window"
    }
});

});

parcelRegister("2os6v", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");

var $dE1p6 = parcelRequire("dE1p6");

const $ed5d65f9b39936d9$export$a37cb5f447b2cf16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function PreviewPanelAction({ icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext }, ref) {
    return href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dE1p6.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        target: "_blank",
        ref: ref,
        role: "button"
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        ref: ref,
        role: "button"
    });
});
module.exports["PreviewPanelAction"] = $ed5d65f9b39936d9$export$a37cb5f447b2cf16;

});

parcelRegister("3ZVni", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");


var $fZVub = parcelRequire("fZVub");


var $6CSXv = parcelRequire("6CSXv");

const $ce13ec86664e204c$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $ce13ec86664e204c$var$styles = {
    header: "_1h6d1l7x _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _12ornqa1 _1r62e4h9 _4t3i8vuz",
    childWrapper: "_16jlkb7n"
};
const $ce13ec86664e204c$export$426d4171de44bac0 = ({ children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onOpenInNewTab?.();
        if (url) window.open($ce13ec86664e204c$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        xcss: $ce13ec86664e204c$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                xcss: $ce13ec86664e204c$var$styles.childWrapper,
                spread: "space-between",
                alignBlock: "center",
                space: "space.100",
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                gap: "space.100",
                children: [
                    url && /*#__PURE__*/ (0, $l998X.jsx)((0, $6CSXv.PreviewPanelNewTabLink), {
                        label: formatMessage((0, $fZVub.default).previewPanelOpenInNewWindowLabel),
                        onClick: onOpenInNewWindow,
                        testId: testId && `${testId}.open-in-new-window-button`
                    }),
                    moreActions,
                    onClose && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                ...iconProps,
                                size: "small"
                            }),
                        label: formatMessage((0, $fZVub.default).previewPanelCloseButtonLabel),
                        onClick: onPanelClose,
                        testId: testId && `${testId}.close-button`,
                        role: "button"
                    })
                ]
            })
        ]
    });
};
module.exports["PreviewPanelHeader"] = $ce13ec86664e204c$export$426d4171de44bac0;

});

parcelRegister("6CSXv", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $8tdj3 = parcelRequire("8tdj3");


var $fZVub = parcelRequire("fZVub");


var $2os6v = parcelRequire("2os6v");

const $4d61e3d7ff65f94b$export$d05dda6f1d91eaad = ({ href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2os6v.PreviewPanelAction), {
        label: label || formatMessage((0, $fZVub.default).previewPanelNewTabActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelNewTabLink"] = $4d61e3d7ff65f94b$export$d05dda6f1d91eaad;

});

parcelRegister("3R2u2", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");

const $237c600fec460668$export$92a58681483f4529 = ({ title: title, icon: icon, color: color })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                weight: "bold",
                maxLines: 1,
                color: color,
                children: title
            })
        ]
    });
};
module.exports["PreviewPanelTitle"] = $237c600fec460668$export$92a58681483f4529;

});

parcelRegister("cu1WV", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $11543dd8ad4b06d3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    pageTitle: {
        id: "confluence.page.preview.panel.pageTitle",
        defaultMessage: "Confluence Page"
    },
    whiteboardTitle: {
        id: "confluence.page.preview.panel.whiteboardTitle",
        defaultMessage: "Confluence Whiteboard"
    }
});
module.exports["messages"] = $11543dd8ad4b06d3$export$defe85febe8b728c;

});

parcelRegister("aXOz9", function(module, exports) {

var $a9sR2 = parcelRequire("a9sR2");

var $5DUgU = parcelRequire("5DUgU");


var $kFwgS = parcelRequire("kFwgS");


var $3WsBD = parcelRequire("3WsBD");

const $8f94b4972688fbbf$export$232fd46a0431e57a = (mode, setPanelWidth)=>mode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? setPanelWidth(Math.floor(window.innerWidth / 2)) : {};
const $8f94b4972688fbbf$export$4acedbb0ac692186 = (hostname)=>{
    if (hostname.includes('localhost')) return (0, $5DUgU.envType).LOCAL;
    if (hostname.includes('jira-dev')) return (0, $5DUgU.envType).DEV;
    return (0, $5DUgU.envType).PROD;
};
const $8f94b4972688fbbf$export$fbee84a774b6734d = (url, themeParam)=>{
    if (!themeParam) return url;
    if (!url.includes('?')) return `${url}?${themeParam}`;
    const [baseUrl, params] = url.split('?');
    const paramsArr = params.split('&');
    if (paramsArr.includes(themeParam)) return url;
    const otherParams = paramsArr.filter((param)=>!(param.split('=')[0] === 'themeState')).join('&');
    const newParams = otherParams ? `${themeParam}&${otherParams}` : themeParam;
    return `${baseUrl}?${newParams}`;
};
const $8f94b4972688fbbf$export$7d842b959fcdcd03 = (cloudId)=>{
    const analyticsClient = new (0, $a9sR2.default)({
        product: 'confluencePreviewPanel',
        env: $8f94b4972688fbbf$export$4acedbb0ac692186(window.location?.hostname),
        origin: (0, $5DUgU.originType).WEB
    });
    if (cloudId) analyticsClient.setTenantInfo((0, $5DUgU.tenantType).CLOUD_ID, cloudId);
    return analyticsClient;
};
const $8f94b4972688fbbf$export$d9ce73382ee04318 = (originalUrl, embedUrl)=>{
    if (!embedUrl) return originalUrl;
    try {
        const previewUrl = new URL(embedUrl);
        const contentId = previewUrl.searchParams.get('contentId');
        const spaceKey = previewUrl.searchParams.get('spaceKey');
        const hostname = previewUrl.searchParams.get('hostname');
        if (contentId && spaceKey && hostname) {
            const decodedSpaceKey = decodeURIComponent(spaceKey);
            const resolved = new URL(`https://${hostname}/wiki/spaces/${decodedSpaceKey}/pages/${contentId}`);
            // Preserve all original URL parameters
            const originalUrl_ = new URL(originalUrl);
            for (const [key, value] of originalUrl_.searchParams)resolved.searchParams.set(key, value);
            return resolved.toString();
        }
    } catch (error) {
        // If URL parsing fails, fall back to original URL
        return originalUrl;
    }
    return originalUrl;
};
const $8f94b4972688fbbf$export$a639a54e55b70225 = (themeState, url, panelData)=>{
    const themeStateParam = themeState ? `themeState=${(0, $3WsBD.themeStateObjectToQueryString)(themeState)}` : '';
    const cardStateUrl = panelData ? $8f94b4972688fbbf$export$d9ce73382ee04318(url, panelData?.embedUrl) : url;
    const formattedUrl = themeStateParam ? $8f94b4972688fbbf$export$fbee84a774b6734d(cardStateUrl, themeStateParam) : cardStateUrl;
    return formattedUrl;
};
module.exports["onEditMode"] = $8f94b4972688fbbf$export$232fd46a0431e57a;
module.exports["initializeAnalyticsClient"] = $8f94b4972688fbbf$export$7d842b959fcdcd03;
module.exports["constructUrl"] = $8f94b4972688fbbf$export$a639a54e55b70225;

});

parcelRegister("aH9Q1", function(module, exports) {

var $2xciB = parcelRequire("2xciB");


var $58Nu8 = parcelRequire("58Nu8");


var $56LFI = parcelRequire("56LFI");

const $da1a55ed1292d791$var$cache = (0, $2xciB.createCache)(new Map());
function $da1a55ed1292d791$export$e83743682263315a(loader, opts) {
    return $da1a55ed1292d791$var$cache.get(opts.moduleId, ()=>(0, $58Nu8.PreloadableJSResource)(()=>(0, $56LFI.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
}
module.exports["JSResourceForInteraction"] = $da1a55ed1292d791$export$e83743682263315a;

});

parcelRegister("2xciB", function(module, exports) {
function $148a59911478cb25$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}
module.exports["createCache"] = $148a59911478cb25$export$cf6fa0bbcc94b912;

});

parcelRegister("58Nu8", function(module, exports) {

var $2X3nY = parcelRequire("2X3nY");

function $ba332286d251cd41$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $2X3nY.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}
module.exports["PreloadableJSResource"] = $ba332286d251cd41$export$4fe5fba5bb1d3c09;

});

parcelRegister("2X3nY", function(module, exports) {

var $6hmze = parcelRequire("6hmze");


var $cAXnn = parcelRequire("cAXnn");


var $7Z6yP = parcelRequire("7Z6yP");

function $39dd57c545107221$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $6hmze.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $cAXnn.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $7Z6yP.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}
module.exports["JSResource"] = $39dd57c545107221$export$148e45a6d4b4d65;

});

parcelRegister("6hmze", function(module, exports) {
let $546b0d6600b43919$var$id = 100000;
function $546b0d6600b43919$export$567fc7097e064344() {
    $546b0d6600b43919$var$id += 1;
    return $546b0d6600b43919$var$id.toString();
}
module.exports["generateId"] = $546b0d6600b43919$export$567fc7097e064344;

});

parcelRegister("cAXnn", function(module, exports) {
function $df7beae67697fe3a$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $df7beae67697fe3a$export$10dc3edfc20c8ff = $df7beae67697fe3a$var$createEventEmitter();
module.exports["eventEmitter"] = $df7beae67697fe3a$export$10dc3edfc20c8ff;

});

parcelRegister("7Z6yP", function(module, exports) {
function $1cfe6d8b66e6a41d$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}
module.exports["isJSModuleWithDefaultExport"] = $1cfe6d8b66e6a41d$export$3b514faac3ba993c;

});

parcelRegister("56LFI", function(module, exports) {
async function $d3c226111d006051$var$toPromise(callback) {
    return callback();
}
function $d3c226111d006051$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $d3c226111d006051$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $d3c226111d006051$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("j5M61")).then(()=>$d3c226111d006051$var$getScheduler(globalThis).postTask(callback, options));
        return $d3c226111d006051$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}
module.exports["postTask"] = $d3c226111d006051$export$13c9d02ca54955a3;

});

parcelRegister("j5M61", function(module, exports) {

let $de63cad6e511e9d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de63cad6e511e9d7$var$load("5a167").then(()=>parcelRequire('jUuBC'));

});

parcelRegister("cab2i", function(module, exports) {
/* eslint-disable @typescript-eslint/ban-types */ function $991254190d627578$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}
module.exports["createEntryPoint"] = $991254190d627578$export$fa00dd5c1a75592f;

});

parcelRegister("4M6GB", function(module, exports) {

var $bniL1 = parcelRequire("bniL1");


var $hnvzE = parcelRequire("hnvzE");

const $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent = (0, $hnvzE.default);
const $a93efc0d5ccefe43$var$entryPointConfig = {
    PlaceholderComponent: (0, $bniL1.default),
    UFOSegmentComponent: $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $a93efc0d5ccefe43$export$93a6801f9db838c4(overrides) {
    Object.assign($a93efc0d5ccefe43$var$entryPointConfig, overrides);
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
function $a93efc0d5ccefe43$export$dfa96f26176fa91f() {
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
module.exports["useEntryPointConfig"] = $a93efc0d5ccefe43$export$dfa96f26176fa91f;

});

parcelRegister("48FEk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $dh538 = parcelRequire("dh538");


var $eduVw = parcelRequire("eduVw");


var $hNKXO = parcelRequire("hNKXO");


var $4M6GB = parcelRequire("4M6GB");

const $f9885621a7911f5b$var$noop = ()=>{};
function $f9885621a7911f5b$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $4M6GB.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const reportErrorUFO = (0, $dh538.fg)('entry_point_container_ufo_report_error') ? (0, $eduVw.useUFOReportError)() : $f9885621a7911f5b$var$noop;
    const onError = (0, $42omo.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $hNKXO.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        if ((0, $dh538.fg)('entry_point_container_ufo_report_error')) reportErrorUFO({
            name: id,
            errorMessage: error.message,
            errorStack: error.stack,
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $42omo.useCallback)(({ error: error })=>{
        const onClose = runtimeProps?.onClose ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError,
        children: /*#__PURE__*/ (0, $l998X.jsx)(PlaceholderComponent, {
            name: placeholderName ?? 'internal-internal-entry-point-container',
            fallback: fallback,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $irOoi.EntryPointContainer), {
                entryPointReference: entryPointReference,
                props: runtimeProps
            })
        })
    });
}
function $f9885621a7911f5b$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $4M6GB.useEntryPointConfig)();
    return /*#__PURE__*/ (0, $l998X.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $l998X.jsx)($f9885621a7911f5b$var$InternalEntryPointContainerInner, {
            ...props
        })
    });
}
module.exports["InternalEntryPointContainer"] = $f9885621a7911f5b$export$5d4dc37edd8a3adb;

});

parcelRegister("hNKXO", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $e5b5ac7e446444f2$var$buffer = [];
let $e5b5ac7e446444f2$var$push = (payload)=>{
    $e5b5ac7e446444f2$var$buffer.push(payload);
};
function $e5b5ac7e446444f2$export$b33b857ad1d9900e(payload) {
    $e5b5ac7e446444f2$var$push(payload);
}
function $e5b5ac7e446444f2$export$abd5747ea77ecab9(handler) {
    if ((0, $dh538.fg)('moving_jira_entry-points_api_under_platform')) {
        $e5b5ac7e446444f2$var$push = handler;
        $e5b5ac7e446444f2$var$buffer.forEach((payload)=>handler(payload));
        $e5b5ac7e446444f2$var$buffer.length = 0;
    }
}
module.exports["reportError"] = $e5b5ac7e446444f2$export$b33b857ad1d9900e;

});

parcelRegister("bJbIe", function(module, exports) {
$parcel$export(module.exports, "default", () => $889cfb8399c60f9e$export$2e2bcd8739ae039);

var $da6O1 = parcelRequire("da6O1");


var $R3ff4 = parcelRequire("R3ff4");


var $g3Gzi = parcelRequire("g3Gzi");


var $f5SRR = parcelRequire("f5SRR");


var $egXhZ = parcelRequire("egXhZ");


var $9hDHZ = parcelRequire("9hDHZ");


var $1tT8e = parcelRequire("1tT8e");


var $qc9ak = parcelRequire("qc9ak");


var $671gj = parcelRequire("671gj");


var $jZ39j = parcelRequire("jZ39j");


var $b5utg = parcelRequire("b5utg");


var $l9XGS = parcelRequire("l9XGS");


var $3Ujd4 = parcelRequire("3Ujd4");


var $2h3f7 = parcelRequire("2h3f7");

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $889cfb8399c60f9e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $889cfb8399c60f9e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $889cfb8399c60f9e$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $889cfb8399c60f9e$var$doubleQuoteRegExp = /''/g;
var $889cfb8399c60f9e$var$notWhitespaceRegExp = /\S/;
var $889cfb8399c60f9e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $889cfb8399c60f9e$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $b5utg.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $g3Gzi.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $jZ39j.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $jZ39j.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $egXhZ.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $l9XGS.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($889cfb8399c60f9e$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $1tT8e.default)) {
            var longFormatter = (0, $1tT8e.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($889cfb8399c60f9e$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $R3ff4.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $671gj.isProtectedWeekYearToken)(token)) (0, $671gj.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $671gj.isProtectedDayOfYearToken)(token)) (0, $671gj.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $3Ujd4.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($889cfb8399c60f9e$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $889cfb8399c60f9e$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $da6O1.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $889cfb8399c60f9e$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $egXhZ.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $f5SRR.default)(date, (0, $qc9ak.default)(date));
    var flags = {};
    var _iterator2 = (0, $R3ff4.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $9hDHZ.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $889cfb8399c60f9e$var$cleanEscapedString(input) {
    return input.match($889cfb8399c60f9e$var$escapedStringRegExp)[1].replace($889cfb8399c60f9e$var$doubleQuoteRegExp, "'");
}

});

parcelRegister("R3ff4", function(module, exports) {

var $TsV82 = parcelRequire("TsV82");

function $09f777b5b2878172$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $TsV82.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports["default"] = $09f777b5b2878172$export$2e2bcd8739ae039;

});

parcelRegister("TsV82", function(module, exports) {

var $9jNLK = parcelRequire("9jNLK");

function $0a6b9229e3e26525$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $9jNLK.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $9jNLK.default)(r, a) : void 0;
    }
}
module.exports["default"] = $0a6b9229e3e26525$export$2e2bcd8739ae039;

});

parcelRegister("9jNLK", function(module, exports) {
function $6c8c7e8119113394$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports["default"] = $6c8c7e8119113394$export$2e2bcd8739ae039;

});

parcelRegister("l9XGS", function(module, exports) {

var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $iLaQ6 = parcelRequire("iLaQ6");

var $f678bd8d7ac0b60d$var$TIMEZONE_UNIT_PRIORITY = 10;
var $f678bd8d7ac0b60d$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $kWj1y.default)(this, Setter);
        (0, $iLaQ6.default)(this, "priority", void 0);
        (0, $iLaQ6.default)(this, "subPriority", 0);
    }
    (0, $9xXPc.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $f678bd8d7ac0b60d$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $gfm86.default)(ValueSetter, _Setter);
    var _super = (0, $3wwsR.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $kWj1y.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $9xXPc.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($f678bd8d7ac0b60d$export$81d53e3678089a6);
var $f678bd8d7ac0b60d$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $gfm86.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $3wwsR.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $kWj1y.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this2), "priority", $f678bd8d7ac0b60d$var$TIMEZONE_UNIT_PRIORITY);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $9xXPc.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($f678bd8d7ac0b60d$export$81d53e3678089a6);
module.exports["ValueSetter"] = $f678bd8d7ac0b60d$export$9a09e32dd4990fd5;
module.exports["DateToSystemTimezoneSetter"] = $f678bd8d7ac0b60d$export$5aaf7ff7f09ea4ee;

});

parcelRegister("5KkDP", function(module, exports) {
function $42f1429094bd004c$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports["default"] = $42f1429094bd004c$export$2e2bcd8739ae039;

});

parcelRegister("gfm86", function(module, exports) {

var $9JDHm = parcelRequire("9JDHm");

function $bd3f3687ad31e822$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $9JDHm.default)(t, e);
}
module.exports["default"] = $bd3f3687ad31e822$export$2e2bcd8739ae039;

});

parcelRegister("3wwsR", function(module, exports) {

var $23OHc = parcelRequire("23OHc");


var $1dBP2 = parcelRequire("1dBP2");


var $82Dwy = parcelRequire("82Dwy");

function $290d8b0c402264de$export$2e2bcd8739ae039(t) {
    var r = (0, $1dBP2.default)();
    return function() {
        var e, o = (0, $23OHc.default)(t);
        if (r) {
            var s = (0, $23OHc.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $82Dwy.default)(this, e);
    };
}
module.exports["default"] = $290d8b0c402264de$export$2e2bcd8739ae039;

});

parcelRegister("23OHc", function(module, exports) {
$parcel$export(module.exports, "default", () => $18032fb0cc96bfcf$export$2e2bcd8739ae039);
function $18032fb0cc96bfcf$export$2e2bcd8739ae039(t) {
    return $18032fb0cc96bfcf$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $18032fb0cc96bfcf$export$2e2bcd8739ae039(t);
}

});

parcelRegister("1dBP2", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e34580674e4df99$export$2e2bcd8739ae039);
function $0e34580674e4df99$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0e34580674e4df99$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("82Dwy", function(module, exports) {

var $da6O1 = parcelRequire("da6O1");


var $5KkDP = parcelRequire("5KkDP");

function $5dad2b4c21ff4d60$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $da6O1.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $5KkDP.default)(t);
}
module.exports["default"] = $5dad2b4c21ff4d60$export$2e2bcd8739ae039;

});

parcelRegister("kWj1y", function(module, exports) {
function $f3e7fb3aad6b0ea3$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports["default"] = $f3e7fb3aad6b0ea3$export$2e2bcd8739ae039;

});

parcelRegister("9xXPc", function(module, exports) {

var $gCRro = parcelRequire("gCRro");

function $6f359a1653c3da39$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $gCRro.default)(o.key), o);
    }
}
function $6f359a1653c3da39$export$2e2bcd8739ae039(e, r, t) {
    return r && $6f359a1653c3da39$var$_defineProperties(e.prototype, r), t && $6f359a1653c3da39$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports["default"] = $6f359a1653c3da39$export$2e2bcd8739ae039;

});

parcelRegister("3Ujd4", function(module, exports) {

var $hzQbH = parcelRequire("hzQbH");


var $ME38g = parcelRequire("ME38g");


var $ODxM2 = parcelRequire("ODxM2");


var $afFXj = parcelRequire("afFXj");


var $7Wbag = parcelRequire("7Wbag");


var $du6zo = parcelRequire("du6zo");


var $2hTtW = parcelRequire("2hTtW");


var $lof2I = parcelRequire("lof2I");


var $1wUSc = parcelRequire("1wUSc");


var $dJ7Bc = parcelRequire("dJ7Bc");


var $56Qdz = parcelRequire("56Qdz");


var $f5ZuE = parcelRequire("f5ZuE");


var $hahvS = parcelRequire("hahvS");


var $4hkrg = parcelRequire("4hkrg");


var $8W49h = parcelRequire("8W49h");


var $dGU37 = parcelRequire("dGU37");


var $5jyPW = parcelRequire("5jyPW");


var $9v13k = parcelRequire("9v13k");


var $5IZ8l = parcelRequire("5IZ8l");


var $5GZ8B = parcelRequire("5GZ8B");


var $jvsga = parcelRequire("jvsga");


var $159WX = parcelRequire("159WX");


var $kEUZw = parcelRequire("kEUZw");


var $8dVaB = parcelRequire("8dVaB");


var $iPEk0 = parcelRequire("iPEk0");


var $8UQlb = parcelRequire("8UQlb");


var $c1MLX = parcelRequire("c1MLX");


var $jtzx8 = parcelRequire("jtzx8");


var $8szAD = parcelRequire("8szAD");


var $7XQKb = parcelRequire("7XQKb");


var $kNeQk = parcelRequire("kNeQk");

var $2d8580c1357539e5$export$19131010e7fd8373 = {
    G: new (0, $hzQbH.EraParser)(),
    y: new (0, $ME38g.YearParser)(),
    Y: new (0, $ODxM2.LocalWeekYearParser)(),
    R: new (0, $afFXj.ISOWeekYearParser)(),
    u: new (0, $7Wbag.ExtendedYearParser)(),
    Q: new (0, $du6zo.QuarterParser)(),
    q: new (0, $2hTtW.StandAloneQuarterParser)(),
    M: new (0, $lof2I.MonthParser)(),
    L: new (0, $1wUSc.StandAloneMonthParser)(),
    w: new (0, $dJ7Bc.LocalWeekParser)(),
    I: new (0, $56Qdz.ISOWeekParser)(),
    d: new (0, $f5ZuE.DateParser)(),
    D: new (0, $hahvS.DayOfYearParser)(),
    E: new (0, $4hkrg.DayParser)(),
    e: new (0, $8W49h.LocalDayParser)(),
    c: new (0, $dGU37.StandAloneLocalDayParser)(),
    i: new (0, $5jyPW.ISODayParser)(),
    a: new (0, $9v13k.AMPMParser)(),
    b: new (0, $5IZ8l.AMPMMidnightParser)(),
    B: new (0, $5GZ8B.DayPeriodParser)(),
    h: new (0, $jvsga.Hour1to12Parser)(),
    H: new (0, $159WX.Hour0to23Parser)(),
    K: new (0, $kEUZw.Hour0To11Parser)(),
    k: new (0, $8dVaB.Hour1To24Parser)(),
    m: new (0, $iPEk0.MinuteParser)(),
    s: new (0, $8UQlb.SecondParser)(),
    S: new (0, $c1MLX.FractionOfSecondParser)(),
    X: new (0, $jtzx8.ISOTimezoneWithZParser)(),
    x: new (0, $8szAD.ISOTimezoneParser)(),
    t: new (0, $7XQKb.TimestampSecondsParser)(),
    T: new (0, $kNeQk.TimestampMillisecondsParser)()
};
module.exports["parsers"] = $2d8580c1357539e5$export$19131010e7fd8373;

});

parcelRegister("hzQbH", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");

var $ccbe2ff6d3113980$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(EraParser, _Parser);
    var _super = (0, $3wwsR.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $kWj1y.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 140);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $kOj7r.Parser));
module.exports["EraParser"] = $ccbe2ff6d3113980$export$8e5a1d3f85a9688;

});

parcelRegister("kOj7r", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $iLaQ6 = parcelRequire("iLaQ6");


var $l9XGS = parcelRequire("l9XGS");

var $f2674ecae7b9448f$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $kWj1y.default)(this, Parser);
        (0, $iLaQ6.default)(this, "incompatibleTokens", void 0);
        (0, $iLaQ6.default)(this, "priority", void 0);
        (0, $iLaQ6.default)(this, "subPriority", void 0);
    }
    (0, $9xXPc.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $l9XGS.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();
module.exports["Parser"] = $f2674ecae7b9448f$export$7acfa6ed01010e37;

});

parcelRegister("ME38g", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $09238ccf5261b9b2$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(YearParser, _Parser);
    var _super = (0, $3wwsR.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $kWj1y.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 130);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $9lhtP.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $9lhtP.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $kOj7r.Parser));
module.exports["YearParser"] = $09238ccf5261b9b2$export$48d352de7cd4a988;

});

parcelRegister("9lhtP", function(module, exports) {

var $jx0NF = parcelRequire("jx0NF");


var $aSp9j = parcelRequire("aSp9j");

function $6cd3a26cb85520f8$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $6cd3a26cb85520f8$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * (0, $jx0NF.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $6cd3a26cb85520f8$export$d931c43c4608a164(dateString) {
    return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).anyDigitsSigned, dateString);
}
function $6cd3a26cb85520f8$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).singleDigit, dateString);
        case 2:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).twoDigits, dateString);
        case 3:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).threeDigits, dateString);
        case 4:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).fourDigits, dateString);
        default:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $6cd3a26cb85520f8$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $6cd3a26cb85520f8$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $6cd3a26cb85520f8$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $6cd3a26cb85520f8$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
module.exports["mapValue"] = $6cd3a26cb85520f8$export$4f84e3a82c7b538;
module.exports["parseNumericPattern"] = $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388;
module.exports["parseTimezonePattern"] = $6cd3a26cb85520f8$export$6497f4c0ecdfba8e;
module.exports["parseAnyDigitsSigned"] = $6cd3a26cb85520f8$export$d931c43c4608a164;
module.exports["parseNDigits"] = $6cd3a26cb85520f8$export$513bb01536146ab6;
module.exports["parseNDigitsSigned"] = $6cd3a26cb85520f8$export$2c9307b2e29c533c;
module.exports["dayPeriodEnumToHours"] = $6cd3a26cb85520f8$export$fb506d2676e7f207;
module.exports["normalizeTwoDigitYear"] = $6cd3a26cb85520f8$export$29126f735cbf69f7;
module.exports["isLeapYearIndex"] = $6cd3a26cb85520f8$export$3d50627710b84d75;

});

parcelRegister("aSp9j", function(module, exports) {
var $7eb2749d6724eb00$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $7eb2749d6724eb00$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
module.exports["numericPatterns"] = $7eb2749d6724eb00$export$c123ee06d9da8480;
module.exports["timezonePatterns"] = $7eb2749d6724eb00$export$a7ee192b982af9c1;

});

parcelRegister("ODxM2", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");


var $40Dd9 = parcelRequire("40Dd9");


var $d1KG5 = parcelRequire("d1KG5");

var $0983583080df7973$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $3wwsR.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $kWj1y.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 130);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $9lhtP.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $40Dd9.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $9lhtP.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $d1KG5.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $d1KG5.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $kOj7r.Parser));
module.exports["LocalWeekYearParser"] = $0983583080df7973$export$b8ef38dfcf05d5db;

});

parcelRegister("afFXj", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");


var $3QScg = parcelRequire("3QScg");

var $776bd9985b6b00f7$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $3wwsR.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $kWj1y.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 130);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $9lhtP.parseNDigitsSigned)(4, dateString);
                return (0, $9lhtP.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $3QScg.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $kOj7r.Parser));
module.exports["ISOWeekYearParser"] = $776bd9985b6b00f7$export$951d1df011fde06f;

});

parcelRegister("7Wbag", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $5c769c3685de8d82$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(ExtendedYearParser, _Parser);
    var _super = (0, $3wwsR.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $kWj1y.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 130);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $9lhtP.parseNDigitsSigned)(4, dateString);
                return (0, $9lhtP.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $kOj7r.Parser));
module.exports["ExtendedYearParser"] = $5c769c3685de8d82$export$bad9d2ea38e8f1a;

});

parcelRegister("du6zo", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $9d132c56bb070087$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(QuarterParser, _Parser);
    var _super = (0, $3wwsR.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $kWj1y.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 120);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $kOj7r.Parser));
module.exports["QuarterParser"] = $9d132c56bb070087$export$5cb0f701186dde1d;

});

parcelRegister("2hTtW", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $1aa834dc0b623229$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $3wwsR.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $kWj1y.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 120);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $kOj7r.Parser));
module.exports["StandAloneQuarterParser"] = $1aa834dc0b623229$export$300c0c2990e20e6d;

});

parcelRegister("lof2I", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $9lhtP = parcelRequire("9lhtP");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");

var $f927820bdb3df3ab$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(MonthParser, _Parser);
    var _super = (0, $3wwsR.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $kWj1y.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 110);
        return _this;
    }
    (0, $9xXPc.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $9lhtP.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $kOj7r.Parser));
module.exports["MonthParser"] = $f927820bdb3df3ab$export$400dd8b40ef138a3;

});

parcelRegister("1wUSc", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $11d4e570e96dee1e$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $3wwsR.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $kWj1y.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 110);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $9lhtP.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $kOj7r.Parser));
module.exports["StandAloneMonthParser"] = $11d4e570e96dee1e$export$1d7eaa53eaa5deba;

});

parcelRegister("dJ7Bc", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");


var $inO80 = parcelRequire("inO80");


var $d1KG5 = parcelRequire("d1KG5");

var $9fe55f4f8f362fac$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(LocalWeekParser, _Parser);
    var _super = (0, $3wwsR.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $kWj1y.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 100);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $d1KG5.default)((0, $inO80.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $kOj7r.Parser));
module.exports["LocalWeekParser"] = $9fe55f4f8f362fac$export$c4005ffc174e07c0;

});

parcelRegister("inO80", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6214262b8dafb1c$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $ld8ZT = parcelRequire("ld8ZT");


var $b5utg = parcelRequire("b5utg");

function $d6214262b8dafb1c$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var week = (0, $jZ39j.default)(dirtyWeek);
    var diff = (0, $ld8ZT.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});

parcelRegister("56Qdz", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");


var $aXMUM = parcelRequire("aXMUM");


var $3QScg = parcelRequire("3QScg");

var $3b8604a6bc017761$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(ISOWeekParser, _Parser);
    var _super = (0, $3wwsR.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $kWj1y.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 100);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $3QScg.default)((0, $aXMUM.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $kOj7r.Parser));
module.exports["ISOWeekParser"] = $3b8604a6bc017761$export$6fc8dbedd560a6af;

});

parcelRegister("aXMUM", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fb55b89aceb3469$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $8mXz6 = parcelRequire("8mXz6");


var $b5utg = parcelRequire("b5utg");

function $7fb55b89aceb3469$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var isoWeek = (0, $jZ39j.default)(dirtyISOWeek);
    var diff = (0, $8mXz6.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});

parcelRegister("f5ZuE", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $9lhtP = parcelRequire("9lhtP");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");

var $afd705f45f0b715c$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $afd705f45f0b715c$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $afd705f45f0b715c$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(DateParser, _Parser);
    var _super = (0, $3wwsR.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $kWj1y.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 90);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "subPriority", 1);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $9lhtP.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $afd705f45f0b715c$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $afd705f45f0b715c$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $kOj7r.Parser));
module.exports["DateParser"] = $afd705f45f0b715c$export$e8d4b28a20981dd2;

});

parcelRegister("hahvS", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $c7f0f49202d1fedf$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(DayOfYearParser, _Parser);
    var _super = (0, $3wwsR.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $kWj1y.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 90);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "subpriority", 1);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $9lhtP.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $kOj7r.Parser));
module.exports["DayOfYearParser"] = $c7f0f49202d1fedf$export$6cfe0d613455f615;

});

parcelRegister("4hkrg", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $g6CRr = parcelRequire("g6CRr");

var $31d89aa5cc04b396$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(DayParser, _Parser);
    var _super = (0, $3wwsR.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $kWj1y.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 90);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $g6CRr.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $kOj7r.Parser));
module.exports["DayParser"] = $31d89aa5cc04b396$export$1b03c8b76262f7bd;

});

parcelRegister("g6CRr", function(module, exports) {
$parcel$export(module.exports, "default", () => $0306a27b35342568$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");


var $2h3f7 = parcelRequire("2h3f7");

function $0306a27b35342568$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b5utg.default)(2, arguments);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var weekStartsOn = (0, $jZ39j.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = (0, $jZ39j.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("8W49h", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");


var $g6CRr = parcelRequire("g6CRr");

var $6816f55b5a2b6010$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(LocalDayParser, _Parser);
    var _super = (0, $3wwsR.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $kWj1y.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 90);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $9lhtP.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $g6CRr.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $kOj7r.Parser));
module.exports["LocalDayParser"] = $6816f55b5a2b6010$export$44d1c127ab42c480;

});

parcelRegister("dGU37", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");


var $g6CRr = parcelRequire("g6CRr");

var $9f7aacdaf3090d72$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $3wwsR.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $kWj1y.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 90);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $9lhtP.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $g6CRr.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $kOj7r.Parser));
module.exports["StandAloneLocalDayParser"] = $9f7aacdaf3090d72$export$e447a647caaaec1d;

});

parcelRegister("5jyPW", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");


var $b3fnO = parcelRequire("b3fnO");

var $3de9bff04ea0a6c5$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(ISODayParser, _Parser);
    var _super = (0, $3wwsR.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $kWj1y.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 90);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $9lhtP.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $9lhtP.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $9lhtP.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $9lhtP.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $b3fnO.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $kOj7r.Parser));
module.exports["ISODayParser"] = $3de9bff04ea0a6c5$export$693fb1e525095b2a;

});

parcelRegister("b3fnO", function(module, exports) {
$parcel$export(module.exports, "default", () => $80bbe8412f227e83$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $80bbe8412f227e83$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $b5utg.default)(2, arguments);
    var day = (0, $jZ39j.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $egXhZ.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("9v13k", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $6ea7d35c0c9fd41f$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(AMPMParser, _Parser);
    var _super = (0, $3wwsR.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $kWj1y.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 80);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $9lhtP.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $kOj7r.Parser));
module.exports["AMPMParser"] = $6ea7d35c0c9fd41f$export$8d1e08492351df91;

});

parcelRegister("5IZ8l", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $42b07bae4fbc7607$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $3wwsR.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $kWj1y.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 80);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $9lhtP.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $kOj7r.Parser));
module.exports["AMPMMidnightParser"] = $42b07bae4fbc7607$export$73ca2bd0a17d273;

});

parcelRegister("5GZ8B", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $42504cb0c2d84ce0$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(DayPeriodParser, _Parser);
    var _super = (0, $3wwsR.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $kWj1y.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 80);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $9lhtP.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $kOj7r.Parser));
module.exports["DayPeriodParser"] = $42504cb0c2d84ce0$export$bb9212adf05373db;

});

parcelRegister("jvsga", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $e336d561ce89ecd5$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(Hour1to12Parser, _Parser);
    var _super = (0, $3wwsR.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $kWj1y.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 70);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $kOj7r.Parser));
module.exports["Hour1to12Parser"] = $e336d561ce89ecd5$export$8a04050a727a1756;

});

parcelRegister("159WX", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $0c9df9ea87066242$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(Hour0to23Parser, _Parser);
    var _super = (0, $3wwsR.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $kWj1y.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 70);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $kOj7r.Parser));
module.exports["Hour0to23Parser"] = $0c9df9ea87066242$export$e56f4dea2c3e56dd;

});

parcelRegister("kEUZw", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $f0a3c057ace59c5d$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(Hour0To11Parser, _Parser);
    var _super = (0, $3wwsR.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $kWj1y.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 70);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $kOj7r.Parser));
module.exports["Hour0To11Parser"] = $f0a3c057ace59c5d$export$cbbe855312f87d77;

});

parcelRegister("8dVaB", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $5fcbe266be913f82$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(Hour1To24Parser, _Parser);
    var _super = (0, $3wwsR.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $kWj1y.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 70);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $kOj7r.Parser));
module.exports["Hour1To24Parser"] = $5fcbe266be913f82$export$6008046d2b34b6a5;

});

parcelRegister("iPEk0", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $db5c447921e67e0d$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(MinuteParser, _Parser);
    var _super = (0, $3wwsR.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $kWj1y.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 60);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $kOj7r.Parser));
module.exports["MinuteParser"] = $db5c447921e67e0d$export$2b52670d9e2be53;

});

parcelRegister("8UQlb", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $67dc2776c62adca4$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(SecondParser, _Parser);
    var _super = (0, $3wwsR.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $kWj1y.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 50);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $kOj7r.Parser));
module.exports["SecondParser"] = $67dc2776c62adca4$export$94d46d540cf1366a;

});

parcelRegister("c1MLX", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $8c1b693bbf932733$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $3wwsR.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $kWj1y.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 30);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $kOj7r.Parser));
module.exports["FractionOfSecondParser"] = $8c1b693bbf932733$export$b8e6f8b2d70893b1;

});

parcelRegister("jtzx8", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $e2dc49ee04af4fe5$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $3wwsR.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $kWj1y.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 10);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $kOj7r.Parser));
module.exports["ISOTimezoneWithZParser"] = $e2dc49ee04af4fe5$export$104d901d49fea29b;

});

parcelRegister("8szAD", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $628c8bac8c7dfaae$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $3wwsR.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $kWj1y.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 10);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $kOj7r.Parser));
module.exports["ISOTimezoneParser"] = $628c8bac8c7dfaae$export$12910e5204b52b9;

});

parcelRegister("7XQKb", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $5cc6f4e956e5cc96$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $3wwsR.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $kWj1y.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 40);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $9xXPc.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $9lhtP.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $kOj7r.Parser));
module.exports["TimestampSecondsParser"] = $5cc6f4e956e5cc96$export$2cd8bf877a05e96;

});

parcelRegister("kNeQk", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $f233e5c71665e058$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $3wwsR.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $kWj1y.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 20);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $9xXPc.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $9lhtP.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $kOj7r.Parser));
module.exports["TimestampMillisecondsParser"] = $f233e5c71665e058$export$6d8f69c6906d6368;

});

parcelRegister("Asv1P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $fTXBo = parcelRequire("fTXBo");

const $040545af9856ecf6$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const methodRef = (0, $fTXBo.useTrackedRef)(method);
    const payloadRef = (0, $fTXBo.useTrackedRef)(payload);
    return (0, $42omo.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};
module.exports["useCallbackWithAnalytics"] = $040545af9856ecf6$export$53c2b9c37c40e0d8;

});

parcelRegister("aY6zh", function(module, exports) {

var $bqMS3 = parcelRequire("bqMS3");

var $6mYMS = parcelRequire("6mYMS");


var $grTgx = parcelRequire("grTgx");


var $9w35C = parcelRequire("9w35C");


var $f8oLo = parcelRequire("f8oLo");


var $eHWNJ = parcelRequire("eHWNJ");

const $9ff3e07c34644328$var$CONTEXT_TYPE = 'Mentions';
const $9ff3e07c34644328$var$isSmartMentionConfigWithMentionNameResolver = (smartMentionConfig)=>!!smartMentionConfig.mentionNameResolver;
/*
 * This is a provider implementation which calls URS to provide a list of recommended users/teams to mention.
 * The entryPoint hierarchy is : Editor -> editor-core -> plugins -> mentions -> typeAhead -> getItems -> pluginState.pluginProvider.filter
 * The results are then mapped to mentionItems which have a render prop mentionToTypeaheadItem -> MentionItem
 * https://bitbucket.org/atlassian/atlassian-frontend/src/0884032d85f11f43c13532cd21f13f696b0d28a7/packages/editor/editor-core/src/plugins/mentions/index.tsx#lines-219
 *
 */ class $9ff3e07c34644328$var$SmartMentionResource extends (0, $bqMS3.AbstractMentionResource) {
    shouldHighlightMention(mention) {
        if (this.smartMentionConfig.shouldHighlightMention) return this.smartMentionConfig.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
    }
    async filter(query, contextIdentifier) {
        this.contextIdentifier = contextIdentifier;
        const searchTime = Date.now();
        try {
            let results = await this.getRecommendedMentions(query ? query : '', contextIdentifier);
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    async getRecommendedMentions(query, contextIdentifier) {
        const startTime = window.performance.now();
        const conf = this.smartMentionConfig;
        const maxNumberOfResults = conf.maxNumberOfResults || 100;
        const request = {
            baseUrl: conf.baseUrl,
            context: {
                productKey: conf.productKey,
                contextType: $9ff3e07c34644328$var$CONTEXT_TYPE,
                principalId: conf.principalId || 'context',
                containerId: contextIdentifier && contextIdentifier.containerId,
                siteId: conf.siteId,
                organizationId: conf.orgId,
                objectId: contextIdentifier && contextIdentifier.objectId || 'undefined',
                childObjectId: contextIdentifier && contextIdentifier.childObjectId || 'undefined',
                mentionsSessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined',
                sessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined'
            },
            includeGroups: conf.includeGroups,
            includeTeams: conf.includeTeams,
            includeUsers: typeof conf.includeUsers === 'undefined' ? true : conf.includeUsers,
            maxNumberOfResults: maxNumberOfResults,
            searchQueryFilter: conf.searchQueryFilter,
            query: query
        };
        try {
            this._notifyAnalyticsListeners((0, $9w35C.SMART_EVENT_TYPE), 'users', (0, $9w35C.Actions).REQUESTED, (0, $9w35C.defaultAttributes)(contextIdentifier));
            const users = await (0, $eHWNJ.default)(request);
            const elapsedTimeMilli = window.performance.now() - startTime;
            const usersForAnalytics = (0, $9w35C.getUsersForAnalytics)(users);
            this._notifyAnalyticsListeners((0, $9w35C.SMART_EVENT_TYPE), 'usersRequest', (0, $9w35C.Actions).SUCCESSFUL, {
                elapsedTimeMilli: elapsedTimeMilli,
                users: usersForAnalytics,
                displayedUsers: usersForAnalytics,
                ...(0, $9w35C.defaultAttributes)(contextIdentifier)
            });
            const mentions = this.transformUsersToMentions(users);
            return {
                mentions: mentions,
                query: query
            };
        } catch (e) {
            const elapsedTimeMilli = window.performance.now() - startTime;
            this._notifyAnalyticsListeners((0, $9w35C.SMART_EVENT_TYPE), 'usersRequest', (0, $9w35C.Actions).FAILED, {
                elapsedTimeMilli: elapsedTimeMilli,
                ...(0, $9w35C.defaultAttributes)(contextIdentifier)
            });
            throw e instanceof Error ? e : new Error(String(e));
        }
    }
    transformTeamMember(member) {
        return {
            id: member.id,
            name: member.name
        };
    }
    transformUserToMention(item) {
        const type = item.entityType;
        let defaultVals = {
            source: 'smarts'
        };
        if (type === (0, $grTgx.EntityType).USER) {
            const user = item;
            return {
                ...defaultVals,
                id: user.id,
                accessLevel: user.accessLevel,
                avatarUrl: user.avatarUrl,
                mentionName: user.nickname || '',
                name: user.name,
                userType: user.userType
            };
        }
        if (type === (0, $grTgx.EntityType).TEAM) {
            const team = item;
            let teamLink = '';
            const defaultTeamLink = `${window.location.origin}/people/team/${team.id}`;
            if (typeof this.smartMentionConfig.teamLinkResolver === 'function') teamLink = this.smartMentionConfig.teamLinkResolver(item.id);
            return {
                ...defaultVals,
                id: team.id,
                name: team.displayName || '',
                mentionName: team.displayName,
                avatarUrl: team.smallAvatarImageUrl,
                accessLevel: (0, $6mYMS.UserAccessLevel)[(0, $6mYMS.UserAccessLevel).CONTAINER],
                userType: (0, $6mYMS.UserType)[(0, $6mYMS.UserType).TEAM],
                lozenge: (0, $6mYMS.UserType)[(0, $6mYMS.UserType).TEAM],
                context: {
                    members: team.members ? team.members.map(this.transformTeamMember) : [],
                    includesYou: team.includesYou || false,
                    memberCount: team.memberCount || 0,
                    teamLink: teamLink || defaultTeamLink //OOH HERE Do we pass in resolver or add in provider?
                },
                source: 'smarts'
            };
        }
        if (type === (0, $grTgx.EntityType).GROUP) {
            const group = item;
            return {
                ...defaultVals,
                id: group.id,
                userType: type.toLowerCase(),
                name: group.name || '',
                lozenge: type.toLowerCase()
            };
        }
        return {
            id: item.id,
            userType: (0, $grTgx.EntityType).USER.toLowerCase(),
            avatarUrl: item.avatarUrl,
            name: item.name,
            lozenge: (0, $grTgx.EntityType).USER.toLowerCase()
        };
    }
    transformUsersToMentions(recommendationItems) {
        return (recommendationItems || []).map(this.transformUserToMention, this).filter((user)=>!!user).map((user)=>user);
    }
    cacheMentionName(id, mentionName) {
        this.smartMentionConfig.mentionNameResolver.cacheName(id, mentionName);
    }
    resolveMentionName(id) {
        return this.smartMentionConfig.mentionNameResolver.lookupName(id);
    }
    supportsMentionNameResolving() {
        return true;
    }
    recordMentionSelection(_mention) {
        this._notifyAnalyticsListeners((0, $9w35C.SMART_EVENT_TYPE), 'usersRequest', (0, $9w35C.Actions).SELECTED, {
            selectedOption: _mention.id,
            ...(0, $9w35C.defaultAttributes)(this.contextIdentifier)
        });
    }
    constructor(smartMentionConfig){
        super();
        // If the product doesn't provide a mention name resolve, use the default resolver so that
        // mention names can be looked up from PRS without configuration.
        this.smartMentionConfig = void 0;
        this.lastReturnedSearch = void 0;
        this.contextIdentifier = void 0;
        this.smartMentionConfig = $9ff3e07c34644328$var$isSmartMentionConfigWithMentionNameResolver(smartMentionConfig) ? smartMentionConfig : {
            ...smartMentionConfig,
            mentionNameResolver: new (0, $f8oLo.DefaultMentionNameResolver)(smartMentionConfig.baseUrl)
        };
        this.lastReturnedSearch = 0;
    }
}
var $9ff3e07c34644328$export$2e2bcd8739ae039 = $9ff3e07c34644328$var$SmartMentionResource;
module.exports["default"] = $9ff3e07c34644328$export$2e2bcd8739ae039;

});

parcelRegister("grTgx", function(module, exports) {
var $066beef4d1f2f02a$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});
module.exports["EntityType"] = $066beef4d1f2f02a$export$8eda7e02f8f033b2;

});

parcelRegister("9w35C", function(module, exports) {
const $4f1d2b2c69412aab$export$c724588856bbfbcf = 'smart';
var $4f1d2b2c69412aab$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["REQUESTED"] = "requested";
    Actions["SUCCESSFUL"] = "successful";
    Actions["SEARCHED"] = "searched";
    Actions["FAILED"] = "failed";
    Actions["SELECTED"] = "selected";
    return Actions;
}({});
const $4f1d2b2c69412aab$export$38cd8db2db178f58 = (context)=>{
    return {
        context: context?.objectId || '',
        sessionId: context?.sessionId || '',
        pickerType: 'mentions',
        source: 'smarts'
    };
};
const $4f1d2b2c69412aab$export$e8be30a842a4b49d = (users)=>{
    return users ? users.map(({ id: id, entityType: entityType })=>({
            id: id,
            type: entityType.toLowerCase()
        })) : [];
};
module.exports["SMART_EVENT_TYPE"] = $4f1d2b2c69412aab$export$c724588856bbfbcf;
module.exports["Actions"] = $4f1d2b2c69412aab$export$b52183d5cfb26dc9;
module.exports["defaultAttributes"] = $4f1d2b2c69412aab$export$38cd8db2db178f58;
module.exports["getUsersForAnalytics"] = $4f1d2b2c69412aab$export$e8be30a842a4b49d;

});

parcelRegister("f8oLo", function(module, exports) {

var $6mYMS = parcelRequire("6mYMS");


var $1NrSh = parcelRequire("1NrSh");


var $9KHZR = parcelRequire("9KHZR");

const $760648ceb1fc9809$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $760648ceb1fc9809$var$makeRequest = async (url, accountIds)=>{
    const query = $760648ceb1fc9809$var$buildUsersQuery(accountIds);
    return (0, $9KHZR.graphqlQuery)(url, query);
};
class $760648ceb1fc9809$export$2ae0434dccdcb77e {
    async lookupName(id) {
        try {
            if (this.cache.has(id)) return {
                id: id,
                name: this.cache.get(id),
                status: (0, $6mYMS.MentionNameStatus).OK
            };
            const url = (0, $1NrSh.PRD_CONFIG).getGraphQLUrl(this.baseUrl);
            const data = await $760648ceb1fc9809$var$makeRequest(url, [
                id
            ]);
            const userInfo = data.users?.find((user)=>user.accountId === id);
            return userInfo ? {
                id: id,
                name: userInfo.name,
                status: (0, $6mYMS.MentionNameStatus).OK
            } : {
                id: id,
                status: (0, $6mYMS.MentionNameStatus).UNKNOWN
            };
        } catch (error) {
            // on network error, return original list with label 'Unknown'
            return {
                id: id,
                status: (0, $6mYMS.MentionNameStatus).UNKNOWN
            };
        }
    }
    cacheName(id, name) {
        this.cache.set(id, name);
    }
    constructor(baseUrl){
        this.baseUrl = void 0;
        this.cache = void 0;
        this.baseUrl = baseUrl;
        this.cache = new Map();
    }
}
module.exports["DefaultMentionNameResolver"] = $760648ceb1fc9809$export$2ae0434dccdcb77e;

});

parcelRegister("1NrSh", function(module, exports) {
const $49895188b0a86f3f$export$d4fff2dfff3e2bc1 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey) {
        return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};
module.exports["PRD_CONFIG"] = $49895188b0a86f3f$export$d4fff2dfff3e2bc1;

});

parcelRegister("9KHZR", function(module, exports) {
const $6d4812bfe02f5ea6$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
function $6d4812bfe02f5ea6$export$74eb8d79ae3e02b5(serviceUrl, query) {
    const headers = $6d4812bfe02f5ea6$var$buildHeaders();
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}
module.exports["graphqlQuery"] = $6d4812bfe02f5ea6$export$74eb8d79ae3e02b5;

});

parcelRegister("eHWNJ", function(module, exports) {

var $1NrSh = parcelRequire("1NrSh");

const $721aad13b249dafb$var$getUserRecommendations = (request)=>{
    const url = (0, $1NrSh.PRD_CONFIG).getRecommendationServiceUrl(request.baseUrl);
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>response.recommendedUsers);
};
var $721aad13b249dafb$export$2e2bcd8739ae039 = $721aad13b249dafb$var$getUserRecommendations;
module.exports["default"] = $721aad13b249dafb$export$2e2bcd8739ae039;

});

parcelRegister("gVoWJ", function(module, exports) {
// #region Imports

var $bupcf = parcelRequire("bupcf");


var $hEicH = parcelRequire("hEicH");

parcelRequire("jL0bJ");
var $jmHSv = parcelRequire("jmHSv");


var $2P8JV = parcelRequire("2P8JV");


var $stVm3 = parcelRequire("stVm3");


var $cNucV = parcelRequire("cNucV");

parcelRequire("d2gjm");
var $kXH7i = parcelRequire("kXH7i");

parcelRequire("1mT7b");
var $acwPl = parcelRequire("acwPl");


var $czo2Z = parcelRequire("czo2Z");


var $jiT42 = parcelRequire("jiT42");

parcelRequire("bgrAk");
var $kbe7k = parcelRequire("kbe7k");


var $7aKg5 = parcelRequire("7aKg5");


var $8exqI = parcelRequire("8exqI");


var $12MPQ = parcelRequire("12MPQ");

parcelRequire("4S3gx");
var $l7rln = parcelRequire("l7rln");


var $1AOco = parcelRequire("1AOco");

parcelRequire("h6Mwq");
var $jS0a0 = parcelRequire("jS0a0");

parcelRequire("eKfhS");
var $HYzBP = parcelRequire("HYzBP");

parcelRequire("ebElI");
var $gATpw = parcelRequire("gATpw");

parcelRequire("ksuJ7");
var $6AqNX = parcelRequire("6AqNX");


var $3HEm4 = parcelRequire("3HEm4");

parcelRequire("lSIzP");
var $kYgUn = parcelRequire("kYgUn");

parcelRequire("koT39");
var $itirX = parcelRequire("itirX");


var $k2RCe = parcelRequire("k2RCe");

parcelRequire("cW0VI");
var $bULcr = parcelRequire("bULcr");

parcelRequire("chY2a");
var $7nKrc = parcelRequire("7nKrc");

parcelRequire("d5O4W");
var $6borH = parcelRequire("6borH");


var $inOAE = parcelRequire("inOAE");

parcelRequire("eGBvf");
var $3JBsx = parcelRequire("3JBsx");


var $1hEK8 = parcelRequire("1hEK8");

parcelRequire("7oMzO");
var $kw2eg = parcelRequire("kw2eg");

parcelRequire("hI2Bx");
var $vxKdN = parcelRequire("vxKdN");

parcelRequire("iZg1u");
var $3O0YV = parcelRequire("3O0YV");

parcelRequire("8C4KP");
var $fI6T7 = parcelRequire("fI6T7");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $aeAfU = parcelRequire("aeAfU");


var $geLSP = parcelRequire("geLSP");

function $836251edf00fa846$export$4efc99f259929bff(options) {
    const isFullPage = (0, $geLSP.isFullPage)(options.appearance);
    const preset = new (0, $bupcf.EditorPresetBuilder)().add([
        (0, $l7rln.featureFlagsPlugin),
        options.featureFlags || {}
    ]).maybeAdd([
        (0, $jmHSv.analyticsPlugin),
        {
            createAnalyticsEvent: options.createAnalyticsEvent,
            performanceTracking: options.performanceTracking
        }
    ], Boolean(options.allowAnalyticsGASV3)).add((0, $stVm3.betterTypeHistoryPlugin)).add([
        (0, $3HEm4.pastePlugin),
        {
            ...options?.paste,
            isFullPage: isFullPage
        }
    ]).add((0, $acwPl.default)).add((0, $jS0a0.focusPlugin)).maybeAdd([
        (0, $hEicH.userPreferencesPlugin),
        {
            initialUserPreferences: {
                toolbarDockingPosition: isFullPage ? 'none' : 'top'
            }
        }
    ], ()=>(0, $dh538.fg)('platform_editor_use_preferences_plugin')).maybeAdd((0, $6AqNX.interactionPlugin), Boolean(options?.__livePage) || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)).add((0, $jiT42.compositionPlugin)).add([
        (0, $kbe7k.contextIdentifierPlugin),
        {
            contextIdentifierProvider: options.contextIdentifierProvider
        }
    ]).add([
        (0, $2P8JV.basePlugin),
        options.base
    ]).add((0, $8exqI.decorationsPlugin)).add([
        (0, $1hEK8.typeAheadPlugin),
        options.typeAhead
    ]).maybeAdd((0, $HYzBP.default), Boolean(options.allowUndoRedoButtons)).maybeAdd((0, $3O0YV.userIntentPlugin), (0, $aeAfU.expValNoExposure)('platform_editor_lovability_user_intent', 'isEnabled', false)).maybeAdd([
        (0, $3JBsx.toolbarPlugin),
        options.toolbar || {}
    ], Boolean(options.toolbar?.enableNewToolbarExperience)).add([
        (0, $itirX.primaryToolbarPlugin),
        {
            contextualFormattingEnabled: isFullPage
        }
    ]).maybeAdd((0, $kw2eg.undoRedoPlugin), Boolean(options.featureFlags?.undoRedoButtons ?? options.allowUndoRedoButtons)).add([
        (0, $cNucV.blockTypePlugin),
        {
            ...options.blockType,
            includeBlockQuoteAsTextstyleOption: isFullPage
        }
    ]).add((0, $kXH7i.clearMarksOnEmptyDocPlugin)).add([
        (0, $7nKrc.selectionToolbarPlugin),
        {
            preferenceToolbarAboveSelection: !!options.preferenceToolbarAboveSelection,
            contextualFormattingEnabled: isFullPage
        }
    ]).add([
        (0, $gATpw.hyperlinkPlugin),
        {
            ...options.hyperlinkOptions,
            // @ts-ignore Temporary solution to check for Live Page editor.
            __livePage: options.__livePage
        }
    ]).add([
        (0, $inOAE.textFormattingPlugin),
        options.textFormatting
    ]).add((0, $fI6T7.widthPlugin)).add([
        (0, $k2RCe.quickInsertPlugin),
        options.quickInsert
    ]).add([
        (0, $kYgUn.placeholderPlugin),
        options.placeholder
    ]).add((0, $vxKdN.unsupportedContentPlugin)).add([
        (0, $12MPQ.editorDisabledPlugin),
        {
            initialDisabledState: options.disabled
        }
    ]).add([
        (0, $6borH.submitEditorPlugin),
        options.submitEditor
    ]).add((0, $7aKg5.copyButtonPlugin)).add((0, $1AOco.floatingToolbarPlugin)).add([
        (0, $bULcr.selectionPlugin),
        {
            ...options.selection,
            __livePage: options.__livePage
        }
    ]).add([
        (0, $czo2Z.codeBlockPlugin),
        options.codeBlock
    ]);
    return preset;
}
function $836251edf00fa846$export$a3add99b7c13b8f7(props) {
    const preset = $836251edf00fa846$export$4efc99f259929bff(props);
    return [
        preset
    ];
}
module.exports["createDefaultPreset"] = $836251edf00fa846$export$4efc99f259929bff;

});

parcelRegister("jL0bJ", function(module, exports) {
$parcel$export(module.exports, "analyticsPlugin", () => (parcelRequire("jmHSv")).analyticsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $jmHSv = parcelRequire("jmHSv");


});

parcelRegister("d2gjm", function(module, exports) {
$parcel$export(module.exports, "clearMarksOnEmptyDocPlugin", () => (parcelRequire("kXH7i")).clearMarksOnEmptyDocPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kXH7i = parcelRequire("kXH7i");


});

parcelRegister("1mT7b", function(module, exports) {
$parcel$export(module.exports, "clipboardPlugin", () => (parcelRequire("acwPl")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $acwPl = parcelRequire("acwPl");


});

parcelRegister("bgrAk", function(module, exports) {
$parcel$export(module.exports, "contextIdentifierPlugin", () => (parcelRequire("kbe7k")).contextIdentifierPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kbe7k = parcelRequire("kbe7k");


});

parcelRegister("4S3gx", function(module, exports) {
$parcel$export(module.exports, "featureFlagsPlugin", () => (parcelRequire("l7rln")).featureFlagsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $l7rln = parcelRequire("l7rln");


});

parcelRegister("h6Mwq", function(module, exports) {
$parcel$export(module.exports, "focusPlugin", () => (parcelRequire("jS0a0")).focusPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $jS0a0 = parcelRequire("jS0a0");


});

parcelRegister("eKfhS", function(module, exports) {
$parcel$export(module.exports, "historyPlugin", () => (parcelRequire("HYzBP")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $HYzBP = parcelRequire("HYzBP");


});

parcelRegister("ebElI", function(module, exports) {
$parcel$export(module.exports, "hyperlinkPlugin", () => (parcelRequire("gATpw")).hyperlinkPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $gATpw = parcelRequire("gATpw");


});

parcelRegister("ksuJ7", function(module, exports) {
$parcel$export(module.exports, "interactionPlugin", () => (parcelRequire("6AqNX")).interactionPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6AqNX = parcelRequire("6AqNX");


});

parcelRegister("lSIzP", function(module, exports) {
$parcel$export(module.exports, "placeholderPlugin", () => (parcelRequire("kYgUn")).placeholderPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kYgUn = parcelRequire("kYgUn");


});

parcelRegister("koT39", function(module, exports) {
$parcel$export(module.exports, "primaryToolbarPlugin", () => (parcelRequire("itirX")).primaryToolbarPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $itirX = parcelRequire("itirX");


});

parcelRegister("cW0VI", function(module, exports) {
$parcel$export(module.exports, "selectionPlugin", () => (parcelRequire("bULcr")).selectionPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $bULcr = parcelRequire("bULcr");


});

parcelRegister("chY2a", function(module, exports) {
$parcel$export(module.exports, "selectionToolbarPlugin", () => (parcelRequire("7nKrc")).selectionToolbarPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7nKrc = parcelRequire("7nKrc");


});

parcelRegister("d5O4W", function(module, exports) {
$parcel$export(module.exports, "submitEditorPlugin", () => (parcelRequire("6borH")).submitEditorPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6borH = parcelRequire("6borH");


});

parcelRegister("eGBvf", function(module, exports) {
$parcel$export(module.exports, "toolbarPlugin", () => (parcelRequire("3JBsx")).toolbarPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3JBsx = parcelRequire("3JBsx");


});

parcelRegister("7oMzO", function(module, exports) {
$parcel$export(module.exports, "undoRedoPlugin", () => (parcelRequire("kw2eg")).undoRedoPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kw2eg = parcelRequire("kw2eg");


});

parcelRegister("hI2Bx", function(module, exports) {
$parcel$export(module.exports, "unsupportedContentPlugin", () => (parcelRequire("vxKdN")).unsupportedContentPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $vxKdN = parcelRequire("vxKdN");


});

parcelRegister("iZg1u", function(module, exports) {
$parcel$export(module.exports, "userIntentPlugin", () => (parcelRequire("3O0YV")).userIntentPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3O0YV = parcelRequire("3O0YV");


});

parcelRegister("8C4KP", function(module, exports) {
$parcel$export(module.exports, "widthPlugin", () => (parcelRequire("fI6T7")).widthPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $fI6T7 = parcelRequire("fI6T7");


});

parcelRegister("2gkmX", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $5vVM5 = parcelRequire("5vVM5");


var $7fmpI = parcelRequire("7fmpI");


var $led7c = parcelRequire("led7c");


var $lWghV = parcelRequire("lWghV");


var $gSnMl = parcelRequire("gSnMl");


var $bT1qC = parcelRequire("bT1qC");

class $1697754dbd6854fe$export$2e2bcd8739ae039 {
    /**
   * This method exists to move initialization logic out of the constructor,
   * so object can be initialized properly before calling render first time.
   *
   * Example:
   * Instance properties get added to an object only after super call in
   * constructor, which leads to some methods being undefined during the
   * first render.
   */ init() {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7fmpI.ErrorBoundary), {
                component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent
            }, component());
        this.portalProviderAPI.render(componentWithErrorBoundary, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.domRef, this.key, undefined, this.shouldRenderImmediatelyInPortal);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // @ts-ignore
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            node.appendChild(contentDOM);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    // Don't set the selection if it's the same as the current selection.
                    if (!resolvedSelection.eq(this.view.state.selection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'ReactNodeView:_handleRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, _decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
   * Copies the attributes from a ProseMirror Node to a DOM node.
   * @param node The Prosemirror Node from which to source the attributes
   */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $1697754dbd6854fe$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
    constructor(_node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        this.domRef = void 0;
        this.contentDOMWrapper = void 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.reactComponent = void 0;
        this.portalProviderAPI = void 0;
        this._viewShouldUpdate = void 0;
        this.eventDispatcher = void 0;
        this.decorations = [];
        this.reactComponentProps = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.key = void 0;
        this.shouldRenderImmediatelyInPortal = void 0;
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $5vVM5.createDispatch)(this.eventDispatcher);
                dispatch((0, $lWghV.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = _node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $gSnMl.generateUniqueNodeKey)();
        this.shouldRenderImmediatelyInPortal = shouldRenderImmediatelyInPortal || false;
    }
}
module.exports["default"] = $1697754dbd6854fe$export$2e2bcd8739ae039;

});

parcelRegister("gSnMl", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");

const $98e7d56f800fed91$export$4a323a0542a1e4d1 = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
};
module.exports["generateUniqueNodeKey"] = $98e7d56f800fed91$export$4a323a0542a1e4d1;

});

parcelRegister("bT1qC", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $d925B = parcelRequire("d925B");


var $7fmpI = parcelRequire("7fmpI");


var $lWghV = parcelRequire("lWghV");

var $d7ZU3 = parcelRequire("d7ZU3");

var $led7c = parcelRequire("led7c");


var $TfRUG = parcelRequire("TfRUG");


var $gSnMl = parcelRequire("gSnMl");


var $iEqmY = parcelRequire("iEqmY");

const $8cc71206023006a6$var$isSSR = Boolean(undefined);
const $8cc71206023006a6$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $8cc71206023006a6$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $8cc71206023006a6$var$virtualizedNodeAllowlist = [
    'inlineCard'
];
function $8cc71206023006a6$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $8cc71206023006a6$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        if (!$8cc71206023006a6$var$canRenderFallback(currentNode) || typeof currentNode.type?.spec?.toDOM !== 'function') return;
        const fallback = (0, $5SAOw.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $iEqmY.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps?.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $8cc71206023006a6$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $8cc71206023006a6$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7fmpI.ErrorBoundary), {
            component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)), /*#__PURE__*/ (0, $9K4OG.jsx)(Component, {
            view: nodeViewParams.view,
            // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getPos: nodeViewParams.getPos,
            node: currentNode,
            ...extraComponentProps
        }), (0, $d7ZU3.browser).android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`,
            contentEditable: "false"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }));
    };
}
const $8cc71206023006a6$var$counterPerEditorViewMap = new WeakMap();
function $8cc71206023006a6$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $8cc71206023006a6$var$virtualizedNodeAllowlist.includes(node?.type?.name || '');
        if (!isNodeTypeAllowedToBeVirtualized || $8cc71206023006a6$var$isSSR) return $8cc71206023006a6$var$createNodeView(parameters);
        if ((0, $dh538.fg)('platform_editor_inline_node_virt_threshold_override')) return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
        let inlineNodeViewsVirtualizationCounter = $8cc71206023006a6$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $8cc71206023006a6$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $8cc71206023006a6$var$createNodeView(parameters);
        return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
    }
    return nodeViewProducer;
}
module.exports["getInlineNodeViewProducer"] = $8cc71206023006a6$export$17a8c3162956317d;

});

parcelRegister("iEqmY", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");

// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $af3e0b19ba2c5452$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb?.());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});
module.exports["getOrCreateOnVisibleObserver"] = $af3e0b19ba2c5452$export$d73c873f0a6a03c3;

});

parcelRegister("9eydB", function(module, exports) {
$parcel$export(module.exports, "captionPlugin", () => (parcelRequire("duFi2")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $duFi2 = parcelRequire("duFi2");


});

parcelRegister("j5BTD", function(module, exports) {
$parcel$export(module.exports, "cardPlugin", () => (parcelRequire("agrUc")).cardPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $agrUc = parcelRequire("agrUc");


});

parcelRegister("7pxpu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eWRwJ = parcelRequire("eWRwJ");

var $inPa6 = parcelRequire("inPa6");


var $eIleF = parcelRequire("eIleF");


var $sXTCx = parcelRequire("sXTCx");


var $aFv56 = parcelRequire("aFv56");


var $l4JAB = parcelRequire("l4JAB");


var $655oj = parcelRequire("655oj");


const $669d74d97f0070d8$export$612752b1e088a45e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { store: store, connections: { client: client } } = (0, $eIleF.useSmartLinkContext)();
    return (0, $42omo.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $l4JAB.runWhenIdle)(()=>{
                        (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $l4JAB.runWhenIdle)(async ()=>{
                        const { default: fireEvent } = await (parcelRequire("eFoJQ"));
                        fireEvent(action, createAnalyticsEvent, client, store)(...args);
                    });
                } catch (error) {
                    (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            linkCreated: factory('created'),
            linkUpdated: factory('updated'),
            linkDeleted: factory('deleted')
        };
    }, [
        client,
        store,
        createAnalyticsEvent
    ]);
};

const $669d74d97f0070d8$export$c82e48d9fd97c55b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { getDatasourceData: getDatasourceData } = (0, $655oj.useDatasourceClientExtension)();
    return (0, $42omo.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $l4JAB.runWhenIdle)(()=>{
                        (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $l4JAB.runWhenIdle)(async ()=>{
                        const { fireDatasourceEvent: fireDatasourceEvent } = await (parcelRequire("eFoJQ"));
                        fireDatasourceEvent(action, createAnalyticsEvent, getDatasourceData)(...args);
                    });
                } catch (error) {
                    (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            datasourceCreated: factory('created'),
            datasourceUpdated: factory('updated'),
            datasourceDeleted: factory('deleted')
        };
    }, [
        createAnalyticsEvent,
        getDatasourceData
    ]);
};
module.exports["useSmartLinkLifecycleAnalytics"] = $669d74d97f0070d8$export$612752b1e088a45e;
module.exports["useDatasourceLifecycleAnalytics"] = $669d74d97f0070d8$export$c82e48d9fd97c55b;

});

parcelRegister("sXTCx", function(module, exports) {
const $8b92489052cdb314$export$3f072f06b90c3985 = 'media';
module.exports["EVENT_CHANNEL"] = $8b92489052cdb314$export$3f072f06b90c3985;

});

parcelRegister("aFv56", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c64352804e2dc1a0b65a6765b7979b51>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen link-analytics
 */ const $260a3ee885876edc$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $260a3ee885876edc$export$2e2bcd8739ae039 = $260a3ee885876edc$var$createEventPayload;
module.exports["default"] = $260a3ee885876edc$export$2e2bcd8739ae039;

});

parcelRegister("l4JAB", function(module, exports) {
/* eslint-disable compat/compat */ const $1f035c9bfd2157e4$export$51d09170c61ebe04 = (callback)=>window.requestIdleCallback ? window.requestIdleCallback(callback, {
        timeout: 5000
    }) : window.requestAnimationFrame(callback);
module.exports["runWhenIdle"] = $1f035c9bfd2157e4$export$51d09170c61ebe04;

});

parcelRegister("eFoJQ", function(module, exports) {

let $aad8158f9fd0d08e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aad8158f9fd0d08e$var$load("iZU4p"),
    $aad8158f9fd0d08e$var$load("aqr2D"),
    $aad8158f9fd0d08e$var$load("6cVEd")
]).then(()=>parcelRequire('bSBwg'));

});

parcelRegister("4Vpub", function(module, exports) {
$parcel$export(module.exports, "datePlugin", () => (parcelRequire("4iQt6")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4iQt6 = parcelRequire("4iQt6");


});

parcelRegister("2wblJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d575faf3ca782e2$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $4TIFs = parcelRequire("4TIFs");


var $b5utg = parcelRequire("b5utg");

function $1d575faf3ca782e2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $4TIFs.default)(dirtyDate, amount * 12);
}

});

parcelRegister("bn2AM", function(module, exports) {
$parcel$export(module.exports, "gridPlugin", () => (parcelRequire("fYKTL")).gridPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $fYKTL = parcelRequire("fYKTL");


});

parcelRegister("58fnx", function(module, exports) {
$parcel$export(module.exports, "guidelinePlugin", () => (parcelRequire("fCLXZ")).guidelinePlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $fCLXZ = parcelRequire("fCLXZ");


});

parcelRegister("d5BeT", function(module, exports) {
$parcel$export(module.exports, "helpDialogPlugin", () => (parcelRequire("flknw")).helpDialogPlugin);
$parcel$export(module.exports, "deprecatedOpenHelpCommand", () => (parcelRequire("bQUgf")).openHelpCommand);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $bQUgf = parcelRequire("bQUgf");

var $flknw = parcelRequire("flknw");


});

parcelRegister("6N2nV", function(module, exports) {
$parcel$export(module.exports, "mediaPlugin", () => (parcelRequire("cWFvG")).mediaPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cWFvG = parcelRequire("cWFvG");


});

parcelRegister("10CSJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");





class $330e3eb3197f64f9$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser && (0, $dh538.fg)('jfp-magma-media-clipboard-init-after-mount')) Promise.all([
            (parcelRequire("aTx7Y")),
            (parcelRequire("2duHf"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Browser && !(0, $dh538.fg)('jfp-magma-media-clipboard-init-after-mount')) {
            const [mediaClient, browserModule] = await Promise.all([
                (parcelRequire("aTx7Y")),
                (parcelRequire("2duHf"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
            });
        }
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
        };
    }
}
$330e3eb3197f64f9$export$3ce634ac4a869e2c.displayName = 'AsyncBrowser';
$330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = void 0;
module.exports["BrowserLoader"] = $330e3eb3197f64f9$export$3ce634ac4a869e2c;

});

parcelRegister("aTx7Y", function(module, exports) {

let $7ee8bcdd5ed38cb7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7ee8bcdd5ed38cb7$var$load("jp3gT"),
    $7ee8bcdd5ed38cb7$var$load("fGT64"),
    $7ee8bcdd5ed38cb7$var$load("aqr2D"),
    $7ee8bcdd5ed38cb7$var$load("6aruy")
]).then(()=>parcelRequire('9VKkC'));

});

parcelRegister("2duHf", function(module, exports) {

let $19d49b5929fc8ec7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $19d49b5929fc8ec7$var$load("fGT64"),
    $19d49b5929fc8ec7$var$load("f35QR"),
    $19d49b5929fc8ec7$var$load("eVYW1"),
    $19d49b5929fc8ec7$var$load("ls0Um"),
    $19d49b5929fc8ec7$var$load("020xd"),
    $19d49b5929fc8ec7$var$load("eTBsW"),
    $19d49b5929fc8ec7$var$load("bYxCZ"),
    $19d49b5929fc8ec7$var$load("6HBYC"),
    $19d49b5929fc8ec7$var$load("eDqo1"),
    $19d49b5929fc8ec7$var$load("lxiFd"),
    $19d49b5929fc8ec7$var$load("1oiJ6"),
    $19d49b5929fc8ec7$var$load("huUvS"),
    $19d49b5929fc8ec7$var$load("6wr18"),
    $19d49b5929fc8ec7$var$load("jp3gT"),
    $19d49b5929fc8ec7$var$load("dT77m"),
    $19d49b5929fc8ec7$var$load("6vhrJ"),
    $19d49b5929fc8ec7$var$load("ffEVr"),
    $19d49b5929fc8ec7$var$load("hqblC")
]).then(()=>parcelRequire('4rZL5'));

});

parcelRegister("dU3Nv", function(module, exports) {
$parcel$export(module.exports, "mediaInsertPlugin", () => (parcelRequire("2U68K")).mediaInsertPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2U68K = parcelRequire("2U68K");


});

parcelRegister("dhgPE", function(module, exports) {
$parcel$export(module.exports, "mentionsPlugin", () => (parcelRequire("5u7tz")).mentionsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5u7tz = parcelRequire("5u7tz");


});

parcelRegister("5u7tz", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $dQl1W = parcelRequire("dQl1W");


var $d925B = parcelRequire("d925B");


var $ePpFN = parcelRequire("ePpFN");

var $4HWgE = parcelRequire("4HWgE");


var $dYBVS = parcelRequire("dYBVS");


var $3pLGZ = parcelRequire("3pLGZ");


var $bqMS3 = parcelRequire("bqMS3");


var $6mYMS = parcelRequire("6mYMS");


var $dh538 = parcelRequire("dh538");


var $3ZAfE = parcelRequire("3ZAfE");


var $8Shge = parcelRequire("8Shge");


var $9gkNA = parcelRequire("9gkNA");


var $8PUqB = parcelRequire("8PUqB");


var $jziTd = parcelRequire("jziTd");


var $jDVxk = parcelRequire("jDVxk");

const $99922ebfc07182a8$var$processName = (name, intl)=>{
    const unknownLabel = intl.formatMessage((0, $ePpFN.mentionMessages).unknownLabel);
    if (name.status === (0, $6mYMS.MentionNameStatus).OK) return `@${name.name || unknownLabel}`;
    else return `@${unknownLabel}`;
};
/**
 * We will need to clean this up once mentionProvider is
 * put inside mention plugin.
 * See: https://product-fabric.atlassian.net/browse/ED-26011
 */ function $99922ebfc07182a8$var$Component({ mentionProvider: mentionProvider, api: api }) {
    const mentionProviderMemo = (0, $42omo.useMemo)(()=>{
        return mentionProvider;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        mentionProviderMemo?.then((mentionProviderSync)=>{
            api?.base?.actions?.registerMarks(({ tr: tr, node: node, pos: pos })=>{
                const { doc: doc } = tr;
                const { schema: schema } = doc.type;
                const { mention: mentionNodeType } = schema.nodes;
                const { id: id } = node.attrs;
                if (node.type === mentionNodeType) {
                    if ((0, $bqMS3.isResolvingMentionProvider)(mentionProviderSync)) {
                        const nameDetail = mentionProviderSync?.resolveMentionName(id);
                        let newText;
                        if ((0, $6mYMS.isPromise)(nameDetail)) newText = `@${intl.formatMessage((0, $ePpFN.mentionMessages).unknownLabel)}`;
                        else newText = $99922ebfc07182a8$var$processName(nameDetail, intl);
                        const currentPos = tr.mapping.map(pos);
                        tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
                    }
                }
            });
        });
    }, [
        mentionProviderMemo,
        api,
        intl
    ]);
    return null;
}
const $99922ebfc07182a8$export$280dfabe1535ae84 = ({ config: options, api: api })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
    let previousMediaProvider;
    const fireEvent = (payload, channel)=>{
        const fireAnalyticsEvent = api?.analytics?.actions?.fireAnalyticsEvent;
        if (!fireAnalyticsEvent) return;
        if (payload.attributes && !payload.attributes.sessionId) payload.attributes.sessionId = sessionId;
        fireAnalyticsEvent(payload, channel);
    };
    const typeAhead = (0, $jDVxk.createTypeAheadConfig)({
        sanitizePrivateContent: options?.sanitizePrivateContent,
        mentionInsertDisplayName: options?.insertDisplayName,
        HighlightComponent: options?.HighlightComponent,
        handleMentionsChanged: options?.handleMentionsChanged,
        fireEvent: fireEvent,
        api: api
    });
    return {
        name: 'mention',
        nodes () {
            return [
                {
                    name: 'mention',
                    node: (0, $8Shge.mentionNodeSpec)()
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'mention',
                    plugin: (pmPluginFactoryParams)=>(0, $8PUqB.createMentionPlugin)({
                            pmPluginFactoryParams: pmPluginFactoryParams,
                            fireEvent: fireEvent,
                            options: options,
                            api: api
                        })
                }
            ];
        },
        contentComponent ({ editorView: editorView, providerFactory: providerFactory }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $dYBVS.WithProviders), {
                providers: [
                    'mentionProvider'
                ],
                providerFactory: providerFactory,
                renderNode: ({ mentionProvider: mentionProvider })=>{
                    return /*#__PURE__*/ (0, $l998X.jsx)($99922ebfc07182a8$var$Component, {
                        mentionProvider: mentionProvider,
                        api: api
                    });
                }
            });
        },
        secondaryToolbarComponent ({ editorView: editorView, disabled: disabled }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $jziTd.SecondaryToolbarComponent), {
                editorView: editorView,
                api: api,
                disabled: disabled,
                typeAhead: typeAhead
            });
        },
        commands: {
            insertMention: (0, $3ZAfE.insertMention)({
                sanitizePrivateContent: options?.sanitizePrivateContent ?? false,
                mentionInsertDisplayName: options?.insertDisplayName ?? false,
                api: api
            })
        },
        actions: {
            openTypeAhead (inputMethod) {
                return Boolean(api?.typeAhead?.actions?.open({
                    triggerHandler: typeAhead,
                    inputMethod: inputMethod
                }));
            },
            announceMentionsInsertion: (mentionChanges)=>{
                if (options?.handleMentionsChanged) options.handleMentionsChanged(mentionChanges);
            },
            setProvider: async (providerPromise)=>{
                if (!(0, $dh538.fg)('platform_editor_mention_provider_via_plugin_config')) return false;
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousMediaProvider === provider) return false;
                previousMediaProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $9gkNA.mentionPluginKey), {
                        action: (0, $8PUqB.ACTIONS).SET_PROVIDER,
                        params: {
                            provider: provider
                        }
                    })) ?? false;
            }
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const mentionPluginState = (0, $9gkNA.mentionPluginKey).getState(editorState);
            return {
                ...mentionPluginState,
                typeAheadHandler: typeAhead
            };
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'mention',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).mention),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).mentionDescription),
                        keywords: [
                            'team',
                            'user'
                        ],
                        priority: 400,
                        keyshortcut: '@',
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconMention), {}),
                        action (insert, state) {
                            const tr = insert(undefined);
                            const pluginState = (0, $9gkNA.mentionPluginKey).getState(state);
                            if (pluginState && pluginState.canInsertMention === false) return false;
                            api?.typeAhead?.actions.openAtTransaction({
                                triggerHandler: typeAhead,
                                inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                            })(tr);
                            return tr;
                        }
                    }
                ],
            typeAhead: typeAhead
        }
    };
};
module.exports["mentionsPlugin"] = $99922ebfc07182a8$export$280dfabe1535ae84;

});

parcelRegister("3ZAfE", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $bYZ53 = parcelRequire("bYZ53");


var $5SAOw = parcelRequire("5SAOw");


var $bqMS3 = parcelRequire("bqMS3");

const $71881ae30930a463$export$c39c34a625f03dcd = ({ mentionInsertDisplayName: mentionInsertDisplayName, mentionProvider: mentionProvider, tr: tr, sanitizePrivateContent: sanitizePrivateContent })=>({ name: name, id: id, userType: userType, nickname: nickname, localId: localId, accessLevel: accessLevel, isXProductUser: isXProductUser })=>{
        const schema = tr.doc.type.schema;
        const trimmedNickname = nickname && nickname.startsWith('@') ? nickname.slice(1) : nickname;
        const renderName = mentionInsertDisplayName || !trimmedNickname ? name : trimmedNickname;
        if (isXProductUser && mentionProvider && mentionProvider.inviteXProductUser) mentionProvider.inviteXProductUser(id, name);
        // Don't insert into document if document data is sanitized.
        const text = sanitizePrivateContent ? '' : `@${renderName}`;
        if (sanitizePrivateContent && (0, $bqMS3.isResolvingMentionProvider)(mentionProvider)) // Cache (locally) for later rendering
        mentionProvider.cacheMentionName(id, renderName);
        const annotationMarksForPos = (0, $bYZ53.getAnnotationMarksForPos)(tr.selection.$head);
        const mentionNode = schema.nodes.mention.createChecked({
            text: text,
            id: id,
            accessLevel: accessLevel,
            userType: userType === 'DEFAULT' ? null : userType,
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            localId: localId ?? (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))()
        }, null, annotationMarksForPos);
        const space = schema.text(' ', annotationMarksForPos);
        return (0, $5SAOw.Fragment).from([
            mentionNode,
            space
        ]);
    };
const $71881ae30930a463$export$8c4314a90d4c5fc1 = ({ sanitizePrivateContent: sanitizePrivateContent, api: api, mentionInsertDisplayName: mentionInsertDisplayName })=>({ name: name, id: id, userType: userType, localId: localId, nickname: nickname, accessLevel: accessLevel, isXProductUser: isXProductUser })=>{
        return ({ tr: tr })=>{
            const mentionProvider = api?.mention.sharedState.currentState()?.mentionProvider;
            const mentionFragment = $71881ae30930a463$export$c39c34a625f03dcd({
                sanitizePrivateContent: sanitizePrivateContent,
                mentionProvider: mentionProvider,
                mentionInsertDisplayName: mentionInsertDisplayName,
                tr: tr
            })({
                name: name,
                id: id,
                userType: userType,
                nickname: nickname,
                localId: localId,
                accessLevel: accessLevel,
                isXProductUser: isXProductUser
            });
            return tr.insert(tr.selection.from, mentionFragment);
        };
    };
module.exports["createSingleMentionFragment"] = $71881ae30930a463$export$c39c34a625f03dcd;
module.exports["insertMention"] = $71881ae30930a463$export$8c4314a90d4c5fc1;

});

parcelRegister("8Shge", function(module, exports) {

var $CmplZ = parcelRequire("CmplZ");


var $24P9d = parcelRequire("24P9d");


var $6fnsQ = parcelRequire("6fnsQ");

const $7f5ae13a5d726242$var$isSSR = Boolean(undefined);
const $7f5ae13a5d726242$export$a9cde69b487c37ac = ()=>{
    if ($7f5ae13a5d726242$var$isSSR) return 0, $CmplZ.mention;
    return {
        ...(0, $CmplZ.mention),
        toDOM: (node)=>{
            // packages/elements/mention/src/components/Mention/index.tsx
            const mentionAttrs = {
                'aria-busy': 'true',
                contenteditable: 'false',
                'data-access-level': '',
                'data-mention-id': node.attrs.id,
                'data-prosemirror-content-type': 'node',
                'data-prosemirror-node-inline': 'true',
                'data-prosemirror-node-name': 'mention',
                style: (0, $24P9d.convertToInlineCss)({
                    display: 'inline',
                    border: `1px solid transparent`,
                    background: `var(--ds-background-neutral, ${(0, $6fnsQ.N30A)})`,
                    color: "var(--ds-text-subtle, #505258)",
                    borderRadius: '20px',
                    cursor: 'pointer',
                    padding: '0 0.3em 2px 0.23em',
                    wordBreak: 'break-word'
                })
            };
            return [
                'span',
                mentionAttrs,
                node.attrs.text
            ];
        }
    };
};
module.exports["mentionNodeSpec"] = $7f5ae13a5d726242$export$a9cde69b487c37ac;

});

parcelRegister("9gkNA", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $c056e65a68cf462f$export$617302757e30e37c = new (0, $ks2lK.PluginKey)('mentionPlugin');
module.exports["mentionPluginKey"] = $c056e65a68cf462f$export$617302757e30e37c;

});

parcelRegister("8PUqB", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $1S4f7 = parcelRequire("1S4f7");


var $8m4tT = parcelRequire("8m4tT");


var $2v1PW = parcelRequire("2v1PW");


var $3jsXx = parcelRequire("3jsXx");


var $6mYMS = parcelRequire("6mYMS");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $3v1AL = parcelRequire("3v1AL");


var $a5yde = parcelRequire("a5yde");


var $9gkNA = parcelRequire("9gkNA");


var $12WWZ = parcelRequire("12WWZ");

const $2f5e4de94cd8d98b$export$92a1a3b7554e9387 = {
    SET_PROVIDER: 'SET_PROVIDER'
};
const $2f5e4de94cd8d98b$var$PACKAGE_NAME = "platform-pkg";
const $2f5e4de94cd8d98b$var$PACKAGE_VERSION = "0.0.0-use.local";
const $2f5e4de94cd8d98b$var$setProvider = (provider)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $9gkNA.mentionPluginKey), {
            action: $2f5e4de94cd8d98b$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        }));
        return true;
    };
function $2f5e4de94cd8d98b$export$36c073f17660f60f({ pmPluginFactoryParams: pmPluginFactoryParams, fireEvent: fireEvent, options: options, api: api }) {
    let mentionProvider;
    const sendAnalytics = (event, actionSubject, action, attributes)=>{
        if (event === (0, $3jsXx.SLI_EVENT_TYPE) || event === (0, $3jsXx.SMART_EVENT_TYPE)) fireEvent({
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                packageName: $2f5e4de94cd8d98b$var$PACKAGE_NAME,
                packageVersion: $2f5e4de94cd8d98b$var$PACKAGE_VERSION,
                componentName: (0, $6mYMS.ComponentNames).MENTION,
                ...attributes
            }
        }, 'fabricElements');
    };
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $9gkNA.mentionPluginKey),
        state: {
            init (_, state) {
                const canInsertMention = (0, $12WWZ.canMentionBeCreatedInRange)(state.selection.from, state.selection.to)(state);
                return {
                    canInsertMention: canInsertMention
                };
            },
            apply (tr, pluginState, oldState, newState) {
                const { action: action, params: params } = tr.getMeta((0, $9gkNA.mentionPluginKey)) || {
                    action: null,
                    params: null
                };
                let hasNewPluginState = false;
                let newPluginState = pluginState;
                const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
                if (tr.docChanged || tr.selectionSet && hasPositionChanged) {
                    newPluginState = {
                        ...pluginState,
                        canInsertMention: (0, $12WWZ.canMentionBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState)
                    };
                    hasNewPluginState = true;
                }
                switch(action){
                    case $2f5e4de94cd8d98b$export$92a1a3b7554e9387.SET_PROVIDER:
                        newPluginState = {
                            ...newPluginState,
                            mentionProvider: params.provider
                        };
                        hasNewPluginState = true;
                        break;
                }
                if (hasNewPluginState) pmPluginFactoryParams.dispatch((0, $9gkNA.mentionPluginKey), newPluginState);
                if ((0, $1oCLl.expValEquals)('platform_editor_new_mentions_detection_logic', 'isEnabled', true) && options?.handleMentionsChanged && tr.docChanged) {
                    (0, $2v1PW.insm).session?.startFeature('mentionDeletionDetection');
                    const mentionSchema = newState.schema.nodes.mention;
                    const mentionsRemoved = new Map();
                    tr.steps.forEach((step, index)=>{
                        step.getMap().forEach((from, to)=>{
                            const newStart = tr.mapping.slice(index).map(from, -1);
                            const newEnd = tr.mapping.slice(index).map(to);
                            const oldStart = tr.mapping.invert().map(newStart, -1);
                            const oldEnd = tr.mapping.invert().map(newEnd);
                            const oldSlice = oldState.doc.slice(oldStart, oldEnd);
                            const newSlice = newState.doc.slice(newStart, newEnd);
                            const mentionsBefore = new Map();
                            const mentionsAfter = new Map();
                            oldSlice.content.descendants((node)=>{
                                if (node.type.name === mentionSchema.name && node.attrs.localId) mentionsBefore.set(node.attrs.localId, {
                                    id: node.attrs.id,
                                    localId: node.attrs.localId
                                });
                            });
                            newSlice.content.descendants((node)=>{
                                if (node.type.name === mentionSchema.name && node.attrs.localId) mentionsAfter.set(node.attrs.localId, {
                                    id: node.attrs.id,
                                    localId: node.attrs.localId
                                });
                            });
                            // Determine which mentions were removed in this step
                            mentionsBefore.forEach((mention, localId)=>{
                                if (!mentionsAfter.has(localId)) mentionsRemoved.set(localId, mention);
                            });
                            // Adjust mentionsRemoved by removing any that reappear
                            mentionsAfter.forEach((_, localId)=>{
                                if (mentionsRemoved.has(localId)) mentionsRemoved.delete(localId);
                            });
                        });
                    });
                    if (mentionsRemoved.size > 0) {
                        const changes = Array.from(mentionsRemoved.values()).map((mention)=>({
                                id: mention.id,
                                localId: mention.localId,
                                type: 'deleted'
                            }));
                        options.handleMentionsChanged(changes);
                    }
                    (0, $2v1PW.insm).session?.endFeature('mentionDeletionDetection');
                }
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                mention: (node, view, getPos, decorations, innerDecorations)=>{
                    return new (0, $3v1AL.MentionNodeView)(node, {
                        options: options,
                        api: api,
                        portalProviderAPI: pmPluginFactoryParams.portalProviderAPI
                    });
                }
            }
        },
        view (editorView) {
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'mentionProvider':
                        if (!providerPromise) {
                            fireEvent({
                                action: (0, $d925B.ACTION).ERRORED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).MENTION,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MENTION_PROVIDER,
                                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    reason: (0, $a5yde.MENTION_PROVIDER_UNDEFINED)
                                }
                            });
                            return $2f5e4de94cd8d98b$var$setProvider(undefined)(editorView.state, editorView.dispatch);
                        }
                        providerPromise.then((provider)=>{
                            if (mentionProvider) mentionProvider.unsubscribe('mentionPlugin');
                            mentionProvider = provider;
                            $2f5e4de94cd8d98b$var$setProvider(provider)(editorView.state, editorView.dispatch);
                            provider.subscribe('mentionPlugin', undefined, undefined, undefined, undefined, sendAnalytics);
                        }).catch(()=>{
                            fireEvent({
                                action: (0, $d925B.ACTION).ERRORED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).MENTION,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MENTION_PROVIDER,
                                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    reason: (0, $a5yde.MENTION_PROVIDER_REJECTED)
                                }
                            });
                            return $2f5e4de94cd8d98b$var$setProvider(undefined)(editorView.state, editorView.dispatch);
                        });
                        break;
                }
                return;
            };
            const providerViaConfig = (0, $dh538.fg)('platform_editor_mention_provider_via_plugin_config');
            if (providerViaConfig && options?.mentionProvider) providerHandler('mentionProvider', options?.mentionProvider);
            else pmPluginFactoryParams.providerFactory.subscribe('mentionProvider', providerHandler);
            return {
                destroy () {
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('mentionProvider', providerHandler);
                    if (mentionProvider) mentionProvider.unsubscribe('mentionPlugin');
                },
                update (view, prevState) {
                    const newState = view.state;
                    if (!(0, $1oCLl.expValEquals)('platform_editor_new_mentions_detection_logic', 'isEnabled', true) && options?.handleMentionsChanged) {
                        const mentionSchema = newState.schema.nodes.mention;
                        const mentionNodesBefore = (0, $8m4tT.findChildrenByType)(prevState.doc, mentionSchema);
                        const mentionLocalIdsAfter = new Set((0, $8m4tT.findChildrenByType)(newState.doc, mentionSchema).map(({ node: node })=>node.attrs.localId));
                        if (mentionNodesBefore.length > mentionLocalIdsAfter.size) {
                            const deletedMentions = mentionNodesBefore.filter(({ node: node })=>!mentionLocalIdsAfter.has(node.attrs.localId)).map(({ node: node })=>({
                                    type: 'deleted',
                                    id: node.attrs.id,
                                    localId: node.attrs.localId
                                }));
                            if (deletedMentions.length > 0) options.handleMentionsChanged(deletedMentions);
                        }
                    }
                }
            };
        }
    });
}
module.exports["ACTIONS"] = $2f5e4de94cd8d98b$export$92a1a3b7554e9387;
module.exports["createMentionPlugin"] = $2f5e4de94cd8d98b$export$36c073f17660f60f;

});

parcelRegister("3v1AL", function(module, exports) {

var $d7ZU3 = parcelRequire("d7ZU3");


var $TfRUG = parcelRequire("TfRUG");


var $5SAOw = parcelRequire("5SAOw");


var $bqMS3 = parcelRequire("bqMS3");

var $6mYMS = parcelRequire("6mYMS");





var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $2K8Se = parcelRequire("2K8Se");

const $562b7f45d4fe9a0b$var$primitiveClassName = 'editor-mention-primitive';
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $562b7f45d4fe9a0b$var$getAccessibilityLabelFromName = (name)=>name.replace(/^@/u, '');
const $562b7f45d4fe9a0b$var$toDOM = (node)=>{
    // packages/elements/mention/src/components/Mention/index.tsx
    let mentionAttrs = {
        contenteditable: 'false',
        'data-access-level': node.attrs.accessLevel,
        'data-mention-id': node.attrs.id,
        'data-prosemirror-content-type': 'node',
        'data-prosemirror-node-inline': 'true',
        'data-prosemirror-node-name': 'mention',
        'data-prosemirror-node-view-type': 'vanilla',
        class: 'mentionView-content-wrap inlineNodeView'
    };
    if ((0, $dh538.fg)('platform_editor_adf_with_localid')) mentionAttrs = {
        ...mentionAttrs,
        'data-local-id': node.attrs.localId
    };
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    return [
        'span',
        mentionAttrs,
        [
            'span',
            {
                class: 'zeroWidthSpaceContainer'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $TfRUG.ZERO_WIDTH_SPACE)
            ]
        ],
        [
            'span',
            {
                spellcheck: 'false',
                class: $562b7f45d4fe9a0b$var$primitiveClassName
            },
            node.attrs.text || "@\u2026"
        ],
        browser.android ? [
            'span',
            {
                class: 'zeroWidthSpaceContainer',
                contenteditable: 'false'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $TfRUG.ZERO_WIDTH_SPACE)
            ]
        ] : [
            'span',
            {
                class: 'inlineNodeViewAddZeroWidthSpace'
            },
            (0, $TfRUG.ZERO_WIDTH_SPACE)
        ]
    ];
};
const $562b7f45d4fe9a0b$var$processName = (name)=>{
    return name.status === (0, $6mYMS.MentionNameStatus).OK ? `@${name.name || ''}` : `@_|unknown|_`;
};
const $562b7f45d4fe9a0b$var$handleProviderName = async (mentionProvider, node)=>{
    if ((0, $bqMS3.isResolvingMentionProvider)(mentionProvider) && node.attrs.id && !node.attrs.text) {
        const nameDetail = mentionProvider?.resolveMentionName(node.attrs.id);
        const resolvedNameDetail = await nameDetail;
        return $562b7f45d4fe9a0b$var$processName(resolvedNameDetail);
    }
};
const $562b7f45d4fe9a0b$var$getNewState = (isHighlighted, isRestricted)=>{
    if (isHighlighted) return 'self';
    if (isRestricted) return 'restricted';
    return 'default';
};
class $562b7f45d4fe9a0b$export$ed501823ec7e75de {
    setClassList(state) {
        this.mentionPrimitiveElement?.classList.toggle('mention-self', state === 'self');
        this.mentionPrimitiveElement?.classList.toggle('mention-restricted', state === 'restricted');
    }
    setTextContent(name) {
        if (name && !this.node.attrs.text && this.mentionPrimitiveElement) this.mentionPrimitiveElement.textContent = name;
    }
    async updateState(mentionProvider) {
        const isHighlighted = mentionProvider?.shouldHighlightMention({
            id: this.node.attrs.id
        }) ?? false;
        const newState = $562b7f45d4fe9a0b$var$getNewState(isHighlighted, (0, $6mYMS.isRestricted)(this.node.attrs.accessLevel));
        if (newState !== this.state) {
            this.setClassList(newState);
            this.state = newState;
        }
        const name = await $562b7f45d4fe9a0b$var$handleProviderName(mentionProvider, this.node);
        this.setTextContent(name);
        if (name && this.domElement && this.config.options?.profilecardProvider) this.domElement.setAttribute('aria-label', $562b7f45d4fe9a0b$var$getAccessibilityLabelFromName(name));
    }
    nodeIsEqual(nextNode) {
        if (this.config.options?.sanitizePrivateContent) {
            // Compare nodes but ignore the text parameter as it may be sanitized
            const nextNodeAttrs = {
                ...nextNode.attrs,
                text: this.node.attrs.text
            };
            return this.node.hasMarkup(nextNode.type, nextNodeAttrs, nextNode.marks);
        }
        return this.node.sameMarkup(nextNode);
    }
    update(node) {
        if (!this.nodeIsEqual(node)) return false;
        this.node = node;
        return true;
    }
    destroy() {
        this.cleanup?.();
        this.destroyProfileCard?.();
    }
    deselectNode() {
        this.removeProfileCard?.();
    }
    constructor(node, config){
        this.state = 'default';
        this.dom = void 0;
        this.domElement = void 0;
        this.contentDOM = void 0;
        this.config = void 0;
        this.node = void 0;
        this.cleanup = void 0;
        this.destroyProfileCard = void 0;
        this.removeProfileCard = void 0;
        this.mentionPrimitiveElement = void 0;
        const { options: options, api: api, portalProviderAPI: portalProviderAPI } = config;
        const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, $562b7f45d4fe9a0b$var$toDOM(node));
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.config = config;
        this.node = node;
        this.domElement = dom instanceof HTMLElement ? dom : undefined;
        this.mentionPrimitiveElement = this.domElement ? this.domElement.querySelector(`.${$562b7f45d4fe9a0b$var$primitiveClassName}`) ?? undefined : undefined;
        const { mentionProvider: mentionProvider } = api?.mention.sharedState.currentState() ?? {};
        this.updateState(mentionProvider);
        this.cleanup = api?.mention.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            this.updateState(nextSharedState?.mentionProvider);
        });
        const { destroyProfileCard: destroyProfileCard, removeProfileCard: removeProfileCard } = (0, $2K8Se.profileCardRenderer)({
            dom: dom,
            options: options,
            portalProviderAPI: portalProviderAPI,
            node: node,
            api: api
        });
        // Accessibility attributes - based on `packages/people-and-teams/profilecard/src/components/User/ProfileCardTrigger.tsx`
        if (this.domElement && options?.profilecardProvider) {
            if (node.attrs.text) this.domElement.setAttribute('aria-label', $562b7f45d4fe9a0b$var$getAccessibilityLabelFromName(node.attrs.text));
            this.domElement.setAttribute('aria-expanded', 'false');
            this.domElement.setAttribute('role', 'button');
            this.domElement.setAttribute('tabindex', '0');
            this.domElement.setAttribute('aria-haspopup', 'dialog');
        }
        this.destroyProfileCard = destroyProfileCard;
        this.removeProfileCard = removeProfileCard;
    }
}
module.exports["MentionNodeView"] = $562b7f45d4fe9a0b$export$ed501823ec7e75de;

});

parcelRegister("2K8Se", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $cUcZ5 = parcelRequire("cUcZ5");


var $ks2lK = parcelRequire("ks2lK");


var $lBy1w = parcelRequire("lBy1w");

const $cd857555fbf3a9f6$export$6adf928fbc333163 = ({ dom: dom, options: options, portalProviderAPI: portalProviderAPI, node: node, api: api })=>{
    let renderingProfileCard = false;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
    let cleanupSelection;
    const removeProfileCard = ()=>{
        if (dom instanceof HTMLElement) dom.setAttribute('aria-expanded', 'false');
        portalProviderAPI.remove(key);
        renderingProfileCard = false;
        cleanupSelection?.();
    };
    const listenerCleanup = (0, $fFa3V.bind)(dom, {
        type: 'click',
        listener: ()=>{
            if (dom instanceof HTMLElement && options?.profilecardProvider && !renderingProfileCard) {
                dom.setAttribute('aria-expanded', 'true');
                renderingProfileCard = true;
                portalProviderAPI.render(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lBy1w.ProfileCardComponent), {
                        activeMention: node,
                        profilecardProvider: options?.profilecardProvider,
                        dom: dom,
                        closeComponent: removeProfileCard
                    }), dom, key);
                // If we change the selection we should also remove the profile card. The "deselectNode"
                // should usually catch this, but it's possible (ie. on triple click) for this not to be called
                // which means the profile card gets stuck open until you click + change selection
                cleanupSelection = api?.selection?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                    const selection = nextSharedState?.selection;
                    if (selection instanceof (0, $ks2lK.NodeSelection) ? selection.node === node : false) return;
                    removeProfileCard?.();
                });
            }
        }
    });
    return {
        destroyProfileCard: ()=>{
            listenerCleanup();
            removeProfileCard?.();
        },
        removeProfileCard: removeProfileCard
    };
};
module.exports["profileCardRenderer"] = $cd857555fbf3a9f6$export$6adf928fbc333163;

});

parcelRegister("lBy1w", function(module, exports) {
/* ProfileCardComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fFa3V = parcelRequire("fFa3V");


var $hF7dB = parcelRequire("hF7dB");


var $7uX2s = parcelRequire("7uX2s");

const $e4866ae3b60254eb$var$styles = {
    loadingStyles: "_2rko12b0 _16qs130s"
};
const $e4866ae3b60254eb$var$LoadingWrapper = ({ children: children, isLoading: isLoading })=>isLoading ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $e4866ae3b60254eb$var$styles.loadingStyles
        ]),
        children: children
    }) : children;
const $e4866ae3b60254eb$export$2776629671584a76 = ({ id: id, provider: provider })=>{
    const [data, setData] = (0, $42omo.useState)();
    const [reportingLinesData, setReportingLinesData] = (0, $42omo.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $42omo.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $42omo.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [hasError, setHasError] = (0, $42omo.useState)(false); // From: packages/people-and-teams/profilecard/src/components/User/ProfileCardTrigger.tsx
    (0, $42omo.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!id || !provider) return;
            setIsLoading(true);
            try {
                const [data, reportingLines, shouldGiveKudos, teamCentralBaseUrl] = await Promise.all([
                    provider?.resourceClient.getProfile(provider?.cloudId || '', id, ()=>{}),
                    provider?.resourceClient.getReportingLines(id),
                    provider?.resourceClient.shouldShowGiveKudos(),
                    provider?.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                setData(data);
                setReportingLinesData(reportingLines);
                setShouldShowGiveKudos(shouldGiveKudos ?? false);
                setTeamCentralBaseUrl(teamCentralBaseUrl);
                setHasError(false);
            } catch (e) {
                setHasError(true);
            } finally{
                setIsLoading(false);
            }
        };
        fetchData();
    }, [
        id,
        provider
    ]);
    return {
        data: data,
        reportingLinesData: reportingLinesData,
        shouldShowGiveKudos: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        isLoading: isLoading,
        hasError: hasError
    };
};
function $e4866ae3b60254eb$export$cbc1b955d6cce80d({ profilecardProvider: profilecardProvider, activeMention: activeMention, dom: dom, closeComponent: closeComponent }) {
    const [provider, setProvider] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        profilecardProvider?.then((p)=>{
            setProvider(p);
        });
    }, [
        profilecardProvider
    ]);
    const { id: id, text: text, accessLevel: accessLevel } = activeMention.attrs ?? {};
    const actions = (0, $42omo.useMemo)(()=>provider?.getActions(id, text ?? '', accessLevel), [
        accessLevel,
        id,
        provider,
        text
    ]);
    const { data: data, reportingLinesData: reportingLinesData, shouldShowGiveKudos: shouldShowGiveKudos, teamCentralBaseUrl: teamCentralBaseUrl, isLoading: isLoading, hasError: hasError } = $e4866ae3b60254eb$export$2776629671584a76({
        id: id,
        provider: provider
    });
    (0, $42omo.useEffect)(()=>{
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') closeComponent();
            }
        });
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7uX2s.Popup), {
        referenceElement: dom,
        children: /*#__PURE__*/ (0, $l998X.jsx)($e4866ae3b60254eb$var$LoadingWrapper, {
            isLoading: isLoading,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hF7dB.ProfileCardLazy), {
                avatarUrl: data?.avatarUrl,
                accountType: data?.accountType,
                status: data?.status,
                statusModifiedDate: data?.statusModifiedDate,
                timestring: data?.timestring,
                isCurrentUser: data?.isCurrentUser,
                isBot: data?.isBot,
                fullName: data?.fullName,
                userId: id,
                cloudId: provider?.cloudId,
                actions: actions,
                isLoading: isLoading,
                location: data?.location,
                companyName: data?.companyName,
                customLozenges: data?.customLozenges,
                nickname: data?.nickname,
                email: data?.email,
                hasError: hasError,
                reportingLines: reportingLinesData,
                isKudosEnabled: shouldShowGiveKudos,
                teamCentralBaseUrl: teamCentralBaseUrl
            })
        })
    });
}
module.exports["ProfileCardComponent"] = $e4866ae3b60254eb$export$cbc1b955d6cce80d;

});

parcelRegister("7uX2s", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lqsSp = parcelRequire("lqsSp");


var $caX7N = parcelRequire("caX7N");


var $dTk3A = parcelRequire("dTk3A");


var $26KdU = parcelRequire("26KdU");

const $2f02737abfc96a63$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update,
        children
    ]);
    return children;
};
function $2f02737abfc96a63$export$129a32eedafa97c5({ referenceElement: referenceElement, children: children }) {
    const [targetRef, setPopupRef] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(null);
    (0, $26KdU.useFocusTrap)({
        targetRef: targetRef
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
            zIndex: (0, $dTk3A.layers).modal(),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lqsSp.Popper), {
                referenceElement: referenceElement,
                offset: [
                    0,
                    8
                ],
                placement: "bottom-end",
                strategy: "fixed",
                children: ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                        ref: (node)=>{
                            if (node) {
                                if (typeof ref === 'function') ref(node);
                                else ref.current = node;
                                setPopupRef(node);
                            }
                        },
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                        style: style,
                        children: /*#__PURE__*/ (0, $l998X.jsx)($2f02737abfc96a63$export$51eddd7655ca235a, {
                            update: update,
                            children: children
                        })
                    })
            })
        })
    });
}
module.exports["Popup"] = $2f02737abfc96a63$export$129a32eedafa97c5;

});

parcelRegister("26KdU", function(module, exports) {
/**
 * Custom hook to add focus trap
 * used for focus trap in ReactionPicker
 * copied from useFocusManager in @atlaskit/popup
 */ 
var $42omo = parcelRequire("42omo");


var $iqsGx = parcelRequire("iqsGx");

const $17acc0524b257831$export$5562a1f223a0d314 = ({ targetRef: targetRef })=>{
    (0, $42omo.useEffect)(()=>{
        if (!targetRef) return;
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: targetRef,
            fallbackFocus: targetRef,
            returnFocusOnDeactivate: true
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($iqsGx)))(targetRef, trapConfig);
        // wait for the popup to reposition itself before we focus
        let frameId = requestAnimationFrame(()=>{
            frameId = null;
            focusTrap.activate();
        });
        return ()=>{
            if (frameId !== null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        targetRef
    ]);
};
module.exports["useFocusTrap"] = $17acc0524b257831$export$5562a1f223a0d314;

});

parcelRegister("a5yde", function(module, exports) {
const $07adcb0974ca6bda$export$7d0bcf8324b20190 = 'REJECTED';
const $07adcb0974ca6bda$export$eceeecffdf63fc89 = 'UNDEFINED';
module.exports["MENTION_PROVIDER_REJECTED"] = $07adcb0974ca6bda$export$7d0bcf8324b20190;
module.exports["MENTION_PROVIDER_UNDEFINED"] = $07adcb0974ca6bda$export$eceeecffdf63fc89;

});

parcelRegister("12WWZ", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $9gkNA = parcelRequire("9gkNA");

function $ed26758b0d30a729$export$1e2b0e72eff65e51(state) {
    return (0, $9gkNA.mentionPluginKey).getState(state);
}
const $ed26758b0d30a729$export$bdc4118452fb5868 = (from, to)=>(state)=>{
        const $from = state.doc.resolve(from);
        const $to = state.doc.resolve(to);
        const mention = state.schema.nodes.mention.createChecked();
        if ($from.parent === $to.parent && (0, $8m4tT.canInsert)($from, mention)) return true;
        return false;
    };
module.exports["getMentionPluginState"] = $ed26758b0d30a729$export$1e2b0e72eff65e51;
module.exports["canMentionBeCreatedInRange"] = $ed26758b0d30a729$export$bdc4118452fb5868;

});

parcelRegister("jziTd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $eiA8Z = parcelRequire("eiA8Z");


var $1NfJ1 = parcelRequire("1NfJ1");

const $84f7a9985f2b0dd5$var$selector = (states)=>{
    return {
        mentionProvider: states.mentionState?.mentionProvider
    };
};
function $84f7a9985f2b0dd5$export$124ea4367cf7d1fc({ editorView: editorView, api: api, typeAhead: typeAhead, disabled: disabled }) {
    const { mentionProvider: mentionProvider } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'mention'
    ], $84f7a9985f2b0dd5$var$selector);
    const openMentionTypeAhead = (0, $42omo.useCallback)(()=>{
        api?.typeAhead?.actions?.open({
            triggerHandler: typeAhead,
            inputMethod: (0, $d925B.INPUT_METHOD).INSERT_MENU
        });
    }, [
        api,
        typeAhead
    ]);
    return !mentionProvider ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $1NfJ1.default), {
        editorView: editorView,
        onInsertMention: openMentionTypeAhead,
        isDisabled: disabled || api?.typeAhead?.actions.isAllowed(editorView.state)
    });
}
module.exports["SecondaryToolbarComponent"] = $84f7a9985f2b0dd5$export$124ea4367cf7d1fc;

});

parcelRegister("1NfJ1", function(module, exports) {
$parcel$export(module.exports, "default", () => $263cf3fdef9fdf3d$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $ePpFN = parcelRequire("ePpFN");


var $8TW6I = parcelRequire("8TW6I");

var $a4eZN = parcelRequire("a4eZN");


var $b4wUN = parcelRequire("b4wUN");

// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $263cf3fdef9fdf3d$var$ToolbarMention extends (0, $42omo.PureComponent) {
    render() {
        const mentionStringTranslated = this.props.intl.formatMessage((0, $ePpFN.mentionMessages).mentionsIconLabel);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
            testId: this.props.testId,
            buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).MENTION,
            spacing: "none",
            onClick: this.handleInsertMention,
            disabled: this.props.isDisabled,
            title: mentionStringTranslated + '@',
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b4wUN))), {
                label: mentionStringTranslated
            })
        });
    }
    constructor(...args){
        super(...args);
        this.handleInsertMention = ()=>{
            if (!this.props.editorView) return false;
            this.props.onInsertMention();
            return true;
        };
    }
}
var $263cf3fdef9fdf3d$export$2e2bcd8739ae039 = (0, $gmMgo.default)($263cf3fdef9fdf3d$var$ToolbarMention);

});

parcelRegister("jDVxk", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $lOELb = parcelRequire("lOELb");


var $5SAOw = parcelRequire("5SAOw");


var $8m4tT = parcelRequire("8m4tT");


var $dVkxw = parcelRequire("dVkxw");

var $dGsOm = parcelRequire("dGsOm");


var $bqMS3 = parcelRequire("bqMS3");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $3ZAfE = parcelRequire("3ZAfE");


var $12WWZ = parcelRequire("12WWZ");


var $e1wFI = parcelRequire("e1wFI");


var $17rN2 = parcelRequire("17rN2");


var $gmydP = parcelRequire("gmydP");

const $24a7b456f3432eef$var$createInviteItem = ({ mentionProvider: mentionProvider, onInviteItemMount: onInviteItemMount })=>({
        title: (0, $e1wFI.INVITE_ITEM_DESCRIPTION).id,
        render: ({ isSelected: isSelected, onClick: onClick, onHover: onHover })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $e1wFI.default), {
                productName: mentionProvider ? mentionProvider.productName : undefined,
                selected: isSelected,
                onMount: onInviteItemMount,
                onMouseEnter: onHover,
                onSelection: onClick,
                userRole: mentionProvider.userRole
            }),
        mention: (0, $e1wFI.INVITE_ITEM_DESCRIPTION)
    });
const $24a7b456f3432eef$var$withInviteItem = ({ mentionProvider: mentionProvider, firstQueryWithoutResults: firstQueryWithoutResults, currentQuery: currentQuery, onInviteItemMount: onInviteItemMount })=>(mentionItems)=>{
        const inviteItem = $24a7b456f3432eef$var$createInviteItem({
            mentionProvider: mentionProvider,
            onInviteItemMount: onInviteItemMount
        });
        const keepInviteItem = (0, $gmydP.shouldKeepInviteItem)(currentQuery, firstQueryWithoutResults);
        if (mentionItems.length === 0) return keepInviteItem ? [
            inviteItem
        ] : [];
        return [
            ...mentionItems,
            // invite item should be shown at the bottom
            inviteItem
        ];
    };
const $24a7b456f3432eef$export$f476360102d72b2 = (mention)=>{
    return {
        title: mention.id,
        render: ({ isSelected: isSelected, onClick: onClick, onHover: onHover })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dGsOm.default), {
                mention: mention,
                selected: isSelected,
                onMouseEnter: onHover,
                onSelection: onClick
            }),
        getCustomComponentHeight: ()=>{
            return 0, $dVkxw.MENTION_ITEM_HEIGHT;
        },
        mention: mention
    };
};
function $24a7b456f3432eef$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(mention) {
        // Check cache for hits
        const hit = seen.get(mention.id);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(mention);
        seen.set(mention.id, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $24a7b456f3432eef$var$memoizedToItem = $24a7b456f3432eef$export$fc10aeed3a532e2a($24a7b456f3432eef$export$f476360102d72b2);
const $24a7b456f3432eef$var$buildAndSendElementsTypeAheadAnalytics = (fireEvent)=>({ query: query, mentions: mentions, stats: stats })=>{
        let duration = 0;
        let userOrTeamIds = null;
        let teams = null;
        let xProductMentionsLength = 0;
        if (!(0, $gmydP.isTeamStats)(stats)) {
            // is from primary mention endpoint which could be just user mentions or user/team mentions
            duration = stats && stats.duration;
            teams = null;
            userOrTeamIds = mentions.map((mention)=>mention.id);
            xProductMentionsLength = mentions.filter((mention)=>mention.isXProductUser).length;
        } else {
            // is from dedicated team-only mention endpoint
            duration = stats && stats.teamMentionDuration;
            userOrTeamIds = null;
            teams = mentions.map((mention)=>(0, $gmydP.isTeamType)(mention.userType) ? {
                    teamId: mention.id,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    includesYou: mention.context.includesYou,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    memberCount: mention.context.memberCount
                } : null).filter((m)=>!!m);
        }
        const payload = (0, $17rN2.buildTypeAheadRenderedPayload)(duration, userOrTeamIds, query, teams, xProductMentionsLength);
        fireEvent(payload, 'fabric-elements');
    };
/**
 * When a team mention is selected, we render a team link and list of member/user mentions
 * in editor content
 */ const $24a7b456f3432eef$var$buildNodesForTeamMention = (schema, selectedMention, mentionProvider, sanitizePrivateContent)=>{
    const { nodes: nodes, marks: marks } = schema;
    const { name: name, id: teamId, accessLevel: accessLevel, context: context } = selectedMention;
    // build team link
    const defaultTeamLink = `${window.location.origin}/people/team/${teamId}`;
    const teamLink = context && context.teamLink ? context.teamLink : defaultTeamLink;
    const teamLinkNode = (0, $dh538.fg)('team-mention-inline-smartlink') ? schema.nodes.inlineCard.create({
        url: teamLink
    }) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    schema.text(name, [
        marks.link.create({
            href: teamLink
        })
    ]);
    const openBracketText = schema.text('(');
    const closeBracketText = schema.text(')');
    const emptySpaceText = schema.text(' ');
    const inlineNodes = [
        teamLinkNode,
        emptySpaceText,
        openBracketText
    ];
    const members = context && context.members ? context.members : [];
    members.forEach((member, index)=>{
        const { name: name, id: id } = member;
        const mentionName = `@${name}`;
        const text = sanitizePrivateContent ? '' : mentionName;
        if (sanitizePrivateContent && (0, $bqMS3.isResolvingMentionProvider)(mentionProvider)) mentionProvider.cacheMentionName(id, name);
        const userMentionNode = nodes.mention.createChecked({
            text: text,
            id: member.id,
            accessLevel: accessLevel,
            userType: 'DEFAULT',
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            localId: (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))()
        });
        inlineNodes.push(userMentionNode);
        // should not add empty space after the last user mention.
        if (index !== members.length - 1) inlineNodes.push(emptySpaceText);
    });
    inlineNodes.push(closeBracketText);
    return (0, $5SAOw.Fragment).fromArray(inlineNodes);
};
const $24a7b456f3432eef$export$90e81ee10e57772b = ({ sanitizePrivateContent: sanitizePrivateContent, mentionInsertDisplayName: mentionInsertDisplayName, fireEvent: fireEvent, HighlightComponent: HighlightComponent, api: api, handleMentionsChanged: handleMentionsChanged })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    let sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
    let firstQueryWithoutResults = null;
    const subscriptionKeys = new Set();
    const typeAhead = {
        id: (0, $lOELb.TypeAheadAvailableNodes).MENTION,
        trigger: '@',
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(@)',
        getHighlight: (state)=>{
            const CustomHighlightComponent = HighlightComponent;
            if (CustomHighlightComponent) return /*#__PURE__*/ (0, $l998X.jsx)(CustomHighlightComponent, {});
            return null;
        },
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = (0, $12WWZ.getMentionPluginState)(editorState);
            if (!pluginState?.mentionProvider) return Promise.resolve([]);
            const { mentionProvider: mentionProvider } = pluginState;
            const { contextIdentifierProvider: contextIdentifierProvider } = api?.contextIdentifier?.sharedState.currentState() ?? {};
            return new Promise((resolve, reject)=>{
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const key = `loadingMentionsForTypeAhead_${(0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))()}`;
                const mentionsSubscribeCallback = (mentions, resultQuery = '', stats)=>{
                    if (query !== resultQuery) return;
                    mentionProvider.unsubscribe(key);
                    subscriptionKeys.delete(key);
                    const mentionItems = mentions.map((mention)=>$24a7b456f3432eef$var$memoizedToItem.call(mention));
                    $24a7b456f3432eef$var$buildAndSendElementsTypeAheadAnalytics(fireEvent)({
                        query: query,
                        mentions: mentions,
                        stats: stats
                    });
                    if (mentions.length === 0 && firstQueryWithoutResults === null) firstQueryWithoutResults = query;
                    if (!mentionProvider.shouldEnableInvite || mentionItems.length > 2) resolve(mentionItems);
                    else {
                        const items = $24a7b456f3432eef$var$withInviteItem({
                            mentionProvider: mentionProvider,
                            firstQueryWithoutResults: firstQueryWithoutResults || '',
                            currentQuery: query,
                            onInviteItemMount: ()=>{
                                fireEvent((0, $17rN2.buildTypeAheadInviteItemViewedPayload)(sessionId, contextIdentifierProvider, mentionProvider.userRole));
                            }
                        })(mentionItems);
                        resolve(items);
                    }
                };
                subscriptionKeys.add(key);
                mentionProvider.subscribe(key, mentionsSubscribeCallback, ()=>{
                    if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
                        mentionProvider.unsubscribe(key);
                        subscriptionKeys.delete(key);
                        reject('FETCH_ERROR');
                    }
                });
                mentionProvider.filter(query || '', {
                    ...contextIdentifierProvider,
                    sessionId: sessionId
                });
            });
        },
        onOpen: ()=>{
            firstQueryWithoutResults = null;
        },
        selectItem (state, item, insert, { mode: mode, stats: stats, query: query, sourceListItem: sourceListItem }) {
            const { schema: schema } = state;
            const pluginState = (0, $12WWZ.getMentionPluginState)(state);
            const { mentionProvider: mentionProvider } = pluginState;
            const { id: id, name: name, nickname: nickname, accessLevel: accessLevel, userType: userType, isXProductUser: isXProductUser } = item.mention;
            const { contextIdentifierProvider: contextIdentifierProvider } = api?.contextIdentifier?.sharedState.currentState() ?? {};
            const mentionContext = {
                ...contextIdentifierProvider,
                sessionId: sessionId
            };
            if (mentionProvider && !(0, $gmydP.isInviteItem)(item.mention)) mentionProvider.recordMentionSelection(item.mention, mentionContext);
            // use same timer as StatsModifier
            const pickerElapsedTime = stats.startedAt ? performance.now() - stats.startedAt : 0;
            if (mentionProvider && mentionProvider.shouldEnableInvite && (0, $gmydP.isInviteItem)(item.mention)) {
                // Don't fire event and the callback with selection by space press
                if (mode !== 'space') {
                    fireEvent((0, $17rN2.buildTypeAheadInviteItemClickedPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, mode, query, contextIdentifierProvider, mentionProvider.userRole));
                    if (mentionProvider.onInviteItemClick) mentionProvider.onInviteItemClick('mention');
                }
                return state.tr;
            }
            let taskListId, taskItemId;
            const taskList = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.taskList)(state.selection);
            if (taskList) {
                taskListId = taskList.node.attrs.localId;
                const taskItem = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.taskItem)(state.selection);
                if (taskItem) taskItemId = taskItem.node.attrs.localId;
            }
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const mentionLocalId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
            if (handleMentionsChanged) {
                if (taskItemId) handleMentionsChanged([
                    {
                        type: 'added',
                        localId: mentionLocalId,
                        id: id,
                        taskLocalId: taskItemId,
                        method: 'typed'
                    }
                ]);
                else handleMentionsChanged([
                    {
                        type: 'added',
                        localId: mentionLocalId,
                        id: id,
                        method: 'typed'
                    }
                ]);
            }
            fireEvent((0, $17rN2.buildTypeAheadInsertedPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, mode, item.mention, mentionLocalId, sourceListItem.map((x)=>x.mention), query, contextIdentifierProvider, taskListId, taskItemId));
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
            if (mentionProvider && (0, $gmydP.isTeamType)(userType)) return insert($24a7b456f3432eef$var$buildNodesForTeamMention(schema, item.mention, mentionProvider, sanitizePrivateContent));
            if (isXProductUser && mentionProvider && mentionProvider.inviteXProductUser) mentionProvider.inviteXProductUser(id, name);
            return insert((0, $3ZAfE.createSingleMentionFragment)({
                mentionProvider: mentionProvider,
                mentionInsertDisplayName: mentionInsertDisplayName,
                tr: state.tr,
                sanitizePrivateContent: sanitizePrivateContent
            })({
                name: name,
                id: id,
                userType: userType,
                nickname: nickname,
                localId: mentionLocalId,
                accessLevel: accessLevel,
                isXProductUser: isXProductUser
            }));
        },
        dismiss ({ editorState: editorState, query: query, stats: stats, wasItemInserted: wasItemInserted }) {
            firstQueryWithoutResults = null;
            const pickerElapsedTime = stats.startedAt ? performance.now() - stats.startedAt : 0;
            if (!wasItemInserted) fireEvent((0, $17rN2.buildTypeAheadCancelPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, query || ''), 'fabric-elements');
            const pluginState = (0, $12WWZ.getMentionPluginState)(editorState);
            if (pluginState?.mentionProvider) {
                const mentionProvider = pluginState.mentionProvider;
                for (const key of subscriptionKeys)mentionProvider.unsubscribe(key);
            }
            subscriptionKeys.clear();
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        }
    };
    return typeAhead;
};
module.exports["createTypeAheadConfig"] = $24a7b456f3432eef$export$90e81ee10e57772b;

});

parcelRegister("dVkxw", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");


var $cStGJ = parcelRequire("cStGJ");

const $69c88bcb95aa7e29$export$be24b091af3609e7 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1b3haxs7"
})({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflow: 'hidden',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'middle'
});
const $69c88bcb95aa7e29$export$141d6bfd196b561 = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e1b3haxs6"
})((props)=>({
        position: 'relative',
        flex: 'initial',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $69c88bcb95aa7e29$export$159b59de9966d2d3 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1b3haxs5"
})((props)=>({
        flex: 1,
        minWidth: 0,
        marginLeft: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $69c88bcb95aa7e29$export$d1c198a7fd873fad = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e1b3haxs4"
})({
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
});
const $69c88bcb95aa7e29$export$50ad5d386685fccb = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1b3haxs3"
})((props)=>({
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'right',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&': {
            /* Lozenge */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& > span': {
                marginBottom: "var(--ds-space-025, 2px)"
            }
        }
    }));
const $69c88bcb95aa7e29$export$cf4c6e54e715dfd9 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1b3haxs2"
})({
    marginLeft: "var(--ds-space-250, 20px)",
    flex: 'none',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N100)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $69c88bcb95aa7e29$export$934cc98367d9ca68 = 48;
const $69c88bcb95aa7e29$export$cf80dda9d7a88a01 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1b3haxs1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.selected ? `var(--ds-background-selected, ${0, $6fnsQ.N30})` : 'transparent',
        display: 'block',
        overflow: 'hidden',
        listStyleType: 'none',
        height: `${$69c88bcb95aa7e29$export$934cc98367d9ca68}px`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.2,
        cursor: 'pointer'
    }));
const $69c88bcb95aa7e29$export$7bf9a8fa7c04527a = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1b3haxs0"
})({
    paddingLeft: "var(--ds-space-050, 4px)",
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`
});
module.exports["RowStyle"] = $69c88bcb95aa7e29$export$be24b091af3609e7;
module.exports["AvatarStyle"] = $69c88bcb95aa7e29$export$141d6bfd196b561;
module.exports["NameSectionStyle"] = $69c88bcb95aa7e29$export$159b59de9966d2d3;
module.exports["FullNameStyle"] = $69c88bcb95aa7e29$export$d1c198a7fd873fad;
module.exports["InfoSectionStyle"] = $69c88bcb95aa7e29$export$50ad5d386685fccb;
module.exports["TimeStyle"] = $69c88bcb95aa7e29$export$cf4c6e54e715dfd9;
module.exports["MENTION_ITEM_HEIGHT"] = $69c88bcb95aa7e29$export$934cc98367d9ca68;
module.exports["MentionItemStyle"] = $69c88bcb95aa7e29$export$cf80dda9d7a88a01;
module.exports["AccessSectionStyle"] = $69c88bcb95aa7e29$export$7bf9a8fa7c04527a;

});

parcelRegister("dGsOm", function(module, exports) {

var $esRft = parcelRequire("esRft");

var $5sA9S = parcelRequire("5sA9S");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");


var $6fnsQ = parcelRequire("6fnsQ");


var $42omo = parcelRequire("42omo");


var $9d81r = parcelRequire("9d81r");


var $6mYMS = parcelRequire("6mYMS");


var $bwC67 = parcelRequire("bwC67");


var $hldTh = parcelRequire("hldTh");


var $l2474 = parcelRequire("l2474");


var $27fVz = parcelRequire("27fVz");


var $dVkxw = parcelRequire("dVkxw");


var $77Xrn = parcelRequire("77Xrn");


var $6RIul = parcelRequire("6RIul");


var $i0btU = parcelRequire("i0btU");


var $laU6g = parcelRequire("laU6g");

function $0204c6fcc7b5f8a9$var$renderLozenge(lozenge) {
    if (typeof lozenge === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), null, lozenge);
    if (typeof lozenge === 'object') {
        const { appearance: appearance, text: text } = lozenge;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: appearance
        }, text);
    }
    return null;
}
function $0204c6fcc7b5f8a9$var$renderTime(time) {
    if (time) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dVkxw.TimeStyle), null, time);
    return null;
}
class $0204c6fcc7b5f8a9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { mention: mention, selected: selected, forwardedRef: forwardedRef } = this.props;
        const { id: id, highlight: highlight, avatarUrl: avatarUrl, presence: presence, name: name, mentionName: mentionName, lozenge: lozenge, accessLevel: accessLevel, isXProductUser: isXProductUser } = mention;
        const { status: status, time: time } = presence || {};
        const restricted = (0, $6mYMS.isRestricted)(accessLevel);
        const nameHighlights = highlight && highlight.name;
        const borderColor = selected ? `var(--ds-border, ${0, $6fnsQ.N30})` : undefined;
        const xProductUserInfoIconColor = selected ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon, #44546F)";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i0btU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dVkxw.MentionItemStyle), {
            selected: selected,
            onMouseDown: this.onMentionSelected,
            onMouseMove: this.onMentionMenuItemMouseMove,
            onMouseEnter: this.onMentionMenuItemMouseEnter,
            "data-mention-item": true,
            "data-testid": `mention-item-${id}`,
            "data-mention-id": id,
            "data-mention-name": mentionName,
            "data-selected": selected,
            ref: forwardedRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dVkxw.RowStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dVkxw.AvatarStyle), {
            restricted: restricted
        }, (0, $dh538.fg)('team-avatar-in-mention-picker') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $laU6g.MentionAvatar), {
            selected: selected,
            mention: mention
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: avatarUrl,
            size: "medium",
            presence: status,
            borderColor: borderColor,
            appearance: (0, $dh538.fg)('jira_ai_agent_avatar_issue_view_comment_mentions') ? (0, $5sA9S.getAppearanceForAppType)(mention.appType) : undefined
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dVkxw.NameSectionStyle), {
            restricted: restricted
        }, (0, $77Xrn.renderHighlight)((0, $dVkxw.FullNameStyle), name, nameHighlights), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6RIul.default), {
            mention: mention
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dVkxw.InfoSectionStyle), {
            restricted: restricted
        }, $0204c6fcc7b5f8a9$var$renderLozenge(lozenge), $0204c6fcc7b5f8a9$var$renderTime(time)), restricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l2474.default), {
            name: name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dVkxw.AccessSectionStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwC67.NoAccessLabel), null, (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $27fVz.default), {
                label: text
            }))))) : null, isXProductUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9d81r))), {
            color: xProductUserInfoIconColor,
            label: ''
        }))));
    }
    constructor(...args){
        super(...args);
        // internal, used for callbacks
        this.onMentionSelected = (event)=>{
            if ((0, $hldTh.leftClick)(event) && this.props.onSelection) {
                event.preventDefault();
                this.props.onSelection(this.props.mention, event);
            }
        };
        this.onMentionMenuItemMouseMove = (event)=>{
            if (this.props.onMouseMove) this.props.onMouseMove(this.props.mention, event);
        };
        this.onMentionMenuItemMouseEnter = (event)=>{
            if (this.props.onMouseEnter) this.props.onMouseEnter(this.props.mention, event);
        };
    }
}
const $0204c6fcc7b5f8a9$export$604dabd552e94336 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0204c6fcc7b5f8a9$export$2e2bcd8739ae039, {
        ...props,
        forwardedRef: ref
    });
});
module.exports["default"] = $0204c6fcc7b5f8a9$export$2e2bcd8739ae039;
module.exports["MentionItemWithRef"] = $0204c6fcc7b5f8a9$export$604dabd552e94336;

});

parcelRegister("hldTh", function(module, exports) {
function $aa59fadcb630050c$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $aa59fadcb630050c$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $aa59fadcb630050c$export$34ebdaf2c517ae75(event) {
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
}
module.exports["mouseLocation"] = $aa59fadcb630050c$export$fd3cd03f8ac42187;
module.exports["actualMouseMove"] = $aa59fadcb630050c$export$de744e30016241b0;
module.exports["leftClick"] = $aa59fadcb630050c$export$34ebdaf2c517ae75;

});

parcelRegister("27fVz", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $80397ffe2f8dbca3$var$AsyncLockCircleIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("b2k5H")).then((module)=>({
            default: module.default
        })));
var $80397ffe2f8dbca3$export$2e2bcd8739ae039 = $80397ffe2f8dbca3$var$AsyncLockCircleIcon;
module.exports["default"] = $80397ffe2f8dbca3$export$2e2bcd8739ae039;

});

parcelRegister("b2k5H", function(module, exports) {

let $808f773acd2b1cac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $808f773acd2b1cac$var$load("8JZKd"),
    $808f773acd2b1cac$var$load("6wr18"),
    $808f773acd2b1cac$var$load("ffEVr"),
    $808f773acd2b1cac$var$load("1S9KM")
]).then(()=>parcelRequire('fKVtj'));

});

parcelRegister("77Xrn", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $3b40cc09386e38bc$export$2bcf43b01d5314f5(ReactComponent, value, highlights, prefix) {
    if (!value) return null;
    const parts = [];
    const prefixText = prefix || '';
    let lastIndex = 0;
    if (highlights) {
        for(let i = 0; i < highlights.length; i++){
            const h = highlights[i];
            const start = h.start;
            const end = h.end;
            if (start > lastIndex) parts.push({
                value: value.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: value.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        }
        if (lastIndex < value.length) parts.push({
            value: value.substring(lastIndex, value.length),
            matches: false
        });
    } else parts.push({
        value: value,
        matches: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ReactComponent, null, prefixText, parts.map((part, index)=>{
        if (part.matches) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", {
            key: index
        }, part.value);
        return part.value;
    }));
}
module.exports["renderHighlight"] = $3b40cc09386e38bc$export$2bcf43b01d5314f5;

});

parcelRegister("6RIul", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $6mYMS = parcelRequire("6mYMS");


var $bTdBi = parcelRequire("bTdBi");


var $lGxNJ = parcelRequire("lGxNJ");


var $dHZFZ = parcelRequire("dHZFZ");


var $gjAAG = parcelRequire("gjAAG");

class $2168da1a134a3aab$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { userType: userType, isXProductUser: isXProductUser } = this.props.mention;
        if (isXProductUser) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dHZFZ.DescriptionBylineStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $gjAAG.messages).xProductMentionDescription));
        switch(userType){
            case (0, $6mYMS.UserType)[(0, $6mYMS.UserType).TEAM]:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGxNJ.default), {
                    mention: this.props.mention
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bTdBi.default), {
                    mention: this.props.mention
                });
        }
    }
}
module.exports["default"] = $2168da1a134a3aab$export$2e2bcd8739ae039;

});

parcelRegister("bTdBi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $77Xrn = parcelRequire("77Xrn");


var $dHZFZ = parcelRequire("dHZFZ");

class $cbd22085b8f91971$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { highlight: highlight, name: name, nickname: nickname } = this.props.mention;
        const nicknameHighlights = highlight && highlight.nickname;
        if (name === nickname) return null;
        return (0, $77Xrn.renderHighlight)((0, $dHZFZ.DescriptionBylineStyle), nickname, nicknameHighlights, '@');
    }
}
module.exports["default"] = $cbd22085b8f91971$export$2e2bcd8739ae039;

});

parcelRegister("dHZFZ", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");


var $cStGJ = parcelRequire("cStGJ");

const $8131603721b4dfdc$export$607100a5f9cc9977 = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e1bkpfff0"
})({
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N100)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginTop: "var(--ds-space-025, 2px)",
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
module.exports["DescriptionBylineStyle"] = $8131603721b4dfdc$export$607100a5f9cc9977;

});

parcelRegister("lGxNJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $dHZFZ = parcelRequire("dHZFZ");


var $gjAAG = parcelRequire("gjAAG");

class $8badfae915fa3b7b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { context: context } = this.props.mention;
        if (!context) return null;
        const includesYou = context.includesYou;
        const memberCount = context.memberCount;
        return this.renderByline(memberCount, includesYou);
    }
    constructor(...args){
        super(...args);
        this.renderByline = (memberCount, includesYou)=>{
            if (includesYou) {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $gjAAG.messages).plus50MembersWithYou));
                return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...(0, $gjAAG.messages).memberCountWithYou,
                    values: {
                        0: memberCount
                    }
                }));
            } else {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $gjAAG.messages).plus50MembersWithoutYou));
                return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...(0, $gjAAG.messages).memberCountWithoutYou,
                    values: {
                        0: memberCount
                    }
                }));
            }
        };
        this.getBylineComponent = (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dHZFZ.DescriptionBylineStyle), null, message);
    }
}
module.exports["default"] = $8badfae915fa3b7b$export$2e2bcd8739ae039;

});

parcelRegister("laU6g", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");

var $5sA9S = parcelRequire("5sA9S");


var $alaek = parcelRequire("alaek");


var $dh538 = parcelRequire("dh538");


var $6mYMS = parcelRequire("6mYMS");

const $1ce2ae5bf64180d0$export$35f495c0dc0a1015 = ({ mention: mention, selected: selected })=>{
    const { appType: appType, avatarUrl: avatarUrl, presence: presence } = mention;
    const borderColor = selected ? "var(--ds-border, #0B120E24)" : undefined;
    const { status: status } = presence || {};
    if ((0, $6mYMS.isTeamMention)(mention)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $alaek.default), {
        src: avatarUrl,
        size: "medium",
        borderColor: borderColor
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: avatarUrl,
        size: "medium",
        presence: status,
        borderColor: borderColor,
        appearance: (0, $dh538.fg)('jira_ai_agent_avatar_issue_view_comment_mentions') ? (0, $5sA9S.getAppearanceForAppType)(appType) : undefined
    });
};
module.exports["MentionAvatar"] = $1ce2ae5bf64180d0$export$35f495c0dc0a1015;

});

parcelRegister("e1wFI", function(module, exports) {
$parcel$export(module.exports, "default", () => $dca1e095f42e8aa9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $ePpFN = parcelRequire("ePpFN");


var $4xFCz = parcelRequire("4xFCz");

const $dca1e095f42e8aa9$var$mentionItemStyle = null;
const $dca1e095f42e8aa9$var$mentionItemSelectedStyle = null;
const $dca1e095f42e8aa9$var$rowStyle = null;
const $dca1e095f42e8aa9$var$avatarStyle = null;
const $dca1e095f42e8aa9$var$nameSectionStyle = null;
const $dca1e095f42e8aa9$var$capitalizedStyle = null;
const $dca1e095f42e8aa9$export$75621ed4176efc9e = {
    id: 'invite-teammate'
}; // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dca1e095f42e8aa9$var$leftClick = (event)=>{
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
};
const $dca1e095f42e8aa9$var$InviteItem = ({ productName: productName, onMount: onMount, onMouseEnter: onMouseEnter, onSelection: onSelection, selected: selected, userRole: userRole, intl: intl })=>{
    const onSelected = (0, $42omo.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if ($dca1e095f42e8aa9$var$leftClick(event) && onSelection) {
            event.preventDefault();
            onSelection($dca1e095f42e8aa9$export$75621ed4176efc9e, event);
        }
    }, [
        onSelection
    ]);
    const onItemMouseEnter = (0, $42omo.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onMouseEnter) onMouseEnter($dca1e095f42e8aa9$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    (0, $42omo.useEffect)(()=>{
        if (onMount) onMount();
    }, [
        onMount
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    , {
        onMouseDown: onSelected,
        onMouseEnter: onItemMouseEnter,
        "data-id": $dca1e095f42e8aa9$export$75621ed4176efc9e.id,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _bfhk1j28 _1e0c1ule _2mzuglyw _80omtlke",
            selected && "_bfhk1dpa"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _2lx2vrvc _1n261g80 _ca0q12x7 _n3td12x7 _19bvdlk8 _u5f3dlk8 _1bto1l2s _s7n4nkob"
            ]),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _1bsb14no _4t3i14no"
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4xFCz))), {
                        label: intl.formatMessage((0, $ePpFN.mentionMessages).mentionsAddLabel),
                        color: "var(--ds-icon-subtle, #505258)"
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    "data-testid": "name-section",
                    className: (0, $gMc0m.default)([
                        "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _18u0dlk8 _syazazsu"
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default // Ignored via go/ees005
                    ), {
                        ...(0, $ePpFN.mentionMessages).inviteItemTitle,
                        values: {
                            userRole: userRole || 'basic',
                            productName: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                                "data-testid": "capitalized-message",
                                className: (0, $gMc0m.default)([
                                    "_1p1d1dk0"
                                ]),
                                children: productName
                            })
                        }
                    })
                })
            ]
        })
    });
};
var $dca1e095f42e8aa9$export$2e2bcd8739ae039 = (0, $gmMgo.default)($dca1e095f42e8aa9$var$InviteItem);
module.exports["INVITE_ITEM_DESCRIPTION"] = $dca1e095f42e8aa9$export$75621ed4176efc9e;

});

parcelRegister("17rN2", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $6mYMS = parcelRequire("6mYMS");


var $gmydP = parcelRequire("gmydP");

const $a0ac5818e0563ad4$var$componentName = 'mention';
const $a0ac5818e0563ad4$var$source = 'mentionInEditor';
const $a0ac5818e0563ad4$var$emptyQueryResponse = {
    queryLength: 0,
    spaceInQuery: false
};
const $a0ac5818e0563ad4$var$extractAttributesFromQuery = (query)=>{
    if (query) return {
        queryLength: query.length,
        spaceInQuery: query.indexOf(' ') !== -1
    };
    return $a0ac5818e0563ad4$var$emptyQueryResponse;
};
const $a0ac5818e0563ad4$export$e1d5d51810b7e165 = (duration, upKeyCount, downKeyCount, sessionId, query)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $a0ac5818e0563ad4$var$extractAttributesFromQuery(query);
    return {
        action: (0, $d925B.ACTION).CANCELLED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).MENTION_TYPEAHEAD,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            componentName: $a0ac5818e0563ad4$var$componentName,
            duration: duration,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            sessionId: sessionId
        }
    };
};
const $a0ac5818e0563ad4$var$getPosition = (mentionList, selectedMention)=>{
    if (mentionList) {
        const index = mentionList.findIndex((mention)=>mention.id === selectedMention.id);
        return index === -1 ? undefined : index;
    }
    return;
};
const $a0ac5818e0563ad4$var$isClicked = (insertType)=>insertType === 'selected';
const $a0ac5818e0563ad4$export$c102b710f5c857c4 = (sessionId, contextIdentifierProvider, userRole)=>{
    const { containerId: containerId, objectId: objectId, childObjectId: childObjectId } = contextIdentifierProvider || {};
    return {
        action: (0, $d925B.ACTION).RENDERED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).INVITE_ITEM,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            componentName: $a0ac5818e0563ad4$var$componentName,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId,
            userRole: userRole,
            sessionId: sessionId,
            source: $a0ac5818e0563ad4$var$source
        }
    };
};
const $a0ac5818e0563ad4$export$e4c4d872dcfe2b15 = (duration, upKeyCount, downKeyCount, sessionId, insertType, query, contextIdentifierProvider, userRole)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $a0ac5818e0563ad4$var$extractAttributesFromQuery(query);
    const { containerId: containerId, objectId: objectId, childObjectId: childObjectId } = contextIdentifierProvider || {};
    return {
        action: $a0ac5818e0563ad4$var$isClicked(insertType) ? (0, $d925B.ACTION).CLICKED : (0, $d925B.ACTION).PRESSED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).INVITE_ITEM,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            componentName: $a0ac5818e0563ad4$var$componentName,
            duration: duration,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId,
            userRole: userRole,
            sessionId: sessionId,
            keyboardKey: $a0ac5818e0563ad4$var$isClicked(insertType) ? undefined : insertType
        }
    };
};
const $a0ac5818e0563ad4$export$84030a552533cdf8 = (duration, upKeyCount, downKeyCount, sessionId, insertType, mention, mentionLocalId, mentionList, query, contextIdentifierProvider, taskListId, taskItemId)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $a0ac5818e0563ad4$var$extractAttributesFromQuery(query);
    let containerId;
    let objectId;
    let childObjectId;
    if (contextIdentifierProvider) {
        containerId = contextIdentifierProvider.containerId || undefined;
        objectId = contextIdentifierProvider.objectId || undefined;
        childObjectId = contextIdentifierProvider.childObjectId || undefined;
    }
    return {
        action: $a0ac5818e0563ad4$var$isClicked(insertType) ? (0, $d925B.ACTION).CLICKED : (0, $d925B.ACTION).PRESSED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).MENTION_TYPEAHEAD,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        containerId: containerId,
        objectId: objectId,
        childObjectId: childObjectId,
        attributes: {
            sessionId: sessionId,
            duration: duration,
            position: $a0ac5818e0563ad4$var$getPosition(mentionList, mention),
            keyboardKey: $a0ac5818e0563ad4$var$isClicked(insertType) ? undefined : insertType,
            source: mention.source,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            isSpecial: (0, $6mYMS.isSpecialMention)(mention),
            accessLevel: mention.accessLevel || '',
            userType: mention.userType,
            userId: mention.id,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            memberCount: (0, $gmydP.isTeamType)(mention.userType) && mention.context ? mention.context.memberCount : null,
            includesYou: (0, $gmydP.isTeamType)(mention.userType) && mention.context ? mention.context.includesYou : null,
            taskListId: taskListId,
            taskItemId: taskItemId,
            localId: mentionLocalId,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId
        }
    };
};
const $a0ac5818e0563ad4$export$901fb6651fc13b0e = (duration, userIds, query, teams, xProductMentionsLength)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $a0ac5818e0563ad4$var$extractAttributesFromQuery(query);
    const actionSubject = userIds ? (0, $d925B.ACTION_SUBJECT).MENTION_TYPEAHEAD : (0, $d925B.ACTION_SUBJECT).TEAM_MENTION_TYPEAHEAD;
    return {
        action: (0, $d925B.ACTION).RENDERED,
        actionSubject: actionSubject,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            componentName: $a0ac5818e0563ad4$var$componentName,
            duration: duration,
            userIds: userIds,
            teams: teams,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            xProductMentionsLength: xProductMentionsLength
        }
    };
};
module.exports["buildTypeAheadCancelPayload"] = $a0ac5818e0563ad4$export$e1d5d51810b7e165;
module.exports["buildTypeAheadInviteItemViewedPayload"] = $a0ac5818e0563ad4$export$c102b710f5c857c4;
module.exports["buildTypeAheadInviteItemClickedPayload"] = $a0ac5818e0563ad4$export$e4c4d872dcfe2b15;
module.exports["buildTypeAheadInsertedPayload"] = $a0ac5818e0563ad4$export$84030a552533cdf8;
module.exports["buildTypeAheadRenderedPayload"] = $a0ac5818e0563ad4$export$901fb6651fc13b0e;

});

parcelRegister("gmydP", function(module, exports) {

var $e1wFI = parcelRequire("e1wFI");

const $fcd57767319030fa$export$6ddb6ef001273170 = (userType)=>userType === 'TEAM';
const $fcd57767319030fa$export$c427182c53a1ba5 = (stat)=>stat && !isNaN(stat.teamMentionDuration);
const $fcd57767319030fa$export$f5a334b5a28d1e01 = (mention)=>mention && mention.id === (0, $e1wFI.INVITE_ITEM_DESCRIPTION).id;
const $fcd57767319030fa$export$16a134d4e1b461dc = (query, firstQueryWithoutResults)=>{
    if (!firstQueryWithoutResults) return true;
    const lastIndexWithResults = firstQueryWithoutResults.length - 1;
    let suffix = query.slice(lastIndexWithResults);
    if (query[lastIndexWithResults - 1] === ' ') suffix = ' ' + suffix;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const depletedExtraWords = /\s[^\s]+\s/.test(suffix);
    return !depletedExtraWords;
};
module.exports["isTeamType"] = $fcd57767319030fa$export$6ddb6ef001273170;
module.exports["isTeamStats"] = $fcd57767319030fa$export$c427182c53a1ba5;
module.exports["isInviteItem"] = $fcd57767319030fa$export$f5a334b5a28d1e01;
module.exports["shouldKeepInviteItem"] = $fcd57767319030fa$export$16a134d4e1b461dc;

});

parcelRegister("8WOs1", function(module, exports) {
$parcel$export(module.exports, "placeholderTextPlugin", () => (parcelRequire("8HLyI")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8HLyI = parcelRequire("8HLyI");


});

parcelRegister("ii4wo", function(module, exports) {
$parcel$export(module.exports, "statusPlugin", () => (parcelRequire("c8680")).statusPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $c8680 = parcelRequire("c8680");


});

parcelRegister("1MUpo", function(module, exports) {
const $72d61fc920bbc248$export$27903d543b563e39 = (attrs)=>(...content)=>({
            type: 'bodiedExtension',
            attrs: attrs,
            content: content
        });
module.exports["bodiedExtension"] = $72d61fc920bbc248$export$27903d543b563e39;

});

parcelRegister("bAT9l", function(module, exports) {
const $6b7e17532fed1b16$export$db83999c14438df4 = (attrs)=>({
        type: 'mention',
        attrs: {
            accessLevel: '',
            ...attrs
        }
    });
module.exports["mention"] = $6b7e17532fed1b16$export$db83999c14438df4;

});

parcelRegister("1RqgI", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $iZTFQ = parcelRequire("iZTFQ");


var $gEpEw = parcelRequire("gEpEw");

class $f76d2aa2a1b6bce3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gEpEw.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        };
        this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        };
        this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        };
        this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        };
        this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $iZTFQ.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}
$f76d2aa2a1b6bce3$export$2e2bcd8739ae039.defaultProps = {
    defaultPage: 1,
    isLoading: false,
    isFixedSize: false,
    isRankable: false,
    onSetPage: (0, $ee7An.default),
    onSort: (0, $ee7An.default),
    rowsPerPage: Infinity
};
module.exports["default"] = $f76d2aa2a1b6bce3$export$2e2bcd8739ae039;

});

parcelRegister("iZTFQ", function(module, exports) {
const $7136cb869e4237cd$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $7136cb869e4237cd$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $7136cb869e4237cd$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $7136cb869e4237cd$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $7136cb869e4237cd$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $7136cb869e4237cd$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $7136cb869e4237cd$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $7136cb869e4237cd$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};
module.exports["getPageRows"] = $7136cb869e4237cd$export$3987dc24b734dcab;
module.exports["assertIsSortable"] = $7136cb869e4237cd$export$5eb35a4771ec4090;
module.exports["validateSortKey"] = $7136cb869e4237cd$export$9133f5a8bfe8a200;
module.exports["inlineStylesIfRanking"] = $7136cb869e4237cd$export$a601f1775e10043f;
module.exports["reorderRows"] = $7136cb869e4237cd$export$c476bbe5da59992d;

});

parcelRegister("gEpEw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $acwm0 = parcelRequire("acwm0");


var $iZTFQ = parcelRequire("iZTFQ");


var $a1aS7 = parcelRequire("a1aS7");


var $1QeRM = parcelRequire("1QeRM");


var $4S6q0 = parcelRequire("4S6q0");


var $ariie = parcelRequire("ariie");


var $fsOrO = parcelRequire("fsOrO");


var $gR32R = parcelRequire("gR32R");


var $3l42I = parcelRequire("3l42I");


var $lF3zd = parcelRequire("lF3zd");

function $5c24977a9a721875$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $acwm0.DESC:
            return 0, $acwm0.ASC;
        case 0, $acwm0.ASC:
            return 0, $acwm0.DESC;
        default:
            return currentSortOrder;
    }
}
const $5c24977a9a721875$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $ee7An.default), onSort: providedOnSort = (0, $ee7An.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $ee7An.default), onRankEnd: providedOnRankEnd = (0, $ee7An.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $42omo.useState)(false);
    const tableBodyRef = (0, $42omo.useRef)(null);
    const onSort = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $42omo.useEffect)(()=>{
        (0, $iZTFQ.validateSortKey)(sortKey, head);
        (0, $iZTFQ.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $acwm0.DESC)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $acwm0.ASC) : $5c24977a9a721875$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $iZTFQ.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $acwm0.LARGE) : (0, $acwm0.SMALL);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1QeRM.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $l998X.jsx)((0, $1QeRM.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gR32R.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $a1aS7.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $l998X.jsx)((0, $a1aS7.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $l998X.jsx)((0, $lF3zd.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $l998X.jsx)($5c24977a9a721875$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a1aS7.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3l42I.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $l998X.jsx)((0, $fsOrO.default), {
                isLoading: isLoading,
                spinnerSize: (0, $acwm0.LARGE),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $5c24977a9a721875$var$RankableTableBody = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("i3bGv")));
const $5c24977a9a721875$var$TableBody = /*#__PURE__*/ (0, $42omo.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $l998X.jsx)((0, $4S6q0.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ariie.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $l998X.jsx)($5c24977a9a721875$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5c24977a9a721875$export$2e2bcd8739ae039 = $5c24977a9a721875$var$DynamicTable;
module.exports["default"] = $5c24977a9a721875$export$2e2bcd8739ae039;

});

parcelRegister("acwm0", function(module, exports) {
const $0675324f6a750b1a$export$1dee026a19752d6b = 'ASC';
const $0675324f6a750b1a$export$b6abcf7fa1d94f65 = 'DESC';
const $0675324f6a750b1a$export$71dd4c8ecd45e95f = 'small';
const $0675324f6a750b1a$export$7b93a10c0fefe3e3 = 'large';
const $0675324f6a750b1a$export$3843c586a90b9cbf = 0.22;
module.exports["ASC"] = $0675324f6a750b1a$export$1dee026a19752d6b;
module.exports["DESC"] = $0675324f6a750b1a$export$b6abcf7fa1d94f65;
module.exports["SMALL"] = $0675324f6a750b1a$export$71dd4c8ecd45e95f;
module.exports["LARGE"] = $0675324f6a750b1a$export$7b93a10c0fefe3e3;
module.exports["LOADING_CONTENTS_OPACITY"] = $0675324f6a750b1a$export$3843c586a90b9cbf;

});

parcelRegister("a1aS7", function(module, exports) {
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $cd45f3a97f0c2709$var$fixedSizeTableStyles = null;
const $cd45f3a97f0c2709$var$tableStyles = null;
const $cd45f3a97f0c2709$var$bodyBorder = null;
const $cd45f3a97f0c2709$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("table" // React and Typescript do not yet support the inert attribute https://github.com/facebook/react/pull/24730
    , {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CFE1FD)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #4688EC)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _yq5hus1c _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1uh4"
        ]),
        children: children
    });
});
const $cd45f3a97f0c2709$var$captionStyles = null;
const $cd45f3a97f0c2709$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("caption", {
        className: (0, $gMc0m.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $cd45f3a97f0c2709$var$paginationWrapperStyles = null;
const $cd45f3a97f0c2709$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });
module.exports["Table"] = $cd45f3a97f0c2709$export$54ec01a60f47d33d;
module.exports["Caption"] = $cd45f3a97f0c2709$export$32fbfacc5d962e0c;
module.exports["PaginationWrapper"] = $cd45f3a97f0c2709$export$3e5e12dc01f20a43;

});

parcelRegister("1QeRM", function(module, exports) {
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $c201fa6e50809e47$var$fixedHeightStyles = null;
const $c201fa6e50809e47$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $gMc0m.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $c201fa6e50809e47$var$emptyViewContainerStyles = null;
const $c201fa6e50809e47$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $gMc0m.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};
module.exports["EmptyViewWithFixedHeight"] = $c201fa6e50809e47$export$8f45b9407d4090d7;
module.exports["EmptyViewContainer"] = $c201fa6e50809e47$export$381ea436de119582;

});

parcelRegister("4S6q0", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6ZeF0 = parcelRequire("6ZeF0");


var $cBjhI = parcelRequire("cBjhI");

// eslint-disable-next-line @repo/internal/react/no-class-components
class $07b7d6d69c936337$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $cBjhI.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $07b7d6d69c936337$var$Body = (0, $6ZeF0.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($07b7d6d69c936337$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$07b7d6d69c936337$export$2e2bcd8739ae039 = $07b7d6d69c936337$var$Body;
module.exports["default"] = $07b7d6d69c936337$export$2e2bcd8739ae039;

});

parcelRegister("6ZeF0", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b3dd488c65554a3$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $acwm0 = parcelRequire("acwm0");


var $iZTFQ = parcelRequire("iZTFQ");

const $9b3dd488c65554a3$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $9b3dd488c65554a3$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $acwm0.ASC) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $9b3dd488c65554a3$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $9b3dd488c65554a3$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $9b3dd488c65554a3$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $iZTFQ.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $9b3dd488c65554a3$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $iZTFQ.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $l998X.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("cBjhI", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lLKv4 = parcelRequire("lLKv4");


var $iu1PC = parcelRequire("iu1PC");

const $979466b421ef3326$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iu1PC.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $42omo.createElement)((0, $lLKv4.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$979466b421ef3326$export$2e2bcd8739ae039 = $979466b421ef3326$var$Row;
module.exports["default"] = $979466b421ef3326$export$2e2bcd8739ae039;

});

parcelRegister("lLKv4", function(module, exports) {
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $lo5NK = parcelRequire("lo5NK");

const $14854dc930c609a4$var$fixedSizeTruncateStyles = null;
const $14854dc930c609a4$var$overflowTruncateStyles = null;
const $14854dc930c609a4$var$truncationWidthStyles = null;
const $14854dc930c609a4$var$cellStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $14854dc930c609a4$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)("td" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        style: (0, $lo5NK.getTruncationStyleVars)({
            width: width
        }),
        // @ts-ignore
        ref: innerRef,
        className: (0, $gMc0m.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });
module.exports["TableBodyCell"] = $14854dc930c609a4$export$948e91fcef170792;

});

parcelRegister("lo5NK", function(module, exports) {
const $2d66c0434ecf2ef8$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $2d66c0434ecf2ef8$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$2d66c0434ecf2ef8$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
module.exports["getTruncationStyleVars"] = $2d66c0434ecf2ef8$export$5e6497a652ae30b5;

});

parcelRegister("iu1PC", function(module, exports) {
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $8163b397157d0c91$var$rowStyles = null;
const $8163b397157d0c91$var$rowBackgroundStyles = null;
const $8163b397157d0c91$var$rowHighlightedBackgroundStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $8163b397157d0c91$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("tr" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gMc0m.default)([
            "_bfhksm61 _1ygbdfik _1ah312gs",
            isHighlighted ? "_bfhk15s3 _irr3ufnl" : "_irr31dpa",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});
module.exports["TableBodyRow"] = $8163b397157d0c91$export$45f39d9c38b886d5;

});

parcelRegister("ariie", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $e87925282ef46156$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["ErrorBoundary"] = $e87925282ef46156$export$e926676385687eaf;

});

parcelRegister("fsOrO", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $acwm0 = parcelRequire("acwm0");


var $2qpLu = parcelRequire("2qpLu");

class $d7f23e5c1016680b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2qpLu.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $l998X.jsx)((0, $2qpLu.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $l998X.jsx)((0, $2qpLu.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}
$d7f23e5c1016680b$export$2e2bcd8739ae039.defaultProps = {
    isLoading: true,
    spinnerSize: (0, $acwm0.LARGE),
    contentsOpacity: (0, $acwm0.LOADING_CONTENTS_OPACITY),
    loadingLabel: 'Loading table'
};
module.exports["default"] = $d7f23e5c1016680b$export$2e2bcd8739ae039;

});

parcelRegister("2qpLu", function(module, exports) {
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $0273760afafdefb6$export$c335a80381ec61f5 = '--contents-opacity';
const $0273760afafdefb6$var$containerStyles = null;
const $0273760afafdefb6$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $0273760afafdefb6$var$contentsContainerStyles = null;
const $0273760afafdefb6$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            [$0273760afafdefb6$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $gMc0m.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $0273760afafdefb6$var$spinnerContainerStyles = null;
const $0273760afafdefb6$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $gMc0m.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });
module.exports["Container"] = $0273760afafdefb6$export$42a852a2b6b56249;
module.exports["ContentsContainer"] = $0273760afafdefb6$export$67c29eae8ae2137a;
module.exports["SpinnerContainer"] = $0273760afafdefb6$export$a5e06607a5ac6158;

});

parcelRegister("gR32R", function(module, exports) {
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $acwm0 = parcelRequire("acwm0");


var $eQFTY = parcelRequire("eQFTY");

class $23b1b51bd1ae612c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eQFTY.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $l998X.jsx)((0, $eQFTY.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eQFTY.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        };
        this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        };
        this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        };
        this.componentWillUnmount = ()=>{
            this.detachListeners();
        };
        this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        };
        this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
        this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        };
        this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        };
        this.handleResize = ()=>{
            this.updateSpinnerPosition();
        };
        this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        };
        this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        };
        this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}
$23b1b51bd1ae612c$export$2e2bcd8739ae039.defaultProps = {
    isLoading: true,
    spinnerSize: (0, $acwm0.LARGE),
    contentsOpacity: `var(--ds-opacity-loading, ${`${0, $acwm0.LOADING_CONTENTS_OPACITY}`})`,
    loadingLabel: 'Loading table'
};
module.exports["default"] = $23b1b51bd1ae612c$export$2e2bcd8739ae039;

});

parcelRegister("eQFTY", function(module, exports) {
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6d5e1b6cb99753a2$var$containerStyles = null;
const $6d5e1b6cb99753a2$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $6d5e1b6cb99753a2$var$spinnerBackdropStyles = null;
const $6d5e1b6cb99753a2$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $gMc0m.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $6d5e1b6cb99753a2$var$spinnerContainerStyles = null;
const $6d5e1b6cb99753a2$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));
module.exports["Container"] = $6d5e1b6cb99753a2$export$42a852a2b6b56249;
module.exports["SpinnerBackdrop"] = $6d5e1b6cb99753a2$export$aa207050321b0c53;
module.exports["SpinnerContainer"] = $6d5e1b6cb99753a2$export$a5e06607a5ac6158;

});

parcelRegister("3l42I", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dsM1s = parcelRequire("dsM1s");

class $5ca997743c0935b2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $dsM1s.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}
module.exports["default"] = $5ca997743c0935b2$export$2e2bcd8739ae039;

});

parcelRegister("dsM1s", function(module, exports) {
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $6mkwk = parcelRequire("6mkwk");


var $kiq1W = parcelRequire("kiq1W");


var $hNEaN = parcelRequire("hNEaN");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $aNNTx = parcelRequire("aNNTx");


var $hBGRU = parcelRequire("hBGRU");


var $kLrz5 = parcelRequire("kLrz5");


var $dSfjw = parcelRequire("dSfjw");


var $l7NbM = parcelRequire("l7NbM");

const $6fe03321c7228100$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $6fe03321c7228100$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $6fe03321c7228100$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($kiq1W))) : (0, (/*@__PURE__*/$parcel$interopDefault($hNEaN)));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "span",
        xcss: $6fe03321c7228100$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor",
            size: "small"
        })
    });
}
function $6fe03321c7228100$var$InnerPagination({ components: components = (0, $dSfjw.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $dSfjw.emptyObject), max: max = 7, onChange: onChange = (0, $ee7An.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $kLrz5.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $6mkwk.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$6fe03321c7228100$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            as: "li",
            xcss: $6fe03321c7228100$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hBGRU.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $aNNTx.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $l998X.jsx)($6fe03321c7228100$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $6fe03321c7228100$var$styles.paginationMenu,
                    children: (0, $l7NbM.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $aNNTx.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $l998X.jsx)($6fe03321c7228100$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $6fe03321c7228100$var$Pagination = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)($6fe03321c7228100$var$InnerPagination));
var $6fe03321c7228100$export$2e2bcd8739ae039 = $6fe03321c7228100$var$Pagination;
module.exports["default"] = $6fe03321c7228100$export$2e2bcd8739ae039;

});

parcelRegister("aNNTx", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e29809e32dcc0c3$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eEA8O = parcelRequire("eEA8O");

function $4e29809e32dcc0c3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("hBGRU", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cc2659209e25aa4$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eEA8O = parcelRequire("eEA8O");

function $2cc2659209e25aa4$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("kLrz5", function(module, exports) {
$parcel$export(module.exports, "default", () => $327224ec3ee62dd2$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $6F6hl = parcelRequire("6F6hl");

const $327224ec3ee62dd2$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $327224ec3ee62dd2$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "li",
        testId: testId,
        xcss: $327224ec3ee62dd2$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $6F6hl.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("dSfjw", function(module, exports) {
const $ccc55450a2ce3996$export$3f860eba1218f8d3 = {};
module.exports["emptyObject"] = $ccc55450a2ce3996$export$3f860eba1218f8d3;

});

parcelRegister("l7NbM", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $e6d8d358662d744b$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $2XqLN.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $e6d8d358662d744b$export$2e2bcd8739ae039 = $e6d8d358662d744b$var$collapseRange;
module.exports["default"] = $e6d8d358662d744b$export$2e2bcd8739ae039;

});

parcelRegister("lF3zd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $iZTFQ = parcelRequire("iZTFQ");


var $65EM3 = parcelRequire("65EM3");


var $l8KsL = parcelRequire("l8KsL");


var $73K2i = parcelRequire("73K2i");

// eslint-disable-next-line @repo/internal/react/no-class-components
class $28a7f7501af435d6$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    UNSAFE_componentWillMount() {
        (0, $iZTFQ.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $iZTFQ.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $l8KsL.default) : (0, $73K2i.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $65EM3.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $l998X.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return /*#__PURE__*/ (0, $l998X.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$28a7f7501af435d6$export$2e2bcd8739ae039 = $28a7f7501af435d6$var$TableHead;
module.exports["default"] = $28a7f7501af435d6$export$2e2bcd8739ae039;

});

parcelRegister("65EM3", function(module, exports) {
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $acwm0 = parcelRequire("acwm0");


var $lo5NK = parcelRequire("lo5NK");

const $207a1abf337d81f4$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $207a1abf337d81f4$var$rankingStyles = null;
const $207a1abf337d81f4$var$headStyles = null;
const $207a1abf337d81f4$var$overflowTruncateStyles = null;
const $207a1abf337d81f4$var$truncationWidthStyles = null;
const $207a1abf337d81f4$var$fixedSizeTruncateStyles = null;
const $207a1abf337d81f4$var$cellStyles = null;
const $207a1abf337d81f4$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $gMc0m.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $207a1abf337d81f4$var$headCellBaseStyles = null;
const $207a1abf337d81f4$export$4e8024263ace498b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $lo5NK.getTruncationStyleVars)({
            width: width
        }),
        [$207a1abf337d81f4$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #6B6E76)"
    };
    const isASC = sortOrder === (0, $acwm0.ASC);
    const isDESC = sortOrder === (0, $acwm0.DESC);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    }; // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $gMc0m.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            "_11c8dcr7 _179r1uh4 _mqm2glyw _kqswh2mm _syazazsu _k48pmoej _y3gn1e5h _s7n4nkob _1ygbd0i9",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq"
        ]),
        children: children
    });
});
module.exports["Head"] = $207a1abf337d81f4$export$e93312b7773dfcac;
module.exports["HeadCell"] = $207a1abf337d81f4$export$4e8024263ace498b;

});

parcelRegister("l8KsL", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $iwGL6 = parcelRequire("iwGL6");


var $iZTFQ = parcelRequire("iZTFQ");


var $73K2i = parcelRequire("73K2i");

// eslint-disable-next-line @repo/internal/react/no-class-components
class $3c91b6293fefaa96$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $iZTFQ.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $73K2i.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $3c91b6293fefaa96$var$RankableTableHeadCell = (0, $iwGL6.default)($3c91b6293fefaa96$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3c91b6293fefaa96$export$2e2bcd8739ae039 = $3c91b6293fefaa96$var$RankableTableHeadCell;
module.exports["default"] = $3c91b6293fefaa96$export$2e2bcd8739ae039;

});

parcelRegister("iwGL6", function(module, exports) {
$parcel$export(module.exports, "default", () => $12473f443f38c444$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $12473f443f38c444$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.ref = void 0;
            this.state = {
                refWidth: 0,
                refHeight: 0
            };
            this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            };
            this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("73K2i", function(module, exports) {
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $22Iw9 = parcelRequire("22Iw9");


var $euUgw = parcelRequire("euUgw");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");


var $3gadb = parcelRequire("3gadb");


var $acwm0 = parcelRequire("acwm0");


var $65EM3 = parcelRequire("65EM3");

const $b62786d16abca385$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk1j28 _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $b62786d16abca385$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c81o8v _syazazsu _k48pmoej"
};
const $b62786d16abca385$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $42omo.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $42omo.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b62786d16abca385$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: sortOrder === (0, $acwm0.ASC) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
                onClick: onClick,
                xcss: $b62786d16abca385$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                        xcss: isVisibleIconOnlyHeader ? $b62786d16abca385$var$styles.hideIconHeaderWrapper : $b62786d16abca385$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                            className: (0, $gMc0m.default)([
                                $b62786d16abca385$var$headCellStyles.text
                            ]),
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                        xcss: isSortIconVisible ? $b62786d16abca385$var$styles.sortIconVisibleWrapper : $b62786d16abca385$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $acwm0.ASC) ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
                            label: "",
                            color: "var(--ds-text-subtle, #505258)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($22Iw9))), {
                            label: "",
                            color: "var(--ds-text-subtle, #505258)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $65EM3.HeadCell // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ), {
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b62786d16abca385$export$2e2bcd8739ae039 = $b62786d16abca385$var$TableHeadCell;
module.exports["default"] = $b62786d16abca385$export$2e2bcd8739ae039;

});

parcelRegister("i3bGv", function(module, exports) {

let $d2419224dbf0c85e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d2419224dbf0c85e$var$load("lUQAm"),
    $d2419224dbf0c85e$var$load("8makw"),
    $d2419224dbf0c85e$var$load("heWL2")
]).then(()=>parcelRequire('dHxkf'));

});

parcelRegister("1t2ub", function(module, exports) {
$parcel$export(module.exports, "contentInsertionPlugin", () => (parcelRequire("2yr9J")).contentInsertionPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2yr9J = parcelRequire("2yr9J");


});

parcelRegister("1crCh", function(module, exports) {
$parcel$export(module.exports, "expandPlugin", () => (parcelRequire("fTvEN")).expandPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $fTvEN = parcelRequire("fTvEN");


});

parcelRegister("cc99d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0cd8dd83f623ffc8a93c918c96c1a11>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e0db38dacc0710f$var$_react = $8e0db38dacc0710f$var$_interopRequireDefault((parcelRequire("42omo")));

var $8e0db38dacc0710f$var$_baseNew = $8e0db38dacc0710f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8e0db38dacc0710f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e0db38dacc0710f$var$FieldTextIcon = (props)=>/*#__PURE__*/ $8e0db38dacc0710f$var$_react.default.createElement($8e0db38dacc0710f$var$_baseNew.default, Object.assign({
        name: "FieldTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$8e0db38dacc0710f$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $8e0db38dacc0710f$var$_default = module.exports.default = $8e0db38dacc0710f$var$FieldTextIcon;

});

parcelRegister("dcNOI", function(module, exports) {
$parcel$export(module.exports, "layoutPlugin", () => (parcelRequire("05jmd")).layoutPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $05jmd = parcelRequire("05jmd");


});

parcelRegister("fdbx8", function(module, exports) {
$parcel$export(module.exports, "panelPlugin", () => (parcelRequire("b3BjA")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $b3BjA = parcelRequire("b3BjA");


});

parcelRegister("1C8xV", function(module, exports) {
$parcel$export(module.exports, "rulePlugin", () => (parcelRequire("5DsxN")).rulePlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5DsxN = parcelRequire("5DsxN");


});

parcelRegister("ituSb", function(module, exports) {
$parcel$export(module.exports, "tablesPlugin", () => (parcelRequire("eeGWn")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $eeGWn = parcelRequire("eeGWn");


});

parcelRegister("51lK8", function(module, exports) {

var $4T4vf = parcelRequire("4T4vf");


var $f1MqO = parcelRequire("f1MqO");

const $883f68a01157ae2e$var$api = (0, $f1MqO.makeApi)({
    monitor: (0, $4T4vf.monitorForElements)
});
const $883f68a01157ae2e$export$4b66ee8317094cdb = $883f68a01157ae2e$var$api.autoScroll;
const $883f68a01157ae2e$export$c9168f41de61f525 = $883f68a01157ae2e$var$api.autoScrollWindow;
module.exports["autoScrollForElements"] = $883f68a01157ae2e$export$4b66ee8317094cdb;

});

parcelRegister("f1MqO", function(module, exports) {

var $bSjaC = parcelRequire("bSjaC");

parcelRequire("eItNK");
var $aYpzB = parcelRequire("aYpzB");


var $jtbk8 = parcelRequire("jtbk8");


var $ejbcR = parcelRequire("ejbcR");


var $h66Yh = parcelRequire("h66Yh");

function $d8d8df98db63a460$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        const cleanup = (0, $bSjaC.combine)((0, $ejbcR.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        return (0, $aYpzB.once)(cleanup);
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        function cleanup() {
            windowRegistry.delete(unique);
        }
        return (0, $aYpzB.once)(cleanup);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $h66Yh.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $jtbk8.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}
module.exports["makeApi"] = $d8d8df98db63a460$export$b8fa21320a811083;

});

parcelRegister("eItNK", function(module, exports) {
$parcel$export(module.exports, "once", () => (parcelRequire("aYpzB")).once);

var $aYpzB = parcelRequire("aYpzB");


});

parcelRegister("jtbk8", function(module, exports) {
parcelRequire("5jQxm");
var $66utD = parcelRequire("66utD");


var $1PEak = parcelRequire("1PEak");

// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $ae06eb7a26d5c40d$var$schedulers = new Map();
function $ae06eb7a26d5c40d$export$5cff7ac265db316a(monitor) {
    const scheduler = $ae06eb7a26d5c40d$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $ae06eb7a26d5c40d$var$makeScheduler(monitor);
    $ae06eb7a26d5c40d$var$schedulers.set(monitor, created);
    return created;
}
function $ae06eb7a26d5c40d$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $66utD.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $1PEak.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $1PEak.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}
module.exports["getScheduler"] = $ae06eb7a26d5c40d$export$5cff7ac265db316a;

});

parcelRegister("1PEak", function(module, exports) {
const $b8aa3381b771fe03$var$ledger = new Map();
const $b8aa3381b771fe03$var$requested = new Set();
function $b8aa3381b771fe03$export$8c764c3f2fc3d2d2(element) {
    $b8aa3381b771fe03$export$1cb7cbb266b6f6fa(element);
    const entry = $b8aa3381b771fe03$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $b8aa3381b771fe03$var$ledger.set(element, fresh);
    return fresh;
}
function $b8aa3381b771fe03$export$1cb7cbb266b6f6fa(element) {
    $b8aa3381b771fe03$var$requested.add(element);
}
function $b8aa3381b771fe03$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $b8aa3381b771fe03$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $b8aa3381b771fe03$var$ledger.forEach((_, element)=>{
        if (!$b8aa3381b771fe03$var$requested.has(element)) $b8aa3381b771fe03$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $b8aa3381b771fe03$var$requested.clear();
}
function $b8aa3381b771fe03$export$13ae770ed39b71ea() {
    $b8aa3381b771fe03$var$ledger.clear();
}
module.exports["markAndGetEngagement"] = $b8aa3381b771fe03$export$8c764c3f2fc3d2d2;
module.exports["clearUnusedEngagements"] = $b8aa3381b771fe03$export$991e77dd347f3df1;
module.exports["clearEngagementHistory"] = $b8aa3381b771fe03$export$13ae770ed39b71ea;

});

parcelRegister("ejbcR", function(module, exports) {
const $ba3cc2be2c89e337$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $ba3cc2be2c89e337$export$aea217a45095ce11 = `[${$ba3cc2be2c89e337$export$4b152ab55cad4fd6}="true"]`;
function $ba3cc2be2c89e337$export$4ec12fb57dfebd53(element) {
    element.setAttribute($ba3cc2be2c89e337$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($ba3cc2be2c89e337$export$4b152ab55cad4fd6);
}
module.exports["selector"] = $ba3cc2be2c89e337$export$aea217a45095ce11;
module.exports["addScrollableAttribute"] = $ba3cc2be2c89e337$export$4ec12fb57dfebd53;

});

parcelRegister("h66Yh", function(module, exports) {

var $h9dtK = parcelRequire("h9dtK");


var $1PEak = parcelRequire("1PEak");


var $ejbcR = parcelRequire("ejbcR");


var $6DDhO = parcelRequire("6DDhO");

function $568f43811c88fe4c$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $568f43811c88fe4c$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$568f43811c88fe4c$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $ejbcR.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $568f43811c88fe4c$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $1PEak.markAndGetEngagement)(element);
    const config = (0, $h9dtK.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $6DDhO.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $568f43811c88fe4c$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $1PEak.markAndGetEngagement)(element);
        const config = (0, $h9dtK.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $6DDhO.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $568f43811c88fe4c$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $568f43811c88fe4c$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$568f43811c88fe4c$var$isScrollingAvailable(remainder)) return;
    $568f43811c88fe4c$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}
module.exports["tryScroll"] = $568f43811c88fe4c$export$233199807749476d;

});

parcelRegister("h9dtK", function(module, exports) {
const $35bbc9592dd770aa$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $35bbc9592dd770aa$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $35bbc9592dd770aa$export$e96028ec7ff9d079(provided) {
    return {
        ...$35bbc9592dd770aa$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $35bbc9592dd770aa$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}
module.exports["getInternalConfig"] = $35bbc9592dd770aa$export$e96028ec7ff9d079;

});

parcelRegister("6DDhO", function(module, exports) {

var $hhm38 = parcelRequire("hhm38");


var $ajYex = parcelRequire("ajYex");


var $lFBSq = parcelRequire("lFBSq");


var $wfJXn = parcelRequire("wfJXn");


var $eIOs5 = parcelRequire("eIOs5");


var $6UNNA = parcelRequire("6UNNA");

function $d6a7fe667f94accc$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $d6a7fe667f94accc$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $d6a7fe667f94accc$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $ajYex.edges).reduce((map, edge)=>{
        const hitbox = (0, $lFBSq.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $ajYex.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $eIOs5.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $6UNNA.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $hhm38.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}
module.exports["getScrollBy"] = $d6a7fe667f94accc$export$6cfa6dfe6898b98f;

});

parcelRegister("hhm38", function(module, exports) {
const $7d638df63a9348c1$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};
module.exports["canScrollOnEdge"] = $7d638df63a9348c1$export$ccd6d9407403fcad;

});

parcelRegister("ajYex", function(module, exports) {
const $e2d5736e549d9f1a$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $e2d5736e549d9f1a$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};
module.exports["edges"] = $e2d5736e549d9f1a$export$4544a00f8eb65eb2;
module.exports["edgeAxisLookup"] = $e2d5736e549d9f1a$export$7fc144124ccf8292;

});

parcelRegister("lFBSq", function(module, exports) {

var $8e8VQ = parcelRequire("8e8VQ");


var $84ZAS = parcelRequire("84ZAS");

function $c2a3ef074bb4151d$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $8e8VQ.axisLookup)[axis];
        const side = (0, $84ZAS.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $c2a3ef074bb4151d$export$b9a449c20abb0e9 = {
    top: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};
module.exports["getOverElementHitbox"] = $c2a3ef074bb4151d$export$b9a449c20abb0e9;

});

parcelRegister("8e8VQ", function(module, exports) {
const $88deb29ded672487$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $88deb29ded672487$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $88deb29ded672487$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $88deb29ded672487$var$vertical,
        crossAxis: $88deb29ded672487$var$horizontal
    },
    horizontal: {
        mainAxis: $88deb29ded672487$var$horizontal,
        crossAxis: $88deb29ded672487$var$vertical
    }
};
module.exports["axisLookup"] = $88deb29ded672487$export$42e42cdab35a2b96;

});

parcelRegister("84ZAS", function(module, exports) {
const $5948654a23ca7c24$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};
module.exports["mainAxisSideLookup"] = $5948654a23ca7c24$export$a45c0cd714a4dbaa;

});

parcelRegister("wfJXn", function(module, exports) {

var $8e8VQ = parcelRequire("8e8VQ");


var $htU2u = parcelRequire("htU2u");


var $84ZAS = parcelRequire("84ZAS");

// We want a consistent scroll speed across devices, regardless of framerate
function $3f544cf5427e20fd$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $3f544cf5427e20fd$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $8e8VQ.axisLookup)[axis];
    const side = (0, $84ZAS.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $htU2u.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $htU2u.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $3f544cf5427e20fd$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $3f544cf5427e20fd$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $3f544cf5427e20fd$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $htU2u.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $84ZAS.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}
module.exports["getScrollChange"] = $3f544cf5427e20fd$export$470a2ff46db8cee8;

});

parcelRegister("htU2u", function(module, exports) {
function $1fec9052eae48826$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}
module.exports["getPercentageInRange"] = $1fec9052eae48826$export$1a29de000a332d74;

});

parcelRegister("eIOs5", function(module, exports) {
function $602bab09026eed2a$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}
module.exports["isAxisAllowed"] = $602bab09026eed2a$export$7120fdbd90bd1292;

});

parcelRegister("6UNNA", function(module, exports) {
function $92037081dc0ecd04$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
module.exports["isWithin"] = $92037081dc0ecd04$export$cda7a9d4399bf2e3;

});

parcelRegister("i0V8C", function(module, exports) {
$parcel$export(module.exports, "tasksAndDecisionsPlugin", () => (parcelRequire("jaskt")).tasksAndDecisionsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $jaskt = parcelRequire("jaskt");


});

parcelRegister("lBvGi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $56c2dc0faf44f7eb$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $c0qxy = parcelRequire("c0qxy");


var $kZ5GD = parcelRequire("kZ5GD");

const $56c2dc0faf44f7eb$var$noOptions = [];
function $56c2dc0faf44f7eb$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $56c2dc0faf44f7eb$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, labelId: labelId, onInvalid: onInvalid = (0, $ee7An.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $c0qxy.useId)();
    const [selectedValue, setSelectedValue] = (0, $42omo.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "radiogroup",
        // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
        "aria-labelledby": labelId || ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $42omo.createElement)((0, $kZ5GD.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}

});

parcelRegister("kZ5GD", function(module, exports) {
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />
// for typing `process`

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $dh538 = parcelRequire("dh538");

const $56d63ff022409480$var$packageName = "platform-pkg";
const $56d63ff022409480$var$packageVersion = "0.0.0-use.local";
const $56d63ff022409480$var$noop = (0, $ee7An.default);
const $56d63ff022409480$var$labelPaddingStyles = null;
const $56d63ff022409480$var$labelStyles = null;
const $56d63ff022409480$var$radioStyles = null;
const $56d63ff022409480$var$newRadioStyles = null;
const $56d63ff022409480$var$InnerRadio = /*#__PURE__*/ (0, $42omo.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $56d63ff022409480$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $56d63ff022409480$var$packageName,
        packageVersion: $56d63ff022409480$var$packageVersion
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $gMc0m.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazi7uo _mqf81gmx _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                "aria-labelledby": labelId || ariaLabelledBy,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $gMc0m.default)([
                    "_18s8ze3t _19it3vzd _2rko1qll _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6q1j9a _1151rsbi _1s6w5w2r _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1qll _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosijmqp _11jyjmqp _f3ett94y _19ybs4qr _1d7ps4qr _j5dh13gf _scgf13gf _4fps13gf _5ry313gf _qep213gf _180n13gf _1gcs13gf _1x1a13gf _6hp813gf _4ryaby5v _o1bdby5v _2kbkby5v _6cyrby5v _n8t0by5v _1o5rby5v _nxi6by5v _neoeby5v _1el2by5v _lekrbk0g _11v7bk0g _1if1bk0g _bl0ebk0g _92nabk0g _awurbk0g _1f8cbk0g _s2ftbk0g _17a1bk0g _x48a2sac _1ib22sac _wml02sac _tusm2sac _1c6f2sac _qftt2sac _1yk92sac _gdmb2sac _pmm42sac _y2mvdfik _1bg41l7b _6tjkdfik _awqn1l7b _1rvql4ek _1p9jrsbi _x2tz1q28 _1iwz1q28 _sj8yr01l _jcko12kk _1dvdrsbi _60ak5w2r",
                    (0, $dh538.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $56d63ff022409480$var$Radio = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($56d63ff022409480$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $56d63ff022409480$export$2e2bcd8739ae039 = $56d63ff022409480$var$Radio;
module.exports["default"] = $56d63ff022409480$export$2e2bcd8739ae039;

});

parcelRegister("jwcwi", function(module, exports) {
/* progress-tracker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cWhfY = parcelRequire("cWhfY");


var $f7TWP = parcelRequire("f7TWP");

const $1a8d06d25fc8b317$var$containerStyles = null;
const $1a8d06d25fc8b317$var$spacingOptions = {
    comfortable: "var(--ds-space-500, 40px)",
    cozy: "var(--ds-space-200, 16px)",
    // @deprecated left for backwards compatibility
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
/**
 * __Progress tracker__
 *
 * A progress tracker displays the steps and progress through a journey.
 *
 * - [Examples](https://atlassian.design/components/progress-tracker/examples)
 * - [Code](https://atlassian.design/components/progress-tracker/code)
 * - [Usage](https://atlassian.design/components/progress-tracker/usage)
 */ const $1a8d06d25fc8b317$var$ProgressTracker = ({ items: items = [], spacing: spacing = 'cozy', render: render = {
    link: ({ item: item })=>// Anchor content is coming from another location
        // eslint-disable-next-line @atlassian/a11y/anchor-has-content
        /*#__PURE__*/ (0, $l998X.jsx)((0, $cWhfY.default), {
            ...item
        })
}, animated: animated = true, testId: testId, label: label = 'Progress' })=>{
    const prevItems = (0, $42omo.useRef)(items.map((stage)=>({
            ...stage,
            percentageComplete: 0
        })));
    const previousStages = items.map((stage)=>{
        const oldStage = prevItems.current?.find((st)=>st.id === stage.id);
        return !!oldStage ? oldStage : stage;
    });
    (0, $42omo.useEffect)(()=>{
        prevItems.current = items;
    }, [
        items
    ]);
    const progressChanges = items.filter((stage, index)=>stage.percentageComplete !== previousStages[index].percentageComplete).length;
    const totalStepsForward = items.filter((stage, index)=>stage.percentageComplete > previousStages[index].percentageComplete).length;
    const totalStepsBack = items.filter((stage, index)=>stage.percentageComplete < previousStages[index].percentageComplete).length;
    let stepsForward = totalStepsForward;
    let stepsBack = totalStepsBack;
    const progressItems = items.map((stage, index)=>{
        let transitionSpeed = 0;
        let transitionDelay = 0;
        const transitionEasing = progressChanges > 1 ? 'linear' : 'cubic-bezier(0.15,1,0.3,1)';
        if (animated) {
            transitionSpeed = progressChanges > 1 ? 50 : 300;
            if (stage.percentageComplete < previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially in reverse.
         */ transitionDelay = (stepsBack - 1) * transitionSpeed;
                stepsBack -= 1;
            } else if (stage.percentageComplete > previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially.
         */ transitionDelay = (totalStepsForward - stepsForward) * transitionSpeed;
                stepsForward -= 1;
            }
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $f7TWP.default), {
            transitionSpeed: transitionSpeed,
            transitionDelay: transitionDelay,
            transitionEasing: transitionEasing,
            item: stage,
            render: render
        }, stage.id);
    });
    const listInlineStyles = {
        gridTemplateColumns: `repeat(${items.length}, 1fr)`,
        ['--ds--pt--sp']: $1a8d06d25fc8b317$var$spacingOptions[spacing],
        maxWidth: 80 * items.length * 2
    };
    return /*#__PURE__*/ (0, $l998X.jsx)("ol", {
        "data-testid": testId,
        style: listInlineStyles,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _zulp6odm _1e0c11p5 _1bsb1osq _2mzuglyw _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _rxvc1jfw"
        ]),
        children: progressItems
    });
};
var $1a8d06d25fc8b317$export$2e2bcd8739ae039 = $1a8d06d25fc8b317$var$ProgressTracker;
module.exports["default"] = $1a8d06d25fc8b317$export$2e2bcd8739ae039;

});

parcelRegister("cWhfY", function(module, exports) {
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $auNCB = parcelRequire("auNCB");

const $e073ee697483df67$var$styles = {
    anchor: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _11c81kw7 _syazi7uo _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
/**
 * __Progress tracker link__
 */ const $e073ee697483df67$var$Link = ({ href: href, onClick: onClick, label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        xcss: $e073ee697483df67$var$styles.anchor,
        // TODO: We should not be rendering empty hrefs on anchors. This should be plain text or a button/pressable if `onClick` is provided.
        href: href || '',
        onClick: onClick,
        testId: testId,
        children: label
    });
};
var $e073ee697483df67$export$2e2bcd8739ae039 = $e073ee697483df67$var$Link;
module.exports["default"] = $e073ee697483df67$export$2e2bcd8739ae039;

});

parcelRegister("f7TWP", function(module, exports) {
/* stage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1kaTo = parcelRequire("1kaTo");


var $gdv5Z = parcelRequire("gdv5Z");


var $3rSKm = parcelRequire("3rSKm");


var $kEBXJ = parcelRequire("kEBXJ");

function $711efba874fede10$var$_defineProperty(e, r, t) {
    return (r = $711efba874fede10$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $711efba874fede10$var$_toPropertyKey(t) {
    var i = $711efba874fede10$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $711efba874fede10$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $711efba874fede10$var$styles = {
    listItemContent: "_1bsb1osq _kqswh2mm"
};
const $711efba874fede10$var$textColor = {
    unvisited: "_syaz1rpy",
    current: "_syaz1oa5",
    visited: "_syazi7uo",
    disabled: "_syaz1gmx"
};
const $711efba874fede10$var$fontWeight = {
    unvisited: "_k48pi7a9",
    current: "_k48pmoej",
    visited: "_k48pmoej",
    disabled: "_k48pmoej"
};
const $711efba874fede10$var$getMarkerColor = ({ status: status, percentageCompleted: percentageCompleted })=>{
    switch(status){
        case 'unvisited':
            return "var(--ds-icon-subtle, #505258)";
        case 'current':
        case 'visited':
            return "var(--ds-icon-brand, #1868DB)";
        case 'disabled':
            if (percentageCompleted === 0) return "var(--ds-icon-disabled, #080F214A)";
             // If the percentage completed is greater than 0, we show the brand colour, so that the marker (circle) blends in with the progress bar.
            // Otherwise, the grey marker would be visible within the progress bar.
            return "var(--ds-icon-brand, #1868DB)";
        default:
            return;
    }
};
const $711efba874fede10$var$listItemStyles = null;
const $711efba874fede10$var$titleStyles = null;
class $711efba874fede10$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    UNSAFE_componentWillMount() {
        this.setState({
            ...this.state,
            transitioning: true
        });
    }
    UNSAFE_componentWillReceiveProps() {
        this.setState({
            ...this.state,
            transitioning: true
        });
    }
    shouldShowLink() {
        return this.props.item.status === 'visited' && // TODO: `noLink` is unnecessary as we should just be detecting if the `href` is set...
        !this.props.item.noLink;
    }
    render() {
        const { item: item, render: render, transitionDelay: transitionDelay, transitionSpeed: transitionSpeed, transitionEasing: transitionEasing, testId: testId } = this.props;
        const ariaCurrent = item.status === 'current' ? 'step' : 'false';
        const listInlineStyles = {
            ['--ds--pt--ts']: `${transitionSpeed}ms`,
            ['--ds--pt--td']: `${transitionDelay}ms`,
            ['--ds--pt--te']: transitionEasing,
            ['--ds--pt--mc']: this.state.oldMarkerColor,
            ['--ds--pt--bg']: $711efba874fede10$var$getMarkerColor({
                status: item.status,
                percentageCompleted: item.percentageComplete
            }),
            listStyleType: 'none'
        };
        return /*#__PURE__*/ (0, $l998X.jsx)("li", {
            "data-testid": testId,
            style: listInlineStyles,
            "aria-current": ariaCurrent,
            className: (0, $gMc0m.default)([
                "_6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1i4q1hna"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $711efba874fede10$var$styles.listItemContent,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1kaTo.default), {
                        appear: true,
                        in: this.state.transitioning,
                        onEntered: this.onEntered,
                        timeout: transitionDelay + transitionSpeed,
                        classNames: "fade",
                        nodeRef: this.nodeRefMarker,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kEBXJ.default), {
                            testId: testId && `${testId}-marker`
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1kaTo.default), {
                        appear: true,
                        in: this.state.transitioning,
                        onEntered: this.onEntered,
                        timeout: transitionDelay + transitionSpeed,
                        classNames: "fade",
                        nodeRef: this.nodeRefBar,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3rSKm.default), {
                            testId: testId && `${testId}-bar`,
                            percentageComplete: item.percentageComplete
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1kaTo.default), {
                        appear: true,
                        in: this.state.transitioning,
                        onEntered: this.onEntered,
                        timeout: transitionDelay + transitionSpeed,
                        classNames: "fade",
                        nodeRef: this.nodeRefTitle,
                        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            "data-testid": testId && `${testId}-title`,
                            className: (0, $gMc0m.default)([
                                "_11c82smr _v564ph28 _1pfhv47k _y3gn1h6o _1t9yph28 _1ez2kb7n _1uuw17dr",
                                $711efba874fede10$var$textColor[item.status],
                                $711efba874fede10$var$fontWeight[item.status]
                            ]),
                            children: this.shouldShowLink() ? render.link({
                                item: item
                            }) : item.label
                        })
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        $711efba874fede10$var$_defineProperty(this, "nodeRefMarker", /*#__PURE__*/ (0, $42omo.createRef)());
        $711efba874fede10$var$_defineProperty(this, "nodeRefBar", /*#__PURE__*/ (0, $42omo.createRef)());
        $711efba874fede10$var$_defineProperty(this, "nodeRefTitle", /*#__PURE__*/ (0, $42omo.createRef)());
        $711efba874fede10$var$_defineProperty(this, "onEntered", ()=>{
            this.setState({
                transitioning: false,
                oldMarkerColor: $711efba874fede10$var$getMarkerColor({
                    status: this.props.item.status,
                    percentageCompleted: this.props.item.percentageComplete
                }),
                oldPercentageComplete: this.props.item.percentageComplete
            });
        });
        this.state = {
            transitioning: false,
            oldMarkerColor: $711efba874fede10$var$getMarkerColor({
                status: this.props.item.status,
                percentageCompleted: this.props.item.percentageComplete
            }),
            oldPercentageComplete: 0
        };
    }
}
module.exports["default"] = $711efba874fede10$export$2e2bcd8739ae039;

});

parcelRegister("1kaTo", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $4tRVV = parcelRequire("4tRVV");



var $8Z1sH = parcelRequire("8Z1sH");


var $2vY2J = parcelRequire("2vY2J");


var $42omo = parcelRequire("42omo");


var $7uLCZ = parcelRequire("7uLCZ");



var $dlky5 = parcelRequire("dlky5");

var $0f701bba444d03b3$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $8Z1sH.default)(node, c);
    });
};
var $0f701bba444d03b3$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $2vY2J.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $0f701bba444d03b3$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $dlky5.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $0f701bba444d03b3$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $0f701bba444d03b3$var$removeClass(node, baseClassName);
        if (activeClassName) $0f701bba444d03b3$var$removeClass(node, activeClassName);
        if (doneClassName) $0f701bba444d03b3$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $bDniu.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7uLCZ.default), (0, $7Q5yr.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
$0f701bba444d03b3$var$CSSTransition.defaultProps = {
    classNames: ''
};
$0f701bba444d03b3$var$CSSTransition.propTypes = {};
var $0f701bba444d03b3$export$2e2bcd8739ae039 = $0f701bba444d03b3$var$CSSTransition;
module.exports["default"] = $0f701bba444d03b3$export$2e2bcd8739ae039;

});

parcelRegister("8Z1sH", function(module, exports) {
$parcel$export(module.exports, "default", () => $68a5278fcaf5b873$export$2e2bcd8739ae039);

var $4VBb5 = parcelRequire("4VBb5");

function $68a5278fcaf5b873$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $4VBb5.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});

parcelRegister("4VBb5", function(module, exports) {
$parcel$export(module.exports, "default", () => $39695305b192572b$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $39695305b192572b$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});

parcelRegister("2vY2J", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d4d0d5605c08ce5$export$2e2bcd8739ae039);
function $1d4d0d5605c08ce5$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $1d4d0d5605c08ce5$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $1d4d0d5605c08ce5$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $1d4d0d5605c08ce5$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});

parcelRegister("3rSKm", function(module, exports) {
/* bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $99e33e8128326caf$var$spacing = {
    comfortable: "var(--ds-space-500, 40px)",
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
const $99e33e8128326caf$var$progressBarStyles = null; /**
                                 * __Progress bar__
                                 *
                                 * A progress bar describes the horizontal tracking bar that traverses each individual step.
                                 *
                                 */ 
const $99e33e8128326caf$var$ProgressBar = ({ percentageComplete: percentageComplete, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        style: {
            width: `calc(${percentageComplete}% + ${percentageComplete / 100} * calc(var(--ds--pt--sp, ${$99e33e8128326caf$var$spacing.cosy}) + ${"var(--ds-space-050, 4px)"}))`
        },
        className: (0, $gMc0m.default)([
            "_v564d86a _4t3iu2gc _kqswstnw _bfhk1856 _1einu2gc _5fbcu2gc _1e021ssb _t9ecymk3 _1lww1oqq"
        ])
    });
var $99e33e8128326caf$export$2e2bcd8739ae039 = $99e33e8128326caf$var$ProgressBar;
module.exports["default"] = $99e33e8128326caf$export$2e2bcd8739ae039;

});

parcelRegister("kEBXJ", function(module, exports) {
/* marker.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $abb2296c785e715e$var$progressMarkerStyles = null; /**
                                    * __Progress marker__
                                    *
                                    * Similar to `@atlaskit/progress-indicator`, a small visual circle marker
                                    */ 
const $abb2296c785e715e$var$ProgressMarker = ({ testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_2rkou2gc _v5645rui _1bsbu2gc _4t3iu2gc _kqswstnw _bfhkr3ku _1e021ssb _t9ec157a _1lww1oqq _1uuw17dr _1ez2kb7n _1190pbrw _1ia8r3ku"
        ])
    });
var $abb2296c785e715e$export$2e2bcd8739ae039 = $abb2296c785e715e$var$ProgressMarker;
module.exports["default"] = $abb2296c785e715e$export$2e2bcd8739ae039;

});

parcelRegister("gYmGc", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3wBuN = parcelRequire("3wBuN");


var $2Pg7f = parcelRequire("2Pg7f");

const $1e910fe72e775768$export$29beada2d5f93289 = ({ data: data, ...props })=>{
    const { data: customData, overrides: customOverrides } = (0, $42omo.useMemo)(()=>$1e910fe72e775768$export$bc55c1ff86d63c4d({
            data: data
        }), [
        data
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Pg7f.default), {
        maxCount: 999,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        tooltipPosition: "top",
        size: "small",
        onMoreClick: ()=>{},
        ...props
    });
};
const $1e910fe72e775768$var$MAX_AVATARS_FEATURED = 2;
const $1e910fe72e775768$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED = 99;
const $1e910fe72e775768$var$OVERFLOW_USER_MARKER = '$$$overflow-user-marker';
const $1e910fe72e775768$export$bc55c1ff86d63c4d = ({ data: users })=>{
    const overflows = users.length > $1e910fe72e775768$var$MAX_AVATARS_FEATURED;
    const lastFeaturedUser = $1e910fe72e775768$var$MAX_AVATARS_FEATURED - 1;
    const featuredUsers = users.slice(0, lastFeaturedUser);
    const overflowUsers = users.slice(lastFeaturedUser);
    const overflowMarkerDummyUser = $1e910fe72e775768$export$1b8d8867a2d1ffbd(overflowUsers);
    const processedUsers = overflows ? [
        ...featuredUsers,
        overflowMarkerDummyUser
    ] : users;
    const overrides = {
        Avatar: {
            render: (AvatarComponent, avatarProps)=>{
                if (avatarProps.name === overflowMarkerDummyUser.name && avatarProps.key === overflowMarkerDummyUser.key) return $1e910fe72e775768$var$renderAvatarWithOverflowCount(AvatarComponent, avatarProps, overflowUsers.length);
                return /*#__PURE__*/ (0, $l998X.jsx)(AvatarComponent, {
                    ...avatarProps
                });
            }
        }
    };
    return {
        overrides: overrides,
        data: processedUsers
    };
};
const $1e910fe72e775768$export$1b8d8867a2d1ffbd = (overflowUsers)=>({
        name: overflowUsers.map((u)=>u.name).join(', '),
        key: $1e910fe72e775768$var$OVERFLOW_USER_MARKER
    });
const $1e910fe72e775768$var$renderAvatarWithOverflowCount = (AvatarComponent, avatarProps, overflowCount)=>/*#__PURE__*/ (0, $l998X.jsx)(AvatarComponent, {
        name: avatarProps.name,
        appearance: avatarProps.appearance,
        size: avatarProps.size,
        borderColor: avatarProps.borderColor,
        stackIndex: 0,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3wBuN.AvatarContent), {
            children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_4cvr1h6o _6a6z1h6o _11c81o8v _1bsb1osq _4t3i1osq _1e0c11p5 _bfhki8nm _syazi7uo _y3gn1h6o _k48p1wq8"
                ]),
                children: `+${Math.min(overflowCount, $1e910fe72e775768$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED)}`
            })
        })
    });
const $1e910fe72e775768$var$avatarOverflowCountContainer = null;
module.exports["FlagCompatibleAvatarGroup"] = $1e910fe72e775768$export$29beada2d5f93289;

});

parcelRegister("btHGY", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $fKV6c = parcelRequire("fKV6c");

const $9af2e217c87bad78$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: props.children({
                loading: false,
                error: true
            })
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fKV6c.MediaImageWithMediaClient), {
            ...props
        })
    });
module.exports["MediaImageWithErrorBoundary"] = $9af2e217c87bad78$export$758a2fef95a29ad0;

});

parcelRegister("fKV6c", function(module, exports) {
/* mediaImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $7soXU = parcelRequire("7soXU");


var $k0QVR = parcelRequire("k0QVR");


var $dh538 = parcelRequire("dh538");

const $30e6950c7927d39d$var$copyDivStyles = null;
const $30e6950c7927d39d$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $k0QVR.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            children({
                loading: status === 'loading',
                error: status === 'error',
                data: status === 'succeeded' ? {
                    status: status,
                    src: preview?.dataURI
                } : undefined
            }),
            (0, $dh538.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: copyNodeRef,
                className: (0, $gMc0m.default)([
                    "_1e0cglyw"
                ])
            }),
            getSsrScriptProps && /*#__PURE__*/ (0, $l998X.jsx)("script", {
                ...getSsrScriptProps()
            })
        ]
    });
};
const $30e6950c7927d39d$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $42omo.useMemo)(()=>(0, $7soXU.withMediaClient)($30e6950c7927d39d$var$MediaImageBase), []);
    return /*#__PURE__*/ (0, $l998X.jsx)(MediaImageComponent, {
        ...props
    });
};
module.exports["MediaImageWithMediaClient"] = $30e6950c7927d39d$export$8acd7eecc88dfeb5;

});

parcelRegister("6FQwA", function(module, exports) {

var $kGZ7I = parcelRequire("kGZ7I");

const $fba4647064c9da0b$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $fba4647064c9da0b$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $fba4647064c9da0b$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $fba4647064c9da0b$export$9748efee331ec573 = (param)=>`${0, $kGZ7I.ROVO_PARAM_PREFIX}${$fba4647064c9da0b$export$fda91e425d265029(param)}`;
const $fba4647064c9da0b$export$f2888183a34644d4 = (param)=>{
    return $fba4647064c9da0b$export$858653b7ee3cbb17(param.replace((0, $kGZ7I.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $fba4647064c9da0b$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $fba4647064c9da0b$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $kGZ7I.ROVO_PARAM_PREFIX))) return;
        const paramKey = $fba4647064c9da0b$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $fba4647064c9da0b$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $fba4647064c9da0b$var$processParams(q).rovoParams;
    } catch  {
        return {};
    }
};
const $fba4647064c9da0b$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $fba4647064c9da0b$export$ef04687636c850fe(window.location.pathname, params));
};
const $fba4647064c9da0b$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $fba4647064c9da0b$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $fba4647064c9da0b$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $fba4647064c9da0b$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$fba4647064c9da0b$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).filter(([_, value])=>value !== undefined).map(([key, value])=>{
        return `${$fba4647064c9da0b$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $fba4647064c9da0b$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $fba4647064c9da0b$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $kGZ7I.ROVO_VALID_PARAMS).map((param)=>`${$fba4647064c9da0b$export$9748efee331ec573(param)}${suffix}`);
};
module.exports["getRovoParams"] = $fba4647064c9da0b$export$6405071f390601f7;
module.exports["updatePageRovoParams"] = $fba4647064c9da0b$export$4a302fc7d977f7b3;
module.exports["addRovoParamsToUrl"] = $fba4647064c9da0b$export$ef04687636c850fe;
module.exports["encodeRovoParams"] = $fba4647064c9da0b$export$eddc20a009406015;

});

parcelRegister("kGZ7I", function(module, exports) {
const $0075612de7c1f282$export$5a550907ffbc9119 = 'rovoChat';
const $0075612de7c1f282$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt'
];
module.exports["ROVO_PARAM_PREFIX"] = $0075612de7c1f282$export$5a550907ffbc9119;
module.exports["ROVO_VALID_PARAMS"] = $0075612de7c1f282$export$3cd6b610e7ede579;

});

parcelRegister("7pmZw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $4u5NT = parcelRequire("4u5NT");


var $9tntP = parcelRequire("9tntP");


var $j2DyP = parcelRequire("j2DyP");


var $1yaYZ = parcelRequire("1yaYZ");


var $kIvLT = parcelRequire("kIvLT");


var $16lEl = parcelRequire("16lEl");

var $5057c1add7d5531a$var$_ExperienceTrackerHandler;
const $5057c1add7d5531a$var$isRovoInstrumentedError = (error)=>error && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
class $5057c1add7d5531a$var$ExperienceTrackerHandler {
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$5057c1add7d5531a$var$ExperienceTrackerHandler.instance) $5057c1add7d5531a$var$ExperienceTrackerHandler.instance = new $5057c1add7d5531a$var$ExperienceTrackerHandler();
        return $5057c1add7d5531a$var$ExperienceTrackerHandler.instance;
    }
    static setLabelStack(labelStack) {
        $5057c1add7d5531a$var$ExperienceTrackerHandler.labelStack = labelStack;
    }
    constructor(){
        this.experienceTracker = new (0, $9tntP.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        this.experienceTracker.subscribe((event)=>{
            let filteredErrorAttributes = {};
            let preventSendingLogException = false;
            // for FailEvent
            if ('error' in event) {
                // do not fail experience tracking if the error is a client fetch error
                if ((0, $j2DyP.isClientFetchError)(event.error)) preventSendingLogException = true;
                if (event.attributes) {
                    const { webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled } = event.attributes;
                    if (webSearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        webSearchEnabled: webSearchEnabled
                    };
                    if (deepResearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        deepResearchEnabled: deepResearchEnabled
                    };
                    if (thinkDeeperEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        thinkDeeperEnabled: thinkDeeperEnabled
                    };
                }
                if ($5057c1add7d5531a$var$isRovoInstrumentedError(event.error)) {
                    const errorAttributes = event.error.errorAttributes;
                    // Remove undefined properties
                    filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([, value])=>value !== undefined));
                }
                if (!preventSendingLogException) {
                    const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                    const attributes = event.attributes;
                    // this is added by `useExperienceTracker` below
                    const touchpointSource = attributes?.touchpointSource;
                    const teamName = attributes?.teamName;
                    const { traceId: traceIdFromErrorObject, ...filteredErrorAttributesRest } = filteredErrorAttributes;
                    const altTraceId = attributes?.traceId || traceIdFromErrorObject;
                    (0, $1yaYZ.logException)({
                        exception: error,
                        name: event.name,
                        tags: {
                            source: 'aiMateExperienceTracker',
                            ...filteredErrorAttributesRest,
                            ...touchpointSource && {
                                touchpointSource: touchpointSource
                            },
                            ...teamName && {
                                teamName: teamName
                            },
                            // Rename traceId to atlTraceId if present in attributes to distinguish from Sentry's Trace ID
                            ...altTraceId && {
                                altTraceId: altTraceId
                            }
                        }
                    });
                }
            }
            if (event.action === 'taskSuccess' || event.action === 'taskFail' || event.action === 'taskAbort') // the experience tracker already uses performance.now() to calculate the duration, so we can just piggyback on that,
            // we will loose some precision due to rounding of duration, but it's good enough for our purposes
            (0, $4u5NT.addSpanToAll)('custom', `exp-${event.name}`, $5057c1add7d5531a$var$ExperienceTrackerHandler.labelStack, event.startTime, event.startTime + event.duration);
            this.sendAnalyticsEvent?.({
                eventType: 'operational',
                action: event.action,
                actionSubject: 'ui',
                attributes: {
                    task: event.name,
                    taskId: event.id,
                    startTime: event.startTime,
                    // Only add duration if event is SuccessEvent or FailEvent
                    ...(event.action === 'taskSuccess' || event.action === 'taskFail') && {
                        duration: event.duration
                    },
                    ...event.action === 'taskFail' && {
                        error: event.error.message,
                        ...filteredErrorAttributes
                    },
                    ...event.attributes
                }
            }, {
                removeDefaultTags: true
            });
        });
    }
}
$5057c1add7d5531a$var$_ExperienceTrackerHandler = $5057c1add7d5531a$var$ExperienceTrackerHandler;
$5057c1add7d5531a$var$ExperienceTrackerHandler.instance = void 0;
$5057c1add7d5531a$var$ExperienceTrackerHandler.labelStack = [];
const $5057c1add7d5531a$export$63af6e7bbb4f375d = ()=>{
    return (0, $42omo.useCallback)((componentLabelStack)=>{
        $5057c1add7d5531a$var$ExperienceTrackerHandler.setLabelStack(componentLabelStack);
    }, []);
};
const $5057c1add7d5531a$export$412c53791574f6f0 = (params)=>{
    (0, $fBMbo.di)((0, $kIvLT.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent, mode: conversationAssistantUIMode } = (0, $kIvLT.useAnalytics)();
    const getNameOverride = (0, $42omo.useCallback)((name)=>{
        switch(conversationAssistantUIMode){
            case 'mini-modal':
                return `${name}.${(0, $16lEl.ExperienceNamePostfix).MINI_MODAL}`;
            default:
                return name;
        }
    }, [
        conversationAssistantUIMode
    ]);
    (0, $42omo.useMemo)(()=>{
        const experienceTracker = $5057c1add7d5531a$var$ExperienceTrackerHandler.getInstance();
        // this is not ideal, okay just because `sendAnalyticsEvent` is never change
        // since every hook instance will override the singleton sendAnalyticsEvent
        experienceTracker.setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        sendAnalyticsEvent
    ]);
    const experienceTrackerProxy = (0, $42omo.useMemo)(()=>{
        const proxyHandler = {
            get: (target, prop)=>{
                // Overriding the experienceTracker target methods to add additional attributes
                if (prop === 'fail') return (failParams)=>{
                    target.fail({
                        ...failParams,
                        attributes: {
                            ...failParams.attributes,
                            name: !!failParams.name ? getNameOverride(failParams.name) : failParams.name,
                            touchpointSource: params?.touchpointSource,
                            teamName: failParams.teamName
                        }
                    });
                };
                if (prop === 'succeed') return (succeedParams)=>{
                    target.succeed({
                        ...succeedParams,
                        name: !!succeedParams.name ? getNameOverride(succeedParams.name) : succeedParams.name,
                        attributes: {
                            ...succeedParams.attributes,
                            touchpointSource: params?.touchpointSource
                        }
                    });
                };
                if (prop === 'start') return (startParams)=>{
                    target.start({
                        ...startParams,
                        name: !!startParams.name ? getNameOverride(startParams.name) : startParams.name
                    });
                };
                if (prop === 'abort') return (abortParams)=>{
                    target.abort({
                        ...abortParams,
                        name: !!abortParams.name ? getNameOverride(abortParams.name) : abortParams.name
                    });
                };
                if (prop === 'stopOnError') return (stopOnErrorParams)=>{
                    target.stopOnError({
                        ...stopOnErrorParams,
                        name: !!stopOnErrorParams.name ? getNameOverride(stopOnErrorParams.name) : stopOnErrorParams.name
                    });
                };
                return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
            }
        };
        return new Proxy($5057c1add7d5531a$var$ExperienceTrackerHandler.getInstance().experienceTracker, proxyHandler);
    }, [
        params?.touchpointSource,
        getNameOverride
    ]);
    return experienceTrackerProxy;
};
module.exports["useUFOLabelStackSetter"] = $5057c1add7d5531a$export$63af6e7bbb4f375d;
module.exports["useAIMateExperienceTracker"] = $5057c1add7d5531a$export$412c53791574f6f0;

});

parcelRegister("j2DyP", function(module, exports) {
// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Issues we are not gonna track in Sentry
const $3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_LIMITED = [
    'server with the specified hostname could not be found',
    'connection failure',
    'Failed to fetch',
    'Network request failed',
    'NetworkError',
    'network error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted'
];
const $3c7c331d93a4dcee$var$isClientFetchErrorMessage = (message)=>{
    const errorTypes = $3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_LIMITED;
    return Boolean(message) && !!errorTypes.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
};
const $3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $3c7c331d93a4dcee$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name) || $3c7c331d93a4dcee$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || $3c7c331d93a4dcee$var$isClientFetchErrorMessage(error.cause.message)));
module.exports["isClientFetchError"] = $3c7c331d93a4dcee$export$2e7adc44463c3f4f;

});

parcelRegister("1yaYZ", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $mbtR9 = parcelRequire("mbtR9");


var $j2DyP = parcelRequire("j2DyP");


var $35fh0 = parcelRequire("35fh0");


var $ldpU6 = parcelRequire("ldpU6");


// importing local file instead of from '@sentry/browser' otherwise there will be typescript errors
const $26a7abafe1ae99d6$var$importSentryAsync = async ()=>(parcelRequire("qPf6L"));
let $26a7abafe1ae99d6$var$sentryClient;
// copied from platform/packages/people-and-teams/teams-client/src/services/sentry/utils/initialise-sentry.ts
const $26a7abafe1ae99d6$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
const $26a7abafe1ae99d6$var$getEnvironment = ()=>{
    return 'production';
};
const $26a7abafe1ae99d6$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride, ignoreErrors: ignoreErrors } = {})=>{
    let accountId = 'UNKNOWN_AAID';
    let product = productOverride ?? (0, $35fh0.getRovoChatProduct)();
    try {
        const profileData = await (0, $mbtR9.performHttpFetch)({
            path: '/gateway/api/me',
            options: {
                method: 'GET'
            }
        });
        if (profileData?.account_id) accountId = profileData.account_id;
    } catch  {
    // do nothing
    }
    if ($26a7abafe1ae99d6$var$sentryClient) {
        // if sentry is trying to be initialized again with new product or account id
        // update the user and tags
        $26a7abafe1ae99d6$var$sentryClient.setTag('product', product);
        $26a7abafe1ae99d6$var$sentryClient.setUser({
            id: accountId
        });
        // do not initialise sentry again, only update the existing one
        return;
    }
    let importedSentry;
    try {
        importedSentry = await $26a7abafe1ae99d6$var$importSentryAsync();
    } catch (e) {
        console.warn('Failed to load conversation-assistant sentry', e); // eslint-disable-line no-console
        return;
    }
    // https://atlassian-2y.sentry.io/projects/ai-mate-conversation-assistant/getting-started/
    const defaultSentryDsn = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
    importedSentry.init({
        dsn: customSentryDsn || defaultSentryDsn,
        environment: $26a7abafe1ae99d6$var$getEnvironment(),
        integrations: (integrations)=>{
            return integrations.filter((integration)=>{
                return $26a7abafe1ae99d6$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        },
        initialScope: {
            user: {
                id: accountId
            },
            tags: {
                packageName: packageName || '@atlassian/conversation-assistant',
                product: product
            }
        },
        // referencing jira/src/packages/platform/observability/errors-handling/src/utils/sentry/handling/normalise-sentry-event.tsx
        beforeSend: (event, hint)=>{
            const exception = hint?.originalException;
            // Ignore network-like errors
            if ((0, $j2DyP.isClientFetchError)(exception)) return null;
            if (!event.tags?.name) // we only want to capture errors that has `name` tag from `logException` function below
            // since the `DISABLED_INTEGRATIONS` filter above is not enough to prevent unhandled errors
            return null;
            let updatedEvent = event;
            if (updatedEvent.request?.url) {
                // Ignore events from localhost and staging
                if (updatedEvent.request.url.includes('localhost') || updatedEvent.request.url.includes('jira-dev.com') || updatedEvent.request.url.includes('stg.atlassian.com') || updatedEvent.request.url.includes('stg.internal.atlassian.com') || updatedEvent.request.url.includes('stg-east.frontend.public.atl-paas.net')) return null;
                updatedEvent.request.url = (0, $ldpU6.normaliseUrl)(updatedEvent.request.url);
            }
            if (updatedEvent.exception?.values) {
                const allMatchedUUIDs = [];
                updatedEvent.exception.values = updatedEvent.exception.values.map((exception)=>{
                    const { normalized: normalized, matchedUUIDs: matchedUUIDs } = (0, $ldpU6.normalizeUUID)(exception.value);
                    allMatchedUUIDs.push(...matchedUUIDs);
                    return {
                        ...exception,
                        value: normalized
                    };
                });
                if (allMatchedUUIDs.length > 0) {
                    if (!updatedEvent.tags) updatedEvent.tags = {};
                    updatedEvent.tags.matchedUUID = JSON.stringify(allMatchedUUIDs);
                }
            }
            return updatedEvent;
        },
        attachStacktrace: true,
        ignoreErrors: ignoreErrors
    });
    $26a7abafe1ae99d6$var$sentryClient = importedSentry;
};
const $26a7abafe1ae99d6$var$getSentryClient = async ()=>{
    if (!$26a7abafe1ae99d6$var$sentryClient) // this only happens if something using sentry before the initialisation in root app
    await $26a7abafe1ae99d6$export$d8bd0edf6c978788();
    return $26a7abafe1ae99d6$var$sentryClient;
};
const $26a7abafe1ae99d6$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    const sentryClient = await $26a7abafe1ae99d6$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        scope.setTag('name', name);
        if (tags) scope.setTags(tags);
        if (tags?.source === 'aiMateExperienceTracker') {
            scope.setTag('experience', name);
            // temporary limiting to one experience for testing.
            if (name === 'aiMateFetchChat' && (0, $dh538.fg)('rovo_sentry_issues_grouping_by_experience')) {
                // Use the experience name (which is the `name` parameter) as the primary grouping dimension
                const fingerprint = [
                    name
                ];
                if (exception instanceof Error) fingerprint.push(exception.name);
                scope.setFingerprint(fingerprint);
            }
        }
        sentryClient.captureException(exception, scope);
    });
};
module.exports["setupSentryClient"] = $26a7abafe1ae99d6$export$d8bd0edf6c978788;
module.exports["logException"] = $26a7abafe1ae99d6$export$f86b2a1a2ce291b3;

});

parcelRegister("mbtR9", function(module, exports) {
// Copied code from conversation-assistant-service/src/common/utils/fetch.ts

var $kU4HV = parcelRequire("kU4HV");


var $hdasn = parcelRequire("hdasn");

/**
 * Copy of this also exists in `conversation-assistant-service/src/common/utils/fetch.ts`
 */ class $94b2983c0cc6d0d2$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $94b2983c0cc6d0d2$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $94b2983c0cc6d0d2$var$processHttpErrorResponse({
            response: response
        });
        return await response.json();
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        throw new (0, $kU4HV.FetchError)(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError'
        });
    }
};
/**
 * Copy of this also exists in `conversation-assistant-service/src/common/utils/fetch.ts`
 */ const $94b2983c0cc6d0d2$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $94b2983c0cc6d0d2$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: (0, $hdasn.getTraceIdFromResponse)(response)
    });
};
module.exports["performHttpFetch"] = $94b2983c0cc6d0d2$export$a38d93aa782475f6;

});

parcelRegister("kU4HV", function(module, exports) {
class $f586bacb2ba5fb17$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
module.exports["FetchError"] = $f586bacb2ba5fb17$export$26e841bcf1aeb894;

});

parcelRegister("hdasn", function(module, exports) {
const $dafebd4c6eb967bf$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
module.exports["getTraceIdFromResponse"] = $dafebd4c6eb967bf$export$9f229e40eb65abfc;

});

parcelRegister("35fh0", function(module, exports) {
const $a3e3dc6fd5fb1937$export$d4fdfa93c283ffc = ()=>{
    let product = 'UNKNOWN';
    if (window && window.__ROVO_CHAT_CONFIG_PRODUCT__) product = window.__ROVO_CHAT_CONFIG_PRODUCT__;
    return product;
};
module.exports["getRovoChatProduct"] = $a3e3dc6fd5fb1937$export$d4fdfa93c283ffc;

});

parcelRegister("ldpU6", function(module, exports) {
const $62424571d4d73005$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $62424571d4d73005$var$ATLAS_HOST = 'home.atlassian.com';
const $62424571d4d73005$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $62424571d4d73005$var$UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $62424571d4d73005$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $62424571d4d73005$var$ATLAS_HOST || parsedUrl.host === $62424571d4d73005$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$62424571d4d73005$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};
const $62424571d4d73005$export$5efaf8444170fe75 = (str)=>{
    if (!str) return {
        normalized: '',
        matchedUUIDs: []
    };
    const matchedUUIDs = str.match($62424571d4d73005$var$UUID_REGEX) || [];
    const normalized = str.replace($62424571d4d73005$var$UUID_REGEX, '{uuid}');
    return {
        normalized: normalized,
        matchedUUIDs: matchedUUIDs
    };
};
module.exports["normaliseUrl"] = $62424571d4d73005$export$d57ae76c6dc57a5;
module.exports["normalizeUUID"] = $62424571d4d73005$export$5efaf8444170fe75;

});

parcelRegister("qPf6L", function(module, exports) {

let $050a2d8d335b8161$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $050a2d8d335b8161$var$load("hyqsV"),
    $050a2d8d335b8161$var$load("2KJHS")
]).then(()=>parcelRequire('3spmo'));

});

parcelRegister("2Cfy4", function(module, exports) {
const $0009c874b00d4f72$export$8849fb25713dbf70 = 'rovoLastClickedRecommendedAgent';
const $0009c874b00d4f72$export$73b400613798970e = 'rovo-agents-fe';
module.exports["LAST_CLICKED_RECOMMENDED_AGENT_KEY"] = $0009c874b00d4f72$export$8849fb25713dbf70;
module.exports["ROVO_AGENTS_FE_TEAM_NAME"] = $0009c874b00d4f72$export$73b400613798970e;

});

parcelRegister("6Vqkv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $fBMbo = parcelRequire("fBMbo");


var $irOoi = parcelRequire("irOoi");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $dh538 = parcelRequire("dh538");


var $aMqwg = parcelRequire("aMqwg");


var $16lEl = parcelRequire("16lEl");


var $flpNp = parcelRequire("flpNp");

var $h26dv = parcelRequire("h26dv");

var $ljUdP = parcelRequire("ljUdP");

var $9eLw5 = parcelRequire("9eLw5");


var $f2OFx = parcelRequire("f2OFx");


var $2Cfy4 = parcelRequire("2Cfy4");


var $ffpG2 = parcelRequire("ffpG2");


var $iswAx = parcelRequire("iswAx");


var $1uFMJ = parcelRequire("1uFMJ");


var $4ul15 = parcelRequire("4ul15");


var $hT0Hx = parcelRequire("hT0Hx");


var $37oID = parcelRequire("37oID");


var $cqFPV = parcelRequire("cqFPV");


var $ka7s2 = parcelRequire("ka7s2");

const $c0881cdb28f9c5e5$var$categoriseAgents = (agents)=>agents.reduce((categorisedAgents, agent)=>{
        if (agent.creator_type === 'SYSTEM') categorisedAgents.system.push(agent);
        else if (agent.visibility === 'PUBLIC') categorisedAgents.public.push(agent);
        else if (agent.visibility === 'PRIVATE') categorisedAgents.private.push(agent);
        else if (!agent.visibility && agent.creator_type === 'CUSTOMER') categorisedAgents.private.push(agent);
        return categorisedAgents;
    }, {
        public: [],
        private: [],
        system: []
    });
/**
 * @deprecated Please use `useAgentsPaginated...` hooks instead
 * @TODO move to different folder https://product-fabric.atlassian.net/browse/RAGE-1562
 */ const $c0881cdb28f9c5e5$var$agentsStore = (0, $1P1Tu.createStore)({
    initialState: {
        availableAgents: [],
        categorisedAgents: {
            private: [],
            public: [],
            system: []
        },
        agentsInitialized: false,
        agentsError: undefined
    },
    name: 'AgentsStore',
    actions: {
        setAgents: (availableAgents)=>({ setState: setState })=>{
                setState({
                    availableAgents: availableAgents,
                    categorisedAgents: $c0881cdb28f9c5e5$var$categoriseAgents(availableAgents)
                });
            },
        setAgentsInitialized: ()=>({ setState: setState })=>{
                setState({
                    agentsInitialized: true
                });
            },
        setAgentsError: (agentsError)=>({ setState: setState })=>{
                setState({
                    agentsError: agentsError
                });
            }
    }
});
/**
 * @deprecated Please use `useAgentsPaginated...` instead
 * @TODO move to different folder https://product-fabric.atlassian.net/browse/RAGE-1562
 */ const $c0881cdb28f9c5e5$var$useAgentsStore = (0, $9zUhf.createHook)($c0881cdb28f9c5e5$var$agentsStore);
const $c0881cdb28f9c5e5$export$f5b1109ecd7858c1 = (0, $h26dv.createHookWithAssistanceService)(({ onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, experienceId: experienceId, product: product, siteId: siteId, touchpointSource: touchpointSource } })=>{
    // TODO remove `isRovoEnabled`
    const { isRovoEnabled: isRovoEnabled } = (0, $aMqwg.useRovoEntitlement)();
    const { agentIdFiltersOverride: agentIdFiltersOverride, agentDefaultIdOverride: agentDefaultIdOverride } = (0, $hT0Hx.useAgentOverrider)();
    const [{ availableAgents: availableAgents, categorisedAgents: categorisedAgents, agentsInitialized: agentsInitialized, agentsError: agentsError }, { setAgents: setAgents, setAgentsInitialized: setAgentsInitialized, setAgentsError: setAgentsError }] = $c0881cdb28f9c5e5$var$useAgentsStore();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $4ul15.useAgentFavourites)({
        assistanceServiceParams: {
            experienceId: experienceId,
            product: product,
            siteId: siteId,
            touchpointSource: touchpointSource
        }
    });
    const favouritedAgents = availableAgents.filter((agent)=>agent.favourite);
    const defaultAgent = (0, $42omo.useMemo)(()=>availableAgents.find((agent)=>agent.is_default), [
        availableAgents
    ]);
    const nonDefaultAgents = (0, $42omo.useMemo)(()=>availableAgents.filter((agent)=>!agent.is_default), [
        availableAgents
    ]);
    const nonDefaultFavouriteAgents = (0, $42omo.useMemo)(()=>nonDefaultAgents.filter((agent)=>!agent.favourite), [
        nonDefaultAgents
    ]);
    const fetchAndStoreAvailableAgents = (0, $9eLw5.useQuery)({
        queryKey: [
            'fetchAgents'
        ],
        queryFn: async ()=>{
            try {
                experienceTracker.start({
                    id: (0, $16lEl.ExperienceName).FETCH_AGENTS,
                    name: (0, $16lEl.ExperienceName).FETCH_AGENTS
                });
                const agents = await assistanceService.getAgents();
                const transformedAgents = agents.map((agent)=>{
                    // Rename default agent to Chat, which is displayed in the UI
                    if (agent.is_default) {
                        agent.name = formatMessage((0, $ka7s2.default).defaultAgentName);
                        agent.description = formatMessage((0, $ka7s2.default).defaultAgentDescription);
                    }
                    return agent;
                });
                const overriddenAgents = (0, $37oID.getOverridenAgents)(transformedAgents, agentIdFiltersOverride, agentDefaultIdOverride);
                setAgents(overriddenAgents);
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).FETCH_AGENTS
                });
                setAgentsInitialized();
            } catch (error) {
                //Filter out HIPAA errors from experience tracker https://product-fabric.atlassian.net/browse/ROVOFE-543
                if ((0, $cqFPV.isHipaaError)(error)) {
                    experienceTracker.succeed({
                        name: (0, $16lEl.ExperienceName).FETCH_AGENTS
                    });
                    return;
                }
                if ((0, $ljUdP.isRateLimitedError)(error)) setAgentsError(error);
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).FETCH_AGENTS,
                    error: error
                });
                throw error;
            }
        },
        onError: onError,
        enabled: isRovoEnabled,
        refetchOnWindowFocus: false
    });
    const { deleteAgent: deleteAgent } = (0, $1uFMJ.useDeleteAgent)({
        onSuccess: ()=>{
            fetchAndStoreAvailableAgents.refetch();
        },
        assistanceServiceParams: {
            experienceId: experienceId,
            product: product,
            siteId: siteId,
            touchpointSource: touchpointSource
        },
        onInit: (id)=>{
            setAgents(availableAgents.filter((agent)=>agent.id !== id));
        },
        onError: ()=>{
            setAgents(availableAgents);
        }
    });
    const setFavouriteAgent = (0, $42omo.useCallback)(async (id, isFavourite)=>{
        const updatedAgent = availableAgents.find((a)=>a.id === id);
        const setUpdatedAgent = (shouldBeFavourite)=>{
            if (updatedAgent) {
                updatedAgent.favourite = shouldBeFavourite;
                setAgents(availableAgents.map((a)=>{
                    // If the current agent's id matches the new agent's id, return the new agent.
                    // Otherwise, return the current agent.
                    return a.id === updatedAgent.id ? updatedAgent : a;
                }));
            }
        };
        //Optimistically update favourite value before we mutate
        setUpdatedAgent(isFavourite);
        //Pass callback to roll back optimistic update if mutation fails
        const errorCallback = {
            onError: ()=>{
                setUpdatedAgent(!isFavourite);
            }
        };
        if (isFavourite) return await favouriteAgent.mutate(id, errorCallback);
        else return await unfavouriteAgent.mutate(id, errorCallback);
    }, [
        availableAgents,
        setAgents,
        favouriteAgent,
        unfavouriteAgent
    ]);
    /** This updates the agent on the client side only
   * Useful for updating the agent after a successful mutation
   */ const updateAgentLocally = (0, $42omo.useCallback)((agentId, updatedAgent)=>{
        const updatedAgents = availableAgents.map((agent)=>{
            if (agent.id === agentId) return {
                ...agent,
                ...updatedAgent
            };
            return agent;
        });
        setAgents(updatedAgents);
    }, [
        availableAgents,
        setAgents
    ]);
    return {
        availableAgents: availableAgents,
        favouritedAgents: favouritedAgents,
        categorisedAgents: categorisedAgents,
        fetchAndStoreAvailableAgents: fetchAndStoreAvailableAgents,
        deleteAgent: deleteAgent,
        setFavouriteAgent: setFavouriteAgent,
        defaultAgent: defaultAgent,
        agentsInitialized: agentsInitialized,
        nonDefaultAgents: nonDefaultAgents,
        nonDefaultFavouriteAgents: nonDefaultFavouriteAgents,
        updateAgentLocally: updateAgentLocally,
        agentsError: agentsError
    };
});
const $c0881cdb28f9c5e5$var$agentsPaginatedStore = (0, $1P1Tu.createStore)({
    initialState: {
        /*
    Hash map which is the source of truth for agent data
    agent categories simply hold the agent ids to perform a lookup
    */ agentsMap: {},
        loadingCategories: new Set(),
        agentCategories: {
            ['all-agents']: {
                agentIds: [],
                pageInfo: (0, $ffpG2.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['starred-agents']: {
                agentIds: [],
                pageInfo: (0, $ffpG2.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['my-agents']: {
                agentIds: [],
                pageInfo: (0, $ffpG2.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['templates']: {
                agentIds: [],
                pageInfo: (0, $ffpG2.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            }
        }
    },
    name: 'AgentsPaginatedStore',
    actions: {
        /**
     * This action populates a specific category with backend data
     * it will store the ids in `agentCategories` and the agents in `agentsMap`
     */ populateAgentCategories: ({ agentsList: agentsList, pageInfo: pageInfo, category: category = 'all-agents' })=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                updatedAgentCategories[category].pageInfo = pageInfo;
                if (!agentsList.length) updatedAgentCategories[category].agentIds = [];
                else agentsList.forEach((agent)=>{
                    updatedAgentsMap[agent.id] = agent;
                    updatedAgentCategories[category].agentIds.push(agent.id);
                });
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
            },
        setAgentCategoriesByCategory: ({ categoryName: categoryName, agentCategoryData: agentCategoryData })=>({ getState: getState, setState: setState })=>{
                const { agentCategories: agentCategories } = getState();
                const updatedAgentCategories = {
                    ...agentCategories,
                    [categoryName]: agentCategoryData
                };
                setState({
                    agentCategories: updatedAgentCategories
                });
            },
        setCategoryError: (categoryName, agentsError)=>({ getState: getState, setState: setState })=>{
                const { agentCategories: agentCategories } = getState();
                const updatedAgentCategories = {
                    ...agentCategories,
                    [categoryName]: {
                        ...agentCategories[categoryName],
                        agentsError: agentsError
                    }
                };
                setState({
                    agentCategories: updatedAgentCategories
                });
            },
        getAgentCategoriesByCategory: (category)=>({ getState: getState })=>{
                const state = getState();
                const { agentCategories: agentCategories } = state;
                return agentCategories[category];
            },
        removeAgent: (id)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const catsImpacted = new Set();
                let agentToReturn;
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                if (agentsMap[id]) {
                    agentToReturn = agentsMap[id];
                    delete updatedAgentsMap[id];
                }
                Object.keys(agentCategories).forEach((category)=>{
                    if (updatedAgentCategories[category]?.agentIds.includes(id)) {
                        updatedAgentCategories[category].agentIds = updatedAgentCategories[category].agentIds.filter((agentId)=>agentId !== id);
                        catsImpacted.add(category);
                    }
                });
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
                return {
                    agent: agentToReturn,
                    categories: Array.from(catsImpacted)
                };
            },
        addAgent: (agent, categories = [
            'all-agents'
        ])=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                categories.forEach((category)=>{
                    updatedAgentCategories?.[category]?.agentIds.push(agent.id);
                });
                updatedAgentsMap[agent.id] = agent;
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
            },
        updateAgent: (id, data)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const prevData = agentsMap[id] ?? {};
                const updatedData = {
                    ...prevData,
                    ...data
                };
                updatedAgentsMap[id] = updatedData;
                setState({
                    agentsMap: updatedAgentsMap
                });
                return updatedData;
            },
        setCategoryLoading: (category, loading)=>({ setState: setState, getState: getState })=>{
                const { loadingCategories: loadingCategories } = getState();
                const updatedLoadingCategories = new Set(loadingCategories);
                if (loading) updatedLoadingCategories.add(category);
                else updatedLoadingCategories.delete(category);
                setState({
                    loadingCategories: updatedLoadingCategories
                });
            },
        abortCategoryFetch: (category)=>({ getState: getState })=>{
                const { agentCategories: agentCategories } = getState();
                agentCategories[category].abortController.abort();
                agentCategories[category].abortController = new AbortController();
            },
        getCachedAgentByExternalConfigReference: (externalConfigReference)=>({ getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                return Object.values(agentsMap).find((agent)=>agent.external_config_reference === externalConfigReference);
            }
    }
});
const $c0881cdb28f9c5e5$export$1553678862324ff0 = (0, $9zUhf.createActionsHook)($c0881cdb28f9c5e5$var$agentsPaginatedStore);
const $c0881cdb28f9c5e5$export$cea603150faaa56f = (0, $9zUhf.createHook)($c0881cdb28f9c5e5$var$agentsPaginatedStore, {
    // TODO https://product-fabric.atlassian.net/browse/RAGE-618
    // change `{ agentId }` to `agentId`
    selector: (state, agentId)=>({
            agent: state.agentsMap[agentId],
            doesAgentExist: Boolean(state.agentsMap[agentId])
        })
});
const $c0881cdb28f9c5e5$export$44c2e95a7a8b47c9 = (0, $h26dv.createHookWithAssistanceService)(({ agentId: agentId, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    (0, $fBMbo.di)($c0881cdb28f9c5e5$export$44c2e95a7a8b47c9, $c0881cdb28f9c5e5$export$cea603150faaa56f, $c0881cdb28f9c5e5$export$1553678862324ff0);
    const [{ agent: agent, doesAgentExist: doesAgentExist }] = $c0881cdb28f9c5e5$export$cea603150faaa56f(agentId ?? '');
    const { updateAgent: updateAgent } = $c0881cdb28f9c5e5$export$1553678862324ff0();
    (0, $9eLw5.useQuery)({
        queryKey: [
            'agentHydration',
            agentId ?? ''
        ],
        queryFn: async ()=>{
            if (!agentId) // this throw won't happen because the `enabled` field below
            throw new Error('Agent ID is required');
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).HYDRATE_AGENT_DATA,
                id: (0, $16lEl.ExperienceName).HYDRATE_AGENT_DATA
            });
            const response = await assistanceService.getAgentDetails(agentId);
            return response;
        },
        enabled: Boolean(agentId) && !doesAgentExist,
        onSuccess: (data)=>{
            if (!agentId) return;
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).HYDRATE_AGENT_DATA
            });
            updateAgent(agentId ?? '', data);
        },
        onError: (error)=>{
            if (!agentId) return;
            if (error.errorAttributes.statusCode !== 404) experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).HYDRATE_AGENT_DATA,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
        }
    });
    if (!agentId) return {
        agent: undefined
    };
    return {
        agent: agent
    };
});
const $c0881cdb28f9c5e5$export$eae59c91509947e4 = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams })=>{
    const environment = (0, $dh538.fg)('browse_agents_use_relay') ? (0, $irOoi.useRelayEnvironment)() : null;
    const removedAgentCache = (0, $42omo.useRef)({
        categories: [],
        agent: undefined
    });
    const { removeAgent: removeAgent, addAgent: addAgent, updateAgent: updateAgent } = $c0881cdb28f9c5e5$export$1553678862324ff0();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $4ul15.useAgentFavourites)({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    // Note: Experience Tracker events implemented in useDeleteAgent
    const { deleteAgent: deleteAgent } = (0, $1uFMJ.useDeleteAgent)({
        assistanceServiceParams: assistanceServiceInjectedParams,
        onInit: (id)=>{
            const { categories: categories, agent: agent } = removeAgent(id);
            removedAgentCache.current = {
                categories: categories,
                agent: agent
            };
        },
        onError: ()=>{
            if (removedAgentCache.current.agent) addAgent(removedAgentCache.current.agent, removedAgentCache.current.categories);
        }
    });
    // Note: Experience Tracker events implemented in useAgentFavourites
    const setFavouriteAgent = (0, $42omo.useCallback)(async (id, favourite, agentAri)=>{
        // Optimistic update
        updateAgent(id, {
            favourite: favourite
        });
        const localRelayUpdate = async (isFavourite)=>{
            if (agentAri && environment && (0, $dh538.fg)('browse_agents_use_relay')) (0, $irOoi.commitLocalUpdate)(environment, (store)=>{
                const id = (0, $f2OFx.default)({
                    id: agentAri
                }, 'AgentStudioAssistant');
                if (!id) return;
                const agentRecord = store.get(id);
                if (agentRecord) agentRecord.setValue(isFavourite, 'isFavourite');
            });
        };
        localRelayUpdate(favourite);
        const errorCallback = {
            onError: ()=>{
                // Reverse optimistic update
                updateAgent(id, {
                    favourite: !favourite
                });
                localRelayUpdate(!favourite);
            }
        };
        if (favourite) return await favouriteAgent.mutate(id, errorCallback);
        else return await unfavouriteAgent.mutate(id, errorCallback);
    }, [
        environment,
        favouriteAgent,
        unfavouriteAgent,
        updateAgent
    ]);
    // Local cache update function for optimistic delete
    // This only handles cache updates, not API calls or analytics
    const deleteAgentLocally = (0, $42omo.useCallback)((id)=>{
        // Optimistically remove from cache
        const { categories: categories, agent: agent } = removeAgent(id);
        // Return restore function for error handling
        return {
            restore: ()=>{
                if (agent) addAgent(agent, categories);
            }
        };
    }, [
        removeAgent,
        addAgent
    ]);
    return {
        deleteAgent: deleteAgent,
        setFavouriteAgent: setFavouriteAgent,
        deleteAgentLocally: deleteAgentLocally
    };
});
const $c0881cdb28f9c5e5$export$cc3deb815b1c179b = (0, $9zUhf.createHook)($c0881cdb28f9c5e5$var$agentsPaginatedStore, {
    selector: (state, category)=>({
            agentsByCategory: state.agentCategories[category].agentIds.map((agentId)=>state.agentsMap[agentId]),
            isCategoryInitialized: state.agentCategories[category].pageInfo.startCursor !== undefined && state.agentCategories[category].pageInfo.endCursor !== undefined,
            isCategoryLoading: state.loadingCategories.has(category),
            isCategoryEmpty: state.agentCategories[category].agentIds.length === 0,
            hasNextPage: state.agentCategories[category].pageInfo.hasNextPage,
            nextPageCursor: state.agentCategories[category].pageInfo.endCursor,
            agentsError: state.agentCategories[category].agentsError
        })
});
const $c0881cdb28f9c5e5$export$e6997ec35c535c54 = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    (0, $fBMbo.di)((0, $hT0Hx.useAgentOverrider), $c0881cdb28f9c5e5$export$1553678862324ff0);
    const { agentDefaultIdOverride: agentDefaultIdOverride, agentIdFiltersOverride: agentIdFiltersOverride } = (0, $hT0Hx.useAgentOverrider)();
    const { addAgent: addAgent, populateAgentCategories: populateAgentCategories } = $c0881cdb28f9c5e5$export$1553678862324ff0();
    const fetchOverriddenAgentsAndPopulateStoreQuery = (0, $9eLw5.useQuery)({
        queryKey: [
            'fetchOverriddenAgentsAndPopulateStore',
            agentDefaultIdOverride ?? '',
            agentIdFiltersOverride?.join(',') ?? ''
        ],
        queryFn: async ()=>{
            const agentIdsToFetchSet = new Set();
            if (agentDefaultIdOverride) agentIdsToFetchSet.add(agentDefaultIdOverride);
            if (agentIdFiltersOverride?.length) agentIdFiltersOverride.forEach((agentId)=>{
                agentIdsToFetchSet.add(agentId);
            });
            if (agentIdsToFetchSet.size === 0) return;
            const agentIdsToFetch = Array.from(agentIdsToFetchSet);
            populateAgentCategories({
                category: 'all-agents',
                agentsList: [],
                pageInfo: (0, $ffpG2.DEFAULT_PAGE_INFO)
            });
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).FETCH_AGENTS_OVERRIDES,
                id: (0, $16lEl.ExperienceName).FETCH_AGENTS_OVERRIDES
            });
            const agents = await Promise.all(agentIdsToFetch.map(async (agentId)=>{
                return await assistanceService.getAgentDetails(agentId);
            }));
            // then add the agents into "All agents" category
            agents.forEach((agent)=>{
                addAgent(agent, [
                    'all-agents'
                ]);
            });
            return agentIdsToFetch;
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_AGENTS_OVERRIDES
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENTS_OVERRIDES,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
        },
        enabled: false
    });
    return {
        fetchOverriddenAgentsAndPopulateStore: fetchOverriddenAgentsAndPopulateStoreQuery.refetch
    };
});
const $c0881cdb28f9c5e5$export$94c2040c41639ede = (0, $h26dv.createHookWithAssistanceService)(({ onError: onError, assistanceServiceInjectedParams: assistanceServiceInjectedParams })=>{
    (0, $fBMbo.di)($c0881cdb28f9c5e5$export$1553678862324ff0, (0, $hT0Hx.useAgentOverrider), $c0881cdb28f9c5e5$export$e6997ec35c535c54);
    const { experienceTracker: experienceTracker, siteId: siteId, product: product, headers: assistanceServiceHeaders } = assistanceServiceInjectedParams;
    const actions = $c0881cdb28f9c5e5$export$1553678862324ff0();
    const { setCategoryLoading: setCategoryLoading, setCategoryError: setCategoryError, populateAgentCategories: populateAgentCategories, getAgentCategoriesByCategory: getAgentCategoriesByCategory, setAgentCategoriesByCategory: setAgentCategoriesByCategory } = actions;
    const { agentDefaultIdOverride: agentDefaultIdOverride, agentIdFiltersOverride: agentIdFiltersOverride } = (0, $hT0Hx.useAgentOverrider)();
    const { fetchOverriddenAgentsAndPopulateStore: fetchOverriddenAgentsAndPopulateStore } = $c0881cdb28f9c5e5$export$e6997ec35c535c54({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    const fetchAgentsByCategory = (0, $42omo.useCallback)(async ({ category: category = 'all-agents', after: after, query: query })=>{
        // if there are any overrides, cancel the normal fetchByCategory and instead fetch the overridden agents
        if (agentDefaultIdOverride || agentIdFiltersOverride?.length) return await fetchOverriddenAgentsAndPopulateStore() ?? [];
        const dataBeforeFetch = getAgentCategoriesByCategory(category);
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).FETCH_AGENTS_PAGINATED,
            id: (0, $16lEl.ExperienceName).FETCH_AGENTS_PAGINATED
        });
        let queryInput = {};
        switch(category){
            case 'starred-agents':
                queryInput.onlyFavouriteAgents = true;
                break;
            case 'my-agents':
                queryInput.onlyMyAgents = true;
                break;
            case 'templates':
                queryInput.onlyTemplateAgents = true;
                break;
        }
        if (query) queryInput.name = query;
        // for rolling back data in case of abort/failure
        const resetData = ()=>{
            setAgentCategoriesByCategory({
                categoryName: category,
                agentCategoryData: dataBeforeFetch
            });
            return dataBeforeFetch.agentIds;
        };
        // No after means we're requesting the first page so the category data is reset
        if (!after) populateAgentCategories({
            category: category,
            agentsList: [],
            pageInfo: (0, $ffpG2.DEFAULT_PAGE_INFO)
        });
        setCategoryLoading(category, true);
        setCategoryError(category, undefined);
        const headers = new Headers(assistanceServiceHeaders);
        const maybeWorkspaceId = headers.get('x-workspace-id');
        try {
            const response = await (0, $ffpG2.fetchPaginatedAgents)({
                after: after ?? undefined,
                cloudId: siteId,
                count: 10,
                input: Object.keys(queryInput).length > 0 ? queryInput : undefined,
                product: product,
                abortController: getAgentCategoriesByCategory(category).abortController,
                workspaceId: maybeWorkspaceId
            });
            setCategoryLoading(category, false);
            if (getAgentCategoriesByCategory(category).abortController.signal?.aborted) {
                experienceTracker.abort({
                    reason: 'Aborted',
                    name: (0, $16lEl.ExperienceName).FETCH_AGENTS_PAGINATED
                });
                return resetData();
            }
            if (response) {
                populateAgentCategories({
                    category: category,
                    agentsList: response.agents,
                    pageInfo: response.pageInfo
                });
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).FETCH_AGENTS_PAGINATED
                });
            }
            return response?.agents.map((agent)=>agent.id);
        } catch (error) {
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENTS_PAGINATED,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
            const prevAgentIds = resetData();
            setCategoryError(category, error);
            setCategoryLoading(category, false);
            if (error instanceof (0, $flpNp.ApiError)) onError?.(error);
            return prevAgentIds;
        }
    }, [
        agentDefaultIdOverride,
        agentIdFiltersOverride?.length,
        getAgentCategoriesByCategory,
        experienceTracker,
        setCategoryLoading,
        setCategoryError,
        assistanceServiceHeaders,
        fetchOverriddenAgentsAndPopulateStore,
        setAgentCategoriesByCategory,
        populateAgentCategories,
        siteId,
        product,
        onError
    ]);
    return {
        ...actions,
        fetchAgentsByCategory: fetchAgentsByCategory
    };
});
const $c0881cdb28f9c5e5$export$65c6565d33cf8f4f = (0, $9zUhf.createHook)($c0881cdb28f9c5e5$var$agentsPaginatedStore, {
    selector: (state)=>state.agentsMap
});
const $c0881cdb28f9c5e5$export$631401679afcb10f = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams, query: query, limit: limit = 3, pageUrl: pageUrl })=>{
    (0, $fBMbo.di)($c0881cdb28f9c5e5$export$65c6565d33cf8f4f);
    const { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId } = assistanceServiceInjectedParams;
    const [agentsMap, { updateAgent: updateAgent }] = $c0881cdb28f9c5e5$export$65c6565d33cf8f4f();
    const { isFetching: isFetching, data: data } = (0, $9eLw5.useQuery)({
        queryKey: [
            'recommendedAgents',
            query ?? '',
            limit,
            pageUrl ?? ''
        ],
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).GET_RECOMMENDED_AGENTS,
                name: (0, $16lEl.ExperienceName).GET_RECOMMENDED_AGENTS
            });
            const response = await assistanceService.getRecommendedAgents({
                limit: limit,
                query: query ?? '',
                pageUrl: pageUrl
            });
            // store the agents in the paginated store for optimistic updates etc
            // not adding them to specific category in local cache on purpose
            response.agents.forEach((agent)=>{
                updateAgent(agent.id, agent);
            });
            return response;
        },
        enabled: Boolean(siteId),
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).GET_RECOMMENDED_AGENTS
            });
        },
        onError: (error)=>{
            if ((0, $cqFPV.isHipaaError)(error)) {
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).GET_RECOMMENDED_AGENTS
                });
                return;
            }
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).GET_RECOMMENDED_AGENTS,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
        }
    });
    return {
        isFetching: isFetching,
        recommendedAgents: data?.agents.map((agent)=>agentsMap[agent.id]).filter(Boolean) ?? [],
        recommendationKey: data?.metadata?.recommendationKey
    };
});
const $c0881cdb28f9c5e5$export$71d3696dcc60eb2d = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { experienceTracker: experienceTracker, siteId: siteId } })=>{
    (0, $fBMbo.di)($c0881cdb28f9c5e5$export$1553678862324ff0, (0, $ffpG2.fetchAgentByExternalConfigReference));
    const { updateAgent: updateAgent, getCachedAgentByExternalConfigReference: getCachedAgentByExternalConfigReference } = $c0881cdb28f9c5e5$export$1553678862324ff0();
    const getAndStoreAgentByExternalConfigReference = (0, $42omo.useCallback)(async ({ externalConfigReference: externalConfigReference })=>{
        const cachedAgent = getCachedAgentByExternalConfigReference(externalConfigReference);
        if (cachedAgent) return cachedAgent;
        try {
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE,
                id: (0, $16lEl.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE
            });
            const agentData = await (0, $ffpG2.fetchAgentByExternalConfigReference)({
                cloudId: siteId,
                externalConfigReference: externalConfigReference
            });
            // cache the data
            updateAgent(agentData.id, agentData);
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE
            });
            return agentData;
        } catch (error) {
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
            return undefined;
        }
    }, [
        getCachedAgentByExternalConfigReference,
        experienceTracker,
        siteId,
        updateAgent
    ]);
    return {
        getAndStoreAgentByExternalConfigReference: getAndStoreAgentByExternalConfigReference
    };
});
const $c0881cdb28f9c5e5$export$eee66751ca85dbf7 = (param)=>{
    return $c0881cdb28f9c5e5$export$f5b1109ecd7858c1(param);
};
const $c0881cdb28f9c5e5$export$6553fa633373a34 = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { product: product, experienceId: experienceId, headers: headers, touchpointSource: touchpointSource, siteId: siteId }, filter: filter })=>{
    const { availableAgents: availableAgents, favouritedAgents: favouritedAgents } = $c0881cdb28f9c5e5$export$eee66751ca85dbf7({
        assistanceServiceParams: {
            product: product,
            experienceId: experienceId,
            headers: headers,
            touchpointSource: touchpointSource,
            siteId: siteId
        }
    });
    const defaultAgents = (0, $iswAx.getSuggestedOotbAgents)({
        availableAgents: availableAgents,
        product: product
    });
    const defaultAgentsOutsideUserFavourites = defaultAgents.filter((defaultAgent)=>!favouritedAgents.find((favAgent)=>favAgent.id === defaultAgent.id));
    const favouritedAgentsWithDefault = [
        ...favouritedAgents,
        ...defaultAgentsOutsideUserFavourites.slice(0, Math.max(3 - favouritedAgents.length, 0))
    ];
    return filter === 'favourites' ? favouritedAgentsWithDefault : availableAgents;
});
module.exports["useAgentsPaginatedByAgentId"] = $c0881cdb28f9c5e5$export$44c2e95a7a8b47c9;
module.exports["useAgentsPaginatedActionsWithOptimistic"] = $c0881cdb28f9c5e5$export$eae59c91509947e4;
module.exports["usePaginatedAgentsByCategory"] = $c0881cdb28f9c5e5$export$cc3deb815b1c179b;
module.exports["usePaginatedAgentsActions"] = $c0881cdb28f9c5e5$export$94c2040c41639ede;
module.exports["useRecommendedAgents"] = $c0881cdb28f9c5e5$export$631401679afcb10f;
module.exports["usePaginatedAgentByConfigReference"] = $c0881cdb28f9c5e5$export$71d3696dcc60eb2d;
module.exports["useAgentsList"] = $c0881cdb28f9c5e5$export$6553fa633373a34;

});

parcelRegister("aMqwg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9d4cc27d6faf7a6e$var$rovoEntitlementStore = (0, $1P1Tu.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $9d4cc27d6faf7a6e$var$useStateHook = (0, $9zUhf.createStateHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$66d5dd4be64dea43 = ()=>{
    const result = $9d4cc27d6faf7a6e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $9d4cc27d6faf7a6e$export$8004893135276275 = (0, $9zUhf.createActionsHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $9d4cc27d6faf7a6e$export$8004893135276275();
    (0, $42omo.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $9d4cc27d6faf7a6e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $9d4cc27d6faf7a6e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $9d4cc27d6faf7a6e$export$d03a05ad8547472c;

});

parcelRegister("flpNp", function(module, exports) {
class $1d075fa469bb0891$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $1d075fa469bb0891$export$89d83cc97c52a37 = (error)=>error instanceof $1d075fa469bb0891$export$f2e832acab1bdd79;
const $1d075fa469bb0891$export$3c02d1a328d4d808 = (error)=>{
    if ($1d075fa469bb0891$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $1d075fa469bb0891$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};
module.exports["ApiError"] = $1d075fa469bb0891$export$f2e832acab1bdd79;
module.exports["isApiError"] = $1d075fa469bb0891$export$89d83cc97c52a37;
module.exports["mapErrorToApiError"] = $1d075fa469bb0891$export$3c02d1a328d4d808;

});

parcelRegister("h26dv", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $7pmZw = parcelRequire("7pmZw");


var $ljUdP = parcelRequire("ljUdP");


var $8Igpw = parcelRequire("8Igpw");


var $33mIS = parcelRequire("33mIS");


var $4Z0i5 = parcelRequire("4Z0i5");


var $4E0A1 = parcelRequire("4E0A1");


var $99vXA = parcelRequire("99vXA");


var $aclUh = parcelRequire("aclUh");


var $aMZ6b = parcelRequire("aMZ6b");

const $7b2e91008351c623$var$PRODUCT_HEADER = 'x-product';
const $7b2e91008351c623$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
const $7b2e91008351c623$var$CHANNEL_ID_HEADER = 'X-Channel-Id';
class $7b2e91008351c623$export$40a7802808e2fbe3 {
    createHeaders(init) {
        return new Headers({
            [$7b2e91008351c623$var$PRODUCT_HEADER]: this.config.product,
            [$7b2e91008351c623$var$EXPERIENCE_ID_HEADER]: this.config.experienceId,
            ...this.config.headers || {},
            ...init || {}
        });
    }
    async fetch({ path: path, options: options }) {
        const { baseUrl: configBaseUrl, credentials: configCredentials } = this.config;
        const baseUrl = configBaseUrl;
        const requestUrl = (0, $4E0A1.addPath)(baseUrl, path);
        const response = await (0, $aMZ6b.fetchFn)(requestUrl, {
            credentials: configCredentials,
            ...options
        });
        return (0, $4E0A1.processResponse)({
            response: response
        });
    }
    async fetchJson(options) {
        const response = await this.fetch(options);
        const json = await response.json();
        return json;
    }
    async fetchStream(options) {
        const response = await this.fetch(options);
        return {
            responseData: {
                traceId: (0, $8Igpw.getTraceIdFromResponse)(response)
            },
            generator: (0, $4Z0i5.readJsonStream)(response)
        };
    }
    constructor(props){
        this.config = void 0;
        this.getConfig = ()=>{
            return {
                ...this.config
            };
        };
        const defaultBaseUrl = '/gateway/api/assist';
        const defaultConfig = {
            baseUrl: defaultBaseUrl,
            headers: {}
        };
        this.config = {
            ...props,
            baseUrl: props.baseUrl || defaultConfig.baseUrl,
            credentials: props.credentials,
            headers: {
                ...props.headers || defaultConfig.headers
            }
        };
    }
}
class $7b2e91008351c623$export$a522c5f4ccda1c94 extends $7b2e91008351c623$export$40a7802808e2fbe3 {
    async sendMessageStream({ agentNamedId: agentNamedId, agentId: agentId, message: message, conversationId: conversationId, controller: controller, storeMessage: storeMessage = false, citationsEnabled: citationsEnabled = true, aiFeatureContext: aiFeatureContext, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, whiteboardContext: whiteboardContext, databaseContext: databaseContext, browserContext: browserContext, additionalContext: additionalContext, dashboardContext: dashboardContext, fileIds: fileIds, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, appFilters: appFilters, useCurrentBrowsingContext: useCurrentBrowsingContext, minionAliasConfig: minionAliasConfig, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, browserContextSanitizer: browserContextSanitizer }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            ...(0, $dh538.fg)('rovo_send_channel_id') && {
                [$7b2e91008351c623$var$CHANNEL_ID_HEADER]: 'rovo-chat'
            },
            // This header is used to opt-in to Deep Research v2 on the BE.
            // This is to ensure that we don't use v2 deep research when we are using the old Rovo Chat UI prior to the refresh..
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            // Opt in to using RESEARCH_STEP, RESEARCH_PLAN, and similar messages for "think deeper".
            // Ensures backward compatibility with legacy clients and allows application targeting within the experiment.
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            }
        });
        let knowledgeOverride = {};
        // not setting knowledgeEnabled and filters means all org knowledge is applied by default.
        if (appFilters) {
            if (appFilters.length === 0) knowledgeOverride = {
                knowledgeEnabled: false
            };
            else knowledgeOverride = {
                knowledgeEnabled: true,
                filters: {
                    knowledgeSources: appFilters
                }
            };
        }
        // Check if the URL is blocklisted
        const browserUrl = browserContext?.context?.browserUrl;
        const isBlocklisted = browserUrl && browserContextSanitizer ? browserContextSanitizer.isBlocklisted(browserUrl) : false;
        // Determine the URL to send to the backend
        // If blocklisted, send empty URL to ensure the site is not sent to the backend
        // If browserContext received and context is undefined, assume we're unable to retrieve the context of the page in focus
        let url;
        if (isBlocklisted || browserContext?.context?.browserUrl === 'NO-URL' && (0, $c6GJD.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) url = '';
        else if (browserContext?.context?.browserUrl) url = browserContext.context.browserUrl;
        else url = window?.location?.href ?? '';
        const body = {
            content: message,
            context: {
                // without useCurrentBrowsingContext browser_url is not always used by the Rovo,
                // instead it depends on prompt intent to use it,
                // with useCurrentBrowsingContext we can ensure it is always used
                browser_url: url,
                ...useCurrentBrowsingContext === undefined ? {} : {
                    useCurrentBrowsingContext: useCurrentBrowsingContext
                },
                webSearchEnabled: webSearchEnabled,
                deepResearchEnabled: deepResearchEnabled,
                ...thinkDeeperEnabled ? {
                    extendedThinkingEnabled: thinkDeeperEnabled
                } : {},
                ...editorContext ? {
                    editor: editorContext
                } : {},
                ...whiteboardContext ? {
                    whiteboardContext: whiteboardContext
                } : {},
                ...databaseContext ? {
                    databaseContext: databaseContext
                } : {},
                // If browserUrl is inaccessable, fallback to htmlBody or canvasText if they exist
                // Do not send htmlBody or canvasText if the URL is blocklisted to ensure the site is truly not sent to the backend
                ...browserContext && !isBlocklisted ? {
                    browser: {
                        htmlBody: browserContext.context?.htmlBody,
                        canvasText: browserContext.context?.canvasText
                    }
                } : {},
                ...(0, $dh538.fg)('enable_jira_workflow_wizard_agent_in_wf_editor') ? {
                    jiraWorkflowContext: jiraWorkflowContext
                } : {},
                ...additionalContext,
                ...(0, $dh538.fg)('platform_avp_enable_dashboard_context_event_pubsub') ? {
                    dashboardContext: dashboardContext
                } : {},
                aiFeatureContext: aiFeatureContext,
                fileIds: fileIds,
                ...knowledgeOverride
            },
            recipient_agent_named_id: agentNamedId,
            agent_id: agentId,
            mimeType: typeof message === 'string' ? 'text/markdown' : 'text/adf',
            // don't allow store message if feature flag is off
            store_message: (0, $dh538.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: citationsEnabled,
            ...minionAliasConfig ?? (this.getConfig().minionAlias ? {
                stratus_config: {
                    minion_alias: this.getConfig().minionAlias
                }
            } : {})
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        });
    }
    async sendMessageConfirmedTools({ conversationId: conversationId, agentId: agentId, controller: controller, confirmed_tools: confirmed_tools }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const url = window?.location?.href;
        const body = {
            conversation_id: conversationId,
            agent_id: agentId,
            confirmed_tools: confirmed_tools,
            context: {
                browser_url: url
            },
            // These values are hardcoded because they are not used in backend, but required in the contract
            content: '',
            mimeType: 'text/markdown',
            store_message: false,
            citations_enabled: false
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        });
    }
    async nlCreateAgentStream({ controller: controller, latest_user_message: latest_user_message, draft_agent: draft_agent, conversation_history: conversation_history }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const body = {
            latest_user_message: latest_user_message,
            draft_agent: draft_agent,
            conversation_history: conversation_history
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/agents/nlcreate`,
            options: options
        });
    }
    async getChat(conversationId) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const rawChat = await this.fetchJson({
            path: `/rovo/v1/chat/conversation/${conversationId}/messages`,
            options: options
        });
        const chatArray = rawChat.items;
        return chatArray.map((message)=>// Must be converted into StreamResponse
            (0, $ljUdP.isHumanMessage)(message) ? message : (0, $aclUh.toStreamResponse)(message));
    }
    async deleteChat(conversationId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}`,
            options: options
        });
    }
    async getAgents(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: '/rovo/v1/agents',
            options: options
        });
        return response.items;
    }
    async getAgentDetails(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options
        });
    }
    async getAgentDetailsByIdentityAccountId(identityAccountId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/accountid/${identityAccountId}`,
            options: options
        });
    }
    async createAgent(payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        return this.fetchJson({
            path: '/rovo/v1/agents',
            options: options
        });
    }
    async updateAgent(id, payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options
        });
        return response;
    }
    async deleteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options
        });
    }
    async favouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'POST',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options
        });
    }
    async unfavouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options
        });
    }
    async createConversationChannel(options) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    name: options?.name ?? (0, $99vXA.generateConversationName)(),
                    dialogues: options?.dialogues ?? undefined
                })
            }
        });
    }
    async getConversationChannels() {
        // Clean up `ConversationChannel[] | { items: ConversationChannel[] }` when fg('rovo_convo_ai_migration') is removed
        const result = await this.fetchJson({
            path: `/rovo/v1/chat/conversations`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            }
        });
        return result.items;
    }
    updateConversationChannel(id, payload) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}`,
            options: {
                method: 'PUT',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify(payload)
            }
        });
    }
    async resolveConversationAction(id, payload) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}/action`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    ...payload,
                    context: {
                        ...payload.context,
                        browser_url: window.location.href
                    }
                })
            }
        });
    }
    // REST starters, newer API
    async generateAgentStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/agent-starter-suggestion',
            options: options
        });
    }
    // REST conversation starters, newer API
    async generateContextualStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/page-contextual',
            options: options
        });
    }
    // REST dynamic conversation starters (new endpoint)
    async getDynamicConvoStartersNew(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            'x-experience-id': 'convo-starter-for-rovo-button'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/ai/v2/ai-feature/convo-starters',
            options: options
        });
    }
    async getWebSearchConfiguration() {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const result = await this.fetchJson({
            path: '/api/v2/configuration/web-search-ai',
            options: options
        });
        return result;
    }
    constructor(props){
        super(props);
        this.getAgentActions = async ()=>{
            const response = await this.fetchJson({
                path: '/rovo/v1/agents/configuration/actions',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
            return response.actions;
        };
        this.getAgentKnowledgeConfiguration = ()=>{
            return this.fetchJson({
                path: `/rovo/v1/agents/configuration/knowledge`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
        };
        this.getAgentPermissions = (agentId, payload)=>{
            return this.fetchJson({
                path: `/rovo/v2/permissions/agents/${agentId}`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                }
            });
        };
        this.getRecommendedAgents = ({ limit: limit, query: query, pageUrl: pageUrl })=>{
            const urlParams = new URLSearchParams({
                limit: limit.toString(),
                query: query
            });
            if (pageUrl) urlParams.append('pageUrl', pageUrl);
            const fullPath = `/rovo/v1/agents/recommend/v2?${urlParams.toString()}`;
            return this.fetchJson({
                path: fullPath,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
        };
        this.getConversationDebugLogs = async (conversationId)=>{
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/debug-logs`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
            return response.items;
        };
        this.validateFiles = async (payload)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            return this.fetchJson({
                path: `/rovo/v1/chat/message/file/validate`,
                options: {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(payload)
                }
            });
        };
        this.uploadFiles = async (payload)=>{
            const formData = new FormData();
            for (const file of payload.files)formData.append('files', file);
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/message/file`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders(),
                    body: formData
                }
            });
            return response;
        };
        this.rovoLabsSendMessage = (payload)=>{
            return this.fetchStream({
                path: '/rovo/v1/agent-playground/chat/stream',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                }
            });
        };
        this.rovoLabsGetConversations = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/chat/conversations',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
        };
        this.rovoLabsGetTools = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/tools',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
        };
        this.rovoLabsGetLanguageModels = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/language-models',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
        };
        this.rovoLabsGetPrompts = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/prompts',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
        };
        this.getGeneratedContent = (payload)=>{
            const queryParams = [];
            if (payload?.actions && payload.actions.length > 0) queryParams.push(`actionKeys=${payload.actions.join(',')}`);
            if (payload?.statuses && payload.statuses.length > 0) queryParams.push(`statuses=${payload.statuses.join(',')}`);
            if (payload?.limit !== undefined) queryParams.push(`limit=${payload.limit}`);
            const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
            return this.fetchJson({
                path: `/rovo/v1/chat/generated-content${queryString}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
        };
    }
}
const $7b2e91008351c623$var$AssistanceServiceContext = /*#__PURE__*/ (0, $42omo.createContext)(new $7b2e91008351c623$export$a522c5f4ccda1c94({
    baseUrl: '',
    product: '',
    experienceId: ''
}));
const $7b2e91008351c623$export$8fe647eb935c33db = ({ value: value, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)($7b2e91008351c623$var$AssistanceServiceContext.Provider, {
        value: value,
        children: children
    });
const $7b2e91008351c623$export$7e31a1844ebbaf85 = (props)=>{
    (0, $fBMbo.di)((0, $42omo.useContext), $7b2e91008351c623$export$a522c5f4ccda1c94);
    const service = (0, $42omo.useContext)($7b2e91008351c623$var$AssistanceServiceContext);
    (0, $33mIS.setRovoChatProduct)(props?.product ?? service.getConfig().product);
    if (!props || !props.experienceId && !props.product && !props.headers) return service;
    const product = props.product ?? service.getConfig().product;
    const experienceId = props.experienceId ?? service.getConfig().experienceId;
    const headers = props.headers ?? service.getConfig().headers;
    return new $7b2e91008351c623$export$a522c5f4ccda1c94({
        ...service.getConfig(),
        product: product,
        experienceId: experienceId,
        headers: headers
    });
};
const $7b2e91008351c623$export$5a9ea20fc196ec62 = (originalHook)=>{
    return (props)=>{
        (0, $fBMbo.di)($7b2e91008351c623$export$a522c5f4ccda1c94, (0, $7pmZw.useAIMateExperienceTracker));
        const { assistanceServiceParams: assistanceServiceParams, ...restProps } = props;
        const experienceTracker = (0, $7pmZw.useAIMateExperienceTracker)({
            touchpointSource: assistanceServiceParams.touchpointSource
        });
        const headers = (0, $42omo.useMemo)(()=>{
            // even though AssistanceServiceInputParam enforces lowercase header keys,
            // it is possible to get a non lowercase key if a prebuilt object was assigned to headers at runtime,
            // so this is an additional safety net, without this duplicate headers keys with different case
            // can get appended during header normalization causing request to fail
            // Relevant thread: https://atlassian.slack.com/archives/C0677M19GU9/p1748531977923069?thread_ts=1747336061.856749&cid=C0677M19GU9
            const inputHeaders = props.assistanceServiceParams.headers ? Object.fromEntries(Object.entries(props.assistanceServiceParams.headers).map(([key, value])=>[
                    key.toLowerCase(),
                    value
                ])) : undefined;
            return {
                'x-cloudid': props.assistanceServiceParams.siteId,
                ...inputHeaders
            };
        }, [
            props.assistanceServiceParams.siteId,
            props.assistanceServiceParams.headers
        ]);
        const assistanceService = (0, $42omo.useMemo)(()=>{
            return new $7b2e91008351c623$export$a522c5f4ccda1c94({
                product: assistanceServiceParams.product,
                experienceId: assistanceServiceParams.experienceId,
                headers: headers,
                baseUrl: assistanceServiceParams.baseUrl,
                minionAlias: assistanceServiceParams.minionAlias
            });
        }, [
            assistanceServiceParams.baseUrl,
            assistanceServiceParams.experienceId,
            assistanceServiceParams.product,
            headers,
            assistanceServiceParams.minionAlias
        ]);
        const result = originalHook({
            ...restProps,
            assistanceServiceInjectedParams: {
                ...assistanceServiceParams,
                headers: headers,
                experienceTracker: experienceTracker,
                assistanceService: assistanceService
            }
        });
        return result;
    };
};
module.exports["AssistanceServiceImpl"] = $7b2e91008351c623$export$a522c5f4ccda1c94;
module.exports["AssistanceServiceProvider"] = $7b2e91008351c623$export$8fe647eb935c33db;
module.exports["useAssistanceService"] = $7b2e91008351c623$export$7e31a1844ebbaf85;
module.exports["createHookWithAssistanceService"] = $7b2e91008351c623$export$5a9ea20fc196ec62;

});

parcelRegister("ljUdP", function(module, exports) {

var $5MO1q = parcelRequire("5MO1q");


var $flpNp = parcelRequire("flpNp");

const $35329f6c3dcf5d43$export$5945515082cc2cbf = 'convoai.rest.not.found';
const $35329f6c3dcf5d43$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
const $35329f6c3dcf5d43$export$fb661125ffb29bd6 = (message)=>{
    return $35329f6c3dcf5d43$export$a69fab2afb88c2eb(message) || $35329f6c3dcf5d43$export$6f965deda7f0960c(message) || $35329f6c3dcf5d43$export$b4631726cbc1440a(message);
};
const $35329f6c3dcf5d43$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $35329f6c3dcf5d43$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $35329f6c3dcf5d43$export$a6e5100ca2770191 = (message)=>message instanceof Object && $35329f6c3dcf5d43$export$6f965deda7f0960c(message.message);
const $35329f6c3dcf5d43$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $35329f6c3dcf5d43$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $35329f6c3dcf5d43$export$1e1cf807ece63df4 = (message)=>$35329f6c3dcf5d43$export$d422a2733a3b5def(message) && message.message?.message_template === $35329f6c3dcf5d43$export$c424fe9570a5f2d9;
const $35329f6c3dcf5d43$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $35329f6c3dcf5d43$export$51a109436d382715 = (message)=>message instanceof Object && message.type === 'REASONING_PART';
const $35329f6c3dcf5d43$export$dbf4211c9117b9bc = (message)=>message instanceof Object && message.type === 'ACTION_PART';
const $35329f6c3dcf5d43$export$3d7b0b359441d5a6 = (message)=>message instanceof Object && message.type === 'ACTION_CLASSIFICATION';
const $35329f6c3dcf5d43$export$584e11c2903f4ed6 = (message)=>message instanceof Object && message.type === 'ACTION_PREPARE';
const $35329f6c3dcf5d43$export$7d94ce53d589f586 = (message)=>message instanceof Object && message.type === 'ACTION_COMPLETE';
const $35329f6c3dcf5d43$export$abec64f24e2ec3e7 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_START';
const $35329f6c3dcf5d43$export$9c1f93971e9e3fbe = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $35329f6c3dcf5d43$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $35329f6c3dcf5d43$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $35329f6c3dcf5d43$export$cde91b49af35d559 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_PLAN';
const $35329f6c3dcf5d43$export$ac74da022f74040a = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT';
const $35329f6c3dcf5d43$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $35329f6c3dcf5d43$export$cfccfd17b68ccb0 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $35329f6c3dcf5d43$export$46e0fb5e4b019a49 = (message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE');
const $35329f6c3dcf5d43$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($35329f6c3dcf5d43$export$46e0fb5e4b019a49(message)) return false;
    if ($35329f6c3dcf5d43$export$cde91b49af35d559(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $35329f6c3dcf5d43$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $35329f6c3dcf5d43$export$b8391261162989d9 = (message)=>$35329f6c3dcf5d43$export$6f965deda7f0960c(message) && (message?.message_metadata?.is_action_execution ?? false) && message?.message_metadata?.action_execution_result === 'SUCCESS';
const $35329f6c3dcf5d43$export$1060c4fa97e34fa7 = (payloadContext)=>{
    return payloadContext?.resolution?.type === 'cancel';
};
const $35329f6c3dcf5d43$export$6ce1ccc24e75456f = (error)=>(0, $flpNp.isApiError)(error) && error.errorAttributes?.errorCode === $35329f6c3dcf5d43$export$5945515082cc2cbf;
const $35329f6c3dcf5d43$export$c3c933dad2745d3f = (msg)=>msg && msg.type === 'ACTION_ERROR' && msg.message && msg.message.status === 'ERRORED';
const $35329f6c3dcf5d43$export$bc96a6a479480590 = (error)=>(0, $flpNp.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $35329f6c3dcf5d43$export$f8b1b75846492611 = (error)=>(0, $flpNp.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $35329f6c3dcf5d43$export$d263dc5d64f36d48 = (error)=>error instanceof Object && error?.detail?.type === 'ERROR' && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === $35329f6c3dcf5d43$export$c424fe9570a5f2d9;
const $35329f6c3dcf5d43$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
function $35329f6c3dcf5d43$export$4af48296a8d61cec(payloadContext) {
    return payloadContext?.resolution?.type === 'confirm';
}
module.exports["ACCEPTABLE_USE_VIOLATIONS_ERROR"] = $35329f6c3dcf5d43$export$c424fe9570a5f2d9;
module.exports["isHumanMessage"] = $35329f6c3dcf5d43$export$a69fab2afb88c2eb;
module.exports["isAssistantMessage"] = $35329f6c3dcf5d43$export$6f965deda7f0960c;
module.exports["isStreamResponse"] = $35329f6c3dcf5d43$export$b4631726cbc1440a;
module.exports["isAgentResponse"] = $35329f6c3dcf5d43$export$a6e5100ca2770191;
module.exports["isStreamError"] = $35329f6c3dcf5d43$export$d422a2733a3b5def;
module.exports["isStreamAUPError"] = $35329f6c3dcf5d43$export$1e1cf807ece63df4;
module.exports["isStreamAnswerPart"] = $35329f6c3dcf5d43$export$e45102edbc73b240;
module.exports["isStreamReasoningPart"] = $35329f6c3dcf5d43$export$51a109436d382715;
module.exports["isStreamActionPart"] = $35329f6c3dcf5d43$export$dbf4211c9117b9bc;
module.exports["isStreamActionClassification"] = $35329f6c3dcf5d43$export$3d7b0b359441d5a6;
module.exports["isStreamActionPrepare"] = $35329f6c3dcf5d43$export$584e11c2903f4ed6;
module.exports["isStreamActionComplete"] = $35329f6c3dcf5d43$export$7d94ce53d589f586;
module.exports["isStreamResearchStart"] = $35329f6c3dcf5d43$export$abec64f24e2ec3e7;
module.exports["isStreamResearchBeginningTrace"] = $35329f6c3dcf5d43$export$9c1f93971e9e3fbe;
module.exports["isStreamResearchStepContent"] = $35329f6c3dcf5d43$export$79a0ed7d987faa8f;
module.exports["isStreamResearchStepTitle"] = $35329f6c3dcf5d43$export$7b1c8227569f1a92;
module.exports["isStreamResearchPlan"] = $35329f6c3dcf5d43$export$cde91b49af35d559;
module.exports["isStreamResearchStepTitleShort"] = $35329f6c3dcf5d43$export$ac74da022f74040a;
module.exports["isStreamResearchStepSource"] = $35329f6c3dcf5d43$export$68192da24ac8c141;
module.exports["isStreamResearchStepCompleted"] = $35329f6c3dcf5d43$export$cfccfd17b68ccb0;
module.exports["isStreamResearchPayload"] = $35329f6c3dcf5d43$export$46e0fb5e4b019a49;
module.exports["isStreamTrace"] = $35329f6c3dcf5d43$export$fd5a05be03f147a0;
module.exports["isFollowUpMessage"] = $35329f6c3dcf5d43$export$aeae5b4fda357302;
module.exports["isActionExecutedSuccessfully"] = $35329f6c3dcf5d43$export$b8391261162989d9;
module.exports["isActionResolutionCancelled"] = $35329f6c3dcf5d43$export$1060c4fa97e34fa7;
module.exports["isChannelNotFoundError"] = $35329f6c3dcf5d43$export$6ce1ccc24e75456f;
module.exports["isStreamActionError"] = $35329f6c3dcf5d43$export$c3c933dad2745d3f;
module.exports["isRateLimitedError"] = $35329f6c3dcf5d43$export$bc96a6a479480590;
module.exports["isHipaaError"] = $35329f6c3dcf5d43$export$f8b1b75846492611;
module.exports["isAUPViolationError"] = $35329f6c3dcf5d43$export$d263dc5d64f36d48;
module.exports["isConversationChannelDataMessage"] = $35329f6c3dcf5d43$export$b454081350f4a578;
module.exports["isConfirmAction"] = $35329f6c3dcf5d43$export$4af48296a8d61cec;

});

parcelRegister("5MO1q", function(module, exports) {
const $bc280b458a56ce28$export$e8114853eca81277 = 'ai-mate';
const $bc280b458a56ce28$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $bc280b458a56ce28$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415,
    FILE_RAI_POLICY_VIOLATION: 406
};
module.exports["ASSISTANCE_SERVICE_ERROR_CODES"] = $bc280b458a56ce28$export$1106bf31edf2a9b8;
module.exports["STATUS_CODES"] = $bc280b458a56ce28$export$333e4f57333eadfa;

});

parcelRegister("33mIS", function(module, exports) {
// Dupe of same function from conversation-assistant
// No need to add a whole dependency just for this function
const $8485b8d4788fac0e$export$caa27b16709bc2df = (product)=>{
    if (window) window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
};
module.exports["setRovoChatProduct"] = $8485b8d4788fac0e$export$caa27b16709bc2df;

});

parcelRegister("4Z0i5", function(module, exports) {

var $wzD3I = parcelRequire("wzD3I");

async function* $daf6340d0b79c55b$export$1f24b2b263bcfa75(response) {
    const reader = (0, $wzD3I.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                yield JSON.parse(chunk);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}
module.exports["readJsonStream"] = $daf6340d0b79c55b$export$1f24b2b263bcfa75;

});

parcelRegister("wzD3I", function(module, exports) {
const $e391ccd494b2887b$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
module.exports["getBufferReader"] = $e391ccd494b2887b$export$f6383c3ea1307da9;

});

parcelRegister("4E0A1", function(module, exports) {

var $flpNp = parcelRequire("flpNp");


var $8Igpw = parcelRequire("8Igpw");

const $839038eaaf7c5a3d$export$4c25481b843feb0b = (baseUrl, path)=>{
    if (path === '') // return base url without trailing slash
    return baseUrl;
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
const $839038eaaf7c5a3d$var$removeTimestampFromErrorMessage = (errorBodyJson)=>{
    const { timestamp: _timestamp, ...rest } = errorBodyJson;
    return JSON.stringify(rest);
};
const $839038eaaf7c5a3d$var$processErrorResponse = async ({ response: response })=>{
    let errorCode;
    let outputErrorMessage;
    const responseText = await response.text();
    let rawErrorMessage;
    try {
        const errorBodyJson = JSON.parse(responseText);
        const { error_code: error_code, error_message: error_message, message_template: message_template, errors: errors, errorMessage: errorMessage, timestamp: timestamp } = errorBodyJson;
        rawErrorMessage = errorMessage ?? error_message;
        if (errors?.length) // Use a single error code for now
        errorCode = errors[0];
        else if (error_code) errorCode = error_code;
        else errorCode = message_template;
        if (!errorCode || !rawErrorMessage) outputErrorMessage = timestamp ? $839038eaaf7c5a3d$var$removeTimestampFromErrorMessage(errorBodyJson) : responseText;
        else outputErrorMessage = `${errorCode} - ${rawErrorMessage}`;
    } catch  {
        outputErrorMessage = responseText;
    }
    throw new (0, $flpNp.ApiError)(`[Code ${response.status}] ${outputErrorMessage}`, {
        errorCode: errorCode,
        statusCode: response.status,
        rawErrorMessage: rawErrorMessage,
        traceId: (0, $8Igpw.getTraceIdFromResponse)(response)
    });
};
const $839038eaaf7c5a3d$export$21fcb6cfd5628534 = async ({ response: response })=>{
    if (!response.ok || response.status >= 400) await $839038eaaf7c5a3d$var$processErrorResponse({
        response: response
    });
    return response;
};
module.exports["addPath"] = $839038eaaf7c5a3d$export$4c25481b843feb0b;
module.exports["processResponse"] = $839038eaaf7c5a3d$export$21fcb6cfd5628534;

});

parcelRegister("99vXA", function(module, exports) {
const $54861eb441be5d90$export$11cc4786742ed7c2 = ()=>{
    const date = new Date();
    const formattedDate = date.toLocaleDateString(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const name = `${formattedDate} ${formattedTime}`;
    return name;
};
module.exports["generateConversationName"] = $54861eb441be5d90$export$11cc4786742ed7c2;

});

parcelRegister("aclUh", function(module, exports) {

var $ljUdP = parcelRequire("ljUdP");

const $68019d45b4210062$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
const $68019d45b4210062$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
    const content = `${response.content}${answerPart.message.content}`;
    // Remove source indexes, e.g [^1^] from the content
    const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
    return {
        ...response,
        content: cleanedContent
    };
};
const $68019d45b4210062$var$addAnswerPartAgentResponse = (response, answerPart)=>({
        ...response,
        message: $68019d45b4210062$var$addAnswerPartAssistantMessage(response.message, answerPart)
    });
// ****************************************************************************
// Action streaming accumulation configuration
// ****************************************************************************
const $68019d45b4210062$var$toPathArr = (path)=>Array.isArray(path) ? path : path.split('.').filter(Boolean);
const $68019d45b4210062$var$getAtPath = (obj, path)=>{
    let cur = obj;
    for (const key of path){
        if (cur == null || typeof cur !== 'object') return undefined;
        cur = cur[key];
    }
    return cur;
};
const $68019d45b4210062$var$setAtPath = (obj, path, value)=>{
    if (path.length === 0) return value;
    const [head, ...rest] = path;
    const base = obj && typeof obj === 'object' ? obj : {};
    return {
        ...base,
        [head]: $68019d45b4210062$var$setAtPath(base[head], rest, value)
    };
};
// Defines which sub-field(s) of a message action's data should be accumulated by string appending.
// Keyed by action key. Values can be a dot path or an array path, or an array of multiple paths.
// E.g.:
// {
//   'create-document-action': 'content',
//   'update-document-action': ['content', 'meta.subtitle']
// }
let $68019d45b4210062$var$actionDataAccumulationConfig = {
    ['aifc-confluence-page-create']: 'adf'
};
const $68019d45b4210062$export$a1715e22f3105088 = (prev, next)=>{
    const key = next.key;
    const rulePaths = $68019d45b4210062$var$actionDataAccumulationConfig[key];
    const prevData = prev?.data;
    const newData = next?.data;
    if (rulePaths && typeof prevData === 'object' && prevData !== null && typeof newData === 'object' && newData !== null) {
        const paths = Array.isArray(rulePaths) ? rulePaths : [
            rulePaths
        ];
        let base = {
            ...newData
        };
        for (const p of paths){
            const pathArr = $68019d45b4210062$var$toPathArr(p);
            const prevVal = $68019d45b4210062$var$getAtPath(prevData, pathArr);
            const nextVal = $68019d45b4210062$var$getAtPath(newData, pathArr);
            const accumulated = String(prevVal ?? '') + String(nextVal ?? '');
            base = $68019d45b4210062$var$setAtPath(base, pathArr, accumulated);
        }
        return {
            ...prev,
            data: base,
            status: next.status
        };
    }
    // Default: replace only data from next, keep other fields from prev
    return {
        ...prev,
        data: next.data,
        status: next.status
    };
};
const $68019d45b4210062$export$6554ad578994a75f = (actions, actionPart, actionUpdaterOverride)=>{
    const { key: key } = actionPart.message;
    const existingActionIndex = actions.findIndex((action)=>action.key === key);
    if (existingActionIndex === -1) return [
        ...actions || [],
        actionPart.message
    ];
    const updatedActions = [
        ...actions
    ];
    const prevAction = updatedActions[existingActionIndex];
    const nextAction = actionPart.message;
    updatedActions[existingActionIndex] = actionUpdaterOverride ? actionUpdaterOverride(prevAction, nextAction) : $68019d45b4210062$export$a1715e22f3105088(prevAction, nextAction);
    return updatedActions;
};
const $68019d45b4210062$export$6e5609c05ab74cc7 = (response, answerPart)=>({
        ...response,
        message: $68019d45b4210062$var$addAnswerPartAgentResponse(response.message, answerPart)
    });
const $68019d45b4210062$export$13b6a4e4e3704011 = (response, actionPart, actionUpdaterOverride)=>{
    const { message: message } = response.message;
    const { actions: actions } = message;
    const isActionsArrayPresent = actions && actions.length > 0;
    return {
        ...response,
        message: {
            ...response.message,
            message: {
                ...message,
                actions: !isActionsArrayPresent ? [
                    actionPart.message
                ] : $68019d45b4210062$export$6554ad578994a75f(actions, actionPart, actionUpdaterOverride)
            }
        }
    };
};
const $68019d45b4210062$var$removeSensitiveDataAssistantMessage = (message)=>{
    const { plugin_invocations: plugin_invocations, ...rest } = message;
    return {
        ...rest,
        plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                ...pluginInvocation,
                plugin_output: '--PRIVATE--'
            }))
    };
};
const $68019d45b4210062$var$removeSensitiveDataAgentResponse = (message)=>({
        ...message,
        message: $68019d45b4210062$var$removeSensitiveDataAssistantMessage(message.message)
    });
const $68019d45b4210062$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        message: $68019d45b4210062$var$removeSensitiveDataAgentResponse(message.message)
    });
const $68019d45b4210062$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId, fileUploads)=>{
    return {
        role: 'HUMAN',
        id: id,
        content: content,
        time_created: new Date().toISOString(),
        user_ari: 'unknown',
        plugin_invocations: [],
        isFromSeededConversation: isFromSeededConversation,
        requestId: requestId,
        file_uploads: fileUploads
    };
};
const $68019d45b4210062$export$3220a4ff7b3a96df = (message)=>{
    if ((0, $ljUdP.isAgentResponse)(message)) return {
        type: 'FINAL_RESPONSE',
        message: message
    };
    return {
        type: 'FINAL_RESPONSE',
        message: {
            message: message
        }
    };
};
module.exports["getId"] = $68019d45b4210062$export$218c8c3169c024d2;
module.exports["addAnswerPart"] = $68019d45b4210062$export$6e5609c05ab74cc7;
module.exports["addActionPart"] = $68019d45b4210062$export$13b6a4e4e3704011;
module.exports["removeSensitiveData"] = $68019d45b4210062$export$efd4f6b5d168b654;
module.exports["createHumanMessage"] = $68019d45b4210062$export$4010f996e89e886a;
module.exports["toStreamResponse"] = $68019d45b4210062$export$3220a4ff7b3a96df;

});

parcelRegister("aMZ6b", function(module, exports) {
const $e8e9829a77b7a504$export$10f0d162cb6dae7c = window.fetch;
module.exports["fetchFn"] = $e8e9829a77b7a504$export$10f0d162cb6dae7c;

});

parcelRegister("9eLw5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $9zUhf = parcelRequire("9zUhf");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");


var $flpNp = parcelRequire("flpNp");

const $2c362c1c58e43242$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        cache: {}
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            }
    }
});
const $2c362c1c58e43242$var$selector = (0, $cclHy.createSelector)((state)=>state.cache, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
	 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
	 * and it will determine whether to rerender the component
	 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
	 *
	 * e.g. for `enabled` true condition:
	 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
	 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
	 *
	 * To test this, run the unit test, and then force this function to return new stuff on every call
	 * e.g. `return { ...result, random: Math.random() };`
	 * it will result in increase renderCount in the unit test
	 */ (cache, key, initialQueryEnabled)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: initialQueryEnabled
    });
const $2c362c1c58e43242$var$useCacheEntry = (0, $9zUhf.createHook)($2c362c1c58e43242$var$store, {
    selector: $2c362c1c58e43242$var$selector
});
const $2c362c1c58e43242$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $42omo.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $42omo.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $42omo.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $2c362c1c58e43242$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            updateCacheEntry(queryKey, {
                data: response
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $flpNp.mapErrorToApiError)(error);
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $fFa3V.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData
    };
};
module.exports["useQuery"] = $2c362c1c58e43242$export$dd0a697e1782aedd;

});

parcelRegister("ffpG2", function(module, exports) {

var $fBMbo = parcelRequire("fBMbo");


var $b62XF = parcelRequire("b62XF");


var $9eSnh = parcelRequire("9eSnh");

const $824f750b126db2e8$export$cf57de7718965ae3 = {
    hasNextPage: false,
    hasPreviousPage: false,
    startCursor: undefined,
    endCursor: undefined
};
const $824f750b126db2e8$var$transformAgentListToGqlResponse = (response)=>{
    try {
        // data can be null if the `abortController` is aborted
        const { edges: edges, pageInfo: pageInfo } = response?.data?.agentStudio_getAgents ?? {
            pageInfo: $824f750b126db2e8$export$cf57de7718965ae3
        };
        const agents = edges?.map((edge)=>(0, $9eSnh.transformAgentGqlResponse)(edge.node)).filter((agent)=>!!agent.id) ?? [];
        return {
            agents: agents,
            pageInfo: pageInfo
        };
    } catch  {
        return {
            agents: [],
            pageInfo: {
                hasNextPage: false,
                hasPreviousPage: false,
                startCursor: undefined,
                endCursor: undefined
            }
        };
    }
};
const $824f750b126db2e8$var$agentStudioAssistantFragment = `
fragment conversationAssistantAgent_agentStudioAssistant on AgentStudioAssistant {
  id
  name
  description
  conversationStarters
  isFavourite
  creatorType
  identityAccountId
  externalConfigReference
  creator {
    id
  }
  icon
  authoringTeam {
    id
    profileUrl
    displayName
	smallAvatarImageUrl
  }
}
`;
const $824f750b126db2e8$export$44f796a68d9bc9f1 = async ({ cloudId: cloudId, count: count = 10, after: after, product: product, input: input, abortController: abortController, workspaceId: workspaceId })=>{
    (0, $fBMbo.di)((0, $b62XF.performGqlFetch));
    const gqlQuery = `
	query agentStudioGetAgents($cloudId: String!, $first: Int, $input: AgentStudioAgentQueryInput, $after: String, $product: String, $workspaceId: String) {
		agentStudio_getAgents(
			cloudId: $cloudId
			first: $first
			input: $input
			after: $after
			product: $product
			workspaceId: $workspaceId
		) @optIn(to: "AgentStudio") {
			edges {
				node {
					...conversationAssistantAgent_agentStudioAssistant
				}
			}
			pageInfo {
				startCursor
				endCursor
				hasNextPage
				hasPreviousPage
			}
		}
	}

	${$824f750b126db2e8$var$agentStudioAssistantFragment}
	`;
    const variables = {
        cloudId: cloudId,
        first: count,
        after: after,
        product: product,
        input: input,
        workspaceId: workspaceId
    };
    const response = await (0, $b62XF.performGqlFetch)({
        gqlQuery: gqlQuery,
        variables: variables,
        abortController: abortController
    });
    return $824f750b126db2e8$var$transformAgentListToGqlResponse(response);
};
const $824f750b126db2e8$export$fce04ce5e2fe57d3 = async ({ cloudId: cloudId, externalConfigReference: externalConfigReference })=>{
    (0, $fBMbo.di)((0, $b62XF.performGqlFetch));
    const gqlQuery = `
	query agentStudioGetAgentByExternalConfigReference($cloudId: String!, $externalConfigReference: String!) {
		agentStudio_getByExternalReference(cloudId: $cloudId, externalReference: $externalConfigReference) @optIn(to: "AgentStudio") {
			...conversationAssistantAgent_agentStudioAssistant
		}
	}

	${$824f750b126db2e8$var$agentStudioAssistantFragment}
	`;
    const variables = {
        cloudId: cloudId,
        externalConfigReference: externalConfigReference
    };
    const response = await (0, $b62XF.performGqlFetch)({
        gqlQuery: gqlQuery,
        variables: variables
    });
    return (0, $9eSnh.transformAgentGqlResponse)(response.data.agentStudio_getByExternalReference);
};
module.exports["DEFAULT_PAGE_INFO"] = $824f750b126db2e8$export$cf57de7718965ae3;
module.exports["fetchPaginatedAgents"] = $824f750b126db2e8$export$44f796a68d9bc9f1;
module.exports["fetchAgentByExternalConfigReference"] = $824f750b126db2e8$export$fce04ce5e2fe57d3;

});

parcelRegister("b62XF", function(module, exports) {

var $8Igpw = parcelRequire("8Igpw");

const $37e96b9c44d16228$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : undefined;
};
const $37e96b9c44d16228$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables, abortController: abortController })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            }),
            signal: abortController?.signal
        });
        const json = await response.json();
        if (json?.errors?.length) await $37e96b9c44d16228$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        return json;
    } catch (err) {
        // GqlApiError is already processed
        if (err instanceof $37e96b9c44d16228$export$ba203f24e0131ba7) throw err;
        // Handle abort signal gracefully, it shouldn't be considered an error despite being caught
        if (err instanceof Error && err.name === 'AbortError') return {
            data: null,
            errors: undefined
        };
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        throw new (0, $8Igpw.FetchError)(`GraphQL query failed (promise rejected): ${originalErrorMessage}`, {
            errorCode: 'performGqlFetchError'
        });
    }
};
class $37e96b9c44d16228$export$ba203f24e0131ba7 extends Error {
    constructor({ errors: errors, queryName: queryName }){
        const errorsString = errors.map((error)=>error.message).join(', ');
        const errorMessage = `GraphQL API error: ${errorsString}`;
        super(errorMessage);
        this.message = void 0;
        this.errorAttributes = void 0;
        this.message = errorMessage;
        this.name = 'GraphQLError';
        this.errorAttributes = {
            errorCode: 'GqlApiError',
            queryName: queryName,
            rawErrorMessage: errorMessage,
            errors: errorsString
        };
    }
}
const $37e96b9c44d16228$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $37e96b9c44d16228$export$ba203f24e0131ba7({
        errors: errorsToThrow,
        queryName: $37e96b9c44d16228$var$extractQueryName(gqlQuery)
    });
};
module.exports["performGqlFetch"] = $37e96b9c44d16228$export$f602b5befecb0b84;

});

parcelRegister("9eSnh", function(module, exports) {
const $ddc6cc090d64d6da$export$92f11cf4e802b166 = (ari)=>{
    // Pattern: ari:cloud:rovo::agent/activation/{uuid}/{uuid}
    const ariPattern = /^ari:cloud:rovo::agent\/activation\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/([^/]+)$/;
    const match = ari.match(ariPattern);
    if (!match) return null;
    // Return the second UUID (agent ID)
    return match[1];
};
const $ddc6cc090d64d6da$export$91e35509133d1cc1 = (agentNode)=>({
        creator_type: agentNode.creatorType,
        creator: agentNode.creator?.id,
        description: agentNode.description,
        external_config_reference: agentNode.externalConfigReference,
        favourite: agentNode.isFavourite,
        id: $ddc6cc090d64d6da$export$92f11cf4e802b166(agentNode.id) ?? '',
        identity_account_id: agentNode.identityAccountId,
        name: agentNode.name,
        user_defined_conversation_starters: agentNode.conversationStarters,
        icon: agentNode.icon,
        // We need named_id here as the FE requires it for certain features
        named_id: $ddc6cc090d64d6da$export$92f11cf4e802b166(agentNode.id) ?? '',
        authoring_team: agentNode?.authoringTeam ? {
            id: agentNode.authoringTeam.id,
            profile_url: agentNode.authoringTeam.profileUrl,
            display_name: agentNode.authoringTeam.displayName,
            avatar_url: agentNode.authoringTeam.smallAvatarImageUrl
        } : null
    });
module.exports["transformAgentGqlResponse"] = $ddc6cc090d64d6da$export$91e35509133d1cc1;

});

parcelRegister("iswAx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $fBMbo = parcelRequire("fBMbo");


var $2Nwuj = parcelRequire("2Nwuj");


var $4Nwes = parcelRequire("4Nwes");


var $9EfFC = parcelRequire("9EfFC");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");


var $9uTsJ = parcelRequire("9uTsJ");


var $kpYGL = parcelRequire("kpYGL");


var $1yaYZ = parcelRequire("1yaYZ");


var $9eLw5 = parcelRequire("9eLw5");


var $26nu6 = parcelRequire("26nu6");


var $cqFPV = parcelRequire("cqFPV");


var $fQF1W = parcelRequire("fQF1W");


var $eOn3v = parcelRequire("eOn3v");


var $5kyLi = parcelRequire("5kyLi");

const $baa53903be441878$export$3761e66a04602cbd = (ari)=>{
    const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
    return matched ? matched[1] : undefined;
};
const $baa53903be441878$export$acf3e1bcf222b00d = (aaid)=>{
    return `ari:cloud:identity::user/${aaid}`;
};
const $baa53903be441878$export$1565ea9a9fb7ad67 = ({ agent: agent, siteId: siteId, simplified: simplified })=>{
    if ((0, $26nu6.isSystemAgent)(agent) || (0, $26nu6.isOOTBAgent)(agent) || !agent.creator) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        testId: "atlassian-icon",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4Nwes.AtlassianIcon), {
                label: "",
                appearance: "brand",
                size: "small"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                children: "Atlassian"
            })
        ]
    });
    if ((0, $26nu6.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) return /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
            alignBlock: "center",
            testId: "atlassian-icon",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                href: authoringTeam.profile_url,
                target: "_blank",
                children: authoringTeam.display_name
            })
        });
        const aaid = agent.creator ? $baa53903be441878$export$3761e66a04602cbd(agent.creator) : undefined;
        if (!aaid) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)($baa53903be441878$var$ResolvingMention, {
            userId: aaid,
            siteId: siteId,
            profileCard: true,
            simplified: simplified
        });
    }
    if ((0, $26nu6.isForgeAgent)(agent)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        children: agent.creator
    });
    return null;
};
// TODO consolidate this with `AgentCreator` component `platform/packages/ai-mate/conversation-assistant-agent/src/common/ui/creator/index.tsx`
const $baa53903be441878$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false })=>{
    (0, $fBMbo.di)($baa53903be441878$export$5d980898591175e);
    const { profile: profile, client: client } = $baa53903be441878$export$5d980898591175e(userId, siteId);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { atlasURL: atlasURL } = (0, $fQF1W.useAtlasURL)(siteId);
    const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, $5kyLi.default).deactivatedCreatorName, {
        name: profile.data.fullName
    }) : profile.data?.fullName;
    if (profile.isFetching || !profile.data) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
        isShimmering: true,
        height: 18,
        width: 100,
        borderRadius: 3
    });
    if (simplified) {
        const profileUrl = atlasURL(`/people/${userId}`);
        return (0, $dh538.fg)('dst-a11y__replace-anchor-with-link__ai-mate') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
            href: profileUrl,
            target: "_blank",
            children: fullName
        }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, $l998X.jsx)("a", {
            href: profileUrl,
            target: "_blank",
            children: fullName
        });
    }
    return profileCard ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9uTsJ.default), {
        userId: userId,
        resourceClient: client,
        ariaLabel: fullName,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9EfFC.default), {
            id: userId,
            isHighlighted: profile.data.isCurrentUser,
            text: `@${fullName}`
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9EfFC.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    });
};
function $baa53903be441878$export$5d980898591175e(userId, siteId, shouldFetch = true) {
    const profileClient = (0, $eOn3v.useProfileClient)();
    const profile = (0, $9eLw5.useQuery)({
        queryKey: [
            'fetchProfile',
            siteId,
            userId
        ],
        queryFn: async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (error) {
                (0, $1yaYZ.logException)({
                    exception: error,
                    name: 'ConversationAssistantAgentUseProfileResolutionError'
                });
                return {};
            }
        },
        enabled: shouldFetch
    });
    return {
        profile: profile,
        client: profileClient
    };
}
const $baa53903be441878$export$13d60404a0dddebd = (agents, filters)=>{
    return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
};
const $baa53903be441878$export$a6e36c224ec3c0cb = (agent)=>{
    const enabledSources = agent.scenarios?.filter((scenario)=>scenario.isActive && scenario.isValid?.value)?.flatMap((scenario)=>scenario.knowledgeSources).filter((source)=>source?.enabled).flatMap((source)=>source?.sources).filter((source)=>source?.enabled);
    if (!enabledSources?.length) return [];
    const allAris = enabledSources?.reduce((acc, cur)=>{
        const allFilters = [
            ...cur?.filters?.parentFilter ?? [],
            ...cur?.filters?.spaceFilter ?? [],
            ...cur?.filters?.projectFilter ?? []
        ];
        allFilters.forEach((item)=>acc.add(item));
        return acc;
    }, new Set());
    return Array.from(allAris);
};
const $baa53903be441878$export$6d876204c5d593ac = ({ availableAgents: availableAgents, product: product })=>{
    // If no product is provided / product is not supported, fallback to using default agents
    const defaultAgentsNamedIds = product ? (0, $cqFPV.DEFAULT_OOTB_AGENTS_NAMED_IDS)[product] ?? (0, $cqFPV.DEFAULT_AGENTS_NAMED_ID_LIST) : (0, $cqFPV.DEFAULT_AGENTS_NAMED_ID_LIST);
    const defaultAgents = availableAgents.filter((agent)=>defaultAgentsNamedIds.has(agent.named_id) || agent.external_config_reference && defaultAgentsNamedIds.has(agent.external_config_reference));
    return defaultAgents;
};
module.exports["getAAIDFromARI"] = $baa53903be441878$export$3761e66a04602cbd;
module.exports["getARIFromAAID"] = $baa53903be441878$export$acf3e1bcf222b00d;
module.exports["AgentCreatedBy"] = $baa53903be441878$export$1565ea9a9fb7ad67;
module.exports["useProfileResolution"] = $baa53903be441878$export$5d980898591175e;
module.exports["getEnabledKnowlegeArisFromAgent"] = $baa53903be441878$export$a6e36c224ec3c0cb;
module.exports["getSuggestedOotbAgents"] = $baa53903be441878$export$6d876204c5d593ac;

});

parcelRegister("26nu6", function(module, exports) {
const $04c28723649a2305$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
const $04c28723649a2305$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
const $04c28723649a2305$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE';
const $04c28723649a2305$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
const $04c28723649a2305$export$7091e3bee2adaacb = (agent)=>agent.creator_type === 'OOTB';
const $04c28723649a2305$export$916e4870f74f205b = {
    ALL_AGENTS: 'all-agents',
    STARRED_AGENTS: 'starred-agents',
    MY_AGENTS: 'my-agents',
    TEMPLATES: 'templates'
};
module.exports["isSystemAgent"] = $04c28723649a2305$export$7c120b233d4844c6;
module.exports["isCustomerAgent"] = $04c28723649a2305$export$f817e52cf2c5cc8c;
module.exports["isForgeAgent"] = $04c28723649a2305$export$2149adda3d8a5807;
module.exports["isOOTBAgent"] = $04c28723649a2305$export$7091e3bee2adaacb;

});

parcelRegister("cqFPV", function(module, exports) {
const $570a782ebb8f75e0$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC'
};
const $570a782ebb8f75e0$export$2d0163867590928d = new Set([
    'decision_director_agent',
    'user_manual_writer_agent',
    'product_requirements_expert_agent'
]);
const $570a782ebb8f75e0$export$804d9ee5f4cc40a8 = {
    ['confluence']: new Set([
        'decision_director_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ]),
    ['jira']: new Set([
        'rovo_expert_agent',
        'issue_organizer_agent',
        'jira_theme_analyzer_agent'
    ]),
    ['atlas']: new Set([
        'progress_tracker_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ])
};
const $570a782ebb8f75e0$var$AGENT_AUP_ERROR_CODE = `convoai.agent.responsible-ai.failure`;
const $570a782ebb8f75e0$var$HIPAA_ERROR_CODE = 'convoai.rest.browsing.product.has.hipaa.enabled';
const $570a782ebb8f75e0$export$a08ace1426fa4a9e = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $570a782ebb8f75e0$var$AGENT_AUP_ERROR_CODE;
const $570a782ebb8f75e0$export$f8b1b75846492611 = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $570a782ebb8f75e0$var$HIPAA_ERROR_CODE;
const $570a782ebb8f75e0$export$429080cfef3412f2 = 'browse-agents-container';
module.exports["DEFAULT_AGENTS_NAMED_ID_LIST"] = $570a782ebb8f75e0$export$2d0163867590928d;
module.exports["DEFAULT_OOTB_AGENTS_NAMED_IDS"] = $570a782ebb8f75e0$export$804d9ee5f4cc40a8;
module.exports["isCreateOrEditAgentAUPError"] = $570a782ebb8f75e0$export$a08ace1426fa4a9e;
module.exports["isHipaaError"] = $570a782ebb8f75e0$export$f8b1b75846492611;
module.exports["AGENTS_CONTAINER_ID"] = $570a782ebb8f75e0$export$429080cfef3412f2;

});

parcelRegister("fQF1W", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $827Ne = parcelRequire("827Ne");


var $dYtRL = parcelRequire("dYtRL");

const $2a6bb271c0fd2ecb$export$8a1abb7c176bd202 = (siteId)=>{
    const { data: tenantData } = (0, $dYtRL.useTenantDataController)(siteId);
    const atlasURL = (0, $42omo.useCallback)((path)=>(0, $827Ne.getAtlasURL)(siteId, path, tenantData?.orgId), [
        siteId,
        tenantData?.orgId
    ]);
    return {
        atlasURL: atlasURL
    };
};
const $2a6bb271c0fd2ecb$export$b61b99f9ac0264be = (siteId)=>{
    const { atlasURL: atlasURL } = $2a6bb271c0fd2ecb$export$8a1abb7c176bd202(siteId);
    return atlasURL('/chat/agents/new');
};
module.exports["useAtlasURL"] = $2a6bb271c0fd2ecb$export$8a1abb7c176bd202;
module.exports["useCreateAgentAtlasURL"] = $2a6bb271c0fd2ecb$export$b61b99f9ac0264be;

});

parcelRegister("827Ne", function(module, exports) {

var $6FQwA = parcelRequire("6FQwA");


var $bhcGS = parcelRequire("bhcGS");

const $5ae4133df3384b49$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $5ae4133df3384b49$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $5ae4133df3384b49$export$5105758c0e772381 = ()=>{
    return (0, $bhcGS.isStaging)() ? $5ae4133df3384b49$var$ATLAS_STAGING_URL : $5ae4133df3384b49$var$ATLAS_PROD_URL;
};
const $5ae4133df3384b49$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    const basePath = orgId ? `${$5ae4133df3384b49$export$5105758c0e772381()}/o/${orgId}` : $5ae4133df3384b49$export$5105758c0e772381();
    return (0, $6FQwA.addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
        cloudId: siteId
    });
};
module.exports["getAtlasHost"] = $5ae4133df3384b49$export$5105758c0e772381;
module.exports["getAtlasURL"] = $5ae4133df3384b49$export$bfee0f88bf621ad3;

});

parcelRegister("bhcGS", function(module, exports) {
const $f2c917fe02396491$export$23da1d24a38b0bde = ()=>{
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
};
module.exports["isStaging"] = $f2c917fe02396491$export$23da1d24a38b0bde;

});

parcelRegister("dYtRL", function(module, exports) {

var $fBMbo = parcelRequire("fBMbo");


var $16lEl = parcelRequire("16lEl");


var $7pmZw = parcelRequire("7pmZw");


var $9eLw5 = parcelRequire("9eLw5");


var $hGGLc = parcelRequire("hGGLc");

const $63d59501eb65c4db$export$b863fec6791eae25 = (siteId)=>{
    (0, $fBMbo.di)((0, $9eLw5.useQuery));
    const experience = (0, $7pmZw.useAIMateExperienceTracker)();
    const { data: data, isFetching: isFetching, error: error } = (0, $9eLw5.useQuery)({
        queryKey: [
            'viewAgentTenantData',
            siteId
        ],
        queryFn: async ()=>{
            experience.start({
                id: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
            const result = await (0, $hGGLc.getCloudUrlFromId)(siteId);
            return result;
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                error: error
            });
        }
    });
    return {
        data: data,
        isFetching: isFetching,
        error: error
    };
};
module.exports["useTenantDataController"] = $63d59501eb65c4db$export$b863fec6791eae25;

});

parcelRegister("hGGLc", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $b62XF = parcelRequire("b62XF");

const $0fc4c72c92b990ea$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
	orgId
  }
}
`;
const $0fc4c72c92b990ea$var$cache = new Map();
const $0fc4c72c92b990ea$export$d4ace54df9bd6bb1 = async (cloudId)=>{
    // If AIFC is enabled, use the new caching
    if ((0, $dh538.fg)('aifc_create_enabled')) {
        // Check if we already have a pending promise or cached result
        if ($0fc4c72c92b990ea$var$cache.has(cloudId)) return $0fc4c72c92b990ea$var$cache.get(cloudId);
        const response = await (0, $b62XF.performGqlFetch)({
            gqlQuery: $0fc4c72c92b990ea$var$CloudIdLookupQuery,
            variables: {
                cloudIds: [
                    cloudId
                ]
            }
        });
        const result = response.data?.tenantContexts?.[0];
        if (result) // Store the promise in the cache
        $0fc4c72c92b990ea$var$cache.set(cloudId, result);
        return result;
    }
    const response = await (0, $b62XF.performGqlFetch)({
        gqlQuery: $0fc4c72c92b990ea$var$CloudIdLookupQuery,
        variables: {
            cloudIds: [
                cloudId
            ]
        }
    });
    return response.data?.tenantContexts?.[0];
};
module.exports["getCloudUrlFromId"] = $0fc4c72c92b990ea$export$d4ace54df9bd6bb1;

});

parcelRegister("eOn3v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $fHxn4 = parcelRequire("fHxn4");

const $1bde4828e2efe4cf$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
let $1bde4828e2efe4cf$var$client;
const $1bde4828e2efe4cf$export$d43dc22a8337ee9f = ()=>{
    (0, $fBMbo.di)((0, $fHxn4.default));
    const profileClient = (0, $42omo.useMemo)(()=>{
        if (!$1bde4828e2efe4cf$var$client) // To support di
        $1bde4828e2efe4cf$var$client = new (0, $fHxn4.default)({
            url: $1bde4828e2efe4cf$var$DIRECTORY_URL,
            cacheSize: 1000,
            // 1 day
            cacheMaxAge: 86400000
        });
        return $1bde4828e2efe4cf$var$client;
    }, []);
    return profileClient;
};
module.exports["useProfileClient"] = $1bde4828e2efe4cf$export$d43dc22a8337ee9f;

});

parcelRegister("5kyLi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b55ef878efda143d$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $b55ef878efda143d$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    deactivatedCreatorName: {
        id: "rovo-chat.agent-card.deactivated-name",
        defaultMessage: "{name} (deactivated)"
    }
});

});

parcelRegister("1uFMJ", function(module, exports) {

var $16lEl = parcelRequire("16lEl");


var $h26dv = parcelRequire("h26dv");

var $29BPs = parcelRequire("29BPs");


var $2Cfy4 = parcelRequire("2Cfy4");

const $4188851fb0c3debc$export$89877d4f8d8790ca = (0, $h26dv.createHookWithAssistanceService)(({ onSuccess: onSuccess, onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, onInit: onInit })=>{
    const deleteAgent = (0, $29BPs.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).DELETE_AGENT,
                name: (0, $16lEl.ExperienceName).DELETE_AGENT
            });
            onInit?.(id);
            return await assistanceService.deleteAgent(id);
        },
        onSuccess: async (data)=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).DELETE_AGENT
            });
            onSuccess?.();
            return data;
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).DELETE_AGENT,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.();
        }
    });
    return {
        deleteAgent: deleteAgent
    };
});
module.exports["useDeleteAgent"] = $4188851fb0c3debc$export$89877d4f8d8790ca;

});

parcelRegister("29BPs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $flpNp = parcelRequire("flpNp");

const $e1cff82b24aa7fdd$export$609860bf8b0084c = ({ mutationFn: mutationFn, onSuccess: onSuccess, onError: onError })=>{
    const mutationFnRef = (0, $42omo.useRef)(mutationFn);
    mutationFnRef.current = mutationFn;
    const onSuccessRef = (0, $42omo.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $42omo.useRef)(onError);
    onErrorRef.current = onError;
    const [data, setData] = (0, $42omo.useState)(null);
    const [error, setError] = (0, $42omo.useState)(null);
    const [isSubmitting, setIsSubmitting] = (0, $42omo.useState)(false);
    const mutate = (0, $42omo.useCallback)(async (payload, mutateCallback)=>{
        setIsSubmitting(true);
        try {
            const response = await mutationFnRef.current(payload);
            setData(response);
            onSuccessRef.current?.(response);
            mutateCallback?.onSuccess?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $flpNp.mapErrorToApiError)(error);
            setError(apiError);
            onErrorRef.current?.(apiError, payload);
            mutateCallback?.onError?.(apiError);
        } finally{
            setIsSubmitting(false);
        }
    }, []);
    return {
        data: data,
        error: error,
        isSubmitting: isSubmitting,
        mutate: mutate
    };
};
module.exports["useMutation"] = $e1cff82b24aa7fdd$export$609860bf8b0084c;

});

parcelRegister("4ul15", function(module, exports) {

var $16lEl = parcelRequire("16lEl");


var $h26dv = parcelRequire("h26dv");

var $29BPs = parcelRequire("29BPs");


var $2Cfy4 = parcelRequire("2Cfy4");

const $d9bcfe62b373548d$export$5c4c46b1f93a6e69 = (0, $h26dv.createHookWithAssistanceService)(({ onError: onError, onSuccess: onSuccess, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    const favouriteAgent = (0, $29BPs.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).FAVOURITE_AGENT,
                name: (0, $16lEl.ExperienceName).FAVOURITE_AGENT
            });
            return await assistanceService.favouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).FAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: true
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).FAVOURITE_AGENT,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.({
                favourite: true
            });
        }
    });
    const unfavouriteAgent = (0, $29BPs.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).UNFAVOURITE_AGENT,
                name: (0, $16lEl.ExperienceName).UNFAVOURITE_AGENT
            });
            return await assistanceService.unfavouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).UNFAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: false
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).UNFAVOURITE_AGENT,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.({
                favourite: false
            });
        }
    });
    return {
        favouriteAgent: favouriteAgent,
        unfavouriteAgent: unfavouriteAgent
    };
});
module.exports["useAgentFavourites"] = $d9bcfe62b373548d$export$5c4c46b1f93a6e69;

});

parcelRegister("hT0Hx", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6570846fafa2bfa7$export$ccc6603eb027f48b = /*#__PURE__*/ (0, $42omo.createContext)({});
const $6570846fafa2bfa7$export$7b61e11d4e81ba17 = ()=>(0, $42omo.useContext)($6570846fafa2bfa7$export$ccc6603eb027f48b);
const $6570846fafa2bfa7$export$aa582af5b4b72bb2 = $6570846fafa2bfa7$export$ccc6603eb027f48b.Provider;
const $6570846fafa2bfa7$export$6aab84dc399ad753 = (config)=>({
        agentDefaultIdOverride: config?.defaultAgentId,
        agentIdFiltersOverride: config?.filter
    });
module.exports["useAgentOverrider"] = $6570846fafa2bfa7$export$7b61e11d4e81ba17;
module.exports["AgentOverriderProvider"] = $6570846fafa2bfa7$export$aa582af5b4b72bb2;
module.exports["createAgentsConfig"] = $6570846fafa2bfa7$export$6aab84dc399ad753;

});

parcelRegister("37oID", function(module, exports) {
const $12593467a1d8dec1$export$b873e2166b2a4c4f = (agents, agentIdFiltersOverride, agentDefaultIdOverride)=>{
    const defaultOverrideAgentsIndex = agents.findIndex((agent)=>agentDefaultIdOverride === agent.id);
    let overridenAgents = [];
    if (defaultOverrideAgentsIndex !== -1) overridenAgents = agents.map((agent, index)=>({
            ...agent,
            is_default: index === defaultOverrideAgentsIndex
        }));
    else overridenAgents = agents;
    if (Array.isArray(agentIdFiltersOverride)) return overridenAgents.filter((agent)=>agentIdFiltersOverride?.includes(agent.id) || agent.is_default);
    return overridenAgents;
};
module.exports["getOverridenAgents"] = $12593467a1d8dec1$export$b873e2166b2a4c4f;

});

parcelRegister("ka7s2", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2b97d183040b705$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $e2b97d183040b705$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    defaultAgentName: {
        id: "ai-mate.agent-selector.default-agent-name",
        defaultMessage: "Chat"
    },
    defaultAgentDescription: {
        id: "ai-mate.agent-selector.default-agent-description",
        defaultMessage: "Get answers, generate new ideas, and accelerate everyday work."
    }
});

});

parcelRegister("eToX6", function(module, exports) {
/**
 * Utility functions for detecting and working with preview panels
 */ // Types for preview panel detection
// Preview panel indicators
const $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
/**
 * Gets URL search parameters safely
 */ const $cf00e918e2c1556d$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $cf00e918e2c1556d$export$5c3b154013d00c5f = (searchParams)=>{
    return searchParams.has($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $cf00e918e2c1556d$export$cd88bef28d20da33 = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $cf00e918e2c1556d$var$getUrlSearchParams(currentSearch);
            if (currentParams && $cf00e918e2c1556d$export$5c3b154013d00c5f(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $cf00e918e2c1556d$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
module.exports["hasPreviewPanelIndicators"] = $cf00e918e2c1556d$export$5c3b154013d00c5f;
module.exports["isInPreviewPanel"] = $cf00e918e2c1556d$export$cd88bef28d20da33;
module.exports["isInIframe"] = $cf00e918e2c1556d$export$9f140ed41af5108c;

});

parcelRegister("7ShCl", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $3d55d2ba43147efd$export$480e55f805d7990f = (0, $cgtv4.defineMessages)({
    // Event hub messages
    eventHubfallbackSuggestedTitle: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitle",
        defaultMessage: "Page title"
    },
    eventHubfallbackSuggestedTitlePrefix: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix",
        defaultMessage: "Page"
    },
    // Toolbar messages
    aiToolbarTitle: {
        id: "fabric.editor.ai.toolbar.titleText",
        defaultMessage: "Atlassian Intelligence"
    },
    improveWritingToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.improveWriting.title",
        defaultMessage: "Improve writing"
    },
    improveWritingToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.improveWriting.tooltip",
        defaultMessage: "Tell Atlassian Intelligence to improve the writing of your selection"
    },
    askAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askAI.title",
        defaultMessage: "Ask AI"
    },
    askRovoToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.title",
        defaultMessage: "Ask Rovo"
    },
    moreRovoOptionsMenuLabel: {
        id: "fabric.editor.ai.toolbar.moreRovoOptions.label",
        defaultMessage: "More Rovo options"
    },
    askRovoAiSplitButtonLabel: {
        id: "fabric.editor.ai.toolbar.askRovoAiSplitButton.label",
        defaultMessage: "Ask Rovo AI"
    },
    askAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    askAIToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand",
        defaultMessage: "Ask AI {key}+'"
    },
    askRovoToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand",
        defaultMessage: "Ask Rovo {key}+'"
    },
    tryAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.tryAI.title",
        defaultMessage: "Try AI"
    },
    tryAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    simplifiedAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.simplifiedAI.title",
        defaultMessage: "AI"
    },
    summarizeToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.summarize.title",
        defaultMessage: "Summarize"
    },
    translateToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.translate.title",
        defaultMessage: "Translate"
    },
    translateOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.translateOptions.label",
        defaultMessage: "Translate options"
    },
    spellingAndGrammarToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.spellingAndGrammar.title",
        defaultMessage: "Fix spelling and grammar"
    },
    makeLongerToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeLonger.title",
        defaultMessage: "Make longer"
    },
    makeShorterToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeShorter.title",
        defaultMessage: "Make shorter"
    },
    changeToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.changeTone.title",
        defaultMessage: "Change tone"
    },
    changeToneOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.changeToneOptions.title",
        defaultMessage: "Change tone options"
    },
    moreProfessionalToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreProfessionalTone.title",
        defaultMessage: "More professional"
    },
    moreCasualToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreCasualTone.title",
        defaultMessage: "More casual"
    },
    moreEmpatheticToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreEmpatheticTone.title",
        defaultMessage: "More empathetic"
    },
    adjustLengthToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.adjustLength.title",
        defaultMessage: "Adjust length"
    },
    DefineDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.DefineDropdownIconTitle.title",
        defaultMessage: "Define"
    },
    // Prebuilt messages
    atlasGenerateContentConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription",
        defaultMessage: "Generates content to be inserted into the update"
    },
    atlasSummarizePageConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription",
        defaultMessage: "Summarizes the content of the update"
    },
    confluenceChangeToneSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Change tone"
    },
    confluenceRewriteSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Rewrite"
    },
    confluenceTranslateSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Translate"
    },
    // AI Panel Action items messages
    actionItemsPageTitle: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageTitle",
        defaultMessage: "Action items panel (Beta)"
    },
    actionItemsPageDescription: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageDescription",
        defaultMessage: "Use Atlassian Intelligence to find action items and display in a panel"
    },
    // AI Panel Summarise page messages
    summarizePageTitle: {
        id: "fabric.editor.ai.ai-panels.summarizePageTitle",
        defaultMessage: "Page summary panel (Beta)"
    },
    summarisePageDescription: {
        id: "fabric.editor.ai.ai-panels.summarizePageDescription",
        defaultMessage: "Use Atlassian Intelligence to summarize this page and display in a panel"
    },
    // Agent messages
    agentsDropdownTitle: {
        id: "rovo.agents.dropdown.title",
        defaultMessage: "Agents"
    },
    agentsViewAgentsLabel: {
        id: "rovo.agents.dropdown.viewAgents.label",
        defaultMessage: "View all agents"
    },
    // Error messages
    unhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.unhandledErrorMessage",
        defaultMessage: "We're having trouble. Close the dialog and try again."
    },
    cmdPaletteUnhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage",
        defaultMessage: "We're having issues and can't generate a response right now. Try again later."
    },
    markdownErrorMessage: {
        id: "fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage",
        defaultMessage: "We're having trouble generating the preview. Close the dialog and try again."
    },
    // Prompt Builder messages
    promptbuilderAriaLabel: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel",
        defaultMessage: "Ask Atlassian Intelligence"
    },
    promptBuilderFromButton: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit",
        defaultMessage: "Generate"
    },
    // AI Smart button messages
    aiSmartButtonDynamicSurfaceSelectedContent: {
        id: "fabric.editor.ai.ai-smart-button.context.reference",
        defaultMessage: "Selected content"
    },
    // Telepointer
    aiRovoTelepointer: {
        id: "fabric.editor.ai.telepointer.rovo",
        defaultMessage: "Rovo"
    }
});
module.exports["aiMessages"] = $3d55d2ba43147efd$export$480e55f805d7990f;

});

parcelRegister("kw19Z", function(module, exports) {

var $iyDxB = parcelRequire("iyDxB");


var $hZW9z = parcelRequire("hZW9z");

class $0be842260db55ec0$export$2e2bcd8739ae039 {
    serializeFragment(fragment) {
        const result = [];
        fragment.forEach((n)=>{
            result.push((0, $hZW9z.reduce)(n, this.schema));
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return result.join('\n').replace(/\n+/g, '\n');
    }
    static fromSchema(schema = (0, $iyDxB.defaultSchema)) {
        return new $0be842260db55ec0$export$2e2bcd8739ae039(schema);
    }
    constructor(schema){
        this.schema = schema;
        this.schema = schema;
    }
}
module.exports["default"] = $0be842260db55ec0$export$2e2bcd8739ae039;

});

parcelRegister("hZW9z", function(module, exports) {

var $dpr67 = parcelRequire("dpr67");


var $4lxYo = parcelRequire("4lxYo");


var $lnC5W = parcelRequire("lnC5W");


var $luMIx = parcelRequire("luMIx");


var $j4yOf = parcelRequire("j4yOf");


var $80lKV = parcelRequire("80lKV");


var $4pSzj = parcelRequire("4pSzj");


var $7oJlc = parcelRequire("7oJlc");


var $6BJLi = parcelRequire("6BJLi");


var $9553M = parcelRequire("9553M");


var $1XLKe = parcelRequire("1XLKe");


var $8SD1i = parcelRequire("8SD1i");


var $ntsJf = parcelRequire("ntsJf");


var $hhMD5 = parcelRequire("hhMD5");


var $7O1my = parcelRequire("7O1my");


var $14o7M = parcelRequire("14o7M");


var $fNci1 = parcelRequire("fNci1");


var $bvn5Z = parcelRequire("bvn5Z");

const $06474df1136b3dc1$export$533b26079ad0b4b = (node, schema)=>{
    const reducer = $06474df1136b3dc1$var$nodeToReducerMapping[node.type.name] || $06474df1136b3dc1$var$nodeToReducerMapping.unknown;
    return reducer(node, schema);
};
const $06474df1136b3dc1$var$nodeToReducerMapping = {
    blockquote: $dpr67.default,
    bulletList: $4lxYo.default,
    date: $lnC5W.default,
    decisionItem: $luMIx.default,
    hardBreak: $j4yOf.default,
    heading: $80lKV.default,
    inlineCard: $4pSzj.default,
    listItem: $7oJlc.default,
    mediaGroup: $6BJLi.default,
    mention: $9553M.default,
    orderedList: $1XLKe.default,
    panel: $8SD1i.default,
    paragraph: $ntsJf.default,
    rule: $hhMD5.default,
    status: $7O1my.default,
    table: $14o7M.default,
    taskItem: $fNci1.default,
    unknown: $bvn5Z.default
};
module.exports["reduce"] = $06474df1136b3dc1$export$533b26079ad0b4b;

});

parcelRegister("dpr67", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $aa8f1012bb552b9a$var$blockquote = (node, schema)=>{
    const result = [];
    node.content.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    return `> ${result.join('')}`;
};
var $aa8f1012bb552b9a$export$2e2bcd8739ae039 = $aa8f1012bb552b9a$var$blockquote;
module.exports["default"] = $aa8f1012bb552b9a$export$2e2bcd8739ae039;

});

parcelRegister("4lxYo", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $6f70b3fb9c9a420a$var$bulletList = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push(`* ${(0, $hZW9z.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $6f70b3fb9c9a420a$export$2e2bcd8739ae039 = $6f70b3fb9c9a420a$var$bulletList;
module.exports["default"] = $6f70b3fb9c9a420a$export$2e2bcd8739ae039;

});

parcelRegister("lnC5W", function(module, exports) {

var $dIxHZ = parcelRequire("dIxHZ");


var $b7FrM = parcelRequire("b7FrM");

const $45097794511600bc$var$date = (node, _schema)=>{
    return node.attrs.timestamp ? (0, $dIxHZ.timestampToIsoFormat)(node.attrs.timestamp) : (0, $b7FrM.getText)(node);
};
var $45097794511600bc$export$2e2bcd8739ae039 = $45097794511600bc$var$date;
module.exports["default"] = $45097794511600bc$export$2e2bcd8739ae039;

});

parcelRegister("luMIx", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $a2f744f6dce90c93$var$decisionItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $hZW9z.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `<> ${result.join('').trim()}`;
};
var $a2f744f6dce90c93$export$2e2bcd8739ae039 = $a2f744f6dce90c93$var$decisionItem;
module.exports["default"] = $a2f744f6dce90c93$export$2e2bcd8739ae039;

});

parcelRegister("j4yOf", function(module, exports) {
const $28af56f2b8986b57$var$hardBreak = ()=>{
    return '\n';
};
var $28af56f2b8986b57$export$2e2bcd8739ae039 = $28af56f2b8986b57$var$hardBreak;
module.exports["default"] = $28af56f2b8986b57$export$2e2bcd8739ae039;

});

parcelRegister("80lKV", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $951f7824bed45cdb$var$heading = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    return result.join('');
};
var $951f7824bed45cdb$export$2e2bcd8739ae039 = $951f7824bed45cdb$var$heading;
module.exports["default"] = $951f7824bed45cdb$export$2e2bcd8739ae039;

});

parcelRegister("4pSzj", function(module, exports) {

var $b7FrM = parcelRequire("b7FrM");

const $defd2b7923d300de$var$inlineCard = (node, _schema)=>{
    return node.attrs.url || node.attrs.data?.url || (0, $b7FrM.getText)(node);
};
var $defd2b7923d300de$export$2e2bcd8739ae039 = $defd2b7923d300de$var$inlineCard;
module.exports["default"] = $defd2b7923d300de$export$2e2bcd8739ae039;

});

parcelRegister("7oJlc", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $134205d8b087ad65$var$listItem = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    return result.join('\n');
};
var $134205d8b087ad65$export$2e2bcd8739ae039 = $134205d8b087ad65$var$listItem;
module.exports["default"] = $134205d8b087ad65$export$2e2bcd8739ae039;

});

parcelRegister("6BJLi", function(module, exports) {
const $d832b43c98f4140b$var$mediaGroup = (node)=>{
    // count children which are media files
    // ignore card links
    let childMediaFilesCount = 0;
    node.content.forEach((childNode)=>{
        if (childNode.attrs.type === 'file') childMediaFilesCount += 1;
    });
    if (childMediaFilesCount) {
        const postfix = childMediaFilesCount > 1 ? 'Files' : 'File';
        return `\u{1F4CE} ${childMediaFilesCount} ${postfix}`;
    }
    return '';
};
var $d832b43c98f4140b$export$2e2bcd8739ae039 = $d832b43c98f4140b$var$mediaGroup;
module.exports["default"] = $d832b43c98f4140b$export$2e2bcd8739ae039;

});

parcelRegister("9553M", function(module, exports) {
const $788567eaebbf2e2c$var$mention = (node, _schema)=>{
    if ([
        'all',
        'here'
    ].indexOf(node.attrs.id) !== -1) return `@${node.attrs.id}`;
    return `${node.attrs.text || '@unknown'}`;
};
var $788567eaebbf2e2c$export$2e2bcd8739ae039 = $788567eaebbf2e2c$var$mention;
module.exports["default"] = $788567eaebbf2e2c$export$2e2bcd8739ae039;

});

parcelRegister("1XLKe", function(module, exports) {

var $irKZA = parcelRequire("irKZA");


var $hZW9z = parcelRequire("hZW9z");

const $d8d47451ce06aad1$var$orderedList = (node, schema)=>{
    const result = [];
    const order = (0, $irKZA.getOrderFromOrderedListNode)(node);
    node.forEach((n, _offset, index)=>{
        result.push(`${index + order}. ${(0, $hZW9z.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $d8d47451ce06aad1$export$2e2bcd8739ae039 = $d8d47451ce06aad1$var$orderedList;
module.exports["default"] = $d8d47451ce06aad1$export$2e2bcd8739ae039;

});

parcelRegister("8SD1i", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $49e4a61201921798$var$panel = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    return result.join('\n');
};
var $49e4a61201921798$export$2e2bcd8739ae039 = $49e4a61201921798$var$panel;
module.exports["default"] = $49e4a61201921798$export$2e2bcd8739ae039;

});

parcelRegister("ntsJf", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $c17bffe0d8dcd208$var$paragraph = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $hZW9z.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return result.join('').trim();
};
var $c17bffe0d8dcd208$export$2e2bcd8739ae039 = $c17bffe0d8dcd208$var$paragraph;
module.exports["default"] = $c17bffe0d8dcd208$export$2e2bcd8739ae039;

});

parcelRegister("hhMD5", function(module, exports) {
const $d065cc1601112956$var$rule = ()=>{
    return '';
};
var $d065cc1601112956$export$2e2bcd8739ae039 = $d065cc1601112956$var$rule;
module.exports["default"] = $d065cc1601112956$export$2e2bcd8739ae039;

});

parcelRegister("7O1my", function(module, exports) {

var $b7FrM = parcelRequire("b7FrM");

const $5da49fbb8ebaf963$var$status = (node, _schema)=>{
    return node.attrs.text ? `[ ${node.attrs.text.toUpperCase()} ]` : (0, $b7FrM.getText)(node);
};
var $5da49fbb8ebaf963$export$2e2bcd8739ae039 = $5da49fbb8ebaf963$var$status;
module.exports["default"] = $5da49fbb8ebaf963$export$2e2bcd8739ae039;

});

parcelRegister("14o7M", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $429219c4864a9efd$var$table = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push($429219c4864a9efd$var$tableRow(n, schema));
    });
    return result.join('\n');
};
const $429219c4864a9efd$var$tableRow = (node, schema)=>{
    const result = [];
    const separator = '|';
    node.forEach((n)=>{
        result.push($429219c4864a9efd$var$tableCell(n, schema));
    });
    return `${separator}${result.join(`${separator}`)}${separator}`;
};
const $429219c4864a9efd$var$tableCell = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    return result.join('\n');
};
var $429219c4864a9efd$export$2e2bcd8739ae039 = $429219c4864a9efd$var$table;
module.exports["default"] = $429219c4864a9efd$export$2e2bcd8739ae039;

});

parcelRegister("fNci1", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $96fce170cf034ba3$var$taskItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    const state = node.attrs.state === 'DONE' ? '[x]' : '[]';
    node.forEach((n)=>{
        const text = (0, $hZW9z.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `${state} ${result.join('').trim()}`;
};
var $96fce170cf034ba3$export$2e2bcd8739ae039 = $96fce170cf034ba3$var$taskItem;
module.exports["default"] = $96fce170cf034ba3$export$2e2bcd8739ae039;

});

parcelRegister("bvn5Z", function(module, exports) {

var $b7FrM = parcelRequire("b7FrM");


var $hZW9z = parcelRequire("hZW9z");

const $14e7757f2318836a$var$unknown = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    if (result.length > 0) return result.join('');
    return (0, $b7FrM.getText)(node);
};
var $14e7757f2318836a$export$2e2bcd8739ae039 = $14e7757f2318836a$var$unknown;
module.exports["default"] = $14e7757f2318836a$export$2e2bcd8739ae039;

});

parcelRegister("kPcbV", function(module, exports) {
$parcel$export(module.exports, "saveOnEnterPlugin", () => (parcelRequire("gCiM9")).saveOnEnterPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $gCiM9 = parcelRequire("gCiM9");


});

parcelRegister("gCiM9", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $lWghV = parcelRequire("lWghV");


var $dus6D = parcelRequire("dus6D");

const $efde80a57d73d90b$export$ae829ec7b2625219 = (eventDispatch, onSave)=>{
    if (!onSave) return;
    return (0, $dus6D.keymap)({
        Enter (state, _dispatch, editorView) {
            if (editorView && $efde80a57d73d90b$var$canSaveOnEnter(editorView)) {
                eventDispatch((0, $lWghV.analyticsEventKey), $efde80a57d73d90b$var$analyticsPayload(state));
                onSave(editorView);
                return true;
            }
            return false;
        }
    });
};
function $efde80a57d73d90b$var$canSaveOnEnter(editorView) {
    const { $cursor: $cursor } = editorView.state.selection;
    const { decisionItem: decisionItem, paragraph: paragraph, taskItem: taskItem } = editorView.state.schema.nodes;
    return !$cursor || $cursor.parent.type === paragraph && $cursor.depth === 1 || $cursor.parent.type === decisionItem && !$efde80a57d73d90b$var$isEmptyAtCursor($cursor) || $cursor.parent.type === taskItem && !$efde80a57d73d90b$var$isEmptyAtCursor($cursor);
}
function $efde80a57d73d90b$var$isEmptyAtCursor($cursor) {
    const { content: content } = $cursor.parent;
    return !(content && content.size);
}
const $efde80a57d73d90b$var$analyticsPayload = (state)=>({
        payload: {
            action: (0, $d925B.ACTION).STOPPED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SAVE,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).SHORTCUT,
                documentSize: state.doc.nodeSize
            },
            eventType: (0, $d925B.EVENT_TYPE).UI
        }
    });
const $efde80a57d73d90b$export$8ba1e5775ae443a6 = ({ config: onSave })=>({
        name: 'saveOnEnter',
        pmPlugins () {
            return [
                {
                    name: 'saveOnEnter',
                    plugin: ({ dispatch: dispatch })=>$efde80a57d73d90b$export$ae829ec7b2625219(dispatch, onSave)
                }
            ];
        }
    });
module.exports["saveOnEnterPlugin"] = $efde80a57d73d90b$export$8ba1e5775ae443a6;

});

parcelRegister("iulqN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8eced7d4004a78c9a645ef3d6727f49b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d75ba71d2f7e4979$var$_react = $d75ba71d2f7e4979$var$_interopRequireDefault((parcelRequire("42omo")));

var $d75ba71d2f7e4979$var$_baseNew = $d75ba71d2f7e4979$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d75ba71d2f7e4979$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeChapters".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto chapters functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d75ba71d2f7e4979$var$AiGenerativeChaptersIcon = (props)=>/*#__PURE__*/ $d75ba71d2f7e4979$var$_react.default.createElement($d75ba71d2f7e4979$var$_baseNew.default, Object.assign({
        name: "AiGenerativeChaptersIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 2.5v10h5.75V14H1.375C.615 14 0 13.384 0 12.625V2.375C0 1.617.613 1 1.374 1h3.5A3.87 3.87 0 0 1 8 2.583 3.87 3.87 0 0 1 11.125 1h3.5C15.387 1 16 1.62 16 2.376V8.25h-1.5V2.5h-3.375A2.375 2.375 0 0 0 8.75 4.875V10h-1.5V4.875A2.375 2.375 0 0 0 4.875 2.5zM13.25 6H10.5V4.5h2.75zM2.75 4.5H5.5V6H2.75zm0 2.5H5.5v1.5H2.75zm9.045 2.494a.75.75 0 0 1 1.41 0l.614 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.41 0l-.615-1.686-1.686-.615a.75.75 0 0 1 0-1.41l1.686-.615z" clip-rule="evenodd"/>`
    }, props));
$d75ba71d2f7e4979$var$AiGenerativeChaptersIcon.displayName = 'AiGenerativeChaptersIcon';
var $d75ba71d2f7e4979$var$_default = module.exports.default = $d75ba71d2f7e4979$var$AiGenerativeChaptersIcon;

});

parcelRegister("i1Nyn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");

const $3527ba50fc1c4fde$export$6f57813fe9f31bf9 = (0, $1P1Tu.createStore)({
    initialState: {
        editorContext: undefined,
        whiteboardContext: undefined,
        databaseContext: undefined,
        browserContext: undefined,
        dashboardContext: undefined,
        jiraWorkflowContext: undefined,
        aiFeatureContext: {},
        contentTargets: {},
        currentTargetId: undefined
    },
    actions: {
        getAllContext: ()=>({ getState: getState })=>getState(),
        getAIFeatureContext: ()=>({ getState: getState })=>{
                const currentState = getState().aiFeatureContext;
                // Delete all properties that are undefined
                Object.keys(currentState).forEach((key)=>currentState[key] === undefined && delete currentState[key]);
                // Avoid sending an empty object
                return Object.keys(currentState).length ? currentState : undefined;
            },
        setAIFeatureContext: (chatContextData)=>({ getState: getState, setState: setState })=>{
                const currentAIFeatureContextState = getState().aiFeatureContext;
                const { contextKey: contextKey, setContext: setContext } = chatContextData;
                if (contextKey) {
                    const contextUpdated = setContext(currentAIFeatureContextState[contextKey]);
                    setState({
                        aiFeatureContext: {
                            ...currentAIFeatureContextState,
                            [contextKey]: contextUpdated
                        }
                    });
                }
            },
        getDashboardContext: ()=>({ getState: getState })=>getState().dashboardContext,
        setDashboardContext: (dashboardContext)=>({ setState: setState })=>{
                setState({
                    dashboardContext: dashboardContext
                });
            },
        getJiraWorkflowContext: ()=>({ getState: getState })=>getState().jiraWorkflowContext,
        setJiraWorkflowContext: (jiraWorkflowContext)=>({ setState: setState })=>{
                setState({
                    jiraWorkflowContext: jiraWorkflowContext
                });
            },
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        getWhiteboardContext: ()=>({ getState: getState })=>getState().whiteboardContext,
        setWhiteboardContext: (whiteboardContext)=>({ setState: setState })=>{
                setState({
                    whiteboardContext: whiteboardContext
                });
            },
        getDatabaseContext: ()=>({ getState: getState })=>getState().databaseContext,
        setDatabaseContext: (databaseContext)=>({ setState: setState })=>{
                setState({
                    databaseContext: databaseContext
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            },
        getTarget: (contentContext)=>({ getState: getState })=>getState().contentTargets[contentContext],
        getContentContext: (contentId)=>({ getState: getState })=>{
                const entries = Object.entries(getState().contentTargets);
                const entry = entries.find(([, value])=>value.id === contentId);
                return entry?.[0];
            },
        getActiveContext: ()=>({ getState: getState })=>{
                const entries = getState().contentTargets;
                // The rules here determine the 'rank' in which Rovo layers are resolved into "which layer is currently active".
                // They map to intended UX - in AIFC, the staging area is a modal-powered experience, on top of global experiences.
                // Consider the scenario of sending a message - the user will be interacting with the topmost layer.
                if (entries['staging-area']) return 'staging-area';
                return 'global';
            },
        hasTarget: (contentContext)=>({ getState: getState })=>!!getState().contentTargets[contentContext],
        setTarget: (toAdd, target)=>({ getState: getState, setState: setState })=>{
                setState({
                    contentTargets: {
                        ...getState().contentTargets,
                        [toAdd]: target
                    }
                });
            },
        clearTarget: (toRemove)=>({ getState: getState, setState: setState })=>{
                const currentState = getState().contentTargets;
                const nextState = {};
                for (const key of Object.keys(currentState)){
                    const k = key;
                    if (k === toRemove) continue;
                    nextState[k] = currentState[k];
                }
                setState({
                    contentTargets: nextState
                });
            },
        setCurrentTargetId: (targetId)=>({ setState: setState })=>{
                setState({
                    currentTargetId: targetId
                });
            },
        getCurrentTargetId: ()=>({ getState: getState })=>getState().currentTargetId
    }
});
const $3527ba50fc1c4fde$export$53bf948a400e8426 = (0, $9zUhf.createActionsHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9);
const $3527ba50fc1c4fde$export$9465f65715425f1b = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.editorContext
});
const $3527ba50fc1c4fde$export$eea520981851a092 = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.whiteboardContext
});
const $3527ba50fc1c4fde$export$376b2a7bf70dad8 = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.browserContext
});
const $3527ba50fc1c4fde$export$904052abb7b98535 = ({ requestBrowserContent: requestBrowserContent, getContentBody: getContentBody, getStagingSpace: getStagingSpace, useCurrentNonEditingPageAsContext: useCurrentNonEditingPageAsContext, requestJiraContext: requestJiraContext })=>{
    const actions = $3527ba50fc1c4fde$export$53bf948a400e8426();
    const { getTarget: getTarget, getCurrentTargetId: getCurrentTargetId } = actions;
    const fetchContent = (0, $42omo.useCallback)(async (type, contentContext)=>{
        const currentTargetId = getCurrentTargetId();
        const contentTarget = getTarget(contentContext);
        if (!contentTarget) return undefined;
        // Only use currentTargetId when staging-area doesn't exist
        // to avoid changing any content open behind the staging
        // area modal
        const shouldUseCurrentTargetId = type === 'page' && !getTarget('staging-area');
        const selectedTargetId = shouldUseCurrentTargetId ? currentTargetId || contentTarget.id : contentTarget.id;
        const contentBody = await getContentBody(type, selectedTargetId);
        if (!contentBody || contentBody.contentType !== type) return undefined;
        switch(contentBody.contentType){
            case 'page':
                if (!contentBody.pageBody) return undefined;
                return {
                    contentId: contentBody.contentId,
                    document: {
                        type: 'text/adf',
                        content: contentBody.pageBody
                    },
                    selection: {
                        type: 'text/markdown',
                        content: contentBody.selectionMarkdown || ''
                    },
                    selectionFragment: contentBody.selectionFragment,
                    selectionLocalIds: contentBody.selectionLocalIds,
                    isViewMode: contentBody.isViewMode,
                    useGenericEditorSkill: contentBody.useGenericEditorSkill,
                    additionalContext: contentBody.additionalContext
                };
            case 'whiteboard':
                if (!contentBody.svg || !contentBody.wdf) return undefined;
                return {
                    contentId: contentBody.contentId,
                    type: 'image/svg+xml',
                    svg: contentBody.svg,
                    title: contentBody.title ?? null,
                    url: contentBody.url ?? null,
                    wdf: contentBody.wdf,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'database':
                if (!contentBody.csv) return undefined;
                return {
                    contentId: contentBody.contentId,
                    csv: contentBody.csv,
                    title: contentBody.title,
                    url: contentBody.url
                };
            default:
                return undefined;
        }
    }, [
        getContentBody,
        getTarget,
        getCurrentTargetId
    ]);
    /**
	 * Fetches the context of a currently live page with Rovo chat open.
	 *
	 * @description see full list of cases to consider in {@link getContextRequirements}
	 */ const getEditorContext = (0, $42omo.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference })=>{
        const isAifcEnabled = (0, $dh538.fg)('aifc_create_enabled');
        const shouldProvideContext = $3527ba50fc1c4fde$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('page', contentContext) : actions.getEditorContext();
    }, [
        actions,
        fetchContent
    ]);
    /**
	 * Fetches the context of a currently live page with Rovo chat open.
	 *
	 * @description see full list of cases to consider in {@link getContextRequirements}
	 */ const getWhiteboardContext = (0, $42omo.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference })=>{
        const isAifcEnabled = (0, $dh538.fg)('aifc_create_enabled');
        const shouldProvideContext = $3527ba50fc1c4fde$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('whiteboard', contentContext) : actions.getWhiteboardContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDatabaseContext = (0, $42omo.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference })=>{
        const isAifcEnabled = (0, $dh538.fg)('aifc_create_enabled');
        const shouldProvideContext = $3527ba50fc1c4fde$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('database', contentContext) : actions.getDatabaseContext();
    }, [
        actions,
        fetchContent
    ]);
    const getSpaceCreateContext = (0, $42omo.useCallback)(({ contentContext: contentContext, isFirstPrompt: isFirstPrompt })=>{
        if (contentContext === 'staging-area' && !isFirstPrompt && (0, $dh538.fg)('aifc_space_creation_enabled')) return getStagingSpace(String(getTarget(contentContext)?.id));
    }, [
        getStagingSpace,
        getTarget
    ]);
    const getIsStagingArea = (0, $42omo.useCallback)(()=>actions.getActiveContext() === 'staging-area', [
        actions
    ]);
    const useCurrentBrowsingContext = (0, $42omo.useCallback)((addCurrentPageAsContextUserPreference)=>{
        // undefined means don't send useCurrentBrowsingContext at all. false tells backend to explicitly not use the browserUrl as context.
        if (useCurrentNonEditingPageAsContext === undefined) return undefined;
        const stagingAreaEnabled = getIsStagingArea();
        return !stagingAreaEnabled && addCurrentPageAsContextUserPreference && useCurrentNonEditingPageAsContext;
    }, [
        useCurrentNonEditingPageAsContext,
        getIsStagingArea
    ]);
    const getBrowserContext = (0, $42omo.useCallback)(async ({ addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, enabled: enabled })=>{
        // if the feature is not enabled, we return the original context resolution.
        if (!enabled && !(0, $c6GJD.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) return actions.getBrowserContext();
        if (!addCurrentPageAsContextUserPreference) return undefined;
        // Request browser content from the extension
        const browserContextResult = await requestBrowserContent();
        const browserContext = browserContextResult ? {
            context: browserContextResult
        } : actions.getBrowserContext();
        return browserContext;
    }, [
        requestBrowserContent,
        actions
    ]);
    const getJiraContext = (0, $42omo.useCallback)(async ()=>{
        if (!requestJiraContext) return undefined;
        try {
            const result = await requestJiraContext();
            return result?.success ? result.context : undefined;
        // eslint-disable-next-line no-unused-vars
        } catch (error) {
            return undefined;
        }
    }, [
        requestJiraContext
    ]);
    return {
        ...actions,
        getEditorContext: getEditorContext,
        getWhiteboardContext: getWhiteboardContext,
        getSpaceCreateContext: getSpaceCreateContext,
        getIsStagingArea: getIsStagingArea,
        useCurrentBrowsingContext: useCurrentBrowsingContext,
        getDatabaseContext: getDatabaseContext,
        getBrowserContext: getBrowserContext,
        getJiraContext: getJiraContext
    };
};
function $3527ba50fc1c4fde$export$86d7678a1db25436({ contentContext: contentContext, source: source, isFirstPrompt: isFirstPrompt, isAifcEnabled: isAifcEnabled, userPreference: userPreference }) {
    /**
	 * If AIFC is not enabled, we default to the user's preference.
	 */ if (!isAifcEnabled) return userPreference;
    /**
	 * In the staging area, we always want to provide context if the source is the
	 * inline editor, or if the prompt is not the first in a new conversation.
	 */ const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP';
    if (contentContext === 'staging-area') return sourceEligible || !isFirstPrompt;
    else /**
		 * On real content when AIFC is enabled, we only want to default to true
		 * if the source of the content is the inline editing experience. Otherwise,
		 * we want to respect the preference chosen by the user.
		 */ return sourceEligible || userPreference;
}
module.exports["useChatContextStoreActions"] = $3527ba50fc1c4fde$export$53bf948a400e8426;
module.exports["useChatContextEditorContext"] = $3527ba50fc1c4fde$export$9465f65715425f1b;
module.exports["useChatContextBrowserContext"] = $3527ba50fc1c4fde$export$376b2a7bf70dad8;
module.exports["useChatContextProvider"] = $3527ba50fc1c4fde$export$904052abb7b98535;

});

parcelRegister("5aqrM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2YmgJ = parcelRequire("2YmgJ");


var $4acD6 = parcelRequire("4acD6");


var $iHwFP = parcelRequire("iHwFP");

const $b840bdbd48de6cdb$export$65d3ca67d6e65cf4 = (sourceId)=>{
    const { removeContext: removeContext, removeAll: removeAll, removeAutomationsConfig: removeAutomationsConfig, setActions: setActions, setNudges: setNudges, setNudgesRefreshed: setNudgesRefreshed, setSuggestedActions: setSuggestedActions, setContext: setContext, setAutomationsConfig: setAutomationsConfig } = (0, $4acD6.useAISmartButtonActions)();
    const { setConversationActions: setConversationActions } = (0, $2YmgJ.useConversationActionsStoreActions)();
    (0, $42omo.useEffect)(()=>{
        // Cleanup on unmount.
        return ()=>{
            removeAll(sourceId);
            removeContext(sourceId);
            removeAutomationsConfig(sourceId);
        };
    }, [
        sourceId,
        removeAll,
        removeContext,
        removeAutomationsConfig
    ]);
    return (0, $42omo.useMemo)(()=>({
            /**
			 * Replaces all actions for this source with new ones.
			 */ setActions: (actions)=>{
                setActions(sourceId, actions);
                // TODO: delete this once we migrate consumers to new way of setting actions
                if (sourceId !== 'view-page' && sourceId !== 'editor') setConversationActions((0, $iHwFP.mapActionsToConversationActions)(actions));
            },
            /*
			 * Replaces all nudges for this source with new ones.
			 */ setNudges: (nudges)=>{
                setNudges(sourceId, nudges);
                // TODO: delete this once we migrate consumers to new way of setting nudges
                if (sourceId === 'jira-ai-rovo-button') setNudgesRefreshed((0, $iHwFP.mapActionsToConversationActions)(nudges));
            },
            /*
			 * Replaces all nudges for this source with new ones.
			 */ setNudgesRefreshed: (nudges)=>{
                setNudgesRefreshed(nudges);
            },
            /**
			 * Replaces all suggested actions for this source with new ones.
			 */ setSuggestedActions: (suggestedActions)=>{
                setSuggestedActions(sourceId, suggestedActions);
            },
            /**
			 * Sets context for this source.
			 */ setContext: (context)=>setContext({
                    ...context,
                    sourceId: sourceId
                }),
            /**
			 * Sets automations config for this source.
			 */ setAutomationsConfig: (automationsConfig)=>setAutomationsConfig({
                    ...automationsConfig,
                    sourceId: sourceId
                }),
            /**
			 * Removes context for this source.
			 */ removeContext: ()=>removeContext(sourceId),
            /**
			 * Removes automations config for this source.
			 */ removeAutomationsConfig: ()=>removeAutomationsConfig(sourceId),
            /**
			 * Removes all actions for this source.
			 */ removeAll: ()=>removeAll(sourceId)
        }), [
        sourceId,
        removeAll,
        removeContext,
        removeAutomationsConfig,
        setActions,
        setNudges,
        setNudgesRefreshed,
        setSuggestedActions,
        setContext,
        setAutomationsConfig,
        setConversationActions
    ]);
};
module.exports["useSourceAIActions"] = $b840bdbd48de6cdb$export$65d3ca67d6e65cf4;

});

parcelRegister("2YmgJ", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $a63d9f06b3e123f3$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        actionFilter: undefined,
        actions: [],
        input: '',
        activeAction: undefined,
        buttonClickedTimestamp: undefined
    },
    actions: {
        setConversationActions: (actions)=>({ setState: setState })=>{
                setState({
                    actions: actions
                });
            },
        setInput: (input)=>({ setState: setState })=>{
                setState({
                    input: input
                });
            },
        setActionFilter: (actionFilter)=>({ setState: setState })=>{
                setState({
                    actionFilter: actionFilter
                });
            },
        /*
		 * Do not use this setter directly. Use setActiveAction from useActiveAction hook in conversation-assistant instead.
		 */ setActiveAction_UNSAFE: (activeAction)=>({ setState: setState })=>{
                setState({
                    activeAction: activeAction
                });
            },
        setActiveActionFollowUpContext: (customFollowUpContext)=>({ getState: getState, setState: setState })=>{
                const activeAction = getState().activeAction;
                if (!activeAction || !('customFollowUpContext' in activeAction)) return;
                setState({
                    activeAction: {
                        ...activeAction,
                        customFollowUpContext: customFollowUpContext
                    }
                });
            },
        setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
                setState({
                    buttonClickedTimestamp: buttonClickedTimestamp
                });
            },
        getConversationActions: ()=>({ getState: getState })=>{
                return getState().actions;
            },
        getActionFilter: ()=>({ getState: getState })=>{
                return getState().actionFilter;
            },
        getInput: ()=>({ getState: getState })=>{
                return getState().input;
            },
        getActiveAction: ()=>({ getState: getState })=>{
                return getState().activeAction;
            },
        getButtonClickedTimestamp: ()=>({ getState: getState })=>{
                return getState().buttonClickedTimestamp;
            }
    }
});
const $a63d9f06b3e123f3$export$83a8985e8d377ba1 = (0, $9zUhf.createHook)($a63d9f06b3e123f3$var$store);
const $a63d9f06b3e123f3$export$74d7aed167e24a67 = (0, $9zUhf.createActionsHook)($a63d9f06b3e123f3$var$store);
module.exports["useConversationActionsStore"] = $a63d9f06b3e123f3$export$83a8985e8d377ba1;
module.exports["useConversationActionsStoreActions"] = $a63d9f06b3e123f3$export$74d7aed167e24a67;

});

parcelRegister("4acD6", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $48675c89bdefef9d$export$a9180caf96fd3fe = /*#__PURE__*/ function(DynamicSurfaceView) {
    DynamicSurfaceView["Default"] = "default";
    return DynamicSurfaceView;
}({});
const $48675c89bdefef9d$export$d4c72bab9d6cc13a = {
    suggestedActions: [],
    actions: [],
    nudges: [],
    currentView: "default",
    surfaceMetadata: {
        siteId: '',
        product: '',
        contentType: ''
    },
    profileData: {
        name: '',
        displayName: '',
        avatarUrl: ''
    }
};
/**
 * Adds source ID to each action in the array recursively.
 */ const $48675c89bdefef9d$var$addSource = (actions, sourceId)=>actions.map((action)=>({
            ...action,
            sourceId: sourceId,
            children: action.children ? $48675c89bdefef9d$var$addSource(action.children, sourceId) : undefined
        }));
/**
 * Updates state only if the new state is different from the current state.
 */ const $48675c89bdefef9d$var$updateStateIfChanged = (newPartialState, getState, setState)=>{
    const currentState = getState();
    const stateChanged = Object.entries(newPartialState).some(([key, value])=>!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(currentState[key], value));
    if (stateChanged) setState(newPartialState);
};
/**
 * Updates a collection of items (actions, nudges, or suggestedActions) for a specific source.
 * Only updates if the items have changed to avoid unnecessary re-renders.
 */ const $48675c89bdefef9d$var$updateItemsForSource = (sourceId, newItems, stateKey, getState, setState)=>{
    const currentItems = getState()[stateKey];
    const currentSourceItems = currentItems.filter((item)=>item.sourceId === sourceId);
    const itemsMatch = currentSourceItems.length === newItems.length && currentSourceItems.every((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(item, newItems[index]));
    if (itemsMatch) return;
    // Filter out items from this source and add new ones.
    const otherItems = currentItems.filter((item)=>item.sourceId !== sourceId);
    const updatedItems = [
        ...otherItems,
        ...$48675c89bdefef9d$var$addSource(newItems, sourceId)
    ];
    setState({
        [stateKey]: updatedItems
    });
};
const $48675c89bdefef9d$export$e324594224ef24da = {
    setActions: (sourceId, actions)=>({ getState: getState, setState: setState })=>{
            $48675c89bdefef9d$var$updateItemsForSource(sourceId, actions, 'actions', getState, setState);
        },
    setNudges: (sourceId, nudges)=>({ getState: getState, setState: setState })=>{
            $48675c89bdefef9d$var$updateItemsForSource(sourceId, nudges, 'nudges', getState, setState);
        },
    setNudgesRefreshed: (nudgesRefreshed)=>({ setState: setState })=>{
            setState({
                nudgesRefreshed: nudgesRefreshed
            });
        },
    setSuggestedActions: (sourceId, suggestedActions)=>({ getState: getState, setState: setState })=>{
            $48675c89bdefef9d$var$updateItemsForSource(sourceId, suggestedActions, 'suggestedActions', getState, setState);
        },
    removeAll: (sourceId)=>({ getState: getState, setState: setState })=>{
            const { actions: actions, nudges: nudges, suggestedActions: suggestedActions } = getState();
            if (sourceId) {
                const newState = {
                    suggestedActions: suggestedActions.filter((action)=>action.sourceId !== sourceId),
                    actions: actions.filter((action)=>action.sourceId !== sourceId),
                    nudges: nudges.filter((nudge)=>nudge.sourceId !== sourceId)
                };
                $48675c89bdefef9d$var$updateStateIfChanged(newState, getState, setState);
            } else {
                const newState = {
                    suggestedActions: [],
                    actions: [],
                    nudges: []
                };
                $48675c89bdefef9d$var$updateStateIfChanged(newState, getState, setState);
            }
        },
    changeView: (view)=>({ getState: getState, setState: setState })=>{
            $48675c89bdefef9d$var$updateStateIfChanged({
                currentView: view
            }, getState, setState);
        },
    setSelectors: (selectors)=>({ getState: getState, setState: setState })=>{
            const existingSelectors = getState().selectors;
            const newSelectors = {
                selectors: {
                    actionsSelector: 'actionsSelector' in selectors ? selectors.actionsSelector : existingSelectors?.actionsSelector,
                    suggestedActionsSelector: 'suggestedActionsSelector' in selectors ? selectors.suggestedActionsSelector : existingSelectors?.suggestedActionsSelector,
                    nudgesSelector: 'nudgesSelector' in selectors ? selectors.nudgesSelector : existingSelectors?.nudgesSelector
                }
            };
            $48675c89bdefef9d$var$updateStateIfChanged(newSelectors, getState, setState);
        },
    setContext: (context)=>({ getState: getState, setState: setState })=>{
            $48675c89bdefef9d$var$updateStateIfChanged({
                context: context
            }, getState, setState);
        },
    removeContext: (sourceId)=>({ getState: getState, setState: setState })=>{
            const { context: context } = getState();
            if (context?.sourceId === sourceId) $48675c89bdefef9d$var$updateStateIfChanged({
                context: undefined
            }, getState, setState);
        },
    setSurfaceMetadata: (surfaceMetadata)=>({ getState: getState, setState: setState })=>{
            $48675c89bdefef9d$var$updateStateIfChanged({
                surfaceMetadata: surfaceMetadata
            }, getState, setState);
        },
    setProfileData: (profileData)=>({ setState: setState })=>{
            setState({
                profileData: profileData
            });
        },
    setAutomationsConfig: (automationsConfig)=>({ getState: getState, setState: setState })=>{
            $48675c89bdefef9d$var$updateStateIfChanged({
                automationsConfig: automationsConfig
            }, getState, setState);
        },
    removeAutomationsConfig: (sourceId)=>({ getState: getState, setState: setState })=>{
            const { automationsConfig: automationsConfig } = getState();
            if (automationsConfig?.sourceId === sourceId) $48675c89bdefef9d$var$updateStateIfChanged({
                automationsConfig: undefined
            }, getState, setState);
        },
    setShowConvoStarters: (showConvoStarters)=>({ setState: setState })=>{
            setState({
                showConvoStarters: showConvoStarters
            });
        },
    setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
            setState({
                buttonClickedTimestamp: buttonClickedTimestamp
            });
        }
};
const $48675c89bdefef9d$export$72552b26ebb37b2 = (0, $1P1Tu.createStore)({
    initialState: $48675c89bdefef9d$export$d4c72bab9d6cc13a,
    actions: $48675c89bdefef9d$export$e324594224ef24da,
    name: 'AISmartButtonStore'
});
const $48675c89bdefef9d$export$af36d029992e7a8c = (0, $9zUhf.createActionsHook)($48675c89bdefef9d$export$72552b26ebb37b2);
module.exports["DynamicSurfaceView"] = $48675c89bdefef9d$export$a9180caf96fd3fe;
module.exports["AISmartButtonStore"] = $48675c89bdefef9d$export$72552b26ebb37b2;
module.exports["useAISmartButtonActions"] = $48675c89bdefef9d$export$af36d029992e7a8c;

});

parcelRegister("iHwFP", function(module, exports) {

var $6Htct = parcelRequire("6Htct");

const $d7b65a248b0debff$export$ed24f115d57335da = (baseActions)=>{
    return baseActions.map((action)=>({
            id: action.id,
            title: action.title,
            icon: (iconProps)=>action.icon,
            description: typeof action.description === 'string' ? action.description : undefined,
            onClick: action.onClick ?? undefined,
            viewConfig: action.viewConfig ?? undefined,
            children: action.children ? $d7b65a248b0debff$export$ed24f115d57335da(action.children) : undefined,
            closePanelOnSelection: action.closePanelOnSelection ?? undefined,
            ref: action.ref ?? undefined,
            type: action.type ?? undefined,
            handleType: $d7b65a248b0debff$var$getHandleType(action),
            customFollowUpContext: action.customFollowUpContext ?? undefined
        }));
};
const $d7b65a248b0debff$var$getHandleType = (action)=>{
    if (action.children) return (0, $6Htct.HandleActionType).Nested;
    else if (action.type === 'convo-starter-action') return (0, $6Htct.HandleActionType).Chat;
    else return (0, $6Htct.HandleActionType).Base;
};
module.exports["mapActionsToConversationActions"] = $d7b65a248b0debff$export$ed24f115d57335da;

});

parcelRegister("6Htct", function(module, exports) {
var $4c47f75c6ef52bb8$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    HandleActionType["Skill"] = "Skill";
    return HandleActionType;
}({});
var $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_PIPELINES"] = "bitbucket-pipelines";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_BLOG_VIEW"] = "confluence-blog-view";
    PageContextType["CONFLUENCE_BLOG_EDIT"] = "confluence-blog-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JSM_INCIDENT_VIEW"] = "jsm-incident-view";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOR_YOU"] = "focus-for-you";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_GOAL_VIEW"] = "focus-focus-area-goal-view";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["SAC"] = "sac";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
module.exports["HandleActionType"] = $4c47f75c6ef52bb8$export$87497e63e164f4b3;
module.exports["PageContextType"] = $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127;

});

parcelRegister("jVlcd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9QtOT = parcelRequire("9QtOT");


var $2YmgJ = parcelRequire("2YmgJ");


var $bTgxo = parcelRequire("bTgxo");


var $lkQ0E = parcelRequire("lkQ0E");

const $b7599fbee0cac3a5$export$a916dc6bee947aa3 = ()=>{
    const context = (0, $9QtOT.useAIContext)();
    const { setConversationActions: setConversationActions } = (0, $2YmgJ.useConversationActionsStoreActions)();
    const { setEditorActions: setEditorActionsInStore, setConsumptionActions: setConsumptionActions } = (0, $bTgxo.useConfluenceRovoButtonActions)();
    const editorActions = (0, $bTgxo.useConfluenceRovoButtonEditorActions)();
    const consumptionActions = (0, $bTgxo.useConfluenceRovoButtonConsumptionActions)();
    const setEditorActions = (0, $42omo.useCallback)((actions)=>{
        setEditorActionsInStore((0, $lkQ0E.mapActionsToConversationActions)(actions));
    }, [
        setEditorActionsInStore
    ]);
    (0, $42omo.useEffect)(()=>{
        /**
		 * When there is selection in editor, sourceId will be 'editor' and reference will be present.
		 * So show only editor actions.
		 */ if (context?.sourceId === 'editor' && context?.reference) setConversationActions(editorActions);
        else setConversationActions([
            ...editorActions,
            ...consumptionActions
        ]);
        return ()=>{
            setConversationActions([]);
        };
    }, [
        context,
        consumptionActions,
        editorActions,
        setConversationActions
    ]);
    return {
        setEditorActions: setEditorActions,
        setConsumptionActions: setConsumptionActions
    };
};
module.exports["useAIActions"] = $b7599fbee0cac3a5$export$a916dc6bee947aa3;

});

parcelRegister("9QtOT", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");


var $4acD6 = parcelRequire("4acD6");

const $9fe72367d410ea7b$export$69b8f052247c1626 = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.context
});
const $9fe72367d410ea7b$export$b854997b7299d67f = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>{
        const { nudges: nudges, selectors: selectors, context: context } = state;
        if (selectors?.nudgesSelector) return selectors.nudgesSelector(nudges, context);
        return nudges;
    }
});
const $9fe72367d410ea7b$export$3d91f71a604904dd = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.nudgesRefreshed
});
const $9fe72367d410ea7b$export$a916dc6bee947aa3 = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>{
        const { actions: actions, selectors: selectors, context: context } = state;
        if (selectors?.actionsSelector) return selectors.actionsSelector(actions, context);
        return actions;
    }
});
const $9fe72367d410ea7b$export$e4b00dbb0b70f9c2 = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.surfaceMetadata
});
const $9fe72367d410ea7b$export$b068b01d46d2f61d = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.currentView
});
const $9fe72367d410ea7b$export$22514df787c8eb15 = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.profileData
});
const $9fe72367d410ea7b$export$f23908d838fcc66a = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.automationsConfig
});
const $9fe72367d410ea7b$export$49ad96840690a3bf = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.showConvoStarters
});
const $9fe72367d410ea7b$export$9af0fbebebbfec35 = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.buttonClickedTimestamp
});
module.exports["useAIContext"] = $9fe72367d410ea7b$export$69b8f052247c1626;
module.exports["useAINudges"] = $9fe72367d410ea7b$export$b854997b7299d67f;
module.exports["useAINudgesRefreshed"] = $9fe72367d410ea7b$export$3d91f71a604904dd;
module.exports["useAIActions"] = $9fe72367d410ea7b$export$a916dc6bee947aa3;
module.exports["useAISurfaceMetadata"] = $9fe72367d410ea7b$export$e4b00dbb0b70f9c2;
module.exports["useAICurrentView"] = $9fe72367d410ea7b$export$b068b01d46d2f61d;
module.exports["useAIProfileData"] = $9fe72367d410ea7b$export$22514df787c8eb15;
module.exports["useAIAutomationsConfig"] = $9fe72367d410ea7b$export$f23908d838fcc66a;
module.exports["useAIConvoStarters"] = $9fe72367d410ea7b$export$49ad96840690a3bf;

});

parcelRegister("bTgxo", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $8214f78e1052f35a$var$initialState = {
    editorActions: [],
    consumptionActions: []
};
const $8214f78e1052f35a$export$e324594224ef24da = {
    setEditorActions: (editorActions)=>({ setState: setState })=>{
            setState({
                editorActions: editorActions
            });
        },
    setConsumptionActions: (consumptionActions)=>({ setState: setState })=>{
            setState({
                consumptionActions: consumptionActions
            });
        }
};
const $8214f78e1052f35a$export$42cff381b16835f = (0, $1P1Tu.createStore)({
    initialState: $8214f78e1052f35a$var$initialState,
    actions: $8214f78e1052f35a$export$e324594224ef24da,
    name: 'ConfluenceRovoButtonStore'
});
const $8214f78e1052f35a$export$54b3536f30e38906 = (0, $9zUhf.createActionsHook)($8214f78e1052f35a$export$42cff381b16835f);
const $8214f78e1052f35a$export$b8374f358792d4a0 = (0, $9zUhf.createStateHook)($8214f78e1052f35a$export$42cff381b16835f, {
    selector: (state)=>state.editorActions
});
const $8214f78e1052f35a$export$7e280b2e80400310 = (0, $9zUhf.createStateHook)($8214f78e1052f35a$export$42cff381b16835f, {
    selector: (state)=>state.consumptionActions
});
module.exports["useConfluenceRovoButtonActions"] = $8214f78e1052f35a$export$54b3536f30e38906;
module.exports["useConfluenceRovoButtonEditorActions"] = $8214f78e1052f35a$export$b8374f358792d4a0;
module.exports["useConfluenceRovoButtonConsumptionActions"] = $8214f78e1052f35a$export$7e280b2e80400310;

});

parcelRegister("lkQ0E", function(module, exports) {

var $6Htct = parcelRequire("6Htct");

const $d0b8b0e748745505$export$ed24f115d57335da = (baseActions)=>{
    return baseActions.map((action)=>({
            id: action.id,
            title: action.title,
            icon: (_)=>action.icon,
            description: typeof action.description === 'string' ? action.description : undefined,
            onClick: action.onClick ?? undefined,
            viewConfig: action.viewConfig ?? undefined,
            children: action.children ? $d0b8b0e748745505$export$ed24f115d57335da(action.children) : undefined,
            closePanelOnSelection: action.closePanelOnSelection ?? undefined,
            ref: action.ref ?? undefined,
            type: action.type ?? undefined,
            handleType: $d0b8b0e748745505$var$getHandleType(action)
        }));
};
const $d0b8b0e748745505$var$getHandleType = (action)=>{
    if (action.children) return (0, $6Htct.HandleActionType).Nested;
    else if (action.type === 'convo-starter-action') return (0, $6Htct.HandleActionType).Chat;
    else return (0, $6Htct.HandleActionType).Base;
};
module.exports["mapActionsToConversationActions"] = $d0b8b0e748745505$export$ed24f115d57335da;

});

parcelRegister("8tIbq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hTKp4 = parcelRequire("hTKp4");


var $2MPqq = parcelRequire("2MPqq");

const $50e1434d8c6bc030$var$defaultOptions = {
    childList: true,
    subtree: true
};
const $50e1434d8c6bc030$export$6a6a5d23d75b0f62 = ({ selectors: selectors = [
    'body'
], options: options = $50e1434d8c6bc030$var$defaultOptions })=>{
    const { popoverContent: popoverContent } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const { update: update } = popoverContent;
    (0, $42omo.useEffect)(()=>{
        if (!update || selectors.length === 0) return;
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) return;
        const elements = new Set();
        selectors.forEach((selector)=>{
            const element = doc.querySelector(selector);
            if (!element) return;
            elements.add(element);
        });
        if (elements.size === 0) return;
        const observers = [];
        elements.forEach((element)=>{
            const observer = new MutationObserver((mutations)=>{
                if (mutations.length === 0) return;
                update();
            });
            observer.observe(element, options);
            observers.push(observer);
        });
        return ()=>{
            observers.forEach((observer)=>observer.disconnect());
        };
    }, [
        selectors,
        options,
        update
    ]);
    return null;
};
module.exports["UNSAFE_UpdateOnChange"] = $50e1434d8c6bc030$export$6a6a5d23d75b0f62;

});

parcelRegister("gjBRE", function(module, exports) {
$parcel$export(module.exports, "default", () => $1db25360181e8d88$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $2gkmX = parcelRequire("2gkmX");


var $fPlBD = parcelRequire("fPlBD");


var $3oRlx = parcelRequire("3oRlx");

class $1db25360181e8d88$export$456a23774b90f061 extends (0, $2gkmX.default) {
    ignoreMutation(mutation) {
        // Extensions can perform async operations that will change the DOM.
        // To avoid having their tree rebuilt, we need to ignore the mutation
        // for atom based extensions if its not a layout, we need to give
        // children a chance to recalc
        return this.node.type.isAtom || mutation.type !== 'selection' && mutation.attributeName !== 'data-layout';
    }
    // Reserve height by setting a minimum height for the extension node view element
    createDomRef() {
        if (!(0, $dh538.fg)('confluence_connect_macro_preset_height')) return super.createDomRef();
        if (!this.node.isInline) {
            const htmlElement = document.createElement('div');
            const extensionHeight = this.reactComponentProps?.extensionNodeViewOptions?.getExtensionHeight?.(this.node);
            if (extensionHeight) htmlElement.style.setProperty('min-height', `${extensionHeight}px`);
            return htmlElement;
        }
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    /**
   * When interacting with input elements inside an extension's body, the events
   * bubble up to the editor and get handled by it. This almost always gets in the way
   * of being able to actually interact with said input in the extension, i.e.
   * typing inside a text field (in an extension body) will print the text in the editor
   * content area instead. This change prevents the editor view from trying to handle these events,
   * when the target of the event is an input element, so the extension can.
   */ stopEvent(event) {
        if ((0, $dh538.fg)('forge-ui-extensionnodeview-stop-event-for-textarea')) return event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement;
        return event.target instanceof HTMLInputElement;
    }
    getContentDOM() {
        if (this.node.isInline) return;
        const dom = document.createElement('div');
        dom.className = `${this.node.type.name}-content-dom-wrapper`;
        return {
            dom: dom
        };
    }
    render(props, forwardRef) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3oRlx.ExtensionNodeWrapper), {
            nodeType: this.node.type.name,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fPlBD.Extension), {
            editorView: this.view,
            node: this.node,
            eventDispatcher: this.eventDispatcher,
            // The getPos arg is always a function when used with nodes
            // the version of the types we use has a union with the type
            // for marks.
            // This has been fixed in later versions of the definitly typed
            // types (and also in prosmirror-views inbuilt types).
            // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57384
            getPos: this.getPos,
            providerFactory: props.providerFactory,
            handleContentDOMRef: forwardRef,
            extensionHandlers: props.extensionHandlers,
            editorAppearance: props.extensionNodeViewOptions?.appearance,
            pluginInjectionApi: props.pluginInjectionApi,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: props.showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: props.showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: props.rendererExtensionHandlers
        }));
    }
}
function $1db25360181e8d88$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers) {
    return (node, view, getPos)=>{
        return new $1db25360181e8d88$export$456a23774b90f061(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory,
            extensionHandlers: extensionHandlers,
            extensionNodeViewOptions: extensionNodeViewOptions,
            pluginInjectionApi: pluginInjectionApi,
            macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: rendererExtensionHandlers
        }).init();
    };
}
module.exports["ExtensionNode"] = $1db25360181e8d88$export$456a23774b90f061;

});

parcelRegister("fPlBD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4FxUL = parcelRequire("4FxUL");

var $dYBVS = parcelRequire("dYBVS");


var $dhO1r = parcelRequire("dhO1r");

class $394b11282ac27980$export$eeddbf09bb970356 extends (0, $42omo.Component) {
    componentWillUnmount() {
        if (!this.props.providerFactory) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dYBVS.WithProviders), {
            providers: [
                'extensionProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
    constructor(props){
        super(props);
        this.providerFactory = void 0;
        this.renderWithProvider = ({ extensionProvider: extensionProvider })=>{
            const { node: node, getPos: getPos, editorView: editorView, handleContentDOMRef: handleContentDOMRef, extensionHandlers: extensionHandlers, references: references, editorAppearance: editorAppearance, pluginInjectionApi: pluginInjectionApi, eventDispatcher: eventDispatcher, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers: rendererExtensionHandlers } = this.props;
            // Extensions are not yet using the new plugin architecture, and the use of the pluginInjectionApi
            // is not type safe in editor-common.
            // @ts-ignore
            const currentState = pluginInjectionApi?.editorViewMode?.sharedState?.currentState();
            const { contentMode: contentMode, mode: mode } = currentState || {};
            const isLivePageViewMode = contentMode === 'live-view' || mode === 'view';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dhO1r.ExtensionComponent), {
                editorView: editorView,
                node: node,
                getPos: getPos,
                references: references,
                extensionProvider: extensionProvider,
                handleContentDOMRef: handleContentDOMRef,
                extensionHandlers: extensionHandlers,
                editorAppearance: editorAppearance,
                pluginInjectionApi: pluginInjectionApi,
                eventDispatcher: eventDispatcher,
                macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
                rendererExtensionHandlers: rendererExtensionHandlers,
                isLivePageViewMode: isLivePageViewMode
            });
        };
        this.providerFactory = props.providerFactory || new (0, $4FxUL.default)();
    }
}
$394b11282ac27980$export$eeddbf09bb970356.displayName = 'Extension';
module.exports["Extension"] = $394b11282ac27980$export$eeddbf09bb970356;

});

parcelRegister("dhO1r", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $ks2lK = parcelRequire("ks2lK");


var $1oCLl = parcelRequire("1oCLl");


var $heH5c = parcelRequire("heH5c");


var $2diEG = parcelRequire("2diEG");

var $7iE7T = parcelRequire("7iE7T");


var $8Ze8r = parcelRequire("8Ze8r");


var $5wrbt = parcelRequire("5wrbt");


var $aAiMR = parcelRequire("aAiMR");


var $akFmj = parcelRequire("akFmj");

const $cad668a69e29b538$var$getBodiedExtensionContent = (node)=>{
    const bodiedExtensionContent = [];
    node.content.forEach((childNode)=>{
        bodiedExtensionContent.push((0, $7iE7T.nodeToJSON)(childNode));
    });
    return !!bodiedExtensionContent.length ? bodiedExtensionContent : node.attrs.text;
};
const $cad668a69e29b538$export$908ff786c04d5297 = (props)=>{
    const { extensionProvider: extensionProviderResolver, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, node: node, ...restProps } = props;
    const [extensionProvider, setExtensionProvider] = (0, $42omo.useState)(undefined);
    const [showBodiedExtensionRendererView, setShowBodiedExtensionRendererView] = (0, $42omo.useState)(!!showLivePagesBodiedMacrosRendererView?.((0, $7iE7T.nodeToJSON)(node)) && !(0, $5wrbt.isEmptyBodiedMacro)(node));
    const mountedRef = (0, $42omo.useRef)(true);
    (0, $42omo.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        extensionProviderResolver?.then((provider)=>{
            if (mountedRef.current) setExtensionProvider(provider);
        });
    }, [
        extensionProviderResolver
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cad668a69e29b538$var$ExtensionComponentInner, {
        ...restProps,
        extensionProvider: extensionProvider,
        node: node,
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView
    });
};
class $cad668a69e29b538$var$ExtensionComponentInner extends (0, $42omo.Component) {
    componentDidUpdate() {
        this.parsePrivateNodePropsIfNeeded();
    }
    render() {
        const { node: node, handleContentDOMRef: handleContentDOMRef, editorView: editorView, references: references, editorAppearance: editorAppearance, pluginInjectionApi: pluginInjectionApi, getPos: getPos, eventDispatcher: eventDispatcher, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, extensionProvider: extensionProvider, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, isLivePageViewMode: isLivePageViewMode } = this.props;
        const { selection: selection } = editorView.state;
        const selectedNode = selection instanceof (0, $ks2lK.NodeSelection) && selection.node;
        const position = typeof getPos === 'function' && getPos();
        const resolvedPosition = position && editorView.state.doc.resolve(position);
        const isNodeNested = !!(resolvedPosition && resolvedPosition.depth > 0);
        if (node.type.name === 'multiBodiedExtension') {
            const allowBodiedOverride = this.state._privateProps?.__allowBodiedOverride;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $akFmj.default), {
                node: node,
                editorView: editorView,
                getPos: getPos,
                handleContentDOMRef: handleContentDOMRef,
                tryExtensionHandler: this.tryExtensionHandler.bind(this),
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi,
                editorAppearance: editorAppearance,
                macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                isNodeSelected: selectedNode === node,
                isNodeNested: isNodeNested,
                isNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.state.isNodeHovered,
                setIsNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.setIsNodeHovered,
                isLivePageViewMode: isLivePageViewMode,
                allowBodiedOverride: allowBodiedOverride
            });
        }
        const extensionHandlerResult = this.tryExtensionHandler(undefined);
        switch(node.type.name){
            case 'extension':
            case 'bodiedExtension':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Ze8r.default), {
                    node: node,
                    getPos: this.props.getPos,
                    references: references,
                    extensionProvider: extensionProvider,
                    handleContentDOMRef: handleContentDOMRef,
                    view: editorView,
                    editorAppearance: editorAppearance,
                    hideFrame: this.state._privateProps?.__hideFrame,
                    pluginInjectionApi: pluginInjectionApi,
                    macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                    isNodeSelected: selectedNode === node,
                    isNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.state.isNodeHovered,
                    isNodeNested: isNodeNested,
                    setIsNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.setIsNodeHovered,
                    showLivePagesBodiedMacrosRendererView: !!showLivePagesBodiedMacrosRendererView?.((0, $7iE7T.nodeToJSON)(node)),
                    showUpdatedLivePages1PBodiedExtensionUI: !!showUpdatedLivePages1PBodiedExtensionUI?.((0, $7iE7T.nodeToJSON)(node)),
                    showBodiedExtensionRendererView: showBodiedExtensionRendererView,
                    setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
                    isLivePageViewMode: isLivePageViewMode
                }, extensionHandlerResult);
            case 'inlineExtension':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aAiMR.default), {
                    node: node,
                    macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                    isNodeSelected: selectedNode === node,
                    pluginInjectionApi: pluginInjectionApi,
                    isNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.state.isNodeHovered,
                    setIsNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.setIsNodeHovered,
                    isLivePageViewMode: isLivePageViewMode
                }, extensionHandlerResult);
            default:
                return null;
        }
    }
    tryExtensionHandler(actions) {
        const { node: node } = this.props;
        try {
            const extensionContent = this.handleExtension(node, actions);
            if (extensionContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(extensionContent)) return extensionContent;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Provided extension handler has thrown an error\n', e);
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return null;
    }
    constructor(...args){
        super(...args);
        this.privatePropsParsed = false;
        this.state = {};
        // memoized to avoid rerender on extension state changes
        this.getNodeRenderer = (0, $2XqLN.default)((0, $heH5c.getNodeRenderer));
        this.getExtensionModuleNodePrivateProps = (0, $2XqLN.default)((0, $heH5c.getExtensionModuleNodePrivateProps));
        this.setIsNodeHovered = (isHovered)=>{
            // Don't want to show hover interactions for live page view mode
            if (!this.props.isLivePageViewMode) this.setState({
                isNodeHovered: isHovered
            });
        };
        /**
     * Parses any private nodes once an extension provider is available.
     *
     * We do this separately from resolving a node renderer component since the
     * private props come from extension provider, rather than an extension
     * handler which only handles `render`/component concerns.
     */ this.parsePrivateNodePropsIfNeeded = async ()=>{
            if (this.privatePropsParsed || !this.props.extensionProvider) return;
            this.privatePropsParsed = true;
            const { extensionType: extensionType, extensionKey: extensionKey } = this.props.node.attrs;
            /**
       * getExtensionModuleNodePrivateProps can throw if there are issues in the
       * manifest
       */ try {
                const privateProps = await this.getExtensionModuleNodePrivateProps(this.props.extensionProvider, extensionType, extensionKey);
                this.setState({
                    _privateProps: privateProps
                });
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('Provided extension handler has thrown an error\n', e);
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        };
        this.handleExtension = (pmNode, actions)=>{
            const { extensionHandlers: extensionHandlers, editorView: editorView, showBodiedExtensionRendererView: showBodiedExtensionRendererView, rendererExtensionHandlers: rendererExtensionHandlers } = this.props;
            const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, text: text } = pmNode.attrs;
            const isBodiedExtension = pmNode.type.name === 'bodiedExtension';
            if (isBodiedExtension && !showBodiedExtensionRendererView) return;
            const fragmentLocalId = pmNode?.marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
            const content = isBodiedExtension ? $cad668a69e29b538$var$getBodiedExtensionContent(pmNode) : text;
            const node = {
                type: pmNode.type.name,
                extensionType: extensionType,
                extensionKey: extensionKey,
                parameters: parameters,
                content: content,
                localId: pmNode.attrs.localId,
                fragmentLocalId: fragmentLocalId
            };
            if (isBodiedExtension) {
                const rendererExtensionHandler = rendererExtensionHandlers?.[extensionType];
                // Forge bodied extensions don't get rendererExtensionHandlers passed in and use extensionHandlerFromProvider from the below logic instead
                if (rendererExtensionHandler) return (0, $2diEG.getExtensionRenderer)(rendererExtensionHandler)(node, (0, $7iE7T.toJSON)(editorView.state.doc));
            }
            let result;
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $2diEG.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, editorView.state.doc, actions);
            }
            if (!result) {
                const extensionHandlerFromProvider = this.props.extensionProvider && this.getNodeRenderer(this.props.extensionProvider, extensionType, extensionKey);
                if (extensionHandlerFromProvider) {
                    const NodeRenderer = extensionHandlerFromProvider;
                    if (node.type === 'multiBodiedExtension') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(NodeRenderer, {
                        node: node,
                        references: this.props.references,
                        actions: actions
                    });
                    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(NodeRenderer, {
                        node: node,
                        references: this.props.references
                    });
                }
            }
            return result;
        };
    }
}
module.exports["ExtensionComponent"] = $cad668a69e29b538$export$908ff786c04d5297;

});

parcelRegister("8Ze8r", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b68c835fd1c0f68$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $eiA8Z = parcelRequire("eiA8Z");


var $frt7o = parcelRequire("frt7o");


var $fJNzZ = parcelRequire("fJNzZ");


var $7gXVN = parcelRequire("7gXVN");


var $klDBQ = parcelRequire("klDBQ");


var $mBi3D = parcelRequire("mBi3D");


var $5wrbt = parcelRequire("5wrbt");


var $jY6Lt = parcelRequire("jY6Lt");

function $8b68c835fd1c0f68$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8b68c835fd1c0f68$var$hoverStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $8b68c835fd1c0f68$var$containerStyle = {
    name: "nhejpy",
    styles: "container-type:inline-size"
};
function $8b68c835fd1c0f68$var$ExtensionWithPluginState(props) {
    const { node: node, handleContentDOMRef: handleContentDOMRef, children: children, widthState: widthState, handleRef: handleRef, shadowClassNames: shadowClassNames, hideFrame: hideFrame, editorAppearance: editorAppearance, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi, isLivePageViewMode: isLivePageViewMode } = props;
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const isLegacyContentMacroExtension = (extensionNode)=>extensionNode.type.name === 'extension' && extensionNode.attrs?.extensionType === 'com.atlassian.confluence.migration' && extensionNode.attrs?.extensionKey === 'legacy-content';
    const showLegacyContentHeader = (0, $dh538.fg)('platform_editor_legacy_content_macro_visual_update') && isLegacyContentMacroExtension(node);
    const hasBody = [
        'bodiedExtension',
        'multiBodiedExtension'
    ].includes(node.type.name);
    const hasChildren = !!children;
    const removeBorder = showMacroInteractionDesignUpdates || !!(hideFrame && !hasBody);
    // Some native bodied macros (e.g Content properties) have this param to hide in view mode
    // which we want to also hide in live page view mode too
    const macroParamHiddenValue = node?.attrs?.parameters?.macroParams?.hidden?.value;
    const shouldHideInLivePageViewMode = isLivePageViewMode && macroParamHiddenValue === 'true'; // it is stored as a string
    const { getPos: getPos, view: view } = props;
    const isTopLevelNode = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        const pos = typeof getPos === 'function' ? getPos() : undefined;
        return typeof pos !== 'undefined' && !isNaN(pos) && view.state.doc.resolve(pos).depth === 0;
    }, [
        view,
        getPos
    ]);
    const shouldBreakout = // Extension should breakout when the layout is set to 'full-width' or 'wide'.
    [
        'full-width',
        'wide'
    ].includes(node.attrs.layout) && // Extension breakout state should only be respected for top level nodes.
    isTopLevelNode && // Extension breakout state should not be respected when the editor appearance is full-width mode
    editorAppearance !== 'full-width';
    // We don't want to show border for non-empty 1p bodied extensions in live pages
    const show1PBodiedExtensionBorder = showUpdatedLivePages1PBodiedExtensionUI ? (0, $5wrbt.isEmptyBodiedMacro)(node) : true;
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('extension-container', 'block', shadowClassNames, {
        'with-overlay': !hasBody && !showMacroInteractionDesignUpdates,
        'with-bodied-border': showMacroInteractionDesignUpdates && (hasBody || isLegacyContentMacroExtension(node)) && !showBodiedExtensionRendererView && show1PBodiedExtensionBorder,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested && !showBodiedExtensionRendererView,
        'with-hover-border': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? false : showMacroInteractionDesignUpdates && isNodeHovered,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'without-frame': removeBorder,
        'legacy-content': showLegacyContentHeader,
        [(0, $jY6Lt.widerLayoutClassName)]: shouldBreakout
    });
    const overflowClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('extension-overflow-wrapper', {
        'with-body': hasBody,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested && !showBodiedExtensionRendererView,
        // Adding extra padding for renderer view so users can have a touch target to click on the extension
        'with-padding-styles': showMacroInteractionDesignUpdates && showBodiedExtensionRendererView
    });
    const headerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
        'with-children': hasChildren,
        'without-frame': removeBorder
    });
    const newContentClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
        'with-padding-styles': showMacroInteractionDesignUpdates,
        'with-bodied-padding-styles': hasBody && showMacroInteractionDesignUpdates
    });
    const contentClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('extension-content', 'block', {
        'remove-border': showMacroInteractionDesignUpdates,
        'hide-content': showBodiedExtensionRendererView
    });
    let customContainerStyles = {
        width: '100%'
    };
    let newContentStyles = {};
    if (shouldBreakout) {
        const { type: type, ...breakoutStyles } = (0, $fJNzZ.calculateBreakoutStyles)({
            mode: node.attrs.layout,
            widthStateWidth: widthState.width,
            widthStateLineLength: widthState.lineLength
        });
        newContentStyles = {
            ...breakoutStyles
        };
        customContainerStyles = breakoutStyles;
    }
    newContentStyles = {
        ...newContentStyles,
        ...(0, $jY6Lt.contentWrapper)
    };
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    const extensionContentStyles = (0, $1oCLl.expValEquals)('platform_editor_extension_styles', 'isEnabled', true) ? (0, $jY6Lt.extensionContent) : (0, $jY6Lt.content);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, showLegacyContentHeader && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7gXVN.LegacyContentHeader), {
        isNodeSelected: isNodeSelected,
        isNodeHovered: isNodeHovered,
        onMouseEnter: ()=>handleMouseEvent(true),
        onMouseLeave: ()=>handleMouseEvent(false)
    }), !showLegacyContentHeader && showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $klDBQ.default), {
        isNodeSelected: isNodeSelected,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        customContainerStyles: customContainerStyles,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: hasBody || isLegacyContentMacroExtension(node),
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
        pluginInjectionApi: pluginInjectionApi
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "extension-container",
        ref: handleRef,
        "data-layout": node.attrs.layout,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $jY6Lt.wrapperStyleInheritedCursor),
            showMacroInteractionDesignUpdates && !isLivePageViewMode && (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) && $8b68c835fd1c0f68$var$hoverStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: ()=>handleMouseEvent(true),
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: ()=>handleMouseEvent(false)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "extension-overflow-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: overflowClassNames,
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $jY6Lt.overflowWrapperStyles),
            (0, $dh538.fg)('platform_fix_macro_renders_in_layouts') && $8b68c835fd1c0f68$var$containerStyle
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        className: 'extension-overlay',
        css: (0, $mBi3D.overlay)
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $jY6Lt.header),
        contentEditable: false,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: headerClassNames
    }, !removeBorder && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $klDBQ.default), {
        isNodeSelected: isNodeSelected,
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        pluginInjectionApi: pluginInjectionApi
    }), children), hasBody && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: newContentStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: newContentClassNames,
        "data-testid": "extension-new-content"
    }, !shouldHideInLivePageViewMode && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "extension-content",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: extensionContentStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: contentClassNames
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: handleContentDOMRef
    }))))));
}
const $8b68c835fd1c0f68$var$Extension = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi } = props;
    const { lineLength: lineLength, width: width } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>({
            width: states.widthState?.width ?? 0,
            lineLength: states.widthState?.lineLength
        }));
    // Ignored via go/ees005
    return /*#__PURE__*/ (0, $9K4OG.jsx)($8b68c835fd1c0f68$var$ExtensionWithPluginState, {
        widthState: {
            width: width ?? 0,
            lineLength: lineLength
        },
        ...props
    });
};
var $8b68c835fd1c0f68$export$2e2bcd8739ae039 = (0, $frt7o.default)($8b68c835fd1c0f68$var$Extension, {
    overflowSelector: '.extension-overflow-wrapper'
});

});

parcelRegister("7gXVN", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ebrpi = parcelRequire("ebrpi");


var $2Nwuj = parcelRequire("2Nwuj");


var $eUDtA = parcelRequire("eUDtA");

const $6eaa8c52d5fb00d7$var$i18n = (0, $cgtv4.defineMessages)({
    legacyContentHeader: {
        id: "editor.extension.legacyContentHeader",
        defaultMessage: "Legacy Content"
    },
    contentHasLimitedFunctionality: {
        id: "editor.extension.legacyContentHeader.contentHasLimitedFunctionality",
        defaultMessage: "This content has limited functionality,"
    },
    learnMore: {
        id: "editor.extension.legacyContentHeader.learnMore",
        defaultMessage: "Learn more"
    }
});
const $6eaa8c52d5fb00d7$var$lcmHeaderStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `0 ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-200, 16px)"}`,
    backgroundColor: "var(--ds-background-neutral, #0515240F)",
    borderRadius: `${"var(--ds-radius-small, 4px)"} ${"var(--ds-radius-small, 4px)"} 0 0`,
    boxShadow: `0 0 0 1px ${"var(--ds-background-neutral, #0515240F)"}`,
    position: 'relative',
    top: `-1px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.selected': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
        backgroundColor: "var(--ds-background-selected, #E9F2FE)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .status-lozenge-span': {
        marginRight: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > .legacy-content-header-text': {
        font: "var(--ds-font-body-UNSAFE_small, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& span': {
            paddingRight: "var(--ds-space-050, 4px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& a': {
            cursor: 'pointer'
        }
    }
});
const $6eaa8c52d5fb00d7$export$e228783371741227 = ({ isNodeHovered: isNodeHovered, isNodeSelected: isNodeSelected, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('legacy-content-header', {
        'with-hover-border': isNodeHovered,
        selected: isNodeSelected
    });
    const learnMore = (0, $42omo.useCallback)(()=>{
        window.open('https://support.atlassian.com/confluence-cloud/docs/the-legacy-content-macro/', '_blank');
    }, []);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "editor-extension-legacy-content-header",
        css: [
            $6eaa8c52d5fb00d7$var$lcmHeaderStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: onMouseEnter,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eUDtA.Status), {
        text: formatMessage($6eaa8c52d5fb00d7$var$i18n.legacyContentHeader),
        color: isNodeSelected ? 'blue' : 'neutral',
        style: "bold",
        isBold: true
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        className: "legacy-content-header-text"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        label: formatMessage($6eaa8c52d5fb00d7$var$i18n.contentHasLimitedFunctionality),
        size: "small"
    }), formatMessage($6eaa8c52d5fb00d7$var$i18n.contentHasLimitedFunctionality), "\xa0", /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2Nwuj.default), {
        onClick: learnMore,
        href: "https://support.atlassian.com/confluence-cloud/docs/the-legacy-content-macro/",
        target: "_blank"
    }, formatMessage($6eaa8c52d5fb00d7$var$i18n.learnMore)))));
};
module.exports["LegacyContentHeader"] = $6eaa8c52d5fb00d7$export$e228783371741227;

});

parcelRegister("klDBQ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $21PP6 = parcelRequire("21PP6");


var $mBi3D = parcelRequire("mBi3D");


var $gSgoy = parcelRequire("gSgoy");

class $74e650406d32bf0b$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        const { node: node, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = this.props;
        const imageData = (0, $21PP6.getExtensionLozengeData)({
            node: node,
            type: 'image'
        });
        if (!showMacroInteractionDesignUpdates && imageData && node.type.name !== 'extension') return this.renderImage(imageData);
        const iconData = (0, $21PP6.getExtensionLozengeData)({
            node: node,
            type: 'icon'
        });
        return this.renderFallback(iconData);
    }
    constructor(...args){
        super(...args);
        this.renderImage = (lozengeData)=>{
            const { extensionKey: extensionKey } = this.props.node.attrs;
            const { url: url, ...rest } = lozengeData;
            // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            return /*#__PURE__*/ (0, $9K4OG.jsx)("img", {
                css: (0, $mBi3D.styledImage),
                src: url,
                ...rest,
                alt: extensionKey
            });
        };
        this.renderFallback = (lozengeData)=>{
            const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, customContainerStyles: customContainerStyles, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi } = this.props;
            const { parameters: parameters, extensionKey: extensionKey } = this.props.node.attrs;
            const { name: name } = this.props.node.type;
            const params = parameters && parameters.macroParams;
            const title = parameters && parameters.extensionTitle || parameters && parameters.macroMetadata && parameters.macroMetadata.title || extensionKey;
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gSgoy.LozengeComponent), {
                isNodeHovered: isNodeHovered,
                isNodeSelected: isNodeSelected,
                isNodeNested: isNodeNested,
                showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
                extensionName: name,
                lozengeData: lozengeData,
                params: params,
                title: title,
                renderImage: this.renderImage,
                customContainerStyles: customContainerStyles,
                setIsNodeHovered: setIsNodeHovered,
                isBodiedMacro: isBodiedMacro,
                showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
                showBodiedExtensionRendererView: showBodiedExtensionRendererView,
                setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
                pluginInjectionApi: pluginInjectionApi
            });
        };
    }
}
module.exports["default"] = $74e650406d32bf0b$export$2e2bcd8739ae039;

});

parcelRegister("mBi3D", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

function $b9c5aa0c0db479ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b9c5aa0c0db479ff$export$2c23939c304dcbb6 = {
    name: "1st3gh2",
    styles: "background:var(--ds-background-neutral, #0515240F);border-radius:var(--ds-radius-small, 3px);position:relative;vertical-align:middle;&.with-overlay{.extension-overlay{background:var(--ds-background-neutral-hovered, #0B120E24);color:transparent;}&:hover .extension-overlay{opacity:1;}}"
};
const $b9c5aa0c0db479ff$export$29dd17c7f3c81c36 = {
    name: "7geot",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;top:0;left:0"
};
const $b9c5aa0c0db479ff$export$f61e107d01719381 = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'inline-flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`
    },
    /* TODO: fix in develop: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E */ /* stylelint-disable-next-line */ label: 'placeholder-fallback'
});
const $b9c5aa0c0db479ff$export$baa8de7b590bf812 = {
    name: "147iacu",
    styles: "display:inline-block;max-width:200px;margin-left:var(--ds-space-050, 4px);color:var(--ds-text-subtlest, #6B6E76);text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};
const $b9c5aa0c0db479ff$export$83cb1da155637959 = {
    name: "1ib9bih-lozenge-image",
    styles: "max-height:16px;max-width:16px;label:lozenge-image"
};
module.exports["wrapperDefault"] = $b9c5aa0c0db479ff$export$2c23939c304dcbb6;
module.exports["overlay"] = $b9c5aa0c0db479ff$export$29dd17c7f3c81c36;
module.exports["placeholderFallback"] = $b9c5aa0c0db479ff$export$f61e107d01719381;
module.exports["placeholderFallbackParams"] = $b9c5aa0c0db479ff$export$baa8de7b590bf812;
module.exports["styledImage"] = $b9c5aa0c0db479ff$export$83cb1da155637959;

});

parcelRegister("gSgoy", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $chO1Z = parcelRequire("chO1Z");


var $mBi3D = parcelRequire("mBi3D");


var $lFpYn = parcelRequire("lFpYn");


var $3owB7 = parcelRequire("3owB7");

const $f12893e761db125d$export$91a15f1424900d33 = 24;
const $f12893e761db125d$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $f12893e761db125d$export$14bad8182dc08b5a = ({ lozengeData: lozengeData, extensionName: extensionName, title: title, params: params, renderImage: renderImage, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, customContainerStyles: customContainerStyles, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi })=>{
    const capitalizedTitle = $f12893e761db125d$var$capitalizeFirstLetter(title);
    if (showMacroInteractionDesignUpdates) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3owB7.ExtensionLabel), {
        text: capitalizedTitle,
        extensionName: extensionName,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        customContainerStyles: customContainerStyles,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: isBodiedMacro,
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        pluginInjectionApi: pluginInjectionApi
    }), showLivePagesBodiedMacrosRendererView && isBodiedMacro && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $lFpYn.EditToggle), {
        isNodeHovered: isNodeHovered,
        setIsNodeHovered: setIsNodeHovered,
        customContainerStyles: customContainerStyles,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView
    }));
    const isBlockExtension = extensionName === 'extension';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "lozenge-fallback",
        css: (0, $mBi3D.placeholderFallback)
    }, lozengeData && !isBlockExtension ? renderImage({
        height: $f12893e761db125d$export$91a15f1424900d33,
        width: $f12893e761db125d$export$91a15f1424900d33,
        ...lozengeData
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        label: title
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        className: "extension-title"
    }, capitalizedTitle), params && !isBlockExtension && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: (0, $mBi3D.placeholderFallbackParams)
    }, Object.keys(params).map((key)=>key && ` | ${key} = ${params[key].value}`))));
};
module.exports["LozengeComponent"] = $f12893e761db125d$export$14bad8182dc08b5a;

});

parcelRegister("lFpYn", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $cvXh8 = parcelRequire("cvXh8");


var $1Zr9M = parcelRequire("1Zr9M");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $1oCLl = parcelRequire("1oCLl");

function $6d2e29ce63723d2b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6d2e29ce63723d2b$var$buttonContainerStyles = {
    name: "cy6p8l",
    styles: "opacity:0;line-height:1;position:absolute;width:max-content;top:-28px;display:inline-flex;justify-content:flex-end;color:var(--ds-text-subtle, #505258)"
};
const $6d2e29ce63723d2b$var$buttonStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
    minHeight: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingLeft: "var(--ds-space-150, 12px)",
    paddingRight: "var(--ds-space-150, 12px)",
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    '&:hover': {
        backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
    },
    outlineColor: "var(--ds-border-focused, #4688EC)",
    border: 'none',
    backgroundColor: "var(--ds-background-input, #FFFFFF)",
    color: "var(--ds-text-subtle, #505258)"
});
const $6d2e29ce63723d2b$var$showButtonContainerStyle = {
    name: "3ix1vd",
    styles: "opacity:1"
};
const $6d2e29ce63723d2b$var$iconStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.075'
});
const $6d2e29ce63723d2b$var$i18n = (0, $cgtv4.defineMessages)({
    doneEditing: {
        id: "editor-common-extensibility-extension-lozenge-editToggle.done.editing",
        defaultMessage: "Done editing"
    },
    makeEdits: {
        id: "editor-common-extensibility-extension-lozenge-editToggle.make.edits",
        defaultMessage: "Make edits"
    }
});
const $6d2e29ce63723d2b$export$2ada5dce8cd41705 = ({ isNodeHovered: isNodeHovered, customContainerStyles: customContainerStyles, setIsNodeHovered: setIsNodeHovered, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView })=>{
    const intl = (0, $8C5kA.default)();
    const text = showBodiedExtensionRendererView ? intl.formatMessage($6d2e29ce63723d2b$var$i18n.makeEdits) : intl.formatMessage($6d2e29ce63723d2b$var$i18n.doneEditing);
    const icon = showBodiedExtensionRendererView ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
        testId: "edit-icon",
        label: ""
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        testId: "check-mark-icon",
        label: ""
    });
    const handleClick = (0, $42omo.useCallback)(()=>{
        setShowBodiedExtensionRendererView?.(!showBodiedExtensionRendererView);
    }, [
        showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'Enter') handleClick();
    }, [
        handleClick
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "extension-edit-toggle-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: [
            $6d2e29ce63723d2b$var$buttonContainerStyles,
            (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? null : isNodeHovered && $6d2e29ce63723d2b$var$showButtonContainerStyle
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-edit-toggle-container",
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseOver: ()=>setIsNodeHovered?.(true),
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: ()=>setIsNodeHovered?.(false),
        tabIndex: -1
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
        type: "button",
        "data-testid": "edit-toggle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: $6d2e29ce63723d2b$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-edit-toggle",
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        onFocus: ()=>setIsNodeHovered?.(true),
        onBlur: ()=>setIsNodeHovered?.(false)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bUlM5.default), {
        as: "span",
        xcss: $6d2e29ce63723d2b$var$iconStyles
    }, icon), text));
};
module.exports["EditToggle"] = $6d2e29ce63723d2b$export$2ada5dce8cd41705;

});

parcelRegister("3owB7", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $isYda = parcelRequire("isYda");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $1oCLl = parcelRequire("1oCLl");


var $3gadb = parcelRequire("3gadb");

function $55e0171fddd47a60$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $55e0171fddd47a60$var$containerStyles = {
    name: "1xnw70r",
    styles: "text-align:left;z-index:1;position:relative;&.bodied{margin-top:var(--ds-space-300, 24px);}"
};
const $55e0171fddd47a60$var$showLabelStyles = {
    name: "3ix1vd",
    styles: "opacity:1"
};
const $55e0171fddd47a60$var$hideLabelStyles = {
    name: "mws4fn",
    styles: "opacity:0"
};
const $55e0171fddd47a60$var$labelStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    display: 'inline-flex',
    justifyContent: 'left',
    position: 'absolute',
    width: 'max-content',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
    top: '-28px',
    // When updating this value, make sure to also update the value in EditToggle.tsx, buttonContainerStyles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.show-label': {
        cursor: 'pointer',
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.nested': {
        // Need to add indent if the node is nested since we removed previous indentation styles to make it fit properly
        // in the nested component
        marginLeft: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.inline': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '-27px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.bodied-background': {
        background: "var(--ds-surface, #FFFFFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.bodied-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    minHeight: "var(--ds-space-300, 24px)",
    alignItems: 'center',
    borderRadius: "var(--ds-radius-small, 3px)",
    paddingLeft: "var(--ds-space-100, 8px)",
    paddingRight: "var(--ds-space-100, 8px)",
    color: "var(--ds-text-subtle, #505258)",
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-left-margin': {
        marginLeft: "var(--ds-space-negative-150, -12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-nested-left-margin': {
        marginLeft: 0
    },
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-macro-live-page-styles': {
        backgroundColor: "var(--ds-background-input, #FFFFFF)",
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    }
});
const $55e0171fddd47a60$var$spacerStyles = (0, $ecnYn.xcss)({
    height: 'space.200',
    position: 'absolute',
    width: '100%'
});
const $55e0171fddd47a60$var$iconStyles = {
    name: "1s9vzwe",
    styles: "margin-left:var(--ds-space-075, 6px);&.hide-icon{display:none;}"
};
const $55e0171fddd47a60$var$bodiedMacroIconStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $55e0171fddd47a60$var$i18n = (0, $cgtv4.defineMessages)({
    configure: {
        id: "editor-common-extensibility.macro.button.configure",
        defaultMessage: "Configure {macroName}"
    }
});
const $55e0171fddd47a60$export$b91fdbabc60200d0 = (isBodiedMacro, isNodeHovered, showLivePagesBodiedMacrosRendererView, showBodiedExtensionRendererView, showUpdatedLivePages1PBodiedExtensionUI)=>{
    // Bodied macros show the label by default except for the new live pages 1P bodied macro experience where we only show it on hover
    if (!isBodiedMacro || showUpdatedLivePages1PBodiedExtensionUI) return isNodeHovered;
    if (!showLivePagesBodiedMacrosRendererView) return true;
     // Keep showing labels as usual for default experience for bodied macros
    return !!(isNodeHovered && !showBodiedExtensionRendererView); // For the new live pages bodied macro experience, we only show the label on hover in the "edit" view
};
const $55e0171fddd47a60$export$addedb5f7f03bdb1 = ({ text: text, extensionName: extensionName, isNodeHovered: isNodeHovered, customContainerStyles: customContainerStyles, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showBodiedExtensionRendererView: showBodiedExtensionRendererView, pluginInjectionApi: _pluginInjectionApi })=>{
    const isInlineExtension = extensionName === 'inlineExtension';
    const showDefaultBodiedStyles = (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'isEnabled', true) ? isBodiedMacro : isBodiedMacro && !isNodeHovered;
    const shouldShowBodiedMacroLabel = $55e0171fddd47a60$export$b91fdbabc60200d0(isBodiedMacro, isNodeHovered, showLivePagesBodiedMacrosRendererView, showBodiedExtensionRendererView, showUpdatedLivePages1PBodiedExtensionUI);
    const containerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
        bodied: isBodiedMacro
    });
    const labelClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('extension-label', {
        nested: isNodeNested,
        inline: isInlineExtension,
        bodied: isBodiedMacro,
        'bodied-border': showDefaultBodiedStyles,
        'bodied-background': showDefaultBodiedStyles,
        'show-label': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? false : shouldShowBodiedMacroLabel,
        'with-bodied-macro-live-page-styles': isBodiedMacro && showLivePagesBodiedMacrosRendererView,
        'always-hide-label': isBodiedMacro && showBodiedExtensionRendererView,
        // Need this separate class since we don't ever want to show the label during view mode
        'remove-left-margin': !isBodiedMacro && !isInlineExtension && !isNodeNested,
        'remove-nested-left-margin': isNodeNested && !isBodiedMacro && !isInlineExtension
    });
    const iconClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
        'hide-icon': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? false : isBodiedMacro && !isNodeHovered,
        'extension-icon': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true)
    });
    return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions, @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: $55e0171fddd47a60$var$containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: containerClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseOver: ()=>{
            setIsNodeHovered?.(true);
        },
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: ()=>{
            setIsNodeHovered?.(false);
        },
        "data-testid": "new-lozenge-container",
        contentEditable: false
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), {
            ...$55e0171fddd47a60$var$i18n.configure,
            values: {
                macroName: text
            }
        }),
        position: "top"
    }, (tooltipProps)=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            "data-testid": "new-lozenge-button",
            ...tooltipProps,
            css: [
                $55e0171fddd47a60$var$labelStyles,
                ...(0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? [
                    !showLivePagesBodiedMacrosRendererView && $55e0171fddd47a60$var$showLabelStyles,
                    (!isBodiedMacro || showUpdatedLivePages1PBodiedExtensionUI) && $55e0171fddd47a60$var$hideLabelStyles
                ] : []
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: labelClassNames
        }, text, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: [
                $55e0171fddd47a60$var$iconStyles,
                isBodiedMacro && (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) && $55e0171fddd47a60$var$bodiedMacroIconStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: iconClassNames,
            "data-testid": "config-icon"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
            label: ""
        })))), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $55e0171fddd47a60$var$spacerStyles
    })));
};
module.exports["ExtensionLabel"] = $55e0171fddd47a60$export$addedb5f7f03bdb1;

});

parcelRegister("5wrbt", function(module, exports) {
const $fafa73a8db5dffb3$export$d01da3229dfc693b = (node)=>{
    if (node.type.name !== 'bodiedExtension') return false;
    const firstChildNode = node?.content?.firstChild;
    const firstGrandChildNode = firstChildNode?.firstChild;
    // If firstChildNode?.childCount > 1 means there is content along with the placeholder.
    const isEmptyWithPlacholder = firstGrandChildNode?.type?.name === 'placeholder' && firstChildNode?.childCount === 1;
    const isEmptyWithNoContent = !firstGrandChildNode && node.childCount === 1;
    return isEmptyWithPlacholder || isEmptyWithNoContent;
};
module.exports["isEmptyBodiedMacro"] = $fafa73a8db5dffb3$export$d01da3229dfc693b;

});

parcelRegister("jY6Lt", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $mBi3D = parcelRequire("mBi3D");

const $9c8e1848f6b0636a$export$c51f29288b3ec9db = 'wider-layout';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $9c8e1848f6b0636a$var$wrapperStyleWithoutCursor = /*#__PURE__*/ (0, $9K4OG.css)((0, $mBi3D.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.without-frame': {
        background: 'transparent'
    },
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.extension-overflow-wrapper:not(.with-body)': {
        overflowX: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        margin: `0 ${"var(--ds-space-negative-250, -20px)"}`,
        padding: `0 ${"var(--ds-space-250, 20px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.legacy-content': {
        borderRadius: `0 0 ${"var(--ds-radius-small, 3px)"} ${"var(--ds-radius-small, 3px)"}`
    }
});
const $9c8e1848f6b0636a$export$ebf956b2dea5bd2e = /*#__PURE__*/ (0, $9K4OG.css)($9c8e1848f6b0636a$var$wrapperStyleWithoutCursor, ".extension-overflow-wrapper:has(.extension-editable-area){cursor:inherit;}.extension-overflow-wrapper:not(:has(.extension-editable-area)){cursor:pointer;}");
const $9c8e1848f6b0636a$export$38e42c68cf43b5d4 = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
    verticalAlign: 'middle',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&.with-children:not(.without-frame)': {
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.without-frame': {
        padding: 0
    }
});
const $9c8e1848f6b0636a$export$a7db06668cad9adb = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: "var(--ds-space-100, 8px)",
    background: "var(--ds-surface, white)",
    border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'initial',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-border': {
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.hide-content': {
        display: 'none'
    }
});
const $9c8e1848f6b0636a$export$16dcf8c62f81d973 = /*#__PURE__*/ (0, $9K4OG.css)({
    boxSizing: 'border-box',
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)",
    background: "var(--ds-surface, white)",
    border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'initial',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-border': {
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.hide-content': {
        display: 'none'
    }
});
const $9c8e1848f6b0636a$export$2a82ddc22e8c7fbb = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
    display: 'flex',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-styles': {
        padding: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-padding-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}` // account for upcoming editor elements drag & drop feature
    }
});
const $9c8e1848f6b0636a$export$2ab74686abf0084 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        margin: `0 ${"var(--ds-space-negative-250, -20px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-styles': {
        padding: "var(--ds-space-100, 8px)"
    }
});
module.exports["widerLayoutClassName"] = $9c8e1848f6b0636a$export$c51f29288b3ec9db;
module.exports["wrapperStyleInheritedCursor"] = $9c8e1848f6b0636a$export$ebf956b2dea5bd2e;
module.exports["header"] = $9c8e1848f6b0636a$export$38e42c68cf43b5d4;
module.exports["content"] = $9c8e1848f6b0636a$export$a7db06668cad9adb;
module.exports["extensionContent"] = $9c8e1848f6b0636a$export$16dcf8c62f81d973;
module.exports["contentWrapper"] = $9c8e1848f6b0636a$export$2a82ddc22e8c7fbb;
module.exports["overflowWrapperStyles"] = $9c8e1848f6b0636a$export$2ab74686abf0084;

});

parcelRegister("aAiMR", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $eiA8Z = parcelRequire("eiA8Z");


var $bWRlG = parcelRequire("bWRlG");


var $klDBQ = parcelRequire("klDBQ");


var $mBi3D = parcelRequire("mBi3D");


var $jZde6 = parcelRequire("jZde6");

function $b04b056b17bd0ca9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b04b056b17bd0ca9$var$inlineWrapperStyles = {
    name: "m3p6m2",
    styles: "max-width:100%;tr &{max-width:inherit;}.rich-media-item{max-width:100%;}"
};
const $b04b056b17bd0ca9$var$hoverStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $b04b056b17bd0ca9$var$InlineExtension = (props)=>{
    const { node: node, pluginInjectionApi: pluginInjectionApi, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, children: children, isNodeHovered: isNodeHovered, setIsNodeHovered: setIsNodeHovered, isLivePageViewMode: isLivePageViewMode } = props;
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const { width: width } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>{
        return {
            width: states.widthState?.width
        };
    });
    const hasChildren = !!children;
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('extension-container', 'inline', {
        'with-overlay': !showMacroInteractionDesignUpdates,
        'with-children': hasChildren,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'with-hover-border': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? false : showMacroInteractionDesignUpdates && isNodeHovered
    });
    let rendererContainerWidth = 0;
    if ((0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    })) {
        if (width) {
            const padding = width > (0, $aFUXX.akEditorFullPageNarrowBreakout) ? (0, $aFUXX.akEditorGutterPaddingDynamic)() : (0, $aFUXX.akEditorGutterPaddingReduced);
            rendererContainerWidth = width - padding * 2;
        }
    } else rendererContainerWidth = width ? width - (0, $aFUXX.akEditorGutterPaddingDynamic)() * 2 : 0;
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    const inlineExtensionInternal = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $klDBQ.default), {
        node: node,
        isNodeSelected: isNodeSelected,
        isNodeHovered: isNodeHovered,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        setIsNodeHovered: setIsNodeHovered,
        pluginInjectionApi: pluginInjectionApi
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "inline-extension-wrapper",
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $jZde6.wrapperStyle),
            $b04b056b17bd0ca9$var$inlineWrapperStyles,
            showMacroInteractionDesignUpdates && !isLivePageViewMode && (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) && $b04b056b17bd0ca9$var$hoverStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: ()=>handleMouseEvent(true),
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: ()=>handleMouseEvent(false)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $mBi3D.overlay),
        className: "extension-overlay"
    }), children ? children : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $klDBQ.default), {
        node: node,
        isNodeSelected: isNodeSelected,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        pluginInjectionApi: pluginInjectionApi
    })));
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthContext).Provider, {
        value: (0, $bWRlG.createWidthContext)(rendererContainerWidth)
    }, inlineExtensionInternal);
};
var $b04b056b17bd0ca9$export$2e2bcd8739ae039 = $b04b056b17bd0ca9$var$InlineExtension;
module.exports["default"] = $b04b056b17bd0ca9$export$2e2bcd8739ae039;

});

parcelRegister("jZde6", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $mBi3D = parcelRequire("mBi3D");

const $d1d88cc5ea760762$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $9K4OG.css)((0, $mBi3D.wrapperDefault), {
    cursor: 'pointer',
    display: 'inline-flex',
    margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> img': {
        borderRadius: "var(--ds-radius-small, 3px)"
    },
    '&::after, &::before': {
        verticalAlign: 'text-top',
        display: 'inline-block',
        content: "''"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-children': {
        padding: 0,
        background: "var(--ds-background-neutral-subtle, white)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
module.exports["wrapperStyle"] = $d1d88cc5ea760762$export$c4d4f06a25de97f;

});

parcelRegister("akFmj", function(module, exports) {
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $chO1Z = parcelRequire("chO1Z");


var $1oCLl = parcelRequire("1oCLl");


var $eiA8Z = parcelRequire("eiA8Z");


var $dsfZn = parcelRequire("dsfZn");


var $fJNzZ = parcelRequire("fJNzZ");

var $21PP6 = parcelRequire("21PP6");


var $klDBQ = parcelRequire("klDBQ");


var $gC39r = parcelRequire("gC39r");


var $7OgWk = parcelRequire("7OgWk");

function $d51e9fd51004e891$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d51e9fd51004e891$var$getContainerCssExtendedStyles = (activeChildIndex, showMacroInteractionDesignUpdates)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9K4OG.css)((0, $dsfZn.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true']:nth-of-type(${activeChildIndex + 1})`]: /*#__PURE__*/ (0, $9K4OG.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $dsfZn.sharedMultiBodiedExtensionStyles).extensionFrameContent, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        showMacroInteractionDesignUpdates && (0, $dsfZn.removeMarginsAndBorder))
    });
const $d51e9fd51004e891$var$imageStyles = {
    name: "yadgg9",
    styles: "max-height:24px;max-width:24px"
};
const $d51e9fd51004e891$var$hoverStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $d51e9fd51004e891$var$MultiBodiedExtensionFrames = ({ articleRef: articleRef })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("article", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--frames",
        "data-testid": "multiBodiedExtension--frames",
        ref: articleRef
    });
};
// Similar to the one in platform/packages/editor/editor-common/src/extensibility/Extension/Lozenge.tsx
const $d51e9fd51004e891$var$getWrapperTitleContent = (imageData, title, showMacroInteractionDesignUpdates)=>{
    if (showMacroInteractionDesignUpdates) return null;
    if (imageData) {
        const { url: url, ...rest } = imageData;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            className: "extension-title"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("img", {
            css: $d51e9fd51004e891$var$imageStyles,
            src: url,
            ...rest,
            alt: title
        }), title));
    }
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-title",
        "data-testid": 'multiBodiedExtension-default-lozenge'
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        label: title
    }), title);
};
const $d51e9fd51004e891$var$MultiBodiedExtensionWithWidth = ({ node: node, handleContentDOMRef: handleContentDOMRef, getPos: getPos, tryExtensionHandler: tryExtensionHandler, editorView: editorView, eventDispatcher: eventDispatcher, widthState: widthState, editorAppearance: editorAppearance, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, pluginInjectionApi: pluginInjectionApi, isLivePageViewMode: isLivePageViewMode, allowBodiedOverride: allowBodiedOverride = false })=>{
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const { parameters: parameters, extensionKey: extensionKey } = node.attrs;
    const title = parameters && parameters.extensionTitle || parameters && parameters.macroMetadata && parameters.macroMetadata.title || extensionKey || node.type.name;
    const imageData = (0, $21PP6.getExtensionLozengeData)({
        node: node,
        type: 'image'
    });
    const [activeChildIndex, setActiveChildIndex] = (0, $42omo.useState)(0);
    // Adding to avoid aliasing `this` for the callbacks
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((index)=>{
        if (typeof index !== 'number') {
            setActiveChildIndex(0);
            throw new Error('Index is not valid');
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const articleRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        return handleContentDOMRef(node);
    }, [
        handleContentDOMRef
    ]);
    const childrenContainer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return /*#__PURE__*/ (0, $9K4OG.jsx)($d51e9fd51004e891$var$MultiBodiedExtensionFrames, {
            articleRef: articleRef
        });
    }, [
        articleRef
    ]);
    const actions = (0, $gC39r.useMultiBodiedExtensionActions)({
        updateActiveChild: updateActiveChild,
        editorView: editorView,
        getPos: getPos,
        node: node,
        eventDispatcher: eventDispatcher,
        allowBodiedOverride: allowBodiedOverride,
        childrenContainer: childrenContainer
    });
    const extensionHandlerResult = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return tryExtensionHandler(actions);
    }, [
        tryExtensionHandler,
        actions
    ]);
    const shouldBreakout = // Extension should breakout when the layout is set to 'full-width' or 'wide'.
    [
        'full-width',
        'wide'
    ].includes(node.attrs.layout) && // Extension breakout state should not be respected when the editor appearance is full-width mode
    editorAppearance !== 'full-width';
    let mbeWrapperStyles = {};
    if (shouldBreakout) {
        const { ...breakoutStyles } = (0, $fJNzZ.calculateBreakoutStyles)({
            mode: node.attrs.layout,
            widthStateLineLength: widthState?.lineLength,
            widthStateWidth: widthState?.width
        });
        mbeWrapperStyles = breakoutStyles;
    }
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('multiBodiedExtension--wrapper', 'extension-container', 'block', {
        'with-border': showMacroInteractionDesignUpdates,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'with-padding-background-styles': showMacroInteractionDesignUpdates,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested,
        'with-hover-border': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? false : showMacroInteractionDesignUpdates && isNodeHovered
    });
    const containerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('multiBodiedExtension--container', {
        'remove-padding': showMacroInteractionDesignUpdates
    });
    const bodyContainerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('multiBodiedExtension--body-container');
    const navigationClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('multiBodiedExtension--navigation', {
        'remove-margins': showMacroInteractionDesignUpdates,
        'remove-border': showMacroInteractionDesignUpdates
    });
    const overlayClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('multiBodiedExtension--overlay', {
        'with-margin': showMacroInteractionDesignUpdates
    });
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $klDBQ.default), {
        isNodeSelected: isNodeSelected,
        node: node,
        showMacroInteractionDesignUpdates: true,
        customContainerStyles: mbeWrapperStyles,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: true,
        pluginInjectionApi: pluginInjectionApi
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: wrapperClassNames,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $7OgWk.mbeExtensionWrapperCSSStyles),
            showMacroInteractionDesignUpdates && !isLivePageViewMode && (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) && $d51e9fd51004e891$var$hoverStyles
        ],
        "data-testid": "multiBodiedExtension--wrapper-editor",
        "data-layout": node.attrs.layout,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mbeWrapperStyles,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: ()=>handleMouseEvent(true),
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: ()=>handleMouseEvent(false)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $7OgWk.overlayStyles),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: overlayClassNames,
        "data-testid": "multiBodiedExtension--overlay"
    }), $d51e9fd51004e891$var$getWrapperTitleContent(imageData, title, showMacroInteractionDesignUpdates), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: containerClassNames,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $d51e9fd51004e891$var$getContainerCssExtendedStyles(activeChildIndex, showMacroInteractionDesignUpdates),
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex
    }, allowBodiedOverride ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: bodyContainerClassNames,
        "data-testid": "multiBodiedExtension--body-container"
    }, extensionHandlerResult) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)("nav", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: navigationClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $dsfZn.sharedMultiBodiedExtensionStyles).mbeNavigation,
        "data-testid": "multiBodiedExtension-navigation"
    }, extensionHandlerResult), childrenContainer))));
};
const $d51e9fd51004e891$var$MultiBodiedExtension = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi } = props;
    const { width: width, lineLength: lineLength } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>({
            width: states.widthState?.width,
            lineLength: states.widthState?.lineLength
        }));
    // Ignored via go/ees005
    return /*#__PURE__*/ (0, $9K4OG.jsx)($d51e9fd51004e891$var$MultiBodiedExtensionWithWidth, {
        widthState: width === undefined ? undefined : {
            width: width,
            lineLength: lineLength
        },
        ...props
    });
};
var $d51e9fd51004e891$export$2e2bcd8739ae039 = $d51e9fd51004e891$var$MultiBodiedExtension;
module.exports["default"] = $d51e9fd51004e891$export$2e2bcd8739ae039;

});

parcelRegister("dsfZn", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

function $a6eef6e1b2d41e58$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $a6eef6e1b2d41e58$var$mbeExtensionContainer = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $a6eef6e1b2d41e58$var$mbeNavigation = {
    name: "4tty3q",
    styles: "border-top-left-radius:var(--ds-radius-small, 3px);border-top-right-radius:var(--ds-radius-small, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $a6eef6e1b2d41e58$var$extensionFrameContent = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    display: 'block',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $a6eef6e1b2d41e58$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $a6eef6e1b2d41e58$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $a6eef6e1b2d41e58$var$mbeExtensionContainer,
    mbeNavigation: $a6eef6e1b2d41e58$var$mbeNavigation,
    extensionFrameContent: $a6eef6e1b2d41e58$var$extensionFrameContent
};
module.exports["removeMarginsAndBorder"] = $a6eef6e1b2d41e58$export$8df0393dc2d5d656;
module.exports["sharedMultiBodiedExtensionStyles"] = $a6eef6e1b2d41e58$export$9c7196ca47f67390;

});

parcelRegister("gC39r", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ks2lK = parcelRequire("ks2lK");


var $d925B = parcelRequire("d925B");


var $lWHWf = parcelRequire("lWHWf");

const $9ffc27468419e619$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, editorView: editorView, getPos: getPos, node: node, eventDispatcher: eventDispatcher, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return {
            changeActive (index) {
                const { state: state, dispatch: dispatch } = editorView;
                const updateActiveChildResult = updateActiveChild(index);
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).CHANGE_ACTIVE, node, eventDispatcher);
                // On selection of a childFrame, we need to change the focus/selection to the end of the target child Frame
                const pos = getPos();
                if (typeof pos !== 'number') return updateActiveChildResult;
                const possiblyMbeNode = state.doc.nodeAt(pos);
                let desiredPos = pos;
                if (possiblyMbeNode && possiblyMbeNode?.type?.name === 'multiBodiedExtension' && possiblyMbeNode?.content) {
                    if (index < 0 || index >= possiblyMbeNode?.content?.childCount) throw new Error(`Index out of bounds: valid range is 0-${possiblyMbeNode?.content?.childCount - 1} inclusive`);
                    for(let i = 0; i <= index && i < possiblyMbeNode?.content?.childCount; i++)desiredPos += possiblyMbeNode?.content?.child(i)?.nodeSize || 0;
                    /* desiredPos gives the cursor at the end of last child of the current frame, in case of paragraph nodes, this will be the end of the paragraph
					 * Performing -1 brings the cursor inside the paragraph, similar to a user click, so any pasted text will be inside the last paragraph rather than a new line
					 */ dispatch(state.tr.setSelection(new (0, $ks2lK.TextSelection)(state.doc.resolve(desiredPos - 1))));
                }
                return updateActiveChildResult;
            },
            addChild () {
                const { state: state, dispatch: dispatch } = editorView;
                const p = state.schema.nodes.paragraph.createAndFill({});
                if (!p) throw new Error('Could not create paragraph');
                const frame = state.schema.nodes.extensionFrame.createAndFill({}, [
                    p
                ]);
                const pos = getPos();
                if (typeof pos !== 'number' || !frame) throw new Error('Could not create frame or position not valid');
                const insertAt = Math.min((pos || 1) + node.content.size, state.doc.content.size);
                const tr = state.tr.insert(insertAt, frame);
                tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(insertAt + 1)));
                dispatch(tr);
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).ADD_CHILD, node, eventDispatcher);
                return true;
            },
            getChildrenCount () {
                return node.content.childCount;
            },
            removeChild (index) {
                const pos = getPos();
                // Ignored via go/ees007
                // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                // TODO: Add child index validation here, don't trust this data
                if (typeof pos !== 'number' || typeof index !== 'number') throw new Error('Position or index not valid');
                const { state: state, dispatch: dispatch } = editorView;
                if (node.content.childCount === 1) {
                    const tr = state.tr;
                    tr.deleteRange(pos, pos + node.content.size);
                    dispatch(tr);
                    return true;
                }
                const $pos = state.doc.resolve(pos);
                const $startNodePos = state.doc.resolve($pos.start($pos.depth + 1));
                const startFramePosition = $startNodePos.posAtIndex(index);
                const maybeFrameNode = state.doc.nodeAt(startFramePosition);
                if (!maybeFrameNode) throw new Error('Could not find frame node');
                const endFramePosition = maybeFrameNode.content.size + startFramePosition;
                const tr = state.tr;
                tr.deleteRange(startFramePosition, endFramePosition);
                dispatch(tr);
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).REMOVE_CHILD, node, eventDispatcher);
                return true;
            },
            updateParameters (parameters) {
                const { state: state, dispatch: dispatch } = editorView;
                const pos = getPos();
                if (typeof pos !== 'number') throw new Error('Position not valid');
                // We are retaining node.attrs to keep the node type and extension key
                // and only updating the parameters coming in from the user
                // parameters will contain only macroParams information
                const updatedParameters = {
                    ...node.attrs,
                    parameters: {
                        ...node.attrs.parameters,
                        macroParams: parameters
                    }
                };
                const tr = state.tr.setNodeMarkup(pos, null, updatedParameters);
                dispatch(tr);
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).UPDATE_PARAMETERS, node, eventDispatcher);
                return true;
            },
            getChildren () {
                const { state: state } = editorView;
                const pos = getPos();
                if (typeof pos !== 'number') return [];
                const children = state.doc.nodeAt(pos)?.content;
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).GET_CHILDREN, node, eventDispatcher);
                return children ? children.toJSON() : [];
            },
            getChildrenContainer () {
                if (!allowBodiedOverride) throw new Error('Could not provide children container');
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).GET_CHILDREN_CONTAINER, node, eventDispatcher);
                return childrenContainer;
            }
        };
    }, [
        node,
        editorView,
        getPos,
        updateActiveChild,
        eventDispatcher,
        allowBodiedOverride,
        childrenContainer
    ]);
    return actions;
};
module.exports["useMultiBodiedExtensionActions"] = $9ffc27468419e619$export$3c7139d93ecb4f1f;

});

parcelRegister("lWHWf", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $5vVM5 = parcelRequire("5vVM5");


var $lWghV = parcelRequire("lWghV");

const $71ab275aa2a7d41a$export$c39676f5ca8bcb0e = (action, node, eventDispatcher)=>{
    const analyticsDispatch = (0, $5vVM5.createDispatch)(eventDispatcher);
    analyticsDispatch((0, $lWghV.analyticsEventKey), {
        payload: {
            action: action,
            actionSubject: (0, $d925B.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey,
                localId: node.attrs.localId,
                currentFramesCount: node.content.childCount
            }
        }
    });
};
module.exports["sendMBEAnalyticsEvent"] = $71ab275aa2a7d41a$export$c39676f5ca8bcb0e;

});

parcelRegister("7OgWk", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $mBi3D = parcelRequire("mBi3D");

function $3f1e3a768037ae22$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3f1e3a768037ae22$export$4226a1fc882c4ef9 = /*#__PURE__*/ (0, $9K4OG.css)((0, $mBi3D.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        marginTop: 0,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)"
    },
    cursor: 'pointer',
    marginTop: "var(--ds-space-250, 24px)",
    marginBottom: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extension-title': {
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: '16px !important',
        marginBottom: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-050, 4px)"} !important`,
        marginRight: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingTop: `${"var(--ds-space-100, 8px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-background-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`,
        background: 'transparent'
    }
});
const $3f1e3a768037ae22$export$9b0df2896b2eff02 = {
    name: "1jgeuox",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;z-index:1;&.with-margin{margin:var(--ds-space-negative-100, -8px);}"
};
module.exports["mbeExtensionWrapperCSSStyles"] = $3f1e3a768037ae22$export$4226a1fc882c4ef9;
module.exports["overlayStyles"] = $3f1e3a768037ae22$export$9b0df2896b2eff02;

});

parcelRegister("3oRlx", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $1oCLl = parcelRequire("1oCLl");


var $TfRUG = parcelRequire("TfRUG");

function $a1dfc4182694ae4d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a1dfc4182694ae4d$var$styles = {
    name: "4s3kp2",
    styles: "&.inline-extension{display:inline-block;}&.relative{position:relative;}"
};
const $a1dfc4182694ae4d$var$hoverStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-container, :has(.extension-edit-toggle-container:hover) .extension-container': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-container:hover) .extension-label, :has(.extension-edit-toggle-container:hover) .extension-label, .extension-label:hover': {
        opacity: 1,
        backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        boxShadow: 'none',
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.always-hide-label': {
            opacity: 0,
            cursor: 'auto'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.with-bodied-macro-live-page-styles': {
            backgroundColor: "var(--ds-background-input, #FFFFFF)",
            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-icon, :has(.extension-container:hover) .extension-icon, :has(.extension-edit-toggle-container:hover) .extension-icon': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-edit-toggle-container, :has(.extension-container:hover) .extension-edit-toggle-container, .extension-edit-toggle-container:hover': {
        opacity: 1
    }
});
const $a1dfc4182694ae4d$export$f97fc055ac075140 = ({ children: children, nodeType: nodeType, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags })=>{
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
        'inline-extension': nodeType === 'inlineExtension' && showMacroInteractionDesignUpdates,
        relative: showMacroInteractionDesignUpdates
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: wrapperClassNames,
        css: [
            $a1dfc4182694ae4d$var$styles,
            (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) && $a1dfc4182694ae4d$var$hoverStyles
        ]
    }, children, nodeType === 'inlineExtension' && (0, $TfRUG.ZERO_WIDTH_SPACE));
};
module.exports["ExtensionNodeWrapper"] = $a1dfc4182694ae4d$export$f97fc055ac075140;

});

parcelRegister("h17uI", function(module, exports) {
/*!
 * is-number <https://github.com/jonschlinkert/is-number>
 *
 * Copyright (c) 2014-present, Jon Schlinkert.
 * Released under the MIT License.
 */ 'use strict';
module.exports = function(num) {
    if (typeof num === 'number') return num - num === 0;
    if (typeof num === 'string' && num.trim() !== '') return Number.isFinite ? Number.isFinite(+num) : isFinite(+num);
    return false;
};

});

parcelRegister("lQotL", function(module, exports) {

var $gSn22 = parcelRequire("gSn22");


var $lClEe = parcelRequire("lClEe");

const $976b4431197bda7a$export$a305f4d2cc38e07 = ({ api: api })=>({
        name: 'localId',
        actions: {
            replaceNode: (0, $gSn22.replaceNode)(api),
            getNode: (0, $gSn22.getNode)(api)
        },
        pmPlugins () {
            return [
                {
                    name: 'localIdPlugin',
                    plugin: ()=>(0, $lClEe.createPlugin)(api)
                }
            ];
        }
    });
module.exports["localIdPlugin"] = $976b4431197bda7a$export$a305f4d2cc38e07;

});

parcelRegister("gSn22", function(module, exports) {
function $1c3c5e644df8ef9c$export$aadcc3ba2430b(tr, localId) {
    let result;
    tr.doc.descendants((node, pos)=>{
        if (result) return false;
        if (node.attrs.localId === localId) result = {
            node: node,
            pos: pos
        };
        return result === undefined;
    });
    return result;
}
const $1c3c5e644df8ef9c$export$5542201de9311ab2 = (api)=>({ localId: localId, value: value })=>{
        const nodeWithPos = $1c3c5e644df8ef9c$export$3f778c4e796a1f9c(api)({
            localId: localId
        });
        if (!nodeWithPos) return false;
        const { pos: pos, node: node } = nodeWithPos;
        return api?.core.actions.execute(({ tr: tr })=>tr.replaceWith(pos, pos + node.nodeSize, value).scrollIntoView()) ?? false;
    };
const $1c3c5e644df8ef9c$export$3f778c4e796a1f9c = (api)=>({ localId: localId })=>{
        let result;
        api?.core.actions.execute(({ tr: tr })=>{
            result = $1c3c5e644df8ef9c$export$aadcc3ba2430b(tr, localId);
            return null;
        });
        return result;
    };
module.exports["replaceNode"] = $1c3c5e644df8ef9c$export$5542201de9311ab2;
module.exports["getNode"] = $1c3c5e644df8ef9c$export$3f778c4e796a1f9c;

});

parcelRegister("lClEe", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");


var $7Mtx3 = parcelRequire("7Mtx3");


var $h3X17 = parcelRequire("h3X17");


var $1S4f7 = parcelRequire("1S4f7");


var $kTbzR = parcelRequire("kTbzR");


var $ks2lK = parcelRequire("ks2lK");


var $dh538 = parcelRequire("dh538");

const $afcb24c50c80cbe1$export$588b8cd7ca34b82 = new (0, $ks2lK.PluginKey)('localIdPlugin');
const $afcb24c50c80cbe1$var$generateUUID = (api, node, pos)=>{
    if ((0, $dh538.fg)('platform_editor_ai_local_id_short')) // Use the same technique as the anchor id which is faster and shorter
    return api?.core.actions.getAnchorIdForNode(node, pos)?.replace('--anchor-', '') ?? (0, $fO7hX.uuid).generate();
    // When the flag is NOT enabled, existing uuid
    return (0, $fO7hX.uuid).generate();
};
// Fallback for Safari which doesn't support requestIdleCallback
const $afcb24c50c80cbe1$var$requestIdleCallbackWithFallback = (callback)=>{
    if (typeof requestIdleCallback !== 'undefined') requestIdleCallback(callback);
    else // Fallback to requestAnimationFrame for Safari
    requestAnimationFrame(callback);
};
const $afcb24c50c80cbe1$export$ae829ec7b2625219 = (api)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $afcb24c50c80cbe1$export$588b8cd7ca34b82,
        view: (editorView)=>{
            /**
			 * This performs a one-time scan of the document to add local IDs
			 * to nodes that don't have them. It's designed to run only once per
			 * editor instance to avoid performance issues.
			 */ // @ts-expect-error - This is an experiment to see if we can improve performance - if successful
            // we will add the plugin as a dependency
            if (api?.collabEdit && (0, $dh538.fg)('platform_editor_ai_aifc_avoid_initial_localId')) return {
                update: ()=>{}
            };
            $afcb24c50c80cbe1$var$requestIdleCallbackWithFallback(()=>{
                const tr = editorView.state.tr;
                let localIdWasAdded = false;
                const nodesToUpdate = new Map(); // position -> localId
                const { text: text, hardBreak: hardBreak, mediaGroup: mediaGroup } = editorView.state.schema.nodes;
                // Media group is ignored for now
                // https://bitbucket.org/atlassian/adf-schema/src/fb2236147a0c2bc9c8efbdb75fd8f8c411df44ba/packages/adf-schema/src/next-schema/nodes/mediaGroup.ts#lines-12
                const ignoredNodeTypes = mediaGroup ? [
                    text.name,
                    hardBreak.name,
                    mediaGroup.name
                ] : [
                    text.name,
                    hardBreak.name
                ];
                editorView.state.doc.descendants((node, pos)=>{
                    if (!ignoredNodeTypes.includes(node.type.name) && !node.attrs.localId && !!node.type.spec.attrs?.localId) {
                        if ((0, $dh538.fg)('platform_editor_localid_improvements')) nodesToUpdate.set(pos, $afcb24c50c80cbe1$var$generateUUID(api, node, pos));
                        else {
                            localIdWasAdded = true;
                            $afcb24c50c80cbe1$export$9c1f7572297aed68(api, pos, tr, node);
                        }
                    }
                    return true; // Continue traversing
                });
                if ((0, $dh538.fg)('platform_editor_localid_improvements')) {
                    if (nodesToUpdate.size > 0) {
                        $afcb24c50c80cbe1$export$6722232dcd7a6b1b(nodesToUpdate, tr);
                        (0, $h3X17.tintDirtyTransaction)(tr);
                        editorView.dispatch(tr);
                    }
                } else if (localIdWasAdded) {
                    tr.setMeta('addToHistory', false);
                    (0, $h3X17.tintDirtyTransaction)(tr);
                    editorView.dispatch(tr);
                }
            });
            return {
                update: ()=>{}
            };
        },
        /**
		 * Handles adding local IDs to new nodes that are created and have the localId attribute
		 * This ensures uniqueness of localIds on nodes being created or edited
		 */ appendTransaction: (transactions, _oldState, newState)=>{
            let modified = false;
            const tr = newState.tr;
            const { text: text, hardBreak: hardBreak, mediaGroup: mediaGroup } = newState.schema.nodes;
            // Media group is ignored for now
            // https://bitbucket.org/atlassian/adf-schema/src/fb2236147a0c2bc9c8efbdb75fd8f8c411df44ba/packages/adf-schema/src/next-schema/nodes/mediaGroup.ts#lines-12
            const ignoredNodeTypes = [
                text?.name,
                hardBreak?.name,
                mediaGroup?.name
            ];
            const addedNodes = new Set();
            const addedNodePos = new Map();
            const localIds = new Set();
            const nodesToUpdate = new Map(); // position -> localId
            // Process only the nodes added in the transactions
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                if (transaction.getMeta('uiEvent') === 'cut' || // We skip remote transactions as we don't want to affect transactions created
                // by other users
                Boolean(transaction.getMeta('isRemote'))) return;
                // Ignore local ID updates for certain transactions
                // this is purposely not a public API as we should not use
                // this except in some circumstances (ie. streaming)
                if (transaction.getMeta('ignoreLocalIdUpdate')) return;
                transaction.steps.forEach((step)=>{
                    if (!(0, $kTbzR.stepHasSlice)(step)) return;
                    step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
                        // Scan the changed range to find all nodes
                        tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node, pos)=>{
                            if (ignoredNodeTypes.includes(node.type.name) || !node.type.spec.attrs?.localId) return true;
                            modified = true;
                            if ((0, $dh538.fg)('platform_editor_use_localid_dedupe')) {
                                // Always add to addedNodes for duplicate prevention
                                addedNodes.add(node);
                                addedNodePos.set(node, pos);
                            } else if (!node?.attrs.localId) {
                                if ((0, $dh538.fg)('platform_editor_localid_improvements')) nodesToUpdate.set(pos, $afcb24c50c80cbe1$var$generateUUID(api, node, pos));
                                else // Legacy behavior - individual steps
                                $afcb24c50c80cbe1$export$9c1f7572297aed68(api, pos, tr, node);
                            }
                            return true;
                        });
                    });
                });
            });
            if (addedNodes.size > 0 && (0, $dh538.fg)('platform_editor_use_localid_dedupe')) {
                newState.doc.descendants((node)=>{
                    if (addedNodes.has(node)) return true;
                    localIds.add(node.attrs.localId);
                    return true;
                });
                // Also ensure the added have no duplicates
                const seenIds = new Set();
                for (const node of addedNodes){
                    if (!node.attrs.localId || localIds.has(node.attrs.localId) || seenIds.has(node.attrs.localId) && (0, $dh538.fg)('platform_editor_ai_local_id_short')) {
                        const pos = addedNodePos.get(node);
                        if (pos !== undefined) {
                            if ((0, $dh538.fg)('platform_editor_localid_improvements')) {
                                const newId = $afcb24c50c80cbe1$var$generateUUID(api, node, pos);
                                nodesToUpdate.set(pos, newId);
                                seenIds.add(newId);
                            } else $afcb24c50c80cbe1$export$9c1f7572297aed68(api, pos, tr, node);
                            modified = true;
                        }
                    }
                    if (node.attrs.localId) seenIds.add(node.attrs.localId);
                }
            }
            // Apply local ID updates based on the improvements feature flag:
            // - When enabled: Batch all updates into a single BatchAttrsStep
            // - When disabled: Individual steps were already applied above during node processing
            if (modified && nodesToUpdate.size > 0 && (0, $dh538.fg)('platform_editor_localid_improvements')) $afcb24c50c80cbe1$export$6722232dcd7a6b1b(nodesToUpdate, tr);
            return modified ? tr : undefined;
        }
    });
};
const $afcb24c50c80cbe1$export$9c1f7572297aed68 = (api, pos, tr, node)=>{
    const targetNode = node || tr.doc.nodeAt(pos);
    tr.setNodeAttribute(pos, 'localId', $afcb24c50c80cbe1$var$generateUUID(api, targetNode, pos));
    tr.setMeta('addToHistory', false);
};
const $afcb24c50c80cbe1$export$6722232dcd7a6b1b = (nodesToUpdate, tr)=>{
    const batchData = Array.from(nodesToUpdate.entries()).map(([pos, localId])=>{
        const node = tr.doc.nodeAt(pos);
        if (!node) throw new Error(`Node does not exist at position ${pos}`);
        return {
            position: pos,
            attrs: {
                localId: localId
            },
            nodeType: node.type.name
        };
    });
    tr.step(new (0, $7Mtx3.BatchAttrsStep)(batchData));
    tr.setMeta('addToHistory', false);
};
module.exports["createPlugin"] = $afcb24c50c80cbe1$export$ae829ec7b2625219;

});

parcelRegister("fi2El", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2eb928472226c820013eae86ad81ede4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b21a97a402c82df9$var$_react = $b21a97a402c82df9$var$_interopRequireDefault((parcelRequire("42omo")));

var $b21a97a402c82df9$var$_baseNew = $b21a97a402c82df9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b21a97a402c82df9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "History".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for history and recent
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b21a97a402c82df9$var$HistoryIcon = (props)=>/*#__PURE__*/ $b21a97a402c82df9$var$_react.default.createElement($b21a97a402c82df9$var$_baseNew.default, Object.assign({
        name: "HistoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.708V1H.5v4.285h4.286v-1.5H3.05a6.5 6.5 0 1 1-1.517 3.541L.042 7.174A8 8 0 1 0 2 2.708M8.75 8.14V3.75h-1.5v5.11l2.781 2.226.938-1.172z" clip-rule="evenodd"/>`
    }, props));
$b21a97a402c82df9$var$HistoryIcon.displayName = 'HistoryIcon';
var $b21a97a402c82df9$var$_default = module.exports.default = $b21a97a402c82df9$var$HistoryIcon;

});

parcelRegister("6eZqW", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8m4tT = parcelRequire("8m4tT");


var $8nxxM = parcelRequire("8nxxM");


var $2htg1 = parcelRequire("2htg1");

/**
 * If the first node is a paragraph we need to wrap it in a paragraph node for the markdown conversion to work properly
 */ function $fb0b992a34319cb0$var$createTextWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $8m4tT.findParentNodeClosestToPos)($from, (node)=>{
        return node.type.name === 'paragraph' || node.type.name === 'heading';
    })?.node;
    if (parent) return schema.nodes.doc.createChecked(null, schema.nodes[parent.type.name].createChecked(parent.attrs, fragment));
    else // If the node is a paragraph we need the parent to be a doc for the conversion to work correctly
    return schema.nodes.doc.createChecked(null, schema.nodes.paragraph.createChecked(null, fragment));
}
/**
 * This finds the closest list item parent to the current selection
 * Once found it will create a new list with the current fragment as its children
 */ function $fb0b992a34319cb0$var$createListItemWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $8m4tT.findParentNodeClosestToPos)($from, (node)=>node.type.name === 'bulletList' || node.type.name === 'orderedList')?.node;
    if (parent) return schema.nodes[parent.type.name].createChecked(parent.attrs, fragment);
    return fragment;
}
/**
 * If the first node is a task item we need to wrap it in a task list node for the markdown conversion to work properly
 */ function $fb0b992a34319cb0$var$createTaskItemWrapper(schema, fragment) {
    return schema.nodes.doc.createChecked(null, schema.nodes.taskList.createChecked(null, fragment));
}
function $fb0b992a34319cb0$var$createLayoutColumnWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const parentSection = (0, $8m4tT.findParentNodeOfType)(schema.nodes.layoutSection)(editorView.state.selection);
    if (parentSection) // Needs to be a doc for the serializer to work as it
    // loops through the fragments children to render
    return schema.nodes.doc.createChecked(null, schema.nodes.layoutSection.createChecked(parentSection.node.attrs, fragment));
    return fragment;
}
/**
 * This function handles partial selections and it will fix any incomplete fragments that won't be converted properly
 * If you do a partial selection, it will not select the parent node of certain nodes text, listItems etc so once it hits the serializer
 * the serializer will just fallback to plain text and not convert the node properly.
 *
 * This function checks the first child of the current selection, if its a node that needs a parent it will find the closest parent
 * and create a new fragment that will be converted properly by the serializer
 */ function $fb0b992a34319cb0$var$checkFragment(editorView, schema, fragment) {
    switch(fragment?.firstChild?.type?.name){
        case 'text':
            return $fb0b992a34319cb0$var$createTextWrapper(editorView, fragment);
        case 'listItem':
            return $fb0b992a34319cb0$var$createListItemWrapper(editorView, fragment);
        case 'taskItem':
            return $fb0b992a34319cb0$var$createTaskItemWrapper(schema, fragment);
        case 'layoutColumn':
            return $fb0b992a34319cb0$var$createLayoutColumnWrapper(editorView, fragment);
        default:
            return fragment;
    }
}
function $fb0b992a34319cb0$export$cc6cac500a4da966({ editorView: editorView, fragment: fragment, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    fragment = $fb0b992a34319cb0$var$checkFragment(editorView, editorView.state.schema, fragment);
    return $fb0b992a34319cb0$export$3d24004275aefeab({
        node: fragment,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
}
function $fb0b992a34319cb0$export$3d24004275aefeab({ node: node, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    const markdownSerializerState = new (0, $2htg1.MarkdownSerializerState)(featureToggles, mentionMap, idMap);
    markdownSerializerState.renderContent(node);
    const pmStats = new (0, $8nxxM.ProseMirrorContentStatistics)(node);
    const contentStatistics = pmStats.collectStatistics();
    const markdown = markdownSerializerState.out === '\u200c' ? '' : markdownSerializerState.out;
    return {
        markdown: markdown,
        fallbackState: markdownSerializerState.fallbackState,
        nonErrorFallbackState: markdownSerializerState.nonErrorFallbackState,
        idMap: markdownSerializerState.idMap,
        contentStatistics: contentStatistics
    };
}
module.exports["convertProsemirrorToMarkdown"] = $fb0b992a34319cb0$export$cc6cac500a4da966;
module.exports["convertProsemirrorNodeToMarkdown"] = $fb0b992a34319cb0$export$3d24004275aefeab;

});

parcelRegister("8nxxM", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

class $13b081699855d8a3$export$acf14785d7d5b1be {
    /**
   * Calculate statistics for the ProseMirror content such as node counts, mark counts and total character count.
   */ collectStatistics() {
        const { nodeCounts: nodeCounts, markCounts: markCounts, linksCount: linksCount, mentionsCount: mentionsCount } = this.countNodesAndMarks();
        const { totalCharacterCount: totalCharacterCount } = this.calculateCharacterCounts();
        return {
            nodeCounts: nodeCounts,
            markCounts: markCounts,
            linksCount: linksCount,
            mentionsCount: mentionsCount,
            totalCharacterCount: totalCharacterCount,
            contextSelectionScope: undefined
        };
    }
    countNodesAndMarks() {
        const nodeCounts = new Map();
        const markCounts = new Map();
        let linksCount = 0;
        let mentionsCount = 0;
        this.content.descendants((node)=>{
            nodeCounts.set(node.type.name, (nodeCounts.get(node.type.name) || 0) + 1);
            const marks = node.marks;
            marks.forEach((mark)=>{
                markCounts.set(mark.type.name, (markCounts.get(mark.type.name) || 0) + 1);
            });
            const { nodes: { inlineCard: inlineCard, mention: mention }, marks: { link: link } } = node.type.schema;
            if (node.type === mention) mentionsCount++;
            if (node.type === inlineCard && node.attrs.url) linksCount++;
            if (marks.find((mark)=>mark.type === link)) linksCount++;
        });
        return {
            nodeCounts: Object.fromEntries(nodeCounts),
            markCounts: Object.fromEntries(markCounts),
            linksCount: linksCount,
            mentionsCount: mentionsCount
        };
    }
    calculateCharacterCounts() {
        let allTextContent = '';
        if (this.content instanceof (0, $5SAOw.Node)) allTextContent = this.content.textContent;
        else this.content.forEach((child)=>{
            allTextContent += child.textContent;
        });
        return {
            totalCharacterCount: allTextContent.length
        };
    }
    constructor(content){
        this.content = void 0;
        this.content = content;
    }
}
module.exports["ProseMirrorContentStatistics"] = $13b081699855d8a3$export$acf14785d7d5b1be;

});

parcelRegister("2htg1", function(module, exports) {

var $42JDa = parcelRequire("42JDa");


var $5SAOw = parcelRequire("5SAOw");


var $2xv4m = parcelRequire("2xv4m");


var $bd943 = parcelRequire("bd943");


var $50zV1 = parcelRequire("50zV1");


var $8q1Q5 = parcelRequire("8q1Q5");

const $e985dce6263f3bba$export$1c401dbe379e8c65 = (()=>{
    function getMaxLength(text) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const matches = text.match(/`+/g) || [];
        return matches.reduce((prev, val)=>val.length > prev.length ? val : prev, '').length;
    }
    return function(text, minLength = 1) {
        const length = Math.max(minLength, getMaxLength(text) + 1);
        return (0, $8q1Q5.stringRepeat)('`', length);
    };
})();
class $e985dce6263f3bba$export$61055fa707e69319 extends (0, $42JDa.MarkdownSerializerState) {
    /**
   *
   * @param state: MarkdownSerializerState
   * @param targetType: string
   * @param targetAttributes: Record<string, unknown>
   * @returns id of the state if the state is found in the idMap, otherwise returns null
   */ findStateIdMap(state, targetType, targetAttributes) {
        // eslint-disable-next-line guard-for-in
        for(const key in state.idMap){
            const { type: type, attributes: attributes } = state.idMap[key];
            // Check type first for early exit
            if (type !== targetType) continue;
            // Check if attributes match
            let attributesMatch = true;
            for(const attrKey in targetAttributes)// localId is a special attribute that is used to identify the node in the markdown and should be ignored on match
            if (attrKey !== 'localId' && targetAttributes[attrKey] !== attributes[attrKey]) {
                attributesMatch = false;
                break; // No need to check other attributes
            }
            if (attributesMatch) return key;
        }
        return null;
    }
    /**
   *
   * @param state: MarkdownSerializerState
   * @param type: string
   * @param attributes: Record<string, unknown>
   * @returns `id-[id]idMap` if the id is not found in the state
   */ getIdBasedOnIdMap(state, type, attributes) {
        const id = state.findStateIdMap(state, type, attributes);
        if (id) return id;
        return `id-${state.idCounter++}`;
    }
    updateFallbackState(error, child) {
        if (error instanceof Error) {
            const childTypeName = child.type.name;
            const errorMessage = error.message;
            const childFallbackState = this.fallbackState?.[childTypeName];
            Object.assign(this.fallbackState, {
                [childTypeName]: {
                    ...childFallbackState,
                    [errorMessage]: (childFallbackState?.[errorMessage] || 0) + 1
                }
            });
        } else throw error;
    }
    updateNonErrorFallbackState(node) {
        Object.assign(this.nonErrorFallbackState, {
            [node.type.name]: (this.nonErrorFallbackState[node.type.name] || 0) + 1
        });
    }
    /**
   * Defines the internal atBlank method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L241
   */ atBlank() {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return /(^|\n)$/.test(this.out);
    }
    /**
   * Defines the internal flushClose method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L202
   */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += '\n';
            if (size > 1) {
                let delimMin = this.delim;
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + '\n';
            }
            this.closed = null;
        }
    }
    /**
   * This method overide adds support for "options"
   * options is an object that can be used to pass additional information to the node serializer
   *
   * This is useful when a grandparent node has information that needs to be passed to a grandchild node
   *
   * For example, a table node has information about whether or not the table has a header row
   * This information needs to be passed to the tableRow and tableCell node serializers so that it can render the correct markdown
   * @see MarkdownSerializerState.render()
   */ render(node, parent, index, options) {
        if (!this.nodes[node.type.name]) throw new Error(`Token type \`${node.type.name}\` not supported by Markdown renderer`);
        if (options?.skipFallback) this.nodes[node.type.name].serialize({
            state: this,
            node: node,
            parent: parent,
            index: index,
            options: options
        });
        else try {
            this.nodes[node.type.name].serialize({
                state: this,
                node: node,
                parent: parent,
                index: index,
                options: options
            });
        } catch (error) {
            this.updateFallbackState(error, node);
            return this.nodes.fallback.serialize({
                state: this,
                node: node,
                parent: parent,
                index: index
            });
        }
    }
    renderContent(parent) {
        parent.forEach((child, _offset, index)=>{
            if (// If child is an empty Textblock we need to insert a zwnj-character in order to preserve that line in markdown
            child.isTextblock && !child.textContent && // If child is a Codeblock we need to handle this separately as we want to preserve empty code blocks
            !(child.type.name === 'codeBlock') && !(child.content && child.content.size > 0)) return this.nodes.empty_line.serialize({
                state: this,
                node: child,
                parent: parent,
                index: index
            });
            try {
                return this.render(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
                return this.nodes.fallback.serialize({
                    state: this,
                    node: child,
                    parent: parent,
                    index: index
                });
            }
        });
    }
    /**
   * This method override will properly escape backticks in text nodes with "code" mark enabled.
   * Bitbucket uses python-markdown which does not honor escaped backtick escape sequences \`
   * inside a backtick fence.
   *
   * @see MarkdownSerializerState.renderInline()
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderInline(parent, options) {
        const active = [];
        let trailing = '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const progress = (node, _, index)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let marks = node ? node.marks.filter((mark)=>this.marks[mark.type.name]) : [];
            let leading = trailing;
            trailing = '';
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const info = this.marks[mark.type.name];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return info && info.expelEnclosingWhitespace;
            })) {
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp, @typescript-eslint/no-non-null-assertion
                const [, lead, inner, trail] = /^(\s*)(.*?)(\s*)$/m.exec(node.text);
                leading += lead;
                trailing = trail;
                if (lead || trail) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    node = inner ? node.withText(inner) : null;
                    if (!node) marks = active;
                }
            }
            const code = marks.length && marks[marks.length - 1].type.name === 'code' && marks[marks.length - 1];
            const len = marks.length - (code ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            // eslint-disable-next-line no-labels
            outer: for(let i = 0; i < len; i++){
                const mark = marks[i];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (!this.marks[mark.type.name].mixable) break;
                for(let j = 0; j < active.length; j++){
                    const other = active[j];
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (!this.marks[other.type.name].mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            while(active.length < len){
                const add = marks[active.length];
                active.push(add);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.text(this.markString(add, true, parent, index), false);
            }
            if (node) {
                if (!code || !node.isText) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.render(node, parent, index);
                else if (node.text) {
                    // Generate valid monospace, fenced with series of backticks longer that backtick series inside it.
                    let text = node.text;
                    const backticks = $e985dce6263f3bba$export$1c401dbe379e8c65(node.text, 1);
                    // Make sure there is a space between fences, otherwise python-markdown renderer will get confused
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    if (text.match(/^`/)) text = ' ' + text;
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    if (text.match(/`$/)) text += ' ';
                    this.text(backticks + text + backticks, false);
                }
            }
        };
        parent.forEach((child, _offset, index)=>{
            if (options?.skipFallback) progress(child, parent, index);
            else try {
                progress(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
            }
        });
        progress(null);
    }
    addBlockMarks(state, node, renderFunction) {
        const closingTags = [];
        // This is temporary, only adding the marks that we support, once we get full support this will be removed
        const markFilters = [
            'alignment',
            'breakout',
            'border'
        ];
        const marks = node.marks.filter((mark)=>markFilters.includes(mark.type.name));
        if (marks.length === 0) {
            renderFunction();
            return;
        }
        marks.forEach((mark)=>{
            const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, mark.type.name, mark.attrs) : `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: mark.type.name,
                attributes: mark.attrs
            };
            state.write(`<custom data-type="${mark.type.name}_open" data-id="${id}" />\n\n`);
            closingTags.unshift(`<custom data-type="${mark.type.name}_close" />\n\n`);
        });
        renderFunction();
        state.write(closingTags.join(''));
    }
    constructor(featureToggles, mentionMap, idMap){
        // @ts-ignore -next-line
        super($e985dce6263f3bba$export$695720b7e7a61533, $e985dce6263f3bba$export$3a8025f2f3e0c64, {});
        // ignoring as generated types for node serializer is inaccurate
        // parent and index in node serializers should be optional
        // Typing this as a string -- to override the PMMarkdownSerializerState type of any
        // In the confluence build -- this results in the out property being set to undefined in the constructor
        // whereas in the dev server this is stripped when the code is transpiled.
        // When it is used in transpilation -- "undefined" is added to the start of the generated text
        // out: string;
        this.idMap = {};
        this.idCounter = 0;
        this.nodes = void 0;
        this.marks = void 0;
        this.featureToggles = {};
        this.mentionMap = {};
        /**
     * Defines the internal variables used in the markdown serializer
     * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L172
     */ this.delim = '';
        this.out = '';
        this.closed = null;
        /**
     * This is used to track the number of times a node has failed to render
     * This is useful for debugging purposes
     * - the key is the node type name
     * - the value is an object with
     *   - the error message as the key
     *   - and the number of times it has failed to render with that message as the value.
     */ this.fallbackState = {};
        /**
     * This is used to track the number of times a node has rendered
     * but has not completely converted to markdown
     * For example: Tables are supported in markdown, however we currently do not have full support
     * So we fallback to the simplest version of the node that our serializer can support
     */ this.nonErrorFallbackState = {};
        this.context = {
            insideTable: false
        };
        this.nodes = $e985dce6263f3bba$export$695720b7e7a61533;
        this.marks = $e985dce6263f3bba$export$3a8025f2f3e0c64;
        this.featureToggles = featureToggles || {};
        this.mentionMap = mentionMap || {};
        this.idMap = idMap || {};
        this.idCounter = Object.keys(this.idMap).length;
    }
}
const $e985dce6263f3bba$var$editorNodes = {
    blockquote: {
        serialize ({ state: state, node: node }) {
            state.wrapBlock('> ', null, node, ()=>state.renderContent(node));
        },
        support: 'full'
    },
    codeBlock: {
        serialize ({ state: state, node: node }) {
            const backticks = $e985dce6263f3bba$export$1c401dbe379e8c65(node.textContent, 3);
            state.write(backticks + (node.attrs.language || '') + '\n');
            state.text(node.textContent ? node.textContent : '\u200c', false);
            state.ensureNewLine();
            state.write(backticks);
            state.closeBlock(node);
        },
        support: 'full'
    },
    heading: {
        serialize ({ state: state, node: node }) {
            state.write(state.repeat('#', node.attrs.level) + ' ');
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    rule: {
        serialize ({ state: state, node: node }) {
            state.write(node.attrs.markup || '---');
            state.closeBlock(node);
        },
        support: 'full'
    },
    bulletList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    orderedList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    listItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const order = (0, $50zV1.getOrderFromMaybeOrderedListNode)(parent);
            const delimiter = parent.type.name === 'bulletList' ? '* ' : `${order + index}. `;
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                // if at second child or more of list item, add a newline
                if (i > 0) state.write('\n');
                // if at first child of list item, add delimiter (e.g "1.").
                // if at second child or more of list item, only add spacing (not delimiter)
                if (i === 0) state.wrapBlock('  ', delimiter, node, ()=>state.render(child, parent, i));
                else state.wrapBlock('    ', null, node, ()=>state.render(child, parent, i));
                if (child.type.name === 'paragraph' && i > 0) state.write('\n');
                state.flushClose(1);
            }
            // if we're at the final list item, add a final closing newline
            if (index === parent.childCount - 1) state.write('\n');
        },
        support: 'full'
    },
    taskList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
                state.write('\n');
            }
            state.write('\n');
        },
        support: 'full'
    },
    taskItem: {
        serialize ({ state: state, node: node }) {
            const taskItemState = node.attrs.state;
            state.write(taskItemState === 'TODO' ? '- [ ] ' : '- [x] ');
            state.renderInline(node);
        },
        support: 'full'
    },
    paragraph: {
        serialize ({ state: state, node: node }) {
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    mediaGroup: {
        serialize ({ state: state, node: node }) {
            state.updateNonErrorFallbackState(node);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'fallback'
    },
    mediaInline: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaInline',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="mediaInline" data-id="${id}"></custom>`);
            });
        },
        support: 'preview'
    },
    mediaSingle: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mediaSingle', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaSingle',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="media_single_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="media_single_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                /**
         * Currently, if the parent is a node we assume that mediaSingle is nested (e.g. inside a
         * table or list). In these cases we only output \n as there is often already new lines added
         * by the parent node.
         * Otherwise, if mediaSingle is not nested we add an extra new line.
         */ if (parent instanceof (0, $5SAOw.Node)) state.write('\n');
                else state.write('\n\n');
            }
        },
        support: 'preview'
    },
    caption: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'caption', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'caption',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="caption_open" data-id="${id}" />\n\n`);
                try {
                    state.renderInline(node, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback.serialize({
                        state: state,
                        node: node,
                        parent: parent,
                        index: index
                    });
                }
                // captions do not contain paragraphs, so we need to add a newline after the content
                state.write(`\n\n<custom data-type="caption_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                state.write(node.textContent);
            }
        },
        support: 'preview'
    },
    media: {
        serialize ({ state: state, node: node }) {
            // Creating this fake URl allows us to pass the media attributes to the markdown without using markdown plus
            // Which allows image retention when using rovo since it doesn't support markdown plus
            const baseUrl = `blob:${(0, $bd943.MEDIA_BASE_URL_STAGING)}/?`;
            const queryString = Object.entries(node.attrs).map(([key, value])=>key !== 'alt' ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : ``).join('&');
            const fakeUrl = `${baseUrl}${queryString}`;
            state.write(`![](${fakeUrl})${state.featureToggles.markdownPlusAddComplexNodes ? '\n\n' : ''}`);
        },
        support: 'full'
    },
    image: {
        serialize ({ state: state, node: node }) {
            // Note: the 'title' is not escaped in this flavor of markdown.
            state.write('![' + (0, $8q1Q5.escapeMarkdown)(node.attrs.alt) + '](' + node.attrs.src + (node.attrs.title ? ` '${(0, $8q1Q5.escapeMarkdown)(node.attrs.title)}'` : '') + ')');
        },
        support: 'full'
    },
    hardBreak: {
        serialize ({ state: state }) {
            state.write('  \n');
        },
        support: 'full'
    },
    text: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const previousNode = index === 0 ? null : parent.child(index - 1);
            let text = node.textContent;
            // BB converts 4 spaces at the beginning of the line to code block
            // that's why we escape 4 spaces with zero-width-non-joiner
            const fourSpaces = '    ';
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            if (!previousNode && /^\s{4}/.test(node.textContent)) text = node.textContent.replace(fourSpaces, '\u200c' + fourSpaces);
            const lines = text.split('\n');
            for(let i = 0; i < lines.length; i++){
                const startOfLine = state.atBlank() || !!state.closed;
                state.write();
                state.out += (0, $8q1Q5.escapeMarkdown)(lines[i], startOfLine, state.context.insideTable);
                if (i !== lines.length - 1) {
                    if (lines[i] && lines[i].length && lines[i + 1] && lines[i + 1].length) state.out += '  ';
                    state.out += '\n';
                }
            }
            // This is so we can determine which marks are most used that aren't being converted to markdown
            node.marks.forEach((mark)=>{
                // @ts-expect-error
                if (!$e985dce6263f3bba$export$3a8025f2f3e0c64[mark.type.name]) state.updateNonErrorFallbackState(mark);
            });
        },
        support: 'full'
    },
    empty_line: {
        serialize ({ state: state, node: node }) {
            state.write('\u200c'); // zero-width-non-joiner
            state.closeBlock(node);
        },
        support: 'full'
    },
    placeholder: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'placeholder', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'placeholder',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="placeholder" data-id="${id}">${node.attrs.text}</custom>`);
            }
        },
        support: 'custom'
    },
    mention: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const isLastNode = parent.childCount === index + 1;
            let delimiter = '';
            if (!isLastNode) {
                const nextNode = parent.child(index + 1);
                const nextNodeHasLeadingSpace = nextNode.textContent.indexOf(' ') === 0;
                delimiter = nextNodeHasLeadingSpace ? '' : ' ';
            }
            // Get the name from the map
            const name = state.mentionMap[node.attrs.id] || '';
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mention', {
                    ...node.attrs,
                    text: `@${name}`
                }) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mention',
                    // Update the attributes to include resolved name
                    attributes: {
                        ...node.attrs,
                        text: `@${name}`
                    }
                };
                if (state.featureToggles.markdownPlusAttributeTest) {
                    // @ts-expect-error
                    node.attrs.text = `@${name}`;
                    state.write(`<custom data-type="mention" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">@${name}</custom>`);
                } else state.write(`<custom data-type="mention" data-id="${id}">@${name}</custom>`);
            } else state.write(`${name}${delimiter}`);
        },
        support: 'custom'
    },
    date: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'date', node.attrs) : `id-${state.idCounter++}`;
                // Ensure localId is explicitly set to null if not present
                const attributes = {
                    ...node.attrs,
                    localId: node.attrs.localId ?? null
                };
                state.idMap[id] = {
                    type: 'date',
                    attributes: attributes
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="date" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
                else state.write(`<custom data-type="date" data-id="${id}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
            } else state.write(new Intl.DateTimeFormat().format(Number(node.attrs.timestamp)));
        },
        support: 'custom'
    },
    emoji: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'emoji', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'emoji',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="emoji" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.shortName}</custom>`);
                else state.write(`<custom data-type="emoji" data-id="${id}">${node.attrs.shortName}</custom>`);
            } else state.write(node.attrs.shortName);
        },
        support: 'custom'
    },
    inlineCard: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineCard', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineCard',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="smartlink" data-id="${id}">${node.attrs.url}</custom>`);
            } else state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'custom'
    },
    status: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'status', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'status',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="status" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.text}</custom>`);
                else state.write(`<custom data-type="status" data-id="${id}">${node.attrs.text}</custom>`);
            } else // this will trigger the fallback conversion (text)
            throw new Error('Token type `status` not supported by Markdown renderer');
        },
        support: 'custom'
    },
    layoutSection: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutSection', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutSection',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutSection_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutSection_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    layoutColumn: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutColumn', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutColumn',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutColumn_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutColumn_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    expand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'expand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'expand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="expand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="expand_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    nestedExpand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'nestedExpand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'nestedExpand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="nestedExpand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="nestedExpand_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    panel: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusPanels) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'panel', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'panel',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="panel_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="panel_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'custom'
    },
    blockCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    embedCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    decisionList: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionList', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionList',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionList_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`<custom data-type="decisionList_close" />\n\n`);
            } else {
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`\n\n`);
            }
        },
        support: 'custom'
    },
    decisionItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionItem', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionItem',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionItem_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`\n\n<custom data-type="decisionItem_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    extension: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'extension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'extension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="extension" data-id="${id}" />\n\n`);
            }
        },
        support: 'custom'
    },
    inlineExtension: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="inlineExtension" data-id="${id}"></custom>`);
            }
        },
        support: 'custom'
    },
    bodiedExtension: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'bodiedExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'bodiedExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="bodiedExtension_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="bodiedExtension_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    fallback: {
        serialize ({ state: state, node: node }) {
            // If PMNode is an unhandled block node, we need to add a newline
            // after the content to prevent the next line from being rendered as
            // part of the block node.
            if (node.isBlock) state.write(`${node.textContent || node.attrs.text || ''}\n\n`);
            else state.write(node.textContent || node.attrs.text || '');
        },
        support: 'fallback'
    }
};
const $e985dce6263f3bba$export$695720b7e7a61533 = {
    ...$e985dce6263f3bba$var$editorNodes,
    ...(0, $2xv4m.default)
};
const $e985dce6263f3bba$export$3a8025f2f3e0c64 = {
    em: {
        open: '_',
        close: '_',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: '**',
        close: '**',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strike: {
        open: '~~',
        close: '~~',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open: '[',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        close (_state, mark) {
            return '](' + mark.attrs['href'] + ')';
        }
    },
    code: {
        open: '`',
        close: '`'
    }
};
module.exports["MarkdownSerializerState"] = $e985dce6263f3bba$export$61055fa707e69319;
module.exports["nodes"] = $e985dce6263f3bba$export$695720b7e7a61533;

});

parcelRegister("2xv4m", function(module, exports) {

var $2VvL9 = parcelRequire("2VvL9");

const $deb7030063275628$var$isHeaderRow = (row)=>row.child(0).type.name === 'tableHeader';
const $deb7030063275628$var$isFirstRow = (row, parent)=>parent.content.child(0) === row;
const $deb7030063275628$var$isHeaderRowPresent = (table)=>{
    let headerRowPresent = false;
    table.content.forEach((row)=>{
        if ($deb7030063275628$var$isHeaderRow(row)) headerRowPresent = true;
    });
    return headerRowPresent;
};
const $deb7030063275628$var$renderNode = (state, node, index)=>{
    if (index > 0) state.write(' ');
    node.content.forEach((child, i)=>{
        if (child.isTextblock || child.type.name === 'mediaSingle') {
            if (i > 0) state.write(' ');
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = true;
            state.renderInline(child);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = false;
        } else $deb7030063275628$var$renderNode(state, child, i);
    });
};
const $deb7030063275628$var$renderInlineContent = ({ state: state, node: node })=>{
    state.write('| ');
    $deb7030063275628$var$renderNode(state, node, 0);
    state.write(' ');
};
const $deb7030063275628$var$tableNodes = {
    table: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="table_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>state.render(child, node, i));
                state.write(`<custom data-type="table_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles, {
                    layout: node.attrs.layout,
                    localId: node.attrs.localId,
                    width: 760
                })) state.updateNonErrorFallbackState(node);
                const headerRowPresent = $deb7030063275628$var$isHeaderRowPresent(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            headerRowPresent: headerRowPresent,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.closeBlock(node);
            }
        },
        support: 'partial'
    },
    tableRow: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="tr_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="tr_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            ...options,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write('|');
                state.ensureNewLine();
                if ($deb7030063275628$var$isHeaderRow(node) || $deb7030063275628$var$isFirstRow(node, parent)) {
                    for(let i = 0; i < node.childCount; i++)state.write('| --- ');
                    state.write('|');
                    state.ensureNewLine();
                }
            }
        },
        support: 'partial'
    },
    tableHeader: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="th_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="th_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $deb7030063275628$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    },
    tableCell: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="td_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="td_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $deb7030063275628$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    }
};
var $deb7030063275628$export$2e2bcd8739ae039 = $deb7030063275628$var$tableNodes;
module.exports["default"] = $deb7030063275628$export$2e2bcd8739ae039;

});

parcelRegister("2VvL9", function(module, exports) {
const $92afea9a8f6a2cee$export$5be26e657c035da4 = (node, featureToggles, overrideDefaults = {})=>{
    if (!featureToggles.allowAttributesMatchDefault) return true;
    // @ts-expect-error - node.type.attrs does not exist in nodeType type, but it does exist.
    const nodeTypeAttrs = node.type.attrs;
    if (!nodeTypeAttrs || Object.keys(nodeTypeAttrs).length === 0 && Object.keys(node.attrs).length === 0) return true;
    const defaultAttrs = {};
    Object.keys(nodeTypeAttrs).forEach((key)=>{
        defaultAttrs[key] = nodeTypeAttrs[key].default;
    });
    // The actual node defaults don't match the node defaults when interacting with a page
    // So we override for a correct comparison
    Object.keys(overrideDefaults).forEach((key)=>{
        defaultAttrs[key] = overrideDefaults[key];
    });
    // Compare the node attributes to the default attributes
    for(const key in node.attrs){
        if (node.attrs[key] !== defaultAttrs[key]) return false;
    }
    return true;
};
module.exports["attributesMatchDefault"] = $92afea9a8f6a2cee$export$5be26e657c035da4;

});

parcelRegister("bd943", function(module, exports) {
const $3b4ff3e4ad90548c$export$53fd140c96bc558 = 'https://media.staging.atl-paas.net';
module.exports["MEDIA_BASE_URL_STAGING"] = $3b4ff3e4ad90548c$export$53fd140c96bc558;

});

parcelRegister("50zV1", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

const $6ff1f24202635c31$export$8ef94ae42a3729bd = 1;
const $6ff1f24202635c31$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $6ff1f24202635c31$export$4ea3c6bbdf8f7944 = (maybeOrderedListNode)=>{
    if (!(maybeOrderedListNode instanceof (0, $5SAOw.Node))) return $6ff1f24202635c31$export$8ef94ae42a3729bd;
    const order = maybeOrderedListNode?.attrs?.order;
    return $6ff1f24202635c31$export$d445360e2a3c026b(order) ?? $6ff1f24202635c31$export$8ef94ae42a3729bd;
};
module.exports["getOrderFromMaybeOrderedListNode"] = $6ff1f24202635c31$export$4ea3c6bbdf8f7944;

});

parcelRegister("8q1Q5", function(module, exports) {
/**
 * A replacement for `String.repeat` until it becomes widely available.
 */ function $74c7a8487430b8e3$export$345d822805ab3239(text, length) {
    let result = '';
    for(let x = 0; x < length; x++)result += text;
    return result;
}
function $74c7a8487430b8e3$export$560888d6fe0cfe97(str, startOfLine, insideTable) {
    let strToEscape = str || '';
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    strToEscape = strToEscape.replace(/[`*\\~\[\]_]/g, (m, i)=>// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        m === '_' && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : '\\' + m);
    if (startOfLine) strToEscape = strToEscape// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\+[ ]|[\-*>])/, '\\$&')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\s*\d+)\.\s/, '$1\\. ');
    if (insideTable) // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    strToEscape = strToEscape.replace(/[|]/g, '\\$&');
    return strToEscape;
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $74c7a8487430b8e3$var$SPECIAL_CHARACTERS = /\u200c|↵/g;
function $74c7a8487430b8e3$var$removeSpecialCharacters(node) {
    if (node.nodeType === 3 && node.textContent) node.textContent = node.textContent.replace($74c7a8487430b8e3$var$SPECIAL_CHARACTERS, '');
    Array.from(node.childNodes).forEach((child)=>$74c7a8487430b8e3$var$removeSpecialCharacters(child));
}
function $74c7a8487430b8e3$export$9c95763b5a419f4c(html, options) {
    const el = document.createElement('div');
    el.innerHTML = html;
    // Remove zero-width-non-joiner
    Array.from(el.querySelectorAll('p')).forEach((p)=>{
        $74c7a8487430b8e3$var$removeSpecialCharacters(p);
    });
    // Convert mention containers, i.e.:
    //   <a href="/abodera/" rel="nofollow" title="@abodera" class="mention mention-me">Artur Bodera</a>
    Array.from(el.querySelectorAll('a.mention, a.ap-mention')).forEach((a)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = a.getAttribute('data-atlassian-id') || '';
        if (atlassianId) // Atlassian ID is wrapped in curlies so that it get serialized as @{aid-id} instead of @aid-id
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        else {
            const title = a.getAttribute('title') || '';
            if (title) {
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const usernameMatch = title.match(/^@(.*?)$/);
                if (usernameMatch) {
                    const username = usernameMatch[1];
                    span.setAttribute('data-mention-id', username);
                }
            }
        }
        const text = a.textContent || '';
        if (text.indexOf('@') === 0) span.textContent = a.textContent;
        else span.textContent = `@${a.textContent}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.insertBefore(span, a);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Convert mention containers, i.e.:
    //   <span class="ap-mention" data-atlassian-id="5c09bf77ec71bd223bbe866f">@Scott Demo</span>
    Array.from(el.querySelectorAll('span.ap-mention')).forEach((s)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = s.getAttribute('data-atlassian-id') || '';
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        const text = s.textContent || '';
        span.textContent = text.indexOf('@') === 0 ? text : `@${text}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.insertBefore(span, s);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.removeChild(s);
    });
    // Parse emojis i.e.
    //     <img src="https://d301sr5gafysq2.cloudfront.net/207268dc597d/emoji/img/diamond_shape_with_a_dot_inside.svg" alt="diamond shape with a dot inside" title="diamond shape with a dot inside" class="emoji">
    Array.from(el.querySelectorAll('img.emoji')).forEach((img)=>{
        const span = document.createElement('span');
        let shortName = img.getAttribute('data-emoji-short-name') || '';
        if (!shortName) {
            // Fallback to parsing Bitbucket's src attributes to find the
            // short name
            const src = img.getAttribute('src');
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            const idMatch = !src ? false : src.match(/([^\/]+)\.[^\/]+$/);
            if (idMatch) shortName = `:${decodeURIComponent(idMatch[1])}:`;
        }
        if (shortName) span.setAttribute('data-emoji-short-name', shortName);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(span, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    if (!options.disableBitbucketLinkStripping) // Convert all automatic links to plain text, because they will be re-created on render by the server
    Array.from(el.querySelectorAll('a'))// Don't convert external links (i.e. not automatic links)
    .filter((a)=>a.getAttribute('data-is-external-link') !== 'true' && a.getAttribute('data-inline-card') === null).forEach((a)=>{
        Array.from(a.childNodes).forEach((child)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            a.parentNode.insertBefore(child, a);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Parse images
    // Not using :pseudo because of IE11 bug:
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16104908/
    Array.from(el.querySelectorAll('img')).filter((img)=>!img.classList.contains('emoji')).forEach((img)=>{
        const { parentNode: parentNode } = img;
        if (!parentNode) return;
        /**
     * Lift image node if parent isn't the root-element
     */ if (parentNode !== el) {
            const isValidPath = validateImageNodeParent(parentNode);
            if (!isValidPath) liftImageNode(parentNode, img);
        }
        /**
     * Replace image with media node
     */ const mediaSingle = document.createElement('div');
        mediaSingle.setAttribute('data-node-type', 'mediaSingle');
        const media = document.createElement('div');
        media.setAttribute('data-node-type', 'media');
        media.setAttribute('data-type', 'external');
        media.setAttribute('data-alt', img.getAttribute('alt') || '');
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        media.setAttribute('data-url', img.getAttribute('src'));
        mediaSingle.appendChild(media);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(mediaSingle, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    function validateImageNodeParent(node) {
        const ALLOWED_PARENTS = [
            'LI',
            'UL',
            'OL',
            'TD',
            'TH',
            'TR',
            'TBODY',
            'THEAD',
            'TABLE'
        ];
        if (node === el) return true;
        if (ALLOWED_PARENTS.indexOf(node.nodeName) === -1) return false;
        if (!node.parentNode) return false;
        return validateImageNodeParent(node.parentNode);
    }
    function liftImageNode(node, img) {
        let foundParent = false;
        let parent = node;
        while(!foundParent){
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            foundParent = validateImageNodeParent(parent.parentNode);
            if (!foundParent) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent = parent.parentNode;
        }
        const cloned = parent.cloneNode();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const target = parent !== el ? parent.parentNode : el;
        while(img.nextSibling)cloned.appendChild(img.nextSibling);
        if (node !== parent) while(node.nextSibling)cloned.appendChild(node.nextSibling);
        if (parent.nextSibling) {
            target.insertBefore(cloned, parent.nextSibling);
            target.insertBefore(img, cloned);
        } else {
            target.appendChild(img);
            target.appendChild(cloned);
        }
        /**
     * If the splitting operation results in
     * the old parent being empty, remove it
     */ if (node.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        node.parentNode.removeChild(node);
        /**
     * Remove cloned element if it's empty.
     */ if (cloned.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cloned.parentNode.removeChild(cloned);
    }
    return el;
}
module.exports["stringRepeat"] = $74c7a8487430b8e3$export$345d822805ab3239;
module.exports["escapeMarkdown"] = $74c7a8487430b8e3$export$560888d6fe0cfe97;

});

parcelRegister("hAuc5", function(module, exports) {

var $2Yzoe = parcelRequire("2Yzoe");


var $csam1 = parcelRequire("csam1");


var $42JDa = parcelRequire("42JDa");


var $5SAOw = parcelRequire("5SAOw");


var $1D8rU = parcelRequire("1D8rU");


var $aLtij = parcelRequire("aLtij");


var $1MDnJ = parcelRequire("1MDnJ");


var $dpgtc = parcelRequire("dpgtc");


var $2mgEK = parcelRequire("2mgEK");


var $fMMkB = parcelRequire("fMMkB");


var $6dzgm = parcelRequire("6dzgm");


var $locel = parcelRequire("locel");


var $ip5oL = parcelRequire("ip5oL");


var $ifgRb = parcelRequire("ifgRb");


var $2XcI5 = parcelRequire("2XcI5");


var $9tykg = parcelRequire("9tykg");


var $d5C9r = parcelRequire("d5C9r");


var $2OwON = parcelRequire("2OwON");

function $ce78ef6bb9d33c7d$var$getFragmentBackingArray(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $ce78ef6bb9d33c7d$var$mapFragment(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($ce78ef6bb9d33c7d$var$mapFragment(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $5SAOw.Fragment)) children.push(...$ce78ef6bb9d33c7d$var$getFragmentBackingArray(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $5SAOw.Fragment).fromArray(children);
}
function $ce78ef6bb9d33c7d$export$b2bf04f78f72b123({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const { markdownPlus: markdownPlus } = featureToggles;
    const tokenizer = new (0, (/*@__PURE__*/$parcel$interopDefault($2Yzoe)))('zero', {
        html: false
    });
    tokenizer.enable([
        // Process html entity - &#123;, &#xAF;, &quot;, ...
        'entity',
        // Process escaped chars and hardbreaks
        'escape',
        'newline'
    ]);
    [
        'nodes',
        'marks'
    ].forEach((key)=>{
        for(const idx in (0, $1D8rU.PM_SCHEMA_TO_MD_MAPPING)[key])if (schema[key][idx]) tokenizer.enable((0, $1D8rU.PM_SCHEMA_TO_MD_MAPPING)[key][idx]);
    });
    const analyticsAttributes = {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {}
    };
    // Remove once markdownPlusAttributeTest is removed
    const markdownPlusAttributeStatus = [];
    if (markdownPlus) {
        tokenizer.use((0, $dpgtc.default), idMap, featureToggles, analyticsAttributes);
        tokenizer.use((0, $fMMkB.default), idMap);
        tokenizer.use((0, $2mgEK.default), idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus);
    }
    tokenizer.use((0, $1MDnJ.default), idMap);
    tokenizer.use((0, $9tykg.default));
    // enable modified version of linkify plugin
    // @see https://product-fabric.atlassian.net/browse/ED-3097
    tokenizer.use((0, $locel.default));
    tokenizer.use((0, $ifgRb.default));
    tokenizer.use((0, $6dzgm.default));
    // Custom Table tokenizer
    if (schema.nodes.table) tokenizer.use((0, $csam1.markdownItTable));
    // Custom Media tokenizer
    if (schema.nodes.media && schema.nodes.mediaSingle) {
        if (featureToggles.markdownPlusUseNextMediaPlugin) tokenizer.use((0, $2XcI5.default));
        else tokenizer.use((0, $ip5oL.markdownItMedia));
        if (markdownPlus && featureToggles.markdownPlusAddComplexNodes) tokenizer.use((0, $aLtij.default));
    }
    // Custom TaskList tokenizer
    if (schema.nodes.taskList) tokenizer.use((0, $d5C9r.default));
    const markdownParser = new (0, $42JDa.MarkdownParser)(schema, tokenizer, (0, $1D8rU.filterMdToPmSchemaMapping)(schema, (0, $1D8rU.getMdToPmMapping)(!!markdownPlus)));
    if (markdown === '') return {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {},
        markdownPlusAttributeStatus: [],
        pmFragment: (0, $5SAOw.Fragment).empty
    };
    // normalize duplicated backticks (needed as a safeguard to avoid rendering malformed escape characters coming from backed)
    // the case with newline characters
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/\\n/g, '\n');
    // the case with custom field attributes (limit only to data- attributes inside custom fields)
    if (markdownPlus) // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/<custom[^>]*?>/g, function(match) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return match.replace(/(data-\w+=)\\\"(.*?)\\\"/g, '$1"$2"');
    });
    const prosemirrorNode = markdownPlus ? markdownParser.parse(markdown) : markdownParser.parse((0, $2OwON.escapeLinks)(markdown));
    if (!prosemirrorNode.content) throw new Error('Markdown conversion did not result in a valid document being created');
    // This logic is duplicated from editor-cores paste transformation.
    // The editor-plugin-ai package is avoiding sharing dependencies with editor-core to support
    // products using it with various versions of editor packages.
    // The duplication is from the following file:
    // packages/editor/editor-core/src/plugins/media/utils/media-single.ts
    // WARNING
    // If the `mapFragment` usage changes -- it means we have a breaking change for products
    // where currently it's expected they are using older versions of editor-common
    const mappedContent = $ce78ef6bb9d33c7d$var$mapFragment(prosemirrorNode.content, (node)=>{
        if (node.type.name === 'media') {
            const replacedAttrs = Object.fromEntries(Object.entries(node.attrs).map(([key, value])=>{
                // If value is the literal string 'null', convert it to JS null
                return [
                    key,
                    value === 'null' ? null : value
                ];
            }));
            return schema.nodes.media.createChecked({
                ...replacedAttrs,
                // Adding this attribute results in the media node being rendered
                // initially using the external url, but then triggering an upload
                // of the external url as an atlassian artifact, and this media
                // will then be replaced to use the atlassian artifact.
                //
                // This is done in the media nodeview by checking the attributes
                // when rendering.
                __external: replacedAttrs.type === 'external',
                __mediaTraceId: null
            }, node.content, node.marks);
        }
        return node;
    });
    return {
        ...analyticsAttributes,
        markdownPlusAttributeStatus: markdownPlusAttributeStatus,
        pmFragment: mappedContent
    };
}
function $ce78ef6bb9d33c7d$export$e661a057c2263d64({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const fragment = $ce78ef6bb9d33c7d$export$b2bf04f78f72b123({
        markdown: markdown,
        schema: schema,
        idMap: idMap,
        featureToggles: {
            markdownPlus: true,
            ...featureToggles
        }
    });
    try {
        const node = schema.nodes.doc.createChecked({}, fragment.pmFragment);
        return node;
    } catch  {
        throw new Error('Markdown conversion did not result in a valid ProseMirror node');
    }
}
module.exports["convertMarkdownToProsemirror"] = $ce78ef6bb9d33c7d$export$b2bf04f78f72b123;
module.exports["backendConvertMarkdownToProsemirrorNode"] = $ce78ef6bb9d33c7d$export$e661a057c2263d64;

});

parcelRegister("1D8rU", function(module, exports) {
function $fe15ff31308e86c4$export$a9d25ff08f358d72(schema, map) {
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $fe15ff31308e86c4$export$b535e2638dcce02 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $fe15ff31308e86c4$export$8f853a1c35ed8bbe = (extendMarkdownSupport)=>({
        blockquote: {
            block: 'blockquote'
        },
        paragraph: {
            block: 'paragraph'
        },
        em: {
            mark: 'em'
        },
        strong: {
            mark: 'strong'
        },
        link: {
            mark: 'link',
            attrs: (tok)=>{
                // @ts-expect-error
                if (tok.pmAttrs) // @ts-expect-error
                return tok.pmAttrs;
                else return {
                    href: tok.attrGet('href'),
                    title: tok.attrGet('title') || null
                };
            }
        },
        hr: {
            node: 'rule'
        },
        heading: {
            block: 'heading',
            attrs: (tok)=>({
                    level: +tok.tag.slice(1)
                })
        },
        softbreak: {
            node: 'hardBreak'
        },
        hardbreak: {
            node: 'hardBreak'
        },
        code_block: {
            block: 'codeBlock'
        },
        list_item: {
            block: 'listItem'
        },
        bullet_list: {
            block: 'bulletList'
        },
        ordered_list: {
            block: 'orderedList',
            attrs: (tok)=>({
                    order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
                })
        },
        code_inline: {
            mark: 'code'
        },
        code: {
            mark: 'code'
        },
        fence: {
            block: 'codeBlock',
            // we trim any whitespaces around language definition
            attrs: (tok)=>({
                    language: tok.info && tok.info.trim() || null
                })
        },
        mediaInline: {
            node: 'mediaInline',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media_single: {
            block: 'mediaSingle',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media: {
            node: 'media',
            attrs: (token)=>{
                // When token.pmAttrs is missing it means it's an external image.
                // @ts-expect-error
                if (token.pmAttrs) // @ts-expect-error
                return token.pmAttrs;
                return {
                    url: token.attrGet('url'),
                    type: 'external'
                };
            }
        },
        caption: {
            block: 'caption',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        alignment: {
            mark: 'alignment',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        breakout: {
            mark: 'breakout',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        border: {
            mark: 'border',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        textColor: {
            mark: 'textColor',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        underline: {
            mark: 'underline',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        subsup: {
            mark: 'subsup',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        emoji: {
            node: 'emoji',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {
                    shortName: `:${token.markup}:`,
                    text: token.content
                };
            }
        },
        inlineCard: {
            node: 'inlineCard',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        date: {
            node: 'date',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        status: {
            node: 'status',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        mention: {
            node: 'mention',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        placeholder: {
            node: 'placeholder',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        table: {
            block: 'table',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        tr: {
            block: 'tableRow',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        th: {
            block: 'tableHeader',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        td: {
            block: 'tableCell',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        s: {
            mark: 'strike'
        },
        strike: {
            mark: 'strike'
        },
        task_list: {
            block: 'taskList'
        },
        task_item: {
            block: 'taskItem',
            attrs: (tok)=>({
                    state: tok.meta
                })
        },
        layoutSection: {
            block: 'layoutSection',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        layoutColumn: {
            block: 'layoutColumn',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        panel: {
            block: 'panel',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionList: {
            block: 'decisionList',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionItem: {
            block: 'decisionItem',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        expand: {
            block: 'expand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        extension: {
            node: 'extension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        bodiedExtension: {
            block: 'bodiedExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        nestedExpand: {
            block: 'nestedExpand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        inlineExtension: {
            node: 'inlineExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        }
    });
module.exports["filterMdToPmSchemaMapping"] = $fe15ff31308e86c4$export$a9d25ff08f358d72;
module.exports["PM_SCHEMA_TO_MD_MAPPING"] = $fe15ff31308e86c4$export$b535e2638dcce02;
module.exports["getMdToPmMapping"] = $fe15ff31308e86c4$export$8f853a1c35ed8bbe;

});

parcelRegister("aLtij", function(module, exports) {
$parcel$export(module.exports, "default", () => $0773845a48a88423$export$2e2bcd8739ae039);
const $0773845a48a88423$var$captionOpen = 'caption_open';
const $0773845a48a88423$var$paragraphOpen = 'paragraph_open';
const $0773845a48a88423$var$paragraphClose = 'paragraph_close';
function $0773845a48a88423$export$eee367902819022(index, tokens) {
    // make sure we have an opening and closing paragraph token
    if (tokens[index]?.type !== $0773845a48a88423$var$paragraphOpen && tokens[index + 2]?.type !== $0773845a48a88423$var$paragraphClose) return;
    // remove the closing paragraph token from state.tokens so we don't add it into the acc
    // when we loop through the tokens
    tokens[index + 2]?.type === $0773845a48a88423$var$paragraphClose && tokens.splice(index + 2, 1);
    // return empty to prevent adding the opening token to the acc
    return;
}
function $0773845a48a88423$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'caption', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            const isWithinCaption = acc[acc.length - 1]?.type === $0773845a48a88423$var$captionOpen;
            if (type === $0773845a48a88423$var$paragraphOpen && isWithinCaption) /**
				 * paragraph_open and paragraph_close tokens get automatically added by markdown-it
				 * around text content. caption nodes do not allow paragraph nodes as children
				 * so we need to prevent these tokens from being added to the acc
				 */ $0773845a48a88423$export$eee367902819022(index, state.tokens);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("1MDnJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e92fa7dc1daa52ee$export$2e2bcd8739ae039);
function $e92fa7dc1daa52ee$export$2e2bcd8739ae039(md) {
    md.inline.ruler.before('text', 'citation', function(state, silent) {
        const str = state.src.slice(state.pos);
        /**
		 * Matches the following:
		 * [^00^]
		 */ // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const citationRegexp = /^\[\^[^\^]+\^]/;
        const match = citationRegexp.exec(str);
        if (!match) return false;
        if (silent) return true;
        // Just skip citation from parsing and don't render them in the output.
        state.pos += match[0].length;
        return true;
    });
}

});

parcelRegister("dpgtc", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cab79ce214481e1$export$2e2bcd8739ae039);

var $7MY8y = parcelRequire("7MY8y");


var $hqwd7 = parcelRequire("hqwd7");

// Some nodes will be inline but it's content will be empty.
// That's why, don't remove paragraphs wrapping it.
// For example, inlineExtension is inline node, so there should be no content inside it.
//  So it's custom element is represented by <custom data-type="inlineExtension" ... />
const $4cab79ce214481e1$var$emptyInlineCustomNodes = [
    'inlineExtension'
];
function $4cab79ce214481e1$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes) {
    md.core.ruler.after('inline', 'custom-block', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const match = token.content.match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123" />
				 * <custom data-type="smartlink" />
				 * <custom data-type="panel_open" data-id="123" />
				 * <custom data-type="panel_close" />
				 */ // Ignored via go/ees005
            // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
            // eslint-disable-next-line require-unicode-regexp
            RegExp('<custom\\s+data-type="(?<dataType>.*?)"\\s*(data-id="(?<dataId>.*?)"\\s*)?\\/>'));
            const dataType = match?.groups?.dataType;
            if (match && dataType && !$4cab79ce214481e1$var$emptyInlineCustomNodes.includes(dataType)) {
                const dataId = match.groups?.dataId;
                if (dataType) {
                    analyticsAttributes.htmlConvertedToNodes++;
                    const customElementToken = (0, $7MY8y.createToken)(state, dataType);
                    if (dataId && idMap[dataId]) // @ts-ignore
                    customElementToken.pmAttrs = idMap[dataId].attributes;
                    customElementToken.attrPush([
                        'isCustomBlock',
                        'true'
                    ]);
                    /**
					 * When the custom tag goes through the tokenizer it is transformed into this structure:
					 * paragraph_open
					 * inline
					 * paragraph_close
					 *
					 * so the following section removes the wrapping paragraph tokens
					 */ acc.splice(acc.length - 1, 1);
                    state.tokens.splice(index + 1, 1);
                    // We then push replace the inline token with our custom token
                    acc.push(customElementToken);
                } else {
                    analyticsAttributes.htmlConvertedToFallbackNodes++;
                    acc.push(token);
                }
            } else acc.push(token);
            return acc;
        }, []);
        const toRemove = (0, $hqwd7.sanitizeCustomBlocks)(state.tokens);
        toRemove.forEach((index)=>{
            const tokenToBeRemoved = state.tokens[index];
            analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] = (analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] || 0) + 1;
        });
        // Remove all indices that have been set in `toRemove`
        if (featureToggles.markdownPlusRemoveUnclosedTokens) state.tokens = state.tokens.filter((_, index)=>!toRemove.has(index));
    });
}

});

parcelRegister("7MY8y", function(module, exports) {
function $6d1436b1813e587d$export$c255480b061bd6aa(state, type, level) {
    let nesting;
    if (type.includes('_open')) nesting = 1;
    else if (type.includes('_close')) nesting = -1;
    else nesting = 0;
    const token = new state.Token(type, '', nesting);
    if (level) token.level = level;
    return token;
}
module.exports["createToken"] = $6d1436b1813e587d$export$c255480b061bd6aa;

});

parcelRegister("hqwd7", function(module, exports) {
function $bb6e978431b17277$export$e717b161ec14d433(tokens) {
    const openTokenIndexMap = new Map();
    const toRemove = new Set();
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // This attribute is set earlier in this file (customElementToken.attrPush(['isCustomBlock', 'true']))
        // So we can identify tokens added by this rule
        if (token.attrGet('isCustomBlock') === 'true') {
            // We split by the last underscore
            const type = token.type.substring(0, token.type.lastIndexOf('_'));
            const prevIndex = openTokenIndexMap.get(type);
            // Only check for removal if type exists
            if (type && token.nesting === 1) {
                if (prevIndex !== undefined) toRemove.add(prevIndex);
                openTokenIndexMap.set(type, i);
            } else if (type && token.nesting === -1) {
                if (prevIndex !== undefined) // If previous open token found, then we've found a match and we can close it
                openTokenIndexMap.delete(type);
                else toRemove.add(i);
            }
        }
    }
    // Anything left in the stack is an unmatched open token
    openTokenIndexMap.forEach((remainingIndex)=>toRemove.add(remainingIndex));
    return toRemove;
}
module.exports["sanitizeCustomBlocks"] = $bb6e978431b17277$export$e717b161ec14d433;

});

parcelRegister("2mgEK", function(module, exports) {
$parcel$export(module.exports, "default", () => $102908d0f0788df0$export$2e2bcd8739ae039);

var $a4TK8 = parcelRequire("a4TK8");

function $102908d0f0788df0$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus) {
    const rule = md.inline.ruler.before('text', 'custom', function(state, silent) {
        const start = state.pos;
        const origSrc = state.src;
        let match;
        if (featureToggles.markdownPlusAttributeTest) match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 * <custom data-type="status" data-id="id-0" data-attrs='{"text":"test","color":"neutral"}'>test</custom>
				 */ // Ignored via go/ees005
        // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
        // eslint-disable-next-line require-unicode-regexp
        RegExp('<custom(?:\\s+data-type="(?<dataType>[^"]*)")?(?:\\s+data-id="(?<dataId>[^"]*)")?(?:\\s+data-attrs="(?<dataAttrs>\\{.*?\\})")?\\s*>(?<dataContent>.*?)<\\/custom>'));
        else match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 */ // Ignored via go/ees005
        // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
        // eslint-disable-next-line require-unicode-regexp
        RegExp('<custom(\\sdata-(type|id)="(?<dataType>.*?)")?(\\sdata-(type|id)="(?<dataId>.*?)")?>(?<dataContent>.*?)<\\/custom>'));
        if (!match) return false;
        const tagLength = match[0].length;
        const beforeTag = state.src.slice(start, state.src.indexOf(match[0]));
        const dataType = match.groups?.dataType;
        const dataId = match.groups?.dataId;
        const dataAttrs = match.groups?.dataAttrs;
        const dataContent = match.groups?.dataContent;
        const afterTag = state.src.slice(start + beforeTag.length + tagLength);
        function mapCustomDataTypeToNodeType(customDataType) {
            switch(customDataType){
                case 'smartlink':
                    return 'inlineCard';
                case 'date':
                case 'emoji':
                case 'status':
                case 'mention':
                case 'placeholder':
                    return customDataType;
                // Just move below case alongside mention above to remove markdownPlusExtensions FF.
                case 'inlineExtension':
                    return featureToggles.markdownPlusExtensions ? 'inlineExtension' : false;
                case 'mediaInline':
                    return featureToggles.markdownPlusAddComplexNodes ? 'mediaInline' : false;
                default:
                    return false;
            }
        }
        const customDataType = mapCustomDataTypeToNodeType(dataType);
        if (!silent) {
            // tokenize beforeTag
            if (beforeTag) {
                state.src = beforeTag;
                // @ts-ignore
                state.md.inline.tokenize(state, beforeTag);
            }
            if (featureToggles.markdownPlusAttributeTest && featureToggles.markdownPlusMentions && !dataId && dataAttrs && customDataType) {
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = dataAttrs;
            }
            if (dataId && idMap?.[dataId]?.attributes && customDataType) {
                analyticsAttributes.htmlConvertedToNodes++;
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = idMap[dataId].attributes;
                if (featureToggles.markdownPlusAttributeTest && dataAttrs) try {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(idMap[dataId].attributes, JSON.parse(dataAttrs))) markdownPlusAttributeStatus.push([
                        customDataType,
                        true
                    ]);
                    else // We need to check this because when you type it calls this function multiple times and the first time its called the current text is not the same
                    if (idMap[dataId].attributes.text === JSON.parse(dataAttrs).text) markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                } catch (e) {
                    markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                }
            } else {
                analyticsAttributes.htmlConvertedToFallbackNodes++;
                const textToken = state.push('text', '', 0);
                // If there is no data content we want to hide the custom tags as the AI has hallucinated something
                if (!dataContent) textToken.content = '';
                else textToken.content = dataContent || match[0];
            }
            if (afterTag) {
                state.src = afterTag;
                state.pos = 0;
                // @ts-ignore
                state.md.inline.tokenize(state, afterTag);
            }
        }
        state.src = origSrc;
        state.pos = start + state.src.length;
        return true;
    });
    return rule;
}

});

parcelRegister("fMMkB", function(module, exports) {
$parcel$export(module.exports, "default", () => $b85e013b8e2ab0fc$export$2e2bcd8739ae039);
const $b85e013b8e2ab0fc$var$decisionItemOpen = 'decisionItem_open';
const $b85e013b8e2ab0fc$var$paragraphOpen = 'paragraph_open';
const $b85e013b8e2ab0fc$var$paragraphClose = 'paragraph_close';
const $b85e013b8e2ab0fc$var$inline = 'inline';
function $b85e013b8e2ab0fc$var$handleParagraphs(acc, token) {
    /**
	 * Traverse up the acc token array, and if a chain of one or more inline tokens are under
	 * a decisionItem_open token, then it is considered to be a paragraph_close token within
	 * a decision item.
	 *
	 * This also works for a paragraph_open token as inlineCount would be zero meaning that
	 * the conditional applies to when decisionItem_open is right above paragraph_open.
	 */ let inlineCount = 0;
    let inlineChainEnded = false;
    for(let i = acc.length - 1; i >= 0; i--){
        const type = acc[i]?.type;
        if (!inlineChainEnded) {
            if (type === $b85e013b8e2ab0fc$var$inline) inlineCount += 1;
            else inlineChainEnded = true;
        }
    }
    const isWithinDecisionItem = acc[acc.length - (inlineCount + 1)]?.type === $b85e013b8e2ab0fc$var$decisionItemOpen;
    if (!isWithinDecisionItem) acc.push(token);
}
function $b85e013b8e2ab0fc$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'decision-list', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $b85e013b8e2ab0fc$var$paragraphOpen || type === $b85e013b8e2ab0fc$var$paragraphClose) $b85e013b8e2ab0fc$var$handleParagraphs(acc, token);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("6dzgm", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6de2bb5deb5f668$export$2e2bcd8739ae039);
const $e6de2bb5deb5f668$var$replaceBrWithLineBreak = (text)=>{
    // Matches <br> or <br /> or <br/> with optional trailing space
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/<br\s*\/?>\s?/gi, '\n');
};
const $e6de2bb5deb5f668$var$processInlineChildren = (children)=>{
    for (const child of children)if (child.type === 'text') {
        const newText = $e6de2bb5deb5f668$var$replaceBrWithLineBreak(child.content);
        if (child.content !== newText) child.content = newText;
    }
};
const $e6de2bb5deb5f668$var$brToLineBreak = (state)=>{
    for (const token of state.tokens)if (token.type === 'inline' && token.children) $e6de2bb5deb5f668$var$processInlineChildren(token.children);
};
var $e6de2bb5deb5f668$export$2e2bcd8739ae039 = (md)=>md.core.ruler.after('inline', 'lineBreak', $e6de2bb5deb5f668$var$brToLineBreak);

});

parcelRegister("locel", function(module, exports) {
$parcel$export(module.exports, "default", () => $866d7fb158c265f1$export$2e2bcd8739ae039);
// File copied from packages/editor/editor-core/src/plugins/paste/linkify-md-plugin.ts

var $2Gb84 = parcelRequire("2Gb84");


var $81OAa = parcelRequire("81OAa");


var $2OwON = parcelRequire("2OwON");

// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $866d7fb158c265f1$var$arrayReplaceAt = (src, pos, newElements)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $866d7fb158c265f1$var$isLinkOpen = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<a[>\s]/i.test(str);
};
const $866d7fb158c265f1$var$isLinkClose = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<\/a\s*>/i.test(str);
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $866d7fb158c265f1$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($866d7fb158c265f1$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($866d7fb158c265f1$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $81OAa.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $2OwON.findFilepaths)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $2OwON.isLinkInMatches)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $866d7fb158c265f1$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$866d7fb158c265f1$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $866d7fb158c265f1$var$linkify);

});

parcelRegister("2OwON", function(module, exports) {
// File copied from packages/editor/editor-core/src/plugins/hyperlink/utils.ts
// Regular expression for a windows filepath in the format <DRIVE LETTER>:\<folder name>\
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7715b3c791c155be$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $7715b3c791c155be$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const localRegExp = new RegExp($7715b3c791c155be$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $7715b3c791c155be$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $7715b3c791c155be$export$8acd10161c5f8b07(text) {
    return text.replace(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /(\[([^\]]+)\]\(|\!\[([^\]]*)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s]+)/g, (str)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s]+$/) ? `<${str}>` : str;
    });
}
module.exports["findFilepaths"] = $7715b3c791c155be$export$d37783fe63e2f0fe;
module.exports["isLinkInMatches"] = $7715b3c791c155be$export$5e652e74655163e5;
module.exports["escapeLinks"] = $7715b3c791c155be$export$8acd10161c5f8b07;

});

parcelRegister("ip5oL", function(module, exports) {
// File copied from packages/editor/editor-markdown-transformer/src/media.ts

var $bd943 = parcelRequire("bd943");

function $623b0b26b9c81375$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[[^\]]*\]\([^)]+\)/g;
    // Allow paragraph_close as a valid parent token for cases where a user has an image at the end of a paragraph
    // due to shift+enter
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'paragraph_close'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            if (url.includes((0, $bd943.MEDIA_BASE_URL_STAGING))) try {
                const urlObject = new URL(getUrl(url));
                const params = urlObject.searchParams;
                if (params.toString()) {
                    const pmAttrs = {};
                    for (const [key, value] of params)pmAttrs[key] = value;
                    // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
                    media.pmAttrs = pmAttrs;
                }
            } catch  {}
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && regx.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const matches = token.content.match(regx);
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + match.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $623b0b26b9c81375$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $623b0b26b9c81375$var$createRule());
};
module.exports["markdownItMedia"] = $623b0b26b9c81375$export$c8dcbd316b71f8cf;

});

parcelRegister("ifgRb", function(module, exports) {
$parcel$export(module.exports, "default", () => $73825321bd2619ae$export$2e2bcd8739ae039);
// file copied from packages/editor/editor-core/src/plugins/paste/newline-md-plugin.ts
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73825321bd2619ae$var$newline = (state, silent)=>{
    let pos = state.pos;
    // ED-15363: unread variables
    // max,
    // ws,
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$73825321bd2619ae$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $73825321bd2619ae$var$newline);

});

parcelRegister("2XcI5", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f17de48a6931d92$export$2e2bcd8739ae039);

var $bd943 = parcelRequire("bd943");


var $7MY8y = parcelRequire("7MY8y");

// eslint-disable-next-line require-unicode-regexp
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $3f17de48a6931d92$var$mediaRegex = /(!\[[^\]]*\]\([^)]+\))|(\[!\[[^\]]*\]\([^)]+\)\]\([^)]+\))/gu;
const $3f17de48a6931d92$var$getUrl = (state, str)=>{
    const res = state.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
    if (res.ok) {
        const href = state.md.normalizeLink(res.str);
        if (state.md.validateLink(href)) return href;
    }
    return '';
};
const $3f17de48a6931d92$var$checkPreviousToken = (type, acc)=>{
    return acc.length > 0 && acc[acc.length - 1].type === type;
};
const $3f17de48a6931d92$var$createMediaTokens = (url, state, acc)=>{
    const mediaSingleOpen = (0, $7MY8y.createToken)(state, 'media_single_open');
    const media = (0, $7MY8y.createToken)(state, 'media');
    media.attrs = [
        [
            'url',
            $3f17de48a6931d92$var$getUrl(state, url)
        ],
        [
            'type',
            'external'
        ]
    ];
    // This is a hack to get internal media to work
    // to recreate the image correctly we need to apply the pmAttrs from the image
    // We store the pmAttrs in the "fake" image url and apply them to the token
    if (url.includes((0, $bd943.MEDIA_BASE_URL_STAGING))) try {
        const urlObject = new URL($3f17de48a6931d92$var$getUrl(state, url));
        const params = urlObject.searchParams;
        if (params.toString()) {
            const pmAttrs = {};
            for (const [key, value] of params)pmAttrs[key] = value;
            // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
            media.pmAttrs = pmAttrs;
        }
    } catch  {}
    const mediaSingleClose = (0, $7MY8y.createToken)(state, 'media_single_close');
    acc.push(mediaSingleOpen, media, mediaSingleClose);
};
const $3f17de48a6931d92$var$createInlineTokens = (content, state, acc)=>{
    const paragraphOpen = (0, $7MY8y.createToken)(state, 'paragraph_open');
    const inline = (0, $7MY8y.createToken)(state, 'inline');
    inline.content = content;
    inline.children = [
        (0, $7MY8y.createToken)(state, 'text')
    ];
    const paragraphClose = (0, $7MY8y.createToken)(state, 'paragraph_close');
    acc.push(paragraphOpen, inline, paragraphClose);
};
/**
 * Splits the content of the inline token
 * Inline tokens can contain multiple media elements as well as regular text
 * We split the content into an array of strings which can then be converted into the correct tokens
 */ const $3f17de48a6931d92$var$findContent = (token)=>{
    let content = [];
    let lastIndex = 0;
    let match;
    $3f17de48a6931d92$var$mediaRegex.lastIndex = 0;
    // eslint-disable-next-line no-cond-assign
    while((match = $3f17de48a6931d92$var$mediaRegex.exec(token.content)) !== null){
        const matchedString = match[0];
        const matchIndex = match.index;
        if (lastIndex < matchIndex) content.push(token.content.substring(lastIndex, matchIndex));
        content.push(matchedString);
        lastIndex = matchIndex + matchedString.length;
    }
    if (lastIndex < token.content.length) content.push(token.content.substring(lastIndex));
    content = content.filter((item)=>item.length > 0);
    return content;
};
function $3f17de48a6931d92$export$2e2bcd8739ae039(md) {
    md.core.ruler.before('inline', 'media', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'inline' && $3f17de48a6931d92$var$mediaRegex.test(token.content)) {
                // If the previous token is a paragraph_open we want to remove it
                if ($3f17de48a6931d92$var$checkPreviousToken('paragraph_open', acc)) acc.pop();
                const content = $3f17de48a6931d92$var$findContent(token);
                content.forEach((item)=>{
                    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
                    const doesMatch = /!\[[^\]]*\]\([^)]+\)/u.test(item);
                    if (doesMatch) $3f17de48a6931d92$var$createMediaTokens(item, state, acc);
                    else $3f17de48a6931d92$var$createInlineTokens(item, state, acc);
                });
            // If the current token is paragraph close we want to make sure that the previous token isn't a media_single_close
            // or paragraph_close
            } else if (type === 'paragraph_close') {
                if (!$3f17de48a6931d92$var$checkPreviousToken('media_single_close', acc) && !$3f17de48a6931d92$var$checkPreviousToken('paragraph_close', acc)) acc.push(token);
            } else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("9tykg", function(module, exports) {
$parcel$export(module.exports, "default", () => $811470bd95061a4c$export$2e2bcd8739ae039);
// File copied from packages/editor/editor-core/src/plugins/paste/paragraph-md-plugin.ts
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $811470bd95061a4c$var$paragraph = (state, startLine /*, endLine*/ )=>{
    let terminate, i, l, token, nextLine = startLine + 1;
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const endLine = state.lineMax;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$811470bd95061a4c$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $811470bd95061a4c$var$paragraph);

});

parcelRegister("d5C9r", function(module, exports) {
$parcel$export(module.exports, "default", () => $11bccb76849cfb3f$export$2e2bcd8739ae039);

var $7MY8y = parcelRequire("7MY8y");

const $11bccb76849cfb3f$var$bulletListOpen = 'bullet_list_open';
const $11bccb76849cfb3f$var$bulletListClose = 'bullet_list_close';
const $11bccb76849cfb3f$var$listItemOpen = 'list_item_open';
const $11bccb76849cfb3f$var$listItemClose = 'list_item_close';
const $11bccb76849cfb3f$var$taskListOpen = 'task_list_open';
const $11bccb76849cfb3f$var$taskListClose = 'task_list_close';
const $11bccb76849cfb3f$var$taskItemOpen = 'task_item_open';
const $11bccb76849cfb3f$var$taskItemClose = 'task_item_close';
const $11bccb76849cfb3f$var$paragraphOpen = 'paragraph_open';
const $11bccb76849cfb3f$var$paragraphClose = 'paragraph_close';
function $11bccb76849cfb3f$var$checkTypeByIndex(acc, type, indexOffset = -1) {
    return acc[acc.length + indexOffset]?.type === type;
}
function $11bccb76849cfb3f$var$getTokenByIndex(acc, indexOffset = -1) {
    return acc[acc.length + indexOffset];
}
function $11bccb76849cfb3f$var$handleBulletListOpen(state, token, acc, index) {
    const isPreviousTokenInline = $11bccb76849cfb3f$var$checkTypeByIndex(acc, 'inline');
    const isStartOfTaskList = state.tokens[index + 3].type === 'inline' && $11bccb76849cfb3f$var$startsWithTodoMarkdown(state.tokens[index + 3]);
    // If the previous token is inline and our current token is a bullet_list_open that
    // means we have found the start of a nested list, due to current ADF limitations task items
    // cannot contain new task lists so first we must close the task item and then convert the
    // bullet_list_open to task_list_open
    if (isPreviousTokenInline) {
        acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskItemClose, $11bccb76849cfb3f$var$getTokenByIndex(acc).level - 1));
        acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListOpen, $11bccb76849cfb3f$var$getTokenByIndex(acc).level));
    } else if (isStartOfTaskList) acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListOpen));
    else acc.push(token);
}
function $11bccb76849cfb3f$var$handleBulletListClose(state, token, acc) {
    const isPreviousTokenTaskItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemClose);
    const isPreviousTokenTaskListClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose);
    if (isPreviousTokenTaskItemClose || isPreviousTokenTaskListClose) acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListClose, $11bccb76849cfb3f$var$getTokenByIndex(acc).level - 1));
    else acc.push(token);
}
function $11bccb76849cfb3f$var$handleListItemOpen(state, token, acc, index) {
    const newTaskItemOpen = (0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskItemOpen);
    const isTaskItem = state.tokens[index + 2].type === 'inline' && $11bccb76849cfb3f$var$startsWithTodoMarkdown(state.tokens[index + 2]);
    const isPreviousTokenTaskItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemClose);
    const isPreviousTokenListItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$listItemClose);
    const isPreviousTokenTaskListClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose);
    if (isTaskItem) {
        // If the previous token is a list item close then we have run into some incorrect task list / list markdown
        // We need to complete the previous bullet list and then open a new task list
        if (isPreviousTokenListItemClose) {
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$bulletListClose));
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListOpen));
        }
        newTaskItemOpen.meta = $11bccb76849cfb3f$var$isDone(state.tokens[index + 2]);
        newTaskItemOpen.level = $11bccb76849cfb3f$var$getTokenByIndex(acc).level + (isPreviousTokenTaskListClose ? 0 : 1);
        acc.push(newTaskItemOpen);
    } else {
        // If the previous token is a task item close but the current token is not a task item we need to
        // close the current task item list and then open a new bullet list
        if (isPreviousTokenTaskItemClose) {
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListClose));
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$bulletListOpen));
        }
        acc.push(token);
    }
}
function $11bccb76849cfb3f$var$handleListItemClose(state, token, acc) {
    const isWithinTaskList = $11bccb76849cfb3f$var$checkTypeByIndex(acc, 'inline') && $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen, -2);
    if (isWithinTaskList) acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskItemClose, $11bccb76849cfb3f$var$getTokenByIndex(acc, -2).level));
    else if (!$11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose)) acc.push(token);
}
function $11bccb76849cfb3f$var$handleInline(token, acc) {
    if (token.children?.[0]) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    token.children[0].content = $11bccb76849cfb3f$var$removeTodoMarkdown(token.children[0].content);
    token.content = $11bccb76849cfb3f$var$removeTodoMarkdown(token.content);
    token.level = $11bccb76849cfb3f$var$getTokenByIndex(acc).level + 1;
    acc.push(token);
}
function $11bccb76849cfb3f$var$handleParagraphs(token, acc) {
    const isWithinTaskItem = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen) || $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen, -2);
    if (!isWithinTaskItem) acc.push(token);
}
function $11bccb76849cfb3f$var$isInlineAfterTaskItemOpen(token, acc) {
    return token.type === 'inline' && acc[acc.length - 1].type === $11bccb76849cfb3f$var$taskItemOpen;
}
function $11bccb76849cfb3f$var$startsWithTodoMarkdown(token) {
    // leading whitespace in a list item is already trimmed off by markdown-it
    return token.content.indexOf('[ ] ') === 0 || token.content.indexOf('[x] ') === 0 || token.content.indexOf('[X] ') === 0;
}
function $11bccb76849cfb3f$var$removeTodoMarkdown(content) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regex = /(\[x\]\s)|(\[\s\]\s)/;
    return content.replace(regex, '');
}
function $11bccb76849cfb3f$var$isDone(token) {
    if (token.content.indexOf('[ ] ') === 0) return 'TODO';
    else return 'DONE';
}
function $11bccb76849cfb3f$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'github-task-lists', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $11bccb76849cfb3f$var$bulletListOpen) $11bccb76849cfb3f$var$handleBulletListOpen(state, token, acc, index);
            else if (type === $11bccb76849cfb3f$var$bulletListClose) $11bccb76849cfb3f$var$handleBulletListClose(state, token, acc);
            else if (type === $11bccb76849cfb3f$var$listItemOpen) $11bccb76849cfb3f$var$handleListItemOpen(state, token, acc, index);
            else if ($11bccb76849cfb3f$var$isInlineAfterTaskItemOpen(token, acc)) $11bccb76849cfb3f$var$handleInline(token, acc);
            else if (type === $11bccb76849cfb3f$var$listItemClose) $11bccb76849cfb3f$var$handleListItemClose(state, token, acc);
            else if (type === $11bccb76849cfb3f$var$paragraphOpen || type === $11bccb76849cfb3f$var$paragraphClose) $11bccb76849cfb3f$var$handleParagraphs(token, acc);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("b4zhJ", function(module, exports) {

var $dM1Gg = parcelRequire("dM1Gg");


var $42omo = parcelRequire("42omo");


var $dWCFT = parcelRequire("dWCFT");

const $4b5152b7d142b759$var$isClickable = (props)=>!!props.onClick;
class $4b5152b7d142b759$export$6341f9a885713487 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dM1Gg.DateLozenge), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.props.className,
            onClick: $4b5152b7d142b759$var$isClickable(this.props) ? this.handleOnClick : undefined,
            color: this.props.color
        }, this.renderContent());
    }
    constructor(...args){
        super(...args);
        this.handleOnClick = (event)=>{
            if ($4b5152b7d142b759$var$isClickable(this.props)) this.props.onClick(this.props.value, event);
        };
        this.renderContent = ()=>{
            if (this.props.children) {
                if (typeof this.props.children === 'function') return(// prettier-ignore
                // eslint-disable-next-line @typescript-eslint/ban-types
                this.props.children(this.props));
                return this.props.children;
            }
            return (0, $dWCFT.default)(this.props.value, this.props.format || '');
        };
    }
}
$4b5152b7d142b759$export$6341f9a885713487.displayName = 'Date';
$4b5152b7d142b759$export$6341f9a885713487.defaultProps = {
    format: 'dd/MM/yyyy',
    color: 'grey'
};
module.exports["Date"] = $4b5152b7d142b759$export$6341f9a885713487;

});

parcelRegister("dM1Gg", function(module, exports) {
/* DateLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $6603fd6b25dc5551$var$baseStyles = null;
const $6603fd6b25dc5551$var$onClickStyles = null;
const $6603fd6b25dc5551$var$colorStyles = {
    red: "_bfhk1vk5 _syaz9lu1 _irr31rtt",
    yellow: "_bfhkibhp _syazfb2s _irr31773",
    blue: "_bfhk1s93 _syaz16jw _irr31dy8",
    green: "_bfhkn729 _syazh55r _irr31wnw",
    purple: "_bfhkp2ly _syazqmo9 _irr31nm4",
    grey: "_bfhki8nm _syazi7uo _irr3plhp"
};
const $6603fd6b25dc5551$export$a9273d5fc6f7142c = (props)=>{
    const { className: className, color: color = 'grey', children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ...rest,
        className: (0, $gMc0m.default)([
            "_2rkofajl _19pkidpf _2hwxt94y _otyridpf _18u0t94y _v5641y8x _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _kqswh2mm _o5721q9c _80omn7od",
            props.onClick && "_80omtlke",
            $6603fd6b25dc5551$var$colorStyles[color],
            className
        ]),
        role: "button"
    }, children);
};
module.exports["DateLozenge"] = $6603fd6b25dc5551$export$a9273d5fc6f7142c;

});

parcelRegister("9XexZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $15h8H = parcelRequire("15h8H");

const $26e790de36bba91a$export$a74fbbd6fb01001c = (clientId, setupHandlers, apiInstance = (0, $15h8H.getBrowserBridgeAPI)())=>{
    const refApi = (0, $42omo.useRef)(apiInstance);
    const refReady = (0, $42omo.useRef)(false);
    const refMount = (0, $42omo.useRef)(setupHandlers);
    const api = refApi.current;
    const setup = (0, $42omo.useCallback)(()=>{
        // register all handlers
        // devx: provide current `clientId`
        setupHandlers?.((command, handler)=>api.on(clientId, command, handler));
    }, [
        clientId,
        setupHandlers,
        api
    ]);
    const ready = (0, $42omo.useCallback)(()=>{
        // setup all handlers
        setup();
        // mark client as ready
        api.ready(clientId);
        // now, the client can receive messages AND handle them
        refReady.current = true;
    }, [
        clientId,
        setup,
        api
    ]);
    const send = (0, $42omo.useCallback)((command, params)=>{
        // devx: provide current `clientId`
        return api.send(command, {
            ...params,
            senderId: clientId
        });
    }, [
        clientId,
        api
    ]);
    const broadcast = (0, $42omo.useCallback)((command, params, options)=>{
        api.broadcast(command, params, options);
    }, [
        api
    ]);
    const teardown = (0, $42omo.useCallback)(()=>{
        // devx: provide current `clientId`
        return api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    (0, $42omo.useEffect)(()=>{
        // teardown if component tree is being destroyed
        // note: will also tear down all command handlers on your behalf
        return ()=>api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    /**
	 * If we have already mounted our handlers once and marked ourselves as ready, then this
	 * bridge API client is already capable of receiving & handling commands. On subsequent renders
	 * if our {@link setupHandlers} reference changes, we need to make sure we run our setup again.
	 *
	 * This will ensure the newest state of every handler is being used, with no stale references
	 * in closures, as can often occur with initialise-only-once code in React.
	 */ if (refReady.current && refMount.current !== setupHandlers) setup();
    // so we can compare on next render
    refMount.current = setupHandlers;
    return {
        id: api.id,
        ready: ready,
        send: send,
        teardown: teardown,
        broadcast: broadcast
    };
};
module.exports["useRovoContentBridgeAPI"] = $26e790de36bba91a$export$a74fbbd6fb01001c;

});

parcelRegister("5gEqE", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $815712ef274e8115$var$initialState = {
    activeMenu: 'none',
    mounted: false,
    isAgentSelectorMenuOpen: false,
    streaming: false,
    isSideNavOpen: false
};
const $815712ef274e8115$var$store = (0, $1P1Tu.createStore)({
    name: 'uiStore',
    initialState: $815712ef274e8115$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState({
                    ...$815712ef274e8115$var$initialState
                });
            },
        setActiveMenu: (menu)=>({ setState: setState })=>{
                setState({
                    activeMenu: menu
                });
            },
        setMounted: (mounted)=>({ setState: setState })=>{
                setState({
                    mounted: mounted
                });
            },
        setIsAgentSelectorMenuOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isAgentSelectorMenuOpen: isOpen
                });
            },
        setStreamingStatus: (status)=>({ setState: setState })=>{
                setState({
                    streaming: status
                });
            },
        setSideNavOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isSideNavOpen: isOpen
                });
            }
    }
});
const $815712ef274e8115$var$useStore = (0, $9zUhf.createHook)($815712ef274e8115$var$store);
const $815712ef274e8115$export$5b2ba9b8ea3b0771 = ()=>{
    const [{ activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isSideNavOpen: isSideNavOpen }, { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setSideNavOpen: setSideNavOpen }] = $815712ef274e8115$var$useStore();
    return {
        activeMenu: activeMenu,
        mounted: mounted,
        streaming: streaming,
        isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
        isSideNavOpen: isSideNavOpen,
        reset: reset,
        setActiveMenu: setActiveMenu,
        setMounted: setMounted,
        setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
        setStreamingStatus: setStreamingStatus,
        setSideNavOpen: setSideNavOpen
    };
};
const $815712ef274e8115$export$cd2fc25ddd3752d4 = (0, $9zUhf.createActionsHook)($815712ef274e8115$var$store);
module.exports["useUIStore"] = $815712ef274e8115$export$5b2ba9b8ea3b0771;
module.exports["useUIStoreActions"] = $815712ef274e8115$export$cd2fc25ddd3752d4;

});

parcelRegister("jO3S6", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $5eff64246cff89b2$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("23ga2")));
const $5eff64246cff89b2$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($5eff64246cff89b2$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        })
    });
});
module.exports["LazyAnimatedRovoIcon"] = $5eff64246cff89b2$export$7ea4e54699cd5224;

});

parcelRegister("23ga2", function(module, exports) {

let $17e865d2382724b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17e865d2382724b6$var$load("frhR0").then(()=>parcelRequire('5O8EX'));

});

parcelRegister("d7r2R", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $376a36c4bbddbe1c$var$Loading = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("title", {
                children: props.alt
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #1868DB)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #1868DB)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #1868DB)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
var $376a36c4bbddbe1c$export$2e2bcd8739ae039 = $376a36c4bbddbe1c$var$Loading;
module.exports["default"] = $376a36c4bbddbe1c$export$2e2bcd8739ae039;

});

parcelRegister("ls2Fy", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $cgtv4 = parcelRequire("cgtv4");

const $19b135ef0d7ad272$export$21be832820f3e6e6 = (0, $cgtv4.defineMessages)({
    aupViolationMessage: {
        id: "fabric.editor.ai.experience.aupViolationMessage",
        defaultMessage: "Your prompt or content might not comply with our Acceptable Use Policy. Please review both and refer to our <link>Acceptable Use Policy</link> if needed. If the problem persists, consider trying a different prompt or content."
    },
    documentInsertError: {
        id: "fabric.editor.ai.experience-application.documentInsertError",
        defaultMessage: "We're having trouble inserting the response. Close the dialog and try again."
    },
    tokenLimitExceeded: {
        id: "fabric.editor.ai.experience-application.tokenLimitExceeded",
        defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again."
    },
    rateLimitEnforced: {
        id: "fabric.editor.ai.experience-application.rateLimitEnforced",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or read about <link>excessive use of AI</link>."
    },
    apiError: {
        id: "fabric.editor.ai.experience.apiError",
        defaultMessage: "We couldn\u2019t get a response, please try again."
    },
    elevateDisabledGenerateError: {
        id: "fabric.editor.ai.experience.elevateDisabledGenetateError",
        defaultMessage: "Free generate is disabled in Elevate at this time."
    },
    internalServerError: {
        id: "fabric.editor.ai.experience.internalServerError",
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <link>check the status of AI</link>."
    },
    inputTooShortError: {
        id: "fabric.editor.ai.experience.inputTooShortError",
        defaultMessage: "The content is too short to summarize. Please add more and try again."
    },
    hipaaContentError: {
        id: "fabric.editor.ai.experience.hipaaContentError",
        defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content. Please remove these links and try again."
    },
    adfStreamingError: {
        id: "fabric.editor.ai.experience.adfStreamingError",
        defaultMessage: "Our apologies, we couldn't get a response."
    },
    aifcAupViolationMessage: {
        id: "fabric.editor.ai.experience.aifcAupViolationMessage",
        defaultMessage: "Content does not comply with our <link>Acceptable Use Policy</link>."
    },
    aifcApiError: {
        id: "fabric.editor.ai.experience.aifcApiError",
        defaultMessage: "An unknown error occurred."
    },
    aifcApiErrorRetry: {
        id: "fabric.editor.ai.experience.aifcApiErrorRetry",
        defaultMessage: "An unknown error occurred. Please reload and try again."
    },
    aifcTokenLimitExceeded: {
        id: "fabric.editor.ai.experience.aifcTokenLimitExceeded",
        defaultMessage: "There\u2019s too much content to process. Select less content and try again."
    },
    aifcInputTooShortError: {
        id: "fabric.editor.ai.experience.aifcInputTooShortError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    },
    aifcHipaaContentError: {
        id: "fabric.editor.ai.experience.aifcHipaaContentError",
        defaultMessage: "Your content contains links to HIPAA restricted content. Remove links and try again."
    },
    aifcRateLimitEnforced: {
        id: "fabric.editor.ai.experience.aifcRateLimitEnforced",
        defaultMessage: "You\u2019ve reached the <link>maximum number of requests</link>. Try again in 5 minutes."
    },
    aifcInternalServerError: {
        id: "fabric.editor.ai.experience.aifcInternalServerError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response. Try again in 5 minutes or <link>check Rovo status</link>."
    },
    aifcAdfStreamingError: {
        id: "fabric.editor.ai.experience.aifcAdfStreamingError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response."
    },
    noTextualContentError: {
        id: "fabric.editor.ai.experience.noTextualContentError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    }
});
module.exports["aiFailedStateMessages"] = $19b135ef0d7ad272$export$21be832820f3e6e6;

});

parcelRegister("kPjga", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $hezkK = parcelRequire("hezkK");

const $d0b7a75160e05812$export$c913fcdcf440a92c = ({ agent: agent })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hezkK.AgentAvatar), {
        agentNamedId: agent.external_config_reference ?? agent.named_id,
        agentId: agent.id,
        agentIdentityAccountId: agent.identity_account_id,
        size: "small",
        showBorder: false,
        isForgeAgent: agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE',
        forgeAgentIconUrl: agent.icon
    });
};
module.exports["PromptAgentAvatar"] = $d0b7a75160e05812$export$c913fcdcf440a92c;

});

parcelRegister("4pEXC", function(module, exports) {

var $b0F8r = parcelRequire("b0F8r");


var $b7FrM = parcelRequire("b7FrM");


var $lpRYt = parcelRequire("lpRYt");


var $ij2FZ = parcelRequire("ij2FZ");

const $cdcb92bd6c40797f$export$d801201dc544181 = (content)=>{
    /*
	This try-catch is a necessary guard rail against broken content to prevent higher level
	error boundaries from displaying the error and breaking the experience.
	*/ try {
        return typeof content !== 'string' && 'type' in content && content.type === 'doc';
    } catch  {
        return false;
    }
};
const $cdcb92bd6c40797f$export$a236f395afded7e0 = (content, suggestionContent)=>{
    if ($cdcb92bd6c40797f$export$d801201dc544181(content)) {
        // Ensure the content is an array of nodes
        const updatedContent = Array.isArray(content.content) ? content.content : [
            content.content
        ];
        // Append the new paragraph node
        updatedContent.push({
            type: 'paragraph',
            content: [
                {
                    type: 'text',
                    text: suggestionContent
                }
            ]
        });
        // Return the updated DocNode
        return {
            ...content,
            content: updatedContent
        };
    }
    return `${content}\n\n${suggestionContent}`;
};
const $cdcb92bd6c40797f$var$pluginConfig = {
    linkify: {
        findFilepaths: $b0F8r.findFilepaths,
        isLinkInMatches: $b0F8r.isLinkInMatches
    },
    smartLinks: {
        regexStorage: globalThis.localStorage
    }
};
const $cdcb92bd6c40797f$export$3374c63d7715b4ce = new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, false));
const $cdcb92bd6c40797f$var$streamingAdfEncoder = new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, true));
const $cdcb92bd6c40797f$export$53ded0b846f45216 = (content, streaming = false, isExperimentEnabled)=>{
    if ($cdcb92bd6c40797f$export$d801201dc544181(content)) return content;
    if (isExperimentEnabled) return new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, streaming, isExperimentEnabled)).encode(content);
    return streaming ? $cdcb92bd6c40797f$var$streamingAdfEncoder.encode(content) : $cdcb92bd6c40797f$export$3374c63d7715b4ce.encode(content);
};
const $cdcb92bd6c40797f$export$cc924f6f2bb49b7c = (content)=>{
    const contentNodes = [];
    let lastIndex = 0;
    let match;
    let promptLength = 0;
    // Find all skill tag matches
    const matches = [];
    while((match = (0, $ij2FZ.ROVO_SKILL_TAG_PATTERN).exec(content)) !== null)matches.push({
        index: match.index,
        skillSlug: match[1],
        length: match[0].length
    });
    // Process the string segment by segment
    for(let i = 0; i < matches.length; i++){
        const currentMatch = matches[i];
        const matchStart = currentMatch.index;
        const matchEnd = matchStart + currentMatch.length;
        // Add text before the skill tag (if any)
        if (matchStart > lastIndex) {
            const textBefore = content.substring(lastIndex, matchStart);
            if (textBefore) {
                contentNodes.push({
                    type: 'text',
                    text: textBefore
                });
                promptLength += textBefore.length;
            }
        }
        // Add the skill tag as inlineExtension
        contentNodes.push({
            type: 'inlineExtension',
            attrs: {
                extensionKey: (0, $ij2FZ.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                extensionType: (0, $ij2FZ.ROVO_SKILL_EXTENSION_TYPE),
                parameters: {
                    slug: currentMatch.skillSlug
                }
            }
        });
        promptLength += 1;
        lastIndex = matchEnd;
    }
    // Add remaining text after the last match (if any)
    if (lastIndex < content.length) {
        const textAfter = content.substring(lastIndex);
        if (textAfter) {
            contentNodes.push({
                type: 'text',
                text: textAfter
            });
            promptLength += textAfter.length;
        }
    }
    // If no matches were found, return the entire string as text
    if (contentNodes.length === 0) {
        contentNodes.push({
            type: 'text',
            text: content
        });
        promptLength += content.length;
    }
    return {
        adf: {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: contentNodes
                }
            ]
        },
        promptLength: promptLength
    };
};
module.exports["isAdfContent"] = $cdcb92bd6c40797f$export$d801201dc544181;
module.exports["appendContent"] = $cdcb92bd6c40797f$export$a236f395afded7e0;
module.exports["encodeAdf"] = $cdcb92bd6c40797f$export$53ded0b846f45216;
module.exports["encodeSkillPromptToAdf"] = $cdcb92bd6c40797f$export$cc924f6f2bb49b7c;

});

parcelRegister("cdw4J", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e1accb675e158e1c$var$animation = null;
const $e1accb675e158e1c$var$animation1 = null;
const $e1accb675e158e1c$var$animation2 = null;
const $e1accb675e158e1c$var$dot1 = null;
const $e1accb675e158e1c$var$dot2 = null;
const $e1accb675e158e1c$var$dot3 = null;
const $e1accb675e158e1c$var$animatedOpacity = null;
const $e1accb675e158e1c$export$c0e6915bcce7d1d0 = ({ isAnimated: isAnimated = true })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44v1gpk",
                    isAnimated && $e1accb675e158e1c$var$animatedOpacity
                ]),
                d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44v18gg",
                    isAnimated && $e1accb675e158e1c$var$animatedOpacity
                ]),
                d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44voqx9",
                    isAnimated && $e1accb675e158e1c$var$animatedOpacity
                ]),
                d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
                fill: "#FCA700"
            })
        ]
    });
};
module.exports["EllipsesAnimation"] = $e1accb675e158e1c$export$c0e6915bcce7d1d0;

});

parcelRegister("gmO0J", function(module, exports) {
$parcel$export(module.exports, "RovoThinkingIndicator", () => (parcelRequire("6jnYQ")).RovoThinkingIndicator);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $hezkK = parcelRequire("hezkK");


var $hQeYQ = parcelRequire("hQeYQ");


var $aisF3 = parcelRequire("aisF3");


var $6jnYQ = parcelRequire("6jnYQ");

const $185ac8354d914567$var$isForgeAgent = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE';
const $185ac8354d914567$var$styles = {
    container: "",
    stepContainerWithIndicator: "_18u01jfw",
    stepContainerWithoutIndicator: "_18u0u2gc"
};
const $185ac8354d914567$var$ExpandableTrace = ({ trace: trace, isLastItem: isLastItem, placeholder: placeholder = false })=>{
    const { title: title, defaultExpanded: defaultExpanded = false, content: content = null, status: status } = trace;
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(defaultExpanded);
    const setIsExpandedValue = (0, $42omo.useCallback)(()=>{
        setIsExpanded((prev)=>!prev);
    }, [
        setIsExpanded
    ]);
    const commonProps = {
        title: title,
        isLastItem: isLastItem,
        status: status
    };
    return content ? /*#__PURE__*/ (0, $l998X.jsx)((0, $hQeYQ.ExpandableLoadingStep), {
        isExpanded: isExpanded,
        onClick: setIsExpandedValue,
        ...commonProps,
        children: content
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $aisF3.LoadingStep), {
        ...commonProps,
        placeholder: placeholder
    });
};
const $185ac8354d914567$export$1e7724c434f1ba76 = ({ traces: traces, disableAnimation: disableAnimation, agent: agent, hideThinkingIndicator: hideThinkingIndicator = false, ...props })=>{
    const thinkingText = props.thinkingText ?? '';
    const agentAvatarOrUndefined = agent ? /*#__PURE__*/ (0, $l998X.jsx)((0, $hezkK.AgentAvatar), {
        agentNamedId: agent.external_config_reference ?? agent.named_id,
        agentId: agent.id,
        agentIdentityAccountId: agent.identity_account_id,
        size: "small",
        showBorder: false,
        isForgeAgent: $185ac8354d914567$var$isForgeAgent(agent),
        forgeAgentIconUrl: agent.icon
    }) : undefined;
    const needsPlaceholder = traces?.some((t)=>t.content);
    const showThinkingIndicator = props.thinkingText && !hideThinkingIndicator;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $185ac8354d914567$var$styles.container,
        children: [
            showThinkingIndicator ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6jnYQ.RovoThinkingIndicator), {
                title: thinkingText,
                isAnimated: !disableAnimation,
                icon: agentAvatarOrUndefined
            }) : null,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)(!!showThinkingIndicator ? $185ac8354d914567$var$styles.stepContainerWithIndicator : $185ac8354d914567$var$styles.stepContainerWithoutIndicator),
                children: traces ? traces.map((trace, i)=>{
                    const isLastItem = i === traces.length - 1;
                    return /*#__PURE__*/ (0, $l998X.jsx)($185ac8354d914567$var$ExpandableTrace, {
                        trace: trace,
                        isLastItem: isLastItem,
                        placeholder: needsPlaceholder
                    }, `${trace.title}-${trace.status}`);
                }) : null
            })
        ]
    });
};
module.exports["MessageLoading"] = $185ac8354d914567$export$1e7724c434f1ba76;

});

parcelRegister("hQeYQ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $g9Srd = parcelRequire("g9Srd");

var $fT2ta = parcelRequire("fT2ta");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");


var $aisF3 = parcelRequire("aisF3");


var $cqWxz = parcelRequire("cqWxz");

const $a05558c6f615f8ad$var$styles = {
    titleContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _2rko1qi0 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1yb4 _1bsb1osq _bfhk1j28 _y3gn1e5h",
    expandablePressable: "_v564mfn2 _1tkezwfg _irr31dpa _d0altlke",
    chevronContainer: "_2hwxu2gc",
    expandedContent: "_1bsb1osq _ca0qu2gc _u5f3u2gc _n3td1b66 _19bvu2gc _1nmz1hna"
};
const $a05558c6f615f8ad$export$aa6e6454f6f47e48 = ({ title: title, onClick: onClick, testId: testId = 'rovo-expandable-step', isExpanded: isExpanded = false, isLastItem: isLastItem = false, status: status, children: children })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $aisF3.LoadingStepContainer), {
        testId: testId,
        status: status,
        isLastItem: isLastItem,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
                xcss: (0, $1Whri.cx)($a05558c6f615f8ad$var$styles.titleContainer, $a05558c6f615f8ad$var$styles.expandablePressable),
                testId: testId,
                onClick: onClick,
                "data-expanded": isExpanded,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aisF3.LoadingStepTitle), {
                            title: title
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $a05558c6f615f8ad$var$styles.chevronContainer,
                        children: isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            label: formatMessage((0, $cqWxz.default).collapseIconLabel),
                            size: "small",
                            color: "var(--ds-icon-subtle, #505258)"
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                            label: formatMessage((0, $cqWxz.default).expandIconLabel),
                            size: "small",
                            color: "var(--ds-icon-subtle, #505258)"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
                children: isExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
                    entranceDirection: "top",
                    exitDirection: "top",
                    duration: "medium",
                    children: (motionProps)=>{
                        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            ...motionProps,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $a05558c6f615f8ad$var$styles.expandedContent,
                                children: children
                            })
                        });
                    }
                })
            })
        ]
    });
};
module.exports["ExpandableLoadingStep"] = $a05558c6f615f8ad$export$aa6e6454f6f47e48;

});

parcelRegister("aisF3", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $fT2ta = parcelRequire("fT2ta");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $ksLgp = parcelRequire("ksLgp");

const $e87a3f4b795675a6$var$styles = {
    root: "_11c82smr _1bsb1osq _gy1p1b66 _1bah1y6m _syazazsu",
    titleContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _2rko1qi0 _1e0c1txw _2lx2vrvc _4cvr1h6o _ca0qu2gc _u5f3u2gc _19bvu2gc _n3tdu2gc",
    iconContainer: "_ca0qu2gc _19pkv77o _1e0c1txw _2lx21bp4",
    contentContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4",
    verticalRule: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1h6d1l7x _1dqonqa1 _189ee4h9 _1bsbidpf _1tke1crf _1e0c1txw _18u0u2gc _2hwxu2gc _19pku2gc",
    loadingStepIconPlaceholder: "_1bsbgktf"
};
const $e87a3f4b795675a6$export$6e706d1f753e28ed = ({ testId: testId, children: children, xcss: xcss, status: status, isLastItem: isLastItem })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: (0, $1Whri.cx)($e87a3f4b795675a6$var$styles.root, xcss),
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $e87a3f4b795675a6$var$styles.iconContainer,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ksLgp.StatusIndicator), {
                        status: status
                    }),
                    !isLastItem && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $e87a3f4b795675a6$var$styles.verticalRule
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $e87a3f4b795675a6$var$styles.contentContainer,
                children: children
            })
        ]
    });
};
const $e87a3f4b795675a6$export$179b516a1b61c27 = ({ title: title })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $e87a3f4b795675a6$var$styles.titleContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            size: "medium",
            color: "color.text.subtle",
            children: title
        })
    });
};
const $e87a3f4b795675a6$export$ed7124825ced7ddc = ({ title: title, testId: testId = 'rovo-loading-step', isLastItem: isLastItem = false, status: status, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
        duration: "large",
        entranceDirection: "bottom",
        children: (props)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                ...props,
                children: /*#__PURE__*/ (0, $l998X.jsx)($e87a3f4b795675a6$export$6e706d1f753e28ed, {
                    testId: testId,
                    status: status,
                    isLastItem: isLastItem,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)($e87a3f4b795675a6$export$179b516a1b61c27, {
                                title: title
                            }),
                            placeholder && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $e87a3f4b795675a6$var$styles.loadingStepIconPlaceholder
                            })
                        ]
                    })
                })
            })
    });
};
module.exports["LoadingStepContainer"] = $e87a3f4b795675a6$export$6e706d1f753e28ed;
module.exports["LoadingStepTitle"] = $e87a3f4b795675a6$export$179b516a1b61c27;
module.exports["LoadingStep"] = $e87a3f4b795675a6$export$ed7124825ced7ddc;

});

parcelRegister("ksLgp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $3gddQ = parcelRequire("3gddQ");


var $a3fRD = parcelRequire("a3fRD");


var $eXmBZ = parcelRequire("eXmBZ");


var $3sFtD = parcelRequire("3sFtD");


var $ebrpi = parcelRequire("ebrpi");


var $6DSrS = parcelRequire("6DSrS");


var $9hlns = parcelRequire("9hlns");


var $9Y4C8 = parcelRequire("9Y4C8");

const $ab83698aa24eebb9$export$b4f88f0ca5784eef = ({ status: status, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    switch(status){
        case 'loading':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                size: "small",
                testId: testId,
                interactionName: "loading-status-indicator-spinner"
            });
        case 'success':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                label: formatMessage((0, $9Y4C8.default).success),
                size: "medium",
                color: "var(--ds-icon-success, #6A9A23)",
                testId: testId
            });
        case 'info':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                label: formatMessage((0, $9Y4C8.default).info),
                size: "medium",
                color: "var(--ds-icon-information, #357DE8)",
                testId: testId
            });
        case 'error':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: formatMessage((0, $9Y4C8.default).error),
                size: "medium",
                color: "var(--ds-icon-danger, #C9372C)",
                testId: testId
            });
        case 'warning':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
                label: formatMessage((0, $9Y4C8.default).warning),
                size: "medium",
                color: "var(--ds-icon-warning, #E06C00)",
                testId: testId
            });
        case 'discovery':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3gddQ))), {
                label: formatMessage((0, $9Y4C8.default).discovery),
                size: "medium",
                color: "var(--ds-icon-discovery, #AF59E1)",
                testId: testId
            });
        case 'to-do':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6DSrS))), {
                label: formatMessage((0, $9Y4C8.default).todo),
                size: "medium",
                testId: testId
            });
        // explicitly return nothing from default case.
        // This shouldn't happen since `status` is required, but it could if someone casts incorrectly or data is undefined from the server.
        default:
    }
};
module.exports["StatusIndicator"] = $ab83698aa24eebb9$export$b4f88f0ca5784eef;

});

parcelRegister("9Y4C8", function(module, exports) {
$parcel$export(module.exports, "default", () => $a054a6fce392dfbb$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $a054a6fce392dfbb$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    success: {
        id: "ai-mate.loading-status-indicator.success",
        defaultMessage: "Success"
    },
    loading: {
        id: "ai-mate.loading-status-indicator.loading",
        defaultMessage: "Loading"
    },
    error: {
        id: "ai-mate.loading-status-indicator.error",
        defaultMessage: "Error"
    },
    info: {
        id: "ai-mate.loading-status-indicator.info",
        defaultMessage: "Information"
    },
    warning: {
        id: "ai-mate.loading-status-indicator.warning",
        defaultMessage: "Warning"
    },
    discovery: {
        id: "ai-mate.loading-status-indicator.discovery",
        defaultMessage: "Discovery"
    },
    todo: {
        id: "ai-mate.loading-status-indicator.todo",
        defaultMessage: "To do"
    }
});

});

parcelRegister("cqWxz", function(module, exports) {
$parcel$export(module.exports, "default", () => $83f7bd9d9dbbd64a$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $83f7bd9d9dbbd64a$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    expandIconLabel: {
        id: "ai-mate.chat-history.loading-state.expand-icon",
        defaultMessage: "Expand"
    },
    collapseIconLabel: {
        id: "ai-mate.chat-history.loading-state.collapse-icon",
        defaultMessage: "Collapse"
    }
});

});

parcelRegister("6jnYQ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $cdw4J = parcelRequire("cdw4J");


var $jO3S6 = parcelRequire("jO3S6");

const $079af3e939037f4e$var$styles = {
    root: "_4t3i1tcg _1e0c1txw _2lx2vrvc _1bah1e5h _1n261g80 _4cvr1h6o",
    iconContainer: "_zulpu2gc _2hwxv77o _1e0c1txw _4cvr1h6o",
    text: "_11c82smr _16jlkb7n _1o9zkb7n _i0dlf1ug _syazi7uo _1nmz1hna",
    ellipsesContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
};
const $079af3e939037f4e$var$getIcon = (icon)=>{
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(icon)) return icon;
    else if (icon) {
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $jO3S6.LazyAnimatedRovoIcon), {
            alt: "Rovo",
            testId: "rovo-loading-animation",
            width: "24px",
            height: "24px"
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
            label: "",
            shouldUseHexLogo: true,
            size: "small"
        });
    }
    return null;
};
const $079af3e939037f4e$export$cc468b3595726b51 = ({ title: title, isAnimated: isAnimated = true, icon: icon = true, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $079af3e939037f4e$var$styles.root,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $079af3e939037f4e$var$styles.iconContainer,
                children: [
                    $079af3e939037f4e$var$getIcon(icon),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $079af3e939037f4e$var$styles.text,
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $079af3e939037f4e$var$styles.ellipsesContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cdw4J.EllipsesAnimation), {
                    isAnimated: isAnimated
                })
            })
        ]
    });
};
module.exports["RovoThinkingIndicator"] = $079af3e939037f4e$export$cc468b3595726b51;

});

parcelRegister("i08Mr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $luTXj = parcelRequire("luTXj");

const $e459ef83dafb04f4$var$initialState = {
    fullScreen: false,
    externalEmbed: false,
    customHandlers: {
        handleDeepLinkClick: undefined,
        handleSubmitSmartCreate: ()=>{}
    },
    isBitbucketBetaEnabled: false,
    stagingAreaRef: undefined,
    promptInputDroppableUrls: undefined,
    enableBrowserContextBanner: false,
    browserContextSanitizer: undefined,
    elements: {
        closeButton: true,
        newChatButton: true,
        fullscreenButton: true,
        createAgentButton: true,
        browseAgentsButton: true,
        agentsMenu: true,
        navbar: true,
        mainChatHeader: true,
        stagingAreaEnabled: false,
        voiceDictationButton: false,
        chatModeMenuButton: true
    },
    // ChatRefreshV1Exp
    isRenderRefreshEnabled: false,
    isNewInputEnabled: false,
    isNewNavigationEnabled: false,
    isNewEmptyScreenEnabled: false,
    dynamicConfig: {
        rovoChatRefreshV2Config: (0, $luTXj.initialState)
    }
};
const $e459ef83dafb04f4$export$ab340e857ee89c62 = $e459ef83dafb04f4$var$initialState;
const $e459ef83dafb04f4$var$uiConfig = /*#__PURE__*/ (0, $42omo.createContext)($e459ef83dafb04f4$var$initialState);
const $e459ef83dafb04f4$export$3063519296e335bf = $e459ef83dafb04f4$var$uiConfig.Provider;
const $e459ef83dafb04f4$export$e83755c3ab7a4493 = ()=>(0, $42omo.useContext)($e459ef83dafb04f4$var$uiConfig);
const $e459ef83dafb04f4$export$3e623b13d2da727a = (config)=>{
    // Allow fullscreen override for branch deploy testing purposes
    const processedConfig = localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $dh538.fg)('rovo_chat_show_local_frontend_components') ? {
        ...config,
        fullScreen: true
    } : config;
    const isRolloutInJiraEnabled = (0, $c6GJD.default).getExperimentValue('jira_ai_rovo_button', 'treatment', 'A') === 'B';
    const rovoChatRefreshV2Config = (0, $luTXj.getChatRefreshV2DynamicConfig)({
        isRolloutInJiraEnabled: isRolloutInJiraEnabled
    });
    return {
        ...{
            ...$e459ef83dafb04f4$var$initialState,
            ...processedConfig,
            enableBrowserContextBanner: processedConfig?.enableBrowserContextBanner ?? $e459ef83dafb04f4$var$initialState.enableBrowserContextBanner,
            browserContextSanitizer: processedConfig?.browserContextSanitizer,
            elements: {
                ...$e459ef83dafb04f4$var$initialState.elements,
                ...processedConfig?.elements
            },
            promptInputDroppableUrls: processedConfig?.promptInputDroppableUrls
        },
        isRenderRefreshEnabled: isRolloutInJiraEnabled || (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v1_experiment', 'isRenderRefreshEnabled', false),
        isNewInputEnabled: isRolloutInJiraEnabled || (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v1_experiment', 'isNewInputEnabled', false),
        isNewNavigationEnabled: isRolloutInJiraEnabled || (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v1_experiment', 'isNewNavigationEnabled', false),
        isNewEmptyScreenEnabled: isRolloutInJiraEnabled || (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v1_experiment', 'isNewEmptyScreenEnabled', false),
        dynamicConfig: {
            ...$e459ef83dafb04f4$var$initialState.dynamicConfig,
            rovoChatRefreshV2Config: {
                ...rovoChatRefreshV2Config
            }
        }
    };
};
module.exports["UIConfigProvider"] = $e459ef83dafb04f4$export$3063519296e335bf;
module.exports["useUIConfig"] = $e459ef83dafb04f4$export$e83755c3ab7a4493;
module.exports["createUIConfig"] = $e459ef83dafb04f4$export$3e623b13d2da727a;

});

parcelRegister("luTXj", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");

const $c3ee1b3abf16f6b9$export$d4c72bab9d6cc13a = {
    isMinimodalHeightAnimationEnabled: false,
    isDeepResearchEnabled: false,
    isNewMessagesEnabled: false,
    isNewMessagesActionsEnabled: false,
    isNewAllConversationScreenEnabled: false,
    isNewInputPromptTypeaheadEnabled: false,
    isReasoningOptionsV2Enabled: false,
    isReasoningStickyOptionEnabled: false,
    isPromptLibraryEnabled: false,
    isNewLoadingStateEnabled: false,
    isUpdatedAgentMenuDropdownEnabled: false,
    isSpinnerOverlayConversationIconEnabled: false
};
const $c3ee1b3abf16f6b9$export$6ae9a55e1ff15aba = ({ isRolloutInJiraEnabled: isRolloutInJiraEnabled })=>{
    const rovoChatRefreshV2Config = isRolloutInJiraEnabled || (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v1_experiment', 'isRenderRefreshEnabled', false) ? $c3ee1b3abf16f6b9$var$getChatRefreshV2ConfigFromExperimentParameters() : $c3ee1b3abf16f6b9$export$d4c72bab9d6cc13a;
    return rovoChatRefreshV2Config;
};
const $c3ee1b3abf16f6b9$var$getChatRefreshV2ConfigFromExperimentParameters = ()=>{
    return {
        isMinimodalHeightAnimationEnabled: false,
        isDeepResearchEnabled: (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isDeepResearchEnabled', false),
        isNewMessagesEnabled: (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isNewMessagesEnabled', false),
        isNewMessagesActionsEnabled: (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isNewMessagesActionsEnabled', false),
        isNewAllConversationScreenEnabled: false,
        isNewInputPromptTypeaheadEnabled: false,
        isDynamicStartersAPIEnabled: false,
        isReasoningOptionsV2Enabled: false,
        isReasoningStickyOptionEnabled: false,
        isPromptLibraryEnabled: (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isPromptLibraryEnabled', false),
        isNewLoadingStateEnabled: (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isNewLoadingStateEnabled', false),
        isUpdatedAgentMenuDropdownEnabled: (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isUpdatedAgentMenuDropdownEnabled', false),
        isSpinnerOverlayConversationIconEnabled: false
    };
};
module.exports["initialState"] = $c3ee1b3abf16f6b9$export$d4c72bab9d6cc13a;
module.exports["getChatRefreshV2DynamicConfig"] = $c3ee1b3abf16f6b9$export$6ae9a55e1ff15aba;

});

parcelRegister("1Rod9", function(module, exports) {

var $9ciHB = parcelRequire("9ciHB");

function $33d6ff45ac878a78$export$63102b0cbe181144(featureFlags) {
    const normalizedFeatureFlags = (0, $9ciHB.normalizeFeatureFlags)(featureFlags);
    // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    return {
        ...normalizedFeatureFlags,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: false,
        errorBoundaryDocStructure: false,
        synchronyErrorDocStructure: false,
        enableViewUpdateSubscription: false,
        collabAvatarScroll: false,
        twoLineEditorToolbar: false,
        disableSpellcheckByBrowser: undefined
    };
}
module.exports["createFeatureFlagsFromProps"] = $33d6ff45ac878a78$export$63102b0cbe181144;

});

parcelRegister("aGjYc", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7W8i8 = parcelRequire("7W8i8");

const $9a76668fa978df44$export$6af3d18059afaa9e = 'outOfDate';
const $9a76668fa978df44$var$logger = (0, $7W8i8.getLogger)('comment-draft-utils');
const $9a76668fa978df44$var$getKey = (type, mode)=>{
    switch(type){
        case 'edit-inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_REPLY;
        case 'inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_REPLY;
        case 'page':
        default:
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_REPLY;
    }
};
const $9a76668fa978df44$export$a4f0a5ceed96eae8 = (adf, pageId, type, mode)=>{
    let b64EncodedDraftObj = null;
    const key = $9a76668fa978df44$var$getKey(type, mode);
    const draftObj = JSON.stringify({
        pageId: pageId,
        adf: adf
    });
    try {
        b64EncodedDraftObj = btoa(draftObj);
    } catch (e) {
        $9a76668fa978df44$var$logger.error`Unable to save draft object for ${pageId}; ${e}`;
    }
    if (b64EncodedDraftObj === null) return false;
    // Store the draft with a 72 hour expiration
    (0, $17wUi.confluenceLocalStorageInstance).setItem(key, b64EncodedDraftObj, 259200);
    return true;
};
const $9a76668fa978df44$export$e7cfba777a0d590e = (type, mode)=>{
    const key = $9a76668fa978df44$var$getKey(type, mode);
    (0, $17wUi.confluenceLocalStorageInstance).removeItem(key);
};
const $9a76668fa978df44$export$5fff31d3d3e1ad8b = (pageId, type, mode)=>Boolean($9a76668fa978df44$export$7c0604f3bd51258a(pageId, type, mode));
const $9a76668fa978df44$export$7c0604f3bd51258a = (pageId, type, mode)=>{
    let draftObj = null;
    const key = $9a76668fa978df44$var$getKey(type, mode);
    const b64EncodedDraftObj = (0, $17wUi.confluenceLocalStorageInstance).getItem(key);
    if (b64EncodedDraftObj !== null) {
        try {
            draftObj = JSON.parse(atob(b64EncodedDraftObj));
        } catch (e) {
            $9a76668fa978df44$var$logger.error`Unable to get draft object for ${pageId}; ${e}`;
        }
        if (draftObj) {
            const { pageId: draftPageId, adf: adf } = draftObj;
            // If the pageId matches, return the ADF, otherwise return null
            if (draftPageId === pageId) return adf;
        }
    }
    return null;
};
module.exports["OUT_OF_DATE_KEY"] = $9a76668fa978df44$export$6af3d18059afaa9e;
module.exports["saveCommentDraft"] = $9a76668fa978df44$export$a4f0a5ceed96eae8;
module.exports["clearCommentDraft"] = $9a76668fa978df44$export$e7cfba777a0d590e;
module.exports["hasCommentDraft"] = $9a76668fa978df44$export$5fff31d3d3e1ad8b;
module.exports["getCommentDraft"] = $9a76668fa978df44$export$7c0604f3bd51258a;

});

parcelRegister("5pQ1Y", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $676464c7222bdee0$export$d84a6ddaa8e6e9d9 = /*#__PURE__*/ (0, $42omo.createContext)({
    refetchContent: false
});
$676464c7222bdee0$export$d84a6ddaa8e6e9d9.displayName = 'ContentRefetchContext';
const $676464c7222bdee0$export$dfd2d999f6a2731 = /*#__PURE__*/ (0, $42omo.createContext)({
    setRefetchContent: ()=>{}
});
$676464c7222bdee0$export$dfd2d999f6a2731.displayName = 'ContentRefetchDispatchContext';
const $676464c7222bdee0$export$cfa813593f7b7ba = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children } = t0;
    const [refetchContent, setRefetchContent] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== refetchContent) {
        t1 = {
            refetchContent: refetchContent
        };
        $[0] = refetchContent;
        $[1] = t1;
    } else t1 = $[1];
    const providerValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setRefetchContent: (shouldRefetchContent)=>setRefetchContent(shouldRefetchContent)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchProviderValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$dfd2d999f6a2731.Provider, {
            value: dispatchProviderValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== providerValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$d84a6ddaa8e6e9d9.Provider, {
            value: providerValue
        }, t3);
        $[5] = providerValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children })=>{
    const [refetchContent, setRefetchContent] = (0, $42omo.useState)(false);
    const providerValue = (0, $42omo.useMemo)(()=>({
            refetchContent: refetchContent
        }), [
        refetchContent
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setRefetchContent: (shouldRefetchContent)=>setRefetchContent(shouldRefetchContent)
        }), [
        setRefetchContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$d84a6ddaa8e6e9d9.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$dfd2d999f6a2731.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $676464c7222bdee0$export$68e22604851d391b = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    return (0, $42omo.useContext)($676464c7222bdee0$export$d84a6ddaa8e6e9d9);
} : ()=>(0, $42omo.useContext)($676464c7222bdee0$export$d84a6ddaa8e6e9d9);
const $676464c7222bdee0$export$8ebf7a2378ada555 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    return (0, $42omo.useContext)($676464c7222bdee0$export$dfd2d999f6a2731);
} : ()=>(0, $42omo.useContext)($676464c7222bdee0$export$dfd2d999f6a2731);
module.exports["ContentRefetchProvider"] = $676464c7222bdee0$export$cfa813593f7b7ba;
module.exports["useContentRefetch"] = $676464c7222bdee0$export$68e22604851d391b;
module.exports["useContentRefetchDispatch"] = $676464c7222bdee0$export$8ebf7a2378ada555;

});

parcelRegister("ag51I", function(module, exports) {

var $49xGN = parcelRequire("49xGN");


var $308Wd = parcelRequire("308Wd");

// This hook returns a mutation function to create a new comment on an object. Because the new
// Comments Data Manager caches all the data for comments in Relay, we need to define the mutation
// here so that the cache can be updated fully when a new comment is created - and that means the
// mutation needs to return the full comment data structure that we are using in the returned query
// part of the mutation.  Since that returned query is quite large, we define it here in its own
// hook to avoid having it in many places in the codebase - which makes the code harder to read and
// could lead to the multiple copies getting out of sync.
// Data Mutation Definition:
// Unfortunately our Relay-friendly type generation tools don't support using GQL fragments yet -
// but in order to keep the definition of the comment fields in sync (so the cache update fragment
// is always in sync with the full query) we will need to manually make any changes to one
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
const $8cba0eaacdb447e5$var$CreateObjectCommentMutation = (0, $49xGN.default);
const $8cba0eaacdb447e5$export$14bad9f468eeedfb = ()=>{
    const [createObjectCommentFn] = (0, $308Wd.useMutationInterop)($8cba0eaacdb447e5$var$CreateObjectCommentMutation);
    return createObjectCommentFn;
};
const $8cba0eaacdb447e5$export$b178188bfecc9b39 = (commentData)=>{
    return commentData ? {
        ...commentData,
        replies: []
    } : undefined;
};
module.exports["useCreateObjectCommentMutation"] = $8cba0eaacdb447e5$export$14bad9f468eeedfb;
module.exports["addEmptyObjectRepliesArray"] = $8cba0eaacdb447e5$export$b178188bfecc9b39;

});

parcelRegister("49xGN", function(module, exports) {
/**
 * @generated SignedSource<<d53041a422fa44843a4488292d1f25f9>>
 * @relayHash 7f12467cda3e83ee49eea8930bbe340a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9ff69767642d0ed166c9c81c48269bc6cb51599ae4efa9c442d98df82f66a484
const $2b92f41c42f85596$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v10 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v11 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v13 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "createFooterComment",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v8 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "container",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineMarkerRef"
                                },
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "inlineResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDangling"
                                        },
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineText"
                                }
                            ],
                            "type": "InlineComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "childType",
                            "value": "comment"
                        },
                        {
                            "kind": "Literal",
                            "name": "contentType",
                            "value": "page"
                        },
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        }
                    ],
                    "concreteType": "ReactionsSummaryResponse",
                    "kind": "LinkedField",
                    "name": "reactionsSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "ari"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "containerAri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "reactionsCount"
                        },
                        {
                            "concreteType": "ReactionsSummaryForEmoji",
                            "kind": "LinkedField",
                            "name": "reactionsSummaryForEmoji",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "emojiId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "reacted"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v5 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateObjectCommentMutation",
            "selections": v13 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateObjectCommentMutation",
            "selections": v13 /*: any*/ 
        },
        "params": {
            "cacheID": "7f12467cda3e83ee49eea8930bbe340a",
            "id": "9ff69767642d0ed166c9c81c48269bc6cb51599ae4efa9c442d98df82f66a484",
            "metadata": {},
            "name": "useCreateObjectCommentMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateObjectCommentMutation($pageId:ID!,$cloudId:ID!,$input:CreateCommentInput!){createFooterComment(cloudId:$cloudId,input:$input){id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}"
        }
    };
}();
$2b92f41c42f85596$var$node.hash = "61d63d0d1994300212ce220d709f174b";
var $2b92f41c42f85596$export$2e2bcd8739ae039 = $2b92f41c42f85596$var$node;
module.exports["default"] = $2b92f41c42f85596$export$2e2bcd8739ae039;

});

parcelRegister("famWw", function(module, exports) {
/* AddCommentPromptButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $c6fYi = parcelRequire("c6fYi");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");


var $9wGTI = parcelRequire("9wGTI");


var $dANtQ = parcelRequire("dANtQ");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");

const $6aab88ace7ca0350$var$styles = {
    addCommentButtonStyle: "_1yt4ze3t _2rko12b0 _11c82smr _1e0c1txw _1tkezwfg _19bvutpp _u5f3utpp _1bah1h6o _4cvr1h6o _syazazsu",
    enabledStyle: "_bfhksm61 _d0altlke _irr31dpa",
    disabledStyle: "_bfhkby5v _80om13gf _syaz1gmx",
    fullWidthStyle: "_1bsb1osq"
};
const $6aab88ace7ca0350$var$i18n = (0, $cgtv4.defineMessages)({
    addCommentPromptText: {
        id: "comments-common.add-comment-prompt.text",
        defaultMessage: "Add a comment"
    },
    addCommentPromptAriaLabel: {
        id: "comments-common.add-comment-prompt.aria-label",
        defaultMessage: "Add a general comment"
    }
});
const $6aab88ace7ca0350$export$caf1bbdc1c7b1a40 = ({ onClick: onClick, autofocusRef: autofocusRef, shouldFitContainer: shouldFitContainer, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId || '');
    const buttonRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (autofocusRef.current) {
            buttonRef.current?.focus({
                preventScroll: true
            });
            autofocusRef.current = false;
        }
    }, [
        autofocusRef
    ]);
    const allowAddComment = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? canAddComments : true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($6aab88ace7ca0350$var$styles.addCommentButtonStyle, !allowAddComment ? $6aab88ace7ca0350$var$styles.disabledStyle : $6aab88ace7ca0350$var$styles.enabledStyle, shouldFitContainer && $6aab88ace7ca0350$var$styles.fullWidthStyle),
        isDisabled: !allowAddComment,
        onClick: onClick,
        testId: testId,
        ref: buttonRef,
        ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
            'aria-label': formatMessage($6aab88ace7ca0350$var$i18n.addCommentPromptAriaLabel)
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6fYi))), {
        label: formatMessage($6aab88ace7ca0350$var$i18n.addCommentPromptText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), null, formatMessage($6aab88ace7ca0350$var$i18n.addCommentPromptText))));
};
module.exports["AddCommentPromptButton"] = $6aab88ace7ca0350$export$caf1bbdc1c7b1a40;

});

parcelRegister("kKAQX", function(module, exports) {
/**
 * @generated SignedSource<<c5008fda444ba5427db7f5c49b38d99b>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $485d7166d746f7d6$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $485d7166d746f7d6$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $485d7166d746f7d6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["ContentRepresentation"] = $485d7166d746f7d6$export$f4016897b165b6d5;
module.exports["Platform"] = $485d7166d746f7d6$export$2dffd0b5373a4389;

});

parcelRegister("87CZC", function(module, exports) {

var $abN8T = parcelRequire("abN8T");


var $7W8i8 = parcelRequire("7W8i8");


var $9rE3H = parcelRequire("9rE3H");


var $eg9xl = parcelRequire("eg9xl");


var $cD1qu = parcelRequire("cD1qu");


var $irVI7 = parcelRequire("irVI7");


var $56QzY = parcelRequire("56QzY");


var $en1dX = parcelRequire("en1dX");


var $2eC70 = parcelRequire("2eC70");


var $2i3To = parcelRequire("2i3To");


var $ftXPY = parcelRequire("ftXPY");

const $80b47fa0b569ef69$var$logger = (0, $7W8i8.getLogger)('page-comments-queries');
const $80b47fa0b569ef69$export$a02bedef5e94d20c = (actionType, queryVariables, isReactionsEnabled, commentId)=>(cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        const { pageId: pageId, type: type } = queryVariables;
        try {
            const singleType = type && type.length >= 1 ? type[0] : undefined;
            const consistentQueryVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                pageId: pageId,
                type: singleType
            });
            // Update the comments panel data
            const commentsPanelCacheResponse = cache.readQuery({
                query: (0, $eg9xl.ActiveCommentsQuery),
                variables: consistentQueryVariables
            });
            if (commentsPanelCacheResponse) {
                const cacheDataClone = {
                    ...commentsPanelCacheResponse
                };
                const panelNodes = cacheDataClone?.comments?.nodes || [];
                if (actionType === 'delete') {
                    // Remove the returned commentId from the cache and reset it
                    const idxToRemove = panelNodes.findIndex((comment)=>comment?.id === commentId);
                    if (idxToRemove !== -1) panelNodes.splice(idxToRemove, 1);
                } else {
                    const mutationResult = {
                        ...result.data.createFooterComment,
                        replies: []
                    };
                    // Add the new reply entry to the cache and reset it
                    panelNodes.push(mutationResult);
                }
                cache.writeQuery({
                    query: (0, $eg9xl.ActiveCommentsQuery),
                    variables: consistentQueryVariables,
                    data: cacheDataClone
                });
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating comments panel cache for ${actionType} - ${err}`;
        }
        try {
            const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
            // Update the comments section data
            const commentsSectionCacheResponse = cache.readQuery({
                query: commentsSectionQuery,
                variables: {
                    contentId: pageId,
                    offset: '',
                    first: (0, $2i3To.DEFAULT_LIMIT)
                }
            });
            if (commentsSectionCacheResponse) {
                // grab the parent comment for the comments panel
                const commentSectionCacheDataClone = {
                    ...commentsSectionCacheResponse
                };
                const commentEdges = commentSectionCacheDataClone?.comments?.edges || [];
                if (actionType === 'delete') {
                    // Find the last index of the top level comment to delete
                    const indexToDelete = commentEdges?.findIndex((edge)=>edge?.node?.id === commentId);
                    if (indexToDelete !== -1) commentEdges.splice(indexToDelete, 1);
                } else {
                    const mutationResult = {
                        ...result.data.createFooterComment
                    };
                    // As far as I can tell, this is always called w/o reactions enabled
                    // This maps the mutation result we get to the cache object that's expected by the comments section query
                    const cacheCommentObject = {
                        id: mutationResult.id,
                        ancestors: [],
                        author: {
                            ...mutationResult.author,
                            type: 'known'
                        },
                        body: mutationResult.body,
                        contentStatus: mutationResult.contentStatus,
                        links: {
                            webui: mutationResult.links.webui,
                            // @ts-ignore
                            __typename: mutationResult.links.__typename
                        },
                        location: mutationResult.location,
                        parentId: mutationResult.parentId,
                        permissions: mutationResult.permissions,
                        version: {
                            ...mutationResult.version,
                            friendlyWhen: 'Just now',
                            // TODO: Maybe replace this with the actual date
                            by: {
                                type: 'user',
                                displayName: '',
                                accountId: '',
                                __typename: 'User'
                            },
                            __typename: 'Version'
                        },
                        __typename: 'Comment'
                    };
                    // The cache will throw an error if we don't do this ¯\_(ツ)_/¯
                    const cacheContentDeepCopy = JSON.parse(JSON.stringify(cacheCommentObject));
                    const newEdge = {
                        cursor: (commentEdges.length - 1).toString(),
                        node: cacheContentDeepCopy,
                        __typename: 'CommentEdge'
                    };
                    const insertAfterIndex = commentEdges.length - 1;
                    // Put the new reply in the array
                    commentEdges.splice(insertAfterIndex + 1, 0, newEdge);
                }
                cache.writeQuery({
                    query: commentsSectionQuery,
                    variables: {
                        contentId: pageId,
                        offset: '',
                        first: (0, $2i3To.DEFAULT_LIMIT)
                    },
                    data: {
                        ...commentSectionCacheDataClone,
                        comments: {
                            ...commentSectionCacheDataClone.comments,
                            totalCount: commentEdges.length,
                            pageInfo: {
                                ...commentSectionCacheDataClone.comments?.pageInfo,
                                endCursor: actionType === 'delete' ? '' : (commentEdges.length - 1).toString(),
                                hasNextPage: false
                            },
                            edges: commentEdges
                        }
                    }
                });
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating comments section cache for ${actionType} - ${err}`;
        }
    };
const $80b47fa0b569ef69$export$bab18f310e4f95e8 = (actionType, queryVariables, parentCommentId, isReactionsEnabled, commentId)=>(cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        const { pageId: pageId, type: type } = queryVariables;
        try {
            const singleType = type && type.length >= 1 ? type[0] : undefined;
            const consistentQueryVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                pageId: pageId,
                type: singleType
            });
            // Update the comments panel data
            const commentsPanelCacheResponse = cache.readQuery({
                query: (0, $eg9xl.ActiveCommentsQuery),
                variables: consistentQueryVariables
            });
            if (commentsPanelCacheResponse) {
                // grab the parent comment for the comments panel
                const commentsPanelCacheData = Object.assign({}, commentsPanelCacheResponse);
                const commentsPanelParentComment = commentsPanelCacheData?.comments?.nodes?.find((comment)=>comment?.id === parentCommentId);
                if (commentsPanelParentComment) {
                    if (actionType === 'delete') {
                        // Remove the returned commentId from the cache and reset it
                        const idxToRemove = commentsPanelParentComment.replies.findIndex((reply)=>reply?.id === commentId);
                        if (idxToRemove !== -1) commentsPanelParentComment.replies.splice(idxToRemove, 1);
                    } else {
                        const mutationResult = result.data.createFooterComment;
                        // Add the new reply entry to the cache and reset it
                        commentsPanelParentComment.replies.push(mutationResult);
                    }
                    cache.writeQuery({
                        query: (0, $eg9xl.ActiveCommentsQuery),
                        variables: consistentQueryVariables,
                        data: commentsPanelCacheData
                    });
                }
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating comments panel cache for ${actionType} reply - ${err}`;
        }
        try {
            const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
            // Update the comments section data
            const commentsSectionCacheResponse = cache.readQuery({
                query: commentsSectionQuery,
                variables: {
                    contentId: pageId,
                    offset: '',
                    first: (0, $2i3To.DEFAULT_LIMIT)
                }
            });
            if (commentsSectionCacheResponse) {
                // grab the parent comment for the comments panel
                const commentsSectionCacheData = {
                    ...commentsSectionCacheResponse
                };
                const commentEdges = commentsSectionCacheData?.comments?.edges || [];
                const parentCommentIdx = commentEdges?.findIndex((commentEdge)=>commentEdge?.node?.id === parentCommentId);
                if (parentCommentIdx !== -1) {
                    if (actionType === 'delete') {
                        // Find the last index of the comment to delete
                        const indexToDelete = commentEdges?.findIndex((edge)=>edge?.node?.id === commentId);
                        if (indexToDelete !== -1) commentEdges.splice(indexToDelete, 1);
                    } else {
                        const mutationResult = {
                            ...result.data.createFooterComment
                        };
                        // As far as I can tell, this is always called w/o reactions enabled
                        // This maps the mutation result we get to the cache object that's expected by the comments section query
                        const cacheCommentObject = {
                            id: mutationResult.id,
                            ancestors: [
                                {
                                    id: mutationResult.parentId,
                                    __typename: 'Comment'
                                }
                            ],
                            author: {
                                ...mutationResult.author,
                                type: 'known'
                            },
                            body: mutationResult.body,
                            contentStatus: mutationResult.contentStatus,
                            links: {
                                webui: mutationResult.links.webui,
                                // @ts-ignore
                                __typename: mutationResult.links.__typename
                            },
                            location: mutationResult.location,
                            parentId: mutationResult.parentId,
                            permissions: mutationResult.permissions,
                            version: {
                                ...mutationResult.version,
                                friendlyWhen: 'Just now',
                                // TODO: Maybe replace this with the actual date
                                by: {
                                    type: 'user',
                                    displayName: '',
                                    accountId: '',
                                    __typename: 'User'
                                },
                                __typename: 'Version'
                            },
                            __typename: 'Comment'
                        };
                        // The cache will throw an error if we don't do this ¯\_(ツ)_/¯
                        const cacheContentDeepCopy = JSON.parse(JSON.stringify(cacheCommentObject));
                        const newEdge = {
                            cursor: (commentEdges.length - 1).toString(),
                            node: cacheContentDeepCopy,
                            __typename: 'CommentEdge'
                        };
                        // Find the last index of the thread to insert the reply
                        const threadLastCommentIdx = commentEdges?.findLastIndex((edge)=>edge?.node?.parentId === parentCommentId);
                        // If we can't find it, the parent has no replies
                        const insertAfterIndex = threadLastCommentIdx !== -1 ? threadLastCommentIdx : parentCommentIdx;
                        // Put the new reply in the array
                        commentEdges.splice(insertAfterIndex + 1, 0, newEdge);
                    }
                    cache.writeQuery({
                        query: commentsSectionQuery,
                        variables: {
                            contentId: pageId,
                            offset: '',
                            first: (0, $2i3To.DEFAULT_LIMIT)
                        },
                        data: {
                            ...commentsSectionCacheData,
                            comments: {
                                ...commentsSectionCacheData.comments,
                                totalCount: commentEdges.length,
                                pageInfo: {
                                    ...commentsSectionCacheData.comments?.pageInfo,
                                    endCursor: actionType === 'delete' ? '' : (commentEdges.length - 1).toString(),
                                    hasNextPage: false
                                },
                                edges: commentEdges
                            }
                        }
                    });
                }
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating general comments cache for ${actionType} reply - ${err}`;
        }
    };
const $80b47fa0b569ef69$export$aee61debd6ae89df = (commentId, newBody, pageId, isReactionsEnabled, cache, sessionDisplayName)=>{
    const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
    try {
        // Update the comments section data
        const commentsSectionCacheData = cache.readQuery({
            query: commentsSectionQuery,
            variables: {
                contentId: pageId,
                offset: '',
                first: (0, $2i3To.DEFAULT_LIMIT)
            }
        });
        if (commentsSectionCacheData) {
            // grab the parent comment for the comments panel
            const commentEdges = commentsSectionCacheData?.comments?.edges || [];
            const commentIdx = commentEdges?.findIndex((commentEdge)=>commentEdge?.node?.id === commentId);
            if (commentIdx !== undefined && commentIdx !== null && commentIdx !== -1 && commentEdges[commentIdx]?.node?.body && commentEdges[commentIdx]?.node?.version?.number) {
                // Find the index to update. TS will throw an error even though we've already checked the index is valid
                // @ts-ignore
                commentEdges[commentIdx].node.body.value = newBody; // Update the body we keep in the footer cache
                // @ts-ignore
                commentEdges[commentIdx].node.version.number += 1; // This is required for the propagated footer version to also be editable
                // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(commentEdges[commentIdx].node, 'version.by.displayName', sessionDisplayName); // Update the display name to the user who edited the comment
                // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(commentEdges[commentIdx].node, 'version.when', new Date().toISOString()); // Update the version date to the date of the edit
            }
            cache.writeQuery({
                query: commentsSectionQuery,
                variables: {
                    contentId: pageId,
                    offset: '',
                    first: (0, $2i3To.DEFAULT_LIMIT)
                },
                data: {
                    ...commentsSectionCacheData,
                    comments: {
                        ...commentsSectionCacheData.comments,
                        totalCount: commentEdges.length,
                        pageInfo: {
                            ...commentsSectionCacheData.comments?.pageInfo,
                            endCursor: Math.random().toString(),
                            // The cache won't update without this. Should be harmless, given hasNextPage is false, so we won't be loading more
                            hasNextPage: false
                        },
                        edges: commentEdges
                    }
                }
            });
        }
    } catch (err) {
        $80b47fa0b569ef69$var$logger.error`An Error occurred when updating cache for edit footer reply - ${err}`;
    }
};
const $80b47fa0b569ef69$export$c94bffbead878776 = ({ onSuccess: onSuccess, editCommentQueryId: editCommentQueryId, setCommentForEdit: setCommentForEdit, data: data, createAnalyticsEvent: createAnalyticsEvent, pageId: pageId, pageType: pageType, analyticsSource: analyticsSource, commentId: commentId, pageMode: pageMode, experienceTracker: experienceTracker, searchSessionId: searchSessionId, isFooterComment: isFooterComment })=>{
    onSuccess();
    if (editCommentQueryId) setCommentForEdit && setCommentForEdit('');
    const replyCommentInfo = data?.createFooterComment;
    // Find the reply button container and scroll to it if needed
    if (replyCommentInfo?.id && commentId && isFooterComment) {
        // First find the container
        const container = document.getElementById(`footer-comment-thread-${commentId}-container`);
        if (container) {
            // Set up observer to watch for the reply button in the container
            const observer = new MutationObserver((_mutations, obs)=>{
                const replyButtonContainer = container.querySelector('[data-testid="comments-panel-reply-comment-action"]');
                if (replyButtonContainer) {
                    obs.disconnect();
                    // Check if the element is not in viewport, accounting for 75px add comment prompt at bottom
                    const rect = replyButtonContainer.getBoundingClientRect();
                    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
                    const isInViewport = rect.top >= 0 && rect.left >= 0 && rect.bottom <= viewportHeight - 75 && // Account for add comment prompt
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth);
                    if (!isInViewport) replyButtonContainer.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }
            });
            observer.observe(container, {
                childList: true,
                subtree: true
            });
            // Cleanup observer after 2 seconds to prevent memory leaks
            setTimeout(()=>{
                observer.disconnect();
            }, 2000);
        }
    }
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'created',
            actionSubject: 'comment',
            actionSubjectId: replyCommentInfo?.id,
            // The newly created comment ID
            objectType: pageType,
            objectId: pageId,
            source: analyticsSource,
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                commentType: (0, $en1dX.CommentType).GENERAL,
                source: analyticsSource,
                pageType: pageType,
                isReply: true,
                pageMode: pageMode,
                isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                editor: 'v2',
                searchSessionId: searchSessionId,
                navdexPointType: (0, $56QzY.END),
                parentCommentId: commentId ?? null // analytics event schema type expects string or null
            }
        }
    }).fire();
    experienceTracker.succeed({
        name: (0, $irVI7.REPLY_TO_PAGE_COMMENT_PUBLISH_EXPERIENCE)
    });
};
module.exports["updateApolloCacheParentCallback"] = $80b47fa0b569ef69$export$a02bedef5e94d20c;
module.exports["updateApolloCacheReplyCallback"] = $80b47fa0b569ef69$export$bab18f310e4f95e8;
module.exports["updateFooterApolloCacheOnEdit"] = $80b47fa0b569ef69$export$aee61debd6ae89df;
module.exports["handleCreateReplySuccess"] = $80b47fa0b569ef69$export$c94bffbead878776;

});

parcelRegister("lFkRf", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $CP0sd = parcelRequire("CP0sd");


var $FBfum = parcelRequire("FBfum");

const $ad3c53086a228972$var$parseError = (error)=>{
    const { message: message } = error;
    let errorMessage;
    /* If this is a GraphQL error we need to extract the data out of it
   * GraphQL errors that are returned from queries/mutations always have the same format:
   * GraphQL error: <GUID>:[ <EXCEPTION>:] <REASON>
   */ if (message.indexOf('GraphQL error:') !== -1) {
        const reasonStartIdx = message.lastIndexOf(':') + 1;
        errorMessage = message.substr(reasonStartIdx, message.length - reasonStartIdx).trim();
    } else errorMessage = message;
    const parsedError = {
        message: errorMessage
    };
    // If we have an ApolloErrorInterop, extract the status code and the authorization status
    const { graphQLErrors: graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors.length) parsedError.statusCode = graphQLErrors?.[0]?.extensions?.statusCode;
    return parsedError;
};
const $ad3c53086a228972$export$a67f8c1198066537 = (error)=>{
    if ((0, $6fil2.containsNetworkError)(error)) return (0, $FBfum.i18n).networkError;
    const parsedError = $ad3c53086a228972$var$parseError(error);
    switch(parsedError.message){
        case (0, $CP0sd.ObjectCommentsError).VIEW_NOT_PERMITTED:
            return (0, $FBfum.i18n).viewNotPermitted;
        case (0, $CP0sd.ObjectCommentsError).NO_CREATE_PERMS:
            return (0, $FBfum.i18n).createNotPermitted;
        default:
            return (0, $FBfum.i18n).unexpectedError;
    }
};
const $ad3c53086a228972$export$c4a6c57f5b95da54 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).viewNotPermitted.id;
const $ad3c53086a228972$export$476aa014e2fd89d5 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).networkError.id;
const $ad3c53086a228972$export$aa951ce6b8761d86 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).createNotPermitted.id;
module.exports["getTranslatedError"] = $ad3c53086a228972$export$a67f8c1198066537;
module.exports["isViewNotPermittedError"] = $ad3c53086a228972$export$c4a6c57f5b95da54;
module.exports["isNetworkError"] = $ad3c53086a228972$export$476aa014e2fd89d5;
module.exports["isCreateNotPermittedError"] = $ad3c53086a228972$export$aa951ce6b8761d86;

});

parcelRegister("CP0sd", function(module, exports) {
var $a1a7014f0329fe2c$export$37d35ac9f5bc0a58 = /*#__PURE__*/ function(ObjectCommentsError) {
    // view
    ObjectCommentsError["VIEW_NOT_PERMITTED"] = "403 Forbidden, current user not permitted to use Confluence.";
    // Create
    ObjectCommentsError["NO_CREATE_PERMS"] = "Could not create content with type comment";
    return ObjectCommentsError;
}({});
module.exports["ObjectCommentsError"] = $a1a7014f0329fe2c$export$37d35ac9f5bc0a58;

});

parcelRegister("FBfum", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $93264f9de833f05e$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    unableToLoadCommentsTitle: {
        id: "comments-util.error.unable.to.load.comments",
        defaultMessage: "Unable to load comments"
    },
    networkError: {
        id: "comments-util.error.network",
        defaultMessage: "A network error was encountered when loading comments. Please try refreshing the page."
    },
    viewNotPermitted: {
        id: "comments-util.error.view.not.permitted",
        defaultMessage: "Your permission settings don\u2019t allow you to view comments on this page. Check with your administrator if you need this ability."
    },
    createNotPermitted: {
        id: "comments-util.error.create.not.permitted",
        defaultMessage: "You can\u2019t create comments in this space. A space admin can modify your permissions."
    },
    unexpectedError: {
        id: "comments-util.error.unexpected",
        defaultMessage: "Something went wrong when loading comments on this page."
    }
});
module.exports["i18n"] = $93264f9de833f05e$export$a7357cdd1f0b0168;

});

parcelRegister("3cu4A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $8i27m = parcelRequire("8i27m");


var $6eYRP = parcelRequire("6eYRP");

const $ba24a8cc7b954968$export$3577ba943a5537ec = 8;
// Binary search to find the transition point between inline/general comments
const $ba24a8cc7b954968$var$findTransitionIndex = (commentsList)=>{
    if (!commentsList.length) return 0;
    let low = 0;
    let high = commentsList.length - 1;
    // If all comments are of the same type, return 0
    const firstType = commentsList[0].type;
    const lastType = commentsList[high].type;
    if (firstType === lastType) return 0;
    while(low < high){
        const mid = Math.floor((low + high) / 2);
        if (commentsList[mid].type === (0, $8i27m.CommentType).INLINE) low = mid + 1;
        else high = mid;
    }
    return low;
};
const $ba24a8cc7b954968$export$69f1296a446ecce6 = /*#__PURE__*/ (0, $42omo.memo)(({ commentsList: commentsList, passThroughProps: passThroughProps, Component: Component, getElementsToBatch: getElementsToBatch })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const batchCount = Math.ceil(commentsList.length / $ba24a8cc7b954968$export$3577ba943a5537ec);
    const batches = (0, $42omo.useMemo)(()=>new Array(batchCount).fill(0), [
        batchCount
    ]);
    const [batch, setBatch] = (0, $42omo.useState)(0);
    const onBatchRendered = (0, $42omo.useCallback)((batchIndex)=>{
        if (passThroughProps) {
            passThroughProps.onCommentBatchRendered && passThroughProps.onCommentBatchRendered();
            if (batches.length && batchIndex === batches.length - 1) passThroughProps.onLastThreadRendered && passThroughProps.onLastThreadRendered();
        }
        setBatch(batchIndex + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const globalTransitionIndex = (0, $42omo.useMemo)(()=>$ba24a8cc7b954968$var$findTransitionIndex(commentsList), [
        commentsList
    ]);
    const transitionBatchIndex = Math.floor(globalTransitionIndex / $ba24a8cc7b954968$export$3577ba943a5537ec);
    const transitionIndexWithinBatch = globalTransitionIndex % $ba24a8cc7b954968$export$3577ba943a5537ec;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, batches.map((_, index)=>{
        const isTransitionBatch = index === transitionBatchIndex && globalTransitionIndex !== 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6eYRP.CommentBatch), {
            key: `${contentId}-batch-${index}`,
            commentsList: commentsList,
            canRenderBatch: index <= batch,
            batchIndex: index,
            passThroughProps: passThroughProps,
            Component: Component,
            getElementsToBatch: getElementsToBatch,
            onBatchRendered: onBatchRendered,
            transitionIndexWithinBatch: isTransitionBatch ? transitionIndexWithinBatch : undefined
        });
    }));
});
module.exports["BATCH_SIZE"] = $ba24a8cc7b954968$export$3577ba943a5537ec;
module.exports["CommentBatchList"] = $ba24a8cc7b954968$export$69f1296a446ecce6;

});

parcelRegister("6eYRP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $9hlns = parcelRequire("9hlns");


var $9wGTI = parcelRequire("9wGTI");


var $3cu4A = parcelRequire("3cu4A");

const $4d6840eb7d00cd1a$var$spinnerContainerStyles = (0, $ecnYn.xcss)({
    margin: 'auto',
    position: 'sticky',
    bottom: '1px'
});
const $4d6840eb7d00cd1a$export$f7f1256703956fe = 100;
const $4d6840eb7d00cd1a$export$a484c9e4bd05c9fe = /*#__PURE__*/ (0, $42omo.memo)(({ passThroughProps: passThroughProps, Component: Component, getElementsToBatch: getElementsToBatch, commentsList: commentsList, canRenderBatch: canRenderBatch, batchIndex: batchIndex, onBatchRendered: onBatchRendered, transitionIndexWithinBatch: transitionIndexWithinBatch })=>{
    const [showSpinner, setShowSpinner] = (0, $42omo.useState)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        if (canRenderBatch) {
            setShowSpinner(true);
            setTimeout(()=>{
                onBatchRendered(batchIndex);
                setShowSpinner(false);
            }, $4d6840eb7d00cd1a$export$f7f1256703956fe);
        }
    }, [
        canRenderBatch,
        batchIndex,
        onBatchRendered
    ]);
    if (!canRenderBatch) return null;
    const batchOffset = batchIndex * (0, $3cu4A.BATCH_SIZE);
    const batchedList = commentsList.slice(batchOffset, batchOffset + (0, $3cu4A.BATCH_SIZE));
    const elements = getElementsToBatch(batchedList, passThroughProps, Component, transitionIndexWithinBatch);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, elements, showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $4d6840eb7d00cd1a$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        interactionName: (0, $9wGTI.fg)('ufo-manual-experimental-holds-confluence') ? 'comment-batch' : undefined,
        size: "medium"
    })) : null);
});
module.exports["CommentBatch"] = $4d6840eb7d00cd1a$export$a484c9e4bd05c9fe;

});

parcelRegister("a6t12", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $8j9VY = parcelRequire("8j9VY");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");


var $5XsiK = parcelRequire("5XsiK");

parcelRequire("6OL2O");
var $5t3NX = parcelRequire("5t3NX");


var $dD7ks = parcelRequire("dD7ks");


var $9wGTI = parcelRequire("9wGTI");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");

const $3d0f3ea3171aff68$var$i18n = (0, $cgtv4.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(44);
    const { position: t1, userId: userId, isAnonymous: t2, canViewProfile: t3, children: children, trigger: t4, fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel } = t0;
    const position = t1 === undefined ? "bottom-start" : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const canViewProfile = t3 === undefined ? true : t3;
    const trigger = t4 === undefined ? "hover" : t4;
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            type: "LANDING"
        };
        $[0] = t5;
    } else t5 = $[0];
    const reportingLines = (0, $dD7ks.useNavigateToTeamsApp)(t5);
    let t6;
    if ($[1] !== orgId) {
        t6 = (clickedUserId)=>(0, $5t3NX.getNavigateToTeamsApp)(orgId || "", {
                type: "USER",
                payload: {
                    userId: clickedUserId
                }
            });
        $[1] = orgId;
        $[2] = t6;
    } else t6 = $[2];
    const getReportingLinesUserProfile = t6;
    const t7 = userId || "";
    let t8;
    if ($[3] !== t7) {
        t8 = {
            type: "USER",
            payload: {
                userId: t7
            }
        };
        $[3] = t7;
        $[4] = t8;
    } else t8 = $[4];
    const userProfile = (0, $dD7ks.useNavigateToTeamsApp)(t8);
    let t9;
    if ($[5] !== reportingLines) {
        t9 = (0, $5XsiK.isTeamsAppEnabled)() ? reportingLines.href : `${0, $jlIaF.CONTEXT_PATH}/people`;
        $[5] = reportingLines;
        $[6] = t9;
    } else t9 = $[6];
    const reportingLinesProfileUrl = t9;
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    let t10;
    if ($[7] !== push || $[8] !== userId || $[9] !== userProfile) {
        t10 = (0, $5XsiK.isTeamsAppEnabled)() ? $3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }) : $3d0f3ea3171aff68$export$98f80b73da7beaf4({
            push: push,
            userId: userId
        });
        $[7] = push;
        $[8] = userId;
        $[9] = userProfile;
        $[10] = t10;
    } else t10 = $[10];
    const viewProfileAction = t10;
    let t11;
    if ($[11] !== followedUsers || $[12] !== getToggleFollowUser || $[13] !== loggedInUserId || $[14] !== renderFeedFollow || $[15] !== userId) {
        t11 = $3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        });
        $[11] = followedUsers;
        $[12] = getToggleFollowUser;
        $[13] = loggedInUserId;
        $[14] = renderFeedFollow;
        $[15] = userId;
        $[16] = t11;
    } else t11 = $[16];
    const followUserAction = t11;
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) {
        let t12;
        if ($[17] !== children) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
            $[17] = children;
            $[18] = t12;
        } else t12 = $[18];
        return t12;
    }
    let t12;
    if ($[19] !== createAnalyticsEvent || $[20] !== getReportingLinesUserProfile || $[21] !== push) {
        t12 = (clickedUserId_0)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "profileCardWrapper",
                    action: "clicked",
                    actionSubject: "viewProfile",
                    actionSubjectId: "userProfileCard",
                    attributes: {
                        clickTarget: "userReportingLine"
                    }
                }
            }).fire();
            if ((0, $5XsiK.isTeamsAppEnabled)()) {
                getReportingLinesUserProfile(clickedUserId_0).onNavigate();
                return false;
            }
            if (window.self !== window.top) window.open((0, $4qzKl.getAtlassianPeopleProfileUrl)(clickedUserId_0, "", (0, $jlIaF.CONTEXT_PATH)), "_blank", "noreferrer");
            else (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(clickedUserId_0).then(push, $3d0f3ea3171aff68$var$_temp);
        };
        $[19] = createAnalyticsEvent;
        $[20] = getReportingLinesUserProfile;
        $[21] = push;
        $[22] = t12;
    } else t12 = $[22];
    const reportingLinesClickCallback = t12;
    let t13;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== ariaLabel || $[25] !== children || $[26] !== cloudId || $[27] !== disabledAriaAttributes || $[28] !== featureFlags || $[29] !== feedConfigError || $[30] !== followUserAction || $[31] !== fullName || $[32] !== isVisible || $[33] !== loggedInUserId || $[34] !== mutationError || $[35] !== offset || $[36] !== onVisibilityChange || $[37] !== position || $[38] !== reportingLinesClickCallback || $[39] !== reportingLinesProfileUrl || $[40] !== trigger || $[41] !== userId || $[42] !== viewProfileAction) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t13
        }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
                feedConfigError: feedConfigError,
                mutationError: mutationError,
                showErrorFlag: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8j9VY.default), {
                cloudId: cloudId,
                userId: userId,
                resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
                position: position,
                trigger: trigger,
                actions: [
                    viewProfileAction,
                    followUserAction
                ],
                reportingLinesProfileUrl: reportingLinesProfileUrl,
                onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
                addFlag: (flag)=>flags.showFlag(flag),
                prepopulatedData: {
                    fullName: fullName
                },
                disabledAriaAttributes: disabledAriaAttributes,
                isVisible: (0, $9wGTI.fg)("fix_profilecard_trigger_isvisible") ? undefined : isVisible,
                onVisibilityChange: onVisibilityChange || ((changedIsVisible)=>{
                    setIsVisible(changedIsVisible);
                }),
                offset: offset,
                testId: "profileCardTrigger",
                viewingUserId: loggedInUserId,
                ariaLabel: ariaLabel
            }, children)));
        $[24] = ariaLabel;
        $[25] = children;
        $[26] = cloudId;
        $[27] = disabledAriaAttributes;
        $[28] = featureFlags;
        $[29] = feedConfigError;
        $[30] = followUserAction;
        $[31] = fullName;
        $[32] = isVisible;
        $[33] = loggedInUserId;
        $[34] = mutationError;
        $[35] = offset;
        $[36] = onVisibilityChange;
        $[37] = position;
        $[38] = reportingLinesClickCallback;
        $[39] = reportingLinesProfileUrl;
        $[40] = trigger;
        $[41] = userId;
        $[42] = viewProfileAction;
        $[43] = t14;
    } else t14 = $[43];
    return t14;
} : ({ position: position = 'bottom-start', userId: userId, isAnonymous: isAnonymous = false, canViewProfile: canViewProfile = true, children: children, trigger: trigger = 'hover', fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const reportingLines = (0, $dD7ks.useNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const getReportingLinesUserProfile = (clickedUserId)=>(0, $5t3NX.getNavigateToTeamsApp)(orgId || '', {
            type: 'USER',
            payload: {
                userId: clickedUserId
            }
        });
    const userProfile = (0, $dD7ks.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId || ''
        }
    });
    const reportingLinesProfileUrl = (0, $5XsiK.isTeamsAppEnabled)() ? reportingLines.href : `${0, $jlIaF.CONTEXT_PATH}/people`;
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    const viewProfileAction = (0, $42omo.useMemo)(()=>(0, $5XsiK.isTeamsAppEnabled)() ? $3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }) : $3d0f3ea3171aff68$export$98f80b73da7beaf4({
            push: push,
            userId: userId
        }), [
        push,
        userId,
        userProfile
    ]);
    const followUserAction = (0, $42omo.useMemo)(()=>$3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId,
        followedUsers
    ]);
    // Should display profile?
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    const reportingLinesClickCallback = (clickedUserId_0)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'profileCardWrapper',
                action: 'clicked',
                actionSubject: 'viewProfile',
                actionSubjectId: 'userProfileCard',
                attributes: {
                    clickTarget: 'userReportingLine'
                }
            }
        }).fire();
        if ((0, $5XsiK.isTeamsAppEnabled)()) {
            getReportingLinesUserProfile(clickedUserId_0).onNavigate();
            return false;
        }
        if (window.self !== window.top) window.open((0, $4qzKl.getAtlassianPeopleProfileUrl)(clickedUserId_0, '', (0, $jlIaF.CONTEXT_PATH)), '_blank', 'noreferrer');
        else (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(clickedUserId_0).then(push, ()=>{});
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            showErrorFlag: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8j9VY.default), {
            cloudId: cloudId,
            userId: userId,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
            position: position,
            trigger: trigger,
            actions: [
                viewProfileAction,
                followUserAction
            ],
            reportingLinesProfileUrl: reportingLinesProfileUrl,
            onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
            addFlag: (flag)=>flags.showFlag(flag),
            prepopulatedData: {
                fullName: fullName
            },
            disabledAriaAttributes: disabledAriaAttributes,
            isVisible: (0, $9wGTI.fg)('fix_profilecard_trigger_isvisible') ? undefined : isVisible,
            onVisibilityChange: onVisibilityChange || ((changedIsVisible)=>{
                setIsVisible(changedIsVisible);
            }),
            offset: offset,
            testId: "profileCardTrigger",
            viewingUserId: loggedInUserId,
            ariaLabel: ariaLabel
        }, children)));
};
function $3d0f3ea3171aff68$var$_temp() {}
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $ay6Zz = parcelRequire("ay6Zz");


var $bYUc2 = parcelRequire("bYUc2");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    const isNav4Enabled = (0, $bYUc2.getIsNav4EnabledSafe)();
    return (0, $ay6Zz.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: isNav4Enabled,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("bedVD", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $3gadb = parcelRequire("3gadb");

const $e4e11ee9fe4a88c9$var$i18n = (0, $cgtv4.defineMessages)({
    follow: {
        id: "profile.card.follow",
        defaultMessage: "Follow"
    },
    unfollow: {
        id: "profile.card.unfollow",
        defaultMessage: "Unfollow"
    },
    followTooltip: {
        id: "profile.card.follow.tooltip",
        defaultMessage: "See activity in feed"
    },
    unfollowTooltip: {
        id: "profile.card.unfollow.tooltip",
        defaultMessage: "Stop seeing activity in feed"
    }
});
const $e4e11ee9fe4a88c9$export$d258f317c876c5dc = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { followed: followed } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== followed || $[1] !== intl) {
        t1 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip);
        $[0] = followed;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== followed || $[4] !== intl) {
        t2 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow);
        $[3] = followed;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t1,
            position: "bottom",
            testId: "feed-follow-tooltip"
        }, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ followed: followed })=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip),
        position: "bottom",
        testId: "feed-follow-tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow)));
};
module.exports["FeedFollow"] = $e4e11ee9fe4a88c9$export$d258f317c876c5dc;

});

parcelRegister("4GlQ9", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");

var $xQxzY = parcelRequire("xQxzY");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery = (0, $eSUdr.default)`query useFeedFollowFeedFollowQuery{getFeedUserConfig{accountIds}}`;
const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation = (0, $eSUdr.default)`mutation useFeedFollowFeedFollowMutation($follow:[ID]$unfollow:[ID]){setFeedUserConfig(input:{followUsers:$follow unfollowUsers:$unfollow}){success}}`;
const $e2d6f47b8e3454eb$var$isUserHasNoAccessError = (error)=>error?.graphQLErrors?.some((gqlError)=>gqlError?.path?.includes('getFeedUserConfig') && gqlError?.message?.includes('User not permitted to access Confluence'));
let $e2d6f47b8e3454eb$export$8631e45fce8db7c6 = false;
function $e2d6f47b8e3454eb$export$438df56e0ed352e6() {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: queryLoading, error: feedConfigError } = (0, $xQxzY.useQuery)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery, {
        skip: !isLicensed || $e2d6f47b8e3454eb$export$8631e45fce8db7c6,
        onError: (error)=>$e2d6f47b8e3454eb$export$8631e45fce8db7c6 = $e2d6f47b8e3454eb$var$isUserHasNoAccessError(error)
    });
    const [mutateFeedFollow, { error: mutationError }] = (0, $1KmJq.useMutation)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation, {
        refetchQueries: [
            {
                query: $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery
            },
            'FeedFollowQuery'
        ]
    });
    const followedUsers = data?.getFeedUserConfig?.accountIds;
    const getToggleFollowUser = (0, $42omo.useCallback)((accountId, following, source)=>async ()=>{
            if (!accountId) return;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedFollow',
                    source: source,
                    attributes: {
                        id: accountId,
                        settingType: 'user',
                        actionType: following ? 'unfollow' : 'follow'
                    }
                }
            }).fire();
            try {
                if (following) await mutateFeedFollow({
                    variables: {
                        unfollow: [
                            accountId
                        ]
                    }
                });
                else await mutateFeedFollow({
                    variables: {
                        follow: [
                            accountId
                        ]
                    }
                });
            } catch (_) {
            // noop since the hook consumer logs the error through <ErrorDisplay>
            // mutateFeedFollow() has the potential to throw an error;
            // since we do not provide an onError callback to the useMutation hook
            // we need to catch the error here as a safety net.
            }
        }, [
        mutateFeedFollow,
        createAnalyticsEvent
    ]);
    const feedFollowData = {
        renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
        loading: queryLoading,
        getToggleFollowUser: getToggleFollowUser,
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        followedUsers: followedUsers
    };
    const feedFollowDataMemoized = (0, $42omo.useMemo)(()=>({
            renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
            loading: queryLoading,
            getToggleFollowUser: getToggleFollowUser,
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            followedUsers: followedUsers ?? []
        }), [
        queryLoading,
        feedConfigError,
        isLicensed,
        getToggleFollowUser,
        mutationError,
        followedUsers
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? feedFollowDataMemoized : feedFollowData;
}
module.exports["useFeedFollow"] = $e2d6f47b8e3454eb$export$438df56e0ed352e6;

});

parcelRegister("bumSD", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $7c52C = parcelRequire("7c52C");


var $bp86Z = parcelRequire("bp86Z");

const $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';
const $226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG = {
    url: $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH,
    cacheSize: 100,
    cacheMaxAge: 300000 // - 5 minutes
};
const $226eb0cd9c5c41b1$export$441fd008df03d370 = (0, $2XqLN.default)((cloudId, _)=>{
    const profileClientConfig = {
        ...$226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG,
        productIdentifier: 'confluence',
        cloudId: cloudId
    };
    return new (0, $7c52C.default)(profileClientConfig, {
        userClient: new (0, $bp86Z.UserProfileClientForConfluence)(profileClientConfig)
    });
});
module.exports["getProfileClient"] = $226eb0cd9c5c41b1$export$441fd008df03d370;

});

parcelRegister("bp86Z", function(module, exports) {

var $8zKPT = parcelRequire("8zKPT");


var $9fywD = parcelRequire("9fywD");


var $7lu50 = parcelRequire("7lu50");


var $hp2SH = parcelRequire("hp2SH");


var $ldOrZ = parcelRequire("ldOrZ");


var $2A84u = parcelRequire("2A84u");


var $9jSPN = parcelRequire("9jSPN");

class $e0ed8187aad1d5de$export$8e0680112f77975e extends (0, $8zKPT.default) {
    async makeRequest(cloudId, userId) {
        // Note because we are only subclassing "makeRequest()", we are still using UserProfileClient's
        // default "getProfile()" function - which means we automatically get the standard
        // UserProfileClient caching of the full user profile data, including our added properties
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).start();
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const UserProfileClientForConfluencePromise = (0, $hp2SH.getApolloClient)().query({
            query: (0, $2A84u.UserProfileClientForConfluenceQuery),
            variables: {
                userId: userId
            }
        });
        // If the standard user data query fails, we want to reject the returned promise because there
        // won't be any data for the caller to make a useful ProfileCard.  But if the standard user
        // data query succeeds but External Collaboration data query fails, we want to still display
        // the ProfileCard with the standard user data (that is, we don't want to reject).  In order to
        // do this, we can't use "Promise.all()" because it will return immediately when any of its
        // requests fail.  Instead we need to wait until all of the requests complete or fail, and that
        // means using "Promise.allSettled()", which has a much more complicated return object.
        const [userProfileClientForConfluenceQueryResult, standardUserDataResult] = await Promise.allSettled([
            UserProfileClientForConfluencePromise,
            super.makeRequest(cloudId, userId)
        ]);
        if (standardUserDataResult.status === 'rejected') {
            (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
                customData: {
                    success: false
                }
            });
            return Promise.reject(standardUserDataResult.reason);
        }
        // If the External Collaboration query was successful and External Collaboration is entitled
        // and this user is an External user, then add our custom Lozenge to the standard user profile
        // data
        const customLozenges = [];
        if (userProfileClientForConfluenceQueryResult.status === 'fulfilled') {
            const confluenceUserResponse = userProfileClientForConfluenceQueryResult.value.data;
            if ((0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(confluenceUserResponse) && confluenceUserResponse?.user?.confluence?.permissionType === (0, $ldOrZ.SitePermissionType).EXTERNAL) customLozenges.push({
                ...(0, $9fywD.ExternalUserLozengeProps),
                key: 'ExternalUserLozenge'
            });
        }
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
            customData: {
                success: true
            }
        });
        return {
            ...standardUserDataResult.value,
            customLozenges: customLozenges
        };
    }
}
module.exports["UserProfileClientForConfluence"] = $e0ed8187aad1d5de$export$8e0680112f77975e;

});

parcelRegister("ldOrZ", function(module, exports) {
/**
 * @generated SignedSource<<6837b1662181fa3feff08f9973248f40>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $0709253cacc9fe3a$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $0709253cacc9fe3a$export$8995abb8169b2cb8;

});

parcelRegister("2A84u", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $ab1c6257ac115bcc$export$8322eea6a290b246 = (0, $eSUdr.default)`query UserProfileClientForConfluenceQuery($userId:ID){user:confluence_atlassianUser(current:false id:$userId){id confluence{permissionType}}entitlements{externalCollaborator{isEntitled}}}`;
module.exports["UserProfileClientForConfluenceQuery"] = $ab1c6257ac115bcc$export$8322eea6a290b246;

});

parcelRegister("9jSPN", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $5487d57e41530957$export$c2710940b43dcf08 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.PROFILE_CARD_QUERY_CUSTOM_KEY)
});
module.exports["PROFILE_CARD_QUERY_METRIC"] = $5487d57e41530957$export$c2710940b43dcf08;

});

parcelRegister("gj42z", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $b3j2Y = parcelRequire("b3j2Y");


var $gqqjz = parcelRequire("gqqjz");

const $3ade761a05c1a959$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    followMutationErrorTitle: {
        id: "profile.card.feed.follow.mutation.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble doing that"
    },
    followMutationErrorDescription: {
        id: "profile.card.feed.follow.mutation.error.description",
        defaultMessage: "Try following or unfollowing this user again"
    }
});
const $3ade761a05c1a959$export$cb92340e76dc7cda = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag } = t0;
    let t1;
    if ($[0] !== feedConfigError) {
        t1 = feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: feedConfigError
        }) : null;
        $[0] = feedConfigError;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== mutationError || $[3] !== showErrorFlag) {
        t2 = mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: mutationError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>{
            if (showErrorFlag) flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
            });
            return null;
        })) : null;
        $[2] = mutationError;
        $[3] = showErrorFlag;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: feedConfigError
    }) : null, mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: mutationError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>{
        if (showErrorFlag) flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
        });
        return null;
    })) : null);
module.exports["FeedFollowErrorDisplay"] = $3ade761a05c1a959$export$cb92340e76dc7cda;

});

parcelRegister("isdzP", function(module, exports) {

var $fJlJm = parcelRequire("fJlJm");


var $hL41C = parcelRequire("hL41C");


var $9CnRS = parcelRequire("9CnRS");

const $e5083fb3da68bf8e$export$e80a9284539c1797 = (error)=>{
    const { message: message } = error;
    let errorMessage = '';
    const parsedError = {
        message: errorMessage,
        isAuthorized: false
    };
    /* If this is a GraphQL error we need to extract the data out of it
   * GraphQL errors that are returned from mutations always have the same format:
   * GraphQL error: <GUID>: <EXCEPTION>: <REASON>
   * The GUID correlates to the microsId so it unfortunately doesn't do much for us
   * With this in mind, we want to extract the REASON as the message for translation
   */ if (message.indexOf('GraphQL error:') !== -1) {
        const reasonStartIdx = message.lastIndexOf(':') + 1;
        errorMessage = message.substr(reasonStartIdx, message.length - reasonStartIdx).trim();
        // Extract the traceId for highlight errors
        parsedError.errorId = (0, $fJlJm.getLogSafeErrorAttributes)(error).traceId;
    } else errorMessage = message;
    parsedError.message = errorMessage;
    // If we have an ApolloErrorInterop, extract the status code and the authorization status
    const { graphQLErrors: graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors.length) {
        parsedError.statusCode = graphQLErrors?.[0]?.extensions?.statusCode;
        parsedError.isAuthorized = graphQLErrors?.[0]?.extensions?.data?.authorized || false;
    }
    return parsedError;
};
const $e5083fb3da68bf8e$export$a67f8c1198066537 = (message, id = '')=>{
    let i18nError;
    // COMMENTS-4199 - This is our own handling of the error thrown by the editor/renderer that we wrap
    //				   in our own message, so to preserve the original error we just check for our message
    if (message.includes('Unable to apply annotation to document')) {
        if (message.includes('Failed to create annotation')) i18nError = (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation;
        else i18nError = (0, $9CnRS.i18n).unableToApplyAnnotation;
    } else if (message.startsWith('Network error: ')) i18nError = (0, $9CnRS.i18n).networkError;
    else switch(message){
        case (0, $hL41C.InlineCommentError).INVALID_SELECTION:
        case (0, $hL41C.InlineCommentError).FAILED_TO_INSERT_MARK:
            i18nError = (0, $9CnRS.i18n).invalidHighlight;
            break;
        case (0, $hL41C.InlineCommentError).STALE_SELECTION:
            i18nError = (0, $9CnRS.i18n).staleContent;
            break;
        case (0, $hL41C.InlineCommentError).NO_ANONYMOUS_ACCESS:
            i18nError = (0, $9CnRS.i18n).actionNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF:
        case (0, $hL41C.InlineCommentError).NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF_LIST:
            i18nError = (0, $9CnRS.i18n).noCommentsFoundForGivenMarkerRef;
            break;
        case (0, $hL41C.InlineCommentError).NO_VIEW_PERMS:
        case (0, $hL41C.InlineCommentError).NOT_AUTHORIZED:
        case (0, $hL41C.InlineCommentError).NOT_AUTHORIZED_COMMENTS:
            i18nError = (0, $9CnRS.i18n).viewNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_UPDATE_PERMS.replace('%d', id ? id : ''):
            i18nError = (0, $9CnRS.i18n).editNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_VIEW_OR_MODIFY_PERMS:
            i18nError = (0, $9CnRS.i18n).viewOrModifyNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_DELETE_WITH_CHILDREN:
            i18nError = (0, $9CnRS.i18n).deleteWithRepliesNotAllowed;
            break;
        case (0, $hL41C.InlineCommentError).NO_CREATE_PERMS:
            i18nError = (0, $9CnRS.i18n).createNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).UPDATE_COMMENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).COMMENT_ALREADY_DELETED.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).CANNOT_RESOLVE_DELETED_COMMENT.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).ERROR_404:
            i18nError = (0, $9CnRS.i18n).commentAlreadyDeleted;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_REPLY_TO_DELETED_PARENT:
            i18nError = (0, $9CnRS.i18n).replyNotAllowedParentDeleted;
            break;
        case (0, $hL41C.InlineCommentError).INVALID_ARGUMENT_MATCHES:
            i18nError = (0, $9CnRS.i18n).contentHasBeenRemoved;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_REPLY_TO_RESOLVED_COMMENT:
            i18nError = (0, $9CnRS.i18n).cannotReplyToResolvedComment;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_UPDATE_RESOLVED_COMMENT:
            i18nError = (0, $9CnRS.i18n).cannotUpdateResolvedComment;
            break;
        case (0, $hL41C.InlineCommentError).CONTENT_OUT_OF_DATE:
            i18nError = (0, $9CnRS.i18n).contentOutOfDate;
            break;
        case (0, $hL41C.InlineCommentError).INVALID_ARGUMENT_CREATED_FROM:
        case (0, $hL41C.InlineCommentError).CREATE_COMMENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).PARENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).INCOMPATIBLE_PARENT_TYPE:
        case (0, $hL41C.InlineCommentError).DELETE_ERROR:
        default:
            i18nError = (0, $9CnRS.i18n).unexpectedError;
            break;
    }
    return i18nError;
};
const $e5083fb3da68bf8e$export$336db91bab9fb3ba = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).invalidHighlight.id;
const $e5083fb3da68bf8e$export$68de2e41a5e9d0c3 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).unexpectedError.id;
const $e5083fb3da68bf8e$export$fb2e61e668e6b1d2 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).unableToApplyAnnotation.id || translatedMessage.id === (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation.id;
const $e5083fb3da68bf8e$export$81795bac145b8560 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).contentOutOfDate.id || translatedMessage.id === (0, $9CnRS.i18n).staleContent.id;
const $e5083fb3da68bf8e$export$b2e3f629cad072ef = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).commentAlreadyDeleted.id;
const $e5083fb3da68bf8e$export$476aa014e2fd89d5 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).networkError.id;
module.exports["parseError"] = $e5083fb3da68bf8e$export$e80a9284539c1797;
module.exports["getTranslatedError"] = $e5083fb3da68bf8e$export$a67f8c1198066537;
module.exports["isHighlightError"] = $e5083fb3da68bf8e$export$336db91bab9fb3ba;
module.exports["isUnexpectedError"] = $e5083fb3da68bf8e$export$68de2e41a5e9d0c3;
module.exports["isAnnotationError"] = $e5083fb3da68bf8e$export$fb2e61e668e6b1d2;
module.exports["isOutOfDateError"] = $e5083fb3da68bf8e$export$81795bac145b8560;
module.exports["isAlreadyDeletedError"] = $e5083fb3da68bf8e$export$b2e3f629cad072ef;
module.exports["isNetworkError"] = $e5083fb3da68bf8e$export$476aa014e2fd89d5;

});

parcelRegister("hL41C", function(module, exports) {
var $4bdefc881ecc3bb8$export$317614131ad59950 = /*#__PURE__*/ function(InlineCommentError) {
    InlineCommentError["INVALID_SELECTION"] = "Invalid text selection. Cannot create inline comments on macros (mentions, images, emojis, etc.)";
    InlineCommentError["FAILED_TO_INSERT_MARK"] = "Failed to insert highlight, invalid originalSelection, numMatches, or matchIndex";
    InlineCommentError["INVALID_ARGUMENT_CREATED_FROM"] = "Invalid createdFrom, please specify if created from editor or renderer";
    InlineCommentError["STALE_SELECTION"] = "Selection was made against a stale version of the content";
    InlineCommentError["NO_ANONYMOUS_ACCESS"] = "Anonymous access is not permitted";
    InlineCommentError["NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF"] = "No comments found for the given markerRef";
    InlineCommentError["NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF_LIST"] = "No comments found for the given markerRefList";
    InlineCommentError["NO_VIEW_PERMS"] = "User doesn't have VIEW permission for this comment";
    InlineCommentError["NOT_AUTHORIZED"] = "403 Forbidden, current user not permitted to use Confluence.";
    InlineCommentError["NOT_AUTHORIZED_COMMENTS"] = "User does not have permission to access the comment(s)";
    // Create Reply
    InlineCommentError["CREATE_COMMENT_NOT_FOUND"] = "Content with id %d for comment container is not found. Please provide correct container id.";
    InlineCommentError["PARENT_NOT_FOUND"] = "Parent comment with id %d is not found. Please provide correct parent comment id.";
    InlineCommentError["INCOMPATIBLE_PARENT_TYPE"] = "Incompatible parent type. Please provide comment id.";
    InlineCommentError["CANNOT_REPLY_TO_DELETED_PARENT"] = "Cannot add reply to a deleted comment";
    InlineCommentError["CANNOT_REPLY_TO_RESOLVED_COMMENT"] = "Inline comment in RESOLVED status cannot be replied";
    // Delete
    // This is the error message for a NotFoundException only
    InlineCommentError["DELETE_ERROR"] = "Exception occurred while deleting comment with id";
    InlineCommentError["NO_VIEW_OR_MODIFY_PERMS"] = "Parent page view is restricted";
    InlineCommentError["NO_DELETE_WITH_CHILDREN"] = "Inline comment with child cannot be deleted.";
    InlineCommentError["COMMENT_ALREADY_DELETED"] = "Exception occurred while deleting comment with id %d";
    InlineCommentError["ERROR_404"] = "Received status 404";
    // Edit
    InlineCommentError["NO_UPDATE_PERMS"] = "Could not update Content of type  = class com.atlassian.confluence.pages.Comment with id %d";
    InlineCommentError["UPDATE_COMMENT_NOT_FOUND"] = "Could not find Comment for update with id CommentId{id=%d}";
    InlineCommentError["CANNOT_UPDATE_RESOLVED_COMMENT"] = "Inline comment in RESOLVED status cannot be updated";
    // Create
    InlineCommentError["NO_CREATE_PERMS"] = "Could not create content with type comment";
    InlineCommentError["INVALID_ARGUMENT_MATCHES"] = "Invalid arguments provided for matchIndex and/or numMatches";
    InlineCommentError["CONTENT_OUT_OF_DATE"] = "Published Version out of date. Please provide correct published version.";
    InlineCommentError["UNABLE_TO_APPLY_ANNOTATION"] = "Unable to apply annotation to document";
    // Resolve
    InlineCommentError["CANNOT_RESOLVE_DELETED_COMMENT"] = "%d must be existing and be an inline comment";
    return InlineCommentError;
}({});
module.exports["InlineCommentError"] = $4bdefc881ecc3bb8$export$317614131ad59950;

});

parcelRegister("9CnRS", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $90dae8a726ff859c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    addNew: {
        id: "inline-comments-common.reactions.add.new",
        defaultMessage: "Add new"
    },
    invalidHighlight: {
        id: "inline-comments-common.error.invalid.highlight",
        defaultMessage: "We\u2019re having trouble adding your comment. Try highlighting more or less text."
    },
    replyCommentPlaceholder: {
        id: "inline-comments-common.reply-comment-placeholder",
        defaultMessage: "Reply"
    },
    staleContent: {
        id: "inline-comments-common.error.stale.content",
        defaultMessage: "Refresh to view the latest updates, and try adding your comment again."
    },
    viewNotPermitted: {
        id: "inline-comments-common.error.view.not.permitted",
        defaultMessage: "Your permission settings don\u2019t allow you to view this comment. Check with your administrator if you need this ability."
    },
    createNotPermitted: {
        id: "inline-comments-common.error.create.not.permitted",
        defaultMessage: "You can\u2019t create comments in this space. A space admin can modify your permissions."
    },
    unableToApplyAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.annotation",
        defaultMessage: "Something went wrong when adding this comment to the document. Refresh to see your comment."
    },
    unableToApplyDanglingCommentAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.dangling.comment.annotation",
        defaultMessage: "Your comment was created but could not be added to the document because the text has been changed or removed."
    },
    contentHasBeenRemoved: {
        id: "inline-comments-common.error.create.content.removed",
        defaultMessage: "The text you highlighted has already been deleted by someone else. Refresh to view the latest updates."
    },
    viewOrModifyNotPermitted: {
        id: "inline-comments-common.error.view.or.modify.not.permitted",
        defaultMessage: "You can\u2019t view or modify comments in this space. A space admin can modify your permissions."
    },
    deleteWithRepliesNotAllowed: {
        id: "inline-comments-common.error.delete.with.replies",
        defaultMessage: "You can\u2019t delete this comment anymore because someone else replied to it. Refresh to see all replies."
    },
    commentAlreadyDeleted: {
        id: "inline-comments-common.error.comment.already.deleted",
        defaultMessage: "This comment has been deleted by someone else. Refresh to view the latest updates."
    },
    noCommentsFoundForGivenMarkerRef: {
        id: "inline-comments-common.error.no.comments.found.for.given.marker.ref",
        defaultMessage: "This comment couldn\u2019t be found. Refresh to view the latest updates."
    },
    resolveNotPermitted: {
        id: "inline-comments-common.error.resolve.not.permitted",
        defaultMessage: "You can\u2019t resolve comments in this space. A space admin can modify your permissions."
    },
    editNotPermitted: {
        id: "inline-comments-common.error.edit.not.permitted",
        defaultMessage: "You can\u2019t edit comments in this space. A space admin can modify your permissions."
    },
    replyNotPermitted: {
        id: "inline-comments-common.error.reply.not.permitted",
        defaultMessage: "You can\u2019t reply to comments in this space. A space admin can modify your permissions."
    },
    replyNotAllowedParentDeleted: {
        id: "inline-comments-common.error.reply.not.allowed.parent.deleted",
        defaultMessage: "You can\u2019t reply to this comment because it was just deleted by someone else. Refresh to view the latest updates."
    },
    unableToMarkDOM: {
        id: "inline-comments-common.error.unable.to.mark.dom",
        defaultMessage: "Your comment has been successfully created. Refresh to view it."
    },
    networkError: {
        id: "inline-comments-common.error.network",
        defaultMessage: "Your comment wasn't added due to a network error. Check your connection and try again."
    },
    unexpectedError: {
        id: "inline-comments-common.error.unexpected",
        defaultMessage: "Something went wrong when saving this comment. Close the comment or refresh, and try adding your comment again."
    },
    actionNotPermittedTitle: {
        id: "inline-comments-common.error.action.not.permitted.title",
        defaultMessage: "Unauthorized action"
    },
    actionNotPermitted: {
        id: "inline-comments-common.error.action.not.permitted",
        defaultMessage: "You can\u2019t perform that action on inline comments in this space. A space admin can modify your permissions."
    },
    cannotReplyToResolvedComment: {
        id: "inline-comments-common.error.cannot.reply.to.resolved",
        defaultMessage: "You can\u2019t reply to this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    cannotUpdateResolvedComment: {
        id: "inline-comments-common.error.cannot.update.resolved",
        defaultMessage: "You can\u2019t edit this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    unableToGenerateStep: {
        id: "inline-comments-common.error.unable.to.generate.step",
        defaultMessage: "You can\u2019t create a comment because something went wrong with your highlight. Close this window and create a new highlight."
    },
    contentOutOfDate: {
        id: "inline-comments-common.error.content.out.of.date",
        defaultMessage: "You can\u2019t create a comment here because the text has been changed or removed."
    },
    createTimeout: {
        id: "inline-comments-common.error.create.timeout",
        defaultMessage: "Your request to create a comment timed out. Wait a few moments and save the comment again."
    },
    /**
   * The message below is duplicated in the next files:
   * next/packages/resolved-inline-comments-dialog/src/ResolvedInlineCommentsDialogComponent.tsx
   * packages/confluence-frontend-server/src/components/Comment/PageCommentRenderer.js
   *
   * If you are going to change the message please make sure that the same changes are made in the mentioned above files
   */ a11yCommentLabel: {
        id: "inline-comments-common.a11y.comment.wrapper.label",
        defaultMessage: "Comment by {username}"
    },
    commentActionsMenuLabel: {
        id: "inline-comments-common.comment.actions.menu.label",
        defaultMessage: "More actions"
    },
    copyLinkTooltip: {
        id: "inline-comments-common.tooltip.copy.link",
        defaultMessage: "Copy link to comment"
    },
    linkCopiedTooltip: {
        id: "inline-comments-common.tooltip.link.has.been.copied",
        defaultMessage: "Copied!"
    },
    resolve: {
        id: "inline-comments-common.view.action.resolve",
        defaultMessage: "Resolve"
    },
    resolved: {
        id: "inline-comments-common.view.action.resolved",
        defaultMessage: "Resolved"
    },
    edit: {
        id: "inline-comments-common.view.action.edit",
        defaultMessage: "Edit"
    },
    delete: {
        id: "inline-comments-common.view.action.delete",
        defaultMessage: "Delete"
    },
    reopen: {
        id: "inline-comments-common.action.reopen",
        defaultMessage: "Reopen"
    },
    replyPlaceholder: {
        id: "inline-comments-common.reply.placeholder",
        defaultMessage: "Reply"
    },
    replyPlaceholderWithName: {
        id: "inline-comments-common.reply.placeholder.with-name",
        defaultMessage: "Reply to {name}"
    },
    reactionAriaLabelWithName: {
        id: "inline-comments-common.reaction.aria-label.with-name",
        defaultMessage: "React to {name}\u2019s comment"
    },
    resolveThread: {
        id: "inline-comments-common.resolve-thread",
        defaultMessage: "Resolve comment thread"
    },
    /**
   * Collaborator Onboarding sample comment
   */ sampleAuthor: {
        id: "inline-comments-common.sample.comment.author",
        defaultMessage: "Confluence"
    },
    sampleBody: {
        id: "inline-comments-common.sample.comment.body",
        defaultMessage: "Highlight content to add an inline comment. All viewers can see these, so it\u2019s great for targeted discussion on a specific word or phrase"
    },
    sampleReply: {
        id: "inline-comments-common.sample.reply.input",
        defaultMessage: "disabled reply input"
    },
    sampleReplyPlaceholder: {
        id: "inline-comments-common.sample.reply.placeholder",
        defaultMessage: "Reply"
    },
    sampleReplyTooltip: {
        id: "inline-comments-common.sample.reply.tooltip",
        defaultMessage: "Reply is unavailable for sample comments"
    },
    sampleDeleteHeader: {
        id: "inline-comments-common.sample.comment.delete.header",
        defaultMessage: "Only you can see this."
    },
    sampleDeleteIcon: {
        id: "inline-comments-common.sample.comment.delete.icon",
        defaultMessage: "Delete icon"
    },
    sampleDeleteTooltip: {
        id: "inline-comments-common.sample.comment.delete.tooltip",
        defaultMessage: "Delete sample comment"
    },
    sampleCloseIconLabel: {
        id: "inline-comments-common.sample.comment.delete.icon.label",
        defaultMessage: "Close sample comment"
    },
    collapsedRepliesMore: {
        id: "inline-comments-common.collapsed.replies.more",
        defaultMessage: "{numCollapsedReplies} more replies"
    },
    unreadInlineComment: {
        id: "inline-comments-common.unread.inline.comment",
        defaultMessage: "This is an unread inline comment"
    },
    deletedCommentActionLabel: {
        id: "inline-comments-common.deleted.comment.action.label",
        defaultMessage: "This comment has been deleted"
    },
    resolvedText: {
        id: "inline-comments-common.resolved",
        defaultMessage: "[Resolved]"
    },
    resolvedFlagText: {
        id: "inline-comments-common.resolved.flag.text",
        defaultMessage: "Comment resolved"
    },
    deletedText: {
        id: "inline-comments-common.deleted",
        defaultMessage: "[Deleted]"
    },
    copyLink: {
        id: "inline-comments-common.copy.link",
        defaultMessage: "Copy link"
    },
    goToCommentCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.gotocomment",
        defaultMessage: "Go to comment"
    },
    undoCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.undo",
        defaultMessage: "Undo"
    },
    contentDeleted: {
        id: "inline-comments-common.content.deleted",
        defaultMessage: "Content deleted"
    },
    originalContentDeleted: {
        id: "inline-comments-common.original.content.deleted",
        defaultMessage: "Original content deleted"
    },
    thisContentWasDeleted: {
        id: "inline-comments-common.dangling.comments.this.content.was.deleted",
        defaultMessage: "This content was deleted."
    },
    viewDeletedContent: {
        id: "inline-comments-common.dangling.comments.view.deleted.content",
        defaultMessage: "View deleted content"
    },
    collapseDeletedContent: {
        id: "inline-comments-common.dangling.comments.collapse.deleted.content",
        defaultMessage: "Collapse deleted content"
    }
});
module.exports["i18n"] = $90dae8a726ff859c$export$a7357cdd1f0b0168;

});

parcelRegister("kmHPt", function(module, exports) {
var $b271ebdedd90282b$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $b271ebdedd90282b$export$b21a3980a7aad169;

});

parcelRegister("8QQGs", function(module, exports) {
"use strict";
var $671c0bfbaf864118$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $671c0bfbaf864118$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $671c0bfbaf864118$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $671c0bfbaf864118$var$catchError;
var $671c0bfbaf864118$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $671c0bfbaf864118$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $671c0bfbaf864118$var$CatchSubscriber = function(_super) {
    $671c0bfbaf864118$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($dZ9AU.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("2mnXV", function(module, exports) {
"use strict";
var $1b8039eb254298fd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $1b8039eb254298fd$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $1b8039eb254298fd$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $1b8039eb254298fd$var$distinctUntilChanged;
var $1b8039eb254298fd$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1b8039eb254298fd$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1b8039eb254298fd$var$DistinctUntilChangedSubscriber = function(_super) {
    $1b8039eb254298fd$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $3FcLR.tryCatch(this.keySelector)(value);
            if (key === $6LPWz.errorObject) return this.destination.error($6LPWz.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $3FcLR.tryCatch(this.compare)(this.key, key);
            if (result === $6LPWz.errorObject) return this.destination.error($6LPWz.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($axeml.Subscriber);

});

parcelRegister("3VDUL", function(module, exports) {
"use strict";
var $2dc5a83127dcb05a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $2dc5a83127dcb05a$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $2dc5a83127dcb05a$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $2dc5a83127dcb05a$var$skipWhile;
var $2dc5a83127dcb05a$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2dc5a83127dcb05a$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2dc5a83127dcb05a$var$SkipWhileSubscriber = function(_super) {
    $2dc5a83127dcb05a$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($axeml.Subscriber);

});

parcelRegister("j8M4E", function(module, exports) {
"use strict";
var $def40e2be1e8c847$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $def40e2be1e8c847$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $def40e2be1e8c847$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $def40e2be1e8c847$var$switchMap;
var $def40e2be1e8c847$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $def40e2be1e8c847$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $def40e2be1e8c847$var$SwitchMapSubscriber = function(_super) {
    $def40e2be1e8c847$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $dZ9AU.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("i3vZV", function(module, exports) {
"use strict";
var $d25153e5d88b6a52$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3u6GG = parcelRequire("3u6GG");

function $d25153e5d88b6a52$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    return function(source) {
        return source.lift(new $d25153e5d88b6a52$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $d25153e5d88b6a52$var$timeInterval;
var $d25153e5d88b6a52$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $d25153e5d88b6a52$var$TimeInterval;
var $d25153e5d88b6a52$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $d25153e5d88b6a52$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d25153e5d88b6a52$var$TimeIntervalSubscriber = function(_super) {
    $d25153e5d88b6a52$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $d25153e5d88b6a52$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($axeml.Subscriber);

});

parcelRegister("ePuNq", function(module, exports) {
"use strict";
var $acbdb7992e24bbb8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $kVeeY = parcelRequire("kVeeY");


var $axeml = parcelRequire("axeml");


var $6GdLZ = parcelRequire("6GdLZ");

/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $acbdb7992e24bbb8$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    var absoluteTimeout = $kVeeY.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $acbdb7992e24bbb8$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $6GdLZ.TimeoutError()));
    };
}
module.exports.timeout = $acbdb7992e24bbb8$var$timeout;
var $acbdb7992e24bbb8$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $acbdb7992e24bbb8$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $acbdb7992e24bbb8$var$TimeoutSubscriber = function(_super) {
    $acbdb7992e24bbb8$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($axeml.Subscriber);

});

parcelRegister("6GdLZ", function(module, exports) {
"use strict";
var $4dd15960f755eae6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $4dd15960f755eae6$var$TimeoutError = function(_super) {
    $4dd15960f755eae6$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $4dd15960f755eae6$var$TimeoutError;

});

parcelRegister("5h38X", function(module, exports) {
"use strict";
var $3d70fa8830a46307$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");


var $bGuMq = parcelRequire("bGuMq");

/**
 * @class BehaviorSubject<T>
 */ var $3d70fa8830a46307$var$BehaviorSubject = function(_super) {
    $3d70fa8830a46307$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $bGuMq.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($augeV.Subject);
module.exports.BehaviorSubject = $3d70fa8830a46307$var$BehaviorSubject;

});

parcelRegister("cZRYC", function(module, exports) {

var $21K7m = parcelRequire("21K7m");


var $9wGTI = parcelRequire("9wGTI");


var $cD1qu = parcelRequire("cD1qu");

const $360cac0569dadbce$export$24cbf19a725de615 = ({ id: id, threadKey: threadKey, setIsThreadHovered: setIsThreadHovered, setHoveredCommentId: setHoveredCommentId, pageMode: pageMode, eventEmitter: eventEmitter })=>{
    if (threadKey) {
        setIsThreadHovered(true);
        id && setHoveredCommentId(id);
        if ((0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) {
            if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) eventEmitter?.emit('sethoveredannotation', threadKey);
            else eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, {
                annotationId: threadKey
            });
        }
    }
};
const $360cac0569dadbce$export$8ce16d4c9a8b2b8a = ({ threadKey: threadKey, setIsThreadHovered: setIsThreadHovered, setHoveredCommentId: setHoveredCommentId, pageMode: pageMode, eventEmitter: eventEmitter })=>{
    if (threadKey) {
        setIsThreadHovered(false);
        setHoveredCommentId(undefined);
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) eventEmitter?.emit('removehoveredannotation', threadKey);
        else eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, {
            annotationId: threadKey
        });
    }
};
module.exports["handleCommentThreadMouseEnter"] = $360cac0569dadbce$export$24cbf19a725de615;
module.exports["handleCommentThreadMouseLeave"] = $360cac0569dadbce$export$8ce16d4c9a8b2b8a;

});

parcelRegister("i8TeS", function(module, exports) {
/* BaseCommentThread.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $8jHAi = parcelRequire("8jHAi");


var $8i27m = parcelRequire("8i27m");


var $cAdj8 = parcelRequire("cAdj8");


var $dANtQ = parcelRequire("dANtQ");


var $3ejfs = parcelRequire("3ejfs");


var $6faGq = parcelRequire("6faGq");


var $3iaSn = parcelRequire("3iaSn");


var $3mVfX = parcelRequire("3mVfX");


var $9wGTI = parcelRequire("9wGTI");


var $fHAwL = parcelRequire("fHAwL");


var $6mKj3 = parcelRequire("6mKj3");


var $cZRYC = parcelRequire("cZRYC");

const $74b51dc92462c104$var$styles = {
    threadBoxStyles: "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _kqswh2mm _19bvpxbi _u5f3pxbi _ca0qpxbi _n3tdpxbi _1e0c1txw _2lx21bp4",
    selectedThreadStyles: "_bfhkl4ek",
    commentTypeSeperatorStyle: "_zulp1b66 _x3doia51 _ca0q1ejb _u5f31ejb _n3tdutpp _19bvpxbi",
    commentBodyBoxStyles: "_qtt8glyw _kqswh2mm"
};
const $74b51dc92462c104$var$i18n = (0, $cgtv4.defineMessages)({
    commentTypeSeperatorText: {
        id: "comments-common.comment.thread.type-seperator",
        defaultMessage: "General comments"
    },
    threadContentAriaLabelWithName: {
        // COMMENTS-5979: ObjectCommentThread doesn't have timestamp, but it probably should
        id: "comments-common.thread.content.aria-label.with-name",
        defaultMessage: "{name}\u2019s comment thread, {timestamp}"
    }
}); // This component renders the parent comment and its replies.
const $74b51dc92462c104$export$a9ce751de1bf208f = ({ commentThreadRef: commentThreadRef, commentComponent: commentComponent, commentRepliesComponent: commentRepliesComponent, parentComment: parentComment, eventEmitter: eventEmitter, pageMode: pageMode, shouldRenderCommentTypeSeparator: shouldRenderCommentTypeSeparator, disallowAddComments: disallowAddComments = false, handleCommentThreadClick: handleCommentThreadClick, handleCommentThreadMouseDown: onCommentThreadMouseDown, testIdPrefix: testIdPrefix })=>{
    const intl = (0, $8C5kA.default)();
    const { formatMessage: formatMessage } = intl;
    const [{ currentlySelectedThreadKey: currentlySelectedThreadKey, commentsMarkedAsRead: commentsMarkedAsRead }, { setCommentsInThreadToBeMarkedAsRead: setCommentsInThreadToBeMarkedAsRead }] = (0, $3mVfX.useCommentsPanel)();
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const threadKey = parentComment.type === (0, $8i27m.CommentType).INLINE ? parentComment.location.inlineMarkerRef ?? '' : parentComment.id;
    const [isThreadHovered, setIsThreadHovered] = (0, $42omo.useState)(false);
    const [isThreadPressed, setIsThreadPressed] = (0, $42omo.useState)(false);
    const [hoveredCommentId, setHoveredCommentId] = (0, $42omo.useState)(undefined);
    const [commentIsFocused, setCommentIsFocused] = (0, $42omo.useState)(false);
    const isCurrentSelectedComment = currentlySelectedThreadKey === threadKey;
    const { canAddComments: hasPermsToAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(pageInfo?.id ?? ''); // TODO: COMMENTS-5980: ObjectCommentThread passes true as second argument
    const canAddComments = hasPermsToAddComments && !disallowAddComments;
    (0, $42omo.useEffect)(()=>{
        const parentIdOfSelectedReply = parentComment?.replies?.find((reply)=>reply.id === currentlySelectedThreadKey);
        if (isCurrentSelectedComment || parentIdOfSelectedReply) setIsThreadPressed(true);
        else setIsThreadPressed(false);
    }, [
        currentlySelectedThreadKey,
        isCurrentSelectedComment,
        parentComment?.replies
    ]);
    const handleCommentThreadMouseDown = (0, $42omo.useCallback)(()=>{
        onCommentThreadMouseDown?.(); /**
                                   * Limiting executions of this function because updating isThreadPressed
                                   * rerenders every component in this tree. Most notably, a user clicking into
                                   * the reply comment editor will call this function every time (and really any sibling component).
                                   * 1. isThreadPressed is only used as a style variable alongside isCurrentSelectedComment
                                   * 2. if clicking doesn't change threadKey then currentlySelectedThreadKey never changes either
                                   * which are the two variables isCurrentSelectedComment compares. We should only call this function
                                   * if threadKey has changed.
                                   */ 
        if (!isCurrentSelectedComment) setIsThreadPressed(true);
    }, [
        onCommentThreadMouseDown,
        isCurrentSelectedComment
    ]);
    const handleCommentThreadHoverProps = (0, $42omo.useMemo)(()=>({
            threadKey: threadKey,
            setIsThreadHovered: setIsThreadHovered,
            setHoveredCommentId: setHoveredCommentId,
            pageMode: pageMode,
            eventEmitter: eventEmitter
        }), [
        threadKey,
        setIsThreadHovered,
        setHoveredCommentId,
        pageMode,
        eventEmitter
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)((id)=>{
        (0, $cZRYC.handleCommentThreadMouseEnter)({
            ...handleCommentThreadHoverProps,
            id: id
        });
    }, [
        handleCommentThreadHoverProps
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        (0, $cZRYC.handleCommentThreadMouseLeave)(handleCommentThreadHoverProps);
    }, [
        handleCommentThreadHoverProps
    ]);
    const handleFocus = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation();
        setCommentIsFocused(true);
    }, [
        setCommentIsFocused
    ]);
    const handleBlur = (0, $42omo.useCallback)((event)=>{
        // Only clear focus if we're not focusing a child element
        if (!event.relatedTarget || !event.currentTarget.contains(event.relatedTarget)) setCommentIsFocused(false);
    }, [
        setCommentIsFocused
    ]);
    const unreadParentCommentAlreadyMarkedAsReadRef = (0, $42omo.useRef)(false);
    if (isCurrentSelectedComment && !unreadParentCommentAlreadyMarkedAsReadRef.current && parentComment.isUnread && !(0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) {
        setCommentsInThreadToBeMarkedAsRead({
            threadKey: threadKey,
            commentIds: [
                parentComment.id
            ],
            commentType: parentComment.type
        });
        unreadParentCommentAlreadyMarkedAsReadRef.current = true;
    }
    const isCommentRemovedByAnotherUser = parentComment?.wasRemovedByAnotherUser;
    const isResolvedByAnotherUser = isCommentRemovedByAnotherUser && isCommentRemovedByAnotherUser === (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD; // if comment thread is resolved, mark it as read exactly once
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        if (isResolvedByAnotherUser) {
            const unreadCommentIds = [];
            if (parentComment.isUnread) unreadCommentIds.push(parentComment.id);
            const unreadReplies = parentComment.replies.filter((reply)=>reply.isUnread);
            if (unreadReplies.length > 0) unreadCommentIds.push(...unreadReplies.map((reply)=>reply.id));
            if (unreadCommentIds.length > 0) setCommentsInThreadToBeMarkedAsRead({
                threadKey: threadKey,
                commentIds: unreadCommentIds,
                commentType: parentComment.type
            });
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const resolveProperties = parentComment.location?.inlineResolveProperties || parentComment.location?.commentResolveProperties || undefined;
    const commentStatus = (0, $3iaSn.useGetCommentStatus)({
        resolveProperties: resolveProperties
    });
    const timestamp = (0, $6faGq.formatTimestampForAriaLabel)({
        intl: intl,
        dateString: parentComment.createdAtNonLocalized,
        commentStatus: commentStatus,
        resolveProperties: resolveProperties
    });
    const testIdPrefixWithDelimiter = testIdPrefix ? `${testIdPrefix}-` : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldRenderCommentTypeSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $74b51dc92462c104$var$styles.commentTypeSeperatorStyle,
        as: "li",
        testId: "comment-section-separator",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
        testId: "general-comment-page-icon",
        color: "var(--ds-icon-subtlest, #6B6E76)",
        label: formatMessage($74b51dc92462c104$var$i18n.commentTypeSeperatorText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        weight: "medium"
    }, formatMessage($74b51dc92462c104$var$i18n.commentTypeSeperatorText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: commentThreadRef,
        id: `${testIdPrefixWithDelimiter}comment-thread-${threadKey}-container`,
        testId: `${testIdPrefixWithDelimiter}comment-thread-${threadKey}-container`,
        xcss: (0, $1Whri.cx)($74b51dc92462c104$var$styles.threadBoxStyles, (isCurrentSelectedComment || isThreadPressed) && $74b51dc92462c104$var$styles.selectedThreadStyles),
        "data-selected-comment-thread": isCurrentSelectedComment && parentComment.location?.inlineMarkerRef ? parentComment.location.inlineMarkerRef : undefined,
        onClick: handleCommentThreadClick,
        onMouseDown: handleCommentThreadMouseDown,
        onMouseUp: ()=>setIsThreadPressed(false),
        onFocus: handleFocus,
        onBlur: handleBlur,
        onKeyDown: ()=>{},
        tabIndex: 0,
        "aria-label": formatMessage($74b51dc92462c104$var$i18n.threadContentAriaLabelWithName, {
            name: parentComment.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous),
            timestamp: timestamp
        }),
        ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
            role: 'button'
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: `${testIdPrefixWithDelimiter}comment-thread-${parentComment.id}-parent`,
        xcss: $74b51dc92462c104$var$styles.commentBodyBoxStyles,
        onMouseEnter: ()=>handleMouseEnter(parentComment.id),
        onMouseLeave: handleMouseLeave
    }, commentComponent({
        comment: parentComment,
        pageInfo: pageInfo,
        pageMode: pageMode,
        isUnread: (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes') ? unreadCommentIDSet.has(parentComment.id) : !commentsMarkedAsRead[parentComment.type][threadKey]?.has(parentComment.id) && parentComment.isUnread,
        isHovered: hoveredCommentId === parentComment.id || commentIsFocused && (0, $9wGTI.fg)('confluence_comments_hover_state_on_focused_comment'),
        threadKey: threadKey,
        hideBranchingStyle: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? parentComment.replies.length === 0 : (!parentComment.isOpen || !canAddComments) && parentComment.replies.length === 0,
        canAddComments: canAddComments,
        isThreadHovered: isThreadHovered
    })), commentRepliesComponent({
        parentComment: parentComment,
        pageInfo: pageInfo,
        isCurrentSelectedComment: isCurrentSelectedComment,
        hoveredCommentId: hoveredCommentId ?? '',
        pageMode: pageMode,
        parentCommentId: parentComment.id,
        handleMouseEnter: handleMouseEnter,
        handleMouseLeave: handleMouseLeave,
        canAddComments: canAddComments
    })));
};
module.exports["BaseCommentThread"] = $74b51dc92462c104$export$a9ce751de1bf208f;

});

parcelRegister("666Tc", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $4KS7f = parcelRequire("4KS7f");


var $9wGTI = parcelRequire("9wGTI");

const $003eb47e4cfe7fce$var$slideOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$48377ae1c677702b = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "ul" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c81o8v _1yt4v0yc _1e0c1txw _1n261g80 _4cvr1h6o _1tke1f4h",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81o8v _1yt4v0yc _1e0c1txw _1n261g80 _4cvr1h6o _1tke1f4h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4fbc87ee9c503b41 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1as91r31 _j4qy8stv _1wwgnqa1 _v0fytlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1as91r31 _j4qy8stv _1wwgnqa1 _v0fytlke",
            __cmplp.className
        ])
    });
});
const $003eb47e4cfe7fce$export$f39f3f768bc98e3d = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isSticky: isSticky, isAutoDismissResolve: isAutoDismissResolve, ...__cmpldp } = __cmplp;
        const { rightOffset: t3 } = __cmplp;
        const rightOffset = t3 === undefined ? 0 : t3;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_16090q4": (0, $7sObp.default)(`${rightOffset}px`),
                "--_162hus6": (0, $7sObp.default)(__cmplp.offset, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_19itia51 _2rko1l7b _16qs1nax _bfhkvuon _1xi21dwo _154i1odf _1e0c1txw _2lx21bp4 _vchhusvi _otyr53f4 _1bsb1178 _c71lglyw",
                __cmplp.mode === "view" ? "_1pbyibnn" : "_1pby1ap8",
                __cmplp.isSticky ? "_kqsw1n9t" : "_kqswstnw",
                Boolean(__cmplp.isAutoDismissResolve) && "",
                Boolean(__cmplp.isAutoDismissResolve) && "_y44vuwz3",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSticky: isSticky, isAutoDismissResolve: isAutoDismissResolve, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_16090q4": (0, $7sObp.default)((()=>{
                const { rightOffset: rightOffset = 0 } = __cmplp;
                return `${rightOffset}px`;
            })()),
            "--_162hus6": (0, $7sObp.default)(__cmplp.offset, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itia51 _2rko1l7b _16qs1nax _bfhkvuon _1xi21dwo _154i1odf _1e0c1txw _2lx21bp4 _vchhusvi _otyr53f4 _1bsb1178 _c71lglyw",
            __cmplp.mode === 'view' ? "_1pbyibnn" : "_1pby1ap8",
            __cmplp.isSticky ? "_kqsw1n9t" : "_kqswstnw",
            Boolean(__cmplp.isAutoDismissResolve) && "",
            Boolean(__cmplp.isAutoDismissResolve) && "_y44vuwz3",
            __cmplp.className
        ])
    });
});
const $003eb47e4cfe7fce$export$18986330a3dbad03 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _bfhkvuon _521wia51",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _bfhkvuon _521wia51",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$86b1f0d05f7b12cd = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(10);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isCommentsPanel: isCommentsPanel, isFabricPage: isFabricPage, ...__cmpldp } = __cmplp;
        const basePadding = __cmplp.mode === "view" ? "var(--ds-space-150, 12px) var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px) var(--ds-space-150, 12px)";
        const t3 = __cmplp.isCommentsPanel ? "0" : basePadding;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = (0, $7sObp.default)((0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "var(--ds-space-075, 6px) var(--ds-space-100, 8px)" : "var(--ds-space-050, 4px)");
            $[5] = t5;
        } else t5 = $[5];
        let t6;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = (0, $7sObp.default)((0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "var(--ds-text-subtlest, #6B6E76)" : "var(--ds-text-disabled, #080F214A)");
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] !== __cmpls || $[8] !== t4) {
            t7 = {
                ...__cmpls,
                "--_1ms47y0": t4,
                "--_567avp": t5,
                "--_1n1whry": t6
            };
            $[7] = __cmpls;
            $[8] = t4;
            $[9] = t7;
        } else t7 = $[9];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t7,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1yt41vmh _n3tdpxbi _1k0c1qnt _159vzwfg _1wv15a2x",
                __cmplp.isCommentsPanel || __cmplp.isFabricPage && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "_x3doglyw" : "_x3doj0fz",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCommentsPanel: isCommentsPanel, isFabricPage: isFabricPage, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ms47y0": (0, $7sObp.default)((()=>{
                const basePadding = __cmplp.mode === 'view' ? `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"}` : `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`;
                return __cmplp.isCommentsPanel ? '0' : basePadding;
            })()),
            "--_567avp": (0, $7sObp.default)((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}` : "var(--ds-space-050, 4px)"),
            "--_1n1whry": (0, $7sObp.default)((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? "var(--ds-text-subtlest, #6B6E76)" : "var(--ds-text-disabled, #080F214A)")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41vmh _n3tdpxbi _1k0c1qnt _159vzwfg _1wv15a2x",
            __cmplp.isCommentsPanel || __cmplp.isFabricPage && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? "_x3doglyw" : "_x3doj0fz",
            __cmplp.className
        ])
    });
});
const $003eb47e4cfe7fce$export$5aae1a36fc838370 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41jx0 _1e0c1txw _4cvr1h6o _2lx21bp4 _1i7v1o8v _9a6v14no _kckd15o9 _125xi7uo _31ku1h6o _ekv61o8v _dkzuutpp _5lhmtlke _1pzm1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41jx0 _1e0c1txw _4cvr1h6o _2lx21bp4 _1i7v1o8v _9a6v14no _kckd15o9 _125xi7uo _31ku1h6o _ekv61o8v _dkzuutpp _5lhmtlke _1pzm1h6o",
            __cmplp.className
        ])
    });
}); // View mode styled components
const $003eb47e4cfe7fce$export$b38a2fd24b22fb35 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isReply: isReply, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "",
            !__cmplp.isReply && "_1yt4utpp _n7zlia51",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReply: isReply, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            !__cmplp.isReply && "_1yt4utpp _n7zlia51",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$d1b98bde82a43bb3 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { shouldHaveButtonGap: shouldHaveButtonGap, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1usn19bv _1achz0dk _1scmazsu",
            __cmplp.shouldHaveButtonGap && "_zulpv77o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveButtonGap: shouldHaveButtonGap, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1usn19bv _1achz0dk _1scmazsu",
            __cmplp.shouldHaveButtonGap && "_zulpv77o",
            __cmplp.className
        ])
    });
});
const $003eb47e4cfe7fce$export$6e006bd290301009 = '24px';
const $003eb47e4cfe7fce$export$3421cb2750fe78a7 = '28px';
const $003eb47e4cfe7fce$export$28ae196bde1430fd = '24px'; // Needed to get the correct overall size to match the comment icon next to it
const $003eb47e4cfe7fce$var$inlineHeaderButtonTheme = (isSSRFocusedComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                background: 'none',
                borderRadius: "var(--ds-radius-small, 4px)",
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: $003eb47e4cfe7fce$export$6e006bd290301009,
                '&:hover': {
                    backgroundColor: `${"var(--ds-surface-hovered, #F0F1F2)"}`
                },
                '&:focus': {
                    boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #4688EC)"}`
                },
                cursor: isSSRFocusedComment ? 'not-allowed' : 'pointer',
                '*': {
                    color: isSSRFocusedComment ? `${"var(--ds-text-subtlest, #6B6E76)"}` : `inherit`
                }
            }
        };
    };
const $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5 = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    let t0;
    if ($[0] !== props.isSSRFocusedComment) {
        t0 = $003eb47e4cfe7fce$var$inlineHeaderButtonTheme(props.isSSRFocusedComment);
        $[0] = props.isSSRFocusedComment;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            theme: t0,
            ...props
        });
        $[2] = props;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        theme: $003eb47e4cfe7fce$var$inlineHeaderButtonTheme(props.isSSRFocusedComment),
        ...props
    });
const $003eb47e4cfe7fce$export$e575a964a1fe8b0 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { shouldShowNavigation: shouldShowNavigation, isReattachHeader: isReattachHeader, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm _1e0c1txw _19bvutpp _u5f3utpp",
            __cmplp.shouldShowNavigation ? "_1bah1yb4" : "_1bahesu3",
            __cmplp.shouldShowNavigation && "_4t3i10yn _ca0qutpp",
            __cmplp.isReattachHeader && "_4t3i10yn _ca0qpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShowNavigation: shouldShowNavigation, isReattachHeader: isReattachHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _1e0c1txw _19bvutpp _u5f3utpp",
            __cmplp.shouldShowNavigation ? "_1bah1yb4" : "_1bahesu3",
            __cmplp.shouldShowNavigation && "_4t3i10yn _ca0qutpp",
            __cmplp.isReattachHeader && "_4t3i10yn _ca0qpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$b3b0191112eea395 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $003eb47e4cfe7fce$export$f39f3f768bc98e3d : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1178 _4t3irvwn",
            __cmplp.showSkeleton ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = $003eb47e4cfe7fce$export$f39f3f768bc98e3d, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1178 _4t3irvwn",
            __cmplp.showSkeleton ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $003eb47e4cfe7fce$export$f895097fe90363d1 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { showNavigation: showNavigation, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.showNavigation ? "_19pkxy5q" : "_19pkze3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showNavigation: showNavigation, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.showNavigation ? "_19pkxy5q" : "_19pkze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$32dd8f1956fe77b1 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswstnw _1xi2utpp _1pbykb7n _154iutpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswstnw _1xi2utpp _1pbykb7n _154iutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4b61d9d7155e9162 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulp12x7 _kqswstnw _154ipxbi _1ltvpxbi _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp12x7 _kqswstnw _154ipxbi _1ltvpxbi _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $003eb47e4cfe7fce$var$closeButtonTheme = (isUpdatedStandaloneComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: isUpdatedStandaloneComment ? $003eb47e4cfe7fce$export$28ae196bde1430fd : $003eb47e4cfe7fce$export$3421cb2750fe78a7
            }
        };
    };
const $003eb47e4cfe7fce$export$de65de8213222d10 = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const t0 = props.isUpdatedStandaloneComment ?? false;
    let t1;
    if ($[0] !== t0) {
        t1 = $003eb47e4cfe7fce$var$closeButtonTheme(t0);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            theme: t1,
            ...props
        });
        $[2] = props;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        theme: $003eb47e4cfe7fce$var$closeButtonTheme(props.isUpdatedStandaloneComment ?? false),
        ...props
    });
module.exports["ActionsContainer"] = $003eb47e4cfe7fce$export$48377ae1c677702b;
module.exports["SidebarContainer"] = $003eb47e4cfe7fce$export$f39f3f768bc98e3d;
module.exports["ReplyListContainer"] = $003eb47e4cfe7fce$export$18986330a3dbad03;
module.exports["NewReplyContainer"] = $003eb47e4cfe7fce$export$86b1f0d05f7b12cd;
module.exports["ResolvedNotificationContainer"] = $003eb47e4cfe7fce$export$5aae1a36fc838370;
module.exports["EditorContainer"] = $003eb47e4cfe7fce$export$b38a2fd24b22fb35;
module.exports["NavigationContainer"] = $003eb47e4cfe7fce$export$d1b98bde82a43bb3;
module.exports["InlineHeaderButton"] = $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5;
module.exports["SidebarHeader"] = $003eb47e4cfe7fce$export$e575a964a1fe8b0;
module.exports["LoadingSkeletonContainer"] = $003eb47e4cfe7fce$export$b3b0191112eea395;
module.exports["TopContainer"] = $003eb47e4cfe7fce$export$f895097fe90363d1;
module.exports["CloseButtonContainer"] = $003eb47e4cfe7fce$export$32dd8f1956fe77b1;
module.exports["CloseButton"] = $003eb47e4cfe7fce$export$de65de8213222d10;

});

parcelRegister("fURMF", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $1dnxO = parcelRequire("1dnxO");


var $9wGTI = parcelRequire("9wGTI");

const $e9d2c346c5e28ee8$var$logger = (0, $7W8i8.getLogger)('scroll-to-element');
const $e9d2c346c5e28ee8$export$aa10bd88079cd4f3 = 60;
/**
 * Returns the HTMLElement that should be used as the scroll root. By default, this is the window.
 * For Nav 4, this is the div with id=AkMainContent, if the id exists in the DOM
 *
 * @param isNav4Enabled - boolean
 */ function $e9d2c346c5e28ee8$var$getScrollRootElement(isNav4Enabled = false) {
    //if we are in mobile size for nav4, we should still scroll window.
    // the magic number below maps to media.above.md @media (min-width: 64rem)	1024px which sadly appears to have no means of access in pure JS
    if (isNav4Enabled && window.innerWidth > 1023 && document.getElementById('AkMainContent')) return document.getElementById('AkMainContent');
    return window;
}
const $e9d2c346c5e28ee8$var$explicitScrollListeners = new Set();
function $e9d2c346c5e28ee8$export$73ac910751bb2a9b(listener) {
    $e9d2c346c5e28ee8$var$explicitScrollListeners.add(listener);
    return ()=>$e9d2c346c5e28ee8$var$explicitScrollListeners.delete(listener);
}


function $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners() {
    $e9d2c346c5e28ee8$var$explicitScrollListeners.forEach((listener)=>{
        try {
            listener();
        } catch (error) {
            Promise.all([
                (parcelRequire("kI6Jo")),
                (parcelRequire("YiYda"))
            ]).then(([{ getMonitoringClient: getMonitoringClient }, { Attribution: Attribution }])=>{
                getMonitoringClient().submitError(error, {
                    attribution: Attribution.PAGE_EXTENSIONS
                });
            }).catch(()=>{
            // ignore errors, we can't do anything at this point
            });
        }
    });
}
function $e9d2c346c5e28ee8$var$isSmoothScrollSupported() {
    return 'scrollBehavior' in document.documentElement.style;
}
function $e9d2c346c5e28ee8$export$9b071b9c6dd786a2(isSmooth = false) {
    $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners();
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const scrollRootElement = $e9d2c346c5e28ee8$var$getScrollRootElement(isNav4Enabled);
    if (scrollRootElement) {
        //typecheck is convinced this can be null
        if (isSmooth && $e9d2c346c5e28ee8$var$isSmoothScrollSupported()) scrollRootElement.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        else scrollRootElement.scrollTo(0, 0);
    }
}
function $e9d2c346c5e28ee8$export$2353115f31f4d15(element, scrollCorrectionPixels, scrollBehavior = 'auto', isLivePage) {
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const scrollRootElement = isLivePage ? document.querySelector('.fabric-editor-popup-scroll-parent') : $e9d2c346c5e28ee8$var$getScrollRootElement(isNav4Enabled);
    let parentsOffset = 0;
    let currentOffsetParent = element.offsetParent;
    while(currentOffsetParent instanceof HTMLElement && currentOffsetParent != scrollRootElement){
        parentsOffset += currentOffsetParent.offsetTop;
        currentOffsetParent = currentOffsetParent.offsetParent;
    }
    const pageHeaderHeightAdjustment = isNav4Enabled ? (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? 56 : 0 : $e9d2c346c5e28ee8$export$aa10bd88079cd4f3;
    let top = element.offsetTop + (scrollCorrectionPixels || 0) + parentsOffset - pageHeaderHeightAdjustment;
    // check if element is nested inside table, if so we need to account for
    // sticky table header overlapping the element
    const hasTableParent = element?.closest('.pm-table-container td');
    if (hasTableParent && scrollCorrectionPixels) top = top + scrollCorrectionPixels * 1.25;
    $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners();
    let behavior = scrollBehavior;
    if (behavior === 'smooth' && !$e9d2c346c5e28ee8$var$isSmoothScrollSupported()) behavior = 'auto';
    try {
        scrollRootElement?.scroll({
            top: top,
            behavior: behavior
        });
    } catch (err) {
        isNav4Enabled ? $e9d2c346c5e28ee8$var$logger.error`scroll() is not supported on #AkMainContent` : $e9d2c346c5e28ee8$var$logger.error`window.scroll() is not supported`;
    }
}
module.exports["scrollToPageStart"] = $e9d2c346c5e28ee8$export$9b071b9c6dd786a2;
module.exports["scrollToElement"] = $e9d2c346c5e28ee8$export$2353115f31f4d15;

});

parcelRegister("kI6Jo", function(module, exports) {

let $f13d236567563fe5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f13d236567563fe5$var$load("9fiFD").then(()=>parcelRequire('6SqQk'));

});

parcelRegister("YiYda", function(module, exports) {

let $0b5451c9b84ee3f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0b5451c9b84ee3f1$var$load("fH5Zm").then(()=>parcelRequire('bZmZf'));

});

parcelRegister("daq5m", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $8jHAi = parcelRequire("8jHAi");


var $jJK3p = parcelRequire("jJK3p");


var $fs6LW = parcelRequire("fs6LW");


var $1YXTQ = parcelRequire("1YXTQ");


var $gvWVt = parcelRequire("gvWVt");


var $6faGq = parcelRequire("6faGq");


var $7tI6B = parcelRequire("7tI6B");


var $9wGTI = parcelRequire("9wGTI");


var $3ejfs = parcelRequire("3ejfs");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $6b5EI = parcelRequire("6b5EI");

const $005e7fbdd3b99ea0$var$CommentAuthorInlineCommentAuthorQuery = (0, $eSUdr.default)`query CommentAuthorInlineCommentAuthorQuery($commentId:ID!){content(id:$commentId){nodes{id history{createdBy{displayName profilePicture{path}...on KnownUser{accountId}}}}}}`;
const $005e7fbdd3b99ea0$var$CommentAuthorUserQuery = (0, $eSUdr.default)`query CommentAuthorUserQuery($id:ID!){user:confluence_atlassianUser(id:$id){id displayName photos{value}}}`;
const $005e7fbdd3b99ea0$var$getAuthorContainerMarginLeft = ({ isFixedEditStyles: isFixedEditStyles, commentMode: commentMode, isReply: isReply, isStandaloneComment: isStandaloneComment, isFooterComment: isFooterComment })=>{
    if (isFixedEditStyles) return commentMode === 'edit' && (isReply || isStandaloneComment || isFooterComment ? '0' : '-24px');
    return commentMode === 'reply' ? '-2px' : 'inherit';
};
const $005e7fbdd3b99ea0$var$getAuthorContainerPaddingBottom = ({ isFixedEditStyles: isFixedEditStyles, commentMode: commentMode, isReply: isReply })=>{
    if (isFixedEditStyles) return commentMode === 'edit' && (isReply ? '8px' : '12px');
    return commentMode === 'view' ? undefined : '8px';
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $005e7fbdd3b99ea0$var$AuthorContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1lfhtsa": (0, $7sObp.default)($005e7fbdd3b99ea0$var$getAuthorContainerMarginLeft(__cmplp)),
                "--_b6gqaj": (0, $7sObp.default)($005e7fbdd3b99ea0$var$getAuthorContainerPaddingBottom(__cmplp))
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1reowpa7 _18m9wpa7 _1e0c1txw _4cvr1h6o _18u0h411 _n3td1ymm _jva41snc _uvzw1snc _wkreagmp _12rjagmp _gcmzvv82 _1vjrvv82 _5xy14viv _1dtc4viv _1msj4viv",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1lfhtsa": (0, $7sObp.default)($005e7fbdd3b99ea0$var$getAuthorContainerMarginLeft(__cmplp)),
            "--_b6gqaj": (0, $7sObp.default)($005e7fbdd3b99ea0$var$getAuthorContainerPaddingBottom(__cmplp))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reowpa7 _18m9wpa7 _1e0c1txw _4cvr1h6o _18u0h411 _n3td1ymm _jva41snc _uvzw1snc _wkreagmp _12rjagmp _gcmzvv82 _1vjrvv82 _5xy14viv _1dtc4viv _1msj4viv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $005e7fbdd3b99ea0$var$AvatarWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isCommentsPanel: isCommentsPanel, isFooterComment: isFooterComment, isFixedEditStyles: isFixedEditStyles, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1hv8",
            __cmplp.isCommentsPanel || __cmplp.isFooterComment || __cmplp.isFixedEditStyles ? "_u5f312x7" : "_u5f3u2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCommentsPanel: isCommentsPanel, isFooterComment: isFooterComment, isFixedEditStyles: isFixedEditStyles, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1hv8",
            __cmplp.isCommentsPanel || __cmplp.isFooterComment || __cmplp.isFixedEditStyles ? "_u5f312x7" : "_u5f3u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _14yy2smr _hwn17g83 _1msj4viv _5xy14viv _1dtc4viv _17rp1o8v _cpznidpf _1s79idpf _amufidpf _x966idpf _387xglyw _14l5azsu _1ptk1j28 _19gdazsu _1gidazsu _1e6pazsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _14yy2smr _hwn17g83 _1msj4viv _5xy14viv _1dtc4viv _17rp1o8v _cpznidpf _1s79idpf _amufidpf _x966idpf _387xglyw _14l5azsu _1ptk1j28 _19gdazsu _1gidazsu _1e6pazsu",
            __cmplp.className
        ])
    });
});
const $005e7fbdd3b99ea0$var$newPageIconStyle = (0, $ecnYn.xcss)({
    position: 'relative'
}); // TODO: remove the following 3 styles when cleaning up `confluence_frontend_content_wrapper` flag
const $005e7fbdd3b99ea0$var$resolvedPropertiesStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050'
});
const $005e7fbdd3b99ea0$var$pageIconStyle = (0, $ecnYn.xcss)({
    position: 'relative',
    top: 'space.negative.025'
});
const $005e7fbdd3b99ea0$var$generalCommentFooterStyle = (0, $ecnYn.xcss)({
    top: 'space.negative.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$ProfileLinkContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $005e7fbdd3b99ea0$var$Container : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = $005e7fbdd3b99ea0$var$Container, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$LozengeWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19bvu2gc _s7n4jp4b",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19bvu2gc _s7n4jp4b",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$DateContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isStandaloneComment: isStandaloneComment, isCommentsPanel: isCommentsPanel, isFixedEditStyles: isFixedEditStyles, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c1txw _4cvr1h6o _102e1o8v _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _7wy0glyw _1plv1j28 _zmp8azsu _1blwazsu _9b8iazsu _1kcs1y54",
            __cmplp.isStandaloneComment && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "_2lx21bp4" : "_2lx2n7od",
            __cmplp.isStandaloneComment && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "_4cvr1y6m" : "_4cvrn7od",
            __cmplp.isStandaloneComment || __cmplp.isCommentsPanel && __cmplp.isFixedEditStyles ? "_1t4p1rpy" : "_1t4pazsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isStandaloneComment: isStandaloneComment, isCommentsPanel: isCommentsPanel, isFixedEditStyles: isFixedEditStyles, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c1txw _4cvr1h6o _102e1o8v _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _7wy0glyw _1plv1j28 _zmp8azsu _1blwazsu _9b8iazsu _1kcs1y54",
            __cmplp.isStandaloneComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? "_2lx21bp4" : "_2lx2n7od",
            __cmplp.isStandaloneComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? "_4cvr1y6m" : "_4cvrn7od",
            __cmplp.isStandaloneComment || __cmplp.isCommentsPanel && __cmplp.isFixedEditStyles ? "_1t4p1rpy" : "_1t4pazsu",
            __cmplp.className
        ])
    });
});
const $005e7fbdd3b99ea0$var$profileLinkContainerStyle = null; // confluence_comments_cohiti_date_tooltips exp evaluations will use this component-level i18n object instead of commentsI18n
const $005e7fbdd3b99ea0$var$i18n = (0, $cgtv4.defineMessages)({
    defaultTooltip: {
        id: "inline-comments-common.date-tooltip.default",
        defaultMessage: "Added on {date} at {timestamp}"
    },
    resolvedTooltip: {
        id: "inline-comments-common.date-tooltip.resolved",
        defaultMessage: "Resolved by {username} on {date} at {timeStamp}"
    },
    reopenedTooltip: {
        id: "inline-comments-common.date-tooltip.reopened",
        defaultMessage: "Reopened by {username} on {date} at {timeStamp}"
    },
    reopenedDateInfoText: {
        id: "inline-comments-common.reopened.date.info.text",
        defaultMessage: "Reopened {timeAgo}{timeStamp, select, undefined {} other { at {timeStamp}} }"
    },
    resolvedDateInfoText: {
        id: "inline-comments-common.resolved.date.info.text",
        defaultMessage: "Resolved {timeAgo}"
    }
});
const $005e7fbdd3b99ea0$export$d05a2f5fbf67a6d7 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(109);
    const { commentMode: commentMode, userId: userId, date: date, createdAtNonLocalized: createdAtNonLocalized, size: size, displayName: displayName, avatarUrl: avatarUrl, commentDateUrl: commentDateUrl, commentId: commentId, permissionType: permissionType, isInactiveComment: isInactiveComment, showCopyLink: t1, resolveProperties: resolveProperties, isCommentsPanel: t2, isGeneralComments: t3, isReply: t4, isFooterComment: t5, isStandaloneComment: t6 } = t0;
    const showCopyLink = t1 === undefined ? false : t1;
    const isCommentsPanel = t2 === undefined ? false : t2;
    const isGeneralComments = t3 === undefined ? false : t3;
    const isReply = t4 === undefined ? false : t4;
    const isFooterComment = t5 === undefined ? false : t5;
    const isStandaloneComment = t6 === undefined ? false : t6;
    let t7;
    if ($[0] !== commentId) {
        t7 = {
            commentId: commentId
        };
        $[0] = commentId;
        $[1] = t7;
    } else t7 = $[1];
    const t8 = Boolean(userId || !commentId);
    let t9;
    if ($[2] !== t7 || $[3] !== t8) {
        t9 = {
            variables: t7,
            fetchPolicy: "cache-and-network",
            skip: t8
        };
        $[2] = t7;
        $[3] = t8;
        $[4] = t9;
    } else t9 = $[4];
    const { data: authorData } = (0, $xQxzY.useQuery)($005e7fbdd3b99ea0$var$CommentAuthorInlineCommentAuthorQuery, t9);
    let t10;
    if ($[5] !== userId) {
        t10 = {
            id: userId
        };
        $[5] = userId;
        $[6] = t10;
    } else t10 = $[6];
    const t11 = Boolean(avatarUrl && displayName || !userId || commentId);
    let t12;
    if ($[7] !== t10 || $[8] !== t11) {
        t12 = {
            variables: t10,
            fetchPolicy: "cache-and-network",
            skip: t11
        };
        $[7] = t10;
        $[8] = t11;
        $[9] = t12;
    } else t12 = $[9];
    const { data: userData } = (0, $xQxzY.useQuery)($005e7fbdd3b99ea0$var$CommentAuthorUserQuery, t12);
    let t13;
    if ($[10] !== authorData?.content?.nodes) {
        t13 = (authorData?.content?.nodes || [])[0]?.history?.createdBy;
        $[10] = authorData?.content?.nodes;
        $[11] = t13;
    } else t13 = $[11];
    const author = t13;
    let t14;
    if ($[12] !== author || $[13] !== userData?.user?.photos) {
        t14 = author ? author.profilePicture?.path : (userData?.user?.photos || [])[0]?.value;
        $[12] = author;
        $[13] = userData?.user?.photos;
        $[14] = t14;
    } else t14 = $[14];
    const userAvatar = t14;
    const userDisplayName = author ? author.displayName : userData?.user?.displayName;
    const userAccountId = author?.accountId;
    const linkToComment = `${window.location.origin}/wiki${commentDateUrl}`;
    const intl = (0, $8C5kA.default)();
    const { formatMessage: formatMessage } = intl;
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    let t15;
    if ($[15] !== createdAtNonLocalized || $[16] !== formatMessage || $[17] !== intl || $[18] !== resolveProperties || $[19] !== timeZone) {
        t15 = ()=>{
            if (resolveProperties?.resolvedTime && (0, $6mKj3.expValEquals)("confluence_comments_cohiti_date_tooltips", "isEnabled", true)) {
                const i18nMessage = resolveProperties?.resolved ? $005e7fbdd3b99ea0$var$i18n.resolvedTooltip : $005e7fbdd3b99ea0$var$i18n.reopenedTooltip;
                const resolvedTimeBase = new Date(resolveProperties.resolvedTime);
                return formatMessage(i18nMessage, {
                    username: resolveProperties?.resolvedUser,
                    date: intl.formatDate(resolvedTimeBase, {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                        timeZone: timeZone
                    }),
                    timeStamp: intl.formatTime(resolvedTimeBase, {
                        hour: "numeric",
                        minute: "numeric",
                        timeZone: timeZone
                    })
                });
            }
            if (resolveProperties?.resolved) return formatMessage((0, $3ejfs.commentsi18n).resolvedByTooltipTextCommentsPanel, {
                username: resolveProperties?.resolvedUser
            });
            return formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
                username: resolveProperties?.resolvedUser,
                createdAtNonLocalized: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
                    date: (0, $6faGq.getValidDate)(createdAtNonLocalized),
                    usePrepositions: true
                })
            });
        };
        $[15] = createdAtNonLocalized;
        $[16] = formatMessage;
        $[17] = intl;
        $[18] = resolveProperties;
        $[19] = timeZone;
        $[20] = t15;
    } else t15 = $[20];
    const getTooltipContent = t15;
    let t16;
    if ($[21] !== formatMessage || $[22] !== resolveProperties?.resolvedFriendlyDate || $[23] !== resolveProperties?.resolvedUser) {
        t16 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: resolveProperties?.resolvedFriendlyDate
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "aria-label": formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                    username: resolveProperties?.resolvedUser,
                    friendlyDate: resolveProperties?.resolvedFriendlyDate
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                color: "color.text.subtlest",
                size: "small",
                maxLines: 2
            }, formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                username: resolveProperties?.resolvedUser,
                friendlyDate: resolveProperties?.resolvedFriendlyDate
            }))));
        $[21] = formatMessage;
        $[22] = resolveProperties?.resolvedFriendlyDate;
        $[23] = resolveProperties?.resolvedUser;
        $[24] = t16;
    } else t16 = $[24];
    const oldStandloneExperienceResolveInfo = t16;
    let t17;
    if ($[25] !== formatMessage || $[26] !== intl || $[27] !== resolveProperties || $[28] !== tenantTimeZone || $[29] !== timeZone || $[30] !== userTimeZone) {
        t17 = ()=>{
            const i18nKey = resolveProperties?.resolved ? "resolvedDateInfoText" : "reopenedDateInfoText";
            if (resolveProperties?.resolvedTime && (0, $6mKj3.expValEquals)("confluence_comments_cohiti_date_tooltips", "isEnabled", true)) {
                const resolvedTimeBase_0 = new Date(resolveProperties.resolvedTime);
                const secondsSinceReopen = (Date.now() - resolvedTimeBase_0.getTime()) / 1000;
                const shouldIncludeTimeStamp = secondsSinceReopen >= 86400;
                return formatMessage($005e7fbdd3b99ea0$var$i18n[i18nKey], {
                    timeAgo: (0, $1YXTQ.formatTimeAgo)(intl, resolvedTimeBase_0, true, {}, userTimeZone, tenantTimeZone),
                    timeStamp: shouldIncludeTimeStamp ? intl.formatTime(resolvedTimeBase_0, {
                        hour: "numeric",
                        minute: "numeric",
                        timeZone: timeZone
                    }) : undefined
                });
            } else return formatMessage((0, $3ejfs.commentsi18n)[i18nKey], {
                friendlyDate: resolveProperties?.resolvedFriendlyDate
            });
        };
        $[25] = formatMessage;
        $[26] = intl;
        $[27] = resolveProperties;
        $[28] = tenantTimeZone;
        $[29] = timeZone;
        $[30] = userTimeZone;
        $[31] = t17;
    } else t17 = $[31];
    const getResolvedDateInfoText = t17;
    let t18;
    if ($[32] !== getResolvedDateInfoText || $[33] !== getTooltipContent) {
        t18 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                position: "top",
                content: getTooltipContent()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "aria-label": getResolvedDateInfoText()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                color: "color.text.subtlest",
                size: "small",
                maxLines: 2
            }, getResolvedDateInfoText())));
        $[32] = getResolvedDateInfoText;
        $[33] = getTooltipContent;
        $[34] = t18;
    } else t18 = $[34];
    const newExperienceResolveInfo = t18;
    let t19;
    if ($[35] !== isCommentsPanel || $[36] !== isFooterComment || $[37] !== newExperienceResolveInfo || $[38] !== oldStandloneExperienceResolveInfo) {
        t19 = ()=>{
            const standAloneExperience = !isFooterComment && !isCommentsPanel;
            if (standAloneExperience && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") || isFooterComment && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") || isCommentsPanel) return newExperienceResolveInfo();
            return oldStandloneExperienceResolveInfo();
        };
        $[35] = isCommentsPanel;
        $[36] = isFooterComment;
        $[37] = newExperienceResolveInfo;
        $[38] = oldStandloneExperienceResolveInfo;
        $[39] = t19;
    } else t19 = $[39];
    const renderResolveInfo = t19;
    let t20;
    if ($[40] !== isFooterComment || $[41] !== isGeneralComments) {
        t20 = ()=>{
            if (!isGeneralComments) return false;
            return !isFooterComment;
        };
        $[40] = isFooterComment;
        $[41] = isGeneralComments;
        $[42] = t20;
    } else t20 = $[42];
    const hasPageCommentIconEnabled = t20;
    let t21;
    if ($[43] !== createdAtNonLocalized || $[44] !== date || $[45] !== formatMessage || $[46] !== hasPageCommentIconEnabled || $[47] !== isFooterComment || $[48] !== isReply || $[49] !== resolveProperties?.resolved || $[50] !== resolveProperties?.resolvedFriendlyDate) {
        t21 = (resolvedInfo)=>resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, resolvedInfo, hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: [
                    $005e7fbdd3b99ea0$var$pageIconStyle,
                    $005e7fbdd3b99ea0$var$resolvedPropertiesStyle,
                    isFooterComment && $005e7fbdd3b99ea0$var$generalCommentFooterStyle
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                color: "var(--ds-icon-subtlest, #6B6E76)",
                testId: "general-comment-page-icon",
                label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
            })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                space: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
                date: (0, $6faGq.getValidDate)((0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? createdAtNonLocalized : date)
            }), hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $005e7fbdd3b99ea0$var$pageIconStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                color: "var(--ds-icon-subtlest, #6B6E76)",
                testId: "general-comment-page-icon",
                label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
            })))));
        $[43] = createdAtNonLocalized;
        $[44] = date;
        $[45] = formatMessage;
        $[46] = hasPageCommentIconEnabled;
        $[47] = isFooterComment;
        $[48] = isReply;
        $[49] = resolveProperties?.resolved;
        $[50] = resolveProperties?.resolvedFriendlyDate;
        $[51] = t21;
    } else t21 = $[51];
    const renderDateInfoOldExperience = t21;
    let t22;
    if ($[52] !== commentDateUrl || $[53] !== createdAtNonLocalized || $[54] !== date || $[55] !== formatMessage || $[56] !== hasPageCommentIconEnabled || $[57] !== intl || $[58] !== isCommentsPanel || $[59] !== isReply || $[60] !== isStandaloneComment || $[61] !== linkToComment || $[62] !== renderDateInfoOldExperience || $[63] !== renderResolveInfo || $[64] !== resolveProperties?.resolved || $[65] !== resolveProperties?.resolvedFriendlyDate || $[66] !== showCopyLink || $[67] !== timeZone) {
        t22 = ()=>{
            const resolvedInfo_0 = renderResolveInfo();
            const renderCopyLinkButton = commentDateUrl && !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") && (isCommentsPanel && !(0, $9wGTI.fg)("confluence_frontend_comments_panel_v2") || !isCommentsPanel);
            const timeAgoDate = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? createdAtNonLocalized : date;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$DateContainer, {
                isStandaloneComment: isStandaloneComment,
                isCommentsPanel: isCommentsPanel,
                isFixedEditStyles: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
            }, (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                space: "space.050"
            }, resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate ? resolvedInfo_0 : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: (0, $6mKj3.expValEquals)("confluence_comments_cohiti_date_tooltips", "isEnabled", true) ? formatMessage($005e7fbdd3b99ea0$var$i18n.defaultTooltip, {
                    date: intl.formatDate((0, $6faGq.getValidDate)(timeAgoDate), {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                        timeZone: timeZone
                    }),
                    timestamp: intl.formatTime((0, $6faGq.getValidDate)(timeAgoDate), {
                        hour: "numeric",
                        minute: "numeric",
                        timeZone: timeZone
                    })
                }) : undefined
            }, (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, "1 w") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
                date: (0, $6faGq.getValidDate)(timeAgoDate)
            })), hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $005e7fbdd3b99ea0$var$newPageIconStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                color: "var(--ds-icon-subtlest, #6B6E76)",
                testId: "general-comment-page-icon",
                label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
            }))))) : renderDateInfoOldExperience(resolvedInfo_0), renderCopyLinkButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6b5EI.CopyLinkButton), {
                visible: showCopyLink,
                textToCopy: linkToComment
            }));
        };
        $[52] = commentDateUrl;
        $[53] = createdAtNonLocalized;
        $[54] = date;
        $[55] = formatMessage;
        $[56] = hasPageCommentIconEnabled;
        $[57] = intl;
        $[58] = isCommentsPanel;
        $[59] = isReply;
        $[60] = isStandaloneComment;
        $[61] = linkToComment;
        $[62] = renderDateInfoOldExperience;
        $[63] = renderResolveInfo;
        $[64] = resolveProperties?.resolved;
        $[65] = resolveProperties?.resolvedFriendlyDate;
        $[66] = showCopyLink;
        $[67] = timeZone;
        $[68] = t22;
    } else t22 = $[68];
    const renderCopyButton = t22;
    let t23;
    if ($[69] !== commentMode || $[70] !== date) {
        t23 = (commentMode === "view" || (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) && date;
        $[69] = commentMode;
        $[70] = date;
        $[71] = t23;
    } else t23 = $[71];
    const isDateShown = t23;
    const name = displayName || userDisplayName || "";
    let t24;
    if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
        $[72] = t24;
    } else t24 = $[72];
    let t25;
    if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
        t25 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
        $[73] = t25;
    } else t25 = $[73];
    const t26 = avatarUrl || userAvatar;
    let t27;
    if ($[74] !== name || $[75] !== size || $[76] !== t26 || $[77] !== userId) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
            userId: userId,
            src: t26,
            trigger: "click",
            size: size,
            name: name
        });
        $[74] = name;
        $[75] = size;
        $[76] = t26;
        $[77] = userId;
        $[78] = t27;
    } else t27 = $[78];
    let t28;
    if ($[79] !== isCommentsPanel || $[80] !== isFooterComment || $[81] !== isReply || $[82] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$AvatarWrapper, {
            isCommentsPanel: isCommentsPanel,
            isReply: isReply,
            isFooterComment: isFooterComment,
            isFixedEditStyles: t25
        }, t27);
        $[79] = isCommentsPanel;
        $[80] = isFooterComment;
        $[81] = isReply;
        $[82] = t27;
        $[83] = t28;
    } else t28 = $[83];
    let t29;
    if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
        t29 = (0, $gMc0m.default)([
            (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) && "_zulpu2gc _2lx2vrvc _4cvr1q9y"
        ]);
        $[84] = t29;
    } else t29 = $[84];
    let t30;
    if ($[85] !== displayName || $[86] !== isInactiveComment || $[87] !== userAccountId || $[88] !== userDisplayName || $[89] !== userId) {
        t30 = isInactiveComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-testid": "dummy-profile-link"
        }, displayName || userDisplayName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
            fullName: displayName || userDisplayName,
            userId: userId || userAccountId,
            style: {
                wordBreak: "break-word",
                color: "var(--ds-text, #292A2E)",
                fontWeight: "var(--ds-font-weight-medium, 500)"
            },
            isUnderlinedByDefault: false
        });
        $[85] = displayName;
        $[86] = isInactiveComment;
        $[87] = userAccountId;
        $[88] = userDisplayName;
        $[89] = userId;
        $[90] = t30;
    } else t30 = $[90];
    let t31;
    if ($[91] !== permissionType) {
        t31 = permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null)) : null;
        $[91] = permissionType;
        $[92] = t31;
    } else t31 = $[92];
    let t32;
    if ($[93] !== t30 || $[94] !== t31) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$ProfileLinkContainer, null, t30, t31);
        $[93] = t30;
        $[94] = t31;
        $[95] = t32;
    } else t32 = $[95];
    let t33;
    if ($[96] !== isDateShown || $[97] !== renderCopyButton) {
        t33 = isDateShown && renderCopyButton();
        $[96] = isDateShown;
        $[97] = renderCopyButton;
        $[98] = t33;
    } else t33 = $[98];
    let t34;
    if ($[99] !== t32 || $[100] !== t33) {
        t34 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$Container, {
            className: t29
        }, t32, t33);
        $[99] = t32;
        $[100] = t33;
        $[101] = t34;
    } else t34 = $[101];
    let t35;
    if ($[102] !== commentMode || $[103] !== isFooterComment || $[104] !== isReply || $[105] !== isStandaloneComment || $[106] !== t28 || $[107] !== t34) {
        t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$AuthorContainer, {
            commentMode: commentMode,
            isReply: isReply,
            isStandaloneComment: isStandaloneComment,
            isFooterComment: isFooterComment,
            isFixedEditStyles: t24,
            "data-cy": "comment-author"
        }, t28, t34);
        $[102] = commentMode;
        $[103] = isFooterComment;
        $[104] = isReply;
        $[105] = isStandaloneComment;
        $[106] = t28;
        $[107] = t34;
        $[108] = t35;
    } else t35 = $[108];
    return t35;
} : ({ commentMode: commentMode, userId: userId, date: date, createdAtNonLocalized: createdAtNonLocalized, size: size, displayName: displayName, avatarUrl: avatarUrl, commentDateUrl: commentDateUrl, commentId: commentId, permissionType: permissionType, isInactiveComment: isInactiveComment, showCopyLink: showCopyLink = false, resolveProperties: resolveProperties, isCommentsPanel: isCommentsPanel = false, isGeneralComments: isGeneralComments = false, isReply: isReply = false, isFooterComment: isFooterComment = false, isStandaloneComment: isStandaloneComment = false })=>{
    const { data: authorData } = (0, $xQxzY.useQuery)($005e7fbdd3b99ea0$var$CommentAuthorInlineCommentAuthorQuery, {
        variables: {
            commentId: commentId
        },
        fetchPolicy: 'cache-and-network',
        skip: Boolean(userId || !commentId)
    });
    const { data: userData } = (0, $xQxzY.useQuery)($005e7fbdd3b99ea0$var$CommentAuthorUserQuery, {
        variables: {
            id: userId
        },
        fetchPolicy: 'cache-and-network',
        // Skip the query if data is provided or the user is anonymous
        skip: Boolean(avatarUrl && displayName || !userId || commentId)
    });
    const author = (authorData?.content?.nodes || [])[0]?.history?.createdBy;
    const userAvatar = author ? author.profilePicture?.path : (userData?.user?.photos || [])[0]?.value;
    const userDisplayName = author ? author.displayName : userData?.user?.displayName;
    const userAccountId = author?.accountId;
    const linkToComment = `${window.location.origin}/wiki${commentDateUrl}`;
    const intl = (0, $8C5kA.default)();
    const { formatMessage: formatMessage } = intl;
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    const getTooltipContent = ()=>{
        if (resolveProperties?.resolvedTime && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true)) {
            // resolveProperties.resolved = true -> comment is in resolved state
            // resolveProperties.resolved = false -> comment is in re-opened state
            const i18nMessage = resolveProperties?.resolved ? $005e7fbdd3b99ea0$var$i18n.resolvedTooltip : $005e7fbdd3b99ea0$var$i18n.reopenedTooltip;
            const resolvedTimeBase = new Date(resolveProperties.resolvedTime);
            return formatMessage(i18nMessage, {
                username: resolveProperties?.resolvedUser,
                date: intl.formatDate(resolvedTimeBase, {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: timeZone
                }),
                timeStamp: intl.formatTime(resolvedTimeBase, {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                })
            });
        }
        if (resolveProperties?.resolved) return formatMessage((0, $3ejfs.commentsi18n).resolvedByTooltipTextCommentsPanel, {
            username: resolveProperties?.resolvedUser
        });
        return formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
            username: resolveProperties?.resolvedUser,
            createdAtNonLocalized: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
                date: (0, $6faGq.getValidDate)(createdAtNonLocalized),
                usePrepositions: true
            })
        });
    };
    const oldStandloneExperienceResolveInfo = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: resolveProperties?.resolvedFriendlyDate
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-label": formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                username: resolveProperties?.resolvedUser,
                friendlyDate: resolveProperties?.resolvedFriendlyDate
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
            username: resolveProperties?.resolvedUser,
            friendlyDate: resolveProperties?.resolvedFriendlyDate
        }))));
    };
    const getResolvedDateInfoText = ()=>{
        // resolveProperties.resolved = true -> comment is in resolved state
        // resolveProperties.resolved = false -> comment is in re-opened state
        const i18nKey = resolveProperties?.resolved ? 'resolvedDateInfoText' : 'reopenedDateInfoText';
        if (resolveProperties?.resolvedTime && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true)) {
            const resolvedTimeBase_0 = new Date(resolveProperties.resolvedTime);
            const twentyFourHourThreshold = 86400; // in seconds
            const secondsSinceReopen = (Date.now() - resolvedTimeBase_0.getTime()) / 1000; // Don't include a timestamp if the comment was re-opened less than 24 hours ago
            const shouldIncludeTimeStamp = secondsSinceReopen >= twentyFourHourThreshold;
            return formatMessage($005e7fbdd3b99ea0$var$i18n[i18nKey], {
                // use formatTimeAgo directly so that this string can be injected into aria-label,
                timeAgo: (0, $1YXTQ.formatTimeAgo)(intl, resolvedTimeBase_0, true, {}, userTimeZone, tenantTimeZone),
                timeStamp: shouldIncludeTimeStamp ? intl.formatTime(resolvedTimeBase_0, {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                }) : undefined
            });
        } else return formatMessage((0, $3ejfs.commentsi18n)[i18nKey], {
            friendlyDate: resolveProperties?.resolvedFriendlyDate
        });
    };
    const newExperienceResolveInfo = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "top",
            content: getTooltipContent()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-label": getResolvedDateInfoText()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, getResolvedDateInfoText())));
    };
    const renderResolveInfo = ()=>{
        const standAloneExperience = !isFooterComment && !isCommentsPanel;
        if (standAloneExperience && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isFooterComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isCommentsPanel) return newExperienceResolveInfo();
        return oldStandloneExperienceResolveInfo();
    };
    const hasPageCommentIconEnabled = (0, $42omo.useCallback)(()=>{
        if (!isGeneralComments) return false;
        return !isFooterComment;
    }, [
        isGeneralComments,
        isFooterComment
    ]); // TODO: remove renderDateInfoOldExperience() when cleaning up `confluence_frontend_content_wrapper` flag
    const renderDateInfoOldExperience = (resolvedInfo)=>{
        return resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, resolvedInfo, hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $005e7fbdd3b99ea0$var$pageIconStyle,
                $005e7fbdd3b99ea0$var$resolvedPropertiesStyle,
                isFooterComment && $005e7fbdd3b99ea0$var$generalCommentFooterStyle
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
            date: (0, $6faGq.getValidDate)((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? createdAtNonLocalized : date)
        }), hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $005e7fbdd3b99ea0$var$pageIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        })))));
    };
    const renderCopyButton = ()=>{
        const resolvedInfo_0 = renderResolveInfo();
        const renderCopyLinkButton = commentDateUrl && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && (isCommentsPanel && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') || !isCommentsPanel);
        const timeAgoDate = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? createdAtNonLocalized : date;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$DateContainer, {
            isStandaloneComment: isStandaloneComment,
            isCommentsPanel: isCommentsPanel,
            isFixedEditStyles: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
        }, (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050"
        }, resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate ? resolvedInfo_0 : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true) ? formatMessage($005e7fbdd3b99ea0$var$i18n.defaultTooltip, {
                date: intl.formatDate((0, $6faGq.getValidDate)(timeAgoDate), {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: timeZone
                }),
                timestamp: intl.formatTime((0, $6faGq.getValidDate)(timeAgoDate), {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                })
            }) : undefined
        }, (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? // Replace with new time format
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, "1 w") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
            date: (0, $6faGq.getValidDate)(timeAgoDate)
        })), hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $005e7fbdd3b99ea0$var$newPageIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }))))) : renderDateInfoOldExperience(resolvedInfo_0), renderCopyLinkButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6b5EI.CopyLinkButton), {
            visible: showCopyLink,
            textToCopy: linkToComment
        }));
    };
    const isDateShown = (commentMode === 'view' || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && date;
    const name = displayName || userDisplayName || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$AuthorContainer, {
        commentMode: commentMode,
        isReply: isReply,
        isStandaloneComment: isStandaloneComment,
        isFooterComment: isFooterComment,
        isFixedEditStyles: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
        "data-cy": "comment-author"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$AvatarWrapper, {
        isCommentsPanel: isCommentsPanel,
        isReply: isReply,
        isFooterComment: isFooterComment,
        isFixedEditStyles: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: userId,
        src: avatarUrl || userAvatar,
        trigger: "click",
        size: size,
        name: name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$Container, {
        className: (0, $gMc0m.default)([
            (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_zulpu2gc _2lx2vrvc _4cvr1q9y"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$ProfileLinkContainer, null, isInactiveComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "dummy-profile-link"
    }, displayName || userDisplayName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
        fullName: displayName || userDisplayName,
        userId: userId || userAccountId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            wordBreak: 'break-word',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text, #292A2E)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            fontWeight: "var(--ds-font-weight-medium, 500)"
        },
        isUnderlinedByDefault: false
    }), permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null)) : null), isDateShown && renderCopyButton()));
};
module.exports["CommentAuthor"] = $005e7fbdd3b99ea0$export$d05a2f5fbf67a6d7;

});

parcelRegister("jJK3p", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $4qzKl = parcelRequire("4qzKl");


var $a6t12 = parcelRequire("a6t12");


var $5XsiK = parcelRequire("5XsiK");


var $dD7ks = parcelRequire("dD7ks");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $ecnYn.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $cgtv4.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $8C5kA.default)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== referralSource || $[13] !== style || $[14] !== teamsAppPersonProfileUrl || $[15] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = referralSource;
        $[13] = style;
        $[14] = teamsAppPersonProfileUrl;
        $[15] = userId;
        $[16] = t7;
    } else t7 = $[16];
    const renderNameComponent = t7;
    let t8;
    if ($[17] !== fullName || $[18] !== hasViewUserProfilePermission || $[19] !== isAnonymous || $[20] !== renderNameComponent || $[21] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, fullName)));
        $[17] = fullName;
        $[18] = hasViewUserProfilePermission;
        $[19] = isAnonymous;
        $[20] = renderNameComponent;
        $[21] = userId;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
} : ({ userId: userId, fullName: fullName, isAnonymous: isAnonymous = false, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: behavior = 'link', position: position = 'bottom-start', offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: isUnderlinedByDefault = true })=>{
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $8C5kA.default)();
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId ?? ''
        }
    });
    const renderNameComponent = ()=>{
        if (behavior === 'card') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            isAnonymous: isAnonymous,
            userId: userId,
            position: position,
            offset: offset,
            ariaLabel: ariaLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            xcss: $5c1fbd48d7d200d4$var$linkStyles
        }, fullName));
        else {
            const linkStyle = {
                ...style,
                ...isUnderlinedByDefault ? {
                    textDecoration: 'underline'
                } : {}
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cPER9.PeopleLink), {
                target: "_blank",
                onClick: onUserLinkClick,
                href: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: linkStyle,
                "data-testid": "profile-link",
                "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                    fullName: fullName
                })
            }, fullName);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAnonymous || !userId || userId === '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "profile.anonymous.name",
        defaultMessage: "Anonymous"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, fullName)));
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $8lYIw = parcelRequire("8lYIw");


var $jlIaF = parcelRequire("jlIaF");


var $5XsiK = parcelRequire("5XsiK");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, ...otherProps } = props);
        $[0] = props;
        $[1] = href;
        $[2] = otherProps;
        $[3] = to;
    } else {
        href = $[1];
        otherProps = $[2];
        to = $[3];
    }
    const url = to || href;
    const path = url && url.indexOf("/") !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    const t0 = (0, $5XsiK.isTeamsAppEnabled)() ? url : destination;
    let t1;
    if ($[4] !== otherProps || $[5] !== props || $[6] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
            ...props,
            href: t0,
            ...otherProps
        });
        $[4] = otherProps;
        $[5] = props;
        $[6] = t0;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : (props)=>{
    const { href: href, to: to, ...otherProps } = props;
    const url = to || href;
    const path = url && url.indexOf('/') !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    // eslint-disable-next-line @atlassian/a11y/anchor-has-content -- See https://go/a11y-anchor-has-content for more details
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
        ...props,
        href: (0, $5XsiK.isTeamsAppEnabled)() ? url : destination,
        ...otherProps
    });
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("fs6LW", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $esRft = parcelRequire("esRft");


var $jyPfN = parcelRequire("jyPfN");


var $a6t12 = parcelRequire("a6t12");

const $98dff64af54e38f8$var$awatarWrapperStyles = {
    base: (0, $ecnYn.xcss)({
        display: 'inline-flex',
        backgroundColor: 'color.background.neutral.subtle',
        borderWidth: '0',
        padding: 'space.0',
        borderRadius: 'radius.full',
        outlineOffset: 'space.0',
        ':focus-within': {
            outlineStyle: 'solid',
            outlineWidth: 'border.width.focused',
            outlineColor: 'color.border.focused'
        }
    }),
    cursor: (0, $ecnYn.xcss)({
        cursor: 'pointer'
    })
};
const $98dff64af54e38f8$var$i18n = (0, $cgtv4.defineMessages)({
    label: {
        id: "profile.avatar.image",
        defaultMessage: "profile image of a user"
    },
    ariaLabel: {
        id: "profile.avatar.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
const $98dff64af54e38f8$export$3778be82376b06d7 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(39);
    const { userId: userId, canViewProfile: t1, isAnonymous: t2, size: t3, src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset } = t0;
    const canViewProfile = t1 === undefined ? true : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const size = t3 === undefined ? "medium" : t3;
    const intl = (0, $8C5kA.default)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const avatarRef = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $42omo.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $42omo.useState)(false);
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (isVisible_0)=>{
            setIsVisible(isVisible_0);
        };
        $[0] = t4;
    } else t4 = $[0];
    const handleVisibilityChange = t4;
    let t5;
    let t6;
    if ($[1] !== isVisible || $[2] !== shouldReturnFocus) {
        t5 = ()=>{
            if (shouldReturnFocus && !isVisible && avatarRef.current) {
                avatarRef.current.focus();
                setShouldReturnFocus(false);
            }
        };
        t6 = [
            isVisible,
            shouldReturnFocus
        ];
        $[1] = isVisible;
        $[2] = shouldReturnFocus;
        $[3] = t5;
        $[4] = t6;
    } else {
        t5 = $[3];
        t6 = $[4];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[5] !== isVisible || $[6] !== wasKeyboardAction) {
        t7 = (e)=>{
            e.stopPropagation();
            if (e.key === "Enter") {
                setWasKeyboardAction(true);
                setIsVisible($98dff64af54e38f8$var$_temp);
                setShouldReturnFocus(true);
            } else if (e.key === "Escape" && isVisible && wasKeyboardAction) {
                setIsVisible(false);
                setWasKeyboardAction(false);
                setShouldReturnFocus(true);
            }
        };
        $[5] = isVisible;
        $[6] = wasKeyboardAction;
        $[7] = t7;
    } else t7 = $[7];
    const handleKeyDown = t7;
    const t8 = name || "";
    let t9;
    if ($[8] !== intl) {
        t9 = intl.formatMessage($98dff64af54e38f8$var$i18n.label);
        $[8] = intl;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== avatarSrc || $[11] !== borderColor || $[12] !== onClick || $[13] !== size || $[14] !== stackIndex || $[15] !== t8 || $[16] !== t9 || $[17] !== testId) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: avatarSrc,
            size: size,
            target: "_blank",
            name: t8,
            label: t9,
            stackIndex: stackIndex,
            testId: testId,
            borderColor: borderColor,
            onClick: onClick
        });
        $[10] = avatarSrc;
        $[11] = borderColor;
        $[12] = onClick;
        $[13] = size;
        $[14] = stackIndex;
        $[15] = t8;
        $[16] = t9;
        $[17] = testId;
        $[18] = t10;
    } else t10 = $[18];
    const Icon = t10;
    const t11 = name || "";
    const t12 = canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$awatarWrapperStyles.cursor;
    let t13;
    if ($[19] !== t12) {
        t13 = [
            $98dff64af54e38f8$var$awatarWrapperStyles.base,
            t12
        ];
        $[19] = t12;
        $[20] = t13;
    } else t13 = $[20];
    let t14;
    if ($[21] !== intl || $[22] !== name) {
        t14 = intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
            name: name || ""
        });
        $[21] = intl;
        $[22] = name;
        $[23] = t14;
    } else t14 = $[23];
    let t15;
    if ($[24] !== Icon || $[25] !== handleKeyDown || $[26] !== isVisible || $[27] !== t13 || $[28] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t13,
            "aria-haspopup": "true",
            "aria-expanded": isVisible,
            role: "button",
            testId: "avatarWrapperTestId",
            "aria-label": t14,
            tabIndex: 0,
            ref: avatarRef,
            onKeyDown: handleKeyDown
        }, Icon);
        $[24] = Icon;
        $[25] = handleKeyDown;
        $[26] = isVisible;
        $[27] = t13;
        $[28] = t14;
        $[29] = t15;
    } else t15 = $[29];
    let t16;
    if ($[30] !== canViewProfile || $[31] !== isAnonymous || $[32] !== offset || $[33] !== position || $[34] !== t11 || $[35] !== t15 || $[36] !== trigger || $[37] !== userId) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            canViewProfile: canViewProfile,
            isAnonymous: isAnonymous,
            trigger: trigger,
            fullName: t11,
            disabledAriaAttributes: true,
            onVisibilityChange: handleVisibilityChange,
            position: position,
            offset: offset
        }, t15);
        $[30] = canViewProfile;
        $[31] = isAnonymous;
        $[32] = offset;
        $[33] = position;
        $[34] = t11;
        $[35] = t15;
        $[36] = trigger;
        $[37] = userId;
        $[38] = t16;
    } else t16 = $[38];
    return t16;
} : ({ userId: userId, canViewProfile: canViewProfile = true, isAnonymous: isAnonymous = false, size: size = 'medium', src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset })=>{
    const intl = (0, $8C5kA.default)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const avatarRef = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $42omo.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $42omo.useState)(false);
    const handleVisibilityChange = (isVisible_0)=>{
        setIsVisible(isVisible_0);
    };
    (0, $42omo.useEffect)(()=>{
        if (shouldReturnFocus && !isVisible && avatarRef.current) {
            avatarRef.current.focus();
            setShouldReturnFocus(false);
        }
    }, [
        isVisible,
        shouldReturnFocus
    ]);
    const handleKeyDown = (e)=>{
        e.stopPropagation();
        if (e.key === 'Enter') {
            setWasKeyboardAction(true);
            setIsVisible((prev)=>!prev);
            setShouldReturnFocus(true);
        } else if (e.key === 'Escape' && isVisible && wasKeyboardAction) {
            setIsVisible(false);
            setWasKeyboardAction(false);
            setShouldReturnFocus(true);
        }
    };
    const Icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: avatarSrc,
        size: size,
        target: "_blank",
        name: name || '',
        label: intl.formatMessage($98dff64af54e38f8$var$i18n.label),
        stackIndex: stackIndex,
        testId: testId,
        borderColor: borderColor,
        onClick: onClick
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: userId,
        canViewProfile: canViewProfile,
        isAnonymous: isAnonymous,
        trigger: trigger,
        fullName: name || '',
        disabledAriaAttributes: true,
        onVisibilityChange: handleVisibilityChange,
        position: position,
        offset: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $98dff64af54e38f8$var$awatarWrapperStyles.base,
            canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$awatarWrapperStyles.cursor
        ],
        "aria-haspopup": "true",
        "aria-expanded": isVisible,
        role: "button",
        testId: "avatarWrapperTestId",
        "aria-label": intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
            name: name || ''
        }),
        tabIndex: 0,
        ref: avatarRef,
        onKeyDown: handleKeyDown
    }, Icon));
};
function $98dff64af54e38f8$var$_temp(prev) {
    return !prev;
}
module.exports["ProfileAvatar"] = $98dff64af54e38f8$export$3778be82376b06d7;

});

parcelRegister("gvWVt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4af2e88caf28e461$export$632b2aa69aba4fdd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iyBz0",
    name: "ExternalCollaboratorUserLozenge",
    loader: async ()=>(await Promise.resolve((parcelRequire("9fywD")))).ExternalUserLozenge
});
module.exports["ExternalCollaboratorUserLozenge"] = $4af2e88caf28e461$export$632b2aa69aba4fdd;

});

parcelRegister("7tI6B", function(module, exports) {
/**
 * @generated SignedSource<<9aed6e6cbc6676e7bd4cc05c0f5959a3>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $89d6a09a4f827a20$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $89d6a09a4f827a20$export$8995abb8169b2cb8;

});

parcelRegister("6b5EI", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $1bY7o = parcelRequire("1bY7o");


var $3sFtD = parcelRequire("3sFtD");


var $6F6hl = parcelRequire("6F6hl");


var $aHcFH = parcelRequire("aHcFH");


var $afGoD = parcelRequire("afGoD");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $9CnRS = parcelRequire("9CnRS");

const $0220545780b126ac$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { visible: visible, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_v5641n2p _1e0c116y _4cvr1h6o _1bah1h6o _18u014y2 _tzy4idpf _t9ec1jvs _1mygkb7n _66dk1xty",
            __cmplp.visible && "_tzy4kb7n _t9ec1ygq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visible: visible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_v5641n2p _1e0c116y _4cvr1h6o _1bah1h6o _18u014y2 _tzy4idpf _t9ec1jvs _1mygkb7n _66dk1xty",
            __cmplp.visible && "_tzy4kb7n _t9ec1ygq",
            __cmplp.className
        ])
    });
});
const $0220545780b126ac$var$CustomTooltipWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c116y _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c116y _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $0220545780b126ac$var$CustomizedTooltipTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(7);
    let children;
    let rest;
    if ($[0] !== t0) {
        ({ children: children, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = rest;
    } else {
        children = $[1];
        rest = $[2];
    }
    const t1 = ref;
    let t2;
    if ($[3] !== children || $[4] !== rest || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$CustomTooltipWrapper, {
            ...rest,
            ref: t1
        }, children);
        $[3] = children;
        $[4] = rest;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$CustomTooltipWrapper, {
        ...rest,
        ref: ref
    }, children));
const $0220545780b126ac$export$da91d1846689786c = 'link-icon';
const $0220545780b126ac$export$9c785f85e6437122 = 'check-icon';
const $0220545780b126ac$export$266980ac2cfa7919 = 'legacy-clipboard-support';
const $0220545780b126ac$var$RESET_TIMEOUT = 5000;
const $0220545780b126ac$export$534d10f1c5b9c7b3 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { visible: visible, textToCopy: textToCopy, children: children } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isCopied, setCopied] = (0, $42omo.useState)(false);
    const copyWrapperRef = (0, $42omo.useRef)(null);
    const cleanupTimer = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditor = (0, $de2j9.useIsEditorPage)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = !(0, $aHcFH.isClipboardApiSupported)() && !(0, $aHcFH.isIEClipboardApiSupported)();
        $[0] = t1;
    } else t1 = $[0];
    const needRenderCopyArea = t1;
    let t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (needRenderCopyArea) copyWrapperRef.current = document.getElementById("copyWrapperRef");
        };
        t3 = [
            needRenderCopyArea
        ];
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[3] !== isCopied) {
        t4 = ()=>{
            if (isCopied) cleanupTimer.current = setTimeout(()=>setCopied(false), $0220545780b126ac$var$RESET_TIMEOUT);
            return ()=>clearTimeout(cleanupTimer.current);
        };
        t5 = [
            isCopied
        ];
        $[3] = isCopied;
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[6] !== createAnalyticsEvent || $[7] !== isCopied || $[8] !== isEditor || $[9] !== isLivePage || $[10] !== textToCopy) {
        t6 = async (event)=>{
            event.stopPropagation();
            if (isCopied) return;
            if ((0, $aHcFH.isClipboardApiSupported)()) await (0, $aHcFH.copyToClipboard)(textToCopy);
            else if ((0, $aHcFH.isIEClipboardApiSupported)()) await (0, $aHcFH.copyToClipboardIE)(textToCopy);
            else await (0, $aHcFH.legacyCopyToClipboard)(textToCopy, copyWrapperRef.current);
            const pageMode = (isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : isEditor ? (0, $afGoD.CommentCreationLocation).EDITOR : (0, $afGoD.CommentCreationLocation).RENDERER).toLowerCase();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: isEditor ? "editPageScreen" : "viewPageScreen",
                    action: "clicked",
                    actionSubject: "copyCommentLink",
                    attributes: {
                        pageMode: pageMode
                    }
                }
            }).fire();
            setCopied(true);
        };
        $[6] = createAnalyticsEvent;
        $[7] = isCopied;
        $[8] = isEditor;
        $[9] = isLivePage;
        $[10] = textToCopy;
        $[11] = t6;
    } else t6 = $[11];
    const handleButtonClick = t6;
    let t7;
    if ($[12] !== formatMessage || $[13] !== isCopied) {
        t7 = isCopied ? formatMessage((0, $9CnRS.i18n).linkCopiedTooltip) : formatMessage((0, $9CnRS.i18n).copyLinkTooltip);
        $[12] = formatMessage;
        $[13] = isCopied;
        $[14] = t7;
    } else t7 = $[14];
    const tooltipContent = t7;
    let t8;
    if ($[15] !== formatMessage || $[16] !== isCopied) {
        t8 = !isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: formatMessage((0, $9CnRS.i18n).copyLinkTooltip),
            testId: $0220545780b126ac$export$da91d1846689786c,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            label: formatMessage((0, $9CnRS.i18n).linkCopiedTooltip),
            color: "var(--ds-icon-success, #6A9A23)",
            testId: $0220545780b126ac$export$9c785f85e6437122,
            spacing: "spacious"
        });
        $[15] = formatMessage;
        $[16] = isCopied;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== handleButtonClick || $[19] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle-link",
            "data-cy": "inline-comment-time-link",
            iconBefore: t8,
            onClick: handleButtonClick,
            spacing: "none"
        });
        $[18] = handleButtonClick;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t9 || $[22] !== tooltipContent) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipContent,
            position: "top",
            tag: $0220545780b126ac$var$CustomizedTooltipTag,
            hideTooltipOnClick: true
        }, t9);
        $[21] = t9;
        $[22] = tooltipContent;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== children) {
        t11 = needRenderCopyArea && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
            testId: $0220545780b126ac$export$266980ac2cfa7919,
            id: "copyWrapperRef"
        }, children);
        $[24] = children;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== t10 || $[27] !== t11 || $[28] !== visible) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$Wrapper, {
            visible: visible
        }, t10, t11);
        $[26] = t10;
        $[27] = t11;
        $[28] = visible;
        $[29] = t12;
    } else t12 = $[29];
    return t12;
} : ({ visible: visible, textToCopy: textToCopy, children: children })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isCopied, setCopied] = (0, $42omo.useState)(false);
    const copyWrapperRef = (0, $42omo.useRef)(null);
    const cleanupTimer = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditor = (0, $de2j9.useIsEditorPage)();
    const needRenderCopyArea = (0, $42omo.useMemo)(()=>!(0, $aHcFH.isClipboardApiSupported)() && !(0, $aHcFH.isIEClipboardApiSupported)(), []);
    (0, $42omo.useEffect)(()=>{
        if (needRenderCopyArea) copyWrapperRef.current = document.getElementById('copyWrapperRef');
    }, [
        needRenderCopyArea
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isCopied) cleanupTimer.current = setTimeout(()=>setCopied(false), $0220545780b126ac$var$RESET_TIMEOUT);
        return ()=>clearTimeout(cleanupTimer.current);
    }, [
        isCopied
    ]);
    const handleButtonClick = async (event)=>{
        event.stopPropagation();
        if (isCopied) return;
        if ((0, $aHcFH.isClipboardApiSupported)()) await (0, $aHcFH.copyToClipboard)(textToCopy);
        else if ((0, $aHcFH.isIEClipboardApiSupported)()) await (0, $aHcFH.copyToClipboardIE)(textToCopy);
        else await (0, $aHcFH.legacyCopyToClipboard)(textToCopy, copyWrapperRef.current);
        const pageMode = (isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : isEditor ? (0, $afGoD.CommentCreationLocation).EDITOR : (0, $afGoD.CommentCreationLocation).RENDERER).toLowerCase();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: isEditor ? 'editPageScreen' : 'viewPageScreen',
                action: 'clicked',
                actionSubject: 'copyCommentLink',
                attributes: {
                    pageMode: pageMode
                }
            }
        }).fire();
        setCopied(true);
    };
    const tooltipContent = isCopied ? formatMessage((0, $9CnRS.i18n).linkCopiedTooltip) : formatMessage((0, $9CnRS.i18n).copyLinkTooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$Wrapper, {
        visible: visible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipContent,
        position: "top",
        tag: $0220545780b126ac$var$CustomizedTooltipTag,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle-link",
        "data-cy": "inline-comment-time-link",
        iconBefore: !isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: formatMessage((0, $9CnRS.i18n).copyLinkTooltip),
            testId: $0220545780b126ac$export$da91d1846689786c,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            label: formatMessage((0, $9CnRS.i18n).linkCopiedTooltip),
            color: "var(--ds-icon-success, #6A9A23)",
            testId: $0220545780b126ac$export$9c785f85e6437122,
            spacing: "spacious"
        }),
        onClick: handleButtonClick,
        spacing: "none"
    })), needRenderCopyArea && // there won't be children, but VisuallyHidden requires it
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        testId: $0220545780b126ac$export$266980ac2cfa7919,
        id: "copyWrapperRef"
    }, children));
};
module.exports["CopyLinkButton"] = $0220545780b126ac$export$534d10f1c5b9c7b3;

});

parcelRegister("c6FO3", function(module, exports) {

var $51jGp = parcelRequire("51jGp");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $kDuN4 = parcelRequire("kDuN4");

var $inPa6 = parcelRequire("inPa6");


var $9Z0wk = parcelRequire("9Z0wk");


var $lspPP = parcelRequire("lspPP");


var $3gadb = parcelRequire("3gadb");


var $kYvrE = parcelRequire("kYvrE");


var $f7lNm = parcelRequire("f7lNm");

var $le4yZ = parcelRequire("le4yZ");

var $14FKK = parcelRequire("14FKK");

var $eVM9z = parcelRequire("eVM9z");


var $kNfRw = parcelRequire("kNfRw");


var $9wGTI = parcelRequire("9wGTI");


var $bzqa9 = parcelRequire("bzqa9");


var $h0UOA = parcelRequire("h0UOA");


var $kdOv6 = parcelRequire("kdOv6");


var $hEeUR = parcelRequire("hEeUR");


var $7mpOv = parcelRequire("7mpOv");


var $chaNr = parcelRequire("chaNr");


var $1C1zB = parcelRequire("1C1zB");


var $gw4Eo = parcelRequire("gw4Eo");


var $eV0v4 = parcelRequire("eV0v4");


var $dPJCf = parcelRequire("dPJCf");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $8i27m = parcelRequire("8i27m");


var $1YXTQ = parcelRequire("1YXTQ");


var $3ejfs = parcelRequire("3ejfs");


var $6faGq = parcelRequire("6faGq");


var $en1dX = parcelRequire("en1dX");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $iKSlH = parcelRequire("iKSlH");


var $97Szk = parcelRequire("97Szk");


var $fFmJj = parcelRequire("fFmJj");


var $g7Tm3 = parcelRequire("g7Tm3");

const $dc146e3974e81fa1$var$i18n = (0, $cgtv4.defineMessages)({
    editedInParentheses: {
        id: "comment.renderer.edited.in.parentheses",
        defaultMessage: "(edited)"
    },
    editedBy: {
        id: "comment.renderer.edited.by",
        defaultMessage: "Edited by {username} {at}"
    }
}); // Approx Scroll Height for Comment Container with 2 Lines
const $dc146e3974e81fa1$var$MIN_SCROLL_HEIGHT = 50;
const $dc146e3974e81fa1$var$legacyStandaloneStyle = null;
const $dc146e3974e81fa1$var$standaloneStyle = null;
const $dc146e3974e81fa1$var$commentsPanelV1Style = null;
const $dc146e3974e81fa1$var$commentsPanelV2Style = null;
const $dc146e3974e81fa1$var$commentEditedLabelStyle = null;
const $dc146e3974e81fa1$export$fb8f382757c44d14 = (entry, hasBeenViewed, commentId, setHasBeenViewed, markCommentsRead)=>{
    if (entry.isIntersecting) // Comment entered the viewport
    setHasBeenViewed(true);
    else if (hasBeenViewed) // Comment left the viewport after it was viewed
    markCommentsRead({
        variables: {
            commentIds: [
                commentId
            ]
        }
    });
};
const $dc146e3974e81fa1$export$ce6d3ea87eba7794 = /*#__PURE__*/ (0, $42omo.memo)(({ commentId: commentId, adf: adf, onContentFallback: onContentFallback, isTruncatedContent: isTruncatedContent, onRendered: onRendered, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, onComplete: onComplete, isInlineComment: isInlineComment, isCommentsPanel: isCommentsPanel = false, isEdited: isEdited, versionByDisplayName: versionByDisplayName, versionDate: versionDate, commentType: commentType })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const [rootEl, setRootEl] = (0, $42omo.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId, cloudId: cloudId, locale: locale, userId: userId, featureFlags: featureFlags } = (0, $bQm3c.useSessionData)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $51jGp.default)
    });
    let analyticsContextSource = (0, $en1dX.AnalyticsSource).COMMENTS_PANEL;
    let definitionExperienceName = 'commentPanelAutohighlight';
    if (!isCommentsPanel) {
        if (commentType === (0, $8i27m.CommentType).GENERAL) {
            analyticsContextSource = (0, $en1dX.AnalyticsSource).PAGE_FOOTER;
            definitionExperienceName = 'commentFooterAutohighlight';
        } else {
            analyticsContextSource = (0, $en1dX.AnalyticsSource).STANDALONE;
            definitionExperienceName = 'commentInlineAutohighlight';
        }
    }
    const { isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isDefinitionsEnabled = (isAIEnabledForContent || isRovoEnabledForContent) && locale.startsWith('en') && !JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT) || '""') && (0, $9wGTI.fg)('kd_definitions_enable_confluence_comments');
    const cloudIdARI = (0, $kYvrE.ConfluenceSiteAri).create({
        siteId: cloudId
    }).toString();
    const contentARI = contentType ? (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        resourceId: contentId || '',
        activationId: ''
    }) : '';
    const spaceARI = spaceId ? (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: 'space',
        resourceId: spaceId,
        activationId: ''
    }) : '';
    const workspaceId = (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: 'workspace',
        resourceId: activationId,
        activationId: ''
    }); // entityAri is empty string to fetch acronyms used in comment text (see loadAutohighlights)
    // rather than acronyms used in associated page to prevent them being highlighted again
    const { keyPhrases: keyPhrases, autoHighlightRegex: autoHighlightRegex, loadAutohighlights: loadAutohighlights } = (0, $le4yZ.useAutohighlightSupplier)({
        entityAri: '',
        workspaceId: workspaceId,
        product: 'confluence',
        cloudId: cloudId
    });
    const { fetchDefinition: fetchDefinition } = (0, $eVM9z.useDefinitionSupplier)({
        workspaceId: workspaceId,
        cloudIdARI: cloudIdARI,
        product: 'confluence',
        fetchConfig: {
            entity_ari: contentARI
        },
        productConfig: {
            contentId: contentARI,
            spaceId: spaceARI
        },
        isDefinitionCurationEnabled: true
    });
    const onDisableDefinitions = (0, $42omo.useCallback)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT, true);
    }, []);
    const onEnableDefinitions = (0, $42omo.useCallback)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT, false);
    }, []);
    const getDefinitionsDisabled = (0, $42omo.useCallback)(()=>{
        return (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT);
    }, []);
    const definitionRestrictionOptions = (0, $97Szk.useDefinitionRestrictionOptions)(contentType);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('kd_definitions_enable_confluence_comments')) {
            const text = adf ? (0, $14FKK.parseContent)(adf) : '';
            loadAutohighlights({
                inputText: {
                    text: text,
                    format: (0, $le4yZ.KnowledgeDiscoveryKeyPhraseInputTextFormat).PLAIN
                }
            });
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const memoTextPlatformHighlighter = (0, $42omo.useMemo)(()=>{
        const sourceConfig = {
            brand: isRovoEnabled ? (0, $f7lNm.AiBrand).ROVO : (0, $f7lNm.AiBrand).AI,
            cloudId: cloudId,
            contentARI: contentARI,
            contentId: contentId,
            experience: definitionExperienceName,
            source: 'readingAids',
            sourceProduct: 'confluence',
            userId: userId,
            workspaceId: workspaceId
        };
        const curatedDefinitionScopeConfig = {
            workspaceId: workspaceId,
            definitionRestrictionOptions: definitionRestrictionOptions,
            productScopes: {
                contentARI: contentARI,
                spaceARI: spaceARI
            },
            cloudId: cloudId,
            product: 'confluence'
        };
        const definitionConfig = {
            fetchDefinition: fetchDefinition,
            isAutohighlighted: true,
            definitionCurationOptions: {
                curatedDefinitionScopeConfig: curatedDefinitionScopeConfig
            },
            disableDefinitionsCallbacks: {
                onDisableDefinitions: onDisableDefinitions,
                onEnableDefinitions: onEnableDefinitions,
                getDefinitionsDisabled: getDefinitionsDisabled
            },
            showChatFollowUps: isRovoLLMEnabled
        };
        return {
            pattern: autoHighlightRegex,
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kNfRw.RendererDefinitionTextHighlighter), {
                    ...props,
                    definitionConfig: definitionConfig,
                    keyPhrases: keyPhrases,
                    sourceConfig: sourceConfig
                })
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        autoHighlightRegex,
        keyPhrases
    ]);
    const handleContentFallback = (extensionKey)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'fellback',
                actionSubject: 'comment',
                actionSubjectId: commentId,
                source: 'comment',
                attributes: {
                    editor: 'v2',
                    commentType: 'page',
                    reason: extensionKey ? `${(0, $chaNr.FALLBACK_REASONS).UNSUPPORTED_EXTENSION} - ${extensionKey}` : (0, $chaNr.FALLBACK_REASONS).INVALID_ADF
                }
            }
        }).fire();
        onContentFallback && onContentFallback(extensionKey);
    };
    const extensionHandlers = (0, $1C1zB.getExtensionHandlers)(handleContentFallback, commentId);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    const embeddedConfluenceEventHandlers = (0, $bzqa9.useEventHandlers)();
    const eventHandlers = (0, $42omo.useMemo)(()=>({
            ...(0, $kdOv6.createSmartCardEventHandler)({
                matchRoute: matchRoute,
                push: push
            }),
            ...(0, $h0UOA.createLinkEventHandler)({
                matchRoute: matchRoute,
                push: push
            }),
            ...embeddedConfluenceEventHandlers
        }), [
        matchRoute,
        push,
        embeddedConfluenceEventHandlers
    ]); /* Logic to not show Fade when we have 2 lines in Inactive state. When we have more than 2 lines the scrollHeight is
                                                            greater than 50, if its less than 50 send fadeOutHeight as 0*/ 
    const getFadeHeight = ()=>{
        if (isTruncatedContent && (rootEl?.firstElementChild?.scrollHeight ?? 0) > $dc146e3974e81fa1$var$MIN_SCROLL_HEIGHT) return fadeOutHeight;
        else return 0;
    };
    const injectObjectIdIntoRendererAnalytics = (objectId)=>(event)=>{
            // WS-3190 If a renderer event is fired, inject the commentId as objectId
            if (event.payload.actionSubject === 'renderer') event.update((payload)=>({
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        appearance: 'comment',
                        objectId: objectId
                    }
                }));
        };
    const getRendererLocation = (0, $42omo.useCallback)(()=>{
        let rendererLocation = isInlineComment ? (0, $g7Tm3.CommentRendererLocation).STANDALONE_INLINE : (0, $g7Tm3.CommentRendererLocation).STANDALONE_OBJECT;
        if (isCommentsPanel) {
            if (isInlineComment) rendererLocation = (0, $g7Tm3.CommentRendererLocation).COMMENTS_PANEL_INLINE;
            else rendererLocation = (0, $g7Tm3.CommentRendererLocation).COMMENTS_PANEL_OBJECT;
        }
        return rendererLocation;
    }, [
        isInlineComment,
        isCommentsPanel
    ]);
    const handleEmojiLoadFail = (0, $42omo.useCallback)((emojiId, reason)=>{
        const rendererLocation = getRendererLocation();
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                objectType: 'page',
                objectId: contentId,
                action: 'failed',
                actionSubject: 'emojiLoad',
                actionSubjectId: 'commentRenderer',
                attributes: {
                    commentId: commentId,
                    location: rendererLocation,
                    isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                    emojiId: emojiId,
                    tenantId: cloudId,
                    userId: userId,
                    reason: reason,
                    pageId: contentId
                }
            }
        }).fire();
    }, [
        pageMode,
        contentId,
        commentId,
        cloudId,
        userId,
        getRendererLocation,
        createAnalyticsEvent
    ]);
    const handleEmojiLoadSuccess = (0, $42omo.useCallback)((emojiId)=>{
        const rendererLocation = getRendererLocation();
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                objectType: 'page',
                objectId: contentId,
                action: 'success',
                actionSubject: 'emojiLoad',
                actionSubjectId: 'commentRenderer',
                attributes: {
                    commentId: commentId,
                    location: rendererLocation,
                    isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                    emojiId: emojiId,
                    tenantId: cloudId,
                    userId: userId,
                    pageId: contentId
                }
            }
        }).fire();
    }, [
        pageMode,
        contentId,
        commentId,
        cloudId,
        userId,
        getRendererLocation,
        createAnalyticsEvent
    ]);
    if (!adf) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: injectObjectIdIntoRendererAnalytics(commentId),
        channel: "editor" // We use the same channel for editor/renderer https://data-portal.internal.atlassian.com/analytics/registry/27447
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eV0v4.DynamicAnalyticsListener), {
        channelParam: (0, $eV0v4.editorChannel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: setRootEl,
        className: (0, $gMc0m.default)([
            !isCommentsPanel && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_ca0qu2gc _n3tdu2gc",
            !isCommentsPanel && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_19pkutpp _n3tdu2gc",
            isCommentsPanel && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_ca0qutpp _n3tdutpp",
            isCommentsPanel && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_n3tdn7od"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKSlH.MultiMacroQueryContainer), {
        contentId: contentId ?? '',
        featureFlags: featureFlags,
        contentRendererMode: "renderer",
        readFragmentInterop: readFragmentInterop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEeUR.ADFRenderer), {
        contentId: commentId,
        document: adf,
        extensionHandlers: extensionHandlers,
        portal: rootEl ?? undefined,
        allowStickyHeaders: false,
        isTruncatedContent: isTruncatedContent,
        onRendered: onRendered,
        onComplete: onComplete,
        allowSelectAllTrap: true,
        maxHeight: maxHeight,
        fadeOutHeight: getFadeHeight(),
        appearance: "comment",
        eventHandlers: eventHandlers,
        UNSTABLE_allowTableAlignment: !isInlineComment && (0, $6mKj3.expVal)('platform_editor_support_table_in_comment_exp', 'isEnabled', false),
        UNSTABLE_allowTableResizing: !isInlineComment && (0, $6mKj3.expVal)('platform_editor_support_table_in_comment_exp', 'isEnabled', false),
        shouldRemoveEmptySpaceAroundContent: true,
        onEmojiLoadFail: handleEmojiLoadFail,
        onEmojiLoadSuccess: handleEmojiLoadSuccess,
        textHighlighter: isDefinitionsEnabled ? memoTextPlatformHighlighter : undefined
    }), isEdited && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_11c81o8v _syaz1rpy _ca0q12x7"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($dc146e3974e81fa1$var$i18n.editedBy, {
            username: versionByDisplayName || formatMessage((0, $3ejfs.commentsi18n).anonymous),
            at: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
                date: (0, $6faGq.getValidDate)(versionDate),
                usePrepositions: true
            })
        }),
        analyticsContext: {
            attributes: {
                source: analyticsContextSource,
                commentType: commentType,
                name: 'commentEditedBadgeTooltip'
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "comment-edited-label",
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z0wk.default), null, formatMessage($dc146e3974e81fa1$var$i18n.editedInParentheses)))))))))));
});
$dc146e3974e81fa1$export$ce6d3ea87eba7794.displayName = 'CommentRenderer';
module.exports["CommentRenderer"] = $dc146e3974e81fa1$export$ce6d3ea87eba7794;

});

parcelRegister("51jGp", function(module, exports) {
/**
 * @generated SignedSource<<15d6f9b34c0625df1e50e01768351b72>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $20cea39b88d5a5ee$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "kind": "ScalarField",
            "name": "data"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "CommentRendererReadFragment",
        "selections": [
            {
                "concreteType": "Macro",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "macroId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "contentId"
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "mode",
                                "value": "RENDERER"
                            }
                        ],
                        "concreteType": "RenderedMacro",
                        "kind": "LinkedField",
                        "name": "renderedMacro",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroRenderedRepresentation"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroBodyStorage"
                            },
                            {
                                "concreteType": "WebResourceDependenciesV2",
                                "kind": "LinkedField",
                                "name": "webResource",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "contexts"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "keys"
                                    },
                                    {
                                        "concreteType": "SuperBatchWebResourcesV2",
                                        "kind": "LinkedField",
                                        "name": "superbatch",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "metatags"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "WebResourceTagsV2",
                                        "kind": "LinkedField",
                                        "name": "tags",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    },
                                    {
                                        "concreteType": "WebResourceUrisV2",
                                        "kind": "LinkedField",
                                        "name": "uris",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "concreteType": "EmbeddedMediaTokenV2",
                                "kind": "LinkedField",
                                "name": "mediaToken",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "renderedMacro(mode:\"RENDERER\")"
                    }
                ]
            },
            {
                "concreteType": "PageInfoV2",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "endCursor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    }
                ]
            }
        ],
        "type": "MacroConnection"
    };
}();
$20cea39b88d5a5ee$var$node.hash = "2939a86cf744f10a55b9d35c52e07226";
var $20cea39b88d5a5ee$export$2e2bcd8739ae039 = $20cea39b88d5a5ee$var$node;
module.exports["default"] = $20cea39b88d5a5ee$export$2e2bcd8739ae039;

});

parcelRegister("9Z0wk", function(module, exports) {
/* edited.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");

const $5e18336ff60a0b69$var$editedContentStyles = {
    root: "_syaz1rpy"
};
const $5e18336ff60a0b69$var$Edited = ({ children: children, onFocus: onFocus, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        className: (0, $gMc0m.default)([
            $5e18336ff60a0b69$var$editedContentStyles.root
        ]),
        children: children
    });
$5e18336ff60a0b69$var$Edited.displayName = 'Edited'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $5e18336ff60a0b69$export$2e2bcd8739ae039 = $5e18336ff60a0b69$var$Edited;
module.exports["default"] = $5e18336ff60a0b69$export$2e2bcd8739ae039;

});

parcelRegister("kYvrE", function(module, exports) {

var $3lhEv = parcelRequire("3lhEv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/site/manifest.ts
var $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $3lhEv.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $3lhEv.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $f451cd8c9de7a9df$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $f451cd8c9de7a9df$export$82e6693d75ffdd8;

});

parcelRegister("3lhEv", function(module, exports) {
// src/confluence/site/types.ts
var $26f1069ffd8f654d$export$9e07499cd8b0bde5 = "confluence", $26f1069ffd8f654d$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $26f1069ffd8f654d$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $26f1069ffd8f654d$export$57b7cabbf31f1f68;

});

parcelRegister("f7lNm", function(module, exports) {
const $ea70aa10be5defa1$export$82b05c69aac5d0c6 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $ea70aa10be5defa1$export$e7d7da8c94dcb6fc = 'https://support.atlassian.com/confluence-cloud/docs/use-atlassian-intelligence-to-search-for-answers/';
const $ea70aa10be5defa1$export$506bad4598ef877f = 'https://www.atlassian.com/software/artificial-intelligence';
const $ea70aa10be5defa1$export$59da2b3b71a076c7 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $ea70aa10be5defa1$export$b4efff19add55eb6 = 'https://confluence.atlassian.com/support/atlassian-support-ai-chat-1455423797.html';
const $ea70aa10be5defa1$export$96cc4126cdc27248 = 'https://www.atlassian.com/legal/acceptable-use-policy';
const $ea70aa10be5defa1$export$d3a50b0660f215e0 = 'https://support.atlassian.com/organization-administration/docs/usage-limits-in-atlassian-intelligence/';
const $ea70aa10be5defa1$export$50e6b843de210064 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $ea70aa10be5defa1$export$dd87179defae3659 = 'https://support.atlassian.com/organization-administration/docs/the-hipaa-implementation-guide/';
const $ea70aa10be5defa1$export$2c1028e1e7bf5557 = 'https://www.atlassian.com/software/rovo';
const $ea70aa10be5defa1$export$c4fda24479ad6357 = '82633dea-7fbf-4faa-9a51-a83a3fd181d9';
const $ea70aa10be5defa1$export$91d63889268b5e23 = "365\xa05ce1d-16b8-4630-9e93-6c39069625fa";
const $ea70aa10be5defa1$export$c0ced37cfe138d3e = '10f4daa4-bcfc-4d42-ae33-92888648d9db';
const $ea70aa10be5defa1$export$d04cd98bb7625919 = 'customfield_10047';
const $ea70aa10be5defa1$export$ed78826c06dd24e3 = 'fabric-elements';
var $ea70aa10be5defa1$export$83c8d7110915321e = /*#__PURE__*/ function(SOURCE) {
    SOURCE["SEARCH_DIALOG"] = "searchDialog";
    SOURCE["ADVANCED_SEARCH"] = "advancedSearch";
    SOURCE["READING_AIDS"] = "readingAids";
    return SOURCE;
}({});
const $ea70aa10be5defa1$export$e7862e8dbda0aa3 = '500px';
const $ea70aa10be5defa1$export$169d09d6d83f61d6 = '/gateway/api/smartAnswers/stream';
const $ea70aa10be5defa1$export$a00f71e6c6b44441 = '/gateway/api/assist';
const $ea70aa10be5defa1$export$cc4a4ed360fef1ba = '/gateway/api/graphql';
var $ea70aa10be5defa1$export$83d4ba88ba80625b = /*#__PURE__*/ function(QueryIntent) {
    QueryIntent["DEFAULT"] = "DEFAULT";
    QueryIntent["NATURAL_LANGUAGE_QUERY"] = "NATURAL_LANGUAGE_QUERY";
    QueryIntent["KEYWORD_OR_ACRONYM"] = "KEYWORD_OR_ACRONYM";
    QueryIntent["PERSON"] = "PERSON";
    QueryIntent["TEAM"] = "TEAM";
    QueryIntent["NAVIGATIONAL"] = "NAVIGATIONAL";
    QueryIntent["NONE"] = "NONE";
    QueryIntent["LOCATION"] = "LOCATION";
    QueryIntent["DATE"] = "DATE";
    QueryIntent["JIRA_ISSUE"] = "JIRA_ISSUE";
    QueryIntent["TOPIC"] = "TOPIC";
    QueryIntent["JIRA_NATURAL_LANGUAGE_QUERY"] = "JIRA_NATURAL_LANGUAGE_QUERY";
    QueryIntent["AGENT"] = "AGENT";
    QueryIntent["EXPLICIT_QUESTION"] = "EXPLICIT_QUESTION";
    QueryIntent["ORG_CHART"] = "ORG_CHART";
    QueryIntent["NAV_CONTENT"] = "NAV_CONTENT";
    return QueryIntent;
}({});
var $ea70aa10be5defa1$export$a08a848abe54c31f = /*#__PURE__*/ function(AnswerCardType) {
    AnswerCardType["PERSON"] = "people";
    AnswerCardType["TEAM"] = "team";
    AnswerCardType["AGENT"] = "agent";
    AnswerCardType["DATE"] = "date";
    AnswerCardType["LOCATION"] = "location";
    AnswerCardType["TOPIC"] = "topic";
    AnswerCardType["JIRA_NATURAL_LANGUAGE_QUERY"] = "jira_nl_to_jql";
    AnswerCardType["JIRA_ISSUE"] = "jira_issue";
    AnswerCardType["NAVIGATIONAL"] = "navigational";
    AnswerCardType["NAV_CONTENT"] = "nav_content";
    AnswerCardType["NONE"] = "none";
    AnswerCardType["DEFAULT"] = "default";
    AnswerCardType["SAIN"] = "SAIN";
    AnswerCardType["DEFINITION"] = "definition";
    AnswerCardType["ORG_CHART"] = "org_chart";
    AnswerCardType["BOOKMARK_KNOWLEDGE_CARD"] = "bookmarkKnowledgeCard";
    return AnswerCardType;
}({});
var $ea70aa10be5defa1$export$c243a7d908564b9b = /*#__PURE__*/ function(AiExperienceName) {
    AiExperienceName["PERSON_CARD"] = "Person Card";
    AiExperienceName["TEAM_CARD"] = "Team Card";
    AiExperienceName["LOCATION_CARD"] = "Location Card";
    AiExperienceName["DATE_CARD"] = "Date Card";
    AiExperienceName["TOPIC_CARD"] = "Topic Card";
    AiExperienceName["JIRA_NATURAL_LANGUAGE_QUERY_CARD"] = "Jira Nl to JQL Card";
    AiExperienceName["AGENT_CARD"] = "Agent Card";
    AiExperienceName["JIRA_ISSUE_CARD"] = "Jira Issue Card";
    AiExperienceName["NAVIGATIONAL"] = "Navigational";
    AiExperienceName["NONE"] = "None";
    AiExperienceName["DEFAULT"] = "Default";
    AiExperienceName["PLAIN_TEXT"] = "Plain Text";
    AiExperienceName["POPULAR_SEARCH_QUERY_CARD"] = "Popular Search Query Card";
    AiExperienceName["NAVIGATIONAL_SEARCH_RESULT_CARD"] = "Navigational Search Result Card";
    return AiExperienceName;
}({});
var $ea70aa10be5defa1$export$30e36b9f4147b88f = /*#__PURE__*/ function(CardTemplate) {
    CardTemplate["DEFAULT"] = "DEFAULT";
    CardTemplate["SMART_ANSWER"] = "SMART_ANSWER";
    CardTemplate["RIGHT_PANEL"] = "RIGHT_PANEL";
    return CardTemplate;
}({});
var $ea70aa10be5defa1$export$49069087564847a7 = /*#__PURE__*/ function(AiBrand) {
    AiBrand["ROVO"] = "ROVO";
    AiBrand["AI"] = "ATLASSIAN INTELLIGENCE";
    return AiBrand;
}({});
var $ea70aa10be5defa1$export$8375a80c95e07251 = /*#__PURE__*/ function(AIAnswerTab) {
    AIAnswerTab["AI_ANSWER"] = "AI_ANSWER";
    AIAnswerTab["SOURCES"] = "SOURCES";
    return AIAnswerTab;
}({});
const $ea70aa10be5defa1$export$98d221c2fcca6d6b = [
    "AI_ANSWER",
    "SOURCES"
];
module.exports["ATLASSIAN_INTELLIGENCE_SEARCH_INFO_LINK"] = $ea70aa10be5defa1$export$e7d7da8c94dcb6fc;
module.exports["ATLASSIAN_INTELLIGENCE_TRUST_LINK"] = $ea70aa10be5defa1$export$59da2b3b71a076c7;
module.exports["SAC_ATLASSIAN_INTELLIGENCE_TRUST_LINK"] = $ea70aa10be5defa1$export$b4efff19add55eb6;
module.exports["ATLASSIAN_ACCEPTABLE_USE_POLICY_LINK"] = $ea70aa10be5defa1$export$96cc4126cdc27248;
module.exports["ATLASSIAN_AI_USAGE_LIMITS_LINK"] = $ea70aa10be5defa1$export$d3a50b0660f215e0;
module.exports["ATLASSIAN_AI_TROUBLESHOOT_LINK"] = $ea70aa10be5defa1$export$50e6b843de210064;
module.exports["ATLASSIAN_HIPAA_COMPLICANCE_LINK"] = $ea70aa10be5defa1$export$dd87179defae3659;
module.exports["ATLASSIAN_ROVO_LINK"] = $ea70aa10be5defa1$export$2c1028e1e7bf5557;
module.exports["FEEDBACK_ENTRYPOINT_ID_SAIN"] = $ea70aa10be5defa1$export$c4fda24479ad6357;
module.exports["FEEDBACK_ENTRYPOINT_ID_TOPICS"] = $ea70aa10be5defa1$export$c0ced37cfe138d3e;
module.exports["FEEDBACK_CONTEXT_CF"] = $ea70aa10be5defa1$export$d04cd98bb7625919;
module.exports["DEFAULT_GAS_CHANNEL"] = $ea70aa10be5defa1$export$ed78826c06dd24e3;
module.exports["READING_AIDS_DIALOG_WIDTH"] = $ea70aa10be5defa1$export$e7862e8dbda0aa3;
module.exports["SAIN_STREAMING_API"] = $ea70aa10be5defa1$export$169d09d6d83f61d6;
module.exports["ASSISTANCE_SERVICE_API_BASE_URL"] = $ea70aa10be5defa1$export$a00f71e6c6b44441;
module.exports["DEFAULT_GRAPHQL_ENDPOINT"] = $ea70aa10be5defa1$export$cc4a4ed360fef1ba;
module.exports["QueryIntent"] = $ea70aa10be5defa1$export$83d4ba88ba80625b;
module.exports["AnswerCardType"] = $ea70aa10be5defa1$export$a08a848abe54c31f;
module.exports["AiExperienceName"] = $ea70aa10be5defa1$export$c243a7d908564b9b;
module.exports["CardTemplate"] = $ea70aa10be5defa1$export$30e36b9f4147b88f;
module.exports["AiBrand"] = $ea70aa10be5defa1$export$49069087564847a7;
module.exports["AIAnswerTab"] = $ea70aa10be5defa1$export$8375a80c95e07251;
module.exports["aiAnswerTabsOrder"] = $ea70aa10be5defa1$export$98d221c2fcca6d6b;

});

parcelRegister("le4yZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $9EFEY = parcelRequire("9EFEY");


var $6yuru = parcelRequire("6yuru");


var $f7lNm = parcelRequire("f7lNm");


var $9pwVP = parcelRequire("9pwVP");


var $bbPOv = parcelRequire("bbPOv");

var $850e39d8df191904$export$5fc610914b028d97 = /*#__PURE__*/ function(KnowledgeDiscoveryKeyPhraseInputTextFormat) {
    KnowledgeDiscoveryKeyPhraseInputTextFormat["PLAIN"] = "PLAIN";
    KnowledgeDiscoveryKeyPhraseInputTextFormat["ADF"] = "ADF";
    return KnowledgeDiscoveryKeyPhraseInputTextFormat;
}({});
var $850e39d8df191904$export$17a511c5c23509af = /*#__PURE__*/ function(KeyPhraseCategory) {
    KeyPhraseCategory["PROJECT"] = "PROJECT";
    KeyPhraseCategory["TEAM"] = "TEAM";
    KeyPhraseCategory["ACRONYM"] = "ACRONYM";
    KeyPhraseCategory["AUTO"] = "AUTO";
    KeyPhraseCategory["OTHER"] = "OTHER";
    return KeyPhraseCategory;
}({});
const $850e39d8df191904$export$276f56b9dab90860 = 'atlassian.knowledge-discovery.autohighlights';
const $850e39d8df191904$var$escapeRegExp = (regex)=>{
    return regex.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};
const $850e39d8df191904$export$4a1c1074ca627 = (keyPhrases)=>{
    try {
        if (!keyPhrases.length) return new RegExp('(?!)');
        else return new RegExp(keyPhrases.map((node)=>`\\b${$850e39d8df191904$var$escapeRegExp(node.keyPhrase)}\\b`).join('|'), 'gi');
    } catch  {
        return new RegExp('(?!)');
    }
};
const $850e39d8df191904$var$getKeyphraseCategory = (keyPhrases)=>{
    return keyPhrases.length ? keyPhrases[0].category : "AUTO";
};
const $850e39d8df191904$var$initialState = {
    keyPhrases: [],
    keyPhraseCategory: "AUTO",
    autoHighlightRegex: new RegExp('(?!)'),
    loadAutohighlights: ()=>Promise.resolve([]),
    resetAutohighlights: ()=>{},
    autohighlightsLoading: false,
    error: undefined
};
const $850e39d8df191904$export$52e9ff9bfbb65046 = ({ entityAri: entityAri, workspaceId: workspaceId, product: product, productConfig: productConfig, fieldType: fieldType, cloudId: cloudId })=>{
    const [state, setState] = (0, $42omo.useState)($850e39d8df191904$var$initialState);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $f7lNm.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const { jiraReporterAccountId: jiraReporterAccountId, jiraAssigneeAccountId: jiraAssigneeAccountId } = productConfig || {};
    const loadAutohighlights = (0, $42omo.useCallback)(async ({ inputText: inputText })=>{
        try {
            setState({
                ...$850e39d8df191904$var$initialState,
                autohighlightsLoading: true
            });
            const keyPhrasesResult = await (0, $9EFEY.fetchAggResponse)({
                graphQuery: (0, $bbPOv.KeyPhrasesQuery),
                variables: {
                    workspaceId: workspaceId,
                    entityAri: entityAri,
                    ...!!jiraReporterAccountId && {
                        jiraReporterAccountId: jiraReporterAccountId
                    },
                    ...!!jiraAssigneeAccountId && {
                        jiraAssigneeAccountId: jiraAssigneeAccountId
                    },
                    ...!!inputText && {
                        inputText: inputText
                    }
                },
                operationName: (0, $bbPOv.KEY_PHRASES_OPERATION_NAME),
                headers: (0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: product
                })
            });
            const keyPhrases = keyPhrasesResult?.data?.knowledgeDiscovery?.keyPhrases?.nodes ? keyPhrasesResult.data.knowledgeDiscovery.keyPhrases.nodes : [];
            if (keyPhrases.length > 0 && (0, $dh538.fg)('kd_definitions_click_and_show_event_product_parity')) fireAnalyticsEvent((0, $9pwVP.onShownAutoDefinitionHighlights)({
                product: product,
                contentId: entityAri,
                keyPhrases: keyPhrases,
                fieldType: fieldType
            }));
            const autoHighlightRegex = $850e39d8df191904$export$4a1c1074ca627(keyPhrases);
            setState({
                ...$850e39d8df191904$var$initialState,
                keyPhraseCategory: $850e39d8df191904$var$getKeyphraseCategory(keyPhrases),
                autoHighlightRegex: autoHighlightRegex,
                keyPhrases: keyPhrases
            });
            return keyPhrases;
        } catch (error) {
            setState({
                ...$850e39d8df191904$var$initialState,
                error: error.message
            });
            return [];
        }
    }, [
        entityAri,
        workspaceId,
        fireAnalyticsEvent,
        product,
        jiraReporterAccountId,
        jiraAssigneeAccountId,
        fieldType,
        cloudId
    ]);
    const resetAutohighlights = (0, $42omo.useCallback)(()=>{
        setState($850e39d8df191904$var$initialState);
    }, []);
    const autoHighlightRegex = (0, $42omo.useMemo)(()=>state.autoHighlightRegex, [
        state.autoHighlightRegex
    ]);
    const autohighlightsLoading = (0, $42omo.useMemo)(()=>state.autohighlightsLoading, [
        state.autohighlightsLoading
    ]);
    const keyPhrases = (0, $42omo.useMemo)(()=>state.keyPhrases, [
        state.keyPhrases
    ]);
    const error = (0, $42omo.useMemo)(()=>state.error, [
        state.error
    ]);
    return {
        keyPhrases: keyPhrases,
        keyPhraseCategory: state.keyPhraseCategory,
        autoHighlightRegex: autoHighlightRegex,
        loadAutohighlights: loadAutohighlights,
        resetAutohighlights: resetAutohighlights,
        autohighlightsLoading: autohighlightsLoading,
        error: error
    };
};
module.exports["KnowledgeDiscoveryKeyPhraseInputTextFormat"] = $850e39d8df191904$export$5fc610914b028d97;
module.exports["KeyPhraseCategory"] = $850e39d8df191904$export$17a511c5c23509af;
module.exports["getHighlightRegex"] = $850e39d8df191904$export$4a1c1074ca627;
module.exports["useAutohighlightSupplier"] = $850e39d8df191904$export$52e9ff9bfbb65046;

});

parcelRegister("9EFEY", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $dwp40 = parcelRequire("dwp40");


var $i1ClO = parcelRequire("i1ClO");

const $f389ba2de7a9be34$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $f389ba2de7a9be34$export$1642248503fca29({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $f389ba2de7a9be34$var$DEFAULT_GRAPHQL_ENDPOINT, cache: cache, headers: headers }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers ? {
                    ...headers
                } : {}
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        }
    };
    // if there's a ttl use fetch with in-mem cacheing
    if (cache && (0, $dh538.fg)('kd_fe_enable_api_cache')) return (0, $i1ClO.fetchAggResponseWithCache)({
        graphQuery: graphQuery,
        variables: variables,
        operationName: operationName,
        cache: cache,
        headers: headers
    });
    return (0, $dwp40.utils).requestService({
        url: url
    }, options);
}
module.exports["fetchAggResponse"] = $f389ba2de7a9be34$export$1642248503fca29;

});

parcelRegister("i1ClO", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $iip0W = parcelRequire("iip0W");

const $d8368aeaca537ae2$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $d8368aeaca537ae2$export$6fe550b7d5be614c({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $d8368aeaca537ae2$var$DEFAULT_GRAPHQL_ENDPOINT, cache: cache, headers: headers }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers ? {
                    ...headers
                } : {}
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        }
    };
    let cachedResponse = (0, $iip0W.InMemCache).getData(cache.key);
    if (cachedResponse && (0, $iip0W.InMemCache).isValid(cache.key)) return Promise.resolve(cachedResponse);
    // return a pending promise that was cached earlier
    const inflightRequest = (0, $iip0W.InMemCache).getInflightRequest(cache.key);
    if (inflightRequest) return inflightRequest;
    // cache miss, fetch data from agg and store ref to promise
    const request = new Promise(async (resolve, reject)=>{
        try {
            const response = await (0, $dwp40.utils).requestService({
                url: url
            }, options);
            (0, $iip0W.InMemCache).setData({
                key: cache.key,
                response: response,
                ttl: cache.ttl
            });
            resolve(response);
        } catch (error) {
            reject(error);
        } finally{
            (0, $iip0W.InMemCache).removeInflightRequest(cache.key);
        }
    });
    (0, $iip0W.InMemCache).setInflightRequest({
        key: cache.key,
        request: request
    });
    return request;
}
module.exports["fetchAggResponseWithCache"] = $d8368aeaca537ae2$export$6fe550b7d5be614c;

});

parcelRegister("iip0W", function(module, exports) {
const $72ec73b0e41d4c0a$var$DEFAULT_TTL = 300000;
class $72ec73b0e41d4c0a$export$916bab80494ce385 {
    static setData({ key: key, response: response, ttl: ttl }) {
        this.cache.set(key, {
            ttl: Date.now() + (ttl || $72ec73b0e41d4c0a$var$DEFAULT_TTL),
            response: response
        });
    }
    static getData(key) {
        return this.cache.get(key)?.response;
    }
    static isValid(key) {
        const item = this.cache.get(key);
        return Boolean(item) && Date.now() < (item?.ttl || 0);
    }
    static getInflightRequest(key) {
        return this.inFlightRequests.get(key);
    }
    static setInflightRequest({ key: key, request: request }) {
        this.inFlightRequests.set(key, request);
    }
    static removeInflightRequest(key) {
        return this.inFlightRequests.delete(key);
    }
    // only for tests
    static clearCache() {
        this.cache.clear();
        this.inFlightRequests.clear();
    }
}
$72ec73b0e41d4c0a$export$916bab80494ce385.cache = new Map();
$72ec73b0e41d4c0a$export$916bab80494ce385.inFlightRequests = new Map();
module.exports["InMemCache"] = $72ec73b0e41d4c0a$export$916bab80494ce385;

});

parcelRegister("6yuru", function(module, exports) {

var $dh538 = parcelRequire("dh538");

function $9b992db01b095d2f$export$14ef296862e3705e({ atlWorkspaceId: atlWorkspaceId, tenantId: tenantId, product: product }) {
    if (!(0, $dh538.fg)('kd_agg_atl_attribution_header')) return;
    const atlAttributionHeader = {
        atlWorkspaceId: atlWorkspaceId,
        tenantId: tenantId,
        product: product
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
}
module.exports["createAtlAttributionHeader"] = $9b992db01b095d2f$export$14ef296862e3705e;

});

parcelRegister("9pwVP", function(module, exports) {

var $cqFuK = parcelRequire("cqFuK");


var $le4yZ = parcelRequire("le4yZ");


var $fjzE4 = parcelRequire("fjzE4");

const $135aee7ed4d7fef7$export$ae4ae603f16dcf42 = ({ commonAttributes: commonAttributes, newDefinition: newDefinition, restrictedScope: restrictedScope, sourceSelected: sourceSelected, aiDefinitionEdited: aiDefinitionEdited })=>{
    const { query: keyPhrase, answerString: oldDefinition, extraAttributes: extraAttributes, source: source } = commonAttributes;
    const { contentId: contentId, readingAidsSessionId: readingAidsSessionId } = extraAttributes || {};
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionUpdateButton',
        source: source,
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: readingAidsSessionId,
            restrictedScope: restrictedScope,
            sourceSelected: sourceSelected,
            newDefinitionLength: newDefinition.length,
            aiDefinitionEdited: // whether the user is editing an AI answer or already edited definition
            aiDefinitionEdited
        },
        nonPrivacySafeAttributes: {
            keyPhrase: keyPhrase,
            oldDefinition: oldDefinition,
            newDefinition: newDefinition
        }
    };
};
const $135aee7ed4d7fef7$export$d80f83cdfda72179 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    const { contentId: contentId, readingAidsSessionId: readingAidsSessionId } = extraAttributes || {};
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionSeeEditHistoryButton',
        source: source,
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: readingAidsSessionId
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $135aee7ed4d7fef7$export$5b155f527aff26b9 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerLikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $135aee7ed4d7fef7$export$c4c8b81ee90e6af2 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDislikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $135aee7ed4d7fef7$export$42897f8f02baa658 = ({ product: product, contentId: contentId, keyPhrases: keyPhrases, fieldType: fieldType })=>({
        action: 'shown',
        actionSubject: 'aiDefinitionsAutohighlights',
        source: 'viewPageScreen',
        eventType: 'track',
        attributes: {
            product: product,
            contentId: contentId,
            numHighlights: keyPhrases.length,
            categories: (0, $fjzE4.getHighlightCategories)(keyPhrases),
            beAcronymsEnabled: true,
            fieldType: fieldType
        }
    });
const $135aee7ed4d7fef7$export$9e6261f08debf93b = ({ contentId: contentId, sessionId: sessionId, keyPhraseCategory: keyPhraseCategory, fieldType: fieldType })=>({
        action: 'clicked',
        actionSubject: 'aiDefinitionsAutohighlights',
        source: 'viewPageScreen',
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: sessionId,
            keyPhraseCategory: keyPhraseCategory || (0, $le4yZ.KeyPhraseCategory).AUTO,
            fieldType: fieldType
        }
    });
const $135aee7ed4d7fef7$export$bfe6deae035e3ea7 = (props)=>({
        action: 'clicked',
        actionSubject: 'aiDefinitionsDisableDefinition',
        source: 'viewPageScreen',
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        }
    });
module.exports["onCuratedDefinitionUpdateButtonClicked"] = $135aee7ed4d7fef7$export$ae4ae603f16dcf42;
module.exports["onCuratedDefinitionSeeEditHistoryButtonClicked"] = $135aee7ed4d7fef7$export$d80f83cdfda72179;
module.exports["onLikeButtonClick"] = $135aee7ed4d7fef7$export$5b155f527aff26b9;
module.exports["onDislikeButtonClick"] = $135aee7ed4d7fef7$export$c4c8b81ee90e6af2;
module.exports["onShownAutoDefinitionHighlights"] = $135aee7ed4d7fef7$export$42897f8f02baa658;
module.exports["onClickAutoDefinitionHighlights"] = $135aee7ed4d7fef7$export$9e6261f08debf93b;
module.exports["onClickDisableDefinition"] = $135aee7ed4d7fef7$export$bfe6deae035e3ea7;

});

parcelRegister("cqFuK", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $01aV7 = parcelRequire("01aV7");

// list from https://atlassian.slack.com/archives/C08VA0N40A2/p1749172242825969?thread_ts=1749088363.059769&cid=C08VA0N40A2
const $f6cafe5dbc3bbc93$var$products1PList = [
    'Assets',
    'Atlas',
    'Confluence',
    'Atlassian Analytics',
    'Atlassian Cloud',
    'Automation for Jira',
    'Bamboo',
    'Bitbucket',
    'Compass',
    'Jira',
    'Jira Product Discovery',
    'Jira Service Management',
    'Jira Software',
    'Jira Work Management',
    'Jira Align',
    'Migration',
    'Loom',
    'Opsgenie',
    'Platform Experiences',
    'Rovo',
    'Statuspage',
    'Trello',
    'webSearch',
    'web-page',
    'Fisheye and Crucible',
    'Crowd',
    'Sourcetree',
    'Unknown',
    'Focus',
    'file-upload',
    'Advanced Roadmaps For Jira',
    'Questions for Confluence',
    'csm',
    'Dewey Support',
    'Dewey JAC Support',
    'Help Aggregator'
];
const $f6cafe5dbc3bbc93$var$getSourceProducts = (sources)=>{
    const products = {};
    sources.forEach((source)=>{
        const productName = source.product;
        if (productName) products[productName] = (products[productName] ?? 0) + 1;
    });
    return products;
};
const $f6cafe5dbc3bbc93$var$sanitizeSources = (sources)=>sources.map((source)=>({
            id: source.ari ?? source.id,
            type: source.type
        }));
const $f6cafe5dbc3bbc93$var$has3PSources = (sources)=>sources.some((source)=>source.product ? !$f6cafe5dbc3bbc93$var$products1PList.includes(source.product) && !source.product.includes('Plugin') : false);
/**
 * Any keys that exactly match an entry in this Set will _NOT_ be sanitized. So be sure that anything
 * you add here will not contain PII or UGC
 */ const $f6cafe5dbc3bbc93$var$ALLOWED_EXTRA_ATTRIBUTES_KEYS = new Set([
    'contentId',
    'readingAidsSessionId',
    'fieldType',
    'multipleUserResultsShown',
    'numAddtlWhoMatches',
    'isCuratedDefinition',
    'isPrecomputedDefinition',
    'editDistance',
    'bookmarkId',
    'bookmarkState',
    'dwellTime',
    'availableProducts',
    'isDescriptionEmpty',
    // from extraAPIAnalyticsAttributes
    'message_id',
    'conversational_channel_id',
    'experience_id',
    'user_id',
    // from extraAnalyticsAttributes
    'experiments',
    'featureGates',
    'isFullPageSearch',
    'has3pProducts',
    'is3pSearch',
    'mode',
    'triggeredBy',
    'referrer'
]);
const $f6cafe5dbc3bbc93$export$988d4f126deef74 = (extraAttributes)=>{
    if (!(0, $dh538.fg)('kd_fe_sanitize_analytics')) return extraAttributes;
    const sanitizedAttributes = {};
    // Sanitize everything except COMMON_ALLOWED_KEYS
    for(const key in extraAttributes)if ($f6cafe5dbc3bbc93$var$ALLOWED_EXTRA_ATTRIBUTES_KEYS.has(key)) sanitizedAttributes[key] = extraAttributes[key];
    else // replacing with text because the value has type `any`
    sanitizedAttributes[key] = '[sanitized]';
    return sanitizedAttributes;
};
const $f6cafe5dbc3bbc93$export$14f72eaec5bfc1a8 = (props)=>{
    const { appliedFilters: appliedFilters, answerFormat: answerFormat, answerLength: answerLength, answerWordCount: answerWordCount, answerCardType: answerCardType, cloudId: cloudId, followUps: followUps, sources: sources, extraAttributes: extraAttributes, searchSessionId: searchSessionId, queryHash: queryHash, baseQueryHash: baseQueryHash, query: query, answerString: answerString, apiSource: apiSource, brand: brand, sessionId: sessionId } = props;
    return {
        searchSessionId: searchSessionId,
        queryHash: queryHash,
        baseQueryHash: baseQueryHash,
        wordCount: (query.match(/\w+/g) || []).length,
        queryLength: query.length,
        answerHash: (0, $01aV7.sha256Hash)(answerString),
        appliedFilters: appliedFilters,
        answerFormat: answerFormat,
        answerLength: answerLength,
        answerWordCount: answerWordCount,
        answerCardType: answerCardType,
        followUpsCount: followUps.length,
        followUpsLength: followUps.map((followUp)=>followUp.length),
        has3PSources: $f6cafe5dbc3bbc93$var$has3PSources(sources),
        sources: $f6cafe5dbc3bbc93$var$sanitizeSources(sources),
        sourceProducts: $f6cafe5dbc3bbc93$var$getSourceProducts(sources),
        apiSource: apiSource,
        brand: brand,
        sessionId: sessionId,
        isHello: (0, $01aV7.isHello)(cloudId),
        ...$f6cafe5dbc3bbc93$export$988d4f126deef74(extraAttributes)
    };
};
module.exports["sanitizeExtraAttributes"] = $f6cafe5dbc3bbc93$export$988d4f126deef74;
module.exports["filterCommonAttributes"] = $f6cafe5dbc3bbc93$export$14f72eaec5bfc1a8;

});

parcelRegister("01aV7", function(module, exports) {

var $7azCD = parcelRequire("7azCD");


var $f7lNm = parcelRequire("f7lNm");

const $2d6714779ba6d3a2$export$e9131c78c1110376 = (str)=>(0, $7azCD.sha256)(str);
const $2d6714779ba6d3a2$export$a3b7216c107a7a1 = (sourceUrl)=>{
    let url;
    try {
        url = new URL(sourceUrl);
    } catch  {
        return undefined;
    }
    return url.hostname;
};
const $2d6714779ba6d3a2$export$8e3fc93123f96c19 = (cloudId)=>{
    return cloudId === 'a436116f-02ce-4520-8fbb-7301462a1674';
};
const $2d6714779ba6d3a2$export$694ee0cc469a8709 = (isReadingAids, smartAnswersRoute)=>{
    if (isReadingAids) return (0, $f7lNm.AnswerCardType).DEFINITION;
    switch(smartAnswersRoute){
        case (0, $f7lNm.QueryIntent).PERSON:
            return (0, $f7lNm.AnswerCardType).PERSON;
        case (0, $f7lNm.QueryIntent).TEAM:
            return (0, $f7lNm.AnswerCardType).TEAM;
        case (0, $f7lNm.QueryIntent).AGENT:
            return (0, $f7lNm.AnswerCardType).AGENT;
        case (0, $f7lNm.QueryIntent).DATE:
            return (0, $f7lNm.AnswerCardType).DATE;
        case (0, $f7lNm.QueryIntent).LOCATION:
            return (0, $f7lNm.AnswerCardType).LOCATION;
        case (0, $f7lNm.QueryIntent).TOPIC:
            return (0, $f7lNm.AnswerCardType).TOPIC;
        case (0, $f7lNm.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY:
            return (0, $f7lNm.AnswerCardType).JIRA_NATURAL_LANGUAGE_QUERY;
        case (0, $f7lNm.QueryIntent).JIRA_ISSUE:
            return (0, $f7lNm.AnswerCardType).JIRA_ISSUE;
        case (0, $f7lNm.QueryIntent).NAV_CONTENT:
            return (0, $f7lNm.AnswerCardType).NAV_CONTENT;
        case (0, $f7lNm.QueryIntent).ORG_CHART:
            return (0, $f7lNm.AnswerCardType).ORG_CHART;
        case (0, $f7lNm.QueryIntent).NAVIGATIONAL:
            return (0, $f7lNm.AnswerCardType).NAVIGATIONAL;
        case (0, $f7lNm.QueryIntent).NONE:
            return (0, $f7lNm.AnswerCardType).NONE;
        case (0, $f7lNm.QueryIntent).DEFAULT:
            return (0, $f7lNm.AnswerCardType).DEFAULT;
        case (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY:
        case (0, $f7lNm.QueryIntent).KEYWORD_OR_ACRONYM:
        default:
            return (0, $f7lNm.AnswerCardType).SAIN;
    }
};
module.exports["sha256Hash"] = $2d6714779ba6d3a2$export$e9131c78c1110376;
module.exports["extractUrlHostname"] = $2d6714779ba6d3a2$export$a3b7216c107a7a1;
module.exports["isHello"] = $2d6714779ba6d3a2$export$8e3fc93123f96c19;
module.exports["getAnswerCardType"] = $2d6714779ba6d3a2$export$694ee0cc469a8709;

});

parcelRegister("fjzE4", function(module, exports) {

var $7azCD = parcelRequire("7azCD");

const $f09d80c8646d0453$export$e9131c78c1110376 = (str)=>(0, $7azCD.sha256)(str);
const $f09d80c8646d0453$export$72ebbc2f4d73897b = (sources)=>sources.map((source)=>({
            id: source.ari ?? source.id,
            type: source.type
        }));
const $f09d80c8646d0453$export$f600f3124ea5916b = (nodes)=>{
    const categories = new Map();
    try {
        nodes.forEach((node)=>{
            const curCategoryCount = categories.get(node.category);
            if (!!curCategoryCount) categories.set(node.category, curCategoryCount + 1);
            else categories.set(node.category, 1);
        });
    } catch  {
        return undefined;
    }
    return Object.fromEntries(categories);
};
module.exports["getHighlightCategories"] = $f09d80c8646d0453$export$f600f3124ea5916b;

});

parcelRegister("bbPOv", function(module, exports) {
const $b754f76c2ea6a90a$export$b260340f6ff10d53 = 'PlatformHighlightKeywordsQuery';
const $b754f76c2ea6a90a$export$39b2bc657daf065 = `
	query ${$b754f76c2ea6a90a$export$b260340f6ff10d53}(
		$entityAri: String!
		$workspaceId: String!
		$jiraReporterAccountId: String
		$jiraAssigneeAccountId: String
		$inputText: KnowledgeDiscoveryKeyPhraseInputText
	) {
		knowledgeDiscovery  {
			keyPhrases(entityAri: $entityAri, workspaceId: $workspaceId, jiraReporterAccountId: $jiraReporterAccountId, jiraAssigneeAccountId: $jiraAssigneeAccountId, inputText: $inputText) 
				@optIn(to: "KnowledgeDiscovery Get Key Phrases") {
				__typename
				... on KnowledgeDiscoveryKeyPhraseConnection {
					nodes {
						... on KnowledgeDiscoveryKeyPhrase {
							keyPhrase
							category
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
module.exports["KEY_PHRASES_OPERATION_NAME"] = $b754f76c2ea6a90a$export$b260340f6ff10d53;
module.exports["KeyPhrasesQuery"] = $b754f76c2ea6a90a$export$39b2bc657daf065;

});

parcelRegister("14FKK", function(module, exports) {
// create separate utils folder if need to export more utils
const $e67d683b71b74003$var$validMarks = (data)=>{
    const invalidMarks = [
        'annotation',
        'link'
    ];
    return !data.marks || !data.marks.some((mark)=>invalidMarks.includes(mark.type));
};
const $e67d683b71b74003$var$validType = (data)=>{
    const invalidTypes = [
        'codeBlock'
    ];
    return !invalidTypes.includes(data.type);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e67d683b71b74003$var$extractContent = (data, flatMap)=>{
    if ($e67d683b71b74003$var$validType(data)) {
        if (data.content && data.content.length > 0) for (const node of data.content)$e67d683b71b74003$var$extractContent(node, flatMap);
    }
    // leaf node
    if (data.type === 'text' && $e67d683b71b74003$var$validMarks(data)) flatMap.push(data);
};
const $e67d683b71b74003$export$4cf5403beffb0fc1 = (adfValue)=>{
    const flatMap = [];
    $e67d683b71b74003$var$extractContent(adfValue, flatMap);
    return flatMap.map((node)=>node.text).join(',');
};
module.exports["parseContent"] = $e67d683b71b74003$export$4cf5403beffb0fc1;

});

parcelRegister("eVM9z", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $eRXI0 = parcelRequire("eRXI0");


var $7Zbm6 = parcelRequire("7Zbm6");


var $9EFEY = parcelRequire("9EFEY");


var $6yuru = parcelRequire("6yuru");


var $5Ymlp = parcelRequire("5Ymlp");


var $xhg8G = parcelRequire("xhg8G");


var $9nZle = parcelRequire("9nZle");


var $4WiNS = parcelRequire("4WiNS");


var $3qbRZ = parcelRequire("3qbRZ");

const $e71f869528412a13$var$i18n = (0, $cgtv4.defineMessages)({
    searchAiDialogQueryPretext: {
        id: "contextual-reading-aids.search-ai-dialog.query-pretext",
        defaultMessage: "what is {queryText}?"
    }
});
const $e71f869528412a13$var$NO_CURATED_DEF_FOUND_MESSAGE = 'No matching scope for Definition';
const $e71f869528412a13$export$7111b45b195dd101 = ({ workspaceId: workspaceId, cloudIdARI: cloudIdARI, fetchConfig: fetchConfig, isDefinitionCurationEnabled: isDefinitionCurationEnabled, productConfig: productConfig, product: product })=>{
    const intl = (0, $8C5kA.default)();
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { contentId: contentId } = productConfig;
    const fetchAIGeneratedDefinition = (0, $42omo.useCallback)(async ({ variables: variables })=>{
        const { query: query, locale: locale, additional_context: additional_context, experience: experience, followUpsEnabled: followUpsEnabled } = variables;
        if (contentId !== '') try {
            const precomputedResult = await (0, $9EFEY.fetchAggResponse)({
                graphQuery: (0, $4WiNS.PrecomputedDefinitionQuery),
                variables: {
                    workspaceId: workspaceId,
                    keyPhrase: variables.query,
                    contentId: contentId
                },
                headers: (0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudIdARI,
                    product: product
                })
            });
            if (precomputedResult.data && !precomputedResult.data.knowledgeDiscovery.autoDefinition.message) {
                const data = {
                    nlpSearch: (0, $3qbRZ.mapCustomDefinitionToNLPSearchType)(precomputedResult.data.knowledgeDiscovery.autoDefinition)
                };
                setLoading(false);
                return data;
            } else if (precomputedResult.data && precomputedResult.data.knowledgeDiscovery.autoDefinition.message) throw new Error(precomputedResult.data.knowledgeDiscovery.autoDefinition.message);
            else throw new Error('Something went wrong with fetching precomputed definition');
        } catch (error) {
            if (error instanceof Object && 'message' in error && error.message !== $e71f869528412a13$var$NO_CURATED_DEF_FOUND_MESSAGE) fireAnalyticsEvent((0, $xhg8G.fetchPrecomputedDefinitionErrorPayload)(error, commonAttributes));
        }
        const streamFetchArgs = {
            variables: {
                query: intl.formatMessage($e71f869528412a13$var$i18n.searchAiDialogQueryPretext, {
                    queryText: query
                }),
                locale: locale,
                cloudIdARI: cloudIdARI,
                additional_context: additional_context,
                experience: experience,
                followUpsEnabled: followUpsEnabled
            },
            isReadingAids: true,
            fetchConfig: fetchConfig,
            generatorConfig: {
                yieldAnswerPart: true,
                yieldFinalResponse: true
            },
            onStreamFinalResponse: ()=>{
                setLoading(false);
            }
        };
        return {
            type: (0, $7Zbm6.AIAnswerAPIType).STREAM,
            stream: (0, $5Ymlp.aiDefinitionsStreamFetchConvoAIService)(streamFetchArgs)
        };
    }, [
        cloudIdARI,
        fetchConfig,
        intl,
        commonAttributes,
        fireAnalyticsEvent,
        workspaceId,
        contentId,
        product
    ]);
    const fetchDefinition = (0, $42omo.useCallback)(async ({ variables: variables })=>{
        if (isDefinitionCurationEnabled) try {
            let confluenceScopeId, jiraScopeId;
            if ('spaceId' in productConfig) confluenceScopeId = productConfig;
            else if ('projectId' in productConfig) jiraScopeId = {
                projectId: productConfig.projectId
            };
            const result = await (0, $9EFEY.fetchAggResponse)({
                graphQuery: (0, $9nZle.CuratedDefinitionQuery),
                variables: {
                    workspaceId: workspaceId,
                    keyPhrase: variables.query,
                    confluenceScopeId: confluenceScopeId,
                    jiraScopeId: jiraScopeId
                },
                operationName: (0, $9nZle.CURATED_DEFINITION_OPERATION_NAME),
                headers: (0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudIdARI,
                    product: product
                })
            });
            if (result.data && !result.data.knowledgeDiscovery.definition.message) {
                const data = {
                    nlpSearch: (0, $3qbRZ.mapCustomDefinitionToNLPSearchType)(result.data.knowledgeDiscovery.definition)
                };
                setLoading(false);
                return data;
            } else if (result.data && result.data.knowledgeDiscovery.definition.message) throw new Error(result.data.knowledgeDiscovery.definition.message);
            else throw new Error('Something went wrong with fetching curated definition');
        } catch (error) {
            // want to fire event when error.message does not equal the no curated definition message
            // returned by the query in data.knowledgeDiscovery.definition.message
            if (error instanceof Object && 'message' in error && error.message !== $e71f869528412a13$var$NO_CURATED_DEF_FOUND_MESSAGE) fireAnalyticsEvent((0, $xhg8G.fetchCuratedDefinitionErrorPayload)(error, commonAttributes));
            return fetchAIGeneratedDefinition({
                variables: variables
            });
        }
        return fetchAIGeneratedDefinition({
            variables: variables
        });
    }, [
        productConfig,
        fetchAIGeneratedDefinition,
        isDefinitionCurationEnabled,
        workspaceId,
        commonAttributes,
        fireAnalyticsEvent,
        cloudIdARI,
        product
    ]);
    return {
        fetchDefinition: fetchDefinition,
        loading: loading
    };
};
module.exports["useDefinitionSupplier"] = $e71f869528412a13$export$7111b45b195dd101;

});

parcelRegister("eRXI0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $f7lNm = parcelRequire("f7lNm");

const $c9273af68a747a43$var$UNINITIALIZED_COMMON_ATTRIBUTES = {
    cloudId: '',
    query: '',
    queryHash: '',
    baseQueryHash: '',
    source: '',
    searchSessionId: '',
    answerString: '',
    answerLength: 0,
    answerWordCount: 0,
    answerFormat: null,
    answerCardType: (0, $f7lNm.AnswerCardType).SAIN,
    sources: [],
    followUps: [],
    errorStateSuggestedQueries: [],
    errorState: null,
    extraAttributes: {},
    apiSource: 'cc-search-nlp',
    workspaceId: '',
    sessionId: '',
    brand: (0, $f7lNm.AiBrand).AI,
    orgId: ''
};
const $c9273af68a747a43$export$19a05d5f6391d0e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    loading: undefined,
    isAnswered: false,
    hasError: false,
    advancedSearchUrl: undefined,
    onNavigate: ()=>{},
    updateContextCache: ()=>{},
    fireAnalyticsEvent: ()=>{},
    setQuery: ()=>{},
    setData: ()=>{},
    userDetails: {},
    disclaimer: null,
    commonAttributes: $c9273af68a747a43$var$UNINITIALIZED_COMMON_ATTRIBUTES,
    initialCollapsed: undefined,
    liked: undefined,
    setLiked: ()=>{},
    likesDisabled: false,
    setLikesDisabled: ()=>{},
    initialReported: undefined,
    isReadingAids: false,
    dynamicLayoutSubAgentMessages: [],
    setDynamicLayoutSubAgentMessages: ()=>{},
    cardProviderProps: undefined,
    baseQuery: undefined,
    smartAnswersRoute: (0, $f7lNm.QueryIntent).DEFAULT,
    cardTemplate: (0, $f7lNm.CardTemplate).DEFAULT,
    brand: (0, $f7lNm.AiBrand).AI,
    answerEditor: undefined,
    closeParentDialog: ()=>{},
    showGenericFooter: false,
    initiallyExpanded: false
});
const $c9273af68a747a43$export$1485bfa2a4aa8c9b = ()=>{
    return (0, $42omo.useContext)($c9273af68a747a43$export$19a05d5f6391d0e1);
};
module.exports["AIAnswerContext"] = $c9273af68a747a43$export$19a05d5f6391d0e1;
module.exports["useAIAnswerContext"] = $c9273af68a747a43$export$1485bfa2a4aa8c9b;

});

parcelRegister("5Ymlp", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $iA4lt = parcelRequire("iA4lt");


var $7Zbm6 = parcelRequire("7Zbm6");


var $4Zqgi = parcelRequire("4Zqgi");


var $f7lNm = parcelRequire("f7lNm");


var $2NVuz = parcelRequire("2NVuz");


var $5Wlau = parcelRequire("5Wlau");

const $6ff046935ab0156c$var$identityUserCloudARIPrefix = 'ari:cloud:identity::user/';
function $6ff046935ab0156c$var$getAgentAndExperience(isReadingAids) {
    return isReadingAids ? {
        named_id: 'reading_aids_agent',
        experience: 'reading-aids'
    } : {
        named_id: 'sain_agent',
        experience: 'sain'
    };
}
function $6ff046935ab0156c$var$mapMimeTypeToFormat(mimeType) {
    switch(mimeType){
        case 'text/markdown':
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
        case 'text/adf':
            return (0, $7Zbm6.NLPSearchResultFormat).ADF;
        case 'text/json':
            return (0, $7Zbm6.NLPSearchResultFormat).JSON;
        default:
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
    }
}
function $6ff046935ab0156c$var$mapErrorToSain(error, traceId) {
    const errorMessage = 'message_template' in error ? error.message_template : error.message.message_template;
    switch(errorMessage){
        case 'NO_ANSWER_LLM':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswer;
        case 'NO_ANSWER_PEOPLE':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerWhoQuestion;
        case 'NO_ANSWER_KEYWORDS':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerKeywords;
        case 'NO_ANSWER_SEARCH_QA_PLUGIN':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerSearchResults;
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return (0, $7Zbm6.NLPSearchErrorState).AcceptableUseViolation;
        case 'OPENAI_RATE_LIMIT_USER_ABUSE':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse;
        case 'FEATURE_DISABLED_ON_SITE':
            return (0, $7Zbm6.NLPSearchErrorState).AIDisabled;
        default:
            (0, $4Zqgi.logger).error({
                error: error,
                functionName: 'mapErrorToSain: NetworkError',
                traceId: traceId
            });
            return (0, $7Zbm6.NLPSearchErrorState).NetworkError;
    }
}
function $6ff046935ab0156c$var$mapMessageToNLPSearchType(message, requestId) {
    // Handle cases where message is directly in root or nested under message.message
    const messageContent = message.message || message;
    return {
        nlpResult: messageContent.content,
        uniqueSources: message.sources ? message.sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: messageContent.message_metadata?.disclaimer ?? null,
        errorState: null,
        format: $6ff046935ab0156c$var$mapMimeTypeToFormat(messageContent.content_mime_type),
        extraAPIAnalyticsAttributes: {
            message_id: messageContent.id,
            conversational_channel_id: messageContent.conversation_channel_id,
            experience_id: messageContent.experience_id,
            user_id: messageContent.user_ari?.replace($6ff046935ab0156c$var$identityUserCloudARIPrefix, '') ?? null,
            userQuery: message.human_message?.content ?? null,
            requestId: (0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? requestId ?? null : message.message?.message_metadata?.request_id ?? null,
            answerGenerationModel: message.usage_data ?? null,
            sources: message.sources,
            cacheInfo: message.message?.message_metadata?.global_cache_info ?? null,
            pluginInvocations: message.message?.plugin_invocations,
            rawJson: message,
            ...(0, $dh538.fg)('kd_sain_online_debugger') && {
                minion_outputs: message.message?.minion_outputs,
                traceId: requestId ?? null
            }
        }
    };
}
function $6ff046935ab0156c$var$mapStreamResponse(response, traceId) {
    if ((0, $2NVuz.isStreamError)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: {
            errorState: $6ff046935ab0156c$var$mapErrorToSain(response, traceId),
            errorCode: response.message.status_code,
            disclaimer: null,
            format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
            uniqueSources: []
        }
    };
    if ((0, $2NVuz.isStreamGenerationType)(response) && (0, $dh538.fg)('kd_dynamic_layout_in_sain')) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType,
        message: {
            answer_generation_type: response.message.answer_generation_type
        }
    };
    if ((0, $2NVuz.isStreamTrace)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).Trace,
        message: response.message.content
    };
    if ((0, $2NVuz.isStreamAnswerPart)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart,
        message: {
            nlpResult: response.message.content
        }
    };
    if ((0, $2NVuz.isStreamResponse)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: $6ff046935ab0156c$var$mapMessageToNLPSearchType(response.message, traceId)
    };
    if ((0, $2NVuz.isStreamFollowUp)(response)) return {
        type: 'follow-up',
        queries: response.message.follow_up_queries ?? []
    };
    if ((0, $2NVuz.isStreamErrorStateQuerySuggestions)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions,
        suggested_queries: response.message.suggested_queries ?? []
    };
    if ((0, $dh538.fg)('kd_dynamic_layout_in_sain')) {
        if ((0, $2NVuz.isStreamDynamicLayoutSubAgent)(response)) return {
            type: (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage,
            message: response.message
        };
    }
    return {
        // Don't currently handle other types, such as PLUGIN_INVOCATION
        type: 'other'
    };
}
async function* $6ff046935ab0156c$export$87d234127b4babfd({ fetchReturn: fetchReturn, variables: variables, fetchConfig: fetchConfig }) {
    try {
        const { query: query, locale: locale, experience: experience, filters: filters, cloudIdARI: cloudIdARI, followUpsEnabled: followUpsEnabled } = variables || {};
        const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.SAIN_STREAMING_API)}`;
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: query,
                filters: filters,
                locations: [
                    cloudIdARI
                ],
                locale: locale,
                experience: experience,
                followUpsEnabled: followUpsEnabled
            }),
            credentials: fetchConfig?.credentials || 'same-origin'
        }));
        if (!response.ok) // For non 200 status codes
        return {
            state: 'failed',
            reason: 'backend',
            details: 'Unhandled error response received',
            errorCode: response.status
        };
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = JSON.parse(line);
                    if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) yield parsedData;
                    else {
                        finalResponse = parsedData;
                        done = true;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') // this is likely an abort error
        return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
const $6ff046935ab0156c$var$getAgentInput = ({ variables: variables, fetchConfig: fetchConfig })=>{
    const { query: query, locale: locale, additional_context: additional_context, experimentContext: experimentContext } = variables || {};
    return {
        content: query,
        locale: locale,
        additional_context: additional_context,
        entity_ari: fetchConfig?.entity_ari,
        ...experimentContext && (0, $dh538.fg)('kd_sain_backend_exp_context') && {
            experimentContext: experimentContext
        }
    };
};
async function* $6ff046935ab0156c$export$ba95d3529d42f9ef({ fetchReturn: fetchReturn, variables: variables, isReadingAids: isReadingAids, fetchConfig: fetchConfig, generatorConfig: generatorConfig = {
    yieldAnswerPart: true,
    yieldFinalResponse: false
}, onStreamFinalResponse: onStreamFinalResponse }) {
    try {
        const { filters: filters, selectedProduct: selectedProduct } = variables || {};
        const { experience: experience, named_id: named_id } = $6ff046935ab0156c$var$getAgentAndExperience(isReadingAids);
        const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.ASSISTANCE_SERVICE_API_BASE_URL)}/chat/v1/invoke_agent/stream`;
        const streamFilters = filters && !Array.isArray(filters) && (0, $dh538.fg)('kd_add_common_filters_support_to_sain') ? [
            {
                commonFilters: filters.commonFilters
            },
            {
                confluenceFilters: filters.confluenceFilters
            }
        ] : [
            {
                confluenceFilters: filters
            }
        ];
        if (selectedProduct) streamFilters.push({
            knowledgeSources: [
                selectedProduct
            ]
        });
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': experience,
                ...fetchConfig?.headers ? fetchConfig.headers : {}
            },
            body: JSON.stringify({
                recipient_agent_named_id: named_id,
                agent_input: {
                    ...$6ff046935ab0156c$var$getAgentInput({
                        variables: variables,
                        fetchConfig: fetchConfig
                    }),
                    filters: filters ? streamFilters : undefined
                }
            }),
            credentials: fetchConfig?.credentials || 'same-origin',
            signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
        }));
        const traceId = response.headers.get('x-trace-id') || null;
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            yield {
                type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType,
                message: {
                    format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN
                }
            };
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // add case here to return error from stream
                if (!response.ok) {
                    const finalResponse = JSON.parse(lines[0]);
                    if (finalResponse?.errors.includes((0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR)) return {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR,
                        errorCode: response.status
                    };
                    // For non 200 status codes
                    return {
                        state: 'failed',
                        reason: 'backend',
                        details: 'Unhandled error response received',
                        errorCode: response.status
                    };
                }
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = (0, $dh538.fg)('kd_separate_sain_definitions_response_mappers') ? (0, $5Wlau.mapStreamSAINResponse)(JSON.parse(line), traceId) : $6ff046935ab0156c$var$mapStreamResponse(JSON.parse(line), traceId);
                    if (parsedData.type === 'other') continue;
                    else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) {
                        if (generatorConfig.yieldAnswerPart) yield parsedData;
                    } else if (parsedData.type === 'follow-up') {
                        if (!finalResponse?.message || !variables?.followUpsEnabled) continue;
                        finalResponse.message.nlpFollowUpResults = {
                            followUps: parsedData.queries
                        };
                        done = true;
                    } else {
                        finalResponse = parsedData;
                        onStreamFinalResponse?.();
                        if (!variables?.followUpsEnabled) done = true;
                        if (generatorConfig.yieldFinalResponse) yield finalResponse;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') // this is likely an abort error
        return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof DOMException && error.name === 'TimeoutError') return {
            state: 'failed',
            reason: 'timeout'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
async function* $6ff046935ab0156c$export$3e1bd964ad0ba888({ fetchReturn: fetchReturn, variables: variables, isReadingAids: isReadingAids, fetchConfig: fetchConfig, generatorConfig: generatorConfig = {
    yieldAnswerPart: true,
    yieldFinalResponse: false
}, onStreamFinalResponse: onStreamFinalResponse }) {
    try {
        const { filters: filters, selectedProduct: selectedProduct } = variables || {};
        const { experience: experience, named_id: named_id } = $6ff046935ab0156c$var$getAgentAndExperience(isReadingAids);
        const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.ASSISTANCE_SERVICE_API_BASE_URL)}/rovo/v1/sain/stream`;
        const streamFilters = filters && !Array.isArray(filters) && (0, $dh538.fg)('kd_add_common_filters_support_to_sain') ? [
            {
                commonFilters: filters.commonFilters
            },
            {
                confluenceFilters: filters.confluenceFilters
            }
        ] : [
            {
                confluenceFilters: filters
            }
        ];
        if (selectedProduct) streamFilters.push({
            knowledgeSources: [
                selectedProduct
            ]
        });
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': experience,
                ...fetchConfig?.headers ? fetchConfig.headers : {}
            },
            body: JSON.stringify({
                recipient_agent_named_id: named_id,
                agent_input: {
                    ...$6ff046935ab0156c$var$getAgentInput({
                        variables: variables,
                        fetchConfig: fetchConfig
                    }),
                    filters: filters ? streamFilters : undefined
                }
            }),
            credentials: fetchConfig?.credentials || 'same-origin',
            signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
        }));
        const traceId = response.headers.get('x-trace-id') || null;
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            yield {
                type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType,
                message: {
                    format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN
                }
            };
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // add case here to return error from stream
                if (!response.ok) {
                    const finalResponse = JSON.parse(lines[0]);
                    if (finalResponse?.errors.includes((0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR)) return {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR,
                        errorCode: response.status
                    };
                    // For non 200 status codes
                    return {
                        state: 'failed',
                        reason: 'backend',
                        details: 'Unhandled error response received',
                        errorCode: response.status
                    };
                }
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = (0, $dh538.fg)('kd_separate_sain_definitions_response_mappers') ? (0, $5Wlau.mapStreamSAINResponse)(JSON.parse(line), traceId) : $6ff046935ab0156c$var$mapStreamResponse(JSON.parse(line), traceId);
                    if (parsedData.type === 'other') continue;
                    else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) {
                        if (generatorConfig.yieldAnswerPart) yield parsedData;
                    } else if (parsedData.type === 'follow-up') {
                        if (!finalResponse?.message || !variables?.followUpsEnabled) continue;
                        finalResponse.message.nlpFollowUpResults = {
                            followUps: parsedData.queries
                        };
                        const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $iA4lt.getFrontendExperiment)({
                            abTestId: 'kd_sain_show_no_answer_suggestions_exp'
                        });
                        if (!serveErrorStateSuggestedQueriesExp) done = true;
                    } else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions) {
                        if (!finalResponse?.message) continue;
                        finalResponse.message.nlpSuggestedQueries = parsedData.suggested_queries;
                        done = true;
                    } else {
                        finalResponse = parsedData;
                        onStreamFinalResponse?.();
                        if (!variables?.followUpsEnabled) done = true;
                        if (generatorConfig.yieldFinalResponse) yield finalResponse;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') // this is likely an abort error
        return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof DOMException && error.name === 'TimeoutError') return {
            state: 'failed',
            reason: 'timeout'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
async function $6ff046935ab0156c$export$c8ae4e2310d6c222({ variables: variables, isReadingAids: isReadingAids, fetchConfig: fetchConfig }) {
    const { experience: experience, named_id: named_id } = $6ff046935ab0156c$var$getAgentAndExperience(isReadingAids);
    const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.ASSISTANCE_SERVICE_API_BASE_URL)}/chat/v1/invoke_agent`;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Product': 'confluence',
            'X-Experience-Id': experience,
            ...fetchConfig?.headers
        },
        body: JSON.stringify({
            recipient_agent_named_id: named_id,
            agent_input: $6ff046935ab0156c$var$getAgentInput({
                variables: variables,
                fetchConfig: fetchConfig
            })
        }),
        credentials: fetchConfig?.credentials || 'same-origin',
        signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
    });
    const traceId = response.headers.get('x-trace-id') || null;
    const data = await response.json();
    if ('message_template' in data) return {
        nlpSearch: {
            errorState: $6ff046935ab0156c$var$mapErrorToSain(data, traceId),
            disclaimer: null,
            format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
            uniqueSources: []
        }
    };
    return {
        nlpSearch: $6ff046935ab0156c$var$mapMessageToNLPSearchType(data, traceId)
    };
}
async function* $6ff046935ab0156c$export$824b789d24de77d3({ fetchReturn: fetchReturn, variables: variables, fetchConfig: fetchConfig, generatorConfig: generatorConfig = {
    yieldAnswerPart: true,
    yieldFinalResponse: false
}, onStreamFinalResponse: onStreamFinalResponse }) {
    try {
        const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.ASSISTANCE_SERVICE_API_BASE_URL)}/rovo/v1/ai-definition`;
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': 'reading-aids',
                ...fetchConfig?.headers ? fetchConfig.headers : {}
            },
            body: JSON.stringify({
                ...$6ff046935ab0156c$var$getAgentInput({
                    variables: variables,
                    fetchConfig: fetchConfig
                })
            }),
            credentials: fetchConfig?.credentials || 'same-origin',
            signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
        }));
        const traceId = response.headers.get('x-trace-id') || null;
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            yield {
                type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType,
                message: {
                    format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN
                }
            };
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // add case here to return error from stream
                if (!response.ok) {
                    const finalResponse = JSON.parse(lines[0]);
                    if (finalResponse?.errors.includes((0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR)) return {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR,
                        errorCode: response.status
                    };
                    return {
                        state: 'failed',
                        reason: 'backend',
                        details: 'Unhandled error response received',
                        errorCode: response.status
                    };
                }
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = (0, $dh538.fg)('kd_separate_sain_definitions_response_mappers') ? (0, $5Wlau.mapStreamDefinitionResponse)(JSON.parse(line)) : $6ff046935ab0156c$var$mapStreamResponse(JSON.parse(line), traceId);
                    if (parsedData.type === 'other') continue;
                    else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) {
                        if (generatorConfig.yieldAnswerPart) yield parsedData;
                    } else if (parsedData.type === 'follow-up') {
                        if (!finalResponse?.message || !variables?.followUpsEnabled) continue;
                        finalResponse.message.nlpFollowUpResults = {
                            followUps: parsedData.queries
                        };
                        const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $iA4lt.getFrontendExperiment)({
                            abTestId: 'kd_sain_show_no_answer_suggestions_exp'
                        });
                        if (!serveErrorStateSuggestedQueriesExp) done = true;
                    } else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions) {
                        if (!finalResponse?.message) continue;
                        finalResponse.message.nlpSuggestedQueries = parsedData.suggested_queries;
                        done = true;
                    } else {
                        finalResponse = parsedData;
                        onStreamFinalResponse?.();
                        if (!variables?.followUpsEnabled) done = true;
                        if (generatorConfig.yieldFinalResponse) yield finalResponse;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof DOMException && error.name === 'TimeoutError') return {
            state: 'failed',
            reason: 'timeout'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
module.exports["sainStreamFetchConvoAIService"] = $6ff046935ab0156c$export$3e1bd964ad0ba888;
module.exports["aiDefinitionsStreamFetchConvoAIService"] = $6ff046935ab0156c$export$824b789d24de77d3;

});

parcelRegister("iA4lt", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $4vEoF = parcelRequire("4vEoF");

const $3a954310db248169$export$a68238496eb1c8ce = ({ abTestId: abTestId, onError: onError })=>{
    try {
        const cohort = (0, $c6GJD.default).getExperiment(abTestId).get('cohort', (0, $4vEoF.Cohort).Default);
        const serveExperiment = cohort === (0, $4vEoF.Cohort).Test;
        return {
            serveExperiment: serveExperiment,
            abTestId: abTestId,
            cohort: cohort
        };
    } catch (error) {
        onError?.(error);
    }
    return {
        serveExperiment: false,
        abTestId: abTestId,
        cohort: (0, $4vEoF.Cohort).Default
    };
};
const $3a954310db248169$export$8774a01dc80b4a26 = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $c6GJD.default).checkGate('search-experiment-overrides-killswitch')) return $3a954310db248169$var$defaultCheckGate;
    if (!overrides) return $3a954310db248169$var$defaultCheckGate;
    try {
        const gates = overrides.filter((overrides)=>overrides.type === 'gate');
        const getFeatureGate = (name)=>{
            const overrideFeatureGate = gates.find((override)=>'name' in override && override.name === name);
            if (!overrideFeatureGate) return $3a954310db248169$var$defaultCheckGate(name);
            // Overrides always resolve to true as using an override is equivelant to turning FF on.
            return true;
        };
        return getFeatureGate;
    } catch (e) {
        console.error(e);
        return $3a954310db248169$var$defaultCheckGate;
    }
};
const $3a954310db248169$export$841981a8a1feee8d = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $c6GJD.default).checkGate('search-experiment-overrides-killswitch')) return $3a954310db248169$export$a68238496eb1c8ce;
    if (!overrides) return $3a954310db248169$export$a68238496eb1c8ce;
    try {
        const experiments = overrides.filter((overrides)=>overrides.type === 'experiment');
        const customGetFrontendExperiment = ({ abTestId: abTestId, onError: onError })=>{
            const overrideFrontendExperiment = experiments.find((override)=>'name' in override && override.name === abTestId);
            if (!overrideFrontendExperiment) return $3a954310db248169$export$a68238496eb1c8ce({
                abTestId: abTestId,
                onError: onError
            });
            return {
                abTestId: abTestId,
                serveExperiment: true,
                cohort: 'cohort' in overrideFrontendExperiment ? overrideFrontendExperiment.cohort : (0, $4vEoF.Cohort).Test
            };
        };
        return customGetFrontendExperiment;
    } catch (e) {
        console.error(e);
        return $3a954310db248169$export$a68238496eb1c8ce;
    }
};
// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
const $3a954310db248169$var$defaultCheckGate = (name)=>(0, $c6GJD.default).checkGate(name);
const $3a954310db248169$export$b8cc3cdd046fba93 = (uiExperimentName, layerName, options = {
    fireLayerExposure: true
})=>{
    const layer = (0, $c6GJD.default).getLayer(layerName, {
        fireLayerExposure: false
    });
    const frontendExperimentName = layer.get('frontendExperimentName', '');
    if (frontendExperimentName === uiExperimentName) return (0, $c6GJD.default).getLayer(layerName, options);
    return undefined;
};
module.exports["getFrontendExperiment"] = $3a954310db248169$export$a68238496eb1c8ce;
module.exports["createFeatureGateHandler"] = $3a954310db248169$export$8774a01dc80b4a26;
module.exports["createFrontendExperimentHandler"] = $3a954310db248169$export$841981a8a1feee8d;
module.exports["getMutuallyExclusiveUIExperiment"] = $3a954310db248169$export$b8cc3cdd046fba93;

});

parcelRegister("4vEoF", function(module, exports) {
var $f534e05ac776c43b$export$b76685d1b5a37732 = /*#__PURE__*/ function(Cohort) {
    Cohort["Default"] = "not-enrolled";
    Cohort["Control"] = "control";
    Cohort["Test"] = "test";
    return Cohort;
}({});
module.exports["Cohort"] = $f534e05ac776c43b$export$b76685d1b5a37732;

});

parcelRegister("4Zqgi", function(module, exports) {

var $97HEP = parcelRequire("97HEP");

const $2afb97bb773ddd18$var$error = async ({ error: error, functionName: functionName, traceId: traceId })=>{
    try {
        const SentryClient = await (0, $97HEP.getSentryClient)();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            scope.setTag('packageName', '@atlassian/search-ai');
            scope.setFingerprint([
                `functionName: ${functionName}`
            ]);
            if (traceId) scope.setTag('traceId', traceId);
            SentryClient.captureException(error, scope);
        });
    } catch (error) {
        // When there was an error with Sentry, just output to console
        // eslint-disable-next-line no-console
        console.error(error);
    }
};
const $2afb97bb773ddd18$export$af88d00dbe7f521 = {
    error: $2afb97bb773ddd18$var$error
};
module.exports["logger"] = $2afb97bb773ddd18$export$af88d00dbe7f521;

});

parcelRegister("97HEP", function(module, exports) {

var $3nPYZ = parcelRequire("3nPYZ");


var $1JvBr = parcelRequire("1JvBr");


var $g8CIJ = parcelRequire("g8CIJ");

let $effdb799a148a720$var$Sentry;
const $effdb799a148a720$var$beforeSend = (event)=>{
    // Delete the query string as it contains UGC
    if (event.request?.url) event.request.url = event.request.url.split('?')[0];
    if (event.request?.headers?.Referer) event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
    if (event.environment === 'development') return null;
    return event;
};

const $effdb799a148a720$export$f553e8b08ef59d31 = async ()=>{
    if (!$effdb799a148a720$var$Sentry) $effdb799a148a720$var$Sentry = (parcelRequire("jKrYC")).then((SentryModule)=>{
        SentryModule.init({
            dsn: (0, $g8CIJ.SENTRY_DSN),
            attachStacktrace: true,
            release: (0, $3nPYZ.PRODUCT_BUILD) || (0, $g8CIJ.UNKNOWN_TAG),
            environment: (0, $1JvBr.getEnvironment)(),
            beforeSend: $effdb799a148a720$var$beforeSend
        });
        return SentryModule;
    }).catch(()=>{
    // TODO: Retry mechanism for chunk loading failures?
    });
    return $effdb799a148a720$var$Sentry;
};
module.exports["getSentryClient"] = $effdb799a148a720$export$f553e8b08ef59d31;

});

parcelRegister("3nPYZ", function(module, exports) {
// @ts-nocheck - extra properties on window are not known
/**
 * Constants for the build version of the product. Each product specifies
 * build version in a different way.
 *  - Jira: window.BUILD_KEY
 *  - Confluence: window.__buildInfo.FRONTEND_VERSION
 *  - For the service workers where window is not available, we return 'unknown'.
 */ const $caff51da97cfcbcc$export$668f31ea3127f48f = (typeof window !== 'undefined' && (window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION)) ?? 'unknown';
module.exports["PRODUCT_BUILD"] = $caff51da97cfcbcc$export$668f31ea3127f48f;

});

parcelRegister("1JvBr", function(module, exports) {
const $bfee5be0414bd1fa$export$57570b1603cf6adb = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
module.exports["getEnvironment"] = $bfee5be0414bd1fa$export$57570b1603cf6adb;

});

parcelRegister("g8CIJ", function(module, exports) {
// https://atlassian-2y.sentry.io/projects/afm-search-ai/getting-started/
const $6ddb4d99fe6d7477$export$6faa4a850bc4d0ce = 'https://467ed23c400f1de490da05364bed5930@o55978.ingest.us.sentry.io/4507432686125056';
const $6ddb4d99fe6d7477$export$ea77880e3935182d = 'unknown';
module.exports["SENTRY_DSN"] = $6ddb4d99fe6d7477$export$6faa4a850bc4d0ce;
module.exports["UNKNOWN_TAG"] = $6ddb4d99fe6d7477$export$ea77880e3935182d;

});

parcelRegister("jKrYC", function(module, exports) {

let $e60803cf9f855be7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e60803cf9f855be7$var$load("hyqsV"),
    $e60803cf9f855be7$var$load("fhU7k")
]).then(()=>parcelRequire('cJyjM'));

});

parcelRegister("2NVuz", function(module, exports) {
/** Types copied from platform/packages/ai-mate/conversation-assistant/src/services/assistance-service/types.ts for now */ var $605e1a783968ada3$export$49d1ac864ca8db3a = /*#__PURE__*/ function(NLPSearchDisclaimerType) {
    NLPSearchDisclaimerType["WhoDisclaimer"] = "WHO_QUESTION";
    return NLPSearchDisclaimerType;
}({});
var $605e1a783968ada3$export$255ec938a30a2b3 = /*#__PURE__*/ function(StreamAnswerGenerationTypes) {
    StreamAnswerGenerationTypes["LUMINA"] = "LUMINA";
    StreamAnswerGenerationTypes["STANDARD"] = "STANDARD";
    return StreamAnswerGenerationTypes;
}({});
const $605e1a783968ada3$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $605e1a783968ada3$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $605e1a783968ada3$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $605e1a783968ada3$export$c563bc6129a38894 = (message)=>message instanceof Object && message.type === 'ANSWER_GENERATION_TYPE';
const $605e1a783968ada3$export$fd5a05be03f147a0 = (message)=>message instanceof Object && message.type === 'TRACE';
const $605e1a783968ada3$export$51a1b4e474708d74 = (message)=>message instanceof Object && message.type === 'PLUGIN_INVOCATION';
const $605e1a783968ada3$export$cfb6b6bb809f778e = (message)=>message instanceof Object && message.type === 'FOLLOW_UP_QUERIES';
const $605e1a783968ada3$export$de29cc71fd2aafc1 = (message)=>message instanceof Object && message.type === 'ERROR_STATE_QUERY_SUGGESTIONS';
const $605e1a783968ada3$export$5fa02529cd2ab34c = (message)=>message instanceof Object && message.type === 'DL_SUB_AGENT';
const $605e1a783968ada3$export$b6b59db8d0b45219 = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $605e1a783968ada3$export$53e95dec5f877b4e = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
module.exports["StreamAnswerGenerationTypes"] = $605e1a783968ada3$export$255ec938a30a2b3;
module.exports["isStreamResponse"] = $605e1a783968ada3$export$b4631726cbc1440a;
module.exports["isStreamError"] = $605e1a783968ada3$export$d422a2733a3b5def;
module.exports["isStreamAnswerPart"] = $605e1a783968ada3$export$e45102edbc73b240;
module.exports["isStreamGenerationType"] = $605e1a783968ada3$export$c563bc6129a38894;
module.exports["isStreamTrace"] = $605e1a783968ada3$export$fd5a05be03f147a0;
module.exports["isStreamFollowUp"] = $605e1a783968ada3$export$cfb6b6bb809f778e;
module.exports["isStreamErrorStateQuerySuggestions"] = $605e1a783968ada3$export$de29cc71fd2aafc1;
module.exports["isStreamDynamicLayoutSubAgent"] = $605e1a783968ada3$export$5fa02529cd2ab34c;
module.exports["isStreamSAINResponse"] = $605e1a783968ada3$export$b6b59db8d0b45219;
module.exports["isStreamDefinitionResponse"] = $605e1a783968ada3$export$53e95dec5f877b4e;

});

parcelRegister("5Wlau", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $7Zbm6 = parcelRequire("7Zbm6");


var $4Zqgi = parcelRequire("4Zqgi");


var $2NVuz = parcelRequire("2NVuz");

const $087142bc218bc052$var$mapMimeTypeToFormat = (mimeType)=>{
    switch(mimeType){
        case 'text/markdown':
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
        case 'text/adf':
            return (0, $7Zbm6.NLPSearchResultFormat).ADF;
        case 'text/json':
            return (0, $7Zbm6.NLPSearchResultFormat).JSON;
        default:
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
    }
};
const $087142bc218bc052$var$mapErrorTo = (error, traceId)=>{
    const errorMessage = 'message_template' in error ? error.message_template : error.message.message_template;
    switch(errorMessage){
        case 'NO_ANSWER_LLM':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswer;
        case 'NO_ANSWER_PEOPLE':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerWhoQuestion;
        case 'NO_ANSWER_KEYWORDS':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerKeywords;
        case 'NO_ANSWER_SEARCH_QA_PLUGIN':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerSearchResults;
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return (0, $7Zbm6.NLPSearchErrorState).AcceptableUseViolation;
        case 'OPENAI_RATE_LIMIT_USER_ABUSE':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse;
        case 'FEATURE_DISABLED_ON_SITE':
            return (0, $7Zbm6.NLPSearchErrorState).AIDisabled;
        default:
            (0, $4Zqgi.logger).error({
                error: error,
                functionName: 'mapErrorToSain: NetworkError',
                traceId: traceId
            });
            return (0, $7Zbm6.NLPSearchErrorState).NetworkError;
    }
};
const $087142bc218bc052$var$identityUserCloudARIPrefix = 'ari:cloud:identity::user/';
const $087142bc218bc052$export$b4465cb8e5734ca9 = (message, requestId)=>{
    // Handle cases where message is directly in root or nested under message.message
    const messageContent = message.message;
    return {
        nlpResult: messageContent.content,
        uniqueSources: message.sources ? message.sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: messageContent.message_metadata?.disclaimer ?? null,
        errorState: null,
        format: $087142bc218bc052$var$mapMimeTypeToFormat(messageContent.content_mime_type),
        extraAPIAnalyticsAttributes: {
            message_id: messageContent.id,
            conversational_channel_id: messageContent.conversation_channel_id,
            experience_id: messageContent.experience_id,
            user_id: messageContent.user_ari?.replace($087142bc218bc052$var$identityUserCloudARIPrefix, '') ?? null,
            userQuery: message.human_message?.content ?? null,
            requestId: (0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? requestId ?? null : messageContent.message_metadata?.request_id ?? null,
            answerGenerationModel: message.usage_data ?? null,
            sources: message.sources,
            cacheInfo: messageContent.message_metadata?.global_cache_info ?? null,
            pluginInvocations: messageContent.plugin_invocations,
            rawJson: message,
            ...(0, $dh538.fg)('kd_sain_online_debugger') && {
                minion_outputs: message.message?.minion_outputs,
                traceId: requestId ?? null
            }
        }
    };
};
const $087142bc218bc052$export$ed070f749797478 = (response, traceId)=>{
    if ((0, $2NVuz.isStreamError)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: {
            errorState: $087142bc218bc052$var$mapErrorTo(response, traceId),
            errorCode: response.message.status_code,
            disclaimer: null,
            format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
            uniqueSources: []
        }
    };
    if ((0, $2NVuz.isStreamGenerationType)(response) && (0, $dh538.fg)('kd_dynamic_layout_in_sain')) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType,
        message: {
            answer_generation_type: response.message.answer_generation_type
        }
    };
    if ((0, $2NVuz.isStreamTrace)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).Trace,
        message: response.message.content
    };
    if ((0, $2NVuz.isStreamAnswerPart)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart,
        message: {
            nlpResult: response.message.content
        }
    };
    if ((0, $2NVuz.isStreamSAINResponse)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: $087142bc218bc052$export$b4465cb8e5734ca9(response.message, traceId)
    };
    if ((0, $2NVuz.isStreamFollowUp)(response)) return {
        type: 'follow-up',
        queries: response.message.follow_up_queries ?? []
    };
    if ((0, $2NVuz.isStreamErrorStateQuerySuggestions)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions,
        suggested_queries: response.message.suggested_queries ?? []
    };
    if ((0, $dh538.fg)('kd_dynamic_layout_in_sain')) {
        if ((0, $2NVuz.isStreamDynamicLayoutSubAgent)(response)) return {
            type: (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage,
            message: response.message
        };
    }
    return {
        // Don't currently handle other types, such as PLUGIN_INVOCATION
        type: 'other'
    };
};
const $087142bc218bc052$export$b4d3daa122c7e257 = (message)=>{
    return {
        nlpResult: message.content,
        uniqueSources: message.sources ? message.sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: null,
        errorState: null,
        format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
        extraAPIAnalyticsAttributes: {
            userQuery: message.human_message?.content ?? null,
            answerGenerationModel: message.usage_data ?? null,
            sources: message.sources,
            rawJson: message
        }
    };
};
const $087142bc218bc052$export$fb9e9bea38ae660f = (response, traceId)=>{
    if ((0, $2NVuz.isStreamError)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: {
            errorState: $087142bc218bc052$var$mapErrorTo(response, traceId),
            errorCode: response.message.status_code,
            disclaimer: null,
            format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
            uniqueSources: []
        }
    };
    if ((0, $2NVuz.isStreamTrace)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).Trace,
        message: response.message.content
    };
    if ((0, $2NVuz.isStreamAnswerPart)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart,
        message: {
            nlpResult: response.message.content
        }
    };
    if ((0, $2NVuz.isStreamDefinitionResponse)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: $087142bc218bc052$export$b4d3daa122c7e257(response.message)
    };
    if ((0, $2NVuz.isStreamFollowUp)(response)) return {
        type: 'follow-up',
        queries: response.message.follow_up_queries ?? []
    };
    return {
        // Don't currently handle other types, such as PLUGIN_INVOCATION
        type: 'other'
    };
};
module.exports["mapStreamSAINResponse"] = $087142bc218bc052$export$ed070f749797478;
module.exports["mapStreamDefinitionResponse"] = $087142bc218bc052$export$fb9e9bea38ae660f;

});

parcelRegister("xhg8G", function(module, exports) {

var $cqFuK = parcelRequire("cqFuK");

const $d691b863678f8843$export$1b6ec2a437dbf65e = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiCuratedDefinitionFetch',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
const $d691b863678f8843$export$b3c6d7a1ecb4efe1 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiPrecomputedDefinitionFetch',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
const $d691b863678f8843$export$ef8b7cdd9a33efb4 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiCuratedDefinitionUpdate',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
const $d691b863678f8843$export$48200d71a3e25afe = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiDefinitionToggle',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
module.exports["fetchCuratedDefinitionErrorPayload"] = $d691b863678f8843$export$1b6ec2a437dbf65e;
module.exports["fetchPrecomputedDefinitionErrorPayload"] = $d691b863678f8843$export$b3c6d7a1ecb4efe1;
module.exports["updateDefinitionErrorPayload"] = $d691b863678f8843$export$ef8b7cdd9a33efb4;
module.exports["toggleDefinitionErrorPayload"] = $d691b863678f8843$export$48200d71a3e25afe;

});

parcelRegister("9nZle", function(module, exports) {
// query to check whether curated definition exists
const $797cf255205c2458$export$9051e5c888508a3d = 'CuratedDefinitionQuery';
const $797cf255205c2458$export$1886f34f107a0451 = `
query ${$797cf255205c2458$export$9051e5c888508a3d}(
		$workspaceId: String!
		$keyPhrase: String!
		$confluenceScopeId: KnowledgeDiscoveryDefinitionScopeIdConfluence
		$jiraScopeId: KnowledgeDiscoveryDefinitionScopeIdJira
	) {
		knowledgeDiscovery {
			definition(
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				confluenceScopeId: $confluenceScopeId
				jiraScopeId: $jiraScopeId
			) @optIn(to: "KnowledgeDiscovery Get definition") {
				__typename
				... on KnowledgeDiscoveryDefinition {
					definition
					accountId
					createdAt
					editor {
						... on User {
							name
							accountId
						}
					}
					referenceUrl
					confluenceEntity {
						... on ConfluencePage {
							id
							type
							title
							space {
								name
							}
						}
						... on ConfluenceBlogPost {
							id
							type
							title
							space {
								name
							}
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
module.exports["CURATED_DEFINITION_OPERATION_NAME"] = $797cf255205c2458$export$9051e5c888508a3d;
module.exports["CuratedDefinitionQuery"] = $797cf255205c2458$export$1886f34f107a0451;

});

parcelRegister("4WiNS", function(module, exports) {
const $205ce4d60dc88166$export$73cd67d787c37f2e = `
query PrecomputedDefinitionQuery(
		$workspaceId: String!
		$keyPhrase: String!
        $contentId: String!
	) {
		knowledgeDiscovery {
			autoDefinition(
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				contentId: $contentId
			) @optIn(to: "KnowledgeDiscovery Get auto definition") {
				__typename
				... on KnowledgeDiscoveryAutoDefinition {
					definition
                    createdAt
					confluenceEntity {
						... on ConfluencePage {
							id
							type
							title
							space {
								name
							}
                            links {
                                base
                                webUi
                            }
						}
						... on ConfluenceBlogPost {
							id
							type
							title
							space {
								name
							}
                            links {
                                base
                                webUi
                            }
						}
					}
				}
				... on QueryError {
					message
                    extensions {
                        statusCode
                        errorType
                    }
				}
			}
		}
	}
`;
module.exports["PrecomputedDefinitionQuery"] = $205ce4d60dc88166$export$73cd67d787c37f2e;

});

parcelRegister("3qbRZ", function(module, exports) {

var $7Zbm6 = parcelRequire("7Zbm6");

const $9a638390fddaeddf$export$faaccabd846a199 = (definition)=>{
    const definitionReference = definition.confluenceEntity;
    return {
        nlpResult: definition.definition,
        uniqueSources: definitionReference ? [
            {
                id: definitionReference?.id || '',
                title: definitionReference?.title || '',
                url: 'referenceUrl' in definition ? definition.referenceUrl || '' : 'links' in definitionReference && definitionReference.links.base && definitionReference.links.webUi ? `${definitionReference.links.base}${definitionReference.links.webUi}` : '',
                type: definitionReference?.type || '',
                // Currently curated and precomputed definitions sources can only be Confluence
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: definitionReference?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: 'editor' in definition ? {
            name: definition.editor?.name || '',
            id: definition.editor?.accountId || ''
        } : undefined,
        disclaimer: null,
        errorState: null,
        format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
        customDefinitionType: 'editor' in definition ? (0, $7Zbm6.NLPSearchCustomDefinitionType).CURATED : (0, $7Zbm6.NLPSearchCustomDefinitionType).PRECOMPUTED
    };
};
module.exports["mapCustomDefinitionToNLPSearchType"] = $9a638390fddaeddf$export$faaccabd846a199;

});

parcelRegister("kNfRw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aFuYc = parcelRequire("aFuYc");

const $88a1eed9115fe27e$var$existingHighlightedTextMap = new Map();
const $88a1eed9115fe27e$export$f9a15102b225398f = ({ children: children, match: match, marks: marks, startPos: startPos, definitionConfig: definitionConfig, sourceConfig: sourceConfig, keyPhrases: keyPhrases })=>{
    const contentARI = sourceConfig.contentARI;
    if (!$88a1eed9115fe27e$var$existingHighlightedTextMap.has(`${contentARI}-${match}`)) $88a1eed9115fe27e$var$existingHighlightedTextMap.set(`${contentARI}-${match}`, startPos);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            $88a1eed9115fe27e$var$existingHighlightedTextMap.delete(`${contentARI}-${match}`);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // no comments or links should be highlighted
    if (!(marks.has('annotation') || marks.has('link'))) {
        const nodeMatch = keyPhrases.find((node)=>node.keyPhrase === match);
        // only highlight first occurrence of the word
        if (!!nodeMatch && $88a1eed9115fe27e$var$existingHighlightedTextMap.get(`${contentARI}-${match}`) === startPos) return /*#__PURE__*/ (0, $l998X.jsx)((0, $aFuYc.DefinitionTextHighlighter), {
            keyPhraseCategory: nodeMatch.category,
            definitionConfig: definitionConfig,
            sourceConfig: sourceConfig,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["RendererDefinitionTextHighlighter"] = $88a1eed9115fe27e$export$f9a15102b225398f;

});

parcelRegister("aFuYc", function(module, exports) {
/* definition-text-highlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $dQl1W = parcelRequire("dQl1W");


var $cVtio = parcelRequire("cVtio");


var $7DCm4 = parcelRequire("7DCm4");


var $jWDKZ = parcelRequire("jWDKZ");


var $9pwVP = parcelRequire("9pwVP");


var $7wVkn = parcelRequire("7wVkn");

const $adc6ea8a600cb787$var$definitionWrapperStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $adc6ea8a600cb787$var$DefinitionHighlighter = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showHighlight: showHighlight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_11qfq0e": (0, $7sObp.default)(__cmplp.showHighlight ? 'solid' : 'none')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_5pioz8co _189e1dm9 _1il9buyh _19lc184f _d0altlke",
            __cmplp.className
        ])
    });
});
const $adc6ea8a600cb787$export$5f4d22ccfacd381d = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, definitionConfig: definitionConfig, keyPhraseCategory: keyPhraseCategory, sourceConfig: sourceConfig })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const definitionSessionId = (0, $42omo.useRef)((0, $dQl1W.v4)()).current; // controls whether to show underline highlight
    const [showHighlight, setShowHighlight] = (0, $42omo.useState)(true);
    const [definitionQuery, setDefinitionQuery] = (0, $42omo.useState)('');
    const [triggerPosition, setTriggerPosition] = (0, $42omo.useState)(undefined); // const [additionalContext, setAdditionalContext] = useState('');
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const onDefinitionSingleClick = (0, $42omo.useCallback)(async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const eventTarget = e.target;
        if (!eventTarget || !(eventTarget instanceof Element)) return;
        await (0, $7DCm4.aiDefinitionsLoadUFOExperience).start();
        setShowHighlight(false);
        fireAnalyticsEvent((0, $9pwVP.onClickAutoDefinitionHighlights)({
            contentId: sourceConfig.contentId,
            sessionId: definitionSessionId,
            keyPhraseCategory: keyPhraseCategory
        })); // const selectedContext = eventTarget.parentElement;
        // const additionalContext = selectedContext
        // 	? selectedContext.textContent || selectedContext.innerText
        // 	: '';
        const rect = eventTarget.getBoundingClientRect(); // we only need to pass in height to popup; others are needed for manual define
        const acronymRect = {
            top: 0,
            left: 0,
            width: rect.width,
            height: rect.height
        };
        setDefinitionQuery(eventTarget.textContent || '');
        setTriggerPosition(acronymRect); // setAdditionalContext(additionalContext);
    }, [
        definitionSessionId,
        fireAnalyticsEvent,
        keyPhraseCategory,
        sourceConfig.contentId
    ]);
    const onDefinitionClick = (0, $jWDKZ.useTextHighlighterClickNative)({
        singleClickCallback: onDefinitionSingleClick,
        doubleClickCallback: ()=>{} // do nothing, actions menu takes over
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($adc6ea8a600cb787$var$DefinitionHighlighter, {
                showHighlight: showHighlight,
                onClick: onDefinitionClick,
                "data-testid": "definition-highlighter",
                children: children
            }),
            triggerPosition ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7wVkn.DefinitionPopup), {
                onClose: ()=>{
                    setTriggerPosition(undefined);
                    setShowHighlight(true);
                },
                triggerPosition: triggerPosition,
                queryConfig: {
                    query: definitionQuery,
                    additionalQueryContext: ''
                },
                sessionConfig: {
                    sessionId: definitionSessionId
                },
                sourceConfig: sourceConfig,
                definitionConfig: definitionConfig,
                definitionLoadingConfig: {
                    width: triggerPosition.width
                },
                onLoad: ()=>setShowHighlight(true)
            }) : null
        ]
    });
});
module.exports["DefinitionTextHighlighter"] = $adc6ea8a600cb787$export$5f4d22ccfacd381d;

});

parcelRegister("cVtio", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $f7lNm = parcelRequire("f7lNm");

const $ca77e5059fb214ed$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $f7lNm.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return [
        fireAnalyticsEvent
    ];
};
module.exports["useAnalytics"] = $ca77e5059fb214ed$export$e955abb82869dc84;

});

parcelRegister("7DCm4", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $399439794f928dc1$var$DEFINITIONS_COMPONENT = 'search-ai-definitions';
const $399439794f928dc1$export$5b2a28beea8d66c3 = new (0, $5aVN7.UFOExperience)(`${$399439794f928dc1$var$DEFINITIONS_COMPONENT}-load`, {
    type: (0, $9NDUe.ExperienceTypes).Experience,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $399439794f928dc1$var$DEFINITIONS_COMPONENT
    }
});
module.exports["aiDefinitionsLoadUFOExperience"] = $399439794f928dc1$export$5b2a28beea8d66c3;

});

parcelRegister("jWDKZ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $4dd7b9fe81a55e61$export$ab78b8e7dad428f8 = ({ singleClickCallback: singleClickCallback, doubleClickCallback: doubleClickCallback, delay: delay = 250 })=>{
    const [state, setState] = (0, $42omo.useState)({
        e: null
    });
    (0, $42omo.useEffect)(()=>{
        if (!Boolean(state.e)) return;
        const timer = setTimeout(()=>{
            // single click
            if (state.e?.detail === 1) singleClickCallback(state.e);
            else if (state.e?.detail && state.e.detail > 1) doubleClickCallback(state.e);
            setState({
                e: null
            });
        }, delay);
        return ()=>clearTimeout(timer);
    }, [
        state,
        singleClickCallback,
        doubleClickCallback,
        delay
    ]);
    return (e)=>{
        setState({
            e: e
        });
    };
};
const $4dd7b9fe81a55e61$export$f93f1774a43b3eae = ({ singleClickCallback: singleClickCallback, doubleClickCallback: doubleClickCallback, delay: delay = 250 })=>{
    const [state, setState] = (0, $42omo.useState)({
        click: 0,
        e: null
    });
    (0, $42omo.useEffect)(()=>{
        if (!Boolean(state.e)) return;
        const timer = setTimeout(()=>{
            // simple click
            if (state.click === 1) singleClickCallback(state.e);
            setState({
                e: null,
                click: 0
            });
        }, delay);
        // the duration between this click and the previous one
        // is less than the value of delay = double-click
        if (state.click === 2) doubleClickCallback(state.e);
        return ()=>clearTimeout(timer);
    }, [
        state,
        singleClickCallback,
        doubleClickCallback,
        delay
    ]);
    return (e)=>{
        setState({
            click: state.click + 1,
            e: e
        });
    };
};
module.exports["useTextHighlighterClickNative"] = $4dd7b9fe81a55e61$export$ab78b8e7dad428f8;
module.exports["useTextHighlighterClick"] = $4dd7b9fe81a55e61$export$f93f1774a43b3eae;

});

parcelRegister("7wVkn", function(module, exports) {
/* definition-popup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $lGgRw = parcelRequire("lGgRw");

const $7a4b02046260f338$var$popupContainerStyles = null;
const $7a4b02046260f338$var$CustomPopupContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1pbyowjs"
        ]),
        children: children
    });
});
const $7a4b02046260f338$var$definitionPopupTriggerStylesStatic = null;

const $7a4b02046260f338$var$LazyDefinitionPopupContent = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dysaL")).then((module)=>({
            default: module.DefinitionPopupContent
        })));
function $7a4b02046260f338$export$576a6d4c65a0c923({ onClose: onClose, triggerPosition: triggerPosition, onLoad: onLoad, ...definitionPopupContentProps }) {
    const definitionPopupTriggerStylesDynamic = {
        height: `${triggerPosition.height}px`,
        left: `${triggerPosition.left}px`,
        top: `${triggerPosition.top}px`,
        width: `${triggerPosition.width}px`
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        content: ({ update: update })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)($7a4b02046260f338$var$LazyDefinitionPopupContent, {
                    ...definitionPopupContentProps,
                    onClose: onClose,
                    onLoad: ()=>{
                        onLoad?.();
                        update();
                    }
                })
            }),
        onClose: onClose,
        placement: "bottom-start",
        popupComponent: $7a4b02046260f338$var$CustomPopupContainer,
        testId: "definition-popup",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
                ...triggerProps,
                style: definitionPopupTriggerStylesDynamic,
                "data-testid": "definition-popup-trigger",
                className: (0, $gMc0m.default)([
                    "_tzy4idpf _kqswstnw _lcxvglyw _bfhk1j28 _1ltvidpf _94n5idpf"
                ])
            }),
        isOpen: true
    });
}
module.exports["DefinitionPopup"] = $7a4b02046260f338$export$576a6d4c65a0c923;

});

parcelRegister("dysaL", function(module, exports) {

let $9de44dd1ff12e1f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9de44dd1ff12e1f2$var$load("8Gekp"),
    $9de44dd1ff12e1f2$var$load("2YffH"),
    $9de44dd1ff12e1f2$var$load("1FvvC"),
    $9de44dd1ff12e1f2$var$load("6mHrv"),
    $9de44dd1ff12e1f2$var$load("9zkjw"),
    $9de44dd1ff12e1f2$var$load("88Shx"),
    $9de44dd1ff12e1f2$var$load("1QdXB"),
    $9de44dd1ff12e1f2$var$load("tKhaz"),
    $9de44dd1ff12e1f2$var$load("8hSeL"),
    $9de44dd1ff12e1f2$var$load("7RXky"),
    $9de44dd1ff12e1f2$var$load("lVO3w"),
    $9de44dd1ff12e1f2$var$load("hyzoX"),
    $9de44dd1ff12e1f2$var$load("h9Ed7"),
    $9de44dd1ff12e1f2$var$load("9A0ig"),
    $9de44dd1ff12e1f2$var$load("dVAT5"),
    $9de44dd1ff12e1f2$var$load("fIFgO"),
    $9de44dd1ff12e1f2$var$load("86sUJ"),
    $9de44dd1ff12e1f2$var$load("h2QhJ"),
    $9de44dd1ff12e1f2$var$load("8VzWv"),
    $9de44dd1ff12e1f2$var$load("8YSo7"),
    $9de44dd1ff12e1f2$var$load("gryT8"),
    $9de44dd1ff12e1f2$var$load("9XYQ9"),
    $9de44dd1ff12e1f2$var$load("kiGNy"),
    $9de44dd1ff12e1f2$var$load("St9Nk"),
    $9de44dd1ff12e1f2$var$load("8JZKd"),
    $9de44dd1ff12e1f2$var$load("7jH9e"),
    $9de44dd1ff12e1f2$var$load("6FuHS"),
    $9de44dd1ff12e1f2$var$load("eyaRC"),
    $9de44dd1ff12e1f2$var$load("drv5I"),
    $9de44dd1ff12e1f2$var$load("g9CVe"),
    $9de44dd1ff12e1f2$var$load("5EQhG"),
    $9de44dd1ff12e1f2$var$load("36QeB"),
    $9de44dd1ff12e1f2$var$load("8fXIr"),
    $9de44dd1ff12e1f2$var$load("dVkhd"),
    $9de44dd1ff12e1f2$var$load("hv4mn"),
    $9de44dd1ff12e1f2$var$load("7jSfd"),
    $9de44dd1ff12e1f2$var$load("4HZlX"),
    $9de44dd1ff12e1f2$var$load("kDqHr"),
    $9de44dd1ff12e1f2$var$load("6wr18"),
    $9de44dd1ff12e1f2$var$load("kjZZD"),
    $9de44dd1ff12e1f2$var$load("ht5OT"),
    $9de44dd1ff12e1f2$var$load("sj9Xz"),
    $9de44dd1ff12e1f2$var$load("eHDb1"),
    $9de44dd1ff12e1f2$var$load("2zUEf"),
    $9de44dd1ff12e1f2$var$load("Wowvf"),
    $9de44dd1ff12e1f2$var$load("37ldp"),
    $9de44dd1ff12e1f2$var$load("dTsOE"),
    $9de44dd1ff12e1f2$var$load("hhss7"),
    $9de44dd1ff12e1f2$var$load("8FbYE"),
    $9de44dd1ff12e1f2$var$load("dUevD"),
    $9de44dd1ff12e1f2$var$load("ffEVr"),
    $9de44dd1ff12e1f2$var$load("f1NVy"),
    $9de44dd1ff12e1f2$var$load("7e13v"),
    $9de44dd1ff12e1f2$var$load("aqr2D"),
    $9de44dd1ff12e1f2$var$load("7EorR"),
    $9de44dd1ff12e1f2$var$load("77ceh")
]).then(()=>parcelRequire('bA47i'));

});

parcelRegister("bzqa9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $dPJCf = parcelRequire("dPJCf");


var $4qzKl = parcelRequire("4qzKl");


var $icKZN = parcelRequire("icKZN");

const $abb6860b27595ef6$export$8ce912bc34d0dbea = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t0;
    if ($[0] !== push) {
        t0 = (event, url)=>{
            if (!event?.isDefaultPrevented()) event?.preventDefault();
            if ((0, $icKZN.isClickEventToOpenNewTab)(event)) window.open(url, "_blank");
            else push(url);
        };
        $[0] = push;
        $[1] = t0;
    } else t0 = $[1];
    const handleClick = t0;
    let t1;
    if ($[2] !== handleClick) {
        t1 = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? {
            mention: {
                onClick: async (userId, _, event_0)=>{
                    event_0?.preventDefault();
                    event_0?.stopPropagation();
                    const url_0 = await (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId);
                    handleClick(event_0, url_0);
                }
            },
            link: {
                onClick (e, url_1) {
                    handleClick(e, url_1);
                }
            },
            smartCard: {
                onClick (e_0, url_2) {
                    handleClick(e_0, url_2);
                }
            }
        } : undefined;
        $[2] = handleClick;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const handleClick = (0, $42omo.useCallback)((event, url)=>{
        if (!event?.isDefaultPrevented()) event?.preventDefault();
        if ((0, $icKZN.isClickEventToOpenNewTab)(event)) window.open(url, '_blank');
        else push(url);
    }, [
        push
    ]);
    return (0, $42omo.useMemo)(()=>(0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? {
            mention: {
                onClick: async (userId, _, event_0)=>{
                    event_0?.preventDefault();
                    event_0?.stopPropagation();
                    // For Confirmed with PM, we apply the same approach as "mobile-web" to open `/people` link directly.
                    const url_0 = await (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId);
                    handleClick(event_0, url_0);
                }
            },
            link: {
                onClick (e, url_1) {
                    handleClick(e, url_1);
                }
            },
            smartCard: {
                onClick (e_0, url_2) {
                    handleClick(e_0, url_2);
                }
            }
        } : undefined, [
        handleClick
    ]);
};
module.exports["useEventHandlers"] = $abb6860b27595ef6$export$8ce912bc34d0dbea;

});

parcelRegister("h0UOA", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $6S5EB = parcelRequire("6S5EB");


var $dHSeC = parcelRequire("dHSeC");


var $jibmA = parcelRequire("jibmA");

const $f3a2ccfb73948f5b$export$68bee16d64211457 = (0, $2XqLN.default)((routesContext)=>routesContext && typeof routesContext.push === 'function' ? {
        link: {
            onClick (e, url) {
                const isInlineComment = e.target instanceof Element && e.target.matches('[data-mark-annotation-type="inlineComment"]');
                if (isInlineComment) return;
                const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
                if ((0, $jibmA.isExternalLink)(url)) {
                    e.preventDefault();
                    window.open(url, '_blank', 'noopener, noreferrer');
                } else if (details?.href && details.href === url) {
                    e.preventDefault();
                    routesContext.push(details.href, (0, $6S5EB.isExternalShareRequest)());
                }
            }
        }
    } : undefined);
module.exports["createLinkEventHandler"] = $f3a2ccfb73948f5b$export$68bee16d64211457;

});

parcelRegister("kdOv6", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $vLw8x = parcelRequire("vLw8x");

const $5095179f89355d70$export$f996105bf70a5c25 = (0, $2XqLN.default)((routesContext)=>routesContext && typeof routesContext.push === 'function' ? {
        smartCard: {
            onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
        }
    } : undefined);
module.exports["createSmartCardEventHandler"] = $5095179f89355d70$export$f996105bf70a5c25;

});

parcelRegister("chaNr", function(module, exports) {
const $edb96fd8df3233f3$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $edb96fd8df3233f3$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $edb96fd8df3233f3$export$718381a72a965ef3 = [
    'jira',
    'attachments',
    'bgcolor',
    'blog-posts',
    'center',
    'chart',
    'column',
    'contentbylabel',
    'content-by-user',
    'rw-ui-layout-macro',
    'content-report-table',
    'profile-picture',
    'contributors-summary',
    'copyright',
    'excerpt',
    'excerpt-include',
    'fancy-bullets',
    'favpages',
    'gallery',
    'global-reports',
    'map',
    'highlight',
    'listlabels',
    'mathblock',
    'mathinline',
    'loremipsum',
    'navmap',
    'network',
    'index',
    'details',
    'detailssummary',
    'panel',
    'popular-labels',
    'privacy-mark',
    'privacy-policy',
    'recently-updated',
    'recently-used-labels',
    'reg-tm',
    'section',
    'sm',
    'space-details',
    'strike',
    'tasks-report-macro',
    'tm',
    'rw-ui-textbox-macro',
    'userlister',
    'profile',
    'jirachart',
    'jiraroadmap',
    'gadget',
    'contributors',
    'widget'
];
module.exports["FALLBACK_REASONS"] = $edb96fd8df3233f3$export$a4903313a3329d59;
module.exports["supportedMacroExtensions"] = $edb96fd8df3233f3$export$718381a72a965ef3;

});

parcelRegister("1C1zB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5kjCz = parcelRequire("5kjCz");


var $8pcS0 = parcelRequire("8pcS0");


var $fuLIO = parcelRequire("fuLIO");


var $9wGTI = parcelRequire("9wGTI");


var $kycWk = parcelRequire("kycWk");

var $F4YLX = parcelRequire("F4YLX");


var $chaNr = parcelRequire("chaNr");


var $lXP6p = parcelRequire("lXP6p");


var $ajkp0 = parcelRequire("ajkp0");

const $4ff570b9d2ed6508$var$context = {
    insertCss: (styles)=>styles._insertCss()
};
const $4ff570b9d2ed6508$var$getRedactionExtensionHandler = (contentId)=>(extension)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $F4YLX.TourableRedactionExtensionLoader), {
            contentId: contentId,
            extensionNode: extension,
            isCommentContext: true
        });
    };
const $4ff570b9d2ed6508$export$fe33197d44e10fcf = (setLegacyRendererFlag, contentId, spaceKey, mode)=>{
    const macroHandler = {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE]: $4ff570b9d2ed6508$var$getMacroExtensionHandler({
            setLegacyRendererFlag: setLegacyRendererFlag,
            contentId: contentId,
            spaceKey: spaceKey,
            mode: mode
        })
    };
    const migrationHandler = {
        [(0, $8pcS0.EXTENSION_TYPE).MIGRATION]: $4ff570b9d2ed6508$var$getMigrationExtensionHandler(setLegacyRendererFlag, contentId)
    };
    const redactionHandler = (0, $9wGTI.fg)('confluence_dlp_comment_redaction') ? {
        [(0, $kycWk.REDACTION_EXTENSION_TYPE)]: $4ff570b9d2ed6508$var$getRedactionExtensionHandler(contentId)
    } : {};
    return {
        ...macroHandler,
        ...migrationHandler,
        ...redactionHandler
    };
};
const $4ff570b9d2ed6508$var$getMacroExtensionHandler = ({ setLegacyRendererFlag: setLegacyRendererFlag, contentId: contentId, spaceKey: spaceKey, mode: mode })=>(extension)=>{
        const { extensionKey: extensionKey } = extension;
        if (setLegacyRendererFlag) setLegacyRendererFlag(extensionKey);
        if ((0, $chaNr.supportedMacroExtensions).includes(extensionKey)) {
            const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
            const macroDefaultProps = {
                node: extension,
                contentId: contentId || '',
                mode: mode || (0, $5kjCz.RENDERER),
                spaceKey: spaceKey || '',
                context: $4ff570b9d2ed6508$var$context,
                extensionKey: extensionKey,
                attributes: attributes
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ajkp0.UnsupportedFallbackComponent), null);
    };
const $4ff570b9d2ed6508$var$getMigrationExtensionHandler = (setLegacyRendererFlag, contentId)=>(extension)=>{
        const { extensionKey: extensionKey } = extension;
        if (extensionKey === (0, $8pcS0.MIGRATION_EXTENSION_KEYS).INVALID) {
            if (setLegacyRendererFlag) setLegacyRendererFlag();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ajkp0.UnsupportedFallbackComponent), null);
        }
        if (extensionKey === (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE || extensionKey === (0, $8pcS0.EXTENSION_KEY).INLINE_MEDIA_IMAGE) {
            if (setLegacyRendererFlag) setLegacyRendererFlag(extensionKey);
            return contentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lXP6p.FallbackComponent), {
                contentId: contentId
            }) : null;
        }
        return null;
    };
module.exports["getExtensionHandlers"] = $4ff570b9d2ed6508$export$fe33197d44e10fcf;

});

parcelRegister("lXP6p", function(module, exports) {
/* FallbackComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $8tdj3 = parcelRequire("8tdj3");


var $6xdDU = parcelRequire("6xdDU");


var $9wGTI = parcelRequire("9wGTI");


var $cutWg = parcelRequire("cutWg");

const $0d195c36a2d7770a$var$StyledContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt45uws _1e0c1txw _10rcu2gc",
            __cmplp.className
        ])
    });
});
const $0d195c36a2d7770a$var$CommentSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $0d195c36a2d7770a$var$SkeletonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41g6e _1e0c1txw _99ztu2gc",
            __cmplp.className
        ])
    });
});
const $0d195c36a2d7770a$var$CommentSkeletonLine = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $7sObp.default)(__cmplp.width, "%")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _bfhkizff _4t3i1crf _otyru2gc _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $0d195c36a2d7770a$export$23216ae99c93d0b = ({ contentId: contentId })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { data: data, loading: loading } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query FallbackComponentLegacyContentQuery($contentId:ID!){content(id:$contentId){nodes{id body{view{value webresource{keys}}}history{createdBy{...on KnownUser{accountId}profilePicture{path}displayName}}type}}}`, {
        variables: {
            contentId: contentId ?? ''
        }
    });
    const buildUserObject = (data)=>{
        const userId = data?.content?.nodes[0].history?.createdBy?.accountId;
        const avatarUrl = data?.content?.nodes[0].history?.createdBy?.profilePicture?.path;
        const displayName = data?.content?.nodes[0].history?.createdBy?.displayName;
        return {
            userId: userId,
            avatarUrl: avatarUrl,
            displayName: displayName
        };
    };
    const handleCloseModal = (0, $42omo.useCallback)(()=>{
        setIsOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    const user = buildUserObject(data);
    const legacyContent = data?.content?.nodes?.[0]?.body?.view?.value ?? '';
    const webResourceKeys = data?.content?.nodes?.[0]?.body?.view?.webresource?.keys ?? [];
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0d195c36a2d7770a$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        spacing: "spacious",
        label: "legacy-modal-shortcut"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0d195c36a2d7770a$var$CommentSkeleton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0d195c36a2d7770a$var$CommentSkeletonLine, {
        width: 100
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0d195c36a2d7770a$var$CommentSkeletonLine, {
        width: 100
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0d195c36a2d7770a$var$CommentSkeletonLine, {
        width: 75
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0d195c36a2d7770a$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        spacing: "spacious",
        label: "legacy-modal-shortcut"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, (0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__comments') ? // eslint-disable-next-line @atlassian/a11y/anchor-is-valid
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: "#",
        onClick: handleCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "comment-extension-handlers.fallback.action",
        defaultMessage: "Click to view content"
    })) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor, @atlassian/a11y/anchor-is-valid
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: "#",
        onClick: handleCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "comment-extension-handlers.fallback.action",
        defaultMessage: "Click to view content"
    })), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "comment-extension-handlers.fallback.reason",
        defaultMessage: "that can\u2019t display inline as it was created in a legacy version of Confluence."
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cutWg.LegacyContentModal), {
        onClose: setIsOpen,
        content: legacyContent,
        webResources: webResourceKeys,
        user: user
    })));
};
module.exports["FallbackComponent"] = $0d195c36a2d7770a$export$23216ae99c93d0b;

});

parcelRegister("cutWg", function(module, exports) {
/* LegacyContentModal.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $eEA8O = parcelRequire("eEA8O");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");


var $brpfO = parcelRequire("brpfO");


var $jJK3p = parcelRequire("jJK3p");


var $fs6LW = parcelRequire("fs6LW");


var $cpjd2 = parcelRequire("cpjd2");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $920076e2f988014c$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _ca0qpxbi",
            __cmplp.className
        ])
    });
});
const $920076e2f988014c$var$ContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _19bvu2gc _16tx1b66",
            __cmplp.className
        ])
    });
});
const $920076e2f988014c$var$closeButton = (0, $cgtv4.defineMessage)({
    id: "comment-extension-handlers.legacy-content-modal.close-button.non-final-ai",
    defaultMessage: "Close"
});
const $920076e2f988014c$export$8d93ebb7c75cb5b4 = ({ onClose: onClose, content: content, user: user, webResources: webResources })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [containerRef, setContainerRef] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        (0, $cpjd2.requireLegacyWRM)(webResources, ()=>{}, ()=>{});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (containerRef) (0, $brpfO.evalLegacyConnectInlineScripts)(containerRef);
    }, [
        containerRef
    ]);
    const onRefSet = (ref)=>{
        setContainerRef(ref);
    };
    const handleClose = ()=>{
        onClose(false);
    };
    const handleImageClick = (event)=>{
        // clicking on an image shows a full screen modal
        // of the image in the background
        if (event.target instanceof HTMLImageElement) onClose(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        onClose: handleClose,
        width: "large",
        testId: "modal-dialog-legacy-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($920076e2f988014c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: user.userId,
        src: user.avatarUrl,
        name: user.displayName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($920076e2f988014c$var$ContentContainer, {
        onClick: handleImageClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
        userId: user.userId,
        fullName: user.displayName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: onRefSet,
        dangerouslySetInnerHTML: {
            __html: content
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        autoFocus: true,
        appearance: "primary",
        onClick: handleClose
    }, formatMessage($920076e2f988014c$var$closeButton))));
};
module.exports["LegacyContentModal"] = $920076e2f988014c$export$8d93ebb7c75cb5b4;

});

parcelRegister("ajkp0", function(module, exports) {
/* UnsupportedFallbackComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");


var $a3fRD = parcelRequire("a3fRD");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ff2521e469949e41$var$StyledContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt45uws _1e0c1txw _10rcu2gc",
            __cmplp.className
        ])
    });
});
const $ff2521e469949e41$export$563f56722e191781 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ff2521e469949e41$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        spacing: "spacious",
        label: "unsupported-legacy-error"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "comment-extension-handlers.unsupported.fallback",
        defaultMessage: "This content cannot be displayed as it was created in a legacy version of Confluence and is unsupported."
    }));
module.exports["UnsupportedFallbackComponent"] = $ff2521e469949e41$export$563f56722e191781;

});

parcelRegister("eV0v4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $78QFu = parcelRequire("78QFu");

const $2f8044ddd141ffa3$export$8f5016028a31aee0 = {
    channel: 'media',
    actionSubjects: [
        'mediaCardRender',
        'mediaUpload',
        'smartLink'
    ]
};
const $2f8044ddd141ffa3$export$def227c48fe2bf2c = {
    channel: 'editor',
    actionSubjects: [
        'renderer'
    ]
};
const $2f8044ddd141ffa3$export$e3ba538a10828e25 = ({ channelParam: channelParam, children: children })=>{
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        function updateEvent() {
            event.update((payload)=>{
                return {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                };
            });
        }
        if (channelParam.actionSubjects.includes(event.payload.actionSubject)) updateEvent();
    }, [
        channelParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        channel: channelParam.channel,
        onEvent: handleEvent
    }, children);
};
module.exports["mediaChannel"] = $2f8044ddd141ffa3$export$8f5016028a31aee0;
module.exports["editorChannel"] = $2f8044ddd141ffa3$export$def227c48fe2bf2c;
module.exports["DynamicAnalyticsListener"] = $2f8044ddd141ffa3$export$e3ba538a10828e25;

});

parcelRegister("97Szk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $chO1Z = parcelRequire("chO1Z");


var $gXn1S = parcelRequire("gXn1S");


var $ctmPb = parcelRequire("ctmPb");


var $9RVmI = parcelRequire("9RVmI");


var $9KkVf = parcelRequire("9KkVf");

const $3fda69966c9a64cd$var$i18n = (0, $cgtv4.defineMessages)({
    editDefinitionRestrictedToSpaceOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.space.option",
        defaultMessage: "In this space"
    },
    editDefinitionRestrictedToPageOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.page.option",
        defaultMessage: "On this page"
    },
    editDefinitionRestrictedToBlogpostOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.blogpost.option",
        defaultMessage: "On this blogpost"
    },
    editDefinitionRestrictedToSiteOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.site.option",
        defaultMessage: "On this site"
    }
});
function $3fda69966c9a64cd$export$ad09b24d617a41f5(contentType) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return (0, $42omo.useMemo)(()=>[
            {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToSpaceOption),
                value: (0, $9KkVf.EditedDefinitionScope).SPACE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gXn1S))), {
                    label: ""
                })
            },
            contentType === 'blogpost' ? {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToBlogpostOption),
                value: (0, $9KkVf.EditedDefinitionScope).BLOGPOST,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))), {
                    label: ""
                })
            } : {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToPageOption),
                value: (0, $9KkVf.EditedDefinitionScope).PAGE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
                    label: ""
                })
            },
            {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToSiteOption),
                value: (0, $9KkVf.EditedDefinitionScope).ORGANIZATION,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ctmPb))), {
                    label: ""
                })
            }
        ], [
        contentType,
        formatMessage
    ]);
}
module.exports["useDefinitionRestrictionOptions"] = $3fda69966c9a64cd$export$ad09b24d617a41f5;

});

parcelRegister("9KkVf", function(module, exports) {
var $3b7655b6bdb7bdb0$export$a53c998f5fa685e1 = /*#__PURE__*/ function(EditedDefinitionScope) {
    EditedDefinitionScope["SPACE"] = "SPACE";
    EditedDefinitionScope["PAGE"] = "PAGE";
    EditedDefinitionScope["BLOGPOST"] = "BLOGPOST";
    EditedDefinitionScope["ORGANIZATION"] = "ORGANIZATION";
    EditedDefinitionScope["PROJECT"] = "PROJECT";
    return EditedDefinitionScope;
}({});
module.exports["EditedDefinitionScope"] = $3b7655b6bdb7bdb0$export$a53c998f5fa685e1;

});

parcelRegister("g7Tm3", function(module, exports) {
var $f98b9dde8f8a6e61$export$f30b281f34822b59 = /*#__PURE__*/ function(CommentRendererLocation) {
    CommentRendererLocation["COMMENTS_PANEL_INLINE"] = "comments-panel-inline";
    CommentRendererLocation["COMMENTS_PANEL_OBJECT"] = "comments-panel-object";
    CommentRendererLocation["STANDALONE_INLINE"] = "standalone-inline";
    CommentRendererLocation["STANDALONE_OBJECT"] = "standalone-object";
    return CommentRendererLocation;
}({});
module.exports["CommentRendererLocation"] = $f98b9dde8f8a6e61$export$f30b281f34822b59;

});

parcelRegister("aUwPP", function(module, exports) {

var $9LRzA = parcelRequire("9LRzA");


var $5abq6 = parcelRequire("5abq6");


var $b9lC3 = parcelRequire("b9lC3");


var $87fJd = parcelRequire("87fJd");

const $8f944f557ac62b40$export$171e576bb7c729fa = ({ api: api })=>({
        name: 'indentation',
        marks () {
            return [
                {
                    name: 'indentation',
                    mark: (0, $9LRzA.indentation)
                }
            ];
        },
        actions: {
            indentParagraphOrHeading: (0, $b9lC3.getIndentCommand)(api?.analytics?.actions),
            outdentParagraphOrHeading: (0, $b9lC3.getOutdentCommand)(api?.analytics?.actions)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { tr: { selection: selection }, schema: { marks: { indentation: indentation } } } = editorState;
            const node = selection.$from.node();
            const indentationMark = node.marks.find((mark)=>mark.type === indentation);
            return {
                isIndentationAllowed: (0, $b9lC3.isIndentationAllowed)(editorState.schema, node),
                // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
                indentDisabled: (indentationMark?.attrs.level >= (0, $5abq6.MAX_INDENTATION_LEVEL)) ?? false,
                outdentDisabled: !indentationMark
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'indentationKeymap',
                    plugin: ()=>(0, $87fJd.keymapPlugin)(api?.analytics?.actions)
                }
            ];
        }
    });
module.exports["indentationPlugin"] = $8f944f557ac62b40$export$171e576bb7c729fa;

});

parcelRegister("b9lC3", function(module, exports) {

var $aU3dp = parcelRequire("aU3dp");

var $d925B = parcelRequire("d925B");


var $dhoHU = parcelRequire("dhoHU");


var $5abq6 = parcelRequire("5abq6");


var $kecXX = parcelRequire("kecXX");


var $by9bj = parcelRequire("by9bj");

const $a4290f7701cf1730$export$54db194d337db321 = (schema, node)=>{
    const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = schema;
    if ([
        paragraph,
        heading
    ].indexOf(node.type) > -1) {
        if (alignment) {
            const hasAlignment = node.marks.filter((mark)=>mark.type === alignment)[0];
            return !hasAlignment;
        }
        return true;
    }
    return false;
};
/**
 * Create new indentation command (Either indent or outdent depend of getArgsFn)
 * @param getNewIndentationAttrs Function to handle new indentation level
 */ function $a4290f7701cf1730$var$createIndentationCommand(getNewIndentationAttrs) {
    return (state, dispatch)=>{
        const { indentation: indentation } = state.schema.marks;
        return (0, $dhoHU.toggleBlockMark)(indentation, getNewIndentationAttrs, $a4290f7701cf1730$export$54db194d337db321)(state, dispatch);
    };
}
function $a4290f7701cf1730$var$createIndentationCommandWithAnalytics({ getNewIndentationAttrs: getNewIndentationAttrs, direction: direction, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI }) {
    // Create a new getAttrs function to record the changes
    const { getAttrs: getAttrs, getAndResetAttrsChanges: getAndResetAttrsChanges } = (0, $kecXX.default)(getNewIndentationAttrs, {
        direction: direction
    });
    // Use new getAttrs wrapper
    const indentationCommand = $a4290f7701cf1730$var$createIndentationCommand(getAttrs);
    // Return a new command where we change dispatch for our analytics dispatch
    return (state, dispatch)=>{
        return indentationCommand(state, (0, $by9bj.createAnalyticsDispatch)({
            getAttrsChanges: getAndResetAttrsChanges,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI,
            state: state,
            dispatch: dispatch
        }));
    };
}
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $a4290f7701cf1730$var$getIndentAttrs = (oldAttr)=>{
    if (!oldAttr) return {
        level: 1
    }; // No mark exist, create a new one with level 1
    const { level: level } = oldAttr;
    if (level >= (0, $5abq6.MAX_INDENTATION_LEVEL)) return undefined; // Max indentation level reached, do nothing.
    return {
        level: level + 1
    }; // Otherwise, increase the level by one
};
const $a4290f7701cf1730$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>$a4290f7701cf1730$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $a4290f7701cf1730$var$getIndentAttrs,
            direction: (0, $aU3dp.INDENT_DIRECTION).INDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $a4290f7701cf1730$var$getOutdentAttrs = (oldAttr)=>{
    if (!oldAttr) return undefined; // Do nothing;
    const { level: level } = oldAttr;
    if (level <= 1) return false; // Remove the mark
    return {
        level: level - 1
    }; // Decrease the level on other cases
};
const $a4290f7701cf1730$export$620b2a1f10eb3a5f = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>$a4290f7701cf1730$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $a4290f7701cf1730$var$getOutdentAttrs,
            direction: (0, $aU3dp.INDENT_DIRECTION).OUTDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
const $a4290f7701cf1730$export$33ad14ed4b6e7a8e = (state, dispatch)=>(0, $dhoHU.toggleBlockMark)(state.schema.marks.indentation, ()=>false)(state, dispatch);
module.exports["isIndentationAllowed"] = $a4290f7701cf1730$export$54db194d337db321;
module.exports["getIndentCommand"] = $a4290f7701cf1730$export$b294289254b8cdac;
module.exports["getOutdentCommand"] = $a4290f7701cf1730$export$620b2a1f10eb3a5f;

});

parcelRegister("kecXX", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d4de3432317ffe3$export$2e2bcd8739ae039);
function $2d4de3432317ffe3$export$2e2bcd8739ae039(getAttrs, options) {
    let changes = [];
    function getAttrsWithChangesRecorder(prevAttrs, node) {
        const newAttrs = getAttrs(prevAttrs, node);
        changes.push({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            node: node,
            prevAttrs: prevAttrs,
            newAttrs: newAttrs,
            options: options
        });
        return newAttrs;
    }
    return {
        getAttrs: getAttrsWithChangesRecorder,
        getAndResetAttrsChanges () {
            const oldChanges = changes;
            changes = [];
            return oldChanges;
        }
    };
}

});

parcelRegister("by9bj", function(module, exports) {

var $d925B = parcelRequire("d925B");

var $aU3dp = parcelRequire("aU3dp");

const $a44445544afb543f$var$indentTypes = {
    paragraph: (0, $aU3dp.INDENT_TYPE).PARAGRAPH,
    heading: (0, $aU3dp.INDENT_TYPE).HEADING
};
function $a44445544afb543f$export$c67aac760a384f96(prevAttrs, newAttrs) {
    if (newAttrs === undefined) return $a44445544afb543f$export$697340b93338bcbd(prevAttrs);
    else if (newAttrs === false) return 0;
    return newAttrs.level;
}
function $a44445544afb543f$export$697340b93338bcbd(prevAttrs) {
    if (prevAttrs === undefined) return 0;
    return prevAttrs.level;
}
function $a44445544afb543f$export$4f15b45384b61427({ getAttrsChanges: getAttrsChanges, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI, state: state, dispatch: dispatch }) {
    return (tr)=>{
        const currentTr = tr;
        const changes = getAttrsChanges(); // Get all attributes changes
        // Add analytics event for each change stored.
        changes.forEach(({ node: node, prevAttrs: prevAttrs, newAttrs: newAttrs, options: { direction: direction } })=>{
            const indentType = $a44445544afb543f$var$indentTypes[node.type.name];
            if (!indentType) return; // If no valid indent type continue
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod,
                    previousIndentationLevel: $a44445544afb543f$export$697340b93338bcbd(prevAttrs),
                    newIndentLevel: $a44445544afb543f$export$c67aac760a384f96(prevAttrs, newAttrs),
                    direction: direction,
                    indentType: indentType
                }
            })(currentTr);
        });
        // Dispatch analytics if exist
        if (dispatch) dispatch(tr);
    };
}
module.exports["createAnalyticsDispatch"] = $a44445544afb543f$export$4f15b45384b61427;

});

parcelRegister("87fJd", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");


var $kTbzR = parcelRequire("kTbzR");


var $dus6D = parcelRequire("dus6D");


var $8m4tT = parcelRequire("8m4tT");


var $b9lC3 = parcelRequire("b9lC3");

function $e60d68c782a1a955$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.indent)), (state, dispatch)=>{
        const { blockTaskItem: blockTaskItem, paragraph: paragraph, doc: doc } = state.schema.nodes;
        if (blockTaskItem) {
            let hasBlockTaskItem = false;
            let hasParagraphAtDocLevel = false;
            // Check if the selection contains a blockTaskItem
            state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
                if (node.type === blockTaskItem) {
                    hasBlockTaskItem = true;
                    return false; // stop iterating
                }
                if (node.type === paragraph && parent?.type === doc) hasParagraphAtDocLevel = true;
            });
            if (hasBlockTaskItem && !hasParagraphAtDocLevel) return false; // let `editor-plugin-tasks-and-decisions` handle indentation
        }
        return (0, $b9lC3.getIndentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch);
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.outdent)), (0, $b9lC3.getOutdentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.backspace)), (state, dispatch)=>{
        const { selection: selection } = state;
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        // Let `editor-plugin-tasks-and-decisions` handle indentation inside blockTaskItems
        if ((0, $kTbzR.isTextSelection)(selection) && selection.$cursor && selection.$cursor.parentOffset === 0 && !(0, $8m4tT.hasParentNodeOfType)([
            blockTaskItem
        ])(selection)) return dispatch ? (0, $b9lC3.getOutdentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch) : false;
        return false;
    }, list);
    return (0, $dus6D.keymap)(list);
}
var $e60d68c782a1a955$export$2e2bcd8739ae039 = $e60d68c782a1a955$export$e832373cff8dec22;
module.exports["keymapPlugin"] = $e60d68c782a1a955$export$e832373cff8dec22;

});

parcelRegister("1a6Dn", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $hrAmX = parcelRequire("hrAmX");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.push({
                    name: name,
                    height: height
                });
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
            else if (this.state.floatingBanners[index].height !== height) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray[index].height = height;
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.hideFloating = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index > -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.splice(index, 1);
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("8WfxO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eSLr0 = parcelRequire("eSLr0");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $dS3n9 = parcelRequire("dS3n9");

const $720c81ac24834d84$export$dc9cc84753faedac = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const atlGeneralHeightChanges = (0, $42omo.useRef)(t0);
    const [webPanelHeight, setWebPanelHeight] = (0, $42omo.useState)($720c81ac24834d84$var$_temp);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    let t2;
    if ($[1] !== contentId || $[2] !== spaceKey) {
        t2 = {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first",
            spaceKey: spaceKey,
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)(t2);
    const isATLGeneralWebPanelFixed = panels.length > 0;
    let t3;
    let t4;
    if ($[4] !== isATLGeneralWebPanelFixed) {
        t3 = ()=>{
            const listener = (e)=>{
                let newHeight;
                if ((0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
                    setWebPanelHeight(e?.detail?.height ?? 0);
                    newHeight = e?.detail?.height ?? 0;
                } else {
                    setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                    newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
                }
                if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__)) {
                    const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                    if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                    window.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__ = atlGeneralHeightChanges.current;
                }
            };
            if (isATLGeneralWebPanelFixed) document.addEventListener("atlGeneralWebPanelHeightUpdated", listener);
            return ()=>{
                if (isATLGeneralWebPanelFixed) document.removeEventListener("atlGeneralWebPanelHeightUpdated", listener);
            };
        };
        t4 = [
            isATLGeneralWebPanelFixed
        ];
        $[4] = isATLGeneralWebPanelFixed;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[7] !== isATLGeneralWebPanelFixed || $[8] !== webPanelHeight) {
        t5 = {
            isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
            atlGeneralWebPanelHeight: webPanelHeight
        };
        $[7] = isATLGeneralWebPanelFixed;
        $[8] = webPanelHeight;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ()=>{
    const atlGeneralHeightChanges = (0, $42omo.useRef)([]);
    const [webPanelHeight, setWebPanelHeight] = (0, $42omo.useState)(()=>{
        if (typeof window !== 'undefined' && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false)) {
            const initialHeight = window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'];
            return initialHeight ?? 0;
        } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
    });
    const [{ contentId: contentId, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)({
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: 'cache-first',
        spaceKey: spaceKey,
        contentId: contentId
    });
    const isATLGeneralWebPanelFixed = panels.length > 0;
    (0, $42omo.useEffect)(()=>{
        const listener = (e)=>{
            let newHeight;
            if ((0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false)) {
                setWebPanelHeight(e?.detail?.height ?? 0);
                newHeight = e?.detail?.height ?? 0;
            } else {
                setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
            }
            // Track ATL General Webpanel height changes for page initial load
            if (typeof window !== 'undefined' && Boolean(window.__SSR_RENDERED__)) {
                // Last height is the SSR rendered height or last observed height
                const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                // If the last height is not the same as the new height, track the change
                if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                window['__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__'] = atlGeneralHeightChanges.current;
            }
        };
        if (isATLGeneralWebPanelFixed) document.addEventListener('atlGeneralWebPanelHeightUpdated', listener);
        return ()=>{
            if (isATLGeneralWebPanelFixed) document.removeEventListener('atlGeneralWebPanelHeightUpdated', listener);
        };
    }, [
        isATLGeneralWebPanelFixed
    ]);
    return {
        isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
        atlGeneralWebPanelHeight: webPanelHeight
    };
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};
function $720c81ac24834d84$var$_temp() {
    if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
        const initialHeight = window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__;
        return initialHeight ?? 0;
    } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
}
module.exports["useATLGeneralWebPanelListener"] = $720c81ac24834d84$export$dc9cc84753faedac;

});

parcelRegister("dS3n9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $8pvtc = parcelRequire("8pvtc");

const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const baseOptions = {
        variables: variables,
        ...onCompleted && {
            onCompleted: onCompleted
        }
    };
    const { loading: loading, data: data, error: error } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $8pvtc.WebPanelLocationQuery), baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $8pvtc.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: fetchPolicy
    });
    const panels = (data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: loading,
        error: error
    };
};
module.exports["useWebPanelLocation"] = $9fffd50bbcc7c343$export$c8daa7260f75e213;

});

parcelRegister("gtauf", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $5a9379de970b4a33$export$aafb32b192c8228c = (node)=>{
    return {
        blockInstanceId: node.attrs.localId,
        content: node.content.toJSON(),
        resourceId: node.attrs.resourceId
    };
};
const $5a9379de970b4a33$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $5a9379de970b4a33$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $5a9379de970b4a33$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $5a9379de970b4a33$export$648ff8dd259e0d9c = (node)=>{
    if (node.type.name !== 'syncBlock' || !node.attrs?.localId || !node.attrs?.resourceId || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $5a9379de970b4a33$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $5a9379de970b4a33$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$5a9379de970b4a33$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined) || [];
};
const $5a9379de970b4a33$export$2cf4a74c3e18f31a = (resourceId)=>{
    const match = resourceId.match(/^(confluence-page|jira-work-item)\/([^/]+)/);
    if (match?.[2]) return {
        sourceProduct: match[1],
        sourceContentId: match[2]
    };
    throw new Error(`Invalid resourceId: ${resourceId}`);
};
module.exports["convertSyncBlockPMNodeToSyncBlockData"] = $5a9379de970b4a33$export$aafb32b192c8228c;
module.exports["createSyncBlockNode"] = $5a9379de970b4a33$export$c5b34fb9069ebb1d;
module.exports["convertSyncBlockJSONNodeToSyncBlockNode"] = $5a9379de970b4a33$export$cd9b0caaea319019;
module.exports["convertPMNodesToSyncBlockNodes"] = $5a9379de970b4a33$export$18b85168a73dad03;
module.exports["getContentIdAndProductFromResourceId"] = $5a9379de970b4a33$export$2cf4a74c3e18f31a;

});

parcelRegister("lEQpi", function(module, exports) {

var $3RNNl = parcelRequire("3RNNl");


var $dBGrG = parcelRequire("dBGrG");

class $f2fbfd8272c84174$export$d353efb45bc662f4 {
    get referenceManager() {
        return this.referenceSyncBlockStoreManager;
    }
    get sourceManager() {
        return this.sourceSyncBlockStoreManager;
    }
    destroy() {
        this.referenceSyncBlockStoreManager.destroy();
        this.sourceSyncBlockStoreManager.destroy();
    }
    constructor(dataProvider, fireAnalyticsEvent){
        this.referenceSyncBlockStoreManager = void 0;
        this.sourceSyncBlockStoreManager = void 0;
        // In future, if reference manager needs to reach to source manager and read it's current in memorey cache
        // we can pass the source manager as a parameter to the reference manager constructor
        this.sourceSyncBlockStoreManager = new (0, $dBGrG.SourceSyncBlockStoreManager)(dataProvider, fireAnalyticsEvent);
        this.referenceSyncBlockStoreManager = new (0, $3RNNl.ReferenceSyncBlockStoreManager)(dataProvider, fireAnalyticsEvent);
    }
}
module.exports["SyncBlockStoreManager"] = $f2fbfd8272c84174$export$d353efb45bc662f4;

});

parcelRegister("3RNNl", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $4FxUL = parcelRequire("4FxUL");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $4wATI = parcelRequire("4wATI");


var $gtauf = parcelRequire("gtauf");

class $bf9ff2ea047058dc$export$fb04276dca31302e {
    generateResourceIdForReference(sourceId) {
        if (!this.dataProvider) throw new Error('Data provider not set');
        return this.dataProvider.generateResourceIdForReference(sourceId);
    }
    updateFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
    }
    getInitialSyncBlockData(resourceId) {
        const syncBlockNode = (0, $gtauf.createSyncBlockNode)('', resourceId);
        return this.getFromCache(resourceId) || this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
    }
    /**
   * Refreshes the subscriptions for all sync blocks.
   * @returns {Promise<void>}
   */ async refreshSubscriptions() {
        if (this.isRefreshingSubscriptions) return;
        this.isRefreshingSubscriptions = true;
        const syncBlocks = [];
        for (const [resourceId, callbacks] of this.subscriptions.entries())Object.keys(callbacks).forEach((localId)=>{
            syncBlocks.push((0, $gtauf.createSyncBlockNode)(localId, resourceId));
        });
        try {
            // fetch latest data for all subscribed sync blocks
            // this function will update the cache and call the subscriptions
            await this.fetchSyncBlocksData(syncBlocks);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
        } finally{
            this.isRefreshingSubscriptions = false;
        }
    }
    fetchSyncBlockSourceInfo(resourceId) {
        try {
            if (!resourceId || !this.dataProvider) throw new Error('Data provider or resourceId not set');
            if (this.syncBlockURLRequests.get(resourceId)) return;
            const existingSyncBlock = this.getFromCache(resourceId);
            if (!existingSyncBlock) throw new Error('No existing sync block to fetch source info for');
            // skip if source URL and title are already present
            if (existingSyncBlock.data?.sourceURL && existingSyncBlock.data?.sourceTitle) return;
            const { sourceAri: sourceAri, product: product, blockInstanceId: blockInstanceId } = existingSyncBlock.data || {};
            if (!sourceAri || !product || !blockInstanceId) {
                this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('SourceAri, product or blockInstanceId missing'));
                return;
            }
            this.syncBlockURLRequests.set(resourceId, true);
            this.dataProvider.fetchSyncBlockSourceInfo(blockInstanceId, sourceAri, product, this.fireAnalyticsEvent).then((sourceInfo)=>{
                if (!sourceInfo) return;
                this.updateCacheWithSourceInfo(resourceId, sourceInfo);
                if (sourceInfo.title) this.updateSourceTitleSubscriptions(resourceId, sourceInfo.title);
            }).catch((error)=>{
                this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            }).finally(()=>{
                this.syncBlockURLRequests.delete(resourceId);
            });
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
        }
    }
    /**
   * Fetch sync block data for a given array of sync block nodes.
   * @param syncBlockNodes - The array of sync block nodes to fetch data for
   * @returns The fetched sync block data results
   */ async fetchSyncBlocksData(syncBlockNodes) {
        if (syncBlockNodes.length === 0) return Promise.resolve([]);
        if (!this.dataProvider) throw new Error('Data provider not set');
        // Don't fetch for not_found error since the source is already deleted
        const nodesToFetch = [], blocksWithNotFoundError = [];
        syncBlockNodes.forEach((node)=>{
            const existingSyncBlock = this.getFromCache(node.attrs.resourceId);
            if (existingSyncBlock?.error === (0, $awHlv.SyncBlockError).NotFound) blocksWithNotFoundError.push(existingSyncBlock);
            else nodesToFetch.push(node);
        });
        const data = await this.dataProvider.fetchNodesData(nodesToFetch);
        const resolvedData = [];
        data.forEach((syncBlockInstance)=>{
            if (!syncBlockInstance.resourceId) {
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(syncBlockInstance.error || 'Returned sync block instance does not have resource id'));
                return;
            }
            const existingSyncBlock = this.getFromCache(syncBlockInstance.resourceId);
            const resolvedSyncBlockInstance = existingSyncBlock ? (0, $4wATI.resolveSyncBlockInstance)(existingSyncBlock, syncBlockInstance) : syncBlockInstance;
            this.updateCache(resolvedSyncBlockInstance);
            resolvedData.push(resolvedSyncBlockInstance);
            if (syncBlockInstance.error) {
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(syncBlockInstance.error));
                return;
            }
            this.fetchSyncBlockSourceInfo(resolvedSyncBlockInstance.resourceId);
        });
        return [
            ...resolvedData,
            ...blocksWithNotFoundError
        ];
    }
    updateCacheWithSourceInfo(resourceId, sourceInfo) {
        const existingSyncBlock = this.getFromCache(resourceId);
        if (existingSyncBlock && existingSyncBlock.data) {
            existingSyncBlock.data.sourceURL = sourceInfo?.url;
            existingSyncBlock.data = {
                ...existingSyncBlock.data,
                sourceURL: sourceInfo?.url,
                sourceTitle: sourceInfo?.title
            };
            this.updateCache(existingSyncBlock);
        }
    }
    updateCache(syncBlock) {
        const { resourceId: resourceId } = syncBlock;
        if (resourceId) {
            this.syncBlockCache.set(resourceId, syncBlock);
            const callbacks = this.subscriptions.get(resourceId);
            if (callbacks) Object.values(callbacks).forEach((callback)=>{
                callback(syncBlock);
            });
        }
    }
    updateSourceTitleSubscriptions(resourceId, title) {
        const callbacks = this.titleSubscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(title);
        });
    }
    getFromCache(resourceId) {
        return this.syncBlockCache.get(resourceId);
    }
    deleteFromCache(resourceId) {
        this.syncBlockCache.delete(resourceId);
        this.providerFactories.delete(resourceId);
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        // add to subscriptions map
        const resourceSubscriptions = this.subscriptions.get(resourceId) || {};
        this.subscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        // New subscription means new reference synced block is added to the document
        this.isCacheDirty = true;
        const syncBlockNode = (0, $gtauf.createSyncBlockNode)(localId, resourceId);
        // call the callback immediately if we have cached data
        // prefer cache from store manager first, should update data provider to use the same cache
        const cachedData = this.getFromCache(resourceId) || this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
        if (cachedData) callback(cachedData);
        else this.fetchSyncBlocksData([
            syncBlockNode
        ]).catch((error)=>{
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
        });
        return ()=>{
            const resourceSubscriptions = this.subscriptions.get(resourceId);
            if (resourceSubscriptions) {
                // Unsubscription means a reference synced block is removed from the document
                this.isCacheDirty = true;
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) {
                    this.subscriptions.delete(resourceId);
                    this.deleteFromCache(resourceId);
                } else this.subscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    subscribeToSourceTitle(node, callback) {
        // check node is a sync block, as we only support sync block subscriptions
        if (node.type.name !== 'syncBlock') return ()=>{};
        const { resourceId: resourceId, localId: localId } = node.attrs;
        if (!localId || !resourceId) return ()=>{};
        const cachedData = this.getFromCache(resourceId);
        if (cachedData?.data?.sourceTitle) callback(cachedData.data.sourceTitle);
        // add to subscriptions map
        const resourceSubscriptions = this.titleSubscriptions.get(resourceId) || {};
        this.titleSubscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        return ()=>{
            const resourceSubscriptions = this.titleSubscriptions.get(resourceId);
            if (resourceSubscriptions) {
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) this.titleSubscriptions.delete(resourceId);
                else this.titleSubscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    subscribe(node, callback) {
        try {
            // check node is a sync block, as we only support sync block subscriptions
            if (node.type.name !== 'syncBlock') throw new Error('Only sync block node subscriptions are supported');
            const { resourceId: resourceId, localId: localId } = node.attrs;
            if (!localId || !resourceId) throw new Error('Missing local id or resource id');
            return this.subscribeToSyncBlock(resourceId, localId, callback);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
            return ()=>{};
        }
    }
    /**
   * Get the URL for a sync block.
   * @param resourceId - The resource ID of the sync block
   * @returns
   */ getSyncBlockURL(resourceId) {
        const syncBlock = this.getFromCache(resourceId);
        if (!syncBlock) return undefined;
        return syncBlock.data?.sourceURL;
    }
    getProviderFactory(resourceId) {
        if (!this.dataProvider) {
            const error = new Error('Data provider not set');
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
            return undefined;
        }
        const { parentDataProviders: parentDataProviders, providerCreator: providerCreator } = this.dataProvider.getSyncedBlockRendererProviderOptions();
        let providerFactory = this.providerFactories.get(resourceId);
        if (!providerFactory) {
            providerFactory = (0, $4FxUL.default).create({
                mentionProvider: parentDataProviders?.mentionProvider,
                profilecardProvider: parentDataProviders?.profilecardProvider,
                taskDecisionProvider: parentDataProviders?.taskDecisionProvider
            });
            this.providerFactories.set(resourceId, providerFactory);
        }
        if (providerCreator) try {
            this.retrieveDynamicProviders(resourceId, providerFactory, providerCreator);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
        }
        return providerFactory;
    }
    retrieveDynamicProviders(resourceId, providerFactory, providerCreator) {
        if (!this.dataProvider) throw new Error('Data provider not set');
        const hasMediaProvider = providerFactory.hasProvider('mediaProvider');
        const hasEmojiProvider = providerFactory.hasProvider('emojiProvider');
        if (hasMediaProvider && hasEmojiProvider) return;
        const syncBlock = this.getFromCache(resourceId);
        if (!syncBlock || !syncBlock.data?.sourceAri || !syncBlock.data?.product) {
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)('Sync block or source ari or product not found'));
            return;
        }
        const parentInfo = this.dataProvider.retrieveSyncBlockParentInfo(syncBlock.data?.sourceAri, syncBlock.data?.product);
        if (!parentInfo) throw new Error('Unable to retrive sync block parent info');
        const { contentId: contentId, contentProduct: contentProduct } = parentInfo;
        if (!hasMediaProvider) {
            if (providerCreator.createMediaProvider && contentId && contentProduct) {
                const mediaProvider = providerCreator.createMediaProvider({
                    contentProduct: contentProduct,
                    contentId: contentId
                });
                if (mediaProvider) providerFactory.setProvider('mediaProvider', mediaProvider);
            }
        }
        if (!hasEmojiProvider) {
            if (providerCreator.createEmojiProvider && contentId && contentProduct) {
                const emojiProvider = providerCreator.createEmojiProvider({
                    contentProduct: contentProduct,
                    contentId: contentId
                });
                if (emojiProvider) providerFactory.setProvider('emojiProvider', emojiProvider);
            }
        }
    }
    /**
   * Update reference synced blocks on the document with the BE
   * 
   * @returns true if the reference synced blocks are updated successfully, false otherwise
   */ async flush() {
        if (!this.isCacheDirty) return true;
        let success = true;
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const blocks = [];
            // Collect all reference synced blocks on the current document
            Array.from(this.subscriptions.entries()).forEach(([resourceId, callbacks])=>{
                Object.keys(callbacks).forEach((localId)=>{
                    blocks.push({
                        resourceId: resourceId,
                        localId: localId
                    });
                });
            });
            if (blocks.length === 0) return true;
            const updateResult = await this.dataProvider.updateReferenceData(blocks);
            if (!updateResult.success) {
                success = false;
                this.fireAnalyticsEvent?.((0, $cFpEg.updateReferenceErrorPayload)(updateResult.error || 'Failed to update reference synced blocks on the document'));
            }
        } catch (error) {
            success = false;
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.updateReferenceErrorPayload)(error.message));
        } finally{
            if (success) this.isCacheDirty = false;
        }
        return success;
    }
    destroy() {
        this.dataProvider = undefined;
        this.syncBlockCache.clear();
        this.subscriptions.clear();
        this.titleSubscriptions.clear();
        this.syncBlockURLRequests.clear();
        this.providerFactories.clear();
        this.isRefreshingSubscriptions = false;
        this.providerFactories.forEach((providerFactory)=>{
            providerFactory.destroy();
        });
        this.providerFactories.clear();
        this.fireAnalyticsEvent = undefined;
    }
    constructor(dataProvider, fireAnalyticsEvent){
        this.dataProvider = void 0;
        this.syncBlockCache = void 0;
        // Keeps track of addition and deletion of reference synced blocks on the document
        // This starts as true to always flush the cache when document is saved for the first time
        // to cater the case when a editor seesion is closed without document being updated right after reference block is deleted
        this.isCacheDirty = true;
        this.subscriptions = void 0;
        this.titleSubscriptions = void 0;
        this.providerFactories = void 0;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockURLRequests = void 0;
        this.isRefreshingSubscriptions = false;
        this.syncBlockCache = new Map();
        this.subscriptions = new Map();
        this.titleSubscriptions = new Map();
        this.dataProvider = dataProvider;
        this.syncBlockURLRequests = new Map();
        this.providerFactories = new Map();
        this.fireAnalyticsEvent = fireAnalyticsEvent;
    }
}
module.exports["ReferenceSyncBlockStoreManager"] = $bf9ff2ea047058dc$export$fb04276dca31302e;

});

parcelRegister("4wATI", function(module, exports) {

var $awHlv = parcelRequire("awHlv");

const $165aef3c3dcb8be4$export$dcc459f28c1cd2fd = (oldResult, newResult)=>{
    // if the old result has no data, we simply return the new result
    if (!oldResult.data) return newResult;
    else if (!newResult.data) {
        // return the old result if there was an error, e.g. network error, but not if not found or forbidden
        if (newResult.error === (0, $awHlv.SyncBlockError).NotFound || newResult.error === (0, $awHlv.SyncBlockError).Forbidden) return newResult;
        else return oldResult;
    }
    // otherwise, we merge the two results, preserving the sourceURL and sourceTitle from the old result if it exists
    return {
        ...newResult,
        data: {
            ...newResult.data,
            sourceURL: newResult.data?.sourceURL || oldResult.data?.sourceURL || undefined,
            sourceTitle: newResult.data?.sourceTitle || oldResult.data?.sourceTitle || undefined
        }
    };
};
module.exports["resolveSyncBlockInstance"] = $165aef3c3dcb8be4$export$dcc459f28c1cd2fd;

});

parcelRegister("dBGrG", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $hWRJP = parcelRequire("hWRJP");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $gtauf = parcelRequire("gtauf");

class $297b92badcfd6d6a$export$9c6faa8962092f36 {
    isSourceBlock(node) {
        return node.type.name === 'bodiedSyncBlock';
    }
    /**
   * Add/update a sync block node to/from the local cache
   * @param syncBlockNode - The sync block node to update
   */ updateSyncBlockData(syncBlockNode) {
        try {
            if (!this.isSourceBlock(syncBlockNode)) throw new Error('Invalid sync block node type provided for updateSyncBlockData');
            const { localId: localId, resourceId: resourceId } = syncBlockNode.attrs;
            if (!localId || !resourceId) throw new Error('Local ID or resource ID is not set');
            const syncBlockData = (0, $gtauf.convertSyncBlockPMNodeToSyncBlockData)(syncBlockNode);
            this.syncBlockCache.set(resourceId, {
                ...syncBlockData,
                isDirty: true
            });
            return true;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.updateCacheErrorPayload)(error.message));
            return false;
        }
    }
    /**
   * Save content of bodiedSyncBlock nodes in local cache to backend
   *
   * @returns true if saving all nodes successfully, false if fail to save some/all nodes
   */ async flush() {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const bodiedSyncBlockNodes = [];
            const bodiedSyncBlockData = [];
            Array.from(this.syncBlockCache.values()).forEach((syncBlockData)=>{
                // Don't flush nodes that are waiting to be deleted to avoid nodes being re-created
                // Don't flush nodes that haven't been updated since we last flushed
                if (!syncBlockData.pendingDeletion && syncBlockData.isDirty) {
                    bodiedSyncBlockNodes.push({
                        type: 'bodiedSyncBlock',
                        attrs: {
                            localId: syncBlockData.blockInstanceId,
                            resourceId: syncBlockData.resourceId
                        }
                    });
                    bodiedSyncBlockData.push(syncBlockData);
                }
            });
            if (bodiedSyncBlockNodes.length === 0) return Promise.resolve(true);
            const writeResults = await this.dataProvider.writeNodesData(bodiedSyncBlockNodes, bodiedSyncBlockData);
            writeResults.forEach((result)=>{
                // set isDirty to false on write success and unrecoverable errors like not found
                if (result.resourceId && (result.error === (0, $awHlv.SyncBlockError).NotFound || !result.error)) {
                    const cachedData = this.syncBlockCache.get(result.resourceId);
                    if (cachedData) cachedData.isDirty = false;
                }
            });
            if (writeResults.every((result)=>result.resourceId && !result.error)) return true;
            else {
                writeResults.filter((result)=>!result.resourceId || result.error).forEach((result)=>{
                    this.fireAnalyticsEvent?.((0, $cFpEg.updateErrorPayload)(result.error || 'Failed to write data'));
                });
                return false;
            }
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.updateErrorPayload)(error.message));
            return false;
        }
    }
    registerPendingCreation(resourceId) {
        this.pendingResourceId = resourceId;
    }
    /**
   * Register callback function (which inserts node, handles focus etc) to be used later when creation to backend succeed
   */ registerCreationCallback(callback) {
        this.creationCallback = callback;
    }
    /**
   *  Fires callback to insert node (if creation is successful) and clears pending creation data
   * @param success
   */ commitPendingCreation(success) {
        if (success && this.creationCallback) this.creationCallback();
        this.pendingResourceId = undefined;
        this.creationCallback = undefined;
    }
    /**
   *
   * @returns true if waiting for the result of saving new bodiedSyncBlock to backend
   */ hasPendingCreation() {
        return !!this.pendingResourceId;
    }
    registerConfirmationCallback(callback) {
        this.confirmationCallback = callback;
        return ()=>{
            this.confirmationCallback = undefined;
        };
    }
    requireConfirmationBeforeDelete() {
        return !!this.confirmationCallback;
    }
    /**
   * @returns attributes for a new bodiedSyncBlock node
   */ generateBodiedSyncBlockAttrs() {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const localId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        const sourceId = this.dataProvider?.getSourceId();
        if (!this.dataProvider || !sourceId) throw new Error('Data provider not set or source id not set');
        const resourceId = this.dataProvider.generateResourceId(sourceId, localId);
        return {
            resourceId: resourceId,
            localId: localId
        };
    }
    /**
   * Create a bodiedSyncBlock node with empty content to backend
   * @param attrs attributes Ids of the node
   */ createBodiedSyncBlockNode(attrs) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const { resourceId: resourceId, localId: blockInstanceId } = attrs;
            this.dataProvider.createNodeData({
                content: [],
                blockInstanceId: blockInstanceId,
                resourceId: resourceId
            }).then((result)=>{
                const resourceId = result.resourceId;
                if (resourceId) this.commitPendingCreation(true);
                else {
                    this.commitPendingCreation(false);
                    this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(result.error || 'Failed to create bodied sync block'));
                }
            }).catch((error)=>{
                this.commitPendingCreation(false);
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(error.message));
            });
            this.registerPendingCreation(resourceId);
        } catch (error) {
            if (this.hasPendingCreation()) this.commitPendingCreation(false);
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(error.message));
        }
    }
    async delete(syncBlockIds, onDelete, onDeleteCompleted) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, true);
            });
            const results = await this.dataProvider.deleteNodesData(syncBlockIds.map((attrs)=>attrs.resourceId));
            let callback;
            const isDeleteSuccessful = results.every((result)=>result.success);
            onDeleteCompleted(isDeleteSuccessful);
            if (isDeleteSuccessful) {
                onDelete();
                callback = (Ids)=>this.syncBlockCache.delete(Ids.resourceId);
                this.clearPendingDeletion();
            } else {
                callback = (Ids)=>{
                    this.setPendingDeletion(Ids, false);
                };
                results.filter((result)=>result.resourceId === undefined).forEach((result)=>{
                    this.fireAnalyticsEvent?.((0, $cFpEg.deleteErrorPayload)(result.error || 'Failed to delete synced block'));
                });
            }
            syncBlockIds.forEach(callback);
            return isDeleteSuccessful;
        } catch (error) {
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, false);
            });
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.deleteErrorPayload)(error.message));
            onDeleteCompleted(false);
            return false;
        }
    }
    isRetryingDeletion() {
        return !!this.deletionRetryInfo;
    }
    async retryDeletion() {
        if (!this.deletionRetryInfo) return Promise.resolve();
        const { syncBlockIds: syncBlockIds, onDelete: onDelete, onDeleteCompleted: onDeleteCompleted } = this.deletionRetryInfo;
        if (this.confirmationCallback) await this.delete(syncBlockIds, onDelete, onDeleteCompleted);
    }
    clearPendingDeletion() {
        this.deletionRetryInfo?.destroyCallback();
        this.deletionRetryInfo = undefined;
    }
    /**
   *
   * @param syncBlockIds - The sync block ids to delete
   * @param onDelete - The callback to delete sync block node from document
   * @param onDeleteCompleted - The callback for after the deletion is saved to BE (whether successful or not)
   * @param destroyCallback - The callback to clear any reference stored for deletion (regardless if deletion is completed or abort)
   */ async deleteSyncBlocksWithConfirmation(syncBlockIds, onDelete, onDeleteCompleted, destroyCallback) {
        if (this.confirmationCallback) {
            const confirmed = await this.confirmationCallback(syncBlockIds.length);
            if (confirmed) {
                const isDeleteSuccessful = await this.delete(syncBlockIds, onDelete, onDeleteCompleted);
                if (!isDeleteSuccessful) // If deletion failed, save deletion info for potential retry
                this.deletionRetryInfo = {
                    syncBlockIds: syncBlockIds,
                    onDelete: onDelete,
                    onDeleteCompleted: onDeleteCompleted,
                    destroyCallback: destroyCallback
                };
            } else destroyCallback();
        }
    }
    destroy() {
        this.syncBlockCache.clear();
        this.confirmationCallback = undefined;
        this.pendingResourceId = undefined;
        this.creationCallback = undefined;
        this.dataProvider = undefined;
        this.clearPendingDeletion();
    }
    constructor(dataProvider, fireAnalyticsEvent){
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockCache = void 0;
        this.confirmationCallback = void 0;
        this.deletionRetryInfo = void 0;
        this.pendingResourceId = void 0;
        this.creationCallback = void 0;
        this.setPendingDeletion = (Ids, value)=>{
            const syncBlock = this.syncBlockCache.get(Ids.resourceId);
            if (syncBlock) syncBlock.pendingDeletion = value;
        };
        this.dataProvider = dataProvider;
        this.syncBlockCache = new Map();
        this.fireAnalyticsEvent = fireAnalyticsEvent;
    }
}
module.exports["SourceSyncBlockStoreManager"] = $297b92badcfd6d6a$export$9c6faa8962092f36;

});

parcelRegister("a7tZV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hWRJP = parcelRequire("hWRJP");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $gtauf = parcelRequire("gtauf");

const $fb1e42d9cacf5d6e$export$2b02427d5640395b = (manager, resourceId, localId, fireAnalyticsEvent)=>{
    const [syncBlockInstance, setSyncBlockInstance] = (0, $42omo.useState)(()=>{
        if (resourceId) return manager?.referenceManager?.getInitialSyncBlockData(resourceId) ?? null;
        return null;
    });
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    const reloadData = (0, $42omo.useCallback)(async ()=>{
        if (isLoading) return;
        try {
            const syncBlockNode = resourceId && localId ? (0, $gtauf.createSyncBlockNode)(localId, resourceId) : null;
            if (!syncBlockNode) throw new Error('Failed to create sync block node from resourceid and localid');
            setIsLoading(true);
            // Fetch sync block data, the `subscribeToSyncBlock` will update the state once data is fetched
            await manager.referenceManager.fetchSyncBlocksData([
                syncBlockNode
            ]);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/useFetchSyncBlockData'
            });
            fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
            // Set error state if fetching fails
            setSyncBlockInstance({
                resourceId: resourceId || '',
                error: (0, $awHlv.SyncBlockError).Errored
            });
        }
        setIsLoading(false);
    }, [
        isLoading,
        localId,
        manager.referenceManager,
        resourceId,
        fireAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = manager.referenceManager.subscribeToSyncBlock(resourceId || '', localId || '', (data)=>{
            setSyncBlockInstance(data);
            setIsLoading(false);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        localId,
        manager.referenceManager,
        resourceId
    ]);
    return {
        isLoading: isLoading,
        providerFactory: manager.referenceManager.getProviderFactory(resourceId || ''),
        reloadData: reloadData,
        syncBlockInstance: syncBlockInstance
    };
};
module.exports["useFetchSyncBlockData"] = $fb1e42d9cacf5d6e$export$2b02427d5640395b;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("fOKpq", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $7c1587c4cdf698a9$export$49e1053dfc41d188 = /*#__PURE__*/ (0, $42omo.createContext)({
    // AI and Company Hub
    isCompanyHub: true,
    isAdminHubAIEnabled: false,
    enableLinkInputInMediaPicker: false,
    helpCenterAri: '',
    showConfigPreambleSupportLink: false,
    // Shortcuts
    shortcutListener: undefined,
    // Smart cards
    smartCardProviderComponent: undefined,
    // Custom search configuration
    orgId: '',
    userId: '',
    searchConfigProvider: {
        peopleDirectoryUrl: '',
        advancedSearchUrl: '',
        searchSessionId: ''
    },
    displayName: '',
    // Theming
    isSSRProductInDarkMode: undefined,
    branding: undefined,
    hideExtensionBorders: false,
    // Feedback collection
    useFeedbackCollector: undefined,
    // Media providers
    cloudId: '',
    useMediaConfig: undefined,
    createEditorMediaProvider: ()=>Promise.resolve({
            viewMediaClientConfig: {
                authProvider: async ()=>({})
            },
            uploadMediaClientConfig: {
                authProvider: async ()=>({})
            }
        }),
    // Error handling
    submitError: ()=>{},
    markErrorAsHandled: ()=>{},
    errorDisplayComponent: ()=>null,
    errorBoundaryComponent: undefined,
    // Premium upsells
    ConfigUpsellScreen: undefined,
    // Experience tracking
    mediaUploadExperienceTracker: undefined,
    aiDescriptionExperienceTracker: undefined,
    experienceSuccessComponent: ()=>null,
    experienceStopComponent: ()=>null,
    experienceStartComponent: ()=>null,
    // Analytics
    analyticsContext: {},
    // User segmentation
    useSegmentationTargetGroups: ()=>{},
    isTargetAudience: ()=>false,
    // Link picker configuration
    linkPickerConfig: {},
    enableTargeting: false,
    enableUnifiedSearchFeatures: false,
    enableSmartCardsFields: false
});
const $7c1587c4cdf698a9$export$774887fcc3922763 = ({ children: children, ...props })=>{
    const defaultValue = (0, $42omo.useContext)($7c1587c4cdf698a9$export$49e1053dfc41d188);
    const value = {
        ...defaultValue,
        ...props
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($7c1587c4cdf698a9$export$49e1053dfc41d188.Provider, {
        value: value,
        children: children
    });
};
function $7c1587c4cdf698a9$export$8dcbb40932065737() {
    const ctx = (0, $42omo.useContext)($7c1587c4cdf698a9$export$49e1053dfc41d188);
    if (!ctx) throw new Error('useProductDependencies must be used within ProductDependenciesProvider');
    return ctx;
}
module.exports["ProductDependenciesContext"] = $7c1587c4cdf698a9$export$49e1053dfc41d188;
module.exports["useProductDependencies"] = $7c1587c4cdf698a9$export$8dcbb40932065737;

});

parcelRegister("lOeVN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8aF6s = parcelRequire("8aF6s");


var $jmjWc = parcelRequire("jmjWc");

function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $42omo.useRef)();
    propsRef.current = props;
    return (0, $42omo.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("5JEoN"))).FeedbackCollector
});
module.exports["useFeedbackCollector"] = $926167cc1656a619$export$4be696be8a3bff13;

});

parcelRegister("5JEoN", function(module, exports) {

let $42d07e1c20ae910c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $42d07e1c20ae910c$var$load("Wowvf"),
    $42d07e1c20ae910c$var$load("6wr18"),
    $42d07e1c20ae910c$var$load("ffEVr"),
    $42d07e1c20ae910c$var$load("hhss7"),
    $42d07e1c20ae910c$var$load("cyGuT"),
    $42d07e1c20ae910c$var$load("bUC6C")
]).then(()=>parcelRequire('cz7bE'));

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ay6Zz = parcelRequire("ay6Zz");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $bYUc2 = parcelRequire("bYUc2");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $ay6Zz.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: (0, $bYUc2.getIsNav4EnabledSafe)(),
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    const getNavigateToTeamsAppCallback = (0, $42omo.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? getNavigateToTeamsAppCallback : getNavigateToTeamsApp;
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("kDja4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");


var $jf9LK = parcelRequire("jf9LK");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $42omo.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        if (featureName in (0, (/*@__PURE__*/$parcel$interopDefault($jf9LK)))) {
            const activeFeatureGate = featureName;
            const featureGateKey = (0, (/*@__PURE__*/$parcel$interopDefault($jf9LK)))[activeFeatureGate];
            return (0, $9wGTI.fg)(featureGateKey);
        }
        return false;
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dh538.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("jf9LK", function(module, exports) {
module.exports = JSON.parse("{\"whiteboardSolidHeader\":\"confluence_frontend_solid_whiteboard_header\",\"whiteboardOptOut\":\"whiteboards_compliance_opt_out\",\"digitalTeammate\":\"cc-ai-whiteboards-enable-digital-teammate\",\"aiFirstCreation\":\"aifc_create_enabled\"}");

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("jn9ek", function(module, exports) {
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};
module.exports["isBadThirdPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$9ae592643c1ef19b;
module.exports["isBadEditedFirstPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$af33641014b57bba;
module.exports["isInvalidSpaceKeyError"] = $2f7d9ade7a6b90fb$export$b6b21a057779c53b;
module.exports["isRateExceededError"] = $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08;
module.exports["getTraceIdFromApolloError"] = $2f7d9ade7a6b90fb$export$69408b85ed2a0e77;

});

parcelRegister("7EIq6", function(module, exports) {

var $j1Ss3 = parcelRequire("j1Ss3");


var $jtuBN = parcelRequire("jtuBN");


var $6mKj3 = parcelRequire("6mKj3");


var $iLgzu = parcelRequire("iLgzu");


var $7NtNc = parcelRequire("7NtNc");


var $bp4rK = parcelRequire("bp4rK");

const $649b778bbd82b1bb$export$1defcb29347f9ac6 = (spaceKey)=>{
    const defaultSpaceQueryArgs = {
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    };
    const { data: defaultSpaceKeyData } = (0, $6mKj3.expValEquals)('confluence_deprecate_experimental_promoted_spaces', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    (0, $iLgzu.useExperimentalPromotedSpacesQuery)(defaultSpaceQueryArgs) : // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $bp4rK.GetDefaultSpaceQuery), defaultSpaceQueryArgs);
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $7NtNc.SpaceEnabledContentTypesQuery), spaceEnabledContentTypesQueryOptions);
    const isCreateWhiteboardEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isWhiteboardsEnabled);
    const isCreateBlogEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isBlogsEnabled);
    const isCreateDatabaseEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isDatabasesEnabled);
    const isCreateSmartLinkEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isEmbedsEnabled);
    const isCreateLiveDocEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isLivePagesEnabled);
    const isCreateFolderEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isFoldersEnabled);
    return {
        isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
        isCreateBlogEnabled: isCreateBlogEnabled,
        isCreateDatabaseEnabled: isCreateDatabaseEnabled,
        isCreateSmartLinkEnabled: isCreateSmartLinkEnabled,
        isCreateLiveDocEnabled: isCreateLiveDocEnabled,
        isCreateFolderEnabled: isCreateFolderEnabled
    };
};
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("7NtNc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $ada047e01258ab08$export$a08098e2700d7e94 = (0, $eSUdr.default)`query SpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id key spaceTypeSettings{enabledContentTypes{isBlogsEnabled isDatabasesEnabled isEmbedsEnabled isLivePagesEnabled isWhiteboardsEnabled isFoldersEnabled}}}}`;
module.exports["SpaceEnabledContentTypesQuery"] = $ada047e01258ab08$export$a08098e2700d7e94;

});

parcelRegister("bp4rK", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $a9375ef73dfcb073$export$9d480e5fa307b726 = // eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
(0, $eSUdr.default)`query GetDefaultSpaceQuery($promotedSpaceKey:String)@experimental{experimentalPromotedSpaces(promotedSpacesLimit:1 otherSpacesLimit:1 promotedSpaceKey:$promotedSpaceKey){nodes{id}}}`;
module.exports["GetDefaultSpaceQuery"] = $a9375ef73dfcb073$export$9d480e5fa307b726;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("10Oe6", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");


var $2XqLN = parcelRequire("2XqLN");


var $5cryL = parcelRequire("5cryL");


var $9wGTI = parcelRequire("9wGTI");


var $iacta = parcelRequire("iacta");


var $ae5hk = parcelRequire("ae5hk");

const $f4c21c880d0229da$var$i18n = (0, $cgtv4.defineMessages)({
    featuredCategoryName: {
        id: "template-utils.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-utils.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    starredCategoryName: {
        id: "template-utils.starred.category.name",
        defaultMessage: "Starred"
    },
    promotedCategoryName: {
        id: "template-utils.promoted.category.name",
        defaultMessage: "Promoted"
    }
});
const $f4c21c880d0229da$export$612b286afa12407b = '00000000-0000-0000-0000-000000000001';
const $f4c21c880d0229da$export$3b0b898c62947fee = (templateId)=>!/^[0-9]+$/.test(templateId);
const $f4c21c880d0229da$export$47ee581a4caa8fa2 = (templateId)=>!templateId || templateId === '';
const $f4c21c880d0229da$export$13d482a11efa2b43 = (template)=>{
    return template?.blueprintModuleCompleteKey || template?.templateId || template?.itemModuleCompleteKey || '';
};
const $f4c21c880d0229da$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || '';
};
const $f4c21c880d0229da$export$3abed2086f3435f9 = (template)=>{
    if (!template) return null;
    if (template.templateType === 'blueprint' && template.hasGlobalBlueprintContent && template.contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b) return template.blueprintModuleCompleteKey;
    return $f4c21c880d0229da$export$c095b4283dffab05(template);
};
const $f4c21c880d0229da$export$f19afdee92cfd543 = (templates, selectedSortOrder)=>{
    const nonFeaturedTemplates = [];
    const promotedTemplates = [];
    const customTemplates = [];
    templates.forEach((template)=>{
        if (template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')) {
            if (!template.categoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID))) template.categoryIds.push((0, $iacta.FEATURED_CATEGORY_ID));
            // We want to show all promoted templates first, regardless of
            // whether or not the template is custom
            if (template.categoryIds.includes('template.category.promoted')) promotedTemplates.push(template);
            else customTemplates.push(template);
        } else nonFeaturedTemplates.push(template);
    });
    // If alphabetical sort is on, we don't care to show featured categories first
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) return [
        ...promotedTemplates,
        ...customTemplates,
        ...nonFeaturedTemplates
    ];
    else return templates;
};
const $f4c21c880d0229da$export$6d6fdbfe01edf136 = (templates, currentUserId, additionalTemplateIdsList)=>{
    templates.forEach((t)=>{
        const isStarredTemplateOrCreatedByCurrentUser = t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || // checks for recently unstarred templates that we still want to display
        additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(t)) || t.author === currentUserId;
        if (isStarredTemplateOrCreatedByCurrentUser && !t.categoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) t.categoryIds.push((0, $iacta.MY_TEMPLATES_CATEGORY_ID));
    });
};
const $f4c21c880d0229da$export$dea26c1eb71953eb = (templates)=>templates?.filter((template)=>template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')).length;
const $f4c21c880d0229da$export$e4f285fe1dc6eb6 = (templates, currentUserId)=>templates?.filter((template)=>template.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || template.author === currentUserId).length;
const $f4c21c880d0229da$export$c5981f9aba761c29 = (availableCategories, lastSelectedCategoryIds)=>availableCategories.filter((category)=>lastSelectedCategoryIds.includes(category.id)).map((category)=>category.id);
const $f4c21c880d0229da$export$cdc91788760e8bf8 = (0, $2XqLN.default)((templates, additionalTemplateIdsList)=>{
    return templates.filter((t)=>t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || additionalTemplateIdsList.has($f4c21c880d0229da$export$3abed2086f3435f9(t)));
});
const $f4c21c880d0229da$export$1caa21769d3bff9a = (templates, categoryIds, selectedSortOrder, currentUserId, additionalTemplateIdsList)=>{
    if (!categoryIds.length) return templates;
    if (categoryIds?.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) $f4c21c880d0229da$export$6d6fdbfe01edf136(templates, currentUserId, additionalTemplateIdsList);
    const isFeaturedCategorySelected = categoryIds?.includes((0, $iacta.FEATURED_CATEGORY_ID));
    const templatesToBeFiltered = isFeaturedCategorySelected ? $f4c21c880d0229da$export$f19afdee92cfd543(templates, selectedSortOrder) : templates;
    return templatesToBeFiltered?.filter((template)=>template?.categoryIds?.some((categoryId)=>categoryIds?.includes(categoryId) || additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template))));
};
const $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter = (categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList)=>{
    const isRecentlyUnstarred = additionalUnstarredTemplateIdsList && additionalUnstarredTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName)) && isFavourite || isRecentlyUnstarred) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName));
    else if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName)) && isPromoted) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName));
    const isFeaturedCategoryTemplate = categoryIds.includes('template.category.promoted') || categoryIds.includes('template.category.custom');
    const isMyTemplatesCategoryTemplate = categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || author === currentUserId;
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName)) && isFeaturedCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName)) && isMyTemplatesCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName));
    const keywordsIncludesSearchQuery = (keyword)=>keyword?.toLowerCase().includes(lowercaseQuery);
    return keywords.some(keywordsIncludesSearchQuery);
};
const $f4c21c880d0229da$export$698b1171e770b401 = (query, intl, currentUserId, additionalUnstarredTemplateIdsList)=>{
    return (template)=>{
        const lowercaseQuery = query.toLowerCase();
        const name = template.name || '';
        const description = template.description || '';
        const author = template.author || '';
        const keywords = template.keywords || [];
        const categoryIds = template.categoryIds || [];
        const isFavourite = template.isFavourite || false;
        const isPromoted = template.isPromoted || false;
        const blueprintAuthor = template.blueprintModuleCompleteKey ? author : '';
        const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList);
        return name.toLowerCase().includes(lowercaseQuery) || description.toLowerCase().includes(lowercaseQuery) || blueprintAuthor.toLowerCase().includes(lowercaseQuery) || keywordsIncludeSearchQuery;
    };
};
const $f4c21c880d0229da$export$bf559da1453b0f39 = (0, $2XqLN.default)((templates, intl, currentUserId, searchQuery, additionalUnstarredTemplateIdsList)=>{
    if (searchQuery) {
        const searchQueryFilter = $f4c21c880d0229da$export$698b1171e770b401(searchQuery, intl, currentUserId, additionalUnstarredTemplateIdsList);
        templates = templates.filter(searchQueryFilter);
    }
    return templates;
});
const $f4c21c880d0229da$export$23b29992d53f1142 = (template, intl, currentUserId, searchQuery)=>{
    if (!searchQuery) return {
        searchQueryMatchesTitle: false,
        searchQueryMatchesDescription: false,
        searchQueryMatchesAuthor: false,
        searchQueryMatchesKeywords: false
    };
    const lowercaseQuery = searchQuery.toLowerCase();
    const name = template.name || '';
    const description = template.description || '';
    const author = template.author || '';
    const keywords = template.keywords || [];
    const categoryIds = template.categoryIds || [];
    const isFavourite = template.isFavourite;
    const isPromoted = template.isPromoted;
    const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId);
    return {
        searchQueryMatchesTitle: name.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesDescription: description.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesAuthor: author.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesKeywords: keywordsIncludeSearchQuery
    };
};
const $f4c21c880d0229da$export$16f4535f1b52f11d = (0, $2XqLN.default)((templates, includeEditorTutorialTemplate, selectedSortOrder)=>{
    // filter out null templates
    const nonNullTemplates = templates.filter((template)=>!!template);
    const tutorialIndex = nonNullTemplates.findIndex((element)=>// only one should appear at the same time
        (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED) : element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY));
    if (tutorialIndex === -1) return nonNullTemplates;
    const tutorial = nonNullTemplates[tutorialIndex];
    // Remove the editor tutorial template if it shouldn't be included
    if (!includeEditorTutorialTemplate) {
        nonNullTemplates.splice(tutorialIndex, 1);
        return nonNullTemplates;
    }
    // If the sorting order is not alphabetical
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) {
        // Remove the tutorial template, and then add it to the front.
        nonNullTemplates.splice(tutorialIndex, 1);
        nonNullTemplates.unshift(tutorial);
    }
    return nonNullTemplates;
});
const $f4c21c880d0229da$export$9b34fbf9a069b426 = (0, $2XqLN.default)((templates, allowList)=>{
    if (!allowList.length) return templates;
    return templates.filter((template)=>allowList.includes($f4c21c880d0229da$export$13d482a11efa2b43(template)));
});
const $f4c21c880d0229da$export$d444d78112a48f41 = (template)=>{
    if (template.blueprintModuleCompleteKey) return {
        idType: 'blueprint',
        id: template.blueprintModuleCompleteKey
    };
    if (template.templateId) return {
        idType: 'template',
        id: template.templateId
    };
    return {
        idType: 'other',
        id: template.itemModuleCompleteKey
    };
};
const $f4c21c880d0229da$export$9fd27f38e4a8e848 = (templates, favouritedTemplatesList)=>{
    // filter out null templates
    const filteredTemplates = templates.filter((template)=>!!template);
    if (!favouritedTemplatesList) return filteredTemplates;
    return filteredTemplates.map((template)=>{
        const isFavourite = favouritedTemplatesList.some((favouritedTemplateId)=>favouritedTemplateId === $f4c21c880d0229da$export$3abed2086f3435f9(template));
        // avoid re-adding starred category to a template that has already been starred
        const categoryIds = template.categoryIds.filter((category)=>category !== (0, $iacta.STARRED_CATEGORY_ID));
        if (isFavourite) categoryIds.push((0, $iacta.STARRED_CATEGORY_ID));
        return {
            ...template,
            isFavourite: isFavourite,
            categoryIds: categoryIds
        };
    });
};
module.exports["BLOG_CONTENT_BLUEPRINT_ID"] = $f4c21c880d0229da$export$612b286afa12407b;
module.exports["isBlueprint"] = $f4c21c880d0229da$export$3b0b898c62947fee;
module.exports["getTemplateKey"] = $f4c21c880d0229da$export$13d482a11efa2b43;
module.exports["getTemplateId"] = $f4c21c880d0229da$export$c095b4283dffab05;
module.exports["getTemplateIdForUserPreferences"] = $f4c21c880d0229da$export$3abed2086f3435f9;
module.exports["getFeaturedCategoryCount"] = $f4c21c880d0229da$export$dea26c1eb71953eb;
module.exports["getMyTemplatesCategoryCount"] = $f4c21c880d0229da$export$e4f285fe1dc6eb6;
module.exports["getExistingCategoryIds"] = $f4c21c880d0229da$export$c5981f9aba761c29;
module.exports["filterTemplatesByCategoryIds"] = $f4c21c880d0229da$export$1caa21769d3bff9a;
module.exports["filterTemplatesBySearchQuery"] = $f4c21c880d0229da$export$bf559da1453b0f39;
module.exports["getSearchQueryMatches"] = $f4c21c880d0229da$export$23b29992d53f1142;
module.exports["filterEditorTutorialTemplate"] = $f4c21c880d0229da$export$16f4535f1b52f11d;
module.exports["filterTemplatesByAllowList"] = $f4c21c880d0229da$export$9b34fbf9a069b426;
module.exports["getTemplateIdAttributesForAnalytics"] = $f4c21c880d0229da$export$d444d78112a48f41;
module.exports["updateFavouriteTemplates"] = $f4c21c880d0229da$export$9fd27f38e4a8e848;

});

parcelRegister("iacta", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

const $1c68435f253b2047$export$b1a62972d9cddd78 = 'template.category.featured';
const $1c68435f253b2047$export$5aacf8f53708daf0 = 'template.category.my-templates';
const $1c68435f253b2047$export$c2a29eb4a43ff314 = 'template.category.starred';
const $1c68435f253b2047$export$d01d2d40a80eb4a1 = (0, $2XqLN.default)((templates, categories, mandatoryCategoryIdToShow = '')=>{
    const categoryIdToCountMap = {};
    for (const template of templates)for (const categoryId of template.categoryIds){
        if (!categoryId) continue;
        if (!categoryIdToCountMap[categoryId]) categoryIdToCountMap[categoryId] = 0;
        categoryIdToCountMap[categoryId]++;
    }
    const countedCategories = [];
    for (const category of categories){
        if (!category?.id || !category?.name) continue;
        const count = categoryIdToCountMap[category.id];
        const shouldForceShowCategory = category.id === mandatoryCategoryIdToShow;
        if (count || shouldForceShowCategory) countedCategories.push({
            id: category.id,
            name: category.name,
            count: count
        });
    }
    return countedCategories;
});
const $1c68435f253b2047$export$b36f54982a81becd = (categoryId, categories)=>{
    return Object.values(categories).some((existingCategory)=>existingCategory.id === categoryId);
};
module.exports["FEATURED_CATEGORY_ID"] = $1c68435f253b2047$export$b1a62972d9cddd78;
module.exports["MY_TEMPLATES_CATEGORY_ID"] = $1c68435f253b2047$export$5aacf8f53708daf0;
module.exports["STARRED_CATEGORY_ID"] = $1c68435f253b2047$export$c2a29eb4a43ff314;
module.exports["getCountedCategories"] = $1c68435f253b2047$export$d01d2d40a80eb4a1;
module.exports["isCategoryIdInCategories"] = $1c68435f253b2047$export$b36f54982a81becd;

});

parcelRegister("c2cyb", function(module, exports) {
/* TemplateIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3wBuN = parcelRequire("3wBuN");


var $esRft = parcelRequire("esRft");


var $gj7hi = parcelRequire("gj7hi");


var $chO1Z = parcelRequire("chO1Z");


var $dAyZN = parcelRequire("dAyZN");


var $8nXYN = parcelRequire("8nXYN");

const $41adb9ebadfabbfe$var$iconWrapperStyles = null;
const $41adb9ebadfabbfe$var$imageWrapperStyles = null;
const $41adb9ebadfabbfe$var$InjectedTemplateIcon = ({ template: template, isDisabled: isDisabled = false, size: size = 'medium' })=>{
    if (template.iconURL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-avatar",
        className: (0, $gMc0m.default)([
            "_1wpz1y6m"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: "square",
        size: size,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3wBuN.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        src: template.iconURL || '',
        srcDark: template.darkModeIconURL || ''
    })))));
    else if (template.styleClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAyZN.TemplateLegacyIcon), {
        size: size,
        template: template
    });
    else // Ideally, this code will never be used. However, if the BE response is missing an iconURL for some reason,
    // this will return an icon with a grey background color that looks like the icon for 3rd party templates.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8nXYN.DefaultIcon), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        spacing: "spacious",
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: ""
    }));
};
// The avatar-item component, which actually renders TemplateIcon, passes a backgroundColor
// prop to the TemplateIcon. The TemplateIcon and InjectedTemplateIcon disregard this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $41adb9ebadfabbfe$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template && prevProps.isDisabled === nextProps.isDisabled && prevProps.size === nextProps.size;
};
const $41adb9ebadfabbfe$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $42omo.memo)($41adb9ebadfabbfe$var$InjectedTemplateIcon, $41adb9ebadfabbfe$var$areEqual);
module.exports["TemplateIcon"] = $41adb9ebadfabbfe$export$17f8b5fdc0dde895;

});

parcelRegister("dAyZN", function(module, exports) {
/* TemplateLegacyIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $c41888ccf34d17d9$var$smallBackgroundSize = null;
const $c41888ccf34d17d9$var$mediumBackgroundSize = null;
const $c41888ccf34d17d9$var$largeBackgroundSize = null;
const $c41888ccf34d17d9$var$smallSize = null;
const $c41888ccf34d17d9$var$mediumSize = null;
const $c41888ccf34d17d9$var$largeSize = null;
const $c41888ccf34d17d9$var$styles = {
    classIconWrapperStyles: "_2mzuglyw",
    classIconStyles: "_2rkofajl",
    iconStyles: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
};
const $c41888ccf34d17d9$var$backgroundSizeMapping = {
    small: $c41888ccf34d17d9$var$smallBackgroundSize,
    medium: $c41888ccf34d17d9$var$mediumBackgroundSize,
    large: $c41888ccf34d17d9$var$largeBackgroundSize
};
const $c41888ccf34d17d9$var$sizeMapping = {
    small: $c41888ccf34d17d9$var$smallSize,
    medium: $c41888ccf34d17d9$var$mediumSize,
    large: $c41888ccf34d17d9$var$largeSize
}; // The avatar-item component, which actually renders TemplateLegacyIcon, passes a backgroundColor
// prop to the TemplateLegacyIcon. The TemplateLegacyIcon disregards this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $c41888ccf34d17d9$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template;
};
const $c41888ccf34d17d9$export$7da270837ef49506 = /*#__PURE__*/ (0, $42omo.memo)(({ template: template, size: size = 'medium' })=>{
    const styleClass = template.styleClass || '';
    const itemModuleCompleteKey = template.itemModuleCompleteKey || '';
    const blueprintModuleCompleteKey = template.blueprintModuleCompleteKey || '';
    const contentBlueprintId = template.contentBlueprintId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            $c41888ccf34d17d9$var$styles.classIconWrapperStyles,
            "template"
        ]),
        "data-item-module-complete-key": itemModuleCompleteKey,
        "data-blueprint-module-complete-key": blueprintModuleCompleteKey,
        "data-content-blueprint-id": contentBlueprintId,
        "data-testid": "template-icon-legacy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            "_17261kzg _17lp134g _15d44clk",
            "_17261772 _17lp1wkm _15d4zabe",
            $c41888ccf34d17d9$var$styles.classIconStyles,
            styleClass
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($c41888ccf34d17d9$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($c41888ccf34d17d9$var$largeSize),
            "--_10y2yj4": (0, $7sObp.default)($c41888ccf34d17d9$var$smallBackgroundSize),
            "--_b7jail": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumBackgroundSize),
            "--_w9udt4": (0, $7sObp.default)($c41888ccf34d17d9$var$largeBackgroundSize)
        }
    }));
}, $c41888ccf34d17d9$var$areEqual);
module.exports["TemplateLegacyIcon"] = $c41888ccf34d17d9$export$7da270837ef49506;

});

parcelRegister("8nXYN", function(module, exports) {
/* TemplateIconStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $978a137b0603779d$var$defaultIconCss = null;
const $978a137b0603779d$var$smallSize = null;
const $978a137b0603779d$var$mediumSize = null;
const $978a137b0603779d$var$largeSize = null;
const $978a137b0603779d$var$iconStyles = null;
const $978a137b0603779d$var$sizeMapping = {
    small: $978a137b0603779d$var$smallSize,
    medium: $978a137b0603779d$var$mediumSize,
    large: $978a137b0603779d$var$largeSize
};
const $978a137b0603779d$export$d206ce4c12e8ddf6 = ({ children: children, size: size = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-default",
        className: (0, $gMc0m.default)([
            "_2rkofajl _ca0q1b66 _y3gn1h6o _bfhk1i45",
            "_17261kzg _17lp134g _15d44clk",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($978a137b0603779d$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($978a137b0603779d$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($978a137b0603779d$var$largeSize)
        }
    }, children);
};
module.exports["DefaultIcon"] = $978a137b0603779d$export$d206ce4c12e8ddf6;

});

parcelRegister("2w2Hu", function(module, exports) {
/**
 * These are loadable names that cross reference by multiple places.
 * They were kept as constants here instead of automatically generated for consistency.
 * ONLY put names here if they are going to be used in _mustPreloadWhenRenderingSPA.
 */ var $8cf96aaaf31dfd76$export$75ebf2388340a0ba = /*#__PURE__*/ function(MustPreloadLoadableNames) {
    MustPreloadLoadableNames["ClassicRendererLoader"] = "ClassicRendererLoader";
    MustPreloadLoadableNames["ClassicEditorContextProviderLoader"] = "ClassicEditorContextProviderLoader";
    MustPreloadLoadableNames["NativeCollabLoader"] = "NativeCollabLoader";
    MustPreloadLoadableNames["FullPageEditorLoader"] = "FullPageEditorLoader";
    MustPreloadLoadableNames["ViewPageRouteComponentLoader"] = "ViewPageRouteComponentLoader";
    MustPreloadLoadableNames["LivePageComponentLoader"] = "LivePageComponentLoader";
    MustPreloadLoadableNames["EditorByLineArea"] = "EditorByLineArea";
    return MustPreloadLoadableNames;
}({});
module.exports["MustPreloadLoadableNames"] = $8cf96aaaf31dfd76$export$75ebf2388340a0ba;

});

parcelRegister("cqCFf", function(module, exports) {
/* LiveSearchTemplate.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ /* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $kyKWe = parcelRequire("kyKWe");


var $jluld = parcelRequire("jluld");


var $3hOY6 = parcelRequire("3hOY6");

var $2gD2K = parcelRequire("2gD2K");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $6F6hl = parcelRequire("6F6hl");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $1AV5C = parcelRequire("1AV5C");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $b3dss = parcelRequire("b3dss");


var $3uWLy = parcelRequire("3uWLy");


var $afqWO = parcelRequire("afqWO");


var $lHQkL = parcelRequire("lHQkL");


var $3EYav = parcelRequire("3EYav");


var $047Sb = parcelRequire("047Sb");

const $ea51fe5225a56158$var$CONFLUENCE_ARI = 'ari:cloud:confluence::site/'; // Value of these constants is important for proper handling of input events for live search
const $ea51fe5225a56158$export$f96974a826589f12 = 'live-search-macro';
const $ea51fe5225a56158$export$914adcd8d06245e4 = 'search-macro-button';
const $ea51fe5225a56158$var$controlStyles = {
    root: "_bfw71uh4 _8vu41qi0 _irr3l4ek",
    focused: "_bfw7z0c1 _irr31j9a"
};
const $ea51fe5225a56158$var$MediumControl = ({ children: children, ...props })=>{
    return /*#__PURE__*/ $42omo.createElement((0, $3hOY6.components).Control, {
        ...props,
        xcss: (0, $1bHXt.cx)($ea51fe5225a56158$var$controlStyles.root, props.isFocused && $ea51fe5225a56158$var$controlStyles.focused)
    }, children);
};
const $ea51fe5225a56158$var$LargeControl = ({ children: children, ...props })=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ $42omo.createElement((0, $3hOY6.components).Control, {
        ...props,
        xcss: (0, $1bHXt.cx)($ea51fe5225a56158$var$controlStyles.root, props.isFocused && $ea51fe5225a56158$var$controlStyles.focused)
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: intl.formatMessage((0, $lHQkL.i18n).searchIconLabel),
        spacing: "spacious"
    }), children);
};
const $ea51fe5225a56158$var$mediumSizeWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $ea51fe5225a56158$var$largeSizeWrapperStyles = (0, $ecnYn.xcss)({
    padding: 'space.050',
    display: 'block'
});
const $ea51fe5225a56158$export$f43084e69a1ba6f6 = ({ config: config })=>{
    const scriptRef = (0, $42omo.useRef)(null);
    const selectRef = (0, $42omo.useRef)(null);
    const { size: size, placeholder: placeholder } = config;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const confluenceInstance = $ea51fe5225a56158$var$CONFLUENCE_ARI.concat(cloudId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [currentSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [searchResults, setSearchResults] = (0, $42omo.useState)([]);
    const [loadState, setLoadState] = (0, $42omo.useState)(true);
    const [searchInput, setSearchInput] = (0, $42omo.useState)('');
    const [menuIsOpen, setMenuOpen] = (0, $42omo.useState)(false);
    const [queryVersion, setQueryVersion] = (0, $42omo.useState)(0);
    const [searchSessionId, setSearchSessionId] = (0, $42omo.useState)((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    const intl = (0, $8C5kA.default)();
    const handleClickNavigate = (0, $3EYav.handleNavigate)();
    const nonceValue = window.__SSR_NONCE_VALUE__;
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isInEditMode = pageMode === (0, $cD1qu.PageMode).EDIT;
    (0, $42omo.useEffect)(()=>{
        const closeResultsOnResize = ()=>{
            setMenuOpen(false);
        };
        window.addEventListener('resize', closeResultsOnResize);
        return ()=>window.removeEventListener('resize', closeResultsOnResize);
    }, []);
    const updateResults = (0, $42omo.useCallback)((results)=>{
        setSearchResults(results);
        setQueryVersion(queryVersion + 1);
    }, [
        queryVersion
    ]);
    const handleMenuClose = (0, $42omo.useCallback)(()=>{
        setSearchInput(searchInput);
        setSearchResults(searchResults);
        setQueryVersion(0);
        setMenuOpen(false);
        setSearchSessionId((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    }, [
        searchInput,
        searchResults
    ]);
    const onChange = async (str)=>{
        const input = str;
        setSearchInput(input);
        if (input.length > 2) {
            setLoadState(true);
            const { results: results, size: size } = await (0, $b3dss.handleAGGSearch)({
                searchInput: input,
                config: config,
                currentSpaceKey: currentSpaceKey,
                confluenceInstance: confluenceInstance
            });
            updateResults(results);
            setLoadState(false);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'shown',
                    actionSubject: 'liveSearchResults',
                    actionSubjectId: 'liveSearchQueryResults',
                    source: 'liveSearch',
                    attributes: {
                        source: 'liveSearch',
                        searchSessionId: searchSessionId,
                        queryHash: (0, $1AV5C.hashDataWithSha1_DO_NOT_USE)(input),
                        queryVersion: queryVersion,
                        queryLength: input.length,
                        wordCount: input.split(/\s+/).length,
                        resultCount: size
                    }
                }
            }).fire();
        } else if (searchResults.length) setSearchResults([]);
    };
    const navigateHandler = (0, $42omo.useCallback)((obj)=>{
        const trigger = obj?.searchMore ? 'menuClick' : obj?.nativeEvent?.type === 'submit' ? 'shortcut' : 'click'; // will need to apply the same filter setting when navigate to advance page
        handleClickNavigate({
            searchMore: searchInput,
            searchResult: obj.searchResult,
            currentSpaceKey: currentSpaceKey,
            config: config,
            eventParams: {
                wordCount: searchInput.split(/\s+/).length,
                queryLength: searchInput.length,
                queryHash: (0, $1AV5C.hashDataWithSha1_DO_NOT_USE)(searchInput),
                trigger: trigger,
                queryVersion: queryVersion,
                searchSessionId: searchSessionId,
                pageId: contentId
            }
        });
    }, // Only searchInput and config may change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        searchInput,
        config
    ]);
    const handleActivateButtonOnKeydown = (event)=>{
        // Keyboard support for button: https://www.w3.org/TR/wai-aria-practices/examples/button/button.html
        // event.key spec: https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
        const ACTIVATE_BUTTON_KEYS = [
            'Enter',
            'Spacebar',
            ' '
        ]; // Stop the propagation of these keyboard events so users can activate the button using the keyboard without the editor handling it
        if (ACTIVATE_BUTTON_KEYS.includes(event?.key)) {
            event?.stopPropagation();
            event?.preventDefault();
            navigateHandler(event);
        }
    };
    const handleKeyDownOverride = (0, $42omo.useCallback)((e)=>{
        if ((e?.metaKey || e?.ctrlKey) && e?.key === 'a') e.stopPropagation();
    }, []);
    const MenuList = (props)=>{
        // corresponds to Search result format LSM setting
        const { additional: additional } = config;
        const extraInfo = additional === 'page excerpt' ? 'excerpt' : additional === 'none' ? 'none' : 'space';
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ $42omo.createElement("div", {
            style: props
        }, /*#__PURE__*/ $42omo.createElement((0, $afqWO.SearchResultsList), {
            searchResults: searchResults,
            searchInput: searchInput,
            onClick: navigateHandler,
            extraInfo: extraInfo,
            loading: loadState
        })));
    };
    const focusSelect = ()=>{
        selectRef.current?.focus();
    };
    return /*#__PURE__*/ $42omo.createElement((0, $3uWLy.LiveSearchWrapper), {
        title: intl.formatMessage((0, $lHQkL.i18n).liveSearchTooltip),
        "data-fabric-macro": config?.macroId,
        "data-macro-body": true,
        "data-macro-parameters": JSON.stringify({
            currentSpaceKey: currentSpaceKey,
            ...config
        })
    }, /*#__PURE__*/ $42omo.createElement((0, $3uWLy.SearchMacro), {
        isLarge: size === 'large'
    }, /*#__PURE__*/ $42omo.createElement("form", {
        onSubmit: navigateHandler
    }, /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: size === 'large' ? $ea51fe5225a56158$var$largeSizeWrapperStyles : $ea51fe5225a56158$var$mediumSizeWrapperStyles
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: "search-macro-query",
        onClick: focusSelect
    }, /*#__PURE__*/ $42omo.createElement((0, $6F6hl.default), null, /*#__PURE__*/ $42omo.createElement("label", {
        htmlFor: "live-search-select"
    }, intl.formatMessage((0, $lHQkL.i18n).liveSearchLabel))), /*#__PURE__*/ $42omo.createElement((0, $2gD2K.default), {
        isDisabled: isInEditMode,
        inputId: "live-search-select",
        classNamePrefix: $ea51fe5225a56158$export$f96974a826589f12,
        ref: selectRef,
        placeholder: placeholder || intl.formatMessage((0, $lHQkL.i18n).liveSearchLabel),
        inputValue: searchInput,
        onInputChange: (input)=>{
            onChange(input);
        },
        onKeyDown: handleKeyDownOverride,
        menuIsOpen: searchInput.length > 2 ? menuIsOpen : false,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 2
                }),
            menu: (base)=>({
                    ...base,
                    overflowY: 'auto',
                    minWidth: '283px'
                }),
            placeholder: (base)=>({
                    ...base,
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                }),
            control: (base, state)=>({
                    ...base,
                    paddingLeft: size === 'large' ? "var(--ds-space-050, 4px)" : '0px',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)",
                    border: state.isFocused ? `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-selected, #1868DB)"}` : `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
                    borderRadius: "var(--ds-radius-medium, 6px)",
                    ':hover': {
                        backgroundColor: state.isFocused ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-input-hovered, #F8F8F8)",
                        border: state.isFocused ? `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-selected, #1868DB)"}` : `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
                        borderRadius: "var(--ds-radius-medium, 6px)"
                    }
                }),
            valueContainer: (base)=>({
                    ...base,
                    paddingLeft: size === 'large' ? "var(--ds-space-025, 2px)" : "var(--ds-space-100, 8px)"
                })
        },
        maxMenuHeight: 400,
        components: {
            MenuList: MenuList,
            DropdownIndicator: ()=>null,
            Control: size === 'large' ? $ea51fe5225a56158$var$LargeControl : $ea51fe5225a56158$var$MediumControl
        },
        menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
        onMenuOpen: ()=>setMenuOpen(true),
        onMenuClose: ()=>handleMenuClose()
    })), size !== 'large' && /*#__PURE__*/ $42omo.createElement((0, $3uWLy.StyledButton // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ), {
        className: $ea51fe5225a56158$export$914adcd8d06245e4,
        iconBefore: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            color: "var(--ds-icon-subtle, #505258)",
            label: intl.formatMessage((0, $lHQkL.i18n).searchIconLabel),
            spacing: "spacious"
        }),
        onClick: navigateHandler,
        onKeyDown: handleActivateButtonOnKeydown,
        appearance: "subtle",
        isDisabled: isInEditMode
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $lHQkL.i18n).liveSearchLabel))), /*#__PURE__*/ $42omo.createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        "data-test-id": "ssr-scripts-init",
        ref: scriptRef,
        dangerouslySetInnerHTML: {
            __html: (0, $047Sb.script)
        }
    }))));
};
module.exports["LIVE_SEARCH_SELECT_CLASSNAME_PREFIX"] = $ea51fe5225a56158$export$f96974a826589f12;
module.exports["LIVE_SEARCH_BUTTON_CLASSNAME"] = $ea51fe5225a56158$export$914adcd8d06245e4;
module.exports["LiveSearchTemplate"] = $ea51fe5225a56158$export$f43084e69a1ba6f6;

});

parcelRegister("b3dss", function(module, exports) {

var $gKr8t = parcelRequire("gKr8t");


var $coZY6 = parcelRequire("coZY6");


var $8scIT = parcelRequire("8scIT");


var $9Iq7b = parcelRequire("9Iq7b");

const $5ecb5a6b19c7b99a$export$f3881448ce6d41ab = async ({ searchInput: searchInput, config: config, currentSpaceKey: currentSpaceKey, confluenceInstance: confluenceInstance })=>{
    const aggClient = (0, $gKr8t.getAGGClient)();
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const results = await aggClient.query({
        query: (0, $9Iq7b.LiveSearchAGGQuery),
        ...(0, $coZY6.getQueryVariablesForAGGSearch)({
            searchInput: searchInput,
            config: config,
            currentSpaceKey: currentSpaceKey,
            confluenceInstance: confluenceInstance
        })
    }).then((response)=>response.data.search?.search?.edges.map((0, $8scIT.aggResultMapper)));
    return {
        results: results,
        size: results.length
    };
};
module.exports["handleAGGSearch"] = $5ecb5a6b19c7b99a$export$f3881448ce6d41ab;

});

parcelRegister("coZY6", function(module, exports) {

var $6Jc3U = parcelRequire("6Jc3U");

const $adcbb7eb47b613db$export$151b4a7c4fb38187 = 'confluence.liveSearchMacro';
const $adcbb7eb47b613db$export$8c6bf2df244e6a99 = '/wiki';
const $adcbb7eb47b613db$export$185e0f2aa1d225bd = 5;
const $adcbb7eb47b613db$export$5685b08df1669f19 = ',';
const $adcbb7eb47b613db$export$c94fdbf59dff15c8 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:comment',
    'ati:cloud:confluence:whiteboard',
    'ati:cloud:confluence:database',
    'ati:cloud:confluence:embed'
];
var $adcbb7eb47b613db$export$9da7f865fb841394 = /*#__PURE__*/ function(ConfluenceATIs) {
    ConfluenceATIs["PAGE"] = "ati:cloud:confluence:page";
    ConfluenceATIs["BLOG"] = "ati:cloud:confluence:blogpost";
    ConfluenceATIs["SPACE"] = "ati:cloud:confluence:space";
    ConfluenceATIs["COMMENT"] = "ati:cloud:confluence:comment";
    ConfluenceATIs["WHITEBOARD"] = "ati:cloud:confluence:whiteboard";
    ConfluenceATIs["DATABASE"] = "ati:cloud:confluence:database";
    ConfluenceATIs["EMBED"] = "ati:cloud:confluence:embed";
    return ConfluenceATIs;
}({});
const $adcbb7eb47b613db$export$36f2f1b03ac5f864 = ({ searchInput: searchInput, config: config, currentSpaceKey: currentSpaceKey, confluenceInstance: confluenceInstance })=>{
    const { type: type, spaceKey: spaceKey, labels: labels } = config;
    return {
        variables: {
            experience: $adcbb7eb47b613db$export$151b4a7c4fb38187,
            query: searchInput,
            first: $adcbb7eb47b613db$export$185e0f2aa1d225bd,
            filters: {
                entities: $adcbb7eb47b613db$export$e2e3f9f64b249105(type),
                locations: [
                    confluenceInstance
                ],
                confluenceFilters: (0, $6Jc3U.createAggFilters)(spaceKey, currentSpaceKey, labels)
            }
        }
    };
};
const $adcbb7eb47b613db$export$e2e3f9f64b249105 = (type)=>{
    let entities;
    switch(type){
        case 'page':
            entities = [
                "ati:cloud:confluence:page"
            ];
            break;
        case 'blogpost':
            entities = [
                "ati:cloud:confluence:blogpost"
            ];
            break;
        case 'spacedesc':
            entities = [
                "ati:cloud:confluence:space"
            ];
            break;
        case 'comment':
            entities = [
                "ati:cloud:confluence:comment"
            ];
            break;
        case 'whiteboard':
            entities = [
                "ati:cloud:confluence:whiteboard"
            ];
            break;
        case 'database':
            entities = [
                "ati:cloud:confluence:database"
            ];
            break;
        case 'embed':
            entities = [
                "ati:cloud:confluence:embed"
            ];
            break;
        default:
            entities = $adcbb7eb47b613db$export$c94fdbf59dff15c8;
    }
    return entities;
};
module.exports["CONTEXT_PATH"] = $adcbb7eb47b613db$export$8c6bf2df244e6a99;
module.exports["LABEL_FILTER_SEPARATOR"] = $adcbb7eb47b613db$export$5685b08df1669f19;
module.exports["getQueryVariablesForAGGSearch"] = $adcbb7eb47b613db$export$36f2f1b03ac5f864;

});

parcelRegister("6Jc3U", function(module, exports) {

var $coZY6 = parcelRequire("coZY6");

const $aa37c24e8c8ac542$export$416386056bdfd75 = (spaceKey, currentSpaceKey, labels)=>{
    const aggConfluenceFilters = {};
    const spaceFilterKey = !spaceKey ? undefined : spaceKey === 'currentSpace()' || spaceKey === '@self' ? currentSpaceKey : spaceKey;
    if (spaceFilterKey) aggConfluenceFilters.spacesFilter = [
        spaceFilterKey
    ];
    if (labels) {
        const labelFilters = labels.split((0, $coZY6.LABEL_FILTER_SEPARATOR));
        aggConfluenceFilters.labelsFilter = labelFilters;
    }
    return aggConfluenceFilters;
};
module.exports["createAggFilters"] = $aa37c24e8c8ac542$export$416386056bdfd75;

});

parcelRegister("8scIT", function(module, exports) {

var $coZY6 = parcelRequire("coZY6");

const $8125818ec3b81d48$export$a9c9cad42c57a90d = ({ node: result })=>({
        id: result.id,
        title: result.title,
        excerpt: result.excerpt || '',
        spaceName: result.space?.name || '',
        type: result.type,
        url: $8125818ec3b81d48$export$d449648a99616a75(result.url)
    });
const $8125818ec3b81d48$export$d449648a99616a75 = (url)=>{
    const splitUrl = url.split((0, $coZY6.CONTEXT_PATH));
    return splitUrl[splitUrl.length - 1];
};
module.exports["aggResultMapper"] = $8125818ec3b81d48$export$a9c9cad42c57a90d;

});

parcelRegister("9Iq7b", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $81d0624ec89d8158$export$2e4dd49df62f357f = (0, $eSUdr.default)`query LiveSearchAGGQuery($experience:String!$query:String!$first:Int$filters:SearchFilterInput!){search{search(experience:$experience query:$query first:$first filters:$filters){edges{node{id title type url ...on SearchConfluencePageBlogAttachment{excerpt space{name}}}}}}}`;
module.exports["LiveSearchAGGQuery"] = $81d0624ec89d8158$export$2e4dd49df62f357f;

});

parcelRegister("3uWLy", function(module, exports) {
/* LiveSearchElementStructure.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");

const $bd32abb04a95f4ca$export$a1c423cec4871ad1 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4v77o _1bsb1osq _p12f1osq _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $bd32abb04a95f4ca$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1w90i7uo _qop31e5h _149mu2gc _16hgi8nm _btpd1ylp _if291txw _1kba1h6o",
            __cmplp.className
        ])
    });
});
const $bd32abb04a95f4ca$export$6d263636989f6ae8 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLarge: isLarge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c82smr _1e0c1o8l _p12f1osq",
            __cmplp.isLarge ? "_1bsb1ogm _8e9gh2mm _11lwglyw _vj0by152 _1y9uglyw _1phytdg6 _w4u1stnw _mbkzu2gc _kjd0rdoj _tj1p1ihb" : "_1bsb1m8p _11lw1e5h _zi7q1ujv _tr7mglyw",
            __cmplp.className
        ])
    });
});
const $bd32abb04a95f4ca$var$SearchMacroMedium = null;
const $bd32abb04a95f4ca$var$SearchMacroLarge = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$fb9f58ebe9de6283 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$1917b7d8b72b7e9c = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0q1l7b _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$41596f83281a8833 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41pyq _1tke1gkc _kqswh2mm _y3gn1e5h _1e0c1txw _2lx2vrvc _19ysutpp _7mmmutpp _irr319i6 _d0altlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$31f0069b8e88f592 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81o8v _1reo15vq _18m915vq _syazazsu _19pkv77o _c71l1f4h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$fcde7feadcb5c60d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81o8v _syazazsu _19pkv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$904a9954c9f03ce2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _1tke163w _1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _7axpzws8 _mezj1st9 _bna712cx",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$7c3018f441722857 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8zdiv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$ec0f4e517a3a36ce = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i163w _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$7d1f3ef9e605f458 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41w7u _x3doia51 _bfhk1bhr _c71lgktf _y3gn1e5h _kqsw1if8 _94n5idpf _irr36o2t _d0altlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$2d2e4766151d9035 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazi7uo _1r5pmoej",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$1b51c6466e79404f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazi7uo _1kibidpf _1laeidpf _1f5yidpf _kq8jidpf _1695idpf _1pnsidpf _vktqidpf _1byqidpf _1ilx1ule",
            __cmplp.className
        ])
    });
});
module.exports["LiveSearchWrapper"] = $bd32abb04a95f4ca$export$a1c423cec4871ad1;
module.exports["StyledButton"] = $bd32abb04a95f4ca$export$2d5d2ba3c7c8c40b;
module.exports["SearchMacro"] = $bd32abb04a95f4ca$export$6d263636989f6ae8;
module.exports["SearchResultIconWrapper"] = $bd32abb04a95f4ca$export$1917b7d8b72b7e9c;
module.exports["SearchResultNormalWrapper"] = $bd32abb04a95f4ca$export$41596f83281a8833;
module.exports["SearchResultExcerpt"] = $bd32abb04a95f4ca$export$31f0069b8e88f592;
module.exports["SearchResultSpace"] = $bd32abb04a95f4ca$export$fcde7feadcb5c60d;
module.exports["SearchNoResultWrapper"] = $bd32abb04a95f4ca$export$904a9954c9f03ce2;
module.exports["TextWrapper"] = $bd32abb04a95f4ca$export$7c3018f441722857;
module.exports["SearchLoadWrapper"] = $bd32abb04a95f4ca$export$ec0f4e517a3a36ce;
module.exports["SearchResultMoreWrapper"] = $bd32abb04a95f4ca$export$7d1f3ef9e605f458;
module.exports["TextContentBold"] = $bd32abb04a95f4ca$export$2d2e4766151d9035;
module.exports["TextContent"] = $bd32abb04a95f4ca$export$1b51c6466e79404f;

});

parcelRegister("afqWO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7gG00 = parcelRequire("7gG00");


var $cElcb = parcelRequire("cElcb");


var $8z70D = parcelRequire("8z70D");


var $dkccs = parcelRequire("dkccs");

const $6cd4a3afa36bda77$export$92697b2a267ec7ef = ({ searchResults: searchResults, searchInput: searchInput, onClick: onClick, loading: loading, extraInfo: extraInfo })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gG00.SearchLoading), null) : searchResults.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, searchResults.map((result)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cElcb.SearchResult), {
            searchResult: result,
            onClick: onClick,
            extraInfo: extraInfo,
            key: result.id
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dkccs.SearchResultMore), {
        onClick: onClick,
        searchInput: searchInput
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8z70D.SearchNoResults), null));
module.exports["SearchResultsList"] = $6cd4a3afa36bda77$export$92697b2a267ec7ef;

});

parcelRegister("7gG00", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $3uWLy = parcelRequire("3uWLy");

const $8f0e2446176068a1$export$8934683688a2f019 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.SearchLoadWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "small"
    }));
module.exports["SearchLoading"] = $8f0e2446176068a1$export$8934683688a2f019;

});

parcelRegister("cElcb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6p02T = parcelRequire("6p02T");


var $3uWLy = parcelRequire("3uWLy");


var $7pRSN = parcelRequire("7pRSN");

const $c20f7d4a6116fd22$export$a2def421b23768aa = ({ searchResult: searchResult, onClick: onClick, extraInfo: extraInfo })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.SearchResultNormalWrapper), {
        onClick: ()=>onClick({
                searchResult: searchResult.url
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.SearchResultIconWrapper), {
        contentType: searchResult.type
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7pRSN.SearchResultTypeIcon), {
        contentType: searchResult.type
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, (0, $6p02T.enrichExcerpt)(searchResult.title)), extraInfo === 'excerpt' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.SearchResultExcerpt), null, (0, $6p02T.processExcerpt)(searchResult.excerpt)), extraInfo === 'space' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.SearchResultSpace), null, (0, $6p02T.enrichExcerpt)(searchResult.type !== 'space' ? searchResult.spaceName : searchResult.title))));
module.exports["SearchResult"] = $c20f7d4a6116fd22$export$a2def421b23768aa;

});

parcelRegister("6p02T", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iXCQx = parcelRequire("iXCQx");

const $3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?\/\[\]_\-+=`~\|:;{}\\]+/;
const $3cbad44d75de57c9$export$16c2ab98757b54d6 = (excerpt)=>{
    excerpt = excerpt.trim();
    if (!excerpt) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text -- can't use primitives here
    return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            key: "empty"
        })
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipses prefix if beginning of excerpt isn't a URL and begins with a lowercase letter (unbolded or bolded)
    if (!beginsWithUrl && (!beginsWithHighlight && excerpt[0] && excerpt[0] === excerpt[0].toLowerCase() || beginsWithHighlight && excerpt[8] && excerpt[8] === excerpt[8].toLowerCase())) excerpt = '...'.concat(excerpt);
    // Add elipses suffix if excerpt doesn't end with ending punctuation
    if (!excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with seperators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $3cbad44d75de57c9$export$b847312d69858d61(excerpt);
};
const $3cbad44d75de57c9$export$b847312d69858d61 = (excerpt)=>{
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        // @ts-expect-error - TS1501 Typescript 5.9.2 upgrade
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                key: excerpt
            }, excerpt));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            key: `pre-${i}`
        }, pre));
        if (textMatch) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "strong",
            key: `textMatch-${i}`
        }, textMatch));
        i++;
    }
    return res;
};
const $3cbad44d75de57c9$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
module.exports["processExcerpt"] = $3cbad44d75de57c9$export$16c2ab98757b54d6;
module.exports["enrichExcerpt"] = $3cbad44d75de57c9$export$b847312d69858d61;
module.exports["cleanExcerpt"] = $3cbad44d75de57c9$export$7512fe8206a7f75b;

});

parcelRegister("7pRSN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxQwS = parcelRequire("hxQwS");


var $41GKb = parcelRequire("41GKb");


var $9lz2c = parcelRequire("9lz2c");


var $13WX1 = parcelRequire("13WX1");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $duwSm = parcelRequire("duwSm");

const $d0c35681f27804ef$export$73b9ddc99f37f785 = ({ contentType: contentType })=>{
    switch(contentType){
        case 'blogpost':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hxQwS.default), {
                label: "page icon"
            });
        case 'image':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($41GKb))), {
                label: "page icon"
            });
        case 'attachment':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9lz2c))), {
                label: "page icon",
                spacing: "spacious"
            });
        case 'whiteboard':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))), {
                label: "whiteboard icon"
            });
        case 'database':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))), {
                label: "database icon"
            });
        case 'embed':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($duwSm))), {
                label: "embed icon"
            });
        case 'page':
        case 'comment':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $13WX1.default), {
                label: "page icon"
            });
    }
};
module.exports["SearchResultTypeIcon"] = $d0c35681f27804ef$export$73b9ddc99f37f785;

});

parcelRegister("8z70D", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $3uWLy = parcelRequire("3uWLy");


var $b4T2n = parcelRequire("b4T2n");


var $lHQkL = parcelRequire("lHQkL");

const $d23f3d633ea38e93$export$8e56e0a68b41e69c = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.SearchNoResultWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b4T2n))),
        alt: intl.formatMessage((0, $lHQkL.i18n).searchIconLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.TextWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.TextContentBold), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $lHQkL.i18n).liveSearchSelectNoResult1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.TextContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $lHQkL.i18n).liveSearchSelectNoResult2))));
};
module.exports["SearchNoResults"] = $d23f3d633ea38e93$export$8e56e0a68b41e69c;

});

parcelRegister("b4T2n", function(module, exports) {
module.exports = new URL("searchError.f24f82b3.svg", import.meta.url).toString();

});

parcelRegister("lHQkL", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $3004d3bb8ead7d7b$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    liveSearchLabel: {
        id: "live-search.label",
        defaultMessage: "Search"
    },
    liveSearchTooltip: {
        id: "live-search.tooltip",
        defaultMessage: "Live Search Macro"
    },
    liveSearchSelectSearchMore: {
        id: "live-search.search-more",
        defaultMessage: "See more search results"
    },
    liveSearchSelectNoResult1: {
        id: "live-search.no-result-1",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We couldn't find anything matching your search"
    },
    liveSearchSelectNoResult2: {
        id: "live-search.no-result-2",
        defaultMessage: "Try again with a different term"
    },
    searchIconLabel: {
        id: "live-search.search-icon-label",
        defaultMessage: "Magnifying glass"
    }
});
module.exports["i18n"] = $3004d3bb8ead7d7b$export$a7357cdd1f0b0168;

});

parcelRegister("dkccs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $3uWLy = parcelRequire("3uWLy");


var $lHQkL = parcelRequire("lHQkL");

const $b4fc439cf581a678$export$37d81fcf1a4df7fc = ({ onClick: onClick, searchInput: searchInput })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.SearchResultMoreWrapper), {
        onClick: ()=>onClick({
                searchMore: searchInput
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $lHQkL.i18n).liveSearchSelectSearchMore));
module.exports["SearchResultMore"] = $b4fc439cf581a678$export$37d81fcf1a4df7fc;

});

parcelRegister("3EYav", function(module, exports) {
// handleNavigate does called in react component
/* eslint-disable react-hooks/rules-of-hooks */ 
var $inPa6 = parcelRequire("inPa6");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $1b86c7896a2c63d8$export$efe49016b6e93b85 = ()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return ({ searchMore: searchMore, searchResult: searchResult, currentSpaceKey: currentSpaceKey, config: config, eventParams: eventParams })=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'liveSearch',
                source: 'liveSearch',
                actionSubjectId: 'liveSearchButtonClicked',
                objectId: eventParams?.pageId,
                attributes: {
                    destination: !searchResult ? 'advanced_search' : 'user_defined',
                    trigger: eventParams?.trigger || 'click',
                    source: 'liveSearch',
                    searchSessionId: eventParams?.searchSessionId || undefined,
                    navigation: searchMore ? 'postQuery' : 'preQuery'
                }
            }
        }).fire();
        if (searchMore !== undefined && !searchResult) {
            const { spaceKey: spaceKey, type: type, labels: labels } = config;
            let typeQuery;
            let spaces;
            if (spaceKey === 'currentSpace()' || spaceKey === '@self') spaces = `&spaces=${currentSpaceKey}`;
            else if (spaceKey) spaces = `&spaces=${spaceKey}`;
            if (type === 'spacedesc') typeQuery = '&type=space';
            else if (type) typeQuery = `&type=${type}`;
            const appliedLabels = labels ? `&labels=${labels}` : '';
            push(`${(0, $1NBp8.ADVANCED_SEARCH).toUrl()}?text=${searchMore}${spaces || ''}${typeQuery || ''}${appliedLabels}`);
        } else {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'selected',
                    actionSubject: 'liveSearchResult',
                    actionSubjectId: 'liveSearchQueryResult',
                    source: 'liveSearch',
                    attributes: {
                        source: 'liveSearch',
                        searchSessionId: eventParams?.searchSessionId,
                        queryHash: eventParams?.queryHash,
                        queryVersion: eventParams?.queryVersion,
                        queryLength: eventParams?.queryLength,
                        wordCount: eventParams?.wordCount
                    }
                }
            }).fire();
            push(`${(0, $1NBp8.WIKI).toUrl()}${searchResult}`);
        }
    };
};
module.exports["handleNavigate"] = $1b86c7896a2c63d8$export$efe49016b6e93b85;

});

parcelRegister("047Sb", function(module, exports) {
/* eslint-disable */ // @ts-ignore
const $4e16e09ee5d4c2a8$export$bc237d627614fc48 = `!function(e,a){a.liveSearchInput={};var t,c=e.querySelectorAll("div[title='Live Search Macro']"),r=c[c.length-1],n=r.getElementsByTagName("form")[0],i=r.getElementsByTagName("button")[0],l=r.getElementsByTagName("input")[0],s=r.attributes,p="";Array.prototype.slice.call(s).forEach(function(e){"data-macro-parameters"===e.name&&(t=JSON.parse(e.value))});var e=t||{},c=e.spaceKey,r=e.type,s=e.currentSpaceKey,u=e.macroId,o="",m="";function v(e){var t="/wiki/search?text="+p+m+o;a.location.href=t,e.preventDefault()}function y(e,t,a){e&&e.addEventListener(t,a)}"currentSpace()"===c||"@self"===c?m="&spaces="+s:c&&(m="&spaces="+c),"spacedesc"===r?o="&type=space":r&&(o="&type="+r),y(n,"submit",v),y(i,"click",v),y(l,"input",function(e){p=e.target.value,u&&(a.liveSearchInput[u]=p)})}(document,window);`;
module.exports["script"] = $4e16e09ee5d4c2a8$export$bc237d627614fc48;

});

parcelRegister("31HPn", function(module, exports) {
const $23fc703b824b091d$export$38c6526d67de94bb = 'xen:macro';
const $23fc703b824b091d$export$8d4b803281599c6a = 'com.atlassian.ecosystem';
const $23fc703b824b091d$export$d7168699755008a = 'com.atlassian.confluence.macro.core';
const $23fc703b824b091d$export$46fc26821adc3495 = 'connectAddon';
const $23fc703b824b091d$export$95077f102dafd025 = 'migratedServerP2Addon';
const $23fc703b824b091d$export$981e47da3e2dfc13 = 'bodiedExtension';
const $23fc703b824b091d$export$4506b39eefa6dc94 = 'multiBodiedExtension';
const $23fc703b824b091d$export$d2cde58d8ae019a9 = 'forge.ui.extension';
const $23fc703b824b091d$export$bf4c163a4c708db1 = 'forgeDocUpdated';
module.exports["MODULE_NAME"] = $23fc703b824b091d$export$38c6526d67de94bb;
module.exports["EXTENSION_NAMESPACE"] = $23fc703b824b091d$export$8d4b803281599c6a;
module.exports["P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE"] = $23fc703b824b091d$export$d7168699755008a;
module.exports["CONNECT_ADDON_ACTION_SUBJECT"] = $23fc703b824b091d$export$46fc26821adc3495;
module.exports["MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT"] = $23fc703b824b091d$export$95077f102dafd025;
module.exports["EXTENSION_TYPE_MULTI_BODIED"] = $23fc703b824b091d$export$4506b39eefa6dc94;
module.exports["FORGE_EXTENSION"] = $23fc703b824b091d$export$d2cde58d8ae019a9;
module.exports["FORGE_DOC_UPDATED_EVENT"] = $23fc703b824b091d$export$bf4c163a4c708db1;

});

parcelRegister("8cOoD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $cpjd2 = parcelRequire("cpjd2");


var $gEtAQ = parcelRequire("gEtAQ");


var $fySJw = parcelRequire("fySJw");


var $3LvmY = parcelRequire("3LvmY");

const $198de0e1d1f1ab22$export$f1a6c160e5107221 = 'dataProvider';
const $198de0e1d1f1ab22$export$57b0f508e89cfdbb = ({ connectHost: connectHost })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const isViewPage = (0, $gEtAQ.isViewPage)();
        $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
            connectHost: connectHost,
            createAnalyticsEvent: createAnalyticsEvent,
            isViewPage: isViewPage
        });
    }, [
        connectHost,
        createAnalyticsEvent
    ]);
    return null;
};
const $198de0e1d1f1ab22$export$594716b2dbd4f0f9 = ()=>!!window['connectHost']?.isModuleDefined($198de0e1d1f1ab22$export$f1a6c160e5107221);
const $198de0e1d1f1ab22$export$eb1900d465fb2cb9 = ({ connectHost: connectHost, createAnalyticsEvent: createAnalyticsEvent, isViewPage: isViewPage })=>{
    const isDPModuleDefined = $198de0e1d1f1ab22$export$594716b2dbd4f0f9();
    const dataProviderModule = {
        emitToDataProvider: async (...args)=>{
            const data = args.length > 1 ? args[0] : null;
            const sendResponse = args.length > 1 ? args[args.length - 1] : args[0];
            const context = sendResponse?._context;
            const fragmentLocalId = context?.extension?.options?.productContext?.['macro.fragmentLocalId'];
            const extensionKey = context?.extension?.key;
            const event = (0, $3LvmY.getReceivedConnectRefDataEvent)({
                isViewPage: isViewPage,
                extensionKey: extensionKey
            });
            createAnalyticsEvent(event).fire();
            if (!extensionKey) throw Error('Missing Connect app extensionKey while transferring data.');
            const connectDataListener = (0, $fySJw.getConnectDataListener)();
            const status = await connectDataListener.transfer(extensionKey, fragmentLocalId, data, createAnalyticsEvent, isViewPage);
            return sendResponse(status);
        }
    };
    if (!isDPModuleDefined) connectHost.defineModule($198de0e1d1f1ab22$export$f1a6c160e5107221, dataProviderModule);
};
const $198de0e1d1f1ab22$export$8738a87451e0e0f8 = async ({ logger: logger, isViewPage: isViewPage, createAnalyticsEvent: createAnalyticsEvent })=>{
    await new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)([
            'wr!confluence.web.resources:querystring',
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            const connectHost = window['connectHost'];
            $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
                connectHost: connectHost,
                createAnalyticsEvent: createAnalyticsEvent,
                isViewPage: isViewPage
            });
            resolve();
        }, ()=>{
            logger.error`Error loading WRM for dataProvider!`;
            resolve();
        });
    });
};
module.exports["DataProviderModule"] = $198de0e1d1f1ab22$export$57b0f508e89cfdbb;
module.exports["checkIsDPModuleDefined"] = $198de0e1d1f1ab22$export$594716b2dbd4f0f9;
module.exports["loadDataProviderModule"] = $198de0e1d1f1ab22$export$8738a87451e0e0f8;

});

parcelRegister("2ttXz", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable check-file/filename-blocklist */ var $2dbc47933025bd48$export$3b10d30805d4d939 = /*#__PURE__*/ function(ReactionLocation) {
    ReactionLocation["PAGE"] = "page";
    ReactionLocation["BLOGPOST"] = "blogpost";
    ReactionLocation["PAGE_COMMENT"] = "page-comment";
    ReactionLocation["INLINE_COMMENT"] = "inline-comment";
    ReactionLocation["EDITOR_INLINE_COMMENT"] = "editor-inline-comment";
    ReactionLocation["FEED_PAGE"] = "feed-page";
    ReactionLocation["FEED_BLOGPOST"] = "feed-blogpost";
    ReactionLocation["FEED_COMMENT"] = "feed-comment";
    ReactionLocation["OBJECT_COMMENT_FOOTER_PAGE"] = "object-comment-footer-page";
    ReactionLocation["OBJECT_COMMENT_FOOTER_BLOGPOST"] = "object-comment-footer-blogpost";
    return ReactionLocation;
}({});
var $2dbc47933025bd48$export$d86afc9493bb8e1 = /*#__PURE__*/ function(ReactionContainerType) {
    ReactionContainerType["PAGE"] = "page";
    ReactionContainerType["BLOGPOST"] = "blogpost";
    ReactionContainerType["SPACE"] = "space";
    return ReactionContainerType;
}({});
module.exports["ReactionLocation"] = $2dbc47933025bd48$export$3b10d30805d4d939;
module.exports["ReactionContainerType"] = $2dbc47933025bd48$export$d86afc9493bb8e1;

});

parcelRegister("1NF8X", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $bFPHx = parcelRequire("bFPHx");


var $5Kc7f = parcelRequire("5Kc7f");


const $032b81a28ff18608$export$96ee387620e23ced = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "XLglR",
    name: "ReactionsLoader",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), {
            useAccuratePills: true,
            ...props
        });
    },
    loader: async ()=>(await (parcelRequire("hPbEf"))).Reactions
});

const $032b81a28ff18608$export$ddfc48793728637f = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "4wRdk",
    name: "ReactionsLoaderBackground",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
    },
    loader: async ()=>(await (parcelRequire("hPbEf"))).Reactions
});
module.exports["ReactionsLoader"] = $032b81a28ff18608$export$96ee387620e23ced;
module.exports["ReactionsLoaderBackground"] = $032b81a28ff18608$export$ddfc48793728637f;

});

parcelRegister("bFPHx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $4FHTF = parcelRequire("4FHTF");


var $1s5hv = parcelRequire("1s5hv");


var $1qfLF = parcelRequire("1qfLF");


var $ep3mz = parcelRequire("ep3mz");

const $3ae84312c23de134$var$ReactionsPlaceholderQuery = (0, $eSUdr.default)`query ReactionsPlaceholderQuery($contentId:ID!){content(id:$contentId){nodes{id contentReactionsSummary{reactionsSummaryForEmoji{id}}}}}`;
const $3ae84312c23de134$var$placeholderContainerStyles = null;
const $3ae84312c23de134$var$reactionPillStyles = null;
const $3ae84312c23de134$var$reactionIconStyles = null;
const $3ae84312c23de134$var$DEFAULT_NUM_PILLS = 2;
const $3ae84312c23de134$export$47a91e92112986d6 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { useAccuratePills: useAccuratePills, onlyRenderPicker: onlyRenderPicker, customAnalyticsAttributes: customAnalyticsAttributes } = t0;
    const isSSR = window.__SSR_RENDERED__ || undefined;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = !isSSR || !useAccuratePills || !contentId || onlyRenderPicker;
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const { data: data, loading: loading } = (0, $xQxzY.useQuery)($3ae84312c23de134$var$ReactionsPlaceholderQuery, t3);
    if (loading) return null;
    let t4;
    if ($[5] !== customAnalyticsAttributes || $[6] !== onlyRenderPicker) {
        t4 = (numPills)=>onlyRenderPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                justifyContent: "center",
                alignItems: "center",
                testId: "reactions-picker-placeholder"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))),
                label: "",
                analyticsContext: {
                    name: "reactionsPicker",
                    ...customAnalyticsAttributes
                }
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "reactions-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _80om1x0y _19pkv77o _otyrv77o _18u0idpf"
                ])
            }, Array(numPills).fill("").map($3ae84312c23de134$var$_temp), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "data-testid": "reaction-icon",
                className: (0, $gMc0m.default)([
                    "_11q7vkf5 _2rko1rr0 _1bsb1crf _4t3i1crf _18u012x7"
                ])
            }));
        $[5] = customAnalyticsAttributes;
        $[6] = onlyRenderPicker;
        $[7] = t4;
    } else t4 = $[7];
    const renderPlaceholder = t4;
    if (isSSR) {
        const numDistinctReactions = data?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji.length;
        const numReactionPills = numDistinctReactions !== undefined ? numDistinctReactions : $3ae84312c23de134$var$DEFAULT_NUM_PILLS;
        let t5;
        if ($[8] !== numReactionPills || $[9] !== renderPlaceholder) {
            t5 = renderPlaceholder(numReactionPills);
            $[8] = numReactionPills;
            $[9] = renderPlaceholder;
            $[10] = t5;
        } else t5 = $[10];
        return t5;
    } else {
        let t5;
        if ($[11] !== renderPlaceholder) {
            t5 = renderPlaceholder($3ae84312c23de134$var$DEFAULT_NUM_PILLS);
            $[11] = renderPlaceholder;
            $[12] = t5;
        } else t5 = $[12];
        return t5;
    }
} : ({ useAccuratePills: useAccuratePills, onlyRenderPicker: onlyRenderPicker, customAnalyticsAttributes: customAnalyticsAttributes })=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = window.__SSR_RENDERED__ || undefined;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading } = (0, $xQxzY.useQuery)($3ae84312c23de134$var$ReactionsPlaceholderQuery, {
        variables: {
            contentId: contentId
        },
        // Only run this query if we're in SSR and useAccuratePills is set and not showing picker since doesn't use the pill UI
        skip: !isSSR || !useAccuratePills || !contentId || onlyRenderPicker
    });
    if (loading) return null;
     // Picker is only an icon and has no pills
    const renderPlaceholder = (numPills)=>onlyRenderPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            justifyContent: "center",
            alignItems: "center",
            testId: "reactions-picker-placeholder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))),
            label: "",
            analyticsContext: {
                name: 'reactionsPicker',
                ...customAnalyticsAttributes
            }
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "reactions-placeholder",
            className: (0, $gMc0m.default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o _80om1x0y _19pkv77o _otyrv77o _18u0idpf"
            ])
        }, Array(numPills).fill('').map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                key: i,
                "data-testid": "reactions-pill",
                className: (0, $gMc0m.default)([
                    "_11q7vkf5 _2rko1rr0 _1bsbor1b _4t3i1tcg _2hwx1b66"
                ])
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-testid": "reaction-icon",
            className: (0, $gMc0m.default)([
                "_11q7vkf5 _2rko1rr0 _1bsb1crf _4t3i1crf _18u012x7"
            ])
        })); // We only need to show accurate pills in SSR
    if (isSSR) {
        const numDistinctReactions = data?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji.length; // If we get a count of reactions use it, otherwise fall back to the default
        const numReactionPills = numDistinctReactions !== undefined ? numDistinctReactions : $3ae84312c23de134$var$DEFAULT_NUM_PILLS;
        return renderPlaceholder(numReactionPills);
    } else return renderPlaceholder($3ae84312c23de134$var$DEFAULT_NUM_PILLS);
};
function $3ae84312c23de134$var$_temp(_, i) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        key: i,
        "data-testid": "reactions-pill",
        className: (0, $gMc0m.default)([
            "_11q7vkf5 _2rko1rr0 _1bsbor1b _4t3i1tcg _2hwx1b66"
        ])
    });
}
module.exports["ReactionsPlaceholder"] = $3ae84312c23de134$export$47a91e92112986d6;

});

parcelRegister("5Kc7f", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");


var $eTjjM = parcelRequire("eTjjM");

const $aba7293523a7a5b0$var$styles = {
    emojiPlaceholderBackground: "_bfhkizff",
    wrapperStyles: "_19bvu2gc _u5f3utpp _19pk1i6y",
    countSkeletonStyles: "_2rko1rr0 _1bsb19bv _4t3i19bv _bfhkizff"
};
const $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS = {
    shortName: 'loading-placeholder',
    size: 16,
    xcss: $aba7293523a7a5b0$var$styles.emojiPlaceholderBackground
};
const $aba7293523a7a5b0$export$d85d0301f09f2005 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center",
            className: (0, $gMc0m.default)([
                $aba7293523a7a5b0$var$styles.wrapperStyles
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $aba7293523a7a5b0$var$styles.countSkeletonStyles
            ])
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center",
        className: (0, $gMc0m.default)([
            $aba7293523a7a5b0$var$styles.wrapperStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $aba7293523a7a5b0$var$styles.countSkeletonStyles
        ])
    }));
};
module.exports["ReactionsSummaryViewPlaceholder"] = $aba7293523a7a5b0$export$d85d0301f09f2005;

});

parcelRegister("hPbEf", function(module, exports) {

let $cfa03c2e3a6d522e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cfa03c2e3a6d522e$var$load("ioQAS"),
    $cfa03c2e3a6d522e$var$load("4Lgj0"),
    $cfa03c2e3a6d522e$var$load("kSJiq"),
    $cfa03c2e3a6d522e$var$load("6wr18"),
    $cfa03c2e3a6d522e$var$load("Wowvf"),
    $cfa03c2e3a6d522e$var$load("dxwAu"),
    $cfa03c2e3a6d522e$var$load("8JZKd"),
    $cfa03c2e3a6d522e$var$load("3ZGnz"),
    $cfa03c2e3a6d522e$var$load("ffEVr"),
    $cfa03c2e3a6d522e$var$load("7EorR"),
    $cfa03c2e3a6d522e$var$load("3EXzu"),
    $cfa03c2e3a6d522e$var$load("1C6qR")
]).then(()=>parcelRequire('kTkGJ'));

});

parcelRegister("ad6ZE", function(module, exports) {
var $bcdbc544cc3a5c22$export$2df6d049e5bad28e = /*#__PURE__*/ function(InlineCommentMode) {
    InlineCommentMode["EDIT"] = "edit";
    InlineCommentMode["VIEW"] = "view";
    InlineCommentMode["LIVE"] = "live";
    return InlineCommentMode;
}({});
module.exports["InlineCommentMode"] = $bcdbc544cc3a5c22$export$2df6d049e5bad28e;

});

parcelRegister("3s9yq", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $dc6096cce6b3b96b$export$8c4bf31cea6aa53c = (0, $eSUdr.default)`query InlineCommentsQuery($pageId:ID!)@allowHigherTimeout{content(id:$pageId){nodes{id type space{id}operations{operation targetType}}}comments(pageId:$pageId type:UNRESOLVED depth:ROOT first:1000){nodes{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}replies{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}}}}}`;
const $dc6096cce6b3b96b$export$3a8bc42d8791443d = (0, $eSUdr.default)`query InlineCommentsWithSpaceKeyQuery($spaceKey:String!){space(key:$spaceKey){id homepageComments(type:UNRESOLVED depth:ROOT){nodes{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}replies{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}}}}}spaceHomepage(spaceKey:$spaceKey){id type space{id}operations{operation targetType}}}`;
module.exports["InlineCommentsQuery"] = $dc6096cce6b3b96b$export$8c4bf31cea6aa53c;

});

parcelRegister("aMfLn", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");


var $kDIns = parcelRequire("kDIns");

const $194c389c7ab5ab2c$export$bbbd7ccaedea9691 = async ({ rendererActions: rendererActions, contentId: contentId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment })=>{
    const allAnnotationMarks = rendererActions?.getAnnotationMarks();
    const allAnnotationIds = allAnnotationMarks?.map((mark)=>mark.attrs.id) || [];
    (0, $kDIns.getRendererAnnotationStates)({
        annotations: allAnnotationIds,
        pageId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        validAnnotationsCallback: updateUnresolvedInlineComment,
        isNestedRender: false
    }).catch(()=>{
    //intentional no-op
    });
};
const $194c389c7ab5ab2c$export$2600439b3e609c06 = (step, pos)=>{
    // AddMarkStep has additional properties that aren't allowed in the mutation variables
    const markInfo = {
        mark: {
            attrs: {
                annotationType: 'inlineComment',
                id: step.mark.attrs.id
            },
            type: 'annotation'
        }
    };
    // TODO: remove this logic since pos should be read from step
    if (pos !== undefined) return {
        pos: pos,
        ...markInfo
    };
    if (step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep)) {
        const { from: from, to: to } = step;
        return {
            from: from,
            to: to,
            ...markInfo
        };
    }
    return {
        pos: step.pos,
        ...markInfo
    };
};
module.exports["updateRendererAnnotations"] = $194c389c7ab5ab2c$export$bbbd7ccaedea9691;
module.exports["constructStepForGql"] = $194c389c7ab5ab2c$export$2600439b3e609c06;

});

parcelRegister("6bd6t", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $2Nwuj = parcelRequire("2Nwuj");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $dpPtd = parcelRequire("dpPtd");


var $3sFtD = parcelRequire("3sFtD");


var $biiXa = parcelRequire("biiXa");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $fYQcF = parcelRequire("fYQcF");


var $9wGTI = parcelRequire("9wGTI");


var $b3j2Y = parcelRequire("b3j2Y");


var $bQm3c = parcelRequire("bQm3c");


var $7OLeD = parcelRequire("7OLeD");


var $PjC9c = parcelRequire("PjC9c");


var $dchHi = parcelRequire("dchHi");

const $6d65bb3bd17dd577$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $6d65bb3bd17dd577$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $6d65bb3bd17dd577$var$i18n = (0, $cgtv4.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Good response"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Bad response"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $6d65bb3bd17dd577$var$PrivacyPolicyLink = ({ link: link })=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__confluence-ai2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6d65bb3bd17dd577$var$i18n.privacyPolicyLink)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6d65bb3bd17dd577$var$i18n.privacyPolicyLink));
const $6d65bb3bd17dd577$var$ResearchGroupLink = ({ link: link })=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__confluence-ai2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6d65bb3bd17dd577$var$i18n.researchGroupLink)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6d65bb3bd17dd577$var$i18n.researchGroupLink));
const $6d65bb3bd17dd577$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$6d65bb3bd17dd577$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d65bb3bd17dd577$var$PrivacyPolicyLink, {
                link: $6d65bb3bd17dd577$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $6d65bb3bd17dd577$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$6d65bb3bd17dd577$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d65bb3bd17dd577$var$ResearchGroupLink, {
                link: $6d65bb3bd17dd577$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $6d65bb3bd17dd577$var$TooltipWrapperXCSS = (0, $ecnYn.xcss)({
    listStyle: 'none',
    marginTop: 'space.0'
});
const $6d65bb3bd17dd577$var$FeedbackIconXCSS = (0, $ecnYn.xcss)({
    marginRight: 'space.050'
});
const $6d65bb3bd17dd577$var$DislikeIconWrapperXCSS = (0, $ecnYn.xcss)({
    transform: 'rotate(180deg)'
});
const $6d65bb3bd17dd577$var$ButtonWrapperXCSS = (0, $ecnYn.xcss)({
    height: '24px',
    width: '24px'
});
const $6d65bb3bd17dd577$var$InlineULXCSS = (0, $ecnYn.xcss)({
    paddingLeft: 'space.0',
    display: 'flex'
});
const $6d65bb3bd17dd577$export$cbc8ab5712ed2bd3 = ({ analyticsProperties: analyticsProperties, contentId: contentId, spaceKey: spaceKey, summaryId: summaryId, summaryLocale: summaryLocale, feedbackTitle: feedbackTitle, feedbackSummaryPlaceholder: feedbackSummaryPlaceholder })=>{
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const feedbackCollectorProperties = (0, $dchHi.useFeedbackCollectorProperties)();
    const [sentiment, setSentiment] = (0, $42omo.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)();
    // Only fetch contributor info when contentId is provided (not for space-level feedback)
    const shouldFetchContributors = !!contentId;
    const contributorResult = (0, $PjC9c.useCurrentUserContributor)(contentId || '');
    const { isCurrentUserContributor: isCurrentUserContributor, contentContributorsError: contentContributorsError } = shouldFetchContributors ? contributorResult : {
        isCurrentUserContributor: undefined,
        contentContributorsError: undefined
    };
    const feedbackContextParts = [
        contentId && `contentId: ${contentId}`,
        spaceKey && `spaceKey: ${spaceKey}`,
        `sentiment: ${sentiment}`,
        `cloudId: ${cloudId}`,
        `isCurrentUserContributor: ${isCurrentUserContributor}`,
        feedbackCollectorProperties.feedbackContext.length > 0 && feedbackCollectorProperties.feedbackContext
    ].filter(Boolean);
    const feedbackContextString = feedbackContextParts.join(' ');
    (0, $42omo.useEffect)(()=>{
        if (isFeedbackOpen) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: `${analyticsProperties.source}FeedbackCollectorDialog`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    sentiment: sentiment,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isFeedbackOpen,
        contentId,
        spaceKey,
        summaryId,
        summaryLocale,
        sentiment,
        analyticsProperties
    ]);
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($6d65bb3bd17dd577$var$i18n.flagTitle),
            description: formatMessage($6d65bb3bd17dd577$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const onLikeClicked = ()=>{
        setIsFeedbackOpen(true);
        setSentiment('good');
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}LikeButton`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
        trackAIFeedbackSubmit('up');
    };
    const onDislikeClicked = ()=>{
        setIsFeedbackOpen(true);
        setSentiment('bad');
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}DislikeButton`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
        trackAIFeedbackSubmit('down');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}SubmitFeedbackButton`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    sentiment: sentiment,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
    };
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "ul",
        xcss: $6d65bb3bd17dd577$var$InlineULXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "li",
        xcss: [
            $6d65bb3bd17dd577$var$TooltipWrapperXCSS,
            $6d65bb3bd17dd577$var$FeedbackIconXCSS
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($6d65bb3bd17dd577$var$i18n.likeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $6d65bb3bd17dd577$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        "aria-label": formatMessage($6d65bb3bd17dd577$var$i18n.likeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7OLeD.ThumbsIcon), {
            isSelected: hasGoodFeedbackBeenSubmitted
        }),
        onClick: onLikeClicked,
        testId: "feedback-like-button",
        isDisabled: hasGoodFeedbackBeenSubmitted
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "li",
        xcss: [
            $6d65bb3bd17dd577$var$TooltipWrapperXCSS,
            $6d65bb3bd17dd577$var$FeedbackIconXCSS
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($6d65bb3bd17dd577$var$i18n.dislikeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $6d65bb3bd17dd577$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        "aria-label": formatMessage($6d65bb3bd17dd577$var$i18n.dislikeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $6d65bb3bd17dd577$var$DislikeIconWrapperXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7OLeD.ThumbsIcon), {
            isSelected: hasBadFeedbackBeenSubmitted
        })),
        onClick: onDislikeClicked,
        testId: "feedback-dislike-button",
        isDisabled: hasBadFeedbackBeenSubmitted
    }))))), isFeedbackOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biiXa.default), {
        locale: feedbackCollectorProperties.locale,
        onSubmit: onFeedbackSubmit,
        onClose: ()=>setIsFeedbackOpen(false),
        atlassianAccountId: feedbackCollectorProperties.userId,
        name: feedbackCollectorProperties.displayName,
        entrypointId: feedbackCollectorProperties.entrypointId,
        summaryPlaceholder: formatMessage(feedbackSummaryPlaceholder ?? $6d65bb3bd17dd577$var$i18n.feedbackSummaryPlaceholder),
        additionalFields: [
            {
                id: feedbackCollectorProperties.feedbackContextId,
                value: feedbackContextString
            }
        ],
        feedbackTitle: formatMessage(feedbackTitle ?? $6d65bb3bd17dd577$var$i18n.feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage($6d65bb3bd17dd577$var$i18n.feedbackSummaryTitle),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d65bb3bd17dd577$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d65bb3bd17dd577$var$EnrolLabel, null)
    })), contentContributorsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentContributorsError
    })));
};
module.exports["SmartsFeedbackComponent"] = $6d65bb3bd17dd577$export$cbc8ab5712ed2bd3;

});

parcelRegister("7OLeD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9FnLD = parcelRequire("9FnLD");

const $e94a9fb89963bcaa$export$1337fc502d44e2c0 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        spacing: "spacious",
        label: ""
    });
module.exports["ThumbsIcon"] = $e94a9fb89963bcaa$export$1337fc502d44e2c0;

});

parcelRegister("PjC9c", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");

const $03062ed3aa730446$var$useCurrentUserContributorContentContributorsQuery = (0, $eSUdr.default)`query useCurrentUserContributorContentContributorsQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}}`;
const $03062ed3aa730446$export$b7b7e80a2f61884d = (contentId)=>{
    const { data: data, loading: contentContributorsLoading, error: contentContributorsError } = (0, $j1Ss3.useQuery)($03062ed3aa730446$var$useCurrentUserContributorContentContributorsQuery, {
        variables: {
            contentId: contentId
        }
    });
    const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor ?? undefined;
    return {
        isCurrentUserContributor: isCurrentUserContributor,
        contentContributorsLoading: contentContributorsLoading,
        contentContributorsError: contentContributorsError
    };
};
module.exports["useCurrentUserContributor"] = $03062ed3aa730446$export$b7b7e80a2f61884d;

});

parcelRegister("dchHi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $bQm3c = parcelRequire("bQm3c");

const $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $e12d220a6c6e853e$export$5b0d1a23cf38988 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $e12d220a6c6e853e$export$eecedbc46bd36460 = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { displayName: sessionDisplayName, userId: sessionUserId } = (0, $bQm3c.useSessionData)();
    const { locale: intlLocale } = (0, $8C5kA.default)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $42omo.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId || sessionUserId || undefined,
            displayName: displayName || sessionDisplayName || undefined
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        sessionUserId,
        displayName,
        sessionDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e12d220a6c6e853e$export$5b0d1a23cf38988.Provider, {
        value: contextValue
    }, children);
};
const $e12d220a6c6e853e$export$e8f7cf9dc2b23528 = ()=>{
    const context = (0, $42omo.useContext)($e12d220a6c6e853e$export$5b0d1a23cf38988);
    if (context === undefined) throw new Error('useFeedbackCollectorProperties must be used within a FeedbackCollectorPropertiesProvider');
    return context;
};
module.exports["FeedbackCollectorPropertiesProvider"] = $e12d220a6c6e853e$export$eecedbc46bd36460;
module.exports["useFeedbackCollectorProperties"] = $e12d220a6c6e853e$export$e8f7cf9dc2b23528;

});

parcelRegister("4r9Ir", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7IghX = parcelRequire("7IghX");

const $4ae3b5b25efc2fdf$export$c465d99c658013a3 = /*#__PURE__*/ (0, $42omo.createContext)({
    newCommentPositions: [],
    addNewComment: ()=>{},
    removeComment: ()=>{},
    acknowledgeComment: ()=>{},
    acknowledgeComments: ()=>{},
    clearNewComments: ()=>{}
});
const $4ae3b5b25efc2fdf$var$getCommentScreenPosition = (commentId)=>{
    const commentElem = document.querySelector(`#comment-${commentId}`);
    if (commentElem) return {
        top: commentElem.offsetTop,
        bottom: commentElem.offsetTop + commentElem.offsetHeight
    };
    return {
        top: Number.NEGATIVE_INFINITY,
        bottom: Number.POSITIVE_INFINITY
    };
};
const $4ae3b5b25efc2fdf$export$18a14437c7fa7b9f = ({ children: children })=>{
    const [newCommentPositions, setNewCommentPositions] = (0, $42omo.useState)([]);
    const { count: count, setCount: setCount } = (0, $42omo.useContext)((0, $7IghX.PageCommentsCountContext));
    const newCommentsContextValue = (0, $42omo.useMemo)(()=>({
            newCommentPositions: newCommentPositions,
            addNewComment: ({ currentUserMadeComment: currentUserMadeComment, newCommentId: newCommentId })=>{
                if (newCommentId) {
                    const pos = $4ae3b5b25efc2fdf$var$getCommentScreenPosition(newCommentId);
                    setNewCommentPositions((existingPositions)=>{
                        const commentExists = existingPositions.some((e)=>e.id === newCommentId);
                        return !commentExists ? [
                            ...existingPositions,
                            {
                                id: newCommentId,
                                pos: pos,
                                seen: false,
                                currentUserMadeComment: currentUserMadeComment
                            }
                        ] : existingPositions;
                    });
                    // Update the comment count
                    setCount(count + 1);
                }
            },
            removeComment: (commentId)=>{
                if (commentId) {
                    const idx = newCommentPositions.findIndex((comment)=>commentId === comment.id);
                    if (idx !== -1) {
                        const positionCopy = [
                            ...newCommentPositions
                        ];
                        positionCopy.splice(idx, 1);
                        setNewCommentPositions(positionCopy);
                    }
                    // Update the comment count
                    const newCount = count - 1;
                    setCount(newCount < 0 ? 0 : newCount);
                }
            },
            acknowledgeComment: (commentId)=>{
                if (commentId) {
                    const comment = newCommentPositions.find((commentPosition)=>commentPosition.id === commentId);
                    if (comment) comment.seen = true;
                }
            },
            acknowledgeComments: (commentIds)=>{
                if (commentIds && commentIds.length) commentIds.forEach((commentId)=>{
                    const comment = newCommentPositions.find((commentPosition)=>commentPosition.id === commentId);
                    if (comment) comment.seen = true;
                });
            },
            clearNewComments: ()=>{
                setNewCommentPositions([]);
            }
        }), [
        count,
        newCommentPositions,
        setCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ae3b5b25efc2fdf$export$c465d99c658013a3.Provider, {
        value: newCommentsContextValue
    }, children);
};
module.exports["NewCommentsContext"] = $4ae3b5b25efc2fdf$export$c465d99c658013a3;
module.exports["NewCommentsProvider"] = $4ae3b5b25efc2fdf$export$18a14437c7fa7b9f;

});

parcelRegister("7IghX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $230ca5ca2ceedabc$export$560530991a10c1f8 = /*#__PURE__*/ (0, $42omo.createContext)({
    count: 0,
    setCount: ()=>{}
});
const $230ca5ca2ceedabc$export$d3be1c3b23ba5810 = ({ children: children, contentId: contentId })=>{
    const [count, setCount] = (0, $42omo.useState)(0);
    const pageCommentsCountContextValue = (0, $42omo.useMemo)(()=>({
            count: count,
            setCount: setCount
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        count,
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($230ca5ca2ceedabc$export$560530991a10c1f8.Provider, {
        value: pageCommentsCountContextValue
    }, children);
};
module.exports["PageCommentsCountContext"] = $230ca5ca2ceedabc$export$560530991a10c1f8;
module.exports["PageCommentsCountProvider"] = $230ca5ca2ceedabc$export$d3be1c3b23ba5810;

});

parcelRegister("804Ue", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $1uFM6 = parcelRequire("1uFM6");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $flE5X = parcelRequire("flE5X");


var $cAdj8 = parcelRequire("cAdj8");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $6mKj3 = parcelRequire("6mKj3");


var $cQkIJ = parcelRequire("cQkIJ");

var $11771bad87ca0882$export$c51d39001809fe3e = /*#__PURE__*/ function(PubSubState) {
    PubSubState[PubSubState["ACTIVE"] = 0] = "ACTIVE";
    PubSubState[PubSubState["TERMINATED"] = 1] = "TERMINATED";
    return PubSubState;
}({});
var $11771bad87ca0882$export$77deeade63afd3a6 = /*#__PURE__*/ function(CommentEventType) {
    CommentEventType[CommentEventType["ALL"] = 0] = "ALL";
    CommentEventType[CommentEventType["FOOTER"] = 1] = "FOOTER";
    CommentEventType[CommentEventType["INLINE"] = 2] = "INLINE";
    return CommentEventType;
}({});
const $11771bad87ca0882$export$5a33be95ac52bdad = 2000;
const $11771bad87ca0882$export$f09c511f29ef2d = 3000;
const $11771bad87ca0882$export$45c0a7c4ba2fbb03 = ({ contentId: contentId, eventType: eventType, subscribeToPubSubEvents: subscribeToPubSubEvents, unsubscribeFromPubSubEvents: unsubscribeFromPubSubEvents, onEventFetchSuccess: onEventFetchSuccess, onFetchContentVersionEvent: onFetchContentVersionEvent, onDocumentReturn: onDocumentReturn, lastPollTime: lastPollTime, inactiveInterval: inactiveInterval = $11771bad87ca0882$export$5a33be95ac52bdad, returnInterval: returnInterval = $11771bad87ca0882$export$f09c511f29ef2d, isAutoReloadPageComments: isAutoReloadPageComments = false })=>{
    const { documentNeedsUpdate: documentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, currentDocumentVersion: currentDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const lastEventCheckTimeRef = (0, $42omo.useRef)(lastPollTime || Date.now());
    const subscriptionShutdownTimer = (0, $42omo.useRef)(null);
    const missedEventQueryTimeout = (0, $42omo.useRef)(null);
    // Check if document is undefined to handle SSR playwright tests
    const [documentVisible, setDocumentVisible] = (0, $42omo.useState)(typeof document !== 'undefined' ? !document.hidden : true);
    const [pubSubState, setPubSubState] = (0, $42omo.useState)(0);
    const { pageInfo: pageInfo, refetch: refetch } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first',
        onCompleted: (data)=>{
            if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
                const number = data?.content?.nodes?.[0]?.version?.number;
                if (number) setPublishedDocumentVersion(number);
            }
        }
    });
    (0, $42omo.useEffect)(()=>{
        const latestVersion = pageInfo?.version?.number;
        const isDocumentVersionFetched = (0, $6mKj3.expValEquals)('confluence_comments_get_document_version_number', 'isEnabled', true) ? !!currentDocumentVersion : true;
        if (latestVersion && isDocumentVersionFetched && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
            setPublishedDocumentVersion(latestVersion);
            setDocumentNeedsUpdate(latestVersion !== currentDocumentVersion);
        }
    }, [
        pageInfo?.version?.number,
        currentDocumentVersion,
        setPublishedDocumentVersion,
        setDocumentNeedsUpdate
    ]);
    const fetchContentVersionNumber = async ()=>{
        try {
            if (refetch) {
                const { data: data } = await refetch();
                return data?.content?.nodes?.[0]?.version?.number;
            }
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            return;
        }
    };
    const fetchMissingCommentEventsSinceTime = async (contentId, since)=>{
        try {
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const response = await (0, $hp2SH.getApolloClient)().query({
                query: (0, $cQkIJ.MissedCommentEventsQuery),
                variables: {
                    contentId: contentId,
                    since: since
                },
                fetchPolicy: 'no-cache',
                errorPolicy: 'all',
                context: {
                    fetchOptions: {
                        ignoreNoNetworkError: true
                    },
                    single: true
                }
            });
            const comments = response.data?.quickReload?.comments || [];
            let filteredCommentEvents = comments;
            // Filter out comment events tha we're not subscribed to
            if (eventType !== 0) filteredCommentEvents = comments.filter((comment)=>eventType === 1 ? comment.comment?.location.type === 'FOOTER' : comment.comment?.location.type === 'INLINE');
            const commentEvents = filteredCommentEvents.map((comment)=>{
                const commentId = comment.comment?.id;
                const type = comment.comment?.location.type;
                const accountId = (comment.comment?.author).accountId || '';
                return {
                    id: commentId,
                    type: type,
                    accountId: accountId
                };
            });
            const time = response.data?.quickReload?.time;
            return {
                commentEvents: commentEvents,
                time: time,
                contentId: contentId
            };
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            // Just do nothing
            return;
        }
    };
    const clearMissedEventTimeout = ()=>{
        if (missedEventQueryTimeout.current) {
            clearTimeout(missedEventQueryTimeout.current);
            missedEventQueryTimeout.current = null;
        }
    };
    const checkAndHandleMissedEvents = ()=>{
        // If we already have a timeout queued clear it
        clearMissedEventTimeout();
        // Check for the missed events on a timeout after the user has been back for 3 seconds
        missedEventQueryTimeout.current = setTimeout(async ()=>{
            if (documentNeedsUpdate) return;
            const contentLatestVersion = await fetchContentVersionNumber();
            if (!isAutoReloadPageComments && contentLatestVersion !== publishedDocumentVersion) {
                if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) // when experiment is ON, this is done in the useEffect block above
                setPublishedDocumentVersion(contentLatestVersion);
                onFetchContentVersionEvent && onFetchContentVersionEvent();
                return;
            }
            // Call passed in fetch function
            fetchMissingCommentEventsSinceTime(contentId, lastEventCheckTimeRef.current || Date.now()).then((res)=>{
                // This check of content types is needed in case the promise resolves after a user has already changed pages
                if (res && contentId === res.contentId) {
                    lastEventCheckTimeRef.current = res.time ?? Date.now();
                    // Return the result to the caller
                    onEventFetchSuccess(res);
                }
            // If the call fails, do nothing, just assume the events were missed
            });
        }, returnInterval);
    };
    // Wire up pub sub events when the component mounts
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            window.removeEventListener('beforeunload', unsubscribeFromPubSubEvents);
            unsubscribeFromPubSubEvents();
            if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') && (0, $9wGTI.fg)('confluence_comments_reply_inline_reliability')) return;
            clearMissedEventTimeout();
        };
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // Need to subscribe to the pubsub when component mounts or contentId, publishedDocumentVersion changes
    (0, $42omo.useEffect)(()=>{
        // No need to subscribe to the pubsub when doc version is 0
        // We need the events only when we have a valid version number i.e published
        if (publishedDocumentVersion === 0) return;
        subscribeToPubSubEvents();
        // Make sure to unsubscribe from pubsub events if the browser closes
        window.addEventListener('beforeunload', unsubscribeFromPubSubEvents);
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        publishedDocumentVersion,
        documentNeedsUpdate
    ]);
    // Listen to document visibility changes
    (0, $42omo.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') && (0, $9wGTI.fg)('confluence_comments_reply_inline_reliability')) return;
        const changeVisibility = ()=>setDocumentVisible(!document.hidden);
        document.addEventListener('visibilitychange', changeVisibility);
        return ()=>{
            document.removeEventListener('visibilitychange', changeVisibility);
        };
    }, [
        setDocumentVisible
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') && (0, $9wGTI.fg)('confluence_comments_reply_inline_reliability')) return;
        if (documentVisible && subscriptionShutdownTimer.current) {
            clearTimeout(subscriptionShutdownTimer.current);
            subscriptionShutdownTimer.current = null;
        }
        // When the document becomes hidden, record the current time as the last check time
        if (!documentVisible) lastEventCheckTimeRef.current = Date.now();
        // If the document is no longer visible, set a timeout to unsubscribe from pubsub events
        if (!documentVisible && !subscriptionShutdownTimer.current && pubSubState === 0) subscriptionShutdownTimer.current = setTimeout(()=>{
            unsubscribeFromPubSubEvents();
            setPubSubState(1);
        }, inactiveInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    // Resubscribe to the pubsub events when we come back and handle any missed events
    (0, $42omo.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') && (0, $9wGTI.fg)('confluence_comments_reply_inline_reliability')) return;
        setPubSubState((prevState)=>{
            if (documentVisible && prevState === 1) {
                onDocumentReturn && onDocumentReturn();
                checkAndHandleMissedEvents();
                subscribeToPubSubEvents();
                return 0;
            }
            return prevState;
        });
    // We only want this to fire when the document visibility has changed, not the pubsub state
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    return null;
};
module.exports["CommentEventType"] = $11771bad87ca0882$export$77deeade63afd3a6;
module.exports["MissedPubSubCommentEventsHandler"] = $11771bad87ca0882$export$45c0a7c4ba2fbb03;

});

parcelRegister("cQkIJ", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $49adc3cefa9af833$export$9a6d2339e4e672fb = (0, $eSUdr.default)`query MissedCommentEventsQuery($contentId:Long!$since:Long!){quickReload(pageId:$contentId since:$since){time comments{comment{id location{type}author{...on KnownUser{accountId}...on UnknownUser{accountId}}}}}}`;
module.exports["MissedCommentEventsQuery"] = $49adc3cefa9af833$export$9a6d2339e4e672fb;

});

parcelRegister("kQekh", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $90ffe60e2eae60ca$export$bf87400a8da436f8 = (0, $eSUdr.default)`query CommentsSectionGetSingleCommentQuery($commentId:ID!$contentId:ID!){comments(commentId:$commentId){nodes{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}reactionsSummary(pageId:$contentId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}`;
const $90ffe60e2eae60ca$export$caecd77287327384 = (0, $eSUdr.default)`query CommentsSectionGetSingleCommentWithoutReactionsQuery($commentId:ID!){comments(commentId:$commentId){nodes{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}}}}`;
module.exports["CommentsSectionGetSingleCommentQuery"] = $90ffe60e2eae60ca$export$bf87400a8da436f8;
module.exports["CommentsSectionGetSingleCommentWithoutReactionsQuery"] = $90ffe60e2eae60ca$export$caecd77287327384;

});

parcelRegister("6nXDf", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a6325bd22772a7a$export$2e2bcd8739ae039);

var $c3Z6w = parcelRequire("c3Z6w");


var $b5utg = parcelRequire("b5utg");

function $4a6325bd22772a7a$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $b5utg.default)(1, arguments);
    return (0, $c3Z6w.default)(dirtyDate, Date.now(), options);
}

});

parcelRegister("eTcMK", function(module, exports) {
const $cae726f3aa41e4da$export$497a036b5874e4b0 = (parentCommentId, location, author, shouldIncludeUser)=>{
    return {
        parentCommentId: parentCommentId,
        location: location,
        user: author && shouldIncludeUser ? {
            displayName: author.displayName,
            accountId: author.accountId
        } : undefined
    };
};
module.exports["createReplyToCommentParams"] = $cae726f3aa41e4da$export$497a036b5874e4b0;

});

parcelRegister("i2BsV", function(module, exports) {
$parcel$export(module.exports, "default", () => $c26d5c1d83386c25$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $3gadb = parcelRequire("3gadb");


var $dokWT = parcelRequire("dokWT");


var $5HQ8i = parcelRequire("5HQ8i");


var $gWldI = parcelRequire("gWldI");


var $1HYxw = parcelRequire("1HYxw");

const $c26d5c1d83386c25$var$styles = {
    base: "_zulp1b66 _2rko12b0 _1e0c116y _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _4cvr1h6o _1bah1h6o _o5724jg8 _1bto1l2s _80om73ad",
    compact: "_4t3igktf",
    expanded: "_4t3i1tcg",
    disabled: "_syaz1gmx _bfhkby5v _80om73ad",
    clickable: "_80omtlke",
    red: "_syazi7uo _bfhk1rtt",
    redClickable: "_13ix1rtt _irr3affd _1di61j5a",
    redBold: "_syaz15cr _bfhkuibq",
    redBoldClickable: "_13ixuibq _irr3100f _1di61cl6",
    orange: "_syazi7uo _bfhk1kkj",
    orangeClickable: "_13ix1kkj _irr39mfs _1di6axpp",
    yellow: "_syazi7uo _bfhkibhp",
    yellowClickable: "_13ixibhp _irr3aetg _1di61o1l",
    green: "_syazi7uo _bfhkn729",
    greenClickable: "_13ixn729 _irr33utz _1di6yfny",
    blue: "_syazi7uo _bfhk1dy8",
    blueClickable: "_13ix1dy8 _irr3815t _1di6rwxf",
    teal: "_syazi7uo _bfhk1a17",
    tealClickable: "_13ix1a17 _irr3kwwr _1di61jb0",
    lime: "_syazi7uo _bfhkz2ec",
    limeClickable: "_13ixz2ec _irr31gf0 _1di62kxc",
    purple: "_syazi7uo _bfhkp2ly",
    purpleClickable: "_13ixp2ly _irr3kca2 _1di61jbm",
    grey: "_syazi7uo _bfhkysee",
    greyClickable: "_13ixysee _irr3wejn _1di618ut",
    popup: "_1bsbp2n4"
};
function $c26d5c1d83386c25$export$2e2bcd8739ae039({ testId: testId, name: name, tooltip: tooltip, tooltipPosition: tooltipPosition, color: color = 'GREY', iconSize: iconSize = 'small', guideline: guideline, isDisabled: isDisabled = false, isPopupDisabled: isPopupDisabled = false, isPopupOpenByDefault: isPopupOpenByDefault = false, getPopupStateControllers: getPopupStateControllers, popupZIndex: popupZIndex, guidelineRepresentation: guidelineRepresentation = 'PLAIN', onPopupShown: onPopupShown, onPopupClose: onPopupClose, onClick: onClick, renderPopupComponent: renderPopupComponent, popupLabel: popupLabel, popupTitleId: popupTitleId, popupRole: popupRole, popupPlacement: popupPlacement = 'bottom-start', shouldRenderToParent: shouldRenderToParent, isIconOnly: isIconOnlyProp = false, associatedPoliciesCount: associatedPoliciesCount, spacing: spacing = 'default' }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(isDisabled || isPopupDisabled ? false : isPopupOpenByDefault);
    if (getPopupStateControllers) {
        const getOpenState = ()=>isPopupOpen;
        const setOpenState = (isOpen)=>setIsPopupOpen(isOpen);
        getPopupStateControllers(getOpenState, setOpenState);
    }
    const isMissingName = !name || name.length === 0;
    const isIconOnly = isMissingName || isIconOnlyProp;
    const nameWithRules = isMissingName ? '' : associatedPoliciesCount ? name + ' ' + formatMessage((0, $1HYxw.messages).rules, {
        associatedPoliciesCount: associatedPoliciesCount
    }) : name;
    const nameTruncated = (nameWithRules ?? '').substring(0, (0, $5HQ8i.nameMaxLength));
    const iconPx = iconSize === 'small' ? 12 : iconSize === 'medium' ? 18 : iconSize === 'large' ? 24 : iconSize === 'xlarge' ? 32 : iconSize === 'xxlarge' ? 40 : 12;
    const handleContainerClicked = ()=>{
        if (isPopupDisabled || isDisabled || isMissingName) return;
        if (onPopupShown) onPopupShown();
        setIsPopupOpen(!isPopupOpen);
    };
    const closePopup = ()=>{
        setIsPopupOpen(false);
    };
    const isClickable = !isPopupDisabled && !isDisabled && !isMissingName;
    const getContainer = (triggerProps = {})=>{
        // @ts-ignore
        const { 'aria-expanded': ariaExpanded, ...restProps } = triggerProps;
        const Container = isClickable ? (0, $fVUfS.default) : (0, $gdv5Z.default);
        return /*#__PURE__*/ (0, $l998X.jsxs)(Container, {
            role: isClickable ? 'button' : 'presentation',
            "aria-disabled": isDisabled,
            ...isClickable ? {
                'aria-label': `${formatMessage((0, $1HYxw.messages).dataClassificationLevel)} - ${name}`
            } : {},
            xcss: (0, $1Whri.cx)(...[
                $c26d5c1d83386c25$var$styles.base,
                // Add size styles if not icon only
                ...!isIconOnly ? [
                    spacing === 'expanded' ? $c26d5c1d83386c25$var$styles.expanded : $c26d5c1d83386c25$var$styles.compact
                ] : [],
                // Add disabled styles if disabled
                ...isDisabled ? [
                    $c26d5c1d83386c25$var$styles.disabled
                ] : [],
                // Add color styles
                ...!isDisabled ? [
                    {
                        RED: $c26d5c1d83386c25$var$styles.red,
                        RED_BOLD: $c26d5c1d83386c25$var$styles.redBold,
                        ORANGE: $c26d5c1d83386c25$var$styles.orange,
                        YELLOW: $c26d5c1d83386c25$var$styles.yellow,
                        GREEN: $c26d5c1d83386c25$var$styles.green,
                        BLUE: $c26d5c1d83386c25$var$styles.blue,
                        TEAL: $c26d5c1d83386c25$var$styles.teal,
                        LIME: $c26d5c1d83386c25$var$styles.lime,
                        PURPLE: $c26d5c1d83386c25$var$styles.purple,
                        GREY: $c26d5c1d83386c25$var$styles.grey
                    }[color]
                ] : [],
                // Add clickable styles if clickable
                ...!isDisabled && isClickable ? [
                    $c26d5c1d83386c25$var$styles.clickable,
                    {
                        RED: $c26d5c1d83386c25$var$styles.redClickable,
                        RED_BOLD: $c26d5c1d83386c25$var$styles.redBoldClickable,
                        ORANGE: $c26d5c1d83386c25$var$styles.orangeClickable,
                        YELLOW: $c26d5c1d83386c25$var$styles.yellowClickable,
                        GREEN: $c26d5c1d83386c25$var$styles.greenClickable,
                        BLUE: $c26d5c1d83386c25$var$styles.blueClickable,
                        TEAL: $c26d5c1d83386c25$var$styles.tealClickable,
                        LIME: $c26d5c1d83386c25$var$styles.limeClickable,
                        PURPLE: $c26d5c1d83386c25$var$styles.purpleClickable,
                        GREY: $c26d5c1d83386c25$var$styles.greyClickable
                    }[color]
                ] : []
            ]),
            testId: testId,
            padding: "space.050",
            onClick: ()=>{
                if (onClick) onClick();
                handleContainerClicked();
            },
            ...isClickable ? triggerProps : restProps,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    justifyContent: "center",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gWldI.ClassificationIcon), {
                        width: iconPx,
                        height: iconPx,
                        color: isDisabled ? (0, $5HQ8i.disabledColorConfig).iconColor : (0, $5HQ8i.colorsConfig)[color].iconColor
                    })
                }),
                !isIconOnly && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: "UNSAFE_small",
                    maxLines: 1,
                    color: color === 'RED_BOLD' ? 'color.text.inverse' : 'color.text',
                    testId: "data-classification-level-name",
                    children: nameTruncated
                })
            ]
        });
    };
    return isPopupDisabled ? getContainer() : // eslint-disable-next-line @atlaskit/design-system/use-should-render-to-parent
    /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        label: popupLabel,
        titleId: popupTitleId,
        role: popupRole,
        shouldRenderToParent: shouldRenderToParent,
        placement: popupPlacement,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: isPopupOpen ? null : tooltip,
                hideTooltipOnClick: true,
                position: tooltipPosition,
                children: getContainer(triggerProps)
            }),
        content: ()=>renderPopupComponent ? renderPopupComponent(closePopup) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                padding: "space.250",
                xcss: $c26d5c1d83386c25$var$styles.popup,
                role: "dialog",
                "aria-labelledby": "data-classification-read-content-name",
                "aria-describedby": "data-classification-read-content-guideline",
                "aria-modal": "true",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dokWT.ClassificationView), {
                    name: name,
                    guideline: guideline,
                    guidelineRepresentation: guidelineRepresentation
                })
            }),
        isOpen: isPopupOpen,
        onClose: ()=>{
            if (onPopupClose) onPopupClose();
            closePopup();
        },
        zIndex: popupZIndex
    });
}

});

parcelRegister("dokWT", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");


var $67O0h = parcelRequire("67O0h");


var $5HQ8i = parcelRequire("5HQ8i");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6522a38deabe02d9$var$Name = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8lodh _syazi7uo",
            __cmplp.className
        ])
    });
});
const $6522a38deabe02d9$var$Guideline = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c82smr _syazi7uo _o5721jtm _1i4q1hna",
            __cmplp.className
        ])
    });
});
const $6522a38deabe02d9$export$d413367b4cbb5577 = ({ name: name, guideline: guideline, guidelineRepresentation: guidelineRepresentation = 'PLAIN' })=>{
    const nameTruncated = (name ?? '').substring(0, (0, $5HQ8i.nameMaxLength));
    const guidelineTruncated = (guideline ?? '').substring(0, (0, $5HQ8i.guidelineMaxLength));
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        children: [
            nameTruncated && /*#__PURE__*/ (0, $l998X.jsx)($6522a38deabe02d9$var$Name, {
                id: "data-classification-read-content-name",
                children: nameTruncated
            }),
            guideline && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                paddingBlockStart: "space.200",
                children: guidelineRepresentation === 'PLAIN' ? /*#__PURE__*/ (0, $l998X.jsx)($6522a38deabe02d9$var$Guideline, {
                    id: "data-classification-read-content-guideline",
                    children: guidelineTruncated
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $67O0h.default), {
                    maxHeight: 200,
                    truncated: true,
                    document: JSON.parse(guideline)
                })
            })
        ]
    });
};
module.exports["ClassificationView"] = $6522a38deabe02d9$export$d413367b4cbb5577;

});

parcelRegister("dLX9a", function(module, exports) {

var $cb6fO = parcelRequire("cb6fO");


var $cEgMD = parcelRequire("cEgMD");


var $1NBp8 = parcelRequire("1NBp8");


var $dqLea = parcelRequire("dqLea");

const $89342ddee4389e57$export$9d5b76aa7bb3f492 = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return (0, $1NBp8.COMPANY_HUB).toUrl();
    const path = `${(0, $cb6fO.getSpaceLink)(spaceKey, contentType === 'page' ? 'pages' : 'blog')}/${contentId}`;
    return path;
};
const $89342ddee4389e57$export$5906c3344719ad0e = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType, breadcrumbs: breadcrumbs, isUnpublishedDraft: isUnpublishedDraft })=>{
    let url = (0, $1NBp8.HOME).toUrl();
    if (isUnpublishedDraft) {
        if (contentType === 'page') // Draft page -> redirect to closest published parent view page
        {
            if (breadcrumbs) {
                url = (0, $dqLea.getNearestVisibleAncestor)({
                    breadcrumbs: breadcrumbs,
                    fallbackUrl: url
                });
                // if the parent is a folder, redirect to the space overview
                if (Boolean((0, $1NBp8.FOLDER_VIEW).match(url))) url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
                    spaceKey: spaceKey
                });
            }
        } else // Draft blog -> redirect to space index page
        url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        });
    } else // this part executes when closing the edit section for a previously/already published page
    // we can do a lil hack here to avoid making a query.
    // the router will prettify our route with slug (& posting date for blogs) for us
    url = $89342ddee4389e57$export$9d5b76aa7bb3f492({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType
    });
    return url;
};
module.exports["getPublishPreloadUrl"] = $89342ddee4389e57$export$9d5b76aa7bb3f492;
module.exports["getClosePreloadUrl"] = $89342ddee4389e57$export$5906c3344719ad0e;

});

parcelRegister("lABjq", function(module, exports) {
const $8cb98e143c540908$export$79ede1af301c436c = {
    pageJustPublished: false
};
module.exports["pagePublishedState"] = $8cb98e143c540908$export$79ede1af301c436c;

});

parcelRegister("lEnke", function(module, exports) {

var $9o40q = parcelRequire("9o40q");


var $aBfpe = parcelRequire("aBfpe");

const $6bba1273a65c92dc$export$97c5b582958cdf97 = ({ onCompleted: onCompleted, onError: onError } = {})=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: ({ contentId: contentId })=>`/wiki/rest/api/content/${contentId}/?status=draft&action=sync`,
        method: 'PUT',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: ({ contentId: contentId, contentType: contentType, title: title, content: content, ncsStepVersion: ncsStepVersion })=>{
            const history = contentType === 'blogpost' ? {
                createdDate: new Date().toISOString()
            } : undefined;
            const extensions = {
                'update-trigger': 'DRAFT_SYNC'
            };
            const body = {
                id: contentId,
                type: contentType,
                title: title,
                body: {
                    atlas_doc_format: {
                        value: content,
                        representation: 'atlas_doc_format',
                        content: {
                            id: contentId
                        }
                    }
                },
                status: 'draft',
                version: {
                    number: 1,
                    message: '',
                    ...ncsStepVersion ? {
                        ncsStepVersion: ncsStepVersion
                    } : {}
                },
                extensions: extensions,
                history: history
            };
            return JSON.stringify(body);
        },
        parseResult: (response)=>{
            // The response should match the GraphQL mutation structure
            // experimentalDraftSync: { id: string | null }
            return {
                experimentalDraftSync: {
                    id: response?.id || null
                }
            };
        },
        onCompleted: onCompleted,
        onError: onError
    });
};
module.exports["useExperimentalDraftSyncMutation"] = $6bba1273a65c92dc$export$97c5b582958cdf97;

});

parcelRegister("3WXN2", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $inPa6 = parcelRequire("inPa6");


var $7zgzO = parcelRequire("7zgzO");


var $1NBp8 = parcelRequire("1NBp8");


var $3JQXa = parcelRequire("3JQXa");


var $9WYR7 = parcelRequire("9WYR7");

const $1e41cfcb0548d2ef$var$useCopyContentLinkCopyLinkQuery = (0, $eSUdr.default)`query useCopyContentLinkCopyLinkQuery($contentId:ID!){singleContent(id:$contentId){id links{editui webui tinyui base}}}`;
var $1e41cfcb0548d2ef$export$61634440d18842d5 = /*#__PURE__*/ function(SUPPORTED_CONTENT_TYPES) {
    SUPPORTED_CONTENT_TYPES["PAGE"] = "page";
    SUPPORTED_CONTENT_TYPES["BLOGPOST"] = "blogpost";
    SUPPORTED_CONTENT_TYPES["OVERVIEW"] = "overview";
    SUPPORTED_CONTENT_TYPES["WHITEBOARD"] = "whiteboard";
    SUPPORTED_CONTENT_TYPES["EMBED"] = "embed";
    SUPPORTED_CONTENT_TYPES["DATABASE"] = "database";
    return SUPPORTED_CONTENT_TYPES;
}({});
const $1e41cfcb0548d2ef$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $42omo.useState)();
    const { toUrl: toUrl } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $3JQXa.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $j1Ss3.useQuery)($1e41cfcb0548d2ef$var$useCopyContentLinkCopyLinkQuery, {
        variables: {
            contentId: contentId
        }
    });
    const getCopyContentLink = (0, $42omo.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === (0, $9WYR7.PAGE_MODE).EDIT) copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) return `${links.base}${copyLink}`;
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === (0, $9WYR7.PAGE_MODE).EDIT) {
            routeName = contentType === "blogpost" ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === "blogpost" ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case "overview":
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case "blogpost":
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case "page":
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case "whiteboard":
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            case "embed":
                routeName = (0, $1NBp8.EMBED_VIEW).name;
                break;
            case "database":
                routeName = (0, $1NBp8.DATABASE_VIEW).name;
            // omit unsupported content types
            default:
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $9WYR7.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'copied',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $9WYR7.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            return `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $42omo.useCallback)(()=>{
        return copyToClipboard(getCopyContentLink());
    }, [
        getCopyContentLink,
        copyToClipboard
    ]);
    return (0, $42omo.useMemo)(()=>({
            queryError: queryError,
            unsupportedLinkError: unsupportedLinkError,
            getCopyContentLink: getCopyContentLink,
            copyContentLink: copyContentLink
        }), [
        queryError,
        unsupportedLinkError,
        getCopyContentLink,
        copyContentLink
    ]);
};
module.exports["SUPPORTED_CONTENT_TYPES"] = $1e41cfcb0548d2ef$export$61634440d18842d5;
module.exports["useCopyContentLink"] = $1e41cfcb0548d2ef$export$a049904f049cf16d;

});

parcelRegister("9WYR7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $1bY7o = parcelRequire("1bY7o");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $56QzY = parcelRequire("56QzY");


var $irVI7 = parcelRequire("irVI7");


var $hjygH = parcelRequire("hjygH");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $3WXN2 = parcelRequire("3WXN2");

const $5e79baa87b282684$var$i18n = (0, $cgtv4.defineMessages)({
    copyLinkLabel: {
        id: "share.copylink.icon.label",
        defaultMessage: "Copy link"
    },
    copiedTextLabel: {
        id: "share.copylink.copied.tooltip",
        defaultMessage: "Copied!"
    },
    errorCopyingTextLabel: {
        id: "share.copylink.error.tooltip",
        defaultMessage: "Something went wrong."
    }
});
const $5e79baa87b282684$var$RESET_COPYTEXT_TIMEOUT = 5000;
const $5e79baa87b282684$export$9957974f8b4d8f74 = 'copyShareLink';
var $5e79baa87b282684$export$e82cf716cce37b4e = /*#__PURE__*/ function(PAGE_MODE) {
    PAGE_MODE["VIEW"] = "view";
    PAGE_MODE["EDIT"] = "edit";
    return PAGE_MODE;
}({});
const $5e79baa87b282684$var$CopyLinkComponent = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, shouldResetOnHover: shouldResetOnHover = false, buttonAppearance: buttonAppearance = 'subtle', tooltipPosition: tooltipPosition = 'bottom' })=>{
    const intl = (0, $8C5kA.default)();
    const [isCopied, setIsCopied] = (0, $42omo.useState)(false);
    const [errorDuringCopy, setErrorDuringCopy] = (0, $42omo.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const cleanupCopiedTimer = (0, $42omo.useRef)();
    const updateTooltipPosition = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        if (isCopied) cleanupCopiedTimer.current = setTimeout(()=>setIsCopied(false), $5e79baa87b282684$var$RESET_COPYTEXT_TIMEOUT);
        return ()=>{
            clearTimeout(cleanupCopiedTimer.current);
        };
    }, [
        isCopied
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                actionSubject: 'copyShareLink',
                action: 'shown',
                source: source,
                attributes: {
                    contentType: contentType,
                    pageMode: pageMode,
                    isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentType,
        source,
        pageMode
    ]);
    const { queryError: queryError, unsupportedLinkError: unsupportedLinkError, copyContentLink: copyContentLink } = (0, $3WXN2.useCopyContentLink)({
        pageMode: pageMode,
        contentType: contentType,
        contentId: contentId,
        spaceKey: spaceKey,
        source: source
    });
    (0, $42omo.useLayoutEffect)(()=>{
        updateTooltipPosition.current?.();
    }, [
        isCopied
    ]);
    const handleCopyLink = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: $5e79baa87b282684$export$9957974f8b4d8f74,
                source: source,
                attributes: {
                    pageMode: pageMode,
                    contentType: contentType,
                    navdexPointType: (0, $56QzY.END),
                    isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                }
            }
        }).fire();
        try {
            await copyContentLink();
        } catch (e) {
            setErrorDuringCopy(e);
        }
        setIsCopied(true);
    };
    const handleHover = ()=>{
        experienceTracker.start({
            name: (0, $irVI7.COPY_CONTENT_LINK_EXPERIENCE)
        });
    };
    // report errors from the hook's query silently since we have fallback link retrieval
    // methods, but show user error tooltip text and fail experience if we actually
    // couldn't get any link to copy or the copy itself failed
    const copyError = unsupportedLinkError || errorDuringCopy;
    const copyLinkText = intl.formatMessage($5e79baa87b282684$var$i18n.copyLinkLabel);
    const confirmationText = intl.formatMessage(copyError ? $5e79baa87b282684$var$i18n.errorCopyingTextLabel : $5e79baa87b282684$var$i18n.copiedTextLabel);
    const isAnyError = Boolean(queryError || copyError);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAnyError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryError || copyError
    }), Boolean(copyError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
        name: (0, $irVI7.COPY_CONTENT_LINK_EXPERIENCE),
        error: copyError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltipPosition.current = update;
            return isCopied ? confirmationText : copyLinkText;
        },
        position: tooltipPosition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "copy-link-button",
        "aria-label": isCopied ? confirmationText : copyLinkText,
        appearance: buttonAppearance,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: "",
            color: isCopied ? "var(--ds-icon-selected, #1868DB)" : undefined,
            spacing: "spacious"
        }),
        onClick: handleCopyLink,
        onMouseEnter: handleHover,
        // Some consumers of CopyLink only reveal the button on hover, and
        // for those ones we need to reset the button to default post hover.
        // state after mouse leaves the component (because the button gets
        // hidden when no longer hovering)
        onMouseLeave: ()=>{
            if (shouldResetOnHover) setIsCopied(false);
            experienceTracker.abort({
                name: (0, $irVI7.COPY_CONTENT_LINK_EXPERIENCE),
                reason: 'user navigated away'
            });
        },
        shouldFitContainer: true
    })), isCopied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.COPY_CONTENT_LINK_EXPERIENCE)
    }));
};
const $5e79baa87b282684$export$1711531201a0c4b7 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})($5e79baa87b282684$var$CopyLinkComponent);
module.exports["ACTION_SUBJECT_ID"] = $5e79baa87b282684$export$9957974f8b4d8f74;
module.exports["PAGE_MODE"] = $5e79baa87b282684$export$e82cf716cce37b4e;
module.exports["CopyLink"] = $5e79baa87b282684$export$1711531201a0c4b7;

});

parcelRegister("cVfpT", function(module, exports) {
$parcel$export(module.exports, "PAGE_MODE", () => (parcelRequire("9WYR7")).PAGE_MODE);

var $jmjWc = parcelRequire("jmjWc");


var $h5hpR = parcelRequire("h5hpR");


var $9WYR7 = parcelRequire("9WYR7");


const $77a17cdb2708e975$export$9d30156e45c09e81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qHKXp",
    name: "CopyLinkButtonLoader",
    loader: async ()=>{
        return (await Promise.resolve((parcelRequire("9WYR7")))).CopyLink;
    },
    loading: (0, $h5hpR.CopyLinkButtonPlaceholder)
});
module.exports["CopyLinkButtonLoader"] = $77a17cdb2708e975$export$9d30156e45c09e81;

});

parcelRegister("h5hpR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1bY7o = parcelRequire("1bY7o");


var $eEA8O = parcelRequire("eEA8O");

const $585272eb5e339a55$var$i18n = (0, $cgtv4.defineMessages)({
    copyLinkLabel: {
        id: "share.copylink.icon.label",
        defaultMessage: "Copy link"
    }
});
const $585272eb5e339a55$export$1f3200a5b8d4d8e1 = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "copy-link-button-placeholder",
        "data-test-id": "copy-link-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: intl.formatMessage($585272eb5e339a55$var$i18n.copyLinkLabel),
            spacing: "spacious"
        }),
        isDisabled: true
    });
};
module.exports["CopyLinkButtonPlaceholder"] = $585272eb5e339a55$export$1f3200a5b8d4d8e1;

});

parcelRegister("lRCxi", function(module, exports) {
const $6d3a2f07b0875b27$export$3475487c10c1ac17 = async (cloudId)=>{
    const siteTraits = await $6d3a2f07b0875b27$var$fetchSitePersonalization(cloudId);
    const optoutTraitValue = siteTraits.find((trait)=>trait.name === 'optout_all_messages')?.value;
    return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};
const $6d3a2f07b0875b27$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $6d3a2f07b0875b27$var$fetchSitePersonalization = async (cloudId)=>{
    const response = await fetch($6d3a2f07b0875b27$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const { attributes: attributes } = await response.json();
    return attributes;
};
module.exports["isSiteOptedOut"] = $6d3a2f07b0875b27$export$3475487c10c1ac17;

});

parcelRegister("kdpMy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9ec3d7afd2a780b8$export$d4c72bab9d6cc13a = {
    generatedTitle: '',
    trackAIResultViewStored: ()=>{}
};
const $9ec3d7afd2a780b8$var$NAME = 'GENERATED_TITLE_STORE';
const $9ec3d7afd2a780b8$export$e324594224ef24da = {
    setGeneratedTitle: (newTitle)=>({ setState: setState })=>{
            setState({
                generatedTitle: newTitle
            });
        },
    setTrackAIResultViewStored: (trackAIResultViewHook)=>({ setState: setState })=>{
            setState({
                trackAIResultViewStored: trackAIResultViewHook
            });
        }
};
const $9ec3d7afd2a780b8$var$GeneratedTitleStore = (0, $1P1Tu.createStore)({
    name: $9ec3d7afd2a780b8$var$NAME,
    initialState: $9ec3d7afd2a780b8$export$d4c72bab9d6cc13a,
    actions: $9ec3d7afd2a780b8$export$e324594224ef24da
});
const $9ec3d7afd2a780b8$export$b824f038e1bda391 = (0, $9zUhf.createHook)($9ec3d7afd2a780b8$var$GeneratedTitleStore);
module.exports["useGeneratedTitle"] = $9ec3d7afd2a780b8$export$b824f038e1bda391;

});

parcelRegister("4adOe", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $eSUdr = parcelRequire("eSUdr");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1KmJq = parcelRequire("1KmJq");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $lsxnT = parcelRequire("lsxnT");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $jZABW = parcelRequire("jZABW");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $6uhfT = parcelRequire("6uhfT");


var $3hlsb = parcelRequire("3hlsb");


var $7BnEk = parcelRequire("7BnEk");


var $3PKog = parcelRequire("3PKog");


var $9uaV8 = parcelRequire("9uaV8");


var $cMbwo = parcelRequire("cMbwo");


var $5bmjx = parcelRequire("5bmjx");


var $4Ewfm = parcelRequire("4Ewfm");


var $T5KYq = parcelRequire("T5KYq");


var $cBa8E = parcelRequire("cBa8E");


var $5608P = parcelRequire("5608P");


var $3Ipyu = parcelRequire("3Ipyu");

const $f9a7e940d2f4f7fe$var$ControllerDirectRestrictionsMutation = (0, $eSUdr.default)`mutation ControllerDirectRestrictionsMutation($pageId:ID!$restrictions:PageRestrictionsInput){updatePage(input:{pageId:$pageId restrictions:$restrictions}){page{id}}}`;
const $f9a7e940d2f4f7fe$export$219d516b185caa05 = 'ShareAndRestrictDialog';
const $f9a7e940d2f4f7fe$export$b1e4cd5fa4074c7a = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions';
const $f9a7e940d2f4f7fe$export$ce504fce6cf8855f = 'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';
const $f9a7e940d2f4f7fe$var$useController = (0, $3u0dr.isReactCompilerActiveV1)() ? function useController(controllerProps, controllerExtras) {
    const $ = (0, $frIzR.c)(41);
    const { fireAnalyticEvent: fireAnalyticEvent, cloudId: cloudId } = controllerExtras;
    const { contentId: contentId, contentType: contentType, publishModalRestrictions: publishModalRestrictions, pushPublishModalRestrictions: pushPublishModalRestrictions, spaceKey: spaceKey, onClose: onClose, onCloseComplete: onCloseComplete, initialDialog: initialDialog, hasRestrictions: hasRestrictions, isUnpublishedDraft: isUnpublishedDraft } = controllerProps;
    const [wasDialogClosedDuringLoading, setWasDialogClosedDuringLoading] = (0, $42omo.useState)(false);
    let t0;
    if ($[0] !== initialDialog) {
        t0 = (0, $7BnEk.makeDefaultMasterState)(initialDialog);
        $[0] = initialDialog;
        $[1] = t0;
    } else t0 = $[1];
    const [masterState, setMasterState] = (0, $42omo.useState)(t0);
    const dispatchCtaFlowEvent = (0, $5608P.useCtaFlowController)(setMasterState);
    const [shownLoadErrorFlag, setShownLoadErrorFlag] = (0, $42omo.useState)(false);
    let t1;
    if ($[2] !== cloudId || $[3] !== contentId || $[4] !== contentType || $[5] !== publishModalRestrictions || $[6] !== spaceKey) {
        t1 = {
            contentId: contentId,
            contentType: contentType,
            publishModalRestrictions: publishModalRestrictions,
            spaceKey: spaceKey,
            cloudId: cloudId
        };
        $[2] = cloudId;
        $[3] = contentId;
        $[4] = contentType;
        $[5] = publishModalRestrictions;
        $[6] = spaceKey;
        $[7] = t1;
    } else t1 = $[7];
    const queriesHookResponse = (0, $cMbwo.useQueries)(t1);
    if (queriesHookResponse.state === "loading" || wasDialogClosedDuringLoading) {
        const t2 = initialDialog === "accessRequests" ? "accessRequests" : "share";
        const t3 = initialDialog === "accessRequests" ? $f9a7e940d2f4f7fe$var$_temp : undefined;
        let t4;
        let t5;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = ()=>{
                setWasDialogClosedDuringLoading(true);
            };
            t5 = {
                lastTriggeredDialogVariant: null,
                openAccessRequestsDialog: $f9a7e940d2f4f7fe$var$_temp2,
                clearElementToFocus: $f9a7e940d2f4f7fe$var$_temp3,
                usdLoading: true
            };
            $[8] = t4;
            $[9] = t5;
        } else {
            t4 = $[8];
            t5 = $[9];
        }
        let t6;
        if ($[10] !== t2 || $[11] !== t3) {
            t6 = {
                titleAndButtons: {
                    title: t2,
                    overflowMenu: undefined,
                    onBackClick: t3,
                    onCloseClick: t4,
                    accessRequests: t5
                },
                hasNavigationLockout: false
            };
            $[10] = t2;
            $[11] = t3;
            $[12] = t6;
        } else t6 = $[12];
        const header = t6;
        let t7;
        if ($[13] !== publishModalRestrictions) {
            t7 = publishModalRestrictions?.some($f9a7e940d2f4f7fe$var$_temp4);
            $[13] = publishModalRestrictions;
            $[14] = t7;
        } else t7 = $[14];
        const publishModalFlowHasSpecificAccess = Boolean(t7);
        const isPublishModalFlow = Boolean(pushPublishModalRestrictions);
        const t8 = hasRestrictions || publishModalFlowHasSpecificAccess;
        const t9 = contentType === "embed";
        let t10;
        if ($[15] !== isPublishModalFlow || $[16] !== isUnpublishedDraft || $[17] !== t8 || $[18] !== t9) {
            t10 = {
                specificAccessVisible: t8,
                isDraft: isUnpublishedDraft,
                isPublishModalFlow: isPublishModalFlow,
                isEmbed: t9
            };
            $[15] = isPublishModalFlow;
            $[16] = isUnpublishedDraft;
            $[17] = t8;
            $[18] = t9;
            $[19] = t10;
        } else t10 = $[19];
        const usdLoadingHeightContext = t10;
        let t11;
        if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
            t11 = ()=>{
                setWasDialogClosedDuringLoading(true);
            };
            $[20] = t11;
        } else t11 = $[20];
        let t12;
        if ($[21] !== onClose || $[22] !== onCloseComplete) {
            t12 = ()=>{
                onClose();
                onCloseComplete?.();
            };
            $[21] = onClose;
            $[22] = onCloseComplete;
            $[23] = t12;
        } else t12 = $[23];
        let t13;
        if ($[24] !== header || $[25] !== t12 || $[26] !== usdLoadingHeightContext) {
            t13 = {
                onCloseRequest: t11,
                onCloseComplete: t12,
                header: header,
                body: undefined,
                footer: undefined,
                isLoading: true,
                analyticsAttributes: undefined,
                usdLoadingHeightContext: usdLoadingHeightContext
            };
            $[24] = header;
            $[25] = t12;
            $[26] = usdLoadingHeightContext;
            $[27] = t13;
        } else t13 = $[27];
        const shareAndRestrictDialog = t13;
        let t14;
        if ($[28] !== shareAndRestrictDialog || $[29] !== wasDialogClosedDuringLoading) {
            t14 = wasDialogClosedDuringLoading ? {
                dialogsProps: {}
            } : {
                dialogsProps: {
                    shareAndRestrictDialog: shareAndRestrictDialog
                }
            };
            $[28] = shareAndRestrictDialog;
            $[29] = wasDialogClosedDuringLoading;
            $[30] = t14;
        } else t14 = $[30];
        return t14;
    }
    if (queriesHookResponse.state === "error") {
        controllerExtras.experienceTracker.fail({
            name: (0, $irVI7.SHARE_AND_RESTRICT_DIALOG_LOAD_EXPERIENCE),
            error: new Error("Failed to fetch share and restrictions dialog data")
        });
        fireAnalyticEvent({
            eventType: "sendTrackEvent",
            action: "failed",
            actionSubject: "query",
            actionSubjectId: "ShareAndRestrictDialog"
        });
        if (!shownLoadErrorFlag) {
            setShownLoadErrorFlag(true);
            controllerExtras.errorFlag("loading-error");
        }
        let t2;
        if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
                dialogsProps: {}
            };
            $[31] = t2;
        } else t2 = $[31];
        return t2;
    }
    const { queriesState: queriesState, refetchQueries: refetchQueries } = queriesHookResponse;
    let t2;
    if ($[32] !== controllerExtras || $[33] !== controllerProps || $[34] !== dispatchCtaFlowEvent || $[35] !== masterState || $[36] !== queriesState || $[37] !== refetchQueries) {
        const derivedState = (0, $3PKog.getDerivedState)(masterState, queriesState, controllerProps);
        const actions = (0, $3hlsb.getActions)(controllerProps, controllerExtras, masterState, derivedState, queriesState, setMasterState, dispatchCtaFlowEvent, refetchQueries);
        const statesAndActions = {
            controllerProps: controllerProps,
            controllerExtras: controllerExtras,
            masterState: masterState,
            derivedState: derivedState,
            queriesState: queriesState,
            actions: actions
        };
        t2 = (0, $9uaV8.makeDialogsProps)(statesAndActions);
        $[32] = controllerExtras;
        $[33] = controllerProps;
        $[34] = dispatchCtaFlowEvent;
        $[35] = masterState;
        $[36] = queriesState;
        $[37] = refetchQueries;
        $[38] = t2;
    } else t2 = $[38];
    let t3;
    if ($[39] !== t2) {
        t3 = {
            dialogsProps: t2
        };
        $[39] = t2;
        $[40] = t3;
    } else t3 = $[40];
    return t3;
} : function useController(controllerProps, controllerExtras) {
    const { fireAnalyticEvent: fireAnalyticEvent, cloudId: cloudId } = controllerExtras;
    const { contentId: contentId, contentType: contentType, publishModalRestrictions: publishModalRestrictions, pushPublishModalRestrictions: pushPublishModalRestrictions, spaceKey: spaceKey, onClose: onClose, onCloseComplete: onCloseComplete, initialDialog: initialDialog, hasRestrictions: hasRestrictions, isUnpublishedDraft: isUnpublishedDraft } = controllerProps;
    const [wasDialogClosedDuringLoading, setWasDialogClosedDuringLoading] = (0, $42omo.useState)(false);
    const [masterState, setMasterState] = (0, $42omo.useState)((0, $7BnEk.makeDefaultMasterState)(initialDialog));
    const dispatchCtaFlowEvent = (0, $5608P.useCtaFlowController)(setMasterState);
    const [shownLoadErrorFlag, setShownLoadErrorFlag] = (0, $42omo.useState)(false);
    const queriesHookResponse = (0, $cMbwo.useQueries)({
        contentId: contentId,
        contentType: contentType,
        publishModalRestrictions: publishModalRestrictions,
        spaceKey: spaceKey,
        cloudId: cloudId
    });
    if (queriesHookResponse.state === 'loading' || // If the user closes the dialog in the loading state, then keep the loading
    // state showing even if the query finally resolves: it's not helpful to
    // replace the dialog contents with a flash of content during the exit
    // transition.
    wasDialogClosedDuringLoading) {
        // If we don't have the bare minimum needed to display the dialog, short-
        // circuit and give hardwired props for the loading state. By doing it this
        // way, the code that later calculates derivedState can rely on all the
        // inputs it needs being available, saving lots of guard code later on.
        const header = {
            titleAndButtons: {
                title: initialDialog === 'accessRequests' ? 'accessRequests' : 'share',
                overflowMenu: undefined,
                onBackClick: initialDialog === 'accessRequests' ? ()=>{} : undefined,
                onCloseClick: ()=>{
                    setWasDialogClosedDuringLoading(true);
                },
                // Needed for the AccessRequestsButton to start preloading early
                accessRequests: {
                    lastTriggeredDialogVariant: null,
                    openAccessRequestsDialog: ()=>{},
                    clearElementToFocus: ()=>{},
                    usdLoading: true
                }
            },
            // principalsStager: undefined,
            // showDraftMessage: false,
            hasNavigationLockout: false
        };
        const publishModalFlowHasSpecificAccess = Boolean(publishModalRestrictions?.some((operation)=>operation?.restrictions.user.results.length));
        const isPublishModalFlow = Boolean(pushPublishModalRestrictions);
        const usdLoadingHeightContext = {
            specificAccessVisible: hasRestrictions || publishModalFlowHasSpecificAccess,
            isDraft: isUnpublishedDraft,
            isPublishModalFlow: isPublishModalFlow,
            isEmbed: contentType === 'embed'
        };
        const shareAndRestrictDialog = {
            onCloseRequest: ()=>{
                setWasDialogClosedDuringLoading(true);
            },
            onCloseComplete: ()=>{
                onClose();
                onCloseComplete?.();
            },
            header: header,
            body: undefined,
            footer: undefined,
            isLoading: true,
            analyticsAttributes: undefined,
            usdLoadingHeightContext: usdLoadingHeightContext
        };
        return wasDialogClosedDuringLoading ? {
            dialogsProps: {}
        } : {
            dialogsProps: {
                shareAndRestrictDialog: shareAndRestrictDialog
            }
        };
    }
    if (queriesHookResponse.state === 'error') {
        controllerExtras.experienceTracker.fail({
            name: (0, $irVI7.SHARE_AND_RESTRICT_DIALOG_LOAD_EXPERIENCE),
            error: new Error('Failed to fetch share and restrictions dialog data')
        });
        fireAnalyticEvent({
            eventType: 'sendTrackEvent',
            action: 'failed',
            actionSubject: 'query',
            actionSubjectId: 'ShareAndRestrictDialog'
        });
        if (!shownLoadErrorFlag) {
            setShownLoadErrorFlag(true);
            controllerExtras.errorFlag('loading-error');
        }
        return {
            dialogsProps: {}
        };
    }
    const { queriesState: queriesState, refetchQueries: refetchQueries } = queriesHookResponse;
    const derivedState = (0, $3PKog.getDerivedState)(masterState, queriesState, controllerProps);
    const actions = (0, $3hlsb.getActions)(controllerProps, controllerExtras, masterState, derivedState, queriesState, setMasterState, dispatchCtaFlowEvent, refetchQueries);
    const statesAndActions = {
        controllerProps: controllerProps,
        controllerExtras: controllerExtras,
        masterState: masterState,
        derivedState: derivedState,
        queriesState: queriesState,
        actions: actions
    };
    return {
        dialogsProps: (0, $9uaV8.makeDialogsProps)(statesAndActions)
    };
};
function $f9a7e940d2f4f7fe$var$_temp4(operation) {
    return operation?.restrictions.user.results.length;
}
function $f9a7e940d2f4f7fe$var$_temp3() {}
function $f9a7e940d2f4f7fe$var$_temp2() {}
function $f9a7e940d2f4f7fe$var$_temp() {}
const $f9a7e940d2f4f7fe$var$i18n = (0, $cgtv4.defineMessages)({
    loadingErrorTitle: {
        id: "share-and-restrict-dialog.general-access.flags.title.failed-to-load-title",
        defaultMessage: "Access info failed to load"
    },
    loadingErrorBody: {
        id: "share-and-restrict-dialog.general-access.flags.title.failed-to-load-body",
        defaultMessage: "We couldn\u2019t load some data so the access information may not be accurate. Try refreshing now."
    },
    notificationErrorTitle: {
        id: "share-and-restrict-dialog.general-access.flags.title.notification-error-title",
        defaultMessage: "Notification failed to send"
    },
    notificationErrorBody: {
        id: "share-and-restrict-dialog.general-access.flags.title.notification-error-body",
        defaultMessage: "We ran into a problem notifying the people you shared with. Try copying the link."
    },
    listTooLargeNotificationErrorTitle: {
        id: "share-and-restrict-dialog.general-access.flags.title.list-too-large-notification-error-title",
        defaultMessage: "Too many recipients"
    },
    listTooLargeNotificationErrorBody: {
        id: "share-and-restrict-dialog.general-access.flags.title.list-too-large-notification-error-body",
        defaultMessage: "You\u2019re sharing with one or more distribution lists that contain too many people to share with at one time."
    },
    mutationErrorTitle: {
        id: "share-and-restrict-dialog.general-access.flags.title.mutation-error-title",
        defaultMessage: "Access change failed"
    },
    mutationErrorBody: {
        id: "share-and-restrict-dialog.general-access.flags.title.mutation-error-body",
        defaultMessage: "We ran into a problem completing your action. Wait a while and try again."
    },
    notificationTitle: {
        id: "share-and-restrict-dialog.flags.title.notification-sent",
        defaultMessage: "Notification sent"
    },
    alreadyHasAccessTitle: {
        id: "share-and-restrict-dialog.flags.title.already-has-access",
        defaultMessage: "The people added already have access"
    },
    contentSharedTitle: {
        id: "share-and-restrict-dialog.flags.title.content-shared",
        defaultMessage: "Content shared"
    },
    draftSharedTitle: {
        id: "share-and-restrict-dialog.flags.title.draft-shared",
        defaultMessage: "Draft shared"
    },
    accessUpdatedTitle: {
        id: "share-and-restrict-dialog.flags.title.access-updated",
        defaultMessage: "Access updated"
    }
});
const $f9a7e940d2f4f7fe$var$flagMap = {
    'loading-error': [
        $f9a7e940d2f4f7fe$var$i18n.loadingErrorTitle,
        $f9a7e940d2f4f7fe$var$i18n.loadingErrorBody
    ],
    'notification-error': [
        $f9a7e940d2f4f7fe$var$i18n.notificationErrorTitle,
        $f9a7e940d2f4f7fe$var$i18n.notificationErrorBody
    ],
    'list-too-large-error': [
        $f9a7e940d2f4f7fe$var$i18n.listTooLargeNotificationErrorTitle,
        $f9a7e940d2f4f7fe$var$i18n.listTooLargeNotificationErrorBody
    ],
    'mutation-error': [
        $f9a7e940d2f4f7fe$var$i18n.mutationErrorTitle,
        $f9a7e940d2f4f7fe$var$i18n.mutationErrorBody
    ]
};
const $f9a7e940d2f4f7fe$var$successFlagMap = {
    'notification-sent': $f9a7e940d2f4f7fe$var$i18n.notificationTitle,
    'content-shared': $f9a7e940d2f4f7fe$var$i18n.contentSharedTitle,
    'draft-shared': $f9a7e940d2f4f7fe$var$i18n.draftSharedTitle,
    'access-updated': $f9a7e940d2f4f7fe$var$i18n.accessUpdatedTitle,
    'has-access-already': $f9a7e940d2f4f7fe$var$i18n.alreadyHasAccessTitle
};
const $f9a7e940d2f4f7fe$export$5ce7431ecd72def8 = (0, $3u0dr.isReactCompilerActiveV1)() ? (controllerProps)=>{
    const $ = (0, $frIzR.c)(42);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { AutoDismissFlag: AutoDismissFlag } = (0, $lsxnT.useChoreographerAssets)();
    const { flags: flags } = controllerProps;
    const { showErrorFlag: showErrorFlag, showFlag: showFlag } = flags;
    const { contentId: contentId, pushPublishModalRestrictions: pushPublishModalRestrictions, refetchButtonData: refetchButtonData, hasRestrictions: hasRestrictions, hasInheritedRestrictions: hasInheritedRestrictions, hasViewRestrictions: hasViewRestrictions } = controllerProps;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { shareToPrincipals: shareToPrincipals } = (0, $T5KYq.useShareToPrincipals)(contentId);
    const [updateRestrictions] = (0, $1KmJq.useMutation)($f9a7e940d2f4f7fe$var$ControllerDirectRestrictionsMutation);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            source: "shareAndRestrictDialog"
        };
        $[0] = t0;
    } else t0 = $[0];
    const { shouldRenderDisablePublicLinkFeature: shouldRenderDisablePublicLinkFeature } = (0, $jZABW.usePublicLinkDisable)(t0);
    let t1;
    if ($[1] !== controllerProps) {
        t1 = ()=>{
            controllerProps.onClose();
            controllerProps.onCloseComplete?.();
        };
        $[1] = controllerProps;
        $[2] = t1;
    } else t1 = $[2];
    const teardownController = (0, $5bmjx.useTeardownController)(t1);
    const { showSpotlight: isHeaderSpotlightActive } = (0, $3Ipyu.useShouldShowSpotlight)();
    const publicLinkButtonRef = (0, $42omo.useRef)(null);
    const shareToSlackButtonRef = (0, $42omo.useRef)(null);
    let t2;
    if ($[3] !== formatMessage || $[4] !== showErrorFlag) {
        t2 = (reason)=>{
            const [title, description] = $f9a7e940d2f4f7fe$var$flagMap[reason];
            showErrorFlag({
                title: formatMessage(title),
                description: formatMessage(description)
            });
        };
        $[3] = formatMessage;
        $[4] = showErrorFlag;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== AutoDismissFlag || $[7] !== formatMessage || $[8] !== showFlag) {
        t3 = (reason_0)=>{
            const title_0 = $f9a7e940d2f4f7fe$var$successFlagMap[reason_0];
            showFlag({
                type: "success-circle",
                title: formatMessage(title_0),
                customComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AutoDismissFlag, {
                        ...props,
                        messageId: `share-and-restrict-dialog-success-flag-${reason_0}`,
                        messageType: "transactional"
                    })
            });
        };
        $[6] = AutoDismissFlag;
        $[7] = formatMessage;
        $[8] = showFlag;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== shareToPrincipals) {
        t4 = async (stagedNotificationRecipients, optionalMessage)=>{
            const notificationRecipients = (0, $cBa8E.getNotificationRecipients)({
                stagedNotificationRecipients: stagedNotificationRecipients
            });
            await shareToPrincipals({
                notificationRecipients: notificationRecipients,
                message: optionalMessage
            });
        };
        $[10] = shareToPrincipals;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    let t6;
    if ($[12] !== contentId || $[13] !== refetchButtonData || $[14] !== updateRestrictions) {
        t5 = async ()=>{
            await updateRestrictions({
                variables: {
                    pageId: contentId,
                    restrictions: {
                        read: {
                            group: [],
                            user: []
                        },
                        update: {
                            group: [],
                            user: []
                        }
                    }
                }
            });
            refetchButtonData();
        };
        t6 = async (stagedGeneralAccessLevel, principalsMap, currentUser, includeInvites)=>{
            if (stagedGeneralAccessLevel != "open-can-edit") {
                const currentUserInMap = principalsMap.get(currentUser.id);
                if (!currentUserInMap || currentUserInMap.role == "can-view") principalsMap.set(currentUser.id, {
                    role: "can-edit",
                    principal: currentUser,
                    isNewOrUpdatedPrincipal: false
                });
            }
            const restrictions = (0, $4Ewfm.getRestrictionsForMutation)({
                stagedGeneralAccessLevel: stagedGeneralAccessLevel,
                principals: principalsMap
            });
            await updateRestrictions({
                variables: {
                    pageId: contentId,
                    restrictions: {
                        ...restrictions,
                        includeInvites: includeInvites
                    }
                }
            });
            refetchButtonData();
        };
        $[12] = contentId;
        $[13] = refetchButtonData;
        $[14] = updateRestrictions;
        $[15] = t5;
        $[16] = t6;
    } else {
        t5 = $[15];
        t6 = $[16];
    }
    let t7;
    if ($[17] !== pushPublishModalRestrictions) {
        t7 = (stagedGeneralAccessLevel_0, principalsMap_0)=>{
            const restrictions_0 = (0, $4Ewfm.getRestrictionsForPublishModal)({
                stagedGeneralAccessLevel: stagedGeneralAccessLevel_0,
                principals: principalsMap_0
            });
            pushPublishModalRestrictions(restrictions_0);
        };
        $[17] = pushPublishModalRestrictions;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== createAnalyticsEvent) {
        t8 = (t9)=>{
            const { eventType: eventType, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, source: t10 } = t9;
            const source = t10 === undefined ? $f9a7e940d2f4f7fe$export$219d516b185caa05 : t10;
            createAnalyticsEvent({
                type: eventType,
                data: {
                    source: source,
                    action: action,
                    actionSubject: actionSubject,
                    actionSubjectId: actionSubjectId,
                    attributes: attributes
                }
            }).fire();
        };
        $[19] = createAnalyticsEvent;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== cloudId || $[22] !== experienceTracker || $[23] !== formatMessage || $[24] !== hasInheritedRestrictions || $[25] !== hasRestrictions || $[26] !== hasViewRestrictions || $[27] !== isHeaderSpotlightActive || $[28] !== shouldRenderDisablePublicLinkFeature || $[29] !== showErrorFlag || $[30] !== showFlag || $[31] !== t2 || $[32] !== t3 || $[33] !== t4 || $[34] !== t5 || $[35] !== t6 || $[36] !== t7 || $[37] !== t8 || $[38] !== teardownController) {
        t9 = {
            errorFlag: t2,
            successFlag: t3,
            showFlag: showFlag,
            showErrorFlag: showErrorFlag,
            sendNotification: t4,
            callResolveMismatchedRestrictions: t5,
            mutateContentRestrictions: t6,
            exportPublishModalRestrictions: t7,
            teardownController: teardownController,
            fireAnalyticEvent: t8,
            experienceTracker: experienceTracker,
            shouldRenderDisablePublicLinkFeature: shouldRenderDisablePublicLinkFeature,
            formatMessage: formatMessage,
            isHeaderSpotlightActive: isHeaderSpotlightActive,
            publicLinkButtonRef: publicLinkButtonRef,
            shareToSlackButtonRef: shareToSlackButtonRef,
            hasRestrictions: hasRestrictions,
            hasInheritedRestrictions: hasInheritedRestrictions,
            hasViewRestrictions: hasViewRestrictions,
            cloudId: cloudId
        };
        $[21] = cloudId;
        $[22] = experienceTracker;
        $[23] = formatMessage;
        $[24] = hasInheritedRestrictions;
        $[25] = hasRestrictions;
        $[26] = hasViewRestrictions;
        $[27] = isHeaderSpotlightActive;
        $[28] = shouldRenderDisablePublicLinkFeature;
        $[29] = showErrorFlag;
        $[30] = showFlag;
        $[31] = t2;
        $[32] = t3;
        $[33] = t4;
        $[34] = t5;
        $[35] = t6;
        $[36] = t7;
        $[37] = t8;
        $[38] = teardownController;
        $[39] = t9;
    } else t9 = $[39];
    const controllerExtras = t9;
    const { dialogsProps: dialogsProps } = $f9a7e940d2f4f7fe$var$useController(controllerProps, controllerExtras);
    let t10;
    if ($[40] !== dialogsProps) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uhfT.Dialogs), dialogsProps);
        $[40] = dialogsProps;
        $[41] = t10;
    } else t10 = $[41];
    return t10;
} : (controllerProps)=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { AutoDismissFlag: AutoDismissFlag } = (0, $lsxnT.useChoreographerAssets)();
    const { flags: flags } = controllerProps;
    const { showErrorFlag: showErrorFlag, showFlag: showFlag } = flags;
    const { contentId: contentId, pushPublishModalRestrictions: pushPublishModalRestrictions, refetchButtonData: refetchButtonData, hasRestrictions: hasRestrictions, hasInheritedRestrictions: hasInheritedRestrictions, hasViewRestrictions: hasViewRestrictions } = controllerProps;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { shareToPrincipals: shareToPrincipals } = (0, $T5KYq.useShareToPrincipals)(contentId);
    const [updateRestrictions] = (0, $1KmJq.useMutation)($f9a7e940d2f4f7fe$var$ControllerDirectRestrictionsMutation);
    const { shouldRenderDisablePublicLinkFeature: shouldRenderDisablePublicLinkFeature } = (0, $jZABW.usePublicLinkDisable)({
        source: 'shareAndRestrictDialog'
    });
    const teardownController = (0, $5bmjx.useTeardownController)(()=>{
        controllerProps.onClose();
        controllerProps.onCloseComplete?.();
    });
    const { showSpotlight: isHeaderSpotlightActive } = (0, $3Ipyu.useShouldShowSpotlight)();
    const publicLinkButtonRef = (0, $42omo.useRef)(null);
    const shareToSlackButtonRef = (0, $42omo.useRef)(null);
    /**
   * The functions that the Controller component can provide to the hook.
   * Mutations, flags, fetch requests...
   */ const controllerExtras = {
        errorFlag: (reason)=>{
            const [title, description] = $f9a7e940d2f4f7fe$var$flagMap[reason];
            showErrorFlag({
                title: formatMessage(title),
                description: formatMessage(description)
            });
        },
        successFlag: (reason_0)=>{
            const title_0 = $f9a7e940d2f4f7fe$var$successFlagMap[reason_0];
            showFlag({
                type: 'success-circle',
                title: formatMessage(title_0),
                customComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AutoDismissFlag, {
                        ...props,
                        messageId: `share-and-restrict-dialog-success-flag-${reason_0}`,
                        messageType: "transactional"
                    })
            });
        },
        showFlag: showFlag,
        showErrorFlag: showErrorFlag,
        sendNotification: async (stagedNotificationRecipients, optionalMessage)=>{
            const notificationRecipients = (0, $cBa8E.getNotificationRecipients)({
                stagedNotificationRecipients: stagedNotificationRecipients
            });
            await shareToPrincipals({
                notificationRecipients: notificationRecipients,
                message: optionalMessage
            });
        },
        callResolveMismatchedRestrictions: async ()=>{
            await updateRestrictions({
                variables: {
                    pageId: contentId,
                    restrictions: {
                        read: {
                            group: [],
                            user: []
                        },
                        update: {
                            group: [],
                            user: []
                        }
                    }
                }
            });
            refetchButtonData();
        },
        mutateContentRestrictions: async (stagedGeneralAccessLevel, principalsMap, currentUser, includeInvites)=>{
            if (stagedGeneralAccessLevel != 'open-can-edit') {
                const currentUserInMap = principalsMap.get(currentUser.id);
                if (!currentUserInMap || currentUserInMap.role == 'can-view') principalsMap.set(currentUser.id, {
                    role: 'can-edit',
                    principal: currentUser,
                    isNewOrUpdatedPrincipal: false
                });
            }
            const restrictions = (0, $4Ewfm.getRestrictionsForMutation)({
                stagedGeneralAccessLevel: stagedGeneralAccessLevel,
                principals: principalsMap
            });
            await updateRestrictions({
                variables: {
                    pageId: contentId,
                    restrictions: {
                        ...restrictions,
                        includeInvites: includeInvites
                    }
                }
            });
            refetchButtonData();
        },
        exportPublishModalRestrictions: (stagedGeneralAccessLevel_0, principalsMap_0)=>{
            const restrictions_0 = (0, $4Ewfm.getRestrictionsForPublishModal)({
                stagedGeneralAccessLevel: stagedGeneralAccessLevel_0,
                principals: principalsMap_0
            });
            pushPublishModalRestrictions(restrictions_0);
        },
        teardownController: teardownController,
        fireAnalyticEvent: ({ eventType: eventType, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, source: source = $f9a7e940d2f4f7fe$export$219d516b185caa05 })=>{
            createAnalyticsEvent({
                type: eventType,
                data: {
                    source: source,
                    action: action,
                    actionSubject: actionSubject,
                    actionSubjectId: actionSubjectId,
                    attributes: attributes
                }
            }).fire();
        },
        experienceTracker: experienceTracker,
        shouldRenderDisablePublicLinkFeature: shouldRenderDisablePublicLinkFeature,
        formatMessage: formatMessage,
        isHeaderSpotlightActive: isHeaderSpotlightActive,
        publicLinkButtonRef: publicLinkButtonRef,
        shareToSlackButtonRef: shareToSlackButtonRef,
        hasRestrictions: hasRestrictions,
        hasInheritedRestrictions: hasInheritedRestrictions,
        hasViewRestrictions: hasViewRestrictions,
        cloudId: cloudId
    };
    const { dialogsProps: dialogsProps } = $f9a7e940d2f4f7fe$var$useController(controllerProps, controllerExtras);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uhfT.Dialogs), dialogsProps);
};
const $f9a7e940d2f4f7fe$export$bd0bf19f25da8474 = (0, $7aRa9.withFlags)($f9a7e940d2f4f7fe$export$5ce7431ecd72def8);
module.exports["SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE"] = $f9a7e940d2f4f7fe$export$219d516b185caa05;
module.exports["SAC_CONTENT_ADD_REMOVE_DOCUMENTATION"] = $f9a7e940d2f4f7fe$export$b1e4cd5fa4074c7a;
module.exports["SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION"] = $f9a7e940d2f4f7fe$export$ce504fce6cf8855f;
module.exports["ControllerComponent"] = $f9a7e940d2f4f7fe$export$5ce7431ecd72def8;
module.exports["Controller"] = $f9a7e940d2f4f7fe$export$bd0bf19f25da8474;

});

parcelRegister("cOQPm", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $e09975e6fa5c8d51$export$1b73a1e3cf498433 = 'ids-invited-from-usd';
const $e09975e6fa5c8d51$export$96b35192759235f0 = ()=>{
    const cachedInvites = (0, $17wUi.confluenceSessionStorageInstance).getItem($e09975e6fa5c8d51$export$1b73a1e3cf498433);
    return cachedInvites ? JSON.parse(cachedInvites) : [];
};
const $e09975e6fa5c8d51$export$eb106122e112a025 = (invites)=>{
    (0, $17wUi.confluenceSessionStorageInstance).setItem($e09975e6fa5c8d51$export$1b73a1e3cf498433, JSON.stringify(invites));
};
const $e09975e6fa5c8d51$export$15440e49d0130132 = (invites)=>{
    const cachedInvites = $e09975e6fa5c8d51$export$96b35192759235f0();
    $e09975e6fa5c8d51$export$eb106122e112a025([
        ...cachedInvites,
        ...invites
    ]);
};
module.exports["getCachedInvites"] = $e09975e6fa5c8d51$export$96b35192759235f0;
module.exports["updateCachedInvites"] = $e09975e6fa5c8d51$export$15440e49d0130132;

});

parcelRegister("8oEoE", function(module, exports) {
/**
 * @generated SignedSource<<b737a884b4d09b51b8ecb9521d585d5a>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $0f8a7127f2228c42$export$e7c9280c9da1cc0a = /*#__PURE__*/ function(ConfluenceGroupUsageType) {
    ConfluenceGroupUsageType["ADMIN_OVERSIGHT"] = "ADMIN_OVERSIGHT";
    ConfluenceGroupUsageType["TEAM_COLLABORATION"] = "TEAM_COLLABORATION";
    ConfluenceGroupUsageType["USERBASE_GROUP"] = "USERBASE_GROUP";
    return ConfluenceGroupUsageType;
}({});
var $0f8a7127f2228c42$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["ConfluenceGroupUsageType"] = $0f8a7127f2228c42$export$e7c9280c9da1cc0a;

});

parcelRegister("1fjr9", function(module, exports) {

var $8oEoE = parcelRequire("8oEoE");

function $6ae0cc53b6a5ae8c$export$ea5292b0643714e2(restrictions, currentUser) {
    const readAndUpdateLists = $6ae0cc53b6a5ae8c$var$convertRestrictionsObject(restrictions);
    const { groupCount: groupCount, teamCount: teamCount, userCount: userCount, principals: principals, currentUserHasAccess: currentUserHasAccess } = $6ae0cc53b6a5ae8c$export$9910d0d832defd77(readAndUpdateLists, currentUser);
    return {
        generalAccessLevel: $6ae0cc53b6a5ae8c$export$348a31f6b2aa49f4(readAndUpdateLists),
        principals: principals,
        groupCount: groupCount,
        teamCount: teamCount,
        userCount: userCount,
        currentUserHasAccess: currentUserHasAccess
    };
}
/**
 * Converts the 'read' and 'update' structures from the query data into their
 * structural equivalents but using our own Principal
 */ function $6ae0cc53b6a5ae8c$var$convertRestrictionsObject(source) {
    const ret = {
        read: {
            users: [],
            groups: []
        },
        update: {
            users: [],
            groups: []
        }
    };
    const { read: read, update: update, groupAndTeamCountsMap: groupAndTeamCountsMap, teamData: teamData } = source;
    if (read) $6ae0cc53b6a5ae8c$var$convertUsersAndGroups(read, ret.read, groupAndTeamCountsMap, teamData);
    if (update) $6ae0cc53b6a5ae8c$var$convertUsersAndGroups(update, ret.update, groupAndTeamCountsMap, teamData);
    return ret;
}
/**
 * Iterates through the users and groups nodes of query data, converting
 * entries into Principal format, and pushing them to accumulators
 */ function $6ae0cc53b6a5ae8c$var$convertUsersAndGroups(source, { users: users, groups: groups }, groupAndTeamCountsMap, teamData) {
    const { restrictions: restrictions } = source;
    if (restrictions) {
        const { userWithRestrictions: userWithRestrictions, group: group } = restrictions;
        if (userWithRestrictions) $6ae0cc53b6a5ae8c$var$pushUserNodes(userWithRestrictions, users);
        if (group) $6ae0cc53b6a5ae8c$var$pushGroupNodes(group, groups, groupAndTeamCountsMap, teamData);
    }
}
function $6ae0cc53b6a5ae8c$export$348a31f6b2aa49f4({ read: { groups: readGroups, users: readUsers }, update: { groups: updateGroups, users: updateUsers } }) {
    const hasViewPrincipals = readGroups.length + readUsers.length > 0;
    const hasEditPrincipals = updateGroups.length + updateUsers.length > 0;
    if (hasViewPrincipals) return 'restricted';
    if (hasEditPrincipals) return 'open-can-view';
    return 'open-can-edit';
}
function $6ae0cc53b6a5ae8c$export$9910d0d832defd77({ read: read, update: update }, currentUser) {
    const map = new Map();
    const addToMapWithRole = (principals, role)=>principals.forEach((principal)=>map.set(principal.id, {
                role: role,
                principal: principal
            }));
    // Initially, populate the map with viewers
    addToMapWithRole([
        ...read.users,
        ...read.groups
    ], 'can-view');
    // Do another pass for the editors, potentially overwriting entries set in the
    // first pass, with their edit role
    addToMapWithRole([
        ...update.users,
        ...update.groups
    ], 'can-edit');
    // Convert the map to a PrincipalAndRole array, and sort by name
    const unsortedArray = Array.from(map).map(([, principalAndRole])=>principalAndRole);
    const { groupCount: groupCount, teamCount: teamCount, userCount: userCount } = unsortedArray.reduce((counts, { principal: principal })=>{
        if (principal.type === 'group') {
            if (principal.usageType === (0, $8oEoE.ConfluenceGroupUsageType).USERBASE_GROUP) counts.groupCount++;
            else if (principal.usageType === (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION) counts.teamCount++;
            else if (principal.usageType === null) // When usageType is null (because the BE sends the data but teams are not yet supported on the FE),
            // fall back to default user base group behavior
            counts.groupCount++;
        }
        if (principal.type === 'user') counts.userCount++;
        return counts;
    }, {
        groupCount: 0,
        teamCount: 0,
        userCount: 0
    });
    const currentUserHasAccess = unsortedArray.some(({ principal: principal })=>principal.id === currentUser.id);
    return {
        principals: Array.from(map).map(([, principalAndRole])=>principalAndRole).sort(({ principal: { name: a } }, { principal: { name: b } })=>{
            if (a === b) return 0;
            else if (a > b) return 1;
            return -1;
        }),
        currentUserHasAccess: currentUserHasAccess,
        groupCount: groupCount,
        teamCount: teamCount,
        userCount: userCount
    };
}
/**
 * Converts groups from query format to Principal format, and pushes them to an accumulator
 */ function $6ae0cc53b6a5ae8c$var$pushGroupNodes(source, dest, groupAndTeamCountsMap, teamData) {
    const { nodes: nodes } = source;
    if (nodes) for (const node of nodes){
        if (!node) continue;
        const id = node?.id || '';
        const team = node?.usageType === (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION ? teamData?.[id] : undefined;
        dest.push({
            type: 'group',
            id: node.id || '',
            name: node.name || '',
            usageType: node.usageType,
            memberCount: groupAndTeamCountsMap.get(node.id || '') ?? 0,
            isVerified: team?.isVerified ?? false,
            avatarSrc: team?.largeAvatarImageUrl ?? ''
        });
    }
}
/**
 * Converts users from query format to Principal format, and pushes them to an accumulator
 */ function $6ae0cc53b6a5ae8c$var$pushUserNodes(source, dest) {
    const { nodes: nodes } = source;
    if (nodes) for (const node of nodes){
        if (!node) continue;
        /**
       * TODO: there are some fields we were querying for in the Restrictions
       * dialog, but not using here (yet):
       * • type
       */ dest.push({
            type: 'user',
            id: node.accountId || '',
            name: node.displayName || '',
            avatarUrl: node.profilePicture?.path || '',
            // TODO
            email: node.email || '',
            knownErrors: $6ae0cc53b6a5ae8c$export$9bc75062b1d89a4d(node),
            sitePermissionType: node.permissionType || ''
        });
    }
}
function $6ae0cc53b6a5ae8c$export$9bc75062b1d89a4d(node) {
    const { restrictingContent: restrictingContent, hasSpaceEditPermission: hasSpaceEditPermission, hasSpaceViewPermission: hasSpaceViewPermission } = node;
    if (hasSpaceViewPermission === false) return {
        accessWarning: 'space-view-access-warning',
        parentLink: null
    };
    if (restrictingContent) return {
        accessWarning: 'parent-access-warning',
        parentLink: {
            webui: restrictingContent.links?.webui,
            base: restrictingContent.links?.base
        }
    };
    // TODO: Implement a check for the principal's current access level.
    // If the access level is 'view', it's not relevant.
    // If the access level is 'edit', it is relevant.
    if (hasSpaceEditPermission === false) return {
        accessWarning: 'space-edit-access-warning',
        parentLink: null
    };
    return undefined;
}
module.exports["getContentRestrictions"] = $6ae0cc53b6a5ae8c$export$ea5292b0643714e2;
module.exports["getPrincipalsAndRoles"] = $6ae0cc53b6a5ae8c$export$9910d0d832defd77;
module.exports["getGeneralAccessLevel"] = $6ae0cc53b6a5ae8c$export$348a31f6b2aa49f4;
module.exports["getKnownErrors"] = $6ae0cc53b6a5ae8c$export$9bc75062b1d89a4d;

});

parcelRegister("2Snr1", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $455278fb4860e860$export$fad5f226cecfdfbf = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.8837 13.367C19.9601 12.9228 20 12.466 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C12.466 20 12.9228 19.9601 13.367 19.8837C13.1304 19.3023 13 18.6664 13 18C13 17.8036 13.0113 17.6099 13.0333 17.4195C12.9034 17.622 12.7713 17.7875 12.6409 17.9161C12.3763 18.1772 12.1606 18.25 12 18.25C11.8394 18.25 11.6237 18.1772 11.3591 17.9161C11.0913 17.6518 10.8157 17.2321 10.568 16.6543C10.1416 15.6593 9.84191 14.2977 9.76783 12.75L14.2322 12.75C14.1914 13.6024 14.0821 14.3983 13.921 15.1076C14.3759 14.4673 14.9778 13.9386 15.6776 13.5709C15.7028 13.3018 15.7216 13.0278 15.7337 12.75H18.4572C18.4469 12.8397 18.4348 12.9289 18.4208 13.0175C18.9344 13.0603 19.426 13.1807 19.8837 13.367ZM10.568 7.34569C10.1416 8.34074 9.84191 9.70234 9.76783 11.25L14.2322 11.25C14.1581 9.70234 13.8584 8.34074 13.432 7.34569C13.1843 6.7679 12.9087 6.34823 12.6409 6.08391C12.3763 5.82276 12.1606 5.75 12 5.75C11.8394 5.75 11.6237 5.82276 11.3591 6.08391C11.0913 6.34823 10.8157 6.7679 10.568 7.34569ZM15.7337 11.25L18.4572 11.25C18.1804 8.84094 16.5866 6.83252 14.4139 5.96299C14.5588 6.20973 14.6909 6.47541 14.8107 6.75481C15.328 7.96182 15.6587 9.53144 15.7337 11.25ZM5.5428 11.25L8.26628 11.25C8.34127 9.53144 8.67203 7.96182 9.18932 6.75481C9.30907 6.47541 9.44124 6.20974 9.58609 5.96299C7.41342 6.83252 5.81958 8.84094 5.5428 11.25ZM8.26628 12.75H5.5428C5.81958 15.1591 7.41342 17.1675 9.58609 18.037C9.44124 17.7903 9.30906 17.5246 9.18932 17.2452C8.67203 16.0382 8.34127 14.4686 8.26628 12.75Z",
            fill: "var(--ds-text-subtle, #505258)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
            cx: "18",
            cy: "18",
            r: "3",
            fill: "var(--ds-icon-accent-green, #22A06B)"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.8837 13.367C19.9601 12.9228 20 12.466 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C12.466 20 12.9228 19.9601 13.367 19.8837C13.1304 19.3023 13 18.6664 13 18C13 17.8036 13.0113 17.6099 13.0333 17.4195C12.9034 17.622 12.7713 17.7875 12.6409 17.9161C12.3763 18.1772 12.1606 18.25 12 18.25C11.8394 18.25 11.6237 18.1772 11.3591 17.9161C11.0913 17.6518 10.8157 17.2321 10.568 16.6543C10.1416 15.6593 9.84191 14.2977 9.76783 12.75L14.2322 12.75C14.1914 13.6024 14.0821 14.3983 13.921 15.1076C14.3759 14.4673 14.9778 13.9386 15.6776 13.5709C15.7028 13.3018 15.7216 13.0278 15.7337 12.75H18.4572C18.4469 12.8397 18.4348 12.9289 18.4208 13.0175C18.9344 13.0603 19.426 13.1807 19.8837 13.367ZM10.568 7.34569C10.1416 8.34074 9.84191 9.70234 9.76783 11.25L14.2322 11.25C14.1581 9.70234 13.8584 8.34074 13.432 7.34569C13.1843 6.7679 12.9087 6.34823 12.6409 6.08391C12.3763 5.82276 12.1606 5.75 12 5.75C11.8394 5.75 11.6237 5.82276 11.3591 6.08391C11.0913 6.34823 10.8157 6.7679 10.568 7.34569ZM15.7337 11.25L18.4572 11.25C18.1804 8.84094 16.5866 6.83252 14.4139 5.96299C14.5588 6.20973 14.6909 6.47541 14.8107 6.75481C15.328 7.96182 15.6587 9.53144 15.7337 11.25ZM5.5428 11.25L8.26628 11.25C8.34127 9.53144 8.67203 7.96182 9.18932 6.75481C9.30907 6.47541 9.44124 6.20974 9.58609 5.96299C7.41342 6.83252 5.81958 8.84094 5.5428 11.25ZM8.26628 12.75H5.5428C5.81958 15.1591 7.41342 17.1675 9.58609 18.037C9.44124 17.7903 9.30906 17.5246 9.18932 17.2452C8.67203 16.0382 8.34127 14.4686 8.26628 12.75Z",
        fill: "var(--ds-text-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "18",
        cy: "18",
        r: "3",
        fill: "var(--ds-icon-accent-green, #22A06B)"
    }));
module.exports["WorldGreenDotGlyph"] = $455278fb4860e860$export$fad5f226cecfdfbf;

});

parcelRegister("iKskQ", function(module, exports) {
/* SpaceIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $buthI = parcelRequire("buthI");


var $4wwVl = parcelRequire("4wwVl");

const $b378bfc9d198c46c$var$spaceImgStyles = {
    default: "_19itidpf _1o9zidpf _bfhkizff",
    loaded: "_bfhk1j28"
};
const $b378bfc9d198c46c$var$AvatarStyles = {
    xsmall: "_2rko12b0 _1bsbgktf _4t3igktf",
    small: "_2rkolb4i _1bsb1tcg _4t3i1tcg",
    medium: "_2rkofajl _1bsbzwfg _4t3izwfg",
    large: "_2rkofajl _1bsb1ylp _4t3i1ylp",
    xlarge: "_2rko1qi0 _1bsb16xz _4t3i16xz"
};
const $b378bfc9d198c46c$export$b14ad400b1d09e0f = {
    global: (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
    personal: (0, (/*@__PURE__*/$parcel$interopDefault($4wwVl)))
};
const $b378bfc9d198c46c$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $42omo.memo)(({ type: type, label: label = '', size: size = 'medium', src: src, testId: testId })=>{
    const [imgLoaded, setImgLoaded] = (0, $42omo.useState)(!src);
    const setLoaded = (0, $42omo.useCallback)(()=>{
        setImgLoaded(true);
    }, [
        setImgLoaded
    ]);
    if (src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: src?.includes('/wiki') || src?.startsWith('http') ? src : `/wiki${src}`,
        alt: label,
        onLoad: setLoaded,
        onError: setLoaded,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $b378bfc9d198c46c$var$spaceImgStyles['default'],
            imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles['loaded'],
            $b378bfc9d198c46c$var$AvatarStyles[size]
        ])
    });
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        testId: testId
    });
});
module.exports["SpaceIcon"] = $b378bfc9d198c46c$export$38ffce4a7986ba20;

});

parcelRegister("2rrpN", function(module, exports) {

var $cOQPm = parcelRequire("cOQPm");


var $1fjr9 = parcelRequire("1fjr9");


var $1vrmd = parcelRequire("1vrmd");

const $f0b77ee9aa683a00$var$addGroupAndTeamData = (restrictions, groupAndTeamCountsMap, teamData)=>({
        ...restrictions,
        groupAndTeamCountsMap: groupAndTeamCountsMap,
        teamData: teamData
    });
function $f0b77ee9aa683a00$export$1864618d14e03dd7(data, publicLinkPageData, spaceKey, contentType, edition, disableSharingToEmails = false, groupAndTeamCountsMap, teamData, requestedUsersPendingApproval) {
    const currentUser = (0, $1vrmd.getCurrentUserPrincipal)(data.user);
    if (!currentUser) return null;
    const contentData = $f0b77ee9aa683a00$var$getContentData(data.content, currentUser, groupAndTeamCountsMap, teamData);
    if (!contentData) return null;
    const principalsPendingAccess = $f0b77ee9aa683a00$export$406b6435d7a02517(contentData.contentRestrictions.principals, requestedUsersPendingApproval);
    return {
        ...contentData,
        spaceKey: spaceKey,
        currentUser: currentUser,
        publicLinkPageData: publicLinkPageData,
        userCanEditContent: $f0b77ee9aa683a00$export$84b461ed686ebfb9(data, contentType),
        userCanEditRestrictions: $f0b77ee9aa683a00$export$d407e9ce7f74386b(data, contentData.contentRestrictions.generalAccessLevel, contentType),
        edition: edition,
        disableSharingToEmails: disableSharingToEmails,
        principalsPendingAccess: principalsPendingAccess
    };
}
function $f0b77ee9aa683a00$export$84b461ed686ebfb9(data, contentType) {
    const contentNode = data?.content?.nodes?.[0];
    const operationsData = contentNode?.operations || [];
    return operationsData.some((operation)=>operation?.operation === 'update' && operation?.targetType === contentType);
}
function $f0b77ee9aa683a00$export$d407e9ce7f74386b(data, generalAccessLevel, contentType) {
    const contentNode = data?.content?.nodes?.[0];
    const operationsData = contentNode?.operations || [];
    const isSpaceAdmin = data?.space?.currentUser?.isAdmin || false;
    // Check if the current content type has a restrict_content operation
    const canRestrictContent = operationsData.some((operation)=>operation?.operation === 'restrict_content' && operation?.targetType === contentType);
    if (generalAccessLevel === 'open-can-edit') return canRestrictContent;
    const userHasEditRestrictions = operationsData.some((operation)=>operation?.operation === 'update' && operation?.targetType === contentType);
    return canRestrictContent && userHasEditRestrictions || isSpaceAdmin;
}
/**  Extracts all the QueriesState data that can be obtained from the `content` node */ function $f0b77ee9aa683a00$var$getContentData(content, currentUser, groupAndTeamCountsMap, teamData) {
    if (!content) return null;
    const { nodes: nodes } = content;
    if (!nodes) return null;
    const [node0] = nodes;
    if (!node0) return null;
    const { restrictions: restrictions, hasInheritedRestrictions: hasInheritedRestrictions, ancestors: ancestors } = node0;
    if (!restrictions) return null;
    const restrictionsWithGroupAndTeamData = $f0b77ee9aa683a00$var$addGroupAndTeamData(restrictions, groupAndTeamCountsMap, teamData);
    const contentRestrictionsAndCounts = (0, $1fjr9.getContentRestrictions)(restrictionsWithGroupAndTeamData, currentUser);
    if (!contentRestrictionsAndCounts) return null;
    const parentPageLink = hasInheritedRestrictions ? $f0b77ee9aa683a00$export$152ce6697c74bacb(ancestors) : null;
    return {
        contentRestrictions: {
            generalAccessLevel: contentRestrictionsAndCounts.generalAccessLevel,
            principals: contentRestrictionsAndCounts.principals
        },
        numberOfAncestors: ancestors?.length || 0,
        groupCount: contentRestrictionsAndCounts.groupCount,
        teamCount: contentRestrictionsAndCounts.teamCount,
        userCount: contentRestrictionsAndCounts.userCount,
        currentUserHasAccess: contentRestrictionsAndCounts.currentUserHasAccess,
        hasInheritedRestrictions: hasInheritedRestrictions,
        parentPageLink: parentPageLink
    };
}
function $f0b77ee9aa683a00$export$152ce6697c74bacb(ancestors) {
    const closestBoundingPage = {
        id: '',
        link: null
    };
    // Last ancestor is closest bounding
    if (ancestors) {
        for(let i = ancestors.length - 1; i >= 0; i--)if (ancestors[i]?.hasViewRestrictions) {
            closestBoundingPage.id = ancestors[i]?.id || '';
            closestBoundingPage.link = ancestors[i]?.links?.webui;
            break;
        }
    }
    return closestBoundingPage.link;
}
function $f0b77ee9aa683a00$export$406b6435d7a02517(existingPrincipals, requestedUsersPendingApproval) {
    return requestedUsersPendingApproval.filter((node)=>node !== null).filter((node)=>!existingPrincipals.some((principal)=>principal.principal.id === node.accessRequestedAaid)).map((node)=>{
        const avatarUrl = node.user?.photos?.find((photo)=>photo?.isPrimary === true)?.value ?? '';
        const email = node.user?.emails?.find((e)=>e?.isPrimary === true)?.value ?? '';
        const cachedInvites = (0, $cOQPm.getCachedInvites)();
        const knownErrors = {
            accessWarning: cachedInvites.includes(node.accessRequestedAaid) ? 'pending-userbase-propagation-warning' : 'pending-site-access-warning',
            parentLink: null
        };
        const principal = {
            type: 'user',
            id: node.accessRequestedAaid,
            name: node.user?.displayName ?? '',
            avatarUrl: avatarUrl,
            email: email,
            knownErrors: knownErrors,
            sitePermissionType: ''
        };
        let role;
        if (node.requestAccessType === 'EDIT') role = 'can-edit';
        else if (node.requestAccessType === 'VIEW') role = 'can-view';
        else role = 'no-access';
        return {
            principal: principal,
            role: role
        };
    });
}
module.exports["dataToQueriesState"] = $f0b77ee9aa683a00$export$1864618d14e03dd7;
module.exports["canSetRestrictions"] = $f0b77ee9aa683a00$export$d407e9ce7f74386b;
module.exports["getClosestAncestorWithViewRestrictions"] = $f0b77ee9aa683a00$export$152ce6697c74bacb;

});

parcelRegister("1vrmd", function(module, exports) {
function $979045d6a0d5e8cc$export$ebb637dbfb7941d3(user) {
    if (!user) return null;
    // Insist on a bare minimum of profile data
    const { id: id, displayName: displayName, photos: photos, emails: emails } = user;
    if (!id) return null;
    if (!displayName) return null;
    return {
        type: 'user',
        id: id,
        name: displayName,
        avatarUrl: $979045d6a0d5e8cc$var$getPrimaryValue(photos),
        email: $979045d6a0d5e8cc$var$getPrimaryValue(emails),
        knownErrors: undefined,
        sitePermissionType: 'INTERNAL'
    };
}
function $979045d6a0d5e8cc$var$getPrimaryValue(maybeList) {
    let best = '';
    if (maybeList) for (const item of maybeList){
        if (!item) continue;
        const { value: value, isPrimary: isPrimary } = item;
        if (!value) continue;
        best = value;
        if (isPrimary) break;
    }
    return best;
}
module.exports["getCurrentUserPrincipal"] = $979045d6a0d5e8cc$export$ebb637dbfb7941d3;

});

parcelRegister("lgKMU", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d6607a34d68309a3$export$9542b2119eeb5eb4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2Q0Hi",
    name: "ShareAndRestrictDialogController",
    loader: async ()=>(await Promise.resolve((parcelRequire("4adOe")))).Controller
});
module.exports["ShareAndRestrictDialogController"] = $d6607a34d68309a3$export$9542b2119eeb5eb4;

});

parcelRegister("ajdQJ", function(module, exports) {
class $78166bfa877f38c2$var$SafeString {
    constructor(value){
        this.value = value;
        this.valueOf = this.toString = this.toJSON = ()=>this.value;
    }
}
const $78166bfa877f38c2$export$b91bb42a4e3ff500 = (value)=>new $78166bfa877f38c2$var$SafeString(value);
const $78166bfa877f38c2$export$7d336779073e9481 = (value)=>value instanceof $78166bfa877f38c2$var$SafeString;
const $78166bfa877f38c2$export$2a4aba80518f1883 = (...allowedStrings)=>(value)=>allowedStrings.includes(value) ? Object.freeze(new $78166bfa877f38c2$var$SafeString(value)) : value;
module.exports["dangerouslyCreateSafeString"] = $78166bfa877f38c2$export$b91bb42a4e3ff500;
module.exports["markAsSafe"] = $78166bfa877f38c2$export$2a4aba80518f1883;

});

parcelRegister("1BYn9", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $fWkVZ = parcelRequire("fWkVZ");

const $141bd073c52fec74$export$44f5b9746e66da9 = ()=>{
    const { data: data, error: error, loading: isAdminCheckLoading } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useIsProductAdminUseIsProductAdminQuery{user:confluence_atlassianUser(current:true){id confluence{operations{operation targetType}}}isSiteAdmin hasUserAccessAdminRole}`);
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(data);
    return {
        isProductAdmin: isProductAdmin,
        isAdminCheckLoading: isAdminCheckLoading
    };
};
module.exports["useIsProductAdmin"] = $141bd073c52fec74$export$44f5b9746e66da9;

});

parcelRegister("letmB", function(module, exports) {

var $a2xFu = parcelRequire("a2xFu");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $8HDoM = parcelRequire("8HDoM");


var $vOJcF = parcelRequire("vOJcF");

const $a2d59a8e8d049c83$export$c3db30b0866daf5a = 'companyHubAnnouncementBannerId';
const $a2d59a8e8d049c83$export$324fa2b24bd3bd0 = async (contentId, tenantId)=>{
    try {
        // Fetch the announcement banner id from the page properties
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: dataAnnouncementBanner } = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $8HDoM.CompanyHubAnnouncementBannerQuery),
            variables: {
                pageId: (0, $a2xFu.ConfluencePageAri).create({
                    siteId: tenantId,
                    pageId: contentId
                }).toString(),
                keys: [
                    $a2d59a8e8d049c83$export$c3db30b0866daf5a
                ]
            }
        });
        const bannerId = dataAnnouncementBanner?.confluence?.page?.properties?.[0]?.value;
        if (!bannerId) return {
            bannerId: null
        };
        // If the announcement banner exists check banner status
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: dataAnnouncementBannerStatus } = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $vOJcF.CompanyHubAnnouncementBannerStatusQuery),
            variables: {
                bannerId: bannerId
            }
        });
        return {
            bannerId: bannerId,
            bannerStatus: dataAnnouncementBannerStatus?.adminAnnouncementBannerSetting?.status
        };
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMPANY_HUB
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return {
            bannerId: null
        };
    }
};
module.exports["COMPANY_HUB_ANNOUNCEMENT_BANNER_CONTENT_PROPERTY_KEY"] = $a2d59a8e8d049c83$export$c3db30b0866daf5a;
module.exports["getCompanyHubAnnouncementBanner"] = $a2d59a8e8d049c83$export$324fa2b24bd3bd0;

});

parcelRegister("8HDoM", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $b548b68664ebb0d0$export$89196b32c22f357e = (0, $eSUdr.default)`query CompanyHubAnnouncementBannerQuery($pageId:ID!$keys:[String]!){confluence{page(id:$pageId){id properties(keys:$keys){key value}}}}`;
module.exports["CompanyHubAnnouncementBannerQuery"] = $b548b68664ebb0d0$export$89196b32c22f357e;

});

parcelRegister("vOJcF", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $bee353d845b65bc1$export$b7c5a946c2c575d = (0, $eSUdr.default)`query CompanyHubAnnouncementBannerStatusQuery($bannerId:String!){adminAnnouncementBannerSetting(id:$bannerId){id status}}`;
module.exports["CompanyHubAnnouncementBannerStatusQuery"] = $bee353d845b65bc1$export$b7c5a946c2c575d;

});

parcelRegister("k7Jwr", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $0714d46e5830d709$export$99fe151f78e1a08f = /*#__PURE__*/ function(GraphQLFrontCoverState) {
    GraphQLFrontCoverState["HIDDEN"] = "HIDDEN";
    GraphQLFrontCoverState["SHOWN"] = "SHOWN";
    GraphQLFrontCoverState["UNSET"] = "UNSET";
    return GraphQLFrontCoverState;
}({});
module.exports["GraphQLFrontCoverState"] = $0714d46e5830d709$export$99fe151f78e1a08f;

});

parcelRegister("5wLVq", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");


var $k7Jwr = parcelRequire("k7Jwr");


var $1HoU0 = parcelRequire("1HoU0");

const $14b7107f244f2fb8$export$eb7670413c83c3d4 = ()=>{
    const [updateSiteLookAndFeel, { data: data, loading: loading, error: error }] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useChangeCompanyHubPublishStateChangeHubPublishStateMutation($input:UpdateSiteLookAndFeelInput!){updateSiteLookAndFeel(input:$input){siteLookAndFeel{frontCoverState}success errors{message extensions{errorType statusCode}}}}`, {
        update: (cache, { data: data })=>{
            cache.writeQuery({
                query: (0, $1HoU0.ChangeHubPublishStateWriteQuery),
                data: {
                    siteSettings: {
                        // Codegen is specifically configured to not add __typename when generating the types file,
                        // so unfortunately ts-ignore is required here.
                        // @ts-ignore
                        __typename: 'SiteSettings',
                        frontCover: {
                            // Codegen is specifically configured to not add __typename when generating the types file,
                            // so unfortunately ts-ignore is required here.
                            // @ts-ignore
                            __typename: 'FrontCover',
                            frontCoverState: data?.updateSiteLookAndFeel.siteLookAndFeel?.frontCoverState
                        }
                    }
                }
            });
        }
    });
    const changeHubPublishState = (frontCoverState)=>updateSiteLookAndFeel({
            variables: {
                input: {
                    faviconFiles: [],
                    frontCoverState: frontCoverState,
                    showFrontCover: frontCoverState === (0, $k7Jwr.GraphQLFrontCoverState).SHOWN
                }
            }
        });
    return {
        data: data,
        loading: loading,
        error: error,
        changeHubPublishState: changeHubPublishState
    };
};
module.exports["useChangeCompanyHubPublishState"] = $14b7107f244f2fb8$export$eb7670413c83c3d4;

});

parcelRegister("1HoU0", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $e23fdd20b1327f37$export$b20671171c26d2fd = (0, $eSUdr.default)`query ChangeHubPublishStateWriteQuery{siteSettings{frontCover{frontCoverState}}}`;
module.exports["ChangeHubPublishStateWriteQuery"] = $e23fdd20b1327f37$export$b20671171c26d2fd;

});

parcelRegister("8Mzkb", function(module, exports) {
/* CreateComment.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @graphql cc */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $7EEGh = parcelRequire("7EEGh");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $8Ss4E = parcelRequire("8Ss4E");


var $2eC70 = parcelRequire("2eC70");


var $aJPUt = parcelRequire("aJPUt");


var $aGjYc = parcelRequire("aGjYc");


var $hXzKU = parcelRequire("hXzKU");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $bSvtO = parcelRequire("bSvtO");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $cAdj8 = parcelRequire("cAdj8");


var $kmHPt = parcelRequire("kmHPt");


var $daq5m = parcelRequire("daq5m");


var $isdzP = parcelRequire("isdzP");


var $6cWI7 = parcelRequire("6cWI7");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $9CnRS = parcelRequire("9CnRS");


var $aMfLn = parcelRequire("aMfLn");


var $9QIM2 = parcelRequire("9QIM2");


var $3Xfi8 = parcelRequire("3Xfi8");


var $eA7s6 = parcelRequire("eA7s6");


var $k8e76 = parcelRequire("k8e76");


var $56QzY = parcelRequire("56QzY");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $hl0fg = parcelRequire("hl0fg");


var $7aRa9 = parcelRequire("7aRa9");


var $5pQ1Y = parcelRequire("5pQ1Y");


var $en1dX = parcelRequire("en1dX");


var $5fMeR = parcelRequire("5fMeR");


var $6mKj3 = parcelRequire("6mKj3");


var $a3q17 = parcelRequire("a3q17");


var $B3Avz = parcelRequire("B3Avz");

const $f4c77c6e390a7914$export$d26c1daa0321174b = (0, $aJPUt.ExperienceTimeout).CREATE_COMMENT_PUBLISH;
const $f4c77c6e390a7914$var$relativeFilePath = 'annotation-provider-inline-comments/CreateComment';
const $f4c77c6e390a7914$var$i18n = (0, $cgtv4.defineMessages)({
    unableToApplyTitle: {
        id: "annotation-provider-inline-comments.create.error.unable.to.apply.title",
        defaultMessage: "Something went wrong"
    },
    unableToApplyDescription: {
        id: "annotation-provider-inline-comments.create.error.unable.to.apply.description",
        defaultMessage: "We failed to display your comment. To view it, refresh now."
    },
    refreshContentLink: {
        id: "annotation-provider-inline-comments.refresh.content.link",
        defaultMessage: "Refresh content"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f4c77c6e390a7914$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt49l6b",
            __cmplp.className
        ])
    });
});
const $f4c77c6e390a7914$var$getNodeType = (element, annotationId)=>{
    const nodeWithAnnotationWrapper = element.querySelector(`[id="${annotationId}"]`);
    if (nodeWithAnnotationWrapper) {
        const firsChildren = nodeWithAnnotationWrapper.firstChild;
        if (firsChildren?.nodeType === Node.TEXT_NODE) return 'text';
        const targetNode = nodeWithAnnotationWrapper.querySelector('[data-node-type]');
        if (targetNode) return targetNode.dataset.nodeType;
    }
    return 'unknown';
}; // Exporting for testing cases
const $f4c77c6e390a7914$export$d4044f5b8f4bc73a = (setWasDraftAnnotationRemoved)=>(mutationList, observer)=>{
        for (const mutation of mutationList){
            if (mutation.type === 'childList') {
                if (mutation.removedNodes.length > 0) mutation.removedNodes.forEach((node)=>{
                    const nodeClassList = Array.from(node.classList ?? []); // COMMENTS-4308 - If any part of the draft annotation was removed, check if the entirity of the draft
                    // 				   was removed, if so, we need to disable the editor buttons as the comment will fail
                    if (nodeClassList.includes('ak-editor-annotation-draft')) {
                        if (document.querySelector('.ak-editor-annotation-draft') === null) {
                            // Tell the editor that the draft annotation was removed
                            setWasDraftAnnotationRemoved(true);
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debugPoint(`CreateComment dialog - draft annotation removed`); // Disconnect the observer since we no longer need it
                            observer.disconnect();
                        }
                    }
                });
            }
        }
    };
const $f4c77c6e390a7914$var$CreateCommentComponent = ({ pageId: pageId, annotationElement: annotationElement, selectionOptions: selectionOptions, onClose: onClose, onCreate: onCreate, isEditor: isEditor, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, flags: flags, isOffline: isOffline })=>{
    const started = (0, $42omo.useRef)(false);
    const pageClass = (0, $9QIM2.usePageClass)();
    if (started.current === false) {
        (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.start();
        started.current = true;
    }
    const initialisedSelection = (0, $42omo.useRef)(false);
    if (selectionOptions && selectionOptions?.createdFrom === 'EDITOR' && initialisedSelection.current === false) {
        initialisedSelection.current = true;
        if (selectionOptions.inlineNodeTypes) (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: selectionOptions.inlineNodeTypes
        });
    }
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const lastContentFetchTime = (0, $42omo.useRef)(1);
    const requestTimeoutHandle = (0, $42omo.useRef)();
    const sidebarEl = (0, $42omo.useRef)(null);
    const draftAnnotationMutationObserverRef = (0, $42omo.useRef)();
    const commentContainerElementRef = (0, $42omo.useRef)(null);
    const { documentUpdated: documentUpdated, publishedDocumentVersion: publishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const [shouldRefetch, setShouldRefetch] = (0, $42omo.useState)(false);
    const [wasDraftAnnotationRemoved, setWasDraftAnnotationRemoved] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { addUnresolvedInlineComment: addUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { addNewCommentThreads: addNewCommentThreads } = (0, $8i27m.useCommentsDataActions)();
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const { isCommentsPanelShown: isCommentsPanelShown } = (0, $5fMeR.useShowCommentsPanel)();
    const { isSticky: isSticky } = (0, $3Xfi8.useShouldCommentSidebarBeSticky)({
        annotationElement: annotationElement,
        isEditor: !!isEditor
    });
    const sidebarOffset = (0, $eA7s6.useCommentSidebarOffset)({
        isEditor: Boolean(isEditor),
        annotationElement: annotationElement,
        windowWidth: windowWidth,
        isSticky: isSticky
    }); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [createCommentFn] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation CreateCommentInlineCommentMutation($input:CreateInlineCommentInput!$pageId:ID!$includeReactionsAndReplies:Boolean!){createInlineComment(input:$input){id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment")@include(if:$includeReactionsAndReplies){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}replies@include(if:$includeReactionsAndReplies){id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}`);
    const { createInlineCommentInterop: createInlineCommentInterop } = (0, $6cWI7.useCreateInlineCommentMutation)({
        contentId: pageId
    });
    const { pageInfo: pageInfo, loading: loading, error: error, refetch: refetch } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first',
        onError: (err)=>{
            experienceTracker.stopOnError({
                name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                error: err
            });
        }
    });
    (0, $42omo.useEffect)(()=>{
        // should only refresh on the Content Out of date `Refresh` CTA is clicked
        if (documentUpdated && shouldRefetch && refetch) {
            refetch();
            setShouldRefetch(false);
            onClose && onClose();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentUpdated,
        shouldRefetch
    ]);
    (0, $42omo.useEffect)(()=>{
        const metadata = document.querySelector('meta[name=confluence-request-time]');
        if (metadata) {
            const fetchTime = Number(metadata.getAttribute('content'));
            lastContentFetchTime.current = isNaN(fetchTime) ? 1 : fetchTime;
        }
        if (pageMode !== (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            const editorTextArea = document.getElementById('ak-editor-textarea');
            draftAnnotationMutationObserverRef.current = new MutationObserver($f4c77c6e390a7914$export$d4044f5b8f4bc73a(setWasDraftAnnotationRemoved)); // We need to watch the whole editorTextArea because highlights could
            if (editorTextArea) draftAnnotationMutationObserverRef.current.observe(editorTextArea, {
                childList: true,
                subtree: true
            });
        }
        return ()=>{
            if (pageMode !== (0, $cD1qu.PageMode).VIEW && draftAnnotationMutationObserverRef.current && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) draftAnnotationMutationObserverRef.current.disconnect();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Check for highlight element on mount - fail experience if createComment renders without a highlight
    // This tracks the scenario where createComment re-renders on close of the comment box without a highlight
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_comment_enable_exp_create_rerenderer', 'isEnabled', true)) return;
         // Use a small delay to allow the DOM to settle after any state changes
        const timeoutId = setTimeout(()=>{
            const draftAnnotationElement = $f4c77c6e390a7914$export$292a5d148db8f191(); // Fail experience if createComment renders without a highlight
            if (!draftAnnotationElement && !wasDraftAnnotationRemoved) (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('CreateComment renders without highlight'));
        }, 100);
        return ()=>clearTimeout(timeoutId); // Only run on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const saveAttemptedTracker = (0, $42omo.useRef)({
        lastMutationSucceeded: false,
        totalSaves: 0,
        failedSaves: 0
    });
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            const savesWithoutError = // hit, the experience will already have completed in the `handleSaveComment`.
            saveAttemptedTracker.current.totalSaves - saveAttemptedTracker.current.failedSaves;
            if (saveAttemptedTracker.current.failedSaves > 0) (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                // eslint-disable-next-line react-hooks/exhaustive-deps
                failedSaves: saveAttemptedTracker.current.failedSaves
            });
            if (savesWithoutError > 1) {
                // At the point this is dismounting -- we don't know for certain if the user intended for this to be discarded or not
                // so we hard fail the full experience (it's possible the dismount is because the second save has worked and
                // the UI is about to load the new comment)
                (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                    savesWithoutError: savesWithoutError
                });
                const msg = 'User clicked save, but UI did not update following successful save'; // we log a debug point and continue with the flow, since creation is not necessarily failing
                (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.debugPoint(msg);
            }
            if (saveAttemptedTracker.current.lastPublishFailure) {
                if (saveAttemptedTracker.current.lastMutationSucceeded) {
                    // in the case there was a publish failure, but the last mutation succeeded -- we assume the dismount is
                    // because the ui is about to load the new comment - in this case we only mark the experience as a soft
                    // failure (we'll capture more details and fail in the final experience step)
                    (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.softFail(// eslint-disable-next-line react-hooks/exhaustive-deps -- This is intentionally using a ref value due to the indirect flow of comment updates
                    saveAttemptedTracker.current.lastPublishFailure);
                    return;
                } else {
                    // In this scenario -- the user attempted to save at least once, got a network error, and gave up on
                    // trying to create the comment
                    // For a subset of errors -- the user is presented with a human readable error message describing that
                    // the comment creation failure is due to the content changing (e.g. the user has edited the page) and
                    // that they need to refresh the page to apply the comment.  In this scenario we don't treat the comment
                    // creation as a failure, but rather we want to mark the experience as aborted.
                    const contentChangedErrorSubstrings = [
                        'Invalid arguments provided for matchIndex and/or numMatches',
                        'Failed to insert highlight, invalid originalSelection, numMatches, or matchIndex',
                        'Selection was made against a stale version of the content',
                        'Published Version out of date. Please provide correct published version.'
                    ];
                    const isContentChangedError = contentChangedErrorSubstrings.some((substring)=>// eslint-disable-next-line react-hooks/exhaustive-deps
                        saveAttemptedTracker.current.lastPublishFailure?.message.includes(substring));
                    if (isContentChangedError) {
                        (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                            abortReason: 'Unable to apply annotation to document'
                        });
                        return;
                    } // This is handled in the UI appropriately, and we should abort not fail
                    const permissionErrorSubstring = 'Could not create content with type comment';
                    const isPermissionError = saveAttemptedTracker.current.lastPublishFailure?.message.includes(permissionErrorSubstring);
                    if (isPermissionError) (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                        abortReason: 'User does not have space permission to create comments'
                    });
                    (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.stopOnError(// eslint-disable-next-line react-hooks/exhaustive-deps -- This is intentionally using a ref value due to the indirect flow of comment updates
                    saveAttemptedTracker.current.lastPublishFailure);
                    return;
                }
            }
            if (saveAttemptedTracker.current.lastMutationSucceeded) {
                (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.complete();
                return;
            } // In this case the user did not attempt to save the comment, and so we assume this was
            // an intentional discard of the comment.
            // So we abort the draftToPublishExperience here, along with any unfinished initExperience.
            const abortReason = 'Create Comment UI dismissed';
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                abortReason: abortReason
            });
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.abort({
                abortReason: abortReason
            });
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).cancel();
        };
    }, []);
    const saveAttemptedCounts = (0, $42omo.useRef)({
        total: 0,
        failedSaves: 0
    });
    const failPublishExperience = (0, $42omo.useCallback)((commentPublishError, translatedErrorMsg)=>{
        // COMMENTS-1879 - Only log unexpected errors or annotation application error as failures
        if ((0, $isdzP.isUnexpectedError)(translatedErrorMsg)) experienceTracker.stopOnError({
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            error: commentPublishError
        });
        else (0, $7Sm4c.markErrorAsHandled)(commentPublishError);
    }, [
        experienceTracker
    ]);
    const onCacheUpdateError = (0, $42omo.useCallback)((cacheError)=>{
        const { message: message } = (0, $isdzP.parseError)(cacheError);
        failPublishExperience(cacheError, (0, $isdzP.getTranslatedError)(message));
    }, [
        failPublishExperience
    ]);
    const handleSaveCommentWithTimeout = (timeoutInMs, saveMutation)=>{
        const timeout = new Promise((_resolve, reject)=>{
            requestTimeoutHandle.current = setTimeout(()=>{
                experienceTracker.stopOnError({
                    name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                    error: new Error(`Request took longer than ${timeoutInMs}ms`)
                });
                return reject({
                    error: (0, $9CnRS.i18n).createTimeout
                });
            }, timeoutInMs);
        });
        return Promise.race([
            timeout,
            saveMutation
        ]).finally(()=>{
            if (requestTimeoutHandle.current) clearTimeout(requestTimeoutHandle.current);
        });
    };
    const handleSaveComment = (adf, onSuccess)=>{
        saveAttemptedTracker.current.totalSaves = saveAttemptedTracker.current.totalSaves + 1;
        saveAttemptedTracker.current.lastMutationSucceeded = false;
        saveAttemptedCounts.current.total = saveAttemptedCounts.current.total + 1;
        if (!selectionOptions) // We likely will never get here, but just in case
        return Promise.reject({
            error: (0, $9CnRS.i18n).unableToGenerateStep
        });
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE),
            attributes: {
                pageId: pageId,
                pageMode: pageMode,
                isEditor: isEditor
            }
        });
        (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).start();
        (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentCreationStart');
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            attributes: {
                timeout: $f4c77c6e390a7914$export$d26c1daa0321174b
            }
        });
        const { numMatches: numMatches, matchIndex: matchIndex, originalSelection: originalSelection, createdFrom: createdFrom, step: step, targetNodeType: targetNodeType } = selectionOptions; // eslint-disable-next-line confluence-feature-gating/inline-usage
        const variables = {
            input: {
                containerId: pageId,
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: 'ATLAS_DOC_FORMAT'
                },
                numMatches: numMatches,
                matchIndex: matchIndex,
                originalSelection: originalSelection,
                createdFrom: createdFrom,
                lastFetchTimeMillis: lastContentFetchTime.current,
                publishedVersion: publishedDocumentVersion,
                ...!!step && {
                    step: (0, $aMfLn.constructStepForGql)(step)
                }
            },
            pageId: pageId,
            includeReactionsAndReplies: false
        }; // Note -- this mixes data saving logic and UI application logic.
        // And when the UI logic fails, the result is that the user is left with
        // the ui looking like the comment failed to save.
        // This should be refactored to separate the two concerns, and on a UI application
        // failure, we should encourage users to refresh (and mark the experience as failed).
        let succeededPublish = false;
        const onCreateSuccess = (retVal)=>{
            saveAttemptedTracker.current.lastMutationSucceeded = true;
            const { data: data } = retVal;
            if (requestTimeoutHandle.current) clearTimeout(requestTimeoutHandle.current);
            succeededPublish = true;
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.publishSucceeded(); // Mark comment creation end for both cohorts
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentCreationEnd');
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentDataLoadStart');
            const annotationId = data?.createInlineComment?.location?.inlineMarkerRef;
            const commentId = data?.createInlineComment?.id;
            if (!annotationId || !commentId) throw new Error(`Comment was not saved correctly - either annotationId '${annotationId}' or commentId '${commentId}' were undefined`);
             // Reset the content changing flag
            resetContentChanged(); // Grab the marker ref id returned and update the editor/renderer
            try {
                onCreate(annotationId, data?.createInlineComment);
            } catch (e) {
                // We generate errors in renderer, but this will also handle the editor case
                throw new Error(`Unable to apply annotation to document - ${e.message}`);
            } // Update the unresolved inline comments count
            addUnresolvedInlineComment(annotationId, pageMode); // For experiment cohort, we pass the mutation data to onCreate
            // The experiment success and data load completion will be handled in AnnotationsContext
            // after the view component renders the new data
            const newComment = {
                // (Need to coerce the data from the new Comments Data Manager's mutation because it is
                // defined using the new Relay-generated types that define option fields as "| null | undefined"
                // but the original Apollo-generated types define them as just "| null".  These aren't compatible
                // without the coercion even though the "if (value)" or "value?." expressions would work the same.)
                ...data?.createInlineComment,
                isUnread: false,
                isOpen: true,
                type: (0, $8i27m.CommentType).INLINE,
                wasRemovedByAnotherUser: false,
                replies: [],
                reactionsSummary: null
            };
            addNewCommentThreads({
                general: {},
                inline: {
                    [annotationId]: newComment
                }
            }); // Create inline comment track event
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: 'page',
                    objectId: pageId,
                    source: isEditor ? 'editPageScreen' : 'viewPageScreen',
                    attributes: {
                        ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                        source: (0, $en1dX.AnalyticsSource).STANDALONE,
                        commentType: (0, $8i27m.CommentType).INLINE,
                        parentCommentId: null,
                        isReply: false,
                        pageMode: pageMode,
                        isLivePage: createdFrom === 'LIVE',
                        navdexPointType: (0, $56QzY.END),
                        inlineNodeTypes: selectionOptions.inlineNodeTypes,
                        ...annotationElement && !isEditor && {
                            nodeType: $f4c77c6e390a7914$var$getNodeType(annotationElement, annotationId)
                        },
                        ...!isEditor && {
                            targetNodeType: targetNodeType
                        }
                    }
                }
            }).fire(); // Reset the editor
            onSuccess();
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                commentType: 'inline',
                entryPoint: 'create-comment',
                annotationId: annotationId
            }); /*
           * On editor pages, the view-inline-comment experience is started by the editor when the
           * created annotation is automatically selected after successful comment creation. For
           * editor pages, we update the attributes here to ensure that the experience is tracked
           * with the correct entry point.
           */ 
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_create')) {
                const attributes = {
                    annotationId: annotationId,
                    entryPoint: $f4c77c6e390a7914$var$relativeFilePath,
                    pageClass: pageClass
                };
                if (pageClass === 'renderer') experienceTracker.start({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                    attributes: {
                        ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                        ...attributes
                    }
                });
                else if (pageClass === 'editor') experienceTracker.updateAttributes({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    attributes: attributes
                });
                if (isCommentsPanelShown) experienceTracker.fail({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('Comments panel is visible when it should not be'),
                    attributes: {
                        stopPoint: $f4c77c6e390a7914$var$relativeFilePath
                    }
                });
            }
        };
        const onCreateFailure = (err)=>{
            saveAttemptedTracker.current.failedSaves = saveAttemptedTracker.current.failedSaves + 1;
            saveAttemptedCounts.current.failedSaves = saveAttemptedCounts.current.failedSaves + 1;
            experienceTracker.fail({
                name: (0, $irVI7.VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE),
                error: err,
                attributes: {
                    pageId: pageId,
                    pageMode: pageMode,
                    isEditor: isEditor,
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui'
                }
            });
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).cancel();
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.debug({
                error: err,
                createAnalyticsEvent: createAnalyticsEvent,
                extraAttributes: {
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui'
                }
            });
            if (!succeededPublish) saveAttemptedTracker.current.lastPublishFailure = err;
            let contentOutOfDate = false; // Get a truncated graphql error message
            const { errorId: errorId, message: message } = (0, $isdzP.parseError)(err);
            const translatedError = (0, $isdzP.getTranslatedError)(message); // COMMENTS-1879 - The backend will fall back to the old method of trying to make string matches if the content
            // is out of date. If the BE fails to apply a comment when using the old fallback method we should log it
            if ((0, $isdzP.isHighlightError)(translatedError)) {
                // Send the analytics event
                const analyticsObject = {
                    source: 'viewPage',
                    objectType: 'page',
                    objectId: pageId,
                    action: 'invalid',
                    actionSubject: 'highlight',
                    actionSubjectId: 'inlineComment',
                    attributes: {
                        errorMessage: message,
                        editor: 'FABRIC',
                        framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                        errorId: errorId,
                        highlightOrigin: 'userHighlight' // TODO: Do we need to programmatically track this?
                    }
                };
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: analyticsObject
                }).fire();
                contentOutOfDate = true;
            }
            failPublishExperience(err, translatedError); // Use the existing value if it's already set or is an out of date error
            contentOutOfDate = contentOutOfDate || (0, $isdzP.isOutOfDateError)(translatedError); // In the case of an annotation error, we should show a flag to the user to let them know
            // their comment has been saved and they need to refresh the content (view mode only)
            if ((0, $isdzP.isAnnotationError)(translatedError)) {
                const CREATE_ERROR_FLAG_ID = `create-error-${Date.now()}`;
                flags.showWarningFlag({
                    id: CREATE_ERROR_FLAG_ID,
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f4c77c6e390a7914$var$i18n.unableToApplyTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), translatedError === (0, $9CnRS.i18n).unableToApplyAnnotation ? $f4c77c6e390a7914$var$i18n.unableToApplyDescription : translatedError),
                    actions: // Only show the refetch content action on view mode as it's not applicable in editor/live
                    pageMode === (0, $cD1qu.PageMode).VIEW ? [
                        {
                            content: formatMessage($f4c77c6e390a7914$var$i18n.refreshContentLink),
                            onClick: ()=>{
                                setRefetchContent(true);
                                handleOnClose();
                                flags.hideFlag(CREATE_ERROR_FLAG_ID);
                            }
                        }
                    ] : // TODO: Add actions for editor/live if needed
                    []
                }); // Log the occurance through analytics so we can still track it
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                        objectType: 'page',
                        objectId: pageId,
                        action: 'failed',
                        actionSubject: 'applyAnnotation',
                        actionSubjectId: 'inlineComment',
                        attributes: {
                            errorMessage: message,
                            editor: 'FABRIC',
                            framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                            isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                            tenantId: cloudId,
                            userId: userId,
                            pageId: pageId
                        }
                    }
                }).fire();
                if ((0, $9wGTI.fg)('confluence_frontend_comment_highlight_apply_fixes')) (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.fail(new Error('Unable to apply annotation to document'), {
                    errorMessage: message,
                    ...errorId ? {
                        errorId: errorId
                    } : {},
                    pageMode: pageMode,
                    context: isEditor ? 'editor' : 'renderer',
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui',
                    pageId: pageId
                });
                else (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                    abortReason: 'Unable to apply annotation to document'
                });
                onClose && onClose();
                return;
            } // CommentEditor expects a translated error message otherwise it fails
            // TODO: CommentEditor should likely just receive the translated message
            // rather than expect the object needed for FormattedMessage
            return Promise.reject({
                error: contentOutOfDate ? (0, $9CnRS.i18n).contentOutOfDate : translatedError,
                contentOutOfDate: contentOutOfDate
            });
        };
        // Wrap the createCommentFn mutation with the interop logic that handles both the direct Apollo
        // mutation path and the new hook-based for the Comments Data Manager
        const commentCreationInteropWrapper = (options)=>createInlineCommentInterop({
                originalMutationFn: createCommentFn,
                options: options,
                onCacheUpdateError: onCacheUpdateError
            });
        if ((0, $9wGTI.fg)('confluence_frontend_add_inline_comment_timeout')) return handleSaveCommentWithTimeout($f4c77c6e390a7914$export$d26c1daa0321174b, commentCreationInteropWrapper({
            variables: variables
        }).then(onCreateSuccess).catch(onCreateFailure));
        else return commentCreationInteropWrapper({
            variables: variables
        }).then(onCreateSuccess).catch(onCreateFailure);
    };
    const handleOnClose = (0, $42omo.useCallback)((hasContentChanged)=>{
        const reason = hasContentChanged ? 'comment discarded by user' : 'empty comment discarded by user';
        experienceTracker.abort({
            name: (0, $irVI7.ADD_INLINE_COMMENT_EXPERIENCE),
            reason: reason
        }); // Clearing reply draft is handled in the comment editor
        (0, $aGjYc.clearCommentDraft)(isEditor ? 'edit-inline' : 'inline', 'create');
        onClose && onClose();
    }, [
        experienceTracker,
        isEditor,
        onClose
    ]);
    const onEditorLoad = ()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.ADD_INLINE_COMMENT_LOAD_EXPERIENCE)
        });
        const draftAnnotationElement = $f4c77c6e390a7914$export$292a5d148db8f191();
        if (!draftAnnotationElement && !wasDraftAnnotationRemoved) {
            // We have handling to show a message when we detect the draft annotation was removed, indicated by
            // `wasDraftAnnotationRemoved=true`. So we only need to fail the experience if we unexpectedly cannot find
            // the draftAnnotationElement, indicated by `wasDraftAnnotationRemoved=false`
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('No annotation element'));
            return;
        }
        setTimeout(()=>{
            // There are multiple useEffects involved in positioning the comment UI.
            // This works around this by only marking the experience as complete after
            // a short timeout + animation frame.
            requestAnimationFrame(()=>{
                // In the Editor and Renderer, the comment UI is positioned relative to slightly different
                // elements.
                if (!draftAnnotationElement) {
                    (0, $3YBks.createInlineCommentCompoundExperience).initExperience.abort({
                        abortReason: 'Draft annotation removed from document'
                    });
                    return;
                } else if (!sidebarEl.current) (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Missing create comment ui'));
                else {
                    const commentUIVerticalDistanceFromAnnotation = Math.abs(draftAnnotationElement.getBoundingClientRect().top - sidebarEl.current.getBoundingClientRect?.().top); // The 40 pixel allowance has been arbitrarily chosen to allow for some wiggle room
                    if (commentUIVerticalDistanceFromAnnotation > 40) {
                        const isVisible = sidebarEl.current.checkVisibility();
                        if (isVisible) {
                            // if it's fully visible, but misaligned, we don't treat this as a failure
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debug({
                                error: new Error('View Created Comment UI too far from annotation'),
                                createAnalyticsEvent: createAnalyticsEvent,
                                extraAttributes: {
                                    misalignedBy: commentUIVerticalDistanceFromAnnotation
                                }
                            });
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.complete();
                        } else {
                            (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                                misalignedBy: commentUIVerticalDistanceFromAnnotation
                            });
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Draft Comment UI is setup too far from annotation'));
                        }
                    } else (0, $3YBks.createInlineCommentCompoundExperience).initExperience.complete();
                }
            });
        }, 1000);
    };
    if (loading || error) {
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debugPoint(`CreateComment dialog ${loading ? 'loading' : 'error'}`, {
            error: error?.message ?? '',
            loading: loading
        });
        return null;
    }
    const spaceId = pageInfo?.space?.id ?? '';
    const pageType = pageInfo?.type ?? ''; // User page permissions
    const operations = pageInfo?.operations || [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment'); // The user can upload media only if they have update permissions for the page if confluence_comment_use_comment_media_endpoint FG is off
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment : operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $B3Avz.CommentSidebar), {
        pageId: pageId,
        onClose: handleOnClose,
        isEditor: isEditor,
        annotationElement: annotationElement,
        sidebarOffset: sidebarOffset,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        sidebarEl: sidebarEl,
        isSticky: isSticky,
        isFabricPage: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f4c77c6e390a7914$var$Container, {
        ref: commentContainerElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daq5m.CommentAuthor), {
        commentMode: "create",
        userId: userId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditor // @ts-ignore FIXME: `pageId` can be `undefined` here, and needs proper handling
    ), {
        pageId: pageId,
        pageType: pageType,
        spaceId: spaceId,
        appearance: "chromeless",
        EditorComponent: (0, $7EEGh.ChromelessEditor),
        onSaveComment: handleSaveComment,
        onContentChange: onChange,
        commentMode: "create",
        commentType: isEditor ? 'edit-inline' : 'inline',
        onEditorReady: onEditorLoad,
        hideWatchCheckbox: true,
        pageMode: isEditor ? 'edit' : 'view',
        shouldWarnOnInternalNavigation: true,
        useNewWarningModal: true,
        setShouldRefetch: ()=>setShouldRefetch(true),
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        commentContainerElementRef: commentContainerElementRef,
        wasDraftAnnotationRemoved: wasDraftAnnotationRemoved,
        isStandaloneComment: true,
        isOffline: isOffline
    })));
};
const $f4c77c6e390a7914$export$b217475cf0d7b767 = (0, $7aRa9.withFlags)($f4c77c6e390a7914$var$CreateCommentComponent); /**
                                                                 *
                                                                 * Exported for testing purposes only
                                                                 *
                                                                 * This function is used to find the draft annotation element in the DOM.
                                                                 * It checks both the renderer and editor for the draft annotation element.
                                                                 *
                                                                 * In some scenarios, there are duplicate draft annotations in the DOM such
                                                                 * as in the renderer where the dom for table headers is repeated.
                                                                 *
                                                                 * To mitigate this, we get all possible draft annotation elements and
                                                                 * and return the first one that has a height greater than 0.
                                                                 *
                                                                 * If no draft annotation element is found, it returns null.
                                                                 */ 
function $f4c77c6e390a7914$export$292a5d148db8f191() {
    const possibleAnnotations = document.querySelectorAll('[data-annotation-draft-mark="true"], .ak-editor-annotation-draft');
    if (possibleAnnotations.length === 1) // In cases where there is only one draft annotation, we can return it directly
    // and avoid the performance hit where reflow is triggered by checking if the
    // annotation has a height greater than 0.
    return possibleAnnotations[0];
    for(let i = 0; i < possibleAnnotations.length; i++){
        if (possibleAnnotations[i].getBoundingClientRect().height > 0) return possibleAnnotations[i];
    }
    return null;
}
module.exports["CreateComment"] = $f4c77c6e390a7914$export$b217475cf0d7b767;

});

parcelRegister("6cWI7", function(module, exports) {

var $l4jQJ = parcelRequire("l4jQJ");


var $42omo = parcelRequire("42omo");


var $308Wd = parcelRequire("308Wd");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");

// This hook returns a mutation function to create a new inline comment. Because the new Comments
// Data Manager caches all the data for comments in Relay, we need to define the mutation here so
// that the cache can be updated fully when a new comment is created - and that means the mutation
// needs to return the full comment data structure that we are using in the returned query part of
// the mutation.  Since that returned query is quite large, we define it here in its own hook to
// avoid having it in many places in the codebase - which makes the code harder to read and could
// lead to the multiple copies getting out of sync.
// Data Mutation Definition:
// Unfortunately our Relay-friendly type generation tools don't support using GQL fragments yet -
// but in order to keep the definition of the comment fields in sync (so the cache update fragment
// is always in sync with the full query) we will need to manually make any changes to one
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// (Note that there is another exported GraphQL mutation variable named "CreateInlineCommentMutation"
// that is exported from @confluence/inline-comments-queries. It's okay that these are the same
// variable name because the other one does not seem to be imported anywhere in the codebase at
// present, this variable is only used internally in this file, and the actual muation's name -
// useCreateInlineCommentMutation - is unique so GQL won't complain.)
const $03f1ee89907a0c1d$var$CreateInlineCommentMutation = (0, $l4jQJ.default);
const $03f1ee89907a0c1d$export$10606ca3587bb707 = ({ contentId: contentId })=>{
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const [createInlineCommentFn] = (0, $308Wd.useMutationInterop)($03f1ee89907a0c1d$var$CreateInlineCommentMutation);
    const addEmptyInlineRepliesArray = (0, $42omo.useCallback)((commentData)=>{
        return commentData ? {
            ...commentData,
            replies: []
        } : undefined;
    }, []);
    // This is the interop mutation function that will be used by components that need to create
    // inline comments. It will either call the new Comments Data Manager path or the old Apollo
    // mutation path depending on whether the relevant experiment is enabled.
    const createInlineCommentInterop = (0, $42omo.useCallback)(({ originalMutationFn: originalMutationFn, options: options, onCacheUpdateError: onCacheUpdateError })=>{
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // Strip out the old update function and other options, and adjust variables as needed
            // The includeReactionsAndReplies variable is needed by some of the legacy mutations but is
            // not needed by the new Comments Data Manager. So remove it if we're using the new path -
            // otherwise Typescript will complain and GQL may error as well.
            const { variables: variables } = options;
            const { includeReactionsAndReplies: _includeReactionsAndReplies, ...newVariables } = variables ?? {
                includeReactionsAndReplies: undefined
            };
            const updateNewCommentInCache = (_dataProxy, mutationResult)=>{
                addCommentInCache({
                    newComment: addEmptyInlineRepliesArray(mutationResult.data.createInlineComment),
                    onError: onCacheUpdateError
                });
            };
            return createInlineCommentFn({
                variables: {
                    ...newVariables
                },
                update: updateNewCommentInCache
            });
        } else return originalMutationFn(options);
    }, [
        addCommentInCache,
        addEmptyInlineRepliesArray,
        createInlineCommentFn
    ]);
    return {
        createInlineCommentInterop: createInlineCommentInterop
    };
};
module.exports["useCreateInlineCommentMutation"] = $03f1ee89907a0c1d$export$10606ca3587bb707;

});

parcelRegister("l4jQJ", function(module, exports) {
/**
 * @generated SignedSource<<9167f2621e6cf106559738ba6aef7b0e>>
 * @relayHash e24366c26db43cec71d2389d47713237
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6fb8d32a19fd54f1167b17c440131031a9406832544a4743963e9e462353f885
const $3dcbd79e6f23278f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v9 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v10 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v11 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v12 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "createInlineComment",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v7 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "container",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineMarkerRef"
                                },
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "inlineResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDangling"
                                        },
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineText"
                                }
                            ],
                            "type": "InlineComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "childType",
                            "value": "comment"
                        },
                        {
                            "kind": "Literal",
                            "name": "contentType",
                            "value": "page"
                        },
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        }
                    ],
                    "concreteType": "ReactionsSummaryResponse",
                    "kind": "LinkedField",
                    "name": "reactionsSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "ari"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "containerAri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "reactionsCount"
                        },
                        {
                            "concreteType": "ReactionsSummaryForEmoji",
                            "kind": "LinkedField",
                            "name": "reactionsSummaryForEmoji",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "emojiId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "reacted"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                v4 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateInlineCommentMutation",
            "selections": v12 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateInlineCommentMutation",
            "selections": v12 /*: any*/ 
        },
        "params": {
            "cacheID": "e24366c26db43cec71d2389d47713237",
            "id": "6fb8d32a19fd54f1167b17c440131031a9406832544a4743963e9e462353f885",
            "metadata": {},
            "name": "useCreateInlineCommentMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateInlineCommentMutation($pageId:ID!,$input:CreateInlineCommentInput!){createInlineComment(input:$input){id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}"
        }
    };
}();
$3dcbd79e6f23278f$var$node.hash = "f3ea5340b40a0a0dd635fcfbf3e8ed68";
var $3dcbd79e6f23278f$export$2e2bcd8739ae039 = $3dcbd79e6f23278f$var$node;
module.exports["default"] = $3dcbd79e6f23278f$export$2e2bcd8739ae039;

});

parcelRegister("3Xfi8", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $7nPJ6 = parcelRequire("7nPJ6");


var $6HwWx = parcelRequire("6HwWx");

const $6a7e747c5d5174c7$export$9be7dcbe458ba189 = ({ annotationElement: annotationElement, isEditor: isEditor })=>{
    const classToCheck = '.pm-table-container';
    let elementToObserve = undefined;
    // elements to observe, these are different than elements that determine if the table is sticky
    if (isEditor) elementToObserve = annotationElement?.closest(classToCheck)?.parentElement?.querySelector('.pm-table-sticky-sentinel-top');
    else elementToObserve = annotationElement?.closest(classToCheck);
    const [isSticky, setIsSticky] = (0, $7nPJ6.useIsSticky)({
        isEditor: isEditor,
        elementToObserve: elementToObserve
    });
    (0, $6HwWx.useStickyTableHeaderObserver)({
        setIsSticky: setIsSticky,
        isEditor: isEditor,
        elementToObserve: elementToObserve
    });
    // Check if annotationElement is a child of tr (th element) and th's immediate parent is tbody
    const thElement = annotationElement?.closest('th');
    if (thElement && (0, $9wGTI.fg)('confluence-fe-comment-stickiness-fix')) {
        const trElement = thElement.parentElement;
        const tbodyElement = trElement?.parentElement;
        // If tr is the first child of tbody, return false
        if (tbodyElement?.firstElementChild !== trElement) return {
            isSticky: false
        };
    }
    // if annotation element is inside a nested table, then return false
    if (annotationElement?.closest('.pm-table-nested-table-with-controls')) return {
        isSticky: false
    };
    // if annotation element is not inside a table header, then return false
    if (!annotationElement?.closest('th')) return {
        isSticky: false
    };
    // Remove debug console logs
    return {
        isSticky: isSticky
    };
};
module.exports["useShouldCommentSidebarBeSticky"] = $6a7e747c5d5174c7$export$9be7dcbe458ba189;

});

parcelRegister("7nPJ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jW2Ig = parcelRequire("jW2Ig");

const $b1509838bb0fcfff$export$2cf94d5875603a88 = ({ isEditor: isEditor, elementToObserve: elementToObserve })=>{
    // check if table is already sticky
    const initialStickyState = elementToObserve ? (0, $jW2Ig.getIsSticky)(elementToObserve.parentElement, isEditor) : false;
    const [isSticky, setIsSticky] = (0, $42omo.useState)((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') && initialStickyState);
    // Sticky state effect for post-render (useEffect)
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        if ((0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        setIsSticky(initialStickyState);
    }, [
        initialStickyState
    ]);
    // Sticky state effect for pre-render (useLayoutEffect)
    (0, $42omo.useLayoutEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        if (!(0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        setIsSticky(initialStickyState);
    }, [
        initialStickyState
    ]);
    return [
        isSticky,
        setIsSticky
    ];
};
module.exports["useIsSticky"] = $b1509838bb0fcfff$export$2cf94d5875603a88;

});

parcelRegister("jW2Ig", function(module, exports) {
const $28177804efc2055d$export$17682ee29db08043 = (tableElement)=>{
    return Boolean(tableElement?.getAttribute('mode') === 'stick');
};
const $28177804efc2055d$export$4676b00e54210cb0 = (tableElement)=>{
    return Boolean(tableElement?.classList.contains('pm-table-sticky'));
};
const $28177804efc2055d$export$f3993a99776f75ca = (tableElement, isEditor)=>isEditor ? $28177804efc2055d$export$4676b00e54210cb0(tableElement) : $28177804efc2055d$export$17682ee29db08043(tableElement);
module.exports["isStickyInViewMode"] = $28177804efc2055d$export$17682ee29db08043;
module.exports["isStickyInEditMode"] = $28177804efc2055d$export$4676b00e54210cb0;
module.exports["getIsSticky"] = $28177804efc2055d$export$f3993a99776f75ca;

});

parcelRegister("6HwWx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $jW2Ig = parcelRequire("jW2Ig");

const $cf08b287de1b8d82$export$204fd756b18b92ff = ({ setIsSticky: setIsSticky, isEditor: isEditor, elementToObserve: elementToObserve })=>{
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        // Create mutation observer to track class changes
        const stickyTableHeaderObserver = new MutationObserver((mutationsList)=>{
            mutationsList.forEach((mutation)=>{
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    if (isEditor && (0, $jW2Ig.isStickyInEditMode)(target) || (0, $jW2Ig.isStickyInViewMode)(target)) setIsSticky(true);
                    else setIsSticky(false);
                }
            });
        });
        // Start observing class changes on the parent element
        if (elementToObserve?.parentElement) stickyTableHeaderObserver.observe(elementToObserve.parentElement, {
            attributes: true,
            attributeFilter: [
                'class'
            ]
        });
        // Clean up all observers
        return ()=>{
            stickyTableHeaderObserver.disconnect();
        };
    }, [
        elementToObserve?.parentElement,
        isEditor,
        setIsSticky
    ]);
};
module.exports["useStickyTableHeaderObserver"] = $cf08b287de1b8d82$export$204fd756b18b92ff;

});

parcelRegister("eA7s6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aHcFH = parcelRequire("aHcFH");

const $168172ede45a02b4$export$aca484f2c8185777 = ({ annotationElement: annotationElement, isEditor: isEditor, isViewCommentMode: isViewCommentMode, windowWidth: windowWidth, isSticky: isSticky })=>{
    return (0, $42omo.useMemo)(()=>{
        if (!annotationElement) return 0;
        if (isEditor) return (0, $aHcFH.calculateEditorOffsetFromParent)(annotationElement, '.fabric-editor-popup-scroll-parent');
        return (0, $aHcFH.calculateRendererOffsetFromParent)(annotationElement, `[data-annotation-draft-mark="true"]`, Boolean(isViewCommentMode));
    // We want to re-calculate when the window width changes or the comment sidebar becomes sticky / unsticky
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEditor,
        annotationElement,
        isViewCommentMode,
        windowWidth,
        isSticky
    ]);
};
module.exports["useCommentSidebarOffset"] = $168172ede45a02b4$export$aca484f2c8185777;

});

parcelRegister("a3q17", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $60a54f1e533f2ef6$export$52ff686bd4414bc5 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$ac7f79e65475cee7 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$321e1f68b293bf76 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'highlightsRendered',
            endMark: 'highlightsRendered'
        }
    ]
});
const $60a54f1e533f2ef6$export$fc794218ec0a6fa5 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: 'direct-comment-data-flow',
    timings: [
        {
            key: 'commentCreationStart',
            startMark: 'commentCreationStart'
        },
        {
            key: 'commentCreationEnd',
            endMark: 'commentCreationEnd'
        },
        {
            key: 'commentDataLoad',
            startMark: 'commentDataLoadStart',
            endMark: 'commentDataLoadEnd'
        }
    ]
});
module.exports["EDITOR_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$52ff686bd4414bc5;
module.exports["RENDERER_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$ac7f79e65475cee7;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_METRIC"] = $60a54f1e533f2ef6$export$321e1f68b293bf76;
module.exports["DIRECT_COMMENT_DATA_FLOW_METRIC"] = $60a54f1e533f2ef6$export$fc794218ec0a6fa5;

});

parcelRegister("B3Avz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $lisKW = parcelRequire("lisKW");


var $T1bCI = parcelRequire("T1bCI");


var $6mKj3 = parcelRequire("6mKj3");


var $hmuev = parcelRequire("hmuev");


var $ccHMk = parcelRequire("ccHMk");


var $1yB28 = parcelRequire("1yB28");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $hnvzE = parcelRequire("hnvzE");


var $3gadb = parcelRequire("3gadb");


var $9FoVw = parcelRequire("9FoVw");


var $f5Wgm = parcelRequire("f5Wgm");


var $aHcFH = parcelRequire("aHcFH");


var $i49vP = parcelRequire("i49vP");


var $eToX6 = parcelRequire("eToX6");


var $bSvtO = parcelRequire("bSvtO");


var $8SCD6 = parcelRequire("8SCD6");


var $cMvMc = parcelRequire("cMvMc");


var $5fMeR = parcelRequire("5fMeR");


var $3D12W = parcelRequire("3D12W");


var $6KwrO = parcelRequire("6KwrO");


var $3mVfX = parcelRequire("3mVfX");


var $kRW4Y = parcelRequire("kRW4Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $9wGTI = parcelRequire("9wGTI");


var $666Tc = parcelRequire("666Tc");


var $aWwYt = parcelRequire("aWwYt");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $fT4aa = parcelRequire("fT4aa");


var $bEwJH = parcelRequire("bEwJH");


var $bXQxx = parcelRequire("bXQxx");


var $6wiaZ = parcelRequire("6wiaZ");

const $2cc0402d98a7d80d$export$b8454eaf88df51d0 = (entry, setIsSticky, setSidebarOffset, sidebarOffset)=>{
    if (entry.intersectionRatio === 0) {
        setIsSticky(false);
        setSidebarOffset(sidebarOffset);
    } else {
        setIsSticky(true);
        setSidebarOffset((0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW));
    }
};
const $2cc0402d98a7d80d$var$redesignedViewAllStyle = (0, $ecnYn.xcss)({
    position: 'absolute',
    right: 'space.500',
    // This gives us 4px between the X and the comment icon
    top: 'space.150' // This lines us up exactly with X
});
const $2cc0402d98a7d80d$var$viewAllContainerStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.150',
    left: 'space.075',
    alignItems: 'center',
    justifyContent: 'center'
});
const $2cc0402d98a7d80d$var$commentHeaderStyle = (0, $ecnYn.xcss)({
    flexDirection: 'column',
    display: 'flex',
    marginTop: 'space.400'
});
const $2cc0402d98a7d80d$var$commentNewHeaderMargin = (0, $ecnYn.xcss)({
    marginTop: 'space.500'
});
const $2cc0402d98a7d80d$var$shadowElementStyle = {
    height: '4px',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.15) 0%, transparent 100%)',
    width: '100%',
    margin: '0',
    padding: '0'
};
const $2cc0402d98a7d80d$var$commentEditorStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.0'
});
const $2cc0402d98a7d80d$var$boxWithMaxHeight = (0, $ecnYn.xcss)({
    maxHeight: 'calc(100vh - 300px)',
    overflowY: 'auto'
});
const $2cc0402d98a7d80d$var$boxWithMaxHeightAndScroll = (0, $ecnYn.xcss)({
    maxHeight: 'calc(100vh - 300px)',
    overflowY: 'scroll'
});
const $2cc0402d98a7d80d$var$boxWithoutMaxHeight = (0, $ecnYn.xcss)({
    overflowY: 'visible'
});
const $2cc0402d98a7d80d$export$d560bdb1ceec916a = ({ pageId: pageId, onClose: onClose, annotationElement: annotationElement, navigationOptions: navigationOptions, isEditor: isEditor, isViewCommentMode: isViewCommentMode, children: children, sidebarOffset: sidebarOffset, commentId: commentId, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, sidebarEl: sidebarEl, annotationId: annotationId, inlineCommentRef: inlineCommentRef = ()=>{}, nudgeRef: nudgeRef, isSticky: isSticky, isFabricPage: isFabricPage, authorName: authorName, setPopupsScrollableElement: setPopupsScrollableElement })=>{
    const [isRefSet, setRef] = (0, $42omo.useState)(false);
    const [oldIsSticky, setOldIsSticky] = (0, $42omo.useState)(false);
    const [newSidebarOffset, setSidebarOffset] = (0, $42omo.useState)(sidebarOffset);
    const [showA11yAnnouncement, setShowA11yAnnouncement] = (0, $42omo.useState)(false);
    const [isScrolled, setIsScrolled] = (0, $42omo.useState)(false);
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const [{ isViewMode: isLiveViewMode }] = (0, $efvKr.useLivePageMode)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelActions)();
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const isRovoButtonEnabled = (0, $fT4aa.useAIRovoButtonEnablement)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        let offset = 0;
        if (annotationElement && !isEditor) {
            let scrollParent;
            if (isEditor) {
                scrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
                offset = (0, $aHcFH.calculateElementOffset)(annotationElement, scrollParent);
            } else {
                /*
        There's two cases here: a view comment and a create comment.
        We need the correct scrollParent for each case.
        Since it's not the editor in this logical branch we should use #content as the scrollParent.
        */ scrollParent = document.querySelector('div#content[data-inline-comments-target="true"]');
                if (scrollParent) {
                    let annotationOffset = 0;
                    if (isViewCommentMode) // If the sidebar is rendering a view comment, we can use the annotationElement directly.
                    annotationOffset = (0, $aHcFH.calculateElementOffset)(annotationElement);
                    else {
                        /*
            If the sidebar is rendering a create comment the annotationElement is actually the wrapperDOM
            we need to find the actual highlight instead. We can find this by looking for the mark because
            there will always be a mark before the create comment button is clicked.
            */ const actualHiglightElement = scrollParent.querySelector(`[data-annotation-draft-mark="true"]`);
                        annotationOffset = (0, $aHcFH.calculateElementOffset)(actualHiglightElement, undefined, true);
                    }
                    offset = annotationOffset + scrollParent.offsetTop;
                }
            }
            setSidebarOffset(offset);
        }
    }, [
        annotationElement,
        isEditor,
        isViewCommentMode
    ]);
    (0, $42omo.useEffect)(()=>{
        // handles media comment scroll
        if (isRefSet && sidebarEl.current && isEditor) {
            if (isOpeningMediaCommentFromToolbar && annotationElement) (0, $i49vP.scrollToElementInEditor)({
                targetElement: annotationElement,
                viewingRoomOffset: -150
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRefSet,
        annotationElement,
        isOpeningMediaCommentFromToolbar,
        commentId,
        isViewCommentMode,
        isEditor
    ]);
    (0, $42omo.useEffect)(()=>{
        let mouseTrap;
        let focusTrap;
        if (isRefSet && sidebarEl.current) {
            mouseTrap = new (0, (/*@__PURE__*/$parcel$interopDefault($lisKW)))(sidebarEl.current);
            // prevent saving via mod+enter from also publishing the page in edit mode
            mouseTrap.bind((0, $gnkil.INLINE_COMMENTS_SHORTCUT), (event)=>{
                event.stopPropagation();
            });
            if (!showA11yAnnouncement) // We need to show this on a timer so the `aria-live` listener will respond with our message
            setTimeout(()=>{
                setShowA11yAnnouncement(true);
            }, 100);
        }
        return ()=>{
            if (mouseTrap) mouseTrap.reset();
            if (focusTrap) focusTrap.deactivate();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRefSet
    ]);
    const handlePropagation = (event)=>{
        /**
     * prevents an event bubbling up to removing focus
     * from the highlight displaying the sidebar
     */ event.stopPropagation();
    };
    const handleOpeningCommentsPanel = (0, $42omo.useCallback)(()=>{
        showCommentsPanel({
            openWithView: (0, $3mVfX.ViewValues).OPEN
        });
        if (annotationId) {
            setCurrentlySelectedThreadKey(annotationId);
            if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) (0, $9FoVw.handleCommentsPanelNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                context: (0, $9FoVw.NavigationContext).PANEL,
                block: 'center',
                annotationId: annotationId,
                commentId: commentId,
                commentType: (0, $f5Wgm.CommentType).INLINE,
                annotationClicked: true
            });
            else scrollCommentsPanelToThread({
                annotationId: annotationId,
                annotationClicked: true
            });
        }
    }, [
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        scrollCommentsPanelToThread,
        annotationId,
        commentId
    ]);
    const handleOnClose = (0, $42omo.useCallback)((dialogs, isOpeningCommentsPanel = false)=>{
        if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose && onClose(false);
            }
        });
        else isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose && onClose(hasContentChanged);
    }, [
        hasContentChanged,
        onClose,
        resetContentChanged,
        handleOpeningCommentsPanel
    ]);
    const handleViewAllClick = (0, $42omo.useCallback)((dialogs)=>{
        handleOnClose(dialogs, true);
    }, [
        handleOnClose
    ]);
    const handleScroll = (0, $42omo.useCallback)((event)=>{
        if (!(0, $9wGTI.fg)('confluence_comment_header_margin')) return;
        const target = event.currentTarget;
        // Check if the inline-comment-sidebar-wrapper is scrolled
        const scrolled = target.scrollTop > 0;
        setIsScrolled(scrolled);
    }, []);
    const sidebarId = (0, $aHcFH.getSidebarId)(isEditor, isViewCommentMode);
    const mode = isEditor ? 'edit' : 'view';
    const intl = (0, $8C5kA.default)();
    const closeCommentBox = intl.formatMessage((0, $bEwJH.i18n).closeCommentBox);
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const sidebarBoundingRect = sidebarEl.current?.getBoundingClientRect();
    const isSidebarExtendedBeyondViewport = (sidebarBoundingRect?.bottom ?? 0) > window.innerHeight;
    /**
   * useEffect to handle sticky comment behavior when attached to a sticky table header.
   * As the user scrolls, the IntersectionObserver triggers the callback the moment the table header starts/stops being sticky
   */ (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) {
            const stickyHeader = annotationElement?.closest('.pm-table-sticky-wrapper');
            if (stickyHeader && !isSidebarExtendedBeyondViewport) {
                // eslint-disable-next-line no-restricted-syntax
                const observer = new IntersectionObserver(([entry])=>$2cc0402d98a7d80d$export$b8454eaf88df51d0(entry, setOldIsSticky, setSidebarOffset, sidebarOffset), {
                    threshold: 1.0
                });
                observer.observe(stickyHeader);
                return ()=>observer.disconnect();
            }
        }
    }, [
        annotationElement,
        sidebarOffset,
        sidebarEl,
        isSidebarExtendedBeyondViewport
    ]);
    const commentSidebarIsSticky = (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? isSticky : oldIsSticky;
    const commentResidesInPreviewPanel = (0, $9wGTI.fg)('confluence_comment_enable_preview_panel_support') ? (0, $eToX6.isInPreviewPanel)() : false;
    const viewAllResidesInPreviewPanel = (0, $9wGTI.fg)('confluence_previewpanel_enable_comments_panel') ? (0, $eToX6.isInPreviewPanel)() : false;
    /**
   * Below logic to set rightOffset is temporary fix.
   * It is very fragile as there are many conditions in ObjectSidebarControl
   * 	component to show/hide action bar and rovo button.
   * Also values are hardcoded.
   */ let rightOffset = 0;
    if (mode === 'view' && isObjectSidebarShown) /**
     * Need rightOffset only when container size doesn't change when
     * 	action bar panel (e.g details panel, comments panel).
     * That happens currently only in view page.
     */ rightOffset = (0, $aWwYt.MIN_PANEL_WIDTH);
    else if (/**
   * When action bar or rovo button is shown, need to set rightOffset,
   * 	otherwise long comment sidebar overlaps on it.
   */ !isObjectSidebarShown && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isRovoButtonEnabled)) /**
     * Width of action bar is 48px,
     * 	got it from object-sidebar-components/src/ObjectSidebarControl.tsx.
     * This is not ideal solution, as it is hardcoded.
     * check if previewPanel support is enabled
     */ {
        if (!commentResidesInPreviewPanel) {
            // es-lint-disable-next-line confluence-feature-gating/no-preconditioning
            if ((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) {
                rightOffset = 100; // add more offset from the right edge of the page so it doesn't overlap with the object sidebar
                if (mode === 'view') rightOffset += commentSidebarIsSticky ? 67 : 12;
                else rightOffset += commentSidebarIsSticky ? 27 : 12;
            } else rightOffset = 48 + (commentSidebarIsSticky ? 52 : 12);
        }
    }
    const a11yProps = (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
        role: 'dialog',
        'aria-modal': false,
        'aria-label': intl.formatMessage((0, $bEwJH.i18n).commentSidebarLabel, {
            name: authorName || ''
        })
    } : {};
    const sidebarContainerOffset = (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? commentSidebarIsSticky ? isEditor ? sidebarOffset : (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW) : sidebarOffset : newSidebarOffset;
    const hasMaxHeight = (0, $6wiaZ.useHasMaxHeight)({
        sidebarEl: sidebarEl,
        isRefSet: isRefSet,
        isFabricPage: isFabricPage,
        isSticky: isSticky
    });
    const isMaxHeightEnabledForSticky = (0, $6mKj3.expValEquals)('confluence_comment_enable_maxheight', 'isEnabled', true) || isSticky && (0, $9wGTI.fg)('confluence-fe-comment-temp-max-height-fix');
    const applyMaxHeightStyles = hasMaxHeight && isFabricPage && isMaxHeightEnabledForSticky;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8SCD6.ReactionsProvider), {
            contentId: pageId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "comment-sidebar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.SidebarContainer), {
            offset: sidebarContainerOffset,
            rightOffset: rightOffset,
            isSticky: commentSidebarIsSticky,
            onClick: handlePropagation,
            id: sidebarId,
            "data-testid": sidebarId,
            "data-cy": sidebarId,
            mode: mode,
            ref: (el)=>{
                sidebarEl.current = el;
                if (nudgeRef) nudgeRef.current = el;
                setRef(true);
                inlineCommentRef(el);
            },
            ...a11yProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.TopContainer), {
            showNavigation: Boolean(navigationOptions)
        }, annotationId && (0, $9wGTI.fg)('confluence-frontend-comments-panel') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            xcss: $2cc0402d98a7d80d$var$viewAllContainerStyles,
            testId: "view-all-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            onClick: ()=>handleViewAllClick(dialogs),
            iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                    ...iconProps,
                    label: "Comment Icon",
                    color: "var(--ds-icon-subtle)"
                }),
            appearance: "subtle",
            spacing: "compact",
            testId: "comment-sidebar-viewall-button",
            interactionName: "view-comments-menu-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtle"
        }, intl.formatMessage((0, $bEwJH.i18n).viewAllCommentsButtonText)))), navigationOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bXQxx.CommentNavigation), {
            pageId: pageId,
            commentData: navigationOptions.commentData,
            isEditor: isEditor,
            onNavigationClick: navigationOptions.onNavigationClick,
            disableCommentCount: navigationOptions.disableCommentCount
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: /**
                 * confluence_frontend_content_wrapper hides inline comment button
                 * confluence-frontend-comments-panel enables comments panel
                 * When either one of the feature gate is enabled, the toggle inline comments shortcut would not work
                 */ (0, $9wGTI.fg)('confluence_frontend_content_wrapper') || (0, $9wGTI.fg)('confluence-frontend-comments-panel') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $bEwJH.i18n).closeSidebarTooltip) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
                isEditorShortcut: isEditor && !isLiveViewMode,
                contentBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $bEwJH.i18n).closeSidebarTooltip),
                isTooltip: true
            }),
            hideTooltipOnClick: true,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButton), {
            appearance: "subtle",
            isUpdatedStandaloneComment: false,
            onClick: ()=>handleOnClose(dialogs),
            onMouseDown: (e)=>e.preventDefault(),
            testId: "close-comment-sidebar-button",
            "data-cy": `${isEditor ? 'editor' : 'renderer'}-close-${isViewCommentMode ? 'view' : 'create'}-comment`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: closeCommentBox,
                color: "var(--ds-icon-subtle, #505258)",
                spacing: "none"
            })
        })))), (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $2cc0402d98a7d80d$var$commentHeaderStyle,
                (0, $9wGTI.fg)('confluence_comment_header_margin') && $2cc0402d98a7d80d$var$commentNewHeaderMargin,
                !isViewCommentMode && $2cc0402d98a7d80d$var$commentEditorStyle
            ]
        }, navigationOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bXQxx.CommentNavigation), {
            pageId: pageId,
            commentData: navigationOptions.commentData,
            isEditor: isEditor,
            onNavigationClick: navigationOptions.onNavigationClick,
            disableCommentCount: navigationOptions.disableCommentCount
        }), annotationId && !viewAllResidesInPreviewPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            testId: "redesigned-view-all-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $2cc0402d98a7d80d$var$redesignedViewAllStyle,
            onClick: (e)=>{
                e.stopPropagation();
                handleViewAllClick(dialogs);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3D12W.CommentPanelButton), {
            contentId: pageId,
            testId: "standalone-comment-view-all-button",
            isStandaloneComment: true,
            isViewAllIcon: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $bEwJH.i18n).closeSidebarTooltip),
            hideTooltipOnClick: true,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButton), {
            appearance: "subtle",
            onClick: ()=>handleOnClose(dialogs),
            onMouseDown: (e)=>e.preventDefault(),
            testId: "close-comment-sidebar-button",
            "data-cy": `${isEditor ? 'editor' : 'renderer'}-close-${isViewCommentMode ? 'view' : 'create'}-comment`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: intl.formatMessage((0, $bEwJH.i18n).closeInlineCommentThread),
                color: "var(--ds-icon-subtle, #505258)",
                spacing: "none"
            }),
            isUpdatedStandaloneComment: true
        })))), isScrolled && (0, $9wGTI.fg)('confluence_comment_header_margin') && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: $2cc0402d98a7d80d$var$shadowElementStyle
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "inline-comment-sidebar-wrapper",
            ref: (el)=>{
                if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
                hasMaxHeight && isFabricPage && isMaxHeightEnabledForSticky) setPopupsScrollableElement?.(el);
            },
            xcss: [
                applyMaxHeightStyles && (0, $6mKj3.expValEquals)('confluence_frontend_fix_no_unnecessary_scrollbar', 'isEnabled', true) && $2cc0402d98a7d80d$var$boxWithMaxHeight,
                applyMaxHeightStyles && !(0, $6mKj3.expValEquals)('confluence_frontend_fix_no_unnecessary_scrollbar', 'isEnabled', true) && $2cc0402d98a7d80d$var$boxWithMaxHeightAndScroll,
                !applyMaxHeightStyles && $2cc0402d98a7d80d$var$boxWithoutMaxHeight
            ],
            onScroll: handleScroll
        }, children))))));
};
module.exports["CommentSidebar"] = $2cc0402d98a7d80d$export$d560bdb1ceec916a;

});

parcelRegister("3D12W", function(module, exports) {
/* CommentPanelButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $1yB28 = parcelRequire("1yB28");


var $jypE9 = parcelRequire("jypE9");


var $21K7m = parcelRequire("21K7m");


var $inPa6 = parcelRequire("inPa6");


var $3gadb = parcelRequire("3gadb");


var $aWwYt = parcelRequire("aWwYt");


var $8aF6s = parcelRequire("8aF6s");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $cMvMc = parcelRequire("cMvMc");


var $ep3mz = parcelRequire("ep3mz");


var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $8Q7Uc = parcelRequire("8Q7Uc");


var $iBnoc = parcelRequire("iBnoc");


var $fHAwL = parcelRequire("fHAwL");


var $cZa7r = parcelRequire("cZa7r");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $1ggpj = parcelRequire("1ggpj");


var $fT4aa = parcelRequire("fT4aa");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $404f4d0022b5692a$var$commentIconContainerStyle = null;
const $404f4d0022b5692a$var$i18n = (0, $cgtv4.defineMessages)({
    openCommentsPanelLabel: {
        id: "object-sidebar-components.open.comments.panel.label",
        defaultMessage: "Open Comments Panel"
    },
    viewAllCommentsLabel: {
        id: "object-sidebar-components.view.all.comments",
        defaultMessage: "View all comments"
    },
    showCommentsLabel: {
        id: "object-sidebar-components.show.comments.label",
        defaultMessage: "Show comments"
    },
    unreadCommentsLabel: {
        id: "object-sidebar-components.unread.comments.icon.label",
        defaultMessage: "You have unread comments"
    }
});
const $404f4d0022b5692a$export$f5ef73dad1bb3f02 = ({ contentId: contentId, collapsed: collapsed, testId: testId, isStandaloneComment: isStandaloneComment = false, isDisabled: isDisabled = false, isViewAllIcon: isViewAllIcon = false })=>{
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { commentsMarkedAsRead: commentsMarkedAsRead } = (0, $3mVfX.useCommentsPanelState)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { viewProps: viewProps, selectionProps: selectionProps, hoverProps: hoverProps, editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, showCreateComponent: showCreateComponent, selectionOptions: selectionOptions } = (0, $cZa7r.useAnnotations)();
    const { setViewProps: setViewProps, setSelectionProps: setSelectionProps, setHoverProps: setHoverProps, setEditorViewProps: setEditorViewProps, setEditorCreateProps: setEditorCreateProps, setShowCreateComponent: setShowCreateComponent, setSelectionOptions: setSelectionOptions } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const { newCommentHighlight: newCommentHighlight, activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [{ isViewMode: isLiveViewMode, isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const dataTestId = testId || 'object-sidebar-comments-button-id';
    const [contentTypeFromState] = (0, $ep3mz.useContentType)();
    const isRovoButtonEnabled = (0, $fT4aa.useAIRovoButtonEnablement)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded } = (0, $fNzRA.useObjectCommentContext)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        isEditorShortcut: pageMode === 'edit' || isLiveEditMode
    });
    // keyboard events do not bubble up to confluence when focus is in the db iframe.
    // Since the keyboard shortcut does not work, we must hide the shortcut text.
    const isShortcutTextShown = contentTypeFromState !== (0, $1ggpj.ContentType).DATABASE;
    const handleCommentClick = (0, $42omo.useCallback)(()=>{
        // FABRIC PAGES
        // Close the view component if it's open
        if (viewProps) {
            // Inform the Renderer to de-select the annotation
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS); // Remove the display of the comment
            setViewProps(null);
        }
        if (showCreateComponent && selectionOptions) {
            // Inform CreateComment to reset the state
            setShowCreateComponent(false);
            setSelectionOptions(undefined);
        }
        if (editorViewProps) {
            // Inform the editor to de-select the annotation
            eventEmitter.emit('setselectedannotation', ''); // Remove the display of the comment
            setEditorViewProps(null);
        }
        if (selectionProps) {
            selectionProps.onClose();
            setSelectionProps(null);
        }
        if (hoverProps) {
            hoverProps.onClose();
            setHoverProps(null);
        }
        if (editorCreateProps) {
            editorCreateProps?.onClose && editorCreateProps.onClose();
            setEditorCreateProps(null);
        } // LEGACY PAGES
        if (newCommentHighlight || activeHighlight) // Close the legacy inline comment panel
        window.dispatchEvent(new Event('closeLegacyInlineCommentSidebar'));
         // Should unmount the expanded comment editor
        // standalone reply, object footer comment
        if (expanded && !(0, $9wGTI.fg)('confluence_comment_panel_close_footer')) closeCommentContainer();
        if (panel?.id === 'commentsPanel') hideObjectSidebar();
        else showCommentsPanel();
    }, [
        eventEmitter,
        viewProps,
        editorViewProps,
        selectionProps,
        hoverProps,
        newCommentHighlight,
        activeHighlight,
        setViewProps,
        setEditorViewProps,
        setSelectionProps,
        setHoverProps,
        showCommentsPanel,
        hideObjectSidebar,
        panel,
        editorCreateProps,
        closeCommentContainer,
        expanded,
        setEditorCreateProps,
        showCreateComponent,
        selectionOptions,
        setShowCreateComponent,
        setSelectionOptions
    ]);
    const checkUnsavedOnClickCommentsButton = (0, $42omo.useCallback)(({ triggeredByKeyboardShortcut: triggeredByKeyboardShortcut = false, isViewAllIcon: isViewAllIcon = false } = {})=>()=>{
            // Early return for ViewAll icon - no action needed
            if (isViewAllIcon && (0, $9wGTI.fg)('confluence_comment_viewall_fix')) return;
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    handleCommentClick();
                    if ((0, $9wGTI.fg)('confluence_comments_reset_data_on_comment_discard')) resetInitialDataLoadedMap();
                }
            });
            else handleCommentClick();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'commentsPanel',
                    source: 'contentWrapper',
                    attributes: {
                        triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                        contentType: contentTypeFromState,
                        pageMode: pageMode
                    }
                }
            }).fire();
        }, [
        hasContentChanged,
        handleCommentClick,
        resetContentChanged,
        resetInitialDataLoadedMap,
        showModal,
        createAnalyticsEvent,
        contentTypeFromState,
        pageMode
    ]);
    const shortcutListeners = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (pageMode === 'view' || isLiveViewMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }), (pageMode === 'edit' || isLiveEditMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }));
    if (collapsed) return shortcutListeners;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": dataTestId,
        "data-vc": "object-sidebar-comments-button",
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: isShortcutTextShown && !(0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            contentBefore: formatMessage($404f4d0022b5692a$var$i18n.showCommentsLabel),
            isEditorShortcut: pageMode === 'edit' || isLiveEditMode,
            isTooltip: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $404f4d0022b5692a$var$i18n.showCommentsLabel),
        shortcut: isShortcutTextShown && (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? commentShortcutStrings : undefined,
        delay: 0,
        hideTooltipOnClick: true
    }, allowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: checkUnsavedOnClickCommentsButton({
            isViewAllIcon: isViewAllIcon
        }),
        appearance: "subtle",
        spacing: isStandaloneComment ? 'compact' : undefined,
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        icon: isStandaloneComment && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_panel_icon_update', 'isEnabled', true) ? (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))) : (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        label: formatMessage($404f4d0022b5692a$var$i18n.openCommentsPanelLabel),
        testId: "sidebar-comments-button",
        interactionName: "view-comments-menu-action",
        ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
            ariaLabel: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel)
        } : {},
        isDisabled: isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
    }), (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes') ? !isStandaloneComment && unreadCommentIDSet?.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iBnoc.UnreadIndicator), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Q7Uc.UnreadCommentCount), {
        pageId: contentId,
        pageMode: pageMode === 'view' ? 'view' : 'edit',
        commentsMarkedAsRead: commentsMarkedAsRead,
        isStandaloneComment: isStandaloneComment
    })), !isStandaloneComment && shortcutListeners));
};
module.exports["CommentPanelButton"] = $404f4d0022b5692a$export$f5ef73dad1bb3f02;

});

parcelRegister("8Q7Uc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bb1882b5e8585780$export$991e9ba11b35b458 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ykWGq",
    name: "UnreadCommentCount",
    loader: async ()=>(await (parcelRequire("hV0WE"))).UnreadCommentCount
});
module.exports["UnreadCommentCount"] = $bb1882b5e8585780$export$991e9ba11b35b458;

});

parcelRegister("hV0WE", function(module, exports) {

let $d0b87e34861efd6f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d0b87e34861efd6f$var$load("7ZBIQ"),
    $d0b87e34861efd6f$var$load("kpzlp")
]).then(()=>parcelRequire('i34K4'));

});

parcelRegister("iBnoc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0360a9befc1d1e18$export$d101cbe06551091d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1wNs0",
    name: "UnreadIndicator",
    loader: async ()=>(await (parcelRequire("9bA4s"))).UnreadIndicator
});
module.exports["UnreadIndicator"] = $0360a9befc1d1e18$export$d101cbe06551091d;

});

parcelRegister("9bA4s", function(module, exports) {

let $6b011f0f99d5e581$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b011f0f99d5e581$var$load("i8hiG").then(()=>parcelRequire('yTrVP'));

});

parcelRegister("bEwJH", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $6015f360c209854c$export$fafb84dd8a714e7a = 5;
const $6015f360c209854c$export$6882b33952f7e4d2 = 125;
const $6015f360c209854c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    closeCommentBox: {
        id: "annotation-provider-inline-comments.closeCommentBox",
        defaultMessage: "Close inline comments"
    },
    closeInlineCommentThread: {
        id: "annotation-provider-inline-comments.close.InlineCommentThread",
        defaultMessage: "Close inline comment thread"
    },
    closeSidebarTooltip: {
        id: "annotation-provider-inline-comments.close.icon.tooltip",
        defaultMessage: "Close comment"
    },
    viewAllCommentsButtonText: {
        id: "annotation-provider-inline-comments.view-all.button.text",
        defaultMessage: "View all"
    },
    commentSidebarLabel: {
        id: "annotation-provider-inline-comments.comment.sidebar.label",
        defaultMessage: "Inline comment by {name}"
    },
    commentSidebarAnnouncement: {
        id: "annotation-provider-inline-comments.comment.sidebar.announcement",
        defaultMessage: "Comment sidebar shown, use Shift + Tab to reach the comment sidebar"
    }
});
module.exports["MAX_UNCOLLAPSED_REPIES"] = $6015f360c209854c$export$fafb84dd8a714e7a;
module.exports["STICKY_COMMENT_VERTICAL_OFFSET_VIEW"] = $6015f360c209854c$export$6882b33952f7e4d2;
module.exports["i18n"] = $6015f360c209854c$export$a7357cdd1f0b0168;

});

parcelRegister("bXQxx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $7N1sB = parcelRequire("7N1sB");


var $9wGTI = parcelRequire("9wGTI");


var $cZa7r = parcelRequire("cZa7r");


var $3BCCf = parcelRequire("3BCCf");

const $d6eff27ff915f22d$var$positionRightStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.150',
    right: 'space.800'
});
const $d6eff27ff915f22d$var$positionLeftStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.150',
    left: 'space.150'
});
const $d6eff27ff915f22d$export$c7f093fedf3e73fe = ({ pageId: pageId, commentData: commentData, isEditor: isEditor, onNavigationClick: onNavigationClick, disableCommentCount: disableCommentCount })=>{
    const { clearStoredCommentData: clearStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { currentCommentIndex: currentCommentIndex, goToNextInlineComment: originalGoToNext, goToPrevInlineComment: originalGoToPrev, commentsCount: commentsCount } = (0, $3BCCf.useInlineCommentNavigation)({
        isEditor: isEditor,
        pageId: pageId,
        onNavigationClick: onNavigationClick,
        commentData: commentData
    });
    // Wrap navigation functions to clear stored comment data before navigation
    const goToNextInlineComment = (0, $42omo.useCallback)(()=>{
        if (clearStoredCommentData && storedCommentData) clearStoredCommentData();
        originalGoToNext();
    }, [
        clearStoredCommentData,
        storedCommentData,
        originalGoToNext
    ]);
    const goToPrevInlineComment = (0, $42omo.useCallback)(()=>{
        if (clearStoredCommentData && storedCommentData) clearStoredCommentData();
        originalGoToPrev();
    }, [
        clearStoredCommentData,
        storedCommentData,
        originalGoToPrev
    ]);
    return (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            xcss: [
                // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                (0, $9wGTI.fg)('confluence-frontend-comments-panel') && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $d6eff27ff915f22d$var$positionRightStyles,
                // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') || !(0, $9wGTI.fg)('confluence-frontend-comments-panel')) && $d6eff27ff915f22d$var$positionLeftStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7N1sB.CommentNavigation), {
            goToNextInlineComment: goToNextInlineComment,
            goToPrevInlineComment: goToPrevInlineComment,
            currentCommentIndex: currentCommentIndex,
            commentsCount: commentsCount,
            disableCommentCount: disableCommentCount
        })), [
        commentsCount,
        currentCommentIndex,
        goToNextInlineComment,
        goToPrevInlineComment,
        disableCommentCount
    ]);
};
module.exports["CommentNavigation"] = $d6eff27ff915f22d$export$c7f093fedf3e73fe;

});

parcelRegister("7N1sB", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $3gadb = parcelRequire("3gadb");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $9wGTI = parcelRequire("9wGTI");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $2eC70 = parcelRequire("2eC70");


var $aJPUt = parcelRequire("aJPUt");


var $9QIM2 = parcelRequire("9QIM2");


var $e4o8D = parcelRequire("e4o8D");


var $666Tc = parcelRequire("666Tc");

const $c0db869228662b46$var$i18n = (0, $cgtv4.defineMessages)({
    nextCommentLabel: {
        id: "inline-comments-common.next-comment-label",
        defaultMessage: "Next comment"
    },
    previousCommentLabel: {
        id: "inline-comments-common.previous-comment-label",
        defaultMessage: "Previous comment"
    }
});
const $c0db869228662b46$export$c7f093fedf3e73fe = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(62);
    const { currentCommentIndex: currentCommentIndex, commentsCount: commentsCount, isSSRFocusedComment: isSSRFocusedComment, goToNextInlineComment: goToNextInlineComment, goToPrevInlineComment: goToPrevInlineComment, disableCommentCount: t1 } = t0;
    const disableCommentCount = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [t2] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t2;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const t3 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT) : (0, $gnkil.PREV_COMMENT_SHORTCUT);
    let t4;
    if ($[0] !== t3) {
        t4 = {
            shortcut: t3
        };
        $[0] = t3;
        $[1] = t4;
    } else t4 = $[1];
    const prevCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t4);
    const t5 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT) : (0, $gnkil.NEXT_COMMENT_SHORTCUT);
    let t6;
    if ($[2] !== t5) {
        t6 = {
            shortcut: t5
        };
        $[2] = t5;
        $[3] = t6;
    } else t6 = $[3];
    const nextCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t6);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const noop = $c0db869228662b46$var$_temp;
    let t7;
    if ($[4] !== commentsCount || $[5] !== currentCommentIndex || $[6] !== disableCommentCount) {
        t7 = ()=>{
            if (disableCommentCount || currentCommentIndex === -1) return null;
            if (typeof currentCommentIndex === "number" && typeof commentsCount === "number") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "data-testid": "comment-index-and-counts"
            }, `${currentCommentIndex + 1} of ${commentsCount}`);
            else return null;
        };
        $[4] = commentsCount;
        $[5] = currentCommentIndex;
        $[6] = disableCommentCount;
        $[7] = t7;
    } else t7 = $[7];
    const renderCommentIndexAndCounts = t7;
    const isPageOrDoc = pageClass === "renderer" || pageClass === "editor";
    let t8;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== isLiveEditMode || $[10] !== isOnEditRoute) {
        t9 = (0, $9wGTI.fg)("platform_tooltip_shortcuts_migration_1") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c0db869228662b46$var$i18n.previousCommentLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            contentBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c0db869228662b46$var$i18n.previousCommentLabel),
            shortcut: isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT) : (0, $gnkil.PREV_COMMENT_SHORTCUT),
            isTooltip: true
        });
        $[9] = isLiveEditMode;
        $[10] = isOnEditRoute;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== prevCommentShortcutStrings) {
        t10 = (0, $9wGTI.fg)("platform_tooltip_shortcuts_migration_1") ? prevCommentShortcutStrings : undefined;
        $[12] = prevCommentShortcutStrings;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== formatMessage) {
        t11 = formatMessage($c0db869228662b46$var$i18n.previousCommentLabel);
        $[14] = formatMessage;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
            label: t11,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[16] = t11;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== experienceTracker || $[19] !== goToPrevInlineComment || $[20] !== isPageOrDoc || $[21] !== isSSRFocusedComment || $[22] !== pageClass) {
        t13 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc && (0, $9wGTI.fg)("confluence_frontend_view_inline_comment_arrow_nav")) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to previous comment via button.");
            return goToPrevInlineComment();
        } : noop;
        $[18] = experienceTracker;
        $[19] = goToPrevInlineComment;
        $[20] = isPageOrDoc;
        $[21] = isSSRFocusedComment;
        $[22] = pageClass;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== isSSRFocusedComment || $[25] !== t12 || $[26] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-previous",
            testId: "comment-navigation-prev",
            iconBefore: t12,
            onClick: t13
        });
        $[24] = isSSRFocusedComment;
        $[25] = t12;
        $[26] = t13;
        $[27] = t14;
    } else t14 = $[27];
    let t15;
    if ($[28] !== t10 || $[29] !== t14 || $[30] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t9,
            shortcut: t10,
            hideTooltipOnClick: true,
            position: "top"
        }, t14);
        $[28] = t10;
        $[29] = t14;
        $[30] = t9;
        $[31] = t15;
    } else t15 = $[31];
    let t16;
    if ($[32] !== isLiveEditMode || $[33] !== isOnEditRoute) {
        t16 = (0, $9wGTI.fg)("platform_tooltip_shortcuts_migration_1") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c0db869228662b46$var$i18n.nextCommentLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            contentBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c0db869228662b46$var$i18n.nextCommentLabel),
            shortcut: isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT) : (0, $gnkil.NEXT_COMMENT_SHORTCUT),
            isTooltip: true
        });
        $[32] = isLiveEditMode;
        $[33] = isOnEditRoute;
        $[34] = t16;
    } else t16 = $[34];
    let t17;
    if ($[35] !== nextCommentShortcutStrings) {
        t17 = (0, $9wGTI.fg)("platform_tooltip_shortcuts_migration_1") ? nextCommentShortcutStrings : undefined;
        $[35] = nextCommentShortcutStrings;
        $[36] = t17;
    } else t17 = $[36];
    let t18;
    if ($[37] !== formatMessage) {
        t18 = formatMessage($c0db869228662b46$var$i18n.nextCommentLabel);
        $[37] = formatMessage;
        $[38] = t18;
    } else t18 = $[38];
    let t19;
    if ($[39] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: t18,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[39] = t18;
        $[40] = t19;
    } else t19 = $[40];
    let t20;
    if ($[41] !== experienceTracker || $[42] !== goToNextInlineComment || $[43] !== isPageOrDoc || $[44] !== isSSRFocusedComment || $[45] !== pageClass) {
        t20 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc && (0, $9wGTI.fg)("confluence_frontend_view_inline_comment_arrow_nav")) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to next comment via button.");
            return goToNextInlineComment();
        } : noop;
        $[41] = experienceTracker;
        $[42] = goToNextInlineComment;
        $[43] = isPageOrDoc;
        $[44] = isSSRFocusedComment;
        $[45] = pageClass;
        $[46] = t20;
    } else t20 = $[46];
    let t21;
    if ($[47] !== isSSRFocusedComment || $[48] !== t19 || $[49] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-next",
            testId: "comment-navigation-next",
            iconBefore: t19,
            onClick: t20
        });
        $[47] = isSSRFocusedComment;
        $[48] = t19;
        $[49] = t20;
        $[50] = t21;
    } else t21 = $[50];
    let t22;
    if ($[51] !== t16 || $[52] !== t17 || $[53] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t16,
            shortcut: t17,
            hideTooltipOnClick: true,
            position: "top"
        }, t21);
        $[51] = t16;
        $[52] = t17;
        $[53] = t21;
        $[54] = t22;
    } else t22 = $[54];
    let t23;
    if ($[55] !== renderCommentIndexAndCounts || $[56] !== renderServerPlaceholder) {
        t23 = renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            id: "inline-comment-index"
        }) : renderCommentIndexAndCounts();
        $[55] = renderCommentIndexAndCounts;
        $[56] = renderServerPlaceholder;
        $[57] = t23;
    } else t23 = $[57];
    let t24;
    if ($[58] !== t15 || $[59] !== t22 || $[60] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.NavigationContainer), {
            "data-testid": "comment-navigation-container",
            shouldHaveButtonGap: t8
        }, t15, t22, t23);
        $[58] = t15;
        $[59] = t22;
        $[60] = t23;
        $[61] = t24;
    } else t24 = $[61];
    return t24;
} : ({ currentCommentIndex: currentCommentIndex, commentsCount: commentsCount, isSSRFocusedComment: isSSRFocusedComment, goToNextInlineComment: goToNextInlineComment, goToPrevInlineComment: goToPrevInlineComment, disableCommentCount: disableCommentCount = false })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const prevCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT) : (0, $gnkil.PREV_COMMENT_SHORTCUT)
    });
    const nextCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT) : (0, $gnkil.NEXT_COMMENT_SHORTCUT)
    });
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const noop = ()=>{};
    const renderCommentIndexAndCounts = ()=>{
        if (disableCommentCount || currentCommentIndex === -1) return null;
        /* doing typecheck instead of if(currentCommentIndex && commentsCount) since
      currentCommentIndex can be 0 */ if (typeof currentCommentIndex === 'number' && typeof commentsCount === 'number') return(// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-testid": "comment-index-and-counts"
        }, `${currentCommentIndex + 1} of ${commentsCount}`));
        else return null;
    };
    const isPageOrDoc = pageClass === 'renderer' || pageClass === 'editor';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.NavigationContainer), {
        "data-testid": "comment-navigation-container",
        shouldHaveButtonGap: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c0db869228662b46$var$i18n.previousCommentLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            contentBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c0db869228662b46$var$i18n.previousCommentLabel),
            shortcut: isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT) : (0, $gnkil.PREV_COMMENT_SHORTCUT),
            isTooltip: true
        }),
        shortcut: (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? prevCommentShortcutStrings : undefined,
        hideTooltipOnClick: true,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
        isSSRFocusedComment: isSSRFocusedComment,
        "data-cy": "inline-nav-previous",
        testId: "comment-navigation-prev",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
            label: formatMessage($c0db869228662b46$var$i18n.previousCommentLabel),
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        }),
        onClick: !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'comment-navigation'
            });
            if (isPageOrDoc && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_arrow_nav')) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                    entryPoint: 'inline-comments-common/CommentNavigation',
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug('Navigating to previous comment via button.');
            return goToPrevInlineComment();
        } : noop
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c0db869228662b46$var$i18n.nextCommentLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            contentBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c0db869228662b46$var$i18n.nextCommentLabel),
            shortcut: isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT) : (0, $gnkil.NEXT_COMMENT_SHORTCUT),
            isTooltip: true
        }),
        shortcut: (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? nextCommentShortcutStrings : undefined,
        hideTooltipOnClick: true,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
        isSSRFocusedComment: isSSRFocusedComment,
        "data-cy": "inline-nav-next",
        testId: "comment-navigation-next",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: formatMessage($c0db869228662b46$var$i18n.nextCommentLabel),
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        }),
        onClick: !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'comment-navigation'
            });
            if (isPageOrDoc && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_arrow_nav')) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                    entryPoint: 'inline-comments-common/CommentNavigation',
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug('Navigating to next comment via button.');
            return goToNextInlineComment();
        } : noop
    })), renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        id: "inline-comment-index"
    }) : renderCommentIndexAndCounts());
};
function $c0db869228662b46$var$_temp() {}
module.exports["CommentNavigation"] = $c0db869228662b46$export$c7f093fedf3e73fe;

});

parcelRegister("3BCCf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9jl6v = parcelRequire("9jl6v");


var $k8e76 = parcelRequire("k8e76");


var $liGyh = parcelRequire("liGyh");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");

const $33dbfc40da2aecd4$export$248861b924bd617d = ({ pageId: pageId, isEditor: isEditor, onNavigationClick: onNavigationClick, commentData: commentData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { unresolvedInlineComments: unresolvedInlineComments } = (0, $k8e76.useInlineCommentsState)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { navigateToInlineComment: navigateToInlineComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const orderedActiveAnnotations = (0, $42omo.useMemo)(()=>{
        return (0, $9wGTI.fg)('confluence_frontend_new_comments_scrolling') ? orderedActiveAnnotationIdList.map((a)=>a.threadKey) : unresolvedInlineComments;
    }, [
        orderedActiveAnnotationIdList,
        unresolvedInlineComments
    ]);
    const getCommentIndex = (0, $42omo.useCallback)((currentMarkerRef)=>{
        return orderedActiveAnnotations?.findIndex((markerRef)=>markerRef === currentMarkerRef);
    }, [
        orderedActiveAnnotations
    ]);
    const currentInlineMarkerRef = commentData?.location?.inlineMarkerRef ?? '';
    const currentCommentIndex = getCommentIndex(currentInlineMarkerRef);
    const goToNextInlineComment = (0, $42omo.useCallback)((triggeredByKeyboardShortcut = false)=>{
        navigateToInlineComment({
            action: 'next',
            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
            currentCommentIndex: currentCommentIndex,
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: isEditor,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: pageId
        });
    }, [
        getCommentIndex,
        navigateToInlineComment,
        createAnalyticsEvent,
        currentCommentIndex,
        onNavigationClick,
        pageId,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        isEditor
    ]);
    const goToPrevInlineComment = (0, $42omo.useCallback)((triggeredByKeyboardShortcut = false)=>{
        navigateToInlineComment({
            action: 'previous',
            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
            currentCommentIndex: currentCommentIndex,
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: isEditor,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: pageId
        });
    }, [
        getCommentIndex,
        navigateToInlineComment,
        createAnalyticsEvent,
        currentCommentIndex,
        onNavigationClick,
        pageId,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        isEditor
    ]);
    return (0, $42omo.useMemo)(()=>({
            currentCommentIndex: currentCommentIndex,
            goToNextInlineComment: goToNextInlineComment,
            goToPrevInlineComment: goToPrevInlineComment,
            commentsCount: orderedActiveAnnotations.length
        }), [
        goToNextInlineComment,
        goToPrevInlineComment,
        orderedActiveAnnotations.length,
        currentCommentIndex
    ]);
};
module.exports["useInlineCommentNavigation"] = $33dbfc40da2aecd4$export$248861b924bd617d;

});

parcelRegister("6wiaZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $781ef84c6c89584f$export$d1fb14f3b5498c7a = ({ sidebarEl: sidebarEl, isRefSet: isRefSet, isSticky: isSticky, isFabricPage: isFabricPage })=>{
    const [hasMaxHeight, setHasMaxHeight] = (0, $42omo.useState)(false);
    // Shared max height check logic
    const checkMaxHeight = (0, $42omo.useCallback)(()=>{
        if (!sidebarEl.current) return;
        if (isSticky) {
            setHasMaxHeight(true);
            return;
        }
        const rect = sidebarEl.current.getBoundingClientRect();
        const availableHeight = window.innerHeight - 300;
        setHasMaxHeight(rect.height > availableHeight);
    }, [
        isSticky,
        sidebarEl
    ]);
    // Max height effect for pre-render (useLayoutEffect)
    (0, $42omo.useLayoutEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
        if (!sidebarEl.current) return;
        if (!(0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        checkMaxHeight();
    }, [
        checkMaxHeight,
        isRefSet,
        isFabricPage,
        sidebarEl
    ]);
    // Max height effect for post-render (useEffect)
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
        if (!sidebarEl.current) return;
        if ((0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        checkMaxHeight();
    }, [
        checkMaxHeight,
        isRefSet,
        isFabricPage,
        sidebarEl
    ]);
    return hasMaxHeight;
};
module.exports["useHasMaxHeight"] = $781ef84c6c89584f$export$d1fb14f3b5498c7a;

});

parcelRegister("g1WP0", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $a55d612ff94024a3$var$ThirdPartyNudge = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1ebVw")).then(({ ThirdPartyNudge: ThirdPartyNudge })=>({
            default: ThirdPartyNudge
        })));

const $a55d612ff94024a3$var$NotificationNudge = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1ebVw")).then(({ NotificationNudge: NotificationNudge })=>({
            default: NotificationNudge
        })));
const $a55d612ff94024a3$export$91e508f993b0fdc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a55d612ff94024a3$var$ThirdPartyNudge, props));
const $a55d612ff94024a3$export$abc42570cc861f1b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a55d612ff94024a3$var$NotificationNudge, null));
module.exports["AsyncWrapper"] = $a55d612ff94024a3$export$91e508f993b0fdc;
module.exports["NotificationNudgeAsyncWrapper"] = $a55d612ff94024a3$export$abc42570cc861f1b;

});

parcelRegister("1ebVw", function(module, exports) {

let $0e5059a9d7d32c01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0e5059a9d7d32c01$var$load("6wr18"),
    $0e5059a9d7d32c01$var$load("1TOYq"),
    $0e5059a9d7d32c01$var$load("7EorR"),
    $0e5059a9d7d32c01$var$load("awqCy"),
    $0e5059a9d7d32c01$var$load("ffEVr"),
    $0e5059a9d7d32c01$var$load("hhss7"),
    $0e5059a9d7d32c01$var$load("bCr24")
]).then(()=>parcelRequire('arPKr'));

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("3Xfhj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bf3492583e212e7a$export$cf8a0a38543b2f6c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EfLS5",
    loader: async ()=>(await (parcelRequire("6kKIx"))).PageContentRendererFabric,
    name: 'PageContentRendererFabric'
});

const $bf3492583e212e7a$export$43e0568dbf658f88 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VZbpe",
    loader: async ()=>(await (parcelRequire("bZ5uc"))).PageContentRendererTiny,
    name: 'PageContentRendererTiny'
});
module.exports["PageContentRendererFabric"] = $bf3492583e212e7a$export$cf8a0a38543b2f6c;
module.exports["PageContentRendererTiny"] = $bf3492583e212e7a$export$43e0568dbf658f88;

});

parcelRegister("6kKIx", function(module, exports) {

let $49c8d973fb1a8c4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $49c8d973fb1a8c4a$var$load("f1NVy"),
    $49c8d973fb1a8c4a$var$load("5UCxV"),
    $49c8d973fb1a8c4a$var$load("jcLEv"),
    $49c8d973fb1a8c4a$var$load("4JQof"),
    $49c8d973fb1a8c4a$var$load("2F69B"),
    $49c8d973fb1a8c4a$var$load("ipiLs"),
    $49c8d973fb1a8c4a$var$load("laMwR"),
    $49c8d973fb1a8c4a$var$load("aZinD"),
    $49c8d973fb1a8c4a$var$load("1QdXB"),
    $49c8d973fb1a8c4a$var$load("goLL0"),
    $49c8d973fb1a8c4a$var$load("9Z7qK"),
    $49c8d973fb1a8c4a$var$load("duPDN"),
    $49c8d973fb1a8c4a$var$load("afXyT"),
    $49c8d973fb1a8c4a$var$load("1Jgsw"),
    $49c8d973fb1a8c4a$var$load("dclpt"),
    $49c8d973fb1a8c4a$var$load("tKhaz"),
    $49c8d973fb1a8c4a$var$load("cPWI2"),
    $49c8d973fb1a8c4a$var$load("lkOIY"),
    $49c8d973fb1a8c4a$var$load("dh8Yu"),
    $49c8d973fb1a8c4a$var$load("fxPKA"),
    $49c8d973fb1a8c4a$var$load("9jS5g"),
    $49c8d973fb1a8c4a$var$load("4eboO"),
    $49c8d973fb1a8c4a$var$load("8YSo7"),
    $49c8d973fb1a8c4a$var$load("9AHrA"),
    $49c8d973fb1a8c4a$var$load("jwWp5"),
    $49c8d973fb1a8c4a$var$load("4t77a"),
    $49c8d973fb1a8c4a$var$load("gLGsg"),
    $49c8d973fb1a8c4a$var$load("6FuHS"),
    $49c8d973fb1a8c4a$var$load("eyaRC"),
    $49c8d973fb1a8c4a$var$load("eHDb1"),
    $49c8d973fb1a8c4a$var$load("2zUEf"),
    $49c8d973fb1a8c4a$var$load("6wr18"),
    $49c8d973fb1a8c4a$var$load("cyGuT"),
    $49c8d973fb1a8c4a$var$load("lrvSS"),
    $49c8d973fb1a8c4a$var$load("axHWl"),
    $49c8d973fb1a8c4a$var$load("8FbYE"),
    $49c8d973fb1a8c4a$var$load("dUevD"),
    $49c8d973fb1a8c4a$var$load("iZU4p"),
    $49c8d973fb1a8c4a$var$load("fZt2F"),
    $49c8d973fb1a8c4a$var$load("kCMj8"),
    $49c8d973fb1a8c4a$var$load("5tz7G"),
    $49c8d973fb1a8c4a$var$load("7u4WP"),
    $49c8d973fb1a8c4a$var$load("Wowvf"),
    $49c8d973fb1a8c4a$var$load("let0D"),
    $49c8d973fb1a8c4a$var$load("aqr2D"),
    $49c8d973fb1a8c4a$var$load("6vyHt"),
    $49c8d973fb1a8c4a$var$load("ioQAS"),
    $49c8d973fb1a8c4a$var$load("ffEVr"),
    $49c8d973fb1a8c4a$var$load("kUbUu"),
    $49c8d973fb1a8c4a$var$load("4Lgj0"),
    $49c8d973fb1a8c4a$var$load("kSJiq"),
    $49c8d973fb1a8c4a$var$load("e9JE4"),
    $49c8d973fb1a8c4a$var$load("e4GNb"),
    $49c8d973fb1a8c4a$var$load("hhss7"),
    $49c8d973fb1a8c4a$var$load("5QKVr"),
    $49c8d973fb1a8c4a$var$load("bxFZs"),
    $49c8d973fb1a8c4a$var$load("7EorR"),
    $49c8d973fb1a8c4a$var$load("kNILH")
]).then(()=>parcelRequire('8ThhQ'));

});

parcelRegister("bZ5uc", function(module, exports) {

let $8b99a59faeaf96f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8b99a59faeaf96f8$var$load("9AHrA"),
    $8b99a59faeaf96f8$var$load("4Lgj0"),
    $8b99a59faeaf96f8$var$load("kSJiq"),
    $8b99a59faeaf96f8$var$load("LXZNT"),
    $8b99a59faeaf96f8$var$load("coJiW"),
    $8b99a59faeaf96f8$var$load("h4Nf7"),
    $8b99a59faeaf96f8$var$load("6FuHS"),
    $8b99a59faeaf96f8$var$load("eyaRC"),
    $8b99a59faeaf96f8$var$load("Wowvf"),
    $8b99a59faeaf96f8$var$load("hhss7"),
    $8b99a59faeaf96f8$var$load("5tz7G"),
    $8b99a59faeaf96f8$var$load("89Sbl"),
    $8b99a59faeaf96f8$var$load("7EorR"),
    $8b99a59faeaf96f8$var$load("e9VVN")
]).then(()=>parcelRequire('ixmFo'));

});

parcelRegister("1ITQ3", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $a4TK8 = parcelRequire("a4TK8");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");

const $336551b5acc450de$var$DEFAULT_EXTENSION_VIEWPORT_SIZES = [];
const $336551b5acc450de$export$e863f5b50b03c8cc = (skipQuery = false)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const VIEWPORT_SIZE_KEY = `${(0, $7Ndnw.FORGE_MODULE_XEN_MACRO)}:viewportSizes:${contentId}`;
    const filteredExtensions = window.__SSR_FORGE_EXTENSIONS__?.[VIEWPORT_SIZE_KEY]?.extensions ?? $336551b5acc450de$var$DEFAULT_EXTENSION_VIEWPORT_SIZES;
    // Technically here cached value can have length of 0.
    // In this case, we don't want to skip the query as we have no way to tell whether its from cache or just default value.
    const hasCachedValue = filteredExtensions.length > 0;
    const { extensions: extensions, loading: loading, error: error } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO),
        skipQuery: skipQuery || hasCachedValue
    });
    const prevExtensionViewportSizes = (0, $42omo.useRef)(filteredExtensions);
    if (loading || error || !extensions) return filteredExtensions;
    const nextExtensionViewportSizes = extensions.map(({ id: id, properties: properties })=>properties?.viewportSize ? {
            extensionId: id,
            viewportSize: properties.viewportSize
        } : undefined).filter(Boolean);
    if (prevExtensionViewportSizes.current.length !== nextExtensionViewportSizes.length || !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevExtensionViewportSizes.current, nextExtensionViewportSizes)) {
        prevExtensionViewportSizes.current = nextExtensionViewportSizes;
        // Write to window object to cache the viewport sizes.
        if (window.__SSR_FORGE_EXTENSIONS__) window.__SSR_FORGE_EXTENSIONS__ = {
            ...window.__SSR_FORGE_EXTENSIONS__,
            [VIEWPORT_SIZE_KEY]: {
                extensions: nextExtensionViewportSizes
            }
        };
    }
    return prevExtensionViewportSizes.current;
};
module.exports["useExtensionViewportSizes"] = $336551b5acc450de$export$e863f5b50b03c8cc;

});

parcelRegister("62fWd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jIiuI = parcelRequire("jIiuI");

var $5U2YR = parcelRequire("5U2YR");


var $3Spjc = parcelRequire("3Spjc");


var $6fRDv = parcelRequire("6fRDv");


var $dh538 = parcelRequire("dh538");

let $3c9dbf4421667f34$var$postRobotOn = null;

// bridge-core import relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') $3c9dbf4421667f34$var$postRobotOn = (parcelRequire("eLUTa")).postRobotOn;
const $3c9dbf4421667f34$export$64f0f7e9be5f8ff = ({ analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children, localId: localId })=>{
    // Listen for analytics events from child iframes (FAUS)
    (0, $42omo.useEffect)(()=>{
        if (localId && $3c9dbf4421667f34$var$postRobotOn && (0, $dh538.fg)('platform_add_bridge_message_forwarding_from_faus')) {
            const allowedDomain = (0, $6fRDv.getProductDomain)();
            const listener = $3c9dbf4421667f34$var$postRobotOn(`analyticsFromEmbeddedFAUS_${localId}`, {
                domain: allowedDomain
            }, async ({ data: data })=>{
                // Forward to the product's analytics client using the existing sendEvent utility
                (0, $3Spjc.sendEvent)(analyticsWebClient)(data);
            });
            return ()=>{
                listener.cancel();
            };
        }
    }, [
        analyticsWebClient,
        localId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jIiuI.EnvironmentContext).Provider, {
        value: environment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5U2YR.MetricsContextProvider), {
        value: {
            product: product,
            page: page
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Spjc.default), {
        client: analyticsWebClient,
        commonAttributes: {
            moduleType: page
        }
    }, children)));
};
module.exports["ForgeUIExtensionPointProvider"] = $3c9dbf4421667f34$export$64f0f7e9be5f8ff;

});

parcelRegister("6fRDv", function(module, exports) {
/**
 * Gets the target window for forwarding messages from FAUS to the product.
 *
 * Current architecture:
 * - Product (Confluence) → Bodied Macro → FAUS → Embedded Macro
 * - FAUS is nested 2 levels deep, so window.parent.parent is the product
 *
 * Future: This can be updated to support multiple nesting levels by checking
 * ancestorOrigins.length or using a more dynamic approach.
 *
 * @returns The product window, or null if not in a nested context
 */ function $1ed0c4b4d8f6d1ca$export$532d4b4b6d3d2c95() {
    // This would need to be changed if we want to support multiple nesting levels
    const targetWindow = window.parent?.parent;
    // Ensure we have a valid target that's not the current window
    if (targetWindow && targetWindow !== window) return targetWindow;
    return null;
}
function $1ed0c4b4d8f6d1ca$export$f0bf9a3931c6275e() {
    return `${window.location.protocol}//${window.location.hostname}`;
}
module.exports["getProductDomain"] = $1ed0c4b4d8f6d1ca$export$f0bf9a3931c6275e;

});

parcelRegister("eLUTa", function(module, exports) {
"use strict";
var $ac11956e102a58e7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ac11956e102a58e7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ac11956e102a58e7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ac11956e102a58e7$var$__exportStar((parcelRequire("fYnqe")), module.exports);

});

parcelRegister("fYnqe", function(module, exports) {
"use strict";
var $ba0ea0bb4cfa0c5b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ba0ea0bb4cfa0c5b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ba0ea0bb4cfa0c5b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ba0ea0bb4cfa0c5b$var$__exportStar((parcelRequire("3b0vC")), module.exports);

});

parcelRegister("3b0vC", function(module, exports) {
"use strict";
var $2502cb3fa9925066$var$__assign = module.exports && module.exports.__assign || function() {
    $2502cb3fa9925066$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2502cb3fa9925066$var$__assign.apply(this, arguments);
};
var $2502cb3fa9925066$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2502cb3fa9925066$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $2502cb3fa9925066$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.postRobotOn = module.exports.postRobotSend = module.exports.createIframeBridge = void 0;

var $eMRIC = parcelRequire("eMRIC");

Object.defineProperty(module.exports, "postRobotOn", {
    enumerable: true,
    get: function() {
        return $eMRIC.on;
    }
});
Object.defineProperty(module.exports, "postRobotSend", {
    enumerable: true,
    get: function() {
        return $eMRIC.send;
    }
});

var $8tWYx = parcelRequire("8tWYx");

var $2502cb3fa9925066$var$setupMessageListeners = function(window1, domain, listeners) {
    return Object.entries(listeners).map(function(_a) {
        var eventKey = _a[0], eventHandler = _a[1];
        return (0, $eMRIC.on)(eventKey, {
            window: window1,
            domain: domain
        }, function(event) {
            if (eventHandler && event.origin === domain) return eventHandler(event);
        });
    });
};
var $2502cb3fa9925066$var$createIframeBridge = function(options) {
    if (!options.withWindow) throw new Error('Target window to setup the bridge with is not defined');
    var bridge = {
        open: function() {
            var withWindow = options.withWindow, withDomain = options.withDomain, features = options.features, theme = options.theme, surfaceColor = options.surfaceColor, sendHandshakeMetric = options.sendHandshakeMetric, metadata = options.metadata, shouldReceiveEmbeddedMacroMessages = options.shouldReceiveEmbeddedMacroMessages;
            var listeners = $2502cb3fa9925066$var$setupMessageListeners(withWindow, withDomain, features);
            // Set up listener for messages forwarded from FAUS (nested embedded macros)
            var cancelEmbeddedMacroHandler;
            if (shouldReceiveEmbeddedMacroMessages && metadata.localId) try {
                var productHostname_1 = window.location.hostname;
                var handler = (0, $eMRIC.on)("messageFromEmbeddedFAUS_".concat(metadata.localId), {}, function(event) {
                    var originUrl = new URL(event.origin);
                    if (originUrl.hostname !== productHostname_1) return;
                    var _a = event.data || {}, eventKey = _a.eventKey, payload = $2502cb3fa9925066$var$__rest(_a, [
                        "eventKey"
                    ]);
                    var handler = features[eventKey];
                    if (handler) return handler($2502cb3fa9925066$var$__assign($2502cb3fa9925066$var$__assign({}, event), {
                        data: payload
                    }));
                });
                cancelEmbeddedMacroHandler = handler.cancel;
            } catch (error) {
                // Log error but don't throw - listener setup failure shouldn't break the app
                // eslint-disable-next-line no-console
                console.error("Failed to set up messageFromEmbeddedFAUS listener for localId ".concat(metadata.localId, ":"), error);
            }
            // We only listen for the READY_EVENT fired from the iframe to support hot-reloading via
            // the tunnel. Without this code the hot-reloading would not work. However we do not need
            // to send success / failure analytics as this is only relied upon during development and
            // not in production
            var cancelReadyHandler = (0, $eMRIC.on)($8tWYx.READY_EVENT, {
                window: withWindow,
                domain: withDomain
            }, function() {
                return $2502cb3fa9925066$var$__awaiter(void 0, void 0, void 0, function() {
                    return $2502cb3fa9925066$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    });
                });
            }).cancel;
            // This is the main READY_EVENT that we rely on in production to establish the bridge
            // We send an analytics event to indicate whether this handshake procedure was successful
            // or not and this is how we measure the reliability of the bridge. If an error argument
            // is not sent then the handshake was successful, when we send the caught error it was not
            (0, $eMRIC.send)(withWindow, $8tWYx.READY_EVENT, $2502cb3fa9925066$var$__assign({
                theme: theme,
                surfaceColor: surfaceColor
            }, options.metadata || {}), {
                timeout: $8tWYx.BRIDGE_HANDSHAKE_TIMEOUT_MS
            }).then(function() {
                sendHandshakeMetric(true);
            }).catch(function(error) {
                sendHandshakeMetric(false, error);
                return (0, $8tWYx.handleMissingHandlerError)(error);
            });
            return {
                enableTheming: function() {
                    (0, $eMRIC.send)(withWindow, $8tWYx.THEME_ENABLE_EVENT).catch($8tWYx.handleMissingHandlerError);
                },
                setTheme: function(theme, surfaceColor, env) {
                    (0, $eMRIC.send)(withWindow, $8tWYx.THEME_CHANGE_EVENT, {
                        theme: theme,
                        surfaceColor: surfaceColor,
                        env: env,
                        isFedRamp: metadata.isFedRamp
                    }).catch($8tWYx.handleMissingHandlerError);
                },
                close: function() {
                    cancelReadyHandler();
                    cancelEmbeddedMacroHandler === null || cancelEmbeddedMacroHandler === void 0 || cancelEmbeddedMacroHandler();
                    listeners.forEach(function(_a) {
                        var cancel = _a.cancel;
                        return cancel();
                    });
                }
            };
        }
    };
    return bridge;
};
module.exports.createIframeBridge = $2502cb3fa9925066$var$createIframeBridge;

});

parcelRegister("eMRIC", function(module, exports) {
/* @flow */ // $FlowFixMe

module.exports = (parcelRequire("p8f0R")); // eslint-disable-line import/no-commonjs
// $FlowFixMe
module.exports.default = module.exports; // eslint-disable-line import/no-commonjs

});

parcelRegister("p8f0R", function(module, exports) {

var $iA9co = parcelRequire("iA9co");

var $04b8ba6eff8b7085$require$Buffer = $iA9co.Buffer;
!function(root, factory) {
    module.exports = factory();
}("undefined" != typeof self ? self : module.exports, function() {
    return function(modules) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module1 = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            module1.l = !0;
            return module1.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                enumerable: !0,
                get: getter
            });
        };
        __webpack_require__.r = function(exports) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            Object.defineProperty(exports, "__esModule", {
                value: !0
            });
        };
        __webpack_require__.t = function(value, mode) {
            1 & mode && (value = __webpack_require__(value));
            if (8 & mode) return value;
            if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
            var ns = Object.create(null);
            __webpack_require__.r(ns);
            Object.defineProperty(ns, "default", {
                enumerable: !0,
                value: value
            });
            if (2 & mode && "string" != typeof value) for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            return ns;
        };
        __webpack_require__.n = function(module1) {
            var getter = module1 && module1.__esModule ? function() {
                return module1.default;
            } : function() {
                return module1;
            };
            __webpack_require__.d(getter, "a", getter);
            return getter;
        };
        __webpack_require__.o = function(object, property) {
            return ({}).hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = 0);
    }([
        function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Promise", function() {
                return promise_ZalgoPromise;
            });
            __webpack_require__.d(__webpack_exports__, "TYPES", function() {
                return src_types_TYPES_0;
            });
            __webpack_require__.d(__webpack_exports__, "ProxyWindow", function() {
                return window_ProxyWindow;
            });
            __webpack_require__.d(__webpack_exports__, "setup", function() {
                return setup;
            });
            __webpack_require__.d(__webpack_exports__, "destroy", function() {
                return destroy;
            });
            __webpack_require__.d(__webpack_exports__, "serializeMessage", function() {
                return setup_serializeMessage;
            });
            __webpack_require__.d(__webpack_exports__, "deserializeMessage", function() {
                return setup_deserializeMessage;
            });
            __webpack_require__.d(__webpack_exports__, "createProxyWindow", function() {
                return createProxyWindow;
            });
            __webpack_require__.d(__webpack_exports__, "toProxyWindow", function() {
                return setup_toProxyWindow;
            });
            __webpack_require__.d(__webpack_exports__, "on", function() {
                return on_on;
            });
            __webpack_require__.d(__webpack_exports__, "once", function() {
                return on_once;
            });
            __webpack_require__.d(__webpack_exports__, "send", function() {
                return send_send;
            });
            __webpack_require__.d(__webpack_exports__, "markWindowKnown", function() {
                return markWindowKnown;
            });
            __webpack_require__.d(__webpack_exports__, "cleanUpWindow", function() {
                return cleanUpWindow;
            });
            __webpack_require__.d(__webpack_exports__, "bridge", function() {});
            function isRegex(item) {
                return "[object RegExp]" === ({}).toString.call(item);
            }
            var IE_WIN_ACCESS_ERROR = "Call was rejected by callee.\r\n";
            function isAboutProtocol(win) {
                void 0 === win && (win = window);
                return "about:" === win.location.protocol;
            }
            function getParent(win) {
                void 0 === win && (win = window);
                if (win) try {
                    if (win.parent && win.parent !== win) return win.parent;
                } catch (err) {}
            }
            function getOpener(win) {
                void 0 === win && (win = window);
                if (win && !getParent(win)) try {
                    return win.opener;
                } catch (err) {}
            }
            function canReadFromWindow(win) {
                try {
                    return !0;
                } catch (err) {}
                return !1;
            }
            function getActualDomain(win) {
                void 0 === win && (win = window);
                var location = win.location;
                if (!location) throw new Error("Can not read window location");
                var protocol = location.protocol;
                if (!protocol) throw new Error("Can not read window protocol");
                if ("file:" === protocol) return "file://";
                if ("about:" === protocol) {
                    var parent = getParent(win);
                    return parent && canReadFromWindow() ? getActualDomain(parent) : "about://";
                }
                var host = location.host;
                if (!host) throw new Error("Can not read window host");
                return protocol + "//" + host;
            }
            function getDomain(win) {
                void 0 === win && (win = window);
                var domain = getActualDomain(win);
                return domain && win.mockDomain && 0 === win.mockDomain.indexOf("mock:") ? win.mockDomain : domain;
            }
            function isSameDomain(win) {
                if (!function(win) {
                    try {
                        if (win === window) return !0;
                    } catch (err) {}
                    try {
                        var desc = Object.getOwnPropertyDescriptor(win, "location");
                        if (desc && !1 === desc.enumerable) return !1;
                    } catch (err) {}
                    try {
                        if (isAboutProtocol(win) && canReadFromWindow()) return !0;
                    } catch (err) {}
                    try {
                        if (getActualDomain(win) === getActualDomain(window)) return !0;
                    } catch (err) {}
                    return !1;
                }(win)) return !1;
                try {
                    if (win === window) return !0;
                    if (isAboutProtocol(win) && canReadFromWindow()) return !0;
                    if (getDomain(window) === getDomain(win)) return !0;
                } catch (err) {}
                return !1;
            }
            function assertSameDomain(win) {
                if (!isSameDomain(win)) throw new Error("Expected window to be same domain");
                return win;
            }
            function isAncestorParent(parent, child) {
                if (!parent || !child) return !1;
                var childParent = getParent(child);
                return childParent ? childParent === parent : -1 !== (function(win) {
                    var result = [];
                    try {
                        for(; win.parent !== win;){
                            result.push(win.parent);
                            win = win.parent;
                        }
                    } catch (err) {}
                    return result;
                })(child).indexOf(parent);
            }
            function getFrames(win) {
                var result = [];
                var frames;
                try {
                    frames = win.frames;
                } catch (err) {
                    frames = win;
                }
                var len;
                try {
                    len = frames.length;
                } catch (err) {}
                if (0 === len) return result;
                if (len) {
                    for(var i = 0; i < len; i++){
                        var frame = void 0;
                        try {
                            frame = frames[i];
                        } catch (err) {
                            continue;
                        }
                        result.push(frame);
                    }
                    return result;
                }
                for(var _i = 0; _i < 100; _i++){
                    var _frame = void 0;
                    try {
                        _frame = frames[_i];
                    } catch (err) {
                        return result;
                    }
                    if (!_frame) return result;
                    result.push(_frame);
                }
                return result;
            }
            var iframeWindows = [];
            var iframeFrames = [];
            function isWindowClosed(win, allowMock) {
                void 0 === allowMock && (allowMock = !0);
                try {
                    if (win === window) return !1;
                } catch (err) {
                    return !0;
                }
                try {
                    if (!win) return !0;
                } catch (err) {
                    return !0;
                }
                try {
                    if (win.closed) return !0;
                } catch (err) {
                    return !err || err.message !== IE_WIN_ACCESS_ERROR;
                }
                if (allowMock && isSameDomain(win)) try {
                    if (win.mockclosed) return !0;
                } catch (err) {}
                try {
                    if (!win.parent || !win.top) return !0;
                } catch (err) {}
                var iframeIndex = function(collection, item) {
                    for(var i = 0; i < collection.length; i++)try {
                        if (collection[i] === item) return i;
                    } catch (err) {}
                    return -1;
                }(iframeWindows, win);
                if (-1 !== iframeIndex) {
                    var frame = iframeFrames[iframeIndex];
                    if (frame && function(frame) {
                        if (!frame.contentWindow) return !0;
                        if (!frame.parentNode) return !0;
                        var doc = frame.ownerDocument;
                        if (doc && doc.documentElement && !doc.documentElement.contains(frame)) {
                            var parent = frame;
                            for(; parent.parentNode && parent.parentNode !== parent;)parent = parent.parentNode;
                            if (!parent.host || !doc.documentElement.contains(parent.host)) return !0;
                        }
                        return !1;
                    }(frame)) return !0;
                }
                return !1;
            }
            function getAncestor(win) {
                void 0 === win && (win = window);
                return getOpener(win = win || window) || getParent(win) || void 0;
            }
            function matchDomain(pattern, origin) {
                if ("string" == typeof pattern) {
                    if ("string" == typeof origin) return "*" === pattern || origin === pattern;
                    if (isRegex(origin)) return !1;
                    if (Array.isArray(origin)) return !1;
                }
                return isRegex(pattern) ? isRegex(origin) ? pattern.toString() === origin.toString() : !Array.isArray(origin) && Boolean(origin.match(pattern)) : !!Array.isArray(pattern) && (Array.isArray(origin) ? JSON.stringify(pattern) === JSON.stringify(origin) : !isRegex(origin) && pattern.some(function(subpattern) {
                    return matchDomain(subpattern, origin);
                }));
            }
            function isWindow(obj) {
                try {
                    if (obj === window) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if ("[object Window]" === ({}).toString.call(obj)) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (window.Window && obj instanceof window.Window) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.self === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.parent === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.top === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && "__unlikely_value__" === obj.__cross_domain_utils_window_check__) return !1;
                } catch (err) {
                    return !0;
                }
                try {
                    if ("postMessage" in obj && "self" in obj && "location" in obj) return !0;
                } catch (err) {}
                return !1;
            }
            function closeWindow(win) {
                try {
                    win.close();
                } catch (err) {}
            }
            function utils_isPromise(item) {
                try {
                    if (!item) return !1;
                    if ("undefined" != typeof Promise && item instanceof Promise) return !0;
                    if ("undefined" != typeof window && "function" == typeof window.Window && item instanceof window.Window) return !1;
                    if ("undefined" != typeof window && "function" == typeof window.constructor && item instanceof window.constructor) return !1;
                    var _toString = {}.toString;
                    if (_toString) {
                        var name = _toString.call(item);
                        if ("[object Window]" === name || "[object global]" === name || "[object DOMWindow]" === name) return !1;
                    }
                    if ("function" == typeof item.then) return !0;
                } catch (err) {
                    return !1;
                }
                return !1;
            }
            var dispatchedErrors = [];
            var possiblyUnhandledPromiseHandlers = [];
            var activeCount = 0;
            var flushPromise;
            function flushActive() {
                if (!activeCount && flushPromise) {
                    var promise = flushPromise;
                    flushPromise = null;
                    promise.resolve();
                }
            }
            function startActive() {
                activeCount += 1;
            }
            function endActive() {
                activeCount -= 1;
                flushActive();
            }
            var promise_ZalgoPromise = function() {
                function ZalgoPromise(handler) {
                    var _this = this;
                    this.resolved = void 0;
                    this.rejected = void 0;
                    this.errorHandled = void 0;
                    this.value = void 0;
                    this.error = void 0;
                    this.handlers = void 0;
                    this.dispatching = void 0;
                    this.stack = void 0;
                    this.resolved = !1;
                    this.rejected = !1;
                    this.errorHandled = !1;
                    this.handlers = [];
                    if (handler) {
                        var _result;
                        var _error;
                        var resolved = !1;
                        var rejected = !1;
                        var isAsync = !1;
                        startActive();
                        try {
                            handler(function(res) {
                                if (isAsync) _this.resolve(res);
                                else {
                                    resolved = !0;
                                    _result = res;
                                }
                            }, function(err) {
                                if (isAsync) _this.reject(err);
                                else {
                                    rejected = !0;
                                    _error = err;
                                }
                            });
                        } catch (err) {
                            endActive();
                            this.reject(err);
                            return;
                        }
                        endActive();
                        isAsync = !0;
                        resolved ? this.resolve(_result) : rejected && this.reject(_error);
                    }
                }
                var _proto = ZalgoPromise.prototype;
                _proto.resolve = function(result) {
                    if (this.resolved || this.rejected) return this;
                    if (utils_isPromise(result)) throw new Error("Can not resolve promise with another promise");
                    this.resolved = !0;
                    this.value = result;
                    this.dispatch();
                    return this;
                };
                _proto.reject = function(error) {
                    var _this2 = this;
                    if (this.resolved || this.rejected) return this;
                    if (utils_isPromise(error)) throw new Error("Can not reject promise with another promise");
                    if (!error) {
                        var _err = error && "function" == typeof error.toString ? error.toString() : ({}).toString.call(error);
                        error = new Error("Expected reject to be called with Error, got " + _err);
                    }
                    this.rejected = !0;
                    this.error = error;
                    this.errorHandled || setTimeout(function() {
                        _this2.errorHandled || function(err, promise) {
                            if (-1 === dispatchedErrors.indexOf(err)) {
                                dispatchedErrors.push(err);
                                setTimeout(function() {
                                    throw err;
                                }, 1);
                                for(var j = 0; j < possiblyUnhandledPromiseHandlers.length; j++)possiblyUnhandledPromiseHandlers[j](err, promise);
                            }
                        }(error, _this2);
                    }, 1);
                    this.dispatch();
                    return this;
                };
                _proto.asyncReject = function(error) {
                    this.errorHandled = !0;
                    this.reject(error);
                    return this;
                };
                _proto.dispatch = function() {
                    var resolved = this.resolved, rejected = this.rejected, handlers = this.handlers;
                    if (!this.dispatching && (resolved || rejected)) {
                        this.dispatching = !0;
                        startActive();
                        var chain = function(firstPromise, secondPromise) {
                            return firstPromise.then(function(res) {
                                secondPromise.resolve(res);
                            }, function(err) {
                                secondPromise.reject(err);
                            });
                        };
                        for(var i = 0; i < handlers.length; i++){
                            var _handlers$i = handlers[i], onSuccess = _handlers$i.onSuccess, onError = _handlers$i.onError, promise = _handlers$i.promise;
                            var _result2 = void 0;
                            if (resolved) try {
                                _result2 = onSuccess ? onSuccess(this.value) : this.value;
                            } catch (err) {
                                promise.reject(err);
                                continue;
                            }
                            else if (rejected) {
                                if (!onError) {
                                    promise.reject(this.error);
                                    continue;
                                }
                                try {
                                    _result2 = onError(this.error);
                                } catch (err) {
                                    promise.reject(err);
                                    continue;
                                }
                            }
                            if (_result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected)) {
                                _result2.resolved ? promise.resolve(_result2.value) : promise.reject(_result2.error);
                                _result2.errorHandled = !0;
                            } else utils_isPromise(_result2) ? _result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected) ? _result2.resolved ? promise.resolve(_result2.value) : promise.reject(_result2.error) : chain(_result2, promise) : promise.resolve(_result2);
                        }
                        handlers.length = 0;
                        this.dispatching = !1;
                        endActive();
                    }
                };
                _proto.then = function(onSuccess, onError) {
                    if (onSuccess && "function" != typeof onSuccess && !onSuccess.call) throw new Error("Promise.then expected a function for success handler");
                    if (onError && "function" != typeof onError && !onError.call) throw new Error("Promise.then expected a function for error handler");
                    var promise = new ZalgoPromise;
                    this.handlers.push({
                        promise: promise,
                        onSuccess: onSuccess,
                        onError: onError
                    });
                    this.errorHandled = !0;
                    this.dispatch();
                    return promise;
                };
                _proto.catch = function(onError) {
                    return this.then(void 0, onError);
                };
                _proto.finally = function(onFinally) {
                    if (onFinally && "function" != typeof onFinally && !onFinally.call) throw new Error("Promise.finally expected a function");
                    return this.then(function(result) {
                        return ZalgoPromise.try(onFinally).then(function() {
                            return result;
                        });
                    }, function(err) {
                        return ZalgoPromise.try(onFinally).then(function() {
                            throw err;
                        });
                    });
                };
                _proto.timeout = function(time, err) {
                    var _this3 = this;
                    if (this.resolved || this.rejected) return this;
                    var timeout = setTimeout(function() {
                        _this3.resolved || _this3.rejected || _this3.reject(err || new Error("Promise timed out after " + time + "ms"));
                    }, time);
                    return this.then(function(result) {
                        clearTimeout(timeout);
                        return result;
                    });
                };
                _proto.toPromise = function() {
                    if ("undefined" == typeof Promise) throw new TypeError("Could not find Promise");
                    return Promise.resolve(this);
                };
                ZalgoPromise.resolve = function(value) {
                    return value instanceof ZalgoPromise ? value : utils_isPromise(value) ? new ZalgoPromise(function(resolve, reject) {
                        return value.then(resolve, reject);
                    }) : (new ZalgoPromise).resolve(value);
                };
                ZalgoPromise.reject = function(error) {
                    return (new ZalgoPromise).reject(error);
                };
                ZalgoPromise.asyncReject = function(error) {
                    return (new ZalgoPromise).asyncReject(error);
                };
                ZalgoPromise.all = function(promises) {
                    var promise = new ZalgoPromise;
                    var count = promises.length;
                    var results = [];
                    if (!count) {
                        promise.resolve(results);
                        return promise;
                    }
                    var chain = function(i, firstPromise, secondPromise) {
                        return firstPromise.then(function(res) {
                            results[i] = res;
                            0 == (count -= 1) && promise.resolve(results);
                        }, function(err) {
                            secondPromise.reject(err);
                        });
                    };
                    for(var i = 0; i < promises.length; i++){
                        var prom = promises[i];
                        if (prom instanceof ZalgoPromise) {
                            if (prom.resolved) {
                                results[i] = prom.value;
                                count -= 1;
                                continue;
                            }
                        } else if (!utils_isPromise(prom)) {
                            results[i] = prom;
                            count -= 1;
                            continue;
                        }
                        chain(i, ZalgoPromise.resolve(prom), promise);
                    }
                    0 === count && promise.resolve(results);
                    return promise;
                };
                ZalgoPromise.hash = function(promises) {
                    var result = {};
                    var awaitPromises = [];
                    var _loop = function(key) {
                        if (promises.hasOwnProperty(key)) {
                            var value = promises[key];
                            utils_isPromise(value) ? awaitPromises.push(value.then(function(res) {
                                result[key] = res;
                            })) : result[key] = value;
                        }
                    };
                    for(var key in promises)_loop(key);
                    return ZalgoPromise.all(awaitPromises).then(function() {
                        return result;
                    });
                };
                ZalgoPromise.map = function(items, method) {
                    return ZalgoPromise.all(items.map(method));
                };
                ZalgoPromise.onPossiblyUnhandledException = function(handler) {
                    return function(handler) {
                        possiblyUnhandledPromiseHandlers.push(handler);
                        return {
                            cancel: function() {
                                possiblyUnhandledPromiseHandlers.splice(possiblyUnhandledPromiseHandlers.indexOf(handler), 1);
                            }
                        };
                    }(handler);
                };
                ZalgoPromise.try = function(method, context, args) {
                    if (method && "function" != typeof method && !method.call) throw new Error("Promise.try expected a function");
                    var result;
                    startActive();
                    try {
                        result = method.apply(context, args || []);
                    } catch (err) {
                        endActive();
                        return ZalgoPromise.reject(err);
                    }
                    endActive();
                    return ZalgoPromise.resolve(result);
                };
                ZalgoPromise.delay = function(_delay) {
                    return new ZalgoPromise(function(resolve) {
                        setTimeout(resolve, _delay);
                    });
                };
                ZalgoPromise.isPromise = function(value) {
                    return !!(value && value instanceof ZalgoPromise) || utils_isPromise(value);
                };
                ZalgoPromise.flush = function() {
                    return function(Zalgo) {
                        var promise = flushPromise = flushPromise || new Zalgo;
                        flushActive();
                        return promise;
                    }(ZalgoPromise);
                };
                return ZalgoPromise;
            }();
            function util_safeIndexOf(collection, item) {
                for(var i = 0; i < collection.length; i++)try {
                    if (collection[i] === item) return i;
                } catch (err) {}
                return -1;
            }
            var weakmap_CrossDomainSafeWeakMap = function() {
                function CrossDomainSafeWeakMap() {
                    this.name = void 0;
                    this.weakmap = void 0;
                    this.keys = void 0;
                    this.values = void 0;
                    this.name = "__weakmap_" + (1e9 * Math.random() >>> 0) + "__";
                    if (function() {
                        if ("undefined" == typeof WeakMap) return !1;
                        if (void 0 === Object.freeze) return !1;
                        try {
                            var testWeakMap = new WeakMap;
                            var testKey = {};
                            Object.freeze(testKey);
                            testWeakMap.set(testKey, "__testvalue__");
                            return "__testvalue__" === testWeakMap.get(testKey);
                        } catch (err) {
                            return !1;
                        }
                    }()) try {
                        this.weakmap = new WeakMap;
                    } catch (err) {}
                    this.keys = [];
                    this.values = [];
                }
                var _proto = CrossDomainSafeWeakMap.prototype;
                _proto._cleanupClosedWindows = function() {
                    var weakmap = this.weakmap;
                    var keys = this.keys;
                    for(var i = 0; i < keys.length; i++){
                        var value = keys[i];
                        if (isWindow(value) && isWindowClosed(value)) {
                            if (weakmap) try {
                                weakmap.delete(value);
                            } catch (err) {}
                            keys.splice(i, 1);
                            this.values.splice(i, 1);
                            i -= 1;
                        }
                    }
                };
                _proto.isSafeToReadWrite = function(key) {
                    return !isWindow(key);
                };
                _proto.set = function(key, value) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        weakmap.set(key, value);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var name = this.name;
                        var entry = key[name];
                        entry && entry[0] === key ? entry[1] = value : Object.defineProperty(key, name, {
                            value: [
                                key,
                                value
                            ],
                            writable: !0
                        });
                        return;
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    var keys = this.keys;
                    var values = this.values;
                    var index = util_safeIndexOf(keys, key);
                    if (-1 === index) {
                        keys.push(key);
                        values.push(value);
                    } else values[index] = value;
                };
                _proto.get = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        if (weakmap.has(key)) return weakmap.get(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var entry = key[this.name];
                        return entry && entry[0] === key ? entry[1] : void 0;
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    var index = util_safeIndexOf(this.keys, key);
                    if (-1 !== index) return this.values[index];
                };
                _proto.delete = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        weakmap.delete(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var entry = key[this.name];
                        entry && entry[0] === key && (entry[0] = entry[1] = void 0);
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    var keys = this.keys;
                    var index = util_safeIndexOf(keys, key);
                    if (-1 !== index) {
                        keys.splice(index, 1);
                        this.values.splice(index, 1);
                    }
                };
                _proto.has = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        if (weakmap.has(key)) return !0;
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var entry = key[this.name];
                        return !(!entry || entry[0] !== key);
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    return -1 !== util_safeIndexOf(this.keys, key);
                };
                _proto.getOrSet = function(key, getter) {
                    if (this.has(key)) return this.get(key);
                    var value = getter();
                    this.set(key, value);
                    return value;
                };
                return CrossDomainSafeWeakMap;
            }();
            function getFunctionName(fn) {
                return fn.name || fn.__name__ || fn.displayName || "anonymous";
            }
            function setFunctionName(fn, name) {
                try {
                    delete fn.name;
                    fn.name = name;
                } catch (err) {}
                fn.__name__ = fn.displayName = name;
                return fn;
            }
            function uniqueID() {
                var chars = "0123456789abcdef";
                return "xxxxxxxxxx".replace(/./g, function() {
                    return chars.charAt(Math.floor(Math.random() * chars.length));
                }) + "_" + (function(str) {
                    if ("function" == typeof btoa) return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(m, p1) {
                        return String.fromCharCode(parseInt(p1, 16));
                    }));
                    if ("undefined" != typeof $04b8ba6eff8b7085$require$Buffer) return $04b8ba6eff8b7085$require$Buffer.from(str, "utf8").toString("base64");
                    throw new Error("Can not find window.btoa or Buffer");
                })((new Date).toISOString().slice(11, 19).replace("T", ".")).replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
            }
            var objectIDs;
            function serializeArgs(args) {
                try {
                    return JSON.stringify([].slice.call(args), function(subkey, val) {
                        return "function" == typeof val ? "memoize[" + function(obj) {
                            objectIDs = objectIDs || new weakmap_CrossDomainSafeWeakMap;
                            if (null == obj || "object" != typeof obj && "function" != typeof obj) throw new Error("Invalid object");
                            var uid = objectIDs.get(obj);
                            if (!uid) {
                                uid = typeof obj + ":" + uniqueID();
                                objectIDs.set(obj, uid);
                            }
                            return uid;
                        }(val) + "]" : val;
                    });
                } catch (err) {
                    throw new Error("Arguments not serializable -- can not be used to memoize");
                }
            }
            var memoizedFunctions = [];
            function memoize(method, options) {
                var _this = this;
                void 0 === options && (options = {});
                var cacheMap = new weakmap_CrossDomainSafeWeakMap;
                var memoizedFunction = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var cache = cacheMap.getOrSet(options.thisNamespace ? this : method, function() {
                        return {};
                    });
                    var key = serializeArgs(args);
                    var cacheTime = options.time;
                    cache[key] && cacheTime && Date.now() - cache[key].time < cacheTime && delete cache[key];
                    if (cache[key]) return cache[key].value;
                    var time = Date.now();
                    var value = method.apply(this, arguments);
                    cache[key] = {
                        time: time,
                        value: value
                    };
                    return cache[key].value;
                };
                memoizedFunction.reset = function() {
                    cacheMap.delete(options.thisNamespace ? _this : method);
                };
                memoizedFunctions.push(memoizedFunction);
                return setFunctionName(memoizedFunction, (options.name || getFunctionName(method)) + "::memoized");
            }
            memoize.clear = function() {
                for(var _i2 = 0; _i2 < memoizedFunctions.length; _i2++)memoizedFunctions[_i2].reset();
            };
            function memoizePromise(method) {
                var cache = {};
                function memoizedPromiseFunction() {
                    var _arguments = arguments, _this2 = this;
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    var key = serializeArgs(args);
                    if (cache.hasOwnProperty(key)) return cache[key];
                    cache[key] = promise_ZalgoPromise.try(function() {
                        return method.apply(_this2, _arguments);
                    }).finally(function() {
                        delete cache[key];
                    });
                    return cache[key];
                }
                memoizedPromiseFunction.reset = function() {
                    cache = {};
                };
                return setFunctionName(memoizedPromiseFunction, getFunctionName(method) + "::promiseMemoized");
            }
            function src_util_noop() {}
            function stringifyError(err, level) {
                void 0 === level && (level = 1);
                if (level >= 3) return "stringifyError stack overflow";
                try {
                    if (!err) return "<unknown error: " + ({}).toString.call(err) + ">";
                    if ("string" == typeof err) return err;
                    if (err instanceof Error) {
                        var stack = err && err.stack;
                        var message = err && err.message;
                        if (stack && message) return -1 !== stack.indexOf(message) ? stack : message + "\n" + stack;
                        if (stack) return stack;
                        if (message) return message;
                    }
                    return err && err.toString && "function" == typeof err.toString ? err.toString() : ({}).toString.call(err);
                } catch (newErr) {
                    return "Error while stringifying error: " + stringifyError(newErr, level + 1);
                }
            }
            function stringify(item) {
                return "string" == typeof item ? item : item && item.toString && "function" == typeof item.toString ? item.toString() : ({}).toString.call(item);
            }
            memoize(function(obj) {
                if (Object.values) return Object.values(obj);
                var result = [];
                for(var key in obj)obj.hasOwnProperty(key) && result.push(obj[key]);
                return result;
            });
            function util_isRegex(item) {
                return "[object RegExp]" === ({}).toString.call(item);
            }
            function util_getOrSet(obj, key, getter) {
                if (obj.hasOwnProperty(key)) return obj[key];
                var val = getter();
                obj[key] = val;
                return val;
            }
            Error;
            function isDocumentReady() {
                return Boolean(document.body) && "complete" === document.readyState;
            }
            function isDocumentInteractive() {
                return Boolean(document.body) && "interactive" === document.readyState;
            }
            memoize(function() {
                return new promise_ZalgoPromise(function(resolve) {
                    if (isDocumentReady() || isDocumentInteractive()) return resolve();
                    var interval = setInterval(function() {
                        if (isDocumentReady() || isDocumentInteractive()) {
                            clearInterval(interval);
                            return resolve();
                        }
                    }, 10);
                });
            });
            var currentScript = "undefined" != typeof document ? document.currentScript : null;
            var getCurrentScript = memoize(function() {
                if (currentScript) return currentScript;
                if (currentScript = function() {
                    try {
                        var stack = function() {
                            try {
                                throw new Error("_");
                            } catch (err) {
                                return err.stack || "";
                            }
                        }();
                        var stackDetails = /.*at [^(]*\((.*):(.+):(.+)\)$/gi.exec(stack);
                        var scriptLocation = stackDetails && stackDetails[1];
                        if (!scriptLocation) return;
                        for(var _i20 = 0, _Array$prototype$slic2 = [].slice.call(document.getElementsByTagName("script")).reverse(); _i20 < _Array$prototype$slic2.length; _i20++){
                            var script = _Array$prototype$slic2[_i20];
                            if (script.src && script.src === scriptLocation) return script;
                        }
                    } catch (err) {}
                }()) return currentScript;
                throw new Error("Can not determine current script");
            });
            var currentUID = uniqueID();
            memoize(function() {
                var script;
                try {
                    script = getCurrentScript();
                } catch (err) {
                    return currentUID;
                }
                var uid = script.getAttribute("data-uid");
                if (uid && "string" == typeof uid) return uid;
                uid = uniqueID();
                script.setAttribute("data-uid", uid);
                return uid;
            });
            function global_getGlobal(win) {
                void 0 === win && (win = window);
                var globalKey = "__post_robot_10_0_41__";
                return win !== window ? win[globalKey] : win[globalKey] = win[globalKey] || {};
            }
            var getObj = function() {
                return {};
            };
            function globalStore(key, defStore) {
                void 0 === key && (key = "store");
                void 0 === defStore && (defStore = getObj);
                return util_getOrSet(global_getGlobal(), key, function() {
                    var store = defStore();
                    return {
                        has: function(storeKey) {
                            return store.hasOwnProperty(storeKey);
                        },
                        get: function(storeKey, defVal) {
                            return store.hasOwnProperty(storeKey) ? store[storeKey] : defVal;
                        },
                        set: function(storeKey, val) {
                            store[storeKey] = val;
                            return val;
                        },
                        del: function(storeKey) {
                            delete store[storeKey];
                        },
                        getOrSet: function(storeKey, getter) {
                            return util_getOrSet(store, storeKey, getter);
                        },
                        reset: function() {
                            store = defStore();
                        },
                        keys: function() {
                            return Object.keys(store);
                        }
                    };
                });
            }
            var WildCard = function() {};
            function getWildcard() {
                var global = global_getGlobal();
                global.WINDOW_WILDCARD = global.WINDOW_WILDCARD || new WildCard;
                return global.WINDOW_WILDCARD;
            }
            function windowStore(key, defStore) {
                void 0 === key && (key = "store");
                void 0 === defStore && (defStore = getObj);
                return globalStore("windowStore").getOrSet(key, function() {
                    var winStore = new weakmap_CrossDomainSafeWeakMap;
                    var getStore = function(win) {
                        return winStore.getOrSet(win, defStore);
                    };
                    return {
                        has: function(win) {
                            return getStore(win).hasOwnProperty(key);
                        },
                        get: function(win, defVal) {
                            var store = getStore(win);
                            return store.hasOwnProperty(key) ? store[key] : defVal;
                        },
                        set: function(win, val) {
                            getStore(win)[key] = val;
                            return val;
                        },
                        del: function(win) {
                            delete getStore(win)[key];
                        },
                        getOrSet: function(win, getter) {
                            return util_getOrSet(getStore(win), key, getter);
                        }
                    };
                });
            }
            function getInstanceID() {
                return globalStore("instance").getOrSet("instanceID", uniqueID);
            }
            function resolveHelloPromise(win, _ref) {
                var domain = _ref.domain;
                var helloPromises = windowStore("helloPromises");
                var existingPromise = helloPromises.get(win);
                existingPromise && existingPromise.resolve({
                    domain: domain
                });
                var newPromise = promise_ZalgoPromise.resolve({
                    domain: domain
                });
                helloPromises.set(win, newPromise);
                return newPromise;
            }
            function sayHello(win, _ref4) {
                return (0, _ref4.send)(win, "postrobot_hello", {
                    instanceID: getInstanceID()
                }, {
                    domain: "*",
                    timeout: -1
                }).then(function(_ref5) {
                    var origin = _ref5.origin, instanceID = _ref5.data.instanceID;
                    resolveHelloPromise(win, {
                        domain: origin
                    });
                    return {
                        win: win,
                        domain: origin,
                        instanceID: instanceID
                    };
                });
            }
            function getWindowInstanceID(win, _ref6) {
                var send = _ref6.send;
                return windowStore("windowInstanceIDPromises").getOrSet(win, function() {
                    return sayHello(win, {
                        send: send
                    }).then(function(_ref7) {
                        return _ref7.instanceID;
                    });
                });
            }
            function markWindowKnown(win) {
                windowStore("knownWindows").set(win, !0);
            }
            function isSerializedType(item) {
                return "object" == typeof item && null !== item && "string" == typeof item.__type__;
            }
            function determineType(val) {
                return void 0 === val ? "undefined" : null === val ? "null" : Array.isArray(val) ? "array" : "function" == typeof val ? "function" : "object" == typeof val ? val instanceof Error ? "error" : "function" == typeof val.then ? "promise" : "[object RegExp]" === ({}).toString.call(val) ? "regex" : "[object Date]" === ({}).toString.call(val) ? "date" : "object" : "string" == typeof val ? "string" : "number" == typeof val ? "number" : "boolean" == typeof val ? "boolean" : void 0;
            }
            function serializeType(type, val) {
                return {
                    __type__: type,
                    __val__: val
                };
            }
            var _SERIALIZER;
            var SERIALIZER = ((_SERIALIZER = {}).function = function() {}, _SERIALIZER.error = function(_ref) {
                return serializeType("error", {
                    message: _ref.message,
                    stack: _ref.stack,
                    code: _ref.code,
                    data: _ref.data
                });
            }, _SERIALIZER.promise = function() {}, _SERIALIZER.regex = function(val) {
                return serializeType("regex", val.source);
            }, _SERIALIZER.date = function(val) {
                return serializeType("date", val.toJSON());
            }, _SERIALIZER.array = function(val) {
                return val;
            }, _SERIALIZER.object = function(val) {
                return val;
            }, _SERIALIZER.string = function(val) {
                return val;
            }, _SERIALIZER.number = function(val) {
                return val;
            }, _SERIALIZER.boolean = function(val) {
                return val;
            }, _SERIALIZER.null = function(val) {
                return val;
            }, _SERIALIZER);
            var defaultSerializers = {};
            var _DESERIALIZER;
            var DESERIALIZER = ((_DESERIALIZER = {}).function = function() {
                throw new Error("Function serialization is not implemented; nothing to deserialize");
            }, _DESERIALIZER.error = function(_ref2) {
                var stack = _ref2.stack, code = _ref2.code, data = _ref2.data;
                var error = new Error(_ref2.message);
                error.code = code;
                data && (error.data = data);
                error.stack = stack + "\n\n" + error.stack;
                return error;
            }, _DESERIALIZER.promise = function() {
                throw new Error("Promise serialization is not implemented; nothing to deserialize");
            }, _DESERIALIZER.regex = function(val) {
                return new RegExp(val);
            }, _DESERIALIZER.date = function(val) {
                return new Date(val);
            }, _DESERIALIZER.array = function(val) {
                return val;
            }, _DESERIALIZER.object = function(val) {
                return val;
            }, _DESERIALIZER.string = function(val) {
                return val;
            }, _DESERIALIZER.number = function(val) {
                return val;
            }, _DESERIALIZER.boolean = function(val) {
                return val;
            }, _DESERIALIZER.null = function(val) {
                return val;
            }, _DESERIALIZER);
            var defaultDeserializers = {};
            new promise_ZalgoPromise(function(resolve) {
                if (window.document && window.document.body) return resolve(window.document.body);
                var interval = setInterval(function() {
                    if (window.document && window.document.body) {
                        clearInterval(interval);
                        return resolve(window.document.body);
                    }
                }, 10);
            });
            function cleanupProxyWindows() {
                var idToProxyWindow = globalStore("idToProxyWindow");
                for(var _i2 = 0, _idToProxyWindow$keys2 = idToProxyWindow.keys(); _i2 < _idToProxyWindow$keys2.length; _i2++){
                    var id = _idToProxyWindow$keys2[_i2];
                    idToProxyWindow.get(id).shouldClean() && idToProxyWindow.del(id);
                }
            }
            function getSerializedWindow(winPromise, _ref) {
                var send = _ref.send, _ref$id = _ref.id, id = void 0 === _ref$id ? uniqueID() : _ref$id;
                var windowNamePromise = winPromise.then(function(win) {
                    if (isSameDomain(win)) return assertSameDomain(win).name;
                });
                var windowTypePromise = winPromise.then(function(window1) {
                    if (isWindowClosed(window1)) throw new Error("Window is closed, can not determine type");
                    return getOpener(window1) ? "popup" : "iframe";
                });
                windowNamePromise.catch(src_util_noop);
                windowTypePromise.catch(src_util_noop);
                return {
                    id: id,
                    getType: function() {
                        return windowTypePromise;
                    },
                    getInstanceID: memoizePromise(function() {
                        return winPromise.then(function(win) {
                            return getWindowInstanceID(win, {
                                send: send
                            });
                        });
                    }),
                    close: function() {
                        return winPromise.then(closeWindow);
                    },
                    getName: function() {
                        return winPromise.then(function(win) {
                            if (!isWindowClosed(win)) return isSameDomain(win) ? assertSameDomain(win).name : windowNamePromise;
                        });
                    },
                    focus: function() {
                        return winPromise.then(function(win) {
                            win.focus();
                        });
                    },
                    isClosed: function() {
                        return winPromise.then(function(win) {
                            return isWindowClosed(win);
                        });
                    },
                    setLocation: function(href) {
                        return winPromise.then(function(win) {
                            var domain = window.location.protocol + "//" + window.location.host;
                            if (0 === href.indexOf("/")) href = "" + domain + href;
                            else if (!href.match(/^https?:\/\//) && 0 !== href.indexOf(domain)) throw new Error("Expected url to be http or https url, or absolute path, got " + JSON.stringify(href));
                            if (isSameDomain(win)) try {
                                if (win.location && "function" == typeof win.location.replace) {
                                    win.location.replace(href);
                                    return;
                                }
                            } catch (err) {}
                            win.location = href;
                        });
                    },
                    setName: function(name) {
                        return winPromise.then(function(win) {
                            var sameDomain = isSameDomain(win);
                            var frame = function(win) {
                                if (isSameDomain(win)) return assertSameDomain(win).frameElement;
                                for(var _i21 = 0, _document$querySelect2 = document.querySelectorAll("iframe"); _i21 < _document$querySelect2.length; _i21++){
                                    var frame = _document$querySelect2[_i21];
                                    if (frame && frame.contentWindow && frame.contentWindow === win) return frame;
                                }
                            }(win);
                            if (!sameDomain) throw new Error("Can not set name for cross-domain window: " + name);
                            assertSameDomain(win).name = name;
                            frame && frame.setAttribute("name", name);
                            windowNamePromise = promise_ZalgoPromise.resolve(name);
                        });
                    }
                };
            }
            var window_ProxyWindow = function() {
                function ProxyWindow(_ref2) {
                    var send = _ref2.send, win = _ref2.win, serializedWindow = _ref2.serializedWindow;
                    this.id = void 0;
                    this.isProxyWindow = !0;
                    this.serializedWindow = void 0;
                    this.actualWindow = void 0;
                    this.actualWindowPromise = void 0;
                    this.send = void 0;
                    this.name = void 0;
                    this.actualWindowPromise = new promise_ZalgoPromise;
                    this.serializedWindow = serializedWindow || getSerializedWindow(this.actualWindowPromise, {
                        send: send
                    });
                    globalStore("idToProxyWindow").set(this.getID(), this);
                    win && this.setWindow(win, {
                        send: send
                    });
                }
                var _proto = ProxyWindow.prototype;
                _proto.getID = function() {
                    return this.serializedWindow.id;
                };
                _proto.getType = function() {
                    return this.serializedWindow.getType();
                };
                _proto.isPopup = function() {
                    return this.getType().then(function(type) {
                        return "popup" === type;
                    });
                };
                _proto.setLocation = function(href) {
                    var _this = this;
                    return this.serializedWindow.setLocation(href).then(function() {
                        return _this;
                    });
                };
                _proto.getName = function() {
                    return this.serializedWindow.getName();
                };
                _proto.setName = function(name) {
                    var _this2 = this;
                    return this.serializedWindow.setName(name).then(function() {
                        return _this2;
                    });
                };
                _proto.close = function() {
                    var _this3 = this;
                    return this.serializedWindow.close().then(function() {
                        return _this3;
                    });
                };
                _proto.focus = function() {
                    var _this4 = this;
                    var isPopupPromise = this.isPopup();
                    var getNamePromise = this.getName();
                    var reopenPromise = promise_ZalgoPromise.hash({
                        isPopup: isPopupPromise,
                        name: getNamePromise
                    }).then(function(_ref3) {
                        var name = _ref3.name;
                        _ref3.isPopup && name && window.open("", name);
                    });
                    var focusPromise = this.serializedWindow.focus();
                    return promise_ZalgoPromise.all([
                        reopenPromise,
                        focusPromise
                    ]).then(function() {
                        return _this4;
                    });
                };
                _proto.isClosed = function() {
                    return this.serializedWindow.isClosed();
                };
                _proto.getWindow = function() {
                    return this.actualWindow;
                };
                _proto.setWindow = function(win, _ref4) {
                    var send = _ref4.send;
                    this.actualWindow = win;
                    this.actualWindowPromise.resolve(this.actualWindow);
                    this.serializedWindow = getSerializedWindow(this.actualWindowPromise, {
                        send: send,
                        id: this.getID()
                    });
                    windowStore("winToProxyWindow").set(win, this);
                };
                _proto.awaitWindow = function() {
                    return this.actualWindowPromise;
                };
                _proto.matchWindow = function(win, _ref5) {
                    var _this5 = this;
                    var send = _ref5.send;
                    return promise_ZalgoPromise.try(function() {
                        return _this5.actualWindow ? win === _this5.actualWindow : promise_ZalgoPromise.hash({
                            proxyInstanceID: _this5.getInstanceID(),
                            knownWindowInstanceID: getWindowInstanceID(win, {
                                send: send
                            })
                        }).then(function(_ref6) {
                            var match = _ref6.proxyInstanceID === _ref6.knownWindowInstanceID;
                            match && _this5.setWindow(win, {
                                send: send
                            });
                            return match;
                        });
                    });
                };
                _proto.unwrap = function() {
                    return this.actualWindow || this;
                };
                _proto.getInstanceID = function() {
                    return this.serializedWindow.getInstanceID();
                };
                _proto.shouldClean = function() {
                    return Boolean(this.actualWindow && isWindowClosed(this.actualWindow));
                };
                _proto.serialize = function() {
                    return this.serializedWindow;
                };
                ProxyWindow.unwrap = function(win) {
                    return ProxyWindow.isProxyWindow(win) ? win.unwrap() : win;
                };
                ProxyWindow.serialize = function(win, _ref7) {
                    var send = _ref7.send;
                    cleanupProxyWindows();
                    return ProxyWindow.toProxyWindow(win, {
                        send: send
                    }).serialize();
                };
                ProxyWindow.deserialize = function(serializedWindow, _ref8) {
                    var send = _ref8.send;
                    cleanupProxyWindows();
                    return globalStore("idToProxyWindow").get(serializedWindow.id) || new ProxyWindow({
                        serializedWindow: serializedWindow,
                        send: send
                    });
                };
                ProxyWindow.isProxyWindow = function(obj) {
                    return Boolean(obj && !isWindow(obj) && obj.isProxyWindow);
                };
                ProxyWindow.toProxyWindow = function(win, _ref9) {
                    var send = _ref9.send;
                    cleanupProxyWindows();
                    if (ProxyWindow.isProxyWindow(win)) return win;
                    var actualWindow = win;
                    return windowStore("winToProxyWindow").get(actualWindow) || new ProxyWindow({
                        win: actualWindow,
                        send: send
                    });
                };
                return ProxyWindow;
            }();
            function addMethod(id, val, name, source, domain) {
                var methodStore = windowStore("methodStore");
                var proxyWindowMethods = globalStore("proxyWindowMethods");
                if (window_ProxyWindow.isProxyWindow(source)) proxyWindowMethods.set(id, {
                    val: val,
                    name: name,
                    domain: domain,
                    source: source
                });
                else {
                    proxyWindowMethods.del(id);
                    methodStore.getOrSet(source, function() {
                        return {};
                    })[id] = {
                        domain: domain,
                        name: name,
                        val: val,
                        source: source
                    };
                }
            }
            function lookupMethod(source, id) {
                var methodStore = windowStore("methodStore");
                var proxyWindowMethods = globalStore("proxyWindowMethods");
                return methodStore.getOrSet(source, function() {
                    return {};
                })[id] || proxyWindowMethods.get(id);
            }
            function function_serializeFunction(destination, domain, val, key, _ref3) {
                on = (_ref = {
                    on: _ref3.on,
                    send: _ref3.send
                }).on, send = _ref.send, globalStore("builtinListeners").getOrSet("functionCalls", function() {
                    return on("postrobot_method", {
                        domain: "*"
                    }, function(_ref2) {
                        var source = _ref2.source, origin = _ref2.origin, data = _ref2.data;
                        var id = data.id, name = data.name;
                        var meth = lookupMethod(source, id);
                        if (!meth) throw new Error("Could not find method '" + name + "' with id: " + data.id + " in " + getDomain(window));
                        var methodSource = meth.source, domain = meth.domain, val = meth.val;
                        return promise_ZalgoPromise.try(function() {
                            if (!matchDomain(domain, origin)) throw new Error("Method '" + data.name + "' domain " + JSON.stringify(util_isRegex(meth.domain) ? meth.domain.source : meth.domain) + " does not match origin " + origin + " in " + getDomain(window));
                            if (window_ProxyWindow.isProxyWindow(methodSource)) return methodSource.matchWindow(source, {
                                send: send
                            }).then(function(match) {
                                if (!match) throw new Error("Method call '" + data.name + "' failed - proxy window does not match source in " + getDomain(window));
                            });
                        }).then(function() {
                            return val.apply({
                                source: source,
                                origin: origin
                            }, data.args);
                        }, function(err) {
                            return promise_ZalgoPromise.try(function() {
                                if (val.onError) return val.onError(err);
                            }).then(function() {
                                err.stack && (err.stack = "Remote call to " + name + "(" + function(args) {
                                    void 0 === args && (args = []);
                                    var item;
                                    return (item = args, [].slice.call(item)).map(function(arg) {
                                        return "string" == typeof arg ? "'" + arg + "'" : void 0 === arg ? "undefined" : null === arg ? "null" : "boolean" == typeof arg ? arg.toString() : Array.isArray(arg) ? "[ ... ]" : "object" == typeof arg ? "{ ... }" : "function" == typeof arg ? "() => { ... }" : "<" + typeof arg + ">";
                                    }).join(", ");
                                }(data.args) + ") failed\n\n" + err.stack);
                                throw err;
                            });
                        }).then(function(result) {
                            return {
                                result: result,
                                id: id,
                                name: name
                            };
                        });
                    });
                });
                var _ref, on, send;
                var id = val.__id__ || uniqueID();
                destination = window_ProxyWindow.unwrap(destination);
                var name = val.__name__ || val.name || key;
                "string" == typeof name && "function" == typeof name.indexOf && 0 === name.indexOf("anonymous::") && (name = name.replace("anonymous::", key + "::"));
                if (window_ProxyWindow.isProxyWindow(destination)) {
                    addMethod(id, val, name, destination, domain);
                    destination.awaitWindow().then(function(win) {
                        addMethod(id, val, name, win, domain);
                    });
                } else addMethod(id, val, name, destination, domain);
                return serializeType("cross_domain_function", {
                    id: id,
                    name: name
                });
            }
            function serializeMessage(destination, domain, obj, _ref) {
                var _serialize;
                var on = _ref.on, send = _ref.send;
                return function(obj, serializers) {
                    void 0 === serializers && (serializers = defaultSerializers);
                    var result = JSON.stringify(obj, function(key) {
                        var val = this[key];
                        if (isSerializedType(this)) return val;
                        var type = determineType(val);
                        if (!type) return val;
                        var serializer = serializers[type] || SERIALIZER[type];
                        return serializer ? serializer(val, key) : val;
                    });
                    return void 0 === result ? "undefined" : result;
                }(obj, ((_serialize = {}).promise = function(val, key) {
                    return function(destination, domain, val, key, _ref) {
                        return serializeType("cross_domain_zalgo_promise", {
                            then: function_serializeFunction(destination, domain, function(resolve, reject) {
                                return val.then(resolve, reject);
                            }, key, {
                                on: _ref.on,
                                send: _ref.send
                            })
                        });
                    }(destination, domain, val, key, {
                        on: on,
                        send: send
                    });
                }, _serialize.function = function(val, key) {
                    return function_serializeFunction(destination, domain, val, key, {
                        on: on,
                        send: send
                    });
                }, _serialize.object = function(val) {
                    return isWindow(val) || window_ProxyWindow.isProxyWindow(val) ? serializeType("cross_domain_window", window_ProxyWindow.serialize(val, {
                        send: send
                    })) : val;
                }, _serialize));
            }
            function deserializeMessage(source, origin, message, _ref2) {
                var _deserialize;
                var send = _ref2.send;
                return function(str, deserializers) {
                    void 0 === deserializers && (deserializers = defaultDeserializers);
                    if ("undefined" !== str) return JSON.parse(str, function(key, val) {
                        if (isSerializedType(this)) return val;
                        var type;
                        var value;
                        if (isSerializedType(val)) {
                            type = val.__type__;
                            value = val.__val__;
                        } else {
                            type = determineType(val);
                            value = val;
                        }
                        if (!type) return value;
                        var deserializer = deserializers[type] || DESERIALIZER[type];
                        return deserializer ? deserializer(value, key) : value;
                    });
                }(message, ((_deserialize = {}).cross_domain_zalgo_promise = function(serializedPromise) {
                    return function(source, origin, _ref2) {
                        return new promise_ZalgoPromise(_ref2.then);
                    }(0, 0, serializedPromise);
                }, _deserialize.cross_domain_function = function(serializedFunction) {
                    return function(source, origin, _ref4, _ref5) {
                        var id = _ref4.id, name = _ref4.name;
                        var send = _ref5.send;
                        var getDeserializedFunction = function(opts) {
                            void 0 === opts && (opts = {});
                            function crossDomainFunctionWrapper() {
                                var _arguments = arguments;
                                return window_ProxyWindow.toProxyWindow(source, {
                                    send: send
                                }).awaitWindow().then(function(win) {
                                    var meth = lookupMethod(win, id);
                                    if (meth && meth.val !== crossDomainFunctionWrapper) return meth.val.apply({
                                        source: window,
                                        origin: getDomain()
                                    }, _arguments);
                                    var _args = [].slice.call(_arguments);
                                    return opts.fireAndForget ? send(win, "postrobot_method", {
                                        id: id,
                                        name: name,
                                        args: _args
                                    }, {
                                        domain: origin,
                                        fireAndForget: !0
                                    }) : send(win, "postrobot_method", {
                                        id: id,
                                        name: name,
                                        args: _args
                                    }, {
                                        domain: origin,
                                        fireAndForget: !1
                                    }).then(function(res) {
                                        return res.data.result;
                                    });
                                }).catch(function(err) {
                                    throw err;
                                });
                            }
                            crossDomainFunctionWrapper.__name__ = name;
                            crossDomainFunctionWrapper.__origin__ = origin;
                            crossDomainFunctionWrapper.__source__ = source;
                            crossDomainFunctionWrapper.__id__ = id;
                            crossDomainFunctionWrapper.origin = origin;
                            return crossDomainFunctionWrapper;
                        };
                        var crossDomainFunctionWrapper = getDeserializedFunction();
                        crossDomainFunctionWrapper.fireAndForget = getDeserializedFunction({
                            fireAndForget: !0
                        });
                        return crossDomainFunctionWrapper;
                    }(source, origin, serializedFunction, {
                        send: send
                    });
                }, _deserialize.cross_domain_window = function(serializedWindow) {
                    return window_ProxyWindow.deserialize(serializedWindow, {
                        send: send
                    });
                }, _deserialize));
            }
            var SEND_MESSAGE_STRATEGIES = {};
            SEND_MESSAGE_STRATEGIES.postrobot_post_message = function(win, serializedMessage, domain) {
                0 === domain.indexOf("file:") && (domain = "*");
                win.postMessage(serializedMessage, domain);
            };
            function send_sendMessage(win, domain, message, _ref2) {
                var on = _ref2.on, send = _ref2.send;
                return promise_ZalgoPromise.try(function() {
                    var domainBuffer = windowStore().getOrSet(win, function() {
                        return {};
                    });
                    domainBuffer.buffer = domainBuffer.buffer || [];
                    domainBuffer.buffer.push(message);
                    domainBuffer.flush = domainBuffer.flush || promise_ZalgoPromise.flush().then(function() {
                        if (isWindowClosed(win)) throw new Error("Window is closed");
                        var serializedMessage = serializeMessage(win, domain, ((_ref = {}).__post_robot_10_0_41__ = domainBuffer.buffer || [], _ref), {
                            on: on,
                            send: send
                        });
                        var _ref;
                        delete domainBuffer.buffer;
                        var strategies = Object.keys(SEND_MESSAGE_STRATEGIES);
                        var errors = [];
                        for(var _i2 = 0; _i2 < strategies.length; _i2++){
                            var strategyName = strategies[_i2];
                            try {
                                SEND_MESSAGE_STRATEGIES[strategyName](win, serializedMessage, domain);
                            } catch (err) {
                                errors.push(err);
                            }
                        }
                        if (errors.length === strategies.length) throw new Error("All post-robot messaging strategies failed:\n\n" + errors.map(function(err, i) {
                            return i + ". " + stringifyError(err);
                        }).join("\n\n"));
                    });
                    return domainBuffer.flush.then(function() {
                        delete domainBuffer.flush;
                    });
                }).then(src_util_noop);
            }
            function getResponseListener(hash) {
                return globalStore("responseListeners").get(hash);
            }
            function deleteResponseListener(hash) {
                globalStore("responseListeners").del(hash);
            }
            function isResponseListenerErrored(hash) {
                return globalStore("erroredResponseListeners").has(hash);
            }
            function getRequestListener(_ref) {
                var name = _ref.name, win = _ref.win, domain = _ref.domain;
                var requestListeners = windowStore("requestListeners");
                "*" === win && (win = null);
                "*" === domain && (domain = null);
                if (!name) throw new Error("Name required to get request listener");
                for(var _i4 = 0, _ref3 = [
                    win,
                    getWildcard()
                ]; _i4 < _ref3.length; _i4++){
                    var winQualifier = _ref3[_i4];
                    if (winQualifier) {
                        var nameListeners = requestListeners.get(winQualifier);
                        if (nameListeners) {
                            var domainListeners = nameListeners[name];
                            if (domainListeners) {
                                if (domain && "string" == typeof domain) {
                                    if (domainListeners[domain]) return domainListeners[domain];
                                    if (domainListeners.__domain_regex__) for(var _i6 = 0, _domainListeners$__DO2 = domainListeners.__domain_regex__; _i6 < _domainListeners$__DO2.length; _i6++){
                                        var _domainListeners$__DO3 = _domainListeners$__DO2[_i6], listener = _domainListeners$__DO3.listener;
                                        if (matchDomain(_domainListeners$__DO3.regex, domain)) return listener;
                                    }
                                }
                                if (domainListeners["*"]) return domainListeners["*"];
                            }
                        }
                    }
                }
            }
            function handleRequest(source, origin, message, _ref) {
                var on = _ref.on, send = _ref.send;
                var options = getRequestListener({
                    name: message.name,
                    win: source,
                    domain: origin
                });
                var logName = "postrobot_method" === message.name && message.data && "string" == typeof message.data.name ? message.data.name + "()" : message.name;
                function sendResponse(ack, data, error) {
                    return promise_ZalgoPromise.flush().then(function() {
                        if (!message.fireAndForget && !isWindowClosed(source)) try {
                            return send_sendMessage(source, origin, {
                                id: uniqueID(),
                                origin: getDomain(window),
                                type: "postrobot_message_response",
                                hash: message.hash,
                                name: message.name,
                                ack: ack,
                                data: data,
                                error: error
                            }, {
                                on: on,
                                send: send
                            });
                        } catch (err) {
                            throw new Error("Send response message failed for " + logName + " in " + getDomain() + "\n\n" + stringifyError(err));
                        }
                    });
                }
                return promise_ZalgoPromise.all([
                    promise_ZalgoPromise.flush().then(function() {
                        if (!message.fireAndForget && !isWindowClosed(source)) try {
                            return send_sendMessage(source, origin, {
                                id: uniqueID(),
                                origin: getDomain(window),
                                type: "postrobot_message_ack",
                                hash: message.hash,
                                name: message.name
                            }, {
                                on: on,
                                send: send
                            });
                        } catch (err) {
                            throw new Error("Send ack message failed for " + logName + " in " + getDomain() + "\n\n" + stringifyError(err));
                        }
                    }),
                    promise_ZalgoPromise.try(function() {
                        if (!options) throw new Error("No handler found for post message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                        if (!matchDomain(options.domain, origin)) throw new Error("Request origin " + origin + " does not match domain " + options.domain.toString());
                        return options.handler({
                            source: source,
                            origin: origin,
                            data: message.data
                        });
                    }).then(function(data) {
                        return sendResponse("success", data);
                    }, function(error) {
                        return sendResponse("error", null, error);
                    })
                ]).then(src_util_noop).catch(function(err) {
                    if (options && options.handleError) return options.handleError(err);
                    throw err;
                });
            }
            function handleAck(source, origin, message) {
                if (!isResponseListenerErrored(message.hash)) {
                    var options = getResponseListener(message.hash);
                    if (!options) throw new Error("No handler found for post message ack for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                    try {
                        if (!matchDomain(options.domain, origin)) throw new Error("Ack origin " + origin + " does not match domain " + options.domain.toString());
                        if (source !== options.win) throw new Error("Ack source does not match registered window");
                    } catch (err) {
                        options.promise.reject(err);
                    }
                    options.ack = !0;
                }
            }
            function handleResponse(source, origin, message) {
                if (!isResponseListenerErrored(message.hash)) {
                    var options = getResponseListener(message.hash);
                    if (!options) throw new Error("No handler found for post message response for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                    if (!matchDomain(options.domain, origin)) throw new Error("Response origin " + origin + " does not match domain " + (pattern = options.domain, Array.isArray(pattern) ? "(" + pattern.join(" | ") + ")" : isRegex(pattern) ? "RegExp(" + pattern.toString() : pattern.toString()));
                    var pattern;
                    if (source !== options.win) throw new Error("Response source does not match registered window");
                    deleteResponseListener(message.hash);
                    "error" === message.ack ? options.promise.reject(message.error) : "success" === message.ack && options.promise.resolve({
                        source: source,
                        origin: origin,
                        data: message.data
                    });
                }
            }
            function receive_receiveMessage(event, _ref2) {
                var on = _ref2.on, send = _ref2.send;
                var receivedMessages = globalStore("receivedMessages");
                try {
                    if (!window || window.closed || !event.source) return;
                } catch (err) {
                    return;
                }
                var source = event.source, origin = event.origin;
                var messages = function(message, source, origin, _ref) {
                    var on = _ref.on, send = _ref.send;
                    var parsedMessage;
                    try {
                        parsedMessage = deserializeMessage(source, origin, message, {
                            on: on,
                            send: send
                        });
                    } catch (err) {
                        return;
                    }
                    if (parsedMessage && "object" == typeof parsedMessage && null !== parsedMessage) {
                        var parseMessages = parsedMessage.__post_robot_10_0_41__;
                        if (Array.isArray(parseMessages)) return parseMessages;
                    }
                }(event.data, source, origin, {
                    on: on,
                    send: send
                });
                if (messages) {
                    markWindowKnown(source);
                    for(var _i2 = 0; _i2 < messages.length; _i2++){
                        var message = messages[_i2];
                        if (receivedMessages.has(message.id)) return;
                        receivedMessages.set(message.id, !0);
                        if (isWindowClosed(source) && !message.fireAndForget) return;
                        0 === message.origin.indexOf("file:") && (origin = "file://");
                        try {
                            "postrobot_message_request" === message.type ? handleRequest(source, origin, message, {
                                on: on,
                                send: send
                            }) : "postrobot_message_response" === message.type ? handleResponse(source, origin, message) : "postrobot_message_ack" === message.type && handleAck(source, origin, message);
                        } catch (err) {
                            setTimeout(function() {
                                throw err;
                            }, 0);
                        }
                    }
                }
            }
            function on_on(name, options, handler) {
                if (!name) throw new Error("Expected name");
                if ("function" == typeof (options = options || {})) {
                    handler = options;
                    options = {};
                }
                if (!handler) throw new Error("Expected handler");
                (options = options || {}).name = name;
                options.handler = handler || options.handler;
                var win = options.window;
                var domain = options.domain;
                var requestListener = function addRequestListener(_ref4, listener) {
                    var name = _ref4.name, win = _ref4.win, domain = _ref4.domain;
                    var requestListeners = windowStore("requestListeners");
                    if (!name || "string" != typeof name) throw new Error("Name required to add request listener");
                    if (Array.isArray(win)) {
                        var listenersCollection = [];
                        for(var _i8 = 0, _win2 = win; _i8 < _win2.length; _i8++)listenersCollection.push(addRequestListener({
                            name: name,
                            domain: domain,
                            win: _win2[_i8]
                        }, listener));
                        return {
                            cancel: function() {
                                for(var _i10 = 0; _i10 < listenersCollection.length; _i10++)listenersCollection[_i10].cancel();
                            }
                        };
                    }
                    if (Array.isArray(domain)) {
                        var _listenersCollection = [];
                        for(var _i12 = 0, _domain2 = domain; _i12 < _domain2.length; _i12++)_listenersCollection.push(addRequestListener({
                            name: name,
                            win: win,
                            domain: _domain2[_i12]
                        }, listener));
                        return {
                            cancel: function() {
                                for(var _i14 = 0; _i14 < _listenersCollection.length; _i14++)_listenersCollection[_i14].cancel();
                            }
                        };
                    }
                    var existingListener = getRequestListener({
                        name: name,
                        win: win,
                        domain: domain
                    });
                    win && "*" !== win || (win = getWildcard());
                    domain = domain || "*";
                    if (existingListener) throw win && domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString() + " for " + (win === getWildcard() ? "wildcard" : "specified") + " window") : win ? new Error("Request listener already exists for " + name + " for " + (win === getWildcard() ? "wildcard" : "specified") + " window") : domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString()) : new Error("Request listener already exists for " + name);
                    var nameListeners = requestListeners.getOrSet(win, function() {
                        return {};
                    });
                    var domainListeners = util_getOrSet(nameListeners, name, function() {
                        return {};
                    });
                    var strDomain = domain.toString();
                    var regexListeners;
                    var regexListener;
                    util_isRegex(domain) ? (regexListeners = util_getOrSet(domainListeners, "__domain_regex__", function() {
                        return [];
                    })).push(regexListener = {
                        regex: domain,
                        listener: listener
                    }) : domainListeners[strDomain] = listener;
                    return {
                        cancel: function() {
                            delete domainListeners[strDomain];
                            if (regexListener) {
                                regexListeners.splice(regexListeners.indexOf(regexListener, 1));
                                regexListeners.length || delete domainListeners.__domain_regex__;
                            }
                            Object.keys(domainListeners).length || delete nameListeners[name];
                            win && !Object.keys(nameListeners).length && requestListeners.del(win);
                        }
                    };
                }({
                    name: name,
                    win: win,
                    domain: domain
                }, {
                    handler: options.handler,
                    handleError: options.errorHandler || function(err) {
                        throw err;
                    },
                    window: win,
                    domain: domain || "*",
                    name: name
                });
                return {
                    cancel: function() {
                        requestListener.cancel();
                    }
                };
            }
            function on_once(name, options, handler) {
                if ("function" == typeof (options = options || {})) {
                    handler = options;
                    options = {};
                }
                var promise = new promise_ZalgoPromise;
                var listener;
                options.errorHandler = function(err) {
                    listener.cancel();
                    promise.reject(err);
                };
                listener = on_on(name, options, function(event) {
                    listener.cancel();
                    promise.resolve(event);
                    if (handler) return handler(event);
                });
                promise.cancel = listener.cancel;
                return promise;
            }
            var send_send = function send(win, name, data, options) {
                var domainMatcher = (options = options || {}).domain || "*";
                var responseTimeout = options.timeout || -1;
                var childTimeout = options.timeout || 5e3;
                var fireAndForget = options.fireAndForget || !1;
                return promise_ZalgoPromise.try(function() {
                    !function(name, win, domain) {
                        if (!name) throw new Error("Expected name");
                        if (domain && "string" != typeof domain && !Array.isArray(domain) && !util_isRegex(domain)) throw new TypeError("Can not send " + name + ". Expected domain " + JSON.stringify(domain) + " to be a string, array, or regex");
                        if (isWindowClosed(win)) throw new Error("Can not send " + name + ". Target window is closed");
                    }(name, win, domainMatcher);
                    if (function(parent, child) {
                        var actualParent = getAncestor(child);
                        if (actualParent) return actualParent === parent;
                        if (child === parent) return !1;
                        if (function(win) {
                            void 0 === win && (win = window);
                            try {
                                if (win.top) return win.top;
                            } catch (err) {}
                            if (getParent(win) === win) return win;
                            try {
                                if (isAncestorParent(window, win) && window.top) return window.top;
                            } catch (err) {}
                            try {
                                if (isAncestorParent(win, window) && window.top) return window.top;
                            } catch (err) {}
                            for(var _i7 = 0, _getAllChildFrames4 = function getAllChildFrames(win) {
                                var result = [];
                                for(var _i3 = 0, _getFrames2 = getFrames(win); _i3 < _getFrames2.length; _i3++){
                                    var frame = _getFrames2[_i3];
                                    result.push(frame);
                                    for(var _i5 = 0, _getAllChildFrames2 = getAllChildFrames(frame); _i5 < _getAllChildFrames2.length; _i5++)result.push(_getAllChildFrames2[_i5]);
                                }
                                return result;
                            }(win); _i7 < _getAllChildFrames4.length; _i7++){
                                var frame = _getAllChildFrames4[_i7];
                                try {
                                    if (frame.top) return frame.top;
                                } catch (err) {}
                                if (getParent(frame) === frame) return frame;
                            }
                        }(child) === child) return !1;
                        for(var _i15 = 0, _getFrames8 = getFrames(parent); _i15 < _getFrames8.length; _i15++)if (_getFrames8[_i15] === child) return !0;
                        return !1;
                    }(window, win)) return function(win, timeout, name) {
                        void 0 === timeout && (timeout = 5e3);
                        void 0 === name && (name = "Window");
                        var promise = function(win) {
                            return windowStore("helloPromises").getOrSet(win, function() {
                                return new promise_ZalgoPromise;
                            });
                        }(win);
                        -1 !== timeout && (promise = promise.timeout(timeout, new Error(name + " did not load after " + timeout + "ms")));
                        return promise;
                    }(win, childTimeout);
                }).then(function(_temp) {
                    return function(win, targetDomain, actualDomain, _ref) {
                        var send = _ref.send;
                        return promise_ZalgoPromise.try(function() {
                            return "string" == typeof targetDomain ? targetDomain : promise_ZalgoPromise.try(function() {
                                return actualDomain || sayHello(win, {
                                    send: send
                                }).then(function(_ref2) {
                                    return _ref2.domain;
                                });
                            }).then(function(normalizedDomain) {
                                if (!matchDomain(targetDomain, targetDomain)) throw new Error("Domain " + stringify(targetDomain) + " does not match " + stringify(targetDomain));
                                return normalizedDomain;
                            });
                        });
                    }(win, domainMatcher, (void 0 === _temp ? {} : _temp).domain, {
                        send: send
                    });
                }).then(function(targetDomain) {
                    var domain = targetDomain;
                    var logName = "postrobot_method" === name && data && "string" == typeof data.name ? data.name + "()" : name;
                    var promise = new promise_ZalgoPromise;
                    var hash = name + "_" + uniqueID();
                    if (!fireAndForget) {
                        var responseListener = {
                            name: name,
                            win: win,
                            domain: domain,
                            promise: promise
                        };
                        !function(hash, listener) {
                            globalStore("responseListeners").set(hash, listener);
                        }(hash, responseListener);
                        var reqPromises = windowStore("requestPromises").getOrSet(win, function() {
                            return [];
                        });
                        reqPromises.push(promise);
                        promise.catch(function() {
                            !function(hash) {
                                globalStore("erroredResponseListeners").set(hash, !0);
                            }(hash);
                            deleteResponseListener(hash);
                        });
                        var totalAckTimeout = function(win) {
                            return windowStore("knownWindows").get(win, !1);
                        }(win) ? 1e4 : 2e3;
                        var totalResTimeout = responseTimeout;
                        var ackTimeout = totalAckTimeout;
                        var resTimeout = totalResTimeout;
                        var interval = function(method, time) {
                            var timeout;
                            !function loop() {
                                timeout = setTimeout(function() {
                                    !function() {
                                        if (isWindowClosed(win)) return promise.reject(new Error("Window closed for " + name + " before " + (responseListener.ack ? "response" : "ack")));
                                        if (responseListener.cancelled) return promise.reject(new Error("Response listener was cancelled for " + name));
                                        ackTimeout = Math.max(ackTimeout - 500, 0);
                                        -1 !== resTimeout && (resTimeout = Math.max(resTimeout - 500, 0));
                                        responseListener.ack || 0 !== ackTimeout ? 0 === resTimeout && promise.reject(new Error("No response for postMessage " + logName + " in " + getDomain() + " in " + totalResTimeout + "ms")) : promise.reject(new Error("No ack for postMessage " + logName + " in " + getDomain() + " in " + totalAckTimeout + "ms"));
                                    }();
                                    loop();
                                }, 500);
                            }();
                            return {
                                cancel: function() {
                                    clearTimeout(timeout);
                                }
                            };
                        }();
                        promise.finally(function() {
                            interval.cancel();
                            reqPromises.splice(reqPromises.indexOf(promise, 1));
                        }).catch(src_util_noop);
                    }
                    return send_sendMessage(win, domain, {
                        id: uniqueID(),
                        origin: getDomain(window),
                        type: "postrobot_message_request",
                        hash: hash,
                        name: name,
                        data: data,
                        fireAndForget: fireAndForget
                    }, {
                        on: on_on,
                        send: send
                    }).then(function() {
                        return fireAndForget ? promise.resolve() : promise;
                    }, function(err) {
                        throw new Error("Send request message failed for " + logName + " in " + getDomain() + "\n\n" + stringifyError(err));
                    });
                });
            };
            function setup_serializeMessage(destination, domain, obj) {
                return serializeMessage(destination, domain, obj, {
                    on: on_on,
                    send: send_send
                });
            }
            function setup_deserializeMessage(source, origin, message) {
                return deserializeMessage(source, origin, message, {
                    on: on_on,
                    send: send_send
                });
            }
            function createProxyWindow(win) {
                return new window_ProxyWindow({
                    send: send_send,
                    win: win
                });
            }
            function setup_toProxyWindow(win) {
                return window_ProxyWindow.toProxyWindow(win, {
                    send: send_send
                });
            }
            function setup() {
                if (!global_getGlobal().initialized) {
                    global_getGlobal().initialized = !0;
                    on = (_ref3 = {
                        on: on_on,
                        send: send_send
                    }).on, send = _ref3.send, (global = global_getGlobal()).receiveMessage = global.receiveMessage || function(message) {
                        return receive_receiveMessage(message, {
                            on: on,
                            send: send
                        });
                    };
                    !function(_ref5) {
                        var on = _ref5.on, send = _ref5.send;
                        globalStore().getOrSet("postMessageListener", function() {
                            return function(obj, event, handler) {
                                obj.addEventListener("message", handler);
                                return {
                                    cancel: function() {
                                        obj.removeEventListener("message", handler);
                                    }
                                };
                            }(window, 0, function(event) {
                                !function(event, _ref4) {
                                    var on = _ref4.on, send = _ref4.send;
                                    promise_ZalgoPromise.try(function() {
                                        var source = event.source || event.sourceElement;
                                        var origin = event.origin || event.originalEvent && event.originalEvent.origin;
                                        var data = event.data;
                                        "null" === origin && (origin = "file://");
                                        if (source) {
                                            if (!origin) throw new Error("Post message did not have origin domain");
                                            receive_receiveMessage({
                                                source: source,
                                                origin: origin,
                                                data: data
                                            }, {
                                                on: on,
                                                send: send
                                            });
                                        }
                                    });
                                }(event, {
                                    on: on,
                                    send: send
                                });
                            });
                        });
                    }({
                        on: on_on,
                        send: send_send
                    });
                    !function(_ref8) {
                        var on = _ref8.on, send = _ref8.send;
                        globalStore("builtinListeners").getOrSet("helloListener", function() {
                            var listener = on("postrobot_hello", {
                                domain: "*"
                            }, function(_ref3) {
                                resolveHelloPromise(_ref3.source, {
                                    domain: _ref3.origin
                                });
                                return {
                                    instanceID: getInstanceID()
                                };
                            });
                            var parent = getAncestor();
                            parent && sayHello(parent, {
                                send: send
                            }).catch(function(err) {});
                            return listener;
                        });
                    }({
                        on: on_on,
                        send: send_send
                    });
                }
                var _ref3, on, send, global;
            }
            function destroy() {
                !function() {
                    var responseListeners = globalStore("responseListeners");
                    for(var _i2 = 0, _responseListeners$ke2 = responseListeners.keys(); _i2 < _responseListeners$ke2.length; _i2++){
                        var hash = _responseListeners$ke2[_i2];
                        var listener = responseListeners.get(hash);
                        listener && (listener.cancelled = !0);
                        responseListeners.del(hash);
                    }
                }();
                (listener = globalStore().get("postMessageListener")) && listener.cancel();
                var listener;
                delete window.__post_robot_10_0_41__;
            }
            var src_types_TYPES_0 = !0;
            function cleanUpWindow(win) {
                for(var _i2 = 0, _requestPromises$get2 = windowStore("requestPromises").get(win, []); _i2 < _requestPromises$get2.length; _i2++)_requestPromises$get2[_i2].reject(new Error("Window " + (isWindowClosed(win) ? "closed" : "cleaned up") + " before response")).catch(src_util_noop);
            }
            setup();
        }
    ]);
});

});

parcelRegister("8tWYx", function(module, exports) {
"use strict";
var $62cec777db13e7d3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $62cec777db13e7d3$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BRIDGE_HANDSHAKE_TIMEOUT_MS = module.exports.THEME_CHANGE_EVENT = module.exports.THEME_ENABLE_EVENT = module.exports.READY_EVENT = module.exports.handleMissingHandlerError = module.exports.firstToResolve = void 0;
var $62cec777db13e7d3$var$invertPromise = function(p) {
    return new Promise(function(resolve, reject) {
        return p.then(reject, resolve);
    });
};
var $62cec777db13e7d3$var$firstToResolve = function(promises) {
    return $62cec777db13e7d3$var$__awaiter(void 0, void 0, void 0, function() {
        var err_1;
        return $62cec777db13e7d3$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        $62cec777db13e7d3$var$invertPromise(Promise.all(promises.map($62cec777db13e7d3$var$invertPromise)))
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 2:
                    err_1 = _a.sent();
                    throw err_1[0];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
module.exports.firstToResolve = $62cec777db13e7d3$var$firstToResolve;
var $62cec777db13e7d3$var$handleMissingHandlerError = function(error) {
    if (error === null || error === void 0 ? void 0 : error.message.startsWith('No handler found for post message:')) return Promise.resolve();
    else return Promise.reject("Error while sending bridge message: ".concat(error === null || error === void 0 ? void 0 : error.message));
};
module.exports.handleMissingHandlerError = $62cec777db13e7d3$var$handleMissingHandlerError;
module.exports.READY_EVENT = '__ready';
module.exports.THEME_ENABLE_EVENT = '__theme_enable';
module.exports.THEME_CHANGE_EVENT = '__theme_change';
module.exports.BRIDGE_HANDSHAKE_TIMEOUT_MS = 20000;

});

parcelRegister("kmWRd", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $g9Srd = parcelRequire("g9Srd");

var $h3cbw = parcelRequire("h3cbw");

const $7a88b175622d580e$var$sidePanelContentStyling = (0, $ecnYn.xcss)({
    position: 'absolute',
    width: '100%',
    backgroundColor: 'elevation.surface',
    height: '100%',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $7a88b175622d580e$export$8689d3888980b1f3 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { headerHeight: t1, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: t2, isOpen: t3 } = t0;
    const headerHeight = t1 === undefined ? 0 : t1;
    const panelTop = t2 === undefined ? 0 : t2;
    const isOpen = t3 === undefined ? true : t3;
    let t4;
    if ($[0] !== children || $[1] !== displayTopBorder || $[2] !== headerHeight || $[3] !== isFixed || $[4] !== isOpen || $[5] !== panelTop) {
        t4 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h3cbw.default), {
            enterFrom: "right",
            fade: "inout"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ...props,
                style: {
                    backgroundColor: "elevation.surface",
                    position: isFixed ? "fixed" : "absolute",
                    right: "0",
                    top: `${panelTop}px`,
                    width: "320px",
                    padding: "space.300",
                    borderLeft: "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)",
                    height: `calc(100vh - ${headerHeight}px)`,
                    borderTop: displayTopBorder ? "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)" : "none"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $7a88b175622d580e$var$sidePanelContentStyling
            }, children)));
        $[0] = children;
        $[1] = displayTopBorder;
        $[2] = headerHeight;
        $[3] = isFixed;
        $[4] = isOpen;
        $[5] = panelTop;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
            appear: true
        }, t4);
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ headerHeight: headerHeight = 0, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: panelTop = 0, isOpen: isOpen = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
        appear: true
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h3cbw.default), {
        enterFrom: "right",
        fade: "inout"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...props,
            // `props` has className, so use inline styling to avoid conflicts
            style: {
                backgroundColor: 'elevation.surface',
                position: isFixed ? 'fixed' : 'absolute',
                right: '0',
                top: `${panelTop}px`,
                width: '320px',
                padding: 'space.300',
                borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
                height: `calc(100vh - ${headerHeight}px)`,
                borderTop: displayTopBorder ? `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $7a88b175622d580e$var$sidePanelContentStyling
        }, children))));
};
module.exports["SidePanel"] = $7a88b175622d580e$export$8689d3888980b1f3;

});

parcelRegister("6otn0", function(module, exports) {
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $4a7bc43a0955ef89$var$ch2 = {};
var $4a7bc43a0955ef89$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($4a7bc43a0955ef89$var$ch2[id] || ($4a7bc43a0955ef89$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $4a7bc43a0955ef89$var$u8 = Uint8Array, $4a7bc43a0955ef89$var$u16 = Uint16Array, $4a7bc43a0955ef89$var$i32 = Int32Array;
// fixed length extra bits
var $4a7bc43a0955ef89$var$fleb = new $4a7bc43a0955ef89$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $4a7bc43a0955ef89$var$fdeb = new $4a7bc43a0955ef89$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $4a7bc43a0955ef89$var$clim = new $4a7bc43a0955ef89$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $4a7bc43a0955ef89$var$freb = function(eb, start) {
    var b = new $4a7bc43a0955ef89$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $4a7bc43a0955ef89$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $4a7bc43a0955ef89$var$_a = $4a7bc43a0955ef89$var$freb($4a7bc43a0955ef89$var$fleb, 2), $4a7bc43a0955ef89$var$fl = $4a7bc43a0955ef89$var$_a.b, $4a7bc43a0955ef89$var$revfl = $4a7bc43a0955ef89$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$4a7bc43a0955ef89$var$fl[28] = 258, $4a7bc43a0955ef89$var$revfl[258] = 28;
var $4a7bc43a0955ef89$var$_b = $4a7bc43a0955ef89$var$freb($4a7bc43a0955ef89$var$fdeb, 0), $4a7bc43a0955ef89$var$fd = $4a7bc43a0955ef89$var$_b.b, $4a7bc43a0955ef89$var$revfd = $4a7bc43a0955ef89$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $4a7bc43a0955ef89$var$rev = new $4a7bc43a0955ef89$var$u16(32768);
for(var $4a7bc43a0955ef89$var$i = 0; $4a7bc43a0955ef89$var$i < 32768; ++$4a7bc43a0955ef89$var$i){
    // reverse table algorithm from SO
    var $4a7bc43a0955ef89$var$x = ($4a7bc43a0955ef89$var$i & 0xAAAA) >> 1 | ($4a7bc43a0955ef89$var$i & 0x5555) << 1;
    $4a7bc43a0955ef89$var$x = ($4a7bc43a0955ef89$var$x & 0xCCCC) >> 2 | ($4a7bc43a0955ef89$var$x & 0x3333) << 2;
    $4a7bc43a0955ef89$var$x = ($4a7bc43a0955ef89$var$x & 0xF0F0) >> 4 | ($4a7bc43a0955ef89$var$x & 0x0F0F) << 4;
    $4a7bc43a0955ef89$var$rev[$4a7bc43a0955ef89$var$i] = (($4a7bc43a0955ef89$var$x & 0xFF00) >> 8 | ($4a7bc43a0955ef89$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $4a7bc43a0955ef89$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $4a7bc43a0955ef89$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $4a7bc43a0955ef89$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $4a7bc43a0955ef89$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$4a7bc43a0955ef89$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $4a7bc43a0955ef89$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $4a7bc43a0955ef89$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $4a7bc43a0955ef89$var$flt = new $4a7bc43a0955ef89$var$u8(288);
for(var $4a7bc43a0955ef89$var$i = 0; $4a7bc43a0955ef89$var$i < 144; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 8;
for(var $4a7bc43a0955ef89$var$i = 144; $4a7bc43a0955ef89$var$i < 256; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 9;
for(var $4a7bc43a0955ef89$var$i = 256; $4a7bc43a0955ef89$var$i < 280; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 7;
for(var $4a7bc43a0955ef89$var$i = 280; $4a7bc43a0955ef89$var$i < 288; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 8;
// fixed distance tree
var $4a7bc43a0955ef89$var$fdt = new $4a7bc43a0955ef89$var$u8(32);
for(var $4a7bc43a0955ef89$var$i = 0; $4a7bc43a0955ef89$var$i < 32; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$fdt[$4a7bc43a0955ef89$var$i] = 5;
// fixed length map
var $4a7bc43a0955ef89$var$flm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$flt, 9, 0), $4a7bc43a0955ef89$var$flrm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$flt, 9, 1);
// fixed distance map
var $4a7bc43a0955ef89$var$fdm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$fdt, 5, 0), $4a7bc43a0955ef89$var$fdrm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$fdt, 5, 1);
// find max of array
var $4a7bc43a0955ef89$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $4a7bc43a0955ef89$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $4a7bc43a0955ef89$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $4a7bc43a0955ef89$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $4a7bc43a0955ef89$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $4a7bc43a0955ef89$var$u8(v.subarray(s, e));
};
var $4a7bc43a0955ef89$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $4a7bc43a0955ef89$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $4a7bc43a0955ef89$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $4a7bc43a0955ef89$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $4a7bc43a0955ef89$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $4a7bc43a0955ef89$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $4a7bc43a0955ef89$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $4a7bc43a0955ef89$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $4a7bc43a0955ef89$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $4a7bc43a0955ef89$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $4a7bc43a0955ef89$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $4a7bc43a0955ef89$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $4a7bc43a0955ef89$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $4a7bc43a0955ef89$var$flrm, dm = $4a7bc43a0955ef89$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $4a7bc43a0955ef89$var$bits(dat, pos, 31) + 257, hcLen = $4a7bc43a0955ef89$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $4a7bc43a0955ef89$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $4a7bc43a0955ef89$var$u8(tl);
                // code length tree
                var clt = new $4a7bc43a0955ef89$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$4a7bc43a0955ef89$var$clim[i]] = $4a7bc43a0955ef89$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $4a7bc43a0955ef89$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $4a7bc43a0955ef89$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$4a7bc43a0955ef89$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $4a7bc43a0955ef89$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $4a7bc43a0955ef89$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $4a7bc43a0955ef89$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $4a7bc43a0955ef89$var$max(lt);
                // max dist bits
                dbt = $4a7bc43a0955ef89$var$max(dt);
                lm = $4a7bc43a0955ef89$var$hMap(lt, lbt, 1);
                dm = $4a7bc43a0955ef89$var$hMap(dt, dbt, 1);
            } else $4a7bc43a0955ef89$var$err(1);
            if (pos > tbts) {
                if (noSt) $4a7bc43a0955ef89$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$4a7bc43a0955ef89$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $4a7bc43a0955ef89$var$err(0);
                break;
            }
            if (!c) $4a7bc43a0955ef89$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $4a7bc43a0955ef89$var$fleb[i];
                    add = $4a7bc43a0955ef89$var$bits(dat, pos, (1 << b) - 1) + $4a7bc43a0955ef89$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$4a7bc43a0955ef89$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $4a7bc43a0955ef89$var$err(3);
                pos += d & 15;
                var dt = $4a7bc43a0955ef89$var$fd[dsym];
                if (dsym > 3) {
                    var b = $4a7bc43a0955ef89$var$fdeb[dsym];
                    dt += $4a7bc43a0955ef89$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $4a7bc43a0955ef89$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $4a7bc43a0955ef89$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $4a7bc43a0955ef89$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $4a7bc43a0955ef89$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $4a7bc43a0955ef89$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $4a7bc43a0955ef89$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $4a7bc43a0955ef89$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $4a7bc43a0955ef89$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $4a7bc43a0955ef89$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $4a7bc43a0955ef89$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $4a7bc43a0955ef89$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $4a7bc43a0955ef89$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($4a7bc43a0955ef89$var$ln(n.l, l, d + 1), $4a7bc43a0955ef89$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $4a7bc43a0955ef89$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $4a7bc43a0955ef89$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $4a7bc43a0955ef89$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $4a7bc43a0955ef89$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $4a7bc43a0955ef89$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $4a7bc43a0955ef89$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $4a7bc43a0955ef89$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $4a7bc43a0955ef89$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $4a7bc43a0955ef89$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $4a7bc43a0955ef89$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $4a7bc43a0955ef89$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $4a7bc43a0955ef89$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $4a7bc43a0955ef89$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$4a7bc43a0955ef89$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $4a7bc43a0955ef89$var$clen(lf, $4a7bc43a0955ef89$var$flt) + $4a7bc43a0955ef89$var$clen(df, $4a7bc43a0955ef89$var$fdt) + eb;
    var dtlen = $4a7bc43a0955ef89$var$clen(lf, dlt) + $4a7bc43a0955ef89$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $4a7bc43a0955ef89$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $4a7bc43a0955ef89$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $4a7bc43a0955ef89$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $4a7bc43a0955ef89$var$hMap(dlt, mlb, 0), ll = dlt, dm = $4a7bc43a0955ef89$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $4a7bc43a0955ef89$var$hMap(lct, mlcb, 0);
        $4a7bc43a0955ef89$var$wbits(out, p, nlc - 257);
        $4a7bc43a0955ef89$var$wbits(out, p + 5, ndc - 1);
        $4a7bc43a0955ef89$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$4a7bc43a0955ef89$var$wbits(out, p + 3 * i, lct[$4a7bc43a0955ef89$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $4a7bc43a0955ef89$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $4a7bc43a0955ef89$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $4a7bc43a0955ef89$var$flm, ll = $4a7bc43a0955ef89$var$flt, dm = $4a7bc43a0955ef89$var$fdm, dl = $4a7bc43a0955ef89$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $4a7bc43a0955ef89$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $4a7bc43a0955ef89$var$wbits(out, p, sym >> 23 & 31), p += $4a7bc43a0955ef89$var$fleb[len];
            var dst = sym & 31;
            $4a7bc43a0955ef89$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $4a7bc43a0955ef89$var$wbits16(out, p, sym >> 5 & 8191), p += $4a7bc43a0955ef89$var$fdeb[dst];
        } else $4a7bc43a0955ef89$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $4a7bc43a0955ef89$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $4a7bc43a0955ef89$var$deo = /*#__PURE__*/ new $4a7bc43a0955ef89$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $4a7bc43a0955ef89$var$et = /*#__PURE__*/ new $4a7bc43a0955ef89$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $4a7bc43a0955ef89$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $4a7bc43a0955ef89$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $4a7bc43a0955ef89$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $4a7bc43a0955ef89$var$u16(32768), head = st.h || new $4a7bc43a0955ef89$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $4a7bc43a0955ef89$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $4a7bc43a0955ef89$var$u16(288), df = new $4a7bc43a0955ef89$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $4a7bc43a0955ef89$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $4a7bc43a0955ef89$var$revfl[l] << 18 | $4a7bc43a0955ef89$var$revfd[d];
                    var lin = $4a7bc43a0955ef89$var$revfl[l] & 31, din = $4a7bc43a0955ef89$var$revfd[d] & 31;
                    eb += $4a7bc43a0955ef89$var$fleb[lin] + $4a7bc43a0955ef89$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $4a7bc43a0955ef89$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $4a7bc43a0955ef89$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $4a7bc43a0955ef89$var$slc(o, 0, pre + $4a7bc43a0955ef89$var$shft(pos) + post);
};
// CRC32 table
var $4a7bc43a0955ef89$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $4a7bc43a0955ef89$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $4a7bc43a0955ef89$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $4a7bc43a0955ef89$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $4a7bc43a0955ef89$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $4a7bc43a0955ef89$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $4a7bc43a0955ef89$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $4a7bc43a0955ef89$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $4a7bc43a0955ef89$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $4a7bc43a0955ef89$var$ch = [];
// clone bufs
var $4a7bc43a0955ef89$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $4a7bc43a0955ef89$var$wrkr = function(fns, init, id, cb) {
    if (!$4a7bc43a0955ef89$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $4a7bc43a0955ef89$var$wcln(fns[i], fnStr, td_1);
        $4a7bc43a0955ef89$var$ch[id] = {
            c: $4a7bc43a0955ef89$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $4a7bc43a0955ef89$var$mrg({}, $4a7bc43a0955ef89$var$ch[id].e);
    return $4a7bc43a0955ef89$var$wk($4a7bc43a0955ef89$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $4a7bc43a0955ef89$var$cbfs(td), cb);
};
// base async inflate fn
var $4a7bc43a0955ef89$var$bInflt = function() {
    return [
        $4a7bc43a0955ef89$var$u8,
        $4a7bc43a0955ef89$var$u16,
        $4a7bc43a0955ef89$var$i32,
        $4a7bc43a0955ef89$var$fleb,
        $4a7bc43a0955ef89$var$fdeb,
        $4a7bc43a0955ef89$var$clim,
        $4a7bc43a0955ef89$var$fl,
        $4a7bc43a0955ef89$var$fd,
        $4a7bc43a0955ef89$var$flrm,
        $4a7bc43a0955ef89$var$fdrm,
        $4a7bc43a0955ef89$var$rev,
        $4a7bc43a0955ef89$var$ec,
        $4a7bc43a0955ef89$var$hMap,
        $4a7bc43a0955ef89$var$max,
        $4a7bc43a0955ef89$var$bits,
        $4a7bc43a0955ef89$var$bits16,
        $4a7bc43a0955ef89$var$shft,
        $4a7bc43a0955ef89$var$slc,
        $4a7bc43a0955ef89$var$err,
        $4a7bc43a0955ef89$var$inflt,
        $4a7bc43a0955ef89$export$90366d8b308ba94a,
        $4a7bc43a0955ef89$var$pbf,
        $4a7bc43a0955ef89$var$gopt
    ];
};
var $4a7bc43a0955ef89$var$bDflt = function() {
    return [
        $4a7bc43a0955ef89$var$u8,
        $4a7bc43a0955ef89$var$u16,
        $4a7bc43a0955ef89$var$i32,
        $4a7bc43a0955ef89$var$fleb,
        $4a7bc43a0955ef89$var$fdeb,
        $4a7bc43a0955ef89$var$clim,
        $4a7bc43a0955ef89$var$revfl,
        $4a7bc43a0955ef89$var$revfd,
        $4a7bc43a0955ef89$var$flm,
        $4a7bc43a0955ef89$var$flt,
        $4a7bc43a0955ef89$var$fdm,
        $4a7bc43a0955ef89$var$fdt,
        $4a7bc43a0955ef89$var$rev,
        $4a7bc43a0955ef89$var$deo,
        $4a7bc43a0955ef89$var$et,
        $4a7bc43a0955ef89$var$hMap,
        $4a7bc43a0955ef89$var$wbits,
        $4a7bc43a0955ef89$var$wbits16,
        $4a7bc43a0955ef89$var$hTree,
        $4a7bc43a0955ef89$var$ln,
        $4a7bc43a0955ef89$var$lc,
        $4a7bc43a0955ef89$var$clen,
        $4a7bc43a0955ef89$var$wfblk,
        $4a7bc43a0955ef89$var$wblk,
        $4a7bc43a0955ef89$var$shft,
        $4a7bc43a0955ef89$var$slc,
        $4a7bc43a0955ef89$var$dflt,
        $4a7bc43a0955ef89$var$dopt,
        $4a7bc43a0955ef89$export$21533ff51b8a0b4a,
        $4a7bc43a0955ef89$var$pbf
    ];
};
// gzip extra
var $4a7bc43a0955ef89$var$gze = function() {
    return [
        $4a7bc43a0955ef89$var$gzh,
        $4a7bc43a0955ef89$var$gzhl,
        $4a7bc43a0955ef89$var$wbytes,
        $4a7bc43a0955ef89$var$crc,
        $4a7bc43a0955ef89$var$crct
    ];
};
// gunzip extra
var $4a7bc43a0955ef89$var$guze = function() {
    return [
        $4a7bc43a0955ef89$var$gzs,
        $4a7bc43a0955ef89$var$gzl
    ];
};
// zlib extra
var $4a7bc43a0955ef89$var$zle = function() {
    return [
        $4a7bc43a0955ef89$var$zlh,
        $4a7bc43a0955ef89$var$wbytes,
        $4a7bc43a0955ef89$var$adler
    ];
};
// unzlib extra
var $4a7bc43a0955ef89$var$zule = function() {
    return [
        $4a7bc43a0955ef89$var$zls
    ];
};
// post buf
var $4a7bc43a0955ef89$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $4a7bc43a0955ef89$var$gopt = function(o) {
    return o && {
        out: o.size && new $4a7bc43a0955ef89$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $4a7bc43a0955ef89$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $4a7bc43a0955ef89$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $4a7bc43a0955ef89$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var $4a7bc43a0955ef89$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $4a7bc43a0955ef89$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $4a7bc43a0955ef89$var$err(5);
        if (t) strm.ondata($4a7bc43a0955ef89$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var $4a7bc43a0955ef89$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $4a7bc43a0955ef89$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $4a7bc43a0955ef89$var$b8 = function(d, b) {
    return $4a7bc43a0955ef89$var$b4(d, b) + $4a7bc43a0955ef89$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $4a7bc43a0955ef89$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $4a7bc43a0955ef89$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $4a7bc43a0955ef89$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $4a7bc43a0955ef89$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $4a7bc43a0955ef89$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $4a7bc43a0955ef89$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $4a7bc43a0955ef89$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $4a7bc43a0955ef89$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $4a7bc43a0955ef89$var$adler();
        h.p(o.dictionary);
        $4a7bc43a0955ef89$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $4a7bc43a0955ef89$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $4a7bc43a0955ef89$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $4a7bc43a0955ef89$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $4a7bc43a0955ef89$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $4a7bc43a0955ef89$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $4a7bc43a0955ef89$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($4a7bc43a0955ef89$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.s.l) $4a7bc43a0955ef89$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $4a7bc43a0955ef89$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.s.l) $4a7bc43a0955ef89$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $4a7bc43a0955ef89$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bDflt,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$ae157b6234afe138
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$ae157b6234afe138(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $4a7bc43a0955ef89$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bDflt
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $4a7bc43a0955ef89$export$21533ff51b8a0b4a(data, opts) {
    return $4a7bc43a0955ef89$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $4a7bc43a0955ef89$var$u8(32768);
        this.p = new $4a7bc43a0955ef89$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.d) $4a7bc43a0955ef89$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $4a7bc43a0955ef89$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $4a7bc43a0955ef89$var$inflt(this.p, this.s, this.o);
        this.ondata($4a7bc43a0955ef89$var$slc(dt, bts, this.s.b), this.d);
        this.o = $4a7bc43a0955ef89$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $4a7bc43a0955ef89$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bInflt,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$d1de70a877d6e43c
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$d1de70a877d6e43c(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $4a7bc43a0955ef89$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bInflt
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$90366d8b308ba94a(ev.data[0], $4a7bc43a0955ef89$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $4a7bc43a0955ef89$export$90366d8b308ba94a(data, opts) {
    return $4a7bc43a0955ef89$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $4a7bc43a0955ef89$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $4a7bc43a0955ef89$var$crc();
        this.l = 0;
        this.v = 1;
        $4a7bc43a0955ef89$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $4a7bc43a0955ef89$var$dopt(c, this.o, this.v && $4a7bc43a0955ef89$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $4a7bc43a0955ef89$var$gzh(raw, this.o), this.v = 0;
        if (f) $4a7bc43a0955ef89$var$wbytes(raw, raw.length - 8, this.c.d()), $4a7bc43a0955ef89$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $4a7bc43a0955ef89$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bDflt,
            $4a7bc43a0955ef89$var$gze,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$ae157b6234afe138,
                    $4a7bc43a0955ef89$export$8e4b66d280bf8342
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$8e4b66d280bf8342(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $4a7bc43a0955ef89$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bDflt,
        $4a7bc43a0955ef89$var$gze,
        function() {
            return [
                $4a7bc43a0955ef89$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $4a7bc43a0955ef89$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $4a7bc43a0955ef89$var$crc(), l = data.length;
    c.p(data);
    var d = $4a7bc43a0955ef89$var$dopt(data, opts, $4a7bc43a0955ef89$var$gzhl(opts), 8), s = d.length;
    return $4a7bc43a0955ef89$var$gzh(d, opts), $4a7bc43a0955ef89$var$wbytes(d, s - 8, c.d()), $4a7bc43a0955ef89$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $4a7bc43a0955ef89$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $4a7bc43a0955ef89$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = $4a7bc43a0955ef89$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $4a7bc43a0955ef89$var$u8(0);
            this.push(new $4a7bc43a0955ef89$var$u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $4a7bc43a0955ef89$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bInflt,
            $4a7bc43a0955ef89$var$guze,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$d1de70a877d6e43c,
                    $4a7bc43a0955ef89$export$4cb607de6db70415
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $4a7bc43a0955ef89$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bInflt,
        $4a7bc43a0955ef89$var$guze,
        function() {
            return [
                $4a7bc43a0955ef89$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $4a7bc43a0955ef89$export$c80456f7aaba691c(data, opts) {
    var st = $4a7bc43a0955ef89$var$gzs(data);
    if (st + 8 > data.length) $4a7bc43a0955ef89$var$err(6, 'invalid gzip data');
    return $4a7bc43a0955ef89$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $4a7bc43a0955ef89$var$u8($4a7bc43a0955ef89$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $4a7bc43a0955ef89$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $4a7bc43a0955ef89$var$adler();
        this.v = 1;
        $4a7bc43a0955ef89$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $4a7bc43a0955ef89$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $4a7bc43a0955ef89$var$zlh(raw, this.o), this.v = 0;
        if (f) $4a7bc43a0955ef89$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $4a7bc43a0955ef89$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bDflt,
            $4a7bc43a0955ef89$var$zle,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$ae157b6234afe138,
                    $4a7bc43a0955ef89$export$4187ccf2467013b9
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$4187ccf2467013b9(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $4a7bc43a0955ef89$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bDflt,
        $4a7bc43a0955ef89$var$zle,
        function() {
            return [
                $4a7bc43a0955ef89$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $4a7bc43a0955ef89$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $4a7bc43a0955ef89$var$adler();
    a.p(data);
    var d = $4a7bc43a0955ef89$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $4a7bc43a0955ef89$var$zlh(d, opts), $4a7bc43a0955ef89$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $4a7bc43a0955ef89$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($4a7bc43a0955ef89$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $4a7bc43a0955ef89$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $4a7bc43a0955ef89$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bInflt,
            $4a7bc43a0955ef89$var$zule,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$d1de70a877d6e43c,
                    $4a7bc43a0955ef89$export$af2424f875ff1b17
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$af2424f875ff1b17(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $4a7bc43a0955ef89$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bInflt,
        $4a7bc43a0955ef89$var$zule,
        function() {
            return [
                $4a7bc43a0955ef89$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$9ec8134f0f1b9fc6(ev.data[0], $4a7bc43a0955ef89$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $4a7bc43a0955ef89$export$9ec8134f0f1b9fc6(data, opts) {
    return $4a7bc43a0955ef89$var$inflt(data.subarray($4a7bc43a0955ef89$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $4a7bc43a0955ef89$export$4cb607de6db70415;
        this.I = $4a7bc43a0955ef89$export$d1de70a877d6e43c;
        this.Z = $4a7bc43a0955ef89$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $4a7bc43a0955ef89$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $4a7bc43a0955ef89$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $4a7bc43a0955ef89$export$d5adcdd968132151;
        this.I = $4a7bc43a0955ef89$export$fff8358d6dbaa9cc;
        this.Z = $4a7bc43a0955ef89$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $4a7bc43a0955ef89$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $4a7bc43a0955ef89$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $4a7bc43a0955ef89$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $4a7bc43a0955ef89$export$cae1ce83fe4a1782(data, opts, cb) : $4a7bc43a0955ef89$export$ca7cbb494e731274(data, opts, cb);
}
function $4a7bc43a0955ef89$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $4a7bc43a0955ef89$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $4a7bc43a0955ef89$export$90366d8b308ba94a(data, opts) : $4a7bc43a0955ef89$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $4a7bc43a0955ef89$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $4a7bc43a0955ef89$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $4a7bc43a0955ef89$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $4a7bc43a0955ef89$var$u8(0),
                op
            ];
            $4a7bc43a0955ef89$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $4a7bc43a0955ef89$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $4a7bc43a0955ef89$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $4a7bc43a0955ef89$var$tds = 0;
try {
    $4a7bc43a0955ef89$var$td.decode($4a7bc43a0955ef89$var$et, {
        stream: true
    });
    $4a7bc43a0955ef89$var$tds = 1;
} catch (e) {}
// decode UTF8
var $4a7bc43a0955ef89$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $4a7bc43a0955ef89$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $4a7bc43a0955ef89$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($4a7bc43a0955ef89$var$tds) this.t = new TextDecoder();
        else this.p = $4a7bc43a0955ef89$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $4a7bc43a0955ef89$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $4a7bc43a0955ef89$var$err(4);
        var dat = new $4a7bc43a0955ef89$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $4a7bc43a0955ef89$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $4a7bc43a0955ef89$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $4a7bc43a0955ef89$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.d) $4a7bc43a0955ef89$var$err(4);
        this.ondata($4a7bc43a0955ef89$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $4a7bc43a0955ef89$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $4a7bc43a0955ef89$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($4a7bc43a0955ef89$var$te) return $4a7bc43a0955ef89$var$te.encode(str);
    var l = str.length;
    var ar = new $4a7bc43a0955ef89$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $4a7bc43a0955ef89$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $4a7bc43a0955ef89$var$slc(ar, 0, ai);
}
function $4a7bc43a0955ef89$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($4a7bc43a0955ef89$var$td) return $4a7bc43a0955ef89$var$td.decode(dat);
    else {
        var _a = $4a7bc43a0955ef89$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $4a7bc43a0955ef89$var$err(8);
        return s;
    }
}
// deflate bit flag
var $4a7bc43a0955ef89$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $4a7bc43a0955ef89$var$slzh = function(d, b) {
    return b + 30 + $4a7bc43a0955ef89$var$b2(d, b + 26) + $4a7bc43a0955ef89$var$b2(d, b + 28);
};
// read zip header
var $4a7bc43a0955ef89$var$zh = function(d, b, z) {
    var fnl = $4a7bc43a0955ef89$var$b2(d, b + 28), fn = $4a7bc43a0955ef89$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($4a7bc43a0955ef89$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $4a7bc43a0955ef89$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $4a7bc43a0955ef89$var$z64e(d, es) : [
        bs,
        $4a7bc43a0955ef89$var$b4(d, b + 24),
        $4a7bc43a0955ef89$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $4a7bc43a0955ef89$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $4a7bc43a0955ef89$var$b2(d, b + 30) + $4a7bc43a0955ef89$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $4a7bc43a0955ef89$var$z64e = function(d, b) {
    for(; $4a7bc43a0955ef89$var$b2(d, b) != 1; b += 4 + $4a7bc43a0955ef89$var$b2(d, b + 2));
    return [
        $4a7bc43a0955ef89$var$b8(d, b + 12),
        $4a7bc43a0955ef89$var$b8(d, b + 4),
        $4a7bc43a0955ef89$var$b8(d, b + 20)
    ];
};
// extra field length
var $4a7bc43a0955ef89$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $4a7bc43a0955ef89$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $4a7bc43a0955ef89$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $4a7bc43a0955ef89$var$exfl(ex);
    $4a7bc43a0955ef89$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $4a7bc43a0955ef89$var$err(10);
    $4a7bc43a0955ef89$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $4a7bc43a0955ef89$var$wbytes(d, b, f.crc);
        $4a7bc43a0955ef89$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $4a7bc43a0955ef89$var$wbytes(d, b + 8, f.size);
    }
    $4a7bc43a0955ef89$var$wbytes(d, b + 12, fl);
    $4a7bc43a0955ef89$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $4a7bc43a0955ef89$var$wbytes(d, b, col);
        $4a7bc43a0955ef89$var$wbytes(d, b + 6, f.attrs);
        $4a7bc43a0955ef89$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $4a7bc43a0955ef89$var$wbytes(d, b, +k);
        $4a7bc43a0955ef89$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $4a7bc43a0955ef89$var$wzf = function(o, b, c, d, e) {
    $4a7bc43a0955ef89$var$wbytes(o, b, 0x6054B50); // skip disk
    $4a7bc43a0955ef89$var$wbytes(o, b + 8, c);
    $4a7bc43a0955ef89$var$wbytes(o, b + 10, c);
    $4a7bc43a0955ef89$var$wbytes(o, b + 12, d);
    $4a7bc43a0955ef89$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $4a7bc43a0955ef89$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $4a7bc43a0955ef89$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $4a7bc43a0955ef89$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $4a7bc43a0955ef89$export$2b25194e1767ea06.call(this, filename);
        this.d = new $4a7bc43a0955ef89$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $4a7bc43a0955ef89$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $4a7bc43a0955ef89$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $4a7bc43a0955ef89$export$2b25194e1767ea06.call(this, filename);
        this.d = new $4a7bc43a0955ef89$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $4a7bc43a0955ef89$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $4a7bc43a0955ef89$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($4a7bc43a0955ef89$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $4a7bc43a0955ef89$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $4a7bc43a0955ef89$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $4a7bc43a0955ef89$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($4a7bc43a0955ef89$var$err(11, 0, 1), null, false);
            var header = new $4a7bc43a0955ef89$var$u8(hl_1);
            $4a7bc43a0955ef89$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $4a7bc43a0955ef89$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $4a7bc43a0955ef89$var$u8(16);
                        $4a7bc43a0955ef89$var$wbytes(dd, 0, 0x8074B50);
                        $4a7bc43a0955ef89$var$wbytes(dd, 4, file.crc);
                        $4a7bc43a0955ef89$var$wbytes(dd, 8, cl_1);
                        $4a7bc43a0955ef89$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($4a7bc43a0955ef89$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $4a7bc43a0955ef89$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $4a7bc43a0955ef89$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $4a7bc43a0955ef89$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $4a7bc43a0955ef89$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    var r = {};
    $4a7bc43a0955ef89$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $4a7bc43a0955ef89$var$mt(function() {
            cb(a, b);
        });
    };
    $4a7bc43a0955ef89$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $4a7bc43a0955ef89$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $4a7bc43a0955ef89$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $4a7bc43a0955ef89$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $4a7bc43a0955ef89$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $4a7bc43a0955ef89$var$crc(), size = file.length;
        c.p(file);
        var f = $4a7bc43a0955ef89$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $4a7bc43a0955ef89$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $4a7bc43a0955ef89$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $4a7bc43a0955ef89$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($4a7bc43a0955ef89$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $4a7bc43a0955ef89$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($4a7bc43a0955ef89$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $4a7bc43a0955ef89$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $4a7bc43a0955ef89$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $4a7bc43a0955ef89$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $4a7bc43a0955ef89$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $4a7bc43a0955ef89$var$exfl(p.extra);
        if (s > 65535) $4a7bc43a0955ef89$var$err(11);
        var d = compression ? $4a7bc43a0955ef89$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $4a7bc43a0955ef89$var$crc();
        c.p(file);
        files.push($4a7bc43a0955ef89$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $4a7bc43a0955ef89$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $4a7bc43a0955ef89$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $4a7bc43a0955ef89$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $4a7bc43a0955ef89$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $4a7bc43a0955ef89$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $4a7bc43a0955ef89$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $4a7bc43a0955ef89$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $4a7bc43a0955ef89$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $4a7bc43a0955ef89$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $4a7bc43a0955ef89$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $4a7bc43a0955ef89$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $4a7bc43a0955ef89$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $4a7bc43a0955ef89$export$93f81d5bbbb7c6bf
        };
        this.p = $4a7bc43a0955ef89$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $4a7bc43a0955ef89$var$err(5);
        if (!this.p) $4a7bc43a0955ef89$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $4a7bc43a0955ef89$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $4a7bc43a0955ef89$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $4a7bc43a0955ef89$var$b2(buf, i + 6), cmp_1 = $4a7bc43a0955ef89$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $4a7bc43a0955ef89$var$b2(buf, i + 26), es = $4a7bc43a0955ef89$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $4a7bc43a0955ef89$var$b4(buf, i + 18), su_1 = $4a7bc43a0955ef89$var$b4(buf, i + 22);
                        var fn_1 = $4a7bc43a0955ef89$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $4a7bc43a0955ef89$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $4a7bc43a0955ef89$var$err(5);
                                if (!sc_1) file_1.ondata(null, $4a7bc43a0955ef89$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($4a7bc43a0955ef89$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($4a7bc43a0955ef89$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $4a7bc43a0955ef89$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($4a7bc43a0955ef89$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $4a7bc43a0955ef89$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $4a7bc43a0955ef89$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $4a7bc43a0955ef89$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $4a7bc43a0955ef89$var$mt(function() {
            cb(a, b);
        });
    };
    $4a7bc43a0955ef89$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $4a7bc43a0955ef89$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($4a7bc43a0955ef89$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $4a7bc43a0955ef89$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $4a7bc43a0955ef89$var$b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = $4a7bc43a0955ef89$var$b4(data, e - 12);
            z = $4a7bc43a0955ef89$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $4a7bc43a0955ef89$var$b4(data, ze + 32);
                o = $4a7bc43a0955ef89$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $4a7bc43a0955ef89$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $4a7bc43a0955ef89$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $4a7bc43a0955ef89$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $4a7bc43a0955ef89$export$90366d8b308ba94a(infl, {
                            out: new $4a7bc43a0955ef89$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($4a7bc43a0955ef89$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($4a7bc43a0955ef89$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $4a7bc43a0955ef89$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $4a7bc43a0955ef89$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $4a7bc43a0955ef89$var$err(13);
    var c = $4a7bc43a0955ef89$var$b2(data, e + 8);
    if (!c) return {};
    var o = $4a7bc43a0955ef89$var$b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = $4a7bc43a0955ef89$var$b4(data, e - 12);
        z = $4a7bc43a0955ef89$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $4a7bc43a0955ef89$var$b4(data, ze + 32);
            o = $4a7bc43a0955ef89$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $4a7bc43a0955ef89$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $4a7bc43a0955ef89$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $4a7bc43a0955ef89$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $4a7bc43a0955ef89$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $4a7bc43a0955ef89$var$u8(su)
            });
            else $4a7bc43a0955ef89$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}
module.exports["gzipSync"] = $4a7bc43a0955ef89$export$3d616c3fb3e15483;
module.exports["gunzipSync"] = $4a7bc43a0955ef89$export$c80456f7aaba691c;

});

parcelRegister("cwXs1", function(module, exports) {

var $6V5uh = parcelRequire("6V5uh");


var $7sea9 = parcelRequire("7sea9");


var $dmgN7 = parcelRequire("dmgN7");

function $91f696e693fdbefb$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert('', serialized, cache.sheet, true);
}
function $91f696e693fdbefb$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $dmgN7.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $91f696e693fdbefb$var$createEmotion = function createEmotion(options) {
    var cache = (0, $6V5uh.default)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $7sea9.serializeStyles)(args, cache.registered, undefined);
        (0, $dmgN7.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $7sea9.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $91f696e693fdbefb$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $7sea9.serializeStyles)(args, cache.registered);
        $91f696e693fdbefb$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $91f696e693fdbefb$var$merge(cache.registered, css, $91f696e693fdbefb$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $dmgN7.getRegisteredStyles).bind(null, cache.registered),
        merge: $91f696e693fdbefb$var$merge.bind(null, cache.registered, css)
    };
};
var $91f696e693fdbefb$var$classnames = function classnames(args) {
    var cls = '';
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
var $91f696e693fdbefb$export$2e2bcd8739ae039 = $91f696e693fdbefb$var$createEmotion;
module.exports["default"] = $91f696e693fdbefb$export$2e2bcd8739ae039;

});

parcelRegister("6V5uh", function(module, exports) {

var $17TcT = parcelRequire("17TcT");


var $iJwkl = parcelRequire("iJwkl");

parcelRequire("bDkqZ");

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $509c529e1de59914$var$delimiter = '/*|*/';
var $509c529e1de59914$var$needle = $509c529e1de59914$var$delimiter + '}';
function $509c529e1de59914$var$toSheet(block) {
    if (block) $509c529e1de59914$var$Sheet.current.insert(block + '}');
}
var $509c529e1de59914$var$Sheet = {
    current: null
};
var $509c529e1de59914$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $509c529e1de59914$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $509c529e1de59914$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $509c529e1de59914$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $509c529e1de59914$var$delimiter : '');
            }
        case -2:
            content.split($509c529e1de59914$var$needle).forEach($509c529e1de59914$var$toSheet);
    }
};
var $509c529e1de59914$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $iJwkl.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($509c529e1de59914$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $509c529e1de59914$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $17TcT.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $509c529e1de59914$export$2e2bcd8739ae039 = $509c529e1de59914$var$createCache;
module.exports["default"] = $509c529e1de59914$export$2e2bcd8739ae039;

});

parcelRegister("17TcT", function(module, exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $0d2144d6479b12ec$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $0d2144d6479b12ec$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    return tag;
}
var $0d2144d6479b12ec$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $0d2144d6479b12ec$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $0d2144d6479b12ec$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();
module.exports["StyleSheet"] = $0d2144d6479b12ec$export$9d753cd7ae895cce;

});

parcelRegister("iJwkl", function(module, exports) {
function $da358174ef16096d$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $da358174ef16096d$export$2e2bcd8739ae039 = $da358174ef16096d$var$stylis_min;
module.exports["default"] = $da358174ef16096d$export$2e2bcd8739ae039;

});

parcelRegister("bDkqZ", function(module, exports) {
var $87833012dd311f8f$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $87833012dd311f8f$export$2e2bcd8739ae039 = $87833012dd311f8f$var$weakMemoize;

});

parcelRegister("7sea9", function(module, exports) {

var $f2VtL = parcelRequire("f2VtL");


var $5LEcS = parcelRequire("5LEcS");


var $1scxZ = parcelRequire("1scxZ");

var $56d622567ec5b15a$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $56d622567ec5b15a$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $56d622567ec5b15a$var$hyphenateRegex = /[A-Z]|^ms/g;
var $56d622567ec5b15a$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $56d622567ec5b15a$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $56d622567ec5b15a$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $56d622567ec5b15a$var$processStyleName = (0, $1scxZ.default)(function(styleName) {
    return $56d622567ec5b15a$var$isCustomProperty(styleName) ? styleName : styleName.replace($56d622567ec5b15a$var$hyphenateRegex, '-$&').toLowerCase();
});
var $56d622567ec5b15a$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($56d622567ec5b15a$var$animationRegex, function(match, p1, p2) {
                $56d622567ec5b15a$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $56d622567ec5b15a$var$cursor
                };
                return p1;
            });
    }
    if ((0, $5LEcS.default)[key] !== 1 && !$56d622567ec5b15a$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $56d622567ec5b15a$var$contentValuePattern, $56d622567ec5b15a$var$contentValues, $56d622567ec5b15a$var$oldProcessStyleValue, $56d622567ec5b15a$var$msPattern, $56d622567ec5b15a$var$hyphenPattern, $56d622567ec5b15a$var$hyphenatedCache;
var $56d622567ec5b15a$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $56d622567ec5b15a$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $56d622567ec5b15a$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $56d622567ec5b15a$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $56d622567ec5b15a$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $56d622567ec5b15a$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $56d622567ec5b15a$var$cursor;
                var result = interpolation(mergedProps);
                $56d622567ec5b15a$var$cursor = previousCursor;
                return $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $56d622567ec5b15a$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($56d622567ec5b15a$var$isProcessableValue(value)) string += $56d622567ec5b15a$var$processStyleName(_key) + ":" + $56d622567ec5b15a$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($56d622567ec5b15a$var$isProcessableValue(value[_i])) string += $56d622567ec5b15a$var$processStyleName(_key) + ":" + $56d622567ec5b15a$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case 'animation':
                case 'animationName':
                    string += $56d622567ec5b15a$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $56d622567ec5b15a$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $56d622567ec5b15a$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $56d622567ec5b15a$var$cursor;
var $56d622567ec5b15a$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $56d622567ec5b15a$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $56d622567ec5b15a$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $56d622567ec5b15a$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $f2VtL.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $56d622567ec5b15a$var$cursor
    };
};
module.exports["serializeStyles"] = $56d622567ec5b15a$export$6321afa313b251b5;

});

parcelRegister("f2VtL", function(module, exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $af43a1132694bb05$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $af43a1132694bb05$export$2e2bcd8739ae039 = $af43a1132694bb05$var$murmur2;
module.exports["default"] = $af43a1132694bb05$export$2e2bcd8739ae039;

});

parcelRegister("5LEcS", function(module, exports) {
var $433087baeb224055$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $433087baeb224055$export$2e2bcd8739ae039 = $433087baeb224055$var$unitlessKeys;
module.exports["default"] = $433087baeb224055$export$2e2bcd8739ae039;

});

parcelRegister("1scxZ", function(module, exports) {
function $10f223981f04db65$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $10f223981f04db65$export$2e2bcd8739ae039 = $10f223981f04db65$var$memoize;
module.exports["default"] = $10f223981f04db65$export$2e2bcd8739ae039;

});

parcelRegister("bIBXx", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dWCFT = parcelRequire("dWCFT");

var $cFEpk = parcelRequire("cFEpk");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $9KYtE = parcelRequire("9KYtE");


var $bS1VQ = parcelRequire("bS1VQ");

var $2gD2K = parcelRequire("2gD2K");

var $eKXGE = parcelRequire("eKXGE");


var $2oOe7 = parcelRequire("2oOe7");


var $jgNUL = parcelRequire("jgNUL");


var $6BP5H = parcelRequire("6BP5H");


var $7lMCw = parcelRequire("7lMCw");


var $cda8t = parcelRequire("cda8t");

const $6a13142a7a4ddecd$var$packageName = "platform-pkg";
const $6a13142a7a4ddecd$var$packageVersion = "0.0.0-use.local";
const $6a13142a7a4ddecd$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $6a13142a7a4ddecd$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $6a13142a7a4ddecd$var$packageName,
    packageVersion: $6a13142a7a4ddecd$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $6a13142a7a4ddecd$var$TimePicker = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $ee7An.default), onChange: providedOnChange = (0, $ee7An.default), onFocus: providedOnFocus = (0, $ee7An.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $6BP5H.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $2oOe7.defaultTimes), value: providedValue }, _ref)=>{
    const [containerRef, setContainerRef] = (0, $42omo.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $42omo.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $42omo.useState)(false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(defaultIsOpen);
    const [value, setValue] = (0, $42omo.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $42omo.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$6a13142a7a4ddecd$var$analyticsAttributes
    });
    (0, $42omo.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $42omo.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $42omo.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $2oOe7.defaultTimeFormat));
            } catch  {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $dWCFT.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $9KYtE.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $bS1VQ.default) : (0, $2gD2K.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $2oOe7.defaultTimeFormat));
        const date = (0, $6BP5H.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $cFEpk.default)(date)) return time;
        if (timeFormat) return (0, $dWCFT.default)(date, (0, $7lMCw.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $cda8t.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $2oOe7.EmptyComponent),
        Menu: (0, $jgNUL.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $2oOe7.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $eKXGE.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$6a13142a7a4ddecd$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`,
                onKeyDown: onSelectKeyDown
            }),
            /*#__PURE__*/ (0, $l998X.jsx)(SelectComponent, {
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                appearance: appearance,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                // @ts-ignore - Type mismatch with components - workaround for help-center local consumption
                components: selectComponents,
                inputId: id,
                isClearable: true,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: isOpen && !isDisabled,
                menuPlacement: "auto",
                openMenuOnFocus: true,
                onBlur: onBlur,
                onCreateOption: onCreateOption,
                // @ts-ignore - Type mismatch with onChange handler - workaround for help-center local consumption
                onChange: onChange,
                options: options,
                onFocus: onFocus,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose,
                placeholder: placeholder || l10n.formatTime((0, $2oOe7.placeholderDatetime)),
                // @ts-ignore - Type mismatch with styles config - workaround for help-center local consumption
                styles: mergedStyles,
                value: initialValue,
                spacing: spacing,
                // We need this to get things to work, even though it's not supported.
                // @ts-ignore
                fixedLayerRef: containerRef,
                isInvalid: isInvalid,
                testId: testId,
                ...otherSelectProps
            })
        ]
    });
});
var $6a13142a7a4ddecd$export$2e2bcd8739ae039 = $6a13142a7a4ddecd$var$TimePicker;
module.exports["default"] = $6a13142a7a4ddecd$export$2e2bcd8739ae039;

});

parcelRegister("jgNUL", function(module, exports) {
/* fixed-layer-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");


var $hq1yX = parcelRequire("hq1yX");

const $234f598d19f6cd6a$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hq1yX.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Menu // We have to have this because `getClassNames` is missing. Can't define
        , {
            ...rest,
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        }),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });
module.exports["FixedLayerMenu"] = $234f598d19f6cd6a$export$982ad994195b4356;

});

parcelRegister("6BP5H", function(module, exports) {
$parcel$export(module.exports, "default", () => $8831c39f93c6811b$export$2e2bcd8739ae039);
const $8831c39f93c6811b$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $8831c39f93c6811b$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $8831c39f93c6811b$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $8831c39f93c6811b$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $8831c39f93c6811b$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $8831c39f93c6811b$var$map24[hour];
    return hour;
}
function $8831c39f93c6811b$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $8831c39f93c6811b$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $8831c39f93c6811b$var$formatSemi24(timeArray[0].trim());
    const hour = $8831c39f93c6811b$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $8831c39f93c6811b$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $8831c39f93c6811b$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $8831c39f93c6811b$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $8831c39f93c6811b$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$8831c39f93c6811b$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $8831c39f93c6811b$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $8831c39f93c6811b$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $8831c39f93c6811b$var$assignToDate(time2);
}

});

parcelRegister("fy6ox", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $7tyMu = parcelRequire("7tyMu");

const $5d73e8e60584e113$var$Author = ({ children: children, href: href, onClick: providedOnClick, onFocus: onFocus, onMouseOver: onMouseOver })=>{
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>providedOnClick && providedOnClick(event, analyticsEvent),
        action: 'clicked',
        componentName: 'commentAuthor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7tyMu.default), {
        hasAuthor: true,
        href: href,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        children: children
    });
};
$5d73e8e60584e113$var$Author.displayName = 'CommentAuthor';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5d73e8e60584e113$export$2e2bcd8739ae039 = $5d73e8e60584e113$var$Author;
module.exports["default"] = $5d73e8e60584e113$export$2e2bcd8739ae039;

});

parcelRegister("7tyMu", function(module, exports) {
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $auNCB = parcelRequire("auNCB");

const $a24e02791d90685a$var$textStyles = {
    root: "_syazazsu"
};
const $a24e02791d90685a$var$anchorStyles = {
    root: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz"
};
const $a24e02791d90685a$var$noAuthorStyles = {
    root: "_k48p1kw7"
};
const $a24e02791d90685a$var$hasAuthorStyles = {
    root: "_k48p1wq8"
}; /**
    * __Field__
    *
    * A field appears in the comment header to add metadata to the comment.
    *
    * @internal
    */ 
const $a24e02791d90685a$var$Field = ({ children: children, hasAuthor: hasAuthor, href: href, onClick: onClick, onFocus: onFocus, onMouseOver: onMouseOver, testId: testId })=>{
    return href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: href,
        xcss: (0, $1Whri.cx)($a24e02791d90685a$var$textStyles.root, $a24e02791d90685a$var$anchorStyles.root, hasAuthor ? $a24e02791d90685a$var$hasAuthorStyles.root : $a24e02791d90685a$var$noAuthorStyles.root),
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        testId: testId,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)("span", {
        /**
                     * It is not normally acceptable to add key handlers to non-interactive elements
                     * as this is an accessibility anti-pattern. However, because this instance is
                     * to add support for analytics instead of creating an inaccessible
                     * custom element, we can add role="presentation" so that there are no negative
                     * impacts to assistive technologies.
                     */ role: "presentation",
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $a24e02791d90685a$var$textStyles.root,
            hasAuthor ? $a24e02791d90685a$var$hasAuthorStyles.root : $a24e02791d90685a$var$noAuthorStyles.root
        ]),
        children: children
    });
};
var $a24e02791d90685a$export$2e2bcd8739ae039 = $a24e02791d90685a$var$Field;
module.exports["default"] = $a24e02791d90685a$export$2e2bcd8739ae039;

});

parcelRegister("fJJGs", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $7tyMu = parcelRequire("7tyMu");

const $d3930f6319807484$var$CommentTime = ({ children: children, href: href, onClick: providedOnClick, onFocus: onFocus, onMouseOver: onMouseOver })=>{
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>providedOnClick && providedOnClick(event, analyticsEvent),
        action: 'clicked',
        componentName: 'commentTime',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7tyMu.default), {
        href: href,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        children: children
    });
};
$d3930f6319807484$var$CommentTime.displayName = 'CommentTime';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d3930f6319807484$export$2e2bcd8739ae039 = $d3930f6319807484$var$CommentTime;
module.exports["default"] = $d3930f6319807484$export$2e2bcd8739ae039;

});

parcelRegister("hlzjm", function(module, exports) {
/* comment.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");


var $bVeqx = parcelRequire("bVeqx");


var $cV7U6 = parcelRequire("cV7U6");


var $ijtAN = parcelRequire("ijtAN");

const $93d62a86395aa94f$var$textStyles = {
    root: "_syazi7uo",
    disabled: "_syaz1gmx"
};
/**
 * __Comment__
 *
 * Comments enable discussions on an entity such as a page, blog post, work item, or pull request.
 */ const $93d62a86395aa94f$var$Comment = ({ actions: actions = [], restrictedTo: restrictedTo = '', highlighted: highlighted = false, isSaving: isSaving = false, savingText: savingText = 'Sending...', isError: isError = false, errorActions: errorActions = [], errorIconLabel: errorIconLabel = '', author: author, avatar: avatar, children: children, content: content, edited: edited, time: time, type: type, testId: testId, id: id, afterContent: afterContent, shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline, headingLevel: headingLevel = '3', shouldHeaderWrap: shouldHeaderWrap })=>{
    const headerProps = {
        author: author,
        edited: edited,
        isError: isError,
        isSaving: isSaving,
        restrictedTo: restrictedTo,
        savingText: savingText,
        time: time,
        type: type,
        headingLevel: headingLevel,
        shouldHeaderWrap: shouldHeaderWrap
    };
    const footerProps = {
        actions: actions,
        errorActions: errorActions,
        errorIconLabel: errorIconLabel,
        isError: isError,
        isSaving: isSaving
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ijtAN.default), {
        testId: testId,
        shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline,
        id: id,
        avatar: avatar,
        content: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.075",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cV7U6.default), {
                            testId: testId && `${testId}-header`,
                            ...headerProps
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            testId: testId && `${testId}-content`,
                            xcss: (0, $1Whri.cx)($93d62a86395aa94f$var$textStyles.root, (isSaving || isError) && $93d62a86395aa94f$var$textStyles.disabled),
                            children: content
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $bVeqx.default), {
                    testId: testId && `${testId}-footer`,
                    ...footerProps
                }),
                afterContent
            ]
        }),
        highlighted: highlighted,
        children: children
    });
};
$93d62a86395aa94f$var$Comment.displayName = 'Comment';
var $93d62a86395aa94f$export$2e2bcd8739ae039 = $93d62a86395aa94f$var$Comment;
module.exports["default"] = $93d62a86395aa94f$export$2e2bcd8739ae039;

});

parcelRegister("bVeqx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5MACL = parcelRequire("5MACL");


var $dcJ7R = parcelRequire("dcJ7R");


var $6fnsQ = parcelRequire("6fnsQ");

/**
 * __Footer items__
 *
 * The footer items in the comment. Usually reserved for error messages.
 *
 * @internal
 */ const $d2b873e75f9e4281$var$Footer = ({ actions: actions = [], errorActions: errorActions = [], errorIconLabel: errorIconLabel, isError: isError, isSaving: isSaving, testId: testId })=>{
    if (isSaving || !(actions.length || errorActions.length)) return null;
    const items = isError ? errorActions : actions;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        shouldWrap: true,
        testId: testId,
        space: "space.100",
        separator: "\xb7",
        children: [
            isError && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5MACL))), {
                spacing: "spacious",
                color: `var(--ds-icon-warning, ${(0, $6fnsQ.Y500)})`,
                label: errorIconLabel ? errorIconLabel : ''
            }),
            items.map((item, key)=>Object.assign({}, item, {
                    key: key
                }))
        ]
    });
};
$d2b873e75f9e4281$var$Footer.displayName = 'CommentFooter';
var $d2b873e75f9e4281$export$2e2bcd8739ae039 = $d2b873e75f9e4281$var$Footer;
module.exports["default"] = $d2b873e75f9e4281$export$2e2bcd8739ae039;

});

parcelRegister("cV7U6", function(module, exports) {
/* header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9Q2dU = parcelRequire("9Q2dU");


var $5nBzc = parcelRequire("5nBzc");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");

const $09aac408a5a8747f$var$headingStyles = {
    root: "_11c82smr"
};
const $09aac408a5a8747f$var$iconWrapperStyles = {
    root: "_18zrv77o _1e0c1txw"
};
const $09aac408a5a8747f$var$headerItemStyles = {
    root: "_o5721q9c _1o9zidpf"
};
const $09aac408a5a8747f$var$authorBoxStyles = {
    root: "_1nmz9jpi _1ul9idpf _p12f1osq"
}; /**
    * __Header items__
    *
    * Comment header items.
    *
    * @internal
    */ 
const $09aac408a5a8747f$var$Header = ({ author: author, edited: edited, isError: isError, isSaving: isSaving, restrictedTo: restrictedTo, savingText: savingText, time: time, testId: testId, type: type, headingLevel: headingLevel = '3', shouldHeaderWrap: shouldHeaderWrap })=>{
    const Heading = `h${headingLevel}`;
    const shouldRender = author || time || restrictedTo || isSaving && savingText || edited || type;
    return shouldRender ? /*#__PURE__*/ (0, $l998X.jsx)(Heading, {
        className: (0, $gMc0m.default)([
            $09aac408a5a8747f$var$headingStyles.root
        ]),
        children: shouldHeaderWrap === false ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            testId: testId,
            space: "space.100",
            as: "span",
            shouldWrap: false,
            children: [
                author,
                type && /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                    testId: testId && `${testId}-type`,
                    children: type
                }),
                time && !isSaving && !isError && time,
                edited || null,
                isSaving ? savingText : null,
                restrictedTo && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        space: "space.050",
                        as: "span",
                        children: [
                            "\u2022",
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                as: "span",
                                xcss: $09aac408a5a8747f$var$iconWrapperStyles.root,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                                    color: "currentColor",
                                    label: "",
                                    size: "small"
                                })
                            }),
                            restrictedTo
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            testId: testId,
            space: "space.100",
            rowSpace: "space.0",
            as: "span",
            shouldWrap: true,
            children: [
                author && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $09aac408a5a8747f$var$authorBoxStyles.root,
                    children: author
                }),
                type && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $09aac408a5a8747f$var$headerItemStyles.root,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                        testId: testId && `${testId}-type`,
                        children: type
                    })
                }),
                time && !isSaving && !isError && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $09aac408a5a8747f$var$headerItemStyles.root,
                    children: time
                }),
                edited && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $09aac408a5a8747f$var$headerItemStyles.root,
                    children: edited
                }),
                isSaving && savingText && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $09aac408a5a8747f$var$headerItemStyles.root,
                    children: savingText
                }),
                restrictedTo && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "center",
                            space: "space.050",
                            as: "span",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    as: "span",
                                    xcss: $09aac408a5a8747f$var$iconWrapperStyles.root,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                                        color: "currentColor",
                                        label: "",
                                        size: "small"
                                    })
                                }),
                                restrictedTo
                            ]
                        })
                    })
                })
            ]
        })
    }) : null;
};
$09aac408a5a8747f$var$Header.displayName = 'CommentHeader';
var $09aac408a5a8747f$export$2e2bcd8739ae039 = $09aac408a5a8747f$var$Header;
module.exports["default"] = $09aac408a5a8747f$export$2e2bcd8739ae039;

});

parcelRegister("ijtAN", function(module, exports) {
/* layout.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $d8SNb = parcelRequire("d8SNb");

var $eyWa4 = parcelRequire("eyWa4");


var $6JC10 = parcelRequire("6JC10");


var $lmM8h = parcelRequire("lmM8h");

const $768cc646e91e2e58$var$containerStyles = {
    root: "_kqswh2mm _yv0e5bpd _1lmc1gx3"
};
const $768cc646e91e2e58$var$inlineCommentStyles = {
    root: "_1lmc1rav"
};
const $768cc646e91e2e58$var$noChildrenStyles = {
    root: "_1lmcvpz5"
};
// if the background is appied on Box and tokens are not switched on it breaks.
// This can be safely removed (and applied on Box) when tokens are on by default
const $768cc646e91e2e58$var$highlightOverlayStyles = {
    root: "_1r04x0bf _nd5l1sux _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _kqswstnw _lcxvglyw"
};
const $768cc646e91e2e58$var$stackOverrideStyles = {
    root: "_nd5l1dav _1q511ejb"
};
/**
 * __CommentLayout__
 *
 * The base layout for the comment component.
 *
 */ const $768cc646e91e2e58$var$Layout = ({ content: content, children: children, highlighted: highlighted, id: id, shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline, testId: testId, avatar: avatar })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
        gap: "space.100",
        xcss: (0, $1Whri.cx)($768cc646e91e2e58$var$containerStyles.root, shouldRenderNestedCommentsInline && $768cc646e91e2e58$var$inlineCommentStyles.root, !children && $768cc646e91e2e58$var$noChildrenStyles.root),
        testId: testId,
        id: id,
        children: [
            avatar && /*#__PURE__*/ (0, $l998X.jsx)((0, $6JC10.default), {
                children: avatar
            }),
            content && /*#__PURE__*/ (0, $l998X.jsx)((0, $lmM8h.default), {
                children: content
            }),
            children && /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                xcss: $768cc646e91e2e58$var$stackOverrideStyles.root,
                space: "space.400",
                children: children
            }),
            highlighted && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $768cc646e91e2e58$var$highlightOverlayStyles.root,
                backgroundColor: "color.background.neutral",
                testId: testId && `${testId}-highlighted`
            })
        ]
    });
$768cc646e91e2e58$var$Layout.displayName = 'CommentLayout';
var $768cc646e91e2e58$export$2e2bcd8739ae039 = $768cc646e91e2e58$var$Layout;
module.exports["default"] = $768cc646e91e2e58$export$2e2bcd8739ae039;

});

parcelRegister("6JC10", function(module, exports) {
/* avatar-slot.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $d6ff3474eb3a1c0a$var$avatarSectionStyles = {
    root: "_nd5l1ofd"
};
/**
 * __Avatar slot is used to nest an avatar in a comment__
 *
 * The avatar slot is used to nest an avatar in a comment's layout.
 *
 */ const $d6ff3474eb3a1c0a$var$AvatarSlot = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $d6ff3474eb3a1c0a$var$avatarSectionStyles.root,
        children: children
    });
var $d6ff3474eb3a1c0a$export$2e2bcd8739ae039 = $d6ff3474eb3a1c0a$var$AvatarSlot;
module.exports["default"] = $d6ff3474eb3a1c0a$export$2e2bcd8739ae039;

});

parcelRegister("lmM8h", function(module, exports) {
/* content-slot.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $df8b60abd3030907$var$contentSlotStyles = {
    root: "_nd5l8niw _1ul9idpf _1q51v77o _slp31hna"
};
const $df8b60abd3030907$var$ContentSlot = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $df8b60abd3030907$var$contentSlotStyles.root
        ]),
        children: children
    });
var $df8b60abd3030907$export$2e2bcd8739ae039 = $df8b60abd3030907$var$ContentSlot;
module.exports["default"] = $df8b60abd3030907$export$2e2bcd8739ae039;

});

parcelRegister("jq9iL", function(module, exports) {
$parcel$export(module.exports, "getFiles", () => (parcelRequire("3E6Lz")).getFiles);
$parcel$export(module.exports, "containsFiles", () => (parcelRequire("3E6Lz")).containsFiles);

var $3E6Lz = parcelRequire("3E6Lz");


});

parcelRegister("3E6Lz", function(module, exports) {
function $709b2838a61f0f18$export$ed3e218cf6ca2bc6({ source: source }) {
    return source.types.includes('Files');
}
function $709b2838a61f0f18$export$d964e69f1fd5fd4c({ source: source }) {
    return source.items// unlike other media types, for files:
    // item.kind is 'file'
    // item.type is the type of file eg 'image/jpg'
    // for other media types, item.type is the mime format
    .filter((item)=>item.kind === 'file').map((item)=>item.getAsFile()).filter((file)=>file != null);
}
module.exports["containsFiles"] = $709b2838a61f0f18$export$ed3e218cf6ca2bc6;
module.exports["getFiles"] = $709b2838a61f0f18$export$d964e69f1fd5fd4c;

});

parcelRegister("aF5bm", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");

const $3217b30f8fcccab4$export$c922e8420e7a46c9 = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $3217b30f8fcccab4$export$3c417c5065f4ac35 = ()=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    return $3217b30f8fcccab4$export$c922e8420e7a46c9({
        cloudId: cloudId,
        activationId: activationId
    });
};
module.exports["getWorkspaceARI"] = $3217b30f8fcccab4$export$c922e8420e7a46c9;
module.exports["useWorkspaceARI"] = $3217b30f8fcccab4$export$3c417c5065f4ac35;

});

parcelRegister("5hAil", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $bavCP = parcelRequire("bavCP");

class $3d8ab1ac7a88b72c$export$9fae4d77e240e114 extends (0, $42omo.Component) {
    render() {
        const { queryProps: queryProps, children: children } = this.props;
        return this._renderQueryComponent(queryProps, children, 0);
    }
    constructor(..._args){
        super(..._args);
        this._queryResults = [];
        this._queryProperties = [];
        this._anyLoading = ()=>this._queryResults.some((data)=>data.loading === true);
        this._renderQueryComponent = (configArray, children, index)=>{
            if (!configArray.length) return children({
                results: [],
                loading: false
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
                errorPolicy: "all",
                ...configArray[index]
            }, ({ data: data, loading: loading, error: error, ...args })=>{
                this._queryResults[index] = {
                    data: data,
                    loading: loading,
                    error: error
                };
                this._queryProperties[index] = args;
                const nextIndex = index + 1;
                if (configArray.length > nextIndex) return this._renderQueryComponent(configArray, children, nextIndex);
                return children({
                    results: this._queryResults,
                    loading: this._anyLoading(),
                    properties: this._queryProperties
                });
            });
        };
    }
}
$3d8ab1ac7a88b72c$export$9fae4d77e240e114.propTypes = {
    queryProps: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).array.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["QueryGroup"] = $3d8ab1ac7a88b72c$export$9fae4d77e240e114;

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("3zetf", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $7ftOo = parcelRequire("7ftOo");

const $578f455bd7f79c76$export$64984dda48ed9108 = (results)=>{
    const errors = results.filter((result)=>result.error).map((result)=>result.error);
    if (errors.length) throw new Error(errors.join('\n\n'));
    return results[0]?.data?.space?.name || '';
};
const $578f455bd7f79c76$export$5e300c68d69bb755 = (spaceKey)=>{
    return [
        {
            query: (0, $7ftOo.SpaceNameQuery),
            variables: {
                spaceKey: spaceKey
            },
            skip: !spaceKey
        }
    ];
};
module.exports["getSpaceNameFromResults"] = $578f455bd7f79c76$export$64984dda48ed9108;
module.exports["getSpaceNameQueryProps"] = $578f455bd7f79c76$export$5e300c68d69bb755;

});

parcelRegister("7ftOo", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $6a955c062718cf11$export$572a16972f8daeee = (0, $eSUdr.default)`query SpaceNameQuery($spaceKey:String!){space(key:$spaceKey){id name key}}`;
module.exports["SpaceNameQuery"] = $6a955c062718cf11$export$572a16972f8daeee;

});

parcelRegister("9Q3jD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4uSkp = parcelRequire("4uSkp");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $iPRuY = parcelRequire("iPRuY");

const $fb83eb4a10554029$export$69ad3f5eb9aa63a1 = ({ children: children, contentQueryResult: contentQueryResult, route: route, versionOverride: versionOverride })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const handleTimeoutError = (error)=>{
        const isTimeoutError = error?.toString().includes('SocketTimeoutException');
        if (isTimeoutError) experienceTracker.fail({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            error: error
        });
        else experienceTracker.abort({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            reason: error.message
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    };
    const handleUnexpectedError = (error)=>{
        const isUserError = (0, $aMcHK.getStatusCodeError)(error)?.startsWith('4');
        if (isUserError) experienceTracker.abort({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            reason: error.message
        });
        else experienceTracker.fail({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            error: error
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        throw error; // Throw to propagate to error boundary - otherwise just shows a blank screen
    };
    // When unauthorized and viewing a restricted page, user is prompted
    // with SuperAdmin gateway
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4uSkp.ViewPageGateway), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iPRuY.ContentPrerequisites), {
        route: route,
        contentQueryResult: contentQueryResult,
        versionOverride: versionOverride,
        handleUnexpectedError: handleUnexpectedError,
        handleTimeoutError: handleTimeoutError
    }, children));
};
module.exports["PagePrerequisites"] = $fb83eb4a10554029$export$69ad3f5eb9aa63a1;

});

parcelRegister("4uSkp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $bavCP = parcelRequire("bavCP");


var $ao6k0 = parcelRequire("ao6k0");


var $1uFM6 = parcelRequire("1uFM6");


var $9xNes = parcelRequire("9xNes");


var $f3euL = parcelRequire("f3euL");


var $ep3mz = parcelRequire("ep3mz");


var $2k9aV = parcelRequire("2k9aV");


var $c4ECQ = parcelRequire("c4ECQ");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $lfFzM = parcelRequire("lfFzM");


var $iPPFu = parcelRequire("iPPFu");

function $34641b344ae1099e$export$27cc57004471e91(hasDirectRestrictions, hasPageInheritedRestrictions, hasSpaceRestrictions) {
    // multiple restrictions = at least two.
    const hasMultipleRestrictions = hasDirectRestrictions ? hasPageInheritedRestrictions || hasSpaceRestrictions : hasPageInheritedRestrictions && hasSpaceRestrictions;
    if (hasMultipleRestrictions) return (0, $c4ECQ.RestrictionFrom).MULTIPLE;
    if (hasDirectRestrictions) return (0, $c4ECQ.RestrictionFrom).DIRECT;
    if (hasPageInheritedRestrictions) return (0, $c4ECQ.RestrictionFrom).PAGE_INHERITED;
    if (hasSpaceRestrictions) return (0, $c4ECQ.RestrictionFrom).SPACE;
    return (0, $c4ECQ.RestrictionFrom).NONE;
}
const $34641b344ae1099e$var$CUSTOM_ATTRIBUTES = {
    inaccessiblePageType: 'RESTRICTED_CONFIRMATION_PAGE'
};
class $34641b344ae1099e$export$92eba4cf4af6c314 extends (0, $42omo.PureComponent) {
    componentDidMount() {
        this.checkConsentToViewPage();
    }
    componentDidUpdate() {
        this.checkConsentToViewPage();
    }
    checkConsentToViewPage() {
        const localStorageValue = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).RESTRICTED_PAGE_CONFIRMED);
        if (!localStorageValue) {
            this.setState({
                restrictedPageViewConfirmed: false
            });
            return;
        }
        // Set the state if it matches so we can skip rendering the confirmation.
        if (String(localStorageValue) === this.props.contentId) this.setState({
            restrictedPageViewConfirmed: true
        });
        else {
            // This means the user is on a different page currently. Can safely
            // delete the entry now so we can render the confirmation again if the
            // former page is accessed again.
            (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).RESTRICTED_PAGE_CONFIRMED);
            this.setState({
                restrictedPageViewConfirmed: false
            });
        }
    }
    render() {
        const { children: children, contentId: contentId } = this.props;
        if (!contentId) // in this case children renders ContentPrerequisites which shows the appropriate 404 page
        return children;
        const { restrictedPageViewConfirmed: restrictedPageViewConfirmed } = this.state;
        if (restrictedPageViewConfirmed) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lfFzM.AdminKeyQuery), null, ({ loading: loading, error: error, isSuperAdmin: isSuperAdmin })=>{
            if (loading) return null;
            if (error) throw error;
            if (!isSuperAdmin) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
                query: (0, $iPPFu.ViewPageGatewayQuery),
                variables: {
                    contentId: contentId
                },
                fetchPolicy: "network-only",
                context: {
                    asSuperAdmin: false
                }
            }, ({ loading: loading, error: error })=>{
                if (loading) return null;
                // render confirmation if the user is accessing a restricted
                // page and has not already confirmed viewing the page
                if (error && !restrictedPageViewConfirmed && (0, $1uFM6.isUnauthorizedError)(error)) return this.renderRestrictedPageConfirmation();
                return children;
            });
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            restrictedPageViewConfirmed: false
        };
        this.onRestrictedPageViewConfirmClick = ()=>{
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).RESTRICTED_PAGE_CONFIRMED, this.props.contentId);
            // Set the state regardles of localstorage setItem succeeding or not so we
            // can render the page.
            this.setState({
                restrictedPageViewConfirmed: true
            });
        };
        this.renderRestrictedPageConfirmation = ()=>{
            const { contentId: contentId, spaceKey: spaceKey } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2k9aV.RestrictionsCheck), {
                contentId: contentId,
                spaceKey: spaceKey
            }, ({ hasDirectViewRestrictions: hasDirectViewRestrictions, hasInheritedViewRestrictions: hasInheritedViewRestrictions, isSpaceRestricted: isSpaceRestricted, loading: loading, error: error })=>{
                // TODO: handled in upper layer when confluence_restrictions_fix is enabled
                if (loading) return null;
                if (error) throw error;
                const restrictionFromType = $34641b344ae1099e$export$27cc57004471e91(hasDirectViewRestrictions, hasInheritedViewRestrictions, isSpaceRestricted);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9xNes.RestrictedPageConfirmation), {
                    restrictionFromType: restrictionFromType,
                    onViewPageClick: this.onRestrictedPageViewConfirmClick
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ao6k0.PageLoadEnd), {
                    metric: (0, $f3euL.INACCESSIBLE_PAGE_LOAD),
                    customData: {
                        contentId: contentId,
                        ...$34641b344ae1099e$var$CUSTOM_ATTRIBUTES
                    }
                }));
            });
        };
    }
}
$34641b344ae1099e$export$92eba4cf4af6c314.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node.isRequired
};
const $34641b344ae1099e$export$35cf1eab48371b15 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ep3mz.PageSubscriber), null, (t2)=>{
            const { contentId: contentId, spaceKey: spaceKey } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($34641b344ae1099e$export$92eba4cf4af6c314, {
                contentId: contentId,
                spaceKey: spaceKey
            }, children);
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ep3mz.PageSubscriber), null, ({ contentId: contentId, spaceKey: spaceKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($34641b344ae1099e$export$92eba4cf4af6c314, {
            contentId: contentId,
            spaceKey: spaceKey
        }, children));
$34641b344ae1099e$export$35cf1eab48371b15.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node.isRequired
};
module.exports["ViewPageGateway"] = $34641b344ae1099e$export$35cf1eab48371b15;

});

parcelRegister("9xNes", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4667b31838ac7b2c$export$8c5f260af94a9e2e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "tXIbI",
    name: "RestrictedPageConfirmation",
    loader: async ()=>(await (parcelRequire("lc1Zh"))).RestrictedPageConfirmation
});
module.exports["RestrictedPageConfirmation"] = $4667b31838ac7b2c$export$8c5f260af94a9e2e;

});

parcelRegister("lc1Zh", function(module, exports) {

let $f6dc429e451ecb75$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f6dc429e451ecb75$var$load("37xVM").then(()=>parcelRequire('7NZoR'));

});

parcelRegister("2k9aV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $80NaV = parcelRequire("80NaV");


var $fG32j = parcelRequire("fG32j");

const $d8539e55a4f27a93$export$26883b91564da8f7 = ({ children: children, spaceKey: spaceKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fG32j.SpaceRestrictionCheck), {
        asSuperAdmin: false,
        spaceKey: spaceKey
    }, ({ error: spaceRestrictionCheckError, isSpaceRestricted: isSpaceRestricted, loading: spaceRestrictionCheckIsLoading })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $80NaV.PageViewRestrictions), null, ({ error: pageViewRestrictionsError, hasDirectViewRestrictions: hasDirectViewRestrictions, hasInheritedViewRestrictions: hasInheritedViewRestrictions, loading: pageViewRestrictionsIsLoading })=>children({
                error: spaceRestrictionCheckError || pageViewRestrictionsError,
                hasDirectViewRestrictions: hasDirectViewRestrictions,
                hasInheritedViewRestrictions: hasInheritedViewRestrictions,
                isSpaceRestricted: isSpaceRestricted,
                loading: spaceRestrictionCheckIsLoading || pageViewRestrictionsIsLoading || false
            })));
module.exports["RestrictionsCheck"] = $d8539e55a4f27a93$export$26883b91564da8f7;

});

parcelRegister("80NaV", function(module, exports) {

var $jLw6A = parcelRequire("jLw6A");


var $6mKj3 = parcelRequire("6mKj3");

function $ac3796b23ede5ce7$export$6bf9ddef68460137({ children: children }) {
    const { restrictions: restrictions, error: error, loading: loading } = (0, $jLw6A.usePageRestrictionsContext)();
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        const hasDirectViewRestrictions = Boolean(restrictions?.hasViewRestrictions);
        const hasInheritedViewRestrictions = Boolean(restrictions?.hasInheritedRestrictions);
        if (loading) return null;
        return children({
            error: error,
            hasDirectViewRestrictions: hasDirectViewRestrictions,
            hasInheritedViewRestrictions: hasInheritedViewRestrictions
        });
    } else {
        let hasDirectViewRestrictions;
        let hasInheritedViewRestrictions;
        if (!loading) {
            hasDirectViewRestrictions = Boolean(restrictions?.hasViewRestrictions);
            hasInheritedViewRestrictions = Boolean(restrictions?.hasInheritedRestrictions);
        }
        return children({
            error: error,
            hasDirectViewRestrictions: hasDirectViewRestrictions,
            hasInheritedViewRestrictions: hasInheritedViewRestrictions,
            loading: loading
        });
    }
}
module.exports["PageViewRestrictions"] = $ac3796b23ede5ce7$export$6bf9ddef68460137;

});

parcelRegister("iPPFu", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $db6511a61fa44cc3$export$aaf44510d6f97779 = (0, $eSUdr.default)`query ViewPageGatewayQuery($contentId:ID){content(id:$contentId){nodes{id status}}}`;
module.exports["ViewPageGatewayQuery"] = $db6511a61fa44cc3$export$aaf44510d6f97779;

});

parcelRegister("5AZDw", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $2pjJ5 = parcelRequire("2pjJ5");


var $h9yJL = parcelRequire("h9yJL");


var $aXG5V = parcelRequire("aXG5V");


var $9NwnH = parcelRequire("9NwnH");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $thP0O = parcelRequire("thP0O");


var $178iy = parcelRequire("178iy");


var $7NEE7 = parcelRequire("7NEE7");


var $7sC4q = parcelRequire("7sC4q");


var $gHSfc = parcelRequire("gHSfc");


var $4jbak = parcelRequire("4jbak");


var $7TpBw = parcelRequire("7TpBw");


var $hp1nS = parcelRequire("hp1nS");


var $5GGNA = parcelRequire("5GGNA");


var $47Xfp = parcelRequire("47Xfp");


var $8Ffh4 = parcelRequire("8Ffh4");


var $1FwZj = parcelRequire("1FwZj");


var $eJriO = parcelRequire("eJriO");

const $8f81d195b82ccad2$var$providerBuilder = (collabEditProviderPromise)=>async (codeToExecute, onError)=>{
        try {
            const provider = await collabEditProviderPromise;
            if (provider) return codeToExecute(provider);
        } catch (err) {
            if (onError) onError(err);
            else // eslint-disable-next-line no-console
            console.error(err);
        }
    };
const $8f81d195b82ccad2$var$createAddInlineCommentMark = (providerPromise)=>({ from: from, to: to, mark: mark })=>{
        providerPromise.then((provider)=>{
            const commentMark = new (0, $aXG5V.AddMarkStep)(Math.min(from, to), Math.max(from, to), mark);
            // @ts-expect-error 2339: Property 'api' does not exist on type 'CollabEditProvider<CollabEvents>'.
            provider.api?.addComment([
                commentMark
            ]);
        });
        return false;
    };
const $8f81d195b82ccad2$var$createAddInlineCommentNodeMark = (providerPromise)=>({ pos: pos, mark: mark })=>{
        providerPromise.then((provider)=>{
            const commentMark = new (0, $aXG5V.AddNodeMarkStep)(pos, mark);
            // @ts-expect-error 2339: Property 'api' does not exist on type 'CollabEditProvider<CollabEvents>'.
            provider.api?.addComment([
                commentMark
            ]);
        });
        return false;
    };
const $8f81d195b82ccad2$export$7b59344e4e475116 = ({ config: options, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    let providerResolver = ()=>{};
    const editorViewRef = {
        current: null
    };
    const collabEditProviderPromise = new Promise((_providerResolver)=>{
        providerResolver = _providerResolver;
    });
    const executeProviderCode = $8f81d195b82ccad2$var$providerBuilder(collabEditProviderPromise);
    return {
        name: 'collabEdit',
        getSharedState (state) {
            if (!state) return {
                initialised: {
                    collabInitialisedAt: null,
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null,
                    lastLocalOrganicChangeAt: null,
                    lastRemoteOrganicChangeAt: null,
                    lastLocalOrganicBodyChangeAt: null,
                    lastRemoteOrganicBodyChangeAt: null
                },
                activeParticipants: undefined,
                sessionId: undefined,
                lastReconnectionConflictMetadata: undefined
            };
            const collabPluginState = (0, $gHSfc.pluginKey).getState(state);
            const metadata = (0, $47Xfp.trackNCSInitializationPluginKey).getState(state);
            const lastOrganicChangeState = (0, $5GGNA.trackLastOrganicChangePluginKey).getState(state);
            const lastRemoteConflict = (0, $8Ffh4.trackLastRemoteConflictPluginKey).getState(state);
            return {
                activeParticipants: collabPluginState?.activeParticipants,
                sessionId: collabPluginState?.sessionId,
                initialised: {
                    collabInitialisedAt: metadata?.collabInitialisedAt || null,
                    firstChangeAfterInitAt: metadata?.firstChangeAfterInitAt || null,
                    firstContentBodyChangeAfterInitAt: metadata?.firstContentBodyChangeAfterInitAt || null,
                    lastLocalOrganicChangeAt: lastOrganicChangeState?.lastLocalOrganicChangeAt || null,
                    lastRemoteOrganicChangeAt: lastOrganicChangeState?.lastRemoteOrganicChangeAt || null,
                    lastLocalOrganicBodyChangeAt: lastOrganicChangeState?.lastLocalOrganicBodyChangeAt || null,
                    lastRemoteOrganicBodyChangeAt: lastOrganicChangeState?.lastRemoteOrganicBodyChangeAt || null
                },
                lastReconnectionConflictMetadata: lastRemoteConflict
            };
        },
        actions: {
            getAvatarColor: $eJriO.getAvatarColor,
            addInlineCommentMark: $8f81d195b82ccad2$var$createAddInlineCommentMark(collabEditProviderPromise),
            addInlineCommentNodeMark: $8f81d195b82ccad2$var$createAddInlineCommentNodeMark(collabEditProviderPromise),
            isRemoteReplaceDocumentTransaction: (tr)=>tr.getMeta('isRemote') && tr.getMeta('replaceDocument'),
            getCurrentCollabState: ()=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const adfDocument = new (0, $h9yJL.JSONTransformer)().encode(editorViewRef.current.state.doc);
                return {
                    content: adfDocument,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    version: (0, $9NwnH.getCollabState)(editorViewRef.current.state)?.version || 0,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    sendableSteps: (0, $9NwnH.sendableSteps)(editorViewRef.current.state)
                };
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validatePMJSONDocument: (doc)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const content = (doc.content || []).map((child)=>// Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    editorViewRef.current.state.schema.nodeFromJSON(child));
                return content.every((node)=>{
                    try {
                        node.check(); // this will throw an error if the node is invalid
                    } catch (error) {
                        return false;
                    }
                    return true;
                });
            }
        },
        pmPlugins () {
            const { useNativePlugin: useNativePlugin = false, userId: userId = null } = options || {};
            const transformUnconfirmed = (steps)=>{
                let transformed = steps;
                if ((0, $iu6m9.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true, {
                    exposure: true
                })) transformed = (0, $7NEE7.filterAnalyticsSteps)(transformed);
                if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) || (0, $1oCLl.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true)) transformed = (0, $4jbak.mergeUnconfirmedSteps)(transformed, api);
                return transformed;
            };
            const plugins = [
                ...useNativePlugin ? [
                    {
                        name: 'pmCollab',
                        plugin: ()=>(0, $9NwnH.collab)({
                                clientID: userId,
                                transformUnconfirmed: transformUnconfirmed
                            })
                    },
                    {
                        name: 'nativeCollabProviderPlugin',
                        plugin: ()=>(0, $7TpBw.nativeCollabProviderPlugin)({
                                providerPromise: collabEditProviderPromise
                            })
                    }
                ] : [],
                {
                    name: 'collab',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory })=>{
                        return (0, $7sC4q.createPlugin)(dispatch, providerFactory, providerResolver, executeProviderCode, options, featureFlags, api);
                    }
                },
                {
                    name: 'collabTrackNCSInitializationPlugin',
                    plugin: (0, $47Xfp.createPlugin)
                }
            ];
            plugins.push({
                name: 'trackAndFilterSpammingSteps',
                plugin: ()=>(0, $hp1nS.createPlugin)((tr)=>{
                        const sanitizedSteps = tr.steps.map((step)=>(0, $hp1nS.sanitizeFilteredStep)(step));
                        api?.analytics?.actions?.fireAnalyticsEvent({
                            action: (0, $d925B.ACTION).STEPS_FILTERED,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).COLLAB,
                            attributes: {
                                steps: sanitizedSteps
                            },
                            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                        });
                    })
            });
            plugins.push({
                name: 'collabTrackLastOrganicChangePlugin',
                plugin: (0, $5GGNA.createPlugin)
            });
            if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) plugins.push({
                name: 'trackLastRemoteConflictPlugin',
                plugin: (0, $8Ffh4.createPlugin)
            });
            return plugins;
        },
        onEditorViewStateUpdated (props) {
            const addErrorAnalytics = (0, $thP0O.addSynchronyErrorAnalytics)(props.newEditorState, props.newEditorState.tr, featureFlags, api?.analytics?.actions);
            const isEmptyDoc = (0, $2pjJ5.isEmptyDocument)(props.newEditorState.doc);
            const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
            executeProviderCode((0, $178iy.sendTransaction)({
                originalTransaction: props.originalTransaction,
                transactions: props.transactions,
                oldEditorState: props.oldEditorState,
                newEditorState: props.newEditorState,
                useNativePlugin: options.useNativePlugin ?? false,
                hideTelecursorOnLoad: !isEmptyDoc && (options.hideTelecursorOnLoad ?? false),
                viewMode: viewMode
            }), addErrorAnalytics);
            (0, $1FwZj.track)({
                api: api,
                ...props,
                onTrackDataProcessed: (steps)=>{
                    api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $d925B.ACTION).STEPS_TRACKED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).COLLAB,
                        attributes: {
                            steps: steps
                        },
                        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                    });
                }
            });
        },
        commands: {
            nudgeTelepointer: (sessionId)=>({ tr: tr })=>{
                    tr.setMeta('nudgeTelepointer', {
                        sessionId: sessionId
                    });
                    return tr;
                }
        }
    };
};
module.exports["collabEditPlugin"] = $8f81d195b82ccad2$export$7b59344e4e475116;

});

parcelRegister("thP0O", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $56Wjx = parcelRequire("56Wjx");


var $1HVk8 = parcelRequire("1HVk8");

const $469073082c3fe329$export$8c408a1f4e12c948 = (state, tr, featureFlags, editorAnalyticsApi)=>{
    return (error)=>{
        const browserExtensions = (0, $1HVk8.sniffUserBrowserExtensions)({
            extensions: [
                'grammarly'
            ]
        });
        const payload = {
            action: (0, $d925B.ACTION).SYNCHRONY_ERROR,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                browserExtensions: browserExtensions
            }
        };
        if (featureFlags.synchronyErrorDocStructure) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        payload.attributes.docStructure = (0, $56Wjx.getDocStructure)(state.doc, {
            compact: true
        });
        editorAnalyticsApi?.attachAnalyticsEvent(payload)(tr);
        return tr;
    };
};
const $469073082c3fe329$export$31cf0e3f119813a1 = (state, tr)=>{
    return (type, editorAnalyticsApi)=>{
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: type === 'error' ? (0, $d925B.ACTION).SYNCHRONY_ENTITY_ERROR : (0, $d925B.ACTION).SYNCHRONY_DISCONNECTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                // https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/onLine
                onLine: navigator.onLine,
                visibilityState: document.visibilityState
            }
        })(tr);
        return tr;
    };
};
module.exports["addSynchronyErrorAnalytics"] = $469073082c3fe329$export$8c408a1f4e12c948;
module.exports["addSynchronyEntityAnalytics"] = $469073082c3fe329$export$31cf0e3f119813a1;

});

parcelRegister("178iy", function(module, exports) {

var $jy7VG = parcelRequire("jy7VG");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $a5O8j = parcelRequire("a5O8j");


var $gHSfc = parcelRequire("gHSfc");

const $ea4f9fca74c39b80$export$8e0e7ffc78696d30 = ({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState, useNativePlugin: useNativePlugin, viewMode: viewMode, hideTelecursorOnLoad: hideTelecursorOnLoad })=>(provider)=>{
        const docChangedTransaction = transactions.find((tr)=>tr.docChanged);
        const currentPluginState = (0, $gHSfc.pluginKey).getState(newEditorState);
        const trNoAnalytics = oldEditorState.tr;
        docChangedTransaction?.steps.forEach((step)=>{
            if (!(step instanceof (0, $jy7VG.AnalyticsStep))) trNoAnalytics.step(step);
        });
        if (!currentPluginState?.isReady) return;
        const newTransaction = (0, $iu6m9.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true, {
            exposure: true
        }) ? trNoAnalytics : docChangedTransaction;
        const shouldSendStepForSynchronyCollabProvider = !originalTransaction.getMeta('isRemote') && // TODO: ED-8995 - We need to do this check to reduce the number of race conditions when working with tables.
        // This metadata is coming from the scaleTable command in table-resizing plugin
        !originalTransaction.getMeta('scaleTable') && ((0, $iu6m9.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true) ? newTransaction?.docChanged : true);
        if (useNativePlugin || shouldSendStepForSynchronyCollabProvider) provider.send(newTransaction, oldEditorState, newEditorState);
        const prevPluginState = (0, $gHSfc.pluginKey).getState(oldEditorState);
        const { activeParticipants: prevActiveParticipants } = prevPluginState || {};
        const { activeParticipants: activeParticipants, sessionId: sessionId } = currentPluginState;
        const selectionChanged = !oldEditorState.selection.eq(newEditorState.selection);
        const participantsChanged = prevActiveParticipants && !prevActiveParticipants.eq(activeParticipants);
        if ((0, $dh538.fg)('platform_editor_ai_generic_prep_for_aifc')) {
            if (!sessionId || viewMode !== 'edit') return;
            // uiEvent is standard metdata (docs: https://prosemirror.net/docs/ref/#state.Transaction)
            const isPaste = docChangedTransaction?.getMeta('uiEvent') === 'paste';
            // If this metadata is truthy then it means a selection bookmark might be declared as the meta value OR the transaction
            // doesn't want the tr.selection to be sent to remote users at all.
            const remoteSelectionBookmark = originalTransaction.getMeta('useSelectionBookmarkForRemote');
            if (!!remoteSelectionBookmark) {
                if (remoteSelectionBookmark !== true && 'resolve' in remoteSelectionBookmark) {
                    const selection = remoteSelectionBookmark.resolve(newEditorState.doc);
                    const message = {
                        type: 'telepointer',
                        selection: (0, $a5O8j.getSendableSelection)(selection),
                        sessionId: sessionId
                    };
                    provider.sendMessage(message);
                }
            } else if (// Broadcast the position if the selection has changed, and the doc hasn't changed (it is mapped
            // by the receiver).
            // If we're pasting content though make an exception (as doc has changed)
            // as on a ranged selection it results in not clearing the ranged selection after the paste
            selectionChanged && (!docChangedTransaction || isPaste) || participantsChanged && !hideTelecursorOnLoad) {
                const selection = (0, $a5O8j.getSendableSelection)(newEditorState.selection);
                const message = {
                    type: 'telepointer',
                    selection: selection,
                    sessionId: sessionId
                };
                provider.sendMessage(message);
            }
        } else if (sessionId && viewMode === 'edit' && (selectionChanged && !docChangedTransaction || participantsChanged && !hideTelecursorOnLoad)) {
            const selection = (0, $a5O8j.getSendableSelection)(newEditorState.selection);
            const message = {
                type: 'telepointer',
                selection: selection,
                sessionId: sessionId
            };
            provider.sendMessage(message);
        }
    };
module.exports["sendTransaction"] = $ea4f9fca74c39b80$export$8e0e7ffc78696d30;

});

parcelRegister("a5O8j", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $cU18e = parcelRequire("cU18e");


var $fKGo7 = parcelRequire("fKGo7");


var $ks2lK = parcelRequire("ks2lK");


var $cO9ey = parcelRequire("cO9ey");


var $9NwnH = parcelRequire("9NwnH");


var $eJriO = parcelRequire("eJriO");

const $5e2f0b1ed387432d$export$d970973925859b8e = ()=>{
    Object.entries($fKGo7).forEach(()=>{});
    Object.entries($cU18e).forEach(()=>{});
};
const $5e2f0b1ed387432d$export$a04a448cc866246 = (initData, view, options, editorAnalyticsApi)=>{
    const { doc: doc, json: json, version: version, reserveCursor: reserveCursor } = initData;
    if (doc) {
        const { state: state } = view;
        const tr = (0, $eJriO.replaceDocument)(doc, state, version, options, reserveCursor, editorAnalyticsApi);
        tr.setMeta('isRemote', true);
        view.dispatch(tr);
    } else if (json) $5e2f0b1ed387432d$export$ff4f2767b9e99aa9(json, view);
};
const $5e2f0b1ed387432d$export$cf9a0dcadb173615 = (connectionData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('sessionId', connectionData));
};
const $5e2f0b1ed387432d$export$f9db5387b510d6c = (presenceData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('presence', presenceData));
};
const $5e2f0b1ed387432d$export$c6643a6a2625d22c = (remoteData, view, options)=>{
    const { json: json, userIds: userIds = [] } = remoteData;
    if (json) $5e2f0b1ed387432d$export$ff4f2767b9e99aa9(json, view, userIds, options);
};
const $5e2f0b1ed387432d$export$ff4f2767b9e99aa9 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
json, view, userIds, options)=>{
    if (!json || !json.length) return;
    const { state: state, state: { schema: schema } } = view;
    const steps = json.map((step)=>(0, $cO9ey.Step).fromJSON(schema, step));
    let tr;
    if (options && options.useNativePlugin && userIds) tr = (0, $9NwnH.receiveTransaction)(state, steps, userIds, {
        mapSelectionBackward: true
    });
    else {
        tr = state.tr;
        steps.forEach((step)=>tr.step(step));
    }
    if (tr) {
        tr.setMeta('addToHistory', false);
        tr.setMeta('isRemote', true);
        /*
		 * Persist marks across transactions. Fixes an issue where
		 * marks are lost if remote transactions are dispatched
		 * between a user creating the mark and typing.
		 */ if (state.tr.storedMarks) tr.setStoredMarks(state.tr.storedMarks);
        view.dispatch(tr);
    }
};
const $5e2f0b1ed387432d$export$abfa80d838a68fd6 = (telepointerData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('telepointer', telepointerData));
};
function $5e2f0b1ed387432d$var$isAllSelection(selection) {
    return selection instanceof (0, $ks2lK.AllSelection);
}
function $5e2f0b1ed387432d$var$isNodeSelection(selection) {
    return selection instanceof (0, $ks2lK.NodeSelection);
}
const $5e2f0b1ed387432d$export$b95b91cb8577b1db = (selection)=>{
    /**
	 * <kbd>CMD + A</kbd> triggers a AllSelection
	 * <kbd>escape</kbd> triggers a NodeSelection
	 */ return {
        type: 'textSelection',
        anchor: selection.anchor,
        head: $5e2f0b1ed387432d$var$isAllSelection(selection) || $5e2f0b1ed387432d$var$isNodeSelection(selection) ? selection.head - 1 : selection.head
    };
};
module.exports["handleInit"] = $5e2f0b1ed387432d$export$a04a448cc866246;
module.exports["handleConnection"] = $5e2f0b1ed387432d$export$cf9a0dcadb173615;
module.exports["handlePresence"] = $5e2f0b1ed387432d$export$f9db5387b510d6c;
module.exports["applyRemoteData"] = $5e2f0b1ed387432d$export$c6643a6a2625d22c;
module.exports["handleTelePointer"] = $5e2f0b1ed387432d$export$abfa80d838a68fd6;
module.exports["getSendableSelection"] = $5e2f0b1ed387432d$export$b95b91cb8577b1db;

});

parcelRegister("cU18e", function(module, exports) {
$parcel$export(module.exports, "InsertTypeAheadStages", () => (parcelRequire("cuprm")).InsertTypeAheadStages);
$parcel$export(module.exports, "InsertTypeAheadStep", () => (parcelRequire("cuprm")).InsertTypeAheadStep);
$parcel$export(module.exports, "SetAttrsStep", () => (parcelRequire("9YoeD")).SetAttrsStep);
$parcel$export(module.exports, "AnalyticsStep", () => (parcelRequire("jy7VG")).AnalyticsStep);
$parcel$export(module.exports, "LinkMetaStep", () => (parcelRequire("8EkET")).LinkMetaStep);
$parcel$export(module.exports, "OverrideDocumentStep", () => (parcelRequire("lBdHV")).OverrideDocumentStep);
$parcel$export(module.exports, "BatchAttrsStep", () => (parcelRequire("7Mtx3")).BatchAttrsStep);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cuprm = parcelRequire("cuprm");


var $9YoeD = parcelRequire("9YoeD");


var $jy7VG = parcelRequire("jy7VG");


var $8EkET = parcelRequire("8EkET");


var $lBdHV = parcelRequire("lBdHV");


var $7Mtx3 = parcelRequire("7Mtx3");


});

parcelRegister("lBdHV", function(module, exports) {

var $cO9ey = parcelRequire("cO9ey");

var $aXG5V = parcelRequire("aXG5V");

const $7344bda4a76d2478$export$28ee9acdd4691fa9 = 'override-document';
class $7344bda4a76d2478$export$d790696cf3da3aa0 extends (0, $cO9ey.Step) {
    apply(doc) {
        this.oldDocumentSize = doc.content.size;
        return (0, $aXG5V.StepResult).ok(this.nextDocument);
    }
    map() {
        return new $7344bda4a76d2478$export$d790696cf3da3aa0({
            nextDocument: this.nextDocument,
            inverted: this.inverted
        });
    }
    getMap() {
        if (!this.nextDocument || !this.oldDocumentSize) return new (0, $aXG5V.StepMap)([
            0,
            0,
            0
        ]);
        const oldSize = this.oldDocumentSize;
        const nextDocumentSize = this.nextDocument.content.size;
        return new (0, $aXG5V.StepMap)([
            0,
            oldSize,
            nextDocumentSize
        ]);
    }
    invert(doc) {
        return new $7344bda4a76d2478$export$d790696cf3da3aa0({
            nextDocument: doc,
            inverted: true
        });
    }
    toJSON() {
        return {
            stepType: $7344bda4a76d2478$export$28ee9acdd4691fa9,
            inverted: this.inverted,
            nextDocument: this.nextDocument.toJSON()
        };
    }
    static fromJSON(schema, json) {
        if (!json || json.stepType !== $7344bda4a76d2478$export$28ee9acdd4691fa9) throw new RangeError('Invalid overrideDocument step OverrideDocumentStep.fromJSON');
        return new $7344bda4a76d2478$export$d790696cf3da3aa0({
            inverted: json.inverted,
            nextDocument: schema.nodeFromJSON(json.nextDocument)
        });
    }
    constructor(opts){
        super();
        this.inverted = false;
        this.nextDocument = void 0;
        this.oldDocumentSize = 0;
        const { inverted: inverted, nextDocument: nextDocument } = opts;
        if (nextDocument.type.name !== 'doc') throw new Error('nextDocument should be the entire prosemirror doc node and not only its content.');
        this.nextDocument = nextDocument;
        this.inverted = Boolean(inverted);
    }
}
(0, $cO9ey.Step).jsonID($7344bda4a76d2478$export$28ee9acdd4691fa9, $7344bda4a76d2478$export$d790696cf3da3aa0);
module.exports["OverrideDocumentStep"] = $7344bda4a76d2478$export$d790696cf3da3aa0;

});

parcelRegister("fKGo7", function(module, exports) {
$parcel$export(module.exports, "TableSortOrder", () => (parcelRequire("5rHEx")).SortOrder);
$parcel$export(module.exports, "TableSortStep", () => (parcelRequire("cCTpf")).TableSortStep);
$parcel$export(module.exports, "AddColumnStep", () => (parcelRequire("1rJN9")).AddColumnStep);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5rHEx = parcelRequire("5rHEx");


var $cCTpf = parcelRequire("cCTpf");


var $1rJN9 = parcelRequire("1rJN9");


});

parcelRegister("eJriO", function(module, exports) {

var $jy7VG = parcelRequire("jy7VG");

var $7Mtx3 = parcelRequire("7Mtx3");

var $9YoeD = parcelRequire("9YoeD");


var $d925B = parcelRequire("d925B");


var $h3X17 = parcelRequire("h3X17");


var $6tl2G = parcelRequire("6tl2G");


var $TfRUG = parcelRequire("TfRUG");


var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $ftzrq = parcelRequire("ftzrq");


var $jyw2s = parcelRequire("jyw2s");


var $dh538 = parcelRequire("dh538");

const $251f784cd31b0be3$export$cc7116c03c331d66 = (id, decorations)=>decorations.find().reduce((arr, deco)=>deco.spec.pointer.presenceId === id ? arr.concat(deco) : arr, []);
function $251f784cd31b0be3$var$style(options) {
    const color = options && options.color || 'black';
    return `border-right: 2px solid ${color}; margin-right: -2px; z-index: 1`;
}
function $251f784cd31b0be3$export$90c6ee000c44ff4a(str) {
    const participantColor = (0, $jyw2s.getParticipantColor)(str);
    return {
        index: participantColor.index,
        backgroundColor: participantColor.color.backgroundColor,
        textColor: participantColor.color.textColor
    };
}
const $251f784cd31b0be3$export$8f868fb36fe42fe8 = (from, to, sessionId, isSelection, initial, presenceId, fullName, isNudged)=>{
    const decorations = [];
    const avatarColor = $251f784cd31b0be3$export$90c6ee000c44ff4a(presenceId);
    const color = avatarColor.index.toString();
    if (isSelection) {
        const className = `telepointer color-${color} telepointer-selection`;
        decorations.push((0, $ftzrq.Decoration).inline(from, to, {
            class: className
        }, {
            pointer: {
                sessionId: sessionId,
                presenceId: presenceId
            }
        }));
    }
    const spaceJoinerBefore = document.createElement('span');
    spaceJoinerBefore.textContent = (0, $TfRUG.ZERO_WIDTH_JOINER);
    const spaceJoinerAfter = document.createElement('span');
    spaceJoinerAfter.textContent = (0, $TfRUG.ZERO_WIDTH_JOINER);
    const cursor = document.createElement('span');
    cursor.textContent = (0, $TfRUG.ZERO_WIDTH_JOINER);
    cursor.className = `telepointer color-${color} telepointer-selection-badge`;
    cursor.style.cssText = `${$251f784cd31b0be3$var$style({
        color: avatarColor.backgroundColor
    })};`;
    cursor.setAttribute('aria-label', `${fullName} cursor position`);
    cursor.setAttribute('role', 'button');
    cursor.setAttribute((0, $h3X17.TELEPOINTER_DATA_SESSION_ID_ATTR), sessionId);
    // If there is an ongoing expand animation, we'll keep the telepointer expanded
    // until the keyframe animation is complete. Please note that this will restart the anim timer
    // from 0 everytime it's re-added.
    if (isNudged) cursor.classList.add((0, $h3X17.TELEPOINTER_PULSE_DURING_TR_CLASS));
    const fullNameEl = document.createElement('span');
    fullNameEl.textContent = fullName;
    fullNameEl.className = 'telepointer-fullname';
    fullNameEl.style.backgroundColor = avatarColor.backgroundColor;
    fullNameEl.style.color = avatarColor.textColor;
    fullNameEl.setAttribute('aria-hidden', 'true');
    cursor.appendChild(fullNameEl);
    const initialEl = document.createElement('span');
    initialEl.textContent = initial;
    initialEl.className = 'telepointer-initial';
    initialEl.style.backgroundColor = avatarColor.backgroundColor;
    initialEl.style.color = avatarColor.textColor;
    initialEl.setAttribute('aria-hidden', 'true');
    cursor.appendChild(initialEl);
    return decorations.concat((0, $ftzrq.Decoration).widget(to, spaceJoinerAfter, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}-zero`
    })).concat((0, $ftzrq.Decoration).widget(to, cursor, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}`
    })).concat((0, $ftzrq.Decoration).widget(to, spaceJoinerBefore, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}-zero`
    }));
};
const $251f784cd31b0be3$export$fe10d6bdd551e45e = (doc, state, version, options, reserveCursor, editorAnalyticsAPI)=>{
    const { schema: schema, tr: tr } = state;
    const parsedDoc = (0, $6tl2G.processRawValueWithoutValidation)(schema, doc, editorAnalyticsAPI?.fireAnalyticsEvent);
    const hasContent = !!parsedDoc?.childCount;
    const content = parsedDoc?.content;
    if (hasContent) {
        tr.setMeta('addToHistory', false);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tr.replaceWith(0, state.doc.nodeSize - 2, content);
        const selection = state.selection;
        if (reserveCursor) // If the cursor is still in the range of the new document,
        // keep where it was.
        {
            if (selection.to < tr.doc.content.size - 2) {
                const $from = tr.doc.resolve(selection.from);
                const $to = tr.doc.resolve(selection.to);
                const newselection = new (0, $ks2lK.TextSelection)($from, $to);
                tr.setSelection(newselection);
            }
        } else tr.setSelection((0, $ks2lK.Selection).atStart(tr.doc));
        tr.setMeta('replaceDocument', true);
        if (options && options.useNativePlugin) {
            const collabState = {
                version: version,
                unconfirmed: []
            };
            tr.setMeta('collab$', collabState);
        }
    }
    return tr;
};
const $251f784cd31b0be3$export$82e6f13680c85057 = (editorView, participants, sessionId, index, editorAnalyticsAPI)=>{
    const selectedUser = participants[index];
    if (selectedUser && selectedUser.cursorPos !== undefined && selectedUser.sessionId !== sessionId) {
        const { state: state } = editorView;
        const tr = state.tr;
        const analyticsPayload = {
            action: (0, $d925B.ACTION).MATCHED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).SELECTION,
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
        tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(selectedUser.cursorPos)));
        editorAnalyticsAPI?.attachAnalyticsEvent(analyticsPayload)(tr);
        tr.scrollIntoView();
        editorView.dispatch(tr);
        if (!editorView.hasFocus()) editorView.focus();
    }
};
const $251f784cd31b0be3$export$4d66b240d6166074 = (sessionId, decorationSet)=>{
    let scrollPosition;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    decorationSet.find().forEach((deco)=>{
        if (deco.type.spec.pointer.sessionId === sessionId) scrollPosition = deco.from;
    });
    return scrollPosition;
};
const $251f784cd31b0be3$export$94600c572c12bcd6 = (step)=>step instanceof (0, $aXG5V.ReplaceStep);
const $251f784cd31b0be3$export$b8c92cc7dad49da = (transaction, metaTag)=>{
    const hasMetaTag = Boolean(transaction.getMeta(metaTag));
    if (hasMetaTag) return true;
    const appendedTransaction = transaction.getMeta('appendedTransaction');
    if (appendedTransaction instanceof (0, $ks2lK.Transaction)) return $251f784cd31b0be3$export$b8c92cc7dad49da(appendedTransaction, metaTag);
    return false;
};
/**
 * This list contains step attributes that do not result from a user action.
 * All steps that contain ONLY the blocked attribute are considered automated steps
 * and should not be recognised as organic change.
 *
 * `attr_colwidth` is an exception to above explanation. Resizing the column
 * currently creates too many steps and is therefore also on this list.
 *
 * Steps analycs dashboard: https://atlassian-discover.cloud.databricks.com/dashboardsv3/01ef4d3c8aa916c8b0cb5332a9f37caf/published?o=4482001201517624
 */ const $251f784cd31b0be3$var$blockedAttrsList = [
    '__contextId',
    'localId',
    '__autoSize',
    'attr_colwidth',
    'originalHeight',
    'originalWidth'
];
const $251f784cd31b0be3$export$227edb0398ff0ff6 = (tr)=>{
    // If document has not been marked as `docChanged` by PM, skip the rest of the logic
    if (!tr.docChanged) return false;
    return tr.steps.some((step)=>{
        // If a step is an instance of AnalyticsStep, it is not considered organic
        if (step instanceof (0, $jy7VG.AnalyticsStep)) return false;
        // editor-plugin-local-id uses AttrStep to set the localId attribute
        if (step instanceof (0, $aXG5V.AttrStep) && step.attr === 'localId') return false;
        // editor-plugin-local-id uses BatchAttrStep to set the localId attribute
        if (step instanceof (0, $7Mtx3.BatchAttrsStep) && (0, $dh538.fg)('platform_editor_inorganic_batchattrsstep_localid')) {
            const allAttributes = step.data.map((data)=>Object.keys(data.attrs)).flat();
            return allAttributes.some((attr)=>!$251f784cd31b0be3$var$blockedAttrsList.includes(attr)) && !tr.doc.eq(tr.before);
        }
        // If a step is not an instance of SetAttrsStep, it is considered organic
        if (!(step instanceof (0, $9YoeD.SetAttrsStep))) return true;
        const allAttributes = Object.keys(step.attrs);
        // If a step is an instance of SetAttrsStep, it checks if the attributes in the step
        // are not in the `blockedAttributes`. If one of the attributes not on the list, it considers the change
        // organic but only if the entire document is not equal to the previous state.
        return allAttributes.some((attr)=>!$251f784cd31b0be3$var$blockedAttrsList.includes(attr)) && !tr.doc.eq(tr.before);
    });
};
const $251f784cd31b0be3$export$6a7a563833bcd8 = (sessionId, nudgeAnimations)=>{
    const nudgeAnimStartTime = nudgeAnimations.get(sessionId);
    let hasExistingNudge = false;
    if (nudgeAnimStartTime) {
        const timeElapsed = Date.now() - nudgeAnimStartTime;
        hasExistingNudge = timeElapsed < (0, $h3X17.TELEPOINTER_PULSE_DURING_TR_DURATION_MS);
    }
    return hasExistingNudge;
};
module.exports["findPointers"] = $251f784cd31b0be3$export$cc7116c03c331d66;
module.exports["getAvatarColor"] = $251f784cd31b0be3$export$90c6ee000c44ff4a;
module.exports["createTelepointers"] = $251f784cd31b0be3$export$8f868fb36fe42fe8;
module.exports["replaceDocument"] = $251f784cd31b0be3$export$fe10d6bdd551e45e;
module.exports["getPositionOfTelepointer"] = $251f784cd31b0be3$export$4d66b240d6166074;
module.exports["isReplaceStep"] = $251f784cd31b0be3$export$94600c572c12bcd6;
module.exports["originalTransactionHasMeta"] = $251f784cd31b0be3$export$b8c92cc7dad49da;
module.exports["isOrganicChange"] = $251f784cd31b0be3$export$227edb0398ff0ff6;
module.exports["hasExistingNudge"] = $251f784cd31b0be3$export$6a7a563833bcd8;

});

parcelRegister("gHSfc", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $66421dcbcc8122ef$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('collabEditPlugin');
module.exports["pluginKey"] = $66421dcbcc8122ef$export$18d4026d1ea86bb1;

});

parcelRegister("7NEE7", function(module, exports) {

var $jy7VG = parcelRequire("jy7VG");


var $9NwnH = parcelRequire("9NwnH");

function $b0d3b33c6517a237$export$75962d04b28eb982(steps) {
    const filteredSteps = steps.reduce((acc, rebaseable)=>{
        if (!(rebaseable.step instanceof (0, $jy7VG.AnalyticsStep))) acc.push(new (0, $9NwnH.Rebaseable)(rebaseable.step, rebaseable.inverted, rebaseable.origin));
        return acc;
    }, []);
    return filteredSteps;
}
module.exports["filterAnalyticsSteps"] = $b0d3b33c6517a237$export$75962d04b28eb982;

});

parcelRegister("7sC4q", function(module, exports) {
// It is important to get all steps in that package
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $cU18e = parcelRequire("cU18e");


var $fKGo7 = parcelRequire("fKGo7");


var $d925B = parcelRequire("d925B");

var $ajtqX = parcelRequire("ajtqX");


var $1S4f7 = parcelRequire("1S4f7");


var $cO9ey = parcelRequire("cO9ey");


var $thP0O = parcelRequire("thP0O");


var $8pDWM = parcelRequire("8pDWM");


var $gHSfc = parcelRequire("gHSfc");


var $9eYcL = parcelRequire("9eYcL");

const $cca91a3622c8da39$var$enforceCustomStepRegisters = ()=>{
    const tryToRegisterStep = (obj)=>{
        for (const customStep of Object.values(obj)){
            // I know this seems awful
            // But unfortunate ProseMirror does not expose the jsonID property p
            // @ts-expect-error
            const id = customStep?.prototype?.jsonID;
            if (typeof id === 'string') try {
                // We are trying to re-register the steps here
                // in the normal flow, those custom step should be already registred
                // So, it should throw an expeception
                // @ts-expect-error
                (0, $cO9ey.Step).jsonID(id, customStep);
            } catch (e) {
            // This mean the step was already registred.
            // It is ok to ignore this exception.
            }
        }
    };
    // @ts-expect-error
    tryToRegisterStep($fKGo7);
    // @ts-expect-error
    tryToRegisterStep($cU18e);
};
const $cca91a3622c8da39$export$ae829ec7b2625219 = (dispatch, providerFactory, providerResolver, collabProviderCallback, options, featureFlags, pluginInjectionApi)=>{
    $cca91a3622c8da39$var$enforceCustomStepRegisters();
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $gHSfc.pluginKey),
        state: {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            init (config) {
                return (0, $9eYcL.PluginState).init(config);
            },
            apply (transaction, prevPluginState, _oldEditorState, _newEditorState) {
                const pluginState = prevPluginState.apply(transaction);
                dispatch((0, $gHSfc.pluginKey), pluginState);
                return pluginState;
            }
        },
        props: {
            decorations (state) {
                return (0, $gHSfc.pluginKey).getState(state)?.decorations;
            },
            handleDOMEvents: {
                click (view, event) {
                    if (!(event.target instanceof HTMLElement)) return false;
                    if (!view.state.selection.empty) return false;
                    const { pos: pos } = view.state.tr.selection.$from;
                    if (!pos) return false;
                    // check if the pos is the same pos as a telepointer decoration
                    const decorations = (0, $gHSfc.pluginKey).getState(view.state)?.decorations?.find(pos, pos);
                    if (!decorations?.length) return false;
                    // analytics to track telepointer clicks as they sometimes cause broken selections
                    const fireAnalyticsCallback = (0, $ajtqX.fireAnalyticsEvent)(pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined);
                    fireAnalyticsCallback({
                        payload: {
                            action: (0, $d925B.ACTION).CLICKED,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).TELEPOINTER,
                            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TELEPOINTER,
                            eventType: (0, $d925B.EVENT_TYPE).TRACK
                        }
                    });
                }
            }
        },
        filterTransaction (tr, state) {
            const pluginState = (0, $gHSfc.pluginKey).getState(state);
            const collabInitialiseTr = tr.getMeta('collabInitialised');
            // Don't allow transactions that modifies the document before
            // collab-plugin is ready.
            if (collabInitialiseTr) return true;
            if (!pluginState?.isReady && tr.docChanged) return false;
            return true;
        },
        view (view) {
            const addErrorAnalytics = (0, $thP0O.addSynchronyErrorAnalytics)(view.state, view.state.tr, featureFlags, pluginInjectionApi?.analytics?.actions);
            const onSyncUpError = (attributes)=>{
                const fireAnalyticsCallback = (0, $ajtqX.fireAnalyticsEvent)(pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined);
                fireAnalyticsCallback({
                    payload: {
                        action: (0, $d925B.ACTION).NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                        attributes: attributes
                    }
                });
            };
            options.onSyncUpError = onSyncUpError;
            const cleanup = collabProviderCallback((0, $8pDWM.initialize)({
                view: view,
                options: options,
                providerFactory: providerFactory,
                featureFlags: featureFlags,
                pluginInjectionApi: pluginInjectionApi,
                editorAnalyticsApi: pluginInjectionApi?.analytics?.actions
            }), addErrorAnalytics);
            providerFactory && providerFactory.subscribe('collabEditProvider', (_name, providerPromise)=>{
                if (providerPromise) providerPromise.then((provider)=>providerResolver(provider));
            });
            return {
                destroy () {
                    providerFactory.unsubscribeAll('collabEditProvider');
                    if (cleanup) cleanup.then((unsubscribe)=>{
                        if (unsubscribe) unsubscribe();
                    });
                }
            };
        }
    });
};
module.exports["createPlugin"] = $cca91a3622c8da39$export$ae829ec7b2625219;

});

parcelRegister("8pDWM", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $cO9ey = parcelRequire("cO9ey");


var $gHSfc = parcelRequire("gHSfc");


var $hRqcI = parcelRequire("hRqcI");

const $a7cf3e66d2d5bf31$var$initCollab = (collabEditProvider, view)=>{
    if (collabEditProvider.initialize) collabEditProvider.initialize(()=>view.state, (json)=>(0, $cO9ey.Step).fromJSON(view.state.schema, json));
};
const $a7cf3e66d2d5bf31$var$initNewCollab = (collabEditProvider, view, editorApi, onSyncUpError)=>{
    collabEditProvider.setup({
        getState: ()=>view.state,
        editorApi: editorApi,
        onSyncUpError: onSyncUpError
    });
};
const $a7cf3e66d2d5bf31$var$initCollabMemo = (0, $2XqLN.default)($a7cf3e66d2d5bf31$var$initCollab);
const $a7cf3e66d2d5bf31$export$2a47f398eeff8b01 = ({ options: options, providerFactory: providerFactory, view: view, featureFlags: featureFlags, editorAnalyticsApi: editorAnalyticsApi, pluginInjectionApi: pluginInjectionApi })=>(provider)=>{
        // eslint-disable-next-line prefer-const
        let cleanup;
        const pluginState = (0, $gHSfc.pluginKey).getState(view.state);
        if (pluginState?.isReady && cleanup) cleanup();
        cleanup = (0, $hRqcI.subscribe)(view, provider, options, featureFlags, providerFactory, editorAnalyticsApi);
        // Initialize provider
        if (options.useNativePlugin) // ED-13912 For NCS we don't want to use memoizeOne because it causes
        // infinite text while changing page-width
        $a7cf3e66d2d5bf31$var$initNewCollab(provider, view, pluginInjectionApi, options.onSyncUpError);
        else /**
			 * We only want to initialise once, if we reload/reconfigure this plugin
			 * We dont want to re-init collab, it would break existing sessions
			 */ $a7cf3e66d2d5bf31$var$initCollabMemo(provider, view);
        return cleanup;
    };
module.exports["initialize"] = $a7cf3e66d2d5bf31$export$2a47f398eeff8b01;

});

parcelRegister("hRqcI", function(module, exports) {

var $a5O8j = parcelRequire("a5O8j");


var $thP0O = parcelRequire("thP0O");


var $8Ffh4 = parcelRequire("8Ffh4");

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $928a0df5510ee3ee$var$effect = (fn, eq)=>{
    let previousDeps;
    let cleanup;
    return (...currentDeps)=>{
        if (cleanup && eq(previousDeps, currentDeps)) return cleanup;
        cleanup = fn(...currentDeps);
        previousDeps = currentDeps;
        return cleanup;
    };
};
const $928a0df5510ee3ee$export$ec068583843480e7 = $928a0df5510ee3ee$var$effect((view, provider, options, featureFlags, _providerFactory, editorAnalyticsApi)=>{
    let entityRef;
    const entityHandlers = {
        disconnectedHandler: ()=>{
            (0, $thP0O.addSynchronyEntityAnalytics)(view.state, view.state.tr)('disconnected', editorAnalyticsApi);
        },
        errorHandler: ()=>{
            (0, $thP0O.addSynchronyEntityAnalytics)(view.state, view.state.tr)('error', editorAnalyticsApi);
        }
    };
    const unsubscribeSynchronyEntity = ()=>{
        if (entityRef) {
            entityRef.off('disconnected', entityHandlers.disconnectedHandler);
            entityRef.off('error', entityHandlers.errorHandler);
        }
    };
    const handlers = {
        initHandler: (data)=>{
            view.dispatch(view.state.tr.setMeta('collabInitialised', true));
            (0, $a5O8j.handleInit)(data, view, options, editorAnalyticsApi);
        },
        connectedHandler: (data)=>(0, $a5O8j.handleConnection)(data, view),
        dataHandler: (data)=>(0, $a5O8j.applyRemoteData)(data, view, options),
        presenceHandler: (data)=>(0, $a5O8j.handlePresence)(data, view),
        telepointerHandler: (data)=>(0, $a5O8j.handleTelePointer)(data, view),
        localStepsHandler: (data)=>{
            const { steps: steps } = data;
            const { state: state } = view;
            const { tr: tr } = state;
            steps.forEach((step)=>tr.step(step));
            view.dispatch(tr);
        },
        errorHandler: (error)=>{
            (0, $thP0O.addSynchronyErrorAnalytics)(view.state, view.state.tr, featureFlags, editorAnalyticsApi)(error);
        },
        entityHandler: ({ entity: entity })=>{
            unsubscribeSynchronyEntity();
            if (options.EXPERIMENTAL_allowInternalErrorAnalytics) {
                entity.on('disconnected', entityHandlers.disconnectedHandler);
                entity.on('error', entityHandlers.errorHandler);
                entityRef = entity;
            }
        },
        dataConflictHandler: (data)=>{
            view.dispatch(view.state.tr.setMeta((0, $8Ffh4.trackLastRemoteConflictPluginKey), data));
        }
    };
    provider.on('init', handlers.initHandler).on('connected', handlers.connectedHandler).on('data', handlers.dataHandler).on('presence', handlers.presenceHandler).on('telepointer', handlers.telepointerHandler).on('local-steps', handlers.localStepsHandler).on('error', handlers.errorHandler).on('entity', handlers.entityHandler).on('data:conflict', handlers.dataConflictHandler);
    return ()=>{
        unsubscribeSynchronyEntity();
        provider.off('init', handlers.initHandler).off('connected', handlers.connectedHandler).off('data', handlers.dataHandler).off('presence', handlers.presenceHandler).off('telepointer', handlers.telepointerHandler).off('local-steps', handlers.localStepsHandler).off('error', handlers.errorHandler).off('entity', handlers.entityHandler).off('data:conflict', handlers.dataConflictHandler);
    };
}, (previousDeps, currentDeps)=>currentDeps && currentDeps.every((dep, i)=>dep === previousDeps[i]));
module.exports["subscribe"] = $928a0df5510ee3ee$export$ec068583843480e7;

});

parcelRegister("8Ffh4", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $dff7c070b048fc1b$export$1fa2affd5117a057 = new (0, $ks2lK.PluginKey)('trackLastRemoteConflict');
const $dff7c070b048fc1b$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $dff7c070b048fc1b$export$1fa2affd5117a057,
        state: {
            init () {
                return undefined;
            },
            apply (transaction, prevPluginState) {
                const metadata = transaction.getMeta($dff7c070b048fc1b$export$1fa2affd5117a057);
                if (metadata) return metadata;
                return prevPluginState;
            }
        }
    });
};
module.exports["trackLastRemoteConflictPluginKey"] = $dff7c070b048fc1b$export$1fa2affd5117a057;
module.exports["createPlugin"] = $dff7c070b048fc1b$export$ae829ec7b2625219;

});

parcelRegister("9eYcL", function(module, exports) {

var $d7ZU3 = parcelRequire("d7ZU3");


var $h3X17 = parcelRequire("h3X17");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $eJL1T = parcelRequire("eJL1T");


var $eJriO = parcelRequire("eJriO");

const $c84f494477793052$export$1e860daa85a829a5 = (tr, pos)=>{
    const endOfDocPos = tr.doc.nodeSize - 2;
    if (pos <= endOfDocPos) {
        const resolvedPos = tr.doc.resolve(pos);
        const backwardSelection = (0, $ks2lK.Selection).findFrom(resolvedPos, -1, true);
        // if there's no correct cursor position before the `pos`, we try to find it after the `pos`
        const forwardSelection = (0, $ks2lK.Selection).findFrom(resolvedPos, 1, true);
        return backwardSelection ? backwardSelection.from : forwardSelection ? forwardSelection.from : pos;
    }
    return endOfDocPos;
};
class $c84f494477793052$export$d8e4bc17e84598c5 {
    get decorations() {
        return this.decorationSet;
    }
    get activeParticipants() {
        return this.participants;
    }
    get sessionId() {
        return this.sid;
    }
    getFullName(sessionId) {
        const participant = this.participants.get(sessionId);
        return participant ? participant.name : 'X';
    }
    getInitial(sessionId) {
        return this.getFullName(sessionId).substring(0, 1).toUpperCase();
    }
    getPresenceId(sessionId) {
        const participant = this.participants.get(sessionId);
        return participant?.presenceId ?? sessionId;
    }
    apply(tr) {
        // Ignored via go/ees005
        // eslint-disable-next-line prefer-const
        let { participants: participants, sid: sid, isReady: isReady } = this;
        const presenceData = tr.getMeta('presence');
        const telepointerData = tr.getMeta('telepointer');
        const nudgeTelepointerData = tr.getMeta('nudgeTelepointer');
        const sessionIdData = tr.getMeta('sessionId');
        let collabInitialised = tr.getMeta('collabInitialised');
        if (typeof collabInitialised !== 'boolean') collabInitialised = isReady;
        if (sessionIdData) sid = sessionIdData.sid;
        let add = [];
        let remove = [];
        if (presenceData) {
            const { joined: joined = [], left: left = [] } = presenceData;
            participants = participants.remove(left.map((i)=>i.sessionId));
            participants = participants.add(joined);
            // Remove telepointers for users that left
            left.forEach((i)=>{
                const pointers = (0, $eJriO.findPointers)(this.getPresenceId(i.sessionId), this.decorationSet);
                if (pointers) remove = remove.concat(pointers);
            });
        }
        if (telepointerData) {
            const { sessionId: sessionId } = telepointerData;
            if (participants.get(sessionId) && sessionId !== sid) {
                const oldPointers = (0, $eJriO.findPointers)(this.getPresenceId(sessionId), this.decorationSet);
                if (oldPointers) remove = remove.concat(oldPointers);
                const endOfDocPos = tr.doc.nodeSize - 2;
                const anchor = telepointerData.selection.anchor;
                const head = telepointerData.selection.head;
                let rawFrom = anchor < head ? anchor : head;
                let rawTo = anchor >= head ? anchor : head;
                if (rawFrom > endOfDocPos) rawFrom = endOfDocPos;
                if (rawTo > endOfDocPos) rawTo = endOfDocPos;
                const isSelection = rawTo - rawFrom > 0;
                let from = 1;
                let to = 1;
                try {
                    from = $c84f494477793052$export$1e860daa85a829a5(tr, isSelection ? Math.max(rawFrom, 0) : rawFrom);
                    to = isSelection ? $c84f494477793052$export$1e860daa85a829a5(tr, rawTo) : from;
                } catch (err) {
                    this.onError(err);
                }
                add = add.concat((0, $eJriO.createTelepointers)(from, to, sessionId, isSelection, this.getInitial(sessionId), this.getPresenceId(sessionId), this.getFullName(sessionId), (0, $eJriO.hasExistingNudge)(sessionId, this.nudgeAnimations)));
            }
        }
        if (tr.docChanged) {
            // Adjust decoration positions to changes made by the transaction
            try {
                this.decorationSet = this.decorationSet.map(tr.mapping, tr.doc, {
                    // Reapplies decorators those got removed by the state change
                    onRemove: (spec)=>{
                        if (spec.pointer && spec.pointer.sessionId && spec.key === `telepointer-${spec.pointer.sessionId}`) {
                            const step = tr.steps.filter((0, $eJriO.isReplaceStep))[0];
                            if (step) {
                                const { sessionId: sessionId, presenceId: presenceId } = spec.pointer;
                                const { slice: { content: { size: size } }, from: from } = step;
                                const pos = $c84f494477793052$export$1e860daa85a829a5(tr, size ? Math.min(from + size, tr.doc.nodeSize - 3) : Math.max(from, 1));
                                add = add.concat((0, $eJriO.createTelepointers)(pos, pos, sessionId, false, this.getInitial(sessionId), presenceId, this.getFullName(sessionId), (0, $eJriO.hasExistingNudge)(sessionId, this.nudgeAnimations)));
                            }
                        }
                    }
                });
            } catch (err) {
                this.onError(err);
            }
            if (!(0, $dh538.fg)('platform_editor_ai_generic_prep_for_aifc')) // Remove any selection decoration within the change range,
            // takes care of the issue when after pasting we end up with a dead selection
            tr.steps.filter((0, $eJriO.isReplaceStep)).forEach((s)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const { from: from, to: to } = s;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.decorationSet.find(from, to).forEach((deco)=>{
                    // `type` is private, `from` and `to` are public in latest version
                    // `from` != `to` means it's a selection
                    if (deco.from !== deco.to) remove.push(deco);
                });
            });
        }
        const { selection: selection } = tr;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.decorationSet.find().forEach((deco)=>{
            if (deco.type.toDOM) {
                const hasTelepointerDimClass = deco.type.toDOM.classList.contains((0, $h3X17.TELEPOINTER_DIM_CLASS));
                const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
                if (deco.from === selection.from && deco.to === selection.to) {
                    if (!hasTelepointerDimClass) deco.type.toDOM.classList.add((0, $h3X17.TELEPOINTER_DIM_CLASS));
                    // Browser condition here to fix ED-14722 where telepointer
                    // decorations with side -1 in Firefox causes backspace issues.
                    // This is likely caused by contenteditable quirks in Firefox
                    if (!browser.gecko) deco.type.side = -1;
                } else {
                    if (hasTelepointerDimClass) deco.type.toDOM.classList.remove((0, $h3X17.TELEPOINTER_DIM_CLASS));
                    deco.type.side = 0;
                }
            }
        });
        if (nudgeTelepointerData) {
            const nudgeSessionId = nudgeTelepointerData?.sessionId;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.decorationSet.find().forEach((deco)=>{
                if (deco.type.toDOM && participants.get(nudgeSessionId) && deco.spec?.pointer?.sessionId === nudgeSessionId && deco.spec?.key === `telepointer-${nudgeSessionId}`) {
                    // Restart animation by removing and re-adding the class
                    deco.type.toDOM.classList.remove((0, $h3X17.TELEPOINTER_PULSE_DURING_TR_CLASS));
                    deco.type.toDOM.classList.remove((0, $h3X17.TELEPOINTER_PULSE_CLASS));
                    deco.type.toDOM.offsetWidth; // Force reflow
                    deco.type.toDOM.classList.add((0, $h3X17.TELEPOINTER_PULSE_CLASS));
                    this.nudgeAnimations.set(nudgeSessionId, Date.now());
                }
            });
        }
        if (remove.length) this.decorationSet = this.decorationSet.remove(remove);
        if (add.length) this.decorationSet = this.decorationSet.add(tr.doc, add);
        // This piece needs to be after the decorationSet adjustments,
        // otherwise it's always one step behind where the cursor is
        if (telepointerData) {
            const { sessionId: sessionId } = telepointerData;
            if (participants.get(sessionId)) {
                const positionForScroll = (0, $eJriO.getPositionOfTelepointer)(sessionId, this.decorationSet);
                if (positionForScroll) participants = participants.updateCursorPos(sessionId, positionForScroll);
            }
        }
        const nextState = new $c84f494477793052$export$d8e4bc17e84598c5(this.decorationSet, participants, sid, collabInitialised, this.onError, this.nudgeAnimations);
        return $c84f494477793052$export$d8e4bc17e84598c5.eq(nextState, this) ? this : nextState;
    }
    static eq(a, b) {
        return a.participants === b.participants && a.sessionId === b.sessionId && a.isReady === b.isReady;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static init(config) {
        const { doc: doc, onError: onError } = config;
        return new $c84f494477793052$export$d8e4bc17e84598c5((0, $ftzrq.DecorationSet).create(doc, []), new (0, $eJL1T.Participants)(), undefined, undefined, onError);
    }
    constructor(decorations, participants, sessionId, collabInitalised = false, onError, nudgeAnimations = new Map()){
        this.decorationSet = void 0;
        this.participants = void 0;
        this.nudgeAnimations = void 0;
        // eslint-disable-next-line no-console
        this.onError = (error)=>console.error(error);
        this.sid = void 0;
        this.isReady = void 0;
        this.decorationSet = decorations;
        this.participants = participants;
        this.sid = sessionId;
        this.isReady = collabInitalised;
        this.onError = onError || this.onError;
        this.nudgeAnimations = nudgeAnimations;
    }
}
module.exports["PluginState"] = $c84f494477793052$export$d8e4bc17e84598c5;

});

parcelRegister("eJL1T", function(module, exports) {
class $4ac32b234017c082$export$3ebbcd8e174d58e4 {
    add(data) {
        const newSet = new Map(this.participants);
        data.forEach((participant)=>{
            newSet.set(participant.sessionId, participant);
        });
        return new $4ac32b234017c082$export$3ebbcd8e174d58e4(newSet);
    }
    remove(sessionIds) {
        const newSet = new Map(this.participants);
        sessionIds.forEach((sessionId)=>{
            newSet.delete(sessionId);
        });
        return new $4ac32b234017c082$export$3ebbcd8e174d58e4(newSet);
    }
    update(sessionId, lastActive) {
        const newSet = new Map(this.participants);
        const data = newSet.get(sessionId);
        if (!data) return this;
        newSet.set(sessionId, {
            ...data,
            lastActive: lastActive
        });
        return new $4ac32b234017c082$export$3ebbcd8e174d58e4(newSet);
    }
    updateCursorPos(sessionId, cursorPos) {
        const newSet = new Map(this.participants);
        const data = newSet.get(sessionId);
        if (!data) return this;
        newSet.set(sessionId, {
            ...data,
            cursorPos: cursorPos
        });
        return new $4ac32b234017c082$export$3ebbcd8e174d58e4(newSet);
    }
    toArray() {
        return Array.from(this.participants.values());
    }
    get(sessionId) {
        return this.participants.get(sessionId);
    }
    size() {
        return this.participants.size;
    }
    eq(other) {
        const left = this.toArray().map((p)=>p.sessionId).sort((a, b)=>a > b ? -1 : 1).join('');
        const right = other.toArray().map((p)=>p.sessionId).sort((a, b)=>a > b ? -1 : 1).join('');
        return left === right;
    }
    constructor(participants = new Map()){
        this.participants = void 0;
        this.participants = participants;
    }
}
module.exports["Participants"] = $4ac32b234017c082$export$3ebbcd8e174d58e4;

});

parcelRegister("4jbak", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $9NwnH = parcelRequire("9NwnH");


var $1oCLl = parcelRequire("1oCLl");

const $535e7c47bdfe9cbe$var$isLocked = (step)=>{
    if (step.origin instanceof (0, $ks2lK.Transaction)) return step.origin.getMeta('mergeIsLocked');
    return false;
};
function $535e7c47bdfe9cbe$export$8e3092acded15d5d(steps, api) {
    const mergedSteps = steps.reduce((acc, rebaseable)=>{
        const lastStep = acc[acc.length - 1];
        const isOffline = api?.connectivity?.sharedState.currentState()?.mode === 'offline';
        const isOnlineMergeEnabled = (0, $1oCLl.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true);
        const isMergingEnabled = isOffline || isOnlineMergeEnabled;
        if (isMergingEnabled && lastStep && !$535e7c47bdfe9cbe$var$isLocked(lastStep) && !$535e7c47bdfe9cbe$var$isLocked(rebaseable)) {
            const mergedStep = lastStep.step.merge(rebaseable.step);
            const inverted = rebaseable.inverted.merge(lastStep.inverted);
            // Always take the origin of the new step.
            // We use this in packages/editor/collab-provider/src/document/document-service.ts:commitUnconfirmedSteps
            // to confirm that the last transaction has been sent. Since we're taking the latest this still works as expected
            // As we want to wait until all the transactions have been pushed through
            const origin = lastStep.origin;
            if (mergedStep && inverted) {
                acc[acc.length - 1] = new (0, $9NwnH.Rebaseable)(mergedStep, inverted, origin instanceof (0, $ks2lK.Transaction) ? origin.setMeta('isOffline', origin.getMeta('isOffline') === true || isOffline) : origin);
                return acc;
            }
        }
        acc.push(new (0, $9NwnH.Rebaseable)(rebaseable.step, rebaseable.inverted, rebaseable.origin instanceof (0, $ks2lK.Transaction) ? rebaseable.origin.setMeta('isOffline', rebaseable.origin.getMeta('isOffline') === true || isOffline) : rebaseable.origin));
        return acc;
    }, []);
    return mergedSteps;
}
module.exports["mergeUnconfirmedSteps"] = $535e7c47bdfe9cbe$export$8e3092acded15d5d;

});

parcelRegister("7TpBw", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $7ad60ed4c4777fb2$var$nativeCollabProviderPluginKey = new (0, $ks2lK.PluginKey)('nativeCollabProviderPlugin');
const $7ad60ed4c4777fb2$export$ad653665b59b3ffd = ({ providerPromise: providerPromise })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $7ad60ed4c4777fb2$var$nativeCollabProviderPluginKey,
        state: {
            init: ()=>null,
            apply: (tr, currentPluginState)=>{
                const provider = tr.getMeta($7ad60ed4c4777fb2$var$nativeCollabProviderPluginKey);
                return provider ? provider : currentPluginState;
            }
        },
        view: (editorView)=>{
            providerPromise.then((provider)=>{
                const { dispatch: dispatch, state: state } = editorView;
                const tr = state.tr;
                tr.setMeta($7ad60ed4c4777fb2$var$nativeCollabProviderPluginKey, provider);
                dispatch(tr);
            });
            return {};
        }
    });
};
const $7ad60ed4c4777fb2$export$82feb779db31f396 = (editorState)=>{
    return $7ad60ed4c4777fb2$var$nativeCollabProviderPluginKey.getState(editorState);
};
module.exports["nativeCollabProviderPlugin"] = $7ad60ed4c4777fb2$export$ad653665b59b3ffd;

});

parcelRegister("hp1nS", function(module, exports) {

var $jy7VG = parcelRequire("jy7VG");

var $cuprm = parcelRequire("cuprm");

var $8EkET = parcelRequire("8EkET");

var $9YoeD = parcelRequire("9YoeD");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");

const $e93f8b61e819792a$var$THRESHOLD = 50; // 50 milliseconds
const $e93f8b61e819792a$export$2d791416d1075a3b = (step)=>{
    const serializedStep = step.toJSON();
    const sanitizedStep = {
        stepType: serializedStep.stepType,
        stepInstance: 'unknown'
    };
    if (step instanceof (0, $aXG5V.AttrStep)) {
        sanitizedStep.attr = step.attr;
        sanitizedStep.stepInstance = 'AttrStep';
    } else if (step instanceof (0, $aXG5V.DocAttrStep)) {
        sanitizedStep.attr = step.attr;
        sanitizedStep.stepInstance = 'DocAttrStep';
    } else if (step instanceof (0, $9YoeD.SetAttrsStep)) {
        // Combines all attrs keys separated by _ to one single string
        sanitizedStep.attr = Object.keys(step.attrs).sort().join('_');
        sanitizedStep.stepInstance = 'SetAttrsStep';
    } else if (step instanceof (0, $aXG5V.AddMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'AddMarkStep';
    } else if (step instanceof (0, $aXG5V.RemoveMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'RemoveMarkStep';
    } else if (step instanceof (0, $aXG5V.RemoveNodeMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'RemoveNodeMarkStep';
    } else if (step instanceof (0, $aXG5V.AddNodeMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'AddNodeMarkStep';
    } else if (step instanceof (0, $aXG5V.ReplaceStep)) sanitizedStep.stepInstance = 'ReplaceStep';
    else if (step instanceof (0, $aXG5V.ReplaceAroundStep)) sanitizedStep.stepInstance = 'ReplaceAroundStep';
    else if (step instanceof (0, $jy7VG.AnalyticsStep)) sanitizedStep.stepInstance = 'AnalyticsStep';
    else if (step instanceof (0, $cuprm.InsertTypeAheadStep)) sanitizedStep.stepInstance = 'InsertTypeAheadStep';
    else if (step instanceof (0, $8EkET.LinkMetaStep)) sanitizedStep.stepInstance = 'LinkMetaStep';
    return sanitizedStep;
};
const $e93f8b61e819792a$export$4bff6ad17bbfeba7 = (recentTransactionsTimestamps, trackFilteredTransaction)=>{
    return (tr)=>{
        if (Boolean(tr.getMeta('appendTransaction'))) return true;
        const isRemote = Boolean(tr.getMeta('isRemote'));
        if (isRemote) return true;
        const containsExcludedSteps = tr.steps.some((step)=>{
            return step instanceof (0, $jy7VG.AnalyticsStep) || step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep) || step instanceof (0, $8EkET.LinkMetaStep);
        });
        if (containsExcludedSteps) return true;
        if (tr.docChanged && tr.doc.eq(tr.before)) {
            const transactionKey = $e93f8b61e819792a$export$16b712be60324104(tr);
            if (!transactionKey) return true;
            //Clean up tracked transactions when time over threshold
            recentTransactionsTimestamps.forEach((value, key)=>{
                if (tr.time - value.timestamp > $e93f8b61e819792a$var$THRESHOLD) // Delete tracked transaction when over threshold
                recentTransactionsTimestamps.delete(key);
            });
            const lastTransactionEntry = recentTransactionsTimestamps.get(transactionKey);
            if (!lastTransactionEntry) {
                // If no timestamp exists for the given transaction, allow transaction and add an entry
                recentTransactionsTimestamps.set(transactionKey, {
                    timestamp: tr.time,
                    steps: tr.steps
                });
                return true;
            }
            // Track analytics for the filtered transaction
            trackFilteredTransaction(tr);
            // Filter transaction
            return false;
        }
        return true; // Allow the transaction
    };
};
function $e93f8b61e819792a$export$16b712be60324104(tr) {
    const stepPositions = tr.steps.map((step)=>{
        if (step instanceof (0, $aXG5V.RemoveNodeMarkStep) || step instanceof (0, $aXG5V.AddNodeMarkStep) || step instanceof (0, $9YoeD.SetAttrsStep) || step instanceof (0, $aXG5V.AttrStep)) {
            if (step.pos !== undefined) return `${step.pos}`;
        } else if (step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep)) return `from_${step.from}_to_${step.to}`;
        else if (step instanceof (0, $cuprm.InsertTypeAheadStep)) return `insertTypeAheadStep`;
        return '';
    });
    if (stepPositions.some((step)=>Boolean(step))) return stepPositions.join('_');
    return '';
}
const $e93f8b61e819792a$export$ea2d2436326e1247 = new (0, $ks2lK.PluginKey)('trackAndFilterSpammingStepsPluginKey');
const $e93f8b61e819792a$export$ae829ec7b2625219 = (trackFilteredTransaction)=>{
    const recentTransactionsTimestamps = new Map();
    return new (0, $1S4f7.SafePlugin)({
        key: $e93f8b61e819792a$export$ea2d2436326e1247,
        filterTransaction: $e93f8b61e819792a$export$4bff6ad17bbfeba7(recentTransactionsTimestamps, trackFilteredTransaction)
    });
};
module.exports["sanitizeFilteredStep"] = $e93f8b61e819792a$export$2d791416d1075a3b;
module.exports["createPlugin"] = $e93f8b61e819792a$export$ae829ec7b2625219;

});

parcelRegister("5GGNA", function(module, exports) {

var $h3X17 = parcelRequire("h3X17");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $eJriO = parcelRequire("eJriO");

const $c97c8d128269dcfd$export$e968e014d3efd8b6 = new (0, $ks2lK.PluginKey)('collabTrackLastOrganicChangePlugin');
const $c97c8d128269dcfd$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $c97c8d128269dcfd$export$e968e014d3efd8b6,
        state: {
            init () {
                return {
                    lastLocalOrganicChangeAt: null,
                    lastRemoteOrganicChangeAt: null,
                    lastLocalOrganicBodyChangeAt: null,
                    lastRemoteOrganicBodyChangeAt: null
                };
            },
            apply (transaction, prevPluginState) {
                if (Boolean(transaction.getMeta('appendedTransaction'))) return prevPluginState;
                const isRemote = Boolean(transaction.getMeta('isRemote'));
                const isDocumentReplaceFromRemote = isRemote && Boolean(transaction.getMeta('replaceDocument'));
                // Inline comment annotations are not considered as edits to the document body
                const isAnnotationStep = !!transaction.steps.find((step)=>(step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep)) && step.mark?.type?.name === 'annotation');
                if (isDocumentReplaceFromRemote) return prevPluginState;
                if ((0, $h3X17.isDirtyTransaction)(transaction)) return prevPluginState;
                if ((0, $eJriO.isOrganicChange)(transaction)) {
                    if (isRemote) return {
                        lastLocalOrganicChangeAt: prevPluginState.lastLocalOrganicChangeAt,
                        lastRemoteOrganicChangeAt: Date.now(),
                        lastLocalOrganicBodyChangeAt: prevPluginState.lastLocalOrganicBodyChangeAt,
                        lastRemoteOrganicBodyChangeAt: isAnnotationStep ? prevPluginState.lastRemoteOrganicBodyChangeAt : Date.now()
                    };
                    return {
                        lastLocalOrganicChangeAt: Date.now(),
                        lastRemoteOrganicChangeAt: prevPluginState.lastRemoteOrganicChangeAt,
                        lastLocalOrganicBodyChangeAt: isAnnotationStep ? prevPluginState.lastLocalOrganicBodyChangeAt : Date.now(),
                        lastRemoteOrganicBodyChangeAt: prevPluginState.lastRemoteOrganicBodyChangeAt
                    };
                }
                return prevPluginState;
            }
        }
    });
};
module.exports["trackLastOrganicChangePluginKey"] = $c97c8d128269dcfd$export$e968e014d3efd8b6;
module.exports["createPlugin"] = $c97c8d128269dcfd$export$ae829ec7b2625219;

});

parcelRegister("47Xfp", function(module, exports) {

var $h3X17 = parcelRequire("h3X17");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $eJriO = parcelRequire("eJriO");

const $1bf8747c56e383f6$export$a79cdfb4b852386b = new (0, $ks2lK.PluginKey)('collabTrackNCSInitializationPlugin');
const $1bf8747c56e383f6$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $1bf8747c56e383f6$export$a79cdfb4b852386b,
        state: {
            init () {
                return {
                    collabInitialisedAt: null,
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null
                };
            },
            apply (transaction, prevPluginState, oldState) {
                if (Boolean(transaction.getMeta('collabInitialised'))) return {
                    collabInitialisedAt: Date.now(),
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null
                };
                const shouldCheckDocument = prevPluginState.collabInitialisedAt && !prevPluginState.firstContentBodyChangeAfterInitAt;
                if (!shouldCheckDocument) return prevPluginState;
                const isRemote = (0, $eJriO.originalTransactionHasMeta)(transaction, 'isRemote');
                const isDocumentReplaceFromRemote = isRemote && (0, $eJriO.originalTransactionHasMeta)(transaction, 'replaceDocument');
                if (isDocumentReplaceFromRemote) return prevPluginState;
                if ((0, $h3X17.isDirtyTransaction)(transaction)) return prevPluginState;
                if (transaction.docChanged && !transaction.doc.eq(oldState.doc)) {
                    // For analytics purposes, inline comment annotations are not considered as edits to the document body
                    // Transaction may contain other steps, but we know that they won't be user-generated (non synthetic) steps
                    // Additionally, for analytics purposes we do not want to trigger on other participants' changes (i.e. remote changes)
                    const isAnnotationStep = !!transaction.steps.find((step)=>step instanceof (0, $aXG5V.AddMarkStep) && step.mark?.type?.name === 'annotation');
                    return {
                        collabInitialisedAt: prevPluginState.collabInitialisedAt,
                        firstChangeAfterInitAt: Date.now(),
                        firstContentBodyChangeAfterInitAt: isAnnotationStep || isRemote ? prevPluginState.firstContentBodyChangeAfterInitAt : Date.now()
                    };
                }
                return prevPluginState;
            }
        },
        props: {
            attributes (editorState) {
                const trackPluginState = $1bf8747c56e383f6$export$a79cdfb4b852386b.getState(editorState);
                return {
                    ['data-has-collab-initialised']: `${Boolean(trackPluginState?.collabInitialisedAt)}`
                };
            }
        }
    });
};
module.exports["trackNCSInitializationPluginKey"] = $1bf8747c56e383f6$export$a79cdfb4b852386b;
module.exports["createPlugin"] = $1bf8747c56e383f6$export$ae829ec7b2625219;

});

parcelRegister("1FwZj", function(module, exports) {

var $jy7VG = parcelRequire("jy7VG");

var $7Mtx3 = parcelRequire("7Mtx3");

var $9YoeD = parcelRequire("9YoeD");


var $aXG5V = parcelRequire("aXG5V");


var $9NwnH = parcelRequire("9NwnH");


var $iu6m9 = parcelRequire("iu6m9");


var $9tLNt = parcelRequire("9tLNt");

function $1d34501b5af9fe4b$var$groupBy(array, keyGetter) {
    // Check group by exists, and that it's a function. If so, use the native browser code
    if ('groupBy' in Object && typeof Object.groupBy === 'function') // @ts-ignore TS2322 - Type 'Partial<Record<string, T[]>>' is not assignable to type 'Record<string, T[]>'.
    return Object.groupBy(array, keyGetter);
    // Fallback to custom implementation
    const map = {};
    array.forEach((item)=>{
        const key = keyGetter(item);
        if (!map[key]) map[key] = [];
        map[key].push(item);
    });
    return map;
}
const $1d34501b5af9fe4b$export$685b976035d234a6 = (step)=>{
    const serializedStep = step.toJSON();
    const sanitizedStep = {
        stepType: serializedStep.stepType
    };
    if (step instanceof (0, $aXG5V.AttrStep) || step instanceof (0, $aXG5V.DocAttrStep)) sanitizedStep.attr = step.attr;
    else if (step instanceof (0, $9YoeD.SetAttrsStep)) // Combines all attrs keys separated by _ to one single string
    sanitizedStep.attr = Object.keys(step.attrs).sort().join('_');
    else if (step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep) || step instanceof (0, $aXG5V.RemoveNodeMarkStep) || step instanceof (0, $aXG5V.AddNodeMarkStep)) sanitizedStep.markType = step.mark.type.name;
    else if (step instanceof (0, $7Mtx3.BatchAttrsStep)) {
        const batched = step.data.map(({ nodeType: nodeType, attrs: attrs })=>`${nodeType}_${Object.keys(attrs).sort().join('_')}`);
        sanitizedStep.attr = batched.sort().join('_');
    }
    return sanitizedStep;
};
const $1d34501b5af9fe4b$export$cb21deee7d469afa = (sanitizedSteps)=>{
    const grouped = $1d34501b5af9fe4b$var$groupBy(sanitizedSteps, (e)=>Object.values(e).join('_'));
    return Object.entries(grouped).reduce((acc, [key, value])=>{
        acc[key] = Array.isArray(value) ? value.length : 0;
        return acc;
    }, {});
};
const $1d34501b5af9fe4b$export$94e939b87ca64fb4 = (cache, onTrackDataProcessed)=>{
    const stepsMetadata = [];
    for (const entry of cache.values()){
        const { startedAt: startedAt, endedAt: endedAt, steps: steps } = entry;
        const stepTypesAmount = $1d34501b5af9fe4b$export$cb21deee7d469afa(steps.map($1d34501b5af9fe4b$export$685b976035d234a6));
        stepsMetadata.push({
            startedAt: startedAt,
            endedAt: endedAt,
            stepTypesAmount: stepTypesAmount
        });
    }
    cache.clear();
    if (stepsMetadata.length > 0) onTrackDataProcessed(stepsMetadata);
};
const $1d34501b5af9fe4b$var$stepsSentCache = new Map();
// Every ten seconds we will try to process the step data.
const $1d34501b5af9fe4b$var$LOW_PRIORITY_DELAY = 10000;
const $1d34501b5af9fe4b$var$getScheduler = (// Our TypeScript configuration isn't ready for the Scheduler API https://developer.mozilla.org/en-US/docs/Web/API/Scheduler/ (yet)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
obj)=>{
    if (!obj) return null;
    if ('scheduler' in obj) return obj.scheduler;
    return null;
};
const $1d34501b5af9fe4b$export$6b2a7d5132615086 = ({ api: api, newEditorState: newEditorState, transactions: transactions, onTrackDataProcessed: onTrackDataProcessed })=>{
    const newSteps = transactions.flatMap((t)=>t.steps);
    const collabState = (0, $9NwnH.sendableSteps)(newEditorState);
    const scheduler = $1d34501b5af9fe4b$var$getScheduler(window);
    if (!newSteps.length || !scheduler || !collabState) return;
    const { version: version } = collabState;
    const buffer = $1d34501b5af9fe4b$var$stepsSentCache.get(version);
    const startedAt = buffer?.startedAt || Date.now();
    const endedAt = Date.now();
    const steps = (buffer?.steps || []).concat(newSteps);
    $1d34501b5af9fe4b$var$stepsSentCache.set(version, {
        startedAt: startedAt,
        endedAt: endedAt,
        steps: steps
    });
    (0, $9tLNt.updateNcsSessionStepMetrics)({
        api: api,
        steps: (0, $iu6m9.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true) ? newSteps.filter((step)=>!(step instanceof (0, $jy7VG.AnalyticsStep))) : newSteps
    });
    scheduler.postTask(()=>{
        $1d34501b5af9fe4b$export$94e939b87ca64fb4($1d34501b5af9fe4b$var$stepsSentCache, onTrackDataProcessed);
    }, {
        priority: 'background',
        delay: $1d34501b5af9fe4b$var$LOW_PRIORITY_DELAY
    });
};
module.exports["track"] = $1d34501b5af9fe4b$export$6b2a7d5132615086;

});

parcelRegister("9tLNt", function(module, exports) {

var $25jxS = parcelRequire("25jxS");


var $kt8c2 = parcelRequire("kt8c2");

const $fc787c08799122c8$var$storageClient = new (0, $kt8c2.default)((0, $25jxS.NCS_STORAGE).NCS_STORAGE_CLIENT_KEY);
const $fc787c08799122c8$export$4fe9abcf7996805c = (metrics, sessionId, steps)=>{
    const current = metrics[sessionId] ?? {
        ncsSessionId: sessionId,
        totalStepSize: 0,
        numberOfSteps: 0,
        maxStepSize: 0,
        stepSizeSumForP90: []
    };
    steps.forEach((step)=>{
        const stepSize = JSON.stringify(step).length;
        current.totalStepSize += stepSize;
        current.numberOfSteps += 1;
        current.maxStepSize = Math.max(current.maxStepSize, stepSize || 0);
        current.stepSizeSumForP90.push(stepSize || 0);
    });
    return current;
};
const $fc787c08799122c8$export$bc7fe0d8ce4c3c0a = (sessionId)=>{
    const currentActiveSessions = JSON.parse($fc787c08799122c8$var$storageClient.getItem((0, $25jxS.NCS_STORAGE).NCS_ACTIVE_SESSIONS) || '{}');
    if (!currentActiveSessions[sessionId]) $fc787c08799122c8$var$storageClient.setItemWithExpiry((0, $25jxS.NCS_STORAGE).NCS_ACTIVE_SESSIONS, JSON.stringify({
        ...currentActiveSessions,
        [sessionId]: true
    }));
};
const $fc787c08799122c8$export$defdcaf9cc1c87fe = ({ api: api, steps: steps })=>{
    const sessionId = api?.collabEdit?.sharedState.currentState()?.sessionId;
    if (!sessionId) return;
    const existingMetrics = JSON.parse($fc787c08799122c8$var$storageClient.getItem((0, $25jxS.NCS_STORAGE).NCS_SESSION_STEP_METRICS) || '{}');
    const ncsSessionStepMetrics = $fc787c08799122c8$export$4fe9abcf7996805c(existingMetrics, sessionId, steps);
    $fc787c08799122c8$var$storageClient.setItemWithExpiry((0, $25jxS.NCS_STORAGE).NCS_SESSION_STEP_METRICS, JSON.stringify({
        ...existingMetrics,
        [sessionId]: ncsSessionStepMetrics
    }));
    $fc787c08799122c8$export$bc7fe0d8ce4c3c0a(sessionId);
};
module.exports["updateNcsSessionStepMetrics"] = $fc787c08799122c8$export$defdcaf9cc1c87fe;

});

parcelRegister("efDik", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3EiOU = parcelRequire("3EiOU");

var $8WAFY = parcelRequire("8WAFY");


var $2UWDO = parcelRequire("2UWDO");


var $3pLGZ = parcelRequire("3pLGZ");


var $lEQpi = parcelRequire("lEQpi");


var $5nBzc = parcelRequire("5nBzc");


var $57Qac = parcelRequire("57Qac");


var $9Oj2R = parcelRequire("9Oj2R");


var $c8abs = parcelRequire("c8abs");


var $cqOa3 = parcelRequire("cqOa3");


var $hqAnd = parcelRequire("hqAnd");


var $kEJjT = parcelRequire("kEJjT");


var $aF0RF = parcelRequire("aF0RF");


var $ckjkT = parcelRequire("ckjkT");


var $89DY6 = parcelRequire("89DY6");

const $5a980f14a84d493f$export$4567b5886e253c5a = ({ config: config, api: api })=>{
    const syncBlockStore = new (0, $lEQpi.SyncBlockStoreManager)(config?.syncBlockDataProvider, api?.analytics?.actions?.fireAnalyticsEvent);
    api?.blockMenu?.actions.registerBlockMenuComponents((0, $cqOa3.getBlockMenuComponents)(api));
    api?.toolbar?.actions.registerComponents((0, $89DY6.getToolbarComponents)(api));
    return {
        name: 'syncedBlock',
        nodes () {
            return [
                {
                    name: 'syncBlock',
                    node: (0, $8WAFY.syncBlock)
                },
                {
                    name: 'bodiedSyncBlock',
                    node: (0, $3EiOU.bodiedSyncBlock)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'syncedBlockPlugin',
                    plugin: (params)=>(0, $c8abs.createPlugin)(config, params, syncBlockStore, api)
                }
            ];
        },
        commands: {
            copySyncedBlockReferenceToClipboard: ()=>(0, $9Oj2R.copySyncedBlockReferenceToClipboardEditorCommand)(syncBlockStore, api),
            insertSyncedBlock: ()=>({ tr: tr })=>(0, $9Oj2R.createSyncedBlock)({
                        tr: tr,
                        syncBlockStore: syncBlockStore
                    }) || null
        },
        actions: {
            flushBodiedSyncBlocks: ()=>{
                return (0, $57Qac.flushBodiedSyncBlocks)(syncBlockStore);
            },
            flushSyncedBlocks: ()=>{
                return (0, $57Qac.flushSyncBlocks)(syncBlockStore);
            }
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'syncBlock',
                        title: formatMessage((0, $2UWDO.messages).syncedBlock),
                        description: formatMessage((0, $2UWDO.messages).syncedBlockDescription),
                        priority: 800,
                        keywords: [
                            'synced',
                            'block',
                            'synced-block',
                            'sync',
                            'sync-block',
                            'auto',
                            'update',
                            'excerpt',
                            'connect'
                        ],
                        isDisabledOffline: true,
                        keyshortcut: '',
                        lozenge: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                            appearance: "new",
                            children: formatMessage((0, $2UWDO.messages).newLozenge)
                        }),
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconSyncBlock), {
                                label: formatMessage((0, $2UWDO.messages).syncedBlock)
                            }),
                        action: (insert, state)=>{
                            return (0, $9Oj2R.createSyncedBlock)({
                                tr: state.tr,
                                syncBlockStore: syncBlockStore,
                                typeAheadInsert: insert
                            });
                        }
                    }
                ],
            floatingToolbar: (state, intl)=>(0, $aF0RF.getToolbarConfig)(state, intl, api, syncBlockStore)
        },
        contentComponent: ()=>{
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ckjkT.SyncBlockRefresher), {
                        syncBlockStoreManager: syncBlockStore,
                        api: api
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $hqAnd.DeleteConfirmationModal), {
                        syncBlockStoreManager: syncBlockStore,
                        api: api
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kEJjT.Flag), {
                        api: api
                    })
                ]
            });
        },
        getSharedState: (editorState)=>{
            if (!editorState) return;
            const { activeFlag: activeFlag, syncBlockStore: currentSyncBlockStore, bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus } = (0, $c8abs.syncedBlockPluginKey).getState(editorState);
            return {
                activeFlag: activeFlag,
                syncBlockStore: currentSyncBlockStore,
                bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus
            };
        }
    };
};
module.exports["syncedBlockPlugin"] = $5a980f14a84d493f$export$4567b5886e253c5a;

});

parcelRegister("57Qac", function(module, exports) {
const $4d87990c851ea68d$export$809659ed37baae65 = (syncBlockStore)=>{
    return syncBlockStore.sourceManager.flush();
};
const $4d87990c851ea68d$export$42389f194734952a = (syncBlockStore)=>{
    return syncBlockStore.referenceManager.flush();
};
module.exports["flushBodiedSyncBlocks"] = $4d87990c851ea68d$export$809659ed37baae65;
module.exports["flushSyncBlocks"] = $4d87990c851ea68d$export$42389f194734952a;

});

parcelRegister("9Oj2R", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $kgnzE = parcelRequire("kgnzE");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $c8abs = parcelRequire("c8abs");


var $8MdFm = parcelRequire("8MdFm");


var $cEH8b = parcelRequire("cEH8b");

const $81d4226bf8406331$export$fbc30658d812c800 = ({ tr: tr, syncBlockStore: syncBlockStore, typeAheadInsert: typeAheadInsert })=>{
    const { schema: { nodes: { bodiedSyncBlock: bodiedSyncBlock, paragraph: paragraph } } } = tr.doc.type;
    // If the selection is empty, we want to insert the sync block on a new line
    if (tr.selection.empty) {
        const attrs = syncBlockStore.sourceManager.generateBodiedSyncBlockAttrs();
        const paragraphNode = paragraph.createAndFill({});
        const newBodiedSyncBlockNode = bodiedSyncBlock.createAndFill(attrs, paragraphNode ? [
            paragraphNode
        ] : []);
        if (!newBodiedSyncBlockNode) return false;
        // Save the new node with empty content to backend
        // This is so that the node can be copied and referenced without the source being saved/published
        syncBlockStore.sourceManager.createBodiedSyncBlockNode(attrs);
        if (typeAheadInsert) tr = typeAheadInsert(newBodiedSyncBlockNode);
        else tr = (0, $8m4tT.safeInsert)(newBodiedSyncBlockNode)(tr).scrollIntoView();
    } else {
        const conversionInfo = (0, $8MdFm.canBeConvertedToSyncBlock)(tr.selection);
        if (!conversionInfo) // TODO: EDITOR-1665 - Raise an error analytics event
        return false;
        const attrs = syncBlockStore.sourceManager.generateBodiedSyncBlockAttrs();
        const newBodiedSyncBlockNode = bodiedSyncBlock.createAndFill(attrs, conversionInfo.contentToInclude);
        if (!newBodiedSyncBlockNode) return false;
        // Save the new node with empty content to backend
        // This is so that the node can be copied and referenced without the source being saved/published
        syncBlockStore.sourceManager.createBodiedSyncBlockNode(attrs);
        tr.replaceWith(conversionInfo.from > 0 ? conversionInfo.from - 1 : 0, conversionInfo.to, newBodiedSyncBlockNode).scrollIntoView();
        // set selection to the end of the previous selection + 1 for the position taken up by the start of the new synced block
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, conversionInfo.to + 1));
    }
    // This transaction will be intercepted in filterTransaction and dispatched when saving to backend succeeds
    // see filterTransaction for more details
    return tr;
};
const $81d4226bf8406331$export$c461f640005976aa = (syncBlockStore, api)=>({ tr: tr })=>{
        if ($81d4226bf8406331$var$copySyncedBlockReferenceToClipboardInternal(tr.doc.type.schema, tr.selection, syncBlockStore, api)) return tr;
        return null;
    };
const $81d4226bf8406331$export$cdf949b884fe546d = (syncBlockStore, api)=>(state, _dispatch, _view)=>{
        return $81d4226bf8406331$var$copySyncedBlockReferenceToClipboardInternal(state.tr.doc.type.schema, state.tr.selection, syncBlockStore, api);
    };
const $81d4226bf8406331$var$copySyncedBlockReferenceToClipboardInternal = (schema, selection, syncBlockStore, api)=>{
    const syncBlockFindResult = (0, $8MdFm.findSyncBlockOrBodiedSyncBlock)(schema, selection);
    if (!syncBlockFindResult) return false;
    const isBodiedSyncBlock = (0, $8MdFm.isBodiedSyncBlockNode)(syncBlockFindResult.node, schema.nodes.bodiedSyncBlock);
    let referenceSyncBlockNode = null;
    if (isBodiedSyncBlock) {
        const { nodes: { syncBlock: syncBlock } } = schema;
        // create sync block reference node
        referenceSyncBlockNode = syncBlock.createAndFill({
            resourceId: syncBlockStore.referenceManager.generateResourceIdForReference(syncBlockFindResult.node.attrs.resourceId)
        });
        if (!referenceSyncBlockNode) return false;
    } else referenceSyncBlockNode = syncBlockFindResult.node;
    if (!referenceSyncBlockNode) return false;
    const domNode = (0, $kgnzE.toDOM)(referenceSyncBlockNode, schema);
    (0, $kgnzE.copyDomNode)(domNode, referenceSyncBlockNode.type, selection);
    // Use setTimeout to dispatch transaction in next tick and avoid re-entrant dispatch
    setTimeout(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            return tr.setMeta((0, $c8abs.syncedBlockPluginKey), {
                activeFlag: {
                    id: (0, $cEH8b.FLAG_ID).SYNC_BLOCK_COPIED
                }
            });
        });
    }, 0);
    return true;
};
const $81d4226bf8406331$export$3a389eb361f43fd = (syncBlockStore, api)=>(state, dispatch, _view)=>{
        const syncBlock = (0, $8MdFm.findSyncBlock)(state.schema, state.selection);
        const resourceId = syncBlock?.node?.attrs?.resourceId;
        if (!resourceId) return false;
        const syncBlockURL = syncBlockStore.referenceManager.getSyncBlockURL(resourceId);
        if (syncBlockURL) window.open(syncBlockURL, '_blank');
        else {
            const tr = state.tr;
            api?.analytics?.actions?.attachAnalyticsEvent({
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                action: (0, $d925B.ACTION).ERROR,
                actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_URL,
                attributes: {
                    error: 'No URL resolved for synced block'
                }
            })(tr);
            dispatch?.(tr);
        }
        return true;
    };
const $81d4226bf8406331$export$1c38da93cd68ba6d = (api)=>(state, dispatch, _view)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        if (!dispatch) return false;
        let removeTr = tr;
        if ((0, $8m4tT.findSelectedNodeOfType)(nodes.syncBlock)(tr.selection) || (0, $8m4tT.findSelectedNodeOfType)(nodes.bodiedSyncBlock)(tr.selection)) removeTr = (0, $8m4tT.removeSelectedNode)(tr);
        else removeTr = (0, $8m4tT.removeParentNodeOfType)(nodes.bodiedSyncBlock)(tr);
        if (!removeTr) return false;
        dispatch(removeTr);
        api?.core.actions.focus();
        return true;
    };
module.exports["createSyncedBlock"] = $81d4226bf8406331$export$fbc30658d812c800;
module.exports["copySyncedBlockReferenceToClipboardEditorCommand"] = $81d4226bf8406331$export$c461f640005976aa;
module.exports["copySyncedBlockReferenceToClipboard"] = $81d4226bf8406331$export$cdf949b884fe546d;
module.exports["editSyncedBlockSource"] = $81d4226bf8406331$export$3a389eb361f43fd;
module.exports["removeSyncedBlock"] = $81d4226bf8406331$export$1c38da93cd68ba6d;

});

parcelRegister("c8abs", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $3tffm = parcelRequire("3tffm");


var $e6n00 = parcelRequire("e6n00");


var $3Ter7 = parcelRequire("3Ter7");

var $l9G9n = parcelRequire("l9G9n");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");


var $gtauf = parcelRequire("gtauf");

var $4Ih1z = parcelRequire("4Ih1z");


var $rPAOL = parcelRequire("rPAOL");


var $e0OS2 = parcelRequire("e0OS2");


var $cEH8b = parcelRequire("cEH8b");


var $4VlDO = parcelRequire("4VlDO");


var $hJwjK = parcelRequire("hJwjK");


var $59NNL = parcelRequire("59NNL");


var $8OZdP = parcelRequire("8OZdP");

const $7e859723415648c3$export$cb5a03b39dafc9cc = new (0, $ks2lK.PluginKey)('syncedBlockPlugin');
const $7e859723415648c3$var$showCopiedFlag = (api)=>{
    // Use setTimeout to dispatch transaction in next tick and avoid re-entrant dispatch
    setTimeout(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            return tr.setMeta($7e859723415648c3$export$cb5a03b39dafc9cc, {
                activeFlag: {
                    id: (0, $cEH8b.FLAG_ID).SYNC_BLOCK_COPIED
                }
            });
        });
    }, 0);
};
const $7e859723415648c3$export$ae829ec7b2625219 = (options, pmPluginFactoryParams, syncBlockStore, api)=>{
    const { useLongPressSelection: useLongPressSelection = false } = options || {};
    const confirmationTransactionRef = {
        current: undefined
    };
    return new (0, $1S4f7.SafePlugin)({
        key: $7e859723415648c3$export$cb5a03b39dafc9cc,
        state: {
            init (_, instance) {
                const syncBlockNodes = instance.doc.children.filter((node)=>node.type.name === 'syncBlock');
                syncBlockStore.referenceManager.fetchSyncBlocksData((0, $gtauf.convertPMNodesToSyncBlockNodes)(syncBlockNodes));
                return {
                    selectionDecorationSet: (0, $59NNL.calculateDecorations)(instance.doc, instance.selection, instance.schema),
                    activeFlag: false,
                    syncBlockStore: syncBlockStore
                };
            },
            apply: (tr, currentPluginState, oldEditorState)=>{
                const meta = tr.getMeta($7e859723415648c3$export$cb5a03b39dafc9cc);
                const { activeFlag: activeFlag, selectionDecorationSet: selectionDecorationSet, bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus } = currentPluginState;
                let newDecorationSet = selectionDecorationSet.map(tr.mapping, tr.doc);
                if (!tr.selection.eq(oldEditorState.selection)) newDecorationSet = (0, $59NNL.calculateDecorations)(tr.doc, tr.selection, tr.doc.type.schema);
                return {
                    activeFlag: meta?.activeFlag ?? activeFlag,
                    selectionDecorationSet: newDecorationSet,
                    syncBlockStore: syncBlockStore,
                    bodiedSyncBlockDeletionStatus: meta?.bodiedSyncBlockDeletionStatus ?? bodiedSyncBlockDeletionStatus
                };
            }
        },
        props: {
            nodeViews: {
                syncBlock: (0, $e0OS2.lazySyncBlockView)({
                    options: options,
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    api: api
                }),
                bodiedSyncBlock: (0, $rPAOL.lazyBodiedSyncBlockView)({
                    pluginOptions: options,
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    api: api
                })
            },
            decorations: (state)=>{
                const selectionDecorationSet = $7e859723415648c3$export$cb5a03b39dafc9cc.getState(state)?.selectionDecorationSet ?? (0, $ftzrq.DecorationSet).empty;
                const { doc: doc } = state;
                const isOffline = api?.connectivity?.sharedState.currentState()?.mode === 'offline';
                const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                const offlineDecorations = [];
                const viewModeDecorations = [];
                state.doc.descendants((node, pos)=>{
                    if (node.type.name === 'bodiedSyncBlock' && isOffline) offlineDecorations.push((0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
                        class: (0, $e6n00.SyncBlockStateCssClassName).disabledClassName
                    }));
                    if ((node.type.name === 'bodiedSyncBlock' || node.type.name === 'syncBlock') && isViewMode) viewModeDecorations.push((0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
                        class: (0, $e6n00.SyncBlockStateCssClassName).viewModeClassName
                    }));
                });
                return selectionDecorationSet.add(doc, offlineDecorations).add(doc, viewModeDecorations);
            },
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'bodiedSyncBlock'
            ], (target)=>!!target.closest(`.${(0, $e6n00.BodiedSyncBlockSharedCssClassName).prefix}`), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: {
                mouseover (view, event) {
                    return (0, $hJwjK.shouldIgnoreDomEvent)(view, event, api);
                },
                mousedown (view, event) {
                    return (0, $hJwjK.shouldIgnoreDomEvent)(view, event, api);
                }
            },
            transformCopied: (slice, { state: state })=>{
                const pluginState = $7e859723415648c3$export$cb5a03b39dafc9cc.getState(state);
                const syncBlockStore = pluginState?.syncBlockStore;
                const { schema: schema } = state;
                if (!syncBlockStore) return slice;
                return (0, $3Ter7.mapSlice)(slice, (node)=>{
                    if (node.type.name === 'syncBlock') {
                        $7e859723415648c3$var$showCopiedFlag(api);
                        return node;
                    }
                    if (node.type.name === 'bodiedSyncBlock' && node.attrs.resourceId) {
                        $7e859723415648c3$var$showCopiedFlag(api);
                        const newResourceId = syncBlockStore.referenceManager.generateResourceIdForReference(node.attrs.resourceId);
                        // Convert bodiedSyncBlock to syncBlock
                        // The paste transformation will regenrate the localId
                        const newAttrs = {
                            ...node.attrs,
                            resourceId: newResourceId
                        };
                        const newMarks = schema.nodes.syncBlock.markSet ? node.marks.filter((mark)=>schema.nodes.syncBlock.markSet?.includes(mark.type)) : node.marks;
                        return schema.nodes.syncBlock.create(newAttrs, null, newMarks);
                    }
                    return node;
                });
            }
        },
        filterTransaction: (tr, state)=>{
            const isOffline = api?.connectivity?.sharedState.currentState()?.mode === 'offline';
            const isConfirmedSyncBlockDeletion = Boolean(tr.getMeta('isConfirmedSyncBlockDeletion'));
            // Ignore transactions that don't change the document
            // or are from remote (collab) or already confirmed sync block deletion
            // We only care about local changes that change the document
            // and are not yet confirmed for sync block deletion
            if (!tr.docChanged || !syncBlockStore?.sourceManager.requireConfirmationBeforeDelete() && !syncBlockStore.sourceManager.hasPendingCreation() || Boolean(tr.getMeta('isRemote')) || Boolean(tr.getMeta('isCommitSyncBlockCreation')) || !isOffline && isConfirmedSyncBlockDeletion) return true;
            const { removed: bodiedSyncBlockRemoved, added: bodiedSyncBlockAdded } = (0, $8OZdP.trackSyncBlocks)(syncBlockStore.sourceManager.isSourceBlock, tr, state);
            if (!isOffline) {
                if (bodiedSyncBlockRemoved.length > 0) {
                    confirmationTransactionRef.current = tr;
                    return (0, $4VlDO.handleBodiedSyncBlockRemoval)(tr, bodiedSyncBlockRemoved, syncBlockStore, api, confirmationTransactionRef);
                }
                if (bodiedSyncBlockAdded.length > 0) {
                    if (Boolean(tr.getMeta((0, $l9G9n.pmHistoryPluginKey)))) // We don't allow bodiedSyncBlock creation via redo, however, we need to return true here to let transaction through so history can be updated properly.
                    // If we simply returns false, creation from redo is blocked as desired, but this results in editor showing redo as possible even though it's not.
                    // After true is returned here and the node is created, we delete the node in the filterTransaction immediately, which cancels out the creation
                    return true;
                    // If there is bodiedSyncBlock node addition and it's waiting for the result of saving the node to backend (syncBlockStore.hasPendingCreation()),
                    // we need to intercept the transaction and save it in insert callback so that we only insert it to the document when backend call if backend call is successful
                    // The callback will be evoked by in SourceSyncBlockStoreManager.commitPendingCreation
                    syncBlockStore.sourceManager.registerCreationCallback(()=>{
                        api?.core?.actions.execute(()=>{
                            return tr.setMeta('isCommitSyncBlockCreation', true);
                        });
                        api?.core.actions.focus();
                    });
                    return false;
                }
            } else {
                const { removed: syncBlockRemoved, added: syncBlockAdded } = (0, $8OZdP.trackSyncBlocks)((node)=>node.type.name === 'syncBlock', tr, state);
                let errorFlag = false;
                // Disable (bodied)syncBlock node deletion/creation/edition in offline mode and trigger an error flag instead
                if (isConfirmedSyncBlockDeletion || bodiedSyncBlockRemoved.length > 0 || syncBlockRemoved.length > 0) errorFlag = (0, $cEH8b.FLAG_ID).CANNOT_DELETE_WHEN_OFFLINE;
                else if (bodiedSyncBlockAdded.length > 0 || syncBlockAdded.length > 0) errorFlag = (0, $cEH8b.FLAG_ID).CANNOT_CREATE_WHEN_OFFLINE;
                else if ((0, $8OZdP.hasEditInSyncBlock)(tr, state)) errorFlag = (0, $cEH8b.FLAG_ID).CANNOT_EDIT_WHEN_OFFLINE;
                if (errorFlag) {
                    // Use setTimeout to dispatch transaction in next tick and avoid re-entrant dispatch
                    setTimeout(()=>{
                        api?.core.actions.execute(({ tr: tr })=>{
                            return tr.setMeta($7e859723415648c3$export$cb5a03b39dafc9cc, {
                                activeFlag: {
                                    id: errorFlag
                                }
                            });
                        });
                    }, 0);
                    return false;
                }
            }
            return true;
        },
        appendTransaction: (trs, oldState, newState)=>{
            trs.filter((tr)=>tr.docChanged).forEach((tr)=>{
                if (confirmationTransactionRef.current) confirmationTransactionRef.current = (0, $4Ih1z.rebaseTransaction)(confirmationTransactionRef.current, tr, newState);
            });
            for (const tr of trs){
                if (!tr.getMeta((0, $l9G9n.pmHistoryPluginKey))) continue;
                const { added: added } = (0, $8OZdP.trackSyncBlocks)(syncBlockStore.sourceManager.isSourceBlock, tr, oldState);
                if (added.length > 0) {
                    // Delete bodiedSyncBlock if it's originated from history, i.e. redo creation
                    // See filterTransaction above for more details
                    const tr = newState.tr;
                    added.forEach((node)=>{
                        if (node.from !== undefined && node.to !== undefined) tr.delete(node.from, node.to);
                    });
                    return tr;
                }
            }
            return null;
        }
    });
};
module.exports["syncedBlockPluginKey"] = $7e859723415648c3$export$cb5a03b39dafc9cc;
module.exports["createPlugin"] = $7e859723415648c3$export$ae829ec7b2625219;

});

parcelRegister("4Ih1z", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");

const $2ca5f7e83e81a6b9$export$9ad1230a11332b62 = (currentTr, incomingTr, state)=>{
    if (!incomingTr.docChanged) return currentTr;
    const currentMapping = new (0, $aXG5V.Mapping)(incomingTr.mapping.maps);
    const rebasedTransaction = state.tr;
    currentTr.steps.forEach((step)=>{
        const mappedStep = step.map(currentMapping);
        if (mappedStep) {
            rebasedTransaction.step(mappedStep);
            currentMapping.appendMap(mappedStep.getMap());
        }
    });
    return rebasedTransaction;
};
module.exports["rebaseTransaction"] = $2ca5f7e83e81a6b9$export$9ad1230a11332b62;

});

parcelRegister("rPAOL", function(module, exports) {

var $ftpVl = parcelRequire("ftpVl");


const $de66a50f644c3a6b$export$aad35c48eac733f9 = (props)=>{
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'bodiedSyncBlock',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = (parcelRequire("6PgjL")).then(({ bodiedSyncBlockNodeView: bodiedSyncBlockNodeView })=>{
                return bodiedSyncBlockNodeView(props);
            });
            return result;
        }
    });
};
module.exports["lazyBodiedSyncBlockView"] = $de66a50f644c3a6b$export$aad35c48eac733f9;

});

parcelRegister("6PgjL", function(module, exports) {

let $4f8429e183546397$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f8429e183546397$var$load("9H9aT").then(()=>parcelRequire('d80Tb'));

});

parcelRegister("e0OS2", function(module, exports) {

var $ftpVl = parcelRequire("ftpVl");


const $5832e54240da7df5$export$b5b91943b8f2be3 = (props)=>{
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'syncBlock',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = (parcelRequire("aXgFn")).then(({ syncBlockNodeView: syncBlockNodeView })=>{
                return syncBlockNodeView(props);
            });
            return result;
        }
    });
};
module.exports["lazySyncBlockView"] = $5832e54240da7df5$export$b5b91943b8f2be3;

});

parcelRegister("aXgFn", function(module, exports) {

let $7f9c57b0b9106257$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f9c57b0b9106257$var$load("5tz7G"),
    $7f9c57b0b9106257$var$load("87Teh")
]).then(()=>parcelRequire('hoY46'));

});

parcelRegister("cEH8b", function(module, exports) {
var $14082efb50d358e2$export$5881677fb314e6d9 = /*#__PURE__*/ function(FLAG_ID) {
    FLAG_ID["CANNOT_DELETE_WHEN_OFFLINE"] = "cannot-delete-when-offline";
    FLAG_ID["CANNOT_EDIT_WHEN_OFFLINE"] = "cannot-edit-when-offline";
    FLAG_ID["CANNOT_CREATE_WHEN_OFFLINE"] = "cannot-create-when-offline";
    FLAG_ID["FAIL_TO_DELETE"] = "fail-to-delete";
    FLAG_ID["SYNC_BLOCK_COPIED"] = "sync-block-copied";
    return FLAG_ID;
}({});
module.exports["FLAG_ID"] = $14082efb50d358e2$export$5881677fb314e6d9;

});

parcelRegister("4VlDO", function(module, exports) {

var $l9G9n = parcelRequire("l9G9n");


var $cEH8b = parcelRequire("cEH8b");


var $c8abs = parcelRequire("c8abs");

const $98bf01fdb90c11b5$var$onRetry = (api, syncBlockStore)=>()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            return tr.setMeta((0, $c8abs.syncedBlockPluginKey), {
                bodiedSyncBlockDeletionStatus: 'processing',
                activeFlag: false
            });
        });
        syncBlockStore.sourceManager.retryDeletion();
    };
const $98bf01fdb90c11b5$var$onDismissed = (syncBlockStore)=>(tr)=>{
        syncBlockStore.sourceManager.clearPendingDeletion();
        return tr.setMeta((0, $c8abs.syncedBlockPluginKey), {
            bodiedSyncBlockDeletionStatus: 'none'
        });
    };
const $98bf01fdb90c11b5$export$4d68be81d3ab4a0d = (tr, bodiedSyncBlockRemoved, syncBlockStore, api, confirmationTransactionRef)=>{
    // Clear potential old pending deletion to retreat the deletion as first attempt
    syncBlockStore.sourceManager.clearPendingDeletion();
    // If there are source sync blocks being removed, and we need to confirm with user before deleting,
    // we block the transaction here, and wait for user confirmation to proceed with deletion.
    // See editor-common/src/sync-block/sync-block-store-manager.ts for how we handle user confirmation and
    // proceed with deletion.
    syncBlockStore.sourceManager.deleteSyncBlocksWithConfirmation(bodiedSyncBlockRemoved.map((node)=>node.attrs), ()=>{
        const confirmationTransaction = confirmationTransactionRef.current;
        if (!confirmationTransaction) return;
        api?.core?.actions.execute(()=>{
            const trToDispatch = confirmationTransaction.setMeta('isConfirmedSyncBlockDeletion', true);
            if (!trToDispatch.getMeta((0, $l9G9n.pmHistoryPluginKey))) // bodiedSyncBlock deletion is expected to be permanent (cannot undo)
            // For a normal deletion (not triggered by undo), remove it from history so that it cannot be undone
            trToDispatch.setMeta('addToHistory', false);
            return trToDispatch;
        });
    }, (success)=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            let newState;
            if (!success) newState = {
                activeFlag: {
                    id: (0, $cEH8b.FLAG_ID).FAIL_TO_DELETE,
                    onRetry: $98bf01fdb90c11b5$var$onRetry(api, syncBlockStore),
                    onDismissed: $98bf01fdb90c11b5$var$onDismissed(syncBlockStore)
                }
            };
            newState = {
                ...newState,
                bodiedSyncBlockDeletionStatus: syncBlockStore.sourceManager.isRetryingDeletion() ? 'none' : 'completed'
            };
            return tr.setMeta((0, $c8abs.syncedBlockPluginKey), newState);
        });
    }, ()=>{
        confirmationTransactionRef.current = undefined;
    });
    return false;
};
module.exports["handleBodiedSyncBlockRemoval"] = $98bf01fdb90c11b5$export$4d68be81d3ab4a0d;

});

parcelRegister("hJwjK", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");

const $f0b41872391b9bd5$export$6b191088ef76a6be = (view, event, api)=>{
    if (api?.connectivity?.sharedState.currentState()?.mode !== 'offline') return;
    const { bodiedSyncBlock: bodiedSyncBlock } = view.state.schema.nodes;
    const pos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    })?.pos;
    if (pos === undefined) return;
    const $pos = view.state.doc.resolve(pos);
    const maybeNode = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, bodiedSyncBlock);
    if (maybeNode) return true;
};
module.exports["shouldIgnoreDomEvent"] = $f0b41872391b9bd5$export$6b191088ef76a6be;

});

parcelRegister("59NNL", function(module, exports) {

var $e6n00 = parcelRequire("e6n00");


var $8m4tT = parcelRequire("8m4tT");


var $ftzrq = parcelRequire("ftzrq");

const $ba7e5685057467c9$export$aee83dbd972779dd = (doc, selection, schema)=>{
    const { bodiedSyncBlock: bodiedSyncBlock } = schema.nodes;
    const syncBlockParent = (0, $8m4tT.findParentNodeOfType)(bodiedSyncBlock)(selection);
    if (syncBlockParent) {
        const { node: node, pos: pos } = syncBlockParent;
        const decoration = (0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
            class: `${(0, $e6n00.BodiedSyncBlockSharedCssClassName).selectionInside}`
        });
        return (0, $ftzrq.DecorationSet).create(doc, [
            decoration
        ]);
    }
    return (0, $ftzrq.DecorationSet).empty;
};
module.exports["calculateDecorations"] = $ba7e5685057467c9$export$aee83dbd972779dd;

});

parcelRegister("8OZdP", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");


var $8m4tT = parcelRequire("8m4tT");

const $f6423e1964ba14ae$export$a1196481035d4d42 = (predicate, tr, state)=>{
    const removed = {};
    const added = {};
    if (!tr.docChanged) return {
        removed: [],
        added: []
    };
    // and cast to specific step types
    const replaceSteps = tr.steps.filter((step)=>step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep));
    // this is a quick check to see if any insertion/deletion of bodiedSyncBlock happened
    const hasBodiedSyncBlockChanges = replaceSteps.some((step)=>{
        const { from: from, to: to } = step;
        let hasChange = false;
        if (from !== to) step.getMap().forEach((oldStart, oldEnd)=>{
            if (oldStart !== oldEnd && !hasChange) {
                const deletedSlice = state.doc.slice(Math.max(0, oldStart), Math.min(state.doc.content.size, oldEnd));
                deletedSlice.content.forEach((node)=>{
                    if (hasChange) return;
                    // for top level nodes
                    if (predicate(node)) hasChange = true;
                });
            }
        });
        // no need to check insertions if we already found deletions
        if (step.slice.content.size > 0 && !hasChange) step.slice.content.forEach((node)=>{
            if (predicate(node) && !hasChange) hasChange = true;
        });
        return hasChange;
    });
    if (hasBodiedSyncBlockChanges) {
        const oldDoc = state.doc;
        const newDoc = tr.doc;
        const syncBlockMapOld = {};
        const syncBlockMapNew = {};
        oldDoc.content.forEach((node)=>{
            if (predicate(node)) {
                const syncBlockAttr = node.attrs;
                syncBlockMapOld[syncBlockAttr.localId] = {
                    attrs: syncBlockAttr
                };
            }
        });
        newDoc.content.forEach((node, offset)=>{
            if (predicate(node)) {
                const syncBlockAttr = node.attrs;
                syncBlockMapNew[syncBlockAttr.localId] = {
                    attrs: syncBlockAttr,
                    from: offset,
                    to: offset + node.nodeSize
                };
            }
        });
        // Find removed sync blocks
        for(const localId in syncBlockMapOld)if (!syncBlockMapNew[localId]) removed[localId] = syncBlockMapOld[localId];
        // Find added sync blocks
        for(const localId in syncBlockMapNew)if (!syncBlockMapOld[localId]) added[localId] = syncBlockMapNew[localId];
    }
    return {
        removed: Object.values(removed),
        added: Object.values(added)
    };
};
const $f6423e1964ba14ae$export$7531459b60818a32 = (tr, state)=>{
    const { bodiedSyncBlock: bodiedSyncBlock } = state.schema.nodes;
    for (const step of tr.steps){
        const map = step.getMap();
        const { doc: doc } = tr;
        const positions = [];
        // Extract positions from steps dynamically based on applicable properties
        if ('from' in step && typeof step.from === 'number' && 'to' in step && typeof step.to === 'number') {
            const { from: from, to: to } = step;
            positions.push(from, to);
        } else if ('pos' in step && typeof step.pos === 'number') {
            const { pos: pos } = step;
            positions.push(pos);
        }
        for (const pos of positions){
            const newPos = map.map(pos);
            if (newPos >= 0 && newPos <= doc.content.size) {
                if ((0, $8m4tT.findParentNodeOfTypeClosestToPos)(doc.resolve(newPos), bodiedSyncBlock)) return true;
            }
        }
    }
    return false;
};
module.exports["trackSyncBlocks"] = $f6423e1964ba14ae$export$a1196481035d4d42;
module.exports["hasEditInSyncBlock"] = $f6423e1964ba14ae$export$7531459b60818a32;

});

parcelRegister("8MdFm", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $7XFGZ = parcelRequire("7XFGZ");

var $id9O1 = parcelRequire("id9O1");

const $418da91bd772292a$export$8e2da6078c69a0c6 = (schema, selection)=>{
    const { syncBlock: syncBlock } = schema.nodes;
    return (0, $8m4tT.findSelectedNodeOfType)(syncBlock)(selection);
};
const $418da91bd772292a$export$342c143cb64448d1 = (schema, selection)=>{
    return (0, $8m4tT.findSelectedNodeOfType)(schema.nodes.bodiedSyncBlock)(selection) || (0, $8m4tT.findParentNodeOfType)(schema.nodes.bodiedSyncBlock)(selection);
};
const $418da91bd772292a$export$72f89723ce6d6fa3 = (schema, selection)=>{
    return $418da91bd772292a$export$8e2da6078c69a0c6(schema, selection) || $418da91bd772292a$export$342c143cb64448d1(schema, selection);
};
const $418da91bd772292a$export$5f971aa95a01794c = (node, bodiedSyncBlock)=>node.type === bodiedSyncBlock;
const $418da91bd772292a$var$UNSUPPORTED_NODE_TYPES = new Set([
    'inlineExtension',
    'extension',
    'bodiedExtension',
    'syncBlock',
    'bodiedSyncBlock'
]);
const $418da91bd772292a$export$a912fa82dfd54783 = (selection)=>{
    const schema = selection.$from.doc.type.schema;
    const { nodes: nodes } = schema;
    let from = selection.from;
    let to = selection.to;
    let contentToInclude = selection.content().content;
    if (selection instanceof (0, $7XFGZ.CellSelection)) {
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return false;
        contentToInclude = (0, $5SAOw.Fragment).from([
            table.node
        ]);
        from = table.pos;
        to = table.pos + table.node.nodeSize;
    } else if (selection instanceof (0, $ks2lK.TextSelection)) {
        const trueParent = (0, $8m4tT.findParentNodeOfType)([
            nodes.bulletList,
            nodes.orderedList,
            nodes.taskList,
            nodes.blockquote
        ])(selection);
        if (trueParent) {
            contentToInclude = (0, $5SAOw.Fragment).from([
                trueParent.node
            ]);
            from = trueParent.pos;
            to = trueParent.pos + trueParent.node.nodeSize;
        }
    }
    let canBeConverted = true;
    selection.$from.doc.nodesBetween(from, to, (node)=>{
        if ($418da91bd772292a$var$UNSUPPORTED_NODE_TYPES.has(node.type.name)) {
            canBeConverted = false;
            return false;
        }
    });
    if (!canBeConverted) return false;
    contentToInclude = $418da91bd772292a$var$removeBreakoutMarks(contentToInclude);
    return {
        contentToInclude: contentToInclude,
        from: from,
        to: to
    };
};
const $418da91bd772292a$var$removeBreakoutMarks = (content)=>{
    const nodes = [];
    // we only need to recurse at the top level, because breakout has to be on a top level
    content.forEach((node)=>{
        const filteredMarks = node.marks.filter((mark)=>mark.type.name !== 'breakout');
        if (node.isText) nodes.push(node);
        else {
            const newNode = node.type.create(node.attrs, node.content, filteredMarks);
            nodes.push(newNode);
        }
    });
    return (0, $5SAOw.Fragment).from(nodes);
};
module.exports["findSyncBlock"] = $418da91bd772292a$export$8e2da6078c69a0c6;
module.exports["findSyncBlockOrBodiedSyncBlock"] = $418da91bd772292a$export$72f89723ce6d6fa3;
module.exports["isBodiedSyncBlockNode"] = $418da91bd772292a$export$5f971aa95a01794c;
module.exports["canBeConvertedToSyncBlock"] = $418da91bd772292a$export$a912fa82dfd54783;

});

parcelRegister("cqOa3", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $btNLq = parcelRequire("btNLq");

var $gEb6G = parcelRequire("gEb6G");


var $6WiIf = parcelRequire("6WiIf");

const $bfc48e23a08c3f1f$export$b1be7b75e24fc24b = (api)=>{
    return [
        {
            type: 'block-menu-item',
            key: (0, $btNLq.BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.BLOCK_ACTIONS_MENU_SECTION).key,
                rank: (0, $gEb6G.BLOCK_ACTIONS_MENU_SECTION_RANK)[(0, $btNLq.BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6WiIf.CreateOrCopySyncedBlockDropdownItem), {
                    api: api
                })
        }
    ];
};
module.exports["getBlockMenuComponents"] = $bfc48e23a08c3f1f$export$b1be7b75e24fc24b;

});

parcelRegister("6WiIf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $eiA8Z = parcelRequire("eiA8Z");


var $eKkkY = parcelRequire("eKkkY");


var $l1bBg = parcelRequire("l1bBg");

var $2GVu1 = parcelRequire("2GVu1");


var $5nBzc = parcelRequire("5nBzc");


var $8MdFm = parcelRequire("8MdFm");

const $f4f4a9661e1724d7$var$CreateSyncedBlockDropdownItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { selection: selection, menuTriggerByNode: menuTriggerByNode, mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selection',
        'blockControls',
        'connectivity'
    ], (states)=>({
            selection: states.selectionState?.selection,
            menuTriggerByNode: states.blockControlsState?.menuTriggerByNode ?? undefined,
            mode: states.connectivityState?.mode
        }));
    const isNested = menuTriggerByNode && menuTriggerByNode.rootPos !== menuTriggerByNode.pos;
    const canBeConverted = (0, $42omo.useMemo)(()=>selection && (0, $8MdFm.canBeConvertedToSyncBlock)(selection), [
        selection
    ]);
    if (isNested || !canBeConverted) return null;
    const onClick = ()=>{
        api?.core?.actions.execute(api?.syncedBlock.commands.insertSyncedBlock());
        api?.core?.actions.execute(api?.blockControls?.commands?.toggleBlockMenu({
            closeMenu: true
        }));
    };
    const isOffline = mode === 'offline';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l1bBg))), {
            label: ""
        }),
        onClick: onClick,
        isDisabled: isOffline,
        elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            appearance: "new",
            children: formatMessage((0, $eKkkY.messages).newLozenge)
        }),
        children: formatMessage((0, $eKkkY.messages).createSyncedBlock)
    });
};
const $f4f4a9661e1724d7$var$CopySyncedBlockDropdownItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>({
            mode: states.connectivityState?.mode
        }));
    const onClick = ()=>{
        api?.core?.actions.execute(api?.syncedBlock.commands.copySyncedBlockReferenceToClipboard());
        api?.core?.actions.execute(api?.blockControls?.commands?.toggleBlockMenu({
            closeMenu: true
        }));
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l1bBg))), {
            label: ""
        }),
        onClick: onClick,
        isDisabled: mode === 'offline',
        elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            appearance: "new",
            children: formatMessage((0, $eKkkY.messages).newLozenge)
        }),
        children: formatMessage((0, $eKkkY.messages).copySyncedBlock)
    });
};
const $f4f4a9661e1724d7$export$3699afce8ee13fa8 = ({ api: api })=>{
    const { menuTriggerByNode: menuTriggerByNode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>({
            menuTriggerByNode: states.blockControlsState?.menuTriggerByNode ?? undefined
        }));
    if (menuTriggerByNode?.nodeType === 'syncBlock' || menuTriggerByNode?.nodeType === 'bodiedSyncBlock') return /*#__PURE__*/ (0, $l998X.jsx)($f4f4a9661e1724d7$var$CopySyncedBlockDropdownItem, {
        api: api
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)($f4f4a9661e1724d7$var$CreateSyncedBlockDropdownItem, {
        api: api
    });
};
module.exports["CreateOrCopySyncedBlockDropdownItem"] = $f4f4a9661e1724d7$export$3699afce8ee13fa8;

});

parcelRegister("l1bBg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::527f33e0573e8027a3e6df8a9b12f86d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4d2b07911d6a9af$var$_react = $f4d2b07911d6a9af$var$_interopRequireDefault((parcelRequire("42omo")));

var $f4d2b07911d6a9af$var$_baseNew = $f4d2b07911d6a9af$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f4d2b07911d6a9af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BlockSynced".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing content blocks in Editor experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4d2b07911d6a9af$var$BlockSyncedIcon = (props)=>/*#__PURE__*/ $f4d2b07911d6a9af$var$_react.default.createElement($f4d2b07911d6a9af$var$_baseNew.default, Object.assign({
        name: "BlockSyncedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2h-1.5z"/><path fill="currentcolor" d="M14.9 8.71a3.75 3.75 0 0 1 0 5.303l-.024.026.439.146a.75.75 0 0 1-.13 1.454l-2.476.354a.75.75 0 0 1-.848-.849l.353-2.474.029-.125a.75.75 0 0 1 1.425-.006l.147.44.025-.026a2.25 2.25 0 0 0 0-3.183l-.707-.707 1.06-1.06zm-3.818-1.98a.75.75 0 0 1 .85.849l-.354 2.475a.75.75 0 0 1-1.454.13l-.147-.44-.025.026a2.25 2.25 0 0 0 0 3.183l.707.707-1.06 1.06-.708-.707a3.75 3.75 0 0 1 0-5.303l.026-.026-.44-.146a.75.75 0 0 1 .13-1.454z"/>`
    }, props));
$f4d2b07911d6a9af$var$BlockSyncedIcon.displayName = 'BlockSyncedIcon';
var $f4d2b07911d6a9af$var$_default = module.exports.default = $f4d2b07911d6a9af$var$BlockSyncedIcon;

});

parcelRegister("hqAnd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $eiA8Z = parcelRequire("eiA8Z");


var $fzXn1 = parcelRequire("fzXn1");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $iXCQx = parcelRequire("iXCQx");


var $c8abs = parcelRequire("c8abs");

const $36d8a16884645580$export$d973532b09e0f2cc = ({ syncBlockStoreManager: syncBlockStoreManager, api: api })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [syncBlockCount, setSyncBlockCount] = (0, $42omo.useState)(1);
    const { mode: mode, bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus, activeFlag: activeFlag } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'syncedBlock'
    ], (states)=>({
            mode: states.connectivityState?.mode,
            bodiedSyncBlockDeletionStatus: states.syncedBlockState?.bodiedSyncBlockDeletionStatus,
            activeFlag: states.syncedBlockState?.activeFlag
        }));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const resolverRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(undefined);
    const handleClick = (0, $42omo.useCallback)((confirm)=>()=>{
            if (resolverRef.current) {
                resolverRef.current(confirm);
                resolverRef.current = undefined;
            }
            if (!confirm) setIsOpen(false);
            api?.core?.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $c8abs.syncedBlockPluginKey), {
                    bodiedSyncBlockDeletionStatus: confirm ? 'processing' : 'none',
                    activeFlag: false
                });
            });
        }, [
        api?.core?.actions
    ]);
    const confirmationCallback = (0, $42omo.useCallback)((syncBlockCount)=>{
        setIsOpen(true);
        setSyncBlockCount(syncBlockCount);
        const confirmedPromise = new Promise((resolve)=>{
            resolverRef.current = resolve;
        });
        if (activeFlag) api?.core?.actions.execute(({ tr: tr })=>{
            return tr.setMeta((0, $c8abs.syncedBlockPluginKey), {
                // Clear flag to avoid potential retry deletion of different blocks
                activeFlag: false
            });
        });
        return confirmedPromise;
    }, [
        activeFlag,
        api?.core?.actions
    ]);
    (0, $42omo.useEffect)(()=>{
        const unregister = syncBlockStoreManager.sourceManager.registerConfirmationCallback(confirmationCallback);
        return ()=>{
            unregister();
        };
    }, [
        syncBlockStoreManager,
        confirmationCallback
    ]);
    (0, $42omo.useEffect)(()=>{
        if (bodiedSyncBlockDeletionStatus === 'completed' && isOpen) {
            // auto close modal once deletion is successful
            setIsOpen(false);
            api?.core?.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $c8abs.syncedBlockPluginKey), {
                    // Reset deletion status to have a clean state for next deletion
                    bodiedSyncBlockDeletionStatus: 'none'
                });
            });
        }
    }, [
        api?.core?.actions,
        bodiedSyncBlockDeletionStatus,
        isOpen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
            onClose: handleClick(false),
            testId: "sync-block-delete-confirmation",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                        appearance: "warning",
                        children: formatMessage((0, $fzXn1.syncBlockMessages).deleteConfirmationModalTitle)
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        children: formatMessage((0, $fzXn1.syncBlockMessages).deleteConfirmationModalDescription, {
                            syncBlockCount: syncBlockCount
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "subtle",
                            onClick: handleClick(false),
                            children: formatMessage((0, $fzXn1.syncBlockMessages).deleteConfirmationModalCancelButton)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "warning",
                            onClick: handleClick(true),
                            autoFocus: true,
                            isDisabled: mode === 'offline',
                            isLoading: bodiedSyncBlockDeletionStatus === 'processing',
                            children: formatMessage((0, $fzXn1.syncBlockMessages).deleteConfirmationModalDeleteButton)
                        })
                    ]
                })
            ]
        })
    });
};
module.exports["DeleteConfirmationModal"] = $36d8a16884645580$export$d973532b09e0f2cc;

});

parcelRegister("kEJjT", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $eiA8Z = parcelRequire("eiA8Z");


var $fzXn1 = parcelRequire("fzXn1");


var $aD1SW = parcelRequire("aD1SW");

var $eCEXz = parcelRequire("eCEXz");

var $6uGcC = parcelRequire("6uGcC");


var $fZtQj = parcelRequire("fZtQj");


var $ebrpi = parcelRequire("ebrpi");


var $c8abs = parcelRequire("c8abs");


var $cEH8b = parcelRequire("cEH8b");

const $52c5140df34ff9d4$var$flagMap = {
    [(0, $cEH8b.FLAG_ID).CANNOT_DELETE_WHEN_OFFLINE]: {
        title: (0, $fzXn1.syncBlockMessages).failToDeleteTitle,
        description: (0, $fzXn1.syncBlockMessages).failToDeleteWhenOfflineDescription,
        type: 'error'
    },
    [(0, $cEH8b.FLAG_ID).CANNOT_EDIT_WHEN_OFFLINE]: {
        title: (0, $fzXn1.syncBlockMessages).failToEditTitle,
        description: (0, $fzXn1.syncBlockMessages).failToEditWhenOfflineDescription,
        type: 'error'
    },
    [(0, $cEH8b.FLAG_ID).CANNOT_CREATE_WHEN_OFFLINE]: {
        title: (0, $fzXn1.syncBlockMessages).failToCreateTitle,
        description: (0, $fzXn1.syncBlockMessages).failToCreateWhenOfflineDescription,
        type: 'error'
    },
    [(0, $cEH8b.FLAG_ID).FAIL_TO_DELETE]: {
        title: (0, $fzXn1.syncBlockMessages).cannotDeleteTitle,
        description: (0, $fzXn1.syncBlockMessages).cannotDeleteDescription,
        type: 'error'
    },
    [(0, $cEH8b.FLAG_ID).SYNC_BLOCK_COPIED]: {
        title: (0, $fzXn1.syncBlockMessages).syncBlockCopiedTitle,
        description: (0, $fzXn1.syncBlockMessages).syncBlockCopiedDescription,
        action: (0, $fzXn1.syncBlockMessages).syncBlockCopiedAction,
        type: 'info'
    }
};
const $52c5140df34ff9d4$export$48ea269755562084 = ({ api: api })=>{
    const { activeFlag: activeFlag, mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'syncedBlock',
        'connectivity'
    ], (states)=>{
        return {
            activeFlag: states.syncedBlockState?.activeFlag,
            mode: states.connectivityState?.mode
        };
    });
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!activeFlag) return;
    const { title: title, description: description, action: action, type: type } = $52c5140df34ff9d4$var$flagMap[activeFlag.id];
    const { onRetry: onRetry, onDismissed: onDismissedCallback } = activeFlag;
    // Retry button often involves network request, hence we dismiss the flag in offline mode to avoid retry
    if (mode === 'offline' && !!onRetry) {
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $c8abs.syncedBlockPluginKey), {
                activeFlag: false
            });
            return tr;
        });
        return;
    }
    const onDismissed = ()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            onDismissedCallback?.(tr);
            const oldMeta = tr.getMeta((0, $c8abs.syncedBlockPluginKey));
            tr.setMeta((0, $c8abs.syncedBlockPluginKey), {
                ...oldMeta,
                activeFlag: false
            });
            return tr;
        });
        api?.core.actions.focus();
    };
    const typeToActions = ()=>{
        if (type === 'error') {
            if (onRetry) return [
                {
                    content: formatMessage((0, $fzXn1.syncBlockMessages).deleteRetryButton),
                    onClick: onRetry
                }
            ];
        } else if (type === 'info' && action) return [
            {
                content: formatMessage(action),
                href: 'https://atlaskit.atlassian.com/',
                target: '_blank'
            }
        ];
        return undefined;
    };
    const FlagComponent = type === 'info' ? (0, $aD1SW.default) : (0, $eCEXz.default);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)(FlagComponent, {
            onDismissed: onDismissed,
            title: formatMessage(title),
            description: formatMessage(description),
            id: activeFlag.id,
            testId: activeFlag.id,
            icon: $52c5140df34ff9d4$var$typeToIcon(type),
            actions: typeToActions()
        })
    });
};
const $52c5140df34ff9d4$var$typeToIcon = (type)=>{
    if (type === 'error') return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        label: "",
        color: "var(--ds-icon-warning, #E06C00)"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fZtQj))), {
        label: ""
    });
};
module.exports["Flag"] = $52c5140df34ff9d4$export$48ea269755562084;

});

parcelRegister("aF0RF", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $61p3e = parcelRequire("61p3e");

var $fzXn1 = parcelRequire("fzXn1");


var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");


var $2MuFw = parcelRequire("2MuFw");


var $gKvd9 = parcelRequire("gKvd9");


var $1Zr9M = parcelRequire("1Zr9M");


var $9Oj2R = parcelRequire("9Oj2R");


var $8MdFm = parcelRequire("8MdFm");

const $4bceb7bfa67a58a2$export$86ce8f8241c20a3 = (state, intl, api, syncBlockStore)=>{
    const syncBlockObject = (0, $8MdFm.findSyncBlockOrBodiedSyncBlock)(state.schema, state.selection);
    if (!syncBlockObject) return;
    const { schema: { nodes: { bodiedSyncBlock: bodiedSyncBlock } } } = state;
    const isBodiedSyncBlock = (0, $8MdFm.isBodiedSyncBlockNode)(syncBlockObject.node, bodiedSyncBlock);
    const { formatMessage: formatMessage } = intl;
    const nodeType = syncBlockObject.node.type;
    const hoverDecoration = api?.decorations?.actions.hoverDecoration;
    const hoverDecorationProps = (nodeType, className)=>({
            onMouseEnter: hoverDecoration?.(nodeType, true, className),
            onMouseLeave: hoverDecoration?.(nodeType, false, className),
            onFocus: hoverDecoration?.(nodeType, true, className),
            onBlur: hoverDecoration?.(nodeType, false, className)
        });
    const items = [];
    const copyButton = {
        id: 'editor.syncedBlock.copy',
        type: 'button',
        appearance: 'subtle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))),
        title: formatMessage((0, $fzXn1.syncBlockMessages).copySyncBlockLabel),
        showTitle: false,
        tooltipContent: formatMessage((0, $fzXn1.syncBlockMessages).copySyncBlockTooltip),
        onClick: (0, $9Oj2R.copySyncedBlockReferenceToClipboard)(syncBlockStore, api),
        ...hoverDecorationProps(nodeType, (0, $aFUXX.akEditorSelectedNodeClassName))
    };
    items.push(copyButton);
    const disabled = !syncBlockStore.referenceManager.getSyncBlockURL(syncBlockObject.node.attrs.resourceId);
    if (!isBodiedSyncBlock) {
        const editSourceButton = {
            id: 'editor.syncedBlock.editSource',
            type: 'button',
            disabled: disabled,
            appearance: 'subtle',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
            title: formatMessage((0, $fzXn1.syncBlockMessages).editSourceLabel),
            showTitle: false,
            tooltipContent: disabled ? formatMessage((0, $fzXn1.syncBlockMessages).editSourceTooltipDisabled) : formatMessage((0, $fzXn1.syncBlockMessages).editSourceTooltip),
            onClick: (0, $9Oj2R.editSyncedBlockSource)(syncBlockStore, api),
            ...hoverDecorationProps(nodeType, (0, $aFUXX.akEditorSelectedNodeClassName))
        };
        items.push(editSourceButton);
    }
    // testId is required to show focus on trigger button on ESC key press
    // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
    const testId = 'synced-block-overflow-dropdown-trigger';
    const overflowMenuConfig = [
        {
            type: 'overflow-dropdown',
            testId: testId,
            options: [
                {
                    title: formatMessage((0, $61p3e.default).delete),
                    onClick: (0, $9Oj2R.removeSyncedBlock)(api),
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType)
                }
            ]
        }
    ];
    items.push(...overflowMenuConfig);
    const getDomRef = (editorView)=>{
        const domAtPos = editorView.domAtPos.bind(editorView);
        const element = (0, $8m4tT.findDomRefAtPos)(syncBlockObject.pos, domAtPos);
        return element;
    };
    return {
        title: 'Synced Block floating controls',
        getDomRef: getDomRef,
        nodeType: nodeType,
        items: items,
        scrollable: true,
        groupLabel: formatMessage((0, $fzXn1.syncBlockMessages).syncBlockGroup),
        visible: api?.connectivity?.sharedState.currentState()?.mode !== 'offline'
    };
};
module.exports["getToolbarConfig"] = $4bceb7bfa67a58a2$export$86ce8f8241c20a3;

});

parcelRegister("ckjkT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");

const $a5aa0720cf403980$export$800ed13216d179da = 3000;
const $a5aa0720cf403980$export$f8d6f80345184030 = ({ syncBlockStoreManager: syncBlockStoreManager, api: api })=>{
    const { mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>({
            mode: states.connectivityState?.mode
        }));
    (0, $42omo.useEffect)(()=>{
        let interval = -1;
        if (mode !== 'offline') interval = window.setInterval(()=>{
            // check if document is visible to avoid unnecessary refreshes
            if (document?.visibilityState === 'visible') syncBlockStoreManager.referenceManager.refreshSubscriptions();
        }, $a5aa0720cf403980$export$800ed13216d179da);
        else if (interval !== -1) window.clearInterval(interval);
        return ()=>{
            window.clearInterval(interval);
        };
    }, [
        syncBlockStoreManager,
        mode
    ]);
    return null;
};
module.exports["SyncBlockRefresher"] = $a5aa0720cf403980$export$f8d6f80345184030;

});

parcelRegister("89DY6", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");


var $aro2m = parcelRequire("aro2m");

var $kDB94 = parcelRequire("kDB94");


var $1oCLl = parcelRequire("1oCLl");


var $alzA4 = parcelRequire("alzA4");

const $97379743d7c8d373$var$SYNCED_BLOCK_PRIMARY_TOOLBAR_GROUP = {
    type: (0, $cPCP8.SYNCED_BLOCK_GROUP).type,
    key: (0, $cPCP8.SYNCED_BLOCK_GROUP).key,
    component: (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aro2m.Show), {
            above: "md",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kDB94.ToolbarButtonGroup), {
                children: children
            })
        }) : undefined,
    parents: [
        {
            type: (0, $cPCP8.INSERT_BLOCK_SECTION).type,
            key: (0, $cPCP8.INSERT_BLOCK_SECTION).key,
            rank: (0, $4Chin.INSERT_BLOCK_SECTION_RANK)[(0, $cPCP8.SYNCED_BLOCK_GROUP).key]
        }
    ]
};
const $97379743d7c8d373$export$a758406ca53b86a5 = (api)=>{
    return [
        $97379743d7c8d373$var$SYNCED_BLOCK_PRIMARY_TOOLBAR_GROUP,
        {
            type: (0, $cPCP8.SYNCED_BLOCK_BUTTON).type,
            key: (0, $cPCP8.SYNCED_BLOCK_BUTTON).key,
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $alzA4.CreateSyncedBlockButton), {
                    api: api
                }),
            parents: [
                {
                    type: (0, $cPCP8.SYNCED_BLOCK_GROUP).type,
                    key: (0, $cPCP8.SYNCED_BLOCK_GROUP).key,
                    rank: (0, $4Chin.SYNCED_BLOCK_SECTION_RANK)[(0, $cPCP8.SYNCED_BLOCK_BUTTON).key]
                }
            ]
        }
    ];
};
module.exports["getToolbarComponents"] = $97379743d7c8d373$export$a758406ca53b86a5;

});

parcelRegister("alzA4", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $eiA8Z = parcelRequire("eiA8Z");


var $fzXn1 = parcelRequire("fzXn1");


var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");


var $l1bBg = parcelRequire("l1bBg");


var $8MdFm = parcelRequire("8MdFm");

const $abdbbe21b6af051b$export$954568e298a26ab0 = ({ api: api })=>{
    const intl = (0, $8C5kA.default)();
    const { selection: selection, mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selection',
        'connectivity'
    ], (states)=>({
            selection: states.selectionState?.selection,
            mode: states.connectivityState?.mode
        }));
    // for toolbar button, we allow both creating a new synced block
    // and converting existing block to synced block
    const canBeConverted = Boolean(selection && (0, $8MdFm.canBeConvertedToSyncBlock)(selection));
    const canInsertEmptyBlock = Boolean(selection?.empty);
    const isDisabled = Boolean(mode === 'offline' || !canBeConverted && !canInsertEmptyBlock);
    const onClick = (0, $42omo.useCallback)(()=>{
        api?.core?.actions.execute(({ tr: tr })=>api?.syncedBlock.commands.insertSyncedBlock()({
                tr: tr
            }));
        api?.core?.actions.focus();
    }, [
        api
    ]);
    const message = intl.formatMessage((0, $fzXn1.syncBlockMessages).createSyncBlockLabel);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: message,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            label: message,
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l1bBg))), {
                size: "small",
                label: ""
            }),
            isDisabled: isDisabled,
            onClick: onClick
        })
    });
};
module.exports["CreateSyncedBlockButton"] = $abdbbe21b6af051b$export$954568e298a26ab0;

});

parcelRegister("iSWIi", function(module, exports) {

var $77wHb = parcelRequire("77wHb");

/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var $038c4daf1440bb6a$var$partition = $77wHb(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
module.exports = $038c4daf1440bb6a$var$partition;

});

parcelRegister("e2ZTm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::abee860452bcaffc9cded3519ab61cd1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3a1430ff6078f73$var$_react = $a3a1430ff6078f73$var$_interopRequireDefault((parcelRequire("42omo")));

var $a3a1430ff6078f73$var$_baseNew = $a3a1430ff6078f73$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a3a1430ff6078f73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SuggestedEdit".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for suggestions powered by Atlassian Intelligence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3a1430ff6078f73$var$SuggestedEditIcon = (props)=>/*#__PURE__*/ $a3a1430ff6078f73$var$_react.default.createElement($a3a1430ff6078f73$var$_baseNew.default, Object.assign({
        name: "SuggestedEditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.84 5.85a2 2 0 0 1 2.83 0l.73.73a2 2 0 0 1 0 2.83l-5.14 5.14a2 2 0 0 1-.86.51l-3.19.91a.75.75 0 0 1-.93-.93l.91-3.19a2 2 0 0 1 .51-.86zm1.77 1.06a.5.5 0 0 0-.71 0l-.59.59 1.44 1.44.59-.59a.5.5 0 0 0 0-.71zM12.69 10l-1.44-1.44-3.49 3.49a.5.5 0 0 0-.13.22l-.54 1.89 1.89-.54a.5.5 0 0 0 .22-.13zM4.75 0c.31 0 .59.19.7.48l1 2.57 2.57 1a.75.75 0 0 1 0 1.4l-2.57 1-1 2.57a.75.75 0 0 1-1.4 0l-1-2.57-2.57-1a.75.75 0 0 1 0-1.4l2.57-1 1-2.57a.75.75 0 0 1 .7-.48m0 2.82L4.33 3.9a.75.75 0 0 1-.43.43l-1.08.42 1.08.42a.75.75 0 0 1 .43.43l.42 1.08.42-1.08a.75.75 0 0 1 .43-.43l1.08-.42-1.08-.42a.75.75 0 0 1-.43-.43z" clip-rule="evenodd"/>`
    }, props));
$a3a1430ff6078f73$var$SuggestedEditIcon.displayName = 'SuggestedEditIcon';
var $a3a1430ff6078f73$var$_default = module.exports.default = $a3a1430ff6078f73$var$SuggestedEditIcon;

});

parcelRegister("axAnW", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $7e9dab50b8978c7c$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldRenderChildren: false
        };
        this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}
$7e9dab50b8978c7c$export$2e2bcd8739ae039.defaultProps = {
    fallback: null
};
module.exports["default"] = $7e9dab50b8978c7c$export$2e2bcd8739ae039;

});

parcelRegister("kkQZq", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed290d22e560c9dd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");


var $hPd3F = parcelRequire("hPd3F");


var $7cTWR = parcelRequire("7cTWR");


var $3Npfo = parcelRequire("3Npfo");


var $k5HOq = parcelRequire("k5HOq");


var $9A5yV = parcelRequire("9A5yV");

function $ed290d22e560c9dd$var$_defineProperty(e, r, t) {
    return (r = $ed290d22e560c9dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ed290d22e560c9dd$var$_toPropertyKey(t) {
    var i = $ed290d22e560c9dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ed290d22e560c9dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $ed290d22e560c9dd$var$baselineUnit = "var(--ds-space-050, 4px)";
const $ed290d22e560c9dd$var$COLOR_N900 = '#091E42';
// eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $ed290d22e560c9dd$var$ContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $ed290d22e560c9dd$var$Image = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $ed290d22e560c9dd$var$ButtonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});
const $ed290d22e560c9dd$var$BodyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0q1b66 _n3td1b66 _syazi7uo",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ed290d22e560c9dd$export$c7313f750e9cbc9d extends (0, $42omo.Component) {
    getPrimaryButton() {
        const { primaryAction: primaryAction, primaryText: primaryText } = this.props;
        return this.getActionButton('primary', this.onPrimaryClick, primaryAction, primaryText);
    }
    getSecondaryButton() {
        const { secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        return this.getActionButton('subtle-link', this.onSecondaryClick, secondaryAction, secondaryText);
    }
    getActionButton(appearance, onClick, action, text) {
        const type = action ? action.type : (0, $7cTWR.buttonActionTypes).DISMISS;
        switch(type){
            case (0, $7cTWR.buttonActionTypes).LINK:
                {
                    const actionData = action.data;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                        href: actionData.url,
                        target: actionData.target,
                        appearance: appearance,
                        onClick: onClick
                    }, text);
                }
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    appearance: appearance,
                    onClick: onClick
                }, text);
        }
    }
    render() {
        const { children: children, title: title, imageSrc: imageSrc, imageAlt: imageAlt, body: body, position: position, order: order, secondaryText: secondaryText } = this.props;
        const messageContent = {
            image: null,
            title: null,
            body: null
        };
        if (title) // eslint-disable-next-line @atlaskit/design-system/use-heading
        messageContent.title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("h4", {
            key: "title"
        }, title);
        if (imageSrc) messageContent.image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$Image, {
            key: "img",
            src: imageSrc,
            alt: imageAlt
        });
        messageContent.body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$BodyContainer, {
            key: "body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9A5yV.default), {
            html: body
        }));
        const orderedContent = order.map((c)=>messageContent[c]);
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$ContentContainer, null, orderedContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$ButtonContainer, null, this.getPrimaryButton(), secondaryText ? this.getSecondaryButton() : null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hPd3F.default), {
            content: content,
            placement: position,
            isOpen: true
        }, children);
    }
    constructor(...args){
        super(...args);
        $ed290d22e560c9dd$var$_defineProperty(this, "onPrimaryClick", ()=>{
            this.props.fireClickEvent('primary');
        });
        $ed290d22e560c9dd$var$_defineProperty(this, "onSecondaryClick", ()=>{
            this.props.fireClickEvent('secondary');
        });
    }
}
$ed290d22e560c9dd$var$_defineProperty($ed290d22e560c9dd$export$c7313f750e9cbc9d, "defaultProps", {
    children: null,
    order: [
        'title',
        'image',
        'body'
    ],
    position: 'bottom left'
});
const $ed290d22e560c9dd$export$3660ec843fc5ef1b = (0, $3Npfo.default)($ed290d22e560c9dd$export$c7313f750e9cbc9d);
var $ed290d22e560c9dd$export$2e2bcd8739ae039 = (0, $k5HOq.default)($ed290d22e560c9dd$export$3660ec843fc5ef1b, 'inlineDialog');

});

parcelRegister("dMGoR", function(module, exports) {

var $7XNmJ = parcelRequire("7XNmJ");

const $52f07778744473c8$export$986a2ab002dbd574 = ()=>({
        name: 'forgeExtension',
        pmPlugins () {
            return [
                {
                    name: 'forgeExtensionUniqueId',
                    plugin: ()=>(0, $7XNmJ.createUniqueLocalIdPlugin)()
                }
            ];
        }
    });
module.exports["forgeEditorPlugin"] = $52f07778744473c8$export$986a2ab002dbd574;

});

parcelRegister("7XNmJ", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");


var $1S4f7 = parcelRequire("1S4f7");


var $3Ter7 = parcelRequire("3Ter7");


var $ks2lK = parcelRequire("ks2lK");


var $31HPn = parcelRequire("31HPn");

function $10ea5100eae0eecb$var$getForgeLocalIdFromNode(node) {
    return node.attrs.extensionType === (0, $31HPn.EXTENSION_NAMESPACE) ? node.attrs.parameters?.localId : undefined;
}
// When Forge extensions are copied, the attrs.localId should be the same as the attrs.parameters.localId.
// Otherwise, it won't be able to use the parameters.localId to locate the node (which is checked against by attrs.localId in editor-plugin-extension/src/pm-plugins/extension-api.ts).
function $10ea5100eae0eecb$var$handleForgeExtensionLocalId({ slice: slice, filterForgeExtensionNode: filterForgeExtensionNode }) {
    return (0, $3Ter7.mapSlice)(slice, (node)=>{
        if (filterForgeExtensionNode(node) && $10ea5100eae0eecb$var$getForgeLocalIdFromNode(node) !== node.attrs.localId) {
            const attrs = {
                ...node.attrs,
                localId: $10ea5100eae0eecb$var$getForgeLocalIdFromNode(node)
            };
            return node.type.create(attrs, node.content, node.marks);
        }
        return node;
    });
}
const $10ea5100eae0eecb$export$cb7a3598b76b7e74 = ()=>new (0, $1S4f7.SafePlugin)({
        key: new (0, $ks2lK.PluginKey)('forgeExtensionUniqueLocalIdPlugin'),
        props: {
            transformPasted: (slice, view)=>{
                const state = view.state;
                const { extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
                const extensionTypes = new Set([
                    extension,
                    bodiedExtension,
                    inlineExtension,
                    multiBodiedExtension
                ]);
                const forgeIdsObserved = new Set();
                const iterateExtensions = (fragment, handler)=>{
                    fragment.descendants((node, pos)=>{
                        if (!!node.type && extensionTypes.has(node.type)) {
                            handler(node, pos);
                            /**
							 * If it's a multiBodiedExtension or bodiedExtension, we'll need to keep digging;
							 * since we can have more extension nodes within the contents of that
							 */ return [
                                multiBodiedExtension,
                                bodiedExtension
                            ].includes(node.type);
                        }
                        /**
						 * Otherwise continue traversing, we can encounter extensions nested in
						 * expands/bodiedExtensions
						 */ return true;
                    });
                };
                // Loop through document to see what IDs are already in use
                iterateExtensions(state.doc, (node)=>{
                    const forgeLocalId = $10ea5100eae0eecb$var$getForgeLocalIdFromNode(node);
                    if (forgeLocalId) forgeIdsObserved.add(forgeLocalId);
                });
                // Now, loop through the pasted content and generate new IDs for any that are already in use
                iterateExtensions(slice.content, (node)=>{
                    const forgeLocalId = $10ea5100eae0eecb$var$getForgeLocalIdFromNode(node);
                    if (!forgeLocalId) return;
                    if (!forgeIdsObserved.has(forgeLocalId)) forgeIdsObserved.add(forgeLocalId);
                    else // attrs.localId will be updated in handleLocalId
                    node.attrs.parameters.localId = (0, $fO7hX.uuid).generate();
                });
                function filterForgeExtensionNode(node) {
                    return !!node.type && extensionTypes.has(node.type) && !!$10ea5100eae0eecb$var$getForgeLocalIdFromNode(node);
                }
                slice = $10ea5100eae0eecb$var$handleForgeExtensionLocalId({
                    slice: slice,
                    filterForgeExtensionNode: filterForgeExtensionNode
                });
                return slice;
            }
        }
    });
module.exports["createUniqueLocalIdPlugin"] = $10ea5100eae0eecb$export$cb7a3598b76b7e74;

});

parcelRegister("iHrpD", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $3Ter7 = parcelRequire("3Ter7");


var $1S4f7 = parcelRequire("1S4f7");


var $l6okE = parcelRequire("l6okE");

var $adhil = parcelRequire("adhil");


var $kMORl = parcelRequire("kMORl");

const $e91b9f4cdd3698fb$var$pluginName = 'legacyContentMacroPlugin';
const $e91b9f4cdd3698fb$var$pluginKey = new (0, $ks2lK.PluginKey)($e91b9f4cdd3698fb$var$pluginName);
const $e91b9f4cdd3698fb$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.migration';
const $e91b9f4cdd3698fb$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY = 'legacy-content';
const $e91b9f4cdd3698fb$var$isLegacyContentMacroExtension = (extensionNode)=>extensionNode.type.name === 'extension' && extensionNode.attrs?.extensionType === $e91b9f4cdd3698fb$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $e91b9f4cdd3698fb$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY;
const $e91b9f4cdd3698fb$export$a0ccdff7cb069dd7 = ({ config: config })=>{
    const isInnerEditor = !!config?.nodeId;
    return {
        name: $e91b9f4cdd3698fb$var$pluginName,
        pmPlugins () {
            return [
                {
                    name: $e91b9f4cdd3698fb$var$pluginName,
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            key: $e91b9f4cdd3698fb$var$pluginKey,
                            state: {
                                init () {
                                    return {
                                        nodeId: null,
                                        side: null,
                                        arrowKeyPressed: null,
                                        isSelectionAtEdge: null
                                    };
                                },
                                apply: (tr, currentPluginState)=>{
                                    const meta = tr.getMeta($e91b9f4cdd3698fb$var$pluginKey);
                                    if (meta) return {
                                        ...currentPluginState,
                                        ...meta
                                    };
                                    return currentPluginState;
                                }
                            },
                            props: {
                                handleDOMEvents: {
                                    keydown (view, event) {
                                        // If the user selects an LCM node and clicks an arrow, update the state with
                                        // the arrow they clicked and the selected node to use for keyboard navigation
                                        // logic in the extension-handler
                                        // We need to track two events to derive the user intention:
                                        //   1. Arrow key press event when selecting the node, to know whether the user
                                        //      is coming from the left or right gap cursor
                                        //   2. Arrow key press event when the node is selected, to know where to enter
                                        //      the legacy content macro
                                        // All of these keyboard events are only activated in the outer editor because
                                        // you can't have selections on the LCM node in the inner editor
                                        if (event instanceof KeyboardEvent && [
                                            'ArrowUp',
                                            'ArrowDown',
                                            'ArrowLeft',
                                            'ArrowRight'
                                        ].includes(event.key) && !isInnerEditor) {
                                            const { state: state, dispatch: dispatch } = view;
                                            const pluginState = $e91b9f4cdd3698fb$var$pluginKey.getState(state);
                                            // When hitting the gap cursor before or after an LCM
                                            if (state.selection instanceof (0, $adhil.GapCursorSelection) && (state.selection.side === (0, $adhil.Side).RIGHT && state.selection.$from.nodeBefore !== null && $e91b9f4cdd3698fb$var$isLegacyContentMacroExtension(state.selection.$from.nodeBefore) || state.selection.side === (0, $adhil.Side).LEFT && state.selection.$from.nodeAfter !== null && $e91b9f4cdd3698fb$var$isLegacyContentMacroExtension(state.selection.$from.nodeAfter))) dispatch(state.tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                side: state.selection.side
                                            }));
                                            else if (state.selection instanceof (0, $ks2lK.NodeSelection) && $e91b9f4cdd3698fb$var$isLegacyContentMacroExtension(state.selection.node) && // Moving from the left into the LCM
                                            (event.key === 'ArrowRight' && pluginState?.side === (0, $adhil.Side).LEFT || // Moving from the right into the LCM
                                            event.key === 'ArrowLeft' && pluginState?.side === (0, $adhil.Side).RIGHT)) {
                                                dispatch(state.tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                    nodeId: state.selection.node.attrs.localId,
                                                    arrowKeyPressed: event.key
                                                }));
                                                event.preventDefault();
                                            // When hitting the LCM from below or above
                                            } else if (state.selection instanceof (0, $ks2lK.NodeSelection) && $e91b9f4cdd3698fb$var$isLegacyContentMacroExtension(state.selection.node) && [
                                                'ArrowUp',
                                                'ArrowDown'
                                            ].includes(event.key)) {
                                                dispatch(state.tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                    nodeId: state.selection.node.attrs.localId,
                                                    // When using the up and down arrow keys intent isn't obvious, so we assume the user wants to enter from the end when coming up and enter from the left when coming down
                                                    side: event.key === 'ArrowUp' ? (0, $adhil.Side).RIGHT : (0, $adhil.Side).LEFT,
                                                    arrowKeyPressed: event.key
                                                }));
                                                event.preventDefault();
                                            }
                                        }
                                        // In the inner editor detect when we try exiting the LCM node and trigger
                                        // selecting the LCM node
                                        if (event instanceof KeyboardEvent && [
                                            'ArrowUp',
                                            'ArrowDown',
                                            'ArrowLeft',
                                            'ArrowRight'
                                        ].includes(event.key) && isInnerEditor) {
                                            const { state: state, dispatch: dispatch } = view;
                                            if (state.selection instanceof (0, $adhil.GapCursorSelection) && // Arrow moving up or left at the initial position of the encapsulating LCM
                                            ((event.key === 'ArrowUp' || event.key === 'ArrowLeft') && (0, $l6okE.atTheBeginningOfDoc)(state) || // Arrow moving down or right at the end position of the encapsulating LCM
                                            (event.key === 'ArrowDown' || event.key === 'ArrowRight') && (0, $l6okE.atTheEndOfDoc)(state))) dispatch(state.tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                nodeId: config.nodeId,
                                                isSelectionAtEdge: true
                                            }));
                                            else {
                                                const pluginState = $e91b9f4cdd3698fb$var$pluginKey.getState(state);
                                                if (pluginState?.isSelectionAtEdge) dispatch(state.tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                    isSelectionAtEdge: false
                                                }));
                                            }
                                        }
                                        return false;
                                    },
                                    blur (view) {
                                        // When entering the LCM editor from the outer editor, reset the state
                                        // to avoid unexpected selection issues
                                        if (!isInnerEditor) {
                                            const pluginState = $e91b9f4cdd3698fb$var$pluginKey.getState(view.state);
                                            if (pluginState?.arrowKeyPressed) {
                                                const { tr: tr } = view.state;
                                                tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                    nodeId: null,
                                                    side: null,
                                                    arrowKeyPressed: null
                                                });
                                                view.dispatch(tr);
                                            }
                                        }
                                    }
                                },
                                handleDrop (_view, _event, slice) {
                                    // Disable drag-and-drop for selections with a legacy content macro extensions
                                    const sliceHasLegacyContentMacro = (0, $3Ter7.hasNode)((node)=>$e91b9f4cdd3698fb$var$isLegacyContentMacroExtension(node))(slice);
                                    return sliceHasLegacyContentMacro;
                                }
                            }
                        });
                    }
                }
            ];
        },
        actions: {
            setSelection: $kMORl.setSelection
        },
        getSharedState (state) {
            if (!state) return undefined;
            const { nodeId: nodeId, side: side, arrowKeyPressed: arrowKeyPressed, isSelectionAtEdge: isSelectionAtEdge } = $e91b9f4cdd3698fb$var$pluginKey.getState(state) ?? {};
            return {
                nodeId: nodeId,
                side: side,
                arrowKeyPressed: arrowKeyPressed,
                isSelectionAtEdge: isSelectionAtEdge
            };
        }
    };
};
module.exports["legacyContentMacroPlugin"] = $e91b9f4cdd3698fb$export$a0ccdff7cb069dd7;

});

parcelRegister("kMORl", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $3ff08e22c2836b71$export$f6e36f80a8190133 = (selection)=>(state, dispatch)=>{
        if (!dispatch) return false;
        const emptySelection = (0, $ks2lK.TextSelection).create(state.doc, 0);
        const tr = state.tr.setSelection(selection ?? emptySelection);
        dispatch(tr);
        return true;
    };
module.exports["setSelection"] = $3ff08e22c2836b71$export$f6e36f80a8190133;

});

parcelRegister("ffQ2A", function(module, exports) {
const $b1b09ff39d31fcf8$var$instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $b1b09ff39d31fcf8$var$idbProxyableTypes;
let $b1b09ff39d31fcf8$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $b1b09ff39d31fcf8$var$getIdbProxyableTypes() {
    return $b1b09ff39d31fcf8$var$idbProxyableTypes || ($b1b09ff39d31fcf8$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $b1b09ff39d31fcf8$var$getCursorAdvanceMethods() {
    return $b1b09ff39d31fcf8$var$cursorAdvanceMethods || ($b1b09ff39d31fcf8$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $b1b09ff39d31fcf8$var$transactionDoneMap = new WeakMap();
const $b1b09ff39d31fcf8$var$transformCache = new WeakMap();
const $b1b09ff39d31fcf8$var$reverseTransformCache = new WeakMap();
function $b1b09ff39d31fcf8$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($b1b09ff39d31fcf8$export$4997ffc0176396a6(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    // This mapping exists in reverseTransformCache but doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $b1b09ff39d31fcf8$var$reverseTransformCache.set(promise, request);
    return promise;
}
function $b1b09ff39d31fcf8$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($b1b09ff39d31fcf8$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $b1b09ff39d31fcf8$var$transactionDoneMap.set(tx, done);
}
let $b1b09ff39d31fcf8$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $b1b09ff39d31fcf8$var$transactionDoneMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $b1b09ff39d31fcf8$export$4997ffc0176396a6(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $b1b09ff39d31fcf8$var$replaceTraps(callback) {
    $b1b09ff39d31fcf8$var$idbProxyTraps = callback($b1b09ff39d31fcf8$var$idbProxyTraps);
}
function $b1b09ff39d31fcf8$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($b1b09ff39d31fcf8$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($b1b09ff39d31fcf8$export$debb760848ca95a(this), args);
        return $b1b09ff39d31fcf8$export$4997ffc0176396a6(this.request);
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $b1b09ff39d31fcf8$export$4997ffc0176396a6(func.apply($b1b09ff39d31fcf8$export$debb760848ca95a(this), args));
    };
}
function $b1b09ff39d31fcf8$var$transformCachableValue(value) {
    if (typeof value === 'function') return $b1b09ff39d31fcf8$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $b1b09ff39d31fcf8$var$cacheDonePromiseForTransaction(value);
    if ($b1b09ff39d31fcf8$var$instanceOfAny(value, $b1b09ff39d31fcf8$var$getIdbProxyableTypes())) return new Proxy(value, $b1b09ff39d31fcf8$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $b1b09ff39d31fcf8$export$4997ffc0176396a6(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $b1b09ff39d31fcf8$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($b1b09ff39d31fcf8$var$transformCache.has(value)) return $b1b09ff39d31fcf8$var$transformCache.get(value);
    const newValue = $b1b09ff39d31fcf8$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $b1b09ff39d31fcf8$var$transformCache.set(value, newValue);
        $b1b09ff39d31fcf8$var$reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const $b1b09ff39d31fcf8$export$debb760848ca95a = (value)=>$b1b09ff39d31fcf8$var$reverseTransformCache.get(value);
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $b1b09ff39d31fcf8$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = $b1b09ff39d31fcf8$export$4997ffc0176396a6(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade($b1b09ff39d31fcf8$export$4997ffc0176396a6(request.result), event.oldVersion, event.newVersion, $b1b09ff39d31fcf8$export$4997ffc0176396a6(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $b1b09ff39d31fcf8$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return $b1b09ff39d31fcf8$export$4997ffc0176396a6(request).then(()=>undefined);
}
const $b1b09ff39d31fcf8$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $b1b09ff39d31fcf8$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $b1b09ff39d31fcf8$var$cachedMethods = new Map();
function $b1b09ff39d31fcf8$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($b1b09ff39d31fcf8$var$cachedMethods.get(prop)) return $b1b09ff39d31fcf8$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $b1b09ff39d31fcf8$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $b1b09ff39d31fcf8$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $b1b09ff39d31fcf8$var$cachedMethods.set(prop, method);
    return method;
}
$b1b09ff39d31fcf8$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$b1b09ff39d31fcf8$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$b1b09ff39d31fcf8$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));
const $b1b09ff39d31fcf8$var$advanceMethodProps = [
    'continue',
    'continuePrimaryKey',
    'advance'
];
const $b1b09ff39d31fcf8$var$methodMap = {};
const $b1b09ff39d31fcf8$var$advanceResults = new WeakMap();
const $b1b09ff39d31fcf8$var$ittrProxiedCursorToOriginalProxy = new WeakMap();
const $b1b09ff39d31fcf8$var$cursorIteratorTraps = {
    get (target, prop) {
        if (!$b1b09ff39d31fcf8$var$advanceMethodProps.includes(prop)) return target[prop];
        let cachedFunc = $b1b09ff39d31fcf8$var$methodMap[prop];
        if (!cachedFunc) cachedFunc = $b1b09ff39d31fcf8$var$methodMap[prop] = function(...args) {
            $b1b09ff39d31fcf8$var$advanceResults.set(this, $b1b09ff39d31fcf8$var$ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
        };
        return cachedFunc;
    }
};
async function* $b1b09ff39d31fcf8$var$iterate(...args) {
    // tslint:disable-next-line:no-this-assignment
    let cursor = this;
    if (!(cursor instanceof IDBCursor)) cursor = await cursor.openCursor(...args);
    if (!cursor) return;
    cursor;
    const proxiedCursor = new Proxy(cursor, $b1b09ff39d31fcf8$var$cursorIteratorTraps);
    $b1b09ff39d31fcf8$var$ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
    // Map this double-proxy back to the original, so other cursor methods work.
    $b1b09ff39d31fcf8$var$reverseTransformCache.set(proxiedCursor, $b1b09ff39d31fcf8$export$debb760848ca95a(cursor));
    while(cursor){
        yield proxiedCursor;
        // If one of the advancing methods was not called, call continue().
        cursor = await ($b1b09ff39d31fcf8$var$advanceResults.get(proxiedCursor) || cursor.continue());
        $b1b09ff39d31fcf8$var$advanceResults.delete(proxiedCursor);
    }
}
function $b1b09ff39d31fcf8$var$isIteratorProp(target, prop) {
    return prop === Symbol.asyncIterator && $b1b09ff39d31fcf8$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore,
        IDBCursor
    ]) || prop === 'iterate' && $b1b09ff39d31fcf8$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore
    ]);
}
$b1b09ff39d31fcf8$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get (target, prop, receiver) {
            if ($b1b09ff39d31fcf8$var$isIteratorProp(target, prop)) return $b1b09ff39d31fcf8$var$iterate;
            return oldTraps.get(target, prop, receiver);
        },
        has (target, prop) {
            return $b1b09ff39d31fcf8$var$isIteratorProp(target, prop) || oldTraps.has(target, prop);
        }
    }));
module.exports["unwrap"] = $b1b09ff39d31fcf8$export$debb760848ca95a;
module.exports["openDB"] = $b1b09ff39d31fcf8$export$ca0ed41b1a2af7e;

});

parcelRegister("awSMG", function(module, exports) {
/**
 * Database name prefix for offline editor databases.
 */ const $4ce470d2dd3584e9$export$6ff460ddb5710005 = 'editor:offline-steps-';
const $4ce470d2dd3584e9$export$7023de141f2ab721 = 'meta';
const $4ce470d2dd3584e9$export$3f9a6f7086c5c8f7 = 'steps';
module.exports["OFFLINE_STEPS_DATABASE_NAME_PREFIX"] = $4ce470d2dd3584e9$export$6ff460ddb5710005;
module.exports["OFFLINE_META_STORE_NAME"] = $4ce470d2dd3584e9$export$7023de141f2ab721;
module.exports["OFFLINE_STEPS_STORE_NAME"] = $4ce470d2dd3584e9$export$3f9a6f7086c5c8f7;

});

parcelRegister("arL2z", function(module, exports) {
$parcel$export(module.exports, "alignmentPlugin", () => (parcelRequire("hr8mu")).alignmentPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hr8mu = parcelRequire("hr8mu");


});

parcelRegister("6ukH4", function(module, exports) {
$parcel$export(module.exports, "annotationPlugin", () => (parcelRequire("cpn0f")).annotationPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cpn0f = parcelRequire("cpn0f");


});

parcelRegister("9sDYf", function(module, exports) {
$parcel$export(module.exports, "breakoutPlugin", () => (parcelRequire("cwPVT")).breakoutPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cwPVT = parcelRequire("cwPVT");


});

parcelRegister("8ElOg", function(module, exports) {
$parcel$export(module.exports, "contextPanelPlugin", () => (parcelRequire("1nZXu")).contextPanelPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1nZXu = parcelRequire("1nZXu");


});

parcelRegister("aAppb", function(module, exports) {
$parcel$export(module.exports, "extensionPlugin", () => (parcelRequire("eyggb")).extensionPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $eyggb = parcelRequire("eyggb");


});

parcelRegister("asQED", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $2daQU = parcelRequire("2daQU");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $7XPIt = parcelRequire("7XPIt");


var $42cjr = parcelRequire("42cjr");


var $2d38b = parcelRequire("2d38b");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $ht0Th = parcelRequire("ht0Th");


var $4aGJ9 = parcelRequire("4aGJ9");


var $hFGQl = parcelRequire("hFGQl");


var $1CpUP = parcelRequire("1CpUP");

const $27cf6bbb40785c7e$export$392ec14fa63f4ae3 = {
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    display: 'inline-block',
    verticalAlign: 'top',
    paddingLeft: "var(--ds-space-100, 8px)"
};
const $27cf6bbb40785c7e$export$63286b959e8d28b9 = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(24);
    const { webItems: webItems, actions: actions, modifications: modifications, className: className, id: id, disableIcons: disableIcons, webItemClassName: webItemClassName, ContainerTagName: ContainerTagName, pageId: pageId, dataTestId: dataTestId, contentSubType: contentSubType, hideDot: hideDot, source: source, noContainer: t0, useBadgeStyles: t1 } = props;
    const noContainer = t0 === undefined ? false : t0;
    const useBadgeStyles = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== actions || $[1] !== contentSubType || $[2] !== disableIcons || $[3] !== hideDot || $[4] !== modifications || $[5] !== pageId || $[6] !== source || $[7] !== useBadgeStyles || $[8] !== webItemClassName || $[9] !== webItems) {
        t2 = ()=>webItems.map((webItem)=>{
                const webItemProps = {
                    key: webItem.completeKey,
                    url: webItem.url,
                    id: webItem.id,
                    onClick: webItem.onClick || actions[webItem.moduleKey],
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(webItem.styleClass, webItemClassName, {
                        "with-dot": !hideDot
                    }),
                    params: webItem.params,
                    iconInfo: webItem.icon,
                    label: webItem.label,
                    tooltip: webItem.tooltip,
                    spinner: modifications[webItem.moduleKey] ? modifications[webItem.moduleKey].spinner : false,
                    disableIcon: disableIcons,
                    iconStyle: webItem.iconStyle,
                    addLargerMargin: hideDot,
                    useBylineStyles: hideDot
                };
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID)) webItemProps["data-jira-metadata-count"] = -1;
                if (pageId && webItem.id === (0, $hFGQl.DRAFT_STATUS_LOZENGE_ID)) {
                    if (webItem.moduleKey === (0, $hFGQl.SCHEDULED_STATUS_LOZENGE_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42cjr.ScheduledStatus), {
                        key: pageId,
                        contentId: pageId
                    });
                    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2d38b.DraftStatus), {
                        key: pageId,
                        contentId: pageId
                    });
                }
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_ATTACHMENTS_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7XPIt.ViewAttachmentsButton), {
                    key: "view-attachments-button"
                });
                if (webItem.id === (0, $hFGQl.INVITE_TO_EDIT_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                    style: $27cf6bbb40785c7e$export$392ec14fa63f4ae3,
                    key: "fabric-share"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE,
                    key: "share-and-restrict-button"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4aGJ9.ShareAndRestrictButton), {
                    contentId: webItem.contentId,
                    contentType: webItem.contentType ?? "page",
                    contentSubType: contentSubType || undefined,
                    source: source
                })));
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID)) return null;
                if (webItem.id === (0, $hFGQl.ANALYTICS_ADDON_ACTIONS_MENU_ID) || webItem.id === (0, $hFGQl.ANALYTICS_ADDON_BYLINE_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ht0Th.JiraButtonAnalyticsWrapper), {
                    key: webItem.completeKey
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1CpUP.WebItem), webItemProps));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1CpUP.WebItem), {
                    key: webItem.completeKey,
                    ...webItemProps,
                    useBadgeStyles: useBadgeStyles
                });
            });
        $[0] = actions;
        $[1] = contentSubType;
        $[2] = disableIcons;
        $[3] = hideDot;
        $[4] = modifications;
        $[5] = pageId;
        $[6] = source;
        $[7] = useBadgeStyles;
        $[8] = webItemClassName;
        $[9] = webItems;
        $[10] = t2;
    } else t2 = $[10];
    const renderWebItems = t2;
    if (noContainer) {
        let t3;
        if ($[11] !== renderWebItems) {
            t3 = renderWebItems();
            $[11] = renderWebItems;
            $[12] = t3;
        } else t3 = $[12];
        let t4;
        if ($[13] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t3);
            $[13] = t3;
            $[14] = t4;
        } else t4 = $[14];
        return t4;
    }
    const t3 = dataTestId || "web-item-wrapper";
    let t4;
    if ($[15] !== renderWebItems) {
        t4 = renderWebItems();
        $[15] = renderWebItems;
        $[16] = t4;
    } else t4 = $[16];
    let t5;
    if ($[17] !== ContainerTagName || $[18] !== className || $[19] !== dataTestId || $[20] !== id || $[21] !== t3 || $[22] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ContainerTagName, {
            className: className,
            id: id,
            "data-test-id": dataTestId,
            "data-testid": t3
        }, t4);
        $[17] = ContainerTagName;
        $[18] = className;
        $[19] = dataTestId;
        $[20] = id;
        $[21] = t3;
        $[22] = t4;
        $[23] = t5;
    } else t5 = $[23];
    return t5;
} : (props)=>{
    const { webItems: webItems, actions: actions, modifications: modifications, className: className, id: id, disableIcons: disableIcons, webItemClassName: webItemClassName, ContainerTagName: ContainerTagName, pageId: pageId, dataTestId: dataTestId, contentSubType: contentSubType, hideDot: hideDot, source: source, noContainer: noContainer = false, useBadgeStyles: useBadgeStyles = false } = props;
    const renderWebItems = ()=>webItems.map((webItem)=>{
            const webItemProps = {
                key: webItem.completeKey,
                url: webItem.url,
                id: webItem.id,
                onClick: webItem.onClick || actions[webItem.moduleKey],
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(webItem.styleClass, webItemClassName, {
                    'with-dot': // For live pages, hideDot will be true and we don't want to show dot separator
                    !hideDot
                }),
                params: webItem.params,
                iconInfo: webItem.icon,
                label: webItem.label,
                tooltip: webItem.tooltip,
                spinner: modifications[webItem.moduleKey] ? modifications[webItem.moduleKey].spinner : false,
                disableIcon: disableIcons,
                iconStyle: webItem.iconStyle,
                addLargerMargin: hideDot,
                useBylineStyles: hideDot
            };
            // Wow! The JIRA metadata item needs this data prop to work correctly! That was an easy debug ha hoo
            if (webItem.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID)) webItemProps['data-jira-metadata-count'] = -1;
            // "Unpublished Changes" lozenge
            if (pageId && webItem.id === (0, $hFGQl.DRAFT_STATUS_LOZENGE_ID)) {
                if (webItem.moduleKey === (0, $hFGQl.SCHEDULED_STATUS_LOZENGE_ID)) // Only show "Scheduled publish" lozenge
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42cjr.ScheduledStatus), {
                    key: pageId,
                    contentId: pageId
                });
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2d38b.DraftStatus), {
                    key: pageId,
                    contentId: pageId
                });
            }
            // TODO(brizvash): move the button to header, no need to check it all the time
            if (webItem.id === (0, $hFGQl.CONTENT_METADATA_ATTACHMENTS_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7XPIt.ViewAttachmentsButton), {
                key: "view-attachments-button"
            });
            if (webItem.id === (0, $hFGQl.INVITE_TO_EDIT_ID)) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: $27cf6bbb40785c7e$export$392ec14fa63f4ae3,
                key: "fabric-share"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE,
                key: "share-and-restrict-button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4aGJ9.ShareAndRestrictButton), {
                contentId: webItem.contentId,
                contentType: webItem.contentType ?? 'page',
                contentSubType: contentSubType || undefined,
                source: source
            }))));
            if (webItem.id === (0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID)) return null;
            if (webItem.id === (0, $hFGQl.ANALYTICS_ADDON_ACTIONS_MENU_ID) || webItem.id === (0, $hFGQl.ANALYTICS_ADDON_BYLINE_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
            if (webItem.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ht0Th.JiraButtonAnalyticsWrapper), {
                key: webItem.completeKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1CpUP.WebItem), webItemProps));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1CpUP.WebItem), {
                key: webItem.completeKey,
                ...webItemProps,
                useBadgeStyles: useBadgeStyles
            });
        });
    if (noContainer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderWebItems());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ContainerTagName, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        id: id,
        "data-test-id": dataTestId,
        "data-testid": dataTestId || 'web-item-wrapper'
    }, renderWebItems());
};
$27cf6bbb40785c7e$export$63286b959e8d28b9.displayName = 'WebItemList';
$27cf6bbb40785c7e$export$63286b959e8d28b9.defaultProps = {
    disableIcons: false,
    ContainerTagName: 'div',
    actions: {},
    modifications: {},
    noContainer: false,
    useBadgeStyles: false
};
$27cf6bbb40785c7e$export$63286b959e8d28b9.propTypes = {
    webItems: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).array,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    modifications: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    disableIcons: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    ContainerTagName: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    webItemClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    pageId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    dataTestId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    hideDot: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    noContainer: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
module.exports["SHARE_BTN_STYLE"] = $27cf6bbb40785c7e$export$392ec14fa63f4ae3;
module.exports["WebItemList"] = $27cf6bbb40785c7e$export$63286b959e8d28b9;

});

parcelRegister("7XPIt", function(module, exports) {
/* ViewAttachmentsButton.js generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $gmMgo = parcelRequire("gmMgo");


var $inPa6 = parcelRequire("inPa6");


var $4KS7f = parcelRequire("4KS7f");


var $9lz2c = parcelRequire("9lz2c");


var $2UWuP = parcelRequire("2UWuP");


var $jlIaF = parcelRequire("jlIaF");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5cc628dffabd5f14$var$ViewAttachmentsButtonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1gflidpf _yhjmidpf _1gqnidpf _11lvidpf _1hbsidpf _1u71idpf _y2qtidpf _fl8bidpf _4rtxtlke _jq8g1ul9 _14hp1ul9 _43dsazsu _oxk4azsu",
            __cmplp.className
        ])
    });
});
const $5cc628dffabd5f14$var$i18n = (0, $cgtv4.defineMessages)({
    attachments: {
        id: "attachments.view-attachments-button",
        defaultMessage: "View attachments"
    }
});
const $5cc628dffabd5f14$var$ATTACHMENTS_ANALYTICS_FROM_VIEW = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        actionSubject: 'ViewAttachmentsButton',
        source: 'attachments',
        attributes: {
            triggeredFrom: 'fromView'
        }
    }
};
const $5cc628dffabd5f14$export$6f695b80f23f4114 = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        actionSubject: 'ViewAttachmentsButton',
        source: 'attachments',
        attributes: {
            triggeredFrom: 'actionsMenu'
        }
    }
};
const $5cc628dffabd5f14$export$774c527e91be8e54 = ({ intl: intl })=>{
    const label = intl.formatMessage($5cc628dffabd5f14$var$i18n.attachments);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'feature',
            action: 'exposed',
            source: 'ViewAttachmentsButton',
            attributes: {
                isPageSSRd: window.__SSR_RENDERED__
            }
        }
    }).fire();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cc628dffabd5f14$var$ViewAttachmentsButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
        analyticsData: $5cc628dffabd5f14$var$ATTACHMENTS_ANALYTICS_FROM_VIEW
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/viewpageattachments.action?pageId=${contentId}&metadataLink=true`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9lz2c))), {
        spacing: "spacious",
        label: label
    }))))));
};
$5cc628dffabd5f14$export$774c527e91be8e54.propTypes = {
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};
const $5cc628dffabd5f14$export$5c9f1ebb6c75cefb = (0, $gmMgo.default)($5cc628dffabd5f14$export$774c527e91be8e54);
module.exports["ATTACHMENTS_ANALYTICS_FROM_ACTIONS_MENU"] = $5cc628dffabd5f14$export$6f695b80f23f4114;
module.exports["ViewAttachmentsButton"] = $5cc628dffabd5f14$export$5c9f1ebb6c75cefb;

});

parcelRegister("2UWuP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $Asv1P = parcelRequire("Asv1P");

const $1c62d6fee936c450$var$noop = ()=>{};
function $1c62d6fee936c450$export$907c57431ebf932({ children: children, analyticsData: analyticsData, innerRef: innerRef, wrapChildren: wrapChildren = false }) {
    const handler = children?.props?.onClick || $1c62d6fee936c450$var$noop;
    const handleClick = (0, $Asv1P.useCallbackWithAnalytics)(handler, analyticsData);
    if (wrapChildren) return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: innerRef,
        onMouseDown: handleClick
    }, children));
    return /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onClick: handleClick,
        ref: innerRef
    });
}
module.exports["WebItemAnalyticsWrapper"] = $1c62d6fee936c450$export$907c57431ebf932;

});

parcelRegister("42cjr", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $7f6808c58612208d$export$d10c0abe99daab65 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "a_lQj",
    name: "ScheduledStatus",
    loader: async ()=>(await (parcelRequire("86Yxv"))).ScheduledStatus
});
module.exports["ScheduledStatus"] = $7f6808c58612208d$export$d10c0abe99daab65;

});

parcelRegister("86Yxv", function(module, exports) {

let $5e7dd82834b8f00a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5e7dd82834b8f00a$var$load("Wowvf"),
    $5e7dd82834b8f00a$var$load("hhss7"),
    $5e7dd82834b8f00a$var$load("iWKl1")
]).then(()=>parcelRequire('dqNU1'));

});

parcelRegister("2d38b", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $30c96bfad3bb5778$export$ad9db10db9173ca8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6vTJj",
    name: "DraftStatus",
    loader: async ()=>(await (parcelRequire("fPRRP"))).DraftStatus
});
module.exports["DraftStatus"] = $30c96bfad3bb5778$export$ad9db10db9173ca8;

});

parcelRegister("fPRRP", function(module, exports) {

let $b8756756645cb48b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b8756756645cb48b$var$load("Wowvf"),
    $b8756756645cb48b$var$load("hhss7"),
    $b8756756645cb48b$var$load("jYr96")
]).then(()=>parcelRequire('1cgZV'));

});

parcelRegister("ht0Th", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $2UWuP = parcelRequire("2UWuP");


var $hFGQl = parcelRequire("hFGQl");

const $cb75d5f0a986326c$var$JIRA_ANALYTICS = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        source: 'viewPageScreen',
        actionSubject: 'JiraTicketsButton'
    }
};
function $cb75d5f0a986326c$export$549130614231f8f4({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const container = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        setTimeout(()=>{
            let linkVisible = false;
            const link = container?.current?.children?.[0, $hFGQl.CONTENT_METADATA_JIRA_ID];
            if (link && !link.classList.contains('hidden')) linkVisible = true;
            if (linkVisible) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: 'JiraTicketsButton',
                    action: 'shown',
                    source: 'viewPageScreen',
                    attributes: {
                        isPageSSRd: window.__SSR_RENDERED__
                    }
                }
            }).fire();
        }, 5000); // should be enough for render after the plugin has mounted
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
        analyticsData: $cb75d5f0a986326c$var$JIRA_ANALYTICS,
        innerRef: container,
        wrapChildren: true
    }, children);
}
$cb75d5f0a986326c$export$549130614231f8f4.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node
};
module.exports["JiraButtonAnalyticsWrapper"] = $cb75d5f0a986326c$export$549130614231f8f4;

});

parcelRegister("hFGQl", function(module, exports) {
const $d3e8bd0515c02c91$export$8b02acc4219d8357 = 'content-metadata-jira';
const $d3e8bd0515c02c91$export$a93781d2f10a1a54 = 'content-metadata-attachments';
const $d3e8bd0515c02c91$export$126027a563ee39b2 = 'content-metadata-page-restrictions';
const $d3e8bd0515c02c91$export$e5b04880f6b7bed = 'draft-status-lozenge';
const $d3e8bd0515c02c91$export$b6c67256b8045624 = 'status-lozenge-scheduled';
const $d3e8bd0515c02c91$export$1b048ac0db68f7ab = 'rte-button-restrictions';
const $d3e8bd0515c02c91$export$607df6eced5a588c = 'inviteToEdit';
const $d3e8bd0515c02c91$export$c8362b8678d6b894 = 'com.addonengine.analytics__analytics-content-byline-item';
const $d3e8bd0515c02c91$export$de7935ab18e02484 = 'com.addonengine.analytics__analytics-content-menu-item';
const $d3e8bd0515c02c91$export$a643e9449b465583 = 'com.addonengine.analytics.moderate__analytics-content-menu-item';
module.exports["CONTENT_METADATA_JIRA_ID"] = $d3e8bd0515c02c91$export$8b02acc4219d8357;
module.exports["CONTENT_METADATA_ATTACHMENTS_ID"] = $d3e8bd0515c02c91$export$a93781d2f10a1a54;
module.exports["CONTENT_METADATA_PAGE_RESTRICTIONS_ID"] = $d3e8bd0515c02c91$export$126027a563ee39b2;
module.exports["DRAFT_STATUS_LOZENGE_ID"] = $d3e8bd0515c02c91$export$e5b04880f6b7bed;
module.exports["SCHEDULED_STATUS_LOZENGE_ID"] = $d3e8bd0515c02c91$export$b6c67256b8045624;
module.exports["EDIT_PAGE_METADATA_RESTRICTIONS_ID"] = $d3e8bd0515c02c91$export$1b048ac0db68f7ab;
module.exports["INVITE_TO_EDIT_ID"] = $d3e8bd0515c02c91$export$607df6eced5a588c;
module.exports["ANALYTICS_ADDON_BYLINE_ID"] = $d3e8bd0515c02c91$export$c8362b8678d6b894;
module.exports["ANALYTICS_ADDON_ACTIONS_MENU_ID"] = $d3e8bd0515c02c91$export$de7935ab18e02484;
module.exports["ANALYTICS_MODERATE_ADDON_ACTIONS_MENU_ID"] = $d3e8bd0515c02c91$export$a643e9449b465583;

});

parcelRegister("4aGJ9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7d2Nc = parcelRequire("7d2Nc");


var $9wGTI = parcelRequire("9wGTI");


var $ln0hx = parcelRequire("ln0hx");


var $irVI7 = parcelRequire("irVI7");


var $gw4Bt = parcelRequire("gw4Bt");


var $2Ppk3 = parcelRequire("2Ppk3");

const $67cd68d5c5612721$export$5894b1d1838f517c = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] !== props.contentId) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
            metric: (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD),
            isCustomStart: true,
            key: props.contentId
        });
        $[0] = props.contentId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE)
        });
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== props) {
        t2 = !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Ppk3.ShareAndRestrictButtonLoader), props) : (0, $9wGTI.fg)("confluence_frontend_usd_ssr") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Ppk3.ShareAndRestrictButtonSSRLoader), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Ppk3.ShareAndRestrictButtonLoader), props);
        $[3] = props;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t0 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t0, t1, t2);
        $[5] = t0;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD),
        isCustomStart: true,
        key: props.contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE)
    }), !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Ppk3.ShareAndRestrictButtonLoader), props) : (0, $9wGTI.fg)('confluence_frontend_usd_ssr') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Ppk3.ShareAndRestrictButtonSSRLoader), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Ppk3.ShareAndRestrictButtonLoader), props));
module.exports["ShareAndRestrictButton"] = $67cd68d5c5612721$export$5894b1d1838f517c;

});

parcelRegister("2Ppk3", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $2pIlF = parcelRequire("2pIlF");


const $e72e8fb00bfcbe3f$export$58f1301a9e949269 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Oh2D2",
    name: "ShareAndRestrictButtonSSRLoader",
    loader: async ()=>(await (parcelRequire("l4zNE"))).ShareRestrictAndCopyCoordinator
});

const $e72e8fb00bfcbe3f$export$3f53fee84268f3f4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ImqyR",
    name: "ShareAndRestrictButtonLoader",
    loader: async ()=>(await (parcelRequire("l4zNE"))).ShareRestrictAndCopyCoordinator,
    loading: (0, $2pIlF.ShareRestrictAndCopyButtonPlaceholder)
});
module.exports["ShareAndRestrictButtonSSRLoader"] = $e72e8fb00bfcbe3f$export$58f1301a9e949269;
module.exports["ShareAndRestrictButtonLoader"] = $e72e8fb00bfcbe3f$export$3f53fee84268f3f4;

});

parcelRegister("2pIlF", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");

var $9gE7g = parcelRequire("9gE7g");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $luv00 = parcelRequire("luv00");


var $lT8a1 = parcelRequire("lT8a1");

const $4c5c52253c9aa054$var$iconSkeletonStyle = (0, $ecnYn.xcss)({
    width: '16px',
    height: '16px',
    borderRadius: 'radius.xsmall',
    background: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"
});
const $4c5c52253c9aa054$var$SkeletonGlyph = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "icon-skeleton",
            xcss: $4c5c52253c9aa054$var$iconSkeletonStyle
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "icon-skeleton",
        xcss: $4c5c52253c9aa054$var$iconSkeletonStyle
    });
const $4c5c52253c9aa054$export$4d89be89896b480 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9gE7g.SplitButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lT8a1.ShareAndRestrictButtonPlaceholder), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            testId: "copy-link-button-placeholder",
            icon: $4c5c52253c9aa054$var$SkeletonGlyph,
            label: "",
            isDisabled: true
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== ssrPlaceholderIdProp) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", ssrPlaceholderIdProp, t0);
        $[1] = ssrPlaceholderIdProp;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", ssrPlaceholderIdProp, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9gE7g.SplitButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lT8a1.ShareAndRestrictButtonPlaceholder), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        testId: "copy-link-button-placeholder",
        icon: $4c5c52253c9aa054$var$SkeletonGlyph,
        label: "",
        isDisabled: true
    })));
};
module.exports["ShareRestrictAndCopyButtonPlaceholder"] = $4c5c52253c9aa054$export$4d89be89896b480;

});

parcelRegister("lT8a1", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $ccHMk = parcelRequire("ccHMk");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $Qy97i = parcelRequire("Qy97i");

const $1b4f772a0e4dae00$var$iconSkeletonStyle = (0, $ecnYn.xcss)({
    width: '16px',
    height: '16px',
    borderRadius: 'radius.xsmall',
    marginLeft: 'space.050',
    marginRight: 'space.025',
    background: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"
});
const $1b4f772a0e4dae00$var$SkeletonGlyph = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "icon-skeleton",
            xcss: $1b4f772a0e4dae00$var$iconSkeletonStyle
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "icon-skeleton",
        xcss: $1b4f772a0e4dae00$var$iconSkeletonStyle
    });
const $1b4f772a0e4dae00$export$b125768944fa8b3 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "default",
            iconBefore: $1b4f772a0e4dae00$var$_temp,
            onClick: $1b4f772a0e4dae00$var$_temp2,
            isDisabled: true,
            testId: "share-and-restrict-button-placeholder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $Qy97i.i18n).share));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1b4f772a0e4dae00$var$SkeletonGlyph, null),
        onClick: ()=>{},
        isDisabled: true,
        testId: "share-and-restrict-button-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $Qy97i.i18n).share));
function $1b4f772a0e4dae00$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1b4f772a0e4dae00$var$SkeletonGlyph, null);
}
function $1b4f772a0e4dae00$var$_temp2() {}
module.exports["ShareAndRestrictButtonPlaceholder"] = $1b4f772a0e4dae00$export$b125768944fa8b3;

});

parcelRegister("Qy97i", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $a3fRD = parcelRequire("a3fRD");


var $3gadb = parcelRequire("3gadb");


var $9Q2dU = parcelRequire("9Q2dU");


var $h1ewt = parcelRequire("h1ewt");


var $2Snr1 = parcelRequire("2Snr1");

const $e65d026078d2a5b9$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    share: {
        id: "share-and-restrict-dialog.controlled-share-button.share",
        defaultMessage: "Share"
    },
    shareArialLabel: {
        id: "share-and-restrict-dialog.controlled-share-button.share-aria-label",
        defaultMessage: "Share, {tooltipMessage}"
    }
});
const $e65d026078d2a5b9$var$ICON_PROP_TO_ICON_COMPONENT = {
    open: (0, (/*@__PURE__*/$parcel$interopDefault($h1ewt))),
    restricted: (0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))),
    public: (0, $2Snr1.WorldGreenDotGlyph),
    error: (0, (/*@__PURE__*/$parcel$interopDefault($a3fRD)))
};
const $e65d026078d2a5b9$var$makeIconProps = (icon, isDisabled)=>{
    if (isDisabled) return {
        color: "var(--ds-icon-disabled, #080F214A)"
    };
    switch(icon){
        case 'error':
            return {
                color: "var(--ds-icon-danger, #C9372C)"
            };
        case 'restricted':
            return {
                color: "var(--ds-icon-danger, #C9372C)"
            };
        default:
            return {
                color: "var(--ds-icon-subtle, #505258)"
            };
    }
};
const $e65d026078d2a5b9$export$f939f151d984bfc = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { icon: icon, onClick: onClick, tooltipMessage: tooltipMessage, isDisabled: isDisabled, children: children, focusRef: focusRef } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const Icon = $e65d026078d2a5b9$var$ICON_PROP_TO_ICON_COMPONENT[icon];
    let t1;
    if ($[0] !== icon || $[1] !== isDisabled) {
        t1 = $e65d026078d2a5b9$var$makeIconProps(icon, isDisabled);
        $[0] = icon;
        $[1] = isDisabled;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = {
            label: "",
            ...t1
        };
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const iconProps = t2;
    let t3;
    if ($[5] !== formatMessage || $[6] !== tooltipMessage) {
        t3 = formatMessage(tooltipMessage);
        $[5] = formatMessage;
        $[6] = tooltipMessage;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== children) {
        t4 = ()=>!children;
        $[8] = children;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== Icon || $[11] !== iconProps) {
        t5 = (parentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                ...parentProps,
                ...iconProps
            });
        $[10] = Icon;
        $[11] = iconProps;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== formatMessage || $[14] !== tooltipMessage) {
        t6 = formatMessage($e65d026078d2a5b9$export$a7357cdd1f0b0168.shareArialLabel, {
            tooltipMessage: formatMessage(tooltipMessage)
        });
        $[13] = formatMessage;
        $[14] = tooltipMessage;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e65d026078d2a5b9$export$a7357cdd1f0b0168.share);
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== children || $[18] !== focusRef || $[19] !== isDisabled || $[20] !== onClick || $[21] !== t5 || $[22] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            iconBefore: t5,
            onClick: onClick,
            "aria-label": t6,
            isDisabled: isDisabled,
            ref: focusRef,
            testId: "controlled-share-button"
        }, children, t7);
        $[17] = children;
        $[18] = focusRef;
        $[19] = isDisabled;
        $[20] = onClick;
        $[21] = t5;
        $[22] = t6;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== t3 || $[25] !== t4 || $[26] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t3,
            position: "bottom",
            canAppear: t4,
            hideTooltipOnMouseDown: true,
            ignoreTooltipPointerEvents: true,
            delay: 100
        }, t8);
        $[24] = t3;
        $[25] = t4;
        $[26] = t8;
        $[27] = t9;
    } else t9 = $[27];
    return t9;
} : ({ icon: icon, onClick: onClick, tooltipMessage: tooltipMessage, isDisabled: isDisabled, children: children, focusRef: focusRef })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const Icon = $e65d026078d2a5b9$var$ICON_PROP_TO_ICON_COMPONENT[icon];
    const iconProps = {
        label: '',
        ...$e65d026078d2a5b9$var$makeIconProps(icon, isDisabled)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage(tooltipMessage),
        position: "bottom",
        canAppear: ()=>!children,
        hideTooltipOnMouseDown: true,
        ignoreTooltipPointerEvents: true,
        delay: 100
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        iconBefore: (parentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                ...parentProps,
                ...iconProps
            }),
        onClick: onClick,
        "aria-label": formatMessage($e65d026078d2a5b9$export$a7357cdd1f0b0168.shareArialLabel, {
            tooltipMessage: formatMessage(tooltipMessage)
        }),
        isDisabled: isDisabled,
        ref: focusRef,
        testId: "controlled-share-button"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e65d026078d2a5b9$export$a7357cdd1f0b0168.share)));
};
module.exports["i18n"] = $e65d026078d2a5b9$export$a7357cdd1f0b0168;
module.exports["ControlledShareButton"] = $e65d026078d2a5b9$export$f939f151d984bfc;

});

parcelRegister("l4zNE", function(module, exports) {

let $f575bdcea4ef9c58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f575bdcea4ef9c58$var$load("jFI2g"),
    $f575bdcea4ef9c58$var$load("e9JE4"),
    $f575bdcea4ef9c58$var$load("e4GNb"),
    $f575bdcea4ef9c58$var$load("2SjHp"),
    $f575bdcea4ef9c58$var$load("h4Nf7"),
    $f575bdcea4ef9c58$var$load("6XCf4"),
    $f575bdcea4ef9c58$var$load("1qlDN"),
    $f575bdcea4ef9c58$var$load("1yVM6"),
    $f575bdcea4ef9c58$var$load("cyGuT"),
    $f575bdcea4ef9c58$var$load("jXx9i"),
    $f575bdcea4ef9c58$var$load("bunf9"),
    $f575bdcea4ef9c58$var$load("kUbUu"),
    $f575bdcea4ef9c58$var$load("7Q5vz"),
    $f575bdcea4ef9c58$var$load("6FuHS"),
    $f575bdcea4ef9c58$var$load("eyaRC"),
    $f575bdcea4ef9c58$var$load("f1NVy"),
    $f575bdcea4ef9c58$var$load("6wr18"),
    $f575bdcea4ef9c58$var$load("kjZZD"),
    $f575bdcea4ef9c58$var$load("Wowvf"),
    $f575bdcea4ef9c58$var$load("7EorR"),
    $f575bdcea4ef9c58$var$load("hhss7"),
    $f575bdcea4ef9c58$var$load("ffEVr"),
    $f575bdcea4ef9c58$var$load("c4Kdp"),
    $f575bdcea4ef9c58$var$load("4opMD")
]).then(()=>parcelRequire('8bw1z'));

});

parcelRegister("1CpUP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $2daQU = parcelRequire("2daQU");


var $5qzNs = parcelRequire("5qzNs");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $3gadb = parcelRequire("3gadb");


var $bCECL = parcelRequire("bCECL");

function $12dd715bfa1d104a$var$_defineProperty(e, r, t) {
    return (r = $12dd715bfa1d104a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $12dd715bfa1d104a$var$_toPropertyKey(t) {
    var i = $12dd715bfa1d104a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $12dd715bfa1d104a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $12dd715bfa1d104a$var$imageStyles = null;
// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
const $12dd715bfa1d104a$var$baseStyles = null;
const $12dd715bfa1d104a$var$largeMargin = null;
const $12dd715bfa1d104a$var$bylineStyles = null;
const $12dd715bfa1d104a$var$badgeStyles = null;
const $12dd715bfa1d104a$var$WebItemTooltip = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { tooltip: tooltip, children: children } = t0;
    if (tooltip) {
        let t1;
        if ($[0] !== children) {
            t1 = (tooltipProps)=>children(tooltipProps);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== t1 || $[3] !== tooltip) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: tooltip
            }, t1);
            $[2] = t1;
            $[3] = tooltip;
            $[4] = t2;
        } else t2 = $[4];
        return t2;
    }
    let t1;
    if ($[5] !== children) {
        t1 = children({});
        $[5] = children;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ tooltip: tooltip, children: children })=>{
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltip
    }, (tooltipProps)=>children(tooltipProps));
    return children({});
};
$12dd715bfa1d104a$var$WebItemTooltip.propTypes = {
    /**
   * Tooltip of the web item
   */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
const $12dd715bfa1d104a$var$WebItemIcon = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    let addLargerMargin;
    let classes;
    let icon;
    let id;
    let label;
    let onClick;
    let otherProps;
    let style;
    let tooltip;
    let url;
    let useBadgeStyles;
    let useBylineStyles;
    if ($[0] !== t0) {
        ({ classes: classes, id: id, url: url, label: label, tooltip: tooltip, onClick: onClick, style: style, icon: icon, addLargerMargin: addLargerMargin, useBylineStyles: useBylineStyles, useBadgeStyles: useBadgeStyles, ...otherProps } = t0);
        $[0] = t0;
        $[1] = addLargerMargin;
        $[2] = classes;
        $[3] = icon;
        $[4] = id;
        $[5] = label;
        $[6] = onClick;
        $[7] = otherProps;
        $[8] = style;
        $[9] = tooltip;
        $[10] = url;
        $[11] = useBadgeStyles;
        $[12] = useBylineStyles;
    } else {
        addLargerMargin = $[1];
        classes = $[2];
        icon = $[3];
        id = $[4];
        label = $[5];
        onClick = $[6];
        otherProps = $[7];
        style = $[8];
        tooltip = $[9];
        url = $[10];
        useBadgeStyles = $[11];
        useBylineStyles = $[12];
    }
    let t1;
    if ($[13] !== addLargerMargin || $[14] !== classes || $[15] !== icon || $[16] !== id || $[17] !== label || $[18] !== onClick || $[19] !== otherProps || $[20] !== style || $[21] !== url || $[22] !== useBadgeStyles || $[23] !== useBylineStyles) {
        t1 = (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                "data-testId": "web-item-link",
                className: (0, $gMc0m.default)([
                    "_2hwxu2gc _vwz4bs82",
                    addLargerMargin && "_2hwx14h2 _vwz41vhj",
                    useBylineStyles && "_syazd34b",
                    useBadgeStyles && "_2rko12b0 _zulp1b66 _1yt41b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c1txw _vwz47vkz _2hwxze3t _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31dpa _1bnxagmp _1di6fcek _c2waglyw",
                    classes
                ]),
                href: url,
                id: id,
                onClick: onClick,
                style: style,
                ...tooltipProps,
                ...otherProps
            }, icon, typeof label === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                dangerouslySetInnerHTML: {
                    __html: label
                }
            }) : label);
        $[13] = addLargerMargin;
        $[14] = classes;
        $[15] = icon;
        $[16] = id;
        $[17] = label;
        $[18] = onClick;
        $[19] = otherProps;
        $[20] = style;
        $[21] = url;
        $[22] = useBadgeStyles;
        $[23] = useBylineStyles;
        $[24] = t1;
    } else t1 = $[24];
    let t2;
    if ($[25] !== t1 || $[26] !== tooltip) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12dd715bfa1d104a$var$WebItemTooltip, {
            tooltip: tooltip
        }, t1);
        $[25] = t1;
        $[26] = tooltip;
        $[27] = t2;
    } else t2 = $[27];
    return t2;
} : ({ classes: classes, id: id, url: url, label: label, tooltip: tooltip, onClick: onClick, style: style, icon: icon, addLargerMargin: addLargerMargin, useBylineStyles: useBylineStyles, useBadgeStyles: useBadgeStyles, ...otherProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12dd715bfa1d104a$var$WebItemTooltip, {
        tooltip: tooltip
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            "data-testId": "web-item-link" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            ,
            className: (0, $gMc0m.default)([
                "_2hwxu2gc _vwz4bs82",
                addLargerMargin && "_2hwx14h2 _vwz41vhj",
                useBylineStyles && "_syazd34b",
                useBadgeStyles && "_2rko12b0 _zulp1b66 _1yt41b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c1txw _vwz47vkz _2hwxze3t _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31dpa _1bnxagmp _1di6fcek _c2waglyw",
                classes
            ]),
            href: url,
            id: id,
            onClick: onClick,
            style: style,
            ...tooltipProps,
            ...otherProps
        }, icon, typeof label === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            dangerouslySetInnerHTML: {
                __html: label
            }
        }) : label));
};
$12dd715bfa1d104a$var$WebItemIcon.propTypes = {
    /**
   * classes to use for the component
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * id passed from WebItem
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Route where the web item will point
   */ url: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Label of the web item
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Tooltip of the web item
   */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Handler for clicks
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    /**
   * WebItem styles
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Icon obj
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Will be true for live pages since apps have different styling
   */ addLargerMargin: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
   * Will be true for live pages since apps have different styling
   */ useBylineStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
class $12dd715bfa1d104a$export$1c46d4b85d455dd4 extends (0, $42omo.PureComponent) {
    getIcon() {
        const { disableIcon: disableIcon, params: params, iconStyle: iconStyle, spinner: spinner, iconInfo: iconInfo, label: label, iconSize: iconSize } = this.props;
        let auiIconClass = params && params.iconClass;
        if (disableIcon) return null;
        if (spinner) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            testId: "spinner",
            size: "small"
        });
        if (iconInfo && iconInfo.path) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        , {
            style: iconStyle,
            src: iconInfo.path,
            width: iconInfo.width,
            height: iconInfo.height,
            alt: label,
            title: label,
            className: (0, $gMc0m.default)([
                "_c71l1osq _4t3i1wug _1e0c1o8l _s7n4nkob _2hwx14y2"
            ])
        });
        if (auiIconClass) {
            if (auiIconClass.indexOf('aui-iconfont-') === -1) auiIconClass = `aui-iconfont-${auiIconClass}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
                iconSize: iconSize,
                className: auiIconClass,
                style: iconStyle
            });
        }
        return null;
    }
    render() {
        const { className: className, id: id, url: url, type: type, label: label, tooltip: tooltip, onClick: onClick, style: style, ...otherProps } = this.props;
        const buttonType = type === 'primary' ? 'aui-button-primary' : '';
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(className, buttonType);
        const icon = this.getIcon(); //react complains about these extra props but we still need to pass otherProps (e.g. data-jira-metadata-count)
        const webItemIconProps = (0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))({
            classes: classes,
            id: id,
            url: url,
            label: label,
            tooltip: tooltip,
            onClick: onClick,
            style: style,
            icon: icon,
            ...otherProps
        }, [
            'disableIcon',
            'iconStyle',
            'spinner',
            'iconInfo',
            'iconSize'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12dd715bfa1d104a$var$WebItemIcon, webItemIconProps);
    }
}
$12dd715bfa1d104a$var$_defineProperty($12dd715bfa1d104a$export$1c46d4b85d455dd4, "propTypes", {
    /**
   * Classnames. Note that WebItem no longer assumes that it should render as a button
   * And as such you may need to explicitly pass the `aui-button` class here.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * id
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Route where the web item will point
   */ url: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Type of the button
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Label of the web item
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Tooltip of the web item
   */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Handler for clicks
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    /**
   * Contain parameters setted in the descriptor
   */ params: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Doesn't render icons when true
   */ disableIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
   * icon information used for absolute images
   */ iconInfo: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).shape({
        path: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number,
        height: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number
    }),
    /**
   * Show spinner instead of an icon if equals true
   */ spinner: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
   * WebItem styles
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Icon styles
   */ iconStyle: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    iconSize: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Will be true for live pages since apps have different styling
   */ addLargerMargin: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
   * Will be true for live pages since apps have different styling
   */ useBylineStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
});
$12dd715bfa1d104a$var$_defineProperty($12dd715bfa1d104a$export$1c46d4b85d455dd4, "defaultProps", {
    spinner: false,
    iconStyle: {},
    style: {},
    iconSize: 'small'
});
module.exports["WebItem"] = $12dd715bfa1d104a$export$1c46d4b85d455dd4;

});

parcelRegister("6fwOO", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");

var $19Jj3 = parcelRequire("19Jj3");

var $aG6kF = parcelRequire("aG6kF");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");


var $gj7hi = parcelRequire("gj7hi");


var $5Mmzd = parcelRequire("5Mmzd");


var $8lKIo = parcelRequire("8lKIo");


var $6yyWj = parcelRequire("6yyWj");


var $inPa6 = parcelRequire("inPa6");


var $daw2l = parcelRequire("daw2l");


var $eCryJ = parcelRequire("eCryJ");


var $3IBnw = parcelRequire("3IBnw");

const $12b6fa95758c8d8a$var$SpotlightTourContext = /*#__PURE__*/ (0, $42omo.createContext)({
    currentStep: null,
    isEnrolled: false
}); // Move cssMap to top-level scope
const $12b6fa95758c8d8a$var$SpotlightBodyStyles = {
    root: "_195gmgjw"
};
const $12b6fa95758c8d8a$var$imageStyles = null; // Generic step content component
const $12b6fa95758c8d8a$var$SpotlightStep = ({ currentStep: currentStep, totalSteps: totalSteps, headlineMessage: headlineMessage, bodyMessage: bodyMessage, image: image, paddingInline: paddingInline = 'space.200', showBackButton: showBackButton = false, primaryActionLabel: primaryActionLabel, onBack: onBack, footerOrder: footerOrder = 'count-first' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage(headlineMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $12b6fa95758c8d8a$var$SpotlightBodyStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingInline: paddingInline,
        paddingBlockEnd: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage(bodyMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: image,
        alt: "",
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1wug"
        ])
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, footerOrder === 'actions-first' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, showBackButton && onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19Jj3.SpotlightSecondaryAction), {
        onClick: onBack
    }, formatMessage((0, $6yyWj.messages).back)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), null, formatMessage(primaryActionLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG6kF.SpotlightStepCount), null, formatMessage((0, $6yyWj.messages).stepCount, {
        current: currentStep + 1,
        total: totalSteps
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG6kF.SpotlightStepCount), null, formatMessage((0, $6yyWj.messages).stepCount, {
        current: currentStep + 1,
        total: totalSteps
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, showBackButton && onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19Jj3.SpotlightSecondaryAction), {
        onClick: onBack
    }, formatMessage((0, $6yyWj.messages).back)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), null, formatMessage(primaryActionLabel))))));
};
const $12b6fa95758c8d8a$export$8343e683bc14cced = ({ children: children, shouldShowTour: shouldShowTour, isEnrolled: isEnrolled = false, onTourComplete: onTourComplete, onTourDismiss: onTourDismiss })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [currentStep, setCurrentStep] = (0, $42omo.useState)(shouldShowTour && isEnrolled ? 0 : null);
    const totalSteps = 2; // Step 1 (page title) and Step 2 (share button)
    (0, $42omo.useEffect)(()=>{
        if (shouldShowTour && isEnrolled) // Wait for one frame to ensure layout has settled and targets are in DOM
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                setCurrentStep(0);
            });
        });
        else setCurrentStep(null);
    }, [
        shouldShowTour,
        isEnrolled
    ]);
    const next = ()=>{
        setCurrentStep((prev)=>{
            if (prev === null) return 0; // Track next action with current step before moving forward
            (0, $daw2l.trackSpotlightEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                action: 'next',
                step: prev
            });
            const nextStep = prev + 1;
            if (nextStep >= totalSteps) {
                endTour(true);
                return null;
            }
            return nextStep;
        });
    };
    const back = ()=>{
        setCurrentStep((prev)=>prev === null ? 0 : Math.max(prev - 1, 0));
    };
    const endTour = (isComplete)=>{
        const stepToTrack = currentStep;
        setCurrentStep(null); // Track dismissal or completion
        if (isComplete) {
            (0, $daw2l.trackSpotlightEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                action: 'completed',
                step: stepToTrack
            });
            if (onTourComplete) onTourComplete();
        } else {
            (0, $daw2l.trackSpotlightEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                action: 'dismissed',
                step: stepToTrack
            });
            if (onTourDismiss) onTourDismiss();
        }
    };
    const done = ()=>endTour(true);
    const dismiss = ()=>endTour(false); // Handle errors and send operational event
    const handleError = (0, $42omo.useCallback)((error, errorInfo)=>{
        (0, $daw2l.trackErrorEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            error: error,
            errorInfo: errorInfo,
            componentName: 'export-jira-context-nudge-spotlight-tour'
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS,
        renderOnError: ()=>children,
        onError: handleError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12b6fa95758c8d8a$var$SpotlightTourContext.Provider, {
        value: (0, $42omo.useMemo)(()=>({
                currentStep: currentStep,
                isEnrolled: isEnrolled
            }), [
            currentStep,
            isEnrolled
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, children, currentStep === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        isVisible: true,
        placement: "left-end",
        dismiss: dismiss,
        done: next
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12b6fa95758c8d8a$var$SpotlightStep, {
        currentStep: currentStep,
        totalSteps: totalSteps,
        headlineMessage: (0, $6yyWj.messages).stepOneHeadline,
        bodyMessage: (0, $6yyWj.messages).stepOneBody,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($5Mmzd))),
        showBackButton: false,
        primaryActionLabel: (0, $6yyWj.messages).next,
        onBack: undefined,
        footerOrder: "count-first"
    })), currentStep === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        isVisible: true,
        placement: "bottom-start",
        dismiss: dismiss,
        done: done
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12b6fa95758c8d8a$var$SpotlightStep, {
        currentStep: currentStep,
        totalSteps: totalSteps,
        headlineMessage: (0, $6yyWj.messages).stepTwoHeadline,
        bodyMessage: (0, $6yyWj.messages).stepTwoBody,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($8lKIo))),
        showBackButton: true,
        primaryActionLabel: (0, $6yyWj.messages).done,
        onBack: back,
        footerOrder: "count-first"
    })))));
};
const $12b6fa95758c8d8a$export$1c3dc5815d8870ee = ({ children: children, stepIndex: stepIndex })=>{
    const { currentStep: currentStep, isEnrolled: isEnrolled } = (0, $42omo.useContext)($12b6fa95758c8d8a$var$SpotlightTourContext); // Only render as PopoverTarget when this step is active and user is enrolled
    // PopoverProvider can only handle one PopoverTarget at a time
    const shouldRenderTarget = currentStep === stepIndex && isEnrolled;
    if (shouldRenderTarget) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children);
     // Otherwise just render children normally
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
module.exports["ExperimentExportJiraContextToPageNudgeSpotlightTour"] = $12b6fa95758c8d8a$export$8343e683bc14cced;
module.exports["ExperimentExportJiraContextToPageNudgeSpotlightStepWrapper"] = $12b6fa95758c8d8a$export$1c3dc5815d8870ee;

});

parcelRegister("5Mmzd", function(module, exports) {
module.exports = new URL("step-one.dcc386c3.svg", import.meta.url).toString();

});

parcelRegister("8lKIo", function(module, exports) {
module.exports = new URL("step-two.cd055733.svg", import.meta.url).toString();

});

parcelRegister("6yyWj", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $96b51e9a0b93ad79$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    // Step 1 messages
    stepOneHeadline: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-one.headline",
        defaultMessage: "Your plans start here"
    },
    stepOneBody: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-one.body",
        defaultMessage: "We've embedded your Jira timeline into this doc so you can work while staying in sync across platforms."
    },
    // Step 2 messages
    stepTwoHeadline: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-two.headline",
        defaultMessage: "Share to keep everyone in sync"
    },
    stepTwoBody: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-two.body",
        defaultMessage: "Share this page with your team so everyone can see the latest updates in real time."
    },
    // Step 3 messages
    stepThreeHeadline: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-three.headline",
        defaultMessage: "Keep building this doc"
    },
    stepThreeBody: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-three.body",
        defaultMessage: "Type / to insert elements like headers, tables, columns and more."
    },
    // Common action buttons
    next: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.actions.next",
        defaultMessage: "Next"
    },
    back: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.actions.back",
        defaultMessage: "Back"
    },
    done: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.actions.done",
        defaultMessage: "Done"
    },
    dismiss: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.actions.dismiss",
        defaultMessage: "Dismiss"
    },
    stepCount: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-count",
        defaultMessage: "{current} of {total}"
    }
});
module.exports["messages"] = $96b51e9a0b93ad79$export$defe85febe8b728c;

});

parcelRegister("daw2l", function(module, exports) {
const $904f0f764f52098e$export$648b2bd0c915d9fe = ({ createAnalyticsEvent: createAnalyticsEvent, action: action, step: step })=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            source: 'confluence',
            actionSubject: 'spotlight',
            action: 'actioned',
            attributes: {
                action: action,
                step: step !== null ? step : undefined
            }
        }
    }).fire();
};
const $904f0f764f52098e$export$d4b1091dbd9649e3 = ({ createAnalyticsEvent: createAnalyticsEvent, error: error, errorInfo: errorInfo, componentName: componentName })=>{
    createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            action: 'reported',
            actionSubject: `${componentName}-error`,
            source: 'confluence',
            attributes: {
                name: error.name,
                msg: error.message,
                stack: error.stack,
                componentStack: errorInfo.componentStack
            }
        }
    }).fire();
};
module.exports["trackSpotlightEvent"] = $904f0f764f52098e$export$648b2bd0c915d9fe;
module.exports["trackErrorEvent"] = $904f0f764f52098e$export$d4b1091dbd9649e3;

});

parcelRegister("7NoF3", function(module, exports) {
const $e900dacf455c7c27$export$45d9f22b250b4fa6 = 'PAGE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$daadd9484abf9243 = 'BLOG_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$18ec89b444ed9e13 = 'SPACE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$1670e1f700b91982 = 'PAGE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$99c4be058cda9518 = 'BLOG_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$9a65fbf92be78751 = 'SPACE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$a5c6eb91dd72e7c0 = 'NAVIGATION_RECENT_DROPDOWN_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$835a97ed77363e2a = 'PAGECARD_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$d8133449fbfd82d4 = 'PAGECARD_DRAFT_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$aca8dbff71ee152b = 'QUICK_ACTIONS_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$3a91fd27464e4cde = 'EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$62ca21e37a92c063 = 'CREATE_PAGE_SHORTCUT';
const $e900dacf455c7c27$export$6eda3121bad7aadf = 'CREATE_NAV_BUTTON_CLICK';
const $e900dacf455c7c27$export$7698b0f9c7cef133 = 'CREATE_PAGETREE_BLOG_BUTTON_CLICK';
const $e900dacf455c7c27$export$d83b4b43e279cde5 = 'CREATE_PAGETREE_CHILDPAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$1dd5c358458f3c8f = 'CREATE_PAGETREE_PAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$6e88709afea7d3ed = [
    $e900dacf455c7c27$export$aca8dbff71ee152b,
    $e900dacf455c7c27$export$835a97ed77363e2a,
    $e900dacf455c7c27$export$d8133449fbfd82d4,
    $e900dacf455c7c27$export$a5c6eb91dd72e7c0
];
module.exports["PAGE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$45d9f22b250b4fa6;
module.exports["BLOG_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$daadd9484abf9243;
module.exports["SPACE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$18ec89b444ed9e13;
module.exports["PAGE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$1670e1f700b91982;
module.exports["BLOG_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$99c4be058cda9518;
module.exports["SPACE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$9a65fbf92be78751;
module.exports["PAGECARD_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$835a97ed77363e2a;
module.exports["QUICK_ACTIONS_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$aca8dbff71ee152b;
module.exports["CREATE_PAGE_SHORTCUT"] = $e900dacf455c7c27$export$62ca21e37a92c063;
module.exports["CREATE_NAV_BUTTON_CLICK"] = $e900dacf455c7c27$export$6eda3121bad7aadf;
module.exports["CREATE_PAGETREE_BLOG_BUTTON_CLICK"] = $e900dacf455c7c27$export$7698b0f9c7cef133;
module.exports["InitialLoadEditSources"] = $e900dacf455c7c27$export$6e88709afea7d3ed;

});

parcelRegister("jIlrR", function(module, exports) {
/* CommentButtonPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $21K7m = parcelRequire("21K7m");


var $eEA8O = parcelRequire("eEA8O");


var $1yB28 = parcelRequire("1yB28");


var $3gadb = parcelRequire("3gadb");


var $gczDe = parcelRequire("gczDe");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $ehS5m = parcelRequire("ehS5m");


var $8Q7Uc = parcelRequire("8Q7Uc");


var $fHAwL = parcelRequire("fHAwL");


var $knsmw = parcelRequire("knsmw");

const $e0f29c26904b1b78$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_701w1ul9 _1yxxv77o _w8sqv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e0f29c26904b1b78$var$CommentCountWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $e0f29c26904b1b78$export$400dbe00d66d91c = ({ isDisabled: isDisabled = true, handleCommentButtonClick: handleCommentButtonClick = ()=>{}, style: style, onRender: onRender, contentId: contentId })=>{
    (0, $42omo.useEffect)(()=>{
        if (!isDisabled) onRender && onRender();
    }, [
        isDisabled,
        onRender
    ]);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [{ unreadCommentsListState: unreadCommentsListState, allComments: allComments }] = (0, $fHAwL.useUnreadComments)();
    const unreadInlineComments = (0, $knsmw.getUnreadInlineCommentsListState)(unreadCommentsListState, allComments);
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT)
    });
    const isEmbeddedCommentsEnabled = (0, $7aw3q.useEmbeddedComments)();
    const eventEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    // When the FG is enabled, the shortcut is placed in the `shortcut` Tooltip prop
    const showCommentsTooltipContent = (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "comment-button.tooltip",
        defaultMessage: "Show comments"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
        shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        contentBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "comment-button.tooltip",
            defaultMessage: "Show comments"
        }),
        isTooltip: true
    });
    if (!isEmbeddedCommentsEnabled) return null;
    else if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e0f29c26904b1b78$export$2d5d2ba3c7c8c40b, {
        testId: "comment-button-placeholder",
        "data-test-id": "comment-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
            label: "",
            spacing: "spacious"
        }),
        isDisabled: true // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        ,
        style: style
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: (e)=>{
            if (document.getElementById('renderer-comments-sidebar')) {
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            } else handleCommentButtonClick(e);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: // If there are unread comments, show the unread tooltip text instead of the shortcut
        unreadInlineComments?.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ehS5m.UnreadTooltipText), {
            count: unreadInlineComments?.length
        }) : showCommentsTooltipContent,
        shortcut: // Only show shortcut when there are no unread comments
        (!unreadInlineComments || unreadInlineComments?.length === 0) && (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? commentShortcutStrings : undefined,
        hideTooltipOnClick: true,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e0f29c26904b1b78$var$CommentCountWrapper, {
        onClick: handleCommentButtonClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e0f29c26904b1b78$export$2d5d2ba3c7c8c40b, {
        "data-id": "comment-button-placeholder",
        "data-cy": "comment-button-placeholder",
        testId: "comment-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
            label: unreadInlineComments?.length > 0 ? formatMessage({
                id: "comment-button.unread.comments.icon.label",
                defaultMessage: "You have unread comments"
            }) : formatMessage({
                id: "comment-button.icon.label",
                defaultMessage: "Show comments"
            }),
            spacing: "spacious"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Q7Uc.UnreadCommentCount), {
            pageId: contentId,
            pageMode: "view"
        })),
        isDisabled: isDisabled,
        style: style
    }))));
};
module.exports["CommentButtonPlaceholder"] = $e0f29c26904b1b78$export$400dbe00d66d91c;

});

parcelRegister("ehS5m", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5586adcf63640865$export$47c27b28eb540ad5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "q5mbM",
    name: "UnreadTooltipText",
    loader: async ()=>(await (parcelRequire("c8U1F"))).UnreadTooltipText
});
module.exports["UnreadTooltipText"] = $5586adcf63640865$export$47c27b28eb540ad5;

});

parcelRegister("c8U1F", function(module, exports) {

let $8d71b0f1829e6919$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d71b0f1829e6919$var$load("hoPjF").then(()=>parcelRequire('4welg'));

});

parcelRegister("knsmw", function(module, exports) {
const $c059b1adf8cf4575$export$44b2fb99348acd1a = (editorEmitter, handleCommentButtonClick)=>{
    if (document.getElementById('editor-comments-sidebar')) editorEmitter.emit('setselectedannotation', '');
    else handleCommentButtonClick();
};
const $c059b1adf8cf4575$export$ca142aafa48f4ac5 = (editorEmitter, handleCommentButtonClick, editorViewProps, setEditorViewProps)=>{
    // If we aren't showing/creating a comment trigger the comment button click
    if (!editorViewProps) handleCommentButtonClick();
    else {
        // Otherwise, close the comment
        editorEmitter.emit('setselectedannotation', '');
        setEditorViewProps(null);
    }
};
const $c059b1adf8cf4575$export$4305694843fca59a = (unreadCommentsListState, allComments)=>{
    if (!allComments || !unreadCommentsListState) return [];
    const threadKeyToTypeMap = allComments.reduce((map, comment)=>{
        map[comment.id] = comment.location.type;
        return map;
    }, {});
    return unreadCommentsListState.filter((unreadComment)=>{
        const type = threadKeyToTypeMap[unreadComment.id];
        return type === 'INLINE';
    });
};
module.exports["toggleCommentEditor"] = $c059b1adf8cf4575$export$44b2fb99348acd1a;
module.exports["toggleCommentEditorWithAnnotationManagers"] = $c059b1adf8cf4575$export$ca142aafa48f4ac5;
module.exports["getUnreadInlineCommentsListState"] = $c059b1adf8cf4575$export$4305694843fca59a;

});

parcelRegister("6nmm4", function(module, exports) {
/**
 * @generated SignedSource<<faa1cdaa6cd8ca161ff40125fc73e5fb>>
 * @relayHash 9c0afe40300e5013e32bbea6173aea1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 06aa97550eece151c700159d732523f4cb4864ece75d8cd83f2a2040951feaf5
const $31e2294f16992ac7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "count"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            }
        ],
        "type": "InlineComment"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "pageId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v3 /*: any*/ ,
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "key",
                                "value": "editor"
                            }
                        ],
                        "concreteType": "PaginatedJsonContentPropertyList",
                        "kind": "LinkedField",
                        "name": "properties",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JsonContentProperty",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                    v3 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "properties(key:\"editor\")"
                    },
                    {
                        "concreteType": "ContentMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                "kind": "LinkedField",
                                "name": "frontend",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "fabricEditorSupported"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePreloadCommentButtonQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePreloadCommentButtonQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "9c0afe40300e5013e32bbea6173aea1d",
            "id": "06aa97550eece151c700159d732523f4cb4864ece75d8cd83f2a2040951feaf5",
            "metadata": {},
            "name": "usePreloadCommentButtonQuery",
            "operationKind": "query",
            "text": "query usePreloadCommentButtonQuery($pageId:ID!){comments(pageId:$pageId,type:UNRESOLVED,depth:ALL){count,nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef}}}},content(id:$pageId){nodes{id,properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported}}}}}"
        }
    };
}();
$31e2294f16992ac7$var$node.hash = "213bd75259a759693c19bec62abadf60";
var $31e2294f16992ac7$export$2e2bcd8739ae039 = $31e2294f16992ac7$var$node;
module.exports["default"] = $31e2294f16992ac7$export$2e2bcd8739ae039;

});

parcelRegister("iAOfI", function(module, exports) {

var $4YBSq = parcelRequire("4YBSq");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $jMyy4 = parcelRequire("jMyy4");


var $9hlns = parcelRequire("9hlns");


var $1iSzD = parcelRequire("1iSzD");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $9wGTI = parcelRequire("9wGTI");


var $gkIgp = parcelRequire("gkIgp");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $7aRa9 = parcelRequire("7aRa9");


var $3u7PM = parcelRequire("3u7PM");


var $c4cfx = parcelRequire("c4cfx");


var $7mHcA = parcelRequire("7mHcA");

const $25b07369982b4436$var$EditContentButtonQuery = (0, $4YBSq.default);
const $25b07369982b4436$var$EditContentButtonInner = (0, $7aRa9.withFlags)(({ flags: flags, contentId: contentId, isCompanyHubButton: isCompanyHubButton, ...passThroughProps })=>{
    const { epMigrationOnLoad: epMigrationOnLoad, epMigrationOnClick: epMigrationOnClick } = (0, $7mHcA.useEmbeddedMigrationQuery)(contentId, true);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($25b07369982b4436$var$EditContentButtonQuery, {
        variables: {
            contentId: contentId
        },
        // cache-and-network is required to ensure that the edit button is rendered immediately after page publish
        fetchPolicy: 'cache-and-network'
    });
    const { data: epMigrationOnLoadData, loading: epMigrationOnLoadLoading, error: epMigrationOnLoadError } = epMigrationOnLoad;
    const { migrateEPData: migrateEPData, data: epMigrationOnClickData, loading: epMigrationOnClickLoading, error: epMigrationOnClickError } = epMigrationOnClick;
    const { showNoEditAccessFlag: showNoEditAccessFlag } = (0, $3u7PM.useNoEditAccessFlag)(flags);
    let renderedEditContentButton;
    if (error) renderedEditContentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    else if (!data && loading || !epMigrationOnLoadData && epMigrationOnLoadLoading || !epMigrationOnClickData && epMigrationOnClickLoading) renderedEditContentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        interactionName: (0, $9wGTI.fg)('ufo-manual-experimental-holds-confluence') ? 'edit-content-button' : undefined,
        size: "small"
    });
    else {
        const contentNode = data?.content?.nodes?.[0];
        const operations = contentNode?.operations ?? [];
        const contentType = contentNode?.type ?? undefined;
        const canEdit = operations.filter((operationCheckResult)=>operationCheckResult?.operation === 'update' && operationCheckResult?.targetType === contentType).length > 0;
        if (!canEdit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.EDIT_SHORTCUT),
            listener: showNoEditAccessFlag
        });
        const spaceKey = data?.content?.nodes?.[0]?.space?.key ?? undefined;
        const metadataFrontend = data?.content?.nodes?.[0]?.metadata?.frontend;
        const isFabricSupported = metadataFrontend?.fabricEditorSupported ?? false;
        const isNCSContent = metadataFrontend?.collabService === (0, $gkIgp.CollabServiceProperty).NCS;
        // 'edit-embed' route (embedded editor) should only be used inside parent product and when page is ncs
        const isEmbeddedContent = ((0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() && isNCSContent) ?? false;
        const embeddedMigrationError = epMigrationOnLoadError || epMigrationOnClickError;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, embeddedMigrationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: embeddedMigrationError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4cfx.EditContentButtonComponent), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            isCompanyHubButton: isCompanyHubButton,
            isFabricSupported: isFabricSupported,
            isEmbeddedContent: isEmbeddedContent,
            migrateEPData: !isNCSContent ? migrateEPData : undefined,
            ...passThroughProps
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        id: contentId,
        name: (0, $irVI7.VIEW_PAGE_EDIT_BUTTON_EXPERIENCE)
    }), renderedEditContentButton);
});
const $25b07369982b4436$export$3df6d768aebb677f = /*#__PURE__*/ (0, $42omo.memo)((0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($25b07369982b4436$var$EditContentButtonInner));
$25b07369982b4436$export$3df6d768aebb677f.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    isCompanyHubButton: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onRender: (0, $c4cfx.EditContentButtonComponent).propTypes?.onRender
};
module.exports["EditContentButton"] = $25b07369982b4436$export$3df6d768aebb677f;

});

parcelRegister("3u7PM", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");

const $3cfcff3140a018ad$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    noEditAccessFlagTitle: {
        id: "edit-features.no-edit-access-flag.title",
        defaultMessage: "This shortcut requires edit access"
    },
    noEditAccessFlagDescription: {
        id: "edit-features.no-edit-access-flag.description",
        defaultMessage: "To use this keyboard shortcut, you'll need edit access to this content."
    }
});
const $3cfcff3140a018ad$export$175b3f54640daa25 = (flags)=>{
    const intl = (0, $8C5kA.default)();
    const showNoEditAccessFlag = ()=>{
        flags.showFlag({
            id: 'live-pages-mode-flag',
            title: intl.formatMessage($3cfcff3140a018ad$export$a7357cdd1f0b0168.noEditAccessFlagTitle),
            description: intl.formatMessage($3cfcff3140a018ad$export$a7357cdd1f0b0168.noEditAccessFlagDescription),
            close: 'auto'
        });
    };
    return {
        showNoEditAccessFlag: showNoEditAccessFlag
    };
};
module.exports["useNoEditAccessFlag"] = $3cfcff3140a018ad$export$175b3f54640daa25;

});

parcelRegister("c4cfx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $jTxSS = parcelRequire("jTxSS");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $4KS7f = parcelRequire("4KS7f");


var $1Zr9M = parcelRequire("1Zr9M");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $9hlns = parcelRequire("9hlns");


var $3gadb = parcelRequire("3gadb");


var $4icDV = parcelRequire("4icDV");

var $70LTe = parcelRequire("70LTe");


var $gzdsP = parcelRequire("gzdsP");


var $iFjdQ = parcelRequire("iFjdQ");


var $5q601 = parcelRequire("5q601");


var $74Lca = parcelRequire("74Lca");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $emYzJ = parcelRequire("emYzJ");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $39rFu = parcelRequire("39rFu");


var $7NoF3 = parcelRequire("7NoF3");


var $4ri4I = parcelRequire("4ri4I");


var $1NBp8 = parcelRequire("1NBp8");


var $56QzY = parcelRequire("56QzY");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");


var $4o1RV = parcelRequire("4o1RV");


var $de2j9 = parcelRequire("de2j9");


var $hl1Kw = parcelRequire("hl1Kw");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $lqy4C = parcelRequire("lqy4C");


var $sD2Tz = parcelRequire("sD2Tz");


var $ca2z9 = parcelRequire("ca2z9");

const $a4b894acf4b5251f$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $4KS7f.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_701w1ul9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $4KS7f.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_701w1ul9",
            __cmplp.className
        ])
    });
});
const $a4b894acf4b5251f$var$i18n = (0, $cgtv4.defineMessages)({
    editLabel: {
        id: "edit-button.edit.label",
        defaultMessage: "Edit this content"
    },
    editEmbedLabel: {
        id: "edit-button.edit.embed.label",
        defaultMessage: "Edit this embed"
    },
    editText: {
        id: "edit-button.edit.text",
        defaultMessage: "Edit"
    }
});
const $a4b894acf4b5251f$var$noop = ()=>null;
const $a4b894acf4b5251f$var$EditContentButtonComponentInner = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(113);
    const { contentId: contentId, contentType: contentType, intl: intl, isEmbeddedContent: t1, isFabricSupported: isFabricSupported, onRender: t2, spaceKey: spaceKey, migrateEPData: migrateEPData, isCompanyHubButton: t3 } = t0;
    const isEmbeddedContent = t1 === undefined ? false : t1;
    const onRender = t2 === undefined ? $a4b894acf4b5251f$var$noop : t2;
    const isCompanyHubButton = t3 === undefined ? false : t3;
    const editButtonRef = (0, $42omo.useRef)(null);
    const [localEditSource, setLocalEditSource] = (0, $42omo.useState)("");
    const [isPopupVisible, setIsPopupVisible] = (0, $42omo.useState)(false);
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const { setEditSource: setEditSource } = (0, $4ri4I.useEditSourceActions)();
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [t4] = (0, $hl1Kw.useSearchSessionId)();
    const { searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics } = t4;
    const { match: match } = routesContext;
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            source: "page-tree-quick-action-edit"
        };
        $[0] = t5;
    } else t5 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t5);
    let t6;
    if ($[1] !== contentId || $[2] !== isFabricSupported) {
        t6 = {
            contentId: contentId,
            isFabricSupported: isFabricSupported
        };
        $[1] = contentId;
        $[2] = isFabricSupported;
        $[3] = t6;
    } else t6 = $[3];
    const { fabricEditorEligibility: fabricEditorEligibility, isFabricEligibilityLoading: isFabricEligibilityLoading } = (0, $ca2z9.useFabricEligibilityMigrationQuery)(t6);
    let t7;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
            shortcut: (0, $gnkil.EDIT_SHORTCUT)
        };
        $[4] = t7;
    } else t7 = $[4];
    const editShortcutStrings = (0, $4tOXV.useShortcutStrings)(t7);
    const currentRouteName = match?.name;
    const isBlogpost = contentType === "blogpost";
    const t8 = isBlogpost ? "blog" : "pages";
    let t9;
    if ($[5] !== contentId || $[6] !== spaceKey || $[7] !== t8) {
        t9 = {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: t8
        };
        $[5] = contentId;
        $[6] = spaceKey;
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    const linkParams = t9;
    const dataTestId = isFabricSupported ? "fabric-edit-button" : undefined;
    const sendMetrics = (0, $70LTe.useEmbeddedConfluenceEventMarkers)();
    let routeType;
    if ($[9] !== isBlogpost || $[10] !== isCompanyHubButton || $[11] !== isEmbeddedContent || $[12] !== isFabricSupported) {
        if (isEmbeddedContent && !isBlogpost) routeType = (0, $1NBp8.EDIT_PAGE_EMBED);
        else {
            if (isCompanyHubButton) routeType = (0, $1NBp8.COMPANY_HUB_EDIT);
            else if (isFabricSupported) routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG_V2) : (0, $1NBp8.EDIT_PAGE_V2);
            else routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG) : (0, $1NBp8.EDIT_PAGE);
        }
        $[9] = isBlogpost;
        $[10] = isCompanyHubButton;
        $[11] = isEmbeddedContent;
        $[12] = isFabricSupported;
        $[13] = routeType;
    } else routeType = $[13];
    let t10;
    let t11;
    if ($[14] !== currentRouteName || $[15] !== isBlogpost || $[16] !== setEditSource) {
        t10 = ()=>{
            let entryPoint = (0, $7NoF3.PAGE_EDIT_BUTTON_CLICK);
            if (isBlogpost) entryPoint = (0, $7NoF3.BLOG_EDIT_BUTTON_CLICK);
            const isSpaceOverview = currentRouteName === (0, $1NBp8.SPACE_OVERVIEW).name;
            if (isSpaceOverview) entryPoint = (0, $7NoF3.SPACE_EDIT_BUTTON_CLICK);
            setEditSource(entryPoint);
            setLocalEditSource(entryPoint);
        };
        t11 = [
            isBlogpost,
            setEditSource,
            currentRouteName,
            setLocalEditSource
        ];
        $[14] = currentRouteName;
        $[15] = isBlogpost;
        $[16] = setEditSource;
        $[17] = t10;
        $[18] = t11;
    } else {
        t10 = $[17];
        t11 = $[18];
    }
    (0, $42omo.useEffect)(t10, t11);
    let t12;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = ()=>editButtonRef && (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(editButtonRef.current)?.click();
        $[19] = t12;
    } else t12 = $[19];
    const clickEditPencilButton = t12;
    let t13;
    if ($[20] !== currentRouteName || $[21] !== isBlogpost || $[22] !== setEditSource) {
        t13 = (isClick)=>{
            if (!isClick) {
                let entryPoint_0 = (0, $7NoF3.PAGE_EDIT_SHORTCUT_E);
                if (isBlogpost) entryPoint_0 = (0, $7NoF3.BLOG_EDIT_SHORTCUT_E);
                const isSpaceOverview_0 = currentRouteName === (0, $1NBp8.SPACE_OVERVIEW).name;
                if (isSpaceOverview_0) entryPoint_0 = (0, $7NoF3.SPACE_EDIT_SHORTCUT_E);
                setEditSource(entryPoint_0);
                setLocalEditSource(entryPoint_0);
            }
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_INTENT_EDIT_FMP_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_INTENT_EDIT_TTI_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.VIEW_EDIT_BUTTON_CLICKED_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_ACTION));
        };
        $[20] = currentRouteName;
        $[21] = isBlogpost;
        $[22] = setEditSource;
        $[23] = t13;
    } else t13 = $[23];
    const measureEditButtonClickConversion = t13;
    let t14;
    if ($[24] !== contentId || $[25] !== contentType || $[26] !== currentRouteName || $[27] !== isBlogpost || $[28] !== isEmbeddedContent || $[29] !== isFabricSupported || $[30] !== linkParams || $[31] !== loadEditor || $[32] !== measureEditButtonClickConversion || $[33] !== migrateEPData || $[34] !== routePolicy || $[35] !== routeType || $[36] !== routesContext || $[37] !== spaceKey) {
        t14 = (e)=>{
            measureEditButtonClickConversion(e.isTrusted);
            (0, $74Lca.rememberScrolledPosition)(contentId);
            const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
            const routePolicyPushInNewTab = routePolicy && !routePolicy.willPushInSelf(currentRouteName, contentId, routeType.name, contentId);
            if (!isBlogpost && Boolean(migrateEPData) && routePolicyPushInNewTab) {
                e.preventDefault();
                const navigateToEmbeddedEditor = ()=>{
                    routesContext.push((0, $1NBp8.EDIT_PAGE_EMBED).toUrl(linkParams));
                };
                const navigateToClassicEditor = ()=>{
                    routesContext.push(routeType.toUrl(linkParams));
                };
                migrateEPData(navigateToEmbeddedEditor, navigateToClassicEditor);
            }
            if (details?.href && !routePolicyPushInNewTab) {
                e.preventDefault();
                e.stopPropagation();
                if (!e.isTrusted) routesContext.preloadRoute(details.href);
                loadEditor({
                    contentId: contentId,
                    spaceKey: spaceKey,
                    redirectUrl: details.href,
                    contentType: contentType,
                    isFabricSupported: isFabricSupported,
                    isEmbeddedContent: isEmbeddedContent
                });
            }
        };
        $[24] = contentId;
        $[25] = contentType;
        $[26] = currentRouteName;
        $[27] = isBlogpost;
        $[28] = isEmbeddedContent;
        $[29] = isFabricSupported;
        $[30] = linkParams;
        $[31] = loadEditor;
        $[32] = measureEditButtonClickConversion;
        $[33] = migrateEPData;
        $[34] = routePolicy;
        $[35] = routeType;
        $[36] = routesContext;
        $[37] = spaceKey;
        $[38] = t14;
    } else t14 = $[38];
    routeType;
    const onClickEdit = t14;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const mode = match?.query?.mode;
    let t15;
    if ($[39] !== additionalAnalytics || $[40] !== contentId || $[41] !== contentType || $[42] !== isFabricSupported || $[43] !== isOnEditRoute || $[44] !== mode || $[45] !== searchSessionId) {
        t15 = (e_0, analyticsEvent)=>{
            analyticsEvent.update({
                data: {
                    action: "clicked",
                    actionSubject: "editButton",
                    attributes: {
                        componentVersion: "v2",
                        contentType: contentType,
                        contentId: contentId,
                        isFabricSupported: isFabricSupported,
                        navdexPointType: (0, $56QzY.END),
                        searchSessionId: searchSessionId,
                        ...additionalAnalytics,
                        mode: mode,
                        isOnEditRoute: isOnEditRoute
                    },
                    source: e_0.isTrusted ? "editContentButton" : "editShortcut"
                },
                type: "sendTrackEvent"
            }).fire();
        };
        $[39] = additionalAnalytics;
        $[40] = contentId;
        $[41] = contentType;
        $[42] = isFabricSupported;
        $[43] = isOnEditRoute;
        $[44] = mode;
        $[45] = searchSessionId;
        $[46] = t15;
    } else t15 = $[46];
    const fireClickAnalytics = t15;
    let t16;
    if ($[47] !== contentId || $[48] !== contentType || $[49] !== dataTestId || $[50] !== editShortcutStrings || $[51] !== enforceStorageLimit || $[52] !== fabricEditorEligibility || $[53] !== fireClickAnalytics || $[54] !== intl || $[55] !== isEmbeddedContent || $[56] !== isFabricEligibilityLoading || $[57] !== isFabricSupported || $[58] !== isPopupVisible || $[59] !== linkParams || $[60] !== localEditSource || $[61] !== onClickEdit || $[62] !== onRender || $[63] !== routeType || $[64] !== sendMetrics || $[65] !== shouldBlockCreate || $[66] !== spaceKey) {
        t16 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const [convertOnEditExpConfig] = (0, $6mKj3.UNSAFE_noExposureExp)("platform_editor_on_edit_convert");
            let t17;
            if ($[68] !== fabricEditorEligibility || $[69] !== isFabricSupported) {
                t17 = !isFabricSupported && typeof fabricEditorEligibility === "string" && [
                    "SUPPORTED",
                    "SUPPORTED_WITH_MIGRATION"
                ].includes(fabricEditorEligibility);
                $[68] = fabricEditorEligibility;
                $[69] = isFabricSupported;
                $[70] = t17;
            } else t17 = $[70];
            const showConvertPagePopup = t17;
            let t18;
            if ($[71] !== fireClickAnalytics || $[72] !== isEmbeddedContent || $[73] !== onClickEdit || $[74] !== sendMetrics || $[75] !== showConvertPagePopup) {
                t18 = (e_1, analyticsEvent_0)=>{
                    if (showConvertPagePopup && (0, $6mKj3.expValEquals)("platform_editor_on_edit_convert", "isEnabled", true)) {
                        e_1.preventDefault();
                        setIsPopupVisible($a4b894acf4b5251f$var$_temp);
                        fireClickAnalytics(e_1, analyticsEvent_0);
                    } else {
                        if (isEmbeddedContent) {
                            const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
                            const uniqueKey = observableObject?.object?.uniqueKey;
                            sendMetrics({
                                timestamp: Date.now(),
                                ...uniqueKey && (0, $9wGTI.fg)("platform_deprecate_lp_cc_embed") ? {
                                    customData: {
                                        uniqueKey: uniqueKey
                                    }
                                } : {}
                            }, `${(0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $4icDV.EMBEDDED_EDIT_CLICK)}`);
                        }
                        fireClickAnalytics(e_1, analyticsEvent_0);
                        onClickEdit(e_1);
                    }
                };
                $[71] = fireClickAnalytics;
                $[72] = isEmbeddedContent;
                $[73] = onClickEdit;
                $[74] = sendMetrics;
                $[75] = showConvertPagePopup;
                $[76] = t18;
            } else t18 = $[76];
            const handleButtonClick = t18;
            let t19;
            if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
                t19 = (0, $9wGTI.fg)("platform_tooltip_shortcuts_migration_1") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    id: "edit-button.tooltip",
                    defaultMessage: "Edit"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                    shortcut: (0, $gnkil.EDIT_SHORTCUT),
                    contentBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                        id: "edit-button.tooltip",
                        defaultMessage: "Edit"
                    }),
                    isTooltip: true
                });
                $[77] = t19;
            } else t19 = $[77];
            let t20;
            if ($[78] !== editShortcutStrings) {
                t20 = (0, $9wGTI.fg)("platform_tooltip_shortcuts_migration_1") ? editShortcutStrings : undefined;
                $[78] = editShortcutStrings;
                $[79] = t20;
            } else t20 = $[79];
            let t21;
            if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
                t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)",
                    spacing: (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "none" : "spacious"
                });
                $[80] = t21;
            } else t21 = $[80];
            let t22;
            if ($[81] !== enforceStorageLimit || $[82] !== handleButtonClick) {
                t22 = enforceStorageLimit(handleButtonClick);
                $[81] = enforceStorageLimit;
                $[82] = handleButtonClick;
                $[83] = t22;
            } else t22 = $[83];
            let t23;
            if ($[84] !== linkParams || $[85] !== routeType || $[86] !== shouldBlockCreate) {
                t23 = shouldBlockCreate ? undefined : routeType.toUrl(linkParams);
                $[84] = linkParams;
                $[85] = routeType;
                $[86] = shouldBlockCreate;
                $[87] = t23;
            } else t23 = $[87];
            let t24;
            if ($[88] !== intl) {
                t24 = intl.formatMessage($a4b894acf4b5251f$var$i18n.editLabel);
                $[88] = intl;
                $[89] = t24;
            } else t24 = $[89];
            let t25;
            if ($[90] !== intl) {
                t25 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                    color: "color.text.subtle",
                    align: "center",
                    weight: "medium",
                    "data-vc": "edit-button-text"
                }, intl.formatMessage($a4b894acf4b5251f$var$i18n.editText));
                $[90] = intl;
                $[91] = t25;
            } else t25 = $[91];
            let t26;
            if ($[92] !== dataTestId || $[93] !== t22 || $[94] !== t23 || $[95] !== t24 || $[96] !== t25) {
                t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a4b894acf4b5251f$var$StyledButton, {
                    appearance: "subtle",
                    iconBefore: t21,
                    ref: editButtonRef,
                    onClick: t22,
                    href: t23,
                    "data-test-id": dataTestId,
                    id: "editPageLink",
                    "aria-label": t24
                }, t25);
                $[92] = dataTestId;
                $[93] = t22;
                $[94] = t23;
                $[95] = t24;
                $[96] = t25;
                $[97] = t26;
            } else t26 = $[97];
            let t27;
            if ($[98] !== t20 || $[99] !== t26) {
                t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    tag: "span",
                    content: t19,
                    shortcut: t20
                }, t26);
                $[98] = t20;
                $[99] = t26;
                $[100] = t27;
            } else t27 = $[100];
            const button = t27;
            if (isFabricEligibilityLoading) {
                let t28;
                if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
                    t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
                        interactionName: (0, $9wGTI.fg)("ufo-manual-experimental-holds-confluence") ? "edit-content-button-preloader" : undefined,
                        size: "small",
                        testId: "edit-content-button-preloader"
                    });
                    $[101] = t28;
                } else t28 = $[101];
                t16 = t28;
                break bb0;
            } else {
                let t28;
                if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
                    t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                        accelerator: (0, $gnkil.EDIT_SHORTCUT),
                        listener: clickEditPencilButton
                    });
                    $[102] = t28;
                } else t28 = $[102];
                let t29;
                if ($[103] !== onRender) {
                    t29 = onRender();
                    $[103] = onRender;
                    $[104] = t29;
                } else t29 = $[104];
                const t30 = showConvertPagePopup && convertOnEditExpConfig.get("isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
                    isOpen: isPopupVisible,
                    onClose: ()=>setIsPopupVisible(false),
                    placement: "bottom-start",
                    content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $emYzJ.EditPopupEligibleMigration), {
                            onClickEdit: onClickEdit,
                            contentId: contentId,
                            href: shouldBlockCreate ? undefined : routeType.toUrl(linkParams),
                            contentHash: "",
                            contentType: contentType,
                            spaceKey: spaceKey
                        }),
                    offset: [
                        -34,
                        8
                    ],
                    trigger: (t31)=>{
                        const { ref: ref } = t31;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                            ref: ref
                        }, button);
                    },
                    shouldRenderToParent: (0, $9wGTI.fg)("should-render-to-parent-should-be-trueenterprise-e")
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, button);
                let t32;
                if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
                    t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                        name: (0, $irVI7.VIEW_PAGE_EDIT_BUTTON_EXPERIENCE)
                    });
                    $[105] = t32;
                } else t32 = $[105];
                let t33;
                if ($[106] !== contentId || $[107] !== isEmbeddedContent || $[108] !== localEditSource || $[109] !== spaceKey || $[110] !== t29 || $[111] !== t30) {
                    t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $sD2Tz.EditContentButtonPreloader), {
                        key: contentId,
                        contentId: contentId,
                        spaceKey: spaceKey,
                        isEmbeddedEditor: isEmbeddedContent,
                        editSource: localEditSource
                    }, t28, t29, t30, t32);
                    $[106] = contentId;
                    $[107] = isEmbeddedContent;
                    $[108] = localEditSource;
                    $[109] = spaceKey;
                    $[110] = t29;
                    $[111] = t30;
                    $[112] = t33;
                } else t33 = $[112];
                t16 = t33;
                break bb0;
            }
        }
        $[47] = contentId;
        $[48] = contentType;
        $[49] = dataTestId;
        $[50] = editShortcutStrings;
        $[51] = enforceStorageLimit;
        $[52] = fabricEditorEligibility;
        $[53] = fireClickAnalytics;
        $[54] = intl;
        $[55] = isEmbeddedContent;
        $[56] = isFabricEligibilityLoading;
        $[57] = isFabricSupported;
        $[58] = isPopupVisible;
        $[59] = linkParams;
        $[60] = localEditSource;
        $[61] = onClickEdit;
        $[62] = onRender;
        $[63] = routeType;
        $[64] = sendMetrics;
        $[65] = shouldBlockCreate;
        $[66] = spaceKey;
        $[67] = t16;
    } else t16 = $[67];
    if (t16 !== Symbol.for("react.early_return_sentinel")) return t16;
} : ({ contentId: contentId, contentType: contentType, intl: intl, isEmbeddedContent: isEmbeddedContent = false, isFabricSupported: isFabricSupported, onRender: onRender = $a4b894acf4b5251f$var$noop, spaceKey: spaceKey, migrateEPData: migrateEPData, isCompanyHubButton: isCompanyHubButton = false })=>{
    const editButtonRef = (0, $42omo.useRef)(null);
    const [localEditSource, setLocalEditSource] = (0, $42omo.useState)('');
    const [isPopupVisible, setIsPopupVisible] = (0, $42omo.useState)(false); // State to control popup visibility
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const { setEditSource: setEditSource } = (0, $4ri4I.useEditSourceActions)();
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [{ searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics }] = (0, $hl1Kw.useSearchSessionId)();
    const { match: match } = routesContext;
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'page-tree-quick-action-edit'
    });
    const { fabricEditorEligibility: fabricEditorEligibility, isFabricEligibilityLoading: isFabricEligibilityLoading } = (0, $ca2z9.useFabricEligibilityMigrationQuery)({
        contentId: contentId,
        isFabricSupported: isFabricSupported
    });
    const editShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.EDIT_SHORTCUT)
    });
    const currentRouteName = match?.name;
    const isBlogpost = contentType === 'blogpost';
    const linkParams = (0, $42omo.useMemo)(()=>({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: isBlogpost ? 'blog' : 'pages'
        }), [
        contentId,
        spaceKey,
        isBlogpost
    ]);
    const dataTestId = isFabricSupported ? 'fabric-edit-button' : undefined;
    const sendMetrics = (0, $70LTe.useEmbeddedConfluenceEventMarkers)();
    let routeType; // Currently a temporary check for blogs is added here until Embedded Pages supports blogs.
    if (isEmbeddedContent && !isBlogpost) routeType = (0, $1NBp8.EDIT_PAGE_EMBED);
    else if (isCompanyHubButton) routeType = (0, $1NBp8.COMPANY_HUB_EDIT);
    else if (isFabricSupported) routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG_V2) : (0, $1NBp8.EDIT_PAGE_V2);
    else routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG) : (0, $1NBp8.EDIT_PAGE);
    (0, $42omo.useEffect)(()=>{
        let entryPoint = (0, $7NoF3.PAGE_EDIT_BUTTON_CLICK);
        if (isBlogpost) entryPoint = (0, $7NoF3.BLOG_EDIT_BUTTON_CLICK);
        const isSpaceOverview = currentRouteName === (0, $1NBp8.SPACE_OVERVIEW).name;
        if (isSpaceOverview) entryPoint = (0, $7NoF3.SPACE_EDIT_BUTTON_CLICK);
        setEditSource(entryPoint);
        setLocalEditSource(entryPoint);
    }, [
        isBlogpost,
        setEditSource,
        currentRouteName,
        setLocalEditSource
    ]);
    const clickEditPencilButton = (0, $42omo.useCallback)(()=>editButtonRef && (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(editButtonRef.current)?.click(), []);
    const measureEditButtonClickConversion = (0, $42omo.useCallback)((isClick)=>{
        if (!isClick) {
            //shortcut
            let entryPoint_0 = (0, $7NoF3.PAGE_EDIT_SHORTCUT_E);
            if (isBlogpost) entryPoint_0 = (0, $7NoF3.BLOG_EDIT_SHORTCUT_E);
            const isSpaceOverview_0 = currentRouteName === (0, $1NBp8.SPACE_OVERVIEW).name;
            if (isSpaceOverview_0) entryPoint_0 = (0, $7NoF3.SPACE_EDIT_SHORTCUT_E);
            setEditSource(entryPoint_0);
            setLocalEditSource(entryPoint_0);
        }
        (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_INTENT_EDIT_FMP_ACTION));
        (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_INTENT_EDIT_TTI_ACTION));
        (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.VIEW_EDIT_BUTTON_CLICKED_ACTION));
        (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_ACTION));
    }, [
        isBlogpost,
        currentRouteName,
        setEditSource,
        setLocalEditSource
    ]);
    const onClickEdit = (0, $42omo.useCallback)((e)=>{
        measureEditButtonClickConversion(e.isTrusted);
        (0, $74Lca.rememberScrolledPosition)(contentId);
        const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
        const routePolicyPushInNewTab = routePolicy && !routePolicy.willPushInSelf(currentRouteName, contentId, routeType.name, contentId);
        if (!isBlogpost && Boolean(migrateEPData) && routePolicyPushInNewTab) {
            e.preventDefault();
            const navigateToEmbeddedEditor = ()=>{
                routesContext.push((0, $1NBp8.EDIT_PAGE_EMBED).toUrl(linkParams));
            };
            const navigateToClassicEditor = ()=>{
                routesContext.push(routeType.toUrl(linkParams));
            };
            migrateEPData(navigateToEmbeddedEditor, navigateToClassicEditor);
        } /**
       * If we end up opening editor route in a new tab (regardless route policy specified it or user does cmd+click etc.),
       * we don't need to show the editor loading component in the current tab and preload editor data.
       * The opened new tab will load the editor data with the loading icon
       * In this case, we fallback to `<Link>`'s `push` method by RouteManager
       */ 
        if (details?.href && !routePolicyPushInNewTab) {
            e.preventDefault();
            e.stopPropagation();
            if (!e.isTrusted) // Preload the editor route when user used the "e" shortcut, as otherwise
            // the standard preloading logic isn't triggered
            routesContext.preloadRoute(details.href);
            loadEditor({
                contentId: contentId,
                spaceKey: spaceKey,
                redirectUrl: details.href,
                contentType: contentType,
                isFabricSupported: isFabricSupported,
                isEmbeddedContent: isEmbeddedContent
            });
        }
    }, [
        measureEditButtonClickConversion,
        contentId,
        routesContext,
        routePolicy,
        currentRouteName,
        routeType,
        isBlogpost,
        migrateEPData,
        linkParams,
        loadEditor,
        spaceKey,
        contentType,
        isFabricSupported,
        isEmbeddedContent
    ]);
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const mode = match?.query?.mode;
    const fireClickAnalytics = (0, $42omo.useCallback)((e_0, analyticsEvent)=>{
        analyticsEvent.update({
            data: {
                action: 'clicked',
                actionSubject: 'editButton',
                attributes: {
                    componentVersion: 'v2',
                    contentType: contentType,
                    contentId: contentId,
                    isFabricSupported: isFabricSupported,
                    navdexPointType: (0, $56QzY.END),
                    searchSessionId: searchSessionId,
                    ...additionalAnalytics,
                    mode: mode,
                    isOnEditRoute: isOnEditRoute
                },
                source: e_0.isTrusted ? 'editContentButton' : 'editShortcut'
            },
            type: 'sendTrackEvent'
        }).fire();
    }, [
        contentType,
        contentId,
        isFabricSupported,
        searchSessionId,
        mode,
        isOnEditRoute,
        additionalAnalytics
    ]); /**
                                                                                                               * Cleanup with the platform_editor_on_edit_convert experiment.
                                                                                                               */ 
    const [convertOnEditExpConfig] = (0, $6mKj3.UNSAFE_noExposureExp)('platform_editor_on_edit_convert');
    const showConvertPagePopup = !isFabricSupported && typeof fabricEditorEligibility === 'string' && [
        'SUPPORTED',
        'SUPPORTED_WITH_MIGRATION'
    ].includes(fabricEditorEligibility);
    const handleButtonClick = (0, $42omo.useCallback)((e_1, analyticsEvent_0)=>{
        if (showConvertPagePopup && (0, $6mKj3.expValEquals)('platform_editor_on_edit_convert', 'isEnabled', true)) {
            e_1.preventDefault(); // Prevent default action
            setIsPopupVisible((prev)=>!prev); // Toggle popup visibility
            fireClickAnalytics(e_1, analyticsEvent_0);
        } else {
            if (isEmbeddedContent) {
                const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
                const uniqueKey = observableObject?.object?.uniqueKey;
                sendMetrics({
                    timestamp: Date.now(),
                    ...uniqueKey && (0, $9wGTI.fg)('platform_deprecate_lp_cc_embed') ? {
                        customData: {
                            uniqueKey: uniqueKey
                        }
                    } : {}
                }, `${(0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $4icDV.EMBEDDED_EDIT_CLICK)}`);
            }
            fireClickAnalytics(e_1, analyticsEvent_0);
            onClickEdit(e_1);
        }
    }, [
        showConvertPagePopup,
        fireClickAnalytics,
        onClickEdit,
        isEmbeddedContent,
        sendMetrics
    ]);
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        content: (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "edit-button.tooltip",
            defaultMessage: "Edit"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: (0, $gnkil.EDIT_SHORTCUT),
            contentBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: "edit-button.tooltip",
                defaultMessage: "Edit"
            }),
            isTooltip: true
        }),
        shortcut: (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? editShortcutStrings : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a4b894acf4b5251f$var$StyledButton, {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            spacing: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? 'none' : 'spacious'
        }),
        ref: editButtonRef,
        onClick: enforceStorageLimit(handleButtonClick),
        href: shouldBlockCreate ? undefined : routeType.toUrl(linkParams),
        "data-test-id": dataTestId,
        id: "editPageLink",
        "aria-label": intl.formatMessage($a4b894acf4b5251f$var$i18n.editLabel)
    }, (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        align: "center",
        weight: "medium",
        "data-vc": "edit-button-text"
    }, intl.formatMessage($a4b894acf4b5251f$var$i18n.editText))));
    if (isFabricEligibilityLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        interactionName: (0, $9wGTI.fg)('ufo-manual-experimental-holds-confluence') ? 'edit-content-button-preloader' : undefined,
        size: "small",
        testId: "edit-content-button-preloader"
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $sD2Tz.EditContentButtonPreloader), {
        key: contentId,
        contentId: contentId,
        spaceKey: spaceKey,
        isEmbeddedEditor: isEmbeddedContent,
        editSource: localEditSource
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.EDIT_SHORTCUT),
        listener: clickEditPencilButton
    }), onRender(), showConvertPagePopup && convertOnEditExpConfig.get('isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isPopupVisible,
        onClose: ()=>setIsPopupVisible(false),
        placement: "bottom-start",
        content: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $emYzJ.EditPopupEligibleMigration), {
                onClickEdit: onClickEdit,
                contentId: contentId,
                href: shouldBlockCreate ? undefined : routeType.toUrl(linkParams),
                contentHash: "",
                contentType: contentType,
                spaceKey: spaceKey
            });
        },
        offset: [
            -34,
            8
        ],
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                ref: ref
            }, button),
        shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-trueenterprise-e')
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, button), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.VIEW_PAGE_EDIT_BUTTON_EXPERIENCE)
    }));
});
const $a4b894acf4b5251f$export$812a4eda75b35614 = (0, $gmMgo.default)($a4b894acf4b5251f$var$EditContentButtonComponentInner);
$a4b894acf4b5251f$export$812a4eda75b35614.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onRender: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    isCompanyHubButton: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isEmbeddedContent: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isFabricSupported: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
function $a4b894acf4b5251f$var$_temp(prev) {
    return !prev;
}
module.exports["EditContentButtonComponent"] = $a4b894acf4b5251f$export$812a4eda75b35614;

});

parcelRegister("74Lca", function(module, exports) {

var $51ADl = parcelRequire("51ADl");


var $1dnxO = parcelRequire("1dnxO");


var $dpqzw = parcelRequire("dpqzw");


var $b1pBe = parcelRequire("b1pBe");

const $7936391e07f83542$export$69c870891d17d6d0 = (contentId)=>{
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    // root page element
    const page = isNav4Enabled ? document?.getElementById((0, $51ADl.NAV_4_MAIN_CONTENT_ID)) || document.documentElement : document.documentElement;
    // get fabric or classic renderer content id
    const pageContent = document.getElementById((0, $dpqzw.FABRIC_PAGE_CONTENT_ID));
    // if there's no page content, do nothing
    if (!pageContent) return;
    // if the user is already at the top of the page, then no need to scroll
    if (page.scrollTop / page.clientHeight < 0.25) return;
    // save closest scrolled element & contentId to localstorage
    (0, $b1pBe.getClosestScrolledElementIndex)(page, pageContent, contentId);
};
module.exports["rememberScrolledPosition"] = $7936391e07f83542$export$69c870891d17d6d0;

});

parcelRegister("51ADl", function(module, exports) {
const $06488191c40cb6cf$export$cd4d46bdb3670fbb = 'AkMainContent';
module.exports["NAV_4_MAIN_CONTENT_ID"] = $06488191c40cb6cf$export$cd4d46bdb3670fbb;

});

parcelRegister("b1pBe", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $dpqzw = parcelRequire("dpqzw");

const $f44449ceafa69a86$export$1df42b18d7384de5 = (page, pageContent, contentId)=>{
    if (!pageContent) return;
    // grab all of the direct children elements from the rendered content view
    const elementCollection = pageContent.querySelector((0, $dpqzw.RENDERED_CONTENT_SELECTOR))?.children || [];
    // set initial index to -1 in case no closest element is found
    let closestElementIndex = -1;
    // go through all direct children elements and see which is closest to the remembered scroll position
    if (elementCollection.length > 0) {
        const childrenElements = Array.from(elementCollection);
        // calculate scroll position based off of how far a user has scrolled the page minus the distance from the renderer content to the top of the page
        const pageScrollTop = page.scrollTop - pageContent.offsetTop;
        childrenElements.reduce((best, elem, index)=>{
            if (Math.abs(pageScrollTop - elem.offsetTop) < Math.abs(pageScrollTop - best.offsetTop)) {
                closestElementIndex = index;
                return elem;
            } else return best;
        });
    }
    // save the closest element's index to local storage
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION, {
        index: closestElementIndex,
        contentId: contentId
    });
};
module.exports["getClosestScrolledElementIndex"] = $f44449ceafa69a86$export$1df42b18d7384de5;

});

parcelRegister("emYzJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $7Sm4c = parcelRequire("7Sm4c");


var $briGH = parcelRequire("briGH");


var $emb8c = parcelRequire("emb8c");

const $1c786d1286cf45c7$var$i18n = (0, $cgtv4.defineMessages)({
    elligibleMigrationModalTitle: {
        id: "fabric-page-optin-migration.elligible-migration-modal.title",
        defaultMessage: "Time to convert your page"
    },
    elligibleMigrationModalDescription: {
        id: "fabric-page-optin-migration.elligible-migration-modal.description",
        defaultMessage: "This page is compatible with the cloud editor. The legacy editor will be phased out soon, find out more in the <link>announcement</link>."
    },
    elligibleMigrationModalUpdateButton: {
        id: "fabric-page-optin-migration.elligible-migration-modal.update-button",
        defaultMessage: "Convert page"
    },
    elligibleMigrationModalCancelButton: {
        id: "fabric-page-optin-migration.elligible-migration-modal.cancel-button",
        defaultMessage: "Not now"
    },
    elligibleMigrationModalUnsupported: {
        id: "fabric-page-optin-migration.elligible-migration-modal.unsupported",
        defaultMessage: "This page cannot be converted"
    }
});
const $1c786d1286cf45c7$var$popupContainerStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $1c786d1286cf45c7$var$topMarginStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.200'
});
const $1c786d1286cf45c7$var$buttonContainerStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 'space.200'
});
const $1c786d1286cf45c7$var$widthStyle = (0, $ecnYn.xcss)({
    width: '297px'
});
const $1c786d1286cf45c7$export$4e1bf6f2717dc4c8 = ({ onClickEdit: onClickEdit, contentId: contentId, href: href, contentHash: contentHash, contentType: contentType, spaceKey: spaceKey })=>{
    const [popupMessage, setPopupMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        ...$1c786d1286cf45c7$var$i18n.elligibleMigrationModalDescription
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [migratePages] = (0, $emb8c.useExperimentalMigratePagesMutation)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'eligibleMigrationModal'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onClickConvert = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async (e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'eligibleMigrationModalConvertButton',
                source: 'editPopupEligibleMigration'
            }
        }).fire();
        const response = await migratePages({
            variables: {
                contentId: contentId,
                contentHash: contentHash
            }
        });
        const status = (0, $briGH.getStatusFromResponse)(response);
        if (status === '200' || status === '204') {
            const redirectRoute = contentType === 'page' ? (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                contentType: 'pages',
                spaceKey: spaceKey,
                contentId: contentId
            }) : (0, $1NBp8.EDIT_BLOG_V2).toUrl({
                contentType: 'blog',
                spaceKey: spaceKey,
                contentId: contentId
            });
            // perform redirect
            push(redirectRoute);
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).PAGE_JUST_CONVERTED, contentId);
        } else {
            setPopupMessage($1c786d1286cf45c7$var$i18n.elligibleMigrationModalUnsupported);
            if (response && 'errors' in response && response.errors) (0, $7Sm4c.markErrorAsHandled)(response.errors);
        }
    }, [
        createAnalyticsEvent,
        migratePages,
        contentId,
        contentHash,
        contentType,
        spaceKey,
        push
    ]);
    if (!isLoggedIn || !href) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$popupContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$widthStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        tagName: "h3",
        ...$1c786d1286cf45c7$var$i18n.elligibleMigrationModalTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$topMarginStyle,
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...popupMessage,
        tagName: "p",
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks),
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
                    href: "https://community.atlassian.com/forums/Confluence-articles/The-Legacy-Editor-is-being-deprecated-in-Confluence-Cloud-Here-s/ba-p/3046832",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, chunks)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$topMarginStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$buttonContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        href: href,
        onClick: onClickEdit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $1c786d1286cf45c7$var$i18n.elligibleMigrationModalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: onClickConvert
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $1c786d1286cf45c7$var$i18n.elligibleMigrationModalUpdateButton))))));
};
module.exports["EditPopupEligibleMigration"] = $1c786d1286cf45c7$export$4e1bf6f2717dc4c8;

});

parcelRegister("briGH", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $7W8i8 = parcelRequire("7W8i8");

const $8540b650e122e686$var$RETRY_STATUS_CODE = [
    409,
    412
];
const $8540b650e122e686$export$8e3b4758c0e0a83 = (response)=>response?.data?.experimentalMigratePages?.status;
const $8540b650e122e686$var$logger = (0, $7W8i8.getLogger)('PageMigration');
const $8540b650e122e686$export$9369b12211e1fce4 = (refetchContentHash, migratePages, retriesLeft = 3, interval = 1000, statusCodes = [])=>{
    return new Promise((resolve, reject)=>{
        // b/c contentHash is variable and could changed when user in preview
        // perform refetch to grab the latest contentHash (to avoid 412 and 409 error when performing migration)
        return refetchContentHash().then((contentHash)=>{
            migratePages(contentHash).then((response)=>{
                const status = $8540b650e122e686$export$8e3b4758c0e0a83(response);
                setTimeout(()=>{
                    if (retriesLeft === 1) {
                        const message = 'Number of retrying attempt reach maximum number of retries';
                        $8540b650e122e686$var$logger.debug`${message}`;
                        return reject(message, statusCodes);
                    }
                    // only retry when status code is 409, 412
                    if ($8540b650e122e686$var$RETRY_STATUS_CODE.indexOf(Number.parseInt(status)) !== -1) {
                        statusCodes.push(Number.parseInt(status));
                        $8540b650e122e686$export$9369b12211e1fce4(refetchContentHash, migratePages, retriesLeft - 1, interval, statusCodes).then(resolve, reject);
                    } else return resolve(response, statusCodes);
                }, interval);
            }).catch((error)=>{
                return reject(error, statusCodes);
            });
        });
    });
};
module.exports["getStatusFromResponse"] = $8540b650e122e686$export$8e3b4758c0e0a83;
module.exports["retry"] = $8540b650e122e686$export$9369b12211e1fce4;

});

parcelRegister("emb8c", function(module, exports) {

var $aBfpe = parcelRequire("aBfpe");


var $9o40q = parcelRequire("9o40q");


var $hBkCm = parcelRequire("hBkCm");

const $b8f7841fb375e78f$export$bff11ed54317b5ef = ({ onCompleted: onCompleted, onError: onError } = {})=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: ({ contentId: contentId, contentHash: contentHash })=>`/wiki/rest/api/content/${contentId}/convert?hash=${contentHash}`,
        method: 'PUT',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON,
            'X-Requested-With': 'XMLHttpRequest'
        },
        parseResult: (response)=>({
                experimentalMigratePages: {
                    status: String(response.status)
                }
            }),
        parseResponseOnSuccess: async (response)=>{
            return {
                status: response.status
            };
        },
        parseResponseOnError: async (error)=>{
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) return {
                status: error.response.status
            };
            throw error;
        },
        onCompleted: onCompleted,
        onError: onError
    });
};
module.exports["useExperimentalMigratePagesMutation"] = $b8f7841fb375e78f$export$bff11ed54317b5ef;

});

parcelRegister("ca2z9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $2HZwz = parcelRequire("2HZwz");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");

const $a70c768defde6626$var$UseFabricEligibilityMigrationQuery = (0, $2HZwz.default);
const $a70c768defde6626$export$848562a07f990254 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { contentId: contentId, isFabricSupported: isFabricSupported } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const shouldFetch = isFabricSupported === false;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            fetchPolicy: (0, $6mKj3.expVal)("confluence_fabric_eligibility_query_cachefirst", "isEnabled", false) ? "cache-first" : "cache-and-network",
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($a70c768defde6626$var$UseFabricEligibilityMigrationQuery, t1);
    let t2;
    if ($[2] !== contentId || $[3] !== createAnalyticsEvent) {
        t2 = (t3)=>{
            const { reason: reason } = t3;
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: "failed",
                    actionSubject: "fabricEditorEligibilityQuery",
                    attributes: {
                        contentId: contentId,
                        reason: reason
                    },
                    source: "editContentButton"
                }
            }).fire();
        };
        $[2] = contentId;
        $[3] = createAnalyticsEvent;
        $[4] = t2;
    } else t2 = $[4];
    const fireErrorEvent = t2;
    let t3;
    let t4;
    if ($[5] !== error || $[6] !== fireErrorEvent) {
        t3 = ()=>{
            if (error) fireErrorEvent({
                reason: "APOLLO_ERROR"
            });
        };
        t4 = [
            error,
            fireErrorEvent
        ];
        $[5] = error;
        $[6] = fireErrorEvent;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    bb0: {
        if (!shouldFetch) {
            let t6;
            if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    fabricEditorEligibility: null,
                    contentHash: null,
                    isFabricEligibilityLoading: false
                };
                $[9] = t6;
            } else t6 = $[9];
            t5 = t6;
            break bb0;
        }
        if (!data && shouldFetch) {
            let t6;
            if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    isFabricEligibilityLoading: true,
                    fabricEditorEligibility: null,
                    contentHash: null
                };
                $[10] = t6;
            } else t6 = $[10];
            t5 = t6;
            break bb0;
        }
        if (!data && loading) {
            let t6;
            if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    isFabricEligibilityLoading: true,
                    fabricEditorEligibility: null,
                    contentHash: null
                };
                $[11] = t6;
            } else t6 = $[11];
            t5 = t6;
            break bb0;
        }
        if (data) {
            const metadataFrontend = data?.content?.nodes?.[0]?.metadata?.frontend;
            const fabricEditorEligibility = metadataFrontend?.fabricEditorEligibility;
            const contentHash = metadataFrontend?.contentHash;
            let t6;
            if ($[12] !== contentHash || $[13] !== fabricEditorEligibility) {
                t6 = {
                    fabricEditorEligibility: fabricEditorEligibility,
                    contentHash: contentHash,
                    isFabricEligibilityLoading: false
                };
                $[12] = contentHash;
                $[13] = fabricEditorEligibility;
                $[14] = t6;
            } else t6 = $[14];
            t5 = t6;
            break bb0;
        }
        let t6;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                fabricEditorEligibility: null,
                contentHash: null,
                isFabricEligibilityLoading: false
            };
            $[15] = t6;
        } else t6 = $[15];
        t5 = t6;
    }
    return t5;
} : ({ contentId: contentId, isFabricSupported: isFabricSupported })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const shouldFetch = isFabricSupported === false;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($a70c768defde6626$var$UseFabricEligibilityMigrationQuery, {
        fetchPolicy: (0, $6mKj3.expVal)('confluence_fabric_eligibility_query_cachefirst', 'isEnabled', false) ? 'cache-first' : 'cache-and-network',
        variables: {
            contentId: contentId
        }
    });
    const fireErrorEvent = (0, $42omo.useCallback)(({ reason: reason })=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'fabricEditorEligibilityQuery',
                attributes: {
                    contentId: contentId,
                    reason: reason
                },
                source: 'editContentButton'
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (error) fireErrorEvent({
            reason: 'APOLLO_ERROR'
        });
    }, [
        error,
        fireErrorEvent
    ]);
    return (0, $42omo.useMemo)(()=>{
        if (!shouldFetch) return {
            fabricEditorEligibility: null,
            contentHash: null,
            isFabricEligibilityLoading: false
        };
        if (!data && shouldFetch) return {
            isFabricEligibilityLoading: true,
            fabricEditorEligibility: null,
            contentHash: null
        };
        if (!data && loading) return {
            isFabricEligibilityLoading: true,
            fabricEditorEligibility: null,
            contentHash: null
        };
        if (data) {
            const metadataFrontend = data?.content?.nodes?.[0]?.metadata?.frontend;
            const fabricEditorEligibility = metadataFrontend?.fabricEditorEligibility;
            const contentHash = metadataFrontend?.contentHash;
            return {
                fabricEditorEligibility: fabricEditorEligibility,
                contentHash: contentHash,
                isFabricEligibilityLoading: false
            };
        }
        return {
            fabricEditorEligibility: null,
            contentHash: null,
            isFabricEligibilityLoading: false
        };
    }, [
        data,
        loading,
        shouldFetch
    ]);
};
module.exports["useFabricEligibilityMigrationQuery"] = $a70c768defde6626$export$848562a07f990254;

});

parcelRegister("2HZwz", function(module, exports) {
/**
 * @generated SignedSource<<f41c893ddfe3d66df98f50dbc01536a5>>
 * @relayHash ec4bb4fc4b91bdd22636b8cd5a8459f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b983ca5b9bb7742a71d4d350f250a5524ffb46863ceb1b44624ac1b612ac288
const $41339af49efc6ee3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorEligibility"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "contentHash"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFabricEligibilityMigrationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFabricEligibilityMigrationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ec4bb4fc4b91bdd22636b8cd5a8459f5",
            "id": "1b983ca5b9bb7742a71d4d350f250a5524ffb46863ceb1b44624ac1b612ac288",
            "metadata": {},
            "name": "useFabricEligibilityMigrationQuery",
            "operationKind": "query",
            "text": "query useFabricEligibilityMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{frontend{fabricEditorEligibility,contentHash}}}}}"
        }
    };
}();
$41339af49efc6ee3$var$node.hash = "204d8fbd9ab341cec958fee25e721167";
var $41339af49efc6ee3$export$2e2bcd8739ae039 = $41339af49efc6ee3$var$node;
module.exports["default"] = $41339af49efc6ee3$export$2e2bcd8739ae039;

});

parcelRegister("7mHcA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $inPa6 = parcelRequire("inPa6");

let $6feb6b3d360f0331$var$onMigrationSuccess = ()=>{};
let $6feb6b3d360f0331$var$onMigrationFailure = ()=>{};
const $6feb6b3d360f0331$export$a48339a192545f1f = (0, $3u0dr.isReactCompilerActiveV1)() ? (contentId, skipOnLoadQuery)=>{
    const $ = (0, $frIzR.c)(29);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent) {
        t0 = (t1)=>{
            const { action: action, actionSubjectId: actionSubjectId, withMigration: withMigration, error: error } = t1;
            return createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: action,
                    actionSubject: "ncsMigrationQuery",
                    actionSubjectId: actionSubjectId,
                    source: "embeddedPageViewScreen",
                    object: {
                        id: contentId,
                        type: "page"
                    },
                    attributes: {
                        withMigration: withMigration,
                        error: error
                    }
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = t0;
    } else t0 = $[2];
    const trackMigrationEvent = t0;
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query useEmbeddedMigrationQueryEmbeddedWithMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id type metadata{frontend{embeddedWithMigration}}}}}`;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[4] = contentId;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    let t4;
    if ($[6] !== trackMigrationEvent) {
        t3 = (data)=>{
            if (data?.content?.nodes?.[0]?.metadata?.frontend?.embeddedWithMigration ?? false) trackMigrationEvent({
                action: "completed",
                actionSubjectId: "ncsMigrationOnLoad",
                withMigration: true
            });
            else trackMigrationEvent({
                action: "completed",
                actionSubjectId: "ncsMigrationOnLoad",
                withMigration: false
            });
        };
        t4 = (err)=>{
            trackMigrationEvent({
                action: "failed",
                actionSubjectId: "ncsMigrationOnLoad",
                error: err.message
            });
        };
        $[6] = trackMigrationEvent;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    let t5;
    if ($[9] !== skipOnLoadQuery || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
        t5 = {
            variables: t2,
            fetchPolicy: "network-only",
            skip: skipOnLoadQuery,
            onCompleted: t3,
            onError: t4
        };
        $[9] = skipOnLoadQuery;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    const epMigrationOnLoad = (0, $j1Ss3.useQuery)(t1, t5);
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $eSUdr.default)`query useEmbeddedMigrationQueryEmbeddedWithMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id type metadata{frontend{embeddedWithMigration}}}}}`;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== contentId) {
        t7 = {
            contentId: contentId
        };
        $[15] = contentId;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== trackMigrationEvent) {
        t8 = (err_0)=>{
            trackMigrationEvent({
                action: "failed",
                actionSubjectId: "ncsMigrationOnEditClick",
                error: err_0?.message
            });
            $6feb6b3d360f0331$var$onMigrationFailure(err_0);
        };
        $[17] = trackMigrationEvent;
        $[18] = t8;
    } else t8 = $[18];
    const [migrateData, t9] = (0, $j1Ss3.useLazyQuery)(t6, {
        variables: t7,
        fetchPolicy: "network-only",
        onCompleted: (data_0)=>{
            if (data_0?.content?.nodes?.[0]?.metadata?.frontend?.embeddedWithMigration ?? false) {
                trackMigrationEvent({
                    action: "completed",
                    actionSubjectId: "ncsMigrationOnEditClick",
                    withMigration: true
                });
                $6feb6b3d360f0331$var$onMigrationSuccess(onClickData);
            } else {
                trackMigrationEvent({
                    action: "completed",
                    actionSubjectId: "ncsMigrationOnEditClick",
                    withMigration: false
                });
                $6feb6b3d360f0331$var$onMigrationFailure();
            }
        },
        onError: t8
    });
    const { data: t10, loading: onClickLoading, error: onClickError } = t9;
    const onClickData = t10;
    let t11;
    if ($[19] !== migrateData) {
        t11 = (t12, t13)=>{
            const onSuccess = t12 === undefined ? $6feb6b3d360f0331$var$_temp : t12;
            const onFailure = t13 === undefined ? $6feb6b3d360f0331$var$_temp2 : t13;
            $6feb6b3d360f0331$var$onMigrationSuccess = onSuccess;
            $6feb6b3d360f0331$var$onMigrationFailure = onFailure;
            migrateData();
        };
        $[19] = migrateData;
        $[20] = t11;
    } else t11 = $[20];
    const migrateEPData = t11;
    let t12;
    if ($[21] !== migrateEPData || $[22] !== onClickData || $[23] !== onClickError || $[24] !== onClickLoading) {
        t12 = {
            migrateEPData: migrateEPData,
            data: onClickData,
            loading: onClickLoading,
            error: onClickError
        };
        $[21] = migrateEPData;
        $[22] = onClickData;
        $[23] = onClickError;
        $[24] = onClickLoading;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== epMigrationOnLoad || $[27] !== t12) {
        t13 = {
            epMigrationOnLoad: epMigrationOnLoad,
            epMigrationOnClick: t12
        };
        $[26] = epMigrationOnLoad;
        $[27] = t12;
        $[28] = t13;
    } else t13 = $[28];
    return t13;
} : (contentId, skipOnLoadQuery)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const trackMigrationEvent = ({ action: action, actionSubjectId: actionSubjectId, withMigration: withMigration, error: error })=>{
        return createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: action,
                actionSubject: 'ncsMigrationQuery',
                actionSubjectId: actionSubjectId,
                source: 'embeddedPageViewScreen',
                object: {
                    id: contentId,
                    type: 'page'
                },
                attributes: {
                    withMigration: withMigration,
                    error: error
                }
            }
        }).fire();
    };
    const epMigrationOnLoad = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useEmbeddedMigrationQueryEmbeddedWithMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id type metadata{frontend{embeddedWithMigration}}}}}`, {
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        skip: skipOnLoadQuery,
        onCompleted: (data)=>{
            if (data?.content?.nodes?.[0]?.metadata?.frontend?.embeddedWithMigration ?? false) trackMigrationEvent({
                action: 'completed',
                actionSubjectId: 'ncsMigrationOnLoad',
                withMigration: true
            });
            else trackMigrationEvent({
                action: 'completed',
                actionSubjectId: 'ncsMigrationOnLoad',
                withMigration: false
            });
        },
        onError: (err)=>{
            trackMigrationEvent({
                action: 'failed',
                actionSubjectId: 'ncsMigrationOnLoad',
                error: err.message
            });
        }
    });
    const [migrateData, { data: onClickData, loading: onClickLoading, error: onClickError }] = (0, $j1Ss3.useLazyQuery)((0, $eSUdr.default)`query useEmbeddedMigrationQueryEmbeddedWithMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id type metadata{frontend{embeddedWithMigration}}}}}`, {
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        onCompleted: (data_0)=>{
            if (data_0?.content?.nodes?.[0]?.metadata?.frontend?.embeddedWithMigration ?? false) {
                trackMigrationEvent({
                    action: 'completed',
                    actionSubjectId: 'ncsMigrationOnEditClick',
                    withMigration: true
                });
                $6feb6b3d360f0331$var$onMigrationSuccess(onClickData);
            } else {
                trackMigrationEvent({
                    action: 'completed',
                    actionSubjectId: 'ncsMigrationOnEditClick',
                    withMigration: false
                });
                $6feb6b3d360f0331$var$onMigrationFailure();
            }
        },
        onError: (err_0)=>{
            trackMigrationEvent({
                action: 'failed',
                actionSubjectId: 'ncsMigrationOnEditClick',
                error: err_0?.message
            });
            $6feb6b3d360f0331$var$onMigrationFailure(err_0);
        }
    });
    const migrateEPData = (onSuccess = ()=>{}, onFailure = ()=>{})=>{
        $6feb6b3d360f0331$var$onMigrationSuccess = onSuccess;
        $6feb6b3d360f0331$var$onMigrationFailure = onFailure;
        migrateData();
    };
    return {
        epMigrationOnLoad: epMigrationOnLoad,
        epMigrationOnClick: {
            migrateEPData: migrateEPData,
            data: onClickData,
            loading: onClickLoading,
            error: onClickError
        }
    };
};
function $6feb6b3d360f0331$var$_temp() {}
function $6feb6b3d360f0331$var$_temp2() {}
module.exports["useEmbeddedMigrationQuery"] = $6feb6b3d360f0331$export$a48339a192545f1f;

});

parcelRegister("fvSfu", function(module, exports) {
$parcel$export(module.exports, "default", () => $187fe05e1f85bcab$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $7541v = parcelRequire("7541v");


var $3cHTn = parcelRequire("3cHTn");


var $1ASA6 = parcelRequire("1ASA6");

function $187fe05e1f85bcab$export$2e2bcd8739ae039({ props: props, initialPluginConfiguration: initialPluginConfiguration }) {
    const previousEditorProps = (0, $7541v.default)(props);
    const [preset, setPreset] = (0, $42omo.useState)(()=>(0, $3cHTn.createUniversalPreset)({
            props: props,
            prevProps: previousEditorProps,
            initialPluginConfiguration: initialPluginConfiguration
        }));
    (0, $42omo.useLayoutEffect)(()=>{
        if (!previousEditorProps) return;
        const recreate = (0, $1ASA6.shouldRecreatePreset)(previousEditorProps, props);
        if (!recreate) return;
        // we are not comparing the previous initialPluginConfiguration to the new one assuming that it never changes
        setPreset((0, $3cHTn.createUniversalPreset)({
            props: props,
            prevProps: previousEditorProps,
            initialPluginConfiguration: initialPluginConfiguration
        }));
    }, [
        props,
        previousEditorProps,
        initialPluginConfiguration
    ]);
    return preset;
}

});

parcelRegister("3cHTn", function(module, exports) {

var $629Sx = parcelRequire("629Sx");


var $6DQRK = parcelRequire("6DQRK");


var $1B55v = parcelRequire("1B55v");

function $0b00a5fce53402e3$export$28b0115d03e9c7ad({ props: props, prevProps: prevProps, initialPluginConfiguration: initialPluginConfiguration }) {
    return (0, $629Sx.default)({
        appearance: props.appearance,
        props: (0, $1B55v.getDefaultPresetOptionsFromEditorProps)(props),
        initialPluginConfiguration: initialPluginConfiguration,
        featureFlags: (0, $6DQRK.createFeatureFlagsFromProps)(props.featureFlags),
        prevAppearance: prevProps?.appearance
    });
}
module.exports["createUniversalPreset"] = $0b00a5fce53402e3$export$28b0115d03e9c7ad;

});

parcelRegister("629Sx", function(module, exports) {
$parcel$export(module.exports, "default", () => $09f6088b2411e2a8$export$2e2bcd8739ae039);

var $NPJKR = parcelRequire("NPJKR");

parcelRequire("i7Cgk");
var $3ihIB = parcelRequire("3ihIB");

parcelRequire("arL2z");
var $hr8mu = parcelRequire("hr8mu");

parcelRequire("6ukH4");
var $cpn0f = parcelRequire("cpn0f");

parcelRequire("9eAHn");
var $PJ00O = parcelRequire("PJ00O");

parcelRequire("h7slR");
var $fPXRH = parcelRequire("fPXRH");

parcelRequire("f3XT2");
var $ksXET = parcelRequire("ksXET");

parcelRequire("ez0Lp");
var $hSJYu = parcelRequire("hSJYu");

parcelRequire("9sDYf");
var $cwPVT = parcelRequire("cwPVT");

parcelRequire("9eydB");
var $duFi2 = parcelRequire("duFi2");

parcelRequire("j5BTD");
var $agrUc = parcelRequire("agrUc");

parcelRequire("czsDV");
var $01uqX = parcelRequire("01uqX");

parcelRequire("bEvBi");
var $5AZDw = parcelRequire("5AZDw");

parcelRequire("1t2ub");
var $2yr9J = parcelRequire("2yr9J");

parcelRequire("8ElOg");
var $1nZXu = parcelRequire("1nZXu");

parcelRequire("a0hli");
var $bS1lJ = parcelRequire("bS1lJ");

parcelRequire("4PNJa");
var $2nH2Y = parcelRequire("2nH2Y");

parcelRequire("4Vpub");
var $4iQt6 = parcelRequire("4iQt6");

parcelRequire("8uNa8");
var $hcboS = parcelRequire("hcboS");

parcelRequire("1crCh");
var $fTvEN = parcelRequire("fTvEN");

parcelRequire("aAppb");
var $eyggb = parcelRequire("eyggb");

parcelRequire("luhHH");
var $3Vesv = parcelRequire("3Vesv");

parcelRequire("9KQQk");
var $dtCIm = parcelRequire("dtCIm");

parcelRequire("2H8MG");
var $6q6xk = parcelRequire("6q6xk");

parcelRequire("bn2AM");
var $fYKTL = parcelRequire("fYKTL");

parcelRequire("58fnx");
var $fCLXZ = parcelRequire("fCLXZ");

parcelRequire("d5BeT");
var $flknw = parcelRequire("flknw");

parcelRequire("li22U");
var $kwFBr = parcelRequire("kwFBr");


var $8POG7 = parcelRequire("8POG7");


var $5zfRA = parcelRequire("5zfRA");

parcelRequire("dcNOI");
var $05jmd = parcelRequire("05jmd");


var $88OoA = parcelRequire("88OoA");

parcelRequire("bGnP4");
var $h8AH9 = parcelRequire("h8AH9");

parcelRequire("6N2nV");
var $cWFvG = parcelRequire("cWFvG");

parcelRequire("dU3Nv");
var $2U68K = parcelRequire("2U68K");

parcelRequire("dhgPE");
var $5u7tz = parcelRequire("5u7tz");

parcelRequire("fdbx8");
var $b3BjA = parcelRequire("b3BjA");

parcelRequire("gKNtz");
var $59fTa = parcelRequire("59fTa");

parcelRequire("8WOs1");
var $8HLyI = parcelRequire("8HLyI");

parcelRequire("1C8xV");
var $5DsxN = parcelRequire("5DsxN");

parcelRequire("kPcbV");
var $gCiM9 = parcelRequire("gCiM9");

parcelRequire("gPle7");
var $1GAIu = parcelRequire("1GAIu");

parcelRequire("ii4wo");
var $c8680 = parcelRequire("c8680");

parcelRequire("1vKzP");
var $efDik = parcelRequire("efDik");

parcelRequire("ituSb");
var $eeGWn = parcelRequire("eeGWn");

parcelRequire("i0V8C");
var $jaskt = parcelRequire("jaskt");


var $gcsWd = parcelRequire("gcsWd");


var $fH5dz = parcelRequire("fH5dz");

parcelRequire("aVfsQ");
var $bz4KD = parcelRequire("bz4KD");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $geLSP = parcelRequire("geLSP");


var $75KVc = parcelRequire("75KVc");


var $gVoWJ = parcelRequire("gVoWJ");

function $09f6088b2411e2a8$export$2e2bcd8739ae039({ appearance: appearance, props: props, featureFlags: featureFlags, initialPluginConfiguration: initialPluginConfiguration, prevAppearance: prevAppearance, createAnalyticsEvent: createAnalyticsEvent }) {
    const isComment = appearance === 'comment';
    const isChromeless = appearance === 'chromeless';
    const isFullPage = (0, $geLSP.isFullPage)(appearance);
    const getEditorFeatureFlags = ()=>featureFlags;
    const defaultPreset = (0, $gVoWJ.createDefaultPreset)({
        ...props,
        appearance: appearance,
        createAnalyticsEvent: createAnalyticsEvent,
        hyperlinkOptions: {
            lpLinkPicker: featureFlags.lpLinkPicker ?? false,
            ...props.hyperlinkOptions
        },
        __livePage: props.__livePage,
        toolbar: initialPluginConfiguration?.toolbarPlugin
    });
    const statusMenuDisabled = !props.allowStatus ? true : typeof props.allowStatus === 'object' ? Boolean(props.allowStatus.menuDisabled) : false;
    const hasBeforePrimaryToolbar = (components)=>{
        if (components && 'before' in components) return !!components.before;
        return false;
    };
    const finalPreset = defaultPreset.add((0, $bz4KD.ufoPlugin)).add((0, $2nH2Y.dataConsumerPlugin)).add((0, $3ihIB.accessibilityUtilsPlugin)).add((0, $2yr9J.contentInsertionPlugin)).add((0, $fPXRH.batchAttributeUpdatesPlugin)).maybeAdd([
        (0, $cwPVT.breakoutPlugin),
        {
            allowBreakoutButton: appearance === 'full-page',
            appearance: appearance
        }
    ], Boolean(props.allowBreakout && isFullPage)).maybeAdd((0, $hr8mu.alignmentPlugin), Boolean(props.allowTextAlignment)).maybeAdd([
        (0, $gcsWd.textColorPlugin),
        props.allowTextColor
    ], Boolean(props.allowTextColor)).add((0, $88OoA.listPlugin)).maybeAdd((0, $5DsxN.rulePlugin), Boolean(props.allowRule)).maybeAdd([
        (0, $fTvEN.expandPlugin),
        {
            allowInsertion: $09f6088b2411e2a8$export$a9b5e68d7107c3df(props),
            useLongPressSelection: false,
            appearance: appearance,
            allowInteractiveExpand: typeof props.allowExpand === 'boolean' ? props.allowExpand : Boolean(props.allowExpand && props.allowExpand.allowInteractiveExpand !== false),
            __livePage: props.__livePage
        }
    ], Boolean(props.allowExpand)).maybeAdd((0, $fCLXZ.guidelinePlugin), Boolean(!isComment && !isChromeless && (props.media || props.allowTables) || (0, $iu6m9.editorExperiment)('platform_editor_breakout_resizing', true, {
        exposure: true
    }) && (props.allowExpand || props.allowLayouts || props.codeBlock))).maybeAdd([
        (0, $fYKTL.gridPlugin),
        {
            shouldCalcBreakoutGridLines: isFullPage
        }
    ], Boolean(props.media)).maybeAdd([
        (0, $cpn0f.annotationPlugin),
        props.annotationProviders
    ], Boolean(props.annotationProviders)).maybeAdd([
        (0, $cWFvG.mediaPlugin),
        {
            ...props.media,
            allowLazyLoading: true,
            allowBreakoutSnapPoints: isFullPage,
            allowAdvancedToolBarOptions: typeof props.media?.allowAdvancedToolBarOptions !== 'undefined' ? props.media?.allowAdvancedToolBarOptions : isFullPage || isComment,
            allowCommentsOnMedia: isFullPage && Boolean(props.annotationProviders),
            allowDropzoneDropLine: isFullPage,
            allowMediaSingleEditable: true,
            allowRemoteDimensionsFetch: true,
            allowMarkingUploadsAsIncomplete: false,
            allowImagePreview: typeof props.media?.allowImagePreview !== 'undefined' ? props.media?.allowImagePreview : isFullPage,
            fullWidthEnabled: appearance === 'full-width',
            editorAppearance: appearance,
            uploadErrorHandler: props.uploadErrorHandler,
            waitForMediaUpload: props.waitForMediaUpload,
            isCopyPasteEnabled: true,
            alignLeftOnInsert: typeof props.media?.alignLeftOnInsert !== 'undefined' ? props.media?.alignLeftOnInsert : isComment,
            getEditorFeatureFlags: getEditorFeatureFlags
        }
    ], Boolean(props.media)).maybeAdd((0, $2U68K.mediaInsertPlugin), Boolean(props.media)).maybeAdd((0, $duFi2.default), Boolean(props.media?.allowCaptions)).maybeAdd([
        (0, $5u7tz.mentionsPlugin),
        {
            sanitizePrivateContent: props.sanitizePrivateContent,
            insertDisplayName: props.mention?.insertDisplayName ?? props.mentionInsertDisplayName,
            allowZeroWidthSpaceAfter: true,
            HighlightComponent: props.mention?.HighlightComponent,
            profilecardProvider: props.mention?.profilecardProvider,
            mentionProvider: props.mentionProvider,
            ...initialPluginConfiguration?.mentionsPlugin
        }
    ], Boolean(props.mentionProvider)).maybeAdd([
        (0, $hcboS.emojiPlugin),
        {
            emojiProvider: props.emojiProvider,
            ...(0, $1oCLl.expValEquals)('platform_editor_plain_text_support', 'isEnabled', true) ? initialPluginConfiguration?.emojiPlugin : {}
        }
    ], Boolean(props.emojiProvider)).maybeAdd([
        (0, $eeGWn.default),
        {
            tableOptions: !props.allowTables || typeof props.allowTables === 'boolean' ? {} : props.allowTables,
            dragAndDropEnabled: featureFlags?.tableDragAndDrop && (isFullPage || (isComment || isChromeless) && (0, $iu6m9.editorExperiment)('support_table_in_comment', true, {
                exposure: true
            })) || isComment && (0, $iu6m9.editorExperiment)('support_table_in_comment_jira', true, {
                exposure: true
            }),
            isTableScalingEnabled: isFullPage || isComment && (0, $iu6m9.editorExperiment)('support_table_in_comment', true, {
                exposure: true
            }) || isComment && (0, $iu6m9.editorExperiment)('support_table_in_comment_jira', true, {
                exposure: true
            }),
            allowContextualMenu: true,
            fullWidthEnabled: appearance === 'full-width',
            wasFullWidthEnabled: prevAppearance && prevAppearance === 'full-width',
            getEditorFeatureFlags: getEditorFeatureFlags,
            isCommentEditor: isComment,
            isChromelessEditor: isChromeless
        }
    ], Boolean(props.allowTables)).maybeAdd([
        (0, $jaskt.tasksAndDecisionsPlugin),
        {
            allowNestedTasks: props.allowNestedTasks,
            consumeTabs: isFullPage,
            useLongPressSelection: false,
            taskDecisionProvider: props.taskDecisionProvider,
            ...initialPluginConfiguration?.tasksAndDecisionsPlugin
        }
    ], Boolean(props.allowTasksAndDecisions || props.taskDecisionProvider)).maybeAdd([
        (0, $3Vesv.feedbackDialogPlugin),
        {
            coreVersion: $75KVc.version,
            ...props.feedbackInfo
        }
    ], Boolean(props.feedbackInfo)).maybeAdd([
        (0, $flknw.helpDialogPlugin),
        !!props.legacyImageUploadProvider
    ], Boolean(props.allowHelpDialog)).maybeAdd([
        (0, $gCiM9.saveOnEnterPlugin),
        props.onSave
    ], Boolean(props.saveOnEnter && props.onSave)).maybeAdd((0, $kwFBr.imageUploadPlugin), Boolean(props.legacyImageUploadProvider)).maybeAdd(// duplicate plugin exists because first one if media is enabled
    // second one when “media is disabled, and legacyMediaProvider is enabled
    // @ts-expect-error
    [
        (0, $cWFvG.mediaPlugin),
        {
            allowMediaSingle: {
                disableLayout: true
            },
            allowMediaGroup: false,
            isCopyPasteEnabled: true
        }
    ], Boolean(props.legacyImageUploadProvider && !props.media)).maybeAdd([
        (0, $5AZDw.collabEditPlugin),
        {
            ...props.collabEdit,
            sanitizePrivateContent: props.sanitizePrivateContent,
            EXPERIMENTAL_allowInternalErrorAnalytics: props.collabEdit?.EXPERIMENTAL_allowInternalErrorAnalytics ?? (0, $NPJKR.shouldForceTracking)()
        }
    ], Boolean(props.collabEdit || props.collabEditProvider)).maybeAdd([
        (0, $h8AH9.default),
        props.maxContentSize
    ], Boolean(props.maxContentSize)).maybeAdd([
        (0, $b3BjA.default),
        {
            useLongPressSelection: false,
            allowCustomPanel: typeof props.allowPanel === 'object' ? props.allowPanel.allowCustomPanel : false,
            allowCustomPanelEdit: typeof props.allowPanel === 'object' ? props.allowPanel.allowCustomPanelEdit : false
        }
    ], Boolean(props.allowPanel)).maybeAdd((0, $1nZXu.contextPanelPlugin), Boolean(isFullPage)).maybeAdd([
        (0, $eyggb.extensionPlugin),
        {
            breakoutEnabled: appearance === 'full-page' && (typeof props.allowExtension === 'object' ? props.allowExtension.allowBreakout : true) !== false,
            extensionHandlers: props.extensionHandlers,
            useLongPressSelection: false,
            appearance: appearance,
            ...initialPluginConfiguration?.extensionPlugin
        }
    ], Boolean(props.allowExtension)).maybeAdd(// we are ignoring a duplicate plugin error here
    // this error exists because we have two annotation plugins being added
    // one with annotationProviders and one with allowConfluenceInlineComment
    // long term this and media should be consolidated into adding both only once
    // @ts-expect-error
    [
        (0, $cpn0f.annotationPlugin),
        undefined
    ], Boolean(!props.annotationProviders && props.allowConfluenceInlineComment)).maybeAdd([
        (0, $4iQt6.default),
        {
            weekStartDay: typeof props.allowDate === 'object' ? props.allowDate.weekStartDay : undefined
        }
    ], Boolean(props.allowDate)).maybeAdd([
        (0, $8HLyI.default),
        // @ts-expect-error 2322: Type 'false | PlaceholderTextOptions | undefined'
        props.allowTemplatePlaceholders !== true ? props.allowTemplatePlaceholders : {}
    ], Boolean(props.allowTemplatePlaceholders)).maybeAdd([
        (0, $05jmd.layoutPlugin),
        {
            ...typeof props.allowLayouts === 'object' ? props.allowLayouts : {},
            useLongPressSelection: false,
            UNSAFE_allowSingleColumnLayout: typeof props.allowLayouts === 'object' ? props.allowLayouts.UNSAFE_allowSingleColumnLayout : undefined,
            editorAppearance: appearance
        }
    ], Boolean(props.allowLayouts)).maybeAdd([
        (0, $agrUc.cardPlugin),
        {
            ...props.UNSAFE_cards,
            ...props.smartLinks,
            ...props.linking?.smartLinks,
            fullWidthMode: appearance === 'full-width',
            linkPicker: props.linking?.linkPicker,
            lpLinkPicker: featureFlags.lpLinkPicker ?? false,
            editorAppearance: appearance,
            // @ts-ignore Temporary solution to check for Live Page editor.
            __livePage: props.__livePage
        }
    ], Boolean(props.linking?.smartLinks || props.smartLinks || props.UNSAFE_cards)).maybeAdd([
        (0, $bS1lJ.customAutoformatPlugin),
        {
            autoformattingProvider: props.autoformattingProvider
        }
    ], Boolean(props.autoformattingProvider)).maybeAdd([
        (0, $c8680.statusPlugin),
        {
            menuDisabled: statusMenuDisabled,
            allowZeroWidthSpaceAfter: true
        }
    ], Boolean(props.allowStatus)).maybeAdd([
        (0, $efDik.syncedBlockPlugin),
        props.syncBlock
    ], Boolean(props.syncBlock) && (0, $iu6m9.editorExperiment)('platform_synced_block', true)).maybeAdd((0, $8POG7.indentationPlugin), Boolean(props.allowIndentation)).maybeAdd((0, $1GAIu.scrollIntoViewPlugin), Boolean(props.autoScrollIntoView !== false)).add([
        (0, $fH5dz.toolbarListsIndentationPlugin),
        {
            showIndentationButtons: !!props.showIndentationButtons,
            allowHeadingAndParagraphIndentation: !!props.allowIndentation
        }
    ]).add([
        (0, $5zfRA.insertBlockPlugin),
        {
            allowTables: !!props.allowTables,
            allowExpand: $09f6088b2411e2a8$export$a9b5e68d7107c3df(props),
            insertMenuItems: props.insertMenuItems,
            horizontalRuleEnabled: props.allowRule,
            tableSelectorSupported: featureFlags?.tableSelector && isFullPage,
            nativeStatusSupported: !statusMenuDisabled,
            showElementBrowserLink: props.elementBrowser && props.elementBrowser.showModal || false,
            appearance: appearance,
            ...initialPluginConfiguration?.insertBlockPlugin
        }
    ]).maybeAdd([
        (0, $ksXET.beforePrimaryToolbarPlugin),
        {
            beforePrimaryToolbarComponents: // @ts-expect-error 2339: Property 'before' does not exist on type 'PrimaryToolbarComponents'.
            props.primaryToolbarComponents?.before
        }
    ], Boolean(hasBeforePrimaryToolbar(props.primaryToolbarComponents) && !featureFlags.twoLineEditorToolbar)).add([
        (0, $PJ00O.avatarGroupPlugin),
        {
            // Avatars are moved to Confluence codebase for Edit in Context
            // When Edit in Context is enabled primaryToolbarComponents is undefined
            // For more details please check
            // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
            collabEdit: props.collabEdit,
            takeFullWidth: !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
            showAvatarGroup: featureFlags.showAvatarGroupAsPlugin === true && !featureFlags.twoLineEditorToolbar
        }
    ]).maybeAdd([
        (0, $dtCIm.findReplacePlugin),
        {
            takeFullWidth: !!featureFlags.showAvatarGroupAsPlugin === false && !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
            twoLineEditorToolbar: !!props.primaryToolbarComponents && !!featureFlags.twoLineEditorToolbar
        }
    ], Boolean(props.allowFindReplace)).maybeAdd((0, $hSJYu.borderPlugin), Boolean(props.allowBorderMark)).maybeAdd((0, $6q6xk.fragmentPlugin), Boolean(props.allowFragmentMark)).add((0, $59fTa.pasteOptionsToolbarPlugin)).maybeAdd([
        (0, $01uqX.codeBidiWarningPlugin),
        {
            appearance: appearance
        }
    ], !(0, $1oCLl.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true));
    return finalPreset;
}
function $09f6088b2411e2a8$export$a9b5e68d7107c3df({ allowExpand: allowExpand }) {
    if (allowExpand && typeof allowExpand === 'object') return !!allowExpand.allowInsertion;
    return false;
}

});

parcelRegister("i7Cgk", function(module, exports) {
$parcel$export(module.exports, "accessibilityUtilsPlugin", () => (parcelRequire("3ihIB")).accessibilityUtilsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3ihIB = parcelRequire("3ihIB");


});

parcelRegister("9eAHn", function(module, exports) {
$parcel$export(module.exports, "avatarGroupPlugin", () => (parcelRequire("PJ00O")).avatarGroupPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $PJ00O = parcelRequire("PJ00O");


});

parcelRegister("h7slR", function(module, exports) {
$parcel$export(module.exports, "batchAttributeUpdatesPlugin", () => (parcelRequire("fPXRH")).batchAttributeUpdatesPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $fPXRH = parcelRequire("fPXRH");


});

parcelRegister("f3XT2", function(module, exports) {
$parcel$export(module.exports, "beforePrimaryToolbarPlugin", () => (parcelRequire("ksXET")).beforePrimaryToolbarPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ksXET = parcelRequire("ksXET");


});

parcelRegister("ksXET", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4PgVh = parcelRequire("4PgVh");

const $31299d1e32261be8$export$66dff0ee14673555 = ({ api: api, config: props })=>{
    const primaryToolbarComponent = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $4PgVh.BeforePrimaryToolbarWrapper), {
            beforePrimaryToolbarComponents: props?.beforePrimaryToolbarComponents
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'beforePrimaryToolbar',
        component: primaryToolbarComponent
    });
    return {
        name: 'beforePrimaryToolbar',
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
module.exports["beforePrimaryToolbarPlugin"] = $31299d1e32261be8$export$66dff0ee14673555;

});

parcelRegister("4PgVh", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

function $63d636b872f679dd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $63d636b872f679dd$var$beforePrimaryToolbarPluginWrapperStyles = {
    name: "4jjuk5",
    styles: "display:flex;margin-right:var(--ds-space-100, 8px);flex-grow:1;justify-content:flex-end;align-items:center"
};
const $63d636b872f679dd$export$b41281e8d2acb8ab = (props)=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $63d636b872f679dd$var$beforePrimaryToolbarPluginWrapperStyles,
        "data-testid": 'before-primary-toolbar-components-plugin'
    }, props.beforePrimaryToolbarComponents);
module.exports["BeforePrimaryToolbarWrapper"] = $63d636b872f679dd$export$b41281e8d2acb8ab;

});

parcelRegister("ez0Lp", function(module, exports) {
$parcel$export(module.exports, "borderPlugin", () => (parcelRequire("hSJYu")).borderPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hSJYu = parcelRequire("hSJYu");


});

parcelRegister("czsDV", function(module, exports) {
$parcel$export(module.exports, "codeBidiWarningPlugin", () => (parcelRequire("01uqX")).codeBidiWarningPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $01uqX = parcelRequire("01uqX");


});

parcelRegister("bEvBi", function(module, exports) {
$parcel$export(module.exports, "collabEditPlugin", () => (parcelRequire("5AZDw")).collabEditPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5AZDw = parcelRequire("5AZDw");


});

parcelRegister("a0hli", function(module, exports) {
$parcel$export(module.exports, "customAutoformatPlugin", () => (parcelRequire("bS1lJ")).customAutoformatPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $bS1lJ = parcelRequire("bS1lJ");


});

parcelRegister("4PNJa", function(module, exports) {
$parcel$export(module.exports, "dataConsumerPlugin", () => (parcelRequire("2nH2Y")).dataConsumerPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2nH2Y = parcelRequire("2nH2Y");


});

parcelRegister("luhHH", function(module, exports) {
$parcel$export(module.exports, "feedbackDialogPlugin", () => (parcelRequire("3Vesv")).feedbackDialogPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3Vesv = parcelRequire("3Vesv");


});

parcelRegister("3Vesv", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $2gySx = parcelRequire("2gySx");

let $ea53b8452ab0b839$var$showJiraCollectorDialog;
let $ea53b8452ab0b839$var$feedbackInfoHash;
let $ea53b8452ab0b839$var$defaultFeedbackInfo;
const $ea53b8452ab0b839$var$hashFeedbackInfo = (feedbackInfo)=>{
    const { product: product, packageName: packageName, packageVersion: packageVersion, labels: labels } = feedbackInfo;
    return [
        product,
        packageName,
        packageVersion,
        ...labels || []
    ].join('|');
};
const $ea53b8452ab0b839$export$432e2d318c18feaa = async (feedbackInfo)=>// eslint-disable-next-line no-async-promise-executor
    new Promise(async (resolve, reject)=>{
        const combinedFeedbackInfo = {
            product: 'n/a',
            labels: [],
            packageName: '',
            packageVersion: '',
            coreVersion: '',
            sessionId: '',
            contentId: '',
            tabId: '',
            ...$ea53b8452ab0b839$var$defaultFeedbackInfo,
            ...feedbackInfo
        };
        const newFeedbackInfoHash = $ea53b8452ab0b839$var$hashFeedbackInfo(combinedFeedbackInfo);
        if (!$ea53b8452ab0b839$var$showJiraCollectorDialog || $ea53b8452ab0b839$var$feedbackInfoHash !== newFeedbackInfoHash) try {
            $ea53b8452ab0b839$var$showJiraCollectorDialog = await (0, $2gySx.default)([
                combinedFeedbackInfo.product,
                ...combinedFeedbackInfo.labels
            ], combinedFeedbackInfo.packageName, combinedFeedbackInfo.coreVersion, combinedFeedbackInfo.packageVersion, combinedFeedbackInfo.sessionId, combinedFeedbackInfo.contentId, combinedFeedbackInfo.tabId);
            $ea53b8452ab0b839$var$feedbackInfoHash = newFeedbackInfoHash;
        } catch (err) {
            reject(err);
        }
        const timeoutId = window.setTimeout($ea53b8452ab0b839$var$showJiraCollectorDialog, 0);
        // Return the timoutId for consumers to call clearTimeout if they need to.
        resolve(timeoutId);
    });
const $ea53b8452ab0b839$export$1b6ac82b29dcc009 = ({ config: feedbackInfo, api: api })=>{
    $ea53b8452ab0b839$var$defaultFeedbackInfo = feedbackInfo ?? {};
    return {
        name: 'feedbackDialog',
        actions: {
            openFeedbackDialog: $ea53b8452ab0b839$export$432e2d318c18feaa
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'feedbackdialog',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).feedbackDialog),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).feedbackDialogDescription),
                        priority: 400,
                        keywords: [
                            'bug'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconFeedback), {}),
                        action (insert, state) {
                            const tr = insert('');
                            $ea53b8452ab0b839$export$432e2d318c18feaa(feedbackInfo);
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).OPENED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).FEEDBACK_DIALOG,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $d925B.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};
module.exports["feedbackDialogPlugin"] = $ea53b8452ab0b839$export$1b6ac82b29dcc009;

});

parcelRegister("2gySx", function(module, exports) {

var $bXyE4 = parcelRequire("bXyE4");


var $6tusa = parcelRequire("6tusa");

const $477708b1f3fcf8d3$var$JIRA_ISSUE_COLLECTOR_URL = 'https://product-fabric.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-w0bwo4/b/14/e73395c53c3b10fde2303f4bf74ffbf6/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-US&collectorId=98644b9c';
const $477708b1f3fcf8d3$var$loadJiraCollectorDialogScript = (labels, packageName, coreVersion, packageVersion, sessionId, contentId, tabId)=>{
    // eslint-disable-next-line no-async-promise-executor, require-await
    return new Promise(async (resolve, reject)=>{
        if (window.jQuery) {
            window.ATL_JQ_PAGE_PROPS = {
                triggerFunction: (showCollectorDialog)=>{
                    if (typeof showCollectorDialog === 'function') resolve(showCollectorDialog);
                    else reject('Failed to initialize showCollectorDialog');
                },
                fieldValues: {
                    description: `Please describe the problem you're having or feature you'd like to see:\n\n\n`,
                    // 11711 is the field ID for the Feedback Labels field on Product Fabric.
                    // this is found by clicking "configure" on the field and inspecting the URL
                    customfield_11711: labels || [],
                    customfield_11712: `version: ${packageName}@${packageVersion} (${coreVersion})
              Browser: ${(0, $bXyE4.default)(navigator.userAgent)}
              OS: ${(0, $6tusa.default)(navigator.userAgent, navigator.appVersion)}`
                },
                environment: {
                    'Editor Package': packageName,
                    'Editor Version': packageVersion,
                    'Editor Core Version': coreVersion,
                    sessionId: sessionId,
                    contentId: contentId,
                    tabId: tabId
                },
                priority: '1',
                components: '15306'
            };
            window.jQuery.ajax({
                url: $477708b1f3fcf8d3$var$JIRA_ISSUE_COLLECTOR_URL,
                type: 'get',
                cache: true,
                dataType: 'script'
            });
        } else reject('jQuery is not defined');
    });
};
var $477708b1f3fcf8d3$export$2e2bcd8739ae039 = $477708b1f3fcf8d3$var$loadJiraCollectorDialogScript;
module.exports["default"] = $477708b1f3fcf8d3$export$2e2bcd8739ae039;

});

parcelRegister("bXyE4", function(module, exports) {
/**
 * Inspired from:
 * https://stackoverflow.com/questions/11219582/how-to-detect-my-browser-version-and-operating-system-using-javascript
 */ const $678a1d6347e818a9$var$getBrowserInfo = (nAgt)=>{
    let browserName;
    let browserVersion;
    let nameOffset;
    let verOffset;
    let index;
    // In Opera 15+, version is after "OPR/"
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf('OPR/')) !== -1) {
        browserName = 'Opera';
        browserVersion = nAgt.substring(verOffset + 4);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
        // In older Opera, version is after "Opera" or after "Version"
        browserName = 'Opera';
        // Ignored via go/ees005
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf('Version')) !== -1) browserVersion = nAgt.substring(verOffset + 8);
        else browserVersion = nAgt.substring(verOffset + 6);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
        // In MSIE, version is after "MSIE" in userAgent
        browserName = 'Microsoft Internet Explorer';
        browserVersion = nAgt.substring(verOffset + 5);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
        // In Chrome, version is after "Chrome"
        browserName = 'Chrome';
        browserVersion = nAgt.substring(verOffset + 7);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
        // In Safari, version is after "Safari" or after "Version"
        browserName = 'Safari';
        // Ignored via go/ees005
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf('Version')) !== -1) browserVersion = nAgt.substring(verOffset + 8);
        else browserVersion = nAgt.substring(verOffset + 7);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
        // In Firefox, version is after "Firefox"
        browserName = 'Firefox';
        browserVersion = nAgt.substring(verOffset + 8);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        // In most other browsers, "name/version" is at the end of userAgent
        browserName = nAgt.substring(nameOffset, verOffset);
        browserVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() === browserName.toUpperCase()) browserName = navigator.appName;
    } else {
        browserName = navigator.appName;
        browserVersion = '' + parseFloat(navigator.appVersion);
    }
    // trim the versionStr string at semicolon/space if present
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    if ((index = browserVersion.indexOf(';')) !== -1) browserVersion = browserVersion.substring(0, index);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    if ((index = browserVersion.indexOf(' ')) !== -1) browserVersion = browserVersion.substring(0, index);
    return `${browserName} ${browserVersion}`;
};
var $678a1d6347e818a9$export$2e2bcd8739ae039 = $678a1d6347e818a9$var$getBrowserInfo;
module.exports["default"] = $678a1d6347e818a9$export$2e2bcd8739ae039;

});

parcelRegister("6tusa", function(module, exports) {
/**
 * Inspired from:
 * https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-version-using-javascript
 */ const $15021288aa91dfe1$var$getDeviceInfo = (nAgt, nVersion)=>{
    let os = '';
    let osVersion = '';
    const clientStrings = [
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows 3.11',
            r: /Win16/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows 95',
            r: /(Windows 95|Win95|Windows_95)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows ME',
            r: /(Win 9x 4.90|Windows ME)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows 98',
            r: /(Windows 98|Win98)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows CE',
            r: /Windows CE/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows 2000',
            r: /(Windows NT 5.0|Windows 2000)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows XP',
            r: /(Windows NT 5.1|Windows XP)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows Server 2003',
            r: /Windows NT 5.2/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows Vista',
            r: /Windows NT 6.0/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows 7',
            r: /(Windows 7|Windows NT 6.1)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows 8.1',
            r: /(Windows 8.1|Windows NT 6.3)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows 8',
            r: /(Windows 8|Windows NT 6.2)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows NT 4.0',
            r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Android',
            r: /Android/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Open BSD',
            r: /OpenBSD/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Sun OS',
            r: /SunOS/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Linux',
            r: /(Linux|X11)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'iOS',
            r: /(iPhone|iPad|iPod)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Mac OS X',
            r: /Mac OS X/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Mac OS',
            r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'QNX',
            r: /QNX/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'UNIX',
            r: /UNIX/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'BeOS',
            r: /BeOS/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'OS/2',
            r: /OS\/2/
        },
        {
            s: 'Search Bot',
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
        }
    ];
    // eslint-disable-next-line guard-for-in
    for(const client in clientStrings){
        const clientObj = clientStrings[client];
        if (clientObj.r.test(nAgt)) {
            os = clientObj.s;
            break;
        }
    }
    let match;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/Windows/.test(os)) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        match = /Windows (.*)/.exec(os);
        osVersion = match && match[1];
        os = 'Windows';
    }
    switch(os){
        case 'Mac OS X':
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            match = /Mac OS X (10[\.\_\d]+)/.exec(nAgt);
            osVersion = match && match[1];
            break;
        case 'Android':
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            match = /Android ([\.\_\d]+)/.exec(nAgt);
            osVersion = match && match[1];
            break;
        case 'iOS':
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            match = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVersion);
            osVersion = match && match[1] + '.' + match[2] + '.' + (match[3] || 0);
    }
    return `${os} ${osVersion}`;
};
var $15021288aa91dfe1$export$2e2bcd8739ae039 = $15021288aa91dfe1$var$getDeviceInfo;
module.exports["default"] = $15021288aa91dfe1$export$2e2bcd8739ae039;

});

parcelRegister("9KQQk", function(module, exports) {
$parcel$export(module.exports, "findReplacePlugin", () => (parcelRequire("dtCIm")).findReplacePlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $dtCIm = parcelRequire("dtCIm");


});

parcelRegister("2H8MG", function(module, exports) {
$parcel$export(module.exports, "fragmentPlugin", () => (parcelRequire("6q6xk")).fragmentPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6q6xk = parcelRequire("6q6xk");


});

parcelRegister("li22U", function(module, exports) {
$parcel$export(module.exports, "imageUploadPlugin", () => (parcelRequire("kwFBr")).imageUploadPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kwFBr = parcelRequire("kwFBr");


});

parcelRegister("kwFBr", function(module, exports) {

var $ahleU = parcelRequire("ahleU");


var $dz7yO = parcelRequire("dz7yO");


var $dOi3m = parcelRequire("dOi3m");


var $Hqiqk = parcelRequire("Hqiqk");

const $57ceba8706161d84$export$e3bfb926c9700157 = ()=>{
    const uploadHandlerReference = {
        current: null
    };
    return {
        name: 'imageUpload',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $Hqiqk.stateKey).getState(editorState);
        },
        actions: {
            startUpload: ()=>(0, $ahleU.insertActionForToolbar)(uploadHandlerReference)
        },
        pmPlugins () {
            return [
                {
                    name: 'imageUpload',
                    plugin: (0, $dOi3m.createPlugin)(uploadHandlerReference)
                },
                {
                    name: 'imageUploadInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $dz7yO.default)(schema, featureFlags)
                }
            ];
        }
    };
};
module.exports["imageUploadPlugin"] = $57ceba8706161d84$export$e3bfb926c9700157;

});

parcelRegister("ahleU", function(module, exports) {

var $i88eX = parcelRequire("i88eX");

const $10b92a36bb7a5950$export$62f5bb5681401150 = (uploadHandlerReference)=>{
    return (state, dispatch)=>{
        if (!uploadHandlerReference.current) return false;
        uploadHandlerReference.current(undefined, (options)=>{
            (0, $i88eX.insertExternalImage)(options)(state, dispatch);
        });
        return true;
    };
};
module.exports["insertActionForToolbar"] = $10b92a36bb7a5950$export$62f5bb5681401150;

});

parcelRegister("i88eX", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $qps4N = parcelRequire("qps4N");


var $jS4Hz = parcelRequire("jS4Hz");


var $Hqiqk = parcelRequire("Hqiqk");

const $916bc99ad638690d$export$d978a1cf00cd351b = (options)=>(state, dispatch)=>{
        const pluginState = (0, $Hqiqk.stateKey).getState(state);
        if (!pluginState?.enabled || !options.src) return false;
        const mediaNode = (0, $qps4N.createExternalMediaNode)(options.src, state.schema);
        if (!mediaNode) return false;
        if (dispatch) dispatch((0, $8m4tT.safeInsert)(mediaNode, state.selection.$to.pos)(state.tr).scrollIntoView());
        return true;
    };
const $916bc99ad638690d$export$41b18c224f9e33da = (event)=>(state, dispatch)=>{
        const pluginState = (0, $Hqiqk.stateKey).getState(state);
        if (pluginState && !pluginState.enabled) return false;
        if (dispatch) dispatch((0, $jS4Hz.startUpload)(event)(state.tr));
        return true;
    };
module.exports["insertExternalImage"] = $916bc99ad638690d$export$d978a1cf00cd351b;
module.exports["startImageUpload"] = $916bc99ad638690d$export$41b18c224f9e33da;

});

parcelRegister("qps4N", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $97c0b772b35946ae$export$d2ec7ab2b2a98746 = (state)=>{
    const { media: media } = state.schema.nodes;
    return state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.type === media;
};
const $97c0b772b35946ae$export$262e43a15b79aeb7 = (state)=>{
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    const { $to: $to } = state.selection;
    if (mediaSingle) for(let d = $to.depth; d >= 0; d--){
        const index = $to.index(d);
        if ($to.node(d).canReplaceWith(index, index, mediaSingle)) return true;
    }
    return false;
};
const $97c0b772b35946ae$export$4747cb76ebf8d6df = (url, schema)=>{
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    if (!media || !mediaSingle) return null;
    const mediaNode = media.createChecked({
        type: 'external',
        url: url
    });
    return mediaSingle.createChecked({}, mediaNode);
};
module.exports["isMediaSelected"] = $97c0b772b35946ae$export$d2ec7ab2b2a98746;
module.exports["canInsertMedia"] = $97c0b772b35946ae$export$262e43a15b79aeb7;
module.exports["createExternalMediaNode"] = $97c0b772b35946ae$export$4747cb76ebf8d6df;

});

parcelRegister("jS4Hz", function(module, exports) {

var $Hqiqk = parcelRequire("Hqiqk");

const $c8b9f63a3af17b0e$var$imageUploadAction = (tr, action)=>{
    return tr.setMeta((0, $Hqiqk.stateKey), action);
};
const $c8b9f63a3af17b0e$export$bacf5b3f68174df = (event)=>(tr)=>$c8b9f63a3af17b0e$var$imageUploadAction(tr, {
            name: 'START_UPLOAD',
            event: event
        });
module.exports["startUpload"] = $c8b9f63a3af17b0e$export$bacf5b3f68174df;

});

parcelRegister("Hqiqk", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $efe8c38ed286d843$export$77b371d6becc8882 = new (0, $ks2lK.PluginKey)('imageUploadPlugin');
module.exports["stateKey"] = $efe8c38ed286d843$export$77b371d6becc8882;

});

parcelRegister("dz7yO", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $l03WE = parcelRequire("l03WE");


var $aIMBk = parcelRequire("aIMBk");


var $qps4N = parcelRequire("qps4N");

function $dafe10b6764a68aa$export$568a7ed6897c4817(schema, featureFlags) {
    if (!schema.nodes.media || !schema.nodes.mediaSingle) return;
    // ![something](link) should convert to an image
    // eslint-disable-next-line require-unicode-regexp
    const imageRule = (0, $l03WE.createRule)(/!\[(.*)\]\((\S+)\)$/, (state, match, start, end)=>{
        const { schema: schema } = state;
        const attrs = {
            src: match[2],
            alt: match[1]
        };
        const node = (0, $qps4N.createExternalMediaNode)(attrs.src, schema);
        if (node) return state.tr.replaceWith(start, end, node);
        return null;
    });
    return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('image-upload', [
        imageRule
    ]));
}
var $dafe10b6764a68aa$export$2e2bcd8739ae039 = $dafe10b6764a68aa$export$568a7ed6897c4817;
module.exports["default"] = $dafe10b6764a68aa$export$2e2bcd8739ae039;

});

parcelRegister("dOi3m", function(module, exports) {

var $8gdgt = parcelRequire("8gdgt");


var $1S4f7 = parcelRequire("1S4f7");


var $lt01C = parcelRequire("lt01C");


var $lVhuP = parcelRequire("lVhuP");


var $qps4N = parcelRequire("qps4N");


var $i88eX = parcelRequire("i88eX");


var $Hqiqk = parcelRequire("Hqiqk");

/**
 * Microsoft Office includes a screenshot image when copying text content.
 *
 * This function determines whether or not we can ignore the image if it
 * came from MS Office. We do this by checking for
 *
 * - plain text
 * - HTML text which includes the MS Office namespace
 * - the number of files and the file name/type
 *
 * It is easy to manually verify this using by using Office on Mac
 * (or Excel if on Windows) and pasting into
 * https://evercoder.github.io/clipboard-inspector/
 *
 * Note: image content in Word is stored in the `text/html` portion
 * of the clipboard, not under `files` attachment like the screenshot.
 *
 * @returns boolean True if the paste event contains a screenshot from MS Office
 */ const $8c64761772976f4f$var$hasScreenshotImageFromMSOffice = (ev)=>{
    const { clipboardData: clipboardData } = ev;
    if (!clipboardData || clipboardData.files.length !== 1) return false;
    const textPlain = !!clipboardData.getData('text/plain');
    const textHtml = clipboardData.getData('text/html');
    const isOfficeXMLNamespace = textHtml.includes('urn:schemas-microsoft-com:office:office');
    const file = clipboardData.files[0];
    const isImagePNG = file.type === 'image/png' && file.name === 'image.png';
    return isImagePNG && textPlain && isOfficeXMLNamespace;
};
const $8c64761772976f4f$var$createReferenceEventFromEvent = (event)=>{
    if (!(0, $lVhuP.isDragEvent)(event) && !(0, $lt01C.isClipboardEvent)(event)) return null;
    // Get files list and early exit if files is undefined
    const files = (0, $lVhuP.isDragEvent)(event) ? event.dataTransfer?.files : event.clipboardData?.files;
    if (!files) return null;
    // Convert filelist into an array
    const filesArray = Array.from(files);
    // Creating a new DataTransfer object should remove any mutation that could be possible from the original event
    const dataTransfer = filesArray.reduce((acc, value)=>{
        acc.items.add(value);
        return acc;
    }, new DataTransfer());
    return {
        type: (0, $lVhuP.isDragEvent)(event) ? 'drop' : 'paste',
        ...(0, $lVhuP.isDragEvent)(event) && {
            dataTransfer: dataTransfer
        },
        ...(0, $lt01C.isClipboardEvent)(event) && {
            clipboardData: dataTransfer
        }
    };
};
const $8c64761772976f4f$var$createDOMHandler = (pred, _eventName, uploadHandlerReference)=>(view, event)=>{
        if (!pred(event)) return false;
        const shouldUpload = !$8c64761772976f4f$var$hasScreenshotImageFromMSOffice(event);
        const referenceEvent = $8c64761772976f4f$var$createReferenceEventFromEvent(event);
        if (shouldUpload && referenceEvent) {
            event.preventDefault();
            event.stopPropagation();
            // Insert external image into document
            if (uploadHandlerReference.current) uploadHandlerReference.current(referenceEvent, (options)=>{
                (0, $i88eX.insertExternalImage)(options)(view.state, view.dispatch);
            });
            // Start image upload
            (0, $i88eX.startImageUpload)(referenceEvent)(view.state, view.dispatch);
        }
        return shouldUpload;
    };
const $8c64761772976f4f$var$getNewActiveUpload = (tr, pluginState)=>{
    const meta = tr.getMeta((0, $Hqiqk.stateKey));
    if (meta && meta.name === 'START_UPLOAD') return {
        event: meta.event
    };
    return pluginState.activeUpload;
};
const $8c64761772976f4f$export$ae829ec7b2625219 = (uploadHandlerReference)=>({ dispatch: dispatch, providerFactory: providerFactory })=>{
        return new (0, $1S4f7.SafePlugin)({
            state: {
                init (_config, state) {
                    return {
                        active: false,
                        enabled: (0, $qps4N.canInsertMedia)(state),
                        hidden: !state.schema.nodes.media || !state.schema.nodes.mediaSingle
                    };
                },
                apply (tr, pluginState, _oldState, newState) {
                    const newActive = (0, $qps4N.isMediaSelected)(newState);
                    const newEnabled = (0, $qps4N.canInsertMedia)(newState);
                    const newActiveUpload = $8c64761772976f4f$var$getNewActiveUpload(tr, pluginState);
                    if (newActive !== pluginState.active || newEnabled !== pluginState.enabled || newActiveUpload !== pluginState.activeUpload) {
                        const newPluginState = {
                            ...pluginState,
                            active: newActive,
                            enabled: newEnabled,
                            activeUpload: newActiveUpload
                        };
                        dispatch((0, $Hqiqk.stateKey), newPluginState);
                        return newPluginState;
                    }
                    return pluginState;
                }
            },
            key: (0, $Hqiqk.stateKey),
            view: ()=>{
                const handleProvider = async (name, provider)=>{
                    if (name !== 'imageUploadProvider' || !provider) return;
                    try {
                        const imageUploadProvider = await provider;
                        uploadHandlerReference.current = imageUploadProvider;
                    } catch (e) {
                        uploadHandlerReference.current = null;
                    }
                };
                providerFactory.subscribe('imageUploadProvider', handleProvider);
                return {
                    destroy () {
                        uploadHandlerReference.current = null;
                        providerFactory.unsubscribe('imageUploadProvider', handleProvider);
                    }
                };
            },
            props: {
                handleDOMEvents: {
                    drop: $8c64761772976f4f$var$createDOMHandler((0, $lVhuP.isDroppedFile), 'atlassian.editor.image.drop', uploadHandlerReference),
                    paste: $8c64761772976f4f$var$createDOMHandler((event)=>(0, $8gdgt.isPastedFile)(event), 'atlassian.editor.image.paste', uploadHandlerReference)
                }
            }
        });
    };
module.exports["createPlugin"] = $8c64761772976f4f$export$ae829ec7b2625219;

});

parcelRegister("lt01C", function(module, exports) {
// Typeguard Function
const $e59683bbab878740$export$5694727fbed080b4 = (event)=>'clipboardData' in event;
module.exports["isClipboardEvent"] = $e59683bbab878740$export$5694727fbed080b4;

});

parcelRegister("lVhuP", function(module, exports) {
// Typeguard Function
const $f38dff49b31c8aeb$export$fd4eab91eb7545c8 = (event)=>'dataTransfer' in event;
function $f38dff49b31c8aeb$export$6ca76751d014281f(rawEvent) {
    const e = rawEvent;
    if (!e.dataTransfer) return false;
    return Array.prototype.slice.call(e.dataTransfer.types).indexOf('Files') !== -1;
}
module.exports["isDragEvent"] = $f38dff49b31c8aeb$export$fd4eab91eb7545c8;
module.exports["isDroppedFile"] = $f38dff49b31c8aeb$export$6ca76751d014281f;

});

parcelRegister("bGnP4", function(module, exports) {
$parcel$export(module.exports, "maxContentSizePlugin", () => (parcelRequire("h8AH9")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $h8AH9 = parcelRequire("h8AH9");


});

parcelRegister("gKNtz", function(module, exports) {
$parcel$export(module.exports, "pasteOptionsToolbarPlugin", () => (parcelRequire("59fTa")).pasteOptionsToolbarPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $59fTa = parcelRequire("59fTa");


});

parcelRegister("gPle7", function(module, exports) {
$parcel$export(module.exports, "scrollIntoViewPlugin", () => (parcelRequire("1GAIu")).scrollIntoViewPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1GAIu = parcelRequire("1GAIu");


});

parcelRegister("1vKzP", function(module, exports) {
$parcel$export(module.exports, "syncedBlockPlugin", () => (parcelRequire("efDik")).syncedBlockPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $efDik = parcelRequire("efDik");


});

parcelRegister("aVfsQ", function(module, exports) {
$parcel$export(module.exports, "ufoPlugin", () => (parcelRequire("bz4KD")).ufoPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $bz4KD = parcelRequire("bz4KD");


});

parcelRegister("1ASA6", function(module, exports) {
function $4baffa82d2587726$export$79c7ce3012e5b8c8(props, nextProps) {
    const properties = [
        'appearance',
        'persistScrollGutter',
        'allowUndoRedoButtons',
        'placeholder',
        'sanitizePrivateContent'
    ];
    return properties.reduce((acc, curr)=>acc || props[curr] !== nextProps[curr], false);
}
module.exports["shouldRecreatePreset"] = $4baffa82d2587726$export$79c7ce3012e5b8c8;

});

parcelRegister("5ozYM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $5hAil = parcelRequire("5hAil");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $cEgMD = parcelRequire("cEgMD");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $3zetf = parcelRequire("3zetf");

const $080ccb5c9f312cd0$var$i18n = (0, $cgtv4.defineMessages)({
    companyHubDefaultTitle: {
        id: "document-title.document-space-title.company-hub.title",
        defaultMessage: "Company hub"
    }
});
function $080ccb5c9f312cd0$export$7ce5f0b10eeaaf17({ spaceKey: spaceKey, titlePrefix: titlePrefix }) {
    const { siteTitle: siteTitle, companyHubName: companyHubName } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    //In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be populated and we can skip document title.
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__']) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).INHERIT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5hAil.QueryGroup), {
        queryProps: (0, $3zetf.getSpaceNameQueryProps)(spaceKey)
    }, ({ results: results, loading: loading })=>{
        if (loading) return null;
        const companyHubSpaceName = companyHubName || formatMessage($080ccb5c9f312cd0$var$i18n.companyHubDefaultTitle);
        const spaceName = isCompanyHub ? companyHubSpaceName : (0, $3zetf.getSpaceNameFromResults)(results);
        const title = [
            titlePrefix,
            spaceName,
            siteTitle
        ].filter((part)=>part).join(' - ');
        // set for SSR document title
        window.__DOCUMENT_TITLE_TAG__ = title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5RCH.PageTitle), {
            title: title
        });
    }));
}
module.exports["DocumentSpaceTitle"] = $080ccb5c9f312cd0$export$7ce5f0b10eeaaf17;

});

parcelRegister("dJ5r4", function(module, exports) {
$parcel$export(module.exports, "ViewCommentShortcutListener", () => (parcelRequire("fPcdI")).ViewCommentShortcutListener);

var $fPcdI = parcelRequire("fPcdI");


});

parcelRegister("fPcdI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $21K7m = parcelRequire("21K7m");


var $inPa6 = parcelRequire("inPa6");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $liGyh = parcelRequire("liGyh");


var $dANtQ = parcelRequire("dANtQ");


var $9QIM2 = parcelRequire("9QIM2");


var $fNzRA = parcelRequire("fNzRA");


var $k8e76 = parcelRequire("k8e76");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $2eC70 = parcelRequire("2eC70");


var $aJPUt = parcelRequire("aJPUt");


var $inDu6 = parcelRequire("inDu6");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $gczDe = parcelRequire("gczDe");


var $7qvmT = parcelRequire("7qvmT");


var $6KwrO = parcelRequire("6KwrO");


var $3mVfX = parcelRequire("3mVfX");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $9wGTI = parcelRequire("9wGTI");


var $aSsfA = parcelRequire("aSsfA");


var $cgy29 = parcelRequire("cgy29");


var $dkkKv = parcelRequire("dkkKv");


var $8i27m = parcelRequire("8i27m");


var $f5Wgm = parcelRequire("f5Wgm");


var $fHAwL = parcelRequire("fHAwL");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $izhdc = parcelRequire("izhdc");


var $gSkOQ = parcelRequire("gSkOQ");

const $c392465906bed01c$var$ViewCommentShortcutListenerComponent = ({ isFabricPage: isFabricPage, contentId: contentId, dialogs: dialogs })=>{
    const { navigateToInlineComment: navigateToInlineComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { unresolvedInlineComments: unresolvedInlineComments } = (0, $k8e76.useInlineCommentsState)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap, footerCommentsLoadingState: footerCommentsLoadingState } = (0, $8i27m.useCommentsDataState)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isNextCommentLoading, setIsNextCommentLoading] = (0, $42omo.useState)(false);
    const [alreadyFetchedInitialData, setAlreadyFetchedInitialData] = (0, $42omo.useState)(false);
    const [triggeredByUnreadKeyboardShortcut, setTriggeredByUnreadKeyboardShortcut] = (0, $42omo.useState)(false);
    // Used to facilitate loading footer comments and navigating after load
    // Should only be set when confluence_frontend_kb_footer_loading is true
    const [pendingStandaloneAction, setPendingStandaloneAction] = (0, $42omo.useState)(null);
    const [{ currentlyRenderedThreads: currentlyRenderedThreads, currentlySelectedThreadKey: currentlySelectedThreadKey }, { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey }] = (0, $3mVfX.useCommentsPanel)();
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = (0, $aWwYt.useObjectSidebarState)();
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '');
    const orderedActiveAnnotations = (0, $42omo.useMemo)(()=>{
        return (0, $9wGTI.fg)('confluence_frontend_new_comments_scrolling') ? orderedActiveAnnotationIdList.map((a)=>a.threadKey) : unresolvedInlineComments;
    }, [
        orderedActiveAnnotationIdList,
        unresolvedInlineComments
    ]);
    (0, $42omo.useEffect)(()=>{
        setIsNextCommentLoading(false);
    }, [
        activeHighlight,
        currentlySelectedThreadKey
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            setCurrentlySelectedThreadKey('');
        };
    }, [
        setCurrentlySelectedThreadKey
    ]);
    const { footerCommentThreads: footerCommentThreads, footerCommentIds: footerCommentIds } = (0, $gSkOQ.useFooterComments)();
    const { unreadInlineComments: unreadInlineComments, unreadGeneralComments: unreadGeneralComments } = (0, $42omo.useMemo)(()=>{
        const unreadInlineComments = [];
        const unreadGeneralComments = [];
        orderedActiveAnnotations.forEach((threadKey)=>{
            const commentData = commentsDataMap.inline[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) {
                    // Use unreadCommentIDSet when feature flag is enabled
                    // in SSR, unreadCommentIDSet is undefined
                    isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                    hasUnreadReplies = commentData.replies?.some((reply)=>unreadCommentIDSet?.has(reply.id)) || false;
                } else {
                    // Use legacy .isUnread field when feature flag is disabled
                    isCommentUnread = commentData.isUnread || false;
                    hasUnreadReplies = commentData.replies?.some((reply)=>reply.isUnread) || false;
                }
                if (isCommentUnread || hasUnreadReplies) unreadInlineComments.push(threadKey);
            }
        });
        Object.keys(commentsDataMap.general).forEach((threadKey)=>{
            const commentData = commentsDataMap.general[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) {
                    // Use unreadCommentIDSet when feature flag is enabled
                    isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                    hasUnreadReplies = commentData.replies?.some((reply)=>unreadCommentIDSet?.has(reply.id)) || false;
                } else {
                    // Use legacy .isUnread field when feature flag is disabled
                    isCommentUnread = commentData.isUnread || false;
                    hasUnreadReplies = commentData.replies?.some((reply)=>reply.isUnread) || false;
                }
                if (isCommentUnread || hasUnreadReplies) unreadGeneralComments.push(threadKey);
            }
        });
        return {
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotations,
        unreadCommentIDSet
    ]);
    const sendKeyboardShortcutAnalytics = (shortcut)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'viewPage',
                action: 'pressed',
                actionSubject: 'keyboardShortcut',
                actionSubjectId: 'createComment',
                attributes: {
                    key: shortcut
                }
            }
        }).fire();
    };
    const { handleCommentButtonClick: handleCommentButtonClick } = (0, $cgy29.useCreateCommentAction)({
        contentId: contentId || '',
        isFabric: isFabricPage,
        sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics
    });
    const getCommentIndex = (0, $42omo.useCallback)((currentThreadKey)=>{
        return (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? [
            ...orderedActiveAnnotations,
            ...footerCommentIds
        ]?.findIndex((threadKey)=>threadKey === currentThreadKey) : orderedActiveAnnotations?.findIndex((threadKey)=>threadKey === currentThreadKey);
    }, [
        orderedActiveAnnotations,
        footerCommentIds
    ]);
    const openInlineComment = (0, $42omo.useCallback)((markerRef)=>{
        if ((pageClass === 'renderer' || pageClass === 'editor') && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_keyboard')) experienceTracker.start({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                annotationId: markerRef,
                entryPoint: 'comments-shortcuts/ViewCommentShortcutListener',
                pageClass: 'renderer'
            }
        });
        setCurrentlySelectedThreadKey('');
        const commentElement = document.getElementById(markerRef);
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            annotationId: markerRef
        });
        (0, $4EKKB.selectInlineComment).debug(`Keyboard selection now triggering annotation selection for annotation ${markerRef}`);
        emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [
                markerRef
            ],
            eventTarget: commentElement
        });
        if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: markerRef,
            commentType: (0, $f5Wgm.CommentType).INLINE,
            isCommentsPanelOpen: isObjectSidebarShown && (0, $9wGTI.fg)('confluence-frontend-comments-panel'),
            hasKeyPressed: true
        });
        else (0, $aHcFH.scrollCommentIntoView)({
            commentElement: commentElement,
            isFabricPage: true
        });
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        experienceTracker,
        pageClass,
        isObjectSidebarShown
    ]);
    const scrollToFooterComment = (0, $42omo.useCallback)((threadKey)=>{
        setCurrentlySelectedThreadKey(threadKey);
        emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [],
            eventTarget: null
        });
        if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: threadKey,
            commentType: (0, $f5Wgm.CommentType).FOOTER,
            isCommentsPanelOpen: isObjectSidebarShown && (0, $9wGTI.fg)('confluence-frontend-comments-panel'),
            hasKeyPressed: true
        });
        else (0, $7qvmT.handlePanelSelectionAndScroll)({
            threadKey: threadKey,
            isResolved: false,
            pageMode: pageMode,
            setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
            eventEmitter: emitter,
            commentType: (0, $8i27m.CommentType).GENERAL
        });
    }, [
        emitter,
        pageMode,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const onNavigationClick = (0, $42omo.useCallback)((nextMarkerRef)=>{
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                openInlineComment(nextMarkerRef);
            }
        });
        else openInlineComment(nextMarkerRef);
    }, [
        hasContentChanged,
        resetContentChanged,
        showModal,
        openInlineComment
    ]);
    const handlePanelCommentNavigation = (0, $42omo.useCallback)((action)=>{
        // If nothing is on the panel, there's nothing to navigate to
        if (currentlyRenderedThreads.length === 0) return;
        const { panelCommentRefs: panelCommentRefs, navigableInlineCommentRefs: navigableInlineCommentRefs } = (0, $izhdc.parsePanelAndInlineRefs)(currentlyRenderedThreads, orderedActiveAnnotations);
        const nextRef = (0, $izhdc.getNextRef)(action, panelCommentRefs, currentlySelectedThreadKey);
        // Use unified keyboard shortcut navigation for panel navigation when feature is enabled
        if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) {
            // Handle panel selection state management in the listener
            setCurrentlySelectedThreadKey(nextRef.ref);
            (0, $9FoVw.handleKeyboardShortcutNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                block: 'center',
                annotationId: nextRef.ref,
                commentType: nextRef.type === (0, $8i27m.CommentType).GENERAL ? (0, $f5Wgm.CommentType).FOOTER : (0, $f5Wgm.CommentType).INLINE,
                isCommentsPanelOpen: isObjectSidebarShown && (0, $9wGTI.fg)('confluence-frontend-comments-panel'),
                hasKeyPressed: true,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                isResolved: !navigableInlineCommentRefs.has(nextRef.ref)
            });
        } else // Use old method when unified navigation is disabled
        (0, $7qvmT.handlePanelSelectionAndScroll)({
            threadKey: nextRef.ref,
            isResolved: !navigableInlineCommentRefs.has(nextRef.ref),
            pageMode: pageMode,
            setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
            eventEmitter: emitter,
            commentType: nextRef.type,
            scrollCommentsPanelToThread: scrollCommentsPanelToThread,
            shouldScrollCommentsPanel: true,
            hasKeyPressed: true
        });
    }, [
        currentlyRenderedThreads,
        orderedActiveAnnotations,
        currentlySelectedThreadKey,
        pageMode,
        setCurrentlySelectedThreadKey,
        emitter,
        scrollCommentsPanelToThread,
        isObjectSidebarShown
    ]);
    const handleNextCommentNavigation = (0, $42omo.useCallback)(({ action: action, isNavigateToNextUnread: isNavigateToNextUnread })=>{
        //Check if the next inline comment is still in process of being rendered. Otherwise, quickly pressing keys will force comment to open and close instead of navigating
        if (isNextCommentLoading) return;
        setIsNextCommentLoading(true);
        navigateToInlineComment({
            action: action,
            triggeredByKeyboardShortcut: true,
            currentCommentIndex: getCommentIndex(activeHighlight || currentlySelectedThreadKey || ''),
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: false,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: contentId,
            isNavigateToNextUnread: isNavigateToNextUnread,
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments,
            footerComments: footerCommentIds,
            scrollToFooterComment: scrollToFooterComment,
            commentsDataMap: commentsDataMap
        });
    }, [
        isNextCommentLoading,
        navigateToInlineComment,
        getCommentIndex,
        activeHighlight,
        currentlySelectedThreadKey,
        onNavigationClick,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        createAnalyticsEvent,
        contentId,
        unreadInlineComments,
        unreadGeneralComments,
        footerCommentIds,
        scrollToFooterComment,
        commentsDataMap
    ]);
    const handleStandaloneCommentNavigation = (0, $42omo.useCallback)((action)=>{
        if (activeHighlight || currentlySelectedThreadKey) {
            // Check if we're navigating to a potentially unloaded footer comment
            const currentIndex = getCommentIndex(activeHighlight || currentlySelectedThreadKey || '');
            const totalComments = [
                ...orderedActiveAnnotations,
                ...footerCommentIds
            ].length;
            const navigatingToPotentiallyUnloadedFooterComment = (0, $izhdc.isNavigatingToPotentiallyUnloadedFooterComment)(action, currentIndex, totalComments, footerCommentsLoadingState);
            if (navigatingToPotentiallyUnloadedFooterComment && (0, $9wGTI.fg)('confluence_frontend_kb_footer_loading')) setPendingStandaloneAction(action);
            else handleNextCommentNavigation({
                isNavigateToNextUnread: false,
                action: action
            });
        } else {
            // No highlight selected, so we navigate to the first inline comment
            const firstInlineCommentMarkerRef = orderedActiveAnnotations[0];
            if (!firstInlineCommentMarkerRef && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? footerCommentThreads.length === 0 : true)) {
                // No active inline comments or footer comments found, but footer is not yet loaded - load footer comments and try again
                if (footerCommentsLoadingState === (0, $8i27m.FooterCommentsLoadingStateType).NOT_LOADED && (0, $9wGTI.fg)('confluence_frontend_kb_footer_loading')) setPendingStandaloneAction(action);
                return;
            }
            if (firstInlineCommentMarkerRef) openInlineComment(firstInlineCommentMarkerRef);
            else if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) scrollToFooterComment(footerCommentThreads[0]?.id);
        }
    }, [
        activeHighlight,
        currentlySelectedThreadKey,
        getCommentIndex,
        orderedActiveAnnotations,
        footerCommentIds,
        footerCommentsLoadingState,
        handleNextCommentNavigation,
        footerCommentThreads,
        openInlineComment,
        scrollToFooterComment
    ]);
    const handleCommentNavigation = (0, $42omo.useCallback)((action)=>{
        // Define behavior when the comments panel is shown - panel FG is a prereq for nav, so has to be checked first
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('confluence-frontend-comments-panel') && isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) handlePanelCommentNavigation(action);
        else // Comments panel not shown
        handleStandaloneCommentNavigation(action);
    }, [
        isObjectSidebarShown,
        panel?.id,
        handlePanelCommentNavigation,
        handleStandaloneCommentNavigation
    ]);
    (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId || '',
        skip: !triggeredByUnreadKeyboardShortcut || alreadyFetchedInitialData || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        onCompletedFn: ()=>{
            setAlreadyFetchedInitialData(true);
        }
    });
    // The flow is setPendingStandaloneAction --> load footer comments --> updates footerCommentIds --> retrigger KB shortcut with updated data
    const shouldLoadFooterComments = pendingStandaloneAction !== null;
    (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId || '',
        skip: !shouldLoadFooterComments || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        fetchPolicy: shouldLoadFooterComments ? 'network-only' : 'cache-only',
        type: (0, $f5Wgm.CommentType).FOOTER
    });
    (0, $42omo.useEffect)(()=>{
        if (pendingStandaloneAction !== null) {
            handleStandaloneCommentNavigation(pendingStandaloneAction);
            setPendingStandaloneAction(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        footerCommentIds
    ]);
    const handleNextUnreadNavigation = (0, $42omo.useCallback)(()=>{
        if (!alreadyFetchedInitialData) {
            //This will trigger the ActiveComments query if it's not already fetched
            setTriggeredByUnreadKeyboardShortcut(true);
            //Exit because the comment data won't be available yet to navigate to
            return;
        }
        //unread panel navigation
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel && (0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
            let nextThreadKey = '';
            let nextCommentType = (0, $8i27m.CommentType).GENERAL;
            if (!currentlySelectedThreadKey) {
                if (unreadInlineComments.length > 0) {
                    nextThreadKey = unreadInlineComments[0];
                    nextCommentType = (0, $8i27m.CommentType).INLINE;
                } else nextThreadKey = unreadGeneralComments[0];
            } else {
                nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(getCommentIndex(currentlySelectedThreadKey ?? '') + 1, [
                    ...orderedActiveAnnotations,
                    ...footerCommentIds
                ], [
                    ...unreadInlineComments,
                    ...unreadGeneralComments
                ]) ?? '';
                if (unreadInlineComments.includes(nextThreadKey)) nextCommentType = (0, $8i27m.CommentType).INLINE;
            }
            // Use unified keyboard shortcut navigation for panel navigation when feature is enabled
            if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) {
                // Handle panel selection state management in the listener
                setCurrentlySelectedThreadKey(nextThreadKey);
                (0, $9FoVw.handleKeyboardShortcutNavigation)({
                    scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                    block: 'center',
                    annotationId: nextThreadKey,
                    commentType: nextCommentType === (0, $8i27m.CommentType).GENERAL ? (0, $f5Wgm.CommentType).FOOTER : (0, $f5Wgm.CommentType).INLINE,
                    isCommentsPanelOpen: isObjectSidebarShown && (0, $9wGTI.fg)('confluence-frontend-comments-panel'),
                    hasKeyPressed: true,
                    context: (0, $9FoVw.NavigationContext).RENDERER,
                    shortcutType: (0, $9FoVw.ShortcutType).UNREAD
                });
            } else // Use old method when unified navigation is disabled
            (0, $7qvmT.handlePanelSelectionAndScroll)({
                threadKey: nextThreadKey,
                isResolved: false,
                pageMode: pageMode,
                setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
                eventEmitter: emitter,
                commentType: nextCommentType,
                scrollCommentsPanelToThread: scrollCommentsPanelToThread,
                shouldScrollCommentsPanel: true
            });
            return;
        }
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: true,
            action: 'next'
        });
        else {
            if (unreadInlineComments.length + unreadGeneralComments.length === 0) return;
            if (unreadInlineComments[0]) openInlineComment(unreadInlineComments[0]);
            else scrollToFooterComment(unreadGeneralComments[0]);
        }
    }, [
        isObjectSidebarShown,
        panel?.id,
        handleNextCommentNavigation,
        unreadInlineComments,
        activeHighlight,
        openInlineComment,
        scrollToFooterComment,
        currentlySelectedThreadKey,
        unreadGeneralComments,
        emitter,
        footerCommentIds,
        getCommentIndex,
        orderedActiveAnnotations,
        pageMode,
        scrollCommentsPanelToThread,
        setCurrentlySelectedThreadKey,
        alreadyFetchedInitialData
    ]);
    (0, $42omo.useEffect)(()=>{
        if (unreadInlineComments.length + unreadGeneralComments.length > 0 && alreadyFetchedInitialData && triggeredByUnreadKeyboardShortcut) {
            // This handles the case where user triggers unread keyboard shortcut when the comments data isn't fetched yet.
            // We need to wait for the data to be fetched before calling handleNextUnreadNavigation
            setTriggeredByUnreadKeyboardShortcut(false);
            // Putting this behind a timeout because need to wait for triggeredByUnreadKeyboardShortcut to be set to false otherwise got called multiple times
            setTimeout(()=>{
                handleNextUnreadNavigation();
            }, 100);
        }
    }, [
        unreadInlineComments,
        unreadGeneralComments,
        handleNextUnreadNavigation,
        alreadyFetchedInitialData,
        triggeredByUnreadKeyboardShortcut,
        setTriggeredByUnreadKeyboardShortcut
    ]);
    const openCommentEditorShortcutCb = (e)=>{
        e.preventDefault();
        // This check is necessary to see which keyboard shortcut was used so it can be sent to analytics.
        // e.key is used to get the key that was pressed according to the current keyboard layout.
        // We compare with CREATE_COMMENT_SHORTCUT because it is a single-letter keyboard shortcut.
        // It's more difficult to compare with UNIVERSAL_OPEN_COMMENT_EDITOR because it includes modifiers.  Modifiers which change what e.key maps to depending on the keyboard layout.
        const shortcut = e.key === (0, $gnkil.CREATE_COMMENT_SHORTCUT) ? (0, $gnkil.CREATE_COMMENT_SHORTCUT) : (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR);
        if (canAddComments || !(0, $9wGTI.fg)('confluence_fe_add_comment_kb_check_permission')) {
            if (document.querySelector('[data-testid="highlightActionsPopup"]')) {
                const createButton = document.querySelector('#create-inline-comment-button');
                // if the disabled attribute is there, and comes back as an empty string, it is disabled.
                // If the disabled attribute is not there, it will come back as null
                const createButtonIsDisabled = createButton?.getAttribute('disabled') === '';
                // If createButton is not found or is disabled, do nothing.
                // This handles the case when hovering over media (image/video) objects in renderer.
                // In this scenario, a `highlightActionsPopup` is shown but the Comment button (which
                // has a different id) behaves differently: if any comment exists on the media object,
                // button click opens it as standalone; otherwise button click opens CreateComment.
                // Keyboard shortcut is disabled for this scenario.
                const createButtonIsEnabled = createButton && createButton?.getAttribute('disabled') !== '';
                if ((0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage') ? createButtonIsEnabled : !createButtonIsDisabled) handleCommentButtonClick({
                    dialogs: dialogs,
                    shortcut: shortcut,
                    experienceAttributes: {
                        entryPoint: 'keyboardShortcut'
                    }
                });
            } else {
                // Check if we should show sticky draft instead of scrolling to object comment wrapper
                const isShowStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT && (0, $9wGTI.fg)('confluence_comment_sticky_footer_enabled');
                if (!expanded) expandCommentContainer({
                    entryPoint: 'keyboardShortcutView'
                });
                if (isShowStickyDraft || !isObjectCommentWrapperVisible && (0, $9wGTI.fg)('confluence_comment_expand_footer_editor')) setFooterEditorEntry((0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT);
                else document.querySelector(`[data-testid='object-comment-wrapper']`)?.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
        sendKeyboardShortcutAnalytics(shortcut);
    };
    if (!isFabricPage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "comments-shortcut-listener"
    }, (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_SELECT_COMMENT_SHORTCUT),
        listener: ()=>{
            const openComment = document.getElementById('renderer-comments-sidebar') || document.getElementById(`comment-thread-${currentlySelectedThreadKey}-container`);
            if (openComment) {
                openComment.setAttribute('tabIndex', '-1');
                openComment.focus();
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.NEXT_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to next comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleCommentNavigation('next');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.PREV_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to previous comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleCommentNavigation('previous');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('Keyboard navigation to next unread comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleNextUnreadNavigation();
        }
    }), (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.CREATE_COMMENT_SHORTCUT),
        accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
        listener: (e)=>openCommentEditorShortcutCb(e)
    }));
};
const $c392465906bed01c$export$c1f9f1253d923bc1 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})((0, $inDu6.withDialogs)($c392465906bed01c$var$ViewCommentShortcutListenerComponent));
module.exports["ViewCommentShortcutListener"] = $c392465906bed01c$export$c1f9f1253d923bc1;

});

parcelRegister("6pBXK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $95494d62ea246593$export$ffdc57aecb97ae41 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nmqvg",
    name: "ReadingAidsAcronymsHighlighter",
    loader: async ()=>(await (parcelRequire("juMUo"))).ReadingAidsAcronymsHighlighter
});
module.exports["ReadingAidsAcronymsHighlighter"] = $95494d62ea246593$export$ffdc57aecb97ae41;

});

parcelRegister("juMUo", function(module, exports) {

let $e316c1e30531c218$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e316c1e30531c218$var$load("2YffH"),
    $e316c1e30531c218$var$load("1FvvC"),
    $e316c1e30531c218$var$load("6mHrv"),
    $e316c1e30531c218$var$load("9zkjw"),
    $e316c1e30531c218$var$load("88Shx"),
    $e316c1e30531c218$var$load("1QdXB"),
    $e316c1e30531c218$var$load("8hSeL"),
    $e316c1e30531c218$var$load("7RXky"),
    $e316c1e30531c218$var$load("lVO3w"),
    $e316c1e30531c218$var$load("hyzoX"),
    $e316c1e30531c218$var$load("h9Ed7"),
    $e316c1e30531c218$var$load("9A0ig"),
    $e316c1e30531c218$var$load("dVAT5"),
    $e316c1e30531c218$var$load("fIFgO"),
    $e316c1e30531c218$var$load("86sUJ"),
    $e316c1e30531c218$var$load("8VzWv"),
    $e316c1e30531c218$var$load("8YSo7"),
    $e316c1e30531c218$var$load("gryT8"),
    $e316c1e30531c218$var$load("1d7Ag"),
    $e316c1e30531c218$var$load("9XYQ9"),
    $e316c1e30531c218$var$load("kiGNy"),
    $e316c1e30531c218$var$load("St9Nk"),
    $e316c1e30531c218$var$load("8JZKd"),
    $e316c1e30531c218$var$load("7jH9e"),
    $e316c1e30531c218$var$load("6FuHS"),
    $e316c1e30531c218$var$load("eyaRC"),
    $e316c1e30531c218$var$load("drv5I"),
    $e316c1e30531c218$var$load("g9CVe"),
    $e316c1e30531c218$var$load("5EQhG"),
    $e316c1e30531c218$var$load("36QeB"),
    $e316c1e30531c218$var$load("8fXIr"),
    $e316c1e30531c218$var$load("dVkhd"),
    $e316c1e30531c218$var$load("hv4mn"),
    $e316c1e30531c218$var$load("hhss7"),
    $e316c1e30531c218$var$load("7jSfd"),
    $e316c1e30531c218$var$load("4HZlX"),
    $e316c1e30531c218$var$load("kDqHr"),
    $e316c1e30531c218$var$load("6wr18"),
    $e316c1e30531c218$var$load("kjZZD"),
    $e316c1e30531c218$var$load("ht5OT"),
    $e316c1e30531c218$var$load("sj9Xz"),
    $e316c1e30531c218$var$load("eHDb1"),
    $e316c1e30531c218$var$load("2zUEf"),
    $e316c1e30531c218$var$load("Wowvf"),
    $e316c1e30531c218$var$load("37ldp"),
    $e316c1e30531c218$var$load("dTsOE"),
    $e316c1e30531c218$var$load("8FbYE"),
    $e316c1e30531c218$var$load("dUevD"),
    $e316c1e30531c218$var$load("ffEVr"),
    $e316c1e30531c218$var$load("f1NVy"),
    $e316c1e30531c218$var$load("8Gekp"),
    $e316c1e30531c218$var$load("7e13v"),
    $e316c1e30531c218$var$load("aqr2D"),
    $e316c1e30531c218$var$load("7EorR"),
    $e316c1e30531c218$var$load("avRkh"),
    $e316c1e30531c218$var$load("6mkG4")
]).then(()=>parcelRequire('6vx1i'));

});

parcelRegister("39nIX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");

var $398ES = parcelRequire("398ES");


var $7d2Nc = parcelRequire("7d2Nc");


var $5RuD9 = parcelRequire("5RuD9");


var $jhifQ = parcelRequire("jhifQ");


/* View Mode Exports */ const $166368e9a123fc4e$var$InlineCommentsLoaderPaint = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "fZs06",
    name: "InlineCommentsLoaderPaint",
    loader: async ()=>(await (parcelRequire("51lmO"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderLazy = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i8DIK",
    name: "InlineCommentsLoaderLazy",
    loader: async ()=>(await (parcelRequire("51lmO"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vilgC",
    name: "InlineCommentsLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("51lmO"))).InlineComments
});

const $166368e9a123fc4e$var$InlineCommentsLoaderBackground = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "05zPo",
    name: "InlineCommentsLoaderBackground",
    loader: async ()=>(await (parcelRequire("51lmO"))).InlineComments
});
const $166368e9a123fc4e$var$loaders = {
    [(0, $398ES.LoadingPriority).LAZY]: $166368e9a123fc4e$var$InlineCommentsLoaderLazy,
    [(0, $398ES.LoadingPriority).PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderPaint,
    [(0, $398ES.LoadingPriority).AFTER_PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint
};
const $166368e9a123fc4e$export$bceb71dc98e1c75f = ({ loadingPriority: loadingPriority, focusedCommentId: focusedCommentId, ...rest })=>{
    const CommentsLoader = $166368e9a123fc4e$var$loaders[loadingPriority] || $166368e9a123fc4e$var$InlineCommentsLoaderBackground;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, focusedCommentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        key: `start-${focusedCommentId}`,
        metric: (0, $jhifQ.FOCUSED_INLINE_COMMENT_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CommentsLoader, rest));
};
module.exports["InlineCommentsLoader"] = $166368e9a123fc4e$export$bceb71dc98e1c75f;

});

parcelRegister("5RuD9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8uhVX = parcelRequire("8uhVX");


var $beAZw = parcelRequire("beAZw");

const $58d1b0f1d68392b5$var$checkForSSRFocusedComment = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $58d1b0f1d68392b5$export$d174da0f28ffce9e = ()=>{
    return $58d1b0f1d68392b5$var$checkForSSRFocusedComment() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8uhVX.FocusedInlineComment), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $beAZw.InlineCommentsLoadingSkeleton), null);
};
module.exports["InlineCommentsLoading"] = $58d1b0f1d68392b5$export$d174da0f28ffce9e;

});

parcelRegister("8uhVX", function(module, exports) {
/* FocusedInlineComment.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $2XqLN = parcelRequire("2XqLN");


var $8C5kA = parcelRequire("8C5kA");


var $xQxzY = parcelRequire("xQxzY");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");




var $8Ya23 = parcelRequire("8Ya23");


var $9CnRS = parcelRequire("9CnRS");


var $666Tc = parcelRequire("666Tc");


var $aHcFH = parcelRequire("aHcFH");



var $f8HSn = parcelRequire("f8HSn");


var $qYtBT = parcelRequire("qYtBT");


var $dQJV7 = parcelRequire("dQJV7");


var $c04ej = parcelRequire("c04ej");

const $d9a6205ec51ab13a$var$parseContent = (0, $2XqLN.default)((content)=>{
    if (!content?.length) return null;
    try {
        return JSON.parse(content);
    } catch (error) {
        return null;
    }
});
const $d9a6205ec51ab13a$var$FocusedInlineCommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $666Tc.SidebarContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_162hus6": (0, $7sObp.default)(__cmplp.offset, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_154i1odf _zqk2124n _16tr13gf",
            __cmplp.showSkeleton ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /* Comment Editor CSS*/ 
const $d9a6205ec51ab13a$var$EditorContainerSSR = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $666Tc.EditorContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_10v51b66 _1fnwia51 _116r1l7b _kv9q2smr _12i31ul9 _j980usvi _1esn1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d9a6205ec51ab13a$var$CommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt49l6b _12ji1r31 _1qu2glyw _12y31o36 _1kl7idpf _x3doidpf _1e0c1txw _2lx21bp4 _1ragidpf _ha8hi7uo",
            __cmplp.isFocused && "_11q71856",
            __cmplp.className
        ])
    });
});
const $d9a6205ec51ab13a$export$622cea445a1c5b7d = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['markerRefOffset'];
    return 0;
}; // Makes sure to only show focusedInlineCommentSSR if the page was ssr'd
const $d9a6205ec51ab13a$export$db871669e60ed1cb = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $d9a6205ec51ab13a$export$7afb8d400fcdf579 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const focusedCommentId = match?.query.focusedCommentId; // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $8Ya23.FocusedInlineCommentQuery), {
        variables: {
            commentId: focusedCommentId,
            contentId: contentId
        },
        skip: !(contentId && focusedCommentId)
    });
    let commentData;
    let isTopLevelComment = true; /* If focusedCommentId is a reply grab top-level comment Data from ancestors.
                                 If ancestors is non-empty it means focusedCommentId is a reply*/ 
    if (data?.comments?.nodes[0]?.ancestors.length > 0) {
        commentData = data?.comments?.nodes[0]?.ancestors?.[0];
        isTopLevelComment = false;
    } else commentData = data?.comments?.nodes[0];
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['isTopLevelComment'] = isTopLevelComment;
    const content = data?.content?.nodes?.[0];
    const operations = content?.operations || [];
    const canCreateComments = Boolean(operations.find((op)=>op?.operation === 'create' && op?.targetType === 'comment'));
    const topCommentUserId = commentData?.author?.accountId;
    const topCommentUserAvatar = commentData?.author?.profilePicture?.path;
    const topCommentDisplayName = commentData?.author?.displayName;
    const commentId = commentData?.id;
    const when = commentData?.version?.when;
    const commentContent = commentData?.body?.value;
    const permissionType = commentData?.author?.permissionType;
    const currentUserAvatarUrl = data?.user?.photos[0].value || null;
    const currentUserDisplayName = data?.user?.displayName || null;
    const currentUserId = data?.user?.id;
    const adf = $d9a6205ec51ab13a$var$parseContent(commentContent);
    const renderReplies = ()=>{
        const replies = commentData?.replies || [];
        return replies.map((reply)=>{
            const adf = $d9a6205ec51ab13a$var$parseContent(reply?.body?.value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
                key: reply?.id,
                isFocused: focusedCommentId === reply?.id,
                "data-comment-id": reply?.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8HSn.CommentAuthor), {
                commentMode: "view",
                userId: reply?.author?.accountId,
                avatarUrl: reply?.author?.profilePicture?.path,
                displayName: reply?.author?.displayName,
                date: reply?.version?.when,
                permissionType: reply?.author?.permissionType
            }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c04ej.CommentRenderer), {
                adf: adf
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dQJV7.CommentActions), {
                isReply: true,
                permissions: reply?.permissions
            }));
        });
    }; // Scroll to focusedInlineComment if it's out of the screen
    const scrollOffset = window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment'] && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['scrollOffset'];
    if (scrollOffset) window.scrollTo({
        top: scrollOffset
    });
    const { commentIndex: commentIndex, totalComments: totalComments } = (0, $aHcFH.getCommentIndexAndCount)();
    if (data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d9a6205ec51ab13a$var$FocusedInlineCommentContainer, {
        mode: "view",
        id: "focused-inline-comment-sidebar-skeleton",
        "data-testid": "focused-inline-comment-sidebar-skeleton",
        showSkeleton: $d9a6205ec51ab13a$export$db871669e60ed1cb(),
        offset: $d9a6205ec51ab13a$export$622cea445a1c5b7d()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $qYtBT.CommentHeader), {
        commentIndex: commentIndex,
        totalComments: totalComments
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
        tabIndex: -1,
        "data-comment-id": commentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "view",
        userId: topCommentUserId,
        avatarUrl: topCommentUserAvatar,
        displayName: topCommentDisplayName,
        date: when,
        permissionType: permissionType,
        size: "medium"
    }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c04ej.CommentRenderer), {
        adf: adf
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dQJV7.CommentActions), {
        permissions: commentData?.permissions,
        isReply: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.ReplyListContainer), {
        "data-testid": "reply-container"
    }, renderReplies()), canCreateComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.NewReplyContainer), {
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d9a6205ec51ab13a$var$EditorContainerSSR, {
        isReply: true,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "reply",
        userId: currentUserId,
        avatarUrl: currentUserAvatarUrl,
        displayName: currentUserDisplayName,
        date: when,
        permissionType: permissionType,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        disabled: true,
        placeholder: formatMessage((0, $9CnRS.i18n).replyPlaceholder)
    })))), undefined);
    return null;
};
module.exports["FocusedInlineComment"] = $d9a6205ec51ab13a$export$7afb8d400fcdf579;

});

parcelRegister("f8HSn", function(module, exports) {
/* CommentAuthor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fs6LW = parcelRequire("fs6LW");


var $gvWVt = parcelRequire("gvWVt");


var $1YXTQ = parcelRequire("1YXTQ");


var $7tI6B = parcelRequire("7tI6B");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$DateContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c1txw _4cvr1h6o _102e1o8v _1mil78py _7wy0glyw _1t4pd34b _1plv1j28 _zmp8d34b _9b8id34b _1blwd34b",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$var$AuthorContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _uvzw1snc _12rjagmp _1vjrvv82 _1dtc4viv _jva41snc _wkreagmp _gcmzvv82 _5xy14viv _1msj4viv",
            __cmplp.commentMode !== 'reply' ? "_18u01i6y" : "_18u01kw7",
            __cmplp.commentMode === 'view' && "_n3tdu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$AvatarWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.commentMode === 'view' && "_4t3i1wpv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$ProfileLinkContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx2vrvc _4cvr1h6o _17rp1o8v _cpznidpf _1s79idpf _amufidpf _x966idpf _387xglyw _14l5d34b _1ptk1j28 _19gdazsu _1e6pazsu _1gidazsu _zer61snc _7ec9agmp _1bkkvv82 _z01g4viv _101q1snc _vnv1agmp _94evvv82 _kvyv4viv _18t3x3d0 _1t4p4viv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$LozengeWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19bvu2gc _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$export$d05a2f5fbf67a6d7 = ({ commentMode: commentMode, userId: userId, date: date, displayName: displayName, avatarUrl: avatarUrl, permissionType: permissionType, size: size })=>{
    const isDateShown = commentMode === 'view' && date;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$AuthorContainer, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$AvatarWrapper, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: userId,
        src: avatarUrl,
        size: size,
        trigger: "click",
        name: displayName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$ProfileLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, displayName), permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null)) : null), isDateShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$DateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
        date: date
    })))));
};
module.exports["CommentAuthor"] = $b0598b16360d1677$export$d05a2f5fbf67a6d7;

});

parcelRegister("qYtBT", function(module, exports) {
/* CommentHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hmuev = parcelRequire("hmuev");


var $9VJDA = parcelRequire("9VJDA");


var $7N1sB = parcelRequire("7N1sB");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9359cd91b07ea16f$var$SidebarHeader = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4ba4q _kqswh2mm _1e0c1txw _4t3i10yn _ca0qutpp _1hadu49m _wzsr12b0 _brspgktf _11pzgktf _p7gl1wug _1p0qutpp _etmr1b66 _13yvyfq0",
            __cmplp.className
        ])
    });
});
const $9359cd91b07ea16f$export$af4e8b81cdb5570a = ({ commentIndex: commentIndex, totalComments: totalComments })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9359cd91b07ea16f$var$SidebarHeader, {
        "data-testid": "inline-comment-ssr-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7N1sB.CommentNavigation), {
        commentsCount: totalComments,
        currentCommentIndex: commentIndex,
        goToNextInlineComment: ()=>{},
        goToPrevInlineComment: ()=>{}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: "dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        label: "overflow-menu-icon",
        color: "var(--ds-icon-disabled, #080F214A)",
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: "close-icon-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        label: "close-icon",
        color: `${"var(--ds-icon-disabled, #080F214A)"}`,
        spacing: "none"
    })));
};
module.exports["CommentHeader"] = $9359cd91b07ea16f$export$af4e8b81cdb5570a;

});

parcelRegister("dQJV7", function(module, exports) {
/* CommentActions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");


var $bFPHx = parcelRequire("bFPHx");


var $666Tc = parcelRequire("666Tc");


var $9CnRS = parcelRequire("9CnRS");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e6040be4eb93366f$var$ActionsContainerSSR = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $666Tc.ActionsContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1tke10yn _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c116y _syaz1rpy _19pk1b66 _xrwlcs5v _144bkb7n _14p1f1ug _ekv61o8v _6wjiesu3 _43ds1oa5 _1pzmusic _ep9t1b66 _1tzjf4df _8bo21mp2 _nqnu1rpy _d32v1rpy",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu21kw7 _12y31o36 _syaz1kw7 _1wyb1kw7 _80omtlke",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$export$e75a036919cd8d68 = ({ isReply: isReply, permissions: permissions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionsContainerSSR, null, permissions.isResolvable && !isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).resolve))), permissions.isEditable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).edit))), permissions.isRemovable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).delete))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), null));
module.exports["CommentActions"] = $e6040be4eb93366f$export$e75a036919cd8d68;

});

parcelRegister("c04ej", function(module, exports) {
/* CommentRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $bzqa9 = parcelRequire("bzqa9");


var $hEeUR = parcelRequire("hEeUR");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $61a27fe9845a1cb4$var$CommentRendererContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _ca0qutpp _n3tdutpp",
            __cmplp.className
        ])
    });
});
const $61a27fe9845a1cb4$export$ce6d3ea87eba7794 = ({ adf: adf })=>{
    const eventHandlers = (0, $bzqa9.useEventHandlers)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($61a27fe9845a1cb4$var$CommentRendererContainer, {
        id: "ssr-comment-renderer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEeUR.ADFRenderer), {
        document: adf,
        appearance: "comment",
        eventHandlers: eventHandlers
    }));
};
module.exports["CommentRenderer"] = $61a27fe9845a1cb4$export$ce6d3ea87eba7794;

});

parcelRegister("beAZw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $rVJpV = parcelRequire("rVJpV");


var $666Tc = parcelRequire("666Tc");

const $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80 = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'] && Array.isArray(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'])) return Boolean(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'].length);
    return false;
};
const $c9d0ea73f4f989e9$export$e90f33bd7f6da077 = ({ offset: offset = 0 })=>{
    /* For SSR check window object or use offset if passed */ // Previously, clicking on a comment via the inline comment button would still generate an offset.
    // That meant that on transitions, the loading skeleton would still flicker, so we check for window.__SSR_RENDERED__ as well
    /// to prevent the flicker on transitions.
    const sideBarOffset = window.__SSR_RENDERED__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['sidebarCommentOffset'] || offset;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.LoadingSkeletonContainer), {
        id: "inline-comment-sidebar-skeleton",
        "data-testid": "inline-comment-sidebar-skeleton",
        showSkeleton: $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80() || Boolean(offset),
        offset: sideBarOffset,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $rVJpV.LoadingSkeletonChildren), null));
};
module.exports["InlineCommentsLoadingSkeleton"] = $c9d0ea73f4f989e9$export$e90f33bd7f6da077;

});

parcelRegister("rVJpV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $9hlns = parcelRequire("9hlns");


var $hmuev = parcelRequire("hmuev");


var $9VJDA = parcelRequire("9VJDA");


var $666Tc = parcelRequire("666Tc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SkeletonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4pxbi _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4pxbi _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonRow = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { flex: flex, useColumnDirection: useColumnDirection, marginTop: marginTop, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_flb7sw": (0, $7sObp.default)(__cmplp.flex),
                "--_11vu6jx": (0, $7sObp.default)(__cmplp.marginTop, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1e0c1txw _19pk4hp3",
                __cmplp.flex ? "_kkes1ubm" : "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.useColumnDirection ? "_2lx21bp4" : "_2lx2vrvc",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { flex: flex, useColumnDirection: useColumnDirection, marginTop: marginTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_flb7sw": (0, $7sObp.default)(__cmplp.flex),
            "--_11vu6jx": (0, $7sObp.default)(__cmplp.marginTop, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _19pk4hp3",
            __cmplp.flex ? "_kkes1ubm" : "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.useColumnDirection ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $f5ae94c9feb318d8$var$CommentAuthorSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1rr0 _4t3izwfg _1bsbzwfg _bfhkizff",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _4t3izwfg _1bsbzwfg _bfhkizff",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonLine = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { marginBottom: marginBottom, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_iz5w78": (0, $7sObp.default)(__cmplp.marginBottom, "px"),
                "--_10ib6lf": (0, $7sObp.default)(__cmplp.height, "px"),
                "--_1gljcou": (0, $7sObp.default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_2rko1l7b _bfhkizff _1bsb1rkg",
                typeof __cmplp.marginBottom === "number" ? "_otyr1s4l" : "_otyrrdoj",
                __cmplp.height ? "_4t3it1jn" : "_4t3iftgi",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginBottom: marginBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_iz5w78": (0, $7sObp.default)(__cmplp.marginBottom, "px"),
            "--_10ib6lf": (0, $7sObp.default)(__cmplp.height, "px"),
            "--_1gljcou": (0, $7sObp.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1l7b _bfhkizff _1bsb1rkg",
            typeof __cmplp.marginBottom === 'number' ? "_otyr1s4l" : "_otyrrdoj",
            __cmplp.height ? "_4t3it1jn" : "_4t3iftgi",
            __cmplp.className
        ])
    });
});
const $f5ae94c9feb318d8$var$SpinnerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _19pku2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _19pku2gc",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SidebarHeader = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41fsj _kqswh2mm _1e0c1txw _1bah1yb4 _4t3i10yn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41fsj _kqswh2mm _1e0c1txw _1bah1yb4 _4t3i10yn",
            __cmplp.className
        ])
    });
});
const $f5ae94c9feb318d8$var$CloseButton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.InlineHeaderButton) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u014y2 _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $666Tc.InlineHeaderButton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u014y2 _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
});
const $f5ae94c9feb318d8$var$NavContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.NavigationContainer) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $666Tc.NavigationContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $f5ae94c9feb318d8$export$4857ba7068d0bed8 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkidpf _otyridpf _kqswh2mm _bfhkvuon",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _otyridpf _kqswh2mm _bfhkvuon",
            __cmplp.className
        ])
    });
});
const $f5ae94c9feb318d8$export$a42ae5e40534ea56 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 30,
            height: 8,
            marginBottom: 0
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-disabled, #080F214A)"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SidebarHeader, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CloseButton, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: ""
            })
        })));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentAuthorSkeleton, null));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$export$4857ba7068d0bed8, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 5,
            marginTop: 5,
            useColumnDirection: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 81
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 53,
            height: 6
        })))));
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t3, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium"
        })));
        $[6] = t6;
    } else t6 = $[6];
    return t6;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SidebarHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$NavContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
        "data-cy": "inline-nav-previous",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
            label: "",
            color: "var(--ds-icon-disabled, #080F214A)",
            spacing: "spacious",
            size: "small"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
        "data-cy": "inline-nav-previous",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            color: "var(--ds-icon-disabled, #080F214A)",
            spacing: "spacious",
            size: "small"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
        width: 30,
        height: 8,
        marginBottom: 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$NavContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-disabled, #080F214A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CloseButton, {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: ""
        })
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$export$4857ba7068d0bed8, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
        flex: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
        flex: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentAuthorSkeleton, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
        flex: 5,
        marginTop: 5,
        useColumnDirection: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
        width: 81
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
        width: 53,
        height: 6
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "medium"
    })));
};
module.exports["LoadingSkeletonChildren"] = $f5ae94c9feb318d8$export$a42ae5e40534ea56;

});

parcelRegister("51lmO", function(module, exports) {

let $3a7d9ec68b20844a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3a7d9ec68b20844a$var$load("goLL0"),
    $3a7d9ec68b20844a$var$load("1c1XO"),
    $3a7d9ec68b20844a$var$load("9Z7qK"),
    $3a7d9ec68b20844a$var$load("duPDN"),
    $3a7d9ec68b20844a$var$load("afXyT"),
    $3a7d9ec68b20844a$var$load("9AHrA"),
    $3a7d9ec68b20844a$var$load("f1NVy"),
    $3a7d9ec68b20844a$var$load("4Lgj0"),
    $3a7d9ec68b20844a$var$load("kSJiq"),
    $3a7d9ec68b20844a$var$load("6wr18"),
    $3a7d9ec68b20844a$var$load("89WyM"),
    $3a7d9ec68b20844a$var$load("1QdXB"),
    $3a7d9ec68b20844a$var$load("cPWI2"),
    $3a7d9ec68b20844a$var$load("h9Ed7"),
    $3a7d9ec68b20844a$var$load("lkOIY"),
    $3a7d9ec68b20844a$var$load("eHDb1"),
    $3a7d9ec68b20844a$var$load("2zUEf"),
    $3a7d9ec68b20844a$var$load("7EorR"),
    $3a7d9ec68b20844a$var$load("ffEVr"),
    $3a7d9ec68b20844a$var$load("8Gekp"),
    $3a7d9ec68b20844a$var$load("89Sbl"),
    $3a7d9ec68b20844a$var$load("5QKVr"),
    $3a7d9ec68b20844a$var$load("bxFZs"),
    $3a7d9ec68b20844a$var$load("1PFZq")
]).then(()=>parcelRequire('31yzi'));

});

parcelRegister("aXika", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $fGzMp = parcelRequire("fGzMp");


var $aJPUt = parcelRequire("aJPUt");


var $ep3mz = parcelRequire("ep3mz");


var $4zbo1 = parcelRequire("4zbo1");


var $lpxTx = parcelRequire("lpxTx");

var $61vTv = parcelRequire("61vTv");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $9Q3jD = parcelRequire("9Q3jD");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $1NBp8 = parcelRequire("1NBp8");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $isEtk = parcelRequire("isEtk");


var $c0urc = parcelRequire("c0urc");

var $1SNEF = parcelRequire("1SNEF");


var $bQm3c = parcelRequire("bQm3c");


var $b8XTE = parcelRequire("b8XTE");


var $7d2Nc = parcelRequire("7d2Nc");


var $essql = parcelRequire("essql");


var $8i27m = parcelRequire("8i27m");


var $gsWjA = parcelRequire("gsWjA");


var $2aFNh = parcelRequire("2aFNh");

const $50e9068f0df1c4d8$var$pageMap = {
    SPACE_OVERVIEW: {
        route: (0, $1NBp8.SPACE_OVERVIEW),
        errorAttribution: 'next-space-overview',
        name: (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE),
        isContentView: false
    },
    COMPANY_HUB: {
        route: (0, $1NBp8.COMPANY_HUB),
        errorAttribution: 'next-company-hub',
        name: (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE),
        isContentView: false
    },
    page: {
        route: (0, $1NBp8.VIEW_PAGE),
        errorAttribution: 'next-view-page',
        name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
        isContentView: true
    }
};
const $50e9068f0df1c4d8$export$2fe638b9bbc723fb = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, spaceKey: spaceKey, children: children, stickyHeader: stickyHeader, contentScreenStyles: contentScreenStyles, isContainerContentView: isContainerContentView = true, versionOverride: versionOverride = null, customPerfData: customPerfData })=>{
    const { setCurrentDocumentVersion: setCurrentDocumentVersion, setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const [{ routeName: routeName = '', contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean((0, window.__SSR_RENDERED__));
    const [{ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: commentsDataMap }, { addNewCommentThreads: addNewCommentThreads }] = (0, $8i27m.useCommentsData)();
    (0, $essql.useUnreadCommentsSetup)({
        pageId: contentId,
        pageContentTypeProps: {
            pageMode: 'view',
            orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
            commentsDataMap: commentsDataMap,
            addNewCommentThreads: addNewCommentThreads
        }
    });
    const extractDataAndSetPublishedVersion = (0, $42omo.useCallback)(({ refetchContentQueryResult: refetchContentQueryResult })=>{
        const { data: data } = refetchContentQueryResult;
        if (data) {
            const versionNumber = data.content?.nodes?.[0]?.version?.number;
            if (versionNumber !== undefined && versionNumber !== null) setPublishedDocumentVersion(versionNumber);
        }
    }, [
        setPublishedDocumentVersion
    ]);
    const chooseContentUnifiedQuery = contentType === 'blogpost' ? (0, $lpxTx.ContentBlogUnifiedQuery) : (0, $61vTv.ContentUnifiedQuery);
    const contentQueryResult = (0, $j1Ss3.useQuery)(chooseContentUnifiedQuery, {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        skip: !contentId || !spaceKey,
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: versionOverride,
            useNewContentTopper: true
        }
    });
    const { route: route, errorAttribution: errorAttribution, name: name, isContentView: isContentView } = $50e9068f0df1c4d8$var$pageMap[routeName] ?? $50e9068f0df1c4d8$var$pageMap['page'];
    const { refetch: refetch } = contentQueryResult;
    (0, $2aFNh.useContentExtensionMetrics)(contentQueryResult?.data?.content?.nodes?.[0]?.body?.dynamic?.value, customPerfData);
    (0, $42omo.useEffect)(()=>{
        // If navigating to a different page, always assume document is up to date.
        // Added for COMMENTS-5327, so when user jumps from an outdated page to another
        // up-to-date page, we won't disable the comment button due to outdated-ness.
        // Caveat: The destination page may not actually be up-to-date, e.g. if the
        // page content was loaded from cache that's saved from the user's previous
        // visit in the same browser tab, and a new version was published since then.
        // Invoking `setDocumentNeedsUpdate(false)` here means `documentNeedsUpdate`
        // may be `false` when page is actually outdated, but this scenario can already
        // occur before this change. COMMENTS-5816 tracks fixing this scenario altogether.
        if ((0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated', 'isEnabled', true)) {
            if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) // With confluence_fe_disable_comment_if_page_outdated_v2 ON,
            // `documentNeedsUpdate` is set to true whenever we set a new
            // `publishedDocumentVersion` IF it's different from `currentDocumentVersion`.
            // This useEffect can be cleaned up after v2 is fully rolled out.
            setDocumentNeedsUpdate(false);
        }
    }, [
        contentId,
        setDocumentNeedsUpdate
    ]);
    // Use this instead of `contentQueryResult.data?.content?.nodes?.[0]?.version?.number`
    // because that field is fetched by other queries too, and thus may become mismatched
    // with the actual version of `body` in GQL cache.
    const contentVersion = contentQueryResult.data?.content?.nodes?.[0]?.body?.dynamic?.content?.version?.number;
    (0, $42omo.useEffect)(()=>{
        if (contentVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) setCurrentDocumentVersion(contentVersion);
    }, [
        contentVersion,
        setCurrentDocumentVersion
    ]);
    const reload = (0, $42omo.useCallback)(async ()=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD,
            attributes: {
                contentType: (0, $8Ss4E.routeNameToContentTypeMap)[routeName],
                contentId: contentId,
                isSpaceOverviewNextRendered: true,
                edition: edition,
                quickReload: true //tell exp metrics error came from reload and not primary experience
            }
        });
        try {
            const refetchContentQueryResult = await refetch({
                contentId: contentId,
                timestamp: Date.now()
            });
            extractDataAndSetPublishedVersion({
                refetchContentQueryResult: refetchContentQueryResult
            });
        } catch (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                (0, $fGzMp.getExperienceTracker)().abort({
                    name: name,
                    reason: 'Expected Apollo error'
                });
                return; //if it's an expected GQL failure don't throw or fail the experience
            }
            (0, $fGzMp.stopExperienceOnError)(name, error);
            throw error; //this successfully avoids the success below
        }
        (0, $fGzMp.getExperienceTracker)().succeed({
            name: name
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        refetch,
        contentId
    ]);
    (0, $1SNEF.useQuickReloadSubscriber)({
        name: 'content',
        types: [
            (0, $c0urc.ReloadType).content,
            (0, $c0urc.ReloadType).comment
        ],
        reload: reload
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        key: contentId,
        metric: (0, $gsWjA.VIEW_PAGE_CONTAINER_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
        contentId: contentId,
        mode: (0, $5kjCz.RENDERER),
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Q3jD.PagePrerequisites), {
        route: route,
        contentQueryResult: contentQueryResult,
        versionOverride: versionOverride
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $isEtk.ContentStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4zbo1.ContentContainer), {
        fetchTheme: true,
        contentId: contentId,
        spaceKey: spaceKey,
        key: "content-screen",
        errorAttribution: errorAttribution,
        isScreenContentView: isContentView,
        isContainerContentView: isContainerContentView,
        contentScreenStyles: contentScreenStyles,
        stickyHeader: stickyHeader,
        versionOverride: versionOverride
    }, ({ isThemed: isThemed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children && children({
            isThemed: isThemed,
            contentQueryData: contentQueryResult.data,
            contentQueryError: contentQueryResult.error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $gsWjA.VIEW_PAGE_CONTAINER_METRIC),
            customData: {
                isThemed: isThemed
            }
        }))))));
});
module.exports["ViewPageContainer"] = $50e9068f0df1c4d8$export$2fe638b9bbc723fb;

});

parcelRegister("4zbo1", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $lpxTx = parcelRequire("lpxTx");

var $61vTv = parcelRequire("61vTv");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $ep3mz = parcelRequire("ep3mz");


var $3jwuS = parcelRequire("3jwuS");

parcelRequire("7R5is");
var $bGq6O = parcelRequire("bGq6O");
var $3FKxL = parcelRequire("3FKxL");


var $bEdUx = parcelRequire("bEdUx");


var $aWwYt = parcelRequire("aWwYt");


var $6KaG6 = parcelRequire("6KaG6");


var $5Myco = parcelRequire("5Myco");


var $9wGTI = parcelRequire("9wGTI");


var $fT4aa = parcelRequire("fT4aa");


var $3YWj2 = parcelRequire("3YWj2");


var $9Gxdl = parcelRequire("9Gxdl");

const $699adfe23402337d$var$EMPTY_CONTENT_SCREEN_STYLES = {};
const $699adfe23402337d$var$EMPTY_LOOK_AND_FEEL = {};
const $699adfe23402337d$var$contentWrapperStyles = null;
const $699adfe23402337d$export$9d2b4227a95687cc = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(52);
    const { contentId: contentId, fetchTheme: t1, children: children, isScreenContentView: t2, isContainerContentView: t3, spaceKey: spaceKey, errorAttribution: t4, contentScreenStyles: t5, stickyHeader: t6, versionOverride: t7 } = t0;
    const fetchTheme = t1 === undefined ? false : t1;
    const isScreenContentView = t2 === undefined ? false : t2;
    const isContainerContentView = t3 === undefined ? false : t3;
    const errorAttribution = t4 === undefined ? (0, $3IBnw.Attribution).BACKBONE : t4;
    const contentScreenStyles = t5 === undefined ? $699adfe23402337d$var$EMPTY_CONTENT_SCREEN_STYLES : t5;
    const stickyHeader = t6 === undefined ? null : t6;
    const versionOverride = t7 === undefined ? null : t7;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const behavior = (0, $aWwYt.useBehavior)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [t8] = (0, $bGq6O.useViewPageDistinctionBannerStore)();
    const { isViewPageBannerVisible: isViewPageBannerVisible } = t8;
    const isRovoButtonEnabled = (0, $fT4aa.useAIRovoButtonEnablement)();
    let t9;
    if ($[0] !== hideObjectSidebar) {
        t9 = ()=>{
            hideObjectSidebar();
        };
        $[0] = hideObjectSidebar;
        $[1] = t9;
    } else t9 = $[1];
    let t10;
    if ($[2] !== contentId || $[3] !== hideObjectSidebar) {
        t10 = [
            contentId,
            hideObjectSidebar
        ];
        $[2] = contentId;
        $[3] = hideObjectSidebar;
        $[4] = t10;
    } else t10 = $[4];
    (0, $42omo.useEffect)(t9, t10);
    const chooseContentUnifiedQuery = contentType === "blogpost" ? (0, $lpxTx.ContentBlogUnifiedQuery) : (0, $61vTv.ContentUnifiedQuery);
    let t11;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = {
            single: true
        };
        $[5] = t11;
    } else t11 = $[5];
    const t12 = !fetchTheme || !contentId;
    let t13;
    if ($[6] !== contentId || $[7] !== spaceKey || $[8] !== versionOverride) {
        t13 = {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: versionOverride,
            useNewContentTopper: true
        };
        $[6] = contentId;
        $[7] = spaceKey;
        $[8] = versionOverride;
        $[9] = t13;
    } else t13 = $[9];
    let t14;
    if ($[10] !== t12 || $[11] !== t13) {
        t14 = {
            context: t11,
            skip: t12,
            variables: t13
        };
        $[10] = t12;
        $[11] = t13;
        $[12] = t14;
    } else t14 = $[12];
    const queryResult = (0, $j1Ss3.useQuery)(chooseContentUnifiedQuery, t14);
    if (queryResult.error) {
        const t15 = children;
        let t16;
        if ($[13] !== queryResult.error) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: queryResult.error
            });
            $[13] = queryResult.error;
            $[14] = t16;
        } else t16 = $[14];
        let t17;
        if ($[15] !== errorAttribution || $[16] !== t15 || $[17] !== t16) {
            t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: errorAttribution
            }, t15, t16);
            $[15] = errorAttribution;
            $[16] = t15;
            $[17] = t16;
            $[18] = t17;
        } else t17 = $[18];
        return t17;
    } else {
        const theme = Boolean(queryResult?.data?.space?.theme);
        const lookAndFeel = queryResult?.data?.space?.lookAndFeel || $699adfe23402337d$var$EMPTY_LOOK_AND_FEEL;
        let t15;
        if ($[19] !== children || $[20] !== queryResult.loading || $[21] !== theme) {
            t15 = typeof children === "function" ? children({
                isThemed: theme,
                isLoading: queryResult.loading
            }) : children;
            $[19] = children;
            $[20] = queryResult.loading;
            $[21] = theme;
            $[22] = t15;
        } else t15 = $[22];
        const childrenToRender = t15;
        const t16 = queryResult.loading;
        const t17 = !theme && stickyHeader ? stickyHeader : null;
        const t18 = queryResult.loading;
        let t19;
        if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
            t19 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
            $[23] = t19;
        } else t19 = $[23];
        const t20 = isViewPageBannerVisible ? (0, $3FKxL.BANNER_HEIGHT) : 0;
        let t21;
        if ($[24] !== behavior || $[25] !== childrenToRender || $[26] !== isObjectSidebarShown || $[27] !== isRovoButtonEnabled || $[28] !== pageMode) {
            t21 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") || isRovoButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    "_16jlcs5v _1o9zkb7n _i0dlf1ug _1e0c1ule _1bsb1osq"
                ])
            }, childrenToRender), isObjectSidebarShown && pageMode === (0, $cD1qu.PageMode).VIEW && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, behavior === "push" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Myco.ObjectSidebarPushPlaceholder), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6KaG6.ObjectSidebarPanel), null))) : childrenToRender;
            $[24] = behavior;
            $[25] = childrenToRender;
            $[26] = isObjectSidebarShown;
            $[27] = isRovoButtonEnabled;
            $[28] = pageMode;
            $[29] = t21;
        } else t21 = $[29];
        let t22;
        if ($[30] !== isContainerContentView || $[31] !== isLivePage || $[32] !== lookAndFeel || $[33] !== queryResult.loading || $[34] !== t20 || $[35] !== t21 || $[36] !== theme) {
            t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Gxdl.ContentContainerComponent), {
                isThemed: theme,
                lookAndFeel: lookAndFeel,
                isContentView: isContainerContentView,
                isLoading: t18,
                isLivePage: isLivePage,
                isObjectSidebarEnabled: t19,
                additionalPaddingTop: t20
            }, t21);
            $[30] = isContainerContentView;
            $[31] = isLivePage;
            $[32] = lookAndFeel;
            $[33] = queryResult.loading;
            $[34] = t20;
            $[35] = t21;
            $[36] = theme;
            $[37] = t22;
        } else t22 = $[37];
        let t23;
        if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
            t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bEdUx.HighlightActionsProviderForNav4), null);
            $[38] = t23;
        } else t23 = $[38];
        let t24;
        if ($[39] !== contentScreenStyles || $[40] !== isLivePage || $[41] !== isScreenContentView || $[42] !== lookAndFeel || $[43] !== queryResult.loading || $[44] !== spaceKey || $[45] !== t17 || $[46] !== t22 || $[47] !== theme) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3YWj2.ContentScreenComponent), {
                spaceKey: spaceKey,
                isThemed: theme,
                isLoading: t16,
                lookAndFeel: lookAndFeel,
                isContentView: isScreenContentView,
                contentScreenStyles: contentScreenStyles,
                isLivePage: isLivePage
            }, t17, t22, t23);
            $[39] = contentScreenStyles;
            $[40] = isLivePage;
            $[41] = isScreenContentView;
            $[42] = lookAndFeel;
            $[43] = queryResult.loading;
            $[44] = spaceKey;
            $[45] = t17;
            $[46] = t22;
            $[47] = theme;
            $[48] = t24;
        } else t24 = $[48];
        let t25;
        if ($[49] !== errorAttribution || $[50] !== t24) {
            t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: errorAttribution
            }, t24);
            $[49] = errorAttribution;
            $[50] = t24;
            $[51] = t25;
        } else t25 = $[51];
        return t25;
    }
} : ({ contentId: contentId, fetchTheme: fetchTheme = false, children: children, isScreenContentView: isScreenContentView = false, isContainerContentView: isContainerContentView = false, spaceKey: spaceKey, errorAttribution: errorAttribution = (0, $3IBnw.Attribution).BACKBONE, contentScreenStyles: contentScreenStyles = $699adfe23402337d$var$EMPTY_CONTENT_SCREEN_STYLES, stickyHeader: stickyHeader = null, versionOverride: versionOverride = null })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const behavior = (0, $aWwYt.useBehavior)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [{ isViewPageBannerVisible: isViewPageBannerVisible }] = (0, $bGq6O.useViewPageDistinctionBannerStore)();
    const isRovoButtonEnabled = (0, $fT4aa.useAIRovoButtonEnablement)(); // Close the object sidebar when navigating to a new page
    (0, $42omo.useEffect)(()=>{
        hideObjectSidebar();
    }, [
        contentId,
        hideObjectSidebar
    ]);
    const chooseContentUnifiedQuery = contentType === 'blogpost' ? (0, $lpxTx.ContentBlogUnifiedQuery) : (0, $61vTv.ContentUnifiedQuery); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const queryResult = (0, $j1Ss3.useQuery)(chooseContentUnifiedQuery, {
        context: {
            single: true
        },
        skip: !fetchTheme || !contentId,
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: versionOverride,
            useNewContentTopper: true
        }
    });
    if (queryResult.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: errorAttribution
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryResult.error
    }));
    else {
        const theme = Boolean(queryResult?.data?.space?.theme);
        const lookAndFeel = queryResult?.data?.space?.lookAndFeel || $699adfe23402337d$var$EMPTY_LOOK_AND_FEEL;
        const childrenToRender = typeof children === 'function' ? children({
            isThemed: theme,
            isLoading: queryResult.loading
        }) : children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: errorAttribution
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3YWj2.ContentScreenComponent), {
            spaceKey: spaceKey,
            isThemed: theme,
            isLoading: queryResult.loading,
            lookAndFeel: lookAndFeel,
            isContentView: isScreenContentView,
            contentScreenStyles: contentScreenStyles,
            isLivePage: isLivePage
        }, !theme && stickyHeader ? stickyHeader : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Gxdl.ContentContainerComponent), {
            isThemed: theme,
            lookAndFeel: lookAndFeel,
            isContentView: isContainerContentView,
            isLoading: queryResult.loading,
            isLivePage: isLivePage,
            isObjectSidebarEnabled: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
            additionalPaddingTop: isViewPageBannerVisible ? (0, $3FKxL.BANNER_HEIGHT) : 0
        }, (0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isRovoButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_16jlcs5v _1o9zkb7n _i0dlf1ug _1e0c1ule _1bsb1osq"
            ])
        }, childrenToRender), isObjectSidebarShown && pageMode === (0, $cD1qu.PageMode).VIEW && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, behavior === 'push' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Myco.ObjectSidebarPushPlaceholder), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6KaG6.ObjectSidebarPanel), null))) : childrenToRender), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bEdUx.HighlightActionsProviderForNav4), null)));
    }
};
module.exports["ContentContainer"] = $699adfe23402337d$export$9d2b4227a95687cc;

});

parcelRegister("7R5is", function(module, exports) {
$parcel$export(module.exports, "useViewPageDistinctionBannerStore", () => (parcelRequire("bGq6O")).useViewPageDistinctionBannerStore);
$parcel$export(module.exports, "VIEW_PAGE_DISTINCTION_BANNER_HEIGHT", () => (parcelRequire("3FKxL")).BANNER_HEIGHT);

var $jmjWc = parcelRequire("jmjWc");


var $bGq6O = parcelRequire("bGq6O");


var $3FKxL = parcelRequire("3FKxL");


const $b607cb0728e6d003$export$d1792f644c5fb9c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kmBft",
    name: "ViewPageDistinctionBanner",
    loader: async ()=>(await (parcelRequire("aoeqD"))).ViewPageDistinctionBanner
});

});

parcelRegister("aoeqD", function(module, exports) {

let $7907567cf177404b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7907567cf177404b$var$load("5tz7G"),
    $7907567cf177404b$var$load("eEyVs"),
    $7907567cf177404b$var$load("hhss7"),
    $7907567cf177404b$var$load("i8Yee")
]).then(()=>parcelRequire('de33F'));

});

parcelRegister("bGq6O", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $c43e4fc54e365866$var$initialState = {
    isViewPageBannerVisible: false
};
const $c43e4fc54e365866$export$e324594224ef24da = {
    setViewPageBannerVisibility: (visibility)=>({ setState: setState })=>{
            setState({
                isViewPageBannerVisible: visibility
            });
        }
};
const $c43e4fc54e365866$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $c43e4fc54e365866$var$initialState,
    actions: $c43e4fc54e365866$export$e324594224ef24da,
    name: 'viewPageDistinctionBannerStore'
});
const $c43e4fc54e365866$export$d1266bf09e522b8e = (0, $9zUhf.createHook)($c43e4fc54e365866$export$390f32400eaf98c9);
const $c43e4fc54e365866$export$ec037367829e76f = (0, $9zUhf.createActionsHook)($c43e4fc54e365866$export$390f32400eaf98c9);
module.exports["useViewPageDistinctionBannerStore"] = $c43e4fc54e365866$export$d1266bf09e522b8e;
module.exports["useViewPageDistinctionBannerActions"] = $c43e4fc54e365866$export$ec037367829e76f;

});

parcelRegister("3FKxL", function(module, exports) {
const $b94c6baa776144a8$export$ed7cc0d417ee89e = 33;
module.exports["BANNER_HEIGHT"] = $b94c6baa776144a8$export$ed7cc0d417ee89e;

});

parcelRegister("5Myco", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $aWwYt = parcelRequire("aWwYt");


var $gV0XG = parcelRequire("gV0XG");

// the min-width should match the value of MIN_PANEL_WIDTH from '@confluence/object-sidebar-api/entry-points/useObjectSidebar'
const $5a9e6187ae9c8f81$var$panelPushStyles = (0, $ecnYn.xcss)({
    display: 'block',
    minWidth: '400px'
});
const $5a9e6187ae9c8f81$export$6bf626a2ed01dddd = ()=>{
    const { setPanelWidth: setPanelWidth } = (0, $aWwYt.useObjectSidebarActions)();
    const [containerRef, width] = (0, $gV0XG.useWidthResizeObserver)();
    (0, $42omo.useEffect)(()=>{
        setPanelWidth(width);
    }, [
        width,
        setPanelWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        ref: containerRef,
        xcss: $5a9e6187ae9c8f81$var$panelPushStyles,
        testId: "object-sidebar-push-placeholder"
    });
};
module.exports["ObjectSidebarPushPlaceholder"] = $5a9e6187ae9c8f81$export$6bf626a2ed01dddd;

});

parcelRegister("gV0XG", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $e8f0e07425900c28$export$38848a0b2363b578 = ()=>{
    const [width, setWidth] = (0, $42omo.useState)(0);
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const observeTarget = ref.current;
        const resizeObserver = new ResizeObserver((entries)=>{
            entries.forEach((entry)=>{
                setWidth(entry.contentRect.width);
            });
        });
        if (observeTarget) {
            resizeObserver.observe(observeTarget);
            return ()=>{
                resizeObserver.unobserve(observeTarget);
            };
        } else setWidth(0);
    }, []);
    return [
        ref,
        width
    ];
};
module.exports["useWidthResizeObserver"] = $e8f0e07425900c28$export$38848a0b2363b578;

});

parcelRegister("3YWj2", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $T1bCI = parcelRequire("T1bCI");


var $hrAmX = parcelRequire("hrAmX");


var $3Klda = parcelRequire("3Klda");

const $7517944cc70514f3$export$af5427d1c079635b = {
    position: 'relative',
    background: "var(--ds-surface, #FFFFFF)",
    paddingTop: '0',
    paddingRight: "var(--ds-space-500, 40px)",
    paddingBottom: "var(--ds-space-250, 20px)",
    paddingLeft: "var(--ds-space-500, 40px)",
    minHeight: 'calc(100vh - 56px)',
    boxSizing: 'border-box',
    // added in for cover image
    '--full-cover-image-margin': '-40px',
    // should be the negative value of the padding of the container
    '--full-cover-image-width': 'calc(100% + 80px)' // should do calculations based on the padding of the container
};
const $7517944cc70514f3$export$ae92da2802c530ea = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: '0',
    display: 'none',
    bottom: '0',
    left: '0',
    right: '0',
    zIndex: '10',
    background: "var(--ds-skeleton, #0515240F)"
};
const $7517944cc70514f3$var$LIVE_PAGES_SCREEN_STYLES = {
    paddingTop: '0px',
    paddingRight: '0px',
    paddingBottom: '0px',
    paddingLeft: '0px',
    minHeight: 'unset',
    // added in for cover image
    '--full-cover-image-margin': '0px',
    // should be the negative value of the padding of the container
    '--full-cover-image-width': '100%' // should do calculations based on the padding of the container
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7517944cc70514f3$var$OverflowHiddenDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $7517944cc70514f3$var$PositionRelativeDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $7517944cc70514f3$var$DEFAULT_LOOK_AND_FEEL = {
    content: {
        screen: $7517944cc70514f3$export$af5427d1c079635b
    }
};
const $7517944cc70514f3$var$EMPTY_CONTENT_SCREEN_STYLES = {};
function $7517944cc70514f3$var$convertGutters(customScreenStyles) {
    if (customScreenStyles.gutterLeft === 'none') customScreenStyles.paddingLeft = '0';
    if (customScreenStyles.gutterRight === 'none') customScreenStyles.paddingRight = '0';
    if (customScreenStyles.gutterTop === '0px') customScreenStyles.paddingTop = '0';
    if (customScreenStyles.gutterBottom === '0px') customScreenStyles.paddingBottom = '0';
    return customScreenStyles;
}
function $7517944cc70514f3$var$getStylesFromLookAndFeel(lookAndFeel) {
    if (!lookAndFeel || !lookAndFeel.content) return {};
    const screenLookAndFeel = $7517944cc70514f3$var$convertGutters({
        ...lookAndFeel.content.screen
    });
    delete screenLookAndFeel.layer;
    return screenLookAndFeel;
}
function $7517944cc70514f3$var$adjustMinHeight(styles, bannerHeight) {
    // Update the minHeight style only if a banner is being shown and the minHeight is "100vh" (aka full height)
    const updatedStyles = {
        ...styles
    };
    if (updatedStyles.minHeight === '100vh' && bannerHeight > 0) updatedStyles.minHeight = `calc(${updatedStyles.minHeight} - ${bannerHeight}px)`;
    return updatedStyles;
}
const $7517944cc70514f3$export$b578f5d8b8749ec2 = ({ spaceKey: spaceKey, children: children, lookAndFeel: lookAndFeel = $7517944cc70514f3$var$DEFAULT_LOOK_AND_FEEL, contentScreenStyles: // This prop contains react-css values to customize the default content screen styles according to the consumer's need.
contentScreenStyles = $7517944cc70514f3$var$EMPTY_CONTENT_SCREEN_STYLES, isThemed: isThemed = false, isContentView: isContentView = false, isLoading: isLoading = false, isLivePage: isLivePage = false })=>{
    const previousStyleState = (0, $42omo.useRef)(null);
    const shouldApplyTheme = isThemed || isContentView;
    let styles;
    // 99.9% of time we should have lookAndFeel preloaded on SSR
    if (isLoading) {
        const previous = previousStyleState.current;
        // In transition since style in the same space should be the same
        // We can optimistically use the same style as the previous one
        if (spaceKey && spaceKey === previous?.spaceKey) styles = previous?.getStyles(isLivePage) || $7517944cc70514f3$export$ae92da2802c530ea;
        else styles = $7517944cc70514f3$export$ae92da2802c530ea;
    } else {
        const getStyles = shouldApplyTheme ? (live)=>({
                ...$7517944cc70514f3$export$af5427d1c079635b,
                ...live ? $7517944cc70514f3$var$LIVE_PAGES_SCREEN_STYLES : {},
                ...contentScreenStyles,
                ...$7517944cc70514f3$var$getStylesFromLookAndFeel(lookAndFeel)
            }) : ()=>({});
        previousStyleState.current = {
            getStyles: getStyles,
            spaceKey: spaceKey
        };
        styles = getStyles(isLivePage);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>{
        const bannerHeight = bannerState.getTotalHeight();
        const updatedStyles = $7517944cc70514f3$var$adjustMinHeight(styles, bannerHeight);
        // styles came from a GraphQL result which will contain __typename
        delete updatedStyles.__typename;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "content-screen-component" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            ,
            className: "content-screen-component" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ,
            style: updatedStyles
        }, shouldApplyTheme ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Klda.ContentScreenBackgroundLayer), {
            lookAndFeel: lookAndFeel
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7517944cc70514f3$var$PositionRelativeDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7517944cc70514f3$var$OverflowHiddenDiv, null), children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children));
    });
};
module.exports["ContentScreenComponent"] = $7517944cc70514f3$export$b578f5d8b8749ec2;

});

parcelRegister("9Gxdl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $1iSzD = parcelRequire("1iSzD");


var $lJlG6 = parcelRequire("lJlG6");


var $9wGTI = parcelRequire("9wGTI");

// Both default styles are needed to properly apply `background-color` in resulting DOM when merged with look-and-feel
const $70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES = {
    background: "var(--ds-surface, #FFFFFF)",
    backgroundColor: "var(--ds-surface, #FFFFFF)"
};
const $70d1ccf7a353c4c2$var$LOADING_SCREEN_STYLES = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: '0',
    display: 'none',
    bottom: '0',
    left: '0',
    right: '0',
    zIndex: '10',
    background: "var(--ds-skeleton, #0515240F)"
};
const $70d1ccf7a353c4c2$var$_convertVerticalGutterSize = (gutterValue)=>{
    switch(gutterValue){
        case 'small':
        case 'medium':
        case 'large':
        case 'default':
            return null;
        default:
            return gutterValue;
    }
};
const $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize = (gutterValue)=>{
    switch(gutterValue){
        case 'small':
            return 5;
        case 'medium':
            return 10;
        case 'large':
            return 15;
        case 'default':
            return null;
        case 'none':
        default:
            return 0;
    }
};
class $70d1ccf7a353c4c2$export$b5a05341299897cc extends (0, $42omo.Component) {
    static _getContainerStyles(lookAndFeel, isThemed, isLivePage, additionalPaddingTop, isObjectSidebarEnabled) {
        if (!lookAndFeel.content) return $70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES;
        const { screen: screen, container: container } = lookAndFeel.content;
        const containerStyles = {
            ...$70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES,
            ...container
        };
        const { padding: padding } = containerStyles;
        let paddingTop = additionalPaddingTop || 0;
        // if page header is fixed, content will need to be pushed down so that the title of the page isn't covered (unless rendered via embedded-confluence)
        // themed spaces do not have fixed headers and do not need the styling
        if (!isThemed && !isLivePage && !(0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() && !(0, $lJlG6.isMobileApp_DO_NOT_USE)()) {
            if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) // if confluence_frontend_content_wrapper is on, add 46px padding since the object header height is 56px and with-sticky-header div above it has 10px height already
            paddingTop += 46;
            else // add 60px padding since regular page header height is 60px.
            paddingTop += 60;
        }
        containerStyles.padding = `${paddingTop}px 0px 0px 0px`;
        if (isThemed && padding === '0') // if the theme doesn't have a padding, we should add a padding because otherwise comments overflow the container
        // see also: https://product-fabric.atlassian.net/wiki/spaces/~speachey/pages/3093430887/DEVHELP-6933
        containerStyles.padding = '20px';
        const { gutterTop: gutterTop, gutterBottom: gutterBottom } = screen;
        if (gutterTop) containerStyles.marginTop = $70d1ccf7a353c4c2$var$_convertVerticalGutterSize(screen.gutterTop);
        if (gutterBottom) containerStyles.marginBottom = $70d1ccf7a353c4c2$var$_convertVerticalGutterSize(screen.gutterBottom);
        const gutterRight = $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize(screen.gutterRight);
        const gutterLeft = $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize(screen.gutterLeft);
        if (gutterRight !== null) containerStyles.marginRight = `${gutterRight}%`;
        if (gutterLeft !== null) containerStyles.marginLeft = `${gutterLeft}%`;
        containerStyles.width = `${100 - gutterRight - gutterLeft}%`;
        containerStyles.boxSizing = 'border-box';
        if (isObjectSidebarEnabled) {
            containerStyles.display = 'flex';
            containerStyles.flexDirection = 'row';
        }
        // container is from graphql result which will contain __typename
        delete containerStyles.__typename;
        return containerStyles;
    }
    static _getInlineCommentStyles(lookAndFeel) {
        if (!lookAndFeel.content) return null;
        const { screen: screen = {} } = lookAndFeel.content;
        const gutterRight = $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize(screen.gutterRight);
        if (gutterRight === 0) /**
       * When we have no gutterRight, we need to override the default ic-sidebar marging-right of -20px and make it 0
       *  so that it does not pull too far right.
       */ return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", null, '.ic-sidebar.ic-is-spa-view-page { margin-right: 0 !important; }'));
        return null;
    }
    getLoadingStyles() {
        const { isLoading: isLoading } = this.props;
        return isLoading ? $70d1ccf7a353c4c2$var$LOADING_SCREEN_STYLES : {};
    }
    render() {
        const { lookAndFeel: lookAndFeel, isThemed: isThemed, isContentView: isContentView, isLivePage: isLivePage, isObjectSidebarEnabled: isObjectSidebarEnabled, additionalPaddingTop: additionalPaddingTop } = this.props;
        const shouldApplyTheme = isThemed || isContentView;
        const containerStyles = shouldApplyTheme ? $70d1ccf7a353c4c2$export$b5a05341299897cc._getContainerStyles(lookAndFeel, isThemed, isLivePage, additionalPaddingTop, isObjectSidebarEnabled) : this.getLoadingStyles();
        const inLineCommentStyles = shouldApplyTheme ? $70d1ccf7a353c4c2$export$b5a05341299897cc._getInlineCommentStyles(lookAndFeel) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "content-container-component",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.props.className,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: containerStyles
        }, inLineCommentStyles, this.props.children);
    }
}
$70d1ccf7a353c4c2$export$b5a05341299897cc.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).any,
    lookAndFeel: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    isThemed: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
   * In view page we apply default style regardless whether theme was enabled or not
   */ isContentView: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isLivePage: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isObjectSidebarEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    additionalPaddingTop: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number
};
$70d1ccf7a353c4c2$export$b5a05341299897cc.defaultProps = {
    isContentView: false,
    lookAndFeel: {
        content: {
            screen: $70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES
        }
    },
    isLivePage: false,
    isObjectSidebarEnabled: false
};
module.exports["ContentContainerComponent"] = $70d1ccf7a353c4c2$export$b5a05341299897cc;

});

parcelRegister("gsWjA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $4icDV = parcelRequire("4icDV");

var $70LTe = parcelRequire("70LTe");


var $gzdsP = parcelRequire("gzdsP");


var $bQm3c = parcelRequire("bQm3c");


var $iFjdQ = parcelRequire("iFjdQ");


var $lSOAM = parcelRequire("lSOAM");

var $i3c1S = parcelRequire("i3c1S");


var $jX1qB = parcelRequire("jX1qB");

var $5q601 = parcelRequire("5q601");

var $1UCmC = parcelRequire("1UCmC");


var $lXYVJ = parcelRequire("lXYVJ");


var $6VdZc = parcelRequire("6VdZc");

var $7fw2E = parcelRequire("7fw2E");


var $7sK8i = parcelRequire("7sK8i");


var $8w1c1 = parcelRequire("8w1c1");

parcelRequire("1InRL");
var $hlP5l = parcelRequire("hlP5l");


var $5qUgM = parcelRequire("5qUgM");


var $7d41Y = parcelRequire("7d41Y");


var $1q7H7 = parcelRequire("1q7H7");


var $aWrnw = parcelRequire("aWrnw");


var $dpv0X = parcelRequire("dpv0X");


var $5YLPl = parcelRequire("5YLPl");


var $9SsRl = parcelRequire("9SsRl");


var $fgdVB = parcelRequire("fgdVB");


var $itS9i = parcelRequire("itS9i");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $5vi32 = parcelRequire("5vi32");


var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");

const $a99ff50c139ee598$var$baseConfig = {
    slo: {
        // based on production p90
        fmp: {
            initial: {
                threshold: 14300
            },
            transition: {
                threshold: 3200
            }
        },
        tti: {
            initial: {
                threshold: 14300
            },
            transition: {
                threshold: 3200
            }
        }
    },
    histogram: {
        // based on pre-production pollinator and prod p90
        initial: {
            fmp: '5000_6000_7000_8000_10000_12000_14000',
            tti: '5000_6000_7000_8000_10000_12000_14000'
        },
        transition: {
            fmp: '2000_2500_3000_3500_4000_4500_5000',
            tti: '2000_2500_3000_3500_4000_4500_5000'
        }
    },
    timings: [
        // breakdowns in order of occurrence
        {
            key: 'html',
            endMark: 'html'
        },
        {
            key: 'fy21-legacy-fmp',
            endMark: 'fy21-legacy-fmp'
        },
        {
            key: 'appLoad',
            startMark: 'html',
            endMark: 'app'
        },
        {
            key: 'appRootRender',
            startMark: 'app',
            endMark: 'root-component-render'
        },
        {
            key: 'routerMatched',
            startMark: 'root-component-render',
            endMark: 'route-manager-initialized'
        },
        {
            key: 'onBeforeAkRenderer',
            endMark: 'onBeforeAkRenderer'
        },
        {
            key: 'fy21-legacy-tti',
            endMark: 'fy21-legacy-tti'
        },
        {
            key: 'fy23-legacy-tti',
            endMark: 'fy23-legacy-tti'
        }
    ]
};
const $a99ff50c139ee598$var$NOOP = ()=>{};
const $a99ff50c139ee598$export$2d5e2a82ee58820b = ({ isLite: isLite, isAnonymous: isAnonymous, isInitialLoad: isInitialLoad })=>{
    if (isLite) return [
        (0, $hlP5l.BYLINE_METRIC),
        (0, $hlP5l.CONTENT_TITLE_METRIC),
        (0, $5YLPl.CONTENT_RENDERER_METRIC)
    ];
    const segments = [
        // New metric adding to this list should also be added to fmpAsUntilStopTimeMetrics
        // See comments in fmpAsUntilStopTimeMetrics for more information
        (0, $hlP5l.BYLINE_METRIC),
        (0, $hlP5l.CONTENT_TITLE_METRIC),
        (0, $5YLPl.CONTENT_RENDERER_METRIC),
        $a99ff50c139ee598$export$e190581c76254e9
    ];
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) segments.push((0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC));
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) segments.push((0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC));
    if (isInitialLoad) {
        segments.push((0, $8w1c1.APP_NAVIGATION_METRIC), (0, $aWrnw.SPACE_NAVIGATION_METRIC));
        segments.push((0, $1q7H7.PAGE_TREE_METRIC));
    }
    if (!isAnonymous) // Note: the edit button metric is not currently tracked because there is no
    // guarantee that segment will fire even for authenticated users
    {
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) segments.push((0, $7d41Y.FAVOURITE_BUTTON_METRIC), (0, $9SsRl.WATCH_BUTTON_METRIC));
    }
    return segments;
};
/**
 * fmpAsUntilStopTimeMetrics
 *
 * UPDATE 2025-04-29: TTI is deprecated. Going forward, new segments should be included here by default in order to
 * preserve the original TTI definition. Segments should be included even if they are not minimally interactive.
 *
 * What is minimally interactive?
 * Minimally interactive during the SSR phase at it's core, is determined if the component/element is clickable,
 * can register the action, and display a visual response that the action has been received.
 * The SSR phase can be stalled by appending ?NO_SPA=1 at the end of a CONNIE url.
 *
 * I.E. If you click on an inline comment/highlight, the click is registered, and displays a loading sidebar component.
 *
 * If a required segment is SSR'd and determined to be minimally interactive at FMP, ADD TO THIS LIST
 * If a required segment is SSR'd but determined to NOT be minimally interactive at FMP, DO NOT ADD TO THIS LIST
 * If a required segment is yet to be SSR'd, this config will not update TTI for that segment, by default is OFF.
 *
 * CONTEXT
 * the returned segments are considered to be minimally interactive during SSR
 * hence we want to use FMP (ssr-ttr mark)
 *
 * PageSegment TTI is measured: useFmpAsUntilStopTime ? FMP : Eventual load time
 * Content-renderer TTI: macros are SSRed ? FMP : Eventual Load Time
 *
 * View Page TTI is measured: Math.max(Non SSR PageSegments TTI, Content-renderer TTI)
 *
 */ const $a99ff50c139ee598$var$fmpAsUntilStopTimeMetrics = ({ isLite: isLite })=>{
    if (isLite) return [
        (0, $jX1qB.BYLINE_SEGMENT_KEY),
        (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY)
    ];
    return [
        (0, $jX1qB.BYLINE_SEGMENT_KEY),
        (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY),
        (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
        (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.WATCH_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.VIEW_PAGE_CONTAINER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY)
    ];
};
const $a99ff50c139ee598$export$acf5746d268ae4ee = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { contentId: contentId, isLite: isLite, customConfig: customConfig } = t0;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const pageLoadMetricRef = (0, $42omo.useRef)();
    const sendMetrics = (0, $70LTe.useEmbeddedConfluenceEventMarkers)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== customConfig?.expectedPageLoadSegments || $[2] !== customConfig?.fmpUntilStopTimeMetrics || $[3] !== customConfig?.pageLoadKey || $[4] !== isEmbeddedConfluence || $[5] !== isLite || $[6] !== sendMetrics || $[7] !== userId) {
        t1 = ()=>{
            const _isInitialLoad = (0, $6VdZc.isInitial)();
            const expectedPageSegments = customConfig?.expectedPageLoadSegments ?? $a99ff50c139ee598$export$2d5e2a82ee58820b({
                isAnonymous: Boolean(!userId),
                isInitialLoad: _isInitialLoad,
                isLite: isLite
            });
            if (0, $itS9i.debuggerEnabled) (0, $itS9i.cacheExpectedViewPageSegments)(expectedPageSegments);
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.VIEW_EDIT_BUTTON_CLICKED_ACTION));
            const untilExperienceMetricNames = customConfig?.fmpUntilStopTimeMetrics ?? $a99ff50c139ee598$var$fmpAsUntilStopTimeMetrics({
                isLite: isLite
            });
            const untilPageSegments = expectedPageSegments.map((segment)=>({
                    experience: segment,
                    useFmpAsUntilStopTime: untilExperienceMetricNames.includes(segment.key)
                }));
            pageLoadMetricRef.current = (0, $lSOAM.createPageLoadMetric)({
                ...$a99ff50c139ee598$var$baseConfig,
                key: customConfig?.pageLoadKey ?? (0, $1UCmC.VIEW_PAGE_LOAD_KEY),
                timings: [
                    ...$a99ff50c139ee598$var$baseConfig.timings,
                    ...(0, $i3c1S.getWaterfallTimings)(expectedPageSegments)
                ],
                include: expectedPageSegments,
                until: untilPageSegments
            });
            if (!_isInitialLoad) expectedPageSegments.forEach($a99ff50c139ee598$var$_temp);
            pageLoadMetricRef.current.startPageLoad();
            pageLoadMetricRef.current.onStop((0, $7fw2E.markBrowserMetricEnd).bind(null, pageLoadMetricRef.current), $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop((0, $7sK8i.resumeLowPriorityEvents), (0, $7sK8i.resumeLowPriorityEvents));
            pageLoadMetricRef.current.onStop((0, $lXYVJ.resetViewTransitionSource), (0, $lXYVJ.resetViewTransitionSource));
            pageLoadMetricRef.current.onStop((data)=>{
                (0, $dpv0X.markLegacyFY23TTI)(pageLoadMetricRef.current, data);
            }, $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop(()=>{
                if (isEmbeddedConfluence) {
                    const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
                    const uniqueKey = observableObject?.object?.uniqueKey;
                    sendMetrics({
                        timestamp: Date.now(),
                        customData: {
                            ...uniqueKey && (0, $9wGTI.fg)("platform_deprecate_lp_cc_embed") ? {
                                uniqueKey: uniqueKey
                            } : {}
                        }
                    }, `${(0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $4icDV.EMBEDDED_VIEW_TTI)}`);
                }
            }, $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop(()=>{
                if (_isInitialLoad && Boolean(window.__HYDRATION_FAILED__)) {
                    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
                    if ((0, $6mKj3.expVal)("confluence_frontend_hydration_failure_reporting", "isEnabled", false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
                        source: "viewPageCommon",
                        route: route,
                        errorWithRoute: errorWithRoute,
                        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
                    })).fire();
                    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
                        attribution: "hydration"
                    });
                }
            }, $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop(()=>{
                if (_isInitialLoad && Boolean(window.__HYDRATION_FAILED__) && Boolean(window.__SSR_REACT_STREAMING__) && !(0, $6mKj3.expVal)("confluence_frontend_hydration_failure_reporting", "isEnabled", false)) {
                    const { error: errorWithRoute_0 } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
                    (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute_0, {
                        attribution: "streaming-hydration"
                    });
                }
            }, $a99ff50c139ee598$var$NOOP);
            return ()=>{
                pageLoadMetricRef.current?.cancel();
            };
        };
        $[0] = createAnalyticsEvent;
        $[1] = customConfig?.expectedPageLoadSegments;
        $[2] = customConfig?.fmpUntilStopTimeMetrics;
        $[3] = customConfig?.pageLoadKey;
        $[4] = isEmbeddedConfluence;
        $[5] = isLite;
        $[6] = sendMetrics;
        $[7] = userId;
        $[8] = t1;
    } else t1 = $[8];
    let t2;
    if ($[9] !== contentId || $[10] !== createAnalyticsEvent || $[11] !== customConfig || $[12] !== isEmbeddedConfluence || $[13] !== isLite || $[14] !== sendMetrics || $[15] !== userId) {
        t2 = [
            contentId,
            customConfig,
            userId,
            isLite,
            isEmbeddedConfluence,
            sendMetrics,
            createAnalyticsEvent
        ];
        $[9] = contentId;
        $[10] = createAnalyticsEvent;
        $[11] = customConfig;
        $[12] = isEmbeddedConfluence;
        $[13] = isLite;
        $[14] = sendMetrics;
        $[15] = userId;
        $[16] = t2;
    } else t2 = $[16];
    (0, $42omo.useEffect)(t1, t2);
    return null;
} : ({ contentId: contentId, isLite: isLite, customConfig: customConfig })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const pageLoadMetricRef = (0, $42omo.useRef)();
    const sendMetrics = (0, $70LTe.useEmbeddedConfluenceEventMarkers)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const _isInitialLoad = (0, $6VdZc.isInitial)();
        const expectedPageSegments = customConfig?.expectedPageLoadSegments ?? $a99ff50c139ee598$export$2d5e2a82ee58820b({
            isAnonymous: Boolean(!userId),
            isInitialLoad: _isInitialLoad,
            isLite: isLite
        });
        if (0, $itS9i.debuggerEnabled) (0, $itS9i.cacheExpectedViewPageSegments)(expectedPageSegments);
        // Marks a custom start time to track user clicks for temporary data gathering
        // Context: https://hello.atlassian.net/wiki/spaces/CCPERF/pages/1951426622
        (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.VIEW_EDIT_BUTTON_CLICKED_ACTION));
        const untilExperienceMetricNames = customConfig?.fmpUntilStopTimeMetrics ?? $a99ff50c139ee598$var$fmpAsUntilStopTimeMetrics({
            isLite: isLite
        });
        // Create a list of untilPageSegments
        // This wraps the segments into an UntilExperience, so that @atlassian/browser-metrics can handle useFmpAsUntilStopTime gracefully
        // Note - this only affect initial load since transitions are not SSR'd, hence page-segments do not have fmp marks
        // More information why useFmpAsUntilStopTime can be found here
        // https://hello.atlassian.net/wiki/spaces/~484600559/pages/1515596554/Toolings+Update+Browser-Metrics+FMP+TTI
        const untilPageSegments = expectedPageSegments.map((segment)=>({
                experience: segment,
                useFmpAsUntilStopTime: untilExperienceMetricNames.includes(segment.key)
            }));
        pageLoadMetricRef.current = (0, $lSOAM.createPageLoadMetric)({
            ...$a99ff50c139ee598$var$baseConfig,
            key: customConfig?.pageLoadKey ?? (0, $1UCmC.VIEW_PAGE_LOAD_KEY),
            timings: [
                ...$a99ff50c139ee598$var$baseConfig.timings,
                ...(0, $i3c1S.getWaterfallTimings)(expectedPageSegments)
            ],
            include: expectedPageSegments,
            until: untilPageSegments
        });
        if (!_isInitialLoad) // Make sure all segments are re-started and not currently marked as finished from a previous navigation
        expectedPageSegments.forEach((m)=>m.startFromPageLoad());
        pageLoadMetricRef.current.startPageLoad();
        pageLoadMetricRef.current.onStop((0, $7fw2E.markBrowserMetricEnd).bind(null, pageLoadMetricRef.current), $a99ff50c139ee598$var$NOOP);
        pageLoadMetricRef.current.onStop((0, $7sK8i.resumeLowPriorityEvents), (0, $7sK8i.resumeLowPriorityEvents));
        pageLoadMetricRef.current.onStop((0, $lXYVJ.resetViewTransitionSource), (0, $lXYVJ.resetViewTransitionSource));
        pageLoadMetricRef.current.onStop((data)=>{
            (0, $dpv0X.markLegacyFY23TTI)(pageLoadMetricRef.current, data);
        }, $a99ff50c139ee598$var$NOOP);
        pageLoadMetricRef.current.onStop(()=>{
            if (isEmbeddedConfluence) {
                const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
                const uniqueKey = observableObject?.object?.uniqueKey;
                sendMetrics({
                    timestamp: Date.now(),
                    customData: {
                        ...uniqueKey && (0, $9wGTI.fg)('platform_deprecate_lp_cc_embed') ? {
                            uniqueKey: uniqueKey
                        } : {}
                    }
                }, `${(0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $4icDV.EMBEDDED_VIEW_TTI)}`);
            }
        }, $a99ff50c139ee598$var$NOOP);
        pageLoadMetricRef.current.onStop(()=>{
            if (_isInitialLoad && Boolean(window.__HYDRATION_FAILED__)) {
                const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
                if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
                    source: 'viewPageCommon',
                    route: route,
                    errorWithRoute: errorWithRoute,
                    isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
                })).fire();
                else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
                    attribution: 'hydration'
                });
            }
        }, $a99ff50c139ee598$var$NOOP);
        pageLoadMetricRef.current.onStop(()=>{
            if (_isInitialLoad && Boolean(window.__HYDRATION_FAILED__) && Boolean(window.__SSR_REACT_STREAMING__) && !(0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) {
                const { error: errorWithRoute_0 } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
                (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute_0, {
                    attribution: 'streaming-hydration'
                });
            }
        }, $a99ff50c139ee598$var$NOOP);
        // Cleanup on unmount or when dependencies have changed
        return ()=>{
            pageLoadMetricRef.current?.cancel();
        };
    }, [
        contentId,
        customConfig,
        userId,
        isLite,
        isEmbeddedConfluence,
        sendMetrics,
        createAnalyticsEvent
    ]);
    return null;
};
const $a99ff50c139ee598$export$e190581c76254e9 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.VIEW_PAGE_CONTAINER_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
function $a99ff50c139ee598$var$_temp(m) {
    return m.startFromPageLoad();
}
module.exports["VIEW_PAGE_CONTAINER_METRIC"] = $a99ff50c139ee598$export$e190581c76254e9;
module.exports["StartViewPageLoad"] = $a99ff50c139ee598$export$acf5746d268ae4ee;

});

parcelRegister("1InRL", function(module, exports) {
$parcel$export(module.exports, "BYLINE_METRIC", () => (parcelRequire("hlP5l")).BYLINE_METRIC);
$parcel$export(module.exports, "CONTENT_TITLE_METRIC", () => (parcelRequire("hlP5l")).CONTENT_TITLE_METRIC);

var $hlP5l = parcelRequire("hlP5l");


});

parcelRegister("hlP5l", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $ca1c06444d7dc3f1$export$1acb68730768e8f3 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.BYLINE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $ca1c06444d7dc3f1$export$e2e4f4b09ade4a7e = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $ca1c06444d7dc3f1$export$9f06d0bab23f5435 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["BYLINE_METRIC"] = $ca1c06444d7dc3f1$export$1acb68730768e8f3;
module.exports["CONTENT_TITLE_METRIC"] = $ca1c06444d7dc3f1$export$e2e4f4b09ade4a7e;
module.exports["CONNECT_APP_WEB_FRAGMENT_METRIC"] = $ca1c06444d7dc3f1$export$9f06d0bab23f5435;

});

parcelRegister("dpv0X", function(module, exports) {

var $5YLPl = parcelRequire("5YLPl");

const $79e64809bb47109c$export$1d7a42050347be43 = (pageLoadMetric, data)=>{
    const contentRendererLegacyMark = (0, $5YLPl.CONTENT_RENDERER_METRIC).getData().marks['fy23-legacy-tti'] || 0;
    const pageLoadMark = data?.stopTime || 0;
    pageLoadMetric?.mark('fy23-legacy-tti', Math.max(pageLoadMark, contentRendererLegacyMark));
};
module.exports["markLegacyFY23TTI"] = $79e64809bb47109c$export$1d7a42050347be43;

});

parcelRegister("2aFNh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7r2px = parcelRequire("7r2px");

function $73c871442f6e75aa$export$6bbd36bf45aa851e(contentBody, customPerfData) {
    const memoRef = (0, $42omo.useRef)({
        contentBody: undefined,
        contentExtensionMetrics: undefined
    });
    if (customPerfData && (memoRef.current.contentBody !== contentBody || !('contentExtensionMetrics' in customPerfData))) {
        // `retrieveContentExtensionsMetrics` parses the ADF string into JSON, but that's likely to be only one of multiple such parsings.
        // For example, the Atlaskit editor/renderer will very likely parse the ADF string into JSON as well.
        // For large documents (e.g. 16MB) such parsing can take noticeable time which is undesirable especially before rendering.
        // This allows an alternative to `retrieveContentExtensionsMetrics` to optionally perform the computation in a more performant way.
        // But if it doesn't, `retrieveContentExtensionsMetrics` will be the fallback.
        let propertyValue;
        Object.defineProperty(customPerfData, 'contentExtensionMetrics', {
            enumerable: true,
            get () {
                if (propertyValue) return propertyValue;
                memoRef.current.contentBody = contentBody;
                const contentExtensionMetrics = contentBody ? (0, $7r2px.retrieveContentExtensionMetrics)(contentBody) : {};
                memoRef.current.contentExtensionMetrics = contentExtensionMetrics;
                return memoRef.current.contentExtensionMetrics;
            },
            set (value) {
                propertyValue = value;
            }
        });
    }
}
module.exports["useContentExtensionMetrics"] = $73c871442f6e75aa$export$6bbd36bf45aa851e;

});

parcelRegister("frvUM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4fa9fecc4e6fa66b$export$8e3d4e3d40a48fc4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3cAEv",
    name: "ContentTools",
    loader: async ()=>(await (parcelRequire("gRh2p"))).ContentTools
});
module.exports["ContentTools"] = $4fa9fecc4e6fa66b$export$8e3d4e3d40a48fc4;

});

parcelRegister("gRh2p", function(module, exports) {

let $c45ecfecb14f95f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c45ecfecb14f95f7$var$load("3VLKz"),
    $c45ecfecb14f95f7$var$load("jFI2g"),
    $c45ecfecb14f95f7$var$load("8FbYE"),
    $c45ecfecb14f95f7$var$load("dUevD"),
    $c45ecfecb14f95f7$var$load("4Lgj0"),
    $c45ecfecb14f95f7$var$load("kSJiq"),
    $c45ecfecb14f95f7$var$load("6wr18"),
    $c45ecfecb14f95f7$var$load("8ADTD"),
    $c45ecfecb14f95f7$var$load("jdHbV"),
    $c45ecfecb14f95f7$var$load("4XFRu"),
    $c45ecfecb14f95f7$var$load("coJiW"),
    $c45ecfecb14f95f7$var$load("h4Nf7"),
    $c45ecfecb14f95f7$var$load("4t77a"),
    $c45ecfecb14f95f7$var$load("fD0v8"),
    $c45ecfecb14f95f7$var$load("6XCf4"),
    $c45ecfecb14f95f7$var$load("6FuHS"),
    $c45ecfecb14f95f7$var$load("eyaRC"),
    $c45ecfecb14f95f7$var$load("5pvpJ"),
    $c45ecfecb14f95f7$var$load("hRUX7"),
    $c45ecfecb14f95f7$var$load("g4oYs"),
    $c45ecfecb14f95f7$var$load("Wowvf"),
    $c45ecfecb14f95f7$var$load("1qlDN"),
    $c45ecfecb14f95f7$var$load("1yVM6"),
    $c45ecfecb14f95f7$var$load("awqCy"),
    $c45ecfecb14f95f7$var$load("fZt2F"),
    $c45ecfecb14f95f7$var$load("bzc8Q"),
    $c45ecfecb14f95f7$var$load("kyfJT"),
    $c45ecfecb14f95f7$var$load("ffEVr"),
    $c45ecfecb14f95f7$var$load("kUbUu"),
    $c45ecfecb14f95f7$var$load("7EorR"),
    $c45ecfecb14f95f7$var$load("9ftJe"),
    $c45ecfecb14f95f7$var$load("e9JE4"),
    $c45ecfecb14f95f7$var$load("e4GNb"),
    $c45ecfecb14f95f7$var$load("hhss7"),
    $c45ecfecb14f95f7$var$load("hWs86")
]).then(()=>parcelRequire('bTUBB'));

});

parcelRegister("8HdsQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h0mTL = parcelRequire("h0mTL");


var $jIlrR = parcelRequire("jIlrR");


var $lF24E = parcelRequire("lF24E");


var $9wGTI = parcelRequire("9wGTI");

const $262f69aacf5ded76$var$noop = ()=>{};
const $262f69aacf5ded76$export$e64f20017ef2874a = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, isCommentButtonSSRd: isCommentButtonSSRd = false })=>{
    const { data: data, error: error } = (0, $lF24E.usePreloadCommentButton)(contentId, isCommentButtonSSRd);
    const contentNode = data?.commentData?.content?.nodes?.[0];
    const isFabricSuported = (0, $9wGTI.fg)('confluence_comment_use_metadata') ? contentNode?.metadata?.frontend?.fabricEditorSupported ?? false : contentNode?.properties?.nodes?.[0]?.value === '"v2"' || contentNode?.properties?.nodes?.[0]?.value === 'v2';
    const [showCommentButton, setShowCommentButton] = (0, $42omo.useState)(false);
    /* Scenario: A user has clicked on the button in SSR -> SPA transition.
     The mouse click event is captured and the loading of CommentButtonLazy is started.
     */ const handleCommentButtonClick = ()=>{
        setShowCommentButton(true);
    };
    /*Conditional Loading of CommentButtonLazy if FF is ON and showCommentButton true (user click)*/ /* in case of an error from CommentButtonQuery load CommentButtonLazy and allow CommentButton to make
          another network call to fetch data*/ const isDataLoaded = Boolean(data?.commentData && !error);
    if (showCommentButton || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h0mTL.CommentButtonLazy), {
        contentId: contentId,
        isDataLoaded: isDataLoaded,
        isFabricPage: isFabricSuported
    }));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jIlrR.CommentButtonPlaceholder), {
        isDisabled: !isDataLoaded && !isCommentButtonSSRd,
        handleCommentButtonClick: isDataLoaded || isCommentButtonSSRd ? handleCommentButtonClick : $262f69aacf5ded76$var$noop,
        contentId: contentId
    }));
});
module.exports["CommentButtonWrapper"] = $262f69aacf5ded76$export$e64f20017ef2874a;

});

parcelRegister("h0mTL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $jIlrR = parcelRequire("jIlrR");


const $3ed4db9782b8d46b$export$43a94cba75d164d3 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pHrwQ",
    name: "CommentButtonLazy",
    loader: async ()=>(await (parcelRequire("aTHBW"))).CommentButton,
    loading: ({ isDataLoaded: isDataLoaded })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jIlrR.CommentButtonPlaceholder), {
            isDisabled: !isDataLoaded
        })
});
module.exports["CommentButtonLazy"] = $3ed4db9782b8d46b$export$43a94cba75d164d3;

});

parcelRegister("aTHBW", function(module, exports) {

let $7ef0dea7d9a77145$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7ef0dea7d9a77145$var$load("9jS5g"),
    $7ef0dea7d9a77145$var$load("i1fe2")
]).then(()=>parcelRequire('32Ecy'));

});

parcelRegister("lF24E", function(module, exports) {

var $6nmm4 = parcelRequire("6nmm4");


var $jMyy4 = parcelRequire("jMyy4");

const $d0986d2d4a7f2d28$var$usePreloadCommentButtonQuery = (0, $6nmm4.default);
const $d0986d2d4a7f2d28$export$d1f3401b494de415 = (contentId, isCommentButtonSSRd)=>{
    const { data: commentData, error: commentError } = (0, $jMyy4.useQueryInterop)($d0986d2d4a7f2d28$var$usePreloadCommentButtonQuery, {
        fetchPolicy: isCommentButtonSSRd ? 'cache-first' : 'cache-and-network',
        variables: {
            pageId: contentId
        }
    });
    return {
        data: {
            commentData: commentData
        },
        error: commentError
    };
};
module.exports["usePreloadCommentButton"] = $d0986d2d4a7f2d28$export$d1f3401b494de415;

});

parcelRegister("dkDqz", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

const $2c3fc5ab77b32b66$export$3238f1bda20b469c = (0, $2XqLN.default)(()=>({
        allowBreakout: true,
        UNSAFE_addSidebarLayouts: true
    }));
module.exports["getLayoutOptions"] = $2c3fc5ab77b32b66$export$3238f1bda20b469c;

});

parcelRegister("bY24B", function(module, exports) {
const $0e0fdc78f7a1bae2$var$DEFAULT_EXPAND_OPTIONS = {
    allowInsertion: true,
    allowInteractiveExpand: true
};
const $0e0fdc78f7a1bae2$export$98ec01862577ac69 = ()=>{
    return $0e0fdc78f7a1bae2$var$DEFAULT_EXPAND_OPTIONS;
};
module.exports["useExpandOptions"] = $0e0fdc78f7a1bae2$export$98ec01862577ac69;

});

parcelRegister("jvzGU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hUz7g = parcelRequire("hUz7g");

const $83b906b815f15665$export$fddc468cd8cb4db9 = ()=>{
    return (0, $42omo.useMemo)(()=>(0, $hUz7g.getTableOptions)(), []);
};
module.exports["useTableOptions"] = $83b906b815f15665$export$fddc468cd8cb4db9;

});

parcelRegister("hUz7g", function(module, exports) {
const $68268dc60793ca56$export$4fc4c895dbb98f6b = ()=>{
    return {
        allowTableResizing: true,
        allowTableAlignment: true,
        allowBackgroundColor: true,
        allowColumnResizing: true,
        allowColumnSorting: true,
        allowDistributeColumns: true,
        allowHeaderColumn: true,
        allowHeaderRow: true,
        allowMergeCells: true,
        allowNumberColumn: true,
        allowNestedTables: true,
        allowControls: true,
        stickyHeaders: true,
        allowAddColumnWithCustomStep: false
    };
};
module.exports["getTableOptions"] = $68268dc60793ca56$export$4fc4c895dbb98f6b;

});

parcelRegister("dLc9m", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $cZa7r = parcelRequire("cZa7r");


var $cD1qu = parcelRequire("cD1qu");


var $inDu6 = parcelRequire("inDu6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $gfqXk = parcelRequire("gfqXk");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $i49vP = parcelRequire("i49vP");


var $fNzRA = parcelRequire("fNzRA");


var $k8e76 = parcelRequire("k8e76");


var $9jl6v = parcelRequire("9jl6v");


var $dkkKv = parcelRequire("dkkKv");


var $8i27m = parcelRequire("8i27m");


var $f5Wgm = parcelRequire("f5Wgm");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $cgy29 = parcelRequire("cgy29");


var $liGyh = parcelRequire("liGyh");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $7qvmT = parcelRequire("7qvmT");


var $6KwrO = parcelRequire("6KwrO");


var $3mVfX = parcelRequire("3mVfX");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $9wGTI = parcelRequire("9wGTI");


var $aSsfA = parcelRequire("aSsfA");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $dANtQ = parcelRequire("dANtQ");


var $9QIM2 = parcelRequire("9QIM2");


var $fHAwL = parcelRequire("fHAwL");


var $3YBks = parcelRequire("3YBks");


var $2eC70 = parcelRequire("2eC70");


var $izhdc = parcelRequire("izhdc");


var $gSkOQ = parcelRequire("gSkOQ");

const $7e419a56a8ff4128$var$EditorCommentShortcutListenerComponent = ({ contentId: contentId, viewMode: viewMode, dialogs: dialogs, editorApi: editorApi })=>{
    const { navigateToInlineComment: navigateToInlineComment, setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { unresolvedInlineComments: unresolvedInlineComments } = (0, $k8e76.useInlineCommentsState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap, footerCommentsLoadingState: footerCommentsLoadingState } = (0, $8i27m.useCommentsDataState)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const [isNextCommentLoading, setIsNextCommentLoading] = (0, $42omo.useState)(false);
    const [alreadyFetchedInitialData, setAlreadyFetchedInitialData] = (0, $42omo.useState)(false);
    const [triggeredByUnreadKeyboardShortcut, setTriggeredByUnreadKeyboardShortcut] = (0, $42omo.useState)(false);
    // Used to facilitate loading footer comments and navigating after load
    // Should only be set when confluence_frontend_kb_footer_loading is true and pageMode == PageMode.LIVE
    const [pendingStandaloneAction, setPendingStandaloneAction] = (0, $42omo.useState)(null);
    const [{ currentlyRenderedThreads: currentlyRenderedThreads, currentlySelectedThreadKey: currentlySelectedThreadKey }, { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey }] = (0, $3mVfX.useCommentsPanel)();
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = (0, $aWwYt.useObjectSidebarState)();
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const pageClass = (0, $9QIM2.usePageClass)();
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '');
    const orderedActiveAnnotations = (0, $42omo.useMemo)(()=>{
        return (0, $9wGTI.fg)('confluence_frontend_new_comments_scrolling') ? orderedActiveAnnotationIdList.map((a)=>a.threadKey) : unresolvedInlineComments;
    }, [
        orderedActiveAnnotationIdList,
        unresolvedInlineComments
    ]);
    (0, $42omo.useEffect)(()=>{
        setIsNextCommentLoading(false);
    }, [
        activeHighlight,
        currentlySelectedThreadKey
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            setCurrentlySelectedThreadKey('');
        };
    }, [
        setCurrentlySelectedThreadKey
    ]);
    const { footerCommentThreads: footerCommentThreads, footerCommentIds: footerCommentIds } = (0, $gSkOQ.useFooterComments)();
    const { setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { unreadInlineComments: unreadInlineComments, unreadGeneralComments: unreadGeneralComments } = (0, $42omo.useMemo)(()=>{
        const unreadInlineComments = [];
        const unreadGeneralComments = [];
        orderedActiveAnnotations.forEach((threadKey)=>{
            const commentData = commentsDataMap.inline[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) {
                    // Use unreadCommentIDSet when feature flag is enabled
                    // in SSR, unreadCommentIDSet is undefined
                    isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                    hasUnreadReplies = commentData.replies?.some((reply)=>unreadCommentIDSet?.has(reply.id)) || false;
                } else {
                    // Use legacy .isUnread field when feature flag is disabled
                    isCommentUnread = commentData.isUnread || false;
                    hasUnreadReplies = commentData.replies?.some((reply)=>reply.isUnread) || false;
                }
                if (isCommentUnread || hasUnreadReplies) unreadInlineComments.push(threadKey);
            }
        });
        Object.keys(commentsDataMap.general).forEach((threadKey)=>{
            const commentData = commentsDataMap.general[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) {
                    // Use unreadCommentIDSet when feature flag is enabled
                    isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                    hasUnreadReplies = commentData.replies?.some((reply)=>unreadCommentIDSet?.has(reply.id)) || false;
                } else {
                    // Use legacy .isUnread field when feature flag is disabled
                    isCommentUnread = commentData.isUnread || false;
                    hasUnreadReplies = commentData.replies?.some((reply)=>reply.isUnread) || false;
                }
                if (isCommentUnread || hasUnreadReplies) unreadGeneralComments.push(threadKey);
            }
        });
        return {
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotations,
        unreadCommentIDSet
    ]);
    const sendKeyboardShortcutAnalytics = (shortcut)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'editPage',
                action: 'pressed',
                actionSubject: 'keyboardShortcut',
                actionSubjectId: 'createComment',
                attributes: {
                    key: shortcut
                }
            }
        }).fire();
    };
    const { handleCommentButtonClick: handleCommentButtonClick } = (0, $cgy29.useCreateCommentAction)({
        contentId: contentId || '',
        isFabric: true,
        sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics
    });
    const onNavigationClick = (0, $42omo.useCallback)((nextMarkerRef)=>{
        setCurrentlySelectedThreadKey('');
        if (!nextMarkerRef) return;
        emitter.emit('setselectedannotation', nextMarkerRef);
        const commentElement = document.getElementById(nextMarkerRef);
        if (commentElement) {
            /*
				 * Don't start the experience if the create sidebar is shown because we can't predict
				 * if the user will close the create sidebar to continue the navigation or create a
				 * new comment. If the user continues the navigation, the experience will be started
				 * by the annotation-provider-inline-comments/editor/ViewManager entrypoint.
				 */ if (document.querySelector('[data-testid="editor-create-sidebar"]') === null && (pageClass === 'renderer' || pageClass === 'editor') && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_keyboard')) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                    annotationId: nextMarkerRef,
                    entryPoint: 'comments-shortcuts/EditorCommentShortcutListener',
                    pageClass: 'editor'
                }
            });
            if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) (0, $9FoVw.handleKeyboardShortcutNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                context: (0, $9FoVw.NavigationContext).PANEL,
                block: 'center',
                annotationId: nextMarkerRef,
                commentType: (0, $f5Wgm.CommentType).INLINE
            });
            else (0, $i49vP.openInlineCommentInEditor)({
                targetElement: commentElement,
                targetElementID: nextMarkerRef
            });
        }
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        experienceTracker,
        pageClass
    ]);
    const scrollToFooterComment = (0, $42omo.useCallback)((threadKey)=>{
        // Close inline comment when keyboard navigating from inline comment to footer comment
        // TODO: The logic to close inline comment is from ViewManager.tsx. To revisit - create a shared function so the close inline comment logic can be reused
        if (!(0, $9wGTI.fg)('confluence_comments_unified_navigation')) setTimeout(()=>{
            // Remove focus from the currently focused element only if unified navigation is enabled
            editorApi?.core.actions.focus();
        }, 100);
        emitter.emit('closeinlinecomment');
        setEditorViewProps(null);
        setCurrentlySelectedThreadKey(threadKey);
        if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: threadKey,
            commentType: (0, $f5Wgm.CommentType).FOOTER,
            isCommentsPanelOpen: isObjectSidebarShown && (0, $9wGTI.fg)('confluence-frontend-comments-panel'),
            hasKeyPressed: true
        });
        else (0, $7qvmT.handlePanelSelectionAndScroll)({
            threadKey: threadKey,
            isResolved: false,
            pageMode: pageMode,
            setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
            eventEmitter: emitter,
            commentType: (0, $8i27m.CommentType).GENERAL
        });
        setActiveHighlight(threadKey);
    }, [
        emitter,
        pageMode,
        editorApi,
        setCurrentlySelectedThreadKey,
        setActiveHighlight,
        setEditorViewProps,
        isObjectSidebarShown
    ]);
    const getCommentIndex = (0, $42omo.useCallback)((currentMarkerRef)=>{
        return (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? [
            ...orderedActiveAnnotations,
            ...footerCommentIds
        ]?.findIndex((markerRef)=>markerRef === currentMarkerRef) : orderedActiveAnnotations?.findIndex((markerRef)=>markerRef === currentMarkerRef);
    }, [
        orderedActiveAnnotations,
        footerCommentIds
    ]);
    const handlePanelCommentNavigation = (0, $42omo.useCallback)((action)=>{
        // If nothing is on the panel, there's nothing to navigate to
        if (currentlyRenderedThreads.length === 0) return;
        const { panelCommentRefs: panelCommentRefs, navigableInlineCommentRefs: navigableInlineCommentRefs } = (0, $izhdc.parsePanelAndInlineRefs)(currentlyRenderedThreads, orderedActiveAnnotations);
        const nextRef = (0, $izhdc.getNextRef)(action, panelCommentRefs, currentlySelectedThreadKey);
        // Use unified keyboard shortcut navigation for panel navigation when feature is enabled
        if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) {
            // Handle panel selection state management in the listener
            setCurrentlySelectedThreadKey(nextRef.ref);
            (0, $9FoVw.handleKeyboardShortcutNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                block: 'center',
                annotationId: nextRef.ref,
                commentType: nextRef.type === (0, $8i27m.CommentType).GENERAL ? (0, $f5Wgm.CommentType).FOOTER : (0, $f5Wgm.CommentType).INLINE,
                isCommentsPanelOpen: isObjectSidebarShown && (0, $9wGTI.fg)('confluence-frontend-comments-panel'),
                hasKeyPressed: true,
                context: (0, $9FoVw.NavigationContext).EDITOR,
                isResolved: !navigableInlineCommentRefs.has(nextRef.ref)
            });
        } else // Use old method when unified navigation is disabled
        (0, $7qvmT.handlePanelSelectionAndScroll)({
            threadKey: nextRef.ref,
            isResolved: !navigableInlineCommentRefs.has(nextRef.ref),
            pageMode: pageMode,
            setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
            eventEmitter: emitter,
            commentType: nextRef.type,
            scrollCommentsPanelToThread: scrollCommentsPanelToThread,
            shouldScrollCommentsPanel: true,
            hasKeyPressed: true
        });
    }, [
        currentlyRenderedThreads,
        orderedActiveAnnotations,
        currentlySelectedThreadKey,
        pageMode,
        setCurrentlySelectedThreadKey,
        emitter,
        scrollCommentsPanelToThread,
        isObjectSidebarShown
    ]);
    const handleNextCommentNavigation = (0, $42omo.useCallback)(({ isNavigateToNextUnread: isNavigateToNextUnread, action: action })=>{
        //Check if the next inline comment is still in process of being rendered. Otherwise, quickly pressing keys will force comment to open and close instead of navigating
        if (isNextCommentLoading) return;
        setIsNextCommentLoading(true);
        navigateToInlineComment({
            action: action,
            triggeredByKeyboardShortcut: true,
            currentCommentIndex: getCommentIndex(activeHighlight || currentlySelectedThreadKey || ''),
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: true,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: contentId,
            isNavigateToNextUnread: isNavigateToNextUnread,
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments,
            footerComments: footerCommentIds,
            scrollToFooterComment: scrollToFooterComment,
            commentsDataMap: commentsDataMap
        });
    }, [
        activeHighlight,
        navigateToInlineComment,
        onNavigationClick,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        createAnalyticsEvent,
        contentId,
        getCommentIndex,
        isNextCommentLoading,
        footerCommentIds,
        scrollToFooterComment,
        commentsDataMap,
        currentlySelectedThreadKey,
        unreadGeneralComments,
        unreadInlineComments
    ]);
    const handleStandaloneCommentNavigation = (0, $42omo.useCallback)((action)=>{
        if (activeHighlight || currentlySelectedThreadKey) {
            // Check if we're navigating to a potentially unloaded footer comment
            const currentIndex = getCommentIndex(activeHighlight || currentlySelectedThreadKey || '');
            const totalComments = [
                ...orderedActiveAnnotations,
                ...footerCommentIds
            ].length;
            const navigatingToPotentiallyUnloadedFooterComment = (0, $izhdc.isNavigatingToPotentiallyUnloadedFooterComment)(action, currentIndex, totalComments, footerCommentsLoadingState);
            if (pageMode === (0, $cD1qu.PageMode).LIVE && navigatingToPotentiallyUnloadedFooterComment && (0, $9wGTI.fg)('confluence_frontend_kb_footer_loading')) setPendingStandaloneAction(action);
            else handleNextCommentNavigation({
                isNavigateToNextUnread: false,
                action: action
            });
        } else {
            // No highlight selected, so we navigate to the first inline comment
            const firstInlineCommentMarkerRef = orderedActiveAnnotations[0];
            if (firstInlineCommentMarkerRef) onNavigationClick(firstInlineCommentMarkerRef);
            else if (pageMode === (0, $cD1qu.PageMode).LIVE && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                // Only Live pages have footer comments which is navigable
                if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? footerCommentThreads.length === 0 : true) // No active inline comments or footer comments found, but footer is not yet loaded - load footer comments and try again
                {
                    if (footerCommentsLoadingState === (0, $8i27m.FooterCommentsLoadingStateType).NOT_LOADED && (0, $9wGTI.fg)('confluence_frontend_kb_footer_loading')) setPendingStandaloneAction(action);
                } else scrollToFooterComment(footerCommentThreads[0]?.id);
            }
        }
    }, [
        activeHighlight,
        onNavigationClick,
        handleNextCommentNavigation,
        scrollToFooterComment,
        footerCommentThreads,
        pageMode,
        currentlySelectedThreadKey,
        orderedActiveAnnotations,
        footerCommentIds,
        footerCommentsLoadingState,
        getCommentIndex,
        setPendingStandaloneAction
    ]);
    const handleCommentNavigation = (0, $42omo.useCallback)((action)=>{
        // Define behavior when the comments panel is shown - panel FG is a prereq for nav, so has to be checked first
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('confluence-frontend-comments-panel') && isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) handlePanelCommentNavigation(action);
        else // Comments panel not shown
        handleStandaloneCommentNavigation(action);
    }, [
        isObjectSidebarShown,
        panel?.id,
        handlePanelCommentNavigation,
        handleStandaloneCommentNavigation
    ]);
    (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId || '',
        skip: !triggeredByUnreadKeyboardShortcut || alreadyFetchedInitialData || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        onCompletedFn: ()=>{
            setAlreadyFetchedInitialData(true);
        }
    });
    // The flow is setPendingStandaloneAction --> load footer comments --> updates footerCommentIds --> retrigger KB shortcut with updated data
    const shouldLoadFooterComments = pendingStandaloneAction !== null && pageMode === (0, $cD1qu.PageMode).LIVE;
    (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId || '',
        skip: !shouldLoadFooterComments || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        fetchPolicy: shouldLoadFooterComments ? 'network-only' : 'cache-only',
        type: (0, $f5Wgm.CommentType).FOOTER
    });
    (0, $42omo.useEffect)(()=>{
        if (pendingStandaloneAction !== null) {
            handleStandaloneCommentNavigation(pendingStandaloneAction);
            setPendingStandaloneAction(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        footerCommentIds
    ]);
    const handleNextUnreadNavigation = (0, $42omo.useCallback)(()=>{
        if (!alreadyFetchedInitialData) {
            //This will trigger the ActiveComments query if it's not already fetched
            setTriggeredByUnreadKeyboardShortcut(true);
            //Exit because the comment data won't be available yet to navigate to
            return;
        }
        if (unreadInlineComments.length + unreadGeneralComments.length === 0) // No unread comments - don't do anything
        return;
        //unread panel navigation
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel && (0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
            let nextThreadKey = '';
            let nextCommentType = (0, $8i27m.CommentType).GENERAL;
            if (!currentlySelectedThreadKey) {
                if (unreadInlineComments.length > 0) {
                    nextThreadKey = unreadInlineComments[0];
                    nextCommentType = (0, $8i27m.CommentType).INLINE;
                } else nextThreadKey = unreadGeneralComments[0];
            } else {
                nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(getCommentIndex(currentlySelectedThreadKey ?? '') + 1, [
                    ...orderedActiveAnnotations,
                    ...footerCommentIds
                ], [
                    ...unreadInlineComments,
                    ...unreadGeneralComments
                ]) ?? '';
                if (unreadInlineComments.includes(nextThreadKey)) nextCommentType = (0, $8i27m.CommentType).INLINE;
            }
            // Use unified keyboard shortcut navigation for panel navigation when feature is enabled
            if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) {
                // Handle panel selection state management in the listener
                setCurrentlySelectedThreadKey(nextThreadKey);
                (0, $9FoVw.handleKeyboardShortcutNavigation)({
                    scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                    block: 'center',
                    annotationId: nextThreadKey,
                    commentType: nextCommentType === (0, $8i27m.CommentType).GENERAL ? (0, $f5Wgm.CommentType).FOOTER : (0, $f5Wgm.CommentType).INLINE,
                    isCommentsPanelOpen: isObjectSidebarShown && (0, $9wGTI.fg)('confluence-frontend-comments-panel'),
                    hasKeyPressed: true,
                    context: (0, $9FoVw.NavigationContext).EDITOR,
                    shortcutType: (0, $9FoVw.ShortcutType).UNREAD
                });
            } else // Use old method when unified navigation is disabled
            (0, $7qvmT.handlePanelSelectionAndScroll)({
                threadKey: nextThreadKey,
                isResolved: false,
                pageMode: pageMode,
                setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
                eventEmitter: emitter,
                commentType: nextCommentType,
                scrollCommentsPanelToThread: scrollCommentsPanelToThread,
                shouldScrollCommentsPanel: true
            });
            return;
        }
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: true,
            action: 'next'
        });
        else {
            if (unreadInlineComments.length + unreadGeneralComments.length === 0) return;
            if (unreadInlineComments[0]) onNavigationClick(unreadInlineComments[0]);
            else scrollToFooterComment(unreadGeneralComments[0]);
        }
    }, [
        isObjectSidebarShown,
        panel?.id,
        handleNextCommentNavigation,
        onNavigationClick,
        activeHighlight,
        unreadInlineComments,
        unreadGeneralComments,
        currentlySelectedThreadKey,
        scrollToFooterComment,
        orderedActiveAnnotations,
        getCommentIndex,
        footerCommentIds,
        emitter,
        pageMode,
        setCurrentlySelectedThreadKey,
        scrollCommentsPanelToThread,
        alreadyFetchedInitialData
    ]);
    (0, $42omo.useEffect)(()=>{
        if (unreadInlineComments.length + unreadGeneralComments.length > 0 && alreadyFetchedInitialData && triggeredByUnreadKeyboardShortcut) {
            // This handles the case where user triggers unread keyboard shortcut when the comments data isn't fetched yet.
            // We need to wait for the data to be fetched before calling handleNextUnreadNavigation
            setTriggeredByUnreadKeyboardShortcut(false);
            // Putting this behind a timeout because need to wait for triggeredByUnreadKeyboardShortcut to be set to false otherwise got called multiple times
            setTimeout(()=>{
                handleNextUnreadNavigation();
            }, 100);
        }
    }, [
        unreadInlineComments,
        unreadGeneralComments,
        handleNextUnreadNavigation,
        alreadyFetchedInitialData,
        triggeredByUnreadKeyboardShortcut,
        setTriggeredByUnreadKeyboardShortcut
    ]);
    const openCommentEditorShortcutCb = (e, shortcut)=>{
        e.preventDefault();
        if (canAddComments || !(0, $9wGTI.fg)('confluence_fe_add_comment_kb_check_permission')) {
            if (document.querySelector('[data-testid="add-comment-media-button"]') && (0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage')) {
                // This is the Comment button for media (image/video) objects in editor, which
                // handles keyboard shortcut separately. So just start the compound experience.
                (0, $3YBks.createInlineCommentCompoundExperience).start({
                    attributes: {
                        ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                        pageClass: 'editor',
                        commentType: 'block',
                        blockType: 'media',
                        entryPoint: 'keyboardShortcut'
                    }
                });
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.start();
                // Without this, initExperience will fail since it won't find a draft annotation.
                // So soft-fail it here to avoid failing the entire compound experience.
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Media in editor has no draft annotation as expected'));
            } else if (document.querySelector('[data-testid="ak-editor-annotation-toolbar-create-button"]')) handleCommentButtonClick({
                dialogs: dialogs,
                shortcut: shortcut,
                experienceAttributes: {
                    entryPoint: 'keyboardShortcut'
                }
            });
            else {
                // Check if we should show sticky draft instead of scrolling to object comment wrapper
                const isShowStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT && (0, $9wGTI.fg)('confluence_comment_sticky_footer_enabled');
                if (!expanded) expandCommentContainer({
                    entryPoint: 'keyboardShortcutEditor'
                });
                if (isShowStickyDraft || !isObjectCommentWrapperVisible && (0, $9wGTI.fg)('confluence_comment_expand_footer_editor')) setFooterEditorEntry((0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT);
                else document.querySelector(`[data-testid='object-comment-wrapper']`)?.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
        sendKeyboardShortcutAnalytics(shortcut);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "comments-shortcut-listener"
    }, (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_SELECT_COMMENT_SHORTCUT),
        listener: ()=>{
            const openComment = document.getElementById('editor-comments-sidebar') || document.getElementById(`comment-thread-${currentlySelectedThreadKey}-container`);
            if (openComment) {
                openComment.setAttribute('tabIndex', '-1');
                openComment.focus();
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT),
        deprecatedAccelerator: viewMode ? (0, $gnkil.PREV_COMMENT_SHORTCUT) : undefined,
        listener: ()=>handleCommentNavigation('previous')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT),
        deprecatedAccelerator: viewMode ? (0, $gnkil.NEXT_COMMENT_SHORTCUT) : undefined,
        listener: ()=>handleCommentNavigation('next')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT),
        listener: handleNextUnreadNavigation
    }), (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
        listener: (e)=>openCommentEditorShortcutCb(e, (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR))
    }));
};
const $7e419a56a8ff4128$export$60fc9509b9a2d030 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})((0, $inDu6.withDialogs)($7e419a56a8ff4128$var$EditorCommentShortcutListenerComponent));
module.exports["EditorCommentShortcutListener"] = $7e419a56a8ff4128$export$60fc9509b9a2d030;

});

parcelRegister("1l6y9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8Tj57 = parcelRequire("8Tj57");

const $bf189bcc55d60d3f$export$eff3dda3a84b308a = ()=>{
    const [startingLinks, setStartingLinks] = (0, $42omo.useState)();
    const onEditorReady = (0, $42omo.useCallback)(async (editorActions)=>{
        const adf = await editorActions.getValue();
        const links = (0, $8Tj57.getAllSmartLinks)(adf);
        setStartingLinks(links);
    }, []);
    return {
        onEditorReady: onEditorReady,
        startingLinks: startingLinks
    };
};
module.exports["useInviteFromLinkExperimentEditor"] = $bf189bcc55d60d3f$export$eff3dda3a84b308a;

});


//# sourceMappingURL=FullPageEditorComponent.db6f15a3.js.map
